
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8569"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8569"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $f7b3d4cc24ae5c99$exports = {};
$parcel$extendImportMap({
    "533vU": "planet.6a07b0b8.png",
    "j5dWA": "ares.30291f11.png"
});

var $79f3f38722d4e01c$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $79f3f38722d4e01c$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 1497);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Taken from klasse by mattdesl https://github.com/mattdesl/klasse
            function hasGetterOrSetter(def) {
                return !!def.get && typeof def.get === 'function' || !!def.set && typeof def.set === 'function';
            }
            function getProperty(definition, k, isClassDescriptor) {
                //  This may be a lightweight object, OR it might be a property that was defined previously.
                //  For simple class descriptors we can just assume its NOT previously defined.
                var def = isClassDescriptor ? definition[k] : Object.getOwnPropertyDescriptor(definition, k);
                if (!isClassDescriptor && def.value && typeof def.value === 'object') def = def.value;
                //  This might be a regular property, or it may be a getter/setter the user defined in a class.
                if (def && hasGetterOrSetter(def)) {
                    if (typeof def.enumerable === 'undefined') def.enumerable = true;
                    if (typeof def.configurable === 'undefined') def.configurable = true;
                    return def;
                } else return false;
            }
            function hasNonConfigurable(obj, k) {
                var prop = Object.getOwnPropertyDescriptor(obj, k);
                if (!prop) return false;
                if (prop.value && typeof prop.value === 'object') prop = prop.value;
                if (prop.configurable === false) return true;
                return false;
            }
            /**
 * Extends the given `myClass` object's prototype with the properties of `definition`.
 *
 * @function extend
 * @ignore
 * @param {Object} ctor The constructor object to mix into.
 * @param {Object} definition A dictionary of functions for the class.
 * @param {boolean} isClassDescriptor Is the definition a class descriptor?
 * @param {Object} [extend] The parent constructor object.
 */ function extend(ctor, definition, isClassDescriptor, extend) {
                for(var k in definition){
                    if (!definition.hasOwnProperty(k)) continue;
                    var def = getProperty(definition, k, isClassDescriptor);
                    if (def !== false) {
                        //  If Extends is used, we will check its prototype to see if the final variable exists.
                        var parent = extend || ctor;
                        if (hasNonConfigurable(parent.prototype, k)) {
                            //  Just skip the final property
                            if (Class.ignoreFinals) continue;
                            //  We cannot re-define a property that is configurable=false.
                            //  So we will consider them final and throw an error. This is by
                            //  default so it is clear to the developer what is happening.
                            //  You can set ignoreFinals to true if you need to extend a class
                            //  which has configurable=false; it will simply not re-define final properties.
                            throw new Error('cannot override final property \'' + k + '\', set Class.ignoreFinals = true to skip');
                        }
                        Object.defineProperty(ctor.prototype, k, def);
                    } else ctor.prototype[k] = definition[k];
                }
            }
            /**
 * Applies the given `mixins` to the prototype of `myClass`.
 *
 * @function mixin
 * @ignore
 * @param {Object} myClass The constructor object to mix into.
 * @param {Object|Array<Object>} mixins The mixins to apply to the constructor.
 */ function mixin(myClass, mixins) {
                if (!mixins) return;
                if (!Array.isArray(mixins)) mixins = [
                    mixins
                ];
                for(var i = 0; i < mixins.length; i++)extend(myClass, mixins[i].prototype || mixins[i]);
            }
            /**
 * Creates a new class with the given descriptor.
 * The constructor, defined by the name `initialize`,
 * is an optional function. If unspecified, an anonymous
 * function will be used which calls the parent class (if
 * one exists).
 *
 * You can also use `Extends` and `Mixins` to provide subclassing
 * and inheritance.
 *
 * @class Phaser.Class
 * @constructor
 * @param {Object} definition a dictionary of functions for the class
 * @example
 *
 *      var MyClass = new Phaser.Class({
 *
 *          initialize: function() {
 *              this.foo = 2.0;
 *          },
 *
 *          bar: function() {
 *              return this.foo + 5;
 *          }
 *      });
 */ function Class(definition) {
                if (!definition) definition = {};
                //  The variable name here dictates what we see in Chrome debugger
                var initialize;
                var Extends;
                if (definition.initialize) {
                    if (typeof definition.initialize !== 'function') throw new Error('initialize must be a function');
                    initialize = definition.initialize;
                    //  Usually we should avoid 'delete' in V8 at all costs.
                    //  However, its unlikely to make any performance difference
                    //  here since we only call this on class creation (i.e. not object creation).
                    delete definition.initialize;
                } else if (definition.Extends) {
                    var base = definition.Extends;
                    initialize = function() {
                        base.apply(this, arguments);
                    };
                } else initialize = function() {};
                if (definition.Extends) {
                    initialize.prototype = Object.create(definition.Extends.prototype);
                    initialize.prototype.constructor = initialize;
                    //  For getOwnPropertyDescriptor to work, we need to act directly on the Extends (or Mixin)
                    Extends = definition.Extends;
                    delete definition.Extends;
                } else initialize.prototype.constructor = initialize;
                //  Grab the mixins, if they are specified...
                var mixins = null;
                if (definition.Mixins) {
                    mixins = definition.Mixins;
                    delete definition.Mixins;
                }
                //  First, mixin if we can.
                mixin(initialize, mixins);
                //  Now we grab the actual definition which defines the overrides.
                extend(initialize, definition, true, Extends);
                return initialize;
            }
            Class.extend = extend;
            Class.mixin = mixin;
            Class.ignoreFinals = false;
            module1.exports = Class;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A NOOP (No Operation) callback function.
 *
 * Used internally by Phaser when it's more expensive to determine if a callback exists
 * than it is to just invoke an empty function.
 *
 * @function Phaser.Utils.NOOP
 * @since 3.0.0
 */ var NOOP = function() {
            //  NOOP
            };
            module1.exports = NOOP;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Finds the key within the top level of the {@link source} object, or returns {@link defaultValue}
 *
 * @function Phaser.Utils.Objects.GetFastValue
 * @since 3.0.0
 *
 * @param {object} source - The object to search
 * @param {string} key - The key for the property on source. Must exist at the top level of the source object (no periods)
 * @param {*} [defaultValue] - The default value to use if the key does not exist.
 *
 * @return {*} The value if found; otherwise, defaultValue (null if none provided)
 */ var GetFastValue = function(source, key, defaultValue) {
                var t = typeof source;
                if (!source || t === 'number' || t === 'string') return defaultValue;
                else if (source.hasOwnProperty(key) && source[key] !== undefined) return source[key];
                else return defaultValue;
            };
            module1.exports = GetFastValue;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            var FuzzyEqual = __webpack_require__(123);
            /**
 * @classdesc
 * A representation of a vector in 2D space.
 *
 * A two-component vector.
 *
 * @class Vector2
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number|Phaser.Types.Math.Vector2Like} [x] - The x component, or an object with `x` and `y` properties.
 * @param {number} [y] - The y component.
 */ var Vector2 = new Class({
                initialize: function Vector2(x, y) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector2#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector2#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    if (typeof x === 'object') {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                    } else {
                        if (y === undefined) y = x;
                        this.x = x || 0;
                        this.y = y || 0;
                    }
                },
                /**
     * Make a clone of this Vector2.
     *
     * @method Phaser.Math.Vector2#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} A clone of this Vector2.
     */ clone: function() {
                    return new Vector2(this.x, this.y);
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector2#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ copy: function(src) {
                    this.x = src.x || 0;
                    this.y = src.y || 0;
                    return this;
                },
                /**
     * Set the component values of this Vector from a given Vector2Like object.
     *
     * @method Phaser.Math.Vector2#setFromObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Math.Vector2Like} obj - The object containing the component values to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setFromObject: function(obj) {
                    this.x = obj.x || 0;
                    this.y = obj.y || 0;
                    return this;
                },
                /**
     * Set the `x` and `y` components of the this Vector to the given `x` and `y` values.
     *
     * @method Phaser.Math.Vector2#set
     * @since 3.0.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ set: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * This method is an alias for `Vector2.set`.
     *
     * @method Phaser.Math.Vector2#setTo
     * @since 3.4.0
     *
     * @param {number} x - The x value to set for this Vector.
     * @param {number} [y=x] - The y value to set for this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setTo: function(x, y) {
                    return this.set(x, y);
                },
                /**
     * Sets the `x` and `y` values of this object from a given polar coordinate.
     *
     * @method Phaser.Math.Vector2#setToPolar
     * @since 3.0.0
     *
     * @param {number} azimuth - The angular coordinate, in radians.
     * @param {number} [radius=1] - The radial coordinate (length).
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setToPolar: function(azimuth, radius) {
                    if (radius == null) radius = 1;
                    this.x = Math.cos(azimuth) * radius;
                    this.y = Math.sin(azimuth) * radius;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector2#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} v - The vector to compare with this Vector.
     *
     * @return {boolean} Whether the given Vector is equal to this Vector.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y;
                },
                /**
     * Check whether this Vector is approximately equal to a given Vector.
     *
     * @method Phaser.Math.Vector2#fuzzyEquals
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} v - The vector to compare with this Vector.
     * @param {number} [epsilon=0.0001] - The tolerance value.
     *
     * @return {boolean} Whether both absolute differences of the x and y components are smaller than `epsilon`.
     */ fuzzyEquals: function(v, epsilon) {
                    return FuzzyEqual(this.x, v.x, epsilon) && FuzzyEqual(this.y, v.y, epsilon);
                },
                /**
     * Calculate the angle between this Vector and the positive x-axis, in radians.
     *
     * @method Phaser.Math.Vector2#angle
     * @since 3.0.0
     *
     * @return {number} The angle between this Vector, and the positive x-axis, given in radians.
     */ angle: function() {
                    // computes the angle in radians with respect to the positive x-axis
                    var angle = Math.atan2(this.y, this.x);
                    if (angle < 0) angle += 2 * Math.PI;
                    return angle;
                },
                /**
     * Set the angle of this Vector.
     *
     * @method Phaser.Math.Vector2#setAngle
     * @since 3.23.0
     *
     * @param {number} angle - The angle, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setAngle: function(angle) {
                    return this.setToPolar(angle, this.length());
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector2#add
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ add: function(src) {
                    this.x += src.x;
                    this.y += src.y;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector2#subtract
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ subtract: function(src) {
                    this.x -= src.x;
                    this.y -= src.y;
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ multiply: function(src) {
                    this.x *= src.x;
                    this.y *= src.y;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector2#scale
     * @since 3.0.0
     *
     * @param {number} value - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ scale: function(value) {
                    if (isFinite(value)) {
                        this.x *= value;
                        this.y *= value;
                    } else {
                        this.x = 0;
                        this.y = 0;
                    }
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector2#divide
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ divide: function(src) {
                    this.x /= src.x;
                    this.y /= src.y;
                    return this;
                },
                /**
     * Negate the `x` and `y` components of this Vector.
     *
     * @method Phaser.Math.Vector2#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#distance
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(src) {
                    var dx = src.x - this.x;
                    var dy = src.y - this.y;
                    return Math.sqrt(dx * dx + dy * dy);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector2#distanceSq
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(src) {
                    var dx = src.x - this.x;
                    var dy = src.y - this.y;
                    return dx * dx + dy * dy;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    return Math.sqrt(x * x + y * y);
                },
                /**
     * Set the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#setLength
     * @since 3.23.0
     *
     * @param {number} length
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ setLength: function(length) {
                    return this.normalize().scale(length);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector2#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    return x * x + y * y;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector2#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var len = x * x + y * y;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                    }
                    return this;
                },
                /**
     * Rotate this Vector to its perpendicular, in the positive direction.
     *
     * @method Phaser.Math.Vector2#normalizeRightHand
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeRightHand: function() {
                    var x = this.x;
                    this.x = this.y * -1;
                    this.y = x;
                    return this;
                },
                /**
     * Rotate this Vector to its perpendicular, in the negative direction.
     *
     * @method Phaser.Math.Vector2#normalizeLeftHand
     * @since 3.23.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ normalizeLeftHand: function() {
                    var x = this.x;
                    this.x = this.y;
                    this.y = x * -1;
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector2 to dot product with this Vector2.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(src) {
                    return this.x * src.x + this.y * src.y;
                },
                /**
     * Calculate the cross product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector2#cross
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector2 to cross with this Vector2.
     *
     * @return {number} The cross product of this Vector and the given Vector.
     */ cross: function(src) {
                    return this.x * src.y - this.y * src.x;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector2#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} src - The Vector2 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ lerp: function(src, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    this.x = ax + t * (src.x - ax);
                    this.y = ay + t * (src.y - ay);
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat3: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var m = mat.val;
                    this.x = m[0] * x + m[3] * y + m[6];
                    this.y = m[1] * x + m[4] * y + m[7];
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector2#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector2 with.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[12];
                    this.y = m[1] * x + m[5] * y + m[13];
                    return this;
                },
                /**
     * Make this Vector the zero vector (0, 0).
     *
     * @method Phaser.Math.Vector2#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    return this;
                },
                /**
     * Limit the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector2#limit
     * @since 3.23.0
     *
     * @param {number} max - The maximum length.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ limit: function(max) {
                    var len = this.length();
                    if (len && len > max) this.scale(max / len);
                    return this;
                },
                /**
     * Reflect this Vector off a line defined by a normal.
     *
     * @method Phaser.Math.Vector2#reflect
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} normal - A vector perpendicular to the line.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ reflect: function(normal) {
                    normal = normal.clone().normalize();
                    return this.subtract(normal.scale(2 * this.dot(normal)));
                },
                /**
     * Reflect this Vector across another.
     *
     * @method Phaser.Math.Vector2#mirror
     * @since 3.23.0
     *
     * @param {Phaser.Math.Vector2} axis - A vector to reflect across.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ mirror: function(axis) {
                    return this.reflect(axis).negate();
                },
                /**
     * Rotate this Vector by an angle amount.
     *
     * @method Phaser.Math.Vector2#rotate
     * @since 3.23.0
     *
     * @param {number} delta - The angle to rotate by, in radians.
     *
     * @return {Phaser.Math.Vector2} This Vector2.
     */ rotate: function(delta) {
                    var cos = Math.cos(delta);
                    var sin = Math.sin(delta);
                    return this.set(cos * this.x - sin * this.y, sin * this.x + cos * this.y);
                }
            });
            /**
 * A static zero Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ZERO
 * @type {Phaser.Math.Vector2}
 * @since 3.1.0
 */ Vector2.ZERO = new Vector2();
            /**
 * A static right Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.RIGHT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.RIGHT = new Vector2(1, 0);
            /**
 * A static left Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.LEFT
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.LEFT = new Vector2(-1, 0);
            /**
 * A static up Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.UP
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.UP = new Vector2(0, -1);
            /**
 * A static down Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.DOWN
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.DOWN = new Vector2(0, 1);
            /**
 * A static one Vector2 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector2.ONE
 * @type {Phaser.Math.Vector2}
 * @since 3.16.0
 */ Vector2.ONE = new Vector2(1, 1);
            module1.exports = Vector2;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GEOM_CONST = __webpack_require__(55);
            /**
 * @classdesc
 * Defines a Point in 2D space, with an x and y component.
 *
 * @class Point
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x coordinate of this Point.
 * @param {number} [y=x] - The y coordinate of this Point.
 */ var Point = new Class({
                initialize: function Point(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.POINT`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Point#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POINT;
                    /**
         * The x coordinate of this Point.
         *
         * @name Phaser.Geom.Point#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y coordinate of this Point.
         *
         * @name Phaser.Geom.Point#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                },
                /**
     * Set the x and y coordinates of the point to the given values.
     *
     * @method Phaser.Geom.Point#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of this Point.
     * @param {number} [y=x] - The y coordinate of this Point.
     *
     * @return {this} This Point object.
     */ setTo: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                }
            });
            module1.exports = Point;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * The Game Object Factory is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and have them automatically registered with the Scene.
 *
 * Game Objects directly register themselves with the Factory and inject their own creation
 * methods into the class.
 *
 * @class GameObjectFactory
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectFactory = new Class({
                initialize: function GameObjectFactory(scene) {
                    /**
         * The Scene to which this Game Object Factory belongs.
         *
         * @name Phaser.GameObjects.GameObjectFactory#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectFactory#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectFactory#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectFactory#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.displayList = this.systems.displayList;
                    this.updateList = this.systems.updateList;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectFactory#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Adds an existing Game Object to this Scene.
     *
     * If the Game Object renders, it will be added to the Display List.
     * If it has a `preUpdate` method, it will be added to the Update List.
     *
     * @method Phaser.GameObjects.GameObjectFactory#existing
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.Group)} child - The child to be added to this Scene.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that was added.
     */ existing: function(child) {
                    if (child.renderCanvas || child.renderWebGL) this.displayList.add(child);
                    //  For when custom objects have overridden `preUpdate` but don't hook into the ADDED_TO_SCENE event:
                    //  Adding to the list multiple times is safe, as it won't add duplicates into the list anyway.
                    if (child.preUpdate) this.updateList.add(child);
                    return child;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectFactory#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectFactory#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                    this.displayList = null;
                    this.updateList = null;
                }
            });
            /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can register a custom GameObject factory in the GameObjectFactory,
 * providing a name (`factoryType`) and the constructor (`factoryFunction`) in order
 * to be called when you call to Phaser.Scene.add[ factoryType ] method.
 *
 * @method Phaser.GameObjects.GameObjectFactory.register
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you will use to call to Phaser.Scene.add[ factoryType ] method.
 * @param {function} factoryFunction - The constructor function to be called when you invoke to the Phaser.Scene.add method.
 */ GameObjectFactory.register = function(factoryType, factoryFunction) {
                if (!GameObjectFactory.prototype.hasOwnProperty(factoryType)) GameObjectFactory.prototype[factoryType] = factoryFunction;
            };
            /**
 * Static method called directly by the Game Object factory functions.
 * With this method you can remove a custom GameObject factory registered in the GameObjectFactory,
 * providing a its `factoryType`.
 *
 * @method Phaser.GameObjects.GameObjectFactory.remove
 * @static
 * @since 3.0.0
 *
 * @param {string} factoryType - The key of the factory that you want to remove from the GameObjectFactory.
 */ GameObjectFactory.remove = function(factoryType) {
                if (GameObjectFactory.prototype.hasOwnProperty(factoryType)) delete GameObjectFactory.prototype[factoryType];
            };
            PluginCache.register('GameObjectFactory', GameObjectFactory, 'add');
            module1.exports = GameObjectFactory;
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Source object
            //  The key as a string, or an array of keys, i.e. 'banner', or 'banner.hideBanner'
            //  The default value to use if the key doesn't exist
            /**
 * Retrieves a value from an object.
 *
 * @function Phaser.Utils.Objects.GetValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var GetValue = function(source, key, defaultValue) {
                if (!source || typeof source === 'number') return defaultValue;
                else if (source.hasOwnProperty(key)) return source[key];
                else if (key.indexOf('.') !== -1) {
                    var keys = key.split('.');
                    var parent = source;
                    var value = defaultValue;
                    //  Use for loop here so we can break early
                    for(var i = 0; i < keys.length; i++)if (parent.hasOwnProperty(keys[i])) {
                        //  Yes it has a key property, let's carry on down
                        value = parent[keys[i]];
                        parent = parent[keys[i]];
                    } else {
                        //  Can't go any further, so reset to default
                        value = defaultValue;
                        break;
                    }
                    return value;
                } else return defaultValue;
            };
            module1.exports = GetValue;
        /***/ },
        /* 7 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a slightly modified version of jQuery.isPlainObject.
 * A plain object is an object whose internal class property is [object Object].
 *
 * @function Phaser.Utils.Objects.IsPlainObject
 * @since 3.0.0
 *
 * @param {object} obj - The object to inspect.
 *
 * @return {boolean} `true` if the object is plain, otherwise `false`.
 */ var IsPlainObject = function(obj) {
                // Not plain objects:
                // - Any object or value whose internal [[Class]] property is not "[object Object]"
                // - DOM nodes
                // - window
                if (typeof obj !== 'object' || obj.nodeType || obj === obj.window) return false;
                // Support: Firefox <20
                // The try/catch suppresses exceptions thrown when attempting to access
                // the "constructor" property of certain host objects, ie. |window.location|
                // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
                try {
                    if (obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf')) return false;
                } catch (e) {
                    return false;
                }
                // If the function hasn't returned already, we're confident that
                // |obj| is a plain object, created by {} or constructed with new Object
                return true;
            };
            module1.exports = IsPlainObject;
        /***/ },
        /* 8 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var types = {};
            /**
 * @namespace Phaser.Loader.FileTypesManager
 */ var FileTypesManager = {
                /**
     * Static method called when a LoaderPlugin is created.
     * 
     * Loops through the local types object and injects all of them as
     * properties into the LoaderPlugin instance.
     *
     * @method Phaser.Loader.FileTypesManager.install
     * @since 3.0.0
     * 
     * @param {Phaser.Loader.LoaderPlugin} loader - The LoaderPlugin to install the types into.
     */ install: function(loader) {
                    for(var key in types)loader[key] = types[key];
                },
                /**
     * Static method called directly by the File Types.
     * 
     * The key is a reference to the function used to load the files via the Loader, i.e. `image`.
     *
     * @method Phaser.Loader.FileTypesManager.register
     * @since 3.0.0
     * 
     * @param {string} key - The key that will be used as the method name in the LoaderPlugin.
     * @param {function} factoryFunction - The function that will be called when LoaderPlugin.key is invoked.
     */ register: function(key, factoryFunction) {
                    types[key] = factoryFunction;
                },
                /**
     * Removed all associated file types.
     *
     * @method Phaser.Loader.FileTypesManager.destroy
     * @since 3.0.0
     */ destroy: function() {
                    types = {};
                }
            };
            module1.exports = FileTypesManager;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var has = Object.prototype.hasOwnProperty, prefix = '~';
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
                if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
                var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
                if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
                else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
                else emitter._events[evt] = [
                    emitter._events[evt],
                    listener
                ];
                return emitter;
            }
            /**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
                if (--emitter._eventsCount === 0) emitter._events = new Events();
                else delete emitter._events[evt];
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
                var evt = prefix ? prefix + event : event, handlers = this._events[evt];
                if (!handlers) return [];
                if (handlers.fn) return [
                    handlers.fn
                ];
                for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
                return ee;
            };
            /**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
                var evt = prefix ? prefix + event : event, listeners = this._events[evt];
                if (!listeners) return 0;
                if (listeners.fn) return 1;
                return listeners.length;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                return addListener(this, event, fn, context, false);
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                return addListener(this, event, fn, context, true);
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    clearEvent(this, evt);
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else clearEvent(this, evt);
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) clearEvent(this, evt);
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            module1.exports = EventEmitter;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(56);
            var GetPoint = __webpack_require__(167);
            var GetPoints = __webpack_require__(300);
            var GEOM_CONST = __webpack_require__(55);
            var Line = __webpack_require__(45);
            var Random = __webpack_require__(170);
            /**
 * @classdesc
 * Encapsulates a 2D rectangle defined by its corner point in the top-left and its extends in x (width) and y (height)
 *
 * @class Rectangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the top left corner of the Rectangle.
 * @param {number} [y=0] - The Y coordinate of the top left corner of the Rectangle.
 * @param {number} [width=0] - The width of the Rectangle.
 * @param {number} [height=0] - The height of the Rectangle.
 */ var Rectangle = new Class({
                initialize: function Rectangle(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.RECTANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Rectangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.RECTANGLE;
                    /**
         * The X coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The Y coordinate of the top left corner of the Rectangle.
         *
         * @name Phaser.Geom.Rectangle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the Rectangle, i.e. the distance between its left side (defined by `x`) and its right side.
         *
         * @name Phaser.Geom.Rectangle#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Rectangle, i.e. the distance between its top side (defined by `y`) and its bottom side.
         *
         * @name Phaser.Geom.Rectangle#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                },
                /**
     * Checks if the given point is inside the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the point to check.
     * @param {number} y - The Y coordinate of the point to check.
     *
     * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
     * 
     * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
     * 
     * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
     *
     * @method Phaser.Geom.Rectangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
     * @param {(Phaser.Geom.Point|object)} [output] - An object to update with the `x` and `y` coordinates of the point.
     *
     * @return {(Phaser.Geom.Point|object)} The updated `output` object, or a new Point if no `output` object was given.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Returns an array of points from the perimeter of the Rectangle, each spaced out based on the quantity or step required.
     *
     * @method Phaser.Geom.Rectangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to return. Set to `false` or 0 to return an arbitrary number of points (`perimeter / stepRate`) evenly spaced around the Rectangle based on the `stepRate`.
     * @param {number} [stepRate] - If `quantity` is 0, determines the normalized distance between each returned point.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to which to append the points.
     *
     * @return {(array|Phaser.Geom.Point[])} The modified `output` array, or a new array if none was provided.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a random point within the Rectangle's bounds.
     *
     * @method Phaser.Geom.Rectangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - The object in which to store the `x` and `y` coordinates of the point.
     *
     * @return {Phaser.Geom.Point} The updated `point`, or a new Point if none was provided.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the position, width, and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setTo
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} y - The Y coordinate of the top left corner of the Rectangle.
     * @param {number} width - The width of the Rectangle.
     * @param {number} height - The height of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setTo: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Resets the position, width, and height of the Rectangle to 0.
     *
     * @method Phaser.Geom.Rectangle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Rectangle object.
     */ setEmpty: function() {
                    return this.setTo(0, 0, 0, 0);
                },
                /**
     * Sets the position of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the top left corner of the Rectangle.
     * @param {number} [y=x] - The Y coordinate of the top left corner of the Rectangle.
     *
     * @return {this} This Rectangle object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the width and height of the Rectangle.
     *
     * @method Phaser.Geom.Rectangle#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width to set the Rectangle to.
     * @param {number} [height=width] - The height to set the Rectangle to.
     *
     * @return {this} This Rectangle object.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Determines if the Rectangle is empty. A Rectangle is empty if its width or height is less than or equal to 0.
     *
     * @method Phaser.Geom.Rectangle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Rectangle is empty. A Rectangle object is empty if its width or height is less than or equal to 0.
     */ isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                /**
     * Returns a Line object that corresponds to the top of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the top of this Rectangle.
     */ getLineA: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x, this.y, this.right, this.y);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the right of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the right of this Rectangle.
     */ getLineB: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.right, this.y, this.right, this.bottom);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the bottom of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the bottom of this Rectangle.
     */ getLineC: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.right, this.bottom, this.x, this.bottom);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to the left of this Rectangle.
     *
     * @method Phaser.Geom.Rectangle#getLineD
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to the left of this Rectangle.
     */ getLineD: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x, this.bottom, this.x, this.y);
                    return line;
                },
                /**
     * The x coordinate of the left of the Rectangle.
     * Changing the left property of a Rectangle object has no effect on the y and height properties. However it does affect the width property, whereas changing the x value does not affect the width property.
     *
     * @name Phaser.Geom.Rectangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x;
                    },
                    set: function(value) {
                        if (value >= this.right) this.width = 0;
                        else this.width = this.right - value;
                        this.x = value;
                    }
                },
                /**
     * The sum of the x and width properties.
     * Changing the right property of a Rectangle object has no effect on the x, y and height properties, however it does affect the width property.
     *
     * @name Phaser.Geom.Rectangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this.width;
                    },
                    set: function(value) {
                        if (value <= this.x) this.width = 0;
                        else this.width = value - this.x;
                    }
                },
                /**
     * The y coordinate of the top of the Rectangle. Changing the top property of a Rectangle object has no effect on the x and width properties.
     * However it does affect the height property, whereas changing the y value does not affect the height property.
     *
     * @name Phaser.Geom.Rectangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y;
                    },
                    set: function(value) {
                        if (value >= this.bottom) this.height = 0;
                        else this.height = this.bottom - value;
                        this.y = value;
                    }
                },
                /**
     * The sum of the y and height properties.
     * Changing the bottom property of a Rectangle object has no effect on the x, y and width properties, but does change the height property.
     *
     * @name Phaser.Geom.Rectangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this.height;
                    },
                    set: function(value) {
                        if (value <= this.y) this.height = 0;
                        else this.height = value - this.y;
                    }
                },
                /**
     * The x coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerX
     * @type {number}
     * @since 3.0.0
     */ centerX: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(value) {
                        this.x = value - this.width / 2;
                    }
                },
                /**
     * The y coordinate of the center of the Rectangle.
     *
     * @name Phaser.Geom.Rectangle#centerY
     * @type {number}
     * @since 3.0.0
     */ centerY: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(value) {
                        this.y = value - this.height / 2;
                    }
                }
            });
            module1.exports = Rectangle;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Components
 */ module1.exports = {
                Alpha: __webpack_require__(605),
                AlphaSingle: __webpack_require__(297),
                BlendMode: __webpack_require__(298),
                ComputedSize: __webpack_require__(606),
                Crop: __webpack_require__(607),
                Depth: __webpack_require__(299),
                Flip: __webpack_require__(608),
                GetBounds: __webpack_require__(609),
                Mask: __webpack_require__(303),
                Origin: __webpack_require__(630),
                PathFollower: __webpack_require__(631),
                Pipeline: __webpack_require__(171),
                ScrollFactor: __webpack_require__(306),
                Size: __webpack_require__(632),
                Texture: __webpack_require__(633),
                TextureCrop: __webpack_require__(634),
                Tint: __webpack_require__(635),
                ToJSON: __webpack_require__(173),
                Transform: __webpack_require__(307),
                TransformMatrix: __webpack_require__(25),
                Visible: __webpack_require__(308)
            };
        /***/ },
        /* 12 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @author       Matthew Groves <@doormat>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate shader source to test maximum ifs.
 *
 * @private
 * @ignore
 * @param {number} maxIfs - The number of if statements to generate
 */ function GenerateSrc(maxIfs) {
                var src = '';
                for(var i = 0; i < maxIfs; ++i){
                    if (i > 0) src += '\nelse ';
                    if (i < maxIfs - 1) src += 'if(test == ' + i + '.0){}';
                }
                return src;
            }
            /**
 * @namespace Phaser.Renderer.WebGL.Utils
 * @since 3.0.0
 */ module1.exports = {
                /**
     * Packs four floats on a range from 0.0 to 1.0 into a single Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintFromFloats
     * @since 3.0.0
     *
     * @param {number} r - Red component in a range from 0.0 to 1.0
     * @param {number} g - Green component in a range from 0.0 to 1.0
     * @param {number} b - Blue component in a range from 0.0 to 1.0
     * @param {number} a - Alpha component in a range from 0.0 to 1.0
     *
     * @return {number} The packed RGBA values as a Uint32.
     */ getTintFromFloats: function(r, g, b, a) {
                    var ur = (r * 255 | 0) & 0xff;
                    var ug = (g * 255 | 0) & 0xff;
                    var ub = (b * 255 | 0) & 0xff;
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | ur << 16 | ug << 8 | ub) >>> 0;
                },
                /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlpha: function(rgb, a) {
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | rgb) >>> 0;
                },
                /**
     * Packs a Uint24, representing RGB components, with a Float32, representing
     * the alpha component, with a range between 0.0 and 1.0 and return a
     * swizzled Uint32
     *
     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlphaAndSwap
     * @since 3.0.0
     *
     * @param {number} rgb - Uint24 representing RGB components
     * @param {number} a - Float32 representing Alpha component
     *
     * @return {number} Packed RGBA as Uint32
     */ getTintAppendFloatAlphaAndSwap: function(rgb, a) {
                    var ur = (rgb >> 16 | 0) & 0xff;
                    var ug = (rgb >> 8 | 0) & 0xff;
                    var ub = (rgb | 0) & 0xff;
                    var ua = (a * 255 | 0) & 0xff;
                    return (ua << 24 | ub << 16 | ug << 8 | ur) >>> 0;
                },
                /**
     * Unpacks a Uint24 RGB into an array of floats of ranges of 0.0 and 1.0
     *
     * @function Phaser.Renderer.WebGL.Utils.getFloatsFromUintRGB
     * @since 3.0.0
     *
     * @param {number} rgb - RGB packed as a Uint24
     *
     * @return {array} Array of floats representing each component as a float
     */ getFloatsFromUintRGB: function(rgb) {
                    var ur = (rgb >> 16 | 0) & 0xff;
                    var ug = (rgb >> 8 | 0) & 0xff;
                    var ub = (rgb | 0) & 0xff;
                    return [
                        ur / 255,
                        ug / 255,
                        ub / 255
                    ];
                },
                /**
     * Check to see how many texture units the GPU supports, based on the given config value.
     * Then tests this against the maximum number of iterations GLSL can support.
     *
     * @function Phaser.Renderer.WebGL.Utils.checkShaderMax
     * @since 3.50.0
     *
     * @param {WebGLRenderingContext} gl - The WebGLContext used to create the shaders.
     * @param {number} maxTextures - The Game Config maxTextures value.
     *
     * @return {number} The number of texture units that is supported by this browser and GPU.
     */ checkShaderMax: function(gl, maxTextures) {
                    if (!maxTextures || maxTextures === -1) maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                    var shader = gl.createShader(gl.FRAGMENT_SHADER);
                    var fragTemplate = [
                        'precision mediump float;',
                        'void main(void){',
                        'float test = 0.1;',
                        '%forloop%',
                        'gl_FragColor = vec4(0.0);',
                        '}'
                    ].join('\n');
                    // eslint-disable-next-line no-constant-condition
                    while(true){
                        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, GenerateSrc(maxTextures));
                        gl.shaderSource(shader, fragmentSrc);
                        gl.compileShader(shader);
                        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxTextures = maxTextures / 2 | 0;
                        else break;
                    }
                    return maxTextures;
                },
                /**
     * Checks the given Fragment Shader Source for `%count%` and `%forloop%` declarations and
     * replaces those with GLSL code for setting `texture = texture2D(uMainSampler[i], outTexCoord)`.
     *
     * @function Phaser.Renderer.WebGL.Utils.parseFragmentShaderMaxTextures
     * @since 3.50.0
     *
     * @param {string} fragmentShaderSource - The Fragment Shader source code to operate on.
     * @param {number} maxTextures - The number of maxTextures value.
     *
     * @return {string} The modified Fragment Shader source.
     */ parseFragmentShaderMaxTextures: function(fragmentShaderSource, maxTextures) {
                    if (!fragmentShaderSource) return '';
                    var src = '';
                    for(var i = 0; i < maxTextures; i++){
                        if (i > 0) src += '\n\telse ';
                        if (i < maxTextures - 1) src += 'if (outTexId < ' + i + '.5)';
                        src += '\n\t{';
                        src += '\n\t\ttexture = texture2D(uMainSampler[' + i + '], outTexCoord);';
                        src += '\n\t}';
                    }
                    fragmentShaderSource = fragmentShaderSource.replace(/%count%/gi, maxTextures.toString());
                    return fragmentShaderSource.replace(/%forloop%/gi, src);
                }
            };
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH = __webpack_require__(190);
            var GetValue = __webpack_require__(6);
            /**
 * Retrieves a value from an object. Allows for more advanced selection options, including:
 *
 * Allowed types:
 * 
 * Implicit
 * {
 *     x: 4
 * }
 *
 * From function
 * {
 *     x: function ()
 * }
 *
 * Randomly pick one element from the array
 * {
 *     x: [a, b, c, d, e, f]
 * }
 *
 * Random integer between min and max:
 * {
 *     x: { randInt: [min, max] }
 * }
 *
 * Random float between min and max:
 * {
 *     x: { randFloat: [min, max] }
 * }
 * 
 *
 * @function Phaser.Utils.Objects.GetAdvancedValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`) - `banner.hideBanner` would return the value of the `hideBanner` property from the object stored in the `banner` property of the `source` object.
 * @param {*} defaultValue - The value to return if the `key` isn't found in the `source` object.
 *
 * @return {*} The value of the requested key.
 */ var GetAdvancedValue = function(source, key, defaultValue) {
                var value = GetValue(source, key, null);
                if (value === null) return defaultValue;
                else if (Array.isArray(value)) return MATH.RND.pick(value);
                else if (typeof value === 'object') {
                    if (value.hasOwnProperty('randInt')) return MATH.RND.integerInRange(value.randInt[0], value.randInt[1]);
                    else if (value.hasOwnProperty('randFloat')) return MATH.RND.realInRange(value.randFloat[0], value.randFloat[1]);
                } else if (typeof value === 'function') return value(key);
                return value;
            };
            module1.exports = GetAdvancedValue;
        /***/ },
        /* 14 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = {
                /**
     * The value of PI * 2.
     * 
     * @name Phaser.Math.PI2
     * @type {number}
     * @since 3.0.0
     */ PI2: Math.PI * 2,
                /**
     * The value of PI * 0.5.
     * 
     * @name Phaser.Math.TAU
     * @type {number}
     * @since 3.0.0
     */ TAU: Math.PI * 0.5,
                /**
     * An epsilon value (1.0e-6)
     * 
     * @name Phaser.Math.EPSILON
     * @type {number}
     * @since 3.0.0
     */ EPSILON: 1.0e-6,
                /**
     * For converting degrees to radians (PI / 180)
     * 
     * @name Phaser.Math.DEG_TO_RAD
     * @type {number}
     * @since 3.0.0
     */ DEG_TO_RAD: Math.PI / 180,
                /**
     * For converting radians to degrees (180 / PI)
     * 
     * @name Phaser.Math.RAD_TO_DEG
     * @type {number}
     * @since 3.0.0
     */ RAD_TO_DEG: 180 / Math.PI,
                /**
     * An instance of the Random Number Generator.
     * This is not set until the Game boots.
     * 
     * @name Phaser.Math.RND
     * @type {Phaser.Math.RandomDataGenerator}
     * @since 3.0.0
     */ RND: null,
                /**
     * The minimum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     * 
     * @name Phaser.Math.MIN_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER || -9007199254740991,
                /**
     * The maximum safe integer this browser supports.
     * We use a const for backward compatibility with Internet Explorer.
     * 
     * @name Phaser.Math.MAX_SAFE_INTEGER
     * @type {number}
     * @since 3.21.0
     */ MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991
            };
            module1.exports = MATH_CONST;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ComponentsToJSON = __webpack_require__(173);
            var DataManager = __webpack_require__(98);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(75);
            /**
 * @classdesc
 * The base class that all Game Objects extend.
 * You don't create GameObjects directly and they cannot be added to the display list.
 * Instead, use them as the base for your own custom classes.
 *
 * @class GameObject
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {string} type - A textual representation of the type of Game Object, i.e. `sprite`.
 */ var GameObject = new Class({
                Extends: EventEmitter,
                initialize: function GameObject(scene, type) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.GameObject#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.GameObject#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                    /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.GameObject#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                    /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.GameObject#state
         * @type {(number|string)}
         * @since 3.16.0
         */ this.state = 0;
                    /**
         * The parent Container of this Game Object, if it has one.
         *
         * @name Phaser.GameObjects.GameObject#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.4.0
         */ this.parentContainer = null;
                    /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.GameObject#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                    /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.GameObject#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.GameObject#tabIndex
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.tabIndex = -1;
                    /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.GameObject#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.0.0
         */ this.data = null;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.GameObject#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.GameObject#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                    /**
         * If this Game Object is enabled for input then this property will contain an InteractiveObject instance.
         * Not usually set directly. Instead call `GameObject.setInteractive()`.
         *
         * @name Phaser.GameObjects.GameObject#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.0.0
         */ this.input = null;
                    /**
         * If this Game Object is enabled for Arcade or Matter Physics then this property will contain a reference to a Physics Body.
         *
         * @name Phaser.GameObjects.GameObject#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                    /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.GameObject#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.5.0
         */ this.ignoreDestroy = false;
                    this.on(Events.ADDED_TO_SCENE, this.addedToScene, this);
                    this.on(Events.REMOVED_FROM_SCENE, this.removedFromScene, this);
                    //  Tell the Scene to re-sort the children
                    scene.sys.queueDepthSort();
                },
                /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.GameObject#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.GameObject#setName
     * @since 3.0.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.GameObject#setState
     * @since 3.16.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                    this.state = value;
                    return this;
                },
                /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#setDataEnabled
     * @since 3.0.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                    if (!this.data) this.data = new DataManager(this);
                    return this;
                },
                /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.GameObject#setData
     * @since 3.0.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.set(key, value);
                    return this;
                },
                /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#incData
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.inc(key, value);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toggleData
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.toggle(key);
                    return this;
                },
                /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.GameObject#getData
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    return this.data.get(key);
                },
                /**
     * Pass this Game Object to the Input Manager to enable it for Input.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @example
     * sprite.setInteractive();
     *
     * @example
     * sprite.setInteractive(new Phaser.Geom.Circle(45, 46, 45), Phaser.Geom.Circle.Contains);
     *
     * @example
     * graphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, 128, 128), Phaser.Geom.Rectangle.Contains);
     *
     * @method Phaser.GameObjects.GameObject#setInteractive
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not given it will try to create a Rectangle based on the texture frame.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The callback that determines if the pointer is within the Hit Area shape or not. If you provide a shape you must also provide a callback.
     * @param {boolean} [dropZone=false] - Should this Game Object be treated as a drop zone target?
     *
     * @return {this} This GameObject.
     */ setInteractive: function(hitArea, hitAreaCallback, dropZone) {
                    this.scene.sys.input.enable(this, hitArea, hitAreaCallback, dropZone);
                    return this;
                },
                /**
     * If this Game Object has previously been enabled for input, this will disable it.
     *
     * An object that is disabled for input stops processing or being considered for
     * input events, but can be turned back on again at any time by simply calling
     * `setInteractive()` with no arguments provided.
     *
     * If want to completely remove interaction from this Game Object then use `removeInteractive` instead.
     *
     * @method Phaser.GameObjects.GameObject#disableInteractive
     * @since 3.7.0
     *
     * @return {this} This GameObject.
     */ disableInteractive: function() {
                    if (this.input) this.input.enabled = false;
                    return this;
                },
                /**
     * If this Game Object has previously been enabled for input, this will queue it
     * for removal, causing it to no longer be interactive. The removal happens on
     * the next game step, it is not immediate.
     *
     * The Interactive Object that was assigned to this Game Object will be destroyed,
     * removed from the Input Manager and cleared from this Game Object.
     *
     * If you wish to re-enable this Game Object at a later date you will need to
     * re-create its InteractiveObject by calling `setInteractive` again.
     *
     * If you wish to only temporarily stop an object from receiving input then use
     * `disableInteractive` instead, as that toggles the interactive state, where-as
     * this erases it completely.
     *
     * If you wish to resize a hit area, don't remove and then set it as being
     * interactive. Instead, access the hitarea object directly and resize the shape
     * being used. I.e.: `sprite.input.hitArea.setSize(width, height)` (assuming the
     * shape is a Rectangle, which it is by default.)
     *
     * @method Phaser.GameObjects.GameObject#removeInteractive
     * @since 3.7.0
     *
     * @return {this} This GameObject.
     */ removeInteractive: function() {
                    this.scene.sys.input.clear(this);
                    this.input = undefined;
                    return this;
                },
                /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.GameObject#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.GameObject#update
     * @since 3.0.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.GameObject#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return ComponentsToJSON(this);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.GameObject#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.GameObject#getIndexList
     * @since 3.4.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                    // eslint-disable-next-line consistent-this
                    var child = this;
                    var parent = this.parentContainer;
                    var indexes = [];
                    while(parent){
                        indexes.unshift(parent.getIndex(child));
                        child = parent;
                        if (!parent.parentContainer) break;
                        else parent = parent.parentContainer;
                    }
                    if (this.displayList) indexes.unshift(this.displayList.getIndex(child));
                    else indexes.unshift(this.scene.sys.displayList.getIndex(child));
                    return indexes;
                },
                /**
     * Destroys this Game Object removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also removes itself from the Input Manager and Physics Manager if previously enabled.
     *
     * Use this to remove a Game Object from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.GameObject#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    //  This Game Object has already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    if (this.preDestroy) this.preDestroy.call(this);
                    this.emit(Events.DESTROY, this);
                    this.removeAllListeners();
                    if (this.postPipelines) this.resetPostPipeline(true);
                    if (this.displayList) {
                        this.displayList.queueDepthSort();
                        this.displayList.remove(this);
                    }
                    if (this.input) {
                        this.scene.sys.input.clear(this);
                        this.input = undefined;
                    }
                    if (this.data) {
                        this.data.destroy();
                        this.data = undefined;
                    }
                    if (this.body) {
                        this.body.destroy();
                        this.body = undefined;
                    }
                    this.active = false;
                    this.visible = false;
                    this.scene = undefined;
                    this.displayList = undefined;
                    this.parentContainer = undefined;
                }
            });
            /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.GameObject
 * @default
 */ GameObject.RENDER_MASK = 15;
            module1.exports = GameObject;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * The Game Object Creator is a Scene plugin that allows you to quickly create many common
 * types of Game Objects and return them. Unlike the Game Object Factory, they are not automatically
 * added to the Scene.
 *
 * Game Objects directly register themselves with the Creator and inject their own creation
 * methods into the class.
 *
 * @class GameObjectCreator
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
 */ var GameObjectCreator = new Class({
                initialize: function GameObjectCreator(scene) {
                    /**
         * The Scene to which this Game Object Creator belongs.
         *
         * @name Phaser.GameObjects.GameObjectCreator#scene
         * @type {Phaser.Scene}
         * @protected
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems.
         *
         * @name Phaser.GameObjects.GameObjectCreator#systems
         * @type {Phaser.Scenes.Systems}
         * @protected
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.GameObjectCreator#events
         * @type {Phaser.Events.EventEmitter}
         * @protected
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * A reference to the Scene Display List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @protected
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Update List.
         *
         * @name Phaser.GameObjects.GameObjectCreator#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @protected
         * @since 3.0.0
         */ this.updateList;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.displayList = this.systems.displayList;
                    this.updateList = this.systems.updateList;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.GameObjectCreator#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.GameObjectCreator#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.GameObjectCreator#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                    this.displayList = null;
                    this.updateList = null;
                }
            });
            //  Static method called directly by the Game Object creator functions
            GameObjectCreator.register = function(factoryType, factoryFunction) {
                if (!GameObjectCreator.prototype.hasOwnProperty(factoryType)) GameObjectCreator.prototype[factoryType] = factoryFunction;
            };
            GameObjectCreator.remove = function(factoryType) {
                if (GameObjectCreator.prototype.hasOwnProperty(factoryType)) delete GameObjectCreator.prototype[factoryType];
            };
            PluginCache.register('GameObjectCreator', GameObjectCreator, 'make');
            module1.exports = GameObjectCreator;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsPlainObject = __webpack_require__(7);
            // @param {boolean} deep - Perform a deep copy?
            // @param {object} target - The target object to copy to.
            // @return {object} The extended object.
            /**
 * This is a slightly modified version of http://api.jquery.com/jQuery.extend/
 *
 * @function Phaser.Utils.Objects.Extend
 * @since 3.0.0
 *
 * @param {...*} [args] - The objects that will be mixed.
 *
 * @return {object} The extended object.
 */ var Extend = function() {
                var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
                // Handle a deep copy situation
                if (typeof target === 'boolean') {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                // extend Phaser if only one argument is passed
                if (length === i) {
                    target = this;
                    --i;
                }
                for(; i < length; i++){
                    // Only deal with non-null/undefined values
                    if ((options = arguments[i]) != null) // Extend the base object
                    for(name in options){
                        src = target[name];
                        copy = options[name];
                        // Prevent never-ending loop
                        if (target === copy) continue;
                        // Recurse if we're merging plain objects or arrays
                        if (deep && copy && (IsPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                            if (copyIsArray) {
                                copyIsArray = false;
                                clone = src && Array.isArray(src) ? src : [];
                            } else clone = src && IsPlainObject(src) ? src : {};
                            // Never move original objects, clone them
                            target[name] = Extend(deep, clone, copy);
                        // Don't bring in undefined values
                        } else if (copy !== undefined) target[name] = copy;
                    }
                }
                // Return the modified object
                return target;
            };
            module1.exports = Extend;
        /***/ },
        /* 18 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Force a value within the boundaries by clamping it to the range `min`, `max`.
 *
 * @function Phaser.Math.Clamp
 * @since 3.0.0
 *
 * @param {number} value - The value to be clamped.
 * @param {number} min - The minimum bounds.
 * @param {number} max - The maximum bounds.
 *
 * @return {number} The clamped value.
 */ var Clamp = function(value, min, max) {
                return Math.max(min, Math.min(max, value));
            };
            module1.exports = Clamp;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var result = {
                camera: tempMatrix1,
                sprite: tempMatrix2,
                calc: tempMatrix3
            };
            /**
 * Calculates the Transform Matrix of the given Game Object and Camera, factoring in
 * the parent matrix if provided.
 *
 * Note that the object this results contains _references_ to the Transform Matrices,
 * not new instances of them. Therefore, you should use their values immediately, or
 * copy them to your own matrix, as they will be replaced as soon as another Game
 * Object is rendered.
 *
 * @function Phaser.GameObjects.GetCalcMatrix
 * @memberof Phaser.GameObjects
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} src - The Game Object to calculate the transform matrix for.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera being used to render the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - The transform matrix of the parent container, if any.
 *
 * @return {Phaser.Types.GameObjects.GetCalcMatrixResults} The results object containing the updated transform matrices.
 */ var GetCalcMatrix = function(src, camera, parentMatrix) {
                var camMatrix = tempMatrix1;
                var spriteMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                spriteMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                camMatrix.copyFrom(camera.matrix);
                if (parentMatrix) {
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    spriteMatrix.e = src.x;
                    spriteMatrix.f = src.y;
                } else {
                    spriteMatrix.e -= camera.scrollX * src.scrollFactorX;
                    spriteMatrix.f -= camera.scrollY * src.scrollFactorY;
                }
                //  Multiply by the Sprite matrix, store result in calcMatrix
                camMatrix.multiply(spriteMatrix, calcMatrix);
                return result;
            };
            module1.exports = GetCalcMatrix;
        /***/ },
        /* 20 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FILE_CONST = {
                /**
     * The Loader is idle.
     * 
     * @name Phaser.Loader.LOADER_IDLE
     * @type {number}
     * @since 3.0.0
     */ LOADER_IDLE: 0,
                /**
     * The Loader is actively loading.
     * 
     * @name Phaser.Loader.LOADER_LOADING
     * @type {number}
     * @since 3.0.0
     */ LOADER_LOADING: 1,
                /**
     * The Loader is processing files is has loaded.
     * 
     * @name Phaser.Loader.LOADER_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ LOADER_PROCESSING: 2,
                /**
     * The Loader has completed loading and processing.
     * 
     * @name Phaser.Loader.LOADER_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ LOADER_COMPLETE: 3,
                /**
     * The Loader is shutting down.
     * 
     * @name Phaser.Loader.LOADER_SHUTDOWN
     * @type {number}
     * @since 3.0.0
     */ LOADER_SHUTDOWN: 4,
                /**
     * The Loader has been destroyed.
     * 
     * @name Phaser.Loader.LOADER_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ LOADER_DESTROYED: 5,
                /**
     * File is in the load queue but not yet started
     * 
     * @name Phaser.Loader.FILE_PENDING
     * @type {number}
     * @since 3.0.0
     */ FILE_PENDING: 10,
                /**
     * File has been started to load by the loader (onLoad called)
     * 
     * @name Phaser.Loader.FILE_LOADING
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADING: 11,
                /**
     * File has loaded successfully, awaiting processing    
     * 
     * @name Phaser.Loader.FILE_LOADED
     * @type {number}
     * @since 3.0.0
     */ FILE_LOADED: 12,
                /**
     * File failed to load
     * 
     * @name Phaser.Loader.FILE_FAILED
     * @type {number}
     * @since 3.0.0
     */ FILE_FAILED: 13,
                /**
     * File is being processed (onProcess callback)
     * 
     * @name Phaser.Loader.FILE_PROCESSING
     * @type {number}
     * @since 3.0.0
     */ FILE_PROCESSING: 14,
                /**
     * The File has errored somehow during processing.
     * 
     * @name Phaser.Loader.FILE_ERRORED
     * @type {number}
     * @since 3.0.0
     */ FILE_ERRORED: 16,
                /**
     * File has finished processing.
     * 
     * @name Phaser.Loader.FILE_COMPLETE
     * @type {number}
     * @since 3.0.0
     */ FILE_COMPLETE: 17,
                /**
     * File has been destroyed
     * 
     * @name Phaser.Loader.FILE_DESTROYED
     * @type {number}
     * @since 3.0.0
     */ FILE_DESTROYED: 18,
                /**
     * File was populated from local data and doesn't need an HTTP request
     * 
     * @name Phaser.Loader.FILE_POPULATED
     * @type {number}
     * @since 3.0.0
     */ FILE_POPULATED: 19
            };
            module1.exports = FILE_CONST;
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scenes.Events
 */ module1.exports = {
                ADDED_TO_SCENE: __webpack_require__(782),
                BOOT: __webpack_require__(783),
                CREATE: __webpack_require__(784),
                DESTROY: __webpack_require__(785),
                PAUSE: __webpack_require__(786),
                POST_UPDATE: __webpack_require__(787),
                PRE_UPDATE: __webpack_require__(788),
                READY: __webpack_require__(789),
                REMOVED_FROM_SCENE: __webpack_require__(790),
                RENDER: __webpack_require__(791),
                RESUME: __webpack_require__(792),
                SHUTDOWN: __webpack_require__(793),
                SLEEP: __webpack_require__(794),
                START: __webpack_require__(795),
                TRANSITION_COMPLETE: __webpack_require__(796),
                TRANSITION_INIT: __webpack_require__(797),
                TRANSITION_OUT: __webpack_require__(798),
                TRANSITION_START: __webpack_require__(799),
                TRANSITION_WAKE: __webpack_require__(800),
                UPDATE: __webpack_require__(801),
                WAKE: __webpack_require__(802)
            };
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core.Events
 */ module1.exports = {
                BLUR: __webpack_require__(610),
                BOOT: __webpack_require__(611),
                CONTEXT_LOST: __webpack_require__(612),
                CONTEXT_RESTORED: __webpack_require__(613),
                DESTROY: __webpack_require__(614),
                FOCUS: __webpack_require__(615),
                HIDDEN: __webpack_require__(616),
                PAUSE: __webpack_require__(617),
                POST_RENDER: __webpack_require__(618),
                POST_STEP: __webpack_require__(619),
                PRE_RENDER: __webpack_require__(620),
                PRE_STEP: __webpack_require__(621),
                READY: __webpack_require__(622),
                RESUME: __webpack_require__(623),
                STEP: __webpack_require__(624),
                VISIBLE: __webpack_require__(625)
            };
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var Events = __webpack_require__(91);
            var GetFastValue = __webpack_require__(2);
            var GetURL = __webpack_require__(153);
            var MergeXHRSettings = __webpack_require__(237);
            var XHRLoader = __webpack_require__(511);
            var XHRSettings = __webpack_require__(154);
            /**
 * @classdesc
 * The base File class used by all File Types that the Loader can support.
 * You shouldn't create an instance of a File directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class File
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {Phaser.Types.Loader.FileConfig} fileConfig - The file configuration object, as created by the file type.
 */ var File = new Class({
                initialize: function File(loader, fileConfig) {
                    /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.File#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.loader = loader;
                    /**
         * A reference to the Cache, or Texture Manager, that is going to store this file if it loads.
         *
         * @name Phaser.Loader.File#cache
         * @type {(Phaser.Cache.BaseCache|Phaser.Textures.TextureManager)}
         * @since 3.7.0
         */ this.cache = GetFastValue(fileConfig, 'cache', false);
                    /**
         * The file type string (image, json, etc) for sorting within the Loader.
         *
         * @name Phaser.Loader.File#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(fileConfig, 'type', false);
                    /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.File#key
         * @type {string}
         * @since 3.0.0
         */ this.key = GetFastValue(fileConfig, 'key', false);
                    var loadKey = this.key;
                    if (loader.prefix && loader.prefix !== '') this.key = loader.prefix + loadKey;
                    if (!this.type || !this.key) throw new Error('Invalid Loader.' + this.type + ' key');
                    var url = GetFastValue(fileConfig, 'url');
                    if (url === undefined) url = loader.path + loadKey + '.' + GetFastValue(fileConfig, 'extension', '');
                    else if (typeof url === 'string' && !url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)) url = loader.path + url;
                    /**
         * The URL of the file, not including baseURL.
         *
         * Automatically has Loader.path prepended to it if a string.
         *
         * Can also be a JavaScript Object, such as the results of parsing JSON data.
         *
         * @name Phaser.Loader.File#url
         * @type {object|string}
         * @since 3.0.0
         */ this.url = url;
                    /**
         * The final URL this file will load from, including baseURL and path.
         * Set automatically when the Loader calls 'load' on this file.
         *
         * @name Phaser.Loader.File#src
         * @type {string}
         * @since 3.0.0
         */ this.src = '';
                    /**
         * The merged XHRSettings for this file.
         *
         * @name Phaser.Loader.File#xhrSettings
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhrSettings = XHRSettings(GetFastValue(fileConfig, 'responseType', undefined));
                    if (GetFastValue(fileConfig, 'xhrSettings', false)) this.xhrSettings = MergeXHRSettings(this.xhrSettings, GetFastValue(fileConfig, 'xhrSettings', {}));
                    /**
         * The XMLHttpRequest instance (as created by XHR Loader) that is loading this File.
         *
         * @name Phaser.Loader.File#xhrLoader
         * @type {?XMLHttpRequest}
         * @since 3.0.0
         */ this.xhrLoader = null;
                    /**
         * The current state of the file. One of the FILE_CONST values.
         *
         * @name Phaser.Loader.File#state
         * @type {number}
         * @since 3.0.0
         */ this.state = typeof this.url === 'function' ? CONST.FILE_POPULATED : CONST.FILE_PENDING;
                    /**
         * The total size of this file.
         * Set by onProgress and only if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bytesTotal = 0;
                    /**
         * Updated as the file loads.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#bytesLoaded
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.bytesLoaded = -1;
                    /**
         * A percentage value between 0 and 1 indicating how much of this file has loaded.
         * Only set if loading via XHR.
         *
         * @name Phaser.Loader.File#percentComplete
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.percentComplete = -1;
                    /**
         * For CORs based loading.
         * If this is undefined then the File will check BaseLoader.crossOrigin and use that (if set)
         *
         * @name Phaser.Loader.File#crossOrigin
         * @type {(string|undefined)}
         * @since 3.0.0
         */ this.crossOrigin = undefined;
                    /**
         * The processed file data, stored here after the file has loaded.
         *
         * @name Phaser.Loader.File#data
         * @type {*}
         * @since 3.0.0
         */ this.data = undefined;
                    /**
         * A config object that can be used by file types to store transitional data.
         *
         * @name Phaser.Loader.File#config
         * @type {*}
         * @since 3.0.0
         */ this.config = GetFastValue(fileConfig, 'config', {});
                    /**
         * If this is a multipart file, i.e. an atlas and its json together, then this is a reference
         * to the parent MultiFile. Set and used internally by the Loader or specific file types.
         *
         * @name Phaser.Loader.File#multiFile
         * @type {?Phaser.Loader.MultiFile}
         * @since 3.7.0
         */ this.multiFile;
                    /**
         * Does this file have an associated linked file? Such as an image and a normal map.
         * Atlases and Bitmap Fonts use the multiFile, because those files need loading together but aren't
         * actually bound by data, where-as a linkFile is.
         *
         * @name Phaser.Loader.File#linkFile
         * @type {?Phaser.Loader.File}
         * @since 3.7.0
         */ this.linkFile;
                },
                /**
     * Links this File with another, so they depend upon each other for loading and processing.
     *
     * @method Phaser.Loader.File#setLink
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} fileB - The file to link to this one.
     */ setLink: function(fileB) {
                    this.linkFile = fileB;
                    fileB.linkFile = this;
                },
                /**
     * Resets the XHRLoader instance this file is using.
     *
     * @method Phaser.Loader.File#resetXHR
     * @since 3.0.0
     */ resetXHR: function() {
                    if (this.xhrLoader) {
                        this.xhrLoader.onload = undefined;
                        this.xhrLoader.onerror = undefined;
                        this.xhrLoader.onprogress = undefined;
                    }
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.File#load
     * @since 3.0.0
     */ load: function() {
                    if (this.state === CONST.FILE_POPULATED) //  Can happen for example in a JSONFile if they've provided a JSON object instead of a URL
                    this.loader.nextFile(this, true);
                    else {
                        this.state = CONST.FILE_LOADING;
                        this.src = GetURL(this, this.loader.baseURL);
                        if (this.src.indexOf('data:') === 0) console.warn('Local data URIs are not supported: ' + this.key);
                        else //  The creation of this XHRLoader starts the load process going.
                        //  It will automatically call the following, based on the load outcome:
                        //
                        // xhr.onload = this.onLoad
                        // xhr.onerror = this.onError
                        // xhr.onprogress = this.onProgress
                        this.xhrLoader = XHRLoader(this, this.loader.xhr);
                    }
                },
                /**
     * Called when the file finishes loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onLoad
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onLoad: function(xhr, event) {
                    var localFileOk = xhr.responseURL && xhr.responseURL.indexOf('file://') === 0 && event.target.status === 0;
                    var success = !(event.target && event.target.status !== 200) || localFileOk;
                    //  Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
                    if (xhr.readyState === 4 && xhr.status >= 400 && xhr.status <= 599) success = false;
                    this.state = CONST.FILE_LOADED;
                    this.resetXHR();
                    this.loader.nextFile(this, success);
                },
                /**
     * Called if the file errors while loading, is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onError
     * @since 3.0.0
     *
     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this error.
     */ onError: function() {
                    this.resetXHR();
                    this.loader.nextFile(this, false);
                },
                /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.File#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent.
     */ onProgress: function(event) {
                    if (event.lengthComputable) {
                        this.bytesLoaded = event.loaded;
                        this.bytesTotal = event.total;
                        this.percentComplete = Math.min(this.bytesLoaded / this.bytesTotal, 1);
                        this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                    }
                },
                /**
     * Usually overridden by the FileTypes and is called by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data, for example a JSON file will parse itself during this stage.
     *
     * @method Phaser.Loader.File#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.onProcessComplete();
                },
                /**
     * Called when the File has completed processing.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessComplete
     * @since 3.7.0
     */ onProcessComplete: function() {
                    this.state = CONST.FILE_COMPLETE;
                    if (this.multiFile) this.multiFile.onFileComplete(this);
                    this.loader.fileProcessComplete(this);
                },
                /**
     * Called when the File has completed processing but it generated an error.
     * Checks on the state of its multifile, if set.
     *
     * @method Phaser.Loader.File#onProcessError
     * @since 3.7.0
     */ onProcessError: function() {
                    this.state = CONST.FILE_ERRORED;
                    if (this.multiFile) this.multiFile.onFileFailed(this);
                    this.loader.fileProcessComplete(this);
                },
                /**
     * Checks if a key matching the one used by this file exists in the target Cache or not.
     * This is called automatically by the LoaderPlugin to decide if the file can be safely
     * loaded or will conflict.
     *
     * @method Phaser.Loader.File#hasCacheConflict
     * @since 3.7.0
     *
     * @return {boolean} `true` if adding this file will cause a conflict, otherwise `false`.
     */ hasCacheConflict: function() {
                    return this.cache && this.cache.exists(this.key);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     * This method is often overridden by specific file types.
     *
     * @method Phaser.Loader.File#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.cache) this.cache.add(this.key, this.data);
                    this.pendingDestroy();
                },
                /**
     * Called once the file has been added to its cache and is now ready for deletion from the Loader.
     * It will emit a `filecomplete` event from the LoaderPlugin.
     *
     * @method Phaser.Loader.File#pendingDestroy
     * @fires Phaser.Loader.Events#FILE_COMPLETE
     * @fires Phaser.Loader.Events#FILE_KEY_COMPLETE
     * @since 3.7.0
     */ pendingDestroy: function(data) {
                    if (data === undefined) data = this.data;
                    var key = this.key;
                    var type = this.type;
                    this.loader.emit(Events.FILE_COMPLETE, key, type, data);
                    this.loader.emit(Events.FILE_KEY_COMPLETE + type + '-' + key, key, type, data);
                    this.loader.flagForRemoval(this);
                },
                /**
     * Destroy this File and any references it holds.
     *
     * @method Phaser.Loader.File#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.loader = null;
                    this.cache = null;
                    this.xhrSettings = null;
                    this.multiFile = null;
                    this.linkFile = null;
                    this.data = null;
                }
            });
            /**
 * Static method for creating object URL using URL API and setting it as image 'src' attribute.
 * If URL API is not supported (usually on old browsers) it falls back to creating Base64 encoded url using FileReader.
 *
 * @method Phaser.Loader.File.createObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be set to object URL.
 * @param {Blob} blob - A Blob object to create an object URL for.
 * @param {string} defaultType - Default mime type used if blob type is not available.
 */ File.createObjectURL = function(image, blob, defaultType) {
                if (typeof URL === 'function') image.src = URL.createObjectURL(blob);
                else {
                    var reader = new FileReader();
                    reader.onload = function() {
                        image.removeAttribute('crossOrigin');
                        image.src = 'data:' + (blob.type || defaultType) + ';base64,' + reader.result.split(',')[1];
                    };
                    reader.onerror = image.onerror;
                    reader.readAsDataURL(blob);
                }
            };
            /**
 * Static method for releasing an existing object URL which was previously created
 * by calling {@link File#createObjectURL} method.
 *
 * @method Phaser.Loader.File.revokeObjectURL
 * @static
 * @since 3.7.0
 *
 * @param {HTMLImageElement} image - Image object which 'src' attribute should be revoked.
 */ File.revokeObjectURL = function(image) {
                if (typeof URL === 'function') URL.revokeObjectURL(image.src);
            };
            module1.exports = File;
        /***/ },
        /* 24 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Contains the plugins that Phaser uses globally and locally.
            //  These are the source objects, not instantiated.
            var corePlugins = {};
            //  Contains the plugins that the dev has loaded into their game
            //  These are the source objects, not instantiated.
            var customPlugins = {};
            var PluginCache = {};
            /**
 * @namespace Phaser.Plugins.PluginCache
 */ /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @method Phaser.Plugins.PluginCache.register
 * @since 3.8.0
 * 
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {boolean} [custom=false] - Core Scene plugin or a Custom Scene plugin?
 */ PluginCache.register = function(key, plugin, mapping, custom) {
                if (custom === undefined) custom = false;
                corePlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    custom: custom
                };
            };
            /**
 * Stores a custom plugin in the global plugin cache.
 * The key must be unique, within the scope of the cache.
 *
 * @method Phaser.Plugins.PluginCache.registerCustom
 * @since 3.8.0
 * 
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
 * @param {?any} data - A value to be passed to the plugin's `init` method.
 */ PluginCache.registerCustom = function(key, plugin, mapping, data) {
                customPlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    data: data
                };
            };
            /**
 * Checks if the given key is already being used in the core plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCore
 * @since 3.8.0
 * 
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the core cache, otherwise `false`.
 */ PluginCache.hasCore = function(key) {
                return corePlugins.hasOwnProperty(key);
            };
            /**
 * Checks if the given key is already being used in the custom plugin cache.
 *
 * @method Phaser.Plugins.PluginCache.hasCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key to check for.
 *
 * @return {boolean} `true` if the key is already in use in the custom cache, otherwise `false`.
 */ PluginCache.hasCustom = function(key) {
                return customPlugins.hasOwnProperty(key);
            };
            /**
 * Returns the core plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCore
 * @since 3.8.0
 * 
 * @param {string} key - The key of the core plugin to get.
 *
 * @return {Phaser.Types.Plugins.CorePluginContainer} The core plugin object.
 */ PluginCache.getCore = function(key) {
                return corePlugins[key];
            };
            /**
 * Returns the custom plugin object from the cache based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.getCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {Phaser.Types.Plugins.CustomPluginContainer} The custom plugin object.
 */ PluginCache.getCustom = function(key) {
                return customPlugins[key];
            };
            /**
 * Returns an object from the custom cache based on the given key that can be instantiated.
 *
 * @method Phaser.Plugins.PluginCache.getCustomClass
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to get.
 *
 * @return {function} The custom plugin object.
 */ PluginCache.getCustomClass = function(key) {
                return customPlugins.hasOwnProperty(key) ? customPlugins[key].plugin : null;
            };
            /**
 * Removes a core plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.remove
 * @since 3.8.0
 * 
 * @param {string} key - The key of the core plugin to remove.
 */ PluginCache.remove = function(key) {
                if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
            };
            /**
 * Removes a custom plugin based on the given key.
 *
 * @method Phaser.Plugins.PluginCache.removeCustom
 * @since 3.8.0
 * 
 * @param {string} key - The key of the custom plugin to remove.
 */ PluginCache.removeCustom = function(key) {
                if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
            };
            /**
 * Removes all Core Plugins.
 * 
 * This includes all of the internal system plugins that Phaser needs, like the Input Plugin and Loader Plugin.
 * So be sure you only call this if you do not wish to run Phaser again.
 *
 * @method Phaser.Plugins.PluginCache.destroyCorePlugins
 * @since 3.12.0
 */ PluginCache.destroyCorePlugins = function() {
                for(var key in corePlugins)if (corePlugins.hasOwnProperty(key)) delete corePlugins[key];
            };
            /**
 * Removes all Custom Plugins.
 *
 * @method Phaser.Plugins.PluginCache.destroyCustomPlugins
 * @since 3.12.0
 */ PluginCache.destroyCustomPlugins = function() {
                for(var key in customPlugins)if (customPlugins.hasOwnProperty(key)) delete customPlugins[key];
            };
            module1.exports = PluginCache;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var MATH_CONST = __webpack_require__(14);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matrix used for display transformations for rendering.
 *
 * It is represented like so:
 *
 * ```
 * | a | c | tx |
 * | b | d | ty |
 * | 0 | 0 | 1  |
 * ```
 *
 * @class TransformMatrix
 * @memberof Phaser.GameObjects.Components
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [a=1] - The Scale X value.
 * @param {number} [b=0] - The Skew Y value.
 * @param {number} [c=0] - The Skew X value.
 * @param {number} [d=1] - The Scale Y value.
 * @param {number} [tx=0] - The Translate X value.
 * @param {number} [ty=0] - The Translate Y value.
 */ var TransformMatrix = new Class({
                initialize: function TransformMatrix(a, b, c, d, tx, ty) {
                    if (a === undefined) a = 1;
                    if (b === undefined) b = 0;
                    if (c === undefined) c = 0;
                    if (d === undefined) d = 1;
                    if (tx === undefined) tx = 0;
                    if (ty === undefined) ty = 0;
                    /**
         * The matrix values.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#matrix
         * @type {Float32Array}
         * @since 3.0.0
         */ this.matrix = new Float32Array([
                        a,
                        b,
                        c,
                        d,
                        tx,
                        ty,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The decomposed matrix.
         *
         * @name Phaser.GameObjects.Components.TransformMatrix#decomposedMatrix
         * @type {object}
         * @since 3.0.0
         */ this.decomposedMatrix = {
                        translateX: 0,
                        translateY: 0,
                        scaleX: 1,
                        scaleY: 1,
                        rotation: 0
                    };
                },
                /**
     * The Scale X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#a
     * @type {number}
     * @since 3.4.0
     */ a: {
                    get: function() {
                        return this.matrix[0];
                    },
                    set: function(value) {
                        this.matrix[0] = value;
                    }
                },
                /**
     * The Skew Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#b
     * @type {number}
     * @since 3.4.0
     */ b: {
                    get: function() {
                        return this.matrix[1];
                    },
                    set: function(value) {
                        this.matrix[1] = value;
                    }
                },
                /**
     * The Skew X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#c
     * @type {number}
     * @since 3.4.0
     */ c: {
                    get: function() {
                        return this.matrix[2];
                    },
                    set: function(value) {
                        this.matrix[2] = value;
                    }
                },
                /**
     * The Scale Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#d
     * @type {number}
     * @since 3.4.0
     */ d: {
                    get: function() {
                        return this.matrix[3];
                    },
                    set: function(value) {
                        this.matrix[3] = value;
                    }
                },
                /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#e
     * @type {number}
     * @since 3.11.0
     */ e: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(value) {
                        this.matrix[4] = value;
                    }
                },
                /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#f
     * @type {number}
     * @since 3.11.0
     */ f: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(value) {
                        this.matrix[5] = value;
                    }
                },
                /**
     * The Translate X value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#tx
     * @type {number}
     * @since 3.4.0
     */ tx: {
                    get: function() {
                        return this.matrix[4];
                    },
                    set: function(value) {
                        this.matrix[4] = value;
                    }
                },
                /**
     * The Translate Y value.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#ty
     * @type {number}
     * @since 3.4.0
     */ ty: {
                    get: function() {
                        return this.matrix[5];
                    },
                    set: function(value) {
                        this.matrix[5] = value;
                    }
                },
                /**
     * The rotation of the Matrix. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotation
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ rotation: {
                    get: function() {
                        return Math.acos(this.a / this.scaleX) * (Math.atan(-this.c / this.a) < 0 ? -1 : 1);
                    }
                },
                /**
     * The rotation of the Matrix, normalized to be within the Phaser right-handed
     * clockwise rotation space. Value is in radians.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#rotationNormalized
     * @type {number}
     * @readonly
     * @since 3.19.0
     */ rotationNormalized: {
                    get: function() {
                        var matrix = this.matrix;
                        var a = matrix[0];
                        var b = matrix[1];
                        var c = matrix[2];
                        var d = matrix[3];
                        if (a || b) // var r = Math.sqrt(a * a + b * b);
                        return b > 0 ? Math.acos(a / this.scaleX) : -Math.acos(a / this.scaleX);
                        else if (c || d) // var s = Math.sqrt(c * c + d * d);
                        return MATH_CONST.TAU - (d > 0 ? Math.acos(-c / this.scaleY) : -Math.acos(c / this.scaleY));
                        else return 0;
                    }
                },
                /**
     * The decomposed horizontal scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleX
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleX: {
                    get: function() {
                        return Math.sqrt(this.a * this.a + this.b * this.b);
                    }
                },
                /**
     * The decomposed vertical scale of the Matrix. This value is always positive.
     *
     * @name Phaser.GameObjects.Components.TransformMatrix#scaleY
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ scaleY: {
                    get: function() {
                        return Math.sqrt(this.c * this.c + this.d * this.d);
                    }
                },
                /**
     * Reset the Matrix to an identity matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#loadIdentity
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ loadIdentity: function() {
                    var matrix = this.matrix;
                    matrix[0] = 1;
                    matrix[1] = 0;
                    matrix[2] = 0;
                    matrix[3] = 1;
                    matrix[4] = 0;
                    matrix[5] = 0;
                    return this;
                },
                /**
     * Translate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#translate
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation value.
     * @param {number} y - The vertical translation value.
     *
     * @return {this} This TransformMatrix.
     */ translate: function(x, y) {
                    var matrix = this.matrix;
                    matrix[4] = matrix[0] * x + matrix[2] * y + matrix[4];
                    matrix[5] = matrix[1] * x + matrix[3] * y + matrix[5];
                    return this;
                },
                /**
     * Scale the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#scale
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale value.
     * @param {number} y - The vertical scale value.
     *
     * @return {this} This TransformMatrix.
     */ scale: function(x, y) {
                    var matrix = this.matrix;
                    matrix[0] *= x;
                    matrix[1] *= x;
                    matrix[2] *= y;
                    matrix[3] *= y;
                    return this;
                },
                /**
     * Rotate the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#rotate
     * @since 3.0.0
     *
     * @param {number} angle - The angle of rotation in radians.
     *
     * @return {this} This TransformMatrix.
     */ rotate: function(angle) {
                    var sin = Math.sin(angle);
                    var cos = Math.cos(angle);
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    matrix[0] = a * cos + c * sin;
                    matrix[1] = b * cos + d * sin;
                    matrix[2] = a * -sin + c * cos;
                    matrix[3] = b * -sin + d * cos;
                    return this;
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * If an `out` Matrix is given then the results will be stored in it.
     * If it is not given, this matrix will be updated in place instead.
     * Use an `out` Matrix if you do not wish to mutate this matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiply
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} rhs - The Matrix to multiply by.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [out] - An optional Matrix to store the results in.
     *
     * @return {(this|Phaser.GameObjects.Components.TransformMatrix)} Either this TransformMatrix, or the `out` Matrix, if given in the arguments.
     */ multiply: function(rhs, out) {
                    var matrix = this.matrix;
                    var source = rhs.matrix;
                    var localA = matrix[0];
                    var localB = matrix[1];
                    var localC = matrix[2];
                    var localD = matrix[3];
                    var localE = matrix[4];
                    var localF = matrix[5];
                    var sourceA = source[0];
                    var sourceB = source[1];
                    var sourceC = source[2];
                    var sourceD = source[3];
                    var sourceE = source[4];
                    var sourceF = source[5];
                    var destinationMatrix = out === undefined ? this : out;
                    destinationMatrix.a = sourceA * localA + sourceB * localC;
                    destinationMatrix.b = sourceA * localB + sourceB * localD;
                    destinationMatrix.c = sourceC * localA + sourceD * localC;
                    destinationMatrix.d = sourceC * localB + sourceD * localD;
                    destinationMatrix.e = sourceE * localA + sourceF * localC + localE;
                    destinationMatrix.f = sourceE * localB + sourceF * localD + localF;
                    return destinationMatrix;
                },
                /**
     * Multiply this Matrix by the matrix given, including the offset.
     *
     * The offsetX is added to the tx value: `offsetX * a + offsetY * c + tx`.
     * The offsetY is added to the ty value: `offsetY * b + offsetY * d + ty`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#multiplyWithOffset
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     * @param {number} offsetX - Horizontal offset to factor in to the multiplication.
     * @param {number} offsetY - Vertical offset to factor in to the multiplication.
     *
     * @return {this} This TransformMatrix.
     */ multiplyWithOffset: function(src, offsetX, offsetY) {
                    var matrix = this.matrix;
                    var otherMatrix = src.matrix;
                    var a0 = matrix[0];
                    var b0 = matrix[1];
                    var c0 = matrix[2];
                    var d0 = matrix[3];
                    var tx0 = matrix[4];
                    var ty0 = matrix[5];
                    var pse = offsetX * a0 + offsetY * c0 + tx0;
                    var psf = offsetX * b0 + offsetY * d0 + ty0;
                    var a1 = otherMatrix[0];
                    var b1 = otherMatrix[1];
                    var c1 = otherMatrix[2];
                    var d1 = otherMatrix[3];
                    var tx1 = otherMatrix[4];
                    var ty1 = otherMatrix[5];
                    matrix[0] = a1 * a0 + b1 * c0;
                    matrix[1] = a1 * b0 + b1 * d0;
                    matrix[2] = c1 * a0 + d1 * c0;
                    matrix[3] = c1 * b0 + d1 * d0;
                    matrix[4] = tx1 * a0 + ty1 * c0 + pse;
                    matrix[5] = tx1 * b0 + ty1 * d0 + psf;
                    return this;
                },
                /**
     * Transform the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ transform: function(a, b, c, d, tx, ty) {
                    var matrix = this.matrix;
                    var a0 = matrix[0];
                    var b0 = matrix[1];
                    var c0 = matrix[2];
                    var d0 = matrix[3];
                    var tx0 = matrix[4];
                    var ty0 = matrix[5];
                    matrix[0] = a * a0 + b * c0;
                    matrix[1] = a * b0 + b * d0;
                    matrix[2] = c * a0 + d * c0;
                    matrix[3] = c * b0 + d * d0;
                    matrix[4] = tx * a0 + ty * c0 + tx0;
                    matrix[5] = tx * b0 + ty * d0 + ty0;
                    return this;
                },
                /**
     * Transform a point using this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#transformPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to transform.
     * @param {number} y - The y coordinate of the point to transform.
     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - The Point object to store the transformed coordinates.
     *
     * @return {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} The Point containing the transformed coordinates.
     */ transformPoint: function(x, y, point) {
                    if (point === undefined) point = {
                        x: 0,
                        y: 0
                    };
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    point.x = x * a + y * c + tx;
                    point.y = x * b + y * d + ty;
                    return point;
                },
                /**
     * Invert the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#invert
     * @since 3.0.0
     *
     * @return {this} This TransformMatrix.
     */ invert: function() {
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    var n = a * d - b * c;
                    matrix[0] = d / n;
                    matrix[1] = -b / n;
                    matrix[2] = -c / n;
                    matrix[3] = a / n;
                    matrix[4] = (c * ty - d * tx) / n;
                    matrix[5] = -(a * ty - b * tx) / n;
                    return this;
                },
                /**
     * Set the values of this Matrix to copy those of the matrix given.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFrom
     * @since 3.11.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} src - The source Matrix to copy from.
     *
     * @return {this} This TransformMatrix.
     */ copyFrom: function(src) {
                    var matrix = this.matrix;
                    matrix[0] = src.a;
                    matrix[1] = src.b;
                    matrix[2] = src.c;
                    matrix[3] = src.d;
                    matrix[4] = src.e;
                    matrix[5] = src.f;
                    return this;
                },
                /**
     * Set the values of this Matrix to copy those of the array given.
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyFromArray
     * @since 3.11.0
     *
     * @param {array} src - The array of values to set into this matrix.
     *
     * @return {this} This TransformMatrix.
     */ copyFromArray: function(src) {
                    var matrix = this.matrix;
                    matrix[0] = src[0];
                    matrix[1] = src[1];
                    matrix[2] = src[2];
                    matrix[3] = src[3];
                    matrix[4] = src[4];
                    matrix[5] = src[5];
                    return this;
                },
                /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.transform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ copyToContext: function(ctx) {
                    var matrix = this.matrix;
                    ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                    return ctx;
                },
                /**
     * Copy the values from this Matrix to the given Canvas Rendering Context.
     * This will use the Context.setTransform method.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setToContext
     * @since 3.12.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas Rendering Context to copy the matrix values to.
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context.
     */ setToContext: function(ctx) {
                    var matrix = this.matrix;
                    ctx.setTransform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                    return ctx;
                },
                /**
     * Copy the values in this Matrix to the array given.
     *
     * Where array indexes 0, 1, 2, 3, 4 and 5 are mapped to a, b, c, d, e and f.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#copyToArray
     * @since 3.12.0
     *
     * @param {array} [out] - The array to copy the matrix values in to.
     *
     * @return {array} An array where elements 0 to 5 contain the values from this matrix.
     */ copyToArray: function(out) {
                    var matrix = this.matrix;
                    if (out === undefined) out = [
                        matrix[0],
                        matrix[1],
                        matrix[2],
                        matrix[3],
                        matrix[4],
                        matrix[5]
                    ];
                    else {
                        out[0] = matrix[0];
                        out[1] = matrix[1];
                        out[2] = matrix[2];
                        out[3] = matrix[3];
                        out[4] = matrix[4];
                        out[5] = matrix[5];
                    }
                    return out;
                },
                /**
     * Set the values of this Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#setTransform
     * @since 3.0.0
     *
     * @param {number} a - The Scale X value.
     * @param {number} b - The Shear Y value.
     * @param {number} c - The Shear X value.
     * @param {number} d - The Scale Y value.
     * @param {number} tx - The Translate X value.
     * @param {number} ty - The Translate Y value.
     *
     * @return {this} This TransformMatrix.
     */ setTransform: function(a, b, c, d, tx, ty) {
                    var matrix = this.matrix;
                    matrix[0] = a;
                    matrix[1] = b;
                    matrix[2] = c;
                    matrix[3] = d;
                    matrix[4] = tx;
                    matrix[5] = ty;
                    return this;
                },
                /**
     * Decompose this Matrix into its translation, scale and rotation values using QR decomposition.
     *
     * The result must be applied in the following order to reproduce the current matrix:
     *
     * translate -> rotate -> scale
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#decomposeMatrix
     * @since 3.0.0
     *
     * @return {object} The decomposed Matrix.
     */ decomposeMatrix: function() {
                    var decomposedMatrix = this.decomposedMatrix;
                    var matrix = this.matrix;
                    //  a = scale X (1)
                    //  b = shear Y (0)
                    //  c = shear X (0)
                    //  d = scale Y (1)
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var determ = a * d - b * c;
                    decomposedMatrix.translateX = matrix[4];
                    decomposedMatrix.translateY = matrix[5];
                    if (a || b) {
                        var r = Math.sqrt(a * a + b * b);
                        decomposedMatrix.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
                        decomposedMatrix.scaleX = r;
                        decomposedMatrix.scaleY = determ / r;
                    } else if (c || d) {
                        var s = Math.sqrt(c * c + d * d);
                        decomposedMatrix.rotation = Math.PI * 0.5 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
                        decomposedMatrix.scaleX = determ / s;
                        decomposedMatrix.scaleY = s;
                    } else {
                        decomposedMatrix.rotation = 0;
                        decomposedMatrix.scaleX = 0;
                        decomposedMatrix.scaleY = 0;
                    }
                    return decomposedMatrix;
                },
                /**
     * Apply the identity, translate, rotate and scale operations on the Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyITRS
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation.
     * @param {number} y - The vertical translation.
     * @param {number} rotation - The angle of rotation in radians.
     * @param {number} scaleX - The horizontal scale.
     * @param {number} scaleY - The vertical scale.
     *
     * @return {this} This TransformMatrix.
     */ applyITRS: function(x, y, rotation, scaleX, scaleY) {
                    var matrix = this.matrix;
                    var radianSin = Math.sin(rotation);
                    var radianCos = Math.cos(rotation);
                    // Translate
                    matrix[4] = x;
                    matrix[5] = y;
                    // Rotate and Scale
                    matrix[0] = radianCos * scaleX;
                    matrix[1] = radianSin * scaleX;
                    matrix[2] = -radianSin * scaleY;
                    matrix[3] = radianCos * scaleY;
                    return this;
                },
                /**
     * Takes the `x` and `y` values and returns a new position in the `output` vector that is the inverse of
     * the current matrix with its transformation applied.
     *
     * Can be used to translate points from world to local space.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#applyInverse
     * @since 3.12.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [output] - A Vector2, or point-like object, to store the results in.
     *
     * @return {Phaser.Math.Vector2} The coordinates, inverse-transformed through this matrix.
     */ applyInverse: function(x, y, output) {
                    if (output === undefined) output = new Vector2();
                    var matrix = this.matrix;
                    var a = matrix[0];
                    var b = matrix[1];
                    var c = matrix[2];
                    var d = matrix[3];
                    var tx = matrix[4];
                    var ty = matrix[5];
                    var id = 1 / (a * d + c * -b);
                    output.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
                    output.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
                    return output;
                },
                /**
     * Returns the X component of this matrix multiplied by the given values.
     * This is the same as `x * a + y * c + e`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getX
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated x value.
     */ getX: function(x, y) {
                    return x * this.a + y * this.c + this.e;
                },
                /**
     * Returns the Y component of this matrix multiplied by the given values.
     * This is the same as `x * b + y * d + f`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getY
     * @since 3.12.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     *
     * @return {number} The calculated y value.
     */ getY: function(x, y) {
                    return x * this.b + y * this.d + this.f;
                },
                /**
     * Returns the X component of this matrix multiplied by the given values.
     *
     * This is the same as `x * a + y * c + e`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getXRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated x value.
     */ getXRound: function(x, y, round) {
                    var v = this.getX(x, y);
                    if (round) v = Math.round(v);
                    return v;
                },
                /**
     * Returns the Y component of this matrix multiplied by the given values.
     *
     * This is the same as `x * b + y * d + f`, optionally passing via `Math.round`.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getYRound
     * @since 3.50.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {boolean} [round=false] - Math.round the resulting value?
     *
     * @return {number} The calculated y value.
     */ getYRound: function(x, y, round) {
                    var v = this.getY(x, y);
                    if (round) v = Math.round(v);
                    return v;
                },
                /**
     * Returns a string that can be used in a CSS Transform call as a `matrix` property.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#getCSSMatrix
     * @since 3.12.0
     *
     * @return {string} A string containing the CSS Transform matrix values.
     */ getCSSMatrix: function() {
                    var m = this.matrix;
                    return 'matrix(' + m[0] + ',' + m[1] + ',' + m[2] + ',' + m[3] + ',' + m[4] + ',' + m[5] + ')';
                },
                /**
     * Destroys this Transform Matrix.
     *
     * @method Phaser.GameObjects.Components.TransformMatrix#destroy
     * @since 3.4.0
     */ destroy: function() {
                    this.matrix = null;
                    this.decomposedMatrix = null;
                }
            });
            module1.exports = TransformMatrix;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithin = function(tileX, tileY, width, height, filteringOptions, layer) {
                if (tileX === undefined) tileX = 0;
                if (tileY === undefined) tileY = 0;
                if (width === undefined) width = layer.width;
                if (height === undefined) height = layer.height;
                if (!filteringOptions) filteringOptions = {};
                var isNotEmpty = GetFastValue(filteringOptions, 'isNotEmpty', false);
                var isColliding = GetFastValue(filteringOptions, 'isColliding', false);
                var hasInterestingFace = GetFastValue(filteringOptions, 'hasInterestingFace', false);
                // Clip x, y to top left of map, while shrinking width/height to match.
                if (tileX < 0) {
                    width += tileX;
                    tileX = 0;
                }
                if (tileY < 0) {
                    height += tileY;
                    tileY = 0;
                }
                // Clip width and height to bottom right of map.
                if (tileX + width > layer.width) width = Math.max(layer.width - tileX, 0);
                if (tileY + height > layer.height) height = Math.max(layer.height - tileY, 0);
                var results = [];
                for(var ty = tileY; ty < tileY + height; ty++)for(var tx = tileX; tx < tileX + width; tx++){
                    var tile = layer.data[ty][tx];
                    if (tile !== null) {
                        if (isNotEmpty && tile.index === -1) continue;
                        if (isColliding && !tile.collides) continue;
                        if (hasInterestingFace && !tile.hasInterestingFace) continue;
                        results.push(tile);
                    }
                }
                return results;
            };
            module1.exports = GetTilesWithin;
        /***/ },
        /* 27 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueSet(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueSet
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueSet = function(items, key, value, step, index, direction) {
                if (step === undefined) step = 0;
                if (index === undefined) index = 0;
                if (direction === undefined) direction = 1;
                var i;
                var t = 0;
                var end = items.length;
                if (direction === 1) //  Start to End
                for(i = index; i < end; i++){
                    items[i][key] = value + t * step;
                    t++;
                }
                else //  End to Start
                for(i = index; i >= 0; i--){
                    items[i][key] = value + t * step;
                    t++;
                }
                return items;
            };
            module1.exports = PropertyValueSet;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Builds a Game Object using the provided configuration object.
 *
 * @function Phaser.GameObjects.BuildGameObject
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene.
 * @param {Phaser.GameObjects.GameObject} gameObject - The initial GameObject.
 * @param {Phaser.Types.GameObjects.GameObjectConfig} config - The config to build the GameObject with.
 *
 * @return {Phaser.GameObjects.GameObject} The built Game Object.
 */ var BuildGameObject = function(scene, gameObject, config) {
                //  Position
                gameObject.x = GetAdvancedValue(config, 'x', 0);
                gameObject.y = GetAdvancedValue(config, 'y', 0);
                gameObject.depth = GetAdvancedValue(config, 'depth', 0);
                //  Flip
                gameObject.flipX = GetAdvancedValue(config, 'flipX', false);
                gameObject.flipY = GetAdvancedValue(config, 'flipY', false);
                //  Scale
                //  Either: { scale: 2 } or { scale: { x: 2, y: 2 }}
                var scale = GetAdvancedValue(config, 'scale', null);
                if (typeof scale === 'number') gameObject.setScale(scale);
                else if (scale !== null) {
                    gameObject.scaleX = GetAdvancedValue(scale, 'x', 1);
                    gameObject.scaleY = GetAdvancedValue(scale, 'y', 1);
                }
                //  ScrollFactor
                //  Either: { scrollFactor: 2 } or { scrollFactor: { x: 2, y: 2 }}
                var scrollFactor = GetAdvancedValue(config, 'scrollFactor', null);
                if (typeof scrollFactor === 'number') gameObject.setScrollFactor(scrollFactor);
                else if (scrollFactor !== null) {
                    gameObject.scrollFactorX = GetAdvancedValue(scrollFactor, 'x', 1);
                    gameObject.scrollFactorY = GetAdvancedValue(scrollFactor, 'y', 1);
                }
                //  Rotation
                gameObject.rotation = GetAdvancedValue(config, 'rotation', 0);
                var angle = GetAdvancedValue(config, 'angle', null);
                if (angle !== null) gameObject.angle = angle;
                //  Alpha
                gameObject.alpha = GetAdvancedValue(config, 'alpha', 1);
                //  Origin
                //  Either: { origin: 0.5 } or { origin: { x: 0.5, y: 0.5 }}
                var origin = GetAdvancedValue(config, 'origin', null);
                if (typeof origin === 'number') gameObject.setOrigin(origin);
                else if (origin !== null) {
                    var ox = GetAdvancedValue(origin, 'x', 0.5);
                    var oy = GetAdvancedValue(origin, 'y', 0.5);
                    gameObject.setOrigin(ox, oy);
                }
                //  BlendMode
                gameObject.blendMode = GetAdvancedValue(config, 'blendMode', BlendModes.NORMAL);
                //  Visible
                gameObject.visible = GetAdvancedValue(config, 'visible', true);
                //  Add to Scene
                var add = GetAdvancedValue(config, 'add', true);
                if (add) scene.sys.displayList.add(gameObject);
                if (gameObject.preUpdate) scene.sys.updateList.add(gameObject);
                return gameObject;
            };
            module1.exports = BuildGameObject;
        /***/ },
        /* 29 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Tilemap constants for orientation.
 * 
 * @namespace Phaser.Tilemaps.Orientation
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ /**
 * Phaser Tilemap constants for orientation.
 * 
 * To find out what each mode does please see [Phaser.Tilemaps.Orientation]{@link Phaser.Tilemaps.Orientation}.
 * 
 * @typedef {Phaser.Tilemaps.Orientation} Phaser.Tilemaps.OrientationType
 * @memberof Phaser.Tilemaps
 * @since 3.50.0
 */ module1.exports = {
                /**
     * Orthogonal Tilemap orientation constant.
     * 
     * @name Phaser.Tilemaps.Orientation.ORTHOGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ ORTHOGONAL: 0,
                /**
     * Isometric Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.ISOMETRIC
     * @type {number}
     * @const
     * @since 3.50.0
     */ ISOMETRIC: 1,
                /**
     * Staggered Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.STAGGERED
     * @type {number}
     * @const
     * @since 3.50.0
     */ STAGGERED: 2,
                /**
     * Hexagonal Tilemap orientation constant.
     *
     * @name Phaser.Tilemaps.Orientation.HEXAGONAL
     * @type {number}
     * @const
     * @since 3.50.0
     */ HEXAGONAL: 3
            };
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Takes a reference to the Canvas Renderer, a Canvas Rendering Context, a Game Object, a Camera and a parent matrix
 * and then performs the following steps:
 *
 * 1. Checks the alpha of the source combined with the Camera alpha. If 0 or less it aborts.
 * 2. Takes the Camera and Game Object matrix and multiplies them, combined with the parent matrix if given.
 * 3. Sets the blend mode of the context to be that used by the Game Object.
 * 4. Sets the alpha value of the context to be that used by the Game Object combined with the Camera.
 * 5. Saves the context state.
 * 6. Sets the final matrix values into the context via setTransform.
 * 7. If Renderer.antialias, or the frame.source.scaleMode is set, then imageSmoothingEnabled is set.
 *
 * This function is only meant to be used internally. Most of the Canvas Renderer classes use it.
 *
 * @function Phaser.Renderer.Canvas.SetTransform
 * @since 3.12.0
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {CanvasRenderingContext2D} ctx - The canvas context to set the transform on.
 * @param {Phaser.GameObjects.GameObject} src - The Game Object being rendered. Can be any type that extends the base class.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A parent transform matrix to apply to the Game Object before rendering.
 *
 * @return {boolean} `true` if the Game Object context was set, otherwise `false`.
 */ var SetTransform = function(renderer, ctx, src, camera, parentMatrix) {
                var alpha = camera.alpha * src.alpha;
                if (alpha <= 0) //  Nothing to see, so don't waste time calculating stuff
                return false;
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                //  Blend Mode
                ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                //  Alpha
                ctx.globalAlpha = alpha;
                ctx.save();
                calcMatrix.setToContext(ctx);
                ctx.imageSmoothingEnabled = !(!renderer.antialias || src.frame && src.frame.source.scaleMode);
                return true;
            };
            module1.exports = SetTransform;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(32);
            var Smoothing = __webpack_require__(189);
            // The pool into which the canvas elements are placed.
            var pool = [];
            //  Automatically apply smoothing(false) to created Canvas elements
            var _disableContextSmoothing = false;
            /**
 * The CanvasPool is a global static object, that allows Phaser to recycle and pool 2D Context Canvas DOM elements.
 * It does not pool WebGL Contexts, because once the context options are set they cannot be modified again, 
 * which is useless for some of the Phaser pipelines / renderer.
 *
 * This singleton is instantiated as soon as Phaser loads, before a Phaser.Game instance has even been created.
 * Which means all instances of Phaser Games on the same page can share the one single pool.
 *
 * @namespace Phaser.Display.Canvas.CanvasPool
 * @since 3.0.0
 */ var CanvasPool = function() {
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     * @param {boolean} [selfParent=false] - Use the generated Canvas element as the parent?
     *
     * @return {HTMLCanvasElement} The canvas element that was created or pulled from the pool
     */ var create = function(parent, width, height, canvasType, selfParent) {
                    if (width === undefined) width = 1;
                    if (height === undefined) height = 1;
                    if (canvasType === undefined) canvasType = CONST.CANVAS;
                    if (selfParent === undefined) selfParent = false;
                    var canvas;
                    var container = first(canvasType);
                    if (container === null) {
                        container = {
                            parent: parent,
                            canvas: document.createElement('canvas'),
                            type: canvasType
                        };
                        if (canvasType === CONST.CANVAS) pool.push(container);
                        canvas = container.canvas;
                    } else {
                        container.parent = parent;
                        canvas = container.canvas;
                    }
                    if (selfParent) container.parent = canvas;
                    canvas.width = width;
                    canvas.height = height;
                    if (_disableContextSmoothing && canvasType === CONST.CANVAS) Smoothing.disable(canvas.getContext('2d'));
                    return canvas;
                };
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.create2D
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created canvas.
     */ var create2D = function(parent, width, height) {
                    return create(parent, width, height, CONST.CANVAS);
                };
                /**
     * Creates a new Canvas DOM element, or pulls one from the pool if free.
     *
     * @function Phaser.Display.Canvas.CanvasPool.createWebGL
     * @since 3.0.0
     *
     * @param {*} parent - The parent of the Canvas object.
     * @param {number} [width=1] - The width of the Canvas.
     * @param {number} [height=1] - The height of the Canvas.
     *
     * @return {HTMLCanvasElement} The created WebGL canvas.
     */ var createWebGL = function(parent, width, height) {
                    return create(parent, width, height, CONST.WEBGL);
                };
                /**
     * Gets the first free canvas index from the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.first
     * @since 3.0.0
     *
     * @param {number} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
     *
     * @return {HTMLCanvasElement} The first free canvas, or `null` if a WebGL canvas was requested or if the pool doesn't have free canvases.
     */ var first = function(canvasType) {
                    if (canvasType === undefined) canvasType = CONST.CANVAS;
                    if (canvasType === CONST.WEBGL) return null;
                    for(var i = 0; i < pool.length; i++){
                        var container = pool[i];
                        if (!container.parent && container.type === canvasType) return container;
                    }
                    return null;
                };
                /**
     * Looks up a canvas based on its parent, and if found puts it back in the pool, freeing it up for re-use.
     * The canvas has its width and height set to 1, and its parent attribute nulled.
     *
     * @function Phaser.Display.Canvas.CanvasPool.remove
     * @since 3.0.0
     *
     * @param {*} parent - The canvas or the parent of the canvas to free.
     */ var remove = function(parent) {
                    //  Check to see if the parent is a canvas object
                    var isCanvas = parent instanceof HTMLCanvasElement;
                    pool.forEach(function(container) {
                        if (isCanvas && container.canvas === parent || !isCanvas && container.parent === parent) {
                            container.parent = null;
                            container.canvas.width = 1;
                            container.canvas.height = 1;
                        }
                    });
                };
                /**
     * Gets the total number of used canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.total
     * @since 3.0.0
     *
     * @return {number} The number of used canvases.
     */ var total = function() {
                    var c = 0;
                    pool.forEach(function(container) {
                        if (container.parent) c++;
                    });
                    return c;
                };
                /**
     * Gets the total number of free canvas elements in the pool.
     *
     * @function Phaser.Display.Canvas.CanvasPool.free
     * @since 3.0.0
     *
     * @return {number} The number of free canvases.
     */ var free = function() {
                    return pool.length - total();
                };
                /**
     * Disable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.disableSmoothing
     * @since 3.0.0
     */ var disableSmoothing = function() {
                    _disableContextSmoothing = true;
                };
                /**
     * Enable context smoothing on any new Canvas element created.
     *
     * @function Phaser.Display.Canvas.CanvasPool.enableSmoothing
     * @since 3.0.0
     */ var enableSmoothing = function() {
                    _disableContextSmoothing = false;
                };
                return {
                    create2D: create2D,
                    create: create,
                    createWebGL: createWebGL,
                    disableSmoothing: disableSmoothing,
                    enableSmoothing: enableSmoothing,
                    first: first,
                    free: free,
                    pool: pool,
                    remove: remove,
                    total: total
                };
            };
            //  If we export the called function here, it'll only be invoked once (not every time it's required).
            module1.exports = CanvasPool();
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Global constants.
 *
 * @ignore
 */ var CONST = {
                /**
     * Phaser Release Version
     *
     * @name Phaser.VERSION
     * @const
     * @type {string}
     * @since 3.0.0
     */ VERSION: '3.52.0',
                BlendModes: __webpack_require__(34),
                ScaleModes: __webpack_require__(164),
                /**
     * This setting will auto-detect if the browser is capable of suppporting WebGL.
     * If it is, it will use the WebGL Renderer. If not, it will fall back to the Canvas Renderer.
     *
     * @name Phaser.AUTO
     * @const
     * @type {number}
     * @since 3.0.0
     */ AUTO: 0,
                /**
     * Forces Phaser to only use the Canvas Renderer, regardless if the browser supports
     * WebGL or not.
     *
     * @name Phaser.CANVAS
     * @const
     * @type {number}
     * @since 3.0.0
     */ CANVAS: 1,
                /**
     * Forces Phaser to use the WebGL Renderer. If the browser does not support it, there is
     * no fallback to Canvas with this setting, so you should trap it and display a suitable
     * message to the user.
     *
     * @name Phaser.WEBGL
     * @const
     * @type {number}
     * @since 3.0.0
     */ WEBGL: 2,
                /**
     * A Headless Renderer doesn't create either a Canvas or WebGL Renderer. However, it still
     * absolutely relies on the DOM being present and available. This mode is meant for unit testing,
     * not for running Phaser on the server, which is something you really shouldn't do.
     *
     * @name Phaser.HEADLESS
     * @const
     * @type {number}
     * @since 3.0.0
     */ HEADLESS: 3,
                /**
     * In Phaser the value -1 means 'forever' in lots of cases, this const allows you to use it instead
     * to help you remember what the value is doing in your code.
     *
     * @name Phaser.FOREVER
     * @const
     * @type {number}
     * @since 3.0.0
     */ FOREVER: -1,
                /**
     * Direction constant.
     *
     * @name Phaser.NONE
     * @const
     * @type {number}
     * @since 3.0.0
     */ NONE: 4,
                /**
     * Direction constant.
     *
     * @name Phaser.UP
     * @const
     * @type {number}
     * @since 3.0.0
     */ UP: 5,
                /**
     * Direction constant.
     *
     * @name Phaser.DOWN
     * @const
     * @type {number}
     * @since 3.0.0
     */ DOWN: 6,
                /**
     * Direction constant.
     *
     * @name Phaser.LEFT
     * @const
     * @type {number}
     * @since 3.0.0
     */ LEFT: 7,
                /**
     * Direction constant.
     *
     * @name Phaser.RIGHT
     * @const
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 8
            };
            module1.exports = CONST;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var Line = __webpack_require__(45);
            var PIPELINES_CONST = __webpack_require__(65);
            /**
 * @classdesc
 * The Shape Game Object is a base class for the various different shapes, such as the Arc, Star or Polygon.
 * You cannot add a Shape directly to your Scene, it is meant as a base for your own custom Shape classes.
 *
 * @class Shape
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
  * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {string} [type] - The internal type of the Shape.
 * @param {any} [data] - The data of the source shape geometry, if any.
 */ var Shape = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible
                ],
                initialize: function Shape(scene, type, data) {
                    if (type === undefined) type = 'Shape';
                    GameObject.call(this, scene, type);
                    /**
         * The source Shape data. Typically a geometry object.
         * You should not manipulate this directly.
         *
         * @name Phaser.GameObjects.Shape#geom
         * @type {any}
         * @readonly
         * @since 3.13.0
         */ this.geom = data;
                    /**
         * Holds the polygon path data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathData
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathData = [];
                    /**
         * Holds the earcut polygon path index data for filled rendering.
         *
         * @name Phaser.GameObjects.Shape#pathIndexes
         * @type {number[]}
         * @readonly
         * @since 3.13.0
         */ this.pathIndexes = [];
                    /**
         * The fill color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillColor
         * @type {number}
         * @since 3.13.0
         */ this.fillColor = 0xffffff;
                    /**
         * The fill alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#fillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.fillAlpha = 1;
                    /**
         * The stroke color used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeColor
         * @type {number}
         * @since 3.13.0
         */ this.strokeColor = 0xffffff;
                    /**
         * The stroke alpha value used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#strokeAlpha
         * @type {number}
         * @since 3.13.0
         */ this.strokeAlpha = 1;
                    /**
         * The stroke line width used by this Shape.
         *
         * @name Phaser.GameObjects.Shape#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                    /**
         * Controls if this Shape is filled or not.
         * Note that some Shapes do not support being filled (such as Line shapes)
         *
         * @name Phaser.GameObjects.Shape#isFilled
         * @type {boolean}
         * @since 3.13.0
         */ this.isFilled = false;
                    /**
         * Controls if this Shape is stroked or not.
         * Note that some Shapes do not support being stroked (such as Iso Box shapes)
         *
         * @name Phaser.GameObjects.Shape#isStroked
         * @type {boolean}
         * @since 3.13.0
         */ this.isStroked = false;
                    /**
         * Controls if this Shape path is closed during rendering when stroked.
         * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
         *
         * @name Phaser.GameObjects.Shape#closePath
         * @type {boolean}
         * @since 3.13.0
         */ this.closePath = true;
                    /**
         * Private internal value.
         * A Line used when parsing internal path data to avoid constant object re-creation.
         *
         * @name Phaser.GameObjects.Shape#_tempLine
         * @type {Phaser.Geom.Line}
         * @private
         * @since 3.13.0
         */ this._tempLine = new Line();
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayWidth` property.
         *
         * @name Phaser.GameObjects.Shape#width
         * @type {number}
         * @since 3.13.0
         */ this.width = 0;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * Changing this value will not change the size that the Game Object is rendered in-game.
         * For that you need to either set the scale of the Game Object (`setScale`) or use
         * the `displayHeight` property.
         *
         * @name Phaser.GameObjects.Shape#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    this.initPipeline(PIPELINES_CONST.GRAPHICS_PIPELINE);
                },
                /**
     * Sets the fill color and alpha for this Shape.
     *
     * If you wish for the Shape to not be filled then call this method with no arguments, or just set `isFilled` to `false`.
     *
     * Note that some Shapes do not support fill colors, such as the Line shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [color] - The color used to fill this shape. If not provided the Shape will not be filled.
     * @param {number} [alpha=1] - The alpha value used when filling this shape, if a fill color is given.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    if (color === undefined) this.isFilled = false;
                    else {
                        this.fillColor = color;
                        this.fillAlpha = alpha;
                        this.isFilled = true;
                    }
                    return this;
                },
                /**
     * Sets the stroke color and alpha for this Shape.
     *
     * If you wish for the Shape to not be stroked then call this method with no arguments, or just set `isStroked` to `false`.
     *
     * Note that some Shapes do not support being stroked, such as the Iso Box shape.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setStrokeStyle
     * @since 3.13.0
     *
     * @param {number} [lineWidth] - The width of line to stroke with. If not provided or undefined the Shape will not be stroked.
     * @param {number} [color] - The color used to stroke this shape. If not provided the Shape will not be stroked.
     * @param {number} [alpha=1] - The alpha value used when stroking this shape, if a stroke color is given.
     *
     * @return {this} This Game Object instance.
     */ setStrokeStyle: function(lineWidth, color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    if (lineWidth === undefined) this.isStroked = false;
                    else {
                        this.lineWidth = lineWidth;
                        this.strokeColor = color;
                        this.strokeAlpha = alpha;
                        this.isStroked = true;
                    }
                    return this;
                },
                /**
     * Sets if this Shape path is closed during rendering when stroked.
     * Note that some Shapes are always closed when stroked (such as Ellipse shapes)
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Shape#setClosePath
     * @since 3.13.0
     *
     * @param {boolean} value - Set to `true` if the Shape should be closed when stroked, otherwise `false`.
     *
     * @return {this} This Game Object instance.
     */ setClosePath: function(value) {
                    this.closePath = value;
                    return this;
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Shape#setSize
     * @private
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shape#preDestroy
     * @protected
     * @since 3.13.0
     */ preDestroy: function() {
                    this.geom = null;
                    this._tempLine = null;
                    this.pathData = [];
                    this.pathIndexes = [];
                },
                /**
     * The displayed width of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayWidth
     * @type {number}
     * @since 3.13.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     *
     * This value takes into account the scale factor.
     *
     * Setting this value will adjust the Game Object's scale property.
     *
     * @name Phaser.GameObjects.Shape#displayHeight
     * @type {number}
     * @since 3.13.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                }
            });
            module1.exports = Shape;
        /***/ },
        /* 34 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes.
 * 
 * @namespace Phaser.BlendModes
 * @since 3.0.0
 */ module1.exports = {
                /**
     * Skips the Blend Mode check in the renderer.
     * 
     * @name Phaser.BlendModes.SKIP_CHECK
     * @type {number}
     * @const
     * @since 3.0.0
     */ SKIP_CHECK: -1,
                /**
     * Normal blend mode. For Canvas and WebGL.
     * This is the default setting and draws new shapes on top of the existing canvas content.
     * 
     * @name Phaser.BlendModes.NORMAL
     * @type {number}
     * @const
     * @since 3.0.0
     */ NORMAL: 0,
                /**
     * Add blend mode. For Canvas and WebGL.
     * Where both shapes overlap the color is determined by adding color values.
     * 
     * @name Phaser.BlendModes.ADD
     * @type {number}
     * @const
     * @since 3.0.0
     */ ADD: 1,
                /**
     * Multiply blend mode. For Canvas and WebGL.
     * The pixels are of the top layer are multiplied with the corresponding pixel of the bottom layer. A darker picture is the result.
     * 
     * @name Phaser.BlendModes.MULTIPLY
     * @type {number}
     * @const
     * @since 3.0.0
     */ MULTIPLY: 2,
                /**
     * Screen blend mode. For Canvas and WebGL.
     * The pixels are inverted, multiplied, and inverted again. A lighter picture is the result (opposite of multiply)
     * 
     * @name Phaser.BlendModes.SCREEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SCREEN: 3,
                /**
     * Overlay blend mode. For Canvas only.
     * A combination of multiply and screen. Dark parts on the base layer become darker, and light parts become lighter.
     * 
     * @name Phaser.BlendModes.OVERLAY
     * @type {number}
     * @const
     * @since 3.0.0
     */ OVERLAY: 4,
                /**
     * Darken blend mode. For Canvas only.
     * Retains the darkest pixels of both layers.
     * 
     * @name Phaser.BlendModes.DARKEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DARKEN: 5,
                /**
     * Lighten blend mode. For Canvas only.
     * Retains the lightest pixels of both layers.
     * 
     * @name Phaser.BlendModes.LIGHTEN
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTEN: 6,
                /**
     * Color Dodge blend mode. For Canvas only.
     * Divides the bottom layer by the inverted top layer.
     * 
     * @name Phaser.BlendModes.COLOR_DODGE
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_DODGE: 7,
                /**
     * Color Burn blend mode. For Canvas only.
     * Divides the inverted bottom layer by the top layer, and then inverts the result.
     * 
     * @name Phaser.BlendModes.COLOR_BURN
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR_BURN: 8,
                /**
     * Hard Light blend mode. For Canvas only.
     * A combination of multiply and screen like overlay, but with top and bottom layer swapped.
     * 
     * @name Phaser.BlendModes.HARD_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ HARD_LIGHT: 9,
                /**
     * Soft Light blend mode. For Canvas only.
     * A softer version of hard-light. Pure black or white does not result in pure black or white.
     * 
     * @name Phaser.BlendModes.SOFT_LIGHT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOFT_LIGHT: 10,
                /**
     * Difference blend mode. For Canvas only.
     * Subtracts the bottom layer from the top layer or the other way round to always get a positive value.
     * 
     * @name Phaser.BlendModes.DIFFERENCE
     * @type {number}
     * @const
     * @since 3.0.0
     */ DIFFERENCE: 11,
                /**
     * Exclusion blend mode. For Canvas only.
     * Like difference, but with lower contrast.
     * 
     * @name Phaser.BlendModes.EXCLUSION
     * @type {number}
     * @const
     * @since 3.0.0
     */ EXCLUSION: 12,
                /**
     * Hue blend mode. For Canvas only.
     * Preserves the luma and chroma of the bottom layer, while adopting the hue of the top layer.
     * 
     * @name Phaser.BlendModes.HUE
     * @type {number}
     * @const
     * @since 3.0.0
     */ HUE: 13,
                /**
     * Saturation blend mode. For Canvas only.
     * Preserves the luma and hue of the bottom layer, while adopting the chroma of the top layer.
     * 
     * @name Phaser.BlendModes.SATURATION
     * @type {number}
     * @const
     * @since 3.0.0
     */ SATURATION: 14,
                /**
     * Color blend mode. For Canvas only.
     * Preserves the luma of the bottom layer, while adopting the hue and chroma of the top layer.
     * 
     * @name Phaser.BlendModes.COLOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ COLOR: 15,
                /**
     * Luminosity blend mode. For Canvas only.
     * Preserves the hue and chroma of the bottom layer, while adopting the luma of the top layer.
     * 
     * @name Phaser.BlendModes.LUMINOSITY
     * @type {number}
     * @const
     * @since 3.0.0
     */ LUMINOSITY: 16,
                /**
     * Alpha erase blend mode. For Canvas and WebGL.
     * 
     * @name Phaser.BlendModes.ERASE
     * @type {number}
     * @const
     * @since 3.0.0
     */ ERASE: 17,
                /**
     * Source-in blend mode. For Canvas only.
     * The new shape is drawn only where both the new shape and the destination canvas overlap. Everything else is made transparent.
     * 
     * @name Phaser.BlendModes.SOURCE_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_IN: 18,
                /**
     * Source-out blend mode. For Canvas only.
     * The new shape is drawn where it doesn't overlap the existing canvas content.
     * 
     * @name Phaser.BlendModes.SOURCE_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_OUT: 19,
                /**
     * Source-out blend mode. For Canvas only.
     * The new shape is only drawn where it overlaps the existing canvas content.
     * 
     * @name Phaser.BlendModes.SOURCE_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ SOURCE_ATOP: 20,
                /**
     * Destination-over blend mode. For Canvas only.
     * New shapes are drawn behind the existing canvas content.
     * 
     * @name Phaser.BlendModes.DESTINATION_OVER
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OVER: 21,
                /**
     * Destination-in blend mode. For Canvas only.
     * The existing canvas content is kept where both the new shape and existing canvas content overlap. Everything else is made transparent.
     * 
     * @name Phaser.BlendModes.DESTINATION_IN
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_IN: 22,
                /**
     * Destination-out blend mode. For Canvas only.
     * The existing content is kept where it doesn't overlap the new shape.
     * 
     * @name Phaser.BlendModes.DESTINATION_OUT
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_OUT: 23,
                /**
     * Destination-out blend mode. For Canvas only.
     * The existing canvas is only kept where it overlaps the new shape. The new shape is drawn behind the canvas content.
     * 
     * @name Phaser.BlendModes.DESTINATION_ATOP
     * @type {number}
     * @const
     * @since 3.0.0
     */ DESTINATION_ATOP: 24,
                /**
     * Lighten blend mode. For Canvas only.
     * Where both shapes overlap the color is determined by adding color values.
     * 
     * @name Phaser.BlendModes.LIGHTER
     * @type {number}
     * @const
     * @since 3.0.0
     */ LIGHTER: 25,
                /**
     * Copy blend mode. For Canvas only.
     * Only the new shape is shown.
     * 
     * @name Phaser.BlendModes.COPY
     * @type {number}
     * @const
     * @since 3.0.0
     */ COPY: 26,
                /**
     * Xor blend mode. For Canvas only.
     * Shapes are made transparent where both overlap and drawn normal everywhere else.
     * 
     * @name Phaser.BlendModes.XOR
     * @type {number}
     * @const
     * @since 3.0.0
     */ XOR: 27
            };
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Convert the given angle from degrees, to the equivalent angle in radians.
 *
 * @function Phaser.Math.DegToRad
 * @since 3.0.0
 *
 * @param {number} degrees - The angle (in degrees) to convert to radians.
 *
 * @return {number} The given angle converted to radians.
 */ var DegToRad = function(degrees) {
                return degrees * CONST.DEG_TO_RAD;
            };
            module1.exports = DegToRad;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Events
 */ module1.exports = {
                DESTROY: __webpack_require__(719),
                FADE_IN_COMPLETE: __webpack_require__(720),
                FADE_IN_START: __webpack_require__(721),
                FADE_OUT_COMPLETE: __webpack_require__(722),
                FADE_OUT_START: __webpack_require__(723),
                FLASH_COMPLETE: __webpack_require__(724),
                FLASH_START: __webpack_require__(725),
                FOLLOW_UPDATE: __webpack_require__(726),
                PAN_COMPLETE: __webpack_require__(727),
                PAN_START: __webpack_require__(728),
                POST_RENDER: __webpack_require__(729),
                PRE_RENDER: __webpack_require__(730),
                ROTATE_COMPLETE: __webpack_require__(731),
                ROTATE_START: __webpack_require__(732),
                SHAKE_COMPLETE: __webpack_require__(733),
                SHAKE_START: __webpack_require__(734),
                ZOOM_COMPLETE: __webpack_require__(735),
                ZOOM_START: __webpack_require__(736)
            };
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetColor = __webpack_require__(100);
            var GetColor32 = __webpack_require__(322);
            var HSVToRGB = __webpack_require__(185);
            var RGBToHSV = __webpack_require__(323);
            /**
 * @namespace Phaser.Display.Color
 */ /**
 * @classdesc
 * The Color class holds a single color value and allows for easy modification and reading of it.
 *
 * @class Color
 * @memberof Phaser.Display
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 255.
 * @param {number} [green=0] - The green color value. A number between 0 and 255.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 255.
 * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
 */ var Color = new Class({
                initialize: function Color(red, green, blue, alpha) {
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    if (alpha === undefined) alpha = 255;
                    /**
         * The internal red color value.
         *
         * @name Phaser.Display.Color#r
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.r = 0;
                    /**
         * The internal green color value.
         *
         * @name Phaser.Display.Color#g
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.g = 0;
                    /**
         * The internal blue color value.
         *
         * @name Phaser.Display.Color#b
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.b = 0;
                    /**
         * The internal alpha color value.
         *
         * @name Phaser.Display.Color#a
         * @type {number}
         * @private
         * @default 255
         * @since 3.0.0
         */ this.a = 255;
                    /**
         * The hue color value. A number between 0 and 1.
         * This is the base color.
         *
         * @name Phaser.Display.Color#_h
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._h = 0;
                    /**
         * The saturation color value. A number between 0 and 1.
         * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
         *
         * @name Phaser.Display.Color#_s
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._s = 0;
                    /**
         * The lightness color value. A number between 0 and 1.
         * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
         *
         * @name Phaser.Display.Color#_v
         * @type {number}
         * @default 0
         * @private
         * @since 3.13.0
         */ this._v = 0;
                    /**
         * Is this color update locked?
         *
         * @name Phaser.Display.Color#_locked
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._locked = false;
                    /**
         * An array containing the calculated color values for WebGL use.
         *
         * @name Phaser.Display.Color#gl
         * @type {number[]}
         * @since 3.0.0
         */ this.gl = [
                        0,
                        0,
                        0,
                        1
                    ];
                    /**
         * Pre-calculated internal color value.
         *
         * @name Phaser.Display.Color#_color
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color = 0;
                    /**
         * Pre-calculated internal color32 value.
         *
         * @name Phaser.Display.Color#_color32
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._color32 = 0;
                    /**
         * Pre-calculated internal color rgb string value.
         *
         * @name Phaser.Display.Color#_rgba
         * @type {string}
         * @private
         * @default ''
         * @since 3.0.0
         */ this._rgba = '';
                    this.setTo(red, green, blue, alpha);
                },
                /**
     * Sets this color to be transparent. Sets all values to zero.
     *
     * @method Phaser.Display.Color#transparent
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ transparent: function() {
                    this._locked = true;
                    this.red = 0;
                    this.green = 0;
                    this.blue = 0;
                    this.alpha = 0;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color of this Color component.
     *
     * @method Phaser.Display.Color#setTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     * @param {boolean} [updateHSV=true] - Update the HSV values after setting the RGB values?
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setTo: function(red, green, blue, alpha, updateHSV) {
                    if (alpha === undefined) alpha = 255;
                    if (updateHSV === undefined) updateHSV = true;
                    this._locked = true;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = alpha;
                    this._locked = false;
                    return this.update(updateHSV);
                },
                /**
     * Sets the red, green, blue and alpha GL values of this Color component.
     *
     * @method Phaser.Display.Color#setGLTo
     * @since 3.0.0
     *
     * @param {number} red - The red color value. A number between 0 and 1.
     * @param {number} green - The green color value. A number between 0 and 1.
     * @param {number} blue - The blue color value. A number between 0 and 1.
     * @param {number} [alpha=1] - The alpha value. A number between 0 and 1.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setGLTo: function(red, green, blue, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this._locked = true;
                    this.redGL = red;
                    this.greenGL = green;
                    this.blueGL = blue;
                    this.alphaGL = alpha;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color based on the color object given.
     *
     * @method Phaser.Display.Color#setFromRGB
     * @since 3.0.0
     *
     * @param {Phaser.Types.Display.InputColorObject} color - An object containing `r`, `g`, `b` and optionally `a` values in the range 0 to 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromRGB: function(color) {
                    this._locked = true;
                    this.red = color.r;
                    this.green = color.g;
                    this.blue = color.b;
                    if (color.hasOwnProperty('a')) this.alpha = color.a;
                    this._locked = false;
                    return this.update(true);
                },
                /**
     * Sets the color based on the hue, saturation and lightness values given.
     *
     * @method Phaser.Display.Color#setFromHSV
     * @since 3.13.0
     *
     * @param {number} h - The hue, in the range 0 - 1. This is the base color.
     * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ setFromHSV: function(h, s, v) {
                    return HSVToRGB(h, s, v, this);
                },
                /**
     * Updates the internal cache values.
     *
     * @method Phaser.Display.Color#update
     * @private
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ update: function(updateHSV) {
                    if (updateHSV === undefined) updateHSV = false;
                    if (this._locked) return this;
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    var a = this.a;
                    this._color = GetColor(r, g, b);
                    this._color32 = GetColor32(r, g, b, a);
                    this._rgba = 'rgba(' + r + ',' + g + ',' + b + ',' + a / 255 + ')';
                    if (updateHSV) RGBToHSV(r, g, b, this);
                    return this;
                },
                /**
     * Updates the internal hsv cache values.
     *
     * @method Phaser.Display.Color#updateHSV
     * @private
     * @since 3.13.0
     *
     * @return {Phaser.Display.Color} This Color object.
     */ updateHSV: function() {
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    RGBToHSV(r, g, b, this);
                    return this;
                },
                /**
     * Returns a new Color component using the values from this one.
     *
     * @method Phaser.Display.Color#clone
     * @since 3.0.0
     *
     * @return {Phaser.Display.Color} A new Color object.
     */ clone: function() {
                    return new Color(this.r, this.g, this.b, this.a);
                },
                /**
     * Sets this Color object to be grayscaled based on the shade value given.
     *
     * @method Phaser.Display.Color#gray
     * @since 3.13.0
     * 
     * @param {number} shade - A value between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ gray: function(shade) {
                    return this.setTo(shade, shade, shade);
                },
                /**
     * Sets this Color object to be a random color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#random
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ random: function(min, max) {
                    if (min === undefined) min = 0;
                    if (max === undefined) max = 255;
                    var r = Math.floor(min + Math.random() * (max - min));
                    var g = Math.floor(min + Math.random() * (max - min));
                    var b = Math.floor(min + Math.random() * (max - min));
                    return this.setTo(r, g, b);
                },
                /**
     * Sets this Color object to be a random grayscale color between the `min` and `max` values given.
     *
     * @method Phaser.Display.Color#randomGray
     * @since 3.13.0
     * 
     * @param {number} [min=0] - The minimum random color value. Between 0 and 255.
     * @param {number} [max=255] - The maximum random color value. Between 0 and 255.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ randomGray: function(min, max) {
                    if (min === undefined) min = 0;
                    if (max === undefined) max = 255;
                    var s = Math.floor(min + Math.random() * (max - min));
                    return this.setTo(s, s, s);
                },
                /**
     * Increase the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#saturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ saturate: function(amount) {
                    this.s += amount / 100;
                    return this;
                },
                /**
     * Decrease the saturation of this Color by the percentage amount given.
     * The saturation is the amount of the base color in the hue.
     *
     * @method Phaser.Display.Color#desaturate
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ desaturate: function(amount) {
                    this.s -= amount / 100;
                    return this;
                },
                /**
     * Increase the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#lighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ lighten: function(amount) {
                    this.v += amount / 100;
                    return this;
                },
                /**
     * Decrease the lightness of this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#darken
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ darken: function(amount) {
                    this.v -= amount / 100;
                    return this;
                },
                /**
     * Brighten this Color by the percentage amount given.
     *
     * @method Phaser.Display.Color#brighten
     * @since 3.13.0
     * 
     * @param {number} amount - The percentage amount to change this color by. A value between 0 and 100.
     *
     * @return {Phaser.Display.Color} This Color object.
     */ brighten: function(amount) {
                    var r = this.r;
                    var g = this.g;
                    var b = this.b;
                    r = Math.max(0, Math.min(255, r - Math.round(255 * -(amount / 100))));
                    g = Math.max(0, Math.min(255, g - Math.round(255 * -(amount / 100))));
                    b = Math.max(0, Math.min(255, b - Math.round(255 * -(amount / 100))));
                    return this.setTo(r, g, b);
                },
                /**
     * The color of this Color component, not including the alpha channel.
     *
     * @name Phaser.Display.Color#color
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color: {
                    get: function() {
                        return this._color;
                    }
                },
                /**
     * The color of this Color component, including the alpha channel.
     *
     * @name Phaser.Display.Color#color32
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ color32: {
                    get: function() {
                        return this._color32;
                    }
                },
                /**
     * The color of this Color component as a string which can be used in CSS color values.
     *
     * @name Phaser.Display.Color#rgba
     * @type {string}
     * @readonly
     * @since 3.0.0
     */ rgba: {
                    get: function() {
                        return this._rgba;
                    }
                },
                /**
     * The red color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#redGL
     * @type {number}
     * @since 3.0.0
     */ redGL: {
                    get: function() {
                        return this.gl[0];
                    },
                    set: function(value) {
                        this.gl[0] = Math.min(Math.abs(value), 1);
                        this.r = Math.floor(this.gl[0] * 255);
                        this.update(true);
                    }
                },
                /**
     * The green color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#greenGL
     * @type {number}
     * @since 3.0.0
     */ greenGL: {
                    get: function() {
                        return this.gl[1];
                    },
                    set: function(value) {
                        this.gl[1] = Math.min(Math.abs(value), 1);
                        this.g = Math.floor(this.gl[1] * 255);
                        this.update(true);
                    }
                },
                /**
     * The blue color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#blueGL
     * @type {number}
     * @since 3.0.0
     */ blueGL: {
                    get: function() {
                        return this.gl[2];
                    },
                    set: function(value) {
                        this.gl[2] = Math.min(Math.abs(value), 1);
                        this.b = Math.floor(this.gl[2] * 255);
                        this.update(true);
                    }
                },
                /**
     * The alpha color value, normalized to the range 0 to 1.
     *
     * @name Phaser.Display.Color#alphaGL
     * @type {number}
     * @since 3.0.0
     */ alphaGL: {
                    get: function() {
                        return this.gl[3];
                    },
                    set: function(value) {
                        this.gl[3] = Math.min(Math.abs(value), 1);
                        this.a = Math.floor(this.gl[3] * 255);
                        this.update();
                    }
                },
                /**
     * The red color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#red
     * @type {number}
     * @since 3.0.0
     */ red: {
                    get: function() {
                        return this.r;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.r = Math.min(value, 255);
                        this.gl[0] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The green color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#green
     * @type {number}
     * @since 3.0.0
     */ green: {
                    get: function() {
                        return this.g;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.g = Math.min(value, 255);
                        this.gl[1] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The blue color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#blue
     * @type {number}
     * @since 3.0.0
     */ blue: {
                    get: function() {
                        return this.b;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.b = Math.min(value, 255);
                        this.gl[2] = value / 255;
                        this.update(true);
                    }
                },
                /**
     * The alpha color value, normalized to the range 0 to 255.
     *
     * @name Phaser.Display.Color#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this.a;
                    },
                    set: function(value) {
                        value = Math.floor(Math.abs(value));
                        this.a = Math.min(value, 255);
                        this.gl[3] = value / 255;
                        this.update();
                    }
                },
                /**
     * The hue color value. A number between 0 and 1.
     * This is the base color.
     *
     * @name Phaser.Display.Color#h
     * @type {number}
     * @since 3.13.0
     */ h: {
                    get: function() {
                        return this._h;
                    },
                    set: function(value) {
                        this._h = value;
                        HSVToRGB(value, this._s, this._v, this);
                    }
                },
                /**
     * The saturation color value. A number between 0 and 1.
     * This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
     *
     * @name Phaser.Display.Color#s
     * @type {number}
     * @since 3.13.0
     */ s: {
                    get: function() {
                        return this._s;
                    },
                    set: function(value) {
                        this._s = value;
                        HSVToRGB(this._h, value, this._v, this);
                    }
                },
                /**
     * The lightness color value. A number between 0 and 1.
     * This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
     *
     * @name Phaser.Display.Color#v
     * @type {number}
     * @since 3.13.0
     */ v: {
                    get: function() {
                        return this._v;
                    },
                    set: function(value) {
                        this._v = value;
                        HSVToRGB(this._h, this._s, value, this);
                    }
                }
            });
            module1.exports = Color;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A representation of a vector in 3D space.
 *
 * A three-component vector.
 *
 * @class Vector3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Vector3 = new Class({
                initialize: function Vector3(x, y, z) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector3#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector3#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector3#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                    if (typeof x === 'object') {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                    }
                },
                /**
     * Set this Vector to point up.
     *
     * Sets the y component of the vector to 1, and the others to 0.
     *
     * @method Phaser.Math.Vector3#up
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ up: function() {
                    this.x = 0;
                    this.y = 1;
                    this.z = 0;
                    return this;
                },
                /**
     * Sets the components of this Vector to be the `Math.min` result from the given vector.
     *
     * @method Phaser.Math.Vector3#min
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the minimum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ min: function(v) {
                    this.x = Math.min(this.x, v.x);
                    this.y = Math.min(this.y, v.y);
                    this.z = Math.min(this.z, v.z);
                    return this;
                },
                /**
     * Sets the components of this Vector to be the `Math.max` result from the given vector.
     *
     * @method Phaser.Math.Vector3#max
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to check the maximum values against.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ max: function(v) {
                    this.x = Math.max(this.x, v.x);
                    this.y = Math.max(this.y, v.y);
                    this.z = Math.max(this.z, v.z);
                    return this;
                },
                /**
     * Make a clone of this Vector3.
     *
     * @method Phaser.Math.Vector3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} A new Vector3 object containing this Vectors values.
     */ clone: function() {
                    return new Vector3(this.x, this.y, this.z);
                },
                /**
     * Adds the two given Vector3s and sets the results into this Vector3.
     *
     * @method Phaser.Math.Vector3#addVectors
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to add.
     * @param {Phaser.Math.Vector3} b - The second Vector to add.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addVectors: function(a, b) {
                    this.x = a.x + b.x;
                    this.y = a.y + b.y;
                    this.z = a.z + b.z;
                    return this;
                },
                /**
     * Calculate the cross (vector) product of two given Vectors.
     *
     * @method Phaser.Math.Vector3#crossVectors
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The first Vector to multiply.
     * @param {Phaser.Math.Vector3} b - The second Vector to multiply.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ crossVectors: function(a, b) {
                    var ax = a.x;
                    var ay = a.y;
                    var az = a.z;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    this.x = ay * bz - az * by;
                    this.y = az * bx - ax * bz;
                    this.z = ax * by - ay * bx;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict equality check against each Vector's components.
     *
     * @method Phaser.Math.Vector3#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to compare against.
     *
     * @return {boolean} True if the two vectors strictly match, otherwise false.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y && this.z === v.z;
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector3#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ copy: function(src) {
                    this.x = src.x;
                    this.y = src.y;
                    this.z = src.z || 0;
                    return this;
                },
                /**
     * Set the `x`, `y`, and `z` components of this Vector to the given `x`, `y`, and `z` values.
     *
     * @method Phaser.Math.Vector3#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y and z components.
     * @param {number} [y] - The y value to set for this Vector.
     * @param {number} [z] - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ set: function(x, y, z) {
                    if (typeof x === 'object') {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                    }
                    return this;
                },
                /**
     * Sets the components of this Vector3 from the position of the given Matrix4.
     *
     * @method Phaser.Math.Vector3#setFromMatrixPosition
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the position from.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixPosition: function(m) {
                    return this.fromArray(m.val, 12);
                },
                /**
     * Sets the components of this Vector3 from the Matrix4 column specified.
     *
     * @method Phaser.Math.Vector3#setFromMatrixColumn
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to get the column from.
     * @param {number} index - The column index.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ setFromMatrixColumn: function(mat4, index) {
                    return this.fromArray(mat4.val, index * 4);
                },
                /**
     * Sets the components of this Vector3 from the given array, based on the offset.
     *
     * Vector3.x = array[offset]
     * Vector3.y = array[offset + 1]
     * Vector3.z = array[offset + 2]
     *
     * @method Phaser.Math.Vector3#fromArray
     * @since 3.50.0
     *
     * @param {number[]} array - The array of values to get this Vector from.
     * @param {number} [offset=0] - The offset index into the array.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ fromArray: function(array, offset) {
                    if (offset === undefined) offset = 0;
                    this.x = array[offset];
                    this.y = array[offset + 1];
                    this.z = array[offset + 2];
                    return this;
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ add: function(v) {
                    this.x += v.x;
                    this.y += v.y;
                    this.z += v.z || 0;
                    return this;
                },
                /**
     * Add the given value to each component of this Vector.
     *
     * @method Phaser.Math.Vector3#addScalar
     * @since 3.50.0
     *
     * @param {number} s - The amount to add to this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScalar: function(s) {
                    this.x += s;
                    this.y += s;
                    this.z += s;
                    return this;
                },
                /**
     * Add and scale a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector3#addScale
     * @since 3.50.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to add to this Vector.
     * @param {number} scale - The amount to scale `v` by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ addScale: function(v, scale) {
                    this.x += v.x * scale;
                    this.y += v.y * scale;
                    this.z += v.z * scale || 0;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector3#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ subtract: function(v) {
                    this.x -= v.x;
                    this.y -= v.y;
                    this.z -= v.z || 0;
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ multiply: function(v) {
                    this.x *= v.x;
                    this.y *= v.y;
                    this.z *= v.z || 1;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector3#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ scale: function(scale) {
                    if (isFinite(scale)) {
                        this.x *= scale;
                        this.y *= scale;
                        this.z *= scale;
                    } else {
                        this.x = 0;
                        this.y = 0;
                        this.z = 0;
                    }
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector3#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ divide: function(v) {
                    this.x /= v.x;
                    this.y /= v.y;
                    this.z /= v.z || 1;
                    return this;
                },
                /**
     * Negate the `x`, `y` and `z` components of this Vector.
     *
     * @method Phaser.Math.Vector3#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    this.z = -this.z;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    return Math.sqrt(dx * dx + dy * dy + dz * dz);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector3#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    return dx * dx + dy * dy + dz * dz;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector3#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    return Math.sqrt(x * x + y * y + z * z);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector3#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    return x * x + y * y + z * z;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector3#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var len = x * x + y * y + z * z;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                        this.z = z * len;
                    }
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector3#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to dot product with this Vector3.
     *
     * @return {number} The dot product of this Vector and `v`.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z;
                },
                /**
     * Calculate the cross (vector) product of this Vector (which will be modified) and the given Vector.
     *
     * @method Phaser.Math.Vector3#cross
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector to cross product with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ cross: function(v) {
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var bx = v.x;
                    var by = v.y;
                    var bz = v.z;
                    this.x = ay * bz - az * by;
                    this.y = az * bx - ax * bz;
                    this.z = ax * by - ay * bx;
                    return this;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector3#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} v - The Vector3 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    this.x = ax + t * (v.x - ax);
                    this.y = ay + t * (v.y - ay);
                    this.z = az + t * (v.z - az);
                    return this;
                },
                /**
     * Takes a Matrix3 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix3
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix3} mat3 - The Matrix3 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix3: function(mat3) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat3.val;
                    this.x = m[0] * x + m[3] * y + m[6] * z;
                    this.y = m[1] * x + m[4] * y + m[7] * z;
                    this.z = m[2] * x + m[5] * y + m[8] * z;
                    return this;
                },
                /**
     * Takes a Matrix4 and applies it to this Vector3.
     *
     * @method Phaser.Math.Vector3#applyMatrix4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to apply to this Vector3.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ applyMatrix4: function(mat4) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat4.val;
                    var w = 1 / (m[3] * x + m[7] * y + m[11] * z + m[15]);
                    this.x = (m[0] * x + m[4] * y + m[8] * z + m[12]) * w;
                    this.y = (m[1] * x + m[5] * y + m[9] * z + m[13]) * w;
                    this.z = (m[2] * x + m[6] * y + m[10] * z + m[14]) * w;
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector3#transformMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix3 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat3: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    this.x = x * m[0] + y * m[3] + z * m[6];
                    this.y = x * m[1] + y * m[4] + z * m[7];
                    this.z = x * m[2] + y * m[5] + z * m[8];
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[8] * z + m[12];
                    this.y = m[1] * x + m[5] * y + m[9] * z + m[13];
                    this.z = m[2] * x + m[6] * y + m[10] * z + m[14];
                    return this;
                },
                /**
     * Transforms the coordinates of this Vector3 with the given Matrix4.
     *
     * @method Phaser.Math.Vector3#transformCoordinates
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformCoordinates: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                    var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                    var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                    var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                    this.x = tx / tw;
                    this.y = ty / tw;
                    this.z = tz / tw;
                    return this;
                },
                /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector3#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ transformQuat: function(q) {
                    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var qx = q.x;
                    var qy = q.y;
                    var qz = q.z;
                    var qw = q.w;
                    // calculate quat * vec
                    var ix = qw * x + qy * z - qz * y;
                    var iy = qw * y + qz * x - qx * z;
                    var iz = qw * z + qx * y - qy * x;
                    var iw = -qx * x - qy * y - qz * z;
                    // calculate result * inverse quat
                    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                    return this;
                },
                /**
     * Multiplies this Vector3 by the specified matrix, applying a W divide. This is useful for projection,
     * e.g. unprojecting a 2D point into 3D space.
     *
     * @method Phaser.Math.Vector3#project
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to multiply this Vector3 with.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ project: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = mat.val;
                    var a00 = m[0];
                    var a01 = m[1];
                    var a02 = m[2];
                    var a03 = m[3];
                    var a10 = m[4];
                    var a11 = m[5];
                    var a12 = m[6];
                    var a13 = m[7];
                    var a20 = m[8];
                    var a21 = m[9];
                    var a22 = m[10];
                    var a23 = m[11];
                    var a30 = m[12];
                    var a31 = m[13];
                    var a32 = m[14];
                    var a33 = m[15];
                    var lw = 1 / (x * a03 + y * a13 + z * a23 + a33);
                    this.x = (x * a00 + y * a10 + z * a20 + a30) * lw;
                    this.y = (x * a01 + y * a11 + z * a21 + a31) * lw;
                    this.z = (x * a02 + y * a12 + z * a22 + a32) * lw;
                    return this;
                },
                /**
     * Multiplies this Vector3 by the given view and projection matrices.
     *
     * @method Phaser.Math.Vector3#projectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} viewMatrix - A View Matrix.
     * @param {Phaser.Math.Matrix4} projectionMatrix - A Projection Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ projectViewMatrix: function(viewMatrix, projectionMatrix) {
                    return this.applyMatrix4(viewMatrix).applyMatrix4(projectionMatrix);
                },
                /**
     * Multiplies this Vector3 by the given inversed projection matrix and world matrix.
     *
     * @method Phaser.Math.Vector3#unprojectViewMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} projectionMatrix - An inversed Projection Matrix.
     * @param {Phaser.Math.Matrix4} worldMatrix - A World View Matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unprojectViewMatrix: function(projectionMatrix, worldMatrix) {
                    return this.applyMatrix4(projectionMatrix).applyMatrix4(worldMatrix);
                },
                /**
     * Unproject this point from 2D space to 3D space.
     * The point should have its x and y properties set to
     * 2D screen space, and the z either at 0 (near plane)
     * or 1 (far plane). The provided matrix is assumed to already
     * be combined, i.e. projection * view * model.
     *
     * After this operation, this vector's (x, y, z) components will
     * represent the unprojected 3D coordinate.
     *
     * @method Phaser.Math.Vector3#unproject
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} viewport - Screen x, y, width and height in pixels.
     * @param {Phaser.Math.Matrix4} invProjectionView - Combined projection and view matrix.
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ unproject: function(viewport, invProjectionView) {
                    var viewX = viewport.x;
                    var viewY = viewport.y;
                    var viewWidth = viewport.z;
                    var viewHeight = viewport.w;
                    var x = this.x - viewX;
                    var y = viewHeight - this.y - 1 - viewY;
                    var z = this.z;
                    this.x = 2 * x / viewWidth - 1;
                    this.y = 2 * y / viewHeight - 1;
                    this.z = 2 * z - 1;
                    return this.project(invProjectionView);
                },
                /**
     * Make this Vector the zero vector (0, 0, 0).
     *
     * @method Phaser.Math.Vector3#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector3} This Vector3.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    this.z = 0;
                    return this;
                }
            });
            /**
 * A static zero Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ZERO
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ZERO = new Vector3();
            /**
 * A static right Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.RIGHT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.RIGHT = new Vector3(1, 0, 0);
            /**
 * A static left Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.LEFT
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.LEFT = new Vector3(-1, 0, 0);
            /**
 * A static up Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.UP
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.UP = new Vector3(0, -1, 0);
            /**
 * A static down Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.DOWN
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.DOWN = new Vector3(0, 1, 0);
            /**
 * A static forward Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.FORWARD
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.FORWARD = new Vector3(0, 0, 1);
            /**
 * A static back Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.BACK
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.BACK = new Vector3(0, 0, -1);
            /**
 * A static one Vector3 for use by reference.
 *
 * This constant is meant for comparison operations and should not be modified directly.
 *
 * @constant
 * @name Phaser.Math.Vector3.ONE
 * @type {Phaser.Math.Vector3}
 * @since 3.16.0
 */ Vector3.ONE = new Vector3(1, 1, 1);
            module1.exports = Vector3;
        /***/ },
        /* 39 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Formats
 */ module1.exports = {
                /**
     * CSV Map Type
     * 
     * @name Phaser.Tilemaps.Formats.CSV
     * @type {number}
     * @since 3.0.0
     */ CSV: 0,
                /**
     * Tiled JSON Map Type
     * 
     * @name Phaser.Tilemaps.Formats.TILED_JSON
     * @type {number}
     * @since 3.0.0
     */ TILED_JSON: 1,
                /**
     * 2D Array Map Type
     * 
     * @name Phaser.Tilemaps.Formats.ARRAY_2D
     * @type {number}
     * @since 3.0.0
     */ ARRAY_2D: 2,
                /**
     * Weltmeister (Impact.js) Map Type
     * 
     * @name Phaser.Tilemaps.Formats.WELTMEISTER
     * @type {number}
     * @since 3.0.0
     */ WELTMEISTER: 3
            };
        /***/ },
        /* 40 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the bottom coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetBottom
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The bottom coordinate of the bounds of the Game Object.
 */ var GetBottom = function(gameObject) {
                return gameObject.y + gameObject.height - gameObject.height * gameObject.originY;
            };
            module1.exports = GetBottom;
        /***/ },
        /* 41 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the left coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetLeft
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The left coordinate of the bounds of the Game Object.
 */ var GetLeft = function(gameObject) {
                return gameObject.x - gameObject.width * gameObject.originX;
            };
            module1.exports = GetLeft;
        /***/ },
        /* 42 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the right coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetRight
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The right coordinate of the bounds of the Game Object.
 */ var GetRight = function(gameObject) {
                return gameObject.x + gameObject.width - gameObject.width * gameObject.originX;
            };
            module1.exports = GetRight;
        /***/ },
        /* 43 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the top coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetTop
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The top coordinate of the bounds of the Game Object.
 */ var GetTop = function(gameObject) {
                return gameObject.y - gameObject.height * gameObject.originY;
            };
            module1.exports = GetTop;
        /***/ },
        /* 44 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
 * and then adds the given value to it.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `PropertyValueInc(group.getChildren(), key, value, step)`
 *
 * @function Phaser.Actions.PropertyValueInc
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {string} key - The property to be updated.
 * @param {number} value - The amount to be added to the property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var PropertyValueInc = function(items, key, value, step, index, direction) {
                if (step === undefined) step = 0;
                if (index === undefined) index = 0;
                if (direction === undefined) direction = 1;
                var i;
                var t = 0;
                var end = items.length;
                if (direction === 1) //  Start to End
                for(i = index; i < end; i++){
                    items[i][key] += value + t * step;
                    t++;
                }
                else //  End to Start
                for(i = index; i >= 0; i--){
                    items[i][key] += value + t * step;
                    t++;
                }
                return items;
            };
            module1.exports = PropertyValueInc;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetPoint = __webpack_require__(301);
            var GetPoints = __webpack_require__(168);
            var GEOM_CONST = __webpack_require__(55);
            var Random = __webpack_require__(169);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * Defines a Line segment, a part of a line between two endpoints.
 *
 * @class Line
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - The x coordinate of the lines starting point.
 * @param {number} [y1=0] - The y coordinate of the lines starting point.
 * @param {number} [x2=0] - The x coordinate of the lines ending point.
 * @param {number} [y2=0] - The y coordinate of the lines ending point.
 */ var Line = new Class({
                initialize: function Line(x1, y1, x2, y2) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.LINE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Line#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.LINE;
                    /**
         * The x coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#x1
         * @type {number}
         * @since 3.0.0
         */ this.x1 = x1;
                    /**
         * The y coordinate of the lines starting point.
         *
         * @name Phaser.Geom.Line#y1
         * @type {number}
         * @since 3.0.0
         */ this.y1 = y1;
                    /**
         * The x coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#x2
         * @type {number}
         * @since 3.0.0
         */ this.x2 = x2;
                    /**
         * The y coordinate of the lines ending point.
         *
         * @name Phaser.Geom.Line#y2
         * @type {number}
         * @since 3.0.0
         */ this.y2 = y2;
                },
                /**
     * Get a point on a line that's a given percentage along its length.
     *
     * @method Phaser.Geom.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
     * @param {(Phaser.Geom.Point|object)} [output] - An optional point, or point-like object, to store the coordinates of the point on the line.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point on the line.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Get a number of points along a line's length.
     *
     * Provide a `quantity` to get an exact number of points along the line.
     *
     * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
     * providing a `stepRate`.
     *
     * @method Phaser.Geom.Line#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
     * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
     * @param {(array|Phaser.Geom.Point[])} [output] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Get a random Point on the Line.
     *
     * @method Phaser.Geom.Line#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - An instance of a Point to be modified.
     *
     * @return {Phaser.Geom.Point} A random Point on the Line.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Set new coordinates for the line endpoints.
     *
     * @method Phaser.Geom.Line#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - The x coordinate of the lines starting point.
     * @param {number} [y1=0] - The y coordinate of the lines starting point.
     * @param {number} [x2=0] - The x coordinate of the lines ending point.
     * @param {number} [y2=0] - The y coordinate of the lines ending point.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    this.x1 = x1;
                    this.y1 = y1;
                    this.x2 = x2;
                    this.y2 = y2;
                    return this;
                },
                /**
     * Returns a Vector2 object that corresponds to the start of this Line.
     *
     * @method Phaser.Geom.Line#getPointA
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the start of this Line.
     */ getPointA: function(vec2) {
                    if (vec2 === undefined) vec2 = new Vector2();
                    vec2.set(this.x1, this.y1);
                    return vec2;
                },
                /**
     * Returns a Vector2 object that corresponds to the end of this Line.
     *
     * @method Phaser.Geom.Line#getPointB
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
     *
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the end of this Line.
     */ getPointB: function(vec2) {
                    if (vec2 === undefined) vec2 = new Vector2();
                    vec2.set(this.x2, this.y2);
                    return vec2;
                },
                /**
     * The left position of the Line.
     *
     * @name Phaser.Geom.Line#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return Math.min(this.x1, this.x2);
                    },
                    set: function(value) {
                        if (this.x1 <= this.x2) this.x1 = value;
                        else this.x2 = value;
                    }
                },
                /**
     * The right position of the Line.
     *
     * @name Phaser.Geom.Line#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return Math.max(this.x1, this.x2);
                    },
                    set: function(value) {
                        if (this.x1 > this.x2) this.x1 = value;
                        else this.x2 = value;
                    }
                },
                /**
     * The top position of the Line.
     *
     * @name Phaser.Geom.Line#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return Math.min(this.y1, this.y2);
                    },
                    set: function(value) {
                        if (this.y1 <= this.y2) this.y1 = value;
                        else this.y2 = value;
                    }
                },
                /**
     * The bottom position of the Line.
     *
     * @name Phaser.Geom.Line#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2);
                    },
                    set: function(value) {
                        if (this.y1 > this.y2) this.y1 = value;
                        else this.y2 = value;
                    }
                }
            });
            module1.exports = Line;
        /***/ },
        /* 46 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the fillStyle on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the fill style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the fill style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var FillStyleCanvas = function(ctx, src, altColor, altAlpha) {
                var fillColor = altColor ? altColor : src.fillColor;
                var fillAlpha = altAlpha ? altAlpha : src.fillAlpha;
                var red = (fillColor & 0xFF0000) >>> 16;
                var green = (fillColor & 0xFF00) >>> 8;
                var blue = fillColor & 0xFF;
                ctx.fillStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + fillAlpha + ')';
            };
            module1.exports = FillStyleCanvas;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A MultiFile is a special kind of parent that contains two, or more, Files as children and looks after
 * the loading and processing of them all. It is commonly extended and used as a base class for file types such as AtlasJSON or BitmapFont.
 *
 * You shouldn't create an instance of a MultiFile directly, but should extend it with your own class, setting a custom type and processing methods.
 *
 * @class MultiFile
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
 * @param {string} type - The file type string for sorting within the Loader.
 * @param {string} key - The key of the file within the loader.
 * @param {Phaser.Loader.File[]} files - An array of Files that make-up this MultiFile.
 */ var MultiFile = new Class({
                initialize: function MultiFile(loader, type, key, files) {
                    var finalFiles = [];
                    //  Clean out any potential 'null' or 'undefined' file entries
                    files.forEach(function(file) {
                        if (file) finalFiles.push(file);
                    });
                    /**
         * A reference to the Loader that is going to load this file.
         *
         * @name Phaser.Loader.MultiFile#loader
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.7.0
         */ this.loader = loader;
                    /**
         * The file type string for sorting within the Loader.
         *
         * @name Phaser.Loader.MultiFile#type
         * @type {string}
         * @since 3.7.0
         */ this.type = type;
                    /**
         * Unique cache key (unique within its file type)
         *
         * @name Phaser.Loader.MultiFile#key
         * @type {string}
         * @since 3.7.0
         */ this.key = key;
                    /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.MultiFile#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = loader.multiKeyIndex++;
                    /**
         * Array of files that make up this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#files
         * @type {Phaser.Loader.File[]}
         * @since 3.7.0
         */ this.files = finalFiles;
                    /**
         * The completion status of this MultiFile.
         *
         * @name Phaser.Loader.MultiFile#complete
         * @type {boolean}
         * @default false
         * @since 3.7.0
         */ this.complete = false;
                    /**
         * The number of files to load.
         *
         * @name Phaser.Loader.MultiFile#pending
         * @type {number}
         * @since 3.7.0
         */ this.pending = finalFiles.length;
                    /**
         * The number of files that failed to load.
         *
         * @name Phaser.Loader.MultiFile#failed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.failed = 0;
                    /**
         * A storage container for transient data that the loading files need.
         *
         * @name Phaser.Loader.MultiFile#config
         * @type {any}
         * @since 3.7.0
         */ this.config = {};
                    /**
         * A reference to the Loaders baseURL at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#baseURL
         * @type {string}
         * @since 3.20.0
         */ this.baseURL = loader.baseURL;
                    /**
         * A reference to the Loaders path at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#path
         * @type {string}
         * @since 3.20.0
         */ this.path = loader.path;
                    /**
         * A reference to the Loaders prefix at the time this MultiFile was created.
         * Used to populate child-files.
         *
         * @name Phaser.Loader.MultiFile#prefix
         * @type {string}
         * @since 3.20.0
         */ this.prefix = loader.prefix;
                    //  Link the files
                    for(var i = 0; i < finalFiles.length; i++)finalFiles[i].multiFile = this;
                },
                /**
     * Checks if this MultiFile is ready to process its children or not.
     *
     * @method Phaser.Loader.MultiFile#isReadyToProcess
     * @since 3.7.0
     *
     * @return {boolean} `true` if all children of this MultiFile have loaded, otherwise `false`.
     */ isReadyToProcess: function() {
                    return this.pending === 0 && this.failed === 0 && !this.complete;
                },
                /**
     * Adds another child to this MultiFile, increases the pending count and resets the completion status.
     *
     * @method Phaser.Loader.MultiFile#addToMultiFile
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} files - The File to add to this MultiFile.
     *
     * @return {Phaser.Loader.MultiFile} This MultiFile instance.
     */ addToMultiFile: function(file) {
                    this.files.push(file);
                    file.multiFile = this;
                    this.pending++;
                    this.complete = false;
                    return this;
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.MultiFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) this.pending--;
                },
                /**
     * Called by each File that fails to load.
     *
     * @method Phaser.Loader.MultiFile#onFileFailed
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has failed to load.
     */ onFileFailed: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) this.failed++;
                }
            });
            module1.exports = MultiFile;
        /***/ },
        /* 48 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points).
 *
 * @function Phaser.Math.Distance.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var DistanceBetween = function(x1, y1, x2, y2) {
                var dx = x1 - x2;
                var dy = y1 - y2;
                return Math.sqrt(dx * dx + dy * dy);
            };
            module1.exports = DistanceBetween;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Events
 */ module1.exports = {
                BOOT: __webpack_require__(918),
                DESTROY: __webpack_require__(919),
                DRAG_END: __webpack_require__(920),
                DRAG_ENTER: __webpack_require__(921),
                DRAG: __webpack_require__(922),
                DRAG_LEAVE: __webpack_require__(923),
                DRAG_OVER: __webpack_require__(924),
                DRAG_START: __webpack_require__(925),
                DROP: __webpack_require__(926),
                GAME_OUT: __webpack_require__(927),
                GAME_OVER: __webpack_require__(928),
                GAMEOBJECT_DOWN: __webpack_require__(929),
                GAMEOBJECT_DRAG_END: __webpack_require__(930),
                GAMEOBJECT_DRAG_ENTER: __webpack_require__(931),
                GAMEOBJECT_DRAG: __webpack_require__(932),
                GAMEOBJECT_DRAG_LEAVE: __webpack_require__(933),
                GAMEOBJECT_DRAG_OVER: __webpack_require__(934),
                GAMEOBJECT_DRAG_START: __webpack_require__(935),
                GAMEOBJECT_DROP: __webpack_require__(936),
                GAMEOBJECT_MOVE: __webpack_require__(937),
                GAMEOBJECT_OUT: __webpack_require__(938),
                GAMEOBJECT_OVER: __webpack_require__(939),
                GAMEOBJECT_POINTER_DOWN: __webpack_require__(940),
                GAMEOBJECT_POINTER_MOVE: __webpack_require__(941),
                GAMEOBJECT_POINTER_OUT: __webpack_require__(942),
                GAMEOBJECT_POINTER_OVER: __webpack_require__(943),
                GAMEOBJECT_POINTER_UP: __webpack_require__(944),
                GAMEOBJECT_POINTER_WHEEL: __webpack_require__(945),
                GAMEOBJECT_UP: __webpack_require__(946),
                GAMEOBJECT_WHEEL: __webpack_require__(947),
                MANAGER_BOOT: __webpack_require__(948),
                MANAGER_PROCESS: __webpack_require__(949),
                MANAGER_UPDATE: __webpack_require__(950),
                POINTER_DOWN: __webpack_require__(951),
                POINTER_DOWN_OUTSIDE: __webpack_require__(952),
                POINTER_MOVE: __webpack_require__(953),
                POINTER_OUT: __webpack_require__(954),
                POINTER_OVER: __webpack_require__(955),
                POINTER_UP: __webpack_require__(956),
                POINTER_UP_OUTSIDE: __webpack_require__(957),
                POINTER_WHEEL: __webpack_require__(958),
                POINTERLOCK_CHANGE: __webpack_require__(959),
                PRE_UPDATE: __webpack_require__(960),
                SHUTDOWN: __webpack_require__(961),
                START: __webpack_require__(962),
                UPDATE: __webpack_require__(963)
            };
        /***/ },
        /* 50 */ /***/ function(module1, exports) {
            /**
* The `Matter.Common` module contains utility functions that are common to all modules.
*
* @class Common
*/ var Common = {};
            module1.exports = Common;
            (function() {
                Common._nextId = 0;
                Common._seed = 0;
                Common._nowStartTime = +new Date();
                /**
     * Extends the object in the first argument using the object in the second argument.
     * @method extend
     * @param {} obj
     * @param {boolean} deep
     * @return {} obj extended
     */ Common.extend = function(obj, deep) {
                    var argsStart, args, deepClone;
                    if (typeof deep === 'boolean') {
                        argsStart = 2;
                        deepClone = deep;
                    } else {
                        argsStart = 1;
                        deepClone = true;
                    }
                    for(var i = argsStart; i < arguments.length; i++){
                        var source = arguments[i];
                        if (source) {
                            for(var prop in source)if (deepClone && source[prop] && source[prop].constructor === Object) {
                                if (!obj[prop] || obj[prop].constructor === Object) {
                                    obj[prop] = obj[prop] || {};
                                    Common.extend(obj[prop], deepClone, source[prop]);
                                } else obj[prop] = source[prop];
                            } else obj[prop] = source[prop];
                        }
                    }
                    return obj;
                };
                /**
     * Creates a new clone of the object, if deep is true references will also be cloned.
     * @method clone
     * @param {} obj
     * @param {bool} deep
     * @return {} obj cloned
     */ Common.clone = function(obj, deep) {
                    return Common.extend({}, deep, obj);
                };
                /**
     * Returns the list of keys for the given object.
     * @method keys
     * @param {} obj
     * @return {string[]} keys
     */ Common.keys = function(obj) {
                    if (Object.keys) return Object.keys(obj);
                    // avoid hasOwnProperty for performance
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /**
     * Returns the list of values for the given object.
     * @method values
     * @param {} obj
     * @return {array} Array of the objects property values
     */ Common.values = function(obj) {
                    var values = [];
                    if (Object.keys) {
                        var keys = Object.keys(obj);
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    // avoid hasOwnProperty for performance
                    for(var key in obj)values.push(obj[key]);
                    return values;
                };
                /**
     * Gets a value from `base` relative to the `path` string.
     * @method get
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} The object at the given path
     */ Common.get = function(obj, path, begin, end) {
                    path = path.split('.').slice(begin, end);
                    for(var i = 0; i < path.length; i += 1)obj = obj[path[i]];
                    return obj;
                };
                /**
     * Sets a value on `base` relative to the given `path` string.
     * @method set
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {} val The value to set
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} Pass through `val` for chaining
     */ Common.set = function(obj, path, val, begin, end) {
                    var parts = path.split('.').slice(begin, end);
                    Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
                    return val;
                };
                /**
     * Shuffles the given array in-place.
     * The function uses a seeded random generator.
     * @method shuffle
     * @param {array} array
     * @return {array} array shuffled randomly
     */ Common.shuffle = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Common.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                /**
     * Randomly chooses a value from a list with equal probability.
     * The function uses a seeded random generator.
     * @method choose
     * @param {array} choices
     * @return {object} A random choice object from the array
     */ Common.choose = function(choices) {
                    return choices[Math.floor(Common.random() * choices.length)];
                };
                /**
     * Returns true if the object is a HTMLElement, otherwise false.
     * @method isElement
     * @param {object} obj
     * @return {boolean} True if the object is a HTMLElement, otherwise false
     */ Common.isElement = function(obj) {
                    if (typeof HTMLElement !== 'undefined') return obj instanceof HTMLElement;
                    return !!(obj && obj.nodeType && obj.nodeName);
                };
                /**
     * Returns true if the object is an array.
     * @method isArray
     * @param {object} obj
     * @return {boolean} True if the object is an array, otherwise false
     */ Common.isArray = function(obj) {
                    return Object.prototype.toString.call(obj) === '[object Array]';
                };
                /**
     * Returns true if the object is a function.
     * @method isFunction
     * @param {object} obj
     * @return {boolean} True if the object is a function, otherwise false
     */ Common.isFunction = function(obj) {
                    return typeof obj === "function";
                };
                /**
     * Returns true if the object is a plain object.
     * @method isPlainObject
     * @param {object} obj
     * @return {boolean} True if the object is a plain object, otherwise false
     */ Common.isPlainObject = function(obj) {
                    return typeof obj === 'object' && obj.constructor === Object;
                };
                /**
     * Returns true if the object is a string.
     * @method isString
     * @param {object} obj
     * @return {boolean} True if the object is a string, otherwise false
     */ Common.isString = function(obj) {
                    return Object.prototype.toString.call(obj) === '[object String]';
                };
                /**
     * Returns the given value clamped between a minimum and maximum value.
     * @method clamp
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number} The value clamped between min and max inclusive
     */ Common.clamp = function(value, min, max) {
                    if (value < min) return min;
                    if (value > max) return max;
                    return value;
                };
                /**
     * Returns the sign of the given value.
     * @method sign
     * @param {number} value
     * @return {number} -1 if negative, +1 if 0 or positive
     */ Common.sign = function(value) {
                    return value < 0 ? -1 : 1;
                };
                /**
     * Returns the current timestamp since the time origin (e.g. from page load).
     * The result will be high-resolution including decimal places if available.
     * @method now
     * @return {number} the current timestamp
     */ Common.now = function() {
                    if (typeof window !== 'undefined' && window.performance) {
                        if (window.performance.now) return window.performance.now();
                        else if (window.performance.webkitNow) return window.performance.webkitNow();
                    }
                    return new Date() - Common._nowStartTime;
                };
                /**
     * Returns a random value between a minimum and a maximum value inclusive.
     * The function uses a seeded random generator.
     * @method random
     * @param {number} min
     * @param {number} max
     * @return {number} A random number between min and max inclusive
     */ Common.random = function(min, max) {
                    min = typeof min !== "undefined" ? min : 0;
                    max = typeof max !== "undefined" ? max : 1;
                    return min + _seededRandom() * (max - min);
                };
                var _seededRandom = function() {
                    // https://en.wikipedia.org/wiki/Linear_congruential_generator
                    Common._seed = (Common._seed * 9301 + 49297) % 233280;
                    return Common._seed / 233280;
                };
                /**
     * Converts a CSS hex colour string into an integer.
     * @method colorToNumber
     * @param {string} colorString
     * @return {number} An integer representing the CSS hex string
     */ Common.colorToNumber = function(colorString) {
                    colorString = colorString.replace('#', '');
                    if (colorString.length == 3) colorString = colorString.charAt(0) + colorString.charAt(0) + colorString.charAt(1) + colorString.charAt(1) + colorString.charAt(2) + colorString.charAt(2);
                    return parseInt(colorString, 16);
                };
                /**
     * The console logging level to use, where each level includes all levels above and excludes the levels below.
     * The default level is 'debug' which shows all console messages.  
     *
     * Possible level values are:
     * - 0 = None
     * - 1 = Debug
     * - 2 = Info
     * - 3 = Warn
     * - 4 = Error
     * @property Common.logLevel
     * @type {Number}
     * @default 1
     */ Common.logLevel = 1;
                /**
     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method log
     * @param ...objs {} The objects to log.
     */ Common.log = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.log.apply(console, [
                        'matter-js:'
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method info
     * @param ...objs {} The objects to log.
     */ Common.info = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 2) console.info.apply(console, [
                        'matter-js:'
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method warn
     * @param ...objs {} The objects to log.
     */ Common.warn = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.warn.apply(console, [
                        'matter-js:'
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Returns the next unique sequential ID.
     * @method nextId
     * @return {Number} Unique sequential ID
     */ Common.nextId = function() {
                    return Common._nextId++;
                };
                /**
     * A cross browser compatible indexOf implementation.
     * @method indexOf
     * @param {array} haystack
     * @param {object} needle
     * @return {number} The position of needle in haystack, otherwise -1.
     */ Common.indexOf = function(haystack, needle) {
                    if (haystack.indexOf) return haystack.indexOf(needle);
                    for(var i = 0; i < haystack.length; i++){
                        if (haystack[i] === needle) return i;
                    }
                    return -1;
                };
                /**
     * A cross browser compatible array map implementation.
     * @method map
     * @param {array} list
     * @param {function} func
     * @return {array} Values from list transformed by func.
     */ Common.map = function(list, func) {
                    if (list.map) return list.map(func);
                    var mapped = [];
                    for(var i = 0; i < list.length; i += 1)mapped.push(func(list[i]));
                    return mapped;
                };
                /**
     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
     * Circular dependencies are allowed.
     * @method topologicalSort
     * @param {object} graph
     * @return {array} Partially ordered set of vertices in topological order.
     */ Common.topologicalSort = function(graph) {
                    // https://github.com/mgechev/javascript-algorithms
                    // Copyright (c) Minko Gechev (MIT license)
                    // Modifications: tidy formatting and naming
                    var result = [], visited = [], temp = [];
                    for(var node in graph)if (!visited[node] && !temp[node]) Common._topologicalSort(node, visited, temp, graph, result);
                    return result;
                };
                Common._topologicalSort = function(node, visited, temp, graph, result) {
                    var neighbors = graph[node] || [];
                    temp[node] = true;
                    for(var i = 0; i < neighbors.length; i += 1){
                        var neighbor = neighbors[i];
                        if (temp[neighbor]) continue;
                        if (!visited[neighbor]) Common._topologicalSort(neighbor, visited, temp, graph, result);
                    }
                    temp[node] = false;
                    visited[node] = true;
                    result.push(node);
                };
                /**
     * Takes _n_ functions as arguments and returns a new function that calls them in order.
     * The arguments applied when calling the new function will also be applied to every function passed.
     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
     * Therefore if a passed function does not return a value, the previously returned value is maintained.
     * After all passed functions have been called the new function returns the last returned value (if any).
     * If any of the passed functions are a chain, then the chain will be flattened.
     * @method chain
     * @param ...funcs {function} The functions to chain.
     * @return {function} A new function that calls the passed functions in order.
     */ Common.chain = function() {
                    var funcs = [];
                    for(var i = 0; i < arguments.length; i += 1){
                        var func = arguments[i];
                        if (func._chained) // flatten already chained functions
                        funcs.push.apply(funcs, func._chained);
                        else funcs.push(func);
                    }
                    var chain = function() {
                        // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
                        var lastResult, args = new Array(arguments.length);
                        for(var i = 0, l = arguments.length; i < l; i++)args[i] = arguments[i];
                        for(i = 0; i < funcs.length; i += 1){
                            var result = funcs[i].apply(lastResult, args);
                            if (typeof result !== 'undefined') lastResult = result;
                        }
                        return lastResult;
                    };
                    chain._chained = funcs;
                    return chain;
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathBefore
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathBefore = function(base, path, func) {
                    return Common.set(base, path, Common.chain(func, Common.get(base, path)));
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathAfter
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathAfter = function(base, path, func) {
                    return Common.set(base, path, Common.chain(Common.get(base, path), func));
                };
            })();
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetTop = function(gameObject, value) {
                gameObject.y = value + gameObject.height * gameObject.originY;
                return gameObject;
            };
            module1.exports = SetTop;
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetLeft = function(gameObject, value) {
                gameObject.x = value + gameObject.width * gameObject.originX;
                return gameObject;
            };
            module1.exports = SetLeft;
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetRight = function(gameObject, value) {
                gameObject.x = value - gameObject.width + gameObject.width * gameObject.originX;
                return gameObject;
            };
            module1.exports = SetRight;
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the bottom of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} value - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetBottom = function(gameObject, value) {
                gameObject.y = value - gameObject.height + gameObject.height * gameObject.originY;
                return gameObject;
            };
            module1.exports = SetBottom;
        /***/ },
        /* 55 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GEOM_CONST = {
                /**
     * A Circle Geometry object type.
     * 
     * @name Phaser.Geom.CIRCLE
     * @type {number}
     * @since 3.19.0
     */ CIRCLE: 0,
                /**
     * An Ellipse Geometry object type.
     * 
     * @name Phaser.Geom.ELLIPSE
     * @type {number}
     * @since 3.19.0
     */ ELLIPSE: 1,
                /**
     * A Line Geometry object type.
     * 
     * @name Phaser.Geom.LINE
     * @type {number}
     * @since 3.19.0
     */ LINE: 2,
                /**
     * A Point Geometry object type.
     * 
     * @name Phaser.Geom.POINT
     * @type {number}
     * @since 3.19.0
     */ POINT: 3,
                /**
     * A Polygon Geometry object type.
     * 
     * @name Phaser.Geom.POLYGON
     * @type {number}
     * @since 3.19.0
     */ POLYGON: 4,
                /**
     * A Rectangle Geometry object type.
     * 
     * @name Phaser.Geom.RECTANGLE
     * @type {number}
     * @since 3.19.0
     */ RECTANGLE: 5,
                /**
     * A Triangle Geometry object type.
     * 
     * @name Phaser.Geom.TRIANGLE
     * @type {number}
     * @since 3.19.0
     */ TRIANGLE: 6
            };
            module1.exports = GEOM_CONST;
        /***/ },
        /* 56 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if a given point is inside a Rectangle's bounds.
 *
 * @function Phaser.Geom.Rectangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the Rectangle's bounds, otherwise `false`.
 */ var Contains = function(rect, x, y) {
                if (rect.width <= 0 || rect.height <= 0) return false;
                return rect.x <= x && rect.x + rect.width >= x && rect.y <= y && rect.y + rect.height >= y;
            };
            module1.exports = Contains;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DeepCopy = __webpack_require__(172);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(368);
            var GetFastValue = __webpack_require__(2);
            var Matrix4 = __webpack_require__(67);
            var RendererEvents = __webpack_require__(88);
            var RenderTarget = __webpack_require__(139);
            var Utils = __webpack_require__(12);
            var WebGLShader = __webpack_require__(369);
            /**
 * @classdesc
 * The `WebGLPipeline` is a base class used by all of the core Phaser pipelines.
 *
 * It describes the way elements will be rendered in WebGL. Internally, it handles
 * compiling the shaders, creating vertex buffers, assigning primitive topology and
 * binding vertex attributes, all based on the given configuration data.
 *
 * The pipeline is configured by passing in a `WebGLPipelineConfig` object. Please
 * see the documentation for this type to fully understand the configuration options
 * available to you.
 *
 * Usually, you would not extend from this class directly, but would instead extend
 * from one of the core pipelines, such as the Multi Pipeline.
 *
 * The pipeline flow per render-step is as follows:
 *
 * 1) onPreRender - called once at the start of the render step
 * 2) onRender - call for each Scene Camera that needs to render (so can be multiple times per render step)
 * 3) Internal flow:
 * 3a)   bind (only called if a Game Object is using this pipeline and it's not currently active)
 * 3b)   onBind (called for every Game Object that uses this pipeline)
 * 3c)   flush (can be called by a Game Object, internal method or from outside by changing pipeline)
 * 4) onPostRender - called once at the end of the render step
 *
 * @class WebGLPipeline
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
 */ var WebGLPipeline = new Class({
                Extends: EventEmitter,
                initialize: function WebGLPipeline(config) {
                    EventEmitter.call(this);
                    var game = config.game;
                    var renderer = game.renderer;
                    var gl = renderer.gl;
                    /**
         * Name of the pipeline. Used for identification and setting from Game Objects.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'WebGLPipeline');
                    /**
         * The Phaser Game instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The WebGL Renderer instance to which this pipeline is bound.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.0.0
         */ this.renderer = renderer;
                    /**
         * A reference to the WebGL Pipeline Manager.
         *
         * This is initially undefined and only set when this pipeline is added
         * to the manager.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#manager
         * @type {?Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.manager;
                    /**
         * The WebGL context this WebGL Pipeline uses.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#gl
         * @type {WebGLRenderingContext}
         * @since 3.0.0
         */ this.gl = gl;
                    /**
         * The canvas which this WebGL Pipeline renders to.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#view
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.view = game.canvas;
                    /**
         * Width of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * Height of the current viewport.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The current number of vertices that have been added to the pipeline batch.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.vertexCount = 0;
                    /**
         * The total number of vertices that this pipeline batch can hold before it will flush.
         *
         * This defaults to `renderer batchSize * 6`, where `batchSize` is defined in the Renderer Game Config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCapacity
         * @type {number}
         * @since 3.0.0
         */ this.vertexCapacity = 0;
                    /**
         * Raw byte buffer of vertices.
         *
         * Either set via the config object `vertices` property, or generates a new Array Buffer of
         * size `vertexCapacity * vertexSize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexData
         * @type {ArrayBuffer}
         * @readonly
         * @since 3.0.0
         */ this.vertexData;
                    /**
         * The WebGLBuffer that holds the vertex data.
         *
         * Created from the `vertexData` ArrayBuffer. If `vertices` are set in the config, a `STATIC_DRAW` buffer
         * is created. If not, a `DYNAMIC_DRAW` buffer is created.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexBuffer
         * @type {WebGLBuffer}
         * @readonly
         * @since 3.0.0
         */ this.vertexBuffer;
                    /**
         * The primitive topology which the pipeline will use to submit draw calls.
         *
         * Defaults to GL_TRIANGLES if not otherwise set in the config.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#topology
         * @type {GLenum}
         * @since 3.0.0
         */ this.topology = GetFastValue(config, 'topology', gl.TRIANGLES);
                    /**
         * Uint8 view to the `vertexData` ArrayBuffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#bytes
         * @type {Uint8Array}
         * @since 3.0.0
         */ this.bytes;
                    /**
         * Float32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewF32
         * @type {Float32Array}
         * @since 3.0.0
         */ this.vertexViewF32;
                    /**
         * Uint32 view of the array buffer containing the pipeline's vertices.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexViewU32
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.vertexViewU32;
                    /**
         * Indicates if the current pipeline is active, or not.
         *
         * Toggle this property to enable or disable a pipeline from rendering anything.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = true;
                    /**
         * Holds the most recently assigned texture unit.
         *
         * Treat this value as read-only.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentUnit
         * @type {number}
         * @since 3.50.0
         */ this.currentUnit = 0;
                    /**
         * Some pipelines require the forced use of texture zero (like the light pipeline).
         *
         * This property should be set when that is the case.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#forceZero
         * @type {boolean}
         * @since 3.50.0
         */ this.forceZero = GetFastValue(config, 'forceZero', false);
                    /**
         * Indicates if this pipeline has booted or not.
         *
         * A pipeline boots only when the Game instance itself, and all associated systems, is
         * fully ready.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#hasBooted
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.hasBooted = false;
                    /**
         * Indicates if this is a Post FX Pipeline, or not.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#isPostFX
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isPostFX = false;
                    /**
         * An array of RenderTarget instances that belong to this pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderTargets
         * @type {Phaser.Renderer.WebGL.RenderTarget[]}
         * @since 3.50.0
         */ this.renderTargets = [];
                    /**
         * A reference to the currently bound Render Target instance from the `WebGLPipeline.renderTargets` array.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentRenderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.currentRenderTarget;
                    /**
         * An array of all the WebGLShader instances that belong to this pipeline.
         *
         * Shaders manage their own attributes and uniforms, but share the same vertex data buffer,
         * which belongs to this pipeline.
         *
         * Shaders are set in a call to the `setShadersFromConfig` method, which happens automatically,
         * but can also be called at any point in your game. See the method documentation for details.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#shaders
         * @type {Phaser.Renderer.WebGL.WebGLShader[]}
         * @since 3.50.0
         */ this.shaders = [];
                    /**
         * A reference to the currently bound WebGLShader instance from the `WebGLPipeline.shaders` array.
         *
         * For lots of pipelines, this is the only shader, so it is a quick way to reference it without
         * an array look-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#currentShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.currentShader;
                    /**
         * The Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                    /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                    /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                    /**
         * The configuration object that was used to create this pipeline.
         *
         * Treat this object as 'read only', because changing it post-creation will not
         * impact this pipeline in any way. However, it is used internally for cloning
         * and post-boot set-up.
         *
         * @name Phaser.Renderer.WebGL.WebGLPipeline#config
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig}
         * @since 3.50.0
         */ this.config = config;
                },
                /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place. You can perform any final tasks that the
     * pipeline may need, that relies on game systems such as the Texture Manager being ready.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#boot
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BOOT
     * @since 3.11.0
     */ boot: function() {
                    var i;
                    var gl = this.gl;
                    var config = this.config;
                    var renderer = this.renderer;
                    if (!this.isPostFX) this.projectionMatrix = new Matrix4().identity();
                    //  Create the Render Targets
                    var renderTargets = this.renderTargets;
                    var targets = GetFastValue(config, 'renderTarget', false);
                    //  If boolean, set to number = 1
                    if (typeof targets === 'boolean' && targets) targets = 1;
                    var width = renderer.width;
                    var height = renderer.height;
                    if (typeof targets === 'number') //  Create this many default RTs
                    for(i = 0; i < targets; i++)renderTargets.push(new RenderTarget(renderer, width, height, 1, 0, true));
                    else if (Array.isArray(targets)) for(i = 0; i < targets.length; i++){
                        var scale = GetFastValue(targets[i], 'scale', 1);
                        var minFilter = GetFastValue(targets[i], 'minFilter', 0);
                        var autoClear = GetFastValue(targets[i], 'autoClear', 1);
                        renderTargets.push(new RenderTarget(renderer, width, height, scale, minFilter, autoClear));
                    }
                    if (renderTargets.length) //  Default to the first one in the array
                    this.currentRenderTarget = renderTargets[0];
                    //  Create the Shaders
                    this.setShadersFromConfig(config);
                    //  Which shader has the largest vertex size?
                    var shaders = this.shaders;
                    var vertexSize = 0;
                    for(i = 0; i < shaders.length; i++)if (shaders[i].vertexSize > vertexSize) vertexSize = shaders[i].vertexSize;
                    var batchSize = GetFastValue(config, 'batchSize', renderer.config.batchSize);
                    //  * 6 because there are 6 vertices in a quad and 'batchSize' represents the quantity of quads in the batch
                    this.vertexCapacity = batchSize * 6;
                    var data = new ArrayBuffer(this.vertexCapacity * vertexSize);
                    this.vertexData = data;
                    this.bytes = new Uint8Array(data);
                    this.vertexViewF32 = new Float32Array(data);
                    this.vertexViewU32 = new Uint32Array(data);
                    var configVerts = GetFastValue(config, 'vertices', null);
                    if (configVerts) {
                        this.vertexViewF32.set(configVerts);
                        this.vertexBuffer = renderer.createVertexBuffer(data, gl.STATIC_DRAW);
                    } else this.vertexBuffer = renderer.createVertexBuffer(data.byteLength, gl.DYNAMIC_DRAW);
                    //  Set-up shaders
                    this.setVertexBuffer();
                    for(i = shaders.length - 1; i >= 0; i--)shaders[i].rebind();
                    this.hasBooted = true;
                    renderer.on(RendererEvents.RESIZE, this.resize, this);
                    renderer.on(RendererEvents.PRE_RENDER, this.onPreRender, this);
                    renderer.on(RendererEvents.RENDER, this.onRender, this);
                    renderer.on(RendererEvents.POST_RENDER, this.onPostRender, this);
                    this.emit(Events.BOOT, this);
                    this.onBoot();
                },
                /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBoot
     * @since 3.50.0
     */ onBoot: function() {},
                /**
     * This method is called once when this pipeline has finished being set-up
     * at the end of the boot process. By the time this method is called, all
     * of the shaders are ready and configured. It's also called if the renderer
     * changes size.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onResize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     */ onResize: function() {},
                /**
     * Sets the currently active shader within this pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShader
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} shader - The shader to set as being current.
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     *
     * @return {this} This WebGLPipeline instance.
     */ setShader: function(shader, setAttributes) {
                    var renderer = this.renderer;
                    if (shader !== this.currentShader || renderer.currentProgram !== this.currentShader.program) {
                        this.flush();
                        renderer.resetTextures();
                        var wasBound = this.setVertexBuffer();
                        if (wasBound && !setAttributes) setAttributes = true;
                        shader.bind(setAttributes, false);
                        this.currentShader = shader;
                    }
                    return this;
                },
                /**
     * Searches all shaders in this pipeline for one matching the given name, then returns it.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#getShaderByName
     * @since 3.50.0
     *
     * @param {string} name - The index of the shader to set.
     *
     * @return {Phaser.Renderer.WebGL.WebGLShader} The WebGLShader instance, if found.
     */ getShaderByName: function(name) {
                    var shaders = this.shaders;
                    for(var i = 0; i < shaders.length; i++){
                        if (shaders[i].name === name) return shaders[i];
                    }
                },
                /**
     * Destroys all shaders currently set in the `WebGLPipeline.shaders` array and then parses the given
     * `config` object, extracting the shaders from it, creating `WebGLShader` instances and finally
     * setting them into the `shaders` array of this pipeline.
     *
     * This is a destructive process. Be very careful when you call it, should you need to.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setShadersFromConfig
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration object for this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setShadersFromConfig: function(config) {
                    var i;
                    var shaders = this.shaders;
                    var renderer = this.renderer;
                    for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                    var vName = 'vertShader';
                    var fName = 'fragShader';
                    var aName = 'attributes';
                    var defaultVertShader = GetFastValue(config, vName, null);
                    var defaultFragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(config, fName, null), renderer.maxTextures);
                    var defaultAttribs = GetFastValue(config, aName, null);
                    var configShaders = GetFastValue(config, 'shaders', []);
                    var len = configShaders.length;
                    if (len === 0) {
                        if (defaultVertShader && defaultFragShader) this.shaders = [
                            new WebGLShader(this, 'default', defaultVertShader, defaultFragShader, DeepCopy(defaultAttribs))
                        ];
                    } else {
                        var newShaders = [];
                        for(i = 0; i < len; i++){
                            var shaderEntry = configShaders[i];
                            var name = GetFastValue(shaderEntry, 'name', 'default');
                            var vertShader = GetFastValue(shaderEntry, vName, defaultVertShader);
                            var fragShader = Utils.parseFragmentShaderMaxTextures(GetFastValue(shaderEntry, fName, defaultFragShader), renderer.maxTextures);
                            var attributes = GetFastValue(shaderEntry, aName, defaultAttribs);
                            if (vertShader && fragShader) newShaders.push(new WebGLShader(this, name, vertShader, fragShader, DeepCopy(attributes)));
                        }
                        this.shaders = newShaders;
                    }
                    if (this.shaders.length === 0) console.warn('Pipeline: ' + this.name + ' - Invalid shader config');
                    else this.currentShader = this.shaders[0];
                    return this;
                },
                /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setGameObject
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                    if (frame === undefined) frame = gameObject.frame;
                    this.currentUnit = this.renderer.setTextureSource(frame.source);
                    return this.currentUnit;
                },
                /**
     * Check if the current batch of vertices is full.
     *
     * You can optionally provide an `amount` parameter. If given, it will check if the batch
     * needs to flush _if_ the `amount` is added to it. This allows you to test if you should
     * flush before populating the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#shouldFlush
     * @since 3.0.0
     *
     * @param {number} [amount=0] - Will the batch need to flush if this many vertices are added to it?
     *
     * @return {boolean} `true` if the current batch should be flushed, otherwise `false`.
     */ shouldFlush: function(amount) {
                    if (amount === undefined) amount = 0;
                    return this.vertexCount + amount > this.vertexCapacity;
                },
                /**
     * Resizes the properties used to describe the viewport.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#resize
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ resize: function(width, height) {
                    if (width !== this.width || height !== this.height) this.flush();
                    this.width = width;
                    this.height = height;
                    var targets = this.renderTargets;
                    for(var i = 0; i < targets.length; i++)targets[i].resize(width, height);
                    this.setProjectionMatrix(width, height);
                    this.emit(Events.RESIZE, width, height, this);
                    this.onResize(width, height);
                    return this;
                },
                /**
     * Adjusts this pipelines ortho Projection Matrix to use the given dimensions
     * and resets the `uProjectionMatrix` uniform on all bound shaders.
     *
     * This method is called automatically by the renderer during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of this WebGL Pipeline.
     * @param {number} height - The new height of this WebGL Pipeline.
     *
     * @return {this} This WebGLPipeline instance.
     */ setProjectionMatrix: function(width, height) {
                    var projectionMatrix = this.projectionMatrix;
                    //  Because not all pipelines have them
                    if (!projectionMatrix) return this;
                    this.projectionWidth = width;
                    this.projectionHeight = height;
                    projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                    var shaders = this.shaders;
                    var name = 'uProjectionMatrix';
                    for(var i = 0; i < shaders.length; i++){
                        var shader = shaders[i];
                        if (shader.hasUniform(name)) {
                            shader.resetUniform(name);
                            shader.setMatrix4fv(name, false, projectionMatrix.val, shader);
                        }
                    }
                    return this;
                },
                /**
     * Adjusts this pipelines ortho Projection Matrix to match that of the global
     * WebGL Renderer Projection Matrix.
     *
     * This method is called automatically by the Pipeline Manager when this
     * pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#updateProjectionMatrix
     * @since 3.50.0
     */ updateProjectionMatrix: function() {
                    if (this.projectionMatrix) {
                        var globalWidth = this.renderer.projectionWidth;
                        var globalHeight = this.renderer.projectionHeight;
                        if (this.projectionWidth !== globalWidth || this.projectionHeight !== globalHeight) this.setProjectionMatrix(globalWidth, globalHeight);
                    }
                },
                /**
     * This method is called every time the Pipeline Manager makes this pipeline the currently active one.
     *
     * It binds the resources and shader needed for this pipeline, including setting the vertex buffer
     * and attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BIND
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {this} This WebGLPipeline instance.
     */ bind: function(currentShader) {
                    if (currentShader === undefined) currentShader = this.currentShader;
                    var wasBound = this.setVertexBuffer();
                    currentShader.bind(wasBound);
                    this.currentShader = currentShader;
                    this.emit(Events.BIND, this, currentShader);
                    this.onActive(currentShader);
                    return this;
                },
                /**
     * This method is called every time the Pipeline Manager rebinds this pipeline.
     *
     * It resets all shaders this pipeline uses, setting their attributes again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#rebind
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#REBIND
     * @since 3.0.0
     *
     * @return {this} This WebGLPipeline instance.
     */ rebind: function() {
                    this.setVertexBuffer();
                    var shaders = this.shaders;
                    //  Loop in reverse, so the first shader in the array is left as being bound
                    for(var i = shaders.length - 1; i >= 0; i--)this.currentShader = shaders[i].rebind();
                    this.emit(Events.REBIND, this.currentShader);
                    this.onActive(this.currentShader);
                    this.onRebind();
                    return this;
                },
                /**
     * Binds the vertex buffer to be the active ARRAY_BUFFER on the WebGL context.
     *
     * It first checks to see if it's already set as the active buffer and only
     * binds itself if not.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setVertexBuffer
     * @since 3.50.0
     *
     * @return {boolean} `true` if the vertex buffer was bound, or `false` if it was already bound.
     */ setVertexBuffer: function() {
                    var gl = this.gl;
                    var buffer = this.vertexBuffer;
                    if (gl.getParameter(gl.ARRAY_BUFFER_BINDING) !== buffer) {
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        return true;
                    }
                    return false;
                },
                /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch. When this is called, the
     * renderer has just performed a flush. It will bind the current render target, if any are set
     * and finally call the `onPreBatch` hook.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#preBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ preBatch: function(gameObject) {
                    if (this.currentRenderTarget) this.currentRenderTarget.bind();
                    this.onPreBatch(gameObject);
                    return this;
                },
                /**
     * This method is called as a result of the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. When this is called, the
     * renderer has just performed a flush.
     *
     * It calls the `onDraw` hook followed by the `onPostBatch` hook, which can be used to perform
     * additional Post FX Pipeline processing.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#postBatch
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.Cameras.Scene2D.Camera)} [gameObject] - The Game Object or Camera that invoked this pipeline, if any.
     *
     * @return {this} This WebGLPipeline instance.
     */ postBatch: function(gameObject) {
                    this.onDraw(this.currentRenderTarget);
                    this.onPostBatch(gameObject);
                    return this;
                },
                /**
     * This method is only used by Post FX Pipelines and those that extend from them.
     *
     * This method is called every time the `postBatch` method is called and is passed a
     * reference to the current render target.
     *
     * At the very least a Post FX Pipeline should call `this.bindAndDraw(renderTarget)`,
     * however, you can do as much additional processing as you like in this method if
     * you override it from within your own pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} renderTarget - The Render Target.
     */ onDraw: function() {},
                /**
     * This method is called every time the Pipeline Manager deactivates this pipeline, swapping from
     * it to another one. This happens after a call to `flush` and before the new pipeline is bound.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#unbind
     * @since 3.50.0
     */ unbind: function() {
                    if (this.currentRenderTarget) this.currentRenderTarget.unbind();
                },
                /**
     * Uploads the vertex data and emits a draw call for the current batch of vertices.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#flush
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
     * @since 3.0.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     *
     * @return {this} This WebGLPipeline instance.
     */ flush: function(isPostFlush) {
                    if (isPostFlush === undefined) isPostFlush = false;
                    if (this.vertexCount > 0) {
                        this.emit(Events.BEFORE_FLUSH, this, isPostFlush);
                        this.onBeforeFlush(isPostFlush);
                        var gl = this.gl;
                        var vertexCount = this.vertexCount;
                        var vertexSize = this.currentShader.vertexSize;
                        if (this.active) {
                            this.setVertexBuffer();
                            if (vertexCount === this.vertexCapacity) gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.DYNAMIC_DRAW);
                            else gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                            gl.drawArrays(this.topology, 0, vertexCount);
                        }
                        this.vertexCount = 0;
                        this.emit(Events.AFTER_FLUSH, this, isPostFlush);
                        this.onAfterFlush(isPostFlush);
                    }
                    return this;
                },
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the Pipeline Manager makes this the active pipeline. It is called
     * at the end of the `WebGLPipeline.bind` method, after the current shader has been set. The current
     * shader is passed to this hook.
     *
     * For example, if a display list has 3 Sprites in it that all use the same pipeline, this hook will
     * only be called for the first one, as the 2nd and 3rd Sprites do not cause the pipeline to be changed.
     *
     * If you need to listen for that event instead, use the `onBind` hook.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onActive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as current.
     */ onActive: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time a **Game Object** asks the Pipeline Manager to use this pipeline,
     * even if the pipeline is already active.
     *
     * Unlike the `onActive` method, which is only called when the Pipeline Manager makes this pipeline
     * active, this hook is called for every Game Object that requests use of this pipeline, allowing you to
     * perform per-object set-up, such as loading shader uniform data.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBind
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBind: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called when the Pipeline Manager needs to rebind this pipeline. This happens after a
     * pipeline has been cleared, usually when passing control over to a 3rd party WebGL library, like Spine,
     * and then returing to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRebind
     * @since 3.50.0
     */ onRebind: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time the `batchQuad` or `batchTri` methods are called. If this was
     * as a result of a Game Object, then the Game Object reference is passed to this hook too.
     *
     * This hook is called _after_ the quad (or tri) has been added to the batch, so you can safely
     * call 'flush' from within this.
     *
     * Note that Game Objects may call `batchQuad` or `batchTri` multiple times for a single draw,
     * for example the Graphics Game Object.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately before a **Game Object** is about to add itself to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPreBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after a **Game Object** has been added to the batch.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     */ onPostBatch: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called once per frame, right before anything has been rendered, but after the canvas
     * has been cleared. If this pipeline has a render target, it will also have been cleared by this point.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreRender
     * @since 3.50.0
     */ onPreRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, by every Camera in a Scene that wants to render.
     *
     * It is called at the start of the rendering process, before anything has been drawn to the Camera.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRender
     * @since 3.50.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called _once per frame_, after all rendering has happened and snapshots have been taken.
     *
     * It is called at the very end of the rendering process, once all Cameras, for all Scenes, have
     * been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostRender
     * @since 3.50.0
     */ onPostRender: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called every time this pipeline is asked to flush its batch.
     *
     * It is called immediately before the `gl.bufferData` and `gl.drawArrays` calls are made, so you can
     * perform any final pre-render modifications. To apply changes post-render, see `onAfterFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBeforeFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onBeforeFlush: function() {},
                /**
     * By default this is an empty method hook that you can override and use in your own custom pipelines.
     *
     * This method is called immediately after this pipeline has finished flushing its batch.
     *
     * It is called after the `gl.drawArrays` call.
     *
     * You can perform additional post-render effects, but be careful not to call `flush`
     * on this pipeline from within this method, or you'll cause an infinite loop.
     *
     * To apply changes pre-render, see `onBeforeFlush`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#onAfterFlush
     * @since 3.50.0
     *
     * @param {boolean} [isPostFlush=false] - Was this flush invoked as part of a post-process, or not?
     */ onAfterFlush: function() {},
                /**
     * Adds a single vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchTri` and `batchQuad`.
     *
     * It does not perform any batch limit checking itself, so if you need to call
     * this method directly, do so in the same way that `batchQuad` does, for example.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} u - UV u value.
     * @param {number} v - UV v value.
     * @param {number} unit - Texture unit to which the texture needs to be bound.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {number} tint - The tint color value.
     */ batchVert: function(x, y, u, v, unit, tintEffect, tint) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexViewU32 = this.vertexViewU32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewF32[++vertexOffset] = u;
                    vertexViewF32[++vertexOffset] = v;
                    vertexViewF32[++vertexOffset] = unit;
                    vertexViewF32[++vertexOffset] = tintEffect;
                    vertexViewU32[++vertexOffset] = tint;
                    this.vertexCount++;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where tx0/ty0 = 0, tx1/ty1 = 1, tx2/ty2 = 2 and tx3/ty3 = 3
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchQuad
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(gameObject, x0, y0, x1, y1, x2, y2, x3, y3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, unit) {
                    if (unit === undefined) unit = this.currentUnit;
                    var hasFlushed = false;
                    if (this.shouldFlush(6)) {
                        this.flush();
                        hasFlushed = true;
                        unit = this.setTexture2D(texture);
                    }
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x1, y1, u0, v1, unit, tintEffect, tintBL);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBR);
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBR);
                    this.batchVert(x3, y3, u1, v0, unit, tintEffect, tintTR);
                    this.onBatch(gameObject);
                    return hasFlushed;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 3 vertices in the following arrangement:
     *
     * ```
     * 0
     * |\
     * | \
     * |  \
     * |   \
     * |    \
     * 1-----2
     * ```
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#batchTri
     * @since 3.50.0
     *
     * @param {(Phaser.GameObjects.GameObject|null)} gameObject - The Game Object, if any, drawing this quad.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {(number|boolean)} tintEffect - The tint effect for the shader to use.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {number} [unit=0] - Texture unit to which the texture needs to be bound.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchTri: function(gameObject, x0, y0, x1, y1, x2, y2, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintEffect, texture, unit) {
                    if (unit === undefined) unit = this.currentUnit;
                    var hasFlushed = false;
                    if (this.shouldFlush(3)) {
                        this.flush();
                        hasFlushed = true;
                        unit = this.setTexture2D(texture);
                    }
                    this.batchVert(x0, y0, u0, v0, unit, tintEffect, tintTL);
                    this.batchVert(x1, y1, u0, v1, unit, tintEffect, tintTR);
                    this.batchVert(x2, y2, u1, v1, unit, tintEffect, tintBL);
                    this.onBatch(gameObject);
                    return hasFlushed;
                },
                /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * The dimensions are run through `Math.floor` before the quad is generated.
     *
     * Rectangle has no transform values and isn't transformed into the local space.
     *
     * Used for directly batching untransformed rectangles, such as Camera background colors.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#drawFillRect
     * @since 3.50.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {number} color - Color of the rectangle to draw.
     * @param {number} alpha - Alpha value of the rectangle to draw.
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch if a flush occurs.
     * @param {boolean} [flipUV=true] - Flip the vertical UV coordinates of the texture before rendering?
     */ drawFillRect: function(x, y, width, height, color, alpha, texture, flipUV) {
                    if (texture === undefined) texture = this.renderer.whiteTexture.glTexture;
                    if (flipUV === undefined) flipUV = true;
                    x = Math.floor(x);
                    y = Math.floor(y);
                    var xw = Math.floor(x + width);
                    var yh = Math.floor(y + height);
                    var unit = this.setTexture2D(texture);
                    var tint = Utils.getTintAppendFloatAlphaAndSwap(color, alpha);
                    var u0 = 0;
                    var v0 = 0;
                    var u1 = 1;
                    var v1 = 1;
                    if (flipUV) {
                        v0 = 1;
                        v1 = 0;
                    }
                    this.batchQuad(null, x, y, x, yh, xw, yh, xw, y, u0, v0, u1, v1, tint, tint, tint, tint, 0, texture, unit);
                },
                /**
     * Sets the texture to be bound to the next available texture unit and returns
     * the unit id.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTexture2D
     * @since 3.50.0
     *
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch. If not given uses `whiteTexture`.
     *
     * @return {number} The assigned texture unit.
     */ setTexture2D: function(texture) {
                    if (texture === undefined) texture = this.renderer.whiteTexture.glTexture;
                    this.currentUnit = this.renderer.setTexture2D(texture);
                    return this.currentUnit;
                },
                /**
     * Activates the given WebGL Texture and binds it to the requested texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindTexture
     * @since 3.50.0
     *
     * @param {WebGLTexture} [target] - The WebGLTexture to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindTexture: function(texture, unit) {
                    if (unit === undefined) unit = 0;
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE0 + unit);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    return this;
                },
                /**
     * Activates the given Render Target texture and binds it to the
     * requested WebGL texture slot.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#bindRenderTarget
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to activate and bind.
     * @param {number} [unit=0] - The WebGL texture ID to activate. Defaults to `gl.TEXTURE0`.
     *
     * @return {this} This WebGL Pipeline instance.
     */ bindRenderTarget: function(target, unit) {
                    return this.bindTexture(target.texture, unit);
                },
                /**
     * Sets the current duration into a 1f uniform value based on the given name.
     *
     * This can be used for mapping time uniform values, such as `iTime`.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setTime
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     *
     * @return {this} This WebGLPipeline instance.
     */ setTime: function(uniform) {
                    this.set1f(uniform, this.game.loop.getDuration());
                    return this;
                },
                /**
     * Sets a 1f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1f: function(name, x, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1f(name, x);
                    return this;
                },
                /**
     * Sets a 2f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2f: function(name, x, y, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2f(name, x, y);
                    return this;
                },
                /**
     * Sets a 3f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3f: function(name, x, y, z, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3f(name, x, y, z);
                    return this;
                },
                /**
     * Sets a 4f uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4f: function(name, x, y, z, w, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4f(name, x, y, z, w);
                    return this;
                },
                /**
     * Sets a 1fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1fv(name, arr);
                    return this;
                },
                /**
     * Sets a 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2fv(name, arr);
                    return this;
                },
                /**
     * Sets a 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3fv(name, arr);
                    return this;
                },
                /**
     * Sets a 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4fv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4fv(name, arr);
                    return this;
                },
                /**
     * Sets a 1iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1iv(name, arr);
                    return this;
                },
                /**
     * Sets a 2iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2iv(name, arr);
                    return this;
                },
                /**
     * Sets a 3iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3iv(name, arr);
                    return this;
                },
                /**
     * Sets a 4iv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4iv: function(name, arr, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4iv(name, arr);
                    return this;
                },
                /**
     * Sets a 1i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set1i: function(name, x, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set1i(name, x);
                    return this;
                },
                /**
     * Sets a 2i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set2i: function(name, x, y, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set2i(name, x, y);
                    return this;
                },
                /**
     * Sets a 3i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set3i: function(name, x, y, z, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set3i(name, x, y, z);
                    return this;
                },
                /**
     * Sets a 4i uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform.
     * @param {number} y - Y component of the uniform.
     * @param {number} z - Z component of the uniform.
     * @param {number} w - W component of the uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ set4i: function(name, x, y, z, w, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.set4i(name, x, y, z, w);
                    return this;
                },
                /**
     * Sets a matrix 2fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix2fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix2fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Sets a matrix 3fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix3fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix3fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Sets a matrix 4fv uniform value based on the given name on the currently set shader.
     *
     * The current shader is bound, before the uniform is set, making it active within the
     * WebGLRenderer. This means you can safely call this method from a location such as
     * a Scene `create` or `update` method. However, when working within a Shader file
     * directly, use the `WebGLShader` method equivalent instead, to avoid the program
     * being set.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Should the matrix be transpose
     * @param {Float32Array} matrix - Matrix data
     * @param {Phaser.Renderer.WebGL.WebGLShader} [shader] - The shader to set the value on. If not given, the `currentShader` is used.
     *
     * @return {this} This WebGLPipeline instance.
     */ setMatrix4fv: function(name, transpose, matrix, shader) {
                    if (shader === undefined) shader = this.currentShader;
                    shader.setMatrix4fv(name, transpose, matrix);
                    return this;
                },
                /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.WebGLPipeline#destroy
     * @fires Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
     * @since 3.0.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                    this.emit(Events.DESTROY, this);
                    var i;
                    var shaders = this.shaders;
                    for(i = 0; i < shaders.length; i++)shaders[i].destroy();
                    var targets = this.renderTargets;
                    for(i = 0; i < targets.length; i++)targets[i].destroy();
                    this.gl.deleteBuffer(this.vertexBuffer);
                    var renderer = this.renderer;
                    renderer.off(RendererEvents.RESIZE, this.resize, this);
                    renderer.off(RendererEvents.PRE_RENDER, this.onPreRender, this);
                    renderer.off(RendererEvents.RENDER, this.onRender, this);
                    renderer.off(RendererEvents.POST_RENDER, this.onPostRender, this);
                    this.removeAllListeners();
                    this.game = null;
                    this.renderer = null;
                    this.manager = null;
                    this.gl = null;
                    this.view = null;
                    this.shaders = null;
                    this.renderTargets = null;
                    this.bytes = null;
                    this.vertexViewF32 = null;
                    this.vertexViewU32 = null;
                    this.vertexData = null;
                    this.vertexBuffer = null;
                    this.currentShader = null;
                    this.currentRenderTarget = null;
                    return this;
                }
            });
            module1.exports = WebGLPipeline;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the strokeStyle and lineWidth on the target context based on the given Shape.
 *
 * @method Phaser.GameObjects.Shape#LineStyleCanvas
 * @since 3.13.0
 * @private
 *
 * @param {CanvasRenderingContext2D} ctx - The context to set the stroke style on.
 * @param {Phaser.GameObjects.Shape} src - The Game Object to set the stroke style from.
 * @param {number} [altColor] - An alternative color to render with.
 * @param {number} [altAlpha] - An alternative alpha to render with.
 */ var LineStyleCanvas = function(ctx, src, altColor, altAlpha) {
                var strokeColor = altColor ? altColor : src.strokeColor;
                var strokeAlpha = altAlpha ? altAlpha : src.strokeAlpha;
                var red = (strokeColor & 0xFF0000) >>> 16;
                var green = (strokeColor & 0xFF00) >>> 8;
                var blue = strokeColor & 0xFF;
                ctx.strokeStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + strokeAlpha + ')';
                ctx.lineWidth = src.lineWidth;
            };
            module1.exports = LineStyleCanvas;
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#json method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#json.
 *
 * @class JSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var JSONFile = new Class({
                Extends: File,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function JSONFile(loader, key, url, xhrSettings, dataKey) {
                    var extension = 'json';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        dataKey = GetFastValue(config, 'dataKey', dataKey);
                    }
                    var fileConfig = {
                        type: 'json',
                        cache: loader.cacheManager.json,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: dataKey
                    };
                    File.call(this, loader, fileConfig);
                    if (IsPlainObject(url)) {
                        //  Object provided instead of a URL, so no need to actually load it (populate data with value)
                        if (dataKey) this.data = GetValue(url, dataKey);
                        else this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.JSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    if (this.state !== CONST.FILE_POPULATED) {
                        this.state = CONST.FILE_PROCESSING;
                        var json = JSON.parse(this.xhrLoader.responseText);
                        var key = this.config;
                        if (typeof key === 'string') this.data = GetValue(json, key, json);
                        else this.data = json;
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a JSON file, or array of JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.json('wavedata', 'files/AlienWaveData.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.json({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.json('wavedata', 'files/AlienWaveData.json');
 * // and later in your game ...
 * var data = this.cache.json.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#json
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(object|string)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, can be a fully formed JSON Object.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('json', function(key, url, dataKey, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new JSONFile(this, key[i]));
                else this.addFile(new JSONFile(this, key, url, xhrSettings, dataKey));
                return this;
            });
            module1.exports = JSONFile;
        /***/ },
        /* 60 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Arcade Physics consts.
 *
 * @ignore
 */ var CONST = {
                /**
     * Dynamic Body.
     *
     * @name Phaser.Physics.Arcade.DYNAMIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.Group#physicsType
     */ DYNAMIC_BODY: 0,
                /**
     * Static Body.
     *
     * @name Phaser.Physics.Arcade.STATIC_BODY
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#physicsType
     * @see Phaser.Physics.Arcade.StaticBody#physicsType
     */ STATIC_BODY: 1,
                /**
     * Arcade Physics Group containing Dynamic Bodies.
     *
     * @name Phaser.Physics.Arcade.GROUP
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ GROUP: 2,
                /**
     * A Tilemap Layer.
     *
     * @name Phaser.Physics.Arcade.TILEMAPLAYER
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ TILEMAPLAYER: 3,
                /**
     * Facing no direction (initial value).
     *
     * @name Phaser.Physics.Arcade.FACING_NONE
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_NONE: 10,
                /**
     * Facing up.
     *
     * @name Phaser.Physics.Arcade.FACING_UP
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_UP: 11,
                /**
     * Facing down.
     *
     * @name Phaser.Physics.Arcade.FACING_DOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_DOWN: 12,
                /**
     * Facing left.
     *
     * @name Phaser.Physics.Arcade.FACING_LEFT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_LEFT: 13,
                /**
     * Facing right.
     *
     * @name Phaser.Physics.Arcade.FACING_RIGHT
     * @readonly
     * @type {number}
     * @since 3.0.0
     *
     * @see Phaser.Physics.Arcade.Body#facing
     */ FACING_RIGHT: 14
            };
            module1.exports = CONST;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(156);
            var GetTilesWithin = __webpack_require__(26);
            /**
 * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
 * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
 * is mostly used internally.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesWithin
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesWithin = function(tileX, tileY, width, height, layer) {
                var above = null;
                var below = null;
                var left = null;
                var right = null;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    if (tile) {
                        if (tile.collides) {
                            above = GetTileAt(tile.x, tile.y - 1, true, layer);
                            below = GetTileAt(tile.x, tile.y + 1, true, layer);
                            left = GetTileAt(tile.x - 1, tile.y, true, layer);
                            right = GetTileAt(tile.x + 1, tile.y, true, layer);
                            tile.faceTop = above && above.collides ? false : true;
                            tile.faceBottom = below && below.collides ? false : true;
                            tile.faceLeft = left && left.collides ? false : true;
                            tile.faceRight = right && right.collides ? false : true;
                        } else tile.resetFaces();
                    }
                }
            };
            module1.exports = CalculateFacesWithin;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(63);
            var GetPoint = __webpack_require__(294);
            var GetPoints = __webpack_require__(295);
            var GEOM_CONST = __webpack_require__(55);
            var Random = __webpack_require__(166);
            /**
 * @classdesc
 * A Circle object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Circle you should look at the capabilities of the Graphics class.
 *
 * @class Circle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the circle.
 * @param {number} [y=0] - The y position of the center of the circle.
 * @param {number} [radius=0] - The radius of the circle.
 */ var Circle = new Class({
                initialize: function Circle(x, y, radius) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.CIRCLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Circle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.CIRCLE;
                    /**
         * The x position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of the center of the circle.
         *
         * @name Phaser.Geom.Circle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The internal radius of the circle.
         *
         * @name Phaser.Geom.Circle#_radius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._radius = radius;
                    /**
         * The internal diameter of the circle.
         *
         * @name Phaser.Geom.Circle#_diameter
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._diameter = radius * 2;
                },
                /**
     * Check to see if the Circle contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Circle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the circle.
     * @param {number} y - The y coordinate to check within the circle.
     *
     * @return {boolean} True if the coordinates are within the circle, otherwise false.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Circle
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Circle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
     */ getPoint: function(position, point) {
                    return GetPoint(this, position, point);
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Circle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the circle.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a uniformly distributed random point from anywhere within the Circle.
     *
     * @method Phaser.Geom.Circle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the x, y and radius of this circle.
     *
     * @method Phaser.Geom.Circle#setTo
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     * @param {number} [radius=0] - The radius of the circle.
     *
     * @return {this} This Circle object.
     */ setTo: function(x, y, radius) {
                    this.x = x;
                    this.y = y;
                    this._radius = radius;
                    this._diameter = radius * 2;
                    return this;
                },
                /**
     * Sets this Circle to be empty with a radius of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Circle#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Circle object.
     */ setEmpty: function() {
                    this._radius = 0;
                    this._diameter = 0;
                    return this;
                },
                /**
     * Sets the position of this Circle.
     *
     * @method Phaser.Geom.Circle#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of the center of the circle.
     * @param {number} [y=0] - The y position of the center of the circle.
     *
     * @return {this} This Circle object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Checks to see if the Circle is empty: has a radius of zero.
     *
     * @method Phaser.Geom.Circle#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Circle is empty, otherwise false.
     */ isEmpty: function() {
                    return this._radius <= 0;
                },
                /**
     * The radius of the Circle.
     *
     * @name Phaser.Geom.Circle#radius
     * @type {number}
     * @since 3.0.0
     */ radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(value) {
                        this._radius = value;
                        this._diameter = value * 2;
                    }
                },
                /**
     * The diameter of the Circle.
     *
     * @name Phaser.Geom.Circle#diameter
     * @type {number}
     * @since 3.0.0
     */ diameter: {
                    get: function() {
                        return this._diameter;
                    },
                    set: function(value) {
                        this._diameter = value;
                        this._radius = value * 0.5;
                    }
                },
                /**
     * The left position of the Circle.
     *
     * @name Phaser.Geom.Circle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x - this._radius;
                    },
                    set: function(value) {
                        this.x = value + this._radius;
                    }
                },
                /**
     * The right position of the Circle.
     *
     * @name Phaser.Geom.Circle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this._radius;
                    },
                    set: function(value) {
                        this.x = value - this._radius;
                    }
                },
                /**
     * The top position of the Circle.
     *
     * @name Phaser.Geom.Circle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y - this._radius;
                    },
                    set: function(value) {
                        this.y = value + this._radius;
                    }
                },
                /**
     * The bottom position of the Circle.
     *
     * @name Phaser.Geom.Circle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this._radius;
                    },
                    set: function(value) {
                        this.y = value - this._radius;
                    }
                }
            });
            module1.exports = Circle;
        /***/ },
        /* 63 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Circle contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Circle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {number} x - The x coordinate to check within the circle.
 * @param {number} y - The y coordinate to check within the circle.
 *
 * @return {boolean} True if the coordinates are within the circle, otherwise false.
 */ var Contains = function(circle, x, y) {
                //  Check if x/y are within the bounds first
                if (circle.radius > 0 && x >= circle.left && x <= circle.right && y >= circle.top && y <= circle.bottom) {
                    var dx = (circle.x - x) * (circle.x - x);
                    var dy = (circle.y - y) * (circle.y - y);
                    return dx + dy <= circle.radius * circle.radius;
                } else return false;
            };
            module1.exports = Contains;
        /***/ },
        /* 64 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the length of the given line.
 *
 * @function Phaser.Geom.Line.Length
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the length of.
 *
 * @return {number} The length of the line.
 */ var Length = function(line) {
                return Math.sqrt((line.x2 - line.x1) * (line.x2 - line.x1) + (line.y2 - line.y1) * (line.y2 - line.y1));
            };
            module1.exports = Length;
        /***/ },
        /* 65 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PIPELINE_CONST = {
                /**
     * The Bitmap Mask Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.BITMAPMASK_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ BITMAPMASK_PIPELINE: 'BitmapMaskPipeline',
                /**
     * The Light 2D Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.LIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ LIGHT_PIPELINE: 'Light2D',
                /**
     * The Point Light Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POINTLIGHT_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POINTLIGHT_PIPELINE: 'PointLightPipeline',
                /**
     * The Single Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.SINGLE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ SINGLE_PIPELINE: 'SinglePipeline',
                /**
     * The Multi Texture Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.MULTI_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ MULTI_PIPELINE: 'MultiPipeline',
                /**
     * The Rope Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.ROPE_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ ROPE_PIPELINE: 'RopePipeline',
                /**
     * The Graphics and Shapes Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.GRAPHICS_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ GRAPHICS_PIPELINE: 'GraphicsPipeline',
                /**
     * The Post FX Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.POSTFX_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ POSTFX_PIPELINE: 'PostFXPipeline',
                /**
     * The Utility Pipeline.
     *
     * @name Phaser.Renderer.WebGL.Pipelines.UTILITY_PIPELINE
     * @type {string}
     * @const
     * @since 3.50.0
     */ UTILITY_PIPELINE: 'UtilityPipeline'
            };
            module1.exports = PIPELINE_CONST;
        /***/ },
        /* 66 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Wrap the given `value` between `min` and `max.
 *
 * @function Phaser.Math.Wrap
 * @since 3.0.0
 *
 * @param {number} value - The value to wrap.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The wrapped value.
 */ var Wrap = function(value, min, max) {
                var range = max - min;
                return min + ((value - min) % range + range) % range;
            };
            module1.exports = Wrap;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector3 = __webpack_require__(38);
            /**
 * @ignore
 */ var EPSILON = 0.000001;
            /**
 * @classdesc
 * A four-dimensional matrix.
 *
 * Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
 * and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
 *
 * @class Matrix4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix4} [m] - Optional Matrix4 to copy values from.
 */ var Matrix4 = new Class({
                initialize: function Matrix4(m) {
                    /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix4#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(16);
                    if (m) //  Assume Matrix4 with val:
                    this.copy(m);
                    else //  Default to identity
                    this.identity();
                },
                /**
     * Make a clone of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} A clone of this Matrix4.
     */ clone: function() {
                    return new Matrix4(this);
                },
                /**
     * This method is an alias for `Matrix4.copy`.
     *
     * @method Phaser.Math.Matrix4#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {this} This Matrix4.
     */ set: function(src) {
                    return this.copy(src);
                },
                /**
     * Sets all values of this Matrix4.
     *
     * @method Phaser.Math.Matrix4#setValues
     * @since 3.50.0
     *
     * @param {number} m00 - The m00 value.
     * @param {number} m01 - The m01 value.
     * @param {number} m02 - The m02 value.
     * @param {number} m03 - The m03 value.
     * @param {number} m10 - The m10 value.
     * @param {number} m11 - The m11 value.
     * @param {number} m12 - The m12 value.
     * @param {number} m13 - The m13 value.
     * @param {number} m20 - The m20 value.
     * @param {number} m21 - The m21 value.
     * @param {number} m22 - The m22 value.
     * @param {number} m23 - The m23 value.
     * @param {number} m30 - The m30 value.
     * @param {number} m31 - The m31 value.
     * @param {number} m32 - The m32 value.
     * @param {number} m33 - The m33 value.
     *
     * @return {this} This Matrix4 instance.
     */ setValues: function(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
                    var out = this.val;
                    out[0] = m00;
                    out[1] = m01;
                    out[2] = m02;
                    out[3] = m03;
                    out[4] = m10;
                    out[5] = m11;
                    out[6] = m12;
                    out[7] = m13;
                    out[8] = m20;
                    out[9] = m21;
                    out[10] = m22;
                    out[11] = m23;
                    out[12] = m30;
                    out[13] = m31;
                    out[14] = m32;
                    out[15] = m33;
                    return this;
                },
                /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to copy the values from.
     *
     * @return {this} This Matrix4.
     */ copy: function(src) {
                    var a = src.val;
                    return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                },
                /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix4#fromArray
     * @since 3.0.0
     *
     * @param {number[]} a - The array to copy the values from. Must have at least 16 elements.
     *
     * @return {this} This Matrix4.
     */ fromArray: function(a) {
                    return this.setValues(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
                },
                /**
     * Reset this Matrix.
     *
     * Sets all values to `0`.
     *
     * @method Phaser.Math.Matrix4#zero
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix4} This Matrix4.
     */ zero: function() {
                    return this.setValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                },
                /**
     * Generates a transform matrix based on the given position, scale and rotation.
     *
     * @method Phaser.Math.Matrix4#transform
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {Phaser.Math.Vector3} scale - The scale vector.
     * @param {Phaser.Math.Quaternion} rotation - The rotation quaternion.
     *
     * @return {this} This Matrix4.
     */ transform: function(position, scale, rotation) {
                    var rotMatrix = _tempMat1.fromQuat(rotation);
                    var rm = rotMatrix.val;
                    var sx = scale.x;
                    var sy = scale.y;
                    var sz = scale.z;
                    return this.setValues(rm[0] * sx, rm[1] * sx, rm[2] * sx, 0, rm[4] * sy, rm[5] * sy, rm[6] * sy, 0, rm[8] * sz, rm[9] * sz, rm[10] * sz, 0, position.x, position.y, position.z, 1);
                },
                /**
     * Set the `x`, `y` and `z` values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#xyz
     * @since 3.0.0
     *
     * @param {number} x - The x value.
     * @param {number} y - The y value.
     * @param {number} z - The z value.
     *
     * @return {this} This Matrix4.
     */ xyz: function(x, y, z) {
                    this.identity();
                    var out = this.val;
                    out[12] = x;
                    out[13] = y;
                    out[14] = z;
                    return this;
                },
                /**
     * Set the scaling values of this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaling
     * @since 3.0.0
     *
     * @param {number} x - The x scaling value.
     * @param {number} y - The y scaling value.
     * @param {number} z - The z scaling value.
     *
     * @return {this} This Matrix4.
     */ scaling: function(x, y, z) {
                    this.zero();
                    var out = this.val;
                    out[0] = x;
                    out[5] = y;
                    out[10] = z;
                    out[15] = 1;
                    return this;
                },
                /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix4#identity
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ identity: function() {
                    return this.setValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                },
                /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix4#transpose
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ transpose: function() {
                    var a = this.val;
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a23 = a[11];
                    a[1] = a[4];
                    a[2] = a[8];
                    a[3] = a[12];
                    a[4] = a01;
                    a[6] = a[9];
                    a[7] = a[13];
                    a[8] = a02;
                    a[9] = a12;
                    a[11] = a[14];
                    a[12] = a03;
                    a[13] = a13;
                    a[14] = a23;
                    return this;
                },
                /**
     * Copies the given Matrix4 into this Matrix and then inverses it.
     *
     * @method Phaser.Math.Matrix4#getInverse
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to invert into this Matrix4.
     *
     * @return {this} This Matrix4.
     */ getInverse: function(m) {
                    this.copy(m);
                    return this.invert();
                },
                /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix4#invert
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ invert: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    //  Calculate the determinant
                    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    if (!det) return this;
                    det = 1 / det;
                    return this.setValues((a11 * b11 - a12 * b10 + a13 * b09) * det, (a02 * b10 - a01 * b11 - a03 * b09) * det, (a31 * b05 - a32 * b04 + a33 * b03) * det, (a22 * b04 - a21 * b05 - a23 * b03) * det, (a12 * b08 - a10 * b11 - a13 * b07) * det, (a00 * b11 - a02 * b08 + a03 * b07) * det, (a32 * b02 - a30 * b05 - a33 * b01) * det, (a20 * b05 - a22 * b02 + a23 * b01) * det, (a10 * b10 - a11 * b08 + a13 * b06) * det, (a01 * b08 - a00 * b10 - a03 * b06) * det, (a30 * b04 - a31 * b02 + a33 * b00) * det, (a21 * b02 - a20 * b04 - a23 * b00) * det, (a11 * b07 - a10 * b09 - a12 * b06) * det, (a00 * b09 - a01 * b07 + a02 * b06) * det, (a31 * b01 - a30 * b03 - a32 * b00) * det, (a20 * b03 - a21 * b01 + a22 * b00) * det);
                },
                /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix4#adjoint
     * @since 3.0.0
     *
     * @return {this} This Matrix4.
     */ adjoint: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    return this.setValues(a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22), -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22)), a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12), -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12)), -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22)), a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22), -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12)), a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12), a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21), -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21)), a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11), -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11)), -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21)), a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21), -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11)), a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
                },
                /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix4#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    // Calculate the determinant
                    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix4#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix to multiply this Matrix by.
     *
     * @return {this} This Matrix4.
     */ multiply: function(src) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b = src.val;
                    // Cache only the current line of the second matrix
                    var b0 = b[0];
                    var b1 = b[1];
                    var b2 = b[2];
                    var b3 = b[3];
                    a[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[4];
                    b1 = b[5];
                    b2 = b[6];
                    b3 = b[7];
                    a[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[8];
                    b1 = b[9];
                    b2 = b[10];
                    b3 = b[11];
                    a[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    b0 = b[12];
                    b1 = b[13];
                    b2 = b[14];
                    b3 = b[15];
                    a[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
                    a[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
                    a[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
                    a[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
                    return this;
                },
                /**
     * Multiply the values of this Matrix4 by those given in the `src` argument.
     *
     * @method Phaser.Math.Matrix4#multiplyLocal
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} src - The source Matrix4 that this Matrix4 is multiplied by.
     *
     * @return {this} This Matrix4.
     */ multiplyLocal: function(src) {
                    var a = this.val;
                    var b = src.val;
                    return this.setValues(a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12], a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13], a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14], a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15], a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12], a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13], a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14], a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15], a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12], a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13], a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14], a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15], a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12], a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13], a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14], a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15]);
                },
                /**
     * Multiplies the given Matrix4 object with this Matrix.
     *
     * This is the same as calling `multiplyMatrices(m, this)`.
     *
     * @method Phaser.Math.Matrix4#premultiply
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to multiply with this one.
     *
     * @return {this} This Matrix4.
     */ premultiply: function(m) {
                    return this.multiplyMatrices(m, this);
                },
                /**
     * Multiplies the two given Matrix4 objects and stores the results in this Matrix.
     *
     * @method Phaser.Math.Matrix4#multiplyMatrices
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} a - The first Matrix4 to multiply.
     * @param {Phaser.Math.Matrix4} b - The second Matrix4 to multiply.
     *
     * @return {this} This Matrix4.
     */ multiplyMatrices: function(a, b) {
                    var am = a.val;
                    var bm = b.val;
                    var a11 = am[0];
                    var a12 = am[4];
                    var a13 = am[8];
                    var a14 = am[12];
                    var a21 = am[1];
                    var a22 = am[5];
                    var a23 = am[9];
                    var a24 = am[13];
                    var a31 = am[2];
                    var a32 = am[6];
                    var a33 = am[10];
                    var a34 = am[14];
                    var a41 = am[3];
                    var a42 = am[7];
                    var a43 = am[11];
                    var a44 = am[15];
                    var b11 = bm[0];
                    var b12 = bm[4];
                    var b13 = bm[8];
                    var b14 = bm[12];
                    var b21 = bm[1];
                    var b22 = bm[5];
                    var b23 = bm[9];
                    var b24 = bm[13];
                    var b31 = bm[2];
                    var b32 = bm[6];
                    var b33 = bm[10];
                    var b34 = bm[14];
                    var b41 = bm[3];
                    var b42 = bm[7];
                    var b43 = bm[11];
                    var b44 = bm[15];
                    return this.setValues(a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41, a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41, a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41, a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41, a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42, a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42, a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42, a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42, a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43, a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43, a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43, a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43, a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44, a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44, a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44, a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44);
                },
                /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix4#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {this} This Matrix4.
     */ translate: function(v) {
                    return this.translateXYZ(v.x, v.y, v.z);
                },
                /**
     * Translate this Matrix using the given values.
     *
     * @method Phaser.Math.Matrix4#translateXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ translateXYZ: function(x, y, z) {
                    var a = this.val;
                    a[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
                    a[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
                    a[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
                    a[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
                    return this;
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x`, `y` and `z` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix4#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {this} This Matrix4.
     */ scale: function(v) {
                    return this.scaleXYZ(v.x, v.y, v.z);
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#scaleXYZ
     * @since 3.16.0
     *
     * @param {number} x - The x component.
     * @param {number} y - The y component.
     * @param {number} z - The z component.
     *
     * @return {this} This Matrix4.
     */ scaleXYZ: function(x, y, z) {
                    var a = this.val;
                    a[0] = a[0] * x;
                    a[1] = a[1] * x;
                    a[2] = a[2] * x;
                    a[3] = a[3] * x;
                    a[4] = a[4] * y;
                    a[5] = a[5] * y;
                    a[6] = a[6] * y;
                    a[7] = a[7] * y;
                    a[8] = a[8] * z;
                    a[9] = a[9] * z;
                    a[10] = a[10] * z;
                    a[11] = a[11] * z;
                    return this;
                },
                /**
     * Derive a rotation matrix around the given axis.
     *
     * @method Phaser.Math.Matrix4#makeRotationAxis
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} axis - The rotation axis.
     * @param {number} angle - The rotation angle in radians.
     *
     * @return {this} This Matrix4.
     */ makeRotationAxis: function(axis, angle) {
                    // Based on http://www.gamedev.net/reference/articles/article1199.asp
                    var c = Math.cos(angle);
                    var s = Math.sin(angle);
                    var t = 1 - c;
                    var x = axis.x;
                    var y = axis.y;
                    var z = axis.z;
                    var tx = t * x;
                    var ty = t * y;
                    return this.setValues(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                },
                /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix4#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     * @param {Phaser.Math.Vector3} axis - The axis to rotate upon.
     *
     * @return {this} This Matrix4.
     */ rotate: function(rad, axis) {
                    var a = this.val;
                    var x = axis.x;
                    var y = axis.y;
                    var z = axis.z;
                    var len = Math.sqrt(x * x + y * y + z * z);
                    if (Math.abs(len) < EPSILON) return this;
                    len = 1 / len;
                    x *= len;
                    y *= len;
                    z *= len;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var t = 1 - c;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    //  Construct the elements of the rotation matrix
                    var b00 = x * x * t + c;
                    var b01 = y * x * t + z * s;
                    var b02 = z * x * t - y * s;
                    var b10 = x * y * t - z * s;
                    var b11 = y * y * t + c;
                    var b12 = z * y * t + x * s;
                    var b20 = x * z * t + y * s;
                    var b21 = y * z * t - x * s;
                    var b22 = z * z * t + c;
                    //  Perform rotation-specific matrix multiplication
                    return this.setValues(a00 * b00 + a10 * b01 + a20 * b02, a01 * b00 + a11 * b01 + a21 * b02, a02 * b00 + a12 * b01 + a22 * b02, a03 * b00 + a13 * b01 + a23 * b02, a00 * b10 + a10 * b11 + a20 * b12, a01 * b10 + a11 * b11 + a21 * b12, a02 * b10 + a12 * b11 + a22 * b12, a03 * b10 + a13 * b11 + a23 * b12, a00 * b20 + a10 * b21 + a20 * b22, a01 * b20 + a11 * b21 + a21 * b22, a02 * b20 + a12 * b21 + a22 * b22, a03 * b20 + a13 * b21 + a23 * b22, a30, a31, a32, a33);
                },
                /**
     * Rotate this matrix on its X axis.
     *
     * @method Phaser.Math.Matrix4#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {this} This Matrix4.
     */ rotateX: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    //  Perform axis-specific matrix multiplication
                    a[4] = a10 * c + a20 * s;
                    a[5] = a11 * c + a21 * s;
                    a[6] = a12 * c + a22 * s;
                    a[7] = a13 * c + a23 * s;
                    a[8] = a20 * c - a10 * s;
                    a[9] = a21 * c - a11 * s;
                    a[10] = a22 * c - a12 * s;
                    a[11] = a23 * c - a13 * s;
                    return this;
                },
                /**
     * Rotate this matrix on its Y axis.
     *
     * @method Phaser.Math.Matrix4#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateY: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    //  Perform axis-specific matrix multiplication
                    a[0] = a00 * c - a20 * s;
                    a[1] = a01 * c - a21 * s;
                    a[2] = a02 * c - a22 * s;
                    a[3] = a03 * c - a23 * s;
                    a[8] = a00 * s + a20 * c;
                    a[9] = a01 * s + a21 * c;
                    a[10] = a02 * s + a22 * c;
                    a[11] = a03 * s + a23 * c;
                    return this;
                },
                /**
     * Rotate this matrix on its Z axis.
     *
     * @method Phaser.Math.Matrix4#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The angle to rotate by, in radians.
     *
     * @return {this} This Matrix4.
     */ rotateZ: function(rad) {
                    var a = this.val;
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    //  Perform axis-specific matrix multiplication
                    a[0] = a00 * c + a10 * s;
                    a[1] = a01 * c + a11 * s;
                    a[2] = a02 * c + a12 * s;
                    a[3] = a03 * c + a13 * s;
                    a[4] = a10 * c - a00 * s;
                    a[5] = a11 * c - a01 * s;
                    a[6] = a12 * c - a02 * s;
                    a[7] = a13 * c - a03 * s;
                    return this;
                },
                /**
     * Set the values of this Matrix from the given rotation Quaternion and translation Vector.
     *
     * @method Phaser.Math.Matrix4#fromRotationTranslation
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set rotation from.
     * @param {Phaser.Math.Vector3} v - The Vector to set translation from.
     *
     * @return {this} This Matrix4.
     */ fromRotationTranslation: function(q, v) {
                    //  Quaternion math
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, v.x, v.y, v.z, 1);
                },
                /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix4#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {this} This Matrix4.
     */ fromQuat: function(q) {
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    return this.setValues(1 - (yy + zz), xy + wz, xz - wy, 0, xy - wz, 1 - (xx + zz), yz + wx, 0, xz + wy, yz - wx, 1 - (xx + yy), 0, 0, 0, 0, 1);
                },
                /**
     * Generate a frustum matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#frustum
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ frustum: function(left, right, bottom, top, near, far) {
                    var rl = 1 / (right - left);
                    var tb = 1 / (top - bottom);
                    var nf = 1 / (near - far);
                    return this.setValues(near * 2 * rl, 0, 0, 0, 0, near * 2 * tb, 0, 0, (right + left) * rl, (top + bottom) * tb, (far + near) * nf, -1, 0, 0, far * near * 2 * nf, 0);
                },
                /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspective
     * @since 3.0.0
     *
     * @param {number} fovy - Vertical field of view in radians
     * @param {number} aspect - Aspect ratio. Typically viewport width  /height.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspective: function(fovy, aspect, near, far) {
                    var f = 1.0 / Math.tan(fovy / 2);
                    var nf = 1 / (near - far);
                    return this.setValues(f / aspect, 0, 0, 0, 0, f, 0, 0, 0, 0, (far + near) * nf, -1, 0, 0, 2 * far * near * nf, 0);
                },
                /**
     * Generate a perspective projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#perspectiveLH
     * @since 3.0.0
     *
     * @param {number} width - The width of the frustum.
     * @param {number} height - The height of the frustum.
     * @param {number} near - Near bound of the frustum.
     * @param {number} far - Far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ perspectiveLH: function(width, height, near, far) {
                    return this.setValues(2 * near / width, 0, 0, 0, 0, 2 * near / height, 0, 0, 0, 0, -far / (near - far), 1, 0, 0, near * far / (near - far), 0);
                },
                /**
     * Generate an orthogonal projection matrix with the given bounds.
     *
     * @method Phaser.Math.Matrix4#ortho
     * @since 3.0.0
     *
     * @param {number} left - The left bound of the frustum.
     * @param {number} right - The right bound of the frustum.
     * @param {number} bottom - The bottom bound of the frustum.
     * @param {number} top - The top bound of the frustum.
     * @param {number} near - The near bound of the frustum.
     * @param {number} far - The far bound of the frustum.
     *
     * @return {this} This Matrix4.
     */ ortho: function(left, right, bottom, top, near, far) {
                    var lr = left - right;
                    var bt = bottom - top;
                    var nf = near - far;
                    //  Avoid division by zero
                    lr = lr === 0 ? lr : 1 / lr;
                    bt = bt === 0 ? bt : 1 / bt;
                    nf = nf === 0 ? nf : 1 / nf;
                    return this.setValues(-2 * lr, 0, 0, 0, 0, -2 * bt, 0, 0, 0, 0, 2 * nf, 0, (left + right) * lr, (top + bottom) * bt, (far + near) * nf, 1);
                },
                /**
     * Generate a right-handed look-at matrix with the given eye position, target and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAtRH
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer.
     * @param {Phaser.Math.Vector3} target - Point the viewer is looking at.
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAtRH: function(eye, target, up) {
                    var m = this.val;
                    _z.subVectors(eye, target);
                    if (_z.getLengthSquared() === 0) // eye and target are in the same position
                    _z.z = 1;
                    _z.normalize();
                    _x.crossVectors(up, _z);
                    if (_x.getLengthSquared() === 0) {
                        // up and z are parallel
                        if (Math.abs(up.z) === 1) _z.x += 0.0001;
                        else _z.z += 0.0001;
                        _z.normalize();
                        _x.crossVectors(up, _z);
                    }
                    _x.normalize();
                    _y.crossVectors(_z, _x);
                    m[0] = _x.x;
                    m[1] = _x.y;
                    m[2] = _x.z;
                    m[4] = _y.x;
                    m[5] = _y.y;
                    m[6] = _y.z;
                    m[8] = _z.x;
                    m[9] = _z.y;
                    m[10] = _z.z;
                    return this;
                },
                /**
     * Generate a look-at matrix with the given eye position, focal point, and up axis.
     *
     * @method Phaser.Math.Matrix4#lookAt
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} eye - Position of the viewer
     * @param {Phaser.Math.Vector3} center - Point the viewer is looking at
     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
     *
     * @return {this} This Matrix4.
     */ lookAt: function(eye, center, up) {
                    var eyex = eye.x;
                    var eyey = eye.y;
                    var eyez = eye.z;
                    var upx = up.x;
                    var upy = up.y;
                    var upz = up.z;
                    var centerx = center.x;
                    var centery = center.y;
                    var centerz = center.z;
                    if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) return this.identity();
                    var z0 = eyex - centerx;
                    var z1 = eyey - centery;
                    var z2 = eyez - centerz;
                    var len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
                    z0 *= len;
                    z1 *= len;
                    z2 *= len;
                    var x0 = upy * z2 - upz * z1;
                    var x1 = upz * z0 - upx * z2;
                    var x2 = upx * z1 - upy * z0;
                    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
                    if (!len) {
                        x0 = 0;
                        x1 = 0;
                        x2 = 0;
                    } else {
                        len = 1 / len;
                        x0 *= len;
                        x1 *= len;
                        x2 *= len;
                    }
                    var y0 = z1 * x2 - z2 * x1;
                    var y1 = z2 * x0 - z0 * x2;
                    var y2 = z0 * x1 - z1 * x0;
                    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
                    if (!len) {
                        y0 = 0;
                        y1 = 0;
                        y2 = 0;
                    } else {
                        len = 1 / len;
                        y0 *= len;
                        y1 *= len;
                        y2 *= len;
                    }
                    return this.setValues(x0, y0, z0, 0, x1, y1, z1, 0, x2, y2, z2, 0, -(x0 * eyex + x1 * eyey + x2 * eyez), -(y0 * eyex + y1 * eyey + y2 * eyez), -(z0 * eyex + z1 * eyey + z2 * eyez), 1);
                },
                /**
     * Set the values of this matrix from the given `yaw`, `pitch` and `roll` values.
     *
     * @method Phaser.Math.Matrix4#yawPitchRoll
     * @since 3.0.0
     *
     * @param {number} yaw - The yaw value.
     * @param {number} pitch - The pitch value.
     * @param {number} roll - The roll value.
     *
     * @return {this} This Matrix4.
     */ yawPitchRoll: function(yaw, pitch, roll) {
                    this.zero();
                    _tempMat1.zero();
                    _tempMat2.zero();
                    var m0 = this.val;
                    var m1 = _tempMat1.val;
                    var m2 = _tempMat2.val;
                    //  Rotate Z
                    var s = Math.sin(roll);
                    var c = Math.cos(roll);
                    m0[10] = 1;
                    m0[15] = 1;
                    m0[0] = c;
                    m0[1] = s;
                    m0[4] = -s;
                    m0[5] = c;
                    //  Rotate X
                    s = Math.sin(pitch);
                    c = Math.cos(pitch);
                    m1[0] = 1;
                    m1[15] = 1;
                    m1[5] = c;
                    m1[10] = c;
                    m1[9] = -s;
                    m1[6] = s;
                    //  Rotate Y
                    s = Math.sin(yaw);
                    c = Math.cos(yaw);
                    m2[5] = 1;
                    m2[15] = 1;
                    m2[0] = c;
                    m2[2] = -s;
                    m2[8] = s;
                    m2[10] = c;
                    this.multiplyLocal(_tempMat1);
                    this.multiplyLocal(_tempMat2);
                    return this;
                },
                /**
     * Generate a world matrix from the given rotation, position, scale, view matrix and projection matrix.
     *
     * @method Phaser.Math.Matrix4#setWorldMatrix
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation of the world matrix.
     * @param {Phaser.Math.Vector3} position - The position of the world matrix.
     * @param {Phaser.Math.Vector3} scale - The scale of the world matrix.
     * @param {Phaser.Math.Matrix4} [viewMatrix] - The view matrix.
     * @param {Phaser.Math.Matrix4} [projectionMatrix] - The projection matrix.
     *
     * @return {this} This Matrix4.
     */ setWorldMatrix: function(rotation, position, scale, viewMatrix, projectionMatrix) {
                    this.yawPitchRoll(rotation.y, rotation.x, rotation.z);
                    _tempMat1.scaling(scale.x, scale.y, scale.z);
                    _tempMat2.xyz(position.x, position.y, position.z);
                    this.multiplyLocal(_tempMat1);
                    this.multiplyLocal(_tempMat2);
                    if (viewMatrix) this.multiplyLocal(viewMatrix);
                    if (projectionMatrix) this.multiplyLocal(projectionMatrix);
                    return this;
                },
                /**
     * Multiplies this Matrix4 by the given `src` Matrix4 and stores the results in the `out` Matrix4.
     *
     * @method Phaser.Math.Matrix4#multiplyToMat4
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} src - The Matrix4 to multiply with this one.
     * @param {Phaser.Math.Matrix4} out - The receiving Matrix.
     *
     * @return {Phaser.Math.Matrix4} This `out` Matrix4.
     */ multiplyToMat4: function(src, out) {
                    var a = this.val;
                    var b = src.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = b[0];
                    var b01 = b[1];
                    var b02 = b[2];
                    var b03 = b[3];
                    var b10 = b[4];
                    var b11 = b[5];
                    var b12 = b[6];
                    var b13 = b[7];
                    var b20 = b[8];
                    var b21 = b[9];
                    var b22 = b[10];
                    var b23 = b[11];
                    var b30 = b[12];
                    var b31 = b[13];
                    var b32 = b[14];
                    var b33 = b[15];
                    return out.setValues(b00 * a00 + b01 * a10 + b02 * a20 + b03 * a30, b01 * a01 + b01 * a11 + b02 * a21 + b03 * a31, b02 * a02 + b01 * a12 + b02 * a22 + b03 * a32, b03 * a03 + b01 * a13 + b02 * a23 + b03 * a33, b10 * a00 + b11 * a10 + b12 * a20 + b13 * a30, b10 * a01 + b11 * a11 + b12 * a21 + b13 * a31, b10 * a02 + b11 * a12 + b12 * a22 + b13 * a32, b10 * a03 + b11 * a13 + b12 * a23 + b13 * a33, b20 * a00 + b21 * a10 + b22 * a20 + b23 * a30, b20 * a01 + b21 * a11 + b22 * a21 + b23 * a31, b20 * a02 + b21 * a12 + b22 * a22 + b23 * a32, b20 * a03 + b21 * a13 + b22 * a23 + b23 * a33, b30 * a00 + b31 * a10 + b32 * a20 + b33 * a30, b30 * a01 + b31 * a11 + b32 * a21 + b33 * a31, b30 * a02 + b31 * a12 + b32 * a22 + b33 * a32, b30 * a03 + b31 * a13 + b32 * a23 + b33 * a33);
                },
                /**
     * Takes the rotation and position vectors and builds this Matrix4 from them.
     *
     * @method Phaser.Math.Matrix4#fromRotationXYTranslation
     * @since 3.50.0
     *
     * @param {Phaser.Math.Vector3} rotation - The rotation vector.
     * @param {Phaser.Math.Vector3} position - The position vector.
     * @param {boolean} translateFirst - Should the operation translate then rotate (`true`), or rotate then translate? (`false`)
     *
     * @return {this} This Matrix4.
     */ fromRotationXYTranslation: function(rotation, position, translateFirst) {
                    var x = position.x;
                    var y = position.y;
                    var z = position.z;
                    var sx = Math.sin(rotation.x);
                    var cx = Math.cos(rotation.x);
                    var sy = Math.sin(rotation.y);
                    var cy = Math.cos(rotation.y);
                    var a30 = x;
                    var a31 = y;
                    var a32 = z;
                    //  Rotate X
                    var b21 = -sx;
                    //  Rotate Y
                    var c01 = 0 - b21 * sy;
                    var c02 = 0 - cx * sy;
                    var c21 = b21 * cy;
                    var c22 = cx * cy;
                    //  Translate
                    if (!translateFirst) {
                        // a30 = cy * x + 0 * y + sy * z;
                        a30 = cy * x + sy * z;
                        a31 = c01 * x + cx * y + c21 * z;
                        a32 = c02 * x + sx * y + c22 * z;
                    }
                    return this.setValues(cy, c01, c02, 0, 0, cx, sx, 0, sy, c21, c22, 0, a30, a31, a32, 1);
                },
                /**
     * Returns the maximum axis scale from this Matrix4.
     *
     * @method Phaser.Math.Matrix4#getMaxScaleOnAxis
     * @since 3.50.0
     *
     * @return {number} The maximum axis scale.
     */ getMaxScaleOnAxis: function() {
                    var m = this.val;
                    var scaleXSq = m[0] * m[0] + m[1] * m[1] + m[2] * m[2];
                    var scaleYSq = m[4] * m[4] + m[5] * m[5] + m[6] * m[6];
                    var scaleZSq = m[8] * m[8] + m[9] * m[9] + m[10] * m[10];
                    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
                }
            });
            /**
 * @ignore
 */ var _tempMat1 = new Matrix4();
            /**
 * @ignore
 */ var _tempMat2 = new Matrix4();
            /**
 * @ignore
 */ var _x = new Vector3();
            /**
 * @ignore
 */ var _y = new Vector3();
            /**
 * @ignore
 */ var _z = new Vector3();
            module1.exports = Matrix4;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This module implements a modified ear slicing algorithm, optimized by z-order curve hashing and extended to
 * handle holes, twisted polygons, degeneracies and self-intersections in a way that doesn't guarantee correctness
 * of triangulation, but attempts to always produce acceptable results for practical data.
 *
 * Example:
 *
 * ```javascript
 * const triangles = Phaser.Geom.Polygon.Earcut([10,0, 0,50, 60,60, 70,10]); // returns [1,0,3, 3,2,1]
 * ```
 *
 * Each group of three vertex indices in the resulting array forms a triangle.
 *
 * ```javascript
 * // triangulating a polygon with a hole
 * earcut([0,0, 100,0, 100,100, 0,100,  20,20, 80,20, 80,80, 20,80], [4]);
 * // [3,0,4, 5,4,0, 3,4,7, 5,0,1, 2,3,7, 6,5,1, 2,7,6, 6,1,2]
 *
 * // triangulating a polygon with 3d coords
 * earcut([10,0,1, 0,50,2, 60,60,3, 70,10,4], null, 3);
 * // [1,0,3, 3,2,1]
 * ```
 *
 * If you pass a single vertex as a hole, Earcut treats it as a Steiner point.
 *
 * If your input is a multi-dimensional array (e.g. GeoJSON Polygon), you can convert it to the format
 * expected by Earcut with `Phaser.Geom.Polygon.Earcut.flatten`:
 *
 * ```javascript
 * var data = earcut.flatten(geojson.geometry.coordinates);
 * var triangles = earcut(data.vertices, data.holes, data.dimensions);
 * ```
 *
 * After getting a triangulation, you can verify its correctness with `Phaser.Geom.Polygon.Earcut.deviation`:
 *
 * ```javascript
 * var deviation = earcut.deviation(vertices, holes, dimensions, triangles);
 * ```
 * Returns the relative difference between the total area of triangles and the area of the input polygon.
 * 0 means the triangulation is fully correct.
 *
 * For more information see https://github.com/mapbox/earcut
 *
 * @function Phaser.Geom.Polygon.Earcut
 * @since 3.50.0
 *
 * @param {number[]} data - A flat array of vertex coordinate, like [x0,y0, x1,y1, x2,y2, ...]
 * @param {number[]} [holeIndices] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [dimensions=2] - The number of coordinates per vertex in the input array (2 by default).
 *
 * @return {number[]} An array of triangulated data.
 */ //  Earcut 2.2.2 (January 21st 2020)
            /*
 * ISC License
 *
 * Copyright (c) 2016, Mapbox
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose
 * with or without fee is hereby granted, provided that the above copyright notice
 * and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
 * OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
 * TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
 * THIS SOFTWARE.
 */ function earcut(data, holeIndices, dim) {
                dim = dim || 2;
                var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
                if (!outerNode || outerNode.next === outerNode.prev) return triangles;
                var minX, minY, maxX, maxY, x, y, invSize;
                if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
                // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
                if (data.length > 80 * dim) {
                    minX = maxX = data[0];
                    minY = maxY = data[1];
                    for(var i = dim; i < outerLen; i += dim){
                        x = data[i];
                        y = data[i + 1];
                        if (x < minX) minX = x;
                        if (y < minY) minY = y;
                        if (x > maxX) maxX = x;
                        if (y > maxY) maxY = y;
                    }
                    // minX, minY and invSize are later used to transform coords into integers for z-order calculation
                    invSize = Math.max(maxX - minX, maxY - minY);
                    invSize = invSize !== 0 ? 1 / invSize : 0;
                }
                earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
                return triangles;
            }
            // create a circular doubly linked list from polygon points in the specified winding order
            function linkedList(data, start, end, dim, clockwise) {
                var i, last;
                if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
                else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
                if (last && equals(last, last.next)) {
                    removeNode(last);
                    last = last.next;
                }
                return last;
            }
            // eliminate colinear or duplicate points
            function filterPoints(start, end) {
                if (!start) return start;
                if (!end) end = start;
                var p = start, again;
                do {
                    again = false;
                    if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                        removeNode(p);
                        p = end = p.prev;
                        if (p === p.next) break;
                        again = true;
                    } else p = p.next;
                }while (again || p !== end);
                return end;
            }
            // main ear slicing loop which triangulates a polygon (given as a linked list)
            function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
                if (!ear) return;
                // interlink polygon nodes in z-order
                if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
                var stop = ear, prev, next;
                // iterate through ears, slicing them one by one
                while(ear.prev !== ear.next){
                    prev = ear.prev;
                    next = ear.next;
                    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                        // cut off the triangle
                        triangles.push(prev.i / dim);
                        triangles.push(ear.i / dim);
                        triangles.push(next.i / dim);
                        removeNode(ear);
                        // skipping the next vertex leads to less sliver triangles
                        ear = next.next;
                        stop = next.next;
                        continue;
                    }
                    ear = next;
                    // if we looped through the whole remaining polygon and can't find any more ears
                    if (ear === stop) {
                        // try filtering points and slicing again
                        if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
                        else if (pass === 1) {
                            ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                            earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
                        // as a last resort, try splitting the remaining polygon into two
                        } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
                        break;
                    }
                }
            }
            // check whether a polygon node forms a valid ear with adjacent nodes
            function isEar(ear) {
                var a = ear.prev, b = ear, c = ear.next;
                if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                // now make sure we don't have other points inside the potential ear
                var p = ear.next.next;
                while(p !== ear.prev){
                    if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.next;
                }
                return true;
            }
            function isEarHashed(ear, minX, minY, invSize) {
                var a = ear.prev, b = ear, c = ear.next;
                if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
                // triangle bbox; min & max are calculated like this for speed
                var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
                // z-order range for the current triangle bbox;
                var minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
                var p = ear.prevZ, n = ear.nextZ;
                // look for points inside the triangle in both directions
                while(p && p.z >= minZ && n && n.z <= maxZ){
                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.prevZ;
                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                    n = n.nextZ;
                }
                // look for remaining points in decreasing z-order
                while(p && p.z >= minZ){
                    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
                    p = p.prevZ;
                }
                // look for remaining points in increasing z-order
                while(n && n.z <= maxZ){
                    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
                    n = n.nextZ;
                }
                return true;
            }
            // go through all polygon nodes and cure small local self-intersections
            function cureLocalIntersections(start, triangles, dim) {
                var p = start;
                do {
                    var a = p.prev, b = p.next.next;
                    if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
                        triangles.push(a.i / dim);
                        triangles.push(p.i / dim);
                        triangles.push(b.i / dim);
                        // remove two nodes involved
                        removeNode(p);
                        removeNode(p.next);
                        p = start = b;
                    }
                    p = p.next;
                }while (p !== start);
                return filterPoints(p);
            }
            // try splitting polygon into two and triangulate them independently
            function splitEarcut(start, triangles, dim, minX, minY, invSize) {
                // look for a valid diagonal that divides the polygon into two
                var a = start;
                do {
                    var b = a.next.next;
                    while(b !== a.prev){
                        if (a.i !== b.i && isValidDiagonal(a, b)) {
                            // split the polygon in two by the diagonal
                            var c = splitPolygon(a, b);
                            // filter colinear points around the cuts
                            a = filterPoints(a, a.next);
                            c = filterPoints(c, c.next);
                            // run earcut on each half
                            earcutLinked(a, triangles, dim, minX, minY, invSize);
                            earcutLinked(c, triangles, dim, minX, minY, invSize);
                            return;
                        }
                        b = b.next;
                    }
                    a = a.next;
                }while (a !== start);
            }
            // link every hole into the outer loop, producing a single-ring polygon without holes
            function eliminateHoles(data, holeIndices, outerNode, dim) {
                var queue = [], i, len, start, end, list;
                for(i = 0, len = holeIndices.length; i < len; i++){
                    start = holeIndices[i] * dim;
                    end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                    list = linkedList(data, start, end, dim, false);
                    if (list === list.next) list.steiner = true;
                    queue.push(getLeftmost(list));
                }
                queue.sort(compareX);
                // process holes from left to right
                for(i = 0; i < queue.length; i++){
                    eliminateHole(queue[i], outerNode);
                    outerNode = filterPoints(outerNode, outerNode.next);
                }
                return outerNode;
            }
            function compareX(a, b) {
                return a.x - b.x;
            }
            // find a bridge between vertices that connects hole with an outer ring and and link it
            function eliminateHole(hole, outerNode) {
                outerNode = findHoleBridge(hole, outerNode);
                if (outerNode) {
                    var b = splitPolygon(outerNode, hole);
                    // filter collinear points around the cuts
                    filterPoints(outerNode, outerNode.next);
                    filterPoints(b, b.next);
                }
            }
            // David Eberly's algorithm for finding a bridge between hole and outer polygon
            function findHoleBridge(hole, outerNode) {
                var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
                // find a segment intersected by a ray from the hole's leftmost point to the left;
                // segment's endpoint with lesser x will be potential connection point
                do {
                    if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                        var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
                        if (x <= hx && x > qx) {
                            qx = x;
                            if (x === hx) {
                                if (hy === p.y) return p;
                                if (hy === p.next.y) return p.next;
                            }
                            m = p.x < p.next.x ? p : p.next;
                        }
                    }
                    p = p.next;
                }while (p !== outerNode);
                if (!m) return null;
                if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
                // look for points inside the triangle of hole point, segment intersection and endpoint;
                // if there are no points found, we have a valid connection;
                // otherwise choose the point of the minimum angle with the ray as connection point
                var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
                p = m;
                do {
                    if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
                        tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
                        if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                            m = p;
                            tanMin = tan;
                        }
                    }
                    p = p.next;
                }while (p !== stop);
                return m;
            }
            // whether sector in vertex m contains sector in vertex p in the same coordinates
            function sectorContainsSector(m, p) {
                return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
            }
            // interlink polygon nodes in z-order
            function indexCurve(start, minX, minY, invSize) {
                var p = start;
                do {
                    if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
                    p.prevZ = p.prev;
                    p.nextZ = p.next;
                    p = p.next;
                }while (p !== start);
                p.prevZ.nextZ = null;
                p.prevZ = null;
                sortLinked(p);
            }
            // Simon Tatham's linked list merge sort algorithm
            // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
            function sortLinked(list) {
                var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
                do {
                    p = list;
                    list = null;
                    tail = null;
                    numMerges = 0;
                    while(p){
                        numMerges++;
                        q = p;
                        pSize = 0;
                        for(i = 0; i < inSize; i++){
                            pSize++;
                            q = q.nextZ;
                            if (!q) break;
                        }
                        qSize = inSize;
                        while(pSize > 0 || qSize > 0 && q){
                            if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                                e = p;
                                p = p.nextZ;
                                pSize--;
                            } else {
                                e = q;
                                q = q.nextZ;
                                qSize--;
                            }
                            if (tail) tail.nextZ = e;
                            else list = e;
                            e.prevZ = tail;
                            tail = e;
                        }
                        p = q;
                    }
                    tail.nextZ = null;
                    inSize *= 2;
                }while (numMerges > 1);
                return list;
            }
            // z-order of a point given coords and inverse of the longer side of data bbox
            function zOrder(x, y, minX, minY, invSize) {
                // coords are transformed into non-negative 15-bit integer range
                x = 32767 * (x - minX) * invSize;
                y = 32767 * (y - minY) * invSize;
                x = (x | x << 8) & 0x00FF00FF;
                x = (x | x << 4) & 0x0F0F0F0F;
                x = (x | x << 2) & 0x33333333;
                x = (x | x << 1) & 0x55555555;
                y = (y | y << 8) & 0x00FF00FF;
                y = (y | y << 4) & 0x0F0F0F0F;
                y = (y | y << 2) & 0x33333333;
                y = (y | y << 1) & 0x55555555;
                return x | y << 1;
            }
            // find the leftmost node of a polygon ring
            function getLeftmost(start) {
                var p = start, leftmost = start;
                do {
                    if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
                    p = p.next;
                }while (p !== start);
                return leftmost;
            }
            // check if a point lies within a convex triangle
            function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
                return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
            }
            // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
            function isValidDiagonal(a, b) {
                return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
                (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
                (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
                equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
            }
            // signed area of a triangle
            function area(p, q, r) {
                return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
            }
            // check if two points are equal
            function equals(p1, p2) {
                return p1.x === p2.x && p1.y === p2.y;
            }
            // check if two segments intersect
            function intersects(p1, q1, p2, q2) {
                var o1 = sign(area(p1, q1, p2));
                var o2 = sign(area(p1, q1, q2));
                var o3 = sign(area(p2, q2, p1));
                var o4 = sign(area(p2, q2, q1));
                if (o1 !== o2 && o3 !== o4) return true; // general case
                if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
                if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
                if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
                if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
                return false;
            }
            // for collinear points p, q, r, check if point q lies on segment pr
            function onSegment(p, q, r) {
                return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
            }
            function sign(num) {
                return num > 0 ? 1 : num < 0 ? -1 : 0;
            }
            // check if a polygon diagonal intersects any polygon segments
            function intersectsPolygon(a, b) {
                var p = a;
                do {
                    if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
                    p = p.next;
                }while (p !== a);
                return false;
            }
            // check if a polygon diagonal is locally inside the polygon
            function locallyInside(a, b) {
                return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
            }
            // check if the middle point of a polygon diagonal is inside the polygon
            function middleInside(a, b) {
                var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
                do {
                    if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
                    p = p.next;
                }while (p !== a);
                return inside;
            }
            // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
            // if one belongs to the outer ring and another to a hole, it merges it into a single ring
            function splitPolygon(a, b) {
                var a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
                a.next = b;
                b.prev = a;
                a2.next = an;
                an.prev = a2;
                b2.next = a2;
                a2.prev = b2;
                bp.next = b2;
                b2.prev = bp;
                return b2;
            }
            // create a node and optionally link it with previous one (in a circular doubly linked list)
            function insertNode(i, x, y, last) {
                var p = new Node(i, x, y);
                if (!last) {
                    p.prev = p;
                    p.next = p;
                } else {
                    p.next = last.next;
                    p.prev = last;
                    last.next.prev = p;
                    last.next = p;
                }
                return p;
            }
            function removeNode(p) {
                p.next.prev = p.prev;
                p.prev.next = p.next;
                if (p.prevZ) p.prevZ.nextZ = p.nextZ;
                if (p.nextZ) p.nextZ.prevZ = p.prevZ;
            }
            function Node(i, x, y) {
                // vertex index in coordinates array
                this.i = i;
                // vertex coordinates
                this.x = x;
                this.y = y;
                // previous and next vertex nodes in a polygon ring
                this.prev = null;
                this.next = null;
                // z-order curve value
                this.z = null;
                // previous and next nodes in z-order
                this.prevZ = null;
                this.nextZ = null;
                // indicates whether this is a steiner point
                this.steiner = false;
            }
            // return a percentage difference between the polygon area and its triangulation area;
            // used to verify correctness of triangulation
            earcut.deviation = function(data, holeIndices, dim, triangles) {
                var hasHoles = holeIndices && holeIndices.length;
                var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
                var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
                if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
                    var start = holeIndices[i] * dim;
                    var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                    polygonArea -= Math.abs(signedArea(data, start, end, dim));
                }
                var trianglesArea = 0;
                for(i = 0; i < triangles.length; i += 3){
                    var a = triangles[i] * dim;
                    var b = triangles[i + 1] * dim;
                    var c = triangles[i + 2] * dim;
                    trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
                }
                return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
            };
            function signedArea(data, start, end, dim) {
                var sum = 0;
                for(var i = start, j = end - dim; i < end; i += dim){
                    sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
                    j = i;
                }
                return sum;
            }
            // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
            earcut.flatten = function(data) {
                var dim = data[0][0].length, result = {
                    vertices: [],
                    holes: [],
                    dimensions: dim
                }, holeIndex = 0;
                for(var i = 0; i < data.length; i++){
                    for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
                    if (i > 0) {
                        holeIndex += data[i - 1].length;
                        result.holes.push(holeIndex);
                    }
                }
                return result;
            };
            module1.exports = earcut;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound.Events
 */ module1.exports = {
                COMPLETE: __webpack_require__(983),
                DECODED: __webpack_require__(984),
                DECODED_ALL: __webpack_require__(985),
                DESTROY: __webpack_require__(986),
                DETUNE: __webpack_require__(987),
                GLOBAL_DETUNE: __webpack_require__(988),
                GLOBAL_MUTE: __webpack_require__(989),
                GLOBAL_RATE: __webpack_require__(990),
                GLOBAL_VOLUME: __webpack_require__(991),
                LOOP: __webpack_require__(992),
                LOOPED: __webpack_require__(993),
                MUTE: __webpack_require__(994),
                PAN: __webpack_require__(995),
                PAUSE_ALL: __webpack_require__(996),
                PAUSE: __webpack_require__(997),
                PLAY: __webpack_require__(998),
                RATE: __webpack_require__(999),
                RESUME_ALL: __webpack_require__(1000),
                RESUME: __webpack_require__(1001),
                SEEK: __webpack_require__(1002),
                STOP_ALL: __webpack_require__(1003),
                STOP: __webpack_require__(1004),
                UNLOCKED: __webpack_require__(1005),
                VOLUME: __webpack_require__(1006)
            };
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#image method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#image.
 *
 * @class ImageFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. Only provided for, and used by, Sprite Sheets.
 */ var ImageFile = new Class({
                Extends: File,
                initialize: function ImageFile(loader, key, url, xhrSettings, frameConfig) {
                    var extension = 'png';
                    var normalMapURL;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        normalMapURL = GetFastValue(config, 'normalMap');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        frameConfig = GetFastValue(config, 'frameConfig');
                    }
                    if (Array.isArray(url)) {
                        normalMapURL = url[1];
                        url = url[0];
                    }
                    var fileConfig = {
                        type: 'image',
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: 'blob',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: frameConfig
                    };
                    File.call(this, loader, fileConfig);
                    //  Do we have a normal map to load as well?
                    if (normalMapURL) {
                        var normalMap = new ImageFile(loader, this.key, normalMapURL, xhrSettings, frameConfig);
                        normalMap.type = 'normalMap';
                        this.setLink(normalMap);
                        loader.addFile(normalMap);
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    var _this = this;
                    this.data.onload = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(this.data, this.xhrLoader.response, 'image/png');
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.ImageFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture;
                    var linkFile = this.linkFile;
                    if (linkFile && linkFile.state === CONST.FILE_COMPLETE) {
                        if (this.type === 'image') texture = this.cache.addImage(this.key, this.data, linkFile.data);
                        else texture = this.cache.addImage(linkFile.key, linkFile.data, this.data);
                        this.pendingDestroy(texture);
                        linkFile.pendingDestroy(texture);
                    } else if (!linkFile) {
                        texture = this.cache.addImage(this.key, this.data);
                        this.pendingDestroy(texture);
                    }
                }
            });
            /**
 * Adds an Image, or array of Images, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.image('logo', 'images/phaserLogo.png');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ImageFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.image('logo', 'images/AtariLogo.png');
 * // and later in your game ...
 * this.add.image(x, y, 'logo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.image('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ]);
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.image({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Image File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#image
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ImageFileConfig|Phaser.Types.Loader.FileTypes.ImageFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('image', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ImageFile(this, key[i]));
                else this.addFile(new ImageFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = ImageFile;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * The `Matter.Body` module contains methods for creating and manipulating body models.
 * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
 * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
 *
 * See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
 * @class Body
 */ var Body = {};
            module1.exports = Body;
            var Vertices = __webpack_require__(94);
            var Vector = __webpack_require__(116);
            var Sleeping = __webpack_require__(267);
            var Common = __webpack_require__(50);
            var Bounds = __webpack_require__(117);
            var Axes = __webpack_require__(585);
            (function() {
                Body._inertiaScale = 4;
                Body._nextCollidingGroupId = 1;
                Body._nextNonCollidingGroupId = -1;
                Body._nextCategory = 0x0001;
                /**
     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * Vertices must be specified in clockwise order.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {body} body
     */ Body.create = function(options) {
                    var defaults = {
                        id: Common.nextId(),
                        type: 'body',
                        label: 'Body',
                        parts: [],
                        plugin: {},
                        angle: 0,
                        vertices: null,
                        position: {
                            x: 0,
                            y: 0
                        },
                        force: {
                            x: 0,
                            y: 0
                        },
                        torque: 0,
                        positionImpulse: {
                            x: 0,
                            y: 0
                        },
                        previousPositionImpulse: {
                            x: 0,
                            y: 0
                        },
                        constraintImpulse: {
                            x: 0,
                            y: 0,
                            angle: 0
                        },
                        totalContacts: 0,
                        speed: 0,
                        angularSpeed: 0,
                        velocity: {
                            x: 0,
                            y: 0
                        },
                        angularVelocity: 0,
                        isSensor: false,
                        isStatic: false,
                        isSleeping: false,
                        motion: 0,
                        sleepThreshold: 60,
                        density: 0.001,
                        restitution: 0,
                        friction: 0.1,
                        frictionStatic: 0.5,
                        frictionAir: 0.01,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        },
                        slop: 0.05,
                        timeScale: 1,
                        events: null,
                        bounds: null,
                        chamfer: null,
                        circleRadius: 0,
                        positionPrev: null,
                        anglePrev: 0,
                        parent: null,
                        axes: null,
                        area: 0,
                        mass: 0,
                        inverseMass: 0,
                        inertia: 0,
                        inverseInertia: 0,
                        _original: null,
                        render: {
                            visible: true,
                            opacity: 1,
                            sprite: {
                                xOffset: 0,
                                yOffset: 0
                            },
                            fillColor: null,
                            fillOpacity: null,
                            lineColor: null,
                            lineOpacity: null,
                            lineThickness: null // custom Phaser property
                        },
                        gameObject: null,
                        scale: {
                            x: 1,
                            y: 1
                        },
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        centerOffset: {
                            x: 0,
                            y: 0
                        },
                        gravityScale: {
                            x: 1,
                            y: 1
                        },
                        ignoreGravity: false,
                        ignorePointer: false,
                        onCollideCallback: null,
                        onCollideEndCallback: null,
                        onCollideActiveCallback: null,
                        onCollideWith: {} // custom Phaser property
                    };
                    if (!options.hasOwnProperty('position') && options.hasOwnProperty('vertices')) options.position = Vertices.centre(options.vertices);
                    else if (!options.hasOwnProperty('vertices')) defaults.vertices = Vertices.fromPath('L 0 0 L 40 0 L 40 40 L 0 40');
                    var body = Common.extend(defaults, options);
                    _initProperties(body, options);
                    //  Helper function
                    body.setOnCollideWith = function(body, callback) {
                        if (callback) this.onCollideWith[body.id] = callback;
                        else delete this.onCollideWith[body.id];
                        return this;
                    };
                    return body;
                };
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
     * See `body.collisionFilter` for more information.
     * @method nextGroup
     * @param {bool} [isNonColliding=false]
     * @return {Number} Unique group index
     */ Body.nextGroup = function(isNonColliding) {
                    if (isNonColliding) return Body._nextNonCollidingGroupId--;
                    return Body._nextCollidingGroupId++;
                };
                /**
     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
     * There are 32 available. See `body.collisionFilter` for more information.
     * @method nextCategory
     * @return {Number} Unique category bitfield
     */ Body.nextCategory = function() {
                    Body._nextCategory = Body._nextCategory << 1;
                    return Body._nextCategory;
                };
                /**
     * Initialises body properties.
     * @method _initProperties
     * @private
     * @param {body} body
     * @param {} [options]
     */ var _initProperties = function(body, options) {
                    options = options || {};
                    // init required properties (order is important)
                    Body.set(body, {
                        bounds: body.bounds || Bounds.create(body.vertices),
                        positionPrev: body.positionPrev || Vector.clone(body.position),
                        anglePrev: body.anglePrev || body.angle,
                        vertices: body.vertices,
                        parts: body.parts || [
                            body
                        ],
                        isStatic: body.isStatic,
                        isSleeping: body.isSleeping,
                        parent: body.parent || body
                    });
                    var bounds = body.bounds;
                    Vertices.rotate(body.vertices, body.angle, body.position);
                    Axes.rotate(body.axes, body.angle);
                    Bounds.update(bounds, body.vertices, body.velocity);
                    // allow options to override the automatically calculated properties
                    Body.set(body, {
                        axes: options.axes || body.axes,
                        area: options.area || body.area,
                        mass: options.mass || body.mass,
                        inertia: options.inertia || body.inertia
                    });
                    if (body.parts.length === 1) {
                        var centerOfMass = body.centerOfMass;
                        var centerOffset = body.centerOffset;
                        var bodyWidth = bounds.max.x - bounds.min.x;
                        var bodyHeight = bounds.max.y - bounds.min.y;
                        centerOfMass.x = -(bounds.min.x - body.position.x) / bodyWidth;
                        centerOfMass.y = -(bounds.min.y - body.position.y) / bodyHeight;
                        centerOffset.x = bodyWidth * centerOfMass.x;
                        centerOffset.y = bodyHeight * centerOfMass.y;
                    }
                };
                /**
     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
     * Prefer to use the actual setter functions in performance critical situations.
     * @method set
     * @param {body} body
     * @param {} settings A property name (or map of properties and values) to set on the body.
     * @param {} value The value to set if `settings` is a single property name.
     */ Body.set = function(body, settings, value) {
                    var property;
                    if (typeof settings === 'string') {
                        property = settings;
                        settings = {};
                        settings[property] = value;
                    }
                    for(property in settings){
                        if (!Object.prototype.hasOwnProperty.call(settings, property)) continue;
                        value = settings[property];
                        switch(property){
                            case 'isStatic':
                                Body.setStatic(body, value);
                                break;
                            case 'isSleeping':
                                Sleeping.set(body, value);
                                break;
                            case 'mass':
                                Body.setMass(body, value);
                                break;
                            case 'density':
                                Body.setDensity(body, value);
                                break;
                            case 'inertia':
                                Body.setInertia(body, value);
                                break;
                            case 'vertices':
                                Body.setVertices(body, value);
                                break;
                            case 'position':
                                Body.setPosition(body, value);
                                break;
                            case 'angle':
                                Body.setAngle(body, value);
                                break;
                            case 'velocity':
                                Body.setVelocity(body, value);
                                break;
                            case 'angularVelocity':
                                Body.setAngularVelocity(body, value);
                                break;
                            case 'parts':
                                Body.setParts(body, value);
                                break;
                            case 'centre':
                                Body.setCentre(body, value);
                                break;
                            default:
                                body[property] = value;
                        }
                    }
                };
                /**
     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
     * @method setStatic
     * @param {body} body
     * @param {bool} isStatic
     */ Body.setStatic = function(body, isStatic) {
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.isStatic = isStatic;
                        if (isStatic) {
                            part._original = {
                                restitution: part.restitution,
                                friction: part.friction,
                                mass: part.mass,
                                inertia: part.inertia,
                                density: part.density,
                                inverseMass: part.inverseMass,
                                inverseInertia: part.inverseInertia
                            };
                            part.restitution = 0;
                            part.friction = 1;
                            part.mass = part.inertia = part.density = Infinity;
                            part.inverseMass = part.inverseInertia = 0;
                            part.positionPrev.x = part.position.x;
                            part.positionPrev.y = part.position.y;
                            part.anglePrev = part.angle;
                            part.angularVelocity = 0;
                            part.speed = 0;
                            part.angularSpeed = 0;
                            part.motion = 0;
                        } else if (part._original) {
                            part.restitution = part._original.restitution;
                            part.friction = part._original.friction;
                            part.mass = part._original.mass;
                            part.inertia = part._original.inertia;
                            part.density = part._original.density;
                            part.inverseMass = part._original.inverseMass;
                            part.inverseInertia = part._original.inverseInertia;
                            part._original = null;
                        }
                    }
                };
                /**
     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
     * @method setMass
     * @param {body} body
     * @param {number} mass
     */ Body.setMass = function(body, mass) {
                    var moment = body.inertia / (body.mass / 6);
                    body.inertia = moment * (mass / 6);
                    body.inverseInertia = 1 / body.inertia;
                    body.mass = mass;
                    body.inverseMass = 1 / body.mass;
                    body.density = body.mass / body.area;
                };
                /**
     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
     * @method setDensity
     * @param {body} body
     * @param {number} density
     */ Body.setDensity = function(body, density) {
                    Body.setMass(body, density * body.area);
                    body.density = density;
                };
                /**
     * Sets the moment of inertia (i.e. second moment of area) of the body. 
     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
     * @method setInertia
     * @param {body} body
     * @param {number} inertia
     */ Body.setInertia = function(body, inertia) {
                    body.inertia = inertia;
                    body.inverseInertia = 1 / body.inertia;
                };
                /**
     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
     * They are then automatically translated to world space based on `body.position`.
     *
     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
     * Vertices must form a convex hull, concave hulls are not supported.
     *
     * @method setVertices
     * @param {body} body
     * @param {vector[]} vertices
     */ Body.setVertices = function(body, vertices) {
                    // change vertices
                    if (vertices[0].body === body) body.vertices = vertices;
                    else body.vertices = Vertices.create(vertices, body);
                    // update properties
                    body.axes = Axes.fromVertices(body.vertices);
                    body.area = Vertices.area(body.vertices);
                    Body.setMass(body, body.density * body.area);
                    // orient vertices around the centre of mass at origin (0, 0)
                    var centre = Vertices.centre(body.vertices);
                    Vertices.translate(body.vertices, centre, -1);
                    // update inertia while vertices are at origin (0, 0)
                    Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
                    // update geometry
                    Vertices.translate(body.vertices, body.position);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                };
                /**
     * Sets the parts of the `body` and updates mass, inertia and centroid.
     * Each part will have its parent set to `body`.
     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
     * @method setParts
     * @param {body} body
     * @param [body] parts
     * @param {bool} [autoHull=true]
     */ Body.setParts = function(body, parts, autoHull) {
                    var i;
                    // add all the parts, ensuring that the first part is always the parent body
                    parts = parts.slice(0);
                    body.parts.length = 0;
                    body.parts.push(body);
                    body.parent = body;
                    for(i = 0; i < parts.length; i++){
                        var part = parts[i];
                        if (part !== body) {
                            part.parent = body;
                            body.parts.push(part);
                        }
                    }
                    if (body.parts.length === 1) return;
                    autoHull = typeof autoHull !== 'undefined' ? autoHull : true;
                    // find the convex hull of all parts to set on the parent body
                    if (autoHull) {
                        var vertices = [];
                        for(i = 0; i < parts.length; i++)vertices = vertices.concat(parts[i].vertices);
                        Vertices.clockwiseSort(vertices);
                        var hull = Vertices.hull(vertices), hullCentre = Vertices.centre(hull);
                        Body.setVertices(body, hull);
                        Vertices.translate(body.vertices, hullCentre);
                    }
                    // sum the properties of all compound parts of the parent body
                    var total = Body._totalProperties(body);
                    //  Phaser addition
                    var cx = total.centre.x;
                    var cy = total.centre.y;
                    var bounds = body.bounds;
                    var centerOfMass = body.centerOfMass;
                    var centerOffset = body.centerOffset;
                    Bounds.update(bounds, body.vertices, body.velocity);
                    centerOfMass.x = -(bounds.min.x - cx) / (bounds.max.x - bounds.min.x);
                    centerOfMass.y = -(bounds.min.y - cy) / (bounds.max.y - bounds.min.y);
                    centerOffset.x = cx;
                    centerOffset.y = cy;
                    body.area = total.area;
                    body.parent = body;
                    body.position.x = cx;
                    body.position.y = cy;
                    body.positionPrev.x = cx;
                    body.positionPrev.y = cy;
                    Body.setMass(body, total.mass);
                    Body.setInertia(body, total.inertia);
                    Body.setPosition(body, total.centre);
                };
                /**
     * Set the centre of mass of the body. 
     * The `centre` is a vector in world-space unless `relative` is set, in which case it is a translation.
     * The centre of mass is the point the body rotates about and can be used to simulate non-uniform density.
     * This is equal to moving `body.position` but not the `body.vertices`.
     * Invalid if the `centre` falls outside the body's convex hull.
     * @method setCentre
     * @param {body} body
     * @param {vector} centre
     * @param {bool} relative
     */ Body.setCentre = function(body, centre, relative) {
                    if (!relative) {
                        body.positionPrev.x = centre.x - (body.position.x - body.positionPrev.x);
                        body.positionPrev.y = centre.y - (body.position.y - body.positionPrev.y);
                        body.position.x = centre.x;
                        body.position.y = centre.y;
                    } else {
                        body.positionPrev.x += centre.x;
                        body.positionPrev.y += centre.y;
                        body.position.x += centre.x;
                        body.position.y += centre.y;
                    }
                };
                /**
     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
     * @method setPosition
     * @param {body} body
     * @param {vector} position
     */ Body.setPosition = function(body, position) {
                    var delta = Vector.sub(position, body.position);
                    body.positionPrev.x += delta.x;
                    body.positionPrev.y += delta.y;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.position.x += delta.x;
                        part.position.y += delta.y;
                        Vertices.translate(part.vertices, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
     * @method setAngle
     * @param {body} body
     * @param {number} angle
     */ Body.setAngle = function(body, angle) {
                    var delta = angle - body.angle;
                    body.anglePrev += delta;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.angle += delta;
                        Vertices.rotate(part.vertices, delta, body.position);
                        Axes.rotate(part.axes, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                        if (i > 0) Vector.rotateAbout(part.position, delta, body.position, part.position);
                    }
                };
                /**
     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setVelocity
     * @param {body} body
     * @param {vector} velocity
     */ Body.setVelocity = function(body, velocity) {
                    body.positionPrev.x = body.position.x - velocity.x;
                    body.positionPrev.y = body.position.y - velocity.y;
                    body.velocity.x = velocity.x;
                    body.velocity.y = velocity.y;
                    body.speed = Vector.magnitude(body.velocity);
                };
                /**
     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
     * @method setAngularVelocity
     * @param {body} body
     * @param {number} velocity
     */ Body.setAngularVelocity = function(body, velocity) {
                    body.anglePrev = body.angle - velocity;
                    body.angularVelocity = velocity;
                    body.angularSpeed = Math.abs(body.angularVelocity);
                };
                /**
     * Moves a body by a given vector relative to its current position, without imparting any velocity.
     * @method translate
     * @param {body} body
     * @param {vector} translation
     */ Body.translate = function(body, translation) {
                    Body.setPosition(body, Vector.add(body.position, translation));
                };
                /**
     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
     * @method rotate
     * @param {body} body
     * @param {number} rotation
     * @param {vector} [point]
     */ Body.rotate = function(body, rotation, point) {
                    if (!point) Body.setAngle(body, body.angle + rotation);
                    else {
                        var cos = Math.cos(rotation), sin = Math.sin(rotation), dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.setAngle(body, body.angle + rotation);
                    }
                };
                /**
     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
     * @method scale
     * @param {body} body
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} [point]
     */ Body.scale = function(body, scaleX, scaleY, point) {
                    var totalArea = 0, totalInertia = 0;
                    point = point || body.position;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.scale.x = scaleX;
                        part.scale.y = scaleY;
                        // scale vertices
                        Vertices.scale(part.vertices, scaleX, scaleY, point);
                        // update properties
                        part.axes = Axes.fromVertices(part.vertices);
                        part.area = Vertices.area(part.vertices);
                        Body.setMass(part, body.density * part.area);
                        // update inertia (requires vertices to be at origin)
                        Vertices.translate(part.vertices, {
                            x: -part.position.x,
                            y: -part.position.y
                        });
                        Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
                        Vertices.translate(part.vertices, {
                            x: part.position.x,
                            y: part.position.y
                        });
                        if (i > 0) {
                            totalArea += part.area;
                            totalInertia += part.inertia;
                        }
                        // scale position
                        part.position.x = point.x + (part.position.x - point.x) * scaleX;
                        part.position.y = point.y + (part.position.y - point.y) * scaleY;
                        // update bounds
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                    // handle parent body
                    if (body.parts.length > 1) {
                        body.area = totalArea;
                        if (!body.isStatic) {
                            Body.setMass(body, body.density * totalArea);
                            Body.setInertia(body, totalInertia);
                        }
                    }
                    // handle circles
                    if (body.circleRadius) {
                        if (scaleX === scaleY) body.circleRadius *= scaleX;
                        else // body is no longer a circle
                        body.circleRadius = null;
                    }
                };
                /**
     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
     * @method update
     * @param {body} body
     * @param {number} deltaTime
     * @param {number} timeScale
     * @param {number} correction
     */ Body.update = function(body, deltaTime, timeScale, correction) {
                    var deltaTimeSquared = Math.pow(deltaTime * timeScale * body.timeScale, 2);
                    // from the previous step
                    var frictionAir = 1 - body.frictionAir * timeScale * body.timeScale, velocityPrevX = body.position.x - body.positionPrev.x, velocityPrevY = body.position.y - body.positionPrev.y;
                    // update velocity with Verlet integration
                    body.velocity.x = velocityPrevX * frictionAir * correction + body.force.x / body.mass * deltaTimeSquared;
                    body.velocity.y = velocityPrevY * frictionAir * correction + body.force.y / body.mass * deltaTimeSquared;
                    body.positionPrev.x = body.position.x;
                    body.positionPrev.y = body.position.y;
                    body.position.x += body.velocity.x;
                    body.position.y += body.velocity.y;
                    // update angular velocity with Verlet integration
                    body.angularVelocity = (body.angle - body.anglePrev) * frictionAir * correction + body.torque / body.inertia * deltaTimeSquared;
                    body.anglePrev = body.angle;
                    body.angle += body.angularVelocity;
                    // track speed and acceleration
                    body.speed = Vector.magnitude(body.velocity);
                    body.angularSpeed = Math.abs(body.angularVelocity);
                    // transform the body geometry
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        Vertices.translate(part.vertices, body.velocity);
                        if (i > 0) {
                            part.position.x += body.velocity.x;
                            part.position.y += body.velocity.y;
                        }
                        if (body.angularVelocity !== 0) {
                            Vertices.rotate(part.vertices, body.angularVelocity, body.position);
                            Axes.rotate(part.axes, body.angularVelocity);
                            if (i > 0) Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
                        }
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Applies a force to a body from a given world-space position, including resulting torque.
     * @method applyForce
     * @param {body} body
     * @param {vector} position
     * @param {vector} force
     */ Body.applyForce = function(body, position, force) {
                    body.force.x += force.x;
                    body.force.y += force.y;
                    var offset = {
                        x: position.x - body.position.x,
                        y: position.y - body.position.y
                    };
                    body.torque += offset.x * force.y - offset.y * force.x;
                };
                /**
     * Returns the sums of the properties of all compound parts of the parent body.
     * @method _totalProperties
     * @private
     * @param {body} body
     * @return {}
     */ Body._totalProperties = function(body) {
                    // from equations at:
                    // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
                    // http://output.to/sideway/default.asp?qno=121100087
                    var properties = {
                        mass: 0,
                        area: 0,
                        inertia: 0,
                        centre: {
                            x: 0,
                            y: 0
                        }
                    };
                    // sum the properties of all compound parts of the parent body
                    for(var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++){
                        var part = body.parts[i], mass = part.mass !== Infinity ? part.mass : 1;
                        properties.mass += mass;
                        properties.area += part.area;
                        properties.inertia += part.inertia;
                        properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
                    }
                    properties.centre = Vector.div(properties.centre, properties.mass);
                    return properties;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a body starts sleeping (where `this` is the body).
    *
    * @event sleepStart
    * @this {body} The body that has started sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a body ends sleeping (where `this` is the body).
    *
    * @event sleepEnd
    * @this {body} The body that has ended sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "body"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Body"
     */ /**
     * An array of bodies that make up this body. 
     * The first body in the array must always be a self reference to the current body instance.
     * All bodies in the `parts` array together form a single rigid compound body.
     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
     * Parts themselves should never be added to a `World`, only the parent body should be.
     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
     *
     * @property parts
     * @type body[]
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * A self reference if the body is _not_ a part of another body.
     * Otherwise this is a reference to the body that this is a part of.
     * See `body.parts`.
     *
     * @property parent
     * @type body
     */ /**
     * A `Number` specifying the angle of the body, in radians.
     *
     * @property angle
     * @type number
     * @default 0
     */ /**
     * An array of `Vector` objects that specify the convex hull of the rigid body.
     * These should be provided about the origin `(0, 0)`. E.g.
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
     * The `Vector` objects are also augmented with additional properties required for efficient collision detection. 
     *
     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
     *
     * @property vertices
     * @type vector[]
     */ /**
     * A `Vector` that specifies the current world-space position of the body.
     *
     * @property position
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that holds the current scale values as set by `Body.setScale`.
     *
     * @property scale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
     *
     * @property force
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
     *
     * @property torque
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
     *
     * @readOnly
     * @property speed
     * @type number
     * @default 0
     */ /**
     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
     *
     * @readOnly
     * @property angularSpeed
     * @type number
     * @default 0
     */ /**
     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property velocity
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only. 
     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
     *
     * @readOnly
     * @property angularVelocity
     * @type number
     * @default 0
     */ /**
     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
     *
     * @property isStatic
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
     *
     * @property isSensor
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
     *
     * @property isSleeping
     * @type boolean
     * @default false
     */ /**
     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
     *
     * @readOnly
     * @property motion
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
     *
     * @property sleepThreshold
     * @type number
     * @default 60
     */ /**
     * A `Number` that defines the density of the body, that is its mass per unit area.
     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
     *
     * @property density
     * @type number
     * @default 0.001
     */ /**
     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
     *
     * @property mass
     * @type number
     */ /**
     * A `Number` that defines the inverse mass of the body (`1 / mass`).
     * If you modify this value, you must also modify the `body.mass` property.
     *
     * @property inverseMass
     * @type number
     */ /**
     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
     *
     * @property inertia
     * @type number
     */ /**
     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
     * If you modify this value, you must also modify the `body.inertia` property.
     *
     * @property inverseInertia
     * @type number
     */ /**
     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
     *
     *     Math.max(bodyA.restitution, bodyB.restitution)
     *
     * @property restitution
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means that the body may slide indefinitely.
     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
     *
     * The effects of the value may be non-linear. 
     * High values may be unstable depending on the body.
     * The engine uses a Coulomb friction model including static and kinetic friction.
     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
     *
     *     Math.min(bodyA.friction, bodyB.friction)
     *
     * @property friction
     * @type number
     * @default 0.1
     */ /**
     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
     *
     * @property frictionStatic
     * @type number
     * @default 0.5
     */ /**
     * A `Number` that defines the air friction of the body (air resistance). 
     * A value of `0` means the body will never slow as it moves through space.
     * The higher the value, the faster a body slows when moving through space.
     * The effects of the value are non-linear. 
     *
     * @property frictionAir
     * @type number
     * @default 0.01
     */ /**
     * An `Object` that specifies the collision filtering properties of this body.
     *
     * Collisions between two bodies will obey the following rules:
     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
     *   they will always collide if the value is positive, and they will never collide
     *   if the value is negative.
     * - If the two bodies have different values of `collisionFilter.group` or if one
     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
     *
     * Each body belongs to a collision category, given by `collisionFilter.category`. This
     * value is used as a bit field and the category should have only one bit set, meaning that
     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
     * different collision categories available.
     *
     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
     * the categories it collides with (the value is the bitwise AND value of all these categories).
     *
     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
     * are both true.
     *
     * @property collisionFilter
     * @type object
     */ /**
     * An Integer `Number`, that specifies the collision group this body belongs to.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.group
     * @type object
     * @default 0
     */ /**
     * A bit field that specifies the collision category this body belongs to.
     * The category value should have only one bit set, for example `0x0001`.
     * This means there are up to 32 unique collision categories available.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.category
     * @type object
     * @default 1
     */ /**
     * A bit mask that specifies the collision categories this body may collide with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.mask
     * @type object
     * @default -1
     */ /**
     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
     *
     * @property slop
     * @type number
     * @default 0.05
     */ /**
     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
     *
     * @property timeScale
     * @type number
     * @default 1
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the body should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * Sets the opacity to use when rendering.
     *
     * @property render.opacity
     * @type number
     * @default 1
    */ /**
     * An `Object` that defines the sprite properties to use when rendering, if any.
     *
     * @property render.sprite
     * @type object
     */ /**
      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
      *
      * @property render.sprite.xOffset
      * @type number
      * @default 0
      */ /**
      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
      *
      * @property render.sprite.yOffset
      * @type number
      * @default 0
      */ /**
     * A hex color value that defines the fill color to use when rendering the body.
     *
     * @property render.fillColor
     * @type number
     */ /**
     * A value that defines the fill opacity to use when rendering the body.
     *
     * @property render.fillOpacity
     * @type number
     */ /**
     * A hex color value that defines the line color to use when rendering the body.
     *
     * @property render.lineColor
     * @type number
     */ /**
     * A value that defines the line opacity to use when rendering the body.
     *
     * @property render.lineOpacity
     * @type number
     */ /**
     * A `Number` that defines the line width to use when rendering the body outline.
     *
     * @property render.lineThickness
     * @type number
     */ /**
     * An array of unique axis vectors (edge normals) used for collision detection.
     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
     * They are constantly updated by `Body.update` during the simulation.
     *
     * @property axes
     * @type vector[]
     */ /**
     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
     *
     * @property area
     * @type string
     * @default 
     */ /**
     * A `Bounds` object that defines the AABB region for the body.
     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
     *
     * @property bounds
     * @type bounds
     */ /**
     * A reference to the Phaser Game Object this body belongs to, if any.
     *
     * @property gameObject
     * @type Phaser.GameObjects.GameObject
     */ /**
     * The center of mass of the Body.
     *
     * @property centerOfMass
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * The center of the body in pixel values.
     * Used by Phaser for texture aligment.
     *
     * @property centerOffset
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * Will this Body ignore World gravity during the Engine update?
     *
     * @property ignoreGravity
     * @type boolean
     * @default false
     */ /**
     * Scale the influence of World gravity when applied to this body.
     *
     * @property gravityScale
     * @type vector
     * @default { x: 1, y: 1 }
     */ /**
     * Will this Body ignore Phaser Pointer input events?
     *
     * @property ignorePointer
     * @type boolean
     * @default false
     */ /**
     * A callback that is invoked when this Body starts colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked when this Body stops colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideEndCallback
     * @type function
     * @default null
     */ /**
     * A callback that is invoked for the duration that this Body is colliding with any other Body.
     * 
     * You can register callbacks by providing a function of type `( pair: Matter.Pair) => void`.
     *
     * @property onCollideActiveCallback
     * @type function
     * @default null
     */ /**
     * A collision callback dictionary used by the `Body.setOnCollideWith` function.
     *
     * @property onCollideWith
     * @type object
     * @default null
     */ })();
        /***/ },
        /* 72 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to set the colliding state of a tile. This does not recalculate
 * interesting faces.
 *
 * @function Phaser.Tilemaps.Components.SetTileCollision
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to set the collision on.
 * @param {boolean} [collides=true] - Should the tile index collide or not?
 */ var SetTileCollision = function(tile, collides) {
                if (collides) tile.setCollision(true, true, true, true, false);
                else tile.resetCollision(false);
            };
            module1.exports = SetTileCollision;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(162);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var SpriteRender = __webpack_require__(1059);
            /**
 * @classdesc
 * A Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Sprite = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    SpriteRender
                ],
                initialize: function Sprite(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, 'Sprite');
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Animation State component of this Sprite.
         *
         * This component provides features to apply animations to this Sprite.
         * It is responsible for playing, loading, queuing animations for later playback,
         * mixing between animations and setting the current animation frame to this Sprite.
         *
         * @name Phaser.GameObjects.Sprite#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.0.0
         */ this.anims = new AnimationState(this);
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.setOriginFromFrame();
                    this.initPipeline();
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Update this Sprite's animations.
     *
     * @method Phaser.GameObjects.Sprite#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    this.anims.update(time, delta);
                },
                /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying) {
                    return this.anims.play(key, ignoreIfPlaying);
                },
                /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.GameObjects.Sprite#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {this} This Game Object.
     */ playReverse: function(key, ignoreIfPlaying) {
                    return this.anims.playReverse(key, ignoreIfPlaying);
                },
                /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay'.
     *
     * @method Phaser.GameObjects.Sprite#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {this} This Game Object.
     */ playAfterDelay: function(key, delay) {
                    return this.anims.playAfterDelay(key, delay);
                },
                /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {this} This Game Object.
     */ playAfterRepeat: function(key, repeatCount) {
                    return this.anims.playAfterRepeat(key, repeatCount);
                },
                /**
     * Sets an animation, or an array of animations, to be played immediately after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have the `stop` method called directly on it.
     *
     * An animation set to repeat forever will never enter a completed state.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it,
     * or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained
     * animations without impacting the animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * @method Phaser.GameObjects.Sprite#chain
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {this} This Game Object.
     */ chain: function(key) {
                    return this.anims.chain(key);
                },
                /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` events.
     *
     * If no animation is playing, no event will be dispatched.
     *
     * If there is another animation queued (via the `chain` method) then it will start playing immediately.
     *
     * @method Phaser.GameObjects.Sprite#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @return {this} This Game Object.
     */ stop: function() {
                    return this.anims.stop();
                },
                /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopAfterDelay: function(delay) {
                    return this.anims.stopAfterDelay(delay);
                },
                /**
     * Stops the current animation from playing after the given number of repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {this} This Game Object.
     */ stopAfterRepeat: function(repeatCount) {
                    return this.anims.stopAfterRepeat(repeatCount);
                },
                /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.GameObjects.Sprite#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {this} This Game Object.
     */ stopOnFrame: function(frame) {
                    return this.anims.stopOnFrame(frame);
                },
                /**
     * Build a JSON representation of this Sprite.
     *
     * @method Phaser.GameObjects.Sprite#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return Components.ToJSON(this);
                },
                /**
     * Handles the pre-destroy step for the Sprite, which removes the Animation component.
     *
     * @method Phaser.GameObjects.Sprite#preDestroy
     * @private
     * @since 3.14.0
     */ preDestroy: function() {
                    this.anims.destroy();
                    this.anims = undefined;
                }
            });
            module1.exports = Sprite;
        /***/ },
        /* 74 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Removes a single item from an array and returns it without creating gc, like the native splice does.
 * Based on code by Mike Reinstein.
 *
 * @function Phaser.Utils.Array.SpliceOne
 * @since 3.0.0
 *
 * @param {array} array - The array to splice from.
 * @param {number} index - The index of the item which should be spliced.
 *
 * @return {*} The item which was spliced (removed).
 */ var SpliceOne = function(array, index) {
                if (index >= array.length) return;
                var len = array.length - 1;
                var item = array[index];
                for(var i = index; i < len; i++)array[i] = array[i + 1];
                array.length = len;
                return item;
            };
            module1.exports = SpliceOne;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Events
 */ module1.exports = {
                ADDED_TO_SCENE: __webpack_require__(641),
                DESTROY: __webpack_require__(642),
                REMOVED_FROM_SCENE: __webpack_require__(643),
                VIDEO_COMPLETE: __webpack_require__(644),
                VIDEO_CREATED: __webpack_require__(645),
                VIDEO_ERROR: __webpack_require__(646),
                VIDEO_LOOP: __webpack_require__(647),
                VIDEO_PLAY: __webpack_require__(648),
                VIDEO_SEEKED: __webpack_require__(649),
                VIDEO_SEEKING: __webpack_require__(650),
                VIDEO_STOP: __webpack_require__(651),
                VIDEO_TIMEOUT: __webpack_require__(652),
                VIDEO_UNLOCKED: __webpack_require__(653)
            };
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using floor.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10`.
 * As will `14` snap to `10`... but `16` will snap to `15`.
 *
 * @function Phaser.Math.Snap.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapFloor = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.floor(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapFloor;
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shallow Object Clone. Will not clone nested objects.
 *
 * @function Phaser.Utils.Objects.Clone
 * @since 3.0.0
 *
 * @param {object} obj - The object to clone.
 *
 * @return {object} A new object with the same properties as the input object.
 */ var Clone = function(obj) {
                var clone = {};
                for(var key in obj)if (Array.isArray(obj[key])) clone[key] = obj[key].slice(0);
                else clone[key] = obj[key];
                return clone;
            };
            module1.exports = Clone;
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if the start and end indexes are a safe range for the given array.
 * 
 * @function Phaser.Utils.Array.SafeRange
 * @since 3.4.0
 *
 * @param {array} array - The array to check.
 * @param {number} startIndex - The start index.
 * @param {number} endIndex - The end index.
 * @param {boolean} [throwError=true] - Throw an error if the range is out of bounds.
 *
 * @return {boolean} True if the range is safe, otherwise false.
 */ var SafeRange = function(array, startIndex, endIndex, throwError) {
                var len = array.length;
                if (startIndex < 0 || startIndex > len || startIndex >= endIndex || endIndex > len || startIndex + endIndex > len) {
                    if (throwError) throw new Error('Range Error: Values outside acceptable range');
                    return false;
                } else return true;
            };
            module1.exports = SafeRange;
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Angry Bytes (and contributors)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The comparator function.
 *
 * @ignore
 *
 * @param {*} a - The first item to test.
 * @param {*} b - The second itemt to test.
 *
 * @return {boolean} True if they localCompare, otherwise false.
 */ function Compare(a, b) {
                return String(a).localeCompare(b);
            }
            /**
 * Process the array contents.
 *
 * @ignore
 *
 * @param {array} array - The array to process.
 * @param {function} compare - The comparison function.
 *
 * @return {array} - The processed array.
 */ function Process(array, compare) {
                // Short-circuit when there's nothing to sort.
                var len = array.length;
                if (len <= 1) return array;
                // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
                // Chunks are the size of the left or right hand in merge sort.
                // Stop when the left-hand covers all of the array.
                var buffer = new Array(len);
                for(var chk = 1; chk < len; chk *= 2){
                    RunPass(array, compare, chk, buffer);
                    var tmp = array;
                    array = buffer;
                    buffer = tmp;
                }
                return array;
            }
            /**
 * Run a single pass with the given chunk size.
 *
 * @ignore
 *
 * @param {array} arr - The array to run the pass on.
 * @param {function} comp - The comparison function.
 * @param {number} chk - The number of iterations.
 * @param {array} result - The array to store the result in.
 */ function RunPass(arr, comp, chk, result) {
                var len = arr.length;
                var i = 0;
                // Step size / double chunk size.
                var dbl = chk * 2;
                // Bounds of the left and right chunks.
                var l, r, e;
                // Iterators over the left and right chunk.
                var li, ri;
                // Iterate over pairs of chunks.
                for(l = 0; l < len; l += dbl){
                    r = l + chk;
                    e = r + chk;
                    if (r > len) r = len;
                    if (e > len) e = len;
                    // Iterate both chunks in parallel.
                    li = l;
                    ri = r;
                    while(true){
                        // Compare the chunks.
                        if (li < r && ri < e) {
                            // This works for a regular `sort()` compatible comparator,
                            // but also for a simple comparator like: `a > b`
                            if (comp(arr[li], arr[ri]) <= 0) result[i++] = arr[li++];
                            else result[i++] = arr[ri++];
                        } else if (li < r) // Nothing to compare, just flush what's left.
                        result[i++] = arr[li++];
                        else if (ri < e) result[i++] = arr[ri++];
                        else break;
                    }
                }
            }
            /**
 * An in-place stable array sort, because `Array#sort()` is not guaranteed stable.
 *
 * This is an implementation of merge sort, without recursion.
 *
 * Function based on the Two-Screen/stable sort 0.1.8 from https://github.com/Two-Screen/stable
 *
 * @function Phaser.Utils.Array.StableSort
 * @since 3.0.0
 *
 * @param {array} array - The input array to be sorted.
 * @param {function} [compare] - The comparison function.
 *
 * @return {array} The sorted result.
 */ var StableSort = function(array, compare) {
                if (compare === undefined) compare = Compare;
                var result = Process(array, compare);
                // This simply copies back if the result isn't in the original array, which happens on an odd number of passes.
                if (result !== array) RunPass(result, null, array.length, array);
                return array;
            };
            module1.exports = StableSort;
        /***/ },
        /* 80 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EaseMap = __webpack_require__(132);
            var UppercaseFirst = __webpack_require__(202);
            /**
 * This internal function is used to return the correct ease function for a Tween.
 * 
 * It can take a variety of input, including an EaseMap based string, or a custom function.
 *
 * @function Phaser.Tweens.Builders.GetEaseFunction
 * @since 3.0.0
 *
 * @param {(string|function)} ease - The ease to find. This can be either a string from the EaseMap, or a custom function.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {function} The ease function.
 */ var GetEaseFunction = function(ease, easeParams) {
                //  Default ease function
                var easeFunction = EaseMap.Power0;
                //  Prepare ease function
                if (typeof ease === 'string') {
                    //  String based look-up
                    //  1) They specified it correctly
                    if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                    else {
                        //  Do some string manipulation to try and find it
                        var direction = '';
                        if (ease.indexOf('.')) {
                            //  quad.in = Quad.easeIn
                            //  quad.out = Quad.easeOut
                            //  quad.inout = Quad.easeInOut
                            direction = ease.substr(ease.indexOf('.') + 1);
                            if (direction.toLowerCase() === 'in') direction = 'easeIn';
                            else if (direction.toLowerCase() === 'out') direction = 'easeOut';
                            else if (direction.toLowerCase() === 'inout') direction = 'easeInOut';
                        }
                        ease = UppercaseFirst(ease.substr(0, ease.indexOf('.') + 1) + direction);
                        if (EaseMap.hasOwnProperty(ease)) easeFunction = EaseMap[ease];
                    }
                } else if (typeof ease === 'function') //  Custom function
                easeFunction = ease;
                else Array.isArray(ease) && ease.length;
                //  No custom ease parameters?
                if (!easeParams) //  Return ease function
                return easeFunction;
                var cloneParams = easeParams.slice(0);
                cloneParams.unshift(0);
                //  Return ease function with custom ease parameters
                return function(v) {
                    cloneParams[0] = v;
                    return easeFunction.apply(this, cloneParams);
                };
            };
            module1.exports = GetEaseFunction;
        /***/ },
        /* 81 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders a stroke outline around the given Shape.
 *
 * @method Phaser.GameObjects.Shape#StrokePathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var StrokePathWebGL = function(pipeline, src, alpha, dx, dy) {
                var strokeTint = pipeline.strokeTint;
                var strokeTintColor = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                strokeTint.TL = strokeTintColor;
                strokeTint.TR = strokeTintColor;
                strokeTint.BL = strokeTintColor;
                strokeTint.BR = strokeTintColor;
                var path = src.pathData;
                var pathLength = path.length - 1;
                var lineWidth = src.lineWidth;
                var halfLineWidth = lineWidth / 2;
                var px1 = path[0] - dx;
                var py1 = path[1] - dy;
                if (!src.closePath) pathLength -= 2;
                for(var i = 2; i < pathLength; i += 2){
                    var px2 = path[i] - dx;
                    var py2 = path[i + 1] - dy;
                    pipeline.batchLine(px1, py1, px2, py2, halfLineWidth, halfLineWidth, lineWidth, i - 2, src.closePath ? i === pathLength - 1 : false);
                    px1 = px2;
                    py1 = py2;
                }
            };
            module1.exports = StrokePathWebGL;
        /***/ },
        /* 82 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(112);
            var GetPoint = __webpack_require__(470);
            var GetPoints = __webpack_require__(471);
            var GEOM_CONST = __webpack_require__(55);
            var Line = __webpack_require__(45);
            var Random = __webpack_require__(178);
            /**
 * @classdesc
 * A triangle is a plane created by connecting three points.
 * The first two arguments specify the first point, the middle two arguments
 * specify the second point, and the last two arguments specify the third point.
 *
 * @class Triangle
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x1=0] - `x` coordinate of the first point.
 * @param {number} [y1=0] - `y` coordinate of the first point.
 * @param {number} [x2=0] - `x` coordinate of the second point.
 * @param {number} [y2=0] - `y` coordinate of the second point.
 * @param {number} [x3=0] - `x` coordinate of the third point.
 * @param {number} [y3=0] - `y` coordinate of the third point.
 */ var Triangle = new Class({
                initialize: function Triangle(x1, y1, x2, y2, x3, y3) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 0;
                    if (y3 === undefined) y3 = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.TRIANGLE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Triangle#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.TRIANGLE;
                    /**
         * `x` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#x1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x1 = x1;
                    /**
         * `y` coordinate of the first point.
         *
         * @name Phaser.Geom.Triangle#y1
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y1 = y1;
                    /**
         * `x` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#x2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x2 = x2;
                    /**
         * `y` coordinate of the second point.
         *
         * @name Phaser.Geom.Triangle#y2
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y2 = y2;
                    /**
         * `x` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#x3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x3 = x3;
                    /**
         * `y` coordinate of the third point.
         *
         * @name Phaser.Geom.Triangle#y3
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y3 = y3;
                },
                /**
     * Checks whether a given points lies within the triangle.
     *
     * @method Phaser.Geom.Triangle#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point to check.
     * @param {number} y - The y coordinate of the point to check.
     *
     * @return {boolean} `true` if the coordinate pair is within the triangle, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a specific point  on the triangle.
     *
     * @method Phaser.Geom.Triangle#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [output,$return]
     *
     * @param {number} position - Position as float within `0` and `1`. `0` equals the first point.
     * @param {(Phaser.Geom.Point|object)} [output] - Optional Point, or point-like object, that the calculated point will be written to.
     *
     * @return {(Phaser.Geom.Point|object)} Calculated `Point` that represents the requested position. It is the same as `output` when this parameter has been given.
     */ getPoint: function(position, output) {
                    return GetPoint(this, position, output);
                },
                /**
     * Calculates a list of evenly distributed points on the triangle. It is either possible to pass an amount of points to be generated (`quantity`) or the distance between two points (`stepRate`).
     *
     * @method Phaser.Geom.Triangle#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - Number of points to be generated. Can be falsey when `stepRate` should be used. All points have the same distance along the triangle.
     * @param {number} [stepRate] - Distance between two points. Will only be used when `quantity` is falsey.
     * @param {(array|Phaser.Geom.Point[])} [output] - Optional Array for writing the calculated points into. Otherwise a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} Returns a list of calculated `Point` instances or the filled array passed as parameter `output`.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a random point along the triangle.
     *
     * @method Phaser.Geom.Triangle#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {Phaser.Geom.Point} [point] - Optional `Point` that should be modified. Otherwise a new one will be created.
     *
     * @return {Phaser.Geom.Point} Random `Point`. When parameter `point` has been provided it will be returned.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets all three points of the triangle. Leaving out any coordinate sets it to be `0`.
     *
     * @method Phaser.Geom.Triangle#setTo
     * @since 3.0.0
     *
     * @param {number} [x1=0] - `x` coordinate of the first point.
     * @param {number} [y1=0] - `y` coordinate of the first point.
     * @param {number} [x2=0] - `x` coordinate of the second point.
     * @param {number} [y2=0] - `y` coordinate of the second point.
     * @param {number} [x3=0] - `x` coordinate of the third point.
     * @param {number} [y3=0] - `y` coordinate of the third point.
     *
     * @return {this} This Triangle object.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 0;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 0;
                    if (y3 === undefined) y3 = 0;
                    this.x1 = x1;
                    this.y1 = y1;
                    this.x2 = x2;
                    this.y2 = y2;
                    this.x3 = x3;
                    this.y3 = y3;
                    return this;
                },
                /**
     * Returns a Line object that corresponds to Line A of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineA
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line A of this Triangle.
     */ getLineA: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x1, this.y1, this.x2, this.y2);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to Line B of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineB
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line B of this Triangle.
     */ getLineB: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x2, this.y2, this.x3, this.y3);
                    return line;
                },
                /**
     * Returns a Line object that corresponds to Line C of this Triangle.
     *
     * @method Phaser.Geom.Triangle#getLineC
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Line} O - [line,$return]
     *
     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
     *
     * @return {Phaser.Geom.Line} A Line object that corresponds to line C of this Triangle.
     */ getLineC: function(line) {
                    if (line === undefined) line = new Line();
                    line.setTo(this.x3, this.y3, this.x1, this.y1);
                    return line;
                },
                /**
     * Left most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return Math.min(this.x1, this.x2, this.x3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.x1 <= this.x2 && this.x1 <= this.x3) diff = this.x1 - value;
                        else if (this.x2 <= this.x1 && this.x2 <= this.x3) diff = this.x2 - value;
                        else diff = this.x3 - value;
                        this.x1 -= diff;
                        this.x2 -= diff;
                        this.x3 -= diff;
                    }
                },
                /**
     * Right most X coordinate of the triangle. Setting it moves the triangle on the X axis accordingly.
     *
     * @name Phaser.Geom.Triangle#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return Math.max(this.x1, this.x2, this.x3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.x1 >= this.x2 && this.x1 >= this.x3) diff = this.x1 - value;
                        else if (this.x2 >= this.x1 && this.x2 >= this.x3) diff = this.x2 - value;
                        else diff = this.x3 - value;
                        this.x1 -= diff;
                        this.x2 -= diff;
                        this.x3 -= diff;
                    }
                },
                /**
     * Top most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return Math.min(this.y1, this.y2, this.y3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.y1 <= this.y2 && this.y1 <= this.y3) diff = this.y1 - value;
                        else if (this.y2 <= this.y1 && this.y2 <= this.y3) diff = this.y2 - value;
                        else diff = this.y3 - value;
                        this.y1 -= diff;
                        this.y2 -= diff;
                        this.y3 -= diff;
                    }
                },
                /**
     * Bottom most Y coordinate of the triangle. Setting it moves the triangle on the Y axis accordingly.
     *
     * @name Phaser.Geom.Triangle#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return Math.max(this.y1, this.y2, this.y3);
                    },
                    set: function(value) {
                        var diff = 0;
                        if (this.y1 >= this.y2 && this.y1 >= this.y3) diff = this.y1 - value;
                        else if (this.y2 >= this.y1 && this.y2 >= this.y3) diff = this.y2 - value;
                        else diff = this.y3 - value;
                        this.y1 -= diff;
                        this.y2 -= diff;
                        this.y3 -= diff;
                    }
                }
            });
            module1.exports = Triangle;
        /***/ },
        /* 83 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Rectangle = __webpack_require__(496);
            /**
 * @classdesc
 * A Tile is a representation of a single tile within the Tilemap. This is a lightweight data
 * representation, so its position information is stored without factoring in scroll, layer
 * scale or layer position.
 *
 * @class Tile
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The LayerData object in the Tilemap that this tile belongs to.
 * @param {number} index - The unique index of this tile within the map.
 * @param {number} x - The x coordinate of this tile in tile coordinates.
 * @param {number} y - The y coordinate of this tile in tile coordinates.
 * @param {number} width - Width of the tile in pixels.
 * @param {number} height - Height of the tile in pixels.
 * @param {number} baseWidth - The base width a tile in the map (in pixels). Tiled maps support
 * multiple tileset sizes within one map, but they are still placed at intervals of the base
 * tile width.
 * @param {number} baseHeight - The base height of the tile in pixels (in pixels). Tiled maps
 * support multiple tileset sizes within one map, but they are still placed at intervals of the
 * base tile height.
 */ var Tile = new Class({
                Mixins: [
                    Components.Alpha,
                    Components.Flip,
                    Components.Visible
                ],
                initialize: function Tile(layer, index, x, y, width, height, baseWidth, baseHeight) {
                    /**
         * The LayerData in the Tilemap data that this tile belongs to.
         *
         * @name Phaser.Tilemaps.Tile#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.0.0
         */ this.layer = layer;
                    /**
         * The index of this tile within the map data corresponding to the tileset, or -1 if this
         * represents a blank tile.
         *
         * @name Phaser.Tilemaps.Tile#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * The x map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y map coordinate of this tile in tile units.
         *
         * @name Phaser.Tilemaps.Tile#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the tile in pixels.
         *
         * @name Phaser.Tilemaps.Tile#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The right of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#right
         * @type {number}
         * @since 3.50.0
         */ this.right;
                    /**
         * The bottom of the tile in pixels.
         *
         * Set in the `updatePixelXY` method.
         *
         * @name Phaser.Tilemaps.Tile#bottom
         * @type {number}
         * @since 3.50.0
         */ this.bottom;
                    /**
         * The maps base width of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseWidth = baseWidth !== undefined ? baseWidth : width;
                    /**
         * The maps base height of a tile in pixels. Tiled maps support multiple tileset sizes
         * within one map, but they are still placed at intervals of the base tile size.
         *
         * @name Phaser.Tilemaps.Tile#baseHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseHeight = baseHeight !== undefined ? baseHeight : height;
                    /**
         * The x coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelX
         * @type {number}
         * @since 3.0.0
         */ this.pixelX = 0;
                    /**
         * The y coordinate of the top left of this tile in pixels. This is relative to the top left
         * of the layer this tile is being rendered within. This property does NOT factor in camera
         * scroll, layer scale or layer position.
         *
         * @name Phaser.Tilemaps.Tile#pixelY
         * @type {number}
         * @since 3.0.0
         */ this.pixelY = 0;
                    this.updatePixelXY();
                    /**
         * Tile specific properties. These usually come from Tiled.
         *
         * @name Phaser.Tilemaps.Tile#properties
         * @type {any}
         * @since 3.0.0
         */ this.properties = {};
                    /**
         * The rotation angle of this tile.
         *
         * @name Phaser.Tilemaps.Tile#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = 0;
                    /**
         * Whether the tile should collide with any object on the left side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.collideLeft = false;
                    /**
         * Whether the tile should collide with any object on the right side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideRight
         * @type {boolean}
         * @since 3.0.0
         */ this.collideRight = false;
                    /**
         * Whether the tile should collide with any object on the top side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideUp
         * @type {boolean}
         * @since 3.0.0
         */ this.collideUp = false;
                    /**
         * Whether the tile should collide with any object on the bottom side.
         *
         * This property is used by Arcade Physics only, however, you can also use it
         * in your own checks.
         *
         * @name Phaser.Tilemaps.Tile#collideDown
         * @type {boolean}
         * @since 3.0.0
         */ this.collideDown = false;
                    /**
         * Whether the tiles left edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceLeft
         * @type {boolean}
         * @since 3.0.0
         */ this.faceLeft = false;
                    /**
         * Whether the tiles right edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceRight
         * @type {boolean}
         * @since 3.0.0
         */ this.faceRight = false;
                    /**
         * Whether the tiles top edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceTop
         * @type {boolean}
         * @since 3.0.0
         */ this.faceTop = false;
                    /**
         * Whether the tiles bottom edge is interesting for collisions.
         *
         * @name Phaser.Tilemaps.Tile#faceBottom
         * @type {boolean}
         * @since 3.0.0
         */ this.faceBottom = false;
                    /**
         * Tile collision callback.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallback
         * @type {function}
         * @since 3.0.0
         */ this.collisionCallback = undefined;
                    /**
         * The context in which the collision callback will be called.
         *
         * @name Phaser.Tilemaps.Tile#collisionCallbackContext
         * @type {object}
         * @since 3.0.0
         */ this.collisionCallbackContext = this;
                    /**
         * The tint to apply to this tile. Note: tint is currently a single color value instead of
         * the 4 corner tint component on other GameObjects.
         *
         * @name Phaser.Tilemaps.Tile#tint
         * @type {number}
         * @default
         * @since 3.0.0
         */ this.tint = 0xffffff;
                    /**
         * An empty object where physics-engine specific information (e.g. bodies) may be stored.
         *
         * @name Phaser.Tilemaps.Tile#physics
         * @type {object}
         * @since 3.0.0
         */ this.physics = {};
                },
                /**
     * Check if the given x and y world coordinates are within this Tile. This does not factor in
     * camera scroll, layer scale or layer position.
     *
     * @method Phaser.Tilemaps.Tile#containsPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to test.
     * @param {number} y - The y coordinate to test.
     *
     * @return {boolean} True if the coordinates are within this Tile, otherwise false.
     */ containsPoint: function(x, y) {
                    return !(x < this.pixelX || y < this.pixelY || x > this.right || y > this.bottom);
                },
                /**
     * Copies the tile data & properties from the given tile to this tile. This copies everything
     * except for position and interesting faces.
     *
     * @method Phaser.Tilemaps.Tile#copy
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The tile to copy from.
     *
     * @return {this} This Tile object instance.
     */ copy: function(tile) {
                    this.index = tile.index;
                    this.alpha = tile.alpha;
                    this.properties = tile.properties;
                    this.visible = tile.visible;
                    this.setFlip(tile.flipX, tile.flipY);
                    this.tint = tile.tint;
                    this.rotation = tile.rotation;
                    this.collideUp = tile.collideUp;
                    this.collideDown = tile.collideDown;
                    this.collideLeft = tile.collideLeft;
                    this.collideRight = tile.collideRight;
                    this.collisionCallback = tile.collisionCallback;
                    this.collisionCallbackContext = tile.collisionCallbackContext;
                    return this;
                },
                /**
     * The collision group for this Tile, defined within the Tileset. This returns a reference to
     * the collision group stored within the Tileset, so any modification of the returned object
     * will impact all tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getCollisionGroup
     * @since 3.0.0
     *
     * @return {?object} The collision group for this Tile, as defined in the Tileset, or `null` if no group was defined.
     */ getCollisionGroup: function() {
                    return this.tileset ? this.tileset.getTileCollisionGroup(this.index) : null;
                },
                /**
     * The tile data for this Tile, defined within the Tileset. This typically contains Tiled
     * collision data, tile animations and terrain information. This returns a reference to the tile
     * data stored within the Tileset, so any modification of the returned object will impact all
     * tiles that have the same index as this tile.
     *
     * @method Phaser.Tilemaps.Tile#getTileData
     * @since 3.0.0
     *
     * @return {?object} The tile data for this Tile, as defined in the Tileset, or `null` if no data was defined.
     */ getTileData: function() {
                    return this.tileset ? this.tileset.getTileData(this.index) : null;
                },
                /**
     * Gets the world X position of the left side of the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getLeft
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The left (x) value of this tile.
     */ getLeft: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? tilemapLayer.tileToWorldX(this.x, camera) : this.x * this.baseWidth;
                },
                /**
     * Gets the world X position of the right side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getRight
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The right (x) value of this tile.
     */ getRight: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? this.getLeft(camera) + this.width * tilemapLayer.scaleX : this.getLeft(camera) + this.width;
                },
                /**
     * Gets the world Y position of the top side of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getTop
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The top (y) value of this tile.
     */ getTop: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    // Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile in grid
                    // units is the bottom left, so the y coordinate needs to be adjusted by the difference
                    // between the base size and this tile's size.
                    return tilemapLayer ? tilemapLayer.tileToWorldY(this.y, camera) - (this.height - this.baseHeight) * tilemapLayer.scaleY : this.y * this.baseHeight - (this.height - this.baseHeight);
                },
                /**
     * Gets the world Y position of the bottom side of the tile, factoring in the layer's position,
     * scale and scroll.

     * @method Phaser.Tilemaps.Tile#getBottom
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The bottom (y) value of this tile.
     */ getBottom: function(camera) {
                    var tilemapLayer = this.tilemapLayer;
                    return tilemapLayer ? this.getTop(camera) + this.height * tilemapLayer.scaleY : this.getTop(camera) + this.height;
                },
                /**
     * Gets the world rectangle bounding box for the tile, factoring in the layers position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object to store the results in.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The bounds of this Tile.
     */ getBounds: function(camera, output) {
                    if (output === undefined) output = new Rectangle();
                    output.x = this.getLeft();
                    output.y = this.getTop();
                    output.width = this.getRight() - output.x;
                    output.height = this.getBottom() - output.y;
                    return output;
                },
                /**
     * Gets the world X position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterX
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center x position of this Tile.
     */ getCenterX: function(camera) {
                    return (this.getLeft(camera) + this.getRight(camera)) / 2;
                },
                /**
     * Gets the world Y position of the center of the tile, factoring in the layer's position,
     * scale and scroll.
     *
     * @method Phaser.Tilemaps.Tile#getCenterY
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
     *
     * @return {number} The center y position of this Tile.
     */ getCenterY: function(camera) {
                    return (this.getTop(camera) + this.getBottom(camera)) / 2;
                },
                /**
     * Check for intersection with this tile. This does not factor in camera scroll, layer scale or
     * layer position.
     *
     * @method Phaser.Tilemaps.Tile#intersects
     * @since 3.0.0
     *
     * @param {number} x - The x axis in pixels.
     * @param {number} y - The y axis in pixels.
     * @param {number} right - The right point.
     * @param {number} bottom - The bottom point.
     *
     * @return {boolean} `true` if the Tile intersects with the given dimensions, otherwise `false`.
     */ intersects: function(x, y, right, bottom) {
                    return !(right <= this.pixelX || bottom <= this.pixelY || x >= this.right || y >= this.bottom);
                },
                /**
     * Checks if the tile is interesting.
     *
     * @method Phaser.Tilemaps.Tile#isInteresting
     * @since 3.0.0
     *
     * @param {boolean} collides - If true, will consider the tile interesting if it collides on any side.
     * @param {boolean} faces - If true, will consider the tile interesting if it has an interesting face.
     *
     * @return {boolean} True if the Tile is interesting, otherwise false.
     */ isInteresting: function(collides, faces) {
                    if (collides && faces) return this.canCollide || this.hasInterestingFace;
                    else if (collides) return this.collides;
                    else if (faces) return this.hasInterestingFace;
                    return false;
                },
                /**
     * Reset collision status flags.
     *
     * @method Phaser.Tilemaps.Tile#resetCollision
     * @since 3.0.0
     *
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ resetCollision: function(recalculateFaces) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    this.collideLeft = false;
                    this.collideRight = false;
                    this.collideUp = false;
                    this.collideDown = false;
                    this.faceTop = false;
                    this.faceBottom = false;
                    this.faceLeft = false;
                    this.faceRight = false;
                    if (recalculateFaces) {
                        var tilemapLayer = this.tilemapLayer;
                        if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                    }
                    return this;
                },
                /**
     * Reset faces.
     *
     * @method Phaser.Tilemaps.Tile#resetFaces
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ resetFaces: function() {
                    this.faceTop = false;
                    this.faceBottom = false;
                    this.faceLeft = false;
                    this.faceRight = false;
                    return this;
                },
                /**
     * Sets the collision flags for each side of this tile and updates the interesting faces list.
     *
     * @method Phaser.Tilemaps.Tile#setCollision
     * @since 3.0.0
     *
     * @param {boolean} left - Indicating collide with any object on the left.
     * @param {boolean} [right] - Indicating collide with any object on the right.
     * @param {boolean} [up] - Indicating collide with any object on the top.
     * @param {boolean} [down] - Indicating collide with any object on the bottom.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
     *
     * @return {this} This Tile object instance.
     */ setCollision: function(left, right, up, down, recalculateFaces) {
                    if (right === undefined) right = left;
                    if (up === undefined) up = left;
                    if (down === undefined) down = left;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    this.collideLeft = left;
                    this.collideRight = right;
                    this.collideUp = up;
                    this.collideDown = down;
                    this.faceLeft = left;
                    this.faceRight = right;
                    this.faceTop = up;
                    this.faceBottom = down;
                    if (recalculateFaces) {
                        var tilemapLayer = this.tilemapLayer;
                        if (tilemapLayer) this.tilemapLayer.calculateFacesAt(this.x, this.y);
                    }
                    return this;
                },
                /**
     * Set a callback to be called when this tile is hit by an object. The callback must true for
     * collision processing to take place.
     *
     * @method Phaser.Tilemaps.Tile#setCollisionCallback
     * @since 3.0.0
     *
     * @param {function} callback - Callback function.
     * @param {object} context - Callback will be called within this context.
     *
     * @return {this} This Tile object instance.
     */ setCollisionCallback: function(callback, context) {
                    if (callback === null) {
                        this.collisionCallback = undefined;
                        this.collisionCallbackContext = undefined;
                    } else {
                        this.collisionCallback = callback;
                        this.collisionCallbackContext = context;
                    }
                    return this;
                },
                /**
     * Sets the size of the tile and updates its pixelX and pixelY.
     *
     * @method Phaser.Tilemaps.Tile#setSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tile in pixels.
     * @param {number} tileHeight - The height of the tile in pixels.
     * @param {number} baseWidth - The base width a tile in the map (in pixels).
     * @param {number} baseHeight - The base height of the tile in pixels (in pixels).
     *
     * @return {this} This Tile object instance.
     */ setSize: function(tileWidth, tileHeight, baseWidth, baseHeight) {
                    if (tileWidth !== undefined) this.width = tileWidth;
                    if (tileHeight !== undefined) this.height = tileHeight;
                    if (baseWidth !== undefined) this.baseWidth = baseWidth;
                    if (baseHeight !== undefined) this.baseHeight = baseHeight;
                    this.updatePixelXY();
                    return this;
                },
                /**
     * Used internally. Updates the tiles world XY position based on the current tile size.
     *
     * @method Phaser.Tilemaps.Tile#updatePixelXY
     * @since 3.0.0
     *
     * @return {this} This Tile object instance.
     */ updatePixelXY: function() {
                    var orientation = this.layer.orientation;
                    if (orientation === CONST.ORTHOGONAL) {
                        //  In orthogonal mode, Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile is the
                        //  bottom left, while the Phaser renderer assumes the origin is the top left. The y
                        //  coordinate needs to be adjusted by the difference.
                        this.pixelX = this.x * this.baseWidth;
                        this.pixelY = this.y * this.baseHeight;
                    } else if (orientation === CONST.ISOMETRIC) {
                        //  Reminder: For the tilemap to be centered we have to move the image to the right with the camera!
                        //  This is crucial for wordtotile, tiletoworld to work.
                        this.pixelX = (this.x - this.y) * this.baseWidth * 0.5;
                        this.pixelY = (this.x + this.y) * this.baseHeight * 0.5;
                    } else if (orientation === CONST.STAGGERED) {
                        this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                        this.pixelY = this.y * (this.baseHeight / 2);
                    } else if (orientation === CONST.HEXAGONAL) {
                        var len = this.layer.hexSideLength;
                        var rowHeight = (this.baseHeight - len) / 2 + len;
                        this.pixelX = this.x * this.baseWidth + this.y % 2 * (this.baseWidth / 2);
                        this.pixelY = this.y * rowHeight;
                    }
                    this.right = this.pixelX + this.baseWidth;
                    this.bottom = this.pixelY + this.baseHeight;
                    return this;
                },
                /**
     * Clean up memory.
     *
     * @method Phaser.Tilemaps.Tile#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.collisionCallback = undefined;
                    this.collisionCallbackContext = undefined;
                    this.properties = undefined;
                },
                /**
     * True if this tile can collide on any of its faces or has a collision callback set.
     *
     * @name Phaser.Tilemaps.Tile#canCollide
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ canCollide: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.collisionCallback !== undefined;
                    }
                },
                /**
     * True if this tile can collide on any of its faces.
     *
     * @name Phaser.Tilemaps.Tile#collides
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ collides: {
                    get: function() {
                        return this.collideLeft || this.collideRight || this.collideUp || this.collideDown;
                    }
                },
                /**
     * True if this tile has any interesting faces.
     *
     * @name Phaser.Tilemaps.Tile#hasInterestingFace
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ hasInterestingFace: {
                    get: function() {
                        return this.faceTop || this.faceBottom || this.faceLeft || this.faceRight;
                    }
                },
                /**
     * The tileset that contains this Tile. This is null if accessed from a LayerData instance
     * before the tile is placed in a TilemapLayer, or if the tile has an index that doesn't correspond
     * to any of the maps tilesets.
     *
     * @name Phaser.Tilemaps.Tile#tileset
     * @type {?Phaser.Tilemaps.Tileset}
     * @readonly
     * @since 3.0.0
     */ tileset: {
                    get: function() {
                        var tilemapLayer = this.layer.tilemapLayer;
                        if (tilemapLayer) {
                            var tileset = tilemapLayer.gidMap[this.index];
                            if (tileset) return tileset;
                        }
                        return null;
                    }
                },
                /**
     * The tilemap layer that contains this Tile. This will only return null if accessed from a
     * LayerData instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemapLayer
     * @type {?Phaser.Tilemaps.TilemapLayer}
     * @readonly
     * @since 3.0.0
     */ tilemapLayer: {
                    get: function() {
                        return this.layer.tilemapLayer;
                    }
                },
                /**
     * The tilemap that contains this Tile. This will only return null if accessed from a LayerData
     * instance before the tile is placed within a TilemapLayer.
     *
     * @name Phaser.Tilemaps.Tile#tilemap
     * @type {?Phaser.Tilemaps.Tilemap}
     * @readonly
     * @since 3.0.0
     */ tilemap: {
                    get: function() {
                        var tilemapLayer = this.tilemapLayer;
                        return tilemapLayer ? tilemapLayer.tilemap : null;
                    }
                }
            });
            module1.exports = Tile;
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center x coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center x coordinate of the bounds of the Game Object.
 */ var GetCenterX = function(gameObject) {
                return gameObject.x - gameObject.width * gameObject.originX + gameObject.width * 0.5;
            };
            module1.exports = GetCenterX;
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterX = function(gameObject, x) {
                var offsetX = gameObject.width * gameObject.originX;
                gameObject.x = x + offsetX - gameObject.width * 0.5;
                return gameObject;
            };
            module1.exports = SetCenterX;
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the center y coordinate from the bounds of the Game Object.
 *
 * @function Phaser.Display.Bounds.GetCenterY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The center y coordinate of the bounds of the Game Object.
 */ var GetCenterY = function(gameObject) {
                return gameObject.y - gameObject.height * gameObject.originY + gameObject.height * 0.5;
            };
            module1.exports = GetCenterY;
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
 *
 * @function Phaser.Display.Bounds.SetCenterY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} y - The coordinate to position the Game Object bounds on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var SetCenterY = function(gameObject, y) {
                var offsetY = gameObject.height * gameObject.originY;
                gameObject.y = y + offsetY - gameObject.height * 0.5;
                return gameObject;
            };
            module1.exports = SetCenterY;
        /***/ },
        /* 88 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Events
 */ module1.exports = {
                POST_RENDER: __webpack_require__(626),
                PRE_RENDER: __webpack_require__(627),
                RENDER: __webpack_require__(628),
                RESIZE: __webpack_require__(629)
            };
        /***/ },
        /* 89 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes the given item, or array of items, from the array.
 *
 * The array is modified in-place.
 *
 * You can optionally specify a callback to be invoked for each item successfully removed from the array.
 *
 * @function Phaser.Utils.Array.Remove
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {*|Array.<*>} item - The item, or array of items, to be removed from the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*|Array.<*>} The item, or array of items, that were successfully removed from the array.
 */ var Remove = function(array, item, callback, context) {
                if (context === undefined) context = array;
                var index;
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    index = array.indexOf(item);
                    if (index !== -1) {
                        SpliceOne(array, index);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to remove
                var itemLength = item.length - 1;
                var removed = [];
                while(itemLength >= 0){
                    var entry = item[itemLength];
                    index = array.indexOf(entry);
                    if (index !== -1) {
                        SpliceOne(array, index);
                        removed.push(entry);
                        if (callback) callback.call(context, entry);
                    }
                    itemLength--;
                }
                return removed;
            };
            module1.exports = Remove;
        /***/ },
        /* 90 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FromPoints = __webpack_require__(196);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Base Curve class, which all other curve types extend.
 *
 * Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
 *
 * @class Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {string} type - The curve type.
 */ var Curve = new Class({
                initialize: function Curve(type) {
                    /**
         * String based identifier for the type of curve.
         *
         * @name Phaser.Curves.Curve#type
         * @type {string}
         * @since 3.0.0
         */ this.type = type;
                    /**
         * The default number of divisions within the curve.
         *
         * @name Phaser.Curves.Curve#defaultDivisions
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.defaultDivisions = 5;
                    /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Curve#arcLengthDivisions
         * @type {number}
         * @default 100
         * @since 3.0.0
         */ this.arcLengthDivisions = 100;
                    /**
         * An array of cached arc length values.
         *
         * @name Phaser.Curves.Curve#cacheArcLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheArcLengths = [];
                    /**
         * Does the data of this curve need updating?
         *
         * @name Phaser.Curves.Curve#needsUpdate
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.needsUpdate = true;
                    /**
         * For a curve on a Path, `false` means the Path will ignore this curve.
         *
         * @name Phaser.Curves.Curve#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                    /**
         * A temporary calculation Vector.
         *
         * @name Phaser.Curves.Curve#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                },
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Curve#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     * @param {number} [pointsTotal=32] - The resolution of the curve. The higher the value the smoother it will render, at the cost of rendering performance.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    //  So you can chain graphics calls
                    return graphics.strokePoints(this.getPoints(pointsTotal));
                },
                /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * You can control the accuracy of the bounds. The value given is used to work out how many points
     * to plot across the curve. Higher values are more accurate at the cost of calculation speed.
     *
     * @method Phaser.Curves.Curve#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in. If falsey a new object will be created.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out, accuracy) {
                    if (!out) out = new Rectangle();
                    if (accuracy === undefined) accuracy = 16;
                    var len = this.getLength();
                    if (accuracy > len) accuracy = len / 2;
                    //  The length of the curve in pixels
                    //  So we'll have 1 spaced point per 'accuracy' pixels
                    var spaced = Math.max(1, Math.round(len / accuracy));
                    return FromPoints(this.getSpacedPoints(spaced), out);
                },
                /**
     * Returns an array of points, spaced out X distance pixels apart.
     * The smaller the distance, the larger the array will be.
     *
     * @method Phaser.Curves.Curve#getDistancePoints
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels, between each point along the curve.
     *
     * @return {Phaser.Geom.Point[]} An Array of Point objects.
     */ getDistancePoints: function(distance) {
                    var len = this.getLength();
                    var spaced = Math.max(1, len / distance);
                    return this.getSpacedPoints(spaced);
                },
                /**
     * Get a point at the end of the curve.
     *
     * @method Phaser.Curves.Curve#getEndPoint
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} [out] - Optional Vector object to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector2 containing the coordinates of the curves end point.
     */ getEndPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPointAt(1, out);
                },
                /**
     * Get total curve arc length
     *
     * @method Phaser.Curves.Curve#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the curve.
     */ getLength: function() {
                    var lengths = this.getLengths();
                    return lengths[lengths.length - 1];
                },
                /**
     * Get a list of cumulative segment lengths.
     *
     * These lengths are
     *
     * - [0] 0
     * - [1] The first segment
     * - [2] The first and second segment
     * - ...
     * - [divisions] All segments
     *
     * @method Phaser.Curves.Curve#getLengths
     * @since 3.0.0
     *
     * @param {number} [divisions] - The number of divisions or segments.
     *
     * @return {number[]} An array of cumulative lengths.
     */ getLengths: function(divisions) {
                    if (divisions === undefined) divisions = this.arcLengthDivisions;
                    if (this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                    this.needsUpdate = false;
                    var cache = [];
                    var current;
                    var last = this.getPoint(0, this._tmpVec2A);
                    var sum = 0;
                    cache.push(0);
                    for(var p = 1; p <= divisions; p++){
                        current = this.getPoint(p / divisions, this._tmpVec2B);
                        sum += current.distance(last);
                        cache.push(sum);
                        last.copy(current);
                    }
                    this.cacheArcLengths = cache;
                    return cache; // { sums: cache, sum:sum }; Sum is in the last element.
                },
                // Get point at relative position in curve according to arc length
                // - u [0 .. 1]
                /**
     * Get a point at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getPointAt: function(u, out) {
                    var t = this.getUtoTmapping(u);
                    return this.getPoint(t, out);
                },
                // Get sequence of points using getPoint( t )
                /**
     * Get a sequence of evenly spaced points from the curve.
     *
     * You can pass `divisions`, `stepRate`, or neither.
     *
     * The number of divisions will be
     *
     * 1. `divisions`, if `divisions` > 0; or
     * 2. `this.getLength / stepRate`, if `stepRate` > 0; or
     * 3. `this.defaultDivisions`
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2[]} O - [out,$return]
     *
     * @param {number} [divisions] - The number of divisions to make.
     * @param {number} [stepRate] - The curve distance between points, implying `divisions`.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {(array|Phaser.Math.Vector2[])} An array of Points from the curve.
     */ getPoints: function(divisions, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!divisions) {
                        if (!stepRate) divisions = this.defaultDivisions;
                        else divisions = this.getLength() / stepRate;
                    }
                    for(var d = 0; d <= divisions; d++)out.push(this.getPoint(d / divisions));
                    return out;
                },
                /**
     * Get a random point from the curve.
     *
     * @method Phaser.Curves.Curve#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point object to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getRandomPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(Math.random(), out);
                },
                // Get sequence of points using getPointAt( u )
                /**
     * Get a sequence of equally spaced points (by arc distance) from the curve.
     *
     * `1 + divisions` points will be returned.
     *
     * @method Phaser.Curves.Curve#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=this.defaultDivisions] - The number of divisions to make.
     * @param {number} [stepRate] - Step between points. Used to calculate the number of points to return when divisions is falsy. Ignored if divisions is positive.
     * @param {(array|Phaser.Math.Vector2[])} [out] - An optional array to store the points in.
     *
     * @return {Phaser.Math.Vector2[]} An array of points.
     */ getSpacedPoints: function(divisions, stepRate, out) {
                    if (out === undefined) out = [];
                    //  If divisions is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                    if (!divisions) {
                        if (!stepRate) divisions = this.defaultDivisions;
                        else divisions = this.getLength() / stepRate;
                    }
                    for(var d = 0; d <= divisions; d++){
                        var t = this.getUtoTmapping(d / divisions, null, divisions);
                        out.push(this.getPoint(t));
                    }
                    return out;
                },
                /**
     * Get a point at the start of the curve.
     *
     * @method Phaser.Curves.Curve#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A point to store the result in.
     *
     * @return {Phaser.Math.Vector2} The point.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPointAt(0, out);
                },
                /**
     * Get a unit vector tangent at a relative position on the curve.
     * In case any sub curve does not implement its tangent derivation,
     * 2 points a small delta apart will be used to find its gradient
     * which seems to give a reasonable approximation
     *
     * @method Phaser.Curves.Curve#getTangent
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var delta = 0.0001;
                    var t1 = t - delta;
                    var t2 = t + delta;
                    // Capping in case of danger
                    if (t1 < 0) t1 = 0;
                    if (t2 > 1) t2 = 1;
                    this.getPoint(t1, this._tmpVec2A);
                    this.getPoint(t2, out);
                    return out.subtract(this._tmpVec2A).normalize();
                },
                /**
     * Get a unit vector tangent at a relative position on the curve, by arc length.
     *
     * @method Phaser.Curves.Curve#getTangentAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The relative position on the curve, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangentAt: function(u, out) {
                    var t = this.getUtoTmapping(u);
                    return this.getTangent(t, out);
                },
                /**
     * Given a distance in pixels, get a t to find p.
     *
     * @method Phaser.Curves.Curve#getTFromDistance
     * @since 3.0.0
     *
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The distance.
     */ getTFromDistance: function(distance, divisions) {
                    if (distance <= 0) return 0;
                    return this.getUtoTmapping(0, distance, divisions);
                },
                /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Curve#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                    var arcLengths = this.getLengths(divisions);
                    var i = 0;
                    var il = arcLengths.length;
                    var targetArcLength; // The targeted u distance value to get
                    if (distance) //  Cannot overshoot the curve
                    targetArcLength = Math.min(distance, arcLengths[il - 1]);
                    else targetArcLength = u * arcLengths[il - 1];
                    // binary search for the index with largest value smaller than target u distance
                    var low = 0;
                    var high = il - 1;
                    var comparison;
                    while(low <= high){
                        i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                        comparison = arcLengths[i] - targetArcLength;
                        if (comparison < 0) low = i + 1;
                        else if (comparison > 0) high = i - 1;
                        else {
                            high = i;
                            break;
                        }
                    }
                    i = high;
                    if (arcLengths[i] === targetArcLength) return i / (il - 1);
                    // we could get finer grain at lengths, or use simple interpolation between two points
                    var lengthBefore = arcLengths[i];
                    var lengthAfter = arcLengths[i + 1];
                    var segmentLength = lengthAfter - lengthBefore;
                    // determine where we are between the 'before' and 'after' points
                    var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                    // add that fractional amount to t
                    return (i + segmentFraction) / (il - 1);
                },
                /**
     * Calculate and cache the arc lengths.
     *
     * @method Phaser.Curves.Curve#updateArcLengths
     * @since 3.0.0
     *
     * @see Phaser.Curves.Curve#getLengths()
     */ updateArcLengths: function() {
                    this.needsUpdate = true;
                    this.getLengths();
                }
            });
            module1.exports = Curve;
        /***/ },
        /* 91 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.Events
 */ module1.exports = {
                ADD: __webpack_require__(964),
                COMPLETE: __webpack_require__(965),
                FILE_COMPLETE: __webpack_require__(966),
                FILE_KEY_COMPLETE: __webpack_require__(967),
                FILE_LOAD_ERROR: __webpack_require__(968),
                FILE_LOAD: __webpack_require__(969),
                FILE_PROGRESS: __webpack_require__(970),
                POST_PROCESS: __webpack_require__(971),
                PROGRESS: __webpack_require__(972),
                START: __webpack_require__(973)
            };
        /***/ },
        /* 92 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            //  This is based off an explanation and expanded math presented by Paul Bourke:
            //  See http:'local.wasp.uwa.edu.au/~pbourke/geometry/lineline2d/
            /**
 * Checks if two Lines intersect. If the Lines are identical, they will be treated as parallel and thus non-intersecting.
 *
 * @function Phaser.Geom.Intersects.LineToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line1 - The first Line to check.
 * @param {Phaser.Geom.Line} line2 - The second Line to check.
 * @param {Phaser.Geom.Point} [out] - A Point in which to optionally store the point of intersection.
 *
 * @return {boolean} `true` if the two Lines intersect, and the `out` object will be populated, if given. Otherwise, `false`.
 */ var LineToLine = function(line1, line2, out) {
                if (out === undefined) out = new Point();
                var x1 = line1.x1;
                var y1 = line1.y1;
                var x2 = line1.x2;
                var y2 = line1.y2;
                var x3 = line2.x1;
                var y3 = line2.y1;
                var x4 = line2.x2;
                var y4 = line2.y2;
                var numA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
                var numB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
                var deNom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
                //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                if (deNom === 0) return false;
                //  Calculate the intermediate fractional point that the lines potentially intersect.
                var uA = numA / deNom;
                var uB = numB / deNom;
                //  The fractional point will be between 0 and 1 inclusive if the lines intersect.
                //  If the fractional calculation is larger than 1 or smaller than 0 the lines would need to be longer to intersect.
                if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
                    out.x = x1 + uA * (x2 - x1);
                    out.y = y1 + uA * (y2 - y1);
                    return true;
                }
                return false;
            };
            module1.exports = LineToLine;
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the angle of the line in radians.
 *
 * @function Phaser.Geom.Line.Angle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of.
 *
 * @return {number} The angle of the line, in radians.
 */ var Angle = function(line) {
                return Math.atan2(line.y2 - line.y1, line.x2 - line.x1);
            };
            module1.exports = Angle;
        /***/ },
        /* 94 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vertices
*/ var Vertices = {};
            module1.exports = Vertices;
            var Vector = __webpack_require__(116);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Creates a new set of `Matter.Body` compatible vertices.
     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
     * but with some additional references required for efficient collision detection routines.
     *
     * Vertices must be specified in clockwise order.
     *
     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
     *
     * @method create
     * @param {vector[]} points
     * @param {body} body
     */ Vertices.create = function(points, body) {
                    var vertices = [];
                    for(var i = 0; i < points.length; i++){
                        var point = points[i], vertex = {
                            x: point.x,
                            y: point.y,
                            index: i,
                            body: body,
                            isInternal: false,
                            contact: null,
                            offset: null
                        };
                        vertex.contact = {
                            vertex: vertex,
                            normalImpulse: 0,
                            tangentImpulse: 0
                        };
                        vertices.push(vertex);
                    }
                    return vertices;
                };
                /**
     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
     * into a `Matter.Vertices` object for the given `Matter.Body`.
     * For parsing SVG paths, see `Svg.pathToVertices`.
     * @method fromPath
     * @param {string} path
     * @param {body} body
     * @return {vertices} vertices
     */ Vertices.fromPath = function(path, body) {
                    var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig, points = [];
                    path.replace(pathPattern, function(match, x, y) {
                        points.push({
                            x: parseFloat(x),
                            y: parseFloat(y)
                        });
                    });
                    return Vertices.create(points, body);
                };
                /**
     * Returns the centre (centroid) of the set of vertices.
     * @method centre
     * @param {vertices} vertices
     * @return {vector} The centre point
     */ Vertices.centre = function(vertices) {
                    var area = Vertices.area(vertices, true), centre = {
                        x: 0,
                        y: 0
                    }, cross, temp, j;
                    for(var i = 0; i < vertices.length; i++){
                        j = (i + 1) % vertices.length;
                        cross = Vector.cross(vertices[i], vertices[j]);
                        temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
                        centre = Vector.add(centre, temp);
                    }
                    return Vector.div(centre, 6 * area);
                };
                /**
     * Returns the average (mean) of the set of vertices.
     * @method mean
     * @param {vertices} vertices
     * @return {vector} The average point
     */ Vertices.mean = function(vertices) {
                    var average = {
                        x: 0,
                        y: 0
                    };
                    for(var i = 0; i < vertices.length; i++){
                        average.x += vertices[i].x;
                        average.y += vertices[i].y;
                    }
                    return Vector.div(average, vertices.length);
                };
                /**
     * Returns the area of the set of vertices.
     * @method area
     * @param {vertices} vertices
     * @param {bool} signed
     * @return {number} The area
     */ Vertices.area = function(vertices, signed) {
                    var area = 0, j = vertices.length - 1;
                    for(var i = 0; i < vertices.length; i++){
                        area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
                        j = i;
                    }
                    if (signed) return area / 2;
                    return Math.abs(area) / 2;
                };
                /**
     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
     * @method inertia
     * @param {vertices} vertices
     * @param {number} mass
     * @return {number} The polygon's moment of inertia
     */ Vertices.inertia = function(vertices, mass) {
                    var numerator = 0, denominator = 0, v = vertices, cross, j;
                    // find the polygon's moment of inertia, using second moment of area
                    // from equations at http://www.physicsforums.com/showthread.php?t=25293
                    for(var n = 0; n < v.length; n++){
                        j = (n + 1) % v.length;
                        cross = Math.abs(Vector.cross(v[j], v[n]));
                        numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
                        denominator += cross;
                    }
                    return mass / 6 * (numerator / denominator);
                };
                /**
     * Translates the set of vertices in-place.
     * @method translate
     * @param {vertices} vertices
     * @param {vector} vector
     * @param {number} scalar
     */ Vertices.translate = function(vertices, vector, scalar) {
                    var i;
                    if (scalar) for(i = 0; i < vertices.length; i++){
                        vertices[i].x += vector.x * scalar;
                        vertices[i].y += vector.y * scalar;
                    }
                    else for(i = 0; i < vertices.length; i++){
                        vertices[i].x += vector.x;
                        vertices[i].y += vector.y;
                    }
                    return vertices;
                };
                /**
     * Rotates the set of vertices in-place.
     * @method rotate
     * @param {vertices} vertices
     * @param {number} angle
     * @param {vector} point
     */ Vertices.rotate = function(vertices, angle, point) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < vertices.length; i++){
                        var vertice = vertices[i], dx = vertice.x - point.x, dy = vertice.y - point.y;
                        vertice.x = point.x + (dx * cos - dy * sin);
                        vertice.y = point.y + (dx * sin + dy * cos);
                    }
                    return vertices;
                };
                /**
     * Returns `true` if the `point` is inside the set of `vertices`.
     * @method contains
     * @param {vertices} vertices
     * @param {vector} point
     * @return {boolean} True if the vertices contains point, otherwise false
     */ Vertices.contains = function(vertices, point) {
                    for(var i = 0; i < vertices.length; i++){
                        var vertice = vertices[i], nextVertice = vertices[(i + 1) % vertices.length];
                        if ((point.x - vertice.x) * (nextVertice.y - vertice.y) + (point.y - vertice.y) * (vertice.x - nextVertice.x) > 0) return false;
                    }
                    return true;
                };
                /**
     * Scales the vertices from a point (default is centre) in-place.
     * @method scale
     * @param {vertices} vertices
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     */ Vertices.scale = function(vertices, scaleX, scaleY, point) {
                    if (scaleX === 1 && scaleY === 1) return vertices;
                    point = point || Vertices.centre(vertices);
                    var vertex, delta;
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        delta = Vector.sub(vertex, point);
                        vertices[i].x = point.x + delta.x * scaleX;
                        vertices[i].y = point.y + delta.y * scaleY;
                    }
                    return vertices;
                };
                /**
     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
     * The radius parameter is a single number or an array to specify the radius for each vertex.
     * @method chamfer
     * @param {vertices} vertices
     * @param {number[]} radius
     * @param {number} quality
     * @param {number} qualityMin
     * @param {number} qualityMax
     */ Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
                    if (typeof radius === 'number') radius = [
                        radius
                    ];
                    else radius = radius || [
                        8
                    ];
                    // quality defaults to -1, which is auto
                    quality = typeof quality !== 'undefined' ? quality : -1;
                    qualityMin = qualityMin || 2;
                    qualityMax = qualityMax || 14;
                    var newVertices = [];
                    for(var i = 0; i < vertices.length; i++){
                        var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1], vertex = vertices[i], nextVertex = vertices[(i + 1) % vertices.length], currentRadius = radius[i < radius.length ? i : radius.length - 1];
                        if (currentRadius === 0) {
                            newVertices.push(vertex);
                            continue;
                        }
                        var prevNormal = Vector.normalise({
                            x: vertex.y - prevVertex.y,
                            y: prevVertex.x - vertex.x
                        });
                        var nextNormal = Vector.normalise({
                            x: nextVertex.y - vertex.y,
                            y: vertex.x - nextVertex.x
                        });
                        var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)), radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius), midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)), scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
                        var precision = quality;
                        if (quality === -1) // automatically decide precision
                        precision = Math.pow(currentRadius, 0.32) * 1.75;
                        precision = Common.clamp(precision, qualityMin, qualityMax);
                        // use an even value for precision, more likely to reduce axes by using symmetry
                        if (precision % 2 === 1) precision += 1;
                        var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)), theta = alpha / precision;
                        for(var j = 0; j < precision; j++)newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
                    }
                    return newVertices;
                };
                /**
     * Sorts the input vertices into clockwise order in place.
     * @method clockwiseSort
     * @param {vertices} vertices
     * @return {vertices} vertices
     */ Vertices.clockwiseSort = function(vertices) {
                    var centre = Vertices.mean(vertices);
                    vertices.sort(function(vertexA, vertexB) {
                        return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
                    });
                    return vertices;
                };
                /**
     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
     * @method isConvex
     * @param {vertices} vertices
     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
     */ Vertices.isConvex = function(vertices) {
                    // http://paulbourke.net/geometry/polygonmesh/
                    // Copyright (c) Paul Bourke (use permitted)
                    var flag = 0, n = vertices.length, i, j, k, z;
                    if (n < 3) return null;
                    for(i = 0; i < n; i++){
                        j = (i + 1) % n;
                        k = (i + 2) % n;
                        z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
                        z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
                        if (z < 0) flag |= 1;
                        else if (z > 0) flag |= 2;
                        if (flag === 3) return false;
                    }
                    if (flag !== 0) return true;
                    else return null;
                };
                /**
     * Returns the convex hull of the input vertices as a new array of points.
     * @method hull
     * @param {vertices} vertices
     * @return [vertex] vertices
     */ Vertices.hull = function(vertices) {
                    // http://geomalgorithms.com/a10-_hull-1.html
                    var upper = [], lower = [], vertex, i;
                    // sort vertices on x-axis (y-axis for ties)
                    vertices = vertices.slice(0);
                    vertices.sort(function(vertexA, vertexB) {
                        var dx = vertexA.x - vertexB.x;
                        return dx !== 0 ? dx : vertexA.y - vertexB.y;
                    });
                    // build lower hull
                    for(i = 0; i < vertices.length; i += 1){
                        vertex = vertices[i];
                        while(lower.length >= 2 && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0)lower.pop();
                        lower.push(vertex);
                    }
                    // build upper hull
                    for(i = vertices.length - 1; i >= 0; i -= 1){
                        vertex = vertices[i];
                        while(upper.length >= 2 && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0)upper.pop();
                        upper.push(vertex);
                    }
                    // concatenation of the lower and upper hulls gives the convex hull
                    // omit last points because they are repeated at the beginning of the other list
                    upper.pop();
                    lower.pop();
                    return upper.concat(lower);
                };
            })();
        /***/ },
        /* 95 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            /**
 * Return a value based on the range between `min` and `max` and the percentage given.
 *
 * @function Phaser.Math.FromPercent
 * @since 3.0.0
 *
 * @param {number} percent - A value between 0 and 1 representing the percentage.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 *
 * @return {number} The value that is `percent` percent between `min` and `max`.
 */ var FromPercent = function(percent, min, max) {
                percent = Clamp(percent, 0, 1);
                return (max - min) * percent;
            };
            module1.exports = FromPercent;
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Retrieves the value of the given key from an object.
 *
 * @function Phaser.Tweens.Builders.GetBoolean
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The key to look for in the `source` object.
 * @param {*} defaultValue - The default value to return if the `key` doesn't exist or if no `source` object is provided.
 *
 * @return {*} The retrieved value.
 */ var GetBoolean = function(source, key, defaultValue) {
                if (!source) return defaultValue;
                else if (source.hasOwnProperty(key)) return source[key];
                else return defaultValue;
            };
            module1.exports = GetBoolean;
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TWEEN_CONST = {
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.CREATED
     * @type {number}
     * @since 3.0.0
     */ CREATED: 0,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.INIT
     * @type {number}
     * @since 3.0.0
     */ INIT: 1,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.DELAY
     * @type {number}
     * @since 3.0.0
     */ DELAY: 2,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.OFFSET_DELAY
     * @type {number}
     * @since 3.0.0
     */ OFFSET_DELAY: 3,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PENDING_RENDER
     * @type {number}
     * @since 3.0.0
     */ PENDING_RENDER: 4,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PLAYING_FORWARD
     * @type {number}
     * @since 3.0.0
     */ PLAYING_FORWARD: 5,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.PLAYING_BACKWARD
     * @type {number}
     * @since 3.0.0
     */ PLAYING_BACKWARD: 6,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.HOLD_DELAY
     * @type {number}
     * @since 3.0.0
     */ HOLD_DELAY: 7,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.REPEAT_DELAY
     * @type {number}
     * @since 3.0.0
     */ REPEAT_DELAY: 8,
                /**
     * TweenData state.
     * 
     * @name Phaser.Tweens.COMPLETE
     * @type {number}
     * @since 3.0.0
     */ COMPLETE: 9,
                //  Tween specific (starts from 20 to cleanly allow extra TweenData consts in the future)
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PENDING_ADD
     * @type {number}
     * @since 3.0.0
     */ PENDING_ADD: 20,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PAUSED
     * @type {number}
     * @since 3.0.0
     */ PAUSED: 21,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.LOOP_DELAY
     * @type {number}
     * @since 3.0.0
     */ LOOP_DELAY: 22,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.ACTIVE
     * @type {number}
     * @since 3.0.0
     */ ACTIVE: 23,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.COMPLETE_DELAY
     * @type {number}
     * @since 3.0.0
     */ COMPLETE_DELAY: 24,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.PENDING_REMOVE
     * @type {number}
     * @since 3.0.0
     */ PENDING_REMOVE: 25,
                /**
     * Tween state.
     * 
     * @name Phaser.Tweens.REMOVED
     * @type {number}
     * @since 3.0.0
     */ REMOVED: 26
            };
            module1.exports = TWEEN_CONST;
        /***/ },
        /* 98 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(309);
            /**
 * @callback DataEachCallback
 *
 * @param {*} parent - The parent object of the DataManager.
 * @param {string} key - The key of the value.
 * @param {*} value - The value.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
 */ /**
 * @classdesc
 * The Data Manager Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {object} parent - The object that this DataManager belongs to.
 * @param {Phaser.Events.EventEmitter} [eventEmitter] - The DataManager's event emitter.
 */ var DataManager = new Class({
                initialize: function DataManager(parent, eventEmitter) {
                    /**
         * The object that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManager#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * The DataManager's event emitter.
         *
         * @name Phaser.Data.DataManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = eventEmitter;
                    if (!eventEmitter) this.events = parent.events ? parent.events : parent;
                    /**
         * The data list.
         *
         * @name Phaser.Data.DataManager#list
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                    /**
         * The public values list. You can use this to access anything you have stored
         * in this Data Manager. For example, if you set a value called `gold` you can
         * access it via:
         *
         * ```javascript
         * this.data.values.gold;
         * ```
         *
         * You can also modify it directly:
         *
         * ```javascript
         * this.data.values.gold += 1000;
         * ```
         *
         * Doing so will emit a `setdata` event from the parent of this Data Manager.
         *
         * Do not modify this object directly. Adding properties directly to this object will not
         * emit any events. Always use `DataManager.set` to create new items the first time around.
         *
         * @name Phaser.Data.DataManager#values
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.10.0
         */ this.values = {};
                    /**
         * Whether setting data is frozen for this DataManager.
         *
         * @name Phaser.Data.DataManager#_frozen
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._frozen = false;
                    if (!parent.hasOwnProperty('sys') && this.events) this.events.once(Events.DESTROY, this.destroy, this);
                },
                /**
     * Retrieves the value for the given key, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * this.data.get('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * this.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * this.data.get([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.Data.DataManager#get
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ get: function(key) {
                    var list = this.list;
                    if (Array.isArray(key)) {
                        var output = [];
                        for(var i = 0; i < key.length; i++)output.push(list[key[i]]);
                        return output;
                    } else return list[key];
                },
                /**
     * Retrieves all data values in a new object.
     *
     * @method Phaser.Data.DataManager#getAll
     * @since 3.0.0
     *
     * @return {Object.<string, *>} All data values.
     */ getAll: function() {
                    var results = {};
                    for(var key in this.list)if (this.list.hasOwnProperty(key)) results[key] = this.list[key];
                    return results;
                },
                /**
     * Queries the DataManager for the values of keys matching the given regular expression.
     *
     * @method Phaser.Data.DataManager#query
     * @since 3.0.0
     *
     * @param {RegExp} search - A regular expression object. If a non-RegExp object obj is passed, it is implicitly converted to a RegExp by using new RegExp(obj).
     *
     * @return {Object.<string, *>} The values of the keys matching the search string.
     */ query: function(search) {
                    var results = {};
                    for(var key in this.list)if (this.list.hasOwnProperty(key) && key.match(search)) results[key] = this.list[key];
                    return results;
                },
                /**
     * Sets a value for the given key. If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * data.set('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * data.set({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `get`:
     *
     * ```javascript
     * data.get('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#set
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object or key value pairs. If an object the `data` argument is ignored.
     * @param {*} data - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This DataManager object.
     */ set: function(key, data) {
                    if (this._frozen) return this;
                    if (typeof key === 'string') return this.setValue(key, data);
                    else for(var entry in key)this.setValue(entry, key[entry]);
                    return this;
                },
                /**
     * Increase a value for the given key. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#inc
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {Phaser.Data.DataManager} This DataManager object.
     */ inc: function(key, data) {
                    if (this._frozen) return this;
                    if (data === undefined) data = 1;
                    var value = this.get(key);
                    if (value === undefined) value = 0;
                    this.set(key, value + data);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * When the value is first set, a `setdata` event is emitted.
     *
     * @method Phaser.Data.DataManager#toggle
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.23.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {Phaser.Data.DataManager} This DataManager object.
     */ toggle: function(key) {
                    if (this._frozen) return this;
                    this.set(key, !this.get(key));
                    return this;
                },
                /**
     * Internal value setter, called automatically by the `set` method.
     *
     * @method Phaser.Data.DataManager#setValue
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @private
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     * @param {*} data - The value to set.
     *
     * @return {this} This DataManager object.
     */ setValue: function(key, data) {
                    if (this._frozen) return this;
                    if (this.has(key)) //  Hit the key getter, which will in turn emit the events.
                    this.values[key] = data;
                    else {
                        var _this = this;
                        var list = this.list;
                        var events = this.events;
                        var parent = this.parent;
                        Object.defineProperty(this.values, key, {
                            enumerable: true,
                            configurable: true,
                            get: function() {
                                return list[key];
                            },
                            set: function(value) {
                                if (!_this._frozen) {
                                    var previousValue = list[key];
                                    list[key] = value;
                                    events.emit(Events.CHANGE_DATA, parent, key, value, previousValue);
                                    events.emit(Events.CHANGE_DATA_KEY + key, parent, value, previousValue);
                                }
                            }
                        });
                        list[key] = data;
                        events.emit(Events.SET_DATA, parent, key, data);
                    }
                    return this;
                },
                /**
     * Passes all data entries to the given callback.
     *
     * @method Phaser.Data.DataManager#each
     * @since 3.0.0
     *
     * @param {DataEachCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
     *
     * @return {this} This DataManager object.
     */ each: function(callback, context) {
                    var args = [
                        this.parent,
                        null,
                        undefined
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var key in this.list){
                        args[1] = key;
                        args[2] = this.list[key];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Merge the given object of key value pairs into this DataManager.
     *
     * Any newly created values will emit a `setdata` event. Any updated values (see the `overwrite` argument)
     * will emit a `changedata` event.
     *
     * @method Phaser.Data.DataManager#merge
     * @fires Phaser.Data.Events#SET_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA
     * @fires Phaser.Data.Events#CHANGE_DATA_KEY
     * @since 3.0.0
     *
     * @param {Object.<string, *>} data - The data to merge.
     * @param {boolean} [overwrite=true] - Whether to overwrite existing data. Defaults to true.
     *
     * @return {this} This DataManager object.
     */ merge: function(data, overwrite) {
                    if (overwrite === undefined) overwrite = true;
                    //  Merge data from another component into this one
                    for(var key in data)if (data.hasOwnProperty(key) && (overwrite || !overwrite && !this.has(key))) this.setValue(key, data[key]);
                    return this;
                },
                /**
     * Remove the value for the given key.
     *
     * If the key is found in this Data Manager it is removed from the internal lists and a
     * `removedata` event is emitted.
     *
     * You can also pass in an array of keys, in which case all keys in the array will be removed:
     *
     * ```javascript
     * this.data.remove([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * @method Phaser.Data.DataManager#remove
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {(string|string[])} key - The key to remove, or an array of keys to remove.
     *
     * @return {this} This DataManager object.
     */ remove: function(key) {
                    if (this._frozen) return this;
                    if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.removeValue(key[i]);
                    else return this.removeValue(key);
                    return this;
                },
                /**
     * Internal value remover, called automatically by the `remove` method.
     *
     * @method Phaser.Data.DataManager#removeValue
     * @private
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.10.0
     *
     * @param {string} key - The key to set the value for.
     *
     * @return {this} This DataManager object.
     */ removeValue: function(key) {
                    if (this.has(key)) {
                        var data = this.list[key];
                        delete this.list[key];
                        delete this.values[key];
                        this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                    }
                    return this;
                },
                /**
     * Retrieves the data associated with the given 'key', deletes it from this Data Manager, then returns it.
     *
     * @method Phaser.Data.DataManager#pop
     * @fires Phaser.Data.Events#REMOVE_DATA
     * @since 3.0.0
     *
     * @param {string} key - The key of the value to retrieve and delete.
     *
     * @return {*} The value of the given key.
     */ pop: function(key) {
                    var data = undefined;
                    if (!this._frozen && this.has(key)) {
                        data = this.list[key];
                        delete this.list[key];
                        delete this.values[key];
                        this.events.emit(Events.REMOVE_DATA, this.parent, key, data);
                    }
                    return data;
                },
                /**
     * Determines whether the given key is set in this Data Manager.
     *
     * Please note that the keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.Data.DataManager#has
     * @since 3.0.0
     *
     * @param {string} key - The key to check.
     *
     * @return {boolean} Returns `true` if the key exists, otherwise `false`.
     */ has: function(key) {
                    return this.list.hasOwnProperty(key);
                },
                /**
     * Freeze or unfreeze this Data Manager. A frozen Data Manager will block all attempts
     * to create new values or update existing ones.
     *
     * @method Phaser.Data.DataManager#setFreeze
     * @since 3.0.0
     *
     * @param {boolean} value - Whether to freeze or unfreeze the Data Manager.
     *
     * @return {this} This DataManager object.
     */ setFreeze: function(value) {
                    this._frozen = value;
                    return this;
                },
                /**
     * Delete all data in this Data Manager and unfreeze it.
     *
     * @method Phaser.Data.DataManager#reset
     * @since 3.0.0
     *
     * @return {this} This DataManager object.
     */ reset: function() {
                    for(var key in this.list){
                        delete this.list[key];
                        delete this.values[key];
                    }
                    this._frozen = false;
                    return this;
                },
                /**
     * Destroy this data manager.
     *
     * @method Phaser.Data.DataManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.reset();
                    this.events.off(Events.CHANGE_DATA);
                    this.events.off(Events.SET_DATA);
                    this.events.off(Events.REMOVE_DATA);
                    this.parent = null;
                },
                /**
     * Gets or sets the frozen state of this Data Manager.
     * A frozen Data Manager will block all attempts to create new values or update existing ones.
     *
     * @name Phaser.Data.DataManager#freeze
     * @type {boolean}
     * @since 3.0.0
     */ freeze: {
                    get: function() {
                        return this._frozen;
                    },
                    set: function(value) {
                        this._frozen = value ? true : false;
                    }
                },
                /**
     * Return the total number of entries in this Data Manager.
     *
     * @name Phaser.Data.DataManager#count
     * @type {number}
     * @since 3.0.0
     */ count: {
                    get: function() {
                        var i = 0;
                        for(var key in this.list)if (this.list[key] !== undefined) i++;
                        return i;
                    }
                }
            });
            module1.exports = DataManager;
        /***/ },
        /* 99 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @callback EachMapCallback<E>
 *
 * @param {string} key - The key of the Map entry.
 * @param {E} entry - The value of the Map entry.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * The keys of a Map can be arbitrary values.
 *
 * ```javascript
 * var map = new Map([
 *    [ 1, 'one' ],
 *    [ 2, 'two' ],
 *    [ 3, 'three' ]
 * ]);
 * ```
 *
 * @class Map
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic K
 * @generic V
 * @genericUse {V[]} - [elements]
 *
 * @param {Array.<*>} elements - An optional array of key-value pairs to populate this Map with.
 */ var Map = new Class({
                initialize: function Map(elements) {
                    /**
         * The entries in this Map.
         *
         * @genericUse {Object.<string, V>} - [$type]
         *
         * @name Phaser.Structs.Map#entries
         * @type {Object.<string, *>}
         * @default {}
         * @since 3.0.0
         */ this.entries = {};
                    /**
         * The number of key / value pairs in this Map.
         *
         * @name Phaser.Structs.Map#size
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.size = 0;
                    if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i][0], elements[i][1]);
                },
                /**
     * Adds an element with a specified `key` and `value` to this Map.
     * If the `key` already exists, the value will be replaced.
     *
     * @method Phaser.Structs.Map#set
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [value]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to be added to this Map.
     * @param {*} value - The value of the element to be added to this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ set: function(key, value) {
                    if (!this.has(key)) this.size++;
                    this.entries[key] = value;
                    return this;
                },
                /**
     * Returns the value associated to the `key`, or `undefined` if there is none.
     *
     * @method Phaser.Structs.Map#get
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {V} - [$return]
     *
     * @param {string} key - The key of the element to return from the `Map` object.
     *
     * @return {*} The element associated with the specified key or `undefined` if the key can't be found in this Map object.
     */ get: function(key) {
                    if (this.has(key)) return this.entries[key];
                },
                /**
     * Returns an `Array` of all the values stored in this Map.
     *
     * @method Phaser.Structs.Map#getArray
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An array of the values stored in this Map.
     */ getArray: function() {
                    var output = [];
                    var entries = this.entries;
                    for(var key in entries)output.push(entries[key]);
                    return output;
                },
                /**
     * Returns a boolean indicating whether an element with the specified key exists or not.
     *
     * @method Phaser.Structs.Map#has
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     *
     * @param {string} key - The key of the element to test for presence of in this Map.
     *
     * @return {boolean} Returns `true` if an element with the specified key exists in this Map, otherwise `false`.
     */ has: function(key) {
                    return this.entries.hasOwnProperty(key);
                },
                /**
     * Delete the specified element from this Map.
     *
     * @method Phaser.Structs.Map#delete
     * @since 3.0.0
     *
     * @genericUse {K} - [key]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {string} key - The key of the element to delete from this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ delete: function(key) {
                    if (this.has(key)) {
                        delete this.entries[key];
                        this.size--;
                    }
                    return this;
                },
                /**
     * Delete all entries from this Map.
     *
     * @method Phaser.Structs.Map#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ clear: function() {
                    Object.keys(this.entries).forEach(function(prop) {
                        delete this.entries[prop];
                    }, this);
                    this.size = 0;
                    return this;
                },
                /**
     * Returns all entries keys in this Map.
     *
     * @method Phaser.Structs.Map#keys
     * @since 3.0.0
     *
     * @genericUse {K[]} - [$return]
     *
     * @return {string[]} Array containing entries' keys.
     */ keys: function() {
                    return Object.keys(this.entries);
                },
                /**
     * Returns an `Array` of all entries.
     *
     * @method Phaser.Structs.Map#values
     * @since 3.0.0
     *
     * @genericUse {V[]} - [$return]
     *
     * @return {Array.<*>} An `Array` of entries.
     */ values: function() {
                    var output = [];
                    var entries = this.entries;
                    for(var key in entries)output.push(entries[key]);
                    return output;
                },
                /**
     * Dumps the contents of this Map to the console via `console.group`.
     *
     * @method Phaser.Structs.Map#dump
     * @since 3.0.0
     */ dump: function() {
                    var entries = this.entries;
                    // eslint-disable-next-line no-console
                    console.group('Map');
                    for(var key in entries)console.log(key, entries[key]);
                    // eslint-disable-next-line no-console
                    console.groupEnd();
                },
                /**
     * Iterates through all entries in this Map, passing each one to the given callback.
     *
     * If the callback returns `false`, the iteration will break.
     *
     * @method Phaser.Structs.Map#each
     * @since 3.0.0
     *
     * @genericUse {EachMapCallback.<V>} - [callback]
     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
     *
     * @param {EachMapCallback} callback - The callback which will receive the keys and entries held in this Map.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ each: function(callback) {
                    var entries = this.entries;
                    for(var key in entries){
                        if (callback(key, entries[key]) === false) break;
                    }
                    return this;
                },
                /**
     * Returns `true` if the value exists within this Map. Otherwise, returns `false`.
     *
     * @method Phaser.Structs.Map#contains
     * @since 3.0.0
     *
     * @genericUse {V} - [value]
     *
     * @param {*} value - The value to search for.
     *
     * @return {boolean} `true` if the value is found, otherwise `false`.
     */ contains: function(value) {
                    var entries = this.entries;
                    for(var key in entries){
                        if (entries[key] === value) return true;
                    }
                    return false;
                },
                /**
     * Merges all new keys from the given Map into this one.
     * If it encounters a key that already exists it will be skipped unless override is set to `true`.
     *
     * @method Phaser.Structs.Map#merge
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Map.<K, V>} - [map,$return]
     *
     * @param {Phaser.Structs.Map} map - The Map to merge in to this Map.
     * @param {boolean} [override=false] - Set to `true` to replace values in this Map with those from the source map, or `false` to skip them.
     *
     * @return {Phaser.Structs.Map} This Map object.
     */ merge: function(map, override) {
                    if (override === undefined) override = false;
                    var local = this.entries;
                    var source = map.entries;
                    for(var key in source)if (local.hasOwnProperty(key) && override) local[key] = source[key];
                    else this.set(key, source[key]);
                    return this;
                }
            });
            module1.exports = Map;
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given 3 separate color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor = function(red, green, blue) {
                return red << 16 | green << 8 | blue;
            };
            module1.exports = GetColor;
        /***/ },
        /* 101 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Scale.Events
 */ module1.exports = {
                ENTER_FULLSCREEN: __webpack_require__(776),
                FULLSCREEN_FAILED: __webpack_require__(777),
                FULLSCREEN_UNSUPPORTED: __webpack_require__(778),
                LEAVE_FULLSCREEN: __webpack_require__(779),
                ORIENTATION_CHANGE: __webpack_require__(780),
                RESIZE: __webpack_require__(781)
            };
        /***/ },
        /* 102 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(process) {
                /**
 * Determines the operating system of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.os` from within any Scene.
 *
 * @typedef {object} Phaser.Device.OS
 * @since 3.0.0
 *
 * @property {boolean} android - Is running on android?
 * @property {boolean} chromeOS - Is running on chromeOS?
 * @property {boolean} cordova - Is the game running under Apache Cordova?
 * @property {boolean} crosswalk - Is the game running under the Intel Crosswalk XDK?
 * @property {boolean} desktop - Is running on a desktop?
 * @property {boolean} ejecta - Is the game running under Ejecta?
 * @property {boolean} electron - Is the game running under GitHub Electron?
 * @property {boolean} iOS - Is running on iOS?
 * @property {boolean} iPad - Is running on iPad?
 * @property {boolean} iPhone - Is running on iPhone?
 * @property {boolean} kindle - Is running on an Amazon Kindle?
 * @property {boolean} linux - Is running on linux?
 * @property {boolean} macOS - Is running on macOS?
 * @property {boolean} node - Is the game running under Node.js?
 * @property {boolean} nodeWebkit - Is the game running under Node-Webkit?
 * @property {boolean} webApp - Set to true if running as a WebApp, i.e. within a WebView
 * @property {boolean} windows - Is running on windows?
 * @property {boolean} windowsPhone - Is running on a Windows Phone?
 * @property {number} iOSVersion - If running in iOS this will contain the major version number.
 * @property {number} pixelRatio - PixelRatio of the host device?
 */ var OS = {
                    android: false,
                    chromeOS: false,
                    cordova: false,
                    crosswalk: false,
                    desktop: false,
                    ejecta: false,
                    electron: false,
                    iOS: false,
                    iOSVersion: 0,
                    iPad: false,
                    iPhone: false,
                    kindle: false,
                    linux: false,
                    macOS: false,
                    node: false,
                    nodeWebkit: false,
                    pixelRatio: 1,
                    webApp: false,
                    windows: false,
                    windowsPhone: false
                };
                function init() {
                    var ua = navigator.userAgent;
                    if (/Windows/.test(ua)) OS.windows = true;
                    else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
                        //  Because iOS 13 identifies as Mac OS:
                        if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                            OS.iOS = true;
                            OS.iPad = true;
                            navigator.appVersion.match(/Version\/(\d+)/);
                            OS.iOSVersion = parseInt(RegExp.$1, 10);
                        } else OS.macOS = true;
                    } else if (/Android/.test(ua)) OS.android = true;
                    else if (/Linux/.test(ua)) OS.linux = true;
                    else if (/iP[ao]d|iPhone/i.test(ua)) {
                        OS.iOS = true;
                        navigator.appVersion.match(/OS (\d+)/);
                        OS.iOSVersion = parseInt(RegExp.$1, 10);
                        OS.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
                        OS.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
                    } else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) OS.kindle = true;
                    else if (/CrOS/.test(ua)) OS.chromeOS = true;
                    if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
                        OS.android = false;
                        OS.iOS = false;
                        OS.macOS = false;
                        OS.windows = true;
                        OS.windowsPhone = true;
                    }
                    var silk = /Silk/.test(ua);
                    if (OS.windows || OS.macOS || OS.linux && !silk || OS.chromeOS) OS.desktop = true;
                    //  Windows Phone / Table reset
                    if (OS.windowsPhone || /Windows NT/i.test(ua) && /Touch/i.test(ua)) OS.desktop = false;
                    //  WebApp mode in iOS
                    if (navigator.standalone) OS.webApp = true;
                    if (window.cordova !== undefined) OS.cordova = true;
                    if (typeof process !== 'undefined' && process.versions && process.versions.node) OS.node = true;
                    if (OS.node && typeof process.versions === 'object') {
                        OS.nodeWebkit = !!process.versions['node-webkit'];
                        OS.electron = !!process.versions.electron;
                    }
                    if (window.ejecta !== undefined) OS.ejecta = true;
                    if (/Crosswalk/.test(ua)) OS.crosswalk = true;
                    OS.pixelRatio = window['devicePixelRatio'] || 1;
                    return OS;
                }
                module1.exports = init();
            /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(804));
        /***/ },
        /* 103 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Events
 */ module1.exports = {
                ADD: __webpack_require__(857),
                ERROR: __webpack_require__(858),
                LOAD: __webpack_require__(859),
                READY: __webpack_require__(860),
                REMOVE: __webpack_require__(861)
            };
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = {
                /**
     * 	8-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ BYTE: {
                    enum: 0x1400,
                    size: 1
                },
                /**
     * 8-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_BYTE
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_BYTE: {
                    enum: 0x1401,
                    size: 1
                },
                /**
     * 16-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ SHORT: {
                    enum: 0x1402,
                    size: 2
                },
                /**
     * 16-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_SHORT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_SHORT: {
                    enum: 0x1403,
                    size: 2
                },
                /**
     * 32-bit twos complement signed integer.
     *
     * @name Phaser.Renderer.WebGL.INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ INT: {
                    enum: 0x1404,
                    size: 4
                },
                /**
     * 32-bit twos complement unsigned integer.
     *
     * @name Phaser.Renderer.WebGL.UNSIGNED_INT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ UNSIGNED_INT: {
                    enum: 0x1405,
                    size: 4
                },
                /**
     * 32-bit IEEE floating point number.
     *
     * @name Phaser.Renderer.WebGL.FLOAT
     * @type {Phaser.Types.Renderer.WebGL.WebGLConst}
     * @since 3.50.0
     */ FLOAT: {
                    enum: 0x1406,
                    size: 4
                }
            };
            module1.exports = WEBGL_CONST;
        /***/ },
        /* 105 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(874);
            var ShaderSourceVS = __webpack_require__(875);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var WEBGL_CONST = __webpack_require__(104);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 *
 * The Multi Pipeline is the core 2D texture rendering pipeline used by Phaser in WebGL.
 * Virtually all Game Objects use this pipeline by default, including Sprites, Graphics
 * and Tilemaps. It handles the batching of quads and tris, as well as methods for
 * drawing and batching geometry data.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintPipeline`.
 *
 * In previous versions of Phaser only one single texture unit was supported at any one time.
 * The Multi Pipeline is an evolution of the old Texture Tint Pipeline, updated to support
 * multi-textures for increased performance.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D array)
 *
 * If you wish to create a custom pipeline extending from this one, you can use two string
 * declarations in your fragment shader source: `%count%` and `%forloop%`, where `count` is
 * used to set the number of `sampler2Ds` available, and `forloop` is a block of GLSL code
 * that will get the currently bound texture unit.
 *
 * This pipeline will automatically inject that code for you, should those values exist
 * in your shader source. If you wish to handle this yourself, you can also use the
 * function `Utils.parseFragmentShaderMaxTextures`.
 *
 * If you wish to create a pipeline that works from a single texture, or that doesn't have
 * internal texture iteration, please see the `SinglePipeline` instead.
 *
 * @class MultiPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var MultiPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function MultiPipeline(config) {
                    var renderer = config.game.renderer;
                    var fragmentShaderSource = GetFastValue(config, 'fragShader', ShaderSourceFS);
                    config.fragShader = Utils.parseFragmentShaderMaxTextures(fragmentShaderSource, renderer.maxTextures);
                    config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                    config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2
                        },
                        {
                            name: 'inTexCoord',
                            size: 2
                        },
                        {
                            name: 'inTexId'
                        },
                        {
                            name: 'inTintEffect'
                        },
                        {
                            name: 'inTint',
                            size: 4,
                            type: WEBGL_CONST.UNSIGNED_BYTE,
                            normalized: true
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.MultiPipeline#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                },
                /**
     * Called every time the pipeline is bound by the renderer.
     * Sets the shader program, vertex buffer and other resources.
     * Should only be called when changing pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#bind
     * @since 3.50.0
     *
     * @return {this} This WebGLPipeline instance.
     */ boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.currentShader.set1iv('uMainSampler', this.renderer.textureIndexes);
                },
                /**
     * Takes a Sprite Game Object, or any object that extends it, and adds it to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchSprite
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.Image|Phaser.GameObjects.Sprite)} gameObject - The texture based Game Object to add to the batch.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(gameObject, camera, parentTransformMatrix) {
                    this.manager.set(this, gameObject);
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var calcMatrix = this._tempMatrix3;
                    var frame = gameObject.frame;
                    var texture = frame.glTexture;
                    var u0 = frame.u0;
                    var v0 = frame.v0;
                    var u1 = frame.u1;
                    var v1 = frame.v1;
                    var frameX = frame.x;
                    var frameY = frame.y;
                    var frameWidth = frame.cutWidth;
                    var frameHeight = frame.cutHeight;
                    var customPivot = frame.customPivot;
                    var displayOriginX = gameObject.displayOriginX;
                    var displayOriginY = gameObject.displayOriginY;
                    var x = -displayOriginX + frameX;
                    var y = -displayOriginY + frameY;
                    if (gameObject.isCropped) {
                        var crop = gameObject._crop;
                        if (crop.flipX !== gameObject.flipX || crop.flipY !== gameObject.flipY) frame.updateCropUVs(crop, gameObject.flipX, gameObject.flipY);
                        u0 = crop.u0;
                        v0 = crop.v0;
                        u1 = crop.u1;
                        v1 = crop.v1;
                        frameWidth = crop.width;
                        frameHeight = crop.height;
                        frameX = crop.x;
                        frameY = crop.y;
                        x = -displayOriginX + frameX;
                        y = -displayOriginY + frameY;
                    }
                    var flipX = 1;
                    var flipY = 1;
                    if (gameObject.flipX) {
                        if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                        flipX = -1;
                    }
                    //  Auto-invert the flipY if this is coming from a GLTexture
                    if (gameObject.flipY || frame.source.isGLTexture && !texture.flipY) {
                        if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                        flipY = -1;
                    }
                    spriteMatrix.applyITRS(gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX * flipX, gameObject.scaleY * flipY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * gameObject.scrollFactorX, -camera.scrollY * gameObject.scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = gameObject.x;
                        spriteMatrix.f = gameObject.y;
                    } else {
                        spriteMatrix.e -= camera.scrollX * gameObject.scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * gameObject.scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(spriteMatrix, calcMatrix);
                    var xw = x + frameWidth;
                    var yh = y + frameHeight;
                    var roundPixels = camera.roundPixels;
                    var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                    var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                    var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                    var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                    var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                    var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                    var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                    var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                    var getTint = Utils.getTintAppendFloatAlpha;
                    var cameraAlpha = camera.alpha;
                    var tintTL = getTint(gameObject.tintTopLeft, cameraAlpha * gameObject._alphaTL);
                    var tintTR = getTint(gameObject.tintTopRight, cameraAlpha * gameObject._alphaTR);
                    var tintBL = getTint(gameObject.tintBottomLeft, cameraAlpha * gameObject._alphaBL);
                    var tintBR = getTint(gameObject.tintBottomRight, cameraAlpha * gameObject._alphaBR);
                    if (this.shouldFlush(6)) this.flush();
                    var unit = this.setGameObject(gameObject, frame);
                    this.manager.preBatch(gameObject);
                    this.batchQuad(gameObject, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, gameObject.tintFill, texture, unit);
                    this.manager.postBatch(gameObject);
                },
                /**
     * Generic function for batching a textured quad using argument values instead of a Game Object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject.
     * @param {WebGLTexture} texture - Raw WebGLTexture associated with the quad.
     * @param {number} textureWidth - Real texture width.
     * @param {number} textureHeight - Real texture height.
     * @param {number} srcX - X coordinate of the quad.
     * @param {number} srcY - Y coordinate of the quad.
     * @param {number} srcWidth - Width of the quad.
     * @param {number} srcHeight - Height of the quad.
     * @param {number} scaleX - X component of scale.
     * @param {number} scaleY - Y component of scale.
     * @param {number} rotation - Rotation of the quad.
     * @param {boolean} flipX - Indicates if the quad is horizontally flipped.
     * @param {boolean} flipY - Indicates if the quad is vertically flipped.
     * @param {number} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll.
     * @param {number} scrollFactorY - By which factor is the quad effected by the camera vertical scroll.
     * @param {number} displayOriginX - Horizontal origin in pixels.
     * @param {number} displayOriginY - Vertical origin in pixels.
     * @param {number} frameX - X coordinate of the texture frame.
     * @param {number} frameY - Y coordinate of the texture frame.
     * @param {number} frameWidth - Width of the texture frame.
     * @param {number} frameHeight - Height of the texture frame.
     * @param {number} tintTL - Tint for top left.
     * @param {number} tintTR - Tint for top right.
     * @param {number} tintBL - Tint for bottom left.
     * @param {number} tintBR - Tint for bottom right.
     * @param {number} tintEffect - The tint effect.
     * @param {number} uOffset - Horizontal offset on texture coordinate.
     * @param {number} vOffset - Vertical offset on texture coordinate.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container.
     * @param {boolean} [skipFlip=false] - Skip the renderTexture check.
     * @param {number} [textureUnit] - Use the currently bound texture unit?
     */ batchTexture: function(gameObject, texture, textureWidth, textureHeight, srcX, srcY, srcWidth, srcHeight, scaleX, scaleY, rotation, flipX, flipY, scrollFactorX, scrollFactorY, displayOriginX, displayOriginY, frameX, frameY, frameWidth, frameHeight, tintTL, tintTR, tintBL, tintBR, tintEffect, uOffset, vOffset, camera, parentTransformMatrix, skipFlip, textureUnit) {
                    this.manager.set(this, gameObject);
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var calcMatrix = this._tempMatrix3;
                    var u0 = frameX / textureWidth + uOffset;
                    var v0 = frameY / textureHeight + vOffset;
                    var u1 = (frameX + frameWidth) / textureWidth + uOffset;
                    var v1 = (frameY + frameHeight) / textureHeight + vOffset;
                    var width = srcWidth;
                    var height = srcHeight;
                    var x = -displayOriginX;
                    var y = -displayOriginY;
                    if (gameObject.isCropped) {
                        var crop = gameObject._crop;
                        var cropWidth = crop.width;
                        var cropHeight = crop.height;
                        width = cropWidth;
                        height = cropHeight;
                        srcWidth = cropWidth;
                        srcHeight = cropHeight;
                        frameX = crop.x;
                        frameY = crop.y;
                        var ox = frameX;
                        var oy = frameY;
                        if (flipX) ox = frameWidth - crop.x - cropWidth;
                        if (flipY) oy = frameHeight - crop.y - cropHeight;
                        u0 = ox / textureWidth + uOffset;
                        v0 = oy / textureHeight + vOffset;
                        u1 = (ox + cropWidth) / textureWidth + uOffset;
                        v1 = (oy + cropHeight) / textureHeight + vOffset;
                        x = -displayOriginX + frameX;
                        y = -displayOriginY + frameY;
                    }
                    //  Invert the flipY if this is a RenderTexture
                    flipY = flipY ^ (!skipFlip && texture.isRenderTexture ? 1 : 0);
                    if (flipX) {
                        width *= -1;
                        x += srcWidth;
                    }
                    if (flipY) {
                        height *= -1;
                        y += srcHeight;
                    }
                    var xw = x + width;
                    var yh = y + height;
                    spriteMatrix.applyITRS(srcX, srcY, rotation, scaleX, scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = srcX;
                        spriteMatrix.f = srcY;
                    } else {
                        spriteMatrix.e -= camera.scrollX * scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(spriteMatrix, calcMatrix);
                    var roundPixels = camera.roundPixels;
                    var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                    var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                    var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                    var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                    var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                    var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                    var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                    var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                    if (textureUnit === undefined) textureUnit = this.renderer.setTexture2D(texture);
                    if (gameObject) this.manager.preBatch(gameObject);
                    this.batchQuad(gameObject, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                    if (gameObject) this.manager.postBatch(gameObject);
                },
                /**
     * Adds a Texture Frame into the batch for rendering.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.MultiPipeline#batchTextureFrame
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} frame - The Texture Frame to be rendered.
     * @param {number} x - The horizontal position to render the texture at.
     * @param {number} y - The vertical position to render the texture at.
     * @param {number} tint - The tint color.
     * @param {number} alpha - The alpha value.
     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - The Transform Matrix to use for the texture.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - A parent Transform Matrix.
     */ batchTextureFrame: function(frame, x, y, tint, alpha, transformMatrix, parentTransformMatrix) {
                    this.manager.set(this);
                    var spriteMatrix = this._tempMatrix1.copyFrom(transformMatrix);
                    var calcMatrix = this._tempMatrix2;
                    var xw = x + frame.width;
                    var yh = y + frame.height;
                    if (parentTransformMatrix) spriteMatrix.multiply(parentTransformMatrix, calcMatrix);
                    else calcMatrix = spriteMatrix;
                    var tx0 = calcMatrix.getX(x, y);
                    var ty0 = calcMatrix.getY(x, y);
                    var tx1 = calcMatrix.getX(x, yh);
                    var ty1 = calcMatrix.getY(x, yh);
                    var tx2 = calcMatrix.getX(xw, yh);
                    var ty2 = calcMatrix.getY(xw, yh);
                    var tx3 = calcMatrix.getX(xw, y);
                    var ty3 = calcMatrix.getY(xw, y);
                    var unit = this.renderer.setTextureSource(frame.source);
                    tint = Utils.getTintAppendFloatAlpha(tint, alpha);
                    this.batchQuad(null, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, 0, frame.glTexture, unit);
                }
            });
            module1.exports = MultiPipeline;
        /***/ },
        /* 106 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Extend = __webpack_require__(17);
            /**
 * @classdesc
 * A Frame is a section of a Texture.
 *
 * @class Frame
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this Frame is a part of.
 * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
 * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
 * @param {number} x - The x coordinate of the top-left of this Frame.
 * @param {number} y - The y coordinate of the top-left of this Frame.
 * @param {number} width - The width of this Frame.
 * @param {number} height - The height of this Frame.
 */ var Frame = new Class({
                initialize: function Frame(texture, name, sourceIndex, x, y, width, height) {
                    /**
         * The Texture this Frame is a part of.
         *
         * @name Phaser.Textures.Frame#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                    /**
         * The name of this Frame.
         * The name is unique within the Texture.
         *
         * @name Phaser.Textures.Frame#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                    /**
         * The TextureSource this Frame is part of.
         *
         * @name Phaser.Textures.Frame#source
         * @type {Phaser.Textures.TextureSource}
         * @since 3.0.0
         */ this.source = texture.source[sourceIndex];
                    /**
         * The index of the TextureSource in the Texture sources array.
         *
         * @name Phaser.Textures.Frame#sourceIndex
         * @type {number}
         * @since 3.0.0
         */ this.sourceIndex = sourceIndex;
                    /**
         * A reference to the Texture Source WebGL Texture that this Frame is using.
         *
         * @name Phaser.Textures.Frame#glTexture
         * @type {?WebGLTexture}
         * @default null
         * @since 3.11.0
         */ this.glTexture = this.source.glTexture;
                    /**
         * X position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutX
         * @type {number}
         * @since 3.0.0
         */ this.cutX;
                    /**
         * Y position within the source image to cut from.
         *
         * @name Phaser.Textures.Frame#cutY
         * @type {number}
         * @since 3.0.0
         */ this.cutY;
                    /**
         * The width of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutWidth
         * @type {number}
         * @since 3.0.0
         */ this.cutWidth;
                    /**
         * The height of the area in the source image to cut.
         *
         * @name Phaser.Textures.Frame#cutHeight
         * @type {number}
         * @since 3.0.0
         */ this.cutHeight;
                    /**
         * The X rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The Y rendering offset of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The rendering width of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#width
         * @type {number}
         * @since 3.0.0
         */ this.width;
                    /**
         * The rendering height of this Frame, taking trim into account.
         *
         * @name Phaser.Textures.Frame#height
         * @type {number}
         * @since 3.0.0
         */ this.height;
                    /**
         * Half the width, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth;
                    /**
         * Half the height, floored.
         * Precalculated for the renderer.
         *
         * @name Phaser.Textures.Frame#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight;
                    /**
         * The x center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerX
         * @type {number}
         * @since 3.0.0
         */ this.centerX;
                    /**
         * The y center of this frame, floored.
         *
         * @name Phaser.Textures.Frame#centerY
         * @type {number}
         * @since 3.0.0
         */ this.centerY;
                    /**
         * The horizontal pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotX = 0;
                    /**
         * The vertical pivot point of this Frame.
         *
         * @name Phaser.Textures.Frame#pivotY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.pivotY = 0;
                    /**
         * Does this Frame have a custom pivot point?
         *
         * @name Phaser.Textures.Frame#customPivot
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customPivot = false;
                    /**
         * **CURRENTLY UNSUPPORTED**
         *
         * Is this frame is rotated or not in the Texture?
         * Rotation allows you to use rotated frames in texture atlas packing.
         * It has nothing to do with Sprite rotation.
         *
         * @name Phaser.Textures.Frame#rotated
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rotated = false;
                    /**
         * Over-rides the Renderer setting.
         * -1 = use Renderer Setting
         * 0 = No rounding
         * 1 = Round
         *
         * @name Phaser.Textures.Frame#autoRound
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.autoRound = -1;
                    /**
         * Any Frame specific custom data can be stored here.
         *
         * @name Phaser.Textures.Frame#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                    /**
         * WebGL UV u0 value.
         *
         * @name Phaser.Textures.Frame#u0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u0 = 0;
                    /**
         * WebGL UV v0 value.
         *
         * @name Phaser.Textures.Frame#v0
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v0 = 0;
                    /**
         * WebGL UV u1 value.
         *
         * @name Phaser.Textures.Frame#u1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.u1 = 0;
                    /**
         * WebGL UV v1 value.
         *
         * @name Phaser.Textures.Frame#v1
         * @type {number}
         * @default 0
         * @since 3.11.0
         */ this.v1 = 0;
                    /**
         * The un-modified source frame, trim and UV data.
         *
         * @name Phaser.Textures.Frame#data
         * @type {object}
         * @private
         * @since 3.0.0
         */ this.data = {
                        cut: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        trim: false,
                        sourceSize: {
                            w: 0,
                            h: 0
                        },
                        spriteSourceSize: {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0,
                            r: 0,
                            b: 0
                        },
                        radius: 0,
                        drawImage: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        }
                    };
                    this.setSize(width, height, x, y);
                },
                /**
     * Sets the width, height, x and y of this Frame.
     *
     * This is called automatically by the constructor
     * and should rarely be changed on-the-fly.
     *
     * @method Phaser.Textures.Frame#setSize
     * @since 3.7.0
     *
     * @param {number} width - The width of the frame before being trimmed.
     * @param {number} height - The height of the frame before being trimmed.
     * @param {number} [x=0] - The x coordinate of the top-left of this Frame.
     * @param {number} [y=0] - The y coordinate of the top-left of this Frame.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setSize: function(width, height, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    this.cutX = x;
                    this.cutY = y;
                    this.cutWidth = width;
                    this.cutHeight = height;
                    this.width = width;
                    this.height = height;
                    this.halfWidth = Math.floor(width * 0.5);
                    this.halfHeight = Math.floor(height * 0.5);
                    this.centerX = Math.floor(width / 2);
                    this.centerY = Math.floor(height / 2);
                    var data = this.data;
                    var cut = data.cut;
                    cut.x = x;
                    cut.y = y;
                    cut.w = width;
                    cut.h = height;
                    cut.r = x + width;
                    cut.b = y + height;
                    data.sourceSize.w = width;
                    data.sourceSize.h = height;
                    data.spriteSourceSize.w = width;
                    data.spriteSourceSize.h = height;
                    data.radius = 0.5 * Math.sqrt(width * width + height * height);
                    var drawImage = data.drawImage;
                    drawImage.x = x;
                    drawImage.y = y;
                    drawImage.width = width;
                    drawImage.height = height;
                    return this.updateUVs();
                },
                /**
     * If the frame was trimmed when added to the Texture Atlas, this records the trim and source data.
     *
     * @method Phaser.Textures.Frame#setTrim
     * @since 3.0.0
     *
     * @param {number} actualWidth - The width of the frame before being trimmed.
     * @param {number} actualHeight - The height of the frame before being trimmed.
     * @param {number} destX - The destination X position of the trimmed frame for display.
     * @param {number} destY - The destination Y position of the trimmed frame for display.
     * @param {number} destWidth - The destination width of the trimmed frame for display.
     * @param {number} destHeight - The destination height of the trimmed frame for display.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setTrim: function(actualWidth, actualHeight, destX, destY, destWidth, destHeight) {
                    var data = this.data;
                    var ss = data.spriteSourceSize;
                    //  Store actual values
                    data.trim = true;
                    data.sourceSize.w = actualWidth;
                    data.sourceSize.h = actualHeight;
                    ss.x = destX;
                    ss.y = destY;
                    ss.w = destWidth;
                    ss.h = destHeight;
                    ss.r = destX + destWidth;
                    ss.b = destY + destHeight;
                    //  Adjust properties
                    this.x = destX;
                    this.y = destY;
                    this.width = destWidth;
                    this.height = destHeight;
                    this.halfWidth = destWidth * 0.5;
                    this.halfHeight = destHeight * 0.5;
                    this.centerX = Math.floor(destWidth / 2);
                    this.centerY = Math.floor(destHeight / 2);
                    return this.updateUVs();
                },
                /**
     * Takes a crop data object and, based on the rectangular region given, calculates the
     * required UV coordinates in order to crop this Frame for WebGL and Canvas rendering.
     *
     * This is called directly by the Game Object Texture Components `setCrop` method.
     * Please use that method to crop a Game Object.
     *
     * @method Phaser.Textures.Frame#setCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {number} x - The x coordinate to start the crop from. Cannot be negative or exceed the Frame width.
     * @param {number} y - The y coordinate to start the crop from. Cannot be negative or exceed the Frame height.
     * @param {number} width - The width of the crop rectangle. Cannot exceed the Frame width.
     * @param {number} height - The height of the crop rectangle. Cannot exceed the Frame height.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ setCropUVs: function(crop, x, y, width, height, flipX, flipY) {
                    //  Clamp the input values
                    var cx = this.cutX;
                    var cy = this.cutY;
                    var cw = this.cutWidth;
                    var ch = this.cutHeight;
                    var rw = this.realWidth;
                    var rh = this.realHeight;
                    x = Clamp(x, 0, rw);
                    y = Clamp(y, 0, rh);
                    width = Clamp(width, 0, rw - x);
                    height = Clamp(height, 0, rh - y);
                    var ox = cx + x;
                    var oy = cy + y;
                    var ow = width;
                    var oh = height;
                    var data = this.data;
                    if (data.trim) {
                        var ss = data.spriteSourceSize;
                        //  Need to check for intersection between the cut area and the crop area
                        //  If there is none, we set UV to be empty, otherwise set it to be the intersection area
                        width = Clamp(width, 0, cw - x);
                        height = Clamp(height, 0, ch - y);
                        var cropRight = x + width;
                        var cropBottom = y + height;
                        var intersects = !(ss.r < x || ss.b < y || ss.x > cropRight || ss.y > cropBottom);
                        if (intersects) {
                            var ix = Math.max(ss.x, x);
                            var iy = Math.max(ss.y, y);
                            var iw = Math.min(ss.r, cropRight) - ix;
                            var ih = Math.min(ss.b, cropBottom) - iy;
                            ow = iw;
                            oh = ih;
                            if (flipX) ox = cx + (cw - (ix - ss.x) - iw);
                            else ox = cx + (ix - ss.x);
                            if (flipY) oy = cy + (ch - (iy - ss.y) - ih);
                            else oy = cy + (iy - ss.y);
                            x = ix;
                            y = iy;
                            width = iw;
                            height = ih;
                        } else {
                            ox = 0;
                            oy = 0;
                            ow = 0;
                            oh = 0;
                        }
                    } else {
                        if (flipX) ox = cx + (cw - x - width);
                        if (flipY) oy = cy + (ch - y - height);
                    }
                    var tw = this.source.width;
                    var th = this.source.height;
                    //  Map the given coordinates into UV space, clamping to the 0-1 range.
                    crop.u0 = Math.max(0, ox / tw);
                    crop.v0 = Math.max(0, oy / th);
                    crop.u1 = Math.min(1, (ox + ow) / tw);
                    crop.v1 = Math.min(1, (oy + oh) / th);
                    crop.x = x;
                    crop.y = y;
                    crop.cx = ox;
                    crop.cy = oy;
                    crop.cw = ow;
                    crop.ch = oh;
                    crop.width = width;
                    crop.height = height;
                    crop.flipX = flipX;
                    crop.flipY = flipY;
                    return crop;
                },
                /**
     * Takes a crop data object and recalculates the UVs based on the dimensions inside the crop object.
     * Called automatically by `setFrame`.
     *
     * @method Phaser.Textures.Frame#updateCropUVs
     * @since 3.11.0
     *
     * @param {object} crop - The crop data object. This is the `GameObject._crop` property.
     * @param {boolean} flipX - Does the parent Game Object have flipX set?
     * @param {boolean} flipY - Does the parent Game Object have flipY set?
     *
     * @return {object} The updated crop data object.
     */ updateCropUVs: function(crop, flipX, flipY) {
                    return this.setCropUVs(crop, crop.x, crop.y, crop.width, crop.height, flipX, flipY);
                },
                /**
     * Directly sets the canvas and WebGL UV data for this frame.
     *
     * Use this if you need to override the values that are generated automatically
     * when the Frame is created.
     *
     * @method Phaser.Textures.Frame#setUVs
     * @since 3.50.0
     *
     * @param {number} width - Width of this frame for the Canvas data.
     * @param {number} height - Height of this frame for the Canvas data.
     * @param {number} u0 - UV u0 value.
     * @param {number} v0 - UV v0 value.
     * @param {number} u1 - UV u1 value.
     * @param {number} v1 - UV v1 value.
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ setUVs: function(width, height, u0, v0, u1, v1) {
                    //  Canvas data
                    var cd = this.data.drawImage;
                    cd.width = width;
                    cd.height = height;
                    //  WebGL data
                    this.u0 = u0;
                    this.v0 = v0;
                    this.u1 = u1;
                    this.v1 = v1;
                    return this;
                },
                /**
     * Updates the internal WebGL UV cache and the drawImage cache.
     *
     * @method Phaser.Textures.Frame#updateUVs
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ updateUVs: function() {
                    var cx = this.cutX;
                    var cy = this.cutY;
                    var cw = this.cutWidth;
                    var ch = this.cutHeight;
                    //  Canvas data
                    var cd = this.data.drawImage;
                    cd.width = cw;
                    cd.height = ch;
                    //  WebGL data
                    var tw = this.source.width;
                    var th = this.source.height;
                    this.u0 = cx / tw;
                    this.v0 = cy / th;
                    this.u1 = (cx + cw) / tw;
                    this.v1 = (cy + ch) / th;
                    return this;
                },
                /**
     * Updates the internal WebGL UV cache.
     *
     * @method Phaser.Textures.Frame#updateUVsInverted
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} This Frame object.
     */ updateUVsInverted: function() {
                    var tw = this.source.width;
                    var th = this.source.height;
                    this.u0 = (this.cutX + this.cutHeight) / tw;
                    this.v0 = this.cutY / th;
                    this.u1 = this.cutX / tw;
                    this.v1 = (this.cutY + this.cutWidth) / th;
                    return this;
                },
                /**
     * Clones this Frame into a new Frame object.
     *
     * @method Phaser.Textures.Frame#clone
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} A clone of this Frame.
     */ clone: function() {
                    var clone = new Frame(this.texture, this.name, this.sourceIndex);
                    clone.cutX = this.cutX;
                    clone.cutY = this.cutY;
                    clone.cutWidth = this.cutWidth;
                    clone.cutHeight = this.cutHeight;
                    clone.x = this.x;
                    clone.y = this.y;
                    clone.width = this.width;
                    clone.height = this.height;
                    clone.halfWidth = this.halfWidth;
                    clone.halfHeight = this.halfHeight;
                    clone.centerX = this.centerX;
                    clone.centerY = this.centerY;
                    clone.rotated = this.rotated;
                    clone.data = Extend(true, clone.data, this.data);
                    clone.updateUVs();
                    return clone;
                },
                /**
     * Destroys this Frame by nulling its reference to the parent Texture and and data objects.
     *
     * @method Phaser.Textures.Frame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.source = null;
                    this.texture = null;
                    this.glTexture = null;
                    this.customData = null;
                    this.data = null;
                },
                /**
     * The width of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realWidth
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realWidth: {
                    get: function() {
                        return this.data.sourceSize.w;
                    }
                },
                /**
     * The height of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
     * before being packed.
     *
     * @name Phaser.Textures.Frame#realHeight
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ realHeight: {
                    get: function() {
                        return this.data.sourceSize.h;
                    }
                },
                /**
     * The radius of the Frame (derived from sqrt(w * w + h * h) / 2)
     *
     * @name Phaser.Textures.Frame#radius
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ radius: {
                    get: function() {
                        return this.data.radius;
                    }
                },
                /**
     * Is the Frame trimmed or not?
     *
     * @name Phaser.Textures.Frame#trimmed
     * @type {boolean}
     * @readonly
     * @since 3.0.0
     */ trimmed: {
                    get: function() {
                        return this.data.trim;
                    }
                },
                /**
     * The Canvas drawImage data object.
     *
     * @name Phaser.Textures.Frame#canvasData
     * @type {object}
     * @readonly
     * @since 3.0.0
     */ canvasData: {
                    get: function() {
                        return this.data.drawImage;
                    }
                }
            });
            module1.exports = Frame;
        /***/ },
        /* 107 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(205);
            var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            var StableSort = __webpack_require__(79);
            /**
 * @callback EachListCallback<I>
 *
 * @param {I} item - The item which is currently being processed.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * List is a generic implementation of an ordered list which contains utility methods for retrieving, manipulating, and iterating items.
 *
 * @class List
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 *
 * @param {*} parent - The parent of this list.
 */ var List = new Class({
                initialize: function List(parent) {
                    /**
         * The parent of this list.
         *
         * @name Phaser.Structs.List#parent
         * @type {*}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * The objects that belong to this collection.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.List#list
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.list = [];
                    /**
         * The index of the current element.
         *
         * This is used internally when iterating through the list with the {@link #first}, {@link #last}, {@link #get}, and {@link #previous} properties.
         *
         * @name Phaser.Structs.List#position
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.position = 0;
                    /**
         * A callback that is invoked every time a child is added to this list.
         *
         * @name Phaser.Structs.List#addCallback
         * @type {function}
         * @since 3.4.0
         */ this.addCallback = NOOP;
                    /**
         * A callback that is invoked every time a child is removed from this list.
         *
         * @name Phaser.Structs.List#removeCallback
         * @type {function}
         * @since 3.4.0
         */ this.removeCallback = NOOP;
                    /**
         * The property key to sort by.
         *
         * @name Phaser.Structs.List#_sortKey
         * @type {string}
         * @since 3.4.0
         */ this._sortKey = '';
                },
                /**
     * Adds the given item to the end of the list. Each item must be unique.
     *
     * @method Phaser.Structs.List#add
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*|Array.<*>} child - The item, or array of items, to add to the list.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The list's underlying array.
     */ add: function(child, skipCallback) {
                    if (skipCallback) return ArrayUtils.Add(this.list, child);
                    else return ArrayUtils.Add(this.list, child, 0, this.addCallback, this);
                },
                /**
     * Adds an item to list, starting at a specified index. Each item must be unique within the list.
     *
     * @method Phaser.Structs.List#addAt
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item, or array of items, to add to the list.
     * @param {number} [index=0] - The index in the list at which the element(s) will be inserted.
     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
     *
     * @return {*} The List's underlying array.
     */ addAt: function(child, index, skipCallback) {
                    if (skipCallback) return ArrayUtils.AddAt(this.list, child, index);
                    else return ArrayUtils.AddAt(this.list, child, index, 0, this.addCallback, this);
                },
                /**
     * Retrieves the item at a given position inside the List.
     *
     * @method Phaser.Structs.List#getAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The index of the item.
     *
     * @return {*} The retrieved item, or `undefined` if it's outside the List's bounds.
     */ getAt: function(index) {
                    return this.list[index];
                },
                /**
     * Locates an item within the List and returns its index.
     *
     * @method Phaser.Structs.List#getIndex
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to locate.
     *
     * @return {number} The index of the item within the List, or -1 if it's not in the List.
     */ getIndex: function(child) {
                    //  Return -1 if given child isn't a child of this display list
                    return this.list.indexOf(child);
                },
                /**
     * Sort the contents of this List so the items are in order based on the given property.
     * For example, `sort('alpha')` would sort the List contents based on the value of their `alpha` property.
     *
     * @method Phaser.Structs.List#sort
     * @since 3.0.0
     *
     * @genericUse {T[]} - [children,$return]
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {Phaser.Structs.List} This List object.
     */ sort: function(property, handler) {
                    if (!property) return this;
                    if (handler === undefined) handler = function(childA, childB) {
                        return childA[property] - childB[property];
                    };
                    StableSort(this.list, handler);
                    return this;
                },
                /**
     * Searches for the first instance of a child with its `name`
     * property matching the given argument. Should more than one child have
     * the same name only the first is returned.
     *
     * @method Phaser.Structs.List#getByName
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} name - The name to search for.
     *
     * @return {?*} The first child with a matching name, or null if none were found.
     */ getByName: function(name) {
                    return ArrayUtils.GetFirst(this.list, 'name', name);
                },
                /**
     * Returns a random child from the group.
     *
     * @method Phaser.Structs.List#getRandom
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {number} [startIndex=0] - Offset from the front of the group (lowest child).
     * @param {number} [length=(to top)] - Restriction on the number of values you want to randomly select from.
     *
     * @return {?*} A random child of this Group.
     */ getRandom: function(startIndex, length) {
                    return ArrayUtils.GetRandom(this.list, startIndex, length);
                },
                /**
     * Returns the first element in a given part of the List which matches a specific criterion.
     *
     * @method Phaser.Structs.List#getFirst
     * @since 3.0.0
     *
     * @genericUse {T | null} - [$return]
     *
     * @param {string} property - The name of the property to test or a falsey value to have no criterion.
     * @param {*} value - The value to test the `property` against, or `undefined` to allow any value and only check for existence.
     * @param {number} [startIndex=0] - The position in the List to start the search at.
     * @param {number} [endIndex] - The position in the List to optionally stop the search at. It won't be checked.
     *
     * @return {?*} The first item which matches the given criterion, or `null` if no such item exists.
     */ getFirst: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns all children in this List.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('parent')` would return only children that have a property called `parent`.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only children that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this List had 100 children,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 children in the List.
     *
     * @method Phaser.Structs.List#getAll
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {T[]} - [$return]
     *
     * @param {string} [property] - An optional property to test against the value argument.
     * @param {*} [value] - If property is set then Child.property must strictly equal this value to be included in the results.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     *
     * @return {Array.<*>} All items of the List which match the given criterion, if any.
     */ getAll: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns the total number of items in the List which have a property matching the given value.
     *
     * @method Phaser.Structs.List#count
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The property to test on each item.
     * @param {*} value - The value to test the property against.
     *
     * @return {number} The total number of matching elements.
     */ count: function(property, value) {
                    return ArrayUtils.CountAllMatching(this.list, property, value);
                },
                /**
     * Swaps the positions of two items in the list.
     *
     * @method Phaser.Structs.List#swap
     * @since 3.0.0
     *
     * @genericUse {T} - [child1,child2]
     *
     * @param {*} child1 - The first item to swap.
     * @param {*} child2 - The second item to swap.
     */ swap: function(child1, child2) {
                    ArrayUtils.Swap(this.list, child1, child2);
                },
                /**
     * Moves an item in the List to a new position.
     *
     * @method Phaser.Structs.List#moveTo
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move.
     * @param {number} index - Moves an item in the List to a new position.
     *
     * @return {*} The item that was moved.
     */ moveTo: function(child, index) {
                    return ArrayUtils.MoveTo(this.list, child, index);
                },
                /**
     * Removes one or many items from the List.
     *
     * @method Phaser.Structs.List#remove
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item, or array of items, to remove.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item, or array of items, which were successfully removed from the List.
     */ remove: function(child, skipCallback) {
                    if (skipCallback) return ArrayUtils.Remove(this.list, child);
                    else return ArrayUtils.Remove(this.list, child, this.removeCallback, this);
                },
                /**
     * Removes the item at the given position in the List.
     *
     * @method Phaser.Structs.List#removeAt
     * @since 3.0.0
     *
     * @genericUse {T} - [$return]
     *
     * @param {number} index - The position to remove the item from.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {*} The item that was removed.
     */ removeAt: function(index, skipCallback) {
                    if (skipCallback) return ArrayUtils.RemoveAt(this.list, index);
                    else return ArrayUtils.RemoveAt(this.list, index, this.removeCallback, this);
                },
                /**
     * Removes the items within the given range in the List.
     *
     * @method Phaser.Structs.List#removeBetween
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @param {number} [startIndex=0] - The index to start removing from.
     * @param {number} [endIndex] - The position to stop removing at. The item at this position won't be removed.
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {Array.<*>} An array of the items which were removed.
     */ removeBetween: function(startIndex, endIndex, skipCallback) {
                    if (skipCallback) return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex);
                    else return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeCallback, this);
                },
                /**
     * Removes all the items.
     *
     * @method Phaser.Structs.List#removeAll
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
     *
     * @return {Phaser.Structs.List} This List object.
     */ removeAll: function(skipCallback) {
                    var i = this.list.length;
                    while(i--)this.remove(this.list[i], skipCallback);
                    return this;
                },
                /**
     * Brings the given child to the top of this List.
     *
     * @method Phaser.Structs.List#bringToTop
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to bring to the top of the List.
     *
     * @return {*} The item which was moved.
     */ bringToTop: function(child) {
                    return ArrayUtils.BringToTop(this.list, child);
                },
                /**
     * Sends the given child to the bottom of this List.
     *
     * @method Phaser.Structs.List#sendToBack
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to send to the back of the list.
     *
     * @return {*} The item which was moved.
     */ sendToBack: function(child) {
                    return ArrayUtils.SendToBack(this.list, child);
                },
                /**
     * Moves the given child up one place in this group unless it's already at the top.
     *
     * @method Phaser.Structs.List#moveUp
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move up.
     *
     * @return {*} The item which was moved.
     */ moveUp: function(child) {
                    ArrayUtils.MoveUp(this.list, child);
                    return child;
                },
                /**
     * Moves the given child down one place in this group unless it's already at the bottom.
     *
     * @method Phaser.Structs.List#moveDown
     * @since 3.0.0
     *
     * @genericUse {T} - [child,$return]
     *
     * @param {*} child - The item to move down.
     *
     * @return {*} The item which was moved.
     */ moveDown: function(child) {
                    ArrayUtils.MoveDown(this.list, child);
                    return child;
                },
                /**
     * Reverses the order of all children in this List.
     *
     * @method Phaser.Structs.List#reverse
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ reverse: function() {
                    this.list.reverse();
                    return this;
                },
                /**
     * Shuffles the items in the list.
     *
     * @method Phaser.Structs.List#shuffle
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.List.<T>} - [$return]
     *
     * @return {Phaser.Structs.List} This List object.
     */ shuffle: function() {
                    ArrayUtils.Shuffle(this.list);
                    return this;
                },
                /**
     * Replaces a child of this List with the given newChild. The newChild cannot be a member of this List.
     *
     * @method Phaser.Structs.List#replace
     * @since 3.0.0
     *
     * @genericUse {T} - [oldChild,newChild,$return]
     *
     * @param {*} oldChild - The child in this List that will be replaced.
     * @param {*} newChild - The child to be inserted into this List.
     *
     * @return {*} Returns the oldChild that was replaced within this group.
     */ replace: function(oldChild, newChild) {
                    return ArrayUtils.Replace(this.list, oldChild, newChild);
                },
                /**
     * Checks if an item exists within the List.
     *
     * @method Phaser.Structs.List#exists
     * @since 3.0.0
     *
     * @genericUse {T} - [child]
     *
     * @param {*} child - The item to check for the existence of.
     *
     * @return {boolean} `true` if the item is found in the list, otherwise `false`.
     */ exists: function(child) {
                    return this.list.indexOf(child) > -1;
                },
                /**
     * Sets the property `key` to the given value on all members of this List.
     *
     * @method Phaser.Structs.List#setAll
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {string} property - The name of the property to set.
     * @param {*} value - The value to set the property to.
     * @param {number} [startIndex] - The first child index to start the search from.
     * @param {number} [endIndex] - The last child index to search up until.
     */ setAll: function(property, value, startIndex, endIndex) {
                    ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                    return this;
                },
                /**
     * Passes all children to the given callback.
     *
     * @method Phaser.Structs.List#each
     * @since 3.0.0
     *
     * @genericUse {EachListCallback.<T>} - [callback]
     *
     * @param {EachListCallback} callback - The function to call.
     * @param {*} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, context) {
                    var args = [
                        null
                    ];
                    for(var i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < this.list.length; i++){
                        args[0] = this.list[i];
                        callback.apply(context, args);
                    }
                },
                /**
     * Clears the List and recreates its internal array.
     *
     * @method Phaser.Structs.List#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.removeAll();
                    this.list = [];
                },
                /**
     * Destroys this List.
     *
     * @method Phaser.Structs.List#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAll();
                    this.parent = null;
                    this.addCallback = null;
                    this.removeCallback = null;
                },
                /**
     * The number of items inside the List.
     *
     * @name Phaser.Structs.List#length
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                /**
     * The first item in the List or `null` for an empty List.
     *
     * @name Phaser.Structs.List#first
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ first: {
                    get: function() {
                        this.position = 0;
                        if (this.list.length > 0) return this.list[0];
                        else return null;
                    }
                },
                /**
     * The last item in the List, or `null` for an empty List.
     *
     * @name Phaser.Structs.List#last
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ last: {
                    get: function() {
                        if (this.list.length > 0) {
                            this.position = this.list.length - 1;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * The next item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #first} or manually setting the {@link #position} to iterate the List.
     *
     * @name Phaser.Structs.List#next
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ next: {
                    get: function() {
                        if (this.position < this.list.length) {
                            this.position++;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * The previous item in the List, or `null` if the entire List has been traversed.
     *
     * This property can be read successively after reading {@link #last} or manually setting the {@link #position} to iterate the List backwards.
     *
     * @name Phaser.Structs.List#previous
     * @genericUse {T} - [$type]
     * @type {*}
     * @readonly
     * @since 3.0.0
     */ previous: {
                    get: function() {
                        if (this.position > 0) {
                            this.position--;
                            return this.list[this.position];
                        } else return null;
                    }
                }
            });
            module1.exports = List;
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(109);
            var GetPoint = __webpack_require__(439);
            var GetPoints = __webpack_require__(440);
            var GEOM_CONST = __webpack_require__(55);
            var Random = __webpack_require__(177);
            /**
 * @classdesc
 * An Ellipse object.
 *
 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render an Ellipse you should look at the capabilities of the Graphics class.
 *
 * @class Ellipse
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x position of the center of the ellipse.
 * @param {number} [y=0] - The y position of the center of the ellipse.
 * @param {number} [width=0] - The width of the ellipse.
 * @param {number} [height=0] - The height of the ellipse.
 */ var Ellipse = new Class({
                initialize: function Ellipse(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    /**
         * The geometry constant type of this object: `GEOM_CONST.ELLIPSE`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Ellipse#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.ELLIPSE;
                    /**
         * The x position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of the center of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The width of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#width
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the ellipse.
         *
         * @name Phaser.Geom.Ellipse#height
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.height = height;
                },
                /**
     * Check to see if the Ellipse contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Ellipse#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the ellipse.
     * @param {number} y - The y coordinate to check within the ellipse.
     *
     * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
     * at 180 degrees around the circle.
     *
     * @method Phaser.Geom.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [out,$return]
     *
     * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
     *
     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
     */ getPoint: function(position, point) {
                    return GetPoint(this, position, point);
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Ellipse#getPoints
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
     */ getPoints: function(quantity, stepRate, output) {
                    return GetPoints(this, quantity, stepRate, output);
                },
                /**
     * Returns a uniformly distributed random point from anywhere within the given Ellipse.
     *
     * @method Phaser.Geom.Ellipse#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Point} O - [point,$return]
     *
     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
     *
     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
     */ getRandomPoint: function(point) {
                    return Random(this, point);
                },
                /**
     * Sets the x, y, width and height of this ellipse.
     *
     * @method Phaser.Geom.Ellipse#setTo
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setTo: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets this Ellipse to be empty with a width and height of zero.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setEmpty
     * @since 3.0.0
     *
     * @return {this} This Ellipse object.
     */ setEmpty: function() {
                    this.width = 0;
                    this.height = 0;
                    return this;
                },
                /**
     * Sets the position of this Ellipse.
     *
     * @method Phaser.Geom.Ellipse#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The x position of the center of the ellipse.
     * @param {number} y - The y position of the center of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the size of this Ellipse.
     * Does not change its position.
     *
     * @method Phaser.Geom.Ellipse#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the ellipse.
     * @param {number} [height=width] - The height of the ellipse.
     *
     * @return {this} This Ellipse object.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Checks to see if the Ellipse is empty: has a width or height equal to zero.
     *
     * @method Phaser.Geom.Ellipse#isEmpty
     * @since 3.0.0
     *
     * @return {boolean} True if the Ellipse is empty, otherwise false.
     */ isEmpty: function() {
                    return this.width <= 0 || this.height <= 0;
                },
                /**
     * Returns the minor radius of the ellipse. Also known as the Semi Minor Axis.
     *
     * @method Phaser.Geom.Ellipse#getMinorRadius
     * @since 3.0.0
     *
     * @return {number} The minor radius.
     */ getMinorRadius: function() {
                    return Math.min(this.width, this.height) / 2;
                },
                /**
     * Returns the major radius of the ellipse. Also known as the Semi Major Axis.
     *
     * @method Phaser.Geom.Ellipse#getMajorRadius
     * @since 3.0.0
     *
     * @return {number} The major radius.
     */ getMajorRadius: function() {
                    return Math.max(this.width, this.height) / 2;
                },
                /**
     * The left position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#left
     * @type {number}
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.x - this.width / 2;
                    },
                    set: function(value) {
                        this.x = value + this.width / 2;
                    }
                },
                /**
     * The right position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#right
     * @type {number}
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.x + this.width / 2;
                    },
                    set: function(value) {
                        this.x = value - this.width / 2;
                    }
                },
                /**
     * The top position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#top
     * @type {number}
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.y - this.height / 2;
                    },
                    set: function(value) {
                        this.y = value + this.height / 2;
                    }
                },
                /**
     * The bottom position of the Ellipse.
     *
     * @name Phaser.Geom.Ellipse#bottom
     * @type {number}
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.y + this.height / 2;
                    },
                    set: function(value) {
                        this.y = value - this.height / 2;
                    }
                }
            });
            module1.exports = Ellipse;
        /***/ },
        /* 109 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check to see if the Ellipse contains the given x / y coordinates.
 *
 * @function Phaser.Geom.Ellipse.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {number} x - The x coordinate to check within the ellipse.
 * @param {number} y - The y coordinate to check within the ellipse.
 *
 * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
 */ var Contains = function(ellipse, x, y) {
                if (ellipse.width <= 0 || ellipse.height <= 0) return false;
                //  Normalize the coords to an ellipse with center 0,0 and a radius of 0.5
                var normx = (x - ellipse.x) / ellipse.width;
                var normy = (y - ellipse.y) / ellipse.height;
                normx *= normx;
                normy *= normy;
                return normx + normy < 0.25;
            };
            module1.exports = Contains;
        /***/ },
        /* 110 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Actions = __webpack_require__(269);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(75);
            var EventEmitter = __webpack_require__(9);
            var GetAll = __webpack_require__(204);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            var Range = __webpack_require__(431);
            var Set = __webpack_require__(148);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * A Group is a way for you to create, manipulate, or recycle similar Game Objects.
 *
 * Group membership is non-exclusive. A Game Object can belong to several groups, one group, or none.
 *
 * Groups themselves aren't displayable, and can't be positioned, rotated, scaled, or hidden.
 *
 * @class Group
 * @memberof Phaser.GameObjects
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group. If `key` is set, Phaser.GameObjects.Group#createMultiple is also called with these settings.
 *
 * @see Phaser.Physics.Arcade.Group
 * @see Phaser.Physics.Arcade.StaticGroup
 */ var Group = new Class({
                Extends: EventEmitter,
                initialize: function Group(scene, children, config) {
                    EventEmitter.call(this);
                    //  They can pass in any of the following as the first argument:
                    //  1) A single child
                    //  2) An array of children
                    //  3) A config object
                    //  4) An array of config objects
                    //  Or they can pass in a child, or array of children AND a config object
                    if (config) //  config has been set, are the children an array?
                    {
                        if (children && !Array.isArray(children)) children = [
                            children
                        ];
                    } else if (Array.isArray(children)) //  No config, so let's check the children argument
                    {
                        if (IsPlainObject(children[0])) {
                            //  It's an array of plain config objects
                            config = children;
                            children = null;
                        }
                    } else if (IsPlainObject(children)) {
                        //  Children isn't an array. Is it a config object though?
                        config = children;
                        children = null;
                    }
                    /**
         * This scene this group belongs to.
         *
         * @name Phaser.GameObjects.Group#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Members of this group.
         *
         * @name Phaser.GameObjects.Group#children
         * @type {Phaser.Structs.Set.<Phaser.GameObjects.GameObject>}
         * @since 3.0.0
         */ this.children = new Set();
                    /**
         * A flag identifying this object as a group.
         *
         * @name Phaser.GameObjects.Group#isParent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isParent = true;
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Group#type
         * @type {string}
         * @default 'Group'
         * @since 3.21.0
         */ this.type = 'Group';
                    /**
         * The class to create new group members from.
         *
         * @name Phaser.GameObjects.Group#classType
         * @type {Function}
         * @since 3.0.0
         * @default Phaser.GameObjects.Sprite
         */ this.classType = GetFastValue(config, 'classType', Sprite);
                    /**
         * The name of this group.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Group#name
         * @type {string}
         * @default ''
         * @since 3.18.0
         */ this.name = GetFastValue(config, 'name', '');
                    /**
         * Whether this group runs its {@link Phaser.GameObjects.Group#preUpdate} method (which may update any members).
         *
         * @name Phaser.GameObjects.Group#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = GetFastValue(config, 'active', true);
                    /**
         * The maximum size of this group, if used as a pool. -1 is no limit.
         *
         * @name Phaser.GameObjects.Group#maxSize
         * @type {number}
         * @since 3.0.0
         * @default -1
         */ this.maxSize = GetFastValue(config, 'maxSize', -1);
                    /**
         * A default texture key to use when creating new group members.
         *
         * This is used in {@link Phaser.GameObjects.Group#create}
         * but not in {@link Phaser.GameObjects.Group#createMultiple}.
         *
         * @name Phaser.GameObjects.Group#defaultKey
         * @type {string}
         * @since 3.0.0
         */ this.defaultKey = GetFastValue(config, 'defaultKey', null);
                    /**
         * A default texture frame to use when creating new group members.
         *
         * @name Phaser.GameObjects.Group#defaultFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.defaultFrame = GetFastValue(config, 'defaultFrame', null);
                    /**
         * Whether to call the update method of any members.
         *
         * @name Phaser.GameObjects.Group#runChildUpdate
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Group#preUpdate
         */ this.runChildUpdate = GetFastValue(config, 'runChildUpdate', false);
                    /**
         * A function to be called when adding or creating group members.
         *
         * @name Phaser.GameObjects.Group#createCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.createCallback = GetFastValue(config, 'createCallback', null);
                    /**
         * A function to be called when removing group members.
         *
         * @name Phaser.GameObjects.Group#removeCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @since 3.0.0
         */ this.removeCallback = GetFastValue(config, 'removeCallback', null);
                    /**
         * A function to be called when creating several group members at once.
         *
         * @name Phaser.GameObjects.Group#createMultipleCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupMultipleCreateCallback}
         * @since 3.0.0
         */ this.createMultipleCallback = GetFastValue(config, 'createMultipleCallback', null);
                    /**
         * A function to be called when adding or creating group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalCreateCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalCreateCallback = GetFastValue(config, 'internalCreateCallback', null);
                    /**
         * A function to be called when removing group members.
         * For internal use only by a Group, or any class that extends it.
         *
         * @name Phaser.GameObjects.Group#internalRemoveCallback
         * @type {?Phaser.Types.GameObjects.Group.GroupCallback}
         * @private
         * @since 3.22.0
         */ this.internalRemoveCallback = GetFastValue(config, 'internalRemoveCallback', null);
                    if (children) this.addMultiple(children);
                    if (config) this.createMultiple(config);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Creates a new Game Object and adds it to this group, unless the group {@link Phaser.GameObjects.Group#isFull is full}.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#create
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the new Game Object in the world.
     * @param {number} [y=0] - The vertical position of the new Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key of the new Game Object.
     * @param {(string|number)} [frame=defaultFrame] - The texture frame of the new Game Object.
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of the new Game Object.
     * @param {boolean} [active=true] - The {@link Phaser.GameObjects.GameObject#active} state of the new Game Object.
     *
     * @return {any} The new Game Object (usually a Sprite, etc.).
     */ create: function(x, y, key, frame, visible, active) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (key === undefined) key = this.defaultKey;
                    if (frame === undefined) frame = this.defaultFrame;
                    if (visible === undefined) visible = true;
                    if (active === undefined) active = true;
                    //  Pool?
                    if (this.isFull()) return null;
                    var child = new this.classType(this.scene, x, y, key, frame);
                    this.scene.sys.displayList.add(child);
                    if (child.preUpdate) this.scene.sys.updateList.add(child);
                    child.visible = visible;
                    child.setActive(active);
                    this.add(child);
                    return child;
                },
                /**
     * Creates several Game Objects and adds them to this group.
     *
     * If the group becomes {@link Phaser.GameObjects.Group#isFull}, no further Game Objects are created.
     *
     * Calls {@link Phaser.GameObjects.Group#createMultipleCallback} and {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#createMultiple
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig[]} config - Creation settings. This can be a single configuration object or an array of such objects, which will be applied in turn.
     *
     * @return {any[]} The newly created Game Objects.
     */ createMultiple: function(config) {
                    if (this.isFull()) return [];
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var output = [];
                    if (config[0].key) for(var i = 0; i < config.length; i++){
                        var entries = this.createFromConfig(config[i]);
                        output = output.concat(entries);
                    }
                    return output;
                },
                /**
     * A helper for {@link Phaser.GameObjects.Group#createMultiple}.
     *
     * @method Phaser.GameObjects.Group#createFromConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Group.GroupCreateConfig} options - Creation settings.
     *
     * @return {any[]} The newly created Game Objects.
     */ createFromConfig: function(options) {
                    if (this.isFull()) return [];
                    this.classType = GetFastValue(options, 'classType', this.classType);
                    var key = GetFastValue(options, 'key', undefined);
                    var frame = GetFastValue(options, 'frame', null);
                    var visible = GetFastValue(options, 'visible', true);
                    var active = GetFastValue(options, 'active', true);
                    var entries = [];
                    //  Can't do anything without at least a key
                    if (key === undefined) return entries;
                    else {
                        if (!Array.isArray(key)) key = [
                            key
                        ];
                        if (!Array.isArray(frame)) frame = [
                            frame
                        ];
                    }
                    //  Build an array of key frame pairs to loop through
                    var repeat = GetFastValue(options, 'repeat', 0);
                    var randomKey = GetFastValue(options, 'randomKey', false);
                    var randomFrame = GetFastValue(options, 'randomFrame', false);
                    var yoyo = GetFastValue(options, 'yoyo', false);
                    var quantity = GetFastValue(options, 'quantity', false);
                    var frameQuantity = GetFastValue(options, 'frameQuantity', 1);
                    var max = GetFastValue(options, 'max', 0);
                    //  If a quantity value is set we use that to override the frameQuantity
                    var range = Range(key, frame, {
                        max: max,
                        qty: quantity ? quantity : frameQuantity,
                        random: randomKey,
                        randomB: randomFrame,
                        repeat: repeat,
                        yoyo: yoyo
                    });
                    if (options.createCallback) this.createCallback = options.createCallback;
                    if (options.removeCallback) this.removeCallback = options.removeCallback;
                    for(var c = 0; c < range.length; c++){
                        var created = this.create(0, 0, range[c].a, range[c].b, visible, active);
                        if (!created) break;
                        entries.push(created);
                    }
                    //  Post-creation options (applied only to those items created in this call):
                    var x = GetValue(options, 'setXY.x', 0);
                    var y = GetValue(options, 'setXY.y', 0);
                    var stepX = GetValue(options, 'setXY.stepX', 0);
                    var stepY = GetValue(options, 'setXY.stepY', 0);
                    Actions.SetXY(entries, x, y, stepX, stepY);
                    var rotation = GetValue(options, 'setRotation.value', 0);
                    var stepRotation = GetValue(options, 'setRotation.step', 0);
                    Actions.SetRotation(entries, rotation, stepRotation);
                    var scaleX = GetValue(options, 'setScale.x', 1);
                    var scaleY = GetValue(options, 'setScale.y', scaleX);
                    var stepScaleX = GetValue(options, 'setScale.stepX', 0);
                    var stepScaleY = GetValue(options, 'setScale.stepY', 0);
                    Actions.SetScale(entries, scaleX, scaleY, stepScaleX, stepScaleY);
                    var originX = GetValue(options, 'setOrigin.x', 0.5);
                    var originY = GetValue(options, 'setOrigin.y', originX);
                    var stepOriginX = GetValue(options, 'setOrigin.stepX', 0);
                    var stepOriginY = GetValue(options, 'setOrigin.stepY', 0);
                    Actions.SetOrigin(entries, originX, originY, stepOriginX, stepOriginY);
                    var alpha = GetValue(options, 'setAlpha.value', 1);
                    var stepAlpha = GetValue(options, 'setAlpha.step', 0);
                    Actions.SetAlpha(entries, alpha, stepAlpha);
                    var depth = GetValue(options, 'setDepth.value', 0);
                    var stepDepth = GetValue(options, 'setDepth.step', 0);
                    Actions.SetDepth(entries, depth, stepDepth);
                    var scrollFactorX = GetValue(options, 'setScrollFactor.x', 1);
                    var scrollFactorY = GetValue(options, 'setScrollFactor.y', scrollFactorX);
                    var stepScrollFactorX = GetValue(options, 'setScrollFactor.stepX', 0);
                    var stepScrollFactorY = GetValue(options, 'setScrollFactor.stepY', 0);
                    Actions.SetScrollFactor(entries, scrollFactorX, scrollFactorY, stepScrollFactorX, stepScrollFactorY);
                    var hitArea = GetFastValue(options, 'hitArea', null);
                    var hitAreaCallback = GetFastValue(options, 'hitAreaCallback', null);
                    if (hitArea) Actions.SetHitArea(entries, hitArea, hitAreaCallback);
                    var grid = GetFastValue(options, 'gridAlign', false);
                    if (grid) Actions.GridAlign(entries, grid);
                    if (this.createMultipleCallback) this.createMultipleCallback.call(this, entries);
                    return entries;
                },
                /**
     * Updates any group members, if {@link Phaser.GameObjects.Group#runChildUpdate} is enabled.
     *
     * @method Phaser.GameObjects.Group#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    if (!this.runChildUpdate || this.children.size === 0) return;
                    //  Because a Group child may mess with the length of the Group during its update
                    var temp = this.children.entries.slice();
                    for(var i = 0; i < temp.length; i++){
                        var item = temp[i];
                        if (item.active) item.update(time, delta);
                    }
                },
                /**
     * Adds a Game Object to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#add
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     * @param {boolean} [addToScene=false] - Also add the Game Object to the scene.
     *
     * @return {this} This Group object.
     */ add: function(child, addToScene) {
                    if (addToScene === undefined) addToScene = false;
                    if (this.isFull()) return this;
                    this.children.set(child);
                    if (this.internalCreateCallback) this.internalCreateCallback.call(this, child);
                    if (this.createCallback) this.createCallback.call(this, child);
                    if (addToScene) {
                        this.scene.sys.displayList.add(child);
                        if (child.preUpdate) this.scene.sys.updateList.add(child);
                    }
                    child.on(Events.DESTROY, this.remove, this);
                    return this;
                },
                /**
     * Adds several Game Objects to this group.
     *
     * Calls {@link Phaser.GameObjects.Group#createCallback}.
     *
     * @method Phaser.GameObjects.Group#addMultiple
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - The Game Objects to add.
     * @param {boolean} [addToScene=false] - Also add the Game Objects to the scene.
     *
     * @return {this} This group.
     */ addMultiple: function(children, addToScene) {
                    if (addToScene === undefined) addToScene = false;
                    if (Array.isArray(children)) for(var i = 0; i < children.length; i++)this.add(children[i], addToScene);
                    return this;
                },
                /**
     * Removes a member of this Group and optionally removes it from the Scene and / or destroys it.
     *
     * Calls {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#remove
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     * @param {boolean} [removeFromScene=false] - Optionally remove the Group member from the Scene it belongs to.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group member.
     *
     * @return {this} This Group object.
     */ remove: function(child, removeFromScene, destroyChild) {
                    if (removeFromScene === undefined) removeFromScene = false;
                    if (destroyChild === undefined) destroyChild = false;
                    if (!this.children.contains(child)) return this;
                    this.children.delete(child);
                    if (this.internalRemoveCallback) this.internalRemoveCallback.call(this, child);
                    if (this.removeCallback) this.removeCallback.call(this, child);
                    child.off(Events.DESTROY, this.remove, this);
                    if (destroyChild) child.destroy();
                    else if (removeFromScene) {
                        child.scene.sys.displayList.remove(child);
                        if (child.preUpdate) child.scene.sys.updateList.remove(child);
                    }
                    return this;
                },
                /**
     * Removes all members of this Group and optionally removes them from the Scene and / or destroys them.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#clear
     * @since 3.0.0
     *
     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group members.
     *
     * @return {this} This group.
     */ clear: function(removeFromScene, destroyChild) {
                    if (removeFromScene === undefined) removeFromScene = false;
                    if (destroyChild === undefined) destroyChild = false;
                    var children = this.children;
                    for(var i = 0; i < children.size; i++){
                        var gameObject = children.entries[i];
                        gameObject.off(Events.DESTROY, this.remove, this);
                        if (destroyChild) gameObject.destroy();
                        else if (removeFromScene) {
                            gameObject.scene.sys.displayList.remove(gameObject);
                            if (gameObject.preUpdate) gameObject.scene.sys.updateList.remove(gameObject);
                        }
                    }
                    this.children.clear();
                    return this;
                },
                /**
     * Tests if a Game Object is a member of this group.
     *
     * @method Phaser.GameObjects.Group#contains
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - A Game Object.
     *
     * @return {boolean} True if the Game Object is a member of this group.
     */ contains: function(child) {
                    return this.children.contains(child);
                },
                /**
     * All members of the group.
     *
     * @method Phaser.GameObjects.Group#getChildren
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.children.entries;
                },
                /**
     * The number of members of the group.
     *
     * @method Phaser.GameObjects.Group#getLength
     * @since 3.0.0
     *
     * @return {number}
     */ getLength: function() {
                    return this.children.size;
                },
                /**
     * Returns all children in this Group that match the given criteria based on the `property` and `value` arguments.
     *
     * For example: `getAll('visible', true)` would return only children that have their `visible` property set.
     *
     * Optionally, you can specify a start and end index. For example if the Group has 100 elements,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50.
     *
     * @method Phaser.GameObjects.Group#getMatching
     * @since 3.50.0
     *
     * @param {string} [property] - The property to test on each array element.
     * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex] - An optional start index to search from.
     * @param {number} [endIndex] - An optional end index to search to.
     *
     * @return {any[]} An array of matching Group members. The array will be empty if nothing matched.
     */ getMatching: function(property, value, startIndex, endIndex) {
                    return GetAll(this.children.entries, property, value, startIndex, endIndex);
                },
                /**
     * Scans the Group, from top to bottom, for the first member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirst
     * @since 3.0.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirst: function(state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(true, 1, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group, from top to bottom, for the nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getFirstNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(true, nth, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLast
     * @since 3.6.0
     *
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLast: function(state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(false, 1, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the Group for the last nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getLastNth
     * @since 3.6.0
     *
     * @param {number} nth - The nth matching Group member to search for.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getLastNth: function(nth, state, createIfNull, x, y, key, frame, visible) {
                    return this.getHandler(false, nth, state, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
     * assigns `x` and `y`, and returns the member.
     *
     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getHandler
     * @private
     * @since 3.6.0
     *
     * @param {boolean} forwards - Search front to back or back to front?
     * @param {number} nth - Stop matching after nth successful matches.
     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first matching group member, or a newly created member, or null.
     */ getHandler: function(forwards, nth, state, createIfNull, x, y, key, frame, visible) {
                    if (state === undefined) state = false;
                    if (createIfNull === undefined) createIfNull = false;
                    var gameObject;
                    var i;
                    var total = 0;
                    var children = this.children.entries;
                    if (forwards) for(i = 0; i < children.length; i++){
                        gameObject = children[i];
                        if (gameObject.active === state) {
                            total++;
                            if (total === nth) break;
                        } else gameObject = null;
                    }
                    else for(i = children.length - 1; i >= 0; i--){
                        gameObject = children[i];
                        if (gameObject.active === state) {
                            total++;
                            if (total === nth) break;
                        } else gameObject = null;
                    }
                    if (gameObject) {
                        if (typeof x === 'number') gameObject.x = x;
                        if (typeof y === 'number') gameObject.y = y;
                        return gameObject;
                    }
                    //  Got this far? We need to create or bail
                    if (createIfNull) return this.create(x, y, key, frame, visible);
                    else return null;
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have its active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#get
     * @since 3.0.0
     *
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {?any} The first inactive group member, or a newly created member, or null.
     */ get: function(x, y, key, frame, visible) {
                    return this.getFirst(false, true, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `true`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no active member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstAlive
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first active group member, or a newly created member, or null.
     */ getFirstAlive: function(createIfNull, x, y, key, frame, visible) {
                    return this.getFirst(true, createIfNull, x, y, key, frame, visible);
                },
                /**
     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
     * assigns `x` and `y`, and returns the member.
     *
     * If no inactive member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
     * The new Game Object will have an active state set to `true`.
     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
     *
     * @method Phaser.GameObjects.Group#getFirstDead
     * @since 3.0.0
     *
     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
     * @param {number} [x] - The horizontal position of the Game Object in the world.
     * @param {number} [y] - The vertical position of the Game Object in the world.
     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
     * @param {(string|number)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
     *
     * @return {any} The first inactive group member, or a newly created member, or null.
     */ getFirstDead: function(createIfNull, x, y, key, frame, visible) {
                    return this.getFirst(false, createIfNull, x, y, key, frame, visible);
                },
                /**
     * {@link Phaser.GameObjects.Components.Animation#play Plays} an animation for all members of this group.
     *
     * @method Phaser.GameObjects.Group#playAnimation
     * @since 3.0.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {string} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Group object.
     */ playAnimation: function(key, startFrame) {
                    Actions.PlayAnimation(this.children.entries, key, startFrame);
                    return this;
                },
                /**
     * Whether this group's size at its {@link Phaser.GameObjects.Group#maxSize maximum}.
     *
     * @method Phaser.GameObjects.Group#isFull
     * @since 3.0.0
     *
     * @return {boolean} True if the number of members equals {@link Phaser.GameObjects.Group#maxSize}.
     */ isFull: function() {
                    if (this.maxSize === -1) return false;
                    else return this.children.size >= this.maxSize;
                },
                /**
     * Counts the number of active (or inactive) group members.
     *
     * @method Phaser.GameObjects.Group#countActive
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Count active (true) or inactive (false) group members.
     *
     * @return {number} The number of group members with an active state matching the `active` argument.
     */ countActive: function(value) {
                    if (value === undefined) value = true;
                    var total = 0;
                    for(var i = 0; i < this.children.size; i++)if (this.children.entries[i].active === value) total++;
                    return total;
                },
                /**
     * Counts the number of in-use (active) group members.
     *
     * @method Phaser.GameObjects.Group#getTotalUsed
     * @since 3.0.0
     *
     * @return {number} The number of group members with an active state of true.
     */ getTotalUsed: function() {
                    return this.countActive();
                },
                /**
     * The difference of {@link Phaser.GameObjects.Group#maxSize} and the number of active group members.
     *
     * This represents the number of group members that could be created or reactivated before reaching the size limit.
     *
     * @method Phaser.GameObjects.Group#getTotalFree
     * @since 3.0.0
     *
     * @return {number} maxSize minus the number of active group numbers; or a large number (if maxSize is -1).
     */ getTotalFree: function() {
                    var used = this.getTotalUsed();
                    var capacity = this.maxSize === -1 ? 999999999999 : this.maxSize;
                    return capacity - used;
                },
                /**
     * Sets the `active` property of this Group.
     * When active, this Group runs its `preUpdate` method.
     *
     * @method Phaser.GameObjects.Group#setActive
     * @since 3.24.0
     *
     * @param {boolean} value - True if this Group should be set as active, false if not.
     *
     * @return {this} This Group object.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Group.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Group#setName
     * @since 3.24.0
     *
     * @param {string} value - The name to be given to this Group.
     *
     * @return {this} This Group object.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the property as defined in `key` of each group member to the given value.
     *
     * @method Phaser.GameObjects.Group#propertyValueSet
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueSet: function(key, value, step, index, direction) {
                    Actions.PropertyValueSet(this.children.entries, key, value, step, index, direction);
                    return this;
                },
                /**
     * Adds the given value to the property as defined in `key` of each group member.
     *
     * @method Phaser.GameObjects.Group#propertyValueInc
     * @since 3.21.0
     *
     * @param {string} key - The property to be updated.
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ propertyValueInc: function(key, value, step, index, direction) {
                    Actions.PropertyValueInc(this.children.entries, key, value, step, index, direction);
                    return this;
                },
                /**
     * Sets the x of each group member.
     *
     * @method Phaser.GameObjects.Group#setX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setX: function(value, step) {
                    Actions.SetX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the y of each group member.
     *
     * @method Phaser.GameObjects.Group#setY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setY: function(value, step) {
                    Actions.SetY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#setXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to set the `x` property to.
     * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setXY: function(x, y, stepX, stepY) {
                    Actions.SetXY(this.children.entries, x, y, stepX, stepY);
                    return this;
                },
                /**
     * Adds the given value to the x of each group member.
     *
     * @method Phaser.GameObjects.Group#incX
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `x` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incX: function(value, step) {
                    Actions.IncX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Adds the given value to the y of each group member.
     *
     * @method Phaser.GameObjects.Group#incY
     * @since 3.21.0
     *
     * @param {number} value - The amount to be added to the `y` property.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incY: function(value, step) {
                    Actions.IncY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Adds the given value to the x, y of each group member.
     *
     * @method Phaser.GameObjects.Group#incXY
     * @since 3.21.0
     *
     * @param {number} x - The amount to be added to the `x` property.
     * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
     * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ incXY: function(x, y, stepX, stepY) {
                    Actions.IncXY(this.children.entries, x, y, stepX, stepY);
                    return this;
                },
                /**
     * Iterate through the group members changing the position of each element to be that of the element that came before
     * it in the array (or after it if direction = 1)
     *
     * The first group member position is set to x/y.
     *
     * @method Phaser.GameObjects.Group#shiftPosition
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate to place the first item in the array at.
     * @param {number} y - The y coordinate to place the first item in the array at.
     * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
     *
     * @return {this} This Group object.
     */ shiftPosition: function(x, y, direction) {
                    Actions.ShiftPosition(this.children.entries, x, y, direction);
                    return this;
                },
                /**
     * Sets the angle of each group member.
     *
     * @method Phaser.GameObjects.Group#angle
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the angle to, in degrees.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ angle: function(value, step) {
                    Actions.Angle(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the rotation of each group member.
     *
     * @method Phaser.GameObjects.Group#rotate
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the rotation to, in radians.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ rotate: function(value, step) {
                    Actions.Rotate(this.children.entries, value, step);
                    return this;
                },
                /**
     * Rotates each group member around the given point by the given angle.
     *
     * @method Phaser.GameObjects.Group#rotateAround
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     *
     * @return {this} This Group object.
     */ rotateAround: function(point, angle) {
                    Actions.RotateAround(this.children.entries, point, angle);
                    return this;
                },
                /**
     * Rotates each group member around the given point by the given angle and distance.
     *
     * @method Phaser.GameObjects.Group#rotateAroundDistance
     * @since 3.21.0
     *
     * @param {Phaser.Types.Math.Vector2Like} point - Any object with public `x` and `y` properties.
     * @param {number} angle - The angle to rotate by, in radians.
     * @param {number} distance - The distance from the point of rotation in pixels.
     *
     * @return {this} This Group object.
     */ rotateAroundDistance: function(point, angle, distance) {
                    Actions.RotateAroundDistance(this.children.entries, point, angle, distance);
                    return this;
                },
                /**
     * Sets the alpha of each group member.
     *
     * @method Phaser.GameObjects.Group#setAlpha
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the alpha to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setAlpha: function(value, step) {
                    Actions.SetAlpha(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the tint of each group member.
     *
     * @method Phaser.GameObjects.Group#setTint
     * @since 3.21.0
     *
     * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
     * @param {number} [topRight] - The tint to be applied to top-right corner of item.
     * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
     * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
     *
     * @return {this} This Group object.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                    Actions.SetTint(this.children.entries, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Sets the originX, originY of each group member.
     *
     * @method Phaser.GameObjects.Group#setOrigin
     * @since 3.21.0
     *
     * @param {number} originX - The amount to set the `originX` property to.
     * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
     * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setOrigin: function(originX, originY, stepX, stepY) {
                    Actions.SetOrigin(this.children.entries, originX, originY, stepX, stepY);
                    return this;
                },
                /**
     * Sets the scaleX of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleX
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleX: function(value, step) {
                    Actions.ScaleX(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleY
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleY: function(value, step) {
                    Actions.ScaleY(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the scaleX, scaleY of each group member.
     *
     * @method Phaser.GameObjects.Group#scaleXY
     * @since 3.21.0
     *
     * @param {number} scaleX - The amount to be added to the `scaleX` property.
     * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
     * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
     * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ scaleXY: function(scaleX, scaleY, stepX, stepY) {
                    Actions.ScaleXY(this.children.entries, scaleX, scaleY, stepX, stepY);
                    return this;
                },
                /**
     * Sets the depth of each group member.
     *
     * @method Phaser.GameObjects.Group#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The amount to set the property to.
     * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
     *
     * @return {this} This Group object.
     */ setDepth: function(value, step) {
                    Actions.SetDepth(this.children.entries, value, step);
                    return this;
                },
                /**
     * Sets the blendMode of each group member.
     *
     * @method Phaser.GameObjects.Group#setBlendMode
     * @since 3.21.0
     *
     * @param {number} value - The amount to set the property to.
     *
     * @return {this} This Group object.
     */ setBlendMode: function(value) {
                    Actions.SetBlendMode(this.children.entries, value);
                    return this;
                },
                /**
     * Passes all group members to the Input Manager to enable them for input with identical areas and callbacks.
     *
     * @method Phaser.GameObjects.Group#setHitArea
     * @since 3.21.0
     *
     * @param {*} hitArea - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
     *
     * @return {this} This Group object.
     */ setHitArea: function(hitArea, hitAreaCallback) {
                    Actions.SetHitArea(this.children.entries, hitArea, hitAreaCallback);
                    return this;
                },
                /**
     * Shuffles the group members in place.
     *
     * @method Phaser.GameObjects.Group#shuffle
     * @since 3.21.0
     *
     * @return {this} This Group object.
     */ shuffle: function() {
                    Actions.Shuffle(this.children.entries);
                    return this;
                },
                /**
     * Deactivates a member of this group.
     *
     * @method Phaser.GameObjects.Group#kill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ kill: function(gameObject) {
                    if (this.children.contains(gameObject)) gameObject.setActive(false);
                },
                /**
     * Deactivates and hides a member of this group.
     *
     * @method Phaser.GameObjects.Group#killAndHide
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
     */ killAndHide: function(gameObject) {
                    if (this.children.contains(gameObject)) {
                        gameObject.setActive(false);
                        gameObject.setVisible(false);
                    }
                },
                /**
     * Sets the visible of each group member.
     *
     * @method Phaser.GameObjects.Group#setVisible
     * @since 3.21.0
     *
     * @param {boolean} value - The value to set the property to.
     * @param {number} [index=0] - An optional offset to start searching from within the items array.
     * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
     *
     * @return {this} This Group object.
     */ setVisible: function(value, index, direction) {
                    Actions.SetVisible(this.children.entries, value, index, direction);
                    return this;
                },
                /**
     * Toggles (flips) the visible state of each member of this group.
     *
     * @method Phaser.GameObjects.Group#toggleVisible
     * @since 3.0.0
     *
     * @return {this} This Group object.
     */ toggleVisible: function() {
                    Actions.ToggleVisible(this.children.entries);
                    return this;
                },
                /**
     * Empties this group and removes it from the Scene.
     *
     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
     *
     * @method Phaser.GameObjects.Group#destroy
     * @since 3.0.0
     *
     * @param {boolean} [destroyChildren=false] - Also {@link Phaser.GameObjects.GameObject#destroy} each group member.
     */ destroy: function(destroyChildren) {
                    if (destroyChildren === undefined) destroyChildren = false;
                    //  This Game Object had already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    this.clear(false, destroyChildren);
                    this.scene = undefined;
                    this.children = undefined;
                }
            });
            module1.exports = Group;
        /***/ },
        /* 111 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders a filled path for the given Shape.
 *
 * @method Phaser.GameObjects.Shape#FillPathWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGL Pipeline used to render this Shape.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix used to get the position values.
 * @param {Phaser.GameObjects.Shape} src - The Game Object shape being rendered in this call.
 * @param {number} alpha - The base alpha value.
 * @param {number} dx - The source displayOriginX.
 * @param {number} dy - The source displayOriginY.
 */ var FillPathWebGL = function(pipeline, calcMatrix, src, alpha, dx, dy) {
                var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                var path = src.pathData;
                var pathIndexes = src.pathIndexes;
                for(var i = 0; i < pathIndexes.length; i += 3){
                    var p0 = pathIndexes[i] * 2;
                    var p1 = pathIndexes[i + 1] * 2;
                    var p2 = pathIndexes[i + 2] * 2;
                    var x0 = path[p0 + 0] - dx;
                    var y0 = path[p0 + 1] - dy;
                    var x1 = path[p1 + 0] - dx;
                    var y1 = path[p1 + 1] - dy;
                    var x2 = path[p2 + 0] - dx;
                    var y2 = path[p2 + 1] - dy;
                    var tx0 = calcMatrix.getX(x0, y0);
                    var ty0 = calcMatrix.getY(x0, y0);
                    var tx1 = calcMatrix.getX(x1, y1);
                    var ty1 = calcMatrix.getY(x1, y1);
                    var tx2 = calcMatrix.getX(x2, y2);
                    var ty2 = calcMatrix.getY(x2, y2);
                    pipeline.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, fillTintColor, fillTintColor, fillTintColor);
                }
            };
            module1.exports = FillPathWebGL;
        /***/ },
        /* 112 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
            /**
 * Checks if a point (as a pair of coordinates) is inside a Triangle's bounds.
 *
 * @function Phaser.Geom.Triangle.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is inside the Triangle, otherwise `false`.
 */ var Contains = function(triangle, x, y) {
                var v0x = triangle.x3 - triangle.x1;
                var v0y = triangle.y3 - triangle.y1;
                var v1x = triangle.x2 - triangle.x1;
                var v1y = triangle.y2 - triangle.y1;
                var v2x = x - triangle.x1;
                var v2y = y - triangle.y1;
                var dot00 = v0x * v0x + v0y * v0y;
                var dot01 = v0x * v1x + v0y * v1y;
                var dot02 = v0x * v2x + v0y * v2y;
                var dot11 = v1x * v1x + v1y * v1y;
                var dot12 = v1x * v2x + v1y * v2y;
                // Compute barycentric coordinates
                var b = dot00 * dot11 - dot01 * dot01;
                var inv = b === 0 ? 0 : 1 / b;
                var u = (dot11 * dot02 - dot01 * dot12) * inv;
                var v = (dot00 * dot12 - dot01 * dot02) * inv;
                return u >= 0 && v >= 0 && u + v < 1;
            };
            module1.exports = Contains;
        /***/ },
        /* 113 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Rectangle = __webpack_require__(10);
            var RectangleToRectangle = __webpack_require__(114);
            var Vector2 = __webpack_require__(3);
            /**
 * Returns the length of the line.
 *
 * @ignore
 * @private
 *
 * @param {number} x1 - The x1 coordinate.
 * @param {number} y1 - The y1 coordinate.
 * @param {number} x2 - The x2 coordinate.
 * @param {number} y2 - The y2 coordinate.
 *
 * @return {number} The length of the line.
 */ function GetLength(x1, y1, x2, y2) {
                var x = x1 - x2;
                var y = y1 - y2;
                var magnitude = x * x + y * y;
                return Math.sqrt(magnitude);
            }
            /**
 * @classdesc
 * A Face Geometry Object.
 *
 * A Face is used by the Mesh Game Object. A Mesh consists of one, or more, faces that are
 * used to render the Mesh Game Objects in WebGL.
 *
 * A Face consists of 3 Vertex instances, for the 3 corners of the face and methods to help
 * you modify and test them.
 *
 * @class Face
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
 * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
 */ var Face = new Class({
                initialize: function Face(vertex1, vertex2, vertex3) {
                    /**
         * The first vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex1
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex1 = vertex1;
                    /**
         * The second vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex2
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex2 = vertex2;
                    /**
         * The third vertex in this Face.
         *
         * @name Phaser.Geom.Mesh.Face#vertex3
         * @type {Phaser.Geom.Mesh.Vertex}
         * @since 3.50.0
         */ this.vertex3 = vertex3;
                    /**
         * The bounds of this Face.
         *
         * Be sure to call the `Face.updateBounds` method _before_ using this property.
         *
         * @name Phaser.Geom.Mesh.Face#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.50.0
         */ this.bounds = new Rectangle();
                    /**
         * The face inCenter. Do not access directly, instead use the `getInCenter` method.
         *
         * @name Phaser.Geom.Mesh.Face#_inCenter
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.50.0
         */ this._inCenter = new Vector2();
                },
                /**
     * Calculates and returns the in-center position of this Face.
     *
     * @method Phaser.Geom.Mesh.Face#getInCenter
     * @since 3.50.0
     *
     * @param {boolean} [local=true] Return the in center from the un-transformed vertex positions (`true`), or transformed? (`false`)
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the in center position of this Face.
     */ getInCenter: function(local) {
                    if (local === undefined) local = true;
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var v1x;
                    var v1y;
                    var v2x;
                    var v2y;
                    var v3x;
                    var v3y;
                    if (local) {
                        v1x = v1.x;
                        v1y = v1.y;
                        v2x = v2.x;
                        v2y = v2.y;
                        v3x = v3.x;
                        v3y = v3.y;
                    } else {
                        v1x = v1.vx;
                        v1y = v1.vy;
                        v2x = v2.vx;
                        v2y = v2.vy;
                        v3x = v3.vx;
                        v3y = v3.vy;
                    }
                    var d1 = GetLength(v3x, v3y, v2x, v2y);
                    var d2 = GetLength(v1x, v1y, v3x, v3y);
                    var d3 = GetLength(v2x, v2y, v1x, v1y);
                    var p = d1 + d2 + d3;
                    return this._inCenter.set((v1x * d1 + v2x * d2 + v3x * d3) / p, (v1y * d1 + v2y * d2 + v3y * d3) / p);
                },
                /**
     * Checks if the given coordinates are within this Face.
     *
     * You can optionally provide a transform matrix. If given, the Face vertices
     * will be transformed first, before being checked against the coordinates.
     *
     * @method Phaser.Geom.Mesh.Face#contains
     * @since 3.50.0
     *
     * @param {number} x - The horizontal position to check.
     * @param {number} y - The vertical position to check.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [calcMatrix] - Optional transform matrix to apply to the vertices before comparison.
     *
     * @return {boolean} `true` if the coordinates lay within this Face, otherwise `false`.
     */ contains: function(x, y, calcMatrix) {
                    var vertex1 = this.vertex1;
                    var vertex2 = this.vertex2;
                    var vertex3 = this.vertex3;
                    var v1x = vertex1.vx;
                    var v1y = vertex1.vy;
                    var v2x = vertex2.vx;
                    var v2y = vertex2.vy;
                    var v3x = vertex3.vx;
                    var v3y = vertex3.vy;
                    if (calcMatrix) {
                        var a = calcMatrix.a;
                        var b = calcMatrix.b;
                        var c = calcMatrix.c;
                        var d = calcMatrix.d;
                        var e = calcMatrix.e;
                        var f = calcMatrix.f;
                        v1x = vertex1.vx * a + vertex1.vy * c + e;
                        v1y = vertex1.vx * b + vertex1.vy * d + f;
                        v2x = vertex2.vx * a + vertex2.vy * c + e;
                        v2y = vertex2.vx * b + vertex2.vy * d + f;
                        v3x = vertex3.vx * a + vertex3.vy * c + e;
                        v3y = vertex3.vx * b + vertex3.vy * d + f;
                    }
                    var t0x = v3x - v1x;
                    var t0y = v3y - v1y;
                    var t1x = v2x - v1x;
                    var t1y = v2y - v1y;
                    var t2x = x - v1x;
                    var t2y = y - v1y;
                    var dot00 = t0x * t0x + t0y * t0y;
                    var dot01 = t0x * t1x + t0y * t1y;
                    var dot02 = t0x * t2x + t0y * t2y;
                    var dot11 = t1x * t1x + t1y * t1y;
                    var dot12 = t1x * t2x + t1y * t2y;
                    //  Compute barycentric coordinates
                    var bc = dot00 * dot11 - dot01 * dot01;
                    var inv = bc === 0 ? 0 : 1 / bc;
                    var u = (dot11 * dot02 - dot01 * dot12) * inv;
                    var v = (dot00 * dot12 - dot01 * dot02) * inv;
                    return u >= 0 && v >= 0 && u + v < 1;
                },
                /**
     * Checks if the vertices in this Face are orientated counter-clockwise, or not.
     *
     * It checks the transformed position of the vertices, not the local one.
     *
     * @method Phaser.Geom.Mesh.Face#isCounterClockwise
     * @since 3.50.0
     *
     * @param {number} z - The z-axis value to test against. Typically the `Mesh.modelPosition.z`.
     *
     * @return {boolean} `true` if the vertices in this Face run counter-clockwise, otherwise `false`.
     */ isCounterClockwise: function(z) {
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var d = (v2.vx - v1.vx) * (v3.vy - v1.vy) - (v2.vy - v1.vy) * (v3.vx - v1.vx);
                    return z <= 0 ? d >= 0 : d < 0;
                },
                /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Face#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     * @param {number} alpha - The alpha of the parent object.
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     *
     * @return {number} The new vertex index array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                    offset = this.vertex1.load(F32, U32, offset, textureUnit, tintEffect);
                    offset = this.vertex2.load(F32, U32, offset, textureUnit, tintEffect);
                    offset = this.vertex3.load(F32, U32, offset, textureUnit, tintEffect);
                    return offset;
                },
                /**
     * Transforms all Face vertices by the given matrix, storing the results in their `vx`, `vy` and `vz` properties.
     *
     * @method Phaser.Geom.Mesh.Face#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     *
     * @return {this} This Face instance.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                    this.vertex1.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    this.vertex2.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    this.vertex3.transformCoordinatesLocal(transformMatrix, width, height, cameraZ);
                    return this;
                },
                /**
     * Updates the bounds of this Face, based on the translated values of the vertices.
     *
     * Call this method prior to accessing the `Face.bounds` property.
     *
     * @method Phaser.Geom.Mesh.Face#updateBounds
     * @since 3.50.0
     *
     * @return {this} This Face instance.
     */ updateBounds: function() {
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    var bounds = this.bounds;
                    bounds.x = Math.min(v1.vx, v2.vx, v3.vx);
                    bounds.y = Math.min(v1.vy, v2.vy, v3.vy);
                    bounds.width = Math.max(v1.vx, v2.vx, v3.vx) - bounds.x;
                    bounds.height = Math.max(v1.vy, v2.vy, v3.vy) - bounds.y;
                    return this;
                },
                /**
     * Checks if this Face is within the view of the given Camera.
     *
     * This method is called in the `MeshWebGLRenderer` function. It performs the following tasks:
     *
     * First, the `Vertex.update` method is called on each of the vertices. This populates them
     * with the new translated values, updating their `tx`, `ty` and `ta` properties.
     *
     * Then it tests to see if this face is visible due to the alpha values, if not, it returns.
     *
     * After this, if `hideCCW` is set, it calls `isCounterClockwise` and returns if not.
     *
     * Finally, it will update the `Face.bounds` based on the newly translated vertex values
     * and return the results of an intersection test between the bounds and the camera world view
     * rectangle.
     *
     * @method Phaser.Geom.Mesh.Face#isInView
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against.
     * @param {boolean} hideCCW - Test the counter-clockwise orientation of the verts?
     * @param {number} z - The Cameras z position, used in the CCW test.
     * @param {number} alpha - The alpha of the parent object.
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     *
     * @return {boolean} `true` if this Face can be seen by the Camera.
     */ isInView: function(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels) {
                    var v1 = this.vertex1.update(a, b, c, d, e, f, roundPixels, alpha);
                    var v2 = this.vertex2.update(a, b, c, d, e, f, roundPixels, alpha);
                    var v3 = this.vertex3.update(a, b, c, d, e, f, roundPixels, alpha);
                    //  Alpha check first
                    if (v1.ta <= 0 && v2.ta <= 0 && v3.ta <= 0) return false;
                    //  CCW check
                    if (hideCCW && !this.isCounterClockwise(z)) return false;
                    //  Bounds check
                    var bounds = this.bounds;
                    bounds.x = Math.min(v1.tx, v2.tx, v3.tx);
                    bounds.y = Math.min(v1.ty, v2.ty, v3.ty);
                    bounds.width = Math.max(v1.tx, v2.tx, v3.tx) - bounds.x;
                    bounds.height = Math.max(v1.ty, v2.ty, v3.ty) - bounds.y;
                    return RectangleToRectangle(bounds, camera.worldView);
                },
                /**
     * Translates the vertices of this Face by the given amounts.
     *
     * The actual vertex positions are adjusted, not their transformed position.
     *
     * Therefore, this updates the vertex data directly.
     *
     * @method Phaser.Geom.Mesh.Face#translate
     * @since 3.50.0
     *
     * @param {number} x - The amount to horizontally translate by.
     * @param {number} [y=0] - The amount to vertically translate by.
     *
     * @return {this} This Face instance.
     */ translate: function(x, y) {
                    if (y === undefined) y = 0;
                    var v1 = this.vertex1;
                    var v2 = this.vertex2;
                    var v3 = this.vertex3;
                    v1.x += x;
                    v1.y += y;
                    v2.x += x;
                    v2.y += y;
                    v3.x += x;
                    v3.y += y;
                    return this;
                },
                /**
     * The x coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#x
     * @type {number}
     * @since 3.50.0
     */ x: {
                    get: function() {
                        return this.getInCenter().x;
                    },
                    set: function(value) {
                        var current = this.getInCenter();
                        this.translate(value - current.x, 0);
                    }
                },
                /**
     * The y coordinate of this Face, based on the in center position of the Face.
     *
     * @name Phaser.Geom.Mesh.Face#y
     * @type {number}
     * @since 3.50.0
     */ y: {
                    get: function() {
                        return this.getInCenter().y;
                    },
                    set: function(value) {
                        var current = this.getInCenter();
                        this.translate(0, value - current.y);
                    }
                },
                /**
     * Set the alpha value of this Face.
     *
     * Each vertex is given the same value. If you need to adjust the alpha on a per-vertex basis
     * then use the `Vertex.alpha` property instead.
     *
     * When getting the alpha of this Face, it will return an average of the alpha
     * component of all three vertices.
     *
     * @name Phaser.Geom.Mesh.Face#alpha
     * @type {number}
     * @since 3.50.0
     */ alpha: {
                    get: function() {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        return (v1.alpha + v2.alpha + v3.alpha) / 3;
                    },
                    set: function(value) {
                        this.vertex1.alpha = value;
                        this.vertex2.alpha = value;
                        this.vertex3.alpha = value;
                    }
                },
                /**
     * The depth of this Face, which is an average of the z component of all three vertices.
     *
     * The depth is calculated based on the transformed z value, not the local one.
     *
     * @name Phaser.Geom.Mesh.Face#depth
     * @type {number}
     * @readonly
     * @since 3.50.0
     */ depth: {
                    get: function() {
                        var v1 = this.vertex1;
                        var v2 = this.vertex2;
                        var v3 = this.vertex3;
                        return (v1.vz + v2.vz + v3.vz) / 3;
                    }
                },
                /**
     * Destroys this Face and nulls the references to the vertices.
     *
     * @method Phaser.Geom.Mesh.Face#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.vertex1 = null;
                    this.vertex2 = null;
                    this.vertex3 = null;
                }
            });
            module1.exports = Face;
        /***/ },
        /* 114 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles intersect.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds.
 * As such, the two Rectangles are considered "solid".
 * A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.RectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the two Rectangles intersect, otherwise `false`.
 */ var RectangleToRectangle = function(rectA, rectB) {
                if (rectA.width <= 0 || rectA.height <= 0 || rectB.width <= 0 || rectB.height <= 0) return false;
                return !(rectA.right < rectB.x || rectA.bottom < rectB.y || rectA.x > rectB.right || rectA.y > rectB.bottom);
            };
            module1.exports = RectangleToRectangle;
        /***/ },
        /* 115 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Utils = __webpack_require__(12);
            var Vector3 = __webpack_require__(38);
            /**
 * @classdesc
 * A Vertex Geometry Object.
 *
 * This class consists of all the information required for a single vertex within a Face Geometry Object.
 *
 * Faces, and thus Vertex objects, are used by the Mesh Game Object in order to render objects in WebGL.
 *
 * @class Vertex
 * @memberof Phaser.Geom.Mesh
 * @constructor
 * @extends Phaser.Math.Vector3
 * @since 3.50.0
 *
 * @param {number} x - The x position of the vertex.
 * @param {number} y - The y position of the vertex.
 * @param {number} z - The z position of the vertex.
 * @param {number} u - The UV u coordinate of the vertex.
 * @param {number} v - The UV v coordinate of the vertex.
 * @param {number} [color=0xffffff] - The color value of the vertex.
 * @param {number} [alpha=1] - The alpha value of the vertex.
 * @param {number} [nx=0] - The x normal value of the vertex.
 * @param {number} [ny=0] - The y normal value of the vertex.
 * @param {number} [nz=0] - The z normal value of the vertex.
 */ var Vertex = new Class({
                Extends: Vector3,
                initialize: function Vertex(x, y, z, u, v, color, alpha, nx, ny, nz) {
                    if (color === undefined) color = 0xffffff;
                    if (alpha === undefined) alpha = 1;
                    if (nx === undefined) nx = 0;
                    if (ny === undefined) ny = 0;
                    if (nz === undefined) nz = 0;
                    Vector3.call(this, x, y, z);
                    /**
         * The projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vx
         * @type {number}
         * @since 3.50.0
         */ this.vx = 0;
                    /**
         * The projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vy
         * @type {number}
         * @since 3.50.0
         */ this.vy = 0;
                    /**
         * The projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#vz
         * @type {number}
         * @since 3.50.0
         */ this.vz = 0;
                    /**
         * The projected x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nx
         * @type {number}
         * @since 3.50.0
         */ this.nx = nx;
                    /**
         * The projected y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ny
         * @type {number}
         * @since 3.50.0
         */ this.ny = ny;
                    /**
         * The projected z coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#nz
         * @type {number}
         * @since 3.50.0
         */ this.nz = nz;
                    /**
         * UV u coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#u
         * @type {number}
         * @since 3.50.0
         */ this.u = u;
                    /**
         * UV v coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#v
         * @type {number}
         * @since 3.50.0
         */ this.v = v;
                    /**
         * The color value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#color
         * @type {number}
         * @since 3.50.0
         */ this.color = color;
                    /**
         * The alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = alpha;
                    /**
         * The translated x coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#tx
         * @type {number}
         * @since 3.50.0
         */ this.tx = 0;
                    /**
         * The translated y coordinate of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ty
         * @type {number}
         * @since 3.50.0
         */ this.ty = 0;
                    /**
         * The translated alpha value of this vertex.
         *
         * @name Phaser.Geom.Mesh.Vertex#ta
         * @type {number}
         * @since 3.50.0
         */ this.ta = 0;
                },
                /**
     * Sets the U and V properties.
     *
     * @method Phaser.Geom.Mesh.Vertex#setUVs
     * @since 3.50.0
     *
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     *
     * @return {this} This Vertex.
     */ setUVs: function(u, v) {
                    this.u = u;
                    this.v = v;
                    return this;
                },
                /**
     * Transforms this vertex by the given matrix, storing the results in `vx`, `vy` and `vz`.
     *
     * @method Phaser.Geom.Mesh.Vertex#transformCoordinatesLocal
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} transformMatrix - The transform matrix to apply to this vertex.
     * @param {number} width - The width of the parent Mesh.
     * @param {number} height - The height of the parent Mesh.
     * @param {number} cameraZ - The z position of the MeshCamera.
     */ transformCoordinatesLocal: function(transformMatrix, width, height, cameraZ) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var m = transformMatrix.val;
                    var tx = x * m[0] + y * m[4] + z * m[8] + m[12];
                    var ty = x * m[1] + y * m[5] + z * m[9] + m[13];
                    var tz = x * m[2] + y * m[6] + z * m[10] + m[14];
                    var tw = x * m[3] + y * m[7] + z * m[11] + m[15];
                    this.vx = tx / tw * width;
                    this.vy = -(ty / tw) * height;
                    if (cameraZ <= 0) this.vz = tz / tw;
                    else this.vz = -(tz / tw);
                },
                /**
     * Updates this Vertex based on the given transform.
     *
     * @method Phaser.Geom.Mesh.Vertex#update
     * @since 3.50.0
     *
     * @param {number} a - The parent transform matrix data a component.
     * @param {number} b - The parent transform matrix data b component.
     * @param {number} c - The parent transform matrix data c component.
     * @param {number} d - The parent transform matrix data d component.
     * @param {number} e - The parent transform matrix data e component.
     * @param {number} f - The parent transform matrix data f component.
     * @param {boolean} roundPixels - Round the vertex position or not?
     * @param {number} alpha - The alpha of the parent object.
     *
     * @return {this} This Vertex.
     */ update: function(a, b, c, d, e, f, roundPixels, alpha) {
                    var tx = this.vx * a + this.vy * c + e;
                    var ty = this.vx * b + this.vy * d + f;
                    if (roundPixels) {
                        tx = Math.round(tx);
                        ty = Math.round(ty);
                    }
                    this.tx = tx;
                    this.ty = ty;
                    this.ta = this.alpha * alpha;
                    return this;
                },
                /**
     * Loads the data from this Vertex into the given Typed Arrays.
     *
     * @method Phaser.Geom.Mesh.Vertex#load
     * @since 3.50.0
     *
     * @param {Float32Array} F32 - A Float32 Array to insert the position, UV and unit data in to.
     * @param {Uint32Array} U32 - A Uint32 Array to insert the color and alpha data in to.
     * @param {number} offset - The index of the array to insert this Vertex to.
     * @param {number} textureUnit - The texture unit currently in use.
     *
     * @return {number} The new array offset.
     */ load: function(F32, U32, offset, textureUnit, tintEffect) {
                    F32[++offset] = this.tx;
                    F32[++offset] = this.ty;
                    F32[++offset] = this.u;
                    F32[++offset] = this.v;
                    F32[++offset] = textureUnit;
                    F32[++offset] = tintEffect;
                    U32[++offset] = Utils.getTintAppendFloatAlpha(this.color, this.ta);
                    return offset;
                }
            });
            module1.exports = Vertex;
        /***/ },
        /* 116 */ /***/ function(module1, exports) {
            /**
* The `Matter.Vector` module contains methods for creating and manipulating vectors.
* Vectors are the basis of all the geometry related operations in the engine.
* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vector
*/ // TODO: consider params for reusing vector objects
            var Vector = {};
            module1.exports = Vector;
            (function() {
                /**
     * Creates a new vector.
     * @method create
     * @param {number} x
     * @param {number} y
     * @return {vector} A new vector
     */ Vector.create = function(x, y) {
                    return {
                        x: x || 0,
                        y: y || 0
                    };
                };
                /**
     * Returns a new vector with `x` and `y` copied from the given `vector`.
     * @method clone
     * @param {vector} vector
     * @return {vector} A new cloned vector
     */ Vector.clone = function(vector) {
                    return {
                        x: vector.x,
                        y: vector.y
                    };
                };
                /**
     * Returns the magnitude (length) of a vector.
     * @method magnitude
     * @param {vector} vector
     * @return {number} The magnitude of the vector
     */ Vector.magnitude = function(vector) {
                    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
                };
                /**
     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
     * @method magnitudeSquared
     * @param {vector} vector
     * @return {number} The squared magnitude of the vector
     */ Vector.magnitudeSquared = function(vector) {
                    return vector.x * vector.x + vector.y * vector.y;
                };
                /**
     * Rotates the vector about (0, 0) by specified angle.
     * @method rotate
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} [output]
     * @return {vector} The vector rotated about (0, 0)
     */ Vector.rotate = function(vector, angle, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = vector.x * cos - vector.y * sin;
                    output.y = vector.x * sin + vector.y * cos;
                    output.x = x;
                    return output;
                };
                /**
     * Rotates the vector about a specified point by specified angle.
     * @method rotateAbout
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} point
     * @param {vector} [output]
     * @return {vector} A new vector rotated about the point
     */ Vector.rotateAbout = function(vector, angle, point, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
                    output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
                    output.x = x;
                    return output;
                };
                /**
     * Normalises a vector (such that its magnitude is `1`).
     * @method normalise
     * @param {vector} vector
     * @return {vector} A new vector normalised
     */ Vector.normalise = function(vector) {
                    var magnitude = Vector.magnitude(vector);
                    if (magnitude === 0) return {
                        x: 0,
                        y: 0
                    };
                    return {
                        x: vector.x / magnitude,
                        y: vector.y / magnitude
                    };
                };
                /**
     * Returns the dot-product of two vectors.
     * @method dot
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The dot product of the two vectors
     */ Vector.dot = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.x + vectorA.y * vectorB.y;
                };
                /**
     * Returns the cross-product of two vectors.
     * @method cross
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The cross product of the two vectors
     */ Vector.cross = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.y - vectorA.y * vectorB.x;
                };
                /**
     * Returns the cross-product of three vectors.
     * @method cross3
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} vectorC
     * @return {number} The cross product of the three vectors
     */ Vector.cross3 = function(vectorA, vectorB, vectorC) {
                    return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
                };
                /**
     * Adds the two vectors.
     * @method add
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB added
     */ Vector.add = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x + vectorB.x;
                    output.y = vectorA.y + vectorB.y;
                    return output;
                };
                /**
     * Subtracts the two vectors.
     * @method sub
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB subtracted
     */ Vector.sub = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x - vectorB.x;
                    output.y = vectorA.y - vectorB.y;
                    return output;
                };
                /**
     * Multiplies a vector and a scalar.
     * @method mult
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector multiplied by scalar
     */ Vector.mult = function(vector, scalar) {
                    return {
                        x: vector.x * scalar,
                        y: vector.y * scalar
                    };
                };
                /**
     * Divides a vector and a scalar.
     * @method div
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector divided by scalar
     */ Vector.div = function(vector, scalar) {
                    return {
                        x: vector.x / scalar,
                        y: vector.y / scalar
                    };
                };
                /**
     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
     * @method perp
     * @param {vector} vector
     * @param {bool} [negate=false]
     * @return {vector} The perpendicular vector
     */ Vector.perp = function(vector, negate) {
                    negate = negate === true ? -1 : 1;
                    return {
                        x: negate * -vector.y,
                        y: negate * vector.x
                    };
                };
                /**
     * Negates both components of a vector such that it points in the opposite direction.
     * @method neg
     * @param {vector} vector
     * @return {vector} The negated vector
     */ Vector.neg = function(vector) {
                    return {
                        x: -vector.x,
                        y: -vector.y
                    };
                };
                /**
     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
     * @method angle
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The angle in radians
     */ Vector.angle = function(vectorA, vectorB) {
                    return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
                };
                /**
     * Temporary vector pool (not thread-safe).
     * @property _temp
     * @type {vector[]}
     * @private
     */ Vector._temp = [
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create()
                ];
            })();
        /***/ },
        /* 117 */ /***/ function(module1, exports) {
            /**
* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
*
* @class Bounds
*/ var Bounds = {};
            module1.exports = Bounds;
            (function() {
                /**
     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
     * @method create
     * @param {vertices} vertices
     * @return {bounds} A new bounds object
     */ Bounds.create = function(vertices) {
                    var bounds = {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: 0,
                            y: 0
                        }
                    };
                    if (vertices) Bounds.update(bounds, vertices);
                    return bounds;
                };
                /**
     * Updates bounds using the given vertices and extends the bounds given a velocity.
     * @method update
     * @param {bounds} bounds
     * @param {vertices} vertices
     * @param {vector} velocity
     */ Bounds.update = function(bounds, vertices, velocity) {
                    bounds.min.x = Infinity;
                    bounds.max.x = -Infinity;
                    bounds.min.y = Infinity;
                    bounds.max.y = -Infinity;
                    for(var i = 0; i < vertices.length; i++){
                        var vertex = vertices[i];
                        if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
                        if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
                        if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
                        if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
                    }
                    if (velocity) {
                        if (velocity.x > 0) bounds.max.x += velocity.x;
                        else bounds.min.x += velocity.x;
                        if (velocity.y > 0) bounds.max.y += velocity.y;
                        else bounds.min.y += velocity.y;
                    }
                };
                /**
     * Returns true if the bounds contains the given point.
     * @method contains
     * @param {bounds} bounds
     * @param {vector} point
     * @return {boolean} True if the bounds contain the point, otherwise false
     */ Bounds.contains = function(bounds, point) {
                    return point.x >= bounds.min.x && point.x <= bounds.max.x && point.y >= bounds.min.y && point.y <= bounds.max.y;
                };
                /**
     * Returns true if the two bounds intersect.
     * @method overlaps
     * @param {bounds} boundsA
     * @param {bounds} boundsB
     * @return {boolean} True if the bounds overlap, otherwise false
     */ Bounds.overlaps = function(boundsA, boundsB) {
                    return boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y;
                };
                /**
     * Translates the bounds by the given vector.
     * @method translate
     * @param {bounds} bounds
     * @param {vector} vector
     */ Bounds.translate = function(bounds, vector) {
                    bounds.min.x += vector.x;
                    bounds.max.x += vector.x;
                    bounds.min.y += vector.y;
                    bounds.max.y += vector.y;
                };
                /**
     * Shifts the bounds to the given position.
     * @method shift
     * @param {bounds} bounds
     * @param {vector} position
     */ Bounds.shift = function(bounds, position) {
                    var deltaX = bounds.max.x - bounds.min.x, deltaY = bounds.max.y - bounds.min.y;
                    bounds.min.x = position.x;
                    bounds.max.x = position.x + deltaX;
                    bounds.min.y = position.y;
                    bounds.max.y = position.y + deltaY;
                };
            })();
        /***/ },
        /* 118 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given tile coordinates are within the bounds of the layer.
 *
 * @function Phaser.Tilemaps.Components.IsInLayerBounds
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {boolean} `true` if the tile coordinates are within the bounds of the layer, otherwise `false`.
 */ var IsInLayerBounds = function(tileX, tileY, layer) {
                return tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height;
            };
            module1.exports = IsInLayerBounds;
        /***/ },
        /* 119 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(29);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing data about about a layer in a map. Maps are parsed from CSV, Tiled,
 * etc. into this format. Tilemap and TilemapLayer objects have a reference
 * to this data and use it to look up and perform operations on tiles.
 *
 * @class LayerData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.LayerDataConfig} [config] - The Layer Data configuration object.
 */ var LayerData = new Class({
                initialize: function LayerData(config) {
                    if (config === undefined) config = {};
                    /**
         * The name of the layer, if specified in Tiled.
         *
         * @name Phaser.Tilemaps.LayerData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'layer');
                    /**
         * The x offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#x
         * @type {number}
         * @since 3.0.0
         */ this.x = GetFastValue(config, 'x', 0);
                    /**
         * The y offset of where to draw from the top left.
         *
         * @name Phaser.Tilemaps.LayerData#y
         * @type {number}
         * @since 3.0.0
         */ this.y = GetFastValue(config, 'y', 0);
                    /**
         * The width of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, 'width', 0);
                    /**
         * The height of the layer in tiles.
         *
         * @name Phaser.Tilemaps.LayerData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, 'height', 0);
                    /**
         * The pixel width of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, 'tileWidth', 0);
                    /**
         * The pixel height of the tiles.
         *
         * @name Phaser.Tilemaps.LayerData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, 'tileHeight', 0);
                    /**
         * The base tile width.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileWidth
         * @type {number}
         * @since 3.0.0
         */ this.baseTileWidth = GetFastValue(config, 'baseTileWidth', this.tileWidth);
                    /**
         * The base tile height.
         *
         * @name Phaser.Tilemaps.LayerData#baseTileHeight
         * @type {number}
         * @since 3.0.0
         */ this.baseTileHeight = GetFastValue(config, 'baseTileHeight', this.tileHeight);
                    /**
         * The layers orientation, necessary to be able to determine a tiles pixelX and pixelY as well as the layers width and height.
         *
         * @name Phaser.Tilemaps.LayerData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, 'orientation', CONST.ORTHOGONAL);
                    /**
         * The width in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.baseTileWidth);
                    /**
         * The height in pixels of the entire layer.
         *
         * @name Phaser.Tilemaps.LayerData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.baseTileHeight);
                    /**
         * The alpha value of the layer.
         *
         * @name Phaser.Tilemaps.LayerData#alpha
         * @type {number}
         * @since 3.0.0
         */ this.alpha = GetFastValue(config, 'alpha', 1);
                    /**
         * Is the layer visible or not?
         *
         * @name Phaser.Tilemaps.LayerData#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, 'visible', true);
                    /**
         * Layer specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.LayerData#properties
         * @type {object[]}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', []);
                    /**
         * Tile ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#indexes
         * @type {array}
         * @since 3.0.0
         */ this.indexes = GetFastValue(config, 'indexes', []);
                    /**
         * Tile Collision ID index map.
         *
         * @name Phaser.Tilemaps.LayerData#collideIndexes
         * @type {array}
         * @since 3.0.0
         */ this.collideIndexes = GetFastValue(config, 'collideIndexes', []);
                    /**
         * An array of callbacks.
         *
         * @name Phaser.Tilemaps.LayerData#callbacks
         * @type {array}
         * @since 3.0.0
         */ this.callbacks = GetFastValue(config, 'callbacks', []);
                    /**
         * An array of physics bodies.
         *
         * @name Phaser.Tilemaps.LayerData#bodies
         * @type {array}
         * @since 3.0.0
         */ this.bodies = GetFastValue(config, 'bodies', []);
                    /**
         * An array of the tile data indexes.
         *
         * @name Phaser.Tilemaps.LayerData#data
         * @type {Phaser.Tilemaps.Tile[][]}
         * @since 3.0.0
         */ this.data = GetFastValue(config, 'data', []);
                    /**
         * A reference to the Tilemap layer that owns this data.
         *
         * @name Phaser.Tilemaps.LayerData#tilemapLayer
         * @type {Phaser.Tilemaps.TilemapLayer}
         * @since 3.0.0
         */ this.tilemapLayer = GetFastValue(config, 'tilemapLayer', null);
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.LayerData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, 'hexSideLength', 0);
                }
            });
            module1.exports = LayerData;
        /***/ },
        /* 120 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(29);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing data about a map. Maps are parsed from CSV, Tiled, etc. into this
 * format. A Tilemap object get a copy of this data and then unpacks the needed properties into
 * itself.
 *
 * @class MapData
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.MapDataConfig} [config] - The Map configuration object.
 */ var MapData = new Class({
                initialize: function MapData(config) {
                    if (config === undefined) config = {};
                    /**
         * The key in the Phaser cache that corresponds to the loaded tilemap data.
         *
         * @name Phaser.Tilemaps.MapData#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'map');
                    /**
         * The width of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#width
         * @type {number}
         * @since 3.0.0
         */ this.width = GetFastValue(config, 'width', 0);
                    /**
         * The height of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#height
         * @type {number}
         * @since 3.0.0
         */ this.height = GetFastValue(config, 'height', 0);
                    /**
         * If the map is infinite or not.
         *
         * @name Phaser.Tilemaps.MapData#infinite
         * @type {boolean}
         * @since 3.17.0
         */ this.infinite = GetFastValue(config, 'infinite', false);
                    /**
         * The width of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = GetFastValue(config, 'tileWidth', 0);
                    /**
         * The height of the tiles.
         *
         * @name Phaser.Tilemaps.MapData#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = GetFastValue(config, 'tileHeight', 0);
                    /**
         * The width in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.tileWidth);
                    /**
         * The height in pixels of the entire tilemap.
         *
         * @name Phaser.Tilemaps.MapData#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.tileHeight);
                    /**
         * The format of the map data.
         *
         * @name Phaser.Tilemaps.MapData#format
         * @type {number}
         * @since 3.0.0
         */ this.format = GetFastValue(config, 'format', null);
                    /**
         * The orientation of the map data (i.e. orthogonal, isometric, hexagonal), default 'orthogonal'.
         *
         * @name Phaser.Tilemaps.MapData#orientation
         * @type {Phaser.Tilemaps.OrientationType}
         * @since 3.50.0
         */ this.orientation = GetFastValue(config, 'orientation', CONST.ORTHOGONAL);
                    /**
         * Determines the draw order of tilemap. Default is right-down
         *
         * 0, or 'right-down'
         * 1, or 'left-down'
         * 2, or 'right-up'
         * 3, or 'left-up'
         *
         * @name Phaser.Tilemaps.MapData#renderOrder
         * @type {string}
         * @since 3.12.0
         */ this.renderOrder = GetFastValue(config, 'renderOrder', 'right-down');
                    /**
         * The version of the map data (as specified in Tiled).
         *
         * @name Phaser.Tilemaps.MapData#version
         * @type {string}
         * @since 3.0.0
         */ this.version = GetFastValue(config, 'version', '1');
                    /**
         * Map specific properties (can be specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', {});
                    /**
         * An array with all the layers configured to the MapData.
         *
         * @name Phaser.Tilemaps.MapData#layers
         * @type {(Phaser.Tilemaps.LayerData[]|Phaser.Tilemaps.ObjectLayer)}
         * @since 3.0.0
         */ this.layers = GetFastValue(config, 'layers', []);
                    /**
         * An array of Tiled Image Layers.
         *
         * @name Phaser.Tilemaps.MapData#images
         * @type {array}
         * @since 3.0.0
         */ this.images = GetFastValue(config, 'images', []);
                    /**
         * An object of Tiled Object Layers.
         *
         * @name Phaser.Tilemaps.MapData#objects
         * @type {object}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, 'objects', {});
                    /**
          * An object of collision data. Must be created as physics object or will return undefined.
         *
         * @name Phaser.Tilemaps.MapData#collision
         * @type {object}
         * @since 3.0.0
         */ this.collision = GetFastValue(config, 'collision', {});
                    /**
         * An array of Tilesets.
         *
         * @name Phaser.Tilemaps.MapData#tilesets
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.0.0
         */ this.tilesets = GetFastValue(config, 'tilesets', []);
                    /**
         * The collection of images the map uses(specified in Tiled)
         *
         * @name Phaser.Tilemaps.MapData#imageCollections
         * @type {array}
         * @since 3.0.0
         */ this.imageCollections = GetFastValue(config, 'imageCollections', []);
                    /**
         * An array of tile instances.
         *
         * @name Phaser.Tilemaps.MapData#tiles
         * @type {array}
         * @since 3.0.0
         */ this.tiles = GetFastValue(config, 'tiles', []);
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.MapData#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = GetFastValue(config, 'hexSideLength', 0);
                }
            });
            module1.exports = MapData;
        /***/ },
        /* 121 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Tileset is a combination of an image containing the tiles and a container for data about
 * each tile.
 *
 * @class Tileset
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {string} name - The name of the tileset in the map data.
 * @param {number} firstgid - The first tile index this tileset contains.
 * @param {number} [tileWidth=32] - Width of each tile (in pixels).
 * @param {number} [tileHeight=32] - Height of each tile (in pixels).
 * @param {number} [tileMargin=0] - The margin around all tiles in the sheet (in pixels).
 * @param {number} [tileSpacing=0] - The spacing between each tile in the sheet (in pixels).
 * @param {object} [tileProperties={}] - Custom properties defined per tile in the Tileset.
 * These typically are custom properties created in Tiled when editing a tileset.
 * @param {object} [tileData={}] - Data stored per tile. These typically are created in Tiled
 * when editing a tileset, e.g. from Tiled's tile collision editor or terrain editor.
 */ var Tileset = new Class({
                initialize: function Tileset(name, firstgid, tileWidth, tileHeight, tileMargin, tileSpacing, tileProperties, tileData) {
                    if (tileWidth === undefined || tileWidth <= 0) tileWidth = 32;
                    if (tileHeight === undefined || tileHeight <= 0) tileHeight = 32;
                    if (tileMargin === undefined) tileMargin = 0;
                    if (tileSpacing === undefined) tileSpacing = 0;
                    if (tileProperties === undefined) tileProperties = {};
                    if (tileData === undefined) tileData = {};
                    /**
         * The name of the Tileset.
         *
         * @name Phaser.Tilemaps.Tileset#name
         * @type {string}
         * @since 3.0.0
         */ this.name = name;
                    /**
         * The starting index of the first tile index this Tileset contains.
         *
         * @name Phaser.Tilemaps.Tileset#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid;
                    /**
         * The width of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileWidth = tileWidth;
                    /**
         * The height of each tile (in pixels). Use setTileSize to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileHeight = tileHeight;
                    /**
         * The margin around the tiles in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileMargin
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileMargin = tileMargin;
                    /**
         * The spacing between each the tile in the sheet (in pixels). Use `setSpacing` to change.
         *
         * @name Phaser.Tilemaps.Tileset#tileSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.tileSpacing = tileSpacing;
                    /**
         * Tileset-specific properties per tile that are typically defined in the Tiled editor in the
         * Tileset editor.
         *
         * @name Phaser.Tilemaps.Tileset#tileProperties
         * @type {object}
         * @since 3.0.0
         */ this.tileProperties = tileProperties;
                    /**
         * Tileset-specific data per tile that are typically defined in the Tiled editor, e.g. within
         * the Tileset collision editor. This is where collision objects and terrain are stored.
         *
         * @name Phaser.Tilemaps.Tileset#tileData
         * @type {object}
         * @since 3.0.0
         */ this.tileData = tileData;
                    /**
         * The cached image that contains the individual tiles. Use setImage to set.
         *
         * @name Phaser.Tilemaps.Tileset#image
         * @type {?Phaser.Textures.Texture}
         * @readonly
         * @since 3.0.0
         */ this.image = null;
                    /**
         * The gl texture used by the WebGL renderer.
         *
         * @name Phaser.Tilemaps.Tileset#glTexture
         * @type {?WebGLTexture}
         * @readonly
         * @since 3.11.0
         */ this.glTexture = null;
                    /**
         * The number of tile rows in the the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#rows
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.rows = 0;
                    /**
         * The number of tile columns in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#columns
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.columns = 0;
                    /**
         * The total number of tiles in the tileset.
         *
         * @name Phaser.Tilemaps.Tileset#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                    /**
         * The look-up table to specific tile image texture coordinates (UV in pixels). Each element
         * contains the coordinates for a tile in an object of the form {x, y}.
         *
         * @name Phaser.Tilemaps.Tileset#texCoordinates
         * @type {object[]}
         * @readonly
         * @since 3.0.0
        */ this.texCoordinates = [];
                },
                /**
     * Get a tiles properties that are stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined in Tiled under the Tileset editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileProperties
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?(object|undefined)}
     */ getTileProperties: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.tileProperties[tileIndex - this.firstgid];
                },
                /**
     * Get a tile's data that is stored in the Tileset. Returns null if tile index is not contained
     * in this Tileset. This is typically defined in Tiled and will contain both Tileset collision
     * info and terrain mapping.
     *
     * @method Phaser.Tilemaps.Tileset#getTileData
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object|undefined}
     */ getTileData: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.tileData[tileIndex - this.firstgid];
                },
                /**
     * Get a tile's collision group that is stored in the Tileset. Returns null if tile index is not
     * contained in this Tileset. This is typically defined within Tiled's tileset collision editor.
     *
     * @method Phaser.Tilemaps.Tileset#getTileCollisionGroup
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object}
     */ getTileCollisionGroup: function(tileIndex) {
                    var data = this.getTileData(tileIndex);
                    return data && data.objectgroup ? data.objectgroup : null;
                },
                /**
     * Returns true if and only if this Tileset contains the given tile index.
     *
     * @method Phaser.Tilemaps.Tileset#containsTileIndex
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {boolean}
     */ containsTileIndex: function(tileIndex) {
                    return tileIndex >= this.firstgid && tileIndex < this.firstgid + this.total;
                },
                /**
     * Returns the texture coordinates (UV in pixels) in the Tileset image for the given tile index.
     * Returns null if tile index is not contained in this Tileset.
     *
     * @method Phaser.Tilemaps.Tileset#getTileTextureCoordinates
     * @since 3.0.0
     *
     * @param {number} tileIndex - The unique id of the tile across all tilesets in the map.
     *
     * @return {?object} Object in the form { x, y } representing the top-left UV coordinate
     * within the Tileset image.
     */ getTileTextureCoordinates: function(tileIndex) {
                    if (!this.containsTileIndex(tileIndex)) return null;
                    return this.texCoordinates[tileIndex - this.firstgid];
                },
                /**
     * Sets the image associated with this Tileset and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setImage
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Texture} texture - The image that contains the tiles.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setImage: function(texture) {
                    this.image = texture;
                    this.glTexture = texture.get().source.glTexture;
                    this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Sets the tile width & height and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setTileSize
     * @since 3.0.0
     *
     * @param {number} [tileWidth] - The width of a tile in pixels.
     * @param {number} [tileHeight] - The height of a tile in pixels.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setTileSize: function(tileWidth, tileHeight) {
                    if (tileWidth !== undefined) this.tileWidth = tileWidth;
                    if (tileHeight !== undefined) this.tileHeight = tileHeight;
                    if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Sets the tile margin & spacing and updates the tile data (rows, columns, etc.).
     *
     * @method Phaser.Tilemaps.Tileset#setSpacing
     * @since 3.0.0
     *
     * @param {number} [margin] - The margin around the tiles in the sheet (in pixels).
     * @param {number} [spacing] - The spacing between the tiles in the sheet (in pixels).
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ setSpacing: function(margin, spacing) {
                    if (margin !== undefined) this.tileMargin = margin;
                    if (spacing !== undefined) this.tileSpacing = spacing;
                    if (this.image) this.updateTileData(this.image.source[0].width, this.image.source[0].height);
                    return this;
                },
                /**
     * Updates tile texture coordinates and tileset data.
     *
     * @method Phaser.Tilemaps.Tileset#updateTileData
     * @since 3.0.0
     *
     * @param {number} imageWidth - The (expected) width of the image to slice.
     * @param {number} imageHeight - The (expected) height of the image to slice.
     *
     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
     */ updateTileData: function(imageWidth, imageHeight) {
                    var rowCount = (imageHeight - this.tileMargin * 2 + this.tileSpacing) / (this.tileHeight + this.tileSpacing);
                    var colCount = (imageWidth - this.tileMargin * 2 + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
                    if (rowCount % 1 !== 0 || colCount % 1 !== 0) console.warn('Image tile area not tile size multiple in: ' + this.name);
                    // In Tiled a tileset image that is not an even multiple of the tile dimensions is truncated
                    // - hence the floor when calculating the rows/columns.
                    rowCount = Math.floor(rowCount);
                    colCount = Math.floor(colCount);
                    this.rows = rowCount;
                    this.columns = colCount;
                    // In Tiled, "empty" spaces in a tileset count as tiles and hence count towards the gid
                    this.total = rowCount * colCount;
                    this.texCoordinates.length = 0;
                    var tx = this.tileMargin;
                    var ty = this.tileMargin;
                    for(var y = 0; y < this.rows; y++){
                        for(var x = 0; x < this.columns; x++){
                            this.texCoordinates.push({
                                x: tx,
                                y: ty
                            });
                            tx += this.tileWidth + this.tileSpacing;
                        }
                        tx = this.tileMargin;
                        ty += this.tileHeight + this.tileSpacing;
                    }
                    return this;
                }
            });
            module1.exports = Tileset;
        /***/ },
        /* 122 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = {
                /**
    * A constant representing a top-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_LEFT
    * @since 3.0.0
    * @type {number}
    */ TOP_LEFT: 0,
                /**
    * A constant representing a top-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_CENTER
    * @since 3.0.0
    * @type {number}
    */ TOP_CENTER: 1,
                /**
    * A constant representing a top-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.TOP_RIGHT
    * @since 3.0.0
    * @type {number}
    */ TOP_RIGHT: 2,
                /**
    * A constant representing a left-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_TOP
    * @since 3.0.0
    * @type {number}
    */ LEFT_TOP: 3,
                /**
    * A constant representing a left-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_CENTER
    * @since 3.0.0
    * @type {number}
    */ LEFT_CENTER: 4,
                /**
    * A constant representing a left-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.LEFT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ LEFT_BOTTOM: 5,
                /**
    * A constant representing a center alignment or position.
    * @constant
    * @name Phaser.Display.Align.CENTER
    * @since 3.0.0
    * @type {number}
    */ CENTER: 6,
                /**
    * A constant representing a right-top alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_TOP
    * @since 3.0.0
    * @type {number}
    */ RIGHT_TOP: 7,
                /**
    * A constant representing a right-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_CENTER
    * @since 3.0.0
    * @type {number}
    */ RIGHT_CENTER: 8,
                /**
    * A constant representing a right-bottom alignment or position.
    * @constant
    * @name Phaser.Display.Align.RIGHT_BOTTOM
    * @since 3.0.0
    * @type {number}
    */ RIGHT_BOTTOM: 9,
                /**
    * A constant representing a bottom-left alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_LEFT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_LEFT: 10,
                /**
    * A constant representing a bottom-center alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_CENTER
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_CENTER: 11,
                /**
    * A constant representing a bottom-right alignment or position.
    * @constant
    * @name Phaser.Display.Align.BOTTOM_RIGHT
    * @since 3.0.0
    * @type {number}
    */ BOTTOM_RIGHT: 12
            };
            module1.exports = ALIGN_CONST;
        /***/ },
        /* 123 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether the given values are fuzzily equal.
 *
 * Two numbers are fuzzily equal if their difference is less than `epsilon`.
 *
 * @function Phaser.Math.Fuzzy.Equal
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if the values are fuzzily equal, otherwise `false`.
 */ var Equal = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.abs(a - b) < epsilon;
            };
            module1.exports = Equal;
        /***/ },
        /* 124 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var ImageRender = __webpack_require__(1062);
            /**
 * @classdesc
 * An Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var Image1 = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    ImageRender
                ],
                initialize: function Image1(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, 'Image');
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Image#_crop
         * @type {object}
         * @private
         * @since 3.11.0
         */ this._crop = this.resetCropObject();
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.setOriginFromFrame();
                    this.initPipeline();
                }
            });
            module1.exports = Image1;
        /***/ },
        /* 125 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determine whether the source object has a property with the specified key.
 *
 * @function Phaser.Utils.Objects.HasValue
 * @since 3.0.0
 *
 * @param {object} source - The source object to be checked.
 * @param {string} key - The property to check for within the object
 *
 * @return {boolean} `true` if the provided `key` exists on the `source` object, otherwise `false`.
 */ var HasValue = function(source, key) {
                return source.hasOwnProperty(key);
            };
            module1.exports = HasValue;
        /***/ },
        /* 126 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Bodies` module contains factory methods for creating rigid body models 
* with commonly used body configurations (such as rectangles, circles and other polygons).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Bodies
*/ // TODO: true circle bodies
            var Bodies = {};
            module1.exports = Bodies;
            var Vertices = __webpack_require__(94);
            var Common = __webpack_require__(50);
            var Body = __webpack_require__(71);
            var Bounds = __webpack_require__(117);
            var Vector = __webpack_require__(116);
            var decomp = __webpack_require__(1487);
            (function() {
                /**
     * Creates a new rigid body model with a rectangle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method rectangle
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {object} [options]
     * @return {body} A new rectangle body
     */ Bodies.rectangle = function(x, y, width, height, options) {
                    options = options || {};
                    var rectangle = {
                        label: 'Rectangle Body',
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath('L 0 0 L ' + width + ' 0 L ' + width + ' ' + height + ' L 0 ' + height)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, rectangle, options));
                };
                /**
     * Creates a new rigid body model with a trapezoid hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method trapezoid
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} slope
     * @param {object} [options]
     * @return {body} A new trapezoid body
     */ Bodies.trapezoid = function(x, y, width, height, slope, options) {
                    options = options || {};
                    slope *= 0.5;
                    var roof = (1 - slope * 2) * width;
                    var x1 = width * slope, x2 = x1 + roof, x3 = x2 + x1, verticesPath;
                    if (slope < 0.5) verticesPath = 'L 0 0 L ' + x1 + ' ' + -height + ' L ' + x2 + ' ' + -height + ' L ' + x3 + ' 0';
                    else verticesPath = 'L 0 0 L ' + x2 + ' ' + -height + ' L ' + x3 + ' 0';
                    var trapezoid = {
                        label: 'Trapezoid Body',
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(verticesPath)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, trapezoid, options));
                };
                /**
     * Creates a new rigid body model with a circle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {object} [options]
     * @param {number} [maxSides]
     * @return {body} A new circle body
     */ Bodies.circle = function(x, y, radius, options, maxSides) {
                    options = options || {};
                    var circle = {
                        label: 'Circle Body',
                        circleRadius: radius
                    };
                    // approximate circles with polygons until true circles implemented in SAT
                    maxSides = maxSides || 25;
                    var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
                    // optimisation: always use even number of sides (half the number of unique axes)
                    if (sides % 2 === 1) sides += 1;
                    return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
                };
                /**
     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method polygon
     * @param {number} x
     * @param {number} y
     * @param {number} sides
     * @param {number} radius
     * @param {object} [options]
     * @return {body} A new regular polygon body
     */ Bodies.polygon = function(x, y, sides, radius, options) {
                    options = options || {};
                    if (sides < 3) return Bodies.circle(x, y, radius, options);
                    var theta = 2 * Math.PI / sides, path = '', offset = theta * 0.5;
                    for(var i = 0; i < sides; i += 1){
                        var angle = offset + i * theta, xx = Math.cos(angle) * radius, yy = Math.sin(angle) * radius;
                        path += 'L ' + xx.toFixed(3) + ' ' + yy.toFixed(3) + ' ';
                    }
                    var polygon = {
                        label: 'Polygon Body',
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(path)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, polygon, options));
                };
                /**
     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices).
     * If the vertices are convex, they will pass through as supplied.
     * Otherwise if the vertices are concave, they will be decomposed if [poly-decomp.js](https://github.com/schteppe/poly-decomp.js) is available.
     * Note that this process is not guaranteed to support complex sets of vertices (e.g. those with holes may fail).
     * By default the decomposition will discard collinear edges (to improve performance).
     * It can also optionally discard any parts that have an area less than `minimumArea`.
     * If the vertices can not be decomposed, the result will fall back to using the convex hull.
     * The options parameter is an object that specifies any `Matter.Body` properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method fromVertices
     * @param {number} x
     * @param {number} y
     * @param [[vector]] vertexSets
     * @param {object} [options]
     * @param {bool} [flagInternal=false]
     * @param {number} [removeCollinear=0.01]
     * @param {number} [minimumArea=10]
     * @return {body}
     */ Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
                    var body, parts, isConvex, vertices, i, j, k, v, z;
                    options = options || {};
                    parts = [];
                    flagInternal = typeof flagInternal !== 'undefined' ? flagInternal : false;
                    removeCollinear = typeof removeCollinear !== 'undefined' ? removeCollinear : 0.01;
                    minimumArea = typeof minimumArea !== 'undefined' ? minimumArea : 10;
                    if (!decomp) Common.warn('Bodies.fromVertices: poly-decomp.js required. Could not decompose vertices. Fallback to convex hull.');
                    // ensure vertexSets is an array of arrays
                    if (!Common.isArray(vertexSets[0])) vertexSets = [
                        vertexSets
                    ];
                    for(v = 0; v < vertexSets.length; v += 1){
                        vertices = vertexSets[v];
                        isConvex = Vertices.isConvex(vertices);
                        if (isConvex || !decomp) {
                            if (isConvex) vertices = Vertices.clockwiseSort(vertices);
                            else // fallback to convex hull when decomposition is not possible
                            vertices = Vertices.hull(vertices);
                            parts.push({
                                position: {
                                    x: x,
                                    y: y
                                },
                                vertices: vertices
                            });
                        } else {
                            // initialise a decomposition
                            var concave = vertices.map(function(vertex) {
                                return [
                                    vertex.x,
                                    vertex.y
                                ];
                            });
                            // vertices are concave and simple, we can decompose into parts
                            decomp.makeCCW(concave);
                            if (removeCollinear !== false) decomp.removeCollinearPoints(concave, removeCollinear);
                            // use the quick decomposition algorithm (Bayazit)
                            var decomposed = decomp.quickDecomp(concave);
                            // for each decomposed chunk
                            for(i = 0; i < decomposed.length; i++){
                                var chunk = decomposed[i];
                                // convert vertices into the correct structure
                                var chunkVertices = chunk.map(function(vertices) {
                                    return {
                                        x: vertices[0],
                                        y: vertices[1]
                                    };
                                });
                                // skip small chunks
                                if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea) continue;
                                // create a compound part
                                parts.push({
                                    position: Vertices.centre(chunkVertices),
                                    vertices: chunkVertices
                                });
                            }
                        }
                    }
                    // create body parts
                    for(i = 0; i < parts.length; i++)parts[i] = Body.create(Common.extend(parts[i], options));
                    if (flagInternal) Bodies.flagCoincidentParts(parts, 5);
                    if (parts.length > 1) {
                        // create the parent body to be returned, that contains generated compound parts
                        body = Body.create(Common.extend({
                            parts: parts.slice(0)
                        }, options));
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    } else return parts[0];
                };
                /**
     * Takes an array of Body objects and flags all internal edges (coincident parts) based on the maxDistance
     * value. The array is changed in-place and returned, so you can pass this function a `Body.parts` property.
     * 
     * @method flagCoincidentParts
     * @param {body[]} parts - The Body parts, or array of bodies, to flag.
     * @param {number} [maxDistance=5]
     * @return {body[]} The modified `parts` parameter.
     */ Bodies.flagCoincidentParts = function(parts, maxDistance) {
                    if (maxDistance === undefined) maxDistance = 5;
                    for(var i = 0; i < parts.length; i++){
                        var partA = parts[i];
                        for(var j = i + 1; j < parts.length; j++){
                            var partB = parts[j];
                            if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                var pav = partA.vertices;
                                var pbv = partB.vertices;
                                // iterate vertices of both parts
                                for(var k = 0; k < partA.vertices.length; k++)for(var z = 0; z < partB.vertices.length; z++){
                                    // find distances between the vertices
                                    var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z]));
                                    var db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                    // if both vertices are very close, consider the edge concident (internal)
                                    if (da < maxDistance && db < maxDistance) {
                                        pav[k].isInternal = true;
                                        pbv[z].isInternal = true;
                                    }
                                }
                            }
                        }
                    }
                    return parts;
                };
            })();
        /***/ },
        /* 127 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            var Circle = __webpack_require__(62);
            var CircleContains = __webpack_require__(63);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(56);
            /**
 * @classdesc
 * A Zone Game Object.
 *
 * A Zone is a non-rendering rectangular Game Object that has a position and size.
 * It has no texture and never displays, but does live on the display list and
 * can be moved, scaled and rotated like any other Game Object.
 *
 * Its primary use is for creating Drop Zones and Input Hit Areas and it has a couple of helper methods
 * specifically for this. It is also useful for object overlap checks, or as a base for your own
 * non-displaying Game Objects.

 * The default origin is 0.5, the center of the Zone, the same as with Game Objects.
 *
 * @class Zone
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=1] - The width of the Game Object.
 * @param {number} [height=1] - The height of the Game Object.
 */ var Zone = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Depth,
                    Components.GetBounds,
                    Components.Origin,
                    Components.Transform,
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function Zone(scene, x, y, width, height) {
                    if (width === undefined) width = 1;
                    if (height === undefined) height = width;
                    GameObject.call(this, scene, 'Zone');
                    this.setPosition(x, y);
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * @name Phaser.GameObjects.Zone#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The Blend Mode of the Game Object.
         * Although a Zone never renders, it still has a blend mode to allow it to fit seamlessly into
         * display lists without causing a batch flush.
         *
         * @name Phaser.GameObjects.Zone#blendMode
         * @type {number}
         * @since 3.0.0
         */ this.blendMode = BlendModes.NORMAL;
                    this.updateDisplayOrigin();
                },
                /**
     * The displayed width of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * This value takes into account the scale factor.
     *
     * @name Phaser.GameObjects.Zone#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                },
                /**
     * Sets the size of this Game Object.
     *
     * @method Phaser.GameObjects.Zone#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * @param {boolean} [resizeInput=true] - If this Zone has a Rectangle for a hit area this argument will resize the hit area as well.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, resizeInput) {
                    if (resizeInput === undefined) resizeInput = true;
                    this.width = width;
                    this.height = height;
                    this.updateDisplayOrigin();
                    var input = this.input;
                    if (resizeInput && input && !input.customHitArea) {
                        input.hitArea.width = width;
                        input.hitArea.height = height;
                    }
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * Calling this will adjust the scale.
     *
     * @method Phaser.GameObjects.Zone#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                },
                /**
     * Sets this Zone to be a Circular Drop Zone.
     * The circle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setCircleDropZone
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Circle that will form the Drop Zone.
     *
     * @return {this} This Game Object.
     */ setCircleDropZone: function(radius) {
                    return this.setDropZone(new Circle(0, 0, radius), CircleContains);
                },
                /**
     * Sets this Zone to be a Rectangle Drop Zone.
     * The rectangle is centered on this Zones `x` and `y` coordinates.
     *
     * @method Phaser.GameObjects.Zone#setRectangleDropZone
     * @since 3.0.0
     *
     * @param {number} width - The width of the rectangle drop zone.
     * @param {number} height - The height of the rectangle drop zone.
     *
     * @return {this} This Game Object.
     */ setRectangleDropZone: function(width, height) {
                    return this.setDropZone(new Rectangle(0, 0, width, height), RectangleContains);
                },
                /**
     * Allows you to define your own Geometry shape to be used as a Drop Zone.
     *
     * @method Phaser.GameObjects.Zone#setDropZone
     * @since 3.0.0
     *
     * @param {object} hitArea - A Geometry shape instance, such as Phaser.Geom.Ellipse, or your own custom shape.
     * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A function that will return `true` if the given x/y coords it is sent are within the shape.
     *
     * @return {this} This Game Object.
     */ setDropZone: function(hitArea, hitAreaCallback) {
                    if (hitArea === undefined) this.setRectangleDropZone(this.width, this.height);
                    else if (!this.input) this.setInteractive(hitArea, hitAreaCallback, true);
                    return this;
                },
                /**
     * A NOOP method so you can pass a Zone to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setAlpha
     * @private
     * @since 3.11.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass a Zone to a Container in Canvas.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Zone#setBlendMode
     * @private
     * @since 3.16.2
     */ setBlendMode: function() {},
                /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderCanvas
     * @private
     * @since 3.0.0
     */ renderCanvas: function() {},
                /**
     * A Zone does not render.
     *
     * @method Phaser.GameObjects.Zone#renderWebGL
     * @private
     * @since 3.0.0
     */ renderWebGL: function() {}
            });
            module1.exports = Zone;
        /***/ },
        /* 128 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the perimeter of a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to use.
 *
 * @return {number} The perimeter of the Rectangle, equal to `(width * 2) + (height * 2)`.
 */ var Perimeter = function(rect) {
                return 2 * (rect.width + rect.height);
            };
            module1.exports = Perimeter;
        /***/ },
        /* 129 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Shuffles the contents of the given array using the Fisher-Yates implementation.
 *
 * The original array is modified directly and returned.
 *
 * @function Phaser.Utils.Array.Shuffle
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [array,$return]
 *
 * @param {T[]} array - The array to shuffle. This array is modified in place.
 *
 * @return {T[]} The shuffled array.
 */ var Shuffle = function(array) {
                for(var i = array.length - 1; i > 0; i--){
                    var j = Math.floor(Math.random() * (i + 1));
                    var temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                }
                return array;
            };
            module1.exports = Shuffle;
        /***/ },
        /* 130 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations.Events
 */ module1.exports = {
                ADD_ANIMATION: __webpack_require__(700),
                ANIMATION_COMPLETE: __webpack_require__(701),
                ANIMATION_COMPLETE_KEY: __webpack_require__(702),
                ANIMATION_REPEAT: __webpack_require__(703),
                ANIMATION_RESTART: __webpack_require__(704),
                ANIMATION_START: __webpack_require__(705),
                ANIMATION_STOP: __webpack_require__(706),
                ANIMATION_UPDATE: __webpack_require__(707),
                PAUSE_ALL: __webpack_require__(708),
                REMOVE_ANIMATION: __webpack_require__(709),
                RESUME_ALL: __webpack_require__(710)
            };
        /***/ },
        /* 131 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DegToRad = __webpack_require__(35);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(36);
            var Rectangle = __webpack_require__(10);
            var TransformMatrix = __webpack_require__(25);
            var ValueToColor = __webpack_require__(184);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Base Camera class.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * The Base Camera is extended by the Camera class, which adds in special effects including Fade,
 * Flash and Camera Shake, as well as the ability to follow Game Objects.
 *
 * The Base Camera was introduced in Phaser 3.12. It was split off from the Camera class, to allow
 * you to isolate special effects as needed. Therefore the 'since' values for properties of this class relate
 * to when they were added to the Camera class.
 *
 * @class BaseCamera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.12.0
 *
 * @extends Phaser.Events.EventEmitter
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var BaseCamera = new Class({
                Extends: EventEmitter,
                Mixins: [
                    Components.Alpha,
                    Components.Visible
                ],
                initialize: function BaseCamera(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 0;
                    if (height === undefined) height = 0;
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene this camera belongs to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene;
                    /**
         * A reference to the Game Scene Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.12.0
         */ this.sceneManager;
                    /**
         * A reference to the Game Scale Manager.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                    /**
         * A reference to the Scene's Camera Manager to which this Camera belongs.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#cameraManager
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.17.0
         */ this.cameraManager;
                    /**
         * The Camera ID. Assigned by the Camera Manager and used to handle camera exclusion.
         * This value is a bitmask.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#id
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.id = 0;
                    /**
         * The name of the Camera. This is left empty for your own use.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                    /**
         * Should this camera round its pixel values to integers?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#roundPixels
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.roundPixels = false;
                    /**
         * Is this Camera visible or not?
         *
         * A visible camera will render and perform input tests.
         * An invisible camera will not render anything and will skip input tests.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#visible
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ /**
         * Is this Camera using a bounds to restrict scrolling movement?
         *
         * Set this property along with the bounds via `Camera.setBounds`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#useBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useBounds = false;
                    /**
         * The World View is a Rectangle that defines the area of the 'world' the Camera is currently looking at.
         * This factors in the Camera viewport size, zoom and scroll position and is updated in the Camera preRender step.
         * If you have enabled Camera bounds the worldview will be clamped to those bounds accordingly.
         * You can use it for culling or intersection checks.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#worldView
         * @type {Phaser.Geom.Rectangle}
         * @readonly
         * @since 3.11.0
         */ this.worldView = new Rectangle();
                    /**
         * Is this Camera dirty?
         *
         * A dirty Camera has had either its viewport size, bounds, scroll, rotation or zoom levels changed since the last frame.
         *
         * This flag is cleared during the `postRenderCamera` method of the renderer.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#dirty
         * @type {boolean}
         * @default true
         * @since 3.11.0
         */ this.dirty = true;
                    /**
         * The x position of the Camera viewport, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_x
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._x = x;
                    /**
         * The y position of the Camera, relative to the top-left of the game canvas.
         * The viewport is the area into which the camera renders.
         * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_y
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._y = y;
                    /**
         * The width of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_width
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._width = width;
                    /**
         * The height of the Camera viewport, in pixels.
         *
         * The viewport is the area into which the Camera renders. Setting the viewport does
         * not restrict where the Camera can scroll to.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_height
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._height = height;
                    /**
         * The bounds the camera is restrained to during scrolling.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                    /**
         * The horizontal scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollX
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollX = 0;
                    /**
         * The vertical scroll position of this Camera.
         *
         * Change this value to cause the Camera to scroll around your Scene.
         *
         * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
         * will automatically adjust the Camera scroll values accordingly.
         *
         * You can set the bounds within which the Camera can scroll via the `setBounds` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_scrollY
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._scrollY = 0;
                    /**
         * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomX
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomX = 1;
                    /**
         * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
         *
         * A value of 0.5 would zoom the Camera out, so you can now see twice as much
         * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
         * now takes up 2 pixels when rendered.
         *
         * Set to 1 to return to the default zoom level.
         *
         * Be careful to never set this value to zero.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_zoomY
         * @type {number}
         * @private
         * @default 1
         * @since 3.50.0
         */ this._zoomY = 1;
                    /**
         * The rotation of the Camera in radians.
         *
         * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
         * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
         *
         * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
         * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_rotation
         * @type {number}
         * @private
         * @default 0
         * @since 3.11.0
         */ this._rotation = 0;
                    /**
         * A local transform matrix used for internal calculations.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#matrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.0.0
         */ this.matrix = new TransformMatrix();
                    /**
         * Does this Camera have a transparent background?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#transparent
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.transparent = true;
                    /**
         * The background color of this Camera. Only used if `transparent` is `false`.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#backgroundColor
         * @type {Phaser.Display.Color}
         * @since 3.0.0
         */ this.backgroundColor = ValueToColor('rgba(0,0,0,0)');
                    /**
         * The Camera alpha value. Setting this property impacts every single object that this Camera
         * renders. You can either set the property directly, i.e. via a Tween, to fade a Camera in or out,
         * or via the chainable `setAlpha` method instead.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#alpha
         * @type {number}
         * @default 1
         * @since 3.11.0
         */ /**
         * Should the camera cull Game Objects before checking them for input hit tests?
         * In some special cases it may be beneficial to disable this.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#disableCull
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.disableCull = false;
                    /**
         * A temporary array of culled objects.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#culledObjects
         * @type {Phaser.GameObjects.GameObject[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.culledObjects = [];
                    /**
         * The mid-point of the Camera in 'world' coordinates.
         *
         * Use it to obtain exactly where in the world the center of the camera is currently looking.
         *
         * This value is updated in the preRender method, after the scroll values and follower
         * have been processed.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#midPoint
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.midPoint = new Vector2(width / 2, height / 2);
                    /**
         * The horizontal origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originX
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originX = 0.5;
                    /**
         * The vertical origin of rotation for this Camera.
         *
         * By default the camera rotates around the center of the viewport.
         *
         * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
         * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
         *
         * See `setOrigin` to set both origins in a single, chainable call.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#originY
         * @type {number}
         * @default 0.5
         * @since 3.11.0
         */ this.originY = 0.5;
                    /**
         * Does this Camera have a custom viewport?
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_customViewport
         * @type {boolean}
         * @private
         * @default false
         * @since 3.12.0
         */ this._customViewport = false;
                    /**
         * The Mask this Camera is using during render.
         * Set the mask using the `setMask` method. Remove the mask using the `clearMask` method.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#mask
         * @type {?(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)}
         * @since 3.17.0
         */ this.mask = null;
                    /**
         * The Camera that this Camera uses for translation during masking.
         *
         * If the mask is fixed in position this will be a reference to
         * the CameraManager.default instance. Otherwise, it'll be a reference
         * to itself.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#_maskCamera
         * @type {?Phaser.Cameras.Scene2D.BaseCamera}
         * @private
         * @since 3.17.0
         */ this._maskCamera = null;
                    /**
         * This array is populated with all of the Game Objects that this Camera has rendered
         * in the previous (or current, depending on when you inspect it) frame.
         *
         * It is cleared at the start of `Camera.preUpdate`, or if the Camera is destroyed.
         *
         * You should not modify this array as it is used internally by the input system,
         * however you can read it as required. Note that Game Objects may appear in this
         * list multiple times if they belong to multiple non-exclusive Containers.
         *
         * @name Phaser.Cameras.Scene2D.BaseCamera#renderList
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.52.0
         */ this.renderList = [];
                },
                /**
     * Adds the given Game Object to this cameras render list.
     *
     * This is invoked during the rendering stage. Only objects that are actually rendered
     * will appear in the render list.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#addToRenderList
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add to the render list.
     */ addToRenderList: function(child) {
                    this.renderList.push(child);
                },
                /**
     * Set the Alpha level of this Camera. The alpha controls the opacity of the Camera as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAlpha
     * @since 3.11.0
     *
     * @param {number} [value=1] - The Camera alpha value.
     *
     * @return {this} This Camera instance.
     */ /**
     * Sets the rotation origin of this Camera.
     *
     * The values are given in the range 0 to 1 and are only used when calculating Camera rotation.
     *
     * By default the camera rotates around the center of the viewport.
     *
     * Changing the origin allows you to adjust the point in the viewport from which rotation happens.
     * A value of 0 would rotate from the top-left of the viewport. A value of 1 from the bottom right.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setOrigin
     * @since 3.11.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Camera instance.
     */ setOrigin: function(x, y) {
                    if (x === undefined) x = 0.5;
                    if (y === undefined) y = x;
                    this.originX = x;
                    this.originY = y;
                    return this;
                },
                /**
     * Calculates what the Camera.scrollX and scrollY values would need to be in order to move
     * the Camera so it is centered on the given x and y coordinates, without actually moving
     * the Camera there. The results are clamped based on the Camera bounds, if set.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getScroll
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 to store the values in. If not given a new Vector2 is created.
     *
     * @return {Phaser.Math.Vector2} The scroll coordinates stored in the `x` and `y` properties.
     */ getScroll: function(x, y, out) {
                    if (out === undefined) out = new Vector2();
                    var originX = this.width * 0.5;
                    var originY = this.height * 0.5;
                    out.x = x - originX;
                    out.y = y - originY;
                    if (this.useBounds) {
                        out.x = this.clampX(out.x);
                        out.y = this.clampY(out.y);
                    }
                    return out;
                },
                /**
     * Moves the Camera horizontally so that it is centered on the given x coordinate, bounds allowing.
     * Calling this does not change the scrollY value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnX
     * @since 3.16.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnX: function(x) {
                    var originX = this.width * 0.5;
                    this.midPoint.x = x;
                    this.scrollX = x - originX;
                    if (this.useBounds) this.scrollX = this.clampX(this.scrollX);
                    return this;
                },
                /**
     * Moves the Camera vertically so that it is centered on the given y coordinate, bounds allowing.
     * Calling this does not change the scrollX value.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOnY
     * @since 3.16.0
     *
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOnY: function(y) {
                    var originY = this.height * 0.5;
                    this.midPoint.y = y;
                    this.scrollY = y - originY;
                    if (this.useBounds) this.scrollY = this.clampY(this.scrollY);
                    return this;
                },
                /**
     * Moves the Camera so that it is centered on the given coordinates, bounds allowing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerOn
     * @since 3.11.0
     *
     * @param {number} x - The horizontal coordinate to center on.
     * @param {number} y - The vertical coordinate to center on.
     *
     * @return {this} This Camera instance.
     */ centerOn: function(x, y) {
                    this.centerOnX(x);
                    this.centerOnY(y);
                    return this;
                },
                /**
     * Moves the Camera so that it is looking at the center of the Camera Bounds, if enabled.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToBounds: function() {
                    if (this.useBounds) {
                        var bounds = this._bounds;
                        var originX = this.width * 0.5;
                        var originY = this.height * 0.5;
                        this.midPoint.set(bounds.centerX, bounds.centerY);
                        this.scrollX = bounds.centerX - originX;
                        this.scrollY = bounds.centerY - originY;
                    }
                    return this;
                },
                /**
     * Moves the Camera so that it is re-centered based on its viewport size.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#centerToSize
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ centerToSize: function() {
                    this.scrollX = this.width * 0.5;
                    this.scrollY = this.height * 0.5;
                    return this;
                },
                /**
     * Takes an array of Game Objects and returns a new array featuring only those objects
     * visible by this camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#cull
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [renderableObjects,$return]
     *
     * @param {Phaser.GameObjects.GameObject[]} renderableObjects - An array of Game Objects to cull.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of Game Objects visible to this Camera.
     */ cull: function(renderableObjects) {
                    if (this.disableCull) return renderableObjects;
                    var cameraMatrix = this.matrix.matrix;
                    var mva = cameraMatrix[0];
                    var mvb = cameraMatrix[1];
                    var mvc = cameraMatrix[2];
                    var mvd = cameraMatrix[3];
                    /* First Invert Matrix */ var determinant = mva * mvd - mvb * mvc;
                    if (!determinant) return renderableObjects;
                    var mve = cameraMatrix[4];
                    var mvf = cameraMatrix[5];
                    var scrollX = this.scrollX;
                    var scrollY = this.scrollY;
                    var cameraW = this.width;
                    var cameraH = this.height;
                    var cullTop = this.y;
                    var cullBottom = cullTop + cameraH;
                    var cullLeft = this.x;
                    var cullRight = cullLeft + cameraW;
                    var culledObjects = this.culledObjects;
                    var length = renderableObjects.length;
                    determinant = 1 / determinant;
                    culledObjects.length = 0;
                    for(var index = 0; index < length; ++index){
                        var object = renderableObjects[index];
                        if (!object.hasOwnProperty('width') || object.parentContainer) {
                            culledObjects.push(object);
                            continue;
                        }
                        var objectW = object.width;
                        var objectH = object.height;
                        var objectX = object.x - scrollX * object.scrollFactorX - objectW * object.originX;
                        var objectY = object.y - scrollY * object.scrollFactorY - objectH * object.originY;
                        var tx = objectX * mva + objectY * mvc + mve;
                        var ty = objectX * mvb + objectY * mvd + mvf;
                        var tw = (objectX + objectW) * mva + (objectY + objectH) * mvc + mve;
                        var th = (objectX + objectW) * mvb + (objectY + objectH) * mvd + mvf;
                        if (tw > cullLeft && tx < cullRight && th > cullTop && ty < cullBottom) culledObjects.push(object);
                    }
                    return culledObjects;
                },
                /**
     * Converts the given `x` and `y` coordinates into World space, based on this Cameras transform.
     * You can optionally provide a Vector2, or similar object, to store the results in.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getWorldPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {number} x - The x position to convert to world space.
     * @param {number} y - The y position to convert to world space.
     * @param {(object|Phaser.Math.Vector2)} [output] - An optional object to store the results in. If not provided a new Vector2 will be created.
     *
     * @return {Phaser.Math.Vector2} An object holding the converted values in its `x` and `y` properties.
     */ getWorldPoint: function(x, y, output) {
                    if (output === undefined) output = new Vector2();
                    var cameraMatrix = this.matrix.matrix;
                    var mva = cameraMatrix[0];
                    var mvb = cameraMatrix[1];
                    var mvc = cameraMatrix[2];
                    var mvd = cameraMatrix[3];
                    var mve = cameraMatrix[4];
                    var mvf = cameraMatrix[5];
                    //  Invert Matrix
                    var determinant = mva * mvd - mvb * mvc;
                    if (!determinant) {
                        output.x = x;
                        output.y = y;
                        return output;
                    }
                    determinant = 1 / determinant;
                    var ima = mvd * determinant;
                    var imb = -mvb * determinant;
                    var imc = -mvc * determinant;
                    var imd = mva * determinant;
                    var ime = (mvc * mvf - mvd * mve) * determinant;
                    var imf = (mvb * mve - mva * mvf) * determinant;
                    var c = Math.cos(this.rotation);
                    var s = Math.sin(this.rotation);
                    var zoomX = this.zoomX;
                    var zoomY = this.zoomY;
                    var scrollX = this.scrollX;
                    var scrollY = this.scrollY;
                    var sx = x + (scrollX * c - scrollY * s) * zoomX;
                    var sy = y + (scrollX * s + scrollY * c) * zoomY;
                    //  Apply transform to point
                    output.x = sx * ima + sy * imc + ime;
                    output.y = sx * imb + sy * imd + imf;
                    return output;
                },
                /**
     * Given a Game Object, or an array of Game Objects, it will update all of their camera filter settings
     * so that they are ignored by this Camera. This means they will not be rendered by this Camera.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#ignore
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group)} entries - The Game Object, or array of Game Objects, to be ignored by this Camera.
     *
     * @return {this} This Camera instance.
     */ ignore: function(entries) {
                    var id = this.id;
                    if (!Array.isArray(entries)) entries = [
                        entries
                    ];
                    for(var i = 0; i < entries.length; i++){
                        var entry = entries[i];
                        if (Array.isArray(entry)) this.ignore(entry);
                        else if (entry.isParent) this.ignore(entry.getChildren());
                        else entry.cameraFilter |= id;
                    }
                    return this;
                },
                /**
     * Internal preRender step.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#preRender
     * @protected
     * @since 3.0.0
     */ preRender: function() {
                    this.renderList.length = 0;
                    var width = this.width;
                    var height = this.height;
                    var halfWidth = width * 0.5;
                    var halfHeight = height * 0.5;
                    var zoomX = this.zoomX;
                    var zoomY = this.zoomY;
                    var matrix = this.matrix;
                    var originX = width * this.originX;
                    var originY = height * this.originY;
                    var sx = this.scrollX;
                    var sy = this.scrollY;
                    if (this.useBounds) {
                        sx = this.clampX(sx);
                        sy = this.clampY(sy);
                    }
                    if (this.roundPixels) {
                        originX = Math.round(originX);
                        originY = Math.round(originY);
                    }
                    //  Values are in pixels and not impacted by zooming the Camera
                    this.scrollX = sx;
                    this.scrollY = sy;
                    var midX = sx + halfWidth;
                    var midY = sy + halfHeight;
                    //  The center of the camera, in world space, so taking zoom into account
                    //  Basically the pixel value of what it's looking at in the middle of the cam
                    this.midPoint.set(midX, midY);
                    var displayWidth = width / zoomX;
                    var displayHeight = height / zoomY;
                    this.worldView.setTo(midX - displayWidth / 2, midY - displayHeight / 2, displayWidth, displayHeight);
                    matrix.applyITRS(this.x + originX, this.y + originY, this.rotation, zoomX, zoomY);
                    matrix.translate(-originX, -originY);
                },
                /**
     * Takes an x value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampX
     * @since 3.11.0
     *
     * @param {number} x - The value to horizontally scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollX.
     */ clampX: function(x) {
                    var bounds = this._bounds;
                    var dw = this.displayWidth;
                    var bx = bounds.x + (dw - this.width) / 2;
                    var bw = Math.max(bx, bx + bounds.width - dw);
                    if (x < bx) x = bx;
                    else if (x > bw) x = bw;
                    return x;
                },
                /**
     * Takes a y value and checks it's within the range of the Camera bounds, adjusting if required.
     * Do not call this method if you are not using camera bounds.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clampY
     * @since 3.11.0
     *
     * @param {number} y - The value to vertically scroll clamp.
     *
     * @return {number} The adjusted value to use as scrollY.
     */ clampY: function(y) {
                    var bounds = this._bounds;
                    var dh = this.displayHeight;
                    var by = bounds.y + (dh - this.height) / 2;
                    var bh = Math.max(by, by + bounds.height - dh);
                    if (y < by) y = by;
                    else if (y > bh) y = bh;
                    return y;
                },
                /*
        var gap = this._zoomInversed;
        return gap * Math.round((src.x - this.scrollX * src.scrollFactorX) / gap);
    */ /**
     * If this Camera has previously had movement bounds set on it, this will remove them.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#removeBounds
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ removeBounds: function() {
                    this.useBounds = false;
                    this.dirty = true;
                    this._bounds.setEmpty();
                    return this;
                },
                /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setAngle
     * @since 3.0.0
     *
     * @param {number} [value=0] - The cameras angle of rotation, given in degrees.
     *
     * @return {this} This Camera instance.
     */ setAngle: function(value) {
                    if (value === undefined) value = 0;
                    this.rotation = DegToRad(value);
                    return this;
                },
                /**
     * Sets the background color for this Camera.
     *
     * By default a Camera has a transparent background but it can be given a solid color, with any level
     * of transparency, via this method.
     *
     * The color value can be specified using CSS color notation, hex or numbers.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBackgroundColor
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Types.Display.InputColorObject)} [color='rgba(0,0,0,0)'] - The color value. In CSS, hex or numeric color notation.
     *
     * @return {this} This Camera instance.
     */ setBackgroundColor: function(color) {
                    if (color === undefined) color = 'rgba(0,0,0,0)';
                    this.backgroundColor = ValueToColor(color);
                    this.transparent = this.backgroundColor.alpha === 0;
                    return this;
                },
                /**
     * Set the bounds of the Camera. The bounds are an axis-aligned rectangle.
     *
     * The Camera bounds controls where the Camera can scroll to, stopping it from scrolling off the
     * edges and into blank space. It does not limit the placement of Game Objects, or where
     * the Camera viewport can be positioned.
     *
     * Temporarily disable the bounds by changing the boolean `Camera.useBounds`.
     *
     * Clear the bounds entirely by calling `Camera.removeBounds`.
     *
     * If you set bounds that are smaller than the viewport it will stop the Camera from being
     * able to scroll. The bounds can be positioned where-ever you wish. By default they are from
     * 0x0 to the canvas width x height. This means that the coordinate 0x0 is the top left of
     * the Camera bounds. However, you can position them anywhere. So if you wanted a game world
     * that was 2048x2048 in size, with 0x0 being the center of it, you can set the bounds x/y
     * to be -1024, -1024, with a width and height of 2048. Depending on your game you may find
     * it easier for 0x0 to be the top-left of the bounds, or you may wish 0x0 to be the middle.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the bounds.
     * @param {number} y - The top-left y coordinate of the bounds.
     * @param {number} width - The width of the bounds, in pixels.
     * @param {number} height - The height of the bounds, in pixels.
     * @param {boolean} [centerOn=false] - If `true` the Camera will automatically be centered on the new bounds.
     *
     * @return {this} This Camera instance.
     */ setBounds: function(x, y, width, height, centerOn) {
                    if (centerOn === undefined) centerOn = false;
                    this._bounds.setTo(x, y, width, height);
                    this.dirty = true;
                    this.useBounds = true;
                    if (centerOn) this.centerToBounds();
                    else {
                        this.scrollX = this.clampX(this.scrollX);
                        this.scrollY = this.clampY(this.scrollY);
                    }
                    return this;
                },
                /**
     * Returns a rectangle containing the bounds of the Camera.
     *
     * If the Camera does not have any bounds the rectangle will be empty.
     *
     * The rectangle is a copy of the bounds, so is safe to modify.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#getBounds
     * @since 3.16.0
     *
     * @param {Phaser.Geom.Rectangle} [out] - An optional Rectangle to store the bounds in. If not given, a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A rectangle containing the bounds of this Camera.
     */ getBounds: function(out) {
                    if (out === undefined) out = new Rectangle();
                    var source = this._bounds;
                    out.setTo(source.x, source.y, source.width, source.height);
                    return out;
                },
                /**
     * Sets the name of this Camera.
     * This value is for your own use and isn't used internally.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setName
     * @since 3.0.0
     *
     * @param {string} [value=''] - The name of the Camera.
     *
     * @return {this} This Camera instance.
     */ setName: function(value) {
                    if (value === undefined) value = '';
                    this.name = value;
                    return this;
                },
                /**
     * Set the position of the Camera viewport within the game.
     *
     * This does not change where the camera is 'looking'. See `setScroll` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setPosition
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} [y=x] - The top-left y coordinate of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setPosition: function(x, y) {
                    if (y === undefined) y = x;
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
     *
     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRotation
     * @since 3.0.0
     *
     * @param {number} [value=0] - The rotation of the Camera, in radians.
     *
     * @return {this} This Camera instance.
     */ setRotation: function(value) {
                    if (value === undefined) value = 0;
                    this.rotation = value;
                    return this;
                },
                /**
     * Should the Camera round pixel values to whole integers when rendering Game Objects?
     *
     * In some types of game, especially with pixel art, this is required to prevent sub-pixel aliasing.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setRoundPixels
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to round Camera pixels, `false` to not.
     *
     * @return {this} This Camera instance.
     */ setRoundPixels: function(value) {
                    this.roundPixels = value;
                    return this;
                },
                /**
     * Sets the Scene the Camera is bound to.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScene
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene the camera is bound to.
     *
     * @return {this} This Camera instance.
     */ setScene: function(scene) {
                    if (this.scene && this._customViewport) this.sceneManager.customViewports--;
                    this.scene = scene;
                    var sys = scene.sys;
                    this.sceneManager = sys.game.scene;
                    this.scaleManager = sys.scale;
                    this.cameraManager = sys.cameras;
                    this.updateSystem();
                    return this;
                },
                /**
     * Set the position of where the Camera is looking within the game.
     * You can also modify the properties `Camera.scrollX` and `Camera.scrollY` directly.
     * Use this method, or the scroll properties, to move your camera around the game world.
     *
     * This does not change where the camera viewport is placed. See `setPosition` to control that.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setScroll
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the Camera in the game world.
     * @param {number} [y=x] - The y coordinate of the Camera in the game world.
     *
     * @return {this} This Camera instance.
     */ setScroll: function(x, y) {
                    if (y === undefined) y = x;
                    this.scrollX = x;
                    this.scrollY = y;
                    return this;
                },
                /**
     * Set the size of the Camera viewport.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * This method sets the position and size of the Camera viewport in a single call.
     *
     * If you're trying to change where the Camera is looking at in your game, then see
     * the method `Camera.setScroll` instead. This method is for changing the viewport
     * itself, not what the camera can see.
     *
     * By default a Camera is the same size as the game, but can be made smaller via this method,
     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
     * viewport within your game.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setViewport
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the Camera viewport.
     * @param {number} y - The top-left y coordinate of the Camera viewport.
     * @param {number} width - The width of the Camera viewport.
     * @param {number} [height=width] - The height of the Camera viewport.
     *
     * @return {this} This Camera instance.
     */ setViewport: function(x, y, width, height) {
                    this.x = x;
                    this.y = y;
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Set the zoom value of the Camera.
     *
     * Changing to a smaller value, such as 0.5, will cause the camera to 'zoom out'.
     * Changing to a larger value, such as 2, will cause the camera to 'zoom in'.
     *
     * A value of 1 means 'no zoom' and is the default.
     *
     * Changing the zoom does not impact the Camera viewport in any way, it is only applied during rendering.
     *
     * As of Phaser 3.50 you can now set the horizontal and vertical zoom values independently.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setZoom
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal zoom value of the Camera. The minimum it can be is 0.001.
     * @param {number} [y=x] - The vertical zoom value of the Camera. The minimum it can be is 0.001.
     *
     * @return {this} This Camera instance.
     */ setZoom: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    if (x === 0) x = 0.001;
                    if (y === 0) y = 0.001;
                    this.zoomX = x;
                    this.zoomY = y;
                    return this;
                },
                /**
     * Sets the mask to be applied to this Camera during rendering.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     *
     * Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Camera it will be immediately replaced.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setMask
     * @since 3.17.0
     *
     * @param {(Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask)} mask - The mask this Camera will use when rendering.
     * @param {boolean} [fixedPosition=true] - Should the mask translate along with the Camera, or be fixed in place and not impacted by the Cameras transform?
     *
     * @return {this} This Camera instance.
     */ setMask: function(mask, fixedPosition) {
                    if (fixedPosition === undefined) fixedPosition = true;
                    this.mask = mask;
                    this._maskCamera = fixedPosition ? this.cameraManager.default : this;
                    return this;
                },
                /**
     * Clears the mask that this Camera was using.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#clearMask
     * @since 3.17.0
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Camera instance.
     */ clearMask: function(destroyMask) {
                    if (destroyMask === undefined) destroyMask = false;
                    if (destroyMask && this.mask) this.mask.destroy();
                    this.mask = null;
                    return this;
                },
                /**
     * Sets the visibility of this Camera.
     *
     * An invisible Camera will skip rendering and input tests of everything it can see.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#setVisible
     * @since 3.10.0
     *
     * @param {boolean} value - The visible state of the Camera.
     *
     * @return {this} This Camera instance.
     */ /**
     * Returns an Object suitable for JSON storage containing all of the Camera viewport and rendering properties.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Cameras.Scene2D.JSONCamera} A well-formed object suitable for conversion to JSON.
     */ toJSON: function() {
                    var output = {
                        name: this.name,
                        x: this.x,
                        y: this.y,
                        width: this.width,
                        height: this.height,
                        zoom: this.zoom,
                        rotation: this.rotation,
                        roundPixels: this.roundPixels,
                        scrollX: this.scrollX,
                        scrollY: this.scrollY,
                        backgroundColor: this.backgroundColor.rgba
                    };
                    if (this.useBounds) output['bounds'] = {
                        x: this._bounds.x,
                        y: this._bounds.y,
                        width: this._bounds.width,
                        height: this._bounds.height
                    };
                    return output;
                },
                /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function() {
                //  NOOP
                },
                /**
     * Internal method called automatically when the viewport changes.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#updateSystem
     * @private
     * @since 3.12.0
     */ updateSystem: function() {
                    if (!this.scaleManager) return;
                    var custom = this._x !== 0 || this._y !== 0 || this.scaleManager.width !== this._width || this.scaleManager.height !== this._height;
                    var sceneManager = this.sceneManager;
                    if (custom && !this._customViewport) //  We need a custom viewport for this Camera
                    sceneManager.customViewports++;
                    else if (!custom && this._customViewport) //  We're turning off a custom viewport for this Camera
                    sceneManager.customViewports--;
                    this.dirty = true;
                    this._customViewport = custom;
                },
                /**
     * Destroys this Camera instance and its internal properties and references.
     * Once destroyed you cannot use this Camera again, even if re-added to a Camera Manager.
     *
     * This method is called automatically by `CameraManager.remove` if that methods `runDestroy` argument is `true`, which is the default.
     *
     * Unless you have a specific reason otherwise, always use `CameraManager.remove` and allow it to handle the camera destruction,
     * rather than calling this method directly.
     *
     * @method Phaser.Cameras.Scene2D.BaseCamera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    this.emit(Events.DESTROY, this);
                    this.removeAllListeners();
                    this.matrix.destroy();
                    this.culledObjects = [];
                    if (this._customViewport) //  We're turning off a custom viewport for this Camera
                    this.sceneManager.customViewports--;
                    this.renderList = [];
                    this._bounds = null;
                    this.scene = null;
                    this.scaleManager = null;
                    this.sceneManager = null;
                    this.cameraManager = null;
                },
                /**
     * The x position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollX` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.updateSystem();
                    }
                },
                /**
     * The y position of the Camera viewport, relative to the top-left of the game canvas.
     * The viewport is the area into which the camera renders.
     * To adjust the position the camera is looking at in the game world, see the `scrollY` value.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.updateSystem();
                    }
                },
                /**
     * The width of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#width
     * @type {number}
     * @since 3.0.0
     */ width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(value) {
                        this._width = value;
                        this.updateSystem();
                    }
                },
                /**
     * The height of the Camera viewport, in pixels.
     *
     * The viewport is the area into which the Camera renders. Setting the viewport does
     * not restrict where the Camera can scroll to.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#height
     * @type {number}
     * @since 3.0.0
     */ height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(value) {
                        this._height = value;
                        this.updateSystem();
                    }
                },
                /**
     * The horizontal scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollX: {
                    get: function() {
                        return this._scrollX;
                    },
                    set: function(value) {
                        this._scrollX = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scroll position of this Camera.
     *
     * Change this value to cause the Camera to scroll around your Scene.
     *
     * Alternatively, setting the Camera to follow a Game Object, via the `startFollow` method,
     * will automatically adjust the Camera scroll values accordingly.
     *
     * You can set the bounds within which the Camera can scroll via the `setBounds` method.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#scrollY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ scrollY: {
                    get: function() {
                        return this._scrollY;
                    },
                    set: function(value) {
                        this._scrollY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoom
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ zoom: {
                    get: function() {
                        return (this._zoomX + this._zoomY) / 2;
                    },
                    set: function(value) {
                        this._zoomX = value;
                        this._zoomY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera horizontal zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomX
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomX: {
                    get: function() {
                        return this._zoomX;
                    },
                    set: function(value) {
                        this._zoomX = value;
                        this.dirty = true;
                    }
                },
                /**
     * The Camera vertical zoom value. Change this value to zoom in, or out of, a Scene.
     *
     * A value of 0.5 would zoom the Camera out, so you can now see twice as much
     * of the Scene as before. A value of 2 would zoom the Camera in, so every pixel
     * now takes up 2 pixels when rendered.
     *
     * Set to 1 to return to the default zoom level.
     *
     * Be careful to never set this value to zero.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#zoomY
     * @type {number}
     * @default 1
     * @since 3.50.0
     */ zoomY: {
                    get: function() {
                        return this._zoomY;
                    },
                    set: function(value) {
                        this._zoomY = value;
                        this.dirty = true;
                    }
                },
                /**
     * The rotation of the Camera in radians.
     *
     * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
     * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
     *
     * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
     * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.11.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        this._rotation = value;
                        this.dirty = true;
                    }
                },
                /**
     * The horizontal position of the center of the Camera's viewport, relative to the left of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerX
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerX: {
                    get: function() {
                        return this.x + 0.5 * this.width;
                    }
                },
                /**
     * The vertical position of the center of the Camera's viewport, relative to the top of the game canvas.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#centerY
     * @type {number}
     * @readonly
     * @since 3.10.0
     */ centerY: {
                    get: function() {
                        return this.y + 0.5 * this.height;
                    }
                },
                /**
     * The displayed width of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport width of 800 and a zoom of 0.5 then its display width
     * would be 1600, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a width of 800 and zoom of 2 would have a display width
     * of 400 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayWidth
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayWidth: {
                    get: function() {
                        return this.width / this.zoomX;
                    }
                },
                /**
     * The displayed height of the camera viewport, factoring in the camera zoom level.
     *
     * If a camera has a viewport height of 600 and a zoom of 0.5 then its display height
     * would be 1200, as it's displaying twice as many pixels as zoom level 1.
     *
     * Equally, a camera with a height of 600 and zoom of 2 would have a display height
     * of 300 pixels.
     *
     * @name Phaser.Cameras.Scene2D.BaseCamera#displayHeight
     * @type {number}
     * @readonly
     * @since 3.11.0
     */ displayHeight: {
                    get: function() {
                        return this.height / this.zoomY;
                    }
                }
            });
            module1.exports = BaseCamera;
        /***/ },
        /* 132 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Back = __webpack_require__(328);
            var Bounce = __webpack_require__(329);
            var Circular = __webpack_require__(330);
            var Cubic = __webpack_require__(331);
            var Elastic = __webpack_require__(332);
            var Expo = __webpack_require__(333);
            var Linear = __webpack_require__(334);
            var Quadratic = __webpack_require__(335);
            var Quartic = __webpack_require__(336);
            var Quintic = __webpack_require__(337);
            var Sine = __webpack_require__(338);
            var Stepped = __webpack_require__(339);
            //  EaseMap
            module1.exports = {
                Power0: Linear,
                Power1: Quadratic.Out,
                Power2: Cubic.Out,
                Power3: Quartic.Out,
                Power4: Quintic.Out,
                Linear: Linear,
                Quad: Quadratic.Out,
                Cubic: Cubic.Out,
                Quart: Quartic.Out,
                Quint: Quintic.Out,
                Sine: Sine.Out,
                Expo: Expo.Out,
                Circ: Circular.Out,
                Elastic: Elastic.Out,
                Back: Back.Out,
                Bounce: Bounce.Out,
                Stepped: Stepped,
                'Quad.easeIn': Quadratic.In,
                'Cubic.easeIn': Cubic.In,
                'Quart.easeIn': Quartic.In,
                'Quint.easeIn': Quintic.In,
                'Sine.easeIn': Sine.In,
                'Expo.easeIn': Expo.In,
                'Circ.easeIn': Circular.In,
                'Elastic.easeIn': Elastic.In,
                'Back.easeIn': Back.In,
                'Bounce.easeIn': Bounce.In,
                'Quad.easeOut': Quadratic.Out,
                'Cubic.easeOut': Cubic.Out,
                'Quart.easeOut': Quartic.Out,
                'Quint.easeOut': Quintic.Out,
                'Sine.easeOut': Sine.Out,
                'Expo.easeOut': Expo.Out,
                'Circ.easeOut': Circular.Out,
                'Elastic.easeOut': Elastic.Out,
                'Back.easeOut': Back.Out,
                'Bounce.easeOut': Bounce.Out,
                'Quad.easeInOut': Quadratic.InOut,
                'Cubic.easeInOut': Cubic.InOut,
                'Quart.easeInOut': Quartic.InOut,
                'Quint.easeInOut': Quintic.InOut,
                'Sine.easeInOut': Sine.InOut,
                'Expo.easeInOut': Expo.InOut,
                'Circ.easeInOut': Circular.InOut,
                'Elastic.easeInOut': Elastic.InOut,
                'Back.easeInOut': Back.InOut,
                'Bounce.easeInOut': Bounce.InOut
            };
        /***/ },
        /* 133 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a linear (interpolation) value over t.
 *
 * @function Phaser.Math.Linear
 * @since 3.0.0
 *
 * @param {number} p0 - The first point.
 * @param {number} p1 - The second point.
 * @param {number} t - The percentage between p0 and p1 to return, represented as a number between 0 and 1.
 *
 * @return {number} The step t% of the way between p0 and p1.
 */ var Linear = function(p0, p1, t) {
                return (p1 - p0) * t + p0;
            };
            module1.exports = Linear;
        /***/ },
        /* 134 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(102);
            /**
 * Determines the browser type and version running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.browser` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.Browser
 * @since 3.0.0
 * 
 * @property {boolean} chrome - Set to true if running in Chrome.
 * @property {boolean} edge - Set to true if running in Microsoft Edge browser.
 * @property {boolean} firefox - Set to true if running in Firefox.
 * @property {boolean} ie - Set to true if running in Internet Explorer 11 or less (not Edge).
 * @property {boolean} mobileSafari - Set to true if running in Mobile Safari.
 * @property {boolean} opera - Set to true if running in Opera.
 * @property {boolean} safari - Set to true if running in Safari.
 * @property {boolean} silk - Set to true if running in the Silk browser (as used on the Amazon Kindle)
 * @property {boolean} trident - Set to true if running a Trident version of Internet Explorer (IE11+)
 * @property {number} chromeVersion - If running in Chrome this will contain the major version number.
 * @property {number} firefoxVersion - If running in Firefox this will contain the major version number.
 * @property {number} ieVersion - If running in Internet Explorer this will contain the major version number. Beyond IE10 you should use Browser.trident and Browser.tridentVersion.
 * @property {number} safariVersion - If running in Safari this will contain the major version number.
 * @property {number} tridentVersion - If running in Internet Explorer 11 this will contain the major version number. See {@link http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx}
 */ var Browser = {
                chrome: false,
                chromeVersion: 0,
                edge: false,
                firefox: false,
                firefoxVersion: 0,
                ie: false,
                ieVersion: 0,
                mobileSafari: false,
                opera: false,
                safari: false,
                safariVersion: 0,
                silk: false,
                trident: false,
                tridentVersion: 0
            };
            function init() {
                var ua = navigator.userAgent;
                if (/Edge\/\d+/.test(ua)) Browser.edge = true;
                else if (/Chrome\/(\d+)/.test(ua) && !OS.windowsPhone) {
                    Browser.chrome = true;
                    Browser.chromeVersion = parseInt(RegExp.$1, 10);
                } else if (/Firefox\D+(\d+)/.test(ua)) {
                    Browser.firefox = true;
                    Browser.firefoxVersion = parseInt(RegExp.$1, 10);
                } else if (/AppleWebKit/.test(ua) && OS.iOS) Browser.mobileSafari = true;
                else if (/MSIE (\d+\.\d+);/.test(ua)) {
                    Browser.ie = true;
                    Browser.ieVersion = parseInt(RegExp.$1, 10);
                } else if (/Opera/.test(ua)) Browser.opera = true;
                else if (/Safari/.test(ua) && !OS.windowsPhone) Browser.safari = true;
                else if (/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(ua)) {
                    Browser.ie = true;
                    Browser.trident = true;
                    Browser.tridentVersion = parseInt(RegExp.$1, 10);
                    Browser.ieVersion = parseInt(RegExp.$3, 10);
                }
                //  Silk gets its own if clause because its ua also contains 'Safari'
                if (/Silk/.test(ua)) Browser.silk = true;
                return Browser;
            }
            module1.exports = init();
        /***/ },
        /* 135 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a random floating point number between the two given bounds, minimum inclusive, maximum exclusive.
 *
 * @function Phaser.Math.FloatBetween
 * @since 3.0.0
 *
 * @param {number} min - The lower bound for the float, inclusive.
 * @param {number} max - The upper bound for the float exclusive.
 *
 * @return {number} A random float within the given range.
 */ var FloatBetween = function(min, max) {
                return Math.random() * (max - min) + min;
            };
            module1.exports = FloatBetween;
        /***/ },
        /* 136 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the given `width` and `height` are a power of two.
 * Useful for checking texture dimensions.
 *
 * @function Phaser.Math.Pow2.IsSize
 * @since 3.0.0
 *
 * @param {number} width - The width.
 * @param {number} height - The height.
 *
 * @return {boolean} `true` if `width` and `height` are a power of two, otherwise `false`.
 */ var IsSizePowerOfTwo = function(width, height) {
                return width > 0 && (width & width - 1) === 0 && height > 0 && (height & height - 1) === 0;
            };
            module1.exports = IsSizePowerOfTwo;
        /***/ },
        /* 137 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using ceil.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `15`.
 * As will `14` snap to `15`... but `16` will snap to `20`.
 *
 * @function Phaser.Math.Snap.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapCeil = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.ceil(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapCeil;
        /***/ },
        /* 138 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A representation of a vector in 4D space.
 *
 * A four-component vector.
 *
 * @class Vector4
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 * @param {number} [w] - The w component.
 */ var Vector4 = new Class({
                initialize: function Vector4(x, y, z, w) {
                    /**
         * The x component of this Vector.
         *
         * @name Phaser.Math.Vector4#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y component of this Vector.
         *
         * @name Phaser.Math.Vector4#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The z component of this Vector.
         *
         * @name Phaser.Math.Vector4#z
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.z = 0;
                    /**
         * The w component of this Vector.
         *
         * @name Phaser.Math.Vector4#w
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.w = 0;
                    if (typeof x === 'object') {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                        this.w = x.w || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                        this.w = w || 0;
                    }
                },
                /**
     * Make a clone of this Vector4.
     *
     * @method Phaser.Math.Vector4#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} A clone of this Vector4.
     */ clone: function() {
                    return new Vector4(this.x, this.y, this.z, this.w);
                },
                /**
     * Copy the components of a given Vector into this Vector.
     *
     * @method Phaser.Math.Vector4#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} src - The Vector to copy the components from.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ copy: function(src) {
                    this.x = src.x;
                    this.y = src.y;
                    this.z = src.z || 0;
                    this.w = src.w || 0;
                    return this;
                },
                /**
     * Check whether this Vector is equal to a given Vector.
     *
     * Performs a strict quality check against each Vector's components.
     *
     * @method Phaser.Math.Vector4#equals
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The vector to check equality with.
     *
     * @return {boolean} A boolean indicating whether the two Vectors are equal or not.
     */ equals: function(v) {
                    return this.x === v.x && this.y === v.y && this.z === v.z && this.w === v.w;
                },
                /**
     * Set the `x`, `y`, `z` and `w` components of the this Vector to the given `x`, `y`, `z` and `w` values.
     *
     * @method Phaser.Math.Vector4#set
     * @since 3.0.0
     *
     * @param {(number|object)} x - The x value to set for this Vector, or an object containing x, y, z and w components.
     * @param {number} y - The y value to set for this Vector.
     * @param {number} z - The z value to set for this Vector.
     * @param {number} w - The z value to set for this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ set: function(x, y, z, w) {
                    if (typeof x === 'object') {
                        this.x = x.x || 0;
                        this.y = x.y || 0;
                        this.z = x.z || 0;
                        this.w = x.w || 0;
                    } else {
                        this.x = x || 0;
                        this.y = y || 0;
                        this.z = z || 0;
                        this.w = w || 0;
                    }
                    return this;
                },
                /**
     * Add a given Vector to this Vector. Addition is component-wise.
     *
     * @method Phaser.Math.Vector4#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to add to this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ add: function(v) {
                    this.x += v.x;
                    this.y += v.y;
                    this.z += v.z || 0;
                    this.w += v.w || 0;
                    return this;
                },
                /**
     * Subtract the given Vector from this Vector. Subtraction is component-wise.
     *
     * @method Phaser.Math.Vector4#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to subtract from this Vector.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ subtract: function(v) {
                    this.x -= v.x;
                    this.y -= v.y;
                    this.z -= v.z || 0;
                    this.w -= v.w || 0;
                    return this;
                },
                /**
     * Scale this Vector by the given value.
     *
     * @method Phaser.Math.Vector4#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ scale: function(scale) {
                    this.x *= scale;
                    this.y *= scale;
                    this.z *= scale;
                    this.w *= scale;
                    return this;
                },
                /**
     * Calculate the length (or magnitude) of this Vector.
     *
     * @method Phaser.Math.Vector4#length
     * @since 3.0.0
     *
     * @return {number} The length of this Vector.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return Math.sqrt(x * x + y * y + z * z + w * w);
                },
                /**
     * Calculate the length of this Vector squared.
     *
     * @method Phaser.Math.Vector4#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Vector, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return x * x + y * y + z * z + w * w;
                },
                /**
     * Normalize this Vector.
     *
     * Makes the vector a unit length vector (magnitude of 1) in the same direction.
     *
     * @method Phaser.Math.Vector4#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var len = x * x + y * y + z * z + w * w;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this.x = x * len;
                        this.y = y * len;
                        this.z = z * len;
                        this.w = w * len;
                    }
                    return this;
                },
                /**
     * Calculate the dot product of this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#dot
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to dot product with this Vector4.
     *
     * @return {number} The dot product of this Vector and the given Vector.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                },
                /**
     * Linearly interpolate between this Vector and the given Vector.
     *
     * Interpolates this Vector towards the given Vector.
     *
     * @method Phaser.Math.Vector4#lerp
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector4} v - The Vector4 to interpolate towards.
     * @param {number} [t=0] - The interpolation percentage, between 0 and 1.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    this.x = ax + t * (v.x - ax);
                    this.y = ay + t * (v.y - ay);
                    this.z = az + t * (v.z - az);
                    this.w = aw + t * (v.w - aw);
                    return this;
                },
                /**
     * Perform a component-wise multiplication between this Vector and the given Vector.
     *
     * Multiplies this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to multiply this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ multiply: function(v) {
                    this.x *= v.x;
                    this.y *= v.y;
                    this.z *= v.z || 1;
                    this.w *= v.w || 1;
                    return this;
                },
                /**
     * Perform a component-wise division between this Vector and the given Vector.
     *
     * Divides this Vector by the given Vector.
     *
     * @method Phaser.Math.Vector4#divide
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to divide this Vector by.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ divide: function(v) {
                    this.x /= v.x;
                    this.y /= v.y;
                    this.z /= v.z || 1;
                    this.w /= v.w || 1;
                    return this;
                },
                /**
     * Calculate the distance between this Vector and the given Vector.
     *
     * @method Phaser.Math.Vector4#distance
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector.
     */ distance: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    var dw = v.w - this.w || 0;
                    return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
                },
                /**
     * Calculate the distance between this Vector and the given Vector, squared.
     *
     * @method Phaser.Math.Vector4#distanceSq
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to calculate the distance to.
     *
     * @return {number} The distance from this Vector to the given Vector, squared.
     */ distanceSq: function(v) {
                    var dx = v.x - this.x;
                    var dy = v.y - this.y;
                    var dz = v.z - this.z || 0;
                    var dw = v.w - this.w || 0;
                    return dx * dx + dy * dy + dz * dz + dw * dw;
                },
                /**
     * Negate the `x`, `y`, `z` and `w` components of this Vector.
     *
     * @method Phaser.Math.Vector4#negate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ negate: function() {
                    this.x = -this.x;
                    this.y = -this.y;
                    this.z = -this.z;
                    this.w = -this.w;
                    return this;
                },
                /**
     * Transform this Vector with the given Matrix.
     *
     * @method Phaser.Math.Vector4#transformMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} mat - The Matrix4 to transform this Vector4 with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformMat4: function(mat) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var m = mat.val;
                    this.x = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
                    this.y = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
                    this.z = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
                    this.w = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
                    return this;
                },
                /**
     * Transform this Vector with the given Quaternion.
     *
     * @method Phaser.Math.Vector4#transformQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to transform this Vector with.
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ transformQuat: function(q) {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var qx = q.x;
                    var qy = q.y;
                    var qz = q.z;
                    var qw = q.w;
                    // calculate quat * vec
                    var ix = qw * x + qy * z - qz * y;
                    var iy = qw * y + qz * x - qx * z;
                    var iz = qw * z + qx * y - qy * x;
                    var iw = -qx * x - qy * y - qz * z;
                    // calculate result * inverse quat
                    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
                    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
                    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
                    return this;
                },
                /**
     * Make this Vector the zero vector (0, 0, 0, 0).
     *
     * @method Phaser.Math.Vector4#reset
     * @since 3.0.0
     *
     * @return {Phaser.Math.Vector4} This Vector4.
     */ reset: function() {
                    this.x = 0;
                    this.y = 0;
                    this.z = 0;
                    this.w = 0;
                    return this;
                }
            });
            Vector4.prototype.sub = Vector4.prototype.subtract;
            Vector4.prototype.mul = Vector4.prototype.multiply;
            Vector4.prototype.div = Vector4.prototype.divide;
            Vector4.prototype.dist = Vector4.prototype.distance;
            Vector4.prototype.distSq = Vector4.prototype.distanceSq;
            Vector4.prototype.len = Vector4.prototype.length;
            Vector4.prototype.lenSq = Vector4.prototype.lengthSq;
            module1.exports = Vector4;
        /***/ },
        /* 139 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(88);
            /**
 * @classdesc
 * A Render Target encapsulates a WebGL framebuffer and the WebGL Texture that displays it.
 *
 * Instances of this class are typically created by, and belong to WebGL Pipelines, however
 * other Game Objects and classes can take advantage of Render Targets as well.
 *
 * @class RenderTarget
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGLRenderer.
 * @param {number} width - The width of this Render Target.
 * @param {number} height - The height of this Render Target.
 * @param {number} [scale=1] - A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
 * @param {number} [minFilter=0] - The minFilter mode of the texture when created. 0 is `LINEAR`, 1 is `NEAREST`.
 * @param {boolean} [autoClear=true] - Automatically clear this framebuffer when bound?
 * @param {boolean} [autoResize=false] - Automatically resize this Render Target if the WebGL Renderer resizes?
 */ var RenderTarget = new Class({
                initialize: function RenderTarget(renderer, width, height, scale, minFilter, autoClear, autoResize) {
                    if (scale === undefined) scale = 1;
                    if (minFilter === undefined) minFilter = 0;
                    if (autoClear === undefined) autoClear = true;
                    if (autoResize === undefined) autoResize = false;
                    /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                    /**
         * The WebGLFramebuffer of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#framebuffer
         * @type {WebGLFramebuffer}
         * @since 3.50.0
         */ this.framebuffer = null;
                    /**
         * The WebGLTexture of this Render Target.
         *
         * This is created in the `RenderTarget.resize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#texture
         * @type {WebGLTexture}
         * @since 3.50.0
         */ this.texture = null;
                    /**
         * The width of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#width
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.width = 0;
                    /**
         * The height of the texture.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#height
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.height = 0;
                    /**
         * A value between 0 and 1. Controls the size of this Render Target in relation to the Renderer.
         *
         * A value of 1 matches it. 0.5 makes the Render Target half the size of the renderer, etc.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#scale
         * @type {number}
         * @since 3.50.0
         */ this.scale = scale;
                    /**
         * The minFilter mode of the texture. 0 is `LINEAR`, 1 is `NEAREST`.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#minFilter
         * @type {number}
         * @since 3.50.0
         */ this.minFilter = minFilter;
                    /**
         * Controls if this Render Target is automatically cleared (via `gl.COLOR_BUFFER_BIT`)
         * during the `RenderTarget.bind` method.
         *
         * If you need more control over how, or if, the target is cleared, you can disable
         * this via the config on creation, or even toggle it directly at runtime.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoClear
         * @type {boolean}
         * @since 3.50.0
         */ this.autoClear = autoClear;
                    /**
         * Does this Render Target automatically resize when the WebGL Renderer does?
         *
         * Modify this property via the `setAutoResize` method.
         *
         * @name Phaser.Renderer.WebGL.RenderTarget#autoResize
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.autoResize = false;
                    this.resize(width, height);
                    if (autoResize) this.setAutoResize(true);
                },
                /**
     * Sets if this Render Target should automatically resize when the WebGL Renderer
     * emits a resize event.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#setAutoResize
     * @since 3.50.0
     *
     * @param {boolean} autoResize - Automatically resize this Render Target when the WebGL Renderer resizes?
     *
     * @return {this} This RenderTarget instance.
     */ setAutoResize: function(autoResize) {
                    if (autoResize && !this.autoResize) {
                        this.renderer.on(Events.RESIZE, this.resize, this);
                        this.autoResize = true;
                    } else if (!autoResize && this.autoResize) {
                        this.renderer.off(Events.RESIZE, this.resize, this);
                        this.autoResize = false;
                    }
                    return this;
                },
                /**
     * Resizes this Render Target.
     *
     * Deletes both the frame buffer and texture, if they exist and then re-creates
     * them using the new sizes.
     *
     * This method is called automatically by the pipeline during its resize handler.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#resize
     * @since 3.50.0
     *
     * @param {number} width - The new width of this Render Target.
     * @param {number} height - The new height of this Render Target.
     *
     * @return {this} This RenderTarget instance.
     */ resize: function(width, height) {
                    var scaledWidth = width * this.scale;
                    var scaledHeight = height * this.scale;
                    if (scaledWidth !== this.width || scaledHeight !== this.height) {
                        var renderer = this.renderer;
                        renderer.deleteFramebuffer(this.framebuffer);
                        renderer.deleteTexture(this.texture);
                        width *= this.scale;
                        height *= this.scale;
                        this.texture = renderer.createTextureFromSource(null, width, height, this.minFilter);
                        this.framebuffer = renderer.createFramebuffer(width, height, this.texture, false);
                        this.width = width;
                        this.height = height;
                    }
                    return this;
                },
                /**
     * Pushes this Render Target as the current frame buffer of the renderer.
     *
     * If `autoClear` is set, then clears the texture.
     *
     * If `adjustViewport` is `true` then it will flush the renderer and then adjust the GL viewport.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#bind
     * @since 3.50.0
     *
     * @param {boolean} [adjustViewport=false] - Adjust the GL viewport by calling `RenderTarget.adjustViewport` ?
     * @param {number} [width] - Optional new width of this Render Target.
     * @param {number} [height] - Optional new height of this Render Target.
     */ bind: function(adjustViewport, width, height) {
                    if (adjustViewport === undefined) adjustViewport = false;
                    if (adjustViewport) this.renderer.flush();
                    if (width && height) this.resize(width, height);
                    this.renderer.pushFramebuffer(this.framebuffer, false, false, false);
                    if (adjustViewport) this.adjustViewport();
                    if (this.autoClear) {
                        var gl = this.renderer.gl;
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                },
                /**
     * Adjusts the GL viewport to match the width and height of this Render Target.
     *
     * Also disables `SCISSOR_TEST`.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#adjustViewport
     * @since 3.50.0
     */ adjustViewport: function() {
                    var gl = this.renderer.gl;
                    gl.viewport(0, 0, this.width, this.height);
                    gl.disable(gl.SCISSOR_TEST);
                },
                /**
     * Clears this Render Target.
     *
     * @method Phaser.Renderer.WebGL.RenderTarget#clear
     * @since 3.50.0
     */ clear: function() {
                    var renderer = this.renderer;
                    var gl = renderer.gl;
                    renderer.pushFramebuffer(this.framebuffer);
                    gl.disable(gl.SCISSOR_TEST);
                    gl.clearColor(0, 0, 0, 0);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    renderer.popFramebuffer();
                    renderer.resetScissor();
                },
                /**
     * Unbinds this Render Target and optionally flushes the WebGL Renderer first.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#unbind
     * @since 3.50.0
     *
     * @param {boolean} [flush=false] - Flush the WebGL Renderer before unbinding?
     *
     * @return {WebGLFramebuffer} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ unbind: function(flush) {
                    if (flush === undefined) flush = false;
                    var renderer = this.renderer;
                    if (flush) renderer.flush();
                    return renderer.popFramebuffer();
                },
                /**
     * Removes all external references from this class and deletes the
     * WebGL framebuffer and texture instances.
     *
     * Does not remove this Render Target from the parent pipeline.
     *
     * @name Phaser.Renderer.WebGL.RenderTarget#destroy
     * @since 3.50.0
     */ destroy: function() {
                    var renderer = this.renderer;
                    renderer.deleteFramebuffer(this.framebuffer);
                    renderer.deleteTexture(this.texture);
                    renderer.off(Events.RESIZE, this.resize, this);
                    this.renderer = null;
                    this.framebuffer = null;
                    this.texture = null;
                }
            });
            module1.exports = RenderTarget;
        /***/ },
        /* 140 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given element to the DOM. If a parent is provided the element is added as a child of the parent, providing it was able to access it.
 * If no parent was given it falls back to using `document.body`.
 *
 * @function Phaser.DOM.AddToDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The element to be added to the DOM. Usually a Canvas object.
 * @param {(string|HTMLElement)} [parent] - The parent in which to add the element. Can be a string which is passed to `getElementById` or an actual DOM object.
 *
 * @return {HTMLElement} The element that was added to the DOM.
 */ var AddToDOM = function(element, parent) {
                var target;
                if (parent) {
                    if (typeof parent === 'string') //  Hopefully an element ID
                    target = document.getElementById(parent);
                    else if (typeof parent === 'object' && parent.nodeType === 1) //  Quick test for a HTMLElement
                    target = parent;
                } else if (element.parentElement || parent === null) return element;
                //  Fallback, covers an invalid ID and a non HTMLElement object
                if (!target) target = document.body;
                target.appendChild(element);
                return element;
            };
            module1.exports = AddToDOM;
        /***/ },
        /* 141 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Keyboard Codes.
 *
 * @namespace Phaser.Input.Keyboard.KeyCodes
 * @memberof Phaser.Input.Keyboard
 * @since 3.0.0
 */ var KeyCodes = {
                /**
     * The BACKSPACE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACKSPACE
     * @type {number}
     * @since 3.0.0
     */ BACKSPACE: 8,
                /**
     * The TAB key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.TAB
     * @type {number}
     * @since 3.0.0
     */ TAB: 9,
                /**
     * The ENTER key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ENTER
     * @type {number}
     * @since 3.0.0
     */ ENTER: 13,
                /**
     * The SHIFT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SHIFT
     * @type {number}
     * @since 3.0.0
     */ SHIFT: 16,
                /**
     * The CTRL key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CTRL
     * @type {number}
     * @since 3.0.0
     */ CTRL: 17,
                /**
     * The ALT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ALT
     * @type {number}
     * @since 3.0.0
     */ ALT: 18,
                /**
     * The PAUSE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAUSE
     * @type {number}
     * @since 3.0.0
     */ PAUSE: 19,
                /**
     * The CAPS_LOCK key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CAPS_LOCK
     * @type {number}
     * @since 3.0.0
     */ CAPS_LOCK: 20,
                /**
     * The ESC key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ESC
     * @type {number}
     * @since 3.0.0
     */ ESC: 27,
                /**
     * The SPACE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SPACE
     * @type {number}
     * @since 3.0.0
     */ SPACE: 32,
                /**
     * The PAGE_UP key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_UP
     * @type {number}
     * @since 3.0.0
     */ PAGE_UP: 33,
                /**
     * The PAGE_DOWN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_DOWN
     * @type {number}
     * @since 3.0.0
     */ PAGE_DOWN: 34,
                /**
     * The END key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.END
     * @type {number}
     * @since 3.0.0
     */ END: 35,
                /**
     * The HOME key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.HOME
     * @type {number}
     * @since 3.0.0
     */ HOME: 36,
                /**
     * The LEFT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.LEFT
     * @type {number}
     * @since 3.0.0
     */ LEFT: 37,
                /**
     * The UP key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.UP
     * @type {number}
     * @since 3.0.0
     */ UP: 38,
                /**
     * The RIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.RIGHT
     * @type {number}
     * @since 3.0.0
     */ RIGHT: 39,
                /**
     * The DOWN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.DOWN
     * @type {number}
     * @since 3.0.0
     */ DOWN: 40,
                /**
     * The PRINT_SCREEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PRINT_SCREEN
     * @type {number}
     * @since 3.0.0
     */ PRINT_SCREEN: 42,
                /**
     * The INSERT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.INSERT
     * @type {number}
     * @since 3.0.0
     */ INSERT: 45,
                /**
     * The DELETE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.DELETE
     * @type {number}
     * @since 3.0.0
     */ DELETE: 46,
                /**
     * The ZERO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ZERO
     * @type {number}
     * @since 3.0.0
     */ ZERO: 48,
                /**
     * The ONE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.ONE
     * @type {number}
     * @since 3.0.0
     */ ONE: 49,
                /**
     * The TWO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.TWO
     * @type {number}
     * @since 3.0.0
     */ TWO: 50,
                /**
     * The THREE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.THREE
     * @type {number}
     * @since 3.0.0
     */ THREE: 51,
                /**
     * The FOUR key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FOUR
     * @type {number}
     * @since 3.0.0
     */ FOUR: 52,
                /**
     * The FIVE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FIVE
     * @type {number}
     * @since 3.0.0
     */ FIVE: 53,
                /**
     * The SIX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SIX
     * @type {number}
     * @since 3.0.0
     */ SIX: 54,
                /**
     * The SEVEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEVEN
     * @type {number}
     * @since 3.0.0
     */ SEVEN: 55,
                /**
     * The EIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.EIGHT
     * @type {number}
     * @since 3.0.0
     */ EIGHT: 56,
                /**
     * The NINE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NINE
     * @type {number}
     * @since 3.0.0
     */ NINE: 57,
                /**
     * The NUMPAD_ZERO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ZERO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ZERO: 96,
                /**
     * The NUMPAD_ONE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ONE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_ONE: 97,
                /**
     * The NUMPAD_TWO key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_TWO
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_TWO: 98,
                /**
     * The NUMPAD_THREE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_THREE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_THREE: 99,
                /**
     * The NUMPAD_FOUR key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FOUR
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FOUR: 100,
                /**
     * The NUMPAD_FIVE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FIVE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_FIVE: 101,
                /**
     * The NUMPAD_SIX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SIX
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SIX: 102,
                /**
     * The NUMPAD_SEVEN key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SEVEN
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_SEVEN: 103,
                /**
     * The NUMPAD_EIGHT key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_EIGHT
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_EIGHT: 104,
                /**
     * The NUMPAD_NINE key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_NINE
     * @type {number}
     * @since 3.0.0
     */ NUMPAD_NINE: 105,
                /**
     * The Numpad Addition (+) key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ADD
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_ADD: 107,
                /**
     * The Numpad Subtraction (-) key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SUBTRACT
     * @type {number}
     * @since 3.21.0
     */ NUMPAD_SUBTRACT: 109,
                /**
     * The A key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.A
     * @type {number}
     * @since 3.0.0
     */ A: 65,
                /**
     * The B key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.B
     * @type {number}
     * @since 3.0.0
     */ B: 66,
                /**
     * The C key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.C
     * @type {number}
     * @since 3.0.0
     */ C: 67,
                /**
     * The D key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.D
     * @type {number}
     * @since 3.0.0
     */ D: 68,
                /**
     * The E key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.E
     * @type {number}
     * @since 3.0.0
     */ E: 69,
                /**
     * The F key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F
     * @type {number}
     * @since 3.0.0
     */ F: 70,
                /**
     * The G key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.G
     * @type {number}
     * @since 3.0.0
     */ G: 71,
                /**
     * The H key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.H
     * @type {number}
     * @since 3.0.0
     */ H: 72,
                /**
     * The I key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.I
     * @type {number}
     * @since 3.0.0
     */ I: 73,
                /**
     * The J key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.J
     * @type {number}
     * @since 3.0.0
     */ J: 74,
                /**
     * The K key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.K
     * @type {number}
     * @since 3.0.0
     */ K: 75,
                /**
     * The L key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.L
     * @type {number}
     * @since 3.0.0
     */ L: 76,
                /**
     * The M key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.M
     * @type {number}
     * @since 3.0.0
     */ M: 77,
                /**
     * The N key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.N
     * @type {number}
     * @since 3.0.0
     */ N: 78,
                /**
     * The O key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.O
     * @type {number}
     * @since 3.0.0
     */ O: 79,
                /**
     * The P key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.P
     * @type {number}
     * @since 3.0.0
     */ P: 80,
                /**
     * The Q key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Q
     * @type {number}
     * @since 3.0.0
     */ Q: 81,
                /**
     * The R key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.R
     * @type {number}
     * @since 3.0.0
     */ R: 82,
                /**
     * The S key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.S
     * @type {number}
     * @since 3.0.0
     */ S: 83,
                /**
     * The T key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.T
     * @type {number}
     * @since 3.0.0
     */ T: 84,
                /**
     * The U key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.U
     * @type {number}
     * @since 3.0.0
     */ U: 85,
                /**
     * The V key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.V
     * @type {number}
     * @since 3.0.0
     */ V: 86,
                /**
     * The W key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.W
     * @type {number}
     * @since 3.0.0
     */ W: 87,
                /**
     * The X key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.X
     * @type {number}
     * @since 3.0.0
     */ X: 88,
                /**
     * The Y key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Y
     * @type {number}
     * @since 3.0.0
     */ Y: 89,
                /**
     * The Z key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.Z
     * @type {number}
     * @since 3.0.0
     */ Z: 90,
                /**
     * The F1 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F1
     * @type {number}
     * @since 3.0.0
     */ F1: 112,
                /**
     * The F2 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F2
     * @type {number}
     * @since 3.0.0
     */ F2: 113,
                /**
     * The F3 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F3
     * @type {number}
     * @since 3.0.0
     */ F3: 114,
                /**
     * The F4 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F4
     * @type {number}
     * @since 3.0.0
     */ F4: 115,
                /**
     * The F5 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F5
     * @type {number}
     * @since 3.0.0
     */ F5: 116,
                /**
     * The F6 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F6
     * @type {number}
     * @since 3.0.0
     */ F6: 117,
                /**
     * The F7 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F7
     * @type {number}
     * @since 3.0.0
     */ F7: 118,
                /**
     * The F8 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F8
     * @type {number}
     * @since 3.0.0
     */ F8: 119,
                /**
     * The F9 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F9
     * @type {number}
     * @since 3.0.0
     */ F9: 120,
                /**
     * The F10 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F10
     * @type {number}
     * @since 3.0.0
     */ F10: 121,
                /**
     * The F11 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F11
     * @type {number}
     * @since 3.0.0
     */ F11: 122,
                /**
     * The F12 key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.F12
     * @type {number}
     * @since 3.0.0
     */ F12: 123,
                /**
     * The SEMICOLON key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON: 186,
                /**
     * The PLUS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PLUS
     * @type {number}
     * @since 3.0.0
     */ PLUS: 187,
                /**
     * The COMMA key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA
     * @type {number}
     * @since 3.0.0
     */ COMMA: 188,
                /**
     * The MINUS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.MINUS
     * @type {number}
     * @since 3.0.0
     */ MINUS: 189,
                /**
     * The PERIOD key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.PERIOD
     * @type {number}
     * @since 3.0.0
     */ PERIOD: 190,
                /**
     * The FORWARD_SLASH key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.FORWARD_SLASH
     * @type {number}
     * @since 3.0.0
     */ FORWARD_SLASH: 191,
                /**
     * The BACK_SLASH key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACK_SLASH
     * @type {number}
     * @since 3.0.0
     */ BACK_SLASH: 220,
                /**
     * The QUOTES key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.QUOTES
     * @type {number}
     * @since 3.0.0
     */ QUOTES: 222,
                /**
     * The BACKTICK key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BACKTICK
     * @type {number}
     * @since 3.0.0
     */ BACKTICK: 192,
                /**
     * The OPEN_BRACKET key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.OPEN_BRACKET
     * @type {number}
     * @since 3.0.0
     */ OPEN_BRACKET: 219,
                /**
     * The CLOSED_BRACKET key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.CLOSED_BRACKET
     * @type {number}
     * @since 3.0.0
     */ CLOSED_BRACKET: 221,
                /**
     * The SEMICOLON_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ SEMICOLON_FIREFOX: 59,
                /**
     * The COLON key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COLON
     * @type {number}
     * @since 3.0.0
     */ COLON: 58,
                /**
     * The COMMA_FIREFOX_WINDOWS key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX_WINDOWS
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX_WINDOWS: 60,
                /**
     * The COMMA_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.COMMA_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ COMMA_FIREFOX: 62,
                /**
     * The BRACKET_RIGHT_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_RIGHT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_RIGHT_FIREFOX: 174,
                /**
     * The BRACKET_LEFT_FIREFOX key.
     * 
     * @name Phaser.Input.Keyboard.KeyCodes.BRACKET_LEFT_FIREFOX
     * @type {number}
     * @since 3.0.0
     */ BRACKET_LEFT_FIREFOX: 175
            };
            module1.exports = KeyCodes;
        /***/ },
        /* 142 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Scene consts.
 * 
 * @ignore
 */ var CONST = {
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.PENDING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PENDING: 0,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.INIT
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ INIT: 1,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.START
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ START: 2,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.LOADING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ LOADING: 3,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.CREATING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ CREATING: 4,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.RUNNING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ RUNNING: 5,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.PAUSED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ PAUSED: 6,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.SLEEPING
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SLEEPING: 7,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.SHUTDOWN
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ SHUTDOWN: 8,
                /**
     * Scene state.
     * 
     * @name Phaser.Scenes.DESTROYED
     * @readonly
     * @type {number}
     * @since 3.0.0
     */ DESTROYED: 9
            };
            module1.exports = CONST;
        /***/ },
        /* 143 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Creates a new Object using all values from obj1 and obj2.
 * If a value exists in both obj1 and obj2, the value in obj1 is used.
 * 
 * This is only a shallow copy. Deeply nested objects are not cloned, so be sure to only use this
 * function on shallow objects.
 *
 * @function Phaser.Utils.Objects.Merge
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object.
 * @param {object} obj2 - The second object.
 *
 * @return {object} A new object containing the union of obj1's and obj2's properties.
 */ var Merge = function(obj1, obj2) {
                var clone = Clone(obj1);
                for(var key in obj2)if (!clone.hasOwnProperty(key)) clone[key] = obj2[key];
                return clone;
            };
            module1.exports = Merge;
        /***/ },
        /* 144 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clone = __webpack_require__(77);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(69);
            var GameEvents = __webpack_require__(22);
            var NOOP = __webpack_require__(1);
            var GetAll = __webpack_require__(204);
            var GetFirst = __webpack_require__(422);
            /**
 * @classdesc
 * Base class for other Sound Manager classes.
 *
 * @class BaseSoundManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @see Phaser.Sound.HTML5AudioSoundManager
 * @see Phaser.Sound.NoAudioSoundManager
 * @see Phaser.Sound.WebAudioSoundManager
 */ var BaseSoundManager = new Class({
                Extends: EventEmitter,
                initialize: function BaseSoundManager(game) {
                    EventEmitter.call(this);
                    /**
         * Local reference to game.
         *
         * @name Phaser.Sound.BaseSoundManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * Local reference to the JSON Cache, as used by Audio Sprites.
         *
         * @name Phaser.Sound.BaseSoundManager#jsonCache
         * @type {Phaser.Cache.BaseCache}
         * @readonly
         * @since 3.7.0
         */ this.jsonCache = game.cache.json;
                    /**
         * An array containing all added sounds.
         *
         * @name Phaser.Sound.BaseSoundManager#sounds
         * @type {Phaser.Sound.BaseSound[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.sounds = [];
                    /**
         * Global mute setting.
         *
         * @name Phaser.Sound.BaseSoundManager#mute
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.mute = false;
                    /**
         * Global volume setting.
         *
         * @name Phaser.Sound.BaseSoundManager#volume
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.volume = 1;
                    /**
         * Flag indicating if sounds should be paused when game looses focus,
         * for instance when user switches to another tab/program/app.
         *
         * @name Phaser.Sound.BaseSoundManager#pauseOnBlur
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.pauseOnBlur = true;
                    /**
         * Property that actually holds the value of global playback rate.
         *
         * @name Phaser.Sound.BaseSoundManager#_rate
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._rate = 1;
                    /**
         * Property that actually holds the value of global detune.
         *
         * @name Phaser.Sound.BaseSoundManager#_detune
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._detune = 0;
                    /**
         * Mobile devices require sounds to be triggered from an explicit user action,
         * such as a tap, before any sound can be loaded/played on a web page.
         * Set to true if the audio system is currently locked awaiting user interaction.
         *
         * @name Phaser.Sound.BaseSoundManager#locked
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.locked = this.locked || false;
                    /**
         * Flag used internally for handling when the audio system
         * has been unlocked, if there ever was a need for it.
         *
         * @name Phaser.Sound.BaseSoundManager#unlocked
         * @type {boolean}
         * @default false
         * @private
         * @since 3.0.0
         */ this.unlocked = false;
                    game.events.on(GameEvents.BLUR, this.onGameBlur, this);
                    game.events.on(GameEvents.FOCUS, this.onGameFocus, this);
                    game.events.on(GameEvents.PRE_STEP, this.update, this);
                    game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.BaseSoundManager#add
     * @override
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.BaseSound} The new sound instance.
     */ add: NOOP,
                /**
     * Adds a new audio sprite sound into the sound manager.
     * Audio Sprites are a combination of audio files and a JSON configuration.
     * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
     *
     * @method Phaser.Sound.BaseSoundManager#addAudioSprite
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {(Phaser.Sound.HTML5AudioSound|Phaser.Sound.WebAudioSound)} The new audio sprite sound instance.
     */ addAudioSprite: function(key, config) {
                    if (config === undefined) config = {};
                    var sound = this.add(key, config);
                    sound.spritemap = this.jsonCache.get(key).spritemap;
                    for(var markerName in sound.spritemap){
                        if (!sound.spritemap.hasOwnProperty(markerName)) continue;
                        var markerConfig = Clone(config);
                        var marker = sound.spritemap[markerName];
                        markerConfig.loop = marker.hasOwnProperty('loop') ? marker.loop : false;
                        sound.addMarker({
                            name: markerName,
                            start: marker.start,
                            duration: marker.end - marker.start,
                            config: markerConfig
                        });
                    }
                    return sound;
                },
                /**
     * Gets the first sound in the manager matching the given key, if any.
     *
     * @method Phaser.Sound.BaseSoundManager#get
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {?Phaser.Sound.BaseSound} - The sound, or null.
     */ get: function(key) {
                    return GetFirst(this.sounds, 'key', key);
                },
                /**
     * Gets any sounds in the manager matching the given key.
     *
     * @method Phaser.Sound.BaseSoundManager#getAll
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {Phaser.Sound.BaseSound[]} - The sounds, or an empty array.
     */ getAll: function(key) {
                    return GetAll(this.sounds, 'key', key);
                },
                /**
     * Adds a new sound to the sound manager and plays it.
     * The sound will be automatically removed (destroyed) once playback ends.
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#play
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {(Phaser.Types.Sound.SoundConfig|Phaser.Types.Sound.SoundMarker)} [extra] - An optional additional object containing settings to be applied to the sound. It could be either config or marker object.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(key, extra) {
                    var sound = this.add(key);
                    sound.once(Events.COMPLETE, sound.destroy, sound);
                    if (extra) {
                        if (extra.name) {
                            sound.addMarker(extra);
                            return sound.play(extra.name);
                        } else return sound.play(extra);
                    } else return sound.play();
                },
                /**
     * Adds a new audio sprite sound to the sound manager and plays it.
     * The sprite will be automatically removed (destroyed) once playback ends.
     * This lets you play a new sound on the fly without the need to keep a reference to it.
     *
     * @method Phaser.Sound.BaseSoundManager#playAudioSprite
     * @listens Phaser.Sound.Events#COMPLETE
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {string} spriteName - The name of the sound sprite to play.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {boolean} Whether the audio sprite sound started playing successfully.
     */ playAudioSprite: function(key, spriteName, config) {
                    var sound = this.addAudioSprite(key);
                    sound.once(Events.COMPLETE, sound.destroy, sound);
                    return sound.play(spriteName, config);
                },
                /**
     * Removes a sound from the sound manager.
     * The removed sound is destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#remove
     * @since 3.0.0
     *
     * @param {Phaser.Sound.BaseSound} sound - The sound object to remove.
     *
     * @return {boolean} True if the sound was removed successfully, otherwise false.
     */ remove: function(sound) {
                    var index = this.sounds.indexOf(sound);
                    if (index !== -1) {
                        sound.destroy();
                        this.sounds.splice(index, 1);
                        return true;
                    }
                    return false;
                },
                /**
     * Removes all sounds from the manager, destroying the sounds.
     *
     * @method Phaser.Sound.BaseSoundManager#removeAll
     * @since 3.23.0
     */ removeAll: function() {
                    this.sounds.forEach(function(sound) {
                        sound.destroy();
                    });
                    this.sounds.length = 0;
                },
                /**
     * Removes all sounds from the sound manager that have an asset key matching the given value.
     * The removed sounds are destroyed before removal.
     *
     * @method Phaser.Sound.BaseSoundManager#removeByKey
     * @since 3.0.0
     *
     * @param {string} key - The key to match when removing sound objects.
     *
     * @return {number} The number of matching sound objects that were removed.
     */ removeByKey: function(key) {
                    var removed = 0;
                    for(var i = this.sounds.length - 1; i >= 0; i--){
                        var sound = this.sounds[i];
                        if (sound.key === key) {
                            sound.destroy();
                            this.sounds.splice(i, 1);
                            removed++;
                        }
                    }
                    return removed;
                },
                /**
     * Pauses all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#pauseAll
     * @fires Phaser.Sound.Events#PAUSE_ALL
     * @since 3.0.0
     */ pauseAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.pause();
                    });
                    this.emit(Events.PAUSE_ALL, this);
                },
                /**
     * Resumes all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#resumeAll
     * @fires Phaser.Sound.Events#RESUME_ALL
     * @since 3.0.0
     */ resumeAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.resume();
                    });
                    this.emit(Events.RESUME_ALL, this);
                },
                /**
     * Stops all the sounds in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#stopAll
     * @fires Phaser.Sound.Events#STOP_ALL
     * @since 3.0.0
     */ stopAll: function() {
                    this.forEachActiveSound(function(sound) {
                        sound.stop();
                    });
                    this.emit(Events.STOP_ALL, this);
                },
                /**
     * Stops any sounds matching the given key.
     *
     * @method Phaser.Sound.BaseSoundManager#stopByKey
     * @since 3.23.0
     *
     * @param {string} key - Sound asset key.
     *
     * @return {number} - How many sounds were stopped.
     */ stopByKey: function(key) {
                    var stopped = 0;
                    this.getAll(key).forEach(function(sound) {
                        if (sound.stop()) stopped++;
                    });
                    return stopped;
                },
                /**
     * Method used internally for unlocking audio playback on devices that
     * require user interaction before any sound can be played on a web page.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.BaseSoundManager#unlock
     * @override
     * @protected
     * @since 3.0.0
     */ unlock: NOOP,
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onBlur
     * @override
     * @protected
     * @since 3.0.0
     */ onBlur: NOOP,
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.BaseSoundManager#onFocus
     * @override
     * @protected
     * @since 3.0.0
     */ onFocus: NOOP,
                /**
     * Internal handler for Phaser.Core.Events#BLUR.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameBlur
     * @private
     * @since 3.23.0
     */ onGameBlur: function() {
                    if (this.pauseOnBlur) this.onBlur();
                },
                /**
     * Internal handler for Phaser.Core.Events#FOCUS.
     *
     * @method Phaser.Sound.BaseSoundManager#onGameFocus
     * @private
     * @since 3.23.0
     */ onGameFocus: function() {
                    if (this.pauseOnBlur) this.onFocus();
                },
                /**
     * Update method called on every game step.
     * Removes destroyed sounds and updates every active sound in the game.
     *
     * @method Phaser.Sound.BaseSoundManager#update
     * @protected
     * @fires Phaser.Sound.Events#UNLOCKED
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.unlocked) {
                        this.unlocked = false;
                        this.locked = false;
                        this.emit(Events.UNLOCKED, this);
                    }
                    for(var i = this.sounds.length - 1; i >= 0; i--)if (this.sounds[i].pendingRemove) this.sounds.splice(i, 1);
                    this.sounds.forEach(function(sound) {
                        sound.update(time, delta);
                    });
                },
                /**
     * Destroys all the sounds in the game and all associated events.
     *
     * @method Phaser.Sound.BaseSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.game.events.off(GameEvents.BLUR, this.onGameBlur, this);
                    this.game.events.off(GameEvents.FOCUS, this.onGameFocus, this);
                    this.game.events.off(GameEvents.PRE_STEP, this.update, this);
                    this.removeAllListeners();
                    this.removeAll();
                    this.sounds.length = 0;
                    this.sounds = null;
                    this.game = null;
                },
                /**
     * Method used internally for iterating only over active sounds and skipping sounds that are marked for removal.
     *
     * @method Phaser.Sound.BaseSoundManager#forEachActiveSound
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.EachActiveSoundCallback} callback - Callback function. (manager: Phaser.Sound.BaseSoundManager, sound: Phaser.Sound.BaseSound, index: number, sounds: Phaser.Manager.BaseSound[]) => void
     * @param {*} [scope] - Callback context.
     */ forEachActiveSound: function(callback, scope) {
                    var _this = this;
                    this.sounds.forEach(function(sound, index) {
                        if (sound && !sound.pendingRemove) callback.call(scope || _this, sound, index, _this.sounds);
                    });
                },
                /**
     * Sets the global playback rate at which all the sounds will be played.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.BaseSoundManager#setRate
     * @fires Phaser.Sound.Events#GLOBAL_RATE
     * @since 3.3.0
     *
     * @param {number} value - Global playback rate at which all the sounds will be played.
     *
     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * Global playback rate at which all the sounds will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audio's playback speed.
     *
     * @name Phaser.Sound.BaseSoundManager#rate
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this._rate;
                    },
                    set: function(value) {
                        this._rate = value;
                        this.forEachActiveSound(function(sound) {
                            sound.calculateRate();
                        });
                        this.emit(Events.GLOBAL_RATE, this, value);
                    }
                },
                /**
     * Sets the global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.BaseSoundManager#setDetune
     * @fires Phaser.Sound.Events#GLOBAL_DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.BaseSoundManager#detune
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this._detune;
                    },
                    set: function(value) {
                        this._detune = value;
                        this.forEachActiveSound(function(sound) {
                            sound.calculateRate();
                        });
                        this.emit(Events.GLOBAL_DETUNE, this, value);
                    }
                }
            });
            module1.exports = BaseSoundManager;
        /***/ },
        /* 145 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(69);
            var Extend = __webpack_require__(17);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * Class containing all the shared state and behavior of a sound object, independent of the implementation.
 *
 * @class BaseSound
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.BaseSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
 */ var BaseSound = new Class({
                Extends: EventEmitter,
                initialize: function BaseSound(manager, key, config) {
                    EventEmitter.call(this);
                    /**
         * Local reference to the sound manager.
         *
         * @name Phaser.Sound.BaseSound#manager
         * @type {Phaser.Sound.BaseSoundManager}
         * @private
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * Asset key for the sound.
         *
         * @name Phaser.Sound.BaseSound#key
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.key = key;
                    /**
         * Flag indicating if sound is currently playing.
         *
         * @name Phaser.Sound.BaseSound#isPlaying
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPlaying = false;
                    /**
         * Flag indicating if sound is currently paused.
         *
         * @name Phaser.Sound.BaseSound#isPaused
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isPaused = false;
                    /**
         * A property that holds the value of sound's actual playback rate,
         * after its rate and detune values has been combined with global
         * rate and detune values.
         *
         * @name Phaser.Sound.BaseSound#totalRate
         * @type {number}
         * @default 1
         * @readonly
         * @since 3.0.0
         */ this.totalRate = 1;
                    /**
         * A value representing the duration, in seconds.
         * It could be total sound duration or a marker duration.
         *
         * @name Phaser.Sound.BaseSound#duration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.duration = this.duration || 0;
                    /**
         * The total duration of the sound in seconds.
         *
         * @name Phaser.Sound.BaseSound#totalDuration
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.totalDuration = this.totalDuration || 0;
                    /**
         * A config object used to store default sound settings' values.
         * Default values will be set by properties' setters.
         *
         * @name Phaser.Sound.BaseSound#config
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.config = {
                        mute: false,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: false,
                        delay: 0,
                        pan: 0
                    };
                    /**
         * Reference to the currently used config.
         * It could be default config or marker config.
         *
         * @name Phaser.Sound.BaseSound#currentConfig
         * @type {Phaser.Types.Sound.SoundConfig}
         * @private
         * @since 3.0.0
         */ this.currentConfig = this.config;
                    this.config = Extend(this.config, config);
                    /**
         * Object containing markers definitions.
         *
         * @name Phaser.Sound.BaseSound#markers
         * @type {Object.<string, Phaser.Types.Sound.SoundMarker>}
         * @default {}
         * @readonly
         * @since 3.0.0
         */ this.markers = {};
                    /**
         * Currently playing marker.
         * 'null' if whole sound is playing.
         *
         * @name Phaser.Sound.BaseSound#currentMarker
         * @type {Phaser.Types.Sound.SoundMarker}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.currentMarker = null;
                    /**
         * Flag indicating if destroy method was called on this sound.
         *
         * @name Phaser.Sound.BaseSound#pendingRemove
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this.pendingRemove = false;
                },
                /**
     * Adds a marker into the current sound. A marker is represented by name, start time, duration, and optionally config object.
     * This allows you to bundle multiple sounds together into a single audio file and use markers to jump between them for playback.
     *
     * @method Phaser.Sound.BaseSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} Whether the marker was added successfully.
     */ addMarker: function(marker) {
                    if (!marker || !marker.name || typeof marker.name !== 'string') return false;
                    if (this.markers[marker.name]) {
                        // eslint-disable-next-line no-console
                        console.error('addMarker ' + marker.name + ' already exists in Sound');
                        return false;
                    }
                    marker = Extend(true, {
                        name: '',
                        start: 0,
                        duration: this.totalDuration - (marker.start || 0),
                        config: {
                            mute: false,
                            volume: 1,
                            rate: 1,
                            detune: 0,
                            seek: 0,
                            loop: false,
                            delay: 0,
                            pan: 0
                        }
                    }, marker);
                    this.markers[marker.name] = marker;
                    return true;
                },
                /**
     * Updates previously added marker.
     *
     * @method Phaser.Sound.BaseSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} Whether the marker was updated successfully.
     */ updateMarker: function(marker) {
                    if (!marker || !marker.name || typeof marker.name !== 'string') return false;
                    if (!this.markers[marker.name]) {
                        // eslint-disable-next-line no-console
                        console.warn('Audio Marker: ' + marker.name + ' missing in Sound: ' + this.key);
                        return false;
                    }
                    this.markers[marker.name] = Extend(true, this.markers[marker.name], marker);
                    return true;
                },
                /**
     * Removes a marker from the sound.
     *
     * @method Phaser.Sound.BaseSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {?Phaser.Types.Sound.SoundMarker} Removed marker object or 'null' if there was no marker with provided name.
     */ removeMarker: function(markerName) {
                    var marker = this.markers[markerName];
                    if (!marker) return null;
                    this.markers[markerName] = null;
                    return marker;
                },
                /**
     * Play this sound, or a marked section of it.
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.BaseSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (markerName === undefined) markerName = '';
                    if (typeof markerName === 'object') {
                        config = markerName;
                        markerName = '';
                    }
                    if (typeof markerName !== 'string') return false;
                    if (!markerName) {
                        this.currentMarker = null;
                        this.currentConfig = this.config;
                        this.duration = this.totalDuration;
                    } else {
                        if (!this.markers[markerName]) {
                            // eslint-disable-next-line no-console
                            console.warn('Marker: ' + markerName + ' missing in Sound: ' + this.key);
                            return false;
                        }
                        this.currentMarker = this.markers[markerName];
                        this.currentConfig = this.currentMarker.config;
                        this.duration = this.currentMarker.duration;
                    }
                    this.resetConfig();
                    this.currentConfig = Extend(this.currentConfig, config);
                    this.isPlaying = true;
                    this.isPaused = false;
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.BaseSound#pause
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.isPaused || !this.isPlaying) return false;
                    this.isPlaying = false;
                    this.isPaused = true;
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.BaseSound#resume
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (!this.isPaused || this.isPlaying) return false;
                    this.isPlaying = true;
                    this.isPaused = false;
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.BaseSound#stop
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (!this.isPaused && !this.isPlaying) return false;
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.resetConfig();
                    return true;
                },
                /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.BaseSound#applyConfig
     * @protected
     * @since 3.0.0
     */ applyConfig: function() {
                    this.mute = this.currentConfig.mute;
                    this.volume = this.currentConfig.volume;
                    this.rate = this.currentConfig.rate;
                    this.detune = this.currentConfig.detune;
                    this.loop = this.currentConfig.loop;
                    this.pan = this.currentConfig.pan;
                },
                /**
     * Method used internally for resetting values of some of the config properties.
     *
     * @method Phaser.Sound.BaseSound#resetConfig
     * @protected
     * @since 3.0.0
     */ resetConfig: function() {
                    this.currentConfig.seek = 0;
                    this.currentConfig.delay = 0;
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.BaseSound#update
     * @override
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ update: NOOP,
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.BaseSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    var cent = 1.0005777895065548; // Math.pow(2, 1/1200);
                    var totalDetune = this.currentConfig.detune + this.manager.detune;
                    var detuneRate = Math.pow(cent, totalDetune);
                    this.totalRate = this.currentConfig.rate * this.manager.rate * detuneRate;
                },
                /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.BaseSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    if (this.pendingRemove) return;
                    this.emit(Events.DESTROY, this);
                    this.pendingRemove = true;
                    this.manager = null;
                    this.key = '';
                    this.removeAllListeners();
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.config = null;
                    this.currentConfig = null;
                    this.markers = null;
                    this.currentMarker = null;
                }
            });
            module1.exports = BaseSound;
        /***/ },
        /* 146 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckMatrix = __webpack_require__(206);
            var TransposeMatrix = __webpack_require__(429);
            /**
 * Rotates the array matrix based on the given rotation value.
 *
 * The value can be given in degrees: 90, -90, 270, -270 or 180,
 * or a string command: `rotateLeft`, `rotateRight` or `rotate180`.
 *
 * Based on the routine from {@link http://jsfiddle.net/MrPolywhirl/NH42z/}.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 * @param {(number|string)} [direction=90] - The amount to rotate the matrix by.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateMatrix = function(matrix, direction) {
                if (direction === undefined) direction = 90;
                if (!CheckMatrix(matrix)) return null;
                if (typeof direction !== 'string') direction = (direction % 360 + 360) % 360;
                if (direction === 90 || direction === -270 || direction === 'rotateLeft') {
                    matrix = TransposeMatrix(matrix);
                    matrix.reverse();
                } else if (direction === -90 || direction === 270 || direction === 'rotateRight') {
                    matrix.reverse();
                    matrix = TransposeMatrix(matrix);
                } else if (Math.abs(direction) === 180 || direction === 'rotate180') {
                    for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                    matrix.reverse();
                }
                return matrix;
            };
            module1.exports = RotateMatrix;
        /***/ },
        /* 147 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GetBitmapTextSize = __webpack_require__(1037);
            var ParseFromAtlas = __webpack_require__(1038);
            var ParseXMLBitmapFont = __webpack_require__(209);
            var Rectangle = __webpack_require__(10);
            var Render = __webpack_require__(1039);
            /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Littera (Web-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class BitmapText
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var BitmapText = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Texture,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function BitmapText(scene, x, y, font, text, size, align) {
                    if (text === undefined) text = '';
                    if (align === undefined) align = 0;
                    GameObject.call(this, scene, 'BitmapText');
                    /**
         * The key of the Bitmap Font used by this Bitmap Text.
         * To change the font after creation please use `setFont`.
         *
         * @name Phaser.GameObjects.BitmapText#font
         * @type {string}
         * @readonly
         * @since 3.0.0
         */ this.font = font;
                    var entry = this.scene.sys.cache.bitmapFont.get(font);
                    if (!entry) console.warn('Invalid BitmapText key: ' + font);
                    /**
         * The data of the Bitmap Font used by this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#fontData
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapFontData}
         * @readonly
         * @since 3.0.0
         */ this.fontData = entry.data;
                    /**
         * The text that this Bitmap Text object displays.
         *
         * @name Phaser.GameObjects.BitmapText#_text
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._text = '';
                    /**
         * The font size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_fontSize
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._fontSize = size || this.fontData.size;
                    /**
         * Adds / Removes spacing between characters.
         *
         * Can be a negative or positive number.
         *
         * @name Phaser.GameObjects.BitmapText#_letterSpacing
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._letterSpacing = 0;
                    /**
         * Controls the alignment of each line of text in this BitmapText object.
         * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
         * Has no effect with single-lines of text.
         *
         * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
         *
         * 0 = Left aligned (default)
         * 1 = Middle aligned
         * 2 = Right aligned
         *
         * The alignment position is based on the longest line of text.
         *
         * @name Phaser.GameObjects.BitmapText#_align
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._align = align;
                    /**
         * An object that describes the size of this Bitmap Text.
         *
         * @name Phaser.GameObjects.BitmapText#_bounds
         * @type {Phaser.Types.GameObjects.BitmapText.BitmapTextSize}
         * @private
         * @since 3.0.0
         */ this._bounds = GetBitmapTextSize();
                    /**
         * An internal dirty flag for bounds calculation.
         *
         * @name Phaser.GameObjects.BitmapText#_dirty
         * @type {boolean}
         * @private
         * @since 3.11.0
         */ this._dirty = true;
                    /**
         * Internal cache var holding the maxWidth.
         *
         * @name Phaser.GameObjects.BitmapText#_maxWidth
         * @type {number}
         * @private
         * @since 3.21.0
         */ this._maxWidth = 0;
                    /**
         * The character code used to detect for word wrapping.
         * Defaults to 32 (a space character).
         *
         * @name Phaser.GameObjects.BitmapText#wordWrapCharCode
         * @type {number}
         * @since 3.21.0
         */ this.wordWrapCharCode = 32;
                    /**
         * Internal array holding the character tint color data.
         *
         * @name Phaser.GameObjects.BitmapText#charColors
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.charColors = [];
                    /**
         * The horizontal offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowX
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowX = 0;
                    /**
         * The vertical offset of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowY
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowY = 0;
                    /**
         * The color of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowColor
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowColor = 0x000000;
                    /**
         * The alpha value of the drop shadow.
         *
         * You can set this directly, or use `Phaser.GameObjects.BitmapText#setDropShadow`.
         *
         * @name Phaser.GameObjects.BitmapText#dropShadowAlpha
         * @type {number}
         * @since 3.50.0
         */ this.dropShadowAlpha = 0.5;
                    this.setTexture(entry.texture, entry.frame);
                    this.setPosition(x, y);
                    this.setOrigin(0, 0);
                    this.initPipeline();
                    this.setText(text);
                },
                /**
     * Set the lines of text in this BitmapText to be left-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setLeftAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setLeftAlign: function() {
                    this._align = BitmapText.ALIGN_LEFT;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the lines of text in this BitmapText to be center-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setCenterAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setCenterAlign: function() {
                    this._align = BitmapText.ALIGN_CENTER;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the lines of text in this BitmapText to be right-aligned.
     * This only has any effect if this BitmapText contains more than one line of text.
     *
     * @method Phaser.GameObjects.BitmapText#setRightAlign
     * @since 3.11.0
     *
     * @return {this} This BitmapText Object.
     */ setRightAlign: function() {
                    this._align = BitmapText.ALIGN_RIGHT;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the font size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#setFontSize
     * @since 3.0.0
     *
     * @param {number} size - The font size to set.
     *
     * @return {this} This BitmapText Object.
     */ setFontSize: function(size) {
                    this._fontSize = size;
                    this._dirty = true;
                    return this;
                },
                /**
     * Sets the letter spacing between each character of this Bitmap Text.
     * Can be a positive value to increase the space, or negative to reduce it.
     * Spacing is applied after the kerning values have been set.
     *
     * @method Phaser.GameObjects.BitmapText#setLetterSpacing
     * @since 3.4.0
     *
     * @param {number} [spacing=0] - The amount of horizontal space to add between each character.
     *
     * @return {this} This BitmapText Object.
     */ setLetterSpacing: function(spacing) {
                    if (spacing === undefined) spacing = 0;
                    this._letterSpacing = spacing;
                    this._dirty = true;
                    return this;
                },
                /**
     * Set the textual content of this BitmapText.
     *
     * An array of strings will be converted into multi-line text. Use the align methods to change multi-line alignment.
     *
     * @method Phaser.GameObjects.BitmapText#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this BitmapText.
     *
     * @return {this} This BitmapText Object.
     */ setText: function(value) {
                    if (!value && value !== 0) value = '';
                    if (Array.isArray(value)) value = value.join('\n');
                    if (value !== this.text) {
                        this._text = value.toString();
                        this._dirty = true;
                        this.updateDisplayOrigin();
                    }
                    return this;
                },
                /**
     * Sets a drop shadow effect on this Bitmap Text.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * You can set the vertical and horizontal offset of the shadow, as well as the color and alpha.
     *
     * Once a shadow has been enabled you can modify the `dropShadowX` and `dropShadowY` properties of this
     * Bitmap Text directly to adjust the position of the shadow in real-time.
     *
     * If you wish to clear the shadow, call this method with no parameters specified.
     *
     * @method Phaser.GameObjects.BitmapText#setDropShadow
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [x=0] - The horizontal offset of the drop shadow.
     * @param {number} [y=0] - The vertical offset of the drop shadow.
     * @param {number} [color=0x000000] - The color of the drop shadow, given as a hex value, i.e. `0x000000` for black.
     * @param {number} [alpha=0.5] - The alpha of the drop shadow, given as a float between 0 and 1. This is combined with the Bitmap Text alpha as well.
     *
     * @return {this} This BitmapText Object.
     */ setDropShadow: function(x, y, color, alpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (color === undefined) color = 0x000000;
                    if (alpha === undefined) alpha = 0.5;
                    this.dropShadowX = x;
                    this.dropShadowY = y;
                    this.dropShadowColor = color;
                    this.dropShadowAlpha = alpha;
                    return this;
                },
                /**
     * Sets a tint on a range of characters in this Bitmap Text, starting from the `start` parameter index
     * and running for `length` quantity of characters.
     *
     * The `start` parameter can be negative. In this case, it starts at the end of the text and counts
     * backwards `start` places.
     *
     * You can also pass in -1 as the `length` and it will tint all characters from `start`
     * up until the end of the string.

     * Remember that spaces and punctuation count as characters.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setWordTint` can override tints set by this function, and vice versa.
     *
     * To remove a tint call this method with just the `start`, and optionally, the `length` parameters defined.
     *
     * @method Phaser.GameObjects.BitmapText#setCharacterTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {number} [start=0] - The starting character to begin the tint at. If negative, it counts back from the end of the text.
     * @param {number} [length=1] - The number of characters to tint. Remember that spaces count as a character too. Pass -1 to tint all characters from `start` onwards.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the character. If not other values are given this value is applied evenly, tinting the whole character.
     * @param {number} [topRight] - The tint being applied to the top-right of the character.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the character.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the character.
     *
     * @return {this} This BitmapText Object.
     */ setCharacterTint: function(start, length, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                    if (start === undefined) start = 0;
                    if (length === undefined) length = 1;
                    if (tintFill === undefined) tintFill = false;
                    if (topLeft === undefined) topLeft = -1;
                    if (topRight === undefined) {
                        topRight = topLeft;
                        bottomLeft = topLeft;
                        bottomRight = topLeft;
                    }
                    var len = this.text.length;
                    if (length === -1) length = len;
                    if (start < 0) start = len + start;
                    start = Clamp(start, 0, len - 1);
                    var end = Clamp(start + length, start, len);
                    var charColors = this.charColors;
                    for(var i = start; i < end; i++){
                        var color = charColors[i];
                        if (topLeft === -1) charColors[i] = null;
                        else {
                            var tintEffect = tintFill ? 1 : 0;
                            if (color) {
                                color.tintEffect = tintEffect;
                                color.tintTL = topLeft;
                                color.tintTR = topRight;
                                color.tintBL = bottomLeft;
                                color.tintBR = bottomRight;
                            } else charColors[i] = {
                                tintEffect: tintEffect,
                                tintTL: topLeft,
                                tintTR: topRight,
                                tintBL: bottomLeft,
                                tintBR: bottomRight
                            };
                        }
                    }
                    return this;
                },
                /**
     * Sets a tint on a matching word within this Bitmap Text.
     *
     * The `word` parameter can be either a string or a number.
     *
     * If a string, it will run a string comparison against the text contents, and if matching,
     * it will tint the whole word.
     *
     * If a number, if till that word, based on its offset within the text contents.
     *
     * The `count` parameter controls how many words are replaced. Pass in -1 to replace them all.
     *
     * This parameter is ignored if you pass a number as the `word` to be searched for.
     *
     * This is a WebGL only feature and only works with Static Bitmap Text, not Dynamic.
     *
     * The tint works by taking the pixel color values from the Bitmap Text texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole character will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the character range.
     *
     * To swap this from being an additive tint to a fill based tint, set the `tintFill` parameter to `true`.
     *
     * To modify the tint color once set, call this method again with new color values.
     *
     * Using `setCharacterTint` can override tints set by this function, and vice versa.
     *
     * @method Phaser.GameObjects.BitmapText#setWordTint
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|number)} word - The word to search for. Either a string, or an index of the word in the words array.
     * @param {number} [count=1] - The number of matching words to tint. Pass -1 to tint all matching words.
     * @param {boolean} [tintFill=false] - Use a fill-based tint (true), or an additive tint (false)
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the word. If not other values are given this value is applied evenly, tinting the whole word.
     * @param {number} [topRight] - The tint being applied to the top-right of the word.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the word.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the word.
     *
     * @return {this} This BitmapText Object.
     */ setWordTint: function(word, count, tintFill, topLeft, topRight, bottomLeft, bottomRight) {
                    if (count === undefined) count = 1;
                    var bounds = this.getTextBounds();
                    var words = bounds.words;
                    var wordIsNumber = typeof word === 'number';
                    var total = 0;
                    for(var i = 0; i < words.length; i++){
                        var lineword = words[i];
                        if (wordIsNumber && i === word || !wordIsNumber && lineword.word === word) {
                            this.setCharacterTint(lineword.i, lineword.word.length, tintFill, topLeft, topRight, bottomLeft, bottomRight);
                            total++;
                            if (total === count) return this;
                        }
                    }
                    return this;
                },
                /**
     * Calculate the bounds of this Bitmap Text.
     *
     * An object is returned that contains the position, width and height of the Bitmap Text in local and global
     * contexts.
     *
     * Local size is based on just the font size and a [0, 0] position.
     *
     * Global size takes into account the Game Object's scale, world position and display origin.
     *
     * Also in the object is data regarding the length of each line, should this be a multi-line BitmapText.
     *
     * @method Phaser.GameObjects.BitmapText#getTextBounds
     * @since 3.0.0
     *
     * @param {boolean} [round=false] - Whether to round the results up to the nearest integer.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} An object that describes the size of this Bitmap Text.
     */ getTextBounds: function(round) {
                    //  local = The BitmapText based on fontSize and 0x0 coords
                    //  global = The BitmapText, taking into account scale and world position
                    //  lines = The BitmapText line data
                    var bounds = this._bounds;
                    if (this._dirty || round || this.scaleX !== bounds.scaleX || this.scaleY !== bounds.scaleY) {
                        GetBitmapTextSize(this, round, true, bounds);
                        this._dirty = false;
                    }
                    return bounds;
                },
                /**
     * Gets the character located at the given x/y coordinate within this Bitmap Text.
     *
     * The coordinates you pass in are translated into the local space of the
     * Bitmap Text, however, it is up to you to first translate the input coordinates to world space.
     *
     * If you wish to use this in combination with an input event, be sure
     * to pass in `Pointer.worldX` and `worldY` so they are in world space.
     *
     * In some cases, based on kerning, characters can overlap. When this happens,
     * the first character in the word is returned.
     *
     * Note that this does not work for DynamicBitmapText if you have changed the
     * character positions during render. It will only scan characters in their un-translated state.
     *
     * @method Phaser.GameObjects.BitmapText#getCharacterAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check.
     * @param {number} y - The y position to check.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} The character object at the given position, or `null`.
     */ getCharacterAt: function(x, y, camera) {
                    var point = this.getLocalPoint(x, y, null, camera);
                    var bounds = this.getTextBounds();
                    var chars = bounds.characters;
                    var tempRect = new Rectangle();
                    for(var i = 0; i < chars.length; i++){
                        var char = chars[i];
                        tempRect.setTo(char.x, char.t, char.r - char.x, char.b);
                        if (tempRect.contains(point.x, point.y)) return char;
                    }
                    return null;
                },
                /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.BitmapText#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                    this._dirty = true;
                    this.getTextBounds(false);
                    return this;
                },
                /**
     * Changes the font this BitmapText is using to render.
     *
     * The new texture is loaded and applied to the BitmapText. The existing test, size and alignment are preserved,
     * unless overridden via the arguments.
     *
     * @method Phaser.GameObjects.BitmapText#setFont
     * @since 3.11.0
     *
     * @param {string} font - The key of the font to use from the Bitmap Font cache.
     * @param {number} [size] - The font size of this Bitmap Text. If not specified the current size will be used.
     * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object. If not specified the current alignment will be used.
     *
     * @return {this} This BitmapText Object.
     */ setFont: function(key, size, align) {
                    if (size === undefined) size = this._fontSize;
                    if (align === undefined) align = this._align;
                    if (key !== this.font) {
                        var entry = this.scene.sys.cache.bitmapFont.get(key);
                        if (entry) {
                            this.font = key;
                            this.fontData = entry.data;
                            this._fontSize = size;
                            this._align = align;
                            this.setTexture(entry.texture, entry.frame);
                            GetBitmapTextSize(this, false, true, this._bounds);
                        }
                    }
                    return this;
                },
                /**
     * Sets the maximum display width of this BitmapText in pixels.
     *
     * If `BitmapText.text` is longer than `maxWidth` then the lines will be automatically wrapped
     * based on the previous whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the `maxWidth` value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * You can set the whitespace character to be searched for by setting the `wordWrapCharCode` parameter or property.
     *
     * @method Phaser.GameObjects.BitmapText#setMaxWidth
     * @since 3.21.0
     *
     * @param {number} value - The maximum display width of this BitmapText in pixels. Set to zero to disable.
     * @param {number} [wordWrapCharCode] - The character code to check for when word wrapping. Defaults to 32 (the space character).
     *
     * @return {this} This BitmapText Object.
     */ setMaxWidth: function(value, wordWrapCharCode) {
                    this._maxWidth = value;
                    this._dirty = true;
                    if (wordWrapCharCode !== undefined) this.wordWrapCharCode = wordWrapCharCode;
                    return this;
                },
                /**
     * Controls the alignment of each line of text in this BitmapText object.
     *
     * Only has any effect when this BitmapText contains multiple lines of text, split with carriage-returns.
     * Has no effect with single-lines of text.
     *
     * See the methods `setLeftAlign`, `setCenterAlign` and `setRightAlign`.
     *
     * 0 = Left aligned (default)
     * 1 = Middle aligned
     * 2 = Right aligned
     *
     * The alignment position is based on the longest line of text.
     *
     * @name Phaser.GameObjects.BitmapText#align
     * @type {number}
     * @since 3.11.0
     */ align: {
                    set: function(value) {
                        this._align = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._align;
                    }
                },
                /**
     * The text that this Bitmap Text object displays.
     *
     * You can also use the method `setText` if you want a chainable way to change the text content.
     *
     * @name Phaser.GameObjects.BitmapText#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                    set: function(value) {
                        this.setText(value);
                    },
                    get: function() {
                        return this._text;
                    }
                },
                /**
     * The font size of this Bitmap Text.
     *
     * You can also use the method `setFontSize` if you want a chainable way to change the font size.
     *
     * @name Phaser.GameObjects.BitmapText#fontSize
     * @type {number}
     * @since 3.0.0
     */ fontSize: {
                    set: function(value) {
                        this._fontSize = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._fontSize;
                    }
                },
                /**
     * Adds / Removes spacing between characters.
     *
     * Can be a negative or positive number.
     *
     * You can also use the method `setLetterSpacing` if you want a chainable way to change the letter spacing.
     *
     * @name Phaser.GameObjects.BitmapText#letterSpacing
     * @type {number}
     * @since 3.0.0
     */ letterSpacing: {
                    set: function(value) {
                        this._letterSpacing = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._letterSpacing;
                    }
                },
                /**
     * The maximum display width of this BitmapText in pixels.
     *
     * If BitmapText.text is longer than maxWidth then the lines will be automatically wrapped
     * based on the last whitespace character found in the line.
     *
     * If no whitespace was found then no wrapping will take place and consequently the maxWidth value will not be honored.
     *
     * Disable maxWidth by setting the value to 0.
     *
     * @name Phaser.GameObjects.BitmapText#maxWidth
     * @type {number}
     * @since 3.21.0
     */ maxWidth: {
                    set: function(value) {
                        this._maxWidth = value;
                        this._dirty = true;
                    },
                    get: function() {
                        return this._maxWidth;
                    }
                },
                /**
     * The width of this Bitmap Text.
     *
     * @name Phaser.GameObjects.BitmapText#width
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ width: {
                    get: function() {
                        this.getTextBounds(false);
                        return this._bounds.global.width;
                    }
                },
                /**
     * The height of this bitmap text.
     *
     * @name Phaser.GameObjects.BitmapText#height
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ height: {
                    get: function() {
                        this.getTextBounds(false);
                        return this._bounds.global.height;
                    }
                },
                /**
     * Build a JSON representation of this Bitmap Text.
     *
     * @method Phaser.GameObjects.BitmapText#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.BitmapText.JSONBitmapText} A JSON representation of this Bitmap Text.
     */ toJSON: function() {
                    var out = Components.ToJSON(this);
                    //  Extra data is added here
                    var data = {
                        font: this.font,
                        text: this.text,
                        fontSize: this.fontSize,
                        letterSpacing: this.letterSpacing,
                        align: this.align
                    };
                    out.data = data;
                    return out;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.BitmapText#preDestroy
     * @protected
     * @since 3.50.0
     */ preDestroy: function() {
                    this.charColors.length = 0;
                    this._bounds = null;
                    this.fontData = null;
                }
            });
            /**
 * Left align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_LEFT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_LEFT = 0;
            /**
 * Center align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_CENTER
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_CENTER = 1;
            /**
 * Right align the text characters in a multi-line BitmapText object.
 *
 * @name Phaser.GameObjects.BitmapText.ALIGN_RIGHT
 * @type {number}
 * @since 3.11.0
 */ BitmapText.ALIGN_RIGHT = 2;
            /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @method Phaser.GameObjects.BitmapText.ParseFromAtlas
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ BitmapText.ParseFromAtlas = ParseFromAtlas;
            /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @method Phaser.GameObjects.BitmapText.ParseXMLBitmapFont
 * @since 3.17.0
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ BitmapText.ParseXMLBitmapFont = ParseXMLBitmapFont;
            module1.exports = BitmapText;
        /***/ },
        /* 148 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @callback EachSetCallback<E>
 *
 * @param {E} entry - The Set entry.
 * @param {number} index - The index of the entry within the Set.
 *
 * @return {?boolean} The callback result.
 */ /**
 * @classdesc
 * A Set is a collection of unique elements.
 *
 * @class Set
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[]} - [elements]
 *
 * @param {Array.<*>} [elements] - An optional array of elements to insert into this Set.
 */ var Set = new Class({
                initialize: function Set(elements) {
                    /**
         * The entries of this Set. Stored internally as an array.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.Set#entries
         * @type {Array.<*>}
         * @default []
         * @since 3.0.0
         */ this.entries = [];
                    if (Array.isArray(elements)) for(var i = 0; i < elements.length; i++)this.set(elements[i]);
                },
                /**
     * Inserts the provided value into this Set. If the value is already contained in this Set this method will have no effect.
     *
     * @method Phaser.Structs.Set#set
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to insert into this Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ set: function(value) {
                    if (this.entries.indexOf(value) === -1) this.entries.push(value);
                    return this;
                },
                /**
     * Get an element of this Set which has a property of the specified name, if that property is equal to the specified value.
     * If no elements of this Set satisfy the condition then this method will return `null`.
     *
     * @method Phaser.Structs.Set#get
     * @since 3.0.0
     *
     * @genericUse {T} - [value,$return]
     *
     * @param {string} property - The property name to check on the elements of this Set.
     * @param {*} value - The value to check for.
     *
     * @return {*} The first element of this Set that meets the required condition, or `null` if this Set contains no elements that meet the condition.
     */ get: function(property, value) {
                    for(var i = 0; i < this.entries.length; i++){
                        var entry = this.entries[i];
                        if (entry[property] === value) return entry;
                    }
                },
                /**
     * Returns an array containing all the values in this Set.
     *
     * @method Phaser.Structs.Set#getArray
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} An array containing all the values in this Set.
     */ getArray: function() {
                    return this.entries.slice(0);
                },
                /**
     * Removes the given value from this Set if this Set contains that value.
     *
     * @method Phaser.Structs.Set#delete
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {*} value - The value to remove from the Set.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ delete: function(value) {
                    var index = this.entries.indexOf(value);
                    if (index > -1) this.entries.splice(index, 1);
                    return this;
                },
                /**
     * Dumps the contents of this Set to the console via `console.group`.
     *
     * @method Phaser.Structs.Set#dump
     * @since 3.0.0
     */ dump: function() {
                    // eslint-disable-next-line no-console
                    console.group('Set');
                    for(var i = 0; i < this.entries.length; i++){
                        var entry = this.entries[i];
                        console.log(entry);
                    }
                    // eslint-disable-next-line no-console
                    console.groupEnd();
                },
                /**
     * Passes each value in this Set to the given callback.
     * Use this function when you know this Set will be modified during the iteration, otherwise use `iterate`.
     *
     * @method Phaser.Structs.Set#each
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ each: function(callback, callbackScope) {
                    var i;
                    var temp = this.entries.slice();
                    var len = temp.length;
                    if (callbackScope) for(i = 0; i < len; i++){
                        if (callback.call(callbackScope, temp[i], i) === false) break;
                    }
                    else for(i = 0; i < len; i++){
                        if (callback(temp[i], i) === false) break;
                    }
                    return this;
                },
                /**
     * Passes each value in this Set to the given callback.
     * For when you absolutely know this Set won't be modified during the iteration.
     *
     * @method Phaser.Structs.Set#iterate
     * @since 3.0.0
     *
     * @genericUse {EachSetCallback.<T>} - [callback]
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {EachSetCallback} callback - The callback to be invoked and passed each value this Set contains.
     * @param {*} [callbackScope] - The scope of the callback.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterate: function(callback, callbackScope) {
                    var i;
                    var len = this.entries.length;
                    if (callbackScope) for(i = 0; i < len; i++){
                        if (callback.call(callbackScope, this.entries[i], i) === false) break;
                    }
                    else for(i = 0; i < len; i++){
                        if (callback(this.entries[i], i) === false) break;
                    }
                    return this;
                },
                /**
     * Goes through each entry in this Set and invokes the given function on them, passing in the arguments.
     *
     * @method Phaser.Structs.Set#iterateLocal
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @param {string} callbackKey - The key of the function to be invoked on each Set entry.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ iterateLocal: function(callbackKey) {
                    var i;
                    var args = [];
                    for(i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    var len = this.entries.length;
                    for(i = 0; i < len; i++){
                        var entry = this.entries[i];
                        entry[callbackKey].apply(entry, args);
                    }
                    return this;
                },
                /**
     * Clears this Set so that it no longer contains any values.
     *
     * @method Phaser.Structs.Set#clear
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
     *
     * @return {Phaser.Structs.Set} This Set object.
     */ clear: function() {
                    this.entries.length = 0;
                    return this;
                },
                /**
     * Returns `true` if this Set contains the given value, otherwise returns `false`.
     *
     * @method Phaser.Structs.Set#contains
     * @since 3.0.0
     *
     * @genericUse {T} - [value]
     *
     * @param {*} value - The value to check for in this Set.
     *
     * @return {boolean} `true` if the given value was found in this Set, otherwise `false`.
     */ contains: function(value) {
                    return this.entries.indexOf(value) > -1;
                },
                /**
     * Returns a new Set containing all values that are either in this Set or in the Set provided as an argument.
     *
     * @method Phaser.Structs.Set#union
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the union with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set and the Set provided as an argument.
     */ union: function(set) {
                    var newSet = new Set();
                    set.entries.forEach(function(value) {
                        newSet.set(value);
                    });
                    this.entries.forEach(function(value) {
                        newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * Returns a new Set that contains only the values which are in this Set and that are also in the given Set.
     *
     * @method Phaser.Structs.Set#intersect
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to intersect this set with.
     *
     * @return {Phaser.Structs.Set} The result of the intersection, as a new Set.
     */ intersect: function(set) {
                    var newSet = new Set();
                    this.entries.forEach(function(value) {
                        if (set.contains(value)) newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * Returns a new Set containing all the values in this Set which are *not* also in the given Set.
     *
     * @method Phaser.Structs.Set#difference
     * @since 3.0.0
     *
     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
     *
     * @param {Phaser.Structs.Set} set - The Set to perform the difference with.
     *
     * @return {Phaser.Structs.Set} A new Set containing all the values in this Set that are not also in the Set provided as an argument to this method.
     */ difference: function(set) {
                    var newSet = new Set();
                    this.entries.forEach(function(value) {
                        if (!set.contains(value)) newSet.set(value);
                    });
                    return newSet;
                },
                /**
     * The size of this Set. This is the number of entries within it.
     * Changing the size will truncate the Set if the given value is smaller than the current size.
     * Increasing the size larger than the current size has no effect.
     *
     * @name Phaser.Structs.Set#size
     * @type {number}
     * @since 3.0.0
     */ size: {
                    get: function() {
                        return this.entries.length;
                    },
                    set: function(value) {
                        if (value < this.entries.length) return this.entries.length = value;
                        else return this.entries.length;
                    }
                }
            });
            module1.exports = Set;
        /***/ },
        /* 149 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var IntegerToColor = __webpack_require__(186);
            var PIPELINES_CONST = __webpack_require__(65);
            var Render = __webpack_require__(1176);
            /**
 * @classdesc
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the dislay list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @class PointLight
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Point Light belongs. A Point Light can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or colr blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 */ var PointLight = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function PointLight(scene, x, y, color, radius, intensity, attenuation) {
                    if (color === undefined) color = 0xffffff;
                    if (radius === undefined) radius = 128;
                    if (intensity === undefined) intensity = 1;
                    if (attenuation === undefined) attenuation = 0.1;
                    GameObject.call(this, scene, 'PointLight');
                    this.initPipeline(PIPELINES_CONST.POINTLIGHT_PIPELINE);
                    this.setPosition(x, y);
                    /**
         * The color of this Point Light. This property is an instance of a
         * Color object, so you can use the methods within it, such as `setTo(r, g, b)`
         * to change the color value.
         *
         * @name Phaser.GameObjects.PointLight#color
         * @type {Phaser.Display.Color}
         * @since 3.50.0
         */ this.color = IntegerToColor(color);
                    /**
         * The intensity of the Point Light.
         *
         * The colors of the light are multiplied by this value during rendering.
         *
         * @name Phaser.GameObjects.PointLight#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                    /**
         * The attenuation of the Point Light.
         *
         * This value controls the force with which the light falls-off from the center of the light.
         *
         * Use small float-based values, i.e. 0.1.
         *
         * @name Phaser.GameObjects.PointLight#attenuation
         * @type {number}
         * @since 3.50.0
         */ this.attenuation = attenuation;
                    //  read only:
                    this.width = radius * 2;
                    this.height = radius * 2;
                    this._radius = radius;
                },
                /**
     * The radius of the Point Light.
     *
     * @name Phaser.GameObjects.PointLight#radius
     * @type {number}
     * @since 3.50.0
     */ radius: {
                    get: function() {
                        return this._radius;
                    },
                    set: function(value) {
                        this._radius = value;
                        this.width = value * 2;
                        this.height = value * 2;
                    }
                },
                originX: {
                    get: function() {
                        return 0.5;
                    }
                },
                originY: {
                    get: function() {
                        return 0.5;
                    }
                },
                displayOriginX: {
                    get: function() {
                        return this._radius;
                    }
                },
                displayOriginY: {
                    get: function() {
                        return this._radius;
                    }
                }
            });
            module1.exports = PointLight;
        /***/ },
        /* 150 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between a circle and a rectangle.
 *
 * @function Phaser.Geom.Intersects.CircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var CircleToRectangle = function(circle, rect) {
                var halfWidth = rect.width / 2;
                var halfHeight = rect.height / 2;
                var cx = Math.abs(circle.x - rect.x - halfWidth);
                var cy = Math.abs(circle.y - rect.y - halfHeight);
                var xDist = halfWidth + circle.radius;
                var yDist = halfHeight + circle.radius;
                if (cx > xDist || cy > yDist) return false;
                else if (cx <= halfWidth || cy <= halfHeight) return true;
                else {
                    var xCornerDist = cx - halfWidth;
                    var yCornerDist = cy - halfHeight;
                    var xCornerDistSq = xCornerDist * xCornerDist;
                    var yCornerDistSq = yCornerDist * yCornerDist;
                    var maxCornerDistSq = circle.radius * circle.radius;
                    return xCornerDistSq + yCornerDistSq <= maxCornerDistSq;
                }
            };
            module1.exports = CircleToRectangle;
        /***/ },
        /* 151 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            //  Contains the plugins that Phaser uses globally and locally.
            //  These are the source objects, not instantiated.
            var inputPlugins = {};
            /**
 * @namespace Phaser.Input.InputPluginCache
 */ var InputPluginCache = {};
            /**
 * Static method called directly by the Core internal Plugins.
 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
 * Plugin is the object to instantiate to create the plugin
 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
 *
 * @function Phaser.Input.InputPluginCache.register
 * @static
 * @since 3.10.0
 *
 * @param {string} key - A reference used to get this plugin from the plugin cache.
 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
 * @param {string} mapping - If this plugin is to be injected into the Input Plugin, this is the property key used.
 * @param {string} settingsKey - The key in the Scene Settings to check to see if this plugin should install or not.
 * @param {string} configKey - The key in the Game Config to check to see if this plugin should install or not.
 */ InputPluginCache.register = function(key, plugin, mapping, settingsKey, configKey) {
                inputPlugins[key] = {
                    plugin: plugin,
                    mapping: mapping,
                    settingsKey: settingsKey,
                    configKey: configKey
                };
            };
            /**
 * Returns the input plugin object from the cache based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.getPlugin
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to get.
 *
 * @return {Phaser.Types.Input.InputPluginContainer} The input plugin object.
 */ InputPluginCache.getPlugin = function(key) {
                return inputPlugins[key];
            };
            /**
 * Installs all of the registered Input Plugins into the given target.
 *
 * @function Phaser.Input.InputPluginCache.install
 * @static
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} target - The target InputPlugin to install the plugins into.
 */ InputPluginCache.install = function(target) {
                var sys = target.scene.sys;
                var settings = sys.settings.input;
                var config = sys.game.config;
                for(var key in inputPlugins){
                    var source = inputPlugins[key].plugin;
                    var mapping = inputPlugins[key].mapping;
                    var settingsKey = inputPlugins[key].settingsKey;
                    var configKey = inputPlugins[key].configKey;
                    if (GetValue(settings, settingsKey, config[configKey])) target[mapping] = new source(target);
                }
            };
            /**
 * Removes an input plugin based on the given key.
 *
 * @function Phaser.Input.InputPluginCache.remove
 * @static
 * @since 3.10.0
 *
 * @param {string} key - The key of the input plugin to remove.
 */ InputPluginCache.remove = function(key) {
                if (inputPlugins.hasOwnProperty(key)) delete inputPlugins[key];
            };
            module1.exports = InputPluginCache;
        /***/ },
        /* 152 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard.Events
 */ module1.exports = {
                ANY_KEY_DOWN: __webpack_require__(1317),
                ANY_KEY_UP: __webpack_require__(1318),
                COMBO_MATCH: __webpack_require__(1319),
                DOWN: __webpack_require__(1320),
                KEY_DOWN: __webpack_require__(1321),
                KEY_UP: __webpack_require__(1322),
                UP: __webpack_require__(1323)
            };
        /***/ },
        /* 153 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given a File and a baseURL value this returns the URL the File will use to download from.
 *
 * @function Phaser.Loader.GetURL
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File object.
 * @param {string} baseURL - A default base URL.
 *
 * @return {string} The URL the File will use.
 */ var GetURL = function(file, baseURL) {
                if (!file.url) return false;
                if (file.url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)) return file.url;
                else return baseURL + file.url;
            };
            module1.exports = GetURL;
        /***/ },
        /* 154 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates an XHRSettings Object with default values.
 *
 * @function Phaser.Loader.XHRSettings
 * @since 3.0.0
 *
 * @param {XMLHttpRequestResponseType} [responseType=''] - The responseType, such as 'text'.
 * @param {boolean} [async=true] - Should the XHR request use async or not?
 * @param {string} [user=''] - Optional username for the XHR request.
 * @param {string} [password=''] - Optional password for the XHR request.
 * @param {number} [timeout=0] - Optional XHR timeout value.
 * @param {boolean} [withCredentials=false] - Optional XHR withCredentials value.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} The XHRSettings object as used by the Loader.
 */ var XHRSettings = function(responseType, async, user, password, timeout, withCredentials) {
                if (responseType === undefined) responseType = '';
                if (async === undefined) async = true;
                if (user === undefined) user = '';
                if (password === undefined) password = '';
                if (timeout === undefined) timeout = 0;
                if (withCredentials === undefined) withCredentials = false;
                // Before sending a request, set the xhr.responseType to "text",
                // "arraybuffer", "blob", or "document", depending on your data needs.
                // Note, setting xhr.responseType = '' (or omitting) will default the response to "text".
                return {
                    //  Ignored by the Loader, only used by File.
                    responseType: responseType,
                    async: async,
                    //  credentials
                    user: user,
                    password: password,
                    //  timeout in ms (0 = no timeout)
                    timeout: timeout,
                    //  setRequestHeader
                    headers: undefined,
                    header: undefined,
                    headerValue: undefined,
                    requestedWith: false,
                    //  overrideMimeType
                    overrideMimeType: undefined,
                    //  withCredentials
                    withCredentials: withCredentials
                };
            };
            module1.exports = XHRSettings;
        /***/ },
        /* 155 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(240);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * An Arcade Physics Sprite is a Sprite with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Sprite and an Arcade Image is that you cannot animate an Arcade Image.
 * If you do not require animation then you can safely use Arcade Images instead of Arcade Sprites.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeSprite = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.Acceleration,
                    Components.Angular,
                    Components.Bounce,
                    Components.Debug,
                    Components.Drag,
                    Components.Enable,
                    Components.Friction,
                    Components.Gravity,
                    Components.Immovable,
                    Components.Mass,
                    Components.Pushable,
                    Components.Size,
                    Components.Velocity
                ],
                initialize: function ArcadeSprite(scene, x, y, texture, frame) {
                    Sprite.call(this, scene, x, y, texture, frame);
                    /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Sprite#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                }
            });
            module1.exports = ArcadeSprite;
        /***/ },
        /* 156 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(118);
            /**
 * Gets a tile at the given tile coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {boolean} nonNull - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAt = function(tileX, tileY, nonNull, layer) {
                if (nonNull === undefined) nonNull = false;
                if (IsInLayerBounds(tileX, tileY, layer)) {
                    var tile = layer.data[tileY][tileX] || null;
                    if (!tile) return null;
                    else if (tile.index === -1) return nonNull ? tile : null;
                    else return tile;
                } else return null;
            };
            module1.exports = GetTileAt;
        /***/ },
        /* 157 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.RunCull
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {object} bounds - An object containing the `left`, `right`, `top` and `bottom` bounds.
 * @param {number} renderOrder - The rendering order constant.
 * @param {array} outputArray - The array to store the Tile objects within.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var RunCull = function(layer, bounds, renderOrder, outputArray) {
                var mapData = layer.data;
                var mapWidth = layer.width;
                var mapHeight = layer.height;
                var tilemapLayer = layer.tilemapLayer;
                var drawLeft = Math.max(0, bounds.left);
                var drawRight = Math.min(mapWidth, bounds.right);
                var drawTop = Math.max(0, bounds.top);
                var drawBottom = Math.min(mapHeight, bounds.bottom);
                var x;
                var y;
                var tile;
                if (renderOrder === 0) {
                    //  right-down
                    for(y = drawTop; y < drawBottom; y++)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 1) {
                    //  left-down
                    for(y = drawTop; y < drawBottom; y++)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 2) {
                    //  right-up
                    for(y = drawBottom; y >= drawTop; y--)for(x = drawLeft; mapData[y] && x < drawRight; x++){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                } else if (renderOrder === 3) {
                    //  left-up
                    for(y = drawBottom; y >= drawTop; y--)for(x = drawRight; mapData[y] && x >= drawLeft; x--){
                        tile = mapData[y][x];
                        if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                        outputArray.push(tile);
                    }
                }
                tilemapLayer.tilesDrawn = outputArray.length;
                tilemapLayer.tilesTotal = mapWidth * mapHeight;
                return outputArray;
            };
            module1.exports = RunCull;
        /***/ },
        /* 158 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internally used method to keep track of the tile indexes that collide within a layer. This
 * updates LayerData.collideIndexes to either contain or not contain the given `tileIndex`.
 *
 * @function Phaser.Tilemaps.Components.SetLayerCollisionIndex
 * @since 3.0.0
 *
 * @param {number} tileIndex - The tile index to set the collision boolean for.
 * @param {boolean} collides - Should the tile index collide or not?
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetLayerCollisionIndex = function(tileIndex, collides, layer) {
                var loc = layer.collideIndexes.indexOf(tileIndex);
                if (collides && loc === -1) layer.collideIndexes.push(tileIndex);
                else if (!collides && loc !== -1) layer.collideIndexes.splice(loc, 1);
            };
            module1.exports = SetLayerCollisionIndex;
        /***/ },
        /* 159 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Seth Berrier <berriers@uwstout.edu>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parse a Tiled group layer and create a state object for inheriting.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.CreateGroupLayer
 * @since 3.21.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {object} [currentl] - The current group layer from the Tiled JSON file.
 * @param {object} [parentstate] - The state of the parent group (if any).
 *
 * @return {object} A group state object with proper values for updating children layers.
 */ var CreateGroupLayer = function(json, groupl, parentstate) {
                if (!groupl) // Return a default group state object
                return {
                    i: 0,
                    layers: json.layers,
                    // Values inherited from parent group
                    name: '',
                    opacity: 1,
                    visible: true,
                    x: 0,
                    y: 0
                };
                // Compute group layer x, y
                var layerX = groupl.x + GetFastValue(groupl, 'startx', 0) * json.tilewidth + GetFastValue(groupl, 'offsetx', 0);
                var layerY = groupl.y + GetFastValue(groupl, 'starty', 0) * json.tileheight + GetFastValue(groupl, 'offsety', 0);
                // Compute next state inherited from group
                return {
                    i: 0,
                    layers: groupl.layers,
                    name: parentstate.name + groupl.name + '/',
                    opacity: parentstate.opacity * groupl.opacity,
                    visible: parentstate.visible && groupl.visible,
                    x: parentstate.x + layerX,
                    y: parentstate.y + layerY
                };
            };
            module1.exports = CreateGroupLayer;
        /***/ },
        /* 160 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function used by the Tween Builder to create a function that will return
 * the given value from the source.
 *
 * @function Phaser.Tweens.Builders.GetNewValue
 * @since 3.0.0
 *
 * @param {any} source - The source object to get the value from.
 * @param {string} key - The property to get from the source.
 * @param {any} defaultValue - A default value to return should the source not have the property set.
 *
 * @return {function} A function which when called will return the property value from the source.
 */ var GetNewValue = function(source, key, defaultValue) {
                var valueCallback;
                if (source.hasOwnProperty(key)) {
                    var t = typeof source[key];
                    if (t === 'function') valueCallback = function(target, targetKey, value, targetIndex, totalTargets, tween) {
                        return source[key](target, targetKey, value, targetIndex, totalTargets, tween);
                    };
                    else valueCallback = function() {
                        return source[key];
                    };
                } else if (typeof defaultValue === 'function') valueCallback = defaultValue;
                else valueCallback = function() {
                    return defaultValue;
                };
                return valueCallback;
            };
            module1.exports = GetNewValue;
        /***/ },
        /* 161 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Defaults = __webpack_require__(261);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(96);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(160);
            var GetProps = __webpack_require__(579);
            var GetTargets = __webpack_require__(259);
            var GetValue = __webpack_require__(6);
            var GetValueOp = __webpack_require__(260);
            var Tween = __webpack_require__(262);
            var TweenData = __webpack_require__(264);
            /**
 * Creates a new Tween.
 *
 * @function Phaser.Tweens.Builders.TweenBuilder
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var TweenBuilder = function(parent, config, defaults) {
                if (defaults === undefined) defaults = Defaults;
                //  Create arrays of the Targets and the Properties
                var targets = defaults.targets ? defaults.targets : GetTargets(config);
                // var props = (defaults.props) ? defaults.props : GetProps(config);
                var props = GetProps(config);
                //  Default Tween values
                var delay = GetNewValue(config, 'delay', defaults.delay);
                var duration = GetNewValue(config, 'duration', defaults.duration);
                var easeParams = GetValue(config, 'easeParams', defaults.easeParams);
                var ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), easeParams);
                var hold = GetNewValue(config, 'hold', defaults.hold);
                var repeat = GetNewValue(config, 'repeat', defaults.repeat);
                var repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
                var yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
                var flipX = GetBoolean(config, 'flipX', defaults.flipX);
                var flipY = GetBoolean(config, 'flipY', defaults.flipY);
                var data = [];
                //  Loop through every property defined in the Tween, i.e.: props { x, y, alpha }
                for(var p = 0; p < props.length; p++){
                    var key = props[p].key;
                    var value = props[p].value;
                    //  Create 1 TweenData per target, per property
                    for(var t = 0; t < targets.length; t++){
                        var ops = GetValueOp(key, value);
                        var tweenData = TweenData(targets[t], t, key, ops.getEnd, ops.getStart, ops.getActive, GetEaseFunction(GetValue(value, 'ease', ease), GetValue(value, 'easeParams', easeParams)), GetNewValue(value, 'delay', delay), GetNewValue(value, 'duration', duration), GetBoolean(value, 'yoyo', yoyo), GetNewValue(value, 'hold', hold), GetNewValue(value, 'repeat', repeat), GetNewValue(value, 'repeatDelay', repeatDelay), GetBoolean(value, 'flipX', flipX), GetBoolean(value, 'flipY', flipY));
                        data.push(tweenData);
                    }
                }
                var tween = new Tween(parent, data, targets);
                tween.offset = GetAdvancedValue(config, 'offset', null);
                tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
                tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
                tween.paused = GetBoolean(config, 'paused', false);
                tween.useFrames = GetBoolean(config, 'useFrames', false);
                //  Set the Callbacks
                var scope = GetValue(config, 'callbackScope', tween);
                //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
                var tweenArray = [
                    tween,
                    null
                ];
                var callbacks = Tween.TYPES;
                for(var i = 0; i < callbacks.length; i++){
                    var type = callbacks[i];
                    var callback = GetValue(config, type, false);
                    if (callback) {
                        var callbackScope = GetValue(config, type + 'Scope', scope);
                        var callbackParams = GetValue(config, type + 'Params', []);
                        //  The null is reset to be the Tween target
                        tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
                    }
                }
                return tween;
            };
            module1.exports = TweenBuilder;
        /***/ },
        /* 162 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(99);
            var GetFastValue = __webpack_require__(2);
            var Events = __webpack_require__(130);
            var Animation = __webpack_require__(182);
            /**
 * @classdesc
 * The Animation State Component.
 *
 * This component provides features to apply animations to Game Objects. It is responsible for
 * loading, queuing animations for later playback, mixing between animations and setting
 * the current animation frame to the Game Object that owns this component.
 *
 * This component lives as an instance within any Game Object that has it defined, such as Sprites.
 *
 * You can access its properties and methods via the `anims` property, i.e. `Sprite.anims`.
 *
 * As well as playing animations stored in the global Animation Manager, this component
 * can also create animations that are stored locally within it. See the `create` method
 * for more details.
 *
 * Prior to Phaser 3.50 this component was called just `Animation` and lived in the
 * `Phaser.GameObjects.Components` namespace. It was renamed to `AnimationState`
 * in 3.50 to help better identify its true purpose when browsing the documentation.
 *
 * @class AnimationState
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} parent - The Game Object to which this animation component belongs.
 */ var AnimationState = new Class({
                initialize: function AnimationState(parent) {
                    /**
         * The Game Object to which this animation component belongs.
         *
         * You can typically access this component from the Game Object
         * via the `this.anims` property.
         *
         * @name Phaser.Animations.AnimationState#parent
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.AnimationState#animationManager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.animationManager = parent.scene.sys.anims;
                    this.animationManager.on(Events.REMOVE_ANIMATION, this.globalRemove, this);
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationState#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.50.0
         */ this.textureManager = this.animationManager.textureManager;
                    /**
         * The Animations stored locally in this Animation component.
         *
         * Do not modify the contents of this Map directly, instead use the
         * `add`, `create` and `remove` methods of this class instead.
         *
         * @name Phaser.Animations.AnimationState#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.50.0
         */ this.anims = null;
                    /**
         * Is an animation currently playing or not?
         *
         * @name Phaser.Animations.AnimationState#isPlaying
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPlaying = false;
                    /**
         * Has the current animation started playing, or is it waiting for a delay to expire?
         *
         * @name Phaser.Animations.AnimationState#hasStarted
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.hasStarted = false;
                    /**
         * The current Animation loaded into this Animation component.
         *
         * Will by `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentAnim
         * @type {?Phaser.Animations.Animation}
         * @default null
         * @since 3.0.0
         */ this.currentAnim = null;
                    /**
         * The current AnimationFrame being displayed by this Animation component.
         *
         * Will by `null` if no animation is yet loaded.
         *
         * @name Phaser.Animations.AnimationState#currentFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @since 3.0.0
         */ this.currentFrame = null;
                    /**
         * The key, instance, or config of the next Animation to be loaded into this Animation component
         * when the current animation completes.
         *
         * Will by `null` if no animation has been queued.
         *
         * @name Phaser.Animations.AnimationState#nextAnim
         * @type {?(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)}
         * @default null
         * @since 3.16.0
         */ this.nextAnim = null;
                    /**
         * A queue of Animations to be loaded into this Animation component when the current animation completes.
         *
         * Populate this queue via the `chain` method.
         *
         * @name Phaser.Animations.AnimationState#nextAnimsQueue
         * @type {array}
         * @since 3.24.0
         */ this.nextAnimsQueue = [];
                    /**
         * The Time Scale factor.
         *
         * You can adjust this value to modify the passage of time for the animation that is currently
         * playing. For example, setting it to 2 will make the animation play twice as fast. Or setting
         * it to 0.5 will slow the animation down.
         *
         * You can change this value at run-time, or set it via the `PlayAnimationConfig`.
         *
         * Prior to Phaser 3.50 this property was private and called `_timeScale`.
         *
         * @name Phaser.Animations.AnimationState#timeScale
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.timeScale = 1;
                    /**
         * The frame rate of playback, of the current animation, in frames per second.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the frame rate, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#frameRate
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameRate = 0;
                    /**
         * The duration of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the duration, provide a new value in the `PlayAnimationConfig` object.
         *
         * @name Phaser.Animations.AnimationState#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * The number of milliseconds per frame, not including frame specific modifiers that may be present in the
         * Animation data.
         *
         * This value is calculated when a new animation is loaded into this component and should
         * be treated as read-only. Changing it will not alter playback speed.
         *
         * @name Phaser.Animations.AnimationState#msPerFrame
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.msPerFrame = 0;
                    /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.AnimationState#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = true;
                    /**
         * The delay before starting playback of the current animation, in milliseconds.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the delay, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_delay`.
         *
         * @name Phaser.Animations.AnimationState#delay
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delay = 0;
                    /**
         * The number of times to repeat playback of the current animation.
         *
         * If -1, it means the animation will repeat forever.
         *
         * This value is set when a new animation is loaded into this component and should
         * be treated as read-only, as changing it once playback has started will not alter
         * the animation. To change the number of repeats, provide a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeat`.
         *
         * @name Phaser.Animations.AnimationState#repeat
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.repeat = 0;
                    /**
         * The number of milliseconds to wait before starting the repeat playback of the current animation.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the repeat delay by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_repeatDelay`.
         *
         * @name Phaser.Animations.AnimationState#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = 0;
                    /**
         * Should the current animation yoyo? An animation that yoyos will play in reverse, from the end
         * to the start, before then repeating or completing. An animation that does not yoyo will just
         * play from the start to the end.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * You can change the yoyo by providing a new value in the `PlayAnimationConfig` object.
         *
         * Prior to Phaser 3.50 this property was private and called `_yoyo`.
         *
         * @name Phaser.Animations.AnimationState#yoyo
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.yoyo = false;
                    /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * This will happen _after_ any delay that may have been set.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is currently delayed.
         *
         * @name Phaser.Animations.AnimationState#showOnStart
         * @type {boolean}
         * @since 3.50.0
         */ this.showOnStart = false;
                    /**
         * Should the GameObject's `visible` property be set to `false` when the animation completes?
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time, assuming the animation is still actively playing.
         *
         * @name Phaser.Animations.AnimationState#hideOnComplete
         * @type {boolean}
         * @since 3.50.0
         */ this.hideOnComplete = false;
                    /**
         * Is the playhead moving forwards (`true`) or in reverse (`false`) ?
         *
         * @name Phaser.Animations.AnimationState#forward
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.forward = true;
                    /**
         * An internal trigger that tells the component if it should plays the animation
         * in reverse mode ('true') or not ('false'). This is used because `forward` can
         * be changed by the `yoyo` feature.
         *
         * Prior to Phaser 3.50 this property was private and called `_reverse`.
         *
         * @name Phaser.Animations.AnimationState#inReverse
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.inReverse = false;
                    /**
         * Internal time overflow accumulator.
         *
         * This has the `delta` time added to it as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#accumulator
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accumulator = 0;
                    /**
         * The time point at which the next animation frame will change.
         *
         * This value is compared against the `accumulator` as part of the `update` step.
         *
         * @name Phaser.Animations.AnimationState#nextTick
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.nextTick = 0;
                    /**
         * A counter keeping track of how much delay time, in milliseconds, is left before playback begins.
         *
         * This is set via the `playAfterDelay` method, although it can be modified at run-time
         * if required, as long as the animation has not already started playing.
         *
         * @name Phaser.Animations.AnimationState#delayCounter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.delayCounter = 0;
                    /**
         * A counter that keeps track of how many repeats are left to run.
         *
         * This value is set when a new animation is loaded into this component, but can also be modified
         * at run-time.
         *
         * @name Phaser.Animations.AnimationState#repeatCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCounter = 0;
                    /**
         * An internal flag keeping track of pending repeats.
         *
         * @name Phaser.Animations.AnimationState#pendingRepeat
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pendingRepeat = false;
                    /**
         * Is the Animation paused?
         *
         * @name Phaser.Animations.AnimationState#_paused
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._paused = false;
                    /**
         * Was the animation previously playing before being paused?
         *
         * @name Phaser.Animations.AnimationState#_wasPlaying
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._wasPlaying = false;
                    /**
         * Internal property tracking if this Animation is waiting to stop.
         *
         * 0 = No
         * 1 = Waiting for ms to pass
         * 2 = Waiting for repeat
         * 3 = Waiting for specific frame
         *
         * @name Phaser.Animations.AnimationState#_pendingStop
         * @type {number}
         * @private
         * @since 3.4.0
         */ this._pendingStop = 0;
                    /**
         * Internal property used by _pendingStop.
         *
         * @name Phaser.Animations.AnimationState#_pendingStopValue
         * @type {any}
         * @private
         * @since 3.4.0
         */ this._pendingStopValue;
                },
                /**
     * Sets an animation, or an array of animations, to be played in the future, after the current one completes or stops.
     *
     * The current animation must enter a 'completed' state for this to happen, i.e. finish all of its repeats, delays, etc,
     * or have one of the `stop` methods called.
     *
     * An animation set to repeat forever will never enter a completed state unless stopped.
     *
     * You can chain a new animation at any point, including before the current one starts playing, during it, or when it ends (via its `animationcomplete` event).
     *
     * Chained animations are specific to a Game Object, meaning different Game Objects can have different chained animations without impacting the global animation they're playing.
     *
     * Call this method with no arguments to reset all currently chained animations.
     *
     * @method Phaser.Animations.AnimationState#chain
     * @since 3.16.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig|string[]|Phaser.Animations.Animation[]|Phaser.Types.Animations.PlayAnimationConfig[])} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ chain: function(key) {
                    var parent = this.parent;
                    if (key === undefined) {
                        this.nextAnimsQueue.length = 0;
                        this.nextAnim = null;
                        return parent;
                    }
                    if (!Array.isArray(key)) key = [
                        key
                    ];
                    for(var i = 0; i < key.length; i++){
                        var anim = key[i];
                        if (this.nextAnim === null) this.nextAnim = anim;
                        else this.nextAnimsQueue.push(anim);
                    }
                    return this.parent;
                },
                /**
     * Returns the key of the animation currently loaded into this component.
     *
     * Prior to Phaser 3.50 this method was called `getCurrentKey`.
     *
     * @method Phaser.Animations.AnimationState#getName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation currently loaded into this component, or an empty string if none loaded.
     */ getName: function() {
                    return this.currentAnim ? this.currentAnim.key : '';
                },
                /**
     * Returns the key of the animation frame currently displayed by this component.
     *
     * @method Phaser.Animations.AnimationState#getFrameName
     * @since 3.50.0
     *
     * @return {string} The key of the Animation Frame currently displayed by this component, or an empty string if no animation has been loaded.
     */ getFrameName: function() {
                    return this.currentFrame ? this.currentFrame.textureFrame : '';
                },
                /**
     * Internal method used to load an animation into this component.
     *
     * @method Phaser.Animations.AnimationState#load
     * @protected
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ load: function(key) {
                    if (this.isPlaying) this.stop();
                    var manager = this.animationManager;
                    var animKey = typeof key === 'string' ? key : GetFastValue(key, 'key', null);
                    //  Get the animation, first from the local map and, if not found, from the Animation Manager
                    var anim = this.exists(animKey) ? this.get(animKey) : manager.get(animKey);
                    if (!anim) console.warn('Missing animation: ' + animKey);
                    else {
                        this.currentAnim = anim;
                        //  And now override the animation values, if set in the config.
                        var totalFrames = anim.getTotalFrames();
                        var frameRate = GetFastValue(key, 'frameRate', anim.frameRate);
                        var duration = GetFastValue(key, 'duration', anim.duration);
                        anim.calculateDuration(this, totalFrames, duration, frameRate);
                        this.delay = GetFastValue(key, 'delay', anim.delay);
                        this.repeat = GetFastValue(key, 'repeat', anim.repeat);
                        this.repeatDelay = GetFastValue(key, 'repeatDelay', anim.repeatDelay);
                        this.yoyo = GetFastValue(key, 'yoyo', anim.yoyo);
                        this.showOnStart = GetFastValue(key, 'showOnStart', anim.showOnStart);
                        this.hideOnComplete = GetFastValue(key, 'hideOnComplete', anim.hideOnComplete);
                        this.skipMissedFrames = GetFastValue(key, 'skipMissedFrames', anim.skipMissedFrames);
                        this.timeScale = GetFastValue(key, 'timeScale', this.timeScale);
                        var startFrame = GetFastValue(key, 'startFrame', 0);
                        if (startFrame > anim.getTotalFrames()) startFrame = 0;
                        var frame = anim.frames[startFrame];
                        if (startFrame === 0 && !this.forward) frame = anim.getLastFrame();
                        this.currentFrame = frame;
                    }
                    return this.parent;
                },
                /**
     * Pause the current animation and set the `isPlaying` property to `false`.
     * You can optionally pause it at a specific frame.
     *
     * @method Phaser.Animations.AnimationState#pause
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [atFrame] - An optional frame to set after pausing the animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ pause: function(atFrame) {
                    if (!this._paused) {
                        this._paused = true;
                        this._wasPlaying = this.isPlaying;
                        this.isPlaying = false;
                    }
                    if (atFrame !== undefined) this.setCurrentFrame(atFrame);
                    return this.parent;
                },
                /**
     * Resumes playback of a paused animation and sets the `isPlaying` property to `true`.
     * You can optionally tell it to start playback from a specific frame.
     *
     * @method Phaser.Animations.AnimationState#resume
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} [fromFrame] - An optional frame to set before restarting playback.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ resume: function(fromFrame) {
                    if (this._paused) {
                        this._paused = false;
                        this.isPlaying = this._wasPlaying;
                    }
                    if (fromFrame !== undefined) this.setCurrentFrame(fromFrame);
                    return this.parent;
                },
                /**
     * Waits for the specified delay, in milliseconds, then starts playback of the given animation.
     *
     * If the animation _also_ has a delay value set in its config, it will be **added** to the delay given here.
     *
     * If an animation is already running and a new animation is given to this method, it will wait for
     * the given delay before starting the new animation.
     *
     * If no animation is currently running, the given one begins after the delay.
     *
     * Prior to Phaser 3.50 this method was called 'delayedPlay' and the parameters were in the reverse order.
     *
     * @method Phaser.Animations.AnimationState#playAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} delay - The delay, in milliseconds, to wait before starting the animation playing.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterDelay: function(key, delay) {
                    if (!this.isPlaying) {
                        this.delayCounter = delay;
                        this.play(key, true);
                    } else {
                        //  If we've got a nextAnim, move it to the queue
                        var nextAnim = this.nextAnim;
                        var queue = this.nextAnimsQueue;
                        if (nextAnim) queue.unshift(nextAnim);
                        this.nextAnim = key;
                        this._pendingStop = 1;
                        this._pendingStopValue = delay;
                    }
                    return this.parent;
                },
                /**
     * Waits for the current animation to complete the `repeatCount` number of repeat cycles, then starts playback
     * of the given animation.
     *
     * You can use this to ensure there are no harsh jumps between two sets of animations, i.e. going from an
     * idle animation to a walking animation, by making them blend smoothly into each other.
     *
     * If no animation is currently running, the given one will start immediately.
     *
     * @method Phaser.Animations.AnimationState#playAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {number} [repeatCount=1] - How many times should the animation repeat before the next one starts?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playAfterRepeat: function(key, repeatCount) {
                    if (repeatCount === undefined) repeatCount = 1;
                    if (!this.isPlaying) this.play(key);
                    else {
                        //  If we've got a nextAnim, move it to the queue
                        var nextAnim = this.nextAnim;
                        var queue = this.nextAnimsQueue;
                        if (nextAnim) queue.unshift(nextAnim);
                        if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                        this.nextAnim = key;
                        this._pendingStop = 2;
                        this._pendingStopValue = repeatCount;
                    }
                    return this.parent;
                },
                /**
     * Start playing the given animation on this Sprite.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).play('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).play({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#play
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If this animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ play: function(key, ignoreIfPlaying) {
                    if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                    var currentAnim = this.currentAnim;
                    var parent = this.parent;
                    //  Must be either an Animation instance, or a PlayAnimationConfig object
                    var animKey = typeof key === 'string' ? key : key.key;
                    if (ignoreIfPlaying && this.isPlaying && currentAnim.key === animKey) return parent;
                    //  Are we mixing?
                    if (currentAnim && this.isPlaying) {
                        var mix = this.animationManager.getMix(currentAnim.key, key);
                        if (mix > 0) return this.playAfterDelay(key, mix);
                    }
                    this.forward = true;
                    this.inReverse = false;
                    this._paused = false;
                    this._wasPlaying = true;
                    return this.startAnimation(key);
                },
                /**
     * Start playing the given animation on this Sprite, in reverse.
     *
     * Animations in Phaser can either belong to the global Animation Manager, or specifically to this Sprite.
     *
     * The benefit of a global animation is that multiple Sprites can all play the same animation, without
     * having to duplicate the data. You can just create it once and then play it on any Sprite.
     *
     * The following code shows how to create a global repeating animation. The animation will be created
     * from all of the frames within the sprite sheet that was loaded with the key 'muybridge':
     *
     * ```javascript
     * var config = {
     *     key: 'run',
     *     frames: 'muybridge',
     *     frameRate: 15,
     *     repeat: -1
     * };
     *
     * //  This code should be run from within a Scene:
     * this.anims.create(config);
     * ```
     *
     * However, if you wish to create an animation that is unique to this Sprite, and this Sprite alone,
     * you can call the `Animation.create` method instead. It accepts the exact same parameters as when
     * creating a global animation, however the resulting data is kept locally in this Sprite.
     *
     * With the animation created, either globally or locally, you can now play it on this Sprite:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse('run');
     * ```
     *
     * Alternatively, if you wish to run it at a different frame rate, for example, you can pass a config
     * object instead:
     *
     * ```javascript
     * this.add.sprite(x, y).playReverse({ key: 'run', frameRate: 24 });
     * ```
     *
     * When playing an animation on a Sprite it will first check to see if it can find a matching key
     * locally within the Sprite. If it can, it will play the local animation. If not, it will then
     * search the global Animation Manager and look for it there.
     *
     * If you need a Sprite to be able to play both local and global animations, make sure they don't
     * have conflicting keys.
     *
     * See the documentation for the `PlayAnimationConfig` config object for more details about this.
     *
     * Also, see the documentation in the Animation Manager for further details on creating animations.
     *
     * @method Phaser.Animations.AnimationState#playReverse
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.12.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ playReverse: function(key, ignoreIfPlaying) {
                    if (ignoreIfPlaying === undefined) ignoreIfPlaying = false;
                    //  Must be either an Animation instance, or a PlayAnimationConfig object
                    var animKey = typeof key === 'string' ? key : key.key;
                    if (ignoreIfPlaying && this.isPlaying && this.currentAnim.key === animKey) return this.parent;
                    this.forward = false;
                    this.inReverse = true;
                    this._paused = false;
                    this._wasPlaying = true;
                    return this.startAnimation(key);
                },
                /**
     * Load the animation based on the key and set-up all of the internal values
     * needed for playback to start. If there is no delay, it will also fire the start events.
     *
     * @method Phaser.Animations.AnimationState#startAnimation
     * @fires Phaser.Animations.Events#ANIMATION_START
     * @since 3.50.0
     *
     * @param {(string|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or a `PlayAnimationConfig` object.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ startAnimation: function(key) {
                    this.load(key);
                    var anim = this.currentAnim;
                    var gameObject = this.parent;
                    if (!anim) return gameObject;
                    //  Should give us 9,007,199,254,740,991 safe repeats
                    this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                    anim.getFirstTick(this);
                    this.isPlaying = true;
                    this.pendingRepeat = false;
                    this.hasStarted = false;
                    this._pendingStop = 0;
                    this._pendingStopValue = 0;
                    this._paused = false;
                    //  Add any delay the animation itself may have had as well
                    this.delayCounter += this.delay;
                    if (this.delayCounter === 0) this.handleStart();
                    return gameObject;
                },
                /**
     * Handles the start of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStart
     * @private
     * @since 3.50.0
     */ handleStart: function() {
                    if (this.showOnStart) this.parent.setVisible(true);
                    this.setCurrentFrame(this.currentFrame);
                    this.hasStarted = true;
                    this.emitEvents(Events.ANIMATION_START);
                },
                /**
     * Handles the repeat of an animation.
     *
     * @method Phaser.Animations.AnimationState#handleRepeat
     * @private
     * @since 3.50.0
     */ handleRepeat: function() {
                    this.pendingRepeat = false;
                    this.emitEvents(Events.ANIMATION_REPEAT);
                },
                /**
     * Handles the stop of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleStop
     * @private
     * @since 3.50.0
     */ handleStop: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    this.emitEvents(Events.ANIMATION_STOP);
                },
                /**
     * Handles the completion of an animation playback.
     *
     * @method Phaser.Animations.AnimationState#handleComplete
     * @private
     * @since 3.50.0
     */ handleComplete: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.hideOnComplete) this.parent.setVisible(false);
                    this.emitEvents(Events.ANIMATION_COMPLETE, Events.ANIMATION_COMPLETE_KEY);
                },
                /**
     * Fires the given animation event.
     *
     * @method Phaser.Animations.AnimationState#emitEvents
     * @private
     * @since 3.50.0
     *
     * @param {string} event - The Animation Event to dispatch.
     */ emitEvents: function(event, keyEvent) {
                    var anim = this.currentAnim;
                    var frame = this.currentFrame;
                    var gameObject = this.parent;
                    var frameKey = frame.textureFrame;
                    gameObject.emit(event, anim, frame, gameObject, frameKey);
                    if (keyEvent) gameObject.emit(keyEvent + anim.key, anim, frame, gameObject, frameKey);
                },
                /**
     * Reverse the Animation that is already playing on the Game Object.
     *
     * @method Phaser.Animations.AnimationState#reverse
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ reverse: function() {
                    if (this.isPlaying) {
                        this.inReverse = !this.inReverse;
                        this.forward = !this.forward;
                    }
                    return this.parent;
                },
                /**
     * Returns a value between 0 and 1 indicating how far this animation is through, ignoring repeats and yoyos.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#getProgress
     * @since 3.4.0
     *
     * @return {number} The progress of the current animation in frames, between 0 and 1.
     */ getProgress: function() {
                    var frame = this.currentFrame;
                    if (!frame) return 0;
                    var p = frame.progress;
                    if (this.inReverse) p *= -1;
                    return p;
                },
                /**
     * Takes a value between 0 and 1 and uses it to set how far this animation is through playback.
     *
     * Does not factor in repeats or yoyos, but does handle playing forwards or backwards.
     *
     * The value is based on the current frame and how far that is in the animation, it is not based on
     * the duration of the animation.
     *
     * @method Phaser.Animations.AnimationState#setProgress
     * @since 3.4.0
     *
     * @param {number} [value=0] - The progress value, between 0 and 1.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setProgress: function(value) {
                    if (!this.forward) value = 1 - value;
                    this.setCurrentFrame(this.currentAnim.getFrameByProgress(value));
                    return this.parent;
                },
                /**
     * Sets the number of times that the animation should repeat after its first play through.
     * For example, if repeat is 1, the animation will play a total of twice: the initial play plus 1 repeat.
     *
     * To repeat indefinitely, use -1.
     * The value should always be an integer.
     *
     * Calling this method only works if the animation is already running. Otherwise, any
     * value specified here will be overwritten when the next animation loads in. To avoid this,
     * use the `repeat` property of the `PlayAnimationConfig` object instead.
     *
     * @method Phaser.Animations.AnimationState#setRepeat
     * @since 3.4.0
     *
     * @param {number} value - The number of times that the animation should repeat.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ setRepeat: function(value) {
                    this.repeatCounter = value === -1 ? Number.MAX_VALUE : value;
                    return this.parent;
                },
                /**
     * Handle the removal of an animation from the Animation Manager.
     *
     * @method Phaser.Animations.AnimationState#globalRemove
     * @since 3.50.0
     *
     * @param {string} [key] - The key of the removed Animation.
     * @param {Phaser.Animations.Animation} [animation] - The removed Animation.
     */ globalRemove: function(key, animation) {
                    if (animation === undefined) animation = this.currentAnim;
                    if (this.isPlaying && animation.key === this.currentAnim.key) {
                        this.stop();
                        this.setCurrentFrame(this.currentAnim.frames[0]);
                    }
                },
                /**
     * Restarts the current animation from its beginning.
     *
     * You can optionally reset the delay and repeat counters as well.
     *
     * Calling this will fire the `ANIMATION_RESTART` event immediately.
     *
     * If you `includeDelay` then it will also fire the `ANIMATION_START` event once
     * the delay has expired, otherwise, playback will just begin immediately.
     *
     * @method Phaser.Animations.AnimationState#restart
     * @fires Phaser.Animations.Events#ANIMATION_RESTART
     * @since 3.0.0
     *
     * @param {boolean} [includeDelay=false] - Whether to include the delay value of the animation when restarting.
     * @param {boolean} [resetRepeats=false] - Whether to reset the repeat counter or not?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ restart: function(includeDelay, resetRepeats) {
                    if (includeDelay === undefined) includeDelay = false;
                    if (resetRepeats === undefined) resetRepeats = false;
                    var anim = this.currentAnim;
                    var gameObject = this.parent;
                    if (!anim) return gameObject;
                    if (resetRepeats) this.repeatCounter = this.repeat === -1 ? Number.MAX_VALUE : this.repeat;
                    anim.getFirstTick(this);
                    this.emitEvents(Events.ANIMATION_RESTART);
                    this.isPlaying = true;
                    this.pendingRepeat = false;
                    //  Set this to `true` if there is no delay to include, so it skips the `hasStarted` check in `update`.
                    this.hasStarted = !includeDelay;
                    this._pendingStop = 0;
                    this._pendingStopValue = 0;
                    this._paused = false;
                    this.setCurrentFrame(anim.frames[0]);
                    return this.parent;
                },
                /**
     * The current animation has completed. This dispatches the `ANIMATION_COMPLETE` event.
     *
     * This method is called by the Animation instance and should not usually be invoked directly.
     *
     * If no animation is loaded, no events will be dispatched.
     *
     * If another animation has been queued for playback, it will be started after the events fire.
     *
     * @method Phaser.Animations.AnimationState#complete
     * @fires Phaser.Animations.Events#ANIMATION_COMPLETE
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ complete: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.currentAnim) this.handleComplete();
                    if (this.nextAnim) {
                        var key = this.nextAnim;
                        this.nextAnim = this.nextAnimsQueue.length > 0 ? this.nextAnimsQueue.shift() : null;
                        this.play(key);
                    }
                    return this.parent;
                },
                /**
     * Immediately stops the current animation from playing and dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing.
     *
     * @method Phaser.Animations.AnimationState#stop
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stop: function() {
                    this._pendingStop = 0;
                    this.isPlaying = false;
                    if (this.currentAnim) this.handleStop();
                    if (this.nextAnim) {
                        var key = this.nextAnim;
                        this.nextAnim = this.nextAnimsQueue.shift();
                        this.play(key);
                    }
                    return this.parent;
                },
                /**
     * Stops the current animation from playing after the specified time delay, given in milliseconds.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopAfterDelay
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {number} delay - The number of milliseconds to wait before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterDelay: function(delay) {
                    this._pendingStop = 1;
                    this._pendingStopValue = delay;
                    return this.parent;
                },
                /**
     * Stops the current animation from playing when it next repeats.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * Prior to Phaser 3.50 this method was called `stopOnRepeat` and had no parameters.
     *
     * @method Phaser.Animations.AnimationState#stopAfterRepeat
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.50.0
     *
     * @param {number} [repeatCount=1] - How many times should the animation repeat before stopping?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopAfterRepeat: function(repeatCount) {
                    if (repeatCount === undefined) repeatCount = 1;
                    if (this.repeatCounter !== -1 && repeatCount > this.repeatCounter) repeatCount = this.repeatCounter;
                    this._pendingStop = 2;
                    this._pendingStopValue = repeatCount;
                    return this.parent;
                },
                /**
     * Stops the current animation from playing when it next sets the given frame.
     * If this frame doesn't exist within the animation it will not stop it from playing.
     *
     * It then dispatches the `ANIMATION_STOP` event.
     *
     * If no animation is running, no events will be dispatched.
     *
     * If there is another animation in the queue (set via the `chain` method) then it will start playing,
     * when the current one stops.
     *
     * @method Phaser.Animations.AnimationState#stopOnFrame
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The frame to check before stopping this animation.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
     */ stopOnFrame: function(frame) {
                    this._pendingStop = 3;
                    this._pendingStopValue = frame;
                    return this.parent;
                },
                /**
     * Returns the total number of frames in this animation, or returns zero if no
     * animation has been loaded.
     *
     * @method Phaser.Animations.AnimationState#getTotalFrames
     * @since 3.4.0
     *
     * @return {number} The total number of frames in the current animation, or zero if no animation has been loaded.
     */ getTotalFrames: function() {
                    return this.currentAnim ? this.currentAnim.getTotalFrames() : 0;
                },
                /**
     * The internal update loop for the AnimationState Component.
     *
     * This is called automatically by the `Sprite.preUpdate` method.
     *
     * @method Phaser.Animations.AnimationState#update
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    var anim = this.currentAnim;
                    if (!this.isPlaying || !anim || anim.paused) return;
                    this.accumulator += delta * this.timeScale;
                    if (this._pendingStop === 1) {
                        this._pendingStopValue -= delta;
                        if (this._pendingStopValue <= 0) return this.stop();
                    }
                    if (!this.hasStarted) {
                        if (this.accumulator >= this.delayCounter) {
                            this.accumulator -= this.delayCounter;
                            this.handleStart();
                        }
                    } else if (this.accumulator >= this.nextTick) {
                        //  Process one frame advance as standard
                        if (this.forward) anim.nextFrame(this);
                        else anim.previousFrame(this);
                        //  And only do more if we're skipping frames and have time left
                        if (this.isPlaying && this._pendingStop === 0 && this.skipMissedFrames && this.accumulator > this.nextTick) {
                            var safetyNet = 0;
                            do {
                                if (this.forward) anim.nextFrame(this);
                                else anim.previousFrame(this);
                                safetyNet++;
                            }while (this.accumulator > this.nextTick && safetyNet < 60);
                        }
                    }
                },
                /**
     * Sets the given Animation Frame as being the current frame
     * and applies it to the parent Game Object, adjusting size and origin as needed.
     *
     * @method Phaser.Animations.AnimationState#setCurrentFrame
     * @fires Phaser.Animations.Events#ANIMATION_UPDATE
     * @fires Phaser.Animations.Events#ANIMATION_STOP
     * @since 3.4.0
     *
     * @param {Phaser.Animations.AnimationFrame} animationFrame - The animation frame to change to.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ setCurrentFrame: function(animationFrame) {
                    var gameObject = this.parent;
                    this.currentFrame = animationFrame;
                    gameObject.texture = animationFrame.frame.texture;
                    gameObject.frame = animationFrame.frame;
                    if (gameObject.isCropped) gameObject.frame.updateCropUVs(gameObject._crop, gameObject.flipX, gameObject.flipY);
                    if (animationFrame.setAlpha) gameObject.alpha = animationFrame.alpha;
                    gameObject.setSizeToFrame();
                    if (gameObject._originComponent) {
                        if (animationFrame.frame.customPivot) gameObject.setOrigin(animationFrame.frame.pivotX, animationFrame.frame.pivotY);
                        else gameObject.updateDisplayOrigin();
                    }
                    if (this.isPlaying && this.hasStarted) {
                        this.emitEvents(Events.ANIMATION_UPDATE);
                        if (this._pendingStop === 3 && this._pendingStopValue === animationFrame) this.stop();
                    }
                    return gameObject;
                },
                /**
     * Advances the animation to the next frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in reverse, calling this method doesn't then change the direction to forwards.
     *
     * @method Phaser.Animations.AnimationState#nextFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ nextFrame: function() {
                    if (this.currentAnim) this.currentAnim.nextFrame(this);
                    return this.parent;
                },
                /**
     * Advances the animation to the previous frame, regardless of the time or animation state.
     * If the animation is set to repeat, or yoyo, this will still take effect.
     *
     * Calling this does not change the direction of the animation. I.e. if it was currently
     * playing in forwards, calling this method doesn't then change the direction to backwards.
     *
     * @method Phaser.Animations.AnimationState#previousFrame
     * @since 3.16.0
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
     */ previousFrame: function() {
                    if (this.currentAnim) this.currentAnim.previousFrame(this);
                    return this.parent;
                },
                /**
     * Get an Animation instance that has been created locally on this Sprite.
     *
     * See the `create` method for more details.
     *
     * @method Phaser.Animations.AnimationState#get
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation, or `null` if the key is invalid.
     */ get: function(key) {
                    return this.anims ? this.anims.get(key) : null;
                },
                /**
     * Checks to see if the given key is already used locally within the animations stored on this Sprite.
     *
     * @method Phaser.Animations.AnimationState#exists
     * @since 3.50.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation exists locally, or `false` if the key is available, or there are no local animations.
     */ exists: function(key) {
                    return this.anims ? this.anims.has(key) : false;
                },
                /**
     * Creates a new Animation that is local specifically to this Sprite.
     *
     * When a Sprite owns an animation, it is kept out of the global Animation Manager, which means
     * you're free to use keys that may be already defined there. Unless you specifically need a Sprite
     * to have a unique animation, you should favor using global animations instead, as they allow for
     * the same animation to be used across multiple Sprites, saving on memory. However, if this Sprite
     * is the only one to use this animation, it's sensible to create it here.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists locally, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use by this Sprite.
     *
     * If you wish to re-use an existing key, call the `remove` method first, then this method.
     *
     * @method Phaser.Animations.AnimationState#create
     * @since 3.50.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                    var key = config.key;
                    var anim = false;
                    if (key) {
                        anim = this.get(key);
                        if (!anim) {
                            anim = new Animation(this, key, config);
                            if (!this.anims) this.anims = new CustomMap();
                            this.anims.set(key, anim);
                        }
                    }
                    return anim;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to look for 6 frames, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNames
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                    return this.animationManager.generateFrameNames(key, config);
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 12 })`.
     *
     * The `end` value tells it to stop after 12 frames. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNames('explosion', {
     *     start: 0,
     *     end: 12
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationState#generateFrameNumbers
     * @since 3.50.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} config - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                    return this.animationManager.generateFrameNumbers(key, config);
                },
                /**
     * Removes a locally created Animation from this Sprite, based on the given key.
     *
     * Once an Animation has been removed, this Sprite cannot play it again without re-creating it.
     *
     * @method Phaser.Animations.AnimationState#remove
     * @since 3.50.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from this Sprite, if the key was valid.
     */ remove: function(key) {
                    var anim = this.get(key);
                    if (anim) {
                        if (this.currentAnim === anim) this.stop();
                        this.anims.delete(key);
                    }
                    return anim;
                },
                /**
     * Destroy this Animation component.
     *
     * Unregisters event listeners and cleans up its references.
     *
     * @method Phaser.Animations.AnimationState#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.animationManager.off(Events.REMOVE_ANIMATION, this.globalRemove, this);
                    if (this.anims) this.anims.clear();
                    this.animationManager = null;
                    this.parent = null;
                    this.nextAnim = null;
                    this.nextAnimsQueue.length = 0;
                    this.currentAnim = null;
                    this.currentFrame = null;
                },
                /**
     * `true` if the current animation is paused, otherwise `false`.
     *
     * @name Phaser.Animations.AnimationState#isPaused
     * @readonly
     * @type {boolean}
     * @since 3.4.0
     */ isPaused: {
                    get: function() {
                        return this._paused;
                    }
                }
            });
            module1.exports = AnimationState;
        /***/ },
        /* 163 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
* A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
* It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
* Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composite
*/ var Composite = {};
            module1.exports = Composite;
            var Events = __webpack_require__(268);
            var Common = __webpack_require__(50);
            var Bounds = __webpack_require__(117);
            var Body = __webpack_require__(71);
            (function() {
                /**
     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properites section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} [options]
     * @return {composite} A new composite
     */ Composite.create = function(options) {
                    return Common.extend({
                        id: Common.nextId(),
                        type: 'composite',
                        parent: null,
                        isModified: false,
                        bodies: [],
                        constraints: [],
                        composites: [],
                        label: 'Composite',
                        plugin: {}
                    }, options);
                };
                /**
     * Sets the composite's `isModified` flag. 
     * If `updateParents` is true, all parents will be set (default: false).
     * If `updateChildren` is true, all children will be set (default: false).
     * @method setModified
     * @param {composite} composite
     * @param {boolean} isModified
     * @param {boolean} [updateParents=false]
     * @param {boolean} [updateChildren=false]
     */ Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
                    Events.trigger(composite, 'compositeModified', composite);
                    composite.isModified = isModified;
                    if (updateParents && composite.parent) Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
                    if (updateChildren) for(var i = 0; i < composite.composites.length; i++){
                        var childComposite = composite.composites[i];
                        Composite.setModified(childComposite, isModified, updateParents, updateChildren);
                    }
                };
                /**
     * Generic add function. Adds one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
     * @method add
     * @param {composite} composite
     * @param {} object
     * @return {composite} The original composite with the objects added
     */ Composite.add = function(composite, object) {
                    var objects = [].concat(object);
                    Events.trigger(composite, 'beforeAdd', {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case 'body':
                                // skip adding compound parts
                                if (obj.parent !== obj) {
                                    Common.warn('Composite.add: skipped adding a compound body part (you must add its parent instead)');
                                    break;
                                }
                                Composite.addBody(composite, obj);
                                break;
                            case 'constraint':
                                Composite.addConstraint(composite, obj);
                                break;
                            case 'composite':
                                Composite.addComposite(composite, obj);
                                break;
                            case 'mouseConstraint':
                                Composite.addConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, 'afterAdd', {
                        object: object
                    });
                    return composite;
                };
                /**
     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Optionally searching its children recursively.
     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
     * @method remove
     * @param {composite} composite
     * @param {} object
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the objects removed
     */ Composite.remove = function(composite, object, deep) {
                    var objects = [].concat(object);
                    Events.trigger(composite, 'beforeRemove', {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case 'body':
                                Composite.removeBody(composite, obj, deep);
                                break;
                            case 'constraint':
                                Composite.removeConstraint(composite, obj, deep);
                                break;
                            case 'composite':
                                Composite.removeComposite(composite, obj, deep);
                                break;
                            case 'mouseConstraint':
                                Composite.removeConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, 'afterRemove', {
                        object: object
                    });
                    return composite;
                };
                /**
     * Adds a composite to the given composite.
     * @private
     * @method addComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @return {composite} The original compositeA with the objects from compositeB added
     */ Composite.addComposite = function(compositeA, compositeB) {
                    compositeA.composites.push(compositeB);
                    compositeB.parent = compositeA;
                    Composite.setModified(compositeA, true, true, false);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @param {boolean} [deep=false]
     * @return {composite} The original compositeA with the composite removed
     */ Composite.removeComposite = function(compositeA, compositeB, deep) {
                    var position = compositeA.composites.indexOf(compositeB);
                    if (position !== -1) {
                        Composite.removeCompositeAt(compositeA, position);
                        Composite.setModified(compositeA, true, true, false);
                    }
                    if (deep) for(var i = 0; i < compositeA.composites.length; i++)Composite.removeComposite(compositeA.composites[i], compositeB, true);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite.
     * @private
     * @method removeCompositeAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the composite removed
     */ Composite.removeCompositeAt = function(composite, position) {
                    composite.composites.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a body to the given composite.
     * @private
     * @method addBody
     * @param {composite} composite
     * @param {body} body
     * @return {composite} The original composite with the body added
     */ Composite.addBody = function(composite, body) {
                    composite.bodies.push(body);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a body from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeBody
     * @param {composite} composite
     * @param {body} body
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the body removed
     */ Composite.removeBody = function(composite, body, deep) {
                    var position = composite.bodies.indexOf(body);
                    if (position !== -1) {
                        Composite.removeBodyAt(composite, position);
                        Composite.setModified(composite, true, true, false);
                    }
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeBody(composite.composites[i], body, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeBodyAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the body removed
     */ Composite.removeBodyAt = function(composite, position) {
                    composite.bodies.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a constraint to the given composite.
     * @private
     * @method addConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @return {composite} The original composite with the constraint added
     */ Composite.addConstraint = function(composite, constraint) {
                    composite.constraints.push(constraint);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a constraint from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraint = function(composite, constraint, deep) {
                    var position = composite.constraints.indexOf(constraint);
                    if (position !== -1) Composite.removeConstraintAt(composite, position);
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeConstraint(composite.composites[i], constraint, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeConstraintAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraintAt = function(composite, position) {
                    composite.constraints.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes all bodies, constraints and composites from the given composite.
     * Optionally clearing its children recursively.
     * @method clear
     * @param {composite} composite
     * @param {boolean} keepStatic
     * @param {boolean} [deep=false]
     */ Composite.clear = function(composite, keepStatic, deep) {
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.clear(composite.composites[i], keepStatic, true);
                    if (keepStatic) composite.bodies = composite.bodies.filter(function(body) {
                        return body.isStatic;
                    });
                    else composite.bodies.length = 0;
                    composite.constraints.length = 0;
                    composite.composites.length = 0;
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns all bodies in the given composite, including all bodies in its children, recursively.
     * @method allBodies
     * @param {composite} composite
     * @return {body[]} All the bodies
     */ Composite.allBodies = function(composite) {
                    var bodies = [].concat(composite.bodies);
                    for(var i = 0; i < composite.composites.length; i++)bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
                    return bodies;
                };
                /**
     * Returns all constraints in the given composite, including all constraints in its children, recursively.
     * @method allConstraints
     * @param {composite} composite
     * @return {constraint[]} All the constraints
     */ Composite.allConstraints = function(composite) {
                    var constraints = [].concat(composite.constraints);
                    for(var i = 0; i < composite.composites.length; i++)constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
                    return constraints;
                };
                /**
     * Returns all composites in the given composite, including all composites in its children, recursively.
     * @method allComposites
     * @param {composite} composite
     * @return {composite[]} All the composites
     */ Composite.allComposites = function(composite) {
                    var composites = [].concat(composite.composites);
                    for(var i = 0; i < composite.composites.length; i++)composites = composites.concat(Composite.allComposites(composite.composites[i]));
                    return composites;
                };
                /**
     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
     * @method get
     * @param {composite} composite
     * @param {number} id
     * @param {string} type
     * @return {object} The requested object, if found
     */ Composite.get = function(composite, id, type) {
                    var objects, object;
                    switch(type){
                        case 'body':
                            objects = Composite.allBodies(composite);
                            break;
                        case 'constraint':
                            objects = Composite.allConstraints(composite);
                            break;
                        case 'composite':
                            objects = Composite.allComposites(composite).concat(composite);
                            break;
                    }
                    if (!objects) return null;
                    object = objects.filter(function(object) {
                        return object.id.toString() === id.toString();
                    });
                    return object.length === 0 ? null : object[0];
                };
                /**
     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
     * @method move
     * @param {compositeA} compositeA
     * @param {object[]} objects
     * @param {compositeB} compositeB
     * @return {composite} Returns compositeA
     */ Composite.move = function(compositeA, objects, compositeB) {
                    Composite.remove(compositeA, objects);
                    Composite.add(compositeB, objects);
                    return compositeA;
                };
                /**
     * Assigns new ids for all objects in the composite, recursively.
     * @method rebase
     * @param {composite} composite
     * @return {composite} Returns composite
     */ Composite.rebase = function(composite) {
                    var objects = Composite.allBodies(composite).concat(Composite.allConstraints(composite)).concat(Composite.allComposites(composite));
                    for(var i = 0; i < objects.length; i++)objects[i].id = Common.nextId();
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Translates all children in the composite by a given vector relative to their current positions, 
     * without imparting any velocity.
     * @method translate
     * @param {composite} composite
     * @param {vector} translation
     * @param {bool} [recursive=true]
     */ Composite.translate = function(composite, translation, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++)Body.translate(bodies[i], translation);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
     * @method rotate
     * @param {composite} composite
     * @param {number} rotation
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.rotate = function(composite, rotation, point, recursive) {
                    var cos = Math.cos(rotation), sin = Math.sin(rotation), bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.rotate(body, rotation);
                    }
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
     * @method scale
     * @param {composite} composite
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + dx * scaleX,
                            y: point.y + dy * scaleY
                        });
                        Body.scale(body, scaleX, scaleY);
                    }
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns the union of the bounds of all of the composite's bodies.
     * @method bounds
     * @param {composite} composite The composite.
     * @returns {bounds} The composite bounds.
     */ Composite.bounds = function(composite) {
                    var bodies = Composite.allBodies(composite), vertices = [];
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i];
                        vertices.push(body.bounds.min, body.bounds.max);
                    }
                    return Bounds.create(vertices);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a call to `Composite.add` is made, before objects have been added.
    *
    * @event beforeAdd
    * @param {} event An event object
    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.add` is made, after objects have been added.
    *
    * @event afterAdd
    * @param {} event An event object
    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, before objects have been removed.
    *
    * @event beforeRemove
    * @param {} event An event object
    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, after objects have been removed.
    *
    * @event afterRemove
    * @param {} event An event object
    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "composite"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage composites.
     *
     * @property label
     * @type string
     * @default "Composite"
     */ /**
     * A flag that specifies whether the composite has been modified during the current step.
     * Most `Matter.Composite` methods will automatically set this flag to `true` to inform the engine of changes to be handled.
     * If you need to change it manually, you should use the `Composite.setModified` method.
     *
     * @property isModified
     * @type boolean
     * @default false
     */ /**
     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
     *
     * @property parent
     * @type composite
     * @default null
     */ /**
     * An array of `Body` that are _direct_ children of this composite.
     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
     *
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * An array of `Constraint` that are _direct_ children of this composite.
     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
     *
     * @property constraints
     * @type constraint[]
     * @default []
     */ /**
     * An array of `Composite` that are _direct_ children of this composite.
     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
     *
     * @property composites
     * @type composite[]
     * @default []
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 164 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Modes.
 * 
 * @namespace Phaser.ScaleModes
 * @since 3.0.0
 */ var ScaleModes = {
                /**
     * Default Scale Mode (Linear).
     * 
     * @name Phaser.ScaleModes.DEFAULT
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ DEFAULT: 0,
                /**
     * Linear Scale Mode.
     * 
     * @name Phaser.ScaleModes.LINEAR
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ LINEAR: 0,
                /**
     * Nearest Scale Mode.
     * 
     * @name Phaser.ScaleModes.NEAREST
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ NEAREST: 1
            };
            module1.exports = ScaleModes;
        /***/ },
        /* 165 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
 *
 * @function Phaser.Geom.Circle.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} angle - The angle from the center of the Circle to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(circle, angle, out) {
                if (out === undefined) out = new Point();
                out.x = circle.x + circle.radius * Math.cos(angle);
                out.y = circle.y + circle.radius * Math.sin(angle);
                return out;
            };
            module1.exports = CircumferencePoint;
        /***/ },
        /* 166 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a uniformly distributed random point from anywhere within the given Circle.
 *
 * @function Phaser.Geom.Circle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(circle, out) {
                if (out === undefined) out = new Point();
                var t = 2 * Math.PI * Math.random();
                var u = Math.random() + Math.random();
                var r = u > 1 ? 2 - u : u;
                var x = r * Math.cos(t);
                var y = r * Math.sin(t);
                out.x = circle.x + x * circle.radius;
                out.y = circle.y + y * circle.radius;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 167 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(128);
            var Point = __webpack_require__(4);
            /**
 * Calculates the coordinates of a point at a certain `position` on the Rectangle's perimeter.
 * 
 * The `position` is a fraction between 0 and 1 which defines how far into the perimeter the point is.
 * 
 * A value of 0 or 1 returns the point at the top left corner of the rectangle, while a value of 0.5 returns the point at the bottom right corner of the rectangle. Values between 0 and 0.5 are on the top or the right side and values between 0.5 and 1 are on the bottom or the left side.
 *
 * @function Phaser.Geom.Rectangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} position - The normalized distance into the Rectangle's perimeter to return.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to update with the `x` and `y` coordinates of the point.
 *
 * @return {Phaser.Geom.Point} The updated `output` object, or a new Point if no `output` object was given.
 */ var GetPoint = function(rectangle, position, out) {
                if (out === undefined) out = new Point();
                if (position <= 0 || position >= 1) {
                    out.x = rectangle.x;
                    out.y = rectangle.y;
                    return out;
                }
                var p = Perimeter(rectangle) * position;
                if (position > 0.5) {
                    p -= rectangle.width + rectangle.height;
                    if (p <= rectangle.width) {
                        //  Face 3
                        out.x = rectangle.right - p;
                        out.y = rectangle.bottom;
                    } else {
                        //  Face 4
                        out.x = rectangle.x;
                        out.y = rectangle.bottom - (p - rectangle.width);
                    }
                } else if (p <= rectangle.width) {
                    //  Face 1
                    out.x = rectangle.x + p;
                    out.y = rectangle.y;
                } else {
                    //  Face 2
                    out.x = rectangle.right;
                    out.y = rectangle.y + (p - rectangle.width);
                }
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 168 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            var Point = __webpack_require__(4);
            /**
 * Get a number of points along a line's length.
 *
 * Provide a `quantity` to get an exact number of points along the line.
 *
 * Provide a `stepRate` to ensure a specific distance between each point on the line. Set `quantity` to `0` when
 * providing a `stepRate`.
 *
 * @function Phaser.Geom.Line.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} quantity - The number of points to place on the line. Set to `0` to use `stepRate` instead.
 * @param {number} [stepRate] - The distance between each point on the line. When set, `quantity` is implied and should be set to `0`.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array of Points, or point-like objects, to store the coordinates of the points on the line.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points, or point-like objects, containing the coordinates of the points on the line.
 */ var GetPoints = function(line, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Length(line) / stepRate;
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                for(var i = 0; i < quantity; i++){
                    var position = i / quantity;
                    var x = x1 + (x2 - x1) * position;
                    var y = y1 + (y2 - y1) * position;
                    out.push(new Point(x, y));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 169 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random point on a given Line.
 *
 * @function Phaser.Geom.Line.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line to calculate the random Point on.
 * @param {(Phaser.Geom.Point|object)} [out] - An instance of a Point to be modified.
 *
 * @return {(Phaser.Geom.Point|object)} A random Point on the Line.
 */ var Random = function(line, out) {
                if (out === undefined) out = new Point();
                var t = Math.random();
                out.x = line.x1 + t * (line.x2 - line.x1);
                out.y = line.y1 + t * (line.y2 - line.y1);
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 170 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random point within a Rectangle.
 *
 * @function Phaser.Geom.Rectangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to return a point from.
 * @param {Phaser.Geom.Point} out - The object to update with the point's coordinates.
 *
 * @return {Phaser.Geom.Point} The modified `out` object, or a new Point if none was provided.
 */ var Random = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.x + Math.random() * rect.width;
                out.y = rect.y + Math.random() * rect.height;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 171 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DeepCopy = __webpack_require__(172);
            var PIPELINE_CONST = __webpack_require__(65);
            var SpliceOne = __webpack_require__(74);
            /**
 * Provides methods used for setting the WebGL rendering pipeline of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Pipeline
 * @webglOnly
 * @since 3.0.0
 */ var Pipeline = {
                /**
     * The initial WebGL pipeline of this Game Object.
     *
     * If you call `resetPipeline` on this Game Object, the pipeline is reset to this default.
     *
     * @name Phaser.GameObjects.Components.Pipeline#defaultPipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ defaultPipeline: null,
                /**
     * The current WebGL pipeline of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipeline
     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
     * @default null
     * @webglOnly
     * @since 3.0.0
     */ pipeline: null,
                /**
     * Does this Game Object have any Post Pipelines set?
     *
     * @name Phaser.GameObjects.Components.Pipeline#hasPostPipeline
     * @type {boolean}
     * @webglOnly
     * @since 3.50.0
     */ hasPostPipeline: false,
                /**
     * The WebGL Post FX Pipelines this Game Object uses for post-render effects.
     *
     * The pipelines are processed in the order in which they appear in this array.
     *
     * If you modify this array directly, be sure to set the
     * `hasPostPipeline` property accordingly.
     *
     * @name Phaser.GameObjects.Components.Pipeline#postPipeline
     * @type {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[]}
     * @webglOnly
     * @since 3.50.0
     */ postPipelines: null,
                /**
     * An object to store pipeline specific data in, to be read by the pipelines this Game Object uses.
     *
     * @name Phaser.GameObjects.Components.Pipeline#pipelineData
     * @type {object}
     * @webglOnly
     * @since 3.50.0
     */ pipelineData: null,
                /**
     * Sets the initial WebGL Pipeline of this Game Object.
     *
     * This should only be called during the instantiation of the Game Object. After that, use `setPipeline`.
     *
     * @method Phaser.GameObjects.Components.Pipeline#initPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline, or a pipeline instance to set.
     *
     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
     */ initPipeline: function(pipeline) {
                    if (pipeline === undefined) pipeline = PIPELINE_CONST.MULTI_PIPELINE;
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return false;
                    var pipelines = renderer.pipelines;
                    this.postPipelines = [];
                    this.pipelineData = {};
                    if (pipelines) {
                        var instance = pipelines.get(pipeline);
                        if (instance) {
                            this.defaultPipeline = instance;
                            this.pipeline = instance;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Sets the main WebGL Pipeline of this Game Object.
     *
     * Also sets the `pipelineData` property, if the parameter is given.
     *
     * Both the pipeline and post pipelines share the same pipeline data object.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline, or a pipeline instance to set.
     * @param {object} [pipelineData] - Optional pipeline data object that is _deep copied_ into the `pipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `pipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPipeline: function(pipeline, pipelineData, copyData) {
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return this;
                    var pipelines = renderer.pipelines;
                    if (pipelines) {
                        var instance = pipelines.get(pipeline);
                        if (instance) this.pipeline = instance;
                        if (pipelineData) this.pipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                    }
                    return this;
                },
                /**
     * Sets one, or more, Post Pipelines on this Game Object.
     *
     * Post Pipelines are invoked after this Game Object has rendered to its target and
     * are commonly used for post-fx.
     *
     * The post pipelines are appended to the `postPipelines` array belonging to this
     * Game Object. When the renderer processes this Game Object, it iterates through the post
     * pipelines in the order in which they appear in the array. If you are stacking together
     * multiple effects, be aware that the order is important.
     *
     * If you call this method multiple times, the new pipelines will be appended to any existing
     * post pipelines already set. Use the `resetPostPipeline` method to clear them first, if required.
     *
     * You can optionally also sets the `pipelineData` property, if the parameter is given.
     *
     * Both the pipeline and post pipelines share the pipeline data object together.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|string[]|function|function[]|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} pipelines - Either the string-based name of the pipeline, or a pipeline instance, or class, or an array of them.
     * @param {object} [pipelineData] - Optional pipeline data object that is _deep copied_ into the `pipelineData` property of this Game Object.
     * @param {boolean} [copyData=true] - Should the pipeline data object be _deep copied_ into the `pipelineData` property of this Game Object? If `false` it will be set by reference instead.
     *
     * @return {this} This Game Object instance.
     */ setPostPipeline: function(pipelines, pipelineData, copyData) {
                    var renderer = this.scene.sys.renderer;
                    if (!renderer) return this;
                    var pipelineManager = renderer.pipelines;
                    if (pipelineManager) {
                        if (!Array.isArray(pipelines)) pipelines = [
                            pipelines
                        ];
                        for(var i = 0; i < pipelines.length; i++){
                            var instance = pipelineManager.getPostPipeline(pipelines[i], this);
                            if (instance) this.postPipelines.push(instance);
                        }
                        if (pipelineData) this.pipelineData = copyData ? DeepCopy(pipelineData) : pipelineData;
                    }
                    this.hasPostPipeline = this.postPipelines.length > 0;
                    return this;
                },
                /**
     * Adds an entry to the `pipelineData` object belonging to this Game Object.
     *
     * If the 'key' already exists, its value is updated. If it doesn't exist, it is created.
     *
     * If `value` is undefined, and `key` exists, `key` is removed from the data object.
     *
     * Both the pipeline and post pipelines share the pipeline data object together.
     *
     * @method Phaser.GameObjects.Components.Pipeline#setPipelineData
     * @webglOnly
     * @since 3.50.0
     *
     * @param {string} key - The key of the pipeline data to set, update, or delete.
     * @param {any} [value] - The value to be set with the key. If `undefined` then `key` will be deleted from the object.
     *
     * @return {this} This Game Object instance.
     */ setPipelineData: function(key, value) {
                    var data = this.pipelineData;
                    if (value === undefined) delete data[key];
                    else data[key] = value;
                    return this;
                },
                /**
     * Gets a Post Pipeline instance from this Game Object, based on the given name, and returns it.
     *
     * @method Phaser.GameObjects.Components.Pipeline#getPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {(Phaser.Renderer.WebGL.Pipelines.PostFXPipeline|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline[])} The Post Pipeline/s matching the name, or undefined if no match. If more than one match they are returned in an array.
     */ getPostPipeline: function(pipeline) {
                    var pipelines = this.postPipelines;
                    var results = [];
                    for(var i = 0; i < pipelines.length; i++){
                        var instance = pipelines[i];
                        if (typeof pipeline === 'string' && instance.name === pipeline || instance instanceof pipeline) results.push(instance);
                    }
                    return results.length === 1 ? results[0] : results;
                },
                /**
     * Resets the WebGL Pipeline of this Game Object back to the default it was created with.
     *
     * @method Phaser.GameObjects.Components.Pipeline#resetPipeline
     * @webglOnly
     * @since 3.0.0
     *
     * @param {boolean} [resetPostPipelines=false] - Reset all of the post pipelines?
     * @param {boolean} [resetData=false] - Reset the `pipelineData` object to being an empty object?
     *
     * @return {boolean} `true` if the pipeline was reset successfully, otherwise `false`.
     */ resetPipeline: function(resetPostPipelines, resetData) {
                    if (resetPostPipelines === undefined) resetPostPipelines = false;
                    if (resetData === undefined) resetData = false;
                    this.pipeline = this.defaultPipeline;
                    if (resetPostPipelines) {
                        this.postPipelines = [];
                        this.hasPostPipeline = false;
                    }
                    if (resetData) this.pipelineData = {};
                    return this.pipeline !== null;
                },
                /**
     * Resets the WebGL Post Pipelines of this Game Object. It does this by calling
     * the `destroy` method on each post pipeline and then clearing the local array.
     *
     * @method Phaser.GameObjects.Components.Pipeline#resetPostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {boolean} [resetData=false] - Reset the `pipelineData` object to being an empty object?
     */ resetPostPipeline: function(resetData) {
                    if (resetData === undefined) resetData = false;
                    var pipelines = this.postPipelines;
                    for(var i = 0; i < pipelines.length; i++)pipelines[i].destroy();
                    this.postPipelines = [];
                    this.hasPostPipeline = false;
                    if (resetData) this.pipelineData = {};
                },
                /**
     * Removes a type of Post Pipeline instances from this Game Object, based on the given name, and destroys them.
     *
     * If you wish to remove all Post Pipelines use the `resetPostPipeline` method instead.
     *
     * @method Phaser.GameObjects.Components.Pipeline#removePostPipeline
     * @webglOnly
     * @since 3.50.0
     *
     * @param {string|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} pipeline - The string-based name of the pipeline, or a pipeline class.
     *
     * @return {this} This Game Object.
     */ removePostPipeline: function(pipeline) {
                    var pipelines = this.postPipelines;
                    for(var i = pipelines.length - 1; i >= 0; i--){
                        var instance = pipelines[i];
                        if (typeof pipeline === 'string' && instance.name === pipeline || typeof pipeline !== 'string' && instance instanceof pipeline) {
                            instance.destroy();
                            SpliceOne(pipelines, i);
                        }
                    }
                    this.hasPostPipeline = this.postPipelines.length > 0;
                    return this;
                },
                /**
     * Gets the name of the WebGL Pipeline this Game Object is currently using.
     *
     * @method Phaser.GameObjects.Components.Pipeline#getPipelineName
     * @webglOnly
     * @since 3.0.0
     *
     * @return {string} The string-based name of the pipeline being used by this Game Object.
     */ getPipelineName: function() {
                    return this.pipeline.name;
                }
            };
            module1.exports = Pipeline;
        /***/ },
        /* 172 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Deep Copy the given object or array.
 *
 * @function Phaser.Utils.Objects.DeepCopy
 * @since 3.50.0
 *
 * @param {object} obj - The object to deep copy.
 *
 * @return {object} A deep copy of the original object.
 */ var DeepCopy = function(inObject) {
                var outObject;
                var value;
                var key;
                if (typeof inObject !== 'object' || inObject === null) //  inObject is not an object
                return inObject;
                //  Create an array or object to hold the values
                outObject = Array.isArray(inObject) ? [] : {};
                for(key in inObject){
                    value = inObject[key];
                    //  Recursively (deep) copy for nested objects, including arrays
                    outObject[key] = DeepCopy(value);
                }
                return outObject;
            };
            module1.exports = DeepCopy;
        /***/ },
        /* 173 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Build a JSON representation of the given Game Object.
 *
 * This is typically extended further by Game Object specific implementations.
 *
 * @method Phaser.GameObjects.Components.ToJSON
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to export as JSON.
 *
 * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
 */ var ToJSON = function(gameObject) {
                var out = {
                    name: gameObject.name,
                    type: gameObject.type,
                    x: gameObject.x,
                    y: gameObject.y,
                    depth: gameObject.depth,
                    scale: {
                        x: gameObject.scaleX,
                        y: gameObject.scaleY
                    },
                    origin: {
                        x: gameObject.originX,
                        y: gameObject.originY
                    },
                    flipX: gameObject.flipX,
                    flipY: gameObject.flipY,
                    rotation: gameObject.rotation,
                    alpha: gameObject.alpha,
                    visible: gameObject.visible,
                    blendMode: gameObject.blendMode,
                    textureKey: '',
                    frameKey: '',
                    data: {}
                };
                if (gameObject.texture) {
                    out.textureKey = gameObject.texture.key;
                    out.frameKey = gameObject.frame.name;
                }
                return out;
            };
            module1.exports = ToJSON;
        /***/ },
        /* 174 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Takes the `x` and `y` coordinates and transforms them into the same space as
 * defined by the position, rotation and scale values.
 *
 * @function Phaser.Math.TransformXY
 * @since 3.0.0
 *
 * @param {number} x - The x coordinate to be transformed.
 * @param {number} y - The y coordinate to be transformed.
 * @param {number} positionX - Horizontal position of the transform point.
 * @param {number} positionY - Vertical position of the transform point.
 * @param {number} rotation - Rotation of the transform point, in radians.
 * @param {number} scaleX - Horizontal scale of the transform point.
 * @param {number} scaleY - Vertical scale of the transform point.
 * @param {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} [output] - The output vector, point or object for the translated coordinates.
 *
 * @return {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} The translated point.
 */ var TransformXY = function(x, y, positionX, positionY, rotation, scaleX, scaleY, output) {
                if (output === undefined) output = new Vector2();
                var radianSin = Math.sin(rotation);
                var radianCos = Math.cos(rotation);
                // Rotate and Scale
                var a = radianCos * scaleX;
                var b = radianSin * scaleX;
                var c = -radianSin * scaleY;
                var d = radianCos * scaleY;
                //  Invert
                var id = 1 / (a * d + c * -b);
                output.x = d * id * x + -c * id * y + (positionY * c - positionX * d) * id;
                output.y = a * id * y + -b * id * x + (-positionY * a + positionX * b) * id;
                return output;
            };
            module1.exports = TransformXY;
        /***/ },
        /* 175 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the start of the array to the end, shifting all items in the process.
 * The "rotation" happens to the left.
 *
 * @function Phaser.Utils.Array.RotateLeft
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the left. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateLeft = function(array, total) {
                if (total === undefined) total = 1;
                var element = null;
                for(var i = 0; i < total; i++){
                    element = array.shift();
                    array.push(element);
                }
                return element;
            };
            module1.exports = RotateLeft;
        /***/ },
        /* 176 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the element at the end of the array to the start, shifting all items in the process.
 * The "rotation" happens to the right.
 *
 * @function Phaser.Utils.Array.RotateRight
 * @since 3.0.0
 *
 * @param {array} array - The array to shift to the right. This array is modified in place.
 * @param {number} [total=1] - The number of times to shift the array.
 *
 * @return {*} The most recently shifted element.
 */ var RotateRight = function(array, total) {
                if (total === undefined) total = 1;
                var element = null;
                for(var i = 0; i < total; i++){
                    element = array.pop();
                    array.unshift(element);
                }
                return element;
            };
            module1.exports = RotateRight;
        /***/ },
        /* 177 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a uniformly distributed random point from anywhere within the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get a random point from.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
 */ var Random = function(ellipse, out) {
                if (out === undefined) out = new Point();
                var p = Math.random() * Math.PI * 2;
                var s = Math.sqrt(Math.random());
                out.x = ellipse.x + s * Math.cos(p) * ellipse.width / 2;
                out.y = ellipse.y + s * Math.sin(p) * ellipse.height / 2;
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 178 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a random Point from within the area of the given Triangle.
 *
 * @function Phaser.Geom.Triangle.Random
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get a random point from.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of a random position within the Triangle.
 */ var Random = function(triangle, out) {
                if (out === undefined) out = new Point();
                //  Basis vectors
                var ux = triangle.x2 - triangle.x1;
                var uy = triangle.y2 - triangle.y1;
                var vx = triangle.x3 - triangle.x1;
                var vy = triangle.y3 - triangle.y1;
                //  Random point within the unit square
                var r = Math.random();
                var s = Math.random();
                //  Point outside the triangle? Remap it.
                if (r + s >= 1) {
                    r = 1 - r;
                    s = 1 - s;
                }
                out.x = triangle.x1 + (ux * r + vx * s);
                out.y = triangle.y1 + (uy * r + vy * s);
                return out;
            };
            module1.exports = Random;
        /***/ },
        /* 179 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` by the given `angle` and `distance`.
 *
 * In polar notation, this maps a point from (r, t) to (distance, t + angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAroundDistance = function(point, x, y, angle, distance) {
                var t = angle + Math.atan2(point.y - y, point.x - x);
                point.x = x + distance * Math.cos(t);
                point.y = y + distance * Math.sin(t);
                return point;
            };
            module1.exports = RotateAroundDistance;
        /***/ },
        /* 180 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smoother interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * Produces an even smoother interpolation than {@link Phaser.Math.SmoothStep}.
 *
 * @function Phaser.Math.SmootherStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmootherStep = function(x, min, max) {
                x = Math.max(0, Math.min(1, (x - min) / (max - min)));
                return x * x * x * (x * (x * 6 - 15) + 10);
            };
            module1.exports = SmootherStep;
        /***/ },
        /* 181 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a smooth interpolation percentage of `x` between `min` and `max`.
 *
 * The function receives the number `x` as an argument and returns 0 if `x` is less than or equal to the left edge,
 * 1 if `x` is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial,
 * between 0 and 1 otherwise.
 *
 * @function Phaser.Math.SmoothStep
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} x - The input value.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The percentage of interpolation, between 0 and 1.
 */ var SmoothStep = function(x, min, max) {
                if (x <= min) return 0;
                if (x >= max) return 1;
                x = (x - min) / (max - min);
                return x * x * (3 - 2 * x);
            };
            module1.exports = SmoothStep;
        /***/ },
        /* 182 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(130);
            var FindClosestInSorted = __webpack_require__(312);
            var Frame = __webpack_require__(313);
            var GetValue = __webpack_require__(6);
            var SortByDigits = __webpack_require__(314);
            /**
 * @classdesc
 * A Frame based Animation.
 *
 * Animations in Phaser consist of a sequence of `AnimationFrame` objects, which are managed by
 * this class, along with properties that impact playback, such as the animations frame rate
 * or delay.
 *
 * This class contains all of the properties and methods needed to handle playback of the animation
 * directly to an `AnimationState` instance, which is owned by a Sprite, or similar Game Object.
 *
 * You don't typically create an instance of this class directly, but instead go via
 * either the `AnimationManager` or the `AnimationState` and use their `create` methods,
 * depending on if you need a global animation, or local to a specific Sprite.
 *
 * @class Animation
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Animations.AnimationManager} manager - A reference to the global Animation Manager
 * @param {string} key - The unique identifying string for this animation.
 * @param {Phaser.Types.Animations.Animation} config - The Animation configuration.
 */ var Animation = new Class({
                initialize: function Animation(manager, key, config) {
                    /**
         * A reference to the global Animation Manager.
         *
         * @name Phaser.Animations.Animation#manager
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The unique identifying string for this animation.
         *
         * @name Phaser.Animations.Animation#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                    /**
         * A frame based animation (as opposed to a bone based animation)
         *
         * @name Phaser.Animations.Animation#type
         * @type {string}
         * @default frame
         * @since 3.0.0
         */ this.type = 'frame';
                    /**
         * Extract all the frame data into the frames array.
         *
         * @name Phaser.Animations.Animation#frames
         * @type {Phaser.Animations.AnimationFrame[]}
         * @since 3.0.0
         */ this.frames = this.getFrames(manager.textureManager, GetValue(config, 'frames', []), GetValue(config, 'defaultTextureKey', null), GetValue(config, 'sortFrames', true));
                    /**
         * The frame rate of playback in frames per second (default 24 if duration is null)
         *
         * @name Phaser.Animations.Animation#frameRate
         * @type {number}
         * @default 24
         * @since 3.0.0
         */ this.frameRate = GetValue(config, 'frameRate', null);
                    /**
         * How long the animation should play for, in milliseconds.
         * If the `frameRate` property has been set then it overrides this value,
         * otherwise the `frameRate` is derived from `duration`.
         *
         * @name Phaser.Animations.Animation#duration
         * @type {number}
         * @since 3.0.0
         */ this.duration = GetValue(config, 'duration', null);
                    /**
         * How many ms per frame, not including frame specific modifiers.
         *
         * @name Phaser.Animations.Animation#msPerFrame
         * @type {number}
         * @since 3.0.0
         */ this.msPerFrame;
                    /**
         * Skip frames if the time lags, or always advanced anyway?
         *
         * @name Phaser.Animations.Animation#skipMissedFrames
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.skipMissedFrames = GetValue(config, 'skipMissedFrames', true);
                    /**
         * The delay in ms before the playback will begin.
         *
         * @name Phaser.Animations.Animation#delay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delay = GetValue(config, 'delay', 0);
                    /**
         * Number of times to repeat the animation. Set to -1 to repeat forever.
         *
         * @name Phaser.Animations.Animation#repeat
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeat = GetValue(config, 'repeat', 0);
                    /**
         * The delay in ms before the a repeat play starts.
         *
         * @name Phaser.Animations.Animation#repeatDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatDelay = GetValue(config, 'repeatDelay', 0);
                    /**
         * Should the animation yoyo (reverse back down to the start) before repeating?
         *
         * @name Phaser.Animations.Animation#yoyo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.yoyo = GetValue(config, 'yoyo', false);
                    /**
         * Should the GameObject's `visible` property be set to `true` when the animation starts to play?
         *
         * @name Phaser.Animations.Animation#showOnStart
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.showOnStart = GetValue(config, 'showOnStart', false);
                    /**
         * Should the GameObject's `visible` property be set to `false` when the animation finishes?
         *
         * @name Phaser.Animations.Animation#hideOnComplete
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hideOnComplete = GetValue(config, 'hideOnComplete', false);
                    /**
         * Global pause. All Game Objects using this Animation instance are impacted by this property.
         *
         * @name Phaser.Animations.Animation#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    this.calculateDuration(this, this.getTotalFrames(), this.duration, this.frameRate);
                    if (this.manager.on) {
                        this.manager.on(Events.PAUSE_ALL, this.pause, this);
                        this.manager.on(Events.RESUME_ALL, this.resume, this);
                    }
                },
                /**
     * Gets the total number of frames in this animation.
     *
     * @method Phaser.Animations.Animation#getTotalFrames
     * @since 3.50.0
     *
     * @return {number} The total number of frames in this animation.
     */ getTotalFrames: function() {
                    return this.frames.length;
                },
                /**
     * Calculates the duration, frame rate and msPerFrame values.
     *
     * @method Phaser.Animations.Animation#calculateDuration
     * @since 3.50.0
     *
     * @param {Phaser.Animations.Animation} target - The target to set the values on.
     * @param {number} totalFrames - The total number of frames in the animation.
     * @param {number} duration - The duration to calculate the frame rate from.
     * @param {number} frameRate - The frame ate to calculate the duration from.
     */ calculateDuration: function(target, totalFrames, duration, frameRate) {
                    if (duration === null && frameRate === null) {
                        //  No duration or frameRate given, use default frameRate of 24fps
                        target.frameRate = 24;
                        target.duration = 24 / totalFrames * 1000;
                    } else if (duration && frameRate === null) {
                        //  Duration given but no frameRate, so set the frameRate based on duration
                        //  I.e. 12 frames in the animation, duration = 4000 ms
                        //  So frameRate is 12 / (4000 / 1000) = 3 fps
                        target.duration = duration;
                        target.frameRate = totalFrames / (duration / 1000);
                    } else {
                        //  frameRate given, derive duration from it (even if duration also specified)
                        //  I.e. 15 frames in the animation, frameRate = 30 fps
                        //  So duration is 15 / 30 = 0.5 * 1000 (half a second, or 500ms)
                        target.frameRate = frameRate;
                        target.duration = totalFrames / frameRate * 1000;
                    }
                    target.msPerFrame = 1000 / target.frameRate;
                },
                /**
     * Add frames to the end of the animation.
     *
     * @method Phaser.Animations.Animation#addFrame
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrame: function(config) {
                    return this.addFrameAt(this.frames.length, config);
                },
                /**
     * Add frame/s into the animation.
     *
     * @method Phaser.Animations.Animation#addFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index to insert the frame at within the animation.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} config - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     *
     * @return {this} This Animation object.
     */ addFrameAt: function(index, config) {
                    var newFrames = this.getFrames(this.manager.textureManager, config);
                    if (newFrames.length > 0) {
                        if (index === 0) this.frames = newFrames.concat(this.frames);
                        else if (index === this.frames.length) this.frames = this.frames.concat(newFrames);
                        else {
                            var pre = this.frames.slice(0, index);
                            var post = this.frames.slice(index);
                            this.frames = pre.concat(newFrames, post);
                        }
                        this.updateFrameSequence();
                    }
                    return this;
                },
                /**
     * Check if the given frame index is valid.
     *
     * @method Phaser.Animations.Animation#checkFrame
     * @since 3.0.0
     *
     * @param {number} index - The index to be checked.
     *
     * @return {boolean} `true` if the index is valid, otherwise `false`.
     */ checkFrame: function(index) {
                    return index >= 0 && index < this.frames.length;
                },
                /**
     * Called internally when this Animation first starts to play.
     * Sets the accumulator and nextTick properties.
     *
     * @method Phaser.Animations.Animation#getFirstTick
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getFirstTick: function(state) {
                    //  When is the first update due?
                    state.accumulator = 0;
                    state.nextTick = state.msPerFrame + state.currentFrame.duration;
                },
                /**
     * Returns the AnimationFrame at the provided index
     *
     * @method Phaser.Animations.Animation#getFrameAt
     * @protected
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {Phaser.Animations.AnimationFrame} The frame at the index provided from the animation sequence
     */ getFrameAt: function(index) {
                    return this.frames[index];
                },
                /**
     * Creates AnimationFrame instances based on the given frame data.
     *
     * @method Phaser.Animations.Animation#getFrames
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureManager} textureManager - A reference to the global Texture Manager.
     * @param {(string|Phaser.Types.Animations.AnimationFrame[])} frames - Either a string, in which case it will use all frames from a texture with the matching key, or an array of Animation Frame configuration objects.
     * @param {string} [defaultTextureKey] - The key to use if no key is set in the frame configuration object.
     *
     * @return {Phaser.Animations.AnimationFrame[]} An array of newly created AnimationFrame instances.
     */ getFrames: function(textureManager, frames, defaultTextureKey, sortFrames) {
                    if (sortFrames === undefined) sortFrames = true;
                    var out = [];
                    var prev;
                    var animationFrame;
                    var index = 1;
                    var i;
                    var textureKey;
                    //  if frames is a string, we'll get all the frames from the texture manager as if it's a sprite sheet
                    if (typeof frames === 'string') {
                        textureKey = frames;
                        var texture = textureManager.get(textureKey);
                        var frameKeys = texture.getFrameNames();
                        if (sortFrames) SortByDigits(frameKeys);
                        frames = [];
                        frameKeys.forEach(function(value) {
                            frames.push({
                                key: textureKey,
                                frame: value
                            });
                        });
                    }
                    if (!Array.isArray(frames) || frames.length === 0) return out;
                    for(i = 0; i < frames.length; i++){
                        var item = frames[i];
                        var key = GetValue(item, 'key', defaultTextureKey);
                        if (!key) continue;
                        //  Could be an integer or a string
                        var frame = GetValue(item, 'frame', 0);
                        //  The actual texture frame
                        var textureFrame = textureManager.getFrame(key, frame);
                        animationFrame = new Frame(key, frame, index, textureFrame);
                        animationFrame.duration = GetValue(item, 'duration', 0);
                        animationFrame.isFirst = !prev;
                        //  The previously created animationFrame
                        if (prev) {
                            prev.nextFrame = animationFrame;
                            animationFrame.prevFrame = prev;
                        }
                        out.push(animationFrame);
                        prev = animationFrame;
                        index++;
                    }
                    if (out.length > 0) {
                        animationFrame.isLast = true;
                        //  Link them end-to-end, so they loop
                        animationFrame.nextFrame = out[0];
                        out[0].prevFrame = animationFrame;
                        //  Generate the progress data
                        var slice = 1 / (out.length - 1);
                        for(i = 0; i < out.length; i++)out[i].progress = i * slice;
                    }
                    return out;
                },
                /**
     * Called internally. Sets the accumulator and nextTick values of the current Animation.
     *
     * @method Phaser.Animations.Animation#getNextTick
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ getNextTick: function(state) {
                    state.accumulator -= state.nextTick;
                    state.nextTick = state.msPerFrame + state.currentFrame.duration;
                },
                /**
     * Returns the frame closest to the given progress value between 0 and 1.
     *
     * @method Phaser.Animations.Animation#getFrameByProgress
     * @since 3.4.0
     *
     * @param {number} value - A value between 0 and 1.
     *
     * @return {Phaser.Animations.AnimationFrame} The frame closest to the given progress value.
     */ getFrameByProgress: function(value) {
                    value = Clamp(value, 0, 1);
                    return FindClosestInSorted(value, this.frames, 'progress');
                },
                /**
     * Advance the animation frame.
     *
     * @method Phaser.Animations.Animation#nextFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     */ nextFrame: function(state) {
                    var frame = state.currentFrame;
                    if (frame.isLast) {
                        //  We're at the end of the animation
                        //  Yoyo? (happens before repeat)
                        if (state.yoyo) this.handleYoyoFrame(state, false);
                        else if (state.repeatCounter > 0) {
                            //  Repeat (happens before complete)
                            if (state.inReverse && state.forward) state.forward = false;
                            else this.repeatAnimation(state);
                        } else state.complete();
                    } else this.updateAndGetNextTick(state, frame.nextFrame);
                },
                /**
     * Handle the yoyo functionality in nextFrame and previousFrame methods.
     *
     * @method Phaser.Animations.Animation#handleYoyoFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State to advance.
     * @param {boolean} isReverse - Is animation in reverse mode? (Default: false)
     */ handleYoyoFrame: function(state, isReverse) {
                    if (!isReverse) isReverse = false;
                    if (state.inReverse === !isReverse && state.repeatCounter > 0) {
                        if (state.repeatDelay === 0 || state.pendingRepeat) state.forward = isReverse;
                        this.repeatAnimation(state);
                        return;
                    }
                    if (state.inReverse !== isReverse && state.repeatCounter === 0) {
                        state.complete();
                        return;
                    }
                    state.forward = isReverse;
                    var frame = isReverse ? state.currentFrame.nextFrame : state.currentFrame.prevFrame;
                    this.updateAndGetNextTick(state, frame);
                },
                /**
     * Returns the animation last frame.
     *
     * @method Phaser.Animations.Animation#getLastFrame
     * @since 3.12.0
     *
     * @return {Phaser.Animations.AnimationFrame} The last Animation Frame.
     */ getLastFrame: function() {
                    return this.frames[this.frames.length - 1];
                },
                /**
     * Called internally when the Animation is playing backwards.
     * Sets the previous frame, causing a yoyo, repeat, complete or update, accordingly.
     *
     * @method Phaser.Animations.Animation#previousFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ previousFrame: function(state) {
                    var frame = state.currentFrame;
                    if (frame.isFirst) {
                        //  We're at the start of the animation
                        if (state.yoyo) this.handleYoyoFrame(state, true);
                        else if (state.repeatCounter > 0) {
                            if (state.inReverse && !state.forward) this.repeatAnimation(state);
                            else {
                                //  Repeat (happens before complete)
                                state.forward = true;
                                this.repeatAnimation(state);
                            }
                        } else state.complete();
                    } else this.updateAndGetNextTick(state, frame.prevFrame);
                },
                /**
     * Update Frame and Wait next tick.
     *
     * @method Phaser.Animations.Animation#updateAndGetNextTick
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State.
     * @param {Phaser.Animations.AnimationFrame} frame - An Animation frame.
     */ updateAndGetNextTick: function(state, frame) {
                    state.setCurrentFrame(frame);
                    this.getNextTick(state);
                },
                /**
     * Removes the given AnimationFrame from this Animation instance.
     * This is a global action. Any Game Object using this Animation will be impacted by this change.
     *
     * @method Phaser.Animations.Animation#removeFrame
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationFrame} frame - The AnimationFrame to be removed.
     *
     * @return {this} This Animation object.
     */ removeFrame: function(frame) {
                    var index = this.frames.indexOf(frame);
                    if (index !== -1) this.removeFrameAt(index);
                    return this;
                },
                /**
     * Removes a frame from the AnimationFrame array at the provided index
     * and updates the animation accordingly.
     *
     * @method Phaser.Animations.Animation#removeFrameAt
     * @since 3.0.0
     *
     * @param {number} index - The index in the AnimationFrame array
     *
     * @return {this} This Animation object.
     */ removeFrameAt: function(index) {
                    this.frames.splice(index, 1);
                    this.updateFrameSequence();
                    return this;
                },
                /**
     * Called internally during playback. Forces the animation to repeat, providing there are enough counts left
     * in the repeat counter.
     *
     * @method Phaser.Animations.Animation#repeatAnimation
     * @fires Phaser.Animations.Events#ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_REPEAT
     * @fires Phaser.Animations.Events#SPRITE_ANIMATION_KEY_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Animations.AnimationState} state - The Animation State belonging to the Game Object invoking this call.
     */ repeatAnimation: function(state) {
                    if (state._pendingStop === 2) {
                        if (state._pendingStopValue === 0) return state.stop();
                        else state._pendingStopValue--;
                    }
                    if (state.repeatDelay > 0 && !state.pendingRepeat) {
                        state.pendingRepeat = true;
                        state.accumulator -= state.nextTick;
                        state.nextTick += state.repeatDelay;
                    } else {
                        state.repeatCounter--;
                        if (state.forward) state.setCurrentFrame(state.currentFrame.nextFrame);
                        else state.setCurrentFrame(state.currentFrame.prevFrame);
                        if (state.isPlaying) {
                            this.getNextTick(state);
                            state.handleRepeat();
                        }
                    }
                },
                /**
     * Converts the animation data to JSON.
     *
     * @method Phaser.Animations.Animation#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimation} The resulting JSONAnimation formatted object.
     */ toJSON: function() {
                    var output = {
                        key: this.key,
                        type: this.type,
                        frames: [],
                        frameRate: this.frameRate,
                        duration: this.duration,
                        skipMissedFrames: this.skipMissedFrames,
                        delay: this.delay,
                        repeat: this.repeat,
                        repeatDelay: this.repeatDelay,
                        yoyo: this.yoyo,
                        showOnStart: this.showOnStart,
                        hideOnComplete: this.hideOnComplete
                    };
                    this.frames.forEach(function(frame) {
                        output.frames.push(frame.toJSON());
                    });
                    return output;
                },
                /**
     * Called internally whenever frames are added to, or removed from, this Animation.
     *
     * @method Phaser.Animations.Animation#updateFrameSequence
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ updateFrameSequence: function() {
                    var len = this.frames.length;
                    var slice = 1 / (len - 1);
                    var frame;
                    for(var i = 0; i < len; i++){
                        frame = this.frames[i];
                        frame.index = i + 1;
                        frame.isFirst = false;
                        frame.isLast = false;
                        frame.progress = i * slice;
                        if (i === 0) {
                            frame.isFirst = true;
                            if (len === 1) {
                                frame.isLast = true;
                                frame.nextFrame = frame;
                                frame.prevFrame = frame;
                            } else {
                                frame.isLast = false;
                                frame.prevFrame = this.frames[len - 1];
                                frame.nextFrame = this.frames[i + 1];
                            }
                        } else if (i === len - 1 && len > 1) {
                            frame.isLast = true;
                            frame.prevFrame = this.frames[len - 2];
                            frame.nextFrame = this.frames[0];
                        } else if (len > 1) {
                            frame.prevFrame = this.frames[i - 1];
                            frame.nextFrame = this.frames[i + 1];
                        }
                    }
                    return this;
                },
                /**
     * Pauses playback of this Animation. The paused state is set immediately.
     *
     * @method Phaser.Animations.Animation#pause
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ pause: function() {
                    this.paused = true;
                    return this;
                },
                /**
     * Resumes playback of this Animation. The paused state is reset immediately.
     *
     * @method Phaser.Animations.Animation#resume
     * @since 3.0.0
     *
     * @return {this} This Animation object.
     */ resume: function() {
                    this.paused = false;
                    return this;
                },
                /**
     * Destroys this Animation instance. It will remove all event listeners,
     * remove this animation and its key from the global Animation Manager,
     * and then destroy all Animation Frames in turn.
     *
     * @method Phaser.Animations.Animation#destroy
     * @since 3.0.0
     */ destroy: function() {
                    if (this.manager.off) {
                        this.manager.off(Events.PAUSE_ALL, this.pause, this);
                        this.manager.off(Events.RESUME_ALL, this.resume, this);
                    }
                    this.manager.remove(this.key);
                    for(var i = 0; i < this.frames.length; i++)this.frames[i].destroy();
                    this.frames = [];
                    this.manager = null;
                }
            });
            module1.exports = Animation;
        /***/ },
        /* 183 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and pads it out, to the length required, using the character
 * specified. For example if you need a string to be 6 characters long, you can call:
 *
 * `pad('bob', 6, '-', 2)`
 *
 * This would return: `bob---` as it has padded it out to 6 characters, using the `-` on the right.
 *
 * You can also use it to pad numbers (they are always returned as strings):
 * 
 * `pad(512, 6, '0', 1)`
 *
 * Would return: `000512` with the string padded to the left.
 *
 * If you don't specify a direction it'll pad to both sides:
 * 
 * `pad('c64', 7, '*')`
 *
 * Would return: `**c64**`
 *
 * @function Phaser.Utils.String.Pad
 * @since 3.0.0
 *
 * @param {string|number|object} str - The target string. `toString()` will be called on the string, which means you can also pass in common data types like numbers.
 * @param {number} [len=0] - The number of characters to be added.
 * @param {string} [pad=" "] - The string to pad it out with (defaults to a space).
 * @param {number} [dir=3] - The direction dir = 1 (left), 2 (right), 3 (both).
 * 
 * @return {string} The padded string.
 */ var Pad = function(str, len, pad, dir) {
                if (len === undefined) len = 0;
                if (pad === undefined) pad = ' ';
                if (dir === undefined) dir = 3;
                str = str.toString();
                var padlen = 0;
                if (len + 1 >= str.length) switch(dir){
                    case 1:
                        str = new Array(len + 1 - str.length).join(pad) + str;
                        break;
                    case 3:
                        var right = Math.ceil((padlen = len - str.length) / 2);
                        var left = padlen - right;
                        str = new Array(left + 1).join(pad) + str + new Array(right + 1).join(pad);
                        break;
                    default:
                        str = str + new Array(len + 1 - str.length).join(pad);
                        break;
                }
                return str;
            };
            module1.exports = Pad;
        /***/ },
        /* 184 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HexStringToColor = __webpack_require__(321);
            var IntegerToColor = __webpack_require__(186);
            var ObjectToColor = __webpack_require__(325);
            var RGBStringToColor = __webpack_require__(326);
            /**
 * Converts the given source color value into an instance of a Color class.
 * The value can be either a string, prefixed with `rgb` or a hex string, a number or an Object.
 *
 * @function Phaser.Display.Color.ValueToColor
 * @since 3.0.0
 *
 * @param {(string|number|Phaser.Types.Display.InputColorObject)} input - The source color value to convert.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ValueToColor = function(input) {
                var t = typeof input;
                switch(t){
                    case 'string':
                        if (input.substr(0, 3).toLowerCase() === 'rgb') return RGBStringToColor(input);
                        else return HexStringToColor(input);
                    case 'number':
                        return IntegerToColor(input);
                    case 'object':
                        return ObjectToColor(input);
                }
            };
            module1.exports = ValueToColor;
        /***/ },
        /* 185 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(100);
            /**
 * RGB space conversion.
 *
 * @ignore
 *
 * @param {number} n - The value to convert.
 * @param {number} h - The h value.
 * @param {number} s - The s value.
 * @param {number} v - The v value.
 *
 * @return {number} The converted value.
 */ function ConvertValue(n, h, s, v) {
                var k = (n + h * 6) % 6;
                var min = Math.min(k, 4 - k, 1);
                return Math.round(255 * (v - v * s * Math.max(0, min)));
            }
            /**
 * Converts a HSV (hue, saturation and value) color set to RGB.
 *
 * Conversion formula from https://en.wikipedia.org/wiki/HSL_and_HSV
 *
 * Assumes HSV values are contained in the set [0, 1].
 *
 * @function Phaser.Display.Color.HSVToRGB
 * @since 3.0.0
 *
 * @param {number} h - The hue, in the range 0 - 1. This is the base color.
 * @param {number} s - The saturation, in the range 0 - 1. This controls how much of the hue will be in the final color, where 1 is fully saturated and 0 will give you white.
 * @param {number} v - The value, in the range 0 - 1. This controls how dark the color is. Where 1 is as bright as possible and 0 is black.
 * @param {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} [out] - A Color object to store the results in. If not given a new ColorObject will be created.
 *
 * @return {(Phaser.Types.Display.ColorObject|Phaser.Display.Color)} An object with the red, green and blue values set in the r, g and b properties.
 */ var HSVToRGB = function(h, s, v, out) {
                if (s === undefined) s = 1;
                if (v === undefined) v = 1;
                var r = ConvertValue(5, h, s, v);
                var g = ConvertValue(3, h, s, v);
                var b = ConvertValue(1, h, s, v);
                if (!out) return {
                    r: r,
                    g: g,
                    b: b,
                    color: GetColor(r, g, b)
                };
                else if (out.setTo) return out.setTo(r, g, b, out.alpha, false);
                else {
                    out.r = r;
                    out.g = g;
                    out.b = b;
                    out.color = GetColor(r, g, b);
                    return out;
                }
            };
            module1.exports = HSVToRGB;
        /***/ },
        /* 186 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            var IntegerToRGB = __webpack_require__(324);
            /**
 * Converts the given color value into an instance of a Color object.
 *
 * @function Phaser.Display.Color.IntegerToColor
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var IntegerToColor = function(input) {
                var rgb = IntegerToRGB(input);
                return new Color(rgb.r, rgb.g, rgb.b, rgb.a);
            };
            module1.exports = IntegerToColor;
        /***/ },
        /* 187 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Centers this Rectangle so that the center coordinates match the given x and y values.
            /**
 * Moves the top-left corner of a Rectangle so that its center is at the given coordinates.
 *
 * @function Phaser.Geom.Rectangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to be centered.
 * @param {number} x - The X coordinate of the Rectangle's center.
 * @param {number} y - The Y coordinate of the Rectangle's center.
 *
 * @return {Phaser.Geom.Rectangle} The centered rectangle.
 */ var CenterOn = function(rect, x, y) {
                rect.x = x - rect.width / 2;
                rect.y = y - rect.height / 2;
                return rect;
            };
            module1.exports = CenterOn;
        /***/ },
        /* 188 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(102);
            var Browser = __webpack_require__(134);
            var CanvasPool = __webpack_require__(31);
            /**
 * Determines the features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.features` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.Features
 * @since 3.0.0
 * 
 * @property {?boolean} canvasBitBltShift - True if canvas supports a 'copy' bitblt onto itself when the source and destination regions overlap.
 * @property {boolean} canvas - Is canvas available?
 * @property {boolean} file - Is file available?
 * @property {boolean} fileSystem - Is fileSystem available?
 * @property {boolean} getUserMedia - Does the device support the getUserMedia API?
 * @property {boolean} littleEndian - Is the device big or little endian? (only detected if the browser supports TypedArrays)
 * @property {boolean} localStorage - Is localStorage available?
 * @property {boolean} pointerLock - Is Pointer Lock available?
 * @property {boolean} support32bit - Does the device context support 32bit pixel manipulation using array buffer views?
 * @property {boolean} vibration - Does the device support the Vibration API?
 * @property {boolean} webGL - Is webGL available?
 * @property {boolean} worker - Is worker available?
 */ var Features = {
                canvas: false,
                canvasBitBltShift: null,
                file: false,
                fileSystem: false,
                getUserMedia: true,
                littleEndian: false,
                localStorage: false,
                pointerLock: false,
                support32bit: false,
                vibration: false,
                webGL: false,
                worker: false
            };
            // Check Little or Big Endian system.
            // @author Matt DesLauriers (@mattdesl)
            function checkIsLittleEndian() {
                var a = new ArrayBuffer(4);
                var b = new Uint8Array(a);
                var c = new Uint32Array(a);
                b[0] = 0xa1;
                b[1] = 0xb2;
                b[2] = 0xc3;
                b[3] = 0xd4;
                if (c[0] === 0xd4c3b2a1) return true;
                if (c[0] === 0xa1b2c3d4) return false;
                else //  Could not determine endianness
                return null;
            }
            function init() {
                Features.canvas = !!window['CanvasRenderingContext2D'];
                try {
                    Features.localStorage = !!localStorage.getItem;
                } catch (error) {
                    Features.localStorage = false;
                }
                Features.file = !!window['File'] && !!window['FileReader'] && !!window['FileList'] && !!window['Blob'];
                Features.fileSystem = !!window['requestFileSystem'];
                var isUint8 = false;
                var testWebGL = function() {
                    if (window['WebGLRenderingContext']) try {
                        var canvas = CanvasPool.createWebGL(this);
                        var ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
                        var canvas2D = CanvasPool.create2D(this);
                        var ctx2D = canvas2D.getContext('2d');
                        //  Can't be done on a webgl context
                        var image = ctx2D.createImageData(1, 1);
                        //  Test to see if ImageData uses CanvasPixelArray or Uint8ClampedArray.
                        //  @author Matt DesLauriers (@mattdesl)
                        isUint8 = image.data instanceof Uint8ClampedArray;
                        CanvasPool.remove(canvas);
                        CanvasPool.remove(canvas2D);
                        return !!ctx;
                    } catch (e) {
                        return false;
                    }
                    return false;
                };
                Features.webGL = testWebGL();
                Features.worker = !!window['Worker'];
                Features.pointerLock = 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document;
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
                window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
                Features.getUserMedia = Features.getUserMedia && !!navigator.getUserMedia && !!window.URL;
                // Older versions of firefox (< 21) apparently claim support but user media does not actually work
                if (Browser.firefox && Browser.firefoxVersion < 21) Features.getUserMedia = false;
                // Excludes iOS versions as they generally wrap UIWebView (eg. Safari WebKit) and it
                // is safer to not try and use the fast copy-over method.
                if (!OS.iOS && (Browser.ie || Browser.firefox || Browser.chrome)) Features.canvasBitBltShift = true;
                // Known not to work
                if (Browser.safari || Browser.mobileSafari) Features.canvasBitBltShift = false;
                navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
                if (navigator.vibrate) Features.vibration = true;
                if (typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint32Array !== 'undefined') Features.littleEndian = checkIsLittleEndian();
                Features.support32bit = typeof ArrayBuffer !== 'undefined' && typeof Uint8ClampedArray !== 'undefined' && typeof Int32Array !== 'undefined' && Features.littleEndian !== null && isUint8;
                return Features;
            }
            module1.exports = init();
        /***/ },
        /* 189 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Browser specific prefix, so not going to change between contexts, only between browsers
            var prefix = '';
            /**
 * @namespace Phaser.Display.Canvas.Smoothing
 * @since 3.0.0
 */ var Smoothing = function() {
                /**
     * Gets the Smoothing Enabled vendor prefix being used on the given context, or null if not set.
     *
     * @function Phaser.Display.Canvas.Smoothing.getPrefix
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The canvas context to check.
     *
     * @return {string} The name of the property on the context which controls image smoothing (either `imageSmoothingEnabled` or a vendor-prefixed version thereof), or `null` if not supported.
     */ var getPrefix = function(context) {
                    var vendors = [
                        'i',
                        'webkitI',
                        'msI',
                        'mozI',
                        'oI'
                    ];
                    for(var i = 0; i < vendors.length; i++){
                        var s = vendors[i] + 'mageSmoothingEnabled';
                        if (s in context) return s;
                    }
                    return null;
                };
                /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.enable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to enable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var enable = function(context) {
                    if (prefix === '') prefix = getPrefix(context);
                    if (prefix) context[prefix] = true;
                    return context;
                };
                /**
     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
     * drawn to the context will be affected. This sets the property across all current browsers but support is
     * patchy on earlier browsers, especially on mobile.
     *
     * @function Phaser.Display.Canvas.Smoothing.disable
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context on which to disable smoothing.
     *
     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} The provided context.
     */ var disable = function(context) {
                    if (prefix === '') prefix = getPrefix(context);
                    if (prefix) context[prefix] = false;
                    return context;
                };
                /**
     * Returns `true` if the given context has image smoothing enabled, otherwise returns `false`.
     * Returns null if no smoothing prefix is available.
     *
     * @function Phaser.Display.Canvas.Smoothing.isEnabled
     * @since 3.0.0
     *
     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - The context to check.
     *
     * @return {?boolean} `true` if smoothing is enabled on the context, otherwise `false`. `null` if not supported.
     */ var isEnabled = function(context) {
                    return prefix !== null ? context[prefix] : null;
                };
                return {
                    disable: disable,
                    enable: enable,
                    getPrefix: getPrefix,
                    isEnabled: isEnabled
                };
            };
            module1.exports = Smoothing();
        /***/ },
        /* 190 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Math
 */ var PhaserMath = {
                //  Collections of functions
                Angle: __webpack_require__(809),
                Distance: __webpack_require__(818),
                Easing: __webpack_require__(823),
                Fuzzy: __webpack_require__(824),
                Interpolation: __webpack_require__(827),
                Pow2: __webpack_require__(832),
                Snap: __webpack_require__(834),
                //  Expose the RNG Class
                RandomDataGenerator: __webpack_require__(836),
                //  Single functions
                Average: __webpack_require__(837),
                Bernstein: __webpack_require__(350),
                Between: __webpack_require__(192),
                CatmullRom: __webpack_require__(191),
                CeilTo: __webpack_require__(838),
                Clamp: __webpack_require__(18),
                DegToRad: __webpack_require__(35),
                Difference: __webpack_require__(839),
                Euler: __webpack_require__(840),
                Factorial: __webpack_require__(351),
                FloatBetween: __webpack_require__(135),
                FloorTo: __webpack_require__(841),
                FromPercent: __webpack_require__(95),
                GetSpeed: __webpack_require__(842),
                IsEven: __webpack_require__(843),
                IsEvenStrict: __webpack_require__(844),
                Linear: __webpack_require__(133),
                MaxAdd: __webpack_require__(845),
                MinSub: __webpack_require__(846),
                Percent: __webpack_require__(847),
                RadToDeg: __webpack_require__(193),
                RandomXY: __webpack_require__(848),
                RandomXYZ: __webpack_require__(849),
                RandomXYZW: __webpack_require__(850),
                Rotate: __webpack_require__(356),
                RotateAround: __webpack_require__(302),
                RotateAroundDistance: __webpack_require__(179),
                RotateTo: __webpack_require__(851),
                RoundAwayFromZero: __webpack_require__(357),
                RoundTo: __webpack_require__(852),
                SinCosTableGenerator: __webpack_require__(853),
                SmootherStep: __webpack_require__(180),
                SmoothStep: __webpack_require__(181),
                ToXY: __webpack_require__(854),
                TransformXY: __webpack_require__(174),
                Within: __webpack_require__(855),
                Wrap: __webpack_require__(66),
                //  Vector classes
                Vector2: __webpack_require__(3),
                Vector3: __webpack_require__(38),
                Vector4: __webpack_require__(138),
                Matrix3: __webpack_require__(358),
                Matrix4: __webpack_require__(67),
                Quaternion: __webpack_require__(359),
                RotateVec3: __webpack_require__(856)
            };
            //   Merge in the consts
            PhaserMath = Extend(false, PhaserMath, CONST);
            //  Export it
            module1.exports = PhaserMath;
        /***/ },
        /* 191 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates a Catmull-Rom value from the given points, based on an alpha of 0.5.
 *
 * @function Phaser.Math.CatmullRom
 * @since 3.0.0
 *
 * @param {number} t - The amount to interpolate by.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 *
 * @return {number} The Catmull-Rom value.
 */ var CatmullRom = function(t, p0, p1, p2, p3) {
                var v0 = (p2 - p0) * 0.5;
                var v1 = (p3 - p1) * 0.5;
                var t2 = t * t;
                var t3 = t * t2;
                return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
            };
            module1.exports = CatmullRom;
        /***/ },
        /* 192 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random integer between the `min` and `max` values, inclusive.
 *
 * @function Phaser.Math.Between
 * @since 3.0.0
 *
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 *
 * @return {number} The random integer.
 */ var Between = function(min, max) {
                return Math.floor(Math.random() * (max - min + 1) + min);
            };
            module1.exports = Between;
        /***/ },
        /* 193 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Convert the given angle in radians, to the equivalent angle in degrees.
 *
 * @function Phaser.Math.RadToDeg
 * @since 3.0.0
 *
 * @param {number} radians - The angle in radians to convert ot degrees.
 *
 * @return {number} The given angle converted to degrees.
 */ var RadToDeg = function(radians) {
                return radians * CONST.RAD_TO_DEG;
            };
            module1.exports = RadToDeg;
        /***/ },
        /* 194 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Default Plugins.
 * 
 * @namespace Phaser.Plugins.DefaultPlugins
 * @memberof Phaser.Plugins
 * @since 3.0.0
 */ var DefaultPlugins = {
                /**
     * These are the Global Managers that are created by the Phaser.Game instance.
     * They are referenced from Scene.Systems so that plugins can use them.
     *
     * @name Phaser.Plugins.DefaultPlugins.Global
     * @type {array}
     * @since 3.0.0
     */ Global: [
                    'game',
                    'anims',
                    'cache',
                    'plugins',
                    'registry',
                    'scale',
                    'sound',
                    'textures',
                    'renderer'
                ],
                /**
     * These are the core plugins that are installed into every Scene.Systems instance, no matter what.
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are created in the order in which they appear in this array and EventEmitter is always first.
     *
     * @name Phaser.Plugins.DefaultPlugins.CoreScene
     * @type {array}
     * @since 3.0.0
     */ CoreScene: [
                    'EventEmitter',
                    'CameraManager',
                    'GameObjectCreator',
                    'GameObjectFactory',
                    'ScenePlugin',
                    'DisplayList',
                    'UpdateList'
                ],
                /**
     * These plugins are created in Scene.Systems in addition to the CoreScenePlugins.
     *
     * You can elect not to have these plugins by either creating a DefaultPlugins object as part
     * of the Game Config, by creating a Plugins object as part of a Scene Config, or by modifying this array
     * and building your own bundle.
     *
     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
     *
     * They are always created in the order in which they appear in the array.
     *
     * @name Phaser.Plugins.DefaultPlugins.DefaultScene
     * @type {array}
     * @since 3.0.0
     */ DefaultScene: [
                    'Clock',
                    'DataManagerPlugin',
                    'InputPlugin',
                    'Loader',
                    'TweenManager',
                    'LightsPlugin'
                ]
            };
            module1.exports = DefaultPlugins;
        /***/ },
        /* 195 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * The ColorMatrix class creates a 5x4 matrix that can be used in shaders and graphics
 * operations. It provides methods required to modify the color values, such as adjusting
 * the brightness, setting a sepia tone, hue rotation and more.
 *
 * Use the method `getData` to return a Float32Array containing the current color values.
 *
 * @class ColorMatrix
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 */ var ColorMatrix = new Class({
                initialize: function ColorMatrix() {
                    /**
         * Internal ColorMatrix array.
         *
         * @name Phaser.Display.ColorMatrix#_matrix
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this._matrix = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ];
                    /**
         * The value that determines how much of the original color is used
         * when mixing the colors. A value between 0 (all original) and 1 (all final)
         *
         * @name Phaser.Display.ColorMatrix#alpha
         * @type {number}
         * @since 3.50.0
         */ this.alpha = 1;
                    /**
         * Is the ColorMatrix array dirty?
         *
         * @name Phaser.Display.ColorMatrix#_dirty
         * @type {boolean}
         * @private
         * @since 3.50.0
         */ this._dirty = true;
                    /**
         * The matrix data as a Float32Array.
         *
         * Returned by the `getData` method.
         *
         * @name Phaser.Display.ColorMatrix#data
         * @type {Float32Array}
         * @private
         * @since 3.50.0
         */ this._data;
                },
                /**
     * Sets this ColorMatrix from the given array of color values.
     *
     * @method Phaser.Display.ColorMatrix#set
     * @since 3.50.0
     *
     * @param {number[]} value - The ColorMatrix values to set.
     *
     * @return {this} This ColorMatrix instance.
     */ set: function(value) {
                    this._matrix = value;
                    this._dirty = true;
                    return this;
                },
                /**
     * Resets the ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#reset
     * @since 3.50.0
     *
     * @return {this} This ColorMatrix instance.
     */ reset: function() {
                    //  Long-winded, but saves on gc, which happens a lot in Post FX Shaders
                    //  that reset the ColorMatrix every frame.
                    var m = this._matrix;
                    m[0] = 1;
                    m[1] = 0;
                    m[2] = 0;
                    m[3] = 0;
                    m[4] = 0;
                    m[5] = 0;
                    m[6] = 1;
                    m[7] = 0;
                    m[8] = 0;
                    m[9] = 0;
                    m[10] = 0;
                    m[11] = 0;
                    m[12] = 1;
                    m[13] = 0;
                    m[14] = 0;
                    m[15] = 0;
                    m[16] = 0;
                    m[17] = 0;
                    m[18] = 1;
                    m[19] = 0;
                    this._dirty = true;
                    return this;
                },
                /**
     * Gets the ColorMatrix as a Float32Array.
     *
     * Can be used directly as a 1fv shader uniform value.
     *
     * @method Phaser.Display.ColorMatrix#getData
     * @since 3.50.0
     *
     * @return {Float32Array} The ColorMatrix as a Float32Array.
     */ getData: function() {
                    if (this._dirty) {
                        var f32 = new Float32Array(this._matrix);
                        f32[4] /= 255;
                        f32[9] /= 255;
                        f32[14] /= 255;
                        f32[19] /= 255;
                        this._data = f32;
                        this._dirty = false;
                    }
                    return this._data;
                },
                /**
     * Changes the brightness of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#brightness
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of brightness to apply to this ColorMatrix. Between 0 (black) and 1.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brightness: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var b = value;
                    return this.multiply([
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Changes the saturation of this ColorMatrix by the given amount.
     *
     * @method Phaser.Display.ColorMatrix#saturate
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of saturation to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ saturate: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var x = value * 2 / 3 + 1;
                    var y = (x - 1) * -0.5;
                    return this.multiply([
                        x,
                        y,
                        y,
                        0,
                        0,
                        y,
                        x,
                        y,
                        0,
                        0,
                        y,
                        y,
                        x,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Desaturates this ColorMatrix (removes color from it).
     *
     * @method Phaser.Display.ColorMatrix#saturation
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturate: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.saturate(-1, multiply);
                },
                /**
     * Rotates the hues of this ColorMatrix by the value given.
     *
     * @method Phaser.Display.ColorMatrix#hue
     * @since 3.50.0
     *
     * @param {number} [rotation=0] - The amount of hue rotation to apply to this ColorMatrix, in degrees.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ hue: function(rotation, multiply) {
                    if (rotation === undefined) rotation = 0;
                    if (multiply === undefined) multiply = false;
                    rotation = rotation / 180 * Math.PI;
                    var cos = Math.cos(rotation);
                    var sin = Math.sin(rotation);
                    var lumR = 0.213;
                    var lumG = 0.715;
                    var lumB = 0.072;
                    return this.multiply([
                        lumR + cos * (1 - lumR) + sin * -lumR,
                        lumG + cos * -lumG + sin * -lumG,
                        lumB + cos * -lumB + sin * (1 - lumB),
                        0,
                        0,
                        lumR + cos * -lumR + sin * 0.143,
                        lumG + cos * (1 - lumG) + sin * 0.140,
                        lumB + cos * -lumB + sin * -0.283,
                        0,
                        0,
                        lumR + cos * -lumR + sin * -(1 - lumR),
                        lumG + cos * -lumG + sin * lumG,
                        lumB + cos * (1 - lumB) + sin * lumB,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Sets this ColorMatrix to be grayscale.
     *
     * @method Phaser.Display.ColorMatrix#grayscale
     * @since 3.50.0
     *
     * @param {number} [value=1] - The grayscale scale (0 is black).
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ grayscale: function(value, multiply) {
                    if (value === undefined) value = 1;
                    if (multiply === undefined) multiply = false;
                    return this.saturate(-value, multiply);
                },
                /**
     * Sets this ColorMatrix to be black and white.
     *
     * @method Phaser.Display.ColorMatrix#blackWhite
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ blackWhite: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0.3,
                        0.6,
                        0.1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Change the contrast of this ColorMatrix by the amount given.
     *
     * @method Phaser.Display.ColorMatrix#contrast
     * @since 3.50.0
     *
     * @param {number} [value=0] - The amount of contrast to apply to this ColorMatrix.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ contrast: function(value, multiply) {
                    if (value === undefined) value = 0;
                    if (multiply === undefined) multiply = false;
                    var v = value + 1;
                    var o = -0.5 * (v - 1);
                    return this.multiply([
                        v,
                        0,
                        0,
                        0,
                        o,
                        0,
                        v,
                        0,
                        0,
                        o,
                        0,
                        0,
                        v,
                        0,
                        o,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Converts this ColorMatrix to have negative values.
     *
     * @method Phaser.Display.ColorMatrix#negative
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ negative: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0,
                        -1,
                        0,
                        1,
                        0,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Apply a desaturated luminance to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#desaturateLuminance
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ desaturateLuminance: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0.2764723,
                        0.9297080,
                        0.0938197,
                        0,
                        -37.1,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a sepia tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#sepia
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ sepia: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.393,
                        0.7689999,
                        0.18899999,
                        0,
                        0,
                        0.349,
                        0.6859999,
                        0.16799999,
                        0,
                        0,
                        0.272,
                        0.5339999,
                        0.13099999,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a night vision tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#night
     * @since 3.50.0
     *
     * @param {number} [intensity=0.1] - The intensity of this effect.
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ night: function(intensity, multiply) {
                    if (intensity === undefined) intensity = 0.1;
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        intensity * -2,
                        -intensity,
                        0,
                        0,
                        0,
                        -intensity,
                        0,
                        intensity,
                        0,
                        0,
                        0,
                        intensity,
                        intensity * 2.0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a trippy color tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#lsd
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ lsd: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        2,
                        -0.4,
                        0.5,
                        0,
                        0,
                        -0.5,
                        2,
                        -0.4,
                        0,
                        0,
                        -0.4,
                        -0.5,
                        3,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a brown tone to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#brown
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ brown: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.5997023498159715,
                        0.34553243048391263,
                        -0.2708298674538042,
                        0,
                        47.43192855600873,
                        -0.037703249837783157,
                        0.8609577587992641,
                        0.15059552388459913,
                        0,
                        -36.96841498319127,
                        0.24113635128153335,
                        -0.07441037908422492,
                        0.44972182064877153,
                        0,
                        -7.562075277591283,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a vintage pinhole color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#vintagePinhole
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ vintagePinhole: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0.6279345635605994,
                        0.3202183420819367,
                        -0.03965408211312453,
                        0,
                        9.651285835294123,
                        0.02578397704808868,
                        0.6441188644374771,
                        0.03259127616149294,
                        0,
                        7.462829176470591,
                        0.0466055556782719,
                        -0.0851232987247891,
                        0.5241648018700465,
                        0,
                        5.159190588235296,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a kodachrome color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#kodachrome
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ kodachrome: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.1285582396593525,
                        -0.3967382283601348,
                        -0.03992559172921793,
                        0,
                        63.72958762196502,
                        -0.16404339962244616,
                        1.0835251566291304,
                        -0.05498805115633132,
                        0,
                        24.732407896706203,
                        -0.16786010706155763,
                        -0.5603416277695248,
                        1.6014850761964943,
                        0,
                        35.62982807460946,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a technicolor color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#technicolor
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ technicolor: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.9125277891456083,
                        -0.8545344976951645,
                        -0.09155508482755585,
                        0,
                        11.793603434377337,
                        -0.3087833385928097,
                        1.7658908555458428,
                        -0.10601743074722245,
                        0,
                        -70.35205161461398,
                        -0.231103377548616,
                        -0.7501899197440212,
                        1.847597816108189,
                        0,
                        30.950940869491138,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Applies a polaroid color effect to this ColorMatrix.
     *
     * @method Phaser.Display.ColorMatrix#polaroid
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ polaroid: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        1.438,
                        -0.062,
                        -0.062,
                        0,
                        0,
                        -0.122,
                        1.378,
                        -0.122,
                        0,
                        0,
                        -0.016,
                        -0.016,
                        1.483,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Shifts the values of this ColorMatrix into BGR order.
     *
     * @method Phaser.Display.ColorMatrix#shiftToBGR
     * @since 3.50.0
     *
     * @param {boolean} [multiply=false] - Multiply the resulting ColorMatrix (`true`), or set it (`false`) ?
     *
     * @return {this} This ColorMatrix instance.
     */ shiftToBGR: function(multiply) {
                    if (multiply === undefined) multiply = false;
                    return this.multiply([
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ], multiply);
                },
                /**
     * Multiplies the two given matrices.
     *
     * @method Phaser.Display.ColorMatrix#multiply
     * @since 3.50.0
     *
     * @param {number[]} a - The 5x4 array to multiply with ColorMatrix._matrix.
     *
     * @return {this} This ColorMatrix instance.
     */ multiply: function(a, multiply) {
                    //  Duplicate _matrix into c
                    if (!multiply) this.reset();
                    var m = this._matrix;
                    var c = [];
                    for(var i = 0; i < 20; i++)c[i] = m[i];
                    //  R
                    m[0] = c[0] * a[0] + c[1] * a[5] + c[2] * a[10] + c[3] * a[15];
                    m[1] = c[0] * a[1] + c[1] * a[6] + c[2] * a[11] + c[3] * a[16];
                    m[2] = c[0] * a[2] + c[1] * a[7] + c[2] * a[12] + c[3] * a[17];
                    m[3] = c[0] * a[3] + c[1] * a[8] + c[2] * a[13] + c[3] * a[18];
                    m[4] = c[0] * a[4] + c[1] * a[9] + c[2] * a[14] + c[3] * a[19] + c[4];
                    //  G
                    m[5] = c[5] * a[0] + c[6] * a[5] + c[7] * a[10] + c[8] * a[15];
                    m[6] = c[5] * a[1] + c[6] * a[6] + c[7] * a[11] + c[8] * a[16];
                    m[7] = c[5] * a[2] + c[6] * a[7] + c[7] * a[12] + c[8] * a[17];
                    m[8] = c[5] * a[3] + c[6] * a[8] + c[7] * a[13] + c[8] * a[18];
                    m[9] = c[5] * a[4] + c[6] * a[9] + c[7] * a[14] + c[8] * a[19] + c[9];
                    //  B
                    m[10] = c[10] * a[0] + c[11] * a[5] + c[12] * a[10] + c[13] * a[15];
                    m[11] = c[10] * a[1] + c[11] * a[6] + c[12] * a[11] + c[13] * a[16];
                    m[12] = c[10] * a[2] + c[11] * a[7] + c[12] * a[12] + c[13] * a[17];
                    m[13] = c[10] * a[3] + c[11] * a[8] + c[12] * a[13] + c[13] * a[18];
                    m[14] = c[10] * a[4] + c[11] * a[9] + c[12] * a[14] + c[13] * a[19] + c[14];
                    //  A
                    m[15] = c[15] * a[0] + c[16] * a[5] + c[17] * a[10] + c[18] * a[15];
                    m[16] = c[15] * a[1] + c[16] * a[6] + c[17] * a[11] + c[18] * a[16];
                    m[17] = c[15] * a[2] + c[16] * a[7] + c[17] * a[12] + c[18] * a[17];
                    m[18] = c[15] * a[3] + c[16] * a[8] + c[17] * a[13] + c[18] * a[18];
                    m[19] = c[15] * a[4] + c[16] * a[9] + c[17] * a[14] + c[18] * a[19] + c[19];
                    this._dirty = true;
                    return this;
                }
            });
            module1.exports = ColorMatrix;
        /***/ },
        /* 196 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var MATH_CONST = __webpack_require__(14);
            //  points is an array of Point-like objects,
            //  either 2 dimensional arrays, or objects with public x/y properties:
            //  var points = [
            //      [100, 200],
            //      [200, 400],
            //      { x: 30, y: 60 }
            //  ]
            /**
 * Constructs new Rectangle or repositions and resizes an existing Rectangle so that all of the given points are on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.FromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {array} points - An array of points (either arrays with two elements corresponding to the X and Y coordinate or an object with public `x` and `y` properties) which should be surrounded by the Rectangle.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromPoints = function(points, out) {
                if (out === undefined) out = new Rectangle();
                if (points.length === 0) return out;
                var minX = Number.MAX_VALUE;
                var minY = Number.MAX_VALUE;
                var maxX = MATH_CONST.MIN_SAFE_INTEGER;
                var maxY = MATH_CONST.MIN_SAFE_INTEGER;
                var p;
                var px;
                var py;
                for(var i = 0; i < points.length; i++){
                    p = points[i];
                    if (Array.isArray(p)) {
                        px = p[0];
                        py = p[1];
                    } else {
                        px = p.x;
                        py = p.y;
                    }
                    minX = Math.min(minX, px);
                    minY = Math.min(minY, py);
                    maxX = Math.max(maxX, px);
                    maxY = Math.max(maxY, py);
                }
                out.x = minX;
                out.y = minY;
                out.width = maxX - minX;
                out.height = maxY - minY;
                return out;
            };
            module1.exports = FromPoints;
        /***/ },
        /* 197 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * The RGB class holds a single color value and allows for easy modification and reading of it,
 * with optional on-change callback notification and a dirty flag.
 *
 * @class RGB
 * @memberof Phaser.Display
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [red=0] - The red color value. A number between 0 and 1.
 * @param {number} [green=0] - The green color value. A number between 0 and 1.
 * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
 */ var RGB = new Class({
                initialize: function RGB(red, green, blue) {
                    /**
         * Cached RGB values.
         *
         * @name Phaser.Display.RGB#_rgb
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this._rgb = [
                        0,
                        0,
                        0
                    ];
                    /**
         * This callback will be invoked each time one of the RGB color values change.
         *
         * The callback is sent the new color values as the parameters.
         *
         * @name Phaser.Display.RGB#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                    /**
         * Is this color dirty?
         *
         * @name Phaser.Display.RGB#dirty
         * @type {boolean}
         * @since 3.50.0
         */ this.dirty = false;
                    this.set(red, green, blue);
                },
                /**
     * Sets the red, green and blue values of this RGB object, flags it as being
     * dirty and then invokes the `onChangeCallback`, if set.
     *
     * @method Phaser.Display.RGB#set
     * @since 3.50.0
     *
     * @param {number} [red=0] - The red color value. A number between 0 and 1.
     * @param {number} [green=0] - The green color value. A number between 0 and 1.
     * @param {number} [blue=0] - The blue color value. A number between 0 and 1.
     *
     * @return {this} This RGB instance.
     */ set: function(red, green, blue) {
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    this._rgb = [
                        red,
                        green,
                        blue
                    ];
                    this.onChange();
                    return this;
                },
                /**
     * Compares the given rgb parameters with those in this object and returns
     * a boolean `true` value if they are equal, otherwise it returns `false`.
     *
     * @method Phaser.Display.RGB#equals
     * @since 3.50.0
     *
     * @param {number} red - The red value to compare with this object.
     * @param {number} green - The green value to compare with this object.
     * @param {number} blue - The blue value to compare with this object.
     *
     * @return {boolean} `true` if the given values match those in this object, otherwise `false`.
     */ equals: function(red, green, blue) {
                    var rgb = this._rgb;
                    return rgb.r === red && rgb.g === green && rgb.b === blue;
                },
                /**
     * Internal on change handler. Sets this object as being dirty and
     * then invokes the `onChangeCallback`, if set, passing in the
     * new RGB values.
     *
     * @method Phaser.Display.RGB#onChange
     * @since 3.50.0
     */ onChange: function() {
                    this.dirty = true;
                    var rgb = this._rgb;
                    this.onChangeCallback.call(this, rgb[0], rgb[1], rgb[2]);
                },
                /**
     * The red color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#r
     * @type {number}
     * @since 3.50.0
     */ r: {
                    get: function() {
                        return this._rgb[0];
                    },
                    set: function(value) {
                        this._rgb[0] = value;
                        this.onChange();
                    }
                },
                /**
     * The green color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#g
     * @type {number}
     * @since 3.50.0
     */ g: {
                    get: function() {
                        return this._rgb[1];
                    },
                    set: function(value) {
                        this._rgb[1] = value;
                        this.onChange();
                    }
                },
                /**
     * The blue color value. Between 0 and 1.
     *
     * Changing this property will flag this RGB object as being dirty
     * and invoke the `onChangeCallback` , if set.
     *
     * @name Phaser.Display.RGB#b
     * @type {number}
     * @since 3.50.0
     */ b: {
                    get: function() {
                        return this._rgb[2];
                    },
                    set: function(value) {
                        this._rgb[2] = value;
                        this.onChange();
                    }
                },
                /**
     * Nulls any external references this object contains.
     *
     * @method Phaser.Display.RGB#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.onChangeCallback = null;
                }
            });
            module1.exports = RGB;
        /***/ },
        /* 198 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                CENTER: __webpack_require__(397),
                ORIENTATION: __webpack_require__(398),
                SCALE_MODE: __webpack_require__(399),
                ZOOM: __webpack_require__(400)
            };
            module1.exports = CONST;
        /***/ },
        /* 199 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to remove the element from its parentNode in the DOM.
 *
 * @function Phaser.DOM.RemoveFromDOM
 * @since 3.0.0
 *
 * @param {HTMLElement} element - The DOM element to remove from its parent node.
 */ var RemoveFromDOM = function(element) {
                if (element.parentNode) element.parentNode.removeChild(element);
            };
            module1.exports = RemoveFromDOM;
        /***/ },
        /* 200 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var INPUT_CONST = {
                /**
     * The mouse pointer is being held down.
     * 
     * @name Phaser.Input.MOUSE_DOWN
     * @type {number}
     * @since 3.10.0
     */ MOUSE_DOWN: 0,
                /**
     * The mouse pointer is being moved.
     * 
     * @name Phaser.Input.MOUSE_MOVE
     * @type {number}
     * @since 3.10.0
     */ MOUSE_MOVE: 1,
                /**
     * The mouse pointer is released.
     * 
     * @name Phaser.Input.MOUSE_UP
     * @type {number}
     * @since 3.10.0
     */ MOUSE_UP: 2,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_START
     * @type {number}
     * @since 3.10.0
     */ TOUCH_START: 3,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_MOVE
     * @type {number}
     * @since 3.10.0
     */ TOUCH_MOVE: 4,
                /**
     * A touch pointer has been started.
     * 
     * @name Phaser.Input.TOUCH_END
     * @type {number}
     * @since 3.10.0
     */ TOUCH_END: 5,
                /**
     * The pointer lock has changed.
     * 
     * @name Phaser.Input.POINTER_LOCK_CHANGE
     * @type {number}
     * @since 3.10.0
     */ POINTER_LOCK_CHANGE: 6,
                /**
     * A touch pointer has been been cancelled by the browser.
     * 
     * @name Phaser.Input.TOUCH_CANCEL
     * @type {number}
     * @since 3.15.0
     */ TOUCH_CANCEL: 7,
                /**
     * The mouse wheel changes.
     * 
     * @name Phaser.Input.MOUSE_WHEEL
     * @type {number}
     * @since 3.18.0
     */ MOUSE_WHEEL: 8
            };
            module1.exports = INPUT_CONST;
        /***/ },
        /* 201 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(142);
            var DefaultPlugins = __webpack_require__(194);
            var Events = __webpack_require__(21);
            var GetPhysicsPlugins = __webpack_require__(413);
            var GetScenePlugins = __webpack_require__(414);
            var GLOBAL_CONST = __webpack_require__(32);
            var NOOP = __webpack_require__(1);
            var Settings = __webpack_require__(415);
            /**
 * @classdesc
 * The Scene Systems class.
 *
 * This class is available from within a Scene under the property `sys`.
 * It is responsible for managing all of the plugins a Scene has running, including the display list, and
 * handling the update step and renderer. It also contains references to global systems belonging to Game.
 *
 * @class Systems
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns this Systems instance.
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - Scene specific configuration settings.
 */ var Systems = new Class({
                initialize: function Systems(scene, config) {
                    /**
         * A reference to the Scene that these Systems belong to.
         *
         * @name Phaser.Scenes.Systems#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Phaser Game instance.
         *
         * @name Phaser.Scenes.Systems#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Scenes.Systems#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer;
                    /**
         * The Scene Configuration object, as passed in when creating the Scene.
         *
         * @name Phaser.Scenes.Systems#config
         * @type {(string|Phaser.Types.Scenes.SettingsConfig)}
         * @since 3.0.0
         */ this.config = config;
                    /**
         * The Scene Settings. This is the parsed output based on the Scene configuration.
         *
         * @name Phaser.Scenes.Systems#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = Settings.create(config);
                    /**
         * A handy reference to the Scene canvas / context.
         *
         * @name Phaser.Scenes.Systems#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                    /**
         * A reference to the Canvas Rendering Context being used by the renderer.
         *
         * @name Phaser.Scenes.Systems#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context;
                    //  Global Systems - these are single-instance global managers that belong to Game
                    /**
         * A reference to the global Animations Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.anims` property.
         *
         * @name Phaser.Scenes.Systems#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                    /**
         * A reference to the global Cache. The Cache stores all files bought in to Phaser via
         * the Loader, with the exception of images. Images are stored in the Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.cache` property.
         *
         * @name Phaser.Scenes.Systems#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                    /**
         * A reference to the global Plugins Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.plugins` property.
         *
         * @name Phaser.Scenes.Systems#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                    /**
         * A reference to the global registry. This is a game-wide instance of the Data Manager, allowing
         * you to exchange data between Scenes via a universal and shared point.
         *
         * In the default set-up you can access this from within a Scene via the `this.registry` property.
         *
         * @name Phaser.Scenes.Systems#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                    /**
         * A reference to the global Scale Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.scale` property.
         *
         * @name Phaser.Scenes.Systems#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.15.0
         */ this.scale;
                    /**
         * A reference to the global Sound Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.sound` property.
         *
         * @name Phaser.Scenes.Systems#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound;
                    /**
         * A reference to the global Texture Manager.
         *
         * In the default set-up you can access this from within a Scene via the `this.textures` property.
         *
         * @name Phaser.Scenes.Systems#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                    //  Core Plugins - these are non-optional Scene plugins, needed by lots of the other systems
                    /**
         * A reference to the Scene's Game Object Factory.
         *
         * Use this to quickly and easily create new Game Object's.
         *
         * In the default set-up you can access this from within a Scene via the `this.add` property.
         *
         * @name Phaser.Scenes.Systems#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                    /**
         * A reference to the Scene's Camera Manager.
         *
         * Use this to manipulate and create Cameras for this specific Scene.
         *
         * In the default set-up you can access this from within a Scene via the `this.cameras` property.
         *
         * @name Phaser.Scenes.Systems#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    /**
         * A reference to the Scene's Display List.
         *
         * Use this to organize the children contained in the display list.
         *
         * In the default set-up you can access this from within a Scene via the `this.children` property.
         *
         * @name Phaser.Scenes.Systems#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene's Event Manager.
         *
         * Use this to listen for Scene specific events, such as `pause` and `shutdown`.
         *
         * In the default set-up you can access this from within a Scene via the `this.events` property.
         *
         * @name Phaser.Scenes.Systems#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                    /**
         * A reference to the Scene's Game Object Creator.
         *
         * Use this to quickly and easily create new Game Object's. The difference between this and the
         * Game Object Factory, is that the Creator just creates and returns Game Object instances, it
         * doesn't then add them to the Display List or Update List.
         *
         * In the default set-up you can access this from within a Scene via the `this.make` property.
         *
         * @name Phaser.Scenes.Systems#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                    /**
         * A reference to the Scene Manager Plugin.
         *
         * Use this to manipulate both this and other Scene's in your game, for example to launch a parallel Scene,
         * or pause or resume a Scene, or switch from this Scene to another.
         *
         * In the default set-up you can access this from within a Scene via the `this.scene` property.
         *
         * @name Phaser.Scenes.Systems#scenePlugin
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scenePlugin;
                    /**
         * A reference to the Scene's Update List.
         *
         * Use this to organize the children contained in the update list.
         *
         * The Update List is responsible for managing children that need their `preUpdate` methods called,
         * in order to process so internal components, such as Sprites with Animations.
         *
         * In the default set-up there is no reference to this from within the Scene itself.
         *
         * @name Phaser.Scenes.Systems#updateList
         * @type {Phaser.GameObjects.UpdateList}
         * @since 3.0.0
         */ this.updateList;
                    /**
         * The Scene Update function.
         *
         * This starts out as NOOP during init, preload and create, and at the end of create
         * it swaps to be whatever the Scene.update function is.
         *
         * @name Phaser.Scenes.Systems#sceneUpdate
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.sceneUpdate = NOOP;
                },
                /**
     * This method is called only once by the Scene Manager when the Scene is instantiated.
     * It is responsible for setting up all of the Scene plugins and references.
     * It should never be called directly.
     *
     * @method Phaser.Scenes.Systems#init
     * @protected
     * @fires Phaser.Scenes.Events#BOOT
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                    this.settings.status = CONST.INIT;
                    //  This will get replaced by the SceneManager with the actual update function, if it exists, once create is over.
                    this.sceneUpdate = NOOP;
                    this.game = game;
                    this.renderer = game.renderer;
                    this.canvas = game.canvas;
                    this.context = game.context;
                    var pluginManager = game.plugins;
                    this.plugins = pluginManager;
                    pluginManager.addToScene(this, DefaultPlugins.Global, [
                        DefaultPlugins.CoreScene,
                        GetScenePlugins(this),
                        GetPhysicsPlugins(this)
                    ]);
                    this.events.emit(Events.BOOT, this);
                    this.settings.isBooted = true;
                },
                /**
     * Called by a plugin, it tells the System to install the plugin locally.
     *
     * @method Phaser.Scenes.Systems#install
     * @private
     * @since 3.0.0
     *
     * @param {array} plugin - An array of plugins to install into this Scene.
     */ install: function(plugin) {
                    if (!Array.isArray(plugin)) plugin = [
                        plugin
                    ];
                    this.plugins.installLocal(this, plugin);
                },
                /**
     * A single game step. Called automatically by the Scene Manager as a result of a Request Animation
     * Frame or Set Timeout call to the main Game instance.
     *
     * @method Phaser.Scenes.Systems#step
     * @fires Phaser.Scenes.Events#PRE_UPDATE
     * @fires Phaser.Scenes.Events#UPDATE
     * @fires Phaser.Scenes.Events#POST_UPDATE
     * @since 3.0.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                    var events = this.events;
                    events.emit(Events.PRE_UPDATE, time, delta);
                    events.emit(Events.UPDATE, time, delta);
                    this.sceneUpdate.call(this.scene, time, delta);
                    events.emit(Events.POST_UPDATE, time, delta);
                },
                /**
     * Called automatically by the Scene Manager.
     * Instructs the Scene to render itself via its Camera Manager to the renderer given.
     *
     * @method Phaser.Scenes.Systems#render
     * @fires Phaser.Scenes.Events#RENDER
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that invoked the render call.
     */ render: function(renderer) {
                    var displayList = this.displayList;
                    displayList.depthSort();
                    this.cameras.render(renderer, displayList);
                    this.events.emit(Events.RENDER, renderer);
                },
                /**
     * Force a sort of the display list on the next render.
     *
     * @method Phaser.Scenes.Systems#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                    this.displayList.queueDepthSort();
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.Scenes.Systems#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                    this.displayList.depthSort();
                },
                /**
     * Pause this Scene.
     * A paused Scene still renders, it just doesn't run ANY of its update handlers or systems.
     *
     * @method Phaser.Scenes.Systems#pause
     * @fires Phaser.Scenes.Events#PAUSE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'pause' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ pause: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (this.settings.active) {
                        settings.status = CONST.PAUSED;
                        settings.active = false;
                        events.emit(Events.PAUSE, this, data);
                    }
                    return this;
                },
                /**
     * Resume this Scene from a paused state.
     *
     * @method Phaser.Scenes.Systems#resume
     * @fires Phaser.Scenes.Events#RESUME
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'resume' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ resume: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (!this.settings.active) {
                        settings.status = CONST.RUNNING;
                        settings.active = true;
                        events.emit(Events.RESUME, this, data);
                    }
                    return this;
                },
                /**
     * Send this Scene to sleep.
     *
     * A sleeping Scene doesn't run its update step or render anything, but it also isn't shut down
     * or has any of its systems or children removed, meaning it can be re-activated at any point and
     * will carry on from where it left off. It also keeps everything in memory and events and callbacks
     * from other Scenes may still invoke changes within it, so be careful what is left active.
     *
     * @method Phaser.Scenes.Systems#sleep
     * @fires Phaser.Scenes.Events#SLEEP
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'sleep' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ sleep: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.SLEEPING;
                    settings.active = false;
                    settings.visible = false;
                    events.emit(Events.SLEEP, this, data);
                    return this;
                },
                /**
     * Wake-up this Scene if it was previously asleep.
     *
     * @method Phaser.Scenes.Systems#wake
     * @fires Phaser.Scenes.Events#WAKE
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'wake' event.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ wake: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.RUNNING;
                    settings.active = true;
                    settings.visible = true;
                    events.emit(Events.WAKE, this, data);
                    if (settings.isTransition) events.emit(Events.TRANSITION_WAKE, settings.transitionFrom, settings.transitionDuration);
                    return this;
                },
                /**
     * Returns any data that was sent to this Scene by another Scene.
     *
     * The data is also passed to `Scene.init` and in various Scene events, but
     * you can access it at any point via this method.
     *
     * @method Phaser.Scenes.Systems#getData
     * @since 3.22.0
     *
     * @return {any}
     */ getData: function() {
                    return this.settings.data;
                },
                /**
     * Is this Scene sleeping?
     *
     * @method Phaser.Scenes.Systems#isSleeping
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is asleep, otherwise `false`.
     */ isSleeping: function() {
                    return this.settings.status === CONST.SLEEPING;
                },
                /**
     * Is this Scene running?
     *
     * @method Phaser.Scenes.Systems#isActive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is running, otherwise `false`.
     */ isActive: function() {
                    return this.settings.status === CONST.RUNNING;
                },
                /**
     * Is this Scene paused?
     *
     * @method Phaser.Scenes.Systems#isPaused
     * @since 3.13.0
     *
     * @return {boolean} `true` if this Scene is paused, otherwise `false`.
     */ isPaused: function() {
                    return this.settings.status === CONST.PAUSED;
                },
                /**
     * Is this Scene currently transitioning out to, or in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitioning
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is currently transitioning, otherwise `false`.
     */ isTransitioning: function() {
                    return this.settings.isTransition || this.scenePlugin._target !== null;
                },
                /**
     * Is this Scene currently transitioning out from itself to another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionOut
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is in transition to another Scene, otherwise `false`.
     */ isTransitionOut: function() {
                    return this.scenePlugin._target !== null && this.scenePlugin._duration > 0;
                },
                /**
     * Is this Scene currently transitioning in from another Scene?
     *
     * @method Phaser.Scenes.Systems#isTransitionIn
     * @since 3.5.0
     *
     * @return {boolean} `true` if this Scene is transitioning in from another Scene, otherwise `false`.
     */ isTransitionIn: function() {
                    return this.settings.isTransition;
                },
                /**
     * Is this Scene visible and rendering?
     *
     * @method Phaser.Scenes.Systems#isVisible
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Scene is visible, otherwise `false`.
     */ isVisible: function() {
                    return this.settings.visible;
                },
                /**
     * Sets the visible state of this Scene.
     * An invisible Scene will not render, but will still process updates.
     *
     * @method Phaser.Scenes.Systems#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to render this Scene, otherwise `false`.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setVisible: function(value) {
                    this.settings.visible = value;
                    return this;
                },
                /**
     * Set the active state of this Scene.
     *
     * An active Scene will run its core update loop.
     *
     * @method Phaser.Scenes.Systems#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - If `true` the Scene will be resumed, if previously paused. If `false` it will be paused.
     * @param {object} [data] - A data object that will be passed in the 'resume' or 'pause' events.
     *
     * @return {Phaser.Scenes.Systems} This Systems object.
     */ setActive: function(value, data) {
                    if (value) return this.resume(data);
                    else return this.pause(data);
                },
                /**
     * Start this Scene running and rendering.
     * Called automatically by the SceneManager.
     *
     * @method Phaser.Scenes.Systems#start
     * @fires Phaser.Scenes.Events#START
     * @fires Phaser.Scenes.Events#READY
     * @since 3.0.0
     *
     * @param {object} data - Optional data object that may have been passed to this Scene from another.
     */ start: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    if (data) settings.data = data;
                    settings.status = CONST.START;
                    settings.active = true;
                    settings.visible = true;
                    //  For plugins to listen out for
                    events.emit(Events.START, this);
                    //  For user-land code to listen out for
                    events.emit(Events.READY, this, data);
                },
                /**
     * Shutdown this Scene and send a shutdown event to all of its systems.
     * A Scene that has been shutdown will not run its update loop or render, but it does
     * not destroy any of its plugins or references. It is put into hibernation for later use.
     * If you don't ever plan to use this Scene again, then it should be destroyed instead
     * to free-up resources.
     *
     * @method Phaser.Scenes.Systems#shutdown
     * @fires Phaser.Scenes.Events#SHUTDOWN
     * @since 3.0.0
     *
     * @param {object} [data] - A data object that will be passed in the 'shutdown' event.
     */ shutdown: function(data) {
                    var events = this.events;
                    var settings = this.settings;
                    events.off(Events.TRANSITION_INIT);
                    events.off(Events.TRANSITION_START);
                    events.off(Events.TRANSITION_COMPLETE);
                    events.off(Events.TRANSITION_OUT);
                    settings.status = CONST.SHUTDOWN;
                    settings.active = false;
                    settings.visible = false;
                    if (this.renderer === GLOBAL_CONST.WEBGL) this.renderer.resetTextures(true);
                    events.emit(Events.SHUTDOWN, this, data);
                },
                /**
     * Destroy this Scene and send a destroy event all of its systems.
     * A destroyed Scene cannot be restarted.
     * You should not call this directly, instead use `SceneManager.remove`.
     *
     * @method Phaser.Scenes.Systems#destroy
     * @private
     * @fires Phaser.Scenes.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    var events = this.events;
                    var settings = this.settings;
                    settings.status = CONST.DESTROYED;
                    settings.active = false;
                    settings.visible = false;
                    events.emit(Events.DESTROY, this);
                    events.removeAllListeners();
                    var props = [
                        'scene',
                        'game',
                        'anims',
                        'cache',
                        'plugins',
                        'registry',
                        'sound',
                        'textures',
                        'add',
                        'camera',
                        'displayList',
                        'events',
                        'make',
                        'scenePlugin',
                        'updateList'
                    ];
                    for(var i = 0; i < props.length; i++)this[props[i]] = null;
                }
            });
            module1.exports = Systems;
        /***/ },
        /* 202 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Capitalizes the first letter of a string if there is one.
 * @example
 * UppercaseFirst('abc');
 * // returns 'Abc'
 * @example
 * UppercaseFirst('the happy family');
 * // returns 'The happy family'
 * @example
 * UppercaseFirst('');
 * // returns ''
 *
 * @function Phaser.Utils.String.UppercaseFirst
 * @since 3.0.0
 *
 * @param {string} str - The string to capitalize.
 *
 * @return {string} A new string, same as the first, but with the first letter capitalized.
 */ var UppercaseFirst = function(str) {
                return str && str[0].toUpperCase() + str.slice(1);
            };
            module1.exports = UppercaseFirst;
        /***/ },
        /* 203 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(32);
            var Class = __webpack_require__(0);
            var Frame = __webpack_require__(106);
            var TextureSource = __webpack_require__(418);
            var TEXTURE_MISSING_ERROR = 'Texture.frame missing: ';
            /**
 * @classdesc
 * A Texture consists of a source, usually an Image from the Cache, and a collection of Frames.
 * The Frames represent the different areas of the Texture. For example a texture atlas
 * may have many Frames, one for each element within the atlas. Where-as a single image would have
 * just one frame, that encompasses the whole image.
 *
 * Every Texture, no matter where it comes from, always has at least 1 frame called the `__BASE` frame.
 * This frame represents the entirety of the source image.
 *
 * Textures are managed by the global TextureManager. This is a singleton class that is
 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
 *
 * Sprites and other Game Objects get the texture data they need from the TextureManager.
 *
 * @class Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[])} source - An array of sources that are used to create the texture. Usually Images, but can also be a Canvas.
 * @param {number} [width] - The width of the Texture. This is optional and automatically derived from the source images.
 * @param {number} [height] - The height of the Texture. This is optional and automatically derived from the source images.
 */ var Texture = new Class({
                initialize: function Texture(manager, key, source, width, height) {
                    if (!Array.isArray(source)) source = [
                        source
                    ];
                    /**
         * A reference to the Texture Manager this Texture belongs to.
         *
         * @name Phaser.Textures.Texture#manager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The unique string-based key of this Texture.
         *
         * @name Phaser.Textures.Texture#key
         * @type {string}
         * @since 3.0.0
         */ this.key = key;
                    /**
         * An array of TextureSource instances.
         * These are unique to this Texture and contain the actual Image (or Canvas) data.
         *
         * @name Phaser.Textures.Texture#source
         * @type {Phaser.Textures.TextureSource[]}
         * @since 3.0.0
         */ this.source = [];
                    /**
         * An array of TextureSource data instances.
         * Used to store additional data images, such as normal maps or specular maps.
         *
         * @name Phaser.Textures.Texture#dataSource
         * @type {array}
         * @since 3.0.0
         */ this.dataSource = [];
                    /**
         * A key-value object pair associating the unique Frame keys with the Frames objects.
         *
         * @name Phaser.Textures.Texture#frames
         * @type {object}
         * @since 3.0.0
         */ this.frames = {};
                    /**
         * Any additional data that was set in the source JSON (if any),
         * or any extra data you'd like to store relating to this texture
         *
         * @name Phaser.Textures.Texture#customData
         * @type {object}
         * @since 3.0.0
         */ this.customData = {};
                    /**
         * The name of the first frame of the Texture.
         *
         * @name Phaser.Textures.Texture#firstFrame
         * @type {string}
         * @since 3.0.0
         */ this.firstFrame = '__BASE';
                    /**
         * The total number of Frames in this Texture, including the `__BASE` frame.
         *
         * A Texture will always contain at least 1 frame because every Texture contains a `__BASE` frame by default,
         * in addition to any extra frames that have been added to it, such as when parsing a Sprite Sheet or Texture Atlas.
         *
         * @name Phaser.Textures.Texture#frameTotal
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.frameTotal = 0;
                    //  Load the Sources
                    for(var i = 0; i < source.length; i++)this.source.push(new TextureSource(this, source[i], width, height));
                },
                /**
     * Adds a new Frame to this Texture.
     *
     * A Frame is a rectangular region of a TextureSource with a unique index or string-based key.
     *
     * The name given must be unique within this Texture. If it already exists, this method will return `null`.
     *
     * @method Phaser.Textures.Texture#add
     * @since 3.0.0
     *
     * @param {(number|string)} name - The name of this Frame. The name is unique within the Texture.
     * @param {number} sourceIndex - The index of the TextureSource that this Frame is a part of.
     * @param {number} x - The x coordinate of the top-left of this Frame.
     * @param {number} y - The y coordinate of the top-left of this Frame.
     * @param {number} width - The width of this Frame.
     * @param {number} height - The height of this Frame.
     *
     * @return {?Phaser.Textures.Frame} The Frame that was added to this Texture, or `null` if the given name already exists.
     */ add: function(name, sourceIndex, x, y, width, height) {
                    if (this.has(name)) return null;
                    var frame = new Frame(this, name, sourceIndex, x, y, width, height);
                    this.frames[name] = frame;
                    //  Set the first frame of the Texture (other than __BASE)
                    //  This is used to ensure we don't spam the display with entire
                    //  atlases of sprite sheets, but instead just the first frame of them
                    //  should the dev incorrectly specify the frame index
                    if (this.firstFrame === '__BASE') this.firstFrame = name;
                    this.frameTotal++;
                    return frame;
                },
                /**
     * Removes the given Frame from this Texture. The Frame is destroyed immediately.
     *
     * Any Game Objects using this Frame should stop using it _before_ you remove it,
     * as it does not happen automatically.
     *
     * @method Phaser.Textures.Texture#remove
     * @since 3.19.0
     *
     * @param {string} name - The key of the Frame to remove.
     *
     * @return {boolean} True if a Frame with the matching key was removed from this Texture.
     */ remove: function(name) {
                    if (this.has(name)) {
                        var frame = this.get(name);
                        frame.destroy();
                        delete this.frames[name];
                        return true;
                    }
                    return false;
                },
                /**
     * Checks to see if a Frame matching the given key exists within this Texture.
     *
     * @method Phaser.Textures.Texture#has
     * @since 3.0.0
     *
     * @param {string} name - The key of the Frame to check for.
     *
     * @return {boolean} True if a Frame with the matching key exists in this Texture.
     */ has: function(name) {
                    return this.frames[name];
                },
                /**
     * Gets a Frame from this Texture based on either the key or the index of the Frame.
     *
     * In a Texture Atlas Frames are typically referenced by a key.
     * In a Sprite Sheet Frames are referenced by an index.
     * Passing no value for the name returns the base texture.
     *
     * @method Phaser.Textures.Texture#get
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {Phaser.Textures.Frame} The Texture Frame.
     */ get: function(name) {
                    //  null, undefined, empty string, zero
                    if (!name) name = this.firstFrame;
                    var frame = this.frames[name];
                    if (!frame) {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        frame = this.frames[this.firstFrame];
                    }
                    return frame;
                },
                /**
     * Takes the given TextureSource and returns the index of it within this Texture.
     * If it's not in this Texture, it returns -1.
     * Unless this Texture has multiple TextureSources, such as with a multi-atlas, this
     * method will always return zero or -1.
     *
     * @method Phaser.Textures.Texture#getTextureSourceIndex
     * @since 3.0.0
     *
     * @param {Phaser.Textures.TextureSource} source - The TextureSource to check.
     *
     * @return {number} The index of the TextureSource within this Texture, or -1 if not in this Texture.
     */ getTextureSourceIndex: function(source) {
                    for(var i = 0; i < this.source.length; i++){
                        if (this.source[i] === source) return i;
                    }
                    return -1;
                },
                /**
     * Returns an array of all the Frames in the given TextureSource.
     *
     * @method Phaser.Textures.Texture#getFramesFromTextureSource
     * @since 3.0.0
     *
     * @param {number} sourceIndex - The index of the TextureSource to get the Frames from.
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {Phaser.Textures.Frame[]} An array of Texture Frames.
     */ getFramesFromTextureSource: function(sourceIndex, includeBase) {
                    if (includeBase === undefined) includeBase = false;
                    var out = [];
                    for(var frameName in this.frames){
                        if (frameName === '__BASE' && !includeBase) continue;
                        var frame = this.frames[frameName];
                        if (frame.sourceIndex === sourceIndex) out.push(frame);
                    }
                    return out;
                },
                /**
     * Returns an array with all of the names of the Frames in this Texture.
     *
     * Useful if you want to randomly assign a Frame to a Game Object, as you can
     * pick a random element from the returned array.
     *
     * @method Phaser.Textures.Texture#getFrameNames
     * @since 3.0.0
     *
     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
     *
     * @return {string[]} An array of all Frame names in this Texture.
     */ getFrameNames: function(includeBase) {
                    if (includeBase === undefined) includeBase = false;
                    var out = Object.keys(this.frames);
                    if (!includeBase) {
                        var idx = out.indexOf('__BASE');
                        if (idx !== -1) out.splice(idx, 1);
                    }
                    return out;
                },
                /**
     * Given a Frame name, return the source image it uses to render with.
     *
     * This will return the actual DOM Image or Canvas element.
     *
     * @method Phaser.Textures.Texture#getSourceImage
     * @since 3.0.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement|Phaser.GameObjects.RenderTexture)} The DOM Image, Canvas Element or Render Texture.
     */ getSourceImage: function(name) {
                    if (name === undefined || name === null || this.frameTotal === 1) name = '__BASE';
                    var frame = this.frames[name];
                    if (frame) return frame.source.image;
                    else {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        return this.frames['__BASE'].source.image;
                    }
                },
                /**
     * Given a Frame name, return the data source image it uses to render with.
     * You can use this to get the normal map for an image for example.
     *
     * This will return the actual DOM Image.
     *
     * @method Phaser.Textures.Texture#getDataSourceImage
     * @since 3.7.0
     *
     * @param {(string|number)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
     *
     * @return {(HTMLImageElement|HTMLCanvasElement)} The DOM Image or Canvas Element.
     */ getDataSourceImage: function(name) {
                    if (name === undefined || name === null || this.frameTotal === 1) name = '__BASE';
                    var frame = this.frames[name];
                    var idx;
                    if (!frame) {
                        console.warn(TEXTURE_MISSING_ERROR + name);
                        idx = this.frames['__BASE'].sourceIndex;
                    } else idx = frame.sourceIndex;
                    return this.dataSource[idx].image;
                },
                /**
     * Adds a data source image to this Texture.
     *
     * An example of a data source image would be a normal map, where all of the Frames for this Texture
     * equally apply to the normal map.
     *
     * @method Phaser.Textures.Texture#setDataSource
     * @since 3.0.0
     *
     * @param {(HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[])} data - The source image.
     */ setDataSource: function(data) {
                    if (!Array.isArray(data)) data = [
                        data
                    ];
                    for(var i = 0; i < data.length; i++){
                        var source = this.source[i];
                        this.dataSource.push(new TextureSource(this, data[i], source.width, source.height));
                    }
                },
                /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * The mode applies to the entire Texture, not just a specific Frame of it.
     *
     * @method Phaser.Textures.Texture#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                    var i;
                    for(i = 0; i < this.source.length; i++)this.source[i].setFilter(filterMode);
                    for(i = 0; i < this.dataSource.length; i++)this.dataSource[i].setFilter(filterMode);
                },
                /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.Texture#destroy
     * @since 3.0.0
     */ destroy: function() {
                    var i;
                    for(i = 0; i < this.source.length; i++)this.source[i].destroy();
                    for(i = 0; i < this.dataSource.length; i++)this.dataSource[i].destroy();
                    for(var frameName in this.frames){
                        var frame = this.frames[frameName];
                        frame.destroy();
                    }
                    this.source = [];
                    this.dataSource = [];
                    this.frames = {};
                    this.manager.removeKey(this.key);
                    var renderer = this.manager.game.renderer;
                    if (renderer.type === CONST.WEBGL) renderer.resetTextures(true);
                    this.manager = null;
                }
            });
            module1.exports = Texture;
        /***/ },
        /* 204 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns all elements in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return only elements that have their visible property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
 * the first 50 elements.
 *
 * @function Phaser.Utils.Array.GetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} All matching elements from the array.
 */ var GetAll = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                var output = [];
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) output.push(child);
                }
                return output;
            };
            module1.exports = GetAll;
        /***/ },
        /* 205 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array
 */ module1.exports = {
                Matrix: __webpack_require__(1009),
                Add: __webpack_require__(1017),
                AddAt: __webpack_require__(1018),
                BringToTop: __webpack_require__(1019),
                CountAllMatching: __webpack_require__(1020),
                Each: __webpack_require__(1021),
                EachInRange: __webpack_require__(1022),
                FindClosestInSorted: __webpack_require__(312),
                GetAll: __webpack_require__(204),
                GetFirst: __webpack_require__(422),
                GetRandom: __webpack_require__(207),
                MoveDown: __webpack_require__(1023),
                MoveTo: __webpack_require__(1024),
                MoveUp: __webpack_require__(1025),
                NumberArray: __webpack_require__(316),
                NumberArrayStep: __webpack_require__(1026),
                QuickSelect: __webpack_require__(430),
                Range: __webpack_require__(431),
                Remove: __webpack_require__(89),
                RemoveAt: __webpack_require__(1027),
                RemoveBetween: __webpack_require__(1028),
                RemoveRandomElement: __webpack_require__(1029),
                Replace: __webpack_require__(1030),
                RotateLeft: __webpack_require__(175),
                RotateRight: __webpack_require__(176),
                SafeRange: __webpack_require__(78),
                SendToBack: __webpack_require__(1031),
                SetAll: __webpack_require__(1032),
                Shuffle: __webpack_require__(129),
                SortByDigits: __webpack_require__(314),
                SpliceOne: __webpack_require__(74),
                StableSort: __webpack_require__(79),
                Swap: __webpack_require__(1033)
            };
        /***/ },
        /* 206 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if an array can be used as a matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.CheckMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - The array to check.
 *
 * @return {boolean} `true` if the given `matrix` array is a valid matrix.
 */ var CheckMatrix = function(matrix) {
                if (!Array.isArray(matrix) || matrix.length < 2 || !Array.isArray(matrix[0])) return false;
                //  How long is the first row?
                var size = matrix[0].length;
                //  Validate the rest of the rows are the same length
                for(var i = 1; i < matrix.length; i++){
                    if (matrix[i].length !== size) return false;
                }
                return true;
            };
            module1.exports = CheckMatrix;
        /***/ },
        /* 207 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a Random element from the array.
 *
 * @function Phaser.Utils.Array.GetRandom
 * @since 3.0.0
 *
 * @param {array} array - The array to select the random entry from.
 * @param {number} [startIndex=0] - An optional start index.
 * @param {number} [length=array.length] - An optional length, the total number of elements (from the startIndex) to choose from.
 *
 * @return {*} A random element from the array, or `null` if no element could be found in the range given.
 */ var GetRandom = function(array, startIndex, length) {
                if (startIndex === undefined) startIndex = 0;
                if (length === undefined) length = array.length;
                var randomIndex = startIndex + Math.floor(Math.random() * length);
                return array[randomIndex] === undefined ? null : array[randomIndex];
            };
            module1.exports = GetRandom;
        /***/ },
        /* 208 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(432);
            /**
 * @classdesc
 * A Process Queue maintains three internal lists.
 *
 * The `pending` list is a selection of items which are due to be made 'active' in the next update.
 * The `active` list is a selection of items which are considered active and should be updated.
 * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
 *
 * When new items are added to a Process Queue they are put in the pending list, rather than being added
 * immediately the active list. Equally, items that are removed are put into the destroy list, rather than
 * being destroyed immediately. This allows the Process Queue to carefully process each item at a specific, fixed
 * time, rather than at the time of the request from the API.
 *
 * @class ProcessQueue
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 *
 * @generic T
 */ var ProcessQueue = new Class({
                Extends: EventEmitter,
                initialize: function ProcessQueue() {
                    EventEmitter.call(this);
                    /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                    /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @genericUse {T[]} - [$type]
         *
         * @name Phaser.Structs.ProcessQueue#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.0.0
         */ this._destroy = [];
                    /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.Structs.ProcessQueue#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._toProcess = 0;
                    /**
         * If `true` only unique objects will be allowed in the queue.
         *
         * @name Phaser.Structs.ProcessQueue#checkQueue
         * @type {boolean}
         * @since 3.50.0
         */ this.checkQueue = false;
                },
                /**
     * Adds a new item to the Process Queue.
     *
     * The item is added to the pending list and made active in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#add
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to add to the queue.
     *
     * @return {*} The item that was added.
     */ add: function(item) {
                    this._pending.push(item);
                    this._toProcess++;
                    return item;
                },
                /**
     * Removes an item from the Process Queue.
     *
     * The item is added to the pending destroy and fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#remove
     * @since 3.0.0
     *
     * @genericUse {T} - [item]
     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
     *
     * @param {*} item - The item to be removed from the queue.
     *
     * @return {*} The item that was removed.
     */ remove: function(item) {
                    this._destroy.push(item);
                    this._toProcess++;
                    return item;
                },
                /**
     * Removes all active items from this Process Queue.
     *
     * All the items are marked as 'pending destroy' and fully removed in the next update.
     *
     * @method Phaser.Structs.ProcessQueue#removeAll
     * @since 3.20.0
     *
     * @return {this} This Process Queue object.
     */ removeAll: function() {
                    var list = this._active;
                    var destroy = this._destroy;
                    var i = list.length;
                    while(i--){
                        destroy.push(list[i]);
                        this._toProcess++;
                    }
                    return this;
                },
                /**
     * Update this queue. First it will process any items awaiting destruction, and remove them.
     *
     * Then it will check to see if there are any items pending insertion, and move them to an
     * active state. Finally, it will return a list of active items for further processing.
     *
     * @method Phaser.Structs.ProcessQueue#update
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ update: function() {
                    if (this._toProcess === 0) //  Quick bail
                    return this._active;
                    var list = this._destroy;
                    var active = this._active;
                    var i;
                    var item;
                    //  Clear the 'destroy' list
                    for(i = 0; i < list.length; i++){
                        item = list[i];
                        //  Remove from the 'active' array
                        var idx = active.indexOf(item);
                        if (idx !== -1) {
                            active.splice(idx, 1);
                            this.emit(Events.PROCESS_QUEUE_REMOVE, item);
                        }
                    }
                    list.length = 0;
                    //  Process the pending addition list
                    //  This stops callbacks and out of sync events from populating the active array mid-way during an update
                    list = this._pending;
                    for(i = 0; i < list.length; i++){
                        item = list[i];
                        if (!this.checkQueue || this.checkQueue && active.indexOf(item) === -1) {
                            active.push(item);
                            this.emit(Events.PROCESS_QUEUE_ADD, item);
                        }
                    }
                    list.length = 0;
                    this._toProcess = 0;
                    //  The owner of this queue can now safely do whatever it needs to with the active list
                    return active;
                },
                /**
     * Returns the current list of active items.
     *
     * This method returns a reference to the active list array, not a copy of it.
     * Therefore, be careful to not modify this array outside of the ProcessQueue.
     *
     * @method Phaser.Structs.ProcessQueue#getActive
     * @since 3.0.0
     *
     * @genericUse {T[]} - [$return]
     *
     * @return {Array.<*>} A list of active items.
     */ getActive: function() {
                    return this._active;
                },
                /**
     * The number of entries in the active list.
     *
     * @name Phaser.Structs.ProcessQueue#length
     * @type {number}
     * @readonly
     * @since 3.20.0
     */ length: {
                    get: function() {
                        return this._active.length;
                    }
                },
                /**
     * Immediately destroys this process queue, clearing all of its internal arrays and resetting the process totals.
     *
     * @method Phaser.Structs.ProcessQueue#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this._toProcess = 0;
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                }
            });
            module1.exports = ProcessQueue;
        /***/ },
        /* 209 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Read an integer value from an XML Node.
 *
 * @function getValue
 * @since 3.0.0
 * @private
 *
 * @param {Node} node - The XML Node.
 * @param {string} attribute - The attribute to read.
 *
 * @return {number} The parsed value.
 */ function getValue(node, attribute) {
                return parseInt(node.getAttribute(attribute), 10);
            }
            /**
 * Parse an XML font to Bitmap Font data for the Bitmap Font cache.
 *
 * @function ParseXMLBitmapFont
 * @since 3.0.0
 * @private
 *
 * @param {XMLDocument} xml - The XML Document to parse the font from.
 * @param {Phaser.Textures.Frame} frame - The texture frame to take into account when creating the uv data.
 * @param {number} [xSpacing=0] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing=0] - The y-axis spacing to add to the line height.
 * @param {Phaser.Textures.Texture} [texture] - If provided, each glyph in the Bitmap Font will be added to this texture as a frame.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapFontData} The parsed Bitmap Font data.
 */ var ParseXMLBitmapFont = function(xml, frame, xSpacing, ySpacing, texture) {
                if (xSpacing === undefined) xSpacing = 0;
                if (ySpacing === undefined) ySpacing = 0;
                var textureX = frame.cutX;
                var textureY = frame.cutY;
                var textureWidth = frame.source.width;
                var textureHeight = frame.source.height;
                var sourceIndex = frame.sourceIndex;
                var data = {};
                var info = xml.getElementsByTagName('info')[0];
                var common = xml.getElementsByTagName('common')[0];
                data.font = info.getAttribute('face');
                data.size = getValue(info, 'size');
                data.lineHeight = getValue(common, 'lineHeight') + ySpacing;
                data.chars = {};
                var letters = xml.getElementsByTagName('char');
                var adjustForTrim = frame !== undefined && frame.trimmed;
                if (adjustForTrim) {
                    var top = frame.height;
                    var left = frame.width;
                }
                for(var i = 0; i < letters.length; i++){
                    var node = letters[i];
                    var charCode = getValue(node, 'id');
                    var letter = String.fromCharCode(charCode);
                    var gx = getValue(node, 'x');
                    var gy = getValue(node, 'y');
                    var gw = getValue(node, 'width');
                    var gh = getValue(node, 'height');
                    //  Handle frame trim issues
                    if (adjustForTrim) {
                        if (gx < left) left = gx;
                        if (gy < top) top = gy;
                    }
                    if (adjustForTrim && top !== 0 && left !== 0) {
                        //  Now we know the top and left coordinates of the glyphs in the original data
                        //  so we can work out how much to adjust the glyphs by
                        gx -= frame.x;
                        gy -= frame.y;
                    }
                    var u0 = (textureX + gx) / textureWidth;
                    var v0 = (textureY + gy) / textureHeight;
                    var u1 = (textureX + gx + gw) / textureWidth;
                    var v1 = (textureY + gy + gh) / textureHeight;
                    data.chars[charCode] = {
                        x: gx,
                        y: gy,
                        width: gw,
                        height: gh,
                        centerX: Math.floor(gw / 2),
                        centerY: Math.floor(gh / 2),
                        xOffset: getValue(node, 'xoffset'),
                        yOffset: getValue(node, 'yoffset'),
                        xAdvance: getValue(node, 'xadvance') + xSpacing,
                        data: {},
                        kerning: {},
                        u0: u0,
                        v0: v0,
                        u1: u1,
                        v1: v1
                    };
                    if (texture && gw !== 0 && gh !== 0) {
                        var charFrame = texture.add(letter, sourceIndex, gx, gy, gw, gh);
                        if (charFrame) charFrame.setUVs(gw, gh, u0, v0, u1, v1);
                    }
                }
                var kernings = xml.getElementsByTagName('kerning');
                for(i = 0; i < kernings.length; i++){
                    var kern = kernings[i];
                    var first = getValue(kern, 'first');
                    var second = getValue(kern, 'second');
                    var amount = getValue(kern, 'amount');
                    data.chars[second].kerning[first] = amount;
                }
                return data;
            };
            module1.exports = ParseXMLBitmapFont;
        /***/ },
        /* 210 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlitterRender = __webpack_require__(1043);
            var Bob = __webpack_require__(434);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Frame = __webpack_require__(106);
            var GameObject = __webpack_require__(15);
            var List = __webpack_require__(107);
            /**
 * @callback CreateCallback
 *
 * @param {Phaser.GameObjects.Bob} bob - The Bob that was created by the Blitter.
 * @param {number} index - The position of the Bob within the Blitter display list.
 */ /**
 * @classdesc
 * A Blitter Game Object.
 *
 * The Blitter Game Object is a special kind of container that creates, updates and manages Bob objects.
 * Bobs are designed for rendering speed rather than flexibility. They consist of a texture, or frame from a texture,
 * a position and an alpha value. You cannot scale or rotate them. They use a batched drawing method for speed
 * during rendering.
 *
 * A Blitter Game Object has one texture bound to it. Bobs created by the Blitter can use any Frame from this
 * Texture to render with, but they cannot use any other Texture. It is this single texture-bind that allows
 * them their speed.
 *
 * If you have a need to blast a large volume of frames around the screen then Blitter objects are well worth
 * investigating. They are especially useful for using as a base for your own special effects systems.
 *
 * @class Blitter
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} [x=0] - The x coordinate of this Game Object in world space.
 * @param {number} [y=0] - The y coordinate of this Game Object in world space.
 * @param {string} [texture='__DEFAULT'] - The key of the texture this Game Object will use for rendering. The Texture must already exist in the Texture Manager.
 * @param {(string|number)} [frame=0] - The Frame of the Texture that this Game Object will use. Only set if the Texture has multiple frames, such as a Texture Atlas or Sprite Sheet.
 */ var Blitter = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    BlitterRender
                ],
                initialize: function Blitter(scene, x, y, texture, frame) {
                    GameObject.call(this, scene, 'Blitter');
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.initPipeline();
                    /**
         * The children of this Blitter.
         * This List contains all of the Bob objects created by the Blitter.
         *
         * @name Phaser.GameObjects.Blitter#children
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Bob>}
         * @since 3.0.0
         */ this.children = new List();
                    /**
         * A transient array that holds all of the Bobs that will be rendered this frame.
         * The array is re-populated whenever the dirty flag is set.
         *
         * @name Phaser.GameObjects.Blitter#renderList
         * @type {Phaser.GameObjects.Bob[]}
         * @default []
         * @private
         * @since 3.0.0
         */ this.renderList = [];
                    /**
         * Is the Blitter considered dirty?
         * A 'dirty' Blitter has had its child count changed since the last frame.
         *
         * @name Phaser.GameObjects.Blitter#dirty
         * @type {boolean}
         * @since 3.0.0
         */ this.dirty = false;
                },
                /**
     * Creates a new Bob in this Blitter.
     *
     * The Bob is created at the given coordinates, relative to the Blitter and uses the given frame.
     * A Bob can use any frame belonging to the texture bound to the Blitter.
     *
     * @method Phaser.GameObjects.Blitter#create
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     * @param {number} [index] - The position in the Blitters Display List to add the new Bob at. Defaults to the top of the list.
     *
     * @return {Phaser.GameObjects.Bob} The newly created Bob object.
     */ create: function(x, y, frame, visible, index) {
                    if (visible === undefined) visible = true;
                    if (index === undefined) index = this.children.length;
                    if (frame === undefined) frame = this.frame;
                    else if (!(frame instanceof Frame)) frame = this.texture.get(frame);
                    var bob = new Bob(this, x, y, frame, visible);
                    this.children.addAt(bob, index, false);
                    this.dirty = true;
                    return bob;
                },
                /**
     * Creates multiple Bob objects within this Blitter and then passes each of them to the specified callback.
     *
     * @method Phaser.GameObjects.Blitter#createFromCallback
     * @since 3.0.0
     *
     * @param {CreateCallback} callback - The callback to invoke after creating a bob. It will be sent two arguments: The Bob and the index of the Bob.
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createFromCallback: function(callback, quantity, frame, visible) {
                    var bobs = this.createMultiple(quantity, frame, visible);
                    for(var i = 0; i < bobs.length; i++){
                        var bob = bobs[i];
                        callback.call(this, bob, i);
                    }
                    return bobs;
                },
                /**
     * Creates multiple Bobs in one call.
     *
     * The amount created is controlled by a combination of the `quantity` argument and the number of frames provided.
     *
     * If the quantity is set to 10 and you provide 2 frames, then 20 Bobs will be created. 10 with the first
     * frame and 10 with the second.
     *
     * @method Phaser.GameObjects.Blitter#createMultiple
     * @since 3.0.0
     *
     * @param {number} quantity - The quantity of Bob objects to create.
     * @param {(string|number|Phaser.Textures.Frame|string[]|number[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
     * @param {boolean} [visible=true] - Should the created Bob render or not?
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that were created.
     */ createMultiple: function(quantity, frame, visible) {
                    if (frame === undefined) frame = this.frame.name;
                    if (visible === undefined) visible = true;
                    if (!Array.isArray(frame)) frame = [
                        frame
                    ];
                    var bobs = [];
                    var _this = this;
                    frame.forEach(function(singleFrame) {
                        for(var i = 0; i < quantity; i++)bobs.push(_this.create(0, 0, singleFrame, visible));
                    });
                    return bobs;
                },
                /**
     * Checks if the given child can render or not, by checking its `visible` and `alpha` values.
     *
     * @method Phaser.GameObjects.Blitter#childCanRender
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Bob} child - The Bob to check for rendering.
     *
     * @return {boolean} Returns `true` if the given child can render, otherwise `false`.
     */ childCanRender: function(child) {
                    return child.visible && child.alpha > 0;
                },
                /**
     * Returns an array of Bobs to be rendered.
     * If the Blitter is dirty then a new list is generated and stored in `renderList`.
     *
     * @method Phaser.GameObjects.Blitter#getRenderList
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Bob[]} An array of Bob objects that will be rendered this frame.
     */ getRenderList: function() {
                    if (this.dirty) {
                        this.renderList = this.children.list.filter(this.childCanRender, this);
                        this.dirty = false;
                    }
                    return this.renderList;
                },
                /**
     * Removes all Bobs from the children List and clears the dirty flag.
     *
     * @method Phaser.GameObjects.Blitter#clear
     * @since 3.0.0
     */ clear: function() {
                    this.children.removeAll();
                    this.dirty = true;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Blitter#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.children.destroy();
                    this.renderList = [];
                }
            });
            module1.exports = Blitter;
        /***/ },
        /* 211 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayUtils = __webpack_require__(205);
            var BlendModes = __webpack_require__(34);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Events = __webpack_require__(75);
            var GameObject = __webpack_require__(15);
            var Rectangle = __webpack_require__(10);
            var Render = __webpack_require__(1046);
            var Union = __webpack_require__(435);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Container Game Object.
 *
 * A Container, as the name implies, can 'contain' other types of Game Object.
 * When a Game Object is added to a Container, the Container becomes responsible for the rendering of it.
 * By default it will be removed from the Display List and instead added to the Containers own internal list.
 *
 * The position of the Game Object automatically becomes relative to the position of the Container.
 *
 * The origin of a Container is 0x0 (in local space) and that cannot be changed. The children you add to the
 * Container should be positioned with this value in mind. I.e. you should treat 0x0 as being the center of
 * the Container, and position children positively and negative around it as required.
 *
 * When the Container is rendered, all of its children are rendered as well, in the order in which they exist
 * within the Container. Container children can be repositioned using methods such as `MoveUp`, `MoveDown` and `SendToBack`.
 *
 * If you modify a transform property of the Container, such as `Container.x` or `Container.rotation` then it will
 * automatically influence all children as well.
 *
 * Containers can include other Containers for deeply nested transforms.
 *
 * Containers can have masks set on them and can be used as a mask too. However, Container children cannot be masked.
 * The masks do not 'stack up'. Only a Container on the root of the display list will use its mask.
 *
 * Containers can be enabled for input. Because they do not have a texture you need to provide a shape for them
 * to use as their hit area. Container children can also be enabled for input, independent of the Container.
 *
 * If input enabling a _child_ you should not set both the `origin` and a **negative** scale factor on the child,
 * or the input area will become misaligned.
 *
 * Containers can be given a physics body for either Arcade Physics, Impact Physics or Matter Physics. However,
 * if Container _children_ are enabled for physics you may get unexpected results, such as offset bodies,
 * if the Container itself, or any of its ancestors, is positioned anywhere other than at 0 x 0. Container children
 * with physics do not factor in the Container due to the excessive extra calculations needed. Please structure
 * your game to work around this.
 *
 * It's important to understand the impact of using Containers. They add additional processing overhead into
 * every one of their children. The deeper you nest them, the more the cost escalates. This is especially true
 * for input events. You also loose the ability to set the display depth of Container children in the same
 * flexible manner as those not within them. In short, don't use them for the sake of it. You pay a small cost
 * every time you create one, try to structure your game around avoiding that where possible.
 *
 * @class Container
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.4.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 */ var Container = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function Container(scene, x, y, children) {
                    GameObject.call(this, scene, 'Container');
                    /**
         * An array holding the children of this Container.
         *
         * @name Phaser.GameObjects.Container#list
         * @type {Phaser.GameObjects.GameObject[]}
         * @since 3.4.0
         */ this.list = [];
                    /**
         * Does this Container exclusively manage its children?
         *
         * The default is `true` which means a child added to this Container cannot
         * belong in another Container, which includes the Scene display list.
         *
         * If you disable this then this Container will no longer exclusively manage its children.
         * This allows you to create all kinds of interesting graphical effects, such as replicating
         * Game Objects without reparenting them all over the Scene.
         * However, doing so will prevent children from receiving any kind of input event or have
         * their physics bodies work by default, as they're no longer a single entity on the
         * display list, but are being replicated where-ever this Container is.
         *
         * @name Phaser.GameObjects.Container#exclusive
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.exclusive = true;
                    /**
         * Containers can have an optional maximum size. If set to anything above 0 it
         * will constrict the addition of new Game Objects into the Container, capping off
         * the maximum limit the Container can grow in size to.
         *
         * @name Phaser.GameObjects.Container#maxSize
         * @type {number}
         * @default -1
         * @since 3.4.0
         */ this.maxSize = -1;
                    /**
         * The cursor position.
         *
         * @name Phaser.GameObjects.Container#position
         * @type {number}
         * @since 3.4.0
         */ this.position = 0;
                    /**
         * Internal Transform Matrix used for local space conversion.
         *
         * @name Phaser.GameObjects.Container#localTransform
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.4.0
         */ this.localTransform = new Components.TransformMatrix();
                    /**
         * Internal temporary Transform Matrix used to avoid object creation.
         *
         * @name Phaser.GameObjects.Container#tempTransformMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.4.0
         */ this.tempTransformMatrix = new Components.TransformMatrix();
                    /**
         * The property key to sort by.
         *
         * @name Phaser.GameObjects.Container#_sortKey
         * @type {string}
         * @private
         * @since 3.4.0
         */ this._sortKey = '';
                    /**
         * A reference to the Scene Systems Event Emitter.
         *
         * @name Phaser.GameObjects.Container#_sysEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.9.0
         */ this._sysEvents = scene.sys.events;
                    /**
         * The horizontal scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorX
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorX = 1;
                    /**
         * The vertical scroll factor of this Container.
         *
         * The scroll factor controls the influence of the movement of a Camera upon this Container.
         *
         * When a camera scrolls it will change the location at which this Container is rendered on-screen.
         * It does not change the Containers actual position values.
         *
         * For a Container, setting this value will only update the Container itself, not its children.
         * If you wish to change the scrollFactor of the children as well, use the `setScrollFactor` method.
         *
         * A value of 1 means it will move exactly in sync with a camera.
         * A value of 0 means it will not move at all, even if the camera moves.
         * Other values control the degree to which the camera movement is mapped to this Container.
         *
         * Please be aware that scroll factor values other than 1 are not taken in to consideration when
         * calculating physics collisions. Bodies always collide based on their world position, but changing
         * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
         * them from physics bodies if not accounted for in your code.
         *
         * @name Phaser.GameObjects.Container#scrollFactorY
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.scrollFactorY = 1;
                    this.initPipeline();
                    this.setPosition(x, y);
                    this.clearAlpha();
                    this.setBlendMode(BlendModes.SKIP_CHECK);
                    if (children) this.add(children);
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originX: {
                    get: function() {
                        return 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#originY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ originY: {
                    get: function() {
                        return 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginX
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginX: {
                    get: function() {
                        return this.width * 0.5;
                    }
                },
                /**
     * Internal value to allow Containers to be used for input and physics.
     * Do not change this value. It has no effect other than to break things.
     *
     * @name Phaser.GameObjects.Container#displayOriginY
     * @type {number}
     * @readonly
     * @override
     * @since 3.4.0
     */ displayOriginY: {
                    get: function() {
                        return this.height * 0.5;
                    }
                },
                /**
     * Does this Container exclusively manage its children?
     *
     * The default is `true` which means a child added to this Container cannot
     * belong in another Container, which includes the Scene display list.
     *
     * If you disable this then this Container will no longer exclusively manage its children.
     * This allows you to create all kinds of interesting graphical effects, such as replicating
     * Game Objects without reparenting them all over the Scene.
     * However, doing so will prevent children from receiving any kind of input event or have
     * their physics bodies work by default, as they're no longer a single entity on the
     * display list, but are being replicated where-ever this Container is.
     *
     * @method Phaser.GameObjects.Container#setExclusive
     * @since 3.4.0
     *
     * @param {boolean} [value=true] - The exclusive state of this Container.
     *
     * @return {this} This Container.
     */ setExclusive: function(value) {
                    if (value === undefined) value = true;
                    this.exclusive = value;
                    return this;
                },
                /**
     * Gets the bounds of this Container. It works by iterating all children of the Container,
     * getting their respective bounds, and then working out a min-max rectangle from that.
     * It does not factor in if the children render or not, all are included.
     *
     * Some children are unable to return their bounds, such as Graphics objects, in which case
     * they are skipped.
     *
     * Depending on the quantity of children in this Container it could be a really expensive call,
     * so cache it and only poll it as needed.
     *
     * The values are stored and returned in a Rectangle object.
     *
     * @method Phaser.GameObjects.Container#getBounds
     * @since 3.4.0
     *
     * @param {Phaser.Geom.Rectangle} [output] - A Geom.Rectangle object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} The values stored in the output object.
     */ getBounds: function(output) {
                    if (output === undefined) output = new Rectangle();
                    output.setTo(this.x, this.y, 0, 0);
                    if (this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        var transformedPosition = parentMatrix.transformPoint(this.x, this.y);
                        output.setTo(transformedPosition.x, transformedPosition.y, 0, 0);
                    }
                    if (this.list.length > 0) {
                        var children = this.list;
                        var tempRect = new Rectangle();
                        var hasSetFirst = false;
                        output.setEmpty();
                        for(var i = 0; i < children.length; i++){
                            var entry = children[i];
                            if (entry.getBounds) {
                                entry.getBounds(tempRect);
                                if (!hasSetFirst) {
                                    output.setTo(tempRect.x, tempRect.y, tempRect.width, tempRect.height);
                                    hasSetFirst = true;
                                } else Union(tempRect, output, output);
                            }
                        }
                    }
                    return output;
                },
                /**
     * Internal add handler.
     *
     * @method Phaser.GameObjects.Container#addHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to this Container.
     */ addHandler: function(gameObject) {
                    gameObject.once(Events.DESTROY, this.remove, this);
                    if (this.exclusive) {
                        if (gameObject.displayList) gameObject.displayList.remove(gameObject);
                        if (gameObject.parentContainer) gameObject.parentContainer.remove(gameObject);
                        if (this.displayList) gameObject.displayList = this.displayList;
                        else gameObject.displayList = this.scene.sys.displayList;
                        gameObject.parentContainer = this;
                    }
                    //  Is only on the Display List via this Container
                    if (!this.scene.sys.displayList.exists(gameObject)) gameObject.emit(Events.ADDED_TO_SCENE, gameObject, this.scene);
                },
                /**
     * Internal remove handler.
     *
     * @method Phaser.GameObjects.Container#removeHandler
     * @private
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just removed from this Container.
     */ removeHandler: function(gameObject) {
                    gameObject.off(Events.DESTROY, this.remove);
                    if (this.exclusive) gameObject.parentContainer = null;
                    //  Is only on the Display List via this Container
                    if (!this.scene.sys.displayList.exists(gameObject)) gameObject.emit(Events.REMOVED_FROM_SCENE, gameObject, this.scene);
                },
                /**
     * Takes a Point-like object, such as a Vector2, Geom.Point or object with public x and y properties,
     * and transforms it into the space of this Container, then returns it in the output object.
     *
     * @method Phaser.GameObjects.Container#pointToContainer
     * @since 3.4.0
     *
     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} source - The Source Point to be transformed.
     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} [output] - A destination object to store the transformed point in. If none given a Vector2 will be created and returned.
     *
     * @return {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} The transformed point.
     */ pointToContainer: function(source, output) {
                    if (output === undefined) output = new Vector2();
                    if (this.parentContainer) this.parentContainer.pointToContainer(source, output);
                    else output = new Vector2(source.x, source.y);
                    var tempMatrix = this.tempTransformMatrix;
                    //  No need to loadIdentity because applyITRS overwrites every value anyway
                    tempMatrix.applyITRS(this.x, this.y, this.rotation, this.scaleX, this.scaleY);
                    tempMatrix.invert();
                    tempMatrix.transformPoint(source.x, source.y, output);
                    return output;
                },
                /**
     * Returns the world transform matrix as used for Bounds checks.
     *
     * The returned matrix is temporal and shouldn't be stored.
     *
     * @method Phaser.GameObjects.Container#getBoundsTransformMatrix
     * @since 3.4.0
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The world transform matrix.
     */ getBoundsTransformMatrix: function() {
                    return this.getWorldTransformMatrix(this.tempTransformMatrix, this.localTransform);
                },
                /**
     * Adds the given Game Object, or array of Game Objects, to this Container.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#add
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     *
     * @return {this} This Container instance.
     */ add: function(child) {
                    ArrayUtils.Add(this.list, child, this.maxSize, this.addHandler, this);
                    return this;
                },
                /**
     * Adds the given Game Object, or array of Game Objects, to this Container at the specified position.
     *
     * Existing Game Objects in the Container are shifted up.
     *
     * Each Game Object must be unique within the Container.
     *
     * @method Phaser.GameObjects.Container#addAt
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
     * @param {number} [index=0] - The position to insert the Game Object/s at.
     *
     * @return {this} This Container instance.
     */ addAt: function(child, index) {
                    ArrayUtils.AddAt(this.list, child, index, this.maxSize, this.addHandler, this);
                    return this;
                },
                /**
     * Returns the Game Object at the given position in this Container.
     *
     * @method Phaser.GameObjects.Container#getAt
     * @since 3.4.0
     *
     * @param {number} index - The position to get the Game Object from.
     *
     * @return {?Phaser.GameObjects.GameObject} The Game Object at the specified index, or `null` if none found.
     */ getAt: function(index) {
                    return this.list[index];
                },
                /**
     * Returns the index of the given Game Object in this Container.
     *
     * @method Phaser.GameObjects.Container#getIndex
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to search for in this Container.
     *
     * @return {number} The index of the Game Object in this Container, or -1 if not found.
     */ getIndex: function(child) {
                    return this.list.indexOf(child);
                },
                /**
     * Sort the contents of this Container so the items are in order based on the given property.
     * For example: `sort('alpha')` would sort the elements based on the value of their `alpha` property.
     *
     * @method Phaser.GameObjects.Container#sort
     * @since 3.4.0
     *
     * @param {string} property - The property to lexically sort by.
     * @param {function} [handler] - Provide your own custom handler function. Will receive 2 children which it should compare and return a boolean.
     *
     * @return {this} This Container instance.
     */ sort: function(property, handler) {
                    if (!property) return this;
                    if (handler === undefined) handler = function(childA, childB) {
                        return childA[property] - childB[property];
                    };
                    ArrayUtils.StableSort(this.list, handler);
                    return this;
                },
                /**
     * Searches for the first instance of a child with its `name` property matching the given argument.
     * Should more than one child have the same name only the first is returned.
     *
     * @method Phaser.GameObjects.Container#getByName
     * @since 3.4.0
     *
     * @param {string} name - The name to search for.
     *
     * @return {?Phaser.GameObjects.GameObject} The first child with a matching name, or `null` if none were found.
     */ getByName: function(name) {
                    return ArrayUtils.GetFirst(this.list, 'name', name);
                },
                /**
     * Returns a random Game Object from this Container.
     *
     * @method Phaser.GameObjects.Container#getRandom
     * @since 3.4.0
     *
     * @param {number} [startIndex=0] - An optional start index.
     * @param {number} [length] - An optional length, the total number of elements (from the startIndex) to choose from.
     *
     * @return {?Phaser.GameObjects.GameObject} A random child from the Container, or `null` if the Container is empty.
     */ getRandom: function(startIndex, length) {
                    return ArrayUtils.GetRandom(this.list, startIndex, length);
                },
                /**
     * Gets the first Game Object in this Container.
     *
     * You can also specify a property and value to search for, in which case it will return the first
     * Game Object in this Container with a matching property and / or value.
     *
     * For example: `getFirst('visible', true)` would return the first Game Object that had its `visible` property set.
     *
     * You can limit the search to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#getFirst
     * @since 3.4.0
     *
     * @param {string} property - The property to test on each Game Object in the Container.
     * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {?Phaser.GameObjects.GameObject} The first matching Game Object, or `null` if none was found.
     */ getFirst: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetFirst(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns all Game Objects in this Container.
     *
     * You can optionally specify a matching criteria using the `property` and `value` arguments.
     *
     * For example: `getAll('body')` would return only Game Objects that have a body property.
     *
     * You can also specify a value to compare the property to:
     *
     * `getAll('visible', true)` would return only Game Objects that have their visible property set to `true`.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#getAll
     * @since 3.4.0
     *
     * @param {string} [property] - The property to test on each Game Object in the Container.
     * @param {any} [value] - If property is set then the `property` must strictly equal this value to be included in the results.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of matching Game Objects from this Container.
     */ getAll: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Returns the total number of Game Objects in this Container that have a property
     * matching the given value.
     *
     * For example: `count('visible', true)` would count all the elements that have their visible property set.
     *
     * You can optionally limit the operation to the `startIndex` - `endIndex` range.
     *
     * @method Phaser.GameObjects.Container#count
     * @since 3.4.0
     *
     * @param {string} property - The property to check.
     * @param {any} value - The value to check.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {number} The total number of Game Objects in this Container with a property matching the given value.
     */ count: function(property, value, startIndex, endIndex) {
                    return ArrayUtils.CountAllMatching(this.list, property, value, startIndex, endIndex);
                },
                /**
     * Swaps the position of two Game Objects in this Container.
     * Both Game Objects must belong to this Container.
     *
     * @method Phaser.GameObjects.Container#swap
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child1 - The first Game Object to swap.
     * @param {Phaser.GameObjects.GameObject} child2 - The second Game Object to swap.
     *
     * @return {this} This Container instance.
     */ swap: function(child1, child2) {
                    ArrayUtils.Swap(this.list, child1, child2);
                    return this;
                },
                /**
     * Moves a Game Object to a new position within this Container.
     *
     * The Game Object must already be a child of this Container.
     *
     * The Game Object is removed from its old position and inserted into the new one.
     * Therefore the Container size does not change. Other children will change position accordingly.
     *
     * @method Phaser.GameObjects.Container#moveTo
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to move.
     * @param {number} index - The new position of the Game Object in this Container.
     *
     * @return {this} This Container instance.
     */ moveTo: function(child, index) {
                    ArrayUtils.MoveTo(this.list, child, index);
                    return this;
                },
                /**
     * Removes the given Game Object, or array of Game Objects, from this Container.
     *
     * The Game Objects must already be children of this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#remove
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to be removed from the Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each child successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ remove: function(child, destroyChild) {
                    var removed = ArrayUtils.Remove(this.list, child, this.removeHandler, this);
                    if (destroyChild && removed) {
                        if (!Array.isArray(removed)) removed = [
                            removed
                        ];
                        for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    }
                    return this;
                },
                /**
     * Removes the Game Object at the given position in this Container.
     *
     * You can also optionally call `destroy` on the Game Object, if one is found.
     *
     * @method Phaser.GameObjects.Container#removeAt
     * @since 3.4.0
     *
     * @param {number} index - The index of the Game Object to be removed.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAt: function(index, destroyChild) {
                    var removed = ArrayUtils.RemoveAt(this.list, index, this.removeHandler, this);
                    if (destroyChild && removed) removed.destroy();
                    return this;
                },
                /**
     * Removes the Game Objects between the given positions in this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeBetween
     * @since 3.4.0
     *
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeBetween: function(startIndex, endIndex, destroyChild) {
                    var removed = ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeHandler, this);
                    if (destroyChild) for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    return this;
                },
                /**
     * Removes all Game Objects from this Container.
     *
     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
     *
     * @method Phaser.GameObjects.Container#removeAll
     * @since 3.4.0
     *
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ removeAll: function(destroyChild) {
                    var removed = ArrayUtils.RemoveBetween(this.list, 0, this.list.length, this.removeHandler, this);
                    if (destroyChild) for(var i = 0; i < removed.length; i++)removed[i].destroy();
                    return this;
                },
                /**
     * Brings the given Game Object to the top of this Container.
     * This will cause it to render on-top of any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#bringToTop
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to bring to the top of the Container.
     *
     * @return {this} This Container instance.
     */ bringToTop: function(child) {
                    ArrayUtils.BringToTop(this.list, child);
                    return this;
                },
                /**
     * Sends the given Game Object to the bottom of this Container.
     * This will cause it to render below any other objects in the Container.
     *
     * @method Phaser.GameObjects.Container#sendToBack
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to send to the bottom of the Container.
     *
     * @return {this} This Container instance.
     */ sendToBack: function(child) {
                    ArrayUtils.SendToBack(this.list, child);
                    return this;
                },
                /**
     * Moves the given Game Object up one place in this Container, unless it's already at the top.
     *
     * @method Phaser.GameObjects.Container#moveUp
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveUp: function(child) {
                    ArrayUtils.MoveUp(this.list, child);
                    return this;
                },
                /**
     * Moves the given Game Object down one place in this Container, unless it's already at the bottom.
     *
     * @method Phaser.GameObjects.Container#moveDown
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
     *
     * @return {this} This Container instance.
     */ moveDown: function(child) {
                    ArrayUtils.MoveDown(this.list, child);
                    return this;
                },
                /**
     * Reverses the order of all Game Objects in this Container.
     *
     * @method Phaser.GameObjects.Container#reverse
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ reverse: function() {
                    this.list.reverse();
                    return this;
                },
                /**
     * Shuffles the all Game Objects in this Container using the Fisher-Yates implementation.
     *
     * @method Phaser.GameObjects.Container#shuffle
     * @since 3.4.0
     *
     * @return {this} This Container instance.
     */ shuffle: function() {
                    ArrayUtils.Shuffle(this.list);
                    return this;
                },
                /**
     * Replaces a Game Object in this Container with the new Game Object.
     * The new Game Object cannot already be a child of this Container.
     *
     * @method Phaser.GameObjects.Container#replace
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} oldChild - The Game Object in this Container that will be replaced.
     * @param {Phaser.GameObjects.GameObject} newChild - The Game Object to be added to this Container.
     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
     *
     * @return {this} This Container instance.
     */ replace: function(oldChild, newChild, destroyChild) {
                    var moved = ArrayUtils.Replace(this.list, oldChild, newChild);
                    if (moved) {
                        this.addHandler(newChild);
                        this.removeHandler(oldChild);
                        if (destroyChild) oldChild.destroy();
                    }
                    return this;
                },
                /**
     * Returns `true` if the given Game Object is a direct child of this Container.
     *
     * This check does not scan nested Containers.
     *
     * @method Phaser.GameObjects.Container#exists
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to check for within this Container.
     *
     * @return {boolean} True if the Game Object is an immediate child of this Container, otherwise false.
     */ exists: function(child) {
                    return this.list.indexOf(child) > -1;
                },
                /**
     * Sets the property to the given value on all Game Objects in this Container.
     *
     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
     * the first 50 Game Objects.
     *
     * @method Phaser.GameObjects.Container#setAll
     * @since 3.4.0
     *
     * @param {string} property - The property that must exist on the Game Object.
     * @param {any} value - The value to get the property to.
     * @param {number} [startIndex=0] - An optional start index to search from.
     * @param {number} [endIndex=Container.length] - An optional end index to search up to (but not included)
     *
     * @return {this} This Container instance.
     */ setAll: function(property, value, startIndex, endIndex) {
                    ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
                    return this;
                },
                /**
     * @callback EachContainerCallback
     * @generic I - [item]
     *
     * @param {*} item - The child Game Object of the Container.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * A copy of the Container is made before passing each entry to your callback.
     * This protects against the callback itself modifying the Container.
     *
     * If you know for sure that the callback will not change the size of this Container
     * then you can use the more performant `Container.iterate` method instead.
     *
     * @method Phaser.GameObjects.Container#each
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ each: function(callback, context) {
                    var args = [
                        null
                    ];
                    var i;
                    var temp = this.list.slice();
                    var len = temp.length;
                    for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < len; i++){
                        args[0] = temp[i];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Passes all Game Objects in this Container to the given callback.
     *
     * Only use this method when you absolutely know that the Container will not be modified during
     * the iteration, i.e. by removing or adding to its contents.
     *
     * @method Phaser.GameObjects.Container#iterate
     * @since 3.4.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [context] - Value to use as `this` when executing callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     *
     * @return {this} This Container instance.
     */ iterate: function(callback, context) {
                    var args = [
                        null
                    ];
                    var i;
                    for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = 0; i < this.list.length; i++){
                        args[0] = this.list[i];
                        callback.apply(context, args);
                    }
                    return this;
                },
                /**
     * Sets the scroll factor of this Container and optionally all of its children.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     *
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Container#setScrollFactor
     * @since 3.4.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     * @param {boolean} [updateChildren=false] - Apply this scrollFactor to all Container children as well?
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y, updateChildren) {
                    if (y === undefined) y = x;
                    if (updateChildren === undefined) updateChildren = false;
                    this.scrollFactorX = x;
                    this.scrollFactorY = y;
                    if (updateChildren) {
                        ArrayUtils.SetAll(this.list, 'scrollFactorX', x);
                        ArrayUtils.SetAll(this.list, 'scrollFactorY', y);
                    }
                    return this;
                },
                /**
     * The number of Game Objects inside this Container.
     *
     * @name Phaser.GameObjects.Container#length
     * @type {number}
     * @readonly
     * @since 3.4.0
     */ length: {
                    get: function() {
                        return this.list.length;
                    }
                },
                /**
     * Returns the first Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#first
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ first: {
                    get: function() {
                        this.position = 0;
                        if (this.list.length > 0) return this.list[0];
                        else return null;
                    }
                },
                /**
     * Returns the last Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#last
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ last: {
                    get: function() {
                        if (this.list.length > 0) {
                            this.position = this.list.length - 1;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Returns the next Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#next
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ next: {
                    get: function() {
                        if (this.position < this.list.length) {
                            this.position++;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Returns the previous Game Object within the Container, or `null` if it is empty.
     *
     * You can move the cursor by calling `Container.next` and `Container.previous`.
     *
     * @name Phaser.GameObjects.Container#previous
     * @type {?Phaser.GameObjects.GameObject}
     * @readonly
     * @since 3.4.0
     */ previous: {
                    get: function() {
                        if (this.position > 0) {
                            this.position--;
                            return this.list[this.position];
                        } else return null;
                    }
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Container#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.removeAll(!!this.exclusive);
                    this.localTransform.destroy();
                    this.tempTransformMatrix.destroy();
                    this.list = [];
                }
            });
            module1.exports = Container;
        /***/ },
        /* 212 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(147);
            var Class = __webpack_require__(0);
            var Render = __webpack_require__(1051);
            /**
 * @classdesc
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 *
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 *
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): {@link http://www.angelcode.com/products/bmfont/|http://www.angelcode.com/products/bmfont/}
 * Glyph Designer (OS X, commercial): {@link http://www.71squared.com/en/glyphdesigner|http://www.71squared.com/en/glyphdesigner}
 * Littera (Web-based, free): {@link http://kvazars.com/littera/|http://kvazars.com/littera/}
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: {@link http://codebeautify.org/xmltojson|http://codebeautify.org/xmltojson}
 *
 * @class DynamicBitmapText
 * @extends Phaser.GameObjects.BitmapText
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
 * @param {number} x - The x coordinate of this Game Object in world space.
 * @param {number} y - The y coordinate of this Game Object in world space.
 * @param {string} font - The key of the font to use from the Bitmap Font cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size of this Bitmap Text.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 */ var DynamicBitmapText = new Class({
                Extends: BitmapText,
                Mixins: [
                    Render
                ],
                initialize: function DynamicBitmapText(scene, x, y, font, text, size, align) {
                    BitmapText.call(this, scene, x, y, font, text, size, align);
                    this.type = 'DynamicBitmapText';
                    /**
         * The horizontal scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollX = 0;
                    /**
         * The vertical scroll position of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#scrollY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.scrollY = 0;
                    /**
         * The crop width of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropWidth = 0;
                    /**
         * The crop height of the Bitmap Text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#cropHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cropHeight = 0;
                    /**
         * A callback that alters how each character of the Bitmap Text is rendered.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#displayCallback
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallback}
         * @since 3.0.0
         */ this.displayCallback;
                    /**
         * The data object that is populated during rendering, then passed to the displayCallback.
         * You should modify this object then return it back from the callback. It's updated values
         * will be used to render the specific glyph.
         *
         * Please note that if you need a reference to this object locally in your game code then you
         * should shallow copy it, as it's updated and re-used for every glyph in the text.
         *
         * @name Phaser.GameObjects.DynamicBitmapText#callbackData
         * @type {Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig}
         * @since 3.11.0
         */ this.callbackData = {
                        parent: this,
                        color: 0,
                        tint: {
                            topLeft: 0,
                            topRight: 0,
                            bottomLeft: 0,
                            bottomRight: 0
                        },
                        index: 0,
                        charCode: 0,
                        x: 0,
                        y: 0,
                        scale: 0,
                        rotation: 0,
                        data: 0
                    };
                },
                /**
     * Set the crop size of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of the crop.
     * @param {number} height - The height of the crop.
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height) {
                    this.cropWidth = width;
                    this.cropHeight = height;
                    return this;
                },
                /**
     * Set a callback that alters how each character of the Bitmap Text is rendered.
     *
     * The callback receives a {@link Phaser.Types.GameObjects.BitmapText.DisplayCallbackConfig} object that contains information about the character that's
     * about to be rendered.
     *
     * It should return an object with `x`, `y`, `scale` and `rotation` properties that will be used instead of the
     * usual values when rendering.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setDisplayCallback
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.BitmapText.DisplayCallback} callback - The display callback to set.
     *
     * @return {this} This Game Object.
     */ setDisplayCallback: function(callback) {
                    this.displayCallback = callback;
                    return this;
                },
                /**
     * Set the horizontal scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollX: function(value) {
                    this.scrollX = value;
                    return this;
                },
                /**
     * Set the vertical scroll position of this Bitmap Text.
     *
     * @method Phaser.GameObjects.DynamicBitmapText#setScrollY
     * @since 3.0.0
     *
     * @param {number} value - The vertical scroll position to set.
     *
     * @return {this} This Game Object.
     */ setScrollY: function(value) {
                    this.scrollY = value;
                    return this;
                }
            });
            module1.exports = DynamicBitmapText;
        /***/ },
        /* 213 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(131);
            var Class = __webpack_require__(0);
            var Commands = __webpack_require__(214);
            var ComponentsAlpha = __webpack_require__(297);
            var ComponentsBlendMode = __webpack_require__(298);
            var ComponentsDepth = __webpack_require__(299);
            var ComponentsMask = __webpack_require__(303);
            var ComponentsPipeline = __webpack_require__(171);
            var ComponentsScrollFactor = __webpack_require__(306);
            var ComponentsTransform = __webpack_require__(307);
            var ComponentsVisible = __webpack_require__(308);
            var Ellipse = __webpack_require__(108);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            var PIPELINES_CONST = __webpack_require__(65);
            var Render = __webpack_require__(1057);
            /**
 * @classdesc
 * A Graphics object is a way to draw primitive shapes to your game. Primitives include forms of geometry, such as
 * Rectangles, Circles, and Polygons. They also include lines, arcs and curves. When you initially create a Graphics
 * object it will be empty.
 *
 * To draw to it you must first specify a line style or fill style (or both), draw shapes using paths, and finally
 * fill or stroke them. For example:
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.beginPath();
 * graphics.moveTo(100, 100);
 * graphics.lineTo(200, 200);
 * graphics.closePath();
 * graphics.strokePath();
 * ```
 *
 * There are also many helpful methods that draw and fill/stroke common shapes for you.
 *
 * ```javascript
 * graphics.lineStyle(5, 0xFF00FF, 1.0);
 * graphics.fillStyle(0xFFFFFF, 1.0);
 * graphics.fillRect(50, 50, 400, 200);
 * graphics.strokeRect(50, 50, 400, 200);
 * ```
 *
 * When a Graphics object is rendered it will render differently based on if the game is running under Canvas or WebGL.
 * Under Canvas it will use the HTML Canvas context drawing operations to draw the path.
 * Under WebGL the graphics data is decomposed into polygons. Both of these are expensive processes, especially with
 * complex shapes.
 *
 * If your Graphics object doesn't change much (or at all) once you've drawn your shape to it, then you will help
 * performance by calling {@link Phaser.GameObjects.Graphics#generateTexture}. This will 'bake' the Graphics object into
 * a Texture, and return it. You can then use this Texture for Sprites or other display objects. If your Graphics object
 * updates frequently then you should avoid doing this, as it will constantly generate new textures, which will consume
 * memory.
 *
 * As you can tell, Graphics objects are a bit of a trade-off. While they are extremely useful, you need to be careful
 * in their complexity and quantity of them in your game.
 *
 * @class Graphics
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Graphics object belongs.
 * @param {Phaser.Types.GameObjects.Graphics.Options} [options] - Options that set the position and default style of this Graphics object.
 */ var Graphics = new Class({
                Extends: GameObject,
                Mixins: [
                    ComponentsAlpha,
                    ComponentsBlendMode,
                    ComponentsDepth,
                    ComponentsMask,
                    ComponentsPipeline,
                    ComponentsTransform,
                    ComponentsVisible,
                    ComponentsScrollFactor,
                    Render
                ],
                initialize: function Graphics(scene, options) {
                    var x = GetValue(options, 'x', 0);
                    var y = GetValue(options, 'y', 0);
                    GameObject.call(this, scene, 'Graphics');
                    this.setPosition(x, y);
                    this.initPipeline(PIPELINES_CONST.GRAPHICS_PIPELINE);
                    /**
         * The horizontal display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginX = 0;
                    /**
         * The vertical display origin of the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#displayOriginY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.displayOriginY = 0;
                    /**
         * The array of commands used to render the Graphics.
         *
         * @name Phaser.GameObjects.Graphics#commandBuffer
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.commandBuffer = [];
                    /**
         * The default fill color for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillColor
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.defaultFillColor = -1;
                    /**
         * The default fill alpha for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultFillAlpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultFillAlpha = 1;
                    /**
         * The default stroke width for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeWidth
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeWidth = 1;
                    /**
         * The default stroke color for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeColor
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.defaultStrokeColor = -1;
                    /**
         * The default stroke alpha for shapes rendered by this Graphics object.
         *
         * @name Phaser.GameObjects.Graphics#defaultStrokeAlpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.defaultStrokeAlpha = 1;
                    /**
         * Internal property that keeps track of the line width style setting.
         *
         * @name Phaser.GameObjects.Graphics#_lineWidth
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._lineWidth = 1.0;
                    this.setDefaultStyles(options);
                },
                /**
     * Set the default style settings for this Graphics object.
     *
     * @method Phaser.GameObjects.Graphics#setDefaultStyles
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Graphics.Styles} options - The styles to set as defaults.
     *
     * @return {this} This Game Object.
     */ setDefaultStyles: function(options) {
                    if (GetValue(options, 'lineStyle', null)) {
                        this.defaultStrokeWidth = GetValue(options, 'lineStyle.width', 1);
                        this.defaultStrokeColor = GetValue(options, 'lineStyle.color', 0xffffff);
                        this.defaultStrokeAlpha = GetValue(options, 'lineStyle.alpha', 1);
                        this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                    }
                    if (GetValue(options, 'fillStyle', null)) {
                        this.defaultFillColor = GetValue(options, 'fillStyle.color', 0xffffff);
                        this.defaultFillAlpha = GetValue(options, 'fillStyle.alpha', 1);
                        this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                    }
                    return this;
                },
                /**
     * Set the current line style.
     *
     * @method Phaser.GameObjects.Graphics#lineStyle
     * @since 3.0.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} color - The stroke color.
     * @param {number} [alpha=1] - The stroke alpha.
     *
     * @return {this} This Game Object.
     */ lineStyle: function(lineWidth, color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.LINE_STYLE, lineWidth, color, alpha);
                    this._lineWidth = lineWidth;
                    return this;
                },
                /**
     * Set the current fill style.
     *
     * @method Phaser.GameObjects.Graphics#fillStyle
     * @since 3.0.0
     *
     * @param {number} color - The fill color.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ fillStyle: function(color, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.FILL_STYLE, color, alpha);
                    return this;
                },
                /**
     * Sets a gradient fill style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all filled shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `fillStyle` and provide a new single fill color.
     *
     * When filling a triangle only the first 3 color values provided are used for the 3 points of a triangle.
     *
     * This feature is best used only on rectangles and triangles. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient fill a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#fillGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} topLeft - The top left fill color.
     * @param {number} topRight - The top right fill color.
     * @param {number} bottomLeft - The bottom left fill color.
     * @param {number} bottomRight - The bottom right fill color. Not used when filling triangles.
     * @param {number} [alphaTopLeft=1] - The top left alpha value. If you give only this value, it's used for all corners.
     * @param {number} [alphaTopRight=1] - The top right alpha value.
     * @param {number} [alphaBottomLeft=1] - The bottom left alpha value.
     * @param {number} [alphaBottomRight=1] - The bottom right alpha value.
     *
     * @return {this} This Game Object.
     */ fillGradientStyle: function(topLeft, topRight, bottomLeft, bottomRight, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight) {
                    if (alphaTopLeft === undefined) alphaTopLeft = 1;
                    if (alphaTopRight === undefined) alphaTopRight = alphaTopLeft;
                    if (alphaBottomLeft === undefined) alphaBottomLeft = alphaTopLeft;
                    if (alphaBottomRight === undefined) alphaBottomRight = alphaTopLeft;
                    this.commandBuffer.push(Commands.GRADIENT_FILL_STYLE, alphaTopLeft, alphaTopRight, alphaBottomLeft, alphaBottomRight, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Sets a gradient line style. This is a WebGL only feature.
     *
     * The gradient color values represent the 4 corners of an untransformed rectangle.
     * The gradient is used to color all stroked shapes and paths drawn after calling this method.
     * If you wish to turn a gradient off, call `lineStyle` and provide a new single line color.
     *
     * This feature is best used only on single lines. All other shapes will give strange results.
     *
     * Note that for objects such as arcs or ellipses, or anything which is made out of triangles, each triangle used
     * will be filled with a gradient on its own. There is no ability to gradient stroke a shape or path as a single
     * entity at this time.
     *
     * @method Phaser.GameObjects.Graphics#lineGradientStyle
     * @webglOnly
     * @since 3.12.0
     *
     * @param {number} lineWidth - The stroke width.
     * @param {number} topLeft - The tint being applied to the top-left of the Game Object.
     * @param {number} topRight - The tint being applied to the top-right of the Game Object.
     * @param {number} bottomLeft - The tint being applied to the bottom-left of the Game Object.
     * @param {number} bottomRight - The tint being applied to the bottom-right of the Game Object.
     * @param {number} [alpha=1] - The fill alpha.
     *
     * @return {this} This Game Object.
     */ lineGradientStyle: function(lineWidth, topLeft, topRight, bottomLeft, bottomRight, alpha) {
                    if (alpha === undefined) alpha = 1;
                    this.commandBuffer.push(Commands.GRADIENT_LINE_STYLE, lineWidth, alpha, topLeft, topRight, bottomLeft, bottomRight);
                    return this;
                },
                /**
     * Start a new shape path.
     *
     * @method Phaser.GameObjects.Graphics#beginPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ beginPath: function() {
                    this.commandBuffer.push(Commands.BEGIN_PATH);
                    return this;
                },
                /**
     * Close the current path.
     *
     * @method Phaser.GameObjects.Graphics#closePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ closePath: function() {
                    this.commandBuffer.push(Commands.CLOSE_PATH);
                    return this;
                },
                /**
     * Fill the current path.
     *
     * @method Phaser.GameObjects.Graphics#fillPath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ fillPath: function() {
                    this.commandBuffer.push(Commands.FILL_PATH);
                    return this;
                },
                /**
     * Fill the current path.
     *
     * This is an alias for `Graphics.fillPath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#fill
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ fill: function() {
                    this.commandBuffer.push(Commands.FILL_PATH);
                    return this;
                },
                /**
     * Stroke the current path.
     *
     * @method Phaser.GameObjects.Graphics#strokePath
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ strokePath: function() {
                    this.commandBuffer.push(Commands.STROKE_PATH);
                    return this;
                },
                /**
     * Stroke the current path.
     *
     * This is an alias for `Graphics.strokePath` and does the same thing.
     * It was added to match the CanvasRenderingContext 2D API.
     *
     * @method Phaser.GameObjects.Graphics#stroke
     * @since 3.16.0
     *
     * @return {this} This Game Object.
     */ stroke: function() {
                    this.commandBuffer.push(Commands.STROKE_PATH);
                    return this;
                },
                /**
     * Fill the given circle.
     *
     * @method Phaser.GameObjects.Graphics#fillCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to fill.
     *
     * @return {this} This Game Object.
     */ fillCircleShape: function(circle) {
                    return this.fillCircle(circle.x, circle.y, circle.radius);
                },
                /**
     * Stroke the given circle.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Circle} circle - The circle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeCircleShape: function(circle) {
                    return this.strokeCircle(circle.x, circle.y, circle.radius);
                },
                /**
     * Fill a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ fillCircle: function(x, y, radius) {
                    this.beginPath();
                    this.arc(x, y, radius, 0, MATH_CONST.PI2);
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke a circle with the given position and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeCircle
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     *
     * @return {this} This Game Object.
     */ strokeCircle: function(x, y, radius) {
                    this.beginPath();
                    this.arc(x, y, radius, 0, MATH_CONST.PI2);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#fillRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to fill.
     *
     * @return {this} This Game Object.
     */ fillRectShape: function(rect) {
                    return this.fillRect(rect.x, rect.y, rect.width, rect.height);
                },
                /**
     * Stroke the given rectangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeRectShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Rectangle} rect - The rectangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeRectShape: function(rect) {
                    return this.strokeRect(rect.x, rect.y, rect.width, rect.height);
                },
                /**
     * Fill a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ fillRect: function(x, y, width, height) {
                    this.commandBuffer.push(Commands.FILL_RECT, x, y, width, height);
                    return this;
                },
                /**
     * Stroke a rectangle with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeRect
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     *
     * @return {this} This Game Object.
     */ strokeRect: function(x, y, width, height) {
                    var lineWidthHalf = this._lineWidth / 2;
                    var minx = x - lineWidthHalf;
                    var maxx = x + lineWidthHalf;
                    this.beginPath();
                    this.moveTo(x, y);
                    this.lineTo(x, y + height);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(x + width, y);
                    this.lineTo(x + width, y + height);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(minx, y);
                    this.lineTo(maxx + width, y);
                    this.strokePath();
                    this.beginPath();
                    this.moveTo(minx, y + height);
                    this.lineTo(maxx + width, y + height);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#fillRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radii for corners.
     *
     * @return {this} This Game Object.
     */ fillRoundedRect: function(x, y, width, height, radius) {
                    if (radius === undefined) radius = 20;
                    var tl = radius;
                    var tr = radius;
                    var bl = radius;
                    var br = radius;
                    if (typeof radius !== 'number') {
                        tl = GetFastValue(radius, 'tl', 20);
                        tr = GetFastValue(radius, 'tr', 20);
                        bl = GetFastValue(radius, 'bl', 20);
                        br = GetFastValue(radius, 'br', 20);
                    }
                    this.beginPath();
                    this.moveTo(x + tl, y);
                    this.lineTo(x + width - tr, y);
                    this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                    this.lineTo(x + width, y + height - br);
                    this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                    this.lineTo(x + bl, y + height);
                    this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                    this.lineTo(x, y + tl);
                    this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke a rounded rectangle with the given position, size and radius.
     *
     * @method Phaser.GameObjects.Graphics#strokeRoundedRect
     * @since 3.11.0
     *
     * @param {number} x - The x coordinate of the top-left of the rectangle.
     * @param {number} y - The y coordinate of the top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {(Phaser.Types.GameObjects.Graphics.RoundedRectRadius|number)} [radius=20] - The corner radius; It can also be an object to specify different radii for corners.
     *
     * @return {this} This Game Object.
     */ strokeRoundedRect: function(x, y, width, height, radius) {
                    if (radius === undefined) radius = 20;
                    var tl = radius;
                    var tr = radius;
                    var bl = radius;
                    var br = radius;
                    if (typeof radius !== 'number') {
                        tl = GetFastValue(radius, 'tl', 20);
                        tr = GetFastValue(radius, 'tr', 20);
                        bl = GetFastValue(radius, 'bl', 20);
                        br = GetFastValue(radius, 'br', 20);
                    }
                    this.beginPath();
                    this.moveTo(x + tl, y);
                    this.lineTo(x + width - tr, y);
                    this.moveTo(x + width - tr, y);
                    this.arc(x + width - tr, y + tr, tr, -MATH_CONST.TAU, 0);
                    this.lineTo(x + width, y + height - br);
                    this.moveTo(x + width, y + height - br);
                    this.arc(x + width - br, y + height - br, br, 0, MATH_CONST.TAU);
                    this.lineTo(x + bl, y + height);
                    this.moveTo(x + bl, y + height);
                    this.arc(x + bl, y + height - bl, bl, MATH_CONST.TAU, Math.PI);
                    this.lineTo(x, y + tl);
                    this.moveTo(x, y + tl);
                    this.arc(x + tl, y + tl, tl, -Math.PI, -MATH_CONST.TAU);
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the given point.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPointShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - The point to fill.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPointShape: function(point, size) {
                    return this.fillPoint(point.x, point.y, size);
                },
                /**
     * Fill a point at the given position.
     *
     * Draws a square at the given position, 1 pixel in size by default.
     *
     * @method Phaser.GameObjects.Graphics#fillPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the point.
     * @param {number} y - The y coordinate of the point.
     * @param {number} [size=1] - The size of the square to draw.
     *
     * @return {this} This Game Object.
     */ fillPoint: function(x, y, size) {
                    if (!size || size < 1) size = 1;
                    else {
                        x -= size / 2;
                        y -= size / 2;
                    }
                    this.commandBuffer.push(Commands.FILL_RECT, x, y, size, size);
                    return this;
                },
                /**
     * Fill the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to fill.
     *
     * @return {this} This Game Object.
     */ fillTriangleShape: function(triangle) {
                    return this.fillTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                },
                /**
     * Stroke the given triangle.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangleShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Triangle} triangle - The triangle to stroke.
     *
     * @return {this} This Game Object.
     */ strokeTriangleShape: function(triangle) {
                    return this.strokeTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
                },
                /**
     * Fill a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#fillTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ fillTriangle: function(x0, y0, x1, y1, x2, y2) {
                    this.commandBuffer.push(Commands.FILL_TRIANGLE, x0, y0, x1, y1, x2, y2);
                    return this;
                },
                /**
     * Stroke a triangle with the given points.
     *
     * @method Phaser.GameObjects.Graphics#strokeTriangle
     * @since 3.0.0
     *
     * @param {number} x0 - The x coordinate of the first point.
     * @param {number} y0 - The y coordinate of the first point.
     * @param {number} x1 - The x coordinate of the second point.
     * @param {number} y1 - The y coordinate of the second point.
     * @param {number} x2 - The x coordinate of the third point.
     * @param {number} y2 - The y coordinate of the third point.
     *
     * @return {this} This Game Object.
     */ strokeTriangle: function(x0, y0, x1, y1, x2, y2) {
                    this.commandBuffer.push(Commands.STROKE_TRIANGLE, x0, y0, x1, y1, x2, y2);
                    return this;
                },
                /**
     * Draw the given line.
     *
     * @method Phaser.GameObjects.Graphics#strokeLineShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Line} line - The line to stroke.
     *
     * @return {this} This Game Object.
     */ strokeLineShape: function(line) {
                    return this.lineBetween(line.x1, line.y1, line.x2, line.y2);
                },
                /**
     * Draw a line between the given points.
     *
     * @method Phaser.GameObjects.Graphics#lineBetween
     * @since 3.0.0
     *
     * @param {number} x1 - The x coordinate of the start point of the line.
     * @param {number} y1 - The y coordinate of the start point of the line.
     * @param {number} x2 - The x coordinate of the end point of the line.
     * @param {number} y2 - The y coordinate of the end point of the line.
     *
     * @return {this} This Game Object.
     */ lineBetween: function(x1, y1, x2, y2) {
                    this.beginPath();
                    this.moveTo(x1, y1);
                    this.lineTo(x2, y2);
                    this.strokePath();
                    return this;
                },
                /**
     * Draw a line from the current drawing position to the given position.
     *
     * Moves the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#lineTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to draw the line to.
     * @param {number} y - The y coordinate to draw the line to.
     *
     * @return {this} This Game Object.
     */ lineTo: function(x, y) {
                    this.commandBuffer.push(Commands.LINE_TO, x, y);
                    return this;
                },
                /**
     * Move the current drawing position to the given position.
     *
     * @method Phaser.GameObjects.Graphics#moveTo
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to move to.
     * @param {number} y - The y coordinate to move to.
     *
     * @return {this} This Game Object.
     */ moveTo: function(x, y) {
                    this.commandBuffer.push(Commands.MOVE_TO, x, y);
                    return this;
                },
                /**
     * Stroke the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is stroked.
     *
     * @method Phaser.GameObjects.Graphics#strokePoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to stroke.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop drawing at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ strokePoints: function(points, closeShape, closePath, endIndex) {
                    if (closeShape === undefined) closeShape = false;
                    if (closePath === undefined) closePath = false;
                    if (endIndex === undefined) endIndex = points.length;
                    this.beginPath();
                    this.moveTo(points[0].x, points[0].y);
                    for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                    if (closeShape) this.lineTo(points[0].x, points[0].y);
                    if (closePath) this.closePath();
                    this.strokePath();
                    return this;
                },
                /**
     * Fill the shape represented by the given array of points.
     *
     * Pass `closeShape` to automatically close the shape by joining the last to the first point.
     *
     * Pass `closePath` to automatically close the path before it is filled.
     *
     * @method Phaser.GameObjects.Graphics#fillPoints
     * @since 3.0.0
     *
     * @param {(array|Phaser.Geom.Point[])} points - The points to fill.
     * @param {boolean} [closeShape=false] - When `true`, the shape is closed by joining the last point to the first point.
     * @param {boolean} [closePath=false] - When `true`, the path is closed before being stroked.
     * @param {number} [endIndex] - The index of `points` to stop at. Defaults to `points.length`.
     *
     * @return {this} This Game Object.
     */ fillPoints: function(points, closeShape, closePath, endIndex) {
                    if (closeShape === undefined) closeShape = false;
                    if (closePath === undefined) closePath = false;
                    if (endIndex === undefined) endIndex = points.length;
                    this.beginPath();
                    this.moveTo(points[0].x, points[0].y);
                    for(var i = 1; i < endIndex; i++)this.lineTo(points[i].x, points[i].y);
                    if (closeShape) this.lineTo(points[0].x, points[0].y);
                    if (closePath) this.closePath();
                    this.fillPath();
                    return this;
                },
                /**
     * Stroke the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to stroke.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipseShape: function(ellipse, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var points = ellipse.getPoints(smoothness);
                    return this.strokePoints(points, true);
                },
                /**
     * Stroke an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#strokeEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ strokeEllipse: function(x, y, width, height, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var ellipse = new Ellipse(x, y, width, height);
                    var points = ellipse.getPoints(smoothness);
                    return this.strokePoints(points, true);
                },
                /**
     * Fill the given ellipse.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipseShape
     * @since 3.0.0
     *
     * @param {Phaser.Geom.Ellipse} ellipse - The ellipse to fill.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipseShape: function(ellipse, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var points = ellipse.getPoints(smoothness);
                    return this.fillPoints(points, true);
                },
                /**
     * Fill an ellipse with the given position and size.
     *
     * @method Phaser.GameObjects.Graphics#fillEllipse
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the ellipse.
     * @param {number} y - The y coordinate of the center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {number} [smoothness=32] - The number of points to draw the ellipse with.
     *
     * @return {this} This Game Object.
     */ fillEllipse: function(x, y, width, height, smoothness) {
                    if (smoothness === undefined) smoothness = 32;
                    var ellipse = new Ellipse(x, y, width, height);
                    var points = ellipse.getPoints(smoothness);
                    return this.fillPoints(points, true);
                },
                /**
     * Draw an arc.
     *
     * This method can be used to create circles, or parts of circles.
     *
     * Make sure you call `beginPath` before starting the arc unless you wish for the arc to automatically
     * close when filled or stroked.
     *
     * Use the optional `overshoot` argument increase the number of iterations that take place when
     * the arc is rendered in WebGL. This is useful if you're drawing an arc with an especially thick line,
     * as it will allow the arc to fully join-up. Try small values at first, i.e. 0.01.
     *
     * Call {@link Phaser.GameObjects.Graphics#fillPath} or {@link Phaser.GameObjects.Graphics#strokePath} after calling
     * this method to draw the arc.
     *
     * @method Phaser.GameObjects.Graphics#arc
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the center of the circle.
     * @param {number} y - The y coordinate of the center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {number} startAngle - The starting angle, in radians.
     * @param {number} endAngle - The ending angle, in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to increase the segment iterations in WebGL rendering. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly. Use small numbers such as 0.01 to start with and increase as needed.
     *
     * @return {this} This Game Object.
     */ arc: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                    if (anticlockwise === undefined) anticlockwise = false;
                    if (overshoot === undefined) overshoot = 0;
                    this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                    return this;
                },
                /**
     * Creates a pie-chart slice shape centered at `x`, `y` with the given radius.
     * You must define the start and end angle of the slice.
     *
     * Setting the `anticlockwise` argument to `true` creates a shape similar to Pacman.
     * Setting it to `false` creates a shape like a slice of pie.
     *
     * This method will begin a new path and close the path at the end of it.
     * To display the actual slice you need to call either `strokePath` or `fillPath` after it.
     *
     * @method Phaser.GameObjects.Graphics#slice
     * @since 3.4.0
     *
     * @param {number} x - The horizontal center of the slice.
     * @param {number} y - The vertical center of the slice.
     * @param {number} radius - The radius of the slice.
     * @param {number} startAngle - The start angle of the slice, given in radians.
     * @param {number} endAngle - The end angle of the slice, given in radians.
     * @param {boolean} [anticlockwise=false] - Whether the drawing should be anticlockwise or clockwise.
     * @param {number} [overshoot=0] - This value allows you to overshoot the endAngle by this amount. Useful if the arc has a thick stroke and needs to overshoot to join-up cleanly.
     *
     * @return {this} This Game Object.
     */ slice: function(x, y, radius, startAngle, endAngle, anticlockwise, overshoot) {
                    if (anticlockwise === undefined) anticlockwise = false;
                    if (overshoot === undefined) overshoot = 0;
                    this.commandBuffer.push(Commands.BEGIN_PATH);
                    this.commandBuffer.push(Commands.MOVE_TO, x, y);
                    this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise, overshoot);
                    this.commandBuffer.push(Commands.CLOSE_PATH);
                    return this;
                },
                /**
     * Saves the state of the Graphics by pushing the current state onto a stack.
     *
     * The most recently saved state can then be restored with {@link Phaser.GameObjects.Graphics#restore}.
     *
     * @method Phaser.GameObjects.Graphics#save
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ save: function() {
                    this.commandBuffer.push(Commands.SAVE);
                    return this;
                },
                /**
     * Restores the most recently saved state of the Graphics by popping from the state stack.
     *
     * Use {@link Phaser.GameObjects.Graphics#save} to save the current state, and call this afterwards to restore that state.
     *
     * If there is no saved state, this command does nothing.
     *
     * @method Phaser.GameObjects.Graphics#restore
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ restore: function() {
                    this.commandBuffer.push(Commands.RESTORE);
                    return this;
                },
                /**
     * Inserts a translation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be translated
     * by the given amount.
     *
     * This does not change the position of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#translateCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal translation to apply.
     * @param {number} y - The vertical translation to apply.
     *
     * @return {this} This Game Object.
     */ translateCanvas: function(x, y) {
                    this.commandBuffer.push(Commands.TRANSLATE, x, y);
                    return this;
                },
                /**
     * Inserts a scale command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be scaled
     * by the given amount.
     *
     * This does not change the scale of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#scaleCanvas
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale to apply.
     * @param {number} y - The vertical scale to apply.
     *
     * @return {this} This Game Object.
     */ scaleCanvas: function(x, y) {
                    this.commandBuffer.push(Commands.SCALE, x, y);
                    return this;
                },
                /**
     * Inserts a rotation command into this Graphics objects command buffer.
     *
     * All objects drawn _after_ calling this method will be rotated
     * by the given amount.
     *
     * This does not change the rotation of the Graphics object itself,
     * only of the objects drawn by it after calling this method.
     *
     * @method Phaser.GameObjects.Graphics#rotateCanvas
     * @since 3.0.0
     *
     * @param {number} radians - The rotation angle, in radians.
     *
     * @return {this} This Game Object.
     */ rotateCanvas: function(radians) {
                    this.commandBuffer.push(Commands.ROTATE, radians);
                    return this;
                },
                /**
     * Clear the command buffer and reset the fill style and line style to their defaults.
     *
     * @method Phaser.GameObjects.Graphics#clear
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ clear: function() {
                    this.commandBuffer.length = 0;
                    if (this.defaultFillColor > -1) this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
                    if (this.defaultStrokeColor > -1) this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
                    return this;
                },
                /**
     * Generate a texture from this Graphics object.
     *
     * If `key` is a string it'll generate a new texture using it and add it into the
     * Texture Manager (assuming no key conflict happens).
     *
     * If `key` is a Canvas it will draw the texture to that canvas context. Note that it will NOT
     * automatically upload it to the GPU in WebGL mode.
     *
     * Please understand that the texture is created via the Canvas API of the browser, therefore some
     * Graphics features, such as `fillGradientStyle`, will not appear on the resulting texture,
     * as they're unsupported by the Canvas API.
     *
     * @method Phaser.GameObjects.Graphics#generateTexture
     * @since 3.0.0
     *
     * @param {(string|HTMLCanvasElement)} key - The key to store the texture with in the Texture Manager, or a Canvas to draw to.
     * @param {number} [width] - The width of the graphics to generate.
     * @param {number} [height] - The height of the graphics to generate.
     *
     * @return {this} This Game Object.
     */ generateTexture: function(key, width, height) {
                    var sys = this.scene.sys;
                    var renderer = sys.game.renderer;
                    if (width === undefined) width = sys.scale.width;
                    if (height === undefined) height = sys.scale.height;
                    Graphics.TargetCamera.setScene(this.scene);
                    Graphics.TargetCamera.setViewport(0, 0, width, height);
                    Graphics.TargetCamera.scrollX = this.x;
                    Graphics.TargetCamera.scrollY = this.y;
                    var texture;
                    var ctx;
                    if (typeof key === 'string') {
                        if (sys.textures.exists(key)) {
                            //  Key is a string, it DOES exist in the Texture Manager AND is a canvas, so draw to it
                            texture = sys.textures.get(key);
                            var src = texture.getSourceImage();
                            if (src instanceof HTMLCanvasElement) ctx = src.getContext('2d');
                        } else {
                            //  Key is a string and doesn't exist in the Texture Manager, so generate and save it
                            texture = sys.textures.createCanvas(key, width, height);
                            ctx = texture.getSourceImage().getContext('2d');
                        }
                    } else if (key instanceof HTMLCanvasElement) //  Key is a Canvas, so draw to it
                    ctx = key.getContext('2d');
                    if (ctx) {
                        // var GraphicsCanvasRenderer = function (renderer, src, camera, parentMatrix, renderTargetCtx, allowClip)
                        this.renderCanvas(renderer, this, Graphics.TargetCamera, null, ctx, false);
                        if (texture) texture.refresh();
                    }
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Graphics#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    this.commandBuffer = [];
                }
            });
            /**
 * A Camera used specifically by the Graphics system for rendering to textures.
 *
 * @name Phaser.GameObjects.Graphics.TargetCamera
 * @type {Phaser.Cameras.Scene2D.Camera}
 * @since 3.1.0
 */ Graphics.TargetCamera = new BaseCamera();
            module1.exports = Graphics;
        /***/ },
        /* 214 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = {
                ARC: 0,
                BEGIN_PATH: 1,
                CLOSE_PATH: 2,
                FILL_RECT: 3,
                LINE_TO: 4,
                MOVE_TO: 5,
                LINE_STYLE: 6,
                FILL_STYLE: 7,
                FILL_PATH: 8,
                STROKE_PATH: 9,
                FILL_TRIANGLE: 10,
                STROKE_TRIANGLE: 11,
                SAVE: 14,
                RESTORE: 15,
                TRANSLATE: 16,
                SCALE: 17,
                ROTATE: 18,
                GRADIENT_FILL_STYLE: 21,
                GRADIENT_LINE_STYLE: 22
            };
        /***/ },
        /* 215 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse based on the given angle.
 *
 * @function Phaser.Geom.Ellipse.CircumferencePoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} angle - The angle from the center of the Ellipse to the circumference to return the point from. Given in radians.
 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
 */ var CircumferencePoint = function(ellipse, angle, out) {
                if (out === undefined) out = new Point();
                var halfWidth = ellipse.width / 2;
                var halfHeight = ellipse.height / 2;
                out.x = ellipse.x + halfWidth * Math.cos(angle);
                out.y = ellipse.y + halfHeight * Math.sin(angle);
                return out;
            };
            module1.exports = CircumferencePoint;
        /***/ },
        /* 216 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var ComponentsToJSON = __webpack_require__(173);
            var DataManager = __webpack_require__(98);
            var EventEmitter = __webpack_require__(9);
            var GameObjectEvents = __webpack_require__(75);
            var List = __webpack_require__(107);
            var Render = __webpack_require__(1065);
            var SceneEvents = __webpack_require__(21);
            var StableSort = __webpack_require__(79);
            /**
 * @classdesc
 * A Layer Game Object.
 *
 * A Layer is a special type of Game Object that acts as a Display List. You can add any type of Game Object
 * to a Layer, just as you would to a Scene. Layers can be used to visually group together 'layers' of Game
 * Objects:
 *
 * ```javascript
 * const spaceman = this.add.sprite(150, 300, 'spaceman');
 * const bunny = this.add.sprite(400, 300, 'bunny');
 * const elephant = this.add.sprite(650, 300, 'elephant');
 *
 * const layer = this.add.layer();
 *
 * layer.add([ spaceman, bunny, elephant ]);
 * ```
 *
 * The 3 sprites in the example above will now be managed by the Layer they were added to. Therefore,
 * if you then set `layer.setVisible(false)` they would all vanish from the display.
 *
 * You can also control the depth of the Game Objects within the Layer. For example, calling the
 * `setDepth` method of a child of a Layer will allow you to adjust the depth of that child _within the
 * Layer itself_, rather than the whole Scene. The Layer, too, can have its depth set as well.
 *
 * The Layer class also offers many different methods for manipulating the list, such as the
 * methods `moveUp`, `moveDown`, `sendToBack`, `bringToTop` and so on. These allow you to change the
 * display list position of the Layers children, causing it to adjust the order in which they are
 * rendered. Using `setDepth` on a child allows you to override this.
 *
 * Layers can have Post FX Pipelines set, which allows you to easily enable a post pipeline across
 * a whole range of children, which, depending on the effect, can often be far more efficient that doing so
 * on a per-child basis.
 *
 * Layers have no position or size within the Scene. This means you cannot enable a Layer for
 * physics or input, or change the position, rotation or scale of a Layer. They also have no scroll
 * factor, texture, tint, origin, crop or bounds.
 *
 * If you need those kind of features then you should use a Container instead. Containers can be added
 * to Layers, but Layers cannot be added to Containers.
 *
 * However, you can set the Alpha, Blend Mode, Depth, Mask and Visible state of a Layer. These settings
 * will impact all children being rendered by the Layer.
 *
 * @class Layer
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 */ var Layer = new Class({
                Extends: List,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Visible,
                    EventEmitter,
                    Render
                ],
                initialize: function Layer(scene, children) {
                    List.call(this, scene);
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene to which this Game Object belongs.
         *
         * Game Objects can only belong to one Scene.
         *
         * You should consider this property as being read-only. You cannot move a
         * Game Object to another Scene by simply changing it.
         *
         * @name Phaser.GameObjects.Layer#scene
         * @type {Phaser.Scene}
         * @since 3.50.0
         */ this.scene = scene;
                    /**
         * Holds a reference to the Display List that contains this Game Object.
         *
         * This is set automatically when this Game Object is added to a Scene or Layer.
         *
         * You should treat this property as being read-only.
         *
         * @name Phaser.GameObjects.Layer#displayList
         * @type {(Phaser.GameObjects.DisplayList|Phaser.GameObjects.Layer)}
         * @default null
         * @since 3.50.0
         */ this.displayList = null;
                    /**
         * A textual representation of this Game Object, i.e. `sprite`.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.GameObjects.Layer#type
         * @type {string}
         * @since 3.50.0
         */ this.type = 'Layer';
                    /**
         * The current state of this Game Object.
         *
         * Phaser itself will never modify this value, although plugins may do so.
         *
         * Use this property to track the state of a Game Object during its lifetime. For example, it could change from
         * a state of 'moving', to 'attacking', to 'dead'. The state value should be an integer (ideally mapped to a constant
         * in your game code), or a string. These are recommended to keep it light and simple, with fast comparisons.
         * If you need to store complex data about your Game Object, look at using the Data Component instead.
         *
         * @name Phaser.GameObjects.Layer#state
         * @type {(number|string)}
         * @since 3.50.0
         */ this.state = 0;
                    /**
         * A Layer cannot be placed inside a Container.
         *
         * This property is kept purely so a Layer has the same
         * shape as a Game Object.
         *
         * @name Phaser.GameObjects.Layer#parentContainer
         * @type {Phaser.GameObjects.Container}
         * @since 3.51.0
         */ this.parentContainer = null;
                    /**
         * The name of this Game Object.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Layer#name
         * @type {string}
         * @default ''
         * @since 3.50.0
         */ this.name = '';
                    /**
         * The active state of this Game Object.
         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
         * An active object is one which is having its logic and internal systems updated.
         *
         * @name Phaser.GameObjects.Layer#active
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.active = true;
                    /**
         * The Tab Index of the Game Object.
         * Reserved for future use by plugins and the Input Manager.
         *
         * @name Phaser.GameObjects.Layer#tabIndex
         * @type {number}
         * @default -1
         * @since 3.51.0
         */ this.tabIndex = -1;
                    /**
         * A Data Manager.
         * It allows you to store, query and get key/value paired information specific to this Game Object.
         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
         *
         * @name Phaser.GameObjects.Layer#data
         * @type {Phaser.Data.DataManager}
         * @default null
         * @since 3.50.0
         */ this.data = null;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.Layer#renderFlags
         * @type {number}
         * @default 15
         * @since 3.50.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.Layer#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.cameraFilter = 0;
                    /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot input enable a Layer.
         *
         * @name Phaser.GameObjects.Layer#input
         * @type {?Phaser.Types.Input.InteractiveObject}
         * @default null
         * @since 3.51.0
         */ this.input = null;
                    /**
         * This property is kept purely so a Layer has the same
         * shape as a Game Object. You cannot give a Layer a physics body.
         *
         * @name Phaser.GameObjects.Layer#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|MatterJS.BodyType)}
         * @default null
         * @since 3.51.0
         */ this.body = null;
                    /**
         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
         * This includes calls that may come from a Group, Container or the Scene itself.
         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
         * responsible for managing references to and from this Game Object.
         *
         * @name Phaser.GameObjects.Layer#ignoreDestroy
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.ignoreDestroy = false;
                    /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.GameObjects.Layer#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.50.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Event Emitter.
         *
         * @name Phaser.GameObjects.Layer#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.Layer#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.sortChildrenFlag = false;
                    //  Set the List callbacks
                    this.addCallback = this.addChildCallback;
                    this.removeCallback = this.removeChildCallback;
                    this.initPipeline();
                    this.clearAlpha();
                    this.setBlendMode(BlendModes.SKIP_CHECK);
                    if (children) this.add(children);
                    //  Tell the Scene to re-sort the children
                    scene.sys.queueDepthSort();
                },
                /**
     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
     *
     * @method Phaser.GameObjects.Layer#setActive
     * @since 3.50.0
     *
     * @param {boolean} value - True if this Game Object should be set as active, false if not.
     *
     * @return {this} This GameObject.
     */ setActive: function(value) {
                    this.active = value;
                    return this;
                },
                /**
     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
     * The `name` property is not populated by Phaser and is presented for your own use.
     *
     * @method Phaser.GameObjects.Layer#setName
     * @since 3.50.0
     *
     * @param {string} value - The name to be given to this Game Object.
     *
     * @return {this} This GameObject.
     */ setName: function(value) {
                    this.name = value;
                    return this;
                },
                /**
     * Sets the current state of this Game Object.
     *
     * Phaser itself will never modify the State of a Game Object, although plugins may do so.
     *
     * For example, a Game Object could change from a state of 'moving', to 'attacking', to 'dead'.
     * The state value should typically be an integer (ideally mapped to a constant
     * in your game code), but could also be a string. It is recommended to keep it light and simple.
     * If you need to store complex data about your Game Object, look at using the Data Component instead.
     *
     * @method Phaser.GameObjects.Layer#setState
     * @since 3.50.0
     *
     * @param {(number|string)} value - The state of the Game Object.
     *
     * @return {this} This GameObject.
     */ setState: function(value) {
                    this.state = value;
                    return this;
                },
                /**
     * Adds a Data Manager component to this Game Object.
     *
     * @method Phaser.GameObjects.Layer#setDataEnabled
     * @since 3.50.0
     * @see Phaser.Data.DataManager
     *
     * @return {this} This GameObject.
     */ setDataEnabled: function() {
                    if (!this.data) this.data = new DataManager(this);
                    return this;
                },
                /**
     * Allows you to store a key value pair within this Game Objects Data Manager.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * ```javascript
     * sprite.setData('name', 'Red Gem Stone');
     * ```
     *
     * You can also pass in an object of key value pairs as the first argument:
     *
     * ```javascript
     * sprite.setData({ name: 'Red Gem Stone', level: 2, owner: 'Link', gold: 50 });
     * ```
     *
     * To get a value back again you can call `getData`:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or you can access the value directly via the `values` property, where it works like any other variable:
     *
     * ```javascript
     * sprite.data.values.gold += 50;
     * ```
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * If the key already exists, a `changedata` event is emitted instead, along an event named after the key.
     * For example, if you updated an existing key called `PlayerLives` then it would emit the event `changedata-PlayerLives`.
     * These events will be emitted regardless if you use this method to set the value, or the direct `values` setter.
     *
     * Please note that the data keys are case-sensitive and must be valid JavaScript Object property strings.
     * This means the keys `gold` and `Gold` are treated as two unique values within the Data Manager.
     *
     * @method Phaser.GameObjects.Layer#setData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to set the value for. Or an object of key value pairs. If an object the `data` argument is ignored.
     * @param {*} [data] - The value to set for the given key. If an object is provided as the key this argument is ignored.
     *
     * @return {this} This GameObject.
     */ setData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.set(key, value);
                    return this;
                },
                /**
     * Increase a value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is increased from 0.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#incData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to increase the value for.
     * @param {*} [data] - The value to increase for the given key.
     *
     * @return {this} This GameObject.
     */ incData: function(key, value) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.inc(key, value);
                    return this;
                },
                /**
     * Toggle a boolean value for the given key within this Game Objects Data Manager. If the key doesn't already exist in the Data Manager then it is toggled from false.
     *
     * If the Game Object has not been enabled for data (via `setDataEnabled`) then it will be enabled
     * before setting the value.
     *
     * If the key doesn't already exist in the Data Manager then it is created.
     *
     * When the value is first set, a `setdata` event is emitted from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#toggleData
     * @since 3.50.0
     *
     * @param {(string|object)} key - The key to toggle the value for.
     *
     * @return {this} This GameObject.
     */ toggleData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    this.data.toggle(key);
                    return this;
                },
                /**
     * Retrieves the value for the given key in this Game Objects Data Manager, or undefined if it doesn't exist.
     *
     * You can also access values via the `values` object. For example, if you had a key called `gold` you can do either:
     *
     * ```javascript
     * sprite.getData('gold');
     * ```
     *
     * Or access the value directly:
     *
     * ```javascript
     * sprite.data.values.gold;
     * ```
     *
     * You can also pass in an array of keys, in which case an array of values will be returned:
     *
     * ```javascript
     * sprite.getData([ 'gold', 'armor', 'health' ]);
     * ```
     *
     * This approach is useful for destructuring arrays in ES6.
     *
     * @method Phaser.GameObjects.Layer#getData
     * @since 3.50.0
     *
     * @param {(string|string[])} key - The key of the value to retrieve, or an array of keys.
     *
     * @return {*} The value belonging to the given key, or an array of values, the order of which will match the input array.
     */ getData: function(key) {
                    if (!this.data) this.data = new DataManager(this);
                    return this.data.get(key);
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#setInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ setInteractive: function() {
                    return this;
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#disableInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ disableInteractive: function() {
                    return this;
                },
                /**
     * A Layer cannot be enabled for input.
     *
     * This method does nothing and is kept to ensure
     * the Layer has the same shape as a Game Object.
     *
     * @method Phaser.GameObjects.Layer#removeInteractive
     * @since 3.51.0
     *
     * @return {this} This GameObject.
     */ removeInteractive: function() {
                    return this;
                },
                /**
     * This callback is invoked when this Game Object is added to a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to add themselves into the Update List.
     *
     * You can also listen for the `ADDED_TO_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#addedToScene
     * @since 3.50.0
     */ addedToScene: function() {},
                /**
     * This callback is invoked when this Game Object is removed from a Scene.
     *
     * Can be overriden by custom Game Objects, but be aware of some Game Objects that
     * will use this, such as Sprites, to removed themselves from the Update List.
     *
     * You can also listen for the `REMOVED_FROM_SCENE` event from this Game Object.
     *
     * @method Phaser.GameObjects.Layer#removedFromScene
     * @since 3.50.0
     */ removedFromScene: function() {},
                /**
     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
     *
     * @method Phaser.GameObjects.Layer#update
     * @since 3.50.0
     *
     * @param {...*} [args] - args
     */ update: function() {},
                /**
     * Returns a JSON representation of the Game Object.
     *
     * @method Phaser.GameObjects.Layer#toJSON
     * @since 3.50.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Game Object.
     */ toJSON: function() {
                    return ComponentsToJSON(this);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Layer#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(this.renderFlags !== 15 || this.list.length === 0 || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Returns an array containing the display list index of either this Game Object, or if it has one,
     * its parent Container. It then iterates up through all of the parent containers until it hits the
     * root of the display list (which is index 0 in the returned array).
     *
     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
     * this Game Object and all of its ancestors.
     *
     * @method Phaser.GameObjects.Layer#getIndexList
     * @since 3.51.0
     *
     * @return {number[]} An array of display list position indexes.
     */ getIndexList: function() {
                    // eslint-disable-next-line consistent-this
                    var child = this;
                    var parent = this.parentContainer;
                    var indexes = [];
                    while(parent){
                        indexes.unshift(parent.getIndex(child));
                        child = parent;
                        if (!parent.parentContainer) break;
                        else parent = parent.parentContainer;
                    }
                    indexes.unshift(this.displayList.getIndex(child));
                    return indexes;
                },
                /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.Layer#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                    gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                    if (gameObject.displayList) gameObject.displayList.remove(gameObject);
                    gameObject.displayList = this;
                    this.queueDepthSort();
                    this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                },
                /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.Layer#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                    gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    gameObject.displayList = null;
                    this.queueDepthSort();
                    this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                },
                /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.Layer#queueDepthSort
     * @since 3.50.0
     */ queueDepthSort: function() {
                    this.sortChildrenFlag = true;
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.Layer#depthSort
     * @since 3.50.0
     */ depthSort: function() {
                    if (this.sortChildrenFlag) {
                        StableSort(this.list, this.sortByDepth);
                        this.sortChildrenFlag = false;
                    }
                },
                /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.Layer#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                    return childA._depth - childB._depth;
                },
                /**
     * Returns an array which contains all Game Objects within this Layer.
     *
     * This is a reference to the main list array, not a copy of it, so be careful not to modify it.
     *
     * @method Phaser.GameObjects.Layer#getChildren
     * @since 3.50.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.list;
                },
                /**
     * Destroys this Layer removing it from the Display List and Update List and
     * severing all ties to parent resources.
     *
     * Also destroys all children of this Layer. If you do not wish for the
     * children to be destroyed, you should move them from this Layer first.
     *
     * Use this to remove this Layer from your game if you don't ever plan to use it again.
     * As long as no reference to it exists within your own code it should become free for
     * garbage collection by the browser.
     *
     * If you just want to temporarily disable an object then look at using the
     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
     *
     * @method Phaser.GameObjects.Layer#destroy
     * @fires Phaser.GameObjects.Events#DESTROY
     * @since 3.50.0
     */ destroy: function() {
                    //  This Game Object has already been destroyed
                    if (!this.scene || this.ignoreDestroy) return;
                    this.emit(GameObjectEvents.DESTROY, this);
                    var i = this.list.length;
                    while(i--)this.list[i].destroy();
                    this.removeAllListeners();
                    this.resetPostPipeline(true);
                    if (this.displayList) {
                        this.displayList.queueDepthSort();
                        this.displayList.remove(this);
                    }
                    if (this.data) {
                        this.data.destroy();
                        this.data = undefined;
                    }
                    this.active = false;
                    this.visible = false;
                    this.list = undefined;
                    this.scene = undefined;
                    this.displayList = undefined;
                    this.systems = undefined;
                    this.events = undefined;
                }
            });
            module1.exports = Layer;
        /***/ },
        /* 217 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GravityWell = __webpack_require__(444);
            var List = __webpack_require__(107);
            var ParticleEmitter = __webpack_require__(446);
            var Render = __webpack_require__(1069);
            /**
 * @classdesc
 * A Particle Emitter Manager creates and controls {@link Phaser.GameObjects.Particles.ParticleEmitter Particle Emitters} and {@link Phaser.GameObjects.Particles.GravityWell Gravity Wells}.
 *
 * @class ParticleEmitterManager
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Emitter Manager belongs.
 * @param {string} texture - The key of the Texture this Emitter Manager will use to render particles, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Emitter Manager will use to render particles.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterConfig[]} [emitters] - Configuration settings for one or more emitters to create.
 */ var ParticleEmitterManager = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: //  frame is optional and can contain the emitters array or object if skipped
                function ParticleEmitterManager(scene, texture, frame, emitters) {
                    GameObject.call(this, scene, 'ParticleEmitterManager');
                    /**
         * The blend mode applied to all emitters and particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#blendMode
         * @type {number}
         * @default -1
         * @private
         * @since 3.0.0
         */ this.blendMode = -1;
                    /**
         * The time scale applied to all emitters and particles, affecting flow rate, lifespan, and movement.
         * Values larger than 1 are faster than normal.
         * This is multiplied with any timeScale set on each individual emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * The texture used to render this Emitter Manager's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#texture
         * @type {Phaser.Textures.Texture}
         * @default null
         * @since 3.0.0
         */ this.texture = null;
                    /**
         * The texture frame used to render this Emitter Manager's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frame
         * @type {Phaser.Textures.Frame}
         * @default null
         * @since 3.0.0
         */ this.frame = null;
                    /**
         * Names of this Emitter Manager's texture frames.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frameNames
         * @type {string[]}
         * @since 3.0.0
         */ this.frameNames = [];
                    //  frame is optional and can contain the emitters array or object if skipped
                    if (frame !== null && (typeof frame === 'object' || Array.isArray(frame))) {
                        emitters = frame;
                        frame = null;
                    }
                    this.setTexture(texture, frame);
                    this.initPipeline();
                    /**
         * A list of Emitters being managed by this Emitter Manager.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#emitters
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.ParticleEmitter>}
         * @since 3.0.0
         */ this.emitters = new List(this);
                    /**
         * A list of Gravity Wells being managed by this Emitter Manager.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#wells
         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.GravityWell>}
         * @since 3.0.0
         */ this.wells = new List(this);
                    if (emitters) {
                        //  An array of emitter configs?
                        if (!Array.isArray(emitters)) emitters = [
                            emitters
                        ];
                        for(var i = 0; i < emitters.length; i++)this.createEmitter(emitters[i]);
                    }
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Sets the texture and frame this Emitter Manager will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Emitter Manager.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Emitter Manager will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Emitter Manager.
     */ setFrame: function(frame) {
                    this.frame = this.texture.get(frame);
                    var frames = this.texture.getFramesFromTextureSource(this.frame.sourceIndex);
                    var names = [];
                    frames.forEach(function(sourceFrame) {
                        names.push(sourceFrame.name);
                    });
                    this.frameNames = names;
                    this.defaultFrame = this.frame;
                    return this;
                },
                /**
     * Assigns texture frames to an emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setEmitterFrames
     * @since 3.0.0
     *
     * @param {(Phaser.Textures.Frame|Phaser.Textures.Frame[])} frames - The texture frames.
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The particle emitter to modify.
     *
     * @return {this} This Emitter Manager.
     */ setEmitterFrames: function(frames, emitter) {
                    if (!Array.isArray(frames)) frames = [
                        frames
                    ];
                    var out = emitter.frames;
                    out.length = 0;
                    for(var i = 0; i < frames.length; i++){
                        var frame = frames[i];
                        if (this.frameNames.indexOf(frame) !== -1) out.push(this.texture.get(frame));
                    }
                    if (out.length > 0) emitter.defaultFrame = out[0];
                    else emitter.defaultFrame = this.defaultFrame;
                    return this;
                },
                /**
     * Adds an existing Particle Emitter to this Emitter Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addEmitter
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Particle Emitter to add to this Emitter Manager.
     *
     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was added to this Emitter Manager.
     */ addEmitter: function(emitter) {
                    return this.emitters.add(emitter);
                },
                /**
     * Creates a new Particle Emitter object, adds it to this Emitter Manager and returns a reference to it.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createEmitter
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Configuration settings for the Particle Emitter to create.
     *
     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was created.
     */ createEmitter: function(config) {
                    return this.addEmitter(new ParticleEmitter(this, config));
                },
                /**
     * Removes a Particle Emitter from this Emitter Manager, if the Emitter belongs to this Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#removeEmitter
     * @since 3.22.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter
     *
     * @return {?Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter if it was removed or null if it was not.
     */ removeEmitter: function(emitter) {
                    return this.emitters.remove(emitter, true);
                },
                /**
     * Adds an existing Gravity Well object to this Emitter Manager.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addGravityWell
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.GravityWell} well - The Gravity Well to add to this Emitter Manager.
     *
     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was added to this Emitter Manager.
     */ addGravityWell: function(well) {
                    return this.wells.add(well);
                },
                /**
     * Creates a new Gravity Well, adds it to this Emitter Manager and returns a reference to it.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createGravityWell
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.GravityWellConfig} config - Configuration settings for the Gravity Well to create.
     *
     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was created.
     */ createGravityWell: function(config) {
                    return this.addGravityWell(new GravityWell(config));
                },
                /**
     * Emits particles from each active emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticle
     * @since 3.0.0
     *
     * @param {number} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     * @param {number} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
     * @param {number} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
     *
     * @return {this} This Emitter Manager.
     */ emitParticle: function(count, x, y) {
                    var emitters = this.emitters.list;
                    for(var i = 0; i < emitters.length; i++){
                        var emitter = emitters[i];
                        if (emitter.active) emitter.emitParticle(count, x, y);
                    }
                    return this;
                },
                /**
     * Emits particles from each active emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticleAt
     * @since 3.0.0
     *
     * @param {number} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
     * @param {number} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
     * @param {number} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     *
     * @return {this} This Emitter Manager.
     */ emitParticleAt: function(x, y, count) {
                    return this.emitParticle(count, x, y);
                },
                /**
     * Pauses this Emitter Manager.
     *
     * This has the effect of pausing all emitters, and all particles of those emitters, currently under its control.
     *
     * The particles will still render, but they will not have any of their logic updated.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#pause
     * @since 3.0.0
     *
     * @return {this} This Emitter Manager.
     */ pause: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Resumes this Emitter Manager, should it have been previously paused.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#resume
     * @since 3.0.0
     *
     * @return {this} This Emitter Manager.
     */ resume: function() {
                    this.active = true;
                    return this;
                },
                /**
     * Gets all active particle processors (gravity wells).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#getProcessors
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Particles.GravityWell[]} - The active gravity wells.
     */ getProcessors: function() {
                    return this.wells.getAll('active', true);
                },
                /**
     * Updates all active emitters.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    //  Scale the delta
                    delta *= this.timeScale;
                    var emitters = this.emitters.list;
                    for(var i = 0; i < emitters.length; i++){
                        var emitter = emitters[i];
                        if (emitter.active) emitter.preUpdate(time, delta);
                    }
                },
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setAlpha
     * @private
     * @since 3.10.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setScrollFactor
     * @private
     * @since 3.10.0
     */ setScrollFactor: function() {},
                /**
     * A NOOP method so you can pass an EmitterManager to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setBlendMode
     * @private
     * @since 3.15.0
     */ setBlendMode: function() {}
            });
            module1.exports = ParticleEmitterManager;
        /***/ },
        /* 218 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            var Camera = __webpack_require__(131);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var CONST = __webpack_require__(32);
            var Frame = __webpack_require__(106);
            var GameObject = __webpack_require__(15);
            var NOOP = __webpack_require__(1);
            var PIPELINE_CONST = __webpack_require__(65);
            var Render = __webpack_require__(1073);
            var RenderTarget = __webpack_require__(139);
            var Utils = __webpack_require__(12);
            var UUID = __webpack_require__(219);
            /**
 * @classdesc
 * A Render Texture.
 *
 * A Render Texture is a special texture that allows any number of Game Objects to be drawn to it. You can take many complex objects and
 * draw them all to this one texture, which can they be used as the texture for other Game Object's. It's a way to generate dynamic
 * textures at run-time that are WebGL friendly and don't invoke expensive GPU uploads.
 *
 * Note that under WebGL a FrameBuffer, which is what the Render Texture uses internally, cannot be anti-aliased. This means
 * that when drawing objects such as Shapes to a Render Texture they will appear to be drawn with no aliasing, however this
 * is a technical limitation of WebGL. To get around it, create your shape as a texture in an art package, then draw that
 * to the Render Texture.
 *
 * @class RenderTexture
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.2.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 * @property {string} [key] - The texture key to make the RenderTexture from.
 * @property {string} [frame] - the frame to make the RenderTexture from.
 */ var RenderTexture = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    Render
                ],
                initialize: function RenderTexture(scene, x, y, width, height, key, frame) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 32;
                    if (height === undefined) height = 32;
                    GameObject.call(this, scene, 'RenderTexture');
                    /**
         * A reference to either the Canvas or WebGL Renderer that the Game instance is using.
         *
         * @name Phaser.GameObjects.RenderTexture#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.2.0
         */ this.renderer = scene.sys.renderer;
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.GameObjects.RenderTexture#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.12.0
         */ this.textureManager = scene.sys.textures;
                    /**
         * The tint of the Render Texture when rendered.
         *
         * @name Phaser.GameObjects.RenderTexture#globalTint
         * @type {number}
         * @default 0xffffff
         * @since 3.2.0
         */ this.globalTint = 0xffffff;
                    /**
         * The alpha of the Render Texture when rendered.
         *
         * @name Phaser.GameObjects.RenderTexture#globalAlpha
         * @type {number}
         * @default 1
         * @since 3.2.0
         */ this.globalAlpha = 1;
                    /**
         * The HTML Canvas Element that the Render Texture is drawing to when using the Canvas Renderer.
         *
         * @name Phaser.GameObjects.RenderTexture#canvas
         * @type {HTMLCanvasElement}
         * @since 3.2.0
         */ this.canvas = null;
                    /**
         * Is this Render Texture dirty or not? If not it won't spend time clearing or filling itself.
         *
         * @name Phaser.GameObjects.RenderTexture#dirty
         * @type {boolean}
         * @since 3.12.0
         */ this.dirty = false;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.RenderTexture#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Texture corresponding to this Render Texture.
         *
         * @name Phaser.GameObjects.RenderTexture#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.12.0
         */ this.texture = null;
                    /**
         * The Frame corresponding to this Render Texture.
         *
         * @name Phaser.GameObjects.RenderTexture#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.12.0
         */ this.frame = null;
                    /**
         * Internal saved texture flag.
         *
         * @name Phaser.GameObjects.RenderTexture#_saved
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this._saved = false;
                    if (key === undefined) {
                        this.canvas = CanvasPool.create2D(this, width, height);
                        //  Create a new Texture for this RenderTexture object
                        this.texture = scene.sys.textures.addCanvas(UUID(), this.canvas);
                        //  Get the frame
                        this.frame = this.texture.get();
                    } else {
                        this.texture = scene.sys.textures.get(key);
                        //  Get the frame
                        this.frame = this.texture.get(frame);
                        this.canvas = this.frame.source.image;
                        this._saved = true;
                        this.dirty = true;
                        this.width = this.frame.cutWidth;
                        this.height = this.frame.cutHeight;
                    }
                    /**
         * A reference to the Rendering Context belonging to the Canvas Element this Render Texture is drawing to.
         *
         * @name Phaser.GameObjects.RenderTexture#context
         * @type {CanvasRenderingContext2D}
         * @since 3.2.0
         */ this.context = this.canvas.getContext('2d');
                    /**
         * Internal erase mode flag.
         *
         * @name Phaser.GameObjects.RenderTexture#_eraseMode
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._eraseMode = false;
                    /**
         * An internal Camera that can be used to move around the Render Texture.
         * Control it just like you would any Scene Camera. The difference is that it only impacts the placement of what
         * is drawn to the Render Texture. You can scroll, zoom and rotate this Camera.
         *
         * @name Phaser.GameObjects.RenderTexture#camera
         * @type {Phaser.Cameras.Scene2D.BaseCamera}
         * @since 3.12.0
         */ this.camera = new Camera(0, 0, width, height);
                    /**
         * The Render Target that belongs to this Render Texture.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * This property remains `null` under Canvas.
         *
         * @name Phaser.GameObjects.RenderTexture#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.renderTarget = null;
                    var renderer = this.renderer;
                    if (!renderer) this.drawGameObject = NOOP;
                    else if (renderer.type === CONST.WEBGL) {
                        this.drawGameObject = this.batchGameObjectWebGL;
                        this.renderTarget = new RenderTarget(renderer, width, height, 1, 0, false);
                    } else if (renderer.type === CONST.CANVAS) this.drawGameObject = this.batchGameObjectCanvas;
                    this.camera.setScene(scene);
                    this.setPosition(x, y);
                    if (key === undefined) this.setSize(width, height);
                    this.setOrigin(0, 0);
                    this.initPipeline(PIPELINE_CONST.SINGLE_PIPELINE);
                },
                /**
     * Sets the size of this Game Object.
     *
     * @method Phaser.GameObjects.RenderTexture#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    return this.resize(width, height);
                },
                /**
     * Resizes the Render Texture to the new dimensions given.
     *
     * If Render Texture was created from specific frame, only the size of the frame will be changed. The size of the source
     * texture will not change.
     *
     * If Render Texture was not created from specific frame, the following will happen:
     *
     * In WebGL it will destroy and then re-create the frame buffer being used by the Render Texture.
     * In Canvas it will resize the underlying canvas element.
     *
     * Both approaches will erase everything currently drawn to the Render Texture.
     *
     * If the dimensions given are the same as those already being used, calling this method will do nothing.
     *
     * @method Phaser.GameObjects.RenderTexture#resize
     * @since 3.10.0
     *
     * @param {number} width - The new width of the Render Texture.
     * @param {number} [height=width] - The new height of the Render Texture. If not specified, will be set the same as the `width`.
     *
     * @return {this} This Render Texture.
     */ resize: function(width, height) {
                    if (height === undefined) height = width;
                    var frame = this.frame;
                    if (width !== this.width || height !== this.height) {
                        if (frame.name === '__BASE') {
                            //  Resize the texture
                            this.canvas.width = width;
                            this.canvas.height = height;
                            this.texture.width = width;
                            this.texture.height = height;
                            var renderTarget = this.renderTarget;
                            if (renderTarget) {
                                renderTarget.resize(width, height);
                                frame.glTexture = renderTarget.texture;
                                frame.source.isRenderTexture = true;
                                frame.source.isGLTexture = true;
                                frame.source.glTexture = renderTarget.texture;
                            }
                            this.camera.setSize(width, height);
                            frame.source.width = width;
                            frame.source.height = height;
                            frame.setSize(width, height);
                            this.width = width;
                            this.height = height;
                        }
                    } else {
                        //  Resize the frame
                        var baseFrame = this.texture.getSourceImage();
                        if (frame.cutX + width > baseFrame.width) width = baseFrame.width - frame.cutX;
                        if (frame.cutY + height > baseFrame.height) height = baseFrame.height - frame.cutY;
                        frame.setSize(width, height, frame.cutX, frame.cutY);
                    }
                    this.updateDisplayOrigin();
                    var input = this.input;
                    if (input && !input.customHitArea) {
                        input.hitArea.width = width;
                        input.hitArea.height = height;
                    }
                    return this;
                },
                /**
     * Set the tint to use when rendering this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#setGlobalTint
     * @since 3.2.0
     *
     * @param {number} tint - The tint value.
     *
     * @return {this} This Render Texture.
     */ setGlobalTint: function(tint) {
                    this.globalTint = tint;
                    return this;
                },
                /**
     * Set the alpha to use when rendering this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#setGlobalAlpha
     * @since 3.2.0
     *
     * @param {number} alpha - The alpha value.
     *
     * @return {this} This Render Texture.
     */ setGlobalAlpha: function(alpha) {
                    this.globalAlpha = alpha;
                    return this;
                },
                /**
     * Stores a copy of this Render Texture in the Texture Manager using the given key.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of this
     * Render Texture by using the texture key:
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 128, 128);
     *
     * // Draw something to the Render Texture
     *
     * rt.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of this Render Texture will automatically update _any_ Game Object
     * that is using it as a texture. Calling `saveTexture` again will not save another copy
     * of the same texture, it will just rename the key of the existing copy.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * If you destroy this Render Texture, any Game Object using it via the Texture Manager will
     * stop rendering. Ensure you remove the texture from the Texture Manager and any Game Objects
     * using it first, before destroying this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#saveTexture
     * @since 3.12.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.Texture} The Texture that was saved.
     */ saveTexture: function(key) {
                    this.textureManager.renameTexture(this.texture.key, key);
                    this._saved = true;
                    return this.texture;
                },
                /**
     * Fills the Render Texture with the given color.
     *
     * @method Phaser.GameObjects.RenderTexture#fill
     * @since 3.2.0
     *
     * @param {number} rgb - The color to fill the Render Texture with.
     * @param {number} [alpha=1] - The alpha value used by the fill.
     * @param {number} [x=0] - The left coordinate of the fill rectangle.
     * @param {number} [y=0] - The top coordinate of the fill rectangle.
     * @param {number} [width=this.frame.cutWidth] - The width of the fill rectangle.
     * @param {number} [height=this.frame.cutHeight] - The height of the fill rectangle.
     *
     * @return {this} This Render Texture instance.
     */ fill: function(rgb, alpha, x, y, width, height) {
                    var frame = this.frame;
                    var camera = this.camera;
                    var renderer = this.renderer;
                    if (alpha === undefined) alpha = 1;
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = frame.cutWidth;
                    if (height === undefined) height = frame.cutHeight;
                    var r = (rgb >> 16 & 0xFF) / 255;
                    var g = (rgb >> 8 & 0xFF) / 255;
                    var b = (rgb & 0xFF) / 255;
                    var renderTarget = this.renderTarget;
                    camera.preRender();
                    if (renderTarget) {
                        renderTarget.bind(true);
                        var pipeline = this.pipeline;
                        pipeline.manager.set(pipeline);
                        var tw = renderTarget.width;
                        var th = renderTarget.height;
                        var rw = renderer.width;
                        var rh = renderer.height;
                        var sx = rw / tw;
                        var sy = rh / th;
                        pipeline.drawFillRect(x * sx, y * sy, width * sx, height * sy, Utils.getTintFromFloats(b, g, r, 1), alpha);
                        renderTarget.unbind(true);
                    } else {
                        var ctx = this.context;
                        renderer.setContext(ctx);
                        ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
                        ctx.fillRect(x + frame.cutX, y + frame.cutY, width, height);
                        renderer.setContext();
                    }
                    this.dirty = true;
                    return this;
                },
                /**
     * Clears the Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#clear
     * @since 3.2.0
     *
     * @return {this} This Render Texture instance.
     */ clear: function() {
                    if (this.dirty) {
                        var renderTarget = this.renderTarget;
                        if (renderTarget) renderTarget.clear();
                        else {
                            var ctx = this.context;
                            ctx.save();
                            ctx.setTransform(1, 0, 0, 1, 0, 0);
                            ctx.clearRect(this.frame.cutX, this.frame.cutY, this.frame.cutWidth, this.frame.cutHeight);
                            ctx.restore();
                        }
                        this.dirty = false;
                    }
                    return this;
                },
                /**
     * Draws the given object, or an array of objects, to this Render Texture using a blend mode of ERASE.
     * This has the effect of erasing any filled pixels in the objects from this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot erase a Render Texture from itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#erase
     * @since 3.16.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     *
     * @return {this} This Render Texture instance.
     */ erase: function(entries, x, y) {
                    this._eraseMode = true;
                    this.draw(entries, x, y, 1, 16777215);
                    this._eraseMode = false;
                    return this;
                },
                /**
     * Draws the given object, or an array of objects, to this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Render Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * Calling this method causes the WebGL batch to flush, so it can write the texture
     * data to the framebuffer being used internally. The batch is flushed at the end,
     * after the entries have been iterated. So if you've a bunch of objects to draw,
     * try and pass them in an array in one single call, rather than making lots of
     * separate calls.
     *
     * @method Phaser.GameObjects.RenderTexture#draw
     * @since 3.2.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha] -  The alpha value. Only used for Texture Frames and if not specified defaults to the `globalAlpha` property. Game Objects use their own current alpha value.
     * @param {number} [tint] -  WebGL only. The tint color value. Only used for Texture Frames and if not specified defaults to the `globalTint` property. Game Objects use their own current tint value.
     *
     * @return {this} This Render Texture instance.
     */ draw: function(entries, x, y, alpha, tint) {
                    this.beginDraw();
                    this.batchDraw(entries, x, y, alpha, tint);
                    this.endDraw();
                    return this;
                },
                /**
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * @method Phaser.GameObjects.RenderTexture#drawFrame
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - WebGL only. The tint color to use. If not specified it uses the `globalTint` property.
     *
     * @return {this} This Render Texture instance.
     */ drawFrame: function(key, frame, x, y, alpha, tint) {
                    this.beginDraw();
                    this.batchDrawFrame(key, frame, x, y, alpha, tint);
                    this.endDraw();
                    return this;
                },
                /**
     * Use this method if you need to batch draw a large number of Game Objects to
     * this Render Texture in a single go, or on a frequent basis.
     *
     * This method starts the beginning of a batched draw.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * @method Phaser.GameObjects.RenderTexture#beginDraw
     * @since 3.50.0
     *
     * @return {this} This Render Texture instance.
     */ beginDraw: function() {
                    var camera = this.camera;
                    var renderer = this.renderer;
                    var renderTarget = this.renderTarget;
                    camera.preRender();
                    if (renderTarget) renderer.beginCapture(renderTarget.width, renderTarget.height);
                    else renderer.setContext(this.context);
                    return this;
                },
                /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of objects to this Render Texture.
     *
     * This method batches the drawing of the given objects to this Render Texture,
     * without causing a bind or batch flush.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * Draws the given object, or an array of objects, to this Render Texture.
     *
     * It can accept any of the following:
     *
     * * Any renderable Game Object, such as a Sprite, Text, Graphics or TileSprite.
     * * Tilemap Layers.
     * * A Group. The contents of which will be iterated and drawn in turn.
     * * A Container. The contents of which will be iterated fully, and drawn in turn.
     * * A Scene's Display List. Pass in `Scene.children` to draw the whole list.
     * * Another Render Texture.
     * * A Texture Frame instance.
     * * A string. This is used to look-up a texture from the Texture Manager.
     *
     * Note: You cannot draw a Render Texture to itself.
     *
     * If passing in a Group or Container it will only draw children that return `true`
     * when their `willRender()` method is called. I.e. a Container with 10 children,
     * 5 of which have `visible=false` will only draw the 5 visible ones.
     *
     * If passing in an array of Game Objects it will draw them all, regardless if
     * they pass a `willRender` check or not.
     *
     * You can pass in a string in which case it will look for a texture in the Texture
     * Manager matching that string, and draw the base frame. If you need to specify
     * exactly which frame to draw then use the method `drawFrame` instead.
     *
     * You can pass in the `x` and `y` coordinates to draw the objects at. The use of
     * the coordinates differ based on what objects are being drawn. If the object is
     * a Group, Container or Display List, the coordinates are _added_ to the positions
     * of the children. For all other types of object, the coordinates are exact.
     *
     * The `alpha` and `tint` values are only used by Texture Frames.
     * Game Objects use their own alpha and tint values when being drawn.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDraw
     * @since 3.50.0
     *
     * @param {any} entries - Any renderable Game Object, or Group, Container, Display List, other Render Texture, Texture Frame or an array of any of these.
     * @param {number} [x] - The x position to draw the Frame at, or the offset applied to the object.
     * @param {number} [y] - The y position to draw the Frame at, or the offset applied to the object.
     * @param {number} [alpha] -  The alpha value. Only used for Texture Frames and if not specified defaults to the `globalAlpha` property. Game Objects use their own current alpha value.
     * @param {number} [tint] -  WebGL only. The tint color value. Only used for Texture Frames and if not specified defaults to the `globalTint` property. Game Objects use their own current tint value.
     *
     * @return {this} This Render Texture instance.
     */ batchDraw: function(entries, x, y, alpha, tint) {
                    if (alpha === undefined) alpha = this.globalAlpha;
                    if (tint === undefined) tint = (this.globalTint >> 16) + (this.globalTint & 0xff00) + ((this.globalTint & 0xff) << 16);
                    else tint = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16);
                    if (!Array.isArray(entries)) entries = [
                        entries
                    ];
                    this.batchList(entries, x, y, alpha, tint);
                    return this;
                },
                /**
     * Use this method if you have already called `beginDraw` and need to batch
     * draw a large number of texture frames to this Render Texture.
     *
     * This method batches the drawing of the given frames to this Render Texture,
     * without causing a bind or batch flush.
     *
     * It is faster than calling `drawFrame`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of frames it's much safer and easier to use the `drawFrame` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * Draws the Texture Frame to the Render Texture at the given position.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * ```javascript
     * var rt = this.add.renderTexture(0, 0, 800, 600);
     * rt.drawFrame(key, frame);
     * ```
     *
     * You can optionally provide a position, alpha and tint value to apply to the frame
     * before it is drawn.
     *
     * Calling this method will cause a batch flush, so if you've got a stack of things to draw
     * in a tight loop, try using the `draw` method instead.
     *
     * If you need to draw a Sprite to this Render Texture, use the `draw` method instead.
     *
     * @method Phaser.GameObjects.RenderTexture#batchDrawFrame
     * @since 3.50.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to draw the frame at.
     * @param {number} [y=0] - The y position to draw the frame at.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - WebGL only. The tint color to use. If not specified it uses the `globalTint` property.
     *
     * @return {this} This Render Texture instance.
     */ batchDrawFrame: function(key, frame, x, y, alpha, tint) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (alpha === undefined) alpha = this.globalAlpha;
                    if (tint === undefined) tint = (this.globalTint >> 16) + (this.globalTint & 0xff00) + ((this.globalTint & 0xff) << 16);
                    else tint = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16);
                    var textureFrame = this.textureManager.getFrame(key, frame);
                    if (textureFrame) {
                        if (this.renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, this.camera.matrix, null);
                        else this.batchTextureFrame(textureFrame, x + this.frame.cutX, y + this.frame.cutY, alpha, tint);
                    }
                    return this;
                },
                /**
     * Use this method to finish batch drawing to this Render Texture.
     *
     * Never call this method without first calling `beginDraw`.
     *
     * It is faster than calling `draw`, but you must be very careful to manage the
     * flow of code and remember to call `endDraw()`. If you don't need to draw large
     * numbers of objects it's much safer and easier to use the `draw` method instead.
     *
     * The flow should be:
     *
     * ```javascript
     * // Call once:
     * RenderTexture.beginDraw();
     *
     * // repeat n times:
     * RenderTexture.batchDraw();
     * // or
     * RenderTexture.batchDrawFrame();
     *
     * // Call once:
     * RenderTexture.endDraw();
     * ```
     *
     * Do not call any methods other than `batchDraw`, `batchDrawFrame`, or `endDraw` once you
     * have started a batch. Also, be very careful not to destroy this Render Texture while the
     * batch is still open, or call `beginDraw` again.
     *
     * @method Phaser.GameObjects.RenderTexture#endDraw
     * @since 3.50.0
     *
     * @return {this} This Render Texture instance.
     */ endDraw: function() {
                    var renderer = this.renderer;
                    var renderTarget = this.renderTarget;
                    if (renderTarget) {
                        var canvasTarget = renderer.endCapture();
                        var util = renderer.pipelines.setUtility();
                        util.blitFrame(canvasTarget, renderTarget, 1, false, false, this._eraseMode);
                        renderer.resetScissor();
                        renderer.resetViewport();
                    } else renderer.setContext();
                    this.dirty = true;
                    return this;
                },
                /**
     * Internal method that handles the drawing of an array of children.
     *
     * @method Phaser.GameObjects.RenderTexture#batchList
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects to draw.
     * @param {number} [x] - The x position to offset the Game Object by.
     * @param {number} [y] - The y position to offset the Game Object by.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - The tint color to use. If not specified it uses the `globalTint` property.
     */ batchList: function(children, x, y, alpha, tint) {
                    for(var i = 0; i < children.length; i++){
                        var entry = children[i];
                        if (!entry || entry === this) continue;
                        if (entry.renderWebGL || entry.renderCanvas) //  Game Objects
                        this.drawGameObject(entry, x, y);
                        else if (entry.isParent || entry.list) //  Groups / Display Lists
                        this.batchGroup(entry.getChildren(), x, y);
                        else if (typeof entry === 'string') //  Texture key
                        this.batchTextureFrameKey(entry, null, x, y, alpha, tint);
                        else if (entry instanceof Frame) //  Texture Frame instance
                        this.batchTextureFrame(entry, x, y, alpha, tint);
                        else if (Array.isArray(entry)) //  Another Array
                        this.batchList(entry, x, y, alpha, tint);
                    }
                },
                /**
     * Internal method that handles drawing a Phaser Group contents.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGroup
     * @private
     * @since 3.12.0
     *
     * @param {array} children - The array of Game Objects to draw.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     */ batchGroup: function(children, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    x += this.frame.cutX;
                    y += this.frame.cutY;
                    for(var i = 0; i < children.length; i++){
                        var entry = children[i];
                        if (entry.willRender(this.camera)) {
                            var tx = entry.x + x;
                            var ty = entry.y + y;
                            this.drawGameObject(entry, tx, ty);
                        }
                    }
                },
                /**
     * Internal method that handles drawing a single Phaser Game Object to this Render Texture using WebGL.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGameObjectWebGL
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to draw.
     * @param {number} [x] - The x position to draw the Game Object at.
     * @param {number} [y] - The y position to draw the Game Object at.
     */ batchGameObjectWebGL: function(gameObject, x, y) {
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    var prevX = gameObject.x;
                    var prevY = gameObject.y;
                    gameObject.setPosition(x + this.frame.cutX, y + this.frame.cutY);
                    if (gameObject.renderDirect) gameObject.renderDirect(this.renderer, gameObject, this.camera);
                    else gameObject.renderWebGL(this.renderer, gameObject, this.camera);
                    gameObject.setPosition(prevX, prevY);
                },
                /**
     * Internal method that handles drawing a single Phaser Game Object to this Render Texture using Canvas.
     *
     * @method Phaser.GameObjects.RenderTexture#batchGameObjectCanvas
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to draw.
     * @param {number} [x] - The x position to draw the Game Object at.
     * @param {number} [y] - The y position to draw the Game Object at.
     */ batchGameObjectCanvas: function(gameObject, x, y) {
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    var prevX = gameObject.x;
                    var prevY = gameObject.y;
                    if (this._eraseMode) {
                        var blendMode = gameObject.blendMode;
                        gameObject.blendMode = BlendModes.ERASE;
                    }
                    gameObject.setPosition(x + this.frame.cutX, y + this.frame.cutY);
                    gameObject.renderCanvas(this.renderer, gameObject, this.camera, null);
                    gameObject.setPosition(prevX, prevY);
                    if (this._eraseMode) gameObject.blendMode = blendMode;
                },
                /**
     * Internal method that handles the drawing of an array of children.
     *
     * @method Phaser.GameObjects.RenderTexture#batchTextureFrameKey
     * @private
     * @since 3.12.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     * @param {number} [x=0] - The x position to offset the Game Object by.
     * @param {number} [y=0] - The y position to offset the Game Object by.
     * @param {number} [alpha] - The alpha to use. If not specified it uses the `globalAlpha` property.
     * @param {number} [tint] - The tint color to use. If not specified it uses the `globalTint` property.
     */ batchTextureFrameKey: function(key, frame, x, y, alpha, tint) {
                    var textureFrame = this.textureManager.getFrame(key, frame);
                    if (textureFrame) this.batchTextureFrame(textureFrame, x, y, alpha, tint);
                },
                /**
     * Internal method that handles the drawing of a Texture Frame to this Render Texture.
     *
     * @method Phaser.GameObjects.RenderTexture#batchTextureFrame
     * @private
     * @since 3.12.0
     *
     * @param {Phaser.Textures.Frame} textureFrame - The Texture Frame to draw.
     * @param {number} [x=0] - The x position to draw the Frame at.
     * @param {number} [y=0] - The y position to draw the Frame at.
     * @param {number} [tint] - A tint color to be applied to the frame drawn to the Render Texture.
     */ batchTextureFrame: function(textureFrame, x, y, alpha, tint) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    x += this.frame.cutX;
                    y += this.frame.cutY;
                    var renderTarget = this.renderTarget;
                    if (renderTarget) this.pipeline.batchTextureFrame(textureFrame, x, y, tint, alpha, this.camera.matrix, null);
                    else {
                        var ctx = this.context;
                        var cd = textureFrame.canvasData;
                        var source = textureFrame.source.image;
                        var matrix = this.camera.matrix;
                        ctx.save();
                        ctx.globalCompositeOperation = this._eraseMode ? 'destination-out' : 'source-over';
                        ctx.globalAlpha = alpha;
                        matrix.setToContext(ctx);
                        ctx.drawImage(source, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                        ctx.restore();
                    }
                },
                /**
     * Takes a snapshot of the given area of this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture the whole Render Texture see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotArea
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, false, x, y, width, height, type, encoderOptions);
                    else this.renderer.snapshotCanvas(this.canvas, callback, false, x, y, width, height, type, encoderOptions);
                    return this;
                },
                /**
     * Takes a snapshot of the whole of this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture just a portion of the Render Texture see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshot
     * @since 3.19.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Render Texture instance.
     */ snapshot: function(callback, type, encoderOptions) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, false, 0, 0, this.width, this.height, type, encoderOptions);
                    else this.renderer.snapshotCanvas(this.canvas, callback, false, 0, 0, this.width, this.height, type, encoderOptions);
                    return this;
                },
                /**
     * Takes a snapshot of the given pixel from this Render Texture.
     *
     * The snapshot is taken immediately.
     *
     * To capture the whole Render Texture see the `snapshot` method. To capture a specific portion, see `snapshotArea`.
     *
     * Unlike the other two snapshot methods, this one will send your callback a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory, than the other snapshot methods.
     *
     * @method Phaser.GameObjects.RenderTexture#snapshotPixel
     * @since 3.19.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This Render Texture instance.
     */ snapshotPixel: function(x, y, callback) {
                    if (this.renderTarget) this.renderer.snapshotFramebuffer(this.renderTarget.framebuffer, this.width, this.height, callback, true, x, y);
                    else this.renderer.snapshotCanvas(this.canvas, callback, true, x, y);
                    return this;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.RenderTexture#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    if (!this._saved) {
                        CanvasPool.remove(this.canvas);
                        if (this.renderTarget) this.renderTarget.destroy();
                        this.texture.destroy();
                        this.camera.destroy();
                        this.canvas = null;
                        this.context = null;
                        this.texture = null;
                    }
                }
            });
            module1.exports = RenderTexture;
        /***/ },
        /* 219 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates and returns an RFC4122 version 4 compliant UUID.
 * 
 * The string is in the form: `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx` where each `x` is replaced with a random
 * hexadecimal digit from 0 to f, and `y` is replaced with a random hexadecimal digit from 8 to b.
 *
 * @function Phaser.Utils.String.UUID
 * @since 3.12.0
 *
 * @return {string} The UUID string.
 */ var UUID = function() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0;
                    var v = c === 'x' ? r : r & 0x3 | 0x8;
                    return v.toString(16);
                });
            };
            module1.exports = UUID;
        /***/ },
        /* 220 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(162);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var PIPELINE_CONST = __webpack_require__(65);
            var RopeRender = __webpack_require__(1079);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Rope Game Object.
 *
 * The Rope object is WebGL only and does not have a Canvas counterpart.
 *
 * A Rope is a special kind of Game Object that has a texture that repeats along its entire length.
 * Unlike a Sprite, it isn't restricted to using just a quad and can have as many vertices as you define
 * when creating it. The vertices can be arranged in a horizontal or vertical strip and have their own
 * color and alpha values as well.
 *
 * A Ropes origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Rope
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.23.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {string} [texture] - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager. If not given, `__DEFAULT` is used.
 * @param {(string|number|null)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created. See `setPoints` to set this post-creation.
 * @param {boolean} [horizontal=true] - Should the vertices of this Rope be aligned horizontally (`true`), or vertically (`false`)?
 * @param {number[]} [colors] - An optional array containing the color data for this Rope. You should provide one color value per pair of vertices.
 * @param {number[]} [alphas] - An optional array containing the alpha data for this Rope. You should provide one alpha value per pair of vertices.
 */ var Rope = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    RopeRender
                ],
                initialize: function Rope(scene, x, y, texture, frame, points, horizontal, colors, alphas) {
                    if (texture === undefined) texture = '__DEFAULT';
                    if (points === undefined) points = 2;
                    if (horizontal === undefined) horizontal = true;
                    GameObject.call(this, scene, 'Rope');
                    /**
         * The Animation State of this Rope.
         *
         * @name Phaser.GameObjects.Rope#anims
         * @type {Phaser.Animations.AnimationState}
         * @since 3.23.0
         */ this.anims = new AnimationState(this);
                    /**
         * An array containing the points data for this Rope.
         *
         * Each point should be given as a Vector2Like object (i.e. a Vector2, Geom.Point or object with public x/y properties).
         *
         * The point coordinates are given in local space, where 0 x 0 is the start of the Rope strip.
         *
         * You can modify the contents of this array directly in real-time to create interesting effects.
         * If you do so, be sure to call `setDirty` _after_ modifying this array, so that the vertices data is
         * updated before the next render. Alternatively, you can use the `setPoints` method instead.
         *
         * Should you need to change the _size_ of this array, then you should always use the `setPoints` method.
         *
         * @name Phaser.GameObjects.Rope#points
         * @type {Phaser.Types.Math.Vector2Like[]}
         * @since 3.23.0
         */ this.points = points;
                    /**
         * An array containing the vertices data for this Rope.
         *
         * This data is calculated automatically in the `updateVertices` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#vertices
         * @type {Float32Array}
         * @since 3.23.0
         */ this.vertices;
                    /**
         * An array containing the uv data for this Rope.
         *
         * This data is calculated automatically in the `setPoints` method, based on the points provided.
         *
         * @name Phaser.GameObjects.Rope#uv
         * @type {Float32Array}
         * @since 3.23.0
         */ this.uv;
                    /**
         * An array containing the color data for this Rope.
         *
         * Colors should be given as numeric RGB values, such as 0xff0000.
         * You should provide _two_ color values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setColors` method instead.
         *
         * @name Phaser.GameObjects.Rope#colors
         * @type {Uint32Array}
         * @since 3.23.0
         */ this.colors;
                    /**
         * An array containing the alpha data for this Rope.
         *
         * Alphas should be given as float values, such as 0.5.
         * You should provide _two_ alpha values for every point in the Rope, one for the top and one for the bottom of each quad.
         *
         * You can modify the contents of this array directly in real-time, however, should you need to change the _size_
         * of the array, then you should use the `setAlphas` method instead.
         *
         * @name Phaser.GameObjects.Rope#alphas
         * @type {Float32Array}
         * @since 3.23.0
         */ this.alphas;
                    /**
         * The tint fill mode.
         *
        * `false` = An additive tint (the default), where vertices colors are blended with the texture.
        * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Rope#tintFill
         * @type {boolean}
         * @since 3.23.0
         */ this.tintFill = texture === '__DEFAULT' ? true : false;
                    /**
         * If the Rope is marked as `dirty` it will automatically recalculate its vertices
         * the next time it renders. You can also force this by calling `updateVertices`.
         *
         * @name Phaser.GameObjects.Rope#dirty
         * @type {boolean}
         * @since 3.23.0
         */ this.dirty = false;
                    /**
         * Are the Rope vertices aligned horizontally, in a strip, or vertically, in a column?
         *
         * This property is set during instantiation and cannot be changed directly.
         * See the `setVertical` and `setHorizontal` methods.
         *
         * @name Phaser.GameObjects.Rope#horizontal
         * @type {boolean}
         * @readonly
         * @since 3.23.0
         */ this.horizontal = horizontal;
                    /**
         * The horizontally flipped state of the Game Object.
         *
         * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipX
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipX = false;
                    /**
         * The vertically flipped state of the Game Object.
         *
         * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture and does not impact the scale value.
         * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
         *
         * @name Phaser.GameObjects.Rope#_flipY
         * @type {boolean}
         * @default false
         * @private
         * @since 3.23.0
         */ this._flipY = false;
                    /**
         * Internal Vector2 used for vertices updates.
         *
         * @name Phaser.GameObjects.Rope#_perp
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.23.0
         */ this._perp = new Vector2();
                    /**
         * You can optionally choose to render the vertices of this Rope to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Rope.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Rope instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * @name Phaser.GameObjects.Rope#debugCallback
         * @type {function}
         * @since 3.23.0
         */ this.debugCallback = null;
                    /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Rope#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.23.0
         */ this.debugGraphic = null;
                    this.setTexture(texture, frame);
                    this.setPosition(x, y);
                    this.setSizeToFrame();
                    this.initPipeline(PIPELINE_CONST.ROPE_PIPELINE);
                    if (Array.isArray(points)) this.resizeArrays(points.length);
                    this.setPoints(points, colors, alphas);
                    this.updateVertices();
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * The Rope update loop.
     *
     * @method Phaser.GameObjects.Rope#preUpdate
     * @protected
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    var prevFrame = this.anims.currentFrame;
                    this.anims.update(time, delta);
                    if (this.anims.currentFrame !== prevFrame) {
                        this.updateUVs();
                        this.updateVertices();
                    }
                },
                /**
     * Start playing the given animation.
     *
     * @method Phaser.GameObjects.Rope#play
     * @since 3.23.0
     *
     * @param {string} key - The string-based key of the animation to play.
     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
     * @param {number} [startFrame=0] - Optionally start the animation playing from this frame index.
     *
     * @return {this} This Game Object.
     */ play: function(key, ignoreIfPlaying, startFrame) {
                    this.anims.play(key, ignoreIfPlaying, startFrame);
                    return this;
                },
                /**
     * Flags this Rope as being dirty. A dirty rope will recalculate all of its vertices data
     * the _next_ time it renders. You should set this rope as dirty if you update the points
     * array directly.
     *
     * @method Phaser.GameObjects.Rope#setDirty
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ setDirty: function() {
                    this.dirty = true;
                    return this;
                },
                /**
     * Sets the alignment of the points in this Rope to be horizontal, in a strip format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setHorizontal
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setHorizontal: function(points, colors, alphas) {
                    if (points === undefined) points = this.points.length;
                    if (this.horizontal) return this;
                    this.horizontal = true;
                    return this.setPoints(points, colors, alphas);
                },
                /**
     * Sets the alignment of the points in this Rope to be vertical, in a column format.
     *
     * Calling this method will reset this Rope. The current points, vertices, colors and alpha
     * values will be reset to thoes values given as parameters.
     *
     * @method Phaser.GameObjects.Rope#setVertical
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided the current points length is used.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setVertical: function(points, colors, alphas) {
                    if (points === undefined) points = this.points.length;
                    if (!this.horizontal) return this;
                    this.horizontal = false;
                    return this.setPoints(points, colors, alphas);
                },
                /**
     * Sets the tint fill mode.
     *
     * Mode 0 (`false`) is an additive tint, the default, which blends the vertices colors with the texture.
     * This mode respects the texture alpha.
     *
     * Mode 1 (`true`) is a fill tint. Unlike an additive tint, a fill-tint literally replaces the pixel colors
     * from the texture with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. This mode respects the texture alpha.
     *
     * See the `setColors` method for details of how to color each of the vertices.
     *
     * @method Phaser.GameObjects.Rope#setTintFill
     * @webglOnly
     * @since 3.23.0
     *
     * @param {boolean} [value=false] - Set to `false` for an Additive tint or `true` fill tint with alpha.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(value) {
                    if (value === undefined) value = false;
                    this.tintFill = value;
                    return this;
                },
                /**
     * Set the alpha values used by the Rope during rendering.
     *
     * You can provide the values in a number of ways:
     *
     * 1) One single numeric value: `setAlphas(0.5)` - This will set a single alpha for the whole Rope.
     * 2) Two numeric value: `setAlphas(1, 0.5)` - This will set a 'top' and 'bottom' alpha value across the whole Rope.
     * 3) An array of values: `setAlphas([ 1, 0.5, 0.2 ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each alpha value per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the alpha values at all
     * vertices in the Rope.
     *
     * Note this method is called `setAlphas` (plural) and not `setAlpha`.
     *
     * @method Phaser.GameObjects.Rope#setAlphas
     * @since 3.23.0
     *
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values. If nothing is provided alpha is reset to 1.
     * @param {number} [bottomAlpha] - An optional bottom alpha value. See the method description for details.
     *
     * @return {this} This Game Object instance.
     */ setAlphas: function(alphas, bottomAlpha) {
                    var total = this.points.length;
                    if (total < 1) return this;
                    var currentAlphas = this.alphas;
                    if (alphas === undefined) alphas = [
                        1
                    ];
                    else if (!Array.isArray(alphas) && bottomAlpha === undefined) alphas = [
                        alphas
                    ];
                    var i;
                    var index = 0;
                    if (bottomAlpha !== undefined) //  Top / Bottom alpha pair
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentAlphas[index] = alphas;
                        currentAlphas[index + 1] = bottomAlpha;
                    }
                    else if (alphas.length === total) //  If there are exactly the same number of alphas as points, we'll combine the alphas
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentAlphas[index] = alphas[i];
                        currentAlphas[index + 1] = alphas[i];
                    }
                    else {
                        var prevAlpha = alphas[0];
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            if (alphas.length > index) prevAlpha = alphas[index];
                            currentAlphas[index] = prevAlpha;
                            if (alphas.length > index + 1) prevAlpha = alphas[index + 1];
                            currentAlphas[index + 1] = prevAlpha;
                        }
                    }
                    return this;
                },
                /**
     * Set the color values used by the Rope during rendering.
     *
     * Colors are used to control the level of tint applied across the Rope texture.
     *
     * You can provide the values in a number of ways:
     *
     * * One single numeric value: `setColors(0xff0000)` - This will set a single color tint for the whole Rope.
     * * An array of values: `setColors([ 0xff0000, 0x00ff00, 0x0000ff ])`
     *
     * If you provide an array of values and the array has exactly the same number of values as `points` in the Rope, it
     * will use each color per rope segment.
     *
     * If the provided array has a different number of values than `points` then it will use the values in order, from
     * the first Rope segment and on, until it runs out of values. This allows you to control the color values at all
     * vertices in the Rope.
     *
     * @method Phaser.GameObjects.Rope#setColors
     * @since 3.23.0
     *
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values. If nothing is provided color is reset to 0xffffff.
     *
     * @return {this} This Game Object instance.
     */ setColors: function(colors) {
                    var total = this.points.length;
                    if (total < 1) return this;
                    var currentColors = this.colors;
                    if (colors === undefined) colors = [
                        0xffffff
                    ];
                    else if (!Array.isArray(colors)) colors = [
                        colors
                    ];
                    var i;
                    var index = 0;
                    if (colors.length === total) //  If there are exactly the same number of colors as points, we'll combine the colors
                    for(i = 0; i < total; i++){
                        index = i * 2;
                        currentColors[index] = colors[i];
                        currentColors[index + 1] = colors[i];
                    }
                    else {
                        var prevColor = colors[0];
                        for(i = 0; i < total; i++){
                            index = i * 2;
                            if (colors.length > index) prevColor = colors[index];
                            currentColors[index] = prevColor;
                            if (colors.length > index + 1) prevColor = colors[index + 1];
                            currentColors[index + 1] = prevColor;
                        }
                    }
                    return this;
                },
                /**
     * Sets the points used by this Rope.
     *
     * The points should be provided as an array of Vector2, or vector2-like objects (i.e. those with public x/y properties).
     *
     * Each point corresponds to one segment of the Rope. The more points in the array, the more segments the rope has.
     *
     * Point coordinates are given in local-space, not world-space, and are directly related to the size of the texture
     * this Rope object is using.
     *
     * For example, a Rope using a 512 px wide texture, split into 4 segments (128px each) would use the following points:
     *
     * ```javascript
     * rope.setPoints([
     *   { x: 0, y: 0 },
     *   { x: 128, y: 0 },
     *   { x: 256, y: 0 },
     *   { x: 384, y: 0 }
     * ]);
     * ```
     *
     * Or, you can provide an integer to do the same thing:
     *
     * ```javascript
     * rope.setPoints(4);
     * ```
     *
     * Which will divide the Rope into 4 equally sized segments based on the frame width.
     *
     * Note that calling this method with a different number of points than the Rope has currently will
     * _reset_ the color and alpha values, unless you provide them as arguments to this method.
     *
     * @method Phaser.GameObjects.Rope#setPoints
     * @since 3.23.0
     *
     * @param {(number|Phaser.Types.Math.Vector2Like[])} [points=2] - An array containing the vertices data for this Rope, or a number that indicates how many segments to split the texture frame into. If none is provided a simple quad is created.
     * @param {(number|number[])} [colors] - Either a single color value, or an array of values.
     * @param {(number|number[])} [alphas] - Either a single alpha value, or an array of values.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(points, colors, alphas) {
                    if (points === undefined) points = 2;
                    if (typeof points === 'number') {
                        //  Generate an array based on the points
                        var segments = points;
                        if (segments < 2) segments = 2;
                        points = [];
                        var s;
                        var frameSegment;
                        var offset;
                        if (this.horizontal) {
                            offset = -this.frame.halfWidth;
                            frameSegment = this.frame.width / (segments - 1);
                            for(s = 0; s < segments; s++)points.push({
                                x: offset + s * frameSegment,
                                y: 0
                            });
                        } else {
                            offset = -this.frame.halfHeight;
                            frameSegment = this.frame.height / (segments - 1);
                            for(s = 0; s < segments; s++)points.push({
                                x: 0,
                                y: offset + s * frameSegment
                            });
                        }
                    }
                    var total = points.length;
                    var currentTotal = this.points.length;
                    if (total < 1) {
                        console.warn('Rope: Not enough points given');
                        return this;
                    } else if (total === 1) {
                        points.unshift({
                            x: 0,
                            y: 0
                        });
                        total++;
                    }
                    if (currentTotal !== total) this.resizeArrays(total);
                    this.points = points;
                    this.updateUVs();
                    if (colors !== undefined && colors !== null) this.setColors(colors);
                    if (alphas !== undefined && alphas !== null) this.setAlphas(alphas);
                    return this;
                },
                /**
     * Updates all of the UVs based on the Rope.points and `flipX` and `flipY` settings.
     *
     * @method Phaser.GameObjects.Rope#updateUVs
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateUVs: function() {
                    var currentUVs = this.uv;
                    var total = this.points.length;
                    var u0 = this.frame.u0;
                    var v0 = this.frame.v0;
                    var u1 = this.frame.u1;
                    var v1 = this.frame.v1;
                    var partH = (u1 - u0) / (total - 1);
                    var partV = (v1 - v0) / (total - 1);
                    for(var i = 0; i < total; i++){
                        var index = i * 4;
                        var uv0;
                        var uv1;
                        var uv2;
                        var uv3;
                        if (this.horizontal) {
                            if (this._flipX) {
                                uv0 = u1 - i * partH;
                                uv2 = u1 - i * partH;
                            } else {
                                uv0 = u0 + i * partH;
                                uv2 = u0 + i * partH;
                            }
                            if (this._flipY) {
                                uv1 = v1;
                                uv3 = v0;
                            } else {
                                uv1 = v0;
                                uv3 = v1;
                            }
                        } else {
                            if (this._flipX) {
                                uv0 = u0;
                                uv2 = u1;
                            } else {
                                uv0 = u1;
                                uv2 = u0;
                            }
                            if (this._flipY) {
                                uv1 = v1 - i * partV;
                                uv3 = v1 - i * partV;
                            } else {
                                uv1 = v0 + i * partV;
                                uv3 = v0 + i * partV;
                            }
                        }
                        currentUVs[index + 0] = uv0;
                        currentUVs[index + 1] = uv1;
                        currentUVs[index + 2] = uv2;
                        currentUVs[index + 3] = uv3;
                    }
                    return this;
                },
                /**
     * Resizes all of the internal arrays: `vertices`, `uv`, `colors` and `alphas` to the new
     * given Rope segment total.
     *
     * @method Phaser.GameObjects.Rope#resizeArrays
     * @since 3.23.0
     *
     * @param {number} newSize - The amount of segments to split the Rope in to.
     *
     * @return {this} This Game Object instance.
     */ resizeArrays: function(newSize) {
                    var colors = this.colors;
                    var alphas = this.alphas;
                    this.vertices = new Float32Array(newSize * 4);
                    this.uv = new Float32Array(newSize * 4);
                    colors = new Uint32Array(newSize * 2);
                    alphas = new Float32Array(newSize * 2);
                    for(var i = 0; i < newSize * 2; i++){
                        colors[i] = 0xffffff;
                        alphas[i] = 1;
                    }
                    this.colors = colors;
                    this.alphas = alphas;
                    //  updateVertices during next render
                    this.dirty = true;
                    return this;
                },
                /**
     * Updates the vertices based on the Rope points.
     *
     * This method is called automatically during rendering if `Rope.dirty` is `true`, which is set
     * by the `setPoints` and `setDirty` methods. You should flag the Rope as being dirty if you modify
     * the Rope points directly.
     *
     * @method Phaser.GameObjects.Rope#updateVertices
     * @since 3.23.0
     *
     * @return {this} This Game Object instance.
     */ updateVertices: function() {
                    var perp = this._perp;
                    var points = this.points;
                    var vertices = this.vertices;
                    var total = points.length;
                    this.dirty = false;
                    if (total < 1) return;
                    var nextPoint;
                    var lastPoint = points[0];
                    var frameSize = this.horizontal ? this.frame.halfHeight : this.frame.halfWidth;
                    for(var i = 0; i < total; i++){
                        var point = points[i];
                        var index = i * 4;
                        if (i < total - 1) nextPoint = points[i + 1];
                        else nextPoint = point;
                        perp.x = nextPoint.y - lastPoint.y;
                        perp.y = -(nextPoint.x - lastPoint.x);
                        var perpLength = perp.length();
                        perp.x /= perpLength;
                        perp.y /= perpLength;
                        perp.x *= frameSize;
                        perp.y *= frameSize;
                        vertices[index] = point.x + perp.x;
                        vertices[index + 1] = point.y + perp.y;
                        vertices[index + 2] = point.x - perp.x;
                        vertices[index + 3] = point.y - perp.y;
                        lastPoint = point;
                    }
                    return this;
                },
                /**
     * This method enables rendering of the Rope vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Rope objects to a single Graphics instance.
     *
     * The Rope class has a built-in debug rendering callback `Rope.renderDebugVerts`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, meshLength, verts)`
     *
     * `src` is the Rope instance being debugged.
     * `meshLength` is the number of mesh vertices in total.
     * `verts` is an array of the translated vertex coordinates.
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Rope#setDebug
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                    this.debugGraphic = graphic;
                    if (!graphic && !callback) this.debugCallback = null;
                    else if (!callback) this.debugCallback = this.renderDebugVerts;
                    else this.debugCallback = callback;
                    return this;
                },
                /**
     * The built-in Rope vertices debug rendering method.
     *
     * See `Rope.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Rope#renderDebugVerts
     * @since 3.23.0
     *
     * @param {Phaser.GameObjects.Rope} src - The Rope object being rendered.
     * @param {number} meshLength - The number of vertices in the mesh.
     * @param {number[]} verts - An array of translated vertex coordinates.
     */ renderDebugVerts: function(src, meshLength, verts) {
                    var graphic = src.debugGraphic;
                    var px0 = verts[0];
                    var py0 = verts[1];
                    var px1 = verts[2];
                    var py1 = verts[3];
                    graphic.lineBetween(px0, py0, px1, py1);
                    for(var i = 4; i < meshLength; i += 4){
                        var x0 = verts[i + 0];
                        var y0 = verts[i + 1];
                        var x1 = verts[i + 2];
                        var y1 = verts[i + 3];
                        graphic.lineBetween(px0, py0, x0, y0);
                        graphic.lineBetween(px1, py1, x1, y1);
                        graphic.lineBetween(px1, py1, x0, y0);
                        graphic.lineBetween(x0, y0, x1, y1);
                        px0 = x0;
                        py0 = y0;
                        px1 = x1;
                        py1 = y1;
                    }
                },
                /**
     * Handles the pre-destroy step for the Rope, which removes the Animation component and typed arrays.
     *
     * @method Phaser.GameObjects.Rope#preDestroy
     * @private
     * @since 3.23.0
     */ preDestroy: function() {
                    this.anims.destroy();
                    this.anims = undefined;
                    this.points = null;
                    this.vertices = null;
                    this.uv = null;
                    this.colors = null;
                    this.alphas = null;
                    this.debugCallback = null;
                    this.debugGraphic = null;
                },
                /**
     * The horizontally flipped state of the Game Object.
     *
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipX
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipX: {
                    get: function() {
                        return this._flipX;
                    },
                    set: function(value) {
                        this._flipX = value;
                        return this.updateUVs();
                    }
                },
                /**
     * The vertically flipped state of the Game Object.
     *
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     *
     * @name Phaser.GameObjects.Rope#flipY
     * @type {boolean}
     * @default false
     * @since 3.23.0
     */ flipY: {
                    get: function() {
                        return this._flipY;
                    },
                    set: function(value) {
                        this._flipY = value;
                        return this.updateUVs();
                    }
                }
            });
            module1.exports = Rope;
        /***/ },
        /* 221 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(140);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameEvents = __webpack_require__(22);
            var GameObject = __webpack_require__(15);
            var GetTextSize = __webpack_require__(452);
            var GetValue = __webpack_require__(6);
            var RemoveFromDOM = __webpack_require__(199);
            var TextRender = __webpack_require__(1082);
            var TextStyle = __webpack_require__(453);
            /**
 * @classdesc
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * **Important:** The font name must be quoted if it contains certain combinations of digits or
 * special characters, either when creating the Text object, or when setting the font via `setFont`
 * or `setFontFamily`, e.g.:
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif' });
 * ```
 *
 * ```javascript
 * this.add.text(0, 0, 'Hello World', { font: '"Press Start 2P"' });
 * ```
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do ths for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * @class Text
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The text style configuration object.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
 */ var Text = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    TextRender
                ],
                initialize: function Text(scene, x, y, text, style) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    GameObject.call(this, scene, 'Text');
                    /**
         * The renderer in use by this Text object.
         *
         * @name Phaser.GameObjects.Text#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.12.0
         */ this.renderer = scene.sys.renderer;
                    this.setPosition(x, y);
                    this.setOrigin(0, 0);
                    this.initPipeline();
                    /**
         * The canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = CanvasPool.create(this);
                    /**
         * The context of the canvas element that the text is rendered to.
         *
         * @name Phaser.GameObjects.Text#context
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.context = this.canvas.getContext('2d');
                    /**
         * The Text Style object.
         *
         * Manages the style of this Text object.
         *
         * @name Phaser.GameObjects.Text#style
         * @type {Phaser.GameObjects.TextStyle}
         * @since 3.0.0
         */ this.style = new TextStyle(this, style);
                    /**
         * Whether to automatically round line positions.
         *
         * @name Phaser.GameObjects.Text#autoRound
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.autoRound = true;
                    /**
         * The Regular Expression that is used to split the text up into lines, in
         * multi-line text. By default this is `/(?:\r\n|\r|\n)/`.
         * You can change this RegExp to be anything else that you may need.
         *
         * @name Phaser.GameObjects.Text#splitRegExp
         * @type {object}
         * @since 3.0.0
         */ this.splitRegExp = /(?:\r\n|\r|\n)/;
                    /**
         * The text to display.
         *
         * @name Phaser.GameObjects.Text#_text
         * @type {string}
         * @private
         * @since 3.12.0
         */ this._text = undefined;
                    /**
         * Specify a padding value which is added to the line width and height when calculating the Text size.
         * Allows you to add extra spacing if the browser is unable to accurately determine the true font dimensions.
         *
         * @name Phaser.GameObjects.Text#padding
         * @type {Phaser.Types.GameObjects.Text.TextPadding}
         * @since 3.0.0
         */ this.padding = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    };
                    /**
         * The width of this Text object.
         *
         * @name Phaser.GameObjects.Text#width
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.width = 1;
                    /**
         * The height of this Text object.
         *
         * @name Phaser.GameObjects.Text#height
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.height = 1;
                    /**
         * The line spacing value.
         * This value is added to the font height to calculate the overall line height.
         * Only has an effect if this Text object contains multiple lines of text.
         *
         * If you update this property directly, instead of using the `setLineSpacing` method, then
         * be sure to call `updateText` after, or you won't see the change reflected in the Text object.
         *
         * @name Phaser.GameObjects.Text#lineSpacing
         * @type {number}
         * @since 3.13.0
         */ this.lineSpacing = 0;
                    /**
         * Whether the text or its settings have changed and need updating.
         *
         * @name Phaser.GameObjects.Text#dirty
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.dirty = false;
                    //  If resolution wasn't set, force it to 1
                    if (this.style.resolution === 0) this.style.resolution = 1;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Text#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    //  Create a Texture for this Text object
                    this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
                    //  Get the frame
                    this.frame = this.texture.get();
                    //  Set the resolution
                    this.frame.source.resolution = this.style.resolution;
                    if (this.renderer && this.renderer.gl) {
                        //  Clear the default 1x1 glTexture, as we override it later
                        this.renderer.deleteTexture(this.frame.source.glTexture);
                        this.frame.source.glTexture = null;
                    }
                    this.initRTL();
                    this.setText(text);
                    if (style && style.padding) this.setPadding(style.padding);
                    if (style && style.lineSpacing) this.setLineSpacing(style.lineSpacing);
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, function() {
                        this.dirty = true;
                    }, this);
                },
                /**
     * Initialize right to left text.
     *
     * @method Phaser.GameObjects.Text#initRTL
     * @since 3.0.0
     */ initRTL: function() {
                    if (!this.style.rtl) return;
                    //  Here is where the crazy starts.
                    //
                    //  Due to browser implementation issues, you cannot fillText BiDi text to a canvas
                    //  that is not part of the DOM. It just completely ignores the direction property.
                    this.canvas.dir = 'rtl';
                    //  Experimental atm, but one day ...
                    this.context.direction = 'rtl';
                    //  Add it to the DOM, but hidden within the parent canvas.
                    this.canvas.style.display = 'none';
                    AddToDOM(this.canvas, this.scene.sys.canvas);
                    //  And finally we set the x origin
                    this.originX = 1;
                },
                /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds.
     *
     * @method Phaser.GameObjects.Text#runWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     *
     * @return {string} The text after wrapping has been applied.
     */ runWordWrap: function(text) {
                    var style = this.style;
                    if (style.wordWrapCallback) {
                        var wrappedLines = style.wordWrapCallback.call(style.wordWrapCallbackScope, text, this);
                        if (Array.isArray(wrappedLines)) wrappedLines = wrappedLines.join('\n');
                        return wrappedLines;
                    } else if (style.wordWrapWidth) {
                        if (style.wordWrapUseAdvanced) return this.advancedWordWrap(text, this.context, this.style.wordWrapWidth);
                        else return this.basicWordWrap(text, this.context, this.style.wordWrapWidth);
                    } else return text;
                },
                /**
     * Advanced wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Consecutive spaces will be collapsed and replaced with a single space. Lines will be
     * trimmed of white space before processing. Throws an error if wordWrapWidth is less than a
     * single character.
     *
     * @method Phaser.GameObjects.Text#advancedWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ advancedWordWrap: function(text, context, wordWrapWidth) {
                    var output = '';
                    // Condense consecutive spaces and split into lines
                    var lines = text.replace(/ +/gi, ' ').split(this.splitRegExp);
                    var linesCount = lines.length;
                    for(var i = 0; i < linesCount; i++){
                        var line = lines[i];
                        var out = '';
                        // Trim whitespace
                        line = line.replace(/^ *|\s*$/gi, '');
                        // If entire line is less than wordWrapWidth append the entire line and exit early
                        var lineWidth = context.measureText(line).width;
                        if (lineWidth < wordWrapWidth) {
                            output += line + '\n';
                            continue;
                        }
                        // Otherwise, calculate new lines
                        var currentLineWidth = wordWrapWidth;
                        // Split into words
                        var words = line.split(' ');
                        for(var j = 0; j < words.length; j++){
                            var word = words[j];
                            var wordWithSpace = word + ' ';
                            var wordWidth = context.measureText(wordWithSpace).width;
                            if (wordWidth > currentLineWidth) {
                                // Break word
                                if (j === 0) {
                                    // Shave off letters from word until it's small enough
                                    var newWord = wordWithSpace;
                                    while(newWord.length){
                                        newWord = newWord.slice(0, -1);
                                        wordWidth = context.measureText(newWord).width;
                                        if (wordWidth <= currentLineWidth) break;
                                    }
                                    // If wordWrapWidth is too small for even a single letter, shame user
                                    // failure with a fatal error
                                    if (!newWord.length) throw new Error('This text\'s wordWrapWidth setting is less than a single character!');
                                    // Replace current word in array with remainder
                                    var secondPart = word.substr(newWord.length);
                                    words[j] = secondPart;
                                    // Append first piece to output
                                    out += newWord;
                                }
                                // If existing word length is 0, don't include it
                                var offset = words[j].length ? j : j + 1;
                                // Collapse rest of sentence and remove any trailing white space
                                var remainder = words.slice(offset).join(' ').replace(/[ \n]*$/gi, '');
                                // Prepend remainder to next line
                                lines[i + 1] = remainder + ' ' + (lines[i + 1] || '');
                                linesCount = lines.length;
                                break; // Processing on this line
                            // Append word with space to output
                            } else {
                                out += wordWithSpace;
                                currentLineWidth -= wordWidth;
                            }
                        }
                        // Append processed line to output
                        output += out.replace(/[ \n]*$/gi, '') + '\n';
                    }
                    // Trim the end of the string
                    output = output.replace(/[\s|\n]*$/gi, '');
                    return output;
                },
                /**
     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
     * bounds. Spaces are not collapsed and whitespace is not trimmed.
     *
     * @method Phaser.GameObjects.Text#basicWordWrap
     * @since 3.0.0
     *
     * @param {string} text - The text to perform word wrap detection against.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {number} wordWrapWidth - The word wrap width.
     *
     * @return {string} The wrapped text.
     */ basicWordWrap: function(text, context, wordWrapWidth) {
                    var result = '';
                    var lines = text.split(this.splitRegExp);
                    var lastLineIndex = lines.length - 1;
                    var whiteSpaceWidth = context.measureText(' ').width;
                    for(var i = 0; i <= lastLineIndex; i++){
                        var spaceLeft = wordWrapWidth;
                        var words = lines[i].split(' ');
                        var lastWordIndex = words.length - 1;
                        for(var j = 0; j <= lastWordIndex; j++){
                            var word = words[j];
                            var wordWidth = context.measureText(word).width;
                            var wordWidthWithSpace = wordWidth;
                            if (j < lastWordIndex) wordWidthWithSpace += whiteSpaceWidth;
                            if (wordWidthWithSpace > spaceLeft) // Skip printing the newline if it's the first word of the line that is greater
                            // than the word wrap width.
                            {
                                if (j > 0) {
                                    result += '\n';
                                    spaceLeft = wordWrapWidth;
                                }
                            }
                            result += word;
                            if (j < lastWordIndex) {
                                result += ' ';
                                spaceLeft -= wordWidthWithSpace;
                            } else spaceLeft -= wordWidth;
                        }
                        if (i < lastLineIndex) result += '\n';
                    }
                    return result;
                },
                /**
     * Runs the given text through this Text objects word wrapping and returns the results as an
     * array, where each element of the array corresponds to a wrapped line of text.
     *
     * @method Phaser.GameObjects.Text#getWrappedText
     * @since 3.0.0
     *
     * @param {string} text - The text for which the wrapping will be calculated. If unspecified, the Text objects current text will be used.
     *
     * @return {string[]} An array of strings with the pieces of wrapped text.
     */ getWrappedText: function(text) {
                    if (text === undefined) text = this._text;
                    this.style.syncFont(this.canvas, this.context);
                    var wrappedLines = this.runWordWrap(text);
                    return wrappedLines.split(this.splitRegExp);
                },
                /**
     * Set the text to display.
     *
     * An array of strings will be joined with `\n` line breaks.
     *
     * @method Phaser.GameObjects.Text#setText
     * @since 3.0.0
     *
     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this Text object.
     *
     * @return {this} This Text object.
     */ setText: function(value) {
                    if (!value && value !== 0) value = '';
                    if (Array.isArray(value)) value = value.join('\n');
                    if (value !== this._text) {
                        this._text = value.toString();
                        this.updateText();
                    }
                    return this;
                },
                /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.Text#setStyle
     * @since 3.0.0
     *
     * @param {object} style - The style settings to set.
     *
     * @return {this} This Text object.
     */ setStyle: function(style) {
                    return this.style.setStyle(style);
                },
                /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFont
     * @since 3.0.0
     *
     * @param {string} font - The font family or font settings to set.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFont: function(font) {
                    return this.style.setFont(font);
                },
                /**
     * Set the font family.
     *
     * **Important:** The font name must be quoted if it contains certain combinations of digits or
     * special characters:
     *
     * ```javascript
     * Text.setFont('"Press Start 2P"');
     * ```
     *
     * Equally, if you wish to provide a list of fallback fonts, then you should ensure they are all
     * quoted properly, too:
     *
     * ```javascript
     * Text.setFont('Georgia, "Goudy Bookletter 1911", Times, serif');
     * ```
     *
     * @method Phaser.GameObjects.Text#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {this} This Text object.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#Valid_family_names
     */ setFontFamily: function(family) {
                    return this.style.setFontFamily(family);
                },
                /**
     * Set the font size.
     *
     * @method Phaser.GameObjects.Text#setFontSize
     * @since 3.0.0
     *
     * @param {number} size - The font size.
     *
     * @return {this} This Text object.
     */ setFontSize: function(size) {
                    return this.style.setFontSize(size);
                },
                /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.Text#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {this} This Text object.
     */ setFontStyle: function(style) {
                    return this.style.setFontStyle(style);
                },
                /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.Text#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set. `0` disables fixed width.
     * @param {number} height - The fixed height to set. `0` disables fixed height.
     *
     * @return {this} This Text object.
     */ setFixedSize: function(width, height) {
                    return this.style.setFixedSize(width, height);
                },
                /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.Text#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {this} This Text object.
     */ setBackgroundColor: function(color) {
                    return this.style.setBackgroundColor(color);
                },
                /**
     * Set the fill style to be used by the Text object.
     *
     * This can be any valid CanvasRenderingContext2D fillStyle value, such as
     * a color (in hex, rgb, rgba, hsl or named values), a gradient or a pattern.
     *
     * See the [MDN fillStyle docs](https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle) for more details.
     *
     * @method Phaser.GameObjects.Text#setFill
     * @since 3.0.0
     *
     * @param {(string|any)} color - The text fill style. Can be any valid CanvasRenderingContext `fillStyle` value.
     *
     * @return {this} This Text object.
     */ setFill: function(fillStyle) {
                    return this.style.setFill(fillStyle);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.Text#setColor
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {this} This Text object.
     */ setColor: function(color) {
                    return this.style.setColor(color);
                },
                /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.Text#setStroke
     * @since 3.0.0
     *
     * @param {string} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {this} This Text object.
     */ setStroke: function(color, thickness) {
                    return this.style.setStroke(color, thickness);
                },
                /**
     * Set the shadow settings.
     *
     * @method Phaser.GameObjects.Text#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {this} This Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                    return this.style.setShadow(x, y, color, blur, shadowStroke, shadowFill);
                },
                /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.Text#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal shadow offset.
     * @param {number} y - The vertical shadow offset.
     *
     * @return {this} This Text object.
     */ setShadowOffset: function(x, y) {
                    return this.style.setShadowOffset(x, y);
                },
                /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.Text#setShadowColor
     * @since 3.0.0
     *
     * @param {string} color - The shadow color.
     *
     * @return {this} This Text object.
     */ setShadowColor: function(color) {
                    return this.style.setShadowColor(color);
                },
                /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.Text#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} blur - The shadow blur radius.
     *
     * @return {this} This Text object.
     */ setShadowBlur: function(blur) {
                    return this.style.setShadowBlur(blur);
                },
                /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.Text#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowStroke: function(enabled) {
                    return this.style.setShadowStroke(enabled);
                },
                /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.Text#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {this} This Text object.
     */ setShadowFill: function(enabled) {
                    return this.style.setShadowFill(enabled);
                },
                /**
     * Set the width (in pixels) to use for wrapping lines. Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.Text#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {?number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {this} This Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                    return this.style.setWordWrapWidth(width, useAdvancedWrap);
                },
                /**
     * Set a custom callback for wrapping lines. Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.Text#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {this} This Text object.
     */ setWordWrapCallback: function(callback, scope) {
                    return this.style.setWordWrapCallback(callback, scope);
                },
                /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.Text#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {this} This Text object.
     */ setAlign: function(align) {
                    return this.style.setAlign(align);
                },
                /**
     * Set the resolution used by this Text object.
     *
     * By default it will be set to match the resolution set in the Game Config,
     * but you can override it via this method, or by specifying it in the Text style configuration object.
     *
     * It allows for much clearer text on High DPI devices, at the cost of memory because it uses larger
     * internal Canvas textures for the Text.
     *
     * Therefore, please use with caution, as the more high res Text you have, the more memory it uses.
     *
     * @method Phaser.GameObjects.Text#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {this} This Text object.
     */ setResolution: function(value) {
                    return this.style.setResolution(value);
                },
                /**
     * Sets the line spacing value.
     *
     * This value is _added_ to the height of the font when calculating the overall line height.
     * This only has an effect if this Text object consists of multiple lines of text.
     *
     * @method Phaser.GameObjects.Text#setLineSpacing
     * @since 3.13.0
     *
     * @param {number} value - The amount to add to the font height to achieve the overall line height.
     *
     * @return {this} This Text object.
     */ setLineSpacing: function(value) {
                    this.lineSpacing = value;
                    return this.updateText();
                },
                /**
     * Set the text padding.
     *
     * 'left' can be an object.
     *
     * If only 'left' and 'top' are given they are treated as 'x' and 'y'.
     *
     * @method Phaser.GameObjects.Text#setPadding
     * @since 3.0.0
     *
     * @param {(number|Phaser.Types.GameObjects.Text.TextPadding)} left - The left padding value, or a padding config object.
     * @param {number} [top] - The top padding value.
     * @param {number} [right] - The right padding value.
     * @param {number} [bottom] - The bottom padding value.
     *
     * @return {this} This Text object.
     */ setPadding: function(left, top, right, bottom) {
                    if (typeof left === 'object') {
                        var config = left;
                        //  If they specify x and/or y this applies to all
                        var x = GetValue(config, 'x', null);
                        if (x !== null) {
                            left = x;
                            right = x;
                        } else {
                            left = GetValue(config, 'left', 0);
                            right = GetValue(config, 'right', left);
                        }
                        var y = GetValue(config, 'y', null);
                        if (y !== null) {
                            top = y;
                            bottom = y;
                        } else {
                            top = GetValue(config, 'top', 0);
                            bottom = GetValue(config, 'bottom', top);
                        }
                    } else {
                        if (left === undefined) left = 0;
                        if (top === undefined) top = left;
                        if (right === undefined) right = left;
                        if (bottom === undefined) bottom = top;
                    }
                    this.padding.left = left;
                    this.padding.top = top;
                    this.padding.right = right;
                    this.padding.bottom = bottom;
                    return this.updateText();
                },
                /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.Text#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {this} This Text object.
     */ setMaxLines: function(max) {
                    return this.style.setMaxLines(max);
                },
                /**
     * Update the displayed text.
     *
     * @method Phaser.GameObjects.Text#updateText
     * @since 3.0.0
     *
     * @return {this} This Text object.
     */ updateText: function() {
                    var canvas = this.canvas;
                    var context = this.context;
                    var style = this.style;
                    var resolution = style.resolution;
                    var size = style.metrics;
                    style.syncFont(canvas, context);
                    var outputText = this._text;
                    if (style.wordWrapWidth || style.wordWrapCallback) outputText = this.runWordWrap(this._text);
                    //  Split text into lines
                    var lines = outputText.split(this.splitRegExp);
                    var textSize = GetTextSize(this, size, lines);
                    var padding = this.padding;
                    var textWidth;
                    if (style.fixedWidth === 0) {
                        this.width = textSize.width + padding.left + padding.right;
                        textWidth = textSize.width;
                    } else {
                        this.width = style.fixedWidth;
                        textWidth = this.width - padding.left - padding.right;
                        if (textWidth < textSize.width) textWidth = textSize.width;
                    }
                    if (style.fixedHeight === 0) this.height = textSize.height + padding.top + padding.bottom;
                    else this.height = style.fixedHeight;
                    var w = this.width;
                    var h = this.height;
                    this.updateDisplayOrigin();
                    w *= resolution;
                    h *= resolution;
                    w = Math.max(w, 1);
                    h = Math.max(h, 1);
                    if (canvas.width !== w || canvas.height !== h) {
                        canvas.width = w;
                        canvas.height = h;
                        this.frame.setSize(w, h);
                        //  Because resizing the canvas resets the context
                        style.syncFont(canvas, context);
                    } else context.clearRect(0, 0, w, h);
                    context.save();
                    context.scale(resolution, resolution);
                    if (style.backgroundColor) {
                        context.fillStyle = style.backgroundColor;
                        context.fillRect(0, 0, w, h);
                    }
                    style.syncStyle(canvas, context);
                    context.textBaseline = 'alphabetic';
                    //  Apply padding
                    context.translate(padding.left, padding.top);
                    var linePositionX;
                    var linePositionY;
                    //  Draw text line by line
                    for(var i = 0; i < textSize.lines; i++){
                        linePositionX = style.strokeThickness / 2;
                        linePositionY = style.strokeThickness / 2 + i * textSize.lineHeight + size.ascent;
                        if (i > 0) linePositionY += textSize.lineSpacing * i;
                        if (style.rtl) linePositionX = w - linePositionX;
                        else if (style.align === 'right') linePositionX += textWidth - textSize.lineWidths[i];
                        else if (style.align === 'center') linePositionX += (textWidth - textSize.lineWidths[i]) / 2;
                        else if (style.align === 'justify') {
                            //  To justify text line its width must be no less than 85% of defined width
                            var minimumLengthToApplyJustification = 0.85;
                            if (textSize.lineWidths[i] / textSize.width >= minimumLengthToApplyJustification) {
                                var extraSpace = textSize.width - textSize.lineWidths[i];
                                var spaceSize = context.measureText(' ').width;
                                var trimmedLine = lines[i].trim();
                                var array = trimmedLine.split(' ');
                                extraSpace += (lines[i].length - trimmedLine.length) * spaceSize;
                                var extraSpaceCharacters = Math.floor(extraSpace / spaceSize);
                                var idx = 0;
                                while(extraSpaceCharacters > 0){
                                    array[idx] += ' ';
                                    idx = (idx + 1) % (array.length - 1 || 1);
                                    --extraSpaceCharacters;
                                }
                                lines[i] = array.join(' ');
                            }
                        }
                        if (this.autoRound) {
                            linePositionX = Math.round(linePositionX);
                            linePositionY = Math.round(linePositionY);
                        }
                        if (style.strokeThickness) {
                            this.style.syncShadow(context, style.shadowStroke);
                            context.strokeText(lines[i], linePositionX, linePositionY);
                        }
                        if (style.color) {
                            this.style.syncShadow(context, style.shadowFill);
                            context.fillText(lines[i], linePositionX, linePositionY);
                        }
                    }
                    context.restore();
                    if (this.renderer && this.renderer.gl) {
                        this.frame.source.glTexture = this.renderer.canvasToTexture(canvas, this.frame.source.glTexture, true);
                        this.frame.glTexture = this.frame.source.glTexture;
                    }
                    this.dirty = true;
                    var input = this.input;
                    if (input && !input.customHitArea) {
                        input.hitArea.width = this.width;
                        input.hitArea.height = this.height;
                    }
                    return this;
                },
                /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.Text#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                    return this.style.getTextMetrics();
                },
                /**
     * The text string being rendered by this Text Game Object.
     *
     * @name Phaser.GameObjects.Text#text
     * @type {string}
     * @since 3.0.0
     */ text: {
                    get: function() {
                        return this._text;
                    },
                    set: function(value) {
                        this.setText(value);
                    }
                },
                /**
     * Build a JSON representation of the Text object.
     *
     * @method Phaser.GameObjects.Text#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.JSONGameObject} A JSON representation of the Text object.
     */ toJSON: function() {
                    var out = Components.ToJSON(this);
                    //  Extra Text data is added here
                    var data = {
                        autoRound: this.autoRound,
                        text: this._text,
                        style: this.style.toJSON(),
                        padding: {
                            left: this.padding.left,
                            right: this.padding.right,
                            top: this.padding.top,
                            bottom: this.padding.bottom
                        }
                    };
                    out.data = data;
                    return out;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Text#preDestroy
     * @protected
     * @since 3.0.0
     */ preDestroy: function() {
                    if (this.style.rtl) RemoveFromDOM(this.canvas);
                    CanvasPool.remove(this.canvas);
                    this.texture.destroy();
                }
            });
            module1.exports = Text;
        /***/ },
        /* 222 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameEvents = __webpack_require__(22);
            var GameObject = __webpack_require__(15);
            var GetPowerOfTwo = __webpack_require__(355);
            var Smoothing = __webpack_require__(189);
            var TileSpriteRender = __webpack_require__(1085);
            var Vector2 = __webpack_require__(3);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * @classdesc
 * A TileSprite is a Sprite that has a repeating texture.
 *
 * The texture can be scrolled and scaled independently of the TileSprite itself. Textures will automatically wrap and
 * are designed so that you can create game backdrops using seamless textures as a source.
 *
 * You shouldn't ever create a TileSprite any larger than your actual canvas size. If you want to create a large repeating background
 * that scrolls across the whole map of your game, then you create a TileSprite that fits the canvas size and then use the `tilePosition`
 * property to scroll the texture as the player moves. If you create a TileSprite that is thousands of pixels in size then it will
 * consume huge amounts of memory and cause performance issues. Remember: use `tilePosition` to scroll your texture and `tileScale` to
 * adjust the scale of the texture - don't resize the sprite itself or make it larger than it needs.
 *
 * An important note about Tile Sprites and NPOT textures: Internally, TileSprite textures use GL_REPEAT to provide
 * seamless repeating of the textures. This, combined with the way in which the textures are handled in WebGL, means
 * they need to be POT (power-of-two) sizes in order to wrap. If you provide a NPOT (non power-of-two) texture to a
 * TileSprite it will generate a POT sized canvas and draw your texture to it, scaled up to the POT size. It's then
 * scaled back down again during rendering to the original dimensions. While this works, in that it allows you to use
 * any size texture for a Tile Sprite, it does mean that NPOT textures are going to appear anti-aliased when rendered,
 * due to the interpolation that took place when it was resized into a POT texture. This is especially visible in
 * pixel art graphics. If you notice it and it becomes an issue, the only way to avoid it is to ensure that you
 * provide POT textures for Tile Sprites.
 *
 * @class TileSprite
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Crop
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {string} textureKey - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frameKey] - An optional frame from the Texture this Game Object is rendering with.
 */ var TileSprite = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Crop,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    TileSpriteRender
                ],
                initialize: function TileSprite(scene, x, y, width, height, textureKey, frameKey) {
                    var renderer = scene.sys.renderer;
                    GameObject.call(this, scene, 'TileSprite');
                    var displayTexture = scene.sys.textures.get(textureKey);
                    var displayFrame = displayTexture.get(frameKey);
                    if (!width || !height) {
                        width = displayFrame.width;
                        height = displayFrame.height;
                    } else {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    /**
         * Internal tile position vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tilePosition
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tilePosition = new Vector2();
                    /**
         * Internal tile scale vector.
         *
         * @name Phaser.GameObjects.TileSprite#_tileScale
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.12.0
         */ this._tileScale = new Vector2(1, 1);
                    /**
         * Whether the Tile Sprite has changed in some way, requiring an re-render of its tile texture.
         *
         * Such changes include the texture frame and scroll position of the Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#dirty
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.dirty = false;
                    /**
         * The renderer in use by this Tile Sprite.
         *
         * @name Phaser.GameObjects.TileSprite#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = renderer;
                    /**
         * The Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#canvas
         * @type {?HTMLCanvasElement}
         * @since 3.12.0
         */ this.canvas = CanvasPool.create(this, width, height);
                    /**
         * The Context of the Canvas element that the TileSprite renders its fill pattern in to.
         * Only used in Canvas mode.
         *
         * @name Phaser.GameObjects.TileSprite#context
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.context = this.canvas.getContext('2d');
                    /**
         * The Texture the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayTexture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @private
         * @since 3.12.0
         */ this.displayTexture = displayTexture;
                    /**
         * The Frame the TileSprite is using as its fill pattern.
         *
         * @name Phaser.GameObjects.TileSprite#displayFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.12.0
         */ this.displayFrame = displayFrame;
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.TileSprite#_crop
         * @type {object}
         * @private
         * @since 3.12.0
         */ this._crop = this.resetCropObject();
                    /**
         * The Texture this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#texture
         * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
         * @since 3.0.0
         */ this.texture = scene.sys.textures.addCanvas(null, this.canvas, true);
                    /**
         * The Texture Frame this Game Object is using to render with.
         *
         * @name Phaser.GameObjects.TileSprite#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = this.texture.get();
                    /**
         * The next power of two value from the width of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potWidth
         * @type {number}
         * @since 3.0.0
         */ this.potWidth = GetPowerOfTwo(displayFrame.width);
                    /**
         * The next power of two value from the height of the Fill Pattern frame.
         *
         * @name Phaser.GameObjects.TileSprite#potHeight
         * @type {number}
         * @since 3.0.0
         */ this.potHeight = GetPowerOfTwo(displayFrame.height);
                    /**
         * The Canvas that the TileSprites texture is rendered to.
         * This is used to create a WebGL texture from.
         *
         * @name Phaser.GameObjects.TileSprite#fillCanvas
         * @type {HTMLCanvasElement}
         * @since 3.12.0
         */ this.fillCanvas = CanvasPool.create2D(this, this.potWidth, this.potHeight);
                    /**
         * The Canvas Context used to render the TileSprites texture.
         *
         * @name Phaser.GameObjects.TileSprite#fillContext
         * @type {CanvasRenderingContext2D}
         * @since 3.12.0
         */ this.fillContext = this.fillCanvas.getContext('2d');
                    /**
         * The texture that the Tile Sprite is rendered to, which is then rendered to a Scene.
         * In WebGL this is a WebGLTexture. In Canvas it's a Canvas Fill Pattern.
         *
         * @name Phaser.GameObjects.TileSprite#fillPattern
         * @type {?(WebGLTexture|CanvasPattern)}
         * @since 3.12.0
         */ this.fillPattern = null;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setFrame(frameKey);
                    this.setOriginFromFrame();
                    this.initPipeline();
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, function(renderer) {
                        var gl = renderer.gl;
                        this.dirty = true;
                        this.fillPattern = null;
                        this.fillPattern = renderer.createTexture2D(0, gl.LINEAR, gl.LINEAR, gl.REPEAT, gl.REPEAT, gl.RGBA, this.fillCanvas, this.potWidth, this.potHeight);
                    }, this);
                },
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.TileSprite#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.displayTexture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * @method Phaser.GameObjects.TileSprite#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame) {
                    var newFrame = this.displayTexture.get(frame);
                    this.potWidth = GetPowerOfTwo(newFrame.width);
                    this.potHeight = GetPowerOfTwo(newFrame.height);
                    //  So updateCanvas is triggered
                    this.canvas.width = 0;
                    if (!newFrame.cutWidth || !newFrame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    this.displayFrame = newFrame;
                    this.dirty = true;
                    this.updateTileTexture();
                    return this;
                },
                /**
     * Sets {@link Phaser.GameObjects.TileSprite#tilePositionX} and {@link Phaser.GameObjects.TileSprite#tilePositionY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTilePosition
     * @since 3.3.0
     *
     * @param {number} [x] - The x position of this sprite's tiling texture.
     * @param {number} [y] - The y position of this sprite's tiling texture.
     *
     * @return {this} This Tile Sprite instance.
     */ setTilePosition: function(x, y) {
                    if (x !== undefined) this.tilePositionX = x;
                    if (y !== undefined) this.tilePositionY = y;
                    return this;
                },
                /**
     * Sets {@link Phaser.GameObjects.TileSprite#tileScaleX} and {@link Phaser.GameObjects.TileSprite#tileScaleY}.
     *
     * @method Phaser.GameObjects.TileSprite#setTileScale
     * @since 3.12.0
     *
     * @param {number} [x] - The horizontal scale of the tiling texture. If not given it will use the current `tileScaleX` value.
     * @param {number} [y=x] - The vertical scale of the tiling texture. If not given it will use the `x` value.
     *
     * @return {this} This Tile Sprite instance.
     */ setTileScale: function(x, y) {
                    if (x === undefined) x = this.tileScaleX;
                    if (y === undefined) y = x;
                    this.tileScaleX = x;
                    this.tileScaleY = y;
                    return this;
                },
                /**
     * Render the tile texture if it is dirty, or if the frame has changed.
     *
     * @method Phaser.GameObjects.TileSprite#updateTileTexture
     * @private
     * @since 3.0.0
     */ updateTileTexture: function() {
                    if (!this.dirty || !this.renderer) return;
                    //  Draw the displayTexture to our fillCanvas
                    var frame = this.displayFrame;
                    if (frame.source.isRenderTexture || frame.source.isGLTexture) {
                        console.warn('TileSprites can only use Image or Canvas based textures');
                        this.dirty = false;
                        return;
                    }
                    var ctx = this.fillContext;
                    var canvas = this.fillCanvas;
                    var fw = this.potWidth;
                    var fh = this.potHeight;
                    if (!this.renderer.gl) {
                        fw = frame.cutWidth;
                        fh = frame.cutHeight;
                    }
                    ctx.clearRect(0, 0, fw, fh);
                    canvas.width = fw;
                    canvas.height = fh;
                    ctx.drawImage(frame.source.image, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, 0, 0, fw, fh);
                    if (this.renderer.gl) this.fillPattern = this.renderer.canvasToTexture(canvas, this.fillPattern);
                    else this.fillPattern = ctx.createPattern(canvas, 'repeat');
                    this.updateCanvas();
                    this.dirty = false;
                },
                /**
     * Draw the fill pattern to the internal canvas.
     *
     * @method Phaser.GameObjects.TileSprite#updateCanvas
     * @private
     * @since 3.12.0
     */ updateCanvas: function() {
                    var canvas = this.canvas;
                    if (canvas.width !== this.width || canvas.height !== this.height) {
                        canvas.width = this.width;
                        canvas.height = this.height;
                        this.frame.setSize(this.width, this.height);
                        this.updateDisplayOrigin();
                        this.dirty = true;
                    }
                    if (!this.dirty || this.renderer && this.renderer.gl) {
                        this.dirty = false;
                        return;
                    }
                    var ctx = this.context;
                    if (!this.scene.sys.game.config.antialias) Smoothing.disable(ctx);
                    var scaleX = this._tileScale.x;
                    var scaleY = this._tileScale.y;
                    var positionX = this._tilePosition.x;
                    var positionY = this._tilePosition.y;
                    ctx.clearRect(0, 0, this.width, this.height);
                    ctx.save();
                    ctx.scale(scaleX, scaleY);
                    ctx.translate(-positionX, -positionY);
                    ctx.fillStyle = this.fillPattern;
                    ctx.fillRect(positionX, positionY, this.width / scaleX, this.height / scaleY);
                    ctx.restore();
                    this.dirty = false;
                },
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.TileSprite#preDestroy
     * @protected
     * @since 3.9.0
     */ preDestroy: function() {
                    if (this.renderer && this.renderer.gl) this.renderer.deleteTexture(this.fillPattern);
                    CanvasPool.remove(this.canvas);
                    CanvasPool.remove(this.fillCanvas);
                    this.fillPattern = null;
                    this.fillContext = null;
                    this.fillCanvas = null;
                    this.displayTexture = null;
                    this.displayFrame = null;
                    this.texture.destroy();
                    this.renderer = null;
                },
                /**
     * The horizontal scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionX
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionX: {
                    get: function() {
                        return this._tilePosition.x;
                    },
                    set: function(value) {
                        this._tilePosition.x = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scroll position of the Tile Sprite.
     *
     * @name Phaser.GameObjects.TileSprite#tilePositionY
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ tilePositionY: {
                    get: function() {
                        return this._tilePosition.y;
                    },
                    set: function(value) {
                        this._tilePosition.y = value;
                        this.dirty = true;
                    }
                },
                /**
     * The horizontal scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleX
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleX: {
                    get: function() {
                        return this._tileScale.x;
                    },
                    set: function(value) {
                        this._tileScale.x = value;
                        this.dirty = true;
                    }
                },
                /**
     * The vertical scale of the Tile Sprite texture.
     *
     * @name Phaser.GameObjects.TileSprite#tileScaleY
     * @type {number}
     * @default 1
     * @since 3.11.0
     */ tileScaleY: {
                    get: function() {
                        return this._tileScale.y;
                    },
                    set: function(value) {
                        this._tileScale.y = value;
                        this.dirty = true;
                    }
                }
            });
            module1.exports = TileSprite;
        /***/ },
        /* 223 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Components = __webpack_require__(11);
            var Events = __webpack_require__(75);
            var GameEvents = __webpack_require__(22);
            var InputEvents = __webpack_require__(49);
            var GameObject = __webpack_require__(15);
            var SoundEvents = __webpack_require__(69);
            var UUID = __webpack_require__(219);
            var VideoRender = __webpack_require__(1088);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Video Game Object.
 *
 * This Game Object is capable of handling playback of a previously loaded video from the Phaser Video Cache,
 * or playing a video based on a given URL. Videos can be either local, or streamed.
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4');
 * }
 *
 * create () {
 *   this.add.video(400, 300, 'pixar');
 * }
 * ```
 *
 * To all intents and purposes, a video is a standard Game Object, just like a Sprite. And as such, you can do
 * all the usual things to it, such as scaling, rotating, cropping, tinting, making interactive, giving a
 * physics body, etc.
 *
 * Transparent videos are also possible via the WebM file format. Providing the video file has was encoded with
 * an alpha channel, and providing the browser supports WebM playback (not all of them do), then it will render
 * in-game with full transparency.
 *
 * ### Autoplaying Videos
 *
 * Videos can only autoplay if the browser has been unlocked with an interaction, or satisfies the MEI settings.
 * The policies that control autoplaying are vast and vary between browser.
 * You can, and should, read more about it here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
 *
 * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is _loaded_,
 * and it will often allow the video to play immediately:
 *
 * ```javascript
 * preload () {
 *   this.load.video('pixar', 'nemo.mp4', 'loadeddata', false, true);
 * }
 * ```
 *
 * The 5th parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
 * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
 * the browsers MEI settings. See the MDN Autoplay Guide for further details.
 *
 * Note that due to a bug in IE11 you cannot play a video texture to a Sprite in WebGL. For IE11 force Canvas mode.
 *
 * More details about video playback and the supported media formats can be found on MDN:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats
 *
 * @class Video
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.20.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.TextureCrop
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 */ var Video = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.Pipeline,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.TextureCrop,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    VideoRender
                ],
                initialize: function Video(scene, x, y, key) {
                    GameObject.call(this, scene, 'Video');
                    /**
         * A reference to the HTML Video Element this Video Game Object is playing.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#video
         * @type {?HTMLVideoElement}
         * @since 3.20.0
         */ this.video = null;
                    /**
         * The Phaser Texture this Game Object is using to render the video to.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTexture
         * @type {?Phaser.Textures.Texture}
         * @since 3.20.0
         */ this.videoTexture = null;
                    /**
         * A reference to the TextureSource belong to the `videoTexture` Texture object.
         * Will be `null` until a video is loaded for playback.
         *
         * @name Phaser.GameObjects.Video#videoTextureSource
         * @type {?Phaser.Textures.TextureSource}
         * @since 3.20.0
         */ this.videoTextureSource = null;
                    /**
         * A Phaser CanvasTexture instance that holds the most recent snapshot taken from the video.
         * This will only be set if `snapshot` or `snapshotArea` have been called, and will be `null` until that point.
         *
         * @name Phaser.GameObjects.Video#snapshotTexture
         * @type {?Phaser.Textures.CanvasTexture}
         * @since 3.20.0
         */ this.snapshotTexture = null;
                    /**
         * If you have saved this video to a texture via the `saveTexture` method, this controls if the video
         * is rendered with `flipY` in WebGL or not. You often need to set this if you wish to use the video texture
         * as the input source for a shader. If you find your video is appearing upside down within a shader or
         * custom pipeline, flip this property.
         *
         * @name Phaser.GameObjects.Video#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = false;
                    /**
         * The key used by the texture as stored in the Texture Manager.
         *
         * @name Phaser.GameObjects.Video#_key
         * @type {string}
         * @private
         * @since 3.20.0
         */ this._key = UUID();
                    /**
         * An internal flag holding the current state of the video lock, should document interaction be required
         * before playback can begin.
         *
         * @name Phaser.GameObjects.Video#touchLocked
         * @type {boolean}
         * @since 3.20.0
         */ this.touchLocked = true;
                    /**
         * Should the video auto play when document interaction is required and happens?
         *
         * @name Phaser.GameObjects.Video#playWhenUnlocked
         * @type {boolean}
         * @since 3.20.0
         */ this.playWhenUnlocked = false;
                    /**
         * When starting playback of a video Phaser will monitor its `readyState` using a `setTimeout` call.
         * The `setTimeout` happens once every `Video.retryInterval` ms. It will carry on monitoring the video
         * state in this manner until the `retryLimit` is reached and then abort.
         *
         * @name Phaser.GameObjects.Video#retryLimit
         * @type {number}
         * @since 3.20.0
         */ this.retryLimit = 20;
                    /**
         * The current retry attempt.
         *
         * @name Phaser.GameObjects.Video#retry
         * @type {number}
         * @since 3.20.0
         */ this.retry = 0;
                    /**
         * The number of ms between each retry while monitoring the ready state of a downloading video.
         *
         * @name Phaser.GameObjects.Video#retryInterval
         * @type {number}
         * @since 3.20.0
         */ this.retryInterval = 500;
                    /**
         * The setTimeout callback ID.
         *
         * @name Phaser.GameObjects.Video#_retryID
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._retryID = null;
                    /**
         * The video was muted due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemMuted = false;
                    /**
         * The video was muted due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codeMuted
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codeMuted = false;
                    /**
         * The video was paused due to a system event, such as the game losing focus.
         *
         * @name Phaser.GameObjects.Video#_systemPaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._systemPaused = false;
                    /**
         * The video was paused due to game code, not a system event.
         *
         * @name Phaser.GameObjects.Video#_codePaused
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._codePaused = false;
                    /**
         * The locally bound event callback handlers.
         *
         * @name Phaser.GameObjects.Video#_callbacks
         * @type {any}
         * @private
         * @since 3.20.0
         */ this._callbacks = {
                        play: this.playHandler.bind(this),
                        error: this.loadErrorHandler.bind(this),
                        end: this.completeHandler.bind(this),
                        time: this.timeUpdateHandler.bind(this),
                        seeking: this.seekingHandler.bind(this),
                        seeked: this.seekedHandler.bind(this)
                    };
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.GameObjects.Video#_crop
         * @type {object}
         * @private
         * @since 3.20.0
         */ this._crop = this.resetCropObject();
                    /**
         * An object containing in and out markers for sequence playback.
         *
         * @name Phaser.GameObjects.Video#markers
         * @type {any}
         * @since 3.20.0
         */ this.markers = {};
                    /**
         * The in marker.
         *
         * @name Phaser.GameObjects.Video#_markerIn
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerIn = -1;
                    /**
         * The out marker.
         *
         * @name Phaser.GameObjects.Video#_markerOut
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._markerOut = MATH_CONST.MAX_SAFE_INTEGER;
                    /**
         * The last time the TextureSource was updated.
         *
         * @name Phaser.GameObjects.Video#_lastUpdate
         * @type {number}
         * @private
         * @since 3.20.0
         */ this._lastUpdate = 0;
                    /**
         * The key of the video being played from the Video cache, if any.
         *
         * @name Phaser.GameObjects.Video#_cacheKey
         * @type {string}
         * @private
         * @since 3.20.0
         */ this._cacheKey = '';
                    /**
         * Is the video currently seeking?
         *
         * @name Phaser.GameObjects.Video#_isSeeking
         * @type {boolean}
         * @private
         * @since 3.20.0
         */ this._isSeeking = false;
                    /**
         * Should the Video element that this Video is using, be removed from the DOM
         * when this Video is destroyed?
         *
         * @name Phaser.GameObjects.Video#removeVideoElementOnDestroy
         * @type {boolean}
         * @since 3.21.0
         */ this.removeVideoElementOnDestroy = false;
                    this.setPosition(x, y);
                    this.initPipeline();
                    if (key) this.changeSource(key, false);
                    var game = scene.sys.game.events;
                    game.on(GameEvents.PAUSE, this.globalPause, this);
                    game.on(GameEvents.RESUME, this.globalResume, this);
                    var sound = scene.sys.sound;
                    if (sound) sound.on(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Starts this video playing.
     *
     * If the video is already playing, or has been queued to play with `changeSource` then this method just returns.
     *
     * Videos can only autoplay if the browser has been unlocked. This happens if you have interacted with the browser, i.e.
     * by clicking on it or pressing a key, or due to server settings. The policies that control autoplaying are vast and
     * vary between browser. You can read more here: https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
     *
     * If your video doesn't contain any audio, then set the `noAudio` parameter to `true` when the video is loaded,
     * and it will often allow the video to play immediately:
     *
     * ```javascript
     * preload () {
     *   this.load.video('pixar', 'nemo.mp4', 'loadeddata', false, true);
     * }
     * ```
     *
     * The 5th parameter in the load call tells Phaser that the video doesn't contain any audio tracks. Video without
     * audio can autoplay without requiring a user interaction. Video with audio cannot do this unless it satisfies
     * the browsers MEI settings. See the MDN Autoplay Guide for details.
     *
     * If you need audio in your videos, then you'll have to consider the fact that the video cannot start playing until the
     * user has interacted with the browser, into your game flow.
     *
     * @method Phaser.GameObjects.Video#play
     * @since 3.20.0
     *
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ play: function(loop, markerIn, markerOut) {
                    if (this.touchLocked && this.playWhenUnlocked || this.isPlaying()) return this;
                    var video = this.video;
                    if (!video) {
                        console.warn('Video not loaded');
                        return this;
                    }
                    if (loop === undefined) loop = video.loop;
                    var sound = this.scene.sys.sound;
                    if (sound && sound.mute) //  Mute will be set based on the global mute state of the Sound Manager (if there is one)
                    this.setMute(true);
                    if (!isNaN(markerIn)) this._markerIn = markerIn;
                    if (!isNaN(markerOut) && markerOut > markerIn) this._markerOut = markerOut;
                    video.loop = loop;
                    var callbacks = this._callbacks;
                    var playPromise = video.play();
                    if (playPromise !== undefined) playPromise.then(this.playPromiseSuccessHandler.bind(this)).catch(this.playPromiseErrorHandler.bind(this));
                    else {
                        //  Old-school browsers with no Promises
                        video.addEventListener('playing', callbacks.play, true);
                        //  If video hasn't downloaded properly yet ...
                        if (video.readyState < 2) {
                            this.retry = this.retryLimit;
                            this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval);
                        }
                    }
                    //  Set these _after_ calling `play` or they don't fire (useful, thanks browsers)
                    video.addEventListener('ended', callbacks.end, true);
                    video.addEventListener('timeupdate', callbacks.time, true);
                    video.addEventListener('seeking', callbacks.seeking, true);
                    video.addEventListener('seeked', callbacks.seeked, true);
                    return this;
                },
                /**
     * This method allows you to change the source of the current video element. It works by first stopping the
     * current video, if playing. Then deleting the video texture, if one has been created. Finally, it makes a
     * new video texture and starts playback of the new source through the existing video element.
     *
     * The reason you may wish to do this is because videos that require interaction to unlock, remain in an unlocked
     * state, even if you change the source of the video. By changing the source to a new video you avoid having to
     * go through the unlock process again.
     *
     * @method Phaser.GameObjects.Video#changeSource
     * @since 3.20.0
     *
     * @param {string} key - The key of the Video this Game Object will swap to playing, as stored in the Video Cache.
     * @param {boolean} [autoplay=true] - Should the video start playing immediately, once the swap is complete?
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     * @param {number} [markerIn] - Optional in marker time, in seconds, for playback of a sequence of the video.
     * @param {number} [markerOut] - Optional out marker time, in seconds, for playback of a sequence of the video.
     *
     * @return {this} This Video Game Object for method chaining.
     */ changeSource: function(key, autoplay, loop, markerIn, markerOut) {
                    if (autoplay === undefined) autoplay = true;
                    var currentVideo = this.video;
                    if (currentVideo) this.stop();
                    var newVideo = this.scene.sys.cache.video.get(key);
                    if (newVideo) {
                        this.video = newVideo;
                        this._cacheKey = key;
                        this._codePaused = newVideo.paused;
                        this._codeMuted = newVideo.muted;
                        if (this.videoTexture) {
                            this.scene.sys.textures.remove(this._key);
                            this.videoTexture = this.scene.sys.textures.create(this._key, newVideo, newVideo.videoWidth, newVideo.videoHeight);
                            this.videoTextureSource = this.videoTexture.source[0];
                            this.videoTexture.add('__BASE', 0, 0, 0, newVideo.videoWidth, newVideo.videoHeight);
                            this.setTexture(this.videoTexture);
                            this.setSizeToFrame();
                            this.updateDisplayOrigin();
                            this.emit(Events.VIDEO_CREATED, this, newVideo.videoWidth, newVideo.videoHeight);
                        } else this.updateTexture();
                        newVideo.currentTime = 0;
                        this._lastUpdate = 0;
                        if (autoplay) this.play(loop, markerIn, markerOut);
                    } else this.video = null;
                    return this;
                },
                /**
     * Adds a sequence marker to this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds.
     *
     * You can then play back specific markers via the `playMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#addMarker
     * @since 3.20.0
     *
     * @param {string} key - A unique name to give this marker.
     * @param {number} markerIn - The time, in seconds, representing the start of this marker.
     * @param {number} markerOut - The time, in seconds, representing the end of this marker.
     *
     * @return {this} This Video Game Object for method chaining.
     */ addMarker: function(key, markerIn, markerOut) {
                    if (!isNaN(markerIn) && markerIn >= 0 && !isNaN(markerOut)) this.markers[key] = [
                        markerIn,
                        markerOut
                    ];
                    return this;
                },
                /**
     * Plays a pre-defined sequence in this video.
     *
     * Markers allow you to split a video up into sequences, delineated by a start and end time, given in seconds and
     * specified via the `addMarker` method.
     *
     * Note that marker timing is _not_ frame-perfect. You should construct your videos in such a way that you allow for
     * plenty of extra padding before and after each sequence to allow for discrepancies in browser seek and currentTime accuracy.
     *
     * See https://github.com/w3c/media-and-entertainment/issues/4 for more details about this issue.
     *
     * @method Phaser.GameObjects.Video#playMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker sequence to play.
     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @return {this} This Video Game Object for method chaining.
     */ playMarker: function(key, loop) {
                    var marker = this.markers[key];
                    if (marker) this.play(loop, marker[0], marker[1]);
                    return this;
                },
                /**
     * Removes a previously set marker from this video.
     *
     * If the marker is currently playing it will _not_ stop playback.
     *
     * @method Phaser.GameObjects.Video#removeMarker
     * @since 3.20.0
     *
     * @param {string} key - The name of the marker to remove.
     *
     * @return {this} This Video Game Object for method chaining.
     */ removeMarker: function(key) {
                    delete this.markers[key];
                    return this;
                },
                /**
     * Takes a snapshot of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a width and height.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshot
     * @since 3.20.0
     *
     * @param {number} [width] - The width of the resulting CanvasTexture.
     * @param {number} [height] - The height of the resulting CanvasTexture.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshot: function(width, height) {
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    return this.snapshotArea(0, 0, this.width, this.height, width, height);
                },
                /**
     * Takes a snapshot of the specified area of the current frame of the video and renders it to a CanvasTexture object,
     * which is then returned. You can optionally resize the grab by passing a different `destWidth` and `destHeight`.
     *
     * This method returns a reference to the `Video.snapshotTexture` object. Calling this method
     * multiple times will overwrite the previous snapshot with the most recent one.
     *
     * @method Phaser.GameObjects.Video#snapshotArea
     * @since 3.20.0
     *
     * @param {number} [x=0] - The horizontal location of the top-left of the area to grab from.
     * @param {number} [y=0] - The vertical location of the top-left of the area to grab from.
     * @param {number} [srcWidth] - The width of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [srcHeight] - The height of area to grab from the video. If not given it will grab the full video dimensions.
     * @param {number} [destWidth] - The destination width of the grab, allowing you to resize it.
     * @param {number} [destHeight] - The destination height of the grab, allowing you to resize it.
     *
     * @return {Phaser.Textures.CanvasTexture}
     */ snapshotArea: function(x, y, srcWidth, srcHeight, destWidth, destHeight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (srcWidth === undefined) srcWidth = this.width;
                    if (srcHeight === undefined) srcHeight = this.height;
                    if (destWidth === undefined) destWidth = srcWidth;
                    if (destHeight === undefined) destHeight = srcHeight;
                    var video = this.video;
                    var snap = this.snapshotTexture;
                    if (!snap) {
                        snap = this.scene.sys.textures.createCanvas(UUID(), destWidth, destHeight);
                        this.snapshotTexture = snap;
                        if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                    } else {
                        snap.setSize(destWidth, destHeight);
                        if (video) snap.context.drawImage(video, x, y, srcWidth, srcHeight, 0, 0, destWidth, destHeight);
                    }
                    return snap.update();
                },
                /**
     * Stores a copy of this Videos `snapshotTexture` in the Texture Manager using the given key.
     *
     * This texture is created when the `snapshot` or `snapshotArea` methods are called.
     *
     * After doing this, any texture based Game Object, such as a Sprite, can use the contents of the
     * snapshot by using the texture key:
     *
     * ```javascript
     * var vid = this.add.video(0, 0, 'intro');
     *
     * vid.snapshot();
     *
     * vid.saveSnapshotTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Updating the contents of the `snapshotTexture`, for example by calling `snapshot` again,
     * will automatically update _any_ Game Object that is using it as a texture.
     * Calling `saveSnapshotTexture` again will not save another copy of the same texture,
     * it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * @method Phaser.GameObjects.Video#saveSnapshotTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     *
     * @return {Phaser.Textures.CanvasTexture} The Texture that was saved.
     */ saveSnapshotTexture: function(key) {
                    if (this.snapshotTexture) this.scene.sys.textures.renameTexture(this.snapshotTexture.key, key);
                    else this.snapshotTexture = this.scene.sys.textures.createCanvas(key, this.width, this.height);
                    return this.snapshotTexture;
                },
                /**
     * Loads a Video from the given URL, ready for playback with the `Video.play` method.
     *
     * You can control at what point the browser determines the video as being ready for playback via
     * the `loadEvent` parameter. See https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
     * for more details.
     *
     * @method Phaser.GameObjects.Video#loadURL
     * @since 3.20.0
     *
     * @param {string} url - The URL of the video to load or be streamed.
     * @param {string} [loadEvent='loadeddata'] - The load event to listen for. Either `loadeddata`, `canplay` or `canplaythrough`.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadURL: function(url, loadEvent, noAudio) {
                    if (loadEvent === undefined) loadEvent = 'loadeddata';
                    if (noAudio === undefined) noAudio = false;
                    if (this.video) this.stop();
                    if (this.videoTexture) this.scene.sys.textures.remove(this._key);
                    var video = document.createElement('video');
                    video.controls = false;
                    if (noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute('autoplay', 'autoplay');
                    }
                    video.setAttribute('playsinline', 'playsinline');
                    video.setAttribute('preload', 'auto');
                    video.addEventListener('error', this._callbacks.error, true);
                    video.src = url;
                    video.load();
                    this.video = video;
                    return this;
                },
                /**
     * Loads a Video from the given MediaStream object, ready for playback with the `Video.play` method.
     *
     * You can control at what point the browser determines the video as being ready for playback via
     * the `loadEvent` parameter. See https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement
     * for more details.
     *
     * @method Phaser.GameObjects.Video#loadMediaStream
     * @since 3.50.0
     *
     * @param {string} stream - The MediaStream object.
     * @param {string} [loadEvent='loadeddata'] - The load event to listen for. Either `loadeddata`, `canplay` or `canplaythrough`.
     * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ loadMediaStream: function(stream, loadEvent, noAudio) {
                    if (loadEvent === undefined) loadEvent = 'loadeddata';
                    if (noAudio === undefined) noAudio = false;
                    if (this.video) this.stop();
                    if (this.videoTexture) this.scene.sys.textures.remove(this._key);
                    var video = document.createElement('video');
                    video.controls = false;
                    if (noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute('autoplay', 'autoplay');
                    }
                    video.setAttribute('playsinline', 'playsinline');
                    video.setAttribute('preload', 'auto');
                    video.addEventListener('error', this._callbacks.error, true);
                    try {
                        video.srcObject = stream;
                    } catch (error) {
                        video.src = window.URL.createObjectURL(stream);
                    }
                    video.load();
                    this.video = video;
                    return this;
                },
                /**
     * This internal method is called automatically if the playback Promise resolves successfully.
     *
     * @method Phaser.GameObjects.Video#playPromiseSuccessHandler
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @private
     * @since 3.20.0
     */ playPromiseSuccessHandler: function() {
                    this.touchLocked = false;
                    this.emit(Events.VIDEO_PLAY, this);
                    if (this._markerIn > -1) this.video.currentTime = this._markerIn;
                },
                /**
     * This internal method is called automatically if the playback Promise fails to resolve.
     *
     * @method Phaser.GameObjects.Video#playPromiseErrorHandler
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @private
     * @since 3.20.0
     *
     * @param {any} error - The Promise resolution error.
     */ playPromiseErrorHandler: function(error) {
                    this.scene.sys.input.once(InputEvents.POINTER_DOWN, this.unlockHandler, this);
                    this.touchLocked = true;
                    this.playWhenUnlocked = true;
                    this.emit(Events.VIDEO_ERROR, this, error);
                },
                /**
     * Called when the video emits a `playing` event during load.
     *
     * This is only listened for if the browser doesn't support Promises.
     *
     * @method Phaser.GameObjects.Video#playHandler
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @since 3.20.0
     */ playHandler: function() {
                    this.touchLocked = false;
                    this.emit(Events.VIDEO_PLAY, this);
                    this.video.removeEventListener('playing', this._callbacks.play, true);
                },
                /**
     * This internal method is called automatically if the video fails to load.
     *
     * @method Phaser.GameObjects.Video#loadErrorHandler
     * @fires Phaser.GameObjects.Events#VIDEO_ERROR
     * @private
     * @since 3.20.0
     *
     * @param {Event} event - The error Event.
     */ loadErrorHandler: function(event) {
                    this.stop();
                    this.emit(Events.VIDEO_ERROR, this, event);
                },
                /**
     * This internal method is called if the video couldn't be played because it was interaction locked
     * by the browser, but an input event has since been received.
     *
     * @method Phaser.GameObjects.Video#unlockHandler
     * @fires Phaser.GameObjects.Events#VIDEO_UNLOCKED
     * @fires Phaser.GameObjects.Events#VIDEO_PLAY
     * @private
     * @since 3.20.0
     *
     * @param {any} error - The Promise resolution error.
     */ unlockHandler: function() {
                    this.touchLocked = false;
                    this.playWhenUnlocked = false;
                    this.emit(Events.VIDEO_UNLOCKED, this);
                    if (this._markerIn > -1) this.video.currentTime = this._markerIn;
                    this.video.play();
                    this.emit(Events.VIDEO_PLAY, this);
                },
                /**
     * Called when the video completes playback, i.e. reaches an `ended` state.
     *
     * This will never happen if the video is coming from a live stream, where the duration is `Infinity`.
     *
     * @method Phaser.GameObjects.Video#completeHandler
     * @fires Phaser.GameObjects.Events#VIDEO_COMPLETE
     * @since 3.20.0
     */ completeHandler: function() {
                    this.emit(Events.VIDEO_COMPLETE, this);
                },
                /**
     * Called when the video emits a `timeUpdate` event during playback.
     *
     * This event is too slow and irregular to be used for actual video timing or texture updating,
     * but we can use it to determine if a video has looped.
     *
     * @method Phaser.GameObjects.Video#timeUpdateHandler
     * @fires Phaser.GameObjects.Events#VIDEO_LOOP
     * @since 3.20.0
     */ timeUpdateHandler: function() {
                    if (this.video && this.video.currentTime < this._lastUpdate) {
                        this.emit(Events.VIDEO_LOOP, this);
                        this._lastUpdate = 0;
                    }
                },
                /**
     * The internal update step.
     *
     * @method Phaser.GameObjects.Video#preUpdate
     * @private
     * @since 3.20.0
     */ preUpdate: function() {
                    var video = this.video;
                    if (video) {
                        var currentTime = video.currentTime;
                        //  Don't render a new frame unless the video has actually changed time
                        if (currentTime !== this._lastUpdate) {
                            this._lastUpdate = currentTime;
                            this.updateTexture();
                            if (currentTime >= this._markerOut) {
                                if (video.loop) {
                                    video.currentTime = this._markerIn;
                                    this.updateTexture();
                                    this._lastUpdate = currentTime;
                                    this.emit(Events.VIDEO_LOOP, this);
                                } else {
                                    this.emit(Events.VIDEO_COMPLETE, this);
                                    this.stop();
                                }
                            }
                        }
                    }
                },
                /**
     * Internal callback that monitors the download progress of a video after changing its source.
     *
     * @method Phaser.GameObjects.Video#checkVideoProgress
     * @fires Phaser.GameObjects.Events#VIDEO_TIMEOUT
     * @private
     * @since 3.20.0
     */ checkVideoProgress: function() {
                    if (this.video.readyState >= 2) //  We've got enough data to update the texture for playback
                    this.updateTexture();
                    else {
                        this.retry--;
                        if (this.retry > 0) this._retryID = window.setTimeout(this.checkVideoProgress.bind(this), this.retryInterval);
                        else this.emit(Events.VIDEO_TIMEOUT, this);
                    }
                },
                /**
     * Internal method that is called when enough video data has been received in order to create a texture
     * from it. The texture is assigned to the `Video.videoTexture` property and given a base frame that
     * encompases the whole video size.
     *
     * @method Phaser.GameObjects.Video#updateTexture
     * @since 3.20.0
     */ updateTexture: function() {
                    var video = this.video;
                    var width = video.videoWidth;
                    var height = video.videoHeight;
                    if (!this.videoTexture) {
                        this.videoTexture = this.scene.sys.textures.create(this._key, video, width, height);
                        this.videoTextureSource = this.videoTexture.source[0];
                        this.videoTexture.add('__BASE', 0, 0, 0, width, height);
                        this.setTexture(this.videoTexture);
                        this.setSizeToFrame();
                        this.updateDisplayOrigin();
                        this.emit(Events.VIDEO_CREATED, this, width, height);
                    } else {
                        var textureSource = this.videoTextureSource;
                        if (textureSource.source !== video) {
                            textureSource.source = video;
                            textureSource.width = width;
                            textureSource.height = height;
                        }
                        textureSource.update();
                    }
                },
                /**
     * Returns the key of the currently played video, as stored in the Video Cache.
     * If the video did not come from the cache this will return an empty string.
     *
     * @method Phaser.GameObjects.Video#getVideoKey
     * @since 3.20.0
     *
     * @return {string} The key of the video being played from the Video Cache, if any.
     */ getVideoKey: function() {
                    return this._cacheKey;
                },
                /**
     * Seeks to a given point in the video. The value is given as a float between 0 and 1,
     * where 0 represents the start of the video and 1 represents the end.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * If you wish to seek based on time instead, use the `Video.setCurrentTime` method.
     *
     * @method Phaser.GameObjects.Video#seekTo
     * @since 3.20.0
     *
     * @param {number} value - The point in the video to seek to. A value between 0 and 1.
     *
     * @return {this} This Video Game Object for method chaining.
     */ seekTo: function(value) {
                    var video = this.video;
                    if (video) {
                        var duration = video.duration;
                        if (duration !== Infinity && !isNaN(duration)) {
                            var seekTime = duration * value;
                            this.setCurrentTime(seekTime);
                        }
                    }
                    return this;
                },
                /**
     * A double-precision floating-point value indicating the current playback time in seconds.
     * If the media has not started to play and has not been seeked, this value is the media's initial playback time.
     *
     * @method Phaser.GameObjects.Video#getCurrentTime
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the current playback time in seconds.
     */ getCurrentTime: function() {
                    return this.video ? this.video.currentTime : 0;
                },
                /**
     * Seeks to a given playback time in the video. The value is given in _seconds_ or as a string.
     *
     * Seeking only works if the video has a duration, so will not work for live streams.
     *
     * When seeking begins, this video will emit a `seeking` event. When the video completes
     * seeking (i.e. reaches its designated timestamp) it will emit a `seeked` event.
     *
     * You can provide a string prefixed with either a `+` or a `-`, such as `+2.5` or `-2.5`.
     * In this case it will seek to +/- the value given, relative to the _current time_.
     *
     * If you wish to seek based on a duration percentage instead, use the `Video.seekTo` method.
     *
     * @method Phaser.GameObjects.Video#setCurrentTime
     * @since 3.20.0
     *
     * @param {(string|number)} value - The playback time to seek to in seconds. Can be expressed as a string, such as `+2` to seek 2 seconds ahead from the current time.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setCurrentTime: function(value) {
                    var video = this.video;
                    if (video) {
                        if (typeof value === 'string') {
                            var op = value[0];
                            var num = parseFloat(value.substr(1));
                            if (op === '+') value = video.currentTime + num;
                            else if (op === '-') value = video.currentTime - num;
                        }
                        video.currentTime = value;
                        this._lastUpdate = value;
                    }
                    return this;
                },
                /**
     * Returns a boolean indicating if this Video is currently seeking, or not.
     *
     * @method Phaser.GameObjects.Video#isSeeking
     * @since 3.20.0
     *
     * @return {boolean} A boolean indicating if this Video is currently seeking, or not.
     */ isSeeking: function() {
                    return this._isSeeking;
                },
                /**
     * Internal seeking handler.
     *
     * @method Phaser.GameObjects.Video#seekingHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKING
     * @private
     * @since 3.20.0
     */ seekingHandler: function() {
                    this._isSeeking = true;
                    this.emit(Events.VIDEO_SEEKING, this);
                },
                /**
     * Internal seeked handler.
     *
     * @method Phaser.GameObjects.Video#seekedHandler
     * @fires Phaser.GameObjects.Events#VIDEO_SEEKED
     * @private
     * @since 3.20.0
     */ seekedHandler: function() {
                    this._isSeeking = false;
                    this.emit(Events.VIDEO_SEEKED, this);
                    var video = this.video;
                    if (video) this.updateTexture();
                },
                /**
     * Returns the current progress of the video. Progress is defined as a value between 0 (the start)
     * and 1 (the end).
     *
     * Progress can only be returned if the video has a duration, otherwise it will always return zero.
     *
     * @method Phaser.GameObjects.Video#getProgress
     * @since 3.20.0
     *
     * @return {number} The current progress of playback. If the video has no duration, will always return zero.
     */ getProgress: function() {
                    var video = this.video;
                    if (video) {
                        var now = video.currentTime;
                        var duration = video.duration;
                        if (duration !== Infinity && !isNaN(duration)) return now / duration;
                    }
                    return 0;
                },
                /**
     * A double-precision floating-point value which indicates the duration (total length) of the media in seconds,
     * on the media's timeline. If no media is present on the element, or the media is not valid, the returned value is NaN.
     *
     * If the media has no known end (such as for live streams of unknown duration, web radio, media incoming from WebRTC,
     * and so forth), this value is +Infinity.
     *
     * @method Phaser.GameObjects.Video#getDuration
     * @since 3.20.0
     *
     * @return {number} A double-precision floating-point value indicating the duration of the media in seconds.
     */ getDuration: function() {
                    return this.video ? this.video.duration : 0;
                },
                /**
     * Sets the muted state of the currently playing video, if one is loaded.
     *
     * @method Phaser.GameObjects.Video#setMute
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The mute value. `true` if the video should be muted, otherwise `false`.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setMute: function(value) {
                    if (value === undefined) value = true;
                    this._codeMuted = value;
                    var video = this.video;
                    if (video) video.muted = this._systemMuted ? true : value;
                    return this;
                },
                /**
     * Returns a boolean indicating if this Video is currently muted.
     *
     * @method Phaser.GameObjects.Video#isMuted
     * @since 3.20.0
     *
     * @return {boolean} A boolean indicating if this Video is currently muted, or not.
     */ isMuted: function() {
                    return this._codeMuted;
                },
                /**
     * Internal global mute handler. Will mute the video, if playing, if the global sound system mutes.
     *
     * @method Phaser.GameObjects.Video#globalMute
     * @private
     * @since 3.20.0
     *
     * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
     * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
     */ globalMute: function(soundManager, value) {
                    this._systemMuted = value;
                    var video = this.video;
                    if (video) video.muted = this._codeMuted ? true : value;
                },
                /**
     * Internal global pause handler. Will pause the video if the Game itself pauses.
     *
     * @method Phaser.GameObjects.Video#globalPause
     * @private
     * @since 3.20.0
     */ globalPause: function() {
                    this._systemPaused = true;
                    if (this.video) this.video.pause();
                },
                /**
     * Internal global resume handler. Will resume a paused video if the Game itself resumes.
     *
     * @method Phaser.GameObjects.Video#globalResume
     * @private
     * @since 3.20.0
     */ globalResume: function() {
                    this._systemPaused = false;
                    if (this.video && !this._codePaused) this.video.play();
                },
                /**
     * Sets the paused state of the currently loaded video.
     *
     * If the video is playing, calling this method with `true` will pause playback.
     * If the video is paused, calling this method with `false` will resume playback.
     *
     * If no video is loaded, this method does nothing.
     *
     * @method Phaser.GameObjects.Video#setPaused
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - The paused value. `true` if the video should be paused, `false` to resume it.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPaused: function(value) {
                    if (value === undefined) value = true;
                    var video = this.video;
                    this._codePaused = value;
                    if (video) {
                        if (value) {
                            if (!video.paused) video.pause();
                        } else if (!value) {
                            if (video.paused && !this._systemPaused) video.play();
                        }
                    }
                    return this;
                },
                /**
     * Returns a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#getVolume
     * @since 3.20.0
     *
     * @return {number} A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     */ getVolume: function() {
                    return this.video ? this.video.volume : 1;
                },
                /**
     * Sets the volume of the currently playing video.
     *
     * The value given is a double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @method Phaser.GameObjects.Video#setVolume
     * @since 3.20.0
     *
     * @param {number} [value=1] - A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     *
     * @return {this} This Video Game Object for method chaining.
     */ setVolume: function(value) {
                    if (value === undefined) value = 1;
                    if (this.video) this.video.volume = Clamp(value, 0, 1);
                    return this;
                },
                /**
     * Returns a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#getPlaybackRate
     * @since 3.20.0
     *
     * @return {number} A double that indicates the rate at which the media is being played back.
     */ getPlaybackRate: function() {
                    return this.video ? this.video.playbackRate : 1;
                },
                /**
     * Sets the playback rate of the current video.
     *
     * The value given is a double that indicates the rate at which the media is being played back.
     *
     * @method Phaser.GameObjects.Video#setPlaybackRate
     * @since 3.20.0
     *
     * @param {number} [rate] - A double that indicates the rate at which the media is being played back.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setPlaybackRate: function(rate) {
                    if (this.video) this.video.playbackRate = rate;
                    return this;
                },
                /**
     * Returns a boolean which indicates whether the media element should start over when it reaches the end.
     *
     * @method Phaser.GameObjects.Video#getLoop
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the media element will start over when it reaches the end.
     */ getLoop: function() {
                    return this.video ? this.video.loop : false;
                },
                /**
     * Sets the loop state of the current video.
     *
     * The value given is a boolean which indicates whether the media element will start over when it reaches the end.
     *
     * Not all videos can loop, for example live streams.
     *
     * Please note that not all browsers support _seamless_ video looping for all encoding formats.
     *
     * @method Phaser.GameObjects.Video#setLoop
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - A boolean which indicates whether the media element will start over when it reaches the end.
     *
     * @return {this} This Video Game Object for method chaining.
     */ setLoop: function(value) {
                    if (value === undefined) value = true;
                    if (this.video) this.video.loop = value;
                    return this;
                },
                /**
     * Returns a boolean which indicates whether the video is currently playing.
     *
     * @method Phaser.GameObjects.Video#isPlaying
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is playing, or not.
     */ isPlaying: function() {
                    return this.video ? !(this.video.paused || this.video.ended) : false;
                },
                /**
     * Returns a boolean which indicates whether the video is currently paused.
     *
     * @method Phaser.GameObjects.Video#isPaused
     * @since 3.20.0
     *
     * @return {boolean} A boolean which indicates whether the video is paused, or not.
     */ isPaused: function() {
                    return this.video && this.video.paused || this._codePaused || this._systemPaused;
                },
                /**
     * Stores this Video in the Texture Manager using the given key as a dynamic texture,
     * which any texture-based Game Object, such as a Sprite, can use as its texture:
     *
     * ```javascript
     * var vid = this.add.video(0, 0, 'intro');
     *
     * vid.play();
     *
     * vid.saveTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * The saved texture is automatically updated as the video plays. If you pause this video,
     * or change its source, then the saved texture updates instantly.
     *
     * Calling `saveTexture` again will not save another copy of the same texture, it will just rename the existing one.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame.
     *
     * If you intend to save the texture so you can use it as the input for a Shader, you may need to set the
     * `flipY` parameter to `true` if you find the video renders upside down in your shader.
     *
     * @method Phaser.GameObjects.Video#saveTexture
     * @since 3.20.0
     *
     * @param {string} key - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y` during upload?
     *
     * @return {Phaser.Textures.Texture} The Texture that was saved.
     */ saveTexture: function(key, flipY) {
                    if (flipY === undefined) flipY = false;
                    if (this.videoTexture) this.scene.sys.textures.renameTexture(this._key, key);
                    this._key = key;
                    this.flipY = flipY;
                    if (this.videoTextureSource) this.videoTextureSource.setFlipY(flipY);
                    return this.videoTexture;
                },
                /**
     * Stops the video playing and clears all internal event listeners.
     *
     * If you only wish to pause playback of the video, and resume it a later time, use the `Video.pause` method instead.
     *
     * If the video hasn't finished downloading, calling this method will not abort the download. To do that you need to
     * call `destroy` instead.
     *
     * @method Phaser.GameObjects.Video#stop
     * @fires Phaser.GameObjects.Events#VIDEO_STOP
     * @since 3.20.0
     *
     * @return {this} This Video Game Object for method chaining.
     */ stop: function() {
                    var video = this.video;
                    if (video) {
                        var callbacks = this._callbacks;
                        for(var callback in callbacks)video.removeEventListener(callback, callbacks[callback], true);
                        video.pause();
                    }
                    if (this._retryID) window.clearTimeout(this._retryID);
                    this.emit(Events.VIDEO_STOP, this);
                    return this;
                },
                /**
     * Removes the Video element from the DOM by calling parentNode.removeChild on itself.
     *
     * Also removes the autoplay and src attributes and nulls the Video reference.
     *
     * You should not call this method if you were playing a video from the Video Cache that
     * you wish to play again in your game, or if another Video object is also using the same
     * video.
     *
     * If you loaded an external video via `Video.loadURL` then you should call this function
     * to clear up once you are done with the instance.
     *
     * @method Phaser.GameObjects.Video#removeVideoElement
     * @since 3.20.0
     */ removeVideoElement: function() {
                    var video = this.video;
                    if (!video) return;
                    if (video.parentNode) video.parentNode.removeChild(video);
                    while(video.hasChildNodes())video.removeChild(video.firstChild);
                    video.removeAttribute('autoplay');
                    video.removeAttribute('src');
                    this.video = null;
                },
                /**
     * Handles the pre-destroy step for the Video object.
     *
     * This calls `Video.stop` and optionally `Video.removeVideoElement`.
     *
     * If any Sprites are using this Video as their texture it is up to you to manage those.
     *
     * @method Phaser.GameObjects.Video#preDestroy
     * @private
     * @since 3.21.0
     */ preDestroy: function() {
                    this.stop();
                    if (this.removeVideoElementOnDestroy) this.removeVideoElement();
                    var game = this.scene.sys.game.events;
                    game.off(GameEvents.PAUSE, this.globalPause, this);
                    game.off(GameEvents.RESUME, this.globalResume, this);
                    var sound = this.scene.sys.sound;
                    if (sound) sound.off(SoundEvents.GLOBAL_MUTE, this.globalMute, this);
                    if (this._retryID) window.clearTimeout(this._retryID);
                }
            });
            module1.exports = Video;
        /***/ },
        /* 224 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Contains = __webpack_require__(225);
            var GetPoints = __webpack_require__(464);
            var GEOM_CONST = __webpack_require__(55);
            /**
 * @classdesc
 * A Polygon object
 *
 * The polygon is a closed shape consists of a series of connected straight lines defined by list of ordered points.
 * Several formats are supported to define the list of points, check the setTo method for details.
 * This is a geometry object allowing you to define and inspect the shape.
 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
 * To render a Polygon you should look at the capabilities of the Graphics class.
 *
 * @class Polygon
 * @memberof Phaser.Geom
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - List of points defining the perimeter of this Polygon. Several formats are supported:
 * - A string containing paired x y values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
 * - An array of objects with public x y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 */ var Polygon = new Class({
                initialize: function Polygon(points) {
                    /**
         * The geometry constant type of this object: `GEOM_CONST.POLYGON`.
         * Used for fast type comparisons.
         *
         * @name Phaser.Geom.Polygon#type
         * @type {number}
         * @readonly
         * @since 3.19.0
         */ this.type = GEOM_CONST.POLYGON;
                    /**
         * The area of this Polygon.
         *
         * @name Phaser.Geom.Polygon#area
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.area = 0;
                    /**
         * An array of number pair objects that make up this polygon. I.e. [ {x,y}, {x,y}, {x,y} ]
         *
         * @name Phaser.Geom.Polygon#points
         * @type {Phaser.Geom.Point[]}
         * @since 3.0.0
         */ this.points = [];
                    if (points) this.setTo(points);
                },
                /**
     * Check to see if the Polygon contains the given x / y coordinates.
     *
     * @method Phaser.Geom.Polygon#contains
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check within the polygon.
     * @param {number} y - The y coordinate to check within the polygon.
     *
     * @return {boolean} `true` if the coordinates are within the polygon, otherwise `false`.
     */ contains: function(x, y) {
                    return Contains(this, x, y);
                },
                /**
     * Sets this Polygon to the given points.
     *
     * The points can be set from a variety of formats:
     *
     * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
     *
     * `setTo` may also be called without any arguments to remove all points.
     *
     * @method Phaser.Geom.Polygon#setTo
     * @since 3.0.0
     *
     * @param {(string|number[]|Phaser.Types.Math.Vector2Like[])} [points] - Points defining the perimeter of this polygon. Please check function description above for the different supported formats.
     *
     * @return {this} This Polygon object.
     */ setTo: function(points) {
                    this.area = 0;
                    this.points = [];
                    if (typeof points === 'string') points = points.split(' ');
                    if (!Array.isArray(points)) return this;
                    var p;
                    var y0 = Number.MAX_VALUE;
                    //  The points argument is an array, so iterate through it
                    for(var i = 0; i < points.length; i++){
                        p = {
                            x: 0,
                            y: 0
                        };
                        if (typeof points[i] === 'number' || typeof points[i] === 'string') {
                            p.x = parseFloat(points[i]);
                            p.y = parseFloat(points[i + 1]);
                            i++;
                        } else if (Array.isArray(points[i])) {
                            //  An array of arrays?
                            p.x = points[i][0];
                            p.y = points[i][1];
                        } else {
                            p.x = points[i].x;
                            p.y = points[i].y;
                        }
                        this.points.push(p);
                        //  Lowest boundary
                        if (p.y < y0) y0 = p.y;
                    }
                    this.calculateArea(y0);
                    return this;
                },
                /**
     * Calculates the area of the Polygon. This is available in the property Polygon.area
     *
     * @method Phaser.Geom.Polygon#calculateArea
     * @since 3.0.0
     *
     * @return {number} The area of the polygon.
     */ calculateArea: function() {
                    if (this.points.length < 3) {
                        this.area = 0;
                        return this.area;
                    }
                    var sum = 0;
                    var p1;
                    var p2;
                    for(var i = 0; i < this.points.length - 1; i++){
                        p1 = this.points[i];
                        p2 = this.points[i + 1];
                        sum += (p2.x - p1.x) * (p1.y + p2.y);
                    }
                    p1 = this.points[0];
                    p2 = this.points[this.points.length - 1];
                    sum += (p1.x - p2.x) * (p2.y + p1.y);
                    this.area = -sum * 0.5;
                    return this.area;
                },
                /**
     * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
     * based on the given quantity or stepRate values.
     *
     * @method Phaser.Geom.Polygon#getPoints
     * @since 3.12.0
     *
     * @generic {Phaser.Geom.Point[]} O - [output,$return]
     *
     * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
     * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
     *
     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the perimeter of the Polygon.
     */ getPoints: function(quantity, step, output) {
                    return GetPoints(this, quantity, step, output);
                }
            });
            module1.exports = Polygon;
        /***/ },
        /* 225 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Checks whether the x and y coordinates are contained within this polygon.
            //  Adapted from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html by Jonas Raoni Soares Silva
            /**
 * Checks if a point is within the bounds of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Contains
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check against.
 * @param {number} x - The X coordinate of the point to check.
 * @param {number} y - The Y coordinate of the point to check.
 *
 * @return {boolean} `true` if the point is within the bounds of the Polygon, otherwise `false`.
 */ var Contains = function(polygon, x, y) {
                var inside = false;
                for(var i = -1, j = polygon.points.length - 1; ++i < polygon.points.length; j = i){
                    var ix = polygon.points[i].x;
                    var iy = polygon.points[i].y;
                    var jx = polygon.points[j].x;
                    var jy = polygon.points[j].y;
                    if ((iy <= y && y < jy || jy <= y && y < iy) && x < (jx - ix) * (y - iy) / (jy - iy) + ix) inside = !inside;
                }
                return inside;
            };
            module1.exports = Contains;
        /***/ },
        /* 226 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Extend = __webpack_require__(17);
            var SetValue = __webpack_require__(472);
            var ShaderRender = __webpack_require__(1170);
            var TransformMatrix = __webpack_require__(25);
            /**
 * @classdesc
 * A Shader Game Object.
 *
 * This Game Object allows you to easily add a quad with its own shader into the display list, and manipulate it
 * as you would any other Game Object, including scaling, rotating, positioning and adding to Containers. Shaders
 * can be masked with either Bitmap or Geometry masks and can also be used as a Bitmap Mask for a Camera or other
 * Game Object. They can also be made interactive and used for input events.
 *
 * It works by taking a reference to a `Phaser.Display.BaseShader` instance, as found in the Shader Cache. These can
 * be created dynamically at runtime, or loaded in via the GLSL File Loader:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('fire', 'shaders/fire.glsl.js');
 * }
 *
 * function create ()
 * {
 *     this.add.shader('fire', 400, 300, 512, 512);
 * }
 * ```
 *
 * Please see the Phaser 3 Examples GitHub repo for examples of loading and creating shaders dynamically.
 *
 * Due to the way in which they work, you cannot directly change the alpha or blend mode of a Shader. This should
 * be handled via exposed uniforms in the shader code itself.
 *
 * By default a Shader will be created with a standard set of uniforms. These were added to match those
 * found on sites such as ShaderToy or GLSLSandbox, and provide common functionality a shader may need,
 * such as the timestamp, resolution or pointer position. You can replace them by specifying your own uniforms
 * in the Base Shader.
 *
 * These Shaders work by halting the current pipeline during rendering, creating a viewport matched to the
 * size of this Game Object and then renders a quad using the bound shader. At the end, the pipeline is restored.
 *
 * Because it blocks the pipeline it means it will interrupt any batching that is currently going on, so you should
 * use these Game Objects sparingly. If you need to have a fully batched custom shader, then please look at using
 * a custom pipeline instead. However, for background or special masking effects, they are extremely effective.
 *
 * @class Shader
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the Game Object.
 * @param {number} [height=128] - The height of the Game Object.
 * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
 * @param {any} [textureData] - Additional texture data if you want to create shader with none NPOT textures.
 */ var Shader = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.ComputedSize,
                    Components.Depth,
                    Components.GetBounds,
                    Components.Mask,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    ShaderRender
                ],
                initialize: function Shader(scene, key, x, y, width, height, textures, textureData) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    GameObject.call(this, scene, 'Shader');
                    /**
         * This Game Object cannot have a blend mode, so skip all checks.
         *
         * @name Phaser.GameObjects.Shader#blendMode
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.blendMode = -1;
                    /**
         * The underlying shader object being used.
         * Empty by default and set during a call to the `setShader` method.
         *
         * @name Phaser.GameObjects.Shader#shader
         * @type {Phaser.Display.BaseShader}
         * @since 3.17.0
         */ this.shader;
                    var renderer = scene.sys.renderer;
                    /**
         * A reference to the current renderer.
         * Shaders only work with the WebGL Renderer.
         *
         * @name Phaser.GameObjects.Shader#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.17.0
         */ this.renderer = renderer;
                    /**
         * The WebGL context belonging to the renderer.
         *
         * @name Phaser.GameObjects.Shader#gl
         * @type {WebGLRenderingContext}
         * @since 3.17.0
         */ this.gl = renderer.gl;
                    /**
         * Raw byte buffer of vertices this Shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexData
         * @type {ArrayBuffer}
         * @since 3.17.0
         */ this.vertexData = new ArrayBuffer(6 * (Float32Array.BYTES_PER_ELEMENT * 2));
                    /**
         * The WebGL vertex buffer object this shader uses.
         *
         * @name Phaser.GameObjects.Shader#vertexBuffer
         * @type {WebGLBuffer}
         * @since 3.17.0
         */ this.vertexBuffer = renderer.createVertexBuffer(this.vertexData.byteLength, this.gl.STREAM_DRAW);
                    /**
         * The WebGL shader program this shader uses.
         *
         * @name Phaser.GameObjects.Shader#program
         * @type {WebGLProgram}
         * @since 3.17.0
         */ this.program = null;
                    /**
         * Uint8 view to the vertex raw buffer. Used for uploading vertex buffer resources to the GPU.
         *
         * @name Phaser.GameObjects.Shader#bytes
         * @type {Uint8Array}
         * @since 3.17.0
         */ this.bytes = new Uint8Array(this.vertexData);
                    /**
         * Float32 view of the array buffer containing the shaders vertices.
         *
         * @name Phaser.GameObjects.Shader#vertexViewF32
         * @type {Float32Array}
         * @since 3.17.0
         */ this.vertexViewF32 = new Float32Array(this.vertexData);
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.GameObjects.Shader#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.17.0
         */ this._tempMatrix3 = new TransformMatrix();
                    /**
         * The view matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#viewMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.viewMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The projection matrix the shader uses during rendering.
         *
         * @name Phaser.GameObjects.Shader#projectionMatrix
         * @type {Float32Array}
         * @readonly
         * @since 3.17.0
         */ this.projectionMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * The default uniform mappings. These can be added to (or replaced) by specifying your own uniforms when
         * creating this shader game object. The uniforms are updated automatically during the render step.
         *
         * The defaults are:
         *
         * `resolution` (2f) - Set to the size of this shader.
         * `time` (1f) - The elapsed game time, in seconds.
         * `mouse` (2f) - If a pointer has been bound (with `setPointer`), this uniform contains its position each frame.
         * `date` (4fv) - A vec4 containing the year, month, day and time in seconds.
         * `sampleRate` (1f) - Sound sample rate. 44100 by default.
         * `iChannel0...3` (sampler2D) - Input channels 0 to 3. `null` by default.
         *
         * @name Phaser.GameObjects.Shader#uniforms
         * @type {any}
         * @since 3.17.0
         */ this.uniforms = {};
                    /**
         * The pointer bound to this shader, if any.
         * Set via the chainable `setPointer` method, or by modifying this property directly.
         *
         * @name Phaser.GameObjects.Shader#pointer
         * @type {Phaser.Input.Pointer}
         * @since 3.17.0
         */ this.pointer = null;
                    /**
         * The cached width of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererWidth
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererWidth = renderer.width;
                    /**
         * The cached height of the renderer.
         *
         * @name Phaser.GameObjects.Shader#_rendererHeight
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._rendererHeight = renderer.height;
                    /**
         * Internal texture count tracker.
         *
         * @name Phaser.GameObjects.Shader#_textureCount
         * @type {number}
         * @private
         * @since 3.17.0
         */ this._textureCount = 0;
                    /**
         * A reference to the GL Frame Buffer this Shader is drawing to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#framebuffer
         * @type {?WebGLFramebuffer}
         * @since 3.19.0
         */ this.framebuffer = null;
                    /**
         * A reference to the WebGLTexture this Shader is rendering to.
         * This property is only set if you have called `Shader.setRenderToTexture`.
         *
         * @name Phaser.GameObjects.Shader#glTexture
         * @type {?WebGLTexture}
         * @since 3.19.0
         */ this.glTexture = null;
                    /**
         * A flag that indicates if this Shader has been set to render to a texture instead of the display list.
         *
         * This property is `true` if you have called `Shader.setRenderToTexture`, otherwise it's `false`.
         *
         * A Shader that is rendering to a texture _does not_ appear on the display list.
         *
         * @name Phaser.GameObjects.Shader#renderToTexture
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.renderToTexture = false;
                    /**
         * A reference to the Phaser.Textures.Texture that has been stored in the Texture Manager for this Shader.
         *
         * This property is only set if you have called `Shader.setRenderToTexture`, otherwise it is `null`.
         *
         * @name Phaser.GameObjects.Shader#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.19.0
         */ this.texture = null;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setOrigin(0.5, 0.5);
                    this.setShader(key, textures, textureData);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Shader#willRender
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    if (this.renderToTexture) return true;
                    else return !(GameObject.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Changes this Shader so instead of rendering to the display list it renders to a
     * WebGL Framebuffer and WebGL Texture instead. This allows you to use the output
     * of this shader as an input for another shader, by mapping a sampler2D uniform
     * to it.
     *
     * After calling this method the `Shader.framebuffer` and `Shader.glTexture` properties
     * are populated.
     *
     * Additionally, you can provide a key to this method. Doing so will create a Phaser Texture
     * from this Shader and save it into the Texture Manager, allowing you to then use it for
     * any texture-based Game Object, such as a Sprite or Image:
     *
     * ```javascript
     * var shader = this.add.shader('myShader', x, y, width, height);
     *
     * shader.setRenderToTexture('doodle');
     *
     * this.add.image(400, 300, 'doodle');
     * ```
     *
     * Note that it stores an active reference to this Shader. That means as this shader updates,
     * so does the texture and any object using it to render with. Also, if you destroy this
     * shader, be sure to clear any objects that may have been using it as a texture too.
     *
     * You can access the Phaser Texture that is created via the `Shader.texture` property.
     *
     * By default it will create a single base texture. You can add frames to the texture
     * by using the `Texture.add` method. After doing this, you can then allow Game Objects
     * to use a specific frame from a Render Texture.
     *
     * @method Phaser.GameObjects.Shader#setRenderToTexture
     * @since 3.19.0
     *
     * @param {string} [key] - The unique key to store the texture as within the global Texture Manager.
     * @param {boolean} [flipY=false] - Does this texture need vertically flipping before rendering? This should usually be set to `true` if being fed from a buffer.
     *
     * @return {this} This Shader instance.
     */ setRenderToTexture: function(key, flipY) {
                    if (flipY === undefined) flipY = false;
                    if (!this.renderToTexture) {
                        var width = this.width;
                        var height = this.height;
                        var renderer = this.renderer;
                        this.glTexture = renderer.createTextureFromSource(null, width, height, 0);
                        this.glTexture.flipY = flipY;
                        this.framebuffer = renderer.createFramebuffer(width, height, this.glTexture, false);
                        this._rendererWidth = width;
                        this._rendererHeight = height;
                        this.renderToTexture = true;
                        this.projOrtho(0, this.width, this.height, 0);
                        if (key) this.texture = this.scene.sys.textures.addGLTexture(key, this.glTexture, width, height);
                    }
                    //  And now render at least once, so our texture isn't blank on the first update
                    if (this.shader) {
                        renderer.pipelines.clear();
                        this.load();
                        this.flush();
                        renderer.pipelines.rebind();
                    }
                    return this;
                },
                /**
     * Sets the fragment and, optionally, the vertex shader source code that this Shader will use.
     * This will immediately delete the active shader program, if set, and then create a new one
     * with the given source. Finally, the shader uniforms are initialized.
     *
     * @method Phaser.GameObjects.Shader#setShader
     * @since 3.17.0
     *
     * @param {(string|Phaser.Display.BaseShader)} key - The key of the shader to use from the shader cache, or a BaseShader instance.
     * @param {string[]} [textures] - Optional array of texture keys to bind to the iChannel0...3 uniforms. The textures must already exist in the Texture Manager.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setShader: function(key, textures, textureData) {
                    if (textures === undefined) textures = [];
                    if (typeof key === 'string') {
                        var cache = this.scene.sys.cache.shader;
                        if (!cache.has(key)) {
                            console.warn('Shader missing: ' + key);
                            return this;
                        }
                        this.shader = cache.get(key);
                    } else this.shader = key;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    if (this.program) gl.deleteProgram(this.program);
                    var program = renderer.createProgram(this.shader.vertexSrc, this.shader.fragmentSrc);
                    //  The default uniforms available within the vertex shader
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, 'uViewMatrix'), false, this.viewMatrix);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, 'uProjectionMatrix'), false, this.projectionMatrix);
                    gl.uniform2f(gl.getUniformLocation(program, 'uResolution'), this.width, this.height);
                    this.program = program;
                    var d = new Date();
                    //  The default uniforms available within the fragment shader
                    var defaultUniforms = {
                        resolution: {
                            type: '2f',
                            value: {
                                x: this.width,
                                y: this.height
                            }
                        },
                        time: {
                            type: '1f',
                            value: 0
                        },
                        mouse: {
                            type: '2f',
                            value: {
                                x: this.width / 2,
                                y: this.height / 2
                            }
                        },
                        date: {
                            type: '4fv',
                            value: [
                                d.getFullYear(),
                                d.getMonth(),
                                d.getDate(),
                                d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds()
                            ]
                        },
                        sampleRate: {
                            type: '1f',
                            value: 44100.0
                        },
                        iChannel0: {
                            type: 'sampler2D',
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel1: {
                            type: 'sampler2D',
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel2: {
                            type: 'sampler2D',
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        },
                        iChannel3: {
                            type: 'sampler2D',
                            value: null,
                            textureData: {
                                repeat: true
                            }
                        }
                    };
                    if (this.shader.uniforms) this.uniforms = Extend(true, {}, this.shader.uniforms, defaultUniforms);
                    else this.uniforms = defaultUniforms;
                    for(var i = 0; i < 4; i++)if (textures[i]) this.setSampler2D('iChannel' + i, textures[i], i, textureData);
                    this.initUniforms();
                    this.projOrtho(0, this._rendererWidth, this._rendererHeight, 0);
                    return this;
                },
                /**
     * Binds a Phaser Pointer object to this Shader.
     *
     * The screen position of the pointer will be set in to the shaders `mouse` uniform
     * automatically every frame. Call this method with no arguments to unbind the pointer.
     *
     * @method Phaser.GameObjects.Shader#setPointer
     * @since 3.17.0
     *
     * @param {Phaser.Input.Pointer} [pointer] - The Pointer to bind to this shader.
     *
     * @return {this} This Shader instance.
     */ setPointer: function(pointer) {
                    this.pointer = pointer;
                    return this;
                },
                /**
     * Sets this shader to use an orthographic projection matrix.
     * This matrix is stored locally in the `projectionMatrix` property,
     * as well as being bound to the `uProjectionMatrix` uniform.
     *
     * @method Phaser.GameObjects.Shader#projOrtho
     * @since 3.17.0
     *
     * @param {number} left - The left value.
     * @param {number} right - The right value.
     * @param {number} bottom - The bottom value.
     * @param {number} top - The top value.
     */ projOrtho: function(left, right, bottom, top) {
                    var near = -1000;
                    var far = 1000;
                    var leftRight = 1 / (left - right);
                    var bottomTop = 1 / (bottom - top);
                    var nearFar = 1 / (near - far);
                    var pm = this.projectionMatrix;
                    pm[0] = -2 * leftRight;
                    pm[5] = -2 * bottomTop;
                    pm[10] = 2 * nearFar;
                    pm[12] = (left + right) * leftRight;
                    pm[13] = (top + bottom) * bottomTop;
                    pm[14] = (far + near) * nearFar;
                    var program = this.program;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    renderer.setProgram(program);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, 'uProjectionMatrix'), false, this.projectionMatrix);
                    this._rendererWidth = right;
                    this._rendererHeight = bottom;
                },
                // Uniforms are specified in the GLSL_ES Specification: http://www.khronos.org/registry/webgl/specs/latest/1.0/
                // http://www.khronos.org/registry/gles/specs/2.0/GLSL_ES_Specification_1.0.17.pdf
                /**
     * Initializes all of the uniforms this shader uses.
     *
     * @method Phaser.GameObjects.Shader#initUniforms
     * @private
     * @since 3.17.0
     */ initUniforms: function() {
                    var gl = this.gl;
                    var map = this.renderer.glFuncMap;
                    var program = this.program;
                    this._textureCount = 0;
                    for(var key in this.uniforms){
                        var uniform = this.uniforms[key];
                        var type = uniform.type;
                        var data = map[type];
                        uniform.uniformLocation = gl.getUniformLocation(program, key);
                        if (type !== 'sampler2D') {
                            uniform.glMatrix = data.matrix;
                            uniform.glValueLength = data.length;
                            uniform.glFunc = data.func;
                        }
                    }
                },
                /**
     * Sets a sampler2D uniform on this shader where the source texture is a WebGLTexture.
     *
     * This allows you to feed the output from one Shader into another:
     *
     * ```javascript
     * let shader1 = this.add.shader(baseShader1, 0, 0, 512, 512).setRenderToTexture();
     * let shader2 = this.add.shader(baseShader2, 0, 0, 512, 512).setRenderToTexture('output');
     *
     * shader1.setSampler2DBuffer('iChannel0', shader2.glTexture, 512, 512);
     * shader2.setSampler2DBuffer('iChannel0', shader1.glTexture, 512, 512);
     * ```
     *
     * In the above code, the result of baseShader1 is fed into Shader2 as the `iChannel0` sampler2D uniform.
     * The result of baseShader2 is then fed back into shader1 again, creating a feedback loop.
     *
     * If you wish to use an image from the Texture Manager as a sampler2D input for this shader,
     * see the `Shader.setSampler2D` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2DBuffer
     * @since 3.19.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {WebGLTexture} texture - A WebGLTexture reference.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2DBuffer: function(uniformKey, texture, width, height, textureIndex, textureData) {
                    if (textureIndex === undefined) textureIndex = 0;
                    if (textureData === undefined) textureData = {};
                    var uniform = this.uniforms[uniformKey];
                    uniform.value = texture;
                    textureData.width = width;
                    textureData.height = height;
                    uniform.textureData = textureData;
                    this._textureCount = textureIndex;
                    this.initSampler2D(uniform);
                    return this;
                },
                /**
     * Sets a sampler2D uniform on this shader.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * If you wish to use another Shader as a sampler2D input for this shader, see the `Shader.setSampler2DBuffer` method.
     *
     * @method Phaser.GameObjects.Shader#setSampler2D
     * @since 3.17.0
     *
     * @param {string} uniformKey - The key of the sampler2D uniform to be updated, i.e. `iChannel0`.
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {number} [textureIndex=0] - The texture index.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setSampler2D: function(uniformKey, textureKey, textureIndex, textureData) {
                    if (textureIndex === undefined) textureIndex = 0;
                    var textureManager = this.scene.sys.textures;
                    if (textureManager.exists(textureKey)) {
                        var frame = textureManager.getFrame(textureKey);
                        if (frame.glTexture && frame.glTexture.isRenderTexture) return this.setSampler2DBuffer(uniformKey, frame.glTexture, frame.width, frame.height, textureIndex, textureData);
                        var uniform = this.uniforms[uniformKey];
                        var source = frame.source;
                        uniform.textureKey = textureKey;
                        uniform.source = source.image;
                        uniform.value = frame.glTexture;
                        if (source.isGLTexture) {
                            if (!textureData) textureData = {};
                            textureData.width = source.width;
                            textureData.height = source.height;
                        }
                        if (textureData) uniform.textureData = textureData;
                        this._textureCount = textureIndex;
                        this.initSampler2D(uniform);
                    }
                    return this;
                },
                /**
     * Sets a property of a uniform already present on this shader.
     *
     * To modify the value of a uniform such as a 1f or 1i use the `value` property directly:
     *
     * ```javascript
     * shader.setUniform('size.value', 16);
     * ```
     *
     * You can use dot notation to access deeper values, for example:
     *
     * ```javascript
     * shader.setUniform('resolution.value.x', 512);
     * ```
     *
     * The change to the uniform will take effect the next time the shader is rendered.
     *
     * @method Phaser.GameObjects.Shader#setUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to modify. Use dots for deep properties, i.e. `resolution.value.x`.
     * @param {any} value - The value to set into the uniform.
     *
     * @return {this} This Shader instance.
     */ setUniform: function(key, value) {
                    SetValue(this.uniforms, key, value);
                    return this;
                },
                /**
     * Returns the uniform object for the given key, or `null` if the uniform couldn't be found.
     *
     * @method Phaser.GameObjects.Shader#getUniform
     * @since 3.17.0
     *
     * @param {string} key - The key of the uniform to return the value for.
     *
     * @return {any} A reference to the uniform object. This is not a copy, so modifying it will update the original object also.
     */ getUniform: function(key) {
                    return GetFastValue(this.uniforms, key, null);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel0` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel0
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel0: function(textureKey, textureData) {
                    return this.setSampler2D('iChannel0', textureKey, 0, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel1` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel1
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel1: function(textureKey, textureData) {
                    return this.setSampler2D('iChannel1', textureKey, 1, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel2` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel2
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel2: function(textureKey, textureData) {
                    return this.setSampler2D('iChannel2', textureKey, 2, textureData);
                },
                /**
     * A short-cut method that will directly set the texture being used by the `iChannel3` sampler2D uniform.
     *
     * The textureKey given is the key from the Texture Manager cache. You cannot use a single frame
     * from a texture, only the full image. Also, lots of shaders expect textures to be power-of-two sized.
     *
     * @method Phaser.GameObjects.Shader#setChannel3
     * @since 3.17.0
     *
     * @param {string} textureKey - The key of the texture, as stored in the Texture Manager. Must already be loaded.
     * @param {any} [textureData] - Additional texture data.
     *
     * @return {this} This Shader instance.
     */ setChannel3: function(textureKey, textureData) {
                    return this.setSampler2D('iChannel3', textureKey, 3, textureData);
                },
                /**
     * Internal method that takes a sampler2D uniform and prepares it for use by setting the
     * gl texture parameters.
     *
     * @method Phaser.GameObjects.Shader#initSampler2D
     * @private
     * @since 3.17.0
     *
     * @param {any} uniform - The sampler2D uniform to process.
     */ initSampler2D: function(uniform) {
                    if (!uniform.value) return;
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE0 + this._textureCount);
                    gl.bindTexture(gl.TEXTURE_2D, uniform.value);
                    //  Extended texture data
                    var data = uniform.textureData;
                    if (data && !uniform.value.isRenderTexture) {
                        // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/texImage2D
                        //  mag / minFilter can be: gl.LINEAR, gl.LINEAR_MIPMAP_LINEAR or gl.NEAREST
                        //  wrapS/T can be: gl.CLAMP_TO_EDGE or gl.REPEAT
                        //  format can be: gl.LUMINANCE or gl.RGBA
                        var magFilter = gl[GetFastValue(data, 'magFilter', 'linear').toUpperCase()];
                        var minFilter = gl[GetFastValue(data, 'minFilter', 'linear').toUpperCase()];
                        var wrapS = gl[GetFastValue(data, 'wrapS', 'repeat').toUpperCase()];
                        var wrapT = gl[GetFastValue(data, 'wrapT', 'repeat').toUpperCase()];
                        var format = gl[GetFastValue(data, 'format', 'rgba').toUpperCase()];
                        if (data.repeat) {
                            wrapS = gl.REPEAT;
                            wrapT = gl.REPEAT;
                        }
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, !!data.flipY);
                        if (data.width) {
                            var width = GetFastValue(data, 'width', 512);
                            var height = GetFastValue(data, 'height', 2);
                            var border = GetFastValue(data, 'border', 0);
                            //  texImage2D(GLenum target, GLint level, GLenum internalformat, GLsizei width, GLsizei height, GLint border, GLenum format, GLenum type, ArrayBufferView? pixels)
                            gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, border, format, gl.UNSIGNED_BYTE, null);
                        } else //  texImage2D(GLenum target, GLint level, GLenum internalformat, GLenum format, GLenum type, ImageData? pixels)
                        gl.texImage2D(gl.TEXTURE_2D, 0, format, gl.RGBA, gl.UNSIGNED_BYTE, uniform.source);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
                    }
                    this.renderer.setProgram(this.program);
                    gl.uniform1i(uniform.uniformLocation, this._textureCount);
                    this._textureCount++;
                },
                /**
     * Synchronizes all of the uniforms this shader uses.
     * Each uniforms gl function is called in turn.
     *
     * @method Phaser.GameObjects.Shader#syncUniforms
     * @private
     * @since 3.17.0
     */ syncUniforms: function() {
                    var gl = this.gl;
                    var uniforms = this.uniforms;
                    var uniform;
                    var length;
                    var glFunc;
                    var location;
                    var value;
                    var textureCount = 0;
                    for(var key in uniforms){
                        uniform = uniforms[key];
                        glFunc = uniform.glFunc;
                        length = uniform.glValueLength;
                        location = uniform.uniformLocation;
                        value = uniform.value;
                        if (value === null) continue;
                        if (length === 1) {
                            if (uniform.glMatrix) glFunc.call(gl, location, uniform.transpose, value);
                            else glFunc.call(gl, location, value);
                        } else if (length === 2) glFunc.call(gl, location, value.x, value.y);
                        else if (length === 3) glFunc.call(gl, location, value.x, value.y, value.z);
                        else if (length === 4) glFunc.call(gl, location, value.x, value.y, value.z, value.w);
                        else if (uniform.type === 'sampler2D') {
                            gl.activeTexture(gl.TEXTURE0 + textureCount);
                            gl.bindTexture(gl.TEXTURE_2D, value);
                            gl.uniform1i(location, textureCount);
                            textureCount++;
                        }
                    }
                },
                /**
     * Called automatically during render.
     *
     * This method performs matrix ITRS and then stores the resulting value in the `uViewMatrix` uniform.
     * It then sets up the vertex buffer and shader, updates and syncs the uniforms ready
     * for flush to be called.
     *
     * @method Phaser.GameObjects.Shader#load
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [matrix2D] - The transform matrix to use during rendering.
     */ load: function(matrix2D) {
                    //  ITRS
                    var gl = this.gl;
                    var width = this.width;
                    var height = this.height;
                    var renderer = this.renderer;
                    var program = this.program;
                    var vm = this.viewMatrix;
                    if (!this.renderToTexture) {
                        var x = -this._displayOriginX;
                        var y = -this._displayOriginY;
                        vm[0] = matrix2D[0];
                        vm[1] = matrix2D[1];
                        vm[4] = matrix2D[2];
                        vm[5] = matrix2D[3];
                        vm[8] = matrix2D[4];
                        vm[9] = matrix2D[5];
                        vm[12] = vm[0] * x + vm[4] * y;
                        vm[13] = vm[1] * x + vm[5] * y;
                    }
                    //  Update vertex shader uniforms
                    gl.useProgram(program);
                    gl.uniformMatrix4fv(gl.getUniformLocation(program, 'uViewMatrix'), false, vm);
                    gl.uniform2f(gl.getUniformLocation(program, 'uResolution'), this.width, this.height);
                    //  Update fragment shader uniforms
                    var uniforms = this.uniforms;
                    var res = uniforms.resolution;
                    res.value.x = width;
                    res.value.y = height;
                    uniforms.time.value = renderer.game.loop.getDuration();
                    var pointer = this.pointer;
                    if (pointer) {
                        var mouse = uniforms.mouse;
                        var px = pointer.x / width;
                        var py = 1 - pointer.y / height;
                        mouse.value.x = px.toFixed(2);
                        mouse.value.y = py.toFixed(2);
                    }
                    this.syncUniforms();
                },
                /**
     * Called automatically during render.
     *
     * Sets the active shader, loads the vertex buffer and then draws.
     *
     * @method Phaser.GameObjects.Shader#flush
     * @since 3.17.0
     */ flush: function() {
                    //  Bind
                    var width = this.width;
                    var height = this.height;
                    var program = this.program;
                    var gl = this.gl;
                    var vertexBuffer = this.vertexBuffer;
                    var renderer = this.renderer;
                    var vertexSize = Float32Array.BYTES_PER_ELEMENT * 2;
                    if (this.renderToTexture) {
                        renderer.setFramebuffer(this.framebuffer);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
                    var location = gl.getAttribLocation(program, 'inPosition');
                    if (location !== -1) {
                        gl.enableVertexAttribArray(location);
                        gl.vertexAttribPointer(location, 2, gl.FLOAT, false, vertexSize, 0);
                    }
                    //  Draw
                    var vf = this.vertexViewF32;
                    vf[3] = height;
                    vf[4] = width;
                    vf[5] = height;
                    vf[8] = width;
                    vf[9] = height;
                    vf[10] = width;
                    //  Flush
                    var vertexCount = 6;
                    gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
                    gl.drawArrays(gl.TRIANGLES, 0, vertexCount);
                    if (this.renderToTexture) renderer.setFramebuffer(null, false);
                },
                /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setAlpha
     * @private
     * @since 3.17.0
     */ setAlpha: function() {},
                /**
     * A NOOP method so you can pass a Shader to a Container.
     * Calling this method will do nothing. It is intentionally empty.
     *
     * @method Phaser.GameObjects.Shader#setBlendMode
     * @private
     * @since 3.17.0
     */ setBlendMode: function() {},
                /**
     * Internal destroy handler, called as part of the destroy process.
     *
     * @method Phaser.GameObjects.Shader#preDestroy
     * @protected
     * @since 3.17.0
     */ preDestroy: function() {
                    var gl = this.gl;
                    gl.deleteProgram(this.program);
                    gl.deleteBuffer(this.vertexBuffer);
                    if (this.renderToTexture) {
                        this.renderer.deleteFramebuffer(this.framebuffer);
                        this.texture.destroy();
                        this.framebuffer = null;
                        this.glTexture = null;
                        this.texture = null;
                    }
                }
            });
            module1.exports = Shader;
        /***/ },
        /* 227 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DegToRad = __webpack_require__(35);
            var Face = __webpack_require__(113);
            var GameObject = __webpack_require__(15);
            var GenerateVerts = __webpack_require__(473);
            var GenerateObjVerts = __webpack_require__(474);
            var GetCalcMatrix = __webpack_require__(19);
            var Matrix4 = __webpack_require__(67);
            var MeshRender = __webpack_require__(1173);
            var StableSort = __webpack_require__(79);
            var Vector3 = __webpack_require__(38);
            var Vertex = __webpack_require__(115);
            /**
 * @classdesc
 * A Mesh Game Object.
 *
 * The Mesh Game Object allows you to render a group of textured vertices and manipulate
 * the view of those vertices, such as rotation, translation or scaling.
 *
 * Support for generating mesh data from grids, model data or Wavefront OBJ Files is included.
 *
 * Although you can use this to render 3D objects, its primary use is for displaying more complex
 * Sprites, or Sprites where you need fine-grained control over the vertex positions in order to
 * achieve special effects in your games. Note that rendering still takes place using Phaser's
 * orthographic camera (after being transformed via `projectionMesh`, see `setPerspective`,
 * `setOrtho`, and `panZ` methods). As a result, all depth and face tests are done in an eventually
 * orthographic space.
 *
 * The rendering process will iterate through the faces of this Mesh and render out each face
 * that is considered as being in view of the camera. No depth buffer is used, and because of this,
 * you should be careful not to use model data with too many vertices, or overlapping geometry,
 * or you'll probably encounter z-depth fighting. The Mesh was designed to allow for more advanced
 * 2D layouts, rather than displaying 3D objects, even though it can do this to a degree.
 *
 * In short, if you want to remake Crysis, use a 3D engine, not a Mesh. However, if you want
 * to easily add some small fun 3D elements into your game, or create some special effects involving
 * vertex warping, this is the right object for you. Mesh data becomes part of the WebGL batch,
 * just like standard Sprites, so doesn't introduce any additional shader overhead. Because
 * the Mesh just generates vertices into the WebGL batch, like any other Sprite, you can use all of
 * the common Game Object components on a Mesh too, such as a custom pipeline, mask, blend mode
 * or texture.
 *
 * Note that the Mesh object is WebGL only and does not have a Canvas counterpart.
 *
 * The Mesh origin is always 0.5 x 0.5 and cannot be changed.
 *
 * @class Mesh
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @webglOnly
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 * @extends Phaser.GameObjects.Components.ScrollFactor
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x] - The horizontal position of this Game Object in the world.
 * @param {number} [y] - The vertical position of this Game Object in the world.
 * @param {string|Phaser.Textures.Texture} [texture] - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {string|number} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {number[]} [vertices] - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true` (but see note).
 * @param {number[]} [uvs] - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? Note: If not, it will be assumed `z=0`, see method `panZ` or `setOrtho`.
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 */ var Mesh = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Mask,
                    Components.Pipeline,
                    Components.Size,
                    Components.Texture,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    MeshRender
                ],
                initialize: function Mesh(scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (texture === undefined) texture = '__WHITE';
                    GameObject.call(this, scene, 'Mesh');
                    /**
         * An array containing the Face instances belonging to this Mesh.
         *
         * A Face consists of 3 Vertex objects.
         *
         * This array is populated during calls such as `addVertices` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#faces
         * @type {Phaser.Geom.Mesh.Face[]}
         * @since 3.50.0
         */ this.faces = [];
                    /**
         * An array containing Vertex instances. One instance per vertex in this Mesh.
         *
         * This array is populated during calls such as `addVertex` or `addOBJ`.
         *
         * @name Phaser.GameObjects.Mesh#vertices
         * @type {Phaser.Geom.Mesh.Vertex[]}
         * @since 3.50.0
         */ this.vertices = [];
                    /**
         * The tint fill mode.
         *
         * `false` = An additive tint (the default), where vertices colors are blended with the texture.
         * `true` = A fill tint, where the vertex colors replace the texture, but respects texture alpha.
         *
         * @name Phaser.GameObjects.Mesh#tintFill
         * @type {boolean}
         * @default false
         * @since 3.50.0
         */ this.tintFill = false;
                    /**
         * You can optionally choose to render the vertices of this Mesh to a Graphics instance.
         *
         * Achieve this by setting the `debugCallback` and the `debugGraphic` properties.
         *
         * You can do this in a single call via the `Mesh.setDebug` method, which will use the
         * built-in debug function. You can also set it to your own callback. The callback
         * will be invoked _once per render_ and sent the following parameters:
         *
         * `debugCallback(src, meshLength, verts)`
         *
         * `src` is the Mesh instance being debugged.
         * `meshLength` is the number of mesh vertices in total.
         * `verts` is an array of the translated vertex coordinates.
         *
         * To disable rendering, set this property back to `null`.
         *
         * Please note that high vertex count Meshes will struggle to debug properly.
         *
         * @name Phaser.GameObjects.Mesh#debugCallback
         * @type {function}
         * @since 3.50.0
         */ this.debugCallback = null;
                    /**
         * The Graphics instance that the debug vertices will be drawn to, if `setDebug` has
         * been called.
         *
         * @name Phaser.GameObjects.Mesh#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.50.0
         */ this.debugGraphic = null;
                    /**
         * When rendering, skip any Face that isn't counter clockwise?
         *
         * Enable this to hide backward-facing Faces during rendering.
         *
         * Disable it to render all Faces.
         *
         * @name Phaser.GameObjects.Mesh#hideCCW
         * @type {boolean}
         * @since 3.50.0
         */ this.hideCCW = true;
                    /**
         * A Vector3 containing the 3D position of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to reposition where
         * the vertices are rendered within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * You can also adjust the 'view' by using the `pan` methods.
         *
         * @name Phaser.GameObjects.Mesh#modelPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelPosition = new Vector3();
                    /**
         * A Vector3 containing the 3D scale of the vertices in this Mesh.
         *
         * Modifying the components of this property will allow you to scale
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelScale
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelScale = new Vector3(1, 1, 1);
                    /**
         * A Vector3 containing the 3D rotation of the vertices in this Mesh.
         *
         * The values should be given in radians, i.e. to rotate the vertices by 90
         * degrees you can use `modelRotation.x = Phaser.Math.DegToRad(90)`.
         *
         * Modifying the components of this property will allow you to rotate
         * the vertices within the Mesh. This happens in the `preUpdate` phase,
         * where each vertex is transformed using the view and projection matrices.
         *
         * Changing this property will impact all vertices being rendered by this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#modelRotation
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.modelRotation = new Vector3();
                    /**
         * An internal cache, used to compare position, rotation, scale and face data
         * each frame, to avoid math calculations in `preUpdate`.
         *
         * Cache structure = position xyz | rotation xyz | scale xyz | face count | view | ortho
         *
         * @name Phaser.GameObjects.Mesh#dirtyCache
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.dirtyCache = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * The transformation matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#transformMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.transformMatrix = new Matrix4();
                    /**
         * The view position for this Mesh.
         *
         * Use the methods`panX`, `panY` and `panZ` to adjust the view.
         *
         * @name Phaser.GameObjects.Mesh#viewPosition
         * @type {Phaser.Math.Vector3}
         * @since 3.50.0
         */ this.viewPosition = new Vector3();
                    /**
         * The view matrix for this Mesh.
         *
         * @name Phaser.GameObjects.Mesh#viewMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.viewMatrix = new Matrix4();
                    /**
         * The projection matrix for this Mesh.
         *
         * Update it with the `setPerspective` or `setOrtho` methods.
         *
         * @name Phaser.GameObjects.Mesh#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix = new Matrix4();
                    /**
         * How many faces were rendered by this Mesh Game Object in the last
         * draw? This is reset in the `preUpdate` method and then incremented
         * each time a face is drawn. Note that in multi-camera Scenes this
         * value may exceed that found in `Mesh.getFaceCount` due to
         * cameras drawing the same faces more than once.
         *
         * @name Phaser.GameObjects.Mesh#totalRendered
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.totalRendered = 0;
                    /**
         * Internal cache var for the total number of faces rendered this frame.
         *
         * See `totalRendered` instead for the actual value.
         *
         * @name Phaser.GameObjects.Mesh#totalFrame
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.totalFrame = 0;
                    /**
         * By default, the Mesh will check to see if its model or view transform has
         * changed each frame and only recalculate the vertex positions if they have.
         *
         * This avoids lots of additional math in the `preUpdate` step when not required.
         *
         * However, if you are performing per-Face or per-Vertex manipulation on this Mesh,
         * such as tweening a Face, or moving it without moving the rest of the Mesh,
         * then you may need to disable the dirty cache in order for the Mesh to re-render
         * correctly. You can toggle this property to do that. Please note that leaving
         * this set to `true` will cause the Mesh to recalculate the position of every single
         * vertex in it, every single frame. So only really do this if you know you
         * need it.
         *
         * @name Phaser.GameObjects.Mesh#ignoreDirtyCache
         * @type {boolean}
         * @since 3.50.0
         */ this.ignoreDirtyCache = false;
                    var renderer = scene.sys.renderer;
                    this.setPosition(x, y);
                    this.setTexture(texture, frame);
                    this.setSize(renderer.width, renderer.height);
                    this.initPipeline();
                    this.setPerspective(renderer.width, renderer.height);
                    if (vertices) this.addVertices(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Translates the view position of this Mesh on the x axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panX
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panX: function(v) {
                    this.viewPosition.addScale(Vector3.LEFT, v);
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Translates the view position of this Mesh on the y axis by the given amount.
     *
     * @method Phaser.GameObjects.Mesh#panY
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panY: function(v) {
                    this.viewPosition.y += Vector3.DOWN.y * v;
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Translates the view position of this Mesh on the z axis by the given amount.
     *
     * As the default `panZ` value is 0, vertices with `z=0` (the default) need special care or else they will not display as they are behind the camera.
     * Consider using `mesh.panZ(mesh.height / (2 * Math.tan(Math.PI / 16)))`, which will interpret vertex geometry 1:1 with pixel geometry (or see `setOrtho`).
     *
     * @method Phaser.GameObjects.Mesh#panZ
     * @since 3.50.0
     *
     * @param {number} v - The amount to pan by.
     */ panZ: function(amount) {
                    this.viewPosition.z += amount;
                    this.dirtyCache[10] = 1;
                    return this;
                },
                /**
     * Builds a new perspective projection matrix from the given values.
     *
     * These are also the initial projection matrix & parameters for `Mesh` (and see `panZ` for more discussion).
     *
     * See also `setOrtho`.
     *
     * @method Phaser.GameObjects.Mesh#setPerspective
     * @since 3.50.0
     *
     * @param {number} width - The width of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} height - The height of the projection matrix. Typically the same as the Mesh and/or Renderer.
     * @param {number} [fov=45] - The field of view, in degrees.
     * @param {number} [near=0.01] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setPerspective: function(width, height, fov, near, far) {
                    if (fov === undefined) fov = 45;
                    if (near === undefined) near = 0.01;
                    if (far === undefined) far = 1000;
                    this.projectionMatrix.perspective(DegToRad(fov), width / height, near, far);
                    this.dirtyCache[10] = 1;
                    this.dirtyCache[11] = 0;
                    return this;
                },
                /**
     * Builds a new orthographic projection matrix from the given values.
     *
     * If using this mode you will often need to set `Mesh.hideCCW` to `false` as well.
     *
     * By default, calling this method with no parameters will set the scaleX value to
     * match the renderer's aspect ratio. If you would like to render vertex positions 1:1
     * to pixel positions, consider calling as `mesh.setOrtho(mesh.width, mesh.height)`.
     *
     * See also `setPerspective`.
     *
     * @method Phaser.GameObjects.Mesh#setOrtho
     * @since 3.50.0
     *
     * @param {number} [scaleX=1] - The default horizontal scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [scaleY=1] - The default vertical scale in relation to the Mesh / Renderer dimensions.
     * @param {number} [near=-1000] - The near value of the view.
     * @param {number} [far=1000] - The far value of the view.
     */ setOrtho: function(scaleX, scaleY, near, far) {
                    if (scaleX === undefined) scaleX = this.scene.sys.renderer.getAspectRatio();
                    if (scaleY === undefined) scaleY = 1;
                    if (near === undefined) near = -1000;
                    if (far === undefined) far = 1000;
                    this.projectionMatrix.ortho(-scaleX, scaleX, -scaleY, scaleY, near, far);
                    this.dirtyCache[10] = 1;
                    this.dirtyCache[11] = 1;
                    return this;
                },
                /**
     * Iterates and destroys all current Faces in this Mesh, then resets the
     * `faces` and `vertices` arrays.
     *
     * @method Phaser.GameObjects.Mesh#clear
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ clear: function() {
                    this.faces.forEach(function(face) {
                        face.destroy();
                    });
                    this.faces = [];
                    this.vertices = [];
                    return this;
                },
                /**
     * This method will add the data from a triangulated Wavefront OBJ model file to this Mesh.
     *
     * The data should have been loaded via the OBJFile:
     *
     * ```javascript
     * this.load.obj(key, url);
     * ```
     *
     * Then use the same `key` as the first parameter to this method.
     *
     * Multiple Mesh Game Objects can use the same model data without impacting on each other.
     *
     * Make sure your 3D package has triangulated the model data prior to exporting it.
     *
     * You can add multiple models to a single Mesh, although they will act as one when
     * moved or rotated. You can scale the model data, should it be too small, or too large, to see.
     * You can also offset the vertices of the model via the `x`, `y` and `z` parameters.
     *
     * @method Phaser.GameObjects.Mesh#addVerticesFromObj
     * @since 3.50.0
     *
     * @param {string} key - The key of the model data in the OBJ Cache to add to this Mesh.
     * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
     * @param {number} [x=0] - Translate the model x position by this amount.
     * @param {number} [y=0] - Translate the model y position by this amount.
     * @param {number} [z=0] - Translate the model z position by this amount.
     * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
     * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
     * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
     * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
     *
     * @return {this} This Mesh Game Object.
     */ addVerticesFromObj: function(key, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                    var data = this.scene.sys.cache.obj.get(key);
                    if (data) GenerateObjVerts(data, this, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp);
                    return this;
                },
                /**
     * Compare the depth of two Faces.
     *
     * @method Phaser.GameObjects.Mesh#sortByDepth
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Face} faceA - The first Face.
     * @param {Phaser.Geom.Mesh.Face} faceB - The second Face.
     *
     * @return {number} The difference between the depths of each Face.
     */ sortByDepth: function(faceA, faceB) {
                    return faceA.depth - faceB.depth;
                },
                /**
     * Runs a depth sort across all Faces in this Mesh, comparing their averaged depth.
     *
     * This is called automatically if you use any of the `rotate` methods, but you can
     * also invoke it to sort the Faces should you manually position them.
     *
     * @method Phaser.GameObjects.Mesh#depthSort
     * @since 3.50.0
     *
     * @return {this} This Mesh Game Object.
     */ depthSort: function() {
                    StableSort(this.faces, this.sortByDepth);
                    return this;
                },
                /**
     * Adds a new Vertex into the vertices array of this Mesh.
     *
     * Just adding a vertex isn't enough to render it. You need to also
     * make it part of a Face, with 3 Vertex instances per Face.
     *
     * @method Phaser.GameObjects.Mesh#addVertex
     * @since 3.50.0
     *
     * @param {number} x - The x position of the vertex.
     * @param {number} y - The y position of the vertex.
     * @param {number} z - The z position of the vertex.
     * @param {number} u - The UV u coordinate of the vertex.
     * @param {number} v - The UV v coordinate of the vertex.
     * @param {number} [color=0xffffff] - The color value of the vertex.
     * @param {number} [alpha=1] - The alpha value of the vertex.
     *
     * @return {this} This Mesh Game Object.
     */ addVertex: function(x, y, z, u, v, color, alpha) {
                    var vert = new Vertex(x, y, z, u, v, color, alpha);
                    this.vertices.push(vert);
                    return vert;
                },
                /**
     * Adds a new Face into the faces array of this Mesh.
     *
     * A Face consists of references to 3 Vertex instances, which must be provided.
     *
     * @method Phaser.GameObjects.Mesh#addFace
     * @since 3.50.0
     *
     * @param {Phaser.Geom.Mesh.Vertex} vertex1 - The first vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex2 - The second vertex of the Face.
     * @param {Phaser.Geom.Mesh.Vertex} vertex3 - The third vertex of the Face.
     *
     * @return {this} This Mesh Game Object.
     */ addFace: function(vertex1, vertex2, vertex3) {
                    var face = new Face(vertex1, vertex2, vertex3);
                    this.faces.push(face);
                    this.dirtyCache[9] = -1;
                    return face;
                },
                /**
     * Adds new vertices to this Mesh by parsing the given data.
     *
     * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
     *
     * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default, and will result in `z=0` for each vertex).
     *
     * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
     *
     * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
     *
     * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
     *
     * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
     *
     * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
     *
     * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
     *
     * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
     *
     * The following example will create a 256 x 256 sized quad using an index array:
     *
     * ```javascript
     * let mesh = new Mesh(this);  // Assuming `this` is a scene!
     * const vertices = [
     *   -128, 128,
     *   128, 128,
     *   -128, -128,
     *   128, -128
     * ];
     *
     * const uvs = [
     *   0, 1,
     *   1, 1,
     *   0, 0,
     *   1, 0
     * ];
     *
     * const indices = [ 0, 2, 1, 2, 3, 1 ];
     *
     * mesh.addVertices(vertices, uvs, indicies);
     * // Note: Otherwise the added points will be "behind" the camera! This value will project vertex `x` & `y` values 1:1 to pixel values.
     * mesh.hideCCW = false;
     * mesh.setOrtho(mesh.width, mesh.height);
     * ```
     *
     * If the data is not indexed, it's assumed that the arrays all contain sequential data.
     *
     * @method Phaser.GameObjects.Mesh#addVertices
     * @since 3.50.0
     *
     * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
     * @param {number[]} uvs - The UVs pairs array.
     * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
     * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component? If not, it will be assumed `z=0`, see methods `panZ` or `setOrtho`.
     * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
     * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
     * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
     *
     * @return {this} This Mesh Game Object.
     */ addVertices: function(vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                    var result = GenerateVerts(vertices, uvs, indicies, containsZ, normals, colors, alphas);
                    if (result) {
                        this.faces = this.faces.concat(result.faces);
                        this.vertices = this.vertices.concat(result.vertices);
                    }
                    this.dirtyCache[9] = -1;
                    return this;
                },
                /**
     * Returns the total number of Faces in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFaceCount
     * @since 3.50.0
     *
     * @return {number} The number of Faces in this Mesh Game Object.
     */ getFaceCount: function() {
                    return this.faces.length;
                },
                /**
     * Returns the total number of Vertices in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getVertexCount
     * @since 3.50.0
     *
     * @return {number} The number of Vertices in this Mesh Game Object.
     */ getVertexCount: function() {
                    return this.vertices.length;
                },
                /**
     * Returns the Face at the given index in this Mesh Game Object.
     *
     * @method Phaser.GameObjects.Mesh#getFace
     * @since 3.50.0
     *
     * @param {number} index - The index of the Face to get.
     *
     * @return {Phaser.Geom.Mesh.Face} The Face at the given index, or `undefined` if index out of range.
     */ getFace: function(index) {
                    return this.faces[index];
                },
                /**
     * Return an array of Face objects from this Mesh that intersect with the given coordinates.
     *
     * The given position is translated through the matrix of this Mesh and the given Camera,
     * before being compared against the vertices.
     *
     * If more than one Face intersects, they will all be returned in the array, but the array will
     * be depth sorted first, so the first element will always be that closest to the camera.
     *
     * @method Phaser.GameObjects.Mesh#getFaceAt
     * @since 3.50.0
     *
     * @param {number} x - The x position to check against.
     * @param {number} y - The y position to check against.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The camera to pass the coordinates through. If not give, the default Scene Camera is used.
     *
     * @return {Phaser.Geom.Mesh.Face[]} An array of Face objects that intersect with the given point, ordered by depth.
     */ getFaceAt: function(x, y, camera) {
                    if (camera === undefined) camera = this.scene.sys.cameras.main;
                    var calcMatrix = GetCalcMatrix(this, camera).calc;
                    var faces = this.faces;
                    var results = [];
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        if (face.contains(x, y, calcMatrix)) results.push(face);
                    }
                    return StableSort(results, this.sortByDepth);
                },
                /**
     * This method enables rendering of the Mesh vertices to the given Graphics instance.
     *
     * If you enable this feature, you **must** call `Graphics.clear()` in your Scene `update`,
     * otherwise the Graphics instance you provide to debug will fill-up with draw calls,
     * eventually crashing the browser. This is not done automatically to allow you to debug
     * draw multiple Mesh objects to a single Graphics instance.
     *
     * The Mesh class has a built-in debug rendering callback `Mesh.renderDebug`, however
     * you can also provide your own callback to be used instead. Do this by setting the `callback` parameter.
     *
     * The callback is invoked _once per render_ and sent the following parameters:
     *
     * `callback(src, faces)`
     *
     * `src` is the Mesh instance being debugged.
     * `faces` is an array of the Faces that were rendered.
     *
     * You can get the final drawn vertex position from a Face object like this:
     *
     * ```javascript
     * let face = faces[i];
     *
     * let x0 = face.vertex1.tx;
     * let y0 = face.vertex1.ty;
     * let x1 = face.vertex2.tx;
     * let y1 = face.vertex2.ty;
     * let x2 = face.vertex3.tx;
     * let y2 = face.vertex3.ty;
     *
     * graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
     * ```
     *
     * If using your own callback you do not have to provide a Graphics instance to this method.
     *
     * To disable debug rendering, to either your own callback or the built-in one, call this method
     * with no arguments.
     *
     * @method Phaser.GameObjects.Mesh#setDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} [graphic] - The Graphic instance to render to if using the built-in callback.
     * @param {function} [callback] - The callback to invoke during debug render. Leave as undefined to use the built-in callback.
     *
     * @return {this} This Game Object instance.
     */ setDebug: function(graphic, callback) {
                    this.debugGraphic = graphic;
                    if (!graphic && !callback) this.debugCallback = null;
                    else if (!callback) this.debugCallback = this.renderDebug;
                    else this.debugCallback = callback;
                    return this;
                },
                /**
     * Checks if the transformation data in this mesh is dirty.
     *
     * This is used internally by the `preUpdate` step to determine if the vertices should
     * be recalculated or not.
     *
     * @method Phaser.GameObjects.Mesh#isDirty
     * @since 3.50.0
     *
     * @return {boolean} Returns `true` if the data of this mesh is dirty, otherwise `false`.
     */ isDirty: function() {
                    var position = this.modelPosition;
                    var rotation = this.modelRotation;
                    var scale = this.modelScale;
                    var dirtyCache = this.dirtyCache;
                    var px = position.x;
                    var py = position.y;
                    var pz = position.z;
                    var rx = rotation.x;
                    var ry = rotation.y;
                    var rz = rotation.z;
                    var sx = scale.x;
                    var sy = scale.y;
                    var sz = scale.z;
                    var faces = this.getFaceCount();
                    var pxCached = dirtyCache[0];
                    var pyCached = dirtyCache[1];
                    var pzCached = dirtyCache[2];
                    var rxCached = dirtyCache[3];
                    var ryCached = dirtyCache[4];
                    var rzCached = dirtyCache[5];
                    var sxCached = dirtyCache[6];
                    var syCached = dirtyCache[7];
                    var szCached = dirtyCache[8];
                    var fCached = dirtyCache[9];
                    dirtyCache[0] = px;
                    dirtyCache[1] = py;
                    dirtyCache[2] = pz;
                    dirtyCache[3] = rx;
                    dirtyCache[4] = ry;
                    dirtyCache[5] = rz;
                    dirtyCache[6] = sx;
                    dirtyCache[7] = sy;
                    dirtyCache[8] = sz;
                    dirtyCache[9] = faces;
                    return pxCached !== px || pyCached !== py || pzCached !== pz || rxCached !== rx || ryCached !== ry || rzCached !== rz || sxCached !== sx || syCached !== sy || szCached !== sz || fCached !== faces;
                },
                /**
     * The Mesh update loop. The following takes place in this method:
     *
     * First, the `totalRendered` and `totalFrame` properties are set.
     *
     * If the view matrix of this Mesh isn't dirty, and the model position, rotate or scale properties are
     * all clean, then the method returns at this point.
     *
     * Otherwise, if the viewPosition is dirty (i.e. from calling a method like `panZ`), then it will
     * refresh the viewMatrix.
     *
     * After this, a new transformMatrix is built and it then iterates through all Faces in this
     * Mesh, calling `transformCoordinatesLocal` on all of them. Internally, this updates every
     * vertex, calculating its new transformed position, based on the new transform matrix.
     *
     * Finally, the faces are depth sorted.
     *
     * @method Phaser.GameObjects.Mesh#preUpdate
     * @protected
     * @since 3.50.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function() {
                    this.totalRendered = this.totalFrame;
                    this.totalFrame = 0;
                    var dirty = this.dirtyCache;
                    if (!this.ignoreDirtyCache && !dirty[10] && !this.isDirty()) //  If neither the view or the mesh is dirty we can bail out and save lots of math
                    return;
                    var width = this.width;
                    var height = this.height;
                    var viewMatrix = this.viewMatrix;
                    var viewPosition = this.viewPosition;
                    if (dirty[10]) {
                        viewMatrix.identity();
                        viewMatrix.translate(viewPosition);
                        viewMatrix.invert();
                        dirty[10] = 0;
                    }
                    var transformMatrix = this.transformMatrix;
                    transformMatrix.setWorldMatrix(this.modelRotation, this.modelPosition, this.modelScale, this.viewMatrix, this.projectionMatrix);
                    var z = viewPosition.z;
                    var faces = this.faces;
                    for(var i = 0; i < faces.length; i++)faces[i].transformCoordinatesLocal(transformMatrix, width, height, z);
                    this.depthSort();
                },
                /**
     * The built-in Mesh debug rendering method.
     *
     * See `Mesh.setDebug` for more details.
     *
     * @method Phaser.GameObjects.Mesh#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Mesh} src - The Mesh object being rendered.
     * @param {Phaser.Geom.Mesh.Face[]} faces - An array of Faces.
     */ renderDebug: function(src, faces) {
                    var graphic = src.debugGraphic;
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        var x0 = face.vertex1.tx;
                        var y0 = face.vertex1.ty;
                        var x1 = face.vertex2.tx;
                        var y1 = face.vertex2.ty;
                        var x2 = face.vertex3.tx;
                        var y2 = face.vertex3.ty;
                        graphic.strokeTriangle(x0, y0, x1, y1, x2, y2);
                    }
                },
                /**
     * Handles the pre-destroy step for the Mesh, which removes the Animation component and typed arrays.
     *
     * @method Phaser.GameObjects.Mesh#preDestroy
     * @private
     * @since 3.50.0
     */ preDestroy: function() {
                    this.clear();
                    this.debugCallback = null;
                    this.debugGraphic = null;
                }
            });
            module1.exports = Mesh;
        /***/ },
        /* 228 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetween = __webpack_require__(48);
            /**
 * Checks if two Circles intersect.
 *
 * @function Phaser.Geom.Intersects.CircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 *
 * @return {boolean} `true` if the two Circles intersect, otherwise `false`.
 */ var CircleToCircle = function(circleA, circleB) {
                return DistanceBetween(circleA.x, circleA.y, circleB.x, circleB.y) <= circleA.radius + circleB.radius;
            };
            module1.exports = CircleToCircle;
        /***/ },
        /* 229 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var LineToCircle = __webpack_require__(230);
            /**
 * Checks for intersection between the line segment and circle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToCircle = function(line, circle, out) {
                if (out === undefined) out = [];
                if (LineToCircle(line, circle)) {
                    var lx1 = line.x1;
                    var ly1 = line.y1;
                    var lx2 = line.x2;
                    var ly2 = line.y2;
                    var cx = circle.x;
                    var cy = circle.y;
                    var cr = circle.radius;
                    var lDirX = lx2 - lx1;
                    var lDirY = ly2 - ly1;
                    var oDirX = lx1 - cx;
                    var oDirY = ly1 - cy;
                    var coefficientA = lDirX * lDirX + lDirY * lDirY;
                    var coefficientB = 2 * (lDirX * oDirX + lDirY * oDirY);
                    var coefficientC = oDirX * oDirX + oDirY * oDirY - cr * cr;
                    var lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                    var x, y;
                    if (lambda === 0) {
                        var root = -coefficientB / (2 * coefficientA);
                        x = lx1 + root * lDirX;
                        y = ly1 + root * lDirY;
                        if (root >= 0 && root <= 1) out.push(new Point(x, y));
                    } else if (lambda > 0) {
                        var root1 = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                        x = lx1 + root1 * lDirX;
                        y = ly1 + root1 * lDirY;
                        if (root1 >= 0 && root1 <= 1) out.push(new Point(x, y));
                        var root2 = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                        x = lx1 + root2 * lDirX;
                        y = ly1 + root2 * lDirY;
                        if (root2 >= 0 && root2 <= 1) out.push(new Point(x, y));
                    }
                }
                return out;
            };
            module1.exports = GetLineToCircle;
        /***/ },
        /* 230 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(63);
            var Point = __webpack_require__(4);
            var tmp = new Point();
            /**
 * Checks for intersection between the line segment and circle.
 *
 * Based on code by [Matt DesLauriers](https://github.com/mattdesl/line-circle-collision/blob/master/LICENSE.md).
 *
 * @function Phaser.Geom.Intersects.LineToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Circle} circle - The circle to check against the line.
 * @param {(Phaser.Geom.Point|any)} [nearest] - An optional Point-like object. If given the closest point on the Line where the circle intersects will be stored in this object.
 *
 * @return {boolean} `true` if the two objects intersect, otherwise `false`.
 */ var LineToCircle = function(line, circle, nearest) {
                if (nearest === undefined) nearest = tmp;
                if (Contains(circle, line.x1, line.y1)) {
                    nearest.x = line.x1;
                    nearest.y = line.y1;
                    return true;
                }
                if (Contains(circle, line.x2, line.y2)) {
                    nearest.x = line.x2;
                    nearest.y = line.y2;
                    return true;
                }
                var dx = line.x2 - line.x1;
                var dy = line.y2 - line.y1;
                var lcx = circle.x - line.x1;
                var lcy = circle.y - line.y1;
                //  project lc onto d, resulting in vector p
                var dLen2 = dx * dx + dy * dy;
                var px = dx;
                var py = dy;
                if (dLen2 > 0) {
                    var dp = (lcx * dx + lcy * dy) / dLen2;
                    px *= dp;
                    py *= dp;
                }
                nearest.x = line.x1 + px;
                nearest.y = line.y1 + py;
                //  len2 of p
                var pLen2 = px * px + py * py;
                return pLen2 <= dLen2 && px * dx + py * dy >= 0 && Contains(circle, nearest.x, nearest.y);
            };
            module1.exports = LineToCircle;
        /***/ },
        /* 231 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var LineToLine = __webpack_require__(92);
            var LineToRectangle = __webpack_require__(482);
            /**
 * Checks for intersection between the Line and a Rectangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetLineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetLineToRectangle = function(line, rect, out) {
                if (out === undefined) out = [];
                if (LineToRectangle(line, rect)) {
                    var lineA = rect.getLineA();
                    var lineB = rect.getLineB();
                    var lineC = rect.getLineC();
                    var lineD = rect.getLineD();
                    var output = [
                        new Point(),
                        new Point(),
                        new Point(),
                        new Point()
                    ];
                    var result = [
                        LineToLine(lineA, line, output[0]),
                        LineToLine(lineB, line, output[1]),
                        LineToLine(lineC, line, output[2]),
                        LineToLine(lineD, line, output[3])
                    ];
                    for(var i = 0; i < 4; i++)if (result[i]) out.push(output[i]);
                }
                return out;
            };
            module1.exports = GetLineToRectangle;
        /***/ },
        /* 232 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  http://www.blackpawn.com/texts/pointinpoly/
            //  points is an array of Point-like objects with public x/y properties
            //  returns an array containing all points that are within the triangle, or an empty array if none
            //  if 'returnFirst' is true it will return after the first point within the triangle is found
            /**
 * Filters an array of point-like objects to only those contained within a triangle.
 * If `returnFirst` is true, will return an array containing only the first point in the provided array that is within the triangle (or an empty array if there are no such points).
 *
 * @function Phaser.Geom.Triangle.ContainsArray
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle that the points are being checked in.
 * @param {Phaser.Geom.Point[]} points - An array of point-like objects (objects that have an `x` and `y` property)
 * @param {boolean} [returnFirst=false] - If `true`, return an array containing only the first point found that is within the triangle.
 * @param {array} [out] - If provided, the points that are within the triangle will be appended to this array instead of being added to a new array. If `returnFirst` is true, only the first point found within the triangle will be appended. This array will also be returned by this function.
 *
 * @return {Phaser.Geom.Point[]} An array containing all the points from `points` that are within the triangle, if an array was provided as `out`, points will be appended to that array and it will also be returned here.
 */ var ContainsArray = function(triangle, points, returnFirst, out) {
                if (returnFirst === undefined) returnFirst = false;
                if (out === undefined) out = [];
                var v0x = triangle.x3 - triangle.x1;
                var v0y = triangle.y3 - triangle.y1;
                var v1x = triangle.x2 - triangle.x1;
                var v1y = triangle.y2 - triangle.y1;
                var dot00 = v0x * v0x + v0y * v0y;
                var dot01 = v0x * v1x + v0y * v1y;
                var dot11 = v1x * v1x + v1y * v1y;
                // Compute barycentric coordinates
                var b = dot00 * dot11 - dot01 * dot01;
                var inv = b === 0 ? 0 : 1 / b;
                var u;
                var v;
                var v2x;
                var v2y;
                var dot02;
                var dot12;
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                for(var i = 0; i < points.length; i++){
                    v2x = points[i].x - x1;
                    v2y = points[i].y - y1;
                    dot02 = v0x * v2x + v0y * v2y;
                    dot12 = v1x * v2x + v1y * v2y;
                    u = (dot11 * dot02 - dot01 * dot12) * inv;
                    v = (dot00 * dot12 - dot01 * dot02) * inv;
                    if (u >= 0 && v >= 0 && u + v < 1) {
                        out.push({
                            x: points[i].x,
                            y: points[i].y
                        });
                        if (returnFirst) break;
                    }
                }
                return out;
            };
            module1.exports = ContainsArray;
        /***/ },
        /* 233 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a line around the given coordinates by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} x - The horizontal coordinate to rotate the line around.
 * @param {number} y - The vertical coordinate to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundXY = function(line, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = line.x1 - x;
                var ty = line.y1 - y;
                line.x1 = tx * c - ty * s + x;
                line.y1 = tx * s + ty * c + y;
                tx = line.x2 - x;
                ty = line.y2 - y;
                line.x2 = tx * c - ty * s + x;
                line.y2 = tx * s + ty * c + y;
                return line;
            };
            module1.exports = RotateAroundXY;
        /***/ },
        /* 234 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the width/height ratio of a rectangle.
 *
 * @function Phaser.Geom.Rectangle.GetAspectRatio
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
 *
 * @return {number} The width/height ratio of the rectangle.
 */ var GetAspectRatio = function(rect) {
                return rect.height === 0 ? NaN : rect.width / rect.height;
            };
            module1.exports = GetAspectRatio;
        /***/ },
        /* 235 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates an entire Triangle at a given angle about a specific point.
 *
 * @function Phaser.Geom.Triangle.RotateAroundXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} x - The X coordinate of the point to rotate the Triangle about.
 * @param {number} y - The Y coordinate of the point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundXY = function(triangle, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = triangle.x1 - x;
                var ty = triangle.y1 - y;
                triangle.x1 = tx * c - ty * s + x;
                triangle.y1 = tx * s + ty * c + y;
                tx = triangle.x2 - x;
                ty = triangle.y2 - y;
                triangle.x2 = tx * c - ty * s + x;
                triangle.y2 = tx * s + ty * c + y;
                tx = triangle.x3 - x;
                ty = triangle.y3 - y;
                triangle.x3 = tx * c - ty * s + x;
                triangle.y3 = tx * s + ty * c + y;
                return triangle;
            };
            module1.exports = RotateAroundXY;
        /***/ },
        /* 236 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Events
 */ module1.exports = {
                BUTTON_DOWN: __webpack_require__(1304),
                BUTTON_UP: __webpack_require__(1305),
                CONNECTED: __webpack_require__(1306),
                DISCONNECTED: __webpack_require__(1307),
                GAMEPAD_BUTTON_DOWN: __webpack_require__(1308),
                GAMEPAD_BUTTON_UP: __webpack_require__(1309)
            };
        /***/ },
        /* 237 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var XHRSettings = __webpack_require__(154);
            /**
 * Takes two XHRSettings Objects and creates a new XHRSettings object from them.
 *
 * The new object is seeded by the values given in the global settings, but any setting in
 * the local object overrides the global ones.
 *
 * @function Phaser.Loader.MergeXHRSettings
 * @since 3.0.0
 *
 * @param {Phaser.Types.Loader.XHRSettingsObject} global - The global XHRSettings object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} local - The local XHRSettings object.
 *
 * @return {Phaser.Types.Loader.XHRSettingsObject} A newly formed XHRSettings object.
 */ var MergeXHRSettings = function(global, local) {
                var output = global === undefined ? XHRSettings() : Extend({}, global);
                if (local) {
                    for(var setting in local)if (local[setting] !== undefined) output[setting] = local[setting];
                }
                return output;
            };
            module1.exports = MergeXHRSettings;
        /***/ },
        /* 238 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var ParseXML = __webpack_require__(402);
            /**
 * @classdesc
 * A single XML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#xml method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#xml.
 *
 * @class XMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var XMLFile = new Class({
                Extends: File,
                initialize: function XMLFile(loader, key, url, xhrSettings) {
                    var extension = 'xml';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'xml',
                        cache: loader.cacheManager.xml,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.XMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = ParseXML(this.xhrLoader.responseText);
                    if (this.data) this.onProcessComplete();
                    else {
                        console.warn('Invalid XMLFile: ' + this.key);
                        this.onProcessError();
                    }
                }
            });
            /**
 * Adds an XML file, or array of XML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 * 
 * ```javascript
 * function preload ()
 * {
 *     this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 * 
 * The key must be a unique String. It is used to add the file to the global XML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the XML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the XML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 * 
 * ```javascript
 * this.load.xml({
 *     key: 'wavedata',
 *     url: 'files/AlienWaveData.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.XMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 * 
 * ```javascript
 * this.load.xml('wavedata', 'files/AlienWaveData.xml');
 * // and later in your game ...
 * var data = this.cache.xml.get('wavedata');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the XML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.xml". It will always add `.xml` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#xml
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.XMLFileConfig|Phaser.Types.Loader.FileTypes.XMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('xml', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new XMLFile(this, key[i]));
                else this.addFile(new XMLFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = XMLFile;
        /***/ },
        /* 239 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Text File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#text method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#text.
 *
 * @class TextFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TextFile = new Class({
                Extends: File,
                initialize: function TextFile(loader, key, url, xhrSettings) {
                    var type = 'text';
                    var extension = 'txt';
                    var cache = loader.cacheManager.text;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        type = GetFastValue(config, 'type', type);
                        cache = GetFastValue(config, 'cache', cache);
                    }
                    var fileConfig = {
                        type: type,
                        cache: cache,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TextFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Text file, or array of Text files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.text('story', 'files/IntroStory.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Text Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Text Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.text({
 *     key: 'story',
 *     url: 'files/IntroStory.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TextFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.text('story', 'files/IntroStory.txt');
 * // and later in your game ...
 * var data = this.cache.text.get('story');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Text Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.txt". It will always add `.txt` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Text File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#text
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TextFileConfig|Phaser.Types.Loader.FileTypes.TextFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('text', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TextFile(this, key[i]));
                else this.addFile(new TextFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TextFile;
        /***/ },
        /* 240 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Components
 */ module1.exports = {
                Acceleration: __webpack_require__(1362),
                Angular: __webpack_require__(1363),
                Bounce: __webpack_require__(1364),
                Debug: __webpack_require__(1365),
                Drag: __webpack_require__(1366),
                Enable: __webpack_require__(1367),
                Friction: __webpack_require__(1368),
                Gravity: __webpack_require__(1369),
                Immovable: __webpack_require__(1370),
                Mass: __webpack_require__(1371),
                OverlapCirc: __webpack_require__(517),
                OverlapRect: __webpack_require__(241),
                Pushable: __webpack_require__(1372),
                Size: __webpack_require__(1373),
                Velocity: __webpack_require__(1374)
            };
        /***/ },
        /* 241 */ /***/ function(module1, exports) {
            /**
 * This method will search the given rectangular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 * 
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 * 
 * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapRect
 * @since 3.17.0
 *
 * @param {number} x - The top-left x coordinate of the area to search within.
 * @param {number} y - The top-left y coordinate of the area to search within.
 * @param {number} width - The width of the area to search within.
 * @param {number} height - The height of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapRect = function(world, x, y, width, height, includeDynamic, includeStatic) {
                if (includeDynamic === undefined) includeDynamic = true;
                if (includeStatic === undefined) includeStatic = false;
                var dynamicBodies = [];
                var staticBodies = [];
                var minMax = world.treeMinMax;
                minMax.minX = x;
                minMax.minY = y;
                minMax.maxX = x + width;
                minMax.maxY = y + height;
                if (includeStatic) staticBodies = world.staticTree.search(minMax);
                if (includeDynamic && world.useTree) dynamicBodies = world.tree.search(minMax);
                else if (includeDynamic) {
                    var bodies = world.bodies;
                    var fakeBody = {
                        position: {
                            x: x,
                            y: y
                        },
                        left: x,
                        top: y,
                        right: x + width,
                        bottom: y + height,
                        isCircle: false
                    };
                    var intersects = world.intersects;
                    bodies.iterate(function(target) {
                        if (intersects(target, fakeBody)) dynamicBodies.push(target);
                    });
                }
                return staticBodies.concat(dynamicBodies);
            };
            module1.exports = OverlapRect;
        /***/ },
        /* 242 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Events
 */ module1.exports = {
                COLLIDE: __webpack_require__(1375),
                OVERLAP: __webpack_require__(1376),
                PAUSE: __webpack_require__(1377),
                RESUME: __webpack_require__(1378),
                TILE_COLLIDE: __webpack_require__(1379),
                TILE_OVERLAP: __webpack_require__(1380),
                WORLD_BOUNDS: __webpack_require__(1381),
                WORLD_STEP: __webpack_require__(1382)
            };
        /***/ },
        /* 243 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(60);
            /**
 * Calculates and returns the horizontal overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.left`, `touching.right`, `touching.none` and `overlapX'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapX = function(body1, body2, overlapOnly, bias) {
                var overlap = 0;
                var maxOverlap = body1.deltaAbsX() + body2.deltaAbsX() + bias;
                if (body1._dx === 0 && body2._dx === 0) {
                    //  They overlap but neither of them are moving
                    body1.embedded = true;
                    body2.embedded = true;
                } else if (body1._dx > body2._dx) {
                    //  Body1 is moving right and / or Body2 is moving left
                    overlap = body1.right - body2.x;
                    if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.right === false || body2.checkCollision.left === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.right = true;
                        body2.touching.none = false;
                        body2.touching.left = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.right = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.left = true;
                        }
                    }
                } else if (body1._dx < body2._dx) {
                    //  Body1 is moving left and/or Body2 is moving right
                    overlap = body1.x - body2.width - body2.x;
                    if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.left === false || body2.checkCollision.right === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.left = true;
                        body2.touching.none = false;
                        body2.touching.right = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.left = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.right = true;
                        }
                    }
                }
                //  Resets the overlapX to zero if there is no overlap, or to the actual pixel value if there is
                body1.overlapX = overlap;
                body2.overlapX = overlap;
                return overlap;
            };
            module1.exports = GetOverlapX;
        /***/ },
        /* 244 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(60);
            /**
 * Calculates and returns the vertical overlap between two arcade physics bodies and sets their properties
 * accordingly, including: `touching.up`, `touching.down`, `touching.none` and `overlapY'.
 *
 * @function Phaser.Physics.Arcade.GetOverlapY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
 * @param {number} bias - A value added to the delta values during collision checks. Increase it to prevent sprite tunneling(sprites passing through another instead of colliding).
 *
 * @return {number} The amount of overlap.
 */ var GetOverlapY = function(body1, body2, overlapOnly, bias) {
                var overlap = 0;
                var maxOverlap = body1.deltaAbsY() + body2.deltaAbsY() + bias;
                if (body1._dy === 0 && body2._dy === 0) {
                    //  They overlap but neither of them are moving
                    body1.embedded = true;
                    body2.embedded = true;
                } else if (body1._dy > body2._dy) {
                    //  Body1 is moving down and/or Body2 is moving up
                    overlap = body1.bottom - body2.y;
                    if (overlap > maxOverlap && !overlapOnly || body1.checkCollision.down === false || body2.checkCollision.up === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.down = true;
                        body2.touching.none = false;
                        body2.touching.up = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.down = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.up = true;
                        }
                    }
                } else if (body1._dy < body2._dy) {
                    //  Body1 is moving up and/or Body2 is moving down
                    overlap = body1.y - body2.bottom;
                    if (-overlap > maxOverlap && !overlapOnly || body1.checkCollision.up === false || body2.checkCollision.down === false) overlap = 0;
                    else {
                        body1.touching.none = false;
                        body1.touching.up = true;
                        body2.touching.none = false;
                        body2.touching.down = true;
                        if (body2.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body1.blocked.none = false;
                            body1.blocked.up = true;
                        }
                        if (body1.physicsType === CONST.STATIC_BODY && !overlapOnly) {
                            body2.blocked.none = false;
                            body2.blocked.down = true;
                        }
                    }
                }
                //  Resets the overlapY to zero if there is no overlap, or to the actual pixel value if there is
                body1.overlapY = overlap;
                body2.overlapY = overlap;
                return overlap;
            };
            module1.exports = GetOverlapY;
        /***/ },
        /* 245 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the given tile rectangle-like object and an Arcade Physics body.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileIntersectsBody
 * @since 3.0.0
 *
 * @param {{ left: number, right: number, top: number, bottom: number }} tileWorldRect - A rectangle object that defines the tile placement in the world.
 * @param {Phaser.Physics.Arcade.Body} body - The body to check for intersection against.
 *
 * @return {boolean} Returns `true` of the tile intersects with the body, otherwise `false`.
 */ var TileIntersectsBody = function(tileWorldRect, body) {
                // Currently, all bodies are treated as rectangles when colliding with a Tile.
                return !(body.right <= tileWorldRect.left || body.bottom <= tileWorldRect.top || body.position.x >= tileWorldRect.right || body.position.y >= tileWorldRect.bottom);
            };
            module1.exports = TileIntersectsBody;
        /***/ },
        /* 246 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
* The stiffness of constraints can be modified to create springs or elastic.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Constraint
*/ var Constraint = {};
            module1.exports = Constraint;
            var Vertices = __webpack_require__(94);
            var Vector = __webpack_require__(116);
            var Sleeping = __webpack_require__(267);
            var Bounds = __webpack_require__(117);
            var Axes = __webpack_require__(585);
            var Common = __webpack_require__(50);
            (function() {
                Constraint._warming = 0.4;
                Constraint._torqueDampen = 1;
                Constraint._minLength = 0.000001;
                /**
     * Creates a new constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {constraint} constraint
     */ Constraint.create = function(options) {
                    var constraint = options;
                    // if bodies defined but no points, use body centre
                    if (constraint.bodyA && !constraint.pointA) constraint.pointA = {
                        x: 0,
                        y: 0
                    };
                    if (constraint.bodyB && !constraint.pointB) constraint.pointB = {
                        x: 0,
                        y: 0
                    };
                    // calculate static length using initial world space points
                    var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA, initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB, length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
                    constraint.length = typeof constraint.length !== 'undefined' ? constraint.length : length;
                    // option defaults
                    constraint.id = constraint.id || Common.nextId();
                    constraint.label = constraint.label || 'Constraint';
                    constraint.type = 'constraint';
                    constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
                    constraint.damping = constraint.damping || 0;
                    constraint.angularStiffness = constraint.angularStiffness || 0;
                    constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
                    constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
                    constraint.plugin = {};
                    // render
                    var render = {
                        visible: true,
                        type: 'line',
                        anchors: true,
                        lineColor: null,
                        lineOpacity: null,
                        lineThickness: null,
                        pinSize: null,
                        anchorColor: null,
                        anchorSize: null // custom Phaser property
                    };
                    if (constraint.length === 0 && constraint.stiffness > 0.1) {
                        render.type = 'pin';
                        render.anchors = false;
                    } else if (constraint.stiffness < 0.9) render.type = 'spring';
                    constraint.render = Common.extend(render, constraint.render);
                    return constraint;
                };
                /**
     * Prepares for solving by constraint warming.
     * @private
     * @method preSolveAll
     * @param {body[]} bodies
     */ Constraint.preSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        body.position.x += impulse.x;
                        body.position.y += impulse.y;
                        body.angle += impulse.angle;
                    }
                };
                /**
     * Solves all constraints in a list of collisions.
     * @private
     * @method solveAll
     * @param {constraint[]} constraints
     * @param {number} timeScale
     */ Constraint.solveAll = function(constraints, timeScale) {
                    // Solve fixed constraints first.
                    for(var i = 0; i < constraints.length; i += 1){
                        var constraint = constraints[i], fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic, fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (fixedA || fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                    // Solve free constraints last.
                    for(i = 0; i < constraints.length; i += 1){
                        constraint = constraints[i];
                        fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic;
                        fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (!fixedA && !fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                };
                /**
     * Solves a distance constraint with Gauss-Siedel method.
     * @private
     * @method solve
     * @param {constraint} constraint
     * @param {number} timeScale
     */ Constraint.solve = function(constraint, timeScale) {
                    var bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointA = constraint.pointA, pointB = constraint.pointB;
                    if (!bodyA && !bodyB) return;
                    // update reference angle
                    if (bodyA && !bodyA.isStatic) {
                        Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
                        constraint.angleA = bodyA.angle;
                    }
                    // update reference angle
                    if (bodyB && !bodyB.isStatic) {
                        Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
                        constraint.angleB = bodyB.angle;
                    }
                    var pointAWorld = pointA, pointBWorld = pointB;
                    if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
                    if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
                    if (!pointAWorld || !pointBWorld) return;
                    var delta = Vector.sub(pointAWorld, pointBWorld), currentLength = Vector.magnitude(delta);
                    // prevent singularity
                    if (currentLength < Constraint._minLength) currentLength = Constraint._minLength;
                    // solve distance constraint with Gauss-Siedel method
                    var difference = (currentLength - constraint.length) / currentLength, stiffness = constraint.stiffness < 1 ? constraint.stiffness * timeScale : constraint.stiffness, force = Vector.mult(delta, difference * stiffness), massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0), inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0), resistanceTotal = massTotal + inertiaTotal, torque, share, normal, normalVelocity, relativeVelocity;
                    if (constraint.damping) {
                        var zero = Vector.create();
                        normal = Vector.div(delta, currentLength);
                        relativeVelocity = Vector.sub(bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero, bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero);
                        normalVelocity = Vector.dot(normal, relativeVelocity);
                    }
                    if (bodyA && !bodyA.isStatic) {
                        share = bodyA.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyA.constraintImpulse.x -= force.x * share;
                        bodyA.constraintImpulse.y -= force.y * share;
                        // apply forces
                        bodyA.position.x -= force.x * share;
                        bodyA.position.y -= force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyA.positionPrev.x -= constraint.damping * normal.x * normalVelocity * share;
                            bodyA.positionPrev.y -= constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointA, force) / resistanceTotal * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
                        bodyA.constraintImpulse.angle -= torque;
                        bodyA.angle -= torque;
                    }
                    if (bodyB && !bodyB.isStatic) {
                        share = bodyB.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyB.constraintImpulse.x += force.x * share;
                        bodyB.constraintImpulse.y += force.y * share;
                        // apply forces
                        bodyB.position.x += force.x * share;
                        bodyB.position.y += force.y * share;
                        // apply damping
                        if (constraint.damping) {
                            bodyB.positionPrev.x += constraint.damping * normal.x * normalVelocity * share;
                            bodyB.positionPrev.y += constraint.damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointB, force) / resistanceTotal * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
                        bodyB.constraintImpulse.angle += torque;
                        bodyB.angle += torque;
                    }
                };
                /**
     * Performs body updates required after solving constraints.
     * @private
     * @method postSolveAll
     * @param {body[]} bodies
     */ Constraint.postSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        Sleeping.set(body, false);
                        // update geometry and reset
                        for(var j = 0; j < body.parts.length; j++){
                            var part = body.parts[j];
                            Vertices.translate(part.vertices, impulse);
                            if (j > 0) {
                                part.position.x += impulse.x;
                                part.position.y += impulse.y;
                            }
                            if (impulse.angle !== 0) {
                                Vertices.rotate(part.vertices, impulse.angle, body.position);
                                Axes.rotate(part.axes, impulse.angle);
                                if (j > 0) Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
                            }
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                        // dampen the cached impulse for warming next step
                        impulse.angle *= Constraint._warming;
                        impulse.x *= Constraint._warming;
                        impulse.y *= Constraint._warming;
                    }
                };
                /**
     * Returns the world-space position of `constraint.pointA`, accounting for `constraint.bodyA`.
     * @method pointAWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointAWorld = function(constraint) {
                    return {
                        x: (constraint.bodyA ? constraint.bodyA.position.x : 0) + constraint.pointA.x,
                        y: (constraint.bodyA ? constraint.bodyA.position.y : 0) + constraint.pointA.y
                    };
                };
                /**
     * Returns the world-space position of `constraint.pointB`, accounting for `constraint.bodyB`.
     * @method pointBWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointBWorld = function(constraint) {
                    return {
                        x: (constraint.bodyB ? constraint.bodyB.position.x : 0) + constraint.pointB.x,
                        y: (constraint.bodyB ? constraint.bodyB.position.y : 0) + constraint.pointB.y
                    };
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Constraint"
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the constraint should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * A `Number` that defines the line width to use when rendering the constraint outline.
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 2
     */ /**
     * A `String` that defines the stroke style to use when rendering the constraint outline.
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the constraint rendering type. 
     * The possible values are 'line', 'pin', 'spring'.
     * An appropriate render type will be automatically chosen unless one is given in options.
     *
     * @property render.type
     * @type string
     * @default 'line'
     */ /**
     * A `Boolean` that defines if the constraint's anchor points should be rendered.
     *
     * @property render.anchors
     * @type boolean
     * @default true
     */ /**
     * The first possible `Body` that this constraint is attached to.
     *
     * @property bodyA
     * @type body
     * @default null
     */ /**
     * The second possible `Body` that this constraint is attached to.
     *
     * @property bodyB
     * @type body
     * @default null
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
     *
     * @property pointA
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
     *
     * @property pointB
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
     * A value of `1` means the constraint should be very stiff.
     * A value of `0.2` means the constraint acts like a soft spring.
     *
     * @property stiffness
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the damping of the constraint, 
     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
     * Damping will only be apparent when the constraint also has a very low `stiffness`.
     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
     * A value of `0` means the constraint will apply no damping.
     *
     * @property damping
     * @type number
     * @default 0
     */ /**
     * A `Number` that specifies the target resting length of the constraint. 
     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     *
     * @property length
     * @type number
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 247 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Components
 */ module1.exports = {
                CalculateFacesAt: __webpack_require__(248),
                CalculateFacesWithin: __webpack_require__(61),
                CheckIsoBounds: __webpack_require__(537),
                Copy: __webpack_require__(1414),
                CreateFromTiles: __webpack_require__(1415),
                CullBounds: __webpack_require__(539),
                CullTiles: __webpack_require__(540),
                Fill: __webpack_require__(1416),
                FilterTiles: __webpack_require__(1417),
                FindByIndex: __webpack_require__(1418),
                FindTile: __webpack_require__(1419),
                ForEachTile: __webpack_require__(1420),
                GetCullTilesFunction: __webpack_require__(1421),
                GetTileAt: __webpack_require__(156),
                GetTileAtWorldXY: __webpack_require__(1422),
                GetTilesWithin: __webpack_require__(26),
                GetTilesWithinShape: __webpack_require__(1423),
                GetTilesWithinWorldXY: __webpack_require__(523),
                GetTileToWorldXFunction: __webpack_require__(1424),
                GetTileToWorldXYFunction: __webpack_require__(1425),
                GetTileToWorldYFunction: __webpack_require__(1426),
                GetWorldToTileXFunction: __webpack_require__(1427),
                GetWorldToTileXYFunction: __webpack_require__(1428),
                GetWorldToTileYFunction: __webpack_require__(1429),
                HasTileAt: __webpack_require__(558),
                HasTileAtWorldXY: __webpack_require__(1430),
                HexagonalCullBounds: __webpack_require__(542),
                HexagonalCullTiles: __webpack_require__(541),
                HexagonalTileToWorldXY: __webpack_require__(546),
                HexagonalTileToWorldY: __webpack_require__(550),
                HexagonalWorldToTileXY: __webpack_require__(552),
                HexagonalWorldToTileY: __webpack_require__(556),
                IsInLayerBounds: __webpack_require__(118),
                IsometricCullTiles: __webpack_require__(543),
                IsometricTileToWorldXY: __webpack_require__(547),
                IsometricWorldToTileXY: __webpack_require__(553),
                PutTileAt: __webpack_require__(253),
                PutTileAtWorldXY: __webpack_require__(1431),
                PutTilesAt: __webpack_require__(1432),
                Randomize: __webpack_require__(1433),
                RemoveTileAt: __webpack_require__(559),
                RemoveTileAtWorldXY: __webpack_require__(1434),
                RenderDebug: __webpack_require__(1435),
                ReplaceByIndex: __webpack_require__(538),
                RunCull: __webpack_require__(157),
                SetCollision: __webpack_require__(1436),
                SetCollisionBetween: __webpack_require__(1437),
                SetCollisionByExclusion: __webpack_require__(1438),
                SetCollisionByProperty: __webpack_require__(1439),
                SetCollisionFromCollisionGroup: __webpack_require__(1440),
                SetLayerCollisionIndex: __webpack_require__(158),
                SetTileCollision: __webpack_require__(72),
                SetTileIndexCallback: __webpack_require__(1441),
                SetTileLocationCallback: __webpack_require__(1442),
                Shuffle: __webpack_require__(1443),
                StaggeredCullBounds: __webpack_require__(545),
                StaggeredCullTiles: __webpack_require__(544),
                StaggeredTileToWorldXY: __webpack_require__(548),
                StaggeredTileToWorldY: __webpack_require__(551),
                StaggeredWorldToTileXY: __webpack_require__(554),
                StaggeredWorldToTileY: __webpack_require__(557),
                SwapByIndex: __webpack_require__(1444),
                TileToWorldX: __webpack_require__(249),
                TileToWorldXY: __webpack_require__(549),
                TileToWorldY: __webpack_require__(250),
                WeightedRandomize: __webpack_require__(1445),
                WorldToTileX: __webpack_require__(251),
                WorldToTileXY: __webpack_require__(555),
                WorldToTileY: __webpack_require__(252)
            };
        /***/ },
        /* 248 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(156);
            /**
 * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
 * faces are used internally for optimizing collisions against tiles. This method is mostly used
 * internally to optimize recalculating faces when only one tile has been changed.
 *
 * @function Phaser.Tilemaps.Components.CalculateFacesAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var CalculateFacesAt = function(tileX, tileY, layer) {
                var tile = GetTileAt(tileX, tileY, true, layer);
                var above = GetTileAt(tileX, tileY - 1, true, layer);
                var below = GetTileAt(tileX, tileY + 1, true, layer);
                var left = GetTileAt(tileX - 1, tileY, true, layer);
                var right = GetTileAt(tileX + 1, tileY, true, layer);
                var tileCollides = tile && tile.collides;
                // Assume the changed tile has all interesting edges
                if (tileCollides) {
                    tile.faceTop = true;
                    tile.faceBottom = true;
                    tile.faceLeft = true;
                    tile.faceRight = true;
                }
                // Reset edges that are shared between tile and its neighbors
                if (above && above.collides) {
                    if (tileCollides) tile.faceTop = false;
                    above.faceBottom = !tileCollides;
                }
                if (below && below.collides) {
                    if (tileCollides) tile.faceBottom = false;
                    below.faceTop = !tileCollides;
                }
                if (left && left.collides) {
                    if (tileCollides) tile.faceLeft = false;
                    left.faceRight = !tileCollides;
                }
                if (right && right.collides) {
                    if (tileCollides) tile.faceRight = false;
                    right.faceLeft = !tileCollides;
                }
                if (tile && !tile.collides) tile.resetFaces();
                return tile;
            };
            module1.exports = CalculateFacesAt;
        /***/ },
        /* 249 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldX
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number}
 */ var TileToWorldX = function(tileX, camera, layer) {
                var tileWidth = layer.baseTileWidth;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                }
                return layerWorldX + tileX * tileWidth;
            };
            module1.exports = TileToWorldX;
        /***/ },
        /* 250 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldY
 * @since 3.0.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var TileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                return layerWorldY + tileY * tileHeight;
            };
            module1.exports = TileToWorldY;
        /***/ },
        /* 251 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileX
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The X location in tile units.
 */ var WorldToTileX = function(worldX, snapToFloor, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                var tileWidth = layer.baseTileWidth;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                return snapToFloor ? Math.floor(worldX / tileWidth) : worldX / tileWidth;
            };
            module1.exports = WorldToTileX;
        /***/ },
        /* 252 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileY
 * @since 3.0.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {?Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var WorldToTileY = function(worldY, snapToFloor, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                return snapToFloor ? Math.floor(worldY / tileHeight) : worldY / tileHeight;
            };
            module1.exports = WorldToTileY;
        /***/ },
        /* 253 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(83);
            var IsInLayerBounds = __webpack_require__(118);
            var CalculateFacesAt = __webpack_require__(248);
            var SetTileCollision = __webpack_require__(72);
            /**
 * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
 * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
 * location. If you pass in an index, only the index at the specified location will be changed.
 * Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAt
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAt = function(tile, tileX, tileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                var oldTile = layer.data[tileY][tileX];
                var oldTileCollides = oldTile && oldTile.collides;
                if (tile instanceof Tile) {
                    if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, tile.index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                    layer.data[tileY][tileX].copy(tile);
                } else {
                    var index = tile;
                    if (layer.data[tileY][tileX] === null) layer.data[tileY][tileX] = new Tile(layer, index, tileX, tileY, layer.tileWidth, layer.tileHeight);
                    else layer.data[tileY][tileX].index = index;
                }
                // Updating colliding flag on the new tile
                var newTile = layer.data[tileY][tileX];
                var collides = layer.collideIndexes.indexOf(newTile.index) !== -1;
                SetTileCollision(newTile, collides);
                // Recalculate faces only if the colliding flag at (tileX, tileY) has changed
                if (recalculateFaces && oldTileCollides !== newTile.collides) CalculateFacesAt(tileX, tileY, layer);
                return newTile;
            };
            module1.exports = PutTileAt;
        /***/ },
        /* 254 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            /**
 * Get the Tilemap orientation from the given string.
 *
 * @function Phaser.Tilemaps.Parsers.FromOrientationString
 * @since 3.50.0
 *
 * @param {string} [orientation] - The orientation type as a string.
 *
 * @return {Phaser.Tilemaps.OrientationType} The Tilemap Orientation type.
 */ var FromOrientationString = function(orientation) {
                orientation = orientation.toLowerCase();
                if (orientation === 'isometric') return CONST.ISOMETRIC;
                else if (orientation === 'staggered') return CONST.STAGGERED;
                else if (orientation === 'hexagonal') return CONST.HEXAGONAL;
                else return CONST.ORTHOGONAL;
            };
            module1.exports = FromOrientationString;
        /***/ },
        /* 255 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(39);
            var LayerData = __webpack_require__(119);
            var MapData = __webpack_require__(120);
            var Tile = __webpack_require__(83);
            /**
 * Parses a 2D array of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.Parse2DArray
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number[][]} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The MapData object.
 */ var Parse2DArray = function(name, data, tileWidth, tileHeight, insertNull) {
                var layerData = new LayerData({
                    tileWidth: tileWidth,
                    tileHeight: tileHeight
                });
                var mapData = new MapData({
                    name: name,
                    tileWidth: tileWidth,
                    tileHeight: tileHeight,
                    format: Formats.ARRAY_2D,
                    layers: [
                        layerData
                    ]
                });
                var tiles = [];
                var height = data.length;
                var width = 0;
                for(var y = 0; y < data.length; y++){
                    tiles[y] = [];
                    var row = data[y];
                    for(var x = 0; x < row.length; x++){
                        var tileIndex = parseInt(row[x], 10);
                        if (isNaN(tileIndex) || tileIndex === -1) tiles[y][x] = insertNull ? null : new Tile(layerData, -1, x, y, tileWidth, tileHeight);
                        else tiles[y][x] = new Tile(layerData, tileIndex, x, y, tileWidth, tileHeight);
                    }
                    if (width === 0) width = row.length;
                }
                mapData.width = layerData.width = width;
                mapData.height = layerData.height = height;
                mapData.widthInPixels = layerData.widthInPixels = width * tileWidth;
                mapData.heightInPixels = layerData.heightInPixels = height * tileHeight;
                layerData.data = tiles;
                return mapData;
            };
            module1.exports = Parse2DArray;
        /***/ },
        /* 256 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pick = __webpack_require__(567);
            var ParseGID = __webpack_require__(257);
            var copyPoints = function(p) {
                return {
                    x: p.x,
                    y: p.y
                };
            };
            var commonObjectProps = [
                'id',
                'name',
                'type',
                'rotation',
                'properties',
                'visible',
                'x',
                'y',
                'width',
                'height'
            ];
            /**
 * Convert a Tiled object to an internal parsed object normalising and copying properties over, while applying optional x and y offsets. The parsed object will always have the properties `id`, `name`, `type`, `rotation`, `properties`, `visible`, `x`, `y`, `width` and `height`. Other properties will be added according to the object type (such as text, polyline, gid etc.)
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObject
 * @since 3.0.0
 *
 * @param {object} tiledObject - Tiled object to convert to an internal parsed object normalising and copying properties over.
 * @param {number} [offsetX=0] - Optional additional offset to apply to the object's x property. Defaults to 0.
 * @param {number} [offsetY=0] - Optional additional offset to apply to the object's y property. Defaults to 0.
 *
 * @return {object} The parsed object containing properties read from the Tiled object according to it's type with x and y values updated according to the given offsets.
 */ var ParseObject = function(tiledObject, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                var parsedObject = Pick(tiledObject, commonObjectProps);
                parsedObject.x += offsetX;
                parsedObject.y += offsetY;
                if (tiledObject.gid) {
                    //  Object tiles
                    var gidInfo = ParseGID(tiledObject.gid);
                    parsedObject.gid = gidInfo.gid;
                    parsedObject.flippedHorizontal = gidInfo.flippedHorizontal;
                    parsedObject.flippedVertical = gidInfo.flippedVertical;
                    parsedObject.flippedAntiDiagonal = gidInfo.flippedAntiDiagonal;
                } else if (tiledObject.polyline) parsedObject.polyline = tiledObject.polyline.map(copyPoints);
                else if (tiledObject.polygon) parsedObject.polygon = tiledObject.polygon.map(copyPoints);
                else if (tiledObject.ellipse) parsedObject.ellipse = tiledObject.ellipse;
                else if (tiledObject.text) parsedObject.text = tiledObject.text;
                else if (tiledObject.point) parsedObject.point = true;
                else // Otherwise, assume it is a rectangle
                parsedObject.rectangle = true;
                return parsedObject;
            };
            module1.exports = ParseObject;
        /***/ },
        /* 257 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FLIPPED_HORIZONTAL = 0x80000000;
            var FLIPPED_VERTICAL = 0x40000000;
            var FLIPPED_ANTI_DIAGONAL = 0x20000000; // Top-right is swapped with bottom-left corners
            /**
 * See Tiled documentation on tile flipping:
 * http://docs.mapeditor.org/en/latest/reference/tmx-map-format/
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseGID
 * @since 3.0.0
 *
 * @param {number} gid - A Tiled GID.
 *
 * @return {Phaser.Types.Tilemaps.GIDData} The GID Data.
 */ var ParseGID = function(gid) {
                var flippedHorizontal = Boolean(gid & FLIPPED_HORIZONTAL);
                var flippedVertical = Boolean(gid & FLIPPED_VERTICAL);
                var flippedAntiDiagonal = Boolean(gid & FLIPPED_ANTI_DIAGONAL);
                gid = gid & ~(FLIPPED_HORIZONTAL | FLIPPED_VERTICAL | FLIPPED_ANTI_DIAGONAL);
                // Parse the flip flags into something Phaser can use
                var rotation = 0;
                var flipped = false;
                if (flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                    rotation = Math.PI / 2;
                    flipped = true;
                } else if (flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                    rotation = Math.PI;
                    flipped = false;
                } else if (flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                    rotation = Math.PI / 2;
                    flipped = false;
                } else if (flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                    rotation = 0;
                    flipped = true;
                } else if (!flippedHorizontal && flippedVertical && flippedAntiDiagonal) {
                    rotation = 3 * Math.PI / 2;
                    flipped = false;
                } else if (!flippedHorizontal && flippedVertical && !flippedAntiDiagonal) {
                    rotation = Math.PI;
                    flipped = true;
                } else if (!flippedHorizontal && !flippedVertical && flippedAntiDiagonal) {
                    rotation = 3 * Math.PI / 2;
                    flipped = true;
                } else if (!flippedHorizontal && !flippedVertical && !flippedAntiDiagonal) {
                    rotation = 0;
                    flipped = false;
                }
                return {
                    gid: gid,
                    flippedHorizontal: flippedHorizontal,
                    flippedVertical: flippedVertical,
                    flippedAntiDiagonal: flippedAntiDiagonal,
                    rotation: rotation,
                    flipped: flipped
                };
            };
            module1.exports = ParseGID;
        /***/ },
        /* 258 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(39);
            var MapData = __webpack_require__(120);
            var Parse = __webpack_require__(560);
            var Tilemap = __webpack_require__(576);
            /**
 * Create a Tilemap from the given key or data. If neither is given, make a blank Tilemap. When
 * loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing from
 * a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map data. For
 * an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @function Phaser.Tilemaps.ParseToTilemap
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels.
 * @param {number} [tileHeight=32] - The height of a tile in pixels.
 * @param {number} [width=10] - The width of the map in tiles.
 * @param {number} [height=10] - The height of the map in tiles.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.Tilemap}
 */ var ParseToTilemap = function(scene, key, tileWidth, tileHeight, width, height, data, insertNull) {
                if (tileWidth === undefined) tileWidth = 32;
                if (tileHeight === undefined) tileHeight = 32;
                if (width === undefined) width = 10;
                if (height === undefined) height = 10;
                if (insertNull === undefined) insertNull = false;
                var mapData = null;
                if (Array.isArray(data)) {
                    var name = key !== undefined ? key : 'map';
                    mapData = Parse(name, Formats.ARRAY_2D, data, tileWidth, tileHeight, insertNull);
                } else if (key !== undefined) {
                    var tilemapData = scene.cache.tilemap.get(key);
                    if (!tilemapData) console.warn('No map data found for key ' + key);
                    else mapData = Parse(key, tilemapData.format, tilemapData.data, tileWidth, tileHeight, insertNull);
                }
                if (mapData === null) mapData = new MapData({
                    tileWidth: tileWidth,
                    tileHeight: tileHeight,
                    width: width,
                    height: height
                });
                return new Tilemap(scene, mapData);
            };
            module1.exports = ParseToTilemap;
        /***/ },
        /* 259 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Extracts an array of targets from a Tween configuration object.
 *
 * The targets will be looked for in a `targets` property. If it's a function, its return value will be used as the result.
 *
 * @function Phaser.Tweens.Builders.GetTargets
 * @since 3.0.0
 *
 * @param {object} config - The configuration object to use.
 *
 * @return {array} An array of targets (may contain only one element), or `null` if no targets were specified.
 */ var GetTargets = function(config) {
                var targets = GetValue(config, 'targets', null);
                if (targets === null) return targets;
                if (typeof targets === 'function') targets = targets.call();
                if (!Array.isArray(targets)) targets = [
                    targets
                ];
                return targets;
            };
            module1.exports = GetTargets;
        /***/ },
        /* 260 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function hasGetActive(def) {
                return !!def.getActive && typeof def.getActive === 'function';
            }
            /**
 * @ignore
 */ function hasGetStart(def) {
                return !!def.getStart && typeof def.getStart === 'function';
            }
            /**
 * @ignore
 */ function hasGetEnd(def) {
                return !!def.getEnd && typeof def.getEnd === 'function';
            }
            /**
 * @ignore
 */ function hasGetters(def) {
                return hasGetStart(def) || hasGetEnd(def) || hasGetActive(def);
            }
            /**
 * Returns `getActive`, `getStart` and `getEnd` functions for a TweenData based on a target property and end value.
 * 
 * `getActive` if not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * `getEnd` is invoked once any start delays have expired and returns what the value should tween to.
 * `getStart` is invoked when the tween reaches the end and needs to either repeat or yoyo, it returns the value to go back to.
 *
 * If the end value is a number, it will be treated as an absolute value and the property will be tweened to it.
 * A string can be provided to specify a relative end value which consists of an operation
 * (`+=` to add to the current value, `-=` to subtract from the current value, `*=` to multiply the current
 * value, or `/=` to divide the current value) followed by its operand.
 * 
 * A function can be provided to allow greater control over the end value; it will receive the target
 * object being tweened, the name of the property being tweened, and the current value of the property
 * as its arguments.
 * 
 * If both the starting and the ending values need to be controlled, an object with `getStart` and `getEnd`
 * callbacks, which will receive the same arguments, can be provided instead. If an object with a `value`
 * property is provided, the property will be used as the effective value under the same rules described here.
 *
 * @function Phaser.Tweens.Builders.GetValueOp
 * @since 3.0.0
 *
 * @param {string} key - The name of the property to modify.
 * @param {*} propertyValue - The ending value of the property, as described above.
 *
 * @return {function} An array of functions, `getActive`, `getStart` and `getEnd`, which return the starting and the ending value of the property based on the provided value.
 */ var GetValueOp = function(key, propertyValue) {
                var callbacks;
                //  The returned value sets what the property will be at the END of the Tween (usually called at the start of the Tween)
                var getEnd = function(target, key, value) {
                    return value;
                };
                //  The returned value sets what the property will be at the START of the Tween (usually called at the end of the Tween)
                var getStart = function(target, key, value) {
                    return value;
                };
                //  What to set the property to the moment the TweenData is invoked
                var getActive = null;
                var t = typeof propertyValue;
                if (t === 'number') // props: {
                //     x: 400,
                //     y: 300
                // }
                getEnd = function() {
                    return propertyValue;
                };
                else if (t === 'string') {
                    // props: {
                    //     x: '+=400',
                    //     y: '-=300',
                    //     z: '*=2',
                    //     w: '/=2'
                    // }
                    var op = propertyValue[0];
                    var num = parseFloat(propertyValue.substr(2));
                    switch(op){
                        case '+':
                            getEnd = function(target, key, value) {
                                return value + num;
                            };
                            break;
                        case '-':
                            getEnd = function(target, key, value) {
                                return value - num;
                            };
                            break;
                        case '*':
                            getEnd = function(target, key, value) {
                                return value * num;
                            };
                            break;
                        case '/':
                            getEnd = function(target, key, value) {
                                return value / num;
                            };
                            break;
                        default:
                            getEnd = function() {
                                return parseFloat(propertyValue);
                            };
                    }
                } else if (t === 'function') //  The same as setting just the getEnd function and no getStart
                // props: {
                //     x: function (target, key, value, targetIndex, totalTargets, tween) { return value + 50); },
                // }
                getEnd = propertyValue;
                else if (t === 'object') {
                    if (hasGetters(propertyValue)) {
                        /*
            x: {
                //  Called the moment Tween is active. The returned value sets the property on the target immediately.
                getActive: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                },

                //  Called at the start of the Tween. The returned value sets what the property will be at the END of the Tween.
                getEnd: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                },

                //  Called at the end of the Tween. The returned value sets what the property will be at the START of the Tween.
                getStart: function (target, key, value, targetIndex, totalTargets, tween)
                {
                    return value;
                }
            }
            */ if (hasGetActive(propertyValue)) getActive = propertyValue.getActive;
                        if (hasGetEnd(propertyValue)) getEnd = propertyValue.getEnd;
                        if (hasGetStart(propertyValue)) getStart = propertyValue.getStart;
                    } else if (propertyValue.hasOwnProperty('value')) //  'value' may still be a string, function or a number
                    // props: {
                    //     x: { value: 400, ... },
                    //     y: { value: 300, ... }
                    // }
                    callbacks = GetValueOp(key, propertyValue.value);
                    else {
                        //  'from' and 'to' may still be a string, function or a number
                        // props: {
                        //     x: { from: 400, to: 600 },
                        //     y: { from: 300, to: 500 }
                        // }
                        //  Same as above, but the 'start' value is set immediately on the target
                        // props: {
                        //     x: { start: 400, to: 600 },
                        //     y: { start: 300, to: 500 }
                        // }
                        //  'start' value is set immediately, then it goes 'from' to 'to' during the tween
                        // props: {
                        //     x: { start: 200, from: 400, to: 600 },
                        //     y: { start: 300, from: 300, to: 500 }
                        // }
                        var hasTo = propertyValue.hasOwnProperty('to');
                        var hasFrom = propertyValue.hasOwnProperty('from');
                        var hasStart = propertyValue.hasOwnProperty('start');
                        if (hasTo && (hasFrom || hasStart)) {
                            callbacks = GetValueOp(key, propertyValue.to);
                            if (hasStart) {
                                var startCallbacks = GetValueOp(key, propertyValue.start);
                                callbacks.getActive = startCallbacks.getEnd;
                            }
                            if (hasFrom) {
                                var fromCallbacks = GetValueOp(key, propertyValue.from);
                                callbacks.getStart = fromCallbacks.getEnd;
                            }
                        }
                    }
                }
                //  If callback not set by the else if block above then set it here and return it
                if (!callbacks) callbacks = {
                    getActive: getActive,
                    getEnd: getEnd,
                    getStart: getStart
                };
                return callbacks;
            };
            module1.exports = GetValueOp;
        /***/ },
        /* 261 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Types.Tweens.TweenConfigDefaults
 * @since 3.0.0
 * 
 * @property {(object|object[])} targets - The object, or an array of objects, to run the tween on.
 * @property {number} [delay=0] - The number of milliseconds to delay before the tween will start.
 * @property {number} [duration=1000] - The duration of the tween in milliseconds.
 * @property {string} [ease='Power0'] - The easing equation to use for the tween.
 * @property {array} [easeParams] - Optional easing parameters.
 * @property {number} [hold=0] - The number of milliseconds to hold the tween for before yoyo'ing.
 * @property {number} [repeat=0] - The number of times to repeat the tween.
 * @property {number} [repeatDelay=0] - The number of milliseconds to pause before a tween will repeat.
 * @property {boolean} [yoyo=false] - Should the tween complete, then reverse the values incrementally to get back to the starting tween values? The reverse tweening will also take `duration` milliseconds to complete.
 * @property {boolean} [flipX=false] - Horizontally flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipX` property.
 * @property {boolean} [flipY=false] - Vertically flip the target of the Tween when it completes (before it yoyos, if set to do so). Only works for targets that support the `flipY` property.
 */ var TWEEN_DEFAULTS = {
                targets: null,
                delay: 0,
                duration: 1000,
                ease: 'Power0',
                easeParams: null,
                hold: 0,
                repeat: 0,
                repeatDelay: 0,
                yoyo: false,
                flipX: false,
                flipY: false
            };
            module1.exports = TWEEN_DEFAULTS;
        /***/ },
        /* 262 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(263);
            var GameObjectCreator = __webpack_require__(16);
            var GameObjectFactory = __webpack_require__(5);
            var TWEEN_CONST = __webpack_require__(97);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Tween is able to manipulate the properties of one or more objects to any given value, based
 * on a duration and type of ease. They are rarely instantiated directly and instead should be
 * created via the TweenManager.
 *
 * @class Tween
 * @memberof Phaser.Tweens
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - A reference to the parent of this Tween. Either the Tween Manager or a Tween Timeline instance.
 * @param {Phaser.Types.Tweens.TweenDataConfig[]} data - An array of TweenData objects, each containing a unique property to be tweened.
 * @param {array} targets - An array of targets to be tweened.
 */ var Tween = new Class({
                Extends: EventEmitter,
                initialize: function Tween(parent, data, targets) {
                    EventEmitter.call(this);
                    /**
         * A reference to the parent of this Tween.
         * Either the Tween Manager or a Tween Timeline instance.
         *
         * @name Phaser.Tweens.Tween#parent
         * @type {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)}
         * @since 3.0.0
         */ this.parent = parent;
                    /**
         * Is the parent of this Tween a Timeline?
         *
         * @name Phaser.Tweens.Tween#parentIsTimeline
         * @type {boolean}
         * @since 3.0.0
         */ this.parentIsTimeline = parent.hasOwnProperty('isTimeline');
                    /**
         * An array of TweenData objects, each containing a unique property and target being tweened.
         *
         * @name Phaser.Tweens.Tween#data
         * @type {Phaser.Types.Tweens.TweenDataConfig[]}
         * @since 3.0.0
         */ this.data = data;
                    /**
         * The cached length of the data array.
         *
         * @name Phaser.Tweens.Tween#totalData
         * @type {number}
         * @since 3.0.0
         */ this.totalData = data.length;
                    /**
         * An array of references to the target/s this Tween is operating on.
         *
         * @name Phaser.Tweens.Tween#targets
         * @type {object[]}
         * @since 3.0.0
         */ this.targets = targets;
                    /**
         * Cached target total (not necessarily the same as the data total)
         *
         * @name Phaser.Tweens.Tween#totalTargets
         * @type {number}
         * @since 3.0.0
         */ this.totalTargets = targets.length;
                    /**
         * If `true` then duration, delay, etc values are all frame totals.
         *
         * @name Phaser.Tweens.Tween#useFrames
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useFrames = false;
                    /**
         * Scales the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
         * Value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
         *
         * @name Phaser.Tweens.Tween#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Loop this tween? Can be -1 for an infinite loop, or an integer.
         * When enabled it will play through ALL TweenDatas again. Use TweenData.repeat to loop a single element.
         *
         * @name Phaser.Tweens.Tween#loop
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loop = 0;
                    /**
         * Time in ms/frames before the tween loops.
         *
         * @name Phaser.Tweens.Tween#loopDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopDelay = 0;
                    /**
         * How many loops are left to run?
         *
         * @name Phaser.Tweens.Tween#loopCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopCounter = 0;
                    /**
         * Time in ms/frames before the 'onStart' event fires.
         * This is the shortest `delay` value across all of the TweenDatas of this Tween.
         *
         * @name Phaser.Tweens.Tween#startDelay
         * @type {number}
         * @default 0
         * @since 3.19.0
         */ this.startDelay = 0;
                    /**
         * Has this Tween started playback yet?
         * This boolean is toggled when the Tween leaves the 'delayed' state and starts running.
         *
         * @name Phaser.Tweens.Tween#hasStarted
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.hasStarted = false;
                    /**
         * Is this Tween currently seeking?
         * This boolean is toggled in the `Tween.seek` method.
         * When a tween is seeking it will not dispatch any events or callbacks.
         *
         * @name Phaser.Tweens.Tween#isSeeking
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this.isSeeking = false;
                    /**
         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = -1 (as it never completes)
         *
         * @name Phaser.Tweens.Tween#completeDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.completeDelay = 0;
                    /**
         * Countdown timer (used by timeline offset, loopDelay and completeDelay)
         *
         * @name Phaser.Tweens.Tween#countdown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.countdown = 0;
                    /**
         * Set only if this Tween is part of a Timeline.
         *
         * @name Phaser.Tweens.Tween#offset
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.offset = 0;
                    /**
         * Set only if this Tween is part of a Timeline. The calculated offset amount.
         *
         * @name Phaser.Tweens.Tween#calculatedOffset
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.calculatedOffset = 0;
                    /**
         * The current state of the tween
         *
         * @name Phaser.Tweens.Tween#state
         * @type {number}
         * @since 3.0.0
         */ this.state = TWEEN_CONST.PENDING_ADD;
                    /**
         * The state of the tween when it was paused (used by Resume)
         *
         * @name Phaser.Tweens.Tween#_pausedState
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._pausedState = TWEEN_CONST.INIT;
                    /**
         * Does the Tween start off paused? (if so it needs to be started with Tween.play)
         *
         * @name Phaser.Tweens.Tween#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Elapsed time in ms/frames of this run through the Tween.
         *
         * @name Phaser.Tweens.Tween#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Total elapsed time in ms/frames of the entire Tween, including looping.
         *
         * @name Phaser.Tweens.Tween#totalElapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalElapsed = 0;
                    /**
         * Time in ms/frames for the whole Tween to play through once, excluding loop amounts and loop delays.
         *
         * @name Phaser.Tweens.Tween#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * Value between 0 and 1. The amount through the Tween, excluding loops.
         *
         * @name Phaser.Tweens.Tween#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Time in ms/frames for the Tween to complete (including looping)
         *
         * @name Phaser.Tweens.Tween#totalDuration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalDuration = 0;
                    /**
         * Value between 0 and 1. The amount through the entire Tween, including looping.
         *
         * @name Phaser.Tweens.Tween#totalProgress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalProgress = 0;
                    /**
         * An object containing the different Tween callback functions.
         *
         * You can either set these in the Tween config, or by calling the `Tween.setCallback` method.
         *
         * `onActive` When the Tween is moved from the pending to the active list in the Tween Manager, even if playback paused.
         * `onStart` When the Tween starts playing after a delayed state. Will happen at the same time as `onActive` if it has no delay.
         * `onYoyo` When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
         * `onRepeat` When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
         * `onComplete` When the Tween finishes playback fully. Never invoked if tween is set to repeat infinitely.
         * `onUpdate` When a TweenData updates a property on a source target during playback.
         * `onLoop` When a Tween loops. This happens _after_ the `loopDelay` expires, if set.
         *
         * @name Phaser.Tweens.Tween#callbacks
         * @type {object}
         * @since 3.0.0
         */ this.callbacks = {
                        onActive: null,
                        onComplete: null,
                        onLoop: null,
                        onRepeat: null,
                        onStart: null,
                        onStop: null,
                        onUpdate: null,
                        onYoyo: null
                    };
                    /**
         * The context in which all callbacks are invoked.
         *
         * @name Phaser.Tweens.Tween#callbackScope
         * @type {any}
         * @since 3.0.0
         */ this.callbackScope;
                },
                /**
     * Returns the current value of the specified Tween Data.
     *
     * @method Phaser.Tweens.Tween#getValue
     * @since 3.0.0
     *
     * @param {number} [index=0] - The Tween Data to return the value from.
     *
     * @return {number} The value of the requested Tween Data.
     */ getValue: function(index) {
                    if (index === undefined) index = 0;
                    return this.data[index].current;
                },
                /**
     * Set the scale the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
     *
     * @method Phaser.Tweens.Tween#setTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The scale factor for timescale.
     *
     * @return {this} - This Tween instance.
     */ setTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * Returns the scale of the time applied to this Tween.
     *
     * @method Phaser.Tweens.Tween#getTimeScale
     * @since 3.0.0
     *
     * @return {number} The timescale of this tween (between 0 and 1)
     */ getTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Checks if the Tween is currently active.
     *
     * @method Phaser.Tweens.Tween#isPlaying
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Tween is active, otherwise `false`.
     */ isPlaying: function() {
                    return this.state === TWEEN_CONST.ACTIVE;
                },
                /**
     * Checks if the Tween is currently paused.
     *
     * @method Phaser.Tweens.Tween#isPaused
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Tween is paused, otherwise `false`.
     */ isPaused: function() {
                    return this.state === TWEEN_CONST.PAUSED;
                },
                /**
     * See if this Tween is currently acting upon the given target.
     *
     * @method Phaser.Tweens.Tween#hasTarget
     * @since 3.0.0
     *
     * @param {object} target - The target to check against this Tween.
     *
     * @return {boolean} `true` if the given target is a target of this Tween, otherwise `false`.
     */ hasTarget: function(target) {
                    return this.targets.indexOf(target) !== -1;
                },
                /**
     * Updates the 'end' value of the given property across all matching targets.
     *
     * Calling this does not adjust the duration of the tween, or the current progress.
     *
     * You can optionally tell it to set the 'start' value to be the current value (before the change).
     *
     * @method Phaser.Tweens.Tween#updateTo
     * @since 3.0.0
     *
     * @param {string} key - The property to set the new value for.
     * @param {*} value - The new value of the property.
     * @param {boolean} [startToCurrent=false] - Should this change set the start value to be the current value?
     *
     * @return {this} - This Tween instance.
     */ updateTo: function(key, value, startToCurrent) {
                    if (startToCurrent === undefined) startToCurrent = false;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = this.data[i];
                        if (tweenData.key === key) {
                            tweenData.end = value;
                            if (startToCurrent) tweenData.start = tweenData.current;
                        }
                    }
                    return this;
                },
                /**
     * Restarts the tween from the beginning.
     *
     * @method Phaser.Tweens.Tween#restart
     * @since 3.0.0
     *
     * @return {this} This Tween instance.
     */ restart: function() {
                    //  Reset these so they're ready for the next update
                    this.elapsed = 0;
                    this.progress = 0;
                    this.totalElapsed = 0;
                    this.totalProgress = 0;
                    if (this.state === TWEEN_CONST.ACTIVE) return this.seek(0);
                    else if (this.state === TWEEN_CONST.REMOVED) {
                        this.seek(0);
                        this.parent.makeActive(this);
                        return this;
                    } else if (this.state === TWEEN_CONST.PENDING_ADD) return this;
                    else return this.play();
                },
                /**
     * Internal method that calculates the overall duration of the Tween.
     *
     * @method Phaser.Tweens.Tween#calcDuration
     * @since 3.0.0
     */ calcDuration: function() {
                    var maxDuration = 0;
                    var minDelay = MATH_CONST.MAX_SAFE_INTEGER;
                    var data = this.data;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        //  Set t1 (duration + hold + yoyo)
                        tweenData.t1 = tweenData.duration + tweenData.hold;
                        if (tweenData.yoyo) tweenData.t1 += tweenData.duration;
                        //  Set t2 (repeatDelay + duration + hold + yoyo)
                        tweenData.t2 = tweenData.t1 + tweenData.repeatDelay;
                        //  Total Duration
                        tweenData.totalDuration = tweenData.delay + tweenData.t1;
                        if (tweenData.repeat === -1) tweenData.totalDuration += tweenData.t2 * 999999999999;
                        else if (tweenData.repeat > 0) tweenData.totalDuration += tweenData.t2 * tweenData.repeat;
                        if (tweenData.totalDuration > maxDuration) //  Get the longest TweenData from the Tween, used to calculate the Tween TD
                        maxDuration = tweenData.totalDuration;
                        if (tweenData.delay < minDelay) minDelay = tweenData.delay;
                    }
                    //  Excludes loop values
                    //  If duration has been set to 0 then we give it a super-low value so that it always
                    //  renders at least 1 frame, but no more, without causing divided by zero errors elsewhere.
                    this.duration = Math.max(maxDuration, 0.001);
                    this.loopCounter = this.loop === -1 ? 999999999999 : this.loop;
                    if (this.loopCounter > 0) this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter;
                    else this.totalDuration = this.duration + this.completeDelay;
                    //  How long before this Tween starts playback?
                    this.startDelay = minDelay;
                },
                /**
     * Called by TweenManager.preUpdate as part of its loop to check pending and active tweens.
     * Should not be called directly.
     *
     * @method Phaser.Tweens.Tween#init
     * @since 3.0.0
     *
     * @return {boolean} Returns `true` if this Tween should be moved from the pending list to the active list by the Tween Manager.
     */ init: function() {
                    //  You can't have a paused Tween if it's part of a Timeline
                    if (this.paused && !this.parentIsTimeline) {
                        this.state = TWEEN_CONST.PENDING_ADD;
                        this._pausedState = TWEEN_CONST.INIT;
                        return false;
                    }
                    var data = this.data;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var gen = tweenData.gen;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        //  Old function signature: i, totalTargets, target
                        //  New function signature: target, key, value, index, total, tween
                        tweenData.delay = gen.delay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.duration = Math.max(gen.duration(target, key, 0, targetIndex, totalTargets, this), 0.001);
                        tweenData.hold = gen.hold(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeat = gen.repeat(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeatDelay = gen.repeatDelay(target, key, 0, targetIndex, totalTargets, this);
                    }
                    this.calcDuration();
                    this.progress = 0;
                    this.totalProgress = 0;
                    this.elapsed = 0;
                    this.totalElapsed = 0;
                    this.state = TWEEN_CONST.INIT;
                    return true;
                },
                /**
     * Internal method that makes this Tween active within the TweenManager
     * and emits the onActive event and callback.
     *
     * @method Phaser.Tweens.Tween#makeActive
     * @fires Phaser.Tweens.Events#TWEEN_ACTIVE
     * @since 3.19.0
     */ makeActive: function() {
                    this.parent.makeActive(this);
                    this.dispatchTweenEvent(Events.TWEEN_ACTIVE, this.callbacks.onActive);
                },
                /**
     * Internal method that advances to the next state of the Tween during playback.
     *
     * @method Phaser.Tweens.Tween#nextState
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @since 3.0.0
     */ nextState: function() {
                    if (this.loopCounter > 0) {
                        this.elapsed = 0;
                        this.progress = 0;
                        this.loopCounter--;
                        this.resetTweenData(true);
                        if (this.loopDelay > 0) {
                            this.countdown = this.loopDelay;
                            this.state = TWEEN_CONST.LOOP_DELAY;
                        } else {
                            this.state = TWEEN_CONST.ACTIVE;
                            this.dispatchTweenEvent(Events.TWEEN_LOOP, this.callbacks.onLoop);
                        }
                    } else if (this.completeDelay > 0) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = this.completeDelay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                    }
                },
                /**
     * Pauses the Tween immediately. Use `resume` to continue playback.
     *
     * @method Phaser.Tweens.Tween#pause
     * @since 3.0.0
     *
     * @return {this} - This Tween instance.
     */ pause: function() {
                    if (this.state === TWEEN_CONST.PAUSED) return this;
                    this.paused = true;
                    this._pausedState = this.state;
                    this.state = TWEEN_CONST.PAUSED;
                    return this;
                },
                /**
     * Starts a Tween playing.
     *
     * You only need to call this method if you have configured the tween to be paused on creation.
     *
     * If the Tween is already playing, calling this method again will have no effect. If you wish to
     * restart the Tween, use `Tween.restart` instead.
     *
     * Calling this method after the Tween has completed will start the Tween playing again from the start.
     * This is the same as calling `Tween.seek(0)` and then `Tween.play()`.
     *
     * @method Phaser.Tweens.Tween#play
     * @since 3.0.0
     *
     * @param {boolean} [resetFromTimeline=false] - Is this Tween being played as part of a Timeline?
     *
     * @return {this} This Tween instance.
     */ play: function(resetFromTimeline) {
                    if (resetFromTimeline === undefined) resetFromTimeline = false;
                    var state = this.state;
                    if (state === TWEEN_CONST.INIT && !this.parentIsTimeline) {
                        this.resetTweenData(false);
                        this.state = TWEEN_CONST.ACTIVE;
                        return this;
                    } else if (state === TWEEN_CONST.ACTIVE || state === TWEEN_CONST.PENDING_ADD && this._pausedState === TWEEN_CONST.PENDING_ADD) return this;
                    else if (!this.parentIsTimeline && (state === TWEEN_CONST.PENDING_REMOVE || state === TWEEN_CONST.REMOVED)) {
                        this.seek(0);
                        this.parent.makeActive(this);
                        return this;
                    }
                    if (this.parentIsTimeline) {
                        this.resetTweenData(resetFromTimeline);
                        if (this.calculatedOffset === 0) this.state = TWEEN_CONST.ACTIVE;
                        else {
                            this.countdown = this.calculatedOffset;
                            this.state = TWEEN_CONST.OFFSET_DELAY;
                        }
                    } else if (this.paused) {
                        this.paused = false;
                        this.makeActive();
                    } else {
                        this.resetTweenData(resetFromTimeline);
                        this.state = TWEEN_CONST.ACTIVE;
                        this.makeActive();
                    }
                    return this;
                },
                /**
     * Internal method that resets all of the Tween Data, including the progress and elapsed values.
     *
     * @method Phaser.Tweens.Tween#resetTweenData
     * @since 3.0.0
     *
     * @param {boolean} resetFromLoop - Has this method been called as part of a loop?
     */ resetTweenData: function(resetFromLoop) {
                    var data = this.data;
                    var total = this.totalData;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < total; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        tweenData.progress = 0;
                        tweenData.elapsed = 0;
                        tweenData.repeatCounter = tweenData.repeat === -1 ? 999999999999 : tweenData.repeat;
                        if (resetFromLoop) {
                            tweenData.start = tweenData.getStartValue(target, key, tweenData.start, targetIndex, totalTargets, this);
                            tweenData.end = tweenData.getEndValue(target, key, tweenData.end, targetIndex, totalTargets, this);
                            tweenData.current = tweenData.start;
                            tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                        } else tweenData.state = TWEEN_CONST.PENDING_RENDER;
                        if (tweenData.delay > 0) {
                            tweenData.elapsed = tweenData.delay;
                            tweenData.state = TWEEN_CONST.DELAY;
                        }
                        if (tweenData.getActiveValue) target[key] = tweenData.getActiveValue(tweenData.target, tweenData.key, tweenData.start);
                    }
                },
                /**
     * Resumes the playback of a previously paused Tween.
     *
     * @method Phaser.Tweens.Tween#resume
     * @since 3.0.0
     *
     * @return {this} - This Tween instance.
     */ resume: function() {
                    if (this.state === TWEEN_CONST.PAUSED) {
                        this.paused = false;
                        this.state = this._pausedState;
                    } else this.play();
                    return this;
                },
                /**
     * Seeks to a specific point in the Tween.
     *
     * **Note:** Be careful when seeking a Tween that repeats or loops forever,
     * or that has an unusually long total duration, as it's possible to hang the browser.
     *
     * The given position is a value between 0 and 1 which represents how far through the Tween to seek to.
     * A value of 0.5 would seek to half-way through the Tween, where-as a value of zero would seek to the start.
     *
     * Note that the seek takes the entire duration of the Tween into account, including delays, loops and repeats.
     * For example, a Tween that lasts for 2 seconds, but that loops 3 times, would have a total duration of 6 seconds,
     * so seeking to 0.5 would seek to 3 seconds into the Tween, as that's half-way through its _entire_ duration.
     *
     * Seeking works by resetting the Tween to its initial values and then iterating through the Tween at `delta`
     * jumps per step. The longer the Tween, the longer this can take.
     *
     * @method Phaser.Tweens.Tween#seek
     * @since 3.0.0
     *
     * @param {number} toPosition - A value between 0 and 1 which represents the progress point to seek to.
     * @param {number} [delta=16.6] - The size of each step when seeking through the Tween. A higher value completes faster but at a cost of less precision.
     *
     * @return {this} This Tween instance.
     */ seek: function(toPosition, delta) {
                    if (delta === undefined) delta = 16.6;
                    if (this.state === TWEEN_CONST.REMOVED) this.makeActive();
                    this.elapsed = 0;
                    this.progress = 0;
                    this.totalElapsed = 0;
                    this.totalProgress = 0;
                    var data = this.data;
                    var totalTargets = this.totalTargets;
                    for(var i = 0; i < this.totalData; i++){
                        var tweenData = data[i];
                        var target = tweenData.target;
                        var gen = tweenData.gen;
                        var key = tweenData.key;
                        var targetIndex = tweenData.index;
                        tweenData.progress = 0;
                        tweenData.elapsed = 0;
                        tweenData.repeatCounter = tweenData.repeat === -1 ? 999999999999 : tweenData.repeat;
                        //  Old function signature: i, totalTargets, target
                        //  New function signature: target, key, value, index, total, tween
                        tweenData.delay = gen.delay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.duration = Math.max(gen.duration(target, key, 0, targetIndex, totalTargets, this), 0.001);
                        tweenData.hold = gen.hold(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeat = gen.repeat(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.repeatDelay = gen.repeatDelay(target, key, 0, targetIndex, totalTargets, this);
                        tweenData.current = tweenData.start;
                        tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                        this.updateTweenData(this, tweenData, 0, targetIndex, totalTargets);
                        if (tweenData.delay > 0) {
                            tweenData.elapsed = tweenData.delay;
                            tweenData.state = TWEEN_CONST.DELAY;
                        }
                    }
                    this.calcDuration();
                    var wasPaused = false;
                    if (this.state === TWEEN_CONST.PAUSED) {
                        wasPaused = true;
                        this.state = TWEEN_CONST.ACTIVE;
                    }
                    this.isSeeking = true;
                    do this.update(0, delta);
                    while (this.totalProgress < toPosition);
                    this.isSeeking = false;
                    if (wasPaused) this.state = TWEEN_CONST.PAUSED;
                    return this;
                },
                /**
     * Sets an event based callback to be invoked during playback.
     *
     * Calling this method will replace a previously set callback for the given type, if any exists.
     *
     * The types available are:
     *
     * `onActive` When the Tween is moved from the pending to the active list in the Tween Manager, even if playback paused.
     * `onStart` When the Tween starts playing after a delayed state. Will happen at the same time as `onActive` if it has no delay.
     * `onYoyo` When a TweenData starts a yoyo. This happens _after_ the `hold` delay expires, if set.
     * `onRepeat` When a TweenData repeats playback. This happens _after_ the `repeatDelay` expires, if set.
     * `onComplete` When the Tween finishes playback fully or `Tween.stop` is called. Never invoked if tween is set to repeat infinitely.
     * `onUpdate` When a TweenData updates a property on a source target during playback.
     * `onLoop` When a Tween loops. This happens _after_ the `loopDelay` expires, if set.
     *
     * @method Phaser.Tweens.Tween#setCallback
     * @since 3.0.0
     *
     * @param {string} type - Type of the callback to set.
     * @param {function} callback - The function to invoke when this callback happens.
     * @param {array} [params] - An array of parameters for specified callbacks types.
     * @param {any} [scope] - The context the callback will be invoked in.
     *
     * @return {this} This Tween instance.
     */ setCallback: function(type, callback, params, scope) {
                    this.callbacks[type] = {
                        func: callback,
                        scope: scope,
                        params: params
                    };
                    return this;
                },
                /**
     * Flags the Tween as being complete, whatever stage of progress it is at.
     *
     * If an onComplete callback has been defined it will automatically invoke it, unless a `delay`
     * argument is provided, in which case the Tween will delay for that period of time before calling the callback.
     *
     * If you don't need a delay, or have an onComplete callback, then call `Tween.stop` instead.
     *
     * @method Phaser.Tweens.Tween#complete
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @since 3.2.0
     *
     * @param {number} [delay=0] - The time to wait before invoking the complete callback. If zero it will fire immediately.
     *
     * @return {this} This Tween instance.
     */ complete: function(delay) {
                    if (delay === undefined) delay = 0;
                    if (delay) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = delay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                    }
                    return this;
                },
                /**
     * Immediately removes this Tween from the TweenManager and all of its internal arrays,
     * no matter what stage it as it. Then sets the tween state to `REMOVED`.
     *
     * You should dispose of your reference to this tween after calling this method, to
     * free it from memory.
     *
     * @method Phaser.Tweens.Tween#remove
     * @since 3.17.0
     *
     * @return {this} This Tween instance.
     */ remove: function() {
                    this.parent.remove(this);
                    return this;
                },
                /**
     * Stops the Tween immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Tween#stop
     * @since 3.0.0
     *
     * @param {number} [resetTo] - If you want to seek the tween, provide a value between 0 and 1.
     *
     * @return {this} This Tween instance.
     */ stop: function(resetTo) {
                    if (this.state === TWEEN_CONST.ACTIVE) {
                        if (resetTo !== undefined) this.seek(resetTo);
                    }
                    if (this.state !== TWEEN_CONST.REMOVED) {
                        if (this.state === TWEEN_CONST.PAUSED || this.state === TWEEN_CONST.PENDING_ADD) {
                            if (this.parentIsTimeline) {
                                this.parent.manager._destroy.push(this);
                                this.parent.manager._toProcess++;
                            } else {
                                this.parent._destroy.push(this);
                                this.parent._toProcess++;
                            }
                        }
                        this.dispatchTweenEvent(Events.TWEEN_STOP, this.callbacks.onStop);
                        this.removeAllListeners();
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                    }
                    return this;
                },
                /**
     * Internal method that advances the Tween based on the time values.
     *
     * @method Phaser.Tweens.Tween#update
     * @fires Phaser.Tweens.Events#TWEEN_COMPLETE
     * @fires Phaser.Tweens.Events#TWEEN_LOOP
     * @fires Phaser.Tweens.Events#TWEEN_START
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this Tween has finished and should be removed from the Tween Manager, otherwise returns `false`.
     */ update: function(timestamp, delta) {
                    if (this.state === TWEEN_CONST.PAUSED) return false;
                    if (this.useFrames) delta = 1 * this.parent.timeScale;
                    delta *= this.timeScale;
                    this.elapsed += delta;
                    this.progress = Math.min(this.elapsed / this.duration, 1);
                    this.totalElapsed += delta;
                    this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
                    switch(this.state){
                        case TWEEN_CONST.ACTIVE:
                            if (!this.hasStarted && !this.isSeeking) {
                                this.startDelay -= delta;
                                if (this.startDelay <= 0) {
                                    this.hasStarted = true;
                                    this.dispatchTweenEvent(Events.TWEEN_START, this.callbacks.onStart);
                                }
                            }
                            var stillRunning = false;
                            for(var i = 0; i < this.totalData; i++){
                                var tweenData = this.data[i];
                                if (this.updateTweenData(this, tweenData, delta)) stillRunning = true;
                            }
                            //  Anything still running? If not, we're done
                            if (!stillRunning) this.nextState();
                            break;
                        case TWEEN_CONST.LOOP_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.ACTIVE;
                                this.dispatchTweenEvent(Events.TWEEN_LOOP, this.callbacks.onLoop);
                            }
                            break;
                        case TWEEN_CONST.OFFSET_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) this.state = TWEEN_CONST.ACTIVE;
                            break;
                        case TWEEN_CONST.COMPLETE_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.PENDING_REMOVE;
                                this.dispatchTweenEvent(Events.TWEEN_COMPLETE, this.callbacks.onComplete);
                            }
                            break;
                    }
                    return this.state === TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Internal method that will emit a TweenData based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Tween#dispatchTweenDataEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData object that caused this event.
     */ dispatchTweenDataEvent: function(event, callback, tweenData) {
                    if (!this.isSeeking) {
                        this.emit(event, this, tweenData.key, tweenData.target, tweenData.current, tweenData.previous);
                        if (callback) {
                            callback.params[1] = tweenData.target;
                            callback.func.apply(callback.scope, callback.params);
                        }
                    }
                },
                /**
     * Internal method that will emit a Tween based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Tween#dispatchTweenEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchTweenEvent: function(event, callback) {
                    if (!this.isSeeking) {
                        this.emit(event, this, this.targets);
                        if (callback) {
                            callback.params[1] = this.targets;
                            callback.func.apply(callback.scope, callback.params);
                        }
                    }
                },
                /**
     * Internal method used as part of the playback process that sets a tween to play in reverse.
     *
     * @method Phaser.Tweens.Tween#setStateFromEnd
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @fires Phaser.Tweens.Events#TWEEN_YOYO
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     *
     * @return {number} The state of this Tween.
     */ setStateFromEnd: function(tween, tweenData, diff) {
                    if (tweenData.yoyo) {
                        //  We've hit the end of a Playing Forward TweenData and we have a yoyo
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        this.dispatchTweenDataEvent(Events.TWEEN_YOYO, tween.callbacks.onYoyo, tweenData);
                        tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        return TWEEN_CONST.PLAYING_BACKWARD;
                    } else if (tweenData.repeatCounter > 0) {
                        //  We've hit the end of a Playing Forward TweenData and we have a Repeat.
                        //  So we're going to go right back to the start to repeat it again.
                        tweenData.repeatCounter--;
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        //  Delay?
                        if (tweenData.repeatDelay > 0) {
                            tweenData.elapsed = tweenData.repeatDelay - diff;
                            tweenData.current = tweenData.start;
                            tweenData.target[tweenData.key] = tweenData.current;
                            return TWEEN_CONST.REPEAT_DELAY;
                        } else {
                            this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            return TWEEN_CONST.PLAYING_FORWARD;
                        }
                    }
                    return TWEEN_CONST.COMPLETE;
                },
                /**
     * Internal method used as part of the playback process that sets a tween to play from the start.
     *
     * @method Phaser.Tweens.Tween#setStateFromStart
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} diff - Any extra time that needs to be accounted for in the elapsed and progress values.
     *
     * @return {number} The state of this Tween.
     */ setStateFromStart: function(tween, tweenData, diff) {
                    if (tweenData.repeatCounter > 0) {
                        tweenData.repeatCounter--;
                        //  Account for any extra time we got from the previous frame
                        tweenData.elapsed = diff;
                        tweenData.progress = diff / tweenData.duration;
                        if (tweenData.flipX) tweenData.target.toggleFlipX();
                        if (tweenData.flipY) tweenData.target.toggleFlipY();
                        tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                        //  Delay?
                        if (tweenData.repeatDelay > 0) {
                            tweenData.elapsed = tweenData.repeatDelay - diff;
                            tweenData.current = tweenData.start;
                            tweenData.target[tweenData.key] = tweenData.current;
                            return TWEEN_CONST.REPEAT_DELAY;
                        } else {
                            this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            return TWEEN_CONST.PLAYING_FORWARD;
                        }
                    }
                    return TWEEN_CONST.COMPLETE;
                },
                /**
     * Internal method that advances the TweenData based on the time value given.
     *
     * @method Phaser.Tweens.Tween#updateTweenData
     * @fires Phaser.Tweens.Events#TWEEN_UPDATE
     * @fires Phaser.Tweens.Events#TWEEN_REPEAT
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to update.
     * @param {Phaser.Types.Tweens.TweenDataConfig} tweenData - The TweenData property to update.
     * @param {number} delta - Either a value in ms, or 1 if Tween.useFrames is true.
     *
     * @return {boolean} True if the tween is not complete (e.g., playing), or false if the tween is complete.
     */ updateTweenData: function(tween, tweenData, delta) {
                    var target = tweenData.target;
                    switch(tweenData.state){
                        case TWEEN_CONST.PLAYING_FORWARD:
                        case TWEEN_CONST.PLAYING_BACKWARD:
                            if (!target) {
                                tweenData.state = TWEEN_CONST.COMPLETE;
                                break;
                            }
                            var elapsed = tweenData.elapsed;
                            var duration = tweenData.duration;
                            var diff = 0;
                            elapsed += delta;
                            if (elapsed > duration) {
                                diff = elapsed - duration;
                                elapsed = duration;
                            }
                            var forward = tweenData.state === TWEEN_CONST.PLAYING_FORWARD;
                            var progress = elapsed / duration;
                            tweenData.elapsed = elapsed;
                            tweenData.progress = progress;
                            tweenData.previous = tweenData.current;
                            if (progress === 1) {
                                if (forward) {
                                    tweenData.current = tweenData.end;
                                    target[tweenData.key] = tweenData.end;
                                    if (tweenData.hold > 0) {
                                        tweenData.elapsed = tweenData.hold - diff;
                                        tweenData.state = TWEEN_CONST.HOLD_DELAY;
                                    } else tweenData.state = this.setStateFromEnd(tween, tweenData, diff);
                                } else {
                                    tweenData.current = tweenData.start;
                                    target[tweenData.key] = tweenData.start;
                                    tweenData.state = this.setStateFromStart(tween, tweenData, diff);
                                }
                            } else {
                                var v = forward ? tweenData.ease(progress) : tweenData.ease(1 - progress);
                                tweenData.current = tweenData.start + (tweenData.end - tweenData.start) * v;
                                target[tweenData.key] = tweenData.current;
                            }
                            this.dispatchTweenDataEvent(Events.TWEEN_UPDATE, tween.callbacks.onUpdate, tweenData);
                            break;
                        case TWEEN_CONST.DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) {
                                tweenData.elapsed = Math.abs(tweenData.elapsed);
                                tweenData.state = TWEEN_CONST.PENDING_RENDER;
                            }
                            break;
                        case TWEEN_CONST.REPEAT_DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) {
                                tweenData.elapsed = Math.abs(tweenData.elapsed);
                                tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                                this.dispatchTweenDataEvent(Events.TWEEN_REPEAT, tween.callbacks.onRepeat, tweenData);
                            }
                            break;
                        case TWEEN_CONST.HOLD_DELAY:
                            tweenData.elapsed -= delta;
                            if (tweenData.elapsed <= 0) tweenData.state = this.setStateFromEnd(tween, tweenData, Math.abs(tweenData.elapsed));
                            break;
                        case TWEEN_CONST.PENDING_RENDER:
                            if (target) {
                                tweenData.start = tweenData.getStartValue(target, tweenData.key, target[tweenData.key], tweenData.index, tween.totalTargets, tween);
                                tweenData.end = tweenData.getEndValue(target, tweenData.key, tweenData.start, tweenData.index, tween.totalTargets, tween);
                                tweenData.current = tweenData.start;
                                target[tweenData.key] = tweenData.start;
                                tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
                            } else tweenData.state = TWEEN_CONST.COMPLETE;
                            break;
                    }
                    //  Return TRUE if this TweenData still playing, otherwise return FALSE
                    return tweenData.state !== TWEEN_CONST.COMPLETE;
                }
            });
            //  onActive = 'active' event = When the Tween is moved from the pending to the active list in the manager, even if playback delayed
            //  onStart = 'start' event = When the Tween starts playing from a delayed state (will happen same time as onActive if no delay)
            //  onStop = 'stop' event = When the Tween is stopped
            //  onYoyo = 'yoyo' event = When the Tween starts a yoyo
            //  onRepeat = 'repeat' event = When a TweenData repeats playback (if any)
            //  onComplete = 'complete' event = When the Tween finishes all playback (can sometimes never happen if repeat -1), also when 'stop' called
            //  onUpdate = 'update' event = When the Tween updates a TweenData during playback (expensive!)
            //  onLoop = 'loop' event = Used to loop ALL TweenDatas in a Tween
            Tween.TYPES = [
                'onActive',
                'onComplete',
                'onLoop',
                'onRepeat',
                'onStart',
                'onStop',
                'onUpdate',
                'onYoyo'
            ];
            /**
 * Creates a new Tween object.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The Tween configuration.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectFactory.register('tween', function(config) {
                return this.scene.sys.tweens.add(config);
            });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            /**
 * Creates a new Tween object and returns it.
 *
 * Note: This method will only be available if Tweens have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tween
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The Tween configuration.
 *
 * @return {Phaser.Tweens.Tween} The Tween that was created.
 */ GameObjectCreator.register('tween', function(config) {
                return this.scene.sys.tweens.create(config);
            });
            //  When registering a factory function 'this' refers to the GameObjectCreator context.
            module1.exports = Tween;
        /***/ },
        /* 263 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Events
 */ module1.exports = {
                TIMELINE_COMPLETE: __webpack_require__(1459),
                TIMELINE_LOOP: __webpack_require__(1460),
                TIMELINE_PAUSE: __webpack_require__(1461),
                TIMELINE_RESUME: __webpack_require__(1462),
                TIMELINE_START: __webpack_require__(1463),
                TIMELINE_UPDATE: __webpack_require__(1464),
                TWEEN_ACTIVE: __webpack_require__(1465),
                TWEEN_COMPLETE: __webpack_require__(1466),
                TWEEN_LOOP: __webpack_require__(1467),
                TWEEN_REPEAT: __webpack_require__(1468),
                TWEEN_START: __webpack_require__(1469),
                TWEEN_STOP: __webpack_require__(1470),
                TWEEN_UPDATE: __webpack_require__(1471),
                TWEEN_YOYO: __webpack_require__(1472)
            };
        /***/ },
        /* 264 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a TweenDataConfig object that describes the tween data for a unique property of a unique target.
 * A single Tween consists of multiple TweenDatas, depending on how many properties are being changed by the Tween.
 *
 * This is an internal function used by the TweenBuilder and should not be accessed directly, instead,
 * Tweens should be created using the GameObjectFactory or GameObjectCreator.
 *
 * @function Phaser.Tweens.TweenData
 * @since 3.0.0
 *
 * @param {any} target - The target to tween.
 * @param {number} index - The target index within the Tween targets array.
 * @param {string} key - The property of the target to tween.
 * @param {function} getEnd - What the property will be at the END of the Tween.
 * @param {function} getStart - What the property will be at the START of the Tween.
 * @param {?function} getActive - If not null, is invoked _immediately_ as soon as the TweenData is running, and is set on the target property.
 * @param {function} ease - The ease function this tween uses.
 * @param {number} delay - Time in ms/frames before tween will start.
 * @param {number} duration - Duration of the tween in ms/frames.
 * @param {boolean} yoyo - Determines whether the tween should return back to its start value after hold has expired.
 * @param {number} hold - Time in ms/frames the tween will pause before repeating or returning to its starting value if yoyo is set to true.
 * @param {number} repeat - Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
 * @param {number} repeatDelay - Time in ms/frames before the repeat will start.
 * @param {boolean} flipX - Should toggleFlipX be called when yoyo or repeat happens?
 * @param {boolean} flipY - Should toggleFlipY be called when yoyo or repeat happens?
 *
 * @return {Phaser.Types.Tweens.TweenDataConfig} The config object describing this TweenData.
 */ var TweenData = function(target, index, key, getEnd, getStart, getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY) {
                return {
                    //  The target to tween
                    target: target,
                    //  The index of the target within the tween targets array
                    index: index,
                    //  The property of the target to tween
                    key: key,
                    //  What to set the property to the moment the TweenData is invoked.
                    getActiveValue: getActive,
                    //  The returned value sets what the property will be at the END of the Tween.
                    getEndValue: getEnd,
                    //  The returned value sets what the property will be at the START of the Tween.
                    getStartValue: getStart,
                    //  The ease function this tween uses.
                    ease: ease,
                    //  Duration of the tween in ms/frames, excludes time for yoyo or repeats.
                    duration: 0,
                    //  The total calculated duration of this TweenData (based on duration, repeat, delay and yoyo)
                    totalDuration: 0,
                    //  Time in ms/frames before tween will start.
                    delay: 0,
                    //  Cause the tween to return back to its start value after hold has expired.
                    yoyo: yoyo,
                    //  Time in ms/frames the tween will pause before running the yoyo or starting a repeat.
                    hold: 0,
                    //  Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
                    repeat: 0,
                    //  Time in ms/frames before the repeat will start.
                    repeatDelay: 0,
                    //  Automatically call toggleFlipX when the TweenData yoyos or repeats
                    flipX: flipX,
                    //  Automatically call toggleFlipY when the TweenData yoyos or repeats
                    flipY: flipY,
                    //  Between 0 and 1 showing completion of this TweenData.
                    progress: 0,
                    //  Delta counter.
                    elapsed: 0,
                    //  How many repeats are left to run?
                    repeatCounter: 0,
                    //  Ease Value Data:
                    start: 0,
                    previous: 0,
                    current: 0,
                    end: 0,
                    //  Time Durations
                    t1: 0,
                    t2: 0,
                    //  LoadValue generation functions
                    gen: {
                        delay: delay,
                        duration: duration,
                        hold: hold,
                        repeat: repeat,
                        repeatDelay: repeatDelay
                    },
                    //  TWEEN_CONST.CREATED
                    state: 0
                };
            };
            module1.exports = TweenData;
        /***/ },
        /* 265 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathWrap = __webpack_require__(66);
            /**
 * Wrap an angle.
 *
 * Wraps the angle to a value in the range of -PI to PI.
 *
 * @function Phaser.Math.Angle.Wrap
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in radians.
 *
 * @return {number} The wrapped angle, in radians.
 */ var Wrap = function(angle) {
                return MathWrap(angle, -Math.PI, Math.PI);
            };
            module1.exports = Wrap;
        /***/ },
        /* 266 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(66);
            /**
 * Wrap an angle in degrees.
 *
 * Wraps the angle to a value in the range of -180 to 180.
 *
 * @function Phaser.Math.Angle.WrapDegrees
 * @since 3.0.0
 *
 * @param {number} angle - The angle to wrap, in degrees.
 *
 * @return {number} The wrapped angle, in degrees.
 */ var WrapDegrees = function(angle) {
                return Wrap(angle, -180, 180);
            };
            module1.exports = WrapDegrees;
        /***/ },
        /* 267 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
*
* @class Sleeping
*/ var Sleeping = {};
            module1.exports = Sleeping;
            var Events = __webpack_require__(268);
            (function() {
                Sleeping._motionWakeThreshold = 0.18;
                Sleeping._motionSleepThreshold = 0.08;
                Sleeping._minBias = 0.9;
                /**
     * Puts bodies to sleep or wakes them up depending on their motion.
     * @method update
     * @param {body[]} bodies
     * @param {number} timeScale
     */ Sleeping.update = function(bodies, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // update bodies sleeping status
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], motion = body.speed * body.speed + body.angularSpeed * body.angularSpeed;
                        // wake up bodies if they have a force applied
                        if (body.force.x !== 0 || body.force.y !== 0) {
                            Sleeping.set(body, false);
                            continue;
                        }
                        var minMotion = Math.min(body.motion, motion), maxMotion = Math.max(body.motion, motion);
                        // biased average motion estimation between frames
                        body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
                        if (body.sleepThreshold > 0 && body.motion < Sleeping._motionSleepThreshold * timeFactor) {
                            body.sleepCounter += 1;
                            if (body.sleepCounter >= body.sleepThreshold) Sleeping.set(body, true);
                        } else if (body.sleepCounter > 0) body.sleepCounter -= 1;
                    }
                };
                /**
     * Given a set of colliding pairs, wakes the sleeping bodies involved.
     * @method afterCollisions
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Sleeping.afterCollisions = function(pairs, timeScale) {
                    var timeFactor = timeScale * timeScale * timeScale;
                    // wake up bodies involved in collisions
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        // don't wake inactive pairs
                        if (!pair.isActive) continue;
                        var collision = pair.collision, bodyA = collision.bodyA.parent, bodyB = collision.bodyB.parent;
                        // don't wake if at least one body is static
                        if (bodyA.isSleeping && bodyB.isSleeping || bodyA.isStatic || bodyB.isStatic) continue;
                        if (bodyA.isSleeping || bodyB.isSleeping) {
                            var sleepingBody = bodyA.isSleeping && !bodyA.isStatic ? bodyA : bodyB, movingBody = sleepingBody === bodyA ? bodyB : bodyA;
                            if (!sleepingBody.isStatic && movingBody.motion > Sleeping._motionWakeThreshold * timeFactor) Sleeping.set(sleepingBody, false);
                        }
                    }
                };
                /**
     * Set a body as sleeping or awake.
     * @method set
     * @param {body} body
     * @param {boolean} isSleeping
     */ Sleeping.set = function(body, isSleeping) {
                    var wasSleeping = body.isSleeping;
                    if (isSleeping) {
                        body.isSleeping = true;
                        body.sleepCounter = body.sleepThreshold;
                        body.positionImpulse.x = 0;
                        body.positionImpulse.y = 0;
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.anglePrev = body.angle;
                        body.speed = 0;
                        body.angularSpeed = 0;
                        body.motion = 0;
                        if (!wasSleeping) Events.trigger(body, 'sleepStart');
                    } else {
                        body.isSleeping = false;
                        body.sleepCounter = 0;
                        if (wasSleeping) Events.trigger(body, 'sleepEnd');
                    }
                };
            })();
        /***/ },
        /* 268 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Events` module contains methods to fire and listen to events on other objects.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Events
*/ var Events = {};
            module1.exports = Events;
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Subscribes a callback function to the given object's `eventName`.
     * @method on
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.on = function(object, eventNames, callback) {
                    var names = eventNames.split(' '), name;
                    for(var i = 0; i < names.length; i++){
                        name = names[i];
                        object.events = object.events || {};
                        object.events[name] = object.events[name] || [];
                        object.events[name].push(callback);
                    }
                    return callback;
                };
                /**
     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
     * @method off
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.off = function(object, eventNames, callback) {
                    if (!eventNames) {
                        object.events = {};
                        return;
                    }
                    // handle Events.off(object, callback)
                    if (typeof eventNames === 'function') {
                        callback = eventNames;
                        eventNames = Common.keys(object.events).join(' ');
                    }
                    var names = eventNames.split(' ');
                    for(var i = 0; i < names.length; i++){
                        var callbacks = object.events[names[i]], newCallbacks = [];
                        if (callback && callbacks) {
                            for(var j = 0; j < callbacks.length; j++)if (callbacks[j] !== callback) newCallbacks.push(callbacks[j]);
                        }
                        object.events[names[i]] = newCallbacks;
                    }
                };
                /**
     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
     * @method trigger
     * @param {} object
     * @param {string} eventNames
     * @param {} event
     */ Events.trigger = function(object, eventNames, event) {
                    var names, name, callbacks, eventClone;
                    var events = object.events;
                    if (events && Common.keys(events).length > 0) {
                        if (!event) event = {};
                        names = eventNames.split(' ');
                        for(var i = 0; i < names.length; i++){
                            name = names[i];
                            callbacks = events[name];
                            if (callbacks) {
                                eventClone = Common.clone(event, false);
                                eventClone.name = name;
                                eventClone.source = object;
                                for(var j = 0; j < callbacks.length; j++)callbacks[j].apply(object, [
                                    eventClone
                                ]);
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 269 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Actions
 */ module1.exports = {
                AlignTo: __webpack_require__(599),
                Angle: __webpack_require__(600),
                Call: __webpack_require__(601),
                GetFirst: __webpack_require__(602),
                GetLast: __webpack_require__(603),
                GridAlign: __webpack_require__(604),
                IncAlpha: __webpack_require__(654),
                IncX: __webpack_require__(655),
                IncXY: __webpack_require__(656),
                IncY: __webpack_require__(657),
                PlaceOnCircle: __webpack_require__(658),
                PlaceOnEllipse: __webpack_require__(659),
                PlaceOnLine: __webpack_require__(660),
                PlaceOnRectangle: __webpack_require__(661),
                PlaceOnTriangle: __webpack_require__(662),
                PlayAnimation: __webpack_require__(663),
                PropertyValueInc: __webpack_require__(44),
                PropertyValueSet: __webpack_require__(27),
                RandomCircle: __webpack_require__(664),
                RandomEllipse: __webpack_require__(665),
                RandomLine: __webpack_require__(666),
                RandomRectangle: __webpack_require__(667),
                RandomTriangle: __webpack_require__(668),
                Rotate: __webpack_require__(669),
                RotateAround: __webpack_require__(670),
                RotateAroundDistance: __webpack_require__(671),
                ScaleX: __webpack_require__(672),
                ScaleXY: __webpack_require__(673),
                ScaleY: __webpack_require__(674),
                SetAlpha: __webpack_require__(675),
                SetBlendMode: __webpack_require__(676),
                SetDepth: __webpack_require__(677),
                SetHitArea: __webpack_require__(678),
                SetOrigin: __webpack_require__(679),
                SetRotation: __webpack_require__(680),
                SetScale: __webpack_require__(681),
                SetScaleX: __webpack_require__(682),
                SetScaleY: __webpack_require__(683),
                SetScrollFactor: __webpack_require__(684),
                SetScrollFactorX: __webpack_require__(685),
                SetScrollFactorY: __webpack_require__(686),
                SetTint: __webpack_require__(687),
                SetVisible: __webpack_require__(688),
                SetX: __webpack_require__(689),
                SetXY: __webpack_require__(690),
                SetY: __webpack_require__(691),
                ShiftPosition: __webpack_require__(692),
                Shuffle: __webpack_require__(693),
                SmootherStep: __webpack_require__(694),
                SmoothStep: __webpack_require__(695),
                Spread: __webpack_require__(696),
                ToggleVisible: __webpack_require__(697),
                WrapInRectangle: __webpack_require__(698)
            };
        /***/ },
        /* 270 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(122);
            var AlignToMap = [];
            AlignToMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(271);
            AlignToMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(272);
            AlignToMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(273);
            AlignToMap[ALIGN_CONST.LEFT_BOTTOM] = __webpack_require__(274);
            AlignToMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(275);
            AlignToMap[ALIGN_CONST.LEFT_TOP] = __webpack_require__(276);
            AlignToMap[ALIGN_CONST.RIGHT_BOTTOM] = __webpack_require__(277);
            AlignToMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(278);
            AlignToMap[ALIGN_CONST.RIGHT_TOP] = __webpack_require__(279);
            AlignToMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(280);
            AlignToMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(281);
            AlignToMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(282);
            /**
 * Takes a Game Object and aligns it next to another, at the given position.
 * The alignment used is based on the `position` argument, which is a `Phaser.Display.Align` property such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.To.QuickSet
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignTo, position, offsetX, offsetY) {
                return AlignToMap[position](child, alignTo, offsetX, offsetY);
            };
            module1.exports = QuickSet;
        /***/ },
        /* 271 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetCenterX = __webpack_require__(84);
            var SetCenterX = __webpack_require__(85);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom center position of the other.
 *
 * @function Phaser.Display.Align.To.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomCenter;
        /***/ },
        /* 272 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetLeft = __webpack_require__(41);
            var SetLeft = __webpack_require__(52);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom left position of the other.
 *
 * @function Phaser.Display.Align.To.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomLeft;
        /***/ },
        /* 273 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetRight = __webpack_require__(42);
            var SetRight = __webpack_require__(53);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the bottom right position of the other.
 *
 * @function Phaser.Display.Align.To.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignTo) + offsetX);
                SetTop(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = BottomRight;
        /***/ },
        /* 274 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetLeft = __webpack_require__(41);
            var SetBottom = __webpack_require__(54);
            var SetRight = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left bottom position of the other.
 *
 * @function Phaser.Display.Align.To.LeftBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftBottom = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = LeftBottom;
        /***/ },
        /* 275 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(86);
            var GetLeft = __webpack_require__(41);
            var SetCenterY = __webpack_require__(87);
            var SetRight = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left center position of the other.
 *
 * @function Phaser.Display.Align.To.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = LeftCenter;
        /***/ },
        /* 276 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(41);
            var GetTop = __webpack_require__(43);
            var SetRight = __webpack_require__(53);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the left top position of the other.
 *
 * @function Phaser.Display.Align.To.LeftTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftTop = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetLeft(alignTo) - offsetX);
                SetTop(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = LeftTop;
        /***/ },
        /* 277 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetRight = __webpack_require__(42);
            var SetBottom = __webpack_require__(54);
            var SetLeft = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right bottom position of the other.
 *
 * @function Phaser.Display.Align.To.RightBottom
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightBottom = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetBottom(gameObject, GetBottom(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = RightBottom;
        /***/ },
        /* 278 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(86);
            var GetRight = __webpack_require__(42);
            var SetCenterY = __webpack_require__(87);
            var SetLeft = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right center position of the other.
 *
 * @function Phaser.Display.Align.To.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
                return gameObject;
            };
            module1.exports = RightCenter;
        /***/ },
        /* 279 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(42);
            var GetTop = __webpack_require__(43);
            var SetLeft = __webpack_require__(52);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the right top position of the other.
 *
 * @function Phaser.Display.Align.To.RightTop
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightTop = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetRight(alignTo) + offsetX);
                SetTop(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = RightTop;
        /***/ },
        /* 280 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(84);
            var GetTop = __webpack_require__(43);
            var SetBottom = __webpack_require__(54);
            var SetCenterX = __webpack_require__(85);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top center position of the other.
 *
 * @function Phaser.Display.Align.To.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopCenter;
        /***/ },
        /* 281 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(41);
            var GetTop = __webpack_require__(43);
            var SetBottom = __webpack_require__(54);
            var SetLeft = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top left position of the other.
 *
 * @function Phaser.Display.Align.To.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignTo) - offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopLeft;
        /***/ },
        /* 282 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(42);
            var GetTop = __webpack_require__(43);
            var SetBottom = __webpack_require__(54);
            var SetRight = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned next to the top right position of the other.
 *
 * @function Phaser.Display.Align.To.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignTo, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignTo) + offsetX);
                SetBottom(gameObject, GetTop(alignTo) - offsetY);
                return gameObject;
            };
            module1.exports = TopRight;
        /***/ },
        /* 283 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(122);
            var AlignInMap = [];
            AlignInMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(284);
            AlignInMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(285);
            AlignInMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(286);
            AlignInMap[ALIGN_CONST.CENTER] = __webpack_require__(287);
            AlignInMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(289);
            AlignInMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(290);
            AlignInMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(291);
            AlignInMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(292);
            AlignInMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(293);
            AlignInMap[ALIGN_CONST.LEFT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_LEFT];
            AlignInMap[ALIGN_CONST.LEFT_TOP] = AlignInMap[ALIGN_CONST.TOP_LEFT];
            AlignInMap[ALIGN_CONST.RIGHT_BOTTOM] = AlignInMap[ALIGN_CONST.BOTTOM_RIGHT];
            AlignInMap[ALIGN_CONST.RIGHT_TOP] = AlignInMap[ALIGN_CONST.TOP_RIGHT];
            /**
 * Takes given Game Object and aligns it so that it is positioned relative to the other.
 * The alignment used is based on the `position` argument, which is an `ALIGN_CONST` value, such as `LEFT_CENTER` or `TOP_RIGHT`.
 *
 * @function Phaser.Display.Align.In.QuickSet
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
 *
 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} position - The position to align the Game Object with. This is an align constant, such as `ALIGN_CONST.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var QuickSet = function(child, alignIn, position, offsetX, offsetY) {
                return AlignInMap[position](child, alignIn, offsetX, offsetY);
            };
            module1.exports = QuickSet;
        /***/ },
        /* 284 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetCenterX = __webpack_require__(84);
            var SetBottom = __webpack_require__(54);
            var SetCenterX = __webpack_require__(85);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom center of the other.
 *
 * @function Phaser.Display.Align.In.BottomCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomCenter;
        /***/ },
        /* 285 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetLeft = __webpack_require__(41);
            var SetBottom = __webpack_require__(54);
            var SetLeft = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom left of the other.
 *
 * @function Phaser.Display.Align.In.BottomLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomLeft = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomLeft;
        /***/ },
        /* 286 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetRight = __webpack_require__(42);
            var SetBottom = __webpack_require__(54);
            var SetRight = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the bottom right of the other.
 *
 * @function Phaser.Display.Align.In.BottomRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var BottomRight = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetBottom(gameObject, GetBottom(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = BottomRight;
        /***/ },
        /* 287 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(288);
            var GetCenterX = __webpack_require__(84);
            var GetCenterY = __webpack_require__(86);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the center of the other.
 *
 * @function Phaser.Display.Align.In.Center
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var Center = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                CenterOn(gameObject, GetCenterX(alignIn) + offsetX, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = Center;
        /***/ },
        /* 288 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetCenterX = __webpack_require__(85);
            var SetCenterY = __webpack_require__(87);
            /**
 * Positions the Game Object so that it is centered on the given coordinates.
 *
 * @function Phaser.Display.Bounds.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
 * @param {number} x - The horizontal coordinate to position the Game Object on.
 * @param {number} y - The vertical coordinate to position the Game Object on.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
 */ var CenterOn = function(gameObject, x, y) {
                SetCenterX(gameObject, x);
                return SetCenterY(gameObject, y);
            };
            module1.exports = CenterOn;
        /***/ },
        /* 289 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(86);
            var GetLeft = __webpack_require__(41);
            var SetCenterY = __webpack_require__(87);
            var SetLeft = __webpack_require__(52);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the left center of the other.
 *
 * @function Phaser.Display.Align.In.LeftCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var LeftCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = LeftCenter;
        /***/ },
        /* 290 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterY = __webpack_require__(86);
            var GetRight = __webpack_require__(42);
            var SetCenterY = __webpack_require__(87);
            var SetRight = __webpack_require__(53);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the right center of the other.
 *
 * @function Phaser.Display.Align.In.RightCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var RightCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
                return gameObject;
            };
            module1.exports = RightCenter;
        /***/ },
        /* 291 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCenterX = __webpack_require__(84);
            var GetTop = __webpack_require__(43);
            var SetCenterX = __webpack_require__(85);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top center of the other.
 *
 * @function Phaser.Display.Align.In.TopCenter
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopCenter = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopCenter;
        /***/ },
        /* 292 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLeft = __webpack_require__(41);
            var GetTop = __webpack_require__(43);
            var SetLeft = __webpack_require__(52);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top left of the other.
 *
 * @function Phaser.Display.Align.In.TopLeft
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopLeft = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetLeft(gameObject, GetLeft(alignIn) - offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopLeft;
        /***/ },
        /* 293 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetRight = __webpack_require__(42);
            var GetTop = __webpack_require__(43);
            var SetRight = __webpack_require__(53);
            var SetTop = __webpack_require__(51);
            /**
 * Takes given Game Object and aligns it so that it is positioned in the top right of the other.
 *
 * @function Phaser.Display.Align.In.TopRight
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
 */ var TopRight = function(gameObject, alignIn, offsetX, offsetY) {
                if (offsetX === undefined) offsetX = 0;
                if (offsetY === undefined) offsetY = 0;
                SetRight(gameObject, GetRight(alignIn) + offsetX);
                SetTop(gameObject, GetTop(alignIn) - offsetY);
                return gameObject;
            };
            module1.exports = TopRight;
        /***/ },
        /* 294 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(165);
            var FromPercent = __webpack_require__(95);
            var MATH_CONST = __webpack_require__(14);
            var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Circle
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Circle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
 */ var GetPoint = function(circle, position, out) {
                if (out === undefined) out = new Point();
                var angle = FromPercent(position, 0, MATH_CONST.PI2);
                return CircumferencePoint(circle, angle, out);
            };
            module1.exports = GetPoint;
        /***/ },
        /* 295 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(296);
            var CircumferencePoint = __webpack_require__(165);
            var FromPercent = __webpack_require__(95);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Circle.GetPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the circumference of the circle.
 */ var GetPoints = function(circle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Circumference(circle) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                    out.push(CircumferencePoint(circle, angle));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 296 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Circle.
 *
 * @function Phaser.Geom.Circle.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference of.
 *
 * @return {number} The circumference of the Circle.
 */ var Circumference = function(circle) {
                return 2 * (Math.PI * circle.radius);
            };
            module1.exports = Circumference;
        /***/ },
        /* 297 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 2; // 0010
            /**
 * Provides methods used for setting the alpha property of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.AlphaSingle
 * @since 3.22.0
 */ var AlphaSingle = {
                /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                    return this.setAlpha(1);
                },
                /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * @method Phaser.GameObjects.Components.AlphaSingle#setAlpha
     * @since 3.0.0
     *
     * @param {number} [value=1] - The alpha value applied across the whole Game Object.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(value) {
                    if (value === undefined) value = 1;
                    this.alpha = value;
                    return this;
                },
                /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.AlphaSingle#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alpha = v;
                        if (v === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                }
            };
            module1.exports = AlphaSingle;
        /***/ },
        /* 298 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            /**
 * Provides methods used for setting the blend mode of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.BlendMode
 * @since 3.0.0
 */ var BlendMode = {
                /**
     * Private internal value. Holds the current blend mode.
     * 
     * @name Phaser.GameObjects.Components.BlendMode#_blendMode
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _blendMode: BlendModes.NORMAL,
                /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency of which blend modes
     * are used.
     *
     * @name Phaser.GameObjects.Components.BlendMode#blendMode
     * @type {(Phaser.BlendModes|string)}
     * @since 3.0.0
     */ blendMode: {
                    get: function() {
                        return this._blendMode;
                    },
                    set: function(value) {
                        if (typeof value === 'string') value = BlendModes[value];
                        value |= 0;
                        if (value >= -1) this._blendMode = value;
                    }
                },
                /**
     * Sets the Blend Mode being used by this Game Object.
     *
     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
     *
     * Under WebGL only the following Blend Modes are available:
     *
     * * ADD
     * * MULTIPLY
     * * SCREEN
     * * ERASE (only works when rendering to a framebuffer, like a Render Texture)
     *
     * Canvas has more available depending on browser support.
     *
     * You can also create your own custom Blend Modes in WebGL.
     *
     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
     * reasons try to be careful about the construction of your Scene and the frequency in which blend modes
     * are used.
     *
     * @method Phaser.GameObjects.Components.BlendMode#setBlendMode
     * @since 3.0.0
     *
     * @param {(string|Phaser.BlendModes)} value - The BlendMode value. Either a string or a CONST.
     *
     * @return {this} This Game Object instance.
     */ setBlendMode: function(value) {
                    this.blendMode = value;
                    return this;
                }
            };
            module1.exports = BlendMode;
        /***/ },
        /* 299 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the depth of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Depth
 * @since 3.0.0
 */ var Depth = {
                /**
     * Private internal value. Holds the depth of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Depth#_depth
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _depth: 0,
                /**
     * The depth of this Game Object within the Scene.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @name Phaser.GameObjects.Components.Depth#depth
     * @type {number}
     * @since 3.0.0
     */ depth: {
                    get: function() {
                        return this._depth;
                    },
                    set: function(value) {
                        if (this.displayList) this.displayList.queueDepthSort();
                        this._depth = value;
                    }
                },
                /**
     * The depth of this Game Object within the Scene.
     *
     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
     * of Game Objects, without actually moving their position in the display list.
     *
     * The default depth is zero. A Game Object with a higher depth
     * value will always render in front of one with a lower value.
     *
     * Setting the depth will queue a depth sort event within the Scene.
     *
     * @method Phaser.GameObjects.Components.Depth#setDepth
     * @since 3.0.0
     *
     * @param {number} value - The depth of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setDepth: function(value) {
                    if (value === undefined) value = 0;
                    this.depth = value;
                    return this;
                }
            };
            module1.exports = Depth;
        /***/ },
        /* 300 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoint = __webpack_require__(167);
            var Perimeter = __webpack_require__(128);
            //  Return an array of points from the perimeter of the rectangle
            //  each spaced out based on the quantity or step required
            /**
 * Return an array of points from the perimeter of the rectangle, each spaced out based on the quantity or step required.
 *
 * @function Phaser.Geom.Rectangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle object to get the points from.
 * @param {number} step - Step between points. Used to calculate the number of points to return when quantity is falsey. Ignored if quantity is positive.
 * @param {number} quantity - The number of evenly spaced points from the rectangles perimeter to return. If falsey, step param will be used to calculate the number of points.
 * @param {(array|Phaser.Geom.Point[])} [out] - An optional array to store the points in.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Points from the perimeter of the rectangle.
 */ var GetPoints = function(rectangle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Perimeter(rectangle) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var position = i / quantity;
                    out.push(GetPoint(rectangle, position));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 301 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get a point on a line that's a given percentage along its length.
 *
 * @function Phaser.Geom.Line.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} position - A value between 0 and 1, where 0 is the start, 0.5 is the middle and 1 is the end of the line.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The point on the line.
 */ var GetPoint = function(line, position, out) {
                if (out === undefined) out = new Point();
                out.x = line.x1 + (line.x2 - line.x1) * position;
                out.y = line.y1 + (line.y2 - line.y1) * position;
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 302 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a `point` around `x` and `y` to the given `angle`, at the same distance.
 *
 * In polar notation, this maps a point from (r, t) to (r, angle), vs. the origin (x, y).
 *
 * @function Phaser.Math.RotateAround
 * @since 3.0.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} x - The horizontal coordinate to rotate around.
 * @param {number} y - The vertical coordinate to rotate around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateAround = function(point, x, y, angle) {
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var tx = point.x - x;
                var ty = point.y - y;
                point.x = tx * c - ty * s + x;
                point.y = tx * s + ty * c + y;
                return point;
            };
            module1.exports = RotateAround;
        /***/ },
        /* 303 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapMask = __webpack_require__(304);
            var GeometryMask = __webpack_require__(305);
            /**
 * Provides methods used for getting and setting the mask of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Mask
 * @since 3.0.0
 */ var Mask = {
                /**
     * The Mask this Game Object is using during render.
     *
     * @name Phaser.GameObjects.Components.Mask#mask
     * @type {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask}
     * @since 3.0.0
     */ mask: null,
                /**
     * Sets the mask that this Game Object will use to render with.
     *
     * The mask must have been previously created and can be either a GeometryMask or a BitmapMask.
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * If a mask is already set on this Game Object it will be immediately replaced.
     *
     * Masks are positioned in global space and are not relative to the Game Object to which they
     * are applied. The reason for this is that multiple Game Objects can all share the same mask.
     *
     * Masks have no impact on physics or input detection. They are purely a rendering component
     * that allows you to limit what is visible during the render pass.
     *
     * @method Phaser.GameObjects.Components.Mask#setMask
     * @since 3.6.2
     *
     * @param {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask} mask - The mask this Game Object will use when rendering.
     *
     * @return {this} This Game Object instance.
     */ setMask: function(mask) {
                    this.mask = mask;
                    return this;
                },
                /**
     * Clears the mask that this Game Object was using.
     *
     * @method Phaser.GameObjects.Components.Mask#clearMask
     * @since 3.6.2
     *
     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
     *
     * @return {this} This Game Object instance.
     */ clearMask: function(destroyMask) {
                    if (destroyMask === undefined) destroyMask = false;
                    if (destroyMask && this.mask) this.mask.destroy();
                    this.mask = null;
                    return this;
                },
                /**
     * Creates and returns a Bitmap Mask. This mask can be used by any Game Object,
     * including this one.
     *
     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
     *
     * To create the mask you need to pass in a reference to a renderable Game Object.
     * A renderable Game Object is one that uses a texture to render with, such as an
     * Image, Sprite, Render Texture or BitmapText.
     *
     * If you do not provide a renderable object, and this Game Object has a texture,
     * it will use itself as the object. This means you can call this method to create
     * a Bitmap Mask from any renderable Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createBitmapMask
     * @since 3.6.2
     *
     * @param {Phaser.GameObjects.GameObject} [renderable] - A renderable Game Object that uses a texture, such as a Sprite.
     *
     * @return {Phaser.Display.Masks.BitmapMask} This Bitmap Mask that was created.
     */ createBitmapMask: function(renderable) {
                    if (renderable === undefined && (this.texture || this.shader)) // eslint-disable-next-line consistent-this
                    renderable = this;
                    return new BitmapMask(this.scene, renderable);
                },
                /**
     * Creates and returns a Geometry Mask. This mask can be used by any Game Object,
     * including this one.
     *
     * To create the mask you need to pass in a reference to a Graphics Game Object.
     *
     * If you do not provide a graphics object, and this Game Object is an instance
     * of a Graphics object, then it will use itself to create the mask.
     *
     * This means you can call this method to create a Geometry Mask from any Graphics Game Object.
     *
     * @method Phaser.GameObjects.Components.Mask#createGeometryMask
     * @since 3.6.2
     *
     * @param {Phaser.GameObjects.Graphics} [graphics] - A Graphics Game Object. The geometry within it will be used as the mask.
     *
     * @return {Phaser.Display.Masks.GeometryMask} This Geometry Mask that was created.
     */ createGeometryMask: function(graphics) {
                    if (graphics === undefined && this.type === 'Graphics') // eslint-disable-next-line consistent-this
                    graphics = this;
                    return new GeometryMask(this.scene, graphics);
                }
            };
            module1.exports = Mask;
        /***/ },
        /* 304 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var RenderEvents = __webpack_require__(88);
            /**
 * @classdesc
 * A Bitmap Mask combines the alpha (opacity) of a masked pixel with the alpha of another pixel.
 * Unlike the Geometry Mask, which is a clipping path, a Bitmap Mask behaves like an alpha mask,
 * not a clipping path. It is only available when using the WebGL Renderer.
 *
 * A Bitmap Mask can use any Game Object to determine the alpha of each pixel of the masked Game Object(s).
 * For any given point of a masked Game Object's texture, the pixel's alpha will be multiplied by the alpha
 * of the pixel at the same position in the Bitmap Mask's Game Object. The color of the pixel from the
 * Bitmap Mask doesn't matter.
 *
 * For example, if a pure blue pixel with an alpha of 0.95 is masked with a pure red pixel with an
 * alpha of 0.5, the resulting pixel will be pure blue with an alpha of 0.475. Naturally, this means
 * that a pixel in the mask with an alpha of 0 will hide the corresponding pixel in all masked Game Objects
 *  A pixel with an alpha of 1 in the masked Game Object will receive the same alpha as the
 * corresponding pixel in the mask.
 *
 * Note: You cannot combine Bitmap Masks and Blend Modes on the same Game Object. You can, however,
 * combine Geometry Masks and Blend Modes together.
 *
 * The Bitmap Mask's location matches the location of its Game Object, not the location of the
 * masked objects. Moving or transforming the underlying Game Object will change the mask
 * (and affect the visibility of any masked objects), whereas moving or transforming a masked object
 * will not affect the mask.
 *
 * The Bitmap Mask will not render its Game Object by itself. If the Game Object is not in a
 * Scene's display list, it will only be used for the mask and its full texture will not be directly
 * visible. Adding the underlying Game Object to a Scene will not cause any problems - it will
 * render as a normal Game Object and will also serve as a mask.
 *
 * @class BitmapMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which this Bitmap Mask will be used in.
 * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
 */ var BitmapMask = new Class({
                initialize: function BitmapMask(scene, renderable) {
                    var renderer = scene.sys.renderer;
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Mask is using.
         *
         * @name Phaser.Display.Masks.BitmapMask#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.11.0
         */ this.renderer = renderer;
                    /**
         * A renderable Game Object that uses a texture, such as a Sprite.
         *
         * @name Phaser.Display.Masks.BitmapMask#bitmapMask
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.bitmapMask = renderable;
                    /**
         * The texture used for the masks framebuffer.
         *
         * @name Phaser.Display.Masks.BitmapMask#maskTexture
         * @type {WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.maskTexture = null;
                    /**
         * The texture used for the main framebuffer.
         *
         * @name Phaser.Display.Masks.BitmapMask#mainTexture
         * @type {WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.mainTexture = null;
                    /**
         * Whether the Bitmap Mask is dirty and needs to be updated.
         *
         * @name Phaser.Display.Masks.BitmapMask#dirty
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.dirty = true;
                    /**
         * The framebuffer to which a masked Game Object is rendered.
         *
         * @name Phaser.Display.Masks.BitmapMask#mainFramebuffer
         * @type {WebGLFramebuffer}
         * @since 3.0.0
         */ this.mainFramebuffer = null;
                    /**
         * The framebuffer to which the Bitmap Mask's masking Game Object is rendered.
         *
         * @name Phaser.Display.Masks.BitmapMask#maskFramebuffer
         * @type {WebGLFramebuffer}
         * @since 3.0.0
         */ this.maskFramebuffer = null;
                    /**
         * Whether to invert the masks alpha.
         *
         * If `true`, the alpha of the masking pixel will be inverted before it's multiplied with the masked pixel.
         * Essentially, this means that a masked area will be visible only if the corresponding area in the mask is invisible.
         *
         * @name Phaser.Display.Masks.BitmapMask#invertAlpha
         * @type {boolean}
         * @since 3.1.2
         */ this.invertAlpha = false;
                    /**
         * Is this mask a stencil mask?
         *
         * @name Phaser.Display.Masks.BitmapMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = false;
                    this.createMask();
                    scene.sys.game.events.on(GameEvents.CONTEXT_RESTORED, this.createMask, this);
                    renderer.on(RenderEvents.RESIZE, this.createMask, this);
                },
                /**
     * Creates the WebGL Texture2D objects and Framebuffers required for this
     * mask. If this mask has already been created, then `clearMask` is called first.
     *
     * @method Phaser.Display.Masks.BitmapMask#createMask
     * @since 3.50.0
     */ createMask: function() {
                    var renderer = this.renderer;
                    if (!renderer.gl) return;
                    if (this.mainTexture) this.clearMask();
                    var width = renderer.width;
                    var height = renderer.height;
                    var pot = (width & width - 1) === 0 && (height & height - 1) === 0;
                    var gl = renderer.gl;
                    var wrap = pot ? gl.REPEAT : gl.CLAMP_TO_EDGE;
                    var filter = gl.LINEAR;
                    this.mainTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
                    this.maskTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
                    this.mainFramebuffer = renderer.createFramebuffer(width, height, this.mainTexture, true);
                    this.maskFramebuffer = renderer.createFramebuffer(width, height, this.maskTexture, true);
                },
                /**
     * Deletes the `mainTexture` and `maskTexture` WebGL Textures and deletes
     * the `mainFramebuffer` and `maskFramebuffer` too, nulling all references.
     *
     * This is called when this mask is destroyed, or if you try to creat a new
     * mask from this object when one is already set.
     *
     * @method Phaser.Display.Masks.BitmapMask#clearMask
     * @since 3.50.0
     */ clearMask: function() {
                    var renderer = this.renderer;
                    if (!renderer.gl || !this.mainTexture) return;
                    renderer.deleteTexture(this.mainTexture);
                    renderer.deleteTexture(this.maskTexture);
                    renderer.deleteFramebuffer(this.mainFramebuffer);
                    renderer.deleteFramebuffer(this.maskFramebuffer);
                    this.mainTexture = null;
                    this.maskTexture = null;
                    this.mainFramebuffer = null;
                    this.maskFramebuffer = null;
                },
                /**
     * Sets a new masking Game Object for the Bitmap Mask.
     *
     * @method Phaser.Display.Masks.BitmapMask#setBitmap
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
     */ setBitmap: function(renderable) {
                    this.bitmapMask = renderable;
                },
                /**
     * Prepares the WebGL Renderer to render a Game Object with this mask applied.
     *
     * This renders the masking Game Object to the mask framebuffer and switches to the main framebuffer so that the masked Game Object will be rendered to it instead of being rendered directly to the frame.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to prepare.
     * @param {Phaser.GameObjects.GameObject} maskedObject - The masked Game Object which will be drawn.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderWebGL: function(renderer, maskedObject, camera) {
                    renderer.pipelines.BITMAPMASK_PIPELINE.beginMask(this, maskedObject, camera);
                },
                /**
     * Finalizes rendering of a masked Game Object.
     *
     * This resets the previously bound framebuffer and switches the WebGL Renderer to the Bitmap Mask Pipeline, which uses a special fragment shader to apply the masking effect.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The WebGL Renderer to clean up.
     */ postRenderWebGL: function(renderer, camera) {
                    renderer.pipelines.BITMAPMASK_PIPELINE.endMask(this, camera);
                },
                /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     * @param {Phaser.GameObjects.GameObject} mask - The masked Game Object which would be rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
     */ preRenderCanvas: function() {
                // NOOP
                },
                /**
     * This is a NOOP method. Bitmap Masks are not supported by the Canvas Renderer.
     *
     * @method Phaser.Display.Masks.BitmapMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Canvas Renderer which would be rendered to.
     */ postRenderCanvas: function() {
                // NOOP
                },
                /**
     * Destroys this BitmapMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.BitmapMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.clearMask();
                    this.renderer.off(RenderEvents.RESIZE, this.createMask, this);
                    this.bitmapMask = null;
                    this.prevFramebuffer = null;
                    this.renderer = null;
                }
            });
            module1.exports = BitmapMask;
        /***/ },
        /* 305 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Geometry Mask can be applied to a Game Object to hide any pixels of it which don't intersect
 * a visible pixel from the geometry mask. The mask is essentially a clipping path which can only
 * make a masked pixel fully visible or fully invisible without changing its alpha (opacity).
 *
 * A Geometry Mask uses a Graphics Game Object to determine which pixels of the masked Game Object(s)
 * should be clipped. For any given point of a masked Game Object's texture, the pixel will only be displayed
 * if the Graphics Game Object of the Geometry Mask has a visible pixel at the same position. The color and
 * alpha of the pixel from the Geometry Mask do not matter.
 *
 * The Geometry Mask's location matches the location of its Graphics object, not the location of the masked objects.
 * Moving or transforming the underlying Graphics object will change the mask (and affect the visibility
 * of any masked objects), whereas moving or transforming a masked object will not affect the mask.
 * You can think of the Geometry Mask (or rather, of its Graphics object) as an invisible curtain placed
 * in front of all masked objects which has its own visual properties and, naturally, respects the camera's
 * visual properties, but isn't affected by and doesn't follow the masked objects by itself.
 *
 * @class GeometryMask
 * @memberof Phaser.Display.Masks
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - This parameter is not used.
 * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics Game Object to use for the Geometry Mask. Doesn't have to be in the Display List.
 */ var GeometryMask = new Class({
                initialize: function GeometryMask(scene, graphicsGeometry) {
                    /**
         * The Graphics object which describes the Geometry Mask.
         *
         * @name Phaser.Display.Masks.GeometryMask#geometryMask
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.geometryMask = graphicsGeometry;
                    /**
         * Similar to the BitmapMasks invertAlpha setting this to true will then hide all pixels
         * drawn to the Geometry Mask.
         *
         * This is a WebGL only feature.
         *
         * @name Phaser.Display.Masks.GeometryMask#invertAlpha
         * @type {boolean}
         * @since 3.16.0
         */ this.invertAlpha = false;
                    /**
         * Is this mask a stencil mask?
         *
         * @name Phaser.Display.Masks.GeometryMask#isStencil
         * @type {boolean}
         * @readonly
         * @since 3.17.0
         */ this.isStencil = true;
                    /**
         * The current stencil level.
         *
         * @name Phaser.Display.Masks.GeometryMask#level
         * @type {boolean}
         * @private
         * @since 3.17.0
         */ this.level = 0;
                },
                /**
     * Sets a new Graphics object for the Geometry Mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#setShape
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphicsGeometry - The Graphics object which will be used for the Geometry Mask.
     *
     * @return {this} This Geometry Mask
     */ setShape: function(graphicsGeometry) {
                    this.geometryMask = graphicsGeometry;
                    return this;
                },
                /**
     * Sets the `invertAlpha` property of this Geometry Mask.
     *
     * Inverting the alpha essentially flips the way the mask works.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.Display.Masks.GeometryMask#setInvertAlpha
     * @since 3.17.0
     *
     * @param {boolean} [value=true] - Invert the alpha of this mask?
     *
     * @return {this} This Geometry Mask
     */ setInvertAlpha: function(value) {
                    if (value === undefined) value = true;
                    this.invertAlpha = value;
                    return this;
                },
                /**
     * Renders the Geometry Mask's underlying Graphics object to the OpenGL stencil buffer and enables the stencil test, which clips rendered pixels according to the mask.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderWebGL: function(renderer, child, camera) {
                    var gl = renderer.gl;
                    //  Force flushing before drawing to stencil buffer
                    renderer.flush();
                    if (renderer.maskStack.length === 0) {
                        gl.enable(gl.STENCIL_TEST);
                        gl.clear(gl.STENCIL_BUFFER_BIT);
                        renderer.maskCount = 0;
                    }
                    if (renderer.currentCameraMask.mask !== this) renderer.currentMask.mask = this;
                    renderer.maskStack.push({
                        mask: this,
                        camera: camera
                    });
                    this.applyStencil(renderer, camera, true);
                    renderer.maskCount++;
                },
                /**
     * Applies the current stencil mask to the renderer.
     *
     * @method Phaser.Display.Masks.GeometryMask#applyStencil
     * @since 3.17.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw to.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     * @param {boolean} inc - Is this an INCR stencil or a DECR stencil?
     */ applyStencil: function(renderer, camera, inc) {
                    var gl = renderer.gl;
                    var geometryMask = this.geometryMask;
                    var level = renderer.maskCount;
                    gl.colorMask(false, false, false, false);
                    if (inc) {
                        gl.stencilFunc(gl.EQUAL, level, 0xFF);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
                    } else {
                        gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
                    }
                    //  Write stencil buffer
                    geometryMask.renderWebGL(renderer, geometryMask, camera);
                    renderer.flush();
                    gl.colorMask(true, true, true, true);
                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
                    if (inc) {
                        if (this.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, level + 1, 0xFF);
                        else gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
                    } else if (this.invertAlpha) gl.stencilFunc(gl.NOTEQUAL, level, 0xFF);
                    else gl.stencilFunc(gl.EQUAL, level, 0xFF);
                },
                /**
     * Flushes all rendered pixels and disables the stencil test of a WebGL context, thus disabling the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderWebGL
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer instance to draw flush.
     */ postRenderWebGL: function(renderer) {
                    var gl = renderer.gl;
                    renderer.maskStack.pop();
                    renderer.maskCount--;
                    //  Force flush before disabling stencil test
                    renderer.flush();
                    var current = renderer.currentMask;
                    if (renderer.maskStack.length === 0) {
                        //  If this is the only mask in the stack, flush and disable
                        current.mask = null;
                        gl.disable(gl.STENCIL_TEST);
                    } else {
                        var prev = renderer.maskStack[renderer.maskStack.length - 1];
                        prev.mask.applyStencil(renderer, prev.camera, false);
                        if (renderer.currentCameraMask.mask !== prev.mask) {
                            current.mask = prev.mask;
                            current.camera = prev.camera;
                        } else current.mask = null;
                    }
                },
                /**
     * Sets the clipping path of a 2D canvas context to the Geometry Mask's underlying Graphics object.
     *
     * @method Phaser.Display.Masks.GeometryMask#preRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance to set the clipping path on.
     * @param {Phaser.GameObjects.GameObject} mask - The Game Object being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera the Game Object is being rendered through.
     */ preRenderCanvas: function(renderer, mask, camera) {
                    var geometryMask = this.geometryMask;
                    renderer.currentContext.save();
                    geometryMask.renderCanvas(renderer, geometryMask, camera, null, null, true);
                    renderer.currentContext.clip();
                },
                /**
     * Restore the canvas context's previous clipping path, thus turning off the mask for it.
     *
     * @method Phaser.Display.Masks.GeometryMask#postRenderCanvas
     * @since 3.0.0
     *
     * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - The Canvas Renderer instance being restored.
     */ postRenderCanvas: function(renderer) {
                    renderer.currentContext.restore();
                },
                /**
     * Destroys this GeometryMask and nulls any references it holds.
     *
     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
     *
     * @method Phaser.Display.Masks.GeometryMask#destroy
     * @since 3.7.0
     */ destroy: function() {
                    this.geometryMask = null;
                }
            });
            module1.exports = GeometryMask;
        /***/ },
        /* 306 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the Scroll Factor of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.ScrollFactor
 * @since 3.0.0
 */ var ScrollFactor = {
                /**
     * The horizontal scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorX: 1,
                /**
     * The vertical scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scrollFactorY: 1,
                /**
     * Sets the scroll factor of this Game Object.
     *
     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
     *
     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
     * It does not change the Game Objects actual position values.
     *
     * A value of 1 means it will move exactly in sync with a camera.
     * A value of 0 means it will not move at all, even if the camera moves.
     * Other values control the degree to which the camera movement is mapped to this Game Object.
     * 
     * Please be aware that scroll factor values other than 1 are not taken in to consideration when
     * calculating physics collisions. Bodies always collide based on their world position, but changing
     * the scroll factor is a visual adjustment to where the textures are rendered, which can offset
     * them from physics bodies if not accounted for in your code.
     *
     * @method Phaser.GameObjects.Components.ScrollFactor#setScrollFactor
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scroll factor of this Game Object.
     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScrollFactor: function(x, y) {
                    if (y === undefined) y = x;
                    this.scrollFactorX = x;
                    this.scrollFactorY = y;
                    return this;
                }
            };
            module1.exports = ScrollFactor;
        /***/ },
        /* 307 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var TransformMatrix = __webpack_require__(25);
            var TransformXY = __webpack_require__(174);
            var WrapAngle = __webpack_require__(265);
            var WrapAngleDegrees = __webpack_require__(266);
            var Vector2 = __webpack_require__(3);
            //  global bitmask flag for GameObject.renderMask (used by Scale)
            var _FLAG = 4; // 0100
            /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                /**
     * Private internal value. Holds the horizontal scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleX
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleX: 1,
                /**
     * Private internal value. Holds the vertical scale value.
     *
     * @name Phaser.GameObjects.Components.Transform#_scaleY
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _scaleY: 1,
                /**
     * Private internal value. Holds the rotation value in radians.
     *
     * @name Phaser.GameObjects.Components.Transform#_rotation
     * @type {number}
     * @private
     * @default 0
     * @since 3.0.0
     */ _rotation: 0,
                /**
     * The x position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: 0,
                /**
     * The y position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: 0,
                /**
     * The z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#depth} instead.
     *
     * @name Phaser.GameObjects.Components.Transform#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: 0,
                /**
     * The w position of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: 0,
                /**
     * This is a special setter that allows you to set both the horizontal and vertical scale of this Game Object
     * to the same value, at the same time. When reading this value the result returned is `(scaleX + scaleY) / 2`.
     *
     * Use of this property implies you wish the horizontal and vertical scales to be equal to each other. If this
     * isn't the case, use the `scaleX` or `scaleY` properties instead.
     *
     * @name Phaser.GameObjects.Components.Transform#scale
     * @type {number}
     * @default 1
     * @since 3.18.0
     */ scale: {
                    get: function() {
                        return (this._scaleX + this._scaleY) / 2;
                    },
                    set: function(value) {
                        this._scaleX = value;
                        this._scaleY = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleX
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(value) {
                        this._scaleX = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.GameObjects.Components.Transform#scaleY
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(value) {
                        this._scaleY = value;
                        if (value === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The angle of this Game Object as expressed in degrees.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, 90 is down, 180/-180 is left
     * and -90 is up.
     *
     * If you prefer to work in radians, see the `rotation` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#angle
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ angle: {
                    get: function() {
                        return WrapAngleDegrees(this._rotation * MATH_CONST.RAD_TO_DEG);
                    },
                    set: function(value) {
                        //  value is in degrees
                        this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                    }
                },
                /**
     * The angle of this Game Object in radians.
     *
     * Phaser uses a right-hand clockwise rotation system, where 0 is right, PI/2 is down, +-PI is left
     * and -PI/2 is up.
     *
     * If you prefer to work in degrees, see the `angle` property instead.
     *
     * @name Phaser.GameObjects.Components.Transform#rotation
     * @type {number}
     * @default 1
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        //  value is in radians
                        this._rotation = WrapAngle(value);
                    }
                },
                /**
     * Sets the position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x position of this Game Object.
     * @param {number} [y=x] - The y position of this Game Object. If not set it will use the `x` value.
     * @param {number} [z=0] - The z position of this Game Object.
     * @param {number} [w=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setPosition: function(x, y, z, w) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    if (z === undefined) z = 0;
                    if (w === undefined) w = 0;
                    this.x = x;
                    this.y = y;
                    this.z = z;
                    this.w = w;
                    return this;
                },
                /**
     * Copies an object's coordinates to this Game Object's position.
     *
     * @method Phaser.GameObjects.Components.Transform#copyPosition
     * @since 3.50.0
     *
     * @param {(Phaser.Types.Math.Vector2Like|Phaser.Types.Math.Vector3Like|Phaser.Types.Math.Vector4Like)} source - An object with numeric 'x', 'y', 'z', or 'w' properties. Undefined values are not copied.
     *
     * @return {this} This Game Object instance.
     */ copyPosition: function(source) {
                    if (source.x !== undefined) this.x = source.x;
                    if (source.y !== undefined) this.y = source.y;
                    if (source.z !== undefined) this.z = source.z;
                    if (source.w !== undefined) this.w = source.w;
                    return this;
                },
                /**
     * Sets the position of this Game Object to be a random position within the confines of
     * the given area.
     *
     * If no area is specified a random position between 0 x 0 and the game width x height is used instead.
     *
     * The position does not factor in the size of this Game Object, meaning that only the origin is
     * guaranteed to be within the area.
     *
     * @method Phaser.GameObjects.Components.Transform#setRandomPosition
     * @since 3.8.0
     *
     * @param {number} [x=0] - The x position of the top-left of the random area.
     * @param {number} [y=0] - The y position of the top-left of the random area.
     * @param {number} [width] - The width of the random area.
     * @param {number} [height] - The height of the random area.
     *
     * @return {this} This Game Object instance.
     */ setRandomPosition: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    this.x = x + Math.random() * width;
                    this.y = y + Math.random() * height;
                    return this;
                },
                /**
     * Sets the rotation of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The rotation of this Game Object, in radians.
     *
     * @return {this} This Game Object instance.
     */ setRotation: function(radians) {
                    if (radians === undefined) radians = 0;
                    this.rotation = radians;
                    return this;
                },
                /**
     * Sets the angle of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The rotation of this Game Object, in degrees.
     *
     * @return {this} This Game Object instance.
     */ setAngle: function(degrees) {
                    if (degrees === undefined) degrees = 0;
                    this.angle = degrees;
                    return this;
                },
                /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} x - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the `x` value.
     *
     * @return {this} This Game Object instance.
     */ setScale: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    this.scaleX = x;
                    this.scaleY = y;
                    return this;
                },
                /**
     * Sets the x position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setX
     * @since 3.0.0
     *
     * @param {number} [value=0] - The x position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setX: function(value) {
                    if (value === undefined) value = 0;
                    this.x = value;
                    return this;
                },
                /**
     * Sets the y position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setY
     * @since 3.0.0
     *
     * @param {number} [value=0] - The y position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setY: function(value) {
                    if (value === undefined) value = 0;
                    this.y = value;
                    return this;
                },
                /**
     * Sets the z position of this Game Object.
     *
     * Note: The z position does not control the rendering order of 2D Game Objects. Use
     * {@link Phaser.GameObjects.Components.Depth#setDepth} instead.
     *
     * @method Phaser.GameObjects.Components.Transform#setZ
     * @since 3.0.0
     *
     * @param {number} [value=0] - The z position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setZ: function(value) {
                    if (value === undefined) value = 0;
                    this.z = value;
                    return this;
                },
                /**
     * Sets the w position of this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#setW
     * @since 3.0.0
     *
     * @param {number} [value=0] - The w position of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setW: function(value) {
                    if (value === undefined) value = 0;
                    this.w = value;
                    return this;
                },
                /**
     * Gets the local transform matrix for this Game Object.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getLocalTransformMatrix: function(tempMatrix) {
                    if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                    return tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                },
                /**
     * Gets the world transform matrix for this Game Object, factoring in any parent Containers.
     *
     * @method Phaser.GameObjects.Components.Transform#getWorldTransformMatrix
     * @since 3.4.0
     *
     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentMatrix] - A temporary matrix to hold parent values during the calculations.
     *
     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
     */ getWorldTransformMatrix: function(tempMatrix, parentMatrix) {
                    if (tempMatrix === undefined) tempMatrix = new TransformMatrix();
                    if (parentMatrix === undefined) parentMatrix = new TransformMatrix();
                    var parent = this.parentContainer;
                    if (!parent) return this.getLocalTransformMatrix(tempMatrix);
                    tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
                    while(parent){
                        parentMatrix.applyITRS(parent.x, parent.y, parent._rotation, parent._scaleX, parent._scaleY);
                        parentMatrix.multiply(tempMatrix, tempMatrix);
                        parent = parent.parentContainer;
                    }
                    return tempMatrix;
                },
                /**
     * Takes the given `x` and `y` coordinates and converts them into local space for this
     * Game Object, taking into account parent and local transforms, and the Display Origin.
     *
     * The returned Vector2 contains the translated point in its properties.
     *
     * A Camera needs to be provided in order to handle modified scroll factors. If no
     * camera is specified, it will use the `main` camera from the Scene to which this
     * Game Object belongs.
     *
     * @method Phaser.GameObjects.Components.Transform#getLocalPoint
     * @since 3.50.0
     *
     * @param {number} x - The x position to translate.
     * @param {number} y - The y position to translate.
     * @param {Phaser.Math.Vector2} [point] - A Vector2, or point-like object, to store the results in.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera which is being tested against. If not given will use the Scene default camera.
     *
     * @return {Phaser.Math.Vector2} The translated point.
     */ getLocalPoint: function(x, y, point, camera) {
                    if (!point) point = new Vector2();
                    if (!camera) camera = this.scene.sys.cameras.main;
                    var csx = camera.scrollX;
                    var csy = camera.scrollY;
                    var px = x + csx * this.scrollFactorX - csx;
                    var py = y + csy * this.scrollFactorY - csy;
                    if (this.parentContainer) this.getWorldTransformMatrix().applyInverse(px, py, point);
                    else TransformXY(px, py, this.x, this.y, this.rotation, this.scaleX, this.scaleY, point);
                    //  Normalize origin
                    if (this._originComponent) {
                        point.x += this._displayOriginX;
                        point.y += this._displayOriginY;
                    }
                    return point;
                },
                /**
     * Gets the sum total rotation of all of this Game Objects parent Containers.
     *
     * The returned value is in radians and will be zero if this Game Object has no parent container.
     *
     * @method Phaser.GameObjects.Components.Transform#getParentRotation
     * @since 3.18.0
     *
     * @return {number} The sum total rotation, in radians, of all parent containers of this Game Object.
     */ getParentRotation: function() {
                    var rotation = 0;
                    var parent = this.parentContainer;
                    while(parent){
                        rotation += parent.rotation;
                        parent = parent.parentContainer;
                    }
                    return rotation;
                }
            };
            module1.exports = Transform;
        /***/ },
        /* 308 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 1; // 0001
            /**
 * Provides methods used for setting the visibility of a Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.Visible
 * @since 3.0.0
 */ var Visible = {
                /**
     * Private internal value. Holds the visible value.
     * 
     * @name Phaser.GameObjects.Components.Visible#_visible
     * @type {boolean}
     * @private
     * @default true
     * @since 3.0.0
     */ _visible: true,
                /**
     * The visible state of the Game Object.
     * 
     * An invisible Game Object will skip rendering, but will still process update logic.
     * 
     * @name Phaser.GameObjects.Components.Visible#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(value) {
                        if (value) {
                            this._visible = true;
                            this.renderFlags |= _FLAG;
                        } else {
                            this._visible = false;
                            this.renderFlags &= ~_FLAG;
                        }
                    }
                },
                /**
     * Sets the visibility of this Game Object.
     * 
     * An invisible Game Object will skip rendering, but will still process update logic.
     *
     * @method Phaser.GameObjects.Components.Visible#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setVisible: function(value) {
                    this.visible = value;
                    return this;
                }
            };
            module1.exports = Visible;
        /***/ },
        /* 309 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data.Events
 */ module1.exports = {
                CHANGE_DATA: __webpack_require__(636),
                CHANGE_DATA_KEY: __webpack_require__(637),
                DESTROY: __webpack_require__(638),
                REMOVE_DATA: __webpack_require__(639),
                SET_DATA: __webpack_require__(640)
            };
        /***/ },
        /* 310 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Perimeter = __webpack_require__(128);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of points from the perimeter of the Rectangle, where each point is spaced out based
 * on either the `step` value, or the `quantity`.
 *
 * @function Phaser.Geom.Rectangle.MarchingAnts
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the perimeter points from.
 * @param {number} [step] - The distance between each point of the perimeter. Set to `null` if you wish to use the `quantity` parameter instead.
 * @param {number} [quantity] - The total number of points to return. The step is then calculated based on the length of the Rectangle, divided by this value.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array in which the perimeter points will be stored. If not given, a new array instance is created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array containing the perimeter points from the Rectangle.
 */ var MarchingAnts = function(rect, step, quantity, out) {
                if (out === undefined) out = [];
                if (!step && !quantity) //  Bail out
                return out;
                //  If step is a falsey value (false, null, 0, undefined, etc) then we calculate
                //  it based on the quantity instead, otherwise we always use the step value
                if (!step) step = Perimeter(rect) / quantity;
                else quantity = Math.round(Perimeter(rect) / step);
                var x = rect.x;
                var y = rect.y;
                var face = 0;
                //  Loop across each face of the rectangle
                for(var i = 0; i < quantity; i++){
                    out.push(new Point(x, y));
                    switch(face){
                        //  Top face
                        case 0:
                            x += step;
                            if (x >= rect.right) {
                                face = 1;
                                y += x - rect.right;
                                x = rect.right;
                            }
                            break;
                        //  Right face
                        case 1:
                            y += step;
                            if (y >= rect.bottom) {
                                face = 2;
                                x -= y - rect.bottom;
                                y = rect.bottom;
                            }
                            break;
                        //  Bottom face
                        case 2:
                            x -= step;
                            if (x <= rect.left) {
                                face = 3;
                                y -= rect.left - x;
                                x = rect.left;
                            }
                            break;
                        //  Left face
                        case 3:
                            y -= step;
                            if (y <= rect.top) {
                                face = 0;
                                y = rect.top;
                            }
                            break;
                    }
                }
                return out;
            };
            module1.exports = MarchingAnts;
        /***/ },
        /* 311 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Using Bresenham's line algorithm this will return an array of all coordinates on this line.
 *
 * The `start` and `end` points are rounded before this runs as the algorithm works on integers.
 *
 * @function Phaser.Geom.Line.BresenhamPoints
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line.
 * @param {number} [stepRate=1] - The optional step rate for the points on the line.
 * @param {Phaser.Types.Math.Vector2Like[]} [results] - An optional array to push the resulting coordinates into.
 *
 * @return {Phaser.Types.Math.Vector2Like[]} The array of coordinates on the line.
 */ var BresenhamPoints = function(line, stepRate, results) {
                if (stepRate === undefined) stepRate = 1;
                if (results === undefined) results = [];
                var x1 = Math.round(line.x1);
                var y1 = Math.round(line.y1);
                var x2 = Math.round(line.x2);
                var y2 = Math.round(line.y2);
                var dx = Math.abs(x2 - x1);
                var dy = Math.abs(y2 - y1);
                var sx = x1 < x2 ? 1 : -1;
                var sy = y1 < y2 ? 1 : -1;
                var err = dx - dy;
                results.push({
                    x: x1,
                    y: y1
                });
                var i = 1;
                while(!(x1 === x2 && y1 === y2)){
                    var e2 = err << 1;
                    if (e2 > -dy) {
                        err -= dy;
                        x1 += sx;
                    }
                    if (e2 < dx) {
                        err += dx;
                        y1 += sy;
                    }
                    if (i % stepRate === 0) results.push({
                        x: x1,
                        y: y1
                    });
                    i++;
                }
                return results;
            };
            module1.exports = BresenhamPoints;
        /***/ },
        /* 312 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches a pre-sorted array for the closet value to the given number.
 *
 * If the `key` argument is given it will assume the array contains objects that all have the required `key` property name,
 * and will check for the closest value of those to the given number.
 *
 * @function Phaser.Utils.Array.FindClosestInSorted
 * @since 3.0.0
 *
 * @param {number} value - The value to search for in the array.
 * @param {array} array - The array to search, which must be sorted.
 * @param {string} [key] - An optional property key. If specified the array elements property will be checked against value.
 *
 * @return {(number|any)} The nearest value found in the array, or if a `key` was given, the nearest object with the matching property value.
 */ var FindClosestInSorted = function(value, array, key) {
                if (!array.length) return NaN;
                else if (array.length === 1) return array[0];
                var i = 1;
                var low;
                var high;
                if (key) {
                    if (value < array[0][key]) return array[0];
                    while(array[i][key] < value)i++;
                } else while(array[i] < value)i++;
                if (i > array.length) i = array.length;
                if (key) {
                    low = array[i - 1][key];
                    high = array[i][key];
                    return high - value <= value - low ? array[i] : array[i - 1];
                } else {
                    low = array[i - 1];
                    high = array[i];
                    return high - value <= value - low ? high : low;
                }
            };
            module1.exports = FindClosestInSorted;
        /***/ },
        /* 313 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A single frame in an Animation sequence.
 *
 * An AnimationFrame consists of a reference to the Texture it uses for rendering, references to other
 * frames in the animation, and index data. It also has the ability to modify the animation timing.
 *
 * AnimationFrames are generated automatically by the Animation class.
 *
 * @class AnimationFrame
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {string} textureKey - The key of the Texture this AnimationFrame uses.
 * @param {(string|number)} textureFrame - The key of the Frame within the Texture that this AnimationFrame uses.
 * @param {number} index - The index of this AnimationFrame within the Animation sequence.
 * @param {Phaser.Textures.Frame} frame - A reference to the Texture Frame this AnimationFrame uses for rendering.
 * @param {boolean} [isKeyFrame=false] - Is this Frame a Keyframe within the Animation?
 */ var AnimationFrame = new Class({
                initialize: function AnimationFrame(textureKey, textureFrame, index, frame, isKeyFrame) {
                    if (isKeyFrame === undefined) isKeyFrame = false;
                    /**
         * The key of the Texture this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureKey
         * @type {string}
         * @since 3.0.0
         */ this.textureKey = textureKey;
                    /**
         * The key of the Frame within the Texture that this AnimationFrame uses.
         *
         * @name Phaser.Animations.AnimationFrame#textureFrame
         * @type {(string|number)}
         * @since 3.0.0
         */ this.textureFrame = textureFrame;
                    /**
         * The index of this AnimationFrame within the Animation sequence.
         *
         * @name Phaser.Animations.AnimationFrame#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * A reference to the Texture Frame this AnimationFrame uses for rendering.
         *
         * @name Phaser.Animations.AnimationFrame#frame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.frame = frame;
                    /**
         * Is this the first frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isFirst
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isFirst = false;
                    /**
         * Is this the last frame in an animation sequence?
         *
         * @name Phaser.Animations.AnimationFrame#isLast
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isLast = false;
                    /**
         * A reference to the AnimationFrame that comes before this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#prevFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.prevFrame = null;
                    /**
         * A reference to the AnimationFrame that comes after this one in the animation, if any.
         *
         * @name Phaser.Animations.AnimationFrame#nextFrame
         * @type {?Phaser.Animations.AnimationFrame}
         * @default null
         * @readonly
         * @since 3.0.0
         */ this.nextFrame = null;
                    /**
         * Additional time (in ms) that this frame should appear for during playback.
         * The value is added onto the msPerFrame set by the animation.
         *
         * @name Phaser.Animations.AnimationFrame#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * What % through the animation does this frame come?
         * This value is generated when the animation is created and cached here.
         *
         * @name Phaser.Animations.AnimationFrame#progress
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Is this Frame a KeyFrame within the Animation?
         *
         * @name Phaser.Animations.AnimationFrame#isKeyFrame
         * @type {boolean}
         * @since 3.50.0
         */ this.isKeyFrame = isKeyFrame;
                },
                /**
     * Generates a JavaScript object suitable for converting to JSON.
     *
     * @method Phaser.Animations.AnimationFrame#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Animations.JSONAnimationFrame} The AnimationFrame data.
     */ toJSON: function() {
                    return {
                        key: this.textureKey,
                        frame: this.textureFrame,
                        duration: this.duration,
                        keyframe: this.isKeyFrame
                    };
                },
                /**
     * Destroys this object by removing references to external resources and callbacks.
     *
     * @method Phaser.Animations.AnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.frame = undefined;
                }
            });
            module1.exports = AnimationFrame;
        /***/ },
        /* 314 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given array and runs a numeric sort on it, ignoring any non-digits that
 * may be in the entries.
 *
 * You should only run this on arrays containing strings.
 *
 * @function Phaser.Utils.Array.SortByDigits
 * @since 3.50.0
 *
 * @param {string[]} array - The input array of strings.
 *
 * @return {string[]} The sorted input array.
 */ var SortByDigits = function(array) {
                var re = /\D/g;
                array.sort(function(a, b) {
                    return parseInt(a.replace(re, ''), 10) - parseInt(b.replace(re, ''), 10);
                });
                return array;
            };
            module1.exports = SortByDigits;
        /***/ },
        /* 315 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Animation = __webpack_require__(182);
            var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(99);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(130);
            var GameEvents = __webpack_require__(22);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var Pad = __webpack_require__(183);
            var NumberArray = __webpack_require__(316);
            /**
 * @classdesc
 * The Animation Manager.
 *
 * Animations are managed by the global Animation Manager. This is a singleton class that is
 * responsible for creating and delivering animations and their corresponding data to all Game Objects.
 * Unlike plugins it is owned by the Game instance, not the Scene.
 *
 * Sprites and other Game Objects get the data they need from the AnimationManager.
 *
 * @class AnimationManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Animations
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var AnimationManager = new Class({
                Extends: EventEmitter,
                initialize: function AnimationManager(game) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Animations.AnimationManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A reference to the Texture Manager.
         *
         * @name Phaser.Animations.AnimationManager#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @protected
         * @since 3.0.0
         */ this.textureManager = null;
                    /**
         * The global time scale of the Animation Manager.
         *
         * This scales the time delta between two frames, thus influencing the speed of time for the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#globalTimeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.globalTimeScale = 1;
                    /**
         * The Animations registered in the Animation Manager.
         *
         * This map should be modified with the {@link #add} and {@link #create} methods of the Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#anims
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @protected
         * @since 3.0.0
         */ this.anims = new CustomMap();
                    /**
         * A list of animation mix times.
         *
         * See the {@link #setMix} method for more details.
         *
         * @name Phaser.Animations.AnimationManager#mixes
         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
         * @since 3.50.0
         */ this.mixes = new CustomMap();
                    /**
         * Whether the Animation Manager is paused along with all of its Animations.
         *
         * @name Phaser.Animations.AnimationManager#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * The name of this Animation Manager.
         *
         * @name Phaser.Animations.AnimationManager#name
         * @type {string}
         * @since 3.0.0
         */ this.name = 'AnimationManager';
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * Registers event listeners after the Game boots.
     *
     * @method Phaser.Animations.AnimationManager#boot
     * @listens Phaser.Core.Events#DESTROY
     * @since 3.0.0
     */ boot: function() {
                    this.textureManager = this.game.textures;
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Adds a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * When playing Animation A on a Game Object, if you then play Animation B, and a
     * mix exists, it will wait for the specified delay to be over before playing Animation B.
     *
     * This allows you to customise smoothing between different types of animation, such
     * as blending between an idle and a walk state, or a running and a firing state.
     *
     * Note that mixing is only applied if you use the `Sprite.play` method. If you opt to use
     * `playAfterRepeat` or `playAfterDelay` instead, those will take pririty and the mix
     * delay will not be used.
     *
     * To update an existing mix, just call this method with the new delay.
     *
     * To remove a mix pairing, see the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#addMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     * @param {number} delay - The delay, in milliseconds, to wait when transitioning from Animation A to B.
     *
     * @return {this} This Animation Manager.
     */ addMix: function(animA, animB, delay) {
                    var anims = this.anims;
                    var mixes = this.mixes;
                    var keyA = typeof animA === 'string' ? animA : animA.key;
                    var keyB = typeof animB === 'string' ? animB : animB.key;
                    if (anims.has(keyA) && anims.has(keyB)) {
                        var mixObj = mixes.get(keyA);
                        if (!mixObj) mixObj = {};
                        mixObj[keyB] = delay;
                        mixes.set(keyA, mixObj);
                    }
                    return this;
                },
                /**
     * Removes a mix between two animations.
     *
     * Mixing allows you to specify a unique delay between a pairing of animations.
     *
     * Calling this method lets you remove those pairings. You can either remove
     * it between `animA` and `animB`, or if you do not provide the `animB` parameter,
     * it will remove all `animA` mixes.
     *
     * If you wish to update an existing mix instead, call the `addMix` method with the
     * new delay.
     *
     * @method Phaser.Animations.AnimationManager#removeMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} [animB] - The string-based key, or instance of, Animation B. If not given, all mixes for Animation A will be removed.
     *
     * @return {this} This Animation Manager.
     */ removeMix: function(animA, animB) {
                    var mixes = this.mixes;
                    var keyA = typeof animA === 'string' ? animA : animA.key;
                    var mixObj = mixes.get(keyA);
                    if (mixObj) {
                        if (animB) {
                            var keyB = typeof animB === 'string' ? animB : animB.key;
                            if (mixObj.hasOwnProperty(keyB)) //  Remove just this pairing
                            delete mixObj[keyB];
                        } else if (!animB) //  Remove everything for animA
                        mixes.delete(keyA);
                    }
                    return this;
                },
                /**
     * Returns the mix delay between two animations.
     *
     * If no mix has been set-up, this method will return zero.
     *
     * If you wish to create, or update, a new mix, call the `addMix` method.
     * If you wish to remove a mix, call the `removeMix` method.
     *
     * @method Phaser.Animations.AnimationManager#getMix
     * @since 3.50.0
     *
     * @param {(string|Phaser.Animations.Animation)} animA - The string-based key, or instance of, Animation A.
     * @param {(string|Phaser.Animations.Animation)} animB - The string-based key, or instance of, Animation B.
     *
     * @return {number} The mix duration, or zero if no mix exists.
     */ getMix: function(animA, animB) {
                    var mixes = this.mixes;
                    var keyA = typeof animA === 'string' ? animA : animA.key;
                    var keyB = typeof animB === 'string' ? animB : animB.key;
                    var mixObj = mixes.get(keyA);
                    if (mixObj && mixObj.hasOwnProperty(keyB)) return mixObj[keyB];
                    else return 0;
                },
                /**
     * Adds an existing Animation to the Animation Manager.
     *
     * @method Phaser.Animations.AnimationManager#add
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key under which the Animation should be added. The Animation will be updated with it. Must be unique.
     * @param {Phaser.Animations.Animation} animation - The Animation which should be added to the Animation Manager.
     *
     * @return {this} This Animation Manager.
     */ add: function(key, animation) {
                    if (this.anims.has(key)) {
                        console.warn('Animation key exists: ' + key);
                        return this;
                    }
                    animation.key = key;
                    this.anims.set(key, animation);
                    this.emit(Events.ADD_ANIMATION, key, animation);
                    return this;
                },
                /**
     * Checks to see if the given key is already in use within the Animation Manager or not.
     *
     * Animations are global. Keys created in one scene can be used from any other Scene in your game. They are not Scene specific.
     *
     * @method Phaser.Animations.AnimationManager#exists
     * @since 3.16.0
     *
     * @param {string} key - The key of the Animation to check.
     *
     * @return {boolean} `true` if the Animation already exists in the Animation Manager, or `false` if the key is available.
     */ exists: function(key) {
                    return this.anims.has(key);
                },
                /**
     * Create one, or more animations from a loaded Aseprite JSON file.
     *
     * Aseprite is a powerful animated sprite editor and pixel art tool.
     *
     * You can find more details at https://www.aseprite.org/
     *
     * To export a compatible JSON file in Aseprite, please do the following:
     *
     * 1. Go to "File - Export Sprite Sheet"
     *
     * 2. On the **Layout** tab:
     * 2a. Set the "Sheet type" to "Packed"
     * 2b. Set the "Constraints" to "None"
     * 2c. Check the "Merge Duplicates" checkbox
     *
     * 3. On the **Sprite** tab:
     * 3a. Set "Layers" to "Visible layers"
     * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
     *
     * 4. On the **Borders** tab:
     * 4a. Check the "Trim Sprite" and "Trim Cells" options
     * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
     *
     * 5. On the **Output** tab:
     * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
     * 5b. Check "JSON Data" and give your json file a name
     * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
     * 5d. Make sure "Tags" is checked in the Meta options
     * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
     *
     * 6. Click export
     *
     * This was tested with Aseprite 1.2.25.
     *
     * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
     *
     * ```javascript
     * function preload ()
     * {
     *     this.load.path = 'assets/animations/aseprite/';
     *     this.load.aseprite('paladin', 'paladin.png', 'paladin.json');
     * }
     * ```
     *
     * Once loaded, you can call this method from within a Scene with the 'atlas' key:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin');
     * ```
     *
     * Any animations defined in the JSON will now be available to use in Phaser and you play them
     * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
     * you can play it in Phaser using that Tag name:
     *
     * ```javascript
     * this.add.sprite(400, 300).play('War Cry');
     * ```
     *
     * When calling this method you can optionally provide an array of tag names, and only those animations
     * will be created. For example:
     *
     * ```javascript
     * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
     * ```
     *
     * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
     *
     * @method Phaser.Animations.AnimationManager#createFromAseprite
     * @since 3.50.0
     *
     * @param {string} key - The key of the loaded Aseprite atlas. It must have been loaded prior to calling this method.
     * @param {string[]} [tags] - An array of Tag names. If provided, only animations found in this array will be created.
     *
     * @return {Phaser.Animations.Animation[]} An array of Animation instances that were successfully created.
     */ createFromAseprite: function(key, tags) {
                    var output = [];
                    var data = this.game.cache.json.get(key);
                    if (!data) return output;
                    var _this = this;
                    var meta = GetValue(data, 'meta', null);
                    var frames = GetValue(data, 'frames', null);
                    if (meta && frames) {
                        var frameTags = GetValue(meta, 'frameTags', []);
                        frameTags.forEach(function(tag) {
                            var animFrames = [];
                            var name = GetFastValue(tag, 'name', null);
                            var from = GetFastValue(tag, 'from', 0);
                            var to = GetFastValue(tag, 'to', 0);
                            var direction = GetFastValue(tag, 'direction', 'forward');
                            if (!name) //  Skip if no name
                            return;
                            if (!tags || tags && tags.indexOf(name) > -1) {
                                //  Get all the frames for this tag
                                var tempFrames = [];
                                var minDuration = Number.MAX_SAFE_INTEGER;
                                for(var i = from; i <= to; i++){
                                    var frameKey = i.toString();
                                    var frame = frames[frameKey];
                                    if (frame) {
                                        var frameDuration = GetFastValue(frame, 'duration', Number.MAX_SAFE_INTEGER);
                                        if (frameDuration < minDuration) minDuration = frameDuration;
                                        tempFrames.push({
                                            frame: frameKey,
                                            duration: frameDuration
                                        });
                                    }
                                }
                                tempFrames.forEach(function(entry) {
                                    animFrames.push({
                                        key: key,
                                        frame: entry.frame,
                                        duration: minDuration - entry.duration
                                    });
                                });
                                var totalDuration = minDuration * animFrames.length;
                                if (direction === 'reverse') animFrames = animFrames.reverse();
                                //  Create the animation
                                var createConfig = {
                                    key: name,
                                    frames: animFrames,
                                    duration: totalDuration,
                                    yoyo: direction === 'pingpong'
                                };
                                var result = _this.create(createConfig);
                                if (result) output.push(result);
                            }
                        });
                    }
                    return output;
                },
                /**
     * Creates a new Animation and adds it to the Animation Manager.
     *
     * Animations are global. Once created, you can use them in any Scene in your game. They are not Scene specific.
     *
     * If an invalid key is given this method will return `false`.
     *
     * If you pass the key of an animation that already exists in the Animation Manager, that animation will be returned.
     *
     * A brand new animation is only created if the key is valid and not already in use.
     *
     * If you wish to re-use an existing key, call `AnimationManager.remove` first, then this method.
     *
     * @method Phaser.Animations.AnimationManager#create
     * @fires Phaser.Animations.Events#ADD_ANIMATION
     * @since 3.0.0
     *
     * @param {Phaser.Types.Animations.Animation} config - The configuration settings for the Animation.
     *
     * @return {(Phaser.Animations.Animation|false)} The Animation that was created, or `false` if the key is already in use.
     */ create: function(config) {
                    var key = config.key;
                    var anim = false;
                    if (key) {
                        anim = this.get(key);
                        if (!anim) {
                            anim = new Animation(this, key, config);
                            this.anims.set(key, anim);
                            this.emit(Events.ADD_ANIMATION, key, anim);
                        }
                    }
                    return anim;
                },
                /**
     * Loads this Animation Manager's Animations and settings from a JSON object.
     *
     * @method Phaser.Animations.AnimationManager#fromJSON
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Animations.JSONAnimations|Phaser.Types.Animations.JSONAnimation)} data - The JSON object to parse.
     * @param {boolean} [clearCurrentAnimations=false] - If set to `true`, the current animations will be removed (`anims.clear()`). If set to `false` (default), the animations in `data` will be added.
     *
     * @return {Phaser.Animations.Animation[]} An array containing all of the Animation objects that were created as a result of this call.
     */ fromJSON: function(data, clearCurrentAnimations) {
                    if (clearCurrentAnimations === undefined) clearCurrentAnimations = false;
                    if (clearCurrentAnimations) this.anims.clear();
                    //  Do we have a String (i.e. from JSON, or an Object?)
                    if (typeof data === 'string') data = JSON.parse(data);
                    var output = [];
                    //  Array of animations, or a single animation?
                    if (data.hasOwnProperty('anims') && Array.isArray(data.anims)) {
                        for(var i = 0; i < data.anims.length; i++)output.push(this.create(data.anims[i]));
                        if (data.hasOwnProperty('globalTimeScale')) this.globalTimeScale = data.globalTimeScale;
                    } else if (data.hasOwnProperty('key') && data.type === 'frame') output.push(this.create(data));
                    return output;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with string based frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNames}.
     *
     * It's a helper method, designed to make it easier for you to extract all of the frame names from texture atlases.
     * If you're working with a sprite sheet, see the `generateFrameNumbers` method instead.
     *
     * Example:
     *
     * If you have a texture atlases loaded called `gems` and it contains 6 frames called `ruby_0001`, `ruby_0002`, and so on,
     * then you can call this method using: `this.anims.generateFrameNames('gems', { prefix: 'ruby_', end: 6, zeroPad: 4 })`.
     *
     * The `end` value tells it to look for 6 frames, incrementally numbered, all starting with the prefix `ruby_`. The `zeroPad`
     * value tells it how many zeroes pad out the numbers. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'ruby',
     *   repeat: -1,
     *   frames: this.anims.generateFrameNames('gems', {
     *     prefix: 'ruby_',
     *     end: 6,
     *     zeroPad: 4
     *   })
     * });
     * ```
     *
     * Please see the animation examples for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNames
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNames} [config] - The configuration object for the animation frame names.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNames: function(key, config) {
                    var prefix = GetValue(config, 'prefix', '');
                    var start = GetValue(config, 'start', 0);
                    var end = GetValue(config, 'end', 0);
                    var suffix = GetValue(config, 'suffix', '');
                    var zeroPad = GetValue(config, 'zeroPad', 0);
                    var out = GetValue(config, 'outputArray', []);
                    var frames = GetValue(config, 'frames', false);
                    var texture = this.textureManager.get(key);
                    if (!texture) return out;
                    var i;
                    if (!config) {
                        //  Use every frame in the atlas
                        frames = texture.getFrameNames();
                        for(i = 0; i < frames.length; i++)out.push({
                            key: key,
                            frame: frames[i]
                        });
                    } else {
                        if (!frames) frames = NumberArray(start, end);
                        for(i = 0; i < frames.length; i++){
                            var frame = prefix + Pad(frames[i], zeroPad, '0', 1) + suffix;
                            if (texture.has(frame)) out.push({
                                key: key,
                                frame: frame
                            });
                            else console.warn('generateFrameNames: Frame missing: ' + frame + ' from texture: ' + key);
                        }
                    }
                    return out;
                },
                /**
     * Generate an array of {@link Phaser.Types.Animations.AnimationFrame} objects from a texture key and configuration object.
     *
     * Generates objects with numbered frame names, as configured by the given {@link Phaser.Types.Animations.GenerateFrameNumbers}.
     *
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * It's a helper method, designed to make it easier for you to extract frames from sprite sheets.
     * If you're working with a texture atlas, see the `generateFrameNames` method instead.
     *
     * Example:
     *
     * If you have a sprite sheet loaded called `explosion` and it contains 12 frames, then you can call this method using:
     * `this.anims.generateFrameNumbers('explosion', { start: 0, end: 12 })`.
     *
     * The `end` value tells it to stop after 12 frames. To create an animation using this method, you can do:
     *
     * ```javascript
     * this.anims.create({
     *   key: 'boom',
     *   frames: this.anims.generateFrameNames('explosion', {
     *     start: 0,
     *     end: 12
     *   })
     * });
     * ```
     *
     * Note that `start` is optional and you don't need to include it if the animation starts from frame 0.
     *
     * To specify an animation in reverse, swap the `start` and `end` values.
     *
     * If the frames are not sequential, you may pass an array of frame numbers instead, for example:
     *
     * `this.anims.generateFrameNumbers('explosion', { frames: [ 0, 1, 2, 1, 2, 3, 4, 0, 1, 2 ] })`
     *
     * Please see the animation examples and `GenerateFrameNumbers` config docs for further details.
     *
     * @method Phaser.Animations.AnimationManager#generateFrameNumbers
     * @since 3.0.0
     *
     * @param {string} key - The key for the texture containing the animation frames.
     * @param {Phaser.Types.Animations.GenerateFrameNumbers} config - The configuration object for the animation frames.
     *
     * @return {Phaser.Types.Animations.AnimationFrame[]} The array of {@link Phaser.Types.Animations.AnimationFrame} objects.
     */ generateFrameNumbers: function(key, config) {
                    var start = GetValue(config, 'start', 0);
                    var end = GetValue(config, 'end', -1);
                    var first = GetValue(config, 'first', false);
                    var out = GetValue(config, 'outputArray', []);
                    var frames = GetValue(config, 'frames', false);
                    var texture = this.textureManager.get(key);
                    if (!texture) return out;
                    if (first && texture.has(first)) out.push({
                        key: key,
                        frame: first
                    });
                    //  No 'frames' array? Then generate one automatically
                    if (!frames) {
                        if (end === -1) //  -1 because of __BASE, which we don't want in our results
                        //  and -1 because frames are zero based
                        end = texture.frameTotal - 2;
                        frames = NumberArray(start, end);
                    }
                    for(var i = 0; i < frames.length; i++)if (texture.has(frames[i])) out.push({
                        key: key,
                        frame: frames[i]
                    });
                    else console.warn('generateFrameNumbers: Frame ' + i + ' missing from texture: ' + key);
                    return out;
                },
                /**
     * Get an Animation.
     *
     * @method Phaser.Animations.AnimationManager#get
     * @since 3.0.0
     *
     * @param {string} key - The key of the Animation to retrieve.
     *
     * @return {Phaser.Animations.Animation} The Animation.
     */ get: function(key) {
                    return this.anims.get(key);
                },
                /**
     * Pause all animations.
     *
     * @method Phaser.Animations.AnimationManager#pauseAll
     * @fires Phaser.Animations.Events#PAUSE_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ pauseAll: function() {
                    if (!this.paused) {
                        this.paused = true;
                        this.emit(Events.PAUSE_ALL);
                    }
                    return this;
                },
                /**
     * Play an animation on the given Game Objects that have an Animation Component.
     *
     * @method Phaser.Animations.AnimationManager#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     *
     * @return {this} This Animation Manager.
     */ play: function(key, children) {
                    if (!Array.isArray(children)) children = [
                        children
                    ];
                    for(var i = 0; i < children.length; i++)children[i].anims.play(key);
                    return this;
                },
                /**
     * Takes an array of Game Objects that have an Animation Component and then
     * starts the given animation playing on them. The start time of each Game Object
     * is offset, incrementally, by the `stagger` amount.
     *
     * For example, if you pass an array with 4 children and a stagger time of 1000,
     * the delays will be:
     *
     * child 1: 1000ms delay
     * child 2: 2000ms delay
     * child 3: 3000ms delay
     * child 4: 4000ms delay
     *
     * If you set the `staggerFirst` parameter to `false` they would be:
     *
     * child 1: 0ms delay
     * child 2: 1000ms delay
     * child 3: 2000ms delay
     * child 4: 3000ms delay
     *
     * You can also set `stagger` to be a negative value. If it was -1000, the above would be:
     *
     * child 1: 3000ms delay
     * child 2: 2000ms delay
     * child 3: 1000ms delay
     * child 4: 0ms delay
     *
     * @method Phaser.Animations.AnimationManager#staggerPlay
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
     *
     * @param {(string|Phaser.Animations.Animation|Phaser.Types.Animations.PlayAnimationConfig)} key - The string-based key of the animation to play, or an Animation instance, or a `PlayAnimationConfig` object.
     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have an Animation Component.
     * @param {number} stagger - The amount of time, in milliseconds, to offset each play time by. If a negative value is given, it's applied to the children in reverse order.
     * @param {boolean} [staggerFirst=true] -Should the first child be staggered as well?
     *
     * @return {this} This Animation Manager.
     */ staggerPlay: function(key, children, stagger, staggerFirst) {
                    if (stagger === undefined) stagger = 0;
                    if (staggerFirst === undefined) staggerFirst = true;
                    if (!Array.isArray(children)) children = [
                        children
                    ];
                    var len = children.length;
                    if (!staggerFirst) len--;
                    for(var i = 0; i < children.length; i++){
                        var time = stagger < 0 ? Math.abs(stagger) * (len - i) : stagger * i;
                        children[i].anims.playAfterDelay(key, time);
                    }
                    return this;
                },
                /**
     * Removes an Animation from this Animation Manager, based on the given key.
     *
     * This is a global action. Once an Animation has been removed, no Game Objects
     * can carry on using it.
     *
     * @method Phaser.Animations.AnimationManager#remove
     * @fires Phaser.Animations.Events#REMOVE_ANIMATION
     * @since 3.0.0
     *
     * @param {string} key - The key of the animation to remove.
     *
     * @return {Phaser.Animations.Animation} The Animation instance that was removed from the Animation Manager.
     */ remove: function(key) {
                    var anim = this.get(key);
                    if (anim) {
                        this.emit(Events.REMOVE_ANIMATION, key, anim);
                        this.anims.delete(key);
                        this.removeMix(key);
                    }
                    return anim;
                },
                /**
     * Resume all paused animations.
     *
     * @method Phaser.Animations.AnimationManager#resumeAll
     * @fires Phaser.Animations.Events#RESUME_ALL
     * @since 3.0.0
     *
     * @return {this} This Animation Manager.
     */ resumeAll: function() {
                    if (this.paused) {
                        this.paused = false;
                        this.emit(Events.RESUME_ALL);
                    }
                    return this;
                },
                /**
     * Returns the Animation data as JavaScript object based on the given key.
     * Or, if not key is defined, it will return the data of all animations as array of objects.
     *
     * @method Phaser.Animations.AnimationManager#toJSON
     * @since 3.0.0
     *
     * @param {string} [key] - The animation to get the JSONAnimation data from. If not provided, all animations are returned as an array.
     *
     * @return {Phaser.Types.Animations.JSONAnimations} The resulting JSONAnimations formatted object.
     */ toJSON: function(key) {
                    var output = {
                        anims: [],
                        globalTimeScale: this.globalTimeScale
                    };
                    if (key !== undefined && key !== '') output.anims.push(this.anims.get(key).toJSON());
                    else this.anims.each(function(animationKey, animation) {
                        output.anims.push(animation.toJSON());
                    });
                    return output;
                },
                /**
     * Destroy this Animation Manager and clean up animation definitions and references to other objects.
     * This method should not be called directly. It will be called automatically as a response to a `destroy` event from the Phaser.Game instance.
     *
     * @method Phaser.Animations.AnimationManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.anims.clear();
                    this.mixes.clear();
                    this.textureManager = null;
                    this.game = null;
                }
            });
            module1.exports = AnimationManager;
        /***/ },
        /* 316 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array representing the range of numbers (usually integers), between, and inclusive of,
 * the given `start` and `end` arguments. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(2, 4); // array = [2, 3, 4]`
 * `var array = Phaser.Utils.Array.NumberArray(0, 9); // array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]`
 * `var array = Phaser.Utils.Array.NumberArray(8, 2); // array = [8, 7, 6, 5, 4, 3, 2]`
 *
 * This is equivalent to `Phaser.Utils.Array.NumberArrayStep(start, end, 1)`.
 *
 * You can optionally provide a prefix and / or suffix string. If given the array will contain
 * strings, not integers. For example:
 *
 * `var array = Phaser.Utils.Array.NumberArray(1, 4, 'Level '); // array = ["Level 1", "Level 2", "Level 3", "Level 4"]`
 * `var array = Phaser.Utils.Array.NumberArray(5, 7, 'HD-', '.png'); // array = ["HD-5.png", "HD-6.png", "HD-7.png"]`
 *
 * @function Phaser.Utils.Array.NumberArray
 * @since 3.0.0
 *
 * @param {number} start - The minimum value the array starts with.
 * @param {number} end - The maximum value the array contains.
 * @param {string} [prefix] - Optional prefix to place before the number. If provided the array will contain strings, not integers.
 * @param {string} [suffix] - Optional suffix to place after the number. If provided the array will contain strings, not integers.
 *
 * @return {(number[]|string[])} The array of number values, or strings if a prefix or suffix was provided.
 */ var NumberArray = function(start, end, prefix, suffix) {
                var result = [];
                var i;
                var asString = false;
                if (prefix || suffix) {
                    asString = true;
                    if (!prefix) prefix = '';
                    if (!suffix) suffix = '';
                }
                if (end < start) {
                    for(i = start; i >= end; i--)if (asString) result.push(prefix + i.toString() + suffix);
                    else result.push(i);
                } else {
                    for(i = start; i <= end; i++)if (asString) result.push(prefix + i.toString() + suffix);
                    else result.push(i);
                }
                return result;
            };
            module1.exports = NumberArray;
        /***/ },
        /* 317 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CustomMap = __webpack_require__(99);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(318);
            /**
 * @classdesc
 * The BaseCache is a base Cache class that can be used for storing references to any kind of data.
 *
 * Data can be added, retrieved and removed based on the given keys.
 *
 * Keys are string-based.
 *
 * @class BaseCache
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 */ var BaseCache = new Class({
                initialize: function BaseCache() {
                    /**
         * The Map in which the cache objects are stored.
         *
         * You can query the Map directly or use the BaseCache methods.
         *
         * @name Phaser.Cache.BaseCache#entries
         * @type {Phaser.Structs.Map.<String, *>}
         * @since 3.0.0
         */ this.entries = new CustomMap();
                    /**
         * An instance of EventEmitter used by the cache to emit related events.
         *
         * @name Phaser.Cache.BaseCache#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                },
                /**
     * Adds an item to this cache. The item is referenced by a unique string, which you are responsible
     * for setting and keeping track of. The item can only be retrieved by using this string.
     *
     * @method Phaser.Cache.BaseCache#add
     * @fires Phaser.Cache.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique key by which the data added to the cache will be referenced.
     * @param {*} data - The data to be stored in the cache.
     *
     * @return {this} This BaseCache object.
     */ add: function(key, data) {
                    this.entries.set(key, data);
                    this.events.emit(Events.ADD, this, key, data);
                    return this;
                },
                /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.exists`.
     *
     * @method Phaser.Cache.BaseCache#has
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ has: function(key) {
                    return this.entries.has(key);
                },
                /**
     * Checks if this cache contains an item matching the given key.
     * This performs the same action as `BaseCache.has` and is called directly by the Loader.
     *
     * @method Phaser.Cache.BaseCache#exists
     * @since 3.7.0
     *
     * @param {string} key - The unique key of the item to be checked in this cache.
     *
     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
     */ exists: function(key) {
                    return this.entries.has(key);
                },
                /**
     * Gets an item from this cache based on the given key.
     *
     * @method Phaser.Cache.BaseCache#get
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to be retrieved from this cache.
     *
     * @return {*} The item in the cache, or `null` if no item matching the given key was found.
     */ get: function(key) {
                    return this.entries.get(key);
                },
                /**
     * Removes and item from this cache based on the given key.
     *
     * If an entry matching the key is found it is removed from the cache and a `remove` event emitted.
     * No additional checks are done on the item removed. If other systems or parts of your game code
     * are relying on this item, it is up to you to sever those relationships prior to removing the item.
     *
     * @method Phaser.Cache.BaseCache#remove
     * @fires Phaser.Cache.Events#REMOVE
     * @since 3.0.0
     *
     * @param {string} key - The unique key of the item to remove from the cache.
     *
     * @return {this} This BaseCache object.
     */ remove: function(key) {
                    var entry = this.get(key);
                    if (entry) {
                        this.entries.delete(key);
                        this.events.emit(Events.REMOVE, this, key, entry.data);
                    }
                    return this;
                },
                /**
     * Returns all keys in use in this cache.
     *
     * @method Phaser.Cache.BaseCache#getKeys
     * @since 3.17.0
     *
     * @return {string[]} Array containing all the keys.
     */ getKeys: function() {
                    return this.entries.keys();
                },
                /**
     * Destroys this cache and all items within it.
     *
     * @method Phaser.Cache.BaseCache#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.entries.clear();
                    this.events.removeAllListeners();
                    this.entries = null;
                    this.events = null;
                }
            });
            module1.exports = BaseCache;
        /***/ },
        /* 318 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache.Events
 */ module1.exports = {
                ADD: __webpack_require__(712),
                REMOVE: __webpack_require__(713)
            };
        /***/ },
        /* 319 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCache = __webpack_require__(317);
            var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            /**
 * @classdesc
 * The Cache Manager is the global cache owned and maintained by the Game instance.
 *
 * Various systems, such as the file Loader, rely on this cache in order to store the files
 * it has loaded. The manager itself doesn't store any files, but instead owns multiple BaseCache
 * instances, one per type of file. You can also add your own custom caches.
 *
 * @class CacheManager
 * @memberof Phaser.Cache
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this CacheManager.
 */ var CacheManager = new Class({
                initialize: function CacheManager(game) {
                    /**
         * A reference to the Phaser.Game instance that owns this CacheManager.
         *
         * @name Phaser.Cache.CacheManager#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A Cache storing all binary files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#binary
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.binary = new BaseCache();
                    /**
         * A Cache storing all bitmap font data files, typically added via the Loader.
         * Only the font data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#bitmapFont
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.bitmapFont = new BaseCache();
                    /**
         * A Cache storing all JSON data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#json
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.json = new BaseCache();
                    /**
         * A Cache storing all physics data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#physics
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.physics = new BaseCache();
                    /**
         * A Cache storing all shader source files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#shader
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.shader = new BaseCache();
                    /**
         * A Cache storing all non-streaming audio files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#audio
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.audio = new BaseCache();
                    /**
         * A Cache storing all non-streaming video files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#video
         * @type {Phaser.Cache.BaseCache}
         * @since 3.20.0
         */ this.video = new BaseCache();
                    /**
         * A Cache storing all text files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#text
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.text = new BaseCache();
                    /**
         * A Cache storing all html files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#html
         * @type {Phaser.Cache.BaseCache}
         * @since 3.12.0
         */ this.html = new BaseCache();
                    /**
         * A Cache storing all WaveFront OBJ files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#obj
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.obj = new BaseCache();
                    /**
         * A Cache storing all tilemap data files, typically added via the Loader.
         * Only the data is stored in this cache, the textures are part of the Texture Manager.
         *
         * @name Phaser.Cache.CacheManager#tilemap
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.tilemap = new BaseCache();
                    /**
         * A Cache storing all xml data files, typically added via the Loader.
         *
         * @name Phaser.Cache.CacheManager#xml
         * @type {Phaser.Cache.BaseCache}
         * @since 3.0.0
         */ this.xml = new BaseCache();
                    /**
         * An object that contains your own custom BaseCache entries.
         * Add to this via the `addCustom` method.
         *
         * @name Phaser.Cache.CacheManager#custom
         * @type {Object.<Phaser.Cache.BaseCache>}
         * @since 3.0.0
         */ this.custom = {};
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Add your own custom Cache for storing your own files.
     * The cache will be available under `Cache.custom.key`.
     * The cache will only be created if the key is not already in use.
     *
     * @method Phaser.Cache.CacheManager#addCustom
     * @since 3.0.0
     *
     * @param {string} key - The unique key of your custom cache.
     *
     * @return {Phaser.Cache.BaseCache} A reference to the BaseCache that was created. If the key was already in use, a reference to the existing cache is returned instead.
     */ addCustom: function(key) {
                    if (!this.custom.hasOwnProperty(key)) this.custom[key] = new BaseCache();
                    return this.custom[key];
                },
                /**
     * Removes all entries from all BaseCaches and destroys all custom caches.
     *
     * @method Phaser.Cache.CacheManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    var keys = [
                        'binary',
                        'bitmapFont',
                        'json',
                        'physics',
                        'shader',
                        'audio',
                        'video',
                        'text',
                        'html',
                        'obj',
                        'tilemap',
                        'xml'
                    ];
                    for(var i = 0; i < keys.length; i++){
                        this[keys[i]].destroy();
                        this[keys[i]] = null;
                    }
                    for(var key in this.custom)this.custom[key].destroy();
                    this.custom = null;
                    this.game = null;
                }
            });
            module1.exports = CacheManager;
        /***/ },
        /* 320 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseCamera = __webpack_require__(131);
            var CenterOn = __webpack_require__(187);
            var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Effects = __webpack_require__(327);
            var Events = __webpack_require__(36);
            var Linear = __webpack_require__(133);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera.
 *
 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
 * and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis.
 *
 * A Camera also has built-in special effects including Fade, Flash and Camera Shake.
 *
 * @class Camera
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Cameras.Scene2D.BaseCamera
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Pipeline
 *
 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
 * @param {number} width - The width of the Camera, in pixels.
 * @param {number} height - The height of the Camera, in pixels.
 */ var Camera = new Class({
                Extends: BaseCamera,
                Mixins: [
                    Components.Flip,
                    Components.Tint,
                    Components.Pipeline
                ],
                initialize: function Camera(x, y, width, height) {
                    BaseCamera.call(this, x, y, width, height);
                    this.postPipelines = [];
                    this.pipelineData = {};
                    /**
         * Does this Camera allow the Game Objects it renders to receive input events?
         *
         * @name Phaser.Cameras.Scene2D.Camera#inputEnabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.inputEnabled = true;
                    /**
         * The Camera Fade effect handler.
         * To fade this camera see the `Camera.fade` methods.
         *
         * @name Phaser.Cameras.Scene2D.Camera#fadeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Fade}
         * @since 3.5.0
         */ this.fadeEffect = new Effects.Fade(this);
                    /**
         * The Camera Flash effect handler.
         * To flash this camera see the `Camera.flash` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#flashEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Flash}
         * @since 3.5.0
         */ this.flashEffect = new Effects.Flash(this);
                    /**
         * The Camera Shake effect handler.
         * To shake this camera see the `Camera.shake` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#shakeEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Shake}
         * @since 3.5.0
         */ this.shakeEffect = new Effects.Shake(this);
                    /**
         * The Camera Pan effect handler.
         * To pan this camera see the `Camera.pan` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#panEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Pan}
         * @since 3.11.0
         */ this.panEffect = new Effects.Pan(this);
                    /**
         * The Camera Rotate To effect handler.
         * To rotate this camera see the `Camera.rotateTo` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#rotateToEffect
         * @type {Phaser.Cameras.Scene2D.Effects.RotateTo}
         * @since 3.23.0
         */ this.rotateToEffect = new Effects.RotateTo(this);
                    /**
         * The Camera Zoom effect handler.
         * To zoom this camera see the `Camera.zoom` method.
         *
         * @name Phaser.Cameras.Scene2D.Camera#zoomEffect
         * @type {Phaser.Cameras.Scene2D.Effects.Zoom}
         * @since 3.11.0
         */ this.zoomEffect = new Effects.Zoom(this);
                    /**
         * The linear interpolation value to use when following a target.
         *
         * Can also be set via `setLerp` or as part of the `startFollow` call.
         *
         * The default values of 1 means the camera will instantly snap to the target coordinates.
         * A lower value, such as 0.1 means the camera will more slowly track the target, giving
         * a smooth transition. You can set the horizontal and vertical values independently, and also
         * adjust this value in real-time during your game.
         *
         * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
         *
         * @name Phaser.Cameras.Scene2D.Camera#lerp
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.lerp = new Vector2(1, 1);
                    /**
         * The values stored in this property are subtracted from the Camera targets position, allowing you to
         * offset the camera from the actual target x/y coordinates by this amount.
         * Can also be set via `setFollowOffset` or as part of the `startFollow` call.
         *
         * @name Phaser.Cameras.Scene2D.Camera#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.9.0
         */ this.followOffset = new Vector2();
                    /**
         * The Camera dead zone.
         *
         * The deadzone is only used when the camera is following a target.
         *
         * It defines a rectangular region within which if the target is present, the camera will not scroll.
         * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
         *
         * The `lerp` values that you can set for a follower target also apply when using a deadzone.
         *
         * You can directly set this property to be an instance of a Rectangle. Or, you can use the
         * `setDeadzone` method for a chainable approach.
         *
         * The rectangle you provide can have its dimensions adjusted dynamically, however, please
         * note that its position is updated every frame, as it is constantly re-centered on the cameras mid point.
         *
         * Calling `setDeadzone` with no arguments will reset an active deadzone, as will setting this property
         * to `null`.
         *
         * @name Phaser.Cameras.Scene2D.Camera#deadzone
         * @type {?Phaser.Geom.Rectangle}
         * @since 3.11.0
         */ this.deadzone = null;
                    /**
         * Internal follow target reference.
         *
         * @name Phaser.Cameras.Scene2D.Camera#_follow
         * @type {?any}
         * @private
         * @default null
         * @since 3.0.0
         */ this._follow = null;
                },
                /**
     * Sets the Camera dead zone.
     *
     * The deadzone is only used when the camera is following a target.
     *
     * It defines a rectangular region within which if the target is present, the camera will not scroll.
     * If the target moves outside of this area, the camera will begin scrolling in order to follow it.
     *
     * The deadzone rectangle is re-positioned every frame so that it is centered on the mid-point
     * of the camera. This allows you to use the object for additional game related checks, such as
     * testing if an object is within it or not via a Rectangle.contains call.
     *
     * The `lerp` values that you can set for a follower target also apply when using a deadzone.
     *
     * Calling this method with no arguments will reset an active deadzone.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setDeadzone
     * @since 3.11.0
     *
     * @param {number} [width] - The width of the deadzone rectangle in pixels. If not specified the deadzone is removed.
     * @param {number} [height] - The height of the deadzone rectangle in pixels.
     *
     * @return {this} This Camera instance.
     */ setDeadzone: function(width, height) {
                    if (width === undefined) this.deadzone = null;
                    else {
                        if (this.deadzone) {
                            this.deadzone.width = width;
                            this.deadzone.height = height;
                        } else this.deadzone = new Rectangle(0, 0, width, height);
                        if (this._follow) {
                            var originX = this.width / 2;
                            var originY = this.height / 2;
                            var fx = this._follow.x - this.followOffset.x;
                            var fy = this._follow.y - this.followOffset.y;
                            this.midPoint.set(fx, fy);
                            this.scrollX = fx - originX;
                            this.scrollY = fy - originY;
                        }
                        CenterOn(this.deadzone, this.midPoint.x, this.midPoint.y);
                    }
                    return this;
                },
                /**
     * Fades the Camera in from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeIn
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeIn: function(duration, red, green, blue, callback, context) {
                    return this.fadeEffect.start(false, duration, red, green, blue, true, callback, context);
                },
                /**
     * Fades the Camera out to the given color over the duration specified.
     * This is an alias for Camera.fade that forces the fade to start, regardless of existing fades.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeOut
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.3.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeOut: function(duration, red, green, blue, callback, context) {
                    return this.fadeEffect.start(true, duration, red, green, blue, true, callback, context);
                },
                /**
     * Fades the Camera from the given color to transparent over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fadeFrom
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fadeFrom: function(duration, red, green, blue, force, callback, context) {
                    return this.fadeEffect.start(false, duration, red, green, blue, force, callback, context);
                },
                /**
     * Fades the Camera from transparent to the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#fade
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ fade: function(duration, red, green, blue, force, callback, context) {
                    return this.fadeEffect.start(true, duration, red, green, blue, force, callback, context);
                },
                /**
     * Flashes the Camera by setting it to the given color immediately and then fading it away again quickly over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#flash
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ flash: function(duration, red, green, blue, force, callback, context) {
                    return this.flashEffect.start(duration, red, green, blue, force, callback, context);
                },
                /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#shake
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.0.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ shake: function(duration, intensity, force, callback, context) {
                    return this.shakeEffect.start(duration, intensity, force, callback, context);
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#pan
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ pan: function(x, y, duration, ease, force, callback, context) {
                    return this.panEffect.start(x, y, duration, ease, force, callback, context);
                },
                /**
     * This effect will rotate the Camera so that the viewport finishes at the given angle in radians,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#rotateTo
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the rotation. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera rotation angle in radians.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
     */ rotateTo: function(radians, shortestPath, duration, ease, force, callback, context) {
                    return this.rotateToEffect.start(radians, shortestPath, duration, ease, force, callback, context);
                },
                /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Camera#zoomTo
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {this} This Camera instance.
     */ zoomTo: function(zoom, duration, ease, force, callback, context) {
                    return this.zoomEffect.start(zoom, duration, ease, force, callback, context);
                },
                /**
     * Internal preRender step.
     *
     * @method Phaser.Cameras.Scene2D.Camera#preRender
     * @protected
     * @since 3.0.0
     */ preRender: function() {
                    this.renderList.length = 0;
                    var width = this.width;
                    var height = this.height;
                    var halfWidth = width * 0.5;
                    var halfHeight = height * 0.5;
                    var zoom = this.zoom;
                    var matrix = this.matrix;
                    var originX = width * this.originX;
                    var originY = height * this.originY;
                    var follow = this._follow;
                    var deadzone = this.deadzone;
                    var sx = this.scrollX;
                    var sy = this.scrollY;
                    if (deadzone) CenterOn(deadzone, this.midPoint.x, this.midPoint.y);
                    var emitFollowEvent = false;
                    if (follow && !this.panEffect.isRunning) {
                        var fx = follow.x - this.followOffset.x;
                        var fy = follow.y - this.followOffset.y;
                        if (deadzone) {
                            if (fx < deadzone.x) sx = Linear(sx, sx - (deadzone.x - fx), this.lerp.x);
                            else if (fx > deadzone.right) sx = Linear(sx, sx + (fx - deadzone.right), this.lerp.x);
                            if (fy < deadzone.y) sy = Linear(sy, sy - (deadzone.y - fy), this.lerp.y);
                            else if (fy > deadzone.bottom) sy = Linear(sy, sy + (fy - deadzone.bottom), this.lerp.y);
                        } else {
                            sx = Linear(sx, fx - originX, this.lerp.x);
                            sy = Linear(sy, fy - originY, this.lerp.y);
                        }
                        emitFollowEvent = true;
                    }
                    if (this.useBounds) {
                        sx = this.clampX(sx);
                        sy = this.clampY(sy);
                    }
                    if (this.roundPixels) {
                        originX = Math.round(originX);
                        originY = Math.round(originY);
                        sx = Math.round(sx);
                        sy = Math.round(sy);
                    }
                    //  Values are in pixels and not impacted by zooming the Camera
                    this.scrollX = sx;
                    this.scrollY = sy;
                    var midX = sx + halfWidth;
                    var midY = sy + halfHeight;
                    //  The center of the camera, in world space, so taking zoom into account
                    //  Basically the pixel value of what it's looking at in the middle of the cam
                    this.midPoint.set(midX, midY);
                    var displayWidth = width / zoom;
                    var displayHeight = height / zoom;
                    var vwx = midX - displayWidth / 2;
                    var vwy = midY - displayHeight / 2;
                    if (this.roundPixels) {
                        vwx = Math.round(vwx);
                        vwy = Math.round(vwy);
                    }
                    this.worldView.setTo(vwx, vwy, displayWidth, displayHeight);
                    matrix.applyITRS(this.x + originX, this.y + originY, this.rotation, zoom, zoom);
                    matrix.translate(-originX, -originY);
                    this.shakeEffect.preRender();
                    if (emitFollowEvent) this.emit(Events.FOLLOW_UPDATE, this, follow);
                },
                /**
     * Sets the linear interpolation value to use when following a target.
     *
     * The default values of 1 means the camera will instantly snap to the target coordinates.
     * A lower value, such as 0.1 means the camera will more slowly track the target, giving
     * a smooth transition. You can set the horizontal and vertical values independently, and also
     * adjust this value in real-time during your game.
     *
     * Be sure to keep the value between 0 and 1. A value of zero will disable tracking on that axis.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setLerp
     * @since 3.9.0
     *
     * @param {number} [x=1] - The amount added to the horizontal linear interpolation of the follow target.
     * @param {number} [y=1] - The amount added to the vertical linear interpolation of the follow target.
     *
     * @return {this} This Camera instance.
     */ setLerp: function(x, y) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    this.lerp.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal and vertical offset of the camera from its follow target.
     * The values are subtracted from the targets position during the Cameras update step.
     *
     * @method Phaser.Cameras.Scene2D.Camera#setFollowOffset
     * @since 3.9.0
     *
     * @param {number} [x=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [y=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ setFollowOffset: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    this.followOffset.set(x, y);
                    return this;
                },
                /**
     * Sets the Camera to follow a Game Object.
     *
     * When enabled the Camera will automatically adjust its scroll position to keep the target Game Object
     * in its center.
     *
     * You can set the linear interpolation value used in the follow code.
     * Use low lerp values (such as 0.1) to automatically smooth the camera motion.
     *
     * If you find you're getting a slight "jitter" effect when following an object it's probably to do with sub-pixel
     * rendering of the targets position. This can be rounded by setting the `roundPixels` argument to `true` to
     * force full pixel rounding rendering. Note that this can still be broken if you have specified a non-integer zoom
     * value on the camera. So be sure to keep the camera zoom to integers.
     *
     * @method Phaser.Cameras.Scene2D.Camera#startFollow
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|object)} target - The target for the Camera to follow.
     * @param {boolean} [roundPixels=false] - Round the camera position to whole integers to avoid sub-pixel rendering?
     * @param {number} [lerpX=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when horizontally tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [lerpY=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when vertically tracking the target. The closer the value to 1, the faster the camera will track.
     * @param {number} [offsetX=0] - The horizontal offset from the camera follow target.x position.
     * @param {number} [offsetY=0] - The vertical offset from the camera follow target.y position.
     *
     * @return {this} This Camera instance.
     */ startFollow: function(target, roundPixels, lerpX, lerpY, offsetX, offsetY) {
                    if (roundPixels === undefined) roundPixels = false;
                    if (lerpX === undefined) lerpX = 1;
                    if (lerpY === undefined) lerpY = lerpX;
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = offsetX;
                    this._follow = target;
                    this.roundPixels = roundPixels;
                    lerpX = Clamp(lerpX, 0, 1);
                    lerpY = Clamp(lerpY, 0, 1);
                    this.lerp.set(lerpX, lerpY);
                    this.followOffset.set(offsetX, offsetY);
                    var originX = this.width / 2;
                    var originY = this.height / 2;
                    var fx = target.x - offsetX;
                    var fy = target.y - offsetY;
                    this.midPoint.set(fx, fy);
                    this.scrollX = fx - originX;
                    this.scrollY = fy - originY;
                    if (this.useBounds) {
                        this.scrollX = this.clampX(this.scrollX);
                        this.scrollY = this.clampY(this.scrollY);
                    }
                    return this;
                },
                /**
     * Stops a Camera from following a Game Object, if previously set via `Camera.startFollow`.
     *
     * @method Phaser.Cameras.Scene2D.Camera#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ stopFollow: function() {
                    this._follow = null;
                    return this;
                },
                /**
     * Resets any active FX, such as a fade, flash or shake. Useful to call after a fade in order to
     * remove the fade.
     *
     * @method Phaser.Cameras.Scene2D.Camera#resetFX
     * @since 3.0.0
     *
     * @return {this} This Camera instance.
     */ resetFX: function() {
                    this.rotateToEffect.reset();
                    this.panEffect.reset();
                    this.shakeEffect.reset();
                    this.flashEffect.reset();
                    this.fadeEffect.reset();
                    return this;
                },
                /**
     * Internal method called automatically by the Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.Camera#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.visible) {
                        this.rotateToEffect.update(time, delta);
                        this.panEffect.update(time, delta);
                        this.zoomEffect.update(time, delta);
                        this.shakeEffect.update(time, delta);
                        this.flashEffect.update(time, delta);
                        this.fadeEffect.update(time, delta);
                    }
                },
                /**
     * Destroys this Camera instance. You rarely need to call this directly.
     *
     * Called by the Camera Manager. If you wish to destroy a Camera please use `CameraManager.remove` as
     * cameras are stored in a pool, ready for recycling later, and calling this directly will prevent that.
     *
     * @method Phaser.Cameras.Scene2D.Camera#destroy
     * @fires Phaser.Cameras.Scene2D.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    this.resetFX();
                    BaseCamera.prototype.destroy.call(this);
                    this._follow = null;
                    this.deadzone = null;
                }
            });
            module1.exports = Camera;
        /***/ },
        /* 321 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            /**
 * Converts a hex string into a Phaser Color object.
 * 
 * The hex string can supplied as `'#0033ff'` or the short-hand format of `'#03f'`; it can begin with an optional "#" or "0x", or be unprefixed.
 *
 * An alpha channel is _not_ supported.
 *
 * @function Phaser.Display.Color.HexStringToColor
 * @since 3.0.0
 *
 * @param {string} hex - The hex color value to convert, such as `#0033ff` or the short-hand format: `#03f`.
 *
 * @return {Phaser.Display.Color} A Color object populated by the values of the given string.
 */ var HexStringToColor = function(hex) {
                var color = new Color();
                // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
                hex = hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
                    return r + r + g + g + b + b;
                });
                var result = /^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                if (result) {
                    var r = parseInt(result[1], 16);
                    var g = parseInt(result[2], 16);
                    var b = parseInt(result[3], 16);
                    color.setTo(r, g, b);
                }
                return color;
            };
            module1.exports = HexStringToColor;
        /***/ },
        /* 322 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Given an alpha and 3 color values this will return an integer representation of it.
 *
 * @function Phaser.Display.Color.GetColor32
 * @since 3.0.0
 *
 * @param {number} red - The red color value. A number between 0 and 255.
 * @param {number} green - The green color value. A number between 0 and 255.
 * @param {number} blue - The blue color value. A number between 0 and 255.
 * @param {number} alpha - The alpha color value. A number between 0 and 255.
 *
 * @return {number} The combined color value.
 */ var GetColor32 = function(red, green, blue, alpha) {
                return alpha << 24 | red << 16 | green << 8 | blue;
            };
            module1.exports = GetColor32;
        /***/ },
        /* 323 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts an RGB color value to HSV (hue, saturation and value).
 * Conversion formula from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes RGB values are contained in the set [0, 255] and returns h, s and v in the set [0, 1].
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.RGBToHSV
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} [out] - An object to store the color values in. If not given an HSV Color Object will be created.
 *
 * @return {(Phaser.Types.Display.HSVColorObject|Phaser.Display.Color)} An object with the properties `h`, `s` and `v` set.
 */ var RGBToHSV = function(r, g, b, out) {
                if (out === undefined) out = {
                    h: 0,
                    s: 0,
                    v: 0
                };
                r /= 255;
                g /= 255;
                b /= 255;
                var min = Math.min(r, g, b);
                var max = Math.max(r, g, b);
                var d = max - min;
                // achromatic by default
                var h = 0;
                var s = max === 0 ? 0 : d / max;
                var v = max;
                if (max !== min) {
                    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
                    else if (max === g) h = (b - r) / d + 2;
                    else if (max === b) h = (r - g) / d + 4;
                    h /= 6;
                }
                if (out.hasOwnProperty('_h')) {
                    out._h = h;
                    out._s = s;
                    out._v = v;
                } else {
                    out.h = h;
                    out.s = s;
                    out.v = v;
                }
                return out;
            };
            module1.exports = RGBToHSV;
        /***/ },
        /* 324 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Return the component parts of a color as an Object with the properties alpha, red, green, blue.
 *
 * Alpha will only be set if it exists in the given color (0xAARRGGBB)
 *
 * @function Phaser.Display.Color.IntegerToRGB
 * @since 3.0.0
 *
 * @param {number} input - The color value to convert into a Color object.
 *
 * @return {Phaser.Types.Display.ColorObject} An object with the red, green and blue values set in the r, g and b properties.
 */ var IntegerToRGB = function(color) {
                if (color > 16777215) //  The color value has an alpha component
                return {
                    a: color >>> 24,
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF
                };
                else return {
                    a: 255,
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF
                };
            };
            module1.exports = IntegerToRGB;
        /***/ },
        /* 325 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            /**
 * Converts an object containing `r`, `g`, `b` and `a` properties into a Color class instance.
 *
 * @function Phaser.Display.Color.ObjectToColor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Display.InputColorObject} input - An object containing `r`, `g`, `b` and `a` properties in the range 0 to 255.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var ObjectToColor = function(input) {
                return new Color(input.r, input.g, input.b, input.a);
            };
            module1.exports = ObjectToColor;
        /***/ },
        /* 326 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            /**
 * Converts a CSS 'web' string into a Phaser Color object.
 * 
 * The web string can be in the format `'rgb(r,g,b)'` or `'rgba(r,g,b,a)'` where r/g/b are in the range [0..255] and a is in the range [0..1].
 *
 * @function Phaser.Display.Color.RGBStringToColor
 * @since 3.0.0
 *
 * @param {string} rgb - The CSS format color string, using the `rgb` or `rgba` format.
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RGBStringToColor = function(rgb) {
                var color = new Color();
                var result = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(rgb.toLowerCase());
                if (result) {
                    var r = parseInt(result[1], 10);
                    var g = parseInt(result[2], 10);
                    var b = parseInt(result[3], 10);
                    var a = result[4] !== undefined ? parseFloat(result[4]) : 1;
                    color.setTo(r, g, b, a * 255);
                }
                return color;
            };
            module1.exports = RGBStringToColor;
        /***/ },
        /* 327 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D.Effects
 */ module1.exports = {
                Fade: __webpack_require__(737),
                Flash: __webpack_require__(738),
                Pan: __webpack_require__(739),
                Shake: __webpack_require__(772),
                RotateTo: __webpack_require__(773),
                Zoom: __webpack_require__(774)
            };
        /***/ },
        /* 328 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Back
 */ module1.exports = {
                In: __webpack_require__(740),
                Out: __webpack_require__(741),
                InOut: __webpack_require__(742)
            };
        /***/ },
        /* 329 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Bounce
 */ module1.exports = {
                In: __webpack_require__(743),
                Out: __webpack_require__(744),
                InOut: __webpack_require__(745)
            };
        /***/ },
        /* 330 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Circular
 */ module1.exports = {
                In: __webpack_require__(746),
                Out: __webpack_require__(747),
                InOut: __webpack_require__(748)
            };
        /***/ },
        /* 331 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Cubic
 */ module1.exports = {
                In: __webpack_require__(749),
                Out: __webpack_require__(750),
                InOut: __webpack_require__(751)
            };
        /***/ },
        /* 332 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Elastic
 */ module1.exports = {
                In: __webpack_require__(752),
                Out: __webpack_require__(753),
                InOut: __webpack_require__(754)
            };
        /***/ },
        /* 333 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Expo
 */ module1.exports = {
                In: __webpack_require__(755),
                Out: __webpack_require__(756),
                InOut: __webpack_require__(757)
            };
        /***/ },
        /* 334 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ module1.exports = __webpack_require__(758);
        /***/ },
        /* 335 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quadratic
 */ module1.exports = {
                In: __webpack_require__(759),
                Out: __webpack_require__(760),
                InOut: __webpack_require__(761)
            };
        /***/ },
        /* 336 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quartic
 */ module1.exports = {
                In: __webpack_require__(762),
                Out: __webpack_require__(763),
                InOut: __webpack_require__(764)
            };
        /***/ },
        /* 337 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Quintic
 */ module1.exports = {
                In: __webpack_require__(765),
                Out: __webpack_require__(766),
                InOut: __webpack_require__(767)
            };
        /***/ },
        /* 338 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Sine
 */ module1.exports = {
                In: __webpack_require__(768),
                Out: __webpack_require__(769),
                InOut: __webpack_require__(770)
            };
        /***/ },
        /* 339 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing.Stepped
 */ module1.exports = __webpack_require__(771);
        /***/ },
        /* 340 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(32);
            var Device = __webpack_require__(341);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var IsPlainObject = __webpack_require__(7);
            var PhaserMath = __webpack_require__(190);
            var NOOP = __webpack_require__(1);
            var DefaultPlugins = __webpack_require__(194);
            var ValueToColor = __webpack_require__(184);
            /**
 * @classdesc
 * The active game configuration settings, parsed from a {@link Phaser.Types.Core.GameConfig} object.
 *
 * @class Config
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 *
 * @see Phaser.Game#config
 */ var Config = new Class({
                initialize: function Config(config) {
                    if (config === undefined) config = {};
                    var defaultBannerColor = [
                        '#ff0000',
                        '#ffff00',
                        '#00ff00',
                        '#00ffff',
                        '#000000'
                    ];
                    var defaultBannerTextColor = '#ffffff';
                    /**
         * @const {(number|string)} Phaser.Core.Config#width - The width of the underlying canvas, in pixels.
         */ this.width = GetValue(config, 'width', 1024);
                    /**
         * @const {(number|string)} Phaser.Core.Config#height - The height of the underlying canvas, in pixels.
         */ this.height = GetValue(config, 'height', 768);
                    /**
         * @const {(Phaser.Scale.ZoomType|number)} Phaser.Core.Config#zoom - The zoom factor, as used by the Scale Manager.
         */ this.zoom = GetValue(config, 'zoom', 1);
                    /**
         * @const {?*} Phaser.Core.Config#parent - A parent DOM element into which the canvas created by the renderer will be injected.
         */ this.parent = GetValue(config, 'parent', undefined);
                    /**
         * @const {Phaser.Scale.ScaleModeType} Phaser.Core.Config#scaleMode - The scale mode as used by the Scale Manager. The default is zero, which is no scaling.
         */ this.scaleMode = GetValue(config, 'scaleMode', 0);
                    /**
         * @const {boolean} Phaser.Core.Config#expandParent - Is the Scale Manager allowed to adjust the CSS height property of the parent to be 100%?
         */ this.expandParent = GetValue(config, 'expandParent', true);
                    /**
         * @const {number} Phaser.Core.Config#autoRound - Automatically round the display and style sizes of the canvas. This can help with performance in lower-powered devices.
         */ this.autoRound = GetValue(config, 'autoRound', false);
                    /**
         * @const {Phaser.Scale.CenterType} Phaser.Core.Config#autoCenter - Automatically center the canvas within the parent?
         */ this.autoCenter = GetValue(config, 'autoCenter', 0);
                    /**
         * @const {number} Phaser.Core.Config#resizeInterval - How many ms should elapse before checking if the browser size has changed?
         */ this.resizeInterval = GetValue(config, 'resizeInterval', 500);
                    /**
         * @const {?(HTMLElement|string)} Phaser.Core.Config#fullscreenTarget - The DOM element that will be sent into full screen mode, or its `id`. If undefined Phaser will create its own div and insert the canvas into it when entering fullscreen mode.
         */ this.fullscreenTarget = GetValue(config, 'fullscreenTarget', null);
                    /**
         * @const {number} Phaser.Core.Config#minWidth - The minimum width, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minWidth = GetValue(config, 'minWidth', 0);
                    /**
         * @const {number} Phaser.Core.Config#maxWidth - The maximum width, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxWidth = GetValue(config, 'maxWidth', 0);
                    /**
         * @const {number} Phaser.Core.Config#minHeight - The minimum height, in pixels, the canvas will scale down to. A value of zero means no minimum.
         */ this.minHeight = GetValue(config, 'minHeight', 0);
                    /**
         * @const {number} Phaser.Core.Config#maxHeight - The maximum height, in pixels, the canvas will scale up to. A value of zero means no maximum.
         */ this.maxHeight = GetValue(config, 'maxHeight', 0);
                    //  Scale Manager - Anything set in here over-rides anything set above
                    var scaleConfig = GetValue(config, 'scale', null);
                    if (scaleConfig) {
                        this.width = GetValue(scaleConfig, 'width', this.width);
                        this.height = GetValue(scaleConfig, 'height', this.height);
                        this.zoom = GetValue(scaleConfig, 'zoom', this.zoom);
                        this.parent = GetValue(scaleConfig, 'parent', this.parent);
                        this.scaleMode = GetValue(scaleConfig, 'mode', this.scaleMode);
                        this.expandParent = GetValue(scaleConfig, 'expandParent', this.expandParent);
                        this.autoRound = GetValue(scaleConfig, 'autoRound', this.autoRound);
                        this.autoCenter = GetValue(scaleConfig, 'autoCenter', this.autoCenter);
                        this.resizeInterval = GetValue(scaleConfig, 'resizeInterval', this.resizeInterval);
                        this.fullscreenTarget = GetValue(scaleConfig, 'fullscreenTarget', this.fullscreenTarget);
                        this.minWidth = GetValue(scaleConfig, 'min.width', this.minWidth);
                        this.maxWidth = GetValue(scaleConfig, 'max.width', this.maxWidth);
                        this.minHeight = GetValue(scaleConfig, 'min.height', this.minHeight);
                        this.maxHeight = GetValue(scaleConfig, 'max.height', this.maxHeight);
                    }
                    /**
         * @const {number} Phaser.Core.Config#renderType - Force Phaser to use a specific renderer. Can be `CONST.CANVAS`, `CONST.WEBGL`, `CONST.HEADLESS` or `CONST.AUTO` (default)
         */ this.renderType = GetValue(config, 'type', CONST.AUTO);
                    /**
         * @const {?HTMLCanvasElement} Phaser.Core.Config#canvas - Force Phaser to use your own Canvas element instead of creating one.
         */ this.canvas = GetValue(config, 'canvas', null);
                    /**
         * @const {?(CanvasRenderingContext2D|WebGLRenderingContext)} Phaser.Core.Config#context - Force Phaser to use your own Canvas context instead of creating one.
         */ this.context = GetValue(config, 'context', null);
                    /**
         * @const {?string} Phaser.Core.Config#canvasStyle - Optional CSS attributes to be set on the canvas object created by the renderer.
         */ this.canvasStyle = GetValue(config, 'canvasStyle', null);
                    /**
         * @const {boolean} Phaser.Core.Config#customEnvironment - Is Phaser running under a custom (non-native web) environment? If so, set this to `true` to skip internal Feature detection. If `true` the `renderType` cannot be left as `AUTO`.
         */ this.customEnvironment = GetValue(config, 'customEnvironment', false);
                    /**
         * @const {?object} Phaser.Core.Config#sceneConfig - The default Scene configuration object.
         */ this.sceneConfig = GetValue(config, 'scene', null);
                    /**
         * @const {string[]} Phaser.Core.Config#seed - A seed which the Random Data Generator will use. If not given, a dynamic seed based on the time is used.
         */ this.seed = GetValue(config, 'seed', [
                        (Date.now() * Math.random()).toString()
                    ]);
                    PhaserMath.RND = new PhaserMath.RandomDataGenerator(this.seed);
                    /**
         * @const {string} Phaser.Core.Config#gameTitle - The title of the game.
         */ this.gameTitle = GetValue(config, 'title', '');
                    /**
         * @const {string} Phaser.Core.Config#gameURL - The URL of the game.
         */ this.gameURL = GetValue(config, 'url', 'https://phaser.io');
                    /**
         * @const {string} Phaser.Core.Config#gameVersion - The version of the game.
         */ this.gameVersion = GetValue(config, 'version', '');
                    /**
         * @const {boolean} Phaser.Core.Config#autoFocus - If `true` the window will automatically be given focus immediately and on any future mousedown event.
         */ this.autoFocus = GetValue(config, 'autoFocus', true);
                    //  DOM Element Container
                    /**
         * @const {?boolean} Phaser.Core.Config#domCreateContainer - Should the game create a div element to act as a DOM Container? Only enable if you're using DOM Element objects. You must provide a parent object if you use this feature.
         */ this.domCreateContainer = GetValue(config, 'dom.createContainer', false);
                    /**
         * @const {?boolean} Phaser.Core.Config#domBehindCanvas - Should the DOM Container that is created (if `dom.createContainer` is true) be positioned behind (true) or over the top (false, the default) of the game canvas?
         */ this.domBehindCanvas = GetValue(config, 'dom.behindCanvas', false);
                    //  Input
                    /**
         * @const {boolean} Phaser.Core.Config#inputKeyboard - Enable the Keyboard Plugin. This can be disabled in games that don't need keyboard input.
         */ this.inputKeyboard = GetValue(config, 'input.keyboard', true);
                    /**
         * @const {*} Phaser.Core.Config#inputKeyboardEventTarget - The DOM Target to listen for keyboard events on. Defaults to `window` if not specified.
         */ this.inputKeyboardEventTarget = GetValue(config, 'input.keyboard.target', window);
                    /**
         * @const {?number[]} Phaser.Core.Config#inputKeyboardCapture - `preventDefault` will be called on every non-modified key which has a key code in this array. By default, it is empty.
         */ this.inputKeyboardCapture = GetValue(config, 'input.keyboard.capture', []);
                    /**
         * @const {(boolean|object)} Phaser.Core.Config#inputMouse - Enable the Mouse Plugin. This can be disabled in games that don't need mouse input.
         */ this.inputMouse = GetValue(config, 'input.mouse', true);
                    /**
         * @const {?*} Phaser.Core.Config#inputMouseEventTarget - The DOM Target to listen for mouse events on. Defaults to the game canvas if not specified.
         */ this.inputMouseEventTarget = GetValue(config, 'input.mouse.target', null);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultDown - Should `mousedown` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultDown = GetValue(config, 'input.mouse.preventDefaultDown', true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultUp - Should `mouseup` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultUp = GetValue(config, 'input.mouse.preventDefaultUp', true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultMove - Should `mousemove` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultMove = GetValue(config, 'input.mouse.preventDefaultMove', true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputMousePreventDefaultWheel - Should `wheel` DOM events have `preventDefault` called on them?
         */ this.inputMousePreventDefaultWheel = GetValue(config, 'input.mouse.preventDefaultWheel', true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputTouch - Enable the Touch Plugin. This can be disabled in games that don't need touch input.
         */ this.inputTouch = GetValue(config, 'input.touch', Device.input.touch);
                    /**
         * @const {?*} Phaser.Core.Config#inputTouchEventTarget - The DOM Target to listen for touch events on. Defaults to the game canvas if not specified.
         */ this.inputTouchEventTarget = GetValue(config, 'input.touch.target', null);
                    /**
         * @const {boolean} Phaser.Core.Config#inputTouchCapture - Should touch events be captured? I.e. have prevent default called on them.
         */ this.inputTouchCapture = GetValue(config, 'input.touch.capture', true);
                    /**
         * @const {number} Phaser.Core.Config#inputActivePointers - The number of Pointer objects created by default. In a mouse-only, or non-multi touch game, you can leave this as 1.
         */ this.inputActivePointers = GetValue(config, 'input.activePointers', 1);
                    /**
         * @const {number} Phaser.Core.Config#inputSmoothFactor - The smoothing factor to apply during Pointer movement. See {@link Phaser.Input.Pointer#smoothFactor}.
         */ this.inputSmoothFactor = GetValue(config, 'input.smoothFactor', 0);
                    /**
         * @const {boolean} Phaser.Core.Config#inputWindowEvents - Should Phaser listen for input events on the Window? If you disable this, events like 'POINTER_UP_OUTSIDE' will no longer fire.
         */ this.inputWindowEvents = GetValue(config, 'input.windowEvents', true);
                    /**
         * @const {boolean} Phaser.Core.Config#inputGamepad - Enable the Gamepad Plugin. This can be disabled in games that don't need gamepad input.
         */ this.inputGamepad = GetValue(config, 'input.gamepad', false);
                    /**
         * @const {*} Phaser.Core.Config#inputGamepadEventTarget - The DOM Target to listen for gamepad events on. Defaults to `window` if not specified.
         */ this.inputGamepadEventTarget = GetValue(config, 'input.gamepad.target', window);
                    /**
         * @const {boolean} Phaser.Core.Config#disableContextMenu - Set to `true` to disable the right-click context menu.
         */ this.disableContextMenu = GetValue(config, 'disableContextMenu', false);
                    /**
         * @const {Phaser.Types.Core.AudioConfig} Phaser.Core.Config#audio - The Audio Configuration object.
         */ this.audio = GetValue(config, 'audio', {});
                    //  If you do: { banner: false } it won't display any banner at all
                    /**
         * @const {boolean} Phaser.Core.Config#hideBanner - Don't write the banner line to the console.log.
         */ this.hideBanner = GetValue(config, 'banner', null) === false;
                    /**
         * @const {boolean} Phaser.Core.Config#hidePhaser - Omit Phaser's name and version from the banner.
         */ this.hidePhaser = GetValue(config, 'banner.hidePhaser', false);
                    /**
         * @const {string} Phaser.Core.Config#bannerTextColor - The color of the banner text.
         */ this.bannerTextColor = GetValue(config, 'banner.text', defaultBannerTextColor);
                    /**
         * @const {string[]} Phaser.Core.Config#bannerBackgroundColor - The background colors of the banner.
         */ this.bannerBackgroundColor = GetValue(config, 'banner.background', defaultBannerColor);
                    if (this.gameTitle === '' && this.hidePhaser) this.hideBanner = true;
                    /**
         * @const {Phaser.Types.Core.FPSConfig} Phaser.Core.Config#fps - The Frame Rate Configuration object, as parsed by the Timestep class.
         */ this.fps = GetValue(config, 'fps', null);
                    //  Renderer Settings
                    //  These can either be in a `render` object within the Config, or specified on their own
                    var renderConfig = GetValue(config, 'render', config);
                    /**
         * @const {Phaser.Types.Core.PipelineConfig} Phaser.Core.Config#pipeline - An object mapping WebGL names to WebGLPipeline classes. These should be class constructors, not instances.
         */ this.pipeline = GetValue(renderConfig, 'pipeline', null);
                    /**
         * @const {boolean} Phaser.Core.Config#antialias - When set to `true`, WebGL uses linear interpolation to draw scaled or rotated textures, giving a smooth appearance. When set to `false`, WebGL uses nearest-neighbor interpolation, giving a crisper appearance. `false` also disables antialiasing of the game canvas itself, if the browser supports it, when the game canvas is scaled.
         */ this.antialias = GetValue(renderConfig, 'antialias', true);
                    /**
         * @const {boolean} Phaser.Core.Config#antialiasGL - Sets the `antialias` property when the WebGL context is created. Setting this value does not impact any subsequent textures that are created, or the canvas style attributes.
         */ this.antialiasGL = GetValue(renderConfig, 'antialiasGL', true);
                    /**
         * @const {string} Phaser.Core.Config#mipmapFilter - Sets the `mipmapFilter` property when the WebGL renderer is created.
         */ this.mipmapFilter = GetValue(renderConfig, 'mipmapFilter', 'LINEAR');
                    /**
         * @const {boolean} Phaser.Core.Config#desynchronized - When set to `true` it will create a desynchronized context for both 2D and WebGL. See https://developers.google.com/web/updates/2019/05/desynchronized for details.
         */ this.desynchronized = GetValue(renderConfig, 'desynchronized', false);
                    /**
         * @const {boolean} Phaser.Core.Config#roundPixels - Draw texture-based Game Objects at only whole-integer positions. Game Objects without textures, like Graphics, ignore this property.
         */ this.roundPixels = GetValue(renderConfig, 'roundPixels', false);
                    /**
         * @const {boolean} Phaser.Core.Config#pixelArt - Prevent pixel art from becoming blurred when scaled. It will remain crisp (tells the WebGL renderer to automatically create textures using a linear filter mode).
         */ this.pixelArt = GetValue(renderConfig, 'pixelArt', this.zoom !== 1);
                    if (this.pixelArt) {
                        this.antialias = false;
                        this.antialiasGL = false;
                        this.roundPixels = true;
                    }
                    /**
         * @const {boolean} Phaser.Core.Config#transparent - Whether the game canvas will have a transparent background.
         */ this.transparent = GetValue(renderConfig, 'transparent', false);
                    /**
         * @const {boolean} Phaser.Core.Config#clearBeforeRender - Whether the game canvas will be cleared between each rendering frame. You can disable this if you have a full-screen background image or game object.
         */ this.clearBeforeRender = GetValue(renderConfig, 'clearBeforeRender', true);
                    /**
         * @const {boolean} Phaser.Core.Config#premultipliedAlpha - In WebGL mode, sets the drawing buffer to contain colors with pre-multiplied alpha.
         */ this.premultipliedAlpha = GetValue(renderConfig, 'premultipliedAlpha', true);
                    /**
         * @const {boolean} Phaser.Core.Config#failIfMajorPerformanceCaveat - Let the browser abort creating a WebGL context if it judges performance would be unacceptable.
         */ this.failIfMajorPerformanceCaveat = GetValue(renderConfig, 'failIfMajorPerformanceCaveat', false);
                    /**
         * @const {string} Phaser.Core.Config#powerPreference - "high-performance", "low-power" or "default". A hint to the browser on how much device power the game might use.
         */ this.powerPreference = GetValue(renderConfig, 'powerPreference', 'default');
                    /**
         * @const {number} Phaser.Core.Config#batchSize - The default WebGL Batch size. Represents the number of _quads_ that can be added to a single batch.
         */ this.batchSize = GetValue(renderConfig, 'batchSize', 4096);
                    /**
         * @const {number} Phaser.Core.Config#maxTextures - When in WebGL mode, this sets the maximum number of GPU Textures to use. The default, -1, will use all available units. The WebGL1 spec says all browsers should provide a minimum of 8.
         */ this.maxTextures = GetValue(renderConfig, 'maxTextures', -1);
                    /**
         * @const {number} Phaser.Core.Config#maxLights - The maximum number of lights allowed to be visible within range of a single Camera in the LightManager.
         */ this.maxLights = GetValue(renderConfig, 'maxLights', 10);
                    var bgc = GetValue(config, 'backgroundColor', 0);
                    /**
         * @const {Phaser.Display.Color} Phaser.Core.Config#backgroundColor - The background color of the game canvas. The default is black. This value is ignored if `transparent` is set to `true`.
         */ this.backgroundColor = ValueToColor(bgc);
                    if (this.transparent) {
                        this.backgroundColor = ValueToColor(0x000000);
                        this.backgroundColor.alpha = 0;
                    }
                    /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#preBoot - Called before Phaser boots. Useful for initializing anything not related to Phaser that Phaser may require while booting.
         */ this.preBoot = GetValue(config, 'callbacks.preBoot', NOOP);
                    /**
         * @const {Phaser.Types.Core.BootCallback} Phaser.Core.Config#postBoot - A function to run at the end of the boot sequence. At this point, all the game systems have started and plugins have been loaded.
         */ this.postBoot = GetValue(config, 'callbacks.postBoot', NOOP);
                    /**
         * @const {Phaser.Types.Core.PhysicsConfig} Phaser.Core.Config#physics - The Physics Configuration object.
         */ this.physics = GetValue(config, 'physics', {});
                    /**
         * @const {(boolean|string)} Phaser.Core.Config#defaultPhysicsSystem - The default physics system. It will be started for each scene. Either 'arcade', 'impact' or 'matter'.
         */ this.defaultPhysicsSystem = GetValue(this.physics, 'default', false);
                    /**
         * @const {string} Phaser.Core.Config#loaderBaseURL - A URL used to resolve paths given to the loader. Example: 'http://labs.phaser.io/assets/'.
         */ this.loaderBaseURL = GetValue(config, 'loader.baseURL', '');
                    /**
         * @const {string} Phaser.Core.Config#loaderPath - A URL path used to resolve relative paths given to the loader. Example: 'images/sprites/'.
         */ this.loaderPath = GetValue(config, 'loader.path', '');
                    /**
         * @const {number} Phaser.Core.Config#loaderMaxParallelDownloads - Maximum parallel downloads allowed for resources (Default to 32).
         */ var defaultParallel = Device.os.android ? 6 : 32;
                    this.loaderMaxParallelDownloads = GetValue(config, 'loader.maxParallelDownloads', defaultParallel);
                    /**
         * @const {(string|undefined)} Phaser.Core.Config#loaderCrossOrigin - 'anonymous', 'use-credentials', or `undefined`. If you're not making cross-origin requests, leave this as `undefined`. See {@link https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes}.
         */ this.loaderCrossOrigin = GetValue(config, 'loader.crossOrigin', undefined);
                    /**
         * @const {string} Phaser.Core.Config#loaderResponseType - The response type of the XHR request, e.g. `blob`, `text`, etc.
         */ this.loaderResponseType = GetValue(config, 'loader.responseType', '');
                    /**
         * @const {boolean} Phaser.Core.Config#loaderAsync - Should the XHR request use async or not?
         */ this.loaderAsync = GetValue(config, 'loader.async', true);
                    /**
         * @const {string} Phaser.Core.Config#loaderUser - Optional username for all XHR requests.
         */ this.loaderUser = GetValue(config, 'loader.user', '');
                    /**
         * @const {string} Phaser.Core.Config#loaderPassword - Optional password for all XHR requests.
         */ this.loaderPassword = GetValue(config, 'loader.password', '');
                    /**
         * @const {number} Phaser.Core.Config#loaderTimeout - Optional XHR timeout value, in ms.
         */ this.loaderTimeout = GetValue(config, 'loader.timeout', 0);
                    /**
         * @const {boolean} Phaser.Core.Config#loaderWithCredentials - Optional XHR withCredentials value.
         */ this.loaderWithCredentials = GetValue(config, 'loader.withCredentials', false);
                    /*
         * Allows `plugins` property to either be an array, in which case it just replaces
         * the default plugins like previously, or a config object.
         *
         * plugins: {
         *    global: [
         *        { key: 'TestPlugin', plugin: TestPlugin, start: true, data: { msg: 'The plugin is alive' } },
         *    ],
         *    scene: [
         *        { key: 'WireFramePlugin', plugin: WireFramePlugin, systemKey: 'wireFramePlugin', sceneKey: 'wireframe' }
         *    ],
         *    default: [], OR
         *    defaultMerge: [
         *        'ModPlayer'
         *    ]
         * }
         */ /**
         * @const {any} Phaser.Core.Config#installGlobalPlugins - An array of global plugins to be installed.
         */ this.installGlobalPlugins = [];
                    /**
         * @const {any} Phaser.Core.Config#installScenePlugins - An array of Scene level plugins to be installed.
         */ this.installScenePlugins = [];
                    var plugins = GetValue(config, 'plugins', null);
                    var defaultPlugins = DefaultPlugins.DefaultScene;
                    if (plugins) {
                        //  Old 3.7 array format?
                        if (Array.isArray(plugins)) this.defaultPlugins = plugins;
                        else if (IsPlainObject(plugins)) {
                            this.installGlobalPlugins = GetFastValue(plugins, 'global', []);
                            this.installScenePlugins = GetFastValue(plugins, 'scene', []);
                            if (Array.isArray(plugins.default)) defaultPlugins = plugins.default;
                            else if (Array.isArray(plugins.defaultMerge)) defaultPlugins = defaultPlugins.concat(plugins.defaultMerge);
                        }
                    }
                    /**
         * @const {any} Phaser.Core.Config#defaultPlugins - The plugins installed into every Scene (in addition to CoreScene and Global).
         */ this.defaultPlugins = defaultPlugins;
                    //  Default / Missing Images
                    var pngPrefix = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAg';
                    /**
         * @const {string} Phaser.Core.Config#defaultImage - A base64 encoded PNG that will be used as the default blank texture.
         */ this.defaultImage = GetValue(config, 'images.default', pngPrefix + 'AQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==');
                    /**
         * @const {string} Phaser.Core.Config#missingImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is missing or not loaded.
         */ this.missingImage = GetValue(config, 'images.missing', pngPrefix + 'CAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==');
                    /**
         * @const {string} Phaser.Core.Config#whiteImage - A base64 encoded PNG that will be used as the default texture when a texture is assigned that is white or not loaded.
         */ this.whiteImage = GetValue(config, 'images.white', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAIAAAAmkwkpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABdJREFUeNpi/P//PwMMMDEgAdwcgAADAJZuAwXJYZOzAAAAAElFTkSuQmCC');
                    if (window) {
                        if (window.FORCE_WEBGL) this.renderType = CONST.WEBGL;
                        else if (window.FORCE_CANVAS) this.renderType = CONST.CANVAS;
                    }
                }
            });
            module1.exports = Config;
        /***/ },
        /* 341 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  This singleton is instantiated as soon as Phaser loads,
            //  before a Phaser.Game instance has even been created.
            //  Which means all instances of Phaser Games can share it,
            //  without having to re-poll the device all over again
            /**
 * @namespace Phaser.Device
 * @since 3.0.0
 */ /**
 * @typedef {object} Phaser.DeviceConf
 *
 * @property {Phaser.Device.OS} os - The OS Device functions.
 * @property {Phaser.Device.Browser} browser - The Browser Device functions.
 * @property {Phaser.Device.Features} features - The Features Device functions.
 * @property {Phaser.Device.Input} input - The Input Device functions.
 * @property {Phaser.Device.Audio} audio - The Audio Device functions.
 * @property {Phaser.Device.Video} video - The Video Device functions.
 * @property {Phaser.Device.Fullscreen} fullscreen - The Fullscreen Device functions.
 * @property {Phaser.Device.CanvasFeatures} canvasFeatures - The Canvas Device functions.
 */ module1.exports = {
                os: __webpack_require__(102),
                browser: __webpack_require__(134),
                features: __webpack_require__(188),
                input: __webpack_require__(805),
                audio: __webpack_require__(806),
                video: __webpack_require__(807),
                fullscreen: __webpack_require__(808),
                canvasFeatures: __webpack_require__(342)
            };
        /***/ },
        /* 342 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            /**
 * Determines the canvas features of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.canvasFeatures` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.CanvasFeatures
 * @since 3.0.0
 * 
 * @property {boolean} supportInverseAlpha - Set to true if the browser supports inversed alpha.
 * @property {boolean} supportNewBlendModes - Set to true if the browser supports new canvas blend modes.
 */ var CanvasFeatures = {
                supportInverseAlpha: false,
                supportNewBlendModes: false
            };
            function checkBlendMode() {
                var pngHead = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/';
                var pngEnd = 'AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
                var magenta = new Image();
                magenta.onload = function() {
                    var yellow = new Image();
                    yellow.onload = function() {
                        var canvas = CanvasPool.create(yellow, 6, 1);
                        var context = canvas.getContext('2d');
                        context.globalCompositeOperation = 'multiply';
                        context.drawImage(magenta, 0, 0);
                        context.drawImage(yellow, 2, 0);
                        if (!context.getImageData(2, 0, 1, 1)) return false;
                        var data = context.getImageData(2, 0, 1, 1).data;
                        CanvasPool.remove(yellow);
                        CanvasFeatures.supportNewBlendModes = data[0] === 255 && data[1] === 0 && data[2] === 0;
                    };
                    yellow.src = pngHead + '/wCKxvRF' + pngEnd;
                };
                magenta.src = pngHead + 'AP804Oa6' + pngEnd;
                return false;
            }
            function checkInverseAlpha() {
                var canvas = CanvasPool.create(this, 2, 1);
                var context = canvas.getContext('2d');
                context.fillStyle = 'rgba(10, 20, 30, 0.5)';
                //  Draw a single pixel
                context.fillRect(0, 0, 1, 1);
                //  Get the color values
                var s1 = context.getImageData(0, 0, 1, 1);
                if (s1 === null) return false;
                //  Plot them to x2
                context.putImageData(s1, 1, 0);
                //  Get those values
                var s2 = context.getImageData(1, 0, 1, 1);
                //  Compare and return
                return s2.data[0] === s1.data[0] && s2.data[1] === s1.data[1] && s2.data[2] === s1.data[2] && s2.data[3] === s1.data[3];
            }
            function init() {
                if (document !== undefined) {
                    CanvasFeatures.supportNewBlendModes = checkBlendMode();
                    CanvasFeatures.supportInverseAlpha = checkInverseAlpha();
                }
                return CanvasFeatures;
            }
            module1.exports = init();
        /***/ },
        /* 343 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * @function Phaser.Math.Angle.Between
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var Between = function(x1, y1, x2, y2) {
                return Math.atan2(y2 - y1, x2 - x1);
            };
            module1.exports = Between;
        /***/ },
        /* 344 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * Calculates the angle of the vector from the first point to the second point.
 *
 * @function Phaser.Math.Angle.BetweenPoints
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPoints = function(point1, point2) {
                return Math.atan2(point2.y - point1.y, point2.x - point1.x);
            };
            module1.exports = BetweenPoints;
        /***/ },
        /* 345 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Normalize an angle to the [0, 2pi] range.
 *
 * @function Phaser.Math.Angle.Normalize
 * @since 3.0.0
 *
 * @param {number} angle - The angle to normalize, in radians.
 *
 * @return {number} The normalized angle, in radians.
 */ var Normalize = function(angle) {
                angle = angle % (2 * Math.PI);
                if (angle >= 0) return angle;
                else return angle + 2 * Math.PI;
            };
            module1.exports = Normalize;
        /***/ },
        /* 346 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPoints
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The distance between the points.
 */ var DistanceBetweenPoints = function(a, b) {
                var dx = a.x - b.x;
                var dy = a.y - b.y;
                return Math.sqrt(dx * dx + dy * dy);
            };
            module1.exports = DistanceBetweenPoints;
        /***/ },
        /* 347 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points), squared.
 *
 * @function Phaser.Math.Distance.Squared
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point, squared.
 */ var DistanceSquared = function(x1, y1, x2, y2) {
                var dx = x1 - x2;
                var dy = y1 - y2;
                return dx * dx + dy * dy;
            };
            module1.exports = DistanceSquared;
        /***/ },
        /* 348 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily greater than `b`.
 *
 * `a` is fuzzily greater than `b` if it is more than `b - epsilon`.
 *
 * @function Phaser.Math.Fuzzy.GreaterThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily greater than than `b`, otherwise `false`.
 */ var GreaterThan = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return a > b - epsilon;
            };
            module1.exports = GreaterThan;
        /***/ },
        /* 349 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check whether `a` is fuzzily less than `b`.
 *
 * `a` is fuzzily less than `b` if it is less than `b + epsilon`.
 *
 * @function Phaser.Math.Fuzzy.LessThan
 * @since 3.0.0
 *
 * @param {number} a - The first value.
 * @param {number} b - The second value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {boolean} `true` if `a` is fuzzily less than `b`, otherwise `false`.
 */ var LessThan = function(a, b, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return a < b + epsilon;
            };
            module1.exports = LessThan;
        /***/ },
        /* 350 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Factorial = __webpack_require__(351);
            /**
 * Calculates the Bernstein basis from the three factorial coefficients.
 *
 * @function Phaser.Math.Bernstein
 * @since 3.0.0
 *
 * @param {number} n - The first value.
 * @param {number} i - The second value.
 *
 * @return {number} The Bernstein basis of Factorial(n) / Factorial(i) / Factorial(n - i)
 */ var Bernstein = function(n, i) {
                return Factorial(n) / Factorial(i) / Factorial(n - i);
            };
            module1.exports = Bernstein;
        /***/ },
        /* 351 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the factorial of a given number for integer values greater than 0.
 *
 * @function Phaser.Math.Factorial
 * @since 3.0.0
 *
 * @param {number} value - A positive integer to calculate the factorial of.
 *
 * @return {number} The factorial of the given number.
 */ var Factorial = function(value) {
                if (value === 0) return 1;
                var res = value;
                while(--value)res *= value;
                return res;
            };
            module1.exports = Factorial;
        /***/ },
        /* 352 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                var k = 1 - t;
                return k * k * k * p;
            }
            /**
 * @ignore
 */ function P1(t, p) {
                var k = 1 - t;
                return 3 * k * k * t * p;
            }
            /**
 * @ignore
 */ function P2(t, p) {
                return 3 * (1 - t) * t * t * p;
            }
            /**
 * @ignore
 */ function P3(t, p) {
                return t * t * t * p;
            }
            /**
 * A cubic bezier interpolation method.
 *
 * https://medium.com/@adrian_cooney/bezier-interpolation-13b68563313a
 *
 * @function Phaser.Math.Interpolation.CubicBezier
 * @since 3.0.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The first control point.
 * @param {number} p2 - The second control point.
 * @param {number} p3 - The end point.
 *
 * @return {number} The interpolated value.
 */ var CubicBezierInterpolation = function(t, p0, p1, p2, p3) {
                return P0(t, p0) + P1(t, p1) + P2(t, p2) + P3(t, p3);
            };
            module1.exports = CubicBezierInterpolation;
        /***/ },
        /* 353 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function P0(t, p) {
                var k = 1 - t;
                return k * k * p;
            }
            /**
 * @ignore
 */ function P1(t, p) {
                return 2 * (1 - t) * t * p;
            }
            /**
 * @ignore
 */ function P2(t, p) {
                return t * t * p;
            }
            // https://github.com/mrdoob/three.js/blob/master/src/extras/core/Interpolations.js
            /**
 * A quadratic bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.QuadraticBezier
 * @since 3.2.0
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} p0 - The start point.
 * @param {number} p1 - The control point.
 * @param {number} p2 - The end point.
 *
 * @return {number} The interpolated value.
 */ var QuadraticBezierInterpolation = function(t, p0, p1, p2) {
                return P0(t, p0) + P1(t, p1) + P2(t, p2);
            };
            module1.exports = QuadraticBezierInterpolation;
        /***/ },
        /* 354 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmoothStep = __webpack_require__(181);
            /**
 * A Smooth Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmoothStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmoothStepInterpolation = function(t, min, max) {
                return min + (max - min) * SmoothStep(t, 0, 1);
            };
            module1.exports = SmoothStepInterpolation;
        /***/ },
        /* 355 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the nearest power of 2 to the given `value`.
 *
 * @function Phaser.Math.Pow2.GetNext
 * @since 3.0.0
 *
 * @param {number} value - The value.
 *
 * @return {number} The nearest power of 2 to `value`.
 */ var GetPowerOfTwo = function(value) {
                var index = Math.log(value) / 0.6931471805599453;
                return 1 << Math.ceil(index);
            };
            module1.exports = GetPowerOfTwo;
        /***/ },
        /* 356 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotate a given point by a given angle around the origin (0, 0), in an anti-clockwise direction.
 *
 * @function Phaser.Math.Rotate
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
 * @param {number} angle - The angle to be rotated by in an anticlockwise direction.
 *
 * @return {Phaser.Geom.Point} The given point, rotated by the given angle in an anticlockwise direction.
 */ var Rotate = function(point, angle) {
                var x = point.x;
                var y = point.y;
                point.x = x * Math.cos(angle) - y * Math.sin(angle);
                point.y = x * Math.sin(angle) + y * Math.cos(angle);
                return point;
            };
            module1.exports = Rotate;
        /***/ },
        /* 357 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a given number so it is further away from zero. That is, positive numbers are rounded up, and negative numbers are rounded down.
 *
 * @function Phaser.Math.RoundAwayFromZero
 * @since 3.0.0
 *
 * @param {number} value - The number to round.
 *
 * @return {number} The rounded number, rounded away from zero.
 */ var RoundAwayFromZero = function(value) {
                // "Opposite" of truncate.
                return value > 0 ? Math.ceil(value) : Math.floor(value);
            };
            module1.exports = RoundAwayFromZero;
        /***/ },
        /* 358 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A three-dimensional matrix.
 *
 * Defaults to the identity matrix when instantiated.
 *
 * @class Matrix3
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Math.Matrix3} [m] - Optional Matrix3 to copy values from.
 */ var Matrix3 = new Class({
                initialize: function Matrix3(m) {
                    /**
         * The matrix values.
         *
         * @name Phaser.Math.Matrix3#val
         * @type {Float32Array}
         * @since 3.0.0
         */ this.val = new Float32Array(9);
                    if (m) //  Assume Matrix3 with val:
                    this.copy(m);
                    else //  Default to identity
                    this.identity();
                },
                /**
     * Make a clone of this Matrix3.
     *
     * @method Phaser.Math.Matrix3#clone
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} A clone of this Matrix3.
     */ clone: function() {
                    return new Matrix3(this);
                },
                /**
     * This method is an alias for `Matrix3.copy`.
     *
     * @method Phaser.Math.Matrix3#set
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to set the values of this Matrix's from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ set: function(src) {
                    return this.copy(src);
                },
                /**
     * Copy the values of a given Matrix into this Matrix.
     *
     * @method Phaser.Math.Matrix3#copy
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ copy: function(src) {
                    var out = this.val;
                    var a = src.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[3];
                    out[4] = a[4];
                    out[5] = a[5];
                    out[6] = a[6];
                    out[7] = a[7];
                    out[8] = a[8];
                    return this;
                },
                /**
     * Copy the values of a given Matrix4 into this Matrix3.
     *
     * @method Phaser.Math.Matrix3#fromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromMat4: function(m) {
                    var a = m.val;
                    var out = this.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[4];
                    out[4] = a[5];
                    out[5] = a[6];
                    out[6] = a[8];
                    out[7] = a[9];
                    out[8] = a[10];
                    return this;
                },
                /**
     * Set the values of this Matrix from the given array.
     *
     * @method Phaser.Math.Matrix3#fromArray
     * @since 3.0.0
     *
     * @param {array} a - The array to copy the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromArray: function(a) {
                    var out = this.val;
                    out[0] = a[0];
                    out[1] = a[1];
                    out[2] = a[2];
                    out[3] = a[3];
                    out[4] = a[4];
                    out[5] = a[5];
                    out[6] = a[6];
                    out[7] = a[7];
                    out[8] = a[8];
                    return this;
                },
                /**
     * Reset this Matrix to an identity (default) matrix.
     *
     * @method Phaser.Math.Matrix3#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ identity: function() {
                    var out = this.val;
                    out[0] = 1;
                    out[1] = 0;
                    out[2] = 0;
                    out[3] = 0;
                    out[4] = 1;
                    out[5] = 0;
                    out[6] = 0;
                    out[7] = 0;
                    out[8] = 1;
                    return this;
                },
                /**
     * Transpose this Matrix.
     *
     * @method Phaser.Math.Matrix3#transpose
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ transpose: function() {
                    var a = this.val;
                    var a01 = a[1];
                    var a02 = a[2];
                    var a12 = a[5];
                    a[1] = a[3];
                    a[2] = a[6];
                    a[3] = a01;
                    a[5] = a[7];
                    a[6] = a02;
                    a[7] = a12;
                    return this;
                },
                /**
     * Invert this Matrix.
     *
     * @method Phaser.Math.Matrix3#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ invert: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    var b01 = a22 * a11 - a12 * a21;
                    var b11 = -a22 * a10 + a12 * a20;
                    var b21 = a21 * a10 - a11 * a20;
                    // Calculate the determinant
                    var det = a00 * b01 + a01 * b11 + a02 * b21;
                    if (!det) return null;
                    det = 1 / det;
                    a[0] = b01 * det;
                    a[1] = (-a22 * a01 + a02 * a21) * det;
                    a[2] = (a12 * a01 - a02 * a11) * det;
                    a[3] = b11 * det;
                    a[4] = (a22 * a00 - a02 * a20) * det;
                    a[5] = (-a12 * a00 + a02 * a10) * det;
                    a[6] = b21 * det;
                    a[7] = (-a21 * a00 + a01 * a20) * det;
                    a[8] = (a11 * a00 - a01 * a10) * det;
                    return this;
                },
                /**
     * Calculate the adjoint, or adjugate, of this Matrix.
     *
     * @method Phaser.Math.Matrix3#adjoint
     * @since 3.0.0
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ adjoint: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    a[0] = a11 * a22 - a12 * a21;
                    a[1] = a02 * a21 - a01 * a22;
                    a[2] = a01 * a12 - a02 * a11;
                    a[3] = a12 * a20 - a10 * a22;
                    a[4] = a00 * a22 - a02 * a20;
                    a[5] = a02 * a10 - a00 * a12;
                    a[6] = a10 * a21 - a11 * a20;
                    a[7] = a01 * a20 - a00 * a21;
                    a[8] = a00 * a11 - a01 * a10;
                    return this;
                },
                /**
     * Calculate the determinant of this Matrix.
     *
     * @method Phaser.Math.Matrix3#determinant
     * @since 3.0.0
     *
     * @return {number} The determinant of this Matrix.
     */ determinant: function() {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
                },
                /**
     * Multiply this Matrix by the given Matrix.
     *
     * @method Phaser.Math.Matrix3#multiply
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} src - The Matrix to multiply this Matrix by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ multiply: function(src) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var a20 = a[6];
                    var a21 = a[7];
                    var a22 = a[8];
                    var b = src.val;
                    var b00 = b[0];
                    var b01 = b[1];
                    var b02 = b[2];
                    var b10 = b[3];
                    var b11 = b[4];
                    var b12 = b[5];
                    var b20 = b[6];
                    var b21 = b[7];
                    var b22 = b[8];
                    a[0] = b00 * a00 + b01 * a10 + b02 * a20;
                    a[1] = b00 * a01 + b01 * a11 + b02 * a21;
                    a[2] = b00 * a02 + b01 * a12 + b02 * a22;
                    a[3] = b10 * a00 + b11 * a10 + b12 * a20;
                    a[4] = b10 * a01 + b11 * a11 + b12 * a21;
                    a[5] = b10 * a02 + b11 * a12 + b12 * a22;
                    a[6] = b20 * a00 + b21 * a10 + b22 * a20;
                    a[7] = b20 * a01 + b21 * a11 + b22 * a21;
                    a[8] = b20 * a02 + b21 * a12 + b22 * a22;
                    return this;
                },
                /**
     * Translate this Matrix using the given Vector.
     *
     * @method Phaser.Math.Matrix3#translate
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to translate this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ translate: function(v) {
                    var a = this.val;
                    var x = v.x;
                    var y = v.y;
                    a[6] = x * a[0] + y * a[3] + a[6];
                    a[7] = x * a[1] + y * a[4] + a[7];
                    a[8] = x * a[2] + y * a[5] + a[8];
                    return this;
                },
                /**
     * Apply a rotation transformation to this Matrix.
     *
     * @method Phaser.Math.Matrix3#rotate
     * @since 3.0.0
     *
     * @param {number} rad - The angle in radians to rotate by.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ rotate: function(rad) {
                    var a = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a10 = a[3];
                    var a11 = a[4];
                    var a12 = a[5];
                    var s = Math.sin(rad);
                    var c = Math.cos(rad);
                    a[0] = c * a00 + s * a10;
                    a[1] = c * a01 + s * a11;
                    a[2] = c * a02 + s * a12;
                    a[3] = c * a10 - s * a00;
                    a[4] = c * a11 - s * a01;
                    a[5] = c * a12 - s * a02;
                    return this;
                },
                /**
     * Apply a scale transformation to this Matrix.
     *
     * Uses the `x` and `y` components of the given Vector to scale the Matrix.
     *
     * @method Phaser.Math.Matrix3#scale
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - The Vector to scale this Matrix with.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ scale: function(v) {
                    var a = this.val;
                    var x = v.x;
                    var y = v.y;
                    a[0] = x * a[0];
                    a[1] = x * a[1];
                    a[2] = x * a[2];
                    a[3] = y * a[3];
                    a[4] = y * a[4];
                    a[5] = y * a[5];
                    return this;
                },
                /**
     * Set the values of this Matrix from the given Quaternion.
     *
     * @method Phaser.Math.Matrix3#fromQuat
     * @since 3.0.0
     *
     * @param {Phaser.Math.Quaternion} q - The Quaternion to set the values of this Matrix from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ fromQuat: function(q) {
                    var x = q.x;
                    var y = q.y;
                    var z = q.z;
                    var w = q.w;
                    var x2 = x + x;
                    var y2 = y + y;
                    var z2 = z + z;
                    var xx = x * x2;
                    var xy = x * y2;
                    var xz = x * z2;
                    var yy = y * y2;
                    var yz = y * z2;
                    var zz = z * z2;
                    var wx = w * x2;
                    var wy = w * y2;
                    var wz = w * z2;
                    var out = this.val;
                    out[0] = 1 - (yy + zz);
                    out[3] = xy + wz;
                    out[6] = xz - wy;
                    out[1] = xy - wz;
                    out[4] = 1 - (xx + zz);
                    out[7] = yz + wx;
                    out[2] = xz + wy;
                    out[5] = yz - wx;
                    out[8] = 1 - (xx + yy);
                    return this;
                },
                /**
     * Set the values of this Matrix3 to be normalized from the given Matrix4.
     *
     * @method Phaser.Math.Matrix3#normalFromMat4
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix4} m - The Matrix4 to normalize the values from.
     *
     * @return {Phaser.Math.Matrix3} This Matrix3.
     */ normalFromMat4: function(m) {
                    var a = m.val;
                    var out = this.val;
                    var a00 = a[0];
                    var a01 = a[1];
                    var a02 = a[2];
                    var a03 = a[3];
                    var a10 = a[4];
                    var a11 = a[5];
                    var a12 = a[6];
                    var a13 = a[7];
                    var a20 = a[8];
                    var a21 = a[9];
                    var a22 = a[10];
                    var a23 = a[11];
                    var a30 = a[12];
                    var a31 = a[13];
                    var a32 = a[14];
                    var a33 = a[15];
                    var b00 = a00 * a11 - a01 * a10;
                    var b01 = a00 * a12 - a02 * a10;
                    var b02 = a00 * a13 - a03 * a10;
                    var b03 = a01 * a12 - a02 * a11;
                    var b04 = a01 * a13 - a03 * a11;
                    var b05 = a02 * a13 - a03 * a12;
                    var b06 = a20 * a31 - a21 * a30;
                    var b07 = a20 * a32 - a22 * a30;
                    var b08 = a20 * a33 - a23 * a30;
                    var b09 = a21 * a32 - a22 * a31;
                    var b10 = a21 * a33 - a23 * a31;
                    var b11 = a22 * a33 - a23 * a32;
                    // Calculate the determinant
                    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
                    if (!det) return null;
                    det = 1 / det;
                    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
                    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
                    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
                    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
                    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
                    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
                    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
                    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
                    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
                    return this;
                }
            });
            module1.exports = Matrix3;
        /***/ },
        /* 359 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
            //  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
            var Class = __webpack_require__(0);
            var Matrix3 = __webpack_require__(358);
            var NOOP = __webpack_require__(1);
            var Vector3 = __webpack_require__(38);
            var EPSILON = 0.000001;
            //  Some shared 'private' arrays
            var siNext = new Int8Array([
                1,
                2,
                0
            ]);
            var tmp = new Float32Array([
                0,
                0,
                0
            ]);
            var xUnitVec3 = new Vector3(1, 0, 0);
            var yUnitVec3 = new Vector3(0, 1, 0);
            var tmpvec = new Vector3();
            var tmpMat3 = new Matrix3();
            /**
 * @classdesc
 * A quaternion.
 *
 * @class Quaternion
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The x component.
 * @param {number} [y=0] - The y component.
 * @param {number} [z=0] - The z component.
 * @param {number} [w=1] - The w component.
 */ var Quaternion = new Class({
                initialize: function Quaternion(x, y, z, w) {
                    /**
         * The x component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_x
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The y component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_y
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The z component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_z
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * The w component of this Quaternion.
         *
         * @name Phaser.Math.Quaternion#_w
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ /**
         * This callback is invoked, if set, each time a value in this quaternion is changed.
         * The callback is passed one argument, a reference to this quaternion.
         *
         * @name Phaser.Math.Quaternion#onChangeCallback
         * @type {function}
         * @since 3.50.0
         */ this.onChangeCallback = NOOP;
                    this.set(x, y, z, w);
                },
                /**
     * The x component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#x
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The y component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#y
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The z component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#z
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(value) {
                        this._z = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * The w component of this Quaternion.
     *
     * @name Phaser.Math.Quaternion#w
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ w: {
                    get: function() {
                        return this._w;
                    },
                    set: function(value) {
                        this._w = value;
                        this.onChangeCallback(this);
                    }
                },
                /**
     * Copy the components of a given Quaternion or Vector into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#copy
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} src - The Quaternion or Vector to copy the components from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ copy: function(src) {
                    return this.set(src);
                },
                /**
     * Set the components of this Quaternion and optionally call the `onChangeCallback`.
     *
     * @method Phaser.Math.Quaternion#set
     * @since 3.0.0
     *
     * @param {(number|object)} [x=0] - The x component, or an object containing x, y, z, and w components.
     * @param {number} [y=0] - The y component.
     * @param {number} [z=0] - The z component.
     * @param {number} [w=0] - The w component.
     * @param {boolean} [update=true] - Call the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ set: function(x, y, z, w, update) {
                    if (update === undefined) update = true;
                    if (typeof x === 'object') {
                        this._x = x.x || 0;
                        this._y = x.y || 0;
                        this._z = x.z || 0;
                        this._w = x.w || 0;
                    } else {
                        this._x = x || 0;
                        this._y = y || 0;
                        this._z = z || 0;
                        this._w = w || 0;
                    }
                    if (update) this.onChangeCallback(this);
                    return this;
                },
                /**
     * Add a given Quaternion or Vector to this Quaternion. Addition is component-wise.
     *
     * @method Phaser.Math.Quaternion#add
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to add to this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ add: function(v) {
                    this._x += v.x;
                    this._y += v.y;
                    this._z += v.z;
                    this._w += v.w;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Subtract a given Quaternion or Vector from this Quaternion. Subtraction is component-wise.
     *
     * @method Phaser.Math.Quaternion#subtract
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to subtract from this Quaternion.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ subtract: function(v) {
                    this._x -= v.x;
                    this._y -= v.y;
                    this._z -= v.z;
                    this._w -= v.w;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Scale this Quaternion by the given value.
     *
     * @method Phaser.Math.Quaternion#scale
     * @since 3.0.0
     *
     * @param {number} scale - The value to scale this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ scale: function(scale) {
                    this._x *= scale;
                    this._y *= scale;
                    this._z *= scale;
                    this._w *= scale;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Calculate the length of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#length
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion.
     */ length: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return Math.sqrt(x * x + y * y + z * z + w * w);
                },
                /**
     * Calculate the length of this Quaternion squared.
     *
     * @method Phaser.Math.Quaternion#lengthSq
     * @since 3.0.0
     *
     * @return {number} The length of this Quaternion, squared.
     */ lengthSq: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    return x * x + y * y + z * z + w * w;
                },
                /**
     * Normalize this Quaternion.
     *
     * @method Phaser.Math.Quaternion#normalize
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ normalize: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    var w = this.w;
                    var len = x * x + y * y + z * z + w * w;
                    if (len > 0) {
                        len = 1 / Math.sqrt(len);
                        this._x = x * len;
                        this._y = y * len;
                        this._z = z * len;
                        this._w = w * len;
                    }
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Calculate the dot product of this Quaternion and the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#dot
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to dot product with this Quaternion.
     *
     * @return {number} The dot product of this Quaternion and the given Quaternion or Vector.
     */ dot: function(v) {
                    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
                },
                /**
     * Linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#lerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - The Quaternion or Vector to interpolate towards.
     * @param {number} [t=0] - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ lerp: function(v, t) {
                    if (t === undefined) t = 0;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    return this.set(ax + t * (v.x - ax), ay + t * (v.y - ay), az + t * (v.z - az), aw + t * (v.w - aw));
                },
                /**
     * Rotates this Quaternion based on the two given vectors.
     *
     * @method Phaser.Math.Quaternion#rotationTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} a - The transform rotation vector.
     * @param {Phaser.Math.Vector3} b - The target rotation vector.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotationTo: function(a, b) {
                    var dot = a.x * b.x + a.y * b.y + a.z * b.z;
                    if (dot < -0.999999) {
                        if (tmpvec.copy(xUnitVec3).cross(a).length() < EPSILON) tmpvec.copy(yUnitVec3).cross(a);
                        tmpvec.normalize();
                        return this.setAxisAngle(tmpvec, Math.PI);
                    } else if (dot > 0.999999) return this.set(0, 0, 0, 1);
                    else {
                        tmpvec.copy(a).cross(b);
                        this._x = tmpvec.x;
                        this._y = tmpvec.y;
                        this._z = tmpvec.z;
                        this._w = 1 + dot;
                        return this.normalize();
                    }
                },
                /**
     * Set the axes of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxes
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} view - The view axis.
     * @param {Phaser.Math.Vector3} right - The right axis.
     * @param {Phaser.Math.Vector3} up - The upwards axis.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxes: function(view, right, up) {
                    var m = tmpMat3.val;
                    m[0] = right.x;
                    m[3] = right.y;
                    m[6] = right.z;
                    m[1] = up.x;
                    m[4] = up.y;
                    m[7] = up.z;
                    m[2] = -view.x;
                    m[5] = -view.y;
                    m[8] = -view.z;
                    return this.fromMat3(tmpMat3).normalize();
                },
                /**
     * Reset this Matrix to an identity (default) Quaternion.
     *
     * @method Phaser.Math.Quaternion#identity
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ identity: function() {
                    return this.set(0, 0, 0, 1);
                },
                /**
     * Set the axis angle of this Quaternion.
     *
     * @method Phaser.Math.Quaternion#setAxisAngle
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector3} axis - The axis.
     * @param {number} rad - The angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setAxisAngle: function(axis, rad) {
                    rad = rad * 0.5;
                    var s = Math.sin(rad);
                    return this.set(s * axis.x, s * axis.y, s * axis.z, Math.cos(rad));
                },
                /**
     * Multiply this Quaternion by the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#multiply
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to multiply this Quaternion by.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ multiply: function(b) {
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    var bw = b.w;
                    return this.set(ax * bw + aw * bx + ay * bz - az * by, ay * bw + aw * by + az * bx - ax * bz, az * bw + aw * bz + ax * by - ay * bx, aw * bw - ax * bx - ay * by - az * bz);
                },
                /**
     * Smoothly linearly interpolate this Quaternion towards the given Quaternion or Vector.
     *
     * @method Phaser.Math.Quaternion#slerp
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - The Quaternion or Vector to interpolate towards.
     * @param {number} t - The percentage of interpolation.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ slerp: function(b, t) {
                    // benchmarks: http://jsperf.com/quaternion-slerp-implementations
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = b.x;
                    var by = b.y;
                    var bz = b.z;
                    var bw = b.w;
                    // calc cosine
                    var cosom = ax * bx + ay * by + az * bz + aw * bw;
                    // adjust signs (if necessary)
                    if (cosom < 0) {
                        cosom = -cosom;
                        bx = -bx;
                        by = -by;
                        bz = -bz;
                        bw = -bw;
                    }
                    // "from" and "to" quaternions are very close
                    //  ... so we can do a linear interpolation
                    var scale0 = 1 - t;
                    var scale1 = t;
                    // calculate coefficients
                    if (1 - cosom > EPSILON) {
                        // standard case (slerp)
                        var omega = Math.acos(cosom);
                        var sinom = Math.sin(omega);
                        scale0 = Math.sin((1.0 - t) * omega) / sinom;
                        scale1 = Math.sin(t * omega) / sinom;
                    }
                    // calculate final values
                    return this.set(scale0 * ax + scale1 * bx, scale0 * ay + scale1 * by, scale0 * az + scale1 * bz, scale0 * aw + scale1 * bw);
                },
                /**
     * Invert this Quaternion.
     *
     * @method Phaser.Math.Quaternion#invert
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ invert: function() {
                    var a0 = this.x;
                    var a1 = this.y;
                    var a2 = this.z;
                    var a3 = this.w;
                    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
                    var invDot = dot ? 1 / dot : 0;
                    return this.set(-a0 * invDot, -a1 * invDot, -a2 * invDot, a3 * invDot);
                },
                /**
     * Convert this Quaternion into its conjugate.
     *
     * Sets the x, y and z components.
     *
     * @method Phaser.Math.Quaternion#conjugate
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ conjugate: function() {
                    this._x = -this.x;
                    this._y = -this.y;
                    this._z = -this.z;
                    this.onChangeCallback(this);
                    return this;
                },
                /**
     * Rotate this Quaternion on the X axis.
     *
     * @method Phaser.Math.Quaternion#rotateX
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateX: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bx = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw + aw * bx, ay * bw + az * bx, az * bw - ay * bx, aw * bw - ax * bx);
                },
                /**
     * Rotate this Quaternion on the Y axis.
     *
     * @method Phaser.Math.Quaternion#rotateY
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateY: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var by = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw - az * by, ay * bw + aw * by, az * bw + ax * by, aw * bw - ay * by);
                },
                /**
     * Rotate this Quaternion on the Z axis.
     *
     * @method Phaser.Math.Quaternion#rotateZ
     * @since 3.0.0
     *
     * @param {number} rad - The rotation angle in radians.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ rotateZ: function(rad) {
                    rad *= 0.5;
                    var ax = this.x;
                    var ay = this.y;
                    var az = this.z;
                    var aw = this.w;
                    var bz = Math.sin(rad);
                    var bw = Math.cos(rad);
                    return this.set(ax * bw + ay * bz, ay * bw - ax * bz, az * bw + aw * bz, aw * bw - az * bz);
                },
                /**
     * Create a unit (or rotation) Quaternion from its x, y, and z components.
     *
     * Sets the w component.
     *
     * @method Phaser.Math.Quaternion#calculateW
     * @since 3.0.0
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ calculateW: function() {
                    var x = this.x;
                    var y = this.y;
                    var z = this.z;
                    this.w = -Math.sqrt(1.0 - x * x - y * y - z * z);
                    return this;
                },
                /**
     * Set this Quaternion from the given Euler, based on Euler order.
     *
     * @method Phaser.Math.Quaternion#setFromEuler
     * @since 3.50.0
     *
     * @param {Phaser.Math.Euler} euler - The Euler to convert from.
     * @param {boolean} [update=true] - Run the `onChangeCallback`?
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromEuler: function(euler, update) {
                    var x = euler.x / 2;
                    var y = euler.y / 2;
                    var z = euler.z / 2;
                    var c1 = Math.cos(x);
                    var c2 = Math.cos(y);
                    var c3 = Math.cos(z);
                    var s1 = Math.sin(x);
                    var s2 = Math.sin(y);
                    var s3 = Math.sin(z);
                    switch(euler.order){
                        case 'XYZ':
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case 'YXZ':
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                        case 'ZXY':
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case 'ZYX':
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                        case 'YZX':
                            this.set(s1 * c2 * c3 + c1 * s2 * s3, c1 * s2 * c3 + s1 * c2 * s3, c1 * c2 * s3 - s1 * s2 * c3, c1 * c2 * c3 - s1 * s2 * s3, update);
                            break;
                        case 'XZY':
                            this.set(s1 * c2 * c3 - c1 * s2 * s3, c1 * s2 * c3 - s1 * c2 * s3, c1 * c2 * s3 + s1 * s2 * c3, c1 * c2 * c3 + s1 * s2 * s3, update);
                            break;
                    }
                    return this;
                },
                /**
     * Sets the rotation of this Quaternion from the given Matrix4.
     *
     * @method Phaser.Math.Quaternion#setFromRotationMatrix
     * @since 3.50.0
     *
     * @param {Phaser.Math.Matrix4} mat4 - The Matrix4 to set the rotation from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ setFromRotationMatrix: function(mat4) {
                    var m = mat4.val;
                    var m11 = m[0];
                    var m12 = m[4];
                    var m13 = m[8];
                    var m21 = m[1];
                    var m22 = m[5];
                    var m23 = m[9];
                    var m31 = m[2];
                    var m32 = m[6];
                    var m33 = m[10];
                    var trace = m11 + m22 + m33;
                    var s;
                    if (trace > 0) {
                        s = 0.5 / Math.sqrt(trace + 1.0);
                        this.set((m32 - m23) * s, (m13 - m31) * s, (m21 - m12) * s, 0.25 / s);
                    } else if (m11 > m22 && m11 > m33) {
                        s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                        this.set(0.25 * s, (m12 + m21) / s, (m13 + m31) / s, (m32 - m23) / s);
                    } else if (m22 > m33) {
                        s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                        this.set((m12 + m21) / s, 0.25 * s, (m23 + m32) / s, (m13 - m31) / s);
                    } else {
                        s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                        this.set((m13 + m31) / s, (m23 + m32) / s, 0.25 * s, (m21 - m12) / s);
                    }
                    return this;
                },
                /**
     * Convert the given Matrix into this Quaternion.
     *
     * @method Phaser.Math.Quaternion#fromMat3
     * @since 3.0.0
     *
     * @param {Phaser.Math.Matrix3} mat - The Matrix to convert from.
     *
     * @return {Phaser.Math.Quaternion} This Quaternion.
     */ fromMat3: function(mat) {
                    // benchmarks:
                    //    http://jsperf.com/typed-array-access-speed
                    //    http://jsperf.com/conversion-of-3x3-matrix-to-quaternion
                    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
                    // article "Quaternion Calculus and Fast Animation".
                    var m = mat.val;
                    var fTrace = m[0] + m[4] + m[8];
                    var fRoot;
                    if (fTrace > 0) {
                        // |w| > 1/2, may as well choose w > 1/2
                        fRoot = Math.sqrt(fTrace + 1.0); // 2w
                        this.w = 0.5 * fRoot;
                        fRoot = 0.5 / fRoot; // 1/(4w)
                        this._x = (m[7] - m[5]) * fRoot;
                        this._y = (m[2] - m[6]) * fRoot;
                        this._z = (m[3] - m[1]) * fRoot;
                    } else {
                        // |w| <= 1/2
                        var i = 0;
                        if (m[4] > m[0]) i = 1;
                        if (m[8] > m[i * 3 + i]) i = 2;
                        var j = siNext[i];
                        var k = siNext[j];
                        //  This isn't quite as clean without array access
                        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1);
                        tmp[i] = 0.5 * fRoot;
                        fRoot = 0.5 / fRoot;
                        tmp[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
                        tmp[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
                        this._x = tmp[0];
                        this._y = tmp[1];
                        this._z = tmp[2];
                        this._w = (m[k * 3 + j] - m[j * 3 + k]) * fRoot;
                    }
                    this.onChangeCallback(this);
                    return this;
                }
            });
            module1.exports = Quaternion;
        /***/ },
        /* 360 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasInterpolation = __webpack_require__(361);
            var CanvasPool = __webpack_require__(31);
            var CONST = __webpack_require__(32);
            var Features = __webpack_require__(188);
            /**
 * Called automatically by Phaser.Game and responsible for creating the renderer it will use.
 *
 * Relies upon two webpack global flags to be defined: `WEBGL_RENDERER` and `CANVAS_RENDERER` during build time, but not at run-time.
 *
 * @function Phaser.Core.CreateRenderer
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance on which the renderer will be set.
 */ var CreateRenderer = function(game) {
                var config = game.config;
                if ((config.customEnvironment || config.canvas) && config.renderType === CONST.AUTO) throw new Error('Must set explicit renderType in custom environment');
                //  Not a custom environment, didn't provide their own canvas and not headless, so determine the renderer:
                if (!config.customEnvironment && !config.canvas && config.renderType !== CONST.HEADLESS) {
                    if (config.renderType === CONST.CANVAS || config.renderType !== CONST.CANVAS && !Features.webGL) {
                        if (Features.canvas) //  They requested Canvas and their browser supports it
                        config.renderType = CONST.CANVAS;
                        else throw new Error('Cannot create Canvas or WebGL context, aborting.');
                    } else //  Game requested WebGL and browser says it supports it
                    config.renderType = CONST.WEBGL;
                }
                //  Pixel Art mode?
                if (!config.antialias) CanvasPool.disableSmoothing();
                var baseSize = game.scale.baseSize;
                var width = baseSize.width;
                var height = baseSize.height;
                //  Does the game config provide its own canvas element to use?
                if (config.canvas) {
                    game.canvas = config.canvas;
                    game.canvas.width = width;
                    game.canvas.height = height;
                } else game.canvas = CanvasPool.create(game, width, height, config.renderType);
                //  Does the game config provide some canvas css styles to use?
                if (config.canvasStyle) game.canvas.style = config.canvasStyle;
                //  Pixel Art mode?
                if (!config.antialias) CanvasInterpolation.setCrisp(game.canvas);
                if (config.renderType === CONST.HEADLESS) //  Nothing more to do here
                return;
                var CanvasRenderer;
                var WebGLRenderer;
                CanvasRenderer = __webpack_require__(362);
                WebGLRenderer = __webpack_require__(365);
                //  Let the config pick the renderer type, as both are included
                if (config.renderType === CONST.WEBGL) game.renderer = new WebGLRenderer(game);
                else {
                    game.renderer = new CanvasRenderer(game);
                    game.context = game.renderer.gameContext;
                }
            };
            module1.exports = CreateRenderer;
        /***/ },
        /* 361 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas.CanvasInterpolation
 * @since 3.0.0
 */ var CanvasInterpolation = {
                /**
     * Sets the CSS image-rendering property on the given canvas to be 'crisp' (aka 'optimize contrast' on webkit).
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setCrisp
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setCrisp: function(canvas) {
                    var types = [
                        'optimizeSpeed',
                        '-moz-crisp-edges',
                        '-o-crisp-edges',
                        '-webkit-optimize-contrast',
                        'optimize-contrast',
                        'crisp-edges',
                        'pixelated'
                    ];
                    types.forEach(function(type) {
                        canvas.style['image-rendering'] = type;
                    });
                    canvas.style.msInterpolationMode = 'nearest-neighbor';
                    return canvas;
                },
                /**
     * Sets the CSS image-rendering property on the given canvas to be 'bicubic' (aka 'auto').
     *
     * @function Phaser.Display.Canvas.CanvasInterpolation.setBicubic
     * @since 3.0.0
     * 
     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
     * 
     * @return {HTMLCanvasElement} The canvas.
     */ setBicubic: function(canvas) {
                    canvas.style['image-rendering'] = 'auto';
                    canvas.style.msInterpolationMode = 'bicubic';
                    return canvas;
                }
            };
            module1.exports = CanvasInterpolation;
        /***/ },
        /* 362 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CameraEvents = __webpack_require__(36);
            var CanvasSnapshot = __webpack_require__(363);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(32);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(88);
            var GetBlendModes = __webpack_require__(364);
            var ScaleEvents = __webpack_require__(101);
            var TextureEvents = __webpack_require__(103);
            var TransformMatrix = __webpack_require__(25);
            /**
 * @classdesc
 * The Canvas Renderer is responsible for managing 2D canvas rendering contexts,
 * including the one used by the Games canvas. It tracks the internal state of a
 * given context and can renderer textured Game Objects to it, taking into
 * account alpha, blending, and scaling.
 *
 * @class CanvasRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.Canvas
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser Game instance that owns this renderer.
 */ var CanvasRenderer = new Class({
                Extends: EventEmitter,
                initialize: function CanvasRenderer(game) {
                    EventEmitter.call(this);
                    var gameConfig = game.config;
                    /**
         * The local configuration settings of the CanvasRenderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                        clearBeforeRender: gameConfig.clearBeforeRender,
                        backgroundColor: gameConfig.backgroundColor,
                        antialias: gameConfig.antialias,
                        roundPixels: gameConfig.roundPixels
                    };
                    /**
         * The Phaser Game instance that owns this renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A constant which allows the renderer to be easily identified as a Canvas Renderer.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.CANVAS;
                    /**
         * The total number of Game Objects which were rendered in a frame.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#drawCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.drawCount = 0;
                    /**
         * The width of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * The height of the canvas being rendered to.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The canvas element which the Game uses.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameCanvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.gameCanvas = game.canvas;
                    var contextOptions = {
                        alpha: game.config.transparent,
                        desynchronized: game.config.desynchronized
                    };
                    /**
         * The canvas context used to render all Cameras in all Scenes during the game loop.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.gameContext = gameConfig.context ? gameConfig.context : this.gameCanvas.getContext('2d', contextOptions);
                    /**
         * The canvas context currently used by the CanvasRenderer for all rendering operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentContext
         * @type {CanvasRenderingContext2D}
         * @since 3.0.0
         */ this.currentContext = this.gameContext;
                    /**
         * Should the Canvas use Image Smoothing or not when drawing Sprites?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#antialias
         * @type {boolean}
         * @since 3.20.0
         */ this.antialias = game.config.antialias;
                    /**
         * The blend modes supported by the Canvas Renderer.
         *
         * This object maps the {@link Phaser.BlendModes} to canvas compositing operations.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#blendModes
         * @type {array}
         * @since 3.0.0
         */ this.blendModes = GetBlendModes();
                    /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.16.0
         */ this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: false,
                        callback: null,
                        type: 'image/png',
                        encoder: 0.92
                    };
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix1
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix1 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix2
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * A temporary Transform Matrix, re-used internally during batching.
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#_tempMatrix3
         * @private
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.11.0
         */ this._tempMatrix3 = new TransformMatrix();
                    /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.Canvas.CanvasRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                    this.init();
                },
                /**
     * Prepares the game canvas for rendering.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#init
     * @since 3.0.0
     */ init: function() {
                    this.game.textures.once(TextureEvents.READY, this.boot, this);
                },
                /**
     * Internal boot handler.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#boot
     * @private
     * @since 3.50.0
     */ boot: function() {
                    var game = this.game;
                    var baseSize = game.scale.baseSize;
                    this.width = baseSize.width;
                    this.height = baseSize.height;
                    this.isBooted = true;
                    game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.resize(baseSize.width, baseSize.height);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions multiplied by the resolution. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                    //  Has the underlying canvas size changed?
                    if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                },
                /**
     * Resize the main game canvas.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     */ resize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.emit(Events.RESIZE, width, height);
                },
                /**
     * Resets the transformation matrix of the current context to the identity matrix, thus resetting any transformation.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#resetTransform
     * @since 3.0.0
     */ resetTransform: function() {
                    this.currentContext.setTransform(1, 0, 0, 1, 0, 0);
                },
                /**
     * Sets the blend mode (compositing operation) of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {string} blendMode - The new blend mode which should be used.
     *
     * @return {this} This CanvasRenderer object.
     */ setBlendMode: function(blendMode) {
                    this.currentContext.globalCompositeOperation = blendMode;
                    return this;
                },
                /**
     * Changes the Canvas Rendering Context that all draw operations are performed against.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setContext
     * @since 3.12.0
     *
     * @param {?CanvasRenderingContext2D} [ctx] - The new Canvas Rendering Context to draw everything to. Leave empty to reset to the Game Canvas.
     *
     * @return {this} The Canvas Renderer instance.
     */ setContext: function(ctx) {
                    this.currentContext = ctx ? ctx : this.gameContext;
                    return this;
                },
                /**
     * Sets the global alpha of the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#setAlpha
     * @since 3.0.0
     *
     * @param {number} alpha - The new alpha to use, where 0 is fully transparent and 1 is fully opaque.
     *
     * @return {this} This CanvasRenderer object.
     */ setAlpha: function(alpha) {
                    this.currentContext.globalAlpha = alpha;
                    return this;
                },
                /**
     * Called at the start of the render loop.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                    var ctx = this.gameContext;
                    var config = this.config;
                    var width = this.width;
                    var height = this.height;
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    if (config.clearBeforeRender) ctx.clearRect(0, 0, width, height);
                    if (!config.transparent) {
                        ctx.fillStyle = config.backgroundColor.rgba;
                        ctx.fillRect(0, 0, width, height);
                    }
                    ctx.save();
                    this.drawCount = 0;
                    this.emit(Events.PRE_RENDER);
                },
                /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                    var childCount = children.length;
                    this.emit(Events.RENDER, scene, camera);
                    var cx = camera.x;
                    var cy = camera.y;
                    var cw = camera.width;
                    var ch = camera.height;
                    var ctx = camera.renderToTexture ? camera.context : scene.sys.context;
                    //  Save context pre-clip
                    ctx.save();
                    if (this.game.scene.customViewports) {
                        ctx.beginPath();
                        ctx.rect(cx, cy, cw, ch);
                        ctx.clip();
                    }
                    this.currentContext = ctx;
                    var mask = camera.mask;
                    if (mask) mask.preRenderCanvas(this, null, camera._maskCamera);
                    if (!camera.transparent) {
                        ctx.fillStyle = camera.backgroundColor.rgba;
                        ctx.fillRect(cx, cy, cw, ch);
                    }
                    ctx.globalAlpha = camera.alpha;
                    ctx.globalCompositeOperation = 'source-over';
                    this.drawCount += childCount;
                    if (camera.renderToTexture) camera.emit(CameraEvents.PRE_RENDER, camera);
                    camera.matrix.copyToContext(ctx);
                    for(var i = 0; i < childCount; i++){
                        var child = children[i];
                        if (child.mask) child.mask.preRenderCanvas(this, child, camera);
                        child.renderCanvas(this, child, camera);
                        if (child.mask) child.mask.postRenderCanvas(this, child, camera);
                    }
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.globalCompositeOperation = 'source-over';
                    ctx.globalAlpha = 1;
                    camera.flashEffect.postRenderCanvas(ctx);
                    camera.fadeEffect.postRenderCanvas(ctx);
                    camera.dirty = false;
                    if (mask) mask.postRenderCanvas(this);
                    //  Restore pre-clip context
                    ctx.restore();
                    if (camera.renderToTexture) {
                        camera.emit(CameraEvents.POST_RENDER, camera);
                        if (camera.renderToGame) scene.sys.context.drawImage(camera.canvas, cx, cy);
                    }
                },
                /**
     * Restores the game context's global settings and takes a snapshot if one is scheduled.
     *
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                    var ctx = this.gameContext;
                    ctx.restore();
                    this.emit(Events.POST_RENDER);
                    var state = this.snapshotState;
                    if (state.callback) {
                        CanvasSnapshot(this.gameCanvas, state);
                        state.callback = null;
                    }
                },
                /**
     * Takes a snapshot of the given area of the given canvas.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotCanvas
     * @since 3.19.0
     *
     * @param {HTMLCanvasElement} canvas - The canvas to grab from.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from.
     * @param {number} [y=0] - The y coordinate to grab from.
     * @param {number} [width=canvas.width] - The width of the area to grab.
     * @param {number} [height=canvas.height] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This Canvas Renderer.
     */ snapshotCanvas: function(canvas, callback, getPixel, x, y, width, height, type, encoderOptions) {
                    if (getPixel === undefined) getPixel = false;
                    this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                    var state = this.snapshotState;
                    state.getPixel = getPixel;
                    CanvasSnapshot(this.canvas, state);
                    state.callback = null;
                    return this;
                },
                /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                    return this.snapshotArea(0, 0, this.gameCanvas.width, this.gameCanvas.height, callback, type, encoderOptions);
                },
                /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by creating an Image object from the canvas data, this is a blocking process, which gets
     * more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    var state = this.snapshotState;
                    state.callback = callback;
                    state.type = type;
                    state.encoder = encoderOptions;
                    state.getPixel = false;
                    state.x = x;
                    state.y = y;
                    state.width = Math.min(width, this.gameCanvas.width);
                    state.height = Math.min(height, this.gameCanvas.height);
                    return this;
                },
                /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                    this.snapshotArea(x, y, 1, 1, callback);
                    this.snapshotState.getPixel = true;
                    return this;
                },
                /**
     * Takes a Sprite Game Object, or any object that extends it, and draws it to the current context.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#batchSprite
     * @since 3.12.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The texture based Game Object to draw.
     * @param {Phaser.Textures.Frame} frame - The frame to draw, doesn't have to be that owned by the Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the rendering transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} [parentTransformMatrix] - The transform matrix of the parent container, if set.
     */ batchSprite: function(sprite, frame, camera, parentTransformMatrix) {
                    var alpha = camera.alpha * sprite.alpha;
                    if (alpha === 0) //  Nothing to see, so abort early
                    return;
                    var ctx = this.currentContext;
                    var camMatrix = this._tempMatrix1;
                    var spriteMatrix = this._tempMatrix2;
                    var cd = frame.canvasData;
                    var frameX = cd.x;
                    var frameY = cd.y;
                    var frameWidth = frame.cutWidth;
                    var frameHeight = frame.cutHeight;
                    var customPivot = frame.customPivot;
                    var res = frame.source.resolution;
                    var displayOriginX = sprite.displayOriginX;
                    var displayOriginY = sprite.displayOriginY;
                    var x = -displayOriginX + frame.x;
                    var y = -displayOriginY + frame.y;
                    if (sprite.isCropped) {
                        var crop = sprite._crop;
                        if (crop.flipX !== sprite.flipX || crop.flipY !== sprite.flipY) frame.updateCropUVs(crop, sprite.flipX, sprite.flipY);
                        frameWidth = crop.cw;
                        frameHeight = crop.ch;
                        frameX = crop.cx;
                        frameY = crop.cy;
                        x = -displayOriginX + crop.x;
                        y = -displayOriginY + crop.y;
                        if (sprite.flipX) {
                            if (x >= 0) x = -(x + frameWidth);
                            else if (x < 0) x = Math.abs(x) - frameWidth;
                        }
                        if (sprite.flipY) {
                            if (y >= 0) y = -(y + frameHeight);
                            else if (y < 0) y = Math.abs(y) - frameHeight;
                        }
                    }
                    var flipX = 1;
                    var flipY = 1;
                    if (sprite.flipX) {
                        if (!customPivot) x += -frame.realWidth + displayOriginX * 2;
                        flipX = -1;
                    }
                    //  Auto-invert the flipY if this is coming from a GLTexture
                    if (sprite.flipY) {
                        if (!customPivot) y += -frame.realHeight + displayOriginY * 2;
                        flipY = -1;
                    }
                    spriteMatrix.applyITRS(sprite.x, sprite.y, sprite.rotation, sprite.scaleX * flipX, sprite.scaleY * flipY);
                    camMatrix.copyFrom(camera.matrix);
                    if (parentTransformMatrix) {
                        //  Multiply the camera by the parent matrix
                        camMatrix.multiplyWithOffset(parentTransformMatrix, -camera.scrollX * sprite.scrollFactorX, -camera.scrollY * sprite.scrollFactorY);
                        //  Undo the camera scroll
                        spriteMatrix.e = sprite.x;
                        spriteMatrix.f = sprite.y;
                    } else {
                        spriteMatrix.e -= camera.scrollX * sprite.scrollFactorX;
                        spriteMatrix.f -= camera.scrollY * sprite.scrollFactorY;
                    }
                    //  Multiply by the Sprite matrix
                    camMatrix.multiply(spriteMatrix);
                    ctx.save();
                    camMatrix.setToContext(ctx);
                    ctx.globalCompositeOperation = this.blendModes[sprite.blendMode];
                    ctx.globalAlpha = alpha;
                    ctx.imageSmoothingEnabled = !(!this.antialias || frame.source.scaleMode);
                    if (sprite.mask) sprite.mask.preRenderCanvas(this, sprite, camera);
                    ctx.drawImage(frame.source.image, frameX, frameY, frameWidth, frameHeight, x, y, frameWidth / res, frameHeight / res);
                    if (sprite.mask) sprite.mask.postRenderCanvas(this, sprite, camera);
                    ctx.restore();
                },
                /**
     * Destroys all object references in the Canvas Renderer.
     *
     * @method Phaser.Renderer.Canvas.CanvasRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.game = null;
                    this.gameCanvas = null;
                    this.gameContext = null;
                }
            });
            module1.exports = CanvasRenderer;
        /***/ },
        /* 363 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Color = __webpack_require__(37);
            var GetFastValue = __webpack_require__(2);
            /**
 * Takes a snapshot of an area from the current frame displayed by a canvas.
 * 
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.Canvas
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} sourceCanvas - The canvas to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var CanvasSnapshot = function(canvas, config) {
                var callback = GetFastValue(config, 'callback');
                var type = GetFastValue(config, 'type', 'image/png');
                var encoderOptions = GetFastValue(config, 'encoder', 0.92);
                var x = Math.abs(Math.round(GetFastValue(config, 'x', 0)));
                var y = Math.abs(Math.round(GetFastValue(config, 'y', 0)));
                var width = GetFastValue(config, 'width', canvas.width);
                var height = GetFastValue(config, 'height', canvas.height);
                var getPixel = GetFastValue(config, 'getPixel', false);
                if (getPixel) {
                    var context = canvas.getContext('2d');
                    var imageData = context.getImageData(x, y, 1, 1);
                    var data = imageData.data;
                    callback.call(null, new Color(data[0], data[1], data[2], data[3] / 255));
                } else if (x !== 0 || y !== 0 || width !== canvas.width || height !== canvas.height) {
                    //  Area Grab
                    var copyCanvas = CanvasPool.createWebGL(this, width, height);
                    var ctx = copyCanvas.getContext('2d');
                    ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
                    var image1 = new Image();
                    image1.onerror = function() {
                        callback.call(null);
                        CanvasPool.remove(copyCanvas);
                    };
                    image1.onload = function() {
                        callback.call(null, image1);
                        CanvasPool.remove(copyCanvas);
                    };
                    image1.src = copyCanvas.toDataURL(type, encoderOptions);
                } else {
                    //  Full Grab
                    var image2 = new Image();
                    image2.onerror = function() {
                        callback.call(null);
                    };
                    image2.onload = function() {
                        callback.call(null, image2);
                    };
                    image2.src = canvas.toDataURL(type, encoderOptions);
                }
            };
            module1.exports = CanvasSnapshot;
        /***/ },
        /* 364 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var modes = __webpack_require__(34);
            var CanvasFeatures = __webpack_require__(342);
            /**
 * Returns an array which maps the default blend modes to supported Canvas blend modes.
 *
 * If the browser doesn't support a blend mode, it will default to the normal `source-over` blend mode.
 *
 * @function Phaser.Renderer.Canvas.GetBlendModes
 * @since 3.0.0
 *
 * @return {array} Which Canvas blend mode corresponds to which default Phaser blend mode.
 */ var GetBlendModes = function() {
                var output = [];
                var useNew = CanvasFeatures.supportNewBlendModes;
                var so = 'source-over';
                output[modes.NORMAL] = so;
                output[modes.ADD] = 'lighter';
                output[modes.MULTIPLY] = useNew ? 'multiply' : so;
                output[modes.SCREEN] = useNew ? 'screen' : so;
                output[modes.OVERLAY] = useNew ? 'overlay' : so;
                output[modes.DARKEN] = useNew ? 'darken' : so;
                output[modes.LIGHTEN] = useNew ? 'lighten' : so;
                output[modes.COLOR_DODGE] = useNew ? 'color-dodge' : so;
                output[modes.COLOR_BURN] = useNew ? 'color-burn' : so;
                output[modes.HARD_LIGHT] = useNew ? 'hard-light' : so;
                output[modes.SOFT_LIGHT] = useNew ? 'soft-light' : so;
                output[modes.DIFFERENCE] = useNew ? 'difference' : so;
                output[modes.EXCLUSION] = useNew ? 'exclusion' : so;
                output[modes.HUE] = useNew ? 'hue' : so;
                output[modes.SATURATION] = useNew ? 'saturation' : so;
                output[modes.COLOR] = useNew ? 'color' : so;
                output[modes.LUMINOSITY] = useNew ? 'luminosity' : so;
                output[modes.ERASE] = 'destination-out';
                output[modes.SOURCE_IN] = 'source-in';
                output[modes.SOURCE_OUT] = 'source-out';
                output[modes.SOURCE_ATOP] = 'source-atop';
                output[modes.DESTINATION_OVER] = 'destination-over';
                output[modes.DESTINATION_IN] = 'destination-in';
                output[modes.DESTINATION_OUT] = 'destination-out';
                output[modes.DESTINATION_ATOP] = 'destination-atop';
                output[modes.LIGHTER] = 'lighter';
                output[modes.COPY] = 'copy';
                output[modes.XOR] = 'xor';
                return output;
            };
            module1.exports = GetBlendModes;
        /***/ },
        /* 365 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(89);
            var CameraEvents = __webpack_require__(36);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(32);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(88);
            var GameEvents = __webpack_require__(22);
            var IsSizePowerOfTwo = __webpack_require__(136);
            var Matrix4 = __webpack_require__(67);
            var NOOP = __webpack_require__(1);
            var PipelineManager = __webpack_require__(366);
            var RenderTarget = __webpack_require__(139);
            var ScaleEvents = __webpack_require__(101);
            var TextureEvents = __webpack_require__(103);
            var Utils = __webpack_require__(12);
            var WebGLSnapshot = __webpack_require__(377);
            /**
 * @callback WebGLContextCallback
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - The WebGL Renderer which owns the context.
 */ /**
 * @classdesc
 * WebGLRenderer is a class that contains the needed functionality to keep the
 * WebGLRenderingContext state clean. The main idea of the WebGLRenderer is to keep track of
 * any context change that happens for WebGL rendering inside of Phaser. This means
 * if raw webgl functions are called outside the WebGLRenderer of the Phaser WebGL
 * rendering ecosystem they might pollute the current WebGLRenderingContext state producing
 * unexpected behavior. It's recommended that WebGL interaction is done through
 * WebGLRenderer and/or WebGLPipeline.
 *
 * @class WebGLRenderer
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance which owns this WebGL Renderer.
 */ var WebGLRenderer = new Class({
                Extends: EventEmitter,
                initialize: function WebGLRenderer(game) {
                    EventEmitter.call(this);
                    var gameConfig = game.config;
                    var contextCreationConfig = {
                        alpha: gameConfig.transparent,
                        desynchronized: gameConfig.desynchronized,
                        depth: false,
                        antialias: gameConfig.antialiasGL,
                        premultipliedAlpha: gameConfig.premultipliedAlpha,
                        stencil: true,
                        failIfMajorPerformanceCaveat: gameConfig.failIfMajorPerformanceCaveat,
                        powerPreference: gameConfig.powerPreference
                    };
                    /**
         * The local configuration settings of this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#config
         * @type {object}
         * @since 3.0.0
         */ this.config = {
                        clearBeforeRender: gameConfig.clearBeforeRender,
                        antialias: gameConfig.antialias,
                        backgroundColor: gameConfig.backgroundColor,
                        contextCreation: contextCreationConfig,
                        roundPixels: gameConfig.roundPixels,
                        maxTextures: gameConfig.maxTextures,
                        maxTextureSize: gameConfig.maxTextureSize,
                        batchSize: gameConfig.batchSize,
                        maxLights: gameConfig.maxLights,
                        mipmapFilter: gameConfig.mipmapFilter
                    };
                    /**
         * The Game instance which owns this WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A constant which allows the renderer to be easily identified as a WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#type
         * @type {number}
         * @since 3.0.0
         */ this.type = CONST.WEBGL;
                    /**
         * An instance of the Pipeline Manager class, that handles all WebGL Pipelines.
         *
         * Use this to manage all of your interactions with pipelines, such as adding, getting,
         * setting and rendering them.
         *
         * The Pipeline Manager class is created in the `init` method and then populated
         * with pipelines during the `boot` method.
         *
         * Prior to Phaser v3.50.0 this was just a plain JavaScript object, not a class.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#pipelines
         * @type {Phaser.Renderer.WebGL.PipelineManager}
         * @since 3.50.0
         */ this.pipelines = null;
                    /**
         * The width of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#width
         * @type {number}
         * @since 3.0.0
         */ this.width = 0;
                    /**
         * The height of the canvas being rendered to.
         * This is populated in the onResize event handler.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#height
         * @type {number}
         * @since 3.0.0
         */ this.height = 0;
                    /**
         * The canvas which this WebGL Renderer draws to.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = game.canvas;
                    /**
         * An array of blend modes supported by the WebGL Renderer.
         *
         * This array includes the default blend modes as well as any custom blend modes added through {@link #addBlendMode}.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blendModes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.blendModes = [];
                    /**
         * This property is set to `true` if the WebGL context of the renderer is lost.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLost
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.contextLost = false;
                    /**
         * Details about the currently scheduled snapshot.
         *
         * If a non-null `callback` is set in this object, a snapshot of the canvas will be taken after the current frame is fully rendered.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#snapshotState
         * @type {Phaser.Types.Renderer.Snapshot.SnapshotState}
         * @since 3.0.0
         */ this.snapshotState = {
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        getPixel: false,
                        callback: null,
                        type: 'image/png',
                        encoder: 0.92,
                        isFramebuffer: false,
                        bufferWidth: 0,
                        bufferHeight: 0
                    };
                    /**
         * Cached value for the last texture unit that was used.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentActiveTexture
         * @type {number}
         * @since 3.1.0
         */ this.currentActiveTexture = 0;
                    /**
         * Contains the current starting active texture unit.
         * This value is constantly updated and should be treated as read-only by your code.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#startActiveTexture
         * @type {number}
         * @since 3.50.0
         */ this.startActiveTexture = 0;
                    /**
         * The maximum number of textures the GPU can handle. The minimum under the WebGL1 spec is 8.
         * This is set via the Game Config `maxTextures` property and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maxTextures
         * @type {number}
         * @since 3.50.0
         */ this.maxTextures = 0;
                    /**
         * An array of the available WebGL texture units, used to populate the uSampler uniforms.
         *
         * This array is populated during the init phase and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureIndexes
         * @type {array}
         * @since 3.50.0
         */ this.textureIndexes;
                    /**
         * An array of default temporary WebGL Textures.
         *
         * This array is populated during the init phase and should never be changed after boot.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#tempTextures
         * @type {array}
         * @since 3.50.0
         */ this.tempTextures;
                    /**
         * The currently bound texture at texture unit zero, if any.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureZero
         * @type {?WebGLTexture}
         * @since 3.50.0
         */ this.textureZero;
                    /**
         * The currently bound normal map texture at texture unit one, if any.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#normalTexture
         * @type {?WebGLTexture}
         * @since 3.50.0
         */ this.normalTexture;
                    /**
         * The currently bound framebuffer in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentFramebuffer
         * @type {WebGLFramebuffer}
         * @default null
         * @since 3.0.0
         */ this.currentFramebuffer = null;
                    /**
         * A stack into which the frame buffer objects are pushed and popped.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#fboStack
         * @type {WebGLFramebuffer[]}
         * @since 3.50.0
         */ this.fboStack = [];
                    /**
         * Current WebGLProgram in use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentProgram
         * @type {WebGLProgram}
         * @default null
         * @since 3.0.0
         */ this.currentProgram = null;
                    /**
         * Current blend mode in use
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentBlendMode
         * @type {number}
         * @since 3.0.0
         */ this.currentBlendMode = Infinity;
                    /**
         * Indicates if the the scissor state is enabled in WebGLRenderingContext
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissorEnabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.currentScissorEnabled = false;
                    /**
         * Stores the current scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissor
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.currentScissor = null;
                    /**
         * Stack of scissor data
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#scissorStack
         * @type {Uint32Array}
         * @since 3.0.0
         */ this.scissorStack = [];
                    /**
         * The handler to invoke when the context is lost.
         * This should not be changed and is set in the boot method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLostHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextLostHandler = NOOP;
                    /**
         * The handler to invoke when the context is restored.
         * This should not be changed and is set in the boot method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextRestoredHandler
         * @type {function}
         * @since 3.19.0
         */ this.contextRestoredHandler = NOOP;
                    /**
         * The underlying WebGL context of the renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#gl
         * @type {WebGLRenderingContext}
         * @default null
         * @since 3.0.0
         */ this.gl = null;
                    /**
         * Array of strings that indicate which WebGL extensions are supported by the browser.
         * This is populated in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#supportedExtensions
         * @type {string[]}
         * @default null
         * @since 3.0.0
         */ this.supportedExtensions = null;
                    /**
         * If the browser supports the `ANGLE_instanced_arrays` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#instancedArraysExtension
         * @type {ANGLE_instanced_arrays}
         * @default null
         * @since 3.50.0
         */ this.instancedArraysExtension = null;
                    /**
         * If the browser supports the `OES_vertex_array_object` extension, this property will hold
         * a reference to the glExtension for it.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#vaoExtension
         * @type {OES_vertex_array_object}
         * @default null
         * @since 3.50.0
         */ this.vaoExtension = null;
                    /**
         * The WebGL Extensions loaded into the current context.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#extensions
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.extensions = {};
                    /**
         * Stores the current WebGL component formats for further use.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFormats
         * @type {array}
         * @default []
         * @since 3.2.0
         */ this.glFormats = [];
                    /**
         * Stores the supported WebGL texture compression formats.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#compression
         * @type {object}
         * @since 3.8.0
         */ this.compression = {
                        ETC1: false,
                        PVRTC: false,
                        S3TC: false
                    };
                    /**
         * Cached drawing buffer height to reduce gl calls.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#drawingBufferHeight
         * @type {number}
         * @readonly
         * @since 3.11.0
         */ this.drawingBufferHeight = 0;
                    /**
         * A blank 32x32 transparent texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#blankTexture
         * @type {WebGLTexture}
         * @readonly
         * @since 3.12.0
         */ this.blankTexture = null;
                    /**
         * A pure white 4x4 texture, as used by the Graphics system where needed.
         * This is set in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#whiteTexture
         * @type {WebGLTexture}
         * @readonly
         * @since 3.50.0
         */ this.whiteTexture = null;
                    /**
         * The total number of masks currently stacked.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskCount
         * @type {number}
         * @since 3.17.0
         */ this.maskCount = 0;
                    /**
         * The mask stack.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#maskStack
         * @type {Phaser.Display.Masks.GeometryMask[]}
         * @since 3.17.0
         */ this.maskStack = [];
                    /**
         * Internal property that tracks the currently set mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentMask
         * @type {any}
         * @since 3.17.0
         */ this.currentMask = {
                        mask: null,
                        camera: null
                    };
                    /**
         * Internal property that tracks the currently set camera mask.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentCameraMask
         * @type {any}
         * @since 3.17.0
         */ this.currentCameraMask = {
                        mask: null,
                        camera: null
                    };
                    /**
         * Internal gl function mapping for uniform look-up.
         * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/uniform
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFuncMap
         * @type {any}
         * @since 3.17.0
         */ this.glFuncMap = null;
                    /**
         * The `type` of the Game Object being currently rendered.
         * This can be used by advanced render functions for batching look-ahead.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentType
         * @type {string}
         * @since 3.19.0
         */ this.currentType = '';
                    /**
         * Is the `type` of the Game Object being currently rendered different than the
         * type of the object before it in the display list? I.e. it's a 'new' type.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#newType
         * @type {boolean}
         * @since 3.19.0
         */ this.newType = false;
                    /**
         * Does the `type` of the next Game Object in the display list match that
         * of the object being currently rendered?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#nextTypeMatch
         * @type {boolean}
         * @since 3.19.0
         */ this.nextTypeMatch = false;
                    /**
         * Is the Game Object being currently rendered the final one in the list?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#finalType
         * @type {boolean}
         * @since 3.50.0
         */ this.finalType = false;
                    /**
         * The mipmap magFilter to be used when creating textures.
         *
         * You can specify this as a string in the game config, i.e.:
         *
         * `renderer: { mipmapFilter: 'NEAREST_MIPMAP_LINEAR' }`
         *
         * The 6 options for WebGL1 are, in order from least to most computationally expensive:
         *
         * NEAREST (for pixel art)
         * LINEAR (the default)
         * NEAREST_MIPMAP_NEAREST
         * LINEAR_MIPMAP_NEAREST
         * NEAREST_MIPMAP_LINEAR
         * LINEAR_MIPMAP_LINEAR
         *
         * Mipmaps only work with textures that are fully power-of-two in size.
         *
         * For more details see https://webglfundamentals.org/webgl/lessons/webgl-3d-textures.html
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#mipmapFilter
         * @type {GLenum}
         * @since 3.21.0
         */ this.mipmapFilter = null;
                    /**
         * The number of times the renderer had to flush this frame, due to running out of texture units.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#textureFlush
         * @type {number}
         * @since 3.50.0
         */ this.textureFlush = 0;
                    /**
         * Are the WebGL Textures in their default state?
         *
         * Used to avoid constant gl binds.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#isTextureClean
         * @type {boolean}
         * @since 3.51.0
         */ this.isTextureClean = false;
                    /**
         * The default scissor, set during `preRender` and modified during `resize`.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#defaultScissor
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.defaultScissor = [
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Has this renderer fully booted yet?
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#isBooted
         * @type {boolean}
         * @since 3.50.0
         */ this.isBooted = false;
                    /**
         * A Render Target you can use to capture the current state of the Renderer.
         *
         * A Render Target encapsulates a framebuffer and texture for the WebGL Renderer.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#renderTarget
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.renderTarget = null;
                    /**
         * The global game Projection matrix, used by shaders as 'uProjectionMatrix' uniform.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionMatrix
         * @type {Phaser.Math.Matrix4}
         * @since 3.50.0
         */ this.projectionMatrix;
                    /**
         * The cached width of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionWidth
         * @type {number}
         * @since 3.50.0
         */ this.projectionWidth = 0;
                    /**
         * The cached height of the Projection matrix.
         *
         * @name Phaser.Renderer.WebGL.WebGLRenderer#projectionHeight
         * @type {number}
         * @since 3.50.0
         */ this.projectionHeight = 0;
                    this.init(this.config);
                },
                /**
     * Creates a new WebGLRenderingContext and initializes all internal state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#init
     * @since 3.0.0
     *
     * @param {object} config - The configuration object for the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ init: function(config) {
                    var gl;
                    var game = this.game;
                    var canvas = this.canvas;
                    var clearColor = config.backgroundColor;
                    //  Did they provide their own context?
                    if (game.config.context) gl = game.config.context;
                    else gl = canvas.getContext('webgl', config.contextCreation) || canvas.getContext('experimental-webgl', config.contextCreation);
                    if (!gl || gl.isContextLost()) {
                        this.contextLost = true;
                        throw new Error('WebGL unsupported');
                    }
                    this.gl = gl;
                    var _this = this;
                    this.contextLostHandler = function(event) {
                        _this.contextLost = true;
                        _this.game.events.emit(GameEvents.CONTEXT_LOST, _this);
                        event.preventDefault();
                    };
                    this.contextRestoredHandler = function() {
                        _this.contextLost = false;
                        _this.init(_this.config);
                        _this.game.events.emit(GameEvents.CONTEXT_RESTORED, _this);
                    };
                    canvas.addEventListener('webglcontextlost', this.contextLostHandler, false);
                    canvas.addEventListener('webglcontextrestored', this.contextRestoredHandler, false);
                    //  Set it back into the Game, so developers can access it from there too
                    game.context = gl;
                    for(var i = 0; i <= 27; i++)this.blendModes.push({
                        func: [
                            gl.ONE,
                            gl.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: gl.FUNC_ADD
                    });
                    //  ADD
                    this.blendModes[1].func = [
                        gl.ONE,
                        gl.DST_ALPHA
                    ];
                    //  MULTIPLY
                    this.blendModes[2].func = [
                        gl.DST_COLOR,
                        gl.ONE_MINUS_SRC_ALPHA
                    ];
                    //  SCREEN
                    this.blendModes[3].func = [
                        gl.ONE,
                        gl.ONE_MINUS_SRC_COLOR
                    ];
                    //  ERASE
                    this.blendModes[17] = {
                        func: [
                            gl.ZERO,
                            gl.ONE_MINUS_SRC_ALPHA
                        ],
                        equation: gl.FUNC_REVERSE_SUBTRACT
                    };
                    this.glFormats[0] = gl.BYTE;
                    this.glFormats[1] = gl.SHORT;
                    this.glFormats[2] = gl.UNSIGNED_BYTE;
                    this.glFormats[3] = gl.UNSIGNED_SHORT;
                    this.glFormats[4] = gl.FLOAT;
                    //  Set the gl function map
                    this.glFuncMap = {
                        mat2: {
                            func: gl.uniformMatrix2fv,
                            length: 1,
                            matrix: true
                        },
                        mat3: {
                            func: gl.uniformMatrix3fv,
                            length: 1,
                            matrix: true
                        },
                        mat4: {
                            func: gl.uniformMatrix4fv,
                            length: 1,
                            matrix: true
                        },
                        '1f': {
                            func: gl.uniform1f,
                            length: 1
                        },
                        '1fv': {
                            func: gl.uniform1fv,
                            length: 1
                        },
                        '1i': {
                            func: gl.uniform1i,
                            length: 1
                        },
                        '1iv': {
                            func: gl.uniform1iv,
                            length: 1
                        },
                        '2f': {
                            func: gl.uniform2f,
                            length: 2
                        },
                        '2fv': {
                            func: gl.uniform2fv,
                            length: 1
                        },
                        '2i': {
                            func: gl.uniform2i,
                            length: 2
                        },
                        '2iv': {
                            func: gl.uniform2iv,
                            length: 1
                        },
                        '3f': {
                            func: gl.uniform3f,
                            length: 3
                        },
                        '3fv': {
                            func: gl.uniform3fv,
                            length: 1
                        },
                        '3i': {
                            func: gl.uniform3i,
                            length: 3
                        },
                        '3iv': {
                            func: gl.uniform3iv,
                            length: 1
                        },
                        '4f': {
                            func: gl.uniform4f,
                            length: 4
                        },
                        '4fv': {
                            func: gl.uniform4fv,
                            length: 1
                        },
                        '4i': {
                            func: gl.uniform4i,
                            length: 4
                        },
                        '4iv': {
                            func: gl.uniform4iv,
                            length: 1
                        }
                    };
                    //  Load supported extensions
                    var exts = gl.getSupportedExtensions();
                    if (!config.maxTextures || config.maxTextures === -1) config.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
                    if (!config.maxTextureSize) config.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                    var extString = 'WEBGL_compressed_texture_';
                    var wkExtString = 'WEBKIT_' + extString;
                    this.compression.ETC1 = gl.getExtension(extString + 'etc1') || gl.getExtension(wkExtString + 'etc1');
                    this.compression.PVRTC = gl.getExtension(extString + 'pvrtc') || gl.getExtension(wkExtString + 'pvrtc');
                    this.compression.S3TC = gl.getExtension(extString + 's3tc') || gl.getExtension(wkExtString + 's3tc');
                    this.supportedExtensions = exts;
                    var angleString = 'ANGLE_instanced_arrays';
                    this.instancedArraysExtension = exts.indexOf(angleString) > -1 ? gl.getExtension(angleString) : null;
                    var vaoString = 'OES_vertex_array_object';
                    this.vaoExtension = exts.indexOf(vaoString) > -1 ? gl.getExtension(vaoString) : null;
                    //  Setup initial WebGL state
                    gl.disable(gl.DEPTH_TEST);
                    gl.disable(gl.CULL_FACE);
                    gl.enable(gl.BLEND);
                    gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                    //  Mipmaps
                    this.mipmapFilter = gl[config.mipmapFilter];
                    //  Check maximum supported textures
                    this.maxTextures = Utils.checkShaderMax(gl, config.maxTextures);
                    this.textureIndexes = [];
                    //  Create temporary WebGL textures
                    var tempTextures = this.tempTextures;
                    if (Array.isArray(tempTextures)) for(var t = 0; i < this.maxTextures; t++)gl.deleteTexture(tempTextures[t]);
                    else tempTextures = new Array(this.maxTextures);
                    //  Create temp textures to stop WebGL errors on mac os
                    for(var index = 0; index < this.maxTextures; index++){
                        var tempTexture = gl.createTexture();
                        gl.activeTexture(gl.TEXTURE0 + index);
                        gl.bindTexture(gl.TEXTURE_2D, tempTexture);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([
                            0,
                            0,
                            255,
                            255
                        ]));
                        tempTextures[index] = tempTexture;
                        this.textureIndexes.push(index);
                    }
                    this.tempTextures = tempTextures;
                    //  Reset to texture 1 (texture zero is reserved for framebuffers)
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    gl.activeTexture(gl.TEXTURE1);
                    this.pipelines = new PipelineManager(this);
                    this.setBlendMode(CONST.BlendModes.NORMAL);
                    this.projectionMatrix = new Matrix4().identity();
                    game.textures.once(TextureEvents.READY, this.boot, this);
                    return this;
                },
                /**
     * Internal boot handler. Calls 'boot' on each pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#boot
     * @private
     * @since 3.11.0
     */ boot: function() {
                    var game = this.game;
                    var pipelineManager = this.pipelines;
                    var baseSize = game.scale.baseSize;
                    this.width = baseSize.width;
                    this.height = baseSize.height;
                    this.isBooted = true;
                    this.renderTarget = new RenderTarget(this, this.width, this.height, 1, 0, true, true);
                    //  Set-up pipelines
                    pipelineManager.boot(game.config.pipeline);
                    //  Set-up default textures, fbo and scissor
                    this.blankTexture = game.textures.getFrame('__DEFAULT');
                    this.whiteTexture = game.textures.getFrame('__WHITE');
                    var gl = this.gl;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.enable(gl.SCISSOR_TEST);
                    game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.resize(baseSize.width, baseSize.height);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#onResize
     * @since 3.16.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize) {
                    //  Has the underlying canvas size changed?
                    if (baseSize.width !== this.width || baseSize.height !== this.height) this.resize(baseSize.width, baseSize.height);
                },
                /**
     * Binds the WebGL Renderers Render Target, so all drawn content is now redirected to it.
     *
     * Make sure to call `endCapture` when you are finished.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#beginCapture
     * @since 3.50.0
     *
     * @param {number} [width] - Optional new width of the Render Target.
     * @param {number} [height] - Optional new height of the Render Target.
     */ beginCapture: function(width, height) {
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    this.renderTarget.bind(true, width, height);
                    this.setProjectionMatrix(width, height);
                    this.resetTextures();
                },
                /**
     * Unbinds the WebGL Renderers Render Target and returns it, stopping any further content being drawn to it.
     *
     * If the viewport or scissors were modified during the capture, you should reset them by calling
     * `resetViewport` and `resetScissor` accordingly.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#endCapture
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.RenderTarget} A reference to the WebGL Renderer Render Target.
     */ endCapture: function() {
                    this.renderTarget.unbind(true);
                    this.resetProjectionMatrix();
                    return this.renderTarget;
                },
                /**
     * Resizes the drawing buffer to match that required by the Scale Manager.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resize
     * @fires Phaser.Renderer.Events#RESIZE
     * @since 3.0.0
     *
     * @param {number} [width] - The new width of the renderer.
     * @param {number} [height] - The new height of the renderer.
     *
     * @return {this} This WebGLRenderer instance.
     */ resize: function(width, height) {
                    var gl = this.gl;
                    this.width = width;
                    this.height = height;
                    this.setProjectionMatrix(width, height);
                    gl.viewport(0, 0, width, height);
                    this.drawingBufferHeight = gl.drawingBufferHeight;
                    gl.scissor(0, gl.drawingBufferHeight - height, width, height);
                    this.defaultScissor[2] = width;
                    this.defaultScissor[3] = height;
                    this.emit(Events.RESIZE, width, height);
                    return this;
                },
                /**
     * Gets the aspect ratio of the WebGLRenderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getAspectRatio
     * @since 3.50.0
     *
     * @return {number} The aspect ratio of the WebGLRenderer dimensions.
     */ getAspectRatio: function() {
                    return this.width / this.height;
                },
                /**
     * Sets the Projection Matrix of this renderer to the given dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProjectionMatrix
     * @since 3.50.0
     *
     * @param {number} width - The new width of the Projection Matrix.
     * @param {number} height - The new height of the Projection Matrix.
     *
     * @return {this} This WebGLRenderer instance.
     */ setProjectionMatrix: function(width, height) {
                    if (width !== this.projectionWidth || height !== this.projectionHeight) {
                        this.projectionWidth = width;
                        this.projectionHeight = height;
                        this.projectionMatrix.ortho(0, width, height, 0, -1000, 1000);
                    }
                    return this;
                },
                /**
     * Resets the Projection Matrix back to this renderers width and height.
     *
     * This is called during `endCapture`, should the matrix have been changed
     * as a result of the capture process.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProjectionMatrix
     * @since 3.50.0
     */ resetProjectionMatrix: function() {
                    this.projectionWidth = this.width;
                    this.projectionHeight = this.height;
                    this.projectionMatrix.ortho(0, this.width, this.height, 0, -1000, 1000);
                },
                /**
     * Checks if a WebGL extension is supported
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - Name of the WebGL extension
     *
     * @return {boolean} `true` if the extension is supported, otherwise `false`.
     */ hasExtension: function(extensionName) {
                    return this.supportedExtensions ? this.supportedExtensions.indexOf(extensionName) : false;
                },
                /**
     * Loads a WebGL extension
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getExtension
     * @since 3.0.0
     *
     * @param {string} extensionName - The name of the extension to load.
     *
     * @return {object} WebGL extension if the extension is supported
     */ getExtension: function(extensionName) {
                    if (!this.hasExtension(extensionName)) return null;
                    if (!(extensionName in this.extensions)) this.extensions[extensionName] = this.gl.getExtension(extensionName);
                    return this.extensions[extensionName];
                },
                /**
     * Flushes the current pipeline if the pipeline is bound
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#flush
     * @since 3.0.0
     */ flush: function() {
                    this.pipelines.flush();
                },
                /**
     * Pushes a new scissor state. This is used to set nested scissor states.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     *
     * @return {number[]} An array containing the scissor values.
     */ pushScissor: function(x, y, width, height, drawingBufferHeight) {
                    if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                    var scissorStack = this.scissorStack;
                    var scissor = [
                        x,
                        y,
                        width,
                        height
                    ];
                    scissorStack.push(scissor);
                    this.setScissor(x, y, width, height, drawingBufferHeight);
                    this.currentScissor = scissor;
                    return scissor;
                },
                /**
     * Sets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setScissor
     * @since 3.0.0
     *
     * @param {number} x - The x position of the scissor.
     * @param {number} y - The y position of the scissor.
     * @param {number} width - The width of the scissor.
     * @param {number} height - The height of the scissor.
     * @param {number} [drawingBufferHeight] - Optional drawingBufferHeight override value.
     */ setScissor: function(x, y, width, height, drawingBufferHeight) {
                    if (drawingBufferHeight === undefined) drawingBufferHeight = this.drawingBufferHeight;
                    var gl = this.gl;
                    var current = this.currentScissor;
                    var setScissor = width > 0 && height > 0;
                    if (current && setScissor) {
                        var cx = current[0];
                        var cy = current[1];
                        var cw = current[2];
                        var ch = current[3];
                        setScissor = cx !== x || cy !== y || cw !== width || ch !== height;
                    }
                    if (setScissor) {
                        this.flush();
                        // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/scissor
                        gl.scissor(x, drawingBufferHeight - y - height, width, height);
                    }
                },
                /**
     * Resets the gl scissor state to be whatever the current scissor is, if there is one, without
     * modifying the scissor stack.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetScissor
     * @since 3.50.0
     */ resetScissor: function() {
                    var gl = this.gl;
                    gl.enable(gl.SCISSOR_TEST);
                    var current = this.currentScissor;
                    if (current) {
                        var x = current[0];
                        var y = current[1];
                        var width = current[2];
                        var height = current[3];
                        if (width > 0 && height > 0) gl.scissor(x, this.drawingBufferHeight - y - height, width, height);
                    }
                },
                /**
     * Pops the last scissor state and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popScissor
     * @since 3.0.0
     */ popScissor: function() {
                    var scissorStack = this.scissorStack;
                    //  Remove the current scissor
                    scissorStack.pop();
                    //  Reset the previous scissor
                    var scissor = scissorStack[scissorStack.length - 1];
                    if (scissor) this.setScissor(scissor[0], scissor[1], scissor[2], scissor[3]);
                    this.currentScissor = scissor;
                },
                /**
     * Is there an active stencil mask?
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasActiveStencilMask
     * @since 3.17.0
     *
     * @return {boolean} `true` if there is an active stencil mask, otherwise `false`.
     */ hasActiveStencilMask: function() {
                    var mask = this.currentMask.mask;
                    var camMask = this.currentCameraMask.mask;
                    return mask && mask.isStencil || camMask && camMask.isStencil;
                },
                /**
     * Resets the gl viewport to the current renderer dimensions.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetViewport
     * @since 3.50.0
     */ resetViewport: function() {
                    var gl = this.gl;
                    gl.viewport(0, 0, this.width, this.height);
                    this.drawingBufferHeight = gl.drawingBufferHeight;
                },
                /**
     * Sets the blend mode to the value given.
     *
     * If the current blend mode is different from the one given, the pipeline is flushed and the new
     * blend mode is enabled.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlendMode
     * @since 3.0.0
     *
     * @param {number} blendModeId - The blend mode to be set. Can be a `BlendModes` const or an integer value.
     * @param {boolean} [force=false] - Force the blend mode to be set, regardless of the currently set blend mode.
     *
     * @return {boolean} `true` if the blend mode was changed as a result of this call, forcing a flush, otherwise `false`.
     */ setBlendMode: function(blendModeId, force) {
                    if (force === undefined) force = false;
                    var gl = this.gl;
                    var blendMode = this.blendModes[blendModeId];
                    if (force || blendModeId !== CONST.BlendModes.SKIP_CHECK && this.currentBlendMode !== blendModeId) {
                        this.flush();
                        gl.enable(gl.BLEND);
                        gl.blendEquation(blendMode.equation);
                        if (blendMode.func.length > 2) gl.blendFuncSeparate(blendMode.func[0], blendMode.func[1], blendMode.func[2], blendMode.func[3]);
                        else gl.blendFunc(blendMode.func[0], blendMode.func[1]);
                        this.currentBlendMode = blendModeId;
                        return true;
                    }
                    return false;
                },
                /**
     * Creates a new custom blend mode for the renderer.
     *
     * See https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants#Blending_modes
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#addBlendMode
     * @since 3.0.0
     *
     * @param {GLenum[]} func - An array containing the WebGL functions to use for the source and the destination blending factors, respectively. See the possible constants for {@link WebGLRenderingContext#blendFunc()}.
     * @param {GLenum} equation - The equation to use for combining the RGB and alpha components of a new pixel with a rendered one. See the possible constants for {@link WebGLRenderingContext#blendEquation()}.
     *
     * @return {number} The index of the new blend mode, used for referencing it in the future.
     */ addBlendMode: function(func, equation) {
                    var index = this.blendModes.push({
                        func: func,
                        equation: equation
                    });
                    return index - 1;
                },
                /**
     * Updates the function bound to a given custom blend mode.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode.
     * @param {function} func - The function to use for the blend mode.
     * @param {function} equation - The equation to use for the blend mode.
     *
     * @return {this} This WebGLRenderer instance.
     */ updateBlendMode: function(index, func, equation) {
                    if (this.blendModes[index]) {
                        this.blendModes[index].func = func;
                        if (equation) this.blendModes[index].equation = equation;
                    }
                    return this;
                },
                /**
     * Removes a custom blend mode from the renderer.
     * Any Game Objects still using this blend mode will error, so be sure to clear them first.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#removeBlendMode
     * @since 3.0.0
     *
     * @param {number} index - The index of the custom blend mode to be removed.
     *
     * @return {this} This WebGLRenderer instance.
     */ removeBlendMode: function(index) {
                    if (index > 17 && this.blendModes[index]) this.blendModes.splice(index, 1);
                    return this;
                },
                /**
     * Sets the current active texture for texture unit zero to be a blank texture.
     * This only happens if there isn't a texture already in use by texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlankTexture
     * @private
     * @since 3.12.0
     */ setBlankTexture: function() {
                    this.setTexture2D(this.blankTexture.glTexture);
                },
                /**
     * Activates the Texture Source and assigns it the next available texture unit.
     * If none are available, it will flush the current pipeline first.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureSource
     * @since 3.50.0
     *
     * @param {Phaser.Textures.TextureSource} textureSource - The Texture Source to be assigned the texture unit.
     *
     * @return {number} The texture unit that was assigned to the Texture Source.
     */ setTextureSource: function(textureSource) {
                    if (this.pipelines.forceZero()) {
                        this.setTextureZero(textureSource.glTexture, true);
                        return 0;
                    }
                    var gl = this.gl;
                    var currentActiveTexture = this.currentActiveTexture;
                    if (textureSource.glIndexCounter < this.startActiveTexture) {
                        textureSource.glIndexCounter = this.startActiveTexture;
                        if (currentActiveTexture < this.maxTextures) {
                            textureSource.glIndex = currentActiveTexture;
                            gl.activeTexture(gl.TEXTURE0 + currentActiveTexture);
                            gl.bindTexture(gl.TEXTURE_2D, textureSource.glTexture);
                            this.currentActiveTexture++;
                        } else {
                            //  We're out of textures, so flush the batch and reset back to 0
                            this.flush();
                            this.startActiveTexture++;
                            this.textureFlush++;
                            textureSource.glIndexCounter = this.startActiveTexture;
                            textureSource.glIndex = 1;
                            gl.activeTexture(gl.TEXTURE1);
                            gl.bindTexture(gl.TEXTURE_2D, textureSource.glTexture);
                            this.currentActiveTexture = 2;
                        }
                    }
                    this.isTextureClean = false;
                    return textureSource.glIndex;
                },
                /**
     * Checks to see if the given diffuse and normal map textures are already bound, or not.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#isNewNormalMap
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL diffuse texture.
     * @param {WebGLTexture} normalMap - The WebGL normal map texture.
     *
     * @return {boolean} Returns `false` if this combination is already set, or `true` if it's a new combination.
     */ isNewNormalMap: function(texture, normalMap) {
                    return this.textureZero !== texture || this.normalTexture !== normalMap;
                },
                /**
     * Binds a texture directly to texture unit zero then activates it.
     * If the texture is already at unit zero, it skips the bind.
     * Make sure to call `clearTextureZero` after using this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureZero
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     * @param {boolean} [flush=false] - Flush the pipeline if the texture is different?
     */ setTextureZero: function(texture, flush) {
                    if (this.textureZero !== texture) {
                        if (flush) this.flush();
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        this.textureZero = texture;
                    }
                },
                /**
     * Clears the texture that was directly bound to texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#clearTextureZero
     * @since 3.50.0
     */ clearTextureZero: function() {
                    this.textureZero = null;
                },
                /**
     * Binds a texture directly to texture unit one then activates it.
     * If the texture is already at unit one, it skips the bind.
     * Make sure to call `clearNormalMap` after using this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setNormalMap
     * @since 3.50.0
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     */ setNormalMap: function(texture) {
                    if (this.normalTexture !== texture) {
                        var gl = this.gl;
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        this.normalTexture = texture;
                        if (this.currentActiveTexture === 1) this.currentActiveTexture = 2;
                    }
                },
                /**
     * Clears the texture that was directly bound to texture unit one and
     * increases the start active texture counter.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#clearNormalMap
     * @since 3.50.0
     */ clearNormalMap: function() {
                    this.normalTexture = null;
                    this.startActiveTexture++;
                    this.currentActiveTexture = 1;
                    this.textureFlush++;
                },
                /**
     * Activates each texture, in turn, then binds them all to `null`.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#unbindTextures
     * @since 3.50.0
     *
     * @param {boolean} [all=false] - Reset all textures, or just the first two?
     */ unbindTextures: function() {
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    for(var i = 0; i < temp.length; i++){
                        gl.activeTexture(gl.TEXTURE0 + i);
                        gl.bindTexture(gl.TEXTURE_2D, null);
                    }
                    this.normalTexture = null;
                    this.textureZero = null;
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    this.textureFlush++;
                },
                /**
     * Flushes the current pipeline, then resets the first two textures
     * back to the default temporary textures, resets the start active
     * counter and sets texture unit 1 as being active.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetTextures
     * @since 3.50.0
     *
     * @param {boolean} [all=false] - Reset all textures, or just the first two?
     */ resetTextures: function(all) {
                    if (all === undefined) all = false;
                    if (this.isTextureClean) //  No need to do this if the textures are already clean
                    return;
                    this.flush();
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    if (all) {
                        for(var i = 0; i < temp.length; i++){
                            gl.activeTexture(gl.TEXTURE0 + i);
                            gl.bindTexture(gl.TEXTURE_2D, temp[i]);
                        }
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, temp[1]);
                        this.isTextureClean = true;
                    } else {
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, temp[0]);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, temp[1]);
                    }
                    this.normalTexture = null;
                    this.textureZero = null;
                    this.currentActiveTexture = 1;
                    this.startActiveTexture++;
                    this.textureFlush++;
                },
                /**
     * Binds a texture at a texture unit. If a texture is already
     * bound to that unit it will force a flush on the current pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTexture2D
     * @since 3.0.0
     * @version 2.0 - Updated in 3.50.0 to remove the `textureUnit` and `flush` parameters.
     *
     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound.
     *
     * @return {number} The texture unit that was assigned to the Texture Source.
     */ setTexture2D: function(texture) {
                    if (this.pipelines.forceZero()) {
                        this.setTextureZero(texture, true);
                        return 0;
                    }
                    var gl = this.gl;
                    var currentActiveTexture = this.currentActiveTexture;
                    if (texture.glIndexCounter < this.startActiveTexture) {
                        texture.glIndexCounter = this.startActiveTexture;
                        if (currentActiveTexture < this.maxTextures) {
                            texture.glIndex = currentActiveTexture;
                            gl.activeTexture(gl.TEXTURE0 + currentActiveTexture);
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            this.currentActiveTexture++;
                        } else {
                            //  We're out of textures, so flush the batch and reset back to 1 (0 is reserved for fbos)
                            this.flush();
                            this.startActiveTexture++;
                            this.textureFlush++;
                            texture.glIndexCounter = this.startActiveTexture;
                            texture.glIndex = 1;
                            gl.activeTexture(gl.TEXTURE1);
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            this.currentActiveTexture = 2;
                        }
                    }
                    this.isTextureClean = false;
                    return texture.glIndex;
                },
                /**
     * Pushes a new framebuffer onto the FBO stack and makes it the currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Call `popFramebuffer` to remove it again.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushFramebuffer
     * @since 3.50.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer that needs to be bound.
     * @param {boolean} [updateScissor=false] - Set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {this} This WebGLRenderer instance.
     */ pushFramebuffer: function(framebuffer, updateScissor, resetTextures, setViewport) {
                    if (framebuffer === this.currentFramebuffer) return this;
                    this.fboStack.push(framebuffer);
                    return this.setFramebuffer(framebuffer, updateScissor, resetTextures, setViewport);
                },
                /**
     * Sets the given framebuffer as the active and currently bound framebuffer.
     *
     * If there was another framebuffer already bound it will force a pipeline flush.
     *
     * Typically, you should call `pushFramebuffer` instead of this method.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFramebuffer
     * @since 3.0.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer that needs to be bound.
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {this} This WebGLRenderer instance.
     */ setFramebuffer: function(framebuffer, updateScissor, resetTextures, setViewport) {
                    if (updateScissor === undefined) updateScissor = false;
                    if (resetTextures === undefined) resetTextures = false;
                    if (setViewport === undefined) setViewport = true;
                    if (framebuffer === this.currentFramebuffer) return this;
                    var gl = this.gl;
                    var width = this.width;
                    var height = this.height;
                    if (framebuffer && framebuffer.renderTexture && setViewport) {
                        width = framebuffer.renderTexture.width;
                        height = framebuffer.renderTexture.height;
                    } else this.flush();
                    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                    if (setViewport) gl.viewport(0, 0, width, height);
                    if (updateScissor) {
                        if (framebuffer) {
                            this.drawingBufferHeight = height;
                            this.pushScissor(0, 0, width, height);
                        } else {
                            this.drawingBufferHeight = this.height;
                            this.popScissor();
                        }
                    }
                    this.currentFramebuffer = framebuffer;
                    if (resetTextures) this.resetTextures();
                    return this;
                },
                /**
     * Pops the previous framebuffer from the fbo stack and sets it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#popFramebuffer
     * @since 3.50.0
     *
     * @param {boolean} [updateScissor=false] - If a framebuffer is given, set the gl scissor to match the frame buffer size? Or, if `null` given, pop the scissor from the stack.
     * @param {boolean} [resetTextures=false] - Should the WebGL Textures be reset after the new framebuffer is bound?
     * @param {boolean} [setViewport=true] - Should the WebGL viewport be set?
     *
     * @return {WebGLFramebuffer} The Framebuffer that was set, or `null` if there aren't any more in the stack.
     */ popFramebuffer: function(updateScissor, resetTextures, setViewport) {
                    if (updateScissor === undefined) updateScissor = false;
                    if (resetTextures === undefined) resetTextures = false;
                    if (setViewport === undefined) setViewport = true;
                    var fboStack = this.fboStack;
                    //  Remove the current fbo
                    fboStack.pop();
                    //  Reset the previous framebuffer
                    var framebuffer = fboStack[fboStack.length - 1];
                    if (!framebuffer) framebuffer = null;
                    this.setFramebuffer(framebuffer, updateScissor, resetTextures, setViewport);
                    return framebuffer;
                },
                /**
     * Binds a shader program.
     *
     * If there was a different program already bound it will force a pipeline flush first.
     *
     * If the same program given to this method is already set as the current program, no change
     * will take place and this method will return `false`.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProgram
     * @since 3.0.0
     *
     * @param {WebGLProgram} program - The program that needs to be bound.
     *
     * @return {boolean} `true` if the given program was bound, otherwise `false`.
     */ setProgram: function(program) {
                    if (program !== this.currentProgram) {
                        this.flush();
                        this.gl.useProgram(program);
                        this.currentProgram = program;
                        return true;
                    }
                    return false;
                },
                /**
     * Rebinds whatever program `WebGLRenderer.currentProgram` is set as, without
     * changing anything, or flushing.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#resetProgram
     * @since 3.50.0
     *
     * @return {this} This WebGLRenderer instance.
     */ resetProgram: function() {
                    this.gl.useProgram(this.currentProgram);
                    return this;
                },
                /**
     * Creates a texture from an image source. If the source is not valid it creates an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTextureFromSource
     * @since 3.0.0
     *
     * @param {object} source - The source of the texture.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} scaleMode - The scale mode to be used by the texture.
     *
     * @return {?WebGLTexture} The WebGL Texture that was created, or `null` if it couldn't be created.
     */ createTextureFromSource: function(source, width, height, scaleMode) {
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var wrap = gl.CLAMP_TO_EDGE;
                    var texture = null;
                    width = source ? source.width : width;
                    height = source ? source.height : height;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (pow) wrap = gl.REPEAT;
                    if (scaleMode === CONST.ScaleModes.LINEAR && this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    if (!source && typeof width === 'number' && typeof height === 'number') texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, null, width, height);
                    else texture = this.createTexture2D(0, minFilter, magFilter, wrap, wrap, gl.RGBA, source);
                    return texture;
                },
                /**
     * A wrapper for creating a WebGLTexture. If no pixel data is passed it will create an empty texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTexture2D
     * @since 3.0.0
     *
     * @param {number} mipLevel - Mip level of the texture.
     * @param {number} minFilter - Filtering of the texture.
     * @param {number} magFilter - Filtering of the texture.
     * @param {number} wrapT - Wrapping mode of the texture.
     * @param {number} wrapS - Wrapping mode of the texture.
     * @param {number} format - Which format does the texture use.
     * @param {?object} pixels - pixel data.
     * @param {number} width - Width of the texture in pixels.
     * @param {number} height - Height of the texture in pixels.
     * @param {boolean} [pma=true] - Does the texture have premultiplied alpha?
     * @param {boolean} [forceSize=false] - If `true` it will use the width and height passed to this method, regardless of the pixels dimension.
     * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
     *
     * @return {WebGLTexture} The WebGLTexture that was created.
     */ createTexture2D: function(mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma, forceSize, flipY) {
                    pma = pma === undefined || pma === null ? true : pma;
                    if (forceSize === undefined) forceSize = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var texture = gl.createTexture();
                    gl.activeTexture(gl.TEXTURE0);
                    var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
                    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, pma);
                    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                    if (pixels === null || pixels === undefined) gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, width, height, 0, format, gl.UNSIGNED_BYTE, null);
                    else {
                        if (!forceSize) {
                            width = pixels.width;
                            height = pixels.height;
                        }
                        gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, format, gl.UNSIGNED_BYTE, pixels);
                    }
                    if (IsSizePowerOfTwo(width, height)) gl.generateMipmap(gl.TEXTURE_2D);
                    if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    texture.isAlphaPremultiplied = pma;
                    texture.isRenderTexture = false;
                    texture.width = width;
                    texture.height = height;
                    texture.glIndex = 0;
                    texture.glIndexCounter = -1;
                    return texture;
                },
                /**
     * Creates a WebGL Framebuffer object and optionally binds a depth stencil render buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createFramebuffer
     * @since 3.0.0
     *
     * @param {number} width - If `addDepthStencilBuffer` is true, this controls the width of the depth stencil.
     * @param {number} height - If `addDepthStencilBuffer` is true, this controls the height of the depth stencil.
     * @param {WebGLTexture} renderTexture - The color texture where the color pixels are written.
     * @param {boolean} [addDepthStencilBuffer=false] - Create a Renderbuffer for the depth stencil?
     *
     * @return {WebGLFramebuffer} Raw WebGLFramebuffer
     */ createFramebuffer: function(width, height, renderTexture, addDepthStencilBuffer) {
                    var gl = this.gl;
                    var framebuffer = gl.createFramebuffer();
                    var complete = 0;
                    this.setFramebuffer(framebuffer);
                    if (addDepthStencilBuffer) {
                        var depthStencilBuffer = gl.createRenderbuffer();
                        gl.bindRenderbuffer(gl.RENDERBUFFER, depthStencilBuffer);
                        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, depthStencilBuffer);
                    }
                    renderTexture.isRenderTexture = true;
                    renderTexture.isAlphaPremultiplied = false;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, renderTexture, 0);
                    complete = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
                    if (complete !== gl.FRAMEBUFFER_COMPLETE) {
                        var errors = {
                            36054: 'Incomplete Attachment',
                            36055: 'Missing Attachment',
                            36057: 'Incomplete Dimensions',
                            36061: 'Framebuffer Unsupported'
                        };
                        throw new Error('Framebuffer status: ' + errors[complete]);
                    }
                    framebuffer.renderTexture = renderTexture;
                    this.setFramebuffer(null);
                    this.resetTextures();
                    return framebuffer;
                },
                /**
     * Creates a WebGLProgram instance based on the given vertex and fragment shader source.
     *
     * Then compiles, attaches and links the program before returning it.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createProgram
     * @since 3.0.0
     *
     * @param {string} vertexShader - The vertex shader source code as a single string.
     * @param {string} fragmentShader - The fragment shader source code as a single string.
     *
     * @return {WebGLProgram} The linked WebGLProgram created from the given shader source.
     */ createProgram: function(vertexShader, fragmentShader) {
                    var gl = this.gl;
                    var program = gl.createProgram();
                    var vs = gl.createShader(gl.VERTEX_SHADER);
                    var fs = gl.createShader(gl.FRAGMENT_SHADER);
                    gl.shaderSource(vs, vertexShader);
                    gl.shaderSource(fs, fragmentShader);
                    gl.compileShader(vs);
                    gl.compileShader(fs);
                    if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) throw new Error('Vertex Shader failed:\n' + gl.getShaderInfoLog(vs));
                    if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) throw new Error('Fragment Shader failed:\n' + gl.getShaderInfoLog(fs));
                    gl.attachShader(program, vs);
                    gl.attachShader(program, fs);
                    gl.linkProgram(program);
                    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Link Program failed:\n' + gl.getProgramInfoLog(program));
                    gl.useProgram(program);
                    return program;
                },
                /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVertexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - It's either ArrayBuffer or an integer indicating the size of the vbo
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW
     *
     * @return {WebGLBuffer} Raw vertex buffer
     */ createVertexBuffer: function(initialDataOrSize, bufferUsage) {
                    var gl = this.gl;
                    var vertexBuffer = gl.createBuffer();
                    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, initialDataOrSize, bufferUsage);
                    gl.bindBuffer(gl.ARRAY_BUFFER, null);
                    return vertexBuffer;
                },
                /**
     * Wrapper for creating a vertex buffer.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createIndexBuffer
     * @since 3.0.0
     *
     * @param {ArrayBuffer} initialDataOrSize - Either ArrayBuffer or an integer indicating the size of the vbo.
     * @param {number} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW.
     *
     * @return {WebGLBuffer} Raw index buffer
     */ createIndexBuffer: function(initialDataOrSize, bufferUsage) {
                    var gl = this.gl;
                    var indexBuffer = gl.createBuffer();
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
                    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, initialDataOrSize, bufferUsage);
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
                    return indexBuffer;
                },
                /**
     * Calls `GL.deleteTexture` on the given WebGLTexture and also optionally
     * resets the currently defined textures.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteTexture
     * @since 3.0.0
     *
     * @param {WebGLTexture} texture - The WebGL Texture to be deleted.
     * @param {boolean} [reset=false] - Call the `resetTextures` method after deleting this texture?
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteTexture: function(texture, reset) {
                    if (texture) this.gl.deleteTexture(texture);
                    if (reset) this.resetTextures();
                    return this;
                },
                /**
     * Deletes a WebGLFramebuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteFramebuffer
     * @since 3.0.0
     *
     * @param {WebGLFramebuffer} framebuffer - The Framebuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteFramebuffer: function(framebuffer) {
                    if (framebuffer) {
                        this.gl.deleteFramebuffer(framebuffer);
                        ArrayRemove(this.fboStack, framebuffer);
                        if (this.currentFramebuffer === framebuffer) this.currentFramebuffer = null;
                    }
                    return this;
                },
                /**
     * Deletes a WebGLProgram from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteProgram
     * @since 3.0.0
     *
     * @param {WebGLProgram} program - The shader program to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteProgram: function(program) {
                    if (program) this.gl.deleteProgram(program);
                    return this;
                },
                /**
     * Deletes a WebGLBuffer from the GL instance.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteBuffer
     * @since 3.0.0
     *
     * @param {WebGLBuffer} vertexBuffer - The WebGLBuffer to be deleted.
     *
     * @return {this} This WebGLRenderer instance.
     */ deleteBuffer: function(buffer) {
                    this.gl.deleteBuffer(buffer);
                    return this;
                },
                /**
     * Controls the pre-render operations for the given camera.
     * Handles any clipping needed by the camera and renders the background color if a color is visible.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to pre-render.
     */ preRenderCamera: function(camera) {
                    var cx = camera.x;
                    var cy = camera.y;
                    var cw = camera.width;
                    var ch = camera.height;
                    var color = camera.backgroundColor;
                    camera.emit(CameraEvents.PRE_RENDER, camera);
                    this.pipelines.preBatchCamera(camera);
                    this.pushScissor(cx, cy, cw, ch);
                    if (camera.mask) {
                        this.currentCameraMask.mask = camera.mask;
                        this.currentCameraMask.camera = camera._maskCamera;
                        camera.mask.preRenderWebGL(this, camera, camera._maskCamera);
                    }
                    if (color.alphaGL > 0) {
                        var pipeline = this.pipelines.setMulti();
                        pipeline.drawFillRect(cx, cy, cw, ch, Utils.getTintFromFloats(color.blueGL, color.greenGL, color.redGL, 1), color.alphaGL);
                    }
                },
                /**
     * Return the current stencil mask.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getCurrentStencilMask
     * @private
     * @since 3.50.0
     */ getCurrentStencilMask: function() {
                    var prev = null;
                    var stack = this.maskStack;
                    var cameraMask = this.currentCameraMask;
                    if (stack.length > 0) prev = stack[stack.length - 1];
                    else if (cameraMask.mask && cameraMask.mask.isStencil) prev = cameraMask;
                    return prev;
                },
                /**
     * Controls the post-render operations for the given camera.
     *
     * Renders the foreground camera effects like flash and fading, then resets the current scissor state.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRenderCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to post-render.
     */ postRenderCamera: function(camera) {
                    var flashEffect = camera.flashEffect;
                    var fadeEffect = camera.fadeEffect;
                    if (flashEffect.isRunning || fadeEffect.isRunning || fadeEffect.isComplete) {
                        var pipeline = this.pipelines.setMulti();
                        flashEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                        fadeEffect.postRenderWebGL(pipeline, Utils.getTintFromFloats);
                    }
                    camera.dirty = false;
                    this.popScissor();
                    if (camera.mask) {
                        this.currentCameraMask.mask = null;
                        camera.mask.postRenderWebGL(this, camera._maskCamera);
                    }
                    this.pipelines.postBatchCamera(camera);
                    camera.emit(CameraEvents.POST_RENDER, camera);
                },
                /**
     * Clears the current vertex buffer and updates pipelines.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRender
     * @fires Phaser.Renderer.Events#PRE_RENDER
     * @since 3.0.0
     */ preRender: function() {
                    if (this.contextLost) return;
                    var gl = this.gl;
                    //  Make sure we are bound to the main frame buffer
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    if (this.config.clearBeforeRender) {
                        var clearColor = this.config.backgroundColor;
                        gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, clearColor.alphaGL);
                        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                    }
                    gl.enable(gl.SCISSOR_TEST);
                    this.currentScissor = this.defaultScissor;
                    this.scissorStack.length = 0;
                    this.scissorStack.push(this.currentScissor);
                    if (this.game.scene.customViewports) gl.scissor(0, this.drawingBufferHeight - this.height, this.width, this.height);
                    this.currentMask.mask = null;
                    this.currentCameraMask.mask = null;
                    this.maskStack.length = 0;
                    this.textureFlush = 0;
                    this.emit(Events.PRE_RENDER);
                },
                /**
     * The core render step for a Scene Camera.
     *
     * Iterates through the given array of Game Objects and renders them with the given Camera.
     *
     * This is called by the `CameraManager.render` method. The Camera Manager instance belongs to a Scene, and is invoked
     * by the Scene Systems.render method.
     *
     * This method is not called if `Camera.visible` is `false`, or `Camera.alpha` is zero.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#render
     * @fires Phaser.Renderer.Events#RENDER
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to render.
     * @param {Phaser.GameObjects.GameObject[]} children - An array of filtered Game Objects that can be rendered by the given Camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera to render with.
     */ render: function(scene, children, camera) {
                    if (this.contextLost) return;
                    var childCount = children.length;
                    this.emit(Events.RENDER, scene, camera);
                    //   Apply scissor for cam region + render background color, if not transparent
                    this.preRenderCamera(camera);
                    //  Nothing to render, so bail out
                    if (childCount === 0) {
                        this.setBlendMode(CONST.BlendModes.NORMAL);
                        //  Applies camera effects and pops the scissor, if set
                        this.postRenderCamera(camera);
                        return;
                    }
                    //  Reset the current type
                    this.currentType = '';
                    var current = this.currentMask;
                    for(var i = 0; i < childCount; i++){
                        this.finalType = i === childCount - 1;
                        var child = children[i];
                        var mask = child.mask;
                        current = this.currentMask;
                        if (current.mask && current.mask !== mask) //  Render out the previously set mask
                        current.mask.postRenderWebGL(this, current.camera);
                        if (mask && current.mask !== mask) mask.preRenderWebGL(this, child, camera);
                        if (child.blendMode !== this.currentBlendMode) this.setBlendMode(child.blendMode);
                        var type = child.type;
                        if (type !== this.currentType) {
                            this.newType = true;
                            this.currentType = type;
                        }
                        if (!this.finalType) this.nextTypeMatch = children[i + 1].type === this.currentType;
                        else this.nextTypeMatch = false;
                        child.renderWebGL(this, child, camera);
                        this.newType = false;
                    }
                    current = this.currentMask;
                    if (current.mask) //  Render out the previously set mask, if it was the last item in the display list
                    current.mask.postRenderWebGL(this, current.camera);
                    this.setBlendMode(CONST.BlendModes.NORMAL);
                    //  Applies camera effects and pops the scissor, if set
                    this.postRenderCamera(camera);
                },
                /**
     * The post-render step happens after all Cameras in all Scenes have been rendered.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRender
     * @fires Phaser.Renderer.Events#POST_RENDER
     * @since 3.0.0
     */ postRender: function() {
                    if (this.contextLost) return;
                    this.flush();
                    this.emit(Events.POST_RENDER);
                    var state = this.snapshotState;
                    if (state.callback) {
                        WebGLSnapshot(this.canvas, state);
                        state.callback = null;
                    }
                    if (this.textureFlush > 0) {
                        this.startActiveTexture++;
                        this.currentActiveTexture = 1;
                    }
                },
                /**
     * Schedules a snapshot of the entire game viewport to be taken after the current frame is rendered.
     *
     * To capture a specific area see the `snapshotArea` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshot
     * @since 3.0.0
     *
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshot: function(callback, type, encoderOptions) {
                    return this.snapshotArea(0, 0, this.gl.drawingBufferWidth, this.gl.drawingBufferHeight, callback, type, encoderOptions);
                },
                /**
     * Schedules a snapshot of the given area of the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific pixel, see `snapshotPixel`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotPixel`, for example, then
     * calling this method will override it.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotArea
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate to grab from.
     * @param {number} y - The y coordinate to grab from.
     * @param {number} width - The width of the area to grab.
     * @param {number} height - The height of the area to grab.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotArea: function(x, y, width, height, callback, type, encoderOptions) {
                    var state = this.snapshotState;
                    state.callback = callback;
                    state.type = type;
                    state.encoder = encoderOptions;
                    state.getPixel = false;
                    state.x = x;
                    state.y = y;
                    state.width = Math.min(width, this.gl.drawingBufferWidth);
                    state.height = Math.min(height, this.gl.drawingBufferHeight);
                    return this;
                },
                /**
     * Schedules a snapshot of the given pixel from the game viewport to be taken after the current frame is rendered.
     *
     * To capture the whole game viewport see the `snapshot` method. To capture a specific area, see `snapshotArea`.
     *
     * Only one snapshot can be active _per frame_. If you have already called `snapshotArea`, for example, then
     * calling this method will override it.
     *
     * Unlike the other two snapshot methods, this one will return a `Color` object containing the color data for
     * the requested pixel. It doesn't need to create an internal Canvas or Image object, so is a lot faster to execute,
     * using less memory.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get.
     * @param {number} y - The y coordinate of the pixel to get.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot pixel data is extracted.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotPixel: function(x, y, callback) {
                    this.snapshotArea(x, y, 1, 1, callback);
                    this.snapshotState.getPixel = true;
                    return this;
                },
                /**
     * Takes a snapshot of the given area of the given frame buffer.
     *
     * Unlike the other snapshot methods, this one is processed immediately and doesn't wait for the next render.
     *
     * Snapshots work by using the WebGL `readPixels` feature to grab every pixel from the frame buffer into an ArrayBufferView.
     * It then parses this, copying the contents to a temporary Canvas and finally creating an Image object from it,
     * which is the image returned to the callback provided. All in all, this is a computationally expensive and blocking process,
     * which gets more expensive the larger the canvas size gets, so please be careful how you employ this in your game.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshotFramebuffer
     * @since 3.19.0
     *
     * @param {WebGLFramebuffer} framebuffer - The framebuffer to grab from.
     * @param {number} bufferWidth - The width of the framebuffer.
     * @param {number} bufferHeight - The height of the framebuffer.
     * @param {Phaser.Types.Renderer.Snapshot.SnapshotCallback} callback - The Function to invoke after the snapshot image is created.
     * @param {boolean} [getPixel=false] - Grab a single pixel as a Color object, or an area as an Image object?
     * @param {number} [x=0] - The x coordinate to grab from.
     * @param {number} [y=0] - The y coordinate to grab from.
     * @param {number} [width=bufferWidth] - The width of the area to grab.
     * @param {number} [height=bufferHeight] - The height of the area to grab.
     * @param {string} [type='image/png'] - The format of the image to create, usually `image/png` or `image/jpeg`.
     * @param {number} [encoderOptions=0.92] - The image quality, between 0 and 1. Used for image formats with lossy compression, such as `image/jpeg`.
     *
     * @return {this} This WebGL Renderer.
     */ snapshotFramebuffer: function(framebuffer, bufferWidth, bufferHeight, callback, getPixel, x, y, width, height, type, encoderOptions) {
                    if (getPixel === undefined) getPixel = false;
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = bufferWidth;
                    if (height === undefined) height = bufferHeight;
                    var currentFramebuffer = this.currentFramebuffer;
                    this.snapshotArea(x, y, width, height, callback, type, encoderOptions);
                    var state = this.snapshotState;
                    state.getPixel = getPixel;
                    state.isFramebuffer = true;
                    state.bufferWidth = bufferWidth;
                    state.bufferHeight = bufferHeight;
                    this.setFramebuffer(framebuffer);
                    WebGLSnapshot(this.canvas, state);
                    this.setFramebuffer(currentFramebuffer);
                    state.callback = null;
                    state.isFramebuffer = false;
                    return this;
                },
                /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * If the `dstTexture` parameter is given, the WebGL Texture is updated, rather than created fresh.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#canvasToTexture
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from
     * @param {WebGLTexture} [dstTexture] - The destination WebGL Texture to set.
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created, or updated, WebGL Texture.
     */ canvasToTexture: function(srcCanvas, dstTexture, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    if (!dstTexture) return this.createCanvasTexture(srcCanvas, noRepeat, flipY);
                    else return this.updateCanvasTexture(srcCanvas, dstTexture, flipY);
                },
                /**
     * Creates a new WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to create the WebGL Texture from
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT` (such as for Text objects?)
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created WebGL Texture.
     */ createCanvasTexture: function(srcCanvas, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var width = srcCanvas.width;
                    var height = srcCanvas.height;
                    var wrapping = gl.CLAMP_TO_EDGE;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (!noRepeat && pow) wrapping = gl.REPEAT;
                    if (this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcCanvas, width, height, true, false, flipY);
                },
                /**
     * Updates a WebGL Texture based on the given Canvas Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateCanvasTexture
     * @since 3.20.0
     *
     * @param {HTMLCanvasElement} srcCanvas - The Canvas to update the WebGL Texture from.
     * @param {WebGLTexture} dstTexture - The destination WebGL Texture to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The updated WebGL Texture.
     */ updateCanvasTexture: function(srcCanvas, dstTexture, flipY) {
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var width = srcCanvas.width;
                    var height = srcCanvas.height;
                    if (width > 0 && height > 0) {
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, dstTexture);
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcCanvas);
                        dstTexture.width = width;
                        dstTexture.height = height;
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    }
                    return dstTexture;
                },
                /**
     * Creates a new WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to create the WebGL Texture from
     * @param {boolean} [noRepeat=false] - Should this canvas be allowed to set `REPEAT`?
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The newly created WebGL Texture.
     */ createVideoTexture: function(srcVideo, noRepeat, flipY) {
                    if (noRepeat === undefined) noRepeat = false;
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var minFilter = gl.NEAREST;
                    var magFilter = gl.NEAREST;
                    var width = srcVideo.videoWidth;
                    var height = srcVideo.videoHeight;
                    var wrapping = gl.CLAMP_TO_EDGE;
                    var pow = IsSizePowerOfTwo(width, height);
                    if (!noRepeat && pow) wrapping = gl.REPEAT;
                    if (this.config.antialias) {
                        minFilter = pow ? this.mipmapFilter : gl.LINEAR;
                        magFilter = gl.LINEAR;
                    }
                    return this.createTexture2D(0, minFilter, magFilter, wrapping, wrapping, gl.RGBA, srcVideo, width, height, true, true, flipY);
                },
                /**
     * Updates a WebGL Texture based on the given HTML Video Element.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateVideoTexture
     * @since 3.20.0
     *
     * @param {HTMLVideoElement} srcVideo - The Video to update the WebGL Texture with.
     * @param {WebGLTexture} dstTexture - The destination WebGL Texture to update.
     * @param {boolean} [flipY=false] - Should the WebGL Texture set `UNPACK_MULTIPLY_FLIP_Y`?
     *
     * @return {WebGLTexture} The updated WebGL Texture.
     */ updateVideoTexture: function(srcVideo, dstTexture, flipY) {
                    if (flipY === undefined) flipY = false;
                    var gl = this.gl;
                    var width = srcVideo.videoWidth;
                    var height = srcVideo.videoHeight;
                    if (width > 0 && height > 0) {
                        gl.activeTexture(gl.TEXTURE0);
                        var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                        gl.bindTexture(gl.TEXTURE_2D, dstTexture);
                        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcVideo);
                        dstTexture.width = width;
                        dstTexture.height = height;
                        if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    }
                    return dstTexture;
                },
                /**
     * Sets the minification and magnification filter for a texture.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureFilter
     * @since 3.0.0
     *
     * @param {number} texture - The texture to set the filter for.
     * @param {number} filter - The filter to set. 0 for linear filtering, 1 for nearest neighbor (blocky) filtering.
     *
     * @return {this} This WebGL Renderer instance.
     */ setTextureFilter: function(texture, filter) {
                    var gl = this.gl;
                    var glFilter = [
                        gl.LINEAR,
                        gl.NEAREST
                    ][filter];
                    gl.activeTexture(gl.TEXTURE0);
                    var currentTexture = gl.getParameter(gl.TEXTURE_BINDING_2D);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, glFilter);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, glFilter);
                    if (currentTexture) gl.bindTexture(gl.TEXTURE_2D, currentTexture);
                    return this;
                },
                /**
     * Returns the largest texture size (either width or height) that can be created.
     * Note that VRAM may not allow a texture of any given size, it just expresses
     * hardware / driver support for a given size.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#getMaxTextureSize
     * @since 3.8.0
     *
     * @return {number} The maximum supported texture size.
     */ getMaxTextureSize: function() {
                    return this.config.maxTextureSize;
                },
                /**
     * Destroy this WebGLRenderer, cleaning up all related resources such as pipelines, native textures, etc.
     *
     * @method Phaser.Renderer.WebGL.WebGLRenderer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.canvas.removeEventListener('webglcontextlost', this.contextLostHandler, false);
                    this.canvas.removeEventListener('webglcontextrestored', this.contextRestoredHandler, false);
                    var gl = this.gl;
                    var temp = this.tempTextures;
                    for(var i = 0; i < temp.length; i++)gl.deleteTexture(temp[i]);
                    this.pipelines.destroy();
                    this.removeAllListeners();
                    this.fboStack = [];
                    this.maskStack = [];
                    this.extensions = {};
                    this.textureIndexes = [];
                    this.gl = null;
                    this.game = null;
                    this.canvas = null;
                    this.contextLost = true;
                    this.currentMask = null;
                    this.currentCameraMask = null;
                }
            });
            module1.exports = WebGLRenderer;
        /***/ },
        /* 366 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(65);
            var CustomMap = __webpack_require__(99);
            //  Default Phaser 3 Pipelines
            var BitmapMaskPipeline = __webpack_require__(367);
            var GraphicsPipeline = __webpack_require__(370);
            var LightPipeline = __webpack_require__(371);
            var MultiPipeline = __webpack_require__(105);
            var PointLightPipeline = __webpack_require__(372);
            var RopePipeline = __webpack_require__(373);
            var SinglePipeline = __webpack_require__(374);
            var UtilityPipeline = __webpack_require__(375);
            /**
 * @classdesc
 * The Pipeline Manager is responsible for the creation, activation, running and destruction
 * of WebGL Pipelines and Post FX Pipelines in Phaser 3.
 *
 * The `WebGLRenderer` owns a single instance of the Pipeline Manager, which you can access
 * via the `WebGLRenderer.pipelines` property.
 *
 * By default, there are 8 pipelines installed into the Pipeline Manager when Phaser boots:
 *
 * 1. The Multi Pipeline. Responsible for all multi-texture rendering, i.e. Sprites and Tilemaps.
 * 2. The Graphics Pipeline. Responsible for rendering Graphics and Shape objects.
 * 3. The Rope Pipeline. Responsible for rendering the Rope Game Object.
 * 4. The Light Pipeline. Responsible for rendering the Light Game Object.
 * 5. The Point Light Pipeline. Responsible for rendering the Point Light Game Object.
 * 6. The Single Pipeline. Responsible for rendering Game Objects that explicitly require one bound texture.
 * 7. The Bitmap Mask Pipeline. Responsible for Bitmap Mask rendering.
 * 8. The Utility Pipeline. Responsible for providing lots of handy texture manipulation functions.
 *
 * You can add your own custom pipeline via the `PipelineManager.add` method. Pipelines are
 * identified by unique string-based keys.
 *
 * @class PipelineManager
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the WebGL Renderer that owns this Pipeline Manager.
 */ var PipelineManager = new Class({
                initialize: function PipelineManager(renderer) {
                    /**
         * A reference to the Game instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#game
         * @type {Phaser.Game}
         * @since 3.50.0
         */ this.game = renderer.game;
                    /**
         * A reference to the WebGL Renderer instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = renderer;
                    /**
         * This map stores all pipeline classes available in this manager.
         *
         * The Utility Class must always come first.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#classes
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.classes = new CustomMap([
                        [
                            CONST.UTILITY_PIPELINE,
                            UtilityPipeline
                        ],
                        [
                            CONST.MULTI_PIPELINE,
                            MultiPipeline
                        ],
                        [
                            CONST.BITMAPMASK_PIPELINE,
                            BitmapMaskPipeline
                        ],
                        [
                            CONST.SINGLE_PIPELINE,
                            SinglePipeline
                        ],
                        [
                            CONST.ROPE_PIPELINE,
                            RopePipeline
                        ],
                        [
                            CONST.LIGHT_PIPELINE,
                            LightPipeline
                        ],
                        [
                            CONST.POINTLIGHT_PIPELINE,
                            PointLightPipeline
                        ],
                        [
                            CONST.GRAPHICS_PIPELINE,
                            GraphicsPipeline
                        ]
                    ]);
                    /**
         * This map stores all Post FX Pipeline classes available in this manager.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#postPipelineClasses
         * @type {Phaser.Structs.Map.<string, Class>}
         * @since 3.50.0
         */ this.postPipelineClasses = new CustomMap();
                    /**
         * This map stores all pipeline instances in this manager.
         *
         * This is populated with the default pipelines in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#pipelines
         * @type {Phaser.Structs.Map.<string, Phaser.Renderer.WebGL.WebGLPipeline>}
         * @since 3.50.0
         */ this.pipelines = new CustomMap();
                    /**
         * Current pipeline in use by the WebGLRenderer.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#current
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.current = null;
                    /**
         * The previous WebGLPipeline that was in use.
         *
         * This is set when `clearPipeline` is called and restored in `rebindPipeline` if none is given.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#previous
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @default null
         * @since 3.50.0
         */ this.previous = null;
                    /**
         * A constant-style reference to the Multi Pipeline Instance.
         *
         * This is the default Phaser 3 pipeline and is used by the WebGL Renderer to manage
         * camera effects and more. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#MULTI_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.MultiPipeline}
         * @default null
         * @since 3.50.0
         */ this.MULTI_PIPELINE = null;
                    /**
         * A constant-style reference to the Bitmap Mask Pipeline Instance.
         *
         * This is the default Phaser 3 mask pipeline and is used Game Objects using
         * a Bitmap Mask. This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#BITMAPMASK_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline}
         * @default null
         * @since 3.50.0
         */ this.BITMAPMASK_PIPELINE = null;
                    /**
         * A constant-style reference to the Utility Pipeline Instance.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#UTILITY_PIPELINE
         * @type {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline}
         * @default null
         * @since 3.50.0
         */ this.UTILITY_PIPELINE = null;
                    /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.PipelineManager#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                },
                /**
     * Internal boot handler, called by the WebGLRenderer durings its boot process.
     *
     * Adds all of the default pipelines, based on the game config, and then calls
     * the `boot` method on each one of them.
     *
     * Finally, the default pipeline is set.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#boot
     * @since 3.50.0
     *
     * @param {Phaser.Types.Core.PipelineConfig} [pipelineConfig] - The pipeline configuration object as set in the Game Config.
     */ boot: function(pipelineConfig) {
                    //  Install each of the default pipelines
                    var instance;
                    var pipelineName;
                    var _this = this;
                    var game = this.game;
                    this.classes.each(function(pipelineName, pipeline) {
                        instance = _this.add(pipelineName, new pipeline({
                            game: game
                        }));
                        if (pipelineName === CONST.UTILITY_PIPELINE) {
                            _this.UTILITY_PIPELINE = instance;
                            //  FBO references
                            _this.fullFrame1 = instance.fullFrame1;
                            _this.fullFrame2 = instance.fullFrame2;
                            _this.halfFrame1 = instance.halfFrame1;
                            _this.halfFrame2 = instance.halfFrame2;
                        }
                    });
                    //  Our const-like references
                    this.MULTI_PIPELINE = this.get(CONST.MULTI_PIPELINE);
                    this.BITMAPMASK_PIPELINE = this.get(CONST.BITMAPMASK_PIPELINE);
                    //  And now the ones in the config, if any
                    if (pipelineConfig) for(pipelineName in pipelineConfig){
                        var pipelineClass = pipelineConfig[pipelineName];
                        instance = new pipelineClass(game);
                        if (instance.isPostFX) this.postPipelineClasses.set(pipelineName, pipelineClass);
                        else if (!this.has(pipelineName)) {
                            this.classes.set(pipelineName, pipelineClass);
                            this.add(pipelineName, instance);
                        }
                    }
                },
                /**
     * Adds a pipeline instance to this Pipeline Manager.
     *
     * The name of the instance must be unique within this manager.
     *
     * Make sure to pass an instance to this method, not a base class.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.add('yourName', new CustomPipeline());`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.add('yourName', CustomPipeline);`
     * ```
     *
     * To add a **Post Pipeline**, see `addPostPipeline` instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#add
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - A pipeline _instance_ which must extend `WebGLPipeline`.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance that was passed.
     */ add: function(name, pipeline) {
                    if (pipeline.isPostFX) {
                        console.warn(name + ' is a Post Pipeline. Use `addPostPipeline` instead');
                        return;
                    }
                    var pipelines = this.pipelines;
                    var renderer = this.renderer;
                    if (!pipelines.has(name)) {
                        pipeline.name = name;
                        pipeline.manager = this;
                        pipelines.set(name, pipeline);
                    } else console.warn('Pipeline exists: ' + name);
                    if (!pipeline.hasBooted) pipeline.boot();
                    if (renderer.width !== 0 && renderer.height !== 0) pipeline.resize(renderer.width, renderer.height);
                    return pipeline;
                },
                /**
     * Adds a Post Pipeline to this Pipeline Manager.
     *
     * Make sure to pass a base class to this method, not an instance.
     *
     * For example, you should pass it like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', CustomPipeline);`
     * ```
     *
     * and **not** like this:
     *
     * ```javascript
     * this.addPostPipeline('yourName', new CustomPipeline());`
     * ```
     *
     * To add a regular pipeline, see the `add` method instead.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#addPostPipeline
     * @since 3.50.0
     *
     * @param {string} name - A unique string-based key for the pipeline within the manager.
     * @param {function} pipeline - A pipeline class which must extend `PostFXPipeline`.
     *
     * @return {this} This Pipeline Manager.
     */ addPostPipeline: function(name, pipeline) {
                    if (!this.postPipelineClasses.has(name)) this.postPipelineClasses.set(name, pipeline);
                },
                /**
     * Flushes the current pipeline, if one is bound.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#flush
     * @since 3.50.0
     */ flush: function() {
                    if (this.current) this.current.flush();
                },
                /**
     * Checks if a pipeline is present in this Pipeline Manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#has
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {boolean} `true` if the given pipeline is loaded, otherwise `false`.
     */ has: function(pipeline) {
                    var pipelines = this.pipelines;
                    if (typeof pipeline === 'string') return pipelines.has(pipeline);
                    else if (pipelines.contains(pipeline)) return true;
                    return false;
                },
                /**
     * Returns the pipeline instance based on the given name, or instance.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#get
     * @since 3.50.0
     *
     * @param {(string|Phaser.Renderer.WebGL.WebGLPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance to look-up.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline instance, or `undefined` if not found.
     */ get: function(pipeline) {
                    var pipelines = this.pipelines;
                    if (typeof pipeline === 'string') return pipelines.get(pipeline);
                    else if (pipelines.contains(pipeline)) return pipeline;
                },
                /**
     * Returns a _new instance_ of the post pipeline based on the given name, or class.
     *
     * If no instance, or matching name, exists in this manager, it returns `undefined`.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#getPostPipeline
     * @since 3.50.0
     *
     * @param {(string|function|Phaser.Renderer.WebGL.Pipelines.PostFXPipeline)} pipeline - Either the string-based name of the pipeline to get, or a pipeline instance, or class to look-up.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - If this post pipeline is being installed into a Game Object or Camera, this is a reference to it.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.PostFXPipeline} The pipeline instance, or `undefined` if not found.
     */ getPostPipeline: function(pipeline, gameObject) {
                    var pipelineClasses = this.postPipelineClasses;
                    var instance;
                    if (typeof pipeline === 'string') instance = pipelineClasses.get(pipeline);
                    else if (typeof pipeline === 'function') //  A class
                    {
                        if (pipelineClasses.contains(pipeline)) instance = pipeline;
                    } else if (typeof pipeline === 'object') //  Instance
                    instance = pipelineClasses.get(pipeline.name);
                    if (instance) {
                        var newPipeline = new instance(this.game);
                        if (gameObject) newPipeline.gameObject = gameObject;
                        return newPipeline;
                    }
                },
                /**
     * Removes a pipeline instance based on the given name.
     *
     * If no pipeline matches the name, this method does nothing.
     *
     * Note that the pipeline will not be flushed or destroyed, it's simply removed from
     * this manager.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#remove
     * @since 3.50.0
     *
     * @param {string} name - The name of the pipeline to be removed.
     * @param {boolean} [removeClass=true] - Remove the pipeline class as well as the instance?
     * @param {boolean} [removePostPipelineClass=true] - Remove the post pipeline class as well as the instance?
     */ remove: function(name, removeClass, removePostPipelineClass) {
                    if (removeClass === undefined) removeClass = true;
                    if (removePostPipelineClass === undefined) removePostPipelineClass = true;
                    this.pipelines.delete(name);
                    if (removeClass) this.classes.delete(name);
                    if (removePostPipelineClass) this.postPipelineClasses.delete(name);
                },
                /**
     * Sets the current pipeline to be used by the `WebGLRenderer`.
     *
     * This method accepts a pipeline instance as its parameter, not the name.
     *
     * If the pipeline isn't already the current one it will call `WebGLPipeline.bind` and then `onBind`.
     *
     * You cannot set Post FX Pipelines using this method. To use a Post FX Pipeline, you should
     * apply it to either a Camera, Container or other supporting Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#set
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be set as current.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object that invoked this pipeline, if any.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The pipeline that was set, or undefined if it couldn't be set.
     */ set: function(pipeline, gameObject, currentShader) {
                    if (pipeline.isPostFX) return;
                    if (!this.isCurrent(pipeline, currentShader)) {
                        this.flush();
                        if (this.current) this.current.unbind();
                        this.current = pipeline;
                        pipeline.bind(currentShader);
                    }
                    pipeline.updateProjectionMatrix();
                    pipeline.onBind(gameObject);
                    return pipeline;
                },
                /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right before a quad
     * belonging to a Game Object is about to be added to the batch. It causes a batch
     * flush, then calls the `preBatch` method on the post-fx pipelines belonging to the
     * Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object about to be batched.
     */ preBatch: function(gameObject) {
                    if (gameObject.hasPostPipeline) {
                        this.flush();
                        var pipelines = gameObject.postPipelines;
                        //  Iterate in reverse because we need them stacked in the order they're in the array
                        for(var i = pipelines.length - 1; i >= 0; i--){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.preBatch(gameObject);
                        }
                    }
                },
                /**
     * This method is called by the `WebGLPipeline.batchQuad` method, right after a quad
     * belonging to a Game Object has been added to the batch. It causes a batch
     * flush, then calls the `postBatch` method on the post-fx pipelines belonging to the
     * Game Object.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatch
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to the batch.
     */ postBatch: function(gameObject) {
                    if (gameObject.hasPostPipeline) {
                        this.flush();
                        var pipelines = gameObject.postPipelines;
                        for(var i = 0; i < pipelines.length; i++){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.postBatch(gameObject);
                        }
                    }
                },
                /**
     * Called at the start of the `WebGLRenderer.preRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `preBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#preBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera about to be rendered.
     */ preBatchCamera: function(camera) {
                    if (camera.hasPostPipeline) {
                        this.flush();
                        var pipelines = camera.postPipelines;
                        //  Iterate in reverse because we need them stacked in the order they're in the array
                        for(var i = pipelines.length - 1; i >= 0; i--){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.preBatch(camera);
                        }
                    }
                },
                /**
     * Called at the end of the `WebGLRenderer.postRenderCamera` method.
     *
     * If the Camera has post pipelines set, it will flush the batch and then call the
     * `postBatch` method on the post-fx pipelines belonging to the Camera.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#postBatchCamera
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that was just rendered.
     */ postBatchCamera: function(camera) {
                    if (camera.hasPostPipeline) {
                        this.flush();
                        var pipelines = camera.postPipelines;
                        for(var i = 0; i < pipelines.length; i++){
                            var pipeline = pipelines[i];
                            if (pipeline.active) pipeline.postBatch(camera);
                        }
                    }
                },
                /**
     * Checks to see if the given pipeline is already the active pipeline, both within this
     * Pipeline Manager and also has the same shader set in the Renderer.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#isCurrent
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline instance to be checked.
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {boolean} `true` if the given pipeline is already the current pipeline, otherwise `false`.
     */ isCurrent: function(pipeline, currentShader) {
                    var renderer = this.renderer;
                    var current = this.current;
                    if (current && !currentShader) currentShader = current.currentShader;
                    return !(current !== pipeline || currentShader.program !== renderer.currentProgram);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).copyFrame(source, target, brightness, clear, clearAlpha);
                    return this;
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).copyToGame(source);
                    return this;
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * The copy itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     *
     * @return {this} This Pipeline Manager instance.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                    this.setUtility(this.UTILITY_PIPELINE.colorMatrixShader).drawFrame(source, target, clearAlpha, colorMatrix);
                    return this;
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.linearShader).blendFrames(source1, source2, target, strength, clearAlpha);
                    return this;
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * The draw itself is handled by the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.setUtility(this.UTILITY_PIPELINE.addShader).blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                    return this;
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ clearFrame: function(target, clearAlpha) {
                    this.UTILITY_PIPELINE.clearFrame(target, clearAlpha);
                    return this;
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     *
     * @return {this} This Pipeline Manager instance.
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    this.setUtility(this.UTILITY_PIPELINE.copyShader).blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                    return this;
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     *
     * @return {this} This Pipeline Manager instance.
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    this.UTILITY_PIPELINE.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                    return this;
                },
                /**
     * Returns `true` if the current pipeline is forced to use texture unit zero.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#forceZero
     * @since 3.50.0
     *
     * @return {boolean} `true` if the current pipeline is forced to use texture unit zero.
     */ forceZero: function() {
                    return this.current && this.current.forceZero;
                },
                /**
     * Sets the Multi Pipeline to be the currently bound pipeline.
     *
     * This is the default Phaser 3 rendering pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setMulti
     * @since 3.50.0
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} The Multi Pipeline instance.
     */ setMulti: function() {
                    return this.set(this.MULTI_PIPELINE);
                },
                /**
     * Sets the Utility Pipeline to be the currently bound pipeline.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#setUtility
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to set as being current.
     *
     * @return {Phaser.Renderer.WebGL.Pipelines.UtilityPipeline} The Utility Pipeline instance.
     */ setUtility: function(currentShader) {
                    return this.UTILITY_PIPELINE.bind(currentShader);
                },
                /**
     * Use this to reset the gl context to the state that Phaser requires to continue rendering.
     *
     * Calling this will:
     *
     * * Disable `DEPTH_TEST`, `CULL_FACE` and `STENCIL_TEST`.
     * * Clear the depth buffer and stencil buffers.
     * * Reset the viewport size.
     * * Reset the blend mode.
     * * Bind a blank texture as the active texture on texture unit zero.
     * * Rebinds the given pipeline instance.
     *
     * You should call this if you have previously called `clear`, and then wish to return
     * rendering control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#rebind
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.WebGLPipeline} [pipeline] - The pipeline instance to be rebound. If not given, the previous pipeline will be bound.
     */ rebind: function(pipeline) {
                    if (pipeline === undefined && this.previous) pipeline = this.previous;
                    var renderer = this.renderer;
                    var gl = renderer.gl;
                    gl.disable(gl.DEPTH_TEST);
                    gl.disable(gl.CULL_FACE);
                    if (renderer.hasActiveStencilMask()) gl.clear(gl.DEPTH_BUFFER_BIT);
                    else {
                        //  If there wasn't a stencil mask set before this call, we can disable it safely
                        gl.disable(gl.STENCIL_TEST);
                        gl.clear(gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
                    }
                    gl.viewport(0, 0, renderer.width, renderer.height);
                    renderer.currentProgram = null;
                    renderer.setBlendMode(0, true);
                    if (pipeline) {
                        this.current = pipeline;
                        pipeline.rebind();
                    }
                    renderer.resetTextures();
                },
                /**
     * Flushes the current pipeline being used and then clears it, along with the
     * the current shader program and vertex buffer from the `WebGLRenderer`.
     *
     * Then resets the blend mode to NORMAL.
     *
     * Call this before jumping to your own gl context handler, and then call `rebind` when
     * you wish to return control to Phaser again.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#clear
     * @since 3.50.0
     */ clear: function() {
                    var renderer = this.renderer;
                    this.flush();
                    if (this.current) {
                        this.current.unbind();
                        this.previous = this.current;
                        this.current = null;
                    } else this.previous = null;
                    renderer.currentProgram = null;
                    renderer.setBlendMode(0, true);
                },
                /**
     * Destroy the Pipeline Manager, cleaning up all related resources and references.
     *
     * @method Phaser.Renderer.WebGL.PipelineManager#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.flush();
                    this.classes.clear();
                    this.postPipelineClasses.clear();
                    this.pipelines.clear();
                    this.renderer = null;
                    this.game = null;
                    this.classes = null;
                    this.postPipelineClasses = null;
                    this.pipelines = null;
                    this.current = null;
                    this.previous = null;
                }
            });
            module1.exports = PipelineManager;
        /***/ },
        /* 367 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(862);
            var ShaderSourceVS = __webpack_require__(863);
            var WEBGL_CONST = __webpack_require__(104);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Bitmap Mask Pipeline handles all of the bitmap mask rendering in WebGL for applying
 * alpha masks to Game Objects. It works by sampling two texture on the fragment shader and
 * using the fragments alpha to clip the region.
 *
 * The fragment shader it uses can be found in `shaders/src/BitmapMask.frag`.
 * The vertex shader it uses can be found in `shaders/src/BitmapMask.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uResolution` (vec2)
 * `uMainSampler` (sampler2D)
 * `uMaskSampler` (sampler2D)
 * `uInvertMaskAlpha` (bool)
 *
 * @class BitmapMaskPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var BitmapMaskPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function BitmapMaskPipeline(config) {
                    config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS), config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS), config.batchSize = GetFastValue(config, 'batchSize', 1), config.vertices = GetFastValue(config, 'vertices', [
                        -1,
                        1,
                        -1,
                        -7,
                        7,
                        1
                    ]), config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2,
                            type: WEBGL_CONST.FLOAT
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.set1i('uMainSampler', 0);
                    this.set1i('uMaskSampler', 1);
                },
                resize: function(width, height) {
                    WebGLPipeline.prototype.resize.call(this, width, height);
                    this.set2f('uResolution', width, height);
                },
                /**
     * Binds necessary resources and renders the mask to a separated framebuffer.
     * The framebuffer for the masked object is also bound for further use.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#beginMask
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as mask.
     * @param {Phaser.GameObjects.GameObject} maskedObject - GameObject masked by the mask GameObject.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the current mask.
     */ beginMask: function(mask, maskedObject, camera) {
                    var gl = this.gl;
                    //  The renderable Game Object that is being used for the bitmap mask
                    if (mask.bitmapMask && gl) {
                        var renderer = this.renderer;
                        renderer.flush();
                        renderer.pushFramebuffer(mask.mainFramebuffer);
                        gl.disable(gl.STENCIL_TEST);
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        if (renderer.currentCameraMask.mask !== mask) {
                            renderer.currentMask.mask = mask;
                            renderer.currentMask.camera = camera;
                        }
                    }
                },
                /**
     * The masked game objects framebuffer is unbound and its texture
     * is bound together with the mask texture and the mask shader and
     * a draw call with a single quad is processed. Here is where the
     * masking effect is applied.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#endMask
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as a mask.
     */ endMask: function(mask, camera) {
                    var gl = this.gl;
                    var renderer = this.renderer;
                    //  The renderable Game Object that is being used for the bitmap mask
                    var bitmapMask = mask.bitmapMask;
                    if (bitmapMask && gl) {
                        //  mask.mainFramebuffer should now contain all the Game Objects we want masked
                        renderer.flush();
                        //  Swap to the mask framebuffer (push, in case the bitmapMask GO has a post-pipeline)
                        renderer.pushFramebuffer(mask.maskFramebuffer);
                        //  Clear it and draw the Game Object that is acting as a mask to it
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                        renderer.setBlendMode(0, true);
                        bitmapMask.renderWebGL(renderer, bitmapMask, camera);
                        renderer.flush();
                        //  Clear the mask framebuffer + main framebuffer
                        renderer.popFramebuffer();
                        renderer.popFramebuffer();
                        //  Is there a stencil further up the stack?
                        var prev = renderer.getCurrentStencilMask();
                        if (prev) {
                            gl.enable(gl.STENCIL_TEST);
                            prev.mask.applyStencil(renderer, prev.camera, true);
                        } else renderer.currentMask.mask = null;
                        //  Bind this pipeline and draw
                        renderer.pipelines.set(this);
                        gl.activeTexture(gl.TEXTURE1);
                        gl.bindTexture(gl.TEXTURE_2D, mask.maskTexture);
                        gl.activeTexture(gl.TEXTURE0);
                        gl.bindTexture(gl.TEXTURE_2D, mask.mainTexture);
                        this.set1i('uInvertMaskAlpha', mask.invertAlpha);
                        //  Finally, draw a triangle filling the whole screen
                        gl.drawArrays(this.topology, 0, 3);
                        renderer.resetTextures();
                    }
                }
            });
            module1.exports = BitmapMaskPipeline;
        /***/ },
        /* 368 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.WebGL.Pipelines.Events
 */ module1.exports = {
                AFTER_FLUSH: __webpack_require__(864),
                BEFORE_FLUSH: __webpack_require__(865),
                BIND: __webpack_require__(866),
                BOOT: __webpack_require__(867),
                DESTROY: __webpack_require__(868),
                REBIND: __webpack_require__(869),
                RESIZE: __webpack_require__(870)
            };
        /***/ },
        /* 369 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var WEBGL_CONST = __webpack_require__(104);
            /**
 * @classdesc
 * Instances of the WebGLShader class belong to the WebGL Pipeline classes. When the pipeline is
 * created it will create an instance of this class for each one of its shaders, as defined in
 * the pipeline configuration.
 *
 * This class encapsulates everything needed to manage a shader in a pipeline, including the
 * shader attributes and uniforms, as well as lots of handy methods such as `set2f`, for setting
 * uniform values on this shader.
 *
 * Typically, you do not create an instance of this class directly, as it works in unison with
 * the pipeline to which it belongs. You can gain access to this class via a pipeline's `shaders`
 * array, post-creation.
 *
 * @class WebGLShader
 * @memberof Phaser.Renderer.WebGL
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline to which this Shader belongs.
 * @param {string} name - The name of this Shader.
 * @param {string} vertexShader - The vertex shader source code as a single string.
 * @param {string} fragmentShader - The fragment shader source code as a single string.
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributesConfig[]} attributes - An array of attributes.
 */ var WebGLShader = new Class({
                initialize: function WebGLShader(pipeline, name, vertexShader, fragmentShader, attributes) {
                    /**
         * A reference to the WebGLPipeline that owns this Shader.
         *
         * A Shader class can only belong to a single pipeline.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#pipeline
         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
         * @since 3.50.0
         */ this.pipeline = pipeline;
                    /**
         * The name of this shader.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#name
         * @type {string}
         * @since 3.50.0
         */ this.name = name;
                    /**
         * A reference to the WebGLRenderer instance.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#renderer
         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
         * @since 3.50.0
         */ this.renderer = pipeline.renderer;
                    /**
         * A reference to the WebGL Rendering Context the WebGL Renderer is using.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#gl
         * @type {WebGLRenderingContext}
         * @since 3.50.0
         */ this.gl = this.renderer.gl;
                    /**
         * The WebGLProgram created from the vertex and fragment shaders.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#program
         * @type {WebGLProgram}
         * @since 3.50.0
         */ this.program = this.renderer.createProgram(vertexShader, fragmentShader);
                    /**
         * Array of objects that describe the vertex attributes.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#attributes
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineAttribute[]}
         * @since 3.50.0
         */ this.attributes;
                    /**
         * The amount of vertex attribute components of 32 bit length.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexComponentCount
         * @type {number}
         * @since 3.50.0
         */ this.vertexComponentCount = 0;
                    /**
         * The size, in bytes, of a single vertex.
         *
         * This is derived by adding together all of the vertex attributes.
         *
         * For example, the Multi Pipeline has the following attributes:
         *
         * inPosition - (size 2 x gl.FLOAT) = 8
         * inTexCoord - (size 2 x gl.FLOAT) = 8
         * inTexId - (size 1 x gl.FLOAT) = 4
         * inTintEffect - (size 1 x gl.FLOAT) = 4
         * inTint - (size 4 x gl.UNSIGNED_BYTE) = 4
         *
         * The total, in this case, is 8 + 8 + 4 + 4 + 4 = 28.
         *
         * This is calculated automatically during the `createAttributes` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#vertexSize
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.vertexSize = 0;
                    /**
         * The active uniforms that this shader has.
         *
         * This is an object that maps the uniform names to their WebGL location and cached values.
         *
         * It is populated automatically via the `createUniforms` method.
         *
         * @name Phaser.Renderer.WebGL.WebGLShader#uniforms
         * @type {Phaser.Types.Renderer.WebGL.WebGLPipelineUniformsConfig}
         * @since 3.50.0
         */ this.uniforms = {};
                    this.createAttributes(attributes);
                    this.createUniforms();
                },
                /**
     * Takes the vertex attributes config and parses it, creating the resulting array that is stored
     * in this shaders `attributes` property, calculating the offset, normalization and location
     * in the process.
     *
     * Calling this method resets `WebGLShader.attributes`, `WebGLShader.vertexSize` and
     * `WebGLShader.vertexComponentCount`.
     *
     * It is called automatically when this class is created, but can be called manually if required.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createAttributes
     * @since 3.50.0
     *
     * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineAttributesConfig[]} attributes - An array of attributes configs.
     */ createAttributes: function(attributes) {
                    var count = 0;
                    var offset = 0;
                    var result = [];
                    this.vertexComponentCount = 0;
                    for(var i = 0; i < attributes.length; i++){
                        var element = attributes[i];
                        var name = element.name;
                        var size = GetFastValue(element, 'size', 1); // i.e. 1 for a float, 2 for a vec2, 4 for a vec4, etc
                        var glType = GetFastValue(element, 'type', WEBGL_CONST.FLOAT);
                        var type = glType.enum; // The GLenum
                        var typeSize = glType.size; // The size in bytes of the type
                        var normalized = element.normalized ? true : false;
                        result.push({
                            name: name,
                            size: size,
                            type: type,
                            normalized: normalized,
                            offset: offset,
                            enabled: false,
                            location: -1
                        });
                        if (typeSize === 4) count += size;
                        else count++;
                        offset += size * typeSize;
                    }
                    this.vertexSize = offset;
                    this.vertexComponentCount = count;
                    this.attributes = result;
                },
                /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * This method is called every time the parent pipeline is made the current active pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#bind
     * @since 3.50.0
     *
     * @param {boolean} [setAttributes=false] - Should the vertex attribute pointers be set?
     * @param {boolean} [flush=false] - Flush the pipeline before binding this shader?
     *
     * @return {this} This WebGLShader instance.
     */ bind: function(setAttributes, flush) {
                    if (setAttributes === undefined) setAttributes = false;
                    if (flush === undefined) flush = false;
                    if (flush) this.pipeline.flush();
                    this.renderer.setProgram(this.program);
                    if (setAttributes) this.setAttribPointers();
                    return this;
                },
                /**
     * Sets the program this shader uses as being the active shader in the WebGL Renderer.
     *
     * Then resets all of the attribute pointers.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#rebind
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ rebind: function() {
                    this.renderer.setProgram(this.program);
                    this.setAttribPointers(true);
                    return this;
                },
                /**
     * Sets the vertex attribute pointers.
     *
     * This should only be called after the vertex buffer has been bound.
     *
     * It is called automatically during the `bind` method.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setAttribPointers
     * @since 3.50.0
     *
     * @param {boolean} [reset=false] - Reset the vertex attribute locations?
     *
     * @return {this} This WebGLShader instance.
     */ setAttribPointers: function(reset) {
                    if (reset === undefined) reset = false;
                    var gl = this.gl;
                    var vertexSize = this.vertexSize;
                    var attributes = this.attributes;
                    var program = this.program;
                    for(var i = 0; i < attributes.length; i++){
                        var element = attributes[i];
                        var size = element.size;
                        var type = element.type;
                        var offset = element.offset;
                        var enabled = element.enabled;
                        var location = element.location;
                        var normalized = element.normalized ? true : false;
                        if (reset) {
                            var attribLocation = gl.getAttribLocation(program, element.name);
                            if (attribLocation >= 0) {
                                gl.enableVertexAttribArray(attribLocation);
                                gl.vertexAttribPointer(attribLocation, size, type, normalized, vertexSize, offset);
                                element.enabled = true;
                                element.location = attribLocation;
                            } else if (attribLocation !== -1) gl.disableVertexAttribArray(attribLocation);
                        } else if (enabled) gl.vertexAttribPointer(location, size, type, normalized, vertexSize, offset);
                        else if (!enabled && location > -1) {
                            gl.disableVertexAttribArray(location);
                            element.location = -1;
                        }
                    }
                    return this;
                },
                /**
     * Sets up the `WebGLShader.uniforms` object, populating it with the names
     * and locations of the shader uniforms this shader requires.
     *
     * It works by first calling `gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS)` to
     * find out how many active uniforms this shader has. It then iterates through them,
     * calling `gl.getActiveUniform` to get the WebGL Active Info from each one. Finally,
     * the name and location are stored in the local array.
     *
     * This method is called automatically when this class is created.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#createUniforms
     * @since 3.50.0
     *
     * @return {this} This WebGLShader instance.
     */ createUniforms: function() {
                    var gl = this.gl;
                    var program = this.program;
                    var uniforms = this.uniforms;
                    var i;
                    var name;
                    var location;
                    //  Look-up all active uniforms
                    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
                    for(i = 0; i < totalUniforms; i++){
                        var info = gl.getActiveUniform(program, i);
                        if (info) {
                            name = info.name;
                            location = gl.getUniformLocation(program, name);
                            if (location !== null) uniforms[name] = {
                                name: name,
                                location: location,
                                value1: null,
                                value2: null,
                                value3: null,
                                value4: null
                            };
                            //  If the uniform name contains [] for an array struct,
                            //  we'll add an entry for the non-struct name as well.
                            //  Such as uMainSampler[12] = uMainSampler
                            var struct = name.indexOf('[');
                            if (struct > 0) {
                                name = name.substr(0, struct);
                                if (!uniforms.hasOwnProperty(name)) {
                                    location = gl.getUniformLocation(program, name);
                                    if (location !== null) uniforms[name] = {
                                        name: name,
                                        location: location,
                                        value1: null,
                                        value2: null,
                                        value3: null,
                                        value4: null
                                    };
                                }
                            }
                        }
                    }
                    return this;
                },
                /**
     * Checks to see if the given uniform name exists and is active in this shader.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#hasUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to check for.
     *
     * @return {boolean} `true` if the uniform exists, otherwise `false`.
     */ hasUniform: function(name) {
                    return this.uniforms.hasOwnProperty(name);
                },
                /**
     * Resets the cached values of the given uniform.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#resetUniform
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to reset.
     *
     * @return {this} This WebGLShader instance.
     */ resetUniform: function(name) {
                    var uniform = this.uniforms[name];
                    if (uniform) {
                        uniform.value1 = null;
                        uniform.value2 = null;
                        uniform.value3 = null;
                        uniform.value4 = null;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform1
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setUniform1: function(setter, name, value1) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (uniform.value1 !== value1) {
                        uniform.value1 = value1;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform2
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setUniform2: function(setter, name, value1, value2) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (uniform.value1 !== value1 || uniform.value2 !== value2) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform3
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setUniform3: function(setter, name, value1, value2, value3) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        uniform.value3 = value3;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2, value3);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets the given uniform value/s based on the name and GL function.
     *
     * This method is called internally by other methods such as `set1f` and `set3iv`.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setUniform4
     * @since 3.50.0
     *
     * @param {function} setter - The GL function to call.
     * @param {string} name - The name of the uniform to set.
     * @param {(boolean|number|number[]|Float32Array)} value1 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value2 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value3 - The new value of the uniform.
     * @param {(boolean|number|number[]|Float32Array)} value4 - The new value of the uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setUniform4: function(setter, name, value1, value2, value3, value4) {
                    var uniform = this.uniforms[name];
                    if (!uniform) return this;
                    if (uniform.value1 !== value1 || uniform.value2 !== value2 || uniform.value3 !== value3 || uniform.value4 !== value4) {
                        uniform.value1 = value1;
                        uniform.value2 = value2;
                        uniform.value3 = value3;
                        uniform.value4 = value4;
                        this.renderer.setProgram(this.program);
                        setter.call(this.gl, uniform.location, value1, value2, value3, value4);
                        this.pipeline.currentShader = this;
                    }
                    return this;
                },
                /**
     * Sets a 1f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `float` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1f: function(name, x) {
                    return this.setUniform1(this.gl.uniform1f, name, x);
                },
                /**
     * Sets a 2f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec2` uniform.
     * @param {number} y - The new Y component of the `vec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2f: function(name, x, y) {
                    return this.setUniform2(this.gl.uniform2f, name, x, y);
                },
                /**
     * Sets a 3f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `vec3` uniform.
     * @param {number} y - The new Y component of the `vec3` uniform.
     * @param {number} z - The new Z component of the `vec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3f: function(name, x, y, z) {
                    return this.setUniform3(this.gl.uniform3f, name, x, y, z);
                },
                /**
     * Sets a 4f uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4f
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4f: function(name, x, y, z, w) {
                    return this.setUniform4(this.gl.uniform4f, name, x, y, z, w);
                },
                /**
     * Sets a 1fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform1fv, name, arr);
                },
                /**
     * Sets a 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform2fv, name, arr);
                },
                /**
     * Sets a 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform3fv, name, arr);
                },
                /**
     * Sets a 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4fv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform4fv, name, arr);
                },
                /**
     * Sets a 1iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set1iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform1iv, name, arr);
                },
                /**
     * Sets a 2iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set2iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform2iv, name, arr);
                },
                /**
     * Sets a 3iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set3iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform3iv, name, arr);
                },
                /**
     * Sets a 4iv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4iv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number[]|Float32Array} arr - The new value to be used for the uniform variable.
     *
     * @return {this} This WebGLShader instance.
     */ set4iv: function(name, arr) {
                    return this.setUniform1(this.gl.uniform4iv, name, arr);
                },
                /**
     * Sets a 1i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set1i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new value of the `int` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set1i: function(name, x) {
                    return this.setUniform1(this.gl.uniform1i, name, x);
                },
                /**
     * Sets a 2i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set2i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec2` uniform.
     * @param {number} y - The new Y component of the `ivec2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set2i: function(name, x, y) {
                    return this.setUniform2(this.gl.uniform2i, name, x, y);
                },
                /**
     * Sets a 3i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set3i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - The new X component of the `ivec3` uniform.
     * @param {number} y - The new Y component of the `ivec3` uniform.
     * @param {number} z - The new Z component of the `ivec3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ set3i: function(name, x, y, z) {
                    return this.setUniform3(this.gl.uniform3i, name, x, y, z);
                },
                /**
     * Sets a 4i uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#set4i
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {number} x - X component of the uniform
     * @param {number} y - Y component of the uniform
     * @param {number} z - Z component of the uniform
     * @param {number} w - W component of the uniform
     *
     * @return {this} This WebGLShader instance.
     */ set4i: function(name, x, y, z, w) {
                    return this.setUniform4(this.gl.uniform4i, name, x, y, z, w);
                },
                /**
     * Sets a matrix 2fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix2fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {number[]|Float32Array} matrix - The new values for the `mat2` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix2fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix2fv, name, transpose, matrix);
                },
                /**
     * Sets a matrix 3fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix3fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Whether to transpose the matrix. Should be `false`.
     * @param {Float32Array} matrix - The new values for the `mat3` uniform.
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix3fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix3fv, name, transpose, matrix);
                },
                /**
     * Sets a matrix 4fv uniform value based on the given name on this shader.
     *
     * The uniform is only set if the value/s given are different to those previously set.
     *
     * This method works by first setting this shader as being the current shader within the
     * WebGL Renderer, if it isn't already. It also sets this shader as being the current
     * one within the pipeline it belongs to.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#setMatrix4fv
     * @since 3.50.0
     *
     * @param {string} name - The name of the uniform to set.
     * @param {boolean} transpose - Should the matrix be transpose
     * @param {Float32Array} matrix - Matrix data
     *
     * @return {this} This WebGLShader instance.
     */ setMatrix4fv: function(name, transpose, matrix) {
                    return this.setUniform2(this.gl.uniformMatrix4fv, name, transpose, matrix);
                },
                /**
     * Removes all external references from this class and deletes the WebGL program from the WebGL context.
     *
     * Does not remove this shader from the parent pipeline.
     *
     * @method Phaser.Renderer.WebGL.WebGLShader#destroy
     * @since 3.50.0
     */ destroy: function() {
                    this.gl.deleteProgram(this.program);
                    this.pipeline = null;
                    this.renderer = null;
                    this.gl = null;
                    this.program = null;
                    this.attributes = null;
                    this.uniforms = null;
                }
            });
            module1.exports = WebGLShader;
        /***/ },
        /* 370 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(68);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(871);
            var ShaderSourceVS = __webpack_require__(872);
            var TransformMatrix = __webpack_require__(25);
            var WEBGL_CONST = __webpack_require__(104);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Graphics Pipeline is the rendering pipeline used by Phaser in WebGL when drawing
 * primitive geometry objects, such as the Graphics Game Object, or the Shape Game Objects
 * such as Arc, Line, Rectangle and Star. It handles the preperation and batching of related vertices.
 *
 * Prior to Phaser v3.50 the functions of this pipeline were merged with the `TextureTintPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Graphics.frag`.
 * The vertex shader it uses can be found in `shaders/src/Graphics.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2)
 * `inColor` (vec4, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 *
 * @class GraphicsPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var GraphicsPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function GraphicsPipeline(config) {
                    config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS);
                    config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                    config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2
                        },
                        {
                            name: 'inColor',
                            size: 4,
                            type: WEBGL_CONST.UNSIGNED_BYTE,
                            normalized: true
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                    /**
         * A temporary Transform Matrix, re-used internally during batching by the
         * Shape Game Objects.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#calcMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @since 3.50.0
         */ this.calcMatrix = new TransformMatrix();
                    /**
         * Used internally to draw stroked triangles.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#tempTriangle
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.tempTriangle = [
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        },
                        {
                            x: 0,
                            y: 0,
                            width: 0
                        }
                    ];
                    /**
         * Cached stroke tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#strokeTint
         * @type {object}
         * @private
         * @since 3.50.0
         */ this.strokeTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Cached fill tint.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#fillTint
         * @type {object}
         * @private
         * @since 3.50.0
         */ this.fillTint = {
                        TL: 0,
                        TR: 0,
                        BL: 0,
                        BR: 0
                    };
                    /**
         * Internal texture frame reference.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#currentFrame
         * @type {Phaser.Textures.Frame}
         * @private
         * @since 3.50.0
         */ this.currentFrame = {
                        u0: 0,
                        v0: 0,
                        u1: 1,
                        v1: 1
                    };
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#firstQuad
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.firstQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Internal path quad cache.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#prevQuad
         * @type {number[]}
         * @private
         * @since 3.50.0
         */ this.prevQuad = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    /**
         * Used internally for triangulating a polygon.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#polygonCache
         * @type {array}
         * @private
         * @since 3.50.0
         */ this.polygonCache = [];
                },
                /**
     * Pushes a filled rectangle into the vertex batch.
     *
     * Rectangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillRect
     * @since 3.50.0
     *
     * @param {number} x - Horizontal top left coordinate of the rectangle.
     * @param {number} y - Vertical top left coordinate of the rectangle.
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillRect: function(x, y, width, height, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var xw = x + width;
                    var yh = y + height;
                    var x0 = calcMatrix.getX(x, y);
                    var y0 = calcMatrix.getY(x, y);
                    var x1 = calcMatrix.getX(x, yh);
                    var y1 = calcMatrix.getY(x, yh);
                    var x2 = calcMatrix.getX(xw, yh);
                    var y2 = calcMatrix.getY(xw, yh);
                    var x3 = calcMatrix.getX(xw, y);
                    var y3 = calcMatrix.getY(xw, y);
                    var tint = this.fillTint;
                    this.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint.TL, tint.TR, tint.BL, tint.BR);
                },
                /**
     * Pushes a filled triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillTriangle
     * @since 3.50.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillTriangle: function(x0, y0, x1, y1, x2, y2, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var tx0 = calcMatrix.getX(x0, y0);
                    var ty0 = calcMatrix.getY(x0, y0);
                    var tx1 = calcMatrix.getX(x1, y1);
                    var ty1 = calcMatrix.getY(x1, y1);
                    var tx2 = calcMatrix.getX(x2, y2);
                    var ty2 = calcMatrix.getY(x2, y2);
                    var tint = this.fillTint;
                    this.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, tint.TL, tint.TR, tint.BL);
                },
                /**
     * Pushes a stroked triangle into the vertex batch.
     *
     * Triangle factors in the given transform matrices before adding to the batch.
     *
     * The triangle is created from 3 lines and drawn using the `batchStrokePath` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchStrokeTriangle
     * @since 3.50.0
     *
     * @param {number} x0 - Point 0 x coordinate.
     * @param {number} y0 - Point 0 y coordinate.
     * @param {number} x1 - Point 1 x coordinate.
     * @param {number} y1 - Point 1 y coordinate.
     * @param {number} x2 - Point 2 x coordinate.
     * @param {number} y2 - Point 2 y coordinate.
     * @param {number} lineWidth - The width of the line in pixels.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokeTriangle: function(x0, y0, x1, y1, x2, y2, lineWidth, currentMatrix, parentMatrix) {
                    var tempTriangle = this.tempTriangle;
                    tempTriangle[0].x = x0;
                    tempTriangle[0].y = y0;
                    tempTriangle[0].width = lineWidth;
                    tempTriangle[1].x = x1;
                    tempTriangle[1].y = y1;
                    tempTriangle[1].width = lineWidth;
                    tempTriangle[2].x = x2;
                    tempTriangle[2].y = y2;
                    tempTriangle[2].width = lineWidth;
                    tempTriangle[3].x = x0;
                    tempTriangle[3].y = y0;
                    tempTriangle[3].width = lineWidth;
                    this.batchStrokePath(tempTriangle, lineWidth, false, currentMatrix, parentMatrix);
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and then passing it through Earcut, which
     * creates a list of polygons. Each polygon is then added to the batch.
     *
     * The path is always automatically closed because it's filled.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchFillPath
     * @since 3.50.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchFillPath: function(path, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var length = path.length;
                    var polygonCache = this.polygonCache;
                    var polygonIndexArray;
                    var point;
                    var tintTL = this.fillTint.TL;
                    var tintTR = this.fillTint.TR;
                    var tintBL = this.fillTint.BL;
                    for(var pathIndex = 0; pathIndex < length; ++pathIndex){
                        point = path[pathIndex];
                        polygonCache.push(point.x, point.y);
                    }
                    polygonIndexArray = Earcut(polygonCache);
                    length = polygonIndexArray.length;
                    for(var index = 0; index < length; index += 3){
                        var p0 = polygonIndexArray[index + 0] * 2;
                        var p1 = polygonIndexArray[index + 1] * 2;
                        var p2 = polygonIndexArray[index + 2] * 2;
                        var x0 = polygonCache[p0 + 0];
                        var y0 = polygonCache[p0 + 1];
                        var x1 = polygonCache[p1 + 0];
                        var y1 = polygonCache[p1 + 1];
                        var x2 = polygonCache[p2 + 0];
                        var y2 = polygonCache[p2 + 1];
                        var tx0 = calcMatrix.getX(x0, y0);
                        var ty0 = calcMatrix.getY(x0, y0);
                        var tx1 = calcMatrix.getX(x1, y1);
                        var ty1 = calcMatrix.getY(x1, y1);
                        var tx2 = calcMatrix.getX(x2, y2);
                        var ty2 = calcMatrix.getY(x2, y2);
                        this.batchTri(tx0, ty0, tx1, ty1, tx2, ty2, tintTL, tintTR, tintBL);
                    }
                    polygonCache.length = 0;
                },
                /**
     * Adds the given path to the vertex batch for rendering.
     *
     * It works by taking the array of path data and calling `batchLine` for each section
     * of the path.
     *
     * The path is optionally closed at the end.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchStrokePath
     * @since 3.50.0
     *
     * @param {Phaser.Types.Math.Vector2Like[]} path - Collection of points that represent the path.
     * @param {number} lineWidth - The width of the line segments in pixels.
     * @param {boolean} pathOpen - Indicates if the path should be closed or left open.
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchStrokePath: function(path, lineWidth, pathOpen, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    //  Reset the closePath booleans
                    this.prevQuad[4] = 0;
                    this.firstQuad[4] = 0;
                    var pathLength = path.length - 1;
                    for(var pathIndex = 0; pathIndex < pathLength; pathIndex++){
                        var point0 = path[pathIndex];
                        var point1 = path[pathIndex + 1];
                        this.batchLine(point0.x, point0.y, point1.x, point1.y, point0.width / 2, point1.width / 2, lineWidth, pathIndex, !pathOpen && pathIndex === pathLength - 1, currentMatrix, parentMatrix);
                    }
                },
                /**
     * Creates a line out of 4 quads and adds it to the vertex batch based on the given line values.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchLine
     * @since 3.50.0
     *
     * @param {number} ax - x coordinate of the start of the line.
     * @param {number} ay - y coordinate of the start of the line.
     * @param {number} bx - x coordinate of the end of the line.
     * @param {number} by - y coordinate of the end of the line.
     * @param {number} aLineWidth - Width of the start of the line.
     * @param {number} bLineWidth - Width of the end of the line.
     * @param {number} index - If this line is part of a multi-line draw, the index of the line in the draw.
     * @param {boolean} closePath - Does this line close a multi-line path?
     * @param {Phaser.GameObjects.Components.TransformMatrix} currentMatrix - The current transform.
     * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - The parent transform.
     */ batchLine: function(ax, ay, bx, by, aLineWidth, bLineWidth, lineWidth, index, closePath, currentMatrix, parentMatrix) {
                    this.renderer.pipelines.set(this);
                    var calcMatrix = this.calcMatrix;
                    //  Multiply and store result in calcMatrix, only if the parentMatrix is set, otherwise we'll use whatever values are already in the calcMatrix
                    if (parentMatrix) parentMatrix.multiply(currentMatrix, calcMatrix);
                    var dx = bx - ax;
                    var dy = by - ay;
                    var len = Math.sqrt(dx * dx + dy * dy);
                    var al0 = aLineWidth * (by - ay) / len;
                    var al1 = aLineWidth * (ax - bx) / len;
                    var bl0 = bLineWidth * (by - ay) / len;
                    var bl1 = bLineWidth * (ax - bx) / len;
                    var lx0 = bx - bl0;
                    var ly0 = by - bl1;
                    var lx1 = ax - al0;
                    var ly1 = ay - al1;
                    var lx2 = bx + bl0;
                    var ly2 = by + bl1;
                    var lx3 = ax + al0;
                    var ly3 = ay + al1;
                    //  tx0 = bottom right
                    var brX = calcMatrix.getX(lx0, ly0);
                    var brY = calcMatrix.getY(lx0, ly0);
                    //  tx1 = bottom left
                    var blX = calcMatrix.getX(lx1, ly1);
                    var blY = calcMatrix.getY(lx1, ly1);
                    //  tx2 = top right
                    var trX = calcMatrix.getX(lx2, ly2);
                    var trY = calcMatrix.getY(lx2, ly2);
                    //  tx3 = top left
                    var tlX = calcMatrix.getX(lx3, ly3);
                    var tlY = calcMatrix.getY(lx3, ly3);
                    var tint = this.strokeTint;
                    var tintTL = tint.TL;
                    var tintTR = tint.TR;
                    var tintBL = tint.BL;
                    var tintBR = tint.BR;
                    //  TL, BL, BR, TR
                    this.batchQuad(tlX, tlY, blX, blY, brX, brY, trX, trY, tintTL, tintTR, tintBL, tintBR);
                    if (lineWidth <= 2) //  No point doing a linejoin if the line isn't thick enough
                    return;
                    var prev = this.prevQuad;
                    var first = this.firstQuad;
                    if (index > 0 && prev[4]) this.batchQuad(tlX, tlY, blX, blY, prev[0], prev[1], prev[2], prev[3], tintTL, tintTR, tintBL, tintBR);
                    else {
                        first[0] = tlX;
                        first[1] = tlY;
                        first[2] = blX;
                        first[3] = blY;
                        first[4] = 1;
                    }
                    if (closePath && first[4]) //  Add a join for the final path segment
                    this.batchQuad(brX, brY, trX, trY, first[0], first[1], first[2], first[3], tintTL, tintTR, tintBL, tintBR);
                    else {
                        //  Store it
                        prev[0] = brX;
                        prev[1] = brY;
                        prev[2] = trX;
                        prev[3] = trY;
                        prev[4] = 1;
                    }
                },
                /**
     * Adds a single vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchTri` and `batchQuad`.
     *
     * It does not perform any batch limit checking itself, so if you need to call
     * this method directly, do so in the same way that `batchQuad` does, for example.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} tint - The tint color value.
     */ batchVert: function(x, y, tint) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexViewU32 = this.vertexViewU32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewU32[++vertexOffset] = tint;
                    this.vertexCount++;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 6 vertices in the following arrangement:
     *
     * ```
     * 0----3
     * |\  B|
     * | \  |
     * |  \ |
     * | A \|
     * |    \
     * 1----2
     * ```
     *
     * Where tx0/ty0 = 0, tx1/ty1 = 1, tx2/ty2 = 2 and tx3/ty3 = 3
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchQuad
     * @override
     * @since 3.50.0
     *
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     * @param {number} tintBR - The bottom-right tint color value.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchQuad: function(x0, y0, x1, y1, x2, y2, x3, y3, tintTL, tintTR, tintBL, tintBR) {
                    var hasFlushed = false;
                    if (this.shouldFlush(6)) {
                        this.flush();
                        hasFlushed = true;
                    }
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x1, y1, tintBL);
                    this.batchVert(x2, y2, tintBR);
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x2, y2, tintBR);
                    this.batchVert(x3, y3, tintTR);
                    return hasFlushed;
                },
                /**
     * Adds the vertices data into the batch and flushes if full.
     *
     * Assumes 3 vertices in the following arrangement:
     *
     * ```
     * 0
     * |\
     * | \
     * |  \
     * |   \
     * |    \
     * 1-----2
     * ```
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#batchTri
     * @override
     * @since 3.50.0
     *
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} tintTL - The top-left tint color value.
     * @param {number} tintTR - The top-right tint color value.
     * @param {number} tintBL - The bottom-left tint color value.
     *
     * @return {boolean} `true` if this method caused the batch to flush, otherwise `false`.
     */ batchTri: function(x0, y0, x1, y1, x2, y2, tintTL, tintTR, tintBL) {
                    var hasFlushed = false;
                    if (this.shouldFlush(3)) {
                        this.flush();
                        hasFlushed = true;
                    }
                    this.batchVert(x0, y0, tintTL);
                    this.batchVert(x1, y1, tintTR);
                    this.batchVert(x2, y2, tintBL);
                    return hasFlushed;
                },
                /**
     * Destroys all shader instances, removes all object references and nulls all external references.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.GraphicsPipeline#destroy
     * @since 3.50.0
     *
     * @return {this} This WebGLPipeline instance.
     */ destroy: function() {
                    WebGLPipeline.prototype.destroy.call(this);
                    this.polygonCache = null;
                    return this;
                }
            });
            module1.exports = GraphicsPipeline;
        /***/ },
        /* 371 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var LightShaderSourceFS = __webpack_require__(873);
            var MultiPipeline = __webpack_require__(105);
            var Vec2 = __webpack_require__(3);
            var WebGLPipeline = __webpack_require__(57);
            var LIGHT_COUNT = 10;
            var tempVec2 = new Vec2();
            /**
 * @classdesc
 * The Light Pipeline is an extension of the Multi Pipeline and uses a custom shader
 * designed to handle forward diffused rendering of 2D lights in a Scene.
 *
 * The shader works in tandem with Light Game Objects, and optionally texture normal maps,
 * to provide an ambient illumination effect.
 *
 * If you wish to provide your own shader, you can use the `%LIGHT_COUNT%` declaration in the source,
 * and it will be automatically replaced at run-time with the total number of configured lights.
 *
 * The maximum number of lights can be set in the Render Config `maxLights` property and defaults to 10.
 *
 * Prior to Phaser v3.50 this pipeline was called the `ForwardDiffuseLightPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Light.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are those from the Multi Pipeline, plus:
 *
 * `uMainSampler` (sampler2D)
 * `uNormSampler` (sampler2D)
 * `uCamera` (vec4)
 * `uResolution` (vec2)
 * `uAmbientLightColor` (vec3)
 * `uInverseRotationMatrix` (mat3)
 * `uLights` (Light struct)
 *
 * @class LightPipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var LightPipeline = new Class({
                Extends: MultiPipeline,
                initialize: function LightPipeline(config) {
                    LIGHT_COUNT = config.game.renderer.config.maxLights;
                    var fragShader = GetFastValue(config, 'fragShader', LightShaderSourceFS);
                    var shaders = [];
                    for(var i = 1; i <= LIGHT_COUNT; i++)shaders.push({
                        name: 'lights' + i,
                        fragShader: fragShader.replace('%LIGHT_COUNT%', i.toString())
                    });
                    config.shaders = shaders;
                    MultiPipeline.call(this, config);
                    /**
         * Inverse rotation matrix for normal map rotations.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#inverseRotationMatrix
         * @type {Float32Array}
         * @private
         * @since 3.16.0
         */ this.inverseRotationMatrix = new Float32Array([
                        1,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    /**
         * Stores a default normal map, which is an object with a `glTexture` property that
         * maps to a 1x1 texture of the color #7f7fff created in the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.LightPipeline#defaultNormalMap
         * @type {object}
         * @since 3.50.0
         */ this.defaultNormalMap;
                },
                /**
     * Called when the Game has fully booted and the Renderer has finished setting up.
     *
     * By this stage all Game level systems are now in place and you can perform any final
     * tasks that the pipeline may need that relied on game systems such as the Texture Manager.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#boot
     * @since 3.11.0
     */ boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var gl = this.gl;
                    var tempTexture = gl.createTexture();
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, tempTexture);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([
                        127,
                        127,
                        255,
                        255
                    ]));
                    this.defaultNormalMap = {
                        glTexture: tempTexture
                    };
                    //  Set the lights shaders
                    for(var i = 0; i < this.shaders.length; i++)this['lightShader' + (i + 1)] = this.shaders[i];
                },
                /**
     * This function sets all the needed resources for each camera pass.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#onRender
     * @ignore
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene being rendered.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered with.
     */ onRender: function(scene, camera) {
                    var lightManager = scene.sys.lights;
                    if (!lightManager || !lightManager.active) return;
                    var lights = lightManager.getLights(camera);
                    var lightsCount = lights.length;
                    if (lightsCount === 0) return;
                    //  Ok, we're good to go ...
                    this.setShader(this['lightShader' + lightsCount], true);
                    var i;
                    var renderer = this.renderer;
                    var height = renderer.height;
                    var cameraMatrix = camera.matrix;
                    this.set1i('uMainSampler', 0);
                    this.set1i('uNormSampler', 1);
                    this.set2f('uResolution', this.width / 2, this.height / 2);
                    this.set4f('uCamera', camera.x, camera.y, camera.rotation, camera.zoom);
                    this.set3f('uAmbientLightColor', lightManager.ambientColor.r, lightManager.ambientColor.g, lightManager.ambientColor.b);
                    for(i = 0; i < lightsCount; i++){
                        var light = lights[i].light;
                        var color = light.color;
                        var lightName = 'uLights[' + i + '].';
                        cameraMatrix.transformPoint(light.x, light.y, tempVec2);
                        this.set2f(lightName + 'position', tempVec2.x - camera.scrollX * light.scrollFactorX * camera.zoom, height - (tempVec2.y - camera.scrollY * light.scrollFactorY * camera.zoom));
                        this.set3f(lightName + 'color', color.r, color.g, color.b);
                        this.set1f(lightName + 'intensity', light.intensity);
                        this.set1f(lightName + 'radius', light.radius);
                    }
                    this.currentNormalMapRotation = null;
                },
                /**
     * Rotates the normal map vectors inversely by the given angle.
     * Only works in 2D space.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setNormalMapRotation
     * @since 3.16.0
     *
     * @param {number} rotation - The angle of rotation in radians.
     */ setNormalMapRotation: function(rotation) {
                    if (rotation !== this.currentNormalMapRotation || this.vertexCount === 0) {
                        if (this.vertexCount > 0) this.flush();
                        var inverseRotationMatrix = this.inverseRotationMatrix;
                        if (rotation) {
                            var rot = -rotation;
                            var c = Math.cos(rot);
                            var s = Math.sin(rot);
                            inverseRotationMatrix[1] = s;
                            inverseRotationMatrix[3] = -s;
                            inverseRotationMatrix[0] = inverseRotationMatrix[4] = c;
                        } else {
                            inverseRotationMatrix[0] = inverseRotationMatrix[4] = 1;
                            inverseRotationMatrix[1] = inverseRotationMatrix[3] = 0;
                        }
                        this.setMatrix3fv('uInverseRotationMatrix', false, inverseRotationMatrix);
                        this.currentNormalMapRotation = rotation;
                    }
                },
                /**
     * Assigns a texture to the current batch. If a different texture is already set it creates a new batch object.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setTexture2D
     * @ignore
     * @since 3.50.0
     *
     * @param {WebGLTexture} [texture] - WebGLTexture that will be assigned to the current batch. If not given uses blankTexture.
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object being rendered or added to the batch.
     */ setTexture2D: function(texture, gameObject) {
                    var renderer = this.renderer;
                    if (texture === undefined) texture = renderer.tempTextures[0];
                    var normalTexture = this.getNormalMap(gameObject);
                    if (renderer.isNewNormalMap(texture, normalTexture)) {
                        this.flush();
                        renderer.setTextureZero(texture);
                        renderer.setNormalMap(normalTexture);
                    }
                    var rotation = gameObject ? gameObject.rotation : 0;
                    this.setNormalMapRotation(rotation);
                    this.currentUnit = 0;
                    return 0;
                },
                /**
     * Custom pipelines can use this method in order to perform any required pre-batch tasks
     * for the given Game Object. It must return the texture unit the Game Object was assigned.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#setGameObject
     * @ignore
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object being rendered or added to the batch.
     * @param {Phaser.Textures.Frame} [frame] - Optional frame to use. Can override that of the Game Object.
     *
     * @return {number} The texture unit the Game Object has been assigned.
     */ setGameObject: function(gameObject, frame) {
                    if (frame === undefined) frame = gameObject.frame;
                    var renderer = this.renderer;
                    var texture = frame.glTexture;
                    var normalTexture = this.getNormalMap(gameObject);
                    if (renderer.isNewNormalMap()) {
                        this.flush();
                        renderer.setTextureZero(texture);
                        renderer.setNormalMap(normalTexture);
                    }
                    this.setNormalMapRotation(gameObject.rotation);
                    this.currentUnit = 0;
                    return 0;
                },
                /**
     * Returns the normal map WebGLTexture from the given Game Object.
     * If the Game Object doesn't have one, it returns the default normal map from this pipeline instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.LightPipeline#getNormalMap
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} [gameObject] - The Game Object to get the normal map from.
     *
     * @return {WebGLTexture} The normal map texture.
     */ getNormalMap: function(gameObject) {
                    var normalTexture;
                    if (!gameObject) normalTexture = this.defaultNormalMap;
                    else if (gameObject.displayTexture) normalTexture = gameObject.displayTexture.dataSource[gameObject.displayFrame.sourceIndex];
                    else if (gameObject.texture) normalTexture = gameObject.texture.dataSource[gameObject.frame.sourceIndex];
                    else if (gameObject.tileset) {
                        if (Array.isArray(gameObject.tileset)) normalTexture = gameObject.tileset[0].image.dataSource[0];
                        else normalTexture = gameObject.tileset.image.dataSource[0];
                    }
                    if (!normalTexture) normalTexture = this.defaultNormalMap;
                    return normalTexture.glTexture;
                }
            });
            LightPipeline.LIGHT_COUNT = LIGHT_COUNT;
            module1.exports = LightPipeline;
        /***/ },
        /* 372 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var PointLightShaderSourceFS = __webpack_require__(876);
            var PointLightShaderSourceVS = __webpack_require__(877);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Point Light Pipeline handles rendering the Point Light Game Objects in WebGL.
 *
 * The fragment shader it uses can be found in `shaders/src/PointLight.frag`.
 * The vertex shader it uses can be found in `shaders/src/PointLight.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2)
 * `inLightPosition` (vec2)
 * `inLightRadius` (float)
 * `inLightAttenuation` (float)
 * `inLightColor` (vec4)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uResolution` (vec2)
 * `uCameraZoom` (sampler2D)
 *
 * @class PointLightPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PointLightPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function PointLightPipeline(config) {
                    config.vertShader = GetFastValue(config, 'vertShader', PointLightShaderSourceVS);
                    config.fragShader = GetFastValue(config, 'fragShader', PointLightShaderSourceFS);
                    config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2
                        },
                        {
                            name: 'inLightPosition',
                            size: 2
                        },
                        {
                            name: 'inLightRadius'
                        },
                        {
                            name: 'inLightAttenuation'
                        },
                        {
                            name: 'inLightColor',
                            size: 4
                        }
                    ]);
                    WebGLPipeline.call(this, config);
                },
                onRender: function(scene, camera) {
                    this.set2f('uResolution', this.width, this.height);
                    this.set1f('uCameraZoom', camera.zoom);
                },
                /**
     * Adds a Point Light Game Object to the batch, flushing if required.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchPointLight
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.PointLight} light - The Point Light Game Object.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera rendering the Point Light.
     * @param {number} x0 - The top-left x position.
     * @param {number} y0 - The top-left y position.
     * @param {number} x1 - The bottom-left x position.
     * @param {number} y1 - The bottom-left y position.
     * @param {number} x2 - The bottom-right x position.
     * @param {number} y2 - The bottom-right y position.
     * @param {number} x3 - The top-right x position.
     * @param {number} y3 - The top-right y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     */ batchPointLight: function(light, camera, x0, y0, x1, y1, x2, y2, x3, y3, lightX, lightY) {
                    var color = light.color;
                    var intensity = light.intensity;
                    var radius = light.radius;
                    var attenuation = light.attenuation;
                    var r = color.r * intensity;
                    var g = color.g * intensity;
                    var b = color.b * intensity;
                    var a = camera.alpha * light.alpha;
                    if (this.shouldFlush(6)) this.flush();
                    this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x1, y1, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x0, y0, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x2, y2, lightX, lightY, radius, attenuation, r, g, b, a);
                    this.batchLightVert(x3, y3, lightX, lightY, radius, attenuation, r, g, b, a);
                },
                /**
     * Adds a single Point Light vertex to the current vertex buffer and increments the
     * `vertexCount` property by 1.
     *
     * This method is called directly by `batchPointLight`.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PointLightPipeline#batchLightVert
     * @since 3.50.0
     *
     * @param {number} x - The vertex x position.
     * @param {number} y - The vertex y position.
     * @param {number} lightX - The horizontal center of the light.
     * @param {number} lightY - The vertical center of the light.
     * @param {number} radius - The radius of the light.
     * @param {number} attenuation - The attenuation of the light.
     * @param {number} r - The red color channel of the light.
     * @param {number} g - The green color channel of the light.
     * @param {number} b - The blue color channel of the light.
     * @param {number} a - The alpha color channel of the light.
     */ batchLightVert: function(x, y, lightX, lightY, radius, attenuation, r, g, b, a) {
                    var vertexViewF32 = this.vertexViewF32;
                    var vertexOffset = this.vertexCount * this.currentShader.vertexComponentCount - 1;
                    vertexViewF32[++vertexOffset] = x;
                    vertexViewF32[++vertexOffset] = y;
                    vertexViewF32[++vertexOffset] = lightX;
                    vertexViewF32[++vertexOffset] = lightY;
                    vertexViewF32[++vertexOffset] = radius;
                    vertexViewF32[++vertexOffset] = attenuation;
                    vertexViewF32[++vertexOffset] = r;
                    vertexViewF32[++vertexOffset] = g;
                    vertexViewF32[++vertexOffset] = b;
                    vertexViewF32[++vertexOffset] = a;
                    this.vertexCount++;
                }
            });
            module1.exports = PointLightPipeline;
        /***/ },
        /* 373 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var MultiPipeline = __webpack_require__(105);
            /**
 * @classdesc
 * The Rope Pipeline is a variation of the Multi Pipeline that uses a `TRIANGLE_STRIP` for
 * its topology, instead of TRIANGLES. This is primarily used by the Rope Game Object,
 * or anything that extends it.
 *
 * Prior to Phaser v3.50 this pipeline was called the `TextureTintStripPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Multi.frag`.
 * The vertex shader it uses can be found in `shaders/src/Multi.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16)
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D array)
 *
 * The pipeline is structurally identical to the Multi Pipeline and should be treated as such.
 *
 * @class RopePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var RopePipeline = new Class({
                Extends: MultiPipeline,
                initialize: function RopePipeline(config) {
                    //  GLenum 5 = TRIANGLE_STRIP
                    config.topology = 5;
                    config.batchSize = GetFastValue(config, 'batchSize', 256);
                    MultiPipeline.call(this, config);
                }
            });
            module1.exports = RopePipeline;
        /***/ },
        /* 374 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var MultiPipeline = __webpack_require__(105);
            var ShaderSourceFS = __webpack_require__(878);
            var ShaderSourceVS = __webpack_require__(879);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Single Pipeline is a special version of the Multi Pipeline that only ever
 * uses one texture, bound to texture unit zero. Although not as efficient as the
 * Multi Pipeline, it provides an easier way to create custom pipelines that only require
 * a single bound texture.
 *
 * Prior to Phaser v3.50 this pipeline didn't exist, but could be compared to the old `TextureTintPipeline`.
 *
 * The fragment shader it uses can be found in `shaders/src/Single.frag`.
 * The vertex shader it uses can be found in `shaders/src/Single.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 * `inTexId` (float, offset 16) - this value is always zero in the Single Pipeline
 * `inTintEffect` (float, offset 20)
 * `inTint` (vec4, offset 24, normalized)
 *
 * The default shader uniforms for this pipeline are:
 *
 * `uProjectionMatrix` (mat4)
 * `uMainSampler` (sampler2D)
 *
 * @class SinglePipeline
 * @extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var SinglePipeline = new Class({
                Extends: MultiPipeline,
                initialize: function SinglePipeline(config) {
                    config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS), config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS), config.forceZero = true;
                    MultiPipeline.call(this, config);
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    this.set1i('uMainSampler', 0);
                }
            });
            module1.exports = SinglePipeline;
        /***/ },
        /* 375 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddBlendFS = __webpack_require__(880);
            var BlendModes = __webpack_require__(34);
            var Class = __webpack_require__(0);
            var ColorMatrix = __webpack_require__(195);
            var ColorMatrixFS = __webpack_require__(881);
            var CopyFS = __webpack_require__(882);
            var GetFastValue = __webpack_require__(2);
            var LinearBlendFS = __webpack_require__(883);
            var QuadVS = __webpack_require__(376);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Utility Pipeline is a special-use pipeline that belongs to the Pipeline Manager.
 *
 * It provides 4 shaders and handy associated methods:
 *
 * 1) Copy Shader. A fast texture to texture copy shader with optional brightness setting.
 * 2) Additive Blend Mode Shader. Blends two textures using an additive blend mode.
 * 3) Linear Blend Mode Shader. Blends two textures using a linear blend mode.
 * 4) Color Matrix Copy Shader. Draws a texture to a target using a Color Matrix.
 *
 * You do not extend this pipeline, but instead get a reference to it from the Pipeline
 * Manager via the `setUtility` method. You can also access methods such as `copyFrame`
 * directly from the Pipeline Manager.
 *
 * This pipeline provides methods for manipulating framebuffer backed textures, such as
 * copying or blending one texture to another, copying a portion of a texture, additively
 * blending two textures, flipping textures and more.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * This pipeline has a hard-coded batch size of 1 and a hard coded set of vertices.
 *
 * @class UtilityPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var UtilityPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function UtilityPipeline(config) {
                    config.renderTarget = GetFastValue(config, 'renderTarget', [
                        {
                            scale: 1
                        },
                        {
                            scale: 1
                        },
                        {
                            scale: 0.5
                        },
                        {
                            scale: 0.5
                        }
                    ]);
                    config.vertShader = GetFastValue(config, 'vertShader', QuadVS);
                    config.shaders = GetFastValue(config, 'shaders', [
                        {
                            name: 'Copy',
                            fragShader: CopyFS
                        },
                        {
                            name: 'AddBlend',
                            fragShader: AddBlendFS
                        },
                        {
                            name: 'LinearBlend',
                            fragShader: LinearBlendFS
                        },
                        {
                            name: 'ColorMatrix',
                            fragShader: ColorMatrixFS
                        }
                    ]);
                    config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2
                        },
                        {
                            name: 'inTexCoord',
                            size: 2
                        }
                    ]);
                    config.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ];
                    config.batchSize = 1;
                    WebGLPipeline.call(this, config);
                    /**
         * A default Color Matrix, used by the Color Matrix Shader when one
         * isn't provided.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                    /**
         * A reference to the Copy Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @default null
         * @since 3.50.0
         */ this.copyShader;
                    /**
         * A reference to the Additive Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#addShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.addShader;
                    /**
         * A reference to the Linear Blend Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#linearShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.linearShader;
                    /**
         * A reference to the Color Matrix Shader belonging to this Utility Pipeline.
         *
         * This property is set during the `boot` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#colorMatrixShader
         * @type {Phaser.Renderer.WebGL.WebGLShader}
         * @since 3.50.0
         */ this.colorMatrixShader;
                    /**
         * A reference to the Full Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target.
         *
         * This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @since 3.50.0
         */ this.halfFrame2;
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var shaders = this.shaders;
                    var targets = this.renderTargets;
                    this.copyShader = shaders[0];
                    this.addShader = shaders[1];
                    this.linearShader = shaders[2];
                    this.colorMatrixShader = shaders[3];
                    this.fullFrame1 = targets[0];
                    this.fullFrame2 = targets[1];
                    this.halfFrame1 = targets[2];
                    this.halfFrame2 = targets[3];
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    if (brightness === undefined) brightness = 1;
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i('uMainSampler', 0);
                    this.set1f('uBrightness', brightness);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    } else gl.viewport(0, 0, source.width, source.height);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    if (brightness === undefined) brightness = 1;
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (eraseMode === undefined) eraseMode = false;
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i('uMainSampler', 0);
                    this.set1f('uBrightness', brightness);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (source.height > target.height) {
                        gl.viewport(0, 0, source.width, source.height);
                        this.setTargetUVs(source, target);
                    } else {
                        var diff = target.height - source.height;
                        gl.viewport(0, diff, source.width, source.height);
                    }
                    gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    if (eraseMode) {
                        var blendMode = this.renderer.currentBlendMode;
                        this.renderer.setBlendMode(BlendModes.ERASE);
                    }
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    if (eraseMode) this.renderer.setBlendMode(blendMode);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                    this.resetUVs();
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, source.framebuffer);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, source.texture, 0);
                    if (clear) {
                        if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                        else gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, target.texture);
                    gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, y, width, height);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    var gl = this.gl;
                    this.setShader(this.copyShader);
                    this.set1i('uMainSampler', 0);
                    this.set1f('uBrightness', 1);
                    this.renderer.popFramebuffer();
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    this.renderer.resetTextures();
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Display.ColorMatrix} [colorMatrix] - The Color Matrix to use when performing the draw.
     */ drawFrame: function(source, target, clearAlpha, colorMatrix) {
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (colorMatrix === undefined) colorMatrix = this.colorMatrix;
                    var gl = this.gl;
                    this.setShader(this.colorMatrixShader);
                    this.set1i('uMainSampler', 0);
                    this.set1fv('uColorMatrix', colorMatrix.getData());
                    this.set1f('uAlpha', colorMatrix.alpha);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                    } else gl.viewport(0, 0, source.width, source.height);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [blendShader] - The shader to use during the blend copy.
     */ blendFrames: function(source1, source2, target, strength, clearAlpha, blendShader) {
                    if (strength === undefined) strength = 1;
                    if (clearAlpha === undefined) clearAlpha = true;
                    if (blendShader === undefined) blendShader = this.linearShader;
                    var gl = this.gl;
                    this.setShader(blendShader);
                    this.set1i('uMainSampler1', 0);
                    this.set1i('uMainSampler2', 1);
                    this.set1f('uStrength', strength);
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source1.texture);
                    gl.activeTexture(gl.TEXTURE1);
                    gl.bindTexture(gl.TEXTURE_2D, source2.texture);
                    if (target) {
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                        gl.viewport(0, 0, target.width, target.height);
                    } else gl.viewport(0, 0, source1.width, source1.height);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    gl.bindTexture(gl.TEXTURE_2D, null);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.blendFrames(source1, source2, target, strength, clearAlpha, this.addShader);
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    gl.viewport(0, 0, target.width, target.height);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                    if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                    else gl.clearColor(0, 0, 0, 1);
                    gl.clear(gl.COLOR_BUFFER_BIT);
                    var fbo = this.renderer.currentFramebuffer;
                    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
                },
                /**
     * Set the UV values for the 6 vertices that make up the quad used by the shaders
     * in the Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setUVs
     * @since 3.50.0
     *
     * @param {number} uA - The u value of vertex A.
     * @param {number} vA - The v value of vertex A.
     * @param {number} uB - The u value of vertex B.
     * @param {number} vB - The v value of vertex B.
     * @param {number} uC - The u value of vertex C.
     * @param {number} vC - The v value of vertex C.
     * @param {number} uD - The u value of vertex D.
     * @param {number} vD - The v value of vertex D.
     */ setUVs: function(uA, vA, uB, vB, uC, vC, uD, vD) {
                    var vertexViewF32 = this.vertexViewF32;
                    vertexViewF32[2] = uA;
                    vertexViewF32[3] = vA;
                    vertexViewF32[6] = uB;
                    vertexViewF32[7] = vB;
                    vertexViewF32[10] = uC;
                    vertexViewF32[11] = vC;
                    vertexViewF32[14] = uA;
                    vertexViewF32[15] = vA;
                    vertexViewF32[18] = uC;
                    vertexViewF32[19] = vC;
                    vertexViewF32[22] = uD;
                    vertexViewF32[23] = vD;
                },
                /**
     * Sets the vertex UV coordinates of the quad used by the shaders in the Utility Pipeline
     * so that they correctly adjust the texture coordinates for a blit frame effect.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#setTargetUVs
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     */ setTargetUVs: function(source, target) {
                    var diff = target.height / source.height;
                    if (diff > 0.5) diff = 0.5 - (diff - 0.5);
                    else diff = 0.5 + (0.5 - diff);
                    this.setUVs(0, diff, 0, 1 + diff, 1, 1 + diff, 1, diff);
                },
                /**
     * Horizontally flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipX
     * @since 3.50.0
     */ flipX: function() {
                    this.setUVs(1, 0, 1, 1, 0, 1, 0, 0);
                },
                /**
     * Vertically flips the UV coordinates of the quad used by the shaders in this
     * Utility Pipeline.
     *
     * Be sure to call `resetUVs` once you have finished manipulating the UV coordinates.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#flipY
     * @since 3.50.0
     */ flipY: function() {
                    this.setUVs(0, 1, 0, 0, 1, 0, 1, 1);
                },
                /**
     * Resets the quad vertice UV values to their default settings.
     *
     * The quad is used by all shaders of the Utility Pipeline.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.UtilityPipeline#resetUVs
     * @since 3.50.0
     */ resetUVs: function() {
                    this.setUVs(0, 0, 0, 1, 1, 1, 1, 0);
                }
            });
            module1.exports = UtilityPipeline;
        /***/ },
        /* 376 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_QUAD_VS',
                '',
                'precision mediump float;',
                '',
                'attribute vec2 inPosition;',
                'attribute vec2 inTexCoord;',
                '',
                'varying vec2 outFragCoord;',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    outFragCoord = inPosition.xy * 0.5 + 0.5;',
                '    outTexCoord = inTexCoord;',
                '',
                '    gl_Position = vec4(inPosition, 0, 1);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 377 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Color = __webpack_require__(37);
            var GetFastValue = __webpack_require__(2);
            /**
 * Takes a snapshot of an area from the current frame displayed by a WebGL canvas.
 *
 * This is then copied to an Image object. When this loads, the results are sent
 * to the callback provided in the Snapshot Configuration object.
 *
 * @function Phaser.Renderer.Snapshot.WebGL
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} sourceCanvas - The canvas to take a snapshot of.
 * @param {Phaser.Types.Renderer.Snapshot.SnapshotState} config - The snapshot configuration object.
 */ var WebGLSnapshot = function(sourceCanvas, config) {
                var gl = sourceCanvas.getContext('experimental-webgl');
                var callback = GetFastValue(config, 'callback');
                var type = GetFastValue(config, 'type', 'image/png');
                var encoderOptions = GetFastValue(config, 'encoder', 0.92);
                var x = GetFastValue(config, 'x', 0);
                var y = GetFastValue(config, 'y', 0);
                var getPixel = GetFastValue(config, 'getPixel', false);
                var isFramebuffer = GetFastValue(config, 'isFramebuffer', false);
                var bufferWidth = isFramebuffer ? GetFastValue(config, 'bufferWidth', 1) : gl.drawingBufferWidth;
                var bufferHeight = isFramebuffer ? GetFastValue(config, 'bufferHeight', 1) : gl.drawingBufferHeight;
                if (getPixel) {
                    var pixel = new Uint8Array(4);
                    var destY = isFramebuffer ? y : bufferHeight - y;
                    gl.readPixels(x, destY, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
                    callback.call(null, new Color(pixel[0], pixel[1], pixel[2], pixel[3] / 255));
                } else {
                    var width = GetFastValue(config, 'width', bufferWidth);
                    var height = GetFastValue(config, 'height', bufferHeight);
                    var total = width * height * 4;
                    var pixels = new Uint8Array(total);
                    gl.readPixels(x, bufferHeight - y - height, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
                    var canvas = CanvasPool.createWebGL(this, width, height);
                    var ctx = canvas.getContext('2d');
                    var imageData = ctx.getImageData(0, 0, width, height);
                    var data = imageData.data;
                    // var destIndex = (isFramebuffer) ? total - ((py * width + (width - px)) * 4) : (py * width + px) * 4;
                    for(var py = 0; py < height; py++)for(var px = 0; px < width; px++){
                        var sourceIndex = ((height - py - 1) * width + px) * 4;
                        var destIndex = (py * width + px) * 4;
                        data[destIndex + 0] = pixels[sourceIndex + 0];
                        data[destIndex + 1] = pixels[sourceIndex + 1];
                        data[destIndex + 2] = pixels[sourceIndex + 2];
                        data[destIndex + 3] = pixels[sourceIndex + 3];
                    }
                    ctx.putImageData(imageData, 0, 0);
                    var image = new Image();
                    image.onerror = function() {
                        callback.call(null);
                        CanvasPool.remove(canvas);
                    };
                    image.onload = function() {
                        callback.call(null, image);
                        CanvasPool.remove(canvas);
                    };
                    image.src = canvas.toDataURL(type, encoderOptions);
                }
            };
            module1.exports = WebGLSnapshot;
        /***/ },
        /* 378 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(32);
            /**
 * Called automatically by Phaser.Game and responsible for creating the console.log debug header.
 *
 * You can customize or disable the header via the Game Config object.
 *
 * @function Phaser.Core.DebugHeader
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance which will output this debug header.
 */ var DebugHeader = function(game) {
                var config = game.config;
                if (config.hideBanner) return;
                var renderType = 'WebGL';
                if (config.renderType === CONST.CANVAS) renderType = 'Canvas';
                else if (config.renderType === CONST.HEADLESS) renderType = 'Headless';
                var audioConfig = config.audio;
                var deviceAudio = game.device.audio;
                var audioType;
                if (deviceAudio.webAudio && !audioConfig.disableWebAudio) audioType = 'Web Audio';
                else if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) audioType = 'No Audio';
                else audioType = 'HTML5 Audio';
                if (!game.device.browser.ie) {
                    var c = '';
                    var args = [
                        c
                    ];
                    if (Array.isArray(config.bannerBackgroundColor)) {
                        var lastColor;
                        config.bannerBackgroundColor.forEach(function(color) {
                            c = c.concat('%c ');
                            args.push('background: ' + color);
                            lastColor = color;
                        });
                        //  inject the text color
                        args[args.length - 1] = 'color: ' + config.bannerTextColor + '; background: ' + lastColor;
                    } else {
                        c = c.concat('%c ');
                        args.push('color: ' + config.bannerTextColor + '; background: ' + config.bannerBackgroundColor);
                    }
                    //  URL link background color (always transparent to support different browser themes)
                    args.push('background: transparent');
                    if (config.gameTitle) {
                        c = c.concat(config.gameTitle);
                        if (config.gameVersion) c = c.concat(' v' + config.gameVersion);
                        if (!config.hidePhaser) c = c.concat(' / ');
                    }
                    var fb = '';
                    if (!config.hidePhaser) c = c.concat('Phaser v' + CONST.VERSION + fb + ' (' + renderType + ' | ' + audioType + ')');
                    c = c.concat(' %c ' + config.gameURL);
                    //  Inject the new string back into the args array
                    args[0] = c;
                    console.log.apply(console, args);
                } else if (window['console']) console.log('Phaser v' + CONST.VERSION + ' / https://phaser.io');
            };
            module1.exports = DebugHeader;
        /***/ },
        /* 379 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            var NOOP = __webpack_require__(1);
            var RequestAnimationFrame = __webpack_require__(380);
            // http://www.testufo.com/#test=animation-time-graph
            /**
 * @classdesc
 * The core runner class that Phaser uses to handle the game loop. It can use either Request Animation Frame,
 * or SetTimeout, based on browser support and config settings, to create a continuous loop within the browser.
 * 
 * Each time the loop fires, `TimeStep.step` is called and this is then passed onto the core Game update loop,
 * it is the core heartbeat of your game. It will fire as often as Request Animation Frame is capable of handling
 * on the target device.
 * 
 * Note that there are lots of situations where a browser will stop updating your game. Such as if the player
 * switches tabs, or covers up the browser window with another application. In these cases, the 'heartbeat'
 * of your game will pause, and only resume when focus is returned to it by the player. There is no way to avoid
 * this situation, all you can do is use the visibility events the browser, and Phaser, provide to detect when
 * it has happened and then gracefully recover.
 *
 * @class TimeStep
 * @memberof Phaser.Core
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this Time Step.
 * @param {Phaser.Types.Core.FPSConfig} config
 */ var TimeStep = new Class({
                initialize: function TimeStep(game, config) {
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Core.TimeStep#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The Request Animation Frame DOM Event handler.
         *
         * @name Phaser.Core.TimeStep#raf
         * @type {Phaser.DOM.RequestAnimationFrame}
         * @readonly
         * @since 3.0.0
         */ this.raf = new RequestAnimationFrame();
                    /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         *
         * @name Phaser.Core.TimeStep#started
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.started = false;
                    /**
         * A flag that is set once the TimeStep has started running and toggled when it stops.
         * The difference between this value and `started` is that `running` is toggled when
         * the TimeStep is sent to sleep, where-as `started` remains `true`, only changing if
         * the TimeStep is actually stopped, not just paused.
         *
         * @name Phaser.Core.TimeStep#running
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.running = false;
                    /**
         * The minimum fps rate you want the Time Step to run at.
         *
         * @name Phaser.Core.TimeStep#minFps
         * @type {number}
         * @default 5
         * @since 3.0.0
         */ this.minFps = GetValue(config, 'min', 5);
                    /**
         * The target fps rate for the Time Step to run at.
         *
         * Setting this value will not actually change the speed at which the browser runs, that is beyond
         * the control of Phaser. Instead, it allows you to determine performance issues and if the Time Step
         * is spiraling out of control.
         *
         * @name Phaser.Core.TimeStep#targetFps
         * @type {number}
         * @default 60
         * @since 3.0.0
         */ this.targetFps = GetValue(config, 'target', 60);
                    /**
         * The minFps value in ms.
         * Defaults to 200ms between frames (i.e. super slow!)
         *
         * @name Phaser.Core.TimeStep#_min
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._min = 1000 / this.minFps;
                    /**
         * The targetFps value in ms.
         * Defaults to 16.66ms between frames (i.e. normal)
         *
         * @name Phaser.Core.TimeStep#_target
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._target = 1000 / this.targetFps;
                    /**
         * An exponential moving average of the frames per second.
         *
         * @name Phaser.Core.TimeStep#actualFps
         * @type {number}
         * @readonly
         * @default 60
         * @since 3.0.0
         */ this.actualFps = this.targetFps;
                    /**
         * The time at which the next fps rate update will take place.
         * When an fps update happens, the `framesThisSecond` value is reset.
         *
         * @name Phaser.Core.TimeStep#nextFpsUpdate
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.nextFpsUpdate = 0;
                    /**
         * The number of frames processed this second.
         *
         * @name Phaser.Core.TimeStep#framesThisSecond
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.framesThisSecond = 0;
                    /**
         * A callback to be invoked each time the Time Step steps.
         *
         * @name Phaser.Core.TimeStep#callback
         * @type {Phaser.Types.Core.TimeStepCallback}
         * @default NOOP
         * @since 3.0.0
         */ this.callback = NOOP;
                    /**
         * You can force the Time Step to use Set Timeout instead of Request Animation Frame by setting
         * the `forceSetTimeOut` property to `true` in the Game Configuration object. It cannot be changed at run-time.
         *
         * @name Phaser.Core.TimeStep#forceSetTimeOut
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.forceSetTimeOut = GetValue(config, 'forceSetTimeOut', false);
                    /**
         * The time, calculated at the start of the current step, as smoothed by the delta value.
         *
         * @name Phaser.Core.TimeStep#time
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.time = 0;
                    /**
         * The time at which the game started running. This value is adjusted if the game is then
         * paused and resumes.
         *
         * @name Phaser.Core.TimeStep#startTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * The time, as returned by `performance.now` of the previous step.
         *
         * @name Phaser.Core.TimeStep#lastTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lastTime = 0;
                    /**
         * The current frame the game is on. This counter is incremented once every game step, regardless of how much
         * time has passed and is unaffected by delta smoothing.
         *
         * @name Phaser.Core.TimeStep#frame
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.0.0
         */ this.frame = 0;
                    /**
         * Is the browser currently considered in focus by the Page Visibility API?
         * This value is set in the `blur` method, which is called automatically by the Game instance.
         *
         * @name Phaser.Core.TimeStep#inFocus
         * @type {boolean}
         * @readonly
         * @default true
         * @since 3.0.0
         */ this.inFocus = true;
                    /**
         * The timestamp at which the game became paused, as determined by the Page Visibility API.
         *
         * @name Phaser.Core.TimeStep#_pauseTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pauseTime = 0;
                    /**
         * An internal counter to allow for the browser 'cooling down' after coming back into focus.
         *
         * @name Phaser.Core.TimeStep#_coolDown
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._coolDown = 0;
                    /**
         * The delta time, in ms, since the last game step. This is a clamped and smoothed average value.
         *
         * @name Phaser.Core.TimeStep#delta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delta = 0;
                    /**
         * Internal index of the delta history position.
         *
         * @name Phaser.Core.TimeStep#deltaIndex
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.deltaIndex = 0;
                    /**
         * Internal array holding the previous delta values, used for delta smoothing.
         *
         * @name Phaser.Core.TimeStep#deltaHistory
         * @type {number[]}
         * @since 3.0.0
         */ this.deltaHistory = [];
                    /**
         * The maximum number of delta values that are retained in order to calculate a smoothed moving average.
         * 
         * This can be changed in the Game Config via the `fps.deltaHistory` property. The default is 10.
         *
         * @name Phaser.Core.TimeStep#deltaSmoothingMax
         * @type {number}
         * @default 10
         * @since 3.0.0
         */ this.deltaSmoothingMax = GetValue(config, 'deltaHistory', 10);
                    /**
         * The number of frames that the cooldown is set to after the browser panics over the FPS rate, usually
         * as a result of switching tabs and regaining focus.
         * 
         * This can be changed in the Game Config via the `fps.panicMax` property. The default is 120.
         *
         * @name Phaser.Core.TimeStep#panicMax
         * @type {number}
         * @default 120
         * @since 3.0.0
         */ this.panicMax = GetValue(config, 'panicMax', 120);
                    /**
         * The actual elapsed time in ms between one update and the next.
         * 
         * Unlike with `delta`, no smoothing, capping, or averaging is applied to this value.
         * So please be careful when using this value in math calculations.
         *
         * @name Phaser.Core.TimeStep#rawDelta
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rawDelta = 0;
                    /**
         * The time, as returned by `performance.now` at the very start of the current step.
         * This can differ from the `time` value in that it isn't calculated based on the delta value.
         *
         * @name Phaser.Core.TimeStep#now
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.now = 0;
                    /**
         * Apply smoothing to the delta value used within Phasers internal calculations?
         * 
         * This can be changed in the Game Config via the `fps.smoothStep` property. The default is `true`.
         * 
         * Smoothing helps settle down the delta values after browser tab switches, or other situations
         * which could cause significant delta spikes or dips. By default it has been enabled in Phaser 3
         * since the first version, but is now exposed under this property (and the corresponding game config
         * `smoothStep` value), to allow you to easily disable it, should you require.
         *
         * @name Phaser.Core.TimeStep#smoothStep
         * @type {boolean}
         * @since 3.22.0
         */ this.smoothStep = GetValue(config, 'smoothStep', true);
                },
                /**
     * Called by the Game instance when the DOM window.onBlur event triggers.
     *
     * @method Phaser.Core.TimeStep#blur
     * @since 3.0.0
     */ blur: function() {
                    this.inFocus = false;
                },
                /**
     * Called by the Game instance when the DOM window.onFocus event triggers.
     *
     * @method Phaser.Core.TimeStep#focus
     * @since 3.0.0
     */ focus: function() {
                    this.inFocus = true;
                    this.resetDelta();
                },
                /**
     * Called when the visibility API says the game is 'hidden' (tab switch out of view, etc)
     *
     * @method Phaser.Core.TimeStep#pause
     * @since 3.0.0
     */ pause: function() {
                    this._pauseTime = window.performance.now();
                },
                /**
     * Called when the visibility API says the game is 'visible' again (tab switch back into view, etc)
     *
     * @method Phaser.Core.TimeStep#resume
     * @since 3.0.0
     */ resume: function() {
                    this.resetDelta();
                    this.startTime += this.time - this._pauseTime;
                },
                /**
     * Resets the time, lastTime, fps averages and delta history.
     * Called automatically when a browser sleeps them resumes.
     *
     * @method Phaser.Core.TimeStep#resetDelta
     * @since 3.0.0
     */ resetDelta: function() {
                    var now = window.performance.now();
                    this.time = now;
                    this.lastTime = now;
                    this.nextFpsUpdate = now + 1000;
                    this.framesThisSecond = 0;
                    //  Pre-populate smoothing array
                    for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = Math.min(this._target, this.deltaHistory[i]);
                    this.delta = 0;
                    this.deltaIndex = 0;
                    this._coolDown = this.panicMax;
                },
                /**
     * Starts the Time Step running, if it is not already doing so.
     * Called automatically by the Game Boot process.
     *
     * @method Phaser.Core.TimeStep#start
     * @since 3.0.0
     *
     * @param {Phaser.Types.Core.TimeStepCallback} callback - The callback to be invoked each time the Time Step steps.
     */ start: function(callback) {
                    if (this.started) return this;
                    this.started = true;
                    this.running = true;
                    for(var i = 0; i < this.deltaSmoothingMax; i++)this.deltaHistory[i] = this._target;
                    this.resetDelta();
                    this.startTime = window.performance.now();
                    this.callback = callback;
                    this.raf.start(this.step.bind(this), this.forceSetTimeOut, this._target);
                },
                /**
     * The main step method. This is called each time the browser updates, either by Request Animation Frame,
     * or by Set Timeout. It is responsible for calculating the delta values, frame totals, cool down history and more.
     * You generally should never call this method directly.
     *
     * @method Phaser.Core.TimeStep#step
     * @since 3.0.0
     */ step: function() {
                    //  Because the timestamp passed in from raf represents the beginning of the main thread frame that we’re currently in,
                    //  not the actual time now, and as we want to compare this time value against Event timeStamps and the like, we need a
                    //  more accurate one:
                    var time = window.performance.now();
                    this.now = time;
                    var before = time - this.lastTime;
                    if (before < 0) //  Because, Chrome.
                    before = 0;
                    this.rawDelta = before;
                    var idx = this.deltaIndex;
                    var history = this.deltaHistory;
                    var max = this.deltaSmoothingMax;
                    //  delta time (time is in ms)
                    var dt = before;
                    //  Delta Average
                    var avg = before;
                    //  When a browser switches tab, then comes back again, it takes around 10 frames before
                    //  the delta time settles down so we employ a 'cooling down' period before we start
                    //  trusting the delta values again, to avoid spikes flooding through our delta average
                    if (this.smoothStep) {
                        if (this._coolDown > 0 || !this.inFocus) {
                            this._coolDown--;
                            dt = Math.min(dt, this._target);
                        }
                        if (dt > this._min) {
                            //  Probably super bad start time or browser tab context loss,
                            //  so use the last 'sane' dt value
                            dt = history[idx];
                            //  Clamp delta to min (in case history has become corrupted somehow)
                            dt = Math.min(dt, this._min);
                        }
                        //  Smooth out the delta over the previous X frames
                        //  add the delta to the smoothing array
                        history[idx] = dt;
                        //  adjusts the delta history array index based on the smoothing count
                        //  this stops the array growing beyond the size of deltaSmoothingMax
                        this.deltaIndex++;
                        if (this.deltaIndex > max) this.deltaIndex = 0;
                        //  Loop the history array, adding the delta values together
                        avg = 0;
                        for(var i = 0; i < max; i++)avg += history[i];
                        //  Then divide by the array length to get the average delta
                        avg /= max;
                    }
                    //  Set as the world delta value
                    this.delta = avg;
                    //  Real-world timer advance
                    this.time += this.rawDelta;
                    // Update the estimate of the frame rate, `fps`. Every second, the number
                    // of frames that occurred in that second are included in an exponential
                    // moving average of all frames per second, with an alpha of 0.25. This
                    // means that more recent seconds affect the estimated frame rate more than
                    // older seconds.
                    //
                    // When a browser window is NOT minimized, but is covered up (i.e. you're using
                    // another app which has spawned a window over the top of the browser), then it
                    // will start to throttle the raf callback time. It waits for a while, and then
                    // starts to drop the frame rate at 1 frame per second until it's down to just over 1fps.
                    // So if the game was running at 60fps, and the player opens a new window, then
                    // after 60 seconds (+ the 'buffer time') it'll be down to 1fps, so rafin'g at 1Hz.
                    //
                    // When they make the game visible again, the frame rate is increased at a rate of
                    // approx. 8fps, back up to 60fps (or the max it can obtain)
                    //
                    // There is no easy way to determine if this drop in frame rate is because the
                    // browser is throttling raf, or because the game is struggling with performance
                    // because you're asking it to do too much on the device.
                    if (time > this.nextFpsUpdate) {
                        //  Compute the new exponential moving average with an alpha of 0.25.
                        this.actualFps = 0.25 * this.framesThisSecond + 0.75 * this.actualFps;
                        this.nextFpsUpdate = time + 1000;
                        this.framesThisSecond = 0;
                    }
                    this.framesThisSecond++;
                    //  Interpolation - how far between what is expected and where we are?
                    var interpolation = avg / this._target;
                    this.callback(time, avg, interpolation);
                    //  Shift time value over
                    this.lastTime = time;
                    this.frame++;
                },
                /**
     * Manually calls `TimeStep.step`.
     *
     * @method Phaser.Core.TimeStep#tick
     * @since 3.0.0
     */ tick: function() {
                    this.step();
                },
                /**
     * Sends the TimeStep to sleep, stopping Request Animation Frame (or SetTimeout) and toggling the `running` flag to false.
     *
     * @method Phaser.Core.TimeStep#sleep
     * @since 3.0.0
     */ sleep: function() {
                    if (this.running) {
                        this.raf.stop();
                        this.running = false;
                    }
                },
                /**
     * Wakes-up the TimeStep, restarting Request Animation Frame (or SetTimeout) and toggling the `running` flag to true.
     * The `seamless` argument controls if the wake-up should adjust the start time or not.
     *
     * @method Phaser.Core.TimeStep#wake
     * @since 3.0.0
     *
     * @param {boolean} [seamless=false] - Adjust the startTime based on the lastTime values.
     */ wake: function(seamless) {
                    if (this.running) return;
                    else if (seamless) this.startTime += -this.lastTime + (this.lastTime + window.performance.now());
                    this.raf.start(this.step.bind(this), this.useRAF);
                    this.running = true;
                    this.step();
                },
                /**
     * Gets the duration which the game has been running, in seconds.
     *
     * @method Phaser.Core.TimeStep#getDuration
     * @since 3.17.0
     *
     * @return {number} The duration in seconds.
     */ getDuration: function() {
                    return Math.round(this.lastTime - this.startTime) / 1000;
                },
                /**
     * Gets the duration which the game has been running, in ms.
     *
     * @method Phaser.Core.TimeStep#getDurationMS
     * @since 3.17.0
     *
     * @return {number} The duration in ms.
     */ getDurationMS: function() {
                    return Math.round(this.lastTime - this.startTime);
                },
                /**
     * Stops the TimeStep running.
     *
     * @method Phaser.Core.TimeStep#stop
     * @since 3.0.0
     *
     * @return {this} The TimeStep object.
     */ stop: function() {
                    this.running = false;
                    this.started = false;
                    this.raf.stop();
                    return this;
                },
                /**
     * Destroys the TimeStep. This will stop Request Animation Frame, stop the step, clear the callbacks and null
     * any objects.
     *
     * @method Phaser.Core.TimeStep#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stop();
                    this.callback = NOOP;
                    this.raf = null;
                    this.game = null;
                }
            });
            module1.exports = TimeStep;
        /***/ },
        /* 380 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * Abstracts away the use of RAF or setTimeOut for the core game update loop.
 * This is invoked automatically by the Phaser.Game instance.
 *
 * @class RequestAnimationFrame
 * @memberof Phaser.DOM
 * @constructor
 * @since 3.0.0
 */ var RequestAnimationFrame = new Class({
                initialize: function RequestAnimationFrame() {
                    /**
         * True if RequestAnimationFrame is running, otherwise false.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isRunning
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isRunning = false;
                    /**
         * The callback to be invoked each step.
         *
         * @name Phaser.DOM.RequestAnimationFrame#callback
         * @type {FrameRequestCallback}
         * @since 3.0.0
         */ this.callback = NOOP;
                    /**
         * The most recent timestamp. Either a DOMHighResTimeStamp under RAF or `Date.now` under SetTimeout.
         *
         * @name Phaser.DOM.RequestAnimationFrame#tick
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.tick = 0;
                    /**
         * True if the step is using setTimeout instead of RAF.
         *
         * @name Phaser.DOM.RequestAnimationFrame#isSetTimeOut
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isSetTimeOut = false;
                    /**
         * The setTimeout or RAF callback ID used when canceling them.
         *
         * @name Phaser.DOM.RequestAnimationFrame#timeOutID
         * @type {?number}
         * @default null
         * @since 3.0.0
         */ this.timeOutID = null;
                    /**
         * The previous time the step was called.
         *
         * @name Phaser.DOM.RequestAnimationFrame#lastTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lastTime = 0;
                    /**
         * The target FPS rate in ms.
         * Only used when setTimeout is used instead of RAF.
         *
         * @name Phaser.DOM.RequestAnimationFrame#target
         * @type {number}
         * @default 0
         * @since 3.21.0
         */ this.target = 0;
                    var _this = this;
                    /**
         * The RAF step function.
         * Updates the local tick value, invokes the callback and schedules another call to requestAnimationFrame.
         *
         * @name Phaser.DOM.RequestAnimationFrame#step
         * @type {FrameRequestCallback}
         * @since 3.0.0
         */ this.step = function step() {
                        //  Because we cannot trust the time passed to this callback from the browser and need it kept in sync with event times
                        var timestamp = window.performance.now();
                        //  DOMHighResTimeStamp
                        _this.lastTime = _this.tick;
                        _this.tick = timestamp;
                        _this.callback(timestamp);
                        _this.timeOutID = window.requestAnimationFrame(step);
                    };
                    /**
         * The SetTimeout step function.
         * Updates the local tick value, invokes the callback and schedules another call to setTimeout.
         *
         * @name Phaser.DOM.RequestAnimationFrame#stepTimeout
         * @type {function}
         * @since 3.0.0
         */ this.stepTimeout = function stepTimeout() {
                        var d = Date.now();
                        var delay = Math.min(Math.max(_this.target * 2 + _this.tick - d, 0), _this.target);
                        _this.lastTime = _this.tick;
                        _this.tick = d;
                        _this.callback(d);
                        _this.timeOutID = window.setTimeout(stepTimeout, delay);
                    };
                },
                /**
     * Starts the requestAnimationFrame or setTimeout process running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#start
     * @since 3.0.0
     *
     * @param {FrameRequestCallback} callback - The callback to invoke each step.
     * @param {boolean} forceSetTimeOut - Should it use SetTimeout, even if RAF is available?
     * @param {number} targetFPS - The target fps rate (in ms). Only used when setTimeout is used.
     */ start: function(callback, forceSetTimeOut, targetFPS) {
                    if (this.isRunning) return;
                    this.callback = callback;
                    this.isSetTimeOut = forceSetTimeOut;
                    this.target = targetFPS;
                    this.isRunning = true;
                    this.timeOutID = forceSetTimeOut ? window.setTimeout(this.stepTimeout, 0) : window.requestAnimationFrame(this.step);
                },
                /**
     * Stops the requestAnimationFrame or setTimeout from running.
     *
     * @method Phaser.DOM.RequestAnimationFrame#stop
     * @since 3.0.0
     */ stop: function() {
                    this.isRunning = false;
                    if (this.isSetTimeOut) clearTimeout(this.timeOutID);
                    else window.cancelAnimationFrame(this.timeOutID);
                },
                /**
     * Stops the step from running and clears the callback reference.
     *
     * @method Phaser.DOM.RequestAnimationFrame#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stop();
                    this.callback = NOOP;
                }
            });
            module1.exports = RequestAnimationFrame;
        /***/ },
        /* 381 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(22);
            /**
 * The Visibility Handler is responsible for listening out for document level visibility change events.
 * This includes `visibilitychange` if the browser supports it, and blur and focus events. It then uses
 * the provided Event Emitter and fires the related events.
 *
 * @function Phaser.Core.VisibilityHandler
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance this Visibility Handler is working on.
 */ var VisibilityHandler = function(game) {
                var hiddenVar;
                var eventEmitter = game.events;
                if (document.hidden !== undefined) hiddenVar = 'visibilitychange';
                else {
                    var vendors = [
                        'webkit',
                        'moz',
                        'ms'
                    ];
                    vendors.forEach(function(prefix) {
                        if (document[prefix + 'Hidden'] !== undefined) {
                            document.hidden = function() {
                                return document[prefix + 'Hidden'];
                            };
                            hiddenVar = prefix + 'visibilitychange';
                        }
                    });
                }
                var onChange = function(event) {
                    if (document.hidden || event.type === 'pause') eventEmitter.emit(Events.HIDDEN);
                    else eventEmitter.emit(Events.VISIBLE);
                };
                if (hiddenVar) document.addEventListener(hiddenVar, onChange, false);
                window.onblur = function() {
                    eventEmitter.emit(Events.BLUR);
                };
                window.onfocus = function() {
                    eventEmitter.emit(Events.FOCUS);
                };
                //  Automatically give the window focus unless config says otherwise
                if (window.focus && game.config.autoFocus) window.focus();
            };
            module1.exports = VisibilityHandler;
        /***/ },
        /* 382 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arne16 = __webpack_require__(383);
            var CanvasPool = __webpack_require__(31);
            var GetValue = __webpack_require__(6);
            /**
 * Generates a texture based on the given Create configuration object.
 * 
 * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
 * data cells map to a single color. For example, if the texture config looked like this:
 *
 * ```javascript
 * var star = [
 *   '.....828.....',
 *   '....72227....',
 *   '....82228....',
 *   '...7222227...',
 *   '2222222222222',
 *   '8222222222228',
 *   '.72222222227.',
 *   '..787777787..',
 *   '..877777778..',
 *   '.78778887787.',
 *   '.27887.78872.',
 *   '.787.....787.'
 * ];
 * 
 * this.textures.generate('star', { data: star, pixelWidth: 4 });
 * ```
 * 
 * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
 * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
 * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
 * 
 * The default palette is Arne16, but you can specify your own using the `palette` property.
 *
 * @function Phaser.Create.GenerateTexture
 * @since 3.0.0
 *
 * @param {Phaser.Types.Create.GenerateTextureConfig} config - The Generate Texture Configuration object.
 *
 * @return {HTMLCanvasElement} An HTMLCanvasElement which contains the generated texture drawn to it.
 */ var GenerateTexture = function(config) {
                var data = GetValue(config, 'data', []);
                var canvas = GetValue(config, 'canvas', null);
                var palette = GetValue(config, 'palette', Arne16);
                var pixelWidth = GetValue(config, 'pixelWidth', 1);
                var pixelHeight = GetValue(config, 'pixelHeight', pixelWidth);
                var resizeCanvas = GetValue(config, 'resizeCanvas', true);
                var clearCanvas = GetValue(config, 'clearCanvas', true);
                var preRender = GetValue(config, 'preRender', null);
                var postRender = GetValue(config, 'postRender', null);
                var width = Math.floor(Math.abs(data[0].length * pixelWidth));
                var height = Math.floor(Math.abs(data.length * pixelHeight));
                if (!canvas) {
                    canvas = CanvasPool.create2D(this, width, height);
                    resizeCanvas = false;
                    clearCanvas = false;
                }
                if (resizeCanvas) {
                    canvas.width = width;
                    canvas.height = height;
                }
                var ctx = canvas.getContext('2d');
                if (clearCanvas) ctx.clearRect(0, 0, width, height);
                //  preRender Callback?
                if (preRender) preRender(canvas, ctx);
                //  Draw it
                for(var y = 0; y < data.length; y++){
                    var row = data[y];
                    for(var x = 0; x < row.length; x++){
                        var d = row[x];
                        if (d !== '.' && d !== ' ') {
                            ctx.fillStyle = palette[d];
                            ctx.fillRect(x * pixelWidth, y * pixelHeight, pixelWidth, pixelHeight);
                        }
                    }
                }
                //  postRender Callback?
                if (postRender) postRender(canvas, ctx);
                return canvas;
            };
            module1.exports = GenerateTexture;
        /***/ },
        /* 383 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.ARNE16
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: '#000',
                1: '#9D9D9D',
                2: '#FFF',
                3: '#BE2633',
                4: '#E06F8B',
                5: '#493C2B',
                6: '#A46422',
                7: '#EB8931',
                8: '#F7E26B',
                9: '#2F484E',
                A: '#44891A',
                B: '#A3CE27',
                C: '#1B2632',
                D: '#005784',
                E: '#31A2F2',
                F: '#B2DCEF'
            };
        /***/ },
        /* 384 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var CubicBezier = __webpack_require__(352);
            var Curve = __webpack_require__(90);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A higher-order Bézier curve constructed of four points.
 *
 * @class CubicBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|Phaser.Math.Vector2[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 * @param {Phaser.Math.Vector2} p3 - End Point.
 */ var CubicBezierCurve = new Class({
                Extends: Curve,
                initialize: function CubicBezierCurve(p0, p1, p2, p3) {
                    Curve.call(this, 'CubicBezierCurve');
                    if (Array.isArray(p0)) {
                        p3 = new Vector2(p0[6], p0[7]);
                        p2 = new Vector2(p0[4], p0[5]);
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The start point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                    /**
         * The first control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                    /**
         * The second control point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p2 = p2;
                    /**
         * The end point of this curve.
         *
         * @name Phaser.Curves.CubicBezier#p3
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p3 = p3;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.CubicBezier#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Returns the resolution of this curve.
     *
     * @method Phaser.Curves.CubicBezier#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - The amount of divisions used by this curve.
     *
     * @return {number} The resolution of the curve.
     */ getResolution: function(divisions) {
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.CubicBezier#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var p0 = this.p0;
                    var p1 = this.p1;
                    var p2 = this.p2;
                    var p3 = this.p3;
                    return out.set(CubicBezier(t, p0.x, p1.x, p2.x, p3.x), CubicBezier(t, p0.y, p1.y, p2.y, p3.y));
                },
                /**
     * Draws this curve to the specified graphics object.
     *
     * @method Phaser.Curves.CubicBezier#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The graphics object this curve should be drawn to.
     * @param {number} [pointsTotal=32] - The number of intermediary points that make up this curve. A higher number of points will result in a smoother curve.
     *
     * @return {Phaser.GameObjects.Graphics} The graphics object this curve was drawn to. Useful for method chaining.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    var points = this.getPoints(pointsTotal);
                    graphics.beginPath();
                    graphics.moveTo(this.p0.x, this.p0.y);
                    for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                    graphics.strokePath();
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Returns a JSON object that describes this curve.
     *
     * @method Phaser.Curves.CubicBezier#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y,
                            this.p3.x,
                            this.p3.y
                        ]
                    };
                }
            });
            /**
 * Generates a curve from a JSON object.
 *
 * @function Phaser.Curves.CubicBezier.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.CubicBezier} The curve generated from the JSON object.
 */ CubicBezierCurve.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                var p2 = new Vector2(points[4], points[5]);
                var p3 = new Vector2(points[6], points[7]);
                return new CubicBezierCurve(p0, p1, p2, p3);
            };
            module1.exports = CubicBezierCurve;
        /***/ },
        /* 385 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(90);
            var DegToRad = __webpack_require__(35);
            var GetValue = __webpack_require__(6);
            var RadToDeg = __webpack_require__(193);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * An Elliptical Curve derived from the Base Curve class.
 * 
 * See https://en.wikipedia.org/wiki/Elliptic_curve for more details.
 *
 * @class Ellipse
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.Curves.EllipseCurveConfig)} [x=0] - The x coordinate of the ellipse, or an Ellipse Curve configuration object.
 * @param {number} [y=0] - The y coordinate of the ellipse.
 * @param {number} [xRadius=0] - The horizontal radius of ellipse.
 * @param {number} [yRadius=0] - The vertical radius of ellipse.
 * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
 * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
 * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
 * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
 */ var EllipseCurve = new Class({
                Extends: Curve,
                initialize: function EllipseCurve(x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                    if (typeof x === 'object') {
                        var config = x;
                        x = GetValue(config, 'x', 0);
                        y = GetValue(config, 'y', 0);
                        xRadius = GetValue(config, 'xRadius', 0);
                        yRadius = GetValue(config, 'yRadius', xRadius);
                        startAngle = GetValue(config, 'startAngle', 0);
                        endAngle = GetValue(config, 'endAngle', 360);
                        clockwise = GetValue(config, 'clockwise', false);
                        rotation = GetValue(config, 'rotation', 0);
                    } else {
                        if (yRadius === undefined) yRadius = xRadius;
                        if (startAngle === undefined) startAngle = 0;
                        if (endAngle === undefined) endAngle = 360;
                        if (clockwise === undefined) clockwise = false;
                        if (rotation === undefined) rotation = 0;
                    }
                    Curve.call(this, 'EllipseCurve');
                    //  Center point
                    /**
         * The center point of the ellipse. Used for calculating rotation.
         *
         * @name Phaser.Curves.Ellipse#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                    /**
         * The horizontal radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_xRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._xRadius = xRadius;
                    /**
         * The vertical radius of the ellipse.
         *
         * @name Phaser.Curves.Ellipse#_yRadius
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._yRadius = yRadius;
                    //  Radians
                    /**
         * The starting angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_startAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._startAngle = DegToRad(startAngle);
                    /**
         * The end angle of the ellipse in radians.
         *
         * @name Phaser.Curves.Ellipse#_endAngle
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._endAngle = DegToRad(endAngle);
                    /**
         * Anti-clockwise direction.
         *
         * @name Phaser.Curves.Ellipse#_clockwise
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._clockwise = clockwise;
                    /**
         * The rotation of the arc.
         *
         * @name Phaser.Curves.Ellipse#_rotation
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._rotation = DegToRad(rotation);
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Ellipse#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(0, out);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Ellipse#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions * 2;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Ellipse#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var twoPi = Math.PI * 2;
                    var deltaAngle = this._endAngle - this._startAngle;
                    var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                    // ensures that deltaAngle is 0 .. 2 PI
                    while(deltaAngle < 0)deltaAngle += twoPi;
                    while(deltaAngle > twoPi)deltaAngle -= twoPi;
                    if (deltaAngle < Number.EPSILON) {
                        if (samePoints) deltaAngle = 0;
                        else deltaAngle = twoPi;
                    }
                    if (this._clockwise && !samePoints) {
                        if (deltaAngle === twoPi) deltaAngle = -twoPi;
                        else deltaAngle = deltaAngle - twoPi;
                    }
                    var angle = this._startAngle + t * deltaAngle;
                    var x = this.p0.x + this._xRadius * Math.cos(angle);
                    var y = this.p0.y + this._yRadius * Math.sin(angle);
                    if (this._rotation !== 0) {
                        var cos = Math.cos(this._rotation);
                        var sin = Math.sin(this._rotation);
                        var tx = x - this.p0.x;
                        var ty = y - this.p0.y;
                        // Rotate the point about the center of the ellipse.
                        x = tx * cos - ty * sin + this.p0.x;
                        y = tx * sin + ty * cos + this.p0.y;
                    }
                    return out.set(x, y);
                },
                /**
     * Sets the horizontal radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setXRadius
     * @since 3.0.0
     *
     * @param {number} value - The horizontal radius of this curve.
     *
     * @return {this} This curve object.
     */ setXRadius: function(value) {
                    this.xRadius = value;
                    return this;
                },
                /**
     * Sets the vertical radius of this curve.
     *
     * @method Phaser.Curves.Ellipse#setYRadius
     * @since 3.0.0
     *
     * @param {number} value - The vertical radius of this curve.
     *
     * @return {this} This curve object.
     */ setYRadius: function(value) {
                    this.yRadius = value;
                    return this;
                },
                /**
     * Sets the width of this curve.
     *
     * @method Phaser.Curves.Ellipse#setWidth
     * @since 3.0.0
     *
     * @param {number} value - The width of this curve.
     *
     * @return {this} This curve object.
     */ setWidth: function(value) {
                    this.xRadius = value / 2;
                    return this;
                },
                /**
     * Sets the height of this curve.
     *
     * @method Phaser.Curves.Ellipse#setHeight
     * @since 3.0.0
     *
     * @param {number} value - The height of this curve.
     *
     * @return {this} This curve object.
     */ setHeight: function(value) {
                    this.yRadius = value / 2;
                    return this;
                },
                /**
     * Sets the start angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setStartAngle
     * @since 3.0.0
     *
     * @param {number} value - The start angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setStartAngle: function(value) {
                    this.startAngle = value;
                    return this;
                },
                /**
     * Sets the end angle of this curve.
     *
     * @method Phaser.Curves.Ellipse#setEndAngle
     * @since 3.0.0
     *
     * @param {number} value - The end angle of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setEndAngle: function(value) {
                    this.endAngle = value;
                    return this;
                },
                /**
     * Sets if this curve extends clockwise or anti-clockwise.
     *
     * @method Phaser.Curves.Ellipse#setClockwise
     * @since 3.0.0
     *
     * @param {boolean} value - The clockwise state of this curve.
     *
     * @return {this} This curve object.
     */ setClockwise: function(value) {
                    this.clockwise = value;
                    return this;
                },
                /**
     * Sets the rotation of this curve.
     *
     * @method Phaser.Curves.Ellipse#setRotation
     * @since 3.0.0
     *
     * @param {number} value - The rotation of this curve, in radians.
     *
     * @return {this} This curve object.
     */ setRotation: function(value) {
                    this.rotation = value;
                    return this;
                },
                /**
     * The x coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.p0.x;
                    },
                    set: function(value) {
                        this.p0.x = value;
                    }
                },
                /**
     * The y coordinate of the center of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.p0.y;
                    },
                    set: function(value) {
                        this.p0.y = value;
                    }
                },
                /**
     * The horizontal radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#xRadius
     * @type {number}
     * @since 3.0.0
     */ xRadius: {
                    get: function() {
                        return this._xRadius;
                    },
                    set: function(value) {
                        this._xRadius = value;
                    }
                },
                /**
     * The vertical radius of the ellipse.
     *
     * @name Phaser.Curves.Ellipse#yRadius
     * @type {number}
     * @since 3.0.0
     */ yRadius: {
                    get: function() {
                        return this._yRadius;
                    },
                    set: function(value) {
                        this._yRadius = value;
                    }
                },
                /**
     * The start angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#startAngle
     * @type {number}
     * @since 3.0.0
     */ startAngle: {
                    get: function() {
                        return RadToDeg(this._startAngle);
                    },
                    set: function(value) {
                        this._startAngle = DegToRad(value);
                    }
                },
                /**
     * The end angle of the ellipse in degrees.
     *
     * @name Phaser.Curves.Ellipse#endAngle
     * @type {number}
     * @since 3.0.0
     */ endAngle: {
                    get: function() {
                        return RadToDeg(this._endAngle);
                    },
                    set: function(value) {
                        this._endAngle = DegToRad(value);
                    }
                },
                /**
     * `true` if the ellipse rotation is clockwise or `false` if anti-clockwise.
     *
     * @name Phaser.Curves.Ellipse#clockwise
     * @type {boolean}
     * @since 3.0.0
     */ clockwise: {
                    get: function() {
                        return this._clockwise;
                    },
                    set: function(value) {
                        this._clockwise = value;
                    }
                },
                /**
     * The rotation of the ellipse, relative to the center, in degrees.
     *
     * @name Phaser.Curves.Ellipse#angle
     * @type {number}
     * @since 3.14.0
     */ angle: {
                    get: function() {
                        return RadToDeg(this._rotation);
                    },
                    set: function(value) {
                        this._rotation = DegToRad(value);
                    }
                },
                /**
     * The rotation of the ellipse, relative to the center, in radians.
     *
     * @name Phaser.Curves.Ellipse#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this._rotation;
                    },
                    set: function(value) {
                        this._rotation = value;
                    }
                },
                /**
     * JSON serialization of the curve.
     *
     * @method Phaser.Curves.Ellipse#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONEllipseCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        x: this.p0.x,
                        y: this.p0.y,
                        xRadius: this._xRadius,
                        yRadius: this._yRadius,
                        startAngle: RadToDeg(this._startAngle),
                        endAngle: RadToDeg(this._endAngle),
                        clockwise: this._clockwise,
                        rotation: RadToDeg(this._rotation)
                    };
                }
            });
            /**
 * Creates a curve from the provided Ellipse Curve Configuration object.
 *
 * @function Phaser.Curves.Ellipse.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONEllipseCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Ellipse} The ellipse curve constructed from the configuration object.
 */ EllipseCurve.fromJSON = function(data) {
                return new EllipseCurve(data);
            };
            module1.exports = EllipseCurve;
        /***/ },
        /* 386 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(90);
            var FromPoints = __webpack_require__(196);
            var Rectangle = __webpack_require__(10);
            var Vector2 = __webpack_require__(3);
            var tmpVec2 = new Vector2();
            /**
 * @classdesc
 * A LineCurve is a "curve" comprising exactly two points (a line segment).
 *
 * @class Line
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - The first endpoint.
 * @param {Phaser.Math.Vector2} [p1] - The second endpoint.
 */ var LineCurve = new Class({
                Extends: Curve,
                initialize: //  vec2s or array
                function LineCurve(p0, p1) {
                    Curve.call(this, 'LineCurve');
                    if (Array.isArray(p0)) {
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The first endpoint.
         *
         * @name Phaser.Curves.Line#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = p0;
                    /**
         * The second endpoint.
         *
         * @name Phaser.Curves.Line#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p1 = p1;
                    //  Override default Curve.arcLengthDivisions
                    /**
         * The quantity of arc length divisions within the curve.
         *
         * @name Phaser.Curves.Line#arcLengthDivisions
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.arcLengthDivisions = 1;
                },
                /**
     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
     *
     * @method Phaser.Curves.Line#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the bounds in. If not given a new Rectangle will be created.
     *
     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
     */ getBounds: function(out) {
                    if (out === undefined) out = new Rectangle();
                    return FromPoints([
                        this.p0,
                        this.p1
                    ], out);
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Line#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Gets the resolution of the line.
     *
     * @method Phaser.Curves.Line#getResolution
     * @since 3.0.0
     *
     * @param {number} [divisions=1] - The number of divisions to consider.
     *
     * @return {number} The resolution. Equal to the number of divisions.
     */ getResolution: function(divisions) {
                    if (divisions === undefined) divisions = 1;
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Line#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    if (t === 1) return out.copy(this.p1);
                    out.copy(this.p1).subtract(this.p0).scale(t).add(this.p0);
                    return out;
                },
                // Line curve is linear, so we can overwrite default getPointAt
                /**
     * Gets a point at a given position on the line.
     *
     * @method Phaser.Curves.Line#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPointAt: function(u, out) {
                    return this.getPoint(u, out);
                },
                /**
     * Gets the slope of the line as a unit vector.
     *
     * @method Phaser.Curves.Line#getTangent
     * @since 3.0.0
     * 
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @return {Phaser.Math.Vector2} The tangent vector.
     */ getTangent: function() {
                    var tangent = tmpVec2.copy(this.p1).subtract(this.p0);
                    return tangent.normalize();
                },
                /**
     * Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant.
     *
     * @method Phaser.Curves.Line#getUtoTmapping
     * @since 3.0.0
     *
     * @param {number} u - A float between 0 and 1.
     * @param {number} distance - The distance, in pixels.
     * @param {number} [divisions] - Optional amount of divisions.
     *
     * @return {number} The equidistant value.
     */ getUtoTmapping: function(u, distance, divisions) {
                    var t;
                    if (distance) {
                        var arcLengths = this.getLengths(divisions);
                        var lineLength = arcLengths[arcLengths.length - 1];
                        //  Cannot overshoot the curve
                        var targetLineLength = Math.min(distance, lineLength);
                        t = targetLineLength / lineLength;
                    } else t = u;
                    return t;
                },
                //  Override default Curve.draw because this is better than calling getPoints on a line!
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.lineBetween` so will be drawn at whatever the present Graphics line color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.Line#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
     */ draw: function(graphics) {
                    graphics.lineBetween(this.p0.x, this.p0.y, this.p1.x, this.p1.y);
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Gets a JSON representation of the line.
     *
     * @method Phaser.Curves.Line#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y
                        ]
                    };
                }
            });
            /**
 * Configures this line from a JSON representation.
 *
 * @function Phaser.Curves.Line.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Line} A new LineCurve object.
 */ LineCurve.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                return new LineCurve(p0, p1);
            };
            module1.exports = LineCurve;
        /***/ },
        /* 387 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A MoveTo Curve is a very simple curve consisting of only a single point.
 * Its intended use is to move the ending point in a Path.
 *
 * @class MoveTo
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - `x` pixel coordinate.
 * @param {number} [y=0] - `y` pixel coordinate.
 */ var MoveTo = new Class({
                initialize: function MoveTo(x, y) {
                    /**
         * Denotes that this Curve does not influence the bounds, points, and drawing of its parent Path. Must be `false` or some methods in the parent Path will throw errors.
         *
         * @name Phaser.Curves.MoveTo#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                    /**
         * The lone point which this curve consists of.
         *
         * @name Phaser.Curves.MoveTo#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.p0 = new Vector2(x, y);
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.MoveTo#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Retrieves the point at given position in the curve. This will always return this curve's only point.
     *
     * @method Phaser.Curves.MoveTo#getPointAt
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} u - The position in the path to retrieve, between 0 and 1. Not used.
     * @param {Phaser.Math.Vector2} [out] - An optional vector in which to store the point.
     *
     * @return {Phaser.Math.Vector2} The modified `out` vector, or a new `Vector2` if none was provided.
     */ getPointAt: function(u, out) {
                    return this.getPoint(u, out);
                },
                /**
     * Gets the resolution of this curve.
     *
     * @method Phaser.Curves.MoveTo#getResolution
     * @since 3.0.0
     *
     * @return {number} The resolution of this curve. For a MoveTo the value is always 1.
     */ getResolution: function() {
                    return 1;
                },
                /**
     * Gets the length of this curve.
     *
     * @method Phaser.Curves.MoveTo#getLength
     * @since 3.0.0
     *
     * @return {number} The length of this curve. For a MoveTo the value is always 0.
     */ getLength: function() {
                    return 0;
                },
                /**
     * Converts this curve into a JSON-serializable object.
     *
     * @method Phaser.Curves.MoveTo#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} A primitive object with the curve's type and only point.
     */ toJSON: function() {
                    return {
                        type: 'MoveTo',
                        points: [
                            this.p0.x,
                            this.p0.y
                        ]
                    };
                }
            });
            module1.exports = MoveTo;
        /***/ },
        /* 388 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Curve = __webpack_require__(90);
            var QuadraticBezierInterpolation = __webpack_require__(353);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A quadratic Bézier curve constructed from two control points.
 *
 * @class QuadraticBezier
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.2.0
 *
 * @param {(Phaser.Math.Vector2|number[])} p0 - Start point, or an array of point pairs.
 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
 */ var QuadraticBezier = new Class({
                Extends: Curve,
                initialize: function QuadraticBezier(p0, p1, p2) {
                    Curve.call(this, 'QuadraticBezier');
                    if (Array.isArray(p0)) {
                        p2 = new Vector2(p0[4], p0[5]);
                        p1 = new Vector2(p0[2], p0[3]);
                        p0 = new Vector2(p0[0], p0[1]);
                    }
                    /**
         * The start point.
         *
         * @name Phaser.Curves.QuadraticBezier#p0
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p0 = p0;
                    /**
         * The first control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p1
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p1 = p1;
                    /**
         * The second control point.
         *
         * @name Phaser.Curves.QuadraticBezier#p2
         * @type {Phaser.Math.Vector2}
         * @since 3.2.0
         */ this.p2 = p2;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getStartPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.p0);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.QuadraticBezier#getResolution
     * @since 3.2.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.QuadraticBezier#getPoint
     * @since 3.2.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var p0 = this.p0;
                    var p1 = this.p1;
                    var p2 = this.p2;
                    return out.set(QuadraticBezierInterpolation(t, p0.x, p1.x, p2.x), QuadraticBezierInterpolation(t, p0.y, p1.y, p2.y));
                },
                /**
     * Draws this curve on the given Graphics object.
     *
     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
     *
     * @method Phaser.Curves.QuadraticBezier#draw
     * @since 3.2.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - `Graphics` object to draw onto.
     * @param {number} [pointsTotal=32] - Number of points to be used for drawing the curve. Higher numbers result in smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} `Graphics` object that was drawn to.
     */ draw: function(graphics, pointsTotal) {
                    if (pointsTotal === undefined) pointsTotal = 32;
                    var points = this.getPoints(pointsTotal);
                    graphics.beginPath();
                    graphics.moveTo(this.p0.x, this.p0.y);
                    for(var i = 1; i < points.length; i++)graphics.lineTo(points[i].x, points[i].y);
                    graphics.strokePath();
                    //  So you can chain graphics calls
                    return graphics;
                },
                /**
     * Converts the curve into a JSON compatible object.
     *
     * @method Phaser.Curves.QuadraticBezier#toJSON
     * @since 3.2.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    return {
                        type: this.type,
                        points: [
                            this.p0.x,
                            this.p0.y,
                            this.p1.x,
                            this.p1.y,
                            this.p2.x,
                            this.p2.y
                        ]
                    };
                }
            });
            /**
 * Creates a curve from a JSON object, e. g. created by `toJSON`.
 *
 * @function Phaser.Curves.QuadraticBezier.fromJSON
 * @since 3.2.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.QuadraticBezier} The created curve instance.
 */ QuadraticBezier.fromJSON = function(data) {
                var points = data.points;
                var p0 = new Vector2(points[0], points[1]);
                var p1 = new Vector2(points[2], points[3]);
                var p2 = new Vector2(points[4], points[5]);
                return new QuadraticBezier(p0, p1, p2);
            };
            module1.exports = QuadraticBezier;
        /***/ },
        /* 389 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var CatmullRom = __webpack_require__(191);
            var Class = __webpack_require__(0);
            var Curve = __webpack_require__(90);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * Create a smooth 2d spline curve from a series of points.
 *
 * @class Spline
 * @extends Phaser.Curves.Curve
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {(Phaser.Math.Vector2[]|number[]|number[][])} [points] - The points that configure the curve.
 */ var SplineCurve = new Class({
                Extends: Curve,
                initialize: function SplineCurve(points) {
                    if (points === undefined) points = [];
                    Curve.call(this, 'SplineCurve');
                    /**
         * The Vector2 points that configure the curve.
         *
         * @name Phaser.Curves.Spline#points
         * @type {Phaser.Math.Vector2[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                    this.addPoints(points);
                },
                /**
     * Add a list of points to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoints
     * @since 3.0.0
     *
     * @param {(Phaser.Math.Vector2[]|number[]|number[][])} points - The points that configure the curve.
     *
     * @return {this} This curve object.
     */ addPoints: function(points) {
                    for(var i = 0; i < points.length; i++){
                        var p = new Vector2();
                        if (typeof points[i] === 'number') {
                            p.x = points[i];
                            p.y = points[i + 1];
                            i++;
                        } else if (Array.isArray(points[i])) {
                            //  An array of arrays?
                            p.x = points[i][0];
                            p.y = points[i][1];
                        } else {
                            p.x = points[i].x;
                            p.y = points[i].y;
                        }
                        this.points.push(p);
                    }
                    return this;
                },
                /**
     * Add a point to the current list of Vector2 points of the curve.
     *
     * @method Phaser.Curves.Spline#addPoint
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of this curve
     * @param {number} y - The y coordinate of this curve
     *
     * @return {Phaser.Math.Vector2} The new Vector2 added to the curve
     */ addPoint: function(x, y) {
                    var vec = new Vector2(x, y);
                    this.points.push(vec);
                    return vec;
                },
                /**
     * Gets the starting point on the curve.
     *
     * @method Phaser.Curves.Spline#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.points[0]);
                },
                /**
     * Get the resolution of the curve.
     *
     * @method Phaser.Curves.Spline#getResolution
     * @since 3.0.0
     *
     * @param {number} divisions - Optional divisions value.
     *
     * @return {number} The curve resolution.
     */ getResolution: function(divisions) {
                    return divisions * this.points.length;
                },
                /**
     * Get point at relative position in curve according to length.
     *
     * @method Phaser.Curves.Spline#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The position along the curve to return. Where 0 is the start and 1 is the end.
     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
     *
     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var points = this.points;
                    var point = (points.length - 1) * t;
                    var intPoint = Math.floor(point);
                    var weight = point - intPoint;
                    var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                    var p1 = points[intPoint];
                    var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                    var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                    return out.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                },
                /**
     * Exports a JSON object containing this curve data.
     *
     * @method Phaser.Curves.Spline#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONCurve} The JSON object containing this curve data.
     */ toJSON: function() {
                    var points = [];
                    for(var i = 0; i < this.points.length; i++){
                        points.push(this.points[i].x);
                        points.push(this.points[i].y);
                    }
                    return {
                        type: this.type,
                        points: points
                    };
                }
            });
            /**
 * Imports a JSON object containing this curve data.
 *
 * @function Phaser.Curves.Spline.fromJSON
 * @since 3.0.0
 *
 * @param {Phaser.Types.Curves.JSONCurve} data - The JSON object containing this curve data.
 *
 * @return {Phaser.Curves.Spline} The spline curve created.
 */ SplineCurve.fromJSON = function(data) {
                return new SplineCurve(data.points);
            };
            module1.exports = SplineCurve;
        /***/ },
        /* 390 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A BaseShader is a small resource class that contains the data required for a WebGL Shader to be created.
 *
 * It contains the raw source code to the fragment and vertex shader, as well as an object that defines
 * the uniforms the shader requires, if any.
 *
 * BaseShaders are stored in the Shader Cache, available in a Scene via `this.cache.shaders` and are referenced
 * by a unique key-based string. Retrieve them via `this.cache.shaders.get(key)`.
 *
 * BaseShaders are created automatically by the GLSL File Loader when loading an external shader resource.
 * They can also be created at runtime, allowing you to use dynamically generated shader source code.
 *
 * Default fragment and vertex source is used if not provided in the constructor, setting-up a basic shader,
 * suitable for debug rendering.
 *
 * @class BaseShader
 * @memberof Phaser.Display
 * @constructor
 * @since 3.17.0
 *
 * @param {string} key - The key of this shader. Must be unique within the shader cache.
 * @param {string} [fragmentSrc] - The fragment source for the shader.
 * @param {string} [vertexSrc] - The vertex source for the shader.
 * @param {any} [uniforms] - Optional object defining the uniforms the shader uses.
 */ var BaseShader = new Class({
                initialize: function BaseShader(key, fragmentSrc, vertexSrc, uniforms) {
                    if (!fragmentSrc || fragmentSrc === '') fragmentSrc = [
                        'precision mediump float;',
                        'uniform vec2 resolution;',
                        'varying vec2 fragCoord;',
                        'void main () {',
                        '    vec2 uv = fragCoord / resolution.xy;',
                        '    gl_FragColor = vec4(uv.xyx, 1.0);',
                        '}'
                    ].join('\n');
                    if (!vertexSrc || vertexSrc === '') vertexSrc = [
                        'precision mediump float;',
                        'uniform mat4 uProjectionMatrix;',
                        'uniform mat4 uViewMatrix;',
                        'uniform vec2 uResolution;',
                        'attribute vec2 inPosition;',
                        'varying vec2 fragCoord;',
                        'varying vec2 outTexCoord;',
                        'void main () {',
                        '   gl_Position = uProjectionMatrix * uViewMatrix * vec4(inPosition, 1.0, 1.0);',
                        '   fragCoord = vec2(inPosition.x, uResolution.y - inPosition.y);',
                        '   outTexCoord = vec2(inPosition.x / uResolution.x, fragCoord.y / uResolution.y);',
                        '}'
                    ].join('\n');
                    if (uniforms === undefined) uniforms = null;
                    /**
         * The key of this shader, unique within the shader cache of this Phaser game instance.
         *
         * @name Phaser.Display.BaseShader#key
         * @type {string}
         * @since 3.17.0
         */ this.key = key;
                    /**
         * The source code, as a string, of the fragment shader being used.
         *
         * @name Phaser.Display.BaseShader#fragmentSrc
         * @type {string}
         * @since 3.17.0
         */ this.fragmentSrc = fragmentSrc;
                    /**
         * The source code, as a string, of the vertex shader being used.
         *
         * @name Phaser.Display.BaseShader#vertexSrc
         * @type {string}
         * @since 3.17.0
         */ this.vertexSrc = vertexSrc;
                    /**
         * The default uniforms for this shader.
         *
         * @name Phaser.Display.BaseShader#uniforms
         * @type {?any}
         * @since 3.17.0
         */ this.uniforms = uniforms;
                }
            });
            module1.exports = BaseShader;
        /***/ },
        /* 391 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            Color.ColorSpectrum = __webpack_require__(905);
            Color.ColorToRGBA = __webpack_require__(906);
            Color.ComponentToHex = __webpack_require__(392);
            Color.GetColor = __webpack_require__(100);
            Color.GetColor32 = __webpack_require__(322);
            Color.HexStringToColor = __webpack_require__(321);
            Color.HSLToColor = __webpack_require__(907);
            Color.HSVColorWheel = __webpack_require__(908);
            Color.HSVToRGB = __webpack_require__(185);
            Color.HueToComponent = __webpack_require__(393);
            Color.IntegerToColor = __webpack_require__(186);
            Color.IntegerToRGB = __webpack_require__(324);
            Color.Interpolate = __webpack_require__(909);
            Color.ObjectToColor = __webpack_require__(325);
            Color.RandomRGB = __webpack_require__(910);
            Color.RGBStringToColor = __webpack_require__(326);
            Color.RGBToHSV = __webpack_require__(323);
            Color.RGBToString = __webpack_require__(911);
            Color.ValueToColor = __webpack_require__(184);
            module1.exports = Color;
        /***/ },
        /* 392 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns a string containing a hex representation of the given color component.
 *
 * @function Phaser.Display.Color.ComponentToHex
 * @since 3.0.0
 *
 * @param {number} color - The color channel to get the hex value for, must be a value between 0 and 255.
 *
 * @return {string} A string of length 2 characters, i.e. 255 = ff, 100 = 64.
 */ var ComponentToHex = function(color) {
                var hex = color.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            };
            module1.exports = ComponentToHex;
        /***/ },
        /* 393 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts a hue to an RGB color.
 * Based on code by Michael Jackson (https://github.com/mjijackson)
 *
 * @function Phaser.Display.Color.HueToComponent
 * @since 3.0.0
 *
 * @param {number} p
 * @param {number} q
 * @param {number} t
 *
 * @return {number} The combined color value.
 */ var HueToComponent = function(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            module1.exports = HueToComponent;
        /***/ },
        /* 394 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var OS = __webpack_require__(102);
            /**
 * @callback ContentLoadedCallback
 */ /**
 * Inspects the readyState of the document. If the document is already complete then it invokes the given callback.
 * If not complete it sets up several event listeners such as `deviceready`, and once those fire, it invokes the callback.
 * Called automatically by the Phaser.Game instance. Should not usually be accessed directly.
 *
 * @function Phaser.DOM.DOMContentLoaded
 * @since 3.0.0
 *
 * @param {ContentLoadedCallback} callback - The callback to be invoked when the device is ready and the DOM content is loaded.
 */ var DOMContentLoaded = function(callback) {
                if (document.readyState === 'complete' || document.readyState === 'interactive') {
                    callback();
                    return;
                }
                var check = function() {
                    document.removeEventListener('deviceready', check, true);
                    document.removeEventListener('DOMContentLoaded', check, true);
                    window.removeEventListener('load', check, true);
                    callback();
                };
                if (!document.body) window.setTimeout(check, 20);
                else if (OS.cordova) //  Ref. http://docs.phonegap.com/en/3.5.0/cordova_events_events.md.html#deviceready
                document.addEventListener('deviceready', check, false);
                else {
                    document.addEventListener('DOMContentLoaded', check, true);
                    window.addEventListener('load', check, true);
                }
            };
            module1.exports = DOMContentLoaded;
        /***/ },
        /* 395 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to determine the document inner height across iOS and standard devices.
 * Based on code by @tylerjpeterson
 *
 * @function Phaser.DOM.GetInnerHeight
 * @since 3.16.0
 *
 * @param {boolean} iOS - Is this running on iOS?
 *
 * @return {number} The inner height value.
 */ var GetInnerHeight = function(iOS) {
                if (!iOS) return window.innerHeight;
                var axis = Math.abs(window.orientation);
                var size = {
                    w: 0,
                    h: 0
                };
                var ruler = document.createElement('div');
                ruler.setAttribute('style', 'position: fixed; height: 100vh; width: 0; top: 0');
                document.documentElement.appendChild(ruler);
                size.w = axis === 90 ? ruler.offsetHeight : window.innerWidth;
                size.h = axis === 90 ? window.innerWidth : ruler.offsetHeight;
                document.documentElement.removeChild(ruler);
                ruler = null;
                if (Math.abs(window.orientation) !== 90) return size.h;
                else return size.w;
            };
            module1.exports = GetInnerHeight;
        /***/ },
        /* 396 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(198);
            /**
 * Attempts to determine the screen orientation using the Orientation API.
 *
 * @function Phaser.DOM.GetScreenOrientation
 * @since 3.16.0
 *
 * @param {number} width - The width of the viewport.
 * @param {number} height - The height of the viewport.
 *
 * @return {string} The orientation.
 */ var GetScreenOrientation = function(width, height) {
                var screen1 = window.screen;
                var orientation = screen1 ? screen1.orientation || screen1.mozOrientation || screen1.msOrientation : false;
                if (orientation && typeof orientation.type === 'string') //  Screen Orientation API specification
                return orientation.type;
                else if (typeof orientation === 'string') //  moz / ms-orientation are strings
                return orientation;
                if (typeof window.orientation === 'number') //  Do this check first, as iOS supports this, but also has an incomplete window.screen implementation
                //  This may change by device based on "natural" orientation.
                return window.orientation === 0 || window.orientation === 180 ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
                else if (window.matchMedia) {
                    if (window.matchMedia('(orientation: portrait)').matches) return CONST.ORIENTATION.PORTRAIT;
                    else if (window.matchMedia('(orientation: landscape)').matches) return CONST.ORIENTATION.LANDSCAPE;
                } else return height > width ? CONST.ORIENTATION.PORTRAIT : CONST.ORIENTATION.LANDSCAPE;
            };
            module1.exports = GetScreenOrientation;
        /***/ },
        /* 397 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 * 
 * @namespace Phaser.Scale.Center
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for centering the game canvas.
 * 
 * To find out what each mode does please see [Phaser.Scale.Center]{@link Phaser.Scale.Center}.
 * 
 * @typedef {Phaser.Scale.Center} Phaser.Scale.CenterType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * The game canvas is not centered within the parent by Phaser.
     * You can still center it yourself via CSS.
     * 
     * @name Phaser.Scale.Center.NO_CENTER
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_CENTER: 0,
                /**
     * The game canvas is centered both horizontally and vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_BOTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_BOTH: 1,
                /**
     * The game canvas is centered horizontally within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_HORIZONTALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_HORIZONTALLY: 2,
                /**
     * The game canvas is centered both vertically within the parent.
     * To do this, the parent has to have a bounds that can be calculated and not be empty.
     * 
     * Centering is achieved by setting the margin left and top properties of the
     * game canvas, and does not factor in any other CSS styles you may have applied.
     * 
     * @name Phaser.Scale.Center.CENTER_VERTICALLY
     * @type {number}
     * @const
     * @since 3.16.0
     */ CENTER_VERTICALLY: 3
            };
        /***/ },
        /* 398 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for orientation.
 * 
 * @namespace Phaser.Scale.Orientation
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for orientation.
 * 
 * To find out what each mode does please see [Phaser.Scale.Orientation]{@link Phaser.Scale.Orientation}.
 * 
 * @typedef {Phaser.Scale.Orientation} Phaser.Scale.OrientationType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * A landscape orientation.
     * 
     * @name Phaser.Scale.Orientation.LANDSCAPE
     * @type {string}
     * @const
     * @since 3.16.0
     */ LANDSCAPE: 'landscape-primary',
                /**
     * A portrait orientation.
     * 
     * @name Phaser.Scale.Orientation.PORTRAIT
     * @type {string}
     * @const
     * @since 3.16.0
     */ PORTRAIT: 'portrait-primary'
            };
        /***/ },
        /* 399 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 * 
 * @namespace Phaser.Scale.ScaleModes
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for the different scale modes available.
 * 
 * To find out what each mode does please see [Phaser.Scale.ScaleModes]{@link Phaser.Scale.ScaleModes}.
 * 
 * @typedef {Phaser.Scale.ScaleModes} Phaser.Scale.ScaleModeType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * No scaling happens at all. The canvas is set to the size given in the game config and Phaser doesn't change it
     * again from that point on. If you change the canvas size, either via CSS, or directly via code, then you need
     * to call the Scale Managers `resize` method to give the new dimensions, or input events will stop working.
     * 
     * @name Phaser.Scale.ScaleModes.NONE
     * @type {number}
     * @const
     * @since 3.16.0
     */ NONE: 0,
                /**
     * The height is automatically adjusted based on the width.
     * 
     * @name Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT
     * @type {number}
     * @const
     * @since 3.16.0
     */ WIDTH_CONTROLS_HEIGHT: 1,
                /**
     * The width is automatically adjusted based on the height.
     * 
     * @name Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH
     * @type {number}
     * @const
     * @since 3.16.0
     */ HEIGHT_CONTROLS_WIDTH: 2,
                /**
     * The width and height are automatically adjusted to fit inside the given target area,
     * while keeping the aspect ratio. Depending on the aspect ratio there may be some space
     * inside the area which is not covered.
     * 
     * @name Phaser.Scale.ScaleModes.FIT
     * @type {number}
     * @const
     * @since 3.16.0
     */ FIT: 3,
                /**
     * The width and height are automatically adjusted to make the size cover the entire target
     * area while keeping the aspect ratio. This may extend further out than the target size.
     * 
     * @name Phaser.Scale.ScaleModes.ENVELOP
     * @type {number}
     * @const
     * @since 3.16.0
     */ ENVELOP: 4,
                /**
     * The Canvas is resized to fit all available _parent_ space, regardless of aspect ratio.
     * 
     * @name Phaser.Scale.ScaleModes.RESIZE
     * @type {number}
     * @const
     * @since 3.16.0
     */ RESIZE: 5
            };
        /***/ },
        /* 400 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 * 
 * @namespace Phaser.Scale.Zoom
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ /**
 * Phaser Scale Manager constants for zoom modes.
 * 
 * To find out what each mode does please see [Phaser.Scale.Zoom]{@link Phaser.Scale.Zoom}.
 * 
 * @typedef {Phaser.Scale.Zoom} Phaser.Scale.ZoomType
 * @memberof Phaser.Scale
 * @since 3.16.0
 */ module1.exports = {
                /**
     * The game canvas will not be zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.NO_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ NO_ZOOM: 1,
                /**
     * The game canvas will be 2x zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.ZOOM_2X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_2X: 2,
                /**
     * The game canvas will be 4x zoomed by Phaser.
     * 
     * @name Phaser.Scale.Zoom.ZOOM_4X
     * @type {number}
     * @const
     * @since 3.16.0
     */ ZOOM_4X: 4,
                /**
     * Calculate the zoom value based on the maximum multiplied game size that will
     * fit into the parent, or browser window if no parent is set.
     * 
     * @name Phaser.Scale.Zoom.MAX_ZOOM
     * @type {number}
     * @const
     * @since 3.16.0
     */ MAX_ZOOM: -1
            };
        /***/ },
        /* 401 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Attempts to get the target DOM element based on the given value, which can be either
 * a string, in which case it will be looked-up by ID, or an element node. If nothing
 * can be found it will return a reference to the document.body.
 *
 * @function Phaser.DOM.GetTarget
 * @since 3.16.0
 *
 * @param {HTMLElement} element - The DOM element to look-up.
 */ var GetTarget = function(element) {
                var target;
                if (element !== '') {
                    if (typeof element === 'string') //  Hopefully an element ID
                    target = document.getElementById(element);
                    else if (element && element.nodeType === 1) //  Quick test for a HTMLElement
                    target = element;
                }
                //  Fallback to the document body. Covers an invalid ID and a non HTMLElement object.
                if (!target) //  Use the full window
                target = document.body;
                return target;
            };
            module1.exports = GetTarget;
        /***/ },
        /* 402 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given data string and parses it as XML.
 * First tries to use the window.DOMParser and reverts to the Microsoft.XMLDOM if that fails.
 * The parsed XML object is returned, or `null` if there was an error while parsing the data.
 *
 * @function Phaser.DOM.ParseXML
 * @since 3.0.0
 *
 * @param {string} data - The XML source stored in a string.
 *
 * @return {?(DOMParser|ActiveXObject)} The parsed XML data, or `null` if the data could not be parsed.
 */ var ParseXML = function(data) {
                var xml = '';
                try {
                    if (window['DOMParser']) {
                        var domparser = new DOMParser();
                        xml = domparser.parseFromString(data, 'text/xml');
                    } else {
                        xml = new ActiveXObject('Microsoft.XMLDOM');
                        xml.loadXML(data);
                    }
                } catch (e) {
                    xml = null;
                }
                if (!xml || !xml.documentElement || xml.getElementsByTagName('parsererror').length) return null;
                else return xml;
            };
            module1.exports = ParseXML;
        /***/ },
        /* 403 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(200);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(49);
            var GameEvents = __webpack_require__(22);
            var Keyboard = __webpack_require__(404);
            var Mouse = __webpack_require__(405);
            var Pointer = __webpack_require__(406);
            var Touch = __webpack_require__(407);
            var TransformMatrix = __webpack_require__(25);
            var TransformXY = __webpack_require__(174);
            /**
 * @classdesc
 * The Input Manager is responsible for handling the pointer related systems in a single Phaser Game instance.
 *
 * Based on the Game Config it will create handlers for mouse and touch support.
 *
 * Keyboard and Gamepad are plugins, handled directly by the InputPlugin class.
 *
 * It then manages the events, pointer creation and general hit test related operations.
 *
 * You rarely need to interact with the Input Manager directly, and as such, all of its properties and methods
 * should be considered private. Instead, you should use the Input Plugin, which is a Scene level system, responsible
 * for dealing with all input events for a Scene.
 *
 * @class InputManager
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Game instance that owns the Input Manager.
 * @param {object} config - The Input Configuration object, as set in the Game Config.
 */ var InputManager = new Class({
                initialize: function InputManager(game, config) {
                    /**
         * The Game instance that owns the Input Manager.
         * A Game only maintains on instance of the Input Manager at any time.
         *
         * @name Phaser.Input.InputManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.0.0
         */ this.game = game;
                    /**
         * A reference to the global Game Scale Manager.
         * Used for all bounds checks and pointer scaling.
         *
         * @name Phaser.Input.InputManager#scaleManager
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scaleManager;
                    /**
         * The Canvas that is used for all DOM event input listeners.
         *
         * @name Phaser.Input.InputManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas;
                    /**
         * The Game Configuration object, as set during the game boot.
         *
         * @name Phaser.Input.InputManager#config
         * @type {Phaser.Core.Config}
         * @since 3.0.0
         */ this.config = config;
                    /**
         * If set, the Input Manager will run its update loop every frame.
         *
         * @name Phaser.Input.InputManager#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * The Event Emitter instance that the Input Manager uses to emit events from.
         *
         * @name Phaser.Input.InputManager#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                    /**
         * Are any mouse or touch pointers currently over the game canvas?
         * This is updated automatically by the canvas over and out handlers.
         *
         * @name Phaser.Input.InputManager#isOver
         * @type {boolean}
         * @readonly
         * @since 3.16.0
         */ this.isOver = true;
                    /**
         * The default CSS cursor to be used when interacting with your game.
         *
         * See the `setDefaultCursor` method for more details.
         *
         * @name Phaser.Input.InputManager#defaultCursor
         * @type {string}
         * @since 3.10.0
         */ this.defaultCursor = '';
                    /**
         * A reference to the Keyboard Manager class, if enabled via the `input.keyboard` Game Config property.
         *
         * @name Phaser.Input.InputManager#keyboard
         * @type {?Phaser.Input.Keyboard.KeyboardManager}
         * @since 3.16.0
         */ this.keyboard = config.inputKeyboard ? new Keyboard(this) : null;
                    /**
         * A reference to the Mouse Manager class, if enabled via the `input.mouse` Game Config property.
         *
         * @name Phaser.Input.InputManager#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = config.inputMouse ? new Mouse(this) : null;
                    /**
         * A reference to the Touch Manager class, if enabled via the `input.touch` Game Config property.
         *
         * @name Phaser.Input.InputManager#touch
         * @type {Phaser.Input.Touch.TouchManager}
         * @since 3.0.0
         */ this.touch = config.inputTouch ? new Touch(this) : null;
                    /**
         * An array of Pointers that have been added to the game.
         * The first entry is reserved for the Mouse Pointer, the rest are Touch Pointers.
         *
         * By default there is 1 touch pointer enabled. If you need more use the `addPointer` method to start them,
         * or set the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointers
         * @type {Phaser.Input.Pointer[]}
         * @since 3.10.0
         */ this.pointers = [];
                    /**
         * The number of touch objects activated and being processed each update.
         *
         * You can change this by either calling `addPointer` at run-time, or by
         * setting the `input.activePointers` property in the Game Config.
         *
         * @name Phaser.Input.InputManager#pointersTotal
         * @type {number}
         * @readonly
         * @since 3.10.0
         */ this.pointersTotal = config.inputActivePointers;
                    if (config.inputTouch && this.pointersTotal === 1) this.pointersTotal = 2;
                    for(var i = 0; i <= this.pointersTotal; i++){
                        var pointer = new Pointer(this, i);
                        pointer.smoothFactor = config.inputSmoothFactor;
                        this.pointers.push(pointer);
                    }
                    /**
         * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
         * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
         * which will always map to the most recently interacted pointer.
         *
         * @name Phaser.Input.InputManager#mousePointer
         * @type {?Phaser.Input.Pointer}
         * @since 3.10.0
         */ this.mousePointer = config.inputMouse ? this.pointers[0] : null;
                    /**
         * The most recently active Pointer object.
         *
         * If you've only 1 Pointer in your game then this will accurately be either the first finger touched, or the mouse.
         *
         * If your game doesn't need to support multi-touch then you can safely use this property in all of your game
         * code and it will adapt to be either the mouse or the touch, based on device.
         *
         * @name Phaser.Input.InputManager#activePointer
         * @type {Phaser.Input.Pointer}
         * @since 3.0.0
         */ this.activePointer = this.pointers[0];
                    /**
         * If the top-most Scene in the Scene List receives an input it will stop input from
         * propagating any lower down the scene list, i.e. if you have a UI Scene at the top
         * and click something on it, that click will not then be passed down to any other
         * Scene below. Disable this to have input events passed through all Scenes, all the time.
         *
         * @name Phaser.Input.InputManager#globalTopOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.globalTopOnly = true;
                    /**
         * The time this Input Manager was last updated.
         * This value is populated by the Game Step each frame.
         *
         * @name Phaser.Input.InputManager#time
         * @type {number}
         * @readonly
         * @since 3.16.2
         */ this.time = 0;
                    /**
         * A re-cycled point-like object to store hit test values in.
         *
         * @name Phaser.Input.InputManager#_tempPoint
         * @type {{x:number, y:number}}
         * @private
         * @since 3.0.0
         */ this._tempPoint = {
                        x: 0,
                        y: 0
                    };
                    /**
         * A re-cycled array to store hit results in.
         *
         * @name Phaser.Input.InputManager#_tempHitTest
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempHitTest = [];
                    /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.4.0
         */ this._tempMatrix = new TransformMatrix();
                    /**
         * A re-cycled matrix used in hit test calculations.
         *
         * @name Phaser.Input.InputManager#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                    /**
         * An internal private var that records Scenes aborting event processing.
         *
         * @name Phaser.Input.InputManager#_tempSkip
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._tempSkip = false;
                    /**
         * An internal private array that avoids needing to create a new array on every DOM mouse event.
         *
         * @name Phaser.Input.InputManager#mousePointerContainer
         * @type {Phaser.Input.Pointer[]}
         * @private
         * @since 3.18.0
         */ this.mousePointerContainer = [
                        this.mousePointer
                    ];
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now.
     *
     * @method Phaser.Input.InputManager#boot
     * @protected
     * @fires Phaser.Input.Events#MANAGER_BOOT
     * @since 3.0.0
     */ boot: function() {
                    this.canvas = this.game.canvas;
                    this.scaleManager = this.game.scale;
                    this.events.emit(Events.MANAGER_BOOT);
                    this.game.events.on(GameEvents.PRE_RENDER, this.preRender, this);
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOver: function(event) {
                    this.isOver = true;
                    this.events.emit(Events.GAME_OVER, event);
                },
                /**
     * Internal canvas state change, called automatically by the Mouse Manager.
     *
     * @method Phaser.Input.InputManager#setCanvasOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.0
     *
     * @param {(MouseEvent|TouchEvent)} event - The DOM Event.
     */ setCanvasOut: function(event) {
                    this.isOver = false;
                    this.events.emit(Events.GAME_OUT, event);
                },
                /**
     * Internal update, called automatically by the Game Step right at the start.
     *
     * @method Phaser.Input.InputManager#preRender
     * @private
     * @since 3.18.0
     */ preRender: function() {
                    var time = this.game.loop.now;
                    var delta = this.game.loop.delta;
                    var scenes = this.game.scene.getScenes(true, true);
                    this.time = time;
                    this.events.emit(Events.MANAGER_UPDATE);
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene.sys.input && scene.sys.input.updatePoll(time, delta) && this.globalTopOnly) //  If the Scene returns true, it means it captured some input that no other Scene should get, so we bail out
                        return;
                    }
                },
                /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputManager#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     */ setDefaultCursor: function(cursor) {
                    this.defaultCursor = cursor;
                    if (this.canvas.style.cursor !== cursor) this.canvas.style.cursor = cursor;
                },
                /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to set a custom cursor during its postUpdate step.
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     *
     * @method Phaser.Input.InputManager#setCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method.
     */ setCursor: function(interactiveObject) {
                    if (interactiveObject.cursor) this.canvas.style.cursor = interactiveObject.cursor;
                },
                /**
     * Called by the InputPlugin when processing over and out events.
     *
     * Tells the Input Manager to clear the hand cursor, if set, during its postUpdate step.
     *
     * @method Phaser.Input.InputManager#resetCursor
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} interactiveObject - The Interactive Object that called this method.
     */ resetCursor: function(interactiveObject) {
                    if (interactiveObject.cursor && this.canvas) this.canvas.style.cursor = this.defaultCursor;
                },
                /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputManager#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                    if (quantity === undefined) quantity = 1;
                    var output = [];
                    if (this.pointersTotal + quantity > 10) quantity = 10 - this.pointersTotal;
                    for(var i = 0; i < quantity; i++){
                        var id = this.pointers.length;
                        var pointer = new Pointer(this, id);
                        pointer.smoothFactor = this.config.inputSmoothFactor;
                        this.pointers.push(pointer);
                        this.pointersTotal++;
                        output.push(pointer);
                    }
                    return output;
                },
                /**
     * Internal method that gets a list of all the active Input Plugins in the game
     * and updates each of them in turn, in reverse order (top to bottom), to allow
     * for DOM top-level event handling simulation.
     *
     * @method Phaser.Input.InputManager#updateInputPlugins
     * @since 3.16.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     */ updateInputPlugins: function(type, pointers) {
                    var scenes = this.game.scene.getScenes(true, true);
                    this._tempSkip = false;
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene.sys.input) {
                            var capture = scene.sys.input.update(type, pointers);
                            if (capture && this.globalTopOnly || this._tempSkip) //  If the Scene returns true, or called stopPropagation, it means it captured some input that no other Scene should get, so we bail out
                            return;
                        }
                    }
                },
                //  event.targetTouches = list of all touches on the TARGET ELEMENT (i.e. game dom element)
                //  event.touches = list of all touches on the ENTIRE DOCUMENT, not just the target element
                //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                /**
     * Processes a touch start event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchStart
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchStart: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (!pointer.active) {
                                pointer.touchstart(changedTouch, event);
                                this.activePointer = pointer;
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_START, changed);
                },
                /**
     * Processes a touch move event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchMove
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchMove: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchmove(changedTouch, event);
                                this.activePointer = pointer;
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_MOVE, changed);
                },
                //  For touch end its a list of the touch points that have been removed from the surface
                //  https://developer.mozilla.org/en-US/docs/DOM/TouchList
                //  event.changedTouches = the touches that CHANGED in this event, not the total number of them
                /**
     * Processes a touch end event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchEnd
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchEnd: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchend(changedTouch, event);
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_END, changed);
                },
                /**
     * Processes a touch cancel event, as passed in by the TouchManager.
     *
     * @method Phaser.Input.InputManager#onTouchCancel
     * @private
     * @since 3.18.0
     *
     * @param {TouchEvent} event - The native DOM Touch event.
     */ onTouchCancel: function(event) {
                    var pointers = this.pointers;
                    var changed = [];
                    for(var c = 0; c < event.changedTouches.length; c++){
                        var changedTouch = event.changedTouches[c];
                        for(var i = 1; i < this.pointersTotal; i++){
                            var pointer = pointers[i];
                            if (pointer.active && pointer.identifier === changedTouch.identifier) {
                                pointer.touchcancel(changedTouch, event);
                                changed.push(pointer);
                                break;
                            }
                        }
                    }
                    this.updateInputPlugins(CONST.TOUCH_CANCEL, changed);
                },
                /**
     * Processes a mouse down event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseDown
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseDown: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.down(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_DOWN, this.mousePointerContainer);
                },
                /**
     * Processes a mouse move event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseMove
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseMove: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.move(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_MOVE, this.mousePointerContainer);
                },
                /**
     * Processes a mouse up event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseUp
     * @private
     * @since 3.18.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onMouseUp: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.up(event);
                    mousePointer.updateMotion();
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_UP, this.mousePointerContainer);
                },
                /**
     * Processes a mouse wheel event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onMouseWheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The native DOM Wheel event.
     */ onMouseWheel: function(event) {
                    var mousePointer = this.mousePointer;
                    mousePointer.wheel(event);
                    this.activePointer = mousePointer;
                    this.updateInputPlugins(CONST.MOUSE_WHEEL, this.mousePointerContainer);
                },
                /**
     * Processes a pointer lock change event, as passed in by the MouseManager.
     *
     * @method Phaser.Input.InputManager#onPointerLockChange
     * @fires Phaser.Input.Events#POINTERLOCK_CHANGE
     * @private
     * @since 3.19.0
     *
     * @param {MouseEvent} event - The native DOM Mouse event.
     */ onPointerLockChange: function(event) {
                    var isLocked = this.mouse.locked;
                    this.mousePointer.locked = isLocked;
                    this.events.emit(Events.POINTERLOCK_CHANGE, event, isLocked);
                },
                /**
     * Checks if the given Game Object should be considered as a candidate for input or not.
     *
     * Checks if the Game Object has an input component that is enabled, that it will render,
     * and finally, if it has a parent, that the parent parent, or any ancestor, is visible or not.
     *
     * @method Phaser.Input.InputManager#inputCandidate
     * @private
     * @since 3.10.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to test.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {boolean} `true` if the Game Object should be considered for input, otherwise `false`.
     */ inputCandidate: function(gameObject, camera) {
                    var input = gameObject.input;
                    if (!input || !input.enabled || !input.alwaysEnabled && !gameObject.willRender(camera)) return false;
                    var visible = true;
                    var parent = gameObject.parentContainer;
                    if (parent) do {
                        if (!parent.willRender(camera)) {
                            visible = false;
                            break;
                        }
                        parent = parent.parentContainer;
                    }while (parent);
                    return visible;
                },
                /**
     * Performs a hit test using the given Pointer and camera, against an array of interactive Game Objects.
     *
     * The Game Objects are culled against the camera, and then the coordinates are translated into the local camera space
     * and used to determine if they fall within the remaining Game Objects hit areas or not.
     *
     * If nothing is matched an empty array is returned.
     *
     * This method is called automatically by InputPlugin.hitTestPointer and doesn't usually need to be invoked directly.
     *
     * @method Phaser.Input.InputManager#hitTest
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to test against.
     * @param {array} gameObjects - An array of interactive Game Objects to check.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     * @param {array} [output] - An array to store the results in. If not given, a new empty array is created.
     *
     * @return {array} An array of the Game Objects that were hit during this hit test.
     */ hitTest: function(pointer, gameObjects, camera, output) {
                    if (output === undefined) output = this._tempHitTest;
                    var tempPoint = this._tempPoint;
                    var csx = camera.scrollX;
                    var csy = camera.scrollY;
                    output.length = 0;
                    var x = pointer.x;
                    var y = pointer.y;
                    //  Stores the world point inside of tempPoint
                    camera.getWorldPoint(x, y, tempPoint);
                    pointer.worldX = tempPoint.x;
                    pointer.worldY = tempPoint.y;
                    var point = {
                        x: 0,
                        y: 0
                    };
                    var matrix = this._tempMatrix;
                    var parentMatrix = this._tempMatrix2;
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        //  Checks if the Game Object can receive input (isn't being ignored by the camera, invisible, etc)
                        //  and also checks all of its parents, if any
                        if (!this.inputCandidate(gameObject, camera)) continue;
                        var px = tempPoint.x + csx * gameObject.scrollFactorX - csx;
                        var py = tempPoint.y + csy * gameObject.scrollFactorY - csy;
                        if (gameObject.parentContainer) {
                            gameObject.getWorldTransformMatrix(matrix, parentMatrix);
                            matrix.applyInverse(px, py, point);
                        } else TransformXY(px, py, gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY, point);
                        if (this.pointWithinHitArea(gameObject, point.x, point.y)) output.push(gameObject);
                    }
                    return output;
                },
                /**
     * Checks if the given x and y coordinate are within the hit area of the Game Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Game Object.
     *
     * If the coordinates are within the hit area they are set into the Game Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinHitArea
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinHitArea: function(gameObject, x, y) {
                    //  Normalize the origin
                    x += gameObject.displayOriginX;
                    y += gameObject.displayOriginY;
                    var input = gameObject.input;
                    if (input && input.hitAreaCallback(input.hitArea, x, y, gameObject)) {
                        input.localX = x;
                        input.localY = y;
                        return true;
                    } else return false;
                },
                /**
     * Checks if the given x and y coordinate are within the hit area of the Interactive Object.
     *
     * This method assumes that the coordinate values have already been translated into the space of the Interactive Object.
     *
     * If the coordinates are within the hit area they are set into the Interactive Objects Input `localX` and `localY` properties.
     *
     * @method Phaser.Input.InputManager#pointWithinInteractiveObject
     * @since 3.0.0
     *
     * @param {Phaser.Types.Input.InteractiveObject} object - The Interactive Object to check against.
     * @param {number} x - The translated x coordinate for the hit test.
     * @param {number} y - The translated y coordinate for the hit test.
     *
     * @return {boolean} `true` if the coordinates were inside the Game Objects hit area, otherwise `false`.
     */ pointWithinInteractiveObject: function(object, x, y) {
                    if (!object.hitArea) return false;
                    //  Normalize the origin
                    x += object.gameObject.displayOriginX;
                    y += object.gameObject.displayOriginY;
                    object.localX = x;
                    object.localY = y;
                    return object.hitAreaCallback(object.hitArea, x, y, object);
                },
                /**
     * Transforms the pageX and pageY values of a Pointer into the scaled coordinate space of the Input Manager.
     *
     * @method Phaser.Input.InputManager#transformPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to transform the values for.
     * @param {number} pageX - The Page X value.
     * @param {number} pageY - The Page Y value.
     * @param {boolean} wasMove - Are we transforming the Pointer from a move event, or an up / down event?
     */ transformPointer: function(pointer, pageX, pageY, wasMove) {
                    var p0 = pointer.position;
                    var p1 = pointer.prevPosition;
                    //  Store previous position
                    p1.x = p0.x;
                    p1.y = p0.y;
                    //  Translate coordinates
                    var x = this.scaleManager.transformX(pageX);
                    var y = this.scaleManager.transformY(pageY);
                    var a = pointer.smoothFactor;
                    if (!wasMove || a === 0) {
                        //  Set immediately
                        p0.x = x;
                        p0.y = y;
                    } else {
                        //  Apply smoothing
                        p0.x = x * a + p1.x * (1 - a);
                        p0.y = y * a + p1.y * (1 - a);
                    }
                },
                /**
     * Destroys the Input Manager and all of its systems.
     *
     * There is no way to recover from doing this.
     *
     * @method Phaser.Input.InputManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.events.removeAllListeners();
                    this.game.events.off(GameEvents.PRE_RENDER);
                    if (this.keyboard) this.keyboard.destroy();
                    if (this.mouse) this.mouse.destroy();
                    if (this.touch) this.touch.destroy();
                    for(var i = 0; i < this.pointers.length; i++)this.pointers[i].destroy();
                    this.pointers = [];
                    this._tempHitTest = [];
                    this._tempMatrix.destroy();
                    this.canvas = null;
                    this.game = null;
                }
            });
            module1.exports = InputManager;
        /***/ },
        /* 404 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(89);
            var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var InputEvents = __webpack_require__(49);
            var KeyCodes = __webpack_require__(141);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * The Keyboard Manager is a helper class that belongs to the global Input Manager.
 *
 * Its role is to listen for native DOM Keyboard Events and then store them for further processing by the Keyboard Plugin.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically if keyboard
 * input has been enabled in the Game Config.
 *
 * @class KeyboardManager
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var KeyboardManager = new Class({
                initialize: function KeyboardManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.16.0
         */ this.manager = inputManager;
                    /**
         * An internal event queue.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#queue
         * @type {KeyboardEvent[]}
         * @private
         * @since 3.16.0
         */ this.queue = [];
                    /**
         * A flag that controls if the non-modified keys, matching those stored in the `captures` array,
         * have `preventDefault` called on them or not.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle this property at run-time.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#preventDefault
         * @type {boolean}
         * @since 3.16.0
         */ this.preventDefault = true;
                    /**
         * An array of Key Code values that will automatically have `preventDefault` called on them,
         * as long as the `KeyboardManager.preventDefault` boolean is set to `true`.
         *
         * By default the array is empty.
         *
         * The key must be non-modified when pressed in order to be captured.
         *
         * A non-modified key is one that doesn't have a modifier key held down with it. The modifier keys are
         * shift, control, alt and the meta key (Command on a Mac, the Windows Key on Windows).
         * Therefore, if the user presses shift + r, it won't prevent this combination, because of the modifier.
         * However, if the user presses just the r key on its own, it will have its event prevented.
         *
         * If you wish to stop capturing the keys, for example switching out to a DOM based element, then
         * you can toggle the `KeyboardManager.preventDefault` boolean at run-time.
         *
         * If you need more specific control, you can create Key objects and set the flag on each of those instead.
         *
         * This array can be populated via the Game Config by setting the `input.keyboard.capture` array, or you
         * can call the `addCapture` method. See also `removeCapture` and `clearCaptures`.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#captures
         * @type {number[]}
         * @since 3.16.0
         */ this.captures = [];
                    /**
         * A boolean that controls if the Keyboard Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.enabled = false;
                    /**
         * The Keyboard Event target, as defined in the Game Config.
         * Typically the window in which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#target
         * @type {any}
         * @since 3.16.0
         */ this.target;
                    /**
         * The Key Down Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyDown
         * @type {function}
         * @since 3.16.00
         */ this.onKeyDown = NOOP;
                    /**
         * The Key Up Event handler.
         * This function is sent the native DOM KeyEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Keyboard.KeyboardManager#onKeyUp
         * @type {function}
         * @since 3.16.00
         */ this.onKeyUp = NOOP;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Keyboard Manager boot process.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#boot
     * @private
     * @since 3.16.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputKeyboard;
                    this.target = config.inputKeyboardEventTarget;
                    this.addCapture(config.inputKeyboardCapture);
                    if (!this.target && window) this.target = window;
                    if (this.enabled && this.target) this.startListeners();
                    this.manager.game.events.on(GameEvents.POST_STEP, this.postUpdate, this);
                },
                /**
     * Starts the Keyboard Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                    var _this = this;
                    this.onKeyDown = function(event) {
                        if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                        return;
                        _this.queue.push(event);
                        _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                        var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                        if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                    };
                    this.onKeyUp = function(event) {
                        if (event.defaultPrevented || !_this.enabled || !_this.manager) // Do nothing if event already handled
                        return;
                        _this.queue.push(event);
                        _this.manager.events.emit(InputEvents.MANAGER_PROCESS);
                        var modified = event.altKey || event.ctrlKey || event.shiftKey || event.metaKey;
                        if (_this.preventDefault && !modified && _this.captures.indexOf(event.keyCode) > -1) event.preventDefault();
                    };
                    var target = this.target;
                    if (target) {
                        target.addEventListener('keydown', this.onKeyDown, false);
                        target.addEventListener('keyup', this.onKeyUp, false);
                        this.enabled = true;
                    }
                },
                /**
     * Stops the Key Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener('keydown', this.onKeyDown, false);
                    target.removeEventListener('keyup', this.onKeyUp, false);
                    this.enabled = false;
                },
                /**
     * Clears the event queue.
     * Called automatically by the Input Manager.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#postUpdate
     * @private
     * @since 3.16.0
     */ postUpdate: function() {
                    this.queue = [];
                },
                /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard event for specific keys so it doesn't bubble up to the the browser
     * and cause the default browser behavior.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are active captures after calling this method, the `preventDefault` property is set to `true`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable capture for, preventing them reaching the browser.
     */ addCapture: function(keycode) {
                    if (typeof keycode === 'string') keycode = keycode.split(',');
                    if (!Array.isArray(keycode)) keycode = [
                        keycode
                    ];
                    var captures = this.captures;
                    for(var i = 0; i < keycode.length; i++){
                        var code = keycode[i];
                        if (typeof code === 'string') code = KeyCodes[code.trim().toUpperCase()];
                        if (captures.indexOf(code) === -1) captures.push(code);
                    }
                    this.preventDefault = captures.length > 0;
                },
                /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass in a single key code value, or an array of key codes, or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or a string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * If there are no captures left after calling this method, the `preventDefault` property is set to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable capture for, allowing them reaching the browser again.
     */ removeCapture: function(keycode) {
                    if (typeof keycode === 'string') keycode = keycode.split(',');
                    if (!Array.isArray(keycode)) keycode = [
                        keycode
                    ];
                    var captures = this.captures;
                    for(var i = 0; i < keycode.length; i++){
                        var code = keycode[i];
                        if (typeof code === 'string') code = KeyCodes[code.toUpperCase()];
                        ArrayRemove(captures, code);
                    }
                    this.preventDefault = captures.length > 0;
                },
                /**
     * Removes all keyboard captures and sets the `preventDefault` property to `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#clearCaptures
     * @since 3.16.0
     */ clearCaptures: function() {
                    this.captures = [];
                    this.preventDefault = false;
                },
                /**
     * Destroys this Keyboard Manager instance.
     *
     * @method Phaser.Input.Keyboard.KeyboardManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.stopListeners();
                    this.clearCaptures();
                    this.queue = [];
                    this.manager.game.events.off(GameEvents.POST_RENDER, this.postUpdate, this);
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = KeyboardManager;
        /***/ },
        /* 405 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Features = __webpack_require__(188);
            var InputEvents = __webpack_require__(49);
            var NOOP = __webpack_require__(1);
            //  https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
            //  https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
            /**
 * @classdesc
 * The Mouse Manager is a helper class that belongs to the Input Manager.
 *
 * Its role is to listen for native DOM Mouse Events and then pass them onto the Input Manager for further processing.
 *
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class MouseManager
 * @memberof Phaser.Input.Mouse
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var MouseManager = new Class({
                initialize: function MouseManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Mouse.MouseManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                    /**
         * If `true` the DOM `mousedown` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultDown
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultDown = true;
                    /**
         * If `true` the DOM `mouseup` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultUp
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultUp = true;
                    /**
         * If `true` the DOM `mousemove` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultMove
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultMove = true;
                    /**
         * If `true` the DOM `wheel` event will have `preventDefault` set.
         *
         * @name Phaser.Input.Mouse.MouseManager#preventDefaultWheel
         * @type {boolean}
         * @default true
         * @since 3.50.0
         */ this.preventDefaultWheel = false;
                    /**
         * A boolean that controls if the Mouse Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Mouse.MouseManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                    /**
         * The Mouse target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Mouse.MouseManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                    /**
         * If the mouse has been pointer locked successfully this will be set to true.
         *
         * @name Phaser.Input.Mouse.MouseManager#locked
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.locked = false;
                    /**
         * The Mouse Move Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseMove
         * @type {function}
         * @since 3.10.0
         */ this.onMouseMove = NOOP;
                    /**
         * The Mouse Down Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDown
         * @type {function}
         * @since 3.10.0
         */ this.onMouseDown = NOOP;
                    /**
         * The Mouse Up Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUp
         * @type {function}
         * @since 3.10.0
         */ this.onMouseUp = NOOP;
                    /**
         * The Mouse Down Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseDownWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseDownWindow = NOOP;
                    /**
         * The Mouse Up Event handler specifically for events on the Window.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseUpWindow
         * @type {function}
         * @since 3.17.0
         */ this.onMouseUpWindow = NOOP;
                    /**
         * The Mouse Over Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOver
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOver = NOOP;
                    /**
         * The Mouse Out Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseOut
         * @type {function}
         * @since 3.16.0
         */ this.onMouseOut = NOOP;
                    /**
         * The Mouse Wheel Event handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#onMouseWheel
         * @type {function}
         * @since 3.18.0
         */ this.onMouseWheel = NOOP;
                    /**
         * Internal pointerLockChange handler.
         * This function is sent the native DOM MouseEvent.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Mouse.MouseManager#pointerLockChange
         * @type {function}
         * @since 3.0.0
         */ this.pointerLockChange = NOOP;
                    /**
         * Are the event listeners hooked into `window.top` or `window`?
         *
         * This is set during the `boot` sequence. If the browser does not have access to `window.top`,
         * such as in cross-origin iframe environments, this property gets set to `false` and the events
         * are hooked into `window` instead.
         *
         * @name Phaser.Input.Mouse.MouseManager#isTop
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTop = true;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Mouse.MouseManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputMouse;
                    this.target = config.inputMouseEventTarget;
                    this.passive = config.inputMousePassive;
                    this.preventDefaultDown = config.inputMousePreventDefaultDown;
                    this.preventDefaultUp = config.inputMousePreventDefaultUp;
                    this.preventDefaultMove = config.inputMousePreventDefaultMove;
                    this.preventDefaultWheel = config.inputMousePreventDefaultWheel;
                    if (!this.target) this.target = this.manager.game.canvas;
                    else if (typeof this.target === 'string') this.target = document.getElementById(this.target);
                    if (config.disableContextMenu) this.disableContextMenu();
                    if (this.enabled && this.target) this.startListeners();
                },
                /**
     * Attempts to disable the context menu from appearing if you right-click on the browser.
     *
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     *
     * Use this if you need to enable right-button mouse support in your game, and the browser
     * menu keeps getting in the way.
     *
     * @method Phaser.Input.Mouse.MouseManager#disableContextMenu
     * @since 3.0.0
     *
     * @return {this} This Mouse Manager instance.
     */ disableContextMenu: function() {
                    document.body.addEventListener('contextmenu', function(event) {
                        event.preventDefault();
                        return false;
                    });
                    return this;
                },
                /**
     * If the browser supports it, you can request that the pointer be locked to the browser window.
     *
     * This is classically known as 'FPS controls', where the pointer can't leave the browser until
     * the user presses an exit key.
     *
     * If the browser successfully enters a locked state, a `POINTER_LOCK_CHANGE_EVENT` will be dispatched,
     * from the games Input Manager, with an `isPointerLocked` property.
     *
     * It is important to note that pointer lock can only be enabled after an 'engagement gesture',
     * see: https://w3c.github.io/pointerlock/#dfn-engagement-gesture.
     *
     * Note for Firefox: There is a bug in certain Firefox releases that cause native DOM events like
     * `mousemove` to fire continuously when in pointer lock mode. You can get around this by setting
     * `this.preventDefaultMove` to `false` in this class. You may also need to do the same for
     * `preventDefaultDown` and/or `preventDefaultUp`. Please test combinations of these if you encounter
     * the error.
     *
     * @method Phaser.Input.Mouse.MouseManager#requestPointerLock
     * @since 3.0.0
     */ requestPointerLock: function() {
                    if (Features.pointerLock) {
                        var element = this.target;
                        element.requestPointerLock = element.requestPointerLock || element.mozRequestPointerLock || element.webkitRequestPointerLock;
                        element.requestPointerLock();
                    }
                },
                /**
     * If the browser supports pointer lock, this will request that the pointer lock is released. If
     * the browser successfully enters a locked state, a 'POINTER_LOCK_CHANGE_EVENT' will be
     * dispatched - from the game's input manager - with an `isPointerLocked` property.
     *
     * @method Phaser.Input.Mouse.MouseManager#releasePointerLock
     * @since 3.0.0
     */ releasePointerLock: function() {
                    if (Features.pointerLock) {
                        document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock;
                        document.exitPointerLock();
                    }
                },
                /**
     * Starts the Mouse Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                    var target = this.target;
                    if (!target) return;
                    var _this = this;
                    var manager = this.manager;
                    var canvas = manager.canvas;
                    var autoFocus = window && window.focus && manager.game.config.autoFocus;
                    this.onMouseMove = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseMove(event);
                            if (_this.preventDefaultMove) event.preventDefault();
                        }
                    };
                    this.onMouseDown = function(event) {
                        if (autoFocus) window.focus();
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseDown(event);
                            if (_this.preventDefaultDown && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onMouseDownWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        manager.onMouseDown(event);
                    };
                    this.onMouseUp = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) {
                            manager.onMouseUp(event);
                            if (_this.preventDefaultUp && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onMouseUpWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        manager.onMouseUp(event);
                    };
                    this.onMouseOver = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOver(event);
                    };
                    this.onMouseOut = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.setCanvasOut(event);
                    };
                    this.onMouseWheel = function(event) {
                        if (!event.defaultPrevented && _this.enabled && manager && manager.enabled) manager.onMouseWheel(event);
                        if (_this.preventDefaultWheel && event.target === canvas) event.preventDefault();
                    };
                    var passive = {
                        passive: true
                    };
                    target.addEventListener('mousemove', this.onMouseMove);
                    target.addEventListener('mousedown', this.onMouseDown);
                    target.addEventListener('mouseup', this.onMouseUp);
                    target.addEventListener('mouseover', this.onMouseOver, passive);
                    target.addEventListener('mouseout', this.onMouseOut, passive);
                    if (this.preventDefaultWheel) target.addEventListener('wheel', this.onMouseWheel, {
                        passive: false
                    });
                    else target.addEventListener('wheel', this.onMouseWheel, passive);
                    if (window && manager.game.config.inputWindowEvents) try {
                        window.top.addEventListener('mousedown', this.onMouseDownWindow, passive);
                        window.top.addEventListener('mouseup', this.onMouseUpWindow, passive);
                    } catch (exception) {
                        window.addEventListener('mousedown', this.onMouseDownWindow, passive);
                        window.addEventListener('mouseup', this.onMouseUpWindow, passive);
                        this.isTop = false;
                    }
                    if (Features.pointerLock) {
                        this.pointerLockChange = function(event) {
                            var element = _this.target;
                            _this.locked = document.pointerLockElement === element || document.mozPointerLockElement === element || document.webkitPointerLockElement === element ? true : false;
                            manager.onPointerLockChange(event);
                        };
                        document.addEventListener('pointerlockchange', this.pointerLockChange, true);
                        document.addEventListener('mozpointerlockchange', this.pointerLockChange, true);
                        document.addEventListener('webkitpointerlockchange', this.pointerLockChange, true);
                    }
                    this.enabled = true;
                },
                /**
     * Stops the Mouse Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Mouse.MouseManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener('mousemove', this.onMouseMove);
                    target.removeEventListener('mousedown', this.onMouseDown);
                    target.removeEventListener('mouseup', this.onMouseUp);
                    target.removeEventListener('mouseover', this.onMouseOver);
                    target.removeEventListener('mouseout', this.onMouseOut);
                    if (window) {
                        target = this.isTop ? window.top : window;
                        target.removeEventListener('mousedown', this.onMouseDownWindow);
                        target.removeEventListener('mouseup', this.onMouseUpWindow);
                    }
                    if (Features.pointerLock) {
                        document.removeEventListener('pointerlockchange', this.pointerLockChange, true);
                        document.removeEventListener('mozpointerlockchange', this.pointerLockChange, true);
                        document.removeEventListener('webkitpointerlockchange', this.pointerLockChange, true);
                    }
                },
                /**
     * Destroys this Mouse Manager instance.
     *
     * @method Phaser.Input.Mouse.MouseManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stopListeners();
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = MouseManager;
        /***/ },
        /* 406 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(343);
            var Class = __webpack_require__(0);
            var Distance = __webpack_require__(48);
            var FuzzyEqual = __webpack_require__(123);
            var SmoothStepInterpolation = __webpack_require__(354);
            var Vector2 = __webpack_require__(3);
            var OS = __webpack_require__(102);
            /**
 * @classdesc
 * A Pointer object encapsulates both mouse and touch input within Phaser.
 *
 * By default, Phaser will create 2 pointers for your game to use. If you require more, i.e. for a multi-touch
 * game, then use the `InputPlugin.addPointer` method to do so, rather than instantiating this class directly,
 * otherwise it won't be managed by the input system.
 *
 * You can reference the current active pointer via `InputPlugin.activePointer`. You can also use the properties
 * `InputPlugin.pointer1` through to `pointer10`, for each pointer you have enabled in your game.
 *
 * The properties of this object are set by the Input Plugin during processing. This object is then sent in all
 * input related events that the Input Plugin emits, so you can reference properties from it directly in your
 * callbacks.
 *
 * @class Pointer
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} manager - A reference to the Input Manager.
 * @param {number} id - The internal ID of this Pointer.
 */ var Pointer = new Class({
                initialize: function Pointer(manager, id) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Pointer#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The internal ID of this Pointer.
         *
         * @name Phaser.Input.Pointer#id
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.id = id;
                    /**
         * The most recent native DOM Event this Pointer has processed.
         *
         * @name Phaser.Input.Pointer#event
         * @type {(TouchEvent|MouseEvent)}
         * @since 3.0.0
         */ this.event;
                    /**
         * The DOM element the Pointer was pressed down on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#downElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.downElement;
                    /**
         * The DOM element the Pointer was released on, taken from the DOM event.
         * In a default set-up this will be the Canvas that Phaser is rendering to, or the Window element.
         *
         * @name Phaser.Input.Pointer#upElement
         * @type {any}
         * @readonly
         * @since 3.16.0
         */ this.upElement;
                    /**
         * The camera the Pointer interacted with during its last update.
         *
         * A Pointer can only ever interact with one camera at once, which will be the top-most camera
         * in the list should multiple cameras be positioned on-top of each other.
         *
         * @name Phaser.Input.Pointer#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = null;
                    /**
         * A read-only property that indicates which button was pressed, or released, on the pointer
         * during the most recent event. It is only set during `up` and `down` events.
         *
         * On Touch devices the value is always 0.
         *
         * Users may change the configuration of buttons on their pointing device so that if an event's button property
         * is zero, it may not have been caused by the button that is physically left–most on the pointing device;
         * however, it should behave as if the left button was clicked in the standard button layout.
         *
         * @name Phaser.Input.Pointer#button
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.18.0
         */ this.button = 0;
                    /**
         * 0: No button or un-initialized
         * 1: Left button
         * 2: Right button
         * 4: Wheel button or middle button
         * 8: 4th button (typically the "Browser Back" button)
         * 16: 5th button (typically the "Browser Forward" button)
         *
         * For a mouse configured for left-handed use, the button actions are reversed.
         * In this case, the values are read from right to left.
         *
         * @name Phaser.Input.Pointer#buttons
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.buttons = 0;
                    /**
         * The position of the Pointer in screen space.
         *
         * @name Phaser.Input.Pointer#position
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.position = new Vector2();
                    /**
         * The previous position of the Pointer in screen space.
         *
         * The old x and y values are stored in here during the InputManager.transformPointer call.
         *
         * Use the properties `velocity`, `angle` and `distance` to create your own gesture recognition.
         *
         * @name Phaser.Input.Pointer#prevPosition
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.11.0
         */ this.prevPosition = new Vector2();
                    /**
         * An internal vector used for calculations of the pointer speed and angle.
         *
         * @name Phaser.Input.Pointer#midPoint
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.16.0
         */ this.midPoint = new Vector2(-1, -1);
                    /**
         * The current velocity of the Pointer, based on its current and previous positions.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.velocity = new Vector2();
                    /**
         * The current angle the Pointer is moving, in radians, based on its previous and current position.
         *
         * The angle is based on the old position facing to the current position.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * @name Phaser.Input.Pointer#angle
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.angle = 0;
                    /**
         * The distance the Pointer has moved, based on its previous and current position.
         *
         * This value is smoothed out each frame, according to the `motionFactor` property.
         *
         * This property is updated whenever the Pointer moves, regardless of any button states. In other words,
         * it changes based on movement alone - a button doesn't have to be pressed first.
         *
         * If you need the total distance travelled since the primary buttons was pressed down,
         * then use the `Pointer.getDistance` method.
         *
         * @name Phaser.Input.Pointer#distance
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.distance = 0;
                    /**
         * The smoothing factor to apply to the Pointer position.
         *
         * Due to their nature, pointer positions are inherently noisy. While this is fine for lots of games, if you need cleaner positions
         * then you can set this value to apply an automatic smoothing to the positions as they are recorded.
         *
         * The default value of zero means 'no smoothing'.
         * Set to a small value, such as 0.2, to apply an average level of smoothing between positions. You can do this by changing this
         * value directly, or by setting the `input.smoothFactor` property in the Game Config.
         *
         * Positions are only smoothed when the pointer moves. If the primary button on this Pointer enters an Up or Down state, then the position
         * is always precise, and not smoothed.
         *
         * @name Phaser.Input.Pointer#smoothFactor
         * @type {number}
         * @default 0
         * @since 3.16.0
         */ this.smoothFactor = 0;
                    /**
         * The factor applied to the motion smoothing each frame.
         *
         * This value is passed to the Smooth Step Interpolation that is used to calculate the velocity,
         * angle and distance of the Pointer. It's applied every frame, until the midPoint reaches the current
         * position of the Pointer. 0.2 provides a good average but can be increased if you need a
         * quicker update and are working in a high performance environment. Never set this value to
         * zero.
         *
         * @name Phaser.Input.Pointer#motionFactor
         * @type {number}
         * @default 0.2
         * @since 3.16.0
         */ this.motionFactor = 0.2;
                    /**
         * The x position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldX
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldX = 0;
                    /**
         * The y position of this Pointer, translated into the coordinate space of the most recent Camera it interacted with.
         *
         * If you wish to use this value _outside_ of an input event handler then you should update it first by calling
         * the `Pointer.updateWorldPoint` method.
         *
         * @name Phaser.Input.Pointer#worldY
         * @type {number}
         * @default 0
         * @since 3.10.0
         */ this.worldY = 0;
                    /**
         * Time when this Pointer was most recently moved (regardless of the state of its buttons, if any)
         *
         * @name Phaser.Input.Pointer#moveTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.moveTime = 0;
                    /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downX = 0;
                    /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downY = 0;
                    /**
         * The Event timestamp when the first button, or Touch input, was pressed. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#downTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.downTime = 0;
                    /**
         * X coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upX = 0;
                    /**
         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upY = 0;
                    /**
         * The Event timestamp when the final button, or Touch input, was released. Used for dragging objects.
         *
         * @name Phaser.Input.Pointer#upTime
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.upTime = 0;
                    /**
         * Is the primary button down? (usually button 0, the left mouse button)
         *
         * @name Phaser.Input.Pointer#primaryDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.primaryDown = false;
                    /**
         * Is _any_ button on this pointer considered as being down?
         *
         * @name Phaser.Input.Pointer#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                    /**
         * Did the previous input event come from a Touch input (true) or Mouse? (false)
         *
         * @name Phaser.Input.Pointer#wasTouch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.wasTouch = false;
                    /**
         * Did this Pointer get canceled by a touchcancel event?
         *
         * Note: "canceled" is the American-English spelling of "cancelled". Please don't submit PRs correcting it!
         *
         * @name Phaser.Input.Pointer#wasCanceled
         * @type {boolean}
         * @default false
         * @since 3.15.0
         */ this.wasCanceled = false;
                    /**
         * If the mouse is locked, the horizontal relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementX = 0;
                    /**
         * If the mouse is locked, the vertical relative movement of the Pointer in pixels since last frame.
         *
         * @name Phaser.Input.Pointer#movementY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.movementY = 0;
                    /**
         * The identifier property of the Pointer as set by the DOM event when this Pointer is started.
         *
         * @name Phaser.Input.Pointer#identifier
         * @type {number}
         * @since 3.10.0
         */ this.identifier = 0;
                    /**
         * The pointerId property of the Pointer as set by the DOM event when this Pointer is started.
         * The browser can and will recycle this value.
         *
         * @name Phaser.Input.Pointer#pointerId
         * @type {number}
         * @since 3.10.0
         */ this.pointerId = null;
                    /**
         * An active Pointer is one that is currently pressed down on the display.
         * A Mouse is always considered as active.
         *
         * @name Phaser.Input.Pointer#active
         * @type {boolean}
         * @since 3.10.0
         */ this.active = id === 0 ? true : false;
                    /**
         * Is this pointer Pointer Locked?
         *
         * Only a mouse pointer can be locked and it only becomes locked when requested via
         * the browsers Pointer Lock API.
         *
         * You can request this by calling the `this.input.mouse.requestPointerLock()` method from
         * a `pointerdown` or `pointerup` event handler.
         *
         * @name Phaser.Input.Pointer#locked
         * @readonly
         * @type {boolean}
         * @since 3.19.0
         */ this.locked = false;
                    /**
         * The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaX
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaX = 0;
                    /**
         * The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         * This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
         *
         * @name Phaser.Input.Pointer#deltaY
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaY = 0;
                    /**
         * The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
         *
         * @name Phaser.Input.Pointer#deltaZ
         * @type {number}
         * @default 0
         * @since 3.18.0
         */ this.deltaZ = 0;
                },
                /**
     * Takes a Camera and updates this Pointer's `worldX` and `worldY` values so they are
     * the result of a translation through the given Camera.
     *
     * Note that the values will be automatically replaced the moment the Pointer is
     * updated by an input event, such as a mouse move, so should be used immediately.
     *
     * @method Phaser.Input.Pointer#updateWorldPoint
     * @since 3.19.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera which is being tested against.
     *
     * @return {this} This Pointer object.
     */ updateWorldPoint: function(camera) {
                    //  Stores the world point inside of tempPoint
                    var temp = camera.getWorldPoint(this.x, this.y);
                    this.worldX = temp.x;
                    this.worldY = temp.y;
                    return this;
                },
                /**
     * Takes a Camera and returns a Vector2 containing the translated position of this Pointer
     * within that Camera. This can be used to convert this Pointers position into camera space.
     *
     * @method Phaser.Input.Pointer#positionToCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use for the translation.
     * @param {(Phaser.Math.Vector2|object)} [output] - A Vector2-like object in which to store the translated position.
     *
     * @return {(Phaser.Math.Vector2|object)} A Vector2 containing the translated coordinates of this Pointer, based on the given camera.
     */ positionToCamera: function(camera, output) {
                    return camera.getWorldPoint(this.x, this.y, output);
                },
                /**
     * Calculates the motion of this Pointer, including its velocity and angle of movement.
     * This method is called automatically each frame by the Input Manager.
     *
     * @method Phaser.Input.Pointer#updateMotion
     * @private
     * @since 3.16.0
     */ updateMotion: function() {
                    var cx = this.position.x;
                    var cy = this.position.y;
                    var mx = this.midPoint.x;
                    var my = this.midPoint.y;
                    if (cx === mx && cy === my) //  Nothing to do here
                    return;
                    //  Moving towards our goal ...
                    var vx = SmoothStepInterpolation(this.motionFactor, mx, cx);
                    var vy = SmoothStepInterpolation(this.motionFactor, my, cy);
                    if (FuzzyEqual(vx, cx, 0.1)) vx = cx;
                    if (FuzzyEqual(vy, cy, 0.1)) vy = cy;
                    this.midPoint.set(vx, vy);
                    var dx = cx - vx;
                    var dy = cy - vy;
                    this.velocity.set(dx, dy);
                    this.angle = Angle(vx, vy, cx, cy);
                    this.distance = Math.sqrt(dx * dx + dy * dy);
                },
                /**
     * Internal method to handle a Mouse Up Event.
     *
     * @method Phaser.Input.Pointer#up
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ up: function(event) {
                    if ('buttons' in event) this.buttons = event.buttons;
                    this.event = event;
                    this.button = event.button;
                    this.upElement = event.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    //  0: Main button pressed, usually the left button or the un-initialized state
                    if (event.button === 0) {
                        this.primaryDown = false;
                        this.upX = this.x;
                        this.upY = this.y;
                    }
                    if (this.buttons === 0) {
                        //  No more buttons are still down
                        this.isDown = false;
                        this.upTime = event.timeStamp;
                        this.wasTouch = false;
                    }
                },
                /**
     * Internal method to handle a Mouse Down Event.
     *
     * @method Phaser.Input.Pointer#down
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ down: function(event) {
                    if ('buttons' in event) this.buttons = event.buttons;
                    this.event = event;
                    this.button = event.button;
                    this.downElement = event.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    //  0: Main button pressed, usually the left button or the un-initialized state
                    if (event.button === 0) {
                        this.primaryDown = true;
                        this.downX = this.x;
                        this.downY = this.y;
                    }
                    if (OS.macOS && event.ctrlKey) {
                        //  Override button settings on macOS
                        this.buttons = 2;
                        this.primaryDown = false;
                    }
                    if (!this.isDown) {
                        this.isDown = true;
                        this.downTime = event.timeStamp;
                    }
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Mouse Move Event.
     *
     * @method Phaser.Input.Pointer#move
     * @private
     * @since 3.0.0
     *
     * @param {MouseEvent} event - The Mouse Event to process.
     */ move: function(event) {
                    if ('buttons' in event) this.buttons = event.buttons;
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, true);
                    if (this.locked) {
                        //  Multiple DOM events may occur within one frame, but only one Phaser event will fire
                        this.movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
                        this.movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
                    }
                    this.moveTime = event.timeStamp;
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Mouse Wheel Event.
     *
     * @method Phaser.Input.Pointer#wheel
     * @private
     * @since 3.18.0
     *
     * @param {WheelEvent} event - The Wheel Event to process.
     */ wheel: function(event) {
                    if ('buttons' in event) this.buttons = event.buttons;
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, event.pageX, event.pageY, false);
                    this.deltaX = event.deltaX;
                    this.deltaY = event.deltaY;
                    this.deltaZ = event.deltaZ;
                    this.wasTouch = false;
                },
                /**
     * Internal method to handle a Touch Start Event.
     *
     * @method Phaser.Input.Pointer#touchstart
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchstart: function(touch, event) {
                    if (touch['pointerId']) this.pointerId = touch.pointerId;
                    this.identifier = touch.identifier;
                    this.target = touch.target;
                    this.active = true;
                    this.buttons = 1;
                    this.event = event;
                    this.downElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = true;
                    this.downX = this.x;
                    this.downY = this.y;
                    this.downTime = event.timeStamp;
                    this.isDown = true;
                    this.wasTouch = true;
                    this.wasCanceled = false;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch Move Event.
     *
     * @method Phaser.Input.Pointer#touchmove
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchmove: function(touch, event) {
                    this.event = event;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, true);
                    this.moveTime = event.timeStamp;
                    this.wasTouch = true;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch End Event.
     *
     * @method Phaser.Input.Pointer#touchend
     * @private
     * @since 3.0.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchend: function(touch, event) {
                    this.buttons = 0;
                    this.event = event;
                    this.upElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = false;
                    this.upX = this.x;
                    this.upY = this.y;
                    this.upTime = event.timeStamp;
                    this.isDown = false;
                    this.wasTouch = true;
                    this.wasCanceled = false;
                    this.active = false;
                    this.updateMotion();
                },
                /**
     * Internal method to handle a Touch Cancel Event.
     *
     * @method Phaser.Input.Pointer#touchcancel
     * @private
     * @since 3.15.0
     *
     * @param {Touch} touch - The Changed Touch from the Touch Event.
     * @param {TouchEvent} event - The full Touch Event.
     */ touchcancel: function(touch, event) {
                    this.buttons = 0;
                    this.event = event;
                    this.upElement = touch.target;
                    //  Sets the local x/y properties
                    this.manager.transformPointer(this, touch.pageX, touch.pageY, false);
                    this.primaryDown = false;
                    this.upX = this.x;
                    this.upY = this.y;
                    this.upTime = event.timeStamp;
                    this.isDown = false;
                    this.wasTouch = true;
                    this.wasCanceled = true;
                    this.active = false;
                },
                /**
     * Checks to see if any buttons are being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#noButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if no buttons are being held down.
     */ noButtonDown: function() {
                    return this.buttons === 0;
                },
                /**
     * Checks to see if the left button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the left button is being held down.
     */ leftButtonDown: function() {
                    return this.buttons & 1 ? true : false;
                },
                /**
     * Checks to see if the right button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the right button is being held down.
     */ rightButtonDown: function() {
                    return this.buttons & 2 ? true : false;
                },
                /**
     * Checks to see if the middle button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the middle button is being held down.
     */ middleButtonDown: function() {
                    return this.buttons & 4 ? true : false;
                },
                /**
     * Checks to see if the back button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the back button is being held down.
     */ backButtonDown: function() {
                    return this.buttons & 8 ? true : false;
                },
                /**
     * Checks to see if the forward button is being held down on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonDown
     * @since 3.0.0
     *
     * @return {boolean} `true` if the forward button is being held down.
     */ forwardButtonDown: function() {
                    return this.buttons & 16 ? true : false;
                },
                /**
     * Checks to see if the left button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#leftButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the left button was just released.
     */ leftButtonReleased: function() {
                    return this.button === 0 && !this.isDown;
                },
                /**
     * Checks to see if the right button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#rightButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the right button was just released.
     */ rightButtonReleased: function() {
                    return this.button === 2 && !this.isDown;
                },
                /**
     * Checks to see if the middle button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#middleButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the middle button was just released.
     */ middleButtonReleased: function() {
                    return this.button === 1 && !this.isDown;
                },
                /**
     * Checks to see if the back button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#backButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the back button was just released.
     */ backButtonReleased: function() {
                    return this.button === 3 && !this.isDown;
                },
                /**
     * Checks to see if the forward button was just released on this Pointer.
     *
     * @method Phaser.Input.Pointer#forwardButtonReleased
     * @since 3.18.0
     *
     * @return {boolean} `true` if the forward button was just released.
     */ forwardButtonReleased: function() {
                    return this.button === 4 && !this.isDown;
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded distance, based on where
     * the Pointer was when the button was released.
     *
     * If you wish to get the distance being travelled currently, based on the velocity of the Pointer,
     * then see the `Pointer.distance` property.
     *
     * @method Phaser.Input.Pointer#getDistance
     * @since 3.13.0
     *
     * @return {number} The distance the Pointer moved.
     */ getDistance: function() {
                    if (this.isDown) return Distance(this.downX, this.downY, this.x, this.y);
                    else return Distance(this.downX, this.downY, this.upX, this.upY);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * horizontal distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded horizontal distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceX
     * @since 3.16.0
     *
     * @return {number} The horizontal distance the Pointer moved.
     */ getDistanceX: function() {
                    if (this.isDown) return Math.abs(this.downX - this.x);
                    else return Math.abs(this.downX - this.upX);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * vertical distance between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded vertical distance, based on where
     * the Pointer was when the button was released.
     *
     * @method Phaser.Input.Pointer#getDistanceY
     * @since 3.16.0
     *
     * @return {number} The vertical distance the Pointer moved.
     */ getDistanceY: function() {
                    if (this.isDown) return Math.abs(this.downY - this.y);
                    else return Math.abs(this.downY - this.upY);
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * duration since the button was pressed down.
     *
     * If no button is held down, it will return the last recorded duration, based on the time
     * the last button on the Pointer was released.
     *
     * @method Phaser.Input.Pointer#getDuration
     * @since 3.16.0
     *
     * @return {number} The duration the Pointer was held down for in milliseconds.
     */ getDuration: function() {
                    if (this.isDown) return this.manager.time - this.downTime;
                    else return this.upTime - this.downTime;
                },
                /**
     * If the Pointer has a button pressed down at the time this method is called, it will return the
     * angle between the Pointer's `downX` and `downY` values and the current position.
     *
     * If no button is held down, it will return the last recorded angle, based on where
     * the Pointer was when the button was released.
     *
     * The angle is based on the old position facing to the current position.
     *
     * If you wish to get the current angle, based on the velocity of the Pointer, then
     * see the `Pointer.angle` property.
     *
     * @method Phaser.Input.Pointer#getAngle
     * @since 3.16.0
     *
     * @return {number} The angle between the Pointer's coordinates in radians.
     */ getAngle: function() {
                    if (this.isDown) return Angle(this.downX, this.downY, this.x, this.y);
                    else return Angle(this.downX, this.downY, this.upX, this.upY);
                },
                /**
     * Takes the previous and current Pointer positions and then generates an array of interpolated values between
     * the two. The array will be populated up to the size of the `steps` argument.
     *
     * ```javaScript
     * var points = pointer.getInterpolatedPosition(4);
     *
     * // points[0] = { x: 0, y: 0 }
     * // points[1] = { x: 2, y: 1 }
     * // points[2] = { x: 3, y: 2 }
     * // points[3] = { x: 6, y: 3 }
     * ```
     *
     * Use this if you need to get smoothed values between the previous and current pointer positions. DOM pointer
     * events can often fire faster than the main browser loop, and this will help you avoid janky movement
     * especially if you have an object following a Pointer.
     *
     * Note that if you provide an output array it will only be populated up to the number of steps provided.
     * It will not clear any previous data that may have existed beyond the range of the steps count.
     *
     * Internally it uses the Smooth Step interpolation calculation.
     *
     * @method Phaser.Input.Pointer#getInterpolatedPosition
     * @since 3.11.0
     *
     * @param {number} [steps=10] - The number of interpolation steps to use.
     * @param {array} [out] - An array to store the results in. If not provided a new one will be created.
     *
     * @return {array} An array of interpolated values.
     */ getInterpolatedPosition: function(steps, out) {
                    if (steps === undefined) steps = 10;
                    if (out === undefined) out = [];
                    var prevX = this.prevPosition.x;
                    var prevY = this.prevPosition.y;
                    var curX = this.position.x;
                    var curY = this.position.y;
                    for(var i = 0; i < steps; i++){
                        var t = 1 / steps * i;
                        out[i] = {
                            x: SmoothStepInterpolation(t, prevX, curX),
                            y: SmoothStepInterpolation(t, prevY, curY)
                        };
                    }
                    return out;
                },
                /**
     * Destroys this Pointer instance and resets its external references.
     *
     * @method Phaser.Input.Pointer#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.manager = null;
                    this.position = null;
                },
                /**
     * The x position of this Pointer.
     * The value is in screen space.
     * See `worldX` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.position.x = value;
                    }
                },
                /**
     * The y position of this Pointer.
     * The value is in screen space.
     * See `worldY` to get a camera converted position.
     *
     * @name Phaser.Input.Pointer#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.position.y = value;
                    }
                },
                /**
     * Time when this Pointer was most recently updated by a DOM Event.
     * This comes directly from the `event.timeStamp` property.
     * If no event has yet taken place, it will return zero.
     *
     * @name Phaser.Input.Pointer#time
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ time: {
                    get: function() {
                        return this.event ? this.event.timeStamp : 0;
                    }
                }
            });
            module1.exports = Pointer;
        /***/ },
        /* 407 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var InputEvents = __webpack_require__(49);
            var NOOP = __webpack_require__(1);
            // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
            // https://patrickhlauke.github.io/touch/tests/results/
            // https://www.html5rocks.com/en/mobile/touch/
            /**
 * @classdesc
 * The Touch Manager is a helper class that belongs to the Input Manager.
 * 
 * Its role is to listen for native DOM Touch Events and then pass them onto the Input Manager for further processing.
 * 
 * You do not need to create this class directly, the Input Manager will create an instance of it automatically.
 *
 * @class TouchManager
 * @memberof Phaser.Input.Touch
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.InputManager} inputManager - A reference to the Input Manager.
 */ var TouchManager = new Class({
                initialize: function TouchManager(inputManager) {
                    /**
         * A reference to the Input Manager.
         *
         * @name Phaser.Input.Touch.TouchManager#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = inputManager;
                    /**
         * If true the DOM events will have event.preventDefault applied to them, if false they will propagate fully.
         *
         * @name Phaser.Input.Touch.TouchManager#capture
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.capture = true;
                    /**
         * A boolean that controls if the Touch Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Touch.TouchManager#enabled
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.enabled = false;
                    /**
         * The Touch Event target, as defined in the Game Config.
         * Typically the canvas to which the game is rendering, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Touch.TouchManager#target
         * @type {any}
         * @since 3.0.0
         */ this.target;
                    /**
         * The Touch Start event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStart
         * @type {function}
         * @since 3.0.0
         */ this.onTouchStart = NOOP;
                    /**
         * The Touch Start event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchStartWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchStartWindow = NOOP;
                    /**
         * The Touch Move event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchMove
         * @type {function}
         * @since 3.0.0
         */ this.onTouchMove = NOOP;
                    /**
         * The Touch End event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEnd
         * @type {function}
         * @since 3.0.0
         */ this.onTouchEnd = NOOP;
                    /**
         * The Touch End event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchEndWindow
         * @type {function}
         * @since 3.17.0
         */ this.onTouchEndWindow = NOOP;
                    /**
         * The Touch Cancel event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancel
         * @type {function}
         * @since 3.15.0
         */ this.onTouchCancel = NOOP;
                    /**
         * The Touch Cancel event handler function specifically for events on the Window.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchCancelWindow
         * @type {function}
         * @since 3.18.0
         */ this.onTouchCancelWindow = NOOP;
                    /**
         * The Touch Over event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchOver
         * @type {function}
         * @since 3.16.0
         */ this.onTouchOver = NOOP;
                    /**
         * The Touch Out event handler function.
         * Initially empty and bound in the `startListeners` method.
         *
         * @name Phaser.Input.Touch.TouchManager#onTouchOut
         * @type {function}
         * @since 3.16.0
         */ this.onTouchOut = NOOP;
                    inputManager.events.once(InputEvents.MANAGER_BOOT, this.boot, this);
                },
                /**
     * The Touch Manager boot process.
     *
     * @method Phaser.Input.Touch.TouchManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    var config = this.manager.config;
                    this.enabled = config.inputTouch;
                    this.target = config.inputTouchEventTarget;
                    this.capture = config.inputTouchCapture;
                    if (!this.target) this.target = this.manager.game.canvas;
                    if (config.disableContextMenu) this.disableContextMenu();
                    if (this.enabled && this.target) this.startListeners();
                },
                /**
     * Attempts to disable the context menu from appearing if you touch-hold on the browser.
     * 
     * Works by listening for the `contextmenu` event and prevent defaulting it.
     * 
     * Use this if you need to disable the OS context menu on mobile.
     *
     * @method Phaser.Input.Touch.TouchManager#disableContextMenu
     * @since 3.20.0
     *
     * @return {this} This Touch Manager instance.
     */ disableContextMenu: function() {
                    document.body.addEventListener('contextmenu', function(event) {
                        event.preventDefault();
                        return false;
                    });
                    return this;
                },
                /**
     * Starts the Touch Event listeners running as long as an input target is set.
     * 
     * This method is called automatically if Touch Input is enabled in the game config,
     * which it is by default. However, you can call it manually should you need to
     * delay input capturing until later in the game.
     *
     * @method Phaser.Input.Touch.TouchManager#startListeners
     * @since 3.0.0
     */ startListeners: function() {
                    var _this = this;
                    var canvas = this.manager.canvas;
                    var autoFocus = window && window.focus && this.manager.game.config.autoFocus;
                    this.onTouchStart = function(event) {
                        if (autoFocus) window.focus();
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchStart(event);
                            if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onTouchStartWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        _this.manager.onTouchStart(event);
                    };
                    this.onTouchMove = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchMove(event);
                            if (_this.capture && event.cancelable) event.preventDefault();
                        }
                    };
                    this.onTouchEnd = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchEnd(event);
                            if (_this.capture && event.cancelable && event.target === canvas) event.preventDefault();
                        }
                    };
                    this.onTouchEndWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled && event.target !== canvas) //  Only process the event if the target isn't the canvas
                        _this.manager.onTouchEnd(event);
                    };
                    this.onTouchCancel = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) {
                            _this.manager.onTouchCancel(event);
                            if (_this.capture) event.preventDefault();
                        }
                    };
                    this.onTouchCancelWindow = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.onTouchCancel(event);
                    };
                    this.onTouchOver = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.setCanvasOver(event);
                    };
                    this.onTouchOut = function(event) {
                        if (!event.defaultPrevented && _this.enabled && _this.manager && _this.manager.enabled) _this.manager.setCanvasOut(event);
                    };
                    var target = this.target;
                    if (!target) return;
                    var passive = {
                        passive: true
                    };
                    var nonPassive = {
                        passive: false
                    };
                    target.addEventListener('touchstart', this.onTouchStart, this.capture ? nonPassive : passive);
                    target.addEventListener('touchmove', this.onTouchMove, this.capture ? nonPassive : passive);
                    target.addEventListener('touchend', this.onTouchEnd, this.capture ? nonPassive : passive);
                    target.addEventListener('touchcancel', this.onTouchCancel, this.capture ? nonPassive : passive);
                    target.addEventListener('touchover', this.onTouchOver, this.capture ? nonPassive : passive);
                    target.addEventListener('touchout', this.onTouchOut, this.capture ? nonPassive : passive);
                    if (window && this.manager.game.config.inputWindowEvents) {
                        window.addEventListener('touchstart', this.onTouchStartWindow, nonPassive);
                        window.addEventListener('touchend', this.onTouchEndWindow, nonPassive);
                        window.addEventListener('touchcancel', this.onTouchCancelWindow, nonPassive);
                    }
                    this.enabled = true;
                },
                /**
     * Stops the Touch Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Touch.TouchManager#stopListeners
     * @since 3.0.0
     */ stopListeners: function() {
                    var target = this.target;
                    target.removeEventListener('touchstart', this.onTouchStart);
                    target.removeEventListener('touchmove', this.onTouchMove);
                    target.removeEventListener('touchend', this.onTouchEnd);
                    target.removeEventListener('touchcancel', this.onTouchCancel);
                    target.removeEventListener('touchover', this.onTouchOver);
                    target.removeEventListener('touchout', this.onTouchOut);
                    if (window) {
                        window.removeEventListener('touchstart', this.onTouchStartWindow);
                        window.removeEventListener('touchend', this.onTouchEndWindow);
                    }
                },
                /**
     * Destroys this Touch Manager instance.
     *
     * @method Phaser.Input.Touch.TouchManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.stopListeners();
                    this.target = null;
                    this.enabled = false;
                    this.manager = null;
                }
            });
            module1.exports = TouchManager;
        /***/ },
        /* 408 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GameEvents = __webpack_require__(22);
            var EventEmitter = __webpack_require__(9);
            var FileTypesManager = __webpack_require__(8);
            var GameObjectCreator = __webpack_require__(16);
            var GameObjectFactory = __webpack_require__(5);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var Remove = __webpack_require__(89);
            /**
 * @classdesc
 * The PluginManager is responsible for installing and adding plugins to Phaser.
 *
 * It is a global system and therefore belongs to the Game instance, not a specific Scene.
 *
 * It works in conjunction with the PluginCache. Core internal plugins automatically register themselves 
 * with the Cache, but it's the Plugin Manager that is responsible for injecting them into the Scenes.
 *
 * There are two types of plugin:
 *
 * 1. A Global Plugin
 * 2. A Scene Plugin
 *
 * A Global Plugin is a plugin that lives within the Plugin Manager rather than a Scene. You can get
 * access to it by calling `PluginManager.get` and providing a key. Any Scene that requests a plugin in
 * this way will all get access to the same plugin instance, allowing you to use a single plugin across
 * multiple Scenes.
 *
 * A Scene Plugin is a plugin dedicated to running within a Scene. These are different to Global Plugins
 * in that their instances do not live within the Plugin Manager, but within the Scene Systems class instead.
 * And that every Scene created is given its own unique instance of a Scene Plugin. Examples of core Scene
 * Plugins include the Input Plugin, the Tween Plugin and the physics Plugins.
 *
 * You can add a plugin to Phaser in three different ways:
 *
 * 1. Preload it
 * 2. Include it in your source code and install it via the Game Config
 * 3. Include it in your source code and install it within a Scene
 *
 * For examples of all of these approaches please see the Phaser 3 Examples Repo `plugins` folder.
 *
 * For information on creating your own plugin please see the Phaser 3 Plugin Template.
 *
 * @class PluginManager
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The game instance that owns this Plugin Manager.
 */ var PluginManager = new Class({
                Extends: EventEmitter,
                initialize: function PluginManager(game) {
                    EventEmitter.call(this);
                    /**
         * The game instance that owns this Plugin Manager.
         *
         * @name Phaser.Plugins.PluginManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The global plugins currently running and managed by this Plugin Manager.
         * A plugin must have been started at least once in order to appear in this list.
         *
         * @name Phaser.Plugins.PluginManager#plugins
         * @type {Phaser.Types.Plugins.GlobalPlugin[]}
         * @since 3.8.0
         */ this.plugins = [];
                    /**
         * A list of plugin keys that should be installed into Scenes as well as the Core Plugins.
         *
         * @name Phaser.Plugins.PluginManager#scenePlugins
         * @type {string[]}
         * @since 3.8.0
         */ this.scenePlugins = [];
                    /**
         * A temporary list of plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingGlobal
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingGlobal = [];
                    /**
         * A temporary list of scene plugins to install when the game has booted.
         *
         * @name Phaser.Plugins.PluginManager#_pendingScene
         * @private
         * @type {array}
         * @since 3.8.0
         */ this._pendingScene = [];
                    if (game.isBooted) this.boot();
                    else game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * Run once the game has booted and installs all of the plugins configured in the Game Config.
     *
     * @method Phaser.Plugins.PluginManager#boot
     * @protected
     * @since 3.0.0
     */ boot: function() {
                    var i;
                    var entry;
                    var key;
                    var plugin;
                    var start;
                    var mapping;
                    var data;
                    var config = this.game.config;
                    //  Any plugins to install?
                    var list = config.installGlobalPlugins;
                    //  Any plugins added outside of the game config, but before the game booted?
                    list = list.concat(this._pendingGlobal);
                    for(i = 0; i < list.length; i++){
                        entry = list[i];
                        // { key: 'TestPlugin', plugin: TestPlugin, start: true, mapping: 'test', data: { msg: 'The plugin is alive' } }
                        key = GetFastValue(entry, 'key', null);
                        plugin = GetFastValue(entry, 'plugin', null);
                        start = GetFastValue(entry, 'start', false);
                        mapping = GetFastValue(entry, 'mapping', null);
                        data = GetFastValue(entry, 'data', null);
                        if (key) {
                            if (plugin) this.install(key, plugin, start, mapping, data);
                            else console.warn('Missing `plugin` for key: ' + key);
                        }
                    }
                    //  Any scene plugins to install?
                    list = config.installScenePlugins;
                    //  Any plugins added outside of the game config, but before the game booted?
                    list = list.concat(this._pendingScene);
                    for(i = 0; i < list.length; i++){
                        entry = list[i];
                        // { key: 'moveSpritePlugin', plugin: MoveSpritePlugin, , mapping: 'move' }
                        key = GetFastValue(entry, 'key', null);
                        plugin = GetFastValue(entry, 'plugin', null);
                        mapping = GetFastValue(entry, 'mapping', null);
                        if (key) {
                            if (plugin) this.installScenePlugin(key, plugin, mapping);
                            else console.warn('Missing `plugin` for key: ' + key);
                        }
                    }
                    this._pendingGlobal = [];
                    this._pendingScene = [];
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * Called by the Scene Systems class. Tells the plugin manager to install all Scene plugins into it.
     *
     * First it will install global references, i.e. references from the Game systems into the Scene Systems (and Scene if mapped.)
     * Then it will install Core Scene Plugins followed by Scene Plugins registered with the PluginManager.
     * Finally it will install any references to Global Plugins that have a Scene mapping property into the Scene itself.
     *
     * @method Phaser.Plugins.PluginManager#addToScene
     * @protected
     * @since 3.8.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems class to install all the plugins in to.
     * @param {array} globalPlugins - An array of global plugins to install.
     * @param {array} scenePlugins - An array of scene plugins to install.
     */ addToScene: function(sys, globalPlugins, scenePlugins) {
                    var i;
                    var pluginKey;
                    var pluginList;
                    var game = this.game;
                    var scene = sys.scene;
                    var map = sys.settings.map;
                    var isBooted = sys.settings.isBooted;
                    //  Reference the GlobalPlugins from Game into Scene.Systems
                    for(i = 0; i < globalPlugins.length; i++){
                        pluginKey = globalPlugins[i];
                        if (game[pluginKey]) {
                            sys[pluginKey] = game[pluginKey];
                            //  Scene level injection
                            if (map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = sys[pluginKey];
                        } else if (pluginKey === 'game' && map.hasOwnProperty(pluginKey)) scene[map[pluginKey]] = game;
                    }
                    for(var s = 0; s < scenePlugins.length; s++){
                        pluginList = scenePlugins[s];
                        for(i = 0; i < pluginList.length; i++){
                            pluginKey = pluginList[i];
                            if (!PluginCache.hasCore(pluginKey)) continue;
                            var source = PluginCache.getCore(pluginKey);
                            var plugin = new source.plugin(scene, this);
                            sys[source.mapping] = plugin;
                            //  Scene level injection
                            if (source.custom) scene[source.mapping] = plugin;
                            else if (map.hasOwnProperty(source.mapping)) scene[map[source.mapping]] = plugin;
                            //  Scene is already booted, usually because this method is being called at run-time, so boot the plugin
                            if (isBooted) plugin.boot();
                        }
                    }
                    //  And finally, inject any 'global scene plugins'
                    pluginList = this.plugins;
                    for(i = 0; i < pluginList.length; i++){
                        var entry = pluginList[i];
                        if (entry.mapping) scene[entry.mapping] = entry.plugin;
                    }
                },
                /**
     * Called by the Scene Systems class. Returns a list of plugins to be installed.
     *
     * @method Phaser.Plugins.PluginManager#getDefaultScenePlugins
     * @protected
     * @since 3.8.0
     *
     * @return {string[]} A list keys of all the Scene Plugins to install.
     */ getDefaultScenePlugins: function() {
                    var list = this.game.config.defaultPlugins;
                    //  Merge in custom Scene plugins
                    list = list.concat(this.scenePlugins);
                    return list;
                },
                /**
     * Installs a new Scene Plugin into the Plugin Manager and optionally adds it
     * to the given Scene as well. A Scene Plugin added to the manager in this way
     * will be automatically installed into all new Scenes using the key and mapping given.
     *
     * The `key` property is what the plugin is injected into Scene.Systems as.
     * The `mapping` property is optional, and if specified is what the plugin is installed into
     * the Scene as. For example:
     *
     * ```javascript
     * this.plugins.installScenePlugin('powerupsPlugin', pluginCode, 'powerups');
     * 
     * // and from within the scene:
     * this.sys.powerupsPlugin; // key value
     * this.powerups; // mapping value
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * @method Phaser.Plugins.PluginManager#installScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The property key that will be used to add this plugin to Scene.Systems.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {Phaser.Scene} [addToScene] - Optionally automatically add this plugin to the given Scene.
     * @param {boolean} [fromLoader=false] - Is this being called by the Loader?
     */ installScenePlugin: function(key, plugin, mapping, addToScene, fromLoader) {
                    if (fromLoader === undefined) fromLoader = false;
                    if (typeof plugin !== 'function') {
                        console.warn('Invalid Scene Plugin: ' + key);
                        return;
                    }
                    if (!PluginCache.hasCore(key)) {
                        //  Plugin is freshly loaded
                        PluginCache.register(key, plugin, mapping, true);
                        this.scenePlugins.push(key);
                    } else if (!fromLoader && PluginCache.hasCore(key)) {
                        //  Plugin wasn't from the loader but already exists
                        console.warn('Scene Plugin key in use: ' + key);
                        return;
                    }
                    if (addToScene) {
                        var instance = new plugin(addToScene, this);
                        addToScene.sys[key] = instance;
                        if (mapping && mapping !== '') addToScene[mapping] = instance;
                        instance.boot();
                    }
                },
                /**
     * Installs a new Global Plugin into the Plugin Manager and optionally starts it running.
     * A global plugin belongs to the Plugin Manager, rather than a specific Scene, and can be accessed
     * and used by all Scenes in your game.
     *
     * The `key` property is what you use to access this plugin from the Plugin Manager.
     *
     * ```javascript
     * this.plugins.install('powerupsPlugin', pluginCode);
     * 
     * // and from within the scene:
     * this.plugins.get('powerupsPlugin');
     * ```
     *
     * This method is called automatically by Phaser if you install your plugins using either the
     * Game Configuration object, or by preloading them via the Loader.
     *
     * The same plugin can be installed multiple times into the Plugin Manager by simply giving each
     * instance its own unique key.
     *
     * @method Phaser.Plugins.PluginManager#install
     * @since 3.8.0
     * 
     * @param {string} key - The unique handle given to this plugin within the Plugin Manager.
     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
     * @param {boolean} [start=false] - Automatically start the plugin running? This is always `true` if you provide a mapping value.
     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
     * @param {any} [data] - A value passed to the plugin's `init` method.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if `start` was false, or game isn't yet booted.
     */ install: function(key, plugin, start, mapping, data) {
                    if (start === undefined) start = false;
                    if (mapping === undefined) mapping = null;
                    if (data === undefined) data = null;
                    if (typeof plugin !== 'function') {
                        console.warn('Invalid Plugin: ' + key);
                        return null;
                    }
                    if (PluginCache.hasCustom(key)) {
                        console.warn('Plugin key in use: ' + key);
                        return null;
                    }
                    if (mapping !== null) start = true;
                    if (!this.game.isBooted) this._pendingGlobal.push({
                        key: key,
                        plugin: plugin,
                        start: start,
                        mapping: mapping,
                        data: data
                    });
                    else {
                        //  Add it to the plugin store
                        PluginCache.registerCustom(key, plugin, mapping, data);
                        if (start) return this.start(key);
                    }
                    return null;
                },
                /**
     * Gets an index of a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getIndex
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {number} The index of the plugin within the plugins array.
     */ getIndex: function(key) {
                    var list = this.plugins;
                    for(var i = 0; i < list.length; i++){
                        var entry = list[i];
                        if (entry.key === key) return i;
                    }
                    return -1;
                },
                /**
     * Gets a global plugin based on the given key.
     *
     * @method Phaser.Plugins.PluginManager#getEntry
     * @protected
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {Phaser.Types.Plugins.GlobalPlugin} The plugin entry.
     */ getEntry: function(key) {
                    var idx = this.getIndex(key);
                    if (idx !== -1) return this.plugins[idx];
                },
                /**
     * Checks if the given global plugin, based on its key, is active or not.
     *
     * @method Phaser.Plugins.PluginManager#isActive
     * @since 3.8.0
     *
     * @param {string} key - The unique plugin key.
     *
     * @return {boolean} `true` if the plugin is active, otherwise `false`.
     */ isActive: function(key) {
                    var entry = this.getEntry(key);
                    return entry && entry.active;
                },
                /**
     * Starts a global plugin running.
     *
     * If the plugin was previously active then calling `start` will reset it to an active state and then
     * call its `start` method.
     *
     * If the plugin has never been run before a new instance of it will be created within the Plugin Manager,
     * its active state set and then both of its `init` and `start` methods called, in that order.
     *
     * If the plugin is already running under the given key then nothing happens.
     *
     * @method Phaser.Plugins.PluginManager#start
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to start.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given or plugin is already stopped.
     */ start: function(key, runAs) {
                    if (runAs === undefined) runAs = key;
                    var entry = this.getEntry(runAs);
                    //  Plugin already running under this key?
                    if (entry && !entry.active) {
                        //  It exists, we just need to start it up again
                        entry.active = true;
                        entry.plugin.start();
                    } else if (!entry) entry = this.createEntry(key, runAs);
                    return entry ? entry.plugin : null;
                },
                /**
     * Creates a new instance of a global plugin, adds an entry into the plugins array and returns it.
     *
     * @method Phaser.Plugins.PluginManager#createEntry
     * @private
     * @since 3.9.0
     *
     * @param {string} key - The key of the plugin to create an instance of.
     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
     *
     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given.
     */ createEntry: function(key, runAs) {
                    var entry = PluginCache.getCustom(key);
                    if (entry) {
                        var instance = new entry.plugin(this);
                        entry = {
                            key: runAs,
                            plugin: instance,
                            active: true,
                            mapping: entry.mapping,
                            data: entry.data
                        };
                        this.plugins.push(entry);
                        instance.init(entry.data);
                        instance.start();
                    }
                    return entry;
                },
                /**
     * Stops a global plugin from running.
     *
     * If the plugin is active then its active state will be set to false and the plugins `stop` method
     * will be called.
     *
     * If the plugin is not already running, nothing will happen.
     *
     * @method Phaser.Plugins.PluginManager#stop
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to stop.
     *
     * @return {this} The Plugin Manager.
     */ stop: function(key) {
                    var entry = this.getEntry(key);
                    if (entry && entry.active) {
                        entry.active = false;
                        entry.plugin.stop();
                    }
                    return this;
                },
                /**
     * Gets a global plugin from the Plugin Manager based on the given key and returns it.
     *
     * If it cannot find an active plugin based on the key, but there is one in the Plugin Cache with the same key,
     * then it will create a new instance of the cached plugin and return that.
     *
     * @method Phaser.Plugins.PluginManager#get
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     * @param {boolean} [autoStart=true] - Automatically start a new instance of the plugin if found in the cache, but not actively running.
     *
     * @return {?(Phaser.Plugins.BasePlugin|function)} The plugin, or `null` if no plugin was found matching the key.
     */ get: function(key, autoStart) {
                    if (autoStart === undefined) autoStart = true;
                    var entry = this.getEntry(key);
                    if (entry) return entry.plugin;
                    else {
                        var plugin = this.getClass(key);
                        if (plugin && autoStart) {
                            entry = this.createEntry(key, key);
                            return entry ? entry.plugin : null;
                        } else if (plugin) return plugin;
                    }
                    return null;
                },
                /**
     * Returns the plugin class from the cache.
     * Used internally by the Plugin Manager.
     *
     * @method Phaser.Plugins.PluginManager#getClass
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to get.
     *
     * @return {Phaser.Plugins.BasePlugin} A Plugin object
     */ getClass: function(key) {
                    return PluginCache.getCustomClass(key);
                },
                /**
     * Removes a global plugin from the Plugin Manager and Plugin Cache.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeGlobalPlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeGlobalPlugin: function(key) {
                    var entry = this.getEntry(key);
                    if (entry) Remove(this.plugins, entry);
                    PluginCache.removeCustom(key);
                },
                /**
     * Removes a scene plugin from the Plugin Manager and Plugin Cache.
     *
     * This will not remove the plugin from any active Scenes that are already using it.
     *
     * It is up to you to remove all references to this plugin that you may hold within your game code.
     *
     * @method Phaser.Plugins.PluginManager#removeScenePlugin
     * @since 3.8.0
     *
     * @param {string} key - The key of the plugin to remove.
     */ removeScenePlugin: function(key) {
                    Remove(this.scenePlugins, key);
                    PluginCache.remove(key);
                },
                /**
     * Registers a new type of Game Object with the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new Game Objects.
     *
     * The key is the property that will be injected into the factories and used to create the
     * Game Object. For example:
     *
     * ```javascript
     * this.plugins.registerGameObject('clown', clownFactoryCallback, clownCreatorCallback);
     * // later in your game code:
     * this.add.clown();
     * this.make.clown();
     * ```
     * 
     * The callbacks are what are called when the factories try to create a Game Object
     * matching the given key. It's important to understand that the callbacks are invoked within
     * the context of the GameObjectFactory. In this context there are several properties available
     * to use:
     * 
     * this.scene - A reference to the Scene that owns the GameObjectFactory.
     * this.displayList - A reference to the Display List the Scene owns.
     * this.updateList - A reference to the Update List the Scene owns.
     * 
     * See the GameObjectFactory and GameObjectCreator classes for more details.
     * Any public property or method listed is available from your callbacks under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerGameObject
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} [factoryCallback] - The callback to invoke when the Game Object Factory is called.
     * @param {function} [creatorCallback] - The callback to invoke when the Game Object Creator is called.
     */ registerGameObject: function(key, factoryCallback, creatorCallback) {
                    if (factoryCallback) GameObjectFactory.register(key, factoryCallback);
                    if (creatorCallback) GameObjectCreator.register(key, creatorCallback);
                    return this;
                },
                /**
     * Removes a previously registered Game Object from the global Game Object Factory and / or Creator.
     * This is usually called from within your Plugin destruction code to help clean-up after your plugin has been removed.
     *
     * @method Phaser.Plugins.PluginManager#removeGameObject
     * @since 3.19.0
     *
     * @param {string} key - The key of the Game Object to be removed from the factories.
     * @param {boolean} [removeFromFactory=true] - Should the Game Object be removed from the Game Object Factory?
     * @param {boolean} [removeFromCreator=true] - Should the Game Object be removed from the Game Object Creator?
     */ removeGameObject: function(key, removeFromFactory, removeFromCreator) {
                    if (removeFromFactory === undefined) removeFromFactory = true;
                    if (removeFromCreator === undefined) removeFromCreator = true;
                    if (removeFromFactory) GameObjectFactory.remove(key);
                    if (removeFromCreator) GameObjectCreator.remove(key);
                    return this;
                },
                /**
     * Registers a new file type with the global File Types Manager, making it available to all Loader
     * Plugins created after this.
     * 
     * This is usually called from within your Plugin code and is a helpful short-cut for creating
     * new loader file types.
     *
     * The key is the property that will be injected into the Loader Plugin and used to load the
     * files. For example:
     *
     * ```javascript
     * this.plugins.registerFileType('wad', doomWadLoaderCallback);
     * // later in your preload code:
     * this.load.wad();
     * ```
     * 
     * The callback is what is called when the loader tries to load a file  matching the given key.
     * It's important to understand that the callback is invoked within
     * the context of the LoaderPlugin. In this context there are several properties / methods available
     * to use:
     * 
     * this.addFile - A method to add the new file to the load queue.
     * this.scene - The Scene that owns the Loader Plugin instance.
     *
     * See the LoaderPlugin class for more details. Any public property or method listed is available from
     * your callback under `this`.
     *
     * @method Phaser.Plugins.PluginManager#registerFileType
     * @since 3.8.0
     *
     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
     * @param {function} callback - The callback to invoke when the Game Object Factory is called.
     * @param {Phaser.Scene} [addToScene] - Optionally add this file type into the Loader Plugin owned by the given Scene.
     */ registerFileType: function(key, callback, addToScene) {
                    FileTypesManager.register(key, callback);
                    if (addToScene && addToScene.sys.load) addToScene.sys.load[key] = callback;
                },
                /**
     * Destroys this Plugin Manager and all associated plugins.
     * It will iterate all plugins found and call their `destroy` methods.
     * 
     * The PluginCache will remove all custom plugins.
     *
     * @method Phaser.Plugins.PluginManager#destroy
     * @since 3.8.0
     */ destroy: function() {
                    for(var i = 0; i < this.plugins.length; i++)this.plugins[i].plugin.destroy();
                    PluginCache.destroyCustomPlugins();
                    if (this.game.noReturn) PluginCache.destroyCorePlugins();
                    this.game = null;
                    this.plugins = [];
                    this.scenePlugins = [];
                }
            });
            /*
 * "Sometimes, the elegant implementation is just a function.
 * Not a method. Not a class. Not a framework. Just a function."
 *  -- John Carmack
 */ module1.exports = PluginManager;
        /***/ },
        /* 409 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(198);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(101);
            var GameEvents = __webpack_require__(22);
            var GetInnerHeight = __webpack_require__(395);
            var GetTarget = __webpack_require__(401);
            var GetScreenOrientation = __webpack_require__(396);
            var NOOP = __webpack_require__(1);
            var Rectangle = __webpack_require__(10);
            var Size = __webpack_require__(410);
            var SnapFloor = __webpack_require__(76);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * The Scale Manager handles the scaling, resizing and alignment of the game canvas.
 *
 * The way scaling is handled is by setting the game canvas to a fixed size, which is defined in the
 * game configuration. You also define the parent container in the game config. If no parent is given,
 * it will default to using the document body. The Scale Manager will then look at the available space
 * within the _parent_ and scale the canvas accordingly. Scaling is handled by setting the canvas CSS
 * width and height properties, leaving the width and height of the canvas element itself untouched.
 * Scaling is therefore achieved by keeping the core canvas the same size and 'stretching'
 * it via its CSS properties. This gives the same result and speed as using the `transform-scale` CSS
 * property, without the need for browser prefix handling.
 *
 * The calculations for the scale are heavily influenced by the bounding parent size, which is the computed
 * dimensions of the canvas's parent. The CSS rules of the parent element play an important role in the
 * operation of the Scale Manager. For example, if the parent has no defined width or height, then actions
 * like auto-centering will fail to achieve the required result. The Scale Manager works in tandem with the
 * CSS you set-up on the page hosting your game, rather than taking control of it.
 *
 * #### Parent and Display canvas containment guidelines:
 *
 * - Style the Parent element (of the game canvas) to control the Parent size and thus the games size and layout.
 *
 * - The Parent element's CSS styles should _effectively_ apply maximum (and minimum) bounding behavior.
 *
 * - The Parent element should _not_ apply a padding as this is not accounted for.
 *   If a padding is required apply it to the Parent's parent or apply a margin to the Parent.
 *   If you need to add a border, margin or any other CSS around your game container, then use a parent element and
 *   apply the CSS to this instead, otherwise you'll be constantly resizing the shape of the game container.
 *
 * - The Display canvas layout CSS styles (i.e. margins, size) should not be altered / specified as
 *   they may be updated by the Scale Manager.
 *
 * #### Scale Modes
 *
 * The way the scaling is handled is determined by the `scaleMode` property. The default is `NONE`,
 * which prevents Phaser from scaling or touching the canvas, or its parent, at all. In this mode, you are
 * responsible for all scaling. The other scaling modes afford you automatic scaling.
 *
 * If you wish to scale your game so that it always fits into the available space within the parent, you
 * should use the scale mode `FIT`. Look at the documentation for other scale modes to see what options are
 * available. Here is a basic config showing how to set this scale mode:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     mode: Phaser.Scale.FIT,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * Place the `scale` config object within your game config.
 *
 * If you wish for the canvas to be resized directly, so that the canvas itself fills the available space
 * (i.e. it isn't scaled, it's resized) then use the `RESIZE` scale mode. This will give you a 1:1 mapping
 * of canvas pixels to game size. In this mode CSS isn't used to scale the canvas, it's literally adjusted
 * to fill all available space within the parent. You should be extremely careful about the size of the
 * canvas you're creating when doing this, as the larger the area, the more work the GPU has to do and it's
 * very easy to hit fill-rate limits quickly.
 *
 * For complex, custom-scaling requirements, you should probably consider using the `RESIZE` scale mode,
 * with your own limitations in place re: canvas dimensions and managing the scaling with the game scenes
 * yourself. For the vast majority of games, however, the `FIT` mode is likely to be the most used.
 *
 * Please appreciate that the Scale Manager cannot perform miracles. All it does is scale your game canvas
 * as best it can, based on what it can infer from its surrounding area. There are all kinds of environments
 * where it's up to you to guide and help the canvas position itself, especially when built into rendering
 * frameworks like React and Vue. If your page requires meta tags to prevent user scaling gestures, or such
 * like, then it's up to you to ensure they are present in the html.
 *
 * #### Centering
 *
 * You can also have the game canvas automatically centered. Again, this relies heavily on the parent being
 * properly configured and styled, as the centering offsets are based entirely on the available space
 * within the parent element. Centering is disabled by default, or can be applied horizontally, vertically,
 * or both. Here's an example:
 *
 * ```javascript
 * scale: {
 *     parent: 'yourgamediv',
 *     autoCenter: Phaser.Scale.CENTER_BOTH,
 *     width: 800,
 *     height: 600
 * }
 * ```
 *
 * #### Fullscreen API
 *
 * If the browser supports it, you can send your game into fullscreen mode. In this mode, the game will fill
 * the entire display, removing all browser UI and anything else present on the screen. It will remain in this
 * mode until your game either disables it, or until the user tabs out or presses ESCape if on desktop. It's a
 * great way to achieve a desktop-game like experience from the browser, but it does require a modern browser
 * to handle it. Some mobile browsers also support this.
 *
 * @class ScaleManager
 * @memberof Phaser.Scale
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Game} game - A reference to the Phaser.Game instance.
 */ var ScaleManager = new Class({
                Extends: EventEmitter,
                initialize: function ScaleManager(game) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Phaser.Game instance.
         *
         * @name Phaser.Scale.ScaleManager#game
         * @type {Phaser.Game}
         * @readonly
         * @since 3.15.0
         */ this.game = game;
                    /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         *
         * @name Phaser.Scale.ScaleManager#canvas
         * @type {HTMLCanvasElement}
         * @since 3.16.0
         */ this.canvas;
                    /**
         * The DOM bounds of the canvas element.
         *
         * @name Phaser.Scale.ScaleManager#canvasBounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.16.0
         */ this.canvasBounds = new Rectangle();
                    /**
         * The parent object of the Canvas. Often a div, or the browser window, or nothing in non-browser environments.
         *
         * This is set in the Game Config as the `parent` property. If undefined (or just not present), it will default
         * to use the document body. If specifically set to `null` Phaser will ignore all parent operations.
         *
         * @name Phaser.Scale.ScaleManager#parent
         * @type {?any}
         * @since 3.16.0
         */ this.parent = null;
                    /**
         * Is the parent element the browser window?
         *
         * @name Phaser.Scale.ScaleManager#parentIsWindow
         * @type {boolean}
         * @since 3.16.0
         */ this.parentIsWindow = false;
                    /**
         * The Parent Size component.
         *
         * @name Phaser.Scale.ScaleManager#parentSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.parentSize = new Size();
                    /**
         * The Game Size component.
         *
         * The un-modified game size, as requested in the game config (the raw width / height),
         * as used for world bounds, cameras, etc
         *
         * @name Phaser.Scale.ScaleManager#gameSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.gameSize = new Size();
                    /**
         * The Base Size component.
         *
         * The modified game size, which is the auto-rounded gameSize, used to set the canvas width and height
         * (but not the CSS style)
         *
         * @name Phaser.Scale.ScaleManager#baseSize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.baseSize = new Size();
                    /**
         * The Display Size component.
         *
         * The size used for the canvas style, factoring in the scale mode, parent and other values.
         *
         * @name Phaser.Scale.ScaleManager#displaySize
         * @type {Phaser.Structs.Size}
         * @since 3.16.0
         */ this.displaySize = new Size();
                    /**
         * The game scale mode.
         *
         * @name Phaser.Scale.ScaleManager#scaleMode
         * @type {Phaser.Scale.ScaleModeType}
         * @since 3.16.0
         */ this.scaleMode = CONST.SCALE_MODE.NONE;
                    /**
         * The game zoom factor.
         *
         * This value allows you to multiply your games base size by the given zoom factor.
         * This is then used when calculating the display size, even in `NONE` situations.
         * If you don't want Phaser to touch the canvas style at all, this value should be 1.
         *
         * Can also be set to `MAX_ZOOM` in which case the zoom value will be derived based
         * on the game size and available space within the parent.
         *
         * @name Phaser.Scale.ScaleManager#zoom
         * @type {number}
         * @since 3.16.0
         */ this.zoom = 1;
                    /**
         * Internal flag set when the game zoom factor is modified.
         *
         * @name Phaser.Scale.ScaleManager#_resetZoom
         * @type {boolean}
         * @readonly
         * @since 3.19.0
         */ this._resetZoom = false;
                    /**
         * The scale factor between the baseSize and the canvasBounds.
         *
         * @name Phaser.Scale.ScaleManager#displayScale
         * @type {Phaser.Math.Vector2}
         * @since 3.16.0
         */ this.displayScale = new Vector2(1, 1);
                    /**
         * If set, the canvas sizes will be automatically passed through Math.floor.
         * This results in rounded pixel display values, which is important for performance on legacy
         * and low powered devices, but at the cost of not achieving a 'perfect' fit in some browser windows.
         *
         * @name Phaser.Scale.ScaleManager#autoRound
         * @type {boolean}
         * @since 3.16.0
         */ this.autoRound = false;
                    /**
         * Automatically center the canvas within the parent? The different centering modes are:
         *
         * 1. No centering.
         * 2. Center both horizontally and vertically.
         * 3. Center horizontally.
         * 4. Center vertically.
         *
         * Please be aware that in order to center the game canvas, you must have specified a parent
         * that has a size set, or the canvas parent is the document.body.
         *
         * @name Phaser.Scale.ScaleManager#autoCenter
         * @type {Phaser.Scale.CenterType}
         * @since 3.16.0
         */ this.autoCenter = CONST.CENTER.NO_CENTER;
                    /**
         * The current device orientation.
         *
         * Orientation events are dispatched via the Device Orientation API, typically only on mobile browsers.
         *
         * @name Phaser.Scale.ScaleManager#orientation
         * @type {Phaser.Scale.OrientationType}
         * @since 3.16.0
         */ this.orientation = CONST.ORIENTATION.LANDSCAPE;
                    /**
         * A reference to the Device.Fullscreen object.
         *
         * @name Phaser.Scale.ScaleManager#fullscreen
         * @type {Phaser.Device.Fullscreen}
         * @since 3.16.0
         */ this.fullscreen;
                    /**
         * The DOM Element which is sent into fullscreen mode.
         *
         * @name Phaser.Scale.ScaleManager#fullscreenTarget
         * @type {?any}
         * @since 3.16.0
         */ this.fullscreenTarget = null;
                    /**
         * Did Phaser create the fullscreen target div, or was it provided in the game config?
         *
         * @name Phaser.Scale.ScaleManager#_createdFullscreenTarget
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._createdFullscreenTarget = false;
                    /**
         * The dirty state of the Scale Manager.
         * Set if there is a change between the parent size and the current size.
         *
         * @name Phaser.Scale.ScaleManager#dirty
         * @type {boolean}
         * @since 3.16.0
         */ this.dirty = false;
                    /**
         * How many milliseconds should elapse before checking if the browser size has changed?
         *
         * Most modern browsers dispatch a 'resize' event, which the Scale Manager will listen for.
         * However, older browsers fail to do this, or do it consistently, so we fall back to a
         * more traditional 'size check' based on a time interval. You can control how often it is
         * checked here.
         *
         * @name Phaser.Scale.ScaleManager#resizeInterval
         * @type {number}
         * @since 3.16.0
         */ this.resizeInterval = 500;
                    /**
         * Internal size interval tracker.
         *
         * @name Phaser.Scale.ScaleManager#_lastCheck
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._lastCheck = 0;
                    /**
         * Internal flag to check orientation state.
         *
         * @name Phaser.Scale.ScaleManager#_checkOrientation
         * @type {boolean}
         * @private
         * @since 3.16.0
         */ this._checkOrientation = false;
                    /**
         * Internal object containing our defined event listeners.
         *
         * @name Phaser.Scale.ScaleManager#listeners
         * @type {object}
         * @private
         * @since 3.16.0
         */ this.listeners = {
                        orientationChange: NOOP,
                        windowResize: NOOP,
                        fullScreenChange: NOOP,
                        fullScreenError: NOOP
                    };
                },
                /**
     * Called _before_ the canvas object is created and added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#preBoot
     * @protected
     * @listens Phaser.Core.Events#BOOT
     * @since 3.16.0
     */ preBoot: function() {
                    //  Parse the config to get the scaling values we need
                    this.parseConfig(this.game.config);
                    this.game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot handler is called by Phaser.Game when it first starts up.
     * The renderer is available by now and the canvas has been added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#boot
     * @protected
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     */ boot: function() {
                    var game = this.game;
                    this.canvas = game.canvas;
                    this.fullscreen = game.device.fullscreen;
                    if (this.scaleMode !== CONST.SCALE_MODE.RESIZE) this.displaySize.setAspectMode(this.scaleMode);
                    if (this.scaleMode === CONST.SCALE_MODE.NONE) this.resize(this.width, this.height);
                    else {
                        this.getParentBounds();
                        //  Only set the parent bounds if the parent has an actual size
                        if (this.parentSize.width > 0 && this.parentSize.height > 0) this.displaySize.setParent(this.parentSize);
                        this.refresh();
                    }
                    game.events.on(GameEvents.PRE_STEP, this.step, this);
                    game.events.once(GameEvents.READY, this.refresh, this);
                    game.events.once(GameEvents.DESTROY, this.destroy, this);
                    this.startListeners();
                },
                /**
     * Parses the game configuration to set-up the scale defaults.
     *
     * @method Phaser.Scale.ScaleManager#parseConfig
     * @protected
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ parseConfig: function(config) {
                    //  Get the parent element, if any
                    this.getParent(config);
                    //  Get the size of the parent element
                    //  This can often set a height of zero (especially for un-styled divs)
                    this.getParentBounds();
                    var width = config.width;
                    var height = config.height;
                    var scaleMode = config.scaleMode;
                    var zoom = config.zoom;
                    var autoRound = config.autoRound;
                    //  If width = '100%', or similar value
                    if (typeof width === 'string') {
                        //  If we have a parent with a height, we'll work it out from that
                        var parentWidth = this.parentSize.width;
                        if (parentWidth === 0) parentWidth = window.innerWidth;
                        var parentScaleX = parseInt(width, 10) / 100;
                        width = Math.floor(parentWidth * parentScaleX);
                    }
                    //  If height = '100%', or similar value
                    if (typeof height === 'string') {
                        //  If we have a parent with a height, we'll work it out from that
                        var parentHeight = this.parentSize.height;
                        if (parentHeight === 0) parentHeight = window.innerHeight;
                        var parentScaleY = parseInt(height, 10) / 100;
                        height = Math.floor(parentHeight * parentScaleY);
                    }
                    this.scaleMode = scaleMode;
                    this.autoRound = autoRound;
                    this.autoCenter = config.autoCenter;
                    this.resizeInterval = config.resizeInterval;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.setSize(width, height);
                    if (zoom === CONST.ZOOM.MAX_ZOOM) zoom = this.getMaxZoom();
                    this.zoom = zoom;
                    if (zoom !== 1) this._resetZoom = true;
                    //  The modified game size
                    this.baseSize.setSize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    if (config.minWidth > 0) this.displaySize.setMin(config.minWidth * zoom, config.minHeight * zoom);
                    if (config.maxWidth > 0) this.displaySize.setMax(config.maxWidth * zoom, config.maxHeight * zoom);
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                    this.displaySize.setSize(width, height);
                    this.orientation = GetScreenOrientation(width, height);
                },
                /**
     * Determines the parent element of the game canvas, if any, based on the game configuration.
     *
     * @method Phaser.Scale.ScaleManager#getParent
     * @since 3.16.0
     *
     * @param {Phaser.Types.Core.GameConfig} config - The Game configuration object.
     */ getParent: function(config) {
                    var parent = config.parent;
                    if (parent === null) //  User is responsible for managing the parent
                    return;
                    this.parent = GetTarget(parent);
                    this.parentIsWindow = this.parent === document.body;
                    if (config.expandParent && config.scaleMode !== CONST.SCALE_MODE.NONE) {
                        var DOMRect = this.parent.getBoundingClientRect();
                        if (this.parentIsWindow || DOMRect.height === 0) {
                            document.documentElement.style.height = '100%';
                            document.body.style.height = '100%';
                            DOMRect = this.parent.getBoundingClientRect();
                            //  The parent STILL has no height, clearly no CSS
                            //  has been set on it even though we fixed the body :(
                            if (!this.parentIsWindow && DOMRect.height === 0) {
                                this.parent.style.overflow = 'hidden';
                                this.parent.style.width = '100%';
                                this.parent.style.height = '100%';
                            }
                        }
                    }
                    //  And now get the fullscreenTarget
                    if (config.fullscreenTarget && !this.fullscreenTarget) this.fullscreenTarget = GetTarget(config.fullscreenTarget);
                },
                /**
     * Calculates the size of the parent bounds and updates the `parentSize` component, if the canvas has a dom parent.
     *
     * @method Phaser.Scale.ScaleManager#getParentBounds
     * @since 3.16.0
     *
     * @return {boolean} `true` if the parent bounds have changed size, otherwise `false`.
     */ getParentBounds: function() {
                    if (!this.parent) return false;
                    var parentSize = this.parentSize;
                    // Ref. http://msdn.microsoft.com/en-us/library/hh781509(v=vs.85).aspx for getBoundingClientRect
                    var DOMRect = this.parent.getBoundingClientRect();
                    if (this.parentIsWindow && this.game.device.os.iOS) DOMRect.height = GetInnerHeight(true);
                    var newWidth = DOMRect.width;
                    var newHeight = DOMRect.height;
                    if (parentSize.width !== newWidth || parentSize.height !== newHeight) {
                        parentSize.setSize(newWidth, newHeight);
                        return true;
                    } else return false;
                },
                /**
     * Attempts to lock the orientation of the web browser using the Screen Orientation API.
     *
     * This API is only available on modern mobile browsers.
     * See https://developer.mozilla.org/en-US/docs/Web/API/Screen/lockOrientation for details.
     *
     * @method Phaser.Scale.ScaleManager#lockOrientation
     * @since 3.16.0
     *
     * @param {string} orientation - The orientation you'd like to lock the browser in. Should be an API string such as 'landscape', 'landscape-primary', 'portrait', etc.
     *
     * @return {boolean} `true` if the orientation was successfully locked, otherwise `false`.
     */ lockOrientation: function(orientation) {
                    var lock = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation;
                    if (lock) return lock.call(screen, orientation);
                    return false;
                },
                /**
     * This method will set the size of the Parent Size component, which is used in scaling
     * and centering calculations. You only need to call this method if you have explicitly
     * disabled the use of a parent in your game config, but still wish to take advantage of
     * other Scale Manager features.
     *
     * @method Phaser.Scale.ScaleManager#setParentSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the parent.
     * @param {number} height - The new height of the parent.
     *
     * @return {this} The Scale Manager instance.
     */ setParentSize: function(width, height) {
                    this.parentSize.setSize(width, height);
                    return this.refresh();
                },
                /**
     * This method will set a new size for your game.
     *
     * It should only be used if you're looking to change the base size of your game and are using
     * one of the Scale Manager scaling modes, i.e. `FIT`. If you're using `NONE` and wish to
     * change the game and canvas size directly, then please use the `resize` method instead.
     *
     * @method Phaser.Scale.ScaleManager#setGameSize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setGameSize: function(width, height) {
                    var autoRound = this.autoRound;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    var previousWidth = this.width;
                    var previousHeight = this.height;
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.resize(width, height);
                    //  The modified game size
                    this.baseSize.resize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  Update the aspect ratio
                    this.displaySize.setAspectRatio(width / height);
                    this.canvas.width = this.baseSize.width;
                    this.canvas.height = this.baseSize.height;
                    return this.refresh(previousWidth, previousHeight);
                },
                /**
     * Call this to modify the size of the Phaser canvas element directly.
     * You should only use this if you are using the `NONE` scale mode,
     * it will update all internal components completely.
     *
     * If all you want to do is change the size of the parent, see the `setParentSize` method.
     *
     * If all you want is to change the base size of the game, but still have the Scale Manager
     * manage all the scaling (i.e. you're **not** using `NONE`), then see the `setGameSize` method.
     *
     * This method will set the `gameSize`, `baseSize` and `displaySize` components to the given
     * dimensions. It will then resize the canvas width and height to the values given, by
     * directly setting the properties. Finally, if you have set the Scale Manager zoom value
     * to anything other than 1 (the default), it will set the canvas CSS width and height to
     * be the given size multiplied by the zoom factor (the canvas pixel size remains untouched).
     *
     * If you have enabled `autoCenter`, it is then passed to the `updateCenter` method and
     * the margins are set, allowing the canvas to be centered based on its parent element
     * alone. Finally, the `displayScale` is adjusted and the RESIZE event dispatched.
     *
     * @method Phaser.Scale.ScaleManager#resize
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} width - The new width of the game.
     * @param {number} height - The new height of the game.
     *
     * @return {this} The Scale Manager instance.
     */ resize: function(width, height) {
                    var zoom = this.zoom;
                    var autoRound = this.autoRound;
                    if (autoRound) {
                        width = Math.floor(width);
                        height = Math.floor(height);
                    }
                    var previousWidth = this.width;
                    var previousHeight = this.height;
                    //  The un-modified game size, as requested in the game config (the raw width / height) as used for world bounds, etc
                    this.gameSize.resize(width, height);
                    //  The modified game size
                    this.baseSize.resize(width, height);
                    if (autoRound) {
                        this.baseSize.width = Math.floor(this.baseSize.width);
                        this.baseSize.height = Math.floor(this.baseSize.height);
                    }
                    //  The size used for the canvas style, factoring in the scale mode and parent and zoom value
                    //  We just use the w/h here as this is what sets the aspect ratio (which doesn't then change)
                    this.displaySize.setSize(width * zoom, height * zoom);
                    this.canvas.width = this.baseSize.width;
                    this.canvas.height = this.baseSize.height;
                    var style = this.canvas.style;
                    var styleWidth = width * zoom;
                    var styleHeight = height * zoom;
                    if (autoRound) {
                        styleWidth = Math.floor(styleWidth);
                        styleHeight = Math.floor(styleHeight);
                    }
                    if (styleWidth !== width || styleHeight !== height) {
                        style.width = styleWidth + 'px';
                        style.height = styleHeight + 'px';
                    }
                    return this.refresh(previousWidth, previousHeight);
                },
                /**
     * Sets the zoom value of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#setZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} value - The new zoom value of the game.
     *
     * @return {this} The Scale Manager instance.
     */ setZoom: function(value) {
                    this.zoom = value;
                    this._resetZoom = true;
                    return this.refresh();
                },
                /**
     * Sets the zoom to be the maximum possible based on the _current_ parent size.
     *
     * @method Phaser.Scale.ScaleManager#setMaxZoom
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @return {this} The Scale Manager instance.
     */ setMaxZoom: function() {
                    this.zoom = this.getMaxZoom();
                    this._resetZoom = true;
                    return this.refresh();
                },
                /**
     * Refreshes the internal scale values, bounds sizes and orientation checks.
     *
     * Once finished, dispatches the resize event.
     *
     * This is called automatically by the Scale Manager when the browser window size changes,
     * as long as it is using a Scale Mode other than 'NONE'.
     *
     * @method Phaser.Scale.ScaleManager#refresh
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {number} [previousWidth] - The previous width of the game. Only set if the gameSize has changed.
     * @param {number} [previousHeight] - The previous height of the game. Only set if the gameSize has changed.
     *
     * @return {this} The Scale Manager instance.
     */ refresh: function(previousWidth, previousHeight) {
                    if (previousWidth === undefined) previousWidth = this.width;
                    if (previousHeight === undefined) previousHeight = this.height;
                    this.updateScale();
                    this.updateBounds();
                    this.updateOrientation();
                    this.displayScale.set(this.baseSize.width / this.canvasBounds.width, this.baseSize.height / this.canvasBounds.height);
                    var domContainer = this.game.domContainer;
                    if (domContainer) {
                        this.baseSize.setCSS(domContainer);
                        var canvasStyle = this.canvas.style;
                        var domStyle = domContainer.style;
                        domStyle.transform = 'scale(' + this.displaySize.width / this.baseSize.width + ',' + this.displaySize.height / this.baseSize.height + ')';
                        domStyle.marginLeft = canvasStyle.marginLeft;
                        domStyle.marginTop = canvasStyle.marginTop;
                    }
                    this.emit(Events.RESIZE, this.gameSize, this.baseSize, this.displaySize, previousWidth, previousHeight);
                    return this;
                },
                /**
     * Internal method that checks the current screen orientation, only if the internal check flag is set.
     *
     * If the orientation has changed it updates the orientation property and then dispatches the orientation change event.
     *
     * @method Phaser.Scale.ScaleManager#updateOrientation
     * @fires Phaser.Scale.Events#ORIENTATION_CHANGE
     * @since 3.16.0
     */ updateOrientation: function() {
                    if (this._checkOrientation) {
                        this._checkOrientation = false;
                        var newOrientation = GetScreenOrientation(this.width, this.height);
                        if (newOrientation !== this.orientation) {
                            this.orientation = newOrientation;
                            this.emit(Events.ORIENTATION_CHANGE, newOrientation);
                        }
                    }
                },
                /**
     * Internal method that manages updating the size components based on the scale mode.
     *
     * @method Phaser.Scale.ScaleManager#updateScale
     * @since 3.16.0
     */ updateScale: function() {
                    var style = this.canvas.style;
                    var width = this.gameSize.width;
                    var height = this.gameSize.height;
                    var styleWidth;
                    var styleHeight;
                    var zoom = this.zoom;
                    var autoRound = this.autoRound;
                    if (this.scaleMode === CONST.SCALE_MODE.NONE) {
                        //  No scale
                        this.displaySize.setSize(width * zoom, height * zoom);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        if (this._resetZoom) {
                            style.width = styleWidth + 'px';
                            style.height = styleHeight + 'px';
                            this._resetZoom = false;
                        }
                    } else if (this.scaleMode === CONST.SCALE_MODE.RESIZE) {
                        //  Resize to match parent
                        //  This will constrain using min/max
                        this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                        this.gameSize.setSize(this.displaySize.width, this.displaySize.height);
                        this.baseSize.setSize(this.displaySize.width, this.displaySize.height);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        this.canvas.width = styleWidth;
                        this.canvas.height = styleHeight;
                    } else {
                        //  All other scale modes
                        this.displaySize.setSize(this.parentSize.width, this.parentSize.height);
                        styleWidth = this.displaySize.width;
                        styleHeight = this.displaySize.height;
                        if (autoRound) {
                            styleWidth = Math.floor(styleWidth);
                            styleHeight = Math.floor(styleHeight);
                        }
                        style.width = styleWidth + 'px';
                        style.height = styleHeight + 'px';
                    }
                    //  Update the parentSize in case the canvas / style change modified it
                    this.getParentBounds();
                    //  Finally, update the centering
                    this.updateCenter();
                },
                /**
     * Calculates and returns the largest possible zoom factor, based on the current
     * parent and game sizes. If the parent has no dimensions (i.e. an unstyled div),
     * or is smaller than the un-zoomed game, then this will return a value of 1 (no zoom)
     *
     * @method Phaser.Scale.ScaleManager#getMaxZoom
     * @since 3.16.0
     *
     * @return {number} The maximum possible zoom factor. At a minimum this value is always at least 1.
     */ getMaxZoom: function() {
                    var zoomH = SnapFloor(this.parentSize.width, this.gameSize.width, 0, true);
                    var zoomV = SnapFloor(this.parentSize.height, this.gameSize.height, 0, true);
                    return Math.max(Math.min(zoomH, zoomV), 1);
                },
                /**
     * Calculates and updates the canvas CSS style in order to center it within the
     * bounds of its parent. If you have explicitly set parent to be `null` in your
     * game config then this method will likely give incorrect results unless you have called the
     * `setParentSize` method first.
     *
     * It works by modifying the canvas CSS `marginLeft` and `marginTop` properties.
     *
     * If they have already been set by your own style sheet, or code, this will overwrite them.
     *
     * To prevent the Scale Manager from centering the canvas, either do not set the
     * `autoCenter` property in your game config, or make sure it is set to `NO_CENTER`.
     *
     * @method Phaser.Scale.ScaleManager#updateCenter
     * @since 3.16.0
     */ updateCenter: function() {
                    var autoCenter = this.autoCenter;
                    if (autoCenter === CONST.CENTER.NO_CENTER) return;
                    var canvas = this.canvas;
                    var style = canvas.style;
                    var bounds = canvas.getBoundingClientRect();
                    // var width = parseInt(canvas.style.width, 10) || canvas.width;
                    // var height = parseInt(canvas.style.height, 10) || canvas.height;
                    var width = bounds.width;
                    var height = bounds.height;
                    var offsetX = Math.floor((this.parentSize.width - width) / 2);
                    var offsetY = Math.floor((this.parentSize.height - height) / 2);
                    if (autoCenter === CONST.CENTER.CENTER_HORIZONTALLY) offsetY = 0;
                    else if (autoCenter === CONST.CENTER.CENTER_VERTICALLY) offsetX = 0;
                    style.marginLeft = offsetX + 'px';
                    style.marginTop = offsetY + 'px';
                },
                /**
     * Updates the `canvasBounds` rectangle to match the bounding client rectangle of the
     * canvas element being used to track input events.
     *
     * @method Phaser.Scale.ScaleManager#updateBounds
     * @since 3.16.0
     */ updateBounds: function() {
                    var bounds = this.canvasBounds;
                    var clientRect = this.canvas.getBoundingClientRect();
                    bounds.x = clientRect.left + (window.pageXOffset || 0) - (document.documentElement.clientLeft || 0);
                    bounds.y = clientRect.top + (window.pageYOffset || 0) - (document.documentElement.clientTop || 0);
                    bounds.width = clientRect.width;
                    bounds.height = clientRect.height;
                },
                /**
     * Transforms the pageX value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformX
     * @since 3.16.0
     *
     * @param {number} pageX - The DOM pageX value.
     *
     * @return {number} The translated value.
     */ transformX: function(pageX) {
                    return (pageX - this.canvasBounds.left) * this.displayScale.x;
                },
                /**
     * Transforms the pageY value into the scaled coordinate space of the Scale Manager.
     *
     * @method Phaser.Scale.ScaleManager#transformY
     * @since 3.16.0
     *
     * @param {number} pageY - The DOM pageY value.
     *
     * @return {number} The translated value.
     */ transformY: function(pageY) {
                    return (pageY - this.canvasBounds.top) * this.displayScale.y;
                },
                /**
     * Sends a request to the browser to ask it to go in to full screen mode, using the {@link https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API Fullscreen API}.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a `pointerup` user-input gesture (**not** `pointerdown`). You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * On touch devices, such as Android and iOS Safari, you should always use `pointerup` and NOT `pointerdown`,
     * otherwise the request will fail unless the document in which your game is embedded has already received
     * some form of touch input, which you cannot guarantee. Activating fullscreen via `pointerup` circumvents
     * this issue.
     *
     * Performing an action that navigates to another page, or opens another tab, will automatically cancel
     * fullscreen mode, as will the user pressing the ESC key. To cancel fullscreen mode directly from your game,
     * i.e. by clicking an icon, call the `stopFullscreen` method.
     *
     * A browser can only send one DOM element into fullscreen. You can control which element this is by
     * setting the `fullscreenTarget` property in your game config, or changing the property in the Scale Manager.
     * Note that the game canvas _must_ be a child of the target. If you do not give a target, Phaser will
     * automatically create a blank `<div>` element and move the canvas into it, before going fullscreen.
     * When it leaves fullscreen, the div will be removed.
     *
     * @method Phaser.Scale.ScaleManager#startFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ startFullscreen: function(fullscreenOptions) {
                    if (fullscreenOptions === undefined) fullscreenOptions = {
                        navigationUI: 'hide'
                    };
                    var fullscreen = this.fullscreen;
                    if (!fullscreen.available) {
                        this.emit(Events.FULLSCREEN_UNSUPPORTED);
                        return;
                    }
                    if (!fullscreen.active) {
                        var fsTarget = this.getFullscreenTarget();
                        if (fullscreen.keyboard) fsTarget[fullscreen.request](Element.ALLOW_KEYBOARD_INPUT);
                        else fsTarget[fullscreen.request](fullscreenOptions);
                    }
                },
                /**
     * The browser has successfully entered fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenSuccessHandler
     * @private
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     */ fullscreenSuccessHandler: function() {
                    this.getParentBounds();
                    this.refresh();
                    this.emit(Events.ENTER_FULLSCREEN);
                },
                /**
     * The browser failed to enter fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#fullscreenErrorHandler
     * @private
     * @fires Phaser.Scale.Events#FULLSCREEN_FAILED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.17.0
     *
     * @param {any} error - The DOM error event.
     */ fullscreenErrorHandler: function(error) {
                    this.removeFullscreenTarget();
                    this.emit(Events.FULLSCREEN_FAILED, error);
                },
                /**
     * An internal method that gets the target element that is used when entering fullscreen mode.
     *
     * @method Phaser.Scale.ScaleManager#getFullscreenTarget
     * @since 3.16.0
     *
     * @return {object} The fullscreen target element.
     */ getFullscreenTarget: function() {
                    if (!this.fullscreenTarget) {
                        var fsTarget = document.createElement('div');
                        fsTarget.style.margin = '0';
                        fsTarget.style.padding = '0';
                        fsTarget.style.width = '100%';
                        fsTarget.style.height = '100%';
                        this.fullscreenTarget = fsTarget;
                        this._createdFullscreenTarget = true;
                    }
                    if (this._createdFullscreenTarget) {
                        var canvasParent = this.canvas.parentNode;
                        canvasParent.insertBefore(this.fullscreenTarget, this.canvas);
                        this.fullscreenTarget.appendChild(this.canvas);
                    }
                    return this.fullscreenTarget;
                },
                /**
     * Removes the fullscreen target that was added to the DOM.
     *
     * @method Phaser.Scale.ScaleManager#removeFullscreenTarget
     * @since 3.17.0
     */ removeFullscreenTarget: function() {
                    if (this._createdFullscreenTarget) {
                        var fsTarget = this.fullscreenTarget;
                        if (fsTarget && fsTarget.parentNode) {
                            var parent = fsTarget.parentNode;
                            parent.insertBefore(this.canvas, fsTarget);
                            parent.removeChild(fsTarget);
                        }
                    }
                },
                /**
     * Calling this method will cancel fullscreen mode, if the browser has entered it.
     *
     * @method Phaser.Scale.ScaleManager#stopFullscreen
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @since 3.16.0
     */ stopFullscreen: function() {
                    var fullscreen = this.fullscreen;
                    if (!fullscreen.available) {
                        this.emit(Events.FULLSCREEN_UNSUPPORTED);
                        return false;
                    }
                    if (fullscreen.active) document[fullscreen.cancel]();
                    this.removeFullscreenTarget();
                    //  Get the parent size again as it will have changed
                    this.getParentBounds();
                    this.emit(Events.LEAVE_FULLSCREEN);
                    this.refresh();
                },
                /**
     * Toggles the fullscreen mode. If already in fullscreen, calling this will cancel it.
     * If not in fullscreen, this will request the browser to enter fullscreen mode.
     *
     * If the browser does not support this, a `FULLSCREEN_UNSUPPORTED` event will be emitted.
     *
     * This method _must_ be called from a user-input gesture, such as `pointerdown`. You cannot launch
     * games fullscreen without this, as most browsers block it. Games within an iframe will also be blocked
     * from fullscreen unless the iframe has the `allowfullscreen` attribute.
     *
     * @method Phaser.Scale.ScaleManager#toggleFullscreen
     * @fires Phaser.Scale.Events#ENTER_FULLSCREEN
     * @fires Phaser.Scale.Events#LEAVE_FULLSCREEN
     * @fires Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
     * @fires Phaser.Scale.Events#RESIZE
     * @since 3.16.0
     *
     * @param {object} [fullscreenOptions] - The FullscreenOptions dictionary is used to provide configuration options when entering full screen.
     */ toggleFullscreen: function(fullscreenOptions) {
                    if (this.fullscreen.active) this.stopFullscreen();
                    else this.startFullscreen(fullscreenOptions);
                },
                /**
     * An internal method that starts the different DOM event listeners running.
     *
     * @method Phaser.Scale.ScaleManager#startListeners
     * @since 3.16.0
     */ startListeners: function() {
                    var _this = this;
                    var listeners = this.listeners;
                    listeners.orientationChange = function() {
                        _this.updateBounds();
                        _this._checkOrientation = true;
                        _this.dirty = true;
                    };
                    listeners.windowResize = function() {
                        _this.updateBounds();
                        _this.dirty = true;
                    };
                    //  Only dispatched on mobile devices
                    window.addEventListener('orientationchange', listeners.orientationChange, false);
                    window.addEventListener('resize', listeners.windowResize, false);
                    if (this.fullscreen.available) {
                        listeners.fullScreenChange = function(event) {
                            return _this.onFullScreenChange(event);
                        };
                        listeners.fullScreenError = function(event) {
                            return _this.onFullScreenError(event);
                        };
                        var vendors = [
                            'webkit',
                            'moz',
                            ''
                        ];
                        vendors.forEach(function(prefix) {
                            document.addEventListener(prefix + 'fullscreenchange', listeners.fullScreenChange, false);
                            document.addEventListener(prefix + 'fullscreenerror', listeners.fullScreenError, false);
                        });
                        //  MS Specific
                        document.addEventListener('MSFullscreenChange', listeners.fullScreenChange, false);
                        document.addEventListener('MSFullscreenError', listeners.fullScreenError, false);
                    }
                },
                /**
     * Triggered when a fullscreenchange event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenChange
     * @protected
     * @since 3.16.0
     */ onFullScreenChange: function() {
                    if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreenElement) this.fullscreenSuccessHandler();
                    else //  They pressed ESC while in fullscreen mode
                    this.stopFullscreen();
                },
                /**
     * Triggered when a fullscreenerror event is dispatched by the DOM.
     *
     * @method Phaser.Scale.ScaleManager#onFullScreenError
     * @since 3.16.0
     */ onFullScreenError: function() {
                    this.removeFullscreenTarget();
                },
                /**
     * Internal method, called automatically by the game step.
     * Monitors the elapsed time and resize interval to see if a parent bounds check needs to take place.
     *
     * @method Phaser.Scale.ScaleManager#step
     * @since 3.16.0
     *
     * @param {number} time - The time value from the most recent Game step. Typically a high-resolution timer value, or Date.now().
     * @param {number} delta - The delta value since the last frame. This is smoothed to avoid delta spikes by the TimeStep class.
     */ step: function(time, delta) {
                    if (!this.parent) return;
                    this._lastCheck += delta;
                    if (this.dirty || this._lastCheck > this.resizeInterval) {
                        //  Returns true if the parent bounds have changed size
                        if (this.getParentBounds()) this.refresh();
                        this.dirty = false;
                        this._lastCheck = 0;
                    }
                },
                /**
     * Stops all DOM event listeners.
     *
     * @method Phaser.Scale.ScaleManager#stopListeners
     * @since 3.16.0
     */ stopListeners: function() {
                    var listeners = this.listeners;
                    window.removeEventListener('orientationchange', listeners.orientationChange, false);
                    window.removeEventListener('resize', listeners.windowResize, false);
                    var vendors = [
                        'webkit',
                        'moz',
                        ''
                    ];
                    vendors.forEach(function(prefix) {
                        document.removeEventListener(prefix + 'fullscreenchange', listeners.fullScreenChange, false);
                        document.removeEventListener(prefix + 'fullscreenerror', listeners.fullScreenError, false);
                    });
                    //  MS Specific
                    document.removeEventListener('MSFullscreenChange', listeners.fullScreenChange, false);
                    document.removeEventListener('MSFullscreenError', listeners.fullScreenError, false);
                },
                /**
     * Destroys this Scale Manager, releasing all references to external resources.
     * Once destroyed, the Scale Manager cannot be used again.
     *
     * @method Phaser.Scale.ScaleManager#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.stopListeners();
                    this.game = null;
                    this.canvas = null;
                    this.canvasBounds = null;
                    this.parent = null;
                    this.fullscreenTarget = null;
                    this.parentSize.destroy();
                    this.gameSize.destroy();
                    this.baseSize.destroy();
                    this.displaySize.destroy();
                },
                /**
     * Is the browser currently in fullscreen mode or not?
     *
     * @name Phaser.Scale.ScaleManager#isFullscreen
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isFullscreen: {
                    get: function() {
                        return this.fullscreen.active;
                    }
                },
                /**
     * The game width.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#width
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ width: {
                    get: function() {
                        return this.gameSize.width;
                    }
                },
                /**
     * The game height.
     *
     * This is typically the size given in the game configuration.
     *
     * @name Phaser.Scale.ScaleManager#height
     * @type {number}
     * @readonly
     * @since 3.16.0
     */ height: {
                    get: function() {
                        return this.gameSize.height;
                    }
                },
                /**
     * Is the device in a portrait orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isPortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isPortrait: {
                    get: function() {
                        return this.orientation === CONST.ORIENTATION.PORTRAIT;
                    }
                },
                /**
     * Is the device in a landscape orientation as reported by the Orientation API?
     * This value is usually only available on mobile devices.
     *
     * @name Phaser.Scale.ScaleManager#isLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isLandscape: {
                    get: function() {
                        return this.orientation === CONST.ORIENTATION.LANDSCAPE;
                    }
                },
                /**
     * Are the game dimensions portrait? (i.e. taller than they are wide)
     *
     * This is different to the device itself being in a portrait orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGamePortrait
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGamePortrait: {
                    get: function() {
                        return this.height > this.width;
                    }
                },
                /**
     * Are the game dimensions landscape? (i.e. wider than they are tall)
     *
     * This is different to the device itself being in a landscape orientation.
     *
     * @name Phaser.Scale.ScaleManager#isGameLandscape
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isGameLandscape: {
                    get: function() {
                        return this.width > this.height;
                    }
                }
            });
            module1.exports = ScaleManager;
        /***/ },
        /* 410 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var SnapFloor = __webpack_require__(76);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * The Size component allows you to set `width` and `height` properties and define the relationship between them.
 * 
 * The component can automatically maintain the aspect ratios between the two values, and clamp them
 * to a defined min-max range. You can also control the dominant axis. When dimensions are given to the Size component
 * that would cause it to exceed its min-max range, the dimensions are adjusted based on the dominant axis.
 *
 * @class Size
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.16.0
 *
 * @param {number} [width=0] - The width of the Size component.
 * @param {number} [height=width] - The height of the Size component. If not given, it will use the `width`.
 * @param {number} [aspectMode=0] - The aspect mode of the Size component. Defaults to 0, no mode.
 * @param {any} [parent=null] - The parent of this Size component. Can be any object with public `width` and `height` properties. Dimensions are clamped to keep them within the parent bounds where possible.
 */ var Size = new Class({
                initialize: function Size(width, height, aspectMode, parent) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    if (aspectMode === undefined) aspectMode = 0;
                    if (parent === undefined) parent = null;
                    /**
         * Internal width value.
         *
         * @name Phaser.Structs.Size#_width
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._width = width;
                    /**
         * Internal height value.
         *
         * @name Phaser.Structs.Size#_height
         * @type {number}
         * @private
         * @since 3.16.0
         */ this._height = height;
                    /**
         * Internal parent reference.
         *
         * @name Phaser.Structs.Size#_parent
         * @type {any}
         * @private
         * @since 3.16.0
         */ this._parent = parent;
                    /**
         * The aspect mode this Size component will use when calculating its dimensions.
         * This property is read-only. To change it use the `setAspectMode` method.
         *
         * @name Phaser.Structs.Size#aspectMode
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectMode = aspectMode;
                    /**
         * The proportional relationship between the width and height.
         * 
         * This property is read-only and is updated automatically when either the `width` or `height` properties are changed,
         * depending on the aspect mode.
         *
         * @name Phaser.Structs.Size#aspectRatio
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.aspectRatio = height === 0 ? 1 : width / height;
                    /**
         * The minimum allowed width.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minWidth = 0;
                    /**
         * The minimum allowed height.
         * Cannot be less than zero.
         * This value is read-only. To change it see the `setMin` method.
         *
         * @name Phaser.Structs.Size#minHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.minHeight = 0;
                    /**
         * The maximum allowed width.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxWidth
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxWidth = Number.MAX_VALUE;
                    /**
         * The maximum allowed height.
         * This value is read-only. To change it see the `setMax` method.
         *
         * @name Phaser.Structs.Size#maxHeight
         * @type {number}
         * @readonly
         * @since 3.16.0
         */ this.maxHeight = Number.MAX_VALUE;
                    /**
         * A Vector2 containing the horizontal and vertical snap values, which the width and height are snapped to during resizing.
         * 
         * By default this is disabled.
         * 
         * This property is read-only. To change it see the `setSnap` method.
         *
         * @name Phaser.Structs.Size#snapTo
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.16.0
         */ this.snapTo = new Vector2();
                },
                /**
     * Sets the aspect mode of this Size component.
     * 
     * The aspect mode controls what happens when you modify the `width` or `height` properties, or call `setSize`.
     * 
     * It can be a number from 0 to 4, or a Size constant:
     * 
     * 0. NONE = Do not make the size fit the aspect ratio. Change the ratio when the size changes.
     * 1. WIDTH_CONTROLS_HEIGHT = The height is automatically adjusted based on the width.
     * 2. HEIGHT_CONTROLS_WIDTH = The width is automatically adjusted based on the height.
     * 3. FIT = The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
     * 4. ENVELOP = The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
     * 
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     * 
     * @method Phaser.Structs.Size#setAspectMode
     * @since 3.16.0
     *
     * @param {number} [value=0] - The aspect mode value.
     *
     * @return {this} This Size component instance.
     */ setAspectMode: function(value) {
                    if (value === undefined) value = 0;
                    this.aspectMode = value;
                    return this.setSize(this._width, this._height);
                },
                /**
     * By setting a Snap To value when this Size component is modified its dimensions will automatically
     * by snapped to the nearest grid slice, using floor. For example, if you have snap value of 16,
     * and the width changes to 68, then it will snap down to 64 (the closest multiple of 16 when floored)
     * 
     * Note that snapping takes place before adjustments by the parent, or the min / max settings. If these
     * values are not multiples of the given snap values, then this can result in un-snapped dimensions.
     * 
     * Call this method with no arguments to reset the snap values.
     * 
     * Calling this method automatically recalculates the `width` and the `height`, if required.
     * 
     * @method Phaser.Structs.Size#setSnap
     * @since 3.16.0
     *
     * @param {number} [snapWidth=0] - The amount to snap the width to. If you don't want to snap the width, pass a value of zero.
     * @param {number} [snapHeight=snapWidth] - The amount to snap the height to. If not provided it will use the `snapWidth` value. If you don't want to snap the height, pass a value of zero.
     *
     * @return {this} This Size component instance.
     */ setSnap: function(snapWidth, snapHeight) {
                    if (snapWidth === undefined) snapWidth = 0;
                    if (snapHeight === undefined) snapHeight = snapWidth;
                    this.snapTo.set(snapWidth, snapHeight);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets, or clears, the parent of this Size component.
     * 
     * To clear the parent call this method with no arguments.
     * 
     * The parent influences the maximum extents to which this Size component can expand,
     * based on the aspect mode:
     * 
     * NONE - The parent clamps both the width and height.
     * WIDTH_CONTROLS_HEIGHT - The parent clamps just the width.
     * HEIGHT_CONTROLS_WIDTH - The parent clamps just the height.
     * FIT - The parent clamps whichever axis is required to ensure the size fits within it.
     * ENVELOP - The parent is used to ensure the size fully envelops the parent.
     * 
     * Calling this method automatically calls `setSize`.
     *
     * @method Phaser.Structs.Size#setParent
     * @since 3.16.0
     *
     * @param {any} [parent] - Sets the parent of this Size component. Don't provide a value to clear an existing parent.
     *
     * @return {this} This Size component instance.
     */ setParent: function(parent) {
                    this._parent = parent;
                    return this.setSize(this._width, this._height);
                },
                /**
     * Set the minimum width and height values this Size component will allow.
     * 
     * The minimum values can never be below zero, or greater than the maximum values.
     * 
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     * 
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the minimums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMin
     * @since 3.16.0
     *
     * @param {number} [width=0] - The minimum allowed width of the Size component.
     * @param {number} [height=width] - The minimum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMin: function(width, height) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    this.minWidth = Clamp(width, 0, this.maxWidth);
                    this.minHeight = Clamp(height, 0, this.maxHeight);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Set the maximum width and height values this Size component will allow.
     * 
     * Setting this will automatically adjust both the `width` and `height` properties to ensure they are within range.
     * 
     * Note that based on the aspect mode, and if this Size component has a parent set or not, the maximums set here
     * _can_ be exceed in some situations.
     *
     * @method Phaser.Structs.Size#setMax
     * @since 3.16.0
     *
     * @param {number} [width=Number.MAX_VALUE] - The maximum allowed width of the Size component.
     * @param {number} [height=width] - The maximum allowed height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setMax: function(width, height) {
                    if (width === undefined) width = Number.MAX_VALUE;
                    if (height === undefined) height = width;
                    this.maxWidth = Clamp(width, this.minWidth, Number.MAX_VALUE);
                    this.maxHeight = Clamp(height, this.minHeight, Number.MAX_VALUE);
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets the width and height of this Size component based on the aspect mode.
     * 
     * If the aspect mode is 'none' then calling this method will change the aspect ratio, otherwise the current
     * aspect ratio is honored across all other modes.
     * 
     * If snapTo values have been set then the given width and height are snapped first, prior to any further
     * adjustment via min/max values, or a parent.
     * 
     * If minimum and/or maximum dimensions have been specified, the values given to this method will be clamped into
     * that range prior to adjustment, but may still exceed them depending on the aspect mode.
     * 
     * If this Size component has a parent set, and the aspect mode is `fit` or `envelop`, then the given sizes will
     * be clamped to the range specified by the parent.
     *
     * @method Phaser.Structs.Size#setSize
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ setSize: function(width, height) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    switch(this.aspectMode){
                        case Size.NONE:
                            this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                            this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                            this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                            break;
                        case Size.WIDTH_CONTROLS_HEIGHT:
                            this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                            this._height = this.getNewHeight(this._width * (1 / this.aspectRatio), false);
                            break;
                        case Size.HEIGHT_CONTROLS_WIDTH:
                            this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                            this._width = this.getNewWidth(this._height * this.aspectRatio, false);
                            break;
                        case Size.FIT:
                            this.constrain(width, height, true);
                            break;
                        case Size.ENVELOP:
                            this.constrain(width, height, false);
                            break;
                    }
                    return this;
                },
                /**
     * Sets a new aspect ratio, overriding what was there previously.
     * 
     * It then calls `setSize` immediately using the current dimensions.
     *
     * @method Phaser.Structs.Size#setAspectRatio
     * @since 3.16.0
     *
     * @param {number} ratio - The new aspect ratio.
     *
     * @return {this} This Size component instance.
     */ setAspectRatio: function(ratio) {
                    this.aspectRatio = ratio;
                    return this.setSize(this._width, this._height);
                },
                /**
     * Sets a new width and height for this Size component and updates the aspect ratio based on them.
     * 
     * It _doesn't_ change the `aspectMode` and still factors in size limits such as the min max and parent bounds.
     *
     * @method Phaser.Structs.Size#resize
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     * @param {number} [height=width] - The new height of the Size component. If not given, it will use the `width`.
     *
     * @return {this} This Size component instance.
     */ resize: function(width, height) {
                    this._width = this.getNewWidth(SnapFloor(width, this.snapTo.x));
                    this._height = this.getNewHeight(SnapFloor(height, this.snapTo.y));
                    this.aspectRatio = this._height === 0 ? 1 : this._width / this._height;
                    return this;
                },
                /**
     * Takes a new width and passes it through the min/max clamp and then checks it doesn't exceed the parent width.
     *
     * @method Phaser.Structs.Size#getNewWidth
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified width value.
     */ getNewWidth: function(value, checkParent) {
                    if (checkParent === undefined) checkParent = true;
                    value = Clamp(value, this.minWidth, this.maxWidth);
                    if (checkParent && this._parent && value > this._parent.width) value = Math.max(this.minWidth, this._parent.width);
                    return value;
                },
                /**
     * Takes a new height and passes it through the min/max clamp and then checks it doesn't exceed the parent height.
     *
     * @method Phaser.Structs.Size#getNewHeight
     * @since 3.16.0
     *
     * @param {number} value - The value to clamp and check.
     * @param {boolean} [checkParent=true] - Check the given value against the parent, if set.
     *
     * @return {number} The modified height value.
     */ getNewHeight: function(value, checkParent) {
                    if (checkParent === undefined) checkParent = true;
                    value = Clamp(value, this.minHeight, this.maxHeight);
                    if (checkParent && this._parent && value > this._parent.height) value = Math.max(this.minHeight, this._parent.height);
                    return value;
                },
                /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     * 
     * If `fit` is true there may be some space inside the target area which is not covered if its aspect ratio differs.
     * If `fit` is false the size may extend further out than the target area if the aspect ratios differ.
     * 
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#constrain
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     * @param {boolean} [fit=true] - Perform a `fit` (true) constraint, or an `envelop` (false) constraint.
     *
     * @return {this} This Size component instance.
     */ constrain: function(width, height, fit) {
                    if (width === undefined) width = 0;
                    if (height === undefined) height = width;
                    if (fit === undefined) fit = true;
                    width = this.getNewWidth(width);
                    height = this.getNewHeight(height);
                    var snap = this.snapTo;
                    var newRatio = height === 0 ? 1 : width / height;
                    if (fit && this.aspectRatio > newRatio || !fit && this.aspectRatio < newRatio) {
                        //  We need to change the height to fit the width
                        width = SnapFloor(width, snap.x);
                        height = width / this.aspectRatio;
                        if (snap.y > 0) {
                            height = SnapFloor(height, snap.y);
                            //  Reduce the width accordingly
                            width = height * this.aspectRatio;
                        }
                    } else if (fit && this.aspectRatio < newRatio || !fit && this.aspectRatio > newRatio) {
                        //  We need to change the width to fit the height
                        height = SnapFloor(height, snap.y);
                        width = height * this.aspectRatio;
                        if (snap.x > 0) {
                            width = SnapFloor(width, snap.x);
                            //  Reduce the height accordingly
                            height = width * (1 / this.aspectRatio);
                        }
                    }
                    this._width = width;
                    this._height = height;
                    return this;
                },
                /**
     * The current `width` and `height` are adjusted to fit inside the given dimensions, while keeping the aspect ratio.
     * 
     * There may be some space inside the target area which is not covered if its aspect ratio differs.
     * 
     * If this Size component has a parent set, then the width and height passed to this method will be clamped so
     * it cannot exceed that of the parent.
     *
     * @method Phaser.Structs.Size#fitTo
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ fitTo: function(width, height) {
                    return this.constrain(width, height, true);
                },
                /**
     * The current `width` and `height` are adjusted so that they fully envelope the given dimensions, while keeping the aspect ratio.
     * 
     * The size may extend further out than the target area if the aspect ratios differ.
     * 
     * If this Size component has a parent set, then the values are clamped so that it never exceeds the parent
     * on the longest axis.
     *
     * @method Phaser.Structs.Size#envelop
     * @since 3.16.0
     *
     * @param {number} [width=0] - The new width of the Size component.
     * @param {number} [height] - The new height of the Size component. If not given, it will use the width value.
     *
     * @return {this} This Size component instance.
     */ envelop: function(width, height) {
                    return this.constrain(width, height, false);
                },
                /**
     * Sets the width of this Size component.
     * 
     * Depending on the aspect mode, changing the width may also update the height and aspect ratio.
     *
     * @method Phaser.Structs.Size#setWidth
     * @since 3.16.0
     *
     * @param {number} width - The new width of the Size component.
     *
     * @return {this} This Size component instance.
     */ setWidth: function(value) {
                    return this.setSize(value, this._height);
                },
                /**
     * Sets the height of this Size component.
     * 
     * Depending on the aspect mode, changing the height may also update the width and aspect ratio.
     *
     * @method Phaser.Structs.Size#setHeight
     * @since 3.16.0
     *
     * @param {number} height - The new height of the Size component.
     *
     * @return {this} This Size component instance.
     */ setHeight: function(value) {
                    return this.setSize(this._width, value);
                },
                /**
     * Returns a string representation of this Size component.
     *
     * @method Phaser.Structs.Size#toString
     * @since 3.16.0
     *
     * @return {string} A string representation of this Size component.
     */ toString: function() {
                    return '[{ Size (width=' + this._width + ' height=' + this._height + ' aspectRatio=' + this.aspectRatio + ' aspectMode=' + this.aspectMode + ') }]';
                },
                /**
     * Sets the values of this Size component to the `element.style.width` and `height`
     * properties of the given DOM Element. The properties are set as `px` values.
     *
     * @method Phaser.Structs.Size#setCSS
     * @since 3.17.0
     *
     * @param {HTMLElement} element - The DOM Element to set the CSS style on.
     */ setCSS: function(element) {
                    if (element && element.style) {
                        element.style.width = this._width + 'px';
                        element.style.height = this._height + 'px';
                    }
                },
                /**
     * Copies the aspect mode, aspect ratio, width and height from this Size component
     * to the given Size component. Note that the parent, if set, is not copied across.
     *
     * @method Phaser.Structs.Size#copy
     * @since 3.16.0
     * 
     * @param {Phaser.Structs.Size} destination - The Size component to copy the values to.
     *
     * @return {Phaser.Structs.Size} The updated destination Size component.
     */ copy: function(destination) {
                    destination.setAspectMode(this.aspectMode);
                    destination.aspectRatio = this.aspectRatio;
                    return destination.setSize(this.width, this.height);
                },
                /**
     * Destroys this Size component.
     * 
     * This clears the local properties and any parent object, if set.
     * 
     * A destroyed Size component cannot be re-used.
     *
     * @method Phaser.Structs.Size#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this._parent = null;
                    this.snapTo = null;
                },
                /**
     * The width of this Size component.
     * 
     * This value is clamped to the range specified by `minWidth` and `maxWidth`, if enabled.
     * 
     * A width can never be less than zero.
     * 
     * Changing this value will automatically update the `height` if the aspect ratio lock is enabled.
     * You can also use the `setWidth` and `getWidth` methods.
     *
     * @name Phaser.Structs.Size#width
     * @type {number}
     * @since 3.16.0
     */ width: {
                    get: function() {
                        return this._width;
                    },
                    set: function(value) {
                        this.setSize(value, this._height);
                    }
                },
                /**
     * The height of this Size component.
     * 
     * This value is clamped to the range specified by `minHeight` and `maxHeight`, if enabled.
     * 
     * A height can never be less than zero.
     * 
     * Changing this value will automatically update the `width` if the aspect ratio lock is enabled.
     * You can also use the `setHeight` and `getHeight` methods.
     *
     * @name Phaser.Structs.Size#height
     * @type {number}
     * @since 3.16.0
     */ height: {
                    get: function() {
                        return this._height;
                    },
                    set: function(value) {
                        this.setSize(this._width, value);
                    }
                }
            });
            /**
 * Do not make the size fit the aspect ratio. Change the ratio when the size changes.
 * 
 * @name Phaser.Structs.Size.NONE
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.NONE = 0;
            /**
 * The height is automatically adjusted based on the width.
 * 
 * @name Phaser.Structs.Size.WIDTH_CONTROLS_HEIGHT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.WIDTH_CONTROLS_HEIGHT = 1;
            /**
 * The width is automatically adjusted based on the height.
 * 
 * @name Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.HEIGHT_CONTROLS_WIDTH = 2;
            /**
 * The width and height are automatically adjusted to fit inside the given target area, while keeping the aspect ratio. Depending on the aspect ratio there may be some space inside the area which is not covered.
 * 
 * @name Phaser.Structs.Size.FIT
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.FIT = 3;
            /**
 * The width and height are automatically adjusted to make the size cover the entire target area while keeping the aspect ratio. This may extend further out than the target size.
 * 
 * @name Phaser.Structs.Size.ENVELOP
 * @constant
 * @type {number}
 * @since 3.16.0
 */ Size.ENVELOP = 4;
            module1.exports = Size;
        /***/ },
        /* 411 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(142);
            var Events = __webpack_require__(21);
            var GameEvents = __webpack_require__(22);
            var GetValue = __webpack_require__(6);
            var LoaderEvents = __webpack_require__(91);
            var NOOP = __webpack_require__(1);
            var Scene = __webpack_require__(412);
            var Systems = __webpack_require__(201);
            /**
 * @classdesc
 * The Scene Manager.
 *
 * The Scene Manager is a Game level system, responsible for creating, processing and updating all of the
 * Scenes in a Game instance.
ó *
 *
 * @class SceneManager
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Scene Manager belongs to.
 * @param {object} sceneConfig - Scene specific configuration settings.
 */ var SceneManager = new Class({
                initialize: function SceneManager(game, sceneConfig) {
                    /**
         * The Game that this SceneManager belongs to.
         *
         * @name Phaser.Scenes.SceneManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * An object that maps the keys to the scene so we can quickly get a scene from a key without iteration.
         *
         * @name Phaser.Scenes.SceneManager#keys
         * @type {object}
         * @since 3.0.0
         */ this.keys = {};
                    /**
         * The array in which all of the scenes are kept.
         *
         * @name Phaser.Scenes.SceneManager#scenes
         * @type {array}
         * @since 3.0.0
         */ this.scenes = [];
                    /**
         * Scenes pending to be added are stored in here until the manager has time to add it.
         *
         * @name Phaser.Scenes.SceneManager#_pending
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * An array of scenes waiting to be started once the game has booted.
         *
         * @name Phaser.Scenes.SceneManager#_start
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._start = [];
                    /**
         * An operations queue, because we don't manipulate the scenes array during processing.
         *
         * @name Phaser.Scenes.SceneManager#_queue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._queue = [];
                    /**
         * Boot time data to merge.
         *
         * @name Phaser.Scenes.SceneManager#_data
         * @type {object}
         * @private
         * @since 3.4.0
         */ this._data = {};
                    /**
         * Is the Scene Manager actively processing the Scenes list?
         *
         * @name Phaser.Scenes.SceneManager#isProcessing
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.isProcessing = false;
                    /**
         * Has the Scene Manager properly started?
         *
         * @name Phaser.Scenes.SceneManager#isBooted
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.4.0
         */ this.isBooted = false;
                    /**
         * Do any of the Cameras in any of the Scenes require a custom viewport?
         * If not we can skip scissor tests.
         *
         * @name Phaser.Scenes.SceneManager#customViewports
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.customViewports = 0;
                    if (sceneConfig) {
                        if (!Array.isArray(sceneConfig)) sceneConfig = [
                            sceneConfig
                        ];
                        for(var i = 0; i < sceneConfig.length; i++)//  The i === 0 part just autostarts the first Scene given (unless it says otherwise in its config)
                        this._pending.push({
                            key: 'default',
                            scene: sceneConfig[i],
                            autoStart: i === 0,
                            data: {}
                        });
                    }
                    game.events.once(GameEvents.READY, this.bootQueue, this);
                },
                /**
     * Internal first-time Scene boot handler.
     *
     * @method Phaser.Scenes.SceneManager#bootQueue
     * @private
     * @since 3.2.0
     */ bootQueue: function() {
                    if (this.isBooted) return;
                    var i;
                    var entry;
                    var key;
                    var sceneConfig;
                    for(i = 0; i < this._pending.length; i++){
                        entry = this._pending[i];
                        key = entry.key;
                        sceneConfig = entry.scene;
                        var newScene;
                        if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                        else if (typeof sceneConfig === 'object') newScene = this.createSceneFromObject(key, sceneConfig);
                        else if (typeof sceneConfig === 'function') newScene = this.createSceneFromFunction(key, sceneConfig);
                        //  Replace key in case the scene changed it
                        key = newScene.sys.settings.key;
                        this.keys[key] = newScene;
                        this.scenes.push(newScene);
                        //  Any data to inject?
                        if (this._data[key]) {
                            newScene.sys.settings.data = this._data[key].data;
                            if (this._data[key].autoStart) entry.autoStart = true;
                        }
                        if (entry.autoStart || newScene.sys.settings.active) this._start.push(key);
                    }
                    //  Clear the pending lists
                    this._pending.length = 0;
                    this._data = {};
                    this.isBooted = true;
                    //  _start might have been populated by the above
                    for(i = 0; i < this._start.length; i++){
                        entry = this._start[i];
                        this.start(entry);
                    }
                    this._start.length = 0;
                },
                /**
     * Process the Scene operations queue.
     *
     * @method Phaser.Scenes.SceneManager#processQueue
     * @since 3.0.0
     */ processQueue: function() {
                    var pendingLength = this._pending.length;
                    var queueLength = this._queue.length;
                    if (pendingLength === 0 && queueLength === 0) return;
                    var i;
                    var entry;
                    if (pendingLength) {
                        for(i = 0; i < pendingLength; i++){
                            entry = this._pending[i];
                            this.add(entry.key, entry.scene, entry.autoStart, entry.data);
                        }
                        //  _start might have been populated by this.add
                        for(i = 0; i < this._start.length; i++){
                            entry = this._start[i];
                            this.start(entry);
                        }
                        //  Clear the pending lists
                        this._start.length = 0;
                        this._pending.length = 0;
                        return;
                    }
                    for(i = 0; i < this._queue.length; i++){
                        entry = this._queue[i];
                        this[entry.op](entry.keyA, entry.keyB);
                    }
                    this._queue.length = 0;
                },
                /**
     * Adds a new Scene into the SceneManager.
     * You must give each Scene a unique key by which you'll identify it.
     *
     * The `sceneConfig` can be:
     *
     * * A `Phaser.Scene` object, or an object that extends it.
     * * A plain JavaScript object
     * * A JavaScript ES6 Class that extends `Phaser.Scene`
     * * A JavaScript ES5 prototype based Class
     * * A JavaScript function
     *
     * If a function is given then a new Scene will be created by calling it.
     *
     * @method Phaser.Scenes.SceneManager#add
     * @since 3.0.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig|function)} sceneConfig - The config for the Scene
     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
     * @param {object} [data] - Optional data object. This will be set as `Scene.settings.data` and passed to `Scene.init`, and `Scene.create`.
     *
     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
     */ add: function(key, sceneConfig, autoStart, data) {
                    if (autoStart === undefined) autoStart = false;
                    if (data === undefined) data = {};
                    //  If processing or not booted then put scene into a holding pattern
                    if (this.isProcessing || !this.isBooted) {
                        this._pending.push({
                            key: key,
                            scene: sceneConfig,
                            autoStart: autoStart,
                            data: data
                        });
                        if (!this.isBooted) this._data[key] = {
                            data: data
                        };
                        return null;
                    }
                    key = this.getKey(key, sceneConfig);
                    var newScene;
                    if (sceneConfig instanceof Scene) newScene = this.createSceneFromInstance(key, sceneConfig);
                    else if (typeof sceneConfig === 'object') {
                        sceneConfig.key = key;
                        newScene = this.createSceneFromObject(key, sceneConfig);
                    } else if (typeof sceneConfig === 'function') newScene = this.createSceneFromFunction(key, sceneConfig);
                    //  Any data to inject?
                    newScene.sys.settings.data = data;
                    //  Replace key in case the scene changed it
                    key = newScene.sys.settings.key;
                    this.keys[key] = newScene;
                    this.scenes.push(newScene);
                    if (autoStart || newScene.sys.settings.active) {
                        if (this._pending.length) this._start.push(key);
                        else this.start(key);
                    }
                    return newScene;
                },
                /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.SceneManager#remove
     * @since 3.2.0
     *
     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ remove: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: 'remove',
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var sceneToRemove = this.getScene(key);
                        if (!sceneToRemove || sceneToRemove.sys.isTransitioning()) return this;
                        var index = this.scenes.indexOf(sceneToRemove);
                        var sceneKey = sceneToRemove.sys.settings.key;
                        if (index > -1) {
                            delete this.keys[sceneKey];
                            this.scenes.splice(index, 1);
                            if (this._start.indexOf(sceneKey) > -1) {
                                index = this._start.indexOf(sceneKey);
                                this._start.splice(index, 1);
                            }
                            sceneToRemove.sys.destroy();
                        }
                    }
                    return this;
                },
                /**
     * Boot the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#bootScene
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to boot.
     */ bootScene: function(scene) {
                    var sys = scene.sys;
                    var settings = sys.settings;
                    sys.sceneUpdate = NOOP;
                    if (scene.init) {
                        scene.init.call(scene, settings.data);
                        settings.status = CONST.INIT;
                        if (settings.isTransition) sys.events.emit(Events.TRANSITION_INIT, settings.transitionFrom, settings.transitionDuration);
                    }
                    var loader;
                    if (sys.load) {
                        loader = sys.load;
                        loader.reset();
                    }
                    if (loader && scene.preload) {
                        scene.preload.call(scene);
                        //  Is the loader empty?
                        if (loader.list.size === 0) this.create(scene);
                        else {
                            settings.status = CONST.LOADING;
                            //  Start the loader going as we have something in the queue
                            loader.once(LoaderEvents.COMPLETE, this.loadComplete, this);
                            loader.start();
                        }
                    } else //  No preload? Then there was nothing to load either
                    this.create(scene);
                },
                /**
     * Handles load completion for a Scene's Loader.
     *
     * Starts the Scene that the Loader belongs to.
     *
     * @method Phaser.Scenes.SceneManager#loadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading.
     */ loadComplete: function(loader) {
                    var scene = loader.scene;
                    //  TODO - Remove. This should *not* be handled here
                    //  Try to unlock HTML5 sounds every time any loader completes
                    if (this.game.sound && this.game.sound.onBlurPausedSounds) this.game.sound.unlock();
                    this.create(scene);
                },
                /**
     * Handle payload completion for a Scene.
     *
     * @method Phaser.Scenes.SceneManager#payloadComplete
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading its Scene's payload.
     */ payloadComplete: function(loader) {
                    this.bootScene(loader.scene);
                },
                /**
     * Updates the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#update
     * @since 3.0.0
     *
     * @param {number} time - Time elapsed.
     * @param {number} delta - Delta time from the last update.
     */ update: function(time, delta) {
                    this.processQueue();
                    this.isProcessing = true;
                    //  Loop through the active scenes in reverse order
                    for(var i = this.scenes.length - 1; i >= 0; i--){
                        var sys = this.scenes[i].sys;
                        if (sys.settings.status > CONST.START && sys.settings.status <= CONST.RUNNING) sys.step(time, delta);
                    }
                },
                /**
     * Renders the Scenes.
     *
     * @method Phaser.Scenes.SceneManager#render
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer to use.
     */ render: function(renderer) {
                    //  Loop through the scenes in forward order
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        if (sys.settings.visible && sys.settings.status >= CONST.LOADING && sys.settings.status < CONST.SLEEPING) sys.render(renderer);
                    }
                    this.isProcessing = false;
                },
                /**
     * Calls the given Scene's {@link Phaser.Scene#create} method and updates its status.
     *
     * @method Phaser.Scenes.SceneManager#create
     * @private
     * @fires Phaser.Scenes.Events#CREATE
     * @fires Phaser.Scenes.Events#TRANSITION_INIT
     * @since 3.0.0
     *
     * @param {Phaser.Scene} scene - The Scene to create.
     */ create: function(scene) {
                    var sys = scene.sys;
                    var settings = sys.settings;
                    if (scene.create) {
                        settings.status = CONST.CREATING;
                        scene.create.call(scene, settings.data);
                        if (settings.status === CONST.DESTROYED) return;
                    }
                    if (settings.isTransition) sys.events.emit(Events.TRANSITION_START, settings.transitionFrom, settings.transitionDuration);
                    //  If the Scene has an update function we'll set it now, otherwise it'll remain as NOOP
                    if (scene.update) sys.sceneUpdate = scene.update;
                    settings.status = CONST.RUNNING;
                    sys.events.emit(Events.CREATE, scene);
                },
                /**
     * Creates and initializes a Scene from a function.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromFunction
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {function} scene - The function to create the Scene from.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromFunction: function(key, scene) {
                    var newScene = new scene();
                    if (newScene instanceof Scene) {
                        var configKey = newScene.sys.settings.key;
                        if (configKey !== '') key = configKey;
                        if (this.keys.hasOwnProperty(key)) throw new Error('Cannot add a Scene with duplicate key: ' + key);
                        return this.createSceneFromInstance(key, newScene);
                    } else {
                        newScene.sys = new Systems(newScene);
                        newScene.sys.settings.key = key;
                        newScene.sys.init(this.game);
                        return newScene;
                    }
                },
                /**
     * Creates and initializes a Scene instance.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromInstance
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {Phaser.Scene} newScene - The Scene instance.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromInstance: function(key, newScene) {
                    var configKey = newScene.sys.settings.key;
                    if (configKey === '') newScene.sys.settings.key = key;
                    newScene.sys.init(this.game);
                    return newScene;
                },
                /**
     * Creates and initializes a Scene from an Object definition.
     *
     * @method Phaser.Scenes.SceneManager#createSceneFromObject
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key of the Scene.
     * @param {(string|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig)} sceneConfig - The Scene config.
     *
     * @return {Phaser.Scene} The created Scene.
     */ createSceneFromObject: function(key, sceneConfig) {
                    var newScene = new Scene(sceneConfig);
                    var configKey = newScene.sys.settings.key;
                    if (configKey !== '') key = configKey;
                    else newScene.sys.settings.key = key;
                    newScene.sys.init(this.game);
                    //  Extract callbacks
                    var defaults = [
                        'init',
                        'preload',
                        'create',
                        'update',
                        'render'
                    ];
                    for(var i = 0; i < defaults.length; i++){
                        var sceneCallback = GetValue(sceneConfig, defaults[i], null);
                        if (sceneCallback) newScene[defaults[i]] = sceneCallback;
                    }
                    //  Now let's move across any other functions or properties that may exist in the extend object:
                    /*
        scene: {
            preload: preload,
            create: create,
            extend: {
                hello: 1,
                test: 'atari',
                addImage: addImage
            }
        }
        */ if (sceneConfig.hasOwnProperty('extend')) for(var propertyKey in sceneConfig.extend){
                        if (!sceneConfig.extend.hasOwnProperty(propertyKey)) continue;
                        var value = sceneConfig.extend[propertyKey];
                        if (propertyKey === 'data' && newScene.hasOwnProperty('data') && typeof value === 'object') //  Populate the DataManager
                        newScene.data.merge(value);
                        else if (propertyKey !== 'sys') newScene[propertyKey] = value;
                    }
                    return newScene;
                },
                /**
     * Retrieves the key of a Scene from a Scene config.
     *
     * @method Phaser.Scenes.SceneManager#getKey
     * @private
     * @since 3.0.0
     *
     * @param {string} key - The key to check in the Scene config.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|function)} sceneConfig - The Scene config.
     *
     * @return {string} The Scene key.
     */ getKey: function(key, sceneConfig) {
                    if (!key) key = 'default';
                    if (typeof sceneConfig === 'function') return key;
                    else if (sceneConfig instanceof Scene) key = sceneConfig.sys.settings.key;
                    else if (typeof sceneConfig === 'object' && sceneConfig.hasOwnProperty('key')) key = sceneConfig.key;
                    //  By this point it's either 'default' or extracted from the Scene
                    if (this.keys.hasOwnProperty(key)) throw new Error('Cannot add a Scene with duplicate key: ' + key);
                    else return key;
                },
                /**
     * Returns an array of all the current Scenes being managed by this Scene Manager.
     *
     * You can filter the output by the active state of the Scene and choose to have
     * the array returned in normal or reversed order.
     *
     * @method Phaser.Scenes.SceneManager#getScenes
     * @since 3.16.0
     *
     * @param {boolean} [isActive=true] - Only include Scene's that are currently active?
     * @param {boolean} [inReverse=false] - Return the array of Scenes in reverse?
     *
     * @return {Phaser.Scene[]} An array containing all of the Scenes in the Scene Manager.
     */ getScenes: function(isActive, inReverse) {
                    if (isActive === undefined) isActive = true;
                    if (inReverse === undefined) inReverse = false;
                    var out = [];
                    var scenes = this.scenes;
                    for(var i = 0; i < scenes.length; i++){
                        var scene = scenes[i];
                        if (scene && (!isActive || isActive && scene.sys.isActive())) out.push(scene);
                    }
                    return inReverse ? out.reverse() : out;
                },
                /**
     * Retrieves a Scene.
     *
     * @method Phaser.Scenes.SceneManager#getScene
     * @since 3.0.0
     *
     * @param {string|Phaser.Scene} key - The Scene to retrieve.
     *
     * @return {?Phaser.Scene} The Scene.
     */ getScene: function(key) {
                    if (typeof key === 'string') {
                        if (this.keys[key]) return this.keys[key];
                    } else for(var i = 0; i < this.scenes.length; i++){
                        if (key === this.scenes[i]) return key;
                    }
                    return null;
                },
                /**
     * Determines whether a Scene is running.
     *
     * @method Phaser.Scenes.SceneManager#isActive
     * @since 3.0.0
     *
     * @param {string} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running.
     */ isActive: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isActive();
                    return null;
                },
                /**
     * Determines whether a Scene is paused.
     *
     * @method Phaser.Scenes.SceneManager#isPaused
     * @since 3.17.0
     *
     * @param {string} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused.
     */ isPaused: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isPaused();
                    return null;
                },
                /**
     * Determines whether a Scene is visible.
     *
     * @method Phaser.Scenes.SceneManager#isVisible
     * @since 3.0.0
     *
     * @param {string} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible.
     */ isVisible: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isVisible();
                    return null;
                },
                /**
     * Determines whether a Scene is sleeping.
     *
     * @method Phaser.Scenes.SceneManager#isSleeping
     * @since 3.0.0
     *
     * @param {string} key - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping.
     */ isSleeping: function(key) {
                    var scene = this.getScene(key);
                    if (scene) return scene.sys.isSleeping();
                    return null;
                },
                /**
     * Pauses the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#pause
     * @since 3.0.0
     *
     * @param {string} key - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its pause event.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ pause: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.pause(data);
                    return this;
                },
                /**
     * Resumes the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#resume
     * @since 3.0.0
     *
     * @param {string} key - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its resume event.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ resume: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.resume(data);
                    return this;
                },
                /**
     * Puts the given Scene to sleep.
     *
     * @method Phaser.Scenes.SceneManager#sleep
     * @since 3.0.0
     *
     * @param {string} key - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its sleep event.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ sleep: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene && !scene.sys.isTransitioning()) scene.sys.sleep(data);
                    return this;
                },
                /**
     * Awakens the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#wake
     * @since 3.0.0
     *
     * @param {string} key - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted by its wake event.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ wake: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene) scene.sys.wake(data);
                    return this;
                },
                /**
     * Runs the given Scene.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.SceneManager#run
     * @since 3.10.0
     *
     * @param {string} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene on start, wake, or resume.
     *
     * @return {Phaser.Scenes.SceneManager} This Scene Manager.
     */ run: function(key, data) {
                    var scene = this.getScene(key);
                    if (!scene) {
                        for(var i = 0; i < this._pending.length; i++)if (this._pending[i].key === key) {
                            this.queueOp('start', key, data);
                            break;
                        }
                        return this;
                    }
                    if (scene.sys.isSleeping()) //  Sleeping?
                    scene.sys.wake(data);
                    else if (scene.sys.isPaused()) //  Paused?
                    scene.sys.resume(data);
                    else //  Not actually running?
                    this.start(key, data);
                },
                /**
     * Starts the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#start
     * @since 3.0.0
     *
     * @param {string} key - The Scene to start.
     * @param {object} [data] - Optional data object to pass to `Scene.Settings` and `Scene.init`, and `Scene.create`.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ start: function(key, data) {
                    //  If the Scene Manager is not running, then put the Scene into a holding pattern
                    if (!this.isBooted) {
                        this._data[key] = {
                            autoStart: true,
                            data: data
                        };
                        return this;
                    }
                    var scene = this.getScene(key);
                    if (scene) {
                        var sys = scene.sys;
                        //  If the Scene is already running (perhaps they called start from a launched sub-Scene?)
                        //  then we close it down before starting it again.
                        if (sys.isActive() || sys.isPaused()) {
                            sys.shutdown();
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                        } else {
                            sys.sceneUpdate = NOOP;
                            sys.start(data);
                            var loader;
                            if (sys.load) loader = sys.load;
                            //  Files payload?
                            if (loader && sys.settings.hasOwnProperty('pack')) {
                                loader.reset();
                                if (loader.addPack({
                                    payload: sys.settings.pack
                                })) {
                                    sys.settings.status = CONST.LOADING;
                                    loader.once(LoaderEvents.COMPLETE, this.payloadComplete, this);
                                    loader.start();
                                    return this;
                                }
                            }
                        }
                        this.bootScene(scene);
                    }
                    return this;
                },
                /**
     * Stops the given Scene.
     *
     * @method Phaser.Scenes.SceneManager#stop
     * @since 3.0.0
     *
     * @param {string} key - The Scene to stop.
     * @param {object} [data] - Optional data object to pass to Scene.shutdown.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ stop: function(key, data) {
                    var scene = this.getScene(key);
                    if (scene && !scene.sys.isTransitioning()) scene.sys.shutdown(data);
                    return this;
                },
                /**
     * Sleeps one one Scene and starts the other.
     *
     * @method Phaser.Scenes.SceneManager#switch
     * @since 3.0.0
     *
     * @param {string} from - The Scene to sleep.
     * @param {string} to - The Scene to start.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ switch: function(from, to) {
                    var sceneA = this.getScene(from);
                    var sceneB = this.getScene(to);
                    if (sceneA && sceneB && sceneA !== sceneB) {
                        this.sleep(from);
                        if (this.isSleeping(to)) this.wake(to);
                        else this.start(to);
                    }
                    return this;
                },
                /**
     * Retrieves a Scene by numeric index.
     *
     * @method Phaser.Scenes.SceneManager#getAt
     * @since 3.0.0
     *
     * @param {number} index - The index of the Scene to retrieve.
     *
     * @return {(Phaser.Scene|undefined)} The Scene.
     */ getAt: function(index) {
                    return this.scenes[index];
                },
                /**
     * Retrieves the numeric index of a Scene.
     *
     * @method Phaser.Scenes.SceneManager#getIndex
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The key of the Scene.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                    var scene = this.getScene(key);
                    return this.scenes.indexOf(scene);
                },
                /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#bringToTop
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ bringToTop: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: 'bringToTop',
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var index = this.getIndex(key);
                        if (index !== -1 && index < this.scenes.length) {
                            var scene = this.getScene(key);
                            this.scenes.splice(index, 1);
                            this.scenes.push(scene);
                        }
                    }
                    return this;
                },
                /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.SceneManager#sendToBack
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ sendToBack: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: 'sendToBack',
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var index = this.getIndex(key);
                        if (index !== -1 && index > 0) {
                            var scene = this.getScene(key);
                            this.scenes.splice(index, 1);
                            this.scenes.unshift(scene);
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveDown
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ moveDown: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: 'moveDown',
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var indexA = this.getIndex(key);
                        if (indexA > 0) {
                            var indexB = indexA - 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#moveUp
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} key - The Scene to move.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ moveUp: function(key) {
                    if (this.isProcessing) this._queue.push({
                        op: 'moveUp',
                        keyA: key,
                        keyB: null
                    });
                    else {
                        var indexA = this.getIndex(key);
                        if (indexA < this.scenes.length - 1) {
                            var indexB = indexA + 1;
                            var sceneA = this.getScene(key);
                            var sceneB = this.getAt(indexB);
                            this.scenes[indexA] = sceneB;
                            this.scenes[indexB] = sceneA;
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene so it is immediately above another Scene in the Scenes list.
     *
     * This means it will render over the top of the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveAbove
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ moveAbove: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: 'moveAbove',
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            //  Add in new location
                            this.scenes.splice(indexA + 1, 0, tempScene);
                        }
                    }
                    return this;
                },
                /**
     * Moves a Scene so it is immediately below another Scene in the Scenes list.
     *
     * This means it will render behind the other Scene.
     *
     * @method Phaser.Scenes.SceneManager#moveBelow
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ moveBelow: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: 'moveBelow',
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexB);
                            //  Remove
                            this.scenes.splice(indexB, 1);
                            if (indexA === 0) this.scenes.unshift(tempScene);
                            else //  Add in new location
                            this.scenes.splice(indexA, 0, tempScene);
                        }
                    }
                    return this;
                },
                /**
     * Queue a Scene operation for the next update.
     *
     * @method Phaser.Scenes.SceneManager#queueOp
     * @private
     * @since 3.0.0
     *
     * @param {string} op - The operation to perform.
     * @param {(string|Phaser.Scene)} keyA - Scene A.
     * @param {(any|string|Phaser.Scene)} [keyB] - Scene B, or a data object.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ queueOp: function(op, keyA, keyB) {
                    this._queue.push({
                        op: op,
                        keyA: keyA,
                        keyB: keyB
                    });
                    return this;
                },
                /**
     * Swaps the positions of two Scenes in the Scenes list.
     *
     * @method Phaser.Scenes.SceneManager#swapPosition
     * @since 3.0.0
     *
     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
     * @param {(string|Phaser.Scene)} keyB - The second Scene to swap.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ swapPosition: function(keyA, keyB) {
                    if (keyA === keyB) return this;
                    if (this.isProcessing) this._queue.push({
                        op: 'swapPosition',
                        keyA: keyA,
                        keyB: keyB
                    });
                    else {
                        var indexA = this.getIndex(keyA);
                        var indexB = this.getIndex(keyB);
                        if (indexA !== indexB && indexA !== -1 && indexB !== -1) {
                            var tempScene = this.getAt(indexA);
                            this.scenes[indexA] = this.scenes[indexB];
                            this.scenes[indexB] = tempScene;
                        }
                    }
                    return this;
                },
                /**
     * Dumps debug information about each Scene to the developer console.
     *
     * @method Phaser.Scenes.SceneManager#dump
     * @since 3.2.0
     */ dump: function() {
                    var out = [];
                    var map = [
                        'pending',
                        'init',
                        'start',
                        'loading',
                        'creating',
                        'running',
                        'paused',
                        'sleeping',
                        'shutdown',
                        'destroyed'
                    ];
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        var key = sys.settings.visible && (sys.settings.status === CONST.RUNNING || sys.settings.status === CONST.PAUSED) ? '[*] ' : '[-] ';
                        key += sys.settings.key + ' (' + map[sys.settings.status] + ')';
                        out.push(key);
                    }
                    console.log(out.join('\n'));
                },
                /**
     * Destroy the SceneManager and all of its Scene's systems.
     *
     * @method Phaser.Scenes.SceneManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var i = 0; i < this.scenes.length; i++){
                        var sys = this.scenes[i].sys;
                        sys.destroy();
                    }
                    this.update = NOOP;
                    this.scenes = [];
                    this._pending = [];
                    this._start = [];
                    this._queue = [];
                    this.game = null;
                }
            });
            module1.exports = SceneManager;
        /***/ },
        /* 412 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Systems = __webpack_require__(201);
            /**
 * @classdesc
 * A base Phaser.Scene class which can be extended for your own use.
 *
 * You can also define the optional methods {@link Phaser.Types.Scenes.SceneInitCallback init()}, {@link Phaser.Types.Scenes.ScenePreloadCallback preload()}, and {@link Phaser.Types.Scenes.SceneCreateCallback create()}.
 *
 * @class Scene
 * @memberof Phaser
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - Scene specific configuration settings.
 */ var Scene = new Class({
                initialize: function Scene(config) {
                    /**
         * The Scene Systems. You must never overwrite this property, or all hell will break lose.
         *
         * @name Phaser.Scene#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = new Systems(this, config);
                    /**
         * A reference to the Phaser.Game instance.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game;
                    /**
         * A reference to the global Animation Manager.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims;
                    /**
         * A reference to the global Cache.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache;
                    /**
         * A reference to the game level Data Manager.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry;
                    /**
         * A reference to the Sound Manager.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#sound
         * @type {Phaser.Sound.BaseSoundManager}
         * @since 3.0.0
         */ this.sound;
                    /**
         * A reference to the Texture Manager.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures;
                    /**
         * A scene level Event Emitter.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events;
                    /**
         * A scene level Camera System.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    /**
         * A scene level Game Object Factory.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#add
         * @type {Phaser.GameObjects.GameObjectFactory}
         * @since 3.0.0
         */ this.add;
                    /**
         * A scene level Game Object Creator.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#make
         * @type {Phaser.GameObjects.GameObjectCreator}
         * @since 3.0.0
         */ this.make;
                    /**
         * A reference to the Scene Manager Plugin.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scene
         * @type {Phaser.Scenes.ScenePlugin}
         * @since 3.0.0
         */ this.scene;
                    /**
         * A scene level Game Object Display List.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#children
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.children;
                    /**
         * A scene level Lights Manager Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#lights
         * @type {Phaser.GameObjects.LightsManager}
         * @since 3.0.0
         */ this.lights;
                    /**
         * A scene level Data Manager Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#data
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.data;
                    /**
         * A scene level Input Manager Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#input
         * @type {Phaser.Input.InputPlugin}
         * @since 3.0.0
         */ this.input;
                    /**
         * A scene level Loader Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#load
         * @type {Phaser.Loader.LoaderPlugin}
         * @since 3.0.0
         */ this.load;
                    /**
         * A scene level Time and Clock Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#time
         * @type {Phaser.Time.Clock}
         * @since 3.0.0
         */ this.time;
                    /**
         * A scene level Tween Manager Plugin.
         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
         *
         * @name Phaser.Scene#tweens
         * @type {Phaser.Tweens.TweenManager}
         * @since 3.0.0
         */ this.tweens;
                    /**
         * A scene level Arcade Physics Plugin.
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#physics
         * @type {Phaser.Physics.Arcade.ArcadePhysics}
         * @since 3.0.0
         */ this.physics;
                    /**
         * A scene level Matter Physics Plugin.
         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
         *
         * @name Phaser.Scene#matter
         * @type {Phaser.Physics.Matter.MatterPhysics}
         * @since 3.0.0
         */ this.matter;
                    /**
         * A reference to the global Scale Manager.
         * This property will only be available if defined in the Scene Injection Map.
         *
         * @name Phaser.Scene#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.2
         */ this.scale;
                    /**
         * A reference to the Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Scene#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins;
                    /**
         * A reference to the renderer instance Phaser is using, either Canvas or WebGL.
         *
         * @name Phaser.Scene#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.50.0
         */ this.renderer;
                },
                /**
     * Should be overridden by your own Scenes.
     * This method is called once per game step while the scene is running.
     *
     * @method Phaser.Scene#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function() {}
            });
            module1.exports = Scene;
        /***/ },
        /* 413 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var UppercaseFirst = __webpack_require__(202);
            /**
 * Builds an array of which physics plugins should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetPhysicsPlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The scene system to get the physics systems of.
 *
 * @return {array} An array of Physics systems to start for this Scene.
 */ var GetPhysicsPlugins = function(sys) {
                var defaultSystem = sys.game.config.defaultPhysicsSystem;
                var sceneSystems = GetFastValue(sys.settings, 'physics', false);
                if (!defaultSystem && !sceneSystems) //  No default physics system or systems in this scene
                return;
                //  Let's build the systems array
                var output = [];
                if (defaultSystem) output.push(UppercaseFirst(defaultSystem + 'Physics'));
                if (sceneSystems) for(var key in sceneSystems){
                    key = UppercaseFirst(key.concat('Physics'));
                    if (output.indexOf(key) === -1) output.push(key);
                }
                //  An array of Physics systems to start for this Scene
                return output;
            };
            module1.exports = GetPhysicsPlugins;
        /***/ },
        /* 414 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Builds an array of which plugins (not including physics plugins) should be activated for the given Scene.
 *
 * @function Phaser.Scenes.GetScenePlugins
 * @since 3.0.0
 *
 * @param {Phaser.Scenes.Systems} sys - The Scene Systems object to check for plugins.
 *
 * @return {array} An array of all plugins which should be activated, either the default ones or the ones configured in the Scene Systems object.
 */ var GetScenePlugins = function(sys) {
                var defaultPlugins = sys.plugins.getDefaultScenePlugins();
                var scenePlugins = GetFastValue(sys.settings, 'plugins', false);
                //  Scene Plugins always override Default Plugins
                if (Array.isArray(scenePlugins)) return scenePlugins;
                else if (defaultPlugins) return defaultPlugins;
                else //  No default plugins or plugins in this scene
                return [];
            };
            module1.exports = GetScenePlugins;
        /***/ },
        /* 415 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(142);
            var GetValue = __webpack_require__(6);
            var Merge = __webpack_require__(143);
            var InjectionMap = __webpack_require__(974);
            /**
 * @namespace Phaser.Scenes.Settings
 */ var Settings = {
                /**
     * Takes a Scene configuration object and returns a fully formed System Settings object.
     *
     * @function Phaser.Scenes.Settings.create
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Scenes.SettingsConfig)} config - The Scene configuration object used to create this Scene Settings.
     *
     * @return {Phaser.Types.Scenes.SettingsObject} The Scene Settings object created as a result of the config and default settings.
     */ create: function(config) {
                    if (typeof config === 'string') config = {
                        key: config
                    };
                    else if (config === undefined) //  Pass the 'hasOwnProperty' checks
                    config = {};
                    return {
                        status: CONST.PENDING,
                        key: GetValue(config, 'key', ''),
                        active: GetValue(config, 'active', false),
                        visible: GetValue(config, 'visible', true),
                        isBooted: false,
                        isTransition: false,
                        transitionFrom: null,
                        transitionDuration: 0,
                        transitionAllowInput: true,
                        //  Loader payload array
                        data: {},
                        pack: GetValue(config, 'pack', false),
                        //  Cameras
                        cameras: GetValue(config, 'cameras', null),
                        //  Scene Property Injection Map
                        map: GetValue(config, 'map', Merge(InjectionMap, GetValue(config, 'mapAdd', {}))),
                        //  Physics
                        physics: GetValue(config, 'physics', {}),
                        //  Loader
                        loader: GetValue(config, 'loader', {}),
                        //  Plugins
                        plugins: GetValue(config, 'plugins', false),
                        //  Input
                        input: GetValue(config, 'input', {})
                    };
                }
            };
            module1.exports = Settings;
        /***/ },
        /* 416 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var CanvasTexture = __webpack_require__(417);
            var Class = __webpack_require__(0);
            var Color = __webpack_require__(37);
            var CONST = __webpack_require__(32);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(103);
            var GameEvents = __webpack_require__(22);
            var GenerateTexture = __webpack_require__(382);
            var GetValue = __webpack_require__(6);
            var Parser = __webpack_require__(419);
            var Texture = __webpack_require__(203);
            /**
 * @callback EachTextureCallback
 *
 * @param {Phaser.Textures.Texture} texture - Each texture in Texture Manager.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 */ /**
 * @classdesc
 * Textures are managed by the global TextureManager. This is a singleton class that is
 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
 *
 * Sprites and other Game Objects get the texture data they need from the TextureManager.
 *
 * Access it via `scene.textures`.
 *
 * @class TextureManager
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - The Phaser.Game instance this Texture Manager belongs to.
 */ var TextureManager = new Class({
                Extends: EventEmitter,
                initialize: function TextureManager(game) {
                    EventEmitter.call(this);
                    /**
         * The Game that this TextureManager belongs to.
         *
         * @name Phaser.Textures.TextureManager#game
         * @type {Phaser.Game}
         * @since 3.0.0
         */ this.game = game;
                    /**
         * The name of this manager.
         *
         * @name Phaser.Textures.TextureManager#name
         * @type {string}
         * @since 3.0.0
         */ this.name = 'TextureManager';
                    /**
         * An object that has all of textures that Texture Manager creates.
         * Textures are assigned to keys so we can access to any texture that this object has directly by key value without iteration.
         *
         * @name Phaser.Textures.TextureManager#list
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.list = {};
                    /**
         * The temporary canvas element to save an pixel data of an arbitrary texture in getPixel() and getPixelAlpha() method.
         *
         * @name Phaser.Textures.TextureManager#_tempCanvas
         * @type {HTMLCanvasElement}
         * @private
         * @since 3.0.0
         */ this._tempCanvas = CanvasPool.create2D(this, 1, 1);
                    /**
         * The context of the temporary canvas element made to save an pixel data in getPixel() and getPixelAlpha() method.
         *
         * @name Phaser.Textures.TextureManager#_tempContext
         * @type {CanvasRenderingContext2D}
         * @private
         * @since 3.0.0
         */ this._tempContext = this._tempCanvas.getContext('2d');
                    /**
         * An counting value used for emitting 'ready' event after all of managers in game is loaded.
         *
         * @name Phaser.Textures.TextureManager#_pending
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pending = 0;
                    game.events.once(GameEvents.BOOT, this.boot, this);
                },
                /**
     * The Boot Handler called by Phaser.Game when it first starts up.
     *
     * @method Phaser.Textures.TextureManager#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    this.on(Events.LOAD, this.updatePending, this);
                    this.on(Events.ERROR, this.updatePending, this);
                    var config = this.game.config;
                    this.addBase64('__DEFAULT', config.defaultImage);
                    this.addBase64('__MISSING', config.missingImage);
                    this.addBase64('__WHITE', config.whiteImage);
                    this._pending = 3;
                    this.game.events.once(GameEvents.DESTROY, this.destroy, this);
                },
                /**
     * After 'onload' or 'onerror' invoked twice, emit 'ready' event.
     *
     * @method Phaser.Textures.TextureManager#updatePending
     * @private
     * @since 3.0.0
     */ updatePending: function() {
                    this._pending--;
                    if (this._pending === 0) {
                        this.off(Events.LOAD);
                        this.off(Events.ERROR);
                        this.emit(Events.READY);
                    }
                },
                /**
     * Checks the given texture key and throws a console.warn if the key is already in use, then returns false.
     * If you wish to avoid the console.warn then use `TextureManager.exists` instead.
     *
     * @method Phaser.Textures.TextureManager#checkKey
     * @since 3.7.0
     *
     * @param {string} key - The texture key to check.
     *
     * @return {boolean} `true` if it's safe to use the texture key, otherwise `false`.
     */ checkKey: function(key) {
                    if (this.exists(key)) {
                        // eslint-disable-next-line no-console
                        console.error('Texture key already in use: ' + key);
                        return false;
                    }
                    return true;
                },
                /**
     * Removes a Texture from the Texture Manager and destroys it. This will immediately
     * clear all references to it from the Texture Manager, and if it has one, destroy its
     * WebGLTexture. This will emit a `removetexture` event.
     *
     * Note: If you have any Game Objects still using this texture they will start throwing
     * errors the next time they try to render. Make sure that removing the texture is the final
     * step when clearing down to avoid this.
     *
     * @method Phaser.Textures.TextureManager#remove
     * @fires Phaser.Textures.Events#REMOVE
     * @since 3.7.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the Texture to remove, or a reference to it.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ remove: function(key) {
                    if (typeof key === 'string') {
                        if (this.exists(key)) key = this.get(key);
                        else {
                            console.warn('No texture found matching key: ' + key);
                            return this;
                        }
                    }
                    //  By this point key should be a Texture, if not, the following fails anyway
                    if (this.list.hasOwnProperty(key.key)) {
                        key.destroy();
                        this.emit(Events.REMOVE, key.key);
                    }
                    return this;
                },
                /**
     * Removes a key from the Texture Manager but does not destroy the Texture that was using the key.
     *
     * @method Phaser.Textures.TextureManager#removeKey
     * @since 3.17.0
     *
     * @param {string} key - The key to remove from the texture list.
     *
     * @return {Phaser.Textures.TextureManager} The Texture Manager.
     */ removeKey: function(key) {
                    if (this.list.hasOwnProperty(key)) delete this.list[key];
                    return this;
                },
                /**
     * Adds a new Texture to the Texture Manager created from the given Base64 encoded data.
     *
     * It works by creating an `Image` DOM object, then setting the `src` attribute to
     * the given base64 encoded data. As a result, the process is asynchronous by its nature,
     * so be sure to listen for the events this method dispatches before using the texture.
     *
     * @method Phaser.Textures.TextureManager#addBase64
     * @fires Phaser.Textures.Events#ADD
     * @fires Phaser.Textures.Events#ERROR
     * @fires Phaser.Textures.Events#LOAD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {*} data - The Base64 encoded data.
     *
     * @return {this} This Texture Manager instance.
     */ addBase64: function(key, data) {
                    if (this.checkKey(key)) {
                        var _this = this;
                        var image = new Image();
                        image.onerror = function() {
                            _this.emit(Events.ERROR, key);
                        };
                        image.onload = function() {
                            var texture = _this.create(key, image);
                            Parser.Image(texture, 0);
                            _this.emit(Events.ADD, key, texture);
                            _this.emit(Events.LOAD, key, texture);
                        };
                        image.src = data;
                    }
                    return this;
                },
                /**
     * Gets an existing texture frame and converts it into a base64 encoded image and returns the base64 data.
     *
     * You can also provide the image type and encoder options.
     *
     * This will only work with bitmap based texture frames, such as those created from Texture Atlases.
     * It will not work with GL Texture objects, such as Shaders, or Render Textures. For those please
     * see the WebGL Snapshot function instead.
     *
     * @method Phaser.Textures.TextureManager#getBase64
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {string} [type='image/png'] - A DOMString indicating the image format. The default format type is image/png.
     * @param {number} [encoderOptions=0.92] - A Number between 0 and 1 indicating the image quality to use for image formats that use lossy compression such as image/jpeg and image/webp. If this argument is anything else, the default value for image quality is used. The default value is 0.92. Other arguments are ignored.
     *
     * @return {string} The base64 encoded data, or an empty string if the texture frame could not be found.
     */ getBase64: function(key, frame, type, encoderOptions) {
                    if (type === undefined) type = 'image/png';
                    if (encoderOptions === undefined) encoderOptions = 0.92;
                    var data = '';
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame && (textureFrame.source.isRenderTexture || textureFrame.source.isGLTexture)) console.warn('Cannot getBase64 from WebGL Texture');
                    else if (textureFrame) {
                        var cd = textureFrame.canvasData;
                        var canvas = CanvasPool.create2D(this, cd.width, cd.height);
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(textureFrame.source.image, cd.x, cd.y, cd.width, cd.height, 0, 0, cd.width, cd.height);
                        data = canvas.toDataURL(type, encoderOptions);
                        CanvasPool.remove(canvas);
                    }
                    return data;
                },
                /**
     * Adds a new Texture to the Texture Manager created from the given Image element.
     *
     * @method Phaser.Textures.TextureManager#addImage
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {HTMLImageElement|HTMLCanvasElement} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addImage: function(key, source, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.Image(texture, 0);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Takes a WebGL Texture and creates a Phaser Texture from it, which is added to the Texture Manager using the given key.
     *
     * This allows you to then use the Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * If the `width` and `height` arguments are omitted, but the WebGL Texture was created by Phaser's WebGL Renderer
     * and has `glTexture.width` and `glTexture.height` properties, these values will be used instead.
     *
     * This is a WebGL only feature.
     *
     * @method Phaser.Textures.TextureManager#addGLTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.19.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {WebGLTexture} glTexture - The source Render Texture.
     * @param {number} [width] - The new width of the Texture. Read from `glTexture.width` if omitted.
     * @param {number} [height] - The new height of the Texture. Read from `glTexture.height` if omitted.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addGLTexture: function(key, glTexture, width, height) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        if (width === undefined) width = glTexture.width;
                        if (height === undefined) height = glTexture.height;
                        texture = this.create(key, glTexture, width, height);
                        texture.add('__BASE', 0, 0, 0, width, height);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Render Texture to the Texture Manager using the given key.
     * This allows you to then use the Render Texture as a normal texture for texture based Game Objects like Sprites.
     *
     * @method Phaser.Textures.TextureManager#addRenderTexture
     * @fires Phaser.Textures.Events#ADD
     * @since 3.12.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.GameObjects.RenderTexture} renderTexture - The source Render Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addRenderTexture: function(key, renderTexture) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, renderTexture);
                        texture.add('__BASE', 0, 0, 0, renderTexture.width, renderTexture.height);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Creates a new Texture using the given config values.
     *
     * Generated textures consist of a Canvas element to which the texture data is drawn.
     *
     * Generates a texture based on the given Create configuration object.
     *
     * The texture is drawn using a fixed-size indexed palette of 16 colors, where the hex value in the
     * data cells map to a single color. For example, if the texture config looked like this:
     *
     * ```javascript
     * var star = [
     *   '.....828.....',
     *   '....72227....',
     *   '....82228....',
     *   '...7222227...',
     *   '2222222222222',
     *   '8222222222228',
     *   '.72222222227.',
     *   '..787777787..',
     *   '..877777778..',
     *   '.78778887787.',
     *   '.27887.78872.',
     *   '.787.....787.'
     * ];
     *
     * this.textures.generate('star', { data: star, pixelWidth: 4 });
     * ```
     *
     * Then it would generate a texture that is 52 x 48 pixels in size, because each cell of the data array
     * represents 1 pixel multiplied by the `pixelWidth` value. The cell values, such as `8`, maps to color
     * number 8 in the palette. If a cell contains a period character `.` then it is transparent.
     *
     * The default palette is Arne16, but you can specify your own using the `palette` property.
     *
     * @method Phaser.Textures.TextureManager#generate
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Create.GenerateTextureConfig} config - The configuration object needed to generate the texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ generate: function(key, config) {
                    if (this.checkKey(key)) {
                        var canvas = CanvasPool.create(this, 1, 1);
                        config.canvas = canvas;
                        GenerateTexture(config);
                        return this.addCanvas(key, canvas);
                    } else return null;
                },
                /**
     * Creates a new Texture using a blank Canvas element of the size given.
     *
     * Canvas elements are automatically pooled and calling this method will
     * extract a free canvas from the CanvasPool, or create one if none are available.
     *
     * @method Phaser.Textures.TextureManager#createCanvas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {number} [width=256] - The width of the Canvas element.
     * @param {number} [height=256] - The height of the Canvas element.
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ createCanvas: function(key, width, height) {
                    if (width === undefined) width = 256;
                    if (height === undefined) height = 256;
                    if (this.checkKey(key)) {
                        var canvas = CanvasPool.create(this, width, height, CONST.CANVAS, true);
                        return this.addCanvas(key, canvas);
                    }
                    return null;
                },
                /**
     * Creates a new Canvas Texture object from an existing Canvas element
     * and adds it to this Texture Manager, unless `skipCache` is true.
     *
     * @method Phaser.Textures.TextureManager#addCanvas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLCanvasElement} source - The Canvas element to form the base of the new Texture.
     * @param {boolean} [skipCache=false] - Skip adding this Texture into the Cache?
     *
     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
     */ addCanvas: function(key, source, skipCache) {
                    if (skipCache === undefined) skipCache = false;
                    var texture = null;
                    if (skipCache) texture = new CanvasTexture(this, key, source, source.width, source.height);
                    else if (this.checkKey(key)) {
                        texture = new CanvasTexture(this, key, source, source.width, source.height);
                        this.list[key] = texture;
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a new Texture Atlas to this Texture Manager.
     * It can accept either JSON Array or JSON Hash formats, as exported by Texture Packer and similar software.
     *
     * @method Phaser.Textures.TextureManager#addAtlas
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlas: function(key, source, data, dataSource) {
                    //  New Texture Packer format?
                    if (Array.isArray(data.textures) || Array.isArray(data.frames)) return this.addAtlasJSONArray(key, source, data, dataSource);
                    else return this.addAtlasJSONHash(key, source, data, dataSource);
                },
                /**
     * Adds a Texture Atlas to this Texture Manager.
     * The frame data of the atlas must be stored in an Array within the JSON.
     * This is known as a JSON Array in software such as Texture Packer.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONArray
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(HTMLImageElement|HTMLImageElement[])} source - The source Image element/s.
     * @param {(object|object[])} data - The Texture Atlas data/s.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONArray: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        //  Multi-Atlas?
                        if (Array.isArray(data)) {
                            var singleAtlasFile = data.length === 1; // multi-pack with one atlas file for all images
                            //  !! Assumes the textures are in the same order in the source array as in the json data !!
                            for(var i = 0; i < texture.source.length; i++){
                                var atlasData = singleAtlasFile ? data[0] : data[i];
                                Parser.JSONArray(texture, i, atlasData);
                            }
                        } else Parser.JSONArray(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Texture Atlas to this Texture Manager.
     * The frame data of the atlas must be stored in an Object within the JSON.
     * This is known as a JSON Hash in software such as Texture Packer.
     *
     * @method Phaser.Textures.TextureManager#addAtlasJSONHash
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasJSONHash: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)Parser.JSONHash(texture, i, data[i]);
                        else Parser.JSONHash(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Texture Atlas to this Texture Manager, where the atlas data is given
     * in the XML format.
     *
     * @method Phaser.Textures.TextureManager#addAtlasXML
     * @fires Phaser.Textures.Events#ADD
     * @since 3.7.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas XML data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addAtlasXML: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.AtlasXML(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Unity Texture Atlas to this Texture Manager.
     * The data must be in the form of a Unity YAML file.
     *
     * @method Phaser.Textures.TextureManager#addUnityAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {object} data - The Texture Atlas data.
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLImageElement[]|HTMLCanvasElement[]} [dataSource] - An optional data Image element.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addUnityAtlas: function(key, source, data, dataSource) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        Parser.UnityYAML(texture, 0, data);
                        if (dataSource) texture.setDataSource(dataSource);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Sprite Sheet to this Texture Manager.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheet
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {Phaser.Types.Textures.SpriteSheetConfig} config - The configuration object for this Sprite Sheet.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addSpriteSheet: function(key, source, config) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = this.create(key, source);
                        var width = texture.source[0].width;
                        var height = texture.source[0].height;
                        Parser.SpriteSheet(texture, 0, 0, 0, width, height, config);
                        this.emit(Events.ADD, key, texture);
                    }
                    return texture;
                },
                /**
     * Adds a Sprite Sheet to this Texture Manager, where the Sprite Sheet exists as a Frame within a Texture Atlas.
     *
     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
     * same size and cannot be trimmed or rotated.
     *
     * @method Phaser.Textures.TextureManager#addSpriteSheetFromAtlas
     * @fires Phaser.Textures.Events#ADD
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {Phaser.Types.Textures.SpriteSheetFromAtlasConfig} config - The configuration object for this Sprite Sheet.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ addSpriteSheetFromAtlas: function(key, config) {
                    if (!this.checkKey(key)) return null;
                    var atlasKey = GetValue(config, 'atlas', null);
                    var atlasFrame = GetValue(config, 'frame', null);
                    if (!atlasKey || !atlasFrame) return;
                    var atlas = this.get(atlasKey);
                    var sheet = atlas.get(atlasFrame);
                    if (sheet) {
                        var texture = this.create(key, sheet.source.image);
                        if (sheet.trimmed) //  If trimmed we need to help the parser adjust
                        Parser.SpriteSheetFromAtlas(texture, sheet, config);
                        else Parser.SpriteSheet(texture, 0, sheet.cutX, sheet.cutY, sheet.cutWidth, sheet.cutHeight, config);
                        this.emit(Events.ADD, key, texture);
                        return texture;
                    }
                },
                /**
     * Creates a new Texture using the given source and dimensions.
     *
     * @method Phaser.Textures.TextureManager#create
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {HTMLImageElement} source - The source Image element.
     * @param {number} width - The width of the Texture.
     * @param {number} height - The height of the Texture.
     *
     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
     */ create: function(key, source, width, height) {
                    var texture = null;
                    if (this.checkKey(key)) {
                        texture = new Texture(this, key, source, width, height);
                        this.list[key] = texture;
                    }
                    return texture;
                },
                /**
     * Checks the given key to see if a Texture using it exists within this Texture Manager.
     *
     * @method Phaser.Textures.TextureManager#exists
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     *
     * @return {boolean} Returns `true` if a Texture matching the given key exists in this Texture Manager.
     */ exists: function(key) {
                    return this.list.hasOwnProperty(key);
                },
                /**
     * Returns a Texture from the Texture Manager that matches the given key.
     *
     * If the key is `undefined` it will return the `__DEFAULT` Texture.
     *
     * If the key is an instance of a Texture, it will return the key directly.
     *
     * Finally. if the key is given, but not found and not a Texture instance, it will return the `__MISSING` Texture.
     *
     * @method Phaser.Textures.TextureManager#get
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The unique string-based key of the Texture, or a Texture instance.
     *
     * @return {Phaser.Textures.Texture} The Texture that was created.
     */ get: function(key) {
                    if (key === undefined) key = '__DEFAULT';
                    if (this.list[key]) return this.list[key];
                    else if (key instanceof Texture) return key;
                    else return this.list['__MISSING'];
                },
                /**
     * Takes a Texture key and Frame name and returns a clone of that Frame if found.
     *
     * @method Phaser.Textures.TextureManager#cloneFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} frame - The string or index of the Frame to be cloned.
     *
     * @return {Phaser.Textures.Frame} A Clone of the given Frame.
     */ cloneFrame: function(key, frame) {
                    if (this.list[key]) return this.list[key].get(frame).clone();
                },
                /**
     * Takes a Texture key and Frame name and returns a reference to that Frame, if found.
     *
     * @method Phaser.Textures.TextureManager#getFrame
     * @since 3.0.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     *
     * @return {Phaser.Textures.Frame} A Texture Frame object.
     */ getFrame: function(key, frame) {
                    if (this.list[key]) return this.list[key].get(frame);
                },
                /**
     * Returns an array with all of the keys of all Textures in this Texture Manager.
     * The output array will exclude the `__DEFAULT` and `__MISSING` keys.
     *
     * @method Phaser.Textures.TextureManager#getTextureKeys
     * @since 3.0.0
     *
     * @return {string[]} An array containing all of the Texture keys stored in this Texture Manager.
     */ getTextureKeys: function() {
                    var output = [];
                    for(var key in this.list)if (key !== '__DEFAULT' && key !== '__MISSING') output.push(key);
                    return output;
                },
                /**
     * Given a Texture and an `x` and `y` coordinate this method will return a new
     * Color object that has been populated with the color and alpha values of the pixel
     * at that location in the Texture.
     *
     * @method Phaser.Textures.TextureManager#getPixel
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {?Phaser.Display.Color} A Color object populated with the color values of the requested pixel,
     * or `null` if the coordinates were out of bounds.
     */ getPixel: function(x, y, key, frame) {
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame) {
                        //  Adjust for trim (if not trimmed x and y are just zero)
                        x -= textureFrame.x;
                        y -= textureFrame.y;
                        var data = textureFrame.data.cut;
                        x += data.x;
                        y += data.y;
                        if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                            var ctx = this._tempContext;
                            ctx.clearRect(0, 0, 1, 1);
                            ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                            var rgb = ctx.getImageData(0, 0, 1, 1);
                            return new Color(rgb.data[0], rgb.data[1], rgb.data[2], rgb.data[3]);
                        }
                    }
                    return null;
                },
                /**
     * Given a Texture and an `x` and `y` coordinate this method will return a value between 0 and 255
     * corresponding to the alpha value of the pixel at that location in the Texture. If the coordinate
     * is out of bounds it will return null.
     *
     * @method Phaser.Textures.TextureManager#getPixelAlpha
     * @since 3.10.0
     *
     * @param {number} x - The x coordinate of the pixel within the Texture.
     * @param {number} y - The y coordinate of the pixel within the Texture.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {number} A value between 0 and 255, or `null` if the coordinates were out of bounds.
     */ getPixelAlpha: function(x, y, key, frame) {
                    var textureFrame = this.getFrame(key, frame);
                    if (textureFrame) {
                        //  Adjust for trim (if not trimmed x and y are just zero)
                        x -= textureFrame.x;
                        y -= textureFrame.y;
                        var data = textureFrame.data.cut;
                        x += data.x;
                        y += data.y;
                        if (x >= data.x && x < data.r && y >= data.y && y < data.b) {
                            var ctx = this._tempContext;
                            ctx.clearRect(0, 0, 1, 1);
                            ctx.drawImage(textureFrame.source.image, x, y, 1, 1, 0, 0, 1, 1);
                            var rgb = ctx.getImageData(0, 0, 1, 1);
                            return rgb.data[3];
                        }
                    }
                    return null;
                },
                /**
     * Sets the given Game Objects `texture` and `frame` properties so that it uses
     * the Texture and Frame specified in the `key` and `frame` arguments to this method.
     *
     * @method Phaser.Textures.TextureManager#setTexture
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the texture would be set on.
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string or index of the Frame.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object the texture was set on.
     */ setTexture: function(gameObject, key, frame) {
                    if (this.list[key]) {
                        gameObject.texture = this.list[key];
                        gameObject.frame = gameObject.texture.get(frame);
                    }
                    return gameObject;
                },
                /**
     * Changes the key being used by a Texture to the new key provided.
     *
     * The old key is removed, allowing it to be re-used.
     *
     * Game Objects are linked to Textures by a reference to the Texture object, so
     * all existing references will be retained.
     *
     * @method Phaser.Textures.TextureManager#renameTexture
     * @since 3.12.0
     *
     * @param {string} currentKey - The current string-based key of the Texture you wish to rename.
     * @param {string} newKey - The new unique string-based key to use for the Texture.
     *
     * @return {boolean} `true` if the Texture key was successfully renamed, otherwise `false`.
     */ renameTexture: function(currentKey, newKey) {
                    var texture = this.get(currentKey);
                    if (texture && currentKey !== newKey) {
                        texture.key = newKey;
                        this.list[newKey] = texture;
                        delete this.list[currentKey];
                        return true;
                    }
                    return false;
                },
                /**
     * Passes all Textures to the given callback.
     *
     * @method Phaser.Textures.TextureManager#each
     * @since 3.0.0
     *
     * @param {EachTextureCallback} callback - The callback function to be sent the Textures.
     * @param {object} scope - The value to use as `this` when executing the callback.
     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
     */ each: function(callback, scope) {
                    var args = [
                        null
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var texture in this.list){
                        args[0] = this.list[texture];
                        callback.apply(scope, args);
                    }
                },
                /**
     * Destroys the Texture Manager and all Textures stored within it.
     *
     * @method Phaser.Textures.TextureManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var texture in this.list)this.list[texture].destroy();
                    this.list = {};
                    this.game = null;
                    CanvasPool.remove(this._tempCanvas);
                }
            });
            module1.exports = TextureManager;
        /***/ },
        /* 417 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Clamp = __webpack_require__(18);
            var Color = __webpack_require__(37);
            var CONST = __webpack_require__(32);
            var IsSizePowerOfTwo = __webpack_require__(136);
            var Texture = __webpack_require__(203);
            /**
 * @classdesc
 * A Canvas Texture is a special kind of Texture that is backed by an HTML Canvas Element as its source.
 *
 * You can use the properties of this texture to draw to the canvas element directly, using all of the standard
 * canvas operations available in the browser. Any Game Object can be given this texture and will render with it.
 *
 * Note: When running under WebGL the Canvas Texture needs to re-generate its base WebGLTexture and reupload it to
 * the GPU every time you modify it, otherwise the changes you make to this texture will not be visible. To do this
 * you should call `CanvasTexture.refresh()` once you are finished with your changes to the canvas. Try and keep
 * this to a minimum, especially on large canvas sizes, or you may inadvertently thrash the GPU by constantly uploading
 * texture data to it. This restriction does not apply if using the Canvas Renderer.
 *
 * It starts with only one frame that covers the whole of the canvas. You can add further frames, that specify
 * sections of the canvas using the `add` method.
 *
 * Should you need to resize the canvas use the `setSize` method so that it accurately updates all of the underlying
 * texture data as well. Forgetting to do this (i.e. by changing the canvas size directly from your code) could cause
 * graphical errors.
 *
 * @class CanvasTexture
 * @extends Phaser.Textures.Texture
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
 * @param {string} key - The unique string-based key of this Texture.
 * @param {HTMLCanvasElement} source - The canvas element that is used as the base of this texture.
 * @param {number} width - The width of the canvas.
 * @param {number} height - The height of the canvas.
 */ var CanvasTexture = new Class({
                Extends: Texture,
                initialize: function CanvasTexture(manager, key, source, width, height) {
                    Texture.call(this, manager, key, source, width, height);
                    this.add('__BASE', 0, 0, 0, width, height);
                    /**
         * A reference to the Texture Source of this Canvas.
         *
         * @name Phaser.Textures.CanvasTexture#_source
         * @type {Phaser.Textures.TextureSource}
         * @private
         * @since 3.7.0
         */ this._source = this.frames['__BASE'].source;
                    /**
         * The source Canvas Element.
         *
         * @name Phaser.Textures.CanvasTexture#canvas
         * @readonly
         * @type {HTMLCanvasElement}
         * @since 3.7.0
         */ this.canvas = this._source.image;
                    /**
         * The 2D Canvas Rendering Context.
         *
         * @name Phaser.Textures.CanvasTexture#context
         * @readonly
         * @type {CanvasRenderingContext2D}
         * @since 3.7.0
         */ this.context = this.canvas.getContext('2d');
                    /**
         * The width of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#width
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.width = width;
                    /**
         * The height of the Canvas.
         * This property is read-only, if you wish to change it use the `setSize` method.
         *
         * @name Phaser.Textures.CanvasTexture#height
         * @readonly
         * @type {number}
         * @since 3.7.0
         */ this.height = height;
                    /**
         * The context image data.
         * Use the `update` method to populate this when the canvas changes.
         *
         * @name Phaser.Textures.CanvasTexture#imageData
         * @type {ImageData}
         * @since 3.13.0
         */ this.imageData = this.context.getImageData(0, 0, width, height);
                    /**
         * A Uint8ClampedArray view into the `buffer`.
         * Use the `update` method to populate this when the canvas changes.
         * Note that this is unavailable in some browsers, such as Epic Browser, due to their security restrictions.
         *
         * @name Phaser.Textures.CanvasTexture#data
         * @type {Uint8ClampedArray}
         * @since 3.13.0
         */ this.data = null;
                    if (this.imageData) this.data = this.imageData.data;
                    /**
         * An Uint32Array view into the `buffer`.
         *
         * @name Phaser.Textures.CanvasTexture#pixels
         * @type {Uint32Array}
         * @since 3.13.0
         */ this.pixels = null;
                    /**
         * An ArrayBuffer the same size as the context ImageData.
         *
         * @name Phaser.Textures.CanvasTexture#buffer
         * @type {ArrayBuffer}
         * @since 3.13.0
         */ this.buffer;
                    if (this.data) {
                        if (this.imageData.data.buffer) {
                            this.buffer = this.imageData.data.buffer;
                            this.pixels = new Uint32Array(this.buffer);
                        } else if (window.ArrayBuffer) {
                            this.buffer = new ArrayBuffer(this.imageData.data.length);
                            this.pixels = new Uint32Array(this.buffer);
                        } else this.pixels = this.imageData.data;
                    }
                },
                /**
     * This re-creates the `imageData` from the current context.
     * It then re-builds the ArrayBuffer, the `data` Uint8ClampedArray reference and the `pixels` Int32Array.
     *
     * Warning: This is a very expensive operation, so use it sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#update
     * @since 3.13.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ update: function() {
                    this.imageData = this.context.getImageData(0, 0, this.width, this.height);
                    this.data = this.imageData.data;
                    if (this.imageData.data.buffer) {
                        this.buffer = this.imageData.data.buffer;
                        this.pixels = new Uint32Array(this.buffer);
                    } else if (window.ArrayBuffer) {
                        this.buffer = new ArrayBuffer(this.imageData.data.length);
                        this.pixels = new Uint32Array(this.buffer);
                    } else this.pixels = this.imageData.data;
                    if (this.manager.game.config.renderType === CONST.WEBGL) this.refresh();
                    return this;
                },
                /**
     * Draws the given Image or Canvas element to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#draw
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate to draw the source at.
     * @param {number} y - The y coordinate to draw the source at.
     * @param {(HTMLImageElement|HTMLCanvasElement)} source - The element to draw to this canvas.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ draw: function(x, y, source) {
                    this.context.drawImage(source, x, y);
                    return this.update();
                },
                /**
     * Draws the given texture frame to this CanvasTexture, then updates the internal
     * ImageData buffer and arrays.
     *
     * @method Phaser.Textures.CanvasTexture#drawFrame
     * @since 3.16.0
     *
     * @param {string} key - The unique string-based key of the Texture.
     * @param {(string|number)} [frame] - The string-based name, or integer based index, of the Frame to get from the Texture.
     * @param {number} [x=0] - The x coordinate to draw the source at.
     * @param {number} [y=0] - The y coordinate to draw the source at.
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ drawFrame: function(key, frame, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    var textureFrame = this.manager.getFrame(key, frame);
                    if (textureFrame) {
                        var cd = textureFrame.canvasData;
                        var width = textureFrame.cutWidth;
                        var height = textureFrame.cutHeight;
                        var res = textureFrame.source.resolution;
                        this.context.drawImage(textureFrame.source.image, cd.x, cd.y, width, height, x, y, width / res, height / res);
                        return this.update();
                    } else return this;
                },
                /**
     * Sets a pixel in the CanvasTexture to the given color and alpha values.
     *
     * This is an expensive operation to run in large quantities, so use sparingly.
     *
     * @method Phaser.Textures.CanvasTexture#setPixel
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} red - The red color value. A number between 0 and 255.
     * @param {number} green - The green color value. A number between 0 and 255.
     * @param {number} blue - The blue color value. A number between 0 and 255.
     * @param {number} [alpha=255] - The alpha value. A number between 0 and 255.
     *
     * @return {this} This CanvasTexture.
     */ setPixel: function(x, y, red, green, blue, alpha) {
                    if (alpha === undefined) alpha = 255;
                    x = Math.abs(Math.floor(x));
                    y = Math.abs(Math.floor(y));
                    var index = this.getIndex(x, y);
                    if (index > -1) {
                        var imageData = this.context.getImageData(x, y, 1, 1);
                        imageData.data[0] = red;
                        imageData.data[1] = green;
                        imageData.data[2] = blue;
                        imageData.data[3] = alpha;
                        this.context.putImageData(imageData, x, y);
                    }
                    return this;
                },
                /**
     * Puts the ImageData into the context of this CanvasTexture at the given coordinates.
     *
     * @method Phaser.Textures.CanvasTexture#putData
     * @since 3.16.0
     *
     * @param {ImageData} imageData - The ImageData to put at the given location.
     * @param {number} x - The x coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate to put the imageData. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [dirtyX=0] - Horizontal position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyY=0] - Vertical position (x coordinate) of the top-left corner from which the image data will be extracted.
     * @param {number} [dirtyWidth] - Width of the rectangle to be painted. Defaults to the width of the image data.
     * @param {number} [dirtyHeight] - Height of the rectangle to be painted. Defaults to the height of the image data.
     *
     * @return {this} This CanvasTexture.
     */ putData: function(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight) {
                    if (dirtyX === undefined) dirtyX = 0;
                    if (dirtyY === undefined) dirtyY = 0;
                    if (dirtyWidth === undefined) dirtyWidth = imageData.width;
                    if (dirtyHeight === undefined) dirtyHeight = imageData.height;
                    this.context.putImageData(imageData, x, y, dirtyX, dirtyY, dirtyWidth, dirtyHeight);
                    return this;
                },
                /**
     * Gets an ImageData region from this CanvasTexture from the position and size specified.
     * You can write this back using `CanvasTexture.putData`, or manipulate it.
     *
     * @method Phaser.Textures.CanvasTexture#getData
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the top-left of the area to get the ImageData from. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} width - The width of the rectangle from which the ImageData will be extracted. Positive values are to the right, and negative to the left.
     * @param {number} height - The height of the rectangle from which the ImageData will be extracted. Positive values are down, and negative are up.
     *
     * @return {ImageData} The ImageData extracted from this CanvasTexture.
     */ getData: function(x, y, width, height) {
                    x = Clamp(Math.floor(x), 0, this.width - 1);
                    y = Clamp(Math.floor(y), 0, this.height - 1);
                    width = Clamp(width, 1, this.width - x);
                    height = Clamp(height, 1, this.height - y);
                    var imageData = this.context.getImageData(x, y, width, height);
                    return imageData;
                },
                /**
     * Get the color of a specific pixel from this texture and store it in a Color object.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixel
     * @since 3.13.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {Phaser.Display.Color} [out] - A Color object to store the pixel values in. If not provided a new Color object will be created.
     *
     * @return {Phaser.Display.Color} An object with the red, green, blue and alpha values set in the r, g, b and a properties.
     */ getPixel: function(x, y, out) {
                    if (!out) out = new Color();
                    var index = this.getIndex(x, y);
                    if (index > -1) {
                        var data = this.data;
                        var r = data[index + 0];
                        var g = data[index + 1];
                        var b = data[index + 2];
                        var a = data[index + 3];
                        out.setTo(r, g, b, a);
                    }
                    return out;
                },
                /**
     * Returns an array containing all of the pixels in the given region.
     *
     * If the requested region extends outside the bounds of this CanvasTexture,
     * the region is truncated to fit.
     *
     * If you have drawn anything to this CanvasTexture since it was created you must call `CanvasTexture.update` to refresh the array buffer,
     * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
     *
     * @method Phaser.Textures.CanvasTexture#getPixels
     * @since 3.16.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [y=0] - The y coordinate of the top-left of the region. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} [width] - The width of the region to get. Must be an integer. Defaults to the canvas width if not given.
     * @param {number} [height] - The height of the region to get. Must be an integer. If not given will be set to the `width`.
     *
     * @return {Phaser.Types.Textures.PixelConfig[][]} A 2d array of Pixel objects.
     */ getPixels: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = width;
                    x = Math.abs(Math.round(x));
                    y = Math.abs(Math.round(y));
                    var left = Clamp(x, 0, this.width);
                    var right = Clamp(x + width, 0, this.width);
                    var top = Clamp(y, 0, this.height);
                    var bottom = Clamp(y + height, 0, this.height);
                    var pixel = new Color();
                    var out = [];
                    for(var py = top; py < bottom; py++){
                        var row = [];
                        for(var px = left; px < right; px++){
                            pixel = this.getPixel(px, py, pixel);
                            row.push({
                                x: px,
                                y: py,
                                color: pixel.color,
                                alpha: pixel.alphaGL
                            });
                        }
                        out.push(row);
                    }
                    return out;
                },
                /**
     * Returns the Image Data index for the given pixel in this CanvasTexture.
     *
     * The index can be used to read directly from the `this.data` array.
     *
     * The index points to the red value in the array. The subsequent 3 indexes
     * point to green, blue and alpha respectively.
     *
     * @method Phaser.Textures.CanvasTexture#getIndex
     * @since 3.16.0
     *
     * @param {number} x - The x coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     * @param {number} y - The y coordinate of the pixel to get. Must lay within the dimensions of this CanvasTexture and be an integer.
     *
     * @return {number}
     */ getIndex: function(x, y) {
                    x = Math.abs(Math.round(x));
                    y = Math.abs(Math.round(y));
                    if (x < this.width && y < this.height) return (x + y * this.width) * 4;
                    else return -1;
                },
                /**
     * This should be called manually if you are running under WebGL.
     * It will refresh the WebGLTexture from the Canvas source. Only call this if you know that the
     * canvas has changed, as there is a significant GPU texture allocation cost involved in doing so.
     *
     * @method Phaser.Textures.CanvasTexture#refresh
     * @since 3.7.0
     *
     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
     */ refresh: function() {
                    this._source.update();
                    return this;
                },
                /**
     * Gets the Canvas Element.
     *
     * @method Phaser.Textures.CanvasTexture#getCanvas
     * @since 3.7.0
     *
     * @return {HTMLCanvasElement} The Canvas DOM element this texture is using.
     */ getCanvas: function() {
                    return this.canvas;
                },
                /**
     * Gets the 2D Canvas Rendering Context.
     *
     * @method Phaser.Textures.CanvasTexture#getContext
     * @since 3.7.0
     *
     * @return {CanvasRenderingContext2D} The Canvas Rendering Context this texture is using.
     */ getContext: function() {
                    return this.context;
                },
                /**
     * Clears the given region of this Canvas Texture, resetting it back to transparent.
     * If no region is given, the whole Canvas Texture is cleared.
     *
     * @method Phaser.Textures.CanvasTexture#clear
     * @since 3.7.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left of the region to clear.
     * @param {number} [y=0] - The y coordinate of the top-left of the region to clear.
     * @param {number} [width] - The width of the region.
     * @param {number} [height] - The height of the region.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ clear: function(x, y, width, height) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    this.context.clearRect(x, y, width, height);
                    return this.update();
                },
                /**
     * Changes the size of this Canvas Texture.
     *
     * @method Phaser.Textures.CanvasTexture#setSize
     * @since 3.7.0
     *
     * @param {number} width - The new width of the Canvas.
     * @param {number} [height] - The new height of the Canvas. If not given it will use the width as the height.
     *
     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
     */ setSize: function(width, height) {
                    if (height === undefined) height = width;
                    if (width !== this.width || height !== this.height) {
                        //  Update the Canvas
                        this.canvas.width = width;
                        this.canvas.height = height;
                        //  Update the Texture Source
                        this._source.width = width;
                        this._source.height = height;
                        this._source.isPowerOf2 = IsSizePowerOfTwo(width, height);
                        //  Update the Frame
                        this.frames['__BASE'].setSize(width, height, 0, 0);
                        //  Update this
                        this.width = width;
                        this.height = height;
                        this.refresh();
                    }
                    return this;
                },
                /**
     * Destroys this Texture and releases references to its sources and frames.
     *
     * @method Phaser.Textures.CanvasTexture#destroy
     * @since 3.16.0
     */ destroy: function() {
                    Texture.prototype.destroy.call(this);
                    this._source = null;
                    this.canvas = null;
                    this.context = null;
                    this.imageData = null;
                    this.data = null;
                    this.pixels = null;
                    this.buffer = null;
                }
            });
            module1.exports = CanvasTexture;
        /***/ },
        /* 418 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var IsSizePowerOfTwo = __webpack_require__(136);
            var ScaleModes = __webpack_require__(164);
            /**
 * @classdesc
 * A Texture Source is the encapsulation of the actual source data for a Texture.
 *
 * This is typically an Image Element, loaded from the file system or network, a Canvas Element or a Video Element.
 *
 * A Texture can contain multiple Texture Sources, which only happens when a multi-atlas is loaded.
 *
 * @class TextureSource
 * @memberof Phaser.Textures
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture this TextureSource belongs to.
 * @param {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|WebGLTexture)} source - The source image data.
 * @param {number} [width] - Optional width of the source image. If not given it's derived from the source itself.
 * @param {number} [height] - Optional height of the source image. If not given it's derived from the source itself.
 * @param {boolean} [flipY=false] - Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
 */ var TextureSource = new Class({
                initialize: function TextureSource(texture, source, width, height, flipY) {
                    if (flipY === undefined) flipY = false;
                    var game = texture.manager.game;
                    /**
         * The Texture this TextureSource belongs to.
         *
         * @name Phaser.Textures.TextureSource#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.7.0
         */ this.renderer = game.renderer;
                    /**
         * The Texture this TextureSource belongs to.
         *
         * @name Phaser.Textures.TextureSource#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = texture;
                    /**
         * The source of the image data.
         *
         * This is either an Image Element, a Canvas Element, a Video Element, a RenderTexture or a WebGLTexture.
         *
         * @name Phaser.Textures.TextureSource#source
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|Phaser.GameObjects.RenderTexture|WebGLTexture)}
         * @since 3.12.0
         */ this.source = source;
                    /**
         * The image data.
         *
         * This is either an Image element, Canvas element or a Video Element.
         *
         * @name Phaser.Textures.TextureSource#image
         * @type {(HTMLImageElement|HTMLCanvasElement|HTMLVideoElement)}
         * @since 3.0.0
         */ this.image = source;
                    /**
         * Currently un-used.
         *
         * @name Phaser.Textures.TextureSource#compressionAlgorithm
         * @type {number}
         * @default null
         * @since 3.0.0
         */ this.compressionAlgorithm = null;
                    /**
         * The resolution of the source image.
         *
         * @name Phaser.Textures.TextureSource#resolution
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.resolution = 1;
                    /**
         * The width of the source image. If not specified in the constructor it will check
         * the `naturalWidth` and then `width` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width || source.naturalWidth || source.videoWidth || source.width || 0;
                    /**
         * The height of the source image. If not specified in the constructor it will check
         * the `naturalHeight` and then `height` properties of the source image.
         *
         * @name Phaser.Textures.TextureSource#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height || source.naturalHeight || source.videoHeight || source.height || 0;
                    /**
         * The Scale Mode the image will use when rendering.
         * Either Linear or Nearest.
         *
         * @name Phaser.Textures.TextureSource#scaleMode
         * @type {number}
         * @since 3.0.0
         */ this.scaleMode = ScaleModes.DEFAULT;
                    /**
         * Is the source image a Canvas Element?
         *
         * @name Phaser.Textures.TextureSource#isCanvas
         * @type {boolean}
         * @since 3.0.0
         */ this.isCanvas = source instanceof HTMLCanvasElement;
                    /**
         * Is the source image a Video Element?
         *
         * @name Phaser.Textures.TextureSource#isVideo
         * @type {boolean}
         * @since 3.20.0
         */ this.isVideo = window.hasOwnProperty('HTMLVideoElement') && source instanceof HTMLVideoElement;
                    /**
         * Is the source image a Render Texture?
         *
         * @name Phaser.Textures.TextureSource#isRenderTexture
         * @type {boolean}
         * @since 3.12.0
         */ this.isRenderTexture = source.type === 'RenderTexture';
                    /**
         * Is the source image a WebGLTexture?
         *
         * @name Phaser.Textures.TextureSource#isGLTexture
         * @type {boolean}
         * @since 3.19.0
         */ this.isGLTexture = window.hasOwnProperty('WebGLTexture') && source instanceof WebGLTexture;
                    /**
         * Are the source image dimensions a power of two?
         *
         * @name Phaser.Textures.TextureSource#isPowerOf2
         * @type {boolean}
         * @since 3.0.0
         */ this.isPowerOf2 = IsSizePowerOfTwo(this.width, this.height);
                    /**
         * The WebGL Texture of the source image. If this TextureSource is driven from a WebGLTexture
         * already, then this is a reference to that WebGLTexture.
         *
         * @name Phaser.Textures.TextureSource#glTexture
         * @type {?WebGLTexture}
         * @default null
         * @since 3.0.0
         */ this.glTexture = null;
                    /**
         * The current texture unit index as assigned by the WebGL Renderer.
         * Un-used in canvas. Should be treated as read-only.
         *
         * @name Phaser.Textures.TextureSource#glIndex
         * @type {number}
         * @default 0
         * @since 3.50.0
         */ this.glIndex = 0;
                    /**
         * The counter value when this texture was last assigned an index by the WebGL Renderer.
         * Un-used in canvas. Should be treated as read-only.
         *
         * @name Phaser.Textures.TextureSource#glIndexCounter
         * @type {number}
         * @default -1
         * @since 3.50.0
         */ this.glIndexCounter = -1;
                    /**
         * Sets the `UNPACK_FLIP_Y_WEBGL` flag the WebGL Texture uses during upload.
         *
         * @name Phaser.Textures.TextureSource#flipY
         * @type {boolean}
         * @since 3.20.0
         */ this.flipY = flipY;
                    this.init(game);
                },
                /**
     * Creates a WebGL Texture, if required, and sets the Texture filter mode.
     *
     * @method Phaser.Textures.TextureSource#init
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
     */ init: function(game) {
                    var renderer = this.renderer;
                    if (renderer) {
                        if (renderer.gl) {
                            if (this.isCanvas) this.glTexture = renderer.createCanvasTexture(this.image, false, this.flipY);
                            else if (this.isVideo) this.glTexture = renderer.createVideoTexture(this.image, false, this.flipY);
                            else if (this.isRenderTexture) {
                                this.image = this.source.canvas;
                                this.glTexture = renderer.createTextureFromSource(null, this.width, this.height, this.scaleMode);
                            } else if (this.isGLTexture) this.glTexture = this.source;
                            else this.glTexture = renderer.createTextureFromSource(this.image, this.width, this.height, this.scaleMode);
                        } else if (this.isRenderTexture) this.image = this.source.canvas;
                    }
                    if (!game.config.antialias) this.setFilter(1);
                },
                /**
     * Sets the Filter Mode for this Texture.
     *
     * The mode can be either Linear, the default, or Nearest.
     *
     * For pixel-art you should use Nearest.
     *
     * @method Phaser.Textures.TextureSource#setFilter
     * @since 3.0.0
     *
     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
     */ setFilter: function(filterMode) {
                    if (this.renderer.gl) this.renderer.setTextureFilter(this.glTexture, filterMode);
                    this.scaleMode = filterMode;
                },
                /**
     * Sets the `UNPACK_FLIP_Y_WEBGL` flag for the WebGL Texture during texture upload.
     *
     * @method Phaser.Textures.TextureSource#setFlipY
     * @since 3.20.0
     *
     * @param {boolean} [value=true] - Should the WebGL Texture be flipped on the Y axis on texture upload or not?
     */ setFlipY: function(value) {
                    if (value === undefined) value = true;
                    this.flipY = value;
                    return this;
                },
                /**
     * If this TextureSource is backed by a Canvas and is running under WebGL,
     * it updates the WebGLTexture using the canvas data.
     *
     * @method Phaser.Textures.TextureSource#update
     * @since 3.7.0
     */ update: function() {
                    var gl = this.renderer.gl;
                    if (gl && this.isCanvas) this.glTexture = this.renderer.updateCanvasTexture(this.image, this.glTexture, this.flipY);
                    else if (gl && this.isVideo) this.glTexture = this.renderer.updateVideoTexture(this.image, this.glTexture, this.flipY);
                },
                /**
     * Destroys this Texture Source and nulls the references.
     *
     * @method Phaser.Textures.TextureSource#destroy
     * @since 3.0.0
     */ destroy: function() {
                    if (this.glTexture) this.renderer.deleteTexture(this.glTexture, false);
                    if (this.isCanvas) CanvasPool.remove(this.image);
                    this.renderer = null;
                    this.texture = null;
                    this.source = null;
                    this.image = null;
                    this.glTexture = null;
                }
            });
            module1.exports = TextureSource;
        /***/ },
        /* 419 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Textures.Parsers
 */ module1.exports = {
                AtlasXML: __webpack_require__(975),
                Canvas: __webpack_require__(976),
                Image: __webpack_require__(977),
                JSONArray: __webpack_require__(978),
                JSONHash: __webpack_require__(979),
                SpriteSheet: __webpack_require__(980),
                SpriteSheetFromAtlas: __webpack_require__(981),
                UnityYAML: __webpack_require__(982)
            };
        /***/ },
        /* 420 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HTML5AudioSoundManager = __webpack_require__(421);
            var NoAudioSoundManager = __webpack_require__(424);
            var WebAudioSoundManager = __webpack_require__(426);
            /**
 * Creates a Web Audio, HTML5 Audio or No Audio Sound Manager based on config and device settings.
 *
 * Be aware of https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
 *
 * @function Phaser.Sound.SoundManagerCreator
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 *
 * @return {(Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager|Phaser.Sound.NoAudioSoundManager)} The Sound Manager instance that was created.
 */ var SoundManagerCreator = {
                create: function(game) {
                    var audioConfig = game.config.audio;
                    var deviceAudio = game.device.audio;
                    if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) return new NoAudioSoundManager(game);
                    if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new WebAudioSoundManager(game);
                    return new HTML5AudioSoundManager(game);
                }
            };
            module1.exports = SoundManagerCreator;
        /***/ },
        /* 421 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(144);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(69);
            var HTML5AudioSound = __webpack_require__(423);
            /**
 * HTML5 Audio implementation of the Sound Manager.
 *
 * To play multiple instances of the same HTML5 Audio sound, you need to provide an `instances` value when
 * loading the sound with the Loader:
 *
 * ```javascript
 * this.load.audio('explosion', 'explosion.mp3', {
 *     instances: 2
 * });
 * ```
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class HTML5AudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var HTML5AudioSoundManager = new Class({
                Extends: BaseSoundManager,
                initialize: function HTML5AudioSoundManager(game) {
                    /**
         * Flag indicating whether if there are no idle instances of HTML5 Audio tag,
         * for any particular sound, if one of the used tags should be hijacked and used
         * for succeeding playback or if succeeding Phaser.Sound.HTML5AudioSound#play
         * call should be ignored.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#override
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.override = true;
                    /**
         * Value representing time difference, in seconds, between calling
         * play method on an audio tag and when it actually starts playing.
         * It is used to achieve more accurate delayed sound playback.
         *
         * You might need to tweak this value to get the desired results
         * since audio play delay varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#audioPlayDelay
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.audioPlayDelay = 0.1;
                    /**
         * A value by which we should offset the loop end marker of the
         * looping sound to compensate for lag, caused by changing audio
         * tag playback position, in order to achieve gapless looping.
         *
         * You might need to tweak this value to get the desired results
         * since loop lag varies depending on the browser/platform.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#loopEndOffset
         * @type {number}
         * @default 0.05
         * @since 3.0.0
         */ this.loopEndOffset = 0.05;
                    /**
         * An array for keeping track of all the sounds
         * that were paused when game lost focus.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#onBlurPausedSounds
         * @type {Phaser.Sound.HTML5AudioSound[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this.onBlurPausedSounds = [];
                    this.locked = 'ontouchstart' in window;
                    /**
         * A queue of all actions performed on sound objects while audio was locked.
         * Once the audio gets unlocked, after an explicit user interaction,
         * all actions will be performed in chronological order.
         * Array of object types: { sound: Phaser.Sound.HTML5AudioSound, name: string, value?: * }
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#lockedActionsQueue
         * @type {array}
         * @private
         * @since 3.0.0
         */ this.lockedActionsQueue = this.locked ? [] : null;
                    /**
         * Property that actually holds the value of global mute
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_mute
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._mute = false;
                    /**
         * Property that actually holds the value of global volume
         * for HTML5 Audio sound manager implementation.
         *
         * @name Phaser.Sound.HTML5AudioSoundManager#_volume
         * @type {boolean}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._volume = 1;
                    BaseSoundManager.call(this, game);
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.HTML5AudioSound} The new sound instance.
     */ add: function(key, config) {
                    var sound = new HTML5AudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                /**
     * Unlocks HTML5 Audio loading and playback on mobile
     * devices on the initial explicit user interaction.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                    this.locked = false;
                    var _this = this;
                    this.game.cache.audio.entries.each(function(key, tags) {
                        for(var i = 0; i < tags.length; i++)if (tags[i].dataset.locked === 'true') {
                            _this.locked = true;
                            return false;
                        }
                        return true;
                    });
                    if (!this.locked) return;
                    var moved = false;
                    var detectMove = function() {
                        moved = true;
                    };
                    var unlock = function() {
                        if (moved) {
                            moved = false;
                            return;
                        }
                        document.body.removeEventListener('touchmove', detectMove);
                        document.body.removeEventListener('touchend', unlock);
                        var lockedTags = [];
                        _this.game.cache.audio.entries.each(function(key, tags) {
                            for(var i = 0; i < tags.length; i++){
                                var tag = tags[i];
                                if (tag.dataset.locked === 'true') lockedTags.push(tag);
                            }
                            return true;
                        });
                        if (lockedTags.length === 0) return;
                        var lastTag = lockedTags[lockedTags.length - 1];
                        lastTag.oncanplaythrough = function() {
                            lastTag.oncanplaythrough = null;
                            lockedTags.forEach(function(tag) {
                                tag.dataset.locked = 'false';
                            });
                            _this.unlocked = true;
                        };
                        lockedTags.forEach(function(tag) {
                            tag.load();
                        });
                    };
                    this.once(Events.UNLOCKED, function() {
                        this.forEachActiveSound(function(sound) {
                            if (sound.currentMarker === null && sound.duration === 0) sound.duration = sound.tags[0].duration;
                            sound.totalDuration = sound.tags[0].duration;
                        });
                        while(this.lockedActionsQueue.length){
                            var lockedAction = this.lockedActionsQueue.shift();
                            if (lockedAction.sound[lockedAction.prop].apply) lockedAction.sound[lockedAction.prop].apply(lockedAction.sound, lockedAction.value || []);
                            else lockedAction.sound[lockedAction.prop] = lockedAction.value;
                        }
                    }, this);
                    document.body.addEventListener('touchmove', detectMove, false);
                    document.body.addEventListener('touchend', unlock, false);
                },
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    this.forEachActiveSound(function(sound) {
                        if (sound.isPlaying) {
                            this.onBlurPausedSounds.push(sound);
                            sound.onBlur();
                        }
                    });
                },
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    this.onBlurPausedSounds.forEach(function(sound) {
                        sound.onFocus();
                    });
                    this.onBlurPausedSounds.length = 0;
                },
                /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSoundManager.prototype.destroy.call(this);
                    this.onBlurPausedSounds.length = 0;
                    this.onBlurPausedSounds = null;
                },
                /**
     * Method used internally by Phaser.Sound.HTML5AudioSound class methods and property setters
     * to check if sound manager is locked and then either perform action immediately or queue it
     * to be performed once the sound manager gets unlocked.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#isLocked
     * @protected
     * @since 3.0.0
     *
     * @param {Phaser.Sound.HTML5AudioSound} sound - Sound object on which to perform queued action.
     * @param {string} prop - Name of the method to be called or property to be assigned a value to.
     * @param {*} [value] - An optional parameter that either holds an array of arguments to be passed to the method call or value to be set to the property.
     *
     * @return {boolean} Whether the sound manager is locked.
     */ isLocked: function(sound, prop, value) {
                    if (sound.tags[0].dataset.locked === 'true') {
                        this.lockedActionsQueue.push({
                            sound: sound,
                            prop: prop,
                            value: value
                        });
                        return true;
                    }
                    return false;
                },
                /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.HTML5AudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this._mute;
                    },
                    set: function(value) {
                        this._mute = value;
                        this.forEachActiveSound(function(sound) {
                            sound.updateMute();
                        });
                        this.emit(Events.GLOBAL_MUTE, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.HTML5AudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        this.forEachActiveSound(function(sound) {
                            sound.updateVolume();
                        });
                        this.emit(Events.GLOBAL_VOLUME, this, value);
                    }
                }
            });
            module1.exports = HTML5AudioSoundManager;
        /***/ },
        /* 422 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns the first element in the array.
 *
 * You can optionally specify a matching criteria using the `property` and `value` arguments.
 *
 * For example: `getAll('visible', true)` would return the first element that had its `visible` property set.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would search only the first 50 elements.
 *
 * @function Phaser.Utils.Array.GetFirst
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} [property] - The property to test on each array element.
 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex=0] - An optional start index to search from.
 * @param {number} [endIndex=array.length] - An optional end index to search up to (but not included)
 *
 * @return {object} The first matching element from the array, or `null` if no element could be found in the range given.
 */ var GetFirst = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (!property || property && value === undefined && child.hasOwnProperty(property) || property && value !== undefined && child[property] === value) return child;
                }
                return null;
            };
            module1.exports = GetFirst;
        /***/ },
        /* 423 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(69);
            var Clamp = __webpack_require__(18);
            /**
 * @classdesc
 * HTML5 Audio implementation of the sound.
 *
 * @class HTML5AudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.HTML5AudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var HTML5AudioSound = new Class({
                Extends: BaseSound,
                initialize: function HTML5AudioSound(manager, key, config) {
                    if (config === undefined) config = {};
                    /**
         * An array containing all HTML5 Audio tags that could be used for individual
         * sound's playback. Number of instances depends on the config value passed
         * to the Loader#audio method call, default is 1.
         *
         * @name Phaser.Sound.HTML5AudioSound#tags
         * @type {HTMLAudioElement[]}
         * @private
         * @since 3.0.0
         */ this.tags = manager.game.cache.audio.get(key);
                    if (!this.tags) throw new Error('There is no audio asset with key "' + key + '" in the audio cache');
                    /**
         * Reference to an HTML5 Audio tag used for playing sound.
         *
         * @name Phaser.Sound.HTML5AudioSound#audio
         * @type {HTMLAudioElement}
         * @private
         * @default null
         * @since 3.0.0
         */ this.audio = null;
                    /**
         * Timestamp as generated by the Request Animation Frame or SetTimeout
         * representing the time at which the delayed sound playback should start.
         * Set to 0 if sound playback is not delayed.
         *
         * @name Phaser.Sound.HTML5AudioSound#startTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * Audio tag's playback position recorded on previous
         * update method call. Set to 0 if sound is not playing.
         *
         * @name Phaser.Sound.HTML5AudioSound#previousTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.previousTime = 0;
                    this.duration = this.tags[0].duration;
                    this.totalDuration = this.tags[0].duration;
                    BaseSound.call(this, manager, key, config);
                },
                /**
     * Play this sound, or a marked section of it.
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.HTML5AudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (this.manager.isLocked(this, 'play', [
                        markerName,
                        config
                    ])) return false;
                    if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    if (!this.pickAndPlayAudioTag()) return false;
                    this.emit(Events.PLAY, this);
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.manager.isLocked(this, 'pause')) return false;
                    if (this.startTime > 0) return false;
                    if (!BaseSound.prototype.pause.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                    this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                    this.stopAndReleaseAudioTag();
                    this.emit(Events.PAUSE, this);
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (this.manager.isLocked(this, 'resume')) return false;
                    if (this.startTime > 0) return false;
                    if (!BaseSound.prototype.resume.call(this)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    if (!this.pickAndPlayAudioTag()) return false;
                    this.emit(Events.RESUME, this);
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (this.manager.isLocked(this, 'stop')) return false;
                    if (!BaseSound.prototype.stop.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                    this.stopAndReleaseAudioTag();
                    this.emit(Events.STOP, this);
                    return true;
                },
                /**
     * Used internally to do what the name says.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAndPlayAudioTag
     * @private
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAndPlayAudioTag: function() {
                    if (!this.pickAudioTag()) {
                        this.reset();
                        return false;
                    }
                    var seek = this.currentConfig.seek;
                    var delay = this.currentConfig.delay;
                    var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                    this.previousTime = offset;
                    this.audio.currentTime = offset;
                    this.applyConfig();
                    if (delay === 0) {
                        this.startTime = 0;
                        if (this.audio.paused) this.playCatchPromise();
                    } else {
                        this.startTime = window.performance.now() + delay * 1000;
                        if (!this.audio.paused) this.audio.pause();
                    }
                    this.resetConfig();
                    return true;
                },
                /**
     * This method performs the audio tag pooling logic. It first looks for
     * unused audio tag to assign to this sound object. If there are no unused
     * audio tags, based on HTML5AudioSoundManager#override property value, it
     * looks for sound with most advanced playback and hijacks its audio tag or
     * does nothing.
     *
     * @method Phaser.Sound.HTML5AudioSound#pickAudioTag
     * @private
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was assigned an audio tag successfully.
     */ pickAudioTag: function() {
                    if (this.audio) return true;
                    for(var i = 0; i < this.tags.length; i++){
                        var audio = this.tags[i];
                        if (audio.dataset.used === 'false') {
                            audio.dataset.used = 'true';
                            this.audio = audio;
                            return true;
                        }
                    }
                    if (!this.manager.override) return false;
                    var otherSounds = [];
                    this.manager.forEachActiveSound(function(sound) {
                        if (sound.key === this.key && sound.audio) otherSounds.push(sound);
                    }, this);
                    otherSounds.sort(function(a1, a2) {
                        if (a1.loop === a2.loop) // sort by progress
                        return a2.seek / a2.duration - a1.seek / a1.duration;
                        return a1.loop ? 1 : -1;
                    });
                    var selectedSound = otherSounds[0];
                    this.audio = selectedSound.audio;
                    selectedSound.reset();
                    selectedSound.audio = null;
                    selectedSound.startTime = 0;
                    selectedSound.previousTime = 0;
                    return true;
                },
                /**
     * Method used for playing audio tag and catching possible exceptions
     * thrown from rejected Promise returned from play method call.
     *
     * @method Phaser.Sound.HTML5AudioSound#playCatchPromise
     * @private
     * @since 3.0.0
     */ playCatchPromise: function() {
                    var playPromise = this.audio.play();
                    if (playPromise) // eslint-disable-next-line no-unused-vars
                    playPromise.catch(function(reason) {
                        console.warn(reason);
                    });
                },
                /**
     * Used internally to do what the name says.
     *
     * @method Phaser.Sound.HTML5AudioSound#stopAndReleaseAudioTag
     * @private
     * @since 3.0.0
     */ stopAndReleaseAudioTag: function() {
                    this.startTime = 0;
                    this.previousTime = 0;
                    if (this.audio) {
                        this.audio.pause();
                        this.audio.dataset.used = 'false';
                        this.audio = null;
                    }
                },
                /**
     * Method used internally to reset sound state, usually when stopping sound
     * or when hijacking audio tag from another sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#reset
     * @private
     * @since 3.0.0
     */ reset: function() {
                    BaseSound.prototype.stop.call(this);
                },
                /**
     * Method used internally by sound manager for pausing sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
     * @private
     * @since 3.0.0
     */ onBlur: function() {
                    this.isPlaying = false;
                    this.isPaused = true;
                    this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                    this.currentConfig.delay = Math.max(0, (this.startTime - window.performance.now()) / 1000);
                    this.stopAndReleaseAudioTag();
                },
                /**
     * Method used internally by sound manager for resuming sound if
     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.HTML5AudioSound#onFocus
     * @private
     * @since 3.0.0
     */ onFocus: function() {
                    this.isPlaying = true;
                    this.isPaused = false;
                    this.pickAndPlayAudioTag();
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.HTML5AudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     */ update: function(time) {
                    if (!this.isPlaying) return;
                    // handling delayed playback
                    if (this.startTime > 0) {
                        if (this.startTime < time - this.manager.audioPlayDelay) {
                            this.audio.currentTime += Math.max(0, time - this.startTime) / 1000;
                            this.startTime = 0;
                            this.previousTime = this.audio.currentTime;
                            this.playCatchPromise();
                        }
                        return;
                    }
                    // handle looping and ending
                    var startTime = this.currentMarker ? this.currentMarker.start : 0;
                    var endTime = startTime + this.duration;
                    var currentTime = this.audio.currentTime;
                    if (this.currentConfig.loop) {
                        if (currentTime >= endTime - this.manager.loopEndOffset) {
                            this.audio.currentTime = startTime + Math.max(0, currentTime - endTime);
                            currentTime = this.audio.currentTime;
                        } else if (currentTime < startTime) {
                            this.audio.currentTime += startTime;
                            currentTime = this.audio.currentTime;
                        }
                        if (currentTime < this.previousTime) this.emit(Events.LOOPED, this);
                    } else if (currentTime >= endTime) {
                        this.reset();
                        this.stopAndReleaseAudioTag();
                        this.emit(Events.COMPLETE, this);
                        return;
                    }
                    this.previousTime = currentTime;
                },
                /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all HTML5 Audio related stuff.
     *
     * @method Phaser.Sound.HTML5AudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                    this.tags = null;
                    if (this.audio) this.stopAndReleaseAudioTag();
                },
                /**
     * Method used internally to determine mute setting of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateMute
     * @private
     * @since 3.0.0
     */ updateMute: function() {
                    if (this.audio) this.audio.muted = this.currentConfig.mute || this.manager.mute;
                },
                /**
     * Method used internally to calculate total volume of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#updateVolume
     * @private
     * @since 3.0.0
     */ updateVolume: function() {
                    if (this.audio) this.audio.volume = Clamp(this.currentConfig.volume * this.manager.volume, 0, 1);
                },
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    BaseSound.prototype.calculateRate.call(this);
                    if (this.audio) this.audio.playbackRate = this.totalRate;
                },
                /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.HTML5AudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.currentConfig.mute;
                    },
                    set: function(value) {
                        this.currentConfig.mute = value;
                        if (this.manager.isLocked(this, 'mute', value)) return;
                        this.updateMute();
                        this.emit(Events.MUTE, this, value);
                    }
                },
                /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.HTML5AudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.currentConfig.volume;
                    },
                    set: function(value) {
                        this.currentConfig.volume = value;
                        if (this.manager.isLocked(this, 'volume', value)) return;
                        this.updateVolume();
                        this.emit(Events.VOLUME, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.HTML5AudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(value) {
                        this.currentConfig.rate = value;
                        if (this.manager.isLocked(this, Events.RATE, value)) return;
                        else {
                            this.calculateRate();
                            this.emit(Events.RATE, this, value);
                        }
                    }
                },
                /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.HTML5AudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.HTML5AudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(value) {
                        this.currentConfig.detune = value;
                        if (this.manager.isLocked(this, Events.DETUNE, value)) return;
                        else {
                            this.calculateRate();
                            this.emit(Events.DETUNE, this, value);
                        }
                    }
                },
                /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.HTML5AudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.HTML5AudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                    get: function() {
                        if (this.isPlaying) return this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
                        else if (this.isPaused) return this.currentConfig.seek;
                        else return 0;
                    },
                    set: function(value) {
                        if (this.manager.isLocked(this, 'seek', value)) return;
                        if (this.startTime > 0) return;
                        if (this.isPlaying || this.isPaused) {
                            value = Math.min(Math.max(0, value), this.duration);
                            if (this.isPlaying) {
                                this.previousTime = value;
                                this.audio.currentTime = value;
                            } else if (this.isPaused) this.currentConfig.seek = value;
                            this.emit(Events.SEEK, this, value);
                        }
                    }
                },
                /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                    this.seek = value;
                    return this;
                },
                /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.HTML5AudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(value) {
                        this.currentConfig.loop = value;
                        if (this.manager.isLocked(this, 'loop', value)) return;
                        if (this.audio) this.audio.loop = value;
                        this.emit(Events.LOOP, this, value);
                    }
                },
                /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.HTML5AudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
     */ setLoop: function(value) {
                    this.loop = value;
                    return this;
                },
                /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @name Phaser.Sound.HTML5AudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                    get: function() {
                        return this.currentConfig.pan;
                    },
                    set: function(value) {
                        this.currentConfig.pan = value;
                        this.emit(Events.PAN, this, value);
                    }
                },
                /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Has no audible effect on HTML5 Audio Sound, but still generates the PAN Event.
     *
     * @method Phaser.Sound.HTML5AudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                    this.pan = value;
                    return this;
                }
            });
            module1.exports = HTML5AudioSound;
        /***/ },
        /* 424 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSoundManager = __webpack_require__(144);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var NoAudioSound = __webpack_require__(425);
            var NOOP = __webpack_require__(1);
            /**
 * @classdesc
 * No-audio implementation of the Sound Manager. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of Sound Manager logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var NoAudioSoundManager = new Class({
                Extends: EventEmitter,
                initialize: function NoAudioSoundManager(game) {
                    EventEmitter.call(this);
                    this.game = game;
                    this.sounds = [];
                    this.mute = false;
                    this.volume = 1;
                    this.rate = 1;
                    this.detune = 0;
                    this.pauseOnBlur = true;
                    this.locked = false;
                },
                add: function(key, config) {
                    var sound = new NoAudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                addAudioSprite: function(key, config) {
                    var sound = this.add(key, config);
                    sound.spritemap = {};
                    return sound;
                },
                // eslint-disable-next-line no-unused-vars
                play: function(key, extra) {
                    return false;
                },
                // eslint-disable-next-line no-unused-vars
                playAudioSprite: function(key, spriteName, config) {
                    return false;
                },
                remove: function(sound) {
                    return BaseSoundManager.prototype.remove.call(this, sound);
                },
                removeByKey: function(key) {
                    return BaseSoundManager.prototype.removeByKey.call(this, key);
                },
                pauseAll: NOOP,
                resumeAll: NOOP,
                stopAll: NOOP,
                update: NOOP,
                setRate: NOOP,
                setDetune: NOOP,
                setMute: NOOP,
                setVolume: NOOP,
                forEachActiveSound: function(callbackfn, scope) {
                    BaseSoundManager.prototype.forEachActiveSound.call(this, callbackfn, scope);
                },
                destroy: function() {
                    BaseSoundManager.prototype.destroy.call(this);
                }
            });
            module1.exports = NoAudioSoundManager;
        /***/ },
        /* 425 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Extend = __webpack_require__(17);
            var returnFalse = function() {
                return false;
            };
            var returnNull = function() {
                return null;
            };
            var returnThis = function() {
                return this;
            };
            /**
 * @classdesc
 * No audio implementation of the sound. It is used if audio has been
 * disabled in the game config or the device doesn't support any audio.
 *
 * It represents a graceful degradation of sound logic that provides
 * minimal functionality and prevents Phaser projects that use audio from
 * breaking on devices that don't support any audio playback technologies.
 *
 * @class NoAudioSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.NoAudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var NoAudioSound = new Class({
                Extends: EventEmitter,
                initialize: function NoAudioSound(manager, key, config) {
                    if (config === void 0) config = {};
                    EventEmitter.call(this);
                    this.manager = manager;
                    this.key = key;
                    this.isPlaying = false;
                    this.isPaused = false;
                    this.totalRate = 1;
                    this.duration = 0;
                    this.totalDuration = 0;
                    this.config = Extend({
                        mute: false,
                        volume: 1,
                        rate: 1,
                        detune: 0,
                        seek: 0,
                        loop: false,
                        delay: 0,
                        pan: 0
                    }, config);
                    this.currentConfig = this.config;
                    this.mute = false;
                    this.volume = 1;
                    this.rate = 1;
                    this.detune = 0;
                    this.seek = 0;
                    this.loop = false;
                    this.pan = 0;
                    this.markers = {};
                    this.currentMarker = null;
                    this.pendingRemove = false;
                },
                /**
     * @method Phaser.Sound.NoAudioSound#addMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object.
     *
     * @return {boolean} false
     */ addMarker: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#updateMarker
     * @since 3.0.0
     *
     * @param {Phaser.Types.Sound.SoundMarker} marker - Marker object with updated values.
     *
     * @return {boolean} false
     */ updateMarker: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#removeMarker
     * @since 3.0.0
     *
     * @param {string} markerName - The name of the marker to remove.
     *
     * @return {null} null
     */ removeMarker: returnNull,
                /**
     * @method Phaser.Sound.NoAudioSound#play
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} false
     */ play: returnFalse,
                /**
     * @method Phaser.Sound.NoAudioSound#pause
     * @since 3.0.0
     *
     * @return {boolean} false
     */ pause: returnFalse,
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.NoAudioSound#resume
     * @since 3.0.0
     *
     * @return {boolean} false
     */ resume: returnFalse,
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.NoAudioSound#stop
     * @since 3.0.0
     *
     * @return {boolean} false
     */ stop: returnFalse,
                /**
     * Destroys this sound and all associated events and marks it for removal from the sound manager.
     *
     * @method Phaser.Sound.NoAudioSound#destroy
     * @fires Phaser.Sound.Events#DESTROY
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                },
                setMute: returnThis,
                setVolume: returnThis,
                setRate: returnThis,
                setDetune: returnThis,
                setSeek: returnThis,
                setLoop: returnThis,
                setPan: returnThis
            });
            module1.exports = NoAudioSound;
        /***/ },
        /* 426 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64ToArrayBuffer = __webpack_require__(427);
            var BaseSoundManager = __webpack_require__(144);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(69);
            var GameEvents = __webpack_require__(22);
            var WebAudioSound = __webpack_require__(428);
            /**
 * @classdesc
 * Web Audio API implementation of the Sound Manager.
 *
 * Not all browsers can play all audio formats.
 *
 * There is a good guide to what's supported: [Cross-browser audio basics: Audio codec support](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
 *
 * @class WebAudioSoundManager
 * @extends Phaser.Sound.BaseSoundManager
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Game} game - Reference to the current game instance.
 */ var WebAudioSoundManager = new Class({
                Extends: BaseSoundManager,
                initialize: function WebAudioSoundManager(game) {
                    /**
         * The AudioContext being used for playback.
         *
         * @name Phaser.Sound.WebAudioSoundManager#context
         * @type {AudioContext}
         * @private
         * @since 3.0.0
         */ this.context = this.createAudioContext(game);
                    /**
         * Gain node responsible for controlling global muting.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterMuteNode
         * @type {GainNode}
         * @private
         * @since 3.0.0
         */ this.masterMuteNode = this.context.createGain();
                    /**
         * Gain node responsible for controlling global volume.
         *
         * @name Phaser.Sound.WebAudioSoundManager#masterVolumeNode
         * @type {GainNode}
         * @private
         * @since 3.0.0
         */ this.masterVolumeNode = this.context.createGain();
                    this.masterMuteNode.connect(this.masterVolumeNode);
                    this.masterVolumeNode.connect(this.context.destination);
                    /**
         * Destination node for connecting individual sounds to.
         *
         * @name Phaser.Sound.WebAudioSoundManager#destination
         * @type {AudioNode}
         * @private
         * @since 3.0.0
         */ this.destination = this.masterMuteNode;
                    this.locked = this.context.state === 'suspended' && ('ontouchstart' in window || 'onclick' in window);
                    BaseSoundManager.call(this, game);
                    if (this.locked && game.isBooted) this.unlock();
                    else game.events.once(GameEvents.BOOT, this.unlock, this);
                },
                /**
     * Method responsible for instantiating and returning AudioContext instance.
     * If an instance of an AudioContext class was provided through the game config,
     * that instance will be returned instead. This can come in handy if you are reloading
     * a Phaser game on a page that never properly refreshes (such as in an SPA project)
     * and you want to reuse already instantiated AudioContext.
     *
     * @method Phaser.Sound.WebAudioSoundManager#createAudioContext
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Game} game - Reference to the current game instance.
     *
     * @return {AudioContext} The AudioContext instance to be used for playback.
     */ createAudioContext: function(game) {
                    var audioConfig = game.config.audio;
                    if (audioConfig.context) {
                        audioConfig.context.resume();
                        return audioConfig.context;
                    }
                    return new AudioContext();
                },
                /**
     * This method takes a new AudioContext reference and then sets
     * this Sound Manager to use that context for all playback.
     *
     * As part of this call it also disconnects the master mute and volume
     * nodes and then re-creates them on the new given context.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setAudioContext
     * @since 3.21.0
     *
     * @param {AudioContext} context - Reference to an already created AudioContext instance.
     *
     * @return {this} The WebAudioSoundManager instance.
     */ setAudioContext: function(context) {
                    if (this.context) this.context.close();
                    if (this.masterMuteNode) this.masterMuteNode.disconnect();
                    if (this.masterVolumeNode) this.masterVolumeNode.disconnect();
                    this.context = context;
                    this.masterMuteNode = context.createGain();
                    this.masterVolumeNode = context.createGain();
                    this.masterMuteNode.connect(this.masterVolumeNode);
                    this.masterVolumeNode.connect(context.destination);
                    this.destination = this.masterMuteNode;
                    return this;
                },
                /**
     * Adds a new sound into the sound manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#add
     * @since 3.0.0
     *
     * @param {string} key - Asset key for the sound.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - An optional config object containing default sound settings.
     *
     * @return {Phaser.Sound.WebAudioSound} The new sound instance.
     */ add: function(key, config) {
                    var sound = new WebAudioSound(this, key, config);
                    this.sounds.push(sound);
                    return sound;
                },
                /**
     * Decode audio data into a format ready for playback via Web Audio.
     *
     * The audio data can be a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     *
     * The `audioKey` is the key that will be used to save the decoded audio to the audio cache.
     *
     * Instead of passing a single entry you can instead pass an array of `Phaser.Types.Sound.DecodeAudioConfig`
     * objects as the first and only argument.
     *
     * Decoding is an async process, so be sure to listen for the events to know when decoding has completed.
     *
     * Once the audio has decoded it can be added to the Sound Manager or played via its key.
     *
     * @method Phaser.Sound.WebAudioSoundManager#decodeAudio
     * @fires Phaser.Sound.Events#DECODED
     * @fires Phaser.Sound.Events#DECODED_ALL
     * @since 3.18.0
     *
     * @param {(Phaser.Types.Sound.DecodeAudioConfig[]|string)} [audioKey] - The string-based key to be used to reference the decoded audio in the audio cache, or an array of audio config objects.
     * @param {(ArrayBuffer|string)} [audioData] - The audio data, either a base64 encoded string, an audio media-type data uri, or an ArrayBuffer instance.
     */ decodeAudio: function(audioKey, audioData) {
                    var audioFiles;
                    if (!Array.isArray(audioKey)) audioFiles = [
                        {
                            key: audioKey,
                            data: audioData
                        }
                    ];
                    else audioFiles = audioKey;
                    var cache = this.game.cache.audio;
                    var remaining = audioFiles.length;
                    for(var i = 0; i < audioFiles.length; i++){
                        var entry = audioFiles[i];
                        var key = entry.key;
                        var data = entry.data;
                        if (typeof data === 'string') data = Base64ToArrayBuffer(data);
                        var success = (function(key, audioBuffer) {
                            cache.add(key, audioBuffer);
                            this.emit(Events.DECODED, key);
                            remaining--;
                            if (remaining === 0) this.emit(Events.DECODED_ALL);
                        }).bind(this, key);
                        var failure = (function(key, error) {
                            //  eslint-disable-next-line no-console
                            console.error('Error decoding audio: ' + key + ' - ', error ? error.message : '');
                            remaining--;
                            if (remaining === 0) this.emit(Events.DECODED_ALL);
                        }).bind(this, key);
                        this.context.decodeAudioData(data, success, failure);
                    }
                },
                /**
     * Unlocks Web Audio API on the initial input event.
     *
     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
     *
     * @method Phaser.Sound.WebAudioSoundManager#unlock
     * @since 3.0.0
     */ unlock: function() {
                    var _this = this;
                    var body = document.body;
                    var unlockHandler = function unlockHandler() {
                        if (_this.context) _this.context.resume().then(function() {
                            body.removeEventListener('touchstart', unlockHandler);
                            body.removeEventListener('touchend', unlockHandler);
                            body.removeEventListener('click', unlockHandler);
                            body.removeEventListener('keydown', unlockHandler);
                            _this.unlocked = true;
                        }, function() {
                            body.removeEventListener('touchstart', unlockHandler);
                            body.removeEventListener('touchend', unlockHandler);
                            body.removeEventListener('click', unlockHandler);
                            body.removeEventListener('keydown', unlockHandler);
                        });
                    };
                    if (body) {
                        body.addEventListener('touchstart', unlockHandler, false);
                        body.addEventListener('touchend', unlockHandler, false);
                        body.addEventListener('click', unlockHandler, false);
                        body.addEventListener('keydown', unlockHandler, false);
                    }
                },
                /**
     * Method used internally for pausing sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    if (!this.locked) this.context.suspend();
                },
                /**
     * Method used internally for resuming sound manager if
     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
     *
     * @method Phaser.Sound.WebAudioSoundManager#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    if (!this.locked) this.context.resume();
                },
                /**
     * Calls Phaser.Sound.BaseSoundManager#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSoundManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.destination = null;
                    this.masterVolumeNode.disconnect();
                    this.masterVolumeNode = null;
                    this.masterMuteNode.disconnect();
                    this.masterMuteNode = null;
                    if (this.game.config.audio.context) this.context.suspend();
                    else {
                        var _this = this;
                        this.context.close().then(function() {
                            _this.context = null;
                        });
                    }
                    BaseSoundManager.prototype.destroy.call(this);
                },
                /**
     * Sets the muted state of all this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setMute
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.3.0
     *
     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.WebAudioSoundManager#mute
     * @type {boolean}
     * @fires Phaser.Sound.Events#GLOBAL_MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.masterMuteNode.gain.value === 0;
                    },
                    set: function(value) {
                        this.masterMuteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                        this.emit(Events.GLOBAL_MUTE, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound Manager.
     *
     * @method Phaser.Sound.WebAudioSoundManager#setVolume
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.3.0
     *
     * @param {number} value - The global volume of this Sound Manager.
     *
     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * @name Phaser.Sound.WebAudioSoundManager#volume
     * @type {number}
     * @fires Phaser.Sound.Events#GLOBAL_VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.masterVolumeNode.gain.value;
                    },
                    set: function(value) {
                        this.masterVolumeNode.gain.setValueAtTime(value, 0);
                        this.emit(Events.GLOBAL_VOLUME, this, value);
                    }
                }
            });
            module1.exports = WebAudioSoundManager;
        /***/ },
        /* 427 */ /***/ function(module1, exports) {
            /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            //  Use a lookup table to find the index.
            var lookup = new Uint8Array(256);
            for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
            /**
 * Converts a base64 string, either with or without a data uri, into an Array Buffer.
 *
 * @function Phaser.Utils.Base64.Base64ToArrayBuffer
 * @since 3.18.0
 * 
 * @param {string} base64 - The base64 string to be decoded. Can optionally contain a data URI header, which will be stripped out prior to decoding.
 * 
 * @return {ArrayBuffer} An ArrayBuffer decoded from the base64 data.
 */ var Base64ToArrayBuffer = function(base64) {
                //  Is it a data uri? if so, strip the header away
                base64 = base64.substr(base64.indexOf(',') + 1);
                var len = base64.length;
                var bufferLength = len * 0.75;
                var p = 0;
                var encoded1;
                var encoded2;
                var encoded3;
                var encoded4;
                if (base64[len - 1] === '=') {
                    bufferLength--;
                    if (base64[len - 2] === '=') bufferLength--;
                }
                var arrayBuffer = new ArrayBuffer(bufferLength);
                var bytes = new Uint8Array(arrayBuffer);
                for(var i = 0; i < len; i += 4){
                    encoded1 = lookup[base64.charCodeAt(i)];
                    encoded2 = lookup[base64.charCodeAt(i + 1)];
                    encoded3 = lookup[base64.charCodeAt(i + 2)];
                    encoded4 = lookup[base64.charCodeAt(i + 3)];
                    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                }
                return arrayBuffer;
            };
            module1.exports = Base64ToArrayBuffer;
        /***/ },
        /* 428 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BaseSound = __webpack_require__(145);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(69);
            /**
 * @classdesc
 * Web Audio API implementation of the sound.
 *
 * @class WebAudioSound
 * @extends Phaser.Sound.BaseSound
 * @memberof Phaser.Sound
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Sound.WebAudioSoundManager} manager - Reference to the current sound manager instance.
 * @param {string} key - Asset key for the sound.
 * @param {Phaser.Types.Sound.SoundConfig} [config={}] - An optional config object containing default sound settings.
 */ var WebAudioSound = new Class({
                Extends: BaseSound,
                initialize: function WebAudioSound(manager, key, config) {
                    if (config === undefined) config = {};
                    /**
         * Audio buffer containing decoded data of the audio asset to be played.
         *
         * @name Phaser.Sound.WebAudioSound#audioBuffer
         * @type {AudioBuffer}
         * @private
         * @since 3.0.0
         */ this.audioBuffer = manager.game.cache.audio.get(key);
                    if (!this.audioBuffer) throw new Error('Audio key "' + key + '" missing from cache');
                    /**
         * A reference to an audio source node used for playing back audio from
         * audio data stored in Phaser.Sound.WebAudioSound#audioBuffer.
         *
         * @name Phaser.Sound.WebAudioSound#source
         * @type {AudioBufferSourceNode}
         * @private
         * @default null
         * @since 3.0.0
         */ this.source = null;
                    /**
         * A reference to a second audio source used for gapless looped playback.
         *
         * @name Phaser.Sound.WebAudioSound#loopSource
         * @type {AudioBufferSourceNode}
         * @private
         * @default null
         * @since 3.0.0
         */ this.loopSource = null;
                    /**
         * Gain node responsible for controlling this sound's muting.
         *
         * @name Phaser.Sound.WebAudioSound#muteNode
         * @type {GainNode}
         * @private
         * @since 3.0.0
         */ this.muteNode = manager.context.createGain();
                    /**
         * Gain node responsible for controlling this sound's volume.
         *
         * @name Phaser.Sound.WebAudioSound#volumeNode
         * @type {GainNode}
         * @private
         * @since 3.0.0
         */ this.volumeNode = manager.context.createGain();
                    /**
         * Panner node responsible for controlling this sound's pan.
         *
         * Doesn't work on iOS / Safari.
         *
         * @name Phaser.Sound.WebAudioSound#pannerNode
         * @type {StereoPannerNode}
         * @private
         * @since 3.50.0
         */ this.pannerNode = null;
                    /**
         * The time at which the sound should have started playback from the beginning.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#playTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.playTime = 0;
                    /**
         * The time at which the sound source should have actually started playback.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#startTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.startTime = 0;
                    /**
         * The time at which the sound loop source should actually start playback.
         * Based on BaseAudioContext.currentTime value.
         *
         * @name Phaser.Sound.WebAudioSound#loopTime
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this.loopTime = 0;
                    /**
         * An array where we keep track of all rate updates during playback.
         * Array of object types: { time: number, rate: number }
         *
         * @name Phaser.Sound.WebAudioSound#rateUpdates
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this.rateUpdates = [];
                    /**
         * Used for keeping track when sound source playback has ended
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasEnded
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this.hasEnded = false;
                    /**
         * Used for keeping track when sound source has looped
         * so its state can be updated accordingly.
         *
         * @name Phaser.Sound.WebAudioSound#hasLooped
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this.hasLooped = false;
                    this.muteNode.connect(this.volumeNode);
                    if (manager.context.createStereoPanner) {
                        this.pannerNode = manager.context.createStereoPanner();
                        this.volumeNode.connect(this.pannerNode);
                        this.pannerNode.connect(manager.destination);
                    } else this.volumeNode.connect(manager.destination);
                    this.duration = this.audioBuffer.duration;
                    this.totalDuration = this.audioBuffer.duration;
                    BaseSound.call(this, manager, key, config);
                },
                /**
     * Play this sound, or a marked section of it.
     *
     * It always plays the sound from the start. If you want to start playback from a specific time
     * you can set 'seek' setting of the config object, provided to this call, to that value.
     *
     * @method Phaser.Sound.WebAudioSound#play
     * @fires Phaser.Sound.Events#PLAY
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Sound.SoundConfig)} [markerName=''] - If you want to play a marker then provide the marker name here. Alternatively, this parameter can be a SoundConfig object.
     * @param {Phaser.Types.Sound.SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
     *
     * @return {boolean} Whether the sound started playing successfully.
     */ play: function(markerName, config) {
                    if (!BaseSound.prototype.play.call(this, markerName, config)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    this.stopAndRemoveBufferSource();
                    this.createAndStartBufferSource();
                    this.emit(Events.PLAY, this);
                    return true;
                },
                /**
     * Pauses the sound.
     *
     * @method Phaser.Sound.WebAudioSound#pause
     * @fires Phaser.Sound.Events#PAUSE
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was paused successfully.
     */ pause: function() {
                    if (this.manager.context.currentTime < this.startTime) return false;
                    if (!BaseSound.prototype.pause.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
                    this.currentConfig.seek = this.getCurrentTime(); // Equivalent to setting paused time
                    this.stopAndRemoveBufferSource();
                    this.emit(Events.PAUSE, this);
                    return true;
                },
                /**
     * Resumes the sound.
     *
     * @method Phaser.Sound.WebAudioSound#resume
     * @fires Phaser.Sound.Events#RESUME
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was resumed successfully.
     */ resume: function() {
                    if (this.manager.context.currentTime < this.startTime) return false;
                    if (!BaseSound.prototype.resume.call(this)) return false;
                    //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
                    this.createAndStartBufferSource();
                    this.emit(Events.RESUME, this);
                    return true;
                },
                /**
     * Stop playing this sound.
     *
     * @method Phaser.Sound.WebAudioSound#stop
     * @fires Phaser.Sound.Events#STOP
     * @since 3.0.0
     *
     * @return {boolean} Whether the sound was stopped successfully.
     */ stop: function() {
                    if (!BaseSound.prototype.stop.call(this)) return false;
                    //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
                    this.stopAndRemoveBufferSource();
                    this.emit(Events.STOP, this);
                    return true;
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartBufferSource
     * @private
     * @since 3.0.0
     */ createAndStartBufferSource: function() {
                    var seek = this.currentConfig.seek;
                    var delay = this.currentConfig.delay;
                    var when = this.manager.context.currentTime + delay;
                    var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
                    var duration = this.duration - seek;
                    this.playTime = when - seek;
                    this.startTime = when;
                    this.source = this.createBufferSource();
                    this.applyConfig();
                    this.source.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                    this.resetConfig();
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createAndStartLoopBufferSource
     * @private
     * @since 3.0.0
     */ createAndStartLoopBufferSource: function() {
                    var when = this.getLoopTime();
                    var offset = this.currentMarker ? this.currentMarker.start : 0;
                    var duration = this.duration;
                    this.loopTime = when;
                    this.loopSource = this.createBufferSource();
                    this.loopSource.playbackRate.setValueAtTime(this.totalRate, 0);
                    this.loopSource.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#createBufferSource
     * @private
     * @since 3.0.0
     *
     * @return {AudioBufferSourceNode}
     */ createBufferSource: function() {
                    var _this = this;
                    var source = this.manager.context.createBufferSource();
                    source.buffer = this.audioBuffer;
                    source.connect(this.muteNode);
                    source.onended = function(ev) {
                        if (ev.target === _this.source) {
                            // sound ended
                            if (_this.currentConfig.loop) _this.hasLooped = true;
                            else _this.hasEnded = true;
                        }
                    // else was stopped
                    };
                    return source;
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveBufferSource
     * @private
     * @since 3.0.0
     */ stopAndRemoveBufferSource: function() {
                    if (this.source) {
                        this.source.stop();
                        this.source.disconnect();
                        this.source = null;
                    }
                    this.playTime = 0;
                    this.startTime = 0;
                    this.stopAndRemoveLoopBufferSource();
                },
                /**
     * Used internally.
     *
     * @method Phaser.Sound.WebAudioSound#stopAndRemoveLoopBufferSource
     * @private
     * @since 3.0.0
     */ stopAndRemoveLoopBufferSource: function() {
                    if (this.loopSource) {
                        this.loopSource.stop();
                        this.loopSource.disconnect();
                        this.loopSource = null;
                    }
                    this.loopTime = 0;
                },
                /**
     * Method used internally for applying config values to some of the sound properties.
     *
     * @method Phaser.Sound.WebAudioSound#applyConfig
     * @protected
     * @since 3.0.0
     */ applyConfig: function() {
                    this.rateUpdates.length = 0;
                    this.rateUpdates.push({
                        time: 0,
                        rate: 1
                    });
                    BaseSound.prototype.applyConfig.call(this);
                },
                /**
     * Update method called automatically by sound manager on every game step.
     *
     * @method Phaser.Sound.WebAudioSound#update
     * @fires Phaser.Sound.Events#COMPLETE
     * @fires Phaser.Sound.Events#LOOPED
     * @protected
     * @since 3.0.0
     */ update: function() {
                    if (this.hasEnded) {
                        this.hasEnded = false;
                        BaseSound.prototype.stop.call(this);
                        this.stopAndRemoveBufferSource();
                        this.emit(Events.COMPLETE, this);
                    } else if (this.hasLooped) {
                        this.hasLooped = false;
                        this.source = this.loopSource;
                        this.loopSource = null;
                        this.playTime = this.startTime = this.loopTime;
                        this.rateUpdates.length = 0;
                        this.rateUpdates.push({
                            time: 0,
                            rate: this.totalRate
                        });
                        this.createAndStartLoopBufferSource();
                        this.emit(Events.LOOPED, this);
                    }
                },
                /**
     * Calls Phaser.Sound.BaseSound#destroy method
     * and cleans up all Web Audio API related stuff.
     *
     * @method Phaser.Sound.WebAudioSound#destroy
     * @since 3.0.0
     */ destroy: function() {
                    BaseSound.prototype.destroy.call(this);
                    this.audioBuffer = null;
                    this.stopAndRemoveBufferSource();
                    this.muteNode.disconnect();
                    this.muteNode = null;
                    this.volumeNode.disconnect();
                    this.volumeNode = null;
                    if (this.pannerNode) {
                        this.pannerNode.disconnect();
                        this.pannerNode = null;
                    }
                    this.rateUpdates.length = 0;
                    this.rateUpdates = null;
                },
                /**
     * Method used internally to calculate total playback rate of the sound.
     *
     * @method Phaser.Sound.WebAudioSound#calculateRate
     * @protected
     * @since 3.0.0
     */ calculateRate: function() {
                    BaseSound.prototype.calculateRate.call(this);
                    var now = this.manager.context.currentTime;
                    if (this.source && typeof this.totalRate === 'number') this.source.playbackRate.setValueAtTime(this.totalRate, now);
                    if (this.isPlaying) {
                        this.rateUpdates.push({
                            time: Math.max(this.startTime, now) - this.playTime,
                            rate: this.totalRate
                        });
                        if (this.loopSource) {
                            this.stopAndRemoveLoopBufferSource();
                            this.createAndStartLoopBufferSource();
                        }
                    }
                },
                /**
     * Method used internally for calculating current playback time of a playing sound.
     *
     * @method Phaser.Sound.WebAudioSound#getCurrentTime
     * @private
     * @since 3.0.0
     */ getCurrentTime: function() {
                    var currentTime = 0;
                    for(var i = 0; i < this.rateUpdates.length; i++){
                        var nextTime = 0;
                        if (i < this.rateUpdates.length - 1) nextTime = this.rateUpdates[i + 1].time;
                        else nextTime = this.manager.context.currentTime - this.playTime;
                        currentTime += (nextTime - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                    }
                    return currentTime;
                },
                /**
     * Method used internally for calculating the time
     * at witch the loop source should start playing.
     *
     * @method Phaser.Sound.WebAudioSound#getLoopTime
     * @private
     * @since 3.0.0
     */ getLoopTime: function() {
                    var lastRateUpdateCurrentTime = 0;
                    for(var i = 0; i < this.rateUpdates.length - 1; i++)lastRateUpdateCurrentTime += (this.rateUpdates[i + 1].time - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
                    var lastRateUpdate = this.rateUpdates[this.rateUpdates.length - 1];
                    return this.playTime + lastRateUpdate.time + (this.duration - lastRateUpdateCurrentTime) / lastRateUpdate.rate;
                },
                /**
     * Rate at which this Sound will be played.
     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @name Phaser.Sound.WebAudioSound#rate
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#RATE
     * @since 3.0.0
     */ rate: {
                    get: function() {
                        return this.currentConfig.rate;
                    },
                    set: function(value) {
                        this.currentConfig.rate = value;
                        this.calculateRate();
                        this.emit(Events.RATE, this, value);
                    }
                },
                /**
     * Sets the playback rate of this Sound.
     *
     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
     * and 2.0 doubles the audios playback speed.
     *
     * @method Phaser.Sound.WebAudioSound#setRate
     * @fires Phaser.Sound.Events#RATE
     * @since 3.3.0
     *
     * @param {number} value - The playback rate at of this Sound.
     *
     * @return {this} This Sound instance.
     */ setRate: function(value) {
                    this.rate = value;
                    return this;
                },
                /**
     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @name Phaser.Sound.WebAudioSound#detune
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.0.0
     */ detune: {
                    get: function() {
                        return this.currentConfig.detune;
                    },
                    set: function(value) {
                        this.currentConfig.detune = value;
                        this.calculateRate();
                        this.emit(Events.DETUNE, this, value);
                    }
                },
                /**
     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @method Phaser.Sound.WebAudioSound#setDetune
     * @fires Phaser.Sound.Events#DETUNE
     * @since 3.3.0
     *
     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
     *
     * @return {this} This Sound instance.
     */ setDetune: function(value) {
                    this.detune = value;
                    return this;
                },
                /**
     * Boolean indicating whether the sound is muted or not.
     * Gets or sets the muted state of this sound.
     *
     * @name Phaser.Sound.WebAudioSound#mute
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.0.0
     */ mute: {
                    get: function() {
                        return this.muteNode.gain.value === 0;
                    },
                    set: function(value) {
                        this.currentConfig.mute = value;
                        this.muteNode.gain.setValueAtTime(value ? 0 : 1, 0);
                        this.emit(Events.MUTE, this, value);
                    }
                },
                /**
     * Sets the muted state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setMute
     * @fires Phaser.Sound.Events#MUTE
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
     *
     * @return {this} This Sound instance.
     */ setMute: function(value) {
                    this.mute = value;
                    return this;
                },
                /**
     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
     *
     * @name Phaser.Sound.WebAudioSound#volume
     * @type {number}
     * @default 1
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.0.0
     */ volume: {
                    get: function() {
                        return this.volumeNode.gain.value;
                    },
                    set: function(value) {
                        this.currentConfig.volume = value;
                        this.volumeNode.gain.setValueAtTime(value, 0);
                        this.emit(Events.VOLUME, this, value);
                    }
                },
                /**
     * Sets the volume of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setVolume
     * @fires Phaser.Sound.Events#VOLUME
     * @since 3.4.0
     *
     * @param {number} value - The volume of the sound.
     *
     * @return {this} This Sound instance.
     */ setVolume: function(value) {
                    this.volume = value;
                    return this;
                },
                /**
     * Property representing the position of playback for this sound, in seconds.
     * Setting it to a specific value moves current playback to that position.
     * The value given is clamped to the range 0 to current marker duration.
     * Setting seek of a stopped sound has no effect.
     *
     * @name Phaser.Sound.WebAudioSound#seek
     * @type {number}
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.0.0
     */ seek: {
                    get: function() {
                        if (this.isPlaying) {
                            if (this.manager.context.currentTime < this.startTime) return this.startTime - this.playTime;
                            return this.getCurrentTime();
                        } else if (this.isPaused) return this.currentConfig.seek;
                        else return 0;
                    },
                    set: function(value) {
                        if (this.manager.context.currentTime < this.startTime) return;
                        if (this.isPlaying || this.isPaused) {
                            value = Math.min(Math.max(0, value), this.duration);
                            this.currentConfig.seek = value;
                            if (this.isPlaying) {
                                this.stopAndRemoveBufferSource();
                                this.createAndStartBufferSource();
                            }
                            this.emit(Events.SEEK, this, value);
                        }
                    }
                },
                /**
     * Seeks to a specific point in this sound.
     *
     * @method Phaser.Sound.WebAudioSound#setSeek
     * @fires Phaser.Sound.Events#SEEK
     * @since 3.4.0
     *
     * @param {number} value - The point in the sound to seek to.
     *
     * @return {this} This Sound instance.
     */ setSeek: function(value) {
                    this.seek = value;
                    return this;
                },
                /**
     * Flag indicating whether or not the sound or current sound marker will loop.
     *
     * @name Phaser.Sound.WebAudioSound#loop
     * @type {boolean}
     * @default false
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.0.0
     */ loop: {
                    get: function() {
                        return this.currentConfig.loop;
                    },
                    set: function(value) {
                        this.currentConfig.loop = value;
                        if (this.isPlaying) {
                            this.stopAndRemoveLoopBufferSource();
                            if (value) this.createAndStartLoopBufferSource();
                        }
                        this.emit(Events.LOOP, this, value);
                    }
                },
                /**
     * Sets the loop state of this Sound.
     *
     * @method Phaser.Sound.WebAudioSound#setLoop
     * @fires Phaser.Sound.Events#LOOP
     * @since 3.4.0
     *
     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
     *
     * @return {this} This Sound instance.
     */ setLoop: function(value) {
                    this.loop = value;
                    return this;
                },
                /**
     * Gets or sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Always returns zero on iOS / Safari as it doesn't support the stereo panner node.
     *
     * @name Phaser.Sound.WebAudioSound#pan
     * @type {number}
     * @default 0
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     */ pan: {
                    get: function() {
                        if (this.pannerNode) return this.pannerNode.pan.value;
                        else return 0;
                    },
                    set: function(value) {
                        this.currentConfig.pan = value;
                        if (this.pannerNode) this.pannerNode.pan.setValueAtTime(value, this.manager.context.currentTime);
                        this.emit(Events.PAN, this, value);
                    }
                },
                /**
     * Sets the pan of this sound, a value between -1 (full left pan) and 1 (full right pan).
     *
     * Note: iOS / Safari doesn't support the stereo panner node.
     *
     * @method Phaser.Sound.WebAudioSound#setPan
     * @fires Phaser.Sound.Events#PAN
     * @since 3.50.0
     *
     * @param {number} value - The pan of the sound. A value between -1 (full left pan) and 1 (full right pan).
     *
     * @return {this} This Sound instance.
     */ setPan: function(value) {
                    this.pan = value;
                    return this;
                }
            });
            module1.exports = WebAudioSound;
        /***/ },
        /* 429 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Transposes the elements of the given matrix (array of arrays).
 *
 * The transpose of a matrix is a new matrix whose rows are the columns of the original.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.TransposeMatrix
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [array,$return]
 *
 * @param {T[][]} [array] - The array matrix to transpose.
 *
 * @return {T[][]} A new array matrix which is a transposed version of the given array.
 */ var TransposeMatrix = function(array) {
                var sourceRowCount = array.length;
                var sourceColCount = array[0].length;
                var result = new Array(sourceColCount);
                for(var i = 0; i < sourceColCount; i++){
                    result[i] = new Array(sourceRowCount);
                    for(var j = sourceRowCount - 1; j > -1; j--)result[i][j] = array[j][i];
                }
                return result;
            };
            module1.exports = TransposeMatrix;
        /***/ },
        /* 430 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ function swap(arr, i, j) {
                var tmp = arr[i];
                arr[i] = arr[j];
                arr[j] = tmp;
            }
            /**
 * @ignore
 */ function defaultCompare(a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
            }
            /**
 * A [Floyd-Rivest](https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm) quick selection algorithm.
 *
 * Rearranges the array items so that all items in the [left, k] range are smaller than all items in [k, right];
 * The k-th element will have the (k - left + 1)th smallest value in [left, right].
 *
 * The array is modified in-place.
 *
 * Based on code by [Vladimir Agafonkin](https://www.npmjs.com/~mourner)
 *
 * @function Phaser.Utils.Array.QuickSelect
 * @since 3.0.0
 *
 * @param {array} arr - The array to sort.
 * @param {number} k - The k-th element index.
 * @param {number} [left=0] - The index of the left part of the range.
 * @param {number} [right] - The index of the right part of the range.
 * @param {function} [compare] - An optional comparison function. Is passed two elements and should return 0, 1 or -1.
 */ var QuickSelect = function(arr, k, left, right, compare) {
                if (left === undefined) left = 0;
                if (right === undefined) right = arr.length - 1;
                if (compare === undefined) compare = defaultCompare;
                while(right > left){
                    if (right - left > 600) {
                        var n = right - left + 1;
                        var m = k - left + 1;
                        var z = Math.log(n);
                        var s = 0.5 * Math.exp(2 * z / 3);
                        var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                        var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                        var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                        QuickSelect(arr, k, newLeft, newRight, compare);
                    }
                    var t = arr[k];
                    var i = left;
                    var j = right;
                    swap(arr, left, k);
                    if (compare(arr[right], t) > 0) swap(arr, left, right);
                    while(i < j){
                        swap(arr, i, j);
                        i++;
                        j--;
                        while(compare(arr[i], t) < 0)i++;
                        while(compare(arr[j], t) > 0)j--;
                    }
                    if (compare(arr[left], t) === 0) swap(arr, left, j);
                    else {
                        j++;
                        swap(arr, j, right);
                    }
                    if (j <= k) left = j + 1;
                    if (k <= j) right = j - 1;
                }
            };
            module1.exports = QuickSelect;
        /***/ },
        /* 431 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            var Shuffle = __webpack_require__(129);
            var BuildChunk = function(a, b, qty) {
                var out = [];
                for(var aIndex = 0; aIndex < a.length; aIndex++){
                    for(var bIndex = 0; bIndex < b.length; bIndex++)for(var i = 0; i < qty; i++)out.push({
                        a: a[aIndex],
                        b: b[bIndex]
                    });
                }
                return out;
            };
            /**
 * Creates an array populated with a range of values, based on the given arguments and configuration object.
 *
 * Range ([a,b,c], [1,2,3]) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3
 * 
 * Range ([a,b], [1,2,3], qty = 3) =
 * a1, a1, a1, a2, a2, a2, a3, a3, a3, b1, b1, b1, b2, b2, b2, b3, b3, b3
 * 
 * Range ([a,b,c], [1,2,3], repeat x1) =
 * a1, a2, a3, b1, b2, b3, c1, c2, c3, a1, a2, a3, b1, b2, b3, c1, c2, c3
 * 
 * Range ([a,b], [1,2], repeat -1 = endless, max = 14) =
 * Maybe if max is set then repeat goes to -1 automatically?
 * a1, a2, b1, b2, a1, a2, b1, b2, a1, a2, b1, b2, a1, a2 (capped at 14 elements)
 * 
 * Range ([a], [1,2,3,4,5], random = true) =
 * a4, a1, a5, a2, a3
 * 
 * Range ([a, b], [1,2,3], random = true) =
 * b3, a2, a1, b1, a3, b2
 * 
 * Range ([a, b, c], [1,2,3], randomB = true) =
 * a3, a1, a2, b2, b3, b1, c1, c3, c2
 * 
 * Range ([a], [1,2,3,4,5], yoyo = true) =
 * a1, a2, a3, a4, a5, a5, a4, a3, a2, a1
 * 
 * Range ([a, b], [1,2,3], yoyo = true) =
 * a1, a2, a3, b1, b2, b3, b3, b2, b1, a3, a2, a1
 *
 * @function Phaser.Utils.Array.Range
 * @since 3.0.0
 *
 * @param {array} a - The first array of range elements.
 * @param {array} b - The second array of range elements.
 * @param {object} [options] - A range configuration object. Can contain: repeat, random, randomB, yoyo, max, qty.
 *
 * @return {array} An array of arranged elements.
 */ var Range = function(a, b, options) {
                var max = GetValue(options, 'max', 0);
                var qty = GetValue(options, 'qty', 1);
                var random = GetValue(options, 'random', false);
                var randomB = GetValue(options, 'randomB', false);
                var repeat = GetValue(options, 'repeat', 0);
                var yoyo = GetValue(options, 'yoyo', false);
                var out = [];
                if (randomB) Shuffle(b);
                //  Endless repeat, so limit by max
                if (repeat === -1) {
                    if (max === 0) repeat = 0;
                    else {
                        //  Work out how many repeats we need
                        var total = a.length * b.length * qty;
                        if (yoyo) total *= 2;
                        repeat = Math.ceil(max / total);
                    }
                }
                for(var i = 0; i <= repeat; i++){
                    var chunk = BuildChunk(a, b, qty);
                    if (random) Shuffle(chunk);
                    out = out.concat(chunk);
                    if (yoyo) {
                        chunk.reverse();
                        out = out.concat(chunk);
                    }
                }
                if (max) out.splice(max);
                return out;
            };
            module1.exports = Range;
        /***/ },
        /* 432 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs.Events
 */ module1.exports = {
                PROCESS_QUEUE_ADD: __webpack_require__(1035),
                PROCESS_QUEUE_REMOVE: __webpack_require__(1036)
            };
        /***/ },
        /* 433 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAdvancedValue = __webpack_require__(13);
            /**
 * Adds an Animation component to a Sprite and populates it based on the given config.
 *
 * @function Phaser.GameObjects.BuildGameObjectAnimation
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Sprite} sprite - The sprite to add an Animation component to.
 * @param {object} config - The animation config.
 *
 * @return {Phaser.GameObjects.Sprite} The updated Sprite.
 */ var BuildGameObjectAnimation = function(sprite, config) {
                var animConfig = GetAdvancedValue(config, 'anims', null);
                if (animConfig === null) return sprite;
                if (typeof animConfig === 'string') //  { anims: 'key' }
                sprite.anims.play(animConfig);
                else if (typeof animConfig === 'object') {
                    //  { anims: {
                    //              key: string
                    //              startFrame: [string|number]
                    //              delay: [float]
                    //              repeat: [integer]
                    //              repeatDelay: [float]
                    //              yoyo: [boolean]
                    //              play: [boolean]
                    //              delayedPlay: [boolean]
                    //           }
                    //  }
                    var anims = sprite.anims;
                    var key = GetAdvancedValue(animConfig, 'key', undefined);
                    if (key) {
                        var startFrame = GetAdvancedValue(animConfig, 'startFrame', undefined);
                        var delay = GetAdvancedValue(animConfig, 'delay', 0);
                        var repeat = GetAdvancedValue(animConfig, 'repeat', 0);
                        var repeatDelay = GetAdvancedValue(animConfig, 'repeatDelay', 0);
                        var yoyo = GetAdvancedValue(animConfig, 'yoyo', false);
                        var play = GetAdvancedValue(animConfig, 'play', false);
                        var delayedPlay = GetAdvancedValue(animConfig, 'delayedPlay', 0);
                        var playConfig = {
                            key: key,
                            delay: delay,
                            repeat: repeat,
                            repeatDelay: repeatDelay,
                            yoyo: yoyo,
                            startFrame: startFrame
                        };
                        if (play) anims.play(playConfig);
                        else if (delayedPlay > 0) anims.playAfterDelay(playConfig, delayedPlay);
                        else anims.load(playConfig);
                    }
                }
                return sprite;
            };
            module1.exports = BuildGameObjectAnimation;
        /***/ },
        /* 434 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Frame = __webpack_require__(106);
            /**
 * @classdesc
 * A Bob Game Object.
 *
 * A Bob belongs to a Blitter Game Object. The Blitter is responsible for managing and rendering this object.
 *
 * A Bob has a position, alpha value and a frame from a texture that it uses to render with. You can also toggle
 * the flipped and visible state of the Bob. The Frame the Bob uses to render can be changed dynamically, but it
 * must be a Frame within the Texture used by the parent Blitter.
 *
 * Bob positions are relative to the Blitter parent. So if you move the Blitter parent, all Bob children will
 * have their positions impacted by this change as well.
 *
 * You can manipulate Bob objects directly from your game code, but the creation and destruction of them should be
 * handled via the Blitter parent.
 *
 * @class Bob
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Blitter} blitter - The parent Blitter object is responsible for updating this Bob.
 * @param {number} x - The horizontal position of this Game Object in the world, relative to the parent Blitter position.
 * @param {number} y - The vertical position of this Game Object in the world, relative to the parent Blitter position.
 * @param {(string|number)} frame - The Frame this Bob will render with, as defined in the Texture the parent Blitter is using.
 * @param {boolean} visible - Should the Bob render visible or not to start with?
 */ var Bob = new Class({
                initialize: function Bob(blitter, x, y, frame, visible) {
                    /**
         * The Blitter object that this Bob belongs to.
         *
         * @name Phaser.GameObjects.Bob#parent
         * @type {Phaser.GameObjects.Blitter}
         * @since 3.0.0
         */ this.parent = blitter;
                    /**
         * The x position of this Bob, relative to the x position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y position of this Bob, relative to the y position of the Blitter.
         *
         * @name Phaser.GameObjects.Bob#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The frame that the Bob uses to render with.
         * To change the frame use the `Bob.setFrame` method.
         *
         * @name Phaser.GameObjects.Bob#frame
         * @type {Phaser.Textures.Frame}
         * @protected
         * @since 3.0.0
         */ this.frame = frame;
                    /**
         * A blank object which can be used to store data related to this Bob in.
         *
         * @name Phaser.GameObjects.Bob#data
         * @type {object}
         * @default {}
         * @since 3.0.0
         */ this.data = {};
                    /**
         * The tint value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#tint
         * @type {number}
         * @default 0xffffff
         * @since 3.20.0
         */ this.tint = 0xffffff;
                    /**
         * The visible state of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_visible
         * @type {boolean}
         * @private
         * @since 3.0.0
         */ this._visible = visible;
                    /**
         * The alpha value of this Bob.
         *
         * @name Phaser.GameObjects.Bob#_alpha
         * @type {number}
         * @private
         * @default 1
         * @since 3.0.0
         */ this._alpha = 1;
                    /**
         * The horizontally flipped state of the Bob.
         * A Bob that is flipped horizontally will render inversed on the horizontal axis.
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipX
         * @type {boolean}
         * @since 3.0.0
         */ this.flipX = false;
                    /**
         * The vertically flipped state of the Bob.
         * A Bob that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
         * Flipping always takes place from the middle of the texture.
         *
         * @name Phaser.GameObjects.Bob#flipY
         * @type {boolean}
         * @since 3.0.0
         */ this.flipY = false;
                },
                /**
     * Changes the Texture Frame being used by this Bob.
     * The frame must be part of the Texture the parent Blitter is using.
     * If no value is given it will use the default frame of the Blitter parent.
     *
     * @method Phaser.GameObjects.Bob#setFrame
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The frame to be used during rendering.
     *
     * @return {this} This Bob Game Object.
     */ setFrame: function(frame) {
                    if (frame === undefined) this.frame = this.parent.frame;
                    else if (frame instanceof Frame && frame.texture === this.parent.texture) this.frame = frame;
                    else this.frame = this.parent.texture.get(frame);
                    return this;
                },
                /**
     * Resets the horizontal and vertical flipped state of this Bob back to their default un-flipped state.
     *
     * @method Phaser.GameObjects.Bob#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Bob Game Object.
     */ resetFlip: function() {
                    this.flipX = false;
                    this.flipY = false;
                    return this;
                },
                /**
     * Resets this Bob.
     *
     * Changes the position to the values given, and optionally changes the frame.
     *
     * Also resets the flipX and flipY values, sets alpha back to 1 and visible to true.
     *
     * @method Phaser.GameObjects.Bob#reset
     * @since 3.0.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {(string|number|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
     *
     * @return {this} This Bob Game Object.
     */ reset: function(x, y, frame) {
                    this.x = x;
                    this.y = y;
                    this.flipX = false;
                    this.flipY = false;
                    this._alpha = 1;
                    this._visible = true;
                    this.parent.dirty = true;
                    if (frame) this.setFrame(frame);
                    return this;
                },
                /**
     * Changes the position of this Bob to the values given.
     *
     * @method Phaser.GameObjects.Bob#setPosition
     * @since 3.20.0
     *
     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
     *
     * @return {this} This Bob Game Object.
     */ setPosition: function(x, y) {
                    this.x = x;
                    this.y = y;
                    return this;
                },
                /**
     * Sets the horizontal flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipX: function(value) {
                    this.flipX = value;
                    return this;
                },
                /**
     * Sets the vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlipY: function(value) {
                    this.flipY = value;
                    return this;
                },
                /**
     * Sets the horizontal and vertical flipped state of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     *
     * @return {this} This Bob Game Object.
     */ setFlip: function(x, y) {
                    this.flipX = x;
                    this.flipY = y;
                    return this;
                },
                /**
     * Sets the visibility of this Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible state of the Game Object.
     *
     * @return {this} This Bob Game Object.
     */ setVisible: function(value) {
                    this.visible = value;
                    return this;
                },
                /**
     * Set the Alpha level of this Bob. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @method Phaser.GameObjects.Bob#setAlpha
     * @since 3.0.0
     *
     * @param {number} value - The alpha value used for this Bob. Between 0 and 1.
     *
     * @return {this} This Bob Game Object.
     */ setAlpha: function(value) {
                    this.alpha = value;
                    return this;
                },
                /**
     * Sets the tint of this Bob.
     *
     * @method Phaser.GameObjects.Bob#setTint
     * @since 3.20.0
     *
     * @param {number} value - The tint value used for this Bob. Between 0 and 0xffffff.
     *
     * @return {this} This Bob Game Object.
     */ setTint: function(value) {
                    this.tint = value;
                    return this;
                },
                /**
     * Destroys this Bob instance.
     * Removes itself from the Blitter and clears the parent, frame and data properties.
     *
     * @method Phaser.GameObjects.Bob#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.parent.dirty = true;
                    this.parent.children.remove(this);
                    this.parent = undefined;
                    this.frame = undefined;
                    this.data = undefined;
                },
                /**
     * The visible state of the Bob.
     *
     * An invisible Bob will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#visible
     * @type {boolean}
     * @since 3.0.0
     */ visible: {
                    get: function() {
                        return this._visible;
                    },
                    set: function(value) {
                        this.parent.dirty |= this._visible !== value;
                        this._visible = value;
                    }
                },
                /**
     * The alpha value of the Bob, between 0 and 1.
     *
     * A Bob with alpha 0 will skip rendering.
     *
     * @name Phaser.GameObjects.Bob#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        this.parent.dirty |= this._alpha > 0 !== value > 0;
                        this._alpha = value;
                    }
                }
            });
            module1.exports = Bob;
        /***/ },
        /* 435 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Creates a new Rectangle or repositions and/or resizes an existing Rectangle so that it encompasses the two given Rectangles, i.e. calculates their union.
 *
 * @function Phaser.Geom.Rectangle.Union
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to use.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to use.
 * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the union in.
 *
 * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
 */ var Union = function(rectA, rectB, out) {
                if (out === undefined) out = new Rectangle();
                //  Cache vars so we can use one of the input rects as the output rect
                var x = Math.min(rectA.x, rectB.x);
                var y = Math.min(rectA.y, rectB.y);
                var w = Math.max(rectA.right, rectB.right) - x;
                var h = Math.max(rectA.bottom, rectB.bottom) - y;
                return out.setTo(x, y, w, h);
            };
            module1.exports = Union;
        /***/ },
        /* 436 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DOMElementRender = __webpack_require__(1049);
            var GameObject = __webpack_require__(15);
            var IsPlainObject = __webpack_require__(7);
            var RemoveFromDOM = __webpack_require__(199);
            var SCENE_EVENTS = __webpack_require__(21);
            var Vector4 = __webpack_require__(138);
            /**
 * @classdesc
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * When this is added, Phaser will automatically create a DOM Container div that is positioned over the top
 * of the game canvas. This div is sized to match the canvas, and if the canvas size changes, as a result of
 * settings within the Scale Manager, the dom container is resized accordingly.
 *
 * If you have not already done so, you have to provide a `parent` in the Game Configuration, or the DOM
 * Container will fail to be created.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * Note that you should only have DOM Elements in a Scene with a _single_ Camera. If you require multiple cameras,
 * use parallel scenes to achieve this.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * @class DOMElement
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.17.0
 *
 * @extends Phaser.GameObjects.Components.AlphaSingle
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this DOM Element in the world.
 * @param {number} [y=0] - The vertical position of this DOM Element in the world.
 * @param {(Element|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 */ var DOMElement = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.AlphaSingle,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Transform,
                    Components.Visible,
                    DOMElementRender
                ],
                initialize: function DOMElement(scene, x, y, element, style, innerText) {
                    GameObject.call(this, scene, 'DOMElement');
                    /**
         * A reference to the parent DOM Container that the Game instance created when it started.
         *
         * @name Phaser.GameObjects.DOMElement#parent
         * @type {Element}
         * @since 3.17.0
         */ this.parent = scene.sys.game.domContainer;
                    /**
         * A reference to the HTML Cache.
         *
         * @name Phaser.GameObjects.DOMElement#cache
         * @type {Phaser.Cache.BaseCache}
         * @since 3.17.0
         */ this.cache = scene.sys.cache.html;
                    /**
         * The actual DOM Element that this Game Object is bound to. For example, if you've created a `<div>`
         * then this property is a direct reference to that element within the dom.
         *
         * @name Phaser.GameObjects.DOMElement#node
         * @type {Element}
         * @since 3.17.0
         */ this.node;
                    /**
         * By default a DOM Element will have its transform, display, opacity, zIndex and blend mode properties
         * updated when its rendered. If, for some reason, you don't want any of these changed other than the
         * CSS transform, then set this flag to `true`. When `true` only the CSS Transform is applied and it's
         * up to you to keep track of and set the other properties as required.
         *
         * This can be handy if, for example, you've a nested DOM Element and you don't want the opacity to be
         * picked-up by any of its children.
         *
         * @name Phaser.GameObjects.DOMElement#transformOnly
         * @type {boolean}
         * @since 3.17.0
         */ this.transformOnly = false;
                    /**
         * The angle, in radians, by which to skew the DOM Element on the horizontal axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewX
         * @type {number}
         * @since 3.17.0
         */ this.skewX = 0;
                    /**
         * The angle, in radians, by which to skew the DOM Element on the vertical axis.
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform
         *
         * @name Phaser.GameObjects.DOMElement#skewY
         * @type {number}
         * @since 3.17.0
         */ this.skewY = 0;
                    /**
         * A Vector4 that contains the 3D rotation of this DOM Element around a fixed axis in 3D space.
         *
         * All values in the Vector4 are treated as degrees, unless the `rotate3dAngle` property is changed.
         *
         * For more details see the following MDN page:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3d
         * @type {Phaser.Math.Vector4}
         * @since 3.17.0
         */ this.rotate3d = new Vector4();
                    /**
         * The unit that represents the 3D rotation values. By default this is `deg` for degrees, but can
         * be changed to any supported unit. See this page for further details:
         *
         * https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate3d
         *
         * @name Phaser.GameObjects.DOMElement#rotate3dAngle
         * @type {string}
         * @since 3.17.0
         */ this.rotate3dAngle = 'deg';
                    /**
         * The native (un-scaled) width of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayWidth` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#width
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.width = 0;
                    /**
         * The native (un-scaled) height of this Game Object.
         *
         * For a DOM Element this property is read-only.
         *
         * The property `displayHeight` holds the computed bounds of this DOM Element, factoring in scaling.
         *
         * @name Phaser.GameObjects.DOMElement#height
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.height = 0;
                    /**
         * The computed display width of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `width` holds the un-scaled width of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayWidth
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayWidth = 0;
                    /**
         * The computed display height of this Game Object, based on the `getBoundingClientRect` DOM call.
         *
         * The property `height` holds the un-scaled height of this DOM Element.
         *
         * @name Phaser.GameObjects.DOMElement#displayHeight
         * @type {number}
         * @readonly
         * @since 3.17.0
         */ this.displayHeight = 0;
                    /**
         * Internal native event handler.
         *
         * @name Phaser.GameObjects.DOMElement#handler
         * @type {number}
         * @private
         * @since 3.17.0
         */ this.handler = this.dispatchNativeEvent.bind(this);
                    this.setPosition(x, y);
                    if (typeof element === 'string') {
                        //  hash?
                        if (element[0] === '#') this.setElement(element.substr(1), style, innerText);
                        else this.createElement(element, style, innerText);
                    } else if (element) this.setElement(element, style, innerText);
                    scene.sys.events.on(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                    scene.sys.events.on(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                /**
     * Handles a Scene Sleep and Wake event.
     *
     * @method Phaser.GameObjects.DOMElement#handleSceneEvent
     * @private
     * @since 3.22.0
     *
     * @param {Phaser.Scenes.Systems} sys - The Scene Systems.
     */ handleSceneEvent: function(sys) {
                    var node = this.node;
                    var style = node.style;
                    if (node) style.display = sys.settings.visible ? 'block' : 'none';
                },
                /**
     * Sets the horizontal and vertical skew values of this DOM Element.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/transform
     *
     * @method Phaser.GameObjects.DOMElement#setSkew
     * @since 3.17.0
     *
     * @param {number} [x=0] - The angle, in radians, by which to skew the DOM Element on the horizontal axis.
     * @param {number} [y=x] - The angle, in radians, by which to skew the DOM Element on the vertical axis.
     *
     * @return {this} This DOM Element instance.
     */ setSkew: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.skewX = x;
                    this.skewY = y;
                    return this;
                },
                /**
     * Sets the perspective CSS property of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @method Phaser.GameObjects.DOMElement#setPerspective
     * @since 3.17.0
     *
     * @param {number} value - The perspective value, in pixels, that determines the distance between the z plane and the user.
     *
     * @return {this} This DOM Element instance.
     */ setPerspective: function(value) {
                    this.parent.style.perspective = value + 'px';
                    return this;
                },
                /**
     * The perspective CSS property value of the _parent DOM Container_. This determines the distance between the z=0
     * plane and the user in order to give a 3D-positioned element some perspective. Each 3D element with
     * z > 0 becomes larger; each 3D-element with z < 0 becomes smaller. The strength of the effect is determined
     * by the value of this property.
     *
     * For more information see: https://developer.mozilla.org/en-US/docs/Web/CSS/perspective
     *
     * **Changing this value changes it globally for all DOM Elements, as they all share the same parent container.**
     *
     * @name Phaser.GameObjects.DOMElement#perspective
     * @type {number}
     * @since 3.17.0
     */ perspective: {
                    get: function() {
                        return parseFloat(this.parent.style.perspective);
                    },
                    set: function(value) {
                        this.parent.style.perspective = value + 'px';
                    }
                },
                /**
     * Adds one or more native DOM event listeners onto the underlying Element of this Game Object.
     * The event is then dispatched via this Game Objects standard event emitter.
     *
     * For example:
     *
     * ```javascript
     * var div = this.add.dom(x, y, element);
     *
     * div.addListener('click');
     *
     * div.on('click', handler);
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#addListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to listen for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ addListener: function(events) {
                    if (this.node) {
                        events = events.split(' ');
                        for(var i = 0; i < events.length; i++)this.node.addEventListener(events[i], this.handler, false);
                    }
                    return this;
                },
                /**
     * Removes one or more native DOM event listeners from the underlying Element of this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#removeListener
     * @since 3.17.0
     *
     * @param {string} events - The DOM event/s to stop listening for. You can specify multiple events by separating them with spaces.
     *
     * @return {this} This DOM Element instance.
     */ removeListener: function(events) {
                    if (this.node) {
                        events = events.split(' ');
                        for(var i = 0; i < events.length; i++)this.node.removeEventListener(events[i], this.handler);
                    }
                    return this;
                },
                /**
     * Internal event proxy to dispatch native DOM Events via this Game Object.
     *
     * @method Phaser.GameObjects.DOMElement#dispatchNativeEvent
     * @private
     * @since 3.17.0
     *
     * @param {any} event - The native DOM event.
     */ dispatchNativeEvent: function(event) {
                    this.emit(event.type, event);
                },
                /**
     * Creates a native DOM Element, adds it to the parent DOM Container and then binds it to this Game Object,
     * so you can control it. The `tagName` should be a string and is passed to `document.createElement`:
     *
     * ```javascript
     * this.add.dom().createElement('div');
     * ```
     *
     * For more details on acceptable tag names see: https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().createElement('div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().createElement('div', style, 'Phaser');
     * ```
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createElement
     * @since 3.17.0
     *
     * @param {string} tagName - A string that specifies the type of element to be created. The nodeName of the created element is initialized with the value of tagName. Don't use qualified names (like "html:a") with this method.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ createElement: function(tagName, style, innerText) {
                    return this.setElement(document.createElement(tagName), style, innerText);
                },
                /**
     * Binds a new DOM Element to this Game Object. If this Game Object already has an Element it is removed from the DOM
     * entirely first. Any event listeners you may have previously created will need to be re-created on the new element.
     *
     * The `element` argument you pass to this method can be either a string tagName:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * this.add.dom().setElement('heading');
     * ```
     *
     * Or a reference to an Element instance:
     *
     * ```javascript
     * <h1 id="heading">Phaser</h1>
     *
     * var h1 = document.getElementById('heading');
     *
     * this.add.dom().setElement(h1);
     * ```
     *
     * You can also pass in a DOMString or style object to set the CSS on the created element, and an optional `innerText`
     * value as well. Here is an example of a DOMString:
     *
     * ```javascript
     * this.add.dom().setElement(h1, 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
     * ```
     *
     * And using a style object:
     *
     * ```javascript
     * var style = {
     *   'background-color': 'lime';
     *   'width': '200px';
     *   'height': '100px';
     *   'font': '48px Arial';
     * };
     *
     * this.add.dom().setElement(h1, style, 'Phaser');
     * ```
     *
     * @method Phaser.GameObjects.DOMElement#setElement
     * @since 3.17.0
     *
     * @param {(string|Element)} element - If a string it is passed to `getElementById()`, or it should be a reference to an existing Element.
     * @param {(string|any)} [style] - Either a DOMString that holds the CSS styles to be applied to the created element, or an object the styles will be ready from.
     * @param {string} [innerText] - A DOMString that holds the text that will be set as the innerText of the created element.
     *
     * @return {this} This DOM Element instance.
     */ setElement: function(element, style, innerText) {
                    //  Already got an element? Remove it first
                    this.removeElement();
                    var target;
                    if (typeof element === 'string') {
                        //  hash?
                        if (element[0] === '#') element = element.substr(1);
                        target = document.getElementById(element);
                    } else if (typeof element === 'object' && element.nodeType === 1) target = element;
                    if (!target) return this;
                    this.node = target;
                    //  style can be empty, a string or a plain object
                    if (style && IsPlainObject(style)) for(var key in style)target.style[key] = style[key];
                    else if (typeof style === 'string') target.style = style;
                    //  Add / Override the values we need
                    target.style.zIndex = '0';
                    target.style.display = 'inline';
                    target.style.position = 'absolute';
                    //  Node handler
                    target.phaser = this;
                    if (this.parent) this.parent.appendChild(target);
                    //  InnerText
                    if (innerText) target.innerText = innerText;
                    return this.updateSize();
                },
                /**
     * Takes a block of html from the HTML Cache, that has previously been preloaded into the game, and then
     * creates a DOM Element from it. The loaded HTML is set as the `innerHTML` property of the created
     * element.
     *
     * Assume the following html is stored in a file called `loginform.html`:
     *
     * ```html
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * ```
     *
     * Which is loaded into your game using the cache key 'login':
     *
     * ```javascript
     * this.load.html('login', 'assets/loginform.html');
     * ```
     *
     * You can create a DOM Element from it using the cache key:
     *
     * ```javascript
     * this.add.dom().createFromCache('login');
     * ```
     *
     * The optional `elementType` argument controls the container that is created, into which the loaded html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromCache
     * @since 3.17.0
     *
     * @param {string} The key of the html cache entry to use for this DOM Element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the loaded html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromCache: function(key, tagName) {
                    var html = this.cache.get(key);
                    if (html) this.createFromHTML(html, tagName);
                    return this;
                },
                /**
     * Takes a string of html and then creates a DOM Element from it. The HTML is set as the `innerHTML`
     * property of the created element.
     *
     * ```javascript
     * let form = `
     * <input type="text" name="nameField" placeholder="Enter your name" style="font-size: 32px">
     * <input type="button" name="playButton" value="Let's Play" style="font-size: 32px">
     * `;
     * ```
     *
     * You can create a DOM Element from it using the string:
     *
     * ```javascript
     * this.add.dom().createFromHTML(form);
     * ```
     *
     * The optional `elementType` argument controls the type of container that is created, into which the html is inserted.
     * The default is a plain `div` object, but any valid tagName can be given.
     *
     * If this Game Object already has an Element, it is removed from the DOM entirely first.
     * Any event listeners you may have previously created will need to be re-created after this call.
     *
     * @method Phaser.GameObjects.DOMElement#createFromHTML
     * @since 3.17.0
     *
     * @param {string} A string of html to be set as the `innerHTML` property of the created element.
     * @param {string} [tagName='div'] - The tag name of the element into which all of the html will be inserted. Defaults to a plain div tag.
     *
     * @return {this} This DOM Element instance.
     */ createFromHTML: function(html, tagName) {
                    if (tagName === undefined) tagName = 'div';
                    //  Already got an element? Remove it first
                    this.removeElement();
                    var element = document.createElement(tagName);
                    this.node = element;
                    element.style.zIndex = '0';
                    element.style.display = 'inline';
                    element.style.position = 'absolute';
                    //  Node handler
                    element.phaser = this;
                    if (this.parent) this.parent.appendChild(element);
                    element.innerHTML = html;
                    return this.updateSize();
                },
                /**
     * Removes the current DOM Element bound to this Game Object from the DOM entirely and resets the
     * `node` property of this Game Object to be `null`.
     *
     * @method Phaser.GameObjects.DOMElement#removeElement
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ removeElement: function() {
                    if (this.node) {
                        RemoveFromDOM(this.node);
                        this.node = null;
                    }
                    return this;
                },
                /**
     * Internal method that calls `getBoundingClientRect` on the `node` and then sets the bounds width
     * and height into the `displayWidth` and `displayHeight` properties, and the `clientWidth` and `clientHeight`
     * values into the `width` and `height` properties respectively.
     *
     * This is called automatically whenever a new element is created or set.
     *
     * @method Phaser.GameObjects.DOMElement#updateSize
     * @since 3.17.0
     *
     * @return {this} This DOM Element instance.
     */ updateSize: function() {
                    var node = this.node;
                    var nodeBounds = node.getBoundingClientRect();
                    this.width = node.clientWidth;
                    this.height = node.clientHeight;
                    this.displayWidth = nodeBounds.width || 0;
                    this.displayHeight = nodeBounds.height || 0;
                    return this;
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a property matching the given key and value. It then returns this child
     * if found, or `null` if not.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByProperty
     * @since 3.17.0
     *
     * @param {string} property - The property to search the children for.
     * @param {string} value - The value the property must strictly equal.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByProperty: function(property, value) {
                    if (this.node) {
                        var children = this.node.querySelectorAll('*');
                        for(var i = 0; i < children.length; i++){
                            if (children[i][property] === value) return children[i];
                        }
                    }
                    return null;
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching id. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByID
     * @since 3.17.0
     *
     * @param {string} id - The id to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByID: function(id) {
                    return this.getChildByProperty('id', id);
                },
                /**
     * Gets all children from this DOM Elements node, using `querySelectorAll('*')` and then iterates through
     * them, looking for the first one that has a matching name. It then returns this child if found, or `null` if not.
     *
     * Be aware that class and id names are case-sensitive.
     *
     * @method Phaser.GameObjects.DOMElement#getChildByName
     * @since 3.17.0
     *
     * @param {string} name - The name to search the children for.
     *
     * @return {?Element} The first matching child DOM Element, or `null` if not found.
     */ getChildByName: function(name) {
                    return this.getChildByProperty('name', name);
                },
                /**
     * Sets the `className` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setClassName
     * @since 3.17.0
     *
     * @param {string} className - A string representing the class or space-separated classes of the element.
     *
     * @return {this} This DOM Element instance.
     */ setClassName: function(className) {
                    if (this.node) {
                        this.node.className = className;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Sets the `innerText` property of the DOM Element node and updates the internal sizes.
     *
     * Note that only certain types of Elements can have `innerText` set on them.
     *
     * @method Phaser.GameObjects.DOMElement#setText
     * @since 3.17.0
     *
     * @param {string} text - A DOMString representing the rendered text content of the element.
     *
     * @return {this} This DOM Element instance.
     */ setText: function(text) {
                    if (this.node) {
                        this.node.innerText = text;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Sets the `innerHTML` property of the DOM Element node and updates the internal sizes.
     *
     * @method Phaser.GameObjects.DOMElement#setHTML
     * @since 3.17.0
     *
     * @param {string} html - A DOMString of html to be set as the `innerHTML` property of the element.
     *
     * @return {this} This DOM Element instance.
     */ setHTML: function(html) {
                    if (this.node) {
                        this.node.innerHTML = html;
                        this.updateSize();
                    }
                    return this;
                },
                /**
     * Runs internal update tasks.
     *
     * @method Phaser.GameObjects.DOMElement#preUpdate
     * @private
     * @since 3.17.0
     */ preUpdate: function() {
                    var parent = this.parentContainer;
                    var node = this.node;
                    if (node && parent && !parent.willRender()) node.style.display = 'none';
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     *
     * DOMElements always return `true` as they need to still set values during the render pass, even if not visible.
     *
     * @method Phaser.GameObjects.DOMElement#willRender
     * @since 3.17.0
     *
     * @return {boolean} `true` if the Game Object should be rendered, otherwise `false`.
     */ willRender: function() {
                    return true;
                },
                /**
     * Handles the pre-destroy step for the DOM Element, which removes the underlying node from the DOM.
     *
     * @method Phaser.GameObjects.DOMElement#preDestroy
     * @private
     * @since 3.17.0
     */ preDestroy: function() {
                    this.removeElement();
                    this.scene.sys.events.off(SCENE_EVENTS.SLEEP, this.handleSceneEvent, this);
                    this.scene.sys.events.off(SCENE_EVENTS.WAKE, this.handleSceneEvent, this);
                }
            });
            module1.exports = DOMElement;
        /***/ },
        /* 437 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CSSBlendModes = __webpack_require__(1050);
            var GameObject = __webpack_require__(15);
            var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DOMElement#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active renderer.
 * @param {Phaser.GameObjects.DOMElement} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DOMElementCSSRenderer = function(renderer, src, camera, parentMatrix) {
                var node = src.node;
                var style = node.style;
                var settings = src.scene.sys.settings;
                if (!node || !style || !settings.visible || GameObject.RENDER_MASK !== src.renderFlags || src.cameraFilter !== 0 && src.cameraFilter & camera.id || src.parentContainer && !src.parentContainer.willRender()) {
                    if (node) style.display = 'none';
                    return;
                }
                var parent = src.parentContainer;
                var alpha = camera.alpha * src.alpha;
                if (parent) alpha *= parent.alpha;
                var camMatrix = tempMatrix1;
                var srcMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                var dx = 0;
                var dy = 0;
                var tx = '0%';
                var ty = '0%';
                if (parentMatrix) {
                    dx = src.width * src.scaleX * src.originX;
                    dy = src.height * src.scaleY * src.originY;
                    srcMatrix.applyITRS(src.x - dx, src.y - dy, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    srcMatrix.e = src.x - dx;
                    srcMatrix.f = src.y - dy;
                    //  Multiply by the src matrix, store result in calcMatrix
                    camMatrix.multiply(srcMatrix, calcMatrix);
                } else {
                    dx = src.width * src.originX;
                    dy = src.height * src.originY;
                    srcMatrix.applyITRS(src.x - dx, src.y - dy, src.rotation, src.scaleX, src.scaleY);
                    camMatrix.copyFrom(camera.matrix);
                    tx = 100 * src.originX + '%';
                    ty = 100 * src.originY + '%';
                    srcMatrix.e -= camera.scrollX * src.scrollFactorX;
                    srcMatrix.f -= camera.scrollY * src.scrollFactorY;
                    //  Multiply by the src matrix, store result in calcMatrix
                    camMatrix.multiply(srcMatrix, calcMatrix);
                }
                if (!src.transformOnly) {
                    style.display = 'block';
                    style.opacity = alpha;
                    style.zIndex = src._depth;
                    style.pointerEvents = 'auto';
                    style.mixBlendMode = CSSBlendModes[src._blendMode];
                }
                // https://developer.mozilla.org/en-US/docs/Web/CSS/transform
                style.transform = calcMatrix.getCSSMatrix() + ' skew(' + src.skewX + 'rad, ' + src.skewY + 'rad)' + ' rotate3d(' + src.rotate3d.x + ',' + src.rotate3d.y + ',' + src.rotate3d.z + ',' + src.rotate3d.w + src.rotate3dAngle + ')';
                style.transformOrigin = tx + ' ' + ty;
            };
            module1.exports = DOMElementCSSRenderer;
        /***/ },
        /* 438 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var ExternRender = __webpack_require__(1054);
            /**
 * @classdesc
 * An Extern Game Object is a special type of Game Object that allows you to pass
 * rendering off to a 3rd party.
 *
 * When you create an Extern and place it in the display list of a Scene, the renderer will
 * process the list as usual. When it finds an Extern it will flush the current batch,
 * clear down the pipeline and prepare a transform matrix which your render function can
 * take advantage of, if required.
 *
 * The WebGL context is then left is a 'clean' state, ready for you to bind your own shaders,
 * or draw to it, whatever you wish to do. Once you've finished, you should free-up any
 * of your resources. The Extern will then rebind the Phaser pipeline and carry on
 * rendering the display list.
 *
 * Although this object has lots of properties such as Alpha, Blend Mode and Tint, none of
 * them are used during rendering unless you take advantage of them in your own render code.
 *
 * @class Extern
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.16.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 */ var Extern = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.Depth,
                    Components.Flip,
                    Components.Origin,
                    Components.ScrollFactor,
                    Components.Size,
                    Components.Texture,
                    Components.Tint,
                    Components.Transform,
                    Components.Visible,
                    ExternRender
                ],
                initialize: function Extern(scene) {
                    GameObject.call(this, scene, 'Extern');
                },
                //  Overrides Game Object method
                addedToScene: function() {
                    this.scene.sys.updateList.add(this);
                },
                //  Overrides Game Object method
                removedFromScene: function() {
                    this.scene.sys.updateList.remove(this);
                },
                preUpdate: function() {
                //  override this!
                //  Arguments: time, delta
                },
                render: function() {
                //  override this!
                //  Arguments: renderer, camera, calcMatrix
                }
            });
            module1.exports = Extern;
        /***/ },
        /* 439 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircumferencePoint = __webpack_require__(215);
            var FromPercent = __webpack_require__(95);
            var MATH_CONST = __webpack_require__(14);
            var Point = __webpack_require__(4);
            /**
 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
 * at 180 degrees around the circle.
 *
 * @function Phaser.Geom.Ellipse.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
 * @param {number} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
 */ var GetPoint = function(ellipse, position, out) {
                if (out === undefined) out = new Point();
                var angle = FromPercent(position, 0, MATH_CONST.PI2);
                return CircumferencePoint(ellipse, angle, out);
            };
            module1.exports = GetPoint;
        /***/ },
        /* 440 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circumference = __webpack_require__(441);
            var CircumferencePoint = __webpack_require__(215);
            var FromPercent = __webpack_require__(95);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Ellipse.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
 */ var GetPoints = function(ellipse, quantity, stepRate, out) {
                if (out === undefined) out = [];
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = Circumference(ellipse) / stepRate;
                for(var i = 0; i < quantity; i++){
                    var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
                    out.push(CircumferencePoint(ellipse, angle));
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 441 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the circumference of the given Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Circumference
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference of.
 *
 * @return {number} The circumference of th Ellipse.
 */ var Circumference = function(ellipse) {
                var rx = ellipse.width / 2;
                var ry = ellipse.height / 2;
                var h = Math.pow(rx - ry, 2) / Math.pow(rx + ry, 2);
                return Math.PI * (rx + ry) * (1 + 3 * h / (10 + Math.sqrt(4 - 3 * h)));
            };
            module1.exports = Circumference;
        /***/ },
        /* 442 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(214);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 * @param {CanvasRenderingContext2D} [renderTargetCtx] - The target rendering context.
 * @param {boolean} allowClip - If `true` then path operations will be used instead of fill operations.
 */ var GraphicsCanvasRenderer = function(renderer, src, camera, parentMatrix, renderTargetCtx, allowClip) {
                var commandBuffer = src.commandBuffer;
                var commandBufferLength = commandBuffer.length;
                var ctx = renderTargetCtx || renderer.currentContext;
                if (commandBufferLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var lineAlpha = 1;
                var fillAlpha = 1;
                var lineColor = 0;
                var fillColor = 0;
                var lineWidth = 1;
                var red = 0;
                var green = 0;
                var blue = 0;
                //  Reset any currently active paths
                ctx.beginPath();
                for(var index = 0; index < commandBufferLength; ++index){
                    var commandID = commandBuffer[index];
                    switch(commandID){
                        case Commands.ARC:
                            ctx.arc(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4], commandBuffer[index + 5], commandBuffer[index + 6]);
                            //  +7 because overshoot is the 7th value, not used in Canvas
                            index += 7;
                            break;
                        case Commands.LINE_STYLE:
                            lineWidth = commandBuffer[index + 1];
                            lineColor = commandBuffer[index + 2];
                            lineAlpha = commandBuffer[index + 3];
                            red = (lineColor & 0xFF0000) >>> 16;
                            green = (lineColor & 0xFF00) >>> 8;
                            blue = lineColor & 0xFF;
                            ctx.strokeStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + lineAlpha + ')';
                            ctx.lineWidth = lineWidth;
                            index += 3;
                            break;
                        case Commands.FILL_STYLE:
                            fillColor = commandBuffer[index + 1];
                            fillAlpha = commandBuffer[index + 2];
                            red = (fillColor & 0xFF0000) >>> 16;
                            green = (fillColor & 0xFF00) >>> 8;
                            blue = fillColor & 0xFF;
                            ctx.fillStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + fillAlpha + ')';
                            index += 2;
                            break;
                        case Commands.BEGIN_PATH:
                            ctx.beginPath();
                            break;
                        case Commands.CLOSE_PATH:
                            ctx.closePath();
                            break;
                        case Commands.FILL_PATH:
                            if (!allowClip) ctx.fill();
                            break;
                        case Commands.STROKE_PATH:
                            if (!allowClip) ctx.stroke();
                            break;
                        case Commands.FILL_RECT:
                            if (!allowClip) ctx.fillRect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                            else ctx.rect(commandBuffer[index + 1], commandBuffer[index + 2], commandBuffer[index + 3], commandBuffer[index + 4]);
                            index += 4;
                            break;
                        case Commands.FILL_TRIANGLE:
                            ctx.beginPath();
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                            ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                            ctx.closePath();
                            if (!allowClip) ctx.fill();
                            index += 6;
                            break;
                        case Commands.STROKE_TRIANGLE:
                            ctx.beginPath();
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
                            ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
                            ctx.closePath();
                            if (!allowClip) ctx.stroke();
                            index += 6;
                            break;
                        case Commands.LINE_TO:
                            ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.MOVE_TO:
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.LINE_FX_TO:
                            ctx.lineTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 5;
                            break;
                        case Commands.MOVE_FX_TO:
                            ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 5;
                            break;
                        case Commands.SAVE:
                            ctx.save();
                            break;
                        case Commands.RESTORE:
                            ctx.restore();
                            break;
                        case Commands.TRANSLATE:
                            ctx.translate(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.SCALE:
                            ctx.scale(commandBuffer[index + 1], commandBuffer[index + 2]);
                            index += 2;
                            break;
                        case Commands.ROTATE:
                            ctx.rotate(commandBuffer[index + 1]);
                            index += 1;
                            break;
                        case Commands.GRADIENT_FILL_STYLE:
                            index += 5;
                            break;
                        case Commands.GRADIENT_LINE_STYLE:
                            index += 6;
                            break;
                    }
                }
                //  Restore the context saved in SetTransform
                ctx.restore();
            };
            module1.exports = GraphicsCanvasRenderer;
        /***/ },
        /* 443 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FloatBetween = __webpack_require__(135);
            var GetEaseFunction = __webpack_require__(80);
            var GetFastValue = __webpack_require__(2);
            var Wrap = __webpack_require__(66);
            /**
 * @classdesc
 * A Particle Emitter property.
 *
 * Facilitates changing Particle properties as they are emitted and throughout their lifetime.
 *
 * @class EmitterOp
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for the Particle Emitter that owns this property.
 * @param {string} key - The name of the property.
 * @param {number} defaultValue - The default value of the property.
 * @param {boolean} [emitOnly=false] - Whether the property can only be modified when a Particle is emitted.
 */ var EmitterOp = new Class({
                initialize: function EmitterOp(config, key, defaultValue, emitOnly) {
                    if (emitOnly === undefined) emitOnly = false;
                    /**
         * The name of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyKey
         * @type {string}
         * @since 3.0.0
         */ this.propertyKey = key;
                    /**
         * The value of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#propertyValue
         * @type {number}
         * @since 3.0.0
         */ this.propertyValue = defaultValue;
                    /**
         * The default value of this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#defaultValue
         * @type {number}
         * @since 3.0.0
         */ this.defaultValue = defaultValue;
                    /**
         * The number of steps for stepped easing between {@link Phaser.GameObjects.Particles.EmitterOp#start} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#end} values, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#steps
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.steps = 0;
                    /**
         * The step counter for stepped easing, per emit.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#counter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.counter = 0;
                    /**
         * The start value for this property to ease between.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#start
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.start = 0;
                    /**
         * The end value for this property to ease between.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#end
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.end = 0;
                    /**
         * The easing function to use for updating this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#ease
         * @type {?function}
         * @since 3.0.0
         */ this.ease;
                    /**
         * Whether this property can only be modified when a Particle is emitted.
         *
         * Set to `true` to allow only {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} callbacks to be set and
         * affect this property.
         *
         * Set to `false` to allow both {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
         * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks to be set and affect this property.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#emitOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.emitOnly = emitOnly;
                    /**
         * The callback to run for Particles when they are emitted from the Particle Emitter.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onEmit
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitCallback}
         * @since 3.0.0
         */ this.onEmit = this.defaultEmit;
                    /**
         * The callback to run for Particles when they are updated.
         *
         * @name Phaser.GameObjects.Particles.EmitterOp#onUpdate
         * @type {Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateCallback}
         * @since 3.0.0
         */ this.onUpdate = this.defaultUpdate;
                    this.loadConfig(config);
                },
                /**
     * Load the property from a Particle Emitter configuration object.
     *
     * Optionally accepts a new property key to use, replacing the current one.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#loadConfig
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} [config] - Settings for the Particle Emitter that owns this property.
     * @param {string} [newKey] - The new key to use for this property, if any.
     */ loadConfig: function(config, newKey) {
                    if (config === undefined) config = {};
                    if (newKey) this.propertyKey = newKey;
                    this.propertyValue = GetFastValue(config, this.propertyKey, this.defaultValue);
                    this.setMethods();
                    if (this.emitOnly) //  Reset it back again
                    this.onUpdate = this.defaultUpdate;
                },
                /**
     * Build a JSON representation of this Particle Emitter property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Particle Emitter property.
     */ toJSON: function() {
                    return this.propertyValue;
                },
                /**
     * Change the current value of the property and update its callback methods.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#onChange
     * @since 3.0.0
     *
     * @param {number} value - The value of the property.
     *
     * @return {this} This Emitter Op object.
     */ onChange: function(value) {
                    this.propertyValue = value;
                    return this.setMethods();
                },
                /**
     * Update the {@link Phaser.GameObjects.Particles.EmitterOp#onEmit} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#onUpdate} callbacks based on the type of the current
     * {@link Phaser.GameObjects.Particles.EmitterOp#propertyValue}.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#setMethods
     * @since 3.0.0
     *
     * @return {this} This Emitter Op object.
     */ setMethods: function() {
                    var value = this.propertyValue;
                    var t = typeof value;
                    //  Reset them in case they're not changed below
                    this.onEmit = this.defaultEmit;
                    this.onUpdate = this.defaultUpdate;
                    if (t === 'number') {
                        //  Explicit static value:
                        //  x: 400
                        this.onEmit = this.staticValueEmit;
                        this.onUpdate = this.staticValueUpdate; // How?
                    } else if (Array.isArray(value)) //  Picks a random element from the array:
                    //  x: [ 100, 200, 300, 400 ]
                    this.onEmit = this.randomStaticValueEmit;
                    else if (t === 'function') {
                        //  The same as setting just the onUpdate function and no onEmit (unless this op is an emitOnly one)
                        //  Custom callback, must return a value:
                        /*
            x: function (particle, key, t, value)
               {
                   return value + 50;
               }
            */ if (this.emitOnly) this.onEmit = value;
                        else this.onUpdate = value;
                    } else if (t === 'object' && this.hasBoth(value, 'start', 'end')) {
                        this.start = value.start;
                        this.end = value.end;
                        //  x: { start: 100, end: 400, random: true } (random optional) = eases between start and end
                        var isRandom = this.has(value, 'random');
                        if (isRandom) this.onEmit = this.randomRangedValueEmit;
                        if (this.has(value, 'steps')) {
                            //  A stepped (per emit) range
                            //  x: { start: 100, end: 400, steps: 64 }
                            //  Increments a value stored in the emitter
                            this.steps = value.steps;
                            this.counter = this.start;
                            this.onEmit = this.steppedEmit;
                        } else {
                            //  An eased range (defaults to Linear if not specified)
                            //  x: { start: 100, end: 400, [ ease: 'Linear' ] }
                            var easeType = this.has(value, 'ease') ? value.ease : 'Linear';
                            this.ease = GetEaseFunction(easeType, value.easeParams);
                            if (!isRandom) this.onEmit = this.easedValueEmit;
                            this.onUpdate = this.easeValueUpdate;
                        }
                    } else if (t === 'object' && this.hasBoth(value, 'min', 'max')) {
                        //  { min: 100, max: 400 } = pick a random number between min and max
                        this.start = value.min;
                        this.end = value.max;
                        this.onEmit = this.randomRangedValueEmit;
                    } else if (t === 'object' && this.has(value, 'random')) {
                        //  { random: [ 100, 400 ] } = pick a random number between the two elements of the array
                        var rnd = value.random;
                        if (Array.isArray(rnd)) {
                            this.start = rnd[0];
                            this.end = rnd[1];
                        }
                        this.onEmit = this.randomRangedValueEmit;
                    } else if (t === 'object' && this.hasEither(value, 'onEmit', 'onUpdate')) {
                        //  Custom onEmit and onUpdate callbacks
                        /*
            x: {
                //  Called at the start of the particles life, when it is being created
                onEmit: function (particle, key, t, value)
                {
                    return value;
                },

                //  Called during the particles life on each update
                onUpdate: function (particle, key, t, value)
                {
                    return value;
                }
            }
            */ if (this.has(value, 'onEmit')) this.onEmit = value.onEmit;
                        if (this.has(value, 'onUpdate')) this.onUpdate = value.onUpdate;
                    }
                    return this;
                },
                /**
     * Check whether an object has the given property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#has
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key - The key of the property to look for in the object.
     *
     * @return {boolean} `true` if the property exists in the object, `false` otherwise.
     */ has: function(object, key) {
                    return object.hasOwnProperty(key);
                },
                /**
     * Check whether an object has both of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasBoth
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if both properties exist in the object, `false` otherwise.
     */ hasBoth: function(object, key1, key2) {
                    return object.hasOwnProperty(key1) && object.hasOwnProperty(key2);
                },
                /**
     * Check whether an object has at least one of the given properties.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#hasEither
     * @since 3.0.0
     *
     * @param {object} object - The object to check.
     * @param {string} key1 - The key of the first property to check the object for.
     * @param {string} key2 - The key of the second property to check the object for.
     *
     * @return {boolean} `true` if at least one of the properties exists in the object, `false` if neither exist.
     */ hasEither: function(object, key1, key2) {
                    return object.hasOwnProperty(key1) || object.hasOwnProperty(key2);
                },
                /**
     * The returned value sets what the property will be at the START of the particles life, on emit.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} [value] - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ defaultEmit: function(particle, key, value) {
                    return value;
                },
                /**
     * The returned value updates the property for the duration of the particles life.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#defaultUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The T value (between 0 and 1)
     * @param {number} value - The current value of the property.
     *
     * @return {number} The new value of the property.
     */ defaultUpdate: function(particle, key, t, value) {
                    return value;
                },
                /**
     * An `onEmit` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueEmit
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueEmit: function() {
                    return this.propertyValue;
                },
                /**
     * An `onUpdate` callback that returns the current value of the property.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueUpdate
     * @since 3.0.0
     *
     * @return {number} The current value of the property.
     */ staticValueUpdate: function() {
                    return this.propertyValue;
                },
                /**
     * An `onEmit` callback that returns a random value from the current value array.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomStaticValueEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ randomStaticValueEmit: function() {
                    var randomIndex = Math.floor(Math.random() * this.propertyValue.length);
                    return this.propertyValue[randomIndex];
                },
                /**
     * An `onEmit` callback that returns a value between the {@link Phaser.GameObjects.Particles.EmitterOp#start} and
     * {@link Phaser.GameObjects.Particles.EmitterOp#end} range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#randomRangedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The key of the property.
     *
     * @return {number} The new value of the property.
     */ randomRangedValueEmit: function(particle, key) {
                    var value = FloatBetween(this.start, this.end);
                    if (particle && particle.data[key]) particle.data[key].min = value;
                    return value;
                },
                /**
     * An `onEmit` callback that returns a stepped value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#steppedEmit
     * @since 3.0.0
     *
     * @return {number} The new value of the property.
     */ steppedEmit: function() {
                    var current = this.counter;
                    var next = this.counter + (this.end - this.start) / this.steps;
                    this.counter = Wrap(next, this.start, this.end);
                    return current;
                },
                /**
     * An `onEmit` callback for an eased property.
     *
     * It prepares the particle for easing by {@link Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate}.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easedValueEmit
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     *
     * @return {number} {@link Phaser.GameObjects.Particles.EmitterOp#start}, as the new value of the property.
     */ easedValueEmit: function(particle, key) {
                    if (particle && particle.data[key]) {
                        var data = particle.data[key];
                        data.min = this.start;
                        data.max = this.end;
                    }
                    return this.start;
                },
                /**
     * An `onUpdate` callback that returns an eased value between the
     * {@link Phaser.GameObjects.Particles.EmitterOp#start} and {@link Phaser.GameObjects.Particles.EmitterOp#end}
     * range.
     *
     * @method Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
     * @param {string} key - The name of the property.
     * @param {number} t - The T value (between 0 and 1)
     *
     * @return {number} The new value of the property.
     */ easeValueUpdate: function(particle, key, t) {
                    var data = particle.data[key];
                    return (data.max - data.min) * this.ease(t) + data.min;
                }
            });
            module1.exports = EmitterOp;
        /***/ },
        /* 444 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * The GravityWell action applies a force on the particle to draw it towards, or repel it from, a single point.
 * 
 * The force applied is inversely proportional to the square of the distance from the particle to the point, in accordance with Newton's law of gravity.
 * 
 * This simulates the effect of gravity over large distances (as between planets, for example).
 *
 * @class GravityWell
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {(number|Phaser.Types.GameObjects.Particles.GravityWellConfig)} [x=0] - The x coordinate of the Gravity Well, in world space.
 * @param {number} [y=0] - The y coordinate of the Gravity Well, in world space.
 * @param {number} [power=0] - The strength of the gravity force - larger numbers produce a stronger force.
 * @param {number} [epsilon=100] - The minimum distance for which the gravity force is calculated.
 * @param {number} [gravity=50] - The gravitational force of this Gravity Well.
 */ var GravityWell = new Class({
                initialize: function GravityWell(x, y, power, epsilon, gravity) {
                    if (typeof x === 'object') {
                        var config = x;
                        x = GetFastValue(config, 'x', 0);
                        y = GetFastValue(config, 'y', 0);
                        power = GetFastValue(config, 'power', 0);
                        epsilon = GetFastValue(config, 'epsilon', 100);
                        gravity = GetFastValue(config, 'gravity', 50);
                    } else {
                        if (x === undefined) x = 0;
                        if (y === undefined) y = 0;
                        if (power === undefined) power = 0;
                        if (epsilon === undefined) epsilon = 100;
                        if (gravity === undefined) gravity = 50;
                    }
                    /**
         * The x coordinate of the Gravity Well, in world space.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#x
         * @type {number}
         * @since 3.0.0
         */ this.x = x;
                    /**
         * The y coordinate of the Gravity Well, in world space.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#y
         * @type {number}
         * @since 3.0.0
         */ this.y = y;
                    /**
         * The active state of the Gravity Well. An inactive Gravity Well will not influence any particles.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Internal gravity value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_gravity
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._gravity = gravity;
                    /**
         * Internal power value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_power
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._power = 0;
                    /**
         * Internal epsilon value.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#_epsilon
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._epsilon = 0;
                    /**
         * The strength of the gravity force - larger numbers produce a stronger force.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#power
         * @type {number}
         * @since 3.0.0
         */ this.power = power;
                    /**
         * The minimum distance for which the gravity force is calculated.
         *
         * @name Phaser.GameObjects.Particles.GravityWell#epsilon
         * @type {number}
         * @since 3.0.0
         */ this.epsilon = epsilon;
                },
                /**
     * Takes a Particle and updates it based on the properties of this Gravity Well.
     *
     * @method Phaser.GameObjects.Particles.GravityWell#update
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     */ update: function(particle, delta) {
                    var x = this.x - particle.x;
                    var y = this.y - particle.y;
                    var dSq = x * x + y * y;
                    if (dSq === 0) return;
                    var d = Math.sqrt(dSq);
                    if (dSq < this._epsilon) dSq = this._epsilon;
                    var factor = this._power * delta / (dSq * d) * 100;
                    particle.velocityX += x * factor;
                    particle.velocityY += y * factor;
                },
                epsilon: {
                    get: function() {
                        return Math.sqrt(this._epsilon);
                    },
                    set: function(value) {
                        this._epsilon = value * value;
                    }
                },
                power: {
                    get: function() {
                        return this._power / this._gravity;
                    },
                    set: function(value) {
                        this._power = value * this._gravity;
                    }
                },
                gravity: {
                    get: function() {
                        return this._gravity;
                    },
                    set: function(value) {
                        var pwr = this.power;
                        this._gravity = value;
                        this.power = pwr;
                    }
                }
            });
            module1.exports = GravityWell;
        /***/ },
        /* 445 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(35);
            var DistanceBetween = __webpack_require__(48);
            /**
 * @classdesc
 * A Particle is a simple Game Object controlled by a Particle Emitter and Manager, and rendered by the Manager.
 * It uses its own lightweight physics system, and can interact only with its Emitter's bounds and zones.
 *
 * @class Particle
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to which this Particle belongs.
 */ var Particle = new Class({
                initialize: function Particle(emitter) {
                    /**
         * The Emitter to which this Particle belongs.
         *
         * A Particle can only belong to a single Emitter and is created, updated and destroyed via it.
         *
         * @name Phaser.GameObjects.Particles.Particle#emitter
         * @type {Phaser.GameObjects.Particles.ParticleEmitter}
         * @since 3.0.0
         */ this.emitter = emitter;
                    /**
         * The texture frame used to render this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#frame
         * @type {Phaser.Textures.Frame}
         * @default null
         * @since 3.0.0
         */ this.frame = null;
                    /**
         * The x coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#x
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.x = 0;
                    /**
         * The y coordinate of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#y
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.y = 0;
                    /**
         * The x velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityX = 0;
                    /**
         * The y velocity of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#velocityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.velocityY = 0;
                    /**
         * The x acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationX = 0;
                    /**
         * The y acceleration of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#accelerationY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelerationY = 0;
                    /**
         * The maximum horizontal velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityX
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityX = 10000;
                    /**
         * The maximum vertical velocity this Particle can travel at.
         *
         * @name Phaser.GameObjects.Particles.Particle#maxVelocityY
         * @type {number}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityY = 10000;
                    /**
         * The bounciness, or restitution, of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#bounce
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.bounce = 0;
                    /**
         * The horizontal scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleX
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleX = 1;
                    /**
         * The vertical scale of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#scaleY
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.scaleY = 1;
                    /**
         * The alpha value of this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#alpha
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.alpha = 1;
                    /**
         * The angle of this Particle in degrees.
         *
         * @name Phaser.GameObjects.Particles.Particle#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                    /**
         * The angle of this Particle in radians.
         *
         * @name Phaser.GameObjects.Particles.Particle#rotation
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.rotation = 0;
                    /**
         * The tint applied to this Particle.
         *
         * @name Phaser.GameObjects.Particles.Particle#tint
         * @type {number}
         * @webglOnly
         * @since 3.0.0
         */ this.tint = 0xffffff;
                    /**
         * The lifespan of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#life
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.life = 1000;
                    /**
         * The current life of this Particle in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeCurrent
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.lifeCurrent = 1000;
                    /**
         * The delay applied to this Particle upon emission, in ms.
         *
         * @name Phaser.GameObjects.Particles.Particle#delayCurrent
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.delayCurrent = 0;
                    /**
         * The normalized lifespan T value, where 0 is the start and 1 is the end.
         *
         * @name Phaser.GameObjects.Particles.Particle#lifeT
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.lifeT = 0;
                    /**
         * The data used by the ease equation.
         *
         * @name Phaser.GameObjects.Particles.Particle#data
         * @type {object}
         * @since 3.0.0
         */ this.data = {
                        tint: {
                            min: 0xffffff,
                            max: 0xffffff,
                            current: 0xffffff
                        },
                        alpha: {
                            min: 1,
                            max: 1
                        },
                        rotate: {
                            min: 0,
                            max: 0
                        },
                        scaleX: {
                            min: 1,
                            max: 1
                        },
                        scaleY: {
                            min: 1,
                            max: 1
                        }
                    };
                },
                /**
     * Checks to see if this Particle is alive and updating.
     *
     * @method Phaser.GameObjects.Particles.Particle#isAlive
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Particle is alive and updating, otherwise `false`.
     */ isAlive: function() {
                    return this.lifeCurrent > 0;
                },
                /**
     * Resets the position of this particle back to zero.
     *
     * @method Phaser.GameObjects.Particles.Particle#resetPosition
     * @since 3.16.0
     */ resetPosition: function() {
                    this.x = 0;
                    this.y = 0;
                },
                /**
     * Starts this Particle from the given coordinates.
     *
     * @method Phaser.GameObjects.Particles.Particle#fire
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to launch this Particle from.
     * @param {number} y - The y coordinate to launch this Particle from.
     */ fire: function(x, y) {
                    var emitter = this.emitter;
                    this.frame = emitter.getFrame();
                    if (emitter.emitZone) //  Updates particle.x and particle.y during this call
                    emitter.emitZone.getPoint(this);
                    if (x === undefined) this.x += emitter.x.onEmit(this, 'x');
                    else this.x += x;
                    if (y === undefined) this.y += emitter.y.onEmit(this, 'y');
                    else this.y += y;
                    this.life = emitter.lifespan.onEmit(this, 'lifespan');
                    this.lifeCurrent = this.life;
                    this.lifeT = 0;
                    var sx = emitter.speedX.onEmit(this, 'speedX');
                    var sy = emitter.speedY ? emitter.speedY.onEmit(this, 'speedY') : sx;
                    if (emitter.radial) {
                        var rad = DegToRad(emitter.angle.onEmit(this, 'angle'));
                        this.velocityX = Math.cos(rad) * Math.abs(sx);
                        this.velocityY = Math.sin(rad) * Math.abs(sy);
                    } else if (emitter.moveTo) {
                        var mx = emitter.moveToX.onEmit(this, 'moveToX');
                        var my = emitter.moveToY ? emitter.moveToY.onEmit(this, 'moveToY') : mx;
                        var angle = Math.atan2(my - this.y, mx - this.x);
                        var speed = DistanceBetween(this.x, this.y, mx, my) / (this.life / 1000);
                        //  We know how many pixels we need to move, but how fast?
                        // var speed = this.distanceToXY(displayObject, x, y) / (maxTime / 1000);
                        this.velocityX = Math.cos(angle) * speed;
                        this.velocityY = Math.sin(angle) * speed;
                    } else {
                        this.velocityX = sx;
                        this.velocityY = sy;
                    }
                    if (emitter.acceleration) {
                        this.accelerationX = emitter.accelerationX.onEmit(this, 'accelerationX');
                        this.accelerationY = emitter.accelerationY.onEmit(this, 'accelerationY');
                    }
                    this.maxVelocityX = emitter.maxVelocityX.onEmit(this, 'maxVelocityX');
                    this.maxVelocityY = emitter.maxVelocityY.onEmit(this, 'maxVelocityY');
                    this.delayCurrent = emitter.delay.onEmit(this, 'delay');
                    this.scaleX = emitter.scaleX.onEmit(this, 'scaleX');
                    this.scaleY = emitter.scaleY ? emitter.scaleY.onEmit(this, 'scaleY') : this.scaleX;
                    this.angle = emitter.rotate.onEmit(this, 'rotate');
                    this.rotation = DegToRad(this.angle);
                    this.bounce = emitter.bounce.onEmit(this, 'bounce');
                    this.alpha = emitter.alpha.onEmit(this, 'alpha');
                    this.tint = emitter.tint.onEmit(this, 'tint');
                },
                /**
     * An internal method that calculates the velocity of the Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter that is updating this Particle.
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {array} processors - Particle processors (gravity wells).
     */ computeVelocity: function(emitter, delta, step, processors) {
                    var vx = this.velocityX;
                    var vy = this.velocityY;
                    var ax = this.accelerationX;
                    var ay = this.accelerationY;
                    var mx = this.maxVelocityX;
                    var my = this.maxVelocityY;
                    vx += emitter.gravityX * step;
                    vy += emitter.gravityY * step;
                    if (ax) vx += ax * step;
                    if (ay) vy += ay * step;
                    if (vx > mx) vx = mx;
                    else if (vx < -mx) vx = -mx;
                    if (vy > my) vy = my;
                    else if (vy < -my) vy = -my;
                    this.velocityX = vx;
                    this.velocityY = vy;
                    //  Apply any additional processors
                    for(var i = 0; i < processors.length; i++)processors[i].update(this, delta, step);
                },
                /**
     * Checks if this Particle is still within the bounds defined by the given Emitter.
     *
     * If not, and depending on the Emitter collision flags, the Particle may either stop or rebound.
     *
     * @method Phaser.GameObjects.Particles.Particle#checkBounds
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to check the bounds against.
     */ checkBounds: function(emitter) {
                    var bounds = emitter.bounds;
                    var bounce = -this.bounce;
                    if (this.x < bounds.x && emitter.collideLeft) {
                        this.x = bounds.x;
                        this.velocityX *= bounce;
                    } else if (this.x > bounds.right && emitter.collideRight) {
                        this.x = bounds.right;
                        this.velocityX *= bounce;
                    }
                    if (this.y < bounds.y && emitter.collideTop) {
                        this.y = bounds.y;
                        this.velocityY *= bounce;
                    } else if (this.y > bounds.bottom && emitter.collideBottom) {
                        this.y = bounds.bottom;
                        this.velocityY *= bounce;
                    }
                },
                /**
     * The main update method for this Particle.
     *
     * Updates its life values, computes the velocity and repositions the Particle.
     *
     * @method Phaser.GameObjects.Particles.Particle#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms.
     * @param {number} step - The delta value divided by 1000.
     * @param {array} processors - An optional array of update processors.
     *
     * @return {boolean} Returns `true` if this Particle has now expired and should be removed, otherwise `false` if still active.
     */ update: function(delta, step, processors) {
                    if (this.delayCurrent > 0) {
                        this.delayCurrent -= delta;
                        return false;
                    }
                    var emitter = this.emitter;
                    //  How far along in life is this particle? (t = 0 to 1)
                    var t = 1 - this.lifeCurrent / this.life;
                    this.lifeT = t;
                    this.computeVelocity(emitter, delta, step, processors);
                    this.x += this.velocityX * step;
                    this.y += this.velocityY * step;
                    if (emitter.bounds) this.checkBounds(emitter);
                    if (emitter.deathZone && emitter.deathZone.willKill(this)) {
                        this.lifeCurrent = 0;
                        //  No need to go any further, particle has been killed
                        return true;
                    }
                    this.scaleX = emitter.scaleX.onUpdate(this, 'scaleX', t, this.scaleX);
                    if (emitter.scaleY) this.scaleY = emitter.scaleY.onUpdate(this, 'scaleY', t, this.scaleY);
                    else this.scaleY = this.scaleX;
                    this.angle = emitter.rotate.onUpdate(this, 'rotate', t, this.angle);
                    this.rotation = DegToRad(this.angle);
                    this.alpha = emitter.alpha.onUpdate(this, 'alpha', t, this.alpha);
                    this.tint = emitter.tint.onUpdate(this, 'tint', t, this.tint);
                    this.lifeCurrent -= delta;
                    return this.lifeCurrent <= 0;
                }
            });
            module1.exports = Particle;
        /***/ },
        /* 446 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BlendModes = __webpack_require__(34);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var DeathZone = __webpack_require__(447);
            var EdgeZone = __webpack_require__(448);
            var EmitterOp = __webpack_require__(443);
            var GetFastValue = __webpack_require__(2);
            var GetRandom = __webpack_require__(207);
            var HasAny = __webpack_require__(449);
            var HasValue = __webpack_require__(125);
            var Particle = __webpack_require__(445);
            var RandomZone = __webpack_require__(450);
            var Rectangle = __webpack_require__(10);
            var StableSort = __webpack_require__(79);
            var Vector2 = __webpack_require__(3);
            var Wrap = __webpack_require__(66);
            /**
 * @classdesc
 * A particle emitter represents a single particle stream.
 * It controls a pool of {@link Phaser.GameObjects.Particles.Particle Particles} and is controlled by a {@link Phaser.GameObjects.Particles.ParticleEmitterManager Particle Emitter Manager}.
 *
 * @class ParticleEmitter
 * @memberof Phaser.GameObjects.Particles
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Mask
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} manager - The Emitter Manager this Emitter belongs to.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
 */ var ParticleEmitter = new Class({
                Mixins: [
                    Components.BlendMode,
                    Components.Mask,
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function ParticleEmitter(manager, config) {
                    /**
         * The Emitter Manager this Emitter belongs to.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#manager
         * @type {Phaser.GameObjects.Particles.ParticleEmitterManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * The texture assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#texture
         * @type {Phaser.Textures.Texture}
         * @since 3.0.0
         */ this.texture = manager.texture;
                    /**
         * The texture frames assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frames
         * @type {Phaser.Textures.Frame[]}
         * @since 3.0.0
         */ this.frames = [
                        manager.defaultFrame
                    ];
                    /**
         * The default texture frame assigned to particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#defaultFrame
         * @type {Phaser.Textures.Frame}
         * @since 3.0.0
         */ this.defaultFrame = manager.defaultFrame;
                    /**
         * Names of simple configuration properties.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#configFastMap
         * @type {object}
         * @since 3.0.0
         */ this.configFastMap = [
                        'active',
                        'blendMode',
                        'collideBottom',
                        'collideLeft',
                        'collideRight',
                        'collideTop',
                        'deathCallback',
                        'deathCallbackScope',
                        'emitCallback',
                        'emitCallbackScope',
                        'follow',
                        'frequency',
                        'gravityX',
                        'gravityY',
                        'maxParticles',
                        'name',
                        'on',
                        'particleBringToTop',
                        'particleClass',
                        'radial',
                        'timeScale',
                        'trackVisible',
                        'visible'
                    ];
                    /**
         * Names of complex configuration properties.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#configOpMap
         * @type {object}
         * @since 3.0.0
         */ this.configOpMap = [
                        'accelerationX',
                        'accelerationY',
                        'angle',
                        'alpha',
                        'bounce',
                        'delay',
                        'lifespan',
                        'maxVelocityX',
                        'maxVelocityY',
                        'moveToX',
                        'moveToY',
                        'quantity',
                        'rotate',
                        'scaleX',
                        'scaleY',
                        'speedX',
                        'speedY',
                        'tint',
                        'x',
                        'y'
                    ];
                    /**
         * The name of this Particle Emitter.
         *
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                    /**
         * The Particle Class which will be emitted by this Emitter.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleClass
         * @type {Phaser.GameObjects.Particles.Particle}
         * @default Phaser.GameObjects.Particles.Particle
         * @since 3.0.0
         */ this.particleClass = Particle;
                    /**
         * The x-coordinate of the particle origin (where particles will be emitted).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#x
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
         */ this.x = new EmitterOp(config, 'x', 0, true);
                    /**
         * The y-coordinate of the particle origin (where particles will be emitted).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#y
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
         */ this.y = new EmitterOp(config, 'y', 0, true);
                    /**
         * A radial emitter will emit particles in all directions between angle min and max,
         * using {@link Phaser.GameObjects.Particles.ParticleEmitter#speed} as the value. If set to false then this acts as a point Emitter.
         * A point emitter will emit particles only in the direction derived from the speedX and speedY values.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#radial
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setRadial
         */ this.radial = true;
                    /**
         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityX
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityX = 0;
                    /**
         * Vertical acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityY
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
         */ this.gravityY = 0;
                    /**
         * Whether accelerationX and accelerationY are non-zero. Set automatically during configuration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#acceleration
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.acceleration = false;
                    /**
         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.accelerationX = new EmitterOp(config, 'accelerationX', 0, true);
                    /**
         * Vertical acceleration applied to emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.accelerationY = new EmitterOp(config, 'accelerationY', 0, true);
                    /**
         * The maximum horizontal velocity of emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityX = new EmitterOp(config, 'maxVelocityX', 10000, true);
                    /**
         * The maximum vertical velocity of emitted particles, in pixels per second squared.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 10000
         * @since 3.0.0
         */ this.maxVelocityY = new EmitterOp(config, 'maxVelocityY', 10000, true);
                    /**
         * The initial horizontal speed of emitted particles, in pixels per second.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
         */ this.speedX = new EmitterOp(config, 'speedX', 0, true);
                    /**
         * The initial vertical speed of emitted particles, in pixels per second.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
         */ this.speedY = new EmitterOp(config, 'speedY', 0, true);
                    /**
         * Whether moveToX and moveToY are nonzero. Set automatically during configuration.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveTo
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.moveTo = false;
                    /**
         * The x-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.moveToX = new EmitterOp(config, 'moveToX', 0, true);
                    /**
         * The y-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.moveToY = new EmitterOp(config, 'moveToY', 0, true);
                    /**
         * Whether particles will rebound when they meet the emitter bounds.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounce
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.bounce = new EmitterOp(config, 'bounce', 0, true);
                    /**
         * The horizontal scale of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleX
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
         */ this.scaleX = new EmitterOp(config, 'scaleX', 1);
                    /**
         * The vertical scale of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleY
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
         */ this.scaleY = new EmitterOp(config, 'scaleY', 1);
                    /**
         * Color tint applied to emitted particles. Value must not include the alpha channel.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#tint
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0xffffff
         * @since 3.0.0
         */ this.tint = new EmitterOp(config, 'tint', 0xffffff);
                    /**
         * The alpha (transparency) of emitted particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#alpha
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
         */ this.alpha = new EmitterOp(config, 'alpha', 1);
                    /**
         * The lifespan of emitted particles, in ms.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#lifespan
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1000
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
         */ this.lifespan = new EmitterOp(config, 'lifespan', 1000, true);
                    /**
         * The angle of the initial velocity of emitted particles, in degrees.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#angle
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default { min: 0, max: 360 }
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAngle
         */ this.angle = new EmitterOp(config, 'angle', {
                        min: 0,
                        max: 360
                    }, true);
                    /**
         * The rotation of emitted particles, in degrees.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#rotate
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.rotate = new EmitterOp(config, 'rotate', 0);
                    /**
         * A function to call when a particle is emitted.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleEmitterCallback}
         * @default null
         * @since 3.0.0
         */ this.emitCallback = null;
                    /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.emitCallbackScope = null;
                    /**
         * A function to call when a particle dies.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallback
         * @type {?Phaser.Types.GameObjects.Particles.ParticleDeathCallback}
         * @default null
         * @since 3.0.0
         */ this.deathCallback = null;
                    /**
         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallback}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope
         * @type {?*}
         * @default null
         * @since 3.0.0
         */ this.deathCallbackScope = null;
                    /**
         * Set to hard limit the amount of particle objects this emitter is allowed to create.
         * 0 means unlimited.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxParticles
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxParticles = 0;
                    /**
         * How many particles are emitted each time particles are emitted (one explosion or one flow cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#quantity
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
         */ this.quantity = new EmitterOp(config, 'quantity', 1, true);
                    /**
         * How many ms to wait after emission before the particles start updating.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#delay
         * @type {Phaser.GameObjects.Particles.EmitterOp}
         * @default 0
         * @since 3.0.0
         */ this.delay = new EmitterOp(config, 'delay', 0, true);
                    /**
         * For a flow emitter, the time interval (>= 0) between particle flow cycles in ms.
         * A value of 0 means there is one particle flow cycle for each logic update (the maximum flow frequency). This is the default setting.
         * For an exploding emitter, this value will be -1.
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} also puts the emitter in flow mode (frequency >= 0).
         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} also puts the emitter in explode mode (frequency = -1).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frequency
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
         */ this.frequency = 0;
                    /**
         * Controls if the emitter is currently emitting a particle flow (when frequency >= 0).
         * Already alive particles will continue to update until they expire.
         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#start} and {@link Phaser.GameObjects.Particles.ParticleEmitter#stop}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#on
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.on = true;
                    /**
         * Newly emitted particles are added to the top of the particle list, i.e. rendered above those already alive.
         * Set to false to send them to the back.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleBringToTop
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.particleBringToTop = true;
                    /**
         * The time rate applied to active particles, affecting lifespan, movement, and tweens. Values larger than 1 are faster than normal.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * An object describing a shape to emit particles from.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitZone
         * @type {?Phaser.GameObjects.Particles.Zones.EdgeZone|Phaser.GameObjects.Particles.Zones.RandomZone}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
         */ this.emitZone = null;
                    /**
         * An object describing a shape that deactivates particles when they interact with it.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathZone
         * @type {?Phaser.GameObjects.Particles.Zones.DeathZone}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
         */ this.deathZone = null;
                    /**
         * A rectangular boundary constraining particle movement.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounds
         * @type {?Phaser.Geom.Rectangle}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBounds
         */ this.bounds = null;
                    /**
         * Whether particles interact with the left edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideLeft
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideLeft = true;
                    /**
         * Whether particles interact with the right edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideRight
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideRight = true;
                    /**
         * Whether particles interact with the top edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideTop
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideTop = true;
                    /**
         * Whether particles interact with the bottom edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideBottom
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.collideBottom = true;
                    /**
         * Whether this emitter updates itself and its particles.
         *
         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#pause}
         * and {@link Phaser.GameObjects.Particles.ParticleEmitter#resume}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Set this to false to hide any active particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#visible
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setVisible
         */ this.visible = true;
                    /**
         * The blend mode of this emitter's particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#blendMode
         * @type {number}
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBlendMode
         */ this.blendMode = BlendModes.NORMAL;
                    /**
         * A Game Object whose position is used as the particle origin.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#follow
         * @type {?Phaser.GameObjects.GameObject}
         * @default null
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         * @see Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
         */ this.follow = null;
                    /**
         * The offset of the particle origin from the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#followOffset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.followOffset = new Vector2();
                    /**
         * Whether the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#visible} state will track
         * the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target's visibility state.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#trackVisible
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
         */ this.trackVisible = false;
                    /**
         * The current texture frame, as an index of {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#currentFrame
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.currentFrame = 0;
                    /**
         * Whether texture {@link Phaser.GameObjects.Particles.ParticleEmitter#frames} are selected at random.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#randomFrame
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.randomFrame = true;
                    /**
         * The number of consecutive particles that receive a single texture frame (per frame cycle).
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity
         * @type {number}
         * @default 1
         * @since 3.0.0
         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
         */ this.frameQuantity = 1;
                    /**
         * Inactive particles.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#dead
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.dead = [];
                    /**
         * Active particles
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#alive
         * @type {Phaser.GameObjects.Particles.Particle[]}
         * @private
         * @since 3.0.0
         */ this.alive = [];
                    /**
         * The time until the next flow cycle.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#_counter
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._counter = 0;
                    /**
         * Counts up to {@link Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity}.
         *
         * @name Phaser.GameObjects.Particles.ParticleEmitter#_frameCounter
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._frameCounter = 0;
                    if (config) this.fromJSON(config);
                },
                /**
     * Merges configuration settings into the emitter's current settings.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#fromJSON
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig} config - Settings for this emitter.
     *
     * @return {this} This Particle Emitter.
     */ fromJSON: function(config) {
                    if (!config) return this;
                    //  Only update properties from their current state if they exist in the given config
                    var i = 0;
                    var key = '';
                    for(i = 0; i < this.configFastMap.length; i++){
                        key = this.configFastMap[i];
                        if (HasValue(config, key)) this[key] = GetFastValue(config, key);
                    }
                    for(i = 0; i < this.configOpMap.length; i++){
                        key = this.configOpMap[i];
                        if (HasValue(config, key)) this[key].loadConfig(config);
                    }
                    this.acceleration = this.accelerationX.propertyValue !== 0 || this.accelerationY.propertyValue !== 0;
                    this.moveTo = this.moveToX.propertyValue !== 0 || this.moveToY.propertyValue !== 0;
                    //  Special 'speed' override
                    if (HasValue(config, 'speed')) {
                        this.speedX.loadConfig(config, 'speed');
                        this.speedY = null;
                    }
                    //  If you specify speedX, speedY or moveTo then it changes the emitter from radial to a point emitter
                    if (HasAny(config, [
                        'speedX',
                        'speedY'
                    ]) || this.moveTo) this.radial = false;
                    //  Special 'scale' override
                    if (HasValue(config, 'scale')) {
                        this.scaleX.loadConfig(config, 'scale');
                        this.scaleY = null;
                    }
                    if (HasValue(config, 'callbackScope')) {
                        var callbackScope = GetFastValue(config, 'callbackScope', null);
                        this.emitCallbackScope = callbackScope;
                        this.deathCallbackScope = callbackScope;
                    }
                    if (HasValue(config, 'emitZone')) this.setEmitZone(config.emitZone);
                    if (HasValue(config, 'deathZone')) this.setDeathZone(config.deathZone);
                    if (HasValue(config, 'bounds')) this.setBounds(config.bounds);
                    if (HasValue(config, 'followOffset')) this.followOffset.setFromObject(GetFastValue(config, 'followOffset', 0));
                    if (HasValue(config, 'frame')) this.setFrame(config.frame);
                    if (HasValue(config, 'reserve')) this.reserve(config.reserve);
                    return this;
                },
                /**
     * Creates a description of this emitter suitable for JSON serialization.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#toJSON
     * @since 3.0.0
     *
     * @param {object} [output] - An object to copy output into.
     *
     * @return {object} - The output object.
     */ toJSON: function(output) {
                    if (output === undefined) output = {};
                    var i = 0;
                    var key = '';
                    for(i = 0; i < this.configFastMap.length; i++){
                        key = this.configFastMap[i];
                        output[key] = this[key];
                    }
                    for(i = 0; i < this.configOpMap.length; i++){
                        key = this.configOpMap[i];
                        if (this[key]) output[key] = this[key].toJSON();
                    }
                    //  special handlers
                    if (!this.speedY) {
                        delete output.speedX;
                        output.speed = this.speedX.toJSON();
                    }
                    if (!this.scaleY) {
                        delete output.scaleX;
                        output.scale = this.scaleX.toJSON();
                    }
                    return output;
                },
                /**
     * Continuously moves the particle origin to follow a Game Object's position.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#startFollow
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} target - The Game Object to follow.
     * @param {number} [offsetX=0] - Horizontal offset of the particle origin from the Game Object.
     * @param {number} [offsetY=0] - Vertical offset of the particle origin from the Game Object.
     * @param {boolean} [trackVisible=false] - Whether the emitter's visible state will track the target's visible state.
     *
     * @return {this} This Particle Emitter.
     */ startFollow: function(target, offsetX, offsetY, trackVisible) {
                    if (offsetX === undefined) offsetX = 0;
                    if (offsetY === undefined) offsetY = 0;
                    if (trackVisible === undefined) trackVisible = false;
                    this.follow = target;
                    this.followOffset.set(offsetX, offsetY);
                    this.trackVisible = trackVisible;
                    return this;
                },
                /**
     * Stops following a Game Object.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ stopFollow: function() {
                    this.follow = null;
                    this.followOffset.set(0, 0);
                    this.trackVisible = false;
                    return this;
                },
                /**
     * Chooses a texture frame from {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getFrame
     * @since 3.0.0
     *
     * @return {Phaser.Textures.Frame} The texture frame.
     */ getFrame: function() {
                    if (this.frames.length === 1) return this.defaultFrame;
                    else if (this.randomFrame) return GetRandom(this.frames);
                    else {
                        var frame = this.frames[this.currentFrame];
                        this._frameCounter++;
                        if (this._frameCounter === this.frameQuantity) {
                            this._frameCounter = 0;
                            this.currentFrame = Wrap(this.currentFrame + 1, 0, this._frameLength);
                        }
                        return frame;
                    }
                },
                // frame: 0
                // frame: 'red'
                // frame: [ 0, 1, 2, 3 ]
                // frame: [ 'red', 'green', 'blue', 'pink', 'white' ]
                // frame: { frames: [ 'red', 'green', 'blue', 'pink', 'white' ], [cycle: bool], [quantity: int] }
                /**
     * Sets a pattern for assigning texture frames to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrame
     * @since 3.0.0
     *
     * @param {(array|string|number|Phaser.Types.GameObjects.Particles.ParticleEmitterFrameConfig)} frames - One or more texture frames, or a configuration object.
     * @param {boolean} [pickRandom=true] - Whether frames should be assigned at random from `frames`.
     * @param {number} [quantity=1] - The number of consecutive particles that will receive each frame.
     *
     * @return {this} This Particle Emitter.
     */ setFrame: function(frames, pickRandom, quantity) {
                    if (pickRandom === undefined) pickRandom = true;
                    if (quantity === undefined) quantity = 1;
                    this.randomFrame = pickRandom;
                    this.frameQuantity = quantity;
                    this.currentFrame = 0;
                    this._frameCounter = 0;
                    var t = typeof frames;
                    if (Array.isArray(frames) || t === 'string' || t === 'number') this.manager.setEmitterFrames(frames, this);
                    else if (t === 'object') {
                        var frameConfig = frames;
                        frames = GetFastValue(frameConfig, 'frames', null);
                        if (frames) this.manager.setEmitterFrames(frames, this);
                        var isCycle = GetFastValue(frameConfig, 'cycle', false);
                        this.randomFrame = isCycle ? false : true;
                        this.frameQuantity = GetFastValue(frameConfig, 'quantity', quantity);
                    }
                    this._frameLength = this.frames.length;
                    if (this._frameLength === 1) {
                        this.frameQuantity = 1;
                        this.randomFrame = false;
                    }
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle movement on or off.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setRadial
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Radial mode (true) or point mode (true).
     *
     * @return {this} This Particle Emitter.
     */ setRadial: function(value) {
                    if (value === undefined) value = true;
                    this.radial = value;
                    return this;
                },
                /**
     * Sets the position of the emitter's particle origin.
     * New particles will be emitted here.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setPosition
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} x - The x-coordinate of the particle origin.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} y - The y-coordinate of the particle origin.
     *
     * @return {this} This Particle Emitter.
     */ setPosition: function(x, y) {
                    this.x.onChange(x);
                    this.y.onChange(y);
                    return this;
                },
                /**
     * Sets or modifies a rectangular boundary constraining the particles.
     *
     * To remove the boundary, set {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds} to null.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setBounds
     * @since 3.0.0
     *
     * @param {(number|Phaser.Types.GameObjects.Particles.ParticleEmitterBounds|Phaser.Types.GameObjects.Particles.ParticleEmitterBoundsAlt)} x - The x-coordinate of the left edge of the boundary, or an object representing a rectangle.
     * @param {number} y - The y-coordinate of the top edge of the boundary.
     * @param {number} width - The width of the boundary.
     * @param {number} height - The height of the boundary.
     *
     * @return {this} This Particle Emitter.
     */ setBounds: function(x, y, width, height) {
                    if (typeof x === 'object') {
                        var obj = x;
                        x = obj.x;
                        y = obj.y;
                        width = HasValue(obj, 'w') ? obj.w : obj.width;
                        height = HasValue(obj, 'h') ? obj.h : obj.height;
                    }
                    if (this.bounds) this.bounds.setTo(x, y, width, height);
                    else this.bounds = new Rectangle(x, y, width, height);
                    return this;
                },
                /**
     * Sets the initial horizontal speed of emitted particles.
     * Changes the emitter to point mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeedX: function(value) {
                    this.speedX.onChange(value);
                    //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                    this.radial = false;
                    return this;
                },
                /**
     * Sets the initial vertical speed of emitted particles.
     * Changes the emitter to point mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeedY: function(value) {
                    if (this.speedY) {
                        this.speedY.onChange(value);
                        //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                        this.radial = false;
                    }
                    return this;
                },
                /**
     * Sets the initial radial speed of emitted particles.
     * Changes the emitter to radial mode.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeed
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The speed, in pixels per second.
     *
     * @return {this} This Particle Emitter.
     */ setSpeed: function(value) {
                    this.speedX.onChange(value);
                    this.speedY = null;
                    //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
                    this.radial = true;
                    return this;
                },
                /**
     * Sets the horizontal scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScaleX: function(value) {
                    this.scaleX.onChange(value);
                    return this;
                },
                /**
     * Sets the vertical scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScaleY: function(value) {
                    this.scaleY.onChange(value);
                    return this;
                },
                /**
     * Sets the scale of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScale
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - The scale, relative to 1.
     *
     * @return {this} This Particle Emitter.
     */ setScale: function(value) {
                    this.scaleX.onChange(value);
                    this.scaleY = null;
                    return this;
                },
                /**
     * Sets the horizontal gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityX
     * @since 3.0.0
     *
     * @param {number} value - Acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravityX: function(value) {
                    this.gravityX = value;
                    return this;
                },
                /**
     * Sets the vertical gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityY
     * @since 3.0.0
     *
     * @param {number} value - Acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravityY: function(value) {
                    this.gravityY = value;
                    return this;
                },
                /**
     * Sets the gravity applied to emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravity
     * @since 3.0.0
     *
     * @param {number} x - Horizontal acceleration due to gravity, in pixels per second squared.
     * @param {number} y - Vertical acceleration due to gravity, in pixels per second squared.
     *
     * @return {this} This Particle Emitter.
     */ setGravity: function(x, y) {
                    this.gravityX = x;
                    this.gravityY = y;
                    return this;
                },
                /**
     * Sets the opacity of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
     * @since 3.0.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 (transparent) and 1 (opaque).
     *
     * @return {this} This Particle Emitter.
     */ setAlpha: function(value) {
                    this.alpha.onChange(value);
                    return this;
                },
                /**
     * Sets the color tint of emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setTint
     * @since 3.22.0
     *
     * @param {(Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType|Phaser.Types.GameObjects.Particles.EmitterOpOnUpdateType)} value - A value between 0 and 0xffffff.
     *
     * @return {this} This Particle Emitter.
     */ setTint: function(value) {
                    this.tint.onChange(value);
                    return this;
                },
                /**
     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitterAngle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The angle of the initial velocity of emitted particles.
     *
     * @return {this} This Particle Emitter.
     */ setEmitterAngle: function(value) {
                    this.angle.onChange(value);
                    return this;
                },
                /**
     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAngle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The angle of the initial velocity of emitted particles.
     *
     * @return {this} This Particle Emitter.
     */ setAngle: function(value) {
                    this.angle.onChange(value);
                    return this;
                },
                /**
     * Sets the lifespan of newly emitted particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} value - The particle lifespan, in ms.
     *
     * @return {this} This Particle Emitter.
     */ setLifespan: function(value) {
                    this.lifespan.onChange(value);
                    return this;
                },
                /**
     * Sets the number of particles released at each flow cycle or explosion.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} quantity - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setQuantity: function(quantity) {
                    this.quantity.onChange(quantity);
                    return this;
                },
                /**
     * Sets the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#frequency}
     * and {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms; or -1 to put the emitter in explosion mode.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [quantity] - The number of particles to release at each flow cycle or explosion.
     *
     * @return {this} This Particle Emitter.
     */ setFrequency: function(frequency, quantity) {
                    this.frequency = frequency;
                    this._counter = 0;
                    if (quantity) this.quantity.onChange(quantity);
                    return this;
                },
                /**
     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#emitZone}.
     *
     * An {@link Phaser.Types.GameObjects.Particles.ParticleEmitterEdgeZoneConfig EdgeZone} places particles on its edges. Its {@link Phaser.Types.GameObjects.Particles.EdgeZoneSource source} can be a Curve, Path, Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link Phaser.Types.GameObjects.Particles.EdgeZoneSourceCallback getPoints} method.
     *
     * A {@link Phaser.Types.GameObjects.Particles.ParticleEmitterRandomZoneConfig RandomZone} places randomly within its interior. Its {@link RandomZoneSource source} can be a Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link Phaser.Types.GameObjects.Particles.RandomZoneSourceCallback getRandomPoint} method.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterEdgeZoneConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterRandomZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current emit zone.
     *
     * @return {this} This Particle Emitter.
     */ setEmitZone: function(zoneConfig) {
                    if (zoneConfig === undefined) this.emitZone = null;
                    else {
                        //  Where source = Geom like Circle, or a Path or Curve
                        //  emitZone: { type: 'random', source: X }
                        //  emitZone: { type: 'edge', source: X, quantity: 32, [stepRate=0], [yoyo=false], [seamless=true] }
                        var type = GetFastValue(zoneConfig, 'type', 'random');
                        var source = GetFastValue(zoneConfig, 'source', null);
                        switch(type){
                            case 'random':
                                this.emitZone = new RandomZone(source);
                                break;
                            case 'edge':
                                var quantity = GetFastValue(zoneConfig, 'quantity', 1);
                                var stepRate = GetFastValue(zoneConfig, 'stepRate', 0);
                                var yoyo = GetFastValue(zoneConfig, 'yoyo', false);
                                var seamless = GetFastValue(zoneConfig, 'seamless', true);
                                this.emitZone = new EdgeZone(source, quantity, stepRate, yoyo, seamless);
                                break;
                        }
                    }
                    return this;
                },
                /**
     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#deathZone}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterDeathZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current death zone.
     *
     * @return {this} This Particle Emitter.
     */ setDeathZone: function(zoneConfig) {
                    if (zoneConfig === undefined) this.deathZone = null;
                    else {
                        //  Where source = Geom like Circle or Rect that supports a 'contains' function
                        //  deathZone: { type: 'onEnter', source: X }
                        //  deathZone: { type: 'onLeave', source: X }
                        var type = GetFastValue(zoneConfig, 'type', 'onEnter');
                        var source = GetFastValue(zoneConfig, 'source', null);
                        if (source && typeof source.contains === 'function') {
                            var killOnEnter = type === 'onEnter' ? true : false;
                            this.deathZone = new DeathZone(source, killOnEnter);
                        }
                    }
                    return this;
                },
                /**
     * Creates inactive particles and adds them to this emitter's pool.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#reserve
     * @since 3.0.0
     *
     * @param {number} particleCount - The number of particles to create.
     *
     * @return {this} This Particle Emitter.
     */ reserve: function(particleCount) {
                    var dead = this.dead;
                    for(var i = 0; i < particleCount; i++)dead.push(new this.particleClass(this));
                    return this;
                },
                /**
     * Gets the number of active (in-use) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getAliveParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=true`.
     */ getAliveParticleCount: function() {
                    return this.alive.length;
                },
                /**
     * Gets the number of inactive (available) particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getDeadParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles with `active=false`.
     */ getDeadParticleCount: function() {
                    return this.dead.length;
                },
                /**
     * Gets the total number of particles in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#getParticleCount
     * @since 3.0.0
     *
     * @return {number} The number of particles, including both alive and dead.
     */ getParticleCount: function() {
                    return this.getAliveParticleCount() + this.getDeadParticleCount();
                },
                /**
     * Whether this emitter is at its limit (if set).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#atLimit
     * @since 3.0.0
     *
     * @return {boolean} Returns `true` if this Emitter is at its limit, or `false` if no limit, or below the `maxParticles` level.
     */ atLimit: function() {
                    return this.maxParticles > 0 && this.getParticleCount() === this.maxParticles;
                },
                /**
     * Sets a function to call for each newly emitted particle.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleEmit
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} [context] - The calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleEmit: function(callback, context) {
                    if (callback === undefined) {
                        //  Clear any previously set callback
                        this.emitCallback = null;
                        this.emitCallbackScope = null;
                    } else if (typeof callback === 'function') {
                        this.emitCallback = callback;
                        if (context) this.emitCallbackScope = context;
                    }
                    return this;
                },
                /**
     * Sets a function to call for each particle death.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleDeath
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleDeathCallback} callback - The function.
     * @param {*} [context] - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ onParticleDeath: function(callback, context) {
                    if (callback === undefined) {
                        //  Clear any previously set callback
                        this.deathCallback = null;
                        this.deathCallbackScope = null;
                    } else if (typeof callback === 'function') {
                        this.deathCallback = callback;
                        if (context) this.deathCallbackScope = context;
                    }
                    return this;
                },
                /**
     * Deactivates every particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#killAll
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ killAll: function() {
                    var dead = this.dead;
                    var alive = this.alive;
                    while(alive.length > 0)dead.push(alive.pop());
                    return this;
                },
                /**
     * Calls a function for each active particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachAlive
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachAlive: function(callback, context) {
                    var alive = this.alive;
                    var length = alive.length;
                    for(var index = 0; index < length; ++index)//  Sends the Particle and the Emitter
                    callback.call(context, alive[index], this);
                    return this;
                },
                /**
     * Calls a function for each inactive particle in this emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachDead
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterCallback} callback - The function.
     * @param {*} context - The function's calling context.
     *
     * @return {this} This Particle Emitter.
     */ forEachDead: function(callback, context) {
                    var dead = this.dead;
                    var length = dead.length;
                    for(var index = 0; index < length; ++index)//  Sends the Particle and the Emitter
                    callback.call(context, dead[index], this);
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on} the emitter and resets the flow counter.
     *
     * If this emitter is in flow mode (frequency >= 0; the default), the particle flow will start (or restart).
     *
     * If this emitter is in explode mode (frequency = -1), nothing will happen.
     * Use {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} or {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#start
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ start: function() {
                    this.on = true;
                    this._counter = 0;
                    return this;
                },
                /**
     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on off} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#stop
     * @since 3.11.0
     *
     * @return {this} This Particle Emitter.
     */ stop: function() {
                    this.on = false;
                    return this;
                },
                /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Deactivates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#pause
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ pause: function() {
                    this.active = false;
                    return this;
                },
                /**
     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Activates} the emitter.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#resume
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ resume: function() {
                    this.active = true;
                    return this;
                },
                /**
     * Removes the emitter from its manager and the scene.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#remove
     * @since 3.22.0
     *
     * @return {this} This Particle Emitter.
     */ remove: function() {
                    this.manager.removeEmitter(this);
                    return this;
                },
                /**
     * Sorts active particles with {@link Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback}.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSort
     * @since 3.0.0
     *
     * @return {this} This Particle Emitter.
     */ depthSort: function() {
                    StableSort(this.alive, this.depthSortCallback);
                    return this;
                },
                /**
     * Puts the emitter in flow mode (frequency >= 0) and starts (or restarts) a particle flow.
     *
     * To resume a flow at the current frequency and quantity, use {@link Phaser.GameObjects.Particles.ParticleEmitter#start} instead.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#flow
     * @since 3.0.0
     *
     * @param {number} frequency - The time interval (>= 0) of each flow cycle, in ms.
     * @param {Phaser.Types.GameObjects.Particles.EmitterOpOnEmitType} [count=1] - The number of particles to emit at each flow cycle.
     *
     * @return {this} This Particle Emitter.
     */ flow: function(frequency, count) {
                    if (count === undefined) count = 1;
                    this.frequency = frequency;
                    this.quantity.onChange(count);
                    return this.start();
                },
                /**
     * Puts the emitter in explode mode (frequency = -1), stopping any current particle flow, and emits several particles all at once.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#explode
     * @since 3.0.0
     *
     * @param {number} count - The amount of Particles to emit.
     * @param {number} x - The x coordinate to emit the Particles from.
     * @param {number} y - The y coordinate to emit the Particles from.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     */ explode: function(count, x, y) {
                    this.frequency = -1;
                    return this.emitParticle(count, x, y);
                },
                /**
     * Emits particles at a given position (or the emitter's current position).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticleAt
     * @since 3.0.0
     *
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     */ emitParticleAt: function(x, y, count) {
                    return this.emitParticle(count, x, y);
                },
                /**
     * Emits particles at a given position (or the emitter's current position).
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticle
     * @since 3.0.0
     *
     * @param {number} [count=this.quantity] - The number of Particles to emit.
     * @param {number} [x=this.x] - The x coordinate to emit the Particles from.
     * @param {number} [y=this.x] - The y coordinate to emit the Particles from.
     *
     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
     *
     * @see Phaser.GameObjects.Particles.Particle#fire
     */ emitParticle: function(count, x, y) {
                    if (this.atLimit()) return;
                    if (count === undefined) count = this.quantity.onEmit();
                    var dead = this.dead;
                    var followX = this.follow ? this.follow.x + this.followOffset.x : x;
                    var followY = this.follow ? this.follow.y + this.followOffset.y : y;
                    for(var i = 0; i < count; i++){
                        var particle = dead.pop();
                        if (!particle) particle = new this.particleClass(this);
                        particle.fire(followX, followY);
                        if (this.particleBringToTop) this.alive.push(particle);
                        else this.alive.unshift(particle);
                        if (this.emitCallback) this.emitCallback.call(this.emitCallbackScope, particle, this);
                        if (this.atLimit()) break;
                    }
                    return particle;
                },
                /**
     * Updates this emitter and its particles.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    //  Scale the delta
                    delta *= this.timeScale;
                    var step = delta / 1000;
                    if (this.trackVisible) this.visible = this.follow.visible;
                    //  Any particle processors?
                    var processors = this.manager.getProcessors();
                    var particles = this.alive;
                    var dead = this.dead;
                    var i = 0;
                    var rip = [];
                    var length = particles.length;
                    for(i = 0; i < length; i++){
                        var particle = particles[i];
                        //  update returns `true` if the particle is now dead (lifeCurrent <= 0)
                        if (particle.update(delta, step, processors)) rip.push({
                            index: i,
                            particle: particle
                        });
                    }
                    //  Move dead particles to the dead array
                    length = rip.length;
                    if (length > 0) {
                        var deathCallback = this.deathCallback;
                        var deathCallbackScope = this.deathCallbackScope;
                        for(i = length - 1; i >= 0; i--){
                            var entry = rip[i];
                            //  Remove from particles array
                            particles.splice(entry.index, 1);
                            //  Add to dead array
                            dead.push(entry.particle);
                            //  Callback
                            if (deathCallback) deathCallback.call(deathCallbackScope, entry.particle);
                            entry.particle.resetPosition();
                        }
                    }
                    if (!this.on) return;
                    if (this.frequency === 0) this.emitParticle();
                    else if (this.frequency > 0) {
                        this._counter -= delta;
                        if (this._counter <= 0) {
                            this.emitParticle();
                            //  counter = frequency - remained from previous delta
                            this._counter = this.frequency - Math.abs(this._counter);
                        }
                    }
                },
                /**
     * Calculates the difference of two particles, for sorting them by depth.
     *
     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback
     * @since 3.0.0
     *
     * @param {object} a - The first particle.
     * @param {object} b - The second particle.
     *
     * @return {number} The difference of a and b's y coordinates.
     */ depthSortCallback: function(a, b) {
                    return a.y - b.y;
                }
            });
            module1.exports = ParticleEmitter;
        /***/ },
        /* 447 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Death Zone.
 *
 * A Death Zone is a special type of zone that will kill a Particle as soon as it either enters, or leaves, the zone.
 *
 * The zone consists of a `source` which could be a Geometric shape, such as a Rectangle or Ellipse, or your own
 * object as long as it includes a `contains` method for which the Particles can be tested against.
 *
 * @class DeathZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.DeathZoneSource} source - An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
 * @param {boolean} killOnEnter - Should the Particle be killed when it enters the zone? `true` or leaves it? `false`
 */ var DeathZone = new Class({
                initialize: function DeathZone(source, killOnEnter) {
                    /**
         * An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
         * This could be a Geometry shape, such as `Phaser.Geom.Circle`, or your own custom object.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#source
         * @type {Phaser.Types.GameObjects.Particles.DeathZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * Set to `true` if the Particle should be killed if it enters this zone.
         * Set to `false` to kill the Particle if it leaves this zone.
         *
         * @name Phaser.GameObjects.Particles.Zones.DeathZone#killOnEnter
         * @type {boolean}
         * @since 3.0.0
         */ this.killOnEnter = killOnEnter;
                },
                /**
     * Checks if the given Particle will be killed or not by this zone.
     *
     * @method Phaser.GameObjects.Particles.Zones.DeathZone#willKill
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to be checked against this zone.
     *
     * @return {boolean} Return `true` if the Particle is to be killed, otherwise return `false`.
     */ willKill: function(particle) {
                    var withinZone = this.source.contains(particle.x, particle.y);
                    return withinZone && this.killOnEnter || !withinZone && !this.killOnEnter;
                }
            });
            module1.exports = DeathZone;
        /***/ },
        /* 448 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A zone that places particles on a shape's edges.
 *
 * @class EdgeZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
 * @param {number} quantity - The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
 * @param {number} stepRate - The distance between each particle. When set, `quantity` is implied and should be set to 0.
 * @param {boolean} [yoyo=false] - Whether particles are placed from start to end and then end to start.
 * @param {boolean} [seamless=true] - Whether one endpoint will be removed if it's identical to the other.
 */ var EdgeZone = new Class({
                initialize: function EdgeZone(source, quantity, stepRate, yoyo, seamless) {
                    if (yoyo === undefined) yoyo = false;
                    if (seamless === undefined) seamless = true;
                    /**
         * An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#source
         * @type {Phaser.Types.GameObjects.Particles.EdgeZoneSource|Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * The points placed on the source edge.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#points
         * @type {Phaser.Geom.Point[]}
         * @default []
         * @since 3.0.0
         */ this.points = [];
                    /**
         * The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#quantity
         * @type {number}
         * @since 3.0.0
         */ this.quantity = quantity;
                    /**
         * The distance between each particle. When set, `quantity` is implied and should be set to 0.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#stepRate
         * @type {number}
         * @since 3.0.0
         */ this.stepRate = stepRate;
                    /**
         * Whether particles are placed from start to end and then end to start.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#yoyo
         * @type {boolean}
         * @since 3.0.0
         */ this.yoyo = yoyo;
                    /**
         * The counter used for iterating the EdgeZone's points.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#counter
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.counter = -1;
                    /**
         * Whether one endpoint will be removed if it's identical to the other.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#seamless
         * @type {boolean}
         * @since 3.0.0
         */ this.seamless = seamless;
                    /**
         * An internal count of the points belonging to this EdgeZone.
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_length
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._length = 0;
                    /**
         * An internal value used to keep track of the current iteration direction for the EdgeZone's points.
         *
         * 0 = forwards, 1 = backwards
         *
         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_direction
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._direction = 0;
                    this.updateSource();
                },
                /**
     * Update the {@link Phaser.GameObjects.Particles.Zones.EdgeZone#points} from the EdgeZone's
     * {@link Phaser.GameObjects.Particles.Zones.EdgeZone#source}.
     *
     * Also updates internal properties.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#updateSource
     * @since 3.0.0
     *
     * @return {this} This Edge Zone.
     */ updateSource: function() {
                    this.points = this.source.getPoints(this.quantity, this.stepRate);
                    //  Remove ends?
                    if (this.seamless) {
                        var a = this.points[0];
                        var b = this.points[this.points.length - 1];
                        if (a.x === b.x && a.y === b.y) this.points.pop();
                    }
                    var oldLength = this._length;
                    this._length = this.points.length;
                    //  Adjust counter if we now have less points than before
                    if (this._length < oldLength && this.counter > this._length) this.counter = this._length - 1;
                    return this;
                },
                /**
     * Change the source of the EdgeZone.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#changeSource
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Particles.EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
     *
     * @return {this} This Edge Zone.
     */ changeSource: function(source) {
                    this.source = source;
                    return this.updateSource();
                },
                /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                    if (this._direction === 0) {
                        this.counter++;
                        if (this.counter >= this._length) {
                            if (this.yoyo) {
                                this._direction = 1;
                                this.counter = this._length - 1;
                            } else this.counter = 0;
                        }
                    } else {
                        this.counter--;
                        if (this.counter === -1) {
                            if (this.yoyo) {
                                this._direction = 0;
                                this.counter = 0;
                            } else this.counter = this._length - 1;
                        }
                    }
                    var point = this.points[this.counter];
                    if (point) {
                        particle.x = point.x;
                        particle.y = point.y;
                    }
                }
            });
            module1.exports = EdgeZone;
        /***/ },
        /* 449 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains at least one of the requested keys
 *
 * @function Phaser.Utils.Objects.HasAny
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to search the object for
 *
 * @return {boolean} true if the source object contains at least one of the keys, false otherwise
 */ var HasAny = function(source, keys) {
                for(var i = 0; i < keys.length; i++){
                    if (source.hasOwnProperty(keys[i])) return true;
                }
                return false;
            };
            module1.exports = HasAny;
        /***/ },
        /* 450 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A zone that places particles randomly within a shapes area.
 *
 * @class RandomZone
 * @memberof Phaser.GameObjects.Particles.Zones
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Particles.RandomZoneSource} source - An object instance with a `getRandomPoint(point)` method.
 */ var RandomZone = new Class({
                initialize: function RandomZone(source) {
                    /**
         * An object instance with a `getRandomPoint(point)` method.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#source
         * @type {Phaser.Types.GameObjects.Particles.RandomZoneSource}
         * @since 3.0.0
         */ this.source = source;
                    /**
         * Internal calculation vector.
         *
         * @name Phaser.GameObjects.Particles.Zones.RandomZone#_tempVec
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec = new Vector2();
                },
                /**
     * Get the next point in the Zone and set its coordinates on the given Particle.
     *
     * @method Phaser.GameObjects.Particles.Zones.RandomZone#getPoint
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle.
     */ getPoint: function(particle) {
                    var vec = this._tempVec;
                    this.source.getRandomPoint(vec);
                    particle.x = vec.x;
                    particle.y = vec.y;
                }
            });
            module1.exports = RandomZone;
        /***/ },
        /* 451 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var Sprite = __webpack_require__(73);
            /**
 * @classdesc
 * A PathFollower Game Object.
 *
 * A PathFollower is a Sprite Game Object with some extra helpers to allow it to follow a Path automatically.
 *
 * Anything you can do with a standard Sprite can be done with this PathFollower, such as animate it, tint it,
 * scale it and so on.
 *
 * PathFollowers are bound to a single Path at any one time and can traverse the length of the Path, from start
 * to finish, forwards or backwards, or from any given point on the Path to its end. They can optionally rotate
 * to face the direction of the path, be offset from the path coordinates or rotate independently of the Path.
 *
 * @class PathFollower
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.PathFollower
 *
 * @param {Phaser.Scene} scene - The Scene to which this PathFollower belongs.
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var PathFollower = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.PathFollower
                ],
                initialize: function PathFollower(scene, path, x, y, texture, frame) {
                    Sprite.call(this, scene, x, y, texture, frame);
                    this.path = path;
                },
                /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.PathFollower#preUpdate
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ preUpdate: function(time, delta) {
                    this.anims.update(time, delta);
                    this.pathUpdate(time);
                }
            });
            module1.exports = PathFollower;
        /***/ },
        /* 452 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns an object containing dimensions of the Text object.
 *
 * @function Phaser.GameObjects.GetTextSize
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object to calculate the size from.
 * @param {Phaser.Types.GameObjects.Text.TextMetrics} size - The Text metrics to use when calculating the size.
 * @param {string[]} lines - The lines of text to calculate the size from.
 *
 * @return {Phaser.Types.GameObjects.Text.GetTextSizeObject} An object containing dimensions of the Text object.
 */ var GetTextSize = function(text, size, lines) {
                var canvas = text.canvas;
                var context = text.context;
                var style = text.style;
                var lineWidths = [];
                var maxLineWidth = 0;
                var drawnLines = lines.length;
                if (style.maxLines > 0 && style.maxLines < lines.length) drawnLines = style.maxLines;
                style.syncFont(canvas, context);
                //  Text Width
                for(var i = 0; i < drawnLines; i++){
                    var lineWidth = style.strokeThickness;
                    lineWidth += context.measureText(lines[i]).width;
                    // Adjust for wrapped text
                    if (style.wordWrap) lineWidth -= context.measureText(' ').width;
                    lineWidths[i] = Math.ceil(lineWidth);
                    maxLineWidth = Math.max(maxLineWidth, lineWidths[i]);
                }
                //  Text Height
                var lineHeight = size.fontSize + style.strokeThickness;
                var height = lineHeight * drawnLines;
                var lineSpacing = text.lineSpacing;
                //  Adjust for line spacing
                if (drawnLines > 1) height += lineSpacing * (drawnLines - 1);
                return {
                    width: maxLineWidth,
                    height: height,
                    lines: drawnLines,
                    lineWidths: lineWidths,
                    lineSpacing: lineSpacing,
                    lineHeight: lineHeight
                };
            };
            module1.exports = GetTextSize;
        /***/ },
        /* 453 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var MeasureText = __webpack_require__(454);
            //  Key: [ Object Key, Default Value ]
            var propertyMap = {
                fontFamily: [
                    'fontFamily',
                    'Courier'
                ],
                fontSize: [
                    'fontSize',
                    '16px'
                ],
                fontStyle: [
                    'fontStyle',
                    ''
                ],
                backgroundColor: [
                    'backgroundColor',
                    null
                ],
                color: [
                    'color',
                    '#fff'
                ],
                stroke: [
                    'stroke',
                    '#fff'
                ],
                strokeThickness: [
                    'strokeThickness',
                    0
                ],
                shadowOffsetX: [
                    'shadow.offsetX',
                    0
                ],
                shadowOffsetY: [
                    'shadow.offsetY',
                    0
                ],
                shadowColor: [
                    'shadow.color',
                    '#000'
                ],
                shadowBlur: [
                    'shadow.blur',
                    0
                ],
                shadowStroke: [
                    'shadow.stroke',
                    false
                ],
                shadowFill: [
                    'shadow.fill',
                    false
                ],
                align: [
                    'align',
                    'left'
                ],
                maxLines: [
                    'maxLines',
                    0
                ],
                fixedWidth: [
                    'fixedWidth',
                    0
                ],
                fixedHeight: [
                    'fixedHeight',
                    0
                ],
                resolution: [
                    'resolution',
                    0
                ],
                rtl: [
                    'rtl',
                    false
                ],
                testString: [
                    'testString',
                    "|M\xc3\u2030qgy"
                ],
                baselineX: [
                    'baselineX',
                    1.2
                ],
                baselineY: [
                    'baselineY',
                    1.4
                ],
                wordWrapWidth: [
                    'wordWrap.width',
                    null
                ],
                wordWrapCallback: [
                    'wordWrap.callback',
                    null
                ],
                wordWrapCallbackScope: [
                    'wordWrap.callbackScope',
                    null
                ],
                wordWrapUseAdvanced: [
                    'wordWrap.useAdvancedWrap',
                    false
                ]
            };
            /**
 * @classdesc
 * A TextStyle class manages all of the style settings for a Text object.
 *
 * Text Game Objects create a TextStyle instance automatically, which is
 * accessed via the `Text.style` property. You do not normally need to
 * instantiate one yourself.
 *
 * @class TextStyle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Text} text - The Text object that this TextStyle is styling.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
 */ var TextStyle = new Class({
                initialize: function TextStyle(text, style) {
                    /**
         * The Text object that this TextStyle is styling.
         *
         * @name Phaser.GameObjects.TextStyle#parent
         * @type {Phaser.GameObjects.Text}
         * @since 3.0.0
         */ this.parent = text;
                    /**
         * The font family.
         *
         * @name Phaser.GameObjects.TextStyle#fontFamily
         * @type {string}
         * @default 'Courier'
         * @since 3.0.0
         */ this.fontFamily;
                    /**
         * The font size.
         *
         * @name Phaser.GameObjects.TextStyle#fontSize
         * @type {string}
         * @default '16px'
         * @since 3.0.0
         */ this.fontSize;
                    /**
         * The font style.
         *
         * @name Phaser.GameObjects.TextStyle#fontStyle
         * @type {string}
         * @since 3.0.0
         */ this.fontStyle;
                    /**
         * The background color.
         *
         * @name Phaser.GameObjects.TextStyle#backgroundColor
         * @type {string}
         * @since 3.0.0
         */ this.backgroundColor;
                    /**
         * The text fill color.
         *
         * @name Phaser.GameObjects.TextStyle#color
         * @type {string}
         * @default '#fff'
         * @since 3.0.0
         */ this.color;
                    /**
         * The text stroke color.
         *
         * @name Phaser.GameObjects.TextStyle#stroke
         * @type {string}
         * @default '#fff'
         * @since 3.0.0
         */ this.stroke;
                    /**
         * The text stroke thickness.
         *
         * @name Phaser.GameObjects.TextStyle#strokeThickness
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.strokeThickness;
                    /**
         * The horizontal shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetX;
                    /**
         * The vertical shadow offset.
         *
         * @name Phaser.GameObjects.TextStyle#shadowOffsetY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowOffsetY;
                    /**
         * The shadow color.
         *
         * @name Phaser.GameObjects.TextStyle#shadowColor
         * @type {string}
         * @default '#000'
         * @since 3.0.0
         */ this.shadowColor;
                    /**
         * The shadow blur radius.
         *
         * @name Phaser.GameObjects.TextStyle#shadowBlur
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.shadowBlur;
                    /**
         * Whether shadow stroke is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowStroke
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowStroke;
                    /**
         * Whether shadow fill is enabled or not.
         *
         * @name Phaser.GameObjects.TextStyle#shadowFill
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shadowFill;
                    /**
         * The text alignment.
         *
         * @name Phaser.GameObjects.TextStyle#align
         * @type {string}
         * @default 'left'
         * @since 3.0.0
         */ this.align;
                    /**
         * The maximum number of lines to draw.
         *
         * @name Phaser.GameObjects.TextStyle#maxLines
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxLines;
                    /**
         * The fixed width of the text.
         *
         * `0` means no fixed with.
         *
         * @name Phaser.GameObjects.TextStyle#fixedWidth
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedWidth;
                    /**
         * The fixed height of the text.
         *
         * `0` means no fixed height.
         *
         * @name Phaser.GameObjects.TextStyle#fixedHeight
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.fixedHeight;
                    /**
         * The resolution the text is rendered to its internal canvas at.
         * The default is 0, which means it will use the resolution set in the Game Config.
         *
         * @name Phaser.GameObjects.TextStyle#resolution
         * @type {number}
         * @default 0
         * @since 3.12.0
         */ this.resolution;
                    /**
         * Whether the text should render right to left.
         *
         * @name Phaser.GameObjects.TextStyle#rtl
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.rtl;
                    /**
         * The test string to use when measuring the font.
         *
         * @name Phaser.GameObjects.TextStyle#testString
         * @type {string}
         * @default '|MÉqgy'
         * @since 3.0.0
         */ this.testString;
                    /**
         * The amount of horizontal padding added to the width of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineX
         * @type {number}
         * @default 1.2
         * @since 3.3.0
         */ this.baselineX;
                    /**
         * The amount of vertical padding added to the height of the text when calculating the font metrics.
         *
         * @name Phaser.GameObjects.TextStyle#baselineY
         * @type {number}
         * @default 1.4
         * @since 3.3.0
         */ this.baselineY;
                    /**
         * The maximum width of a line of text in pixels. Null means no line wrapping. Setting this
         * property directly will not re-run the word wrapping algorithm. To change the width and
         * re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapWidth
         * @type {number | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapWidth;
                    /**
         * A custom function that will be responsible for wrapping the text. It will receive two
         * arguments: text (the string to wrap), textObject (this Text instance). It should return
         * the wrapped lines either as an array of lines or as a string with newline characters in
         * place to indicate where breaks should happen. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallback
         * @type {TextStyleWordWrapCallback | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallback;
                    /**
         * The scope that will be applied when the wordWrapCallback is invoked. Setting this directly will not re-run the
         * word wrapping algorithm. To change the callback and re-wrap, use
         * {@link Phaser.GameObjects.TextStyle#setWordWrapCallback}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapCallbackScope
         * @type {object | null}
         * @default null
         * @since 3.24.0
         */ this.wordWrapCallbackScope;
                    /**
         * Whether or not to use the advanced wrapping algorithm. If true, spaces are collapsed and
         * whitespace is trimmed from lines. If false, spaces and whitespace are left as is. Setting
         * this property directly will not re-run the word wrapping algorithm. To change the
         * advanced setting and re-wrap, use {@link Phaser.GameObjects.TextStyle#setWordWrapWidth}.
         *
         * @name Phaser.GameObjects.TextStyle#wordWrapUseAdvanced
         * @type {boolean}
         * @default false
         * @since 3.24.0
         */ this.wordWrapUseAdvanced;
                    /**
         * The font style, size and family.
         *
         * @name Phaser.GameObjects.TextStyle#_font
         * @type {string}
         * @private
         * @since 3.0.0
         */ this._font;
                    //  Set to defaults + user style
                    this.setStyle(style, false, true);
                    var metrics = GetValue(style, 'metrics', false);
                    //  Provide optional TextMetrics in the style object to avoid the canvas look-up / scanning
                    //  Doing this is reset if you then change the font of this TextStyle after creation
                    if (metrics) this.metrics = {
                        ascent: GetValue(metrics, 'ascent', 0),
                        descent: GetValue(metrics, 'descent', 0),
                        fontSize: GetValue(metrics, 'fontSize', 0)
                    };
                    else this.metrics = MeasureText(this);
                },
                /**
     * Set the text style.
     *
     * @example
     * text.setStyle({
     *     fontSize: '64px',
     *     fontFamily: 'Arial',
     *     color: '#ffffff',
     *     align: 'center',
     *     backgroundColor: '#ff00ff'
     * });
     *
     * @method Phaser.GameObjects.TextStyle#setStyle
     * @since 3.0.0
     *
     * @param {Phaser.Types.GameObjects.Text.TextStyle} style - The style settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     * @param {boolean} [setDefaults=false] - Use the default values is not set, or the local values.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStyle: function(style, updateText, setDefaults) {
                    if (updateText === undefined) updateText = true;
                    if (setDefaults === undefined) setDefaults = false;
                    //  Avoid type mutation
                    // eslint-disable-next-line no-prototype-builtins
                    if (style && style.hasOwnProperty('fontSize') && typeof style.fontSize === 'number') style.fontSize = style.fontSize.toString() + 'px';
                    for(var key in propertyMap){
                        var value = setDefaults ? propertyMap[key][1] : this[key];
                        if (key === 'wordWrapCallback' || key === 'wordWrapCallbackScope') // Callback & scope should be set without processing the values
                        this[key] = GetValue(style, propertyMap[key][0], value);
                        else this[key] = GetAdvancedValue(style, propertyMap[key][0], value);
                    }
                    //  Allow for 'font' override
                    var font = GetValue(style, 'font', null);
                    if (font !== null) this.setFont(font, false);
                    this._font = [
                        this.fontStyle,
                        this.fontSize,
                        this.fontFamily
                    ].join(' ').trim();
                    //  Allow for 'fill' to be used in place of 'color'
                    var fill = GetValue(style, 'fill', null);
                    if (fill !== null) this.color = fill;
                    if (updateText) return this.update(true);
                    else return this.parent;
                },
                /**
     * Synchronize the font settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncFont
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncFont: function(canvas, context) {
                    context.font = this._font;
                },
                /**
     * Synchronize the text style settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncStyle
     * @since 3.0.0
     *
     * @param {HTMLCanvasElement} canvas - The Canvas Element.
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     */ syncStyle: function(canvas, context) {
                    context.textBaseline = 'alphabetic';
                    context.fillStyle = this.color;
                    context.strokeStyle = this.stroke;
                    context.lineWidth = this.strokeThickness;
                    context.lineCap = 'round';
                    context.lineJoin = 'round';
                },
                /**
     * Synchronize the shadow settings to the given Canvas Rendering Context.
     *
     * @method Phaser.GameObjects.TextStyle#syncShadow
     * @since 3.0.0
     *
     * @param {CanvasRenderingContext2D} context - The Canvas Rendering Context.
     * @param {boolean} enabled - Whether shadows are enabled or not.
     */ syncShadow: function(context, enabled) {
                    if (enabled) {
                        context.shadowOffsetX = this.shadowOffsetX;
                        context.shadowOffsetY = this.shadowOffsetY;
                        context.shadowColor = this.shadowColor;
                        context.shadowBlur = this.shadowBlur;
                    } else {
                        context.shadowOffsetX = 0;
                        context.shadowOffsetY = 0;
                        context.shadowColor = 0;
                        context.shadowBlur = 0;
                    }
                },
                /**
     * Update the style settings for the parent Text object.
     *
     * @method Phaser.GameObjects.TextStyle#update
     * @since 3.0.0
     *
     * @param {boolean} recalculateMetrics - Whether to recalculate font and text metrics.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ update: function(recalculateMetrics) {
                    if (recalculateMetrics) {
                        this._font = [
                            this.fontStyle,
                            this.fontSize,
                            this.fontFamily
                        ].join(' ').trim();
                        this.metrics = MeasureText(this);
                    }
                    return this.parent.updateText();
                },
                /**
     * Set the font.
     *
     * If a string is given, the font family is set.
     *
     * If an object is given, the `fontFamily`, `fontSize` and `fontStyle`
     * properties of that object are set.
     *
     * @method Phaser.GameObjects.TextStyle#setFont
     * @since 3.0.0
     *
     * @param {(string|object)} font - The font family or font settings to set.
     * @param {boolean} [updateText=true] - Whether to update the text immediately.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFont: function(font, updateText) {
                    if (updateText === undefined) updateText = true;
                    var fontFamily = font;
                    var fontSize = '';
                    var fontStyle = '';
                    if (typeof font !== 'string') {
                        fontFamily = GetValue(font, 'fontFamily', 'Courier');
                        fontSize = GetValue(font, 'fontSize', '16px');
                        fontStyle = GetValue(font, 'fontStyle', '');
                    } else {
                        var fontSplit = font.split(' ');
                        var i = 0;
                        fontStyle = fontSplit.length > 2 ? fontSplit[i++] : '';
                        fontSize = fontSplit[i++] || '16px';
                        fontFamily = fontSplit[i++] || 'Courier';
                    }
                    if (fontFamily !== this.fontFamily || fontSize !== this.fontSize || fontStyle !== this.fontStyle) {
                        this.fontFamily = fontFamily;
                        this.fontSize = fontSize;
                        this.fontStyle = fontStyle;
                        if (updateText) this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font family.
     *
     * @method Phaser.GameObjects.TextStyle#setFontFamily
     * @since 3.0.0
     *
     * @param {string} family - The font family.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontFamily: function(family) {
                    if (this.fontFamily !== family) {
                        this.fontFamily = family;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font style.
     *
     * @method Phaser.GameObjects.TextStyle#setFontStyle
     * @since 3.0.0
     *
     * @param {string} style - The font style.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontStyle: function(style) {
                    if (this.fontStyle !== style) {
                        this.fontStyle = style;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the font size.
     *
     * @method Phaser.GameObjects.TextStyle#setFontSize
     * @since 3.0.0
     *
     * @param {(number|string)} size - The font size.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFontSize: function(size) {
                    if (typeof size === 'number') size = size.toString() + 'px';
                    if (this.fontSize !== size) {
                        this.fontSize = size;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the test string to use when measuring the font.
     *
     * @method Phaser.GameObjects.TextStyle#setTestString
     * @since 3.0.0
     *
     * @param {string} string - The test string to use when measuring the font.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setTestString: function(string) {
                    this.testString = string;
                    return this.update(true);
                },
                /**
     * Set a fixed width and height for the text.
     *
     * Pass in `0` for either of these parameters to disable fixed width or height respectively.
     *
     * @method Phaser.GameObjects.TextStyle#setFixedSize
     * @since 3.0.0
     *
     * @param {number} width - The fixed width to set.
     * @param {number} height - The fixed height to set.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFixedSize: function(width, height) {
                    this.fixedWidth = width;
                    this.fixedHeight = height;
                    if (width) this.parent.width = width;
                    if (height) this.parent.height = height;
                    return this.update(false);
                },
                /**
     * Set the background color.
     *
     * @method Phaser.GameObjects.TextStyle#setBackgroundColor
     * @since 3.0.0
     *
     * @param {string} color - The background color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setBackgroundColor: function(color) {
                    this.backgroundColor = color;
                    return this.update(false);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setFill
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setFill: function(color) {
                    this.color = color;
                    return this.update(false);
                },
                /**
     * Set the text fill color.
     *
     * @method Phaser.GameObjects.TextStyle#setColor
     * @since 3.0.0
     *
     * @param {string} color - The text fill color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setColor: function(color) {
                    this.color = color;
                    return this.update(false);
                },
                /**
     * Set the resolution used by the Text object.
     *
     * By default it will be set to match the resolution set in the Game Config,
     * but you can override it via this method. It allows for much clearer text on High DPI devices,
     * at the cost of memory because it uses larger internal Canvas textures for the Text.
     *
     * Please use with caution, as the more high res Text you have, the more memory it uses up.
     *
     * @method Phaser.GameObjects.TextStyle#setResolution
     * @since 3.12.0
     *
     * @param {number} value - The resolution for this Text object to use.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setResolution: function(value) {
                    this.resolution = value;
                    return this.update(false);
                },
                /**
     * Set the stroke settings.
     *
     * @method Phaser.GameObjects.TextStyle#setStroke
     * @since 3.0.0
     *
     * @param {string} color - The stroke color.
     * @param {number} thickness - The stroke thickness.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setStroke: function(color, thickness) {
                    if (thickness === undefined) thickness = this.strokeThickness;
                    if (color === undefined && this.strokeThickness !== 0) {
                        //  Reset the stroke to zero (disabling it)
                        this.strokeThickness = 0;
                        this.update(true);
                    } else if (this.stroke !== color || this.strokeThickness !== thickness) {
                        this.stroke = color;
                        this.strokeThickness = thickness;
                        this.update(true);
                    }
                    return this.parent;
                },
                /**
     * Set the shadow settings.
     *
     * Calling this method always re-measures the parent Text object,
     * so only call it when you actually change the shadow settings.
     *
     * @method Phaser.GameObjects.TextStyle#setShadow
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     * @param {string} [color='#000'] - The shadow color.
     * @param {number} [blur=0] - The shadow blur radius.
     * @param {boolean} [shadowStroke=false] - Whether to stroke the shadow.
     * @param {boolean} [shadowFill=true] - Whether to fill the shadow.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadow: function(x, y, color, blur, shadowStroke, shadowFill) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (color === undefined) color = '#000';
                    if (blur === undefined) blur = 0;
                    if (shadowStroke === undefined) shadowStroke = false;
                    if (shadowFill === undefined) shadowFill = true;
                    this.shadowOffsetX = x;
                    this.shadowOffsetY = y;
                    this.shadowColor = color;
                    this.shadowBlur = blur;
                    this.shadowStroke = shadowStroke;
                    this.shadowFill = shadowFill;
                    return this.update(false);
                },
                /**
     * Set the shadow offset.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowOffset
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal shadow offset.
     * @param {number} [y=0] - The vertical shadow offset.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowOffset: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.shadowOffsetX = x;
                    this.shadowOffsetY = y;
                    return this.update(false);
                },
                /**
     * Set the shadow color.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowColor
     * @since 3.0.0
     *
     * @param {string} [color='#000'] - The shadow color.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowColor: function(color) {
                    if (color === undefined) color = '#000';
                    this.shadowColor = color;
                    return this.update(false);
                },
                /**
     * Set the shadow blur radius.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowBlur
     * @since 3.0.0
     *
     * @param {number} [blur=0] - The shadow blur radius.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowBlur: function(blur) {
                    if (blur === undefined) blur = 0;
                    this.shadowBlur = blur;
                    return this.update(false);
                },
                /**
     * Enable or disable shadow stroke.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowStroke
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow stroke is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowStroke: function(enabled) {
                    this.shadowStroke = enabled;
                    return this.update(false);
                },
                /**
     * Enable or disable shadow fill.
     *
     * @method Phaser.GameObjects.TextStyle#setShadowFill
     * @since 3.0.0
     *
     * @param {boolean} enabled - Whether shadow fill is enabled or not.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setShadowFill: function(enabled) {
                    this.shadowFill = enabled;
                    return this.update(false);
                },
                /**
     * Set the width (in pixels) to use for wrapping lines.
     *
     * Pass in null to remove wrapping by width.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapWidth
     * @since 3.0.0
     *
     * @param {number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
     * spaces and whitespace are left as is.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapWidth: function(width, useAdvancedWrap) {
                    if (useAdvancedWrap === undefined) useAdvancedWrap = false;
                    this.wordWrapWidth = width;
                    this.wordWrapUseAdvanced = useAdvancedWrap;
                    return this.update(false);
                },
                /**
     * Set a custom callback for wrapping lines.
     *
     * Pass in null to remove wrapping by callback.
     *
     * @method Phaser.GameObjects.TextStyle#setWordWrapCallback
     * @since 3.0.0
     *
     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
     * instance). It should return the wrapped lines either as an array of lines or as a string with
     * newline characters in place to indicate where breaks should happen.
     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setWordWrapCallback: function(callback, scope) {
                    if (scope === undefined) scope = null;
                    this.wordWrapCallback = callback;
                    this.wordWrapCallbackScope = scope;
                    return this.update(false);
                },
                /**
     * Set the alignment of the text in this Text object.
     *
     * The argument can be one of: `left`, `right`, `center` or `justify`.
     *
     * Alignment only works if the Text object has more than one line of text.
     *
     * @method Phaser.GameObjects.TextStyle#setAlign
     * @since 3.0.0
     *
     * @param {string} [align='left'] - The text alignment for multi-line text.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setAlign: function(align) {
                    if (align === undefined) align = 'left';
                    this.align = align;
                    return this.update(false);
                },
                /**
     * Set the maximum number of lines to draw.
     *
     * @method Phaser.GameObjects.TextStyle#setMaxLines
     * @since 3.0.0
     *
     * @param {number} [max=0] - The maximum number of lines to draw.
     *
     * @return {Phaser.GameObjects.Text} The parent Text object.
     */ setMaxLines: function(max) {
                    if (max === undefined) max = 0;
                    this.maxLines = max;
                    return this.update(false);
                },
                /**
     * Get the current text metrics.
     *
     * @method Phaser.GameObjects.TextStyle#getTextMetrics
     * @since 3.0.0
     *
     * @return {Phaser.Types.GameObjects.Text.TextMetrics} The text metrics.
     */ getTextMetrics: function() {
                    var metrics = this.metrics;
                    return {
                        ascent: metrics.ascent,
                        descent: metrics.descent,
                        fontSize: metrics.fontSize
                    };
                },
                /**
     * Build a JSON representation of this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#toJSON
     * @since 3.0.0
     *
     * @return {object} A JSON representation of this Text Style.
     */ toJSON: function() {
                    var output = {};
                    for(var key in propertyMap)output[key] = this[key];
                    output.metrics = this.getTextMetrics();
                    return output;
                },
                /**
     * Destroy this Text Style.
     *
     * @method Phaser.GameObjects.TextStyle#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.parent = undefined;
                }
            });
            module1.exports = TextStyle;
        /***/ },
        /* 454 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CanvasPool = __webpack_require__(31);
            /**
 * Calculates the ascent, descent and fontSize of a given font style.
 *
 * @function Phaser.GameObjects.MeasureText
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.TextStyle} textStyle - The TextStyle object to measure.
 *
 * @return {Phaser.Types.GameObjects.Text.TextMetrics} An object containing the ascent, descent and fontSize of the TextStyle.
 */ var MeasureText = function(textStyle) {
                var canvas = CanvasPool.create(this);
                var context = canvas.getContext('2d');
                textStyle.syncFont(canvas, context);
                var metrics = context.measureText(textStyle.testString);
                if (metrics.hasOwnProperty('actualBoundingBoxAscent')) {
                    var ascent = metrics.actualBoundingBoxAscent;
                    var descent = metrics.actualBoundingBoxDescent;
                    CanvasPool.remove(canvas);
                    return {
                        ascent: ascent,
                        descent: descent,
                        fontSize: ascent + descent
                    };
                }
                var width = Math.ceil(metrics.width * textStyle.baselineX);
                var baseline = width;
                var height = 2 * baseline;
                baseline = baseline * textStyle.baselineY | 0;
                canvas.width = width;
                canvas.height = height;
                context.fillStyle = '#f00';
                context.fillRect(0, 0, width, height);
                context.font = textStyle._font;
                context.textBaseline = 'alphabetic';
                context.fillStyle = '#000';
                context.fillText(textStyle.testString, 0, baseline);
                var output = {
                    ascent: 0,
                    descent: 0,
                    fontSize: 0
                };
                if (!context.getImageData(0, 0, width, height)) {
                    output.ascent = baseline;
                    output.descent = baseline + 6;
                    output.fontSize = output.ascent + output.descent;
                    CanvasPool.remove(canvas);
                    return output;
                }
                var imagedata = context.getImageData(0, 0, width, height).data;
                var pixels = imagedata.length;
                var line = width * 4;
                var i;
                var j;
                var idx = 0;
                var stop = false;
                // ascent. scan from top to bottom until we find a non red pixel
                for(i = 0; i < baseline; i++){
                    for(j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx += line;
                    else break;
                }
                output.ascent = baseline - i;
                idx = pixels - line;
                stop = false;
                // descent. scan from bottom to top until we find a non red pixel
                for(i = height; i > baseline; i--){
                    for(j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx -= line;
                    else break;
                }
                output.descent = i - baseline;
                output.fontSize = output.ascent + output.descent;
                CanvasPool.remove(canvas);
                return output;
            };
            module1.exports = MeasureText;
        /***/ },
        /* 455 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcRender = __webpack_require__(1091);
            var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(35);
            var Earcut = __webpack_require__(68);
            var GeomCircle = __webpack_require__(62);
            var MATH_CONST = __webpack_require__(14);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 * 
 * Arcs also have an `iterations` property and corresponding `setIterations` method. This allows
 * you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction.
 *
 * @class Arc
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Arc = new Class({
                Extends: Shape,
                Mixins: [
                    ArcRender
                ],
                initialize: function Arc(scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 128;
                    if (startAngle === undefined) startAngle = 0;
                    if (endAngle === undefined) endAngle = 360;
                    if (anticlockwise === undefined) anticlockwise = false;
                    Shape.call(this, scene, 'Arc', new GeomCircle(0, 0, radius));
                    /**
         * Private internal value. Holds the start angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_startAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startAngle = startAngle;
                    /**
         * Private internal value. Holds the end angle in degrees.
         *
         * @name Phaser.GameObjects.Arc#_endAngle
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endAngle = endAngle;
                    /**
         * Private internal value. Holds the winding order of the start and end angles.
         *
         * @name Phaser.GameObjects.Arc#_anticlockwise
         * @type {boolean}
         * @private
         * @since 3.13.0
         */ this._anticlockwise = anticlockwise;
                    /**
         * Private internal value. Holds the number of iterations used when drawing the arc.
         *
         * @name Phaser.GameObjects.Arc#_iterations
         * @type {number}
         * @default 0.01
         * @private
         * @since 3.13.0
         */ this._iterations = 0.01;
                    this.setPosition(x, y);
                    var diameter = this.geom.radius * 2;
                    this.setSize(diameter, diameter);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * The number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     *
     * @name Phaser.GameObjects.Arc#iterations
     * @type {number}
     * @default 0.01
     * @since 3.13.0
     */ iterations: {
                    get: function() {
                        return this._iterations;
                    },
                    set: function(value) {
                        this._iterations = value;
                        this.updateData();
                    }
                },
                /**
     * The radius of the arc.
     *
     * @name Phaser.GameObjects.Arc#radius
     * @type {number}
     * @since 3.13.0
     */ radius: {
                    get: function() {
                        return this.geom.radius;
                    },
                    set: function(value) {
                        this.geom.radius = value;
                        var diameter = value * 2;
                        this.setSize(diameter, diameter);
                        this.updateDisplayOrigin();
                        this.updateData();
                    }
                },
                /**
     * The start angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#startAngle
     * @type {number}
     * @since 3.13.0
     */ startAngle: {
                    get: function() {
                        return this._startAngle;
                    },
                    set: function(value) {
                        this._startAngle = value;
                        this.updateData();
                    }
                },
                /**
     * The end angle of the arc, in degrees.
     *
     * @name Phaser.GameObjects.Arc#endAngle
     * @type {number}
     * @since 3.13.0
     */ endAngle: {
                    get: function() {
                        return this._endAngle;
                    },
                    set: function(value) {
                        this._endAngle = value;
                        this.updateData();
                    }
                },
                /**
     * The winding order of the start and end angles.
     *
     * @name Phaser.GameObjects.Arc#anticlockwise
     * @type {boolean}
     * @since 3.13.0
     */ anticlockwise: {
                    get: function() {
                        return this._anticlockwise;
                    },
                    set: function(value) {
                        this._anticlockwise = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the radius of the arc.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setRadius
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the radius to.
     *
     * @return {this} This Game Object instance.
     */ setRadius: function(value) {
                    this.radius = value;
                    return this;
                },
                /**
     * Sets the number of iterations used when drawing the arc.
     * Increase this value for smoother arcs, at the cost of more polygons being rendered.
     * Modify this value by small amounts, such as 0.01.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setIterations
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the iterations to.
     *
     * @return {this} This Game Object instance.
     */ setIterations: function(value) {
                    if (value === undefined) value = 0.01;
                    this.iterations = value;
                    return this;
                },
                /**
     * Sets the starting angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setStartAngle
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the starting angle to.
     *
     * @return {this} This Game Object instance.
     */ setStartAngle: function(angle, anticlockwise) {
                    this._startAngle = angle;
                    if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                    return this.updateData();
                },
                /**
     * Sets the ending angle of the arc, in degrees.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Arc#setEndAngle
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the ending angle to.
     *
     * @return {this} This Game Object instance.
     */ setEndAngle: function(angle, anticlockwise) {
                    this._endAngle = angle;
                    if (anticlockwise !== undefined) this._anticlockwise = anticlockwise;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Arc#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var step = this._iterations;
                    var iteration = step;
                    var radius = this.geom.radius;
                    var startAngle = DegToRad(this._startAngle);
                    var endAngle = DegToRad(this._endAngle);
                    var anticlockwise = this._anticlockwise;
                    var x = radius;
                    var y = radius;
                    endAngle -= startAngle;
                    if (anticlockwise) {
                        if (endAngle < -MATH_CONST.PI2) endAngle = -MATH_CONST.PI2;
                        else if (endAngle > 0) endAngle = -MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                    } else if (endAngle > MATH_CONST.PI2) endAngle = MATH_CONST.PI2;
                    else if (endAngle < 0) endAngle = MATH_CONST.PI2 + endAngle % MATH_CONST.PI2;
                    var path = [
                        x + Math.cos(startAngle) * radius,
                        y + Math.sin(startAngle) * radius
                    ];
                    var ta;
                    while(iteration < 1){
                        ta = endAngle * iteration + startAngle;
                        path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                        iteration += step;
                    }
                    ta = endAngle + startAngle;
                    path.push(x + Math.cos(ta) * radius, y + Math.sin(ta) * radius);
                    path.push(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Arc;
        /***/ },
        /* 456 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CurveRender = __webpack_require__(1094);
            var Earcut = __webpack_require__(68);
            var Rectangle = __webpack_require__(10);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 * 
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Curve
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Curve = new Class({
                Extends: Shape,
                Mixins: [
                    CurveRender
                ],
                initialize: function Curve(scene, x, y, curve, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    Shape.call(this, scene, 'Curve', curve);
                    /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Curve#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 32;
                    /**
         * Private internal value.
         * The Curve bounds rectangle.
         *
         * @name Phaser.GameObjects.Curve#_curveBounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.13.0
         */ this._curveBounds = new Rectangle();
                    this.closePath = false;
                    this.setPosition(x, y);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateData();
                },
                /**
     * The smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Curve#smoothness
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(value) {
                        this._smoothness = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the smoothness of the curve. The number of points used when rendering it.
     * Increase this value for smoother curves, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Curve#setSmoothness
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                    this._smoothness = value;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Curve#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var bounds = this._curveBounds;
                    var smoothness = this._smoothness;
                    //  Update the bounds in case the underlying data has changed
                    this.geom.getBounds(bounds, smoothness);
                    this.setSize(bounds.width, bounds.height);
                    this.updateDisplayOrigin();
                    var path = [];
                    var points = this.geom.getPoints(smoothness);
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Curve;
        /***/ },
        /* 457 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(68);
            var EllipseRender = __webpack_require__(1097);
            var GeomEllipse = __webpack_require__(108);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 * 
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @class Ellipse
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Ellipse = new Class({
                Extends: Shape,
                Mixins: [
                    EllipseRender
                ],
                initialize: function Ellipse(scene, x, y, width, height, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    Shape.call(this, scene, 'Ellipse', new GeomEllipse(width / 2, height / 2, width, height));
                    /**
         * Private internal value.
         * The number of points used to draw the curve. Higher values create smoother renders at the cost of more triangles being drawn.
         *
         * @name Phaser.GameObjects.Ellipse#_smoothness
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._smoothness = 64;
                    this.setPosition(x, y);
                    this.width = width;
                    this.height = height;
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * The smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     *
     * @name Phaser.GameObjects.Ellipse#smoothness
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ smoothness: {
                    get: function() {
                        return this._smoothness;
                    },
                    set: function(value) {
                        this._smoothness = value;
                        this.updateData();
                    }
                },
                /**
     * Sets the size of the ellipse by changing the underlying geometry data, rather than scaling the object.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSize
     * @since 3.13.0
     * 
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.geom.setPosition(width / 2, height / 2);
                    this.geom.setSize(width, height);
                    return this.updateData();
                },
                /**
     * Sets the smoothness of the ellipse. The number of points used when rendering it.
     * Increase this value for a smoother ellipse, at the cost of more polygons being rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Ellipse#setSmoothness
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the smoothness to.
     *
     * @return {this} This Game Object instance.
     */ setSmoothness: function(value) {
                    this._smoothness = value;
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Ellipse#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this.geom.getPoints(this._smoothness);
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Ellipse;
        /***/ },
        /* 458 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(33);
            var GridRender = __webpack_require__(1100);
            /**
 * @classdesc
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only fill colors and cannot be stroked.
 *
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @class Grid
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells. See the `setOutline` method.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 */ var Grid = new Class({
                Extends: Shape,
                Mixins: [
                    GridRender
                ],
                initialize: function Grid(scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    if (cellWidth === undefined) cellWidth = 32;
                    if (cellHeight === undefined) cellHeight = 32;
                    Shape.call(this, scene, 'Grid', null);
                    /**
         * The width of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellWidth
         * @type {number}
         * @since 3.13.0
         */ this.cellWidth = cellWidth;
                    /**
         * The height of each grid cell.
         * Must be a positive value.
         *
         * @name Phaser.GameObjects.Grid#cellHeight
         * @type {number}
         * @since 3.13.0
         */ this.cellHeight = cellHeight;
                    /**
         * Will the grid render its cells in the `fillColor`?
         *
         * @name Phaser.GameObjects.Grid#showCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showCells = true;
                    /**
         * The color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillColor
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillColor = 0;
                    /**
         * The alpha value for the color of the lines between each grid cell.
         *
         * @name Phaser.GameObjects.Grid#outlineFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.outlineFillAlpha = 0;
                    /**
         * Will the grid display the lines between each cell when it renders?
         *
         * @name Phaser.GameObjects.Grid#showOutline
         * @type {boolean}
         * @since 3.13.0
         */ this.showOutline = true;
                    /**
         * Will the grid render the alternating cells in the `altFillColor`?
         *
         * @name Phaser.GameObjects.Grid#showAltCells
         * @type {boolean}
         * @since 3.13.0
         */ this.showAltCells = false;
                    /**
         * The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
         *
         * @name Phaser.GameObjects.Grid#altFillColor
         * @type {number}
         * @since 3.13.0
         */ this.altFillColor;
                    /**
         * The alpha the alternating grid cells will be filled with.
         * You can also set the alpha of the overall Shape using its `alpha` property.
         *
         * @name Phaser.GameObjects.Grid#altFillAlpha
         * @type {number}
         * @since 3.13.0
         */ this.altFillAlpha;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    this.setFillStyle(fillColor, fillAlpha);
                    if (outlineFillColor !== undefined) this.setOutlineStyle(outlineFillColor, outlineFillAlpha);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the fill color and alpha level the grid cells will use when rendering.
     *
     * If this method is called with no values then the grid cells will not be rendered,
     * however the grid lines and alternating cells may still be.
     *
     * Also see the `setOutlineStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showCells = false;
                    else {
                        this.fillColor = fillColor;
                        this.fillAlpha = fillAlpha;
                        this.showCells = true;
                    }
                    return this;
                },
                /**
     * Sets the fill color and alpha level that the alternating grid cells will use.
     *
     * If this method is called with no values then alternating grid cells will not be rendered in a different color.
     *
     * Also see the `setOutlineStyle` and `setFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setAltFillStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the alternating grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the alternating grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setAltFillStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showAltCells = false;
                    else {
                        this.altFillColor = fillColor;
                        this.altFillAlpha = fillAlpha;
                        this.showAltCells = true;
                    }
                    return this;
                },
                /**
     * Sets the fill color and alpha level that the lines between each grid cell will use.
     *
     * If this method is called with no values then the grid lines will not be rendered at all, however
     * the cells themselves may still be if they have colors set.
     *
     * Also see the `setFillStyle` and `setAltFillStyle` methods.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Grid#setOutlineStyle
     * @since 3.13.0
     *
     * @param {number} [fillColor] - The color the lines between the grid cells will be filled with, i.e. 0xff0000 for red.
     * @param {number} [fillAlpha=1] - The alpha the lines between the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
     *
     * @return {this} This Game Object instance.
     */ setOutlineStyle: function(fillColor, fillAlpha) {
                    if (fillAlpha === undefined) fillAlpha = 1;
                    if (fillColor === undefined) this.showOutline = false;
                    else {
                        this.outlineFillColor = fillColor;
                        this.outlineFillAlpha = fillAlpha;
                        this.showOutline = true;
                    }
                    return this;
                }
            });
            module1.exports = Grid;
        /***/ },
        /* 459 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsoBoxRender = __webpack_require__(1103);
            var Class = __webpack_require__(0);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @class IsoBox
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 */ var IsoBox = new Class({
                Extends: Shape,
                Mixins: [
                    IsoBoxRender
                ],
                initialize: function IsoBox(scene, x, y, size, height, fillTop, fillLeft, fillRight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (size === undefined) size = 48;
                    if (height === undefined) height = 32;
                    if (fillTop === undefined) fillTop = 0xeeeeee;
                    if (fillLeft === undefined) fillLeft = 0x999999;
                    if (fillRight === undefined) fillRight = 0xcccccc;
                    Shape.call(this, scene, 'IsoBox', null);
                    /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoBox#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                    /**
         * The color used to fill in the top of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                    /**
         * The color used to fill in the left-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                    /**
         * The color used to fill in the right-facing side of the iso box.
         *
         * @name Phaser.GameObjects.IsoBox#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                    /**
         * Controls if the top-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                    /**
         * Controls if the left-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                    /**
         * Controls if the right-face of the iso box be rendered.
         *
         * @name Phaser.GameObjects.IsoBox#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                    this.isFilled = true;
                    this.setPosition(x, y);
                    this.setSize(size, height);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setProjection
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                    this.projection = value;
                    return this;
                },
                /**
     * Sets which faces of the iso box will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFaces
     * @since 3.13.0
     * 
     * @param {boolean} [showTop=true] - Show the top-face of the iso box.
     * @param {boolean} [showLeft=true] - Show the left-face of the iso box.
     * @param {boolean} [showRight=true] - Show the right-face of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                    if (showTop === undefined) showTop = true;
                    if (showLeft === undefined) showLeft = true;
                    if (showRight === undefined) showRight = true;
                    this.showTop = showTop;
                    this.showLeft = showLeft;
                    this.showRight = showRight;
                    return this;
                },
                /**
     * Sets the fill colors for each face of the iso box.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoBox#setFillStyle
     * @since 3.13.0
     * 
     * @param {number} [fillTop] - The color used to fill the top of the iso box.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso box.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso box.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                    this.fillTop = fillTop;
                    this.fillLeft = fillLeft;
                    this.fillRight = fillRight;
                    this.isFilled = true;
                    return this;
                }
            });
            module1.exports = IsoBox;
        /***/ },
        /* 460 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var IsoTriangleRender = __webpack_require__(1106);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @class IsoTriangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 */ var IsoTriangle = new Class({
                Extends: Shape,
                Mixins: [
                    IsoTriangleRender
                ],
                initialize: function IsoTriangle(scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (size === undefined) size = 48;
                    if (height === undefined) height = 32;
                    if (reversed === undefined) reversed = false;
                    if (fillTop === undefined) fillTop = 0xeeeeee;
                    if (fillLeft === undefined) fillLeft = 0x999999;
                    if (fillRight === undefined) fillRight = 0xcccccc;
                    Shape.call(this, scene, 'IsoTriangle', null);
                    /**
         * The projection level of the iso box. Change this to change the 'angle' at which you are looking at the box.
         *
         * @name Phaser.GameObjects.IsoTriangle#projection
         * @type {number}
         * @default 4
         * @since 3.13.0
         */ this.projection = 4;
                    /**
         * The color used to fill in the top of the iso triangle. This is only used if the triangle is reversed.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillTop
         * @type {number}
         * @since 3.13.0
         */ this.fillTop = fillTop;
                    /**
         * The color used to fill in the left-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillLeft
         * @type {number}
         * @since 3.13.0
         */ this.fillLeft = fillLeft;
                    /**
         * The color used to fill in the right-facing side of the iso triangle.
         *
         * @name Phaser.GameObjects.IsoTriangle#fillRight
         * @type {number}
         * @since 3.13.0
         */ this.fillRight = fillRight;
                    /**
         * Controls if the top-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showTop
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showTop = true;
                    /**
         * Controls if the left-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showLeft
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showLeft = true;
                    /**
         * Controls if the right-face of the iso triangle be rendered.
         *
         * @name Phaser.GameObjects.IsoTriangle#showRight
         * @type {boolean}
         * @default true
         * @since 3.13.0
         */ this.showRight = true;
                    /**
         * Sets if the iso triangle will be rendered upside down or not.
         *
         * @name Phaser.GameObjects.IsoTriangle#isReversed
         * @type {boolean}
         * @default false
         * @since 3.13.0
         */ this.isReversed = reversed;
                    this.isFilled = true;
                    this.setPosition(x, y);
                    this.setSize(size, height);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the projection level of the iso triangle. Change this to change the 'angle' at which you are looking at the pyramid.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setProjection
     * @since 3.13.0
     * 
     * @param {number} value - The value to set the projection to.
     *
     * @return {this} This Game Object instance.
     */ setProjection: function(value) {
                    this.projection = value;
                    return this;
                },
                /**
     * Sets if the iso triangle will be rendered upside down or not.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setReversed
     * @since 3.13.0
     * 
     * @param {boolean} reversed - Sets if the iso triangle will be rendered upside down or not.
     *
     * @return {this} This Game Object instance.
     */ setReversed: function(reversed) {
                    this.isReversed = reversed;
                    return this;
                },
                /**
     * Sets which faces of the iso triangle will be rendered.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFaces
     * @since 3.13.0
     * 
     * @param {boolean} [showTop=true] - Show the top-face of the iso triangle (only if `reversed` is true)
     * @param {boolean} [showLeft=true] - Show the left-face of the iso triangle.
     * @param {boolean} [showRight=true] - Show the right-face of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFaces: function(showTop, showLeft, showRight) {
                    if (showTop === undefined) showTop = true;
                    if (showLeft === undefined) showLeft = true;
                    if (showRight === undefined) showRight = true;
                    this.showTop = showTop;
                    this.showLeft = showLeft;
                    this.showRight = showRight;
                    return this;
                },
                /**
     * Sets the fill colors for each face of the iso triangle.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.IsoTriangle#setFillStyle
     * @since 3.13.0
     * 
     * @param {number} [fillTop] - The color used to fill the top of the iso triangle.
     * @param {number} [fillLeft] - The color used to fill in the left-facing side of the iso triangle.
     * @param {number} [fillRight] - The color used to fill in the right-facing side of the iso triangle.
     *
     * @return {this} This Game Object instance.
     */ setFillStyle: function(fillTop, fillLeft, fillRight) {
                    this.fillTop = fillTop;
                    this.fillLeft = fillLeft;
                    this.fillRight = fillRight;
                    this.isFilled = true;
                    return this;
                }
            });
            module1.exports = IsoTriangle;
        /***/ },
        /* 461 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(33);
            var GeomLine = __webpack_require__(45);
            var LineRender = __webpack_require__(1109);
            /**
 * @classdesc
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports only stroke colors and cannot be filled.
 *
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 *
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * Be aware that as with all Game Objects the default origin is 0.5. If you need to draw a Line
 * between two points and want the x1/y1 values to match the x/y values, then set the origin to 0.
 *
 * @class Line
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Line = new Class({
                Extends: Shape,
                Mixins: [
                    LineRender
                ],
                initialize: function Line(scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 0;
                    if (x2 === undefined) x2 = 128;
                    if (y2 === undefined) y2 = 0;
                    Shape.call(this, scene, 'Line', new GeomLine(x1, y1, x2, y2));
                    var width = Math.max(1, this.geom.right - this.geom.left);
                    var height = Math.max(1, this.geom.bottom - this.geom.top);
                    /**
         * The width (or thickness) of the line.
         * See the setLineWidth method for extra details on changing this on WebGL.
         *
         * @name Phaser.GameObjects.Line#lineWidth
         * @type {number}
         * @since 3.13.0
         */ this.lineWidth = 1;
                    /**
         * Private internal value. Holds the start width of the line.
         *
         * @name Phaser.GameObjects.Line#_startWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._startWidth = 1;
                    /**
         * Private internal value. Holds the end width of the line.
         *
         * @name Phaser.GameObjects.Line#_endWidth
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._endWidth = 1;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (strokeColor !== undefined) this.setStrokeStyle(1, strokeColor, strokeAlpha);
                    this.updateDisplayOrigin();
                },
                /**
     * Sets the width of the line.
     *
     * When using the WebGL renderer you can have different start and end widths.
     * When using the Canvas renderer only the `startWidth` value is used. The `endWidth` is ignored.
     *
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Line#setLineWidth
     * @since 3.13.0
     *
     * @param {number} startWidth - The start width of the line.
     * @param {number} [endWidth] - The end width of the line. Only used in WebGL.
     *
     * @return {this} This Game Object instance.
     */ setLineWidth: function(startWidth, endWidth) {
                    if (endWidth === undefined) endWidth = startWidth;
                    this._startWidth = startWidth;
                    this._endWidth = endWidth;
                    this.lineWidth = startWidth;
                    return this;
                },
                /**
     * Sets the start and end coordinates of this Line.
     *
     * @method Phaser.GameObjects.Line#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the start of the line.
     * @param {number} [y1=0] - The vertical position of the start of the line.
     * @param {number} [x2=0] - The horizontal position of the end of the line.
     * @param {number} [y2=0] - The vertical position of the end of the line.
     *
     * @return {this} This Line object.
     */ setTo: function(x1, y1, x2, y2) {
                    this.geom.setTo(x1, y1, x2, y2);
                    return this;
                }
            });
            module1.exports = Line;
        /***/ },
        /* 462 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PolygonRender = __webpack_require__(1112);
            var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(68);
            var GetAABB = __webpack_require__(463);
            var GeomPolygon = __webpack_require__(224);
            var Shape = __webpack_require__(33);
            var Smooth = __webpack_require__(466);
            /**
 * @classdesc
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - A string containing paired values separated by a single space: `'40 0 40 20 100 20 100 80 40 80 40 100 0 50'`
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 * 
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * @class Polygon
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Polygon = new Class({
                Extends: Shape,
                Mixins: [
                    PolygonRender
                ],
                initialize: function Polygon(scene, x, y, points, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    Shape.call(this, scene, 'Polygon', new GeomPolygon(points));
                    var bounds = GetAABB(this.geom);
                    this.setPosition(x, y);
                    this.setSize(bounds.width, bounds.height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Smooths the polygon over the number of iterations specified.
     * The base polygon data will be updated and replaced with the smoothed values.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Polygon#smooth
     * @since 3.13.0
     * 
     * @param {number} [iterations=1] - The number of times to apply the polygon smoothing.
     *
     * @return {this} This Game Object instance.
     */ smooth: function(iterations) {
                    if (iterations === undefined) iterations = 1;
                    for(var i = 0; i < iterations; i++)Smooth(this.geom);
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Polygon#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this.geom.points;
                    for(var i = 0; i < points.length; i++)path.push(points[i].x, points[i].y);
                    path.push(points[0].x, points[0].y);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Polygon;
        /***/ },
        /* 463 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Calculates the bounding AABB rectangle of a polygon.
 *
 * @function Phaser.Geom.Polygon.GetAABB
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon that should be calculated.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - The rectangle or object that has x, y, width, and height properties to store the result. Optional.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The resulting rectangle or object that is passed in with position and dimensions of the polygon's AABB.
 */ var GetAABB = function(polygon, out) {
                if (out === undefined) out = new Rectangle();
                var minX = Infinity;
                var minY = Infinity;
                var maxX = -minX;
                var maxY = -minY;
                var p;
                for(var i = 0; i < polygon.points.length; i++){
                    p = polygon.points[i];
                    minX = Math.min(minX, p.x);
                    minY = Math.min(minY, p.y);
                    maxX = Math.max(maxX, p.x);
                    maxY = Math.max(maxY, p.y);
                }
                out.x = minX;
                out.y = minY;
                out.width = maxX - minX;
                out.height = maxY - minY;
                return out;
            };
            module1.exports = GetAABB;
        /***/ },
        /* 464 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            var Line = __webpack_require__(45);
            var Perimeter = __webpack_require__(465);
            /**
 * Returns an array of Point objects containing the coordinates of the points around the perimeter of the Polygon,
 * based on the given quantity or stepRate values.
 *
 * @function Phaser.Geom.Polygon.GetPoints
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the points from.
 * @param {number} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
 * @param {number} [stepRate] - Sets the quantity by getting the perimeter of the Polygon and dividing it by the stepRate.
 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
 *
 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the perimeter of the Polygon.
 */ var GetPoints = function(polygon, quantity, stepRate, out) {
                if (out === undefined) out = [];
                var points = polygon.points;
                var perimeter = Perimeter(polygon);
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                for(var i = 0; i < quantity; i++){
                    var position = perimeter * (i / quantity);
                    var accumulatedPerimeter = 0;
                    for(var j = 0; j < points.length; j++){
                        var pointA = points[j];
                        var pointB = points[(j + 1) % points.length];
                        var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                        var length = Length(line);
                        if (position < accumulatedPerimeter || position > accumulatedPerimeter + length) {
                            accumulatedPerimeter += length;
                            continue;
                        }
                        var point = line.getPoint((position - accumulatedPerimeter) / length);
                        out.push(point);
                        break;
                    }
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 465 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            var Line = __webpack_require__(45);
            /**
 * Returns the perimeter of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Perimeter
 * @since 3.12.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to get the perimeter of.
 *
 * @return {number} The perimeter of the Polygon.
 */ var Perimeter = function(polygon) {
                var points = polygon.points;
                var perimeter = 0;
                for(var i = 0; i < points.length; i++){
                    var pointA = points[i];
                    var pointB = points[(i + 1) % points.length];
                    var line = new Line(pointA.x, pointA.y, pointB.x, pointB.y);
                    perimeter += Length(line);
                }
                return perimeter;
            };
            module1.exports = Perimeter;
        /***/ },
        /* 466 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Igor Ognichenko <ognichenko.igor@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @ignore
 */ var copy = function(out, a) {
                out[0] = a[0];
                out[1] = a[1];
                return out;
            };
            /**
 * Takes a Polygon object and applies Chaikin's smoothing algorithm on its points.
 *
 * @function Phaser.Geom.Polygon.Smooth
 * @since 3.13.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be smoothed. The polygon will be modified in-place and returned.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Smooth = function(polygon) {
                var i;
                var points = [];
                var data = polygon.points;
                for(i = 0; i < data.length; i++)points.push([
                    data[i].x,
                    data[i].y
                ]);
                var output = [];
                if (points.length > 0) output.push(copy([
                    0,
                    0
                ], points[0]));
                for(i = 0; i < points.length - 1; i++){
                    var p0 = points[i];
                    var p1 = points[i + 1];
                    var p0x = p0[0];
                    var p0y = p0[1];
                    var p1x = p1[0];
                    var p1y = p1[1];
                    output.push([
                        0.85 * p0x + 0.15 * p1x,
                        0.85 * p0y + 0.15 * p1y
                    ]);
                    output.push([
                        0.15 * p0x + 0.85 * p1x,
                        0.15 * p0y + 0.85 * p1y
                    ]);
                }
                if (points.length > 1) output.push(copy([
                    0,
                    0
                ], points[points.length - 1]));
                return polygon.setTo(output);
            };
            module1.exports = Smooth;
        /***/ },
        /* 467 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GeomRectangle = __webpack_require__(10);
            var Shape = __webpack_require__(33);
            var RectangleRender = __webpack_require__(1115);
            /**
 * @classdesc
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 *
 * This shape supports both fill and stroke colors.
 *
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @class Rectangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Rectangle = new Class({
                Extends: Shape,
                Mixins: [
                    RectangleRender
                ],
                initialize: function Rectangle(scene, x, y, width, height, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = 128;
                    if (height === undefined) height = 128;
                    Shape.call(this, scene, 'Rectangle', new GeomRectangle(0, 0, width, height));
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     *
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     *
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     *
     * @method Phaser.GameObjects.Rectangle#setSize
     * @since 3.13.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     *
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    this.geom.setSize(width, height);
                    this.updateData();
                    return this;
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Rectangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var rect = this.geom;
                    var line = this._tempLine;
                    rect.getLineA(line);
                    path.push(line.x1, line.y1, line.x2, line.y2);
                    rect.getLineB(line);
                    path.push(line.x2, line.y2);
                    rect.getLineC(line);
                    path.push(line.x2, line.y2);
                    rect.getLineD(line);
                    path.push(line.x2, line.y2);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Rectangle;
        /***/ },
        /* 468 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var StarRender = __webpack_require__(1118);
            var Class = __webpack_require__(0);
            var Earcut = __webpack_require__(68);
            var Shape = __webpack_require__(33);
            /**
 * @classdesc
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 * 
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @class Star
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Star = new Class({
                Extends: Shape,
                Mixins: [
                    StarRender
                ],
                initialize: function Star(scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (points === undefined) points = 5;
                    if (innerRadius === undefined) innerRadius = 32;
                    if (outerRadius === undefined) outerRadius = 64;
                    Shape.call(this, scene, 'Star', null);
                    /**
         * Private internal value.
         * The number of points in the star.
         *
         * @name Phaser.GameObjects.Star#_points
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._points = points;
                    /**
         * Private internal value.
         * The inner radius of the star.
         *
         * @name Phaser.GameObjects.Star#_innerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._innerRadius = innerRadius;
                    /**
         * Private internal value.
         * The outer radius of the star.
         *
         * @name Phaser.GameObjects.Star#_outerRadius
         * @type {number}
         * @private
         * @since 3.13.0
         */ this._outerRadius = outerRadius;
                    this.setPosition(x, y);
                    this.setSize(outerRadius * 2, outerRadius * 2);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the number of points that make up the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setPoints
     * @since 3.13.0
     * 
     * @param {number} value - The amount of points the Star will have.
     *
     * @return {this} This Game Object instance.
     */ setPoints: function(value) {
                    this._points = value;
                    return this.updateData();
                },
                /**
     * Sets the inner radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setInnerRadius
     * @since 3.13.0
     * 
     * @param {number} value - The amount to set the inner radius to.
     *
     * @return {this} This Game Object instance.
     */ setInnerRadius: function(value) {
                    this._innerRadius = value;
                    return this.updateData();
                },
                /**
     * Sets the outer radius of the Star shape.
     * This call can be chained.
     *
     * @method Phaser.GameObjects.Star#setOuterRadius
     * @since 3.13.0
     * 
     * @param {number} value - The amount to set the outer radius to.
     *
     * @return {this} This Game Object instance.
     */ setOuterRadius: function(value) {
                    this._outerRadius = value;
                    return this.updateData();
                },
                /**
     * The number of points that make up the Star shape.
     *
     * @name Phaser.GameObjects.Star#points
     * @type {number}
     * @default 5
     * @since 3.13.0
     */ points: {
                    get: function() {
                        return this._points;
                    },
                    set: function(value) {
                        this._points = value;
                        this.updateData();
                    }
                },
                /**
     * The inner radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#innerRadius
     * @type {number}
     * @default 32
     * @since 3.13.0
     */ innerRadius: {
                    get: function() {
                        return this._innerRadius;
                    },
                    set: function(value) {
                        this._innerRadius = value;
                        this.updateData();
                    }
                },
                /**
     * The outer radius of the Star shape.
     *
     * @name Phaser.GameObjects.Star#outerRadius
     * @type {number}
     * @default 64
     * @since 3.13.0
     */ outerRadius: {
                    get: function() {
                        return this._outerRadius;
                    },
                    set: function(value) {
                        this._outerRadius = value;
                        this.updateData();
                    }
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Star#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var points = this._points;
                    var innerRadius = this._innerRadius;
                    var outerRadius = this._outerRadius;
                    var rot = Math.PI / 2 * 3;
                    var step = Math.PI / points;
                    //  So origin 0.5 = the center of the star
                    var x = outerRadius;
                    var y = outerRadius;
                    path.push(x, y + -outerRadius);
                    for(var i = 0; i < points; i++){
                        path.push(x + Math.cos(rot) * outerRadius, y + Math.sin(rot) * outerRadius);
                        rot += step;
                        path.push(x + Math.cos(rot) * innerRadius, y + Math.sin(rot) * innerRadius);
                        rot += step;
                    }
                    path.push(x, y + -outerRadius);
                    this.pathIndexes = Earcut(path);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Star;
        /***/ },
        /* 469 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Shape = __webpack_require__(33);
            var GeomTriangle = __webpack_require__(82);
            var TriangleRender = __webpack_require__(1121);
            /**
 * @classdesc
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @class Triangle
 * @extends Phaser.GameObjects.Shape
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.13.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 */ var Triangle = new Class({
                Extends: Shape,
                Mixins: [
                    TriangleRender
                ],
                initialize: function Triangle(scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (x1 === undefined) x1 = 0;
                    if (y1 === undefined) y1 = 128;
                    if (x2 === undefined) x2 = 64;
                    if (y2 === undefined) y2 = 0;
                    if (x3 === undefined) x3 = 128;
                    if (y3 === undefined) y3 = 128;
                    Shape.call(this, scene, 'Triangle', new GeomTriangle(x1, y1, x2, y2, x3, y3));
                    var width = this.geom.right - this.geom.left;
                    var height = this.geom.bottom - this.geom.top;
                    this.setPosition(x, y);
                    this.setSize(width, height);
                    if (fillColor !== undefined) this.setFillStyle(fillColor, fillAlpha);
                    this.updateDisplayOrigin();
                    this.updateData();
                },
                /**
     * Sets the data for the lines that make up this Triangle shape.
     *
     * @method Phaser.GameObjects.Triangle#setTo
     * @since 3.13.0
     *
     * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
     * @param {number} [y1=0] - The vertical position of the first point in the triangle.
     * @param {number} [x2=0] - The horizontal position of the second point in the triangle.
     * @param {number} [y2=0] - The vertical position of the second point in the triangle.
     * @param {number} [x3=0] - The horizontal position of the third point in the triangle.
     * @param {number} [y3=0] - The vertical position of the third point in the triangle.
     *
     * @return {this} This Game Object instance.
     */ setTo: function(x1, y1, x2, y2, x3, y3) {
                    this.geom.setTo(x1, y1, x2, y2, x3, y3);
                    return this.updateData();
                },
                /**
     * Internal method that updates the data and path values.
     *
     * @method Phaser.GameObjects.Triangle#updateData
     * @private
     * @since 3.13.0
     *
     * @return {this} This Game Object instance.
     */ updateData: function() {
                    var path = [];
                    var tri = this.geom;
                    var line = this._tempLine;
                    tri.getLineA(line);
                    path.push(line.x1, line.y1, line.x2, line.y2);
                    tri.getLineB(line);
                    path.push(line.x2, line.y2);
                    tri.getLineC(line);
                    path.push(line.x2, line.y2);
                    this.pathData = path;
                    return this;
                }
            });
            module1.exports = Triangle;
        /***/ },
        /* 470 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var Length = __webpack_require__(64);
            /**
 * Returns a Point from around the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the point on its perimeter from.
 * @param {number} position - The position along the perimeter of the triangle. A value between 0 and 1.
 * @param {(Phaser.Geom.Point|object)} [out] - An option Point, or Point-like object to store the value in. If not given a new Point will be created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object containing the given position from the perimeter of the triangle.
 */ var GetPoint = function(triangle, position, out) {
                if (out === undefined) out = new Point();
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                if (position <= 0 || position >= 1) {
                    out.x = line1.x1;
                    out.y = line1.y1;
                    return out;
                }
                var length1 = Length(line1);
                var length2 = Length(line2);
                var length3 = Length(line3);
                var perimeter = length1 + length2 + length3;
                var p = perimeter * position;
                var localPosition = 0;
                //  Which line is it on?
                if (p < length1) {
                    //  Line 1
                    localPosition = p / length1;
                    out.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                    out.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                } else if (p > length1 + length2) {
                    //  Line 3
                    p -= length1 + length2;
                    localPosition = p / length3;
                    out.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                    out.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                } else {
                    //  Line 2
                    p -= length1;
                    localPosition = p / length2;
                    out.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                    out.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                }
                return out;
            };
            module1.exports = GetPoint;
        /***/ },
        /* 471 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of evenly spaced points on the perimeter of a Triangle.
 *
 * @function Phaser.Geom.Triangle.GetPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the points from.
 * @param {number} quantity - The number of evenly spaced points to return. Set to 0 to return an arbitrary number of points based on the `stepRate`.
 * @param {number} stepRate - If `quantity` is 0, the distance between each returned point.
 * @param {(array|Phaser.Geom.Point[])} [out] - An array to which the points should be appended.
 *
 * @return {(array|Phaser.Geom.Point[])} The modified `out` array, or a new array if none was provided.
 */ var GetPoints = function(triangle, quantity, stepRate, out) {
                if (out === undefined) out = [];
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                var length1 = Length(line1);
                var length2 = Length(line2);
                var length3 = Length(line3);
                var perimeter = length1 + length2 + length3;
                //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
                if (!quantity && stepRate > 0) quantity = perimeter / stepRate;
                for(var i = 0; i < quantity; i++){
                    var p = perimeter * (i / quantity);
                    var localPosition = 0;
                    var point = new Point();
                    //  Which line is it on?
                    if (p < length1) {
                        //  Line 1
                        localPosition = p / length1;
                        point.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
                        point.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
                    } else if (p > length1 + length2) {
                        //  Line 3
                        p -= length1 + length2;
                        localPosition = p / length3;
                        point.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
                        point.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
                    } else {
                        //  Line 2
                        p -= length1;
                        localPosition = p / length2;
                        point.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
                        point.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
                    }
                    out.push(point);
                }
                return out;
            };
            module1.exports = GetPoints;
        /***/ },
        /* 472 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a value in an object, allowing for dot notation to control the depth of the property.
 * 
 * For example:
 * 
 * ```javascript
 * var data = {
 *   world: {
 *     position: {
 *       x: 200,
 *       y: 100
 *     }
 *   }
 * };
 * 
 * SetValue(data, 'world.position.y', 300);
 * 
 * console.log(data.world.position.y); // 300
 * ```
 *
 * @function Phaser.Utils.Objects.SetValue
 * @since 3.17.0
 *
 * @param {object} source - The object to set the value in.
 * @param {string} key - The name of the property in the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`)
 * @param {any} value - The value to set into the property, if found in the source object.
 *
 * @return {boolean} `true` if the property key was valid and the value was set, otherwise `false`.
 */ var SetValue = function(source, key, value) {
                if (!source || typeof source === 'number') return false;
                else if (source.hasOwnProperty(key)) {
                    source[key] = value;
                    return true;
                } else if (key.indexOf('.') !== -1) {
                    var keys = key.split('.');
                    var parent = source;
                    var prev = source;
                    //  Use for loop here so we can break early
                    for(var i = 0; i < keys.length; i++){
                        if (parent.hasOwnProperty(keys[i])) {
                            //  Yes it has a key property, let's carry on down
                            prev = parent;
                            parent = parent[keys[i]];
                        } else return false;
                    }
                    prev[keys[keys.length - 1]] = value;
                    return true;
                }
                return false;
            };
            module1.exports = SetValue;
        /***/ },
        /* 473 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(113);
            var Vertex = __webpack_require__(115);
            /**
 * Generates a set of Face and Vertex objects by parsing the given data.
 *
 * This method will take vertex data in one of two formats, based on the `containsZ` parameter.
 *
 * If your vertex data are `x`, `y` pairs, then `containsZ` should be `false` (this is the default)
 *
 * If your vertex data is groups of `x`, `y` and `z` values, then the `containsZ` parameter must be true.
 *
 * The `uvs` parameter is a numeric array consisting of `u` and `v` pairs.
 *
 * The `normals` parameter is a numeric array consisting of `x`, `y` vertex normal values and, if `containsZ` is true, `z` values as well.
 *
 * The `indicies` parameter is an optional array that, if given, is an indexed list of vertices to be added.
 *
 * The `colors` parameter is an optional array, or single value, that if given sets the color of each vertex created.
 *
 * The `alphas` parameter is an optional array, or single value, that if given sets the alpha of each vertex created.
 *
 * When providing indexed data it is assumed that _all_ of the arrays are indexed, not just the vertices.
 *
 * The following example will create a 256 x 256 sized quad using an index array:
 *
 * ```javascript
 * const vertices = [
 *   -128, 128,
 *   128, 128,
 *   -128, -128,
 *   128, -128
 * ];
 *
 * const uvs = [
 *   0, 1,
 *   1, 1,
 *   0, 0,
 *   1, 0
 * ];
 *
 * const indices = [ 0, 2, 1, 2, 3, 1 ];
 *
 * GenerateVerts(vertices, uvs, indicies);
 * ```
 *
 * If the data is not indexed, it's assumed that the arrays all contain sequential data.
 *
 * @function Phaser.Geom.Mesh.GenerateVerts
 * @since 3.50.0
 *
 * @param {number[]} vertices - The vertices array. Either `xy` pairs, or `xyz` if the `containsZ` parameter is `true`.
 * @param {number[]} uvs - The UVs pairs array.
 * @param {number[]} [indicies] - Optional vertex indicies array. If you don't have one, pass `null` or an empty array.
 * @param {boolean} [containsZ=false] - Does the vertices data include a `z` component?
 * @param {number[]} [normals] - Optional vertex normals array. If you don't have one, pass `null` or an empty array.
 * @param {number|number[]} [colors=0xffffff] - An array of colors, one per vertex, or a single color value applied to all vertices.
 * @param {number|number[]} [alphas=1] - An array of alpha values, one per vertex, or a single alpha value applied to all vertices.
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateVerts = function(vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                if (containsZ === undefined) containsZ = false;
                if (colors === undefined) colors = 0xffffff;
                if (alphas === undefined) alphas = 1;
                if (vertices.length !== uvs.length) {
                    console.warn('GenerateVerts: vertices and uvs count not equal');
                    return;
                }
                var result = {
                    faces: [],
                    vertices: []
                };
                var i;
                var x;
                var y;
                var z;
                var u;
                var v;
                var color;
                var alpha;
                var normalX;
                var normalY;
                var normalZ;
                var iInc = containsZ ? 3 : 2;
                var isColorArray = Array.isArray(colors);
                var isAlphaArray = Array.isArray(alphas);
                if (Array.isArray(indicies) && indicies.length > 0) for(i = 0; i < indicies.length; i++){
                    var index1 = indicies[i];
                    var index2 = indicies[i] * 2;
                    var index3 = indicies[i] * iInc;
                    x = vertices[index3];
                    y = vertices[index3 + 1];
                    z = containsZ ? vertices[index3 + 2] : 0;
                    u = uvs[index2];
                    v = uvs[index2 + 1];
                    color = isColorArray ? colors[index1] : colors;
                    alpha = isAlphaArray ? alphas[index1] : alphas;
                    normalX = 0;
                    normalY = 0;
                    normalZ = 0;
                    if (normals) {
                        normalX = normals[index3];
                        normalY = normals[index3 + 1];
                        normalZ = containsZ ? normals[index3 + 2] : 0;
                    }
                    result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                }
                else {
                    var uvIndex = 0;
                    var colorIndex = 0;
                    for(i = 0; i < vertices.length; i += iInc){
                        x = vertices[i];
                        y = vertices[i + 1];
                        z = containsZ ? vertices[i + 2] : 0;
                        u = uvs[uvIndex];
                        v = uvs[uvIndex + 1];
                        color = isColorArray ? colors[colorIndex] : colors;
                        alpha = isAlphaArray ? alphas[colorIndex] : alphas;
                        normalX = 0;
                        normalY = 0;
                        normalZ = 0;
                        if (normals) {
                            normalX = normals[i];
                            normalY = normals[i + 1];
                            normalZ = containsZ ? normals[i + 2] : 0;
                        }
                        result.vertices.push(new Vertex(x, y, z, u, v, color, alpha, normalX, normalY, normalZ));
                        uvIndex += 2;
                        colorIndex++;
                    }
                }
                for(i = 0; i < result.vertices.length; i += 3){
                    var vert1 = result.vertices[i];
                    var vert2 = result.vertices[i + 1];
                    var vert3 = result.vertices[i + 2];
                    result.faces.push(new Face(vert1, vert2, vert3));
                }
                return result;
            };
            module1.exports = GenerateVerts;
        /***/ },
        /* 474 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(113);
            var Matrix4 = __webpack_require__(67);
            var Vector3 = __webpack_require__(38);
            var Vertex = __webpack_require__(115);
            var tempPosition = new Vector3();
            var tempRotation = new Vector3();
            var tempMatrix = new Matrix4();
            /**
 * This method will return an object containing Face and Vertex instances, generated
 * from the parsed triangulated OBJ Model data given to this function.
 *
 * The obj data should have been parsed in advance via the ParseObj function:
 *
 * ```javascript
 * var data = Phaser.Geom.Mesh.ParseObj(rawData, flipUV);
 *
 * var results = GenerateObjVerts(data);
 * ```
 *
 * Alternatively, you can parse obj files loaded via the OBJFile loader:
 *
 * ```javascript
 * preload ()
 * {
 *   this.load.obj('alien', 'assets/3d/alien.obj);
 * }
 *
 * var results = GenerateObjVerts(this.cache.obj.get('alien));
 * ```
 *
 * Make sure your 3D package has triangulated the model data prior to exporting it.
 *
 * You can use the data returned by this function to populate the vertices of a Mesh Game Object.
 *
 * You may add multiple models to a single Mesh, although they will act as one when
 * moved or rotated. You can scale the model data, should it be too small (or large) to visualize.
 * You can also offset the model via the `x`, `y` and `z` parameters.
 *
 * @function Phaser.Geom.Mesh.GenerateObjVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.OBJData} data - The parsed OBJ model data.
 * @param {Phaser.GameObjects.Mesh} [mesh] - An optional Mesh Game Object. If given, the generated Faces will be automatically added to this Mesh. Set to `null` to skip.
 * @param {number} [scale=1] - An amount to scale the model data by. Use this if the model has exported too small, or large, to see.
 * @param {number} [x=0] - Translate the model x position by this amount.
 * @param {number} [y=0] - Translate the model y position by this amount.
 * @param {number} [z=0] - Translate the model z position by this amount.
 * @param {number} [rotateX=0] - Rotate the model on the x axis by this amount, in radians.
 * @param {number} [rotateY=0] - Rotate the model on the y axis by this amount, in radians.
 * @param {number} [rotateZ=0] - Rotate the model on the z axis by this amount, in radians.
 * @param {boolean} [zIsUp=true] - Is the z axis up (true), or is y axis up (false)?
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateVertsResult} The parsed Face and Vertex objects.
 */ var GenerateObjVerts = function(data, mesh, scale, x, y, z, rotateX, rotateY, rotateZ, zIsUp) {
                if (scale === undefined) scale = 1;
                if (x === undefined) x = 0;
                if (y === undefined) y = 0;
                if (z === undefined) z = 0;
                if (rotateX === undefined) rotateX = 0;
                if (rotateY === undefined) rotateY = 0;
                if (rotateZ === undefined) rotateZ = 0;
                if (zIsUp === undefined) zIsUp = true;
                var result = {
                    faces: [],
                    verts: []
                };
                var materials = data.materials;
                tempPosition.set(x, y, z);
                tempRotation.set(rotateX, rotateY, rotateZ);
                tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                for(var m = 0; m < data.models.length; m++){
                    var model = data.models[m];
                    var vertices = model.vertices;
                    var textureCoords = model.textureCoords;
                    var faces = model.faces;
                    for(var i = 0; i < faces.length; i++){
                        var face = faces[i];
                        var v1 = face.vertices[0];
                        var v2 = face.vertices[1];
                        var v3 = face.vertices[2];
                        var m1 = vertices[v1.vertexIndex];
                        var m2 = vertices[v2.vertexIndex];
                        var m3 = vertices[v3.vertexIndex];
                        var t1 = v1.textureCoordsIndex;
                        var t2 = v2.textureCoordsIndex;
                        var t3 = v3.textureCoordsIndex;
                        var uv1 = t1 === -1 ? {
                            u: 0,
                            v: 1
                        } : textureCoords[t1];
                        var uv2 = t2 === -1 ? {
                            u: 0,
                            v: 0
                        } : textureCoords[t2];
                        var uv3 = t3 === -1 ? {
                            u: 1,
                            v: 1
                        } : textureCoords[t3];
                        var color = 0xffffff;
                        if (face.material !== '' && materials[face.material]) color = materials[face.material];
                        var vert1 = new Vertex(m1.x * scale, m1.y * scale, m1.z * scale, uv1.u, uv1.v, color).transformMat4(tempMatrix);
                        var vert2 = new Vertex(m2.x * scale, m2.y * scale, m2.z * scale, uv2.u, uv2.v, color).transformMat4(tempMatrix);
                        var vert3 = new Vertex(m3.x * scale, m3.y * scale, m3.z * scale, uv3.u, uv3.v, color).transformMat4(tempMatrix);
                        result.verts.push(vert1, vert2, vert3);
                        result.faces.push(new Face(vert1, vert2, vert3));
                    }
                }
                if (mesh) {
                    mesh.faces = mesh.faces.concat(result.faces);
                    mesh.vertices = mesh.vertices.concat(result.verts);
                }
                return result;
            };
            module1.exports = GenerateObjVerts;
        /***/ },
        /* 475 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(62);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var RGB = __webpack_require__(197);
            var Utils = __webpack_require__(12);
            /**
 * @classdesc
 * A 2D point light.
 *
 * These are typically created by a {@link Phaser.GameObjects.LightsManager}, available from within a scene via `this.lights`.
 *
 * Any Game Objects using the Light2D pipeline will then be affected by these Lights as long as they have a normal map.
 *
 * They can also simply be used to represent a point light for your own purposes.
 *
 * @class Light
 * @extends Phaser.Geom.Circle
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {number} x - The horizontal position of the light.
 * @param {number} y - The vertical position of the light.
 * @param {number} radius - The radius of the light.
 * @param {number} r - The red color of the light. A value between 0 and 1.
 * @param {number} g - The green color of the light. A value between 0 and 1.
 * @param {number} b - The blue color of the light. A value between 0 and 1.
 * @param {number} intensity - The intensity of the light.
 */ var Light = new Class({
                Extends: Circle,
                Mixins: [
                    Components.ScrollFactor,
                    Components.Visible
                ],
                initialize: function Light(x, y, radius, r, g, b, intensity) {
                    Circle.call(this, x, y, radius);
                    /**
         * The color of the light.
         *
         * @name Phaser.GameObjects.Light#color
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.color = new RGB(r, g, b);
                    /**
         * The intensity of the light.
         *
         * @name Phaser.GameObjects.Light#intensity
         * @type {number}
         * @since 3.50.0
         */ this.intensity = intensity;
                    /**
         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
         * If those components are not used by your custom class then you can use this bitmask as you wish.
         *
         * @name Phaser.GameObjects.GameObject#renderFlags
         * @type {number}
         * @default 15
         * @since 3.0.0
         */ this.renderFlags = 15;
                    /**
         * A bitmask that controls if this Game Object is drawn by a Camera or not.
         * Not usually set directly, instead call `Camera.ignore`, however you can
         * set this property directly using the Camera.id property:
         *
         * @example
         * this.cameraFilter |= camera.id
         *
         * @name Phaser.GameObjects.GameObject#cameraFilter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.cameraFilter = 0;
                    this.setScrollFactor(1, 1);
                },
                /**
     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
     * Also checks the Game Object against the given Cameras exclusion list.
     *
     * @method Phaser.GameObjects.Light#willRender
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to check against this Game Object.
     *
     * @return {boolean} True if the Game Object should be rendered, otherwise false.
     */ willRender: function(camera) {
                    return !(Light.RENDER_MASK !== this.renderFlags || this.cameraFilter !== 0 && this.cameraFilter & camera.id);
                },
                /**
     * Set the color of the light from a single integer RGB value.
     *
     * @method Phaser.GameObjects.Light#setColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the light.
     *
     * @return {this} This Light object.
     */ setColor: function(rgb) {
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    this.color.set(color[0], color[1], color[2]);
                    return this;
                },
                /**
     * Set the intensity of the light.
     *
     * @method Phaser.GameObjects.Light#setIntensity
     * @since 3.0.0
     *
     * @param {number} intensity - The intensity of the light.
     *
     * @return {this} This Light object.
     */ setIntensity: function(intensity) {
                    this.intensity = intensity;
                    return this;
                },
                /**
     * Set the radius of the light.
     *
     * @method Phaser.GameObjects.Light#setRadius
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the light.
     *
     * @return {this} This Light object.
     */ setRadius: function(radius) {
                    this.radius = radius;
                    return this;
                }
            });
            /**
 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
 *
 * @constant {number} RENDER_MASK
 * @memberof Phaser.GameObjects.Light
 * @default
 */ Light.RENDER_MASK = 15;
            module1.exports = Light;
        /***/ },
        /* 476 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleToRectangle = __webpack_require__(150);
            var Class = __webpack_require__(0);
            var DistanceBetween = __webpack_require__(48);
            var Light = __webpack_require__(475);
            var PointLight = __webpack_require__(149);
            var RGB = __webpack_require__(197);
            var SpliceOne = __webpack_require__(74);
            var StableSort = __webpack_require__(79);
            var Utils = __webpack_require__(12);
            /**
 * @callback LightForEach
 *
 * @param {Phaser.GameObjects.Light} light - The Light.
 */ /**
 * @classdesc
 * Manages Lights for a Scene.
 *
 * Affects the rendering of Game Objects using the `Light2D` pipeline.
 *
 * @class LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 */ var LightsManager = new Class({
                initialize: function LightsManager() {
                    /**
         * The Lights in the Scene.
         *
         * @name Phaser.GameObjects.LightsManager#lights
         * @type {Phaser.GameObjects.Light[]}
         * @default []
         * @since 3.0.0
         */ this.lights = [];
                    /**
         * The ambient color.
         *
         * @name Phaser.GameObjects.LightsManager#ambientColor
         * @type {Phaser.Display.RGB}
         * @since 3.50.0
         */ this.ambientColor = new RGB(0.1, 0.1, 0.1);
                    /**
         * Whether the Lights Manager is enabled.
         *
         * @name Phaser.GameObjects.LightsManager#active
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.active = false;
                    /**
         * The maximum number of lights that a single Camera and the lights shader can process.
         * Change this via the `maxLights` property in your game config, as it cannot be changed at runtime.
         *
         * @name Phaser.GameObjects.LightsManager#maxLights
         * @type {number}
         * @readonly
         * @since 3.15.0
         */ this.maxLights = -1;
                    /**
         * The number of lights that the LightPipeline processed in the _previous_ frame.
         *
         * @name Phaser.GameObjects.LightsManager#visibleLights
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.visibleLights = 0;
                },
                addPointLight: function(x, y, color, radius, intensity) {
                    return this.systems.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity));
                },
                /**
     * Enable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#enable
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
     */ enable: function() {
                    if (this.maxLights === -1) this.maxLights = this.scene.sys.renderer.config.maxLights;
                    this.active = true;
                    return this;
                },
                /**
     * Disable the Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#disable
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
     */ disable: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Get all lights that can be seen by the given Camera.
     *
     * It will automatically cull lights that are outside the world view of the Camera.
     *
     * If more lights are returned than supported by the pipeline, the lights are then culled
     * based on the distance from the center of the camera. Only those closest are rendered.
     *
     * @method Phaser.GameObjects.LightsManager#getLights
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to cull Lights for.
     *
     * @return {Phaser.GameObjects.Light[]} The culled Lights.
     */ getLights: function(camera) {
                    var lights = this.lights;
                    var worldView = camera.worldView;
                    var visibleLights = [];
                    for(var i = 0; i < lights.length; i++){
                        var light = lights[i];
                        if (light.willRender(camera) && CircleToRectangle(light, worldView)) visibleLights.push({
                            light: light,
                            distance: DistanceBetween(light.x, light.y, worldView.centerX, worldView.centerY)
                        });
                    }
                    if (visibleLights.length > this.maxLights) {
                        //  We've got too many lights, so sort by distance from camera and cull those far away
                        //  This isn't ideal because it doesn't factor in the radius of the lights, but it'll do for now
                        //  and is significantly better than we had before!
                        StableSort(visibleLights, this.sortByDistance);
                        visibleLights = visibleLights.slice(0, this.maxLights);
                    }
                    this.visibleLights = visibleLights.length;
                    return visibleLights;
                },
                sortByDistance: function(a, b) {
                    return a.distance >= b.distance;
                },
                /**
     * Set the ambient light color.
     *
     * @method Phaser.GameObjects.LightsManager#setAmbientColor
     * @since 3.0.0
     *
     * @param {number} rgb - The integer RGB color of the ambient light.
     *
     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
     */ setAmbientColor: function(rgb) {
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    this.ambientColor.set(color[0], color[1], color[2]);
                    return this;
                },
                /**
     * Returns the maximum number of Lights allowed to appear at once.
     *
     * @method Phaser.GameObjects.LightsManager#getMaxVisibleLights
     * @since 3.0.0
     *
     * @return {number} The maximum number of Lights allowed to appear at once.
     */ getMaxVisibleLights: function() {
                    return this.maxLights;
                },
                /**
     * Get the number of Lights managed by this Lights Manager.
     *
     * @method Phaser.GameObjects.LightsManager#getLightCount
     * @since 3.0.0
     *
     * @return {number} The number of Lights managed by this Lights Manager.
     */ getLightCount: function() {
                    return this.lights.length;
                },
                /**
     * Add a Light.
     *
     * @method Phaser.GameObjects.LightsManager#addLight
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Light.
     * @param {number} [y=0] - The vertical position of the Light.
     * @param {number} [radius=100] - The radius of the Light.
     * @param {number} [rgb=0xffffff] - The integer RGB color of the light.
     * @param {number} [intensity=1] - The intensity of the Light.
     *
     * @return {Phaser.GameObjects.Light} The Light that was added.
     */ addLight: function(x, y, radius, rgb, intensity) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (radius === undefined) radius = 128;
                    if (rgb === undefined) rgb = 0xffffff;
                    if (intensity === undefined) intensity = 1;
                    var color = Utils.getFloatsFromUintRGB(rgb);
                    var light = new Light(x, y, radius, color[0], color[1], color[2], intensity);
                    this.lights.push(light);
                    return light;
                },
                /**
     * Remove a Light.
     *
     * @method Phaser.GameObjects.LightsManager#removeLight
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Light} light - The Light to remove.
     *
     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
     */ removeLight: function(light) {
                    var index = this.lights.indexOf(light);
                    if (index >= 0) SpliceOne(this.lights, index);
                    return this;
                },
                /**
     * Shut down the Lights Manager.
     *
     * Recycles all active Lights into the Light pool, resets ambient light color and clears the lists of Lights and
     * culled Lights.
     *
     * @method Phaser.GameObjects.LightsManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.lights.length = 0;
                },
                /**
     * Destroy the Lights Manager.
     *
     * Cleans up all references by calling {@link Phaser.GameObjects.LightsManager#shutdown}.
     *
     * @method Phaser.GameObjects.LightsManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                }
            });
            module1.exports = LightsManager;
        /***/ },
        /* 477 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(55);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Geom
 */ var Geom = {
                Circle: __webpack_require__(1185),
                Ellipse: __webpack_require__(1195),
                Intersects: __webpack_require__(478),
                Line: __webpack_require__(1215),
                Mesh: __webpack_require__(1237),
                Point: __webpack_require__(1240),
                Polygon: __webpack_require__(1254),
                Rectangle: __webpack_require__(496),
                Triangle: __webpack_require__(1287)
            };
            //   Merge in the consts
            Geom = Extend(false, Geom, CONST);
            module1.exports = Geom;
        /***/ },
        /* 478 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Intersects
 */ module1.exports = {
                CircleToCircle: __webpack_require__(228),
                CircleToRectangle: __webpack_require__(150),
                GetCircleToCircle: __webpack_require__(1205),
                GetCircleToRectangle: __webpack_require__(1206),
                GetLineToCircle: __webpack_require__(229),
                GetLineToLine: __webpack_require__(479),
                GetLineToPoints: __webpack_require__(480),
                GetLineToPolygon: __webpack_require__(481),
                GetLineToRectangle: __webpack_require__(231),
                GetRaysFromPointToPolygon: __webpack_require__(1207),
                GetRectangleIntersection: __webpack_require__(1208),
                GetRectangleToRectangle: __webpack_require__(1209),
                GetRectangleToTriangle: __webpack_require__(1210),
                GetTriangleToCircle: __webpack_require__(1211),
                GetTriangleToLine: __webpack_require__(486),
                GetTriangleToTriangle: __webpack_require__(1212),
                LineToCircle: __webpack_require__(230),
                LineToLine: __webpack_require__(92),
                LineToRectangle: __webpack_require__(482),
                PointToLine: __webpack_require__(490),
                PointToLineSegment: __webpack_require__(1213),
                RectangleToRectangle: __webpack_require__(114),
                RectangleToTriangle: __webpack_require__(483),
                RectangleToValues: __webpack_require__(1214),
                TriangleToCircle: __webpack_require__(485),
                TriangleToLine: __webpack_require__(487),
                TriangleToTriangle: __webpack_require__(488)
            };
        /***/ },
        /* 479 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(38);
            /**
 * Checks for intersection between the two line segments and returns the intersection point as a Vector3,
 * or `null` if the lines are parallel, or do not intersect.
 *
 * The `z` property of the Vector3 contains the intersection distance, which can be used to find
 * the closest intersecting point from a group of line segments.
 *
 * @function Phaser.Geom.Intersects.GetLineToLine
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line1 - The first line segment to check.
 * @param {Phaser.Geom.Line} line2 - The second line segment to check.
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToLine = function(line1, line2, out) {
                var x1 = line1.x1;
                var y1 = line1.y1;
                var x2 = line1.x2;
                var y2 = line1.y2;
                var x3 = line2.x1;
                var y3 = line2.y1;
                var x4 = line2.x2;
                var y4 = line2.y2;
                var dx1 = x2 - x1;
                var dy1 = y2 - y1;
                var dx2 = x4 - x3;
                var dy2 = y4 - y3;
                var denom = dy2 * dx1 - dx2 * dy1;
                //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
                //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
                //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
                if (dx1 === 0 || denom === 0) return false;
                var T2 = (dx1 * (y3 - y1) + dy1 * (x1 - x3)) / (dx2 * dy1 - dy2 * dx1);
                var T1 = (x3 + dx2 * T2 - x1) / dx1;
                //  Intersects?
                if (T1 < 0 || T2 < 0 || T2 > 1) return null;
                if (out === undefined) out = new Vector3();
                return out.set(x1 + dx1 * T1, y1 + dy1 * T1, T1);
            };
            module1.exports = GetLineToLine;
        /***/ },
        /* 480 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(38);
            var GetLineToLine = __webpack_require__(479);
            var Line = __webpack_require__(45);
            //  Temp calculation segment
            var segment = new Line();
            //  Temp vec3
            var tempIntersect = new Vector3();
            /**
 * Checks for the closest point of intersection between a line segment and an array of points, where each pair
 * of points are converted to line segments for the intersection tests.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector3 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 *
 * @function Phaser.Geom.Intersects.GetLineToPoints
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Math.Vector2[] | Phaser.Geom.Point[]} points - An array of points to check.
 * @param {Phaser.Math.Vector3} [out] - A Vector3 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector3} A Vector3 containing the intersection results, or `null`.
 */ var GetLineToPoints = function(line, points, out) {
                if (out === undefined) out = new Vector3();
                var closestIntersect = false;
                //  Reset our vec3s
                out.set();
                tempIntersect.set();
                var prev = points[0];
                for(var i = 1; i < points.length; i++){
                    var current = points[i];
                    segment.setTo(prev.x, prev.y, current.x, current.y);
                    prev = current;
                    if (GetLineToLine(line, segment, tempIntersect)) {
                        if (!closestIntersect || tempIntersect.z < out.z) {
                            out.copy(tempIntersect);
                            closestIntersect = true;
                        }
                    }
                }
                return closestIntersect ? out : null;
            };
            module1.exports = GetLineToPoints;
        /***/ },
        /* 481 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(38);
            var Vector4 = __webpack_require__(138);
            var GetLineToPoints = __webpack_require__(480);
            //  Temp vec3
            var tempIntersect = new Vector3();
            /**
 * Checks for the closest point of intersection between a line segment and an array of polygons.
 *
 * If no intersection is found, this function returns `null`.
 *
 * If intersection was found, a Vector4 is returned with the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the closest distance.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetLineToPolygon
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Line} line - The line segment to check.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check.
 * @param {Phaser.Math.Vector4} [out] - A Vector4 to store the intersection results in.
 *
 * @return {Phaser.Math.Vector4} A Vector4 containing the intersection results, or `null`.
 */ var GetLineToPolygon = function(line, polygons, out) {
                if (out === undefined) out = new Vector4();
                if (!Array.isArray(polygons)) polygons = [
                    polygons
                ];
                var closestIntersect = false;
                //  Reset our vec4s
                out.set();
                tempIntersect.set();
                for(var i = 0; i < polygons.length; i++){
                    if (GetLineToPoints(line, polygons[i].points, tempIntersect)) {
                        if (!closestIntersect || tempIntersect.z < out.z) {
                            out.set(tempIntersect.x, tempIntersect.y, tempIntersect.z, i);
                            closestIntersect = true;
                        }
                    }
                }
                return closestIntersect ? out : null;
            };
            module1.exports = GetLineToPolygon;
        /***/ },
        /* 482 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks for intersection between the Line and a Rectangle shape, or a rectangle-like
 * object, with public `x`, `y`, `right` and `bottom` properties, such as a Sprite or Body.
 *
 * An intersection is considered valid if:
 *
 * The line starts within, or ends within, the Rectangle.
 * The line segment intersects one of the 4 rectangle edges.
 *
 * The for the purposes of this function rectangles are considered 'solid'.
 *
 * @function Phaser.Geom.Intersects.LineToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line to check for intersection.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle to check for intersection.
 *
 * @return {boolean} `true` if the Line and the Rectangle intersect, `false` otherwise.
 */ var LineToRectangle = function(line, rect) {
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var bx1 = rect.x;
                var by1 = rect.y;
                var bx2 = rect.right;
                var by2 = rect.bottom;
                var t = 0;
                //  If the start or end of the line is inside the rect then we assume
                //  collision, as rects are solid for our use-case.
                if (x1 >= bx1 && x1 <= bx2 && y1 >= by1 && y1 <= by2 || x2 >= bx1 && x2 <= bx2 && y2 >= by1 && y2 <= by2) return true;
                if (x1 < bx1 && x2 >= bx1) {
                    //  Left edge
                    t = y1 + (y2 - y1) * (bx1 - x1) / (x2 - x1);
                    if (t > by1 && t <= by2) return true;
                } else if (x1 > bx2 && x2 <= bx2) {
                    //  Right edge
                    t = y1 + (y2 - y1) * (bx2 - x1) / (x2 - x1);
                    if (t >= by1 && t <= by2) return true;
                }
                if (y1 < by1 && y2 >= by1) {
                    //  Top edge
                    t = x1 + (x2 - x1) * (by1 - y1) / (y2 - y1);
                    if (t >= bx1 && t <= bx2) return true;
                } else if (y1 > by2 && y2 <= by2) {
                    //  Bottom edge
                    t = x1 + (x2 - x1) * (by2 - y1) / (y2 - y1);
                    if (t >= bx1 && t <= bx2) return true;
                }
                return false;
            };
            module1.exports = LineToRectangle;
        /***/ },
        /* 483 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(92);
            var Contains = __webpack_require__(56);
            var ContainsArray = __webpack_require__(232);
            var Decompose = __webpack_require__(484);
            /**
 * Checks for intersection between Rectangle shape and Triangle shape.
 *
 * @function Phaser.Geom.Intersects.RectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 *
 * @return {boolean} A value of `true` if objects intersect; otherwise `false`.
 */ var RectangleToTriangle = function(rect, triangle) {
                //  First the cheapest ones:
                if (triangle.left > rect.right || triangle.right < rect.left || triangle.top > rect.bottom || triangle.bottom < rect.top) return false;
                var triA = triangle.getLineA();
                var triB = triangle.getLineB();
                var triC = triangle.getLineC();
                //  Are any of the triangle points within the rectangle?
                if (Contains(rect, triA.x1, triA.y1) || Contains(rect, triA.x2, triA.y2)) return true;
                if (Contains(rect, triB.x1, triB.y1) || Contains(rect, triB.x2, triB.y2)) return true;
                if (Contains(rect, triC.x1, triC.y1) || Contains(rect, triC.x2, triC.y2)) return true;
                //  Cheap tests over, now to see if any of the lines intersect ...
                var rectA = rect.getLineA();
                var rectB = rect.getLineB();
                var rectC = rect.getLineC();
                var rectD = rect.getLineD();
                if (LineToLine(triA, rectA) || LineToLine(triA, rectB) || LineToLine(triA, rectC) || LineToLine(triA, rectD)) return true;
                if (LineToLine(triB, rectA) || LineToLine(triB, rectB) || LineToLine(triB, rectC) || LineToLine(triB, rectD)) return true;
                if (LineToLine(triC, rectA) || LineToLine(triC, rectB) || LineToLine(triC, rectC) || LineToLine(triC, rectD)) return true;
                //  None of the lines intersect, so are any rectangle points within the triangle?
                var points = Decompose(rect);
                var within = ContainsArray(triangle, points, true);
                return within.length > 0;
            };
            module1.exports = RectangleToTriangle;
        /***/ },
        /* 484 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Create an array of points for each corner of a Rectangle
 * If an array is specified, each point object will be added to the end of the array, otherwise a new array will be created.
 *
 * @function Phaser.Geom.Rectangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object to be decomposed.
 * @param {array} [out] - If provided, each point will be added to this array.
 *
 * @return {array} Will return the array you specified or a new array containing the points of the Rectangle.
 */ var Decompose = function(rect, out) {
                if (out === undefined) out = [];
                out.push({
                    x: rect.x,
                    y: rect.y
                });
                out.push({
                    x: rect.right,
                    y: rect.y
                });
                out.push({
                    x: rect.right,
                    y: rect.bottom
                });
                out.push({
                    x: rect.x,
                    y: rect.bottom
                });
                return out;
            };
            module1.exports = Decompose;
        /***/ },
        /* 485 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToCircle = __webpack_require__(230);
            var Contains = __webpack_require__(112);
            /**
 * Checks if a Triangle and a Circle intersect.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.TriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 *
 * @return {boolean} `true` if the Triangle and the `Circle` intersect, otherwise `false`.
 */ var TriangleToCircle = function(triangle, circle) {
                //  First the cheapest ones:
                if (triangle.left > circle.right || triangle.right < circle.left || triangle.top > circle.bottom || triangle.bottom < circle.top) return false;
                if (Contains(triangle, circle.x, circle.y)) return true;
                if (LineToCircle(triangle.getLineA(), circle)) return true;
                if (LineToCircle(triangle.getLineB(), circle)) return true;
                if (LineToCircle(triangle.getLineC(), circle)) return true;
                return false;
            };
            module1.exports = TriangleToCircle;
        /***/ },
        /* 486 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var TriangleToLine = __webpack_require__(487);
            var LineToLine = __webpack_require__(92);
            /**
 * Checks if a Triangle and a Line intersect, and returns the intersection points as a Point object array.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToLine = function(triangle, line, out) {
                if (out === undefined) out = [];
                if (TriangleToLine(triangle, line)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    var output = [
                        new Point(),
                        new Point(),
                        new Point()
                    ];
                    var result = [
                        LineToLine(lineA, line, output[0]),
                        LineToLine(lineB, line, output[1]),
                        LineToLine(lineC, line, output[2])
                    ];
                    for(var i = 0; i < 3; i++)if (result[i]) out.push(output[i]);
                }
                return out;
            };
            module1.exports = GetTriangleToLine;
        /***/ },
        /* 487 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineToLine = __webpack_require__(92);
            /**
 * Checks if a Triangle and a Line intersect.
 *
 * The Line intersects the Triangle if it starts inside of it, ends inside of it, or crosses any of the Triangle's sides. Thus, the Triangle is considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToLine
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check with.
 * @param {Phaser.Geom.Line} line - The Line to check with.
 *
 * @return {boolean} `true` if the Triangle and the Line intersect, otherwise `false`.
 */ var TriangleToLine = function(triangle, line) {
                //  If the Triangle contains either the start or end point of the line, it intersects
                if (triangle.contains(line.x1, line.y1) || triangle.contains(line.x2, line.y2)) return true;
                //  Now check the line against each line of the Triangle
                if (LineToLine(triangle.getLineA(), line)) return true;
                if (LineToLine(triangle.getLineB(), line)) return true;
                if (LineToLine(triangle.getLineC(), line)) return true;
                return false;
            };
            module1.exports = TriangleToLine;
        /***/ },
        /* 488 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ContainsArray = __webpack_require__(232);
            var Decompose = __webpack_require__(489);
            var LineToLine = __webpack_require__(92);
            /**
 * Checks if two Triangles intersect.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.TriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 *
 * @return {boolean} `true` if the Triangles intersect, otherwise `false`.
 */ var TriangleToTriangle = function(triangleA, triangleB) {
                //  First the cheapest ones:
                if (triangleA.left > triangleB.right || triangleA.right < triangleB.left || triangleA.top > triangleB.bottom || triangleA.bottom < triangleB.top) return false;
                var lineAA = triangleA.getLineA();
                var lineAB = triangleA.getLineB();
                var lineAC = triangleA.getLineC();
                var lineBA = triangleB.getLineA();
                var lineBB = triangleB.getLineB();
                var lineBC = triangleB.getLineC();
                //  Now check the lines against each line of TriangleB
                if (LineToLine(lineAA, lineBA) || LineToLine(lineAA, lineBB) || LineToLine(lineAA, lineBC)) return true;
                if (LineToLine(lineAB, lineBA) || LineToLine(lineAB, lineBB) || LineToLine(lineAB, lineBC)) return true;
                if (LineToLine(lineAC, lineBA) || LineToLine(lineAC, lineBB) || LineToLine(lineAC, lineBC)) return true;
                //  Nope, so check to see if any of the points of triangleA are within triangleB
                var points = Decompose(triangleA);
                var within = ContainsArray(triangleB, points, true);
                if (within.length > 0) return true;
                //  Finally check to see if any of the points of triangleB are within triangleA
                points = Decompose(triangleB);
                within = ContainsArray(triangleA, points, true);
                if (within.length > 0) return true;
                return false;
            };
            module1.exports = TriangleToTriangle;
        /***/ },
        /* 489 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decomposes a Triangle into an array of its points.
 *
 * @function Phaser.Geom.Triangle.Decompose
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to decompose.
 * @param {array} [out] - An array to store the points into.
 *
 * @return {array} The provided `out` array, or a new array if none was provided, with three objects with `x` and `y` properties representing each point of the Triangle appended to it.
 */ var Decompose = function(triangle, out) {
                if (out === undefined) out = [];
                out.push({
                    x: triangle.x1,
                    y: triangle.y1
                });
                out.push({
                    x: triangle.x2,
                    y: triangle.y2
                });
                out.push({
                    x: triangle.x3,
                    y: triangle.y3
                });
                return out;
            };
            module1.exports = Decompose;
        /***/ },
        /* 490 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the a Point falls between the two end-points of a Line, based on the given line thickness.
 * 
 * Assumes that the line end points are circular, not square.
 *
 * @function Phaser.Geom.Intersects.PointToLine
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Point|any)} point - The point, or point-like object to check.
 * @param {Phaser.Geom.Line} line - The line segment to test for intersection on.
 * @param {number} [lineThickness=1] - The line thickness. Assumes that the line end points are circular.
 *
 * @return {boolean} `true` if the Point falls on the Line, otherwise `false`.
 */ var PointToLine = function(point, line, lineThickness) {
                if (lineThickness === undefined) lineThickness = 1;
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var px = point.x;
                var py = point.y;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return false;
                var r = ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / L2;
                //  Assume line thickness is circular
                if (r < 0) //  Outside line1
                return Math.sqrt((x1 - px) * (x1 - px) + (y1 - py) * (y1 - py)) <= lineThickness;
                else if (r >= 0 && r <= 1) {
                    //  On the line segment
                    var s = ((y1 - py) * (x2 - x1) - (x1 - px) * (y2 - y1)) / L2;
                    return Math.abs(s) * Math.sqrt(L2) <= lineThickness;
                } else //  Outside line2
                return Math.sqrt((x2 - px) * (x2 - px) + (y2 - py) * (y2 - py)) <= lineThickness;
            };
            module1.exports = PointToLine;
        /***/ },
        /* 491 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Wrap = __webpack_require__(66);
            var Angle = __webpack_require__(93);
            /**
 * Get the angle of the normal of the given line in radians.
 *
 * @function Phaser.Geom.Line.NormalAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the angle of the normal of.
 *
 * @return {number} The angle of the normal of the line in radians.
 */ var NormalAngle = function(line) {
                var angle = Angle(line) - MATH_CONST.TAU;
                return Wrap(angle, -Math.PI, Math.PI);
            };
            module1.exports = NormalAngle;
        /***/ },
        /* 492 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var flip = true;
            var defaultModelName = 'untitled';
            var currentGroup = '';
            var currentMaterial = '';
            /**
 * @ignore
 */ function stripComments(line) {
                var idx = line.indexOf('#');
                return idx > -1 ? line.substring(0, idx) : line;
            }
            /**
 * @ignore
 */ function currentModel(result) {
                if (result.models.length === 0) result.models.push({
                    faces: [],
                    name: defaultModelName,
                    textureCoords: [],
                    vertexNormals: [],
                    vertices: []
                });
                currentGroup = '';
                return result.models[result.models.length - 1];
            }
            /**
 * @ignore
 */ function parseObject(lineItems, result) {
                var modelName = lineItems.length >= 2 ? lineItems[1] : defaultModelName;
                result.models.push({
                    faces: [],
                    name: modelName,
                    textureCoords: [],
                    vertexNormals: [],
                    vertices: []
                });
                currentGroup = '';
            }
            /**
 * @ignore
 */ function parseGroup(lineItems) {
                if (lineItems.length === 2) currentGroup = lineItems[1];
            }
            /**
 * @ignore
 */ function parseVertexCoords(lineItems, result) {
                var len = lineItems.length;
                var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                currentModel(result).vertices.push({
                    x: x,
                    y: y,
                    z: z
                });
            }
            /**
 * @ignore
 */ function parseTextureCoords(lineItems, result) {
                var len = lineItems.length;
                var u = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var v = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var w = len >= 4 ? parseFloat(lineItems[3]) : 0;
                if (isNaN(u)) u = 0;
                if (isNaN(v)) v = 0;
                if (isNaN(w)) w = 0;
                if (flip) v = 1 - v;
                currentModel(result).textureCoords.push({
                    u: u,
                    v: v,
                    w: w
                });
            }
            /**
 * @ignore
 */ function parseVertexNormal(lineItems, result) {
                var len = lineItems.length;
                var x = len >= 2 ? parseFloat(lineItems[1]) : 0;
                var y = len >= 3 ? parseFloat(lineItems[2]) : 0;
                var z = len >= 4 ? parseFloat(lineItems[3]) : 0;
                currentModel(result).vertexNormals.push({
                    x: x,
                    y: y,
                    z: z
                });
            }
            /**
 * @ignore
 */ function parsePolygon(lineItems, result) {
                var totalVertices = lineItems.length - 1;
                if (totalVertices < 3) return;
                var face = {
                    group: currentGroup,
                    material: currentMaterial,
                    vertices: []
                };
                for(var i = 0; i < totalVertices; i++){
                    var vertexString = lineItems[i + 1];
                    var vertexValues = vertexString.split('/');
                    var vvLen = vertexValues.length;
                    if (vvLen < 1 || vvLen > 3) continue;
                    var vertexIndex = 0;
                    var textureCoordsIndex = 0;
                    var vertexNormalIndex = 0;
                    vertexIndex = parseInt(vertexValues[0], 10);
                    if (vvLen > 1 && vertexValues[1] !== '') textureCoordsIndex = parseInt(vertexValues[1], 10);
                    if (vvLen > 2) vertexNormalIndex = parseInt(vertexValues[2], 10);
                    if (vertexIndex !== 0) {
                        // Negative vertex indices refer to the nth last defined vertex
                        // convert these to postive indices for simplicity
                        if (vertexIndex < 0) vertexIndex = currentModel(result).vertices.length + 1 + vertexIndex;
                        textureCoordsIndex -= 1;
                        vertexIndex -= 1;
                        vertexNormalIndex -= 1;
                        face.vertices.push({
                            textureCoordsIndex: textureCoordsIndex,
                            vertexIndex: vertexIndex,
                            vertexNormalIndex: vertexNormalIndex
                        });
                    }
                }
                currentModel(result).faces.push(face);
            }
            /**
 * @ignore
 */ function parseMtlLib(lineItems, result) {
                if (lineItems.length >= 2) result.materialLibraries.push(lineItems[1]);
            }
            /**
 * @ignore
 */ function parseUseMtl(lineItems) {
                if (lineItems.length >= 2) currentMaterial = lineItems[1];
            }
            /**
 * Parses a Wavefront OBJ File, extracting the models from it and returning them in an array.
 *
 * The model data *must* be triangulated for a Mesh Game Object to be able to render it.
 *
 * @function Phaser.Geom.Mesh.ParseObj
 * @since 3.50.0
 *
 * @param {string} data - The OBJ File data as a raw string.
 * @param {boolean} [flipUV=true] - Flip the UV coordinates?
 *
 * @return {Phaser.Types.Geom.Mesh.OBJData} The parsed model and material data.
 */ var ParseObj = function(data, flipUV) {
                if (flipUV === undefined) flipUV = true;
                flip = flipUV;
                //  Store results in here
                var result = {
                    materials: {},
                    materialLibraries: [],
                    models: []
                };
                currentGroup = '';
                currentMaterial = '';
                var lines = data.split('\n');
                for(var i = 0; i < lines.length; i++){
                    var line = stripComments(lines[i]);
                    var lineItems = line.replace(/\s\s+/g, ' ').trim().split(' ');
                    switch(lineItems[0].toLowerCase()){
                        case 'o':
                            // Start A New Model
                            parseObject(lineItems, result);
                            break;
                        case 'g':
                            // Start a new polygon group
                            parseGroup(lineItems);
                            break;
                        case 'v':
                            // Define a vertex for the current model
                            parseVertexCoords(lineItems, result);
                            break;
                        case 'vt':
                            // Texture Coords
                            parseTextureCoords(lineItems, result);
                            break;
                        case 'vn':
                            // Define a vertex normal for the current model
                            parseVertexNormal(lineItems, result);
                            break;
                        case 'f':
                            // Define a Face/Polygon
                            parsePolygon(lineItems, result);
                            break;
                        case 'mtllib':
                            // Reference to a material library file (.mtl)
                            parseMtlLib(lineItems, result);
                            break;
                        case 'usemtl':
                            // Sets the current material to be applied to polygons defined from this point forward
                            parseUseMtl(lineItems);
                            break;
                    }
                }
                return result;
            };
            module1.exports = ParseObj;
        /***/ },
        /* 493 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(100);
            /**
 * Takes a Wavefront Material file and extracts the diffuse reflectivity of the named
 * materials, converts them to integer color values and returns them.
 *
 * This is used internally by the `addOBJ` and `addModel` methods, but is exposed for
 * public consumption as well.
 *
 * Note this only works with diffuse values, specified in the `Kd r g b` format, where
 * `g` and `b` are optional, but `r` is required. It does not support spectral rfl files,
 * or any other material statement (such as `Ka` or `Ks`)
 *
 * @method Phaser.Geom.Mesh.ParseObjMaterial
 * @since 3.50.0
 *
 * @param {string} mtl - The OBJ MTL file as a raw string, i.e. loaded via `this.load.text`.
 *
 * @return {object} The parsed material colors, where each property of the object matches the material name.
 */ var ParseObjMaterial = function(mtl) {
                var output = {};
                var lines = mtl.split('\n');
                var currentMaterial = '';
                for(var i = 0; i < lines.length; i++){
                    var line = lines[i].trim();
                    if (line.indexOf('#') === 0 || line === '') continue;
                    var lineItems = line.replace(/\s\s+/g, ' ').trim().split(' ');
                    switch(lineItems[0].toLowerCase()){
                        case 'newmtl':
                            currentMaterial = lineItems[1];
                            break;
                        //  The diffuse reflectivity of the current material
                        //  Support r, [g], [b] format, where g and b are optional
                        case 'kd':
                            var r = Math.floor(lineItems[1] * 255);
                            var g = lineItems.length >= 2 ? Math.floor(lineItems[2] * 255) : r;
                            var b = lineItems.length >= 3 ? Math.floor(lineItems[3] * 255) : r;
                            output[currentMaterial] = GetColor(r, g, b);
                            break;
                    }
                }
                return output;
            };
            module1.exports = ParseObjMaterial;
        /***/ },
        /* 494 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the magnitude of the point, which equivalent to the length of the line from the origin to this point.
 *
 * @function Phaser.Geom.Point.GetMagnitude
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The point to calculate the magnitude for
 *
 * @return {number} The resulting magnitude
 */ var GetMagnitude = function(point) {
                return Math.sqrt(point.x * point.x + point.y * point.y);
            };
            module1.exports = GetMagnitude;
        /***/ },
        /* 495 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the square of magnitude of given point.(Can be used for fast magnitude calculation of point)
 *
 * @function Phaser.Geom.Point.GetMagnitudeSq
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - Returns square of the magnitude/length of given point.
 *
 * @return {number} Returns square of the magnitude of given point.
 */ var GetMagnitudeSq = function(point) {
                return point.x * point.x + point.y * point.y;
            };
            module1.exports = GetMagnitudeSq;
        /***/ },
        /* 496 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            Rectangle.Area = __webpack_require__(1261);
            Rectangle.Ceil = __webpack_require__(1262);
            Rectangle.CeilAll = __webpack_require__(1263);
            Rectangle.CenterOn = __webpack_require__(187);
            Rectangle.Clone = __webpack_require__(1264);
            Rectangle.Contains = __webpack_require__(56);
            Rectangle.ContainsPoint = __webpack_require__(1265);
            Rectangle.ContainsRect = __webpack_require__(497);
            Rectangle.CopyFrom = __webpack_require__(1266);
            Rectangle.Decompose = __webpack_require__(484);
            Rectangle.Equals = __webpack_require__(1267);
            Rectangle.FitInside = __webpack_require__(1268);
            Rectangle.FitOutside = __webpack_require__(1269);
            Rectangle.Floor = __webpack_require__(1270);
            Rectangle.FloorAll = __webpack_require__(1271);
            Rectangle.FromPoints = __webpack_require__(196);
            Rectangle.FromXY = __webpack_require__(1272);
            Rectangle.GetAspectRatio = __webpack_require__(234);
            Rectangle.GetCenter = __webpack_require__(1273);
            Rectangle.GetPoint = __webpack_require__(167);
            Rectangle.GetPoints = __webpack_require__(300);
            Rectangle.GetSize = __webpack_require__(1274);
            Rectangle.Inflate = __webpack_require__(1275);
            Rectangle.Intersection = __webpack_require__(1276);
            Rectangle.MarchingAnts = __webpack_require__(310);
            Rectangle.MergePoints = __webpack_require__(1277);
            Rectangle.MergeRect = __webpack_require__(1278);
            Rectangle.MergeXY = __webpack_require__(1279);
            Rectangle.Offset = __webpack_require__(1280);
            Rectangle.OffsetPoint = __webpack_require__(1281);
            Rectangle.Overlaps = __webpack_require__(1282);
            Rectangle.Perimeter = __webpack_require__(128);
            Rectangle.PerimeterPoint = __webpack_require__(1283);
            Rectangle.Random = __webpack_require__(170);
            Rectangle.RandomOutside = __webpack_require__(1284);
            Rectangle.SameDimensions = __webpack_require__(1285);
            Rectangle.Scale = __webpack_require__(1286);
            Rectangle.Union = __webpack_require__(435);
            module1.exports = Rectangle;
        /***/ },
        /* 497 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests if one rectangle fully contains another.
 *
 * @function Phaser.Geom.Rectangle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first rectangle.
 * @param {Phaser.Geom.Rectangle} rectB - The second rectangle.
 *
 * @return {boolean} True only if rectA fully contains rectB.
 */ var ContainsRect = function(rectA, rectB) {
                //  Volume check (if rectB volume > rectA then rectA cannot contain it)
                if (rectB.width * rectB.height > rectA.width * rectA.height) return false;
                return rectB.x > rectA.x && rectB.x < rectA.right && rectB.right > rectA.x && rectB.right < rectA.right && rectB.y > rectA.y && rectB.y < rectA.bottom && rectB.bottom > rectA.y && rectB.bottom < rectA.bottom;
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 498 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            //  The three medians (the lines drawn from the vertices to the bisectors of the opposite sides)
            //  meet in the centroid or center of mass (center of gravity).
            //  The centroid divides each median in a ratio of 2:1
            /**
 * Calculates the position of a Triangle's centroid, which is also its center of mass (center of gravity).
 *
 * The centroid is the point in a Triangle at which its three medians (the lines drawn from the vertices to the bisectors of the opposite sides) meet. It divides each one in a 2:1 ratio.
 *
 * @function Phaser.Geom.Triangle.Centroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the coordinates in.
 *
 * @return {(Phaser.Geom.Point|object)} The `out` object with modified `x` and `y` properties, or a new Point if none was provided.
 */ var Centroid = function(triangle, out) {
                if (out === undefined) out = new Point();
                out.x = (triangle.x1 + triangle.x2 + triangle.x3) / 3;
                out.y = (triangle.y1 + triangle.y2 + triangle.y3) / 3;
                return out;
            };
            module1.exports = Centroid;
        /***/ },
        /* 499 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves each point (vertex) of a Triangle by a given offset, thus moving the entire Triangle by that offset.
 *
 * @function Phaser.Geom.Triangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to move.
 * @param {number} x - The horizontal offset (distance) by which to move each point. Can be positive or negative.
 * @param {number} y - The vertical offset (distance) by which to move each point. Can be positive or negative.
 *
 * @return {Phaser.Geom.Triangle} The modified Triangle.
 */ var Offset = function(triangle, x, y) {
                triangle.x1 += x;
                triangle.y1 += y;
                triangle.x2 += x;
                triangle.y2 += y;
                triangle.x3 += x;
                triangle.y3 += y;
                return triangle;
            };
            module1.exports = Offset;
        /***/ },
        /* 500 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            // The three angle bisectors of a triangle meet in one point called the incenter.
            // It is the center of the incircle, the circle inscribed in the triangle.
            function getLength(x1, y1, x2, y2) {
                var x = x1 - x2;
                var y = y1 - y2;
                var magnitude = x * x + y * y;
                return Math.sqrt(magnitude);
            }
            /**
 * Calculates the position of the incenter of a Triangle object. This is the point where its three angle bisectors meet and it's also the center of the incircle, which is the circle inscribed in the triangle.
 *
 * @function Phaser.Geom.Triangle.InCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to find the incenter of.
 * @param {Phaser.Geom.Point} [out] - An optional Point in which to store the coordinates.
 *
 * @return {Phaser.Geom.Point} Point (x, y) of the center pixel of the triangle.
 */ var InCenter = function(triangle, out) {
                if (out === undefined) out = new Point();
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                var d1 = getLength(x3, y3, x2, y2);
                var d2 = getLength(x1, y1, x3, y3);
                var d3 = getLength(x2, y2, x1, y1);
                var p = d1 + d2 + d3;
                out.x = (x1 * d1 + x2 * d2 + x3 * d3) / p;
                out.y = (y1 * d1 + y2 * d2 + y3 * d3) / p;
                return out;
            };
            module1.exports = InCenter;
        /***/ },
        /* 501 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Pixel Perfect Handler function.
 *
 * Access via `InputPlugin.makePixelPerfect` rather than calling it directly.
 *
 * @function Phaser.Input.CreatePixelPerfectHandler
 * @since 3.10.0
 *
 * @param {Phaser.Textures.TextureManager} textureManager - A reference to the Texture Manager.
 * @param {number} alphaTolerance - The alpha level that the pixel should be above to be included as a successful interaction.
 *
 * @return {function} The new Pixel Perfect Handler function.
 */ var CreatePixelPerfectHandler = function(textureManager, alphaTolerance) {
                return function(hitArea, x, y, gameObject) {
                    var alpha = textureManager.getPixelAlpha(x, y, gameObject.texture.key, gameObject.frame.name);
                    return alpha && alpha >= alphaTolerance;
                };
            };
            module1.exports = CreatePixelPerfectHandler;
        /***/ },
        /* 502 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Creates a new Interactive Object.
 * 
 * This is called automatically by the Input Manager when you enable a Game Object for input.
 *
 * The resulting Interactive Object is mapped to the Game Object's `input` property.
 *
 * @function Phaser.Input.CreateInteractiveObject
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to which this Interactive Object is bound.
 * @param {any} hitArea - The hit area for this Interactive Object. Typically a geometry shape, like a Rectangle or Circle.
 * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - The 'contains' check callback that the hit area shape will use for all hit tests.
 *
 * @return {Phaser.Types.Input.InteractiveObject} The new Interactive Object.
 */ var CreateInteractiveObject = function(gameObject, hitArea, hitAreaCallback) {
                return {
                    gameObject: gameObject,
                    enabled: true,
                    alwaysEnabled: false,
                    draggable: false,
                    dropZone: false,
                    cursor: false,
                    target: null,
                    camera: null,
                    hitArea: hitArea,
                    hitAreaCallback: hitAreaCallback,
                    hitAreaDebug: null,
                    //  Has the dev specified their own shape, or is this bound to the texture size?
                    customHitArea: false,
                    localX: 0,
                    localY: 0,
                    //  0 = Not being dragged
                    //  1 = Being checked for dragging
                    //  2 = Being dragged
                    dragState: 0,
                    dragStartX: 0,
                    dragStartY: 0,
                    dragStartXGlobal: 0,
                    dragStartYGlobal: 0,
                    dragX: 0,
                    dragY: 0
                };
            };
            module1.exports = CreateInteractiveObject;
        /***/ },
        /* 503 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * Contains information about a specific Gamepad Axis.
 * Axis objects are created automatically by the Gamepad as they are needed.
 *
 * @class Axis
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Axis belongs to.
 * @param {number} index - The index of this Axis.
 */ var Axis = new Class({
                initialize: function Axis(pad, index) {
                    /**
         * A reference to the Gamepad that this Axis belongs to.
         *
         * @name Phaser.Input.Gamepad.Axis#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                    /**
         * An event emitter to use to emit the axis events.
         *
         * @name Phaser.Input.Gamepad.Axis#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.events;
                    /**
         * The index of this Axis.
         *
         * @name Phaser.Input.Gamepad.Axis#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * The raw axis value, between -1 and 1 with 0 being dead center.
         * Use the method `getValue` to get a normalized value with the threshold applied.
         *
         * @name Phaser.Input.Gamepad.Axis#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                    /**
         * Movement tolerance threshold below which axis values are ignored in `getValue`.
         *
         * @name Phaser.Input.Gamepad.Axis#threshold
         * @type {number}
         * @default 0.1
         * @since 3.0.0
         */ this.threshold = 0.1;
                },
                /**
     * Internal update handler for this Axis.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Axis#update
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the axis movement.
     */ update: function(value) {
                    this.value = value;
                },
                /**
     * Applies the `threshold` value to the axis and returns it.
     *
     * @method Phaser.Input.Gamepad.Axis#getValue
     * @since 3.0.0
     *
     * @return {number} The axis value, adjusted for the movement threshold.
     */ getValue: function() {
                    return Math.abs(this.value) < this.threshold ? 0 : this.value;
                },
                /**
     * Destroys this Axis instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Axis#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.pad = null;
                    this.events = null;
                }
            });
            module1.exports = Axis;
        /***/ },
        /* 504 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(236);
            /**
 * @classdesc
 * Contains information about a specific button on a Gamepad.
 * Button objects are created automatically by the Gamepad as they are needed.
 *
 * @class Button
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.Gamepad} pad - A reference to the Gamepad that this Button belongs to.
 * @param {number} index - The index of this Button.
 */ var Button = new Class({
                initialize: function Button(pad, index) {
                    /**
         * A reference to the Gamepad that this Button belongs to.
         *
         * @name Phaser.Input.Gamepad.Button#pad
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @since 3.0.0
         */ this.pad = pad;
                    /**
         * An event emitter to use to emit the button events.
         *
         * @name Phaser.Input.Gamepad.Button#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = pad.manager;
                    /**
         * The index of this Button.
         *
         * @name Phaser.Input.Gamepad.Button#index
         * @type {number}
         * @since 3.0.0
         */ this.index = index;
                    /**
         * Between 0 and 1.
         *
         * @name Phaser.Input.Gamepad.Button#value
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.value = 0;
                    /**
         * Can be set for analogue buttons to enable a 'pressure' threshold,
         * before a button is considered as being 'pressed'.
         *
         * @name Phaser.Input.Gamepad.Button#threshold
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.threshold = 1;
                    /**
         * Is the Button being pressed down or not?
         *
         * @name Phaser.Input.Gamepad.Button#pressed
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.pressed = false;
                },
                /**
     * Internal update handler for this Button.
     * Called automatically by the Gamepad as part of its update.
     *
     * @method Phaser.Input.Gamepad.Button#update
     * @fires Phaser.Input.Gamepad.Events#BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#BUTTON_UP
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
     * @fires Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
     * @private
     * @since 3.0.0
     *
     * @param {number} value - The value of the button. Between 0 and 1.
     */ update: function(value) {
                    this.value = value;
                    var pad = this.pad;
                    var index = this.index;
                    if (value >= this.threshold) {
                        if (!this.pressed) {
                            this.pressed = true;
                            this.events.emit(Events.BUTTON_DOWN, pad, this, value);
                            this.pad.emit(Events.GAMEPAD_BUTTON_DOWN, index, value, this);
                        }
                    } else if (this.pressed) {
                        this.pressed = false;
                        this.events.emit(Events.BUTTON_UP, pad, this, value);
                        this.pad.emit(Events.GAMEPAD_BUTTON_UP, index, value, this);
                    }
                },
                /**
     * Destroys this Button instance and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Button#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.pad = null;
                    this.events = null;
                }
            });
            module1.exports = Button;
        /***/ },
        /* 505 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Axis = __webpack_require__(503);
            var Button = __webpack_require__(504);
            var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A single Gamepad.
 *
 * These are created, updated and managed by the Gamepad Plugin.
 *
 * @class Gamepad
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Gamepad.GamepadPlugin} manager - A reference to the Gamepad Plugin.
 * @param {Phaser.Types.Input.Gamepad.Pad} pad - The Gamepad object, as extracted from GamepadEvent.
 */ var Gamepad = new Class({
                Extends: EventEmitter,
                initialize: function Gamepad(manager, pad) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Gamepad Plugin.
         *
         * @name Phaser.Input.Gamepad.Gamepad#manager
         * @type {Phaser.Input.Gamepad.GamepadPlugin}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * A reference to the native Gamepad object that is connected to the browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#pad
         * @type {any}
         * @since 3.10.0
         */ this.pad = pad;
                    /**
         * A string containing some information about the controller.
         *
         * This is not strictly specified, but in Firefox it will contain three pieces of information
         * separated by dashes (-): two 4-digit hexadecimal strings containing the USB vendor and
         * product id of the controller, and the name of the controller as provided by the driver.
         * In Chrome it will contain the name of the controller as provided by the driver,
         * followed by vendor and product 4-digit hexadecimal strings.
         *
         * @name Phaser.Input.Gamepad.Gamepad#id
         * @type {string}
         * @since 3.0.0
         */ this.id = pad.id;
                    /**
         * An integer that is unique for each Gamepad currently connected to the system.
         * This can be used to distinguish multiple controllers.
         * Note that disconnecting a device and then connecting a new device may reuse the previous index.
         *
         * @name Phaser.Input.Gamepad.Gamepad#index
         * @type {number}
         * @since 3.0.0
         */ this.index = pad.index;
                    var buttons = [];
                    for(var i = 0; i < pad.buttons.length; i++)buttons.push(new Button(this, i));
                    /**
         * An array of Gamepad Button objects, corresponding to the different buttons available on the Gamepad.
         *
         * @name Phaser.Input.Gamepad.Gamepad#buttons
         * @type {Phaser.Input.Gamepad.Button[]}
         * @since 3.0.0
         */ this.buttons = buttons;
                    var axes = [];
                    for(i = 0; i < pad.axes.length; i++)axes.push(new Axis(this, i));
                    /**
         * An array of Gamepad Axis objects, corresponding to the different axes available on the Gamepad, if any.
         *
         * @name Phaser.Input.Gamepad.Gamepad#axes
         * @type {Phaser.Input.Gamepad.Axis[]}
         * @since 3.0.0
         */ this.axes = axes;
                    /**
         * The Gamepad's Haptic Actuator (Vibration / Rumble support).
         * This is highly experimental and only set if both present on the device,
         * and exposed by both the hardware and browser.
         *
         * @name Phaser.Input.Gamepad.Gamepad#vibration
         * @type {GamepadHapticActuator}
         * @since 3.10.0
         */ this.vibration = pad.vibrationActuator;
                    // https://w3c.github.io/gamepad/#remapping
                    var _noButton = {
                        value: 0,
                        pressed: false
                    };
                    /**
         * A reference to the Left Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCLeft = buttons[14] ? buttons[14] : _noButton;
                    /**
         * A reference to the Right Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCRight = buttons[15] ? buttons[15] : _noButton;
                    /**
         * A reference to the Top Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCTop = buttons[12] ? buttons[12] : _noButton;
                    /**
         * A reference to the Bottom Button in the Left Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_LCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._LCBottom = buttons[13] ? buttons[13] : _noButton;
                    /**
         * A reference to the Left Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCLeft = buttons[2] ? buttons[2] : _noButton;
                    /**
         * A reference to the Right Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCRight = buttons[1] ? buttons[1] : _noButton;
                    /**
         * A reference to the Top Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCTop = buttons[3] ? buttons[3] : _noButton;
                    /**
         * A reference to the Bottom Button in the Right Cluster.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_RCBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._RCBottom = buttons[0] ? buttons[0] : _noButton;
                    /**
         * A reference to the Top Left Front Button (L1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftTop = buttons[4] ? buttons[4] : _noButton;
                    /**
         * A reference to the Bottom Left Front Button (L2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBLeftBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBLeftBottom = buttons[6] ? buttons[6] : _noButton;
                    /**
         * A reference to the Top Right Front Button (R1 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightTop
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightTop = buttons[5] ? buttons[5] : _noButton;
                    /**
         * A reference to the Bottom Right Front Button (R2 Shoulder Button)
         *
         * @name Phaser.Input.Gamepad.Gamepad#_FBRightBottom
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._FBRightBottom = buttons[7] ? buttons[7] : _noButton;
                    var _noAxis = {
                        value: 0
                    };
                    /**
         * A reference to the Horizontal Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisLeft = axes[0] ? axes[0] : _noAxis;
                    /**
         * A reference to the Vertical Axis for the Left Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisLeft
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisLeft = axes[1] ? axes[1] : _noAxis;
                    /**
         * A reference to the Horizontal Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_HAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._HAxisRight = axes[2] ? axes[2] : _noAxis;
                    /**
         * A reference to the Vertical Axis for the Right Stick.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_VAxisRight
         * @type {Phaser.Input.Gamepad.Button}
         * @private
         * @since 3.10.0
         */ this._VAxisRight = axes[3] ? axes[3] : _noAxis;
                    /**
         * A Vector2 containing the most recent values from the Gamepad's left axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a left axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#leftStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.leftStick = new Vector2();
                    /**
         * A Vector2 containing the most recent values from the Gamepad's right axis stick.
         * This is updated automatically as part of the Gamepad.update cycle.
         * The H Axis is mapped to the `Vector2.x` property, and the V Axis to the `Vector2.y` property.
         * The values are based on the Axis thresholds.
         * If the Gamepad does not have a right axis stick, the values will always be zero.
         *
         * @name Phaser.Input.Gamepad.Gamepad#rightStick
         * @type {Phaser.Math.Vector2}
         * @since 3.10.0
         */ this.rightStick = new Vector2();
                    /**
         * When was this Gamepad created? Used to avoid duplicate event spamming in the update loop.
         *
         * @name Phaser.Input.Gamepad.Gamepad#_created
         * @type {number}
         * @private
         * @since 3.50.0
         */ this._created = performance.now();
                },
                /**
     * Gets the total number of axis this Gamepad claims to support.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisTotal
     * @since 3.10.0
     *
     * @return {number} The total number of axes this Gamepad claims to support.
     */ getAxisTotal: function() {
                    return this.axes.length;
                },
                /**
     * Gets the value of an axis based on the given index.
     * The index must be valid within the range of axes supported by this Gamepad.
     * The return value will be a float between 0 and 1.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getAxisValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the axes to get the value for.
     *
     * @return {number} The value of the axis, between 0 and 1.
     */ getAxisValue: function(index) {
                    return this.axes[index].getValue();
                },
                /**
     * Sets the threshold value of all axis on this Gamepad.
     * The value is a float between 0 and 1 and is the amount below which the axis is considered as not having been moved.
     *
     * @method Phaser.Input.Gamepad.Gamepad#setAxisThreshold
     * @since 3.10.0
     *
     * @param {number} value - A value between 0 and 1.
     */ setAxisThreshold: function(value) {
                    for(var i = 0; i < this.axes.length; i++)this.axes[i].threshold = value;
                },
                /**
     * Gets the total number of buttons this Gamepad claims to have.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonTotal
     * @since 3.10.0
     *
     * @return {number} The total number of buttons this Gamepad claims to have.
     */ getButtonTotal: function() {
                    return this.buttons.length;
                },
                /**
     * Gets the value of a button based on the given index.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * The return value will be either 0 or 1 for an analogue button, or a float between 0 and 1
     * for a pressure-sensitive digital button, such as the shoulder buttons on a Dual Shock.
     *
     * @method Phaser.Input.Gamepad.Gamepad#getButtonValue
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {number} The value of the button, between 0 and 1.
     */ getButtonValue: function(index) {
                    return this.buttons[index].value;
                },
                /**
     * Returns if the button is pressed down or not.
     * The index must be valid within the range of buttons supported by this Gamepad.
     *
     * @method Phaser.Input.Gamepad.Gamepad#isButtonDown
     * @since 3.10.0
     *
     * @param {number} index - The index of the button to get the value for.
     *
     * @return {boolean} `true` if the button is considered as being pressed down, otherwise `false`.
     */ isButtonDown: function(index) {
                    return this.buttons[index].pressed;
                },
                /**
     * Internal update handler for this Gamepad.
     * Called automatically by the Gamepad Manager as part of its update.
     *
     * @method Phaser.Input.Gamepad.Gamepad#update
     * @private
     * @since 3.0.0
     */ update: function(pad) {
                    if (pad.timestamp < this._created) return;
                    var i;
                    //  Sync the button values
                    var localButtons = this.buttons;
                    var gamepadButtons = pad.buttons;
                    var len = localButtons.length;
                    for(i = 0; i < len; i++)localButtons[i].update(gamepadButtons[i].value);
                    //  Sync the axis values
                    var localAxes = this.axes;
                    var gamepadAxes = pad.axes;
                    len = localAxes.length;
                    for(i = 0; i < len; i++)localAxes[i].update(gamepadAxes[i]);
                    if (len >= 2) {
                        this.leftStick.set(localAxes[0].getValue(), localAxes[1].getValue());
                        if (len >= 4) this.rightStick.set(localAxes[2].getValue(), localAxes[3].getValue());
                    }
                },
                /**
     * Destroys this Gamepad instance, its buttons and axes, and releases external references it holds.
     *
     * @method Phaser.Input.Gamepad.Gamepad#destroy
     * @since 3.10.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.manager = null;
                    this.pad = null;
                    var i;
                    for(i = 0; i < this.buttons.length; i++)this.buttons[i].destroy();
                    for(i = 0; i < this.axes.length; i++)this.axes[i].destroy();
                    this.buttons = [];
                    this.axes = [];
                },
                /**
     * Is this Gamepad currently connected or not?
     *
     * @name Phaser.Input.Gamepad.Gamepad#connected
     * @type {boolean}
     * @default true
     * @since 3.0.0
     */ connected: {
                    get: function() {
                        return this.pad.connected;
                    }
                },
                /**
     * A timestamp containing the most recent time this Gamepad was updated.
     *
     * @name Phaser.Input.Gamepad.Gamepad#timestamp
     * @type {number}
     * @since 3.0.0
     */ timestamp: {
                    get: function() {
                        return this.pad.timestamp;
                    }
                },
                /**
     * Is the Gamepad's Left button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad left button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#left
     * @type {boolean}
     * @since 3.10.0
     */ left: {
                    get: function() {
                        return this._LCLeft.pressed;
                    }
                },
                /**
     * Is the Gamepad's Right button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad right button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#right
     * @type {boolean}
     * @since 3.10.0
     */ right: {
                    get: function() {
                        return this._LCRight.pressed;
                    }
                },
                /**
     * Is the Gamepad's Up button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad up button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#up
     * @type {boolean}
     * @since 3.10.0
     */ up: {
                    get: function() {
                        return this._LCTop.pressed;
                    }
                },
                /**
     * Is the Gamepad's Down button being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * This is the d-pad down button under standard Gamepad mapping.
     *
     * @name Phaser.Input.Gamepad.Gamepad#down
     * @type {boolean}
     * @since 3.10.0
     */ down: {
                    get: function() {
                        return this._LCBottom.pressed;
                    }
                },
                /**
     * Is the Gamepad's bottom button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the X button.
     * On an XBox controller it's the A button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#A
     * @type {boolean}
     * @since 3.10.0
     */ A: {
                    get: function() {
                        return this._RCBottom.pressed;
                    }
                },
                /**
     * Is the Gamepad's top button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Triangle button.
     * On an XBox controller it's the Y button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#Y
     * @type {boolean}
     * @since 3.10.0
     */ Y: {
                    get: function() {
                        return this._RCTop.pressed;
                    }
                },
                /**
     * Is the Gamepad's left button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Square button.
     * On an XBox controller it's the X button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#X
     * @type {boolean}
     * @since 3.10.0
     */ X: {
                    get: function() {
                        return this._RCLeft.pressed;
                    }
                },
                /**
     * Is the Gamepad's right button in the right button cluster being pressed?
     * If the Gamepad doesn't have this button it will always return false.
     * On a Dual Shock controller it's the Circle button.
     * On an XBox controller it's the B button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#B
     * @type {boolean}
     * @since 3.10.0
     */ B: {
                    get: function() {
                        return this._RCRight.pressed;
                    }
                },
                /**
     * Returns the value of the Gamepad's top left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L1 button.
     * On an XBox controller it's the LB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L1
     * @type {number}
     * @since 3.10.0
     */ L1: {
                    get: function() {
                        return this._FBLeftTop.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's bottom left shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the L2 button.
     * On an XBox controller it's the LT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#L2
     * @type {number}
     * @since 3.10.0
     */ L2: {
                    get: function() {
                        return this._FBLeftBottom.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's top right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R1 button.
     * On an XBox controller it's the RB button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R1
     * @type {number}
     * @since 3.10.0
     */ R1: {
                    get: function() {
                        return this._FBRightTop.value;
                    }
                },
                /**
     * Returns the value of the Gamepad's bottom right shoulder button.
     * If the Gamepad doesn't have this button it will always return zero.
     * The value is a float between 0 and 1, corresponding to how depressed the button is.
     * On a Dual Shock controller it's the R2 button.
     * On an XBox controller it's the RT button.
     *
     * @name Phaser.Input.Gamepad.Gamepad#R2
     * @type {number}
     * @since 3.10.0
     */ R2: {
                    get: function() {
                        return this._FBRightBottom.value;
                    }
                }
            });
            module1.exports = Gamepad;
        /***/ },
        /* 506 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(152);
            /**
 * @classdesc
 * A generic Key object which can be passed to the Process functions (and so on)
 * keycode must be an integer
 *
 * @class Key
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} plugin - The Keyboard Plugin instance that owns this Key object.
 * @param {number} keyCode - The keycode of this key.
 */ var Key = new Class({
                Extends: EventEmitter,
                initialize: function Key(plugin, keyCode) {
                    EventEmitter.call(this);
                    /**
         * The Keyboard Plugin instance that owns this Key object.
         *
         * @name Phaser.Input.Keyboard.Key#plugin
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.17.0
         */ this.plugin = plugin;
                    /**
         * The keycode of this key.
         *
         * @name Phaser.Input.Keyboard.Key#keyCode
         * @type {number}
         * @since 3.0.0
         */ this.keyCode = keyCode;
                    /**
         * The original DOM event.
         *
         * @name Phaser.Input.Keyboard.Key#originalEvent
         * @type {KeyboardEvent}
         * @since 3.0.0
         */ this.originalEvent = undefined;
                    /**
         * Can this Key be processed?
         *
         * @name Phaser.Input.Keyboard.Key#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * The "down" state of the key. This will remain `true` for as long as the keyboard thinks this key is held down.
         *
         * @name Phaser.Input.Keyboard.Key#isDown
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isDown = false;
                    /**
         * The "up" state of the key. This will remain `true` for as long as the keyboard thinks this key is up.
         *
         * @name Phaser.Input.Keyboard.Key#isUp
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isUp = true;
                    /**
         * The down state of the ALT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#altKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.altKey = false;
                    /**
         * The down state of the CTRL key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#ctrlKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.ctrlKey = false;
                    /**
         * The down state of the SHIFT key, if pressed at the same time as this key.
         *
         * @name Phaser.Input.Keyboard.Key#shiftKey
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.shiftKey = false;
                    /**
         * The down state of the Meta key, if pressed at the same time as this key.
         * On a Mac the Meta Key is the Command key. On Windows keyboards, it's the Windows key.
         *
         * @name Phaser.Input.Keyboard.Key#metaKey
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.metaKey = false;
                    /**
         * The location of the modifier key. 0 for standard (or unknown), 1 for left, 2 for right, 3 for numpad.
         *
         * @name Phaser.Input.Keyboard.Key#location
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.location = 0;
                    /**
         * The timestamp when the key was last pressed down.
         *
         * @name Phaser.Input.Keyboard.Key#timeDown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeDown = 0;
                    /**
         * The number of milliseconds this key was held down for in the previous down - up sequence.
         * This value isn't updated every game step, only when the Key changes state.
         * To get the current duration use the `getDuration` method.
         *
         * @name Phaser.Input.Keyboard.Key#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * The timestamp when the key was last released.
         *
         * @name Phaser.Input.Keyboard.Key#timeUp
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeUp = 0;
                    /**
         * When a key is held down should it continuously fire the `down` event each time it repeats?
         * 
         * By default it will emit the `down` event just once, but if you wish to receive the event
         * for each repeat as well, enable this property.
         *
         * @name Phaser.Input.Keyboard.Key#emitOnRepeat
         * @type {boolean}
         * @default false
         * @since 3.16.0
         */ this.emitOnRepeat = false;
                    /**
         * If a key is held down this holds down the number of times the key has 'repeated'.
         *
         * @name Phaser.Input.Keyboard.Key#repeats
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeats = 0;
                    /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justDown
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justDown = false;
                    /**
         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
         *
         * @name Phaser.Input.Keyboard.Key#_justUp
         * @type {boolean}
         * @private
         * @default false
         * @since 3.0.0
         */ this._justUp = false;
                    /**
         * Internal tick counter.
         *
         * @name Phaser.Input.Keyboard.Key#_tick
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._tick = -1;
                },
                /**
     * Controls if this Key will continuously emit a `down` event while being held down (true),
     * or emit the event just once, on first press, and then skip future events (false).
     *
     * @method Phaser.Input.Keyboard.Key#setEmitOnRepeat
     * @since 3.16.0
     * 
     * @param {boolean} value - Emit `down` events on repeated key down actions, or just once?
     * 
     * @return {this} This Key instance.
     */ setEmitOnRepeat: function(value) {
                    this.emitOnRepeat = value;
                    return this;
                },
                /**
     * Processes the Key Down action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onDown
     * @fires Phaser.Input.Keyboard.Events#DOWN
     * @since 3.16.0
     * 
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onDown: function(event) {
                    this.originalEvent = event;
                    if (!this.enabled) return;
                    this.altKey = event.altKey;
                    this.ctrlKey = event.ctrlKey;
                    this.shiftKey = event.shiftKey;
                    this.metaKey = event.metaKey;
                    this.location = event.location;
                    this.repeats++;
                    if (!this.isDown) {
                        this.isDown = true;
                        this.isUp = false;
                        this.timeDown = event.timeStamp;
                        this.duration = 0;
                        this._justDown = true;
                        this._justUp = false;
                        this.emit(Events.DOWN, this, event);
                    } else if (this.emitOnRepeat) this.emit(Events.DOWN, this, event);
                },
                /**
     * Processes the Key Up action for this Key.
     * Called automatically by the Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.Key#onUp
     * @fires Phaser.Input.Keyboard.Events#UP
     * @since 3.16.0
     * 
     * @param {KeyboardEvent} event - The native DOM Keyboard event.
     */ onUp: function(event) {
                    this.originalEvent = event;
                    if (!this.enabled) return;
                    this.isDown = false;
                    this.isUp = true;
                    this.timeUp = event.timeStamp;
                    this.duration = this.timeUp - this.timeDown;
                    this.repeats = 0;
                    this._justDown = false;
                    this._justUp = true;
                    this._tick = -1;
                    this.emit(Events.UP, this, event);
                },
                /**
     * Resets this Key object back to its default un-pressed state.
     *
     * @method Phaser.Input.Keyboard.Key#reset
     * @since 3.6.0
     * 
     * @return {this} This Key instance.
     */ reset: function() {
                    this.preventDefault = true;
                    this.enabled = true;
                    this.isDown = false;
                    this.isUp = true;
                    this.altKey = false;
                    this.ctrlKey = false;
                    this.shiftKey = false;
                    this.metaKey = false;
                    this.timeDown = 0;
                    this.duration = 0;
                    this.timeUp = 0;
                    this.repeats = 0;
                    this._justDown = false;
                    this._justUp = false;
                    this._tick = -1;
                    return this;
                },
                /**
     * Returns the duration, in ms, that the Key has been held down for.
     * 
     * If the key is not currently down it will return zero.
     * 
     * The get the duration the Key was held down for in the previous up-down cycle,
     * use the `Key.duration` property value instead.
     *
     * @method Phaser.Input.Keyboard.Key#getDuration
     * @since 3.17.0
     * 
     * @return {number} The duration, in ms, that the Key has been held down for if currently down.
     */ getDuration: function() {
                    if (this.isDown) return this.plugin.game.loop.time - this.timeDown;
                    else return 0;
                },
                /**
     * Removes any bound event handlers and removes local references.
     *
     * @method Phaser.Input.Keyboard.Key#destroy
     * @since 3.16.0
     */ destroy: function() {
                    this.removeAllListeners();
                    this.originalEvent = null;
                    this.plugin = null;
                }
            });
            module1.exports = Key;
        /***/ },
        /* 507 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(152);
            var GetFastValue = __webpack_require__(2);
            var ProcessKeyCombo = __webpack_require__(508);
            var ResetKeyCombo = __webpack_require__(510);
            /**
 * @classdesc
 * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
 * it will emit a `keycombomatch` event from the Keyboard Manager.
 *
 * The keys to be listened for can be defined as:
 *
 * A string (i.e. 'ATARI')
 * An array of either integers (key codes) or strings, or a mixture of both
 * An array of objects (such as Key objects) with a public 'keyCode' property
 *
 * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
 * you could pass the following array of key codes:
 *
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * Or, to listen for the user entering the word PHASER:
 *
 * ```javascript
 * this.input.keyboard.createCombo('PHASER');
 * ```
 *
 * @class KeyCombo
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @listens Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyboardPlugin} keyboardPlugin - A reference to the Keyboard Plugin.
 * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
 * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
 */ var KeyCombo = new Class({
                initialize: function KeyCombo(keyboardPlugin, keys, config) {
                    if (config === undefined) config = {};
                    //  Can't have a zero or single length combo (string or array based)
                    if (keys.length < 2) return false;
                    /**
         * A reference to the Keyboard Manager
         *
         * @name Phaser.Input.Keyboard.KeyCombo#manager
         * @type {Phaser.Input.Keyboard.KeyboardPlugin}
         * @since 3.0.0
         */ this.manager = keyboardPlugin;
                    /**
         * A flag that controls if this Key Combo is actively processing keys or not.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = true;
                    /**
         * An array of the keycodes that comprise this combo.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#keyCodes
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.keyCodes = [];
                    //  if 'keys' is a string we need to get the keycode of each character in it
                    for(var i = 0; i < keys.length; i++){
                        var char = keys[i];
                        if (typeof char === 'string') this.keyCodes.push(char.toUpperCase().charCodeAt(0));
                        else if (typeof char === 'number') this.keyCodes.push(char);
                        else if (char.hasOwnProperty('keyCode')) this.keyCodes.push(char.keyCode);
                    }
                    /**
         * The current keyCode the combo is waiting for.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#current
         * @type {number}
         * @since 3.0.0
         */ this.current = this.keyCodes[0];
                    /**
         * The current index of the key being waited for in the 'keys' string.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#index
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.index = 0;
                    /**
         * The length of this combo (in keycodes)
         *
         * @name Phaser.Input.Keyboard.KeyCombo#size
         * @type {number}
         * @since 3.0.0
         */ this.size = this.keyCodes.length;
                    /**
         * The time the previous key in the combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeLastMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeLastMatched = 0;
                    /**
         * Has this Key Combo been matched yet?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#matched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.matched = false;
                    /**
         * The time the entire combo was matched.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#timeMatched
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.timeMatched = 0;
                    /**
         * If they press the wrong key do we reset the combo?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnWrongKey
         * @type {boolean}
         * @default 0
         * @since 3.0.0
         */ this.resetOnWrongKey = GetFastValue(config, 'resetOnWrongKey', true);
                    /**
         * The max delay in ms between each key press. Above this the combo is reset. 0 means disabled.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#maxKeyDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxKeyDelay = GetFastValue(config, 'maxKeyDelay', 0);
                    /**
         * If previously matched and they press the first key of the combo again, will it reset?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#resetOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.resetOnMatch = GetFastValue(config, 'resetOnMatch', false);
                    /**
         * If the combo matches, will it delete itself?
         *
         * @name Phaser.Input.Keyboard.KeyCombo#deleteOnMatch
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.deleteOnMatch = GetFastValue(config, 'deleteOnMatch', false);
                    var _this = this;
                    var onKeyDownHandler = function(event) {
                        if (_this.matched || !_this.enabled) return;
                        var matched = ProcessKeyCombo(event, _this);
                        if (matched) {
                            _this.manager.emit(Events.COMBO_MATCH, _this, event);
                            if (_this.resetOnMatch) ResetKeyCombo(_this);
                            else if (_this.deleteOnMatch) _this.destroy();
                        }
                    };
                    /**
         * The internal Key Down handler.
         *
         * @name Phaser.Input.Keyboard.KeyCombo#onKeyDown
         * @private
         * @type {KeyboardKeydownCallback}
         * @fires Phaser.Input.Keyboard.Events#COMBO_MATCH
         * @since 3.0.0
         */ this.onKeyDown = onKeyDownHandler;
                    this.manager.on(Events.ANY_KEY_DOWN, this.onKeyDown);
                },
                /**
     * How far complete is this combo? A value between 0 and 1.
     *
     * @name Phaser.Input.Keyboard.KeyCombo#progress
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ progress: {
                    get: function() {
                        return this.index / this.size;
                    }
                },
                /**
     * Destroys this Key Combo and all of its references.
     *
     * @method Phaser.Input.Keyboard.KeyCombo#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enabled = false;
                    this.keyCodes = [];
                    this.manager.off(Events.ANY_KEY_DOWN, this.onKeyDown);
                    this.manager = null;
                }
            });
            module1.exports = KeyCombo;
        /***/ },
        /* 508 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AdvanceKeyCombo = __webpack_require__(509);
            /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ProcessKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to be processed.
 *
 * @return {boolean} `true` if the combo was matched, otherwise `false`.
 */ var ProcessKeyCombo = function(event, combo) {
                if (combo.matched) return true;
                var comboMatched = false;
                var keyMatched = false;
                if (event.keyCode === combo.current) {
                    //  Key was correct
                    if (combo.index > 0 && combo.maxKeyDelay > 0) {
                        //  We have to check to see if the delay between
                        //  the new key and the old one was too long (if enabled)
                        var timeLimit = combo.timeLastMatched + combo.maxKeyDelay;
                        //  Check if they pressed it in time or not
                        if (event.timeStamp <= timeLimit) {
                            keyMatched = true;
                            comboMatched = AdvanceKeyCombo(event, combo);
                        }
                    } else {
                        keyMatched = true;
                        //  We don't check the time for the first key pressed, so just advance it
                        comboMatched = AdvanceKeyCombo(event, combo);
                    }
                }
                if (!keyMatched && combo.resetOnWrongKey) {
                    //  Wrong key was pressed
                    combo.index = 0;
                    combo.current = combo.keyCodes[0];
                }
                if (comboMatched) {
                    combo.timeLastMatched = event.timeStamp;
                    combo.matched = true;
                    combo.timeMatched = event.timeStamp;
                }
                return comboMatched;
            };
            module1.exports = ProcessKeyCombo;
        /***/ },
        /* 509 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 * Return `true` if it reached the end of the combo, `false` if not.
 *
 * @function Phaser.Input.Keyboard.AdvanceKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {KeyboardEvent} event - The native Keyboard Event.
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo object to advance.
 *
 * @return {boolean} `true` if it reached the end of the combo, `false` if not.
 */ var AdvanceKeyCombo = function(event, combo) {
                combo.timeLastMatched = event.timeStamp;
                combo.index++;
                if (combo.index === combo.size) return true;
                else {
                    combo.current = combo.keyCodes[combo.index];
                    return false;
                }
            };
            module1.exports = AdvanceKeyCombo;
        /***/ },
        /* 510 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Used internally by the KeyCombo class.
 *
 * @function Phaser.Input.Keyboard.ResetKeyCombo
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo to reset.
 *
 * @return {Phaser.Input.Keyboard.KeyCombo} The KeyCombo.
 */ var ResetKeyCombo = function(combo) {
                combo.current = combo.keyCodes[0];
                combo.index = 0;
                combo.timeLastMatched = 0;
                combo.matched = false;
                combo.timeMatched = 0;
                return combo;
            };
            module1.exports = ResetKeyCombo;
        /***/ },
        /* 511 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MergeXHRSettings = __webpack_require__(237);
            /**
 * Creates a new XMLHttpRequest (xhr) object based on the given File and XHRSettings
 * and starts the download of it. It uses the Files own XHRSettings and merges them
 * with the global XHRSettings object to set the xhr values before download.
 *
 * @function Phaser.Loader.XHRLoader
 * @since 3.0.0
 *
 * @param {Phaser.Loader.File} file - The File to download.
 * @param {Phaser.Types.Loader.XHRSettingsObject} globalXHRSettings - The global XHRSettings object.
 *
 * @return {XMLHttpRequest} The XHR object.
 */ var XHRLoader = function(file, globalXHRSettings) {
                var config = MergeXHRSettings(globalXHRSettings, file.xhrSettings);
                var xhr = new XMLHttpRequest();
                xhr.open('GET', file.src, config.async, config.user, config.password);
                xhr.responseType = file.xhrSettings.responseType;
                xhr.timeout = config.timeout;
                if (config.headers) for(var key in config.headers)xhr.setRequestHeader(key, config.headers[key]);
                if (config.header && config.headerValue) xhr.setRequestHeader(config.header, config.headerValue);
                if (config.requestedWith) xhr.setRequestHeader('X-Requested-With', config.requestedWith);
                if (config.overrideMimeType) xhr.overrideMimeType(config.overrideMimeType);
                if (config.withCredentials) xhr.withCredentials = true;
                // After a successful request, the xhr.response property will contain the requested data as a DOMString, ArrayBuffer, Blob, or Document (depending on what was set for responseType.)
                xhr.onload = file.onLoad.bind(file, xhr);
                xhr.onerror = file.onError.bind(file, xhr);
                xhr.onprogress = file.onProgress.bind(file);
                //  This is the only standard method, the ones above are browser additions (maybe not universal?)
                // xhr.onreadystatechange
                xhr.send();
                return xhr;
            };
            module1.exports = XHRLoader;
        /***/ },
        /* 512 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var HTML5AudioFile = __webpack_require__(513);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {any} [urlConfig] - The absolute or relative URL to load this file from in a config object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {AudioContext} [audioContext] - The AudioContext this file will use to process itself.
 */ var AudioFile = new Class({
                Extends: File,
                initialize: //  URL is an object created by AudioFile.findAudioURL
                function AudioFile(loader, key, urlConfig, xhrSettings, audioContext) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        audioContext = GetFastValue(config, 'context', audioContext);
                    }
                    var fileConfig = {
                        type: 'audio',
                        cache: loader.cacheManager.audio,
                        extension: urlConfig.type,
                        responseType: 'arraybuffer',
                        key: key,
                        url: urlConfig.url,
                        xhrSettings: xhrSettings,
                        config: {
                            context: audioContext
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AudioFile#onProcess
     * @since 3.0.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var _this = this;
                    // interesting read https://github.com/WebAudio/web-audio-api/issues/1305
                    this.config.context.decodeAudioData(this.xhrLoader.response, function(audioBuffer) {
                        _this.data = audioBuffer;
                        _this.onProcessComplete();
                    }, function(e) {
                        // eslint-disable-next-line no-console
                        console.error('Error decoding audio: ' + _this.key + ' - ', e ? e.message : null);
                        _this.onProcessError();
                    });
                    this.config.context = null;
                }
            });
            AudioFile.create = function(loader, key, urls, config, xhrSettings) {
                var game = loader.systems.game;
                var audioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                //  url may be inside key, which may be an object
                if (IsPlainObject(key)) {
                    urls = GetFastValue(key, 'url', []);
                    config = GetFastValue(key, 'config', {});
                }
                var urlConfig = AudioFile.getAudioURL(game, urls);
                if (!urlConfig) return null;
                // https://developers.google.com/web/updates/2012/02/HTML5-audio-and-the-Web-Audio-API-are-BFFs
                // var stream = GetFastValue(config, 'stream', false);
                if (deviceAudio.webAudio && !audioConfig.disableWebAudio) return new AudioFile(loader, key, urlConfig, xhrSettings, game.sound.context);
                else return new HTML5AudioFile(loader, key, urlConfig, config);
            };
            AudioFile.getAudioURL = function(game, urls) {
                if (!Array.isArray(urls)) urls = [
                    urls
                ];
                for(var i = 0; i < urls.length; i++){
                    var url = GetFastValue(urls[i], 'url', urls[i]);
                    if (url.indexOf('blob:') === 0 || url.indexOf('data:') === 0) return {
                        url: url,
                        type: ''
                    };
                    var audioType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                    audioType = GetFastValue(urls[i], 'type', audioType ? audioType[1] : '').toLowerCase();
                    if (game.device.audio[audioType]) return {
                        url: url,
                        type: audioType
                    };
                }
                return null;
            };
            /**
 * Adds an Audio or HTML5Audio file, or array of audio files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audio('title', [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audio({
 *     key: 'title',
 *     url: [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audio
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig|Phaser.Types.Loader.FileTypes.AudioFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[])} [urls] - The absolute or relative URL to load the audio files from.
 * @param {any} [config] - An object containing an `instances` property for HTML5Audio. Defaults to 1.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('audio', function(key, urls, config, xhrSettings) {
                var game = this.systems.game;
                var audioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                if (audioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                return this;
                var audioFile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    audioFile = AudioFile.create(this, key[i]);
                    if (audioFile) this.addFile(audioFile);
                }
                else {
                    audioFile = AudioFile.create(this, key, urls, config, xhrSettings);
                    if (audioFile) this.addFile(audioFile);
                }
                return this;
            });
            module1.exports = AudioFile;
        /***/ },
        /* 513 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Events = __webpack_require__(91);
            var File = __webpack_require__(23);
            var GetFastValue = __webpack_require__(2);
            var GetURL = __webpack_require__(153);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Audio File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
 *
 * @class HTML5AudioFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [urlConfig] - The absolute or relative URL to load this file from.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTML5AudioFile = new Class({
                Extends: File,
                initialize: function HTML5AudioFile(loader, key, urlConfig, audioConfig) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        audioConfig = GetFastValue(config, 'config', audioConfig);
                    }
                    var fileConfig = {
                        type: 'audio',
                        cache: loader.cacheManager.audio,
                        extension: urlConfig.type,
                        key: key,
                        url: urlConfig.url,
                        config: audioConfig
                    };
                    File.call(this, loader, fileConfig);
                    //  New properties specific to this class
                    this.locked = 'ontouchstart' in window;
                    this.loaded = false;
                    this.filesLoaded = 0;
                    this.filesTotal = 0;
                },
                /**
     * Called when the file finishes loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onLoad
     * @since 3.0.0
     */ onLoad: function() {
                    if (this.loaded) return;
                    this.loaded = true;
                    this.loader.nextFile(this, true);
                },
                /**
     * Called if the file errors while loading.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onError
     * @since 3.0.0
     */ onError: function() {
                    for(var i = 0; i < this.data.length; i++){
                        var audio = this.data[i];
                        audio.oncanplaythrough = null;
                        audio.onerror = null;
                    }
                    this.loader.nextFile(this, false);
                },
                /**
     * Called during the file load progress. Is sent a DOM ProgressEvent.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onProgress
     * @fires Phaser.Loader.Events#FILE_PROGRESS
     * @since 3.0.0
     */ onProgress: function(event) {
                    var audio = event.target;
                    audio.oncanplaythrough = null;
                    audio.onerror = null;
                    this.filesLoaded++;
                    this.percentComplete = Math.min(this.filesLoaded / this.filesTotal, 1);
                    this.loader.emit(Events.FILE_PROGRESS, this, this.percentComplete);
                    if (this.filesLoaded === this.filesTotal) this.onLoad();
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.HTML5AudioFile#load
     * @since 3.0.0
     */ load: function() {
                    this.data = [];
                    var instances = this.config && this.config.instances || 1;
                    this.filesTotal = instances;
                    this.filesLoaded = 0;
                    this.percentComplete = 0;
                    for(var i = 0; i < instances; i++){
                        var audio = new Audio();
                        if (!audio.dataset) audio.dataset = {};
                        audio.dataset.name = this.key + ('0' + i).slice(-2);
                        audio.dataset.used = 'false';
                        if (this.locked) audio.dataset.locked = 'true';
                        else {
                            audio.dataset.locked = 'false';
                            audio.preload = 'auto';
                            audio.oncanplaythrough = this.onProgress.bind(this);
                            audio.onerror = this.onError.bind(this);
                        }
                        this.data.push(audio);
                    }
                    for(i = 0; i < this.data.length; i++){
                        audio = this.data[i];
                        audio.src = GetURL(this, this.loader.baseURL);
                        if (!this.locked) audio.load();
                    }
                    if (this.locked) //  This is super-dangerous but works. Race condition potential high.
                    //  Is there another way?
                    setTimeout(this.onLoad.bind(this));
                }
            });
            module1.exports = HTML5AudioFile;
        /***/ },
        /* 514 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#script method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#script.
 *
 * @class ScriptFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScriptFile = new Class({
                Extends: File,
                initialize: function ScriptFile(loader, key, url, xhrSettings) {
                    var extension = 'js';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'script',
                        cache: false,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScriptFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = document.createElement('script');
                    this.data.language = 'javascript';
                    this.data.type = 'text/javascript';
                    this.data.defer = false;
                    this.data.text = this.xhrLoader.responseText;
                    document.head.appendChild(this.data);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Script file, or array of Script files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.script('aliens', 'lib/aliens.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.script({
 *     key: 'aliens',
 *     url: 'lib/aliens.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScriptFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#script
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScriptFileConfig|Phaser.Types.Loader.FileTypes.ScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('script', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ScriptFile(this, key[i]));
                else this.addFile(new ScriptFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = ScriptFile;
        /***/ },
        /* 515 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeImage = __webpack_require__(516);
            var ArcadeSprite = __webpack_require__(155);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(60);
            var PhysicsGroup = __webpack_require__(518);
            var StaticPhysicsGroup = __webpack_require__(519);
            /**
 * @classdesc
 * The Arcade Physics Factory allows you to easily create Arcade Physics enabled Game Objects.
 * Objects that are created by this Factory are automatically added to the physics world.
 *
 * @class Factory
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics World instance.
 */ var Factory = new Class({
                initialize: function Factory(world) {
                    /**
         * A reference to the Arcade Physics World.
         *
         * @name Phaser.Physics.Arcade.Factory#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * A reference to the Scene this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                    /**
         * A reference to the Scene.Systems this Arcade Physics instance belongs to.
         *
         * @name Phaser.Physics.Arcade.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                },
                /**
     * Creates a new Arcade Physics Collider object.
     *
     * @method Phaser.Physics.Arcade.Factory#collider
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object1 - The first object to check for collision.
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ collider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    return this.world.addCollider(object1, object2, collideCallback, processCallback, callbackContext);
                },
                /**
     * Creates a new Arcade Physics Collider Overlap object.
     *
     * @method Phaser.Physics.Arcade.Factory#overlap
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object1 - The first object to check for overlap.
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object2 - The second object to check for overlap.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ overlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    return this.world.addOverlap(object1, object2, collideCallback, processCallback, callbackContext);
                },
                /**
     * Adds an Arcade Physics Body to the given Game Object.
     *
     * @method Phaser.Physics.Arcade.Factory#existing
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - A Game Object.
     * @param {boolean} [isStatic=false] - Create a Static body (true) or Dynamic body (false).
     *
     * @return {Phaser.Types.Physics.Arcade.GameObjectWithBody} The Game Object.
     */ existing: function(gameObject, isStatic) {
                    var type = isStatic ? CONST.STATIC_BODY : CONST.DYNAMIC_BODY;
                    this.world.enableBody(gameObject, type);
                    return gameObject;
                },
                /**
     * Creates a new Arcade Image object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticImage
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithStaticBody} The Image object that was created.
     */ staticImage: function(x, y, key, frame) {
                    var image = new ArcadeImage(this.scene, x, y, key, frame);
                    this.sys.displayList.add(image);
                    this.world.enableBody(image, CONST.STATIC_BODY);
                    return image;
                },
                /**
     * Creates a new Arcade Image object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.ImageWithDynamicBody} The Image object that was created.
     */ image: function(x, y, key, frame) {
                    var image = new ArcadeImage(this.scene, x, y, key, frame);
                    this.sys.displayList.add(image);
                    this.world.enableBody(image, CONST.DYNAMIC_BODY);
                    return image;
                },
                /**
     * Creates a new Arcade Sprite object with a Static body.
     *
     * @method Phaser.Physics.Arcade.Factory#staticSprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithStaticBody} The Sprite object that was created.
     */ staticSprite: function(x, y, key, frame) {
                    var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    this.world.enableBody(sprite, CONST.STATIC_BODY);
                    return sprite;
                },
                /**
     * Creates a new Arcade Sprite object with a Dynamic body.
     *
     * @method Phaser.Physics.Arcade.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
     *
     * @return {Phaser.Types.Physics.Arcade.SpriteWithDynamicBody} The Sprite object that was created.
     */ sprite: function(x, y, key, frame) {
                    var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    this.world.enableBody(sprite, CONST.DYNAMIC_BODY);
                    return sprite;
                },
                /**
     * Creates a Static Physics Group object.
     * All Game Objects created by this Group will automatically be static Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#staticGroup
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} The Static Group object that was created.
     */ staticGroup: function(children, config) {
                    return this.sys.updateList.add(new StaticPhysicsGroup(this.world, this.world.scene, children, config));
                },
                /**
     * Creates a Physics Group object.
     * All Game Objects created by this Group will automatically be dynamic Arcade Physics objects.
     *
     * @method Phaser.Physics.Arcade.Factory#group
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
     * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
     *
     * @return {Phaser.Physics.Arcade.Group} The Group object that was created.
     */ group: function(children, config) {
                    return this.sys.updateList.add(new PhysicsGroup(this.world, this.world.scene, children, config));
                },
                /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Arcade.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.world = null;
                    this.scene = null;
                    this.sys = null;
                }
            });
            module1.exports = Factory;
        /***/ },
        /* 516 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(240);
            var Image1 = __webpack_require__(124);
            /**
 * @classdesc
 * An Arcade Physics Image is an Image with an Arcade Physics body and related components.
 * The body can be dynamic or static.
 *
 * The main difference between an Arcade Image and an Arcade Sprite is that you cannot animate an Arcade Image.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Arcade.Components.Acceleration
 * @extends Phaser.Physics.Arcade.Components.Angular
 * @extends Phaser.Physics.Arcade.Components.Bounce
 * @extends Phaser.Physics.Arcade.Components.Debug
 * @extends Phaser.Physics.Arcade.Components.Drag
 * @extends Phaser.Physics.Arcade.Components.Enable
 * @extends Phaser.Physics.Arcade.Components.Friction
 * @extends Phaser.Physics.Arcade.Components.Gravity
 * @extends Phaser.Physics.Arcade.Components.Immovable
 * @extends Phaser.Physics.Arcade.Components.Mass
 * @extends Phaser.Physics.Arcade.Components.Pushable
 * @extends Phaser.Physics.Arcade.Components.Size
 * @extends Phaser.Physics.Arcade.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 */ var ArcadeImage = new Class({
                Extends: Image1,
                Mixins: [
                    Components.Acceleration,
                    Components.Angular,
                    Components.Bounce,
                    Components.Debug,
                    Components.Drag,
                    Components.Enable,
                    Components.Friction,
                    Components.Gravity,
                    Components.Immovable,
                    Components.Mass,
                    Components.Pushable,
                    Components.Size,
                    Components.Velocity
                ],
                initialize: function ArcadeImage(scene, x, y, texture, frame) {
                    Image1.call(this, scene, x, y, texture, frame);
                    /**
         * This Game Object's Physics Body.
         *
         * @name Phaser.Physics.Arcade.Image#body
         * @type {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)}
         * @default null
         * @since 3.0.0
         */ this.body = null;
                }
            });
            module1.exports = ArcadeImage;
        /***/ },
        /* 517 */ /***/ function(module1, exports, __webpack_require__) {
            var OverlapRect = __webpack_require__(241);
            var Circle = __webpack_require__(62);
            var CircleToCircle = __webpack_require__(228);
            var CircleToRectangle = __webpack_require__(150);
            /**
 * This method will search the given circular area and return an array of all physics bodies that
 * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
 *
 * A body only has to intersect with the search area to be considered, it doesn't have to be fully
 * contained within it.
 *
 * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
 * otherwise the search is O(N) for Dynamic Bodies.
 *
 * @function Phaser.Physics.Arcade.Components.OverlapCirc
 * @since 3.21.0
 *
 * @param {number} x - The x coordinate of the center of the area to search within.
 * @param {number} y - The y coordinate of the center of the area to search within.
 * @param {number} radius - The radius of the area to search within.
 * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
 * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
 *
 * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
 */ var OverlapCirc = function(world, x, y, radius, includeDynamic, includeStatic) {
                var bodiesInRect = OverlapRect(world, x - radius, y - radius, 2 * radius, 2 * radius, includeDynamic, includeStatic);
                if (bodiesInRect.length === 0) return bodiesInRect;
                var area = new Circle(x, y, radius);
                var circFromBody = new Circle();
                var bodiesInArea = [];
                for(var i = 0; i < bodiesInRect.length; i++){
                    var body = bodiesInRect[i];
                    if (body.isCircle) {
                        circFromBody.setTo(body.center.x, body.center.y, body.halfWidth);
                        if (CircleToCircle(area, circFromBody)) bodiesInArea.push(body);
                    } else if (CircleToRectangle(area, body)) bodiesInArea.push(body);
                }
                return bodiesInArea;
            };
            module1.exports = OverlapCirc;
        /***/ },
        /* 518 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(155);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(60);
            var GetFastValue = __webpack_require__(2);
            var Group = __webpack_require__(110);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An Arcade Physics Group object.
 *
 * The primary use of a Physics Group is a way to collect together physics enable objects
 * that share the same intrinsic structure into a single pool. They can they be easily
 * compared against other Groups, or Game Objects.
 *
 * All Game Objects created by, or added to this Group will automatically be given **dynamic**
 * Arcade Physics bodies (if they have no body already) and the bodies will receive the
 * Groups {@link Phaser.Physics.Arcade.Group#defaults default values}.
 *
 * You should not pass objects into this Group that should not receive a body. For example,
 * do not add basic Geometry or Tilemap Layers into a Group, as they will not behave in the
 * way you may expect. Groups should all ideally have objects of the same type in them.
 *
 * If you wish to create a Group filled with Static Bodies, please see {@link Phaser.Physics.Arcade.StaticGroup}.
 *
 * @class Group
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.Physics.Arcade.PhysicsGroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var PhysicsGroup = new Class({
                Extends: Group,
                initialize: function PhysicsGroup(world, scene, children, config) {
                    if (!children && !config) config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    else if (IsPlainObject(children)) {
                        //  children is a plain object, so swizzle them:
                        config = children;
                        children = null;
                        config.internalCreateCallback = this.createCallbackHandler;
                        config.internalRemoveCallback = this.removeCallbackHandler;
                    } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                        //  children is an array of plain objects (i.e., configs)
                        config = children[0];
                        var _this = this;
                        children.forEach(function(singleConfig) {
                            singleConfig.internalCreateCallback = _this.createCallbackHandler;
                            singleConfig.internalRemoveCallback = _this.removeCallbackHandler;
                        });
                        children = null;
                    } else // config is not defined and children is not a plain object nor an array of plain objects
                    config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.Group#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The class to create new Group members from.
         *
         * This should be either `Phaser.Physics.Arcade.Image`, `Phaser.Physics.Arcade.Sprite`, or a class extending one of those.
         *
         * @name Phaser.Physics.Arcade.Group#classType
         * @type {Function}
         * @default ArcadeSprite
         * @since 3.0.0
         */ config.classType = GetFastValue(config, 'classType', ArcadeSprite);
                    /**
         * The physics type of the Group's members.
         *
         * @name Phaser.Physics.Arcade.Group#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                    /**
         * Default physics properties applied to Game Objects added to the Group or created by the Group. Derived from the `config` argument.
         *
         * You can remove the default values by setting this property to `{}`.
         *
         * @name Phaser.Physics.Arcade.Group#defaults
         * @type {Phaser.Types.Physics.Arcade.PhysicsGroupDefaults}
         * @since 3.0.0
         */ this.defaults = {
                        setCollideWorldBounds: GetFastValue(config, 'collideWorldBounds', false),
                        setBoundsRectangle: GetFastValue(config, 'customBoundsRectangle', null),
                        setAccelerationX: GetFastValue(config, 'accelerationX', 0),
                        setAccelerationY: GetFastValue(config, 'accelerationY', 0),
                        setAllowDrag: GetFastValue(config, 'allowDrag', true),
                        setAllowGravity: GetFastValue(config, 'allowGravity', true),
                        setAllowRotation: GetFastValue(config, 'allowRotation', true),
                        setBounceX: GetFastValue(config, 'bounceX', 0),
                        setBounceY: GetFastValue(config, 'bounceY', 0),
                        setDragX: GetFastValue(config, 'dragX', 0),
                        setDragY: GetFastValue(config, 'dragY', 0),
                        setEnable: GetFastValue(config, 'enable', true),
                        setGravityX: GetFastValue(config, 'gravityX', 0),
                        setGravityY: GetFastValue(config, 'gravityY', 0),
                        setFrictionX: GetFastValue(config, 'frictionX', 0),
                        setFrictionY: GetFastValue(config, 'frictionY', 0),
                        setMaxVelocityX: GetFastValue(config, 'maxVelocityX', 10000),
                        setMaxVelocityY: GetFastValue(config, 'maxVelocityY', 10000),
                        setVelocityX: GetFastValue(config, 'velocityX', 0),
                        setVelocityY: GetFastValue(config, 'velocityY', 0),
                        setAngularVelocity: GetFastValue(config, 'angularVelocity', 0),
                        setAngularAcceleration: GetFastValue(config, 'angularAcceleration', 0),
                        setAngularDrag: GetFastValue(config, 'angularDrag', 0),
                        setMass: GetFastValue(config, 'mass', 1),
                        setImmovable: GetFastValue(config, 'immovable', false)
                    };
                    Group.call(this, scene, children, config);
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.Group#type
         * @type {string}
         * @default 'PhysicsGroup'
         * @since 3.21.0
         */ this.type = 'PhysicsGroup';
                },
                /**
     * Enables a Game Object's Body and assigns `defaults`. Called when a Group member is added or created.
     *
     * @method Phaser.Physics.Arcade.Group#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being added.
     */ createCallbackHandler: function(child) {
                    if (!child.body) this.world.enableBody(child, CONST.DYNAMIC_BODY);
                    var body = child.body;
                    for(var key in this.defaults)body[key](this.defaults[key]);
                },
                /**
     * Disables a Game Object's Body. Called when a Group member is removed.
     *
     * @method Phaser.Physics.Arcade.Group#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object being removed.
     */ removeCallbackHandler: function(child) {
                    if (child.body) this.world.disableBody(child);
                },
                /**
     * Sets the velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity.
     * @param {number} y - The vertical velocity.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x, y), the second (x + step, y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocity: function(x, y, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.set(x + i * step, y + i * step);
                    return this;
                },
                /**
     * Sets the horizontal velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (x), the second (x + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityX: function(value, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.x = value + i * step;
                    return this;
                },
                /**
     * Sets the vertical velocity of each Group member.
     *
     * @method Phaser.Physics.Arcade.Group#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity value.
     * @param {number} [step=0] - The velocity increment. When set, the first member receives velocity (y), the second (y + step), and so on.
     *
     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
     */ setVelocityY: function(value, step) {
                    if (step === undefined) step = 0;
                    var items = this.getChildren();
                    for(var i = 0; i < items.length; i++)items[i].body.velocity.y = value + i * step;
                    return this;
                }
            });
            module1.exports = PhysicsGroup;
        /***/ },
        /* 519 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArcadeSprite = __webpack_require__(155);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(60);
            var GetFastValue = __webpack_require__(2);
            var Group = __webpack_require__(110);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An Arcade Physics Static Group object.
 *
 * All Game Objects created by or added to this Group will automatically be given static Arcade Physics bodies, if they have no body.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Group}.
 *
 * @class StaticGroup
 * @extends Phaser.GameObjects.Group
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The physics simulation.
 * @param {Phaser.Scene} scene - The scene this group belongs to.
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig)} [children] - Game Objects to add to this group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - Settings for this group.
 */ var StaticPhysicsGroup = new Class({
                Extends: Group,
                initialize: function StaticPhysicsGroup(world, scene, children, config) {
                    if (!children && !config) config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler,
                        createMultipleCallback: this.createMultipleCallbackHandler,
                        classType: ArcadeSprite
                    };
                    else if (IsPlainObject(children)) {
                        //  children is a plain object, so swizzle them:
                        config = children;
                        children = null;
                        config.internalCreateCallback = this.createCallbackHandler;
                        config.internalRemoveCallback = this.removeCallbackHandler;
                        config.createMultipleCallback = this.createMultipleCallbackHandler;
                        config.classType = GetFastValue(config, 'classType', ArcadeSprite);
                    } else if (Array.isArray(children) && IsPlainObject(children[0])) {
                        //  children is an array of plain objects
                        config = children;
                        children = null;
                        config.forEach(function(singleConfig) {
                            singleConfig.internalCreateCallback = this.createCallbackHandler;
                            singleConfig.internalRemoveCallback = this.removeCallbackHandler;
                            singleConfig.createMultipleCallback = this.createMultipleCallbackHandler;
                            singleConfig.classType = GetFastValue(singleConfig, 'classType', ArcadeSprite);
                        });
                    } else // config is not defined and children is not a plain object nor an array of plain objects
                    config = {
                        internalCreateCallback: this.createCallbackHandler,
                        internalRemoveCallback: this.removeCallbackHandler
                    };
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The scene this group belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                    Group.call(this, scene, children, config);
                    /**
         * A textual representation of this Game Object.
         * Used internally by Phaser but is available for your own custom classes to populate.
         *
         * @name Phaser.Physics.Arcade.StaticGroup#type
         * @type {string}
         * @default 'StaticPhysicsGroup'
         * @since 3.21.0
         */ this.type = 'StaticPhysicsGroup';
                },
                /**
     * Adds a static physics body to the new group member (if it lacks one) and adds it to the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The new group member.
     *
     * @see Phaser.Physics.Arcade.World#enableBody
     */ createCallbackHandler: function(child) {
                    if (!child.body) this.world.enableBody(child, CONST.STATIC_BODY);
                },
                /**
     * Disables the group member's physics body, removing it from the simulation.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#removeCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The group member being removed.
     *
     * @see Phaser.Physics.Arcade.World#disableBody
     */ removeCallbackHandler: function(child) {
                    if (child.body) this.world.disableBody(child);
                },
                /**
     * Refreshes the group.
     *
     * @method Phaser.Physics.Arcade.StaticGroup#createMultipleCallbackHandler
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} entries - The newly created group members.
     *
     * @see Phaser.Physics.Arcade.StaticGroup#refresh
     */ createMultipleCallbackHandler: function() {
                    this.refresh();
                },
                /**
     * Resets each Body to the position of its parent Game Object.
     * Body sizes aren't changed (use {@link Phaser.Physics.Arcade.Components.Enable#refreshBody} for that).
     *
     * @method Phaser.Physics.Arcade.StaticGroup#refresh
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticGroup} This group.
     *
     * @see Phaser.Physics.Arcade.StaticBody#reset
     */ refresh: function() {
                    var children = this.children.entries;
                    for(var i = 0; i < children.length; i++)children[i].body.reset();
                    return this;
                }
            });
            module1.exports = StaticPhysicsGroup;
        /***/ },
        /* 520 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AngleBetweenPoints = __webpack_require__(344);
            var Body = __webpack_require__(521);
            var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Collider = __webpack_require__(522);
            var CONST = __webpack_require__(60);
            var DistanceBetween = __webpack_require__(48);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(242);
            var FuzzyEqual = __webpack_require__(123);
            var FuzzyGreaterThan = __webpack_require__(348);
            var FuzzyLessThan = __webpack_require__(349);
            var GetOverlapX = __webpack_require__(243);
            var GetOverlapY = __webpack_require__(244);
            var GetTilesWithinWorldXY = __webpack_require__(523);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            var ProcessQueue = __webpack_require__(208);
            var ProcessTileCallbacks = __webpack_require__(524);
            var Rectangle = __webpack_require__(10);
            var RTree = __webpack_require__(525);
            var SeparateTile = __webpack_require__(526);
            var SeparateX = __webpack_require__(531);
            var SeparateY = __webpack_require__(532);
            var Set = __webpack_require__(148);
            var StaticBody = __webpack_require__(533);
            var TileIntersectsBody = __webpack_require__(245);
            var TransformMatrix = __webpack_require__(25);
            var Vector2 = __webpack_require__(3);
            var Wrap = __webpack_require__(66);
            /**
 * @classdesc
 * The Arcade Physics World.
 *
 * The World is responsible for creating, managing, colliding and updating all of the bodies within it.
 *
 * An instance of the World belongs to a Phaser.Scene and is accessed via the property `physics.world`.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this World instance belongs.
 * @param {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} config - An Arcade Physics Configuration object.
 */ var World = new Class({
                Extends: EventEmitter,
                initialize: function World(scene, config) {
                    EventEmitter.call(this);
                    /**
         * The Scene this simulation belongs to.
         *
         * @name Phaser.Physics.Arcade.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * Dynamic Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#bodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.Body>}
         * @since 3.0.0
         */ this.bodies = new Set();
                    /**
         * Static Bodies in this simulation.
         *
         * @name Phaser.Physics.Arcade.World#staticBodies
         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.StaticBody>}
         * @since 3.0.0
         */ this.staticBodies = new Set();
                    /**
         * Static Bodies marked for deletion.
         *
         * @name Phaser.Physics.Arcade.World#pendingDestroy
         * @type {Phaser.Structs.Set.<(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)>}
         * @since 3.1.0
         */ this.pendingDestroy = new Set();
                    /**
         * This simulation's collision processors.
         *
         * @name Phaser.Physics.Arcade.World#colliders
         * @type {Phaser.Structs.ProcessQueue.<Phaser.Physics.Arcade.Collider>}
         * @since 3.0.0
         */ this.colliders = new ProcessQueue();
                    /**
         * Acceleration of Bodies due to gravity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.World#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.gravity = new Vector2(GetValue(config, 'gravity.x', 0), GetValue(config, 'gravity.y', 0));
                    /**
         * A boundary constraining Bodies.
         *
         * @name Phaser.Physics.Arcade.World#bounds
         * @type {Phaser.Geom.Rectangle}
         * @since 3.0.0
         */ this.bounds = new Rectangle(GetValue(config, 'x', 0), GetValue(config, 'y', 0), GetValue(config, 'width', scene.sys.scale.width), GetValue(config, 'height', scene.sys.scale.height));
                    /**
         * The boundary edges that Bodies can collide with.
         *
         * @name Phaser.Physics.Arcade.World#checkCollision
         * @type {Phaser.Types.Physics.Arcade.CheckCollisionObject}
         * @since 3.0.0
         */ this.checkCollision = {
                        up: GetValue(config, 'checkCollision.up', true),
                        down: GetValue(config, 'checkCollision.down', true),
                        left: GetValue(config, 'checkCollision.left', true),
                        right: GetValue(config, 'checkCollision.right', true)
                    };
                    /**
         * The number of physics steps to be taken per second.
         *
         * This property is read-only. Use the `setFPS` method to modify it at run-time.
         *
         * @name Phaser.Physics.Arcade.World#fps
         * @readonly
         * @type {number}
         * @default 60
         * @since 3.10.0
         */ this.fps = GetValue(config, 'fps', 60);
                    /**
         * Should Physics use a fixed update time-step (true) or sync to the render fps (false)?.
         * False value of this property disables fps and timeScale properties.
         *
         * @name Phaser.Physics.Arcade.World#fixedStep
         * @type {boolean}
         * @default true
         * @since 3.23.0
         */ this.fixedStep = GetValue(config, 'fixedStep', true);
                    /**
         * The amount of elapsed ms since the last frame.
         *
         * @name Phaser.Physics.Arcade.World#_elapsed
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._elapsed = 0;
                    /**
         * Internal frame time value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTime
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTime = 1 / this.fps;
                    /**
         * Internal frame time ms value.
         *
         * @name Phaser.Physics.Arcade.World#_frameTimeMS
         * @private
         * @type {number}
         * @since 3.10.0
         */ this._frameTimeMS = 1000 * this._frameTime;
                    /**
         * The number of steps that took place in the last frame.
         *
         * @name Phaser.Physics.Arcade.World#stepsLastFrame
         * @readonly
         * @type {number}
         * @since 3.10.0
         */ this.stepsLastFrame = 0;
                    /**
         * Scaling factor applied to the frame rate.
         *
         * - 1.0 = normal speed
         * - 2.0 = half speed
         * - 0.5 = double speed
         *
         * @name Phaser.Physics.Arcade.World#timeScale
         * @type {number}
         * @default 1
         * @since 3.10.0
         */ this.timeScale = GetValue(config, 'timeScale', 1);
                    /**
         * The maximum absolute difference of a Body's per-step velocity and its overlap with another Body that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         *
         * @name Phaser.Physics.Arcade.World#OVERLAP_BIAS
         * @type {number}
         * @default 4
         * @since 3.0.0
         */ this.OVERLAP_BIAS = GetValue(config, 'overlapBias', 4);
                    /**
         * The maximum absolute value of a Body's overlap with a tile that will result in separation on *each axis*.
         * Larger values favor separation.
         * Smaller values favor no separation.
         * The optimum value may be similar to the tile size.
         *
         * @name Phaser.Physics.Arcade.World#TILE_BIAS
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.TILE_BIAS = GetValue(config, 'tileBias', 16);
                    /**
         * Always separate overlapping Bodies horizontally before vertically.
         * False (the default) means Bodies are first separated on the axis of greater gravity, or the vertical axis if neither is greater.
         *
         * @name Phaser.Physics.Arcade.World#forceX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.forceX = GetValue(config, 'forceX', false);
                    /**
         * Whether the simulation advances with the game loop.
         *
         * @name Phaser.Physics.Arcade.World#isPaused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isPaused = GetValue(config, 'isPaused', false);
                    /**
         * Temporary total of colliding Bodies.
         *
         * @name Phaser.Physics.Arcade.World#_total
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._total = 0;
                    /**
         * Enables the debug display.
         *
         * @name Phaser.Physics.Arcade.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = GetValue(config, 'debug', false);
                    /**
         * The graphics object drawing the debug display.
         *
         * @name Phaser.Physics.Arcade.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                    /**
         * Default debug display settings for new Bodies.
         *
         * @name Phaser.Physics.Arcade.World#defaults
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldDefaults}
         * @since 3.0.0
         */ this.defaults = {
                        debugShowBody: GetValue(config, 'debugShowBody', true),
                        debugShowStaticBody: GetValue(config, 'debugShowStaticBody', true),
                        debugShowVelocity: GetValue(config, 'debugShowVelocity', true),
                        bodyDebugColor: GetValue(config, 'debugBodyColor', 0xff00ff),
                        staticBodyDebugColor: GetValue(config, 'debugStaticBodyColor', 0x0000ff),
                        velocityDebugColor: GetValue(config, 'debugVelocityColor', 0x00ff00)
                    };
                    /**
         * The maximum number of items per node on the RTree.
         *
         * This is ignored if `useTree` is `false`. If you have a large number of bodies in
         * your world then you may find search performance improves by increasing this value,
         * to allow more items per node and less node division.
         *
         * @name Phaser.Physics.Arcade.World#maxEntries
         * @type {number}
         * @default 16
         * @since 3.0.0
         */ this.maxEntries = GetValue(config, 'maxEntries', 16);
                    /**
         * Should this Arcade Physics World use an RTree for Dynamic bodies?
         *
         * An RTree is a fast way of spatially sorting of all the bodies in the world.
         * However, at certain limits, the cost of clearing and inserting the bodies into the
         * tree every frame becomes more expensive than the search speed gains it provides.
         *
         * If you have a large number of dynamic bodies in your world then it may be best to
         * disable the use of the RTree by setting this property to `false` in the physics config.
         *
         * The number it can cope with depends on browser and device, but a conservative estimate
         * of around 5,000 bodies should be considered the max before disabling it.
         *
         * This only applies to dynamic bodies. Static bodies are always kept in an RTree,
         * because they don't have to be cleared every frame, so you benefit from the
         * massive search speeds all the time.
         *
         * @name Phaser.Physics.Arcade.World#useTree
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.useTree = GetValue(config, 'useTree', true);
                    /**
         * The spatial index of Dynamic Bodies.
         *
         * @name Phaser.Physics.Arcade.World#tree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.tree = new RTree(this.maxEntries);
                    /**
         * The spatial index of Static Bodies.
         *
         * @name Phaser.Physics.Arcade.World#staticTree
         * @type {Phaser.Structs.RTree}
         * @since 3.0.0
         */ this.staticTree = new RTree(this.maxEntries);
                    /**
         * Recycled input for tree searches.
         *
         * @name Phaser.Physics.Arcade.World#treeMinMax
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldTreeMinMax}
         * @since 3.0.0
         */ this.treeMinMax = {
                        minX: 0,
                        minY: 0,
                        maxX: 0,
                        maxY: 0
                    };
                    /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix = new TransformMatrix();
                    /**
         * A temporary Transform Matrix used by bodies for calculations without them needing their own local copy.
         *
         * @name Phaser.Physics.Arcade.World#_tempMatrix2
         * @type {Phaser.GameObjects.Components.TransformMatrix}
         * @private
         * @since 3.12.0
         */ this._tempMatrix2 = new TransformMatrix();
                    if (this.drawDebug) this.createDebugGraphic();
                },
                /**
     * Adds an Arcade Physics Body to a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `enableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * You can specify if the bodies are to be Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to create the bodies.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     */ enable: function(object, bodyType) {
                    if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entry = object[i];
                        if (entry.isParent) {
                            var children = entry.getChildren();
                            for(var c = 0; c < children.length; c++){
                                var child = children[c];
                                if (child.isParent) //  Handle Groups nested inside of Groups
                                this.enable(child, bodyType);
                                else this.enableBody(child, bodyType);
                            }
                        } else this.enableBody(entry, bodyType);
                    }
                },
                /**
     * Creates an Arcade Physics Body on a single Game Object.
     *
     * If the Game Object already has a body, this method will simply add it back into the simulation.
     *
     * You can specify if the body is Dynamic or Static. A dynamic body can move via velocity and
     * acceleration. A static body remains fixed in place and as such is able to use an optimized search
     * tree, making it ideal for static elements such as level objects. You can still collide and overlap
     * with static bodies.
     *
     * Normally, rather than calling this method directly, you'd use the helper methods available in the
     * Arcade Physics Factory, such as:
     *
     * ```javascript
     * this.physics.add.image(x, y, textureKey);
     * this.physics.add.sprite(x, y, textureKey);
     * ```
     *
     * Calling factory methods encapsulates the creation of a Game Object and the creation of its
     * body at the same time. If you are creating custom classes then you can pass them to this
     * method to have their bodies created.
     *
     * @method Phaser.Physics.Arcade.World#enableBody
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} object - The Game Object on which to create the body.
     * @param {number} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object on which the body was created.
     */ enableBody: function(object, bodyType) {
                    if (bodyType === undefined) bodyType = CONST.DYNAMIC_BODY;
                    if (!object.body) {
                        if (bodyType === CONST.DYNAMIC_BODY) object.body = new Body(this, object);
                        else if (bodyType === CONST.STATIC_BODY) object.body = new StaticBody(this, object);
                    }
                    this.add(object.body);
                    return object;
                },
                /**
     * Adds an existing Arcade Physics Body or StaticBody to the simulation.
     *
     * The body is enabled and added to the local search trees.
     *
     * @method Phaser.Physics.Arcade.World#add
     * @since 3.10.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be added to the simulation.
     *
     * @return {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} The Body that was added to the simulation.
     */ add: function(body) {
                    if (body.physicsType === CONST.DYNAMIC_BODY) this.bodies.set(body);
                    else if (body.physicsType === CONST.STATIC_BODY) {
                        this.staticBodies.set(body);
                        this.staticTree.insert(body);
                    }
                    body.enable = true;
                    return body;
                },
                /**
     * Disables the Arcade Physics Body of a Game Object, an array of Game Objects, or the children of a Group.
     *
     * The difference between this and the `disableBody` method is that you can pass arrays or Groups
     * to this method.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]|Phaser.GameObjects.Group|Phaser.GameObjects.Group[])} object - The object, or objects, on which to disable the bodies.
     */ disable: function(object) {
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entry = object[i];
                        if (entry.isParent) {
                            var children = entry.getChildren();
                            for(var c = 0; c < children.length; c++){
                                var child = children[c];
                                if (child.isParent) //  Handle Groups nested inside of Groups
                                this.disable(child);
                                else this.disableBody(child.body);
                            }
                        } else this.disableBody(entry.body);
                    }
                },
                /**
     * Disables an existing Arcade Physics Body or StaticBody and removes it from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enable` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `World.enable` or `World.add`.
     *
     * @method Phaser.Physics.Arcade.World#disableBody
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The Body to be disabled.
     */ disableBody: function(body) {
                    this.remove(body);
                    body.enable = false;
                },
                /**
     * Removes an existing Arcade Physics Body or StaticBody from the simulation.
     *
     * The body is disabled and removed from the local search trees.
     *
     * The body itself is not deleted, it just has its `enabled` property set to false, which
     * means you can re-enable it again at any point by passing it to enable `enable` or `add`.
     *
     * @method Phaser.Physics.Arcade.World#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)} body - The body to be removed from the simulation.
     */ remove: function(body) {
                    if (body.physicsType === CONST.DYNAMIC_BODY) {
                        this.tree.remove(body);
                        this.bodies.delete(body);
                    } else if (body.physicsType === CONST.STATIC_BODY) {
                        this.staticBodies.delete(body);
                        this.staticTree.remove(body);
                    }
                },
                /**
     * Creates a Graphics Game Object that the world will use to render the debug display to.
     *
     * This is called automatically when the World is instantiated if the `debug` config property
     * was set to `true`. However, you can call it at any point should you need to display the
     * debug Graphic from a fixed point.
     *
     * You can control which objects are drawn to the Graphics object, and the colors they use,
     * by setting the debug properties in the physics config.
     *
     * You should not typically use this in a production game. Use it to aid during debugging.
     *
     * @method Phaser.Physics.Arcade.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object that was created for use by the World.
     */ createDebugGraphic: function() {
                    var graphic = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    graphic.setDepth(Number.MAX_VALUE);
                    this.debugGraphic = graphic;
                    this.drawDebug = true;
                    return graphic;
                },
                /**
     * Sets the position, size and properties of the World boundary.
     *
     * The World boundary is an invisible rectangle that defines the edges of the World.
     * If a Body is set to collide with the world bounds then it will automatically stop
     * when it reaches any of the edges. You can optionally set which edges of the boundary
     * should be checked against.
     *
     * @method Phaser.Physics.Arcade.World#setBounds
     * @since 3.0.0
     *
     * @param {number} x - The top-left x coordinate of the boundary.
     * @param {number} y - The top-left y coordinate of the boundary.
     * @param {number} width - The width of the boundary.
     * @param {number} height - The height of the boundary.
     * @param {boolean} [checkLeft] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [checkRight] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [checkUp] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [checkDown] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBounds: function(x, y, width, height, checkLeft, checkRight, checkUp, checkDown) {
                    this.bounds.setTo(x, y, width, height);
                    if (checkLeft !== undefined) this.setBoundsCollision(checkLeft, checkRight, checkUp, checkDown);
                    return this;
                },
                /**
     * Enables or disables collisions on each edge of the World boundary.
     *
     * @method Phaser.Physics.Arcade.World#setBoundsCollision
     * @since 3.0.0
     *
     * @param {boolean} [left=true] - Should bodies check against the left edge of the boundary?
     * @param {boolean} [right=true] - Should bodies check against the right edge of the boundary?
     * @param {boolean} [up=true] - Should bodies check against the top edge of the boundary?
     * @param {boolean} [down=true] - Should bodies check against the bottom edge of the boundary?
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ setBoundsCollision: function(left, right, up, down) {
                    if (left === undefined) left = true;
                    if (right === undefined) right = true;
                    if (up === undefined) up = true;
                    if (down === undefined) down = true;
                    this.checkCollision.left = left;
                    this.checkCollision.right = right;
                    this.checkCollision.up = up;
                    this.checkCollision.down = down;
                    return this;
                },
                /**
     * Pauses the simulation.
     *
     * A paused simulation does not update any existing bodies, or run any Colliders.
     *
     * However, you can still enable and disable bodies within it, or manually run collide or overlap
     * checks.
     *
     * @method Phaser.Physics.Arcade.World#pause
     * @fires Phaser.Physics.Arcade.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ pause: function() {
                    this.isPaused = true;
                    this.emit(Events.PAUSE);
                    return this;
                },
                /**
     * Resumes the simulation, if paused.
     *
     * @method Phaser.Physics.Arcade.World#resume
     * @fires Phaser.Physics.Arcade.Events#RESUME
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ resume: function() {
                    this.isPaused = false;
                    this.emit(Events.RESUME);
                    return this;
                },
                /**
     * Creates a new Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform collision checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.collide` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addCollider
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.World#collide
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addCollider: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    var collider = new Collider(this, false, object1, object2, collideCallback, processCallback, callbackContext);
                    this.colliders.add(collider);
                    return collider;
                },
                /**
     * Creates a new Overlap Collider object and adds it to the simulation.
     *
     * A Collider is a way to automatically perform overlap checks between two objects,
     * calling the collide and process callbacks if they occur.
     *
     * Colliders are run as part of the World update, after all of the Bodies have updated.
     *
     * By creating a Collider you don't need then call `World.overlap` in your `update` loop,
     * as it will be handled for you automatically.
     *
     * @method Phaser.Physics.Arcade.World#addOverlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for overlap.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for overlap.
     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects overlap. Must return a boolean.
     * @param {*} [callbackContext] - The scope in which to call the callbacks.
     *
     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
     */ addOverlap: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    var collider = new Collider(this, true, object1, object2, collideCallback, processCallback, callbackContext);
                    this.colliders.add(collider);
                    return collider;
                },
                /**
     * Removes a Collider from the simulation so it is no longer processed.
     *
     * This method does not destroy the Collider. If you wish to add it back at a later stage you can call
     * `World.colliders.add(Collider)`.
     *
     * If you no longer need the Collider you can call the `Collider.destroy` method instead, which will
     * automatically clear all of its references and then remove it from the World. If you call destroy on
     * a Collider you _don't_ need to pass it to this method too.
     *
     * @method Phaser.Physics.Arcade.World#removeCollider
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Collider} collider - The Collider to remove from the simulation.
     *
     * @return {Phaser.Physics.Arcade.World} This World object.
     */ removeCollider: function(collider) {
                    this.colliders.remove(collider);
                    return this;
                },
                /**
     * Sets the frame rate to run the simulation at.
     *
     * The frame rate value is used to simulate a fixed update time step. This fixed
     * time step allows for a straightforward implementation of a deterministic game state.
     *
     * This frame rate is independent of the frequency at which the game is rendering. The
     * higher you set the fps, the more physics simulation steps will occur per game step.
     * Conversely, the lower you set it, the less will take place.
     *
     * You can optionally advance the simulation directly yourself by calling the `step` method.
     *
     * @method Phaser.Physics.Arcade.World#setFPS
     * @since 3.10.0
     *
     * @param {number} framerate - The frame rate to advance the simulation at.
     *
     * @return {this} This World object.
     */ setFPS: function(framerate) {
                    this.fps = framerate;
                    this._frameTime = 1 / this.fps;
                    this._frameTimeMS = 1000 * this._frameTime;
                    return this;
                },
                /**
     * Advances the simulation based on the elapsed time and fps rate.
     *
     * This is called automatically by your Scene and does not need to be invoked directly.
     *
     * @method Phaser.Physics.Arcade.World#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (this.isPaused || this.bodies.size === 0) return;
                    var i;
                    var fixedDelta = this._frameTime;
                    var msPerFrame = this._frameTimeMS * this.timeScale;
                    this._elapsed += delta;
                    //  Update all active bodies
                    var body;
                    var bodies = this.bodies.entries;
                    //  Will a step happen this frame?
                    var willStep = this._elapsed >= msPerFrame;
                    if (!this.fixedStep) {
                        fixedDelta = delta * 0.001;
                        willStep = true;
                        this._elapsed = 0;
                    }
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (body.enable) body.preUpdate(willStep, fixedDelta);
                    }
                    //  We know that a step will happen this frame, so let's bundle it all together to save branching and iteration costs
                    if (willStep) {
                        this._elapsed -= msPerFrame;
                        this.stepsLastFrame = 1;
                        //  Optionally populate our dynamic collision tree
                        if (this.useTree) {
                            this.tree.clear();
                            this.tree.load(bodies);
                        }
                        //  Process any colliders
                        var colliders = this.colliders.update();
                        for(i = 0; i < colliders.length; i++){
                            var collider = colliders[i];
                            if (collider.active) collider.update();
                        }
                        this.emit(Events.WORLD_STEP, fixedDelta);
                    }
                    //  Process any additional steps this frame
                    while(this._elapsed >= msPerFrame){
                        this._elapsed -= msPerFrame;
                        this.step(fixedDelta);
                    }
                },
                /**
     * Advances the simulation by a time increment.
     *
     * @method Phaser.Physics.Arcade.World#step
     * @fires Phaser.Physics.Arcade.Events#WORLD_STEP
     * @since 3.10.0
     *
     * @param {number} delta - The delta time amount, in seconds, by which to advance the simulation.
     */ step: function(delta) {
                    //  Update all active bodies
                    var i;
                    var body;
                    var bodies = this.bodies.entries;
                    var len = bodies.length;
                    for(i = 0; i < len; i++){
                        body = bodies[i];
                        if (body.enable) body.update(delta);
                    }
                    //  Optionally populate our dynamic collision tree
                    if (this.useTree) {
                        this.tree.clear();
                        this.tree.load(bodies);
                    }
                    //  Process any colliders
                    var colliders = this.colliders.update();
                    for(i = 0; i < colliders.length; i++){
                        var collider = colliders[i];
                        if (collider.active) collider.update();
                    }
                    this.emit(Events.WORLD_STEP, delta);
                    this.stepsLastFrame++;
                },
                /**
     * Updates bodies, draws the debug display, and handles pending queue operations.
     *
     * @method Phaser.Physics.Arcade.World#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                    var i;
                    var body;
                    var bodies = this.bodies.entries;
                    var len = bodies.length;
                    var dynamic = this.bodies;
                    var staticBodies = this.staticBodies;
                    //  We don't need to postUpdate if there wasn't a step this frame
                    if (this.stepsLastFrame) {
                        this.stepsLastFrame = 0;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.enable) body.postUpdate();
                        }
                    }
                    if (this.drawDebug) {
                        var graphics = this.debugGraphic;
                        graphics.clear();
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.willDrawDebug()) body.drawDebug(graphics);
                        }
                        bodies = staticBodies.entries;
                        len = bodies.length;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.willDrawDebug()) body.drawDebug(graphics);
                        }
                    }
                    var pending = this.pendingDestroy;
                    if (pending.size > 0) {
                        var dynamicTree = this.tree;
                        var staticTree = this.staticTree;
                        bodies = pending.entries;
                        len = bodies.length;
                        for(i = 0; i < len; i++){
                            body = bodies[i];
                            if (body.physicsType === CONST.DYNAMIC_BODY) {
                                dynamicTree.remove(body);
                                dynamic.delete(body);
                            } else if (body.physicsType === CONST.STATIC_BODY) {
                                staticTree.remove(body);
                                staticBodies.delete(body);
                            }
                            body.world = undefined;
                            body.gameObject = undefined;
                        }
                        pending.clear();
                    }
                },
                /**
     * Calculates a Body's velocity and updates its position.
     *
     * @method Phaser.Physics.Arcade.World#updateMotion
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to be updated.
     * @param {number} delta - The delta value to be used in the motion calculations, in seconds.
     */ updateMotion: function(body, delta) {
                    if (body.allowRotation) this.computeAngularVelocity(body, delta);
                    this.computeVelocity(body, delta);
                },
                /**
     * Calculates a Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeAngularVelocity
     * @since 3.10.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeAngularVelocity: function(body, delta) {
                    var velocity = body.angularVelocity;
                    var acceleration = body.angularAcceleration;
                    var drag = body.angularDrag;
                    var max = body.maxAngular;
                    if (acceleration) velocity += acceleration * delta;
                    else if (body.allowDrag && drag) {
                        drag *= delta;
                        if (FuzzyGreaterThan(velocity - drag, 0, 0.1)) velocity -= drag;
                        else if (FuzzyLessThan(velocity + drag, 0, 0.1)) velocity += drag;
                        else velocity = 0;
                    }
                    velocity = Clamp(velocity, -max, max);
                    var velocityDelta = velocity - body.angularVelocity;
                    body.angularVelocity += velocityDelta;
                    body.rotation += body.angularVelocity * delta;
                },
                /**
     * Calculates a Body's per-axis velocity.
     *
     * @method Phaser.Physics.Arcade.World#computeVelocity
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body - The Body to compute the velocity for.
     * @param {number} delta - The delta value to be used in the calculation, in seconds.
     */ computeVelocity: function(body, delta) {
                    var velocityX = body.velocity.x;
                    var accelerationX = body.acceleration.x;
                    var dragX = body.drag.x;
                    var maxX = body.maxVelocity.x;
                    var velocityY = body.velocity.y;
                    var accelerationY = body.acceleration.y;
                    var dragY = body.drag.y;
                    var maxY = body.maxVelocity.y;
                    var speed = body.speed;
                    var maxSpeed = body.maxSpeed;
                    var allowDrag = body.allowDrag;
                    var useDamping = body.useDamping;
                    if (body.allowGravity) {
                        velocityX += (this.gravity.x + body.gravity.x) * delta;
                        velocityY += (this.gravity.y + body.gravity.y) * delta;
                    }
                    if (accelerationX) velocityX += accelerationX * delta;
                    else if (allowDrag && dragX) {
                        if (useDamping) {
                            //  Damping based deceleration
                            dragX = Math.pow(dragX, delta);
                            velocityX *= dragX;
                            speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                            if (FuzzyEqual(speed, 0, 0.001)) velocityX = 0;
                        } else {
                            //  Linear deceleration
                            dragX *= delta;
                            if (FuzzyGreaterThan(velocityX - dragX, 0, 0.01)) velocityX -= dragX;
                            else if (FuzzyLessThan(velocityX + dragX, 0, 0.01)) velocityX += dragX;
                            else velocityX = 0;
                        }
                    }
                    if (accelerationY) velocityY += accelerationY * delta;
                    else if (allowDrag && dragY) {
                        if (useDamping) {
                            //  Damping based deceleration
                            dragY = Math.pow(dragY, delta);
                            velocityY *= dragY;
                            speed = Math.sqrt(velocityX * velocityX + velocityY * velocityY);
                            if (FuzzyEqual(speed, 0, 0.001)) velocityY = 0;
                        } else {
                            //  Linear deceleration
                            dragY *= delta;
                            if (FuzzyGreaterThan(velocityY - dragY, 0, 0.01)) velocityY -= dragY;
                            else if (FuzzyLessThan(velocityY + dragY, 0, 0.01)) velocityY += dragY;
                            else velocityY = 0;
                        }
                    }
                    velocityX = Clamp(velocityX, -maxX, maxX);
                    velocityY = Clamp(velocityY, -maxY, maxY);
                    body.velocity.set(velocityX, velocityY);
                    if (maxSpeed > -1 && speed > maxSpeed) {
                        body.velocity.normalize().scale(maxSpeed);
                        speed = maxSpeed;
                    }
                    body.speed = speed;
                },
                /**
     * Separates two Bodies.
     *
     * @method Phaser.Physics.Arcade.World#separate
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {ArcadePhysicsCallback} [processCallback] - The process callback.
     * @param {*} [callbackContext] - The context in which to invoke the callback.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     * @param {boolean} [intersects] - Assert that the bodies intersect and should not be tested before separation.
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separate: function(body1, body2, processCallback, callbackContext, overlapOnly, intersects) {
                    if (!intersects && !body1.enable || !body2.enable || body1.checkCollision.none || body2.checkCollision.none || !this.intersects(body1, body2)) return false;
                    //  They overlap. Is there a custom process callback? If it returns true then we can carry on, otherwise we should abort.
                    if (processCallback && processCallback.call(callbackContext, body1.gameObject, body2.gameObject) === false) return false;
                    //  Circle vs. Circle quick bail out
                    if (body1.isCircle && body2.isCircle) return this.separateCircle(body1, body2, overlapOnly);
                    // We define the behavior of bodies in a collision circle and rectangle
                    // If a collision occurs in the corner points of the rectangle, the body behave like circles
                    //  Either body1 or body2 is a circle
                    if (body1.isCircle !== body2.isCircle) {
                        var bodyRect = body1.isCircle ? body2 : body1;
                        var bodyCircle = body1.isCircle ? body1 : body2;
                        var rect = {
                            x: bodyRect.x,
                            y: bodyRect.y,
                            right: bodyRect.right,
                            bottom: bodyRect.bottom
                        };
                        var circle = bodyCircle.center;
                        if (circle.y < rect.y || circle.y > rect.bottom) {
                            if (circle.x < rect.x || circle.x > rect.right) return this.separateCircle(body1, body2, overlapOnly);
                        }
                    }
                    var resultX = false;
                    var resultY = false;
                    //  Do we separate on x first or y first or both?
                    if (overlapOnly) {
                        //  No separation but we need to calculate overlapX, overlapY, etc.
                        resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    } else if (this.forceX || Math.abs(this.gravity.y + body1.gravity.y) < Math.abs(this.gravity.x + body1.gravity.x)) {
                        resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        //  Are they still intersecting? Let's do the other axis then
                        if (this.intersects(body1, body2)) resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    } else {
                        resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                        //  Are they still intersecting? Let's do the other axis then
                        if (this.intersects(body1, body2)) resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
                    }
                    var result = resultX || resultY;
                    if (result) {
                        if (overlapOnly) {
                            if (body1.onOverlap || body2.onOverlap) this.emit(Events.OVERLAP, body1.gameObject, body2.gameObject, body1, body2);
                        } else if (body1.onCollide || body2.onCollide) this.emit(Events.COLLIDE, body1.gameObject, body2.gameObject, body1, body2);
                    }
                    return result;
                },
                /**
     * Separates two Bodies, when both are circular.
     *
     * @method Phaser.Physics.Arcade.World#separateCircle
     * @fires Phaser.Physics.Arcade.Events#COLLIDE
     * @fires Phaser.Physics.Arcade.Events#OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to be separated.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to be separated.
     * @param {boolean} [overlapOnly] - If this a collide or overlap check?
     * @param {number} [bias] - A small value added to the calculations.
     *
     * @return {boolean} True if separation occurred, otherwise false.
     */ separateCircle: function(body1, body2, overlapOnly, bias) {
                    //  Set the bounding box overlap values into the bodies themselves (hence we don't use the return values here)
                    GetOverlapX(body1, body2, false, bias);
                    GetOverlapY(body1, body2, false, bias);
                    var overlap = 0;
                    if (body1.isCircle !== body2.isCircle) {
                        var rect = {
                            x: body2.isCircle ? body1.position.x : body2.position.x,
                            y: body2.isCircle ? body1.position.y : body2.position.y,
                            right: body2.isCircle ? body1.right : body2.right,
                            bottom: body2.isCircle ? body1.bottom : body2.bottom
                        };
                        var circle = {
                            x: body1.isCircle ? body1.center.x : body2.center.x,
                            y: body1.isCircle ? body1.center.y : body2.center.y,
                            radius: body1.isCircle ? body1.halfWidth : body2.halfWidth
                        };
                        if (circle.y < rect.y) {
                            if (circle.x < rect.x) overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.y) - circle.radius;
                            else if (circle.x > rect.right) overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.y) - circle.radius;
                        } else if (circle.y > rect.bottom) {
                            if (circle.x < rect.x) overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.bottom) - circle.radius;
                            else if (circle.x > rect.right) overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.bottom) - circle.radius;
                        }
                        overlap *= -1;
                    } else overlap = body1.halfWidth + body2.halfWidth - DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y);
                    body1.overlapR = overlap;
                    body2.overlapR = overlap;
                    //  Can't separate two immovable bodies, or a body with its own custom separation logic
                    if (overlapOnly || overlap === 0 || body1.immovable && body2.immovable || body1.customSeparateX || body2.customSeparateX) {
                        if (overlap !== 0 && (body1.onOverlap || body2.onOverlap)) this.emit(Events.OVERLAP, body1.gameObject, body2.gameObject, body1, body2);
                        //  return true if there was some overlap, otherwise false
                        return overlap !== 0;
                    }
                    var dx = body1.center.x - body2.center.x;
                    var dy = body1.center.y - body2.center.y;
                    var d = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    var nx = (body2.center.x - body1.center.x) / d || 0;
                    var ny = (body2.center.y - body1.center.y) / d || 0;
                    var p = 2 * (body1.velocity.x * nx + body1.velocity.y * ny - body2.velocity.x * nx - body2.velocity.y * ny) / (body1.mass + body2.mass);
                    if (body1.immovable || body2.immovable) p *= 2;
                    if (!body1.immovable) {
                        body1.velocity.x = body1.velocity.x - p / body1.mass * nx;
                        body1.velocity.y = body1.velocity.y - p / body1.mass * ny;
                    }
                    if (!body2.immovable) {
                        body2.velocity.x = body2.velocity.x + p / body2.mass * nx;
                        body2.velocity.y = body2.velocity.y + p / body2.mass * ny;
                    }
                    if (!body1.immovable && !body2.immovable) overlap /= 2;
                    // Note: This is inadequate for circle-rectangle separation
                    var angle = AngleBetweenPoints(body1.center, body2.center);
                    var overlapX = (overlap + MATH_CONST.EPSILON) * Math.cos(angle);
                    var overlapY = (overlap + MATH_CONST.EPSILON) * Math.sin(angle);
                    if (!body1.immovable) {
                        body1.x -= overlapX;
                        body1.y -= overlapY;
                        body1.updateCenter();
                    }
                    if (!body2.immovable) {
                        body2.x += overlapX;
                        body2.y += overlapY;
                        body2.updateCenter();
                    }
                    body1.velocity.x *= body1.bounce.x;
                    body1.velocity.y *= body1.bounce.y;
                    body2.velocity.x *= body2.bounce.x;
                    body2.velocity.y *= body2.bounce.y;
                    if (body1.onCollide || body2.onCollide) this.emit(Events.COLLIDE, body1.gameObject, body2.gameObject, body1, body2);
                    return true;
                },
                /**
     * Checks to see if two Bodies intersect at all.
     *
     * @method Phaser.Physics.Arcade.World#intersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} body1 - The first body to check.
     * @param {Phaser.Physics.Arcade.Body} body2 - The second body to check.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ intersects: function(body1, body2) {
                    if (body1 === body2) return false;
                    if (!body1.isCircle && !body2.isCircle) //  Rect vs. Rect
                    return !(body1.right <= body2.position.x || body1.bottom <= body2.position.y || body1.position.x >= body2.right || body1.position.y >= body2.bottom);
                    else if (body1.isCircle) {
                        if (body2.isCircle) //  Circle vs. Circle
                        return DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y) <= body1.halfWidth + body2.halfWidth;
                        else //  Circle vs. Rect
                        return this.circleBodyIntersects(body1, body2);
                    } else //  Rect vs. Circle
                    return this.circleBodyIntersects(body2, body1);
                },
                /**
     * Tests if a circular Body intersects with another Body.
     *
     * @method Phaser.Physics.Arcade.World#circleBodyIntersects
     * @since 3.0.0
     *
     * @param {Phaser.Physics.Arcade.Body} circle - The circular body to test.
     * @param {Phaser.Physics.Arcade.Body} body - The rectangular body to test.
     *
     * @return {boolean} True if the two bodies intersect, otherwise false.
     */ circleBodyIntersects: function(circle, body) {
                    var x = Clamp(circle.center.x, body.left, body.right);
                    var y = Clamp(circle.center.y, body.top, body.bottom);
                    var dx = (circle.center.x - x) * (circle.center.x - x);
                    var dy = (circle.center.y - y) * (circle.center.y - y);
                    return dx + dy <= circle.halfWidth * circle.halfWidth;
                },
                /**
     * Tests if Game Objects overlap.
     *
     * See details in {@link Phaser.Physics.Arcade.World#collide}.
     *
     * @method Phaser.Physics.Arcade.World#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `overlapCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    return this.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                },
                /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link Phaser.Physics.Arcade.World#overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided; they receive the colliding game objects as arguments.
     * If an overlap is detected, the `processCallback` is called first. It can cancel the collision by returning false.
     * Next the objects are separated and `collideCallback` is invoked.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.World#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} `true` if any overlapping Game Objects were separated, otherwise `false`.
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    return this.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                },
                /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideObjects
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideObjects: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var i;
                    var j;
                    if (object1.isParent && object1.physicsType === undefined) object1 = object1.children.entries;
                    if (object2 && object2.isParent && object2.physicsType === undefined) object2 = object2.children.entries;
                    var object1isArray = Array.isArray(object1);
                    var object2isArray = Array.isArray(object2);
                    this._total = 0;
                    if (!object1isArray && !object2isArray) //  Neither of them are arrays - do this first as it's the most common use-case
                    this.collideHandler(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    else if (!object1isArray && object2isArray) //  Object 2 is an Array
                    for(i = 0; i < object2.length; i++)this.collideHandler(object1, object2[i], collideCallback, processCallback, callbackContext, overlapOnly);
                    else if (object1isArray && !object2isArray) {
                        //  Object 1 is an Array
                        if (!object2) //  Special case for array vs. self
                        for(i = 0; i < object1.length; i++){
                            var child = object1[i];
                            for(j = i + 1; j < object1.length; j++){
                                if (i === j) continue;
                                this.collideHandler(child, object1[j], collideCallback, processCallback, callbackContext, overlapOnly);
                            }
                        }
                        else for(i = 0; i < object1.length; i++)this.collideHandler(object1[i], object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else {
                        //  They're both arrays
                        for(i = 0; i < object1.length; i++)for(j = 0; j < object2.length; j++)this.collideHandler(object1[i], object2[j], collideCallback, processCallback, callbackContext, overlapOnly);
                    }
                    return this._total > 0;
                },
                /**
     * Internal helper function. Please use Phaser.Physics.Arcade.World#collide and Phaser.Physics.Arcade.World#overlap instead.
     *
     * @method Phaser.Physics.Arcade.World#collideHandler
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideHandler: function(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    //  Collide Group with Self
                    //  Only collide valid objects
                    if (object2 === undefined && object1.isParent) return this.collideGroupVsGroup(object1, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                    //  If neither of the objects are set then bail out
                    if (!object1 || !object2) return false;
                    //  A Body
                    if (object1.body) {
                        if (object2.body) return this.collideSpriteVsSprite(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideSpriteVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isTilemap) return this.collideSpriteVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else if (object1.isParent) {
                        if (object2.body) return this.collideSpriteVsGroup(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideGroupVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isTilemap) return this.collideGroupVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
                    } else if (object1.isTilemap) {
                        if (object2.body) return this.collideSpriteVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                        else if (object2.isParent) return this.collideGroupVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
                    }
                },
                /**
     * Internal handler for Sprite vs. Sprite collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsSprite
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite1 - The first object to check for collision.
     * @param {Phaser.GameObjects.GameObject} sprite2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsSprite: function(sprite1, sprite2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    if (!sprite1.body || !sprite2.body) return false;
                    if (this.separate(sprite1.body, sprite2.body, processCallback, callbackContext, overlapOnly)) {
                        if (collideCallback) collideCallback.call(callbackContext, sprite1, sprite2);
                        this._total++;
                    }
                    return true;
                },
                /**
     * Internal handler for Sprite vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
     * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
     * @param {any} callbackContext - The scope in which to call the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} `true` if the Sprite collided with the given Group, otherwise `false`.
     */ collideSpriteVsGroup: function(sprite, group, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var bodyA = sprite.body;
                    if (group.length === 0 || !bodyA || !bodyA.enable || bodyA.checkCollision.none) return;
                    //  Does sprite collide with anything?
                    var i;
                    var len;
                    var bodyB;
                    if (this.useTree || group.physicsType === CONST.STATIC_BODY) {
                        var minMax = this.treeMinMax;
                        minMax.minX = bodyA.left;
                        minMax.minY = bodyA.top;
                        minMax.maxX = bodyA.right;
                        minMax.maxY = bodyA.bottom;
                        var results = group.physicsType === CONST.DYNAMIC_BODY ? this.tree.search(minMax) : this.staticTree.search(minMax);
                        len = results.length;
                        for(i = 0; i < len; i++){
                            bodyB = results[i];
                            if (bodyA === bodyB || !bodyB.enable || bodyB.checkCollision.none || !group.contains(bodyB.gameObject)) continue;
                            if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly, true)) {
                                if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                this._total++;
                            }
                        }
                    } else {
                        var children = group.getChildren();
                        var skipIndex = group.children.entries.indexOf(sprite);
                        len = children.length;
                        for(i = 0; i < len; i++){
                            bodyB = children[i].body;
                            if (!bodyB || i === skipIndex || !bodyB.enable) continue;
                            if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly)) {
                                if (collideCallback) collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
                                this._total++;
                            }
                        }
                    }
                },
                /**
     * Internal handler for Group vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsTilemapLayer
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} collideCallback - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} processCallback - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} callbackContext - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsTilemapLayer: function(group, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var children = group.getChildren();
                    if (children.length === 0) return false;
                    var didCollide = false;
                    for(var i = 0; i < children.length; i++){
                        if (children[i].body) {
                            if (this.collideSpriteVsTilemapLayer(children[i], tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly)) didCollide = true;
                        }
                    }
                    return didCollide;
                },
                /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * @method Phaser.Physics.Arcade.World#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    if (!sprite.body.enable || tiles.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, false, false);
                },
                /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * @method Phaser.Physics.Arcade.World#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    if (!sprite.body.enable || tiles.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, tiles, collideCallback, processCallback, callbackContext, true, false);
                },
                /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilemapLayer
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilemapLayer: function(sprite, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly) {
                    var body = sprite.body;
                    if (!body.enable || body.checkCollision.none) return false;
                    var x = body.position.x;
                    var y = body.position.y;
                    var w = body.width;
                    var h = body.height;
                    var layerData = tilemapLayer.layer;
                    if (layerData.tileWidth > layerData.baseTileWidth) {
                        // The x origin of a tile is the left side, so x and width need to be adjusted.
                        var xDiff = (layerData.tileWidth - layerData.baseTileWidth) * tilemapLayer.scaleX;
                        x -= xDiff;
                        w += xDiff;
                    }
                    if (layerData.tileHeight > layerData.baseTileHeight) {
                        // The y origin of a tile is the bottom side, so just the height needs to be adjusted.
                        var yDiff = (layerData.tileHeight - layerData.baseTileHeight) * tilemapLayer.scaleY;
                        h += yDiff;
                    }
                    var mapData = GetTilesWithinWorldXY(x, y, w, h, null, tilemapLayer.scene.cameras.main, tilemapLayer.layer);
                    if (mapData.length === 0) return false;
                    else return this.collideSpriteVsTilesHandler(sprite, mapData, collideCallback, processCallback, callbackContext, overlapOnly, true);
                },
                /**
     * Internal handler for Sprite vs. Tilemap collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilesHandler
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @private
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} [overlapOnly] - Whether this is a collision or overlap check.
     * @param {boolean} [isLayer] - Is this check coming from a TilemapLayer or an array of tiles?
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideSpriteVsTilesHandler: function(sprite, tiles, collideCallback, processCallback, callbackContext, overlapOnly, isLayer) {
                    var body = sprite.body;
                    var tile;
                    var tileWorldRect = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    };
                    var tilemapLayer;
                    var collision = false;
                    for(var i = 0; i < tiles.length; i++){
                        tile = tiles[i];
                        tilemapLayer = tile.tilemapLayer;
                        var point = tilemapLayer.tileToWorldXY(tile.x, tile.y);
                        tileWorldRect.left = point.x;
                        tileWorldRect.top = point.y;
                        //  If the maps base tile size differs from the layer tile size, only the top of the rect
                        //  needs to be adjusted since its origin is (0, 1).
                        if (tile.baseHeight !== tile.height) tileWorldRect.top -= (tile.height - tile.baseHeight) * tilemapLayer.scaleY;
                        tileWorldRect.right = tileWorldRect.left + tile.width * tilemapLayer.scaleX;
                        tileWorldRect.bottom = tileWorldRect.top + tile.height * tilemapLayer.scaleY;
                        if (TileIntersectsBody(tileWorldRect, body) && (!processCallback || processCallback.call(callbackContext, sprite, tile)) && ProcessTileCallbacks(tile, sprite) && (overlapOnly || SeparateTile(i, body, tile, tileWorldRect, tilemapLayer, this.TILE_BIAS, isLayer))) {
                            this._total++;
                            collision = true;
                            if (collideCallback) collideCallback.call(callbackContext, sprite, tile);
                            if (overlapOnly && body.onOverlap) this.emit(Events.TILE_OVERLAP, sprite, tile, body);
                            else if (body.onCollide) this.emit(Events.TILE_COLLIDE, sprite, tile, body);
                        }
                    }
                    return collision;
                },
                /**
     * Internal helper for Group vs. Group collisions.
     * Please use Phaser.Physics.Arcade.World#collide instead.
     *
     * @method Phaser.Physics.Arcade.World#collideGroupVsGroup
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Group} group1 - The first object to check for collision.
     * @param {Phaser.GameObjects.Group} group2 - The second object to check for collision.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     * @param {boolean} overlapOnly - Whether this is a collision or overlap check.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideGroupVsGroup: function(group1, group2, collideCallback, processCallback, callbackContext, overlapOnly) {
                    if (group1.length === 0 || group2.length === 0) return;
                    var children = group1.getChildren();
                    for(var i = 0; i < children.length; i++)this.collideSpriteVsGroup(children[i], group2, collideCallback, processCallback, callbackContext, overlapOnly);
                },
                /**
     * Wrap an object's coordinates (or several objects' coordinates) within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * If the object is outside any boundary edge (left, top, right, bottom), it will be moved to the same offset from the opposite edge (the interior).
     *
     * @method Phaser.Physics.Arcade.World#wrap
     * @since 3.3.0
     *
     * @param {any} object - A Game Object, a Group, an object with `x` and `y` coordinates, or an array of such objects.
     * @param {number} [padding=0] - An amount added to each boundary edge during the operation.
     */ wrap: function(object, padding) {
                    if (object.body) this.wrapObject(object, padding);
                    else if (object.getChildren) this.wrapArray(object.getChildren(), padding);
                    else if (Array.isArray(object)) this.wrapArray(object, padding);
                    else this.wrapObject(object, padding);
                },
                /**
     * Wrap each object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapArray
     * @since 3.3.0
     *
     * @param {Array.<*>} objects - An array of objects to be wrapped.
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapArray: function(objects, padding) {
                    for(var i = 0; i < objects.length; i++)this.wrapObject(objects[i], padding);
                },
                /**
     * Wrap an object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
     *
     * @method Phaser.Physics.Arcade.World#wrapObject
     * @since 3.3.0
     *
     * @param {*} object - A Game Object, a Physics Body, or any object with `x` and `y` coordinates
     * @param {number} [padding=0] - An amount added to the boundary.
     */ wrapObject: function(object, padding) {
                    if (padding === undefined) padding = 0;
                    object.x = Wrap(object.x, this.bounds.left - padding, this.bounds.right + padding);
                    object.y = Wrap(object.y, this.bounds.top - padding, this.bounds.bottom + padding);
                },
                /**
     * Shuts down the simulation, clearing physics data and removing listeners.
     *
     * @method Phaser.Physics.Arcade.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.tree.clear();
                    this.staticTree.clear();
                    this.bodies.clear();
                    this.staticBodies.clear();
                    this.colliders.destroy();
                    this.removeAllListeners();
                },
                /**
     * Shuts down the simulation and disconnects it from the current scene.
     *
     * @method Phaser.Physics.Arcade.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene = null;
                }
            });
            module1.exports = World;
        /***/ },
        /* 521 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Benjamin D. Richards <benjamindrichards@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(60);
            var Events = __webpack_require__(242);
            var RadToDeg = __webpack_require__(193);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(56);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Dynamic Arcade Body.
 *
 * Its static counterpart is {@link Phaser.Physics.Arcade.StaticBody}.
 *
 * @class Body
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Body belongs to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object this Body belongs to.
 */ var Body = new Class({
                initialize: function Body(world, gameObject) {
                    var width = gameObject.displayWidth ? gameObject.displayWidth : 64;
                    var height = gameObject.displayHeight ? gameObject.displayHeight : 64;
                    /**
         * The Arcade Physics simulation this Body belongs to.
         *
         * @name Phaser.Physics.Arcade.Body#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Game Object this Body belongs to.
         *
         * @name Phaser.Physics.Arcade.Body#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = gameObject;
                    /**
         * Transformations applied to this Body.
         *
         * @name Phaser.Physics.Arcade.Body#transform
         * @type {object}
         * @since 3.4.0
         */ this.transform = {
                        x: gameObject.x,
                        y: gameObject.y,
                        rotation: gameObject.angle,
                        scaleX: gameObject.scaleX,
                        scaleY: gameObject.scaleY,
                        displayOriginX: gameObject.displayOriginX,
                        displayOriginY: gameObject.displayOriginY
                    };
                    /**
         * Whether the Body is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowBody;
                    /**
         * Whether the Body's velocity is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugShowVelocity
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowVelocity = world.defaults.debugShowVelocity;
                    /**
         * The color of this Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.Body#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.bodyDebugColor;
                    /**
         * Whether this Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.Body#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                    /**
         * Whether this Body is circular (true) or rectangular (false).
         *
         * @name Phaser.Physics.Arcade.Body#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.isCircle = false;
                    /**
         * If this Body is circular, this is the unscaled radius of the Body, as set by setCircle(), in source pixels.
         * The true radius is equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.Body#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setCircle
         */ this.radius = 0;
                    /**
         * The offset of this Body's position from its Game Object's position, in source pixels.
         *
         * @name Phaser.Physics.Arcade.Body#offset
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setOffset
         */ this.offset = new Vector2();
                    /**
         * The position of this Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.Body#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - gameObject.scaleX * gameObject.displayOriginX, gameObject.y - gameObject.scaleY * gameObject.displayOriginY);
                    /**
         * The position of this Body during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#prev
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.prev = this.position.clone();
                    /**
         * The position of this Body during the previous frame.
         *
         * @name Phaser.Physics.Arcade.Body#prevFrame
         * @type {Phaser.Math.Vector2}
         * @since 3.20.0
         */ this.prevFrame = this.position.clone();
                    /**
         * Whether this Body's `rotation` is affected by its angular acceleration and angular velocity.
         *
         * @name Phaser.Physics.Arcade.Body#allowRotation
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowRotation = true;
                    /**
         * This body's rotation, in degrees, based on its angular acceleration and angular velocity.
         * The Body's rotation controls the `angle` of its Game Object.
         * It doesn't rotate the Body's own geometry, which is always an axis-aligned rectangle or a circle.
         *
         * @name Phaser.Physics.Arcade.Body#rotation
         * @type {number}
         * @since 3.0.0
         */ this.rotation = gameObject.angle;
                    /**
         * The Body rotation, in degrees, during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#preRotation
         * @type {number}
         * @since 3.0.0
         */ this.preRotation = gameObject.angle;
                    /**
         * The width of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the width use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#width
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Body, in pixels.
         * If the Body is circular, this is also the diameter.
         * If you wish to change the height use the `Body.setSize` method.
         *
         * @name Phaser.Physics.Arcade.Body#height
         * @type {number}
         * @readonly
         * @default 64
         * @since 3.0.0
         */ this.height = height;
                    /**
         * The unscaled width of the Body, in source pixels, as set by setSize().
         * The default is the width of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceWidth
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceWidth = width;
                    /**
         * The unscaled height of the Body, in source pixels, as set by setSize().
         * The default is the height of the Body's Game Object's texture frame.
         *
         * @name Phaser.Physics.Arcade.Body#sourceHeight
         * @type {number}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#setSize
         */ this.sourceHeight = height;
                    if (gameObject.frame) {
                        this.sourceWidth = gameObject.frame.realWidth;
                        this.sourceHeight = gameObject.frame.realHeight;
                    }
                    /**
         * Half the Body's width, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(width / 2);
                    /**
         * Half the Body's height, in pixels.
         *
         * @name Phaser.Physics.Arcade.Body#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(height / 2);
                    /**
         * The center of the Body.
         * The midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.Body#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    /**
         * The Body's velocity, in pixels per second.
         *
         * @name Phaser.Physics.Arcade.Body#velocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.velocity = new Vector2();
                    /**
         * The Body's change in position (due to velocity) at the last step, in pixels.
         *
         * The size of this value depends on the simulation's step rate.
         *
         * @name Phaser.Physics.Arcade.Body#newVelocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.newVelocity = new Vector2();
                    /**
         * The Body's absolute maximum change in position, in pixels per step.
         *
         * @name Phaser.Physics.Arcade.Body#deltaMax
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.deltaMax = new Vector2();
                    /**
         * The Body's change in velocity, in pixels per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#acceleration
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.acceleration = new Vector2();
                    /**
         * Whether this Body's velocity is affected by its `drag`.
         *
         * @name Phaser.Physics.Arcade.Body#allowDrag
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.allowDrag = true;
                    /**
         * When `useDamping` is false (the default), this is absolute loss of velocity due to movement, in pixels per second squared.
         *
         * When `useDamping` is true, this is a damping multiplier between 0 and 1.
         * A value of 0 means the Body stops instantly.
         * A value of 0.01 mean the Body loses 99% of its velocity per second.
         * A value of 0.1 means the Body loses 90% of its velocity per second.
         * A value of 1 means the Body loses no velocity.
         *
         * The x and y components are applied separately.
         *
         * Drag is applied only when `acceleration` is zero.
         *
         * @name Phaser.Physics.Arcade.Body#drag
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.drag = new Vector2();
                    /**
         * Whether this Body's position is affected by gravity (local or world).
         *
         * @name Phaser.Physics.Arcade.Body#allowGravity
         * @type {boolean}
         * @default true
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.Body#gravity
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.allowGravity = true;
                    /**
         * Acceleration due to gravity (specific to this Body), in pixels per second squared.
         * Total gravity is the sum of this vector and the simulation's `gravity`.
         *
         * @name Phaser.Physics.Arcade.Body#gravity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#gravity
         */ this.gravity = new Vector2();
                    /**
         * Rebound following a collision, relative to 1.
         *
         * @name Phaser.Physics.Arcade.Body#bounce
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.bounce = new Vector2();
                    /**
         * Rebound following a collision with the world boundary, relative to 1.
         * If null, `bounce` is used instead.
         *
         * @name Phaser.Physics.Arcade.Body#worldBounce
         * @type {?Phaser.Math.Vector2}
         * @default null
         * @since 3.0.0
         */ this.worldBounce = null;
                    /**
         * The rectangle used for world boundary collisions.
         *
         * By default it is set to the world boundary rectangle. Or, if this Body was
         * created by a Physics Group, then whatever rectangle that Group defined.
         *
         * You can also change it by using the `Body.setBoundsRectangle` method.
         *
         * @name Phaser.Physics.Arcade.Body#customBoundsRectangle
         * @type {Phaser.Geom.Rectangle}
         * @since 3.20
         */ this.customBoundsRectangle = world.bounds;
                    //  If true this Body will dispatch events
                    /**
         * Whether the simulation emits a `worldbounds` event when this Body collides with the world boundary (and `collideWorldBounds` is also true).
         *
         * @name Phaser.Physics.Arcade.Body#onWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#WORLD_BOUNDS
         */ this.onWorldBounds = false;
                    /**
         * Whether the simulation emits a `collide` event when this Body collides with another.
         *
         * @name Phaser.Physics.Arcade.Body#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#COLLIDE
         */ this.onCollide = false;
                    /**
         * Whether the simulation emits an `overlap` event when this Body overlaps with another.
         *
         * @name Phaser.Physics.Arcade.Body#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.Physics.Arcade.World#OVERLAP
         */ this.onOverlap = false;
                    /**
         * The Body's absolute maximum velocity, in pixels per second.
         * The horizontal and vertical components are applied separately.
         *
         * @name Phaser.Physics.Arcade.Body#maxVelocity
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.maxVelocity = new Vector2(10000, 10000);
                    /**
         * The maximum speed this Body is allowed to reach, in pixels per second.
         *
         * If not negative it limits the scalar value of speed.
         *
         * Any negative value means no maximum is being applied (the default).
         *
         * @name Phaser.Physics.Arcade.Body#maxSpeed
         * @type {number}
         * @default -1
         * @since 3.16.0
         */ this.maxSpeed = -1;
                    /**
         * If this Body is `immovable` and in motion, `friction` is the proportion of this Body's motion received by the riding Body on each axis, relative to 1.
         * The horizontal component (x) is applied only when two colliding Bodies are separated vertically.
         * The vertical component (y) is applied only when two colliding Bodies are separated horizontally.
         * The default value (1, 0) moves the riding Body horizontally in equal proportion to this Body and vertically not at all.
         *
         * @name Phaser.Physics.Arcade.Body#friction
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.friction = new Vector2(1, 0);
                    /**
         * If this Body is using `drag` for deceleration this property controls how the drag is applied.
         * If set to `true` drag will use a damping effect rather than a linear approach. If you are
         * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
         * the game Asteroids) then you will get a far smoother and more visually correct deceleration
         * by using damping, avoiding the axis-drift that is prone with linear deceleration.
         *
         * If you enable this property then you should use far smaller `drag` values than with linear, as
         * they are used as a multiplier on the velocity. Values such as 0.05 will give a nice slow
         * deceleration.
         *
         * @name Phaser.Physics.Arcade.Body#useDamping
         * @type {boolean}
         * @default false
         * @since 3.10.0
         */ this.useDamping = false;
                    /**
         * The rate of change of this Body's `rotation`, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#angularVelocity
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularVelocity = 0;
                    /**
         * The Body's angular acceleration (change in angular velocity), in degrees per second squared.
         *
         * @name Phaser.Physics.Arcade.Body#angularAcceleration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularAcceleration = 0;
                    /**
         * Loss of angular velocity due to angular movement, in degrees per second.
         *
         * Angular drag is applied only when angular acceleration is zero.
         *
         * @name Phaser.Physics.Arcade.Body#angularDrag
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angularDrag = 0;
                    /**
         * The Body's maximum angular velocity, in degrees per second.
         *
         * @name Phaser.Physics.Arcade.Body#maxAngular
         * @type {number}
         * @default 1000
         * @since 3.0.0
         */ this.maxAngular = 1000;
                    /**
         * The Body's inertia, relative to a default unit (1).
         * With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.Body#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                    /**
         * The calculated angle of this Body's velocity vector, in radians, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#angle
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.angle = 0;
                    /**
         * The calculated magnitude of the Body's velocity, in pixels per second, during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#speed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speed = 0;
                    /**
         * The direction of the Body's velocity, as calculated during the last step.
         * This is a numeric constant value (FACING_UP, FACING_DOWN, FACING_LEFT, FACING_RIGHT).
         * If the Body is moving on both axes, this describes motion on the vertical axis only.
         *
         * @name Phaser.Physics.Arcade.Body#facing
         * @type {number}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.FACING_UP
         * @see Phaser.Physics.Arcade.FACING_DOWN
         * @see Phaser.Physics.Arcade.FACING_LEFT
         * @see Phaser.Physics.Arcade.FACING_RIGHT
         */ this.facing = CONST.FACING_NONE;
                    /**
         * Whether this Body can be moved by collisions with another Body.
         *
         * @name Phaser.Physics.Arcade.Body#immovable
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.immovable = false;
                    /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Dynamic Bodies are always pushable.
         *
         * @name Phaser.Physics.Arcade.Body#pushable
         * @type {boolean}
         * @default true
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = true;
                    /**
         * Whether the Body's position and rotation are affected by its velocity, acceleration, drag, and gravity.
         *
         * @name Phaser.Physics.Arcade.Body#moves
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.moves = true;
                    /**
         * A flag disabling the default horizontal separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                    /**
         * A flag disabling the default vertical separation of colliding bodies.
         * Pass your own `collideCallback` to the collider.
         *
         * @name Phaser.Physics.Arcade.Body#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                    /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                    /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.Body#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                    /**
         * The amount of overlap (before separation), if this Body is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.Body#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                    /**
         * Whether this Body is overlapped with another and both are not moving, on at least one axis.
         *
         * @name Phaser.Physics.Arcade.Body#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                    /**
         * Whether this Body interacts with the world boundary.
         *
         * @name Phaser.Physics.Arcade.Body#collideWorldBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                    /**
         * Whether this Body is checked for collisions and for which directions.
         * You can set `checkCollision.none = true` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.Body#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = {
                        none: false,
                        up: true,
                        down: true,
                        left: true,
                        right: true
                    };
                    /**
         * Whether this Body is colliding with a Body or Static Body and in which direction.
         * In a collision where both bodies have zero velocity, `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#blocked
         * @see Phaser.Physics.Arcade.Body#embedded
         */ this.touching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This Body's `touching` value during the previous step.
         *
         * @name Phaser.Physics.Arcade.Body#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.wasTouching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * Whether this Body is colliding with a Static Body, a tile, or the world boundary.
         * In a collision with a Static Body, if this Body has zero velocity then `embedded` will be set instead.
         *
         * @name Phaser.Physics.Arcade.Body#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         *
         * @see Phaser.Physics.Arcade.Body#embedded
         * @see Phaser.Physics.Arcade.Body#touching
         */ this.blocked = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * Whether to automatically synchronize this Body's dimensions to the dimensions of its Game Object's visual bounds.
         *
         * @name Phaser.Physics.Arcade.Body#syncBounds
         * @type {boolean}
         * @default false
         * @since 3.0.0
         * @see Phaser.GameObjects.Components.GetBounds#getBounds
         */ this.syncBounds = false;
                    /**
         * The Body's physics type (dynamic or static).
         *
         * @name Phaser.Physics.Arcade.Body#physicsType
         * @type {number}
         * @readonly
         * @default Phaser.Physics.Arcade.DYNAMIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.DYNAMIC_BODY;
                    /**
         * Cached horizontal scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sx
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sx = gameObject.scaleX;
                    /**
         * Cached vertical scale of the Body's Game Object.
         *
         * @name Phaser.Physics.Arcade.Body#_sy
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._sy = gameObject.scaleY;
                    /**
         * The calculated change in the Body's horizontal position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dx = 0;
                    /**
         * The calculated change in the Body's vertical position during the last step.
         *
         * @name Phaser.Physics.Arcade.Body#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._dy = 0;
                    /**
         * The final calculated change in the Body's horizontal position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_tx
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._tx = 0;
                    /**
         * The final calculated change in the Body's vertical position as of `postUpdate`.
         *
         * @name Phaser.Physics.Arcade.Body#_ty
         * @type {number}
         * @private
         * @default 0
         * @since 3.22.0
         */ this._ty = 0;
                    /**
         * Stores the Game Object's bounds.
         *
         * @name Phaser.Physics.Arcade.Body#_bounds
         * @type {Phaser.Geom.Rectangle}
         * @private
         * @since 3.0.0
         */ this._bounds = new Rectangle();
                },
                /**
     * Updates the Body's `transform`, `width`, `height`, and `center` from its Game Object.
     * The Body's `position` isn't changed.
     *
     * @method Phaser.Physics.Arcade.Body#updateBounds
     * @since 3.0.0
     */ updateBounds: function() {
                    var sprite = this.gameObject;
                    //  Container?
                    var transform = this.transform;
                    if (sprite.parentContainer) {
                        var matrix = sprite.getWorldTransformMatrix(this.world._tempMatrix, this.world._tempMatrix2);
                        transform.x = matrix.tx;
                        transform.y = matrix.ty;
                        transform.rotation = RadToDeg(matrix.rotation);
                        transform.scaleX = matrix.scaleX;
                        transform.scaleY = matrix.scaleY;
                        transform.displayOriginX = sprite.displayOriginX;
                        transform.displayOriginY = sprite.displayOriginY;
                    } else {
                        transform.x = sprite.x;
                        transform.y = sprite.y;
                        transform.rotation = sprite.angle;
                        transform.scaleX = sprite.scaleX;
                        transform.scaleY = sprite.scaleY;
                        transform.displayOriginX = sprite.displayOriginX;
                        transform.displayOriginY = sprite.displayOriginY;
                    }
                    var recalc = false;
                    if (this.syncBounds) {
                        var b = sprite.getBounds(this._bounds);
                        this.width = b.width;
                        this.height = b.height;
                        recalc = true;
                    } else {
                        var asx = Math.abs(transform.scaleX);
                        var asy = Math.abs(transform.scaleY);
                        if (this._sx !== asx || this._sy !== asy) {
                            this.width = this.sourceWidth * asx;
                            this.height = this.sourceHeight * asy;
                            this._sx = asx;
                            this._sy = asy;
                            recalc = true;
                        }
                    }
                    if (recalc) {
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.updateCenter();
                    }
                },
                /**
     * Updates the Body's `center` from its `position`, `width`, and `height`.
     *
     * @method Phaser.Physics.Arcade.Body#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                /**
     * Updates the Body's `position`, `width`, `height`, and `center` from its Game Object and `offset`.
     *
     * You don't need to call this for Dynamic Bodies, as it happens automatically during the physics step.
     * But you could use it if you have modified the Body offset or Game Object transform and need to immediately
     * read the Body's new `position` or `center`.
     *
     * To resynchronize the Body with its Game Object, use `reset()` instead.
     *
     * @method Phaser.Physics.Arcade.Body#updateFromGameObject
     * @since 3.24.0
     */ updateFromGameObject: function() {
                    this.updateBounds();
                    var transform = this.transform;
                    this.position.x = transform.x + transform.scaleX * (this.offset.x - transform.displayOriginX);
                    this.position.y = transform.y + transform.scaleY * (this.offset.y - transform.displayOriginY);
                    this.updateCenter();
                },
                /**
     * Prepares the Body for a physics step by resetting the `wasTouching`, `touching` and `blocked` states.
     *
     * This method is only called if the physics world is going to run a step this frame.
     *
     * @method Phaser.Physics.Arcade.Body#resetFlags
     * @since 3.18.0
     *
     * @param {boolean} [clear=false] - Set the `wasTouching` values to their defaults.
     */ resetFlags: function(clear) {
                    if (clear === undefined) clear = false;
                    //  Store and reset collision flags
                    var wasTouching = this.wasTouching;
                    var touching = this.touching;
                    var blocked = this.blocked;
                    if (clear) {
                        wasTouching.none = true;
                        wasTouching.up = false;
                        wasTouching.down = false;
                        wasTouching.left = false;
                        wasTouching.right = false;
                    } else {
                        wasTouching.none = touching.none;
                        wasTouching.up = touching.up;
                        wasTouching.down = touching.down;
                        wasTouching.left = touching.left;
                        wasTouching.right = touching.right;
                    }
                    touching.none = true;
                    touching.up = false;
                    touching.down = false;
                    touching.left = false;
                    touching.right = false;
                    blocked.none = true;
                    blocked.up = false;
                    blocked.down = false;
                    blocked.left = false;
                    blocked.right = false;
                    this.overlapR = 0;
                    this.overlapX = 0;
                    this.overlapY = 0;
                    this.embedded = false;
                },
                /**
     * Syncs the position body position with the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#preUpdate
     * @since 3.17.0
     *
     * @param {boolean} willStep - Will this Body run an update as well?
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ preUpdate: function(willStep, delta) {
                    if (willStep) this.resetFlags();
                    this.updateFromGameObject();
                    this.rotation = this.transform.rotation;
                    this.preRotation = this.rotation;
                    if (this.moves) {
                        this.prev.x = this.position.x;
                        this.prev.y = this.position.y;
                        this.prevFrame.x = this.position.x;
                        this.prevFrame.y = this.position.y;
                    }
                    if (willStep) this.update(delta);
                },
                /**
     * Performs a single physics step and updates the body velocity, angle, speed and other properties.
     *
     * This method can be called multiple times per game frame, depending on the physics step rate.
     *
     * The results are synced back to the Game Object in `postUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#update
     * @fires Phaser.Physics.Arcade.Events#WORLD_BOUNDS
     * @since 3.0.0
     *
     * @param {number} delta - The delta time, in seconds, elapsed since the last frame.
     */ update: function(delta) {
                    this.prev.x = this.position.x;
                    this.prev.y = this.position.y;
                    if (this.moves) {
                        this.world.updateMotion(this, delta);
                        var vx = this.velocity.x;
                        var vy = this.velocity.y;
                        this.newVelocity.set(vx * delta, vy * delta);
                        this.position.add(this.newVelocity);
                        this.updateCenter();
                        this.angle = Math.atan2(vy, vx);
                        this.speed = Math.sqrt(vx * vx + vy * vy);
                        //  Now the update will throw collision checks at the Body
                        //  And finally we'll integrate the new position back to the Sprite in postUpdate
                        if (this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds) this.world.emit(Events.WORLD_BOUNDS, this, this.blocked.up, this.blocked.down, this.blocked.left, this.blocked.right);
                    }
                    this._dx = this.position.x - this.prev.x;
                    this._dy = this.position.y - this.prev.y;
                },
                /**
     * Feeds the Body results back into the parent Game Object.
     *
     * This method is called every game frame, regardless if the world steps or not.
     *
     * @method Phaser.Physics.Arcade.Body#postUpdate
     * @since 3.0.0
     */ postUpdate: function() {
                    var dx = this.position.x - this.prevFrame.x;
                    var dy = this.position.y - this.prevFrame.y;
                    if (this.moves) {
                        var mx = this.deltaMax.x;
                        var my = this.deltaMax.y;
                        if (mx !== 0 && dx !== 0) {
                            if (dx < 0 && dx < -mx) dx = -mx;
                            else if (dx > 0 && dx > mx) dx = mx;
                        }
                        if (my !== 0 && dy !== 0) {
                            if (dy < 0 && dy < -my) dy = -my;
                            else if (dy > 0 && dy > my) dy = my;
                        }
                        this.gameObject.x += dx;
                        this.gameObject.y += dy;
                    }
                    if (dx < 0) this.facing = CONST.FACING_LEFT;
                    else if (dx > 0) this.facing = CONST.FACING_RIGHT;
                    if (dy < 0) this.facing = CONST.FACING_UP;
                    else if (dy > 0) this.facing = CONST.FACING_DOWN;
                    if (this.allowRotation) this.gameObject.angle += this.deltaZ();
                    this._tx = dx;
                    this._ty = dy;
                },
                /**
     * Sets a custom collision boundary rectangle. Use if you want to have a custom
     * boundary instead of the world boundaries.
     *
     * @method Phaser.Physics.Arcade.Body#setBoundsRectangle
     * @since 3.20
     *
     * @param {?Phaser.Geom.Rectangle} [bounds] - The new boundary rectangle. Pass `null` to use the World bounds.
     *
     * @return {this} This Body object.
     */ setBoundsRectangle: function(bounds) {
                    this.customBoundsRectangle = !bounds ? this.world.bounds : bounds;
                    return this;
                },
                /**
     * Checks for collisions between this Body and the world boundary and separates them.
     *
     * @method Phaser.Physics.Arcade.Body#checkWorldBounds
     * @since 3.0.0
     *
     * @return {boolean} True if this Body is colliding with the world boundary.
     */ checkWorldBounds: function() {
                    var pos = this.position;
                    var bounds = this.customBoundsRectangle;
                    var check = this.world.checkCollision;
                    var bx = this.worldBounce ? -this.worldBounce.x : -this.bounce.x;
                    var by = this.worldBounce ? -this.worldBounce.y : -this.bounce.y;
                    var wasSet = false;
                    if (pos.x < bounds.x && check.left) {
                        pos.x = bounds.x;
                        this.velocity.x *= bx;
                        this.blocked.left = true;
                        wasSet = true;
                    } else if (this.right > bounds.right && check.right) {
                        pos.x = bounds.right - this.width;
                        this.velocity.x *= bx;
                        this.blocked.right = true;
                        wasSet = true;
                    }
                    if (pos.y < bounds.y && check.up) {
                        pos.y = bounds.y;
                        this.velocity.y *= by;
                        this.blocked.up = true;
                        wasSet = true;
                    } else if (this.bottom > bounds.bottom && check.down) {
                        pos.y = bounds.bottom - this.height;
                        this.velocity.y *= by;
                        this.blocked.down = true;
                        wasSet = true;
                    }
                    if (wasSet) {
                        this.blocked.none = false;
                        this.updateCenter();
                    }
                    return wasSet;
                },
                /**
     * Sets the offset of the Body's position from its Game Object's position.
     * The Body's `position` isn't changed until the next `preUpdate`.
     *
     * @method Phaser.Physics.Arcade.Body#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal offset, in source pixels.
     * @param {number} [y=x] - The vertical offset, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setOffset: function(x, y) {
                    if (y === undefined) y = x;
                    this.offset.set(x, y);
                    return this;
                },
                /**
     * Sizes and positions this Body, as a rectangle.
     * Modifies the Body `offset` if `center` is true (the default).
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.Body#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Modify the Body's `offset`, placing the Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setSize: function(width, height, center) {
                    if (center === undefined) center = true;
                    var gameObject = this.gameObject;
                    if (!width && gameObject.frame) width = gameObject.frame.realWidth;
                    if (!height && gameObject.frame) height = gameObject.frame.realHeight;
                    this.sourceWidth = width;
                    this.sourceHeight = height;
                    this.width = this.sourceWidth * this._sx;
                    this.height = this.sourceHeight * this._sy;
                    this.halfWidth = Math.floor(this.width / 2);
                    this.halfHeight = Math.floor(this.height / 2);
                    this.updateCenter();
                    if (center && gameObject.getCenter) {
                        var ox = (gameObject.width - width) / 2;
                        var oy = (gameObject.height - height) / 2;
                        this.offset.set(ox, oy);
                    }
                    this.isCircle = false;
                    this.radius = 0;
                    return this;
                },
                /**
     * Sizes and positions this Body, as a circle.
     *
     * @method Phaser.Physics.Arcade.Body#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the Body, in source pixels.
     * @param {number} [offsetX] - The horizontal offset of the Body from its Game Object, in source pixels.
     * @param {number} [offsetY] - The vertical offset of the Body from its Game Object, in source pixels.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = this.offset.x;
                    if (offsetY === undefined) offsetY = this.offset.y;
                    if (radius > 0) {
                        this.isCircle = true;
                        this.radius = radius;
                        this.sourceWidth = radius * 2;
                        this.sourceHeight = radius * 2;
                        this.width = this.sourceWidth * this._sx;
                        this.height = this.sourceHeight * this._sy;
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.offset.set(offsetX, offsetY);
                        this.updateCenter();
                    } else this.isCircle = false;
                    return this;
                },
                /**
     * Sets this Body's parent Game Object to the given coordinates and resets this Body at the new coordinates.
     * If the Body had any velocity or acceleration it is lost as a result of calling this.
     *
     * @method Phaser.Physics.Arcade.Body#reset
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position to place the Game Object.
     * @param {number} y - The vertical position to place the Game Object.
     */ reset: function(x, y) {
                    this.stop();
                    var gameObject = this.gameObject;
                    gameObject.setPosition(x, y);
                    if (gameObject.getTopLeft) gameObject.getTopLeft(this.position);
                    else this.position.set(x, y);
                    this.prev.copy(this.position);
                    this.prevFrame.copy(this.position);
                    this.rotation = gameObject.angle;
                    this.preRotation = gameObject.angle;
                    this.updateBounds();
                    this.updateCenter();
                    this.resetFlags(true);
                },
                /**
     * Sets acceleration, velocity, and speed to zero.
     *
     * @method Phaser.Physics.Arcade.Body#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ stop: function() {
                    this.velocity.set(0);
                    this.acceleration.set(0);
                    this.speed = 0;
                    this.angularVelocity = 0;
                    this.angularAcceleration = 0;
                    return this;
                },
                /**
     * Copies the coordinates of this Body's edges into an object.
     *
     * @method Phaser.Physics.Arcade.Body#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - An object to copy the values into.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} - An object with {x, y, right, bottom}.
     */ getBounds: function(obj) {
                    obj.x = this.x;
                    obj.y = this.y;
                    obj.right = this.right;
                    obj.bottom = this.bottom;
                    return obj;
                },
                /**
     * Tests if the coordinates are within this Body.
     *
     * @method Phaser.Physics.Arcade.Body#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The horizontal coordinate.
     * @param {number} y - The vertical coordinate.
     *
     * @return {boolean} True if (x, y) is within this Body.
     */ hitTest: function(x, y) {
                    if (!this.isCircle) return RectangleContains(this, x, y);
                    //  Check if x/y are within the bounds first
                    if (this.radius > 0 && x >= this.left && x <= this.right && y >= this.top && y <= this.bottom) {
                        var dx = (this.center.x - x) * (this.center.x - x);
                        var dy = (this.center.y - y) * (this.center.y - y);
                        return dx + dy <= this.radius * this.radius;
                    }
                    return false;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving down.
     *
     * @method Phaser.Physics.Arcade.Body#onFloor
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onFloor: function() {
                    return this.blocked.down;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving up.
     *
     * @method Phaser.Physics.Arcade.Body#onCeiling
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onCeiling: function() {
                    return this.blocked.up;
                },
                /**
     * Whether this Body is touching a tile or the world boundary while moving left or right.
     *
     * @method Phaser.Physics.Arcade.Body#onWall
     * @since 3.0.0
     * @see Phaser.Physics.Arcade.Body#blocked
     *
     * @return {boolean} True if touching.
     */ onWall: function() {
                    return this.blocked.left || this.blocked.right;
                },
                /**
     * The absolute (non-negative) change in this Body's horizontal position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsX: function() {
                    return this._dx > 0 ? this._dx : -this._dx;
                },
                /**
     * The absolute (non-negative) change in this Body's vertical position from the previous step.
     *
     * @method Phaser.Physics.Arcade.Body#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaAbsY: function() {
                    return this._dy > 0 ? this._dy : -this._dy;
                },
                /**
     * The change in this Body's horizontal position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaXFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaX
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaX: function() {
                    return this._dx;
                },
                /**
     * The change in this Body's vertical position from the previous step.
     * This value is set during the Body's update phase.
     *
     * As a Body can update multiple times per step this may not hold the final
     * delta value for the Body. In this case, please see the `deltaYFinal` method.
     *
     * @method Phaser.Physics.Arcade.Body#deltaY
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaY: function() {
                    return this._dy;
                },
                /**
     * The change in this Body's horizontal position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaXFinal
     * @since 3.22.0
     *
     * @return {number} The final delta x value.
     */ deltaXFinal: function() {
                    return this._tx;
                },
                /**
     * The change in this Body's vertical position from the previous game update.
     *
     * This value is set during the `postUpdate` phase and takes into account the
     * `deltaMax` and final position of the Body.
     *
     * Because this value is not calculated until `postUpdate`, you must listen for it
     * during a Scene `POST_UPDATE` or `RENDER` event, and not in `update`, as it will
     * not be calculated by that point. If you _do_ use these values in `update` they
     * will represent the delta from the _previous_ game frame.
     *
     * @method Phaser.Physics.Arcade.Body#deltaYFinal
     * @since 3.22.0
     *
     * @return {number} The final delta y value.
     */ deltaYFinal: function() {
                    return this._ty;
                },
                /**
     * The change in this Body's rotation from the previous step, in degrees.
     *
     * @method Phaser.Physics.Arcade.Body#deltaZ
     * @since 3.0.0
     *
     * @return {number} The delta value.
     */ deltaZ: function() {
                    return this.rotation - this.preRotation;
                },
                /**
     * Disables this Body and marks it for deletion by the simulation.
     *
     * @method Phaser.Physics.Arcade.Body#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enable = false;
                    if (this.world) this.world.pendingDestroy.set(this);
                },
                /**
     * Draws this Body and its velocity, if enabled.
     *
     * @method Phaser.Physics.Arcade.Body#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to draw on.
     */ drawDebug: function(graphic) {
                    var pos = this.position;
                    var x = pos.x + this.halfWidth;
                    var y = pos.y + this.halfHeight;
                    if (this.debugShowBody) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor);
                        if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                        else {
                            //  Only draw the sides where checkCollision is true, similar to debugger in layer
                            if (this.checkCollision.up) graphic.lineBetween(pos.x, pos.y, pos.x + this.width, pos.y);
                            if (this.checkCollision.right) graphic.lineBetween(pos.x + this.width, pos.y, pos.x + this.width, pos.y + this.height);
                            if (this.checkCollision.down) graphic.lineBetween(pos.x, pos.y + this.height, pos.x + this.width, pos.y + this.height);
                            if (this.checkCollision.left) graphic.lineBetween(pos.x, pos.y, pos.x, pos.y + this.height);
                        }
                    }
                    if (this.debugShowVelocity) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.world.defaults.velocityDebugColor, 1);
                        graphic.lineBetween(x, y, x + this.velocity.x / 2, y + this.velocity.y / 2);
                    }
                },
                /**
     * Whether this Body will be drawn to the debug display.
     *
     * @method Phaser.Physics.Arcade.Body#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} True if either `debugShowBody` or `debugShowVelocity` are enabled.
     */ willDrawDebug: function() {
                    return this.debugShowBody || this.debugShowVelocity;
                },
                /**
     * Sets whether this Body collides with the world boundary.
     *
     * Optionally also sets the World Bounce and `onWorldBounds` values.
     *
     * @method Phaser.Physics.Arcade.Body#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if the Body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this replaces the Body's `worldBounce.x` value.
     * @param {number} [bounceY] - If given this replaces the Body's `worldBounce.y` value.
     * @param {boolean} [onWorldBounds] - If given this replaces the Body's `onWorldBounds` value.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY, onWorldBounds) {
                    if (value === undefined) value = true;
                    this.collideWorldBounds = value;
                    var setBounceX = bounceX !== undefined;
                    var setBounceY = bounceY !== undefined;
                    if (setBounceX || setBounceY) {
                        if (!this.worldBounce) this.worldBounce = new Vector2();
                        if (setBounceX) this.worldBounce.x = bounceX;
                        if (setBounceY) this.worldBounce.y = bounceY;
                    }
                    if (onWorldBounds !== undefined) this.onWorldBounds = onWorldBounds;
                    return this;
                },
                /**
     * Sets the Body's velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocity: function(x, y) {
                    this.velocity.set(x, y);
                    x = this.velocity.x;
                    y = this.velocity.y;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityX
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityX: function(value) {
                    this.velocity.x = value;
                    var x = value;
                    var y = this.velocity.y;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setVelocityY
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setVelocityY: function(value) {
                    this.velocity.y = value;
                    var x = this.velocity.x;
                    var y = value;
                    this.speed = Math.sqrt(x * x + y * y);
                    return this;
                },
                /**
     * Sets the Body's maximum velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocity
     * @since 3.10.0
     *
     * @param {number} x - The horizontal velocity, in pixels per second.
     * @param {number} [y=x] - The vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocity: function(x, y) {
                    this.maxVelocity.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's maximum horizontal velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityX
     * @since 3.50.0
     *
     * @param {number} value - The maximum horizontal velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityX: function(value) {
                    this.maxVelocity.x = value;
                    return this;
                },
                /**
     * Sets the Body's maximum vertical velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxVelocityY
     * @since 3.50.0
     *
     * @param {number} value - The maximum vertical velocity, in pixels per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxVelocityY: function(value) {
                    this.maxVelocity.y = value;
                    return this;
                },
                /**
     * Sets the maximum speed the Body can move.
     *
     * @method Phaser.Physics.Arcade.Body#setMaxSpeed
     * @since 3.16.0
     *
     * @param {number} value - The maximum speed value, in pixels per second. Set to a negative value to disable.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMaxSpeed: function(value) {
                    this.maxSpeed = value;
                    return this;
                },
                /**
     * Sets the Body's bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The horizontal bounce, relative to 1.
     * @param {number} y - The vertical bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounce: function(x, y) {
                    this.bounce.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceX: function(value) {
                    this.bounce.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical bounce.
     *
     * @method Phaser.Physics.Arcade.Body#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The bounce, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setBounceY: function(value) {
                    this.bounce.y = value;
                    return this;
                },
                /**
     * Sets the Body's acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAcceleration: function(x, y) {
                    this.acceleration.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationX: function(value) {
                    this.acceleration.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAccelerationY: function(value) {
                    this.acceleration.y = value;
                    return this;
                },
                /**
     * Enables or disables drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowDrag
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowDrag
     *
     * @param {boolean} [value=true] - `true` to allow drag on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowDrag: function(value) {
                    if (value === undefined) value = true;
                    this.allowDrag = value;
                    return this;
                },
                /**
     * Enables or disables gravity's effect on this Body.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowGravity
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowGravity
     *
     * @param {boolean} [value=true] - `true` to allow gravity on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowGravity: function(value) {
                    if (value === undefined) value = true;
                    this.allowGravity = value;
                    return this;
                },
                /**
     * Enables or disables rotation.
     *
     * @method Phaser.Physics.Arcade.Body#setAllowRotation
     * @since 3.9.0
     * @see Phaser.Physics.Arcade.Body#allowRotation
     *
     * @param {boolean} [value=true] - `true` to allow rotation on this body, or `false` to disable it.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAllowRotation: function(value) {
                    if (value === undefined) value = true;
                    this.allowRotation = value;
                    return this;
                },
                /**
     * Sets the Body's drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDrag: function(x, y) {
                    this.drag.set(x, y);
                    return this;
                },
                /**
     * If this Body is using `drag` for deceleration this property controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Body#setDamping
     * @since 3.50.0
     *
     * @param {boolean} value - `true` to use damping, or `false` to use drag.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDamping: function(value) {
                    this.useDamping = value;
                    return this;
                },
                /**
     * Sets the Body's horizontal drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragX: function(value) {
                    this.drag.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical drag.
     *
     * @method Phaser.Physics.Arcade.Body#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The drag, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setDragY: function(value) {
                    this.drag.y = value;
                    return this;
                },
                /**
     * Sets the Body's gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, in pixels per second squared.
     * @param {number} y - The vertical component, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravity: function(x, y) {
                    this.gravity.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityX
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityX: function(value) {
                    this.gravity.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical gravity.
     *
     * @method Phaser.Physics.Arcade.Body#setGravityY
     * @since 3.0.0
     *
     * @param {number} value - The gravity, in pixels per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setGravityY: function(value) {
                    this.gravity.y = value;
                    return this;
                },
                /**
     * Sets the Body's friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The horizontal component, relative to 1.
     * @param {number} y - The vertical component, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFriction: function(x, y) {
                    this.friction.set(x, y);
                    return this;
                },
                /**
     * Sets the Body's horizontal friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionX
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionX: function(value) {
                    this.friction.x = value;
                    return this;
                },
                /**
     * Sets the Body's vertical friction.
     *
     * @method Phaser.Physics.Arcade.Body#setFrictionY
     * @since 3.0.0
     *
     * @param {number} value - The friction value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setFrictionY: function(value) {
                    this.friction.y = value;
                    return this;
                },
                /**
     * Sets the Body's angular velocity.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The velocity, in degrees per second.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularVelocity: function(value) {
                    this.angularVelocity = value;
                    return this;
                },
                /**
     * Sets the Body's angular acceleration.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The acceleration, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularAcceleration: function(value) {
                    this.angularAcceleration = value;
                    return this;
                },
                /**
     * Sets the Body's angular drag.
     *
     * @method Phaser.Physics.Arcade.Body#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The drag, in degrees per second squared.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setAngularDrag: function(value) {
                    this.angularDrag = value;
                    return this;
                },
                /**
     * Sets the Body's mass.
     *
     * @method Phaser.Physics.Arcade.Body#setMass
     * @since 3.0.0
     *
     * @param {number} value - The mass value, relative to 1.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setMass: function(value) {
                    this.mass = value;
                    return this;
                },
                /**
     * Sets the Body's `immovable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - The value to assign to `immovable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setImmovable: function(value) {
                    if (value === undefined) value = true;
                    this.immovable = value;
                    return this;
                },
                /**
     * Sets the Body's `enable` property.
     *
     * @method Phaser.Physics.Arcade.Body#setEnable
     * @since 3.15.0
     *
     * @param {boolean} [value=true] - The value to assign to `enable`.
     *
     * @return {Phaser.Physics.Arcade.Body} This Body object.
     */ setEnable: function(value) {
                    if (value === undefined) value = true;
                    this.enable = value;
                    return this;
                },
                /**
     * This is an internal handler, called by the `ProcessX` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processX
     * @since 3.50.0
     *
     * @param {number} x - The amount to add to the Body position.
     * @param {number} [vx] - The amount to add to the Body velocity.
     * @param {boolean} [left] - Set the blocked.left value?
     * @param {boolean} [right] - Set the blocked.right value?
     */ processX: function(x, vx, left, right) {
                    this.x += x;
                    this.updateCenter();
                    if (vx !== null) this.velocity.x = vx;
                    var blocked = this.blocked;
                    if (left) blocked.left = true;
                    if (right) blocked.right = true;
                },
                /**
     * This is an internal handler, called by the `ProcessY` function as part
     * of the collision step. You should almost never call this directly.
     *
     * @method Phaser.Physics.Arcade.Body#processY
     * @since 3.50.0
     *
     * @param {number} y - The amount to add to the Body position.
     * @param {number} [vy] - The amount to add to the Body velocity.
     * @param {boolean} [up] - Set the blocked.up value?
     * @param {boolean} [down] - Set the blocked.down value?
     */ processY: function(y, vy, up, down) {
                    this.y += y;
                    this.updateCenter();
                    if (vy !== null) this.velocity.y = vy;
                    var blocked = this.blocked;
                    if (up) blocked.up = true;
                    if (down) blocked.down = true;
                },
                /**
     * The Bodys horizontal position (left edge).
     *
     * @name Phaser.Physics.Arcade.Body#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.position.x = value;
                    }
                },
                /**
     * The Bodys vertical position (top edge).
     *
     * @name Phaser.Physics.Arcade.Body#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.position.y = value;
                    }
                },
                /**
     * The left edge of the Body. Identical to x.
     *
     * @name Phaser.Physics.Arcade.Body#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                /**
     * The right edge of the Body.
     *
     * @name Phaser.Physics.Arcade.Body#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                /**
     * The top edge of the Body. Identical to y.
     *
     * @name Phaser.Physics.Arcade.Body#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                /**
     * The bottom edge of this Body.
     *
     * @name Phaser.Physics.Arcade.Body#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            module1.exports = Body;
        /***/ },
        /* 522 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * An Arcade Physics Collider will automatically check for collision, or overlaps, between two objects
 * every step. If a collision, or overlap, occurs it will invoke the given callbacks.
 *
 * @class Collider
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade physics World that will manage the collisions.
 * @param {boolean} overlapOnly - Whether to check for collisions or overlap.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object to check for collision.
 * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object2 - The second object to check for collision.
 * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
 * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
 * @param {any} callbackContext - The scope in which to call the callbacks.
 */ var Collider = new Class({
                initialize: function Collider(world, overlapOnly, object1, object2, collideCallback, processCallback, callbackContext) {
                    /**
         * The world in which the bodies will collide.
         *
         * @name Phaser.Physics.Arcade.Collider#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The name of the collider (unused by Phaser).
         *
         * @name Phaser.Physics.Arcade.Collider#name
         * @type {string}
         * @since 3.1.0
         */ this.name = '';
                    /**
         * Whether the collider is active.
         *
         * @name Phaser.Physics.Arcade.Collider#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * Whether to check for collisions or overlaps.
         *
         * @name Phaser.Physics.Arcade.Collider#overlapOnly
         * @type {boolean}
         * @since 3.0.0
         */ this.overlapOnly = overlapOnly;
                    /**
         * The first object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object1
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object1 = object1;
                    /**
         * The second object to check for collision.
         *
         * @name Phaser.Physics.Arcade.Collider#object2
         * @type {Phaser.Types.Physics.Arcade.ArcadeColliderType}
         * @since 3.0.0
         */ this.object2 = object2;
                    /**
         * The callback to invoke when the two objects collide.
         *
         * @name Phaser.Physics.Arcade.Collider#collideCallback
         * @type {ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.collideCallback = collideCallback;
                    /**
         * If a processCallback exists it must return true or collision checking will be skipped.
         *
         * @name Phaser.Physics.Arcade.Collider#processCallback
         * @type {ArcadePhysicsCallback}
         * @since 3.0.0
         */ this.processCallback = processCallback;
                    /**
         * The context the collideCallback and processCallback will run in.
         *
         * @name Phaser.Physics.Arcade.Collider#callbackContext
         * @type {object}
         * @since 3.0.0
         */ this.callbackContext = callbackContext;
                },
                /**
     * A name for the Collider.
     *
     * Phaser does not use this value, it's for your own reference.
     *
     * @method Phaser.Physics.Arcade.Collider#setName
     * @since 3.1.0
     *
     * @param {string} name - The name to assign to the Collider.
     *
     * @return {Phaser.Physics.Arcade.Collider} This Collider instance.
     */ setName: function(name) {
                    this.name = name;
                    return this;
                },
                /**
     * Called by World as part of its step processing, initial operation of collision checking.
     *
     * @method Phaser.Physics.Arcade.Collider#update
     * @since 3.0.0
     */ update: function() {
                    this.world.collideObjects(this.object1, this.object2, this.collideCallback, this.processCallback, this.callbackContext, this.overlapOnly);
                },
                /**
     * Removes Collider from World and disposes of its resources.
     *
     * @method Phaser.Physics.Arcade.Collider#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.world.removeCollider(this);
                    this.active = false;
                    this.world = null;
                    this.object1 = null;
                    this.object2 = null;
                    this.collideCallback = null;
                    this.processCallback = null;
                    this.callbackContext = null;
                }
            });
            module1.exports = Collider;
        /***/ },
        /* 523 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var Vector2 = __webpack_require__(3);
            var pointStart = new Vector2();
            var pointEnd = new Vector2();
            /**
 * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The world x coordinate for the top-left of the area.
 * @param {number} worldY - The world y coordinate for the top-left of the area.
 * @param {number} width - The width of the area.
 * @param {number} height - The height of the area.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinWorldXY = function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                var worldToTileXY = layer.tilemapLayer.tilemap._convert.WorldToTileXY;
                //  Top left corner of the rect, rounded down to include partial tiles
                worldToTileXY(worldX, worldY, true, pointStart, camera, layer);
                var xStart = pointStart.x;
                var yStart = pointStart.y;
                //  Bottom right corner of the rect, rounded up to include partial tiles
                worldToTileXY(worldX + width, worldY + height, false, pointEnd, camera, layer);
                var xEnd = Math.ceil(pointEnd.x);
                var yEnd = Math.ceil(pointEnd.y);
                return GetTilesWithin(xStart, yStart, xEnd - xStart, yEnd - yStart, filteringOptions, layer);
            };
            module1.exports = GetTilesWithinWorldXY;
        /***/ },
        /* 524 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A function to process the collision callbacks between a single tile and an Arcade Physics enabled Game Object.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileCallbacks
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.Tile} tile - The Tile to process.
 * @param {Phaser.GameObjects.Sprite} sprite - The Game Object to process with the Tile.
 *
 * @return {boolean} The result of the callback, `true` for further processing, or `false` to skip this pair.
 */ var ProcessTileCallbacks = function(tile, sprite) {
                //  Tile callbacks take priority over layer level callbacks
                if (tile.collisionCallback) return !tile.collisionCallback.call(tile.collisionCallbackContext, sprite, tile);
                else if (tile.layer.callbacks[tile.index]) return !tile.layer.callbacks[tile.index].callback.call(tile.layer.callbacks[tile.index].callbackContext, sprite, tile);
                return true;
            };
            module1.exports = ProcessTileCallbacks;
        /***/ },
        /* 525 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Vladimir Agafonkin
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var quickselect = __webpack_require__(430);
            /**
 * @classdesc
 * RBush is a high-performance JavaScript library for 2D spatial indexing of points and rectangles.
 * It's based on an optimized R-tree data structure with bulk insertion support.
 *
 * Spatial index is a special data structure for points and rectangles that allows you to perform queries like
 * "all items within this bounding box" very efficiently (e.g. hundreds of times faster than looping over all items).
 *
 * This version of RBush uses a fixed min/max accessor structure of `[ '.left', '.top', '.right', '.bottom' ]`.
 * This is to avoid the eval like function creation that the original library used, which caused CSP policy violations.
 * 
 * rbush is forked from https://github.com/mourner/rbush by Vladimir Agafonkin
 *
 * @class RTree
 * @memberof Phaser.Structs
 * @constructor
 * @since 3.0.0
 */ function rbush(maxEntries) {
                var format = [
                    '.left',
                    '.top',
                    '.right',
                    '.bottom'
                ];
                if (!(this instanceof rbush)) return new rbush(maxEntries, format);
                // max entries in a node is 9 by default; min node fill is 40% for best performance
                this._maxEntries = Math.max(4, maxEntries || 9);
                this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
                this.clear();
            }
            rbush.prototype = {
                all: function() {
                    return this._all(this.data, []);
                },
                search: function(bbox) {
                    var node = this.data, result = [], toBBox = this.toBBox;
                    if (!intersects(bbox, node)) return result;
                    var nodesToSearch = [], i, len, child, childBBox;
                    while(node){
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            childBBox = node.leaf ? toBBox(child) : child;
                            if (intersects(bbox, childBBox)) {
                                if (node.leaf) result.push(child);
                                else if (contains(bbox, childBBox)) this._all(child, result);
                                else nodesToSearch.push(child);
                            }
                        }
                        node = nodesToSearch.pop();
                    }
                    return result;
                },
                collides: function(bbox) {
                    var node = this.data, toBBox = this.toBBox;
                    if (!intersects(bbox, node)) return false;
                    var nodesToSearch = [], i, len, child, childBBox;
                    while(node){
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            childBBox = node.leaf ? toBBox(child) : child;
                            if (intersects(bbox, childBBox)) {
                                if (node.leaf || contains(bbox, childBBox)) return true;
                                nodesToSearch.push(child);
                            }
                        }
                        node = nodesToSearch.pop();
                    }
                    return false;
                },
                load: function(data) {
                    if (!(data && data.length)) return this;
                    if (data.length < this._minEntries) {
                        for(var i = 0, len = data.length; i < len; i++)this.insert(data[i]);
                        return this;
                    }
                    // recursively build the tree with the given data from scratch using OMT algorithm
                    var node = this._build(data.slice(), 0, data.length - 1, 0);
                    if (!this.data.children.length) // save as is if tree is empty
                    this.data = node;
                    else if (this.data.height === node.height) // split root if trees have the same height
                    this._splitRoot(this.data, node);
                    else {
                        if (this.data.height < node.height) {
                            // swap trees if inserted one is bigger
                            var tmpNode = this.data;
                            this.data = node;
                            node = tmpNode;
                        }
                        // insert the small tree into the large tree at appropriate level
                        this._insert(node, this.data.height - node.height - 1, true);
                    }
                    return this;
                },
                insert: function(item) {
                    if (item) this._insert(item, this.data.height - 1);
                    return this;
                },
                clear: function() {
                    this.data = createNode([]);
                    return this;
                },
                remove: function(item, equalsFn) {
                    if (!item) return this;
                    var node = this.data, bbox = this.toBBox(item), path = [], indexes = [], i, parent, index, goingUp;
                    // depth-first iterative tree traversal
                    while(node || path.length){
                        if (!node) {
                            node = path.pop();
                            parent = path[path.length - 1];
                            i = indexes.pop();
                            goingUp = true;
                        }
                        if (node.leaf) {
                            index = findItem(item, node.children, equalsFn);
                            if (index !== -1) {
                                // item found, remove the item and condense tree upwards
                                node.children.splice(index, 1);
                                path.push(node);
                                this._condense(path);
                                return this;
                            }
                        }
                        if (!goingUp && !node.leaf && contains(node, bbox)) {
                            path.push(node);
                            indexes.push(i);
                            i = 0;
                            parent = node;
                            node = node.children[0];
                        } else if (parent) {
                            i++;
                            node = parent.children[i];
                            goingUp = false;
                        } else node = null; // nothing found
                    }
                    return this;
                },
                toBBox: function(item) {
                    return item;
                },
                compareMinX: compareNodeMinX,
                compareMinY: compareNodeMinY,
                toJSON: function() {
                    return this.data;
                },
                fromJSON: function(data) {
                    this.data = data;
                    return this;
                },
                _all: function(node, result) {
                    var nodesToSearch = [];
                    while(node){
                        if (node.leaf) result.push.apply(result, node.children);
                        else nodesToSearch.push.apply(nodesToSearch, node.children);
                        node = nodesToSearch.pop();
                    }
                    return result;
                },
                _build: function(items, left, right, height) {
                    var N = right - left + 1, M = this._maxEntries, node;
                    if (N <= M) {
                        // reached leaf level; return leaf
                        node = createNode(items.slice(left, right + 1));
                        calcBBox(node, this.toBBox);
                        return node;
                    }
                    if (!height) {
                        // target height of the bulk-loaded tree
                        height = Math.ceil(Math.log(N) / Math.log(M));
                        // target number of root entries to maximize storage utilization
                        M = Math.ceil(N / Math.pow(M, height - 1));
                    }
                    node = createNode([]);
                    node.leaf = false;
                    node.height = height;
                    // split the items into M mostly square tiles
                    var N2 = Math.ceil(N / M), N1 = N2 * Math.ceil(Math.sqrt(M)), i, j, right2, right3;
                    multiSelect(items, left, right, N1, this.compareMinX);
                    for(i = left; i <= right; i += N1){
                        right2 = Math.min(i + N1 - 1, right);
                        multiSelect(items, i, right2, N2, this.compareMinY);
                        for(j = i; j <= right2; j += N2){
                            right3 = Math.min(j + N2 - 1, right2);
                            // pack each entry recursively
                            node.children.push(this._build(items, j, right3, height - 1));
                        }
                    }
                    calcBBox(node, this.toBBox);
                    return node;
                },
                _chooseSubtree: function(bbox, node, level, path) {
                    var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
                    while(true){
                        path.push(node);
                        if (node.leaf || path.length - 1 === level) break;
                        minArea = minEnlargement = Infinity;
                        for(i = 0, len = node.children.length; i < len; i++){
                            child = node.children[i];
                            area = bboxArea(child);
                            enlargement = enlargedArea(bbox, child) - area;
                            // choose entry with the least area enlargement
                            if (enlargement < minEnlargement) {
                                minEnlargement = enlargement;
                                minArea = area < minArea ? area : minArea;
                                targetNode = child;
                            } else if (enlargement === minEnlargement) // otherwise choose one with the smallest area
                            {
                                if (area < minArea) {
                                    minArea = area;
                                    targetNode = child;
                                }
                            }
                        }
                        node = targetNode || node.children[0];
                    }
                    return node;
                },
                _insert: function(item, level, isNode) {
                    var toBBox = this.toBBox, bbox = isNode ? item : toBBox(item), insertPath = [];
                    // find the best node for accommodating the item, saving all nodes along the path too
                    var node = this._chooseSubtree(bbox, this.data, level, insertPath);
                    // put the item into the node
                    node.children.push(item);
                    extend(node, bbox);
                    // split on node overflow; propagate upwards if necessary
                    while(level >= 0){
                        if (insertPath[level].children.length > this._maxEntries) {
                            this._split(insertPath, level);
                            level--;
                        } else break;
                    }
                    // adjust bboxes along the insertion path
                    this._adjustParentBBoxes(bbox, insertPath, level);
                },
                // split overflowed node into two
                _split: function(insertPath, level) {
                    var node = insertPath[level], M = node.children.length, m = this._minEntries;
                    this._chooseSplitAxis(node, m, M);
                    var splitIndex = this._chooseSplitIndex(node, m, M);
                    var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
                    newNode.height = node.height;
                    newNode.leaf = node.leaf;
                    calcBBox(node, this.toBBox);
                    calcBBox(newNode, this.toBBox);
                    if (level) insertPath[level - 1].children.push(newNode);
                    else this._splitRoot(node, newNode);
                },
                _splitRoot: function(node, newNode) {
                    // split root node
                    this.data = createNode([
                        node,
                        newNode
                    ]);
                    this.data.height = node.height + 1;
                    this.data.leaf = false;
                    calcBBox(this.data, this.toBBox);
                },
                _chooseSplitIndex: function(node, m, M) {
                    var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
                    minOverlap = minArea = Infinity;
                    for(i = m; i <= M - m; i++){
                        bbox1 = distBBox(node, 0, i, this.toBBox);
                        bbox2 = distBBox(node, i, M, this.toBBox);
                        overlap = intersectionArea(bbox1, bbox2);
                        area = bboxArea(bbox1) + bboxArea(bbox2);
                        // choose distribution with minimum overlap
                        if (overlap < minOverlap) {
                            minOverlap = overlap;
                            index = i;
                            minArea = area < minArea ? area : minArea;
                        } else if (overlap === minOverlap) // otherwise choose distribution with minimum area
                        {
                            if (area < minArea) {
                                minArea = area;
                                index = i;
                            }
                        }
                    }
                    return index;
                },
                // sorts node children by the best axis for split
                _chooseSplitAxis: function(node, m, M) {
                    var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : compareNodeMinY, xMargin = this._allDistMargin(node, m, M, compareMinX), yMargin = this._allDistMargin(node, m, M, compareMinY);
                    // if total distributions margin value is minimal for x, sort by minX,
                    // otherwise it's already sorted by minY
                    if (xMargin < yMargin) node.children.sort(compareMinX);
                },
                // total margin of all possible split distributions where each node is at least m full
                _allDistMargin: function(node, m, M, compare) {
                    node.children.sort(compare);
                    var toBBox = this.toBBox, leftBBox = distBBox(node, 0, m, toBBox), rightBBox = distBBox(node, M - m, M, toBBox), margin = bboxMargin(leftBBox) + bboxMargin(rightBBox), i, child;
                    for(i = m; i < M - m; i++){
                        child = node.children[i];
                        extend(leftBBox, node.leaf ? toBBox(child) : child);
                        margin += bboxMargin(leftBBox);
                    }
                    for(i = M - m - 1; i >= m; i--){
                        child = node.children[i];
                        extend(rightBBox, node.leaf ? toBBox(child) : child);
                        margin += bboxMargin(rightBBox);
                    }
                    return margin;
                },
                _adjustParentBBoxes: function(bbox, path, level) {
                    // adjust bboxes along the given tree path
                    for(var i = level; i >= 0; i--)extend(path[i], bbox);
                },
                _condense: function(path) {
                    // go through the path, removing empty nodes and updating bboxes
                    for(var i = path.length - 1, siblings; i >= 0; i--)if (path[i].children.length === 0) {
                        if (i > 0) {
                            siblings = path[i - 1].children;
                            siblings.splice(siblings.indexOf(path[i]), 1);
                        } else this.clear();
                    } else calcBBox(path[i], this.toBBox);
                },
                compareMinX: function(a, b) {
                    return a.left - b.left;
                },
                compareMinY: function(a, b) {
                    return a.top - b.top;
                },
                toBBox: function(a) {
                    return {
                        minX: a.left,
                        minY: a.top,
                        maxX: a.right,
                        maxY: a.bottom
                    };
                }
            };
            function findItem(item, items, equalsFn) {
                if (!equalsFn) return items.indexOf(item);
                for(var i = 0; i < items.length; i++){
                    if (equalsFn(item, items[i])) return i;
                }
                return -1;
            }
            // calculate node's bbox from bboxes of its children
            function calcBBox(node, toBBox) {
                distBBox(node, 0, node.children.length, toBBox, node);
            }
            // min bounding rectangle of node children from k to p-1
            function distBBox(node, k, p, toBBox, destNode) {
                if (!destNode) destNode = createNode(null);
                destNode.minX = Infinity;
                destNode.minY = Infinity;
                destNode.maxX = -Infinity;
                destNode.maxY = -Infinity;
                for(var i = k, child; i < p; i++){
                    child = node.children[i];
                    extend(destNode, node.leaf ? toBBox(child) : child);
                }
                return destNode;
            }
            function extend(a, b) {
                a.minX = Math.min(a.minX, b.minX);
                a.minY = Math.min(a.minY, b.minY);
                a.maxX = Math.max(a.maxX, b.maxX);
                a.maxY = Math.max(a.maxY, b.maxY);
                return a;
            }
            function compareNodeMinX(a, b) {
                return a.minX - b.minX;
            }
            function compareNodeMinY(a, b) {
                return a.minY - b.minY;
            }
            function bboxArea(a) {
                return (a.maxX - a.minX) * (a.maxY - a.minY);
            }
            function bboxMargin(a) {
                return a.maxX - a.minX + (a.maxY - a.minY);
            }
            function enlargedArea(a, b) {
                return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) * (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
            }
            function intersectionArea(a, b) {
                var minX = Math.max(a.minX, b.minX), minY = Math.max(a.minY, b.minY), maxX = Math.min(a.maxX, b.maxX), maxY = Math.min(a.maxY, b.maxY);
                return Math.max(0, maxX - minX) * Math.max(0, maxY - minY);
            }
            function contains(a, b) {
                return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
            }
            function intersects(a, b) {
                return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
            }
            function createNode(children) {
                return {
                    children: children,
                    height: 1,
                    leaf: true,
                    minX: Infinity,
                    minY: Infinity,
                    maxX: -Infinity,
                    maxY: -Infinity
                };
            }
            // sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
            // combines selection algorithm with binary divide & conquer approach
            function multiSelect(arr, left, right, n, compare) {
                var stack = [
                    left,
                    right
                ], mid;
                while(stack.length){
                    right = stack.pop();
                    left = stack.pop();
                    if (right - left <= n) continue;
                    mid = left + Math.ceil((right - left) / n / 2) * n;
                    quickselect(arr, mid, left, right, compare);
                    stack.push(left, mid, mid, right);
                }
            }
            module1.exports = rbush;
        /***/ },
        /* 526 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileCheckX = __webpack_require__(527);
            var TileCheckY = __webpack_require__(529);
            var TileIntersectsBody = __webpack_require__(245);
            /**
 * The core separation function to separate a physics body and a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.SeparateTile
 * @since 3.0.0
 *
 * @param {number} i - The index of the tile within the map data.
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to collide against.
 * @param {Phaser.Geom.Rectangle} tileWorldRect - A rectangle-like object defining the dimensions of the tile.
 * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {boolean} `true` if the body was separated, otherwise `false`.
 */ var SeparateTile = function(i, body, tile, tileWorldRect, tilemapLayer, tileBias, isLayer) {
                var tileLeft = tileWorldRect.left;
                var tileTop = tileWorldRect.top;
                var tileRight = tileWorldRect.right;
                var tileBottom = tileWorldRect.bottom;
                var faceHorizontal = tile.faceLeft || tile.faceRight;
                var faceVertical = tile.faceTop || tile.faceBottom;
                if (!isLayer) {
                    faceHorizontal = true;
                    faceVertical = true;
                }
                //  We don't need to go any further if this tile doesn't actually have any colliding faces. This
                //  could happen if the tile was meant to be collided with re: a callback, but otherwise isn't
                //  needed for separation.
                if (!faceHorizontal && !faceVertical) return false;
                var ox = 0;
                var oy = 0;
                var minX = 0;
                var minY = 1;
                if (body.deltaAbsX() > body.deltaAbsY()) //  Moving faster horizontally, check X axis first
                minX = -1;
                else if (body.deltaAbsX() < body.deltaAbsY()) //  Moving faster vertically, check Y axis first
                minY = -1;
                if (body.deltaX() !== 0 && body.deltaY() !== 0 && faceHorizontal && faceVertical) {
                    //  We only need do this if both axes have colliding faces AND we're moving in both
                    //  directions
                    minX = Math.min(Math.abs(body.position.x - tileRight), Math.abs(body.right - tileLeft));
                    minY = Math.min(Math.abs(body.position.y - tileBottom), Math.abs(body.bottom - tileTop));
                }
                if (minX < minY) {
                    if (faceHorizontal) {
                        ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                        //  That's horizontal done, check if we still intersects? If not then we can return now
                        if (ox !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                    }
                    if (faceVertical) oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                } else {
                    if (faceVertical) {
                        oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias, isLayer);
                        //  That's vertical done, check if we still intersects? If not then we can return now
                        if (oy !== 0 && !TileIntersectsBody(tileWorldRect, body)) return true;
                    }
                    if (faceHorizontal) ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias, isLayer);
                }
                return ox !== 0 || oy !== 0;
            };
            module1.exports = SeparateTile;
        /***/ },
        /* 527 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationX = __webpack_require__(528);
            /**
 * Check the body against the given tile on the X axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileLeft - The left position of the tile within the tile world.
 * @param {number} tileRight - The right position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckX = function(body, tile, tileLeft, tileRight, tileBias, isLayer) {
                var ox = 0;
                var faceLeft = tile.faceLeft;
                var faceRight = tile.faceRight;
                var collideLeft = tile.collideLeft;
                var collideRight = tile.collideRight;
                if (!isLayer) {
                    faceLeft = true;
                    faceRight = true;
                    collideLeft = true;
                    collideRight = true;
                }
                if (body.deltaX() < 0 && collideRight && body.checkCollision.left) //  Body is moving LEFT
                {
                    if (faceRight && body.x < tileRight) {
                        ox = body.x - tileRight;
                        if (ox < -tileBias) ox = 0;
                    }
                } else if (body.deltaX() > 0 && collideLeft && body.checkCollision.right) //  Body is moving RIGHT
                {
                    if (faceLeft && body.right > tileLeft) {
                        ox = body.right - tileLeft;
                        if (ox > tileBias) ox = 0;
                    }
                }
                if (ox !== 0) {
                    if (body.customSeparateX) body.overlapX = ox;
                    else ProcessTileSeparationX(body, ox);
                }
                return ox;
            };
            module1.exports = TileCheckX;
        /***/ },
        /* 528 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} x - The x separation amount.
 */ var ProcessTileSeparationX = function(body, x) {
                if (x < 0) {
                    body.blocked.none = false;
                    body.blocked.left = true;
                } else if (x > 0) {
                    body.blocked.none = false;
                    body.blocked.right = true;
                }
                body.position.x -= x;
                if (body.bounce.x === 0) body.velocity.x = 0;
                else body.velocity.x = -body.velocity.x * body.bounce.x;
            };
            module1.exports = ProcessTileSeparationX;
        /***/ },
        /* 529 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ProcessTileSeparationY = __webpack_require__(530);
            /**
 * Check the body against the given tile on the Y axis.
 * Used internally by the SeparateTile function.
 *
 * @function Phaser.Physics.Arcade.Tilemap.TileCheckY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
 * @param {number} tileTop - The top position of the tile within the tile world.
 * @param {number} tileBottom - The bottom position of the tile within the tile world.
 * @param {number} tileBias - The tile bias value. Populated by the `World.TILE_BIAS` constant.
 * @param {boolean} isLayer - Is this check coming from a TilemapLayer or an array of tiles?
 *
 * @return {number} The amount of separation that occurred.
 */ var TileCheckY = function(body, tile, tileTop, tileBottom, tileBias, isLayer) {
                var oy = 0;
                var faceTop = tile.faceTop;
                var faceBottom = tile.faceBottom;
                var collideUp = tile.collideUp;
                var collideDown = tile.collideDown;
                if (!isLayer) {
                    faceTop = true;
                    faceBottom = true;
                    collideUp = true;
                    collideDown = true;
                }
                if (body.deltaY() < 0 && collideDown && body.checkCollision.up) //  Body is moving UP
                {
                    if (faceBottom && body.y < tileBottom) {
                        oy = body.y - tileBottom;
                        if (oy < -tileBias) oy = 0;
                    }
                } else if (body.deltaY() > 0 && collideUp && body.checkCollision.down) //  Body is moving DOWN
                {
                    if (faceTop && body.bottom > tileTop) {
                        oy = body.bottom - tileTop;
                        if (oy > tileBias) oy = 0;
                    }
                }
                if (oy !== 0) {
                    if (body.customSeparateY) body.overlapY = oy;
                    else ProcessTileSeparationY(body, oy);
                }
                return oy;
            };
            module1.exports = TileCheckY;
        /***/ },
        /* 530 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Internal function to process the separation of a physics body from a tile.
 *
 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
 * @param {number} y - The y separation amount.
 */ var ProcessTileSeparationY = function(body, y) {
                if (y < 0) {
                    body.blocked.none = false;
                    body.blocked.up = true;
                } else if (y > 0) {
                    body.blocked.none = false;
                    body.blocked.down = true;
                }
                body.position.y -= y;
                if (body.bounce.y === 0) body.velocity.y = 0;
                else body.velocity.y = -body.velocity.y * body.bounce.y;
            };
            module1.exports = ProcessTileSeparationY;
        /***/ },
        /* 531 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapX = __webpack_require__(243);
            var ProcessX = __webpack_require__(1383);
            /**
 * Separates two overlapping bodies on the X-axis (horizontally).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no horizontal overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateX
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateX = function(body1, body2, overlapOnly, bias) {
                var overlap = GetOverlapX(body1, body2, overlapOnly, bias);
                var body1Immovable = body1.immovable;
                var body2Immovable = body2.immovable;
                //  Can't separate two immovable bodies, or a body with its own custom separation logic
                if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateX || body2.customSeparateX) //  return true if there was some overlap, otherwise false
                return overlap !== 0 || body1.embedded && body2.embedded;
                var blockedState = ProcessX.Set(body1, body2, overlap);
                if (!body1Immovable && !body2Immovable) {
                    if (blockedState > 0) return true;
                    return ProcessX.Check();
                } else if (body1Immovable) ProcessX.RunImmovableBody1(blockedState);
                else if (body2Immovable) ProcessX.RunImmovableBody2(blockedState);
                //  If we got this far then there WAS overlap, and separation is complete, so return true
                return true;
            };
            module1.exports = SeparateX;
        /***/ },
        /* 532 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetOverlapY = __webpack_require__(244);
            var ProcessY = __webpack_require__(1384);
            /**
 * Separates two overlapping bodies on the Y-axis (vertically).
 *
 * Separation involves moving two overlapping bodies so they don't overlap anymore and adjusting their velocities based on their mass. This is a core part of collision detection.
 *
 * The bodies won't be separated if there is no vertical overlap between them, if they are static, or if either one uses custom logic for its separation.
 *
 * @function Phaser.Physics.Arcade.SeparateY
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
 * @param {boolean} overlapOnly - If `true`, the bodies will only have their overlap data set and no separation will take place.
 * @param {number} bias - A value to add to the delta value during overlap checking. Used to prevent sprite tunneling.
 *
 * @return {boolean} `true` if the two bodies overlap vertically, otherwise `false`.
 */ var SeparateY = function(body1, body2, overlapOnly, bias) {
                var overlap = GetOverlapY(body1, body2, overlapOnly, bias);
                var body1Immovable = body1.immovable;
                var body2Immovable = body2.immovable;
                //  Can't separate two immovable bodies, or a body with its own custom separation logic
                if (overlapOnly || overlap === 0 || body1Immovable && body2Immovable || body1.customSeparateY || body2.customSeparateY) //  return true if there was some overlap, otherwise false
                return overlap !== 0 || body1.embedded && body2.embedded;
                var blockedState = ProcessY.Set(body1, body2, overlap);
                if (!body1Immovable && !body2Immovable) {
                    if (blockedState > 0) return true;
                    return ProcessY.Check();
                } else if (body1Immovable) ProcessY.RunImmovableBody1(blockedState);
                else if (body2Immovable) ProcessY.RunImmovableBody2(blockedState);
                //  If we got this far then there WAS overlap, and separation is complete, so return true
                return true;
            };
            module1.exports = SeparateY;
        /***/ },
        /* 533 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CircleContains = __webpack_require__(63);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(60);
            var RectangleContains = __webpack_require__(56);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Static Arcade Physics Body.
 *
 * A Static Body never moves, and isn't automatically synchronized with its parent Game Object.
 * That means if you make any change to the parent's origin, position, or scale after creating or adding the body, you'll need to update the Static Body manually.
 *
 * A Static Body can collide with other Bodies, but is never moved by collisions.
 *
 * Its dynamic counterpart is {@link Phaser.Physics.Arcade.Body}.
 *
 * @class StaticBody
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Static Body belongs to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object this Static Body belongs to.
 */ var StaticBody = new Class({
                initialize: function StaticBody(world, gameObject) {
                    var width = gameObject.displayWidth ? gameObject.displayWidth : 64;
                    var height = gameObject.displayHeight ? gameObject.displayHeight : 64;
                    /**
         * The Arcade Physics simulation this Static Body belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticBody#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Game Object this Static Body belongs to.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.0.0
         */ this.gameObject = gameObject;
                    /**
         * Whether the Static Body's boundary is drawn to the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugShowBody
         * @type {boolean}
         * @since 3.0.0
         */ this.debugShowBody = world.defaults.debugShowStaticBody;
                    /**
         * The color of this Static Body on the debug display.
         *
         * @name Phaser.Physics.Arcade.StaticBody#debugBodyColor
         * @type {number}
         * @since 3.0.0
         */ this.debugBodyColor = world.defaults.staticBodyDebugColor;
                    /**
         * Whether this Static Body is updated by the physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#enable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enable = true;
                    /**
         * Whether this Static Body's boundary is circular (`true`) or rectangular (`false`).
         *
         * @name Phaser.Physics.Arcade.StaticBody#isCircle
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.isCircle = false;
                    /**
         * If this Static Body is circular, this is the radius of the boundary, as set by {@link Phaser.Physics.Arcade.StaticBody#setCircle}, in pixels.
         * Equal to `halfWidth`.
         *
         * @name Phaser.Physics.Arcade.StaticBody#radius
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.radius = 0;
                    /**
         * The offset set by {@link Phaser.Physics.Arcade.StaticBody#setCircle} or {@link Phaser.Physics.Arcade.StaticBody#setSize}.
         *
         * This doesn't affect the Static Body's position, because a Static Body does not follow its Game Object.
         *
         * @name Phaser.Physics.Arcade.StaticBody#offset
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.offset = new Vector2();
                    /**
         * The position of this Static Body within the simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2(gameObject.x - width * gameObject.originX, gameObject.y - height * gameObject.originY);
                    /**
         * The width of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#width
         * @type {number}
         * @since 3.0.0
         */ this.width = width;
                    /**
         * The height of the Static Body's boundary, in pixels.
         * If the Static Body is circular, this is also the Static Body's diameter.
         *
         * @name Phaser.Physics.Arcade.StaticBody#height
         * @type {number}
         * @since 3.0.0
         */ this.height = height;
                    /**
         * Half the Static Body's width, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfWidth
         * @type {number}
         * @since 3.0.0
         */ this.halfWidth = Math.abs(this.width / 2);
                    /**
         * Half the Static Body's height, in pixels.
         * If the Static Body is circular, this is also the Static Body's radius.
         *
         * @name Phaser.Physics.Arcade.StaticBody#halfHeight
         * @type {number}
         * @since 3.0.0
         */ this.halfHeight = Math.abs(this.height / 2);
                    /**
         * The center of the Static Body's boundary.
         * This is the midpoint of its `position` (top-left corner) and its bottom-right corner.
         *
         * @name Phaser.Physics.Arcade.StaticBody#center
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.center = new Vector2(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    /**
         * A constant zero velocity used by the Arcade Physics simulation for calculations.
         *
         * @name Phaser.Physics.Arcade.StaticBody#velocity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.velocity = Vector2.ZERO;
                    /**
         * A constant `false` value expected by the Arcade Physics simulation.
         *
         * @name Phaser.Physics.Arcade.StaticBody#allowGravity
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.allowGravity = false;
                    /**
         * Gravitational force applied specifically to this Body. Values are in pixels per second squared. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#gravity
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.gravity = Vector2.ZERO;
                    /**
         * Rebound, or restitution, following a collision, relative to 1. Always zero for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#bounce
         * @type {Phaser.Math.Vector2}
         * @readonly
         * @since 3.0.0
         */ this.bounce = Vector2.ZERO;
                    //  If true this Body will dispatch events
                    /**
         * Whether the simulation emits a `worldbounds` event when this StaticBody collides with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary and never trigger a `worldbounds` event.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#onWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.onWorldBounds = false;
                    /**
         * Whether the simulation emits a `collide` event when this StaticBody collides with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onCollide
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onCollide = false;
                    /**
         * Whether the simulation emits an `overlap` event when this StaticBody overlaps with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#onOverlap
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.onOverlap = false;
                    /**
         * The StaticBody's inertia, relative to a default unit (1). With `bounce`, this affects the exchange of momentum (velocities) during collisions.
         *
         * @name Phaser.Physics.Arcade.StaticBody#mass
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.mass = 1;
                    /**
         * Whether this object can be moved by collisions with another body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#immovable
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.immovable = true;
                    /**
         * Sets if this Body can be pushed by another Body.
         *
         * A body that cannot be pushed will reflect back all of the velocity it is given to the
         * colliding body. If that body is also not pushable, then the separation will be split
         * between them evenly.
         *
         * If you want your body to never move or seperate at all, see the `setImmovable` method.
         *
         * By default, Static Bodies are not pushable.
         *
         * @name Phaser.Physics.Arcade.StaticBody#pushable
         * @type {boolean}
         * @default false
         * @since 3.50.0
         * @see Phaser.GameObjects.Components.Pushable#setPushable
         */ this.pushable = false;
                    /**
         * A flag disabling the default horizontal separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateX
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateX = false;
                    /**
         * A flag disabling the default vertical separation of colliding bodies. Pass your own `collideHandler` to the collider.
         *
         * @name Phaser.Physics.Arcade.StaticBody#customSeparateY
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.customSeparateY = false;
                    /**
         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapX = 0;
                    /**
         * The amount of vertical overlap (before separation), if this Body is colliding with another.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapY = 0;
                    /**
         * The amount of overlap (before separation), if this StaticBody is circular and colliding with another circular body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#overlapR
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.overlapR = 0;
                    /**
         * Whether this StaticBody has ever overlapped with another while both were not moving.
         *
         * @name Phaser.Physics.Arcade.StaticBody#embedded
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.embedded = false;
                    /**
         * Whether this StaticBody interacts with the world boundary.
         * Always false for a Static Body. (Static Bodies never collide with the world boundary.)
         *
         * @name Phaser.Physics.Arcade.StaticBody#collideWorldBounds
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.0.0
         */ this.collideWorldBounds = false;
                    /**
         * Whether this StaticBody is checked for collisions and for which directions. You can set `checkCollision.none = false` to disable collision checks.
         *
         * @name Phaser.Physics.Arcade.StaticBody#checkCollision
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.checkCollision = {
                        none: false,
                        up: true,
                        down: true,
                        left: true,
                        right: true
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#touching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.touching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         * The values are always false for a Static Body.
         *
         * @name Phaser.Physics.Arcade.StaticBody#wasTouching
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.wasTouching = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * This property is kept for compatibility with Dynamic Bodies.
         * Avoid using it.
         *
         * @name Phaser.Physics.Arcade.StaticBody#blocked
         * @type {Phaser.Types.Physics.Arcade.ArcadeBodyCollision}
         * @since 3.0.0
         */ this.blocked = {
                        none: true,
                        up: false,
                        down: false,
                        left: false,
                        right: false
                    };
                    /**
         * The StaticBody's physics type (static by default).
         *
         * @name Phaser.Physics.Arcade.StaticBody#physicsType
         * @type {number}
         * @default Phaser.Physics.Arcade.STATIC_BODY
         * @since 3.0.0
         */ this.physicsType = CONST.STATIC_BODY;
                    /**
         * The calculated change in the Static Body's horizontal position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dx
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dx = 0;
                    /**
         * The calculated change in the Static Body's vertical position during the current step.
         * For a static body this is always zero.
         *
         * @name Phaser.Physics.Arcade.StaticBody#_dy
         * @type {number}
         * @private
         * @default 0
         * @since 3.10.0
         */ this._dy = 0;
                },
                /**
     * Changes the Game Object this Body is bound to.
     * First it removes its reference from the old Game Object, then sets the new one.
     * You can optionally update the position and dimensions of this Body to reflect that of the new Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setGameObject
     * @since 3.1.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The new Game Object that will own this Body.
     * @param {boolean} [update=true] - Reposition and resize this Body to match the new Game Object?
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ setGameObject: function(gameObject, update) {
                    if (gameObject && gameObject !== this.gameObject) {
                        //  Remove this body from the old game object
                        this.gameObject.body = null;
                        gameObject.body = this;
                        //  Update our reference
                        this.gameObject = gameObject;
                    }
                    if (update) this.updateFromGameObject();
                    return this;
                },
                /**
     * Syncs the Static Body's position and size with its parent Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     * @since 3.1.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ updateFromGameObject: function() {
                    this.world.staticTree.remove(this);
                    var gameObject = this.gameObject;
                    gameObject.getTopLeft(this.position);
                    this.width = gameObject.displayWidth;
                    this.height = gameObject.displayHeight;
                    this.halfWidth = Math.abs(this.width / 2);
                    this.halfHeight = Math.abs(this.height / 2);
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Positions the Static Body at an offset from its Game Object.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setOffset
     * @since 3.4.0
     *
     * @param {number} x - The horizontal offset of the Static Body from the Game Object's `x`.
     * @param {number} y - The vertical offset of the Static Body from the Game Object's `y`.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setOffset: function(x, y) {
                    if (y === undefined) y = x;
                    this.world.staticTree.remove(this);
                    this.position.x -= this.offset.x;
                    this.position.y -= this.offset.y;
                    this.offset.set(x, y);
                    this.position.x += this.offset.x;
                    this.position.y += this.offset.y;
                    this.updateCenter();
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Sets the size of the Static Body.
     * When `center` is true, also repositions it.
     * Resets the width and height to match current frame, if no width and height provided and a frame is found.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setSize
     * @since 3.0.0
     *
     * @param {number} [width] - The width of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame width.
     * @param {number} [height] - The height of the Static Body in pixels. Cannot be zero. If not given, and the parent Game Object has a frame, it will use the frame height.
     * @param {boolean} [center=true] - Place the Static Body's center on its Game Object's center. Only works if the Game Object has the `getCenter` method.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setSize: function(width, height, center) {
                    if (center === undefined) center = true;
                    var gameObject = this.gameObject;
                    if (!width && gameObject.frame) width = gameObject.frame.realWidth;
                    if (!height && gameObject.frame) height = gameObject.frame.realHeight;
                    this.world.staticTree.remove(this);
                    this.width = width;
                    this.height = height;
                    this.halfWidth = Math.floor(width / 2);
                    this.halfHeight = Math.floor(height / 2);
                    if (center && gameObject.getCenter) {
                        var ox = gameObject.displayWidth / 2;
                        var oy = gameObject.displayHeight / 2;
                        this.position.x -= this.offset.x;
                        this.position.y -= this.offset.y;
                        this.offset.set(ox - this.halfWidth, oy - this.halfHeight);
                        this.position.x += this.offset.x;
                        this.position.y += this.offset.y;
                    }
                    this.updateCenter();
                    this.isCircle = false;
                    this.radius = 0;
                    this.world.staticTree.insert(this);
                    return this;
                },
                /**
     * Sets this Static Body to have a circular body and sets its size and position.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the StaticBody, in pixels.
     * @param {number} [offsetX] - The horizontal offset of the StaticBody from its Game Object, in pixels.
     * @param {number} [offsetY] - The vertical offset of the StaticBody from its Game Object, in pixels.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    if (offsetX === undefined) offsetX = this.offset.x;
                    if (offsetY === undefined) offsetY = this.offset.y;
                    if (radius > 0) {
                        this.world.staticTree.remove(this);
                        this.isCircle = true;
                        this.radius = radius;
                        this.width = radius * 2;
                        this.height = radius * 2;
                        this.halfWidth = Math.floor(this.width / 2);
                        this.halfHeight = Math.floor(this.height / 2);
                        this.offset.set(offsetX, offsetY);
                        this.updateCenter();
                        this.world.staticTree.insert(this);
                    } else this.isCircle = false;
                    return this;
                },
                /**
     * Updates the StaticBody's `center` from its `position` and dimensions.
     *
     * @method Phaser.Physics.Arcade.StaticBody#updateCenter
     * @since 3.0.0
     */ updateCenter: function() {
                    this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
                },
                /**
     * Resets this Body to the given coordinates. Also positions its parent Game Object to the same coordinates.
     *
     * @method Phaser.Physics.Arcade.StaticBody#reset
     * @since 3.0.0
     *
     * @param {number} [x] - The x coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     * @param {number} [y] - The y coordinate to reset the body to. If not given will use the parent Game Object's coordinate.
     */ reset: function(x, y) {
                    var gameObject = this.gameObject;
                    if (x === undefined) x = gameObject.x;
                    if (y === undefined) y = gameObject.y;
                    this.world.staticTree.remove(this);
                    gameObject.setPosition(x, y);
                    gameObject.getTopLeft(this.position);
                    this.updateCenter();
                    this.world.staticTree.insert(this);
                },
                /**
     * NOOP function. A Static Body cannot be stopped.
     *
     * @method Phaser.Physics.Arcade.StaticBody#stop
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ stop: function() {
                    return this;
                },
                /**
     * Returns the x and y coordinates of the top left and bottom right points of the StaticBody.
     *
     * @method Phaser.Physics.Arcade.StaticBody#getBounds
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} obj - The object which will hold the coordinates of the bounds.
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeBodyBounds} The same object that was passed with `x`, `y`, `right` and `bottom` values matching the respective values of the StaticBody.
     */ getBounds: function(obj) {
                    obj.x = this.x;
                    obj.y = this.y;
                    obj.right = this.right;
                    obj.bottom = this.bottom;
                    return obj;
                },
                /**
     * Checks to see if a given x,y coordinate is colliding with this Static Body.
     *
     * @method Phaser.Physics.Arcade.StaticBody#hitTest
     * @since 3.0.0
     *
     * @param {number} x - The x coordinate to check against this body.
     * @param {number} y - The y coordinate to check against this body.
     *
     * @return {boolean} `true` if the given coordinate lies within this body, otherwise `false`.
     */ hitTest: function(x, y) {
                    return this.isCircle ? CircleContains(this, x, y) : RectangleContains(this, x, y);
                },
                /**
     * NOOP
     *
     * @method Phaser.Physics.Arcade.StaticBody#postUpdate
     * @since 3.12.0
     */ postUpdate: function() {},
                /**
     * The absolute (non-negative) change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsX
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsX: function() {
                    return 0;
                },
                /**
     * The absolute (non-negative) change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsY
     * @since 3.0.0
     *
     * @return {number} Always zero for a Static Body.
     */ deltaAbsY: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's horizontal position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaX
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaX: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's vertical position from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaY
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's velocity from the previous step. Always zero.
     */ deltaY: function() {
                    return 0;
                },
                /**
     * The change in this StaticBody's rotation from the previous step. Always zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#deltaZ
     * @since 3.0.0
     *
     * @return {number} The change in this StaticBody's rotation from the previous step. Always zero.
     */ deltaZ: function() {
                    return 0;
                },
                /**
     * Disables this Body and marks it for destruction during the next step.
     *
     * @method Phaser.Physics.Arcade.StaticBody#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.enable = false;
                    this.world.pendingDestroy.set(this);
                },
                /**
     * Draws a graphical representation of the StaticBody for visual debugging purposes.
     *
     * @method Phaser.Physics.Arcade.StaticBody#drawDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to use for the debug drawing of the StaticBody.
     */ drawDebug: function(graphic) {
                    var pos = this.position;
                    var x = pos.x + this.halfWidth;
                    var y = pos.y + this.halfHeight;
                    if (this.debugShowBody) {
                        graphic.lineStyle(graphic.defaultStrokeWidth, this.debugBodyColor, 1);
                        if (this.isCircle) graphic.strokeCircle(x, y, this.width / 2);
                        else graphic.strokeRect(pos.x, pos.y, this.width, this.height);
                    }
                },
                /**
     * Indicates whether the StaticBody is going to be showing a debug visualization during postUpdate.
     *
     * @method Phaser.Physics.Arcade.StaticBody#willDrawDebug
     * @since 3.0.0
     *
     * @return {boolean} Whether or not the StaticBody is going to show the debug visualization during postUpdate.
     */ willDrawDebug: function() {
                    return this.debugShowBody;
                },
                /**
     * Sets the Mass of the StaticBody. Will set the Mass to 0.1 if the value passed is less than or equal to zero.
     *
     * @method Phaser.Physics.Arcade.StaticBody#setMass
     * @since 3.0.0
     *
     * @param {number} value - The value to set the Mass to. Values of zero or less are changed to 0.1.
     *
     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
     */ setMass: function(value) {
                    if (value <= 0) //  Causes havoc otherwise
                    value = 0.1;
                    this.mass = value;
                    return this;
                },
                /**
     * The x coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.position.x;
                    },
                    set: function(value) {
                        this.world.staticTree.remove(this);
                        this.position.x = value;
                        this.world.staticTree.insert(this);
                    }
                },
                /**
     * The y coordinate of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.position.y;
                    },
                    set: function(value) {
                        this.world.staticTree.remove(this);
                        this.position.y = value;
                        this.world.staticTree.insert(this);
                    }
                },
                /**
     * Returns the left-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#left
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ left: {
                    get: function() {
                        return this.position.x;
                    }
                },
                /**
     * The right-most x coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#right
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ right: {
                    get: function() {
                        return this.position.x + this.width;
                    }
                },
                /**
     * The highest y coordinate of the area of the StaticBody.
     *
     * @name Phaser.Physics.Arcade.StaticBody#top
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ top: {
                    get: function() {
                        return this.position.y;
                    }
                },
                /**
     * The lowest y coordinate of the area of the StaticBody. (y + height)
     *
     * @name Phaser.Physics.Arcade.StaticBody#bottom
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ bottom: {
                    get: function() {
                        return this.position.y + this.height;
                    }
                }
            });
            module1.exports = StaticBody;
        /***/ },
        /* 534 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Components
 */ module1.exports = {
                Bounce: __webpack_require__(1500),
                Collision: __webpack_require__(1501),
                Force: __webpack_require__(1502),
                Friction: __webpack_require__(1503),
                Gravity: __webpack_require__(1504),
                Mass: __webpack_require__(1505),
                Sensor: __webpack_require__(1506),
                SetBody: __webpack_require__(1507),
                Sleep: __webpack_require__(1508),
                Static: __webpack_require__(1525),
                Transform: __webpack_require__(1526),
                Velocity: __webpack_require__(1527)
            };
        /***/ },
        /* 535 */ /***/ function(module1, exports) {
            /**
* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
*
* @class Pair
*/ var Pair = {};
            module1.exports = Pair;
            (function() {
                /**
     * Creates a pair.
     * @method create
     * @param {collision} collision
     * @param {number} timestamp
     * @return {pair} A new pair
     */ Pair.create = function(collision, timestamp) {
                    var bodyA = collision.bodyA, bodyB = collision.bodyB;
                    var pair = {
                        id: Pair.id(bodyA, bodyB),
                        bodyA: bodyA,
                        bodyB: bodyB,
                        activeContacts: [],
                        separation: 0,
                        isActive: true,
                        confirmedActive: true,
                        isSensor: bodyA.isSensor || bodyB.isSensor,
                        timeCreated: timestamp,
                        timeUpdated: timestamp,
                        collision: null,
                        inverseMass: 0,
                        friction: 0,
                        frictionStatic: 0,
                        restitution: 0,
                        slop: 0
                    };
                    Pair.update(pair, collision, timestamp);
                    return pair;
                };
                /**
     * Updates a pair given a collision.
     * @method update
     * @param {pair} pair
     * @param {collision} collision
     * @param {number} timestamp
     */ Pair.update = function(pair, collision, timestamp) {
                    pair.collision = collision;
                    if (collision.collided) {
                        var supports = collision.supports, activeContacts = pair.activeContacts, parentA = collision.parentA, parentB = collision.parentB;
                        pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
                        pair.friction = Math.min(parentA.friction, parentB.friction);
                        pair.frictionStatic = Math.max(parentA.frictionStatic, parentB.frictionStatic);
                        pair.restitution = Math.max(parentA.restitution, parentB.restitution);
                        pair.slop = Math.max(parentA.slop, parentB.slop);
                        for(var i = 0; i < supports.length; i++)activeContacts[i] = supports[i].contact;
                        // optimise array size
                        var supportCount = supports.length;
                        if (supportCount < activeContacts.length) activeContacts.length = supportCount;
                        pair.separation = collision.depth;
                        Pair.setActive(pair, true, timestamp);
                    } else if (pair.isActive === true) Pair.setActive(pair, false, timestamp);
                };
                /**
     * Set a pair as active or inactive.
     * @method setActive
     * @param {pair} pair
     * @param {bool} isActive
     * @param {number} timestamp
     */ Pair.setActive = function(pair, isActive, timestamp) {
                    if (isActive) {
                        pair.isActive = true;
                        pair.timeUpdated = timestamp;
                    } else {
                        pair.isActive = false;
                        pair.activeContacts.length = 0;
                    }
                };
                /**
     * Get the id for the given pair.
     * @method id
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {string} Unique pairId
     */ Pair.id = function(bodyA, bodyB) {
                    if (bodyA.id < bodyB.id) return 'A' + bodyA.id + 'B' + bodyB.id;
                    else return 'A' + bodyB.id + 'B' + bodyA.id;
                };
            })();
        /***/ },
        /* 536 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* @author       Richard Davey <rich@photonstorm.com>
* @copyright    2020 Photon Storm Ltd.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A Global Plugin is installed just once into the Game owned Plugin Manager.
 * It can listen for Game events and respond to them.
 *
 * @class BasePlugin
 * @memberof Phaser.Plugins
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 */ var BasePlugin = new Class({
                initialize: function BasePlugin(pluginManager) {
                    /**
         * A handy reference to the Plugin Manager that is responsible for this plugin.
         * Can be used as a route to gain access to game systems and  events.
         *
         * @name Phaser.Plugins.BasePlugin#pluginManager
         * @type {Phaser.Plugins.PluginManager}
         * @protected
         * @since 3.8.0
         */ this.pluginManager = pluginManager;
                    /**
         * A reference to the Game instance this plugin is running under.
         *
         * @name Phaser.Plugins.BasePlugin#game
         * @type {Phaser.Game}
         * @protected
         * @since 3.8.0
         */ this.game = pluginManager.game;
                },
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is first instantiated.
     * It will never be called again on this instance.
     * In here you can set-up whatever you need for this plugin to run.
     * If a plugin is set to automatically start then `BasePlugin.start` will be called immediately after this.
     * On a Scene Plugin, this method is never called. Use {@link Phaser.Plugins.ScenePlugin#boot} instead.
     *
     * @method Phaser.Plugins.BasePlugin#init
     * @since 3.8.0
     *
     * @param {?any} [data] - A value specified by the user, if any, from the `data` property of the plugin's configuration object (if started at game boot) or passed in the PluginManager's `install` method (if started manually).
     */ init: function() {},
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is started.
     * If a plugin is stopped, and then started again, this will get called again.
     * Typically called immediately after `BasePlugin.init`.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#start
     * @since 3.8.0
     */ start: function() {
                //  Here are the game-level events you can listen to.
                //  At the very least you should offer a destroy handler for when the game closes down.
                // var eventEmitter = this.game.events;
                // eventEmitter.once('destroy', this.gameDestroy, this);
                // eventEmitter.on('pause', this.gamePause, this);
                // eventEmitter.on('resume', this.gameResume, this);
                // eventEmitter.on('resize', this.gameResize, this);
                // eventEmitter.on('prestep', this.gamePreStep, this);
                // eventEmitter.on('step', this.gameStep, this);
                // eventEmitter.on('poststep', this.gamePostStep, this);
                // eventEmitter.on('prerender', this.gamePreRender, this);
                // eventEmitter.on('postrender', this.gamePostRender, this);
                },
                /**
     * The PluginManager calls this method on a Global Plugin when the plugin is stopped.
     * The game code has requested that your plugin stop doing whatever it does.
     * It is now considered as 'inactive' by the PluginManager.
     * Handle that process here (i.e. stop listening for events, etc)
     * If the plugin is started again then `BasePlugin.start` will be called again.
     * On a Scene Plugin, this method is never called.
     *
     * @method Phaser.Plugins.BasePlugin#stop
     * @since 3.8.0
     */ stop: function() {},
                /**
     * Game instance has been destroyed.
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.BasePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                    this.pluginManager = null;
                    this.game = null;
                    this.scene = null;
                    this.systems = null;
                }
            });
            module1.exports = BasePlugin;
        /***/ },
        /* 537 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Checks if the given tile coordinate is within the isometric layer bounds, or not.
 *
 * @function Phaser.Tilemaps.Components.CheckIsoBounds
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to check against.
 * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
 *
 * @return {boolean} Returns `true` if the coordinates are within the iso bounds.
 */ var CheckIsoBounds = function(tileX, tileY, layer, camera) {
                var tilemapLayer = layer.tilemapLayer;
                var cullPaddingX = tilemapLayer.cullPaddingX;
                var cullPaddingY = tilemapLayer.cullPaddingY;
                var pos = tilemapLayer.tilemap.tileToWorldXY(tileX, tileY, point, camera, tilemapLayer);
                // we always subtract 1/2 of the tile's height/width to make the culling distance start from the center of the tiles.
                return pos.x > camera.worldView.x + tilemapLayer.scaleX * layer.tileWidth * (-cullPaddingX - 0.5) && pos.x < camera.worldView.right + tilemapLayer.scaleX * layer.tileWidth * (cullPaddingX - 0.5) && pos.y > camera.worldView.y + tilemapLayer.scaleY * layer.tileHeight * (-cullPaddingY - 1.0) && pos.y < camera.worldView.bottom + tilemapLayer.scaleY * layer.tileHeight * (cullPaddingY - 0.5);
            };
            module1.exports = CheckIsoBounds;
        /***/ },
        /* 538 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
 * not change collision information.
 *
 * @function Phaser.Tilemaps.Components.ReplaceByIndex
 * @since 3.0.0
 *
 * @param {number} findIndex - The index of the tile to search for.
 * @param {number} newIndex - The index of the tile to replace it with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ReplaceByIndex = function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)if (tiles[i] && tiles[i].index === findIndex) tiles[i].index = newIndex;
            };
            module1.exports = ReplaceByIndex;
        /***/ },
        /* 539 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var SnapCeil = __webpack_require__(137);
            var SnapFloor = __webpack_require__(76);
            var bounds = new Rectangle();
            /**
 * Returns the bounds in the given orthogonal layer that are within the cameras viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.CullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle containing the culled bounds. If you wish to retain this object, clone it, as it's recycled internally.
 */ var CullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH, 0, true) + tilemapLayer.cullPaddingY;
                return bounds.setTo(boundsLeft, boundsTop, boundsRight - boundsLeft, boundsBottom - boundsTop);
            };
            module1.exports = CullBounds;
        /***/ },
        /* 540 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(539);
            var RunCull = __webpack_require__(157);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.CullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var CullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                //  Camera world view bounds, snapped for scaled tile size
                //  Cull Padding values are given in tiles, not pixels
                var bounds = CullBounds(layer, camera);
                if (tilemapLayer.skipCull || tilemapLayer.scrollFactorX !== 1 || tilemapLayer.scrollFactorY !== 1) {
                    bounds.left = 0;
                    bounds.right = layer.width;
                    bounds.top = 0;
                    bounds.bottom = layer.height;
                }
                RunCull(layer, bounds, renderOrder, outputArray);
                return outputArray;
            };
            module1.exports = CullTiles;
        /***/ },
        /* 541 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(542);
            var RunCull = __webpack_require__(157);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var HexagonalCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                if (!tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    RunCull(layer, bounds, renderOrder, outputArray);
                }
                return outputArray;
            };
            module1.exports = HexagonalCullTiles;
        /***/ },
        /* 542 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(137);
            var SnapFloor = __webpack_require__(76);
            /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.HexagonalCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var HexagonalCullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var len = layer.hexSideLength;
                var rowH = (tileH - len) / 2 + len;
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, rowH, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, rowH, 0, true) + tilemapLayer.cullPaddingY;
                return {
                    left: boundsLeft,
                    right: boundsRight,
                    top: boundsTop,
                    bottom: boundsBottom
                };
            };
            module1.exports = HexagonalCullBounds;
        /***/ },
        /* 543 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CheckIsoBounds = __webpack_require__(537);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.IsometricCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var IsometricCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                var mapData = layer.data;
                var mapWidth = layer.width;
                var mapHeight = layer.height;
                var drawLeft = 0;
                var drawRight = mapWidth;
                var drawTop = 0;
                var drawBottom = mapHeight;
                if (!tilemapLayer.skipCull) {
                    var x;
                    var y;
                    var tile;
                    if (renderOrder === 0) //  right-down
                    for(y = drawTop; y < drawBottom; y++){
                        for(x = drawLeft; mapData[y] && x < drawRight; x++)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 1) //  left-down
                    for(y = drawTop; y < drawBottom; y++){
                        for(x = drawRight; mapData[y] && x >= drawLeft; x--)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 2) //  right-up
                    for(y = drawBottom; y >= drawTop; y--){
                        for(x = drawLeft; mapData[y] && x < drawRight; x++)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                    else if (renderOrder === 3) //  left-up
                    for(y = drawBottom; y >= drawTop; y--){
                        for(x = drawRight; mapData[y] && x >= drawLeft; x--)if (CheckIsoBounds(x, y, layer, camera)) {
                            tile = mapData[y][x];
                            if (!tile || tile.index === -1 || !tile.visible || tile.alpha === 0) continue;
                            outputArray.push(tile);
                        }
                    }
                }
                tilemapLayer.tilesDrawn = outputArray.length;
                tilemapLayer.tilesTotal = mapWidth * mapHeight;
                return outputArray;
            };
            module1.exports = IsometricCullTiles;
        /***/ },
        /* 544 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CullBounds = __webpack_require__(545);
            var RunCull = __webpack_require__(157);
            /**
 * Returns the tiles in the given layer that are within the cameras viewport. This is used internally.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullTiles
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 * @param {array} [outputArray] - An optional array to store the Tile objects within.
 * @param {number} [renderOrder=0] - The rendering order constant.
 *
 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
 */ var StaggeredCullTiles = function(layer, camera, outputArray, renderOrder) {
                if (outputArray === undefined) outputArray = [];
                if (renderOrder === undefined) renderOrder = 0;
                outputArray.length = 0;
                var tilemapLayer = layer.tilemapLayer;
                if (!tilemapLayer.skipCull && tilemapLayer.scrollFactorX === 1 && tilemapLayer.scrollFactorY === 1) {
                    //  Camera world view bounds, snapped for scaled tile size
                    //  Cull Padding values are given in tiles, not pixels
                    var bounds = CullBounds(layer, camera);
                    RunCull(layer, bounds, renderOrder, outputArray);
                }
                return outputArray;
            };
            module1.exports = StaggeredCullTiles;
        /***/ },
        /* 545 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SnapCeil = __webpack_require__(137);
            var SnapFloor = __webpack_require__(76);
            /**
 * Returns the bounds in the given layer that are within the camera's viewport.
 * This is used internally by the cull tiles function.
 *
 * @function Phaser.Tilemaps.Components.StaggeredCullBounds
 * @since 3.50.0
 *
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to run the cull check against.
 *
 * @return {object} An object containing the `left`, `right`, `top` and `bottom` bounds.
 */ var StaggeredCullBounds = function(layer, camera) {
                var tilemap = layer.tilemapLayer.tilemap;
                var tilemapLayer = layer.tilemapLayer;
                //  We need to use the tile sizes defined for the map as a whole, not the layer,
                //  in order to calculate the bounds correctly. As different sized tiles may be
                //  placed on the grid and we cannot trust layer.baseTileWidth to give us the true size.
                var tileW = Math.floor(tilemap.tileWidth * tilemapLayer.scaleX);
                var tileH = Math.floor(tilemap.tileHeight * tilemapLayer.scaleY);
                var boundsLeft = SnapFloor(camera.worldView.x - tilemapLayer.x, tileW, 0, true) - tilemapLayer.cullPaddingX;
                var boundsRight = SnapCeil(camera.worldView.right - tilemapLayer.x, tileW, 0, true) + tilemapLayer.cullPaddingX;
                var boundsTop = SnapFloor(camera.worldView.y - tilemapLayer.y, tileH / 2, 0, true) - tilemapLayer.cullPaddingY;
                var boundsBottom = SnapCeil(camera.worldView.bottom - tilemapLayer.y, tileH / 2, 0, true) + tilemapLayer.cullPaddingY;
                return {
                    left: boundsLeft,
                    right: boundsRight,
                    top: boundsTop,
                    bottom: boundsBottom
                };
            };
            module1.exports = StaggeredCullBounds;
        /***/ },
        /* 546 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from hexagonal tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var HexagonalTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                // similar to staggered, because Tiled uses the oddr representation.
                var x = layerWorldX + tileX * tileWidth + tileY % 2 * (tileWidth / 2);
                var y = layerWorldY + tileY * rowHeight;
                return point.set(x, y);
            };
            module1.exports = HexagonalTileToWorldXY;
        /***/ },
        /* 547 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from isometric tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var IsometricTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var x = layerWorldX + (tileX - tileY) * (tileWidth / 2);
                var y = layerWorldY + (tileX + tileY) * (tileHeight / 2);
                return point.set(x, y);
            };
            module1.exports = IsometricTileToWorldXY;
        /***/ },
        /* 548 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from staggered tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldXY
 * @since 3.50.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var StaggeredTileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldX = 0;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
                    tileWidth *= tilemapLayer.scaleX;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var x = layerWorldX + tileX * tileWidth + tileY % 2 * (tileWidth / 2);
                var y = layerWorldY + tileY * (tileHeight / 2);
                return point.set(x, y);
            };
            module1.exports = StaggeredTileToWorldXY;
        /***/ },
        /* 549 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileToWorldX = __webpack_require__(249);
            var TileToWorldY = __webpack_require__(250);
            var Vector2 = __webpack_require__(3);
            /**
 * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.TileToWorldXY
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
 */ var TileToWorldXY = function(tileX, tileY, point, camera, layer) {
                if (!point) point = new Vector2(0, 0);
                point.x = TileToWorldX(tileX, camera, layer);
                point.y = TileToWorldY(tileY, camera, layer);
                return point;
            };
            module1.exports = TileToWorldXY;
        /***/ },
        /* 550 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from hexagonal tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layer's position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.HexagonalTileToWorldY
 * @since 3.50.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var HexagonalTileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (camera === undefined) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = tilemapLayer.tilemap.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                return layerWorldY + tileY * rowHeight;
            };
            module1.exports = HexagonalTileToWorldY;
        /***/ },
        /* 551 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from staggered tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredTileToWorldY
 * @since 3.50.0
 *
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in world coordinates.
 */ var StaggeredTileToWorldY = function(tileY, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                var layerWorldY = 0;
                if (tilemapLayer) {
                    if (camera === undefined) camera = tilemapLayer.scene.cameras.main;
                    layerWorldY = tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY);
                    tileHeight *= tilemapLayer.scaleY;
                }
                return layerWorldY + tileY * (tileHeight / 2);
            };
            module1.exports = StaggeredTileToWorldY;
        /***/ },
        /* 552 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to hexagonal tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.HexagonalWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinates down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var HexagonalWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                // similar to staggered, because Tiled uses the oddr representation.
                var y = snapToFloor ? Math.floor(worldY / rowHeight) : worldY / rowHeight;
                var x = snapToFloor ? Math.floor((worldX - y % 2 * 0.5 * tileWidth) / tileWidth) : (worldX - y % 2 * 0.5 * tileWidth) / tileWidth;
                return point.set(x, y);
            };
            module1.exports = HexagonalWorldToTileXY;
        /***/ },
        /* 553 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to isometric tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.IsometricWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var IsometricWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                worldX -= tileWidth / 2;
                var x = snapToFloor ? Math.floor((worldX / (tileWidth / 2) + worldY / (tileHeight / 2)) / 2) : (worldX / (tileWidth / 2) + worldY / (tileHeight / 2)) / 2;
                var y = snapToFloor ? Math.floor((worldY / (tileHeight / 2) - worldX / (tileWidth / 2)) / 2) : (worldY / (tileHeight / 2) - worldX / (tileWidth / 2)) / 2;
                return point.set(x, y);
            };
            module1.exports = IsometricWorldToTileXY;
        /***/ },
        /* 554 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to staggered tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileXY
 * @since 3.50.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var StaggeredWorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (!point) point = new Vector2();
                var tileWidth = layer.baseTileWidth;
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                    // Find the world position relative to the static or dynamic layer's top left origin,
                    // factoring in the camera's horizontal scroll
                    worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
                    tileWidth *= tilemapLayer.scaleX;
                }
                var y = snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
                var x = snapToFloor ? Math.floor((worldX + y % 2 * 0.5 * tileWidth) / tileWidth) : (worldX + y % 2 * 0.5 * tileWidth) / tileWidth;
                return point.set(x, y);
            };
            module1.exports = StaggeredWorldToTileXY;
        /***/ },
        /* 555 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WorldToTileX = __webpack_require__(251);
            var WorldToTileY = __webpack_require__(252);
            var Vector2 = __webpack_require__(3);
            /**
 * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
 * `point` object.
 *
 * @function Phaser.Tilemaps.Components.WorldToTileXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Math.Vector2} point - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Math.Vector2} The XY location in tile units.
 */ var WorldToTileXY = function(worldX, worldY, snapToFloor, point, camera, layer) {
                if (snapToFloor === undefined) snapToFloor = true;
                if (!point) point = new Vector2(0, 0);
                point.x = WorldToTileX(worldX, snapToFloor, camera, layer);
                point.y = WorldToTileY(worldY, snapToFloor, camera, layer);
                return point;
            };
            module1.exports = WorldToTileXY;
        /***/ },
        /* 556 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to hexagonal tile Y coordinates (tile units), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.HexagonalWorldToTileY
 * @since 3.50.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var HexagonalWorldToTileY = function(worldY, snapToFloor, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    //  Find the world position relative to the static or dynamic layer's top left origin,
                    //  factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                var len = layer.hexSideLength;
                var rowHeight = (tileHeight - len) / 2 + len;
                return snapToFloor ? Math.floor(worldY / rowHeight) : worldY / rowHeight;
            };
            module1.exports = HexagonalWorldToTileY;
        /***/ },
        /* 557 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts from world Y coordinates (pixels) to staggered tile Y coordinates (tile units), factoring in the
 * layers position, scale and scroll.
 *
 * @function Phaser.Tilemaps.Components.StaggeredWorldToTileY
 * @since 3.50.0
 *
 * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
 * @param {boolean} snapToFloor - Whether or not to round the tile coordinate down to the nearest integer.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {number} The Y location in tile units.
 */ var StaggeredWorldToTileY = function(worldY, snapToFloor, camera, layer) {
                var tileHeight = layer.baseTileHeight;
                var tilemapLayer = layer.tilemapLayer;
                if (tilemapLayer) {
                    if (!camera) camera = tilemapLayer.scene.cameras.main;
                    //  Find the world position relative to the static or dynamic layer's top left origin,
                    //  factoring in the camera's vertical scroll
                    worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
                    tileHeight *= tilemapLayer.scaleY;
                }
                return snapToFloor ? Math.floor(worldY / (tileHeight / 2)) : worldY / (tileHeight / 2);
            };
            module1.exports = StaggeredWorldToTileY;
        /***/ },
        /* 558 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var IsInLayerBounds = __webpack_require__(118);
            /**
 * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
 * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAt = function(tileX, tileY, layer) {
                if (IsInLayerBounds(tileX, tileY, layer)) {
                    var tile = layer.data[tileY][tileX];
                    return tile !== null && tile.index > -1;
                } else return false;
            };
            module1.exports = HasTileAt;
        /***/ },
        /* 559 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tile = __webpack_require__(83);
            var IsInLayerBounds = __webpack_require__(118);
            var CalculateFacesAt = __webpack_require__(248);
            /**
 * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAt
 * @since 3.0.0
 *
 * @param {number} tileX - The x coordinate.
 * @param {number} tileY - The y coordinate.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAt = function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                if (replaceWithNull === undefined) replaceWithNull = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!IsInLayerBounds(tileX, tileY, layer)) return null;
                var tile = layer.data[tileY][tileX];
                if (!tile) return null;
                else layer.data[tileY][tileX] = replaceWithNull ? null : new Tile(layer, -1, tileX, tileY, layer.tileWidth, layer.tileHeight);
                //  Recalculate faces only if the removed tile was a colliding tile
                if (recalculateFaces && tile && tile.collides) CalculateFacesAt(tileX, tileY, layer);
                return tile;
            };
            module1.exports = RemoveTileAt;
        /***/ },
        /* 560 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(39);
            var Parse2DArray = __webpack_require__(255);
            var ParseCSV = __webpack_require__(561);
            var ParseJSONTiled = __webpack_require__(562);
            var ParseWeltmeister = __webpack_require__(573);
            /**
 * Parses raw data of a given Tilemap format into a new MapData object. If no recognized data format
 * is found, returns `null`. When loading from CSV or a 2D array, you should specify the tileWidth &
 * tileHeight. When parsing from a map from Tiled, the tileWidth & tileHeight will be pulled from
 * the map data.
 *
 * @function Phaser.Tilemaps.Parsers.Parse
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {number} mapFormat - See ../Formats.js.
 * @param {(number[][]|string|object)} data - 2D array, CSV string or Tiled JSON object.
 * @param {number} tileWidth - The width of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {number} tileHeight - The height of a tile in pixels. Required for 2D array and CSV, but
 * ignored for Tiled JSON.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The created `MapData` object.
 */ var Parse = function(name, mapFormat, data, tileWidth, tileHeight, insertNull) {
                var newMap;
                switch(mapFormat){
                    case Formats.ARRAY_2D:
                        newMap = Parse2DArray(name, data, tileWidth, tileHeight, insertNull);
                        break;
                    case Formats.CSV:
                        newMap = ParseCSV(name, data, tileWidth, tileHeight, insertNull);
                        break;
                    case Formats.TILED_JSON:
                        newMap = ParseJSONTiled(name, data, insertNull);
                        break;
                    case Formats.WELTMEISTER:
                        newMap = ParseWeltmeister(name, data, insertNull);
                        break;
                    default:
                        console.warn('Unrecognized tilemap data format: ' + mapFormat);
                        newMap = null;
                }
                return newMap;
            };
            module1.exports = Parse;
        /***/ },
        /* 561 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(39);
            var Parse2DArray = __webpack_require__(255);
            /**
 * Parses a CSV string of tile indexes into a new MapData object with a single layer.
 *
 * @function Phaser.Tilemaps.Parsers.ParseCSV
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {string} data - CSV string of tile indexes.
 * @param {number} tileWidth - The width of a tile in pixels.
 * @param {number} tileHeight - The height of a tile in pixels.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {Phaser.Tilemaps.MapData} The resulting MapData object.
 */ var ParseCSV = function(name, data, tileWidth, tileHeight, insertNull) {
                var array2D = data.trim().split('\n').map(function(row) {
                    return row.split(',');
                });
                var map = Parse2DArray(name, array2D, tileWidth, tileHeight, insertNull);
                map.format = Formats.CSV;
                return map;
            };
            module1.exports = ParseCSV;
        /***/ },
        /* 562 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AssignTileProperties = __webpack_require__(563);
            var BuildTilesetIndex = __webpack_require__(564);
            var CONST = __webpack_require__(29);
            var Formats = __webpack_require__(39);
            var FromOrientationString = __webpack_require__(254);
            var MapData = __webpack_require__(120);
            var ParseImageLayers = __webpack_require__(565);
            var ParseObjectLayers = __webpack_require__(566);
            var ParseTileLayers = __webpack_require__(569);
            var ParseTilesets = __webpack_require__(571);
            /**
 * Parses a Tiled JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} json - The Tiled JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseJSONTiled = function(name, json, insertNull) {
                //  Map data will consist of: layers, objects, images, tilesets, sizes
                var mapData = new MapData({
                    width: json.width,
                    height: json.height,
                    name: name,
                    tileWidth: json.tilewidth,
                    tileHeight: json.tileheight,
                    orientation: FromOrientationString(json.orientation),
                    format: Formats.TILED_JSON,
                    version: json.version,
                    properties: json.properties,
                    renderOrder: json.renderorder,
                    infinite: json.infinite
                });
                if (mapData.orientation === CONST.HEXAGONAL) mapData.hexSideLength = json.hexsidelength;
                mapData.layers = ParseTileLayers(json, insertNull);
                mapData.images = ParseImageLayers(json);
                var sets = ParseTilesets(json);
                mapData.tilesets = sets.tilesets;
                mapData.imageCollections = sets.imageCollections;
                mapData.objects = ParseObjectLayers(json);
                mapData.tiles = BuildTilesetIndex(mapData);
                AssignTileProperties(mapData);
                return mapData;
            };
            module1.exports = ParseJSONTiled;
        /***/ },
        /* 563 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            /**
 * Copy properties from tileset to tiles.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.AssignTileProperties
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.MapData} mapData - The Map Data object.
 */ var AssignTileProperties = function(mapData) {
                var layerData;
                var tile;
                var sid;
                var set;
                var row;
                // go through each of the map data layers
                for(var i = 0; i < mapData.layers.length; i++){
                    layerData = mapData.layers[i];
                    set = null;
                    // rows of tiles
                    for(var j = 0; j < layerData.data.length; j++){
                        row = layerData.data[j];
                        // individual tiles
                        for(var k = 0; k < row.length; k++){
                            tile = row[k];
                            if (tile === null || tile.index < 0) continue;
                            // find the relevant tileset
                            sid = mapData.tiles[tile.index][2];
                            set = mapData.tilesets[sid];
                            // Ensure that a tile's size matches its tileset
                            tile.width = set.tileWidth;
                            tile.height = set.tileHeight;
                            // if that tile type has any properties, add them to the tile object
                            if (set.tileProperties && set.tileProperties[tile.index - set.firstgid]) tile.properties = Extend(tile.properties, set.tileProperties[tile.index - set.firstgid]);
                        }
                    }
                }
            };
            module1.exports = AssignTileProperties;
        /***/ },
        /* 564 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(121);
            /**
 * Master list of tiles -> x, y, index in tileset.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.BuildTilesetIndex
 * @since 3.0.0
 *
 * @param {Phaser.Tilemaps.MapData} mapData - The Map Data object.
 *
 * @return {array} An array of Tileset objects.
 */ var BuildTilesetIndex = function(mapData) {
                var i;
                var set;
                var tiles = [];
                for(i = 0; i < mapData.imageCollections.length; i++){
                    var collection = mapData.imageCollections[i];
                    var images = collection.images;
                    for(var j = 0; j < images.length; j++){
                        var image = images[j];
                        set = new Tileset(image.image, image.gid, collection.imageWidth, collection.imageHeight, 0, 0);
                        set.updateTileData(collection.imageWidth, collection.imageHeight);
                        mapData.tilesets.push(set);
                    }
                }
                for(i = 0; i < mapData.tilesets.length; i++){
                    set = mapData.tilesets[i];
                    var x = set.tileMargin;
                    var y = set.tileMargin;
                    var count = 0;
                    var countX = 0;
                    var countY = 0;
                    for(var t = set.firstgid; t < set.firstgid + set.total; t++){
                        //  Can add extra properties here as needed
                        tiles[t] = [
                            x,
                            y,
                            i
                        ];
                        x += set.tileWidth + set.tileSpacing;
                        count++;
                        if (count === set.total) break;
                        countX++;
                        if (countX === set.columns) {
                            x = set.tileMargin;
                            y += set.tileHeight + set.tileSpacing;
                            countX = 0;
                            countY++;
                            if (countY === set.rows) break;
                        }
                    }
                }
                return tiles;
            };
            module1.exports = BuildTilesetIndex;
        /***/ },
        /* 565 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var CreateGroupLayer = __webpack_require__(159);
            /**
 * Parses a Tiled JSON object into an array of objects with details about the image layers.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseImageLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} Array of objects that include critical info about the map's image layers
 */ var ParseImageLayers = function(json) {
                var images = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    // Get current layer and advance iterator
                    var curi = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    if (curi.type !== 'imagelayer') {
                        if (curi.type === 'group') {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curi, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    var layerOffsetX = GetFastValue(curi, 'offsetx', 0) + GetFastValue(curi, 'startx', 0);
                    var layerOffsetY = GetFastValue(curi, 'offsety', 0) + GetFastValue(curi, 'starty', 0);
                    images.push({
                        name: curGroupState.name + curi.name,
                        image: curi.image,
                        x: curGroupState.x + layerOffsetX + curi.x,
                        y: curGroupState.y + layerOffsetY + curi.y,
                        alpha: curGroupState.opacity * curi.opacity,
                        visible: curGroupState.visible && curi.visible,
                        properties: GetFastValue(curi, 'properties', {})
                    });
                }
                return images;
            };
            module1.exports = ParseImageLayers;
        /***/ },
        /* 566 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            var ParseObject = __webpack_require__(256);
            var ObjectLayer = __webpack_require__(568);
            var CreateGroupLayer = __webpack_require__(159);
            /**
 * Parses a Tiled JSON object into an array of ObjectLayer objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObjectLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 *
 * @return {array} An array of all object layers in the tilemap as `ObjectLayer`s.
 */ var ParseObjectLayers = function(json) {
                var objectLayers = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    // Get current layer and advance iterator
                    var curo = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    // Modify inherited properties
                    curo.opacity *= curGroupState.opacity;
                    curo.visible = curGroupState.visible && curo.visible;
                    if (curo.type !== 'objectgroup') {
                        if (curo.type === 'group') {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curo, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    curo.name = curGroupState.name + curo.name;
                    var offsetX = curGroupState.x + GetFastValue(curo, 'startx', 0) + GetFastValue(curo, 'offsetx', 0);
                    var offsetY = curGroupState.y + GetFastValue(curo, 'starty', 0) + GetFastValue(curo, 'offsety', 0);
                    var objects = [];
                    for(var j = 0; j < curo.objects.length; j++){
                        var parsedObject = ParseObject(curo.objects[j], offsetX, offsetY);
                        objects.push(parsedObject);
                    }
                    var objectLayer = new ObjectLayer(curo);
                    objectLayer.objects = objects;
                    objectLayers.push(objectLayer);
                }
                return objectLayers;
            };
            module1.exports = ParseObjectLayers;
        /***/ },
        /* 567 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasValue = __webpack_require__(125);
            /**
 * Returns a new object that only contains the `keys` that were found on the object provided.
 * If no `keys` are found, an empty object is returned.
 *
 * @function Phaser.Utils.Objects.Pick
 * @since 3.18.0
 *
 * @param {object} object - The object to pick the provided keys from.
 * @param {array} keys - An array of properties to retrieve from the provided object.
 *
 * @return {object} A new object that only contains the `keys` that were found on the provided object. If no `keys` were found, an empty object will be returned.
 */ var Pick = function(object, keys) {
                var obj = {};
                for(var i = 0; i < keys.length; i++){
                    var key = keys[i];
                    if (HasValue(object, key)) obj[key] = object[key];
                }
                return obj;
            };
            module1.exports = Pick;
        /***/ },
        /* 568 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A class for representing a Tiled object layer in a map. This mirrors the structure of a Tiled
 * object layer, except:
 *  - "x" & "y" properties are ignored since these cannot be changed in Tiled.
 *  - "offsetx" & "offsety" are applied to the individual object coordinates directly, so they
 *    are ignored as well.
 *  - "draworder" is ignored.
 *
 * @class ObjectLayer
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tilemaps.ObjectLayerConfig} [config] - The data for the layer from the Tiled JSON object.
 */ var ObjectLayer = new Class({
                initialize: function ObjectLayer(config) {
                    if (config === undefined) config = {};
                    /**
         * The name of the Object Layer.
         *
         * @name Phaser.Tilemaps.ObjectLayer#name
         * @type {string}
         * @since 3.0.0
         */ this.name = GetFastValue(config, 'name', 'object layer');
                    /**
         * The opacity of the layer, between 0 and 1.
         *
         * @name Phaser.Tilemaps.ObjectLayer#opacity
         * @type {number}
         * @since 3.0.0
         */ this.opacity = GetFastValue(config, 'opacity', 1);
                    /**
         * The custom properties defined on the Object Layer, keyed by their name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = GetFastValue(config, 'properties', {});
                    /**
         * The type of each custom property defined on the Object Layer, keyed by its name.
         *
         * @name Phaser.Tilemaps.ObjectLayer#propertyTypes
         * @type {object}
         * @since 3.0.0
         */ this.propertyTypes = GetFastValue(config, 'propertytypes', {});
                    /**
         * The type of the layer, which should be `objectgroup`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#type
         * @type {string}
         * @since 3.0.0
         */ this.type = GetFastValue(config, 'type', 'objectgroup');
                    /**
         * Whether the layer is shown (`true`) or hidden (`false`).
         *
         * @name Phaser.Tilemaps.ObjectLayer#visible
         * @type {boolean}
         * @since 3.0.0
         */ this.visible = GetFastValue(config, 'visible', true);
                    /**
         * An array of all objects on this Object Layer.
         *
         * Each Tiled object corresponds to a JavaScript object in this array. It has an `id` (unique),
         * `name` (as assigned in Tiled), `type` (as assigned in Tiled), `rotation` (in clockwise degrees),
         * `properties` (if any), `visible` state (`true` if visible, `false` otherwise),
         * `x` and `y` coordinates (in pixels, relative to the tilemap), and a `width` and `height` (in pixels).
         *
         * An object tile has a `gid` property (GID of the represented tile), a `flippedHorizontal` property,
         * a `flippedVertical` property, and `flippedAntiDiagonal` property.
         * The {@link http://docs.mapeditor.org/en/latest/reference/tmx-map-format/|Tiled documentation} contains
         * information on flipping and rotation.
         *
         * Polylines have a `polyline` property, which is an array of objects corresponding to points,
         * where each point has an `x` property and a `y` property. Polygons have an identically structured
         * array in their `polygon` property. Text objects have a `text` property with the text's properties.
         *
         * Rectangles and ellipses have a `rectangle` or `ellipse` property set to `true`.
         *
         * @name Phaser.Tilemaps.ObjectLayer#objects
         * @type {Phaser.Types.Tilemaps.TiledObject[]}
         * @since 3.0.0
         */ this.objects = GetFastValue(config, 'objects', []);
                }
            });
            module1.exports = ObjectLayer;
        /***/ },
        /* 569 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Base64Decode = __webpack_require__(570);
            var CONST = __webpack_require__(29);
            var CreateGroupLayer = __webpack_require__(159);
            var FromOrientationString = __webpack_require__(254);
            var GetFastValue = __webpack_require__(2);
            var LayerData = __webpack_require__(119);
            var ParseGID = __webpack_require__(257);
            var Tile = __webpack_require__(83);
            /**
 * Parses all tilemap layers in a Tiled JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                var infiniteMap = GetFastValue(json, 'infinite', false);
                var tileLayers = [];
                // State inherited from a parent group
                var groupStack = [];
                var curGroupState = CreateGroupLayer(json);
                while(curGroupState.i < curGroupState.layers.length || groupStack.length > 0){
                    if (curGroupState.i >= curGroupState.layers.length) {
                        // Ensure recursion stack is not empty first
                        if (groupStack.length < 1) {
                            console.warn('TilemapParser.parseTiledJSON - Invalid layer group hierarchy');
                            break;
                        }
                        // Return to previous recursive state
                        curGroupState = groupStack.pop();
                        continue;
                    }
                    var curl = curGroupState.layers[curGroupState.i];
                    curGroupState.i++;
                    if (curl.type !== 'tilelayer') {
                        if (curl.type === 'group') {
                            // Compute next state inherited from group
                            var nextGroupState = CreateGroupLayer(json, curl, curGroupState);
                            // Preserve current state before recursing
                            groupStack.push(curGroupState);
                            curGroupState = nextGroupState;
                        }
                        continue;
                    }
                    // Base64 decode data if necessary. NOTE: uncompressed base64 only.
                    if (curl.compression) {
                        console.warn('TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer \'' + curl.name + '\'');
                        continue;
                    } else if (curl.encoding && curl.encoding === 'base64') {
                        // Chunks for an infinite map
                        if (curl.chunks) for(var i = 0; i < curl.chunks.length; i++)curl.chunks[i].data = Base64Decode(curl.chunks[i].data);
                        // Non-infinite map data
                        if (curl.data) curl.data = Base64Decode(curl.data);
                        delete curl.encoding; // Allow the same map to be parsed multiple times
                    }
                    //  This is an array containing the tile indexes, one after the other. -1 = no tile,
                    //  everything else = the tile index (starting at 1 for Tiled, 0 for CSV) If the map
                    //  contains multiple tilesets then the indexes are relative to that which the set starts
                    //  from. Need to set which tileset in the cache = which tileset in the JSON, if you do this
                    //  manually it means you can use the same map data but a new tileset.
                    var layerData;
                    var gidInfo;
                    var tile;
                    var blankTile;
                    var output = [];
                    var x = 0;
                    if (infiniteMap) {
                        var layerOffsetX = GetFastValue(curl, 'startx', 0) + curl.x;
                        var layerOffsetY = GetFastValue(curl, 'starty', 0) + curl.y;
                        layerData = new LayerData({
                            name: curGroupState.name + curl.name,
                            x: curGroupState.x + GetFastValue(curl, 'offsetx', 0) + layerOffsetX * json.tilewidth,
                            y: curGroupState.y + GetFastValue(curl, 'offsety', 0) + layerOffsetY * json.tileheight,
                            width: curl.width,
                            height: curl.height,
                            tileWidth: json.tilewidth,
                            tileHeight: json.tileheight,
                            alpha: curGroupState.opacity * curl.opacity,
                            visible: curGroupState.visible && curl.visible,
                            properties: GetFastValue(curl, 'properties', []),
                            orientation: FromOrientationString(json.orientation)
                        });
                        if (layerData.orientation === CONST.HEXAGONAL) layerData.hexSideLength = json.hexsidelength;
                        for(var c = 0; c < curl.height; c++){
                            output.push([
                                null
                            ]);
                            for(var j = 0; j < curl.width; j++)output[c][j] = null;
                        }
                        for(c = 0, len = curl.chunks.length; c < len; c++){
                            var chunk = curl.chunks[c];
                            var offsetX = chunk.x - layerOffsetX;
                            var offsetY = chunk.y - layerOffsetY;
                            var y = 0;
                            for(var t = 0, len2 = chunk.data.length; t < len2; t++){
                                var newOffsetX = x + offsetX;
                                var newOffsetY = y + offsetY;
                                gidInfo = ParseGID(chunk.data[t]);
                                //  index, x, y, width, height
                                if (gidInfo.gid > 0) {
                                    tile = new Tile(layerData, gidInfo.gid, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                    // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                    // propeties into flipX, flipY and rotation
                                    tile.rotation = gidInfo.rotation;
                                    tile.flipX = gidInfo.flipped;
                                    output[newOffsetY][newOffsetX] = tile;
                                } else {
                                    blankTile = insertNull ? null : new Tile(layerData, -1, newOffsetX, newOffsetY, json.tilewidth, json.tileheight);
                                    output[newOffsetY][newOffsetX] = blankTile;
                                }
                                x++;
                                if (x === chunk.width) {
                                    y++;
                                    x = 0;
                                }
                            }
                        }
                    } else {
                        layerData = new LayerData({
                            name: curGroupState.name + curl.name,
                            x: curGroupState.x + GetFastValue(curl, 'offsetx', 0) + curl.x,
                            y: curGroupState.y + GetFastValue(curl, 'offsety', 0) + curl.y,
                            width: curl.width,
                            height: curl.height,
                            tileWidth: json.tilewidth,
                            tileHeight: json.tileheight,
                            alpha: curGroupState.opacity * curl.opacity,
                            visible: curGroupState.visible && curl.visible,
                            properties: GetFastValue(curl, 'properties', []),
                            orientation: FromOrientationString(json.orientation)
                        });
                        if (layerData.orientation === CONST.HEXAGONAL) layerData.hexSideLength = json.hexsidelength;
                        var row = [];
                        //  Loop through the data field in the JSON.
                        for(var k = 0, len = curl.data.length; k < len; k++){
                            gidInfo = ParseGID(curl.data[k]);
                            //  index, x, y, width, height
                            if (gidInfo.gid > 0) {
                                tile = new Tile(layerData, gidInfo.gid, x, output.length, json.tilewidth, json.tileheight);
                                // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
                                // propeties into flipX, flipY and rotation
                                tile.rotation = gidInfo.rotation;
                                tile.flipX = gidInfo.flipped;
                                row.push(tile);
                            } else {
                                blankTile = insertNull ? null : new Tile(layerData, -1, x, output.length, json.tilewidth, json.tileheight);
                                row.push(blankTile);
                            }
                            x++;
                            if (x === curl.width) {
                                output.push(row);
                                x = 0;
                                row = [];
                            }
                        }
                    }
                    layerData.data = output;
                    tileLayers.push(layerData);
                }
                return tileLayers;
            };
            module1.exports = ParseTileLayers;
        /***/ },
        /* 570 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Decode base-64 encoded data, for example as exported by Tiled.
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.Base64Decode
 * @since 3.0.0
 *
 * @param {object} data - Base-64 encoded data to decode.
 *
 * @return {array} Array containing the decoded bytes.
 */ var Base64Decode = function(data) {
                var binaryString = window.atob(data);
                var len = binaryString.length;
                var bytes = new Array(len / 4);
                // Interpret binaryString as an array of bytes representing little-endian encoded uint32 values.
                for(var i = 0; i < len; i += 4)bytes[i / 4] = (binaryString.charCodeAt(i) | binaryString.charCodeAt(i + 1) << 8 | binaryString.charCodeAt(i + 2) << 16 | binaryString.charCodeAt(i + 3) << 24) >>> 0;
                return bytes;
            };
            module1.exports = Base64Decode;
        /***/ },
        /* 571 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(121);
            var ImageCollection = __webpack_require__(572);
            var ParseObject = __webpack_require__(256);
            /**
 * Tilesets and Image Collections
 *
 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Tiled JSON data.
 *
 * @return {object} An object containing the tileset and image collection data.
 */ var ParseTilesets = function(json) {
                var tilesets = [];
                var imageCollections = [];
                var lastSet = null;
                var stringID;
                for(var i = 0; i < json.tilesets.length; i++){
                    //  name, firstgid, width, height, margin, spacing, properties
                    var set = json.tilesets[i];
                    if (set.source) console.warn('External tilesets unsupported. Use Embed Tileset and re-export');
                    else if (set.image) {
                        var newSet = new Tileset(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing);
                        if (json.version > 1) // Tiled 1.2+
                        {
                            if (Array.isArray(set.tiles)) {
                                var tiles = {};
                                var props = {};
                                for(var t = 0; t < set.tiles.length; t++){
                                    var tile = set.tiles[t];
                                    //  Convert tileproperties
                                    if (tile.properties) {
                                        var newPropData = {};
                                        tile.properties.forEach(function(propData) {
                                            newPropData[propData['name']] = propData['value'];
                                        });
                                        props[tile.id] = newPropData;
                                    }
                                    //  Convert objectgroup
                                    if (tile.objectgroup) {
                                        tiles[tile.id] = {
                                            objectgroup: tile.objectgroup
                                        };
                                        if (tile.objectgroup.objects) {
                                            var parsedObjects2 = tile.objectgroup.objects.map(function(obj) {
                                                return ParseObject(obj);
                                            });
                                            tiles[tile.id].objectgroup.objects = parsedObjects2;
                                        }
                                    }
                                    // Copy animation data
                                    if (tile.animation) {
                                        if (tiles.hasOwnProperty(tile.id)) tiles[tile.id].animation = tile.animation;
                                        else tiles[tile.id] = {
                                            animation: tile.animation
                                        };
                                    }
                                }
                                newSet.tileData = tiles;
                                newSet.tileProperties = props;
                            }
                        } else {
                            // Tiled 1
                            // Properties stored per-tile in object with string indexes starting at "0"
                            if (set.tileproperties) newSet.tileProperties = set.tileproperties;
                            // Object & terrain shapes stored per-tile in object with string indexes starting at "0"
                            if (set.tiles) {
                                newSet.tileData = set.tiles;
                                // Parse the objects into Phaser format to match handling of other Tiled objects
                                for(stringID in newSet.tileData){
                                    var objectGroup = newSet.tileData[stringID].objectgroup;
                                    if (objectGroup && objectGroup.objects) {
                                        var parsedObjects1 = objectGroup.objects.map(function(obj) {
                                            return ParseObject(obj);
                                        });
                                        newSet.tileData[stringID].objectgroup.objects = parsedObjects1;
                                    }
                                }
                            }
                        }
                        // For a normal sliced tileset the row/count/size information is computed when updated.
                        // This is done (again) after the image is set.
                        newSet.updateTileData(set.imagewidth, set.imageheight);
                        tilesets.push(newSet);
                    } else {
                        var newCollection = new ImageCollection(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing, set.properties);
                        var maxId = 0;
                        for(t = 0; t < set.tiles.length; t++){
                            tile = set.tiles[t];
                            var image = tile.image;
                            var tileId = parseInt(tile.id, 10);
                            var gid = set.firstgid + tileId;
                            newCollection.addImage(gid, image);
                            maxId = Math.max(tileId, maxId);
                        }
                        newCollection.maxId = maxId;
                        imageCollections.push(newCollection);
                    }
                    //  We've got a new Tileset, so set the lastgid into the previous one
                    if (lastSet) lastSet.lastgid = set.firstgid - 1;
                    lastSet = set;
                }
                return {
                    tilesets: tilesets,
                    imageCollections: imageCollections
                };
            };
            module1.exports = ParseTilesets;
        /***/ },
        /* 572 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * An Image Collection is a special Tile Set containing multiple images, with no slicing into each image.
 *
 * Image Collections are normally created automatically when Tiled data is loaded.
 *
 * @class ImageCollection
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 * 
 * @param {string} name - The name of the image collection in the map data.
 * @param {number} firstgid - The first image index this image collection contains.
 * @param {number} [width=32] - Width of widest image (in pixels).
 * @param {number} [height=32] - Height of tallest image (in pixels).
 * @param {number} [margin=0] - The margin around all images in the collection (in pixels).
 * @param {number} [spacing=0] - The spacing between each image in the collection (in pixels).
 * @param {object} [properties={}] - Custom Image Collection properties.
 */ var ImageCollection = new Class({
                initialize: function ImageCollection(name, firstgid, width, height, margin, spacing, properties) {
                    if (width === undefined || width <= 0) width = 32;
                    if (height === undefined || height <= 0) height = 32;
                    if (margin === undefined) margin = 0;
                    if (spacing === undefined) spacing = 0;
                    /**
         * The name of the Image Collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#name
         * @type {string}
         * @since 3.0.0
        */ this.name = name;
                    /**
         * The Tiled firstgid value.
         * This is the starting index of the first image index this Image Collection contains.
         * 
         * @name Phaser.Tilemaps.ImageCollection#firstgid
         * @type {number}
         * @since 3.0.0
         */ this.firstgid = firstgid | 0;
                    /**
         * The width of the widest image (in pixels).
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageWidth
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageWidth = width | 0;
                    /**
         * The height of the tallest image (in pixels).
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageHeight
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageHeight = height | 0;
                    /**
         * The margin around the images in the collection (in pixels).
         * Use `setSpacing` to change.
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageMarge
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageMargin = margin | 0;
                    /**
         * The spacing between each image in the collection (in pixels).
         * Use `setSpacing` to change.
         * 
         * @name Phaser.Tilemaps.ImageCollection#imageSpacing
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.imageSpacing = spacing | 0;
                    /**
         * Image Collection-specific properties that are typically defined in the Tiled editor.
         * 
         * @name Phaser.Tilemaps.ImageCollection#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = properties || {};
                    /**
         * The cached images that are a part of this collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#images
         * @type {array}
         * @readonly
         * @since 3.0.0
         */ this.images = [];
                    /**
         * The total number of images in the image collection.
         * 
         * @name Phaser.Tilemaps.ImageCollection#total
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.total = 0;
                },
                /**
     * Returns true if and only if this image collection contains the given image index.
     *
     * @method Phaser.Tilemaps.ImageCollection#containsImageIndex
     * @since 3.0.0
     * 
     * @param {number} imageIndex - The image index to search for.
     * 
     * @return {boolean} True if this Image Collection contains the given index.
     */ containsImageIndex: function(imageIndex) {
                    return imageIndex >= this.firstgid && imageIndex < this.firstgid + this.total;
                },
                /**
     * Add an image to this Image Collection.
     *
     * @method Phaser.Tilemaps.ImageCollection#addImage
     * @since 3.0.0
     * 
     * @param {number} gid - The gid of the image in the Image Collection.
     * @param {string} image - The the key of the image in the Image Collection and in the cache.
     *
     * @return {Phaser.Tilemaps.ImageCollection} This ImageCollection object.
     */ addImage: function(gid, image) {
                    this.images.push({
                        gid: gid,
                        image: image
                    });
                    this.total++;
                    return this;
                }
            });
            module1.exports = ImageCollection;
        /***/ },
        /* 573 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Formats = __webpack_require__(39);
            var MapData = __webpack_require__(120);
            var ParseTileLayers = __webpack_require__(574);
            var ParseTilesets = __webpack_require__(575);
            /**
 * Parses a Weltmeister JSON object into a new MapData object.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseWeltmeister
 * @since 3.0.0
 *
 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
 * @param {object} json - The Weltmeister JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 *
 * @return {?Phaser.Tilemaps.MapData} The created MapData object, or `null` if the data can't be parsed.
 */ var ParseWeltmeister = function(name, json, insertNull) {
                if (json.layer.length === 0) {
                    console.warn('No layers found in the Weltmeister map: ' + name);
                    return null;
                }
                var width = 0;
                var height = 0;
                for(var i = 0; i < json.layer.length; i++){
                    if (json.layer[i].width > width) width = json.layer[i].width;
                    if (json.layer[i].height > height) height = json.layer[i].height;
                }
                var mapData = new MapData({
                    width: width,
                    height: height,
                    name: name,
                    tileWidth: json.layer[0].tilesize,
                    tileHeight: json.layer[0].tilesize,
                    format: Formats.WELTMEISTER
                });
                mapData.layers = ParseTileLayers(json, insertNull);
                mapData.tilesets = ParseTilesets(json);
                return mapData;
            };
            module1.exports = ParseWeltmeister;
        /***/ },
        /* 574 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LayerData = __webpack_require__(119);
            var Tile = __webpack_require__(83);
            /**
 * Parses all tilemap layers in an Impact JSON object into new LayerData objects.
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTileLayers
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON object.
 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
 * data are handled (see {@link Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled}).
 *
 * @return {Phaser.Tilemaps.LayerData[]} - An array of LayerData objects, one for each entry in
 * json.layers with the type 'tilelayer'.
 */ var ParseTileLayers = function(json, insertNull) {
                var tileLayers = [];
                for(var i = 0; i < json.layer.length; i++){
                    var layer = json.layer[i];
                    var layerData = new LayerData({
                        name: layer.name,
                        width: layer.width,
                        height: layer.height,
                        tileWidth: layer.tilesize,
                        tileHeight: layer.tilesize,
                        visible: layer.visible === 1
                    });
                    var row = [];
                    var tileGrid = [];
                    //  Loop through the data field in the JSON. This is a 2D array containing the tile indexes,
                    //  one after the other. The indexes are relative to the tileset that contains the tile.
                    for(var y = 0; y < layer.data.length; y++){
                        for(var x = 0; x < layer.data[y].length; x++){
                            // In Weltmeister, 0 = no tile, but the Tilemap API expects -1 = no tile.
                            var index = layer.data[y][x] - 1;
                            var tile;
                            if (index > -1) tile = new Tile(layerData, index, x, y, layer.tilesize, layer.tilesize);
                            else tile = insertNull ? null : new Tile(layerData, -1, x, y, layer.tilesize, layer.tilesize);
                            row.push(tile);
                        }
                        tileGrid.push(row);
                        row = [];
                    }
                    layerData.data = tileGrid;
                    tileLayers.push(layerData);
                }
                return tileLayers;
            };
            module1.exports = ParseTileLayers;
        /***/ },
        /* 575 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Tileset = __webpack_require__(121);
            /**
 * Tilesets and Image Collections
 *
 * @function Phaser.Tilemaps.Parsers.Impact.ParseTilesets
 * @since 3.0.0
 *
 * @param {object} json - The Impact JSON data.
 *
 * @return {array} An array of Tilesets.
 */ var ParseTilesets = function(json) {
                var tilesets = [];
                var tilesetsNames = [];
                for(var i = 0; i < json.layer.length; i++){
                    var layer = json.layer[i];
                    // A relative filepath to the source image (within Weltmeister) is used for the name
                    var tilesetName = layer.tilesetName;
                    // Only add unique tilesets that have a valid name. Collision layers will have a blank name.
                    if (tilesetName !== '' && tilesetsNames.indexOf(tilesetName) === -1) {
                        tilesetsNames.push(tilesetName);
                        // Tiles are stored with an ID relative to the tileset, rather than a globally unique ID
                        // across all tilesets. Also, tilesets in Weltmeister have no margin or padding.
                        tilesets.push(new Tileset(tilesetName, 0, layer.tilesize, layer.tilesize, 0, 0));
                    }
                }
                return tilesets;
            };
            module1.exports = ParseTilesets;
        /***/ },
        /* 576 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(35);
            var Formats = __webpack_require__(39);
            var GetFastValue = __webpack_require__(2);
            var LayerData = __webpack_require__(119);
            var ORIENTATION = __webpack_require__(29);
            var Rotate = __webpack_require__(356);
            var SpliceOne = __webpack_require__(74);
            var Sprite = __webpack_require__(73);
            var Tile = __webpack_require__(83);
            var TilemapComponents = __webpack_require__(247);
            var TilemapLayer = __webpack_require__(577);
            var Tileset = __webpack_require__(121);
            /**
 * @callback TilemapFilterCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found in the filtered area.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {Phaser.GameObjects.GameObject} The object.
 */ /**
 * @callback TilemapFindCallback
 *
 * @param {Phaser.GameObjects.GameObject} value - An object found.
 * @param {number} index - The index of the object within the array.
 * @param {Phaser.GameObjects.GameObject[]} array - An array of all the objects found.
 *
 * @return {boolean} `true` if the callback should be invoked, otherwise `false`.
 */ /**
 * @classdesc
 * A Tilemap is a container for Tilemap data. This isn't a display object, rather, it holds data
 * about the map and allows you to add tilesets and tilemap layers to it. A map can have one or
 * more tilemap layers, which are the display objects that actually render the tiles.
 *
 * The Tilemap data can be parsed from a Tiled JSON file, a CSV file or a 2D array. Tiled is a free
 * software package specifically for creating tile maps, and is available from:
 * http://www.mapeditor.org
 *
 * As of Phaser 3.50.0 the Tilemap API now supports the following types of map:
 *
 * 1) Orthogonal
 * 2) Isometric
 * 3) Hexagonal
 * 4) Staggered
 *
 * Prior to this release, only orthogonal maps were supported.
 *
 * Another large change in 3.50 was the consolidation of Tilemap Layers. Previously, you created
 * either a Static or Dynamic Tilemap Layer. However, as of 3.50 the features of both have been
 * merged and the API simplified, so now there is just the single `TilemapLayer` class.
 *
 * A Tilemap has handy methods for getting and manipulating the tiles within a layer, allowing
 * you to build or modify the tilemap data at runtime.
 *
 * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a
 * TilemapLayer may have its own unique tile size that overrides this.
 *
 * As of Phaser 3.21.0, if your tilemap includes layer groups (a feature of Tiled 1.2.0+) these
 * will be traversed and the following properties will impact children:
 *
 * - Opacity (blended with parent) and visibility (parent overrides child)
 * - Vertical and horizontal offset
 *
 * The grouping hierarchy is not preserved and all layers will be flattened into a single array.
 *
 * Group layers are parsed during Tilemap construction but are discarded after parsing so dynamic
 * layers will NOT continue to be affected by a parent.
 *
 * To avoid duplicate layer names, a layer that is a child of a group layer will have its parent
 * group name prepended with a '/'.  For example, consider a group called 'ParentGroup' with a
 * child called 'Layer 1'. In the Tilemap object, 'Layer 1' will have the name
 * 'ParentGroup/Layer 1'.
 *
 * @class Tilemap
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
 * @param {Phaser.Tilemaps.MapData} mapData - A MapData instance containing Tilemap data.
 */ var Tilemap = new Class({
                initialize: function Tilemap(scene, mapData) {
                    /**
         * @name Phaser.Tilemaps.Tilemap#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The base width of a tile in pixels. Note that individual layers may have a different tile
         * width.
         *
         * @name Phaser.Tilemaps.Tilemap#tileWidth
         * @type {number}
         * @since 3.0.0
         */ this.tileWidth = mapData.tileWidth;
                    /**
         * The base height of a tile in pixels. Note that individual layers may have a different
         * tile height.
         *
         * @name Phaser.Tilemaps.Tilemap#tileHeight
         * @type {number}
         * @since 3.0.0
         */ this.tileHeight = mapData.tileHeight;
                    /**
         * The width of the map (in tiles).
         *
         * @name Phaser.Tilemaps.Tilemap#width
         * @type {number}
         * @since 3.0.0
         */ this.width = mapData.width;
                    /**
         * The height of the map (in tiles).
         *
         * @name Phaser.Tilemaps.Tilemap#height
         * @type {number}
         * @since 3.0.0
         */ this.height = mapData.height;
                    /**
         * The orientation of the map data (as specified in Tiled), usually 'orthogonal'.
         *
         * @name Phaser.Tilemaps.Tilemap#orientation
         * @type {string}
         * @since 3.0.0
         */ this.orientation = mapData.orientation;
                    /**
         * The render (draw) order of the map data (as specified in Tiled), usually 'right-down'.
         *
         * The draw orders are:
         *
         * right-down
         * left-down
         * right-up
         * left-up
         *
         * This can be changed via the `setRenderOrder` method.
         *
         * @name Phaser.Tilemaps.Tilemap#renderOrder
         * @type {string}
         * @since 3.12.0
         */ this.renderOrder = mapData.renderOrder;
                    /**
         * The format of the map data.
         *
         * @name Phaser.Tilemaps.Tilemap#format
         * @type {number}
         * @since 3.0.0
         */ this.format = mapData.format;
                    /**
         * The version of the map data (as specified in Tiled, usually 1).
         *
         * @name Phaser.Tilemaps.Tilemap#version
         * @type {number}
         * @since 3.0.0
         */ this.version = mapData.version;
                    /**
         * Map specific properties as specified in Tiled.
         *
         * @name Phaser.Tilemaps.Tilemap#properties
         * @type {object}
         * @since 3.0.0
         */ this.properties = mapData.properties;
                    /**
         * The width of the map in pixels based on width * tileWidth.
         *
         * @name Phaser.Tilemaps.Tilemap#widthInPixels
         * @type {number}
         * @since 3.0.0
         */ this.widthInPixels = mapData.widthInPixels;
                    /**
         * The height of the map in pixels based on height * tileHeight.
         *
         * @name Phaser.Tilemaps.Tilemap#heightInPixels
         * @type {number}
         * @since 3.0.0
         */ this.heightInPixels = mapData.heightInPixels;
                    /**
         * A collection of Images, as parsed from Tiled map data.
         *
         * @name Phaser.Tilemaps.Tilemap#imageCollections
         * @type {Phaser.Tilemaps.ImageCollection[]}
         * @since 3.0.0
         */ this.imageCollections = mapData.imageCollections;
                    /**
         * An array of Tiled Image Layers.
         *
         * @name Phaser.Tilemaps.Tilemap#images
         * @type {array}
         * @since 3.0.0
         */ this.images = mapData.images;
                    /**
         * An array of Tilemap layer data.
         *
         * @name Phaser.Tilemaps.Tilemap#layers
         * @type {Phaser.Tilemaps.LayerData[]}
         * @since 3.0.0
         */ this.layers = mapData.layers;
                    /**
         * An array of Tilesets used in the map.
         *
         * @name Phaser.Tilemaps.Tilemap#tilesets
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.0.0
         */ this.tilesets = mapData.tilesets;
                    /**
         * An array of ObjectLayer instances parsed from Tiled object layers.
         *
         * @name Phaser.Tilemaps.Tilemap#objects
         * @type {Phaser.Tilemaps.ObjectLayer[]}
         * @since 3.0.0
         */ this.objects = mapData.objects;
                    /**
         * The index of the currently selected LayerData object.
         *
         * @name Phaser.Tilemaps.Tilemap#currentLayerIndex
         * @type {number}
         * @since 3.0.0
         */ this.currentLayerIndex = 0;
                    /**
         * The length of the horizontal sides of the hexagon.
         * Only used for hexagonal orientation Tilemaps.
         *
         * @name Phaser.Tilemaps.Tilemap#hexSideLength
         * @type {number}
         * @since 3.50.0
         */ this.hexSideLength = mapData.hexSideLength;
                    var orientation = this.orientation;
                    /**
         * Functions used to handle world to tile, and tile to world, conversion.
         * Cached here for internal use by public methods such as `worldToTileXY`, etc.
         *
         * @name Phaser.Tilemaps.Tilemap#_convert
         * @private
         * @type {object}
         * @since 3.50.0
         */ this._convert = {
                        WorldToTileXY: TilemapComponents.GetWorldToTileXYFunction(orientation),
                        WorldToTileX: TilemapComponents.GetWorldToTileXFunction(orientation),
                        WorldToTileY: TilemapComponents.GetWorldToTileYFunction(orientation),
                        TileToWorldXY: TilemapComponents.GetTileToWorldXYFunction(orientation),
                        TileToWorldX: TilemapComponents.GetTileToWorldXFunction(orientation),
                        TileToWorldY: TilemapComponents.GetTileToWorldYFunction(orientation)
                    };
                },
                /**
     * @ignore
     */ createBlankDynamicLayer: function(name, tileset, x, y, width, height, tileWidth, tileHeight) {
                    console.warn('createBlankDynamicLayer is deprecated. Use createBlankLayer');
                    return this.createBlankLayer(name, tileset, x, y, width, height, tileWidth, tileHeight);
                },
                /**
     * @ignore
     */ createDynamicLayer: function(layerID, tileset, x, y) {
                    console.warn('createDynamicLayer is deprecated. Use createLayer');
                    return this.createLayer(layerID, tileset, x, y);
                },
                /**
     * @ignore
     */ createStaticLayer: function(layerID, tileset, x, y) {
                    console.warn('createStaticLayer is deprecated. Use createLayer');
                    return this.createLayer(layerID, tileset, x, y);
                },
                /**
     * Sets the rendering (draw) order of the tiles in this map.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * Calling this method _after_ creating Tilemap Layers will **not** automatically
     * update them to use the new render order. If you call this method after creating layers, use their
     * own `setRenderOrder` methods to change them as needed.
     *
     * @method Phaser.Tilemaps.Tilemap#setRenderOrder
     * @since 3.12.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap object.
     */ setRenderOrder: function(renderOrder) {
                    var orders = [
                        'right-down',
                        'left-down',
                        'right-up',
                        'left-up'
                    ];
                    if (typeof renderOrder === 'number') renderOrder = orders[renderOrder];
                    if (orders.indexOf(renderOrder) > -1) this.renderOrder = renderOrder;
                    return this;
                },
                /**
     * Adds an image to the map to be used as a tileset. A single map may use multiple tilesets.
     * Note that the tileset name can be found in the JSON file exported from Tiled, or in the Tiled
     * editor.
     *
     * @method Phaser.Tilemaps.Tilemap#addTilesetImage
     * @since 3.0.0
     *
     * @param {string} tilesetName - The name of the tileset as specified in the map data.
     * @param {string} [key] - The key of the Phaser.Cache image used for this tileset. If
     * `undefined` or `null` it will look for an image with a key matching the tilesetName parameter.
     * @param {number} [tileWidth] - The width of the tile (in pixels) in the Tileset Image. If not
     * given it will default to the map's tileWidth value, or the tileWidth specified in the Tiled
     * JSON file.
     * @param {number} [tileHeight] - The height of the tiles (in pixels) in the Tileset Image. If
     * not given it will default to the map's tileHeight value, or the tileHeight specified in the
     * Tiled JSON file.
     * @param {number} [tileMargin] - The margin around the tiles in the sheet (in pixels). If not
     * specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [tileSpacing] - The spacing between each the tile in the sheet (in pixels).
     * If not specified, it will default to 0 or the value specified in the Tiled JSON file.
     * @param {number} [gid=0] - If adding multiple tilesets to a blank map, specify the starting
     * GID this set will use here.
     *
     * @return {?Phaser.Tilemaps.Tileset} Returns the Tileset object that was created or updated, or null if it
     * failed.
     */ addTilesetImage: function(tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid) {
                    if (tilesetName === undefined) return null;
                    if (key === undefined || key === null) key = tilesetName;
                    if (!this.scene.sys.textures.exists(key)) {
                        console.warn('Invalid Tileset Image: ' + key);
                        return null;
                    }
                    var texture = this.scene.sys.textures.get(key);
                    var index = this.getTilesetIndex(tilesetName);
                    if (index === null && this.format === Formats.TILED_JSON) {
                        console.warn('No data found for Tileset: ' + tilesetName);
                        return null;
                    }
                    var tileset = this.tilesets[index];
                    if (tileset) {
                        tileset.setTileSize(tileWidth, tileHeight);
                        tileset.setSpacing(tileMargin, tileSpacing);
                        tileset.setImage(texture);
                        return tileset;
                    }
                    if (tileWidth === undefined) tileWidth = this.tileWidth;
                    if (tileHeight === undefined) tileHeight = this.tileHeight;
                    if (tileMargin === undefined) tileMargin = 0;
                    if (tileSpacing === undefined) tileSpacing = 0;
                    if (gid === undefined) gid = 0;
                    tileset = new Tileset(tilesetName, gid, tileWidth, tileHeight, tileMargin, tileSpacing);
                    tileset.setImage(texture);
                    this.tilesets.push(tileset);
                    return tileset;
                },
                /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * If no layer specified, the map's current layer is used. This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#copy
     * @since 3.0.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                    layer = this.getLayer(layer);
                    if (layer !== null) {
                        TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer);
                        return this;
                    } else return null;
                },
                /**
     * Creates a new and empty Tilemap Layer. The currently selected layer in the map is set to this new layer.
     *
     * Prior to v3.50.0 this method was called `createBlankDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createBlankLayer
     * @since 3.0.0
     *
     * @param {string} name - The name of this layer. Must be unique within the map.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
     * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
     * @param {number} [width] - The width of the layer in tiles. If not specified, it will default to the map's width.
     * @param {number} [height] - The height of the layer in tiles. If not specified, it will default to the map's height.
     * @param {number} [tileWidth] - The width of the tiles the layer uses for calculations. If not specified, it will default to the map's tileWidth.
     * @param {number} [tileHeight] - The height of the tiles the layer uses for calculations. If not specified, it will default to the map's tileHeight.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer that was created, or `null` if it failed.
     */ createBlankLayer: function(name, tileset, x, y, width, height, tileWidth, tileHeight) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.width;
                    if (height === undefined) height = this.height;
                    if (tileWidth === undefined) tileWidth = this.tileWidth;
                    if (tileHeight === undefined) tileHeight = this.tileHeight;
                    var index = this.getLayerIndex(name);
                    if (index !== null) {
                        console.warn('Invalid Tilemap Layer ID: ' + name);
                        return null;
                    }
                    var layerData = new LayerData({
                        name: name,
                        tileWidth: tileWidth,
                        tileHeight: tileHeight,
                        width: width,
                        height: height,
                        orientation: this.orientation
                    });
                    var row;
                    for(var tileY = 0; tileY < height; tileY++){
                        row = [];
                        for(var tileX = 0; tileX < width; tileX++)row.push(new Tile(layerData, -1, tileX, tileY, tileWidth, tileHeight, this.tileWidth, this.tileHeight));
                        layerData.data.push(row);
                    }
                    this.layers.push(layerData);
                    this.currentLayerIndex = this.layers.length - 1;
                    var layer = new TilemapLayer(this.scene, this, this.currentLayerIndex, tileset, x, y);
                    layer.setRenderOrder(this.renderOrder);
                    this.scene.sys.displayList.add(layer);
                    return layer;
                },
                /**
     * Creates a new Tilemap Layer that renders the LayerData associated with the given
     * `layerID`. The currently selected layer in the map is set to this new layer.
     *
     * The `layerID` is important. If you've created your map in Tiled then you can get this by
     * looking in Tiled and looking at the layer name. Or you can open the JSON file it exports and
     * look at the layers[].name value. Either way it must match.
     *
     * Prior to v3.50.0 this method was called `createDynamicLayer`.
     *
     * @method Phaser.Tilemaps.Tilemap#createLayer
     * @since 3.0.0
     *
     * @param {(number|string)} layerID - The layer array index value, or if a string is given, the layer name from Tiled.
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     * @param {number} [x=0] - The x position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     * @param {number} [y=0] - The y position to place the layer in the world. If not specified, it will default to the layer offset from Tiled or 0.
     *
     * @return {?Phaser.Tilemaps.TilemapLayer} Returns the new layer was created, or null if it failed.
     */ createLayer: function(layerID, tileset, x, y) {
                    var index = this.getLayerIndex(layerID);
                    if (index === null) {
                        console.warn('Invalid Tilemap Layer ID: ' + layerID);
                        if (typeof layerID === 'string') console.warn('Valid tilelayer names:\n\t' + this.getTileLayerNames().join(',\n\t'));
                        return null;
                    }
                    var layerData = this.layers[index];
                    // Check for an associated static or dynamic tilemap layer
                    if (layerData.tilemapLayer) {
                        console.warn('Tilemap Layer ID already exists:' + layerID);
                        return null;
                    }
                    this.currentLayerIndex = index;
                    //  Default the x/y position to match Tiled layer offset, if it exists.
                    if (x === undefined) x = layerData.x;
                    if (y === undefined) y = layerData.y;
                    var layer = new TilemapLayer(this.scene, this, index, tileset, x, y);
                    layer.setRenderOrder(this.renderOrder);
                    this.scene.sys.displayList.add(layer);
                    return layer;
                },
                /**
     * This method will iterate through all of the objects defined in a Tiled Object Layer and then
     * convert the matching results into Phaser Game Objects (by default, Sprites)
     *
     * Objects are matched on one of 3 criteria: The Object ID, the Object GID or the Object Name.
     *
     * Within Tiled, Object IDs are unique per Object. Object GIDs, however, are shared by all objects
     * using the same image. Finally, Object Names are strings and the same name can be used on multiple
     * Objects in Tiled, they do not have to be unique.
     *
     * You set the configuration parameter accordingly, based on which type of criteria you wish
     * to match against. For example, to convert all items on an Object Layer with a `gid` of 26:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26
     * });
     * ```
     *
     * Or, to convert objects with the name 'bonus':
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   name: 'bonus'
     * });
     * ```
     *
     * Or, to convert an object with a specific id:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   id: 9
     * });
     * ```
     *
     * You should only specify either `id`, `gid`, `name`, or none of them. Do not add more than
     * one criteria to your config. If you do not specify any criteria, then _all_ objects in the
     * Object Layer will be converted.
     *
     * By default this method will convert objects into `Sprite` instances, but you can override
     * this by providing your own class type:
     *
     * ```javascript
     * createFromObjects(layerName, {
     *   gid: 26,
     *   classType: Coin
     * });
     * ```
     *
     * This will convert all Objects with a gid of 26 into your custom `Coin` class. You can pass
     * any class type here, but it _must_ extend `Phaser.GameObjects.GameObject` as its base class.
     * Your class will always be passed 1 parameter: `scene`, which is a reference to either the Scene
     * specified in the config object or, if not given, the Scene to which this Tilemap belongs.
     *
     * All properties from object are copied into the Game Object, so you can use this as an easy
     * way to configure properties from within the map editor. For example giving an object a
     * property of `alpha: 0.5` in Tiled will be reflected in the Game Object that is created.
     *
     * Custom object properties that do not exist as a Game Object property are set in the
     * Game Objects {@link Phaser.GameObjects.GameObject#data data store}.
     *
     * You can use set a `container` property in the config. If given, the class will be added to
     * the Container instance instead of the Scene.
     *
     * Finally, you can provide an array of config objects, to convert multiple types of object in
     * a single call:
     *
     * ```javascript
     * createFromObjects(layerName, [
     *   {
     *     gid: 26,
     *     classType: Coin
     *   },
     *   {
     *     id: 9,
     *     classType: BossMonster
     *   },
     *   {
     *     name: 'lava',
     *     classType: LavaTile
     *   }
     * ]);
     * ```
     *
     * The signature of this method changed significantly in v3.50.0. Prior to this, it did not take config objects.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromObjects
     * @since 3.0.0
     *
     * @param {string} objectLayerName - The name of the Tiled object layer to create the Game Objects from.
     * @param {Phaser.Types.Tilemaps.CreateFromObjectLayerConfig|Phaser.Types.Tilemaps.CreateFromObjectLayerConfig[]} config - A CreateFromObjects configuration object, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array containing the Game Objects that were created. Empty if invalid object layer, or no matching id/gid/name was found.
     */ createFromObjects: function(objectLayerName, config) {
                    var results = [];
                    var objectLayer = this.getObjectLayer(objectLayerName);
                    if (!objectLayer) {
                        console.warn('createFromObjects: Invalid objectLayerName given: ' + objectLayerName);
                        return results;
                    }
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var objects = objectLayer.objects;
                    for(var c = 0; c < config.length; c++){
                        var singleConfig = config[c];
                        var id = GetFastValue(singleConfig, 'id', null);
                        var gid = GetFastValue(singleConfig, 'gid', null);
                        var name = GetFastValue(singleConfig, 'name', null);
                        var obj;
                        var toConvert = [];
                        //  Sweep to get all the objects we want to convert in this pass
                        for(var s = 0; s < objects.length; s++){
                            obj = objects[s];
                            if (id === null && gid === null && name === null || id !== null && obj.id === id || gid !== null && obj.gid === gid || name !== null && obj.name === name) toConvert.push(obj);
                        }
                        //  Now let's convert them ...
                        var classType = GetFastValue(singleConfig, 'classType', Sprite);
                        var scene = GetFastValue(singleConfig, 'scene', this.scene);
                        var container = GetFastValue(singleConfig, 'container', null);
                        var texture = GetFastValue(singleConfig, 'key', null);
                        var frame = GetFastValue(singleConfig, 'frame', null);
                        for(var i = 0; i < toConvert.length; i++){
                            obj = toConvert[i];
                            var sprite = new classType(scene);
                            sprite.setName(obj.name);
                            sprite.setPosition(obj.x, obj.y);
                            sprite.setTexture(texture, frame);
                            if (obj.width) sprite.displayWidth = obj.width;
                            if (obj.height) sprite.displayHeight = obj.height;
                            //  Origin is (0, 1) in Tiled, so find the offset that matches the Sprites origin.
                            //  Do not offset objects with zero dimensions (e.g. points).
                            var offset = {
                                x: sprite.originX * obj.width,
                                y: (sprite.originY - 1) * obj.height
                            };
                            //  If the object is rotated, then the origin offset also needs to be rotated.
                            if (obj.rotation) {
                                var angle = DegToRad(obj.rotation);
                                Rotate(offset, angle);
                                sprite.rotation = angle;
                            }
                            sprite.x += offset.x;
                            sprite.y += offset.y;
                            if (obj.flippedHorizontal !== undefined || obj.flippedVertical !== undefined) sprite.setFlip(obj.flippedHorizontal, obj.flippedVertical);
                            if (!obj.visible) sprite.visible = false;
                            //  Set properties the class may have, or setData those it doesn't
                            for(var key in obj.properties)if (sprite[key] !== undefined) sprite[key] = obj.properties[key];
                            else sprite.setData(key, obj.properties[key]);
                            if (container) container.add(sprite);
                            else scene.add.existing(sprite);
                            results.push(sprite);
                        }
                    }
                    return results;
                },
                /**
     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * @method Phaser.Tilemaps.Tilemap#createFromTiles
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} spriteConfig - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.GameObjects.Sprite[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, layer);
                },
                /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * If no layer specified, the map's current layer is used.
     * This cannot be applied to StaticTilemapLayers.
     *
     * @method Phaser.Tilemaps.Tilemap#fill
     * @since 3.0.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, layer);
                    return this;
                },
                /**
     * For each object in the given object layer, run the given filter callback function. Any
     * objects that pass the filter test (i.e. where the callback returns true) will returned as a
     * new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#filterObjects
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFilterCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject[]} An array of object that match the search, or null if the objectLayer given was invalid.
     */ filterObjects: function(objectLayer, callback, context) {
                    if (typeof objectLayer === 'string') {
                        var name = objectLayer;
                        objectLayer = this.getObjectLayer(objectLayer);
                        if (!objectLayer) {
                            console.warn('No object layer found with the name: ' + name);
                            return null;
                        }
                    }
                    return objectLayer.objects.filter(callback, context);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#filterTiles
     * @since 3.0.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findByIndex
     * @since 3.0.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findByIndex: function(findIndex, skip, reverse, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FindByIndex(findIndex, skip, reverse, layer);
                },
                /**
     * Find the first object in the given object layer that satisfies the provided testing function.
     * I.e. finds the first object for which `callback` returns true. Similar to
     * Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.Tilemap#findObject
     * @since 3.0.0
     *
     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
     * @param {TilemapFindCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     *
     * @return {?Phaser.Types.Tilemaps.TiledObject} An object that matches the search, or null if no object found.
     */ findObject: function(objectLayer, callback, context) {
                    if (typeof objectLayer === 'string') {
                        var name = objectLayer;
                        objectLayer = this.getObjectLayer(objectLayer);
                        if (!objectLayer) {
                            console.warn('No object layer found with the name: ' + name);
                            return null;
                        }
                    }
                    return objectLayer.objects.find(callback, context) || null;
                },
                /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     * If no layer specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#findTile
     * @since 3.0.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * If no layer specified, the map's current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#forEachTile
     * @since 3.0.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The Tile layer to run the search on. If not provided will use the current layer.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
                    return this;
                },
                /**
     * Gets the image layer index based on its name.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the image to get.
     *
     * @return {number} The index of the image in this tilemap, or null if not found.
     */ getImageIndex: function(name) {
                    return this.getIndex(this.images, name);
                },
                /**
     * Return a list of all valid imagelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getImageLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid imagelayer names / IDs loaded into this Tilemap.
     */ getImageLayerNames: function() {
                    if (!this.images || !Array.isArray(this.images)) return [];
                    return this.images.map(function(image) {
                        return image.name;
                    });
                },
                /**
     * Internally used. Returns the index of the object in one of the Tilemaps arrays whose name
     * property matches the given `name`.
     *
     * @method Phaser.Tilemaps.Tilemap#getIndex
     * @since 3.0.0
     *
     * @param {array} location - The Tilemap array to search.
     * @param {string} name - The name of the array element to get.
     *
     * @return {number} The index of the element in the array, or null if not found.
     */ getIndex: function(location, name) {
                    for(var i = 0; i < location.length; i++){
                        if (location[i].name === name) return i;
                    }
                    return null;
                },
                /**
     * Gets the LayerData from `this.layers` that is associated with the given `layer`, or null if the layer is invalid.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or Tilemap Layer. If not given will default to the maps current layer index.
     *
     * @return {Phaser.Tilemaps.LayerData} The corresponding LayerData within this.layers.
     */ getLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    return index !== null ? this.layers[index] : null;
                },
                /**
     * Gets the ObjectLayer from `this.objects` that has the given `name`, or null if no ObjectLayer is found with that name.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayer
     * @since 3.0.0
     *
     * @param {string} [name] - The name of the object layer from Tiled.
     *
     * @return {?Phaser.Tilemaps.ObjectLayer} The corresponding `ObjectLayer` within `this.objects`, or null.
     */ getObjectLayer: function(name) {
                    var index = this.getIndex(this.objects, name);
                    return index !== null ? this.objects[index] : null;
                },
                /**
     * Return a list of all valid objectgroup names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getObjectLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid objectgroup names / IDs loaded into this Tilemap.
     */ getObjectLayerNames: function() {
                    if (!this.objects || !Array.isArray(this.objects)) return [];
                    return this.objects.map(function(object) {
                        return object.name;
                    });
                },
                /**
     * Gets the LayerData index of the given `layer` within this.layers, or null if an invalid
     * `layer` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndex
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a Tilemap Layer. If not given will default to the map's current layer index.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndex: function(layer) {
                    if (layer === undefined) return this.currentLayerIndex;
                    else if (typeof layer === 'string') return this.getLayerIndexByName(layer);
                    else if (typeof layer === 'number' && layer < this.layers.length) return layer;
                    else if (layer instanceof TilemapLayer) return layer.layerIndex;
                    else return null;
                },
                /**
     * Gets the index of the LayerData within this.layers that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getLayerIndexByName
     * @since 3.0.0
     *
     * @param {string} name - The name of the layer to get.
     *
     * @return {number} The LayerData index within this.layers.
     */ getLayerIndexByName: function(name) {
                    return this.getIndex(this.layers, name);
                },
                /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAt: function(tileX, tileY, nonNull, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTileAt(tileX, tileY, nonNull, layer);
                },
                /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull] - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, layer);
                },
                /**
     * Return a list of all valid tilelayer names loaded in this Tilemap.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileLayerNames
     * @since 3.21.0
     *
     * @return {string[]} Array of valid tilelayer names / IDs loaded into this Tilemap.
     */ getTileLayerNames: function() {
                    if (!this.layers || !Array.isArray(this.layers)) return [];
                    return this.layers.map(function(layer) {
                        return layer.name;
                    });
                },
                /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                },
                /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinShape
     * @since 3.0.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinShape: function(shape, filteringOptions, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesWithinWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, layer);
                },
                /**
     * Gets the Tileset that has the given `name`, or null if an invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTileset
     * @since 3.14.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {?Phaser.Tilemaps.Tileset} The Tileset, or `null` if no matching named tileset was found.
     */ getTileset: function(name) {
                    var index = this.getIndex(this.tilesets, name);
                    return index !== null ? this.tilesets[index] : null;
                },
                /**
     * Gets the index of the Tileset within this.tilesets that has the given `name`, or null if an
     * invalid `name` is given.
     *
     * @method Phaser.Tilemaps.Tilemap#getTilesetIndex
     * @since 3.0.0
     *
     * @param {string} name - The name of the Tileset to get.
     *
     * @return {number} The Tileset index within this.tilesets.
     */ getTilesetIndex: function(name) {
                    return this.getIndex(this.tilesets, name);
                },
                /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAt: function(tileX, tileY, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.HasTileAt(tileX, tileY, layer);
                },
                /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#hasTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
     */ hasTileAtWorldXY: function(worldX, worldY, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, layer);
                },
                /**
     * The LayerData object that is currently selected in the map. You can set this property using
     * any type supported by setLayer.
     *
     * @name Phaser.Tilemaps.Tilemap#layer
     * @type {Phaser.Tilemaps.LayerData}
     * @since 3.0.0
     */ layer: {
                    get: function() {
                        return this.layers[this.currentLayerIndex];
                    },
                    set: function(layer) {
                        this.setLayer(layer);
                    }
                },
                /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAt
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid or the coordinates were out of bounds.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, layer);
                },
                /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTileAtWorldXY
     * @since 3.0.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, layer);
                },
                /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#putTilesAt
     * @since 3.0.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, layer);
                    return this;
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#randomize
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ randomize: function(tileX, tileY, width, height, indexes, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Randomize(tileX, tileY, width, height, indexes, layer);
                    return this;
                },
                /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesAt: function(tileX, tileY, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.CalculateFacesAt(tileX, tileY, layer);
                    return this;
                },
                /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#calculateFacesWithin
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ calculateFacesWithin: function(tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Removes the given TilemapLayer from this Tilemap without destroying it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be removed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ removeLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) {
                        SpliceOne(this.layers, index);
                        for(var i = index; i < this.layers.length; i++)if (this.layers[i].tilemapLayer) this.layers[i].tilemapLayer.layerIndex--;
                        if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                        return this;
                    } else return null;
                },
                /**
     * Destroys the given TilemapLayer and removes it from this Tilemap.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#destroyLayer
     * @since 3.17.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to be destroyed.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
     */ destroyLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) {
                        layer = this.layers[index];
                        layer.destroy();
                        SpliceOne(this.layers, index);
                        if (this.currentLayerIndex === index) this.currentLayerIndex = 0;
                        return this;
                    } else return null;
                },
                /**
     * Removes all Tilemap Layers from this Tilemap and calls `destroy` on each of them.
     *
     * @method Phaser.Tilemaps.Tilemap#removeAllLayers
     * @since 3.0.0
     *
     * @return {this} This Tilemap object.
     */ removeAllLayers: function() {
                    var layers = this.layers;
                    for(var i = 0; i < layers.length; i++)if (layers[i].tilemapLayer) layers[i].tilemapLayer.destroy(false);
                    layers.length = 0;
                    this.currentLayerIndex = 0;
                    return this;
                },
                /**
     * Removes the given Tile, or an array of Tiles, from the layer to which they belong,
     * and optionally recalculates the collision information.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTile
     * @since 3.17.0
     *
     * @param {(Phaser.Tilemaps.Tile|Phaser.Tilemaps.Tile[])} tiles - The Tile to remove, or an array of Tiles.
     * @param {number} [replaceIndex=-1] - After removing the Tile, insert a brand new Tile into its location with the given index. Leave as -1 to just remove the tile.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile[]} Returns an array of Tiles that were removed.
     */ removeTile: function(tiles, replaceIndex, recalculateFaces) {
                    if (replaceIndex === undefined) replaceIndex = -1;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    var removed = [];
                    if (!Array.isArray(tiles)) tiles = [
                        tiles
                    ];
                    for(var i = 0; i < tiles.length; i++){
                        var tile = tiles[i];
                        removed.push(this.removeTileAt(tile.x, tile.y, true, recalculateFaces, tile.tilemapLayer));
                        if (replaceIndex > -1) this.putTileAt(replaceIndex, tile.x, tile.y, recalculateFaces, tile.tilemapLayer);
                    }
                    return removed;
                },
                /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAt
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns the Tile that was removed, or null if the layer given was invalid.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces, layer) {
                    if (replaceWithNull === undefined) replaceWithNull = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, layer);
                },
                /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#removeTileAtWorldXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull] - If `true` (the default), this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces] - If `true` (the default), the faces data will be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                    if (replaceWithNull === undefined) replaceWithNull = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer);
                },
                /**
     * Draws a debug representation of the layer to the given Graphics object. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * **Note:** This method currently only works with orthogonal tilemap layers.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebug
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ renderDebug: function(graphics, styleConfig, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    if (this.orientation === ORIENTATION.ORTHOGONAL) TilemapComponents.RenderDebug(graphics, styleConfig, layer);
                    return this;
                },
                /**
     * Draws a debug representation of all layers within this Tilemap to the given Graphics object.
     *
     * This is helpful when you want to get a quick idea of which of your tiles are colliding and which
     * have interesting faces. The tiles are drawn starting at (0, 0) in the Graphics, allowing you to
     * place the debug representation wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.Tilemap#renderDebugFull
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap instance.
     */ renderDebugFull: function(graphics, styleConfig) {
                    var layers = this.layers;
                    for(var i = 0; i < layers.length; i++)TilemapComponents.RenderDebug(graphics, styleConfig, layers[i]);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#replaceByIndex
     * @since 3.0.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollision
     * @since 3.0.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollision: function(indexes, collides, recalculateFaces, layer, updateLayer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    if (updateLayer === undefined) updateLayer = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollision(indexes, collides, recalculateFaces, layer, updateLayer);
                    return this;
                },
                /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionBetween
     * @since 3.0.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByProperty
     * @since 3.0.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionByExclusion
     * @since 3.0.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tiles colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setCollisionFromCollisionGroup
     * @since 3.0.0
     *
     * @param {boolean} [collides] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces] - Whether or not to recalculate the tile faces after the update.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces, layer) {
                    if (collides === undefined) collides = true;
                    if (recalculateFaces === undefined) recalculateFaces = true;
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, layer);
                    return this;
                },
                /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see `setTileLocationCallback`.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileIndexCallback
     * @since 3.0.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for. All values should be integers.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileIndexCallback: function(indexes, callback, callbackContext, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, layer);
                    return this;
                },
                /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#setTileLocationCallback
     * @since 3.0.0
     *
     * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} width - How many tiles wide from the `tileX` index the area will be.
     * @param {number} height - How many tiles tall from the `tileY` index the area will be.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context under which the callback is called.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, layer);
                    return this;
                },
                /**
     * Sets the current layer to the LayerData associated with `layer`.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayer
     * @since 3.0.0
     *
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayer: function(layer) {
                    var index = this.getLayerIndex(layer);
                    if (index !== null) this.currentLayerIndex = index;
                    return this;
                },
                /**
     * Sets the base tile size for the map. Note: this does not necessarily match the tileWidth and
     * tileHeight for all layers. This also updates the base size on all tiles across all layers.
     *
     * @method Phaser.Tilemaps.Tilemap#setBaseTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles the map uses for calculations.
     * @param {number} tileHeight - The height of the tiles the map uses for calculations.
     *
     * @return {this} This Tilemap object.
     */ setBaseTileSize: function(tileWidth, tileHeight) {
                    this.tileWidth = tileWidth;
                    this.tileHeight = tileHeight;
                    this.widthInPixels = this.width * tileWidth;
                    this.heightInPixels = this.height * tileHeight;
                    //  Update the base tile size on all layers & tiles
                    for(var i = 0; i < this.layers.length; i++){
                        this.layers[i].baseTileWidth = tileWidth;
                        this.layers[i].baseTileHeight = tileHeight;
                        var mapData = this.layers[i].data;
                        var mapWidth = this.layers[i].width;
                        var mapHeight = this.layers[i].height;
                        for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                            var tile = mapData[row][col];
                            if (tile !== null) tile.setSize(undefined, undefined, tileWidth, tileHeight);
                        }
                    }
                    return this;
                },
                /**
     * Sets the tile size for a specific `layer`. Note: this does not necessarily match the maps
     * tileWidth and tileHeight for all layers. This will set the tile size for the layer and any
     * tiles the layer has.
     *
     * @method Phaser.Tilemaps.Tilemap#setLayerTileSize
     * @since 3.0.0
     *
     * @param {number} tileWidth - The width of the tiles (in pixels) in the layer.
     * @param {number} tileHeight - The height of the tiles (in pixels) in the layer.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The name of the layer from Tiled, the index of the layer in the map or a TilemapLayer. If not given will default to the maps current layer index.
     *
     * @return {this} This Tilemap object.
     */ setLayerTileSize: function(tileWidth, tileHeight, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return this;
                    layer.tileWidth = tileWidth;
                    layer.tileHeight = tileHeight;
                    var mapData = layer.data;
                    var mapWidth = layer.width;
                    var mapHeight = layer.height;
                    for(var row = 0; row < mapHeight; row++)for(var col = 0; col < mapWidth; col++){
                        var tile = mapData[row][col];
                        if (tile !== null) tile.setSize(tileWidth, tileHeight);
                    }
                    return this;
                },
                /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#shuffle
     * @since 3.0.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ shuffle: function(tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.Shuffle(tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#swapByIndex
     * @since 3.0.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, layer);
                    return this;
                },
                /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldX
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldX: function(tileX, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldX(tileX, camera, layer);
                },
                /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldY
     * @since 3.0.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ tileToWorldY: function(tileX, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldY(tileX, camera, layer);
                },
                /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#tileToWorldXY
     * @since 3.0.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a Vector2, or null if the layer given was invalid.
     */ tileToWorldXY: function(tileX, tileY, vec2, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.TileToWorldXY(tileX, tileY, vec2, camera, layer);
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being picked is (the indexs weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#weightedRandomize
     * @since 3.0.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, layer);
                    return this;
                },
                /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileX
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileX: function(worldX, snapToFloor, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileX(worldX, snapToFloor, camera, layer);
                },
                /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileY
     * @since 3.0.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?number} Returns a number, or null if the layer given was invalid.
     */ worldToTileY: function(worldY, snapToFloor, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileY(worldY, snapToFloor, camera, layer);
                },
                /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * If no layer is specified, the maps current layer is used.
     *
     * @method Phaser.Tilemaps.Tilemap#worldToTileXY
     * @since 3.0.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     * @param {(string|number|Phaser.Tilemaps.TilemapLayer)} [layer] - The tile layer to use. If not given the current layer is used.
     *
     * @return {?Phaser.Math.Vector2} Returns a vec2, or null if the layer given was invalid.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, vec2, camera, layer) {
                    layer = this.getLayer(layer);
                    if (layer === null) return null;
                    return this._convert.WorldToTileXY(worldX, worldY, snapToFloor, vec2, camera, layer);
                },
                /**
     * Removes all layer data from this Tilemap and nulls the scene reference. This will destroy any
     * TilemapLayers that have been created.
     *
     * @method Phaser.Tilemaps.Tilemap#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllLayers();
                    this.tilesets.length = 0;
                    this.objects.length = 0;
                    this.scene = null;
                }
            });
            module1.exports = Tilemap;
        /***/ },
        /* 577 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(11);
            var GameObject = __webpack_require__(15);
            var TilemapComponents = __webpack_require__(247);
            var TilemapLayerRender = __webpack_require__(1449);
            /**
 * @classdesc
 * A Tilemap Layer is a Game Object that renders LayerData from a Tilemap when used in combination
 * with one, or more, Tilesets.
 *
 * @class TilemapLayer
 * @extends Phaser.GameObjects.GameObject
 * @memberof Phaser.Tilemaps
 * @constructor
 * @since 3.50.0
 *
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.ComputedSize
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
 * @param {Phaser.Tilemaps.Tilemap} tilemap - The Tilemap this layer is a part of.
 * @param {number} layerIndex - The index of the LayerData associated with this layer.
 * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
 * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
 * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
 */ var TilemapLayer = new Class({
                Extends: GameObject,
                Mixins: [
                    Components.Alpha,
                    Components.BlendMode,
                    Components.ComputedSize,
                    Components.Depth,
                    Components.Flip,
                    Components.GetBounds,
                    Components.Origin,
                    Components.Pipeline,
                    Components.Transform,
                    Components.Visible,
                    Components.ScrollFactor,
                    TilemapLayerRender
                ],
                initialize: function TilemapLayer(scene, tilemap, layerIndex, tileset, x, y) {
                    GameObject.call(this, scene, 'TilemapLayer');
                    /**
         * Used internally by physics system to perform fast type checks.
         *
         * @name Phaser.Tilemaps.TilemapLayer#isTilemap
         * @type {boolean}
         * @readonly
         * @since 3.50.0
         */ this.isTilemap = true;
                    /**
         * The Tilemap that this layer is a part of.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilemap
         * @type {Phaser.Tilemaps.Tilemap}
         * @since 3.50.0
         */ this.tilemap = tilemap;
                    /**
         * The index of the LayerData associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layerIndex
         * @type {number}
         * @since 3.50.0
         */ this.layerIndex = layerIndex;
                    /**
         * The LayerData associated with this layer. LayerData can only be associated with one
         * tilemap layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#layer
         * @type {Phaser.Tilemaps.LayerData}
         * @since 3.50.0
         */ this.layer = tilemap.layers[layerIndex];
                    // Link the LayerData with this static tilemap layer
                    this.layer.tilemapLayer = this;
                    /**
         * An array of `Tileset` objects associated with this layer.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tileset
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.tileset = [];
                    /**
         * The total number of tiles drawn by the renderer in the last frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesDrawn
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesDrawn = 0;
                    /**
         * The total number of tiles in this layer. Updated every frame.
         *
         * @name Phaser.Tilemaps.TilemapLayer#tilesTotal
         * @type {number}
         * @readonly
         * @since 3.50.0
         */ this.tilesTotal = this.layer.width * this.layer.height;
                    /**
         * Used internally during rendering. This holds the tiles that are visible within the Camera.
         *
         * @name Phaser.Tilemaps.TilemapLayer#culledTiles
         * @type {Phaser.Tilemaps.Tile[]}
         * @since 3.50.0
         */ this.culledTiles = [];
                    /**
         * You can control if the camera should cull tiles on this layer before rendering them or not.
         *
         * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
         *
         * However, there are some instances when you may wish to disable this, and toggling this flag allows
         * you to do so. Also see `setSkipCull` for a chainable method that does the same thing.
         *
         * @name Phaser.Tilemaps.TilemapLayer#skipCull
         * @type {boolean}
         * @since 3.50.0
         */ this.skipCull = false;
                    /**
         * The amount of extra tiles to add into the cull rectangle when calculating its horizontal size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingX
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingX = 1;
                    /**
         * The amount of extra tiles to add into the cull rectangle when calculating its vertical size.
         *
         * See the method `setCullPadding` for more details.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullPaddingY
         * @type {number}
         * @default 1
         * @since 3.50.0
         */ this.cullPaddingY = 1;
                    /**
         * The callback that is invoked when the tiles are culled.
         *
         * It will call a different function based on the map orientation:
         *
         * Orthogonal (the default) is `TilemapComponents.CullTiles`
         * Isometric is `TilemapComponents.IsometricCullTiles`
         * Hexagonal is `TilemapComponents.HexagonalCullTiles`
         * Staggered is `TilemapComponents.StaggeredCullTiles`
         *
         * However, you can override this to call any function you like.
         *
         * It will be sent 4 arguments:
         *
         * 1. The Phaser.Tilemaps.LayerData object for this Layer
         * 2. The Camera that is culling the layer. You can check its `dirty` property to see if it has changed since the last cull.
         * 3. A reference to the `culledTiles` array, which should be used to store the tiles you want rendered.
         * 4. The Render Order constant.
         *
         * See the `TilemapComponents.CullTiles` source code for details on implementing your own culling system.
         *
         * @name Phaser.Tilemaps.TilemapLayer#cullCallback
         * @type {function}
         * @since 3.50.0
         */ this.cullCallback = TilemapComponents.GetCullTilesFunction(this.layer.orientation);
                    /**
         * The rendering (draw) order of the tiles in this layer.
         *
         * The default is 0 which is 'right-down', meaning it will draw the tiles starting from the top-left,
         * drawing to the right and then moving down to the next row.
         *
         * The draw orders are:
         *
         * 0 = right-down
         * 1 = left-down
         * 2 = right-up
         * 3 = left-up
         *
         * This can be changed via the `setRenderOrder` method.
         *
         * @name Phaser.Tilemaps.TilemapLayer#_renderOrder
         * @type {number}
         * @default 0
         * @private
         * @since 3.50.0
         */ this._renderOrder = 0;
                    /**
         * An array holding the mapping between the tile indexes and the tileset they belong to.
         *
         * @name Phaser.Tilemaps.TilemapLayer#gidMap
         * @type {Phaser.Tilemaps.Tileset[]}
         * @since 3.50.0
         */ this.gidMap = [];
                    this.setTilesets(tileset);
                    this.setAlpha(this.layer.alpha);
                    this.setPosition(x, y);
                    this.setOrigin();
                    this.setSize(tilemap.tileWidth * this.layer.width, tilemap.tileHeight * this.layer.height);
                    this.initPipeline();
                },
                /**
     * Populates the internal `tileset` array with the Tileset references this Layer requires for rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTilesets
     * @private
     * @since 3.50.0
     *
     * @param {(string|string[]|Phaser.Tilemaps.Tileset|Phaser.Tilemaps.Tileset[])} tileset - The tileset, or an array of tilesets, used to render this layer. Can be a string or a Tileset object.
     */ setTilesets: function(tilesets) {
                    var gidMap = [];
                    var setList = [];
                    var map = this.tilemap;
                    if (!Array.isArray(tilesets)) tilesets = [
                        tilesets
                    ];
                    for(var i = 0; i < tilesets.length; i++){
                        var tileset = tilesets[i];
                        if (typeof tileset === 'string') tileset = map.getTileset(tileset);
                        if (tileset) {
                            setList.push(tileset);
                            var s = tileset.firstgid;
                            for(var t = 0; t < tileset.total; t++)gidMap[s + t] = tileset;
                        }
                    }
                    this.gidMap = gidMap;
                    this.tileset = setList;
                },
                /**
     * Sets the rendering (draw) order of the tiles in this layer.
     *
     * The default is 'right-down', meaning it will order the tiles starting from the top-left,
     * drawing to the right and then moving down to the next row.
     *
     * The draw orders are:
     *
     * 0 = right-down
     * 1 = left-down
     * 2 = right-up
     * 3 = left-up
     *
     * Setting the render order does not change the tiles or how they are stored in the layer,
     * it purely impacts the order in which they are rendered.
     *
     * You can provide either an integer (0 to 3), or the string version of the order.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setRenderOrder
     * @since 3.50.0
     *
     * @param {(number|string)} renderOrder - The render (draw) order value. Either an integer between 0 and 3, or a string: 'right-down', 'left-down', 'right-up' or 'left-up'.
     *
     * @return {this} This Tilemap Layer object.
     */ setRenderOrder: function(renderOrder) {
                    var orders = [
                        'right-down',
                        'left-down',
                        'right-up',
                        'left-up'
                    ];
                    if (typeof renderOrder === 'string') renderOrder = orders.indexOf(renderOrder);
                    if (renderOrder >= 0 && renderOrder < 4) this._renderOrder = renderOrder;
                    return this;
                },
                /**
     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
     * faces are used internally for optimizing collisions against tiles. This method is mostly used
     * internally to optimize recalculating faces when only one tile has been changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate.
     * @param {number} tileY - The y coordinate.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesAt: function(tileX, tileY) {
                    TilemapComponents.CalculateFacesAt(tileX, tileY, this.layer);
                    return this;
                },
                /**
     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
     * is mostly used internally.
     *
     * @method Phaser.Tilemaps.TilemapLayer#calculateFacesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ calculateFacesWithin: function(tileX, tileY, width, height) {
                    TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
     * created. This is useful if you want to lay down special tiles in a level that are converted to
     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
     *
     * @method Phaser.Tilemaps.TilemapLayer#createFromTiles
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - The tile index, or array of indexes, to create Sprites from.
     * @param {(number|array)} replacements - The tile index, or array of indexes, to change a converted
     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
     * one-to-one mapping with the indexes array.
     * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} [spriteConfig] - The config object to pass into the Sprite creator (i.e.
     * scene.make.sprite).
     * @param {Phaser.Scene} [scene] - The Scene to create the Sprites within.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when determining the world XY
     *
     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
     */ createFromTiles: function(indexes, replacements, spriteConfig, scene, camera) {
                    return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, this.layer);
                },
                /**
     * Returns the tiles in the given layer that are within the cameras viewport.
     * This is used internally during rendering.
     *
     * @method Phaser.Tilemaps.TilemapLayer#cull
     * @since 3.50.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects to render.
     */ cull: function(camera) {
                    return this.cullCallback(this.layer, camera, this.culledTiles, this._renderOrder);
                },
                /**
     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
     * coordinates) within the layer. This copies all tile properties & recalculates collision
     * information in the destination region.
     *
     * @method Phaser.Tilemaps.TilemapLayer#copy
     * @since 3.50.0
     *
     * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
     * @param {number} width - The width of the area to copy, in tiles, not pixels.
     * @param {number} height - The height of the area to copy, in tiles, not pixels.
     * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
     * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ copy: function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces) {
                    TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
     * specified index. Tiles will be set to collide if the given index is a colliding index.
     * Collision information in the region will be recalculated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#fill
     * @since 3.50.0
     *
     * @param {number} index - The tile index to fill the area with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ fill: function(index, tileX, tileY, width, height, recalculateFaces) {
                    TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#filterTiles
     * @since 3.50.0
     *
     * @param {function} callback - The callback. Each tile in the given area will be passed to this
     * callback as the first and only parameter. The callback should return true for tiles that pass the
     * filter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
     */ filterTiles: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
     * object. If no match is found, it returns null. The search starts from the top-left tile and
     * continues horizontally until it hits the end of the row, then it drops down to the next column.
     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
     * the top-left.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findByIndex
     * @since 3.50.0
     *
     * @param {number} index - The tile index value to search for.
     * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
     *
     * @return {Phaser.Tilemaps.Tile} The first matching Tile object.
     */ findByIndex: function(findIndex, skip, reverse) {
                    return TilemapComponents.FindByIndex(findIndex, skip, reverse, this.layer);
                },
                /**
     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
     * true. Similar to Array.prototype.find in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#findTile
     * @since 3.50.0
     *
     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {?Phaser.Tilemaps.Tile} The first Tile found at the given location.
     */ findTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
     * callback. Similar to Array.prototype.forEach in vanilla JS.
     *
     * @method Phaser.Tilemaps.TilemapLayer#forEachTile
     * @since 3.50.0
     *
     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
     * @param {object} [context] - The context, or scope, under which the callback should be run.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area to search.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {this} This Tilemap Layer object.
     */ forEachTile: function(callback, context, tileX, tileY, width, height, filteringOptions) {
                    TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
                    return this;
                },
                /**
     * Gets a tile at the given tile coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - X position to get the tile from (given in tile units, not pixels).
     * @param {number} tileY - Y position to get the tile from (given in tile units, not pixels).
     * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAt: function(tileX, tileY, nonNull) {
                    return TilemapComponents.GetTileAt(tileX, tileY, nonNull, this.layer);
                },
                /**
     * Gets a tile at the given world coordinates from the given layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - X position to get the tile from (given in pixels)
     * @param {number} worldY - Y position to get the tile from (given in pixels)
     * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
     */ getTileAtWorldXY: function(worldX, worldY, nonNull, camera) {
                    return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, this.layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithin
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithin: function(tileX, tileY, width, height, filteringOptions) {
                    return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, this.layer);
                },
                /**
     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
     * Line, Rectangle or Triangle. The shape should be in world coordinates.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinShape
     * @since 3.50.0
     *
     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the shape.
     */ getTilesWithinShape: function(shape, filteringOptions, camera) {
                    return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, this.layer);
                },
                /**
     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
     *
     * @method Phaser.Tilemaps.TilemapLayer#getTilesWithinWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The world x coordinate for the top-left of the area.
     * @param {number} worldY - The world y coordinate for the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {Phaser.Types.Tilemaps.FilteringOptions} [filteringOptions] - Optional filters to apply when getting the tiles.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects found within the area.
     */ getTilesWithinWorldXY: function(worldX, worldY, width, height, filteringOptions, camera) {
                    return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, this.layer);
                },
                /**
     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAt: function(tileX, tileY) {
                    return TilemapComponents.HasTileAt(tileX, tileY, this.layer);
                },
                /**
     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
     * false if there is no tile or if the tile at that location has an index of -1.
     *
     * @method Phaser.Tilemaps.TilemapLayer#hasTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when factoring in which tiles to return.
     *
     * @return {boolean} `true` if a tile was found at the given location, otherwise `false`.
     */ hasTileAtWorldXY: function(worldX, worldY, camera) {
                    return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, this.layer);
                },
                /**
     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
     * location. If you pass in an index, only the index at the specified location will be changed.
     * Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAt
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAt: function(tile, tileX, tileY, recalculateFaces) {
                    return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, this.layer);
                },
                /**
     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
     * specified location. If you pass in an index, only the index at the specified location will be
     * changed. Collision information will be recalculated at the specified location.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTileAtWorldXY
     * @since 3.50.0
     *
     * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [recalculateFaces] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was inserted at the given coordinates.
     */ putTileAtWorldXY: function(tile, worldX, worldY, recalculateFaces, camera) {
                    return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, this.layer);
                },
                /**
     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
     * all attributes will be copied over to the specified location. If you pass in an index, only the
     * index at the specified location will be changed. Collision information will be recalculated
     * within the region tiles were changed.
     *
     * @method Phaser.Tilemaps.TilemapLayer#putTilesAt
     * @since 3.50.0
     *
     * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {this} This Tilemap Layer object.
     */ putTilesAt: function(tilesArray, tileX, tileY, recalculateFaces) {
                    TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
     * indexes. This method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#randomize
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {number[]} [indexes] - An array of indexes to randomly draw from during randomization.
     *
     * @return {this} This Tilemap Layer object.
     */ randomize: function(tileX, tileY, width, height, indexes) {
                    TilemapComponents.Randomize(tileX, tileY, width, height, indexes, this.layer);
                    return this;
                },
                /**
     * Removes the tile at the given tile coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAt
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     *
     * @return {Phaser.Tilemaps.Tile} A Tile object.
     */ removeTileAt: function(tileX, tileY, replaceWithNull, recalculateFaces) {
                    return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, this.layer);
                },
                /**
     * Removes the tile at the given world coordinates in the specified layer and updates the layers
     * collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#removeTileAtWorldXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate, in pixels.
     * @param {number} worldY - The y coordinate, in pixels.
     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
     * @param {boolean} [recalculateFaces=true] - `true` if the faces data should be recalculated.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Tilemaps.Tile} The Tile object that was removed from the given location.
     */ removeTileAtWorldXY: function(worldX, worldY, replaceWithNull, recalculateFaces, camera) {
                    return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, this.layer);
                },
                /**
     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
     * wherever you want on the screen.
     *
     * @method Phaser.Tilemaps.TilemapLayer#renderDebug
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
     * @param {Phaser.Types.Tilemaps.StyleConfig} [styleConfig] - An object specifying the colors to use for the debug drawing.
     *
     * @return {this} This Tilemap Layer object.
     */ renderDebug: function(graphics, styleConfig) {
                    TilemapComponents.RenderDebug(graphics, styleConfig, this.layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
     * not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#replaceByIndex
     * @since 3.50.0
     *
     * @param {number} findIndex - The index of the tile to search for.
     * @param {number} newIndex - The index of the tile to replace it with.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ replaceByIndex: function(findIndex, newIndex, tileX, tileY, width, height) {
                    TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * You can control if the Cameras should cull tiles before rendering them or not.
     *
     * By default the camera will try to cull the tiles in this layer, to avoid over-drawing to the renderer.
     *
     * However, there are some instances when you may wish to disable this.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setSkipCull
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Set to `true` to stop culling tiles. Set to `false` to enable culling again.
     *
     * @return {this} This Tilemap Layer object.
     */ setSkipCull: function(value) {
                    if (value === undefined) value = true;
                    this.skipCull = value;
                    return this;
                },
                /**
     * When a Camera culls the tiles in this layer it does so using its view into the world, building up a
     * rectangle inside which the tiles must exist or they will be culled. Sometimes you may need to expand the size
     * of this 'cull rectangle', especially if you plan on rotating the Camera viewing the layer. Do so
     * by providing the padding values. The values given are in tiles, not pixels. So if the tile width was 32px
     * and you set `paddingX` to be 4, it would add 32px x 4 to the cull rectangle (adjusted for scale)
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCullPadding
     * @since 3.50.0
     *
     * @param {number} [paddingX=1] - The amount of extra horizontal tiles to add to the cull check padding.
     * @param {number} [paddingY=1] - The amount of extra vertical tiles to add to the cull check padding.
     *
     * @return {this} This Tilemap Layer object.
     */ setCullPadding: function(paddingX, paddingY) {
                    if (paddingX === undefined) paddingX = 1;
                    if (paddingY === undefined) paddingY = 1;
                    this.cullPaddingX = paddingX;
                    this.cullPaddingY = paddingY;
                    return this;
                },
                /**
     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
     * collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollision
     * @since 3.50.0
     *
     * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollision: function(indexes, collides, recalculateFaces, updateLayer) {
                    TilemapComponents.SetCollision(indexes, collides, recalculateFaces, this.layer, updateLayer);
                    return this;
                },
                /**
     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
     * enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionBetween
     * @since 3.50.0
     *
     * @param {number} start - The first index of the tile to be set for collision.
     * @param {number} stop - The last index of the tile to be set for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionBetween: function(start, stop, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
     * that matches the given properties object, its collision flag will be set. The `collides`
     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
     * "types" property that matches any of those values, its collision flag will be updated.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByProperty
     * @since 3.50.0
     *
     * @param {object} properties - An object with tile properties and corresponding values that should be checked.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByProperty: function(properties, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
     * the given array. The `collides` parameter controls if collision will be enabled (true) or
     * disabled (false). Tile indexes not currently in the layer are not affected.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionByExclusion
     * @since 3.50.0
     *
     * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionByExclusion: function(indexes, collides, recalculateFaces) {
                    TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets collision on the tiles within a layer by checking each tiles collision group data
     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
     * a tiles collision group, the tile's colliding information will be set. The `collides` parameter
     * controls if collision will be enabled (true) or disabled (false).
     *
     * @method Phaser.Tilemaps.TilemapLayer#setCollisionFromCollisionGroup
     * @since 3.50.0
     *
     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the update.
     *
     * @return {this} This Tilemap Layer object.
     */ setCollisionFromCollisionGroup: function(collides, recalculateFaces) {
                    TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, this.layer);
                    return this;
                },
                /**
     * Sets a global collision callback for the given tile index within the layer. This will affect all
     * tiles on this layer that have the same index. If a callback is already set for the tile index it
     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
     * at a specific location on the map then see setTileLocationCallback.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileIndexCallback
     * @since 3.50.0
     *
     * @param {(number|number[])} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
     * @param {function} callback - The callback that will be invoked when the tile is collided with.
     * @param {object} callbackContext - The context under which the callback is called.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileIndexCallback: function(indexes, callback, callbackContext) {
                    TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, this.layer);
                    return this;
                },
                /**
     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
     * remove it.
     *
     * @method Phaser.Tilemaps.TilemapLayer#setTileLocationCallback
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     * @param {function} [callback] - The callback that will be invoked when the tile is collided with.
     * @param {object} [callbackContext] - The context, or scope, under which the callback is invoked.
     *
     * @return {this} This Tilemap Layer object.
     */ setTileLocationCallback: function(tileX, tileY, width, height, callback, callbackContext) {
                    TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, this.layer);
                    return this;
                },
                /**
     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
     * appear to have changed! This method only modifies tile indexes and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#shuffle
     * @since 3.50.0
     *
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ shuffle: function(tileX, tileY, width, height) {
                    TilemapComponents.Shuffle(tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
     * information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#swapByIndex
     * @since 3.50.0
     *
     * @param {number} tileA - First tile index.
     * @param {number} tileB - Second tile index.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ swapByIndex: function(indexA, indexB, tileX, tileY, width, height) {
                    TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, this.layer);
                    return this;
                },
                /**
     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldX
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile X coordinate converted to pixels.
     */ tileToWorldX: function(tileX, camera) {
                    return this.tilemap.tileToWorldX(tileX, camera, this);
                },
                /**
     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldY
     * @since 3.50.0
     *
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The Tile Y coordinate converted to pixels.
     */ tileToWorldY: function(tileY, camera) {
                    return this.tilemap.tileToWorldY(tileY, camera, this);
                },
                /**
     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#tileToWorldXY
     * @since 3.50.0
     *
     * @param {number} tileX - The x coordinate, in tiles, not pixels.
     * @param {number} tileY - The y coordinate, in tiles, not pixels.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the world coordinates of the Tile.
     */ tileToWorldXY: function(tileX, tileY, point, camera) {
                    return this.tilemap.tileToWorldXY(tileX, tileY, point, camera, this);
                },
                /**
     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
     * weightedIndexes array. An example weighted array:
     *
     * [
     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
     * ]
     *
     * The probability of any index being choose is (the index's weight) / (sum of all weights). This
     * method only modifies tile indexes and does not change collision information.
     *
     * @method Phaser.Tilemaps.TilemapLayer#weightedRandomize
     * @since 3.50.0
     *
     * @param {object[]} weightedIndexes - An array of objects to randomly draw from during randomization. They should be in the form: { index: 0, weight: 4 } or { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
     * @param {number} [tileX] - The left most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [tileY] - The top most tile index (in tile coordinates) to use as the origin of the area.
     * @param {number} [width] - How many tiles wide from the `tileX` index the area will be.
     * @param {number} [height] - How many tiles tall from the `tileY` index the area will be.
     *
     * @return {this} This Tilemap Layer object.
     */ weightedRandomize: function(weightedIndexes, tileX, tileY, width, height) {
                    TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, this.layer);
                    return this;
                },
                /**
     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileX
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile X coordinate based on the world value.
     */ worldToTileX: function(worldX, snapToFloor, camera) {
                    return this.tilemap.worldToTileX(worldX, snapToFloor, camera, this);
                },
                /**
     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
     * layers position, scale and scroll.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileY
     * @since 3.50.0
     *
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {number} The tile Y coordinate based on the world value.
     */ worldToTileY: function(worldY, snapToFloor, camera) {
                    return this.tilemap.worldToTileY(worldY, snapToFloor, camera, this);
                },
                /**
     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
     * layers position, scale and scroll. This will return a new Vector2 object or update the given
     * `point` object.
     *
     * @method Phaser.Tilemaps.TilemapLayer#worldToTileXY
     * @since 3.50.0
     *
     * @param {number} worldX - The x coordinate to be converted, in pixels, not tiles.
     * @param {number} worldY - The y coordinate to be converted, in pixels, not tiles.
     * @param {boolean} [snapToFloor] - Whether or not to round the tile coordinate down to the nearest integer.
     * @param {Phaser.Math.Vector2} [point] - A Vector2 to store the coordinates in. If not given a new Vector2 is created.
     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use when calculating the tile index from the world values.
     *
     * @return {Phaser.Math.Vector2} A Vector2 containing the tile coordinates of the world values.
     */ worldToTileXY: function(worldX, worldY, snapToFloor, point, camera) {
                    return this.tilemap.worldToTileXY(worldX, worldY, snapToFloor, point, camera, this);
                },
                /**
     * Destroys this TilemapLayer and removes its link to the associated LayerData.
     *
     * @method Phaser.Tilemaps.TilemapLayer#destroy
     * @since 3.50.0
     *
     * @param {boolean} [removeFromTilemap=true] - Remove this layer from the parent Tilemap?
     */ destroy: function(removeFromTilemap) {
                    if (removeFromTilemap === undefined) removeFromTilemap = true;
                    if (!this.tilemap) //  Abort, we've already been destroyed
                    return;
                    //  Uninstall this layer only if it is still installed on the LayerData object
                    if (this.layer.tilemapLayer === this) this.layer.tilemapLayer = undefined;
                    if (removeFromTilemap) this.tilemap.removeLayer(this);
                    this.tilemap = undefined;
                    this.layer = undefined;
                    this.culledTiles.length = 0;
                    this.cullCallback = null;
                    this.gidMap = [];
                    this.tileset = [];
                    GameObject.prototype.destroy.call(this);
                }
            });
            module1.exports = TilemapLayer;
        /***/ },
        /* 578 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            /**
 * @classdesc
 * A Timer Event represents a delayed function call. It's managed by a Scene's {@link Clock} and will call its function after a set amount of time has passed. The Timer Event can optionally repeat - i.e. call its function multiple times before finishing, or loop indefinitely.
 *
 * Because it's managed by a Clock, a Timer Event is based on game time, will be affected by its Clock's time scale, and will pause if its Clock pauses.
 *
 * @class TimerEvent
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Time.TimerEventConfig} config - The configuration for the Timer Event, including its delay and callback.
 */ var TimerEvent = new Class({
                initialize: function TimerEvent(config) {
                    /**
         * The delay in ms at which this TimerEvent fires.
         *
         * @name Phaser.Time.TimerEvent#delay
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.delay = 0;
                    /**
         * The total number of times this TimerEvent will repeat before finishing.
         *
         * @name Phaser.Time.TimerEvent#repeat
         * @type {number}
         * @default 0
         * @readonly
         * @since 3.0.0
         */ this.repeat = 0;
                    /**
         * If repeating this contains the current repeat count.
         *
         * @name Phaser.Time.TimerEvent#repeatCount
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.repeatCount = 0;
                    /**
         * True if this TimerEvent loops, otherwise false.
         *
         * @name Phaser.Time.TimerEvent#loop
         * @type {boolean}
         * @default false
         * @readonly
         * @since 3.0.0
         */ this.loop = false;
                    /**
         * The callback that will be called when the TimerEvent occurs.
         *
         * @name Phaser.Time.TimerEvent#callback
         * @type {function}
         * @since 3.0.0
         */ this.callback;
                    /**
         * The scope in which the callback will be called.
         *
         * @name Phaser.Time.TimerEvent#callbackScope
         * @type {object}
         * @since 3.0.0
         */ this.callbackScope;
                    /**
         * Additional arguments to be passed to the callback.
         *
         * @name Phaser.Time.TimerEvent#args
         * @type {array}
         * @since 3.0.0
         */ this.args;
                    /**
         * Scale the time causing this TimerEvent to update.
         *
         * @name Phaser.Time.TimerEvent#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Start this many MS into the elapsed (useful if you want a long duration with repeat, but for the first loop to fire quickly)
         *
         * @name Phaser.Time.TimerEvent#startAt
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.startAt = 0;
                    /**
         * The time in milliseconds which has elapsed since the Timer Event's creation.
         *
         * This value is local for the Timer Event and is relative to its Clock. As such, it's influenced by the Clock's time scale and paused state, the Timer Event's initial {@link #startAt} property, and the Timer Event's {@link #timeScale} and {@link #paused} state.
         *
         * @name Phaser.Time.TimerEvent#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Whether or not this timer is paused.
         *
         * @name Phaser.Time.TimerEvent#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Whether the Timer Event's function has been called.
         *
         * When the Timer Event fires, this property will be set to `true` before the callback function is invoked and will be reset immediately afterward if the Timer Event should repeat. The value of this property does not directly influence whether the Timer Event will be removed from its Clock, but can prevent it from firing.
         *
         * @name Phaser.Time.TimerEvent#hasDispatched
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.hasDispatched = false;
                    this.reset(config);
                },
                /**
     * Completely reinitializes the Timer Event, regardless of its current state, according to a configuration object.
     *
     * @method Phaser.Time.TimerEvent#reset
     * @since 3.0.0
     *
     * @param {Phaser.Types.Time.TimerEventConfig} config - The new state for the Timer Event.
     *
     * @return {Phaser.Time.TimerEvent} This TimerEvent object.
     */ reset: function(config) {
                    this.delay = GetFastValue(config, 'delay', 0);
                    //  Can also be set to -1 for an infinite loop (same as setting loop: true)
                    this.repeat = GetFastValue(config, 'repeat', 0);
                    this.loop = GetFastValue(config, 'loop', false);
                    this.callback = GetFastValue(config, 'callback', undefined);
                    this.callbackScope = GetFastValue(config, 'callbackScope', this.callback);
                    this.args = GetFastValue(config, 'args', []);
                    this.timeScale = GetFastValue(config, 'timeScale', 1);
                    this.startAt = GetFastValue(config, 'startAt', 0);
                    this.paused = GetFastValue(config, 'paused', false);
                    this.elapsed = this.startAt;
                    this.hasDispatched = false;
                    this.repeatCount = this.repeat === -1 || this.loop ? 999999999999 : this.repeat;
                    return this;
                },
                /**
     * Gets the progress of the current iteration, not factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getProgress
     * @since 3.0.0
     *
     * @return {number} A number between 0 and 1 representing the current progress.
     */ getProgress: function() {
                    return this.elapsed / this.delay;
                },
                /**
     * Gets the progress of the timer overall, factoring in repeats.
     *
     * @method Phaser.Time.TimerEvent#getOverallProgress
     * @since 3.0.0
     *
     * @return {number} The overall progress of the Timer Event, between 0 and 1.
     */ getOverallProgress: function() {
                    if (this.repeat > 0) {
                        var totalDuration = this.delay + this.delay * this.repeat;
                        var totalElapsed = this.elapsed + this.delay * (this.repeat - this.repeatCount);
                        return totalElapsed / totalDuration;
                    } else return this.getProgress();
                },
                /**
     * Returns the number of times this Timer Event will repeat before finishing.
     *
     * This should not be confused with the number of times the Timer Event will fire before finishing. A return value of 0 doesn't indicate that the Timer Event has finished running - it indicates that it will not repeat after the next time it fires.
     *
     * @method Phaser.Time.TimerEvent#getRepeatCount
     * @since 3.0.0
     *
     * @return {number} How many times the Timer Event will repeat.
     */ getRepeatCount: function() {
                    return this.repeatCount;
                },
                /**
     * Returns the local elapsed time for the current iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getElapsed
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in milliseconds.
     */ getElapsed: function() {
                    return this.elapsed;
                },
                /**
     * Returns the local elapsed time for the current iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getElapsedSeconds
     * @since 3.0.0
     *
     * @return {number} The local elapsed time in seconds.
     */ getElapsedSeconds: function() {
                    return this.elapsed * 0.001;
                },
                /**
     * Returns the time interval until the next iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getRemaining: function() {
                    return this.delay - this.elapsed;
                },
                /**
     * Returns the time interval until the next iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getRemainingSeconds: function() {
                    return this.getRemaining() * 0.001;
                },
                /**
     * Returns the time interval until the last iteration of the Timer Event.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemaining
     * @since 3.50.0
     *
     * @return {number} The time interval in milliseconds.
     */ getOverallRemaining: function() {
                    return this.delay * (1 + this.repeatCount) - this.elapsed;
                },
                /**
     * Returns the time interval until the last iteration of the Timer Event in seconds.
     *
     * @method Phaser.Time.TimerEvent#getOverallRemainingSeconds
     * @since 3.50.0
     *
     * @return {number} The time interval in seconds.
     */ getOverallRemainingSeconds: function() {
                    return this.getOverallRemaining() * 0.001;
                },
                /**
     * Forces the Timer Event to immediately expire, thus scheduling its removal in the next frame.
     *
     * @method Phaser.Time.TimerEvent#remove
     * @since 3.0.0
     *
     * @param {boolean} [dispatchCallback=false] - If `true`, the function of the Timer Event will be called before its removal.
     */ remove: function(dispatchCallback) {
                    if (dispatchCallback === undefined) dispatchCallback = false;
                    this.elapsed = this.delay;
                    this.hasDispatched = !dispatchCallback;
                    this.repeatCount = 0;
                },
                /**
     * Destroys all object references in the Timer Event, i.e. its callback, scope, and arguments.
     *
     * Normally, this method is only called by the Clock when it shuts down. As such, it doesn't stop the Timer Event. If called manually, the Timer Event will still be updated by the Clock, but it won't do anything when it fires.
     *
     * @method Phaser.Time.TimerEvent#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.callback = undefined;
                    this.callbackScope = undefined;
                    this.args = [];
                }
            });
            module1.exports = TimerEvent;
        /***/ },
        /* 579 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RESERVED = __webpack_require__(1458);
            /**
 * Internal function used by the Tween Builder to return an array of properties
 * that the Tween will be operating on. It takes a tween configuration object
 * and then checks that none of the `props` entries start with an underscore, or that
 * none of the direct properties are on the Reserved list.
 *
 * @function Phaser.Tweens.Builders.GetProps
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TweenBuilderConfig} config - The configuration object of the Tween to get the properties from.
 *
 * @return {string[]} An array of all the properties the tween will operate on.
 */ var GetProps = function(config) {
                var key;
                var keys = [];
                //  First see if we have a props object
                if (config.hasOwnProperty('props')) {
                    for(key in config.props)//  Skip any property that starts with an underscore
                    if (key.substr(0, 1) !== '_') keys.push({
                        key: key,
                        value: config.props[key]
                    });
                } else {
                    for(key in config)//  Skip any property that is in the ReservedProps list or that starts with an underscore
                    if (RESERVED.indexOf(key) === -1 && key.substr(0, 1) !== '_') keys.push({
                        key: key,
                        value: config[key]
                    });
                }
                return keys;
            };
            module1.exports = GetProps;
        /***/ },
        /* 580 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Internal function used by the Timeline Builder.
 * 
 * It returns an array of all tweens in the given timeline config.
 *
 * @function Phaser.Tweens.Builders.GetTweens
 * @since 3.0.0
 *
 * @param {Phaser.Types.Tweens.TimelineBuilderConfig} config - The configuration object for the Timeline.
 *
 * @return {Phaser.Tweens.Tween[]} An array of Tween instances that the Timeline will manage.
 */ var GetTweens = function(config) {
                var tweens = GetValue(config, 'tweens', null);
                if (tweens === null) return [];
                else if (typeof tweens === 'function') tweens = tweens.call();
                if (!Array.isArray(tweens)) tweens = [
                    tweens
                ];
                return tweens;
            };
            module1.exports = GetTweens;
        /***/ },
        /* 581 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Defaults = __webpack_require__(261);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(96);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(160);
            var GetValue = __webpack_require__(6);
            var GetValueOp = __webpack_require__(260);
            var Tween = __webpack_require__(262);
            var TweenData = __webpack_require__(264);
            /**
 * Creates a new Number Tween.
 *
 * @function Phaser.Tweens.Builders.NumberTweenBuilder
 * @since 3.0.0
 *
 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - The owner of the new Tween.
 * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - Configuration for the new Tween.
 * @param {Phaser.Types.Tweens.TweenConfigDefaults} defaults - Tween configuration defaults.
 *
 * @return {Phaser.Tweens.Tween} The new tween.
 */ var NumberTweenBuilder = function(parent, config, defaults) {
                if (defaults === undefined) defaults = Defaults;
                //  var tween = this.tweens.addCounter({
                //      from: 100,
                //      to: 200,
                //      ... (normal tween properties)
                //  })
                //
                //  Then use it in your game via:
                //
                //  tween.getValue()
                var from = GetValue(config, 'from', 0);
                var to = GetValue(config, 'to', 1);
                var targets = [
                    {
                        value: from
                    }
                ];
                var delay = GetNewValue(config, 'delay', defaults.delay);
                var duration = GetNewValue(config, 'duration', defaults.duration);
                var easeParams = GetValue(config, 'easeParams', defaults.easeParams);
                var ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), easeParams);
                var hold = GetNewValue(config, 'hold', defaults.hold);
                var repeat = GetNewValue(config, 'repeat', defaults.repeat);
                var repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
                var yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
                var data = [];
                var ops = GetValueOp('value', to);
                var tweenData = TweenData(targets[0], 0, 'value', ops.getEnd, ops.getStart, ops.getActive, ease, delay, duration, yoyo, hold, repeat, repeatDelay, false, false);
                tweenData.start = from;
                tweenData.current = from;
                tweenData.to = to;
                data.push(tweenData);
                var tween = new Tween(parent, data, targets);
                tween.offset = GetAdvancedValue(config, 'offset', null);
                tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
                tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
                tween.paused = GetBoolean(config, 'paused', false);
                tween.useFrames = GetBoolean(config, 'useFrames', false);
                //  Set the Callbacks
                var scope = GetValue(config, 'callbackScope', tween);
                //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
                var tweenArray = [
                    tween,
                    null
                ];
                var callbacks = Tween.TYPES;
                for(var i = 0; i < callbacks.length; i++){
                    var type = callbacks[i];
                    var callback = GetValue(config, type, false);
                    if (callback) {
                        var callbackScope = GetValue(config, type + 'Scope', scope);
                        var callbackParams = GetValue(config, type + 'Params', []);
                        //  The null is reset to be the Tween target
                        tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
                    }
                }
                return tween;
            };
            module1.exports = NumberTweenBuilder;
        /***/ },
        /* 582 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetEaseFunction = __webpack_require__(80);
            var GetValue = __webpack_require__(6);
            var MATH_CONST = __webpack_require__(14);
            /**
 * Creates a Stagger function to be used by a Tween property.
 * 
 * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
 * 
 * This is only worth using if the tween has multiple targets.
 * 
 * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
 * over the duration specified:
 * 
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(100)
 * });
 * ```
 * 
 * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
 * from the center out, using a cubic ease.
 * 
 * ```javascript
 * this.tweens.add({
 *     targets: [ ... ],
 *     scale: 0.2,
 *     ease: 'linear',
 *     duration: 1000,
 *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
 * });
 * ```
 *
 * @function Phaser.Tweens.Builders.StaggerBuilder
 * @since 3.19.0
 *
 * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
 * @param {Phaser.Types.Tweens.StaggerConfig} [config] - A Stagger Configuration object.
 *
 * @return {function} The stagger function.
 */ var StaggerBuilder = function(value, options) {
                if (options === undefined) options = {};
                var result;
                var start = GetValue(options, 'start', 0);
                var ease = GetValue(options, 'ease', null);
                var grid = GetValue(options, 'grid', null);
                var from = GetValue(options, 'from', 0);
                var fromFirst = from === 'first';
                var fromCenter = from === 'center';
                var fromLast = from === 'last';
                var fromValue = typeof from === 'number';
                var isRange = Array.isArray(value);
                var value1 = isRange ? parseFloat(value[0]) : parseFloat(value);
                var value2 = isRange ? parseFloat(value[1]) : 0;
                var maxValue = Math.max(value1, value2);
                if (isRange) start += value1;
                if (grid) {
                    //  Pre-calc the grid to save doing it for ever tweendata update
                    var gridWidth = grid[0];
                    var gridHeight = grid[1];
                    var fromX = 0;
                    var fromY = 0;
                    var distanceX = 0;
                    var distanceY = 0;
                    var gridValues = [];
                    if (fromLast) {
                        fromX = gridWidth - 1;
                        fromY = gridHeight - 1;
                    } else if (fromValue) {
                        fromX = from % gridWidth;
                        fromY = Math.floor(from / gridWidth);
                    } else if (fromCenter) {
                        fromX = (gridWidth - 1) / 2;
                        fromY = (gridHeight - 1) / 2;
                    }
                    var gridMax = MATH_CONST.MIN_SAFE_INTEGER;
                    for(var toY = 0; toY < gridHeight; toY++){
                        gridValues[toY] = [];
                        for(var toX = 0; toX < gridWidth; toX++){
                            distanceX = fromX - toX;
                            distanceY = fromY - toY;
                            var dist = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                            if (dist > gridMax) gridMax = dist;
                            gridValues[toY][toX] = dist;
                        }
                    }
                }
                var easeFunction = ease ? GetEaseFunction(ease) : null;
                if (grid) result = function(target, key, value, index) {
                    var gridSpace = 0;
                    var toX = index % gridWidth;
                    var toY = Math.floor(index / gridWidth);
                    if (toX >= 0 && toX < gridWidth && toY >= 0 && toY < gridHeight) gridSpace = gridValues[toY][toX];
                    var output;
                    if (isRange) {
                        var diff = value2 - value1;
                        if (easeFunction) output = gridSpace / gridMax * diff * easeFunction(gridSpace / gridMax);
                        else output = gridSpace / gridMax * diff;
                    } else if (easeFunction) output = gridSpace * value1 * easeFunction(gridSpace / gridMax);
                    else output = gridSpace * value1;
                    return output + start;
                };
                else result = function(target, key, value, index, total) {
                    //  zero offset
                    total--;
                    var fromIndex;
                    if (fromFirst) fromIndex = index;
                    else if (fromCenter) fromIndex = Math.abs(total / 2 - index);
                    else if (fromLast) fromIndex = total - index;
                    else if (fromValue) fromIndex = Math.abs(from - index);
                    var output;
                    if (isRange) {
                        var spacing;
                        if (fromCenter) spacing = (value2 - value1) / total * (fromIndex * 2);
                        else spacing = (value2 - value1) / total * fromIndex;
                        if (easeFunction) output = spacing * easeFunction(fromIndex / total);
                        else output = spacing;
                    } else if (easeFunction) output = total * maxValue * easeFunction(fromIndex / total);
                    else output = fromIndex * value1;
                    return output + start;
                };
                return result;
            };
            module1.exports = StaggerBuilder;
        /***/ },
        /* 583 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            var Defaults = __webpack_require__(261);
            var GetAdvancedValue = __webpack_require__(13);
            var GetBoolean = __webpack_require__(96);
            var GetEaseFunction = __webpack_require__(80);
            var GetNewValue = __webpack_require__(160);
            var GetTargets = __webpack_require__(259);
            var GetTweens = __webpack_require__(580);
            var GetValue = __webpack_require__(6);
            var Timeline = __webpack_require__(584);
            var TweenBuilder = __webpack_require__(161);
            /**
 * Builds a Timeline of Tweens based on a configuration object.
 *
 * @function Phaser.Tweens.Builders.TimelineBuilder
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} manager - The Tween Manager to which the Timeline will belong.
 * @param {Phaser.Types.Tweens.TimelineBuilderConfig} config - The configuration object for the Timeline.
 *
 * @return {Phaser.Tweens.Timeline} The created Timeline.
 */ var TimelineBuilder = function(manager, config) {
                var timeline = new Timeline(manager);
                timeline.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
                timeline.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
                timeline.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
                timeline.paused = GetBoolean(config, 'paused', false);
                timeline.useFrames = GetBoolean(config, 'useFrames', false);
                //  Callbacks
                var scope = GetValue(config, 'callbackScope', timeline);
                var timelineArray = [
                    timeline
                ];
                var onStart = GetValue(config, 'onStart', false);
                //  The Start of the Timeline
                if (onStart) {
                    var onStartScope = GetValue(config, 'onStartScope', scope);
                    var onStartParams = GetValue(config, 'onStartParams', []);
                    timeline.setCallback('onStart', onStart, timelineArray.concat(onStartParams), onStartScope);
                }
                var onUpdate = GetValue(config, 'onUpdate', false);
                //  Every time the Timeline updates (regardless which Tweens are running)
                if (onUpdate) {
                    var onUpdateScope = GetValue(config, 'onUpdateScope', scope);
                    var onUpdateParams = GetValue(config, 'onUpdateParams', []);
                    timeline.setCallback('onUpdate', onUpdate, timelineArray.concat(onUpdateParams), onUpdateScope);
                }
                var onLoop = GetValue(config, 'onLoop', false);
                //  Called when the whole Timeline loops
                if (onLoop) {
                    var onLoopScope = GetValue(config, 'onLoopScope', scope);
                    var onLoopParams = GetValue(config, 'onLoopParams', []);
                    timeline.setCallback('onLoop', onLoop, timelineArray.concat(onLoopParams), onLoopScope);
                }
                var onYoyo = GetValue(config, 'onYoyo', false);
                //  Called when a Timeline yoyos
                if (onYoyo) {
                    var onYoyoScope = GetValue(config, 'onYoyoScope', scope);
                    var onYoyoParams = GetValue(config, 'onYoyoParams', []);
                    timeline.setCallback('onYoyo', onYoyo, timelineArray.concat(null, onYoyoParams), onYoyoScope);
                }
                var onComplete = GetValue(config, 'onComplete', false);
                //  Called when the Timeline completes, after the completeDelay, etc.
                if (onComplete) {
                    var onCompleteScope = GetValue(config, 'onCompleteScope', scope);
                    var onCompleteParams = GetValue(config, 'onCompleteParams', []);
                    timeline.setCallback('onComplete', onComplete, timelineArray.concat(onCompleteParams), onCompleteScope);
                }
                // Tweens
                var tweens = GetTweens(config);
                if (tweens.length === 0) {
                    timeline.paused = true;
                    return timeline;
                }
                var defaults = Clone(Defaults);
                defaults.targets = GetTargets(config);
                //  totalDuration: If specified each tween in the Timeline is given an equal portion of the totalDuration
                var totalDuration = GetAdvancedValue(config, 'totalDuration', 0);
                if (totalDuration > 0) defaults.duration = Math.floor(totalDuration / tweens.length);
                else defaults.duration = GetNewValue(config, 'duration', defaults.duration);
                defaults.delay = GetNewValue(config, 'delay', defaults.delay);
                defaults.easeParams = GetValue(config, 'easeParams', defaults.easeParams);
                defaults.ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), defaults.easeParams);
                defaults.hold = GetNewValue(config, 'hold', defaults.hold);
                defaults.repeat = GetNewValue(config, 'repeat', defaults.repeat);
                defaults.repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
                defaults.yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
                defaults.flipX = GetBoolean(config, 'flipX', defaults.flipX);
                defaults.flipY = GetBoolean(config, 'flipY', defaults.flipY);
                //  Create the Tweens
                for(var i = 0; i < tweens.length; i++)timeline.queue(TweenBuilder(timeline, tweens[i], defaults));
                return timeline;
            };
            module1.exports = TimelineBuilder;
        /***/ },
        /* 584 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(263);
            var TweenBuilder = __webpack_require__(161);
            var TWEEN_CONST = __webpack_require__(97);
            /**
 * @classdesc
 * A Timeline combines multiple Tweens into one. Its overall behavior is otherwise similar to a single Tween.
 *
 * The Timeline updates all of its Tweens simultaneously. Its methods allow you to easily build a sequence
 * of Tweens (each one starting after the previous one) or run multiple Tweens at once during given parts of the Timeline.
 *
 * @class Timeline
 * @memberof Phaser.Tweens
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Tweens.TweenManager} manager - The Tween Manager which owns this Timeline.
 */ var Timeline = new Class({
                Extends: EventEmitter,
                initialize: function Timeline(manager) {
                    EventEmitter.call(this);
                    /**
         * The Tween Manager which owns this Timeline.
         *
         * @name Phaser.Tweens.Timeline#manager
         * @type {Phaser.Tweens.TweenManager}
         * @since 3.0.0
         */ this.manager = manager;
                    /**
         * A constant value which allows this Timeline to be easily identified as one.
         *
         * @name Phaser.Tweens.Timeline#isTimeline
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.isTimeline = true;
                    /**
         * An array of Tween objects, each containing a unique property and target being tweened.
         *
         * @name Phaser.Tweens.Timeline#data
         * @type {array}
         * @default []
         * @since 3.0.0
         */ this.data = [];
                    /**
         * The cached size of the data array.
         *
         * @name Phaser.Tweens.Timeline#totalData
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalData = 0;
                    /**
         * If true then duration, delay, etc values are all frame totals, rather than ms.
         *
         * @name Phaser.Tweens.Timeline#useFrames
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.useFrames = false;
                    /**
         * Scales the time applied to this Timeline. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
         * Value isn't used when calculating total duration of the Timeline, it's a run-time delta adjustment only.
         *
         * @name Phaser.Tweens.Timeline#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Loop this Timeline? Can be -1 for an infinite loop, or an integer.
         * When enabled it will play through ALL Tweens again (use Tween.repeat to loop a single tween)
         *
         * @name Phaser.Tweens.Timeline#loop
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loop = 0;
                    /**
         * Time in ms/frames before this Timeline loops.
         *
         * @name Phaser.Tweens.Timeline#loopDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopDelay = 0;
                    /**
         * How many loops are left to run?
         *
         * @name Phaser.Tweens.Timeline#loopCounter
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.loopCounter = 0;
                    /**
         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = true (as it never completes)
         *
         * @name Phaser.Tweens.Timeline#completeDelay
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.completeDelay = 0;
                    /**
         * Countdown timer value, as used by `loopDelay` and `completeDelay`.
         *
         * @name Phaser.Tweens.Timeline#countdown
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.countdown = 0;
                    /**
         * The current state of the Timeline.
         *
         * @name Phaser.Tweens.Timeline#state
         * @type {number}
         * @since 3.0.0
         */ this.state = TWEEN_CONST.PENDING_ADD;
                    /**
         * The state of the Timeline when it was paused (used by Resume)
         *
         * @name Phaser.Tweens.Timeline#_pausedState
         * @type {number}
         * @private
         * @since 3.0.0
         */ this._pausedState = TWEEN_CONST.PENDING_ADD;
                    /**
         * Does the Timeline start off paused? (if so it needs to be started with Timeline.play)
         *
         * @name Phaser.Tweens.Timeline#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * Elapsed time in ms/frames of this run through of the Timeline.
         *
         * @name Phaser.Tweens.Timeline#elapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.elapsed = 0;
                    /**
         * Total elapsed time in ms/frames of the entire Timeline, including looping.
         *
         * @name Phaser.Tweens.Timeline#totalElapsed
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalElapsed = 0;
                    /**
         * Time in ms/frames for the whole Timeline to play through once, excluding loop amounts and loop delays.
         *
         * @name Phaser.Tweens.Timeline#duration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.duration = 0;
                    /**
         * Value between 0 and 1. The amount of progress through the Timeline, _excluding loops_.
         *
         * @name Phaser.Tweens.Timeline#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Time in ms/frames for all Tweens in this Timeline to complete (including looping)
         *
         * @name Phaser.Tweens.Timeline#totalDuration
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalDuration = 0;
                    /**
         * Value between 0 and 1. The amount through the entire Timeline, including looping.
         *
         * @name Phaser.Tweens.Timeline#totalProgress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalProgress = 0;
                    /**
         * An object containing the different Tween callback functions.
         * 
         * You can either set these in the Tween config, or by calling the `Tween.setCallback` method.
         * 
         * `onComplete` When the Timeline finishes playback fully or `Timeline.stop` is called. Never invoked if timeline is set to repeat infinitely.
         * `onLoop` When a Timeline loops.
         * `onStart` When the Timeline starts playing.
         * `onUpdate` When a Timeline updates a child Tween.
         * `onYoyo` When a Timeline starts a yoyo.
         *
         * @name Phaser.Tweens.Timeline#callbacks
         * @type {object}
         * @since 3.0.0
         */ this.callbacks = {
                        onComplete: null,
                        onLoop: null,
                        onStart: null,
                        onUpdate: null,
                        onYoyo: null
                    };
                    /**
         * The context in which all callbacks are invoked.
         *
         * @name Phaser.Tweens.Timeline#callbackScope
         * @type {any}
         * @since 3.0.0
         */ this.callbackScope;
                },
                /**
     * Internal method that will emit a Timeline based Event and invoke the given callback.
     *
     * @method Phaser.Tweens.Timeline#dispatchTimelineEvent
     * @since 3.19.0
     *
     * @param {Phaser.Types.Tweens.Event} event - The Event to be dispatched.
     * @param {function} callback - The callback to be invoked. Can be `null` or `undefined` to skip invocation.
     */ dispatchTimelineEvent: function(event, callback) {
                    this.emit(event, this);
                    if (callback) callback.func.apply(callback.scope, callback.params);
                },
                /**
     * Sets the value of the time scale applied to this Timeline. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     * 
     * The value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
     *
     * @method Phaser.Tweens.Timeline#setTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The time scale value to set.
     *
     * @return {this} This Timeline object.
     */ setTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * Gets the value of the time scale applied to this Timeline. A value of 1 runs in real-time.
     * A value of 0.5 runs 50% slower, and so on.
     *
     * @method Phaser.Tweens.Timeline#getTimeScale
     * @since 3.0.0
     *
     * @return {number} The value of the time scale applied to this Timeline.
     */ getTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Check whether or not the Timeline is playing.
     *
     * @method Phaser.Tweens.Timeline#isPlaying
     * @since 3.0.0
     *
     * @return {boolean} `true` if this Timeline is active, otherwise `false`.
     */ isPlaying: function() {
                    return this.state === TWEEN_CONST.ACTIVE;
                },
                /**
     * Creates a new Tween, based on the given Tween Config, and adds it to this Timeline.
     *
     * @method Phaser.Tweens.Timeline#add
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Tweens.TweenBuilderConfig|object)} config - The configuration object for the Tween.
     *
     * @return {this} This Timeline object.
     */ add: function(config) {
                    return this.queue(TweenBuilder(this, config));
                },
                /**
     * Adds an existing Tween to this Timeline.
     *
     * @method Phaser.Tweens.Timeline#queue
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be added to this Timeline.
     *
     * @return {this} This Timeline object.
     */ queue: function(tween) {
                    if (!this.isPlaying()) {
                        tween.parent = this;
                        tween.parentIsTimeline = true;
                        this.data.push(tween);
                        this.totalData = this.data.length;
                    }
                    return this;
                },
                /**
     * Checks whether a Tween has an offset value.
     *
     * @method Phaser.Tweens.Timeline#hasOffset
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {boolean} `true` if the tween has a non-null offset.
     */ hasOffset: function(tween) {
                    return tween.offset !== null;
                },
                /**
     * Checks whether the offset value is a number or a directive that is relative to previous tweens.
     *
     * @method Phaser.Tweens.Timeline#isOffsetAbsolute
     * @since 3.0.0
     *
     * @param {number} value - The offset value to be evaluated.
     *
     * @return {boolean} `true` if the result is a number, `false` if it is a directive like " -= 1000".
     */ isOffsetAbsolute: function(value) {
                    return typeof value === 'number';
                },
                /**
     * Checks if the offset is a relative value rather than an absolute one.
     * If the value is just a number, this returns false.
     *
     * @method Phaser.Tweens.Timeline#isOffsetRelative
     * @since 3.0.0
     *
     * @param {string} value - The offset value to be evaluated.
     *
     * @return {boolean} `true` if the value is relative, i.e " -= 1000". If `false`, the offset is absolute.
     */ isOffsetRelative: function(value) {
                    var t = typeof value;
                    if (t === 'string') {
                        var op = value[0];
                        if (op === '-' || op === '+') return true;
                    }
                    return false;
                },
                /**
     * Parses the relative offset value, returning a positive or negative number.
     *
     * @method Phaser.Tweens.Timeline#getRelativeOffset
     * @since 3.0.0
     *
     * @param {string} value - The relative offset, in the format of '-=500', for example. The first character determines whether it will be a positive or negative number. Spacing matters here.
     * @param {number} base - The value to use as the offset.
     *
     * @return {number} The parsed offset value.
     */ getRelativeOffset: function(value, base) {
                    var op = value[0];
                    var num = parseFloat(value.substr(2));
                    var result = base;
                    switch(op){
                        case '+':
                            result += num;
                            break;
                        case '-':
                            result -= num;
                            break;
                    }
                    //  Cannot ever be < 0
                    return Math.max(0, result);
                },
                /**
     * Calculates the total duration of the timeline.
     * 
     * Computes all tween durations and returns the full duration of the timeline.
     * 
     * The resulting number is stored in the timeline, not as a return value.
     *
     * @method Phaser.Tweens.Timeline#calcDuration
     * @since 3.0.0
     */ calcDuration: function() {
                    var prevEnd = 0;
                    var totalDuration = 0;
                    var offsetDuration = 0;
                    for(var i = 0; i < this.totalData; i++){
                        var tween = this.data[i];
                        tween.init();
                        if (this.hasOffset(tween)) {
                            if (this.isOffsetAbsolute(tween.offset)) {
                                //  An actual number, so it defines the start point from the beginning of the timeline
                                tween.calculatedOffset = tween.offset;
                                if (tween.offset === 0) offsetDuration = 0;
                            } else if (this.isOffsetRelative(tween.offset)) //  A relative offset (i.e. '-=1000', so starts at 'offset' ms relative to the PREVIOUS Tweens ending time)
                            tween.calculatedOffset = this.getRelativeOffset(tween.offset, prevEnd);
                        } else //  Sequential
                        tween.calculatedOffset = offsetDuration;
                        prevEnd = tween.totalDuration + tween.calculatedOffset;
                        totalDuration += tween.totalDuration;
                        offsetDuration += tween.totalDuration;
                    }
                    //  Excludes loop values
                    this.duration = totalDuration;
                    this.loopCounter = this.loop === -1 ? 999999999999 : this.loop;
                    if (this.loopCounter > 0) this.totalDuration = this.duration + this.completeDelay + (this.duration + this.loopDelay) * this.loopCounter;
                    else this.totalDuration = this.duration + this.completeDelay;
                },
                /**
     * Initializes the timeline, which means all Tweens get their init() called, and the total duration will be computed.
     * Returns a boolean indicating whether the timeline is auto-started or not.
     *
     * @method Phaser.Tweens.Timeline#init
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Timeline is started. `false` if it is paused.
     */ init: function() {
                    this.calcDuration();
                    this.progress = 0;
                    this.totalProgress = 0;
                    if (this.paused) {
                        this.state = TWEEN_CONST.PAUSED;
                        return false;
                    } else return true;
                },
                /**
     * Resets all of the timeline's tweens back to their initial states.
     * The boolean parameter indicates whether tweens that are looping should reset as well, or not.
     *
     * @method Phaser.Tweens.Timeline#resetTweens
     * @since 3.0.0
     *
     * @param {boolean} resetFromLoop - If `true`, resets all looping tweens to their initial values.
     */ resetTweens: function(resetFromLoop) {
                    for(var i = 0; i < this.totalData; i++){
                        var tween = this.data[i];
                        tween.play(resetFromLoop);
                    }
                },
                /**
     * Sets a callback for the Timeline.
     *
     * @method Phaser.Tweens.Timeline#setCallback
     * @since 3.0.0
     *
     * @param {string} type - The internal type of callback to set.
     * @param {function} callback - Timeline allows multiple tweens to be linked together to create a streaming sequence.
     * @param {array} [params] - The parameters to pass to the callback.
     * @param {object} [scope] - The context scope of the callback.
     *
     * @return {this} This Timeline object.
     */ setCallback: function(type, callback, params, scope) {
                    if (Timeline.TYPES.indexOf(type) !== -1) this.callbacks[type] = {
                        func: callback,
                        scope: scope,
                        params: params
                    };
                    return this;
                },
                /**
     * Passed a Tween to the Tween Manager and requests it be made active.
     *
     * @method Phaser.Tweens.Timeline#makeActive
     * @since 3.3.0
     *
     * @param {Phaser.Tweens.Tween} tween - The tween object to make active.
     *
     * @return {Phaser.Tweens.TweenManager} The Timeline's Tween Manager reference.
     */ makeActive: function(tween) {
                    return this.manager.makeActive(tween);
                },
                /**
     * Starts playing the Timeline.
     *
     * @method Phaser.Tweens.Timeline#play
     * @fires Phaser.Tweens.Events#TIMELINE_START
     * @since 3.0.0
     */ play: function() {
                    if (this.state === TWEEN_CONST.ACTIVE) return;
                    if (this.paused) {
                        this.paused = false;
                        this.manager.makeActive(this);
                        return;
                    } else {
                        this.resetTweens(false);
                        this.state = TWEEN_CONST.ACTIVE;
                    }
                    this.dispatchTimelineEvent(Events.TIMELINE_START, this.callbacks.onStart);
                },
                /**
     * Updates the Timeline's `state` and fires callbacks and events.
     *
     * @method Phaser.Tweens.Timeline#nextState
     * @fires Phaser.Tweens.Events#TIMELINE_COMPLETE
     * @fires Phaser.Tweens.Events#TIMELINE_LOOP
     * @since 3.0.0
     *
     * @see Phaser.Tweens.Timeline#update
     */ nextState: function() {
                    if (this.loopCounter > 0) {
                        //  Reset the elapsed time
                        this.elapsed = 0;
                        this.progress = 0;
                        this.loopCounter--;
                        this.resetTweens(true);
                        if (this.loopDelay > 0) {
                            this.countdown = this.loopDelay;
                            this.state = TWEEN_CONST.LOOP_DELAY;
                        } else {
                            this.state = TWEEN_CONST.ACTIVE;
                            this.dispatchTimelineEvent(Events.TIMELINE_LOOP, this.callbacks.onLoop);
                        }
                    } else if (this.completeDelay > 0) {
                        this.state = TWEEN_CONST.COMPLETE_DELAY;
                        this.countdown = this.completeDelay;
                    } else {
                        this.state = TWEEN_CONST.PENDING_REMOVE;
                        this.dispatchTimelineEvent(Events.TIMELINE_COMPLETE, this.callbacks.onComplete);
                    }
                },
                /**
     * Returns 'true' if this Timeline has finished and should be removed from the Tween Manager.
     * Otherwise, returns false.
     *
     * @method Phaser.Tweens.Timeline#update
     * @fires Phaser.Tweens.Events#TIMELINE_COMPLETE
     * @fires Phaser.Tweens.Events#TIMELINE_UPDATE
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} Returns `true` if this Timeline has finished and should be removed from the Tween Manager.
     */ update: function(timestamp, delta) {
                    if (this.state === TWEEN_CONST.PAUSED) return;
                    if (this.useFrames) delta = 1 * this.manager.timeScale;
                    delta *= this.timeScale;
                    this.elapsed += delta;
                    this.progress = Math.min(this.elapsed / this.duration, 1);
                    this.totalElapsed += delta;
                    this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
                    switch(this.state){
                        case TWEEN_CONST.ACTIVE:
                            var stillRunning = this.totalData;
                            for(var i = 0; i < this.totalData; i++){
                                var tween = this.data[i];
                                if (tween.update(timestamp, delta)) stillRunning--;
                            }
                            this.dispatchTimelineEvent(Events.TIMELINE_UPDATE, this.callbacks.onUpdate);
                            //  Anything still running? If not, we're done
                            if (stillRunning === 0) this.nextState();
                            break;
                        case TWEEN_CONST.LOOP_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.ACTIVE;
                                this.dispatchTimelineEvent(Events.TIMELINE_LOOP, this.callbacks.onLoop);
                            }
                            break;
                        case TWEEN_CONST.COMPLETE_DELAY:
                            this.countdown -= delta;
                            if (this.countdown <= 0) {
                                this.state = TWEEN_CONST.PENDING_REMOVE;
                                this.dispatchTimelineEvent(Events.TIMELINE_COMPLETE, this.callbacks.onComplete);
                            }
                            break;
                    }
                    return this.state === TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Stops the Timeline immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Timeline#stop
     * @since 3.0.0
     */ stop: function() {
                    this.state = TWEEN_CONST.PENDING_REMOVE;
                },
                /**
     * Pauses the Timeline, retaining its internal state.
     * 
     * Calling this on a Timeline that is already paused has no effect and fires no event.
     *
     * @method Phaser.Tweens.Timeline#pause
     * @fires Phaser.Tweens.Events#TIMELINE_PAUSE
     * @since 3.0.0
     *
     * @return {this} This Timeline object.
     */ pause: function() {
                    if (this.state === TWEEN_CONST.PAUSED) return;
                    this.paused = true;
                    this._pausedState = this.state;
                    this.state = TWEEN_CONST.PAUSED;
                    this.emit(Events.TIMELINE_PAUSE, this);
                    return this;
                },
                /**
     * Resumes a paused Timeline from where it was when it was paused.
     * 
     * Calling this on a Timeline that isn't paused has no effect and fires no event.
     *
     * @method Phaser.Tweens.Timeline#resume
     * @fires Phaser.Tweens.Events#TIMELINE_RESUME
     * @since 3.0.0
     *
     * @return {this} This Timeline object.
     */ resume: function() {
                    if (this.state === TWEEN_CONST.PAUSED) {
                        this.paused = false;
                        this.state = this._pausedState;
                        this.emit(Events.TIMELINE_RESUME, this);
                    }
                    return this;
                },
                /**
     * Checks if any of the Tweens in this Timeline as operating on the target object.
     * 
     * Returns `false` if no Tweens operate on the target object.
     *
     * @method Phaser.Tweens.Timeline#hasTarget
     * @since 3.0.0
     *
     * @param {object} target - The target to check all Tweens against.
     *
     * @return {boolean} `true` if there is at least a single Tween that operates on the target object, otherwise `false`.
     */ hasTarget: function(target) {
                    for(var i = 0; i < this.data.length; i++){
                        if (this.data[i].hasTarget(target)) return true;
                    }
                    return false;
                },
                /**
     * Stops all the Tweens in the Timeline immediately, whatever stage of progress they are at and flags
     * them for removal by the TweenManager.
     *
     * @method Phaser.Tweens.Timeline#destroy
     * @since 3.0.0
     */ destroy: function() {
                    for(var i = 0; i < this.data.length; i++)this.data[i].stop();
                }
            });
            Timeline.TYPES = [
                'onStart',
                'onUpdate',
                'onLoop',
                'onComplete',
                'onYoyo'
            ];
            module1.exports = Timeline;
        /***/ },
        /* 585 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
*
* @class Axes
*/ var Axes = {};
            module1.exports = Axes;
            var Vector = __webpack_require__(116);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Creates a new set of axes from the given vertices.
     * @method fromVertices
     * @param {vertices} vertices
     * @return {axes} A new axes from the given vertices
     */ Axes.fromVertices = function(vertices) {
                    var axes = {};
                    // find the unique axes, using edge normal gradients
                    for(var i = 0; i < vertices.length; i++){
                        var j = (i + 1) % vertices.length, normal = Vector.normalise({
                            x: vertices[j].y - vertices[i].y,
                            y: vertices[i].x - vertices[j].x
                        }), gradient = normal.y === 0 ? Infinity : normal.x / normal.y;
                        // limit precision
                        gradient = gradient.toFixed(3).toString();
                        axes[gradient] = normal;
                    }
                    return Common.values(axes);
                };
                /**
     * Rotates a set of axes by the given angle.
     * @method rotate
     * @param {axes} axes
     * @param {number} angle
     */ Axes.rotate = function(axes, angle) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < axes.length; i++){
                        var axis = axes[i], xx;
                        xx = axis.x * cos - axis.y * sin;
                        axis.y = axis.x * sin + axis.y * cos;
                        axis.x = xx;
                    }
                };
            })();
        /***/ },
        /* 586 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Events
 */ module1.exports = {
                AFTER_ADD: __webpack_require__(1509),
                AFTER_REMOVE: __webpack_require__(1510),
                AFTER_UPDATE: __webpack_require__(1511),
                BEFORE_ADD: __webpack_require__(1512),
                BEFORE_REMOVE: __webpack_require__(1513),
                BEFORE_UPDATE: __webpack_require__(1514),
                COLLISION_ACTIVE: __webpack_require__(1515),
                COLLISION_END: __webpack_require__(1516),
                COLLISION_START: __webpack_require__(1517),
                DRAG_END: __webpack_require__(1518),
                DRAG: __webpack_require__(1519),
                DRAG_START: __webpack_require__(1520),
                PAUSE: __webpack_require__(1521),
                RESUME: __webpack_require__(1522),
                SLEEP_END: __webpack_require__(1523),
                SLEEP_START: __webpack_require__(1524)
            };
        /***/ },
        /* 587 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
*
* @class Detector
*/ // TODO: speculative contacts
            var Detector = {};
            module1.exports = Detector;
            var SAT = __webpack_require__(588);
            var Pair = __webpack_require__(535);
            var Bounds = __webpack_require__(117);
            (function() {
                /**
     * Finds all collisions given a list of pairs.
     * @method collisions
     * @param {pair[]} broadphasePairs
     * @param {engine} engine
     * @return {array} collisions
     */ Detector.collisions = function(broadphasePairs, engine) {
                    var collisions = [], pairsTable = engine.pairs.table;
                    // @if DEBUG
                    var metrics = engine.metrics;
                    // @endif
                    for(var i = 0; i < broadphasePairs.length; i++){
                        var bodyA = broadphasePairs[i][0], bodyB = broadphasePairs[i][1];
                        if ((bodyA.isStatic || bodyA.isSleeping) && (bodyB.isStatic || bodyB.isSleeping)) continue;
                        if (!Detector.canCollide(bodyA.collisionFilter, bodyB.collisionFilter)) continue;
                        // @if DEBUG
                        metrics.midphaseTests += 1;
                        // @endif
                        // mid phase
                        if (Bounds.overlaps(bodyA.bounds, bodyB.bounds)) for(var j = bodyA.parts.length > 1 ? 1 : 0; j < bodyA.parts.length; j++){
                            var partA = bodyA.parts[j];
                            for(var k = bodyB.parts.length > 1 ? 1 : 0; k < bodyB.parts.length; k++){
                                var partB = bodyB.parts[k];
                                if (partA === bodyA && partB === bodyB || Bounds.overlaps(partA.bounds, partB.bounds)) {
                                    // find a previous collision we could reuse
                                    var pairId = Pair.id(partA, partB), pair = pairsTable[pairId], previousCollision;
                                    if (pair && pair.isActive) previousCollision = pair.collision;
                                    else previousCollision = null;
                                    // narrow phase
                                    var collision = SAT.collides(partA, partB, previousCollision);
                                    // @if DEBUG
                                    metrics.narrowphaseTests += 1;
                                    if (collision.reused) metrics.narrowReuseCount += 1;
                                    // @endif
                                    if (collision.collided) {
                                        collisions.push(collision);
                                        // @if DEBUG
                                        metrics.narrowDetections += 1;
                                    // @endif
                                    }
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Returns `true` if both supplied collision filters will allow a collision to occur.
     * See `body.collisionFilter` for more information.
     * @method canCollide
     * @param {} filterA
     * @param {} filterB
     * @return {bool} `true` if collision can occur
     */ Detector.canCollide = function(filterA, filterB) {
                    if (filterA.group === filterB.group && filterA.group !== 0) return filterA.group > 0;
                    return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
                };
            })();
        /***/ },
        /* 588 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
*
* @class SAT
*/ // TODO: true circles and curves
            var SAT = {};
            module1.exports = SAT;
            var Vertices = __webpack_require__(94);
            var Vector = __webpack_require__(116);
            (function() {
                /**
     * Detect collision between two bodies using the Separating Axis Theorem.
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {collision} previousCollision
     * @return {collision} collision
     */ SAT.collides = function(bodyA, bodyB, previousCollision) {
                    var overlapAB, overlapBA, minOverlap, collision, canReusePrevCol = false;
                    if (previousCollision) {
                        // estimate total motion
                        var parentA = bodyA.parent, parentB = bodyB.parent, motion = parentA.speed * parentA.speed + parentA.angularSpeed * parentA.angularSpeed + parentB.speed * parentB.speed + parentB.angularSpeed * parentB.angularSpeed;
                        // we may be able to (partially) reuse collision result 
                        // but only safe if collision was resting
                        canReusePrevCol = previousCollision && previousCollision.collided && motion < 0.2;
                        // reuse collision object
                        collision = previousCollision;
                    } else collision = {
                        collided: false,
                        bodyA: bodyA,
                        bodyB: bodyB
                    };
                    if (previousCollision && canReusePrevCol) {
                        // if we can reuse the collision result
                        // we only need to test the previously found axis
                        var axisBodyA = collision.axisBody, axisBodyB = axisBodyA === bodyA ? bodyB : bodyA, axes = [
                            axisBodyA.axes[previousCollision.axisNumber]
                        ];
                        minOverlap = SAT._overlapAxes(axisBodyA.vertices, axisBodyB.vertices, axes);
                        collision.reused = true;
                        if (minOverlap.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                    } else {
                        // if we can't reuse a result, perform a full SAT test
                        overlapAB = SAT._overlapAxes(bodyA.vertices, bodyB.vertices, bodyA.axes);
                        if (overlapAB.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                        overlapBA = SAT._overlapAxes(bodyB.vertices, bodyA.vertices, bodyB.axes);
                        if (overlapBA.overlap <= 0) {
                            collision.collided = false;
                            return collision;
                        }
                        if (overlapAB.overlap < overlapBA.overlap) {
                            minOverlap = overlapAB;
                            collision.axisBody = bodyA;
                        } else {
                            minOverlap = overlapBA;
                            collision.axisBody = bodyB;
                        }
                        // important for reuse later
                        collision.axisNumber = minOverlap.axisNumber;
                    }
                    collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
                    collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
                    collision.collided = true;
                    collision.depth = minOverlap.overlap;
                    collision.parentA = collision.bodyA.parent;
                    collision.parentB = collision.bodyB.parent;
                    bodyA = collision.bodyA;
                    bodyB = collision.bodyB;
                    // ensure normal is facing away from bodyA
                    if (Vector.dot(minOverlap.axis, Vector.sub(bodyB.position, bodyA.position)) < 0) collision.normal = {
                        x: minOverlap.axis.x,
                        y: minOverlap.axis.y
                    };
                    else collision.normal = {
                        x: -minOverlap.axis.x,
                        y: -minOverlap.axis.y
                    };
                    collision.tangent = Vector.perp(collision.normal);
                    collision.penetration = collision.penetration || {};
                    collision.penetration.x = collision.normal.x * collision.depth;
                    collision.penetration.y = collision.normal.y * collision.depth;
                    // find support points, there is always either exactly one or two
                    var verticesB = SAT._findSupports(bodyA, bodyB, collision.normal), supports = [];
                    // find the supports from bodyB that are inside bodyA
                    if (Vertices.contains(bodyA.vertices, verticesB[0])) supports.push(verticesB[0]);
                    if (Vertices.contains(bodyA.vertices, verticesB[1])) supports.push(verticesB[1]);
                    // find the supports from bodyA that are inside bodyB
                    if (supports.length < 2) {
                        var verticesA = SAT._findSupports(bodyB, bodyA, Vector.neg(collision.normal));
                        if (Vertices.contains(bodyB.vertices, verticesA[0])) supports.push(verticesA[0]);
                        if (supports.length < 2 && Vertices.contains(bodyB.vertices, verticesA[1])) supports.push(verticesA[1]);
                    }
                    // account for the edge case of overlapping but no vertex containment
                    if (supports.length < 1) supports = [
                        verticesB[0]
                    ];
                    collision.supports = supports;
                    return collision;
                };
                /**
     * Find the overlap between two sets of vertices.
     * @method _overlapAxes
     * @private
     * @param {} verticesA
     * @param {} verticesB
     * @param {} axes
     * @return result
     */ SAT._overlapAxes = function(verticesA, verticesB, axes) {
                    var projectionA = Vector._temp[0], projectionB = Vector._temp[1], result = {
                        overlap: Number.MAX_VALUE
                    }, overlap, axis;
                    for(var i = 0; i < axes.length; i++){
                        axis = axes[i];
                        SAT._projectToAxis(projectionA, verticesA, axis);
                        SAT._projectToAxis(projectionB, verticesB, axis);
                        overlap = Math.min(projectionA.max - projectionB.min, projectionB.max - projectionA.min);
                        if (overlap <= 0) {
                            result.overlap = overlap;
                            return result;
                        }
                        if (overlap < result.overlap) {
                            result.overlap = overlap;
                            result.axis = axis;
                            result.axisNumber = i;
                        }
                    }
                    return result;
                };
                /**
     * Projects vertices on an axis and returns an interval.
     * @method _projectToAxis
     * @private
     * @param {} projection
     * @param {} vertices
     * @param {} axis
     */ SAT._projectToAxis = function(projection, vertices, axis) {
                    var min = Vector.dot(vertices[0], axis), max = min;
                    for(var i = 1; i < vertices.length; i += 1){
                        var dot = Vector.dot(vertices[i], axis);
                        if (dot > max) max = dot;
                        else if (dot < min) min = dot;
                    }
                    projection.min = min;
                    projection.max = max;
                };
                /**
     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
     * @method _findSupports
     * @private
     * @param {} bodyA
     * @param {} bodyB
     * @param {} normal
     * @return [vector]
     */ SAT._findSupports = function(bodyA, bodyB, normal) {
                    var nearestDistance = Number.MAX_VALUE, vertexToBody = Vector._temp[0], vertices = bodyB.vertices, bodyAPosition = bodyA.position, distance, vertex, vertexA, vertexB;
                    // find closest vertex on bodyB
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        vertexToBody.x = vertex.x - bodyAPosition.x;
                        vertexToBody.y = vertex.y - bodyAPosition.y;
                        distance = -Vector.dot(normal, vertexToBody);
                        if (distance < nearestDistance) {
                            nearestDistance = distance;
                            vertexA = vertex;
                        }
                    }
                    // find next closest vertex using the two connected to it
                    var prevIndex = vertexA.index - 1 >= 0 ? vertexA.index - 1 : vertices.length - 1;
                    vertex = vertices[prevIndex];
                    vertexToBody.x = vertex.x - bodyAPosition.x;
                    vertexToBody.y = vertex.y - bodyAPosition.y;
                    nearestDistance = -Vector.dot(normal, vertexToBody);
                    vertexB = vertex;
                    var nextIndex = (vertexA.index + 1) % vertices.length;
                    vertex = vertices[nextIndex];
                    vertexToBody.x = vertex.x - bodyAPosition.x;
                    vertexToBody.y = vertex.y - bodyAPosition.y;
                    distance = -Vector.dot(normal, vertexToBody);
                    if (distance < nearestDistance) vertexB = vertex;
                    return [
                        vertexA,
                        vertexB
                    ];
                };
            })();
        /***/ },
        /* 589 */ /***/ function(module1, exports) {
            var g;
            // This works in non-strict mode
            g = function() {
                return this;
            }();
            try {
                // This works if eval is allowed (see CSP)
                g = g || new Function("return this")();
            } catch (e) {
                // This works if the window reference is available
                if (typeof window === "object") g = window;
            }
            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}
            module1.exports = g;
        /***/ },
        /* 590 */ /***/ function(module1, exports, __webpack_require__) {
            __webpack_require__(591);
            __webpack_require__(592);
            __webpack_require__(593);
            __webpack_require__(594);
            __webpack_require__(595);
            __webpack_require__(596);
            __webpack_require__(597);
            __webpack_require__(598);
        /***/ },
        /* 591 */ /***/ function(module1, exports) {
            /**
* A polyfill for Array.forEach
* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
*/ if (!Array.prototype.forEach) Array.prototype.forEach = function(fun /*, thisArg */ ) {
                'use strict';
                if (this === void 0 || this === null) throw new TypeError();
                var t = Object(this);
                var len = t.length >>> 0;
                if (typeof fun !== 'function') throw new TypeError();
                var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
                for(var i = 0; i < len; i++)if (i in t) fun.call(thisArg, t[i], i, t);
            };
        /***/ },
        /* 592 */ /***/ function(module1, exports) {
            /**
* A polyfill for Array.isArray
*/ if (!Array.isArray) Array.isArray = function(arg) {
                return Object.prototype.toString.call(arg) === '[object Array]';
            };
        /***/ },
        /* 593 */ /***/ function(module1, exports) {
            /* Copyright 2013 Chris Wilson

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ /*

This monkeypatch library is intended to be included in projects that are
written to the proper AudioContext spec (instead of webkitAudioContext),
and that use the new naming and proper bits of the Web Audio API (e.g.
using BufferSourceNode.start() instead of BufferSourceNode.noteOn()), but may
have to run on systems that only support the deprecated bits.

This library should be harmless to include if the browser supports
unprefixed "AudioContext", and/or if it supports the new names.

The patches this library handles:
if window.AudioContext is unsupported, it will be aliased to webkitAudioContext().
if AudioBufferSourceNode.start() is unimplemented, it will be routed to noteOn() or
noteGrainOn(), depending on parameters.

The following aliases only take effect if the new names are not already in place:

AudioBufferSourceNode.stop() is aliased to noteOff()
AudioContext.createGain() is aliased to createGainNode()
AudioContext.createDelay() is aliased to createDelayNode()
AudioContext.createScriptProcessor() is aliased to createJavaScriptNode()
AudioContext.createPeriodicWave() is aliased to createWaveTable()
OscillatorNode.start() is aliased to noteOn()
OscillatorNode.stop() is aliased to noteOff()
OscillatorNode.setPeriodicWave() is aliased to setWaveTable()
AudioParam.setTargetAtTime() is aliased to setTargetValueAtTime()

This library does NOT patch the enumerated type changes, as it is
recommended in the specification that implementations support both integer
and string types for AudioPannerNode.panningModel, AudioPannerNode.distanceModel
BiquadFilterNode.type and OscillatorNode.type.

*/ (function() {
                function fixSetTarget(param) {
                    if (!param) return;
                    if (!param.setTargetAtTime) param.setTargetAtTime = param.setTargetValueAtTime;
                }
                if (window.hasOwnProperty('webkitAudioContext') && !window.hasOwnProperty('AudioContext')) {
                    window.AudioContext = webkitAudioContext;
                    if (!AudioContext.prototype.hasOwnProperty('createGain')) AudioContext.prototype.createGain = AudioContext.prototype.createGainNode;
                    if (!AudioContext.prototype.hasOwnProperty('createDelay')) AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode;
                    if (!AudioContext.prototype.hasOwnProperty('createScriptProcessor')) AudioContext.prototype.createScriptProcessor = AudioContext.prototype.createJavaScriptNode;
                    if (!AudioContext.prototype.hasOwnProperty('createPeriodicWave')) AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable;
                    AudioContext.prototype.internal_createGain = AudioContext.prototype.createGain;
                    AudioContext.prototype.createGain = function() {
                        var node = this.internal_createGain();
                        fixSetTarget(node.gain);
                        return node;
                    };
                    AudioContext.prototype.internal_createDelay = AudioContext.prototype.createDelay;
                    AudioContext.prototype.createDelay = function(maxDelayTime) {
                        var node = maxDelayTime ? this.internal_createDelay(maxDelayTime) : this.internal_createDelay();
                        fixSetTarget(node.delayTime);
                        return node;
                    };
                    AudioContext.prototype.internal_createBufferSource = AudioContext.prototype.createBufferSource;
                    AudioContext.prototype.createBufferSource = function() {
                        var node = this.internal_createBufferSource();
                        if (!node.start) node.start = function(when, offset, duration) {
                            if (offset || duration) this.noteGrainOn(when || 0, offset, duration);
                            else this.noteOn(when || 0);
                        };
                        else {
                            node.internal_start = node.start;
                            node.start = function(when, offset, duration) {
                                if (typeof duration !== 'undefined') node.internal_start(when || 0, offset, duration);
                                else node.internal_start(when || 0, offset || 0);
                            };
                        }
                        if (!node.stop) node.stop = function(when) {
                            this.noteOff(when || 0);
                        };
                        else {
                            node.internal_stop = node.stop;
                            node.stop = function(when) {
                                node.internal_stop(when || 0);
                            };
                        }
                        fixSetTarget(node.playbackRate);
                        return node;
                    };
                    AudioContext.prototype.internal_createDynamicsCompressor = AudioContext.prototype.createDynamicsCompressor;
                    AudioContext.prototype.createDynamicsCompressor = function() {
                        var node = this.internal_createDynamicsCompressor();
                        fixSetTarget(node.threshold);
                        fixSetTarget(node.knee);
                        fixSetTarget(node.ratio);
                        fixSetTarget(node.reduction);
                        fixSetTarget(node.attack);
                        fixSetTarget(node.release);
                        return node;
                    };
                    AudioContext.prototype.internal_createBiquadFilter = AudioContext.prototype.createBiquadFilter;
                    AudioContext.prototype.createBiquadFilter = function() {
                        var node = this.internal_createBiquadFilter();
                        fixSetTarget(node.frequency);
                        fixSetTarget(node.detune);
                        fixSetTarget(node.Q);
                        fixSetTarget(node.gain);
                        return node;
                    };
                    if (AudioContext.prototype.hasOwnProperty('createOscillator')) {
                        AudioContext.prototype.internal_createOscillator = AudioContext.prototype.createOscillator;
                        AudioContext.prototype.createOscillator = function() {
                            var node = this.internal_createOscillator();
                            if (!node.start) node.start = function(when) {
                                this.noteOn(when || 0);
                            };
                            else {
                                node.internal_start = node.start;
                                node.start = function(when) {
                                    node.internal_start(when || 0);
                                };
                            }
                            if (!node.stop) node.stop = function(when) {
                                this.noteOff(when || 0);
                            };
                            else {
                                node.internal_stop = node.stop;
                                node.stop = function(when) {
                                    node.internal_stop(when || 0);
                                };
                            }
                            if (!node.setPeriodicWave) node.setPeriodicWave = node.setWaveTable;
                            fixSetTarget(node.frequency);
                            fixSetTarget(node.detune);
                            return node;
                        };
                    }
                }
                if (window.hasOwnProperty('webkitOfflineAudioContext') && !window.hasOwnProperty('OfflineAudioContext')) window.OfflineAudioContext = webkitOfflineAudioContext;
            })();
        /***/ },
        /* 594 */ /***/ function(module1, exports) {
            /**
 * Also fix for the absent console in IE9
 */ if (!window.console) {
                window.console = {};
                window.console.log = window.console.assert = function() {};
                window.console.warn = window.console.assert = function() {};
            }
        /***/ },
        /* 595 */ /***/ function(module1, exports) {
            // ES6 Math.trunc - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
            if (!Math.trunc) Math.trunc = function trunc(x) {
                return x < 0 ? Math.ceil(x) : Math.floor(x);
            };
        /***/ },
        /* 596 */ /***/ function(module1, exports) {
            /**
 * performance.now
 */ (function() {
                if ('performance' in window === false) window.performance = {};
                //  Thanks IE8
                Date.now = Date.now || function() {
                    return new Date().getTime();
                };
                if ('now' in window.performance === false) {
                    var nowOffset = Date.now();
                    if (performance.timing && performance.timing.navigationStart) nowOffset = performance.timing.navigationStart;
                    window.performance.now = function now() {
                        return Date.now() - nowOffset;
                    };
                }
            })();
        /***/ },
        /* 597 */ /***/ function(module1, exports) {
            // References:
            // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
            // https://gist.github.com/1579671
            // http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
            // https://gist.github.com/timhall/4078614
            // https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
            // requestAnimationFrame
            var lastTime = Date.now();
            var vendors = [
                'ms',
                'moz',
                'webkit',
                'o'
            ];
            for(var x = 0; x < vendors.length && !window.requestAnimationFrame; x++){
                window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
                window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
            }
            if (!window.requestAnimationFrame) window.requestAnimationFrame = function(callback) {
                if (typeof callback !== 'function') throw new TypeError(callback + 'is not a function');
                var currentTime = Date.now();
                var delay = 16 + lastTime - currentTime;
                if (delay < 0) delay = 0;
                lastTime = currentTime;
                return setTimeout(function() {
                    lastTime = Date.now();
                    callback(performance.now());
                }, delay);
            };
            if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function(id) {
                clearTimeout(id);
            };
        /***/ },
        /* 598 */ /***/ function(module1, exports) {
            /**
* Low-budget Float32Array knock-off, suitable for use with P2.js in IE9
* Source: http://www.html5gamedevs.com/topic/5988-phaser-12-ie9/
* Cameron Foale (http://www.kibibu.com)
*/ if (typeof window.Uint32Array !== 'function' && typeof window.Uint32Array !== 'object') {
                var CheapArray = function(fakeType) {
                    var proto = new Array(); // jshint ignore:line
                    window[fakeType] = function(arg) {
                        if (typeof arg === 'number') {
                            Array.call(this, arg);
                            this.length = arg;
                            for(var i = 0; i < this.length; i++)this[i] = 0;
                        } else {
                            Array.call(this, arg.length);
                            this.length = arg.length;
                            for(var i = 0; i < this.length; i++)this[i] = arg[i];
                        }
                    };
                    window[fakeType].prototype = proto;
                    window[fakeType].constructor = window[fakeType];
                };
                CheapArray('Float32Array'); // jshint ignore:line
                CheapArray('Uint32Array'); // jshint ignore:line
                CheapArray('Uint16Array'); // jshint ignore:line
                CheapArray('Int16Array'); // jshint ignore:line
                CheapArray('ArrayBuffer'); // jshint ignore:line
            }
        /***/ },
        /* 599 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var QuickSet = __webpack_require__(270);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties, and aligns them next to each other.
 *
 * The first item isn't moved. The second item is aligned next to the first, then the third next to the second, and so on.
 *
 * @function Phaser.Actions.AlignTo
 * @since 3.22.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} position - The position to align the items with. This is an align constant, such as `Phaser.Display.Align.LEFT_CENTER`.
 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
 * @param {number} [offsetY=0] - Optional vertical offset from the position.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var AlignTo = function(items, position, offsetX, offsetY) {
                var target = items[0];
                for(var i = 1; i < items.length; i++){
                    var item = items[i];
                    QuickSet(item, target, position, offsetX, offsetY);
                    target = item;
                }
                return items;
            };
            module1.exports = AlignTo;
        /***/ },
        /* 600 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `angle` property,
 * and then adds the given value to each of their `angle` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Angle(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Angle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `angle` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Angle = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'angle', value, step, index, direction);
            };
            module1.exports = Angle;
        /***/ },
        /* 601 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and passes each of them to the given callback.
 *
 * @function Phaser.Actions.Call
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.CallCallback} callback - The callback to be invoked. It will be passed just one argument: the item from the array.
 * @param {*} context - The scope in which the callback will be invoked.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that was passed to this Action.
 */ var Call = function(items, callback, context) {
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    callback.call(context, item);
                }
                return items;
            };
            module1.exports = Call;
        /***/ },
        /* 602 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the first element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the first item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetFirst(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetFirst
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The first object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetFirst = function(items, compare, index) {
                if (index === undefined) index = 0;
                for(var i = index; i < items.length; i++){
                    var item = items[i];
                    var match = true;
                    for(var property in compare)if (item[property] !== compare[property]) match = false;
                    if (match) return item;
                }
                return null;
            };
            module1.exports = GetFirst;
        /***/ },
        /* 603 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of objects and returns the last element in the array that has properties which match
 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
 * then it would return the last item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
 *
 * To use this with a Group: `GetLast(group.getChildren(), compare, index)`
 *
 * @function Phaser.Actions.GetLast
 * @since 3.3.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 *
 * @return {?(object|Phaser.GameObjects.GameObject)} The last object in the array that matches the comparison object, or `null` if no match was found.
 */ var GetLast = function(items, compare, index) {
                if (index === undefined) index = 0;
                for(var i = index; i < items.length; i++){
                    var item = items[i];
                    var match = true;
                    for(var property in compare)if (item[property] !== compare[property]) match = false;
                    if (match) return item;
                }
                return null;
            };
            module1.exports = GetLast;
        /***/ },
        /* 604 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AlignIn = __webpack_require__(283);
            var CONST = __webpack_require__(122);
            var GetFastValue = __webpack_require__(2);
            var NOOP = __webpack_require__(1);
            var Zone = __webpack_require__(127);
            var tempZone = new Zone({
                sys: {
                    queueDepthSort: NOOP,
                    events: {
                        once: NOOP
                    }
                }
            }, 0, 0, 1, 1);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then aligns them based on the grid configuration given to this action.
 *
 * @function Phaser.Actions.GridAlign
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {Phaser.Types.Actions.GridAlignConfig} options - The GridAlign Configuration object.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var GridAlign = function(items, options) {
                if (options === undefined) options = {};
                var widthSet = options.hasOwnProperty('width');
                var heightSet = options.hasOwnProperty('height');
                var width = GetFastValue(options, 'width', -1);
                var height = GetFastValue(options, 'height', -1);
                var cellWidth = GetFastValue(options, 'cellWidth', 1);
                var cellHeight = GetFastValue(options, 'cellHeight', cellWidth);
                var position = GetFastValue(options, 'position', CONST.TOP_LEFT);
                var x = GetFastValue(options, 'x', 0);
                var y = GetFastValue(options, 'y', 0);
                var cx = 0;
                var cy = 0;
                var w = width * cellWidth;
                var h = height * cellHeight;
                tempZone.setPosition(x, y);
                tempZone.setSize(cellWidth, cellHeight);
                for(var i = 0; i < items.length; i++){
                    AlignIn(items[i], tempZone, position);
                    if (widthSet && width === -1) //  We keep laying them out horizontally until we've done them all
                    tempZone.x += cellWidth;
                    else if (heightSet && height === -1) //  We keep laying them out vertically until we've done them all
                    tempZone.y += cellHeight;
                    else if (heightSet && !widthSet) {
                        //  We keep laying them out until we hit the column limit
                        cy += cellHeight;
                        tempZone.y += cellHeight;
                        if (cy === h) {
                            cy = 0;
                            cx += cellWidth;
                            tempZone.y = y;
                            tempZone.x += cellWidth;
                            if (cx === w) break;
                        }
                    } else {
                        //  We keep laying them out until we hit the column limit
                        cx += cellWidth;
                        tempZone.x += cellWidth;
                        if (cx === w) {
                            cx = 0;
                            cy += cellHeight;
                            tempZone.x = x;
                            tempZone.y += cellHeight;
                            if (cy === h) break;
                        }
                    }
                }
                return items;
            };
            module1.exports = GridAlign;
        /***/ },
        /* 605 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            //  bitmask flag for GameObject.renderMask
            var _FLAG = 2; // 0010
            /**
 * Provides methods used for setting the alpha properties of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Alpha
 * @since 3.0.0
 */ var Alpha = {
                /**
     * Private internal value. Holds the global alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alpha
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alpha: 1,
                /**
     * Private internal value. Holds the top-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTL: 1,
                /**
     * Private internal value. Holds the top-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaTR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaTR: 1,
                /**
     * Private internal value. Holds the bottom-left alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBL
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBL: 1,
                /**
     * Private internal value. Holds the bottom-right alpha value.
     *
     * @name Phaser.GameObjects.Components.Alpha#_alphaBR
     * @type {number}
     * @private
     * @default 1
     * @since 3.0.0
     */ _alphaBR: 1,
                /**
     * Clears all alpha values associated with this Game Object.
     *
     * Immediately sets the alpha levels back to 1 (fully opaque).
     *
     * @method Phaser.GameObjects.Components.Alpha#clearAlpha
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearAlpha: function() {
                    return this.setAlpha(1);
                },
                /**
     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
     *
     * If your game is running under WebGL you can optionally specify four different alpha values, each of which
     * correspond to the four corners of the Game Object. Under Canvas only the `topLeft` value given is used.
     *
     * @method Phaser.GameObjects.Components.Alpha#setAlpha
     * @since 3.0.0
     *
     * @param {number} [topLeft=1] - The alpha value used for the top-left of the Game Object. If this is the only value given it's applied across the whole Game Object.
     * @param {number} [topRight] - The alpha value used for the top-right of the Game Object. WebGL only.
     * @param {number} [bottomLeft] - The alpha value used for the bottom-left of the Game Object. WebGL only.
     * @param {number} [bottomRight] - The alpha value used for the bottom-right of the Game Object. WebGL only.
     *
     * @return {this} This Game Object instance.
     */ setAlpha: function(topLeft, topRight, bottomLeft, bottomRight) {
                    if (topLeft === undefined) topLeft = 1;
                    //  Treat as if there is only one alpha value for the whole Game Object
                    if (topRight === undefined) this.alpha = topLeft;
                    else {
                        this._alphaTL = Clamp(topLeft, 0, 1);
                        this._alphaTR = Clamp(topRight, 0, 1);
                        this._alphaBL = Clamp(bottomLeft, 0, 1);
                        this._alphaBR = Clamp(bottomRight, 0, 1);
                    }
                    return this;
                },
                /**
     * The alpha value of the Game Object.
     *
     * This is a global value, impacting the entire Game Object, not just a region of it.
     *
     * @name Phaser.GameObjects.Components.Alpha#alpha
     * @type {number}
     * @since 3.0.0
     */ alpha: {
                    get: function() {
                        return this._alpha;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alpha = v;
                        this._alphaTL = v;
                        this._alphaTR = v;
                        this._alphaBL = v;
                        this._alphaBR = v;
                        if (v === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the top-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopLeft: {
                    get: function() {
                        return this._alphaTL;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaTL = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the top-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaTopRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaTopRight: {
                    get: function() {
                        return this._alphaTR;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaTR = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the bottom-left of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomLeft
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomLeft: {
                    get: function() {
                        return this._alphaBL;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaBL = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                },
                /**
     * The alpha value starting from the bottom-right of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Alpha#alphaBottomRight
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ alphaBottomRight: {
                    get: function() {
                        return this._alphaBR;
                    },
                    set: function(value) {
                        var v = Clamp(value, 0, 1);
                        this._alphaBR = v;
                        if (v !== 0) this.renderFlags |= _FLAG;
                    }
                }
            };
            module1.exports = Alpha;
        /***/ },
        /* 606 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for calculating and setting the size of a non-Frame based Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.ComputedSize
 * @since 3.0.0
 */ var ComputedSize = {
                /**
     * The native (un-scaled) width of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                /**
     * The native (un-scaled) height of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                /**
     * The displayed width of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return this.scaleX * this.width;
                    },
                    set: function(value) {
                        this.scaleX = value / this.width;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.ComputedSize#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return this.scaleY * this.height;
                    },
                    set: function(value) {
                        this.scaleY = value / this.height;
                    }
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.ComputedSize#setSize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * 
     * Calling this will adjust the scale.
     * 
     * @method Phaser.GameObjects.Components.ComputedSize#setDisplaySize
     * @since 3.4.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                }
            };
            module1.exports = ComputedSize;
        /***/ },
        /* 607 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Crop
 * @since 3.12.0
 */ var Crop = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Crop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.Crop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     * 
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     * 
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     * 
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     * 
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     * 
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rect of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     * 
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     * 
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     * 
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.Crop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from.
     * @param {number} [width] - The width of the crop rectangle in pixels.
     * @param {number} [height] - The height of the crop rectangle in pixels.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                    if (x === undefined) this.isCropped = false;
                    else if (this.frame) {
                        if (typeof x === 'number') this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                        else {
                            var rect = x;
                            this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                        }
                        this.isCropped = true;
                    }
                    return this;
                },
                /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.Crop#resetCropObject
     * @private
     * @since 3.12.0
     * 
     * @return {object} The crop object.
     */ resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: false,
                        flipY: false,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            module1.exports = Crop;
        /***/ },
        /* 608 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for visually flipping a Game Object.
 * Should be applied as a mixin and not used directly.
 * 
 * @namespace Phaser.GameObjects.Components.Flip
 * @since 3.0.0
 */ var Flip = {
                /**
     * The horizontally flipped state of the Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @name Phaser.GameObjects.Components.Flip#flipX
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipX: false,
                /**
     * The vertically flipped state of the Game Object.
     * 
     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @name Phaser.GameObjects.Components.Flip#flipY
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ flipY: false,
                /**
     * Toggles the horizontal flipped state of this Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#toggleFlipX
     * @since 3.0.0
     * 
     * @return {this} This Game Object instance.
     */ toggleFlipX: function() {
                    this.flipX = !this.flipX;
                    return this;
                },
                /**
     * Toggles the vertical flipped state of this Game Object.
     * 
     * @method Phaser.GameObjects.Components.Flip#toggleFlipY
     * @since 3.0.0
     * 
     * @return {this} This Game Object instance.
     */ toggleFlipY: function() {
                    this.flipY = !this.flipY;
                    return this;
                },
                /**
     * Sets the horizontal flipped state of this Game Object.
     * 
     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlipX
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlipX: function(value) {
                    this.flipX = value;
                    return this;
                },
                /**
     * Sets the vertical flipped state of this Game Object.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlipY
     * @since 3.0.0
     *
     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlipY: function(value) {
                    this.flipY = value;
                    return this;
                },
                /**
     * Sets the horizontal and vertical flipped state of this Game Object.
     * 
     * A Game Object that is flipped will render inversed on the flipped axis.
     * Flipping always takes place from the middle of the texture and does not impact the scale value.
     * If this Game Object has a physics body, it will not change the body. This is a rendering toggle only.
     * 
     * @method Phaser.GameObjects.Components.Flip#setFlip
     * @since 3.0.0
     *
     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
     * 
     * @return {this} This Game Object instance.
     */ setFlip: function(x, y) {
                    this.flipX = x;
                    this.flipY = y;
                    return this;
                },
                /**
     * Resets the horizontal and vertical flipped state of this Game Object back to their default un-flipped state.
     * 
     * @method Phaser.GameObjects.Components.Flip#resetFlip
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ resetFlip: function() {
                    this.flipX = false;
                    this.flipY = false;
                    return this;
                }
            };
            module1.exports = Flip;
        /***/ },
        /* 609 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var RotateAround = __webpack_require__(302);
            var Vector2 = __webpack_require__(3);
            /**
 * Provides methods used for obtaining the bounds of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.GetBounds
 * @since 3.0.0
 */ var GetBounds = {
                /**
     * Processes the bounds output vector before returning it.
     *
     * @method Phaser.GameObjects.Components.GetBounds#prepareBoundsOutput
     * @private
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} output - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ prepareBoundsOutput: function(output, includeParent) {
                    if (includeParent === undefined) includeParent = false;
                    if (this.rotation !== 0) RotateAround(output, this.x, this.y, this.rotation);
                    if (includeParent && this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        parentMatrix.transformPoint(output.x, output.y, output);
                    }
                    return output;
                },
                /**
     * Gets the center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getCenter
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getCenter: function(output) {
                    if (output === undefined) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return output;
                },
                /**
     * Gets the top-left corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopLeft: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the top-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the top-right corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getTopRight
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getTopRight: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the left-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getLeftCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getLeftCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the right-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getRightCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getRightCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight / 2;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-left corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomLeft
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomLeft: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-center coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomCenter
     * @since 3.18.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomCenter: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth / 2;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bottom-right corner coordinate of this Game Object, regardless of origin.
     * The returned point is calculated in local space and does not factor in any parent containers
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBottomRight
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [output,$return]
     *
     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
     *
     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
     */ getBottomRight: function(output, includeParent) {
                    if (!output) output = new Vector2();
                    output.x = this.x - this.displayWidth * this.originX + this.displayWidth;
                    output.y = this.y - this.displayHeight * this.originY + this.displayHeight;
                    return this.prepareBoundsOutput(output, includeParent);
                },
                /**
     * Gets the bounds of this Game Object, regardless of origin.
     * The values are stored and returned in a Rectangle, or Rectangle-like, object.
     *
     * @method Phaser.GameObjects.Components.GetBounds#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Geom.Rectangle} O - [output,$return]
     *
     * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in. If not provided a new Rectangle will be created.
     *
     * @return {(Phaser.Geom.Rectangle|object)} The values stored in the output object.
     */ getBounds: function(output) {
                    if (output === undefined) output = new Rectangle();
                    //  We can use the output object to temporarily store the x/y coords in:
                    var TLx, TLy, TRx, TRy, BLx, BLy, BRx, BRy;
                    // Instead of doing a check if parent container is 
                    // defined per corner we only do it once.
                    if (this.parentContainer) {
                        var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
                        this.getTopLeft(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        TLx = output.x;
                        TLy = output.y;
                        this.getTopRight(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        TRx = output.x;
                        TRy = output.y;
                        this.getBottomLeft(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        BLx = output.x;
                        BLy = output.y;
                        this.getBottomRight(output);
                        parentMatrix.transformPoint(output.x, output.y, output);
                        BRx = output.x;
                        BRy = output.y;
                    } else {
                        this.getTopLeft(output);
                        TLx = output.x;
                        TLy = output.y;
                        this.getTopRight(output);
                        TRx = output.x;
                        TRy = output.y;
                        this.getBottomLeft(output);
                        BLx = output.x;
                        BLy = output.y;
                        this.getBottomRight(output);
                        BRx = output.x;
                        BRy = output.y;
                    }
                    output.x = Math.min(TLx, TRx, BLx, BRx);
                    output.y = Math.min(TLy, TRy, BLy, BRy);
                    output.width = Math.max(TLx, TRx, BLx, BRx) - output.x;
                    output.height = Math.max(TLy, TRy, BLy, BRy) - output.y;
                    return output;
                }
            };
            module1.exports = GetBounds;
        /***/ },
        /* 610 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Blur Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a blurred state. The blur event is raised when the window loses focus. This can happen if a user swaps
 * tab, or if they simply remove focus from the browser to another app.
 *
 * @event Phaser.Core.Events#BLUR
 * @since 3.0.0
 */ module1.exports = 'blur';
        /***/ },
        /* 611 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Boot Event.
 * 
 * This event is dispatched when the Phaser Game instance has finished booting, but before it is ready to start running.
 * The global systems use this event to know when to set themselves up, dispatching their own `ready` events as required.
 *
 * @event Phaser.Core.Events#BOOT
 * @since 3.0.0
 */ module1.exports = 'boot';
        /***/ },
        /* 612 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Context Lost Event.
 * 
 * This event is dispatched by the Game if the WebGL Renderer it is using encounters a WebGL Context Lost event from the browser.
 * 
 * The partner event is `CONTEXT_RESTORED`.
 *
 * @event Phaser.Core.Events#CONTEXT_LOST
 * @since 3.19.0
 */ module1.exports = 'contextlost';
        /***/ },
        /* 613 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Context Restored Event.
 * 
 * This event is dispatched by the Game if the WebGL Renderer it is using encounters a WebGL Context Restored event from the browser.
 * 
 * The partner event is `CONTEXT_LOST`.
 *
 * @event Phaser.Core.Events#CONTEXT_RESTORED
 * @since 3.19.0
 */ module1.exports = 'contextrestored';
        /***/ },
        /* 614 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Destroy Event.
 * 
 * This event is dispatched when the game instance has been told to destroy itself.
 * Lots of internal systems listen to this event in order to clear themselves out.
 * Custom plugins and game code should also do the same.
 *
 * @event Phaser.Core.Events#DESTROY
 * @since 3.0.0
 */ module1.exports = 'destroy';
        /***/ },
        /* 615 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Focus Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the window in which the Game instance is embedded
 * enters a focused state. The focus event is raised when the window re-gains focus, having previously lost it.
 *
 * @event Phaser.Core.Events#FOCUS
 * @since 3.0.0
 */ module1.exports = 'focus';
        /***/ },
        /* 616 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Hidden Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a hidden state. Only browsers that support the Visibility API will cause this event to be emitted.
 * 
 * In most modern browsers, when the document enters a hidden state, the Request Animation Frame and setTimeout, which
 * control the main game loop, will automatically pause. There is no way to stop this from happening. It is something
 * your game should account for in its own code, should the pause be an issue (i.e. for multiplayer games)
 *
 * @event Phaser.Core.Events#HIDDEN
 * @since 3.0.0
 */ module1.exports = 'hidden';
        /***/ },
        /* 617 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pause Event.
 * 
 * This event is dispatched when the Game loop enters a paused state, usually as a result of the Visibility Handler.
 *
 * @event Phaser.Core.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = 'pause';
        /***/ },
        /* 618 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Render Event.
 * 
 * This event is dispatched right at the end of the render process.
 * 
 * Every Scene will have rendered and been drawn to the canvas by the time this event is fired.
 * Use it for any last minute post-processing before the next game step begins.
 *
 * @event Phaser.Core.Events#POST_RENDER
 * @since 3.0.0
 * 
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = 'postrender';
        /***/ },
        /* 619 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Post-Step Event.
 * 
 * This event is dispatched after the Scene Manager has updated.
 * Hook into it from plugins or systems that need to do things before the render starts.
 *
 * @event Phaser.Core.Events#POST_STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'poststep';
        /***/ },
        /* 620 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Render Event.
 * 
 * This event is dispatched immediately before any of the Scenes have started to render.
 * 
 * The renderer will already have been initialized this frame, clearing itself and preparing to receive the Scenes for rendering, but it won't have actually drawn anything yet.
 *
 * @event Phaser.Core.Events#PRE_RENDER
 * @since 3.0.0
 * 
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer being used by the Game instance.
 */ module1.exports = 'prerender';
        /***/ },
        /* 621 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Pre-Step Event.
 * 
 * This event is dispatched before the main Game Step starts. By this point in the game cycle none of the Scene updates have yet happened.
 * Hook into it from plugins or systems that need to update before the Scene Manager does.
 *
 * @event Phaser.Core.Events#PRE_STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'prestep';
        /***/ },
        /* 622 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Ready Event.
 * 
 * This event is dispatched when the Phaser Game instance has finished booting, the Texture Manager is fully ready,
 * and all local systems are now able to start.
 *
 * @event Phaser.Core.Events#READY
 * @since 3.0.0
 */ module1.exports = 'ready';
        /***/ },
        /* 623 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Resume Event.
 * 
 * This event is dispatched when the game loop leaves a paused state and resumes running.
 *
 * @event Phaser.Core.Events#RESUME
 * @since 3.0.0
 */ module1.exports = 'resume';
        /***/ },
        /* 624 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Step Event.
 * 
 * This event is dispatched after the Game Pre-Step and before the Scene Manager steps.
 * Hook into it from plugins or systems that need to update before the Scene Manager does, but after the core Systems have.
 *
 * @event Phaser.Core.Events#STEP
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'step';
        /***/ },
        /* 625 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Visible Event.
 * 
 * This event is dispatched by the Game Visibility Handler when the document in which the Game instance is embedded
 * enters a visible state, previously having been hidden.
 * 
 * Only browsers that support the Visibility API will cause this event to be emitted.
 *
 * @event Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 */ module1.exports = 'visible';
        /***/ },
        /* 626 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Post-Render Event.
 *
 * This event is dispatched by the Renderer when all rendering, for all cameras in all Scenes,
 * has completed, but before any pending snap shots have been taken.
 *
 * @event Phaser.Renderer.Events#POST_RENDER
 * @since 3.50.0
 */ module1.exports = 'postrender';
        /***/ },
        /* 627 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pre-Render Event.
 *
 * This event is dispatched by the Phaser Renderer. This happens right at the start of the render
 * process, after the context has been cleared, the scissors enabled (WebGL only) and everything has been
 * reset ready for the render.
 *
 * @event Phaser.Renderer.Events#PRE_RENDER
 * @since 3.50.0
 */ module1.exports = 'prerender';
        /***/ },
        /* 628 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Render Event.
 *
 * This event is dispatched by the Phaser Renderer for every camera in every Scene.
 *
 * It is dispatched before any of the children in the Scene have been rendered.
 *
 * @event Phaser.Renderer.Events#RENDER
 * @since 3.50.0
 *
 * @param {Phaser.Scene} scene - The Scene being rendered.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Scene Camera being rendered.
 */ module1.exports = 'render';
        /***/ },
        /* 629 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Renderer Resize Event.
 *
 * This event is dispatched by the Phaser Renderer when it is resized, usually as a result
 * of the Scale Manager resizing.
 *
 * @event Phaser.Renderer.Events#RESIZE
 * @since 3.50.0
 *
 * @param {number} width - The new width of the renderer.
 * @param {number} height - The new height of the renderer.
 */ module1.exports = 'resize';
        /***/ },
        /* 630 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the origin of a Game Object.
 * Values are normalized, given in the range 0 to 1.
 * Display values contain the calculated pixel values.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Origin
 * @since 3.0.0
 */ var Origin = {
                /**
     * A property indicating that a Game Object has this component.
     *
     * @name Phaser.GameObjects.Components.Origin#_originComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _originComponent: true,
                /**
     * The horizontal origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the left of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Origin#originX
     * @type {number}
     * @default 0.5
     * @since 3.0.0
     */ originX: 0.5,
                /**
     * The vertical origin of this Game Object.
     * The origin maps the relationship between the size and position of the Game Object.
     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
     * Setting the value to 0 means the position now relates to the top of the Game Object.
     *
     * @name Phaser.GameObjects.Components.Origin#originY
     * @type {number}
     * @default 0.5
     * @since 3.0.0
     */ originY: 0.5,
                //  private + read only
                _displayOriginX: 0,
                _displayOriginY: 0,
                /**
     * The horizontal display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginX
     * @type {number}
     * @since 3.0.0
     */ displayOriginX: {
                    get: function() {
                        return this._displayOriginX;
                    },
                    set: function(value) {
                        this._displayOriginX = value;
                        this.originX = value / this.width;
                    }
                },
                /**
     * The vertical display origin of this Game Object.
     * The origin is a normalized value between 0 and 1.
     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
     *
     * @name Phaser.GameObjects.Components.Origin#displayOriginY
     * @type {number}
     * @since 3.0.0
     */ displayOriginY: {
                    get: function() {
                        return this._displayOriginY;
                    },
                    set: function(value) {
                        this._displayOriginY = value;
                        this.originY = value / this.height;
                    }
                },
                /**
     * Sets the origin of this Game Object.
     *
     * The values are given in the range 0 to 1.
     *
     * @method Phaser.GameObjects.Components.Origin#setOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0.5] - The horizontal origin value.
     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setOrigin: function(x, y) {
                    if (x === undefined) x = 0.5;
                    if (y === undefined) y = x;
                    this.originX = x;
                    this.originY = y;
                    return this.updateDisplayOrigin();
                },
                /**
     * Sets the origin of this Game Object based on the Pivot values in its Frame.
     *
     * @method Phaser.GameObjects.Components.Origin#setOriginFromFrame
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ setOriginFromFrame: function() {
                    if (!this.frame || !this.frame.customPivot) return this.setOrigin();
                    else {
                        this.originX = this.frame.pivotX;
                        this.originY = this.frame.pivotY;
                    }
                    return this.updateDisplayOrigin();
                },
                /**
     * Sets the display origin of this Game Object.
     * The difference between this and setting the origin is that you can use pixel values for setting the display origin.
     *
     * @method Phaser.GameObjects.Components.Origin#setDisplayOrigin
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal display origin value.
     * @param {number} [y=x] - The vertical display origin value. If not defined it will be set to the value of `x`.
     *
     * @return {this} This Game Object instance.
     */ setDisplayOrigin: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this.displayOriginX = x;
                    this.displayOriginY = y;
                    return this;
                },
                /**
     * Updates the Display Origin cached values internally stored on this Game Object.
     * You don't usually call this directly, but it is exposed for edge-cases where you may.
     *
     * @method Phaser.GameObjects.Components.Origin#updateDisplayOrigin
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ updateDisplayOrigin: function() {
                    this._displayOriginX = this.originX * this.width;
                    this._displayOriginY = this.originY * this.height;
                    return this;
                }
            };
            module1.exports = Origin;
        /***/ },
        /* 631 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(35);
            var GetBoolean = __webpack_require__(96);
            var GetValue = __webpack_require__(6);
            var TWEEN_CONST = __webpack_require__(97);
            var Vector2 = __webpack_require__(3);
            /**
 * Provides methods used for managing a Game Object following a Path.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.PathFollower
 * @since 3.17.0
 */ var PathFollower = {
                /**
     * The Path this PathFollower is following. It can only follow one Path at a time.
     *
     * @name Phaser.GameObjects.Components.PathFollower#path
     * @type {Phaser.Curves.Path}
     * @since 3.0.0
     */ path: null,
                /**
     * Should the PathFollower automatically rotate to point in the direction of the Path?
     *
     * @name Phaser.GameObjects.Components.PathFollower#rotateToPath
     * @type {boolean}
     * @default false
     * @since 3.0.0
     */ rotateToPath: false,
                /**
     * If the PathFollower is rotating to match the Path (@see Phaser.GameObjects.PathFollower#rotateToPath)
     * this value is added to the rotation value. This allows you to rotate objects to a path but control
     * the angle of the rotation as well.
     *
     * @name Phaser.GameObjects.PathFollower#pathRotationOffset
     * @type {number}
     * @default 0
     * @since 3.0.0
     */ pathRotationOffset: 0,
                /**
     * An additional vector to add to the PathFollowers position, allowing you to offset it from the
     * Path coordinates.
     *
     * @name Phaser.GameObjects.PathFollower#pathOffset
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathOffset: null,
                /**
     * A Vector2 that stores the current point of the path the follower is on.
     *
     * @name Phaser.GameObjects.PathFollower#pathVector
     * @type {Phaser.Math.Vector2}
     * @since 3.0.0
     */ pathVector: null,
                /**
     * The distance the follower has traveled from the previous point to the current one, at the last update.
     *
     * @name Phaser.GameObjects.PathFollower#pathDelta
     * @type {Phaser.Math.Vector2}
     * @since 3.23.0
     */ pathDelta: null,
                /**
     * The Tween used for following the Path.
     *
     * @name Phaser.GameObjects.PathFollower#pathTween
     * @type {Phaser.Tweens.Tween}
     * @since 3.0.0
     */ pathTween: null,
                /**
     * Settings for the PathFollower.
     *
     * @name Phaser.GameObjects.PathFollower#pathConfig
     * @type {?Phaser.Types.GameObjects.PathFollower.PathConfig}
     * @default null
     * @since 3.0.0
     */ pathConfig: null,
                /**
     * Records the direction of the follower so it can change direction.
     *
     * @name Phaser.GameObjects.PathFollower#_prevDirection
     * @type {number}
     * @private
     * @since 3.0.0
     */ _prevDirection: TWEEN_CONST.PLAYING_FORWARD,
                /**
     * Set the Path that this PathFollower should follow.
     *
     * Optionally accepts {@link Phaser.Types.GameObjects.PathFollower.PathConfig} settings.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setPath
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config] - Settings for the PathFollower.
     *
     * @return {this} This Game Object.
     */ setPath: function(path, config) {
                    if (config === undefined) config = this.pathConfig;
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    this.path = path;
                    if (config) this.startFollow(config);
                    return this;
                },
                /**
     * Set whether the PathFollower should automatically rotate to point in the direction of the Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#setRotateToPath
     * @since 3.0.0
     *
     * @param {boolean} value - Whether the PathFollower should automatically rotate to point in the direction of the Path.
     * @param {number} [offset=0] - Rotation offset in degrees.
     *
     * @return {this} This Game Object.
     */ setRotateToPath: function(value, offset) {
                    if (offset === undefined) offset = 0;
                    this.rotateToPath = value;
                    this.pathRotationOffset = offset;
                    return this;
                },
                /**
     * Is this PathFollower actively following a Path or not?
     *
     * To be considered as `isFollowing` it must be currently moving on a Path, and not paused.
     *
     * @method Phaser.GameObjects.Components.PathFollower#isFollowing
     * @since 3.0.0
     *
     * @return {boolean} `true` is this PathFollower is actively following a Path, otherwise `false`.
     */ isFollowing: function() {
                    var tween = this.pathTween;
                    return tween && tween.isPlaying();
                },
                /**
     * Starts this PathFollower following its given Path.
     *
     * @method Phaser.GameObjects.Components.PathFollower#startFollow
     * @since 3.3.0
     *
     * @param {(number|Phaser.Types.GameObjects.PathFollower.PathConfig|Phaser.Types.Tweens.NumberTweenBuilderConfig)} [config={}] - The duration of the follow, or a PathFollower config object.
     * @param {number} [startAt=0] - Optional start position of the follow, between 0 and 1.
     *
     * @return {this} This Game Object.
     */ startFollow: function(config, startAt) {
                    if (config === undefined) config = {};
                    if (startAt === undefined) startAt = 0;
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    if (typeof config === 'number') config = {
                        duration: config
                    };
                    //  Override in case they've been specified in the config
                    config.from = GetValue(config, 'from', 0);
                    config.to = GetValue(config, 'to', 1);
                    var positionOnPath = GetBoolean(config, 'positionOnPath', false);
                    this.rotateToPath = GetBoolean(config, 'rotateToPath', false);
                    this.pathRotationOffset = GetValue(config, 'rotationOffset', 0);
                    //  This works, but it's not an ideal way of doing it as the follower jumps position
                    var seek = GetValue(config, 'startAt', startAt);
                    if (seek) config.onStart = function(tween) {
                        var tweenData = tween.data[0];
                        tweenData.progress = seek;
                        tweenData.elapsed = tweenData.duration * seek;
                        var v = tweenData.ease(tweenData.progress);
                        tweenData.current = tweenData.start + (tweenData.end - tweenData.start) * v;
                        tweenData.target[tweenData.key] = tweenData.current;
                    };
                    if (!this.pathOffset) this.pathOffset = new Vector2(this.x, this.y);
                    if (!this.pathVector) this.pathVector = new Vector2();
                    if (!this.pathDelta) this.pathDelta = new Vector2();
                    this.pathDelta.reset();
                    this.pathTween = this.scene.sys.tweens.addCounter(config);
                    //  The starting point of the path, relative to this follower
                    this.path.getStartPoint(this.pathOffset);
                    if (positionOnPath) {
                        this.x = this.pathOffset.x;
                        this.y = this.pathOffset.y;
                    }
                    this.pathOffset.x = this.x - this.pathOffset.x;
                    this.pathOffset.y = this.y - this.pathOffset.y;
                    this._prevDirection = TWEEN_CONST.PLAYING_FORWARD;
                    if (this.rotateToPath) {
                        //  Set the rotation now (in case the tween has a delay on it, etc)
                        var nextPoint = this.path.getPoint(0.1);
                        this.rotation = Math.atan2(nextPoint.y - this.y, nextPoint.x - this.x) + DegToRad(this.pathRotationOffset);
                    }
                    this.pathConfig = config;
                    return this;
                },
                /**
     * Pauses this PathFollower. It will still continue to render, but it will remain motionless at the
     * point on the Path at which you paused it.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pauseFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ pauseFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.pause();
                    return this;
                },
                /**
     * Resumes a previously paused PathFollower.
     *
     * If the PathFollower was not paused this has no effect.
     *
     * @method Phaser.GameObjects.Components.PathFollower#resumeFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ resumeFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPaused()) tween.resume();
                    return this;
                },
                /**
     * Stops this PathFollower from following the path any longer.
     *
     * This will invoke any 'stop' conditions that may exist on the Path, or for the follower.
     *
     * @method Phaser.GameObjects.Components.PathFollower#stopFollow
     * @since 3.3.0
     *
     * @return {this} This Game Object.
     */ stopFollow: function() {
                    var tween = this.pathTween;
                    if (tween && tween.isPlaying()) tween.stop();
                    return this;
                },
                /**
     * Internal update handler that advances this PathFollower along the path.
     *
     * Called automatically by the Scene step, should not typically be called directly.
     *
     * @method Phaser.GameObjects.Components.PathFollower#pathUpdate
     * @since 3.17.0
     */ pathUpdate: function() {
                    var tween = this.pathTween;
                    if (tween) {
                        var tweenData = tween.data[0];
                        var pathDelta = this.pathDelta;
                        var pathVector = this.pathVector;
                        pathDelta.copy(pathVector).negate();
                        if (tweenData.state === TWEEN_CONST.COMPLETE) {
                            this.path.getPoint(1, pathVector);
                            pathDelta.add(pathVector);
                            pathVector.add(this.pathOffset);
                            this.setPosition(pathVector.x, pathVector.y);
                            return;
                        } else if (tweenData.state !== TWEEN_CONST.PLAYING_FORWARD && tweenData.state !== TWEEN_CONST.PLAYING_BACKWARD) //  If delayed, etc then bail out
                        return;
                        this.path.getPoint(tween.getValue(), pathVector);
                        pathDelta.add(pathVector);
                        pathVector.add(this.pathOffset);
                        var oldX = this.x;
                        var oldY = this.y;
                        this.setPosition(pathVector.x, pathVector.y);
                        var speedX = this.x - oldX;
                        var speedY = this.y - oldY;
                        if (speedX === 0 && speedY === 0) //  Bail out early
                        return;
                        if (tweenData.state !== this._prevDirection) {
                            //  We've changed direction, so don't do a rotate this frame
                            this._prevDirection = tweenData.state;
                            return;
                        }
                        if (this.rotateToPath) this.rotation = Math.atan2(speedY, speedX) + DegToRad(this.pathRotationOffset);
                    }
                }
            };
            module1.exports = PathFollower;
        /***/ },
        /* 632 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for getting and setting the size of a Game Object.
 * 
 * @namespace Phaser.GameObjects.Components.Size
 * @since 3.0.0
 */ var Size = {
                /**
     * A property indicating that a Game Object has this component.
     * 
     * @name Phaser.GameObjects.Components.Size#_sizeComponent
     * @type {boolean}
     * @private
     * @default true
     * @since 3.2.0
     */ _sizeComponent: true,
                /**
     * The native (un-scaled) width of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayWidth` property.
     * 
     * @name Phaser.GameObjects.Components.Size#width
     * @type {number}
     * @since 3.0.0
     */ width: 0,
                /**
     * The native (un-scaled) height of this Game Object.
     * 
     * Changing this value will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or use
     * the `displayHeight` property.
     * 
     * @name Phaser.GameObjects.Components.Size#height
     * @type {number}
     * @since 3.0.0
     */ height: 0,
                /**
     * The displayed width of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.Size#displayWidth
     * @type {number}
     * @since 3.0.0
     */ displayWidth: {
                    get: function() {
                        return Math.abs(this.scaleX * this.frame.realWidth);
                    },
                    set: function(value) {
                        this.scaleX = value / this.frame.realWidth;
                    }
                },
                /**
     * The displayed height of this Game Object.
     * 
     * This value takes into account the scale factor.
     * 
     * Setting this value will adjust the Game Object's scale property.
     * 
     * @name Phaser.GameObjects.Components.Size#displayHeight
     * @type {number}
     * @since 3.0.0
     */ displayHeight: {
                    get: function() {
                        return Math.abs(this.scaleY * this.frame.realHeight);
                    },
                    set: function(value) {
                        this.scaleY = value / this.frame.realHeight;
                    }
                },
                /**
     * Sets the size of this Game Object to be that of the given Frame.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.Size#setSizeToFrame
     * @since 3.0.0
     *
     * @param {Phaser.Textures.Frame} frame - The frame to base the size of this Game Object on.
     * 
     * @return {this} This Game Object instance.
     */ setSizeToFrame: function(frame) {
                    if (frame === undefined) frame = this.frame;
                    this.width = frame.realWidth;
                    this.height = frame.realHeight;
                    return this;
                },
                /**
     * Sets the internal size of this Game Object, as used for frame or physics body creation.
     * 
     * This will not change the size that the Game Object is rendered in-game.
     * For that you need to either set the scale of the Game Object (`setScale`) or call the
     * `setDisplaySize` method, which is the same thing as changing the scale but allows you
     * to do so by giving pixel values.
     * 
     * If you have enabled this Game Object for input, changing the size will _not_ change the
     * size of the hit area. To do this you should adjust the `input.hitArea` object directly.
     * 
     * @method Phaser.GameObjects.Components.Size#setSize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setSize: function(width, height) {
                    this.width = width;
                    this.height = height;
                    return this;
                },
                /**
     * Sets the display size of this Game Object.
     * 
     * Calling this will adjust the scale.
     * 
     * @method Phaser.GameObjects.Components.Size#setDisplaySize
     * @since 3.0.0
     *
     * @param {number} width - The width of this Game Object.
     * @param {number} height - The height of this Game Object.
     * 
     * @return {this} This Game Object instance.
     */ setDisplaySize: function(width, height) {
                    this.displayWidth = width;
                    this.displayHeight = height;
                    return this;
                }
            };
            module1.exports = Size;
        /***/ },
        /* 633 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.Texture
 * @since 3.0.0
 */ var Texture = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.Texture#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * Internal flag. Not to be set by this Game Object.
     *
     * @name Phaser.GameObjects.Components.Texture#isCropped
     * @type {boolean}
     * @private
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Components.Texture#setTexture
     * @since 3.0.0
     *
     * @param {(string|Phaser.Textures.Texture)} key - The key of the texture to be used, as stored in the Texture Manager, or a Texture instance.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.Texture#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                    if (updateSize === undefined) updateSize = true;
                    if (updateOrigin === undefined) updateOrigin = true;
                    this.frame = this.texture.get(frame);
                    if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    if (this._sizeComponent && updateSize) this.setSizeToFrame();
                    if (this._originComponent && updateOrigin) {
                        if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                        else this.updateDisplayOrigin();
                    }
                    return this;
                }
            };
            module1.exports = Texture;
        /***/ },
        /* 634 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  bitmask flag for GameObject.renderMask
            var _FLAG = 8; // 1000
            /**
 * Provides methods used for getting and setting the texture of a Game Object.
 *
 * @namespace Phaser.GameObjects.Components.TextureCrop
 * @since 3.0.0
 */ var TextureCrop = {
                /**
     * The Texture this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#texture
     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
     * @since 3.0.0
     */ texture: null,
                /**
     * The Texture Frame this Game Object is using to render with.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#frame
     * @type {Phaser.Textures.Frame}
     * @since 3.0.0
     */ frame: null,
                /**
     * A boolean flag indicating if this Game Object is being cropped or not.
     * You can toggle this at any time after `setCrop` has been called, to turn cropping on or off.
     * Equally, calling `setCrop` with no arguments will reset the crop and disable it.
     *
     * @name Phaser.GameObjects.Components.TextureCrop#isCropped
     * @type {boolean}
     * @since 3.11.0
     */ isCropped: false,
                /**
     * Applies a crop to a texture based Game Object, such as a Sprite or Image.
     *
     * The crop is a rectangle that limits the area of the texture frame that is visible during rendering.
     *
     * Cropping a Game Object does not change its size, dimensions, physics body or hit area, it just
     * changes what is shown when rendered.
     *
     * The crop coordinates are relative to the texture frame, not the Game Object, meaning 0 x 0 is the top-left.
     *
     * Therefore, if you had a Game Object that had an 800x600 sized texture, and you wanted to show only the left
     * half of it, you could call `setCrop(0, 0, 400, 600)`.
     *
     * It is also scaled to match the Game Object scale automatically. Therefore a crop rect of 100x50 would crop
     * an area of 200x100 when applied to a Game Object that had a scale factor of 2.
     *
     * You can either pass in numeric values directly, or you can provide a single Rectangle object as the first argument.
     *
     * Call this method with no arguments at all to reset the crop, or toggle the property `isCropped` to `false`.
     *
     * You should do this if the crop rectangle becomes the same size as the frame itself, as it will allow
     * the renderer to skip several internal calculations.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setCrop
     * @since 3.11.0
     *
     * @param {(number|Phaser.Geom.Rectangle)} [x] - The x coordinate to start the crop from. Or a Phaser.Geom.Rectangle object, in which case the rest of the arguments are ignored.
     * @param {number} [y] - The y coordinate to start the crop from.
     * @param {number} [width] - The width of the crop rectangle in pixels.
     * @param {number} [height] - The height of the crop rectangle in pixels.
     *
     * @return {this} This Game Object instance.
     */ setCrop: function(x, y, width, height) {
                    if (x === undefined) this.isCropped = false;
                    else if (this.frame) {
                        if (typeof x === 'number') this.frame.setCropUVs(this._crop, x, y, width, height, this.flipX, this.flipY);
                        else {
                            var rect = x;
                            this.frame.setCropUVs(this._crop, rect.x, rect.y, rect.width, rect.height, this.flipX, this.flipY);
                        }
                        this.isCropped = true;
                    }
                    return this;
                },
                /**
     * Sets the texture and frame this Game Object will use to render with.
     *
     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setTexture
     * @since 3.0.0
     *
     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - The name or index of the frame within the Texture.
     *
     * @return {this} This Game Object instance.
     */ setTexture: function(key, frame) {
                    this.texture = this.scene.sys.textures.get(key);
                    return this.setFrame(frame);
                },
                /**
     * Sets the frame this Game Object will use to render with.
     *
     * The Frame has to belong to the current Texture being used.
     *
     * It can be either a string or an index.
     *
     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#setFrame
     * @since 3.0.0
     *
     * @param {(string|number)} frame - The name or index of the frame within the Texture.
     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
     *
     * @return {this} This Game Object instance.
     */ setFrame: function(frame, updateSize, updateOrigin) {
                    if (updateSize === undefined) updateSize = true;
                    if (updateOrigin === undefined) updateOrigin = true;
                    this.frame = this.texture.get(frame);
                    if (!this.frame.cutWidth || !this.frame.cutHeight) this.renderFlags &= ~_FLAG;
                    else this.renderFlags |= _FLAG;
                    if (this._sizeComponent && updateSize) this.setSizeToFrame();
                    if (this._originComponent && updateOrigin) {
                        if (this.frame.customPivot) this.setOrigin(this.frame.pivotX, this.frame.pivotY);
                        else this.updateDisplayOrigin();
                    }
                    if (this.isCropped) this.frame.updateCropUVs(this._crop, this.flipX, this.flipY);
                    return this;
                },
                /**
     * Internal method that returns a blank, well-formed crop object for use by a Game Object.
     *
     * @method Phaser.GameObjects.Components.TextureCrop#resetCropObject
     * @private
     * @since 3.12.0
     *
     * @return {object} The crop object.
     */ resetCropObject: function() {
                    return {
                        u0: 0,
                        v0: 0,
                        u1: 0,
                        v1: 0,
                        width: 0,
                        height: 0,
                        x: 0,
                        y: 0,
                        flipX: false,
                        flipY: false,
                        cx: 0,
                        cy: 0,
                        cw: 0,
                        ch: 0
                    };
                }
            };
            module1.exports = TextureCrop;
        /***/ },
        /* 635 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the tint of a Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.GameObjects.Components.Tint
 * @webglOnly
 * @since 3.0.0
 */ var Tint = {
                /**
     * The tint value being applied to the top-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopLeft: 0xffffff,
                /**
     * The tint value being applied to the top-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintTopRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintTopRight: 0xffffff,
                /**
     * The tint value being applied to the bottom-left vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomLeft
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomLeft: 0xffffff,
                /**
     * The tint value being applied to the bottom-right vertice of the Game Object.
     * This value is interpolated from the corner to the center of the Game Object.
     * The value should be set as a hex number, i.e. 0xff0000 for red, or 0xff00ff for purple.
     *
     * @name Phaser.GameObjects.Components.Tint#tintBottomRight
     * @type {number}
     * @default 0xffffff
     * @since 3.0.0
     */ tintBottomRight: 0xffffff,
                /**
     * The tint fill mode.
     *
     * `false` = An additive tint (the default), where vertices colors are blended with the texture.
     * `true` = A fill tint, where the vertices colors replace the texture, but respects texture alpha.
     *
     * @name Phaser.GameObjects.Components.Tint#tintFill
     * @type {boolean}
     * @default false
     * @since 3.11.0
     */ tintFill: false,
                /**
     * Clears all tint values associated with this Game Object.
     *
     * Immediately sets the color values back to 0xffffff and the tint type to 'additive',
     * which results in no visible change to the texture.
     *
     * @method Phaser.GameObjects.Components.Tint#clearTint
     * @webglOnly
     * @since 3.0.0
     *
     * @return {this} This Game Object instance.
     */ clearTint: function() {
                    this.setTint(0xffffff);
                    return this;
                },
                /**
     * Sets an additive tint on this Game Object.
     *
     * The tint works by taking the pixel color values from the Game Objects texture, and then
     * multiplying it by the color value of the tint. You can provide either one color value,
     * in which case the whole Game Object will be tinted in that color. Or you can provide a color
     * per corner. The colors are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being an additive tint to a fill based tint set the property `tintFill` to `true`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTint
     * @webglOnly
     * @since 3.0.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If no other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTint: function(topLeft, topRight, bottomLeft, bottomRight) {
                    if (topLeft === undefined) topLeft = 0xffffff;
                    if (topRight === undefined) {
                        topRight = topLeft;
                        bottomLeft = topLeft;
                        bottomRight = topLeft;
                    }
                    this.tintTopLeft = topLeft;
                    this.tintTopRight = topRight;
                    this.tintBottomLeft = bottomLeft;
                    this.tintBottomRight = bottomRight;
                    this.tintFill = false;
                    return this;
                },
                /**
     * Sets a fill-based tint on this Game Object.
     *
     * Unlike an additive tint, a fill-tint literally replaces the pixel colors from the texture
     * with those in the tint. You can use this for effects such as making a player flash 'white'
     * if hit by something. You can provide either one color value, in which case the whole
     * Game Object will be rendered in that color. Or you can provide a color per corner. The colors
     * are blended together across the extent of the Game Object.
     *
     * To modify the tint color once set, either call this method again with new values or use the
     * `tint` property to set all colors at once. Or, use the properties `tintTopLeft`, `tintTopRight,
     * `tintBottomLeft` and `tintBottomRight` to set the corner color values independently.
     *
     * To remove a tint call `clearTint`.
     *
     * To swap this from being a fill-tint to an additive tint set the property `tintFill` to `false`.
     *
     * @method Phaser.GameObjects.Components.Tint#setTintFill
     * @webglOnly
     * @since 3.11.0
     *
     * @param {number} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If not other values are given this value is applied evenly, tinting the whole Game Object.
     * @param {number} [topRight] - The tint being applied to the top-right of the Game Object.
     * @param {number} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
     * @param {number} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
     *
     * @return {this} This Game Object instance.
     */ setTintFill: function(topLeft, topRight, bottomLeft, bottomRight) {
                    this.setTint(topLeft, topRight, bottomLeft, bottomRight);
                    this.tintFill = true;
                    return this;
                },
                /**
     * The tint value being applied to the whole of the Game Object.
     * This property is a setter-only. Use the properties `tintTopLeft` etc to read the current tint value.
     *
     * @name Phaser.GameObjects.Components.Tint#tint
     * @type {number}
     * @webglOnly
     * @since 3.0.0
     */ tint: {
                    set: function(value) {
                        this.setTint(value, value, value, value);
                    }
                },
                /**
     * Does this Game Object have a tint applied?
     *
     * It checks to see if the 4 tint properties are set to the value 0xffffff
     * and that the `tintFill` property is `false`. This indicates that a Game Object isn't tinted.
     *
     * @name Phaser.GameObjects.Components.Tint#isTinted
     * @type {boolean}
     * @webglOnly
     * @readonly
     * @since 3.11.0
     */ isTinted: {
                    get: function() {
                        var white = 0xffffff;
                        return this.tintFill || this.tintTopLeft !== white || this.tintTopRight !== white || this.tintBottomLeft !== white || this.tintBottomRight !== white;
                    }
                }
            };
            module1.exports = Tint;
        /***/ },
        /* 636 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Event.
 * 
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * a change data event from a Game Object you would use: `sprite.data.on('changedata', listener)`.
 * 
 * This event is dispatched for all items that change in the Data Manager.
 * To listen for the change of a specific item, use the `CHANGE_DATA_KEY_EVENT` event.
 *
 * @event Phaser.Data.Events#CHANGE_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that the Data Manager responsible for this event belongs to.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} value - The new value of the item in the Data Manager.
 * @param {any} previousValue - The previous value of the item in the Data Manager.
 */ module1.exports = 'changedata';
        /***/ },
        /* 637 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Change Data Key Event.
 * 
 * This event is dispatched by a Data Manager when an item in the data store is changed.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the change of a specific data item from a Game Object you would use: `sprite.data.on('changedata-key', listener)`,
 * where `key` is the unique string key of the data item. For example, if you have a data item stored called `gold`
 * then you can listen for `sprite.data.on('changedata-gold')`.
 *
 * @event Phaser.Data.Events#CHANGE_DATA_KEY
 * @since 3.16.1
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {any} value - The item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 * @param {any} previousValue - The previous item that was updated in the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'changedata-';
        /***/ },
        /* 638 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Data Manager Destroy Event.
 *
 * The Data Manager will listen for the destroy event from its parent, and then close itself down.
 *
 * @event Phaser.Data.Events#DESTROY
 * @since 3.50.0
 */ module1.exports = 'destroy';
        /***/ },
        /* 639 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Data Event.
 * 
 * This event is dispatched by a Data Manager when an item is removed from it.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the removal of a data item on a Game Object you would use: `sprite.data.on('removedata', listener)`.
 *
 * @event Phaser.Data.Events#REMOVE_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was removed from the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'removedata';
        /***/ },
        /* 640 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Set Data Event.
 * 
 * This event is dispatched by a Data Manager when a new item is added to the data store.
 * 
 * Game Objects with data enabled have an instance of a Data Manager under the `data` property. So, to listen for
 * the addition of a new data item on a Game Object you would use: `sprite.data.on('setdata', listener)`.
 *
 * @event Phaser.Data.Events#SET_DATA
 * @since 3.0.0
 * 
 * @param {any} parent - A reference to the object that owns the instance of the Data Manager responsible for this event.
 * @param {string} key - The unique key of the data item within the Data Manager.
 * @param {any} data - The item that was added to the Data Manager. This can be of any data type, i.e. a string, boolean, number, object or instance.
 */ module1.exports = 'setdata';
        /***/ },
        /* 641 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('addedtoscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#ADDED_TO_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = 'addedtoscene';
        /***/ },
        /* 642 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Destroy Event.
 * 
 * This event is dispatched when a Game Object instance is being destroyed.
 * 
 * Listen for it on a Game Object instance using `GameObject.on('destroy', listener)`.
 *
 * @event Phaser.GameObjects.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object which is being destroyed.
 */ module1.exports = 'destroy';
        /***/ },
        /* 643 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it on a Game Object instance using `GameObject.on('removedfromscene', listener)`.
 *
 * @event Phaser.GameObjects.Events#REMOVED_FROM_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = 'removedfromscene';
        /***/ },
        /* 644 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Complete Event.
 * 
 * This event is dispatched when a Video finishes playback by reaching the end of its duration. It
 * is also dispatched if a video marker sequence is being played and reaches the end.
 * 
 * Note that not all videos can fire this event. Live streams, for example, have no fixed duration,
 * so never technically 'complete'.
 * 
 * If a video is stopped from playback, via the `Video.stop` method, it will emit the
 * `VIDEO_STOP` event instead of this one.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('complete', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_COMPLETE
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed playback.
 */ module1.exports = 'complete';
        /***/ },
        /* 645 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Created Event.
 * 
 * This event is dispatched when the texture for a Video has been created. This happens
 * when enough of the video source has been loaded that the browser is able to render a
 * frame from it.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('created', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_CREATED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 * @param {number} width - The width of the video.
 * @param {number} height - The height of the video.
 */ module1.exports = 'created';
        /***/ },
        /* 646 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Error Event.
 * 
 * This event is dispatched when a Video tries to play a source that does not exist, or is the wrong file type.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('error', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_ERROR
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which threw the error.
 * @param {Event} event - The native DOM event the browser raised during playback.
 */ module1.exports = 'error';
        /***/ },
        /* 647 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Loop Event.
 * 
 * This event is dispatched when a Video that is currently playing has looped. This only
 * happens if the `loop` parameter was specified, or the `setLoop` method was called,
 * and if the video has a fixed duration. Video streams, for example, cannot loop, as
 * they have no duration.
 * 
 * Looping is based on the result of the Video `timeupdate` event. This event is not
 * frame-accurate, due to the way browsers work, so please do not rely on this loop
 * event to be time or frame precise.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('loop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_LOOP
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which has looped.
 */ module1.exports = 'loop';
        /***/ },
        /* 648 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Play Event.
 * 
 * This event is dispatched when a Video begins playback. For videos that do not require
 * interaction unlocking, this is usually as soon as the `Video.play` method is called.
 * However, for videos that require unlocking, it is fired once playback begins after
 * they've been unlocked.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('play', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_PLAY
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started playback.
 */ module1.exports = 'play';
        /***/ },
        /* 649 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeked Event.
 * 
 * This event is dispatched when a Video completes seeking to a new point in its timeline.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('seeked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which completed seeking.
 */ module1.exports = 'seeked';
        /***/ },
        /* 650 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Seeking Event.
 * 
 * This event is dispatched when a Video _begins_ seeking to a new point in its timeline.
 * When the seek is complete, it will dispatch the `VIDEO_SEEKED` event to conclude.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('seeking', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_SEEKING
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which started seeking.
 */ module1.exports = 'seeking';
        /***/ },
        /* 651 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Stopped Event.
 * 
 * This event is dispatched when a Video is stopped from playback via a call to the `Video.stop` method,
 * either directly via game code, or indirectly as the result of changing a video source or destroying it.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('stop', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_STOP
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which stopped playback.
 */ module1.exports = 'stop';
        /***/ },
        /* 652 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Timeout Event.
 * 
 * This event is dispatched when a Video has exhausted its allocated time while trying to connect to a video
 * source to start playback.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('timeout', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_TIMEOUT
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which timed out.
 */ module1.exports = 'timeout';
        /***/ },
        /* 653 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Video Game Object Unlocked Event.
 * 
 * This event is dispatched when a Video that was prevented from playback due to the browsers
 * Media Engagement Interaction policy, is unlocked by a user gesture.
 * 
 * Listen for it from a Video Game Object instance using `Video.on('unlocked', listener)`.
 *
 * @event Phaser.GameObjects.Events#VIDEO_UNLOCKED
 * @since 3.20.0
 * 
 * @param {Phaser.GameObjects.Video} video - The Video Game Object which raised the event.
 */ module1.exports = 'unlocked';
        /***/ },
        /* 654 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `alpha` property,
 * and then adds the given value to each of their `alpha` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `alpha` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncAlpha = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'alpha', value, step, index, direction);
            };
            module1.exports = IncAlpha;
        /***/ },
        /* 655 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `x` property,
 * and then adds the given value to each of their `x` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `x` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncX = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'x', value, step, index, direction);
            };
            module1.exports = IncX;
        /***/ },
        /* 656 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.IncXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to be added to the `x` property.
 * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncXY = function(items, x, y, stepX, stepY, index, direction) {
                if (y === undefined || y === null) y = x;
                PropertyValueInc(items, 'x', x, stepX, index, direction);
                return PropertyValueInc(items, 'y', y, stepY, index, direction);
            };
            module1.exports = IncXY;
        /***/ },
        /* 657 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `y` property,
 * and then adds the given value to each of their `y` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `IncY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.IncY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `y` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var IncY = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'y', value, step, index, direction);
            };
            module1.exports = IncY;
        /***/ },
        /* 658 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Circle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnCircle = function(items, circle, startAngle, endAngle) {
                if (startAngle === undefined) startAngle = 0;
                if (endAngle === undefined) endAngle = 6.28;
                var angle = startAngle;
                var angleStep = (endAngle - startAngle) / items.length;
                for(var i = 0; i < items.length; i++){
                    items[i].x = circle.x + circle.radius * Math.cos(angle);
                    items[i].y = circle.y + circle.radius * Math.sin(angle);
                    angle += angleStep;
                }
                return items;
            };
            module1.exports = PlaceOnCircle;
        /***/ },
        /* 659 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of an Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects on.
 * @param {number} [startAngle=0] - Optional angle to start position from, in radians.
 * @param {number} [endAngle=6.28] - Optional angle to stop position at, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnEllipse = function(items, ellipse, startAngle, endAngle) {
                if (startAngle === undefined) startAngle = 0;
                if (endAngle === undefined) endAngle = 6.28;
                var angle = startAngle;
                var angleStep = (endAngle - startAngle) / items.length;
                var a = ellipse.width / 2;
                var b = ellipse.height / 2;
                for(var i = 0; i < items.length; i++){
                    items[i].x = ellipse.x + a * Math.cos(angle);
                    items[i].y = ellipse.y + b * Math.sin(angle);
                    angle += angleStep;
                }
                return items;
            };
            module1.exports = PlaceOnEllipse;
        /***/ },
        /* 660 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetPoints = __webpack_require__(168);
            /**
 * Positions an array of Game Objects on evenly spaced points of a Line.
 *
 * @function Phaser.Actions.PlaceOnLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects on.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnLine = function(items, line) {
                var points = GetPoints(line, items.length);
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    var point = points[i];
                    item.x = point.x;
                    item.y = point.y;
                }
                return items;
            };
            module1.exports = PlaceOnLine;
        /***/ },
        /* 661 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MarchingAnts = __webpack_require__(310);
            var RotateLeft = __webpack_require__(175);
            var RotateRight = __webpack_require__(176);
            /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the perimeter of a Rectangle.
 * 
 * Placement starts from the top-left of the rectangle, and proceeds in a clockwise direction.
 * If the `shift` parameter is given you can offset where placement begins.
 *
 * @function Phaser.Actions.PlaceOnRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects on.
 * @param {number} [shift=1] - An optional positional offset.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnRectangle = function(items, rect, shift) {
                if (shift === undefined) shift = 0;
                var points = MarchingAnts(rect, false, items.length);
                if (shift > 0) RotateLeft(points, shift);
                else if (shift < 0) RotateRight(points, Math.abs(shift));
                for(var i = 0; i < items.length; i++){
                    items[i].x = points[i].x;
                    items[i].y = points[i].y;
                }
                return items;
            };
            module1.exports = PlaceOnRectangle;
        /***/ },
        /* 662 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BresenhamPoints = __webpack_require__(311);
            /**
 * Takes an array of Game Objects and positions them on evenly spaced points around the edges of a Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.PlaceOnTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects on.
 * @param {number} [stepRate=1] - An optional step rate, to increase or decrease the packing of the Game Objects on the lines.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlaceOnTriangle = function(items, triangle, stepRate) {
                var p1 = BresenhamPoints({
                    x1: triangle.x1,
                    y1: triangle.y1,
                    x2: triangle.x2,
                    y2: triangle.y2
                }, stepRate);
                var p2 = BresenhamPoints({
                    x1: triangle.x2,
                    y1: triangle.y2,
                    x2: triangle.x3,
                    y2: triangle.y3
                }, stepRate);
                var p3 = BresenhamPoints({
                    x1: triangle.x3,
                    y1: triangle.y3,
                    x2: triangle.x1,
                    y2: triangle.y1
                }, stepRate);
                //  Remove overlaps
                p1.pop();
                p2.pop();
                p3.pop();
                p1 = p1.concat(p2, p3);
                var step = p1.length / items.length;
                var p = 0;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    var point = p1[Math.floor(p)];
                    item.x = point.x;
                    item.y = point.y;
                    p += step;
                }
                return items;
            };
            module1.exports = PlaceOnTriangle;
        /***/ },
        /* 663 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Play an animation with the given key, starting at the given startFrame on all Game Objects in items.
 *
 * @function Phaser.Actions.PlayAnimation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} key - The name of the animation to play.
 * @param {(string|number)} [startFrame] - The starting frame of the animation with the given key.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var PlayAnimation = function(items, key, startFrame) {
                for(var i = 0; i < items.length; i++)items[i].anims.play(key, startFrame);
                return items;
            };
            module1.exports = PlayAnimation;
        /***/ },
        /* 664 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(166);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Circle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Circle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomCircle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Circle} circle - The Circle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomCircle = function(items, circle) {
                for(var i = 0; i < items.length; i++)Random(circle, items[i]);
                return items;
            };
            module1.exports = RandomCircle;
        /***/ },
        /* 665 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(177);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Ellipse.
 * 
 * If you wish to pass a `Phaser.GameObjects.Ellipse` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomEllipse
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomEllipse = function(items, ellipse) {
                for(var i = 0; i < items.length; i++)Random(ellipse, items[i]);
                return items;
            };
            module1.exports = RandomEllipse;
        /***/ },
        /* 666 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(169);
            /**
 * Takes an array of Game Objects and positions them at random locations on the Line.
 * 
 * If you wish to pass a `Phaser.GameObjects.Line` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomLine
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Line} line - The Line to position the Game Objects randomly on.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomLine = function(items, line) {
                for(var i = 0; i < items.length; i++)Random(line, items[i]);
                return items;
            };
            module1.exports = RandomLine;
        /***/ },
        /* 667 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(170);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Rectangle.
 *
 * @function Phaser.Actions.RandomRectangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomRectangle = function(items, rect) {
                for(var i = 0; i < items.length; i++)Random(rect, items[i]);
                return items;
            };
            module1.exports = RandomRectangle;
        /***/ },
        /* 668 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Random = __webpack_require__(178);
            /**
 * Takes an array of Game Objects and positions them at random locations within the Triangle.
 * 
 * If you wish to pass a `Phaser.GameObjects.Triangle` Shape to this function, you should pass its `geom` property.
 *
 * @function Phaser.Actions.RandomTriangle
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to position the Game Objects within.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RandomTriangle = function(items, triangle) {
                for(var i = 0; i < items.length; i++)Random(triangle, items[i]);
                return items;
            };
            module1.exports = RandomTriangle;
        /***/ },
        /* 669 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `rotation` property,
 * and then adds the given value to each of their `rotation` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `Rotate(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `rotation` property (in radians).
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var Rotate = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'rotation', value, step, index, direction);
            };
            module1.exports = Rotate;
        /***/ },
        /* 670 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundDistance = __webpack_require__(179);
            var DistanceBetween = __webpack_require__(48);
            /**
 * Rotates each item around the given point by the given angle.
 *
 * @function Phaser.Actions.RotateAround
 * @since 3.0.0
 * @see Phaser.Math.RotateAroundDistance
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAround = function(items, point, angle) {
                var x = point.x;
                var y = point.y;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    RotateAroundDistance(item, x, y, angle, Math.max(1, DistanceBetween(item.x, item.y, x, y)));
                }
                return items;
            };
            module1.exports = RotateAround;
        /***/ },
        /* 671 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathRotateAroundDistance = __webpack_require__(179);
            /**
 * Rotates an array of Game Objects around a point by the given angle and distance.
 *
 * @function Phaser.Actions.RotateAroundDistance
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {object} point - Any object with public `x` and `y` properties.
 * @param {number} angle - The angle to rotate by, in radians.
 * @param {number} distance - The distance from the point of rotation in pixels.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var RotateAroundDistance = function(items, point, angle, distance) {
                var x = point.x;
                var y = point.y;
                //  There's nothing to do
                if (distance === 0) return items;
                for(var i = 0; i < items.length; i++)MathRotateAroundDistance(items[i], x, y, angle, distance);
                return items;
            };
            module1.exports = RotateAroundDistance;
        /***/ },
        /* 672 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `scaleX` property,
 * and then adds the given value to each of their `scaleX` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleX` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleX = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'scaleX', value, step, index, direction);
            };
            module1.exports = ScaleX;
        /***/ },
        /* 673 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have public `scaleX` and `scaleY` properties,
 * and then adds the given value to each of them.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleXY(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.ScaleXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to be added to the `scaleX` property.
 * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleXY = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                PropertyValueInc(items, 'scaleX', scaleX, stepX, index, direction);
                return PropertyValueInc(items, 'scaleY', scaleY, stepY, index, direction);
            };
            module1.exports = ScaleXY;
        /***/ },
        /* 674 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueInc = __webpack_require__(44);
            /**
 * Takes an array of Game Objects, or any objects that have a public `scaleY` property,
 * and then adds the given value to each of their `scaleY` properties.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `ScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.ScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to be added to the `scaleY` property.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var ScaleY = function(items, value, step, index, direction) {
                return PropertyValueInc(items, 'scaleY', value, step, index, direction);
            };
            module1.exports = ScaleY;
        /***/ },
        /* 675 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `alpha`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetAlpha(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetAlpha
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetAlpha = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'alpha', value, step, index, direction);
            };
            module1.exports = SetAlpha;
        /***/ },
        /* 676 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `blendMode`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetBlendMode(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetBlendMode
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetBlendMode = function(items, value, index, direction) {
                return PropertyValueSet(items, 'blendMode', value, 0, index, direction);
            };
            module1.exports = SetBlendMode;
        /***/ },
        /* 677 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `depth`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetDepth(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetDepth
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetDepth = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'depth', value, step, index, direction);
            };
            module1.exports = SetDepth;
        /***/ },
        /* 678 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes all provided Game Objects to the Input Manager to enable them for input with identical areas and callbacks.
 * 
 * @see {@link Phaser.GameObjects.GameObject#setInteractive}
 *
 * @function Phaser.Actions.SetHitArea
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {*} hitArea - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
 * @param {Phaser.Types.Input.HitAreaCallback} hitAreaCallback - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetHitArea = function(items, hitArea, hitAreaCallback) {
                for(var i = 0; i < items.length; i++)items[i].setInteractive(hitArea, hitAreaCallback);
                return items;
            };
            module1.exports = SetHitArea;
        /***/ },
        /* 679 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `originX` and `originY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetOrigin(group.getChildren(), originX, originY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetOrigin
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} originX - The amount to set the `originX` property to.
 * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
 * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetOrigin = function(items, originX, originY, stepX, stepY, index, direction) {
                if (originY === undefined || originY === null) originY = originX;
                PropertyValueSet(items, 'originX', originX, stepX, index, direction);
                PropertyValueSet(items, 'originY', originY, stepY, index, direction);
                items.forEach(function(item) {
                    item.updateDisplayOrigin();
                });
                return items;
            };
            module1.exports = SetOrigin;
        /***/ },
        /* 680 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `rotation`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetRotation(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetRotation
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetRotation = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'rotation', value, step, index, direction);
            };
            module1.exports = SetRotation;
        /***/ },
        /* 681 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `scaleX` and `scaleY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScale(group.getChildren(), scaleX, scaleY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScale
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scaleX - The amount to set the `scaleX` property to.
 * @param {number} [scaleY] - The amount to set the `scaleY` property to. If `undefined` or `null` it uses the `scaleX` value.
 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScale = function(items, scaleX, scaleY, stepX, stepY, index, direction) {
                if (scaleY === undefined || scaleY === null) scaleY = scaleX;
                PropertyValueSet(items, 'scaleX', scaleX, stepX, index, direction);
                return PropertyValueSet(items, 'scaleY', scaleY, stepY, index, direction);
            };
            module1.exports = SetScale;
        /***/ },
        /* 682 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'scaleX', value, step, index, direction);
            };
            module1.exports = SetScaleX;
        /***/ },
        /* 683 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scaleY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScaleY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScaleY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScaleY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'scaleY', value, step, index, direction);
            };
            module1.exports = SetScaleY;
        /***/ },
        /* 684 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `scrollFactorX` and `scrollFactorY`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactor(group.getChildren(), scrollFactorX, scrollFactorY, stepX, stepY)`
 *
 * @function Phaser.Actions.SetScrollFactor
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} scrollFactorX - The amount to set the `scrollFactorX` property to.
 * @param {number} [scrollFactorY] - The amount to set the `scrollFactorY` property to. If `undefined` or `null` it uses the `scrollFactorX` value.
 * @param {number} [stepX=0] - This is added to the `scrollFactorX` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `scrollFactorY` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactor = function(items, scrollFactorX, scrollFactorY, stepX, stepY, index, direction) {
                if (scrollFactorY === undefined || scrollFactorY === null) scrollFactorY = scrollFactorX;
                PropertyValueSet(items, 'scrollFactorX', scrollFactorX, stepX, index, direction);
                return PropertyValueSet(items, 'scrollFactorY', scrollFactorY, stepY, index, direction);
            };
            module1.exports = SetScrollFactor;
        /***/ },
        /* 685 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorX`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorX
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'scrollFactorX', value, step, index, direction);
            };
            module1.exports = SetScrollFactorX;
        /***/ },
        /* 686 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `scrollFactorY`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetScrollFactorY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetScrollFactorY
 * @since 3.21.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetScrollFactorY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'scrollFactorY', value, step, index, direction);
            };
            module1.exports = SetScrollFactorY;
        /***/ },
        /* 687 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects, or any objects that have the public method setTint() and then updates it to the given value(s). You can specify tint color per corner or provide only one color value for `topLeft` parameter, in which case whole item will be tinted with that color.
 *
 * @function Phaser.Actions.SetTint
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {number} topLeft - The tint being applied to top-left corner of item. If other parameters are given no value, this tint will be applied to whole item.
 * @param {number} [topRight] - The tint to be applied to top-right corner of item.
 * @param {number} [bottomLeft] - The tint to be applied to the bottom-left corner of item.
 * @param {number} [bottomRight] - The tint to be applied to the bottom-right corner of item.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SetTint = function(items, topLeft, topRight, bottomLeft, bottomRight) {
                for(var i = 0; i < items.length; i++)items[i].setTint(topLeft, topRight, bottomLeft, bottomRight);
                return items;
            };
            module1.exports = SetTint;
        /***/ },
        /* 688 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `visible`
 * and then sets it to the given value.
 *
 * To use this with a Group: `SetVisible(group.getChildren(), value)`
 *
 * @function Phaser.Actions.SetVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {boolean} value - The value to set the property to.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetVisible = function(items, value, index, direction) {
                return PropertyValueSet(items, 'visible', value, 0, index, direction);
            };
            module1.exports = SetVisible;
        /***/ },
        /* 689 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `x`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetX(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetX
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetX = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'x', value, step, index, direction);
            };
            module1.exports = SetX;
        /***/ },
        /* 690 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public properties `x` and `y`
 * and then sets them to the given values.
 *
 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetXY(group.getChildren(), x, y, stepX, stepY)`
 *
 * @function Phaser.Actions.SetXY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} x - The amount to set the `x` property to.
 * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetXY = function(items, x, y, stepX, stepY, index, direction) {
                if (y === undefined || y === null) y = x;
                PropertyValueSet(items, 'x', x, stepX, index, direction);
                return PropertyValueSet(items, 'y', y, stepY, index, direction);
            };
            module1.exports = SetXY;
        /***/ },
        /* 691 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PropertyValueSet = __webpack_require__(27);
            /**
 * Takes an array of Game Objects, or any objects that have the public property `y`
 * and then sets it to the given value.
 *
 * The optional `step` property is applied incrementally, multiplied by each item in the array.
 *
 * To use this with a Group: `SetY(group.getChildren(), value, step)`
 *
 * @function Phaser.Actions.SetY
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
 * @param {number} value - The amount to set the property to.
 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
 * @param {number} [index=0] - An optional offset to start searching from within the items array.
 * @param {number} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
 */ var SetY = function(items, value, step, index, direction) {
                return PropertyValueSet(items, 'y', value, step, index, direction);
            };
            module1.exports = SetY;
        /***/ },
        /* 692 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Iterate through the items array changing the position of each element to be that of the element that came before
 * it in the array (or after it if direction = 1)
 * 
 * The first items position is set to x/y.
 * 
 * The final x/y coords are returned
 *
 * @function Phaser.Actions.ShiftPosition
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
 * @generic {Phaser.Math.Vector2} O - [output,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {number} x - The x coordinate to place the first item in the array at.
 * @param {number} y - The y coordinate to place the first item in the array at.
 * @param {number} [direction=0] - The iteration direction. 0 = first to last and 1 = last to first.
 * @param {(Phaser.Math.Vector2|object)} [output] - An optional objec to store the final objects position in.
 *
 * @return {Phaser.Math.Vector2} The output vector.
 */ var ShiftPosition = function(items, x, y, direction, output) {
                if (direction === undefined) direction = 0;
                if (output === undefined) output = new Vector2();
                var px;
                var py;
                if (items.length > 1) {
                    var i;
                    var cx;
                    var cy;
                    var cur;
                    if (direction === 0) {
                        //  Bottom to Top
                        var len = items.length - 1;
                        px = items[len].x;
                        py = items[len].y;
                        for(i = len - 1; i >= 0; i--){
                            //  Current item
                            cur = items[i];
                            //  Get current item x/y, to be passed to the next item in the list
                            cx = cur.x;
                            cy = cur.y;
                            //  Set current item to the previous items x/y
                            cur.x = px;
                            cur.y = py;
                            //  Set current as previous
                            px = cx;
                            py = cy;
                        }
                        //  Update the head item to the new x/y coordinates
                        items[len].x = x;
                        items[len].y = y;
                    } else {
                        //  Top to Bottom
                        px = items[0].x;
                        py = items[0].y;
                        for(i = 1; i < items.length; i++){
                            //  Current item
                            cur = items[i];
                            //  Get current item x/y, to be passed to the next item in the list
                            cx = cur.x;
                            cy = cur.y;
                            //  Set current item to the previous items x/y
                            cur.x = px;
                            cur.y = py;
                            //  Set current as previous
                            px = cx;
                            py = cy;
                        }
                        //  Update the head item to the new x/y coordinates
                        items[0].x = x;
                        items[0].y = y;
                    }
                } else {
                    px = items[0].x;
                    py = items[0].y;
                    items[0].x = x;
                    items[0].y = y;
                }
                //  Return the final set of coordinates as they're effectively lost from the shift and may be needed
                output.x = px;
                output.y = py;
                return output;
            };
            module1.exports = ShiftPosition;
        /***/ },
        /* 693 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayShuffle = __webpack_require__(129);
            /**
 * Shuffles the array in place. The shuffled array is both modified and returned.
 *
 * @function Phaser.Actions.Shuffle
 * @since 3.0.0
 * @see Phaser.Utils.Array.Shuffle
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var Shuffle = function(items) {
                return ArrayShuffle(items);
            };
            module1.exports = Shuffle;
        /***/ },
        /* 694 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmootherStep = __webpack_require__(180);
            /**
 * Smootherstep is a sigmoid-like interpolation and clamping function.
 * 
 * The function depends on three parameters, the input x, the "left edge" and the "right edge", with the left edge being assumed smaller than the right edge. The function receives a real number x as an argument and returns 0 if x is less than or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the smoothstep function is zero at both edges. This is convenient for creating a sequence of transitions using smoothstep to interpolate each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmootherStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmootherStep = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmootherStep(i * step, min, max);
                else for(i = 0; i < items.length; i++)items[i][property] = MathSmootherStep(i * step, min, max);
                return items;
            };
            module1.exports = SmootherStep;
        /***/ },
        /* 695 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MathSmoothStep = __webpack_require__(181);
            /**
 * Smoothstep is a sigmoid-like interpolation and clamping function.
 * 
 * The function depends on three parameters, the input x, the "left edge" and the "right edge", with the left edge being assumed smaller than the right edge. The function receives a real number x as an argument and returns 0 if x is less than or equal to the left edge, 1 if x is greater than or equal to the right edge, and smoothly interpolates, using a Hermite polynomial, between 0 and 1 otherwise. The slope of the smoothstep function is zero at both edges. This is convenient for creating a sequence of transitions using smoothstep to interpolate each segment as an alternative to using more sophisticated or expensive interpolation techniques.
 *
 * @function Phaser.Actions.SmoothStep
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to interpolate.
 * @param {number} min - The minimum interpolation value.
 * @param {number} max - The maximum interpolation value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var SmoothStep = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += MathSmoothStep(i * step, min, max);
                else for(i = 0; i < items.length; i++)items[i][property] = MathSmoothStep(i * step, min, max);
                return items;
            };
            module1.exports = SmoothStep;
        /***/ },
        /* 696 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and then modifies their `property` so the value equals, or is incremented, by the
 * calculated spread value.
 * 
 * The spread value is derived from the given `min` and `max` values and the total number of items in the array.
 * 
 * For example, to cause an array of Sprites to change in alpha from 0 to 1 you could call:
 * 
 * ```javascript
 * Phaser.Actions.Spread(itemsArray, 'alpha', 0, 1);
 * ```
 *
 * @function Phaser.Actions.Spread
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {string} property - The property of the Game Object to spread.
 * @param {number} min - The minimum value.
 * @param {number} max - The maximum value.
 * @param {boolean} [inc=false] - Should the values be incremented? `true` or set (`false`)
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that were passed to this Action.
 */ var Spread = function(items, property, min, max, inc) {
                if (inc === undefined) inc = false;
                var step = Math.abs(max - min) / items.length;
                var i;
                if (inc) for(i = 0; i < items.length; i++)items[i][property] += i * step + min;
                else for(i = 0; i < items.length; i++)items[i][property] = i * step + min;
                return items;
            };
            module1.exports = Spread;
        /***/ },
        /* 697 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes an array of Game Objects and toggles the visibility of each one.
 * Those previously `visible = false` will become `visible = true`, and vice versa.
 *
 * @function Phaser.Actions.ToggleVisible
 * @since 3.0.0
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var ToggleVisible = function(items) {
                for(var i = 0; i < items.length; i++)items[i].visible = !items[i].visible;
                return items;
            };
            module1.exports = ToggleVisible;
        /***/ },
        /* 698 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       samme <samme.npm@gmail.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Wrap = __webpack_require__(66);
            /**
 * Wrap each item's coordinates within a rectangle's area.
 *
 * @function Phaser.Actions.WrapInRectangle
 * @since 3.0.0
 * @see Phaser.Math.Wrap
 *
 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
 *
 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
 * @param {number} [padding=0] - An amount added to each side of the rectangle during the operation.
 *
 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
 */ var WrapInRectangle = function(items, rect, padding) {
                if (padding === undefined) padding = 0;
                for(var i = 0; i < items.length; i++){
                    var item = items[i];
                    item.x = Wrap(item.x, rect.left - padding, rect.right + padding);
                    item.y = Wrap(item.y, rect.top - padding, rect.bottom + padding);
                }
                return items;
            };
            module1.exports = WrapInRectangle;
        /***/ },
        /* 699 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Animations
 */ module1.exports = {
                Animation: __webpack_require__(182),
                AnimationFrame: __webpack_require__(313),
                AnimationManager: __webpack_require__(315),
                AnimationState: __webpack_require__(162),
                Events: __webpack_require__(130)
            };
        /***/ },
        /* 700 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Add Animation Event.
 * 
 * This event is dispatched when a new animation is added to the global Animation Manager.
 * 
 * This can happen either as a result of an animation instance being added to the Animation Manager,
 * or the Animation Manager creating a new animation directly.
 *
 * @event Phaser.Animations.Events#ADD_ANIMATION
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Animation that was added to the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the newly created Animation.
 */ module1.exports = 'add';
        /***/ },
        /* 701 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * Listen for it on the Sprite using `sprite.on('animationcomplete', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationcomplete';
        /***/ },
        /* 702 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Complete Dynamic Key Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it completes playback.
 * This happens when the animation gets to the end of its sequence, factoring in any delays
 * or repeats it may have to process.
 *
 * An animation that is set to loop, or repeat forever, will never fire this event, because
 * it never actually completes. If you need to handle this, listen for the `ANIMATION_STOP`
 * event instead, as this is emitted when the animation is stopped directly.
 *
 * The difference between this and the `ANIMATION_COMPLETE` event is that this one has a
 * dynamic event name that contains the name of the animation within it. For example,
 * if you had an animation called `explode` you could listen for the completion of that
 * specific animation by using: `sprite.on('animationcomplete-explode', listener)`. Or, if you
 * wish to use types: `sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'explode', listener)`.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_COMPLETE_KEY
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that completed.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationcomplete-';
        /***/ },
        /* 703 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Repeat Event.
 *
 * This event is dispatched by a Sprite when an animation repeats playing on it.
 * This happens if the animation was created, or played, with a `repeat` value specified.
 *
 * An animation will repeat when it reaches the end of its sequence.
 *
 * Listen for it on the Sprite using `sprite.on('animationrepeat', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_REPEAT
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has repeated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation repeated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationrepeat';
        /***/ },
        /* 704 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Restart Event.
 *
 * This event is dispatched by a Sprite when an animation restarts playing on it.
 * This only happens when the `Sprite.anims.restart` method is called.
 *
 * Listen for it on the Sprite using `sprite.on('animationrestart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_RESTART
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has restarted.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation restarted.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationrestart';
        /***/ },
        /* 705 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Start Event.
 *
 * This event is dispatched by a Sprite when an animation starts playing on it.
 * This happens when the animation is played, factoring in any delay that may have been specified.
 * This event happens after the delay has expired and prior to the first update event.
 *
 * Listen for it on the Sprite using `sprite.on('animationstart', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_START
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has started.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation started.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationstart';
        /***/ },
        /* 706 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Stop Event.
 *
 * This event is dispatched by a Sprite when an animation is stopped on it. An animation
 * will only be stopeed if a method such as `Sprite.stop` or `Sprite.anims.stopAfterDelay`
 * is called. It can also be emitted if a new animation is started before the current one completes.
 *
 * Listen for it on the Sprite using `sprite.on('animationstop', listener)`
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_STOP
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has stopped.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation stopped.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationstop';
        /***/ },
        /* 707 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Animation Update Event.
 *
 * This event is dispatched by a Sprite when an animation playing on it updates. This happens when the animation changes frame.
 * An animation will change frame based on the frme rate and other factors like `timeScale` and `delay`. It can also change
 * frame when stopped or restarted.
 *
 * Listen for it on the Sprite using `sprite.on('animationupdate', listener)`
 *
 * If an animation is playing faster than the game frame-rate can handle, it's entirely possible for it to emit several
 * update events in a single game frame, so please be aware of this in your code. The **final** event received that frame
 * is the one that is rendered to the game.
 *
 * The animation event flow is as follows:
 *
 * 1. `ANIMATION_START`
 * 2. `ANIMATION_UPDATE` (repeated for however many frames the animation has)
 * 3. `ANIMATION_REPEAT` (only if the animation is set to repeat, it then emits more update events after this)
 * 4. `ANIMATION_COMPLETE` (only if there is a finite, or zero, repeat count)
 * 5. `ANIMATION_COMPLETE_KEY` (only if there is a finite, or zero, repeat count)
 *
 * If the animation is stopped directly, the `ANIMATION_STOP` event is dispatched instead of `ANIMATION_COMPLETE`.
 *
 * If the animation is restarted while it is already playing, `ANIMATION_RESTART` is emitted.
 *
 * @event Phaser.Animations.Events#ANIMATION_UPDATE
 * @since 3.50.0
 *
 * @param {Phaser.Animations.Animation} animation - A reference to the Animation that has updated.
 * @param {Phaser.Animations.AnimationFrame} frame - The current Animation Frame of the Animation.
 * @param {Phaser.GameObjects.Sprite} gameObject - A reference to the Game Object on which the animation updated.
 * @param {string} frameKey - The unique key of the Animation Frame within the Animation.
 */ module1.exports = 'animationupdate';
        /***/ },
        /* 708 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Animations Event.
 * 
 * This event is dispatched when the global Animation Manager is told to pause.
 * 
 * When this happens all current animations will stop updating, although it doesn't necessarily mean
 * that the game has paused as well.
 *
 * @event Phaser.Animations.Events#PAUSE_ALL
 * @since 3.0.0
 */ module1.exports = 'pauseall';
        /***/ },
        /* 709 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Remove Animation Event.
 * 
 * This event is dispatched when an animation is removed from the global Animation Manager.
 *
 * @event Phaser.Animations.Events#REMOVE_ANIMATION
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Animation that was removed from the global Animation Manager.
 * @param {Phaser.Animations.Animation} animation - An instance of the removed Animation.
 */ module1.exports = 'remove';
        /***/ },
        /* 710 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Animations Event.
 * 
 * This event is dispatched when the global Animation Manager resumes, having been previously paused.
 * 
 * When this happens all current animations will continue updating again.
 *
 * @event Phaser.Animations.Events#RESUME_ALL
 * @since 3.0.0
 */ module1.exports = 'resumeall';
        /***/ },
        /* 711 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cache
 */ module1.exports = {
                BaseCache: __webpack_require__(317),
                CacheManager: __webpack_require__(319),
                Events: __webpack_require__(318)
            };
        /***/ },
        /* 712 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Add Event.
 * 
 * This event is dispatched by any Cache that extends the BaseCache each time a new object is added to it.
 *
 * @event Phaser.Cache.Events#ADD
 * @since 3.0.0
 * 
 * @param {Phaser.Cache.BaseCache} cache - The cache to which the object was added.
 * @param {string} key - The key of the object added to the cache.
 * @param {*} object - A reference to the object that was added to the cache.
 */ module1.exports = 'add';
        /***/ },
        /* 713 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Cache Remove Event.
 * 
 * This event is dispatched by any Cache that extends the BaseCache each time an object is removed from it.
 *
 * @event Phaser.Cache.Events#REMOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Cache.BaseCache} cache - The cache from which the object was removed.
 * @param {string} key - The key of the object removed from the cache.
 * @param {*} object - A reference to the object that was removed from the cache.
 */ module1.exports = 'remove';
        /***/ },
        /* 714 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras
 */ /**
 * @namespace Phaser.Types.Cameras
 */ module1.exports = {
                Controls: __webpack_require__(715),
                Scene2D: __webpack_require__(718)
            };
        /***/ },
        /* 715 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Controls
 */ module1.exports = {
                FixedKeyControl: __webpack_require__(716),
                SmoothedKeyControl: __webpack_require__(717)
            };
        /***/ },
        /* 716 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            /**
 * @classdesc
 * A Fixed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 *
 * ```javascript
 * var camControl = new FixedKeyControl({
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     speed: float OR { x: 0, y: 0 }
 * });
 * ```
 *
 * Movement is precise and has no 'smoothing' applied to it.
 *
 * You must call the `update` method of this controller every frame.
 *
 * @class FixedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.FixedKeyControlConfig} config - The Fixed Key Control configuration object.
 */ var FixedKeyControl = new Class({
                initialize: function FixedKeyControl(config) {
                    /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, 'camera', null);
                    /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, 'left', null);
                    /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, 'right', null);
                    /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, 'up', null);
                    /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, 'down', null);
                    /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, 'zoomIn', null);
                    /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, 'zoomOut', null);
                    /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
                    /**
         * The horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedX = 0;
                    /**
         * The vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#speedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.speedY = 0;
                    var speed = GetValue(config, 'speed', null);
                    if (typeof speed === 'number') {
                        this.speedX = speed;
                        this.speedY = speed;
                    } else {
                        this.speedX = GetValue(config, 'speed.x', 0);
                        this.speedY = GetValue(config, 'speed.y', 0);
                    }
                    /**
         * Internal property to track the current zoom level.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                    /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.FixedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                },
                /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                    this.active = this.camera !== null;
                    return this;
                },
                /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                    this.camera = camera;
                    return this;
                },
                /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                    if (!this.active) return;
                    if (delta === undefined) delta = 1;
                    var cam = this.camera;
                    if (this.up && this.up.isDown) cam.scrollY -= this.speedY * delta | 0;
                    else if (this.down && this.down.isDown) cam.scrollY += this.speedY * delta | 0;
                    if (this.left && this.left.isDown) cam.scrollX -= this.speedX * delta | 0;
                    else if (this.right && this.right.isDown) cam.scrollX += this.speedX * delta | 0;
                    //  Camera zoom
                    if (this.zoomIn && this.zoomIn.isDown) {
                        cam.zoom -= this.zoomSpeed;
                        if (cam.zoom < 0.1) cam.zoom = 0.1;
                    } else if (this.zoomOut && this.zoomOut.isDown) cam.zoom += this.zoomSpeed;
                },
                /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.FixedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.left = null;
                    this.right = null;
                    this.up = null;
                    this.down = null;
                    this.zoomIn = null;
                    this.zoomOut = null;
                }
            });
            module1.exports = FixedKeyControl;
        /***/ },
        /* 717 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var GetValue = __webpack_require__(6);
            /**
 * @classdesc
 * A Smoothed Key Camera Control.
 *
 * This allows you to control the movement and zoom of a camera using the defined keys.
 * Unlike the Fixed Camera Control you can also provide physics values for acceleration, drag and maxSpeed for smoothing effects.
 *
 * ```javascript
 * var controlConfig = {
 *     camera: this.cameras.main,
 *     left: cursors.left,
 *     right: cursors.right,
 *     up: cursors.up,
 *     down: cursors.down,
 *     zoomIn: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Q),
 *     zoomOut: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.E),
 *     zoomSpeed: 0.02,
 *     acceleration: 0.06,
 *     drag: 0.0005,
 *     maxSpeed: 1.0
 * };
 * ```
 * 
 * You must call the `update` method of this controller every frame.
 *
 * @class SmoothedKeyControl
 * @memberof Phaser.Cameras.Controls
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Types.Cameras.Controls.SmoothedKeyControlConfig} config - The Smoothed Key Control configuration object.
 */ var SmoothedKeyControl = new Class({
                initialize: function SmoothedKeyControl(config) {
                    /**
         * The Camera that this Control will update.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#camera
         * @type {?Phaser.Cameras.Scene2D.Camera}
         * @default null
         * @since 3.0.0
         */ this.camera = GetValue(config, 'camera', null);
                    /**
         * The Key to be pressed that will move the Camera left.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#left
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.left = GetValue(config, 'left', null);
                    /**
         * The Key to be pressed that will move the Camera right.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#right
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.right = GetValue(config, 'right', null);
                    /**
         * The Key to be pressed that will move the Camera up.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#up
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.up = GetValue(config, 'up', null);
                    /**
         * The Key to be pressed that will move the Camera down.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#down
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.down = GetValue(config, 'down', null);
                    /**
         * The Key to be pressed that will zoom the Camera in.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomIn
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomIn = GetValue(config, 'zoomIn', null);
                    /**
         * The Key to be pressed that will zoom the Camera out.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomOut
         * @type {?Phaser.Input.Keyboard.Key}
         * @default null
         * @since 3.0.0
         */ this.zoomOut = GetValue(config, 'zoomOut', null);
                    /**
         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomSpeed
         * @type {number}
         * @default 0.01
         * @since 3.0.0
         */ this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
                    /**
         * The horizontal acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelX = 0;
                    /**
         * The vertical acceleration the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.accelY = 0;
                    var accel = GetValue(config, 'acceleration', null);
                    if (typeof accel === 'number') {
                        this.accelX = accel;
                        this.accelY = accel;
                    } else {
                        this.accelX = GetValue(config, 'acceleration.x', 0);
                        this.accelY = GetValue(config, 'acceleration.y', 0);
                    }
                    /**
         * The horizontal drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragX = 0;
                    /**
         * The vertical drag applied to the camera when it is moving.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragY = 0;
                    var drag = GetValue(config, 'drag', null);
                    if (typeof drag === 'number') {
                        this.dragX = drag;
                        this.dragY = drag;
                    } else {
                        this.dragX = GetValue(config, 'drag.x', 0);
                        this.dragY = GetValue(config, 'drag.y', 0);
                    }
                    /**
         * The maximum horizontal speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedX
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedX = 0;
                    /**
         * The maximum vertical speed the camera will move.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedY
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.maxSpeedY = 0;
                    var maxSpeed = GetValue(config, 'maxSpeed', null);
                    if (typeof maxSpeed === 'number') {
                        this.maxSpeedX = maxSpeed;
                        this.maxSpeedY = maxSpeed;
                    } else {
                        this.maxSpeedX = GetValue(config, 'maxSpeed.x', 0);
                        this.maxSpeedY = GetValue(config, 'maxSpeed.y', 0);
                    }
                    /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedX = 0;
                    /**
         * Internal property to track the speed of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._speedY = 0;
                    /**
         * Internal property to track the zoom of the control.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_zoom
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._zoom = 0;
                    /**
         * A flag controlling if the Controls will update the Camera or not.
         *
         * @name Phaser.Cameras.Controls.SmoothedKeyControl#active
         * @type {boolean}
         * @since 3.0.0
         */ this.active = this.camera !== null;
                },
                /**
     * Starts the Key Control running, providing it has been linked to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#start
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ start: function() {
                    this.active = this.camera !== null;
                    return this;
                },
                /**
     * Stops this Key Control from running. Call `start` to start it again.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#stop
     * @since 3.0.0
     *
     * @return {this} This Key Control instance.
     */ stop: function() {
                    this.active = false;
                    return this;
                },
                /**
     * Binds this Key Control to a camera.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#setCamera
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
     *
     * @return {this} This Key Control instance.
     */ setCamera: function(camera) {
                    this.camera = camera;
                    return this;
                },
                /**
     * Applies the results of pressing the control keys to the Camera.
     *
     * You must call this every step, it is not called automatically.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#update
     * @since 3.0.0
     *
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(delta) {
                    if (!this.active) return;
                    if (delta === undefined) delta = 1;
                    var cam = this.camera;
                    //  Apply Deceleration
                    if (this._speedX > 0) {
                        this._speedX -= this.dragX * delta;
                        if (this._speedX < 0) this._speedX = 0;
                    } else if (this._speedX < 0) {
                        this._speedX += this.dragX * delta;
                        if (this._speedX > 0) this._speedX = 0;
                    }
                    if (this._speedY > 0) {
                        this._speedY -= this.dragY * delta;
                        if (this._speedY < 0) this._speedY = 0;
                    } else if (this._speedY < 0) {
                        this._speedY += this.dragY * delta;
                        if (this._speedY > 0) this._speedY = 0;
                    }
                    //  Check for keys
                    if (this.up && this.up.isDown) {
                        this._speedY += this.accelY;
                        if (this._speedY > this.maxSpeedY) this._speedY = this.maxSpeedY;
                    } else if (this.down && this.down.isDown) {
                        this._speedY -= this.accelY;
                        if (this._speedY < -this.maxSpeedY) this._speedY = -this.maxSpeedY;
                    }
                    if (this.left && this.left.isDown) {
                        this._speedX += this.accelX;
                        if (this._speedX > this.maxSpeedX) this._speedX = this.maxSpeedX;
                    } else if (this.right && this.right.isDown) {
                        this._speedX -= this.accelX;
                        if (this._speedX < -this.maxSpeedX) this._speedX = -this.maxSpeedX;
                    }
                    //  Camera zoom
                    if (this.zoomIn && this.zoomIn.isDown) this._zoom = -this.zoomSpeed;
                    else if (this.zoomOut && this.zoomOut.isDown) this._zoom = this.zoomSpeed;
                    else this._zoom = 0;
                    //  Apply to Camera
                    if (this._speedX !== 0) cam.scrollX -= this._speedX * delta | 0;
                    if (this._speedY !== 0) cam.scrollY -= this._speedY * delta | 0;
                    if (this._zoom !== 0) {
                        cam.zoom += this._zoom;
                        if (cam.zoom < 0.001) cam.zoom = 0.001;
                    }
                },
                /**
     * Destroys this Key Control.
     *
     * @method Phaser.Cameras.Controls.SmoothedKeyControl#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.camera = null;
                    this.left = null;
                    this.right = null;
                    this.up = null;
                    this.down = null;
                    this.zoomIn = null;
                    this.zoomOut = null;
                }
            });
            module1.exports = SmoothedKeyControl;
        /***/ },
        /* 718 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Cameras.Scene2D
 */ module1.exports = {
                Camera: __webpack_require__(320),
                BaseCamera: __webpack_require__(131),
                CameraManager: __webpack_require__(775),
                Effects: __webpack_require__(327),
                Events: __webpack_require__(36)
            };
        /***/ },
        /* 719 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Destroy Camera Event.
 * 
 * This event is dispatched by a Camera instance when it is destroyed by the Camera Manager.
 *
 * @event Phaser.Cameras.Scene2D.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that was destroyed.
 */ module1.exports = 'cameradestroy';
        /***/ },
        /* 720 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Fade In Effect completes.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeincomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = 'camerafadeincomplete';
        /***/ },
        /* 721 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade In Start Event.
 * 
 * This event is dispatched by a Camera instance when the Fade In Effect starts.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeinstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_IN_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'camerafadeinstart';
        /***/ },
        /* 722 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Fade Out Effect completes.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutcomplete', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 */ module1.exports = 'camerafadeoutcomplete';
        /***/ },
        /* 723 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Fade Out Start Event.
 * 
 * This event is dispatched by a Camera instance when the Fade Out Effect starts.
 * 
 * Listen to it from a Camera instance using `Camera.on('camerafadeoutstart', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FADE_OUT_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'camerafadeoutstart';
        /***/ },
        /* 724 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Flash Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 */ module1.exports = 'cameraflashcomplete';
        /***/ },
        /* 725 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Flash Start Event.
 * 
 * This event is dispatched by a Camera instance when the Flash Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#FLASH_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} red - The red color channel value.
 * @param {number} green - The green color channel value.
 * @param {number} blue - The blue color channel value.
 */ module1.exports = 'cameraflashstart';
        /***/ },
        /* 726 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Follower Update Event.
 *
 * This event is dispatched by a Camera instance when it is following a
 * Game Object and the Camera position has been updated as a result of
 * that following.
 *
 * Listen to it from a Camera instance using: `camera.on('followupdate', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#FOLLOW_UPDATE
 * @since 3.50.0
 *
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that emitted the event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the camera is following.
 */ module1.exports = 'followupdate';
        /***/ },
        /* 727 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Pan Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 */ module1.exports = 'camerapancomplete';
        /***/ },
        /* 728 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pan Start Event.
 * 
 * This event is dispatched by a Camera instance when the Pan Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#PAN_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Pan} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} x - The destination scroll x coordinate.
 * @param {number} y - The destination scroll y coordinate.
 */ module1.exports = 'camerapanstart';
        /***/ },
        /* 729 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Post-Render Event.
 * 
 * This event is dispatched by a Camera instance after is has finished rendering.
 * It is only dispatched if the Camera is rendering to a texture.
 * 
 * Listen to it from a Camera instance using: `camera.on('postrender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#POST_RENDER
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that has finished rendering to a texture.
 */ module1.exports = 'postrender';
        /***/ },
        /* 730 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Pre-Render Event.
 * 
 * This event is dispatched by a Camera instance when it is about to render.
 * It is only dispatched if the Camera is rendering to a texture.
 * 
 * Listen to it from a Camera instance using: `camera.on('prerender', listener)`.
 *
 * @event Phaser.Cameras.Scene2D.Events#PRE_RENDER
 * @since 3.0.0
 * 
 * @param {Phaser.Cameras.Scene2D.BaseCamera} camera - The camera that is about to render to a texture.
 */ module1.exports = 'prerender';
        /***/ },
        /* 731 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Rotate Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
 * @since 3.23.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 */ module1.exports = 'camerarotatecomplete';
        /***/ },
        /* 732 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Rotate Start Event.
 * 
 * This event is dispatched by a Camera instance when the Rotate Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#ROTATE_START
 * @since 3.23.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.RotateTo} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} destination - The destination value.
 */ module1.exports = 'camerarotatestart';
        /***/ },
        /* 733 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Shake Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 */ module1.exports = 'camerashakecomplete';
        /***/ },
        /* 734 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Shake Start Event.
 * 
 * This event is dispatched by a Camera instance when the Shake Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#SHAKE_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} intensity - The intensity of the effect.
 */ module1.exports = 'camerashakestart';
        /***/ },
        /* 735 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Complete Event.
 * 
 * This event is dispatched by a Camera instance when the Zoom Effect completes.
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 */ module1.exports = 'camerazoomcomplete';
        /***/ },
        /* 736 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Camera Zoom Start Event.
 * 
 * This event is dispatched by a Camera instance when the Zoom Effect starts.
 *
 * @event Phaser.Cameras.Scene2D.Events#ZOOM_START
 * @since 3.3.0
 * 
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
 * @param {Phaser.Cameras.Scene2D.Effects.Zoom} effect - A reference to the effect instance.
 * @param {number} duration - The duration of the effect.
 * @param {number} zoom - The destination zoom value.
 */ module1.exports = 'camerazoomstart';
        /***/ },
        /* 737 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(36);
            /**
 * @classdesc
 * A Camera Fade effect.
 *
 * This effect will fade the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is faded. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Fade
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Fade = new Class({
                initialize: function Fade(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * Has this effect finished running?
         *
         * This is different from `isRunning` because it remains set to `true` when the effect is over,
         * until the effect is either reset or started again.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#isComplete
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isComplete = false;
                    /**
         * The direction of the fade.
         * `true` = fade out (transparent to color), `false` = fade in (color to transparent)
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#direction
         * @type {boolean}
         * @readonly
         * @since 3.5.0
         */ this.direction = true;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The value of the red color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                    /**
         * The value of the green color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                    /**
         * The value of the blue color channel the camera will use for the fade effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                    /**
         * The value of the alpha channel used during the fade effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#alpha
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.alpha = 0;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFadeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Fades the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#start
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_START
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_START
     * @since 3.5.0
     *
     * @param {boolean} [direction=true] - The direction of the fade. `true` = fade out (transparent to color), `false` = fade in (color to transparent)
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {number} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
     * @param {number} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
     * @param {number} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFadeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(direction, duration, red, green, blue, force, callback, context) {
                    if (direction === undefined) direction = true;
                    if (duration === undefined) duration = 1000;
                    if (red === undefined) red = 0;
                    if (green === undefined) green = 0;
                    if (blue === undefined) blue = 0;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.isComplete = false;
                    this.duration = duration;
                    this.direction = direction;
                    this.progress = 0;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = direction ? Number.MIN_VALUE : 1;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    var eventName = direction ? Events.FADE_OUT_START : Events.FADE_IN_START;
                    this.camera.emit(eventName, this.camera, this, duration, red, green, blue);
                    return this.camera;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) this.alpha = this.direction ? this.progress : 1 - this.progress;
                    else {
                        this.alpha = this.direction ? 1 : 0;
                        this.effectComplete();
                    }
                },
                /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                    if (!this.isRunning && !this.isComplete) return false;
                    var camera = this.camera;
                    ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
                    ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                    return true;
                },
                /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                    if (!this.isRunning && !this.isComplete) return false;
                    var camera = this.camera;
                    var red = this.red / 255;
                    var green = this.green / 255;
                    var blue = this.blue / 255;
                    pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                    return true;
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FADE_IN_COMPLETE
     * @fires Phaser.Cameras.Scene2D.Events#FADE_OUT_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.isComplete = true;
                    var eventName = this.direction ? Events.FADE_OUT_COMPLETE : Events.FADE_IN_COMPLETE;
                    this.camera.emit(eventName, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this.isComplete = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Fade#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Fade;
        /***/ },
        /* 738 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(36);
            /**
 * @classdesc
 * A Camera Flash effect.
 *
 * This effect will flash the camera viewport to the given color, over the duration specified.
 *
 * Only the camera viewport is flashed. None of the objects it is displaying are impacted, i.e. their colors do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect, if required.
 *
 * @class Flash
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Flash = new Class({
                initialize: function Flash(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The value of the red color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#red
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.red = 0;
                    /**
         * The value of the green color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#green
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.green = 0;
                    /**
         * The value of the blue color channel the camera will use for the flash effect.
         * A value between 0 and 255.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#blue
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.blue = 0;
                    /**
         * The value of the alpha channel used during the flash effect.
         * A value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#alpha
         * @type {number}
         * @private
         * @since 3.5.0
         */ this.alpha = 0;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraFlashCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Flashes the Camera to or from the given color over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#start
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_START
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=250] - The duration of the effect in milliseconds.
     * @param {number} [red=255] - The amount to flash the red channel towards. A value between 0 and 255.
     * @param {number} [green=255] - The amount to flash the green channel towards. A value between 0 and 255.
     * @param {number} [blue=255] - The amount to flash the blue channel towards. A value between 0 and 255.
     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraFlashCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, red, green, blue, force, callback, context) {
                    if (duration === undefined) duration = 250;
                    if (red === undefined) red = 255;
                    if (green === undefined) green = 255;
                    if (blue === undefined) blue = 255;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    this.red = red;
                    this.green = green;
                    this.blue = blue;
                    this.alpha = 1;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.FLASH_START, this.camera, this, duration, red, green, blue);
                    return this.camera;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) this.alpha = 1 - this.progress;
                    else this.effectComplete();
                },
                /**
     * Called internally by the Canvas Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderCanvas
     * @since 3.5.0
     *
     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderCanvas: function(ctx) {
                    if (!this.isRunning) return false;
                    var camera = this.camera;
                    ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
                    ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
                    return true;
                },
                /**
     * Called internally by the WebGL Renderer.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderWebGL
     * @since 3.5.0
     *
     * @param {Phaser.Renderer.WebGL.Pipelines.MultiPipeline} pipeline - The WebGL Pipeline to render to. Must provide the `drawFillRect` method.
     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
     *
     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
     */ postRenderWebGL: function(pipeline, getTintFunction) {
                    if (!this.isRunning) return false;
                    var camera = this.camera;
                    var red = this.red / 255;
                    var green = this.green / 255;
                    var blue = this.blue / 255;
                    pipeline.drawFillRect(camera.x, camera.y, camera.width, camera.height, getTintFunction(blue, green, red, 1), this.alpha);
                    return true;
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#FLASH_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.FLASH_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Flash#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Flash;
        /***/ },
        /* 739 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var EaseMap = __webpack_require__(132);
            var Events = __webpack_require__(36);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera Pan effect.
 *
 * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
 * over the duration and with the ease specified.
 *
 * Only the camera scroll is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Pan
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Pan = new Class({
                initialize: function Pan(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                    /**
         * The starting scroll coordinates to pan the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#source
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.source = new Vector2();
                    /**
         * The constantly updated value based on zoom.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#current
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.current = new Vector2();
                    /**
         * The destination scroll coordinates to pan the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#destination
         * @type {Phaser.Math.Vector2}
         * @since 3.11.0
         */ this.destination = new Vector2();
                    /**
         * The ease function to use during the pan.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.Pan#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraPanCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Pan#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given destination,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#start
     * @fires Phaser.Cameras.Scene2D.Events#PAN_START
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     *
     * @param {number} x - The destination x coordinate to scroll the center of the Camera viewport to.
     * @param {number} y - The destination y coordinate to scroll the center of the Camera viewport to.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the pan. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the pan effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraPanCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(x, y, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source.set(cam.scrollX, cam.scrollY);
                    //  Destination
                    this.destination.set(x, y);
                    //  Zoom factored version
                    cam.getScroll(x, y, this.current);
                    //  Using this ease
                    if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === 'function') this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.PAN_START, this.camera, this, duration, x, y);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    var progress = Clamp(this._elapsed / this.duration, 0, 1);
                    this.progress = progress;
                    var cam = this.camera;
                    if (this._elapsed < this.duration) {
                        var v = this.ease(progress);
                        cam.getScroll(this.destination.x, this.destination.y, this.current);
                        var x = this.source.x + (this.current.x - this.source.x) * v;
                        var y = this.source.y + (this.current.y - this.source.y) * v;
                        cam.setScroll(x, y);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, x, y);
                    } else {
                        cam.centerOn(this.destination.x, this.destination.y);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, cam.scrollX, cam.scrollY);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#PAN_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.PAN_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#reset
     * @since 3.11.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Pan#destroy
     * @since 3.11.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.source = null;
                    this.destination = null;
                }
            });
            module1.exports = Pan;
        /***/ },
        /* 740 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in.
 *
 * @function Phaser.Math.Easing.Back.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var In = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                return v * v * ((overshoot + 1) * v - overshoot);
            };
            module1.exports = In;
        /***/ },
        /* 741 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-out.
 *
 * @function Phaser.Math.Easing.Back.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                return --v * v * ((overshoot + 1) * v + overshoot) + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 742 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Back ease-in/out.
 *
 * @function Phaser.Math.Easing.Back.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [overshoot=1.70158] - The overshoot amount.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, overshoot) {
                if (overshoot === undefined) overshoot = 1.70158;
                var s = overshoot * 1.525;
                if ((v *= 2) < 1) return 0.5 * (v * v * ((s + 1) * v - s));
                else return 0.5 * ((v -= 2) * v * ((s + 1) * v + s) + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 743 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in.
 *
 * @function Phaser.Math.Easing.Bounce.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                v = 1 - v;
                if (v < 1 / 2.75) return 1 - 7.5625 * v * v;
                else if (v < 2 / 2.75) return 1 - (7.5625 * (v -= 1.5 / 2.75) * v + 0.75);
                else if (v < 2.5 / 2.75) return 1 - (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375);
                else return 1 - (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375);
            };
            module1.exports = In;
        /***/ },
        /* 744 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-out.
 *
 * @function Phaser.Math.Easing.Bounce.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                if (v < 1 / 2.75) return 7.5625 * v * v;
                else if (v < 2 / 2.75) return 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                else if (v < 2.5 / 2.75) return 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                else return 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
            };
            module1.exports = Out;
        /***/ },
        /* 745 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Bounce ease-in/out.
 *
 * @function Phaser.Math.Easing.Bounce.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                var reverse = false;
                if (v < 0.5) {
                    v = 1 - v * 2;
                    reverse = true;
                } else v = v * 2 - 1;
                if (v < 1 / 2.75) v = 7.5625 * v * v;
                else if (v < 2 / 2.75) v = 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
                else if (v < 2.5 / 2.75) v = 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
                else v = 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
                if (reverse) return (1 - v) * 0.5;
                else return v * 0.5 + 0.5;
            };
            module1.exports = InOut;
        /***/ },
        /* 746 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in.
 *
 * @function Phaser.Math.Easing.Circular.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return 1 - Math.sqrt(1 - v * v);
            };
            module1.exports = In;
        /***/ },
        /* 747 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-out.
 *
 * @function Phaser.Math.Easing.Circular.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return Math.sqrt(1 - --v * v);
            };
            module1.exports = Out;
        /***/ },
        /* 748 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Circular ease-in/out.
 *
 * @function Phaser.Math.Easing.Circular.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return -0.5 * (Math.sqrt(1 - v * v) - 1);
                else return 0.5 * (Math.sqrt(1 - (v -= 2) * v) + 1);
            };
            module1.exports = InOut;
        /***/ },
        /* 749 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in.
 *
 * @function Phaser.Math.Easing.Cubic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 750 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-out.
 *
 * @function Phaser.Math.Easing.Cubic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return --v * v * v + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 751 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Cubic ease-in/out.
 *
 * @function Phaser.Math.Easing.Cubic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v;
                else return 0.5 * ((v -= 2) * v * v + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 752 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in.
 *
 * @function Phaser.Math.Easing.Elastic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var In = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    return -(amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                }
            };
            module1.exports = In;
        /***/ },
        /* 753 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-out.
 *
 * @function Phaser.Math.Easing.Elastic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var Out = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    return amplitude * Math.pow(2, -10 * v) * Math.sin((v - s) * (2 * Math.PI) / period) + 1;
                }
            };
            module1.exports = Out;
        /***/ },
        /* 754 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Elastic ease-in/out.
 *
 * @function Phaser.Math.Easing.Elastic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [amplitude=0.1] - The amplitude of the elastic ease.
 * @param {number} [period=0.1] - Sets how tight the sine-wave is, where smaller values are tighter waves, which result in more cycles.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v, amplitude, period) {
                if (amplitude === undefined) amplitude = 0.1;
                if (period === undefined) period = 0.1;
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else {
                    var s = period / 4;
                    if (amplitude < 1) amplitude = 1;
                    else s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
                    if ((v *= 2) < 1) return -0.5 * (amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
                    else return amplitude * Math.pow(2, -10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period) * 0.5 + 1;
                }
            };
            module1.exports = InOut;
        /***/ },
        /* 755 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in.
 *
 * @function Phaser.Math.Easing.Expo.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return Math.pow(2, 10 * (v - 1)) - 0.001;
            };
            module1.exports = In;
        /***/ },
        /* 756 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-out.
 *
 * @function Phaser.Math.Easing.Expo.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return 1 - Math.pow(2, -10 * v);
            };
            module1.exports = Out;
        /***/ },
        /* 757 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Exponential ease-in/out.
 *
 * @function Phaser.Math.Easing.Expo.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * Math.pow(2, 10 * (v - 1));
                else return 0.5 * (2 - Math.pow(2, -10 * (v - 1)));
            };
            module1.exports = InOut;
        /***/ },
        /* 758 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Linear easing (no variation).
 *
 * @function Phaser.Math.Easing.Linear
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Linear = function(v) {
                return v;
            };
            module1.exports = Linear;
        /***/ },
        /* 759 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in.
 *
 * @function Phaser.Math.Easing.Quadratic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v;
            };
            module1.exports = In;
        /***/ },
        /* 760 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-out.
 *
 * @function Phaser.Math.Easing.Quadratic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return v * (2 - v);
            };
            module1.exports = Out;
        /***/ },
        /* 761 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quadratic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quadratic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v;
                else return -0.5 * (--v * (v - 2) - 1);
            };
            module1.exports = InOut;
        /***/ },
        /* 762 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in.
 *
 * @function Phaser.Math.Easing.Quartic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 763 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-out.
 *
 * @function Phaser.Math.Easing.Quartic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return 1 - --v * v * v * v;
            };
            module1.exports = Out;
        /***/ },
        /* 764 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quartic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quartic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v * v;
                else return -0.5 * ((v -= 2) * v * v * v - 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 765 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in.
 *
 * @function Phaser.Math.Easing.Quintic.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                return v * v * v * v * v;
            };
            module1.exports = In;
        /***/ },
        /* 766 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-out.
 *
 * @function Phaser.Math.Easing.Quintic.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                return --v * v * v * v * v + 1;
            };
            module1.exports = Out;
        /***/ },
        /* 767 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Quintic ease-in/out.
 *
 * @function Phaser.Math.Easing.Quintic.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if ((v *= 2) < 1) return 0.5 * v * v * v * v * v;
                else return 0.5 * ((v -= 2) * v * v * v * v + 2);
            };
            module1.exports = InOut;
        /***/ },
        /* 768 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in.
 *
 * @function Phaser.Math.Easing.Sine.In
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var In = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return 1 - Math.cos(v * Math.PI / 2);
            };
            module1.exports = In;
        /***/ },
        /* 769 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-out.
 *
 * @function Phaser.Math.Easing.Sine.Out
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var Out = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return Math.sin(v * Math.PI / 2);
            };
            module1.exports = Out;
        /***/ },
        /* 770 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sinusoidal ease-in/out.
 *
 * @function Phaser.Math.Easing.Sine.InOut
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 *
 * @return {number} The tweened value.
 */ var InOut = function(v) {
                if (v === 0) return 0;
                else if (v === 1) return 1;
                else return 0.5 * (1 - Math.cos(Math.PI * v));
            };
            module1.exports = InOut;
        /***/ },
        /* 771 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Stepped easing.
 *
 * @function Phaser.Math.Easing.Stepped
 * @since 3.0.0
 *
 * @param {number} v - The value to be tweened.
 * @param {number} [steps=1] - The number of steps in the ease.
 *
 * @return {number} The tweened value.
 */ var Stepped = function(v, steps) {
                if (steps === undefined) steps = 1;
                if (v <= 0) return 0;
                else if (v >= 1) return 1;
                else return ((steps * v | 0) + 1) * (1 / steps);
            };
            module1.exports = Stepped;
        /***/ },
        /* 772 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(36);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Camera Shake effect.
 *
 * This effect will shake the camera viewport by a random amount, bounded by the specified intensity, each frame.
 *
 * Only the camera viewport is moved. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Shake
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.5.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Shake = new Class({
                initialize: function Shake(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.5.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.5.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.5.0
         */ this.duration = 0;
                    /**
         * The intensity of the effect. Use small float values. The default when the effect starts is 0.05.
         * This is a Vector2 object, allowing you to control the shake intensity independently across x and y.
         * You can modify this value while the effect is active to create more varied shake effects.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#intensity
         * @type {Phaser.Math.Vector2}
         * @since 3.5.0
         */ this.intensity = new Vector2();
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#progress
         * @type {number}
         * @since 3.5.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * How much to offset the camera by horizontally.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetX
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetX = 0;
                    /**
         * How much to offset the camera by vertically.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetY
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._offsetY = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraShakeCallback}
         * @private
         * @default null
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                },
                /**
     * Shakes the Camera by the given intensity over the duration specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#start
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_START
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     *
     * @param {number} [duration=100] - The duration of the effect in milliseconds.
     * @param {(number|Phaser.Math.Vector2)} [intensity=0.05] - The intensity of the shake.
     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraShakeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(duration, intensity, force, callback, context) {
                    if (duration === undefined) duration = 100;
                    if (intensity === undefined) intensity = 0.05;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (!force && this.isRunning) return this.camera;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    if (typeof intensity === 'number') this.intensity.set(intensity);
                    else this.intensity.set(intensity.x, intensity.y);
                    this._elapsed = 0;
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.SHAKE_START, this.camera, this, duration, intensity);
                    return this.camera;
                },
                /**
     * The pre-render step for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#preRender
     * @since 3.5.0
     */ preRender: function() {
                    if (this.isRunning) this.camera.matrix.translate(this._offsetX, this._offsetY);
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#update
     * @since 3.5.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
                    if (this._elapsed < this.duration) {
                        var intensity = this.intensity;
                        var width = this.camera.width;
                        var height = this.camera.height;
                        var zoom = this.camera.zoom;
                        this._offsetX = (Math.random() * intensity.x * width * 2 - intensity.x * width) * zoom;
                        this._offsetY = (Math.random() * intensity.y * height * 2 - intensity.y * height) * zoom;
                        if (this.camera.roundPixels) {
                            this._offsetX = Math.round(this._offsetX);
                            this._offsetY = Math.round(this._offsetY);
                        }
                    } else this.effectComplete();
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#SHAKE_COMPLETE
     * @since 3.5.0
     */ effectComplete: function() {
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.SHAKE_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#reset
     * @since 3.5.0
     */ reset: function() {
                    this.isRunning = false;
                    this._offsetX = 0;
                    this._offsetY = 0;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Shake#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.intensity = null;
                }
            });
            module1.exports = Shake;
        /***/ },
        /* 773 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Jason Nicholls <nicholls.jason@gmail.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(36);
            var EaseMap = __webpack_require__(132);
            /**
 * @classdesc
 * A Camera Rotate effect.
 *
 * This effect will rotate the Camera so that the its viewport finishes at the given angle in radians,
 * over the duration and with the ease specified.
 * 
 * Camera rotation always takes place based on the Camera viewport. By default, rotation happens
 * in the center of the viewport. You can adjust this with the `originX` and `originY` properties.
 *
 * Rotation influences the rendering of _all_ Game Objects visible by this Camera. However, it does not
 * rotate the Camera viewport itself, which always remains an axis-aligned rectangle.
 *
 * Only the camera is rotates. None of the objects it is displaying are impacted, i.e. their positions do
 * not change.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class RotateTo
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.23.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var RotateTo = new Class({
                initialize: function RotateTo(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.23.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.23.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.23.0
         */ this.duration = 0;
                    /**
         * The starting angle to rotate the camera from.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#source
         * @type {number}
         * @since 3.23.0
         */ this.source = 0;
                    /**
         * The constantly updated value based on the force.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#current
         * @type {number}
         * @since 3.23.0
         */ this.current = 0;
                    /**
         * The destination angle in radians to rotate the camera to.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#destination
         * @type {number}
         * @since 3.23.0
         */ this.destination = 0;
                    /**
         * The ease function to use during the Rotate.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#ease
         * @type {function}
         * @since 3.23.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#progress
         * @type {number}
         * @since 3.23.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_elapsed
         * @type {number}
         * @private
         * @since 3.23.0
         */ this._elapsed = 0;
                    /**
         * @callback CameraRotateCallback
         *
         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
         * @param {number} progress - The progress of the effect. A value between 0 and 1.
         * @param {number} angle - The Camera's new angle in radians.
         */ /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdate
         * @type {?CameraRotateCallback}
         * @private
         * @default null
         * @since 3.23.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.23.0
         */ this._onUpdateScope;
                    /**
         * The direction of the rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#clockwise
         * @type {boolean}
         * @since 3.23.0
         */ this.clockwise = true;
                    /**
         * The shortest direction to the target rotation.
         * 
         * @name Phaser.Cameras.Scene2D.Effects.RotateTo#shortestPath
         * @type {boolean}
         * @since 3.23.0
         */ this.shortestPath = false;
                },
                /**
     * This effect will scroll the Camera so that the center of its viewport finishes at the given angle,
     * over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#start
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_START
     * @fires Phaser.Cameras.Scene2D.Events#ROTATE_COMPLETE
     * @since 3.23.0
     *
     * @param {number} radians - The destination angle in radians to rotate the Camera viewport to. If the angle is positive then the rotation is clockwise else anticlockwise
     * @param {boolean} [shortestPath=false] - If shortest path is set to true the camera will rotate in the quickest direction clockwise or anti-clockwise.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Rotate. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the rotation effect to start immediately, even if already running.
     * @param {CameraRotateCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent four arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * the current camera scroll x coordinate and the current camera scroll y coordinate.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(radians, shortestPath, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    if (shortestPath === undefined) shortestPath = false;
                    this.shortestPath = shortestPath;
                    var tmpDestination = radians;
                    if (radians < 0) {
                        tmpDestination = -1 * radians;
                        this.clockwise = false;
                    } else this.clockwise = true;
                    var maxRad = 360 * Math.PI / 180;
                    tmpDestination = tmpDestination - Math.floor(tmpDestination / maxRad) * maxRad;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source = cam.rotation;
                    //  Destination
                    this.destination = tmpDestination;
                    //  Using this ease
                    if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === 'function') this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    if (this.shortestPath) {
                        // The shortest path is true so calculate the quickest direction
                        var cwDist = 0;
                        var acwDist = 0;
                        if (this.destination > this.source) cwDist = Math.abs(this.destination - this.source);
                        else cwDist = Math.abs(this.destination + maxRad) - this.source;
                        if (this.source > this.destination) acwDist = Math.abs(this.source - this.destination);
                        else acwDist = Math.abs(this.source + maxRad) - this.destination;
                        if (cwDist < acwDist) this.clockwise = true;
                        else if (cwDist > acwDist) this.clockwise = false;
                    }
                    this.camera.emit(Events.ROTATE_START, this.camera, this, duration, tmpDestination);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#update
     * @since 3.23.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    var progress = Clamp(this._elapsed / this.duration, 0, 1);
                    this.progress = progress;
                    var cam = this.camera;
                    if (this._elapsed < this.duration) {
                        var v = this.ease(progress);
                        this.current = cam.rotation;
                        var distance = 0;
                        var maxRad = 360 * Math.PI / 180;
                        var target = this.destination;
                        var current = this.current;
                        if (this.clockwise === false) {
                            target = this.current;
                            current = this.destination;
                        }
                        if (target >= current) distance = Math.abs(target - current);
                        else distance = Math.abs(target + maxRad) - current;
                        var r = 0;
                        if (this.clockwise) r = cam.rotation + distance * v;
                        else r = cam.rotation - distance * v;
                        cam.rotation = r;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, r);
                    } else {
                        cam.rotation = this.destination;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, cam, progress, this.destination);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#effectComplete
     * @since 3.23.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.ROTATE_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#reset
     * @since 3.23.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.RotateTo#destroy
     * @since 3.23.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                    this.source = null;
                    this.destination = null;
                }
            });
            module1.exports = RotateTo;
        /***/ },
        /* 774 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var EaseMap = __webpack_require__(132);
            var Events = __webpack_require__(36);
            /**
 * @classdesc
 * A Camera Zoom effect.
 *
 * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
 *
 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
 * which is invoked each frame for the duration of the effect if required.
 *
 * @class Zoom
 * @memberof Phaser.Cameras.Scene2D.Effects
 * @constructor
 * @since 3.11.0
 *
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
 */ var Zoom = new Class({
                initialize: function Zoom(camera) {
                    /**
         * The Camera this effect belongs to.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @readonly
         * @since 3.11.0
         */ this.camera = camera;
                    /**
         * Is this effect actively running?
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#isRunning
         * @type {boolean}
         * @readonly
         * @default false
         * @since 3.11.0
         */ this.isRunning = false;
                    /**
         * The duration of the effect, in milliseconds.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#duration
         * @type {number}
         * @readonly
         * @default 0
         * @since 3.11.0
         */ this.duration = 0;
                    /**
         * The starting zoom value;
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#source
         * @type {number}
         * @since 3.11.0
         */ this.source = 1;
                    /**
         * The destination zoom value.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#destination
         * @type {number}
         * @since 3.11.0
         */ this.destination = 1;
                    /**
         * The ease function to use during the zoom.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#ease
         * @type {function}
         * @since 3.11.0
         */ this.ease;
                    /**
         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#progress
         * @type {number}
         * @since 3.11.0
         */ this.progress = 0;
                    /**
         * Effect elapsed timer.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_elapsed
         * @type {number}
         * @private
         * @since 3.11.0
         */ this._elapsed = 0;
                    /**
         * This callback is invoked every frame for the duration of the effect.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdate
         * @type {?Phaser.Types.Cameras.Scene2D.CameraZoomCallback}
         * @private
         * @default null
         * @since 3.11.0
         */ this._onUpdate;
                    /**
         * On Complete callback scope.
         *
         * @name Phaser.Cameras.Scene2D.Effects.Zoom#_onUpdateScope
         * @type {any}
         * @private
         * @since 3.11.0
         */ this._onUpdateScope;
                },
                /**
     * This effect will zoom the Camera to the given scale, over the duration and with the ease specified.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#start
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_START
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     *
     * @param {number} zoom - The target Camera zoom value.
     * @param {number} [duration=1000] - The duration of the effect in milliseconds.
     * @param {(string|function)} [ease='Linear'] - The ease to use for the Zoom. Can be any of the Phaser Easing constants or a custom function.
     * @param {boolean} [force=false] - Force the zoom effect to start immediately, even if already running.
     * @param {Phaser.Types.Cameras.Scene2D.CameraZoomCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
     * It is sent three arguments: A reference to the camera, a progress amount between 0 and 1 indicating how complete the effect is,
     * and the current camera zoom value.
     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
     */ start: function(zoom, duration, ease, force, callback, context) {
                    if (duration === undefined) duration = 1000;
                    if (ease === undefined) ease = EaseMap.Linear;
                    if (force === undefined) force = false;
                    if (callback === undefined) callback = null;
                    if (context === undefined) context = this.camera.scene;
                    var cam = this.camera;
                    if (!force && this.isRunning) return cam;
                    this.isRunning = true;
                    this.duration = duration;
                    this.progress = 0;
                    //  Starting from
                    this.source = cam.zoom;
                    //  Zooming to
                    this.destination = zoom;
                    //  Using this ease
                    if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease)) this.ease = EaseMap[ease];
                    else if (typeof ease === 'function') this.ease = ease;
                    this._elapsed = 0;
                    this._onUpdate = callback;
                    this._onUpdateScope = context;
                    this.camera.emit(Events.ZOOM_START, this.camera, this, duration, zoom);
                    return cam;
                },
                /**
     * The main update loop for this effect. Called automatically by the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#update
     * @since 3.11.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    if (!this.isRunning) return;
                    this._elapsed += delta;
                    this.progress = Clamp(this._elapsed / this.duration, 0, 1);
                    if (this._elapsed < this.duration) {
                        this.camera.zoom = this.source + (this.destination - this.source) * this.ease(this.progress);
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.camera.zoom);
                    } else {
                        this.camera.zoom = this.destination;
                        if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.camera, this.progress, this.destination);
                        this.effectComplete();
                    }
                },
                /**
     * Called internally when the effect completes.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#effectComplete
     * @fires Phaser.Cameras.Scene2D.Events#ZOOM_COMPLETE
     * @since 3.11.0
     */ effectComplete: function() {
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    this.isRunning = false;
                    this.camera.emit(Events.ZOOM_COMPLETE, this.camera, this);
                },
                /**
     * Resets this camera effect.
     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#reset
     * @since 3.11.0
     */ reset: function() {
                    this.isRunning = false;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                },
                /**
     * Destroys this effect, releasing it from the Camera.
     *
     * @method Phaser.Cameras.Scene2D.Effects.Zoom#destroy
     * @since 3.11.0
     */ destroy: function() {
                    this.reset();
                    this.camera = null;
                }
            });
            module1.exports = Zoom;
        /***/ },
        /* 775 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Camera = __webpack_require__(320);
            var Class = __webpack_require__(0);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var RectangleContains = __webpack_require__(56);
            var ScaleEvents = __webpack_require__(101);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * The Camera Manager is a plugin that belongs to a Scene and is responsible for managing all of the Scene Cameras.
 *
 * By default you can access the Camera Manager from within a Scene using `this.cameras`, although this can be changed
 * in your game config.
 *
 * Create new Cameras using the `add` method. Or extend the Camera class with your own addition code and then add
 * the new Camera in using the `addExisting` method.
 *
 * Cameras provide a view into your game world, and can be positioned, rotated, zoomed and scrolled accordingly.
 *
 * A Camera consists of two elements: The viewport and the scroll values.
 *
 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
 * created the same size as your game, but their position and size can be set to anything. This means if you
 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
 *
 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
 * viewport, and changing the viewport has no impact on the scrolling.
 *
 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
 * allowing you to filter Game Objects out on a per-Camera basis. The Camera Manager can manage up to 31 unique
 * 'Game Object ignore capable' Cameras. Any Cameras beyond 31 that you create will all be given a Camera ID of
 * zero, meaning that they cannot be used for Game Object exclusion. This means if you need your Camera to ignore
 * Game Objects, make sure it's one of the first 31 created.
 *
 * A Camera also has built-in special effects including Fade, Flash, Camera Shake, Pan and Zoom.
 *
 * @class CameraManager
 * @memberof Phaser.Cameras.Scene2D
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that owns the Camera Manager plugin.
 */ var CameraManager = new Class({
                initialize: function CameraManager(scene) {
                    /**
         * The Scene that owns the Camera Manager plugin.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene.Systems handler for the Scene that owns the Camera Manager.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * All Cameras created by, or added to, this Camera Manager, will have their `roundPixels`
         * property set to match this value. By default it is set to match the value set in the
         * game configuration, but can be changed at any point. Equally, individual cameras can
         * also be changed as needed.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#roundPixels
         * @type {boolean}
         * @since 3.11.0
         */ this.roundPixels = scene.sys.game.config.roundPixels;
                    /**
         * An Array of the Camera objects being managed by this Camera Manager.
         * The Cameras are updated and rendered in the same order in which they appear in this array.
         * Do not directly add or remove entries to this array. However, you can move the contents
         * around the array should you wish to adjust the display order.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#cameras
         * @type {Phaser.Cameras.Scene2D.Camera[]}
         * @since 3.0.0
         */ this.cameras = [];
                    /**
         * A handy reference to the 'main' camera. By default this is the first Camera the
         * Camera Manager creates. You can also set it directly, or use the `makeMain` argument
         * in the `add` and `addExisting` methods. It allows you to access it from your game:
         *
         * ```javascript
         * var cam = this.cameras.main;
         * ```
         *
         * Also see the properties `camera1`, `camera2` and so on.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#main
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.main;
                    /**
         * A default un-transformed Camera that doesn't exist on the camera list and doesn't
         * count towards the total number of cameras being managed. It exists for other
         * systems, as well as your own code, should they require a basic un-transformed
         * camera instance from which to calculate a view matrix.
         *
         * @name Phaser.Cameras.Scene2D.CameraManager#default
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.17.0
         */ this.default;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#boot
     * @private
     * @listens Phaser.Scenes.Events#DESTROY
     * @since 3.5.1
     */ boot: function() {
                    var sys = this.systems;
                    if (sys.settings.cameras) //  We have cameras to create
                    this.fromJSON(sys.settings.cameras);
                    else //  Make one
                    this.add();
                    this.main = this.cameras[0];
                    //  Create a default camera
                    this.default = new Camera(0, 0, sys.scale.width, sys.scale.height).setScene(this.scene);
                    sys.game.scale.on(ScaleEvents.RESIZE, this.onResize, this);
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#start
     * @private
     * @listens Phaser.Scenes.Events#UPDATE
     * @listens Phaser.Scenes.Events#SHUTDOWN
     * @since 3.5.0
     */ start: function() {
                    if (!this.main) {
                        var sys = this.systems;
                        if (sys.settings.cameras) //  We have cameras to create
                        this.fromJSON(sys.settings.cameras);
                        else //  Make one
                        this.add();
                        this.main = this.cameras[0];
                    }
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Adds a new Camera into the Camera Manager. The Camera Manager can support up to 31 different Cameras.
     *
     * Each Camera has its own viewport, which controls the size of the Camera and its position within the canvas.
     *
     * Use the `Camera.scrollX` and `Camera.scrollY` properties to change where the Camera is looking, or the
     * Camera methods such as `centerOn`. Cameras also have built in special effects, such as fade, flash, shake,
     * pan and zoom.
     *
     * By default Cameras are transparent and will render anything that they can see based on their `scrollX`
     * and `scrollY` values. Game Objects can be set to be ignored by a Camera by using the `Camera.ignore` method.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after creation if required.
     *
     * See the Camera class documentation for more details.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#add
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the Camera viewport.
     * @param {number} [y=0] - The vertical position of the Camera viewport.
     * @param {number} [width] - The width of the Camera viewport. If not given it'll be the game config size.
     * @param {number} [height] - The height of the Camera viewport. If not given it'll be the game config size.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     * @param {string} [name=''] - The name of the Camera.
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The newly created Camera.
     */ add: function(x, y, width, height, makeMain, name) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    if (makeMain === undefined) makeMain = false;
                    if (name === undefined) name = '';
                    var camera = new Camera(x, y, width, height);
                    camera.setName(name);
                    camera.setScene(this.scene);
                    camera.setRoundPixels(this.roundPixels);
                    camera.id = this.getNextID();
                    this.cameras.push(camera);
                    if (makeMain) this.main = camera;
                    return camera;
                },
                /**
     * Adds an existing Camera into the Camera Manager.
     *
     * The Camera should either be a `Phaser.Cameras.Scene2D.Camera` instance, or a class that extends from it.
     *
     * The Camera will have its `roundPixels` property set to whatever `CameraManager.roundPixels` is. You can change
     * it after addition if required.
     *
     * The Camera will be assigned an ID, which is used for Game Object exclusion and then added to the
     * manager. As long as it doesn't already exist in the manager it will be added then returned.
     *
     * If this method returns `null` then the Camera already exists in this Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#addExisting
     * @since 3.0.0
     *
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to be added to the Camera Manager.
     * @param {boolean} [makeMain=false] - Set this Camera as being the 'main' camera. This just makes the property `main` a reference to it.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The Camera that was added to the Camera Manager, or `null` if it couldn't be added.
     */ addExisting: function(camera, makeMain) {
                    if (makeMain === undefined) makeMain = false;
                    var index = this.cameras.indexOf(camera);
                    if (index === -1) {
                        camera.id = this.getNextID();
                        camera.setRoundPixels(this.roundPixels);
                        this.cameras.push(camera);
                        if (makeMain) this.main = camera;
                        return camera;
                    }
                    return null;
                },
                /**
     * Gets the next available Camera ID number.
     *
     * The Camera Manager supports up to 31 unique cameras, after which the ID returned will always be zero.
     * You can create additional cameras beyond 31, but they cannot be used for Game Object exclusion.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getNextID
     * @private
     * @since 3.11.0
     *
     * @return {number} The next available Camera ID, or 0 if they're all already in use.
     */ getNextID: function() {
                    var cameras = this.cameras;
                    var testID = 1;
                    //  Find the first free camera ID we can use
                    for(var t = 0; t < 32; t++){
                        var found = false;
                        for(var i = 0; i < cameras.length; i++){
                            var camera = cameras[i];
                            if (camera && camera.id === testID) {
                                found = true;
                                continue;
                            }
                        }
                        if (found) testID = testID << 1;
                        else return testID;
                    }
                    return 0;
                },
                /**
     * Gets the total number of Cameras in this Camera Manager.
     *
     * If the optional `isVisible` argument is set it will only count Cameras that are currently visible.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getTotal
     * @since 3.11.0
     *
     * @param {boolean} [isVisible=false] - Set the `true` to only include visible Cameras in the total.
     *
     * @return {number} The total number of Cameras in this Camera Manager.
     */ getTotal: function(isVisible) {
                    if (isVisible === undefined) isVisible = false;
                    var total = 0;
                    var cameras = this.cameras;
                    for(var i = 0; i < cameras.length; i++){
                        var camera = cameras[i];
                        if (!isVisible || isVisible && camera.visible) total++;
                    }
                    return total;
                },
                /**
     * Populates this Camera Manager based on the given configuration object, or an array of config objects.
     *
     * See the `Phaser.Types.Cameras.Scene2D.CameraConfig` documentation for details of the object structure.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#fromJSON
     * @since 3.0.0
     *
     * @param {(Phaser.Types.Cameras.Scene2D.CameraConfig|Phaser.Types.Cameras.Scene2D.CameraConfig[])} config - A Camera configuration object, or an array of them, to be added to this Camera Manager.
     *
     * @return {this} This Camera Manager instance.
     */ fromJSON: function(config) {
                    if (!Array.isArray(config)) config = [
                        config
                    ];
                    var gameWidth = this.scene.sys.scale.width;
                    var gameHeight = this.scene.sys.scale.height;
                    for(var i = 0; i < config.length; i++){
                        var cameraConfig = config[i];
                        var x = GetFastValue(cameraConfig, 'x', 0);
                        var y = GetFastValue(cameraConfig, 'y', 0);
                        var width = GetFastValue(cameraConfig, 'width', gameWidth);
                        var height = GetFastValue(cameraConfig, 'height', gameHeight);
                        var camera = this.add(x, y, width, height);
                        //  Direct properties
                        camera.name = GetFastValue(cameraConfig, 'name', '');
                        camera.zoom = GetFastValue(cameraConfig, 'zoom', 1);
                        camera.rotation = GetFastValue(cameraConfig, 'rotation', 0);
                        camera.scrollX = GetFastValue(cameraConfig, 'scrollX', 0);
                        camera.scrollY = GetFastValue(cameraConfig, 'scrollY', 0);
                        camera.roundPixels = GetFastValue(cameraConfig, 'roundPixels', false);
                        camera.visible = GetFastValue(cameraConfig, 'visible', true);
                        // Background Color
                        var backgroundColor = GetFastValue(cameraConfig, 'backgroundColor', false);
                        if (backgroundColor) camera.setBackgroundColor(backgroundColor);
                        //  Bounds
                        var boundsConfig = GetFastValue(cameraConfig, 'bounds', null);
                        if (boundsConfig) {
                            var bx = GetFastValue(boundsConfig, 'x', 0);
                            var by = GetFastValue(boundsConfig, 'y', 0);
                            var bwidth = GetFastValue(boundsConfig, 'width', gameWidth);
                            var bheight = GetFastValue(boundsConfig, 'height', gameHeight);
                            camera.setBounds(bx, by, bwidth, bheight);
                        }
                    }
                    return this;
                },
                /**
     * Gets a Camera based on its name.
     *
     * Camera names are optional and don't have to be set, so this method is only of any use if you
     * have given your Cameras unique names.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamera
     * @since 3.0.0
     *
     * @param {string} name - The name of the Camera.
     *
     * @return {?Phaser.Cameras.Scene2D.Camera} The first Camera with a name matching the given string, otherwise `null`.
     */ getCamera: function(name) {
                    var cameras = this.cameras;
                    for(var i = 0; i < cameras.length; i++){
                        if (cameras[i].name === name) return cameras[i];
                    }
                    return null;
                },
                /**
     * Returns an array of all cameras below the given Pointer.
     *
     * The first camera in the array is the top-most camera in the camera list.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getCamerasBelowPointer
     * @since 3.10.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against.
     *
     * @return {Phaser.Cameras.Scene2D.Camera[]} An array of cameras below the Pointer.
     */ getCamerasBelowPointer: function(pointer) {
                    var cameras = this.cameras;
                    var x = pointer.x;
                    var y = pointer.y;
                    var output = [];
                    for(var i = 0; i < cameras.length; i++){
                        var camera = cameras[i];
                        if (camera.visible && camera.inputEnabled && RectangleContains(camera, x, y)) //  So the top-most camera is at the top of the search array
                        output.unshift(camera);
                    }
                    return output;
                },
                /**
     * Removes the given Camera, or an array of Cameras, from this Camera Manager.
     *
     * If found in the Camera Manager it will be immediately removed from the local cameras array.
     * If also currently the 'main' camera, 'main' will be reset to be camera 0.
     *
     * The removed Cameras are automatically destroyed if the `runDestroy` argument is `true`, which is the default.
     * If you wish to re-use the cameras then set this to `false`, but know that they will retain their references
     * and internal data until destroyed or re-added to a Camera Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#remove
     * @since 3.0.0
     *
     * @param {(Phaser.Cameras.Scene2D.Camera|Phaser.Cameras.Scene2D.Camera[])} camera - The Camera, or an array of Cameras, to be removed from this Camera Manager.
     * @param {boolean} [runDestroy=true] - Automatically call `Camera.destroy` on each Camera removed from this Camera Manager.
     *
     * @return {number} The total number of Cameras removed.
     */ remove: function(camera, runDestroy) {
                    if (runDestroy === undefined) runDestroy = true;
                    if (!Array.isArray(camera)) camera = [
                        camera
                    ];
                    var total = 0;
                    var cameras = this.cameras;
                    for(var i = 0; i < camera.length; i++){
                        var index = cameras.indexOf(camera[i]);
                        if (index !== -1) {
                            if (runDestroy) cameras[index].destroy();
                            else cameras[index].renderList = [];
                            cameras.splice(index, 1);
                            total++;
                        }
                    }
                    if (!this.main && cameras[0]) this.main = cameras[0];
                    return total;
                },
                /**
     * The internal render method. This is called automatically by the Scene and should not be invoked directly.
     *
     * It will iterate through all local cameras and render them in turn, as long as they're visible and have
     * an alpha level > 0.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#render
     * @protected
     * @since 3.0.0
     *
     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Renderer that will render the children to this camera.
     * @param {Phaser.GameObjects.DisplayList} displayList - The Display List for the Scene.
     */ render: function(renderer, displayList) {
                    var scene = this.scene;
                    var cameras = this.cameras;
                    for(var i = 0; i < this.cameras.length; i++){
                        var camera = cameras[i];
                        if (camera.visible && camera.alpha > 0) {
                            camera.preRender();
                            var visibleChildren = this.getVisibleChildren(displayList.getChildren(), camera);
                            renderer.render(scene, visibleChildren, camera);
                        }
                    }
                },
                /**
     * Takes an array of Game Objects and a Camera and returns a new array
     * containing only those Game Objects that pass the `willRender` test
     * against the given Camera.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#getVisibleChildren
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject[]} children - An array of Game Objects to be checked against the camera.
     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to filte the Game Objects against.
     *
     * @return {Phaser.GameObjects.GameObject[]} A filtered list of only Game Objects within the Scene that will render against the given Camera.
     */ getVisibleChildren: function(children, camera) {
                    var visible = [];
                    for(var i = 0; i < children.length; i++){
                        var child = children[i];
                        if (child.willRender(camera)) visible.push(child);
                    }
                    return visible;
                },
                /**
     * Resets this Camera Manager.
     *
     * This will iterate through all current Cameras, destroying them all, then it will reset the
     * cameras array, reset the ID counter and create 1 new single camera using the default values.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resetAll
     * @since 3.0.0
     *
     * @return {Phaser.Cameras.Scene2D.Camera} The freshly created main Camera.
     */ resetAll: function() {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                    this.cameras = [];
                    this.main = this.add();
                    return this.main;
                },
                /**
     * The main update loop. Called automatically when the Scene steps.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#update
     * @protected
     * @since 3.0.0
     *
     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
     */ update: function(time, delta) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].update(time, delta);
                },
                /**
     * The event handler that manages the `resize` event dispatched by the Scale Manager.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#onResize
     * @since 3.18.0
     *
     * @param {Phaser.Structs.Size} gameSize - The default Game Size object. This is the un-modified game dimensions.
     * @param {Phaser.Structs.Size} baseSize - The base Size object. The game dimensions. The canvas width / height values match this.
     */ onResize: function(gameSize, baseSize, displaySize, previousWidth, previousHeight) {
                    for(var i = 0; i < this.cameras.length; i++){
                        var cam = this.cameras[i];
                        //  if camera is at 0x0 and was the size of the previous game size, then we can safely assume it
                        //  should be updated to match the new game size too
                        if (cam._x === 0 && cam._y === 0 && cam._width === previousWidth && cam._height === previousHeight) cam.setSize(baseSize.width, baseSize.height);
                    }
                },
                /**
     * Resizes all cameras to the given dimensions.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#resize
     * @since 3.2.0
     *
     * @param {number} width - The new width of the camera.
     * @param {number} height - The new height of the camera.
     */ resize: function(width, height) {
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].setSize(width, height);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.main = undefined;
                    for(var i = 0; i < this.cameras.length; i++)this.cameras[i].destroy();
                    this.cameras = [];
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Cameras.Scene2D.CameraManager#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.default.destroy();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('CameraManager', CameraManager, 'cameras');
            module1.exports = CameraManager;
        /***/ },
        /* 776 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager has successfully entered fullscreen mode.
 *
 * @event Phaser.Scale.Events#ENTER_FULLSCREEN
 * @since 3.16.1
 */ module1.exports = 'enterfullscreen';
        /***/ },
        /* 777 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode but failed.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_FAILED
 * @since 3.17.0
 */ module1.exports = 'fullscreenfailed';
        /***/ },
        /* 778 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager tried to enter fullscreen mode, but it is unsupported by the browser.
 *
 * @event Phaser.Scale.Events#FULLSCREEN_UNSUPPORTED
 * @since 3.16.1
 */ module1.exports = 'fullscreenunsupported';
        /***/ },
        /* 779 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager was in fullscreen mode, but has since left, either directly via game code,
 * or via a user gestured, such as pressing the ESC key.
 *
 * @event Phaser.Scale.Events#LEAVE_FULLSCREEN
 * @since 3.16.1
 */ module1.exports = 'leavefullscreen';
        /***/ },
        /* 780 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Orientation Change Event.
 *
 * This event is dispatched whenever the Scale Manager detects an orientation change event from the browser.
 *
 * @event Phaser.Scale.Events#ORIENTATION_CHANGE
 * @since 3.16.1
 *
 * @param {string} orientation - The new orientation value. Either `Phaser.Scale.Orientation.LANDSCAPE` or `Phaser.Scale.Orientation.PORTRAIT`.
 */ module1.exports = 'orientationchange';
        /***/ },
        /* 781 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scale Manager Resize Event.
 *
 * This event is dispatched whenever the Scale Manager detects a resize event from the browser.
 * It sends three parameters to the callback, each of them being Size components. You can read
 * the `width`, `height`, `aspectRatio` and other properties of these components to help with
 * scaling your own game content.
 *
 * @event Phaser.Scale.Events#RESIZE
 * @since 3.16.1
 *
 * @param {Phaser.Structs.Size} gameSize - A reference to the Game Size component. This is the un-scaled size of your game canvas.
 * @param {Phaser.Structs.Size} baseSize - A reference to the Base Size component. This is the game size.
 * @param {Phaser.Structs.Size} displaySize - A reference to the Display Size component. This is the scaled canvas size, after applying zoom and scale mode.
 * @param {number} previousWidth - If the `gameSize` has changed, this value contains its previous width, otherwise it contains the current width.
 * @param {number} previousHeight - If the `gameSize` has changed, this value contains its previous height, otherwise it contains the current height.
 */ module1.exports = 'resize';
        /***/ },
        /* 782 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Added to Scene Event.
 *
 * This event is dispatched when a Game Object is added to a Scene.
 *
 * Listen for it from a Scene using `this.scene.events.on('addedtoscene', listener)`.
 *
 * @event Phaser.Scenes.Events#ADDED_TO_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the Scene.
 * @param {Phaser.Scene} scene - The Scene to which the Game Object was added.
 */ module1.exports = 'addedtoscene';
        /***/ },
        /* 783 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Boot Event.
 * 
 * This event is dispatched by a Scene during the Scene Systems boot process. Primarily used by Scene Plugins.
 * 
 * Listen to it from a Scene using `this.scene.events.on('boot', listener)`.
 * 
 * @event Phaser.Scenes.Events#BOOT
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'boot';
        /***/ },
        /* 784 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Create Event.
 * 
 * This event is dispatched by a Scene after it has been created by the Scene Manager.
 * 
 * If a Scene has a `create` method then this event is emitted _after_ that has run.
 * 
 * If there is a transition, this event will be fired after the `TRANSITION_START` event.
 * 
 * Listen to it from a Scene using `this.scene.events.on('create', listener)`.
 * 
 * @event Phaser.Scenes.Events#CREATE
 * @since 3.17.0
 * 
 * @param {Phaser.Scene} scene - A reference to the Scene that emitted this event.
 */ module1.exports = 'create';
        /***/ },
        /* 785 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Destroy Event.
 * 
 * This event is dispatched by a Scene during the Scene Systems destroy process.
 * 
 * Listen to it from a Scene using `this.scene.events.on('destroy', listener)`.
 * 
 * You should destroy any resources that may be in use by your Scene in this event handler.
 * 
 * @event Phaser.Scenes.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'destroy';
        /***/ },
        /* 786 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pause Event.
 * 
 * This event is dispatched by a Scene when it is paused, either directly via the `pause` method, or as an
 * action from another Scene.
 * 
 * Listen to it from a Scene using `this.scene.events.on('pause', listener)`.
 * 
 * @event Phaser.Scenes.Events#PAUSE
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was paused.
 */ module1.exports = 'pause';
        /***/ },
        /* 787 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Post Update Event.
 * 
 * This event is dispatched by a Scene during the main game loop step.
 * 
 * The event flow for a single step of a Scene is as follows:
 * 
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 * 
 * Listen to it from a Scene using `this.scene.events.on('postupdate', listener)`.
 * 
 * A Scene will only run its step if it is active.
 * 
 * @event Phaser.Scenes.Events#POST_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'postupdate';
        /***/ },
        /* 788 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Pre Update Event.
 * 
 * This event is dispatched by a Scene during the main game loop step.
 * 
 * The event flow for a single step of a Scene is as follows:
 * 
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 * 
 * Listen to it from a Scene using `this.scene.events.on('preupdate', listener)`.
 * 
 * A Scene will only run its step if it is active.
 * 
 * @event Phaser.Scenes.Events#PRE_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'preupdate';
        /***/ },
        /* 789 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Ready Event.
 * 
 * This event is dispatched by a Scene during the Scene Systems start process.
 * By this point in the process the Scene is now fully active and rendering.
 * This event is meant for your game code to use, as all plugins have responded to the earlier 'start' event.
 * 
 * Listen to it from a Scene using `this.scene.events.on('ready', listener)`.
 * 
 * @event Phaser.Scenes.Events#READY
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was started.
 */ module1.exports = 'ready';
        /***/ },
        /* 790 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Removed from Scene Event.
 *
 * This event is dispatched when a Game Object is removed from a Scene.
 *
 * Listen for it from a Scene using `this.scene.events.on('removedfromscene', listener)`.
 *
 * @event Phaser.Scenes.Events#REMOVED_FROM_SCENE
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the Scene.
 * @param {Phaser.Scene} scene - The Scene from which the Game Object was removed.
 */ module1.exports = 'removedfromscene';
        /***/ },
        /* 791 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Render Event.
 * 
 * This event is dispatched by a Scene during the main game loop step.
 * 
 * The event flow for a single step of a Scene is as follows:
 * 
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 * 
 * Listen to it from a Scene using `this.scene.events.on('render', listener)`.
 * 
 * A Scene will only render if it is visible and active.
 * By the time this event is dispatched, the Scene will have already been rendered.
 * 
 * @event Phaser.Scenes.Events#RENDER
 * @since 3.0.0
 * 
 * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer that rendered the Scene.
 */ module1.exports = 'render';
        /***/ },
        /* 792 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Resume Event.
 * 
 * This event is dispatched by a Scene when it is resumed from a paused state, either directly via the `resume` method,
 * or as an action from another Scene.
 * 
 * Listen to it from a Scene using `this.scene.events.on('resume', listener)`.
 * 
 * @event Phaser.Scenes.Events#RESUME
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was resumed.
 */ module1.exports = 'resume';
        /***/ },
        /* 793 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Shutdown Event.
 * 
 * This event is dispatched by a Scene during the Scene Systems shutdown process.
 * 
 * Listen to it from a Scene using `this.scene.events.on('shutdown', listener)`.
 * 
 * You should free-up any resources that may be in use by your Scene in this event handler, on the understanding
 * that the Scene may, at any time, become active again. A shutdown Scene is not 'destroyed', it's simply not
 * currently active. Use the [DESTROY]{@linkcode Phaser.Scenes.Events#event:DESTROY} event to completely clear resources.
 * 
 * @event Phaser.Scenes.Events#SHUTDOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was shutdown.
 */ module1.exports = 'shutdown';
        /***/ },
        /* 794 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Sleep Event.
 * 
 * This event is dispatched by a Scene when it is sent to sleep, either directly via the `sleep` method,
 * or as an action from another Scene.
 * 
 * Listen to it from a Scene using `this.scene.events.on('sleep', listener)`.
 * 
 * @event Phaser.Scenes.Events#SLEEP
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was sent to sleep.
 */ module1.exports = 'sleep';
        /***/ },
        /* 795 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Start Event.
 * 
 * This event is dispatched by a Scene during the Scene Systems start process. Primarily used by Scene Plugins.
 * 
 * Listen to it from a Scene using `this.scene.events.on('start', listener)`.
 * 
 * @event Phaser.Scenes.Events#START
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 */ module1.exports = 'start';
        /***/ },
        /* 796 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Complete Event.
 * 
 * This event is dispatched by the Target Scene of a transition.
 * 
 * It happens when the transition process has completed. This occurs when the duration timer equals or exceeds the duration
 * of the transition.
 * 
 * Listen to it from a Scene using `this.scene.events.on('transitioncomplete', listener)`.
 * 
 * The Scene Transition event flow is as follows:
 * 
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 * 
 * @event Phaser.Scenes.Events#TRANSITION_COMPLETE
 * @since 3.5.0
 * 
 * @param {Phaser.Scene} scene -The Scene on which the transitioned completed.
 */ module1.exports = 'transitioncomplete';
        /***/ },
        /* 797 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Init Event.
 * 
 * This event is dispatched by the Target Scene of a transition.
 * 
 * It happens immediately after the `Scene.init` method is called. If the Scene does not have an `init` method,
 * this event is not dispatched.
 * 
 * Listen to it from a Scene using `this.scene.events.on('transitioninit', listener)`.
 * 
 * The Scene Transition event flow is as follows:
 * 
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 * 
 * @event Phaser.Scenes.Events#TRANSITION_INIT
 * @since 3.5.0
 * 
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitioninit';
        /***/ },
        /* 798 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Out Event.
 * 
 * This event is dispatched by a Scene when it initiates a transition to another Scene.
 * 
 * Listen to it from a Scene using `this.scene.events.on('transitionout', listener)`.
 * 
 * The Scene Transition event flow is as follows:
 * 
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 * 
 * @event Phaser.Scenes.Events#TRANSITION_OUT
 * @since 3.5.0
 * 
 * @param {Phaser.Scene} target - A reference to the Scene that is being transitioned to.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionout';
        /***/ },
        /* 799 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Start Event.
 * 
 * This event is dispatched by the Target Scene of a transition, only if that Scene was not asleep.
 * 
 * It happens immediately after the `Scene.create` method is called. If the Scene does not have a `create` method,
 * this event is dispatched anyway.
 * 
 * If the Target Scene was sleeping then the [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} event is
 * dispatched instead of this event.
 * 
 * Listen to it from a Scene using `this.scene.events.on('transitionstart', listener)`.
 * 
 * The Scene Transition event flow is as follows:
 * 
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 * 
 * @event Phaser.Scenes.Events#TRANSITION_START
 * @since 3.5.0
 * 
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionstart';
        /***/ },
        /* 800 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Transition Wake Event.
 * 
 * This event is dispatched by the Target Scene of a transition, only if that Scene was asleep before
 * the transition began. If the Scene was not asleep the [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} event is dispatched instead.
 * 
 * Listen to it from a Scene using `this.scene.events.on('transitionwake', listener)`.
 * 
 * The Scene Transition event flow is as follows:
 * 
 * 1. [TRANSITION_OUT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_OUT} - the Scene that started the transition will emit this event.
 * 2. [TRANSITION_INIT]{@linkcode Phaser.Scenes.Events#event:TRANSITION_INIT} - the Target Scene will emit this event if it has an `init` method.
 * 3. [TRANSITION_START]{@linkcode Phaser.Scenes.Events#event:TRANSITION_START} - the Target Scene will emit this event after its `create` method is called, OR ...
 * 4. [TRANSITION_WAKE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_WAKE} - the Target Scene will emit this event if it was asleep and has been woken-up to be transitioned to.
 * 5. [TRANSITION_COMPLETE]{@linkcode Phaser.Scenes.Events#event:TRANSITION_COMPLETE} - the Target Scene will emit this event when the transition finishes.
 * 
 * @event Phaser.Scenes.Events#TRANSITION_WAKE
 * @since 3.5.0
 * 
 * @param {Phaser.Scene} from - A reference to the Scene that is being transitioned from.
 * @param {number} duration - The duration of the transition in ms.
 */ module1.exports = 'transitionwake';
        /***/ },
        /* 801 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Update Event.
 * 
 * This event is dispatched by a Scene during the main game loop step.
 * 
 * The event flow for a single step of a Scene is as follows:
 * 
 * 1. [PRE_UPDATE]{@linkcode Phaser.Scenes.Events#event:PRE_UPDATE}
 * 2. [UPDATE]{@linkcode Phaser.Scenes.Events#event:UPDATE}
 * 3. The `Scene.update` method is called, if it exists
 * 4. [POST_UPDATE]{@linkcode Phaser.Scenes.Events#event:POST_UPDATE}
 * 5. [RENDER]{@linkcode Phaser.Scenes.Events#event:RENDER}
 * 
 * Listen to it from a Scene using `this.scene.events.on('update', listener)`.
 * 
 * A Scene will only run its step if it is active.
 * 
 * @event Phaser.Scenes.Events#UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'update';
        /***/ },
        /* 802 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Scene Systems Wake Event.
 * 
 * This event is dispatched by a Scene when it is woken from sleep, either directly via the `wake` method,
 * or as an action from another Scene.
 * 
 * Listen to it from a Scene using `this.scene.events.on('wake', listener)`.
 * 
 * @event Phaser.Scenes.Events#WAKE
 * @since 3.0.0
 * 
 * @param {Phaser.Scenes.Systems} sys - A reference to the Scene Systems class of the Scene that emitted this event.
 * @param {any} [data] - An optional data object that was passed to this Scene when it was woken up.
 */ module1.exports = 'wake';
        /***/ },
        /* 803 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Core
 */ module1.exports = {
                Config: __webpack_require__(340),
                CreateRenderer: __webpack_require__(360),
                DebugHeader: __webpack_require__(378),
                Events: __webpack_require__(22),
                TimeStep: __webpack_require__(379),
                VisibilityHandler: __webpack_require__(381)
            };
        /***/ },
        /* 804 */ /***/ function(module1, exports) {
            // shim for using process in browser
            var process = module1.exports = {};
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
            var cachedSetTimeout;
            var cachedClearTimeout;
            function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
            }
            function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
            }
            (function() {
                try {
                    if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                    else cachedSetTimeout = defaultSetTimout;
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                    else cachedClearTimeout = defaultClearTimeout;
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            })();
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                return setTimeout(fun, 0);
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }
            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                return clearTimeout(marker);
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
            function cleanUpNextTick() {
                if (!draining || !currentQueue) return;
                draining = false;
                if (currentQueue.length) queue = currentQueue.concat(queue);
                else queueIndex = -1;
                if (queue.length) drainQueue();
            }
            function drainQueue() {
                if (draining) return;
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;
                var len = queue.length;
                while(len){
                    currentQueue = queue;
                    queue = [];
                    while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }
            process.nextTick = function(fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) runTimeout(drainQueue);
            };
            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function() {
                this.fun.apply(null, this.array);
            };
            process.title = 'browser';
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ''; // empty string to avoid regexp issues
            process.versions = {};
            function noop() {}
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
            process.listeners = function(name) {
                return [];
            };
            process.binding = function(name) {
                throw new Error('process.binding is not supported');
            };
            process.cwd = function() {
                return '/';
            };
            process.chdir = function(dir) {
                throw new Error('process.chdir is not supported');
            };
            process.umask = function() {
                return 0;
            };
        /***/ },
        /* 805 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(134);
            /**
 * Determines the input support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.input` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.Input
 * @since 3.0.0
 * 
 * @property {?string} wheelType - The newest type of Wheel/Scroll event supported: 'wheel', 'mousewheel', 'DOMMouseScroll'
 * @property {boolean} gamepads - Is navigator.getGamepads available?
 * @property {boolean} mspointer - Is mspointer available?
 * @property {boolean} touch - Is touch available?
 */ var Input = {
                gamepads: false,
                mspointer: false,
                touch: false,
                wheelEvent: null
            };
            function init() {
                if ('ontouchstart' in document.documentElement || navigator.maxTouchPoints && navigator.maxTouchPoints >= 1) Input.touch = true;
                if (navigator.msPointerEnabled || navigator.pointerEnabled) Input.mspointer = true;
                if (navigator.getGamepads) Input.gamepads = true;
                // See https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                if ('onwheel' in window || Browser.ie && 'WheelEvent' in window) // DOM3 Wheel Event: FF 17+, IE 9+, Chrome 31+, Safari 7+
                Input.wheelEvent = 'wheel';
                else if ('onmousewheel' in window) // Non-FF legacy: IE 6-9, Chrome 1-31, Safari 5-7.
                Input.wheelEvent = 'mousewheel';
                else if (Browser.firefox && 'MouseScrollEvent' in window) // FF prior to 17. This should probably be scrubbed.
                Input.wheelEvent = 'DOMMouseScroll';
                return Input;
            }
            module1.exports = init();
        /***/ },
        /* 806 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Browser = __webpack_require__(134);
            /**
 * Determines the audio playback capabilities of the device running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.audio` from within any Scene.
 *
 * @typedef {object} Phaser.Device.Audio
 * @since 3.0.0
 *
 * @property {boolean} audioData - Can this device play HTML Audio tags?
 * @property {boolean} dolby - Can this device play EC-3 Dolby Digital Plus files?
 * @property {boolean} m4a - Can this device can play m4a files.
 * @property {boolean} mp3 - Can this device play mp3 files?
 * @property {boolean} ogg - Can this device play ogg files?
 * @property {boolean} opus - Can this device play opus files?
 * @property {boolean} wav - Can this device play wav files?
 * @property {boolean} webAudio - Does this device have the Web Audio API?
 * @property {boolean} webm - Can this device play webm files?
 */ var Audio1 = {
                audioData: false,
                dolby: false,
                m4a: false,
                mp3: false,
                ogg: false,
                opus: false,
                wav: false,
                webAudio: false,
                webm: false
            };
            function init() {
                Audio1.audioData = !!window['Audio'];
                Audio1.webAudio = !!(window['AudioContext'] || window['webkitAudioContext']);
                var audioElement = document.createElement('audio');
                var result = !!audioElement.canPlayType;
                try {
                    if (result) {
                        if (audioElement.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, '')) Audio1.ogg = true;
                        if (audioElement.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, '') || audioElement.canPlayType('audio/opus;').replace(/^no$/, '')) Audio1.opus = true;
                        if (audioElement.canPlayType('audio/mpeg;').replace(/^no$/, '')) Audio1.mp3 = true;
                        //  Mimetypes accepted:
                        //  developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                        if (audioElement.canPlayType('audio/wav').replace(/^no$/, '')) Audio1.wav = true;
                        if (audioElement.canPlayType('audio/x-m4a;') || audioElement.canPlayType('audio/aac;').replace(/^no$/, '')) Audio1.m4a = true;
                        if (audioElement.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')) Audio1.webm = true;
                        if (audioElement.canPlayType('audio/mp4;codecs="ec-3"') !== '') {
                            if (Browser.edge) Audio1.dolby = true;
                            else if (Browser.safari && Browser.safariVersion >= 9) {
                                if (/Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)) {
                                    var major = parseInt(RegExp.$1, 10);
                                    var minor = parseInt(RegExp.$2, 10);
                                    if (major === 10 && minor >= 11 || major > 10) Audio1.dolby = true;
                                }
                            }
                        }
                    }
                } catch (e) {
                //  Nothing to do here
                }
                return Audio1;
            }
            module1.exports = init();
        /***/ },
        /* 807 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the video support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.video` from within any Scene.
 * 
 * In Phaser 3.20 the properties were renamed to drop the 'Video' suffix.
 * 
 * @typedef {object} Phaser.Device.Video
 * @since 3.0.0
 * 
 * @property {boolean} h264 - Can this device play h264 mp4 video files?
 * @property {boolean} hls - Can this device play hls video files?
 * @property {boolean} mp4 - Can this device play h264 mp4 video files?
 * @property {boolean} ogg - Can this device play ogg video files?
 * @property {boolean} vp9 - Can this device play vp9 video files?
 * @property {boolean} webm - Can this device play webm video files?
 */ var Video = {
                h264: false,
                hls: false,
                mp4: false,
                ogg: false,
                vp9: false,
                webm: false
            };
            function init() {
                var videoElement = document.createElement('video');
                var result = !!videoElement.canPlayType;
                try {
                    if (result) {
                        if (videoElement.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, '')) Video.ogg = true;
                        if (videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '')) {
                            // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
                            Video.h264 = true;
                            Video.mp4 = true;
                        }
                        if (videoElement.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, '')) Video.webm = true;
                        if (videoElement.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, '')) Video.vp9 = true;
                        if (videoElement.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '')) Video.hls = true;
                    }
                } catch (e) {
                //  Nothing to do
                }
                return Video;
            }
            module1.exports = init();
        /***/ },
        /* 808 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines the full screen support of the browser running this Phaser Game instance.
 * These values are read-only and populated during the boot sequence of the game.
 * They are then referenced by internal game systems and are available for you to access
 * via `this.sys.game.device.fullscreen` from within any Scene.
 * 
 * @typedef {object} Phaser.Device.Fullscreen
 * @since 3.0.0
 * 
 * @property {boolean} available - Does the browser support the Full Screen API?
 * @property {boolean} keyboard - Does the browser support access to the Keyboard during Full Screen mode?
 * @property {string} cancel - If the browser supports the Full Screen API this holds the call you need to use to cancel it.
 * @property {string} request - If the browser supports the Full Screen API this holds the call you need to use to activate it.
 */ var Fullscreen = {
                available: false,
                cancel: '',
                keyboard: false,
                request: ''
            };
            /**
* Checks for support of the Full Screen API.
* 
* @ignore
*/ function init() {
                var i;
                var suffix1 = 'Fullscreen';
                var suffix2 = 'FullScreen';
                var fs = [
                    'request' + suffix1,
                    'request' + suffix2,
                    'webkitRequest' + suffix1,
                    'webkitRequest' + suffix2,
                    'msRequest' + suffix1,
                    'msRequest' + suffix2,
                    'mozRequest' + suffix2,
                    'mozRequest' + suffix1
                ];
                for(i = 0; i < fs.length; i++)if (document.documentElement[fs[i]]) {
                    Fullscreen.available = true;
                    Fullscreen.request = fs[i];
                    break;
                }
                var cfs = [
                    'cancel' + suffix2,
                    'exit' + suffix1,
                    'webkitCancel' + suffix2,
                    'webkitExit' + suffix1,
                    'msCancel' + suffix2,
                    'msExit' + suffix1,
                    'mozCancel' + suffix2,
                    'mozExit' + suffix1
                ];
                if (Fullscreen.available) {
                    for(i = 0; i < cfs.length; i++)if (document[cfs[i]]) {
                        Fullscreen.cancel = cfs[i];
                        break;
                    }
                }
                //  Keyboard Input?
                //  Safari 5.1 says it supports fullscreen keyboard, but is lying.
                if (window['Element'] && Element['ALLOW_KEYBOARD_INPUT'] && !/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) Fullscreen.keyboard = true;
                Object.defineProperty(Fullscreen, 'active', {
                    get: function() {
                        return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
                    }
                });
                return Fullscreen;
            }
            module1.exports = init();
        /***/ },
        /* 809 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Angle
 */ module1.exports = {
                Between: __webpack_require__(343),
                BetweenPoints: __webpack_require__(344),
                BetweenPointsY: __webpack_require__(810),
                BetweenY: __webpack_require__(811),
                CounterClockwise: __webpack_require__(812),
                Normalize: __webpack_require__(345),
                Random: __webpack_require__(813),
                RandomDegrees: __webpack_require__(814),
                Reverse: __webpack_require__(815),
                RotateTo: __webpack_require__(816),
                ShortestBetween: __webpack_require__(817),
                Wrap: __webpack_require__(265),
                WrapDegrees: __webpack_require__(266)
            };
        /***/ },
        /* 810 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
 *
 * The difference between this method and {@link Phaser.Math.Angle.BetweenPoints} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenPointsY
 * @since 3.0.0
 *
 * @param {Phaser.Types.Math.Vector2Like} point1 - The first point.
 * @param {Phaser.Types.Math.Vector2Like} point2 - The second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenPointsY = function(point1, point2) {
                return Math.atan2(point2.x - point1.x, point2.y - point1.y);
            };
            module1.exports = BetweenPointsY;
        /***/ },
        /* 811 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Find the angle of a segment from (x1, y1) -> (x2, y2).
 *
 * The difference between this method and {@link Phaser.Math.Angle.Between} is that this assumes the y coordinate
 * travels down the screen.
 *
 * @function Phaser.Math.Angle.BetweenY
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The angle in radians.
 */ var BetweenY = function(x1, y1, x2, y2) {
                return Math.atan2(x2 - x1, y2 - y1);
            };
            module1.exports = BetweenY;
        /***/ },
        /* 812 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(14);
            /**
 * Takes an angle in Phasers default clockwise format and converts it so that
 * 0 is North, 90 is West, 180 is South and 270 is East,
 * therefore running counter-clockwise instead of clockwise.
 * 
 * You can pass in the angle from a Game Object using:
 * 
 * ```javascript
 * var converted = CounterClockwise(gameobject.rotation);
 * ```
 * 
 * All values for this function are in radians.
 *
 * @function Phaser.Math.Angle.CounterClockwise
 * @since 3.16.0
 *
 * @param {number} angle - The angle to convert, in radians.
 *
 * @return {number} The converted angle, in radians.
 */ var CounterClockwise = function(angle) {
                if (angle > Math.PI) angle -= CONST.PI2;
                return Math.abs(((angle + CONST.TAU) % CONST.PI2 - CONST.PI2) % CONST.PI2);
            };
            module1.exports = CounterClockwise;
        /***/ },
        /* 813 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       @samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(135);
            /**
 * Returns a random angle in the range [-pi, pi].
 *
 * @function Phaser.Math.Angle.Random
 * @since 3.23.0
 *
 * @return {number} The angle, in radians.
 */ var Random = function() {
                return FloatBetween(-Math.PI, Math.PI);
            };
            module1.exports = Random;
        /***/ },
        /* 814 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       @samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FloatBetween = __webpack_require__(135);
            /**
 * Returns a random angle in the range [-180, 180].
 *
 * @function Phaser.Math.Angle.RandomDegrees
 * @since 3.23.0
 *
 * @return {number} The angle, in degrees.
 */ var RandomDegrees = function() {
                return FloatBetween(-180, 180);
            };
            module1.exports = RandomDegrees;
        /***/ },
        /* 815 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Normalize = __webpack_require__(345);
            /**
 * Reverse the given angle.
 *
 * @function Phaser.Math.Angle.Reverse
 * @since 3.0.0
 *
 * @param {number} angle - The angle to reverse, in radians.
 *
 * @return {number} The reversed angle, in radians.
 */ var Reverse = function(angle) {
                return Normalize(angle + Math.PI);
            };
            module1.exports = Reverse;
        /***/ },
        /* 816 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            /**
 * Rotates `currentAngle` towards `targetAngle`, taking the shortest rotation distance. The `lerp` argument is the amount to rotate by in this call.
 *
 * @function Phaser.Math.Angle.RotateTo
 * @since 3.0.0
 *
 * @param {number} currentAngle - The current angle, in radians.
 * @param {number} targetAngle - The target angle to rotate to, in radians.
 * @param {number} [lerp=0.05] - The lerp value to add to the current angle.
 *
 * @return {number} The adjusted angle.
 */ var RotateTo = function(currentAngle, targetAngle, lerp) {
                if (lerp === undefined) lerp = 0.05;
                if (currentAngle === targetAngle) return currentAngle;
                if (Math.abs(targetAngle - currentAngle) <= lerp || Math.abs(targetAngle - currentAngle) >= MATH_CONST.PI2 - lerp) currentAngle = targetAngle;
                else {
                    if (Math.abs(targetAngle - currentAngle) > Math.PI) {
                        if (targetAngle < currentAngle) targetAngle += MATH_CONST.PI2;
                        else targetAngle -= MATH_CONST.PI2;
                    }
                    if (targetAngle > currentAngle) currentAngle += lerp;
                    else if (targetAngle < currentAngle) currentAngle -= lerp;
                }
                return currentAngle;
            };
            module1.exports = RotateTo;
        /***/ },
        /* 817 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Gets the shortest angle between `angle1` and `angle2`.
 *
 * Both angles must be in the range -180 to 180, which is the same clamped
 * range that `sprite.angle` uses, so you can pass in two sprite angles to
 * this method and get the shortest angle back between the two of them.
 *
 * The angle returned will be in the same range. If the returned angle is
 * greater than 0 then it's a counter-clockwise rotation, if < 0 then it's
 * a clockwise rotation.
 *
 * @function Phaser.Math.Angle.ShortestBetween
 * @since 3.0.0
 *
 * @param {number} angle1 - The first angle in the range -180 to 180.
 * @param {number} angle2 - The second angle in the range -180 to 180.
 *
 * @return {number} The shortest angle, in degrees. If greater than zero it's a counter-clockwise rotation.
 */ var ShortestBetween = function(angle1, angle2) {
                var difference = angle2 - angle1;
                if (difference === 0) return 0;
                var times = Math.floor((difference - -180) / 360);
                return difference - times * 360;
            };
            module1.exports = ShortestBetween;
        /***/ },
        /* 818 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Distance
 */ module1.exports = {
                Between: __webpack_require__(48),
                BetweenPoints: __webpack_require__(346),
                BetweenPointsSquared: __webpack_require__(819),
                Chebyshev: __webpack_require__(820),
                Power: __webpack_require__(821),
                Snake: __webpack_require__(822),
                Squared: __webpack_require__(347)
            };
        /***/ },
        /* 819 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the squared distance between two points.
 *
 * @function Phaser.Math.Distance.BetweenPointsSquared
 * @since 3.22.0
 *
 * @param {Phaser.Types.Math.Vector2Like} a - The first point.
 * @param {Phaser.Types.Math.Vector2Like} b - The second point.
 *
 * @return {number} The squared distance between the points.
 */ var DistanceBetweenPointsSquared = function(a, b) {
                var dx = a.x - b.x;
                var dy = a.y - b.y;
                return dx * dx + dy * dy;
            };
            module1.exports = DistanceBetweenPointsSquared;
        /***/ },
        /* 820 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the Chebyshev distance between two sets of coordinates (points).
 *
 * Chebyshev distance (or chessboard distance) is the maximum of the horizontal and vertical distances.
 * It's the effective distance when movement can be horizontal, vertical, or diagonal.
 *
 * @function Phaser.Math.Distance.Chebyshev
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var ChebyshevDistance = function(x1, y1, x2, y2) {
                return Math.max(Math.abs(x1 - x2), Math.abs(y1 - y2));
            };
            module1.exports = ChebyshevDistance;
        /***/ },
        /* 821 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the distance between two sets of coordinates (points) to the power of `pow`.
 *
 * @function Phaser.Math.Distance.Power
 * @since 3.0.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 * @param {number} pow - The exponent.
 *
 * @return {number} The distance between each point.
 */ var DistancePower = function(x1, y1, x2, y2, pow) {
                if (pow === undefined) pow = 2;
                return Math.sqrt(Math.pow(x2 - x1, pow) + Math.pow(y2 - y1, pow));
            };
            module1.exports = DistancePower;
        /***/ },
        /* 822 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the snake distance between two sets of coordinates (points).
 *
 * Snake distance (rectilinear distance, Manhattan distance) is the sum of the horizontal and vertical distances.
 * It's the effective distance when movement is allowed only horizontally or vertically (but not both).
 *
 * @function Phaser.Math.Distance.Snake
 * @since 3.22.0
 *
 * @param {number} x1 - The x coordinate of the first point.
 * @param {number} y1 - The y coordinate of the first point.
 * @param {number} x2 - The x coordinate of the second point.
 * @param {number} y2 - The y coordinate of the second point.
 *
 * @return {number} The distance between each point.
 */ var SnakeDistance = function(x1, y1, x2, y2) {
                return Math.abs(x1 - x2) + Math.abs(y1 - y2);
            };
            module1.exports = SnakeDistance;
        /***/ },
        /* 823 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Easing
 */ module1.exports = {
                Back: __webpack_require__(328),
                Bounce: __webpack_require__(329),
                Circular: __webpack_require__(330),
                Cubic: __webpack_require__(331),
                Elastic: __webpack_require__(332),
                Expo: __webpack_require__(333),
                Linear: __webpack_require__(334),
                Quadratic: __webpack_require__(335),
                Quartic: __webpack_require__(336),
                Quintic: __webpack_require__(337),
                Sine: __webpack_require__(338),
                Stepped: __webpack_require__(339)
            };
        /***/ },
        /* 824 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Fuzzy
 */ module1.exports = {
                Ceil: __webpack_require__(825),
                Equal: __webpack_require__(123),
                Floor: __webpack_require__(826),
                GreaterThan: __webpack_require__(348),
                LessThan: __webpack_require__(349)
            };
        /***/ },
        /* 825 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy ceiling of the given value.
 *
 * @function Phaser.Math.Fuzzy.Ceil
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The fuzzy ceiling of the value.
 */ var Ceil = function(value, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.ceil(value - epsilon);
            };
            module1.exports = Ceil;
        /***/ },
        /* 826 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the fuzzy floor of the given value.
 *
 * @function Phaser.Math.Fuzzy.Floor
 * @since 3.0.0
 *
 * @param {number} value - The value.
 * @param {number} [epsilon=0.0001] - The epsilon.
 *
 * @return {number} The floor of the value.
 */ var Floor = function(value, epsilon) {
                if (epsilon === undefined) epsilon = 0.0001;
                return Math.floor(value + epsilon);
            };
            module1.exports = Floor;
        /***/ },
        /* 827 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Interpolation
 */ module1.exports = {
                Bezier: __webpack_require__(828),
                CatmullRom: __webpack_require__(829),
                CubicBezier: __webpack_require__(352),
                Linear: __webpack_require__(830),
                QuadraticBezier: __webpack_require__(353),
                SmoothStep: __webpack_require__(354),
                SmootherStep: __webpack_require__(831)
            };
        /***/ },
        /* 828 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bernstein = __webpack_require__(350);
            /**
 * A bezier interpolation method.
 *
 * @function Phaser.Math.Interpolation.Bezier
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var BezierInterpolation = function(v, k) {
                var b = 0;
                var n = v.length - 1;
                for(var i = 0; i <= n; i++)b += Math.pow(1 - k, n - i) * Math.pow(k, i) * v[i] * Bernstein(n, i);
                return b;
            };
            module1.exports = BezierInterpolation;
        /***/ },
        /* 829 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CatmullRom = __webpack_require__(191);
            /**
 * A Catmull-Rom interpolation method.
 *
 * @function Phaser.Math.Interpolation.CatmullRom
 * @since 3.0.0
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {number} The interpolated value.
 */ var CatmullRomInterpolation = function(v, k) {
                var m = v.length - 1;
                var f = m * k;
                var i = Math.floor(f);
                if (v[0] === v[m]) {
                    if (k < 0) i = Math.floor(f = m * (1 + k));
                    return CatmullRom(f - i, v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m]);
                } else {
                    if (k < 0) return v[0] - (CatmullRom(-f, v[0], v[0], v[1], v[1]) - v[0]);
                    if (k > 1) return v[m] - (CatmullRom(f - m, v[m], v[m], v[m - 1], v[m - 1]) - v[m]);
                    return CatmullRom(f - i, v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2]);
                }
            };
            module1.exports = CatmullRomInterpolation;
        /***/ },
        /* 830 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(133);
            /**
 * A linear interpolation method.
 *
 * @function Phaser.Math.Interpolation.Linear
 * @since 3.0.0
 * @see {@link https://en.wikipedia.org/wiki/Linear_interpolation}
 *
 * @param {number[]} v - The input array of values to interpolate between.
 * @param {!number} k - The percentage of interpolation, between 0 and 1.
 *
 * @return {!number} The interpolated value.
 */ var LinearInterpolation = function(v, k) {
                var m = v.length - 1;
                var f = m * k;
                var i = Math.floor(f);
                if (k < 0) return Linear(v[0], v[1], f);
                else if (k > 1) return Linear(v[m], v[m - 1], m - f);
                else return Linear(v[i], v[i + 1 > m ? m : i + 1], f - i);
            };
            module1.exports = LinearInterpolation;
        /***/ },
        /* 831 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SmootherStep = __webpack_require__(180);
            /**
 * A Smoother Step interpolation method.
 *
 * @function Phaser.Math.Interpolation.SmootherStep
 * @since 3.9.0
 * @see {@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 *
 * @param {number} t - The percentage of interpolation, between 0 and 1.
 * @param {number} min - The minimum value, also known as the 'left edge', assumed smaller than the 'right edge'.
 * @param {number} max - The maximum value, also known as the 'right edge', assumed greater than the 'left edge'.
 *
 * @return {number} The interpolated value.
 */ var SmootherStepInterpolation = function(t, min, max) {
                return min + (max - min) * SmootherStep(t, 0, 1);
            };
            module1.exports = SmootherStepInterpolation;
        /***/ },
        /* 832 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Pow2
 */ module1.exports = {
                GetNext: __webpack_require__(355),
                IsSize: __webpack_require__(136),
                IsValue: __webpack_require__(833)
            };
        /***/ },
        /* 833 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tests the value and returns `true` if it is a power of two.
 *
 * @function Phaser.Math.Pow2.IsValue
 * @since 3.0.0
 *
 * @param {number} value - The value to check if it's a power of two.
 *
 * @return {boolean} Returns `true` if `value` is a power of two, otherwise `false`.
 */ var IsValuePowerOfTwo = function(value) {
                return value > 0 && (value & value - 1) === 0;
            };
            module1.exports = IsValuePowerOfTwo;
        /***/ },
        /* 834 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Math.Snap
 */ module1.exports = {
                Ceil: __webpack_require__(137),
                Floor: __webpack_require__(76),
                To: __webpack_require__(835)
            };
        /***/ },
        /* 835 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Snap a value to nearest grid slice, using rounding.
 *
 * Example: if you have an interval gap of `5` and a position of `12`... you will snap to `10` whereas `14` will snap to `15`.
 *
 * @function Phaser.Math.Snap.To
 * @since 3.0.0
 *
 * @param {number} value - The value to snap.
 * @param {number} gap - The interval gap of the grid.
 * @param {number} [start=0] - Optional starting offset for gap.
 * @param {boolean} [divide=false] - If `true` it will divide the snapped value by the gap before returning.
 *
 * @return {number} The snapped value.
 */ var SnapTo = function(value, gap, start, divide) {
                if (start === undefined) start = 0;
                if (gap === 0) return value;
                value -= start;
                value = gap * Math.round(value / gap);
                return divide ? (start + value) / gap : start + value;
            };
            module1.exports = SnapTo;
        /***/ },
        /* 836 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            /**
 * @classdesc
 * A seeded Random Data Generator.
 * 
 * Access via `Phaser.Math.RND` which is an instance of this class pre-defined
 * by Phaser. Or, create your own instance to use as you require.
 * 
 * The `Math.RND` generator is seeded by the Game Config property value `seed`.
 * If no such config property exists, a random number is used.
 * 
 * If you create your own instance of this class you should provide a seed for it.
 * If no seed is given it will use a 'random' one based on Date.now.
 *
 * @class RandomDataGenerator
 * @memberof Phaser.Math
 * @constructor
 * @since 3.0.0
 *
 * @param {(string|string[])} [seeds] - The seeds to use for the random number generator.
 */ var RandomDataGenerator = new Class({
                initialize: function RandomDataGenerator(seeds) {
                    if (seeds === undefined) seeds = [
                        (Date.now() * Math.random()).toString()
                    ];
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#c
         * @type {number}
         * @default 1
         * @private
         * @since 3.0.0
         */ this.c = 1;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s0
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s0 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s1
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s1 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#s2
         * @type {number}
         * @default 0
         * @private
         * @since 3.0.0
         */ this.s2 = 0;
                    /**
         * Internal var.
         *
         * @name Phaser.Math.RandomDataGenerator#n
         * @type {number}
         * @default 0
         * @private
         * @since 3.2.0
         */ this.n = 0;
                    /**
         * Signs to choose from.
         *
         * @name Phaser.Math.RandomDataGenerator#signs
         * @type {number[]}
         * @since 3.0.0
         */ this.signs = [
                        -1,
                        1
                    ];
                    if (seeds) this.init(seeds);
                },
                /**
     * Private random helper.
     *
     * @method Phaser.Math.RandomDataGenerator#rnd
     * @since 3.0.0
     * @private
     *
     * @return {number} A random number.
     */ rnd: function() {
                    var t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
                    this.c = t | 0;
                    this.s0 = this.s1;
                    this.s1 = this.s2;
                    this.s2 = t - this.c;
                    return this.s2;
                },
                /**
     * Internal method that creates a seed hash.
     *
     * @method Phaser.Math.RandomDataGenerator#hash
     * @since 3.0.0
     * @private
     *
     * @param {string} data - The value to hash.
     *
     * @return {number} The hashed value.
     */ hash: function(data) {
                    var h;
                    var n = this.n;
                    data = data.toString();
                    for(var i = 0; i < data.length; i++){
                        n += data.charCodeAt(i);
                        h = 0.02519603282416938 * n;
                        n = h >>> 0;
                        h -= n;
                        h *= n;
                        n = h >>> 0;
                        h -= n;
                        n += h * 0x100000000; // 2^32
                    }
                    this.n = n;
                    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
                },
                /**
     * Initialize the state of the random data generator.
     *
     * @method Phaser.Math.RandomDataGenerator#init
     * @since 3.0.0
     *
     * @param {(string|string[])} seeds - The seeds to initialize the random data generator with.
     */ init: function(seeds) {
                    if (typeof seeds === 'string') this.state(seeds);
                    else this.sow(seeds);
                },
                /**
     * Reset the seed of the random data generator.
     *
     * _Note_: the seed array is only processed up to the first `undefined` (or `null`) value, should such be present.
     *
     * @method Phaser.Math.RandomDataGenerator#sow
     * @since 3.0.0
     *
     * @param {string[]} seeds - The array of seeds: the `toString()` of each value is used.
     */ sow: function(seeds) {
                    // Always reset to default seed
                    this.n = 0xefc8249d;
                    this.s0 = this.hash(' ');
                    this.s1 = this.hash(' ');
                    this.s2 = this.hash(' ');
                    this.c = 1;
                    if (!seeds) return;
                    // Apply any seeds
                    for(var i = 0; i < seeds.length && seeds[i] != null; i++){
                        var seed = seeds[i];
                        this.s0 -= this.hash(seed);
                        this.s0 += ~~(this.s0 < 0);
                        this.s1 -= this.hash(seed);
                        this.s1 += ~~(this.s1 < 0);
                        this.s2 -= this.hash(seed);
                        this.s2 += ~~(this.s2 < 0);
                    }
                },
                /**
     * Returns a random integer between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#integer
     * @since 3.0.0
     *
     * @return {number} A random integer between 0 and 2^32.
     */ integer: function() {
                    // 2^32
                    return this.rnd() * 0x100000000;
                },
                /**
     * Returns a random real number between 0 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#frac
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 1.
     */ frac: function() {
                    // 2^-53
                    return this.rnd() + (this.rnd() * 0x200000 | 0) * 1.1102230246251565e-16;
                },
                /**
     * Returns a random real number between 0 and 2^32.
     *
     * @method Phaser.Math.RandomDataGenerator#real
     * @since 3.0.0
     *
     * @return {number} A random real number between 0 and 2^32.
     */ real: function() {
                    return this.integer() + this.frac();
                },
                /**
     * Returns a random integer between and including min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#integerInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ integerInRange: function(min, max) {
                    return Math.floor(this.realInRange(0, max - min + 1) + min);
                },
                /**
     * Returns a random integer between and including min and max.
     * This method is an alias for RandomDataGenerator.integerInRange.
     *
     * @method Phaser.Math.RandomDataGenerator#between
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ between: function(min, max) {
                    return Math.floor(this.realInRange(0, max - min + 1) + min);
                },
                /**
     * Returns a random real number between min and max.
     *
     * @method Phaser.Math.RandomDataGenerator#realInRange
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random number between min and max.
     */ realInRange: function(min, max) {
                    return this.frac() * (max - min) + min;
                },
                /**
     * Returns a random real number between -1 and 1.
     *
     * @method Phaser.Math.RandomDataGenerator#normal
     * @since 3.0.0
     *
     * @return {number} A random real number between -1 and 1.
     */ normal: function() {
                    return 1 - 2 * this.frac();
                },
                /**
     * Returns a valid RFC4122 version4 ID hex string from https://gist.github.com/1308368
     *
     * @method Phaser.Math.RandomDataGenerator#uuid
     * @since 3.0.0
     *
     * @return {string} A valid RFC4122 version4 ID hex string
     */ uuid: function() {
                    var a = '';
                    var b = '';
                    for(b = a = ''; a++ < 36; b += ~a % 5 | a * 3 & 4 ? (a ^ 15 ? 8 ^ this.frac() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-');
                    return b;
                },
                /**
     * Returns a random element from within the given array.
     *
     * @method Phaser.Math.RandomDataGenerator#pick
     * @since 3.0.0
     * 
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ pick: function(array) {
                    return array[this.integerInRange(0, array.length - 1)];
                },
                /**
     * Returns a sign to be used with multiplication operator.
     *
     * @method Phaser.Math.RandomDataGenerator#sign
     * @since 3.0.0
     *
     * @return {number} -1 or +1.
     */ sign: function() {
                    return this.pick(this.signs);
                },
                /**
     * Returns a random element from within the given array, favoring the earlier entries.
     *
     * @method Phaser.Math.RandomDataGenerator#weightedPick
     * @since 3.0.0
     *
     * @generic T
     * @genericUse {T[]} - [array]
     * @genericUse {T} - [$return]
     *
     * @param {T[]} array - The array to pick a random element from.
     *
     * @return {T} A random member of the array.
     */ weightedPick: function(array) {
                    return array[~~(Math.pow(this.frac(), 2) * (array.length - 1) + 0.5)];
                },
                /**
     * Returns a random timestamp between min and max, or between the beginning of 2000 and the end of 2020 if min and max aren't specified.
     *
     * @method Phaser.Math.RandomDataGenerator#timestamp
     * @since 3.0.0
     *
     * @param {number} min - The minimum value in the range.
     * @param {number} max - The maximum value in the range.
     *
     * @return {number} A random timestamp between min and max.
     */ timestamp: function(min, max) {
                    return this.realInRange(min || 946684800000, max || 1577862000000);
                },
                /**
     * Returns a random angle between -180 and 180.
     *
     * @method Phaser.Math.RandomDataGenerator#angle
     * @since 3.0.0
     *
     * @return {number} A random number between -180 and 180.
     */ angle: function() {
                    return this.integerInRange(-180, 180);
                },
                /**
     * Returns a random rotation in radians, between -3.141 and 3.141
     *
     * @method Phaser.Math.RandomDataGenerator#rotation
     * @since 3.0.0
     *
     * @return {number} A random number between -3.141 and 3.141
     */ rotation: function() {
                    return this.realInRange(-3.1415926, 3.1415926);
                },
                /**
     * Gets or Sets the state of the generator. This allows you to retain the values
     * that the generator is using between games, i.e. in a game save file.
     *
     * To seed this generator with a previously saved state you can pass it as the
     * `seed` value in your game config, or call this method directly after Phaser has booted.
     *
     * Call this method with no parameters to return the current state.
     *
     * If providing a state it should match the same format that this method
     * returns, which is a string with a header `!rnd` followed by the `c`,
     * `s0`, `s1` and `s2` values respectively, each comma-delimited.
     *
     * @method Phaser.Math.RandomDataGenerator#state
     * @since 3.0.0
     *
     * @param {string} [state] - Generator state to be set.
     *
     * @return {string} The current state of the generator.
     */ state: function(state) {
                    if (typeof state === 'string' && state.match(/^!rnd/)) {
                        state = state.split(',');
                        this.c = parseFloat(state[1]);
                        this.s0 = parseFloat(state[2]);
                        this.s1 = parseFloat(state[3]);
                        this.s2 = parseFloat(state[4]);
                    }
                    return [
                        '!rnd',
                        this.c,
                        this.s0,
                        this.s1,
                        this.s2
                    ].join(',');
                },
                /**
     * Shuffles the given array, using the current seed.
     *
     * @method Phaser.Math.RandomDataGenerator#shuffle
     * @since 3.7.0
     *
     * @generic T
     * @genericUse {T[]} - [array,$return]
     *
     * @param {T[]} [array] - The array to be shuffled.
     *
     * @return {T[]} The shuffled array.
     */ shuffle: function(array) {
                    var len = array.length - 1;
                    for(var i = len; i > 0; i--){
                        var randomIndex = Math.floor(this.frac() * (i + 1));
                        var itemAtIndex = array[randomIndex];
                        array[randomIndex] = array[i];
                        array[i] = itemAtIndex;
                    }
                    return array;
                }
            });
            module1.exports = RandomDataGenerator;
        /***/ },
        /* 837 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the mean average of the given values.
 *
 * @function Phaser.Math.Average
 * @since 3.0.0
 *
 * @param {number[]} values - The values to average.
 *
 * @return {number} The average value.
 */ var Average = function(values) {
                var sum = 0;
                for(var i = 0; i < values.length; i++)sum += +values[i];
                return sum / values.length;
            };
            module1.exports = Average;
        /***/ },
        /* 838 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Ceils to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.CeilTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var CeilTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.ceil(value * p) / p;
            };
            module1.exports = CeilTo;
        /***/ },
        /* 839 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the positive difference of two given numbers.
 *
 * @function Phaser.Math.Difference
 * @since 3.0.0
 *
 * @param {number} a - The first number in the calculation.
 * @param {number} b - The second number in the calculation.
 *
 * @return {number} The positive difference of the two given numbers.
 */ var Difference = function(a, b) {
                return Math.abs(a - b);
            };
            module1.exports = Difference;
        /***/ },
        /* 840 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Matrix4 = __webpack_require__(67);
            var NOOP = __webpack_require__(1);
            var tempMatrix = new Matrix4();
            /**
 * @classdesc
 *
 * @class Euler
 * @memberof Phaser.Math
 * @constructor
 * @since 3.50.0
 *
 * @param {number} [x] - The x component.
 * @param {number} [y] - The y component.
 * @param {number} [z] - The z component.
 */ var Euler = new Class({
                initialize: function Euler(x, y, z, order) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (z === undefined) z = 0;
                    if (order === undefined) order = Euler.DefaultOrder;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    this.onChangeCallback = NOOP;
                },
                x: {
                    get: function() {
                        return this._x;
                    },
                    set: function(value) {
                        this._x = value;
                        this.onChangeCallback(this);
                    }
                },
                y: {
                    get: function() {
                        return this._y;
                    },
                    set: function(value) {
                        this._y = value;
                        this.onChangeCallback(this);
                    }
                },
                z: {
                    get: function() {
                        return this._z;
                    },
                    set: function(value) {
                        this._z = value;
                        this.onChangeCallback(this);
                    }
                },
                order: {
                    get: function() {
                        return this._order;
                    },
                    set: function(value) {
                        this._order = value;
                        this.onChangeCallback(this);
                    }
                },
                set: function(x, y, z, order) {
                    if (order === undefined) order = this._order;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    this.onChangeCallback(this);
                    return this;
                },
                copy: function(euler) {
                    return this.set(euler.x, euler.y, euler.z, euler.order);
                },
                setFromQuaternion: function(quaternion, order, update) {
                    if (order === undefined) order = this._order;
                    if (update === undefined) update = false;
                    tempMatrix.fromQuat(quaternion);
                    return this.setFromRotationMatrix(tempMatrix, order, update);
                },
                setFromRotationMatrix: function(matrix, order, update) {
                    if (order === undefined) order = this._order;
                    if (update === undefined) update = false;
                    var elements = matrix.val;
                    //  Upper 3x3 of matrix is un-scaled rotation matrix
                    var m11 = elements[0];
                    var m12 = elements[4];
                    var m13 = elements[8];
                    var m21 = elements[1];
                    var m22 = elements[5];
                    var m23 = elements[9];
                    var m31 = elements[2];
                    var m32 = elements[6];
                    var m33 = elements[10];
                    var x = 0;
                    var y = 0;
                    var z = 0;
                    var epsilon = 0.99999;
                    switch(order){
                        case 'XYZ':
                            y = Math.asin(Clamp(m13, -1, 1));
                            if (Math.abs(m13) < epsilon) {
                                x = Math.atan2(-m23, m33);
                                z = Math.atan2(-m12, m11);
                            } else x = Math.atan2(m32, m22);
                            break;
                        case 'YXZ':
                            x = Math.asin(-Clamp(m23, -1, 1));
                            if (Math.abs(m23) < epsilon) {
                                y = Math.atan2(m13, m33);
                                z = Math.atan2(m21, m22);
                            } else y = Math.atan2(-m31, m11);
                            break;
                        case 'ZXY':
                            x = Math.asin(Clamp(m32, -1, 1));
                            if (Math.abs(m32) < epsilon) {
                                y = Math.atan2(-m31, m33);
                                z = Math.atan2(-m12, m22);
                            } else z = Math.atan2(m21, m11);
                            break;
                        case 'ZYX':
                            y = Math.asin(-Clamp(m31, -1, 1));
                            if (Math.abs(m31) < epsilon) {
                                x = Math.atan2(m32, m33);
                                z = Math.atan2(m21, m11);
                            } else z = Math.atan2(-m12, m22);
                            break;
                        case 'YZX':
                            z = Math.asin(Clamp(m21, -1, 1));
                            if (Math.abs(m21) < epsilon) {
                                x = Math.atan2(-m23, m22);
                                y = Math.atan2(-m31, m11);
                            } else y = Math.atan2(m13, m33);
                            break;
                        case 'XZY':
                            z = Math.asin(-Clamp(m12, -1, 1));
                            if (Math.abs(m12) < epsilon) {
                                x = Math.atan2(m32, m22);
                                y = Math.atan2(m13, m11);
                            } else x = Math.atan2(-m23, m33);
                            break;
                    }
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    this._order = order;
                    if (update) this.onChangeCallback(this);
                    return this;
                }
            });
            Euler.RotationOrders = [
                'XYZ',
                'YXZ',
                'ZXY',
                'ZYX',
                'YZX',
                'XZY'
            ];
            Euler.DefaultOrder = 'XYZ';
            module1.exports = Euler;
        /***/ },
        /* 841 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Floors to some place comparative to a `base`, default is 10 for decimal place.
 *
 * The `place` is represented by the power applied to `base` to get that place.
 *
 * @function Phaser.Math.FloorTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var FloorTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.floor(value * p) / p;
            };
            module1.exports = FloorTo;
        /***/ },
        /* 842 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate a per-ms speed from a distance and time (given in seconds).
 *
 * @function Phaser.Math.GetSpeed
 * @since 3.0.0
 *
 * @param {number} distance - The distance.
 * @param {number} time - The time, in seconds.
 *
 * @return {number} The speed, in distance per ms.
 *
 * @example
 * // 400px over 1 second is 0.4 px/ms
 * Phaser.Math.GetSpeed(400, 1) // -> 0.4
 */ var GetSpeed = function(distance, time) {
                return distance / time / 1000;
            };
            module1.exports = GetSpeed;
        /***/ },
        /* 843 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number.
 *
 * @function Phaser.Math.IsEven
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEven = function(value) {
                // Use abstract equality == for "is number" test
                // eslint-disable-next-line eqeqeq
                return value == parseFloat(value) ? !(value % 2) : void 0;
            };
            module1.exports = IsEven;
        /***/ },
        /* 844 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if a given value is an even number using a strict type check.
 *
 * @function Phaser.Math.IsEvenStrict
 * @since 3.0.0
 *
 * @param {number} value - The number to perform the check with.
 *
 * @return {boolean} Whether the number is even or not.
 */ var IsEvenStrict = function(value) {
                // Use strict equality === for "is number" test
                return value === parseFloat(value) ? !(value % 2) : void 0;
            };
            module1.exports = IsEvenStrict;
        /***/ },
        /* 845 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Add an `amount` to a `value`, limiting the maximum result to `max`.
 *
 * @function Phaser.Math.MaxAdd
 * @since 3.0.0
 *
 * @param {number} value - The value to add to.
 * @param {number} amount - The amount to add.
 * @param {number} max - The maximum value to return.
 *
 * @return {number} The resulting value.
 */ var MaxAdd = function(value, amount, max) {
                return Math.min(value + amount, max);
            };
            module1.exports = MaxAdd;
        /***/ },
        /* 846 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Subtract an `amount` from `value`, limiting the minimum result to `min`.
 *
 * @function Phaser.Math.MinSub
 * @since 3.0.0
 *
 * @param {number} value - The value to subtract from.
 * @param {number} amount - The amount to subtract.
 * @param {number} min - The minimum value to return.
 *
 * @return {number} The resulting value.
 */ var MinSub = function(value, amount, min) {
                return Math.max(value - amount, min);
            };
            module1.exports = MinSub;
        /***/ },
        /* 847 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Work out what percentage `value` is of the range between `min` and `max`.
 * If `max` isn't given then it will return the percentage of `value` to `min`.
 *
 * You can optionally specify an `upperMax` value, which is a mid-way point in the range that represents 100%, after which the % starts to go down to zero again.
 *
 * @function Phaser.Math.Percent
 * @since 3.0.0
 *
 * @param {number} value - The value to determine the percentage of.
 * @param {number} min - The minimum value.
 * @param {number} [max] - The maximum value.
 * @param {number} [upperMax] - The mid-way point in the range that represents 100%.
 *
 * @return {number} A value between 0 and 1 representing the percentage.
 */ var Percent = function(value, min, max, upperMax) {
                if (max === undefined) max = min + 1;
                var percentage = (value - min) / (max - min);
                if (percentage > 1) {
                    if (upperMax !== undefined) {
                        percentage = (upperMax - value) / (upperMax - max);
                        if (percentage < 0) percentage = 0;
                    } else percentage = 1;
                } else if (percentage < 0) percentage = 0;
                return percentage;
            };
            module1.exports = Percent;
        /***/ },
        /* 848 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random unit vector.
 *
 * Computes random values for the given vector between -1 and 1 that can be used to represent a direction.
 *
 * Optionally accepts a scale value to scale the resulting vector by.
 *
 * @function Phaser.Math.RandomXY
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector2} vector - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector2} The given Vector.
 */ var RandomXY = function(vector, scale) {
                if (scale === undefined) scale = 1;
                var r = Math.random() * 2 * Math.PI;
                vector.x = Math.cos(r) * scale;
                vector.y = Math.sin(r) * scale;
                return vector;
            };
            module1.exports = RandomXY;
        /***/ },
        /* 849 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random position vector in a spherical area, optionally defined by the given radius.
 *
 * @function Phaser.Math.RandomXYZ
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec3 - The Vector to compute random values for.
 * @param {number} [radius=1] - The radius.
 *
 * @return {Phaser.Math.Vector3} The given Vector.
 */ var RandomXYZ = function(vec3, radius) {
                if (radius === undefined) radius = 1;
                var r = Math.random() * 2 * Math.PI;
                var z = Math.random() * 2 - 1;
                var zScale = Math.sqrt(1 - z * z) * radius;
                vec3.x = Math.cos(r) * zScale;
                vec3.y = Math.sin(r) * zScale;
                vec3.z = z * radius;
                return vec3;
            };
            module1.exports = RandomXYZ;
        /***/ },
        /* 850 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compute a random four-dimensional vector.
 *
 * @function Phaser.Math.RandomXYZW
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector4} vec4 - The Vector to compute random values for.
 * @param {number} [scale=1] - The scale of the random values.
 *
 * @return {Phaser.Math.Vector4} The given Vector.
 */ var RandomXYZW = function(vec4, scale) {
                if (scale === undefined) scale = 1;
                vec4.x = (Math.random() * 2 - 1) * scale;
                vec4.y = (Math.random() * 2 - 1) * scale;
                vec4.z = (Math.random() * 2 - 1) * scale;
                vec4.w = (Math.random() * 2 - 1) * scale;
                return vec4;
            };
            module1.exports = RandomXYZW;
        /***/ },
        /* 851 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Position a `point` at the given `angle` and `distance` to (`x`, `y`).
 *
 * @function Phaser.Math.RotateTo
 * @since 3.24.0
 *
 * @generic {Phaser.Types.Math.Vector2Like} T - [point,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like} point - The point to be positioned.
 * @param {number} x - The horizontal coordinate to position from.
 * @param {number} y - The vertical coordinate to position from.
 * @param {number} angle - The angle of rotation in radians.
 * @param {number} distance - The distance from (x, y) to place the point at.
 *
 * @return {Phaser.Types.Math.Vector2Like} The given point.
 */ var RotateTo = function(point, x, y, angle, distance) {
                point.x = x + distance * Math.cos(angle);
                point.y = y + distance * Math.sin(angle);
                return point;
            };
            module1.exports = RotateTo;
        /***/ },
        /* 852 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Round a value to the given precision.
 * 
 * For example:
 * 
 * ```javascript
 * RoundTo(123.456, 0) = 123
 * RoundTo(123.456, 1) = 120
 * RoundTo(123.456, 2) = 100
 * ```
 * 
 * To round the decimal, i.e. to round to precision, pass in a negative `place`:
 * 
 * ```javascript
 * RoundTo(123.456789, 0) = 123
 * RoundTo(123.456789, -1) = 123.5
 * RoundTo(123.456789, -2) = 123.46
 * RoundTo(123.456789, -3) = 123.457
 * ```
 *
 * @function Phaser.Math.RoundTo
 * @since 3.0.0
 *
 * @param {number} value - The value to round.
 * @param {number} [place=0] - The place to round to. Positive to round the units, negative to round the decimal.
 * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
 *
 * @return {number} The rounded value.
 */ var RoundTo = function(value, place, base) {
                if (place === undefined) place = 0;
                if (base === undefined) base = 10;
                var p = Math.pow(base, -place);
                return Math.round(value * p) / p;
            };
            module1.exports = RoundTo;
        /***/ },
        /* 853 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Generate a series of sine and cosine values.
 *
 * @function Phaser.Math.SinCosTableGenerator
 * @since 3.0.0
 *
 * @param {number} length - The number of values to generate.
 * @param {number} [sinAmp=1] - The sine value amplitude.
 * @param {number} [cosAmp=1] - The cosine value amplitude.
 * @param {number} [frequency=1] - The frequency of the values.
 *
 * @return {Phaser.Types.Math.SinCosTable} The generated values.
 */ var SinCosTableGenerator = function(length, sinAmp, cosAmp, frequency) {
                if (sinAmp === undefined) sinAmp = 1;
                if (cosAmp === undefined) cosAmp = 1;
                if (frequency === undefined) frequency = 1;
                frequency *= Math.PI / length;
                var cos = [];
                var sin = [];
                for(var c = 0; c < length; c++){
                    cosAmp -= sinAmp * frequency;
                    sinAmp += cosAmp * frequency;
                    cos[c] = cosAmp;
                    sin[c] = sinAmp;
                }
                return {
                    sin: sin,
                    cos: cos,
                    length: length
                };
            };
            module1.exports = SinCosTableGenerator;
        /***/ },
        /* 854 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            /**
 * Returns a Vector2 containing the x and y position of the given index in a `width` x `height` sized grid.
 * 
 * For example, in a 6 x 4 grid, index 16 would equal x: 4 y: 2.
 * 
 * If the given index is out of range an empty Vector2 is returned.
 *
 * @function Phaser.Math.ToXY
 * @since 3.19.0
 *
 * @param {number} index - The position within the grid to get the x/y value for.
 * @param {number} width - The width of the grid.
 * @param {number} height - The height of the grid.
 * @param {Phaser.Math.Vector2} [out] - An optional Vector2 to store the result in. If not given, a new Vector2 instance will be created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 where the x and y properties contain the given grid index.
 */ var ToXY = function(index, width, height, out) {
                if (out === undefined) out = new Vector2();
                var x = 0;
                var y = 0;
                var total = width * height;
                if (index > 0 && index <= total) {
                    if (index > width - 1) {
                        y = Math.floor(index / width);
                        x = index - y * width;
                    } else x = index;
                    out.set(x, y);
                }
                return out;
            };
            module1.exports = ToXY;
        /***/ },
        /* 855 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if the two values are within the given `tolerance` of each other.
 *
 * @function Phaser.Math.Within
 * @since 3.0.0
 *
 * @param {number} a - The first value to use in the calculation.
 * @param {number} b - The second value to use in the calculation.
 * @param {number} tolerance - The tolerance. Anything equal to or less than this value is considered as being within range.
 *
 * @return {boolean} Returns `true` if `a` is less than or equal to the tolerance of `b`.
 */ var Within = function(a, b, tolerance) {
                return Math.abs(a - b) <= tolerance;
            };
            module1.exports = Within;
        /***/ },
        /* 856 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector3 = __webpack_require__(38);
            var Matrix4 = __webpack_require__(67);
            var Quaternion = __webpack_require__(359);
            var tmpMat4 = new Matrix4();
            var tmpQuat = new Quaternion();
            var tmpVec3 = new Vector3();
            /**
 * Rotates a vector in place by axis angle.
 *
 * This is the same as transforming a point by an
 * axis-angle quaternion, but it has higher precision.
 *
 * @function Phaser.Math.RotateVec3
 * @since 3.0.0
 *
 * @param {Phaser.Math.Vector3} vec - The vector to be rotated.
 * @param {Phaser.Math.Vector3} axis - The axis to rotate around.
 * @param {number} radians - The angle of rotation in radians.
 *
 * @return {Phaser.Math.Vector3} The given vector.
 */ var RotateVec3 = function(vec, axis, radians) {
                //  Set the quaternion to our axis angle
                tmpQuat.setAxisAngle(axis, radians);
                //  Create a rotation matrix from the axis angle
                tmpMat4.fromRotationTranslation(tmpQuat, tmpVec3.set(0, 0, 0));
                //  Multiply our vector by the rotation matrix
                return vec.transformMat4(tmpMat4);
            };
            module1.exports = RotateVec3;
        /***/ },
        /* 857 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Add Event.
 * 
 * This event is dispatched by the Texture Manager when a texture is added to it.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('addtexture', listener)`.
 *
 * @event Phaser.Textures.Events#ADD
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was added to the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was added to the Texture Manager.
 */ module1.exports = 'addtexture';
        /***/ },
        /* 858 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Error Event.
 * 
 * This event is dispatched by the Texture Manager when a texture it requested to load failed.
 * This only happens when base64 encoded textures fail. All other texture types are loaded via the Loader Plugin.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('onerror', listener)`.
 *
 * @event Phaser.Textures.Events#ERROR
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that failed to load into the Texture Manager.
 */ module1.exports = 'onerror';
        /***/ },
        /* 859 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Load Event.
 * 
 * This event is dispatched by the Texture Manager when a texture has finished loading on it.
 * This only happens for base64 encoded textures. All other texture types are loaded via the Loader Plugin.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('onload', listener)`.
 * 
 * This event is dispatched after the [ADD]{@linkcode Phaser.Textures.Events#event:ADD} event.
 *
 * @event Phaser.Textures.Events#LOAD
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was loaded by the Texture Manager.
 * @param {Phaser.Textures.Texture} texture - A reference to the Texture that was loaded by the Texture Manager.
 */ module1.exports = 'onload';
        /***/ },
        /* 860 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This internal event signifies that the Texture Manager is now ready and the Game can continue booting.
 * 
 * When a Phaser Game instance is booting for the first time, the Texture Manager has to wait on a couple of non-blocking
 * async events before it's fully ready to carry on. When those complete the Texture Manager emits this event via the Game
 * instance, which tells the Game to carry on booting.
 *
 * @event Phaser.Textures.Events#READY
 * @since 3.16.1
 */ module1.exports = 'ready';
        /***/ },
        /* 861 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Texture Remove Event.
 * 
 * This event is dispatched by the Texture Manager when a texture is removed from it.
 * 
 * Listen to this event from within a Scene using: `this.textures.on('removetexture', listener)`.
 * 
 * If you have any Game Objects still using the removed texture, they will start throwing
 * errors the next time they try to render. Be sure to clear all use of the texture in this event handler.
 *
 * @event Phaser.Textures.Events#REMOVE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the Texture that was removed from the Texture Manager.
 */ module1.exports = 'removetexture';
        /***/ },
        /* 862 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_BITMAP_MASK_FS',
                '',
                'precision mediump float;',
                '',
                'uniform vec2 uResolution;',
                'uniform sampler2D uMainSampler;',
                'uniform sampler2D uMaskSampler;',
                'uniform bool uInvertMaskAlpha;',
                '',
                'void main ()',
                '{',
                '    vec2 uv = gl_FragCoord.xy / uResolution;',
                '    vec4 mainColor = texture2D(uMainSampler, uv);',
                '    vec4 maskColor = texture2D(uMaskSampler, uv);',
                '    float alpha = mainColor.a;',
                '',
                '    if (!uInvertMaskAlpha)',
                '    {',
                '        alpha *= (maskColor.a);',
                '    }',
                '    else',
                '    {',
                '        alpha *= (1.0 - maskColor.a);',
                '    }',
                '',
                '    gl_FragColor = vec4(mainColor.rgb * alpha, alpha);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 863 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_BITMAP_MASK_VS',
                '',
                'precision mediump float;',
                '',
                'attribute vec2 inPosition;',
                '',
                'void main ()',
                '{',
                '    gl_Position = vec4(inPosition, 0.0, 1.0);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 864 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline After Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right after it has issued a drawArrays command
 * and cleared its vertex count.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#AFTER_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = 'pipelineafterflush';
        /***/ },
        /* 865 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Before Flush Event.
 *
 * This event is dispatched by a WebGLPipeline right before it is about to
 * flush and issue a bufferData and drawArrays command.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BEFORE_FLUSH
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that is about to flush.
 * @param {boolean} isPostFlush - Was this flush invoked as part of a post-process, or not?
 */ module1.exports = 'pipelinebeforeflush';
        /***/ },
        /* 866 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Bind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was bound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = 'pipelinebind';
        /***/ },
        /* 867 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Boot Event.
 *
 * This event is dispatched by a WebGLPipeline when it has completed its `boot` phase.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#BOOT
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that booted.
 */ module1.exports = 'pipelineboot';
        /***/ },
        /* 868 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Destroy Event.
 *
 * This event is dispatched by a WebGLPipeline when it is starting its destroy process.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#DESTROY
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that has flushed.
 */ module1.exports = 'pipelinedestroy';
        /***/ },
        /* 869 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline ReBind Event.
 *
 * This event is dispatched by a WebGLPipeline when it is re-bound by the Pipeline Manager.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#REBIND
 * @since 3.50.0
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was rebound.
 * @param {Phaser.Renderer.WebGL.WebGLShader} currentShader - The shader that was set as being current.
 */ module1.exports = 'pipelinerebind';
        /***/ },
        /* 870 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The WebGLPipeline Resize Event.
 *
 * This event is dispatched by a WebGLPipeline when it is resized, usually as a result
 * of the Renderer resizing.
 *
 * @event Phaser.Renderer.WebGL.Pipelines.Events#RESIZE
 * @since 3.50.0
 *
 * @param {number} width - The new width of the pipeline.
 * @param {number} height - The new height of the pipeline.
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The pipeline that was resized.
 */ module1.exports = 'pipelineresize';
        /***/ },
        /* 871 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_GRAPHICS_FS',
                '',
                'precision mediump float;',
                '',
                'varying vec4 outColor;',
                '',
                'void main ()',
                '{',
                '    gl_FragColor = vec4(outColor.bgr * outColor.a, outColor.a);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 872 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_GRAPHICS_VS',
                '',
                'precision mediump float;',
                '',
                'uniform mat4 uProjectionMatrix;',
                '',
                'attribute vec2 inPosition;',
                'attribute vec4 inColor;',
                '',
                'varying vec4 outColor;',
                '',
                'void main ()',
                '{',
                '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                '',
                '    outColor = inColor;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 873 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_LIGHT_FS',
                '',
                'precision mediump float;',
                '',
                'struct Light',
                '{',
                '    vec2 position;',
                '    vec3 color;',
                '    float intensity;',
                '    float radius;',
                '};',
                '',
                'const int kMaxLights = %LIGHT_COUNT%;',
                '',
                'uniform vec4 uCamera; /* x, y, rotation, zoom */',
                'uniform vec2 uResolution;',
                'uniform sampler2D uMainSampler;',
                'uniform sampler2D uNormSampler;',
                'uniform vec3 uAmbientLightColor;',
                'uniform Light uLights[kMaxLights];',
                'uniform mat3 uInverseRotationMatrix;',
                '',
                'varying vec2 outTexCoord;',
                'varying vec4 outTint;',
                '',
                'void main()',
                '{',
                '    vec3 finalColor = vec3(0.0, 0.0, 0.0);',
                '    vec4 color = texture2D(uMainSampler, outTexCoord) * vec4(outTint.bgr * outTint.a, outTint.a);',
                '    vec3 normalMap = texture2D(uNormSampler, outTexCoord).rgb;',
                '    vec3 normal = normalize(uInverseRotationMatrix * vec3(normalMap * 2.0 - 1.0));',
                '    vec2 res = vec2(min(uResolution.x, uResolution.y)) * uCamera.w;',
                '',
                '    for (int index = 0; index < kMaxLights; ++index)',
                '    {',
                '        Light light = uLights[index];',
                '        vec3 lightDir = vec3((light.position.xy / res) - (gl_FragCoord.xy / res), 0.1);',
                '        vec3 lightNormal = normalize(lightDir);',
                '        float distToSurf = length(lightDir) * uCamera.w;',
                '        float diffuseFactor = max(dot(normal, lightNormal), 0.0);',
                '        float radius = (light.radius / res.x * uCamera.w) * uCamera.w;',
                '        float attenuation = clamp(1.0 - distToSurf * distToSurf / (radius * radius), 0.0, 1.0);',
                '        vec3 diffuse = light.color * diffuseFactor;',
                '        finalColor += (attenuation * diffuse) * light.intensity;',
                '    }',
                '',
                '    vec4 colorOutput = vec4(uAmbientLightColor + finalColor, 1.0);',
                '',
                '    gl_FragColor = color * vec4(colorOutput.rgb * colorOutput.a, colorOutput.a);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 874 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_MULTI_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler[%count%];',
                '',
                'varying vec2 outTexCoord;',
                'varying float outTexId;',
                'varying float outTintEffect;',
                'varying vec4 outTint;',
                '',
                'void main ()',
                '{',
                '    vec4 texture;',
                '',
                '    %forloop%',
                '',
                '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                '',
                '    //  Multiply texture tint',
                '    vec4 color = texture * texel;',
                '',
                '    if (outTintEffect == 1.0)',
                '    {',
                '        //  Solid color + texture alpha',
                '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                '    }',
                '    else if (outTintEffect == 2.0)',
                '    {',
                '        //  Solid color, no texture',
                '        color = texel;',
                '    }',
                '',
                '    gl_FragColor = color;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 875 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_MULTI_VS',
                '',
                'precision mediump float;',
                '',
                'uniform mat4 uProjectionMatrix;',
                '',
                'attribute vec2 inPosition;',
                'attribute vec2 inTexCoord;',
                'attribute float inTexId;',
                'attribute float inTintEffect;',
                'attribute vec4 inTint;',
                '',
                'varying vec2 outTexCoord;',
                'varying float outTexId;',
                'varying float outTintEffect;',
                'varying vec4 outTint;',
                '',
                'void main ()',
                '{',
                '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                '',
                '    outTexCoord = inTexCoord;',
                '    outTexId = inTexId;',
                '    outTint = inTint;',
                '    outTintEffect = inTintEffect;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 876 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_POINTLIGHT_FS',
                '',
                'precision mediump float;',
                '',
                'uniform vec2 uResolution;',
                'uniform float uCameraZoom;',
                '',
                'varying vec4 lightPosition;',
                'varying vec4 lightColor;',
                'varying float lightRadius;',
                'varying float lightAttenuation;',
                '',
                'void main ()',
                '{',
                '    vec2 center = (lightPosition.xy + 1.0) * (uResolution.xy * 0.5);',
                '',
                '    float distToSurf = length(center - gl_FragCoord.xy);',
                '',
                '    float radius = 1.0 - distToSurf / (lightRadius * uCameraZoom);',
                '',
                '    float intensity = smoothstep(0.0, 1.0, radius * lightAttenuation);',
                '',
                '    vec4 color = vec4(intensity, intensity, intensity, 0.0) * lightColor;',
                '',
                '    gl_FragColor = vec4(color.rgb * lightColor.a, color.a);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 877 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_POINTLIGHT_VS',
                '',
                'precision mediump float;',
                '',
                'uniform mat4 uProjectionMatrix;',
                '',
                'attribute vec2 inPosition;',
                'attribute vec2 inLightPosition;',
                'attribute vec4 inLightColor;',
                'attribute float inLightRadius;',
                'attribute float inLightAttenuation;',
                '',
                'varying vec4 lightPosition;',
                'varying vec4 lightColor;',
                'varying float lightRadius;',
                'varying float lightAttenuation;',
                '',
                'void main ()',
                '{',
                '    lightColor = inLightColor;',
                '    lightRadius = inLightRadius;',
                '    lightAttenuation = inLightAttenuation;',
                '    lightPosition = uProjectionMatrix * vec4(inLightPosition, 1.0, 1.0);',
                '',
                '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 878 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_SINGLE_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler;',
                '',
                'varying vec2 outTexCoord;',
                'varying float outTintEffect;',
                'varying vec4 outTint;',
                '',
                'void main ()',
                '{',
                '    vec4 texture = texture2D(uMainSampler, outTexCoord);',
                '    vec4 texel = vec4(outTint.bgr * outTint.a, outTint.a);',
                '',
                '    //  Multiply texture tint',
                '    vec4 color = texture * texel;',
                '',
                '    if (outTintEffect == 1.0)',
                '    {',
                '        //  Solid color + texture alpha',
                '        color.rgb = mix(texture.rgb, outTint.bgr * outTint.a, texture.a);',
                '    }',
                '    else if (outTintEffect == 2.0)',
                '    {',
                '        //  Solid color, no texture',
                '        color = texel;',
                '    }',
                '',
                '    gl_FragColor = color;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 879 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_SINGLE_VS',
                '',
                'precision mediump float;',
                '',
                'uniform mat4 uProjectionMatrix;',
                '',
                'attribute vec2 inPosition;',
                'attribute vec2 inTexCoord;',
                'attribute float inTexId;',
                'attribute float inTintEffect;',
                'attribute vec4 inTint;',
                '',
                'varying vec2 outTexCoord;',
                'varying float outTintEffect;',
                'varying vec4 outTint;',
                '',
                'void main ()',
                '{',
                '    gl_Position = uProjectionMatrix * vec4(inPosition, 1.0, 1.0);',
                '',
                '    outTexCoord = inTexCoord;',
                '    outTint = inTint;',
                '    outTintEffect = inTintEffect;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 880 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_ADD_BLEND_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler1;',
                'uniform sampler2D uMainSampler2;',
                'uniform float uStrength;',
                '',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);',
                '    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);',
                '',
                '    gl_FragColor = frame1 + frame2 * uStrength;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 881 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_COLORMATRIX_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler;',
                'uniform float uColorMatrix[20];',
                'uniform float uAlpha;',
                '',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    vec4 c = texture2D(uMainSampler, outTexCoord);',
                '',
                '    if (uAlpha == 0.0)',
                '    {',
                '        gl_FragColor = c;',
                '',
                '        return;',
                '    }',
                '',
                '    if (c.a > 0.0)',
                '    {',
                '        c.rgb /= c.a;',
                '    }',
                '',
                '    vec4 result;',
                '',
                '    result.r = (uColorMatrix[0] * c.r) + (uColorMatrix[1] * c.g) + (uColorMatrix[2] * c.b) + (uColorMatrix[3] * c.a) + uColorMatrix[4];',
                '    result.g = (uColorMatrix[5] * c.r) + (uColorMatrix[6] * c.g) + (uColorMatrix[7] * c.b) + (uColorMatrix[8] * c.a) + uColorMatrix[9];',
                '    result.b = (uColorMatrix[10] * c.r) + (uColorMatrix[11] * c.g) + (uColorMatrix[12] * c.b) + (uColorMatrix[13] * c.a) + uColorMatrix[14];',
                '    result.a = (uColorMatrix[15] * c.r) + (uColorMatrix[16] * c.g) + (uColorMatrix[17] * c.b) + (uColorMatrix[18] * c.a) + uColorMatrix[19];',
                '',
                '    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);',
                '',
                '    rgb *= result.a;',
                '',
                '    gl_FragColor = vec4(rgb, result.a);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 882 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_COPY_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler;',
                'uniform float uBrightness;',
                '',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    gl_FragColor = texture2D(uMainSampler, outTexCoord) * uBrightness;',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 883 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_LINEAR_BLEND_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler1;',
                'uniform sampler2D uMainSampler2;',
                'uniform float uStrength;',
                '',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    vec4 frame1 = texture2D(uMainSampler1, outTexCoord);',
                '    vec4 frame2 = texture2D(uMainSampler2, outTexCoord);',
                '',
                '    gl_FragColor = mix(frame1, frame2 * uStrength, 0.5);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 884 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create
 */ module1.exports = {
                GenerateTexture: __webpack_require__(382),
                Palettes: __webpack_require__(885)
            };
        /***/ },
        /* 885 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Create.Palettes
 */ module1.exports = {
                ARNE16: __webpack_require__(383),
                C64: __webpack_require__(886),
                CGA: __webpack_require__(887),
                JMP: __webpack_require__(888),
                MSX: __webpack_require__(889)
            };
        /***/ },
        /* 886 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by the Commodore 64.
 *
 * @name Phaser.Create.Palettes.C64
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: '#000',
                1: '#fff',
                2: '#8b4131',
                3: '#7bbdc5',
                4: '#8b41ac',
                5: '#6aac41',
                6: '#3931a4',
                7: '#d5de73',
                8: '#945a20',
                9: '#5a4100',
                A: '#bd736a',
                B: '#525252',
                C: '#838383',
                D: '#acee8b',
                E: '#7b73de',
                F: '#acacac'
            };
        /***/ },
        /* 887 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color CGA inspired palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.CGA
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: '#000',
                1: '#2234d1',
                2: '#0c7e45',
                3: '#44aacc',
                4: '#8a3622',
                5: '#5c2e78',
                6: '#aa5c3d',
                7: '#b5b5b5',
                8: '#5e606e',
                9: '#4c81fb',
                A: '#6cd947',
                B: '#7be2f9',
                C: '#eb8a60',
                D: '#e23d69',
                E: '#ffd93f',
                F: '#fff'
            };
        /***/ },
        /* 888 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color JMP palette by [Arne](http://androidarts.com/palette/16pal.htm)
 *
 * @name Phaser.Create.Palettes.JMP
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: '#000',
                1: '#191028',
                2: '#46af45',
                3: '#a1d685',
                4: '#453e78',
                5: '#7664fe',
                6: '#833129',
                7: '#9ec2e8',
                8: '#dc534b',
                9: '#e18d79',
                A: '#d6b97b',
                B: '#e9d8a1',
                C: '#216c4b',
                D: '#d365c8',
                E: '#afaab9',
                F: '#f5f4eb'
            };
        /***/ },
        /* 889 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A 16 color palette inspired by Japanese computers like the MSX.
 *
 * @name Phaser.Create.Palettes.MSX
 * @since 3.0.0
 *
 * @type {Phaser.Types.Create.Palette}
 */ module1.exports = {
                0: '#000',
                1: '#191028',
                2: '#46af45',
                3: '#a1d685',
                4: '#453e78',
                5: '#7664fe',
                6: '#833129',
                7: '#9ec2e8',
                8: '#dc534b',
                9: '#e18d79',
                A: '#d6b97b',
                B: '#e9d8a1',
                C: '#216c4b',
                D: '#d365c8',
                E: '#afaab9',
                F: '#fff'
            };
        /***/ },
        /* 890 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Curves
 */ module1.exports = {
                Path: __webpack_require__(891),
                MoveTo: __webpack_require__(387),
                CubicBezier: __webpack_require__(384),
                Curve: __webpack_require__(90),
                Ellipse: __webpack_require__(385),
                Line: __webpack_require__(386),
                QuadraticBezier: __webpack_require__(388),
                Spline: __webpack_require__(389)
            };
        /***/ },
        /* 891 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
            var Class = __webpack_require__(0);
            var CubicBezierCurve = __webpack_require__(384);
            var EllipseCurve = __webpack_require__(385);
            var GameObjectFactory = __webpack_require__(5);
            var LineCurve = __webpack_require__(386);
            var MovePathTo = __webpack_require__(387);
            var QuadraticBezierCurve = __webpack_require__(388);
            var Rectangle = __webpack_require__(10);
            var SplineCurve = __webpack_require__(389);
            var Vector2 = __webpack_require__(3);
            var MATH_CONST = __webpack_require__(14);
            /**
 * @classdesc
 * A Path combines multiple Curves into one continuous compound curve.
 * It does not matter how many Curves are in the Path or what type they are.
 *
 * A Curve in a Path does not have to start where the previous Curve ends - that is to say, a Path does not
 * have to be an uninterrupted curve. Only the order of the Curves influences the actual points on the Path.
 *
 * @class Path
 * @memberof Phaser.Curves
 * @constructor
 * @since 3.0.0
 *
 * @param {number} [x=0] - The X coordinate of the Path's starting point or a {@link Phaser.Types.Curves.JSONPath}.
 * @param {number} [y=0] - The Y coordinate of the Path's starting point.
 */ var Path = new Class({
                initialize: function Path(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    /**
         * The name of this Path.
         * Empty by default and never populated by Phaser, this is left for developers to use.
         *
         * @name Phaser.Curves.Path#name
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.name = '';
                    /**
         * The list of Curves which make up this Path.
         *
         * @name Phaser.Curves.Path#curves
         * @type {Phaser.Curves.Curve[]}
         * @default []
         * @since 3.0.0
         */ this.curves = [];
                    /**
         * The cached length of each Curve in the Path.
         *
         * Used internally by {@link #getCurveLengths}.
         *
         * @name Phaser.Curves.Path#cacheLengths
         * @type {number[]}
         * @default []
         * @since 3.0.0
         */ this.cacheLengths = [];
                    /**
         * Automatically closes the path.
         *
         * @name Phaser.Curves.Path#autoClose
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.autoClose = false;
                    /**
         * The starting point of the Path.
         *
         * This is not necessarily equivalent to the starting point of the first Curve in the Path. In an empty Path, it's also treated as the ending point.
         *
         * @name Phaser.Curves.Path#startPoint
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.startPoint = new Vector2();
                    /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2A
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2A = new Vector2();
                    /**
         * A temporary vector used to avoid object creation when adding a Curve to the Path.
         *
         * @name Phaser.Curves.Path#_tmpVec2B
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tmpVec2B = new Vector2();
                    if (typeof x === 'object') this.fromJSON(x);
                    else this.startPoint.set(x, y);
                },
                /**
     * Appends a Curve to the end of the Path.
     *
     * The Curve does not have to start where the Path ends or, for an empty Path, at its defined starting point.
     *
     * @method Phaser.Curves.Path#add
     * @since 3.0.0
     *
     * @param {Phaser.Curves.Curve} curve - The Curve to append.
     *
     * @return {this} This Path object.
     */ add: function(curve) {
                    this.curves.push(curve);
                    return this;
                },
                /**
     * Creates a circular Ellipse Curve positioned at the end of the Path.
     *
     * @method Phaser.Curves.Path#circleTo
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {boolean} [clockwise=false] - `true` to create a clockwise circle as opposed to a counter-clockwise circle.
     * @param {number} [rotation=0] - The rotation of the circle in degrees.
     *
     * @return {this} This Path object.
     */ circleTo: function(radius, clockwise, rotation) {
                    if (clockwise === undefined) clockwise = false;
                    return this.ellipseTo(radius, radius, 0, 360, clockwise, rotation);
                },
                /**
     * Ensures that the Path is closed.
     *
     * A closed Path starts and ends at the same point. If the Path is not closed, a straight Line Curve will be created from the ending point directly to the starting point. During the check, the actual starting point of the Path, i.e. the starting point of the first Curve, will be used as opposed to the Path's defined {@link startPoint}, which could differ.
     *
     * Calling this method on an empty Path will result in an error.
     *
     * @method Phaser.Curves.Path#closePath
     * @since 3.0.0
     *
     * @return {this} This Path object.
     */ closePath: function() {
                    // Add a line curve if start and end of lines are not connected
                    var startPoint = this.curves[0].getPoint(0);
                    var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                    if (!startPoint.equals(endPoint)) //  This will copy a reference to the vectors, which probably isn't sensible
                    this.curves.push(new LineCurve(endPoint, startPoint));
                    return this;
                },
                /**
     * Creates a cubic bezier curve starting at the previous end point and ending at p3, using p1 and p2 as control points.
     *
     * @method Phaser.Curves.Path#cubicBezierTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The x coordinate of the end point. Or, if a Vector2, the p1 value.
     * @param {(number|Phaser.Math.Vector2)} y - The y coordinate of the end point. Or, if a Vector2, the p2 value.
     * @param {(number|Phaser.Math.Vector2)} control1X - The x coordinate of the first control point. Or, if a Vector2, the p3 value.
     * @param {number} [control1Y] - The y coordinate of the first control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2X] - The x coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     * @param {number} [control2Y] - The y coordinate of the second control point. Not used if Vector2s are provided as the first 3 arguments.
     *
     * @return {this} This Path object.
     */ cubicBezierTo: function(x, y, control1X, control1Y, control2X, control2Y) {
                    var p0 = this.getEndPoint();
                    var p1;
                    var p2;
                    var p3;
                    //  Assume they're all Vector2s
                    if (x instanceof Vector2) {
                        p1 = x;
                        p2 = y;
                        p3 = control1X;
                    } else {
                        p1 = new Vector2(control1X, control1Y);
                        p2 = new Vector2(control2X, control2Y);
                        p3 = new Vector2(x, y);
                    }
                    return this.add(new CubicBezierCurve(p0, p1, p2, p3));
                },
                //  Creates a quadratic bezier curve starting at the previous end point and ending at p2, using p1 as a control point
                /**
     * Creates a Quadratic Bezier Curve starting at the ending point of the Path.
     *
     * @method Phaser.Curves.Path#quadraticBezierTo
     * @since 3.2.0
     *
     * @param {(number|Phaser.Math.Vector2[])} x - The X coordinate of the second control point or, if it's a `Vector2`, the first control point.
     * @param {number} [y] - The Y coordinate of the second control point or, if `x` is a `Vector2`, the second control point.
     * @param {number} [controlX] - If `x` is not a `Vector2`, the X coordinate of the first control point.
     * @param {number} [controlY] - If `x` is not a `Vector2`, the Y coordinate of the first control point.
     *
     * @return {this} This Path object.
     */ quadraticBezierTo: function(x, y, controlX, controlY) {
                    var p0 = this.getEndPoint();
                    var p1;
                    var p2;
                    //  Assume they're all Vector2s
                    if (x instanceof Vector2) {
                        p1 = x;
                        p2 = y;
                    } else {
                        p1 = new Vector2(controlX, controlY);
                        p2 = new Vector2(x, y);
                    }
                    return this.add(new QuadraticBezierCurve(p0, p1, p2));
                },
                /**
     * Draws all Curves in the Path to a Graphics Game Object.
     *
     * @method Phaser.Curves.Path#draw
     * @since 3.0.0
     *
     * @generic {Phaser.GameObjects.Graphics} G - [out,$return]
     *
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics Game Object to draw to.
     * @param {number} [pointsTotal=32] - The number of points to draw for each Curve. Higher numbers result in a smoother curve but require more processing.
     *
     * @return {Phaser.GameObjects.Graphics} The Graphics object which was drawn to.
     */ draw: function(graphics, pointsTotal) {
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        curve.draw(graphics, pointsTotal);
                    }
                    return graphics;
                },
                /**
     * Creates an ellipse curve positioned at the previous end point, using the given parameters.
     *
     * @method Phaser.Curves.Path#ellipseTo
     * @since 3.0.0
     *
     * @param {number} [xRadius=0] - The horizontal radius of ellipse.
     * @param {number} [yRadius=0] - The vertical radius of ellipse.
     * @param {number} [startAngle=0] - The start angle of the ellipse, in degrees.
     * @param {number} [endAngle=360] - The end angle of the ellipse, in degrees.
     * @param {boolean} [clockwise=false] - Whether the ellipse angles are given as clockwise (`true`) or counter-clockwise (`false`).
     * @param {number} [rotation=0] - The rotation of the ellipse, in degrees.
     *
     * @return {this} This Path object.
     */ ellipseTo: function(xRadius, yRadius, startAngle, endAngle, clockwise, rotation) {
                    var ellipse = new EllipseCurve(0, 0, xRadius, yRadius, startAngle, endAngle, clockwise, rotation);
                    var end = this.getEndPoint(this._tmpVec2A);
                    //  Calculate where to center the ellipse
                    var start = ellipse.getStartPoint(this._tmpVec2B);
                    end.subtract(start);
                    ellipse.x = end.x;
                    ellipse.y = end.y;
                    return this.add(ellipse);
                },
                /**
     * Creates a Path from a Path Configuration object.
     *
     * The provided object should be a {@link Phaser.Types.Curves.JSONPath}, as returned by {@link #toJSON}. Providing a malformed object may cause errors.
     *
     * @method Phaser.Curves.Path#fromJSON
     * @since 3.0.0
     *
     * @param {Phaser.Types.Curves.JSONPath} data - The JSON object containing the Path data.
     *
     * @return {this} This Path object.
     */ fromJSON: function(data) {
                    //  data should be an object matching the Path.toJSON object structure.
                    this.curves = [];
                    this.cacheLengths = [];
                    this.startPoint.set(data.x, data.y);
                    this.autoClose = data.autoClose;
                    for(var i = 0; i < data.curves.length; i++){
                        var curve = data.curves[i];
                        switch(curve.type){
                            case 'LineCurve':
                                this.add(LineCurve.fromJSON(curve));
                                break;
                            case 'EllipseCurve':
                                this.add(EllipseCurve.fromJSON(curve));
                                break;
                            case 'SplineCurve':
                                this.add(SplineCurve.fromJSON(curve));
                                break;
                            case 'CubicBezierCurve':
                                this.add(CubicBezierCurve.fromJSON(curve));
                                break;
                            case 'QuadraticBezierCurve':
                                this.add(QuadraticBezierCurve.fromJSON(curve));
                                break;
                        }
                    }
                    return this;
                },
                /**
     * Returns a Rectangle with a position and size matching the bounds of this Path.
     *
     * @method Phaser.Curves.Path#getBounds
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in.
     * @param {number} [accuracy=16] - The accuracy of the bounds calculations. Higher values are more accurate at the cost of calculation speed.
     *
     * @return {Phaser.Geom.Rectangle} The modified `out` Rectangle, or a new Rectangle if none was provided.
     */ getBounds: function(out, accuracy) {
                    if (out === undefined) out = new Rectangle();
                    if (accuracy === undefined) accuracy = 16;
                    out.x = Number.MAX_VALUE;
                    out.y = Number.MAX_VALUE;
                    var bounds = new Rectangle();
                    var maxRight = MATH_CONST.MIN_SAFE_INTEGER;
                    var maxBottom = MATH_CONST.MIN_SAFE_INTEGER;
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        curve.getBounds(bounds, accuracy);
                        out.x = Math.min(out.x, bounds.x);
                        out.y = Math.min(out.y, bounds.y);
                        maxRight = Math.max(maxRight, bounds.right);
                        maxBottom = Math.max(maxBottom, bounds.bottom);
                    }
                    out.right = maxRight;
                    out.bottom = maxBottom;
                    return out;
                },
                /**
     * Returns an array containing the length of the Path at the end of each Curve.
     *
     * The result of this method will be cached to avoid recalculating it in subsequent calls. The cache is only invalidated when the {@link #curves} array changes in length, leading to potential inaccuracies if a Curve in the Path is changed, or if a Curve is removed and another is added in its place.
     *
     * @method Phaser.Curves.Path#getCurveLengths
     * @since 3.0.0
     *
     * @return {number[]} An array containing the length of the Path at the end of each one of its Curves.
     */ getCurveLengths: function() {
                    // We use cache values if curves and cache array are same length
                    if (this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                    // Get length of sub-curve
                    // Push sums into cached array
                    var lengths = [];
                    var sums = 0;
                    for(var i = 0; i < this.curves.length; i++){
                        sums += this.curves[i].getLength();
                        lengths.push(sums);
                    }
                    this.cacheLengths = lengths;
                    return lengths;
                },
                /**
     * Returns the ending point of the Path.
     *
     * A Path's ending point is equivalent to the ending point of the last Curve in the Path. For an empty Path, the ending point is at the Path's defined {@link #startPoint}.
     *
     * @method Phaser.Curves.Path#getEndPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - The object to store the point in.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getEndPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    if (this.curves.length > 0) this.curves[this.curves.length - 1].getPoint(1, out);
                    else out.copy(this.startPoint);
                    return out;
                },
                /**
     * Returns the total length of the Path.
     *
     * @see {@link #getCurveLengths}
     *
     * @method Phaser.Curves.Path#getLength
     * @since 3.0.0
     *
     * @return {number} The total length of the Path.
     */ getLength: function() {
                    var lens = this.getCurveLengths();
                    return lens[lens.length - 1];
                },
                // To get accurate point with reference to
                // entire path distance at time t,
                // following has to be done:
                // 1. Length of each sub path have to be known
                // 2. Locate and identify type of curve
                // 3. Get t for the curve
                // 4. Return curve.getPointAt(t')
                /**
     * Calculates the coordinates of the point at the given normalized location (between 0 and 1) on the Path.
     *
     * The location is relative to the entire Path, not to an individual Curve. A location of 0.5 is always in the middle of the Path and is thus an equal distance away from both its starting and ending points. In a Path with one Curve, it would be in the middle of the Curve; in a Path with two Curves, it could be anywhere on either one of them depending on their lengths.
     *
     * @method Phaser.Curves.Path#getPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The location of the point to return, between 0 and 1.
     * @param {Phaser.Math.Vector2} [out] - The object in which to store the calculated point.
     *
     * @return {?Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getPoint: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var d = t * this.getLength();
                    var curveLengths = this.getCurveLengths();
                    var i = 0;
                    while(i < curveLengths.length){
                        if (curveLengths[i] >= d) {
                            var diff = curveLengths[i] - d;
                            var curve = this.curves[i];
                            var segmentLength = curve.getLength();
                            var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                            return curve.getPointAt(u, out);
                        }
                        i++;
                    }
                    // loop where sum != 0, sum > d , sum+1 <d
                    return null;
                },
                /**
     * Get a sequence of points on the path.
     *
     * @method Phaser.Curves.Path#getPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=12] - The number of divisions per resolution per curve.
     *
     * @return {Phaser.Math.Vector2[]} An array of Vector2 objects that containing the points along the Path.
     */ getPoints: function(divisions) {
                    if (divisions === undefined) divisions = 12;
                    var points = [];
                    var last;
                    for(var i = 0; i < this.curves.length; i++){
                        var curve = this.curves[i];
                        if (!curve.active) continue;
                        var resolution = curve.getResolution(divisions);
                        var pts = curve.getPoints(resolution);
                        for(var j = 0; j < pts.length; j++){
                            var point = pts[j];
                            if (last && last.equals(point)) continue;
                            points.push(point);
                            last = point;
                        }
                    }
                    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                    return points;
                },
                /**
     * Returns a randomly chosen point anywhere on the path. This follows the same rules as `getPoint` in that it may return a point on any Curve inside this path.
     *
     * When calling this method multiple times, the points are not guaranteed to be equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getRandomPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new `Vector2` if none was provided.
     */ getRandomPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return this.getPoint(Math.random(), out);
                },
                /**
     * Divides this Path into a set of equally spaced points,
     *
     * The resulting points are equally spaced with respect to the points' position on the path, but not necessarily equally spaced spatially.
     *
     * @method Phaser.Curves.Path#getSpacedPoints
     * @since 3.0.0
     *
     * @param {number} [divisions=40] - The amount of points to divide this Path into.
     *
     * @return {Phaser.Math.Vector2[]} A list of the points this path was subdivided into.
     */ getSpacedPoints: function(divisions) {
                    if (divisions === undefined) divisions = 40;
                    var points = [];
                    for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                    if (this.autoClose) points.push(points[0]);
                    return points;
                },
                /**
     * Returns the starting point of the Path.
     *
     * @method Phaser.Curves.Path#getStartPoint
     * @since 3.0.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {Phaser.Math.Vector2} [out] - `Vector2` instance that should be used for storing the result. If `undefined` a new `Vector2` will be created.
     *
     * @return {Phaser.Math.Vector2} The modified `out` object, or a new Vector2 if none was provided.
     */ getStartPoint: function(out) {
                    if (out === undefined) out = new Vector2();
                    return out.copy(this.startPoint);
                },
                /**
     * Gets a unit vector tangent at a relative position on the path.
     *
     * @method Phaser.Curves.Path#getTangent
     * @since 3.23.0
     *
     * @generic {Phaser.Math.Vector2} O - [out,$return]
     *
     * @param {number} t - The relative position on the path, [0..1].
     * @param {Phaser.Math.Vector2} [out] - A vector to store the result in.
     *
     * @return {Phaser.Math.Vector2} Vector approximating the tangent line at the point t (delta +/- 0.0001)
     */ getTangent: function(t, out) {
                    if (out === undefined) out = new Vector2();
                    var d = t * this.getLength();
                    var curveLengths = this.getCurveLengths();
                    var i = 0;
                    while(i < curveLengths.length){
                        if (curveLengths[i] >= d) {
                            var diff = curveLengths[i] - d;
                            var curve = this.curves[i];
                            var segmentLength = curve.getLength();
                            var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                            return curve.getTangentAt(u, out);
                        }
                        i++;
                    }
                    return null;
                },
                /**
     * Creates a line curve from the previous end point to x/y.
     *
     * @method Phaser.Curves.Path#lineTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The X coordinate of the line's end point, or a `Vector2` containing the entire end point.
     * @param {number} [y] - The Y coordinate of the line's end point, if a number was passed as the X parameter.
     *
     * @return {this} This Path object.
     */ lineTo: function(x, y) {
                    if (x instanceof Vector2) this._tmpVec2B.copy(x);
                    else this._tmpVec2B.set(x, y);
                    var end = this.getEndPoint(this._tmpVec2A);
                    return this.add(new LineCurve([
                        end.x,
                        end.y,
                        this._tmpVec2B.x,
                        this._tmpVec2B.y
                    ]));
                },
                /**
     * Creates a spline curve starting at the previous end point, using the given points on the curve.
     *
     * @method Phaser.Curves.Path#splineTo
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2[]} points - The points the newly created spline curve should consist of.
     *
     * @return {this} This Path object.
     */ splineTo: function(points) {
                    points.unshift(this.getEndPoint());
                    return this.add(new SplineCurve(points));
                },
                /**
     * Creates a "gap" in this path from the path's current end point to the given coordinates.
     *
     * After calling this function, this Path's end point will be equal to the given coordinates
     *
     * @method Phaser.Curves.Path#moveTo
     * @since 3.0.0
     *
     * @param {(number|Phaser.Math.Vector2)} x - The X coordinate of the position to move the path's end point to, or a `Vector2` containing the entire new end point.
     * @param {number} [y] - The Y coordinate of the position to move the path's end point to, if a number was passed as the X coordinate.
     *
     * @return {this} This Path object.
     */ moveTo: function(x, y) {
                    if (x instanceof Vector2) return this.add(new MovePathTo(x.x, x.y));
                    else return this.add(new MovePathTo(x, y));
                },
                /**
     * Converts this Path to a JSON object containing the path information and its constituent curves.
     *
     * @method Phaser.Curves.Path#toJSON
     * @since 3.0.0
     *
     * @return {Phaser.Types.Curves.JSONPath} The JSON object containing this path's data.
     */ toJSON: function() {
                    var out = [];
                    for(var i = 0; i < this.curves.length; i++)out.push(this.curves[i].toJSON());
                    return {
                        type: 'Path',
                        x: this.startPoint.x,
                        y: this.startPoint.y,
                        autoClose: this.autoClose,
                        curves: out
                    };
                },
                /**
     * cacheLengths must be recalculated.
     *
     * @method Phaser.Curves.Path#updateArcLengths
     * @since 3.0.0
     */ updateArcLengths: function() {
                    this.cacheLengths = [];
                    this.getCurveLengths();
                },
                /**
     * Disposes of this Path, clearing its internal references to objects so they can be garbage-collected.
     *
     * @method Phaser.Curves.Path#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.curves.length = 0;
                    this.cacheLengths.length = 0;
                    this.startPoint = undefined;
                }
            });
            /**
 * Creates a new Path Object.
 *
 * @method Phaser.GameObjects.GameObjectFactory#path
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Path.
 * @param {number} y - The vertical position of this Path.
 *
 * @return {Phaser.Curves.Path} The Path Object that was created.
 */ GameObjectFactory.register('path', function(x, y) {
                return new Path(x, y);
            });
            //  When registering a factory function 'this' refers to the GameObjectFactory context.
            //
            //  There are several properties available to use:
            //
            //  this.scene - a reference to the Scene that owns the GameObjectFactory
            //  this.displayList - a reference to the Display List the Scene owns
            //  this.updateList - a reference to the Update List the Scene owns
            module1.exports = Path;
        /***/ },
        /* 892 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Data
 */ module1.exports = {
                DataManager: __webpack_require__(98),
                DataManagerPlugin: __webpack_require__(893),
                Events: __webpack_require__(309)
            };
        /***/ },
        /* 893 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DataManager = __webpack_require__(98);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * The Data Component features a means to store pieces of data specific to a Game Object, System or Plugin.
 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
 * or have a property called `events` that is an instance of it.
 *
 * @class DataManagerPlugin
 * @extends Phaser.Data.DataManager
 * @memberof Phaser.Data
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this DataManager belongs to.
 */ var DataManagerPlugin = new Class({
                Extends: DataManager,
                initialize: function DataManagerPlugin(scene) {
                    DataManager.call(this, scene, scene.sys.events);
                    /**
         * A reference to the Scene that this DataManager belongs to.
         *
         * @name Phaser.Data.DataManagerPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene's Systems.
         *
         * @name Phaser.Data.DataManagerPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.events = this.systems.events;
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Data.DataManagerPlugin#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Data.DataManagerPlugin#shutdown
     * @private
     * @since 3.5.0
     */ shutdown: function() {
                    this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Data.DataManagerPlugin#destroy
     * @since 3.5.0
     */ destroy: function() {
                    DataManager.prototype.destroy.call(this);
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('DataManagerPlugin', DataManagerPlugin, 'data');
            module1.exports = DataManagerPlugin;
        /***/ },
        /* 894 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display
 */ module1.exports = {
                Align: __webpack_require__(895),
                BaseShader: __webpack_require__(390),
                Bounds: __webpack_require__(898),
                Canvas: __webpack_require__(902),
                Color: __webpack_require__(391),
                ColorMatrix: __webpack_require__(195),
                Masks: __webpack_require__(912),
                RGB: __webpack_require__(197)
            };
        /***/ },
        /* 895 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(122);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Display.Align
 */ var Align = {
                In: __webpack_require__(896),
                To: __webpack_require__(897)
            };
            //   Merge in the consts
            Align = Extend(false, Align, CONST);
            module1.exports = Align;
        /***/ },
        /* 896 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.In
 */ module1.exports = {
                BottomCenter: __webpack_require__(284),
                BottomLeft: __webpack_require__(285),
                BottomRight: __webpack_require__(286),
                Center: __webpack_require__(287),
                LeftCenter: __webpack_require__(289),
                QuickSet: __webpack_require__(283),
                RightCenter: __webpack_require__(290),
                TopCenter: __webpack_require__(291),
                TopLeft: __webpack_require__(292),
                TopRight: __webpack_require__(293)
            };
        /***/ },
        /* 897 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Align.To
 */ module1.exports = {
                BottomCenter: __webpack_require__(271),
                BottomLeft: __webpack_require__(272),
                BottomRight: __webpack_require__(273),
                LeftBottom: __webpack_require__(274),
                LeftCenter: __webpack_require__(275),
                LeftTop: __webpack_require__(276),
                QuickSet: __webpack_require__(270),
                RightBottom: __webpack_require__(277),
                RightCenter: __webpack_require__(278),
                RightTop: __webpack_require__(279),
                TopCenter: __webpack_require__(280),
                TopLeft: __webpack_require__(281),
                TopRight: __webpack_require__(282)
            };
        /***/ },
        /* 898 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Bounds
 */ module1.exports = {
                CenterOn: __webpack_require__(288),
                GetBottom: __webpack_require__(40),
                GetBounds: __webpack_require__(899),
                GetCenterX: __webpack_require__(84),
                GetCenterY: __webpack_require__(86),
                GetLeft: __webpack_require__(41),
                GetOffsetX: __webpack_require__(900),
                GetOffsetY: __webpack_require__(901),
                GetRight: __webpack_require__(42),
                GetTop: __webpack_require__(43),
                SetBottom: __webpack_require__(54),
                SetCenterX: __webpack_require__(85),
                SetCenterY: __webpack_require__(87),
                SetLeft: __webpack_require__(52),
                SetRight: __webpack_require__(53),
                SetTop: __webpack_require__(51)
            };
        /***/ },
        /* 899 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetBottom = __webpack_require__(40);
            var GetLeft = __webpack_require__(41);
            var GetRight = __webpack_require__(42);
            var GetTop = __webpack_require__(43);
            /**
 * Returns the unrotated bounds of the Game Object as a rectangle.
 *
 * @function Phaser.Display.Bounds.GetBounds
 * @since 3.24.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in.
 *
 * @return {(Phaser.Geom.Rectangle|object)} - The bounds of the Game Object.
 */ var GetBounds = function(gameObject, output) {
                if (output === undefined) output = {};
                var left = GetLeft(gameObject);
                var top = GetTop(gameObject);
                output.x = left;
                output.y = top;
                output.width = GetRight(gameObject) - left;
                output.height = GetBottom(gameObject) - top;
                return output;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 900 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its x coordinate.
 * This is the same as `width * origin.x`.
 * This value will only be > 0 if `origin.x` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetX
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The horizontal offset of the Game Object.
 */ var GetOffsetX = function(gameObject) {
                return gameObject.width * gameObject.originX;
            };
            module1.exports = GetOffsetX;
        /***/ },
        /* 901 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns the amount the Game Object is visually offset from its y coordinate.
 * This is the same as `width * origin.y`.
 * This value will only be > 0 if `origin.y` is not equal to zero.
 *
 * @function Phaser.Display.Bounds.GetOffsetY
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
 *
 * @return {number} The vertical offset of the Game Object.
 */ var GetOffsetY = function(gameObject) {
                return gameObject.height * gameObject.originY;
            };
            module1.exports = GetOffsetY;
        /***/ },
        /* 902 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Canvas
 */ module1.exports = {
                CanvasInterpolation: __webpack_require__(361),
                CanvasPool: __webpack_require__(31),
                Smoothing: __webpack_require__(189),
                TouchAction: __webpack_require__(903),
                UserSelect: __webpack_require__(904)
            };
        /***/ },
        /* 903 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the touch-action property on the canvas style. Can be used to disable default browser touch actions.
 *
 * @function Phaser.Display.Canvas.TouchAction
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch action value to set on the canvas. Set to `none` to disable touch actions.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var TouchAction = function(canvas, value) {
                if (value === undefined) value = 'none';
                canvas.style['msTouchAction'] = value;
                canvas.style['ms-touch-action'] = value;
                canvas.style['touch-action'] = value;
                return canvas;
            };
            module1.exports = TouchAction;
        /***/ },
        /* 904 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets the user-select property on the canvas style. Can be used to disable default browser selection actions.
 *
 * @function Phaser.Display.Canvas.UserSelect
 * @since 3.0.0
 *
 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
 * @param {string} [value='none'] - The touch callout value to set on the canvas. Set to `none` to disable touch callouts.
 *
 * @return {HTMLCanvasElement} The canvas element.
 */ var UserSelect = function(canvas, value) {
                if (value === undefined) value = 'none';
                var vendors = [
                    '-webkit-',
                    '-khtml-',
                    '-moz-',
                    '-ms-',
                    ''
                ];
                vendors.forEach(function(vendor) {
                    canvas.style[vendor + 'user-select'] = value;
                });
                canvas.style['-webkit-touch-callout'] = value;
                canvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';
                return canvas;
            };
            module1.exports = UserSelect;
        /***/ },
        /* 905 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetColor = __webpack_require__(100);
            /**
 * Return an array of Colors in a Color Spectrum.
 *
 * The spectrum colors flow in the order: red, yellow, green, blue.
 *
 * By default this function will return an array with 1024 elements in.
 *
 * However, you can reduce this to a smaller quantity if needed, by specitying the `limit` parameter.
 *
 * @function Phaser.Display.Color.ColorSpectrum
 * @since 3.50.0
 *
 * @param {number} [limit=1024] - How many colors should be returned? The maximum is 1024 but you can set a smaller quantity if required.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing `limit` parameter number of elements, where each contains a Color Object.
 */ var ColorSpectrum = function(limit) {
                if (limit === undefined) limit = 1024;
                var colors = [];
                var range = 255;
                var i;
                var r = 255;
                var g = 0;
                var b = 0;
                //  Red to Yellow
                for(i = 0; i <= range; i++)colors.push({
                    r: r,
                    g: i,
                    b: b,
                    color: GetColor(r, i, b)
                });
                g = 255;
                //  Yellow to Green
                for(i = range; i >= 0; i--)colors.push({
                    r: i,
                    g: g,
                    b: b,
                    color: GetColor(i, g, b)
                });
                r = 0;
                //  Green to Blue
                for(i = 0; i <= range; i++, g--)colors.push({
                    r: r,
                    g: g,
                    b: i,
                    color: GetColor(r, g, i)
                });
                g = 0;
                b = 255;
                //  Blue to Red
                for(i = 0; i <= range; i++, b--, r++)colors.push({
                    r: r,
                    g: g,
                    b: b,
                    color: GetColor(r, g, b)
                });
                if (limit === 1024) return colors;
                else {
                    var out = [];
                    var t = 0;
                    var inc = 1024 / limit;
                    for(i = 0; i < limit; i++){
                        out.push(colors[Math.floor(t)]);
                        t += inc;
                    }
                    return out;
                }
            };
            module1.exports = ColorSpectrum;
        /***/ },
        /* 906 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Converts the given color value into an Object containing r,g,b and a properties.
 *
 * @function Phaser.Display.Color.ColorToRGBA
 * @since 3.0.0
 *
 * @param {number} color - A color value, optionally including the alpha value.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the parsed color values.
 */ var ColorToRGBA = function(color) {
                var output = {
                    r: color >> 16 & 0xFF,
                    g: color >> 8 & 0xFF,
                    b: color & 0xFF,
                    a: 255
                };
                if (color > 16777215) output.a = color >>> 24;
                return output;
            };
            module1.exports = ColorToRGBA;
        /***/ },
        /* 907 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Color = __webpack_require__(37);
            var HueToComponent = __webpack_require__(393);
            /**
 * Converts HSL (hue, saturation and lightness) values to a Phaser Color object.
 *
 * @function Phaser.Display.Color.HSLToColor
 * @since 3.0.0
 *
 * @param {number} h - The hue value in the range 0 to 1.
 * @param {number} s - The saturation value in the range 0 to 1.
 * @param {number} l - The lightness value in the range 0 to 1.
 *
 * @return {Phaser.Display.Color} A Color object created from the results of the h, s and l values.
 */ var HSLToColor = function(h, s, l) {
                // achromatic by default
                var r = l;
                var g = l;
                var b = l;
                if (s !== 0) {
                    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    var p = 2 * l - q;
                    r = HueToComponent(p, q, h + 1 / 3);
                    g = HueToComponent(p, q, h);
                    b = HueToComponent(p, q, h - 1 / 3);
                }
                var color = new Color();
                return color.setGLTo(r, g, b, 1);
            };
            module1.exports = HSLToColor;
        /***/ },
        /* 908 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HSVToRGB = __webpack_require__(185);
            /**
 * Get HSV color wheel values in an array which will be 360 elements in size.
 *
 * @function Phaser.Display.Color.HSVColorWheel
 * @since 3.0.0
 *
 * @param {number} [s=1] - The saturation, in the range 0 - 1.
 * @param {number} [v=1] - The value, in the range 0 - 1.
 *
 * @return {Phaser.Types.Display.ColorObject[]} An array containing 360 elements, where each contains a single numeric value corresponding to the color at that point in the HSV color wheel.
 */ var HSVColorWheel = function(s, v) {
                if (s === undefined) s = 1;
                if (v === undefined) v = 1;
                var colors = [];
                for(var c = 0; c <= 359; c++)colors.push(HSVToRGB(c / 359, s, v));
                return colors;
            };
            module1.exports = HSVColorWheel;
        /***/ },
        /* 909 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Linear = __webpack_require__(133);
            /**
 * @namespace Phaser.Display.Color.Interpolate
 * @memberof Phaser.Display.Color
 * @since 3.0.0
 */ /**
 * Interpolates between the two given color ranges over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.RGBWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {number} r1 - Red value.
 * @param {number} g1 - Blue value.
 * @param {number} b1 - Green value.
 * @param {number} r2 - Red value.
 * @param {number} g2 - Blue value.
 * @param {number} b2 - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var RGBWithRGB = function(r1, g1, b1, r2, g2, b2, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                var t = index / length;
                return {
                    r: Linear(r1, r2, t),
                    g: Linear(g1, g2, t),
                    b: Linear(b1, b2, t)
                };
            };
            /**
 * Interpolates between the two given color objects over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithColor
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {Phaser.Display.Color} color2 - The second Color object.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithColor = function(color1, color2, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                return RGBWithRGB(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b, length, index);
            };
            /**
 * Interpolates between the Color object and color values over the length supplied.
 *
 * @function Phaser.Display.Color.Interpolate.ColorWithRGB
 * @memberof Phaser.Display.Color.Interpolate
 * @static
 * @since 3.0.0
 *
 * @param {Phaser.Display.Color} color1 - The first Color object.
 * @param {number} r - Red value.
 * @param {number} g - Blue value.
 * @param {number} b - Green value.
 * @param {number} [length=100] - Distance to interpolate over.
 * @param {number} [index=0] - Index to start from.
 *
 * @return {Phaser.Types.Display.ColorObject} An object containing the interpolated color values.
 */ var ColorWithRGB = function(color, r, g, b, length, index) {
                if (length === undefined) length = 100;
                if (index === undefined) index = 0;
                return RGBWithRGB(color.r, color.g, color.b, r, g, b, length, index);
            };
            module1.exports = {
                RGBWithRGB: RGBWithRGB,
                ColorWithRGB: ColorWithRGB,
                ColorWithColor: ColorWithColor
            };
        /***/ },
        /* 910 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(192);
            var Color = __webpack_require__(37);
            /**
 * Creates a new Color object where the r, g, and b values have been set to random values
 * based on the given min max values.
 *
 * @function Phaser.Display.Color.RandomRGB
 * @since 3.0.0
 *
 * @param {number} [min=0] - The minimum value to set the random range from (between 0 and 255)
 * @param {number} [max=255] - The maximum value to set the random range from (between 0 and 255)
 *
 * @return {Phaser.Display.Color} A Color object.
 */ var RandomRGB = function(min, max) {
                if (min === undefined) min = 0;
                if (max === undefined) max = 255;
                return new Color(Between(min, max), Between(min, max), Between(min, max));
            };
            module1.exports = RandomRGB;
        /***/ },
        /* 911 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ComponentToHex = __webpack_require__(392);
            /**
 * Converts the color values into an HTML compatible color string, prefixed with either `#` or `0x`.
 *
 * @function Phaser.Display.Color.RGBToString
 * @since 3.0.0
 *
 * @param {number} r - The red color value. A number between 0 and 255.
 * @param {number} g - The green color value. A number between 0 and 255.
 * @param {number} b - The blue color value. A number between 0 and 255.
 * @param {number} [a=255] - The alpha value. A number between 0 and 255.
 * @param {string} [prefix=#] - The prefix of the string. Either `#` or `0x`.
 *
 * @return {string} A string-based representation of the color values.
 */ var RGBToString = function(r, g, b, a, prefix) {
                if (a === undefined) a = 255;
                if (prefix === undefined) prefix = '#';
                if (prefix === '#') return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
                else return '0x' + ComponentToHex(a) + ComponentToHex(r) + ComponentToHex(g) + ComponentToHex(b);
            };
            module1.exports = RGBToString;
        /***/ },
        /* 912 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Display.Masks
 */ module1.exports = {
                BitmapMask: __webpack_require__(304),
                GeometryMask: __webpack_require__(305)
            };
        /***/ },
        /* 913 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.DOM
 */ var Dom = {
                AddToDOM: __webpack_require__(140),
                DOMContentLoaded: __webpack_require__(394),
                GetInnerHeight: __webpack_require__(395),
                GetScreenOrientation: __webpack_require__(396),
                GetTarget: __webpack_require__(401),
                ParseXML: __webpack_require__(402),
                RemoveFromDOM: __webpack_require__(199),
                RequestAnimationFrame: __webpack_require__(380)
            };
            module1.exports = Dom;
        /***/ },
        /* 914 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Events
 */ module1.exports = {
                EventEmitter: __webpack_require__(915)
            };
        /***/ },
        /* 915 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EE = __webpack_require__(9);
            var PluginCache = __webpack_require__(24);
            /**
 * @classdesc
 * EventEmitter is a Scene Systems plugin compatible version of eventemitter3.
 *
 * @class EventEmitter
 * @memberof Phaser.Events
 * @constructor
 * @since 3.0.0
 */ var EventEmitter = new Class({
                Extends: EE,
                initialize: function EventEmitter() {
                    EE.call(this);
                },
                /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.removeAllListeners();
                },
                /**
     * Removes all listeners.
     *
     * @method Phaser.Events.EventEmitter#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.removeAllListeners();
                }
            });
            /**
 * Return an array listing the events for which the emitter has registered listeners.
 *
 * @method Phaser.Events.EventEmitter#eventNames
 * @since 3.0.0
 *
 * @return {Array.<string|symbol>}
 */ /**
 * Return the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#listeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {Function[]} The registered listeners.
 */ /**
 * Return the number of listeners listening to a given event.
 *
 * @method Phaser.Events.EventEmitter#listenerCount
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 *
 * @return {number} The number of listeners.
 */ /**
 * Calls each of the listeners registered for a given event.
 *
 * @method Phaser.Events.EventEmitter#emit
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {...*} [args] - Additional arguments that will be passed to the event handler.
 *
 * @return {boolean} `true` if the event had listeners, else `false`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#on
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#addListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Add a one-time listener for a given event.
 *
 * @method Phaser.Events.EventEmitter#once
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} fn - The listener function.
 * @param {*} [context=this] - The context to invoke the listener with.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#removeListener
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove the listeners of a given event.
 *
 * @method Phaser.Events.EventEmitter#off
 * @since 3.0.0
 *
 * @param {(string|symbol)} event - The event name.
 * @param {function} [fn] - Only remove the listeners that match this function.
 * @param {*} [context] - Only remove the listeners that have this context.
 * @param {boolean} [once] - Only remove one-time listeners.
 *
 * @return {this} `this`.
 */ /**
 * Remove all listeners, or those of the specified event.
 *
 * @method Phaser.Events.EventEmitter#removeAllListeners
 * @since 3.0.0
 *
 * @param {(string|symbol)} [event] - The event name.
 *
 * @return {this} `this`.
 */ PluginCache.register('EventEmitter', EventEmitter, 'events');
            module1.exports = EventEmitter;
        /***/ },
        /* 916 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(140);
            var AnimationManager = __webpack_require__(315);
            var CacheManager = __webpack_require__(319);
            var CanvasPool = __webpack_require__(31);
            var Class = __webpack_require__(0);
            var Config = __webpack_require__(340);
            var CreateDOMContainer = __webpack_require__(917);
            var CreateRenderer = __webpack_require__(360);
            var DataManager = __webpack_require__(98);
            var DebugHeader = __webpack_require__(378);
            var Device = __webpack_require__(341);
            var DOMContentLoaded = __webpack_require__(394);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(22);
            var InputManager = __webpack_require__(403);
            var PluginCache = __webpack_require__(24);
            var PluginManager = __webpack_require__(408);
            var ScaleManager = __webpack_require__(409);
            var SceneManager = __webpack_require__(411);
            var TextureEvents = __webpack_require__(103);
            var TextureManager = __webpack_require__(416);
            var TimeStep = __webpack_require__(379);
            var VisibilityHandler = __webpack_require__(381);
            var SoundManagerCreator = __webpack_require__(420);
            var FacebookInstantGamesPlugin;
            /**
 * @classdesc
 * The Phaser.Game instance is the main controller for the entire Phaser game. It is responsible
 * for handling the boot process, parsing the configuration values, creating the renderer,
 * and setting-up all of the global Phaser systems, such as sound and input.
 * Once that is complete it will start the Scene Manager and then begin the main game loop.
 *
 * You should generally avoid accessing any of the systems created by Game, and instead use those
 * made available to you via the Phaser.Scene Systems class instead.
 *
 * @class Game
 * @memberof Phaser
 * @constructor
 * @fires Phaser.Core.Events#BLUR
 * @fires Phaser.Core.Events#FOCUS
 * @fires Phaser.Core.Events#HIDDEN
 * @fires Phaser.Core.Events#VISIBLE
 * @since 3.0.0
 *
 * @param {Phaser.Types.Core.GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
 */ var Game = new Class({
                initialize: function Game(config) {
                    /**
         * The parsed Game Configuration object.
         *
         * The values stored within this object are read-only and should not be changed at run-time.
         *
         * @name Phaser.Game#config
         * @type {Phaser.Core.Config}
         * @readonly
         * @since 3.0.0
         */ this.config = new Config(config);
                    /**
         * A reference to either the Canvas or WebGL Renderer that this Game is using.
         *
         * @name Phaser.Game#renderer
         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
         * @since 3.0.0
         */ this.renderer = null;
                    /**
         * A reference to an HTML Div Element used as the DOM Element Container.
         *
         * Only set if `createDOMContainer` is `true` in the game config (by default it is `false`) and
         * if you provide a parent element to insert the Phaser Game inside.
         *
         * See the DOM Element Game Object for more details.
         *
         * @name Phaser.Game#domContainer
         * @type {HTMLDivElement}
         * @since 3.17.0
         */ this.domContainer = null;
                    /**
         * A reference to the HTML Canvas Element that Phaser uses to render the game.
         * This is created automatically by Phaser unless you provide a `canvas` property
         * in your Game Config.
         *
         * @name Phaser.Game#canvas
         * @type {HTMLCanvasElement}
         * @since 3.0.0
         */ this.canvas = null;
                    /**
         * A reference to the Rendering Context belonging to the Canvas Element this game is rendering to.
         * If the game is running under Canvas it will be a 2d Canvas Rendering Context.
         * If the game is running under WebGL it will be a WebGL Rendering Context.
         * This context is created automatically by Phaser unless you provide a `context` property
         * in your Game Config.
         *
         * @name Phaser.Game#context
         * @type {(CanvasRenderingContext2D|WebGLRenderingContext)}
         * @since 3.0.0
         */ this.context = null;
                    /**
         * A flag indicating when this Game instance has finished its boot process.
         *
         * @name Phaser.Game#isBooted
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isBooted = false;
                    /**
         * A flag indicating if this Game is currently running its game step or not.
         *
         * @name Phaser.Game#isRunning
         * @type {boolean}
         * @readonly
         * @since 3.0.0
         */ this.isRunning = false;
                    /**
         * An Event Emitter which is used to broadcast game-level events from the global systems.
         *
         * @name Phaser.Game#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.0.0
         */ this.events = new EventEmitter();
                    /**
         * An instance of the Animation Manager.
         *
         * The Animation Manager is a global system responsible for managing all animations used within your game.
         *
         * @name Phaser.Game#anims
         * @type {Phaser.Animations.AnimationManager}
         * @since 3.0.0
         */ this.anims = new AnimationManager(this);
                    /**
         * An instance of the Texture Manager.
         *
         * The Texture Manager is a global system responsible for managing all textures being used by your game.
         *
         * @name Phaser.Game#textures
         * @type {Phaser.Textures.TextureManager}
         * @since 3.0.0
         */ this.textures = new TextureManager(this);
                    /**
         * An instance of the Cache Manager.
         *
         * The Cache Manager is a global system responsible for caching, accessing and releasing external game assets.
         *
         * @name Phaser.Game#cache
         * @type {Phaser.Cache.CacheManager}
         * @since 3.0.0
         */ this.cache = new CacheManager(this);
                    /**
         * An instance of the Data Manager
         *
         * @name Phaser.Game#registry
         * @type {Phaser.Data.DataManager}
         * @since 3.0.0
         */ this.registry = new DataManager(this);
                    /**
         * An instance of the Input Manager.
         *
         * The Input Manager is a global system responsible for the capture of browser-level input events.
         *
         * @name Phaser.Game#input
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.input = new InputManager(this, this.config);
                    /**
         * An instance of the Scene Manager.
         *
         * The Scene Manager is a global system responsible for creating, modifying and updating the Scenes in your game.
         *
         * @name Phaser.Game#scene
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.scene = new SceneManager(this, this.config.sceneConfig);
                    /**
         * A reference to the Device inspector.
         *
         * Contains information about the device running this game, such as OS, browser vendor and feature support.
         * Used by various systems to determine capabilities and code paths.
         *
         * @name Phaser.Game#device
         * @type {Phaser.DeviceConf}
         * @since 3.0.0
         */ this.device = Device;
                    /**
         * An instance of the Scale Manager.
         *
         * The Scale Manager is a global system responsible for handling scaling of the game canvas.
         *
         * @name Phaser.Game#scale
         * @type {Phaser.Scale.ScaleManager}
         * @since 3.16.0
         */ this.scale = new ScaleManager(this, this.config);
                    /**
         * An instance of the base Sound Manager.
         *
         * The Sound Manager is a global system responsible for the playback and updating of all audio in your game.
         *
         * You can disable the inclusion of the Sound Manager in your build by toggling the webpack `FEATURE_SOUND` flag.
         *
         * @name Phaser.Game#sound
         * @type {(Phaser.Sound.NoAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager|Phaser.Sound.WebAudioSoundManager)}
         * @since 3.0.0
         */ this.sound = null;
                    this.sound = SoundManagerCreator.create(this);
                    /**
         * An instance of the Time Step.
         *
         * The Time Step is a global system responsible for setting-up and responding to the browser frame events, processing
         * them and calculating delta values. It then automatically calls the game step.
         *
         * @name Phaser.Game#loop
         * @type {Phaser.Core.TimeStep}
         * @since 3.0.0
         */ this.loop = new TimeStep(this, this.config.fps);
                    /**
         * An instance of the Plugin Manager.
         *
         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
         * those plugins into Scenes as required.
         *
         * @name Phaser.Game#plugins
         * @type {Phaser.Plugins.PluginManager}
         * @since 3.0.0
         */ this.plugins = new PluginManager(this, this.config);
                    /**
         * Is this Game pending destruction at the start of the next frame?
         *
         * @name Phaser.Game#pendingDestroy
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.pendingDestroy = false;
                    /**
         * Remove the Canvas once the destroy is over?
         *
         * @name Phaser.Game#removeCanvas
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this.removeCanvas = false;
                    /**
         * Remove everything when the game is destroyed.
         * You cannot create a new Phaser instance on the same web page after doing this.
         *
         * @name Phaser.Game#noReturn
         * @type {boolean}
         * @private
         * @since 3.12.0
         */ this.noReturn = false;
                    /**
         * Does the window the game is running in currently have focus or not?
         * This is modified by the VisibilityHandler.
         *
         * @name Phaser.Game#hasFocus
         * @type {boolean}
         * @readonly
         * @since 3.9.0
         */ this.hasFocus = false;
                    //  Wait for the DOM Ready event, then call boot.
                    DOMContentLoaded(this.boot.bind(this));
                },
                /**
     * This method is called automatically when the DOM is ready. It is responsible for creating the renderer,
     * displaying the Debug Header, adding the game canvas to the DOM and emitting the 'boot' event.
     * It listens for a 'ready' event from the base systems and once received it will call `Game.start`.
     *
     * @method Phaser.Game#boot
     * @protected
     * @fires Phaser.Core.Events#BOOT
     * @listens Phaser.Textures.Events#READY
     * @since 3.0.0
     */ boot: function() {
                    if (!PluginCache.hasCore('EventEmitter')) {
                        console.warn('Aborting. Core Plugins missing.');
                        return;
                    }
                    this.isBooted = true;
                    this.config.preBoot(this);
                    this.scale.preBoot();
                    CreateRenderer(this);
                    CreateDOMContainer(this);
                    DebugHeader(this);
                    AddToDOM(this.canvas, this.config.parent);
                    //  The Texture Manager has to wait on a couple of non-blocking events before it's fully ready.
                    //  So it will emit this internal event when done:
                    this.textures.once(TextureEvents.READY, this.texturesReady, this);
                    this.events.emit(Events.BOOT);
                },
                /**
     * Called automatically when the Texture Manager has finished setting up and preparing the
     * default textures.
     *
     * @method Phaser.Game#texturesReady
     * @private
     * @fires Phaser.Game#READY
     * @since 3.12.0
     */ texturesReady: function() {
                    //  Start all the other systems
                    this.events.emit(Events.READY);
                    this.start();
                },
                /**
     * Called automatically by Game.boot once all of the global systems have finished setting themselves up.
     * By this point the Game is now ready to start the main loop running.
     * It will also enable the Visibility Handler.
     *
     * @method Phaser.Game#start
     * @protected
     * @since 3.0.0
     */ start: function() {
                    this.isRunning = true;
                    this.config.postBoot(this);
                    if (this.renderer) this.loop.start(this.step.bind(this));
                    else this.loop.start(this.headlessStep.bind(this));
                    VisibilityHandler(this);
                    var eventEmitter = this.events;
                    eventEmitter.on(Events.HIDDEN, this.onHidden, this);
                    eventEmitter.on(Events.VISIBLE, this.onVisible, this);
                    eventEmitter.on(Events.BLUR, this.onBlur, this);
                    eventEmitter.on(Events.FOCUS, this.onFocus, this);
                },
                /**
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * It will then render each Scene in turn, via the Renderer. This process emits `prerender` and `postrender` events.
     *
     * @method Phaser.Game#step
     * @fires Phaser.Core.Events#PRE_STEP
     * @fires Phaser.Core.Events#STEP
     * @fires Phaser.Core.Events#POST_STEP
     * @fires Phaser.Core.Events#PRE_RENDER
     * @fires Phaser.Core.Events#POST_RENDER
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var eventEmitter = this.events;
                    //  Global Managers like Input and Sound update in the prestep
                    eventEmitter.emit(Events.PRE_STEP, time, delta);
                    //  This is mostly meant for user-land code and plugins
                    eventEmitter.emit(Events.STEP, time, delta);
                    //  Update the Scene Manager and all active Scenes
                    this.scene.update(time, delta);
                    //  Our final event before rendering starts
                    eventEmitter.emit(Events.POST_STEP, time, delta);
                    var renderer = this.renderer;
                    //  Run the Pre-render (clearing the canvas, setting background colors, etc)
                    renderer.preRender();
                    eventEmitter.emit(Events.PRE_RENDER, renderer, time, delta);
                    //  The main render loop. Iterates all Scenes and all Cameras in those scenes, rendering to the renderer instance.
                    this.scene.render(renderer);
                    //  The Post-Render call. Tidies up loose end, takes snapshots, etc.
                    renderer.postRender();
                    //  The final event before the step repeats. Your last chance to do anything to the canvas before it all starts again.
                    eventEmitter.emit(Events.POST_RENDER, renderer, time, delta);
                },
                /**
     * A special version of the Game Step for the HEADLESS renderer only.
     *
     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
     * Request Animation Frame, or Set Timeout on very old browsers.)
     *
     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
     *
     * This process emits `prerender` and `postrender` events, even though nothing actually displays.
     *
     * @method Phaser.Game#headlessStep
     * @fires Phaser.Game#PRE_RENDER
     * @fires Phaser.Game#POST_RENDER
     * @since 3.2.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ headlessStep: function(time, delta) {
                    if (this.pendingDestroy) return this.runDestroy();
                    var eventEmitter = this.events;
                    //  Global Managers
                    eventEmitter.emit(Events.PRE_STEP, time, delta);
                    eventEmitter.emit(Events.STEP, time, delta);
                    //  Scenes
                    this.scene.update(time, delta);
                    eventEmitter.emit(Events.POST_STEP, time, delta);
                    //  Render
                    eventEmitter.emit(Events.PRE_RENDER);
                    eventEmitter.emit(Events.POST_RENDER);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will pause the main loop and then emit a pause event.
     *
     * @method Phaser.Game#onHidden
     * @protected
     * @fires Phaser.Core.Events#PAUSE
     * @since 3.0.0
     */ onHidden: function() {
                    this.loop.pause();
                    this.events.emit(Events.PAUSE);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will resume the main loop and then emit a resume event.
     *
     * @method Phaser.Game#onVisible
     * @protected
     * @fires Phaser.Core.Events#RESUME
     * @since 3.0.0
     */ onVisible: function() {
                    this.loop.resume();
                    this.events.emit(Events.RESUME);
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'blurred' state, which pauses it.
     *
     * @method Phaser.Game#onBlur
     * @protected
     * @since 3.0.0
     */ onBlur: function() {
                    this.hasFocus = false;
                    this.loop.blur();
                },
                /**
     * Called automatically by the Visibility Handler.
     * This will set the main loop into a 'focused' state, which resumes it.
     *
     * @method Phaser.Game#onFocus
     * @protected
     * @since 3.0.0
     */ onFocus: function() {
                    this.hasFocus = true;
                    this.loop.focus();
                },
                /**
     * Returns the current game frame.
     *
     * When the game starts running, the frame is incremented every time Request Animation Frame, or Set Timeout, fires.
     *
     * @method Phaser.Game#getFrame
     * @since 3.16.0
     *
     * @return {number} The current game frame.
     */ getFrame: function() {
                    return this.loop.frame;
                },
                /**
     * Returns the time that the current game step started at, as based on `performance.now`.
     *
     * @method Phaser.Game#getTime
     * @since 3.16.0
     *
     * @return {number} The current game timestamp.
     */ getTime: function() {
                    return this.loop.now;
                },
                /**
     * Flags this Game instance as needing to be destroyed on the _next frame_, making this an asynchronous operation.
     *
     * It will wait until the current frame has completed and then call `runDestroy` internally.
     *
     * If you need to react to the games eventual destruction, listen for the `DESTROY` event.
     *
     * If you **do not** need to run Phaser again on the same web page you can set the `noReturn` argument to `true` and it will free-up
     * memory being held by the core Phaser plugins. If you do need to create another game instance on the same page, leave this as `false`.
     *
     * @method Phaser.Game#destroy
     * @fires Phaser.Core.Events#DESTROY
     * @since 3.0.0
     *
     * @param {boolean} removeCanvas - Set to `true` if you would like the parent canvas element removed from the DOM, or `false` to leave it in place.
     * @param {boolean} [noReturn=false] - If `true` all the core Phaser plugins are destroyed. You cannot create another instance of Phaser on the same web page if you do this.
     */ destroy: function(removeCanvas, noReturn) {
                    if (noReturn === undefined) noReturn = false;
                    this.pendingDestroy = true;
                    this.removeCanvas = removeCanvas;
                    this.noReturn = noReturn;
                },
                /**
     * Destroys this Phaser.Game instance, all global systems, all sub-systems and all Scenes.
     *
     * @method Phaser.Game#runDestroy
     * @private
     * @since 3.5.0
     */ runDestroy: function() {
                    this.scene.destroy();
                    this.events.emit(Events.DESTROY);
                    this.events.removeAllListeners();
                    if (this.renderer) this.renderer.destroy();
                    if (this.removeCanvas && this.canvas) {
                        CanvasPool.remove(this.canvas);
                        if (this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
                    }
                    if (this.domContainer) this.domContainer.parentNode.removeChild(this.domContainer);
                    this.loop.destroy();
                    this.pendingDestroy = false;
                }
            });
            module1.exports = Game;
        /**
 * "Computers are good at following instructions, but not at reading your mind." - Donald Knuth
 */ /***/ },
        /* 917 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AddToDOM = __webpack_require__(140);
            var CreateDOMContainer = function(game) {
                var config = game.config;
                if (!config.parent || !config.domCreateContainer) return;
                //  DOM Element Container
                var div = document.createElement('div');
                div.style.cssText = [
                    'display: block;',
                    'width: ' + game.scale.width + 'px;',
                    'height: ' + game.scale.height + 'px;',
                    'padding: 0; margin: 0;',
                    'position: absolute;',
                    'overflow: hidden;',
                    'pointer-events: none;',
                    'transform: scale(1);',
                    'transform-origin: left top;'
                ].join(' ');
                game.domContainer = div;
                AddToDOM(div, config.parent);
            };
            module1.exports = CreateDOMContainer;
        /***/ },
        /* 918 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Boot Event.
 * 
 * This internal event is dispatched by the Input Plugin when it boots, signalling to all of its systems to create themselves.
 *
 * @event Phaser.Input.Events#BOOT
 * @since 3.0.0
 */ module1.exports = 'boot';
        /***/ },
        /* 919 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Destroy Event.
 * 
 * This internal event is dispatched by the Input Plugin when it is destroyed, signalling to all of its systems to destroy themselves.
 *
 * @event Phaser.Input.Events#DESTROY
 * @since 3.0.0
 */ module1.exports = 'destroy';
        /***/ },
        /* 920 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag End Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer stops dragging a Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragend', listener)`.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_END]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_END} event instead.
 *
 * @event Phaser.Input.Events#DRAG_END
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer stopped dragging.
 */ module1.exports = 'dragend';
        /***/ },
        /* 921 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Enter Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object into a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragenter', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_ENTER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_ENTER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_ENTER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = 'dragenter';
        /***/ },
        /* 922 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves while dragging a Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('drag', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG} event instead.
 *
 * @event Phaser.Input.Events#DRAG
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'drag';
        /***/ },
        /* 923 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Leave Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object out of a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragleave', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_LEAVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_LEAVE} event instead.
 *
 * @event Phaser.Input.Events#DRAG_LEAVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = 'dragleave';
        /***/ },
        /* 924 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drags a Game Object over a Drag Target.
 * 
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragover', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_OVER} event instead.
 *
 * @event Phaser.Input.Events#DRAG_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = 'dragover';
        /***/ },
        /* 925 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drag Start Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer starts to drag any Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('dragstart', listener)`.
 * 
 * A Pointer can only drag a single Game Object at once.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DRAG_START]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DRAG_START} event instead.
 *
 * @event Phaser.Input.Events#DRAG_START
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer is dragging.
 */ module1.exports = 'dragstart';
        /***/ },
        /* 926 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Drop Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer drops a Game Object on a Drag Target.
 * 
 * Listen to this event from within a Scene using: `this.input.on('drop', listener)`.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_DROP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DROP} event instead.
 *
 * @event Phaser.Input.Events#DROP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The interactive Game Object that this pointer was dragging.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = 'drop';
        /***/ },
        /* 927 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Out Event.
 * 
 * This event is dispatched by the Input Plugin if the active pointer leaves the game canvas and is now
 * outside of it, elsewhere on the web page.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameout', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OUT
 * @since 3.16.1
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas out.
 */ module1.exports = 'gameout';
        /***/ },
        /* 928 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Game Over Event.
 * 
 * This event is dispatched by the Input Plugin if the active pointer enters the game canvas and is now
 * over of it, having previously been elsewhere on the web page.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameover', listener)`.
 *
 * @event Phaser.Input.Events#GAME_OVER
 * @since 3.16.1
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {(MouseEvent|TouchEvent)} event - The DOM Event that triggered the canvas over.
 */ module1.exports = 'gameover';
        /***/ },
        /* 929 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Down Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down on _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectdown', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was pressed down on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectdown';
        /***/ },
        /* 930 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag End Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer stops dragging it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragend', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive](Phaser.GameObjects.GameObject#setInteractive) for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_END
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer stopped dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer stopped dragging the Game Object, in world space.
 */ module1.exports = 'dragend';
        /***/ },
        /* 931 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Enter Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it into a drag target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragenter', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved into.
 */ module1.exports = 'dragenter';
        /***/ },
        /* 932 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves while dragging it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('drag', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'drag';
        /***/ },
        /* 933 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Leave Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it out of a drag target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragleave', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has left.
 */ module1.exports = 'dragleave';
        /***/ },
        /* 934 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Over Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drags it over a drag target.
 * 
 * When the Game Object first enters the drag target it will emit a `dragenter` event. If it then moves while within
 * the drag target, it will emit this event instead.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The drag target that this pointer has moved over.
 */ module1.exports = 'dragover';
        /***/ },
        /* 935 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drag Start Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer starts to drag it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('dragstart', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * There are lots of useful drag related properties that are set within the Game Object when dragging occurs.
 * For example, `gameObject.input.dragStartX`, `dragStartY` and so on.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DRAG_START
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} dragX - The x coordinate where the Pointer is currently dragging the Game Object, in world space.
 * @param {number} dragY - The y coordinate where the Pointer is currently dragging the Game Object, in world space.
 */ module1.exports = 'dragstart';
        /***/ },
        /* 936 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Drop Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer drops it on a Drag Target.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('drop', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive and enabled for drag.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_DROP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} target - The Drag Target the `gameObject` has been dropped on.
 */ module1.exports = 'drop';
        /***/ },
        /* 937 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Move Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved across _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectmove', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was moved on.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectmove';
        /***/ },
        /* 938 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Out Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectout', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved out of.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectout';
        /***/ },
        /* 939 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectover', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer moved over.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectover';
        /***/ },
        /* 940 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Down Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is pressed down on it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerdown', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerdown';
        /***/ },
        /* 941 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Move Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is moved while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointermove', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointermove';
        /***/ },
        /* 942 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Out Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves out of it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerout', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerout';
        /***/ },
        /* 943 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Over Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer moves over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerover', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerover';
        /***/ },
        /* 944 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Up Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer is released while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('pointerup', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} localX - The x coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {number} localY - The y coordinate that the Pointer interacted with this object on, relative to the Game Object's top-left position.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'pointerup';
        /***/ },
        /* 945 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Pointer Wheel Event.
 * 
 * This event is dispatched by an interactive Game Object if a pointer has its wheel moved while over it.
 * 
 * Listen to this event from a Game Object using: `gameObject.on('wheel', listener)`.
 * Note that the scope of the listener is automatically set to be the Game Object instance itself.
 * 
 * To receive this event, the Game Object must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'wheel';
        /***/ },
        /* 946 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Up Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released while over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectup', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when released.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectup';
        /***/ },
        /* 947 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Game Object Wheel Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel moved while over _any_ interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('gameobjectwheel', listener)`.
 * 
 * To receive this event, the Game Objects must have been set as interactive.
 * See [GameObject.setInteractive]{@link Phaser.GameObjects.GameObject#setInteractive} for more details.
 * 
 * To listen for this event from a _specific_ Game Object, use the [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL} event instead.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#GAMEOBJECT_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object the pointer was over when the wheel changed.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {Phaser.Types.Input.EventData} event - The Phaser input event. You can call `stopPropagation()` to halt it from going any further in the event flow.
 */ module1.exports = 'gameobjectwheel';
        /***/ },
        /* 948 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Boot Event.
 * 
 * This internal event is dispatched by the Input Manager when it boots.
 *
 * @event Phaser.Input.Events#MANAGER_BOOT
 * @since 3.0.0
 */ module1.exports = 'boot';
        /***/ },
        /* 949 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Process Event.
 * 
 * This internal event is dispatched by the Input Manager when not using the legacy queue system,
 * and it wants the Input Plugins to update themselves.
 *
 * @event Phaser.Input.Events#MANAGER_PROCESS
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'process';
        /***/ },
        /* 950 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Update Event.
 * 
 * This internal event is dispatched by the Input Manager as part of its update step.
 *
 * @event Phaser.Input.Events#MANAGER_UPDATE
 * @since 3.0.0
 */ module1.exports = 'update';
        /***/ },
        /* 951 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerdown', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointerdown';
        /***/ },
        /* 952 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Down Outside Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is pressed down anywhere outside of the game canvas.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerdownoutside', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_DOWN}
 * 2. [GAMEOBJECT_DOWN]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_DOWN}
 * 3. [POINTER_DOWN]{@linkcode Phaser.Input.Events#event:POINTER_DOWN} or [POINTER_DOWN_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_DOWN_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_DOWN_OUTSIDE
 * @since 3.16.1
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = 'pointerdownoutside';
        /***/ },
        /* 953 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Move Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is moved anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointermove', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_MOVE}
 * 2. [GAMEOBJECT_MOVE]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_MOVE}
 * 3. [POINTER_MOVE]{@linkcode Phaser.Input.Events#event:POINTER_MOVE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_MOVE
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointermove';
        /***/ },
        /* 954 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Out Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves out of any interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerout', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OUT}
 * 2. [GAMEOBJECT_OUT]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OUT}
 * 3. [POINTER_OUT]{@linkcode Phaser.Input.Events#event:POINTER_OUT}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_OUT
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOut - An array containing all interactive Game Objects that the pointer moved out of when the event was created.
 */ module1.exports = 'pointerout';
        /***/ },
        /* 955 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Over Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer moves over any interactive Game Object.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerover', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_OVER}
 * 2. [GAMEOBJECT_OVER]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_OVER}
 * 3. [POINTER_OVER]{@linkcode Phaser.Input.Events#event:POINTER_OVER}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_OVER
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} justOver - An array containing all interactive Game Objects that the pointer moved over when the event was created.
 */ module1.exports = 'pointerover';
        /***/ },
        /* 956 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerup', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 */ module1.exports = 'pointerup';
        /***/ },
        /* 957 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Up Outside Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer is released anywhere outside of the game canvas.
 * 
 * Listen to this event from within a Scene using: `this.input.on('pointerupoutside', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_UP}
 * 2. [GAMEOBJECT_UP]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_UP}
 * 3. [POINTER_UP]{@linkcode Phaser.Input.Events#event:POINTER_UP} or [POINTER_UP_OUTSIDE]{@linkcode Phaser.Input.Events#event:POINTER_UP_OUTSIDE}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_UP_OUTSIDE
 * @since 3.16.1
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 */ module1.exports = 'pointerupoutside';
        /***/ },
        /* 958 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pointer Wheel Input Event.
 * 
 * This event is dispatched by the Input Plugin belonging to a Scene if a pointer has its wheel updated.
 * 
 * Listen to this event from within a Scene using: `this.input.on('wheel', listener)`.
 * 
 * The event hierarchy is as follows:
 * 
 * 1. [GAMEOBJECT_POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_POINTER_WHEEL}
 * 2. [GAMEOBJECT_WHEEL]{@linkcode Phaser.Input.Events#event:GAMEOBJECT_WHEEL}
 * 3. [POINTER_WHEEL]{@linkcode Phaser.Input.Events#event:POINTER_WHEEL}
 * 
 * With the top event being dispatched first and then flowing down the list. Note that higher-up event handlers can stop
 * the propagation of this event.
 *
 * @event Phaser.Input.Events#POINTER_WHEEL
 * @since 3.18.0
 * 
 * @param {Phaser.Input.Pointer} pointer - The Pointer responsible for triggering this event.
 * @param {Phaser.GameObjects.GameObject[]} currentlyOver - An array containing all interactive Game Objects that the pointer was over when the event was created.
 * @param {number} deltaX - The horizontal scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 * @param {number} deltaY - The vertical scroll amount that occurred due to the user moving a mouse wheel or similar input device. This value will typically be less than 0 if the user scrolls up and greater than zero if scrolling down.
 * @param {number} deltaZ - The z-axis scroll amount that occurred due to the user moving a mouse wheel or similar input device.
 */ module1.exports = 'wheel';
        /***/ },
        /* 959 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Manager Pointer Lock Change Event.
 * 
 * This event is dispatched by the Input Manager when it is processing a native Pointer Lock Change DOM Event.
 *
 * @event Phaser.Input.Events#POINTERLOCK_CHANGE
 * @since 3.0.0
 * 
 * @param {Event} event - The native DOM Event.
 * @param {boolean} locked - The locked state of the Mouse Pointer.
 */ module1.exports = 'pointerlockchange';
        /***/ },
        /* 960 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Pre-Update Event.
 * 
 * This internal event is dispatched by the Input Plugin at the start of its `preUpdate` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#PRE_UPDATE
 * @since 3.0.0
 */ module1.exports = 'preupdate';
        /***/ },
        /* 961 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Shutdown Event.
 * 
 * This internal event is dispatched by the Input Plugin when it shuts down, signalling to all of its systems to shut themselves down.
 *
 * @event Phaser.Input.Events#SHUTDOWN
 * @since 3.0.0
 */ module1.exports = 'shutdown';
        /***/ },
        /* 962 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Start Event.
 * 
 * This internal event is dispatched by the Input Plugin when it has finished setting-up,
 * signalling to all of its internal systems to start.
 *
 * @event Phaser.Input.Events#START
 * @since 3.0.0
 */ module1.exports = 'start';
        /***/ },
        /* 963 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Input Plugin Update Event.
 * 
 * This internal event is dispatched by the Input Plugin at the start of its `update` method.
 * This hook is designed specifically for input plugins, but can also be listened to from user-land code.
 *
 * @event Phaser.Input.Events#UPDATE
 * @since 3.0.0
 * 
 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
 * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
 */ module1.exports = 'update';
        /***/ },
        /* 964 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Add File Event.
 * 
 * This event is dispatched when a new file is successfully added to the Loader and placed into the load queue.
 * 
 * Listen to it from a Scene using: `this.load.on('addfile', listener)`.
 * 
 * If you add lots of files to a Loader from a `preload` method, it will dispatch this event for each one of them.
 *
 * @event Phaser.Loader.Events#ADD
 * @since 3.0.0
 * 
 * @param {string} key - The unique key of the file that was added to the Loader.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} string of the file that was added to the Loader, i.e. `image`.
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {Phaser.Loader.File} file - A reference to the File which was added to the Loader.
 */ module1.exports = 'addfile';
        /***/ },
        /* 965 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Complete Event.
 * 
 * This event is dispatched when the Loader has fully processed everything in the load queue.
 * By this point every loaded file will now be in its associated cache and ready for use.
 * 
 * Listen to it from a Scene using: `this.load.on('complete', listener)`.
 *
 * @event Phaser.Loader.Events#COMPLETE
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 * @param {number} totalComplete - The total number of files that successfully loaded.
 * @param {number} totalFailed - The total number of files that failed to load.
 */ module1.exports = 'complete';
        /***/ },
        /* 966 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 * 
 * This event is dispatched by the Loader Plugin when any file in the queue finishes loading.
 * 
 * Listen to it from a Scene using: `this.load.on('filecomplete', listener)`.
 * 
 * You can also listen for the completion of a specific file. See the [FILE_KEY_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_KEY_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_COMPLETE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} data - The raw data the file contained.
 */ module1.exports = 'filecomplete';
        /***/ },
        /* 967 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Complete Event.
 * 
 * This event is dispatched by the Loader Plugin when any file in the queue finishes loading.
 * 
 * It uses a special dynamic event name constructed from the key and type of the file.
 * 
 * For example, if you have loaded an `image` with a key of `monster`, you can listen for it
 * using the following:
 *
 * ```javascript
 * this.load.on('filecomplete-image-monster', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 *
 * Or, if you have loaded a texture `atlas` with a key of `Level1`:
 * 
 * ```javascript
 * this.load.on('filecomplete-atlas-Level1', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 * 
 * Or, if you have loaded a sprite sheet with a key of `Explosion` and a prefix of `GAMEOVER`:
 * 
 * ```javascript
 * this.load.on('filecomplete-spritesheet-GAMEOVERExplosion', function (key, type, data) {
 *     // Your handler code
 * });
 * ```
 * 
 * You can also listen for the generic completion of files. See the [FILE_COMPLETE]{@linkcode Phaser.Loader.Events#event:FILE_COMPLETE} event.
 *
 * @event Phaser.Loader.Events#FILE_KEY_COMPLETE
 * @since 3.0.0
 * 
 * @param {string} key - The key of the file that just loaded and finished processing.
 * @param {string} type - The [file type]{@link Phaser.Loader.File#type} of the file that just loaded, i.e. `image`.
 * @param {any} data - The raw data the file contained.
 */ module1.exports = 'filecomplete-';
        /***/ },
        /* 968 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Error Event.
 * 
 * This event is dispatched by the Loader Plugin when a file fails to load.
 * 
 * Listen to it from a Scene using: `this.load.on('loaderror', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD_ERROR
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 */ module1.exports = 'loaderror';
        /***/ },
        /* 969 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Event.
 * 
 * This event is dispatched by the Loader Plugin when a file finishes loading,
 * but _before_ it is processed and added to the internal Phaser caches.
 * 
 * Listen to it from a Scene using: `this.load.on('load', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_LOAD
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which just finished loading.
 */ module1.exports = 'load';
        /***/ },
        /* 970 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The File Load Progress Event.
 * 
 * This event is dispatched by the Loader Plugin during the load of a file, if the browser receives a DOM ProgressEvent and
 * the `lengthComputable` event property is true. Depending on the size of the file and browser in use, this may, or may not happen.
 * 
 * Listen to it from a Scene using: `this.load.on('fileprogress', listener)`.
 *
 * @event Phaser.Loader.Events#FILE_PROGRESS
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.File} file - A reference to the File which errored during load.
 * @param {number} percentComplete - A value between 0 and 1 indicating how 'complete' this file is.
 */ module1.exports = 'fileprogress';
        /***/ },
        /* 971 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Post Process Event.
 * 
 * This event is dispatched by the Loader Plugin when the Loader has finished loading everything in the load queue.
 * It is dispatched before the internal lists are cleared and each File is destroyed.
 * 
 * Use this hook to perform any last minute processing of files that can only happen once the
 * Loader has completed, but prior to it emitting the `complete` event.
 * 
 * Listen to it from a Scene using: `this.load.on('postprocess', listener)`.
 *
 * @event Phaser.Loader.Events#POST_PROCESS
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = 'postprocess';
        /***/ },
        /* 972 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Progress Event.
 * 
 * This event is dispatched when the Loader updates its load progress, typically as a result of a file having completed loading.
 * 
 * Listen to it from a Scene using: `this.load.on('progress', listener)`.
 *
 * @event Phaser.Loader.Events#PROGRESS
 * @since 3.0.0
 * 
 * @param {number} progress - The current progress of the load. A value between 0 and 1.
 */ module1.exports = 'progress';
        /***/ },
        /* 973 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Loader Plugin Start Event.
 * 
 * This event is dispatched when the Loader starts running. At this point load progress is zero.
 * 
 * This event is dispatched even if there aren't any files in the load queue.
 * 
 * Listen to it from a Scene using: `this.load.on('start', listener)`.
 *
 * @event Phaser.Loader.Events#START
 * @since 3.0.0
 * 
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader Plugin that dispatched this event.
 */ module1.exports = 'start';
        /***/ },
        /* 974 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  These properties get injected into the Scene and map to local systems
            //  The map value is the property that is injected into the Scene, the key is the Scene.Systems reference.
            //  These defaults can be modified via the Scene config object
            //          var config = {
            //            map: {
            //                add: 'makeStuff',
            //                load: 'loader'
            //            }
            //        };
            var InjectionMap = {
                game: 'game',
                renderer: 'renderer',
                anims: 'anims',
                cache: 'cache',
                plugins: 'plugins',
                registry: 'registry',
                scale: 'scale',
                sound: 'sound',
                textures: 'textures',
                events: 'events',
                cameras: 'cameras',
                add: 'add',
                make: 'make',
                scenePlugin: 'scene',
                displayList: 'children',
                lights: 'lights',
                data: 'data',
                input: 'input',
                load: 'load',
                time: 'time',
                tweens: 'tweens',
                arcadePhysics: 'physics',
                impactPhysics: 'impact',
                matterPhysics: 'matter'
            };
            module1.exports = InjectionMap;
        /***/ },
        /* 975 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Parses an XML Texture Atlas object and adds all the Frames into a Texture.
 *
 * @function Phaser.Textures.Parsers.AtlasXML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.7.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {*} xml - The XML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var AtlasXML = function(texture, sourceIndex, xml) {
                //  Malformed?
                if (!xml.getElementsByTagName('TextureAtlas')) {
                    console.warn('Invalid Texture Atlas XML given');
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed array
                var frames = xml.getElementsByTagName('SubTexture');
                var newFrame;
                for(var i = 0; i < frames.length; i++){
                    var frame = frames[i].attributes;
                    var name = frame.name.value;
                    var x = parseInt(frame.x.value, 10);
                    var y = parseInt(frame.y.value, 10);
                    var width = parseInt(frame.width.value, 10);
                    var height = parseInt(frame.height.value, 10);
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(name, sourceIndex, x, y, width, height);
                    //  These are the original (non-trimmed) sprite values
                    if (frame.frameX) {
                        var frameX = Math.abs(parseInt(frame.frameX.value, 10));
                        var frameY = Math.abs(parseInt(frame.frameY.value, 10));
                        var frameWidth = parseInt(frame.frameWidth.value, 10);
                        var frameHeight = parseInt(frame.frameHeight.value, 10);
                        newFrame.setTrim(width, height, frameX, frameY, frameWidth, frameHeight);
                    }
                }
                return texture;
            };
            module1.exports = AtlasXML;
        /***/ },
        /* 976 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds a Canvas Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Canvas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Canvas = function(texture, sourceIndex) {
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                return texture;
            };
            module1.exports = Canvas;
        /***/ },
        /* 977 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds an Image Element to a Texture.
 *
 * @function Phaser.Textures.Parsers.Image
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var Image1 = function(texture, sourceIndex) {
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                return texture;
            };
            module1.exports = Image1;
        /***/ },
        /* 978 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Parses a Texture Atlas JSON Array and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an array of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONArray
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONArray = function(texture, sourceIndex, json) {
                //  Malformed?
                if (!json['frames'] && !json['textures']) {
                    console.warn('Invalid Texture Atlas JSON Array');
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed array
                var frames = Array.isArray(json.textures) ? json.textures[sourceIndex].frames : json.frames;
                var newFrame;
                for(var i = 0; i < frames.length; i++){
                    var src = frames[i];
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(src.filename, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                    //  These are the original (non-trimmed) sprite values
                    if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                    if (src.rotated) {
                        newFrame.rotated = true;
                        newFrame.updateUVsInverted();
                    }
                    var pivot = src.anchor || src.pivot;
                    if (pivot) {
                        newFrame.customPivot = true;
                        newFrame.pivotX = pivot.x;
                        newFrame.pivotY = pivot.y;
                    }
                    //  Copy over any extra data
                    newFrame.customData = Clone(src);
                }
                //  Copy over any additional data that was in the JSON to Texture.customData
                for(var dataKey in json){
                    if (dataKey === 'frames') continue;
                    if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                    else texture.customData[dataKey] = json[dataKey];
                }
                return texture;
            };
            module1.exports = JSONArray;
        /***/ },
        /* 979 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Parses a Texture Atlas JSON Hash and adds the Frames to the Texture.
 * JSON format expected to match that defined by Texture Packer, with the frames property containing an object of Frames.
 *
 * @function Phaser.Textures.Parsers.JSONHash
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} json - The JSON data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var JSONHash = function(texture, sourceIndex, json) {
                //  Malformed?
                if (!json['frames']) {
                    console.warn('Invalid Texture Atlas JSON Hash given, missing \'frames\' Object');
                    return;
                }
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                //  By this stage frames is a fully parsed Object
                var frames = json.frames;
                var newFrame;
                for(var key in frames){
                    if (!frames.hasOwnProperty(key)) continue;
                    var src = frames[key];
                    //  The frame values are the exact coordinates to cut the frame out of the atlas from
                    newFrame = texture.add(key, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
                    //  These are the original (non-trimmed) sprite values
                    if (src.trimmed) newFrame.setTrim(src.sourceSize.w, src.sourceSize.h, src.spriteSourceSize.x, src.spriteSourceSize.y, src.spriteSourceSize.w, src.spriteSourceSize.h);
                    if (src.rotated) {
                        newFrame.rotated = true;
                        newFrame.updateUVsInverted();
                    }
                    var pivot = src.anchor || src.pivot;
                    if (pivot) {
                        newFrame.customPivot = true;
                        newFrame.pivotX = pivot.x;
                        newFrame.pivotY = pivot.y;
                    }
                    //  Copy over any extra data
                    newFrame.customData = Clone(src);
                }
                //  Copy over any additional data that was in the JSON to Texture.customData
                for(var dataKey in json){
                    if (dataKey === 'frames') continue;
                    if (Array.isArray(json[dataKey])) texture.customData[dataKey] = json[dataKey].slice(0);
                    else texture.customData[dataKey] = json[dataKey];
                }
                return texture;
            };
            module1.exports = JSONHash;
        /***/ },
        /* 980 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parses a Sprite Sheet and adds the Frames to the Texture.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheet
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {number} x - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} y - The top-left coordinate of the Sprite Sheet. Defaults to zero. Used when extracting sheets from atlases.
 * @param {number} width - The width of the source image.
 * @param {number} height - The height of the source image.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - The frame to start extracting from. Defaults to zero.
 * @param {number} [config.endFrame=-1] - The frame to finish extracting at. Defaults to -1, which means 'all frames'.
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheet = function(texture, sourceIndex, x, y, width, height, config) {
                var frameWidth = GetFastValue(config, 'frameWidth', null);
                var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
                //  If missing we can't proceed
                if (frameWidth === null) throw new Error('TextureManager.SpriteSheet: Invalid frameWidth given.');
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                var startFrame = GetFastValue(config, 'startFrame', 0);
                var endFrame = GetFastValue(config, 'endFrame', -1);
                var margin = GetFastValue(config, 'margin', 0);
                var spacing = GetFastValue(config, 'spacing', 0);
                var row = Math.floor((width - margin + spacing) / (frameWidth + spacing));
                var column = Math.floor((height - margin + spacing) / (frameHeight + spacing));
                var total = row * column;
                if (total === 0) console.warn('SpriteSheet frame dimensions will result in zero frames for texture:', texture.key);
                if (startFrame > total || startFrame < -total) startFrame = 0;
                if (startFrame < 0) //  Allow negative skipframes.
                startFrame = total + startFrame;
                if (endFrame !== -1) total = startFrame + (endFrame + 1);
                var fx = margin;
                var fy = margin;
                var ax = 0;
                var ay = 0;
                for(var i = 0; i < total; i++){
                    ax = 0;
                    ay = 0;
                    var w = fx + frameWidth;
                    var h = fy + frameHeight;
                    if (w > width) ax = w - width;
                    if (h > height) ay = h - height;
                    texture.add(i, sourceIndex, x + fx, y + fy, frameWidth - ax, frameHeight - ay);
                    fx += frameWidth + spacing;
                    if (fx + frameWidth > width) {
                        fx = margin;
                        fy += frameHeight + spacing;
                    }
                }
                return texture;
            };
            module1.exports = SpriteSheet;
        /***/ },
        /* 981 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetFastValue = __webpack_require__(2);
            /**
 * Parses a Sprite Sheet and adds the Frames to the Texture, where the Sprite Sheet is stored as a frame within an Atlas.
 *
 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
 * same size and cannot be trimmed or rotated.
 *
 * @function Phaser.Textures.Parsers.SpriteSheetFromAtlas
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {Phaser.Textures.Frame} frame - The Frame that contains the Sprite Sheet.
 * @param {object} config - An object describing how to parse the Sprite Sheet.
 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
 * @param {number} [config.startFrame=0] - Index of the start frame in the sprite sheet
 * @param {number} [config.endFrame=-1] - Index of the end frame in the sprite sheet. -1 mean all the rest of the frames
 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var SpriteSheetFromAtlas = function(texture, frame, config) {
                var frameWidth = GetFastValue(config, 'frameWidth', null);
                var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
                //  If missing we can't proceed
                if (!frameWidth) throw new Error('TextureManager.SpriteSheetFromAtlas: Invalid frameWidth given.');
                //  Add in a __BASE entry (for the entire atlas frame)
                var source = texture.source[0];
                texture.add('__BASE', 0, 0, 0, source.width, source.height);
                var startFrame = GetFastValue(config, 'startFrame', 0);
                var endFrame = GetFastValue(config, 'endFrame', -1);
                var margin = GetFastValue(config, 'margin', 0);
                var spacing = GetFastValue(config, 'spacing', 0);
                var x = frame.cutX;
                var y = frame.cutY;
                var cutWidth = frame.cutWidth;
                var cutHeight = frame.cutHeight;
                var sheetWidth = frame.realWidth;
                var sheetHeight = frame.realHeight;
                var row = Math.floor((sheetWidth - margin + spacing) / (frameWidth + spacing));
                var column = Math.floor((sheetHeight - margin + spacing) / (frameHeight + spacing));
                var total = row * column;
                //  trim offsets
                var leftPad = frame.x;
                var leftWidth = frameWidth - leftPad;
                var rightWidth = frameWidth - (sheetWidth - cutWidth - leftPad);
                var topPad = frame.y;
                var topHeight = frameHeight - topPad;
                var bottomHeight = frameHeight - (sheetHeight - cutHeight - topPad);
                if (startFrame > total || startFrame < -total) startFrame = 0;
                if (startFrame < 0) //  Allow negative skipframes.
                startFrame = total + startFrame;
                if (endFrame !== -1) total = startFrame + (endFrame + 1);
                var sheetFrame;
                var frameX = margin;
                var frameY = margin;
                var frameIndex = 0;
                var sourceIndex = frame.sourceIndex;
                for(var sheetY = 0; sheetY < column; sheetY++){
                    var topRow = sheetY === 0;
                    var bottomRow = sheetY === column - 1;
                    for(var sheetX = 0; sheetX < row; sheetX++){
                        var leftRow = sheetX === 0;
                        var rightRow = sheetX === row - 1;
                        sheetFrame = texture.add(frameIndex, sourceIndex, x + frameX, y + frameY, frameWidth, frameHeight);
                        if (leftRow || topRow || rightRow || bottomRow) {
                            var destX = leftRow ? leftPad : 0;
                            var destY = topRow ? topPad : 0;
                            var trimWidth = 0;
                            var trimHeight = 0;
                            if (leftRow) trimWidth += frameWidth - leftWidth;
                            if (rightRow) trimWidth += frameWidth - rightWidth;
                            if (topRow) trimHeight += frameHeight - topHeight;
                            if (bottomRow) trimHeight += frameHeight - bottomHeight;
                            var destWidth = frameWidth - trimWidth;
                            var destHeight = frameHeight - trimHeight;
                            sheetFrame.cutWidth = destWidth;
                            sheetFrame.cutHeight = destHeight;
                            sheetFrame.setTrim(frameWidth, frameHeight, destX, destY, destWidth, destHeight);
                        }
                        frameX += spacing;
                        if (leftRow) frameX += leftWidth;
                        else if (rightRow) frameX += rightWidth;
                        else frameX += frameWidth;
                        frameIndex++;
                    }
                    frameX = margin;
                    frameY += spacing;
                    if (topRow) frameY += topHeight;
                    else if (bottomRow) frameY += bottomHeight;
                    else frameY += frameHeight;
                }
                return texture;
            };
            module1.exports = SpriteSheetFromAtlas;
        /***/ },
        /* 982 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var imageHeight = 0;
            /**
 * @function addFrame
 * @private
 * @since 3.0.0
 */ var addFrame = function(texture, sourceIndex, name, frame) {
                //  The frame values are the exact coordinates to cut the frame out of the atlas from
                var y = imageHeight - frame.y - frame.height;
                texture.add(name, sourceIndex, frame.x, y, frame.width, frame.height);
            //  These are the original (non-trimmed) sprite values
            /*
    if (src.trimmed)
    {
        newFrame.setTrim(
            src.sourceSize.w,
            src.sourceSize.h,
            src.spriteSourceSize.x,
            src.spriteSourceSize.y,
            src.spriteSourceSize.w,
            src.spriteSourceSize.h
        );
    }
    */ };
            /**
 * Parses a Unity YAML File and creates Frames in the Texture.
 * For more details about Sprite Meta Data see https://docs.unity3d.com/ScriptReference/SpriteMetaData.html
 *
 * @function Phaser.Textures.Parsers.UnityYAML
 * @memberof Phaser.Textures.Parsers
 * @private
 * @since 3.0.0
 *
 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
 * @param {number} sourceIndex - The index of the TextureSource.
 * @param {object} yaml - The YAML data.
 *
 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
 */ var UnityYAML = function(texture, sourceIndex, yaml) {
                //  Add in a __BASE entry (for the entire atlas)
                var source = texture.source[sourceIndex];
                texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
                imageHeight = source.height;
                var data = yaml.split('\n');
                var lineRegExp = /^[ ]*(- )*(\w+)+[: ]+(.*)/;
                var prevSprite = '';
                var currentSprite = '';
                var rect = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
                // var pivot = { x: 0, y: 0 };
                // var border = { x: 0, y: 0, z: 0, w: 0 };
                for(var i = 0; i < data.length; i++){
                    var results = data[i].match(lineRegExp);
                    if (!results) continue;
                    var isList = results[1] === '- ';
                    var key = results[2];
                    var value = results[3];
                    if (isList) {
                        if (currentSprite !== prevSprite) {
                            addFrame(texture, sourceIndex, currentSprite, rect);
                            prevSprite = currentSprite;
                        }
                        rect = {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        };
                    }
                    if (key === 'name') {
                        //  Start new list
                        currentSprite = value;
                        continue;
                    }
                    switch(key){
                        case 'x':
                        case 'y':
                        case 'width':
                        case 'height':
                            rect[key] = parseInt(value, 10);
                            break;
                    }
                }
                if (currentSprite !== prevSprite) addFrame(texture, sourceIndex, currentSprite, rect);
                return texture;
            };
            module1.exports = UnityYAML;
        /*
Example data:

TextureImporter:
  spritePivot: {x: .5, y: .5}
  spriteBorder: {x: 0, y: 0, z: 0, w: 0}
  spritePixelsToUnits: 100
  spriteSheet:
    sprites:
    - name: asteroids_0
      rect:
        serializedVersion: 2
        x: 5
        y: 328
        width: 65
        height: 82
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
    - name: asteroids_1
      rect:
        serializedVersion: 2
        x: 80
        y: 322
        width: 53
        height: 88
      alignment: 0
      pivot: {x: 0, y: 0}
      border: {x: 0, y: 0, z: 0, w: 0}
  spritePackingTag: Asteroids
*/ /***/ },
        /* 983 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Complete Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they complete playback.
 * 
 * Listen to it from a Sound instance using `Sound.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('complete', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#COMPLETE
 * @since 3.16.1
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'complete';
        /***/ },
        /* 984 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded Event.
 * 
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method.
 * 
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decoded', listener)`, i.e.:
 * 
 * ```javascript
 * this.sound.on('decoded', handler);
 * this.sound.decodeAudio(key, audioData);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED
 * @since 3.18.0
 * 
 * @param {string} key - The key of the audio file that was decoded and added to the audio cache.
 */ module1.exports = 'decoded';
        /***/ },
        /* 985 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Audio Data Decoded All Event.
 * 
 * This event is dispatched by the Web Audio Sound Manager as a result of calling the `decodeAudio` method,
 * once all files passed to the method have been decoded (or errored).
 * 
 * Use `Phaser.Sound.Events#DECODED` to listen for single sounds being decoded, and `DECODED_ALL` to
 * listen for them all completing.
 * 
 * Listen to it from the Sound Manager in a Scene using `this.sound.on('decodedall', listener)`, i.e.:
 * 
 * ```javascript
 * this.sound.once('decodedall', handler);
 * this.sound.decodeAudio([ audioFiles ]);
 * ```
 *
 * @event Phaser.Sound.Events#DECODED_ALL
 * @since 3.18.0
 */ module1.exports = 'decodedall';
        /***/ },
        /* 986 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Destroy Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are destroyed, either
 * directly or via a Sound Manager.
 * 
 * Listen to it from a Sound instance using `Sound.on('destroy', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('destroy', listener);
 * music.destroy();
 * ```
 *
 * @event Phaser.Sound.Events#DESTROY
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'destroy';
        /***/ },
        /* 987 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Detune Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their detune value changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('detune', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('detune', listener);
 * music.play();
 * music.setDetune(200);
 * ```
 *
 * @event Phaser.Sound.Events#DETUNE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = 'detune';
        /***/ },
        /* 988 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Detune Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `detune` property of the Sound Manager is changed, which globally
 * adjusts the detuning of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_DETUNE
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} detune - The updated detune value.
 */ module1.exports = 'detune';
        /***/ },
        /* 989 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Mute Event.
 * 
 * This event is dispatched by the Sound Manager when its `mute` property is changed, either directly
 * or via the `setMute` method. This changes the mute state of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('mute', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_MUTE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the Sound Manager that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound Manager is now muted, otherwise `false`.
 */ module1.exports = 'mute';
        /***/ },
        /* 990 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Rate Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `rate` property of the Sound Manager is changed, which globally
 * adjusts the playback rate of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('rate', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_RATE
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} rate - The updated rate value.
 */ module1.exports = 'rate';
        /***/ },
        /* 991 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Global Volume Event.
 * 
 * This event is dispatched by the Sound Manager when its `volume` property is changed, either directly
 * or via the `setVolume` method. This changes the volume of all active sounds.
 * 
 * Listen to it from a Scene using: `this.sound.on('volume', listener)`.
 *
 * @event Phaser.Sound.Events#GLOBAL_VOLUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSoundManager|Phaser.Sound.HTML5AudioSoundManager)} soundManager - A reference to the sound manager that emitted the event.
 * @param {number} volume - The new global volume of the Sound Manager.
 */ module1.exports = 'volume';
        /***/ },
        /* 992 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Loop Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their loop state is changed.
 * 
 * Listen to it from a Sound instance using `Sound.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('loop', listener);
 * music.setLoop(true);
 * ```
 * 
 * This is not to be confused with the [LOOPED]{@linkcode Phaser.Sound.Events#event:LOOPED} event, which emits each time a Sound loops during playback.
 *
 * @event Phaser.Sound.Events#LOOP
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} loop - The new loop value. `true` if the Sound will loop, otherwise `false`.
 */ module1.exports = 'loop';
        /***/ },
        /* 993 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Looped Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they loop during playback.
 * 
 * Listen to it from a Sound instance using `Sound.on('looped', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('looped', listener);
 * music.setLoop(true);
 * music.play();
 * ```
 * 
 * This is not to be confused with the [LOOP]{@linkcode Phaser.Sound.Events#event:LOOP} event, which only emits when the loop state of a Sound is changed.
 *
 * @event Phaser.Sound.Events#LOOPED
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'looped';
        /***/ },
        /* 994 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Mute Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their mute state changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('mute', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('mute', listener);
 * music.play();
 * music.setMute(true);
 * ```
 *
 * @event Phaser.Sound.Events#MUTE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {boolean} mute - The mute value. `true` if the Sound is now muted, otherwise `false`.
 */ module1.exports = 'mute';
        /***/ },
        /* 995 */ /***/ function(module1, exports) {
            /**
 * @author       pi-kei
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pan Event.
 *
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their pan changes.
 *
 * Listen to it from a Sound instance using `Sound.on('pan', listener)`, i.e.:
 *
 * ```javascript
 * var sound = this.sound.add('key');
 * sound.on('pan', listener);
 * sound.play();
 * sound.setPan(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#PAN
 * @since 3.50.0
 *
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} pan - The new pan of the Sound.
 */ module1.exports = 'pan';
        /***/ },
        /* 996 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Pause All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `pauseAll` method is invoked and after all current Sounds
 * have been paused.
 * 
 * Listen to it from a Scene using: `this.sound.on('pauseall', listener)`.
 *
 * @event Phaser.Sound.Events#PAUSE_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'pauseall';
        /***/ },
        /* 997 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Pause Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are paused.
 * 
 * Listen to it from a Sound instance using `Sound.on('pause', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('pause', listener);
 * music.play();
 * music.pause();
 * ```
 *
 * @event Phaser.Sound.Events#PAUSE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'pause';
        /***/ },
        /* 998 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Play Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are played.
 * 
 * Listen to it from a Sound instance using `Sound.on('play', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('play', listener);
 * music.play();
 * ```
 *
 * @event Phaser.Sound.Events#PLAY
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'play';
        /***/ },
        /* 999 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Rate Change Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their rate changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('rate', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('rate', listener);
 * music.play();
 * music.setRate(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#RATE
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} rate - The new rate of the Sound.
 */ module1.exports = 'rate';
        /***/ },
        /* 1000 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Resume All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `resumeAll` method is invoked and after all current Sounds
 * have been resumed.
 * 
 * Listen to it from a Scene using: `this.sound.on('resumeall', listener)`.
 *
 * @event Phaser.Sound.Events#RESUME_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'resumeall';
        /***/ },
        /* 1001 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Resume Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are resumed from a paused state.
 * 
 * Listen to it from a Sound instance using `Sound.on('resume', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('resume', listener);
 * music.play();
 * music.pause();
 * music.resume();
 * ```
 *
 * @event Phaser.Sound.Events#RESUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'resume';
        /***/ },
        /* 1002 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Seek Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are seeked to a new position.
 * 
 * Listen to it from a Sound instance using `Sound.on('seek', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('seek', listener);
 * music.play();
 * music.setSeek(5000);
 * ```
 *
 * @event Phaser.Sound.Events#SEEK
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} detune - The new detune value of the Sound.
 */ module1.exports = 'seek';
        /***/ },
        /* 1003 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Stop All Sounds Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched when the `stopAll` method is invoked and after all current Sounds
 * have been stopped.
 * 
 * Listen to it from a Scene using: `this.sound.on('stopall', listener)`.
 *
 * @event Phaser.Sound.Events#STOP_ALL
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'stopall';
        /***/ },
        /* 1004 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Stop Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when they are stopped.
 * 
 * Listen to it from a Sound instance using `Sound.on('stop', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('stop', listener);
 * music.play();
 * music.stop();
 * ```
 *
 * @event Phaser.Sound.Events#STOP
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 */ module1.exports = 'stop';
        /***/ },
        /* 1005 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Manager Unlocked Event.
 * 
 * This event is dispatched by the Base Sound Manager, or more typically, an instance of the Web Audio Sound Manager,
 * or the HTML5 Audio Manager. It is dispatched during the update loop when the Sound Manager becomes unlocked. For
 * Web Audio this is on the first user gesture on the page.
 * 
 * Listen to it from a Scene using: `this.sound.on('unlocked', listener)`.
 *
 * @event Phaser.Sound.Events#UNLOCKED
 * @since 3.0.0
 * 
 * @param {Phaser.Sound.BaseSoundManager} soundManager - A reference to the sound manager that emitted the event.
 */ module1.exports = 'unlocked';
        /***/ },
        /* 1006 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Sound Volume Event.
 * 
 * This event is dispatched by both Web Audio and HTML5 Audio Sound objects when their volume changes.
 * 
 * Listen to it from a Sound instance using `Sound.on('volume', listener)`, i.e.:
 * 
 * ```javascript
 * var music = this.sound.add('key');
 * music.on('volume', listener);
 * music.play();
 * music.setVolume(0.5);
 * ```
 *
 * @event Phaser.Sound.Events#VOLUME
 * @since 3.0.0
 * 
 * @param {(Phaser.Sound.WebAudioSound|Phaser.Sound.HTML5AudioSound)} sound - A reference to the Sound that emitted the event.
 * @param {number} volume - The new volume of the Sound.
 */ module1.exports = 'volume';
        /***/ },
        /* 1007 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects
 */ var GameObjects = {
                Events: __webpack_require__(75),
                DisplayList: __webpack_require__(1008),
                GameObjectCreator: __webpack_require__(16),
                GameObjectFactory: __webpack_require__(5),
                UpdateList: __webpack_require__(1034),
                Components: __webpack_require__(11),
                GetCalcMatrix: __webpack_require__(19),
                BuildGameObject: __webpack_require__(28),
                BuildGameObjectAnimation: __webpack_require__(433),
                GameObject: __webpack_require__(15),
                BitmapText: __webpack_require__(147),
                Blitter: __webpack_require__(210),
                Bob: __webpack_require__(434),
                Container: __webpack_require__(211),
                DOMElement: __webpack_require__(436),
                DynamicBitmapText: __webpack_require__(212),
                Extern: __webpack_require__(438),
                Graphics: __webpack_require__(213),
                Group: __webpack_require__(110),
                Image: __webpack_require__(124),
                Layer: __webpack_require__(216),
                Particles: __webpack_require__(1068),
                PathFollower: __webpack_require__(451),
                RenderTexture: __webpack_require__(218),
                RetroFont: __webpack_require__(1076),
                Rope: __webpack_require__(220),
                Sprite: __webpack_require__(73),
                Text: __webpack_require__(221),
                GetTextSize: __webpack_require__(452),
                MeasureText: __webpack_require__(454),
                TextStyle: __webpack_require__(453),
                TileSprite: __webpack_require__(222),
                Zone: __webpack_require__(127),
                Video: __webpack_require__(223),
                //  Shapes
                Shape: __webpack_require__(33),
                Arc: __webpack_require__(455),
                Curve: __webpack_require__(456),
                Ellipse: __webpack_require__(457),
                Grid: __webpack_require__(458),
                IsoBox: __webpack_require__(459),
                IsoTriangle: __webpack_require__(460),
                Line: __webpack_require__(461),
                Polygon: __webpack_require__(462),
                Rectangle: __webpack_require__(467),
                Star: __webpack_require__(468),
                Triangle: __webpack_require__(469),
                //  Game Object Factories
                Factories: {
                    Blitter: __webpack_require__(1124),
                    Container: __webpack_require__(1125),
                    DOMElement: __webpack_require__(1126),
                    DynamicBitmapText: __webpack_require__(1127),
                    Extern: __webpack_require__(1128),
                    Graphics: __webpack_require__(1129),
                    Group: __webpack_require__(1130),
                    Image: __webpack_require__(1131),
                    Layer: __webpack_require__(1132),
                    Particles: __webpack_require__(1133),
                    PathFollower: __webpack_require__(1134),
                    RenderTexture: __webpack_require__(1135),
                    Rope: __webpack_require__(1136),
                    Sprite: __webpack_require__(1137),
                    StaticBitmapText: __webpack_require__(1138),
                    Text: __webpack_require__(1139),
                    TileSprite: __webpack_require__(1140),
                    Zone: __webpack_require__(1141),
                    Video: __webpack_require__(1142),
                    //  Shapes
                    Arc: __webpack_require__(1143),
                    Curve: __webpack_require__(1144),
                    Ellipse: __webpack_require__(1145),
                    Grid: __webpack_require__(1146),
                    IsoBox: __webpack_require__(1147),
                    IsoTriangle: __webpack_require__(1148),
                    Line: __webpack_require__(1149),
                    Polygon: __webpack_require__(1150),
                    Rectangle: __webpack_require__(1151),
                    Star: __webpack_require__(1152),
                    Triangle: __webpack_require__(1153)
                },
                Creators: {
                    Blitter: __webpack_require__(1154),
                    Container: __webpack_require__(1155),
                    DynamicBitmapText: __webpack_require__(1156),
                    Graphics: __webpack_require__(1157),
                    Group: __webpack_require__(1158),
                    Image: __webpack_require__(1159),
                    Layer: __webpack_require__(1160),
                    Particles: __webpack_require__(1161),
                    RenderTexture: __webpack_require__(1162),
                    Rope: __webpack_require__(1163),
                    Sprite: __webpack_require__(1164),
                    StaticBitmapText: __webpack_require__(1165),
                    Text: __webpack_require__(1166),
                    TileSprite: __webpack_require__(1167),
                    Zone: __webpack_require__(1168),
                    Video: __webpack_require__(1169)
                }
            };
            GameObjects.Shader = __webpack_require__(226);
            GameObjects.Mesh = __webpack_require__(227);
            GameObjects.PointLight = __webpack_require__(149);
            GameObjects.Factories.Shader = __webpack_require__(1178);
            GameObjects.Factories.Mesh = __webpack_require__(1179);
            GameObjects.Factories.PointLight = __webpack_require__(1180);
            GameObjects.Creators.Shader = __webpack_require__(1181);
            GameObjects.Creators.Mesh = __webpack_require__(1182);
            GameObjects.Creators.PointLight = __webpack_require__(1183);
            GameObjects.Light = __webpack_require__(475);
            GameObjects.LightsManager = __webpack_require__(476);
            GameObjects.LightsPlugin = __webpack_require__(1184);
            module1.exports = GameObjects;
        /***/ },
        /* 1008 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var List = __webpack_require__(107);
            var PluginCache = __webpack_require__(24);
            var GameObjectEvents = __webpack_require__(75);
            var SceneEvents = __webpack_require__(21);
            var StableSort = __webpack_require__(79);
            /**
 * @classdesc
 * The Display List plugin.
 *
 * Display Lists belong to a Scene and maintain the list of Game Objects to render every frame.
 *
 * Some of these Game Objects may also be part of the Scene's [Update List]{@link Phaser.GameObjects.UpdateList}, for updating.
 *
 * @class DisplayList
 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Display List belongs to.
 */ var DisplayList = new Class({
                Extends: List,
                initialize: function DisplayList(scene) {
                    List.call(this, scene);
                    /**
         * The flag the determines whether Game Objects should be sorted when `depthSort()` is called.
         *
         * @name Phaser.GameObjects.DisplayList#sortChildrenFlag
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.sortChildrenFlag = false;
                    /**
         * The Scene that this Display List belongs to.
         *
         * @name Phaser.GameObjects.DisplayList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.DisplayList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The Scene's Event Emitter.
         *
         * @name Phaser.GameObjects.DisplayList#events
         * @type {Phaser.Events.EventEmitter}
         * @since 3.50.0
         */ this.events = scene.sys.events;
                    //  Set the List callbacks
                    this.addCallback = this.addChildCallback;
                    this.removeCallback = this.removeChildCallback;
                    this.events.once(SceneEvents.BOOT, this.boot, this);
                    this.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * Internal method called from `List.addCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#addChildCallback
     * @private
     * @fires Phaser.Scenes.Events#ADDED_TO_SCENE
     * @fires Phaser.GameObjects.Events#ADDED_TO_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was added to the list.
     */ addChildCallback: function(gameObject) {
                    gameObject.emit(GameObjectEvents.ADDED_TO_SCENE, gameObject, this.scene);
                    if (gameObject.displayList) gameObject.displayList.remove(gameObject);
                    gameObject.displayList = this;
                    this.queueDepthSort();
                    this.events.emit(SceneEvents.ADDED_TO_SCENE, gameObject, this.scene);
                },
                /**
     * Internal method called from `List.removeCallback`.
     *
     * @method Phaser.GameObjects.DisplayList#removeChildCallback
     * @private
     * @fires Phaser.Scenes.Events#REMOVED_FROM_SCENE
     * @fires Phaser.GameObjects.Events#REMOVED_FROM_SCENE
     * @since 3.50.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was removed from the list.
     */ removeChildCallback: function(gameObject) {
                    gameObject.emit(GameObjectEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                    gameObject.displayList = null;
                    this.queueDepthSort();
                    this.events.emit(SceneEvents.REMOVED_FROM_SCENE, gameObject, this.scene);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.DisplayList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    this.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Force a sort of the display list on the next call to depthSort.
     *
     * @method Phaser.GameObjects.DisplayList#queueDepthSort
     * @since 3.0.0
     */ queueDepthSort: function() {
                    this.sortChildrenFlag = true;
                },
                /**
     * Immediately sorts the display list if the flag is set.
     *
     * @method Phaser.GameObjects.DisplayList#depthSort
     * @since 3.0.0
     */ depthSort: function() {
                    if (this.sortChildrenFlag) {
                        StableSort(this.list, this.sortByDepth);
                        this.sortChildrenFlag = false;
                    }
                },
                /**
     * Compare the depth of two Game Objects.
     *
     * @method Phaser.GameObjects.DisplayList#sortByDepth
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object.
     *
     * @return {number} The difference between the depths of each Game Object.
     */ sortByDepth: function(childA, childB) {
                    return childA._depth - childB._depth;
                },
                /**
     * Returns an array which contains all objects currently on the Display List.
     * This is a reference to the main list array, not a copy of it, so be careful not to modify it.
     *
     * @method Phaser.GameObjects.DisplayList#getChildren
     * @since 3.12.0
     *
     * @return {Phaser.GameObjects.GameObject[]} The group members.
     */ getChildren: function() {
                    return this.list;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.DisplayList#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var list = this.list;
                    var i = list.length;
                    while(i--)list[i].destroy(true);
                    list.length = 0;
                    this.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.DisplayList#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.events = null;
                }
            });
            PluginCache.register('DisplayList', DisplayList, 'displayList');
            module1.exports = DisplayList;
        /***/ },
        /* 1009 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Array.Matrix
 */ module1.exports = {
                CheckMatrix: __webpack_require__(206),
                MatrixToString: __webpack_require__(1010),
                ReverseColumns: __webpack_require__(1011),
                ReverseRows: __webpack_require__(1012),
                Rotate180: __webpack_require__(1013),
                RotateLeft: __webpack_require__(1014),
                RotateMatrix: __webpack_require__(146),
                RotateRight: __webpack_require__(1015),
                Translate: __webpack_require__(1016),
                TransposeMatrix: __webpack_require__(429)
            };
        /***/ },
        /* 1010 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Pad = __webpack_require__(183);
            var CheckMatrix = __webpack_require__(206);
            /**
 * Generates a string (which you can pass to console.log) from the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.MatrixToString
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix]
 *
 * @param {T[][]} [matrix] - A 2-dimensional array.
 *
 * @return {string} A string representing the matrix.
 */ var MatrixToString = function(matrix) {
                var str = '';
                if (!CheckMatrix(matrix)) return str;
                for(var r = 0; r < matrix.length; r++){
                    for(var c = 0; c < matrix[r].length; c++){
                        var cell = matrix[r][c].toString();
                        if (cell !== 'undefined') str += Pad(cell, 2);
                        else str += '?';
                        if (c < matrix[r].length - 1) str += ' |';
                    }
                    if (r < matrix.length - 1) {
                        str += '\n';
                        for(var i = 0; i < matrix[r].length; i++){
                            str += '---';
                            if (i < matrix[r].length - 1) str += '+';
                        }
                        str += '\n';
                    }
                }
                return str;
            };
            module1.exports = MatrixToString;
        /***/ },
        /* 1011 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the columns in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseColumns
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the columns for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseColumns = function(matrix) {
                return matrix.reverse();
            };
            module1.exports = ReverseColumns;
        /***/ },
        /* 1012 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the rows in the given Array Matrix.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.ReverseRows
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to reverse the rows for.
 *
 * @return {T[][]} The column reversed matrix.
 */ var ReverseRows = function(matrix) {
                for(var i = 0; i < matrix.length; i++)matrix[i].reverse();
                return matrix;
            };
            module1.exports = ReverseRows;
        /***/ },
        /* 1013 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(146);
            /**
 * Rotates the array matrix 180 degrees.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Rotate180
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var Rotate180 = function(matrix) {
                return RotateMatrix(matrix, 180);
            };
            module1.exports = Rotate180;
        /***/ },
        /* 1014 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(146);
            /**
 * Rotates the array matrix to the left (or 90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateLeft
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateLeft = function(matrix) {
                return RotateMatrix(matrix, 90);
            };
            module1.exports = RotateLeft;
        /***/ },
        /* 1015 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateMatrix = __webpack_require__(146);
            /**
 * Rotates the array matrix to the left (or -90 degrees)
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.RotateRight
 * @since 3.0.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array to rotate.
 *
 * @return {T[][]} The rotated matrix array. The source matrix should be discard for the returned matrix.
 */ var RotateRight = function(matrix) {
                return RotateMatrix(matrix, -90);
            };
            module1.exports = RotateRight;
        /***/ },
        /* 1016 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateLeft = __webpack_require__(175);
            var RotateRight = __webpack_require__(176);
            /**
 * Translates the given Array Matrix by shifting each column and row the
 * amount specified.
 *
 * A matrix is a two-dimensional array (array of arrays), where all sub-arrays (rows)
 * have the same length. There must be at least two rows. This is an example matrix:
 *
 * ```
 * [
 *    [ 1, 1, 1, 1, 1, 1 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 2, 0, 1, 2, 0, 4 ],
 *    [ 2, 0, 3, 4, 0, 4 ],
 *    [ 2, 0, 0, 0, 0, 4 ],
 *    [ 3, 3, 3, 3, 3, 3 ]
 * ]
 * ```
 *
 * @function Phaser.Utils.Array.Matrix.Translate
 * @since 3.50.0
 *
 * @generic T
 * @genericUse {T[][]} - [matrix,$return]
 *
 * @param {T[][]} [matrix] - The array matrix to translate.
 * @param {number} [x=0] - The amount to horizontally translate the matrix by.
 * @param {number} [y=0] - The amount to vertically translate the matrix by.
 *
 * @return {T[][]} The translated matrix.
 */ var TranslateMatrix = function(matrix, x, y) {
                if (x === undefined) x = 0;
                if (y === undefined) y = 0;
                //  Vertical translation
                if (y !== 0) {
                    if (y < 0) //  Shift Up
                    RotateLeft(matrix, Math.abs(y));
                    else //  Shift Down
                    RotateRight(matrix, y);
                }
                //  Horizontal translation
                if (x !== 0) for(var i = 0; i < matrix.length; i++){
                    var row = matrix[i];
                    if (x < 0) RotateLeft(row, Math.abs(x));
                    else RotateRight(row, x);
                }
                return matrix;
            };
            module1.exports = TranslateMatrix;
        /***/ },
        /* 1017 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array.
 *
 * Each item must be unique within the array.
 *
 * The array is modified in-place and returned.
 *
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 *
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.Add
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array. Each item must be unique within the array.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var Add = function(array, item, limit, callback, context) {
                if (context === undefined) context = array;
                if (limit > 0) {
                    var remaining = limit - array.length;
                    //  There's nothing more we can do here, the array is full
                    if (remaining <= 0) return null;
                }
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    if (array.indexOf(item) === -1) {
                        array.push(item);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to insert
                //  Ensure all the items are unique
                var itemLength = item.length - 1;
                while(itemLength >= 0){
                    if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                    item.splice(itemLength, 1);
                    itemLength--;
                }
                //  Anything left?
                itemLength = item.length;
                if (itemLength === 0) return null;
                if (limit > 0 && itemLength > remaining) {
                    item.splice(remaining);
                    itemLength = remaining;
                }
                for(var i = 0; i < itemLength; i++){
                    var entry = item[i];
                    array.push(entry);
                    if (callback) callback.call(context, entry);
                }
                return item;
            };
            module1.exports = Add;
        /***/ },
        /* 1018 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Adds the given item, or array of items, to the array starting at the index specified.
 * 
 * Each item must be unique within the array.
 * 
 * Existing elements in the array are shifted up.
 * 
 * The array is modified in-place and returned.
 * 
 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
 * added will take the array length over this limit, it will stop adding once the limit is reached.
 * 
 * You can optionally specify a callback to be invoked for each item successfully added to the array.
 *
 * @function Phaser.Utils.Array.AddAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be added to.
 * @param {any|any[]} item - The item, or array of items, to add to the array.
 * @param {number} [index=0] - The index in the array where the item will be inserted.
 * @param {number} [limit] - Optional limit which caps the size of the array.
 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {array} The input array.
 */ var AddAt = function(array, item, index, limit, callback, context) {
                if (index === undefined) index = 0;
                if (context === undefined) context = array;
                if (limit > 0) {
                    var remaining = limit - array.length;
                    //  There's nothing more we can do here, the array is full
                    if (remaining <= 0) return null;
                }
                //  Fast path to avoid array mutation and iteration
                if (!Array.isArray(item)) {
                    if (array.indexOf(item) === -1) {
                        array.splice(index, 0, item);
                        if (callback) callback.call(context, item);
                        return item;
                    } else return null;
                }
                //  If we got this far, we have an array of items to insert
                //  Ensure all the items are unique
                var itemLength = item.length - 1;
                while(itemLength >= 0){
                    if (array.indexOf(item[itemLength]) !== -1) //  Already exists in array, so remove it
                    item.pop();
                    itemLength--;
                }
                //  Anything left?
                itemLength = item.length;
                if (itemLength === 0) return null;
                //  Truncate to the limit
                if (limit > 0 && itemLength > remaining) {
                    item.splice(remaining);
                    itemLength = remaining;
                }
                for(var i = itemLength - 1; i >= 0; i--){
                    var entry = item[i];
                    array.splice(index, 0, entry);
                    if (callback) callback.call(context, entry);
                }
                return item;
            };
            module1.exports = AddAt;
        /***/ },
        /* 1019 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the top of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.BringToTop
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var BringToTop = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex < array.length) {
                    array.splice(currentIndex, 1);
                    array.push(item);
                }
                return item;
            };
            module1.exports = BringToTop;
        /***/ },
        /* 1020 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Returns the total number of elements in the array which have a property matching the given value.
 *
 * @function Phaser.Utils.Array.CountAllMatching
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test on each array element.
 * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {number} The total number of elements with properties matching the given value.
 */ var CountAllMatching = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                var total = 0;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var child = array[i];
                    if (child[property] === value) total++;
                }
                return total;
            };
            module1.exports = CountAllMatching;
        /***/ },
        /* 1021 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Passes each element in the array to the given callback.
 *
 * @function Phaser.Utils.Array.Each
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the current array item.
 *
 * @return {array} The input array.
 */ var Each = function(array, callback, context) {
                var i;
                var args = [
                    null
                ];
                for(i = 3; i < arguments.length; i++)args.push(arguments[i]);
                for(i = 0; i < array.length; i++){
                    args[0] = array[i];
                    callback.apply(context, args);
                }
                return array;
            };
            module1.exports = Each;
        /***/ },
        /* 1022 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Passes each element in the array, between the start and end indexes, to the given callback.
 *
 * @function Phaser.Utils.Array.EachInRange
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {function} callback - A callback to be invoked for each item in the array.
 * @param {object} context - The context in which the callback is invoked.
 * @param {number} startIndex - The start index to search from.
 * @param {number} endIndex - The end index to search to.
 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
 *
 * @return {array} The input array.
 */ var EachInRange = function(array, callback, context, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) {
                    var i;
                    var args = [
                        null
                    ];
                    for(i = 5; i < arguments.length; i++)args.push(arguments[i]);
                    for(i = startIndex; i < endIndex; i++){
                        args[0] = array[i];
                        callback.apply(context, args);
                    }
                }
                return array;
            };
            module1.exports = EachInRange;
        /***/ },
        /* 1023 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element down one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveDown
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move down the array.
 *
 * @return {array} The input array.
 */ var MoveDown = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex > 0) {
                    var item2 = array[currentIndex - 1];
                    var index2 = array.indexOf(item2);
                    array[currentIndex] = item2;
                    array[index2] = item;
                }
                return array;
            };
            module1.exports = MoveDown;
        /***/ },
        /* 1024 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves an element in an array to a new position within the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveTo
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 * @param {number} index - The new index that the element will be moved to.
 *
 * @return {*} The element that was moved.
 */ var MoveTo = function(array, item, index) {
                var currentIndex = array.indexOf(item);
                if (currentIndex === -1 || index < 0 || index >= array.length) throw new Error('Supplied index out of bounds');
                if (currentIndex !== index) {
                    //  Remove
                    array.splice(currentIndex, 1);
                    //  Add in new location
                    array.splice(index, 0, item);
                }
                return item;
            };
            module1.exports = MoveTo;
        /***/ },
        /* 1025 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given array element up one place in the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.MoveUp
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item - The element to move up the array.
 *
 * @return {array} The input array.
 */ var MoveUp = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex < array.length - 1) {
                    //  The element one above `item` in the array
                    var item2 = array[currentIndex + 1];
                    var index2 = array.indexOf(item2);
                    array[currentIndex] = item2;
                    array[index2] = item;
                }
                return array;
            };
            module1.exports = MoveUp;
        /***/ },
        /* 1026 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RoundAwayFromZero = __webpack_require__(357);
            /**
 * Create an array of numbers (positive and/or negative) progressing from `start`
 * up to but not including `end` by advancing by `step`.
 *
 * If `start` is less than `end` a zero-length range is created unless a negative `step` is specified.
 *
 * Certain values for `start` and `end` (eg. NaN/undefined/null) are currently coerced to 0;
 * for forward compatibility make sure to pass in actual numbers.
 * 
 * @example
 * NumberArrayStep(4);
 * // => [0, 1, 2, 3]
 *
 * NumberArrayStep(1, 5);
 * // => [1, 2, 3, 4]
 *
 * NumberArrayStep(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * NumberArrayStep(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * NumberArrayStep(1, 4, 0);
 * // => [1, 1, 1]
 *
 * NumberArrayStep(0);
 * // => []
 *
 * @function Phaser.Utils.Array.NumberArrayStep
 * @since 3.0.0
 *
 * @param {number} [start=0] - The start of the range.
 * @param {number} [end=null] - The end of the range.
 * @param {number} [step=1] - The value to increment or decrement by.
 *
 * @return {number[]} The array of number values.
 */ var NumberArrayStep = function(start, end, step) {
                if (start === undefined) start = 0;
                if (end === undefined) end = null;
                if (step === undefined) step = 1;
                if (end === null) {
                    end = start;
                    start = 0;
                }
                var result = [];
                var total = Math.max(RoundAwayFromZero((end - start) / (step || 1)), 0);
                for(var i = 0; i < total; i++){
                    result.push(start);
                    start += step;
                }
                return result;
            };
            module1.exports = NumberArrayStep;
        /***/ },
        /* 1027 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes the item from the given position in the array.
 * 
 * The array is modified in-place.
 * 
 * You can optionally specify a callback to be invoked for the item if it is successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveAt
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} index - The array index to remove the item from. The index must be in bounds or it will throw an error.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {*} The item that was removed.
 */ var RemoveAt = function(array, index, callback, context) {
                if (context === undefined) context = array;
                if (index < 0 || index > array.length - 1) throw new Error('Index out of bounds');
                var item = SpliceOne(array, index);
                if (callback) callback.call(context, item);
                return item;
            };
            module1.exports = RemoveAt;
        /***/ },
        /* 1028 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Removes the item within the given range in the array.
 * 
 * The array is modified in-place.
 * 
 * You can optionally specify a callback to be invoked for the item/s successfully removed from the array.
 *
 * @function Phaser.Utils.Array.RemoveBetween
 * @since 3.4.0
 *
 * @param {array} array - The array to be modified.
 * @param {number} startIndex - The start index to remove from.
 * @param {number} endIndex - The end index to remove to.
 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
 * @param {object} [context] - The context in which the callback is invoked.
 *
 * @return {Array.<*>} An array of items that were removed.
 */ var RemoveBetween = function(array, startIndex, endIndex, callback, context) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (context === undefined) context = array;
                if (SafeRange(array, startIndex, endIndex)) {
                    var size = endIndex - startIndex;
                    var removed = array.splice(startIndex, size);
                    if (callback) for(var i = 0; i < removed.length; i++){
                        var entry = removed[i];
                        callback.call(context, entry);
                    }
                    return removed;
                } else return [];
            };
            module1.exports = RemoveBetween;
        /***/ },
        /* 1029 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SpliceOne = __webpack_require__(74);
            /**
 * Removes a random object from the given array and returns it.
 * Will return null if there are no array items that fall within the specified range or if there is no item for the randomly chosen index.
 *
 * @function Phaser.Utils.Array.RemoveRandomElement
 * @since 3.0.0
 *
 * @param {array} array - The array to removed a random element from.
 * @param {number} [start=0] - The array index to start the search from.
 * @param {number} [length=array.length] - Optional restriction on the number of elements to randomly select from.
 *
 * @return {object} The random element that was removed, or `null` if there were no array elements that fell within the given range.
 */ var RemoveRandomElement = function(array, start, length) {
                if (start === undefined) start = 0;
                if (length === undefined) length = array.length;
                var randomIndex = start + Math.floor(Math.random() * length);
                return SpliceOne(array, randomIndex);
            };
            module1.exports = RemoveRandomElement;
        /***/ },
        /* 1030 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Replaces an element of the array with the new element.
 * The new element cannot already be a member of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Replace
 * @since 3.4.0
 *
 * @param {array} array - The array to search within.
 * @param {*} oldChild - The element in the array that will be replaced.
 * @param {*} newChild - The element to be inserted into the array at the position of `oldChild`.
 *
 * @return {boolean} Returns true if the oldChild was successfully replaced, otherwise returns false.
 */ var Replace = function(array, oldChild, newChild) {
                var index1 = array.indexOf(oldChild);
                var index2 = array.indexOf(newChild);
                if (index1 !== -1 && index2 === -1) {
                    array[index1] = newChild;
                    return true;
                } else return false;
            };
            module1.exports = Replace;
        /***/ },
        /* 1031 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Moves the given element to the bottom of the array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.SendToBack
 * @since 3.4.0
 *
 * @param {array} array - The array.
 * @param {*} item - The element to move.
 *
 * @return {*} The element that was moved.
 */ var SendToBack = function(array, item) {
                var currentIndex = array.indexOf(item);
                if (currentIndex !== -1 && currentIndex > 0) {
                    array.splice(currentIndex, 1);
                    array.unshift(item);
                }
                return item;
            };
            module1.exports = SendToBack;
        /***/ },
        /* 1032 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SafeRange = __webpack_require__(78);
            /**
 * Scans the array for elements with the given property. If found, the property is set to the `value`.
 *
 * For example: `SetAll('visible', true)` would set all elements that have a `visible` property to `false`.
 *
 * Optionally you can specify a start and end index. For example if the array had 100 elements,
 * and you set `startIndex` to 0 and `endIndex` to 50, it would update only the first 50 elements.
 *
 * @function Phaser.Utils.Array.SetAll
 * @since 3.4.0
 *
 * @param {array} array - The array to search.
 * @param {string} property - The property to test for on each array element.
 * @param {*} value - The value to set the property to.
 * @param {number} [startIndex] - An optional start index to search from.
 * @param {number} [endIndex] - An optional end index to search to.
 *
 * @return {array} The input array.
 */ var SetAll = function(array, property, value, startIndex, endIndex) {
                if (startIndex === undefined) startIndex = 0;
                if (endIndex === undefined) endIndex = array.length;
                if (SafeRange(array, startIndex, endIndex)) for(var i = startIndex; i < endIndex; i++){
                    var entry = array[i];
                    if (entry.hasOwnProperty(property)) entry[property] = value;
                }
                return array;
            };
            module1.exports = SetAll;
        /***/ },
        /* 1033 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the position of two elements in the given array.
 * The elements must exist in the same array.
 * The array is modified in-place.
 *
 * @function Phaser.Utils.Array.Swap
 * @since 3.4.0
 *
 * @param {array} array - The input array.
 * @param {*} item1 - The first element to swap.
 * @param {*} item2 - The second element to swap.
 *
 * @return {array} The input array.
 */ var Swap = function(array, item1, item2) {
                if (item1 === item2) return;
                var index1 = array.indexOf(item1);
                var index2 = array.indexOf(item2);
                if (index1 < 0 || index2 < 0) throw new Error('Supplied items must be elements of the same array');
                array[index1] = item2;
                array[index2] = item1;
                return array;
            };
            module1.exports = Swap;
        /***/ },
        /* 1034 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ProcessQueue = __webpack_require__(208);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * The Update List plugin.
 *
 * Update Lists belong to a Scene and maintain the list Game Objects to be updated every frame.
 *
 * Some or all of these Game Objects may also be part of the Scene's [Display List]{@link Phaser.GameObjects.DisplayList}, for Rendering.
 *
 * @class UpdateList
 * @extends Phaser.Structs.ProcessQueue.<Phaser.GameObjects.GameObject>
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that the Update List belongs to.
 */ var UpdateList = new Class({
                Extends: ProcessQueue,
                initialize: function UpdateList(scene) {
                    ProcessQueue.call(this);
                    //  No duplicates in this list
                    this.checkQueue = true;
                    /**
         * The Scene that the Update List belongs to.
         *
         * @name Phaser.GameObjects.UpdateList#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.GameObjects.UpdateList#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The `pending` list is a selection of items which are due to be made 'active' in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_pending
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `active` list is a selection of items which are considered active and should be updated.
         *
         * @name Phaser.GameObjects.UpdateList#_active
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The `destroy` list is a selection of items that were active and are awaiting being destroyed in the next update.
         *
         * @name Phaser.GameObjects.UpdateList#_destroy
         * @type {Array.<*>}
         * @private
         * @default []
         * @since 3.20.0
         */ /**
         * The total number of items awaiting processing.
         *
         * @name Phaser.GameObjects.UpdateList#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.GameObjects.UpdateList#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.update, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.sceneUpdate, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The update step.
     *
     * Pre-updates every active Game Object in the list.
     *
     * @method Phaser.GameObjects.UpdateList#sceneUpdate
     * @since 3.20.0
     *
     * @param {number} time - The current timestamp.
     * @param {number} delta - The delta time elapsed since the last frame.
     */ sceneUpdate: function(time, delta) {
                    var list = this._active;
                    var length = list.length;
                    for(var i = 0; i < length; i++){
                        var gameObject = list[i];
                        if (gameObject.active) gameObject.preUpdate.call(gameObject, time, delta);
                    }
                },
                /**
     * The Scene that owns this plugin is shutting down.
     *
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.GameObjects.UpdateList#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    var i = this._active.length;
                    while(i--)this._active[i].destroy(true);
                    i = this._pending.length;
                    while(i--)this._pending[i].destroy(true);
                    i = this._destroy.length;
                    while(i--)this._destroy[i].destroy(true);
                    this._toProcess = 0;
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                    this.removeAllListeners();
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.sceneUpdate, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     *
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.GameObjects.UpdateList#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.systems.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('UpdateList', UpdateList, 'updateList');
            module1.exports = UpdateList;
        /***/ },
        /* 1035 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Add Event.
 * 
 * This event is dispatched by a Process Queue when a new item is successfully moved to its active list.
 * 
 * You will most commonly see this used by a Scene's Update List when a new Game Object has been added.
 * 
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('add', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_ADD
 * @since 3.20.0
 * 
 * @param {*} item - The item that was added to the Process Queue.
 */ module1.exports = 'add';
        /***/ },
        /* 1036 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Process Queue Remove Event.
 * 
 * This event is dispatched by a Process Queue when a new item is successfully removed from its active list.
 * 
 * You will most commonly see this used by a Scene's Update List when a Game Object has been removed.
 * 
 * In that instance, listen to this event from within a Scene using: `this.sys.updateList.on('remove', listener)`.
 *
 * @event Phaser.Structs.Events#PROCESS_QUEUE_REMOVE
 * @since 3.20.0
 * 
 * @param {*} item - The item that was removed from the Process Queue.
 */ module1.exports = 'remove';
        /***/ },
        /* 1037 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the full bounds, in local and world space, of a BitmapText Game Object.
 *
 * Returns a BitmapTextSize object that contains global and local variants of the Game Objects x and y coordinates and
 * its width and height. Also includes an array of the line lengths and all word positions.
 *
 * The global position and size take into account the Game Object's position and scale.
 *
 * The local position and size just takes into account the font data.
 *
 * @function GetBitmapTextSize
 * @since 3.0.0
 * @private
 *
 * @param {(Phaser.GameObjects.DynamicBitmapText|Phaser.GameObjects.BitmapText)} src - The BitmapText to calculate the bounds values for.
 * @param {boolean} [round=false] - Whether to round the positions to the nearest integer.
 * @param {boolean} [updateOrigin=false] - Whether to update the origin of the BitmapText after bounds calculations?
 * @param {object} [out] - Object to store the results in, to save constant object creation. If not provided an empty object is returned.
 *
 * @return {Phaser.Types.GameObjects.BitmapText.BitmapTextSize} The calculated bounds values of the BitmapText.
 */ var GetBitmapTextSize = function(src, round, updateOrigin, out) {
                if (updateOrigin === undefined) updateOrigin = false;
                if (out === undefined) {
                    out = {
                        local: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        },
                        global: {
                            x: 0,
                            y: 0,
                            width: 0,
                            height: 0
                        },
                        lines: {
                            shortest: 0,
                            longest: 0,
                            lengths: null,
                            height: 0
                        },
                        wrappedText: '',
                        words: [],
                        characters: [],
                        scaleX: 0,
                        scaleY: 0
                    };
                    return out;
                }
                var text = src.text;
                var textLength = text.length;
                var maxWidth = src.maxWidth;
                var wordWrapCharCode = src.wordWrapCharCode;
                var bx = Number.MAX_VALUE;
                var by = Number.MAX_VALUE;
                var bw = 0;
                var bh = 0;
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src.letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var align = src._align;
                var x = 0;
                var y = 0;
                var scale = src.fontSize / src.fontData.size;
                var sx = scale * src.scaleX;
                var sy = scale * src.scaleY;
                var lastGlyph = null;
                var lastCharCode = 0;
                var lineWidths = [];
                var shortestLine = Number.MAX_VALUE;
                var longestLine = 0;
                var currentLine = 0;
                var currentLineWidth = 0;
                var i;
                var words = [];
                var characters = [];
                var current = null;
                //  Scan for breach of maxWidth and insert carriage-returns
                if (maxWidth > 0) {
                    for(i = 0; i < textLength; i++){
                        charCode = text.charCodeAt(i);
                        if (charCode === 10) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy,
                                    cr: true
                                });
                                current = null;
                            }
                            xAdvance = 0;
                            yAdvance += lineHeight;
                            lastGlyph = null;
                            continue;
                        }
                        glyph = chars[charCode];
                        if (!glyph) continue;
                        if (lastGlyph !== null) var glyphKerningOffset = glyph.kerning[lastCharCode];
                        if (charCode === wordWrapCharCode) {
                            if (current !== null) {
                                words.push({
                                    word: current.word,
                                    i: current.i,
                                    x: current.x * sx,
                                    y: current.y * sy,
                                    w: current.w * sx,
                                    h: current.h * sy,
                                    cr: false
                                });
                                current = null;
                            }
                        } else {
                            if (current === null) //  We're starting a new word, recording the starting index, etc
                            current = {
                                word: '',
                                i: i,
                                x: xAdvance,
                                y: yAdvance,
                                w: 0,
                                h: lineHeight,
                                cr: false
                            };
                            current.word = current.word.concat(text[i]);
                            current.w += glyph.xOffset + glyph.xAdvance + (glyphKerningOffset !== undefined ? glyphKerningOffset : 0);
                        }
                        xAdvance += glyph.xAdvance + letterSpacing;
                        lastGlyph = glyph;
                        lastCharCode = charCode;
                    }
                    //  Last word
                    if (current !== null) words.push({
                        word: current.word,
                        i: current.i,
                        x: current.x * sx,
                        y: current.y * sy,
                        w: current.w * sx,
                        h: current.h * sy,
                        cr: false
                    });
                    //  Reset for the next loop
                    xAdvance = 0;
                    yAdvance = 0;
                    lastGlyph = null;
                    lastCharCode = 0;
                    //  Loop through the words array and see if we've got any > maxWidth
                    var prev;
                    var offset = 0;
                    var crs = [];
                    for(i = 0; i < words.length; i++){
                        var entry = words[i];
                        var left = entry.x;
                        var right = entry.x + entry.w;
                        if (prev) {
                            var diff = left - (prev.x + prev.w);
                            offset = left - (diff + prev.w);
                            prev = null;
                        }
                        var checkLeft = left - offset;
                        var checkRight = right - offset;
                        if (checkLeft > maxWidth || checkRight > maxWidth) {
                            crs.push(entry.i - 1);
                            if (entry.cr) {
                                crs.push(entry.i + entry.word.length);
                                offset = 0;
                                prev = null;
                            } else prev = entry;
                        } else if (entry.cr) {
                            crs.push(entry.i + entry.word.length);
                            offset = 0;
                            prev = null;
                        }
                    }
                    var stringInsert = function(str, index, value) {
                        return str.substr(0, index) + value + str.substr(index + 1);
                    };
                    for(i = crs.length - 1; i >= 0; i--)// eslint-disable-next-line quotes
                    text = stringInsert(text, crs[i], "\n");
                    out.wrappedText = text;
                    textLength = text.length;
                    //  Recalculated in the next loop
                    words = [];
                    current = null;
                }
                var charIndex = 0;
                for(i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        if (current !== null) {
                            words.push({
                                word: current.word,
                                i: current.i,
                                x: current.x * sx,
                                y: current.y * sy,
                                w: current.w * sx,
                                h: current.h * sy
                            });
                            current = null;
                        }
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        lineWidths[currentLine] = currentLineWidth;
                        if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                        if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                        currentLine++;
                        currentLineWidth = 0;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    x = xAdvance;
                    y = yAdvance;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    if (bx > x) bx = x;
                    if (by > y) by = y;
                    var gw = x + glyph.xAdvance;
                    var gh = y + lineHeight;
                    if (bw < gw) bw = gw;
                    if (bh < gh) bh = gh;
                    var charWidth = glyph.xOffset + glyph.xAdvance + (kerningOffset !== undefined ? kerningOffset : 0);
                    if (charCode === wordWrapCharCode) {
                        if (current !== null) {
                            words.push({
                                word: current.word,
                                i: current.i,
                                x: current.x * sx,
                                y: current.y * sy,
                                w: current.w * sx,
                                h: current.h * sy
                            });
                            current = null;
                        }
                    } else {
                        if (current === null) //  We're starting a new word, recording the starting index, etc
                        current = {
                            word: '',
                            i: charIndex,
                            x: xAdvance,
                            y: yAdvance,
                            w: 0,
                            h: lineHeight
                        };
                        current.word = current.word.concat(text[i]);
                        current.w += charWidth;
                    }
                    characters.push({
                        i: charIndex,
                        char: text[i],
                        code: charCode,
                        x: (glyph.xOffset + xAdvance) * scale,
                        y: (glyph.yOffset + yAdvance) * scale,
                        w: glyph.width * scale,
                        h: glyph.height * scale,
                        t: yAdvance * scale,
                        r: gw * scale,
                        b: lineHeight * scale,
                        line: currentLine,
                        glyph: glyph
                    });
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    currentLineWidth = gw * scale;
                    charIndex++;
                }
                //  Last word
                if (current !== null) words.push({
                    word: current.word,
                    i: current.i,
                    x: current.x * sx,
                    y: current.y * sy,
                    w: current.w * sx,
                    h: current.h * sy
                });
                lineWidths[currentLine] = currentLineWidth;
                if (currentLineWidth > longestLine) longestLine = currentLineWidth;
                if (currentLineWidth < shortestLine) shortestLine = currentLineWidth;
                //  Adjust all of the character positions based on alignment
                if (align > 0) for(var c = 0; c < characters.length; c++){
                    var currentChar = characters[c];
                    if (align === 1) {
                        var ax1 = (longestLine - lineWidths[currentChar.line]) / 2;
                        currentChar.x += ax1;
                        currentChar.r += ax1;
                    } else if (align === 2) {
                        var ax2 = longestLine - lineWidths[currentChar.line];
                        currentChar.x += ax2;
                        currentChar.r += ax2;
                    }
                }
                var local = out.local;
                var global = out.global;
                var lines = out.lines;
                local.x = bx * scale;
                local.y = by * scale;
                local.width = bw * scale;
                local.height = bh * scale;
                global.x = src.x - src._displayOriginX + bx * sx;
                global.y = src.y - src._displayOriginY + by * sy;
                global.width = bw * sx;
                global.height = bh * sy;
                lines.shortest = shortestLine;
                lines.longest = longestLine;
                lines.lengths = lineWidths;
                if (round) {
                    local.x = Math.ceil(local.x);
                    local.y = Math.ceil(local.y);
                    local.width = Math.ceil(local.width);
                    local.height = Math.ceil(local.height);
                    global.x = Math.ceil(global.x);
                    global.y = Math.ceil(global.y);
                    global.width = Math.ceil(global.width);
                    global.height = Math.ceil(global.height);
                    lines.shortest = Math.ceil(shortestLine);
                    lines.longest = Math.ceil(longestLine);
                }
                if (updateOrigin) {
                    src._displayOriginX = src.originX * local.width;
                    src._displayOriginY = src.originY * local.height;
                    global.x = src.x - src._displayOriginX * src.scaleX;
                    global.y = src.y - src._displayOriginY * src.scaleY;
                    if (round) {
                        global.x = Math.ceil(global.x);
                        global.y = Math.ceil(global.y);
                    }
                }
                out.words = words;
                out.characters = characters;
                out.lines.height = lineHeight;
                out.scale = scale;
                out.scaleX = src.scaleX;
                out.scaleY = src.scaleY;
                return out;
            };
            module1.exports = GetBitmapTextSize;
        /***/ },
        /* 1038 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ParseXMLBitmapFont = __webpack_require__(209);
            /**
 * Parse an XML Bitmap Font from an Atlas.
 *
 * Adds the parsed Bitmap Font data to the cache with the `fontName` key.
 *
 * @function ParseFromAtlas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Scene} scene - The Scene to parse the Bitmap Font for.
 * @param {string} fontName - The key of the font to add to the Bitmap Font cache.
 * @param {string} textureKey - The key of the BitmapFont's texture.
 * @param {string} frameKey - The key of the BitmapFont texture's frame.
 * @param {string} xmlKey - The key of the XML data of the font to parse.
 * @param {number} [xSpacing] - The x-axis spacing to add between each letter.
 * @param {number} [ySpacing] - The y-axis spacing to add to the line height.
 *
 * @return {boolean} Whether the parsing was successful or not.
 */ var ParseFromAtlas = function(scene, fontName, textureKey, frameKey, xmlKey, xSpacing, ySpacing) {
                var texture = scene.sys.textures.get(textureKey);
                var frame = texture.get(frameKey);
                var xml = scene.sys.cache.xml.get(xmlKey);
                if (frame && xml) {
                    var data = ParseXMLBitmapFont(xml, frame, xSpacing, ySpacing, texture);
                    scene.sys.cache.bitmapFont.add(fontName, {
                        data: data,
                        texture: textureKey,
                        frame: frameKey
                    });
                    return true;
                } else return false;
            };
            module1.exports = ParseFromAtlas;
        /***/ },
        /* 1039 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1040);
            renderCanvas = __webpack_require__(1042);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1040 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BatchChar = __webpack_require__(1041);
            var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                if (textLength === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var roundPixels = camera.roundPixels;
                var cameraAlpha = camera.alpha;
                var charColors = src.charColors;
                var tintEffect = src.tintFill;
                var getTint = Utils.getTintAppendFloatAlpha;
                var tintTL = getTint(src.tintTopLeft, cameraAlpha * src._alphaTL);
                var tintTR = getTint(src.tintTopRight, cameraAlpha * src._alphaTR);
                var tintBL = getTint(src.tintBottomLeft, cameraAlpha * src._alphaBL);
                var tintBR = getTint(src.tintBottomRight, cameraAlpha * src._alphaBR);
                var texture = src.frame.glTexture;
                var textureUnit = pipeline.setGameObject(src);
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                var i;
                var char;
                var glyph;
                var characters = bounds.characters;
                var dropShadowX = src.dropShadowX;
                var dropShadowY = src.dropShadowY;
                var dropShadow = dropShadowX !== 0 || dropShadowY !== 0;
                renderer.pipelines.preBatch(src);
                if (dropShadow) {
                    var srcShadowColor = src.dropShadowColor;
                    var srcShadowAlpha = src.dropShadowAlpha;
                    var shadowTL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTL);
                    var shadowTR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaTR);
                    var shadowBL = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBL);
                    var shadowBR = getTint(srcShadowColor, cameraAlpha * srcShadowAlpha * src._alphaBR);
                    for(i = 0; i < characters.length; i++){
                        char = characters[i];
                        glyph = char.glyph;
                        if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                        BatchChar(pipeline, src, char, glyph, dropShadowX, dropShadowY, calcMatrix, roundPixels, shadowTL, shadowTR, shadowBL, shadowBR, 1, texture, textureUnit);
                    }
                }
                for(i = 0; i < characters.length; i++){
                    char = characters[i];
                    glyph = char.glyph;
                    if (char.code === 32 || glyph.width === 0 || glyph.height === 0) continue;
                    if (charColors[char.i]) {
                        var color = charColors[char.i];
                        var charTintEffect = color.tintEffect;
                        var charTintTL = getTint(color.tintTL, cameraAlpha * src._alphaTL);
                        var charTintTR = getTint(color.tintTR, cameraAlpha * src._alphaTR);
                        var charTintBL = getTint(color.tintBL, cameraAlpha * src._alphaBL);
                        var charTintBR = getTint(color.tintBR, cameraAlpha * src._alphaBR);
                        BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, charTintTL, charTintTR, charTintBL, charTintBR, charTintEffect, texture, textureUnit);
                    } else BatchChar(pipeline, src, char, glyph, 0, 0, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                //  Debug test if the characters are in the correct place when rendered:
                // pipeline.drawFillRect(tx0, ty0, tx2 - tx0, ty2 - ty0, 0x00ff00, 0.5);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = BitmapTextWebGLRenderer;
        /***/ },
        /* 1041 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders one character of the Bitmap Text to the WebGL Pipeline.
 *
 * @function BatchChar
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipeline - The WebGLPipeline. Must have a `batchQuad` method.
 * @param {Phaser.GameObjects.BitmapText} src - The BitmapText Game Object.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextCharacter} char - The character to render.
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapFontCharacterData} glyph - The character glyph.
 * @param {number} offsetX - The x offset.
 * @param {number} offsetY - The y offset.
 * @param {Phaser.GameObjects.Components.TransformMatrix} calcMatrix - The transform matrix.
 * @param {boolean} roundPixels - Round the transform values or not?
 * @param {number} tintTL - Top-left tint value.
 * @param {number} tintTR - Top-right tint value.
 * @param {number} tintBL - Bottom-left tint value.
 * @param {number} tintBR - Bottom-right tint value.
 * @param {number} tintEffect - The tint effect mode.
 * @param {WebGLTexture} texture - The WebGL texture.
 * @param {number} textureUnit - The texture unit.
 */ var BatchChar = function(pipeline, src, char, glyph, offsetX, offsetY, calcMatrix, roundPixels, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit) {
                var x = char.x - src.displayOriginX + offsetX;
                var y = char.y - src.displayOriginY + offsetY;
                var xw = x + char.w;
                var yh = y + char.h;
                var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, glyph.u0, glyph.v0, glyph.u1, glyph.v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
            };
            module1.exports = BatchChar;
        /***/ },
        /* 1042 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.BitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                var ctx = renderer.currentContext;
                if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var textureFrame = src.texture.frames['__BASE'];
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src._letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var glyphX = 0;
                var glyphY = 0;
                var glyphW = 0;
                var glyphH = 0;
                var x = 0;
                var y = 0;
                var lastGlyph = null;
                var lastCharCode = 0;
                var image = textureFrame.source.image;
                var textureX = textureFrame.cutX;
                var textureY = textureFrame.cutY;
                var scale = src._fontSize / src.fontData.size;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                //  In case the method above changed it (word wrapping)
                if (src.maxWidth > 0) {
                    text = bounds.wrappedText;
                    textLength = text.length;
                }
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                ctx.translate(-src.displayOriginX, -src.displayOriginY);
                var roundPixels = camera.roundPixels;
                for(var i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphX = textureX + glyph.x;
                    glyphY = textureY + glyph.y;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    x = glyph.xOffset + xAdvance;
                    y = glyph.yOffset + yAdvance;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    x *= scale;
                    y *= scale;
                    x += lineOffsetX;
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    if (roundPixels) {
                        x = Math.round(x);
                        y = Math.round(y);
                    }
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.scale(scale, scale);
                    ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = BitmapTextCanvasRenderer;
        /***/ },
        /* 1043 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1044);
            renderCanvas = __webpack_require__(1045);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1044 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var list = src.getRenderList();
                if (list.length === 0) return src.clearRenderDepth(camera);
                src.setRenderDepth(camera);
                var pipeline = renderer.pipelines.set(this.pipeline, src);
                var cameraScrollX = camera.scrollX * src.scrollFactorX;
                var cameraScrollY = camera.scrollY * src.scrollFactorY;
                var calcMatrix = tempMatrix.copyFrom(camera.matrix);
                if (parentMatrix) {
                    calcMatrix.multiplyWithOffset(parentMatrix, -cameraScrollX, -cameraScrollY);
                    cameraScrollX = 0;
                    cameraScrollY = 0;
                }
                var blitterX = src.x - cameraScrollX;
                var blitterY = src.y - cameraScrollY;
                var prevTextureSourceIndex = -1;
                var tintEffect = false;
                var alpha = camera.alpha * src.alpha;
                var roundPixels = camera.roundPixels;
                renderer.pipelines.preBatch(src);
                for(var index = 0; index < list.length; index++){
                    var bob = list[index];
                    var frame = bob.frame;
                    var bobAlpha = bob.alpha * alpha;
                    if (bobAlpha === 0) continue;
                    var width = frame.width;
                    var height = frame.height;
                    var x = blitterX + bob.x + frame.x;
                    var y = blitterY + bob.y + frame.y;
                    if (bob.flipX) {
                        width *= -1;
                        x += frame.width;
                    }
                    if (bob.flipY) {
                        height *= -1;
                        y += frame.height;
                    }
                    var xw = x + width;
                    var yh = y + height;
                    var tx0 = calcMatrix.getX(x, y);
                    var ty0 = calcMatrix.getY(x, y);
                    var tx1 = calcMatrix.getX(xw, yh);
                    var ty1 = calcMatrix.getY(xw, yh);
                    var tint = Utils.getTintAppendFloatAlpha(bob.tint, bobAlpha);
                    //  Bind texture only if the Texture Source is different from before
                    if (frame.sourceIndex !== prevTextureSourceIndex) {
                        var textureUnit = pipeline.setGameObject(src, frame);
                        prevTextureSourceIndex = frame.sourceIndex;
                    }
                    if (roundPixels) {
                        tx0 = Math.round(tx0);
                        ty0 = Math.round(ty0);
                        tx1 = Math.round(tx1);
                        ty1 = Math.round(ty1);
                    }
                    //  TL x/y, BL x/y, BR x/y, TR x/y
                    if (pipeline.batchQuad(src, tx0, ty0, tx0, ty1, tx1, ty1, tx1, ty0, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, frame.glTexture, textureUnit)) prevTextureSourceIndex = -1;
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = BlitterWebGLRenderer;
        /***/ },
        /* 1045 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Blitter#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var BlitterCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var list = src.getRenderList();
                if (list.length === 0) return;
                var ctx = renderer.currentContext;
                var alpha = camera.alpha * src.alpha;
                if (alpha === 0) //  Nothing to see, so abort early
                return;
                camera.addToRenderList(src);
                //  Blend Mode + Scale Mode
                ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
                ctx.imageSmoothingEnabled = !(!renderer.antialias || src.frame.source.scaleMode);
                var cameraScrollX = src.x - camera.scrollX * src.scrollFactorX;
                var cameraScrollY = src.y - camera.scrollY * src.scrollFactorY;
                ctx.save();
                if (parentMatrix) parentMatrix.copyToContext(ctx);
                var roundPixels = camera.roundPixels;
                //  Render bobs
                for(var i = 0; i < list.length; i++){
                    var bob = list[i];
                    var flip = bob.flipX || bob.flipY;
                    var frame = bob.frame;
                    var cd = frame.canvasData;
                    var dx = frame.x;
                    var dy = frame.y;
                    var fx = 1;
                    var fy = 1;
                    var bobAlpha = bob.alpha * alpha;
                    if (bobAlpha === 0) continue;
                    ctx.globalAlpha = bobAlpha;
                    if (!flip) {
                        if (roundPixels) {
                            dx = Math.round(dx);
                            dy = Math.round(dy);
                        }
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx + bob.x + cameraScrollX, dy + bob.y + cameraScrollY, cd.width, cd.height);
                    } else {
                        if (bob.flipX) {
                            fx = -1;
                            dx -= cd.width;
                        }
                        if (bob.flipY) {
                            fy = -1;
                            dy -= cd.height;
                        }
                        ctx.save();
                        ctx.translate(bob.x + cameraScrollX, bob.y + cameraScrollY);
                        ctx.scale(fx, fy);
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, dx, dy, cd.width, cd.height);
                        ctx.restore();
                    }
                }
                ctx.restore();
            };
            module1.exports = BlitterCanvasRenderer;
        /***/ },
        /* 1046 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1047);
            renderCanvas = __webpack_require__(1048);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1047 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderWebGL
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerWebGLRenderer = function(renderer, container, camera, parentMatrix) {
                var children = container.list;
                var childCount = children.length;
                if (childCount === 0) return;
                var transformMatrix = container.localTransform;
                if (parentMatrix) {
                    transformMatrix.loadIdentity();
                    transformMatrix.multiply(parentMatrix);
                    transformMatrix.translate(container.x, container.y);
                    transformMatrix.rotate(container.rotation);
                    transformMatrix.scale(container.scaleX, container.scaleY);
                } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                renderer.pipelines.preBatch(container);
                var containerHasBlendMode = container.blendMode !== -1;
                if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = container.alpha;
                var scrollFactorX = container.scrollFactorX;
                var scrollFactorY = container.scrollFactorY;
                for(var i = 0; i < childCount; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlphaTopLeft;
                    var childAlphaTopRight;
                    var childAlphaBottomLeft;
                    var childAlphaBottomRight;
                    if (child.alphaTopLeft !== undefined) {
                        childAlphaTopLeft = child.alphaTopLeft;
                        childAlphaTopRight = child.alphaTopRight;
                        childAlphaBottomLeft = child.alphaBottomLeft;
                        childAlphaBottomRight = child.alphaBottomRight;
                    } else {
                        var childAlpha = child.alpha;
                        childAlphaTopLeft = childAlpha;
                        childAlphaTopRight = childAlpha;
                        childAlphaBottomLeft = childAlpha;
                        childAlphaBottomRight = childAlpha;
                    }
                    var childScrollFactorX = child.scrollFactorX;
                    var childScrollFactorY = child.scrollFactorY;
                    if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    var mask = child.mask;
                    if (mask) mask.preRenderWebGL(renderer, child, camera);
                    var type = child.type;
                    if (type !== renderer.currentType) {
                        renderer.newType = true;
                        renderer.currentType = type;
                    }
                    renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                    //  Set parent values
                    child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                    child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                    //  Render
                    child.renderWebGL(renderer, child, camera, transformMatrix);
                    //  Restore original values
                    child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                    child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                    if (mask) mask.postRenderWebGL(renderer, camera);
                    renderer.newType = false;
                }
                renderer.pipelines.postBatch(container);
            };
            module1.exports = ContainerWebGLRenderer;
        /***/ },
        /* 1048 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Container#renderCanvas
 * @since 3.4.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ContainerCanvasRenderer = function(renderer, container, camera, parentMatrix) {
                var children = container.list;
                if (children.length === 0) return;
                var transformMatrix = container.localTransform;
                if (parentMatrix) {
                    transformMatrix.loadIdentity();
                    transformMatrix.multiply(parentMatrix);
                    transformMatrix.translate(container.x, container.y);
                    transformMatrix.rotate(container.rotation);
                    transformMatrix.scale(container.scaleX, container.scaleY);
                } else transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
                var containerHasBlendMode = container.blendMode !== -1;
                if (!containerHasBlendMode) //  If Container is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = container._alpha;
                var scrollFactorX = container.scrollFactorX;
                var scrollFactorY = container.scrollFactorY;
                if (container.mask) container.mask.preRenderCanvas(renderer, null, camera);
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlpha = child.alpha;
                    var childScrollFactorX = child.scrollFactorX;
                    var childScrollFactorY = child.scrollFactorY;
                    if (!containerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Container doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    //  Set parent values
                    child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
                    child.setAlpha(childAlpha * alpha);
                    //  Render
                    child.renderCanvas(renderer, child, camera, transformMatrix);
                    //  Restore original values
                    child.setAlpha(childAlpha);
                    child.setScrollFactor(childScrollFactorX, childScrollFactorY);
                }
                if (container.mask) container.mask.postRenderCanvas(renderer);
            };
            module1.exports = ContainerCanvasRenderer;
        /***/ },
        /* 1049 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(437);
            renderCanvas = __webpack_require__(437);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1050 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Phaser Blend Modes to CSS Blend Modes Map.
 *
 * @name Phaser.CSSBlendModes
 * @ignore
 * @enum {string}
 * @memberof Phaser
 * @readonly
 * @since 3.12.0
 */ module1.exports = [
                'normal',
                'multiply',
                'multiply',
                'screen',
                'overlay',
                'darken',
                'lighten',
                'color-dodge',
                'color-burn',
                'hard-light',
                'soft-light',
                'difference',
                'exclusion',
                'hue',
                'saturation',
                'color',
                'luminosity'
            ];
        /***/ },
        /* 1051 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1052);
            renderCanvas = __webpack_require__(1053);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1052 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src.text;
                var textLength = text.length;
                if (textLength === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var spriteMatrix = result.sprite;
                var calcMatrix = result.calc;
                var fontMatrix = tempMatrix;
                var crop = src.cropWidth > 0 || src.cropHeight > 0;
                if (crop) {
                    pipeline.flush();
                    renderer.pushScissor(calcMatrix.tx, calcMatrix.ty, src.cropWidth * calcMatrix.scaleX, src.cropHeight * calcMatrix.scaleY);
                }
                var frame = src.frame;
                var texture = frame.glTexture;
                var tintEffect = src.tintFill;
                var tintTL = Utils.getTintAppendFloatAlpha(src.tintTopLeft, camera.alpha * src._alphaTL);
                var tintTR = Utils.getTintAppendFloatAlpha(src.tintTopRight, camera.alpha * src._alphaTR);
                var tintBL = Utils.getTintAppendFloatAlpha(src.tintBottomLeft, camera.alpha * src._alphaBL);
                var tintBR = Utils.getTintAppendFloatAlpha(src.tintBottomRight, camera.alpha * src._alphaBR);
                var textureUnit = pipeline.setGameObject(src);
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var lastCharCode = 0;
                var letterSpacing = src.letterSpacing;
                var glyph;
                var glyphW = 0;
                var glyphH = 0;
                var lastGlyph;
                var scrollX = src.scrollX;
                var scrollY = src.scrollY;
                var fontData = src.fontData;
                var chars = fontData.chars;
                var lineHeight = fontData.lineHeight;
                var scale = src.fontSize / fontData.size;
                var rotation = 0;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                var bounds = src.getTextBounds(false);
                //  In case the method above changed it (word wrapping)
                if (src.maxWidth > 0) {
                    text = bounds.wrappedText;
                    textLength = text.length;
                }
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                var roundPixels = camera.roundPixels;
                var displayCallback = src.displayCallback;
                var callbackData = src.callbackData;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < textLength; i++){
                    charCode = text.charCodeAt(i);
                    //  Carriage-return
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    var x = glyph.xOffset + xAdvance - scrollX;
                    var y = glyph.yOffset + yAdvance - scrollY;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    scale = src.fontSize / src.fontData.size;
                    rotation = 0;
                    if (displayCallback) {
                        callbackData.color = 0;
                        callbackData.tint.topLeft = tintTL;
                        callbackData.tint.topRight = tintTR;
                        callbackData.tint.bottomLeft = tintBL;
                        callbackData.tint.bottomRight = tintBR;
                        callbackData.index = i;
                        callbackData.charCode = charCode;
                        callbackData.x = x;
                        callbackData.y = y;
                        callbackData.scale = scale;
                        callbackData.rotation = rotation;
                        callbackData.data = glyph.data;
                        var output = displayCallback(callbackData);
                        x = output.x;
                        y = output.y;
                        scale = output.scale;
                        rotation = output.rotation;
                        if (output.color) {
                            tintTL = output.color;
                            tintTR = output.color;
                            tintBL = output.color;
                            tintBR = output.color;
                        } else {
                            tintTL = output.tint.topLeft;
                            tintTR = output.tint.topRight;
                            tintBL = output.tint.bottomLeft;
                            tintBR = output.tint.bottomRight;
                        }
                        tintTL = Utils.getTintAppendFloatAlpha(tintTL, camera.alpha * src._alphaTL);
                        tintTR = Utils.getTintAppendFloatAlpha(tintTR, camera.alpha * src._alphaTR);
                        tintBL = Utils.getTintAppendFloatAlpha(tintBL, camera.alpha * src._alphaBL);
                        tintBR = Utils.getTintAppendFloatAlpha(tintBR, camera.alpha * src._alphaBR);
                    }
                    x *= scale;
                    y *= scale;
                    x -= src.displayOriginX;
                    y -= src.displayOriginY;
                    x += lineOffsetX;
                    fontMatrix.applyITRS(x, y, rotation, scale, scale);
                    calcMatrix.multiply(fontMatrix, spriteMatrix);
                    var u0 = glyph.u0;
                    var v0 = glyph.v0;
                    var u1 = glyph.u1;
                    var v1 = glyph.v1;
                    var xw = glyphW;
                    var yh = glyphH;
                    var tx0 = spriteMatrix.e;
                    var ty0 = spriteMatrix.f;
                    var tx1 = yh * spriteMatrix.c + spriteMatrix.e;
                    var ty1 = yh * spriteMatrix.d + spriteMatrix.f;
                    var tx2 = xw * spriteMatrix.a + yh * spriteMatrix.c + spriteMatrix.e;
                    var ty2 = xw * spriteMatrix.b + yh * spriteMatrix.d + spriteMatrix.f;
                    var tx3 = xw * spriteMatrix.a + spriteMatrix.e;
                    var ty3 = xw * spriteMatrix.b + spriteMatrix.f;
                    if (roundPixels) {
                        tx0 = Math.round(tx0);
                        ty0 = Math.round(ty0);
                        tx1 = Math.round(tx1);
                        ty1 = Math.round(ty1);
                        tx2 = Math.round(tx2);
                        ty2 = Math.round(ty2);
                        tx3 = Math.round(tx3);
                        ty3 = Math.round(ty3);
                    }
                    pipeline.batchQuad(src, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, u0, v0, u1, v1, tintTL, tintTR, tintBL, tintBR, tintEffect, texture, textureUnit);
                }
                if (crop) {
                    pipeline.flush();
                    renderer.popScissor();
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = DynamicBitmapTextWebGLRenderer;
        /***/ },
        /* 1053 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.DynamicBitmapText#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var DynamicBitmapTextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var text = src._text;
                var textLength = text.length;
                var ctx = renderer.currentContext;
                if (textLength === 0 || !SetTransform(renderer, ctx, src, camera, parentMatrix)) return;
                camera.addToRenderList(src);
                var textureFrame = src.frame;
                var displayCallback = src.displayCallback;
                var callbackData = src.callbackData;
                var chars = src.fontData.chars;
                var lineHeight = src.fontData.lineHeight;
                var letterSpacing = src._letterSpacing;
                var xAdvance = 0;
                var yAdvance = 0;
                var charCode = 0;
                var glyph = null;
                var glyphX = 0;
                var glyphY = 0;
                var glyphW = 0;
                var glyphH = 0;
                var x = 0;
                var y = 0;
                var lastGlyph = null;
                var lastCharCode = 0;
                var image = src.frame.source.image;
                var textureX = textureFrame.cutX;
                var textureY = textureFrame.cutY;
                var rotation = 0;
                var scale = 0;
                var baseScale = src._fontSize / src.fontData.size;
                var align = src._align;
                var currentLine = 0;
                var lineOffsetX = 0;
                //  Update the bounds - skipped internally if not dirty
                src.getTextBounds(false);
                var lineData = src._bounds.lines;
                if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[0]) / 2;
                else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[0];
                ctx.translate(-src.displayOriginX, -src.displayOriginY);
                var roundPixels = camera.roundPixels;
                if (src.cropWidth > 0 && src.cropHeight > 0) {
                    ctx.beginPath();
                    ctx.rect(0, 0, src.cropWidth, src.cropHeight);
                    ctx.clip();
                }
                for(var i = 0; i < textLength; i++){
                    //  Reset the scale (in case the callback changed it)
                    scale = baseScale;
                    rotation = 0;
                    charCode = text.charCodeAt(i);
                    if (charCode === 10) {
                        currentLine++;
                        if (align === 1) lineOffsetX = (lineData.longest - lineData.lengths[currentLine]) / 2;
                        else if (align === 2) lineOffsetX = lineData.longest - lineData.lengths[currentLine];
                        xAdvance = 0;
                        yAdvance += lineHeight;
                        lastGlyph = null;
                        continue;
                    }
                    glyph = chars[charCode];
                    if (!glyph) continue;
                    glyphX = textureX + glyph.x;
                    glyphY = textureY + glyph.y;
                    glyphW = glyph.width;
                    glyphH = glyph.height;
                    x = glyph.xOffset + xAdvance - src.scrollX;
                    y = glyph.yOffset + yAdvance - src.scrollY;
                    if (lastGlyph !== null) {
                        var kerningOffset = glyph.kerning[lastCharCode];
                        x += kerningOffset !== undefined ? kerningOffset : 0;
                    }
                    if (displayCallback) {
                        callbackData.index = i;
                        callbackData.charCode = charCode;
                        callbackData.x = x;
                        callbackData.y = y;
                        callbackData.scale = scale;
                        callbackData.rotation = rotation;
                        callbackData.data = glyph.data;
                        var output = displayCallback(callbackData);
                        x = output.x;
                        y = output.y;
                        scale = output.scale;
                        rotation = output.rotation;
                    }
                    x *= scale;
                    y *= scale;
                    x += lineOffsetX;
                    xAdvance += glyph.xAdvance + letterSpacing;
                    lastGlyph = glyph;
                    lastCharCode = charCode;
                    //  Nothing to render or a space? Then skip to the next glyph
                    if (glyphW === 0 || glyphH === 0 || charCode === 32) continue;
                    if (roundPixels) {
                        x = Math.round(x);
                        y = Math.round(y);
                    }
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rotation);
                    ctx.scale(scale, scale);
                    ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = DynamicBitmapTextCanvasRenderer;
        /***/ },
        /* 1054 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1055);
            renderCanvas = __webpack_require__(1056);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1055 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Extern#renderWebGL
 * @since 3.16.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Extern} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ExternWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                renderer.pipelines.clear();
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                src.render.call(src, renderer, camera, calcMatrix);
                renderer.pipelines.rebind();
            };
            module1.exports = ExternWebGLRenderer;
        /***/ },
        /* 1056 */ /***/ function(module1, exports) {
        /***/ },
        /* 1057 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1058);
            //  Needed for Graphics.generateTexture
            renderCanvas = __webpack_require__(442);
            renderCanvas = __webpack_require__(442);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1058 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Commands = __webpack_require__(214);
            var GetCalcMatrix = __webpack_require__(19);
            var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var Point = function(x, y, width) {
                this.x = x;
                this.y = y;
                this.width = width;
            };
            var Path = function(x, y, width) {
                this.points = [];
                this.pointsLength = 1;
                this.points[0] = new Point(x, y, width);
            };
            var matrixStack = [];
            var tempMatrix = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Graphics#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GraphicsWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.commandBuffer.length === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                renderer.pipelines.preBatch(src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var currentMatrix = tempMatrix.loadIdentity();
                var commands = src.commandBuffer;
                var alpha = camera.alpha * src.alpha;
                var lineWidth = 1;
                var fillTint = pipeline.fillTint;
                var strokeTint = pipeline.strokeTint;
                var tx = 0;
                var ty = 0;
                var ta = 0;
                var iterStep = 0.01;
                var PI2 = Math.PI * 2;
                var cmd;
                var path = [];
                var pathIndex = 0;
                var pathOpen = true;
                var lastPath = null;
                var getTint = Utils.getTintAppendFloatAlpha;
                for(var cmdIndex = 0; cmdIndex < commands.length; cmdIndex++){
                    cmd = commands[cmdIndex];
                    switch(cmd){
                        case Commands.BEGIN_PATH:
                            path.length = 0;
                            lastPath = null;
                            pathOpen = true;
                            break;
                        case Commands.CLOSE_PATH:
                            pathOpen = false;
                            if (lastPath && lastPath.points.length) lastPath.points.push(lastPath.points[0]);
                            break;
                        case Commands.FILL_PATH:
                            for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchFillPath(path[pathIndex].points, currentMatrix, calcMatrix);
                            break;
                        case Commands.STROKE_PATH:
                            for(pathIndex = 0; pathIndex < path.length; pathIndex++)pipeline.batchStrokePath(path[pathIndex].points, lineWidth, pathOpen, currentMatrix, calcMatrix);
                            break;
                        case Commands.LINE_STYLE:
                            lineWidth = commands[++cmdIndex];
                            var strokeColor = commands[++cmdIndex];
                            var strokeAlpha = commands[++cmdIndex] * alpha;
                            var strokeTintColor = getTint(strokeColor, strokeAlpha);
                            strokeTint.TL = strokeTintColor;
                            strokeTint.TR = strokeTintColor;
                            strokeTint.BL = strokeTintColor;
                            strokeTint.BR = strokeTintColor;
                            break;
                        case Commands.FILL_STYLE:
                            var fillColor = commands[++cmdIndex];
                            var fillAlpha = commands[++cmdIndex] * alpha;
                            var fillTintColor = getTint(fillColor, fillAlpha);
                            fillTint.TL = fillTintColor;
                            fillTint.TR = fillTintColor;
                            fillTint.BL = fillTintColor;
                            fillTint.BR = fillTintColor;
                            break;
                        case Commands.GRADIENT_FILL_STYLE:
                            var alphaTL = commands[++cmdIndex] * alpha;
                            var alphaTR = commands[++cmdIndex] * alpha;
                            var alphaBL = commands[++cmdIndex] * alpha;
                            var alphaBR = commands[++cmdIndex] * alpha;
                            fillTint.TL = getTint(commands[++cmdIndex], alphaTL);
                            fillTint.TR = getTint(commands[++cmdIndex], alphaTR);
                            fillTint.BL = getTint(commands[++cmdIndex], alphaBL);
                            fillTint.BR = getTint(commands[++cmdIndex], alphaBR);
                            break;
                        case Commands.GRADIENT_LINE_STYLE:
                            lineWidth = commands[++cmdIndex];
                            var gradientLineAlpha = commands[++cmdIndex] * alpha;
                            strokeTint.TL = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.TR = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.BL = getTint(commands[++cmdIndex], gradientLineAlpha);
                            strokeTint.BR = getTint(commands[++cmdIndex], gradientLineAlpha);
                            break;
                        case Commands.ARC:
                            var iteration = 0;
                            var x = commands[++cmdIndex];
                            var y = commands[++cmdIndex];
                            var radius = commands[++cmdIndex];
                            var startAngle = commands[++cmdIndex];
                            var endAngle = commands[++cmdIndex];
                            var anticlockwise = commands[++cmdIndex];
                            var overshoot = commands[++cmdIndex];
                            endAngle -= startAngle;
                            if (anticlockwise) {
                                if (endAngle < -PI2) endAngle = -PI2;
                                else if (endAngle > 0) endAngle = -PI2 + endAngle % PI2;
                            } else if (endAngle > PI2) endAngle = PI2;
                            else if (endAngle < 0) endAngle = PI2 + endAngle % PI2;
                            if (lastPath === null) {
                                lastPath = new Path(x + Math.cos(startAngle) * radius, y + Math.sin(startAngle) * radius, lineWidth);
                                path.push(lastPath);
                                iteration += iterStep;
                            }
                            while(iteration < 1 + overshoot){
                                ta = endAngle * iteration + startAngle;
                                tx = x + Math.cos(ta) * radius;
                                ty = y + Math.sin(ta) * radius;
                                lastPath.points.push(new Point(tx, ty, lineWidth));
                                iteration += iterStep;
                            }
                            ta = endAngle + startAngle;
                            tx = x + Math.cos(ta) * radius;
                            ty = y + Math.sin(ta) * radius;
                            lastPath.points.push(new Point(tx, ty, lineWidth));
                            break;
                        case Commands.FILL_RECT:
                            pipeline.batchFillRect(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                            break;
                        case Commands.FILL_TRIANGLE:
                            pipeline.batchFillTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], currentMatrix, calcMatrix);
                            break;
                        case Commands.STROKE_TRIANGLE:
                            pipeline.batchStrokeTriangle(commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], commands[++cmdIndex], lineWidth, currentMatrix, calcMatrix);
                            break;
                        case Commands.LINE_TO:
                            if (lastPath !== null) lastPath.points.push(new Point(commands[++cmdIndex], commands[++cmdIndex], lineWidth));
                            else {
                                lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                                path.push(lastPath);
                            }
                            break;
                        case Commands.MOVE_TO:
                            lastPath = new Path(commands[++cmdIndex], commands[++cmdIndex], lineWidth);
                            path.push(lastPath);
                            break;
                        case Commands.SAVE:
                            matrixStack.push(currentMatrix.copyToArray());
                            break;
                        case Commands.RESTORE:
                            currentMatrix.copyFromArray(matrixStack.pop());
                            break;
                        case Commands.TRANSLATE:
                            x = commands[++cmdIndex];
                            y = commands[++cmdIndex];
                            currentMatrix.translate(x, y);
                            break;
                        case Commands.SCALE:
                            x = commands[++cmdIndex];
                            y = commands[++cmdIndex];
                            currentMatrix.scale(x, y);
                            break;
                        case Commands.ROTATE:
                            currentMatrix.rotate(commands[++cmdIndex]);
                            break;
                    }
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = GraphicsWebGLRenderer;
        /***/ },
        /* 1059 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1060);
            renderCanvas = __webpack_require__(1061);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1060 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                src.pipeline.batchSprite(src, camera, parentMatrix);
            };
            module1.exports = SpriteWebGLRenderer;
        /***/ },
        /* 1061 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Sprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var SpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = SpriteCanvasRenderer;
        /***/ },
        /* 1062 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1063);
            renderCanvas = __webpack_require__(1064);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1063 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                this.pipeline.batchSprite(src, camera, parentMatrix);
            };
            module1.exports = ImageWebGLRenderer;
        /***/ },
        /* 1064 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Image#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ImageCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = ImageCanvasRenderer;
        /***/ },
        /* 1065 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1066);
            renderCanvas = __webpack_require__(1067);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1066 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var LayerWebGLRenderer = function(renderer, layer, camera) {
                var children = layer.list;
                var childCount = children.length;
                if (childCount === 0) return;
                layer.depthSort();
                renderer.pipelines.preBatch(layer);
                var layerHasBlendMode = layer.blendMode !== -1;
                if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = layer.alpha;
                for(var i = 0; i < childCount; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlphaTopLeft;
                    var childAlphaTopRight;
                    var childAlphaBottomLeft;
                    var childAlphaBottomRight;
                    if (child.alphaTopLeft !== undefined) {
                        childAlphaTopLeft = child.alphaTopLeft;
                        childAlphaTopRight = child.alphaTopRight;
                        childAlphaBottomLeft = child.alphaBottomLeft;
                        childAlphaBottomRight = child.alphaBottomRight;
                    } else {
                        var childAlpha = child.alpha;
                        childAlphaTopLeft = childAlpha;
                        childAlphaTopRight = childAlpha;
                        childAlphaBottomLeft = childAlpha;
                        childAlphaBottomRight = childAlpha;
                    }
                    if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    var mask = child.mask;
                    if (mask) mask.preRenderWebGL(renderer, child, camera);
                    var type = child.type;
                    if (type !== renderer.currentType) {
                        renderer.newType = true;
                        renderer.currentType = type;
                    }
                    renderer.nextTypeMatch = i < childCount - 1 ? children[i + 1].type === renderer.currentType : false;
                    child.setAlpha(childAlphaTopLeft * alpha, childAlphaTopRight * alpha, childAlphaBottomLeft * alpha, childAlphaBottomRight * alpha);
                    //  Render
                    child.renderWebGL(renderer, child, camera);
                    //  Restore original values
                    child.setAlpha(childAlphaTopLeft, childAlphaTopRight, childAlphaBottomLeft, childAlphaBottomRight);
                    if (mask) mask.postRenderWebGL(renderer, camera);
                    renderer.newType = false;
                }
                renderer.pipelines.postBatch(layer);
            };
            module1.exports = LayerWebGLRenderer;
        /***/ },
        /* 1067 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Layer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Layer} layer - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LayerCanvasRenderer = function(renderer, layer, camera) {
                var children = layer.list;
                if (children.length === 0) return;
                layer.depthSort();
                var layerHasBlendMode = layer.blendMode !== -1;
                if (!layerHasBlendMode) //  If Layer is SKIP_TEST then set blend mode to be Normal
                renderer.setBlendMode(0);
                var alpha = layer._alpha;
                if (layer.mask) layer.mask.preRenderCanvas(renderer, null, camera);
                for(var i = 0; i < children.length; i++){
                    var child = children[i];
                    if (!child.willRender(camera)) continue;
                    var childAlpha = child.alpha;
                    if (!layerHasBlendMode && child.blendMode !== renderer.currentBlendMode) //  If Layer doesn't have its own blend mode, then a child can have one
                    renderer.setBlendMode(child.blendMode);
                    //  Set parent values
                    child.setAlpha(childAlpha * alpha);
                    //  Render
                    child.renderCanvas(renderer, child, camera);
                    //  Restore original values
                    child.setAlpha(childAlpha);
                }
                if (layer.mask) layer.mask.postRenderCanvas(renderer);
            };
            module1.exports = LayerCanvasRenderer;
        /***/ },
        /* 1068 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles
 */ module1.exports = {
                EmitterOp: __webpack_require__(443),
                GravityWell: __webpack_require__(444),
                Particle: __webpack_require__(445),
                ParticleEmitter: __webpack_require__(446),
                ParticleEmitterManager: __webpack_require__(217),
                Zones: __webpack_require__(1072)
            };
        /***/ },
        /* 1069 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1070);
            renderCanvas = __webpack_require__(1071);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1070 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var Utils = __webpack_require__(12);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var tempMatrix4 = new TransformMatrix();
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.EmitterManager#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleManagerWebGLRenderer = function(renderer, emitterManager, camera, parentMatrix) {
                var emitters = emitterManager.emitters.list;
                var emittersLength = emitters.length;
                if (emittersLength === 0) return;
                var pipeline = renderer.pipelines.set(emitterManager.pipeline);
                var camMatrix = tempMatrix1;
                var calcMatrix = tempMatrix2;
                var particleMatrix = tempMatrix3;
                var managerMatrix = tempMatrix4;
                if (parentMatrix) {
                    managerMatrix.loadIdentity();
                    managerMatrix.multiply(parentMatrix);
                    managerMatrix.translate(emitterManager.x, emitterManager.y);
                    managerMatrix.rotate(emitterManager.rotation);
                    managerMatrix.scale(emitterManager.scaleX, emitterManager.scaleY);
                } else managerMatrix.applyITRS(emitterManager.x, emitterManager.y, emitterManager.rotation, emitterManager.scaleX, emitterManager.scaleY);
                var roundPixels = camera.roundPixels;
                var texture = emitterManager.defaultFrame.glTexture;
                var getTint = Utils.getTintAppendFloatAlpha;
                var textureUnit = pipeline.setGameObject(emitterManager, emitterManager.defaultFrame);
                renderer.pipelines.preBatch(emitterManager);
                for(var e = 0; e < emittersLength; e++){
                    var emitter = emitters[e];
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    if (!emitter.visible || particleCount === 0) continue;
                    camera.addToRenderList(emitter);
                    var scrollFactorX = emitter.scrollFactorX;
                    var scrollFactorY = emitter.scrollFactorY;
                    renderer.setBlendMode(emitter.blendMode);
                    if (emitter.mask) {
                        emitter.mask.preRenderWebGL(renderer, emitter, camera);
                        renderer.pipelines.set(emitterManager.pipeline);
                    }
                    var tintEffect = 0;
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * camera.alpha;
                        if (alpha <= 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        camMatrix.multiplyWithOffset(managerMatrix, -camera.scrollX * scrollFactorX, -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        var x = -frame.halfWidth;
                        var y = -frame.halfHeight;
                        var xw = x + frame.width;
                        var yh = y + frame.height;
                        var tx0 = calcMatrix.getXRound(x, y, roundPixels);
                        var ty0 = calcMatrix.getYRound(x, y, roundPixels);
                        var tx1 = calcMatrix.getXRound(x, yh, roundPixels);
                        var ty1 = calcMatrix.getYRound(x, yh, roundPixels);
                        var tx2 = calcMatrix.getXRound(xw, yh, roundPixels);
                        var ty2 = calcMatrix.getYRound(xw, yh, roundPixels);
                        var tx3 = calcMatrix.getXRound(xw, y, roundPixels);
                        var ty3 = calcMatrix.getYRound(xw, y, roundPixels);
                        var tint = getTint(particle.tint, alpha);
                        pipeline.batchQuad(emitter, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, frame.u0, frame.v0, frame.u1, frame.v1, tint, tint, tint, tint, tintEffect, texture, textureUnit);
                    }
                    if (emitter.mask) emitter.mask.postRenderWebGL(renderer, camera);
                }
                renderer.pipelines.postBatch(emitterManager);
            };
            module1.exports = ParticleManagerWebGLRenderer;
        /***/ },
        /* 1071 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            var tempMatrix4 = new TransformMatrix();
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Particles.EmitterManager#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ParticleManagerCanvasRenderer = function(renderer, emitterManager, camera, parentMatrix) {
                var emitters = emitterManager.emitters.list;
                var emittersLength = emitters.length;
                if (emittersLength === 0) return;
                var camMatrix = tempMatrix1.copyFrom(camera.matrix);
                var calcMatrix = tempMatrix2;
                var particleMatrix = tempMatrix3;
                var managerMatrix = tempMatrix4;
                if (parentMatrix) {
                    managerMatrix.loadIdentity();
                    managerMatrix.multiply(parentMatrix);
                    managerMatrix.translate(emitterManager.x, emitterManager.y);
                    managerMatrix.rotate(emitterManager.rotation);
                    managerMatrix.scale(emitterManager.scaleX, emitterManager.scaleY);
                } else managerMatrix.applyITRS(emitterManager.x, emitterManager.y, emitterManager.rotation, emitterManager.scaleX, emitterManager.scaleY);
                var ctx = renderer.currentContext;
                var roundPixels = camera.roundPixels;
                for(var e = 0; e < emittersLength; e++){
                    var emitter = emitters[e];
                    var particles = emitter.alive;
                    var particleCount = particles.length;
                    if (!emitter.visible || particleCount === 0) continue;
                    camera.addToRenderList(emitter);
                    var followX = emitter.follow ? emitter.follow.x + emitter.followOffset.x : 0;
                    var followY = emitter.follow ? emitter.follow.y + emitter.followOffset.y : 0;
                    var scrollFactorX = emitter.scrollFactorX;
                    var scrollFactorY = emitter.scrollFactorY;
                    ctx.save();
                    ctx.globalCompositeOperation = renderer.blendModes[emitter.blendMode];
                    for(var i = 0; i < particleCount; i++){
                        var particle = particles[i];
                        var alpha = particle.alpha * camera.alpha;
                        if (alpha <= 0) continue;
                        particleMatrix.applyITRS(particle.x, particle.y, particle.rotation, particle.scaleX, particle.scaleY);
                        camMatrix.copyFrom(camera.matrix);
                        camMatrix.multiplyWithOffset(managerMatrix, followX + -camera.scrollX * scrollFactorX, followY + -camera.scrollY * scrollFactorY);
                        //  Undo the camera scroll
                        particleMatrix.e = particle.x;
                        particleMatrix.f = particle.y;
                        //  Multiply by the particle matrix, store result in calcMatrix
                        camMatrix.multiply(particleMatrix, calcMatrix);
                        var frame = particle.frame;
                        var cd = frame.canvasData;
                        var x = -frame.halfWidth;
                        var y = -frame.halfHeight;
                        ctx.globalAlpha = alpha;
                        ctx.save();
                        calcMatrix.setToContext(ctx);
                        if (roundPixels) {
                            x = Math.round(x);
                            y = Math.round(y);
                        }
                        ctx.imageSmoothingEnabled = !(!renderer.antialias || frame.source.scaleMode);
                        ctx.drawImage(frame.source.image, cd.x, cd.y, cd.width, cd.height, x, y, cd.width, cd.height);
                        ctx.restore();
                    }
                    ctx.restore();
                }
            };
            module1.exports = ParticleManagerCanvasRenderer;
        /***/ },
        /* 1072 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.GameObjects.Particles.Zones
 */ module1.exports = {
                DeathZone: __webpack_require__(447),
                EdgeZone: __webpack_require__(448),
                RandomZone: __webpack_require__(450)
            };
        /***/ },
        /* 1073 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1074);
            renderCanvas = __webpack_require__(1075);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1074 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.RenderTexture#renderWebGL
 * @since 3.2.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.RenderTexture} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RenderTextureWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var cameraAlpha = camera.alpha;
                var renderTarget = src.renderTarget;
                var width = renderTarget.width;
                var height = renderTarget.height;
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline);
                var textureUnit = pipeline.setTexture2D(renderTarget.texture);
                renderer.pipelines.preBatch(src);
                pipeline.batchTexture(src, renderTarget.texture, width, height, src.x, src.y, width, height, src.scaleX, src.scaleY, src.rotation, src.flipX, !src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, cameraAlpha * src._alphaTL), getTint(src.tintTopRight, cameraAlpha * src._alphaTR), getTint(src.tintBottomLeft, cameraAlpha * src._alphaBL), getTint(src.tintBottomRight, cameraAlpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, true, textureUnit);
                renderer.resetTextures();
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RenderTextureWebGLRenderer;
        /***/ },
        /* 1075 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.RenderTexture#renderCanvas
 * @since 3.2.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.RenderTexture} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RenderTextureCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = RenderTextureCanvasRenderer;
        /***/ },
        /* 1076 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = __webpack_require__(1077);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.GameObjects.RetroFont
 * @since 3.6.0
 */ var RetroFont = {
                Parse: __webpack_require__(1078)
            };
            //   Merge in the consts
            RetroFont = Extend(false, RetroFont, RETRO_FONT_CONST);
            module1.exports = RetroFont;
        /***/ },
        /* 1077 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RETRO_FONT_CONST = {
                /**
     * Text Set 1 =  !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET1
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET1: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',
                /**
     * Text Set 2 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET2
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET2: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                /**
     * Text Set 3 = ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET3
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET3: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ',
                /**
     * Text Set 4 = ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET4
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET4: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789',
                /**
     * Text Set 5 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET5
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET5: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() \'!?-*:0123456789',
                /**
     * Text Set 6 = ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.' 
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET6
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET6: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.\' ',
                /**
     * Text Set 7 = AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-'39
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET7
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET7: 'AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-\'39',
                /**
     * Text Set 8 = 0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET8
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET8: '0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                /**
     * Text Set 9 = ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'"?!
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET9
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET9: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,\'"?!',
                /**
     * Text Set 10 = ABCDEFGHIJKLMNOPQRSTUVWXYZ
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET10
     * @type {string}
     * @since 3.6.0
     */ TEXT_SET10: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                /**
     * Text Set 11 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()':;0123456789
     * 
     * @name Phaser.GameObjects.RetroFont.TEXT_SET11
     * @since 3.6.0
     * @type {string}
     */ TEXT_SET11: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()\':;0123456789'
            };
            module1.exports = RETRO_FONT_CONST;
        /***/ },
        /* 1078 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            /**
 * Parses a Retro Font configuration object so you can pass it to the BitmapText constructor
 * and create a BitmapText object using a fixed-width retro font.
 *
 * @function Phaser.GameObjects.RetroFont.Parse
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Phaser Scene.
 * @param {Phaser.Types.GameObjects.BitmapText.RetroFontConfig} config - The font configuration object.
 *
 * @return {object} A parsed Bitmap Font data entry for the Bitmap Font cache.
 */ var ParseRetroFont = function(scene, config) {
                var w = config.width;
                var h = config.height;
                var cx = Math.floor(w / 2);
                var cy = Math.floor(h / 2);
                var letters = GetValue(config, 'chars', '');
                if (letters === '') return;
                var key = GetValue(config, 'image', '');
                var frame = scene.sys.textures.getFrame(key);
                var textureX = frame.cutX;
                var textureY = frame.cutY;
                var textureWidth = frame.source.width;
                var textureHeight = frame.source.height;
                var offsetX = GetValue(config, 'offset.x', 0);
                var offsetY = GetValue(config, 'offset.y', 0);
                var spacingX = GetValue(config, 'spacing.x', 0);
                var spacingY = GetValue(config, 'spacing.y', 0);
                var lineSpacing = GetValue(config, 'lineSpacing', 0);
                var charsPerRow = GetValue(config, 'charsPerRow', null);
                if (charsPerRow === null) {
                    charsPerRow = textureWidth / w;
                    if (charsPerRow > letters.length) charsPerRow = letters.length;
                }
                var x = offsetX;
                var y = offsetY;
                var data = {
                    retroFont: true,
                    font: key,
                    size: w,
                    lineHeight: h + lineSpacing,
                    chars: {}
                };
                var r = 0;
                for(var i = 0; i < letters.length; i++){
                    var charCode = letters.charCodeAt(i);
                    var u0 = (textureX + x) / textureWidth;
                    var v0 = (textureY + y) / textureHeight;
                    var u1 = (textureX + x + w) / textureWidth;
                    var v1 = (textureY + y + h) / textureHeight;
                    data.chars[charCode] = {
                        x: x,
                        y: y,
                        width: w,
                        height: h,
                        centerX: cx,
                        centerY: cy,
                        xOffset: 0,
                        yOffset: 0,
                        xAdvance: w,
                        data: {},
                        kerning: {},
                        u0: u0,
                        v0: v0,
                        u1: u1,
                        v1: v1
                    };
                    r++;
                    if (r === charsPerRow) {
                        r = 0;
                        x = offsetX;
                        y += h + spacingY;
                    } else x += w + spacingX;
                }
                var entry = {
                    data: data,
                    frame: null,
                    texture: key
                };
                return entry;
            };
            module1.exports = ParseRetroFont;
        /***/ },
        /* 1079 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1080);
            renderCanvas = __webpack_require__(1081);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1080 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rope#renderWebGL
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RopeWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var vertices = src.vertices;
                var uvs = src.uv;
                var colors = src.colors;
                var alphas = src.alphas;
                var alpha = src.alpha;
                var getTint = Utils.getTintAppendFloatAlpha;
                var roundPixels = camera.roundPixels;
                var meshVerticesLength = vertices.length;
                var vertexCount = Math.floor(meshVerticesLength * 0.5);
                //  Because it's a triangle strip and we don't want lots of degenerate triangles joining things up
                pipeline.flush();
                renderer.pipelines.preBatch(src);
                var textureUnit = pipeline.setGameObject(src);
                var vertexViewF32 = pipeline.vertexViewF32;
                var vertexViewU32 = pipeline.vertexViewU32;
                var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                var colorIndex = 0;
                var tintEffect = src.tintFill;
                if (src.dirty) src.updateVertices();
                var debugCallback = src.debugCallback;
                var debugVerts = [];
                for(var i = 0; i < meshVerticesLength; i += 2){
                    var x = vertices[i + 0];
                    var y = vertices[i + 1];
                    var tx = x * calcMatrix.a + y * calcMatrix.c + calcMatrix.e;
                    var ty = x * calcMatrix.b + y * calcMatrix.d + calcMatrix.f;
                    if (roundPixels) {
                        tx = Math.round(tx);
                        ty = Math.round(ty);
                    }
                    vertexViewF32[++vertexOffset] = tx;
                    vertexViewF32[++vertexOffset] = ty;
                    vertexViewF32[++vertexOffset] = uvs[i + 0];
                    vertexViewF32[++vertexOffset] = uvs[i + 1];
                    vertexViewF32[++vertexOffset] = textureUnit;
                    vertexViewF32[++vertexOffset] = tintEffect;
                    vertexViewU32[++vertexOffset] = getTint(colors[colorIndex], camera.alpha * (alphas[colorIndex] * alpha));
                    colorIndex++;
                    if (debugCallback) {
                        debugVerts[i + 0] = tx;
                        debugVerts[i + 1] = ty;
                    }
                }
                if (debugCallback) debugCallback.call(src, src, meshVerticesLength, debugVerts);
                pipeline.vertexCount += vertexCount;
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RopeWebGLRenderer;
        /***/ },
        /* 1081 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Rope.Render. There is no Canvas renderer for Rope objects.
 *
 * @method Phaser.GameObjects.Rope#renderCanvas
 * @since 3.23.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rope} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var RopeCanvasRenderer = function() {};
            module1.exports = RopeCanvasRenderer;
        /***/ },
        /* 1082 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1083);
            renderCanvas = __webpack_require__(1084);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1083 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.width === 0 || src.height === 0) return;
                camera.addToRenderList(src);
                var frame = src.frame;
                var width = frame.width;
                var height = frame.height;
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var textureUnit = pipeline.setTexture2D(frame.glTexture, src);
                renderer.pipelines.preBatch(src);
                pipeline.batchTexture(src, frame.glTexture, width, height, src.x, src.y, width / src.style.resolution, height / src.style.resolution, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.displayOriginX, src.displayOriginY, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, 0, 0, camera, parentMatrix, false, textureUnit);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TextWebGLRenderer;
        /***/ },
        /* 1084 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Text#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TextCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.width === 0 || src.height === 0) return;
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = TextCanvasRenderer;
        /***/ },
        /* 1085 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1086);
            renderCanvas = __webpack_require__(1087);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1086 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                src.updateCanvas();
                var width = src.width;
                var height = src.height;
                if (width === 0 || height === 0) return;
                camera.addToRenderList(src);
                renderer.pipelines.preBatch(src);
                var getTint = Utils.getTintAppendFloatAlpha;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var textureUnit = pipeline.setTexture2D(src.fillPattern, src);
                pipeline.batchTexture(src, src.fillPattern, src.displayFrame.width * src.tileScaleX, src.displayFrame.height * src.tileScaleY, src.x, src.y, width, height, src.scaleX, src.scaleY, src.rotation, src.flipX, src.flipY, src.scrollFactorX, src.scrollFactorY, src.originX * width, src.originY * height, 0, 0, width, height, getTint(src.tintTopLeft, camera.alpha * src._alphaTL), getTint(src.tintTopRight, camera.alpha * src._alphaTR), getTint(src.tintBottomLeft, camera.alpha * src._alphaBL), getTint(src.tintBottomRight, camera.alpha * src._alphaBR), src.tintFill, src.tilePositionX % src.displayFrame.width / src.displayFrame.width, src.tilePositionY % src.displayFrame.height / src.displayFrame.height, camera, parentMatrix, false, textureUnit);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TileSpriteWebGLRenderer;
        /***/ },
        /* 1087 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.TileSprite#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TileSpriteCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                src.updateCanvas();
                camera.addToRenderList(src);
                renderer.batchSprite(src, src.frame, camera, parentMatrix);
            };
            module1.exports = TileSpriteCanvasRenderer;
        /***/ },
        /* 1088 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1089);
            renderCanvas = __webpack_require__(1090);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1089 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderWebGL
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.videoTexture) {
                    camera.addToRenderList(src);
                    src.pipeline.batchSprite(src, camera, parentMatrix);
                }
            };
            module1.exports = VideoWebGLRenderer;
        /***/ },
        /* 1090 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Video#renderCanvas
 * @since 3.20.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Video} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var VideoCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                if (src.videoTexture) {
                    camera.addToRenderList(src);
                    renderer.batchSprite(src, src.frame, camera, parentMatrix);
                }
            };
            module1.exports = VideoCanvasRenderer;
        /***/ },
        /* 1091 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1092);
            renderCanvas = __webpack_require__(1093);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1092 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var FillPathWebGL = __webpack_require__(111);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = ArcWebGLRenderer;
        /***/ },
        /* 1093 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DegToRad = __webpack_require__(35);
            var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Arc#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Arc} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ArcCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var radius = src.radius;
                    ctx.beginPath();
                    ctx.arc(radius - src.originX * (radius * 2), radius - src.originY * (radius * 2), radius, DegToRad(src._startAngle), DegToRad(src._endAngle), src.anticlockwise);
                    if (src.closePath) ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = ArcCanvasRenderer;
        /***/ },
        /* 1094 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1095);
            renderCanvas = __webpack_require__(1096);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1095 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(111);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX + src._curveBounds.x;
                var dy = src._displayOriginY + src._curveBounds.y;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = CurveWebGLRenderer;
        /***/ },
        /* 1096 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Curve#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Curve} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var CurveCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX + src._curveBounds.x;
                    var dy = src._displayOriginY + src._curveBounds.y;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    if (src.closePath) ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = CurveCanvasRenderer;
        /***/ },
        /* 1097 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1098);
            renderCanvas = __webpack_require__(1099);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1098 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(111);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = EllipseWebGLRenderer;
        /***/ },
        /* 1099 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Ellipse#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Ellipse} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var EllipseCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = EllipseCanvasRenderer;
        /***/ },
        /* 1100 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1101);
            renderCanvas = __webpack_require__(1102);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1101 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                calcMatrix.translate(-src._displayOriginX, -src._displayOriginY);
                var alpha = camera.alpha * src.alpha;
                //  Work out the grid size
                var width = src.width;
                var height = src.height;
                var cellWidth = src.cellWidth;
                var cellHeight = src.cellHeight;
                var gridWidth = Math.ceil(width / cellWidth);
                var gridHeight = Math.ceil(height / cellHeight);
                var cellWidthA = cellWidth;
                var cellHeightA = cellHeight;
                var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                var fillTint;
                var fillTintColor;
                var showCells = src.showCells;
                var showAltCells = src.showAltCells;
                var showOutline = src.showOutline;
                var x = 0;
                var y = 0;
                var r = 0;
                var cw = 0;
                var ch = 0;
                if (showOutline) {
                    //  To make room for the grid lines (in case alpha < 1)
                    cellWidthA--;
                    cellHeightA--;
                    if (cellWidthB === cellWidth) cellWidthB--;
                    if (cellHeightB === cellHeight) cellHeightB--;
                }
                renderer.pipelines.preBatch(src);
                if (showCells && src.fillAlpha > 0) {
                    fillTint = pipeline.fillTint;
                    fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    for(y = 0; y < gridHeight; y++){
                        if (showAltCells) r = y % 2;
                        for(x = 0; x < gridWidth; x++){
                            if (showAltCells && r) {
                                r = 0;
                                continue;
                            }
                            r++;
                            cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                            ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                            pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                        }
                    }
                }
                if (showAltCells && src.altFillAlpha > 0) {
                    fillTint = pipeline.fillTint;
                    fillTintColor = Utils.getTintAppendFloatAlpha(src.altFillColor, src.altFillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    for(y = 0; y < gridHeight; y++){
                        if (showAltCells) r = y % 2;
                        for(x = 0; x < gridWidth; x++){
                            if (showAltCells && !r) {
                                r = 1;
                                continue;
                            }
                            r = 0;
                            cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                            ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                            pipeline.batchFillRect(x * cellWidth, y * cellHeight, cw, ch);
                        }
                    }
                }
                if (showOutline && src.outlineFillAlpha > 0) {
                    var strokeTint = pipeline.strokeTint;
                    var color = Utils.getTintAppendFloatAlpha(src.outlineFillColor, src.outlineFillAlpha * alpha);
                    strokeTint.TL = color;
                    strokeTint.TR = color;
                    strokeTint.BL = color;
                    strokeTint.BR = color;
                    for(x = 1; x < gridWidth; x++){
                        var x1 = x * cellWidth;
                        pipeline.batchLine(x1, 0, x1, height, 1, 1, 1, 0, false);
                    }
                    for(y = 1; y < gridHeight; y++){
                        var y1 = y * cellHeight;
                        pipeline.batchLine(0, y1, width, y1, 1, 1, 1, 0, false);
                    }
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = GridWebGLRenderer;
        /***/ },
        /* 1102 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Grid#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Grid} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var GridCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = -src._displayOriginX;
                    var dy = -src._displayOriginY;
                    var alpha = camera.alpha * src.alpha;
                    //  Work out the grid size
                    var width = src.width;
                    var height = src.height;
                    var cellWidth = src.cellWidth;
                    var cellHeight = src.cellHeight;
                    var gridWidth = Math.ceil(width / cellWidth);
                    var gridHeight = Math.ceil(height / cellHeight);
                    var cellWidthA = cellWidth;
                    var cellHeightA = cellHeight;
                    var cellWidthB = cellWidth - (gridWidth * cellWidth - width);
                    var cellHeightB = cellHeight - (gridHeight * cellHeight - height);
                    var showCells = src.showCells;
                    var showAltCells = src.showAltCells;
                    var showOutline = src.showOutline;
                    var x = 0;
                    var y = 0;
                    var r = 0;
                    var cw = 0;
                    var ch = 0;
                    if (showOutline) {
                        //  To make room for the grid lines (in case alpha < 1)
                        cellWidthA--;
                        cellHeightA--;
                        if (cellWidthB === cellWidth) cellWidthB--;
                        if (cellHeightB === cellHeight) cellHeightB--;
                    }
                    if (showCells && src.fillAlpha > 0) {
                        FillStyleCanvas(ctx, src);
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && r) {
                                    r = 0;
                                    continue;
                                }
                                r++;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showAltCells && src.altFillAlpha > 0) {
                        FillStyleCanvas(ctx, src, src.altFillColor, src.altFillAlpha * alpha);
                        for(y = 0; y < gridHeight; y++){
                            if (showAltCells) r = y % 2;
                            for(x = 0; x < gridWidth; x++){
                                if (showAltCells && !r) {
                                    r = 1;
                                    continue;
                                }
                                r = 0;
                                cw = x < gridWidth - 1 ? cellWidthA : cellWidthB;
                                ch = y < gridHeight - 1 ? cellHeightA : cellHeightB;
                                ctx.fillRect(dx + x * cellWidth, dy + y * cellHeight, cw, ch);
                            }
                        }
                    }
                    if (showOutline && src.outlineFillAlpha > 0) {
                        LineStyleCanvas(ctx, src, src.outlineFillColor, src.outlineFillAlpha * alpha);
                        for(x = 1; x < gridWidth; x++){
                            var x1 = x * cellWidth;
                            ctx.beginPath();
                            ctx.moveTo(x1 + dx, dy);
                            ctx.lineTo(x1 + dx, height + dy);
                            ctx.stroke();
                        }
                        for(y = 1; y < gridHeight; y++){
                            var y1 = y * cellHeight;
                            ctx.beginPath();
                            ctx.moveTo(dx, y1 + dy);
                            ctx.lineTo(dx + width, y1 + dy);
                            ctx.stroke();
                        }
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = GridCanvasRenderer;
        /***/ },
        /* 1103 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1104);
            renderCanvas = __webpack_require__(1105);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1104 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var size = src.width;
                var height = src.height;
                var sizeA = size / 2;
                var sizeB = size / src.projection;
                var alpha = camera.alpha * src.alpha;
                if (!src.isFilled) return;
                var tint;
                var x0;
                var y0;
                var x1;
                var y1;
                var x2;
                var y2;
                var x3;
                var y3;
                renderer.pipelines.preBatch(src);
                //  Top Face
                if (src.showTop) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                    x0 = calcMatrix.getX(-sizeA, -height);
                    y0 = calcMatrix.getY(-sizeA, -height);
                    x1 = calcMatrix.getX(0, -sizeB - height);
                    y1 = calcMatrix.getY(0, -sizeB - height);
                    x2 = calcMatrix.getX(sizeA, -height);
                    y2 = calcMatrix.getY(sizeA, -height);
                    x3 = calcMatrix.getX(0, sizeB - height);
                    y3 = calcMatrix.getY(0, sizeB - height);
                    pipeline.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint, tint, tint, tint);
                }
                //  Left Face
                if (src.showLeft) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                    x0 = calcMatrix.getX(-sizeA, 0);
                    y0 = calcMatrix.getY(-sizeA, 0);
                    x1 = calcMatrix.getX(0, sizeB);
                    y1 = calcMatrix.getY(0, sizeB);
                    x2 = calcMatrix.getX(0, sizeB - height);
                    y2 = calcMatrix.getY(0, sizeB - height);
                    x3 = calcMatrix.getX(-sizeA, -height);
                    y3 = calcMatrix.getY(-sizeA, -height);
                    pipeline.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint, tint, tint, tint);
                }
                //  Right Face
                if (src.showRight) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                    x0 = calcMatrix.getX(sizeA, 0);
                    y0 = calcMatrix.getY(sizeA, 0);
                    x1 = calcMatrix.getX(0, sizeB);
                    y1 = calcMatrix.getY(0, sizeB);
                    x2 = calcMatrix.getX(0, sizeB - height);
                    y2 = calcMatrix.getY(0, sizeB - height);
                    x3 = calcMatrix.getX(sizeA, -height);
                    y3 = calcMatrix.getY(sizeA, -height);
                    pipeline.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint, tint, tint, tint);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = IsoBoxWebGLRenderer;
        /***/ },
        /* 1105 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoBox#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoBox} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoBoxCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    //  Top Face
                    if (src.showTop) {
                        FillStyleCanvas(ctx, src, src.fillTop);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, -height);
                        ctx.lineTo(0, -sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(sizeA, -1);
                        ctx.lineTo(0, sizeB - 1);
                        ctx.lineTo(-sizeA, -1);
                        ctx.lineTo(-sizeA, -height);
                        ctx.fill();
                    }
                    //  Left Face
                    if (src.showLeft) {
                        FillStyleCanvas(ctx, src, src.fillLeft);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, 0);
                        ctx.lineTo(0, sizeB);
                        ctx.lineTo(0, sizeB - height);
                        ctx.lineTo(-sizeA, -height);
                        ctx.lineTo(-sizeA, 0);
                        ctx.fill();
                    }
                    //  Right Face
                    if (src.showRight) {
                        FillStyleCanvas(ctx, src, src.fillRight);
                        ctx.beginPath();
                        ctx.moveTo(sizeA, 0);
                        ctx.lineTo(0, sizeB);
                        ctx.lineTo(0, sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(sizeA, 0);
                        ctx.fill();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = IsoBoxCanvasRenderer;
        /***/ },
        /* 1106 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1107);
            renderCanvas = __webpack_require__(1108);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1107 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var size = src.width;
                var height = src.height;
                var sizeA = size / 2;
                var sizeB = size / src.projection;
                var reversed = src.isReversed;
                var alpha = camera.alpha * src.alpha;
                if (!src.isFilled) return;
                renderer.pipelines.preBatch(src);
                var tint;
                var x0;
                var y0;
                var x1;
                var y1;
                var x2;
                var y2;
                //  Top Face
                if (src.showTop && reversed) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillTop, alpha);
                    x0 = calcMatrix.getX(-sizeA, -height);
                    y0 = calcMatrix.getY(-sizeA, -height);
                    x1 = calcMatrix.getX(0, -sizeB - height);
                    y1 = calcMatrix.getY(0, -sizeB - height);
                    x2 = calcMatrix.getX(sizeA, -height);
                    y2 = calcMatrix.getY(sizeA, -height);
                    var x3 = calcMatrix.getX(0, sizeB - height);
                    var y3 = calcMatrix.getY(0, sizeB - height);
                    pipeline.batchQuad(x0, y0, x1, y1, x2, y2, x3, y3, tint, tint, tint, tint);
                }
                //  Left Face
                if (src.showLeft) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillLeft, alpha);
                    if (reversed) {
                        x0 = calcMatrix.getX(-sizeA, -height);
                        y0 = calcMatrix.getY(-sizeA, -height);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    } else {
                        x0 = calcMatrix.getX(-sizeA, 0);
                        y0 = calcMatrix.getY(-sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    }
                    pipeline.batchTri(x0, y0, x1, y1, x2, y2, tint, tint, tint);
                }
                //  Right Face
                if (src.showRight) {
                    tint = Utils.getTintAppendFloatAlpha(src.fillRight, alpha);
                    if (reversed) {
                        x0 = calcMatrix.getX(sizeA, -height);
                        y0 = calcMatrix.getY(sizeA, -height);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    } else {
                        x0 = calcMatrix.getX(sizeA, 0);
                        y0 = calcMatrix.getY(sizeA, 0);
                        x1 = calcMatrix.getX(0, sizeB);
                        y1 = calcMatrix.getY(0, sizeB);
                        x2 = calcMatrix.getX(0, sizeB - height);
                        y2 = calcMatrix.getY(0, sizeB - height);
                    }
                    pipeline.batchTri(x0, y0, x1, y1, x2, y2, tint, tint, tint);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = IsoTriangleWebGLRenderer;
        /***/ },
        /* 1108 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.IsoTriangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.IsoTriangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var IsoTriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix) && src.isFilled) {
                    var size = src.width;
                    var height = src.height;
                    var sizeA = size / 2;
                    var sizeB = size / src.projection;
                    var reversed = src.isReversed;
                    //  Top Face
                    if (src.showTop && reversed) {
                        FillStyleCanvas(ctx, src, src.fillTop);
                        ctx.beginPath();
                        ctx.moveTo(-sizeA, -height);
                        ctx.lineTo(0, -sizeB - height);
                        ctx.lineTo(sizeA, -height);
                        ctx.lineTo(0, sizeB - height);
                        ctx.fill();
                    }
                    //  Left Face
                    if (src.showLeft) {
                        FillStyleCanvas(ctx, src, src.fillLeft);
                        ctx.beginPath();
                        if (reversed) {
                            ctx.moveTo(-sizeA, -height);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        } else {
                            ctx.moveTo(-sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        }
                        ctx.fill();
                    }
                    //  Right Face
                    if (src.showRight) {
                        FillStyleCanvas(ctx, src, src.fillRight);
                        ctx.beginPath();
                        if (reversed) {
                            ctx.moveTo(sizeA, -height);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        } else {
                            ctx.moveTo(sizeA, 0);
                            ctx.lineTo(0, sizeB);
                            ctx.lineTo(0, sizeB - height);
                        }
                        ctx.fill();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = IsoTriangleCanvasRenderer;
        /***/ },
        /* 1109 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1110);
            renderCanvas = __webpack_require__(1111);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1110 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isStroked) {
                    var strokeTint = pipeline.strokeTint;
                    var color = Utils.getTintAppendFloatAlpha(src.strokeColor, src.strokeAlpha * alpha);
                    strokeTint.TL = color;
                    strokeTint.TR = color;
                    strokeTint.BL = color;
                    strokeTint.BR = color;
                    var startWidth = src._startWidth;
                    var endWidth = src._endWidth;
                    pipeline.batchLine(src.geom.x1 - dx, src.geom.y1 - dy, src.geom.x2 - dx, src.geom.y2 - dy, startWidth, endWidth, 1, 0, false, result.sprite, result.camera);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = LineWebGLRenderer;
        /***/ },
        /* 1111 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Line#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Line} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var LineCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.beginPath();
                        ctx.moveTo(src.geom.x1 - dx, src.geom.y1 - dy);
                        ctx.lineTo(src.geom.x2 - dx, src.geom.y2 - dy);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = LineCanvasRenderer;
        /***/ },
        /* 1112 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1113);
            renderCanvas = __webpack_require__(1114);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1113 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(111);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = PolygonWebGLRenderer;
        /***/ },
        /* 1114 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Polygon#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Polygon} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PolygonCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = PolygonCanvasRenderer;
        /***/ },
        /* 1115 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1116);
            renderCanvas = __webpack_require__(1117);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1116 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) {
                    var fillTint = pipeline.fillTint;
                    var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    pipeline.batchFillRect(-dx, -dy, src.width, src.height);
                }
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = RectangleWebGLRenderer;
        /***/ },
        /* 1117 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Rectangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Rectangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var RectangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fillRect(-dx, -dy, src.width, src.height);
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.beginPath();
                        ctx.rect(-dx, -dy, src.width, src.height);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = RectangleCanvasRenderer;
        /***/ },
        /* 1118 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1119);
            renderCanvas = __webpack_require__(1120);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1119 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillPathWebGL = __webpack_require__(111);
            var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                var calcMatrix = pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) FillPathWebGL(pipeline, calcMatrix, src, alpha, dx, dy);
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = StarWebGLRenderer;
        /***/ },
        /* 1120 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Star#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Star} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var StarCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var path = src.pathData;
                    var pathLength = path.length - 1;
                    var px1 = path[0] - dx;
                    var py1 = path[1] - dy;
                    ctx.beginPath();
                    ctx.moveTo(px1, py1);
                    if (!src.closePath) pathLength -= 2;
                    for(var i = 2; i < pathLength; i += 2){
                        var px2 = path[i] - dx;
                        var py2 = path[i + 1] - dy;
                        ctx.lineTo(px2, py2);
                    }
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = StarCanvasRenderer;
        /***/ },
        /* 1121 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1122);
            renderCanvas = __webpack_require__(1123);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1122 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            var StrokePathWebGL = __webpack_require__(81);
            var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderWebGL
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var result = GetCalcMatrix(src, camera, parentMatrix);
                pipeline.calcMatrix.copyFrom(result.calc);
                var dx = src._displayOriginX;
                var dy = src._displayOriginY;
                var alpha = camera.alpha * src.alpha;
                renderer.pipelines.preBatch(src);
                if (src.isFilled) {
                    var fillTint = pipeline.fillTint;
                    var fillTintColor = Utils.getTintAppendFloatAlpha(src.fillColor, src.fillAlpha * alpha);
                    fillTint.TL = fillTintColor;
                    fillTint.TR = fillTintColor;
                    fillTint.BL = fillTintColor;
                    fillTint.BR = fillTintColor;
                    var x1 = src.geom.x1 - dx;
                    var y1 = src.geom.y1 - dy;
                    var x2 = src.geom.x2 - dx;
                    var y2 = src.geom.y2 - dy;
                    var x3 = src.geom.x3 - dx;
                    var y3 = src.geom.y3 - dy;
                    pipeline.batchFillTriangle(x1, y1, x2, y2, x3, y3, result.sprite, result.camera);
                }
                if (src.isStroked) StrokePathWebGL(pipeline, src, alpha, dx, dy);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TriangleWebGLRenderer;
        /***/ },
        /* 1123 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var FillStyleCanvas = __webpack_require__(46);
            var LineStyleCanvas = __webpack_require__(58);
            var SetTransform = __webpack_require__(30);
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Triangle#renderCanvas
 * @since 3.13.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Triangle} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TriangleCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var ctx = renderer.currentContext;
                if (SetTransform(renderer, ctx, src, camera, parentMatrix)) {
                    var dx = src._displayOriginX;
                    var dy = src._displayOriginY;
                    var x1 = src.geom.x1 - dx;
                    var y1 = src.geom.y1 - dy;
                    var x2 = src.geom.x2 - dx;
                    var y2 = src.geom.y2 - dy;
                    var x3 = src.geom.x3 - dx;
                    var y3 = src.geom.y3 - dy;
                    ctx.beginPath();
                    ctx.moveTo(x1, y1);
                    ctx.lineTo(x2, y2);
                    ctx.lineTo(x3, y3);
                    ctx.closePath();
                    if (src.isFilled) {
                        FillStyleCanvas(ctx, src);
                        ctx.fill();
                    }
                    if (src.isStroked) {
                        LineStyleCanvas(ctx, src);
                        ctx.stroke();
                    }
                    //  Restore the context saved in SetTransform
                    ctx.restore();
                }
            };
            module1.exports = TriangleCanvasRenderer;
        /***/ },
        /* 1124 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(210);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Blitter Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#blitter
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} key - The key of the Texture the Blitter object will use.
 * @param {(string|number)} [frame] - The default Frame children of the Blitter will use.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectFactory.register('blitter', function(x, y, key, frame) {
                return this.displayList.add(new Blitter(this.scene, x, y, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1125 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Container = __webpack_require__(211);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Container Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#container
 * @since 3.4.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectFactory.register('container', function(x, y, children) {
                return this.displayList.add(new Container(this.scene, x, y, children));
            });
        /***/ },
        /* 1126 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DOMElement = __webpack_require__(436);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * DOM Element Game Objects are a way to control and manipulate HTML Elements over the top of your game.
 *
 * In order for DOM Elements to display you have to enable them by adding the following to your game
 * configuration object:
 *
 * ```javascript
 * dom {
 *   createContainer: true
 * }
 * ```
 *
 * When this is added, Phaser will automatically create a DOM Container div that is positioned over the top
 * of the game canvas. This div is sized to match the canvas, and if the canvas size changes, as a result of
 * settings within the Scale Manager, the dom container is resized accordingly.
 *
 * You can create a DOM Element by either passing in DOMStrings, or by passing in a reference to an existing
 * Element that you wish to be placed under the control of Phaser. For example:
 *
 * ```javascript
 * this.add.dom(x, y, 'div', 'background-color: lime; width: 220px; height: 100px; font: 48px Arial', 'Phaser');
 * ```
 *
 * The above code will insert a div element into the DOM Container at the given x/y coordinate. The DOMString in
 * the 4th argument sets the initial CSS style of the div and the final argument is the inner text. In this case,
 * it will create a lime colored div that is 220px by 100px in size with the text Phaser in it, in an Arial font.
 *
 * You should nearly always, without exception, use explicitly sized HTML Elements, in order to fully control
 * alignment and positioning of the elements next to regular game content.
 *
 * Rather than specify the CSS and HTML directly you can use the `load.html` File Loader to load it into the
 * cache and then use the `createFromCache` method instead. You can also use `createFromHTML` and various other
 * methods available in this class to help construct your elements.
 *
 * Once the element has been created you can then control it like you would any other Game Object. You can set its
 * position, scale, rotation, alpha and other properties. It will move as the main Scene Camera moves and be clipped
 * at the edge of the canvas. It's important to remember some limitations of DOM Elements: The obvious one is that
 * they appear above or below your game canvas. You cannot blend them into the display list, meaning you cannot have
 * a DOM Element, then a Sprite, then another DOM Element behind it.
 *
 * They also cannot be enabled for input. To do that, you have to use the `addListener` method to add native event
 * listeners directly. The final limitation is to do with cameras. The DOM Container is sized to match the game canvas
 * entirely and clipped accordingly. DOM Elements respect camera scrolling and scrollFactor settings, but if you
 * change the size of the camera so it no longer matches the size of the canvas, they won't be clipped accordingly.
 *
 * Also, all DOM Elements are inserted into the same DOM Container, regardless of which Scene they are created in.
 *
 * DOM Elements are a powerful way to align native HTML with your Phaser Game Objects. For example, you can insert
 * a login form for a multiplayer game directly into your title screen. Or a text input box for a highscore table.
 * Or a banner ad from a 3rd party service. Or perhaps you'd like to use them for high resolution text display and
 * UI. The choice is up to you, just remember that you're dealing with standard HTML and CSS floating over the top
 * of your game, and should treat it accordingly.
 *
 * Note: This method will only be available if the DOM Element Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dom
 * @since 3.17.0
 *
 * @param {number} x - The horizontal position of this DOM Element in the world.
 * @param {number} y - The vertical position of this DOM Element in the world.
 * @param {(HTMLElement|string)} [element] - An existing DOM element, or a string. If a string starting with a # it will do a `getElementById` look-up on the string (minus the hash). Without a hash, it represents the type of element to create, i.e. 'div'.
 * @param {(string|any)} [style] - If a string, will be set directly as the elements `style` property value. If a plain object, will be iterated and the values transferred. In both cases the values replacing whatever CSS styles may have been previously set.
 * @param {string} [innerText] - If given, will be set directly as the elements `innerText` property value, replacing whatever was there before.
 *
 * @return {Phaser.GameObjects.DOMElement} The Game Object that was created.
 */ GameObjectFactory.register('dom', function(x, y, element, style, innerText) {
                var gameObject = new DOMElement(this.scene, x, y, element, style, innerText);
                this.displayList.add(gameObject);
                return gameObject;
            });
        /***/ },
        /* 1127 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DynamicBitmapText = __webpack_require__(212);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Dynamic Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * Dynamic Bitmap Text objects are different from Static Bitmap Text in that they invoke a callback for each
 * letter being rendered during the render pass. This callback allows you to manipulate the properties of
 * each letter being rendered, such as its position, scale or tint, allowing you to create interesting effects
 * like jiggling text, which can't be done with Static text. This means that Dynamic Text takes more processing
 * time, so only use them if you require the callback ability they have.
 *
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#dynamicBitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectFactory.register('dynamicBitmapText', function(x, y, font, text, size) {
                return this.displayList.add(new DynamicBitmapText(this.scene, x, y, font, text, size));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1128 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extern = __webpack_require__(438);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Extern Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Extern Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#extern
 * @since 3.16.0
 *
 * @return {Phaser.GameObjects.Extern} The Game Object that was created.
 */ GameObjectFactory.register('extern', function() {
                var extern = new Extern(this.scene);
                this.displayList.add(extern);
                return extern;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1129 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Graphics = __webpack_require__(213);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Graphics Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#graphics
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Graphics.Options} [config] - The Graphics configuration.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectFactory.register('graphics', function(config) {
                return this.displayList.add(new Graphics(this.scene, config));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1130 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Group = __webpack_require__(110);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Group Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#group
 * @since 3.0.0
 *
 * @param {(Phaser.GameObjects.GameObject[]|Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupConfig[])} [children] - Game Objects to add to this Group; or the `config` argument.
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} [config] - A Group Configuration object.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectFactory.register('group', function(children, config) {
                return this.updateList.add(new Group(this.scene, children, config));
            });
        /***/ },
        /* 1131 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Image1 = __webpack_require__(124);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Image Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#image
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectFactory.register('image', function(x, y, key, frame) {
                return this.displayList.add(new Image1(this.scene, x, y, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1132 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Layer = __webpack_require__(216);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Layer Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#layer
 * @since 3.50.0
 *
 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Layer.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectFactory.register('layer', function(children) {
                return this.displayList.add(new Layer(this.scene, children));
            });
        /***/ },
        /* 1133 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var ParticleEmitterManager = __webpack_require__(217);
            /**
 * Creates a new Particle Emitter Manager Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#particles
 * @since 3.0.0
 *
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number|object)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.GameObjects.Particles.ParticleEmitterConfig|Phaser.Types.GameObjects.Particles.ParticleEmitterConfig[]} [emitters] - Configuration settings for one or more emitters to create.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
 */ GameObjectFactory.register('particles', function(key, frame, emitters) {
                return this.displayList.add(new ParticleEmitterManager(this.scene, key, frame, emitters));
            });
        /***/ },
        /* 1134 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var PathFollower = __webpack_require__(451);
            /**
 * Creates a new PathFollower Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the PathFollower Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#follower
 * @since 3.0.0
 *
 * @param {Phaser.Curves.Path} path - The Path this PathFollower is connected to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.PathFollower} The Game Object that was created.
 */ GameObjectFactory.register('follower', function(path, x, y, key, frame) {
                var sprite = new PathFollower(this.scene, path, x, y, key, frame);
                this.displayList.add(sprite);
                this.updateList.add(sprite);
                return sprite;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1135 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var RenderTexture = __webpack_require__(218);
            /**
 * Creates a new Render Texture Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 * 
 * A Render Texture is a special texture that allows any number of Game Objects to be drawn to it. You can take many complex objects and
 * draw them all to this one texture, which can they be used as the texture for other Game Object's. It's a way to generate dynamic
 * textures at run-time that are WebGL friendly and don't invoke expensive GPU uploads.
 *
 * @method Phaser.GameObjects.GameObjectFactory#renderTexture
 * @since 3.2.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} [width=32] - The width of the Render Texture.
 * @param {number} [height=32] - The height of the Render Texture.
 * @property {string} [key] - The texture key to make the RenderTexture from.
 * @property {string} [frame] - the frame to make the RenderTexture from.
 * 
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectFactory.register('renderTexture', function(x, y, width, height, key, frame) {
                return this.displayList.add(new RenderTexture(this.scene, x, y, width, height, key, frame));
            });
        /***/ },
        /* 1136 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rope = __webpack_require__(220);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register('rope', function(x, y, texture, frame, points, horizontal, colors, alphas) {
                return this.displayList.add(new Rope(this.scene, x, y, texture, frame, points, horizontal, colors, alphas));
            });
        /***/ },
        /* 1137 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Sprite = __webpack_require__(73);
            /**
 * Creates a new Sprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#sprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectFactory.register('sprite', function(x, y, key, frame) {
                var sprite = new Sprite(this.scene, x, y, key, frame);
                this.displayList.add(sprite);
                return sprite;
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1138 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(147);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Bitmap Text Game Object and adds it to the Scene.
 * 
 * BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
 * 
 * During rendering for each letter of the text is rendered to the display, proportionally spaced out and aligned to
 * match the font structure.
 * 
 * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability
 * to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
 * processing the font texture in an image editor, applying fills and any other effects required.
 *
 * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
 *
 * To create a BitmapText data files you need a 3rd party app such as:
 *
 * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
 * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
 * Littera (Web-based, free): http://kvazars.com/littera/
 *
 * For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
 * converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#bitmapText
 * @since 3.0.0
 *
 * @param {number} x - The x position of the Game Object.
 * @param {number} y - The y position of the Game Object.
 * @param {string} font - The key of the font to use from the BitmapFont cache.
 * @param {(string|string[])} [text] - The string, or array of strings, to be set as the content of this Bitmap Text.
 * @param {number} [size] - The font size to set.
 * @param {number} [align=0] - The alignment of the text in a multi-line BitmapText object.
 *
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectFactory.register('bitmapText', function(x, y, font, text, size, align) {
                return this.displayList.add(new BitmapText(this.scene, x, y, font, text, size, align));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1139 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Text = __webpack_require__(221);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Text Game Object and adds it to the Scene.
 *
 * A Text Game Object.
 *
 * Text objects work by creating their own internal hidden Canvas and then renders text to it using
 * the standard Canvas `fillText` API. It then creates a texture from this canvas which is rendered
 * to your game during the render pass.
 *
 * Because it uses the Canvas API you can take advantage of all the features this offers, such as
 * applying gradient fills to the text, or strokes, shadows and more. You can also use custom fonts
 * loaded externally, such as Google or TypeKit Web fonts.
 *
 * You can only display fonts that are currently loaded and available to the browser: therefore fonts must
 * be pre-loaded. Phaser does not do ths for you, so you will require the use of a 3rd party font loader,
 * or have the fonts ready available in the CSS on the page in which your Phaser game resides.
 *
 * See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts
 * across mobile browsers.
 *
 * A note on performance: Every time the contents of a Text object changes, i.e. changing the text being
 * displayed, or the style of the text, it needs to remake the Text canvas, and if on WebGL, re-upload the
 * new texture to the GPU. This can be an expensive operation if used often, or with large quantities of
 * Text objects in your game. If you run into performance issues you would be better off using Bitmap Text
 * instead, as it benefits from batching and avoids expensive Canvas API calls.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#text
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|string[])} text - The text this Text object will display.
 * @param {Phaser.Types.GameObjects.Text.TextStyle} [style] - The Text style configuration object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectFactory.register('text', function(x, y, text, style) {
                return this.displayList.add(new Text(this.scene, x, y, text, style));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1140 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TileSprite = __webpack_require__(222);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new TileSprite Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tileSprite
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object. If zero it will use the size of the texture frame.
 * @param {number} height - The height of the Game Object. If zero it will use the size of the texture frame.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectFactory.register('tileSprite', function(x, y, width, height, key, frame) {
                return this.displayList.add(new TileSprite(this.scene, x, y, width, height, key, frame));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1141 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Zone = __webpack_require__(127);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Zone Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#zone
 * @since 3.0.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {number} width - The width of the Game Object.
 * @param {number} height - The height of the Game Object.
 * 
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectFactory.register('zone', function(x, y, width, height) {
                return this.displayList.add(new Zone(this.scene, x, y, width, height));
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //  
        //  There are several properties available to use:
        //  
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1142 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Video = __webpack_require__(223);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Video Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#video
 * @since 3.20.0
 *
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {string} [key] - Optional key of the Video this Game Object will play, as stored in the Video Cache.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectFactory.register('video', function(x, y, key) {
                return this.displayList.add(new Video(this.scene, x, y, key));
            });
        /***/ },
        /* 1143 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Arc = __webpack_require__(455);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Arc Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 * 
 * The Arc Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an arc shape. You can control the start and end angles of the arc,
 * as well as if the angles are winding clockwise or anti-clockwise. With the default settings
 * it renders as a complete circle. By changing the angles you can create other arc shapes,
 * such as half-circles.
 *
 * @method Phaser.GameObjects.GameObjectFactory#arc
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the arc.
 * @param {number} [startAngle=0] - The start angle of the arc, in degrees.
 * @param {number} [endAngle=360] - The end angle of the arc, in degrees.
 * @param {boolean} [anticlockwise=false] - The winding order of the start and end angles.
 * @param {number} [fillColor] - The color the arc will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the arc will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register('arc', function(x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha) {
                return this.displayList.add(new Arc(this.scene, x, y, radius, startAngle, endAngle, anticlockwise, fillColor, fillAlpha));
            });
            /**
 * Creates a new Circle Shape Game Object and adds it to the Scene.
 * 
 * A Circle is an Arc with no defined start and end angle, making it render as a complete circle.
 *
 * Note: This method will only be available if the Arc Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectFactory#circle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [radius=128] - The radius of the circle.
 * @param {number} [fillColor] - The color the circle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the circle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Arc} The Game Object that was created.
 */ GameObjectFactory.register('circle', function(x, y, radius, fillColor, fillAlpha) {
                return this.displayList.add(new Arc(this.scene, x, y, radius, 0, 360, false, fillColor, fillAlpha));
            });
        /***/ },
        /* 1144 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Curve = __webpack_require__(456);
            /**
 * Creates a new Curve Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Curve Game Object has been built into Phaser.
 * 
 * The Curve Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * To render a Curve Shape you must first create a `Phaser.Curves.Curve` object, then pass it to
 * the Curve Shape in the constructor.
 * 
 * The Curve shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#curve
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {Phaser.Curves.Curve} [curve] - The Curve object to use to create the Shape.
 * @param {number} [fillColor] - The color the curve will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the curve will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Curve} The Game Object that was created.
 */ GameObjectFactory.register('curve', function(x, y, curve, fillColor, fillAlpha) {
                return this.displayList.add(new Curve(this.scene, x, y, curve, fillColor, fillAlpha));
            });
        /***/ },
        /* 1145 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(457);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Ellipse Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Ellipse Game Object has been built into Phaser.
 * 
 * The Ellipse Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * When it renders it displays an ellipse shape. You can control the width and height of the ellipse.
 * If the width and height match it will render as a circle. If the width is less than the height,
 * it will look more like an egg shape.
 * 
 * The Ellipse shape also has a `smoothness` property and corresponding `setSmoothness` method.
 * This allows you to control how smooth the shape renders in WebGL, by controlling the number of iterations
 * that take place during construction. Increase and decrease the default value for smoother, or more
 * jagged, shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#ellipse
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [height=128] - The height of the ellipse. An ellipse with equal width and height renders as a circle.
 * @param {number} [fillColor] - The color the ellipse will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the ellipse will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Ellipse} The Game Object that was created.
 */ GameObjectFactory.register('ellipse', function(x, y, width, height, fillColor, fillAlpha) {
                return this.displayList.add(new Ellipse(this.scene, x, y, width, height, fillColor, fillAlpha));
            });
        /***/ },
        /* 1146 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Grid = __webpack_require__(458);
            /**
 * Creates a new Grid Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Grid Game Object has been built into Phaser.
 * 
 * The Grid Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * A Grid Shape allows you to display a grid in your game, where you can control the size of the
 * grid as well as the width and height of the grid cells. You can set a fill color for each grid
 * cell as well as an alternate fill color. When the alternate fill color is set then the grid
 * cells will alternate the fill colors as they render, creating a chess-board effect. You can
 * also optionally have an outline fill color. If set, this draws lines between the grid cells
 * in the given color. If you specify an outline color with an alpha of zero, then it will draw
 * the cells spaced out, but without the lines between them.
 *
 * @method Phaser.GameObjects.GameObjectFactory#grid
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the grid.
 * @param {number} [height=128] - The height of the grid.
 * @param {number} [cellWidth=32] - The width of one cell in the grid.
 * @param {number} [cellHeight=32] - The height of one cell in the grid.
 * @param {number} [fillColor] - The color the grid cells will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the grid cells will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 * @param {number} [outlineFillColor] - The color of the lines between the grid cells.
 * @param {number} [outlineFillAlpha] - The alpha of the lines between the grid cells.
 *
 * @return {Phaser.GameObjects.Grid} The Game Object that was created.
 */ GameObjectFactory.register('grid', function(x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha) {
                return this.displayList.add(new Grid(this.scene, x, y, width, height, cellWidth, cellHeight, fillColor, fillAlpha, outlineFillColor, outlineFillAlpha));
            });
        /***/ },
        /* 1147 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var IsoBox = __webpack_require__(459);
            /**
 * Creates a new IsoBox Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoBox Game Object has been built into Phaser.
 * 
 * The IsoBox Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoBox is an 'isometric' rectangle. Each face of it has a different fill color. You can set
 * the color of the top, left and right faces of the rectangle respectively. You can also choose
 * which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoBox from under-neath, however you can change the 'angle' by setting
 * the `projection` property.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isobox
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso box in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso box. The left and right faces will be this tall. The overall height of the isobox will be this value plus half the `size` value.
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso box.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso box.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso box.
 *
 * @return {Phaser.GameObjects.IsoBox} The Game Object that was created.
 */ GameObjectFactory.register('isobox', function(x, y, size, height, fillTop, fillLeft, fillRight) {
                return this.displayList.add(new IsoBox(this.scene, x, y, size, height, fillTop, fillLeft, fillRight));
            });
        /***/ },
        /* 1148 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var IsoTriangle = __webpack_require__(460);
            /**
 * Creates a new IsoTriangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the IsoTriangle Game Object has been built into Phaser.
 * 
 * The IsoTriangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only fill colors and cannot be stroked.
 * 
 * An IsoTriangle is an 'isometric' triangle. Think of it like a pyramid. Each face has a different
 * fill color. You can set the color of the top, left and right faces of the triangle respectively
 * You can also choose which of the faces are rendered via the `showTop`, `showLeft` and `showRight` properties.
 * 
 * You cannot view an IsoTriangle from under-neath, however you can change the 'angle' by setting
 * the `projection` property. The `reversed` property controls if the IsoTriangle is rendered upside
 * down or not.
 *
 * @method Phaser.GameObjects.GameObjectFactory#isotriangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [size=48] - The width of the iso triangle in pixels. The left and right faces will be exactly half this value.
 * @param {number} [height=32] - The height of the iso triangle. The left and right faces will be this tall. The overall height of the iso triangle will be this value plus half the `size` value.
 * @param {boolean} [reversed=false] - Is the iso triangle upside down?
 * @param {number} [fillTop=0xeeeeee] - The fill color of the top face of the iso triangle.
 * @param {number} [fillLeft=0x999999] - The fill color of the left face of the iso triangle.
 * @param {number} [fillRight=0xcccccc] - The fill color of the right face of the iso triangle.
 *
 * @return {Phaser.GameObjects.IsoTriangle} The Game Object that was created.
 */ GameObjectFactory.register('isotriangle', function(x, y, size, height, reversed, fillTop, fillLeft, fillRight) {
                return this.displayList.add(new IsoTriangle(this.scene, x, y, size, height, reversed, fillTop, fillLeft, fillRight));
            });
        /***/ },
        /* 1149 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Line = __webpack_require__(461);
            /**
 * Creates a new Line Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Line Game Object has been built into Phaser.
 * 
 * The Line Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports only stroke colors and cannot be filled.
 * 
 * A Line Shape allows you to draw a line between two points in your game. You can control the
 * stroke color and thickness of the line. In WebGL only you can also specify a different
 * thickness for the start and end of the line, allowing you to render lines that taper-off.
 * 
 * If you need to draw multiple lines in a sequence you may wish to use the Polygon Shape instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#line
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the start of the line.
 * @param {number} [y1=0] - The vertical position of the start of the line.
 * @param {number} [x2=128] - The horizontal position of the end of the line.
 * @param {number} [y2=0] - The vertical position of the end of the line.
 * @param {number} [strokeColor] - The color the line will be drawn in, i.e. 0xff0000 for red.
 * @param {number} [strokeAlpha] - The alpha the line will be drawn in. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Line} The Game Object that was created.
 */ GameObjectFactory.register('line', function(x, y, x1, y1, x2, y2, strokeColor, strokeAlpha) {
                return this.displayList.add(new Line(this.scene, x, y, x1, y1, x2, y2, strokeColor, strokeAlpha));
            });
        /***/ },
        /* 1150 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Polygon = __webpack_require__(462);
            /**
 * Creates a new Polygon Shape Game Object and adds it to the Scene.
 * 
 * Note: This method will only be available if the Polygon Game Object has been built into Phaser.
 * 
 * The Polygon Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Polygon Shape is created by providing a list of points, which are then used to create an
 * internal Polygon geometry object. The points can be set from a variety of formats:
 *
 * - An array of Point or Vector2 objects: `[new Phaser.Math.Vector2(x1, y1), ...]`
 * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
 * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
 * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
 * 
 * By default the `x` and `y` coordinates of this Shape refer to the center of it. However, depending
 * on the coordinates of the points provided, the final shape may be rendered offset from its origin.
 *
 * @method Phaser.GameObjects.GameObjectFactory#polygon
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {any} [points] - The points that make up the polygon.
 * @param {number} [fillColor] - The color the polygon will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the polygon will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Polygon} The Game Object that was created.
 */ GameObjectFactory.register('polygon', function(x, y, points, fillColor, fillAlpha) {
                return this.displayList.add(new Polygon(this.scene, x, y, points, fillColor, fillAlpha));
            });
        /***/ },
        /* 1151 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Rectangle = __webpack_require__(467);
            /**
 * Creates a new Rectangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Rectangle Game Object has been built into Phaser.
 * 
 * The Rectangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * You can change the size of the rectangle by changing the `width` and `height` properties.
 *
 * @method Phaser.GameObjects.GameObjectFactory#rectangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [width=128] - The width of the rectangle.
 * @param {number} [height=128] - The height of the rectangle.
 * @param {number} [fillColor] - The color the rectangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the rectangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Rectangle} The Game Object that was created.
 */ GameObjectFactory.register('rectangle', function(x, y, width, height, fillColor, fillAlpha) {
                return this.displayList.add(new Rectangle(this.scene, x, y, width, height, fillColor, fillAlpha));
            });
        /***/ },
        /* 1152 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Star = __webpack_require__(468);
            var GameObjectFactory = __webpack_require__(5);
            /**
 * Creates a new Star Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Star Game Object has been built into Phaser.
 * 
 * The Star Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * As the name implies, the Star shape will display a star in your game. You can control several
 * aspects of it including the number of points that constitute the star. The default is 5. If
 * you change it to 4 it will render as a diamond. If you increase them, you'll get a more spiky
 * star shape.
 * 
 * You can also control the inner and outer radius, which is how 'long' each point of the star is.
 * Modify these values to create more interesting shapes.
 *
 * @method Phaser.GameObjects.GameObjectFactory#star
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [points=5] - The number of points on the star.
 * @param {number} [innerRadius=32] - The inner radius of the star.
 * @param {number} [outerRadius=64] - The outer radius of the star.
 * @param {number} [fillColor] - The color the star will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the star will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Star} The Game Object that was created.
 */ GameObjectFactory.register('star', function(x, y, points, innerRadius, outerRadius, fillColor, fillAlpha) {
                return this.displayList.add(new Star(this.scene, x, y, points, innerRadius, outerRadius, fillColor, fillAlpha));
            });
        /***/ },
        /* 1153 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var Triangle = __webpack_require__(469);
            /**
 * Creates a new Triangle Shape Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Triangle Game Object has been built into Phaser.
 * 
 * The Triangle Shape is a Game Object that can be added to a Scene, Group or Container. You can
 * treat it like any other Game Object in your game, such as tweening it, scaling it, or enabling
 * it for input or physics. It provides a quick and easy way for you to render this shape in your
 * game without using a texture, while still taking advantage of being fully batched in WebGL.
 * 
 * This shape supports both fill and stroke colors.
 * 
 * The Triangle consists of 3 lines, joining up to form a triangular shape. You can control the
 * position of each point of these lines. The triangle is always closed and cannot have an open
 * face. If you require that, consider using a Polygon instead.
 *
 * @method Phaser.GameObjects.GameObjectFactory#triangle
 * @since 3.13.0
 *
 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
 * @param {number} [y=0] - The vertical position of this Game Object in the world.
 * @param {number} [x1=0] - The horizontal position of the first point in the triangle.
 * @param {number} [y1=128] - The vertical position of the first point in the triangle.
 * @param {number} [x2=64] - The horizontal position of the second point in the triangle.
 * @param {number} [y2=0] - The vertical position of the second point in the triangle.
 * @param {number} [x3=128] - The horizontal position of the third point in the triangle.
 * @param {number} [y3=128] - The vertical position of the third point in the triangle.
 * @param {number} [fillColor] - The color the triangle will be filled with, i.e. 0xff0000 for red.
 * @param {number} [fillAlpha] - The alpha the triangle will be filled with. You can also set the alpha of the overall Shape using its `alpha` property.
 *
 * @return {Phaser.GameObjects.Triangle} The Game Object that was created.
 */ GameObjectFactory.register('triangle', function(x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha) {
                return this.displayList.add(new Triangle(this.scene, x, y, x1, y1, x2, y2, x3, y3, fillColor, fillAlpha));
            });
        /***/ },
        /* 1154 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Blitter = __webpack_require__(210);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Blitter Game Object and returns it.
 *
 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#blitter
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
 */ GameObjectCreator.register('blitter', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var blitter = new Blitter(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, blitter, config);
                return blitter;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1155 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Felipe Alfonso <@bitnenfer>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var Container = __webpack_require__(211);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Container Game Object and returns it.
 *
 * Note: This method will only be available if the Container Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#container
 * @since 3.4.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Container} The Game Object that was created.
 */ GameObjectCreator.register('container', function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, 'x', 0);
                var y = GetAdvancedValue(config, 'y', 0);
                var children = GetAdvancedValue(config, 'children', null);
                var container = new Container(this.scene, x, y, children);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, container, config);
                return container;
            });
        /***/ },
        /* 1156 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(212);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Dynamic Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#dynamicBitmapText
 * @since 3.0.0
 *²
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
 */ GameObjectCreator.register('dynamicBitmapText', function(config, addToScene) {
                if (config === undefined) config = {};
                var font = GetAdvancedValue(config, 'font', '');
                var text = GetAdvancedValue(config, 'text', '');
                var size = GetAdvancedValue(config, 'size', false);
                var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, bitmapText, config);
                return bitmapText;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1157 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var Graphics = __webpack_require__(213);
            /**
 * Creates a new Graphics Game Object and returns it.
 *
 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#graphics
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
 */ GameObjectCreator.register('graphics', function(config, addToScene) {
                if (config === undefined) config = {};
                if (addToScene !== undefined) config.add = addToScene;
                var graphics = new Graphics(this.scene, config);
                if (config.add) this.scene.sys.displayList.add(graphics);
                return graphics;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1158 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var Group = __webpack_require__(110);
            /**
 * Creates a new Group Game Object and returns it.
 *
 * Note: This method will only be available if the Group Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#group
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Group.GroupConfig|Phaser.Types.GameObjects.Group.GroupCreateConfig} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Group} The Game Object that was created.
 */ GameObjectCreator.register('group', function(config) {
                return new Group(this.scene, null, config);
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1159 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Image1 = __webpack_require__(124);
            /**
 * Creates a new Image Game Object and returns it.
 *
 * Note: This method will only be available if the Image Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#image
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Image} The Game Object that was created.
 */ GameObjectCreator.register('image', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var image = new Image1(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, image, config);
                return image;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1160 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var Layer = __webpack_require__(216);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            /**
 * Creates a new Layer Game Object and returns it.
 *
 * Note: This method will only be available if the Layer Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#layer
 * @since 3.50.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Layer} The Game Object that was created.
 */ GameObjectCreator.register('layer', function(config, addToScene) {
                if (config === undefined) config = {};
                var children = GetAdvancedValue(config, 'children', null);
                var layer = new Layer(this.scene, children);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, layer, config);
                return layer;
            });
        /***/ },
        /* 1161 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetFastValue = __webpack_require__(2);
            var ParticleEmitterManager = __webpack_require__(217);
            /**
 * Creates a new Particle Emitter Manager Game Object and returns it.
 *
 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#particles
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
 */ GameObjectCreator.register('particles', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var emitters = GetFastValue(config, 'emitters', null);
                //  frame is optional and can contain the emitters array or object if skipped
                var manager = new ParticleEmitterManager(this.scene, key, frame, emitters);
                if (addToScene !== undefined) config.add = addToScene;
                var add = GetFastValue(config, 'add', false);
                if (add) this.displayList.add(manager);
                else this.updateList.add(manager);
                return manager;
            });
        /***/ },
        /* 1162 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var RenderTexture = __webpack_require__(218);
            /**
 * Creates a new Render Texture Game Object and returns it.
 *
 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#renderTexture
 * @since 3.2.0
 *
 * @param {Phaser.Types.GameObjects.RenderTexture.RenderTextureConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
 */ GameObjectCreator.register('renderTexture', function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, 'x', 0);
                var y = GetAdvancedValue(config, 'y', 0);
                var width = GetAdvancedValue(config, 'width', 32);
                var height = GetAdvancedValue(config, 'height', 32);
                var key = GetAdvancedValue(config, 'key', undefined);
                var frame = GetAdvancedValue(config, 'frame', undefined);
                var renderTexture = new RenderTexture(this.scene, x, y, width, height, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, renderTexture, config);
                return renderTexture;
            });
        /***/ },
        /* 1163 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var Rope = __webpack_require__(220);
            /**
 * Creates a new Rope Game Object and returns it.
 *
 * Note: This method will only be available if the Rope Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#rope
 * @since 3.23.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Rope} The Game Object that was created.
 */ GameObjectCreator.register('rope', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var horizontal = GetAdvancedValue(config, 'horizontal', true);
                var points = GetValue(config, 'points', undefined);
                var colors = GetValue(config, 'colors', undefined);
                var alphas = GetValue(config, 'alphas', undefined);
                var rope = new Rope(this.scene, 0, 0, key, frame, points, horizontal, colors, alphas);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, rope, config);
                if (!config.add) this.updateList.add(rope);
                return rope;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1164 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var BuildGameObjectAnimation = __webpack_require__(433);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Sprite = __webpack_require__(73);
            /**
 * Creates a new Sprite Game Object and returns it.
 *
 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#sprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
 */ GameObjectCreator.register('sprite', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var sprite = new Sprite(this.scene, 0, 0, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, sprite, config);
                //  Sprite specific config options:
                BuildGameObjectAnimation(sprite, config);
                return sprite;
            });
        /***/ },
        /* 1165 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BitmapText = __webpack_require__(147);
            var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            /**
 * Creates a new Bitmap Text Game Object and returns it.
 *
 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#bitmapText
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.BitmapText.BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 * 
 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
 */ GameObjectCreator.register('bitmapText', function(config, addToScene) {
                if (config === undefined) config = {};
                var font = GetValue(config, 'font', '');
                var text = GetAdvancedValue(config, 'text', '');
                var size = GetAdvancedValue(config, 'size', false);
                var align = GetValue(config, 'align', 0);
                var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size, align);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, bitmapText, config);
                return bitmapText;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1166 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Text = __webpack_require__(221);
            /**
 * Creates a new Text Game Object and returns it.
 *
 * Note: This method will only be available if the Text Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#text
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.Text.TextConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Text} The Game Object that was created.
 */ GameObjectCreator.register('text', function(config, addToScene) {
                if (config === undefined) config = {};
                // style Object = {
                //     font: [ 'font', '16px Courier' ],
                //     backgroundColor: [ 'backgroundColor', null ],
                //     fill: [ 'fill', '#fff' ],
                //     stroke: [ 'stroke', '#fff' ],
                //     strokeThickness: [ 'strokeThickness', 0 ],
                //     shadowOffsetX: [ 'shadow.offsetX', 0 ],
                //     shadowOffsetY: [ 'shadow.offsetY', 0 ],
                //     shadowColor: [ 'shadow.color', '#000' ],
                //     shadowBlur: [ 'shadow.blur', 0 ],
                //     shadowStroke: [ 'shadow.stroke', false ],
                //     shadowFill: [ 'shadow.fill', false ],
                //     align: [ 'align', 'left' ],
                //     maxLines: [ 'maxLines', 0 ],
                //     fixedWidth: [ 'fixedWidth', false ],
                //     fixedHeight: [ 'fixedHeight', false ],
                //     rtl: [ 'rtl', false ]
                // }
                var content = GetAdvancedValue(config, 'text', '');
                var style = GetAdvancedValue(config, 'style', null);
                //  Padding
                //      { padding: 2 }
                //      { padding: { x: , y: }}
                //      { padding: { left: , top: }}
                //      { padding: { left: , right: , top: , bottom: }}
                var padding = GetAdvancedValue(config, 'padding', null);
                if (padding !== null) style.padding = padding;
                var text = new Text(this.scene, 0, 0, content, style);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, text, config);
                //  Text specific config options:
                text.autoRound = GetAdvancedValue(config, 'autoRound', true);
                text.resolution = GetAdvancedValue(config, 'resolution', 1);
                return text;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1167 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var TileSprite = __webpack_require__(222);
            /**
 * Creates a new TileSprite Game Object and returns it.
 *
 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tileSprite
 * @since 3.0.0
 *
 * @param {Phaser.Types.GameObjects.TileSprite.TileSpriteConfig} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
 */ GameObjectCreator.register('tileSprite', function(config, addToScene) {
                if (config === undefined) config = {};
                var x = GetAdvancedValue(config, 'x', 0);
                var y = GetAdvancedValue(config, 'y', 0);
                var width = GetAdvancedValue(config, 'width', 512);
                var height = GetAdvancedValue(config, 'height', 512);
                var key = GetAdvancedValue(config, 'key', '');
                var frame = GetAdvancedValue(config, 'frame', '');
                var tile = new TileSprite(this.scene, x, y, width, height, key, frame);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, tile, config);
                return tile;
            });
        /***/ },
        /* 1168 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Zone = __webpack_require__(127);
            /**
 * Creates a new Zone Game Object and returns it.
 *
 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#zone
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 *
 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
 */ GameObjectCreator.register('zone', function(config) {
                var x = GetAdvancedValue(config, 'x', 0);
                var y = GetAdvancedValue(config, 'y', 0);
                var width = GetAdvancedValue(config, 'width', 1);
                var height = GetAdvancedValue(config, 'height', width);
                return new Zone(this.scene, x, y, width, height);
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1169 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Video = __webpack_require__(223);
            /**
 * Creates a new Video Game Object and returns it.
 *
 * Note: This method will only be available if the Video Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#video
 * @since 3.20.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Video} The Game Object that was created.
 */ GameObjectCreator.register('video', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var video = new Video(this.scene, 0, 0, key);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, video, config);
                if (!config.add) this.updateList.add(video);
                return video;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1170 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1171);
            renderCanvas = __webpack_require__(1172);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1171 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Shader#renderWebGL
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var ShaderWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                if (!src.shader) return;
                camera.addToRenderList(src);
                renderer.pipelines.clear();
                if (src.renderToTexture) {
                    src.load();
                    src.flush();
                } else {
                    var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                    //  Renderer size changed?
                    if (renderer.width !== src._rendererWidth || renderer.height !== src._rendererHeight) src.projOrtho(0, renderer.width, renderer.height, 0);
                    src.load(calcMatrix.matrix);
                    src.flush();
                }
                renderer.pipelines.rebind();
            };
            module1.exports = ShaderWebGLRenderer;
        /***/ },
        /* 1172 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Shader.Render. There is no Canvas renderer for Shader objects.
 *
 * @method Phaser.GameObjects.Shader#renderCanvas
 * @since 3.17.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Shader} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var ShaderCanvasRenderer = function() {};
            module1.exports = ShaderCanvasRenderer;
        /***/ },
        /* 1173 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1174);
            renderCanvas = __webpack_require__(1175);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1174 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.Mesh#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var MeshWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                var faces = src.faces;
                var totalFaces = faces.length;
                if (totalFaces === 0) return;
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var textureUnit = pipeline.setGameObject(src);
                var F32 = pipeline.vertexViewF32;
                var U32 = pipeline.vertexViewU32;
                var vertexOffset = pipeline.vertexCount * pipeline.currentShader.vertexComponentCount - 1;
                var tintEffect = src.tintFill;
                var debugFaces = [];
                var debugCallback = src.debugCallback;
                var a = calcMatrix.a;
                var b = calcMatrix.b;
                var c = calcMatrix.c;
                var d = calcMatrix.d;
                var e = calcMatrix.e;
                var f = calcMatrix.f;
                var z = src.viewPosition.z;
                var hideCCW = src.hideCCW;
                var roundPixels = camera.roundPixels;
                var alpha = camera.alpha * src.alpha;
                var totalFacesRendered = 0;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < totalFaces; i++){
                    var face = faces[i];
                    //  If face has alpha <= 0, or hideCCW + clockwise, or isn't in camera view, then don't draw it
                    if (!face.isInView(camera, hideCCW, z, alpha, a, b, c, d, e, f, roundPixels)) continue;
                    if (pipeline.shouldFlush(3)) {
                        pipeline.flush();
                        vertexOffset = 0;
                    }
                    vertexOffset = face.load(F32, U32, vertexOffset, textureUnit, tintEffect);
                    totalFacesRendered++;
                    pipeline.vertexCount += 3;
                    if (debugCallback) debugFaces.push(face);
                }
                src.totalFrame += totalFacesRendered;
                if (debugCallback) debugCallback.call(src, src, debugFaces);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = MeshWebGLRenderer;
        /***/ },
        /* 1175 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * This is a stub function for Mesh.Render. There is no Canvas renderer for Mesh objects.
 *
 * @method Phaser.GameObjects.Mesh#renderCanvas
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var MeshCanvasRenderer = function() {};
            module1.exports = MeshCanvasRenderer;
        /***/ },
        /* 1176 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1177);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1177 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetCalcMatrix = __webpack_require__(19);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.GameObjects.PointLight#renderWebGL
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.GameObjects.PointLight} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var PointLightWebGLRenderer = function(renderer, src, camera, parentMatrix) {
                camera.addToRenderList(src);
                var pipeline = renderer.pipelines.set(src.pipeline);
                var calcMatrix = GetCalcMatrix(src, camera, parentMatrix).calc;
                var width = src.width;
                var height = src.height;
                var x = -src._radius;
                var y = -src._radius;
                var xw = x + width;
                var yh = y + height;
                var lightX = calcMatrix.getX(0, 0);
                var lightY = calcMatrix.getY(0, 0);
                var tx0 = calcMatrix.getX(x, y);
                var ty0 = calcMatrix.getY(x, y);
                var tx1 = calcMatrix.getX(x, yh);
                var ty1 = calcMatrix.getY(x, yh);
                var tx2 = calcMatrix.getX(xw, yh);
                var ty2 = calcMatrix.getY(xw, yh);
                var tx3 = calcMatrix.getX(xw, y);
                var ty3 = calcMatrix.getY(xw, y);
                renderer.pipelines.preBatch(src);
                pipeline.batchPointLight(src, camera, tx0, ty0, tx1, ty1, tx2, ty2, tx3, ty3, lightX, lightY);
                renderer.pipelines.postBatch(src);
            };
            module1.exports = PointLightWebGLRenderer;
        /***/ },
        /* 1178 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Shader = __webpack_require__(226);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register('shader', function(key, x, y, width, height, textures, textureData) {
                return this.displayList.add(new Shader(this.scene, key, x, y, width, height, textures, textureData));
            });
        /***/ },
        /* 1179 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Mesh = __webpack_require__(227);
            var GameObjectFactory = __webpack_require__(5);
            GameObjectFactory.register('mesh', function(x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas) {
                return this.displayList.add(new Mesh(this.scene, x, y, texture, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas));
            });
        /***/ },
        /* 1180 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var PointLight = __webpack_require__(149);
            /**
 * Creates a new Point Light Game Object and adds it to the Scene.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * The Point Light Game Object provides a way to add a point light effect into your game,
 * without the expensive shader processing requirements of the traditional Light Game Object.
 *
 * The difference is that the Point Light renders using a custom shader, designed to give the
 * impression of a point light source, of variable radius, intensity and color, in your game.
 * However, unlike the Light Game Object, it does not impact any other Game Objects, or use their
 * normal maps for calcuations. This makes them extremely fast to render compared to Lights
 * and perfect for special effects, such as flickering torches or muzzle flashes.
 *
 * For maximum performance you should batch Point Light Game Objects together. This means
 * ensuring they follow each other consecutively on the display list. Ideally, use a Layer
 * Game Object and then add just Point Lights to it, so that it can batch together the rendering
 * of the lights. You don't _have_ to do this, and if you've only a handful of Point Lights in
 * your game then it's perfectly safe to mix them into the dislay list as normal. However, if
 * you're using a large number of them, please consider how they are mixed into the display list.
 *
 * The renderer will automatically cull Point Lights. Those with a radius that does not intersect
 * with the Camera will be skipped in the rendering list. This happens automatically and the
 * culled state is refreshed every frame, for every camera.
 *
 * The origin of a Point Light is always 0.5 and it cannot be changed.
 *
 * Point Lights are a WebGL only feature and do not have a Canvas counterpart.
 *
 * @method Phaser.GameObjects.GameObjectFactory#pointlight
 * @since 3.50.0
 *
 * @param {number} x - The horizontal position of this Point Light in the world.
 * @param {number} y - The vertical position of this Point Light in the world.
 * @param {number} [color=0xffffff] - The color of the Point Light, given as a hex value.
 * @param {number} [radius=128] - The radius of the Point Light.
 * @param {number} [intensity=1] - The intensity, or colr blend, of the Point Light.
 * @param {number} [attenuation=0.1] - The attenuation  of the Point Light. This is the reduction of light from the center point.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectFactory.register('pointlight', function(x, y, color, radius, intensity, attenuation) {
                return this.displayList.add(new PointLight(this.scene, x, y, color, radius, intensity, attenuation));
            });
        /***/ },
        /* 1181 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var Shader = __webpack_require__(226);
            /**
 * Creates a new Shader Game Object and returns it.
 *
 * Note: This method will only be available if the Shader Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#shader
 * @since 3.17.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Shader} The Game Object that was created.
 */ GameObjectCreator.register('shader', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var x = GetAdvancedValue(config, 'x', 0);
                var y = GetAdvancedValue(config, 'y', 0);
                var width = GetAdvancedValue(config, 'width', 128);
                var height = GetAdvancedValue(config, 'height', 128);
                var shader = new Shader(this.scene, key, x, y, width, height);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, shader, config);
                return shader;
            });
        //  When registering a factory function 'this' refers to the GameObjectCreator context.
        /***/ },
        /* 1182 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var GetValue = __webpack_require__(6);
            var Mesh = __webpack_require__(227);
            /**
 * Creates a new Mesh Game Object and returns it.
 *
 * Note: This method will only be available if the Mesh Game Object and WebGL support have been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#mesh
 * @since 3.0.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.Mesh} The Game Object that was created.
 */ GameObjectCreator.register('mesh', function(config, addToScene) {
                if (config === undefined) config = {};
                var key = GetAdvancedValue(config, 'key', null);
                var frame = GetAdvancedValue(config, 'frame', null);
                var vertices = GetValue(config, 'vertices', []);
                var uvs = GetValue(config, 'uvs', []);
                var indicies = GetValue(config, 'indicies', []);
                var containsZ = GetValue(config, 'containsZ', false);
                var normals = GetValue(config, 'normals', []);
                var colors = GetValue(config, 'colors', 0xffffff);
                var alphas = GetValue(config, 'alphas', 1);
                var mesh = new Mesh(this.scene, 0, 0, key, frame, vertices, uvs, indicies, containsZ, normals, colors, alphas);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, mesh, config);
                return mesh;
            });
        /***/ },
        /* 1183 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var BuildGameObject = __webpack_require__(28);
            var GameObjectCreator = __webpack_require__(16);
            var GetAdvancedValue = __webpack_require__(13);
            var PointLight = __webpack_require__(149);
            /**
 * Creates a new Point Light Game Object and returns it.
 *
 * Note: This method will only be available if the Point Light Game Object has been built into Phaser.
 *
 * @method Phaser.GameObjects.GameObjectCreator#pointlight
 * @since 3.50.0
 *
 * @param {object} config - The configuration object this Game Object will use to create itself.
 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
 *
 * @return {Phaser.GameObjects.PointLight} The Game Object that was created.
 */ GameObjectCreator.register('pointlight', function(config, addToScene) {
                if (config === undefined) config = {};
                var color = GetAdvancedValue(config, 'color', 0xffffff);
                var radius = GetAdvancedValue(config, 'radius', 128);
                var intensity = GetAdvancedValue(config, 'intensity', 1);
                var attenuation = GetAdvancedValue(config, 'attenuation', 0.1);
                var layer = new PointLight(this.scene, 0, 0, color, radius, intensity, attenuation);
                if (addToScene !== undefined) config.add = addToScene;
                BuildGameObject(this.scene, layer, config);
                return layer;
            });
        /***/ },
        /* 1184 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var LightsManager = __webpack_require__(476);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * A Scene plugin that provides a {@link Phaser.GameObjects.LightsManager} for the Light2D pipeline.
 *
 * Available from within a Scene via `this.lights`.
 *
 * Add Lights using the {@link Phaser.GameObjects.LightsManager#addLight} method:
 *
 * ```javascript
 * // Enable the Lights Manager because it is disabled by default
 * this.lights.enable();
 *
 * // Create a Light at [400, 300] with a radius of 200
 * this.lights.addLight(400, 300, 200);
 * ```
 *
 * For Game Objects to be affected by the Lights when rendered, you will need to set them to use the `Light2D` pipeline like so:
 *
 * ```javascript
 * sprite.setPipeline('Light2D');
 * ```
 *
 * Note that you cannot use this pipeline on Graphics Game Objects or Shape Game Objects.
 *
 * @class LightsPlugin
 * @extends Phaser.GameObjects.LightsManager
 * @memberof Phaser.GameObjects
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Lights Plugin belongs to.
 */ var LightsPlugin = new Class({
                Extends: LightsManager,
                initialize: function LightsPlugin(scene) {
                    /**
         * A reference to the Scene that this Lights Plugin belongs to.
         *
         * @name Phaser.GameObjects.LightsPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene's systems.
         *
         * @name Phaser.GameObjects.LightsPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    if (!scene.sys.settings.isBooted) scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    LightsManager.call(this);
                },
                /**
     * Boot the Lights Plugin.
     *
     * @method Phaser.GameObjects.LightsPlugin#boot
     * @since 3.0.0
     */ boot: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.SHUTDOWN, this.shutdown, this);
                    eventEmitter.on(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * Destroy the Lights Plugin.
     *
     * Cleans up all references.
     *
     * @method Phaser.GameObjects.LightsPlugin#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene = undefined;
                    this.systems = undefined;
                }
            });
            PluginCache.register('LightsPlugin', LightsPlugin, 'lights');
            module1.exports = LightsPlugin;
        /***/ },
        /* 1185 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(62);
            Circle.Area = __webpack_require__(1186);
            Circle.Circumference = __webpack_require__(296);
            Circle.CircumferencePoint = __webpack_require__(165);
            Circle.Clone = __webpack_require__(1187);
            Circle.Contains = __webpack_require__(63);
            Circle.ContainsPoint = __webpack_require__(1188);
            Circle.ContainsRect = __webpack_require__(1189);
            Circle.CopyFrom = __webpack_require__(1190);
            Circle.Equals = __webpack_require__(1191);
            Circle.GetBounds = __webpack_require__(1192);
            Circle.GetPoint = __webpack_require__(294);
            Circle.GetPoints = __webpack_require__(295);
            Circle.Offset = __webpack_require__(1193);
            Circle.OffsetPoint = __webpack_require__(1194);
            Circle.Random = __webpack_require__(166);
            module1.exports = Circle;
        /***/ },
        /* 1186 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the circle.
 *
 * @function Phaser.Geom.Circle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the area of.
 *
 * @return {number} The area of the Circle.
 */ var Area = function(circle) {
                return circle.radius > 0 ? Math.PI * circle.radius * circle.radius : 0;
            };
            module1.exports = Area;
        /***/ },
        /* 1187 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(62);
            /**
 * Creates a new Circle instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Circle.Clone
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|object)} source - The Circle to be cloned. Can be an instance of a Circle or a circle-like object, with x, y and radius properties.
 *
 * @return {Phaser.Geom.Circle} A clone of the source Circle.
 */ var Clone = function(source) {
                return new Circle(source.x, source.y, source.radius);
            };
            module1.exports = Clone;
        /***/ },
        /* 1188 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(63);
            /**
 * Check to see if the Circle contains the given Point object.
 *
 * @function Phaser.Geom.Circle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(circle, point) {
                return Contains(circle, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1189 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(63);
            /**
 * Check to see if the Circle contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Circle.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Circle or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the circle, otherwise false.
 */ var ContainsRect = function(circle, rect) {
                return Contains(circle, rect.x, rect.y) && Contains(circle, rect.right, rect.y) && Contains(circle, rect.x, rect.bottom) && Contains(circle, rect.right, rect.bottom);
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 1190 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y` and `radius` properties from the `source` Circle
 * into the given `dest` Circle, then returns the `dest` Circle.
 *
 * @function Phaser.Geom.Circle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Circle} source - The source Circle to copy the values from.
 * @param {Phaser.Geom.Circle} dest - The destination Circle to copy the values to.
 *
 * @return {Phaser.Geom.Circle} The destination Circle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.radius);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1191 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y` and `radius` properties of the two given Circles.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Circle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The first Circle to compare.
 * @param {Phaser.Geom.Circle} toCompare - The second Circle to compare.
 *
 * @return {boolean} `true` if the two Circles equal each other, otherwise `false`.
 */ var Equals = function(circle, toCompare) {
                return circle.x === toCompare.x && circle.y === toCompare.y && circle.radius === toCompare.radius;
            };
            module1.exports = Equals;
        /***/ },
        /* 1192 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Returns the bounds of the Circle object.
 *
 * @function Phaser.Geom.Circle.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the circle bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Circles bounds.
 */ var GetBounds = function(circle, out) {
                if (out === undefined) out = new Rectangle();
                out.x = circle.left;
                out.y = circle.top;
                out.width = circle.diameter;
                out.height = circle.diameter;
                return out;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 1193 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given.
 *
 * @function Phaser.Geom.Circle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Circle by.
 * @param {number} y - The amount to vertically offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var Offset = function(circle, x, y) {
                circle.x += x;
                circle.y += y;
                return circle;
            };
            module1.exports = Offset;
        /***/ },
        /* 1194 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Circle by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Circle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [circle,$return]
 *
 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Circle by.
 *
 * @return {Phaser.Geom.Circle} The Circle that was offset.
 */ var OffsetPoint = function(circle, point) {
                circle.x += point.x;
                circle.y += point.y;
                return circle;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1195 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(108);
            Ellipse.Area = __webpack_require__(1196);
            Ellipse.Circumference = __webpack_require__(441);
            Ellipse.CircumferencePoint = __webpack_require__(215);
            Ellipse.Clone = __webpack_require__(1197);
            Ellipse.Contains = __webpack_require__(109);
            Ellipse.ContainsPoint = __webpack_require__(1198);
            Ellipse.ContainsRect = __webpack_require__(1199);
            Ellipse.CopyFrom = __webpack_require__(1200);
            Ellipse.Equals = __webpack_require__(1201);
            Ellipse.GetBounds = __webpack_require__(1202);
            Ellipse.GetPoint = __webpack_require__(439);
            Ellipse.GetPoints = __webpack_require__(440);
            Ellipse.Offset = __webpack_require__(1203);
            Ellipse.OffsetPoint = __webpack_require__(1204);
            Ellipse.Random = __webpack_require__(177);
            module1.exports = Ellipse;
        /***/ },
        /* 1196 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the Ellipse.
 *
 * @function Phaser.Geom.Ellipse.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the area of.
 *
 * @return {number} The area of the Ellipse.
 */ var Area = function(ellipse) {
                if (ellipse.isEmpty()) return 0;
                //  units squared
                return ellipse.getMajorRadius() * ellipse.getMinorRadius() * Math.PI;
            };
            module1.exports = Area;
        /***/ },
        /* 1197 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Ellipse = __webpack_require__(108);
            /**
 * Creates a new Ellipse instance based on the values contained in the given source.
 *
 * @function Phaser.Geom.Ellipse.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} source - The Ellipse to be cloned. Can be an instance of an Ellipse or a ellipse-like object, with x, y, width and height properties.
 *
 * @return {Phaser.Geom.Ellipse} A clone of the source Ellipse.
 */ var Clone = function(source) {
                return new Ellipse(source.x, source.y, source.width, source.height);
            };
            module1.exports = Clone;
        /***/ },
        /* 1198 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(109);
            /**
 * Check to see if the Ellipse contains the given Point object.
 *
 * @function Phaser.Geom.Ellipse.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
 *
 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
 */ var ContainsPoint = function(ellipse, point) {
                return Contains(ellipse, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1199 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(109);
            /**
 * Check to see if the Ellipse contains all four points of the given Rectangle object.
 *
 * @function Phaser.Geom.Ellipse.ContainsRect
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Ellipse or not.
 *
 * @return {boolean} True if all of the Rectangle coordinates are within the ellipse, otherwise false.
 */ var ContainsRect = function(ellipse, rect) {
                return Contains(ellipse, rect.x, rect.y) && Contains(ellipse, rect.right, rect.y) && Contains(ellipse, rect.x, rect.bottom) && Contains(ellipse, rect.right, rect.bottom);
            };
            module1.exports = ContainsRect;
        /***/ },
        /* 1200 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copies the `x`, `y`, `width` and `height` properties from the `source` Ellipse
 * into the given `dest` Ellipse, then returns the `dest` Ellipse.
 *
 * @function Phaser.Geom.Ellipse.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [dest,$return]
 *
 * @param {Phaser.Geom.Ellipse} source - The source Ellipse to copy the values from.
 * @param {Phaser.Geom.Ellipse} dest - The destination Ellipse to copy the values to.
 *
 * @return {Phaser.Geom.Ellipse} The destination Ellipse.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.width, source.height);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1201 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of the two given Ellipses.
 * Returns `true` if they all match, otherwise returns `false`.
 *
 * @function Phaser.Geom.Ellipse.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The first Ellipse to compare.
 * @param {Phaser.Geom.Ellipse} toCompare - The second Ellipse to compare.
 *
 * @return {boolean} `true` if the two Ellipse equal each other, otherwise `false`.
 */ var Equals = function(ellipse, toCompare) {
                return ellipse.x === toCompare.x && ellipse.y === toCompare.y && ellipse.width === toCompare.width && ellipse.height === toCompare.height;
            };
            module1.exports = Equals;
        /***/ },
        /* 1202 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Returns the bounds of the Ellipse object.
 *
 * @function Phaser.Geom.Ellipse.GetBounds
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the bounds from.
 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the ellipse bounds in. If not given a new Rectangle will be created.
 *
 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Ellipse bounds.
 */ var GetBounds = function(ellipse, out) {
                if (out === undefined) out = new Rectangle();
                out.x = ellipse.left;
                out.y = ellipse.top;
                out.width = ellipse.width;
                out.height = ellipse.height;
                return out;
            };
            module1.exports = GetBounds;
        /***/ },
        /* 1203 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given.
 *
 * @function Phaser.Geom.Ellipse.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {number} x - The amount to horizontally offset the Ellipse by.
 * @param {number} y - The amount to vertically offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var Offset = function(ellipse, x, y) {
                ellipse.x += x;
                ellipse.y += y;
                return ellipse;
            };
            module1.exports = Offset;
        /***/ },
        /* 1204 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offsets the Ellipse by the values given in the `x` and `y` properties of the Point object.
 *
 * @function Phaser.Geom.Ellipse.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
 *
 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Ellipse by.
 *
 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
 */ var OffsetPoint = function(ellipse, point) {
                ellipse.x += point.x;
                ellipse.y += point.y;
                return ellipse;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1205 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var CircleToCircle = __webpack_require__(228);
            /**
 * Checks if two Circles intersect and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circleA - The first Circle to check for intersection.
 * @param {Phaser.Geom.Circle} circleB - The second Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToCircle = function(circleA, circleB, out) {
                if (out === undefined) out = [];
                if (CircleToCircle(circleA, circleB)) {
                    var x0 = circleA.x;
                    var y0 = circleA.y;
                    var r0 = circleA.radius;
                    var x1 = circleB.x;
                    var y1 = circleB.y;
                    var r1 = circleB.radius;
                    var coefficientA, coefficientB, coefficientC, lambda, x;
                    if (y0 === y1) {
                        x = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0) / (2 * (x0 - x1));
                        coefficientA = 1;
                        coefficientB = -2 * y1;
                        coefficientC = x1 * x1 + x * x - 2 * x1 * x + y1 * y1 - r1 * r1;
                        lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                        if (lambda === 0) out.push(new Point(x, -coefficientB / (2 * coefficientA)));
                        else if (lambda > 0) {
                            out.push(new Point(x, (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA)));
                            out.push(new Point(x, (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA)));
                        }
                    } else {
                        var v1 = (x0 - x1) / (y0 - y1);
                        var n = (r1 * r1 - r0 * r0 - x1 * x1 + x0 * x0 - y1 * y1 + y0 * y0) / (2 * (y0 - y1));
                        coefficientA = v1 * v1 + 1;
                        coefficientB = 2 * y0 * v1 - 2 * n * v1 - 2 * x0;
                        coefficientC = x0 * x0 + y0 * y0 + n * n - r0 * r0 - 2 * y0 * n;
                        lambda = coefficientB * coefficientB - 4 * coefficientA * coefficientC;
                        if (lambda === 0) {
                            x = -coefficientB / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                        } else if (lambda > 0) {
                            x = (-coefficientB + Math.sqrt(lambda)) / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                            x = (-coefficientB - Math.sqrt(lambda)) / (2 * coefficientA);
                            out.push(new Point(x, n - x * v1));
                        }
                    }
                }
                return out;
            };
            module1.exports = GetCircleToCircle;
        /***/ },
        /* 1206 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(229);
            var CircleToRectangle = __webpack_require__(150);
            /**
 * Checks for intersection between a circle and a rectangle,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetCircleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Circle} circle - The circle to be checked.
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to be checked.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetCircleToRectangle = function(circle, rect, out) {
                if (out === undefined) out = [];
                if (CircleToRectangle(circle, rect)) {
                    var lineA = rect.getLineA();
                    var lineB = rect.getLineB();
                    var lineC = rect.getLineC();
                    var lineD = rect.getLineD();
                    GetLineToCircle(lineA, circle, out);
                    GetLineToCircle(lineB, circle, out);
                    GetLineToCircle(lineC, circle, out);
                    GetLineToCircle(lineD, circle, out);
                }
                return out;
            };
            module1.exports = GetCircleToRectangle;
        /***/ },
        /* 1207 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector4 = __webpack_require__(138);
            var GetLineToPolygon = __webpack_require__(481);
            var Line = __webpack_require__(45);
            //  Temp calculation segment
            var segment = new Line();
            /**
 * @ignore
 */ function CheckIntersects(angle, x, y, polygons, intersects) {
                var dx = Math.cos(angle);
                var dy = Math.sin(angle);
                segment.setTo(x, y, x + dx, y + dy);
                var closestIntersect = GetLineToPolygon(segment, polygons);
                if (closestIntersect) intersects.push(new Vector4(closestIntersect.x, closestIntersect.y, angle, closestIntersect.w));
            }
            /**
 * @ignore
 */ function SortIntersects(a, b) {
                return a.z - b.z;
            }
            /**
 * Projects rays out from the given point to each line segment of the polygons.
 *
 * If the rays intersect with the polygons, the points of intersection are returned in an array.
 *
 * If no intersections are found, the returned array will be empty.
 *
 * Each Vector4 intersection result has the following properties:
 *
 * The `x` and `y` components contain the point of the intersection.
 * The `z` component contains the angle of intersection.
 * The `w` component contains the index of the polygon, in the given array, that triggered the intersection.
 *
 * @function Phaser.Geom.Intersects.GetRaysFromPointToPolygon
 * @since 3.50.0
 *
 * @param {number} x - The x coordinate to project the rays from.
 * @param {number} y - The y coordinate to project the rays from.
 * @param {Phaser.Geom.Polygon | Phaser.Geom.Polygon[]} polygons - A single polygon, or array of polygons, to check against the rays.
 *
 * @return {Phaser.Math.Vector4[]} An array containing all intersections in Vector4s.
 */ var GetRaysFromPointToPolygon = function(x, y, polygons) {
                if (!Array.isArray(polygons)) polygons = [
                    polygons
                ];
                var intersects = [];
                var angles = [];
                for(var i = 0; i < polygons.length; i++){
                    var points = polygons[i].points;
                    for(var p = 0; p < points.length; p++){
                        var angle = Math.atan2(points[p].y - y, points[p].x - x);
                        if (angles.indexOf(angle) === -1) {
                            //  +- 0.00001 rads to catch lines behind segment corners
                            CheckIntersects(angle, x, y, polygons, intersects);
                            CheckIntersects(angle - 0.00001, x, y, polygons, intersects);
                            CheckIntersects(angle + 0.00001, x, y, polygons, intersects);
                            angles.push(angle);
                        }
                    }
                }
                return intersects.sort(SortIntersects);
            };
            module1.exports = GetRaysFromPointToPolygon;
        /***/ },
        /* 1208 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var RectangleToRectangle = __webpack_require__(114);
            /**
 * Checks if two Rectangle shapes intersect and returns the area of this intersection as Rectangle object.
 * 
 * If optional `output` parameter is omitted, new Rectangle object is created and returned. If there is intersection, it will contain intersection area. If there is no intersection, it wil be empty Rectangle (all values set to zero).
 * 
 * If Rectangle object is passed as `output` and there is intersection, then intersection area data will be loaded into it and it will be returned. If there is no intersection, it will be returned without any change.
 *
 * @function Phaser.Geom.Intersects.GetRectangleIntersection
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [output,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle object.
 * @param {Phaser.Geom.Rectangle} [output] - Optional Rectangle object. If given, the intersection data will be loaded into it (in case of no intersection, it will be left unchanged). Otherwise, new Rectangle object will be created and returned with either intersection data or empty (all values set to zero), if there is no intersection.
 *
 * @return {Phaser.Geom.Rectangle} A rectangle object with intersection data.
 */ var GetRectangleIntersection = function(rectA, rectB, output) {
                if (output === undefined) output = new Rectangle();
                if (RectangleToRectangle(rectA, rectB)) {
                    output.x = Math.max(rectA.x, rectB.x);
                    output.y = Math.max(rectA.y, rectB.y);
                    output.width = Math.min(rectA.right, rectB.right) - output.x;
                    output.height = Math.min(rectA.bottom, rectB.bottom) - output.y;
                }
                return output;
            };
            module1.exports = GetRectangleIntersection;
        /***/ },
        /* 1209 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToRectangle = __webpack_require__(231);
            var RectangleToRectangle = __webpack_require__(114);
            /**
 * Checks if two Rectangles intersect and returns the intersection points as a Point object array.
 *
 * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds. As such, the two Rectangles are considered "solid". A Rectangle with no width or no height will never intersect another Rectangle.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToRectangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check for intersection.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToRectangle = function(rectA, rectB, out) {
                if (out === undefined) out = [];
                if (RectangleToRectangle(rectA, rectB)) {
                    var lineA = rectA.getLineA();
                    var lineB = rectA.getLineB();
                    var lineC = rectA.getLineC();
                    var lineD = rectA.getLineD();
                    GetLineToRectangle(lineA, rectB, out);
                    GetLineToRectangle(lineB, rectB, out);
                    GetLineToRectangle(lineC, rectB, out);
                    GetLineToRectangle(lineD, rectB, out);
                }
                return out;
            };
            module1.exports = GetRectangleToRectangle;
        /***/ },
        /* 1210 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RectangleToTriangle = __webpack_require__(483);
            var GetLineToRectangle = __webpack_require__(231);
            /**
 * Checks for intersection between Rectangle shape and Triangle shape,
 * and returns the intersection points as a Point object array.
 *
 * @function Phaser.Geom.Intersects.GetRectangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle object to test.
 * @param {Phaser.Geom.Triangle} triangle - Triangle object to test.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetRectangleToTriangle = function(rect, triangle, out) {
                if (out === undefined) out = [];
                if (RectangleToTriangle(rect, triangle)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    GetLineToRectangle(lineA, rect, out);
                    GetLineToRectangle(lineB, rect, out);
                    GetLineToRectangle(lineC, rect, out);
                }
                return out;
            };
            module1.exports = GetRectangleToTriangle;
        /***/ },
        /* 1211 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetLineToCircle = __webpack_require__(229);
            var TriangleToCircle = __webpack_require__(485);
            /**
 * Checks if a Triangle and a Circle intersect, and returns the intersection points as a Point object array.
 *
 * A Circle intersects a Triangle if its center is located within it or if any of the Triangle's sides intersect the Circle. As such, the Triangle and the Circle are considered "solid" for the intersection.
 *
 * @function Phaser.Geom.Intersects.GetTriangleToCircle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to check for intersection.
 * @param {Phaser.Geom.Circle} circle - The Circle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToCircle = function(triangle, circle, out) {
                if (out === undefined) out = [];
                if (TriangleToCircle(triangle, circle)) {
                    var lineA = triangle.getLineA();
                    var lineB = triangle.getLineB();
                    var lineC = triangle.getLineC();
                    GetLineToCircle(lineA, circle, out);
                    GetLineToCircle(lineB, circle, out);
                    GetLineToCircle(lineC, circle, out);
                }
                return out;
            };
            module1.exports = GetTriangleToCircle;
        /***/ },
        /* 1212 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Florian Vazelle
 * @author       Geoffrey Glaive
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TriangleToTriangle = __webpack_require__(488);
            var GetTriangleToLine = __webpack_require__(486);
            /**
 * Checks if two Triangles intersect, and returns the intersection points as a Point object array.
 *
 * A Triangle intersects another Triangle if any pair of their lines intersects or if any point of one Triangle is within the other Triangle. Thus, the Triangles are considered "solid".
 *
 * @function Phaser.Geom.Intersects.GetTriangleToTriangle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangleA - The first Triangle to check for intersection.
 * @param {Phaser.Geom.Triangle} triangleB - The second Triangle to check for intersection.
 * @param {array} [out] - An optional array in which to store the points of intersection.
 *
 * @return {array} An array with the points of intersection if objects intersect, otherwise an empty array.
 */ var GetTriangleToTriangle = function(triangleA, triangleB, out) {
                if (out === undefined) out = [];
                if (TriangleToTriangle(triangleA, triangleB)) {
                    var lineA = triangleB.getLineA();
                    var lineB = triangleB.getLineB();
                    var lineC = triangleB.getLineC();
                    GetTriangleToLine(triangleA, lineA, out);
                    GetTriangleToLine(triangleA, lineB, out);
                    GetTriangleToLine(triangleA, lineC, out);
                }
                return out;
            };
            module1.exports = GetTriangleToTriangle;
        /***/ },
        /* 1213 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PointToLine = __webpack_require__(490);
            /**
 * Checks if a Point is located on the given line segment.
 *
 * @function Phaser.Geom.Intersects.PointToLineSegment
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The Point to check for intersection.
 * @param {Phaser.Geom.Line} line - The line segment to check for intersection.
 *
 * @return {boolean} `true` if the Point is on the given line segment, otherwise `false`.
 */ var PointToLineSegment = function(point, line) {
                if (!PointToLine(point, line)) return false;
                var xMin = Math.min(line.x1, line.x2);
                var xMax = Math.max(line.x1, line.x2);
                var yMin = Math.min(line.y1, line.y2);
                var yMax = Math.max(line.y1, line.y2);
                return point.x >= xMin && point.x <= xMax && point.y >= yMin && point.y <= yMax;
            };
            module1.exports = PointToLineSegment;
        /***/ },
        /* 1214 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Check if rectangle intersects with values.
 *
 * @function Phaser.Geom.Intersects.RectangleToValues
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle object
 * @param {number} left - The x coordinate of the left of the Rectangle.
 * @param {number} right - The x coordinate of the right of the Rectangle.
 * @param {number} top - The y coordinate of the top of the Rectangle.
 * @param {number} bottom - The y coordinate of the bottom of the Rectangle.
 * @param {number} [tolerance=0] - Tolerance allowed in the calculation, expressed in pixels.
 *
 * @return {boolean} Returns true if there is an intersection.
 */ var RectangleToValues = function(rect, left, right, top, bottom, tolerance) {
                if (tolerance === undefined) tolerance = 0;
                return !(left > rect.right + tolerance || right < rect.left - tolerance || top > rect.bottom + tolerance || bottom < rect.top - tolerance);
            };
            module1.exports = RectangleToValues;
        /***/ },
        /* 1215 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(45);
            Line.Angle = __webpack_require__(93);
            Line.BresenhamPoints = __webpack_require__(311);
            Line.CenterOn = __webpack_require__(1216);
            Line.Clone = __webpack_require__(1217);
            Line.CopyFrom = __webpack_require__(1218);
            Line.Equals = __webpack_require__(1219);
            Line.Extend = __webpack_require__(1220);
            Line.GetEasedPoints = __webpack_require__(1221);
            Line.GetMidPoint = __webpack_require__(1222);
            Line.GetNearestPoint = __webpack_require__(1223);
            Line.GetNormal = __webpack_require__(1224);
            Line.GetPoint = __webpack_require__(301);
            Line.GetPoints = __webpack_require__(168);
            Line.GetShortestDistance = __webpack_require__(1225);
            Line.Height = __webpack_require__(1226);
            Line.Length = __webpack_require__(64);
            Line.NormalAngle = __webpack_require__(491);
            Line.NormalX = __webpack_require__(1227);
            Line.NormalY = __webpack_require__(1228);
            Line.Offset = __webpack_require__(1229);
            Line.PerpSlope = __webpack_require__(1230);
            Line.Random = __webpack_require__(169);
            Line.ReflectAngle = __webpack_require__(1231);
            Line.Rotate = __webpack_require__(1232);
            Line.RotateAroundPoint = __webpack_require__(1233);
            Line.RotateAroundXY = __webpack_require__(233);
            Line.SetToAngle = __webpack_require__(1234);
            Line.Slope = __webpack_require__(1235);
            Line.Width = __webpack_require__(1236);
            module1.exports = Line;
        /***/ },
        /* 1216 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Center a line on the given coordinates.
 *
 * @function Phaser.Geom.Line.CenterOn
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to center.
 * @param {number} x - The horizontal coordinate to center the line on.
 * @param {number} y - The vertical coordinate to center the line on.
 *
 * @return {Phaser.Geom.Line} The centered line.
 */ var CenterOn = function(line, x, y) {
                var tx = x - (line.x1 + line.x2) / 2;
                var ty = y - (line.y1 + line.y2) / 2;
                line.x1 += tx;
                line.y1 += ty;
                line.x2 += tx;
                line.y2 += ty;
                return line;
            };
            module1.exports = CenterOn;
        /***/ },
        /* 1217 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Line = __webpack_require__(45);
            /**
 * Clone the given line.
 *
 * @function Phaser.Geom.Line.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} source - The source line to clone.
 *
 * @return {Phaser.Geom.Line} The cloned line.
 */ var Clone = function(source) {
                return new Line(source.x1, source.y1, source.x2, source.y2);
            };
            module1.exports = Clone;
        /***/ },
        /* 1218 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one line to a destination line.
 *
 * @function Phaser.Geom.Line.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [dest,$return]
 *
 * @param {Phaser.Geom.Line} source - The source line to copy the values from.
 * @param {Phaser.Geom.Line} dest - The destination line to copy the values to.
 *
 * @return {Phaser.Geom.Line} The destination line.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x1, source.y1, source.x2, source.y2);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1219 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compare two lines for strict equality.
 *
 * @function Phaser.Geom.Line.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The first line to compare.
 * @param {Phaser.Geom.Line} toCompare - The second line to compare.
 *
 * @return {boolean} Whether the two lines are equal.
 */ var Equals = function(line, toCompare) {
                return line.x1 === toCompare.x1 && line.y1 === toCompare.y1 && line.x2 === toCompare.x2 && line.y2 === toCompare.y2;
            };
            module1.exports = Equals;
        /***/ },
        /* 1220 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            /**
 * Extends the start and end points of a Line by the given amounts.
 *
 * The amounts can be positive or negative. Positive points will increase the length of the line,
 * while negative ones will decrease it.
 *
 * If no `right` value is provided it will extend the length of the line equally in both directions.
 *
 * Pass a value of zero to leave the start or end point unchanged.
 *
 * @function Phaser.Geom.Line.Extend
 * @since 3.16.0
 *
 * @param {Phaser.Geom.Line} line - The line instance to extend.
 * @param {number} left - The amount to extend the start of the line by.
 * @param {number} [right] - The amount to extend the end of the line by. If not given it will be set to the `left` value.
 *
 * @return {Phaser.Geom.Line} The modified Line instance.
 */ var Extend = function(line, left, right) {
                if (right === undefined) right = left;
                var length = Length(line);
                var slopX = line.x2 - line.x1;
                var slopY = line.y2 - line.y1;
                if (left) {
                    line.x1 = line.x1 - slopX / length * left;
                    line.y1 = line.y1 - slopY / length * left;
                }
                if (right) {
                    line.x2 = line.x2 + slopX / length * right;
                    line.y2 = line.y2 + slopY / length * right;
                }
                return line;
            };
            module1.exports = Extend;
        /***/ },
        /* 1221 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var DistanceBetweenPoints = __webpack_require__(346);
            var GetEaseFunction = __webpack_require__(80);
            var Point = __webpack_require__(4);
            /**
 * Returns an array of `quantity` Points where each point is taken from the given Line,
 * spaced out according to the ease function specified.
 * 
 * ```javascript
 * const line = new Phaser.Geom.Line(100, 300, 700, 300);
 * const points = Phaser.Geom.Line.GetEasedPoints(line, 'sine.out', 32)
 * ```
 * 
 * In the above example, the `points` array will contain 32 points spread-out across
 * the length of `line`, where the position of each point is determined by the `Sine.out`
 * ease function.
 * 
 * You can optionally provide a collinear threshold. In this case, the resulting points
 * are checked against each other, and if they are `< collinearThreshold` distance apart,
 * they are dropped from the results. This can help avoid lots of clustered points at
 * far ends of the line with tightly-packed eases such as Quartic. Leave the value set
 * to zero to skip this check.
 * 
 * Note that if you provide a collinear threshold, the resulting array may not always
 * contain `quantity` points.
 *
 * @function Phaser.Geom.Line.GetEasedPoints
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Point[]} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The Line object.
 * @param {(string|function)} ease - The ease to use. This can be either a string from the EaseMap, or a custom function.
 * @param {number} quantity - The number of points to return. Note that if you provide a `collinearThreshold`, the resulting array may not always contain this number of points.
 * @param {number} [collinearThreshold=0] - An optional threshold. The final array is reduced so that each point is spaced out at least this distance apart. This helps reduce clustering in noisey eases.
 * @param {number[]} [easeParams] - An optional array of ease parameters to go with the ease.
 *
 * @return {Phaser.Geom.Point[]} An array of Geom.Points containing the coordinates of the points on the line.
 */ var GetEasedPoints = function(line, ease, quantity, collinearThreshold, easeParams) {
                if (collinearThreshold === undefined) collinearThreshold = 0;
                if (easeParams === undefined) easeParams = [];
                var results = [];
                var x1 = line.x1;
                var y1 = line.y1;
                var spaceX = line.x2 - x1;
                var spaceY = line.y2 - y1;
                var easeFunc = GetEaseFunction(ease, easeParams);
                var i;
                var v;
                var q = quantity - 1;
                for(i = 0; i < q; i++){
                    v = easeFunc(i / q);
                    results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                }
                //  Always include the end of the line
                v = easeFunc(1);
                results.push(new Point(x1 + spaceX * v, y1 + spaceY * v));
                //  Remove collinear parts
                if (collinearThreshold > 0) {
                    var prevPoint = results[0];
                    //  Store the new results here
                    var sortedResults = [
                        prevPoint
                    ];
                    for(i = 1; i < results.length - 1; i++){
                        var point = results[i];
                        if (DistanceBetweenPoints(prevPoint, point) >= collinearThreshold) {
                            sortedResults.push(point);
                            prevPoint = point;
                        }
                    }
                    //  Top and tail
                    var endPoint = results[results.length - 1];
                    if (DistanceBetweenPoints(prevPoint, endPoint) < collinearThreshold) sortedResults.pop();
                    sortedResults.push(endPoint);
                    return sortedResults;
                } else return results;
            };
            module1.exports = GetEasedPoints;
        /***/ },
        /* 1222 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the midpoint of the given line.
 *
 * @function Phaser.Geom.Line.GetMidPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the midpoint of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the midpoint in.
 *
 * @return {(Phaser.Geom.Point|object)} The midpoint of the Line.
 */ var GetMidPoint = function(line, out) {
                if (out === undefined) out = new Point();
                out.x = (line.x1 + line.x2) / 2;
                out.y = (line.y1 + line.y2) / 2;
                return out;
            };
            module1.exports = GetMidPoint;
        /***/ },
        /* 1223 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the nearest point on a line perpendicular to the given point.
 *
 * @function Phaser.Geom.Line.GetNearestPoint
 * @since 3.16.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the nearest point on.
 * @param {(Phaser.Geom.Point|object)} point - The point to get the nearest point to.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point, or point-like object, to store the coordinates of the nearest point on the line.
 *
 * @return {(Phaser.Geom.Point|object)} The nearest point on the line.
 */ var GetNearestPoint = function(line, point, out) {
                if (out === undefined) out = new Point();
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return out;
                var r = ((point.x - x1) * (x2 - x1) + (point.y - y1) * (y2 - y1)) / L2;
                out.x = x1 + r * (x2 - x1);
                out.y = y1 + r * (y2 - y1);
                return out;
            };
            module1.exports = GetNearestPoint;
        /***/ },
        /* 1224 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(93);
            var Point = __webpack_require__(4);
            /**
 * Calculate the normal of the given line.
 *
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.GetNormal
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional point object to store the normal in.
 *
 * @return {(Phaser.Geom.Point|object)} The normal of the Line.
 */ var GetNormal = function(line, out) {
                if (out === undefined) out = new Point();
                var a = Angle(line) - MATH_CONST.TAU;
                out.x = Math.cos(a);
                out.y = Math.sin(a);
                return out;
            };
            module1.exports = GetNormal;
        /***/ },
        /* 1225 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Florian Mertens
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Get the shortest distance from a Line to the given Point.
 *
 * @function Phaser.Geom.Line.GetShortestDistance
 * @since 3.16.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to get the distance from.
 * @param {(Phaser.Geom.Point|object)} point - The point to get the shortest distance to.
 *
 * @return {number} The shortest distance from the line to the point.
 */ var GetShortestDistance = function(line, point) {
                var x1 = line.x1;
                var y1 = line.y1;
                var x2 = line.x2;
                var y2 = line.y2;
                var L2 = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
                if (L2 === 0) return false;
                var s = ((y1 - point.y) * (x2 - x1) - (x1 - point.x) * (y2 - y1)) / L2;
                return Math.abs(s) * Math.sqrt(L2);
            };
            module1.exports = GetShortestDistance;
        /***/ },
        /* 1226 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the height of the given line.
 *
 * @function Phaser.Geom.Line.Height
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the height of.
 *
 * @return {number} The height of the line.
 */ var Height = function(line) {
                return Math.abs(line.y1 - line.y2);
            };
            module1.exports = Height;
        /***/ },
        /* 1227 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(93);
            /**
 * Returns the x component of the normal vector of the given line.
 *
 * @function Phaser.Geom.Line.NormalX
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The Line object to get the normal value from.
 *
 * @return {number} The x component of the normal vector of the line.
 */ var NormalX = function(line) {
                return Math.cos(Angle(line) - MATH_CONST.TAU);
            };
            module1.exports = NormalX;
        /***/ },
        /* 1228 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MATH_CONST = __webpack_require__(14);
            var Angle = __webpack_require__(93);
            /**
 * The Y value of the normal of the given line.
 * The normal of a line is a vector that points perpendicular from it.
 *
 * @function Phaser.Geom.Line.NormalY
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the normal of.
 *
 * @return {number} The Y value of the normal of the Line.
 */ var NormalY = function(line) {
                return Math.sin(Angle(line) - MATH_CONST.TAU);
            };
            module1.exports = NormalY;
        /***/ },
        /* 1229 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Offset a line by the given amount.
 *
 * @function Phaser.Geom.Line.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to offset.
 * @param {number} x - The horizontal offset to add to the line.
 * @param {number} y - The vertical offset to add to the line.
 *
 * @return {Phaser.Geom.Line} The offset line.
 */ var Offset = function(line, x, y) {
                line.x1 += x;
                line.y1 += y;
                line.x2 += x;
                line.y2 += y;
                return line;
            };
            module1.exports = Offset;
        /***/ },
        /* 1230 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the perpendicular slope of the given line.
 *
 * @function Phaser.Geom.Line.PerpSlope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the perpendicular slope of.
 *
 * @return {number} The perpendicular slope of the line.
 */ var PerpSlope = function(line) {
                return -((line.x2 - line.x1) / (line.y2 - line.y1));
            };
            module1.exports = PerpSlope;
        /***/ },
        /* 1231 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Angle = __webpack_require__(93);
            var NormalAngle = __webpack_require__(491);
            /**
 * Calculate the reflected angle between two lines.
 *
 * This is the outgoing angle based on the angle of Line 1 and the normalAngle of Line 2.
 *
 * @function Phaser.Geom.Line.ReflectAngle
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} lineA - The first line.
 * @param {Phaser.Geom.Line} lineB - The second line.
 *
 * @return {number} The reflected angle between each line.
 */ var ReflectAngle = function(lineA, lineB) {
                return 2 * NormalAngle(lineB) - Math.PI - Angle(lineA);
            };
            module1.exports = ReflectAngle;
        /***/ },
        /* 1232 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(233);
            /**
 * Rotate a line around its midpoint by the given angle in radians.
 *
 * @function Phaser.Geom.Line.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var Rotate = function(line, angle) {
                var x = (line.x1 + line.x2) / 2;
                var y = (line.y1 + line.y2) / 2;
                return RotateAroundXY(line, x, y, angle);
            };
            module1.exports = Rotate;
        /***/ },
        /* 1233 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(233);
            /**
 * Rotate a line around a point by the given angle in radians.
 *
 * @function Phaser.Geom.Line.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to rotate.
 * @param {(Phaser.Geom.Point|object)} point - The point to rotate the line around.
 * @param {number} angle - The angle of rotation in radians.
 *
 * @return {Phaser.Geom.Line} The rotated line.
 */ var RotateAroundPoint = function(line, point, angle) {
                return RotateAroundXY(line, point.x, point.y, angle);
            };
            module1.exports = RotateAroundPoint;
        /***/ },
        /* 1234 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Set a line to a given position, angle and length.
 *
 * @function Phaser.Geom.Line.SetToAngle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Line} O - [line,$return]
 *
 * @param {Phaser.Geom.Line} line - The line to set.
 * @param {number} x - The horizontal start position of the line.
 * @param {number} y - The vertical start position of the line.
 * @param {number} angle - The angle of the line in radians.
 * @param {number} length - The length of the line.
 *
 * @return {Phaser.Geom.Line} The updated line.
 */ var SetToAngle = function(line, x, y, angle, length) {
                line.x1 = x;
                line.y1 = y;
                line.x2 = x + Math.cos(angle) * length;
                line.y2 = y + Math.sin(angle) * length;
                return line;
            };
            module1.exports = SetToAngle;
        /***/ },
        /* 1235 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the slope of the given line.
 *
 * @function Phaser.Geom.Line.Slope
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the slope of.
 *
 * @return {number} The slope of the line.
 */ var Slope = function(line) {
                return (line.y2 - line.y1) / (line.x2 - line.x1);
            };
            module1.exports = Slope;
        /***/ },
        /* 1236 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculate the width of the given line.
 *
 * @function Phaser.Geom.Line.Width
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Line} line - The line to calculate the width of.
 *
 * @return {number} The width of the line.
 */ var Width = function(line) {
                return Math.abs(line.x1 - line.x2);
            };
            module1.exports = Width;
        /***/ },
        /* 1237 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Geom.Mesh
 */ var Mesh = {
                Face: __webpack_require__(113),
                GenerateGridVerts: __webpack_require__(1238),
                GenerateObjVerts: __webpack_require__(474),
                GenerateVerts: __webpack_require__(473),
                ParseObj: __webpack_require__(492),
                ParseObjMaterial: __webpack_require__(493),
                RotateFace: __webpack_require__(1239),
                Vertex: __webpack_require__(115)
            };
            module1.exports = Mesh;
        /***/ },
        /* 1238 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Face = __webpack_require__(113);
            var GetFastValue = __webpack_require__(2);
            var Matrix4 = __webpack_require__(67);
            var Vector3 = __webpack_require__(38);
            var Vertex = __webpack_require__(115);
            var tempPosition = new Vector3();
            var tempRotation = new Vector3();
            var tempMatrix = new Matrix4();
            /**
 * Creates a grid of vertices based on the given configuration object and optionally adds it to a Mesh.
 *
 * The size of the grid is given in pixels. An example configuration may be:
 *
 * `{ width: 256, height: 256, widthSegments: 2, heightSegments: 2, tile: true }`
 *
 * This will create a grid 256 x 256 pixels in size, split into 2 x 2 segments, with
 * the texture tiling across the cells.
 *
 * You can split the grid into segments both vertically and horizontally. This will
 * generate two faces per grid segment as a result.
 *
 * The `tile` parameter allows you to control if the tile will repeat across the grid
 * segments, or be displayed in full.
 *
 * If adding this grid to a Mesh you can offset the grid via the `x` and `y` properties.
 *
 * UV coordinates are generated based on the given texture and frame in the config. For
 * example, no frame is given, the UVs will be in the range 0 to 1. If a frame is given,
 * such as from a texture atlas, the UVs will be generated within the range of that frame.
 *
 * @function Phaser.Geom.Mesh.GenerateGridVerts
 * @since 3.50.0
 *
 * @param {Phaser.Types.Geom.Mesh.GenerateGridConfig} config - A Grid configuration object.
 *
 * @return {Phaser.Types.Geom.Mesh.GenerateGridVertsResult} A Grid Result object, containing the generated vertices and indicies.
 */ var GenerateGridVerts = function(config) {
                var mesh = GetFastValue(config, 'mesh');
                var texture = GetFastValue(config, 'texture', null);
                var frame = GetFastValue(config, 'frame');
                var width = GetFastValue(config, 'width', 1);
                var height = GetFastValue(config, 'height', width);
                var widthSegments = GetFastValue(config, 'widthSegments', 1);
                var heightSegments = GetFastValue(config, 'heightSegments', widthSegments);
                var posX = GetFastValue(config, 'x', 0);
                var posY = GetFastValue(config, 'y', 0);
                var posZ = GetFastValue(config, 'z', 0);
                var rotateX = GetFastValue(config, 'rotateX', 0);
                var rotateY = GetFastValue(config, 'rotateY', 0);
                var rotateZ = GetFastValue(config, 'rotateZ', 0);
                var zIsUp = GetFastValue(config, 'zIsUp', true);
                var isOrtho = GetFastValue(config, 'isOrtho', mesh ? mesh.dirtyCache[11] : false);
                var colors = GetFastValue(config, 'colors', [
                    0xffffff
                ]);
                var alphas = GetFastValue(config, 'alphas', [
                    1
                ]);
                var tile = GetFastValue(config, 'tile', false);
                var flipY = GetFastValue(config, 'flipY', false);
                var widthSet = GetFastValue(config, 'width', null);
                var result = {
                    faces: [],
                    verts: []
                };
                tempPosition.set(posX, posY, posZ);
                tempRotation.set(rotateX, rotateY, rotateZ);
                tempMatrix.fromRotationXYTranslation(tempRotation, tempPosition, zIsUp);
                if (!texture && mesh) texture = mesh.texture;
                else if (mesh && typeof texture === 'string') texture = mesh.scene.sys.textures.get(texture);
                else //  There's nothing more we can do without a texture
                return result;
                var textureFrame = texture.get(frame);
                //  If the Mesh is ortho and no width / height is given, we'll default to texture sizes (if set!)
                if (!widthSet && isOrtho && texture && mesh) {
                    width = textureFrame.width / mesh.height;
                    height = textureFrame.height / mesh.height;
                }
                var halfWidth = width / 2;
                var halfHeight = height / 2;
                var gridX = Math.floor(widthSegments);
                var gridY = Math.floor(heightSegments);
                var gridX1 = gridX + 1;
                var gridY1 = gridY + 1;
                var segmentWidth = width / gridX;
                var segmentHeight = height / gridY;
                var uvs = [];
                var vertices = [];
                var ix;
                var iy;
                var frameU0 = 0;
                var frameU1 = 1;
                var frameV0 = 0;
                var frameV1 = 1;
                if (textureFrame) {
                    frameU0 = textureFrame.u0;
                    frameU1 = textureFrame.u1;
                    if (!flipY) {
                        frameV0 = textureFrame.v0;
                        frameV1 = textureFrame.v1;
                    } else {
                        frameV0 = textureFrame.v1;
                        frameV1 = textureFrame.v0;
                    }
                }
                var frameU = frameU1 - frameU0;
                var frameV = frameV1 - frameV0;
                for(iy = 0; iy < gridY1; iy++){
                    var y = iy * segmentHeight - halfHeight;
                    for(ix = 0; ix < gridX1; ix++){
                        var x = ix * segmentWidth - halfWidth;
                        vertices.push(x, -y);
                        var tu = frameU0 + frameU * (ix / gridX);
                        var tv = frameV0 + frameV * (iy / gridY);
                        uvs.push(tu, tv);
                    }
                }
                if (!Array.isArray(colors)) colors = [
                    colors
                ];
                if (!Array.isArray(alphas)) alphas = [
                    alphas
                ];
                var alphaIndex = 0;
                var colorIndex = 0;
                for(iy = 0; iy < gridY; iy++)for(ix = 0; ix < gridX; ix++){
                    var a = (ix + gridX1 * iy) * 2;
                    var b = (ix + gridX1 * (iy + 1)) * 2;
                    var c = (ix + 1 + gridX1 * (iy + 1)) * 2;
                    var d = (ix + 1 + gridX1 * iy) * 2;
                    var color = colors[colorIndex];
                    var alpha = alphas[alphaIndex];
                    var vert1 = new Vertex(vertices[a], vertices[a + 1], 0, uvs[a], uvs[a + 1], color, alpha).transformMat4(tempMatrix);
                    var vert2 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                    var vert3 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                    var vert4 = new Vertex(vertices[b], vertices[b + 1], 0, uvs[b], uvs[b + 1], color, alpha).transformMat4(tempMatrix);
                    var vert5 = new Vertex(vertices[c], vertices[c + 1], 0, uvs[c], uvs[c + 1], color, alpha).transformMat4(tempMatrix);
                    var vert6 = new Vertex(vertices[d], vertices[d + 1], 0, uvs[d], uvs[d + 1], color, alpha).transformMat4(tempMatrix);
                    if (tile) {
                        vert1.setUVs(frameU0, frameV1);
                        vert2.setUVs(frameU0, frameV0);
                        vert3.setUVs(frameU1, frameV1);
                        vert4.setUVs(frameU0, frameV0);
                        vert5.setUVs(frameU1, frameV0);
                        vert6.setUVs(frameU1, frameV1);
                    }
                    colorIndex++;
                    if (colorIndex === colors.length) colorIndex = 0;
                    alphaIndex++;
                    if (alphaIndex === alphas.length) alphaIndex = 0;
                    result.verts.push(vert1, vert2, vert3, vert4, vert5, vert6);
                    result.faces.push(new Face(vert1, vert2, vert3), new Face(vert4, vert5, vert6));
                }
                if (mesh) {
                    mesh.faces = mesh.faces.concat(result.faces);
                    mesh.vertices = mesh.vertices.concat(result.verts);
                }
                return result;
            };
            module1.exports = GenerateGridVerts;
        /***/ },
        /* 1239 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rotates the vertices of a Face to the given angle.
 *
 * The actual vertex positions are adjusted, not their transformed positions.
 *
 * Therefore, this updates the vertex data directly.
 *
 * @function Phaser.Geom.Mesh.RotateFace
 * @since 3.50.0
 *
 * @param {Phaser.Geom.Mesh.Face} face - The Face to rotate.
 * @param {number} angle - The angle to rotate to, in radians.
 * @param {number} [cx] - An optional center of rotation. If not given, the Face in-center is used.
 * @param {number} [cy] - An optional center of rotation. If not given, the Face in-center is used.
 */ var RotateFace = function(face, angle, cx, cy) {
                var x;
                var y;
                //  No point of rotation? Use the inCenter instead, then.
                if (cx === undefined && cy === undefined) {
                    var inCenter = face.getInCenter();
                    x = inCenter.x;
                    y = inCenter.y;
                }
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var v1 = face.vertex1;
                var v2 = face.vertex2;
                var v3 = face.vertex3;
                var tx = v1.x - x;
                var ty = v1.y - y;
                v1.set(tx * c - ty * s + x, tx * s + ty * c + y);
                tx = v2.x - x;
                ty = v2.y - y;
                v2.set(tx * c - ty * s + x, tx * s + ty * c + y);
                tx = v3.x - x;
                ty = v3.y - y;
                v3.set(tx * c - ty * s + x, tx * s + ty * c + y);
            };
            module1.exports = RotateFace;
        /***/ },
        /* 1240 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            Point.Ceil = __webpack_require__(1241);
            Point.Clone = __webpack_require__(1242);
            Point.CopyFrom = __webpack_require__(1243);
            Point.Equals = __webpack_require__(1244);
            Point.Floor = __webpack_require__(1245);
            Point.GetCentroid = __webpack_require__(1246);
            Point.GetMagnitude = __webpack_require__(494);
            Point.GetMagnitudeSq = __webpack_require__(495);
            Point.GetRectangleFromPoints = __webpack_require__(1247);
            Point.Interpolate = __webpack_require__(1248);
            Point.Invert = __webpack_require__(1249);
            Point.Negative = __webpack_require__(1250);
            Point.Project = __webpack_require__(1251);
            Point.ProjectUnit = __webpack_require__(1252);
            Point.SetMagnitude = __webpack_require__(1253);
            module1.exports = Point;
        /***/ },
        /* 1241 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to ceil.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.ceil()` applied to its coordinates.
 */ var Ceil = function(point) {
                return point.setTo(Math.ceil(point.x), Math.ceil(point.y));
            };
            module1.exports = Ceil;
        /***/ },
        /* 1242 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Clone the given Point.
 *
 * @function Phaser.Geom.Point.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} source - The source Point to clone.
 *
 * @return {Phaser.Geom.Point} The cloned Point.
 */ var Clone = function(source) {
                return new Point(source.x, source.y);
            };
            module1.exports = Clone;
        /***/ },
        /* 1243 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Point to a destination Point.
 *
 * @function Phaser.Geom.Point.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [dest,$return]
 *
 * @param {Phaser.Geom.Point} source - The source Point to copy the values from.
 * @param {Phaser.Geom.Point} dest - The destination Point to copy the values to.
 *
 * @return {Phaser.Geom.Point} The destination Point.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1244 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A comparison of two `Point` objects to see if they are equal.
 *
 * @function Phaser.Geom.Point.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Point} point - The original `Point` to compare against.
 * @param {Phaser.Geom.Point} toCompare - The second `Point` to compare.
 *
 * @return {boolean} Returns true if the both `Point` objects are equal.
 */ var Equals = function(point, toCompare) {
                return point.x === toCompare.x && point.y === toCompare.y;
            };
            module1.exports = Equals;
        /***/ },
        /* 1245 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Apply `Math.ceil()` to each coordinate of the given Point.
 *
 * @function Phaser.Geom.Point.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to floor.
 *
 * @return {Phaser.Geom.Point} The Point with `Math.floor()` applied to its coordinates.
 */ var Floor = function(point) {
                return point.setTo(Math.floor(point.x), Math.floor(point.y));
            };
            module1.exports = Floor;
        /***/ },
        /* 1246 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Get the centroid or geometric center of a plane figure (the arithmetic mean position of all the points in the figure).
 * Informally, it is the point at which a cutout of the shape could be perfectly balanced on the tip of a pin.
 *
 * @function Phaser.Geom.Point.GetCentroid
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the geometric center of.
 * @param {Phaser.Geom.Point} [out] - A Point object to store the output coordinates in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object representing the geometric center of the given points.
 */ var GetCentroid = function(points, out) {
                if (out === undefined) out = new Point();
                if (!Array.isArray(points)) throw new Error('GetCentroid points argument must be an array');
                var len = points.length;
                if (len < 1) throw new Error('GetCentroid points array must not be empty');
                else if (len === 1) {
                    out.x = points[0].x;
                    out.y = points[0].y;
                } else {
                    for(var i = 0; i < len; i++){
                        out.x += points[i].x;
                        out.y += points[i].y;
                    }
                    out.x /= len;
                    out.y /= len;
                }
                return out;
            };
            module1.exports = GetCentroid;
        /***/ },
        /* 1247 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Calculates the Axis Aligned Bounding Box (or aabb) from an array of points.
 *
 * @function Phaser.Geom.Point.GetRectangleFromPoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {Phaser.Types.Math.Vector2Like[]} points - An array of Vector2Like objects to get the AABB from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the results in. If not given, a new Rectangle instance is created.
 *
 * @return {Phaser.Geom.Rectangle} A Rectangle object holding the AABB values for the given points.
 */ var GetRectangleFromPoints = function(points, out) {
                if (out === undefined) out = new Rectangle();
                var xMax = Number.NEGATIVE_INFINITY;
                var xMin = Number.POSITIVE_INFINITY;
                var yMax = Number.NEGATIVE_INFINITY;
                var yMin = Number.POSITIVE_INFINITY;
                for(var i = 0; i < points.length; i++){
                    var point = points[i];
                    if (point.x > xMax) xMax = point.x;
                    if (point.x < xMin) xMin = point.x;
                    if (point.y > yMax) yMax = point.y;
                    if (point.y < yMin) yMin = point.y;
                }
                out.x = xMin;
                out.y = yMin;
                out.width = xMax - xMin;
                out.height = yMax - yMin;
                return out;
            };
            module1.exports = GetRectangleFromPoints;
        /***/ },
        /* 1248 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the linear interpolation point between the two given points, based on `t`.
 *
 * @function Phaser.Geom.Point.Interpolate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - The starting `Point` for the interpolation.
 * @param {Phaser.Geom.Point} pointB - The target `Point` for the interpolation.
 * @param {number} [t=0] - The amount to interpolate between the two points. Generally, a value between 0 (returns the starting `Point`) and 1 (returns the target `Point`). If omitted, 0 is used.
 * @param {(Phaser.Geom.Point|object)} [out] - An optional `Point` object whose `x` and `y` values will be set to the result of the interpolation (can also be any object with `x` and `y` properties). If omitted, a new `Point` created and returned.
 *
 * @return {(Phaser.Geom.Point|object)} Either the object from the `out` argument with the properties `x` and `y` set to the result of the interpolation or a newly created `Point` object.
 */ var Interpolate = function(pointA, pointB, t, out) {
                if (t === undefined) t = 0;
                if (out === undefined) out = new Point();
                out.x = pointA.x + (pointB.x - pointA.x) * t;
                out.y = pointA.y + (pointB.y - pointA.y) * t;
                return out;
            };
            module1.exports = Interpolate;
        /***/ },
        /* 1249 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Swaps the X and the Y coordinate of a point.
 *
 * @function Phaser.Geom.Point.Invert
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to modify.
 *
 * @return {Phaser.Geom.Point} The modified `point`.
 */ var Invert = function(point) {
                return point.setTo(point.y, point.x);
            };
            module1.exports = Invert;
        /***/ },
        /* 1250 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Inverts a Point's coordinates.
 *
 * @function Phaser.Geom.Point.Negative
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to invert.
 * @param {Phaser.Geom.Point} [out] - The Point to return the inverted coordinates in.
 *
 * @return {Phaser.Geom.Point} The modified `out` Point, or a new Point if none was provided.
 */ var Negative = function(point, out) {
                if (out === undefined) out = new Point();
                return out.setTo(-point.x, -point.y);
            };
            module1.exports = Negative;
        /***/ },
        /* 1251 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var GetMagnitudeSq = __webpack_require__(495);
            /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line paralle to `pointB`.
 *
 * @function Phaser.Geom.Point.Project
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var Project = function(pointA, pointB, out) {
                if (out === undefined) out = new Point();
                var dot = pointA.x * pointB.x + pointA.y * pointB.y;
                var amt = dot / GetMagnitudeSq(pointB);
                if (amt !== 0) {
                    out.x = amt * pointB.x;
                    out.y = amt * pointB.y;
                }
                return out;
            };
            module1.exports = Project;
        /***/ },
        /* 1252 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Calculates the vector projection of `pointA` onto the nonzero `pointB`. This is the
 * orthogonal projection of `pointA` onto a straight line paralle to `pointB`.
 *
 * @function Phaser.Geom.Point.ProjectUnit
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Point} pointA - Point A, to be projected onto Point B. Must be a normalized point with a magnitude of 1.
 * @param {Phaser.Geom.Point} pointB - Point B, to have Point A projected upon it.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A unit Point object holding the coordinates of the vector projection of `pointA` onto `pointB`.
 */ var ProjectUnit = function(pointA, pointB, out) {
                if (out === undefined) out = new Point();
                var amt = pointA.x * pointB.x + pointA.y * pointB.y;
                if (amt !== 0) {
                    out.x = amt * pointB.x;
                    out.y = amt * pointB.y;
                }
                return out;
            };
            module1.exports = ProjectUnit;
        /***/ },
        /* 1253 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetMagnitude = __webpack_require__(494);
            /**
 * Changes the magnitude (length) of a two-dimensional vector without changing its direction.
 *
 * @function Phaser.Geom.Point.SetMagnitude
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [point,$return]
 *
 * @param {Phaser.Geom.Point} point - The Point to treat as the end point of the vector.
 * @param {number} magnitude - The new magnitude of the vector.
 *
 * @return {Phaser.Geom.Point} The modified Point.
 */ var SetMagnitude = function(point, magnitude) {
                if (point.x !== 0 || point.y !== 0) {
                    var m = GetMagnitude(point);
                    point.x /= m;
                    point.y /= m;
                }
                point.x *= magnitude;
                point.y *= magnitude;
                return point;
            };
            module1.exports = SetMagnitude;
        /***/ },
        /* 1254 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(224);
            Polygon.Clone = __webpack_require__(1255);
            Polygon.Contains = __webpack_require__(225);
            Polygon.ContainsPoint = __webpack_require__(1256);
            Polygon.Earcut = __webpack_require__(68);
            Polygon.GetAABB = __webpack_require__(463);
            Polygon.GetNumberArray = __webpack_require__(1257);
            Polygon.GetPoints = __webpack_require__(464);
            Polygon.Perimeter = __webpack_require__(465);
            Polygon.Reverse = __webpack_require__(1258);
            Polygon.Simplify = __webpack_require__(1259);
            Polygon.Smooth = __webpack_require__(466);
            Polygon.Translate = __webpack_require__(1260);
            module1.exports = Polygon;
        /***/ },
        /* 1255 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Polygon = __webpack_require__(224);
            /**
 * Create a new polygon which is a copy of the specified polygon
 *
 * @function Phaser.Geom.Polygon.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to create a clone of
 *
 * @return {Phaser.Geom.Polygon} A new separate Polygon cloned from the specified polygon, based on the same points.
 */ var Clone = function(polygon) {
                return new Polygon(polygon.points);
            };
            module1.exports = Clone;
        /***/ },
        /* 1256 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(225);
            /**
 * Checks the given Point again the Polygon to see if the Point lays within its vertices.
 *
 * @function Phaser.Geom.Polygon.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to check.
 * @param {Phaser.Geom.Point} point - The Point to check if it's within the Polygon.
 *
 * @return {boolean} `true` if the Point is within the Polygon, otherwise `false`.
 */ var ContainsPoint = function(polygon, point) {
                return Contains(polygon, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1257 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Export the points as an array of flat numbers, following the sequence [ x,y, x,y, x,y ]
            /**
 * Stores all of the points of a Polygon into a flat array of numbers following the sequence [ x,y, x,y, x,y ],
 * i.e. each point of the Polygon, in the order it's defined, corresponds to two elements of the resultant
 * array for the point's X and Y coordinate.
 *
 * @function Phaser.Geom.Polygon.GetNumberArray
 * @since 3.0.0
 *
 * @generic {number[]} O - [output,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon whose points to export.
 * @param {(array|number[])} [output] - An array to which the points' coordinates should be appended.
 *
 * @return {(array|number[])} The modified `output` array, or a new array if none was given.
 */ var GetNumberArray = function(polygon, output) {
                if (output === undefined) output = [];
                for(var i = 0; i < polygon.points.length; i++){
                    output.push(polygon.points[i].x);
                    output.push(polygon.points[i].y);
                }
                return output;
            };
            module1.exports = GetNumberArray;
        /***/ },
        /* 1258 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Reverses the order of the points of a Polygon.
 *
 * @function Phaser.Geom.Polygon.Reverse
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Reverse = function(polygon) {
                polygon.points.reverse();
                return polygon;
            };
            module1.exports = Reverse;
        /***/ },
        /* 1259 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Vladimir Agafonkin
 * @see          Based on Simplify.js mourner.github.io/simplify-js
 */ /**
 * Copyright (c) 2017, Vladimir Agafonkin
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
 * TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * @ignore
 */ function getSqDist(p1, p2) {
                var dx = p1.x - p2.x, dy = p1.y - p2.y;
                return dx * dx + dy * dy;
            }
            /**
 * Square distance from a point to a segment
 *
 * @ignore
 */ function getSqSegDist(p, p1, p2) {
                var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
                if (dx !== 0 || dy !== 0) {
                    var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
                    if (t > 1) {
                        x = p2.x;
                        y = p2.y;
                    } else if (t > 0) {
                        x += dx * t;
                        y += dy * t;
                    }
                }
                dx = p.x - x;
                dy = p.y - y;
                return dx * dx + dy * dy;
            }
            /**
 * Basic distance-based simplification
 *
 * @ignore
 */ function simplifyRadialDist(points, sqTolerance) {
                var prevPoint = points[0], newPoints = [
                    prevPoint
                ], point;
                for(var i = 1, len = points.length; i < len; i++){
                    point = points[i];
                    if (getSqDist(point, prevPoint) > sqTolerance) {
                        newPoints.push(point);
                        prevPoint = point;
                    }
                }
                if (prevPoint !== point) newPoints.push(point);
                return newPoints;
            }
            /**
 * @ignore
 */ function simplifyDPStep(points, first, last, sqTolerance, simplified) {
                var maxSqDist = sqTolerance, index;
                for(var i = first + 1; i < last; i++){
                    var sqDist = getSqSegDist(points[i], points[first], points[last]);
                    if (sqDist > maxSqDist) {
                        index = i;
                        maxSqDist = sqDist;
                    }
                }
                if (maxSqDist > sqTolerance) {
                    if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
                    simplified.push(points[index]);
                    if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
                }
            }
            /**
 * Simplification using Ramer-Douglas-Peucker algorithm
 *
 * @ignore
 */ function simplifyDouglasPeucker(points, sqTolerance) {
                var last = points.length - 1;
                var simplified = [
                    points[0]
                ];
                simplifyDPStep(points, 0, last, sqTolerance, simplified);
                simplified.push(points[last]);
                return simplified;
            }
            /**
 * Takes a Polygon object and simplifies the points by running them through a combination of
 * Douglas-Peucker and Radial Distance algorithms. Simplification dramatically reduces the number of
 * points in a polygon while retaining its shape, giving a huge performance boost when processing
 * it and also reducing visual noise.
 *
 * @function Phaser.Geom.Polygon.Simplify
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The polygon to be simplified. The polygon will be modified in-place and returned.
 * @param {number} [tolerance=1] - Affects the amount of simplification (in the same metric as the point coordinates).
 * @param {boolean} [highestQuality=false] - Excludes distance-based preprocessing step which leads to highest quality simplification but runs ~10-20 times slower.
 *
 * @return {Phaser.Geom.Polygon} The input polygon.
 */ var Simplify = function(polygon, tolerance, highestQuality) {
                if (tolerance === undefined) tolerance = 1;
                if (highestQuality === undefined) highestQuality = false;
                var points = polygon.points;
                if (points.length > 2) {
                    var sqTolerance = tolerance * tolerance;
                    if (!highestQuality) points = simplifyRadialDist(points, sqTolerance);
                    polygon.setTo(simplifyDouglasPeucker(points, sqTolerance));
                }
                return polygon;
            };
            module1.exports = Simplify;
        /***/ },
        /* 1260 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tranlates the points of the given Polygon.
 *
 * @function Phaser.Geom.Polygon.Translate
 * @since 3.50.0
 *
 * @generic {Phaser.Geom.Polygon} O - [polygon,$return]
 *
 * @param {Phaser.Geom.Polygon} polygon - The Polygon to modify.
 * @param {number} x - The amount to horizontally translate the points by.
 * @param {number} y - The amount to vertically translate the points by.
 *
 * @return {Phaser.Geom.Polygon} The modified Polygon.
 */ var Translate = function(polygon, x, y) {
                var points = polygon.points;
                for(var i = 0; i < points.length; i++){
                    points[i].x += x;
                    points[i].y += y;
                }
                return polygon;
            };
            module1.exports = Translate;
        /***/ },
        /* 1261 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Calculates the area of the given Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to calculate the area of.
 *
 * @return {number} The area of the Rectangle object.
 */ var Area = function(rect) {
                return rect.width * rect.height;
            };
            module1.exports = Area;
        /***/ },
        /* 1262 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position up to the smallest integer greater than or equal to each current coordinate.
 *
 * @function Phaser.Geom.Rectangle.Ceil
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Ceil = function(rect) {
                rect.x = Math.ceil(rect.x);
                rect.y = Math.ceil(rect.y);
                return rect;
            };
            module1.exports = Ceil;
        /***/ },
        /* 1263 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size up to the smallest integer greater than or equal to each respective value.
 *
 * @function Phaser.Geom.Rectangle.CeilAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to modify.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var CeilAll = function(rect) {
                rect.x = Math.ceil(rect.x);
                rect.y = Math.ceil(rect.y);
                rect.width = Math.ceil(rect.width);
                rect.height = Math.ceil(rect.height);
                return rect;
            };
            module1.exports = CeilAll;
        /***/ },
        /* 1264 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Creates a new Rectangle which is identical to the given one.
 *
 * @function Phaser.Geom.Rectangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} source - The Rectangle to clone.
 *
 * @return {Phaser.Geom.Rectangle} The newly created Rectangle, which is separate from the given one.
 */ var Clone = function(source) {
                return new Rectangle(source.x, source.y, source.width, source.height);
            };
            module1.exports = Clone;
        /***/ },
        /* 1265 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(56);
            /**
 * Determines whether the specified point is contained within the rectangular region defined by this Rectangle object.
 *
 * @function Phaser.Geom.Rectangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle object.
 * @param {Phaser.Geom.Point} point - The point object to be checked. Can be a Phaser Point object or any object with x and y values.
 *
 * @return {boolean} A value of true if the Rectangle object contains the specified point, otherwise false.
 */ var ContainsPoint = function(rect, point) {
                return Contains(rect, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1266 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Rectangle to a destination Rectangle.
 *
 * @function Phaser.Geom.Rectangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Rectangle} source - The source Rectangle to copy the values from.
 * @param {Phaser.Geom.Rectangle} dest - The destination Rectangle to copy the values to.
 *
 * @return {Phaser.Geom.Rectangle} The destination Rectangle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x, source.y, source.width, source.height);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1267 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Compares the `x`, `y`, `width` and `height` properties of two rectangles.
 *
 * @function Phaser.Geom.Rectangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rect - Rectangle A
 * @param {Phaser.Geom.Rectangle} toCompare - Rectangle B
 *
 * @return {boolean} `true` if the rectangles' properties are an exact match, otherwise `false`.
 */ var Equals = function(rect, toCompare) {
                return rect.x === toCompare.x && rect.y === toCompare.y && rect.width === toCompare.width && rect.height === toCompare.height;
            };
            module1.exports = Equals;
        /***/ },
        /* 1268 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(234);
            /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fits inside the area of the source rectangle, while maintaining its original
 * aspect ratio.
 * 
 * Unlike the `FitOutside` function, there may be some space inside the source area not covered.
 *
 * @function Phaser.Geom.Rectangle.FitInside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelop the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitInside = function(target, source) {
                var ratio = GetAspectRatio(target);
                if (ratio < GetAspectRatio(source)) //  Taller than Wide
                target.setSize(source.height * ratio, source.height);
                else //  Wider than Tall
                target.setSize(source.width, source.width / ratio);
                return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
            };
            module1.exports = FitInside;
        /***/ },
        /* 1269 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetAspectRatio = __webpack_require__(234);
            /**
 * Adjusts the target rectangle, changing its width, height and position,
 * so that it fully covers the area of the source rectangle, while maintaining its original
 * aspect ratio.
 * 
 * Unlike the `FitInside` function, the target rectangle may extend further out than the source.
 *
 * @function Phaser.Geom.Rectangle.FitOutside
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The target rectangle to adjust.
 * @param {Phaser.Geom.Rectangle} source - The source rectangle to envelope the target in.
 *
 * @return {Phaser.Geom.Rectangle} The modified target rectangle instance.
 */ var FitOutside = function(target, source) {
                var ratio = GetAspectRatio(target);
                if (ratio > GetAspectRatio(source)) //  Wider than Tall
                target.setSize(source.height * ratio, source.height);
                else //  Taller than Wide
                target.setSize(source.width, source.width / ratio);
                return target.setPosition(source.centerX - target.width / 2, source.centerY - target.height / 2);
            };
            module1.exports = FitOutside;
        /***/ },
        /* 1270 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds down (floors) the top left X and Y coordinates of the given Rectangle to the largest integer less than or equal to them
 *
 * @function Phaser.Geom.Rectangle.Floor
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The rectangle to floor the top left X and Y coordinates of
 *
 * @return {Phaser.Geom.Rectangle} The rectangle that was passed to this function with its coordinates floored.
 */ var Floor = function(rect) {
                rect.x = Math.floor(rect.x);
                rect.y = Math.floor(rect.y);
                return rect;
            };
            module1.exports = Floor;
        /***/ },
        /* 1271 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Rounds a Rectangle's position and size down to the largest integer less than or equal to each current coordinate or dimension.
 *
 * @function Phaser.Geom.Rectangle.FloorAll
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var FloorAll = function(rect) {
                rect.x = Math.floor(rect.x);
                rect.y = Math.floor(rect.y);
                rect.width = Math.floor(rect.width);
                rect.height = Math.floor(rect.height);
                return rect;
            };
            module1.exports = FloorAll;
        /***/ },
        /* 1272 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            /**
 * Create the smallest Rectangle containing two coordinate pairs.
 *
 * @function Phaser.Geom.Rectangle.FromXY
 * @since 3.23.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
 *
 * @param {number} x1 - The X coordinate of the first point.
 * @param {number} y1 - The Y coordinate of the first point.
 * @param {number} x2 - The X coordinate of the second point.
 * @param {number} y2 - The Y coordinate of the second point.
 * @param {Phaser.Geom.Rectangle} [out] - Optional Rectangle to adjust.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted `out` Rectangle, or a new Rectangle if none was provided.
 */ var FromXY = function(x1, y1, x2, y2, out) {
                if (out === undefined) out = new Rectangle();
                return out.setTo(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x1 - x2), Math.abs(y1 - y2));
            };
            module1.exports = FromXY;
        /***/ },
        /* 1273 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the center of a Rectangle as a Point.
 *
 * @function Phaser.Geom.Rectangle.GetCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the center of.
 * @param {(Phaser.Geom.Point|object)} [out] - Optional point-like object to update with the center coordinates.
 *
 * @return {(Phaser.Geom.Point|object)} The modified `out` object, or a new Point if none was provided.
 */ var GetCenter = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.centerX;
                out.y = rect.centerY;
                return out;
            };
            module1.exports = GetCenter;
        /***/ },
        /* 1274 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            /**
 * Returns the size of the Rectangle, expressed as a Point object.
 * With the value of the `width` as the `x` property and the `height` as the `y` property.
 *
 * @function Phaser.Geom.Rectangle.GetSize
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to get the size from.
 * @param {(Phaser.Geom.Point|object)} [out] - The Point object to store the size in. If not given, a new Point instance is created.
 *
 * @return {(Phaser.Geom.Point|object)} A Point object where `x` holds the width and `y` holds the height of the Rectangle.
 */ var GetSize = function(rect, out) {
                if (out === undefined) out = new Point();
                out.x = rect.width;
                out.y = rect.height;
                return out;
            };
            module1.exports = GetSize;
        /***/ },
        /* 1275 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CenterOn = __webpack_require__(187);
            /**
 * Increases the size of a Rectangle by a specified amount.
 *
 * The center of the Rectangle stays the same. The amounts are added to each side, so the actual increase in width or height is two times bigger than the respective argument.
 *
 * @function Phaser.Geom.Rectangle.Inflate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to inflate.
 * @param {number} x - How many pixels the left and the right side should be moved by horizontally.
 * @param {number} y - How many pixels the top and the bottom side should be moved by vertically.
 *
 * @return {Phaser.Geom.Rectangle} The inflated Rectangle.
 */ var Inflate = function(rect, x, y) {
                var cx = rect.centerX;
                var cy = rect.centerY;
                rect.setSize(rect.width + x * 2, rect.height + y * 2);
                return CenterOn(rect, cx, cy);
            };
            module1.exports = Inflate;
        /***/ },
        /* 1276 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Rectangle = __webpack_require__(10);
            var Intersects = __webpack_require__(114);
            /**
 * Takes two Rectangles and first checks to see if they intersect.
 * If they intersect it will return the area of intersection in the `out` Rectangle.
 * If they do not intersect, the `out` Rectangle will have a width and height of zero.
 *
 * @function Phaser.Geom.Rectangle.Intersection
 * @since 3.11.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to get the intersection from.
 * @param {Phaser.Geom.Rectangle} [out] - A Rectangle to store the intersection results in.
 *
 * @return {Phaser.Geom.Rectangle} The intersection result. If the width and height are zero, no intersection occurred.
 */ var Intersection = function(rectA, rectB, out) {
                if (out === undefined) out = new Rectangle();
                if (Intersects(rectA, rectB)) {
                    out.x = Math.max(rectA.x, rectB.x);
                    out.y = Math.max(rectA.y, rectB.y);
                    out.width = Math.min(rectA.right, rectB.right) - out.x;
                    out.height = Math.min(rectA.bottom, rectB.bottom) - out.y;
                } else out.setEmpty();
                return out;
            };
            module1.exports = Intersection;
        /***/ },
        /* 1277 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a list of points by repositioning and/or resizing it such that all points are located on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergePoints
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged.
 * @param {Phaser.Geom.Point[]} points - An array of Points (or any object with public `x` and `y` properties) which should be merged with the Rectangle.
 *
 * @return {Phaser.Geom.Rectangle} The modified Rectangle.
 */ var MergePoints = function(target, points) {
                var minX = target.x;
                var maxX = target.right;
                var minY = target.y;
                var maxY = target.bottom;
                for(var i = 0; i < points.length; i++){
                    minX = Math.min(minX, points[i].x);
                    maxX = Math.max(maxX, points[i].x);
                    minY = Math.min(minY, points[i].y);
                    maxY = Math.max(maxY, points[i].y);
                }
                target.x = minX;
                target.y = minY;
                target.width = maxX - minX;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergePoints;
        /***/ },
        /* 1278 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  Merges source rectangle into target rectangle and returns target
            //  Neither rect should have negative widths or heights
            /**
 * Merges the source rectangle into the target rectangle and returns the target.
 * Neither rectangle should have a negative width or height.
 *
 * @function Phaser.Geom.Rectangle.MergeRect
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - Target rectangle. Will be modified to include source rectangle.
 * @param {Phaser.Geom.Rectangle} source - Rectangle that will be merged into target rectangle.
 *
 * @return {Phaser.Geom.Rectangle} Modified target rectangle that contains source rectangle.
 */ var MergeRect = function(target, source) {
                var minX = Math.min(target.x, source.x);
                var maxX = Math.max(target.right, source.right);
                target.x = minX;
                target.width = maxX - minX;
                var minY = Math.min(target.y, source.y);
                var maxY = Math.max(target.bottom, source.bottom);
                target.y = minY;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergeRect;
        /***/ },
        /* 1279 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Merges a Rectangle with a point by repositioning and/or resizing it so that the point is on or within its bounds.
 *
 * @function Phaser.Geom.Rectangle.MergeXY
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
 *
 * @param {Phaser.Geom.Rectangle} target - The Rectangle which should be merged and modified.
 * @param {number} x - The X coordinate of the point which should be merged.
 * @param {number} y - The Y coordinate of the point which should be merged.
 *
 * @return {Phaser.Geom.Rectangle} The modified `target` Rectangle.
 */ var MergeXY = function(target, x, y) {
                var minX = Math.min(target.x, x);
                var maxX = Math.max(target.right, x);
                target.x = minX;
                target.width = maxX - minX;
                var minY = Math.min(target.y, y);
                var maxY = Math.max(target.bottom, y);
                target.y = minY;
                target.height = maxY - minY;
                return target;
            };
            module1.exports = MergeXY;
        /***/ },
        /* 1280 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top left corner of a Rectangle by a given offset.
 *
 * @function Phaser.Geom.Rectangle.Offset
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {number} x - The distance to move the Rectangle horizontally.
 * @param {number} y - The distance to move the Rectangle vertically.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var Offset = function(rect, x, y) {
                rect.x += x;
                rect.y += y;
                return rect;
            };
            module1.exports = Offset;
        /***/ },
        /* 1281 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Nudges (translates) the top-left corner of a Rectangle by the coordinates of a point (translation vector).
 *
 * @function Phaser.Geom.Rectangle.OffsetPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The Rectangle to adjust.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2)} point - The point whose coordinates should be used as an offset.
 *
 * @return {Phaser.Geom.Rectangle} The adjusted Rectangle.
 */ var OffsetPoint = function(rect, point) {
                rect.x += point.x;
                rect.y += point.y;
                return rect;
            };
            module1.exports = OffsetPoint;
        /***/ },
        /* 1282 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Checks if two Rectangles overlap. If a Rectangle is within another Rectangle, the two will be considered overlapping. Thus, the Rectangles are treated as "solid".
 *
 * @function Phaser.Geom.Rectangle.Overlaps
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Rectangle} rectA - The first Rectangle to check.
 * @param {Phaser.Geom.Rectangle} rectB - The second Rectangle to check.
 *
 * @return {boolean} `true` if the two Rectangles overlap, `false` otherwise.
 */ var Overlaps = function(rectA, rectB) {
                return rectA.x < rectB.right && rectA.right > rectB.x && rectA.y < rectB.bottom && rectA.bottom > rectB.y;
            };
            module1.exports = Overlaps;
        /***/ },
        /* 1283 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Point = __webpack_require__(4);
            var DegToRad = __webpack_require__(35);
            /**
 * Returns a Point from the perimeter of a Rectangle based on the given angle.
 *
 * @function Phaser.Geom.Rectangle.PerimeterPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} rectangle - The Rectangle to get the perimeter point from.
 * @param {number} angle - The angle of the point, in degrees.
 * @param {Phaser.Geom.Point} [out] - The Point object to store the position in. If not given, a new Point instance is created.
 *
 * @return {Phaser.Geom.Point} A Point object holding the coordinates of the Rectangle perimeter.
 */ var PerimeterPoint = function(rectangle, angle, out) {
                if (out === undefined) out = new Point();
                angle = DegToRad(angle);
                var s = Math.sin(angle);
                var c = Math.cos(angle);
                var dx = c > 0 ? rectangle.width / 2 : rectangle.width / -2;
                var dy = s > 0 ? rectangle.height / 2 : rectangle.height / -2;
                if (Math.abs(dx * s) < Math.abs(dy * c)) dy = dx * s / c;
                else dx = dy * c / s;
                out.x = dx + rectangle.centerX;
                out.y = dy + rectangle.centerY;
                return out;
            };
            module1.exports = PerimeterPoint;
        /***/ },
        /* 1284 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Between = __webpack_require__(192);
            var ContainsRect = __webpack_require__(497);
            var Point = __webpack_require__(4);
            /**
 * Calculates a random point that lies within the `outer` Rectangle, but outside of the `inner` Rectangle.
 * The inner Rectangle must be fully contained within the outer rectangle.
 *
 * @function Phaser.Geom.Rectangle.RandomOutside
 * @since 3.10.0
 *
 * @generic {Phaser.Geom.Point} O - [out,$return]
 *
 * @param {Phaser.Geom.Rectangle} outer - The outer Rectangle to get the random point within.
 * @param {Phaser.Geom.Rectangle} inner - The inner Rectangle to exclude from the returned point.
 * @param {Phaser.Geom.Point} [out] - A Point, or Point-like object to store the result in. If not specified, a new Point will be created.
 *
 * @return {Phaser.Geom.Point} A Point object containing the random values in its `x` and `y` properties.
 */ var RandomOutside = function(outer, inner, out) {
                if (out === undefined) out = new Point();
                if (ContainsRect(outer, inner)) //  Pick a random quadrant
                //
                //  The quadrants don't extend the full widths / heights of the outer rect to give
                //  us a better uniformed distribution, otherwise you get clumping in the corners where
                //  the 4 quads would overlap
                switch(Between(0, 3)){
                    case 0:
                        out.x = outer.x + Math.random() * (inner.right - outer.x);
                        out.y = outer.y + Math.random() * (inner.top - outer.y);
                        break;
                    case 1:
                        out.x = inner.x + Math.random() * (outer.right - inner.x);
                        out.y = inner.bottom + Math.random() * (outer.bottom - inner.bottom);
                        break;
                    case 2:
                        out.x = outer.x + Math.random() * (inner.x - outer.x);
                        out.y = inner.y + Math.random() * (outer.bottom - inner.y);
                        break;
                    case 3:
                        out.x = inner.right + Math.random() * (outer.right - inner.right);
                        out.y = outer.y + Math.random() * (inner.bottom - outer.y);
                        break;
                }
                return out;
            };
            module1.exports = RandomOutside;
        /***/ },
        /* 1285 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Determines if the two objects (either Rectangles or Rectangle-like) have the same width and height values under strict equality.
 *
 * @function Phaser.Geom.Rectangle.SameDimensions
 * @since 3.15.0
 *
 * @param {Phaser.Geom.Rectangle} rect - The first Rectangle object.
 * @param {Phaser.Geom.Rectangle} toCompare - The second Rectangle object.
 *
 * @return {boolean} `true` if the objects have equivalent values for the `width` and `height` properties, otherwise `false`.
 */ var SameDimensions = function(rect, toCompare) {
                return rect.width === toCompare.width && rect.height === toCompare.height;
            };
            module1.exports = SameDimensions;
        /***/ },
        /* 1286 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // Scales the width and height of this Rectangle by the given amounts.
            /**
 * Scales the width and height of this Rectangle by the given amounts.
 *
 * @function Phaser.Geom.Rectangle.Scale
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
 *
 * @param {Phaser.Geom.Rectangle} rect - The `Rectangle` object that will be scaled by the specified amount(s).
 * @param {number} x - The factor by which to scale the rectangle horizontally.
 * @param {number} y - The amount by which to scale the rectangle vertically. If this is not specified, the rectangle will be scaled by the factor `x` in both directions.
 *
 * @return {Phaser.Geom.Rectangle} The rectangle object with updated `width` and `height` properties as calculated from the scaling factor(s).
 */ var Scale = function(rect, x, y) {
                if (y === undefined) y = x;
                rect.width *= x;
                rect.height *= y;
                return rect;
            };
            module1.exports = Scale;
        /***/ },
        /* 1287 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            Triangle.Area = __webpack_require__(1288);
            Triangle.BuildEquilateral = __webpack_require__(1289);
            Triangle.BuildFromPolygon = __webpack_require__(1290);
            Triangle.BuildRight = __webpack_require__(1291);
            Triangle.CenterOn = __webpack_require__(1292);
            Triangle.Centroid = __webpack_require__(498);
            Triangle.CircumCenter = __webpack_require__(1293);
            Triangle.CircumCircle = __webpack_require__(1294);
            Triangle.Clone = __webpack_require__(1295);
            Triangle.Contains = __webpack_require__(112);
            Triangle.ContainsArray = __webpack_require__(232);
            Triangle.ContainsPoint = __webpack_require__(1296);
            Triangle.CopyFrom = __webpack_require__(1297);
            Triangle.Decompose = __webpack_require__(489);
            Triangle.Equals = __webpack_require__(1298);
            Triangle.GetPoint = __webpack_require__(470);
            Triangle.GetPoints = __webpack_require__(471);
            Triangle.InCenter = __webpack_require__(500);
            Triangle.Perimeter = __webpack_require__(1299);
            Triangle.Offset = __webpack_require__(499);
            Triangle.Random = __webpack_require__(178);
            Triangle.Rotate = __webpack_require__(1300);
            Triangle.RotateAroundPoint = __webpack_require__(1301);
            Triangle.RotateAroundXY = __webpack_require__(235);
            module1.exports = Triangle;
        /***/ },
        /* 1288 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ // The 2D area of a triangle. The area value is always non-negative.
            /**
 * Returns the area of a Triangle.
 *
 * @function Phaser.Geom.Triangle.Area
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use.
 *
 * @return {number} The area of the Triangle, always non-negative.
 */ var Area = function(triangle) {
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                return Math.abs(((x3 - x1) * (y2 - y1) - (x2 - x1) * (y3 - y1)) / 2);
            };
            module1.exports = Area;
        /***/ },
        /* 1289 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            /**
 * Builds an equilateral triangle. In the equilateral triangle, all the sides are the same length (congruent) and all the angles are the same size (congruent).
 * The x/y specifies the top-middle of the triangle (x1/y1) and length is the length of each side.
 *
 * @function Phaser.Geom.Triangle.BuildEquilateral
 * @since 3.0.0
 *
 * @param {number} x - x coordinate of the top point of the triangle.
 * @param {number} y - y coordinate of the top point of the triangle.
 * @param {number} length - Length of each side of the triangle.
 *
 * @return {Phaser.Geom.Triangle} The Triangle object of the given size.
 */ var BuildEquilateral = function(x, y, length) {
                var height = length * (Math.sqrt(3) / 2);
                var x1 = x;
                var y1 = y;
                var x2 = x + length / 2;
                var y2 = y + height;
                var x3 = x - length / 2;
                var y3 = y + height;
                return new Triangle(x1, y1, x2, y2, x3, y3);
            };
            module1.exports = BuildEquilateral;
        /***/ },
        /* 1290 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var EarCut = __webpack_require__(68);
            var Triangle = __webpack_require__(82);
            /**
 * Takes an array of vertex coordinates, and optionally an array of hole indices, then returns an array
 * of Triangle instances, where the given vertices have been decomposed into a series of triangles.
 *
 * @function Phaser.Geom.Triangle.BuildFromPolygon
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle[]} O - [out,$return]
 *
 * @param {array} data - A flat array of vertex coordinates like [x0,y0, x1,y1, x2,y2, ...]
 * @param {array} [holes=null] - An array of hole indices if any (e.g. [5, 8] for a 12-vertex input would mean one hole with vertices 5–7 and another with 8–11).
 * @param {number} [scaleX=1] - Horizontal scale factor to multiply the resulting points by.
 * @param {number} [scaleY=1] - Vertical scale factor to multiply the resulting points by.
 * @param {(array|Phaser.Geom.Triangle[])} [out] - An array to store the resulting Triangle instances in. If not provided, a new array is created.
 *
 * @return {(array|Phaser.Geom.Triangle[])} An array of Triangle instances, where each triangle is based on the decomposed vertices data.
 */ var BuildFromPolygon = function(data, holes, scaleX, scaleY, out) {
                if (holes === undefined) holes = null;
                if (scaleX === undefined) scaleX = 1;
                if (scaleY === undefined) scaleY = 1;
                if (out === undefined) out = [];
                var tris = EarCut(data, holes);
                var a;
                var b;
                var c;
                var x1;
                var y1;
                var x2;
                var y2;
                var x3;
                var y3;
                for(var i = 0; i < tris.length; i += 3){
                    a = tris[i];
                    b = tris[i + 1];
                    c = tris[i + 2];
                    x1 = data[a * 2] * scaleX;
                    y1 = data[a * 2 + 1] * scaleY;
                    x2 = data[b * 2] * scaleX;
                    y2 = data[b * 2 + 1] * scaleY;
                    x3 = data[c * 2] * scaleX;
                    y3 = data[c * 2 + 1] * scaleY;
                    out.push(new Triangle(x1, y1, x2, y2, x3, y3));
                }
                return out;
            };
            module1.exports = BuildFromPolygon;
        /***/ },
        /* 1291 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            //  Builds a right triangle, with one 90 degree angle and two acute angles
            //  The x/y is the coordinate of the 90 degree angle (and will map to x1/y1 in the resulting Triangle)
            //  w/h can be positive or negative and represent the length of each side
            /**
 * Builds a right triangle, i.e. one which has a 90-degree angle and two acute angles.
 *
 * @function Phaser.Geom.Triangle.BuildRight
 * @since 3.0.0
 *
 * @param {number} x - The X coordinate of the right angle, which will also be the first X coordinate of the constructed Triangle.
 * @param {number} y - The Y coordinate of the right angle, which will also be the first Y coordinate of the constructed Triangle.
 * @param {number} width - The length of the side which is to the left or to the right of the right angle.
 * @param {number} height - The length of the side which is above or below the right angle.
 *
 * @return {Phaser.Geom.Triangle} The constructed right Triangle.
 */ var BuildRight = function(x, y, width, height) {
                if (height === undefined) height = width;
                //  90 degree angle
                var x1 = x;
                var y1 = y;
                var x2 = x;
                var y2 = y - height;
                var x3 = x + width;
                var y3 = y;
                return new Triangle(x1, y1, x2, y2, x3, y3);
            };
            module1.exports = BuildRight;
        /***/ },
        /* 1292 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Centroid = __webpack_require__(498);
            var Offset = __webpack_require__(499);
            /**
 * @callback CenterFunction
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to return the center coordinates of.
 *
 * @return {Phaser.Math.Vector2} The center point of the Triangle according to the function.
 */ /**
 * Positions the Triangle so that it is centered on the given coordinates.
 *
 * @function Phaser.Geom.Triangle.CenterOn
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle to be positioned.
 * @param {number} x - The horizontal coordinate to center on.
 * @param {number} y - The vertical coordinate to center on.
 * @param {CenterFunction} [centerFunc] - The function used to center the triangle. Defaults to Centroid centering.
 *
 * @return {Phaser.Geom.Triangle} The Triangle that was centered.
 */ var CenterOn = function(triangle, x, y, centerFunc) {
                if (centerFunc === undefined) centerFunc = Centroid;
                //  Get the center of the triangle
                var center = centerFunc(triangle);
                //  Difference
                var diffX = x - center.x;
                var diffY = y - center.y;
                return Offset(triangle, diffX, diffY);
            };
            module1.exports = CenterOn;
        /***/ },
        /* 1293 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Vector2 = __webpack_require__(3);
            //  Adapted from http://bjornharrtell.github.io/jsts/doc/api/jsts_geom_Triangle.js.html
            /**
 * Computes the determinant of a 2x2 matrix. Uses standard double-precision arithmetic, so is susceptible to round-off error.
 *
 * @function det
 * @private
 * @since 3.0.0
 *
 * @param {number} m00 - The [0,0] entry of the matrix.
 * @param {number} m01 - The [0,1] entry of the matrix.
 * @param {number} m10 - The [1,0] entry of the matrix.
 * @param {number} m11 - The [1,1] entry of the matrix.
 *
 * @return {number} the determinant.
 */ function det(m00, m01, m10, m11) {
                return m00 * m11 - m01 * m10;
            }
            /**
 * Computes the circumcentre of a triangle. The circumcentre is the centre of
 * the circumcircle, the smallest circle which encloses the triangle. It is also
 * the common intersection point of the perpendicular bisectors of the sides of
 * the triangle, and is the only point which has equal distance to all three
 * vertices of the triangle.
 *
 * @function Phaser.Geom.Triangle.CircumCenter
 * @since 3.0.0
 *
 * @generic {Phaser.Math.Vector2} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the circumcenter of.
 * @param {Phaser.Math.Vector2} [out] - The Vector2 object to store the position in. If not given, a new Vector2 instance is created.
 *
 * @return {Phaser.Math.Vector2} A Vector2 object holding the coordinates of the circumcenter of the Triangle.
 */ var CircumCenter = function(triangle, out) {
                if (out === undefined) out = new Vector2();
                var cx = triangle.x3;
                var cy = triangle.y3;
                var ax = triangle.x1 - cx;
                var ay = triangle.y1 - cy;
                var bx = triangle.x2 - cx;
                var by = triangle.y2 - cy;
                var denom = 2 * det(ax, ay, bx, by);
                var numx = det(ay, ax * ax + ay * ay, by, bx * bx + by * by);
                var numy = det(ax, ax * ax + ay * ay, bx, bx * bx + by * by);
                out.x = cx - numx / denom;
                out.y = cy + numy / denom;
                return out;
            };
            module1.exports = CircumCenter;
        /***/ },
        /* 1294 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(62);
            //  Adapted from https://gist.github.com/mutoo/5617691
            /**
 * Finds the circumscribed circle (circumcircle) of a Triangle object. The circumcircle is the circle which touches all of the triangle's vertices.
 *
 * @function Phaser.Geom.Triangle.CircumCircle
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Circle} O - [out,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to use as input.
 * @param {Phaser.Geom.Circle} [out] - An optional Circle to store the result in.
 *
 * @return {Phaser.Geom.Circle} The updated `out` Circle, or a new Circle if none was provided.
 */ var CircumCircle = function(triangle, out) {
                if (out === undefined) out = new Circle();
                //  A
                var x1 = triangle.x1;
                var y1 = triangle.y1;
                //  B
                var x2 = triangle.x2;
                var y2 = triangle.y2;
                //  C
                var x3 = triangle.x3;
                var y3 = triangle.y3;
                var A = x2 - x1;
                var B = y2 - y1;
                var C = x3 - x1;
                var D = y3 - y1;
                var E = A * (x1 + x2) + B * (y1 + y2);
                var F = C * (x1 + x3) + D * (y1 + y3);
                var G = 2 * (A * (y3 - y2) - B * (x3 - x2));
                var dx;
                var dy;
                //  If the points of the triangle are collinear, then just find the
                //  extremes and use the midpoint as the center of the circumcircle.
                if (Math.abs(G) < 0.000001) {
                    var minX = Math.min(x1, x2, x3);
                    var minY = Math.min(y1, y2, y3);
                    dx = (Math.max(x1, x2, x3) - minX) * 0.5;
                    dy = (Math.max(y1, y2, y3) - minY) * 0.5;
                    out.x = minX + dx;
                    out.y = minY + dy;
                    out.radius = Math.sqrt(dx * dx + dy * dy);
                } else {
                    out.x = (D * E - B * F) / G;
                    out.y = (A * F - C * E) / G;
                    dx = out.x - x1;
                    dy = out.y - y1;
                    out.radius = Math.sqrt(dx * dx + dy * dy);
                }
                return out;
            };
            module1.exports = CircumCircle;
        /***/ },
        /* 1295 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Triangle = __webpack_require__(82);
            /**
 * Clones a Triangle object.
 *
 * @function Phaser.Geom.Triangle.Clone
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} source - The Triangle to clone.
 *
 * @return {Phaser.Geom.Triangle} A new Triangle identical to the given one but separate from it.
 */ var Clone = function(source) {
                return new Triangle(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
            };
            module1.exports = Clone;
        /***/ },
        /* 1296 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Contains = __webpack_require__(112);
            /**
 * Tests if a triangle contains a point.
 *
 * @function Phaser.Geom.Triangle.ContainsPoint
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The triangle.
 * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|any)} point - The point to test, or any point-like object with public `x` and `y` properties.
 *
 * @return {boolean} `true` if the point is within the triangle, otherwise `false`.
 */ var ContainsPoint = function(triangle, point) {
                return Contains(triangle, point.x, point.y);
            };
            module1.exports = ContainsPoint;
        /***/ },
        /* 1297 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Copy the values of one Triangle to a destination Triangle.
 *
 * @function Phaser.Geom.Triangle.CopyFrom
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [dest,$return]
 *
 * @param {Phaser.Geom.Triangle} source - The source Triangle to copy the values from.
 * @param {Phaser.Geom.Triangle} dest - The destination Triangle to copy the values to.
 *
 * @return {Phaser.Geom.Triangle} The destination Triangle.
 */ var CopyFrom = function(source, dest) {
                return dest.setTo(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
            };
            module1.exports = CopyFrom;
        /***/ },
        /* 1298 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns true if two triangles have the same coordinates.
 *
 * @function Phaser.Geom.Triangle.Equals
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The first triangle to check.
 * @param {Phaser.Geom.Triangle} toCompare - The second triangle to check.
 *
 * @return {boolean} `true` if the two given triangles have the exact same coordinates, otherwise `false`.
 */ var Equals = function(triangle, toCompare) {
                return triangle.x1 === toCompare.x1 && triangle.y1 === toCompare.y1 && triangle.x2 === toCompare.x2 && triangle.y2 === toCompare.y2 && triangle.x3 === toCompare.x3 && triangle.y3 === toCompare.y3;
            };
            module1.exports = Equals;
        /***/ },
        /* 1299 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Length = __webpack_require__(64);
            /**
 * Gets the length of the perimeter of the given triangle.
 * Calculated by adding together the length of each of the three sides.
 *
 * @function Phaser.Geom.Triangle.Perimeter
 * @since 3.0.0
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to get the length from.
 *
 * @return {number} The length of the Triangle.
 */ var Perimeter = function(triangle) {
                var line1 = triangle.getLineA();
                var line2 = triangle.getLineB();
                var line3 = triangle.getLineC();
                return Length(line1) + Length(line2) + Length(line3);
            };
            module1.exports = Perimeter;
        /***/ },
        /* 1300 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(235);
            var InCenter = __webpack_require__(500);
            /**
 * Rotates a Triangle about its incenter, which is the point at which its three angle bisectors meet.
 *
 * @function Phaser.Geom.Triangle.Rotate
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var Rotate = function(triangle, angle) {
                var point = InCenter(triangle);
                return RotateAroundXY(triangle, point.x, point.y, angle);
            };
            module1.exports = Rotate;
        /***/ },
        /* 1301 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RotateAroundXY = __webpack_require__(235);
            /**
 * Rotates a Triangle at a certain angle about a given Point or object with public `x` and `y` properties.
 *
 * @function Phaser.Geom.Triangle.RotateAroundPoint
 * @since 3.0.0
 *
 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
 *
 * @param {Phaser.Geom.Triangle} triangle - The Triangle to rotate.
 * @param {Phaser.Geom.Point} point - The Point to rotate the Triangle about.
 * @param {number} angle - The angle by which to rotate the Triangle, in radians.
 *
 * @return {Phaser.Geom.Triangle} The rotated Triangle.
 */ var RotateAroundPoint = function(triangle, point, angle) {
                return RotateAroundXY(triangle, point.x, point.y, angle);
            };
            module1.exports = RotateAroundPoint;
        /***/ },
        /* 1302 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(200);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Input
 */ var Input = {
                CreatePixelPerfectHandler: __webpack_require__(501),
                CreateInteractiveObject: __webpack_require__(502),
                Events: __webpack_require__(49),
                Gamepad: __webpack_require__(1303),
                InputManager: __webpack_require__(403),
                InputPlugin: __webpack_require__(1315),
                InputPluginCache: __webpack_require__(151),
                Keyboard: __webpack_require__(1316),
                Mouse: __webpack_require__(1330),
                Pointer: __webpack_require__(406),
                Touch: __webpack_require__(1331)
            };
            //   Merge in the consts
            Input = Extend(false, Input, CONST);
            module1.exports = Input;
        /***/ },
        /* 1303 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad
 */ module1.exports = {
                Axis: __webpack_require__(503),
                Button: __webpack_require__(504),
                Events: __webpack_require__(236),
                Gamepad: __webpack_require__(505),
                GamepadPlugin: __webpack_require__(1310),
                Configs: __webpack_require__(1311)
            };
        /***/ },
        /* 1304 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a button has been pressed on any active Gamepad.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.on('down', listener)`.
 * 
 * You can also listen for a DOWN event from a Gamepad instance. See the [GAMEPAD_BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_DOWN
 * @since 3.10.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was pressed.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = 'down';
        /***/ },
        /* 1305 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a button has been released on any active Gamepad.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.on('up', listener)`.
 * 
 * You can also listen for an UP event from a Gamepad instance. See the [GAMEPAD_BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:GAMEPAD_BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#BUTTON_UP
 * @since 3.10.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad on which the button was released.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 */ module1.exports = 'up';
        /***/ },
        /* 1306 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Connected Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been connected.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.once('connected', listener)`.
 * 
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * @event Phaser.Input.Gamepad.Events#CONNECTED
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was connected.
 * @param {Event} event - The native DOM Event that triggered the connection.
 */ module1.exports = 'connected';
        /***/ },
        /* 1307 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Disconnected Event.
 * 
 * This event is dispatched by the Gamepad Plugin when a Gamepad has been disconnected.
 * 
 * Listen to this event from within a Scene using: `this.input.gamepad.once('disconnected', listener)`.
 *
 * @event Phaser.Input.Gamepad.Events#DISCONNECTED
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Gamepad} pad - A reference to the Gamepad which was disconnected.
 * @param {Event} event - The native DOM Event that triggered the disconnection.
 */ module1.exports = 'disconnected';
        /***/ },
        /* 1308 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Down Event.
 * 
 * This event is dispatched by a Gamepad instance when a button has been pressed on it.
 * 
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('down', listener)`.
 * 
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 * 
 * You can also listen for a DOWN event from the Gamepad Plugin. See the [BUTTON_DOWN]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_DOWN} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_DOWN
 * @since 3.10.0
 * 
 * @param {number} index - The index of the button that was pressed.
 * @param {number} value - The value of the button at the time it was pressed. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was pressed.
 */ module1.exports = 'down';
        /***/ },
        /* 1309 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Gamepad Button Up Event.
 * 
 * This event is dispatched by a Gamepad instance when a button has been released on it.
 * 
 * Listen to this event from a Gamepad instance. Once way to get this is from the `pad1`, `pad2`, etc properties on the Gamepad Plugin:
 * `this.input.gamepad.pad1.on('up', listener)`.
 * 
 * Note that you will not receive any Gamepad button events until the browser considers the Gamepad as being 'connected'.
 * 
 * You can also listen for an UP event from the Gamepad Plugin. See the [BUTTON_UP]{@linkcode Phaser.Input.Gamepad.Events#event:BUTTON_UP} event for details.
 *
 * @event Phaser.Input.Gamepad.Events#GAMEPAD_BUTTON_UP
 * @since 3.10.0
 * 
 * @param {number} index - The index of the button that was released.
 * @param {number} value - The value of the button at the time it was released. Between 0 and 1. Some Gamepads have pressure-sensitive buttons.
 * @param {Phaser.Input.Gamepad.Button} button - A reference to the Button which was released.
 */ module1.exports = 'up';
        /***/ },
        /* 1310 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(236);
            var Gamepad = __webpack_require__(505);
            var GetValue = __webpack_require__(6);
            var InputPluginCache = __webpack_require__(151);
            var InputEvents = __webpack_require__(49);
            /**
 * @classdesc
 * The Gamepad Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Gamepad Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.gamepad`.
 *
 * To listen for a gamepad being connected:
 *
 * ```javascript
 * this.input.gamepad.once('connected', function (pad) {
 *     //   'pad' is a reference to the gamepad that was just connected
 * });
 * ```
 *
 * Note that the browser may require you to press a button on a gamepad before it will allow you to access it,
 * this is for security reasons. However, it may also trust the page already, in which case you won't get the
 * 'connected' event and instead should check `GamepadPlugin.total` to see if it thinks there are any gamepads
 * already connected.
 *
 * Once you have received the connected event, or polled the gamepads and found them enabled, you can access
 * them via the built-in properties `GamepadPlugin.pad1` to `pad4`, for up to 4 game pads. With a reference
 * to the gamepads you can poll its buttons and axis sticks. See the properties and methods available on
 * the `Gamepad` class for more details.
 *
 * As of September 2020 Chrome, and likely other browsers, will soon start to require that games requesting
 * access to the Gamepad API are running under SSL. They will actively block API access if they are not.
 *
 * For more information about Gamepad support in browsers see the following resources:
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API
 * https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
 * https://www.smashingmagazine.com/2015/11/gamepad-api-in-web-games/
 * http://html5gamepad.com/
 *
 * @class GamepadPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Gamepad
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var GamepadPlugin = new Class({
                Extends: EventEmitter,
                initialize: function GamepadPlugin(sceneInputPlugin) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                    /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                    /**
         * A boolean that controls if the Gamepad Manager is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                    /**
         * The Gamepad Event target, as defined in the Game Config.
         * Typically the browser window, but can be any interactive DOM element.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#target
         * @type {any}
         * @since 3.10.0
         */ this.target;
                    /**
         * An array of the connected Gamepads.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#gamepads
         * @type {Phaser.Input.Gamepad.Gamepad[]}
         * @default []
         * @since 3.10.0
         */ this.gamepads = [];
                    /**
         * An internal event queue.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#queue
         * @type {GamepadEvent[]}
         * @private
         * @since 3.10.0
         */ this.queue = [];
                    /**
         * Internal event handler.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#onGamepadHandler
         * @type {function}
         * @private
         * @since 3.10.0
         */ this.onGamepadHandler;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad1
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad1;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad2
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad2;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad3
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad3;
                    /**
         * Internal Gamepad reference.
         *
         * @name Phaser.Input.Gamepad.GamepadPlugin#_pad4
         * @type {Phaser.Input.Gamepad.Gamepad}
         * @private
         * @since 3.10.0
         */ this._pad4;
                    sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                    sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                    var game = this.scene.sys.game;
                    var settings = this.settings.input;
                    var config = game.config;
                    this.enabled = GetValue(settings, 'gamepad', config.inputGamepad) && game.device.input.gamepads;
                    this.target = GetValue(settings, 'gamepad.target', config.inputGamepadEventTarget);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                    if (this.enabled) {
                        this.startListeners();
                        this.refreshPads();
                    }
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * Starts the Gamepad Event listeners running.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#startListeners
     * @private
     * @since 3.10.0
     */ startListeners: function() {
                    var _this = this;
                    var target = this.target;
                    var handler = function(event) {
                        if (event.defaultPrevented || !_this.isActive()) // Do nothing if event already handled
                        return;
                        _this.refreshPads();
                        _this.queue.push(event);
                    };
                    this.onGamepadHandler = handler;
                    target.addEventListener('gamepadconnected', handler, false);
                    target.addEventListener('gamepaddisconnected', handler, false);
                    //  FF also supports gamepadbuttondown, gamepadbuttonup and gamepadaxismove but
                    //  nothing else does, and we can get those values via the gamepads anyway, so we will
                    //  until more browsers support this
                    //  Finally, listen for an update event from the Input Plugin
                    this.sceneInputPlugin.pluginEvents.on(InputEvents.UPDATE, this.update, this);
                },
                /**
     * Stops the Gamepad Event listeners.
     * This is called automatically and does not need to be manually invoked.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#stopListeners
     * @private
     * @since 3.10.0
     */ stopListeners: function() {
                    this.target.removeEventListener('gamepadconnected', this.onGamepadHandler);
                    this.target.removeEventListener('gamepaddisconnected', this.onGamepadHandler);
                    this.sceneInputPlugin.pluginEvents.off(InputEvents.UPDATE, this.update);
                    for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].removeAllListeners();
                },
                /**
     * Disconnects all current Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#disconnectAll
     * @since 3.10.0
     */ disconnectAll: function() {
                    for(var i = 0; i < this.gamepads.length; i++)this.gamepads[i].pad.connected = false;
                },
                /**
     * Refreshes the list of connected Gamepads.
     *
     * This is called automatically when a gamepad is connected or disconnected,
     * and during the update loop.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#refreshPads
     * @private
     * @since 3.10.0
     */ refreshPads: function() {
                    var connectedPads = navigator.getGamepads();
                    if (!connectedPads) this.disconnectAll();
                    else {
                        var currentPads = this.gamepads;
                        for(var i = 0; i < connectedPads.length; i++){
                            var livePad = connectedPads[i];
                            //  Because sometimes they're null (yes, really)
                            if (!livePad) continue;
                            var id = livePad.id;
                            var index = livePad.index;
                            var currentPad = currentPads[index];
                            if (!currentPad) {
                                //  A new Gamepad, not currently stored locally
                                var newPad = new Gamepad(this, livePad);
                                currentPads[index] = newPad;
                                if (!this._pad1) this._pad1 = newPad;
                                else if (!this._pad2) this._pad2 = newPad;
                                else if (!this._pad3) this._pad3 = newPad;
                                else if (!this._pad4) this._pad4 = newPad;
                            } else if (currentPad.id !== id) {
                                //  A new Gamepad with a different vendor string, but it has got the same index as an old one
                                currentPad.destroy();
                                currentPads[index] = new Gamepad(this, livePad);
                            } else //  If neither of these, it's a pad we've already got, so update it
                            currentPad.update(livePad);
                        }
                    }
                },
                /**
     * Returns an array of all currently connected Gamepads.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getAll
     * @since 3.10.0
     *
     * @return {Phaser.Input.Gamepad.Gamepad[]} An array of all currently connected Gamepads.
     */ getAll: function() {
                    var out = [];
                    var pads = this.gamepads;
                    for(var i = 0; i < pads.length; i++)if (pads[i]) out.push(pads[i]);
                    return out;
                },
                /**
     * Looks-up a single Gamepad based on the given index value.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#getPad
     * @since 3.10.0
     *
     * @param {number} index - The index of the Gamepad to get.
     *
     * @return {Phaser.Input.Gamepad.Gamepad} The Gamepad matching the given index, or undefined if none were found.
     */ getPad: function(index) {
                    var pads = this.gamepads;
                    for(var i = 0; i < pads.length; i++){
                        if (pads[i] && pads[i].index === index) return pads[i];
                    }
                },
                /**
     * The internal update loop. Refreshes all connected gamepads and processes their events.
     *
     * Called automatically by the Input Manager, invoked from the Game step.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#update
     * @private
     * @fires Phaser.Input.Gamepad.Events#CONNECTED
     * @fires Phaser.Input.Gamepad.Events#DISCONNECTED
     * @since 3.10.0
     */ update: function() {
                    if (!this.enabled) return;
                    this.refreshPads();
                    var len = this.queue.length;
                    if (len === 0) return;
                    var queue = this.queue.splice(0, len);
                    //  Process the event queue, dispatching all of the events that have stored up
                    for(var i = 0; i < len; i++){
                        var event = queue[i];
                        var pad = this.getPad(event.gamepad.index);
                        if (event.type === 'gamepadconnected') this.emit(Events.CONNECTED, pad, event);
                        else if (event.type === 'gamepaddisconnected') this.emit(Events.DISCONNECTED, pad, event);
                    }
                },
                /**
     * Shuts the Gamepad Plugin down.
     * All this does is remove any listeners bound to it.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                    this.stopListeners();
                    this.removeAllListeners();
                },
                /**
     * Destroys this Gamepad Plugin, disconnecting all Gamepads and releasing internal references.
     *
     * @method Phaser.Input.Gamepad.GamepadPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                    this.shutdown();
                    for(var i = 0; i < this.gamepads.length; i++)if (this.gamepads[i]) this.gamepads[i].destroy();
                    this.gamepads = [];
                    this.scene = null;
                    this.settings = null;
                    this.sceneInputPlugin = null;
                    this.target = null;
                },
                /**
     * The total number of connected game pads.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#total
     * @type {number}
     * @since 3.10.0
     */ total: {
                    get: function() {
                        return this.gamepads.length;
                    }
                },
                /**
     * A reference to the first connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad1
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad1: {
                    get: function() {
                        return this._pad1;
                    }
                },
                /**
     * A reference to the second connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad2
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad2: {
                    get: function() {
                        return this._pad2;
                    }
                },
                /**
     * A reference to the third connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad3
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad3: {
                    get: function() {
                        return this._pad3;
                    }
                },
                /**
     * A reference to the fourth connected Gamepad.
     *
     * This will be undefined if either no pads are connected, or the browser
     * has not yet issued a gamepadconnect, which can happen even if a Gamepad
     * is plugged in, but hasn't yet had any buttons pressed on it.
     *
     * @name Phaser.Input.Gamepad.GamepadPlugin#pad4
     * @type {Phaser.Input.Gamepad.Gamepad}
     * @since 3.10.0
     */ pad4: {
                    get: function() {
                        return this._pad4;
                    }
                }
            });
            /**
 * An instance of the Gamepad Plugin class, if enabled via the `input.gamepad` Scene or Game Config property.
 * Use this to create access Gamepads connected to the browser and respond to gamepad buttons.
 *
 * @name Phaser.Input.InputPlugin#gamepad
 * @type {?Phaser.Input.Gamepad.GamepadPlugin}
 * @since 3.10.0
 */ InputPluginCache.register('GamepadPlugin', GamepadPlugin, 'gamepad', 'gamepad', 'inputGamepad');
            module1.exports = GamepadPlugin;
        /***/ },
        /* 1311 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Gamepad.Configs
 */ module1.exports = {
                DUALSHOCK_4: __webpack_require__(1312),
                SNES_USB: __webpack_require__(1313),
                XBOX_360: __webpack_require__(1314)
            };
        /***/ },
        /* 1312 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * PlayStation DualShock 4 Gamepad Configuration.
 * Sony PlayStation DualShock 4 (v2) wireless controller
 *
 * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SHARE: 8,
                OPTIONS: 9,
                PS: 16,
                TOUCHBAR: 17,
                X: 0,
                CIRCLE: 1,
                SQUARE: 2,
                TRIANGLE: 3,
                L1: 4,
                R1: 5,
                L2: 6,
                R2: 7,
                L3: 10,
                R3: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        /***/ },
        /* 1313 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Tatar SNES USB Controller Gamepad Configuration.
 * USB Gamepad  (STANDARD GAMEPAD Vendor: 0079 Product: 0011)
 *
 * @name Phaser.Input.Gamepad.Configs.SNES_USB
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                SELECT: 8,
                START: 9,
                B: 0,
                A: 1,
                Y: 2,
                X: 3,
                LEFT_SHOULDER: 4,
                RIGHT_SHOULDER: 5
            };
        /***/ },
        /* 1314 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * XBox 360 Gamepad Configuration.
 *
 * @name Phaser.Input.Gamepad.Configs.XBOX_360
 * @type {object}
 * @since 3.0.0
 */ module1.exports = {
                UP: 12,
                DOWN: 13,
                LEFT: 14,
                RIGHT: 15,
                MENU: 16,
                A: 0,
                B: 1,
                X: 2,
                Y: 3,
                LB: 4,
                RB: 5,
                LT: 6,
                RT: 7,
                BACK: 8,
                START: 9,
                LS: 10,
                RS: 11,
                LEFT_STICK_H: 0,
                LEFT_STICK_V: 1,
                RIGHT_STICK_H: 2,
                RIGHT_STICK_V: 3
            };
        /***/ },
        /* 1315 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Circle = __webpack_require__(62);
            var CircleContains = __webpack_require__(63);
            var Class = __webpack_require__(0);
            var CONST = __webpack_require__(200);
            var CreateInteractiveObject = __webpack_require__(502);
            var CreatePixelPerfectHandler = __webpack_require__(501);
            var DistanceBetween = __webpack_require__(48);
            var Ellipse = __webpack_require__(108);
            var EllipseContains = __webpack_require__(109);
            var Events = __webpack_require__(49);
            var EventEmitter = __webpack_require__(9);
            var GetFastValue = __webpack_require__(2);
            var GEOM_CONST = __webpack_require__(55);
            var InputPluginCache = __webpack_require__(151);
            var IsPlainObject = __webpack_require__(7);
            var PluginCache = __webpack_require__(24);
            var Rectangle = __webpack_require__(10);
            var RectangleContains = __webpack_require__(56);
            var SceneEvents = __webpack_require__(21);
            var Triangle = __webpack_require__(82);
            var TriangleContains = __webpack_require__(112);
            /**
 * @classdesc
 * The Input Plugin belongs to a Scene and handles all input related events and operations for it.
 *
 * You can access it from within a Scene using `this.input`.
 *
 * It emits events directly. For example, you can do:
 *
 * ```javascript
 * this.input.on('pointerdown', callback, context);
 * ```
 *
 * To listen for a pointer down event anywhere on the game canvas.
 *
 * Game Objects can be enabled for input by calling their `setInteractive` method. After which they
 * will directly emit input events:
 *
 * ```javascript
 * var sprite = this.add.sprite(x, y, texture);
 * sprite.setInteractive();
 * sprite.on('pointerdown', callback, context);
 * ```
 *
 * There are lots of game configuration options available relating to input.
 * See the [Input Config object]{@linkcode Phaser.Types.Core.InputConfig} for more details, including how to deal with Phaser
 * listening for input events outside of the canvas, how to set a default number of pointers, input
 * capture settings and more.
 *
 * Please also see the Input examples and tutorials for further information.
 *
 * **Incorrect input coordinates with Angular**
 *
 * If you are using Phaser within Angular, and use nglf or the router, to make the component in which the Phaser game resides
 * change state (i.e. appear or disappear) then you'll need to notify the Scale Manager about this, as Angular will mess with
 * the DOM in a way in which Phaser can't detect directly. Call `this.scale.updateBounds()` as part of your game init in order
 * to refresh the canvas DOM bounds values, which Phaser uses for input point position calculations.
 *
 * @class InputPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that this Input Plugin is responsible for.
 */ var InputPlugin = new Class({
                Extends: EventEmitter,
                initialize: function InputPlugin(scene) {
                    EventEmitter.call(this);
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.InputPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems class.
         *
         * @name Phaser.Input.InputPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.InputPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.5.0
         */ this.settings = scene.sys.settings;
                    /**
         * A reference to the Game Input Manager.
         *
         * @name Phaser.Input.InputPlugin#manager
         * @type {Phaser.Input.InputManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.input;
                    /**
         * Internal event queue used for plugins only.
         *
         * @name Phaser.Input.InputPlugin#pluginEvents
         * @type {Phaser.Events.EventEmitter}
         * @private
         * @since 3.10.0
         */ this.pluginEvents = new EventEmitter();
                    /**
         * If `true` this Input Plugin will process DOM input events.
         *
         * @name Phaser.Input.InputPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.5.0
         */ this.enabled = true;
                    /**
         * A reference to the Scene Display List. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#displayList
         * @type {Phaser.GameObjects.DisplayList}
         * @since 3.0.0
         */ this.displayList;
                    /**
         * A reference to the Scene Cameras Manager. This property is set during the `boot` method.
         *
         * @name Phaser.Input.InputPlugin#cameras
         * @type {Phaser.Cameras.Scene2D.CameraManager}
         * @since 3.0.0
         */ this.cameras;
                    //  Inject the available input plugins into this class
                    InputPluginCache.install(this);
                    /**
         * A reference to the Mouse Manager.
         *
         * This property is only set if Mouse support has been enabled in your Game Configuration file.
         *
         * If you just wish to get access to the mouse pointer, use the `mousePointer` property instead.
         *
         * @name Phaser.Input.InputPlugin#mouse
         * @type {?Phaser.Input.Mouse.MouseManager}
         * @since 3.0.0
         */ this.mouse = this.manager.mouse;
                    /**
         * When set to `true` (the default) the Input Plugin will emulate DOM behavior by only emitting events from
         * the top-most Game Objects in the Display List.
         *
         * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
         *
         * @name Phaser.Input.InputPlugin#topOnly
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.topOnly = true;
                    /**
         * How often should the Pointers be checked?
         *
         * The value is a time, given in ms, and is the time that must have elapsed between game steps before
         * the Pointers will be polled again. When a pointer is polled it runs a hit test to see which Game
         * Objects are currently below it, or being interacted with it.
         *
         * Pointers will *always* be checked if they have been moved by the user, or press or released.
         *
         * This property only controls how often they will be polled if they have not been updated.
         * You should set this if you want to have Game Objects constantly check against the pointers, even
         * if the pointer didn't itself move.
         *
         * Set to 0 to poll constantly. Set to -1 to only poll on user movement.
         *
         * @name Phaser.Input.InputPlugin#pollRate
         * @type {number}
         * @default -1
         * @since 3.0.0
         */ this.pollRate = -1;
                    /**
         * Internal poll timer value.
         *
         * @name Phaser.Input.InputPlugin#_pollTimer
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._pollTimer = 0;
                    var _eventData = {
                        cancelled: false
                    };
                    /**
         * Internal event propagation callback container.
         *
         * @name Phaser.Input.InputPlugin#_eventContainer
         * @type {Phaser.Types.Input.EventData}
         * @private
         * @since 3.13.0
         */ this._eventContainer = {
                        stopPropagation: function() {
                            _eventData.cancelled = true;
                        }
                    };
                    /**
         * Internal event propagation data object.
         *
         * @name Phaser.Input.InputPlugin#_eventData
         * @type {object}
         * @private
         * @since 3.13.0
         */ this._eventData = _eventData;
                    /**
         * The distance, in pixels, a pointer has to move while being held down, before it thinks it is being dragged.
         *
         * @name Phaser.Input.InputPlugin#dragDistanceThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragDistanceThreshold = 0;
                    /**
         * The amount of time, in ms, a pointer has to be held down before it thinks it is dragging.
         *
         * The default polling rate is to poll only on move so once the time threshold is reached the
         * drag event will not start until you move the mouse. If you want it to start immediately
         * when the time threshold is reached, you must increase the polling rate by calling
         * [setPollAlways]{@linkcode Phaser.Input.InputPlugin#setPollAlways} or
         * [setPollRate]{@linkcode Phaser.Input.InputPlugin#setPollRate}.
         *
         * @name Phaser.Input.InputPlugin#dragTimeThreshold
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.dragTimeThreshold = 0;
                    /**
         * Used to temporarily store the results of the Hit Test
         *
         * @name Phaser.Input.InputPlugin#_temp
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._temp = [];
                    /**
         * Used to temporarily store the results of the Hit Test dropZones
         *
         * @name Phaser.Input.InputPlugin#_tempZones
         * @type {array}
         * @private
         * @default []
         * @since 3.0.0
         */ this._tempZones = [];
                    /**
         * A list of all Game Objects that have been set to be interactive in the Scene this Input Plugin is managing.
         *
         * @name Phaser.Input.InputPlugin#_list
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._list = [];
                    /**
         * Objects waiting to be inserted to the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingInsertion
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                    /**
         * Objects waiting to be removed from the list on the next call to 'begin'.
         *
         * @name Phaser.Input.InputPlugin#_pendingRemoval
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                    /**
         * A list of all Game Objects that have been enabled for dragging.
         *
         * @name Phaser.Input.InputPlugin#_draggable
         * @type {Phaser.GameObjects.GameObject[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._draggable = [];
                    /**
         * A list of all Interactive Objects currently considered as being 'draggable' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_drag
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._drag = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    };
                    /**
         * A array containing the dragStates, for this Scene, index by the Pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_dragState
         * @type {number[]}
         * @private
         * @since 3.16.0
         */ this._dragState = [];
                    /**
         * A list of all Interactive Objects currently considered as being 'over' by any pointer, indexed by pointer ID.
         *
         * @name Phaser.Input.InputPlugin#_over
         * @type {{0:Array,1:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array,10:Array}}
         * @private
         * @since 3.0.0
         */ this._over = {
                        0: [],
                        1: [],
                        2: [],
                        3: [],
                        4: [],
                        5: [],
                        6: [],
                        7: [],
                        8: [],
                        9: [],
                        10: []
                    };
                    /**
         * A list of valid DOM event types.
         *
         * @name Phaser.Input.InputPlugin#_validTypes
         * @type {string[]}
         * @private
         * @since 3.0.0
         */ this._validTypes = [
                        'onDown',
                        'onUp',
                        'onOver',
                        'onOut',
                        'onMove',
                        'onDragStart',
                        'onDrag',
                        'onDragEnd',
                        'onDragEnter',
                        'onDragLeave',
                        'onDragOver',
                        'onDrop'
                    ];
                    /**
         * Internal property that tracks frame event state.
         *
         * @name Phaser.Input.InputPlugin#_updatedThisFrame
         * @type {boolean}
         * @private
         * @since 3.18.0
         */ this._updatedThisFrame = false;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#boot
     * @fires Phaser.Input.Events#BOOT
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.cameras = this.systems.cameras;
                    this.displayList = this.systems.displayList;
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.BOOT);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.InputPlugin#start
     * @fires Phaser.Input.Events#START
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.TRANSITION_START, this.transitionIn, this);
                    eventEmitter.on(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                    eventEmitter.on(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.manager.events.on(Events.GAME_OUT, this.onGameOut, this);
                    this.manager.events.on(Events.GAME_OVER, this.onGameOver, this);
                    this.enabled = true;
                    //  Populate the pointer drag states
                    this._dragState = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.START);
                },
                /**
     * Game Over handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOver
     * @fires Phaser.Input.Events#GAME_OVER
     * @private
     * @since 3.16.2
     */ onGameOver: function(event) {
                    if (this.isActive()) this.emit(Events.GAME_OVER, event.timeStamp, event);
                },
                /**
     * Game Out handler.
     *
     * @method Phaser.Input.InputPlugin#onGameOut
     * @fires Phaser.Input.Events#GAME_OUT
     * @private
     * @since 3.16.2
     */ onGameOut: function(event) {
                    if (this.isActive()) this.emit(Events.GAME_OUT, event.timeStamp, event);
                },
                /**
     * The pre-update handler is responsible for checking the pending removal and insertion lists and
     * deleting old Game Objects.
     *
     * @method Phaser.Input.InputPlugin#preUpdate
     * @private
     * @fires Phaser.Input.Events#PRE_UPDATE
     * @since 3.0.0
     */ preUpdate: function() {
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.PRE_UPDATE);
                    var removeList = this._pendingRemoval;
                    var insertList = this._pendingInsertion;
                    var toRemove = removeList.length;
                    var toInsert = insertList.length;
                    if (toRemove === 0 && toInsert === 0) //  Quick bail
                    return;
                    var current = this._list;
                    //  Delete old gameObjects
                    for(var i = 0; i < toRemove; i++){
                        var gameObject = removeList[i];
                        var index = current.indexOf(gameObject);
                        if (index > -1) {
                            current.splice(index, 1);
                            this.clear(gameObject, true);
                        }
                    }
                    //  Clear the removal list
                    removeList.length = 0;
                    this._pendingRemoval.length = 0;
                    //  Move pendingInsertion to list (also clears pendingInsertion at the same time)
                    this._list = current.concat(insertList.splice(0));
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.InputPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * This is called automatically by the Input Manager.
     * It emits events for plugins to listen to and also handles polling updates, if enabled.
     *
     * @method Phaser.Input.InputPlugin#updatePoll
     * @since 3.18.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ updatePoll: function(time, delta) {
                    if (!this.isActive()) return false;
                    //  The plugins should update every frame, regardless if there has been
                    //  any DOM input events or not (such as the Gamepad and Keyboard)
                    this.pluginEvents.emit(Events.UPDATE, time, delta);
                    //  We can leave now if we've already updated once this frame via the immediate DOM event handlers
                    if (this._updatedThisFrame) {
                        this._updatedThisFrame = false;
                        return false;
                    }
                    var i;
                    var manager = this.manager;
                    var pointers = manager.pointers;
                    var pointersTotal = manager.pointersTotal;
                    for(i = 0; i < pointersTotal; i++)pointers[i].updateMotion();
                    //  No point going any further if there aren't any interactive objects
                    if (this._list.length === 0) return false;
                    var rate = this.pollRate;
                    if (rate === -1) return false;
                    else if (rate > 0) {
                        this._pollTimer -= delta;
                        if (this._pollTimer < 0) //  Discard timer diff, we're ready to poll again
                        this._pollTimer = this.pollRate;
                        else //  Not enough time has elapsed since the last poll, so abort now
                        return false;
                    }
                    //  We got this far? Then we should poll for movement
                    var captured = false;
                    for(i = 0; i < pointersTotal; i++){
                        var total = 0;
                        var pointer = pointers[i];
                        //  Always reset this array
                        this._tempZones = [];
                        //  _temp contains a hit tested and camera culled list of IO objects
                        this._temp = this.hitTestPointer(pointer);
                        this.sortGameObjects(this._temp, pointer);
                        this.sortDropZones(this._tempZones);
                        if (this.topOnly) {
                            //  Only the top-most one counts now, so safely ignore the rest
                            if (this._temp.length) this._temp.splice(1);
                            if (this._tempZones.length) this._tempZones.splice(1);
                        }
                        total += this.processOverOutEvents(pointer);
                        if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, time);
                        if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                        captured = true;
                    }
                    return captured;
                },
                /**
     * This method is called when a DOM Event is received by the Input Manager. It handles dispatching the events
     * to relevant input enabled Game Objects in this scene.
     *
     * @method Phaser.Input.InputPlugin#update
     * @private
     * @fires Phaser.Input.Events#UPDATE
     * @since 3.0.0
     *
     * @param {number} type - The type of event to process.
     * @param {Phaser.Input.Pointer[]} pointers - An array of Pointers on which the event occurred.
     *
     * @return {boolean} `true` if this Scene has captured the input events from all other Scenes, otherwise `false`.
     */ update: function(type, pointers) {
                    if (!this.isActive()) return false;
                    var pointersTotal = pointers.length;
                    var captured = false;
                    for(var i = 0; i < pointersTotal; i++){
                        var total = 0;
                        var pointer = pointers[i];
                        //  Always reset this array
                        this._tempZones = [];
                        //  _temp contains a hit tested and camera culled list of IO objects
                        this._temp = this.hitTestPointer(pointer);
                        this.sortGameObjects(this._temp, pointer);
                        this.sortDropZones(this._tempZones);
                        if (this.topOnly) {
                            //  Only the top-most one counts now, so safely ignore the rest
                            if (this._temp.length) this._temp.splice(1);
                            if (this._tempZones.length) this._tempZones.splice(1);
                        }
                        switch(type){
                            case CONST.MOUSE_DOWN:
                                total += this.processDragDownEvent(pointer);
                                total += this.processDownEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.MOUSE_UP:
                                total += this.processDragUpEvent(pointer);
                                total += this.processUpEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.TOUCH_START:
                                total += this.processDragDownEvent(pointer);
                                total += this.processDownEvents(pointer);
                                total += this.processOverEvents(pointer);
                                break;
                            case CONST.TOUCH_END:
                            case CONST.TOUCH_CANCEL:
                                total += this.processDragUpEvent(pointer);
                                total += this.processUpEvents(pointer);
                                total += this.processOutEvents(pointer);
                                break;
                            case CONST.MOUSE_MOVE:
                            case CONST.TOUCH_MOVE:
                                total += this.processDragMoveEvent(pointer);
                                total += this.processMoveEvents(pointer);
                                total += this.processOverOutEvents(pointer);
                                break;
                            case CONST.MOUSE_WHEEL:
                                total += this.processWheelEvent(pointer);
                                break;
                        }
                        if (total > 0) //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
                        captured = true;
                    }
                    this._updatedThisFrame = true;
                    return captured;
                },
                /**
     * Clears a Game Object so it no longer has an Interactive Object associated with it.
     * The Game Object is then queued for removal from the Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#clear
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have its Interactive Object removed.
     * @param {boolean} [skipQueue=false] - Skip adding this Game Object into the removal queue?
     *
     * @return {Phaser.GameObjects.GameObject} The Game Object that had its Interactive Object removed.
     */ clear: function(gameObject, skipQueue) {
                    if (skipQueue === undefined) skipQueue = false;
                    var input = gameObject.input;
                    // If GameObject.input already cleared from higher class
                    if (!input) return;
                    if (!skipQueue) this.queueForRemoval(gameObject);
                    input.gameObject = undefined;
                    input.target = undefined;
                    input.hitArea = undefined;
                    input.hitAreaCallback = undefined;
                    input.callbackContext = undefined;
                    gameObject.input = null;
                    //  Clear from _draggable, _drag and _over
                    var index = this._draggable.indexOf(gameObject);
                    if (index > -1) this._draggable.splice(index, 1);
                    index = this._drag[0].indexOf(gameObject);
                    if (index > -1) this._drag[0].splice(index, 1);
                    index = this._over[0].indexOf(gameObject);
                    if (index > -1) {
                        this._over[0].splice(index, 1);
                        this.manager.resetCursor(input);
                    }
                    return gameObject;
                },
                /**
     * Disables Input on a single Game Object.
     *
     * An input disabled Game Object still retains its Interactive Object component and can be re-enabled
     * at any time, by passing it to `InputPlugin.enable`.
     *
     * @method Phaser.Input.InputPlugin#disable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to have its input system disabled.
     */ disable: function(gameObject) {
                    gameObject.input.enabled = false;
                },
                /**
     * Enable a Game Object for interaction.
     *
     * If the Game Object already has an Interactive Object component, it is enabled and returned.
     *
     * Otherwise, a new Interactive Object component is created and assigned to the Game Object's `input` property.
     *
     * Input works by using hit areas, these are nearly always geometric shapes, such as rectangles or circles, that act as the hit area
     * for the Game Object. However, you can provide your own hit area shape and callback, should you wish to handle some more advanced
     * input detection.
     *
     * If no arguments are provided it will try and create a rectangle hit area based on the texture frame the Game Object is using. If
     * this isn't a texture-bound object, such as a Graphics or BitmapText object, this will fail, and you'll need to provide a specific
     * shape for it to use.
     *
     * You can also provide an Input Configuration Object as the only argument to this method.
     *
     * @method Phaser.Input.InputPlugin#enable
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to be enabled for input.
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     * @param {boolean} [dropZone=false] - Is this Game Object a drop zone or not?
     *
     * @return {this} This Input Plugin.
     */ enable: function(gameObject, hitArea, hitAreaCallback, dropZone) {
                    if (dropZone === undefined) dropZone = false;
                    if (gameObject.input) //  If it is already has an InteractiveObject then just enable it and return
                    gameObject.input.enabled = true;
                    else //  Create an InteractiveObject and enable it
                    this.setHitArea(gameObject, hitArea, hitAreaCallback);
                    if (gameObject.input && dropZone && !gameObject.input.dropZone) gameObject.input.dropZone = dropZone;
                    return this;
                },
                /**
     * Takes the given Pointer and performs a hit test against it, to see which interactive Game Objects
     * it is currently above.
     *
     * The hit test is performed against which-ever Camera the Pointer is over. If it is over multiple
     * cameras, it starts checking the camera at the top of the camera list, and if nothing is found, iterates down the list.
     *
     * @method Phaser.Input.InputPlugin#hitTestPointer
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} An array of all the interactive Game Objects the Pointer was above.
     */ hitTestPointer: function(pointer) {
                    var cameras = this.cameras.getCamerasBelowPointer(pointer);
                    for(var c = 0; c < cameras.length; c++){
                        var camera = cameras[c];
                        //  Get a list of all objects that can be seen by the camera below the pointer in the scene and store in 'over' array.
                        //  All objects in this array are input enabled, as checked by the hitTest method, so we don't need to check later on as well.
                        var over = this.manager.hitTest(pointer, this._list, camera);
                        //  Filter out the drop zones
                        for(var i = 0; i < over.length; i++){
                            var obj = over[i];
                            if (obj.input.dropZone) this._tempZones.push(obj);
                        }
                        if (over.length > 0) {
                            pointer.camera = camera;
                            return over;
                        }
                    }
                    //  If we got this far then there were no Game Objects below the pointer, but it was still over
                    //  a camera, so set that the top-most one into the pointer
                    pointer.camera = cameras[0];
                    return [];
                },
                /**
     * An internal method that handles the Pointer down event.
     *
     * @method Phaser.Input.InputPlugin#processDownEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_DOWN
     * @fires Phaser.Input.Events#GAMEOBJECT_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN
     * @fires Phaser.Input.Events#POINTER_DOWN_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer being tested.
     *
     * @return {number} The total number of objects interacted with.
     */ processDownEvents: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_DOWN, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_DOWN, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    //  If they released outside the canvas, but pressed down inside it, we'll still dispatch the event.
                    if (!aborted && this.manager) {
                        if (pointer.downElement === this.manager.game.canvas) this.emit(Events.POINTER_DOWN, pointer, currentlyOver);
                        else this.emit(Events.POINTER_DOWN_OUTSIDE, pointer);
                    }
                    return total;
                },
                /**
     * Returns the drag state of the given Pointer for this Input Plugin.
     *
     * The state will be one of the following:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#getDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to get the drag state for.
     *
     * @return {number} The drag state of the given Pointer.
     */ getDragState: function(pointer) {
                    return this._dragState[pointer.id];
                },
                /**
     * Sets the drag state of the given Pointer for this Input Plugin.
     *
     * The state must be one of the following values:
     *
     * 0 = Not dragging anything
     * 1 = Primary button down and objects below, so collect a draglist
     * 2 = Pointer being checked if meets drag criteria
     * 3 = Pointer meets criteria, notify the draglist
     * 4 = Pointer actively dragging the draglist and has moved
     * 5 = Pointer actively dragging but has been released, notify draglist
     *
     * @method Phaser.Input.InputPlugin#setDragState
     * @since 3.16.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to set the drag state for.
     * @param {number} state - The drag state value. An integer between 0 and 5.
     */ setDragState: function(pointer, state) {
                    this._dragState[pointer.id] = state;
                },
                /**
     * Checks to see if a Pointer is ready to drag the objects below it, based on either a distance
     * or time threshold.
     *
     * @method Phaser.Input.InputPlugin#processDragThresholdEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check the drag thresholds on.
     * @param {number} time - The current time.
     */ processDragThresholdEvent: function(pointer, time) {
                    var passed = false;
                    var timeThreshold = this.dragTimeThreshold;
                    var distanceThreshold = this.dragDistanceThreshold;
                    if (distanceThreshold > 0 && DistanceBetween(pointer.x, pointer.y, pointer.downX, pointer.downY) >= distanceThreshold) //  It has moved far enough to be considered a drag
                    passed = true;
                    else if (timeThreshold > 0 && time >= pointer.downTime + timeThreshold) //  It has been held down long enough to be considered a drag
                    passed = true;
                    if (passed) {
                        this.setDragState(pointer, 3);
                        return this.processDragStartList(pointer);
                    }
                },
                /**
     * Processes the drag list for the given pointer and dispatches the start events for each object on it.
     *
     * @method Phaser.Input.InputPlugin#processDragStartList
     * @private
     * @fires Phaser.Input.Events#DRAG_START
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_START
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that DRAG_START was called on.
     */ processDragStartList: function(pointer) {
                    //  3 = Pointer meets criteria and is freshly down, notify the draglist
                    if (this.getDragState(pointer) !== 3) return 0;
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        input.dragState = 2;
                        input.dragStartX = gameObject.x;
                        input.dragStartY = gameObject.y;
                        input.dragStartXGlobal = pointer.worldX;
                        input.dragStartYGlobal = pointer.worldY;
                        input.dragX = input.dragStartXGlobal - input.dragStartX;
                        input.dragY = input.dragStartYGlobal - input.dragStartY;
                        gameObject.emit(Events.GAMEOBJECT_DRAG_START, pointer, input.dragX, input.dragY);
                        this.emit(Events.DRAG_START, pointer, gameObject);
                    }
                    this.setDragState(pointer, 4);
                    return list.length;
                },
                /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragDownEvent
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were collected on the drag list.
     */ processDragDownEvent: function(pointer) {
                    var currentlyOver = this._temp;
                    if (this._draggable.length === 0 || currentlyOver.length === 0 || !pointer.primaryDown || this.getDragState(pointer) !== 0) //  There are no draggable items, no over items or the pointer isn't down, so let's not even bother going further
                    return 0;
                    //  1 = Primary button down and objects below, so collect a draglist
                    this.setDragState(pointer, 1);
                    //  Get draggable objects, sort them, pick the top (or all) and store them somewhere
                    var draglist = [];
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (gameObject.input.draggable && gameObject.input.dragState === 0) draglist.push(gameObject);
                    }
                    if (draglist.length === 0) {
                        this.setDragState(pointer, 0);
                        return 0;
                    } else if (draglist.length > 1) {
                        this.sortGameObjects(draglist, pointer);
                        if (this.topOnly) draglist.splice(1);
                    }
                    //  draglist now contains all potential candidates for dragging
                    this._drag[pointer.id] = draglist;
                    if (this.dragDistanceThreshold === 0 && this.dragTimeThreshold === 0) {
                        //  No drag criteria, so snap immediately to mode 3
                        this.setDragState(pointer, 3);
                        return this.processDragStartList(pointer);
                    } else {
                        //  Check the distance / time on the next event
                        this.setDragState(pointer, 2);
                        return 0;
                    }
                },
                /**
     * Processes a 'drag move' event for the given pointer.
     *
     * @method Phaser.Input.InputPlugin#processDragMoveEvent
     * @private
     * @fires Phaser.Input.Events#DRAG_ENTER
     * @fires Phaser.Input.Events#DRAG
     * @fires Phaser.Input.Events#DRAG_LEAVE
     * @fires Phaser.Input.Events#DRAG_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_ENTER
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_LEAVE
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragMoveEvent: function(pointer) {
                    //  2 = Pointer being checked if meets drag criteria
                    if (this.getDragState(pointer) === 2) this.processDragThresholdEvent(pointer, this.manager.game.loop.now);
                    if (this.getDragState(pointer) !== 4) return 0;
                    //  4 = Pointer actively dragging the draglist and has moved
                    var dropZones = this._tempZones;
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        var target = input.target;
                        //  If this GO has a target then let's check it
                        if (target) {
                            var index = dropZones.indexOf(target);
                            //  Got a target, are we still over it?
                            if (index === 0) {
                                //  We're still over it, and it's still the top of the display list, phew ...
                                gameObject.emit(Events.GAMEOBJECT_DRAG_OVER, pointer, target);
                                this.emit(Events.DRAG_OVER, pointer, gameObject, target);
                            } else if (index > 0) {
                                //  Still over it but it's no longer top of the display list (targets must always be at the top)
                                gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                input.target = dropZones[0];
                                target = input.target;
                                gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                            } else {
                                //  Nope, we've moved on (or the target has!), leave the old target
                                gameObject.emit(Events.GAMEOBJECT_DRAG_LEAVE, pointer, target);
                                this.emit(Events.DRAG_LEAVE, pointer, gameObject, target);
                                //  Anything new to replace it?
                                //  Yup!
                                if (dropZones[0]) {
                                    input.target = dropZones[0];
                                    target = input.target;
                                    gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                                    this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                                } else //  Nope
                                input.target = null;
                            }
                        } else if (!target && dropZones[0]) {
                            input.target = dropZones[0];
                            target = input.target;
                            gameObject.emit(Events.GAMEOBJECT_DRAG_ENTER, pointer, target);
                            this.emit(Events.DRAG_ENTER, pointer, gameObject, target);
                        }
                        var dragX;
                        var dragY;
                        if (!gameObject.parentContainer) {
                            dragX = pointer.worldX - input.dragX;
                            dragY = pointer.worldY - input.dragY;
                        } else {
                            var dx = pointer.worldX - input.dragStartXGlobal;
                            var dy = pointer.worldY - input.dragStartYGlobal;
                            var rotation = gameObject.getParentRotation();
                            var dxRotated = dx * Math.cos(rotation) + dy * Math.sin(rotation);
                            var dyRotated = dy * Math.cos(rotation) - dx * Math.sin(rotation);
                            dxRotated *= 1 / gameObject.parentContainer.scaleX;
                            dyRotated *= 1 / gameObject.parentContainer.scaleY;
                            dragX = dxRotated + input.dragStartX;
                            dragY = dyRotated + input.dragStartY;
                        }
                        gameObject.emit(Events.GAMEOBJECT_DRAG, pointer, dragX, dragY);
                        this.emit(Events.DRAG, pointer, gameObject, dragX, dragY);
                    }
                    return list.length;
                },
                /**
     * Processes a 'drag down' event for the given pointer. Checks the pointer state, builds-up the drag list
     * and prepares them all for interaction.
     *
     * @method Phaser.Input.InputPlugin#processDragUpEvent
     * @fires Phaser.Input.Events#DRAG_END
     * @fires Phaser.Input.Events#DROP
     * @fires Phaser.Input.Events#GAMEOBJECT_DRAG_END
     * @fires Phaser.Input.Events#GAMEOBJECT_DROP
     * @private
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The Pointer to process the drag event on.
     *
     * @return {number} The number of items that were updated by this drag event.
     */ processDragUpEvent: function(pointer) {
                    //  5 = Pointer was actively dragging but has been released, notify draglist
                    var list = this._drag[pointer.id];
                    for(var i = 0; i < list.length; i++){
                        var gameObject = list[i];
                        var input = gameObject.input;
                        if (input && input.dragState === 2) {
                            input.dragState = 0;
                            input.dragX = input.localX - gameObject.displayOriginX;
                            input.dragY = input.localY - gameObject.displayOriginY;
                            var dropped = false;
                            var target = input.target;
                            if (target) {
                                gameObject.emit(Events.GAMEOBJECT_DROP, pointer, target);
                                this.emit(Events.DROP, pointer, gameObject, target);
                                input.target = null;
                                dropped = true;
                            }
                            //  And finally the dragend event
                            if (gameObject.input) {
                                gameObject.emit(Events.GAMEOBJECT_DRAG_END, pointer, input.dragX, input.dragY, dropped);
                                this.emit(Events.DRAG_END, pointer, gameObject, dropped);
                            }
                        }
                    }
                    this.setDragState(pointer, 0);
                    list.splice(0);
                    return 0;
                },
                /**
     * An internal method that handles the Pointer movement event.
     *
     * @method Phaser.Input.InputPlugin#processMoveEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_MOVE
     * @fires Phaser.Input.Events#GAMEOBJECT_MOVE
     * @fires Phaser.Input.Events#POINTER_MOVE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processMoveEvents: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_MOVE, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_MOVE, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        if (this.topOnly) break;
                    }
                    if (!aborted) this.emit(Events.POINTER_MOVE, pointer, currentlyOver);
                    return total;
                },
                /**
     * An internal method that handles a mouse wheel event.
     *
     * @method Phaser.Input.InputPlugin#processWheelEvent
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_WHEEL
     * @fires Phaser.Input.Events#GAMEOBJECT_WHEEL
     * @fires Phaser.Input.Events#POINTER_WHEEL
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processWheelEvent: function(pointer) {
                    var total = 0;
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    var dx = pointer.deltaX;
                    var dy = pointer.deltaY;
                    var dz = pointer.deltaZ;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        total++;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_WHEEL, pointer, dx, dy, dz, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_WHEEL, pointer, gameObject, dx, dy, dz, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    if (!aborted) this.emit(Events.POINTER_WHEEL, pointer, currentlyOver, dx, dy, dz);
                    return total;
                },
                /**
     * An internal method that handles the Pointer over events.
     * This is called when a touch input hits the canvas, having previously been off of it.
     *
     * @method Phaser.Input.InputPlugin#processOverEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var totalInteracted = 0;
                    var total = currentlyOver.length;
                    var justOver = [];
                    if (total > 0) {
                        var manager = this.manager;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        var aborted = false;
                        for(var i = 0; i < total; i++){
                            var gameObject = currentlyOver[i];
                            if (!gameObject.input) continue;
                            justOver.push(gameObject);
                            manager.setCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OVER, pointer, justOver);
                    }
                    //  Then sort it into display list order
                    this._over[pointer.id] = justOver;
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer out events.
     * This is called when a touch input leaves the canvas, as it can never be 'over' in this case.
     *
     * @method Phaser.Input.InputPlugin#processOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.18.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOutEvents: function(pointer) {
                    var previouslyOver = this._over[pointer.id];
                    var totalInteracted = 0;
                    var total = previouslyOver.length;
                    if (total > 0) {
                        var manager = this.manager;
                        var _eventData = this._eventData;
                        var _eventContainer = this._eventContainer;
                        _eventData.cancelled = false;
                        var aborted = false;
                        this.sortGameObjects(previouslyOver, pointer);
                        for(var i = 0; i < total; i++){
                            var gameObject = previouslyOver[i];
                            //  Call onOut for everything in the previouslyOver array
                            gameObject = previouslyOver[i];
                            if (!gameObject.input) continue;
                            manager.resetCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            if (!aborted) this.emit(Events.POINTER_OUT, pointer, previouslyOver);
                        }
                        this._over[pointer.id] = [];
                    }
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer over and out events.
     *
     * @method Phaser.Input.InputPlugin#processOverOutEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_OVER
     * @fires Phaser.Input.Events#POINTER_OVER
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_OUT
     * @fires Phaser.Input.Events#GAMEOBJECT_OUT
     * @fires Phaser.Input.Events#POINTER_OUT
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processOverOutEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var i;
                    var gameObject;
                    var justOut = [];
                    var justOver = [];
                    var stillOver = [];
                    var previouslyOver = this._over[pointer.id];
                    var currentlyDragging = this._drag[pointer.id];
                    var manager = this.manager;
                    //  Go through all objects the pointer was previously over, and see if it still is.
                    //  Splits the previouslyOver array into two parts: justOut and stillOver
                    for(i = 0; i < previouslyOver.length; i++){
                        gameObject = previouslyOver[i];
                        if (currentlyOver.indexOf(gameObject) === -1 && currentlyDragging.indexOf(gameObject) === -1) //  Not in the currentlyOver array, so must be outside of this object now
                        justOut.push(gameObject);
                        else //  In the currentlyOver array
                        stillOver.push(gameObject);
                    }
                    //  Go through all objects the pointer is currently over (the hit test results)
                    //  and if not in the previouslyOver array we know it's a new entry, so add to justOver
                    for(i = 0; i < currentlyOver.length; i++){
                        gameObject = currentlyOver[i];
                        //  Is this newly over?
                        if (previouslyOver.indexOf(gameObject) === -1) justOver.push(gameObject);
                    }
                    //  By this point the arrays are filled, so now we can process what happened...
                    //  Process the Just Out objects
                    var total = justOut.length;
                    var totalInteracted = 0;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    if (total > 0) {
                        this.sortGameObjects(justOut, pointer);
                        //  Call onOut for everything in the justOut array
                        for(i = 0; i < total; i++){
                            gameObject = justOut[i];
                            if (!gameObject.input) continue;
                            //  Reset cursor before we emit the event, in case they want to change it during the event
                            manager.resetCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OUT, pointer, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OUT, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OUT, pointer, justOut);
                    }
                    //  Process the Just Over objects
                    total = justOver.length;
                    _eventData.cancelled = false;
                    aborted = false;
                    if (total > 0) {
                        this.sortGameObjects(justOver, pointer);
                        //  Call onOver for everything in the justOver array
                        for(i = 0; i < total; i++){
                            gameObject = justOver[i];
                            if (!gameObject.input) continue;
                            //  Set cursor before we emit the event, in case they want to change it during the event
                            manager.setCursor(gameObject.input);
                            gameObject.emit(Events.GAMEOBJECT_POINTER_OVER, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                            totalInteracted++;
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                            this.emit(Events.GAMEOBJECT_OVER, pointer, gameObject, _eventContainer);
                            if (_eventData.cancelled || !gameObject.input) {
                                aborted = true;
                                break;
                            }
                        }
                        if (!aborted) this.emit(Events.POINTER_OVER, pointer, justOver);
                    }
                    //  Add the contents of justOver to the previously over array
                    previouslyOver = stillOver.concat(justOver);
                    //  Then sort it into display list order
                    this._over[pointer.id] = this.sortGameObjects(previouslyOver, pointer);
                    return totalInteracted;
                },
                /**
     * An internal method that handles the Pointer up events.
     *
     * @method Phaser.Input.InputPlugin#processUpEvents
     * @private
     * @fires Phaser.Input.Events#GAMEOBJECT_POINTER_UP
     * @fires Phaser.Input.Events#GAMEOBJECT_UP
     * @fires Phaser.Input.Events#POINTER_UP
     * @fires Phaser.Input.Events#POINTER_UP_OUTSIDE
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
     *
     * @return {number} The total number of objects interacted with.
     */ processUpEvents: function(pointer) {
                    var currentlyOver = this._temp;
                    var _eventData = this._eventData;
                    var _eventContainer = this._eventContainer;
                    _eventData.cancelled = false;
                    var aborted = false;
                    //  Go through all objects the pointer was over and fire their events / callbacks
                    for(var i = 0; i < currentlyOver.length; i++){
                        var gameObject = currentlyOver[i];
                        if (!gameObject.input) continue;
                        gameObject.emit(Events.GAMEOBJECT_POINTER_UP, pointer, gameObject.input.localX, gameObject.input.localY, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                        this.emit(Events.GAMEOBJECT_UP, pointer, gameObject, _eventContainer);
                        if (_eventData.cancelled || !gameObject.input) {
                            aborted = true;
                            break;
                        }
                    }
                    //  If they released outside the canvas, but pressed down inside it, we'll still dispatch the event.
                    if (!aborted && this.manager) {
                        if (pointer.upElement === this.manager.game.canvas) this.emit(Events.POINTER_UP, pointer, currentlyOver);
                        else this.emit(Events.POINTER_UP_OUTSIDE, pointer);
                    }
                    return currentlyOver.length;
                },
                /**
     * Queues a Game Object for insertion into this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForInsertion
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
     *
     * @return {this} This InputPlugin object.
     */ queueForInsertion: function(child) {
                    if (this._pendingInsertion.indexOf(child) === -1 && this._list.indexOf(child) === -1) this._pendingInsertion.push(child);
                    return this;
                },
                /**
     * Queues a Game Object for removal from this Input Plugin on the next update.
     *
     * @method Phaser.Input.InputPlugin#queueForRemoval
     * @private
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
     *
     * @return {this} This InputPlugin object.
     */ queueForRemoval: function(child) {
                    this._pendingRemoval.push(child);
                    return this;
                },
                /**
     * Sets the draggable state of the given array of Game Objects.
     *
     * They can either be set to be draggable, or can have their draggable state removed by passing `false`.
     *
     * A Game Object will not fire drag events unless it has been specifically enabled for drag.
     *
     * @method Phaser.Input.InputPlugin#setDraggable
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to change the draggable state on.
     * @param {boolean} [value=true] - Set to `true` if the Game Objects should be made draggable, `false` if they should be unset.
     *
     * @return {this} This InputPlugin object.
     */ setDraggable: function(gameObjects, value) {
                    if (value === undefined) value = true;
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        gameObject.input.draggable = value;
                        var index = this._draggable.indexOf(gameObject);
                        if (value && index === -1) this._draggable.push(gameObject);
                        else if (!value && index > -1) this._draggable.splice(index, 1);
                    }
                    return this;
                },
                /**
     * Creates a function that can be passed to `setInteractive`, `enable` or `setHitArea` that will handle
     * pixel-perfect input detection on an Image or Sprite based Game Object, or any custom class that extends them.
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 1.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect());
     * ```
     *
     * The following will create a sprite that is clickable on any pixel that has an alpha value >= 150.
     *
     * ```javascript
     * this.add.sprite(x, y, key).setInteractive(this.input.makePixelPerfect(150));
     * ```
     *
     * Once you have made an Interactive Object pixel perfect it impacts all input related events for it: down, up,
     * dragstart, drag, etc.
     *
     * As a pointer interacts with the Game Object it will constantly poll the texture, extracting a single pixel from
     * the given coordinates and checking its color values. This is an expensive process, so should only be enabled on
     * Game Objects that really need it.
     *
     * You cannot make non-texture based Game Objects pixel perfect. So this will not work on Graphics, BitmapText,
     * Render Textures, Text, Tilemaps, Containers or Particles.
     *
     * @method Phaser.Input.InputPlugin#makePixelPerfect
     * @since 3.10.0
     *
     * @param {number} [alphaTolerance=1] - The alpha level that the pixel should be above to be included as a successful interaction.
     *
     * @return {function} A Pixel Perfect Handler for use as a hitArea shape callback.
     */ makePixelPerfect: function(alphaTolerance) {
                    if (alphaTolerance === undefined) alphaTolerance = 1;
                    var textureManager = this.systems.textures;
                    return CreatePixelPerfectHandler(textureManager, alphaTolerance);
                },
                /**
     * Sets the hit area for the given array of Game Objects.
     *
     * A hit area is typically one of the geometric shapes Phaser provides, such as a `Phaser.Geom.Rectangle`
     * or `Phaser.Geom.Circle`. However, it can be any object as long as it works with the provided callback.
     *
     * If no hit area is provided a Rectangle is created based on the size of the Game Object, if possible
     * to calculate.
     *
     * The hit area callback is the function that takes an `x` and `y` coordinate and returns a boolean if
     * those values fall within the area of the shape or not. All of the Phaser geometry objects provide this,
     * such as `Phaser.Geom.Rectangle.Contains`.
     *
     * @method Phaser.Input.InputPlugin#setHitArea
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set the hit area on.
     * @param {(Phaser.Types.Input.InputConfiguration|any)} [hitArea] - Either an input configuration object, or a geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
     * @param {Phaser.Types.Input.HitAreaCallback} [hitAreaCallback] - The 'contains' function to invoke to check if the pointer is within the hit area.
     *
     * @return {this} This InputPlugin object.
     */ setHitArea: function(gameObjects, hitArea, hitAreaCallback) {
                    if (hitArea === undefined) return this.setHitAreaFromTexture(gameObjects);
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    var draggable = false;
                    var dropZone = false;
                    var cursor = false;
                    var useHandCursor = false;
                    var pixelPerfect = false;
                    var customHitArea = true;
                    //  Config object?
                    if (IsPlainObject(hitArea)) {
                        var config = hitArea;
                        hitArea = GetFastValue(config, 'hitArea', null);
                        hitAreaCallback = GetFastValue(config, 'hitAreaCallback', null);
                        draggable = GetFastValue(config, 'draggable', false);
                        dropZone = GetFastValue(config, 'dropZone', false);
                        cursor = GetFastValue(config, 'cursor', false);
                        useHandCursor = GetFastValue(config, 'useHandCursor', false);
                        pixelPerfect = GetFastValue(config, 'pixelPerfect', false);
                        var alphaTolerance = GetFastValue(config, 'alphaTolerance', 1);
                        if (pixelPerfect) {
                            hitArea = {};
                            hitAreaCallback = this.makePixelPerfect(alphaTolerance);
                        }
                        //  Still no hitArea or callback?
                        if (!hitArea || !hitAreaCallback) {
                            this.setHitAreaFromTexture(gameObjects);
                            customHitArea = false;
                        }
                    } else if (typeof hitArea === 'function' && !hitAreaCallback) {
                        hitAreaCallback = hitArea;
                        hitArea = {};
                    }
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        if (pixelPerfect && gameObject.type === 'Container') {
                            console.warn('Cannot pixelPerfect test a Container. Use a custom callback.');
                            continue;
                        }
                        var io = !gameObject.input ? CreateInteractiveObject(gameObject, hitArea, hitAreaCallback) : gameObject.input;
                        io.customHitArea = customHitArea;
                        io.dropZone = dropZone;
                        io.cursor = useHandCursor ? 'pointer' : cursor;
                        gameObject.input = io;
                        if (draggable) this.setDraggable(gameObject);
                        this.queueForInsertion(gameObject);
                    }
                    return this;
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Circle` shape, using
     * the given coordinates and radius to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaCircle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a circle hit area.
     * @param {number} x - The center of the circle.
     * @param {number} y - The center of the circle.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Circle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaCircle: function(gameObjects, x, y, radius, callback) {
                    if (callback === undefined) callback = CircleContains;
                    var shape = new Circle(x, y, radius);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Ellipse` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaEllipse
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {number} x - The center of the ellipse.
     * @param {number} y - The center of the ellipse.
     * @param {number} width - The width of the ellipse.
     * @param {number} height - The height of the ellipse.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Ellipse.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaEllipse: function(gameObjects, x, y, width, height, callback) {
                    if (callback === undefined) callback = EllipseContains;
                    var shape = new Ellipse(x, y, width, height);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the Game Objects texture frame to define the position and size of the hit area.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaFromTexture
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaFromTexture: function(gameObjects, callback) {
                    if (callback === undefined) callback = RectangleContains;
                    if (!Array.isArray(gameObjects)) gameObjects = [
                        gameObjects
                    ];
                    for(var i = 0; i < gameObjects.length; i++){
                        var gameObject = gameObjects[i];
                        var frame = gameObject.frame;
                        var width = 0;
                        var height = 0;
                        if (gameObject.width) {
                            width = gameObject.width;
                            height = gameObject.height;
                        } else if (frame) {
                            width = frame.realWidth;
                            height = frame.realHeight;
                        }
                        if (gameObject.type === 'Container' && (width === 0 || height === 0)) {
                            console.warn('Container.setInteractive must specify a Shape or call setSize() first');
                            continue;
                        }
                        if (width !== 0 && height !== 0) {
                            gameObject.input = CreateInteractiveObject(gameObject, new Rectangle(0, 0, width, height), callback);
                            this.queueForInsertion(gameObject);
                        }
                    }
                    return this;
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Rectangle` shape, using
     * the given coordinates and dimensions to control its position and size.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaRectangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a rectangular hit area.
     * @param {number} x - The top-left of the rectangle.
     * @param {number} y - The top-left of the rectangle.
     * @param {number} width - The width of the rectangle.
     * @param {number} height - The height of the rectangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaRectangle: function(gameObjects, x, y, width, height, callback) {
                    if (callback === undefined) callback = RectangleContains;
                    var shape = new Rectangle(x, y, width, height);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Sets the hit area for an array of Game Objects to be a `Phaser.Geom.Triangle` shape, using
     * the given coordinates to control the position of its points.
     *
     * @method Phaser.Input.InputPlugin#setHitAreaTriangle
     * @since 3.0.0
     *
     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a  triangular hit area.
     * @param {number} x1 - The x coordinate of the first point of the triangle.
     * @param {number} y1 - The y coordinate of the first point of the triangle.
     * @param {number} x2 - The x coordinate of the second point of the triangle.
     * @param {number} y2 - The y coordinate of the second point of the triangle.
     * @param {number} x3 - The x coordinate of the third point of the triangle.
     * @param {number} y3 - The y coordinate of the third point of the triangle.
     * @param {Phaser.Types.Input.HitAreaCallback} [callback] - The hit area callback. If undefined it uses Triangle.Contains.
     *
     * @return {this} This InputPlugin object.
     */ setHitAreaTriangle: function(gameObjects, x1, y1, x2, y2, x3, y3, callback) {
                    if (callback === undefined) callback = TriangleContains;
                    var shape = new Triangle(x1, y1, x2, y2, x3, y3);
                    return this.setHitArea(gameObjects, shape, callback);
                },
                /**
     * Creates an Input Debug Shape for the given Game Object.
     *
     * The Game Object must have _already_ been enabled for input prior to calling this method.
     *
     * This is intended to assist you during development and debugging.
     *
     * Debug Shapes can only be created for Game Objects that are using standard Phaser Geometry for input,
     * including: Circle, Ellipse, Line, Polygon, Rectangle and Triangle.
     *
     * Game Objects that are using their automatic hit areas are using Rectangles by default, so will also work.
     *
     * The Debug Shape is created and added to the display list and is then kept in sync with the Game Object
     * it is connected with. Should you need to modify it yourself, such as to hide it, you can access it via
     * the Game Object property: `GameObject.input.hitAreaDebug`.
     *
     * Calling this method on a Game Object that already has a Debug Shape will first destroy the old shape,
     * before creating a new one. If you wish to remove the Debug Shape entirely, you should call the
     * method `InputPlugin.removeDebug`.
     *
     * Note that the debug shape will only show the outline of the input area. If the input test is using a
     * pixel perfect check, for example, then this is not displayed. If you are using a custom shape, that
     * doesn't extend one of the base Phaser Geometry objects, as your hit area, then this method will not
     * work.
     *
     * @method Phaser.Input.InputPlugin#enableDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to create the input debug shape for.
     * @param {number} [color=0x00ff00] - The outline color of the debug shape.
     *
     * @return {this} This Input Plugin.
     */ enableDebug: function(gameObject, color) {
                    if (color === undefined) color = 0x00ff00;
                    var input = gameObject.input;
                    if (!input || !input.hitArea) return this;
                    var shape = input.hitArea;
                    var shapeType = shape.type;
                    var debug = input.hitAreaDebug;
                    var factory = this.systems.add;
                    var updateList = this.systems.updateList;
                    if (debug) {
                        updateList.remove(debug);
                        debug.destroy();
                        debug = null;
                    }
                    var offsetx = 0;
                    var offsety = 0;
                    switch(shapeType){
                        case GEOM_CONST.CIRCLE:
                            debug = factory.arc(0, 0, shape.radius);
                            offsetx = shape.x - shape.radius;
                            offsety = shape.y - shape.radius;
                            break;
                        case GEOM_CONST.ELLIPSE:
                            debug = factory.ellipse(0, 0, shape.width, shape.height);
                            offsetx = shape.x - shape.width / 2;
                            offsety = shape.y - shape.height / 2;
                            break;
                        case GEOM_CONST.LINE:
                            debug = factory.line(0, 0, shape.x1, shape.y1, shape.x2, shape.y2);
                            break;
                        case GEOM_CONST.POLYGON:
                            debug = factory.polygon(0, 0, shape.points);
                            break;
                        case GEOM_CONST.RECTANGLE:
                            debug = factory.rectangle(0, 0, shape.width, shape.height);
                            offsetx = shape.x;
                            offsety = shape.y;
                            break;
                        case GEOM_CONST.TRIANGLE:
                            debug = factory.triangle(0, 0, shape.x1, shape.y1, shape.x2, shape.y2, shape.x3, shape.y3);
                            break;
                    }
                    if (debug) {
                        debug.isFilled = false;
                        debug.preUpdate = function() {
                            debug.setStrokeStyle(1 / gameObject.scale, color);
                            debug.setDisplayOrigin(gameObject.displayOriginX, gameObject.displayOriginY);
                            var x = gameObject.x;
                            var y = gameObject.y;
                            var rotation = gameObject.rotation;
                            var scaleX = gameObject.scaleX;
                            var scaleY = gameObject.scaleY;
                            if (gameObject.parentContainer) {
                                var matrix = gameObject.getWorldTransformMatrix();
                                x = matrix.tx;
                                y = matrix.ty;
                                rotation = matrix.rotation;
                                scaleX = matrix.scaleX;
                                scaleY = matrix.scaleY;
                            }
                            debug.setRotation(rotation);
                            debug.setScale(scaleX, scaleY);
                            debug.setPosition(x + offsetx, y + offsety);
                            debug.setScrollFactor(gameObject.scrollFactorX, gameObject.scrollFactorY);
                            debug.setDepth(gameObject.depth);
                        };
                        updateList.add(debug);
                        input.hitAreaDebug = debug;
                    }
                    return this;
                },
                /**
     * Removes an Input Debug Shape from the given Game Object.
     *
     * The shape is destroyed immediately and the `hitAreaDebug` property is set to `null`.
     *
     * @method Phaser.Input.InputPlugin#removeDebug
     * @since 3.19.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to remove the input debug shape from.
     *
     * @return {this} This Input Plugin.
     */ removeDebug: function(gameObject) {
                    var input = gameObject.input;
                    if (input && input.hitAreaDebug) {
                        var debug = input.hitAreaDebug;
                        this.systems.updateList.remove(debug);
                        debug.destroy();
                        input.hitAreaDebug = null;
                    }
                    return this;
                },
                /**
     * Sets the Pointers to always poll.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it, regardless if the Pointer has actually moved or not.
     *
     * You should enable this if you want objects in your game to fire over / out events, and the objects
     * are constantly moving, but the pointer may not have. Polling every frame has additional computation
     * costs, especially if there are a large number of interactive objects in your game.
     *
     * @method Phaser.Input.InputPlugin#setPollAlways
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollAlways: function() {
                    return this.setPollRate(0);
                },
                /**
     * Sets the Pointers to only poll when they are moved or updated.
     *
     * When a pointer is polled it runs a hit test to see which Game Objects are currently below it,
     * or being interacted with it.
     *
     * @method Phaser.Input.InputPlugin#setPollOnMove
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ setPollOnMove: function() {
                    return this.setPollRate(-1);
                },
                /**
     * Sets the poll rate value. This is the amount of time that should have elapsed before a pointer
     * will be polled again. See the `setPollAlways` and `setPollOnMove` methods.
     *
     * @method Phaser.Input.InputPlugin#setPollRate
     * @since 3.0.0
     *
     * @param {number} value - The amount of time, in ms, that should elapsed before re-polling the pointers.
     *
     * @return {this} This InputPlugin object.
     */ setPollRate: function(value) {
                    this.pollRate = value;
                    this._pollTimer = 0;
                    return this;
                },
                /**
     * When set to `true` the global Input Manager will emulate DOM behavior by only emitting events from
     * the top-most Scene in the Scene List. By default, if a Scene receives an input event it will then stop the event
     * from flowing down to any Scenes below it in the Scene list. To disable this behavior call this method with `false`.
     *
     * @method Phaser.Input.InputPlugin#setGlobalTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - Set to `true` to stop processing input events on the Scene that receives it, or `false` to let the event continue down the Scene list.
     *
     * @return {this} This InputPlugin object.
     */ setGlobalTopOnly: function(value) {
                    this.manager.globalTopOnly = value;
                    return this;
                },
                /**
     * When set to `true` this Input Plugin will emulate DOM behavior by only emitting events from
     * the top-most Game Objects in the Display List.
     *
     * If set to `false` it will emit events from all Game Objects below a Pointer, not just the top one.
     *
     * @method Phaser.Input.InputPlugin#setTopOnly
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to only include the top-most Game Object, or `false` to include all Game Objects in a hit test.
     *
     * @return {this} This InputPlugin object.
     */ setTopOnly: function(value) {
                    this.topOnly = value;
                    return this;
                },
                /**
     * Given an array of Game Objects and a Pointer, sort the array and return it,
     * so that the objects are in render order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortGameObjects
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     * @param {Phaser.Input.Pointer} pointer - The Pointer to check against the Game Objects.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortGameObjects: function(gameObjects, pointer) {
                    if (gameObjects.length < 2) return gameObjects;
                    var list = pointer.camera.renderList;
                    return gameObjects.sort(function(childA, childB) {
                        return list.indexOf(childB) - list.indexOf(childA);
                    });
                },
                /**
     * Given an array of Drop Zone Game Objects, sort the array and return it,
     * so that the objects are in depth index order with the lowest at the bottom.
     *
     * @method Phaser.Input.InputPlugin#sortDropZones
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject[]} gameObjects - An array of Game Objects to be sorted.
     *
     * @return {Phaser.GameObjects.GameObject[]} The sorted array of Game Objects.
     */ sortDropZones: function(gameObjects) {
                    if (gameObjects.length < 2) return gameObjects;
                    this.scene.sys.depthSort();
                    return gameObjects.sort(this.sortDropZoneHandler.bind(this));
                },
                /**
     * Return the child lowest down the display list (with the smallest index)
     * Will iterate through all parent containers, if present.
     *
     * Prior to version 3.52.0 this method was called `sortHandlerGO`.
     *
     * @method Phaser.Input.InputPlugin#sortDropZoneHandler
     * @private
     * @since 3.52.0
     *
     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object to compare.
     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object to compare.
     *
     * @return {number} Returns either a negative or positive integer, or zero if they match.
     */ sortDropZoneHandler: function(childA, childB) {
                    if (!childA.parentContainer && !childB.parentContainer) //  Quick bail out when neither child has a container
                    return this.displayList.getIndex(childB) - this.displayList.getIndex(childA);
                    else if (childA.parentContainer === childB.parentContainer) //  Quick bail out when both children have the same container
                    return childB.parentContainer.getIndex(childB) - childA.parentContainer.getIndex(childA);
                    else if (childA.parentContainer === childB) //  Quick bail out when childA is a child of childB
                    return -1;
                    else if (childB.parentContainer === childA) //  Quick bail out when childA is a child of childB
                    return 1;
                    else {
                        //  Container index check
                        var listA = childA.getIndexList();
                        var listB = childB.getIndexList();
                        var len = Math.min(listA.length, listB.length);
                        for(var i = 0; i < len; i++){
                            var indexA = listA[i];
                            var indexB = listB[i];
                            if (indexA === indexB) continue;
                            else //  Non-matching parents, so return
                            return indexB - indexA;
                        }
                        return listB.length - listA.length;
                    }
                    //  Technically this shouldn't happen, but ...
                    // eslint-disable-next-line no-unreachable
                    return 0;
                },
                /**
     * This method should be called from within an input event handler, such as `pointerdown`.
     *
     * When called, it stops the Input Manager from allowing _this specific event_ to be processed by any other Scene
     * not yet handled in the scene list.
     *
     * @method Phaser.Input.InputPlugin#stopPropagation
     * @since 3.0.0
     *
     * @return {this} This InputPlugin object.
     */ stopPropagation: function() {
                    this.manager._tempSkip = true;
                    return this;
                },
                /**
     * Adds new Pointer objects to the Input Manager.
     *
     * By default Phaser creates 2 pointer objects: `mousePointer` and `pointer1`.
     *
     * You can create more either by calling this method, or by setting the `input.activePointers` property
     * in the Game Config, up to a maximum of 10 pointers.
     *
     * The first 10 pointers are available via the `InputPlugin.pointerX` properties, once they have been added
     * via this method.
     *
     * @method Phaser.Input.InputPlugin#addPointer
     * @since 3.10.0
     *
     * @param {number} [quantity=1] The number of new Pointers to create. A maximum of 10 is allowed in total.
     *
     * @return {Phaser.Input.Pointer[]} An array containing all of the new Pointer objects that were created.
     */ addPointer: function(quantity) {
                    return this.manager.addPointer(quantity);
                },
                /**
     * Tells the Input system to set a custom cursor.
     *
     * This cursor will be the default cursor used when interacting with the game canvas.
     *
     * If an Interactive Object also sets a custom cursor, this is the cursor that is reset after its use.
     *
     * Any valid CSS cursor value is allowed, including paths to image files, i.e.:
     *
     * ```javascript
     * this.input.setDefaultCursor('url(assets/cursors/sword.cur), pointer');
     * ```
     *
     * Please read about the differences between browsers when it comes to the file formats and sizes they support:
     *
     * https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
     * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_User_Interface/Using_URL_values_for_the_cursor_property
     *
     * It's up to you to pick a suitable cursor format that works across the range of browsers you need to support.
     *
     * @method Phaser.Input.InputPlugin#setDefaultCursor
     * @since 3.10.0
     *
     * @param {string} cursor - The CSS to be used when setting the default cursor.
     *
     * @return {this} This Input instance.
     */ setDefaultCursor: function(cursor) {
                    this.manager.setDefaultCursor(cursor);
                    return this;
                },
                /**
     * The Scene that owns this plugin is transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionIn
     * @private
     * @since 3.5.0
     */ transitionIn: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                /**
     * The Scene that owns this plugin has finished transitioning in.
     *
     * @method Phaser.Input.InputPlugin#transitionComplete
     * @private
     * @since 3.5.0
     */ transitionComplete: function() {
                    if (!this.settings.transitionAllowInput) this.enabled = true;
                },
                /**
     * The Scene that owns this plugin is transitioning out.
     *
     * @method Phaser.Input.InputPlugin#transitionOut
     * @private
     * @since 3.5.0
     */ transitionOut: function() {
                    this.enabled = this.settings.transitionAllowInput;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Input.InputPlugin#shutdown
     * @fires Phaser.Input.Events#SHUTDOWN
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.SHUTDOWN);
                    this._temp.length = 0;
                    this._list.length = 0;
                    this._draggable.length = 0;
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                    this._dragState.length = 0;
                    for(var i = 0; i < 10; i++){
                        this._drag[i] = [];
                        this._over[i] = [];
                    }
                    this.removeAllListeners();
                    var manager = this.manager;
                    manager.canvas.style.cursor = manager.defaultCursor;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.TRANSITION_START, this.transitionIn, this);
                    eventEmitter.off(SceneEvents.TRANSITION_OUT, this.transitionOut, this);
                    eventEmitter.off(SceneEvents.TRANSITION_COMPLETE, this.transitionComplete, this);
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    manager.events.off(Events.GAME_OUT, this.onGameOut, this);
                    manager.events.off(Events.GAME_OVER, this.onGameOver, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Input.InputPlugin#destroy
     * @fires Phaser.Input.Events#DESTROY
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    //  Registered input plugins listen for this
                    this.pluginEvents.emit(Events.DESTROY);
                    this.pluginEvents.removeAllListeners();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.cameras = null;
                    this.manager = null;
                    this.events = null;
                    this.mouse = null;
                },
                /**
     * The x coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#x
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.manager.activePointer.x;
                    }
                },
                /**
     * The y coordinates of the ActivePointer based on the first camera in the camera list.
     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
     *
     * @name Phaser.Input.InputPlugin#y
     * @type {number}
     * @readonly
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.manager.activePointer.y;
                    }
                },
                /**
     * Are any mouse or touch pointers currently over the game canvas?
     *
     * @name Phaser.Input.InputPlugin#isOver
     * @type {boolean}
     * @readonly
     * @since 3.16.0
     */ isOver: {
                    get: function() {
                        return this.manager.isOver;
                    }
                },
                /**
     * The mouse has its own unique Pointer object, which you can reference directly if making a _desktop specific game_.
     * If you are supporting both desktop and touch devices then do not use this property, instead use `activePointer`
     * which will always map to the most recently interacted pointer.
     *
     * @name Phaser.Input.InputPlugin#mousePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ mousePointer: {
                    get: function() {
                        return this.manager.mousePointer;
                    }
                },
                /**
     * The current active input Pointer.
     *
     * @name Phaser.Input.InputPlugin#activePointer
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.0.0
     */ activePointer: {
                    get: function() {
                        return this.manager.activePointer;
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer1
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer1: {
                    get: function() {
                        return this.manager.pointers[1];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer2
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer2: {
                    get: function() {
                        return this.manager.pointers[2];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer3
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer3: {
                    get: function() {
                        return this.manager.pointers[3];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer4
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer4: {
                    get: function() {
                        return this.manager.pointers[4];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer5
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer5: {
                    get: function() {
                        return this.manager.pointers[5];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer6
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer6: {
                    get: function() {
                        return this.manager.pointers[6];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer7
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer7: {
                    get: function() {
                        return this.manager.pointers[7];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer8
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer8: {
                    get: function() {
                        return this.manager.pointers[8];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer9
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer9: {
                    get: function() {
                        return this.manager.pointers[9];
                    }
                },
                /**
     * A touch-based Pointer object.
     * This will be `undefined` by default unless you add a new Pointer using `addPointer`.
     *
     * @name Phaser.Input.InputPlugin#pointer10
     * @type {Phaser.Input.Pointer}
     * @readonly
     * @since 3.10.0
     */ pointer10: {
                    get: function() {
                        return this.manager.pointers[10];
                    }
                }
            });
            PluginCache.register('InputPlugin', InputPlugin, 'input');
            module1.exports = InputPlugin;
        /***/ },
        /* 1316 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Keyboard
 */ module1.exports = {
                Events: __webpack_require__(152),
                KeyboardManager: __webpack_require__(404),
                KeyboardPlugin: __webpack_require__(1324),
                Key: __webpack_require__(506),
                KeyCodes: __webpack_require__(141),
                KeyCombo: __webpack_require__(507),
                AdvanceKeyCombo: __webpack_require__(509),
                ProcessKeyCombo: __webpack_require__(508),
                ResetKeyCombo: __webpack_require__(510),
                JustDown: __webpack_require__(1326),
                JustUp: __webpack_require__(1327),
                DownDuration: __webpack_require__(1328),
                UpDuration: __webpack_require__(1329)
            };
        /***/ },
        /* 1317 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Down Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 * 
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keydown', listener)`.
 * 
 * You can also listen for a specific key being pressed. See [Keyboard.Events.KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_DOWN} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 * 
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_DOWN
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = 'keydown';
        /***/ },
        /* 1318 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Global Key Up Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 * 
 * Listen to this event from within a Scene using: `this.input.keyboard.on('keyup', listener)`.
 * 
 * You can also listen for a specific key being released. See [Keyboard.Events.KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:KEY_UP} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#ANY_KEY_UP
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = 'keyup';
        /***/ },
        /* 1319 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Combo Match Event.
 * 
 * This event is dispatched by the Keyboard Plugin when a [Key Combo]{@link Phaser.Input.Keyboard.KeyCombo} is matched.
 * 
 * Listen for this event from the Key Plugin after a combo has been created:
 * 
 * ```javascript
 * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
 *
 * this.input.keyboard.on('keycombomatch', function (event) {
 *     console.log('Konami Code entered!');
 * });
 * ```
 *
 * @event Phaser.Input.Keyboard.Events#COMBO_MATCH
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.KeyCombo} keycombo - The Key Combo object that was matched.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event of the final key in the combo. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'keycombomatch';
        /***/ },
        /* 1320 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 * 
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is pressed.
 * 
 * Listen for this event from the Key object instance directly:
 * 
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * 
 * spaceBar.on('down', listener)
 * ```
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 *
 * @event Phaser.Input.Keyboard.Events#DOWN
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was pressed.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'down';
        /***/ },
        /* 1321 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Down Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is pressed down.
 * 
 * Unlike the `ANY_KEY_DOWN` event, this one has a special dynamic event name. For example, to listen for the `A` key being pressed
 * use the following from within a Scene: `this.input.keyboard.on('keydown-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar: 
 * `this.input.keyboard.on('keydown-SPACE', listener)`.
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_DOWN} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.DOWN]{@linkcode Phaser.Input.Keyboard.Events#event:DOWN} for details.
 * 
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * Read [this article on ghosting]{@link http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/} for details.
 *
 * Also, please be aware that some browser extensions can disable or override Phaser keyboard handling.
 * For example, the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * There are others. So, please check your extensions if you find you have specific keys that don't work.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_DOWN
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was pressed, any modifiers, etc.
 */ module1.exports = 'keydown-';
        /***/ },
        /* 1322 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 * 
 * This event is dispatched by the Keyboard Plugin when any key on the keyboard is released.
 * 
 * Unlike the `ANY_KEY_UP` event, this one has a special dynamic event name. For example, to listen for the `A` key being released
 * use the following from within a Scene: `this.input.keyboard.on('keyup-A', listener)`. You can replace the `-A` part of the event
 * name with any valid [Key Code string]{@link Phaser.Input.Keyboard.KeyCodes}. For example, this will listen for the space bar: 
 * `this.input.keyboard.on('keyup-SPACE', listener)`.
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 * 
 * Finally, you can create Key objects, which you can also listen for events from. See [Keyboard.Events.UP]{@linkcode Phaser.Input.Keyboard.Events#event:UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#KEY_UP
 * @since 3.0.0
 * 
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about the key that was released, any modifiers, etc.
 */ module1.exports = 'keyup-';
        /***/ },
        /* 1323 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Key Up Event.
 * 
 * This event is dispatched by a [Key]{@link Phaser.Input.Keyboard.Key} object when it is released.
 * 
 * Listen for this event from the Key object instance directly:
 * 
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * 
 * spaceBar.on('up', listener)
 * ```
 * 
 * You can also create a generic 'global' listener. See [Keyboard.Events.ANY_KEY_UP]{@linkcode Phaser.Input.Keyboard.Events#event:ANY_KEY_UP} for details.
 *
 * @event Phaser.Input.Keyboard.Events#UP
 * @since 3.0.0
 * 
 * @param {Phaser.Input.Keyboard.Key} key - The Key object that was released.
 * @param {KeyboardEvent} event - The native DOM Keyboard Event. You can inspect this to learn more about any modifiers, etc.
 */ module1.exports = 'up';
        /***/ },
        /* 1324 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(152);
            var GameEvents = __webpack_require__(22);
            var GetValue = __webpack_require__(6);
            var InputEvents = __webpack_require__(49);
            var InputPluginCache = __webpack_require__(151);
            var Key = __webpack_require__(506);
            var KeyCodes = __webpack_require__(141);
            var KeyCombo = __webpack_require__(507);
            var KeyMap = __webpack_require__(1325);
            var SceneEvents = __webpack_require__(21);
            var SnapFloor = __webpack_require__(76);
            /**
 * @classdesc
 * The Keyboard Plugin is an input plugin that belongs to the Scene-owned Input system.
 *
 * Its role is to listen for native DOM Keyboard Events and then process them.
 *
 * You do not need to create this class directly, the Input system will create an instance of it automatically.
 *
 * You can access it from within a Scene using `this.input.keyboard`. For example, you can do:
 *
 * ```javascript
 * this.input.keyboard.on('keydown', callback, context);
 * ```
 *
 * Or, to listen for a specific key:
 *
 * ```javascript
 * this.input.keyboard.on('keydown-A', callback, context);
 * ```
 *
 * You can also create Key objects, which you can then poll in your game loop:
 *
 * ```javascript
 * var spaceBar = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);
 * ```
 *
 * If you have multiple parallel Scenes, each trying to get keyboard input, be sure to disable capture on them to stop them from
 * stealing input from another Scene in the list. You can do this with `this.input.keyboard.enabled = false` within the
 * Scene to stop all input, or `this.input.keyboard.preventDefault = false` to stop a Scene halting input on another Scene.
 *
 * _Note_: Many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
 * See http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/ for more details.
 *
 * Also please be aware that certain browser extensions can disable or override Phaser keyboard handling.
 * For example the Chrome extension vimium is known to disable Phaser from using the D key, while EverNote disables the backtick key.
 * And there are others. So, please check your extensions before opening Phaser issues about keys that don't work.
 *
 * @class KeyboardPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Input.Keyboard
 * @constructor
 * @since 3.10.0
 *
 * @param {Phaser.Input.InputPlugin} sceneInputPlugin - A reference to the Scene Input Plugin that the KeyboardPlugin belongs to.
 */ var KeyboardPlugin = new Class({
                Extends: EventEmitter,
                initialize: function KeyboardPlugin(sceneInputPlugin) {
                    EventEmitter.call(this);
                    /**
         * A reference to the core game, so we can listen for visibility events.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#game
         * @type {Phaser.Game}
         * @since 3.16.0
         */ this.game = sceneInputPlugin.systems.game;
                    /**
         * A reference to the Scene that this Input Plugin is responsible for.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.10.0
         */ this.scene = sceneInputPlugin.scene;
                    /**
         * A reference to the Scene Systems Settings.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.10.0
         */ this.settings = this.scene.sys.settings;
                    /**
         * A reference to the Scene Input Plugin that created this Keyboard Plugin.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#sceneInputPlugin
         * @type {Phaser.Input.InputPlugin}
         * @since 3.10.0
         */ this.sceneInputPlugin = sceneInputPlugin;
                    /**
         * A reference to the global Keyboard Manager.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#manager
         * @type {Phaser.Input.InputPlugin}
         * @since 3.16.0
         */ this.manager = sceneInputPlugin.manager.keyboard;
                    /**
         * A boolean that controls if this Keyboard Plugin is enabled or not.
         * Can be toggled on the fly.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#enabled
         * @type {boolean}
         * @default true
         * @since 3.10.0
         */ this.enabled = true;
                    /**
         * An array of Key objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#keys
         * @type {Phaser.Input.Keyboard.Key[]}
         * @since 3.10.0
         */ this.keys = [];
                    /**
         * An array of KeyCombo objects to process.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#combos
         * @type {Phaser.Input.Keyboard.KeyCombo[]}
         * @since 3.10.0
         */ this.combos = [];
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevCode
         * @type {string}
         * @private
         * @since 3.50.0
         */ this.prevCode = null;
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevTime
         * @type {number}
         * @private
         * @since 3.50.0
         */ this.prevTime = 0;
                    /**
         * Internal repeat key flag.
         *
         * @name Phaser.Input.Keyboard.KeyboardPlugin#prevType
         * @type {string}
         * @private
         * @since 3.50.1
         */ this.prevType = null;
                    sceneInputPlugin.pluginEvents.once(InputEvents.BOOT, this.boot, this);
                    sceneInputPlugin.pluginEvents.on(InputEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#boot
     * @private
     * @since 3.10.0
     */ boot: function() {
                    var settings = this.settings.input;
                    this.enabled = GetValue(settings, 'keyboard', true);
                    var captures = GetValue(settings, 'keyboard.capture', null);
                    if (captures) this.addCaptures(captures);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#start
     * @private
     * @since 3.10.0
     */ start: function() {
                    this.sceneInputPlugin.manager.events.on(InputEvents.MANAGER_PROCESS, this.update, this);
                    this.sceneInputPlugin.pluginEvents.once(InputEvents.SHUTDOWN, this.shutdown, this);
                    this.game.events.on(GameEvents.BLUR, this.resetKeys, this);
                    this.scene.sys.events.on(SceneEvents.PAUSE, this.resetKeys, this);
                    this.scene.sys.events.on(SceneEvents.SLEEP, this.resetKeys, this);
                },
                /**
     * Checks to see if both this plugin and the Scene to which it belongs is active.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#isActive
     * @since 3.10.0
     *
     * @return {boolean} `true` if the plugin and the Scene it belongs to is active.
     */ isActive: function() {
                    return this.enabled && this.scene.sys.isActive();
                },
                /**
     * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
     * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
     *
     * This `addCapture` method enables consuming keyboard events for specific keys, so they don't bubble up the browser
     * and cause the default behaviors.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to say prevent
     * the SPACE BAR from triggering a page scroll, then it will prevent it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.addCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.addCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.addCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to enable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ addCapture: function(keycode) {
                    this.manager.addCapture(keycode);
                    return this;
                },
                /**
     * Removes an existing key capture.
     *
     * Please note that keyboard captures are global. This means that if you call this method from within a Scene, to remove
     * the capture of a key, then it will remove it for any Scene in your game, not just the calling one.
     *
     * You can pass a single key code value:
     *
     * ```javascript
     * this.input.keyboard.removeCapture(62);
     * ```
     *
     * An array of key codes:
     *
     * ```javascript
     * this.input.keyboard.removeCapture([ 62, 63, 64 ]);
     * ```
     *
     * Or, a comma-delimited string:
     *
     * ```javascript
     * this.input.keyboard.removeCapture('W,S,A,D');
     * ```
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * You can also provide an array mixing both strings and key code integers.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeCapture
     * @since 3.16.0
     *
     * @param {(string|number|number[]|any[])} keycode - The Key Codes to disable event capture for.
     *
     * @return {this} This KeyboardPlugin object.
     */ removeCapture: function(keycode) {
                    this.manager.removeCapture(keycode);
                    return this;
                },
                /**
     * Returns an array that contains all of the keyboard captures currently enabled.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#getCaptures
     * @since 3.16.0
     *
     * @return {number[]} An array of all the currently capturing key codes.
     */ getCaptures: function() {
                    return this.manager.captures;
                },
                /**
     * Allows Phaser to prevent any key captures you may have defined from bubbling up the browser.
     * You can use this to re-enable event capturing if you had paused it via `disableGlobalCapture`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#enableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ enableGlobalCapture: function() {
                    this.manager.preventDefault = true;
                    return this;
                },
                /**
     * Disables Phaser from preventing any key captures you may have defined, without actually removing them.
     * You can use this to temporarily disable event capturing if, for example, you swap to a DOM element.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#disableGlobalCapture
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ disableGlobalCapture: function() {
                    this.manager.preventDefault = false;
                    return this;
                },
                /**
     * Removes all keyboard captures.
     *
     * Note that this is a global change. It will clear all event captures across your game, not just for this specific Scene.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#clearCaptures
     * @since 3.16.0
     *
     * @return {this} This KeyboardPlugin object.
     */ clearCaptures: function() {
                    this.manager.clearCaptures();
                    return this;
                },
                /**
     * Creates and returns an object containing 4 hotkeys for Up, Down, Left and Right, and also Space Bar and shift.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCursorKeys
     * @since 3.10.0
     *
     * @return {Phaser.Types.Input.Keyboard.CursorKeys} An object containing the properties: `up`, `down`, `left`, `right`, `space` and `shift`.
     */ createCursorKeys: function() {
                    return this.addKeys({
                        up: KeyCodes.UP,
                        down: KeyCodes.DOWN,
                        left: KeyCodes.LEFT,
                        right: KeyCodes.RIGHT,
                        space: KeyCodes.SPACE,
                        shift: KeyCodes.SHIFT
                    });
                },
                /**
     * A practical way to create an object containing user selected hotkeys.
     *
     * For example:
     *
     * ```javascript
     * this.input.keyboard.addKeys({ 'up': Phaser.Input.Keyboard.KeyCodes.W, 'down': Phaser.Input.Keyboard.KeyCodes.S });
     * ```
     *
     * would return an object containing the properties (`up` and `down`) mapped to W and S {@link Phaser.Input.Keyboard.Key} objects.
     *
     * You can also pass in a comma-separated string:
     *
     * ```javascript
     * this.input.keyboard.addKeys('W,S,A,D');
     * ```
     *
     * Which will return an object with the properties W, S, A and D mapped to the relevant Key objects.
     *
     * To use non-alpha numeric keys, use a string, such as 'UP', 'SPACE' or 'LEFT'.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKeys
     * @since 3.10.0
     *
     * @param {(object|string)} keys - An object containing Key Codes, or a comma-separated string.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {object} An object containing Key objects mapped to the input properties.
     */ addKeys: function(keys, enableCapture, emitOnRepeat) {
                    if (enableCapture === undefined) enableCapture = true;
                    if (emitOnRepeat === undefined) emitOnRepeat = false;
                    var output = {};
                    if (typeof keys === 'string') {
                        keys = keys.split(',');
                        for(var i = 0; i < keys.length; i++){
                            var currentKey = keys[i].trim();
                            if (currentKey) output[currentKey] = this.addKey(currentKey, enableCapture, emitOnRepeat);
                        }
                    } else for(var key in keys)output[key] = this.addKey(keys[key], enableCapture, emitOnRepeat);
                    return output;
                },
                /**
     * Adds a Key object to this Keyboard Plugin.
     *
     * The given argument can be either an existing Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * If a Key object is given, and one already exists matching the same key code, the existing one is replaced with the new one.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#addKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [enableCapture=true] - Automatically call `preventDefault` on the native DOM browser event for the key codes being added.
     * @param {boolean} [emitOnRepeat=false] - Controls if the Key will continuously emit a 'down' event while being held down (true), or emit the event just once (false, the default).
     *
     * @return {Phaser.Input.Keyboard.Key} The newly created Key object, or a reference to it if it already existed in the keys array.
     */ addKey: function(key, enableCapture, emitOnRepeat) {
                    if (enableCapture === undefined) enableCapture = true;
                    if (emitOnRepeat === undefined) emitOnRepeat = false;
                    var keys = this.keys;
                    if (key instanceof Key) {
                        var idx = keys.indexOf(key);
                        if (idx > -1) keys[idx] = key;
                        else keys[key.keyCode] = key;
                        if (enableCapture) this.addCapture(key.keyCode);
                        key.setEmitOnRepeat(emitOnRepeat);
                        return key;
                    }
                    if (typeof key === 'string') key = KeyCodes[key.toUpperCase()];
                    if (!keys[key]) {
                        keys[key] = new Key(this, key);
                        if (enableCapture) this.addCapture(key);
                        keys[key].setEmitOnRepeat(emitOnRepeat);
                    }
                    return keys[key];
                },
                /**
     * Removes a Key object from this Keyboard Plugin.
     *
     * The given argument can be either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeKey
     * @since 3.10.0
     *
     * @param {(Phaser.Input.Keyboard.Key|string|number)} key - Either a Key object, a string, such as `A` or `SPACE`, or a key code value.
     * @param {boolean} [destroy=false] - Call `Key.destroy` on the removed Key object?
     *
     * @return {this} This KeyboardPlugin object.
     */ removeKey: function(key, destroy) {
                    if (destroy === undefined) destroy = false;
                    var keys = this.keys;
                    var ref;
                    if (key instanceof Key) {
                        var idx = keys.indexOf(key);
                        if (idx > -1) {
                            ref = this.keys[idx];
                            this.keys[idx] = undefined;
                        }
                    } else if (typeof key === 'string') key = KeyCodes[key.toUpperCase()];
                    if (keys[key]) {
                        ref = keys[key];
                        keys[key] = undefined;
                    }
                    if (ref) {
                        ref.plugin = null;
                        if (destroy) ref.destroy();
                    }
                    return this;
                },
                /**
     * Removes all Key objects created by _this_ Keyboard Plugin.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#removeAllKeys
     * @since 3.24.0
     *
     * @param {boolean} [destroy=false] - Call `Key.destroy` on each removed Key object?
     *
     * @return {this} This KeyboardPlugin object.
     */ removeAllKeys: function(destroy) {
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        if (key) {
                            keys[i] = undefined;
                            if (destroy) key.destroy();
                        }
                    }
                    return this;
                },
                /**
     * Creates a new KeyCombo.
     *
     * A KeyCombo will listen for a specific string of keys from the Keyboard, and when it receives them
     * it will emit a `keycombomatch` event from this Keyboard Plugin.
     *
     * The keys to be listened for can be defined as:
     *
     * A string (i.e. 'ATARI')
     * An array of either integers (key codes) or strings, or a mixture of both
     * An array of objects (such as Key objects) with a public 'keyCode' property
     *
     * For example, to listen for the Konami code (up, up, down, down, left, right, left, right, b, a, enter)
     * you could pass the following array of key codes:
     *
     * ```javascript
     * this.input.keyboard.createCombo([ 38, 38, 40, 40, 37, 39, 37, 39, 66, 65, 13 ], { resetOnMatch: true });
     *
     * this.input.keyboard.on('keycombomatch', function (event) {
     *     console.log('Konami Code entered!');
     * });
     * ```
     *
     * Or, to listen for the user entering the word PHASER:
     *
     * ```javascript
     * this.input.keyboard.createCombo('PHASER');
     * ```
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#createCombo
     * @since 3.10.0
     *
     * @param {(string|number[]|object[])} keys - The keys that comprise this combo.
     * @param {Phaser.Types.Input.Keyboard.KeyComboConfig} [config] - A Key Combo configuration object.
     *
     * @return {Phaser.Input.Keyboard.KeyCombo} The new KeyCombo object.
     */ createCombo: function(keys, config) {
                    return new KeyCombo(this, keys, config);
                },
                /**
     * Checks if the given Key object is currently being held down.
     *
     * The difference between this method and checking the `Key.isDown` property directly is that you can provide
     * a duration to this method. For example, if you wanted a key press to fire a bullet, but you only wanted
     * it to be able to fire every 100ms, then you can call this method with a `duration` of 100 and it
     * will only return `true` every 100ms.
     *
     * If the Keyboard Plugin has been disabled, this method will always return `false`.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#checkDown
     * @since 3.11.0
     *
     * @param {Phaser.Input.Keyboard.Key} key - A Key object.
     * @param {number} [duration=0] - The duration which must have elapsed before this Key is considered as being down.
     *
     * @return {boolean} `true` if the Key is down within the duration specified, otherwise `false`.
     */ checkDown: function(key, duration) {
                    if (duration === undefined) duration = 0;
                    if (this.enabled && key.isDown) {
                        var t = SnapFloor(this.time - key.timeDown, duration);
                        if (t > key._tick) {
                            key._tick = t;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Internal update handler called by the Input Plugin, which is in turn invoked by the Game step.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#update
     * @private
     * @since 3.10.0
     */ update: function() {
                    var queue = this.manager.queue;
                    var len = queue.length;
                    if (!this.isActive() || len === 0) return;
                    var keys = this.keys;
                    //  Process the event queue, dispatching all of the events that have stored up
                    for(var i = 0; i < len; i++){
                        var event = queue[i];
                        var code = event.keyCode;
                        var key = keys[code];
                        var repeat = false;
                        //  Override the default functions (it's too late for the browser to use them anyway, so we may as well)
                        if (event.cancelled === undefined) {
                            //  Event allowed to flow across all handlers in this Scene, and any other Scene in the Scene list
                            event.cancelled = 0;
                            //  Won't reach any more local (Scene level) handlers
                            event.stopImmediatePropagation = function() {
                                event.cancelled = 1;
                            };
                            //  Won't reach any more handlers in any Scene further down the Scene list
                            event.stopPropagation = function() {
                                event.cancelled = -1;
                            };
                        }
                        if (event.cancelled === -1) continue;
                        //  Duplicate event bailout
                        if (code === this.prevCode && event.timeStamp === this.prevTime && event.type === this.prevType) continue;
                        this.prevCode = code;
                        this.prevTime = event.timeStamp;
                        this.prevType = event.type;
                        if (event.type === 'keydown') {
                            //  Key specific callback first
                            if (key) {
                                repeat = key.isDown;
                                key.onDown(event);
                            }
                            if (!event.cancelled && (!key || !repeat)) {
                                if (KeyMap[code]) this.emit(Events.KEY_DOWN + KeyMap[code], event);
                                if (!event.cancelled) this.emit(Events.ANY_KEY_DOWN, event);
                            }
                        } else {
                            //  Key specific callback first
                            if (key) key.onUp(event);
                            if (!event.cancelled) {
                                if (KeyMap[code]) this.emit(Events.KEY_UP + KeyMap[code], event);
                                if (!event.cancelled) this.emit(Events.ANY_KEY_UP, event);
                            }
                        }
                        //  Reset the cancel state for other Scenes to use
                        if (event.cancelled === 1) event.cancelled = 0;
                    }
                },
                /**
     * Resets all Key objects created by _this_ Keyboard Plugin back to their default un-pressed states.
     * This can only reset keys created via the `addKey`, `addKeys` or `createCursorKeys` methods.
     * If you have created a Key object directly you'll need to reset it yourself.
     *
     * This method is called automatically when the Keyboard Plugin shuts down, but can be
     * invoked directly at any time you require.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#resetKeys
     * @since 3.15.0
     *
     * @return {this} This KeyboardPlugin object.
     */ resetKeys: function() {
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                    if (keys[i]) keys[i].reset();
                    return this;
                },
                /**
     * Shuts this Keyboard Plugin down. This performs the following tasks:
     *
     * 1 - Resets all keys created by this Keyboard plugin.
     * 2 - Stops and removes the keyboard event listeners.
     * 3 - Clears out any pending requests in the queue, without processing them.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#shutdown
     * @private
     * @since 3.10.0
     */ shutdown: function() {
                    this.resetKeys();
                    this.sceneInputPlugin.manager.events.off(InputEvents.MANAGER_PROCESS, this.update, this);
                    this.game.events.off(GameEvents.BLUR, this.resetKeys);
                    this.scene.sys.events.off(SceneEvents.PAUSE, this.resetKeys, this);
                    this.scene.sys.events.off(SceneEvents.SLEEP, this.resetKeys, this);
                    this.removeAllListeners();
                    this.queue = [];
                },
                /**
     * Destroys this Keyboard Plugin instance and all references it holds, plus clears out local arrays.
     *
     * @method Phaser.Input.Keyboard.KeyboardPlugin#destroy
     * @private
     * @since 3.10.0
     */ destroy: function() {
                    this.shutdown();
                    var keys = this.keys;
                    for(var i = 0; i < keys.length; i++)//  Because it's a sparsely populated array
                    if (keys[i]) keys[i].destroy();
                    this.keys = [];
                    this.combos = [];
                    this.queue = [];
                    this.scene = null;
                    this.settings = null;
                    this.sceneInputPlugin = null;
                    this.manager = null;
                },
                /**
     * Internal time value.
     *
     * @name Phaser.Input.Keyboard.KeyboardPlugin#time
     * @type {number}
     * @private
     * @since 3.11.0
     */ time: {
                    get: function() {
                        return this.sceneInputPlugin.manager.time;
                    }
                }
            });
            /**
 * An instance of the Keyboard Plugin class, if enabled via the `input.keyboard` Scene or Game Config property.
 * Use this to create Key objects and listen for keyboard specific events.
 *
 * @name Phaser.Input.InputPlugin#keyboard
 * @type {?Phaser.Input.Keyboard.KeyboardPlugin}
 * @since 3.10.0
 */ InputPluginCache.register('KeyboardPlugin', KeyboardPlugin, 'keyboard', 'keyboard', 'inputKeyboard');
            module1.exports = KeyboardPlugin;
        /***/ },
        /* 1325 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var KeyCodes = __webpack_require__(141);
            var KeyMap = {};
            for(var key in KeyCodes)KeyMap[KeyCodes[key]] = key;
            module1.exports = KeyMap;
        /***/ },
        /* 1326 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justDown value allows you to test if this Key has just been pressed down or not.
 * 
 * When you check this value it will return `true` if the Key is down, otherwise `false`.
 * 
 * You can only call justDown once per key press. It will only return `true` once, until the Key is released and pressed down again.
 * This allows you to use it in situations where you want to check if this key is down without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustDown
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just down or not.
 *
 * @return {boolean} `true` if the Key was just pressed, otherwise `false`.
 */ var JustDown = function(key) {
                if (key._justDown) {
                    key._justDown = false;
                    return true;
                } else return false;
            };
            module1.exports = JustDown;
        /***/ },
        /* 1327 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The justUp value allows you to test if this Key has just been released or not.
 * 
 * When you check this value it will return `true` if the Key is up, otherwise `false`.
 * 
 * You can only call JustUp once per key release. It will only return `true` once, until the Key is pressed down and released again.
 * This allows you to use it in situations where you want to check if this key is up without using an event, such as in a core game loop.
 *
 * @function Phaser.Input.Keyboard.JustUp
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key to check to see if it's just up or not.
 *
 * @return {boolean} `true` if the Key was just released, otherwise `false`.
 */ var JustUp = function(key) {
                if (key._justUp) {
                    key._justUp = false;
                    return true;
                } else return false;
            };
            module1.exports = JustUp;
        /***/ },
        /* 1328 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was pressed down within the `duration` value given, based on the current
 * game clock time. Or `false` if it either isn't down, or was pressed down longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.DownDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been pressed down.
 *
 * @return {boolean} `true` if the Key was pressed down within `duration` ms ago, otherwise `false`.
 */ var DownDuration = function(key, duration) {
                if (duration === undefined) duration = 50;
                var current = key.plugin.game.loop.time - key.timeDown;
                return key.isDown && current < duration;
            };
            module1.exports = DownDuration;
        /***/ },
        /* 1329 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Returns `true` if the Key was released within the `duration` value given, based on the current
 * game clock time. Or returns `false` if it either isn't up, or was released longer ago than the given duration.
 *
 * @function Phaser.Input.Keyboard.UpDuration
 * @since 3.0.0
 *
 * @param {Phaser.Input.Keyboard.Key} key - The Key object to test.
 * @param {number} [duration=50] - The duration, in ms, within which the key must have been released.
 *
 * @return {boolean} `true` if the Key was released within `duration` ms ago, otherwise `false`.
 */ var UpDuration = function(key, duration) {
                if (duration === undefined) duration = 50;
                var current = key.plugin.game.loop.time - key.timeUp;
                return key.isUp && current < duration;
            };
            module1.exports = UpDuration;
        /***/ },
        /* 1330 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Mouse
 */ /* eslint-disable */ module1.exports = {
                MouseManager: __webpack_require__(405)
            };
        /* eslint-enable */ /***/ },
        /* 1331 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Input.Touch
 */ /* eslint-disable */ module1.exports = {
                TouchManager: __webpack_require__(407)
            };
        /* eslint-enable */ /***/ },
        /* 1332 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(20);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Loader
 */ var Loader = {
                Events: __webpack_require__(91),
                FileTypes: __webpack_require__(1333),
                File: __webpack_require__(23),
                FileTypesManager: __webpack_require__(8),
                GetURL: __webpack_require__(153),
                LoaderPlugin: __webpack_require__(1359),
                MergeXHRSettings: __webpack_require__(237),
                MultiFile: __webpack_require__(47),
                XHRLoader: __webpack_require__(511),
                XHRSettings: __webpack_require__(154)
            };
            //   Merge in the consts
            Loader = Extend(false, Loader, CONST);
            module1.exports = Loader;
        /***/ },
        /* 1333 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Loader.FileTypes
 */ module1.exports = {
                AnimationJSONFile: __webpack_require__(1334),
                AsepriteFile: __webpack_require__(1335),
                AtlasJSONFile: __webpack_require__(1336),
                AtlasXMLFile: __webpack_require__(1337),
                AudioFile: __webpack_require__(512),
                AudioSpriteFile: __webpack_require__(1338),
                BinaryFile: __webpack_require__(1339),
                BitmapFontFile: __webpack_require__(1340),
                CSSFile: __webpack_require__(1341),
                GLSLFile: __webpack_require__(1342),
                HTML5AudioFile: __webpack_require__(513),
                HTMLFile: __webpack_require__(1343),
                HTMLTextureFile: __webpack_require__(1344),
                ImageFile: __webpack_require__(70),
                JSONFile: __webpack_require__(59),
                MultiAtlasFile: __webpack_require__(1345),
                MultiScriptFile: __webpack_require__(1346),
                OBJFile: __webpack_require__(1347),
                PackFile: __webpack_require__(1348),
                PluginFile: __webpack_require__(1349),
                SceneFile: __webpack_require__(1350),
                ScenePluginFile: __webpack_require__(1351),
                ScriptFile: __webpack_require__(514),
                SpriteSheetFile: __webpack_require__(1352),
                SVGFile: __webpack_require__(1353),
                TextFile: __webpack_require__(239),
                TilemapCSVFile: __webpack_require__(1354),
                TilemapImpactFile: __webpack_require__(1355),
                TilemapJSONFile: __webpack_require__(1356),
                UnityAtlasFile: __webpack_require__(1357),
                VideoFile: __webpack_require__(1358),
                XMLFile: __webpack_require__(238)
            };
        /***/ },
        /* 1334 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(59);
            var LoaderEvents = __webpack_require__(91);
            /**
 * @classdesc
 * A single Animation JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#animation method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#animation.
 *
 * @class AnimationJSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var AnimationJSONFile = new Class({
                Extends: JSONFile,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function AnimationJSONFile(loader, key, url, xhrSettings, dataKey) {
                    JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                    this.type = 'animationJSON';
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    //  We need to hook into this event:
                    this.loader.once(LoaderEvents.POST_PROCESS, this.onLoadComplete, this);
                    //  But the rest is the same as a normal JSON file
                    JSONFile.prototype.onProcess.call(this);
                },
                /**
     * Called at the end of the load process, after the Loader has finished all files in its queue.
     *
     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onLoadComplete
     * @since 3.7.0
     */ onLoadComplete: function() {
                    this.loader.systems.anims.fromJSON(this.data);
                }
            });
            /**
 * Adds an Animation JSON Data file, or array of Animation JSON files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.animation({
 *     key: 'baddieAnims',
 *     url: 'files/BaddieAnims.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.JSONFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be passed to the global Animation Managers `fromJSON` method.
 * This will parse all of the JSON data and create animation data from it. This process happens at the very end
 * of the Loader, once every other file in the load queue has finished. The reason for this is to allow you to load
 * both animation data and the images it relies upon in the same load call.
 *
 * Once the animation data has been parsed you will be able to play animations using that data.
 * Please see the Animation Manager `fromJSON` method for more details about the format and playback.
 *
 * You can also access the raw animation data from its Cache using its key:
 *
 * ```javascript
 * this.load.animation('baddieAnims', 'files/BaddieAnims.json');
 * // and later in your game ...
 * var data = this.cache.json.get('baddieAnims');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And if you only wanted to create animations from the `boss` data, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#animation
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.JSONFileConfig|Phaser.Types.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the Animation JSON file loads only this property will be stored in the Cache and used to create animation data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('animation', function(key, url, dataKey, xhrSettings) {
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new AnimationJSONFile(this, key[i]));
                else this.addFile(new AnimationJSONFile(this, key, url, xhrSettings, dataKey));
                return this;
            });
            module1.exports = AnimationJSONFile;
        /***/ },
        /* 1335 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(59);
            var MultiFile = __webpack_require__(47);
            /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AsepriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AsepriteFile = new Class({
                Extends: MultiFile,
                initialize: function AsepriteFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'textureURL'),
                            extension: GetFastValue(config, 'textureExtension', 'png'),
                            normalMap: GetFastValue(config, 'normalMap'),
                            xhrSettings: GetFastValue(config, 'textureXhrSettings')
                        });
                        data = new JSONFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'atlasURL'),
                            extension: GetFastValue(config, 'atlasExtension', 'json'),
                            xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, 'atlasjson', key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, 'atlasjson', key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AsepriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var json = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                        json.addToCache();
                        this.complete = true;
                    }
                }
            });
            /**
 * Aseprite is a powerful animated sprite editor and pixel art tool.
 *
 * You can find more details at https://www.aseprite.org/
 *
 * Adds a JSON based Aseprite Animation, or array of animations, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.aseprite('gladiator', 'images/Gladiator.png', 'images/Gladiator.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * To export a compatible JSON file in Aseprite, please do the following:
 *
 * 1. Go to "File - Export Sprite Sheet"
 *
 * 2. On the **Layout** tab:
 * 2a. Set the "Sheet type" to "Packed"
 * 2b. Set the "Constraints" to "None"
 * 2c. Check the "Merge Duplicates" checkbox
 *
 * 3. On the **Sprite** tab:
 * 3a. Set "Layers" to "Visible layers"
 * 3b. Set "Frames" to "All frames", unless you only wish to export a sub-set of tags
 *
 * 4. On the **Borders** tab:
 * 4a. Check the "Trim Sprite" and "Trim Cells" options
 * 4b. Ensure "Border Padding", "Spacing" and "Inner Padding" are all > 0 (1 is usually enough)
 *
 * 5. On the **Output** tab:
 * 5a. Check "Output File", give your image a name and make sure you choose "png files" as the file type
 * 5b. Check "JSON Data" and give your json file a name
 * 5c. The JSON Data type can be either a Hash or Array, Phaser doesn't mind.
 * 5d. Make sure "Tags" is checked in the Meta options
 * 5e. In the "Item Filename" input box, make sure it says just "{frame}" and nothing more.
 *
 * 6. Click export
 *
 * This was tested with Aseprite 1.2.25.
 *
 * This will export a png and json file which you can load using the Aseprite Loader, i.e.:
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.aseprite({
 *     key: 'gladiator',
 *     textureURL: 'images/Gladiator.png',
 *     atlasURL: 'images/Gladiator.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AsepriteFileConfig` for more details.
 *
 * Instead of passing a URL for the JSON data you can also pass in a well formed JSON object instead.
 *
 * Once loaded, you can call this method from within a Scene with the 'atlas' key:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin');
 * ```
 *
 * Any animations defined in the JSON will now be available to use in Phaser and you play them
 * via their Tag name. For example, if you have an animation called 'War Cry' on your Aseprite timeline,
 * you can play it in Phaser using that Tag name:
 *
 * ```javascript
 * this.add.sprite(400, 300).play('War Cry');
 * ```
 *
 * When calling this method you can optionally provide an array of tag names, and only those animations
 * will be created. For example:
 *
 * ```javascript
 * this.anims.createFromAseprite('paladin', [ 'step', 'War Cry', 'Magnum Break' ]);
 * ```
 *
 * This will only create the 3 animations defined. Note that the tag names are case-sensitive.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Aseprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#aseprite
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AsepriteFileConfig|Phaser.Types.Loader.FileTypes.AsepriteFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('aseprite', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AsepriteFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AsepriteFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AsepriteFile;
        /***/ },
        /* 1336 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(59);
            var MultiFile = __webpack_require__(47);
            /**
 * @classdesc
 * A single JSON based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
 *
 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
 *
 * @class AtlasJSONFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasJSONFile = new Class({
                Extends: MultiFile,
                initialize: function AtlasJSONFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'textureURL'),
                            extension: GetFastValue(config, 'textureExtension', 'png'),
                            normalMap: GetFastValue(config, 'normalMap'),
                            xhrSettings: GetFastValue(config, 'textureXhrSettings')
                        });
                        data = new JSONFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'atlasURL'),
                            extension: GetFastValue(config, 'atlasExtension', 'json'),
                            xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, 'atlasjson', key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, 'atlasjson', key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var json = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
                        json.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a JSON based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file, using either the JSON Hash or JSON Array format.
 * These files are created by software such as Texture Packer, Shoebox and Adobe Flash / Animate.
 * If you are using Texture Packer and have enabled multi-atlas support, then please use the Phaser Multi Atlas loader
 * instead of this one.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.json');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.json'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig|Phaser.Types.Loader.FileTypes.AtlasJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {object|string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('atlas', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AtlasJSONFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AtlasJSONFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AtlasJSONFile;
        /***/ },
        /* 1337 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(47);
            var XMLFile = __webpack_require__(238);
            /**
 * @classdesc
 * A single XML based Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#atlasXML method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlasXML.
 *
 * @class AtlasXMLFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 */ var AtlasXMLFile = new Class({
                Extends: MultiFile,
                initialize: function AtlasXMLFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'textureURL'),
                            extension: GetFastValue(config, 'textureExtension', 'png'),
                            normalMap: GetFastValue(config, 'normalMap'),
                            xhrSettings: GetFastValue(config, 'textureXhrSettings')
                        });
                        data = new XMLFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'atlasURL'),
                            extension: GetFastValue(config, 'atlasExtension', 'xml'),
                            xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new XMLFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, 'atlasxml', key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, 'atlasxml', key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AtlasXMLFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var xml = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addAtlasXML(image.key, image.data, xml.data, normalMap);
                        xml.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an XML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in an XML file format.
 * These files are created by software such as Shoebox and Adobe Flash / Animate.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.atlasXML('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.atlasXML({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Atlas XML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#atlasXML
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig|Phaser.Types.Loader.FileTypes.AtlasXMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('atlasXML', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AtlasXMLFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new AtlasXMLFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = AtlasXMLFile;
        /***/ },
        /* 1338 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AudioFile = __webpack_require__(512);
            var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(59);
            var MultiFile = __webpack_require__(47);
            /**
 * @classdesc
 * An Audio Sprite File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#audioSprite method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audioSprite.
 *
 * @class AudioSpriteFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {{(string|string[])}} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 */ var AudioSpriteFile = new Class({
                Extends: MultiFile,
                initialize: function AudioSpriteFile(loader, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        jsonURL = GetFastValue(config, 'jsonURL');
                        audioURL = GetFastValue(config, 'audioURL');
                        audioConfig = GetFastValue(config, 'audioConfig');
                        audioXhrSettings = GetFastValue(config, 'audioXhrSettings');
                        jsonXhrSettings = GetFastValue(config, 'jsonXhrSettings');
                    }
                    var data;
                    //  No url? then we're going to do a json load and parse it from that
                    if (!audioURL) {
                        data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                        MultiFile.call(this, loader, 'audiosprite', key, [
                            data
                        ]);
                        this.config.resourceLoad = true;
                        this.config.audioConfig = audioConfig;
                        this.config.audioXhrSettings = audioXhrSettings;
                    } else {
                        var audio = AudioFile.create(loader, key, audioURL, audioConfig, audioXhrSettings);
                        if (audio) {
                            data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
                            MultiFile.call(this, loader, 'audiosprite', key, [
                                audio,
                                data
                            ]);
                            this.config.resourceLoad = false;
                        }
                    }
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) {
                        this.pending--;
                        if (this.config.resourceLoad && file.type === 'json' && file.data.hasOwnProperty('resources')) {
                            //  Inspect the data for the files to now load
                            var urls = file.data.resources;
                            var audioConfig = GetFastValue(this.config, 'audioConfig');
                            var audioXhrSettings = GetFastValue(this.config, 'audioXhrSettings');
                            var audio = AudioFile.create(this.loader, file.key, urls, audioConfig, audioXhrSettings);
                            if (audio) {
                                this.addToMultiFile(audio);
                                this.loader.addFile(audio);
                            }
                        }
                    }
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.AudioSpriteFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var fileA = this.files[0];
                        var fileB = this.files[1];
                        fileA.addToCache();
                        fileB.addToCache();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a JSON based Audio Sprite, or array of audio sprites, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json', [
 *         'kyobi.ogg',
 *         'kyobi.mp3',
 *         'kyobi.m4a'
 *     ]);
 * }
 * ```
 *
 * Audio Sprites are a combination of audio files and a JSON configuration.
 * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
 *
 * If the JSON file includes a 'resource' object then you can let Phaser parse it and load the audio
 * files automatically based on its content. To do this exclude the audio URLs from the load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.audioSprite('kyobi', 'kyobi.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Audio Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.audioSprite({
 *     key: 'kyobi',
 *     jsonURL: 'audio/Kyobi.json',
 *     audioURL: [
 *         'audio/Kyobi.ogg',
 *         'audio/Kyobi.mp3',
 *         'audio/Kyobi.m4a'
 *     ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig` for more details.
 *
 * Instead of passing a URL for the audio JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the audio has finished loading you can use it create an Audio Sprite by referencing its key:
 *
 * ```javascript
 * this.load.audioSprite('kyobi', 'kyobi.json');
 * // and later in your game ...
 * var music = this.sound.addAudioSprite('kyobi');
 * music.play('title');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support.
 *
 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
 *
 * Note: The ability to load this type of file will only be available if the Audio Sprite File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#audioSprite
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig|Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig[])} key - The key to use for this file, or a file configuration object, or an array of objects.
 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
 * @param {(string|string[])} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
 * @param {any} [audioConfig] - The audio configuration options.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader.
 */ FileTypesManager.register('audioSprite', function(key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings) {
                var game = this.systems.game;
                var gameAudioConfig = game.config.audio;
                var deviceAudio = game.device.audio;
                if (gameAudioConfig && gameAudioConfig.noAudio || !deviceAudio.webAudio && !deviceAudio.audioData) //  Sounds are disabled, so skip loading audio
                return this;
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new AudioSpriteFile(this, key[i]);
                    if (multifile.files) this.addFile(multifile.files);
                }
                else {
                    multifile = new AudioSpriteFile(this, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings);
                    if (multifile.files) this.addFile(multifile.files);
                }
                return this;
            });
        /***/ },
        /* 1339 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Binary File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#binary method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#binary.
 *
 * @class BinaryFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 */ var BinaryFile = new Class({
                Extends: File,
                initialize: function BinaryFile(loader, key, url, xhrSettings, dataType) {
                    var extension = 'bin';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        dataType = GetFastValue(config, 'dataType', dataType);
                    }
                    var fileConfig = {
                        type: 'binary',
                        cache: loader.cacheManager.binary,
                        extension: extension,
                        responseType: 'arraybuffer',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            dataType: dataType
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.BinaryFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var ctor = this.config.dataType;
                    this.data = ctor ? new ctor(this.xhrLoader.response) : this.xhrLoader.response;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Binary file, or array of Binary files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.binary('doom', 'files/Doom.wad');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Binary Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Binary Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Binary Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.binary({
 *     key: 'doom',
 *     url: 'files/Doom.wad',
 *     dataType: Uint8Array
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BinaryFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.binary('doom', 'files/Doom.wad');
 * // and later in your game ...
 * var data = this.cache.binary.get('doom');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Data` the final key will be `LEVEL1.Data` and
 * this is what you would use to retrieve the text from the Binary Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "doom"
 * and no URL is given then the Loader will set the URL to be "doom.bin". It will always add `.bin` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Binary File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#binary
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BinaryFileConfig|Phaser.Types.Loader.FileTypes.BinaryFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('binary', function(key, url, dataType, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new BinaryFile(this, key[i]));
                else this.addFile(new BinaryFile(this, key, url, xhrSettings, dataType));
                return this;
            });
            module1.exports = BinaryFile;
        /***/ },
        /* 1340 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(47);
            var ParseXMLBitmapFont = __webpack_require__(209);
            var XMLFile = __webpack_require__(238);
            /**
 * @classdesc
 * A single Bitmap Font based File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#bitmapFont method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#bitmapFont.
 *
 * @class BitmapFontFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 */ var BitmapFontFile = new Class({
                Extends: MultiFile,
                initialize: function BitmapFontFile(loader, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'textureURL'),
                            extension: GetFastValue(config, 'textureExtension', 'png'),
                            normalMap: GetFastValue(config, 'normalMap'),
                            xhrSettings: GetFastValue(config, 'textureXhrSettings')
                        });
                        data = new XMLFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'fontDataURL'),
                            extension: GetFastValue(config, 'fontDataExtension', 'xml'),
                            xhrSettings: GetFastValue(config, 'fontDataXhrSettings')
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new XMLFile(loader, key, fontDataURL, fontDataXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, 'bitmapfont', key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, 'bitmapfont', key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.BitmapFontFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var xml = this.files[1];
                        image.addToCache();
                        xml.pendingDestroy();
                        var texture = image.cache.get(image.key);
                        var data = ParseXMLBitmapFont(xml.data, image.cache.getFrame(image.key), 0, 0, texture);
                        this.loader.cacheManager.bitmapFont.add(image.key, {
                            data: data,
                            texture: image.key,
                            frame: null
                        });
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an XML based Bitmap Font, or array of fonts, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:

 * ```javascript
 * function preload ()
 * {
 *     this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the font data to be provided in an XML file format.
 * These files are created by software such as the [Angelcode Bitmap Font Generator](http://www.angelcode.com/products/bmfont/),
 * [Littera](http://kvazars.com/littera/) or [Glyph Designer](https://71squared.com/glyphdesigner)
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.BitmapFontFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use key of it when creating a Bitmap Text Game Object:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
 * // and later in your game ...
 * this.add.bitmapText(x, y, 'goldenFont', 'Hello World');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use when creating a Bitmap Text object.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.bitmapFont('goldenFont', [ 'images/GoldFont.png', 'images/GoldFont-n.png' ], 'images/GoldFont.xml');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.bitmapFont({
 *     key: 'goldenFont',
 *     textureURL: 'images/GoldFont.png',
 *     normalMap: 'images/GoldFont-n.png',
 *     fontDataURL: 'images/GoldFont.xml'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Bitmap Font File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#bitmapFont
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig|Phaser.Types.Loader.FileTypes.BitmapFontFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('bitmapFont', function(key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new BitmapFontFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new BitmapFontFile(this, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = BitmapFontFile;
        /***/ },
        /* 1341 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single CSS File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#css method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#css.
 *
 * @class CSSFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var CSSFile = new Class({
                Extends: File,
                initialize: function CSSFile(loader, key, url, xhrSettings) {
                    var extension = 'css';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'script',
                        cache: false,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.CSSFile#onProcess
     * @since 3.17.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = document.createElement('style');
                    this.data.defer = false;
                    this.data.innerHTML = this.xhrLoader.responseText;
                    document.head.appendChild(this.data);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a CSS file, or array of CSS files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.css('headers', 'styles/headers.css');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.css({
 *     key: 'headers',
 *     url: 'styles/headers.css'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.CSSFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a style DOM element
 * via `document.createElement('style')`. It will have its `defer` property set to false and then the
 * resulting element will be appended to `document.head`. The CSS styles are then applied to the current document.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.css". It will always add `.css` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the CSS File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#css
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.CSSFileConfig|Phaser.Types.Loader.FileTypes.CSSFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.css`, i.e. if `key` was "alien" then the URL will be "alien.css".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('css', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new CSSFile(this, key[i]));
                else this.addFile(new CSSFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = CSSFile;
        /***/ },
        /* 1342 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var Shader = __webpack_require__(390);
            /**
 * @classdesc
 * A single GLSL File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#glsl method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#glsl.
 *
 * @class GLSLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var GLSLFile = new Class({
                Extends: File,
                initialize: function GLSLFile(loader, key, url, shaderType, xhrSettings) {
                    var extension = 'glsl';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        shaderType = GetFastValue(config, 'shaderType', 'fragment');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    } else if (shaderType === undefined) shaderType = 'fragment';
                    var fileConfig = {
                        type: 'glsl',
                        cache: loader.cacheManager.shader,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        config: {
                            shaderType: shaderType
                        },
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                    var data = this.data.split('\n');
                    //  Check to see if this is a shader bundle, or raw glsl file.
                    var block = this.extractBlock(data, 0);
                    if (block) while(block){
                        var key = this.getShaderName(block.header);
                        var shaderType = this.getShaderType(block.header);
                        var uniforms = this.getShaderUniforms(block.header);
                        var shaderSrc = block.shader;
                        if (this.cache.has(key)) {
                            var shader = this.cache.get(key);
                            if (shaderType === 'fragment') shader.fragmentSrc = shaderSrc;
                            else shader.vertexSrc = shaderSrc;
                            if (!shader.uniforms) shader.uniforms = uniforms;
                        } else if (shaderType === 'fragment') this.cache.add(key, new Shader(key, shaderSrc, '', uniforms));
                        else this.cache.add(key, new Shader(key, '', shaderSrc, uniforms));
                        block = this.extractBlock(data, block.offset);
                    }
                    else if (this.config.shaderType === 'fragment') //  Single shader
                    this.cache.add(this.key, new Shader(this.key, this.data));
                    else this.cache.add(this.key, new Shader(this.key, '', this.data));
                    this.pendingDestroy();
                },
                /**
     * Returns the name of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderName
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader name.
     */ getShaderName: function(headerSource) {
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 5) === 'name:') return line.substring(5).trim();
                    }
                    return this.key;
                },
                /**
     * Returns the type of the shader from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderType
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {string} The shader type. Either 'fragment' or 'vertex'.
     */ getShaderType: function(headerSource) {
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 5) === 'type:') return line.substring(5).trim();
                    }
                    return this.config.shaderType;
                },
                /**
     * Returns the shader uniforms from the header block.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#getShaderUniforms
     * @since 3.17.0
     *
     * @param {string[]} headerSource - The header data.
     *
     * @return {any} The shader uniforms object.
     */ getShaderUniforms: function(headerSource) {
                    var uniforms = {};
                    for(var i = 0; i < headerSource.length; i++){
                        var line = headerSource[i].trim();
                        if (line.substring(0, 8) === 'uniform.') {
                            var pos = line.indexOf(':');
                            if (pos) {
                                var key = line.substring(8, pos);
                                try {
                                    uniforms[key] = JSON.parse(line.substring(pos + 1));
                                } catch (e) {
                                    console.warn('Invalid uniform JSON: ' + key);
                                }
                            }
                        }
                    }
                    return uniforms;
                },
                /**
     * Processes the shader file and extracts the relevant data.
     *
     * @method Phaser.Loader.FileTypes.GLSLFile#extractBlock
     * @private
     * @since 3.17.0
     *
     * @param {string[]} data - The array of shader data to process.
     * @param {number} offset - The offset to start processing from.
     *
     * @return {any} The processed shader block, or null.
     */ extractBlock: function(data, offset) {
                    var headerStart = -1;
                    var headerEnd = -1;
                    var blockEnd = -1;
                    var headerOpen = false;
                    var captureSource = false;
                    var headerSource = [];
                    var shaderSource = [];
                    for(var i = offset; i < data.length; i++){
                        var line = data[i].trim();
                        if (line === '---') {
                            if (headerStart === -1) {
                                headerStart = i;
                                headerOpen = true;
                            } else if (headerOpen) {
                                headerEnd = i;
                                headerOpen = false;
                                captureSource = true;
                            } else {
                                //  We've hit another --- delimiter, break out
                                captureSource = false;
                                break;
                            }
                        } else if (headerOpen) headerSource.push(line);
                        else if (captureSource) {
                            shaderSource.push(line);
                            blockEnd = i;
                        }
                    }
                    if (!headerOpen && headerEnd !== -1) return {
                        header: headerSource,
                        shader: shaderSource.join('\n'),
                        offset: blockEnd
                    };
                    else return null;
                }
            });
            /**
 * Adds a GLSL file, or array of GLSL files, to the current load queue.
 * In Phaser 3 GLSL files are just plain Text files at the current moment in time.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Shader Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Shader Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Shader Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.glsl({
 *     key: 'plasma',
 *     shaderType: 'fragment',
 *     url: 'shaders/Plasma.glsl'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.GLSLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.glsl('plasma', 'shaders/Plasma.glsl');
 * // and later in your game ...
 * var data = this.cache.shader.get('plasma');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `FX.` and the key was `Plasma` the final key will be `FX.Plasma` and
 * this is what you would use to retrieve the text from the Shader Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "plasma"
 * and no URL is given then the Loader will set the URL to be "plasma.glsl". It will always add `.glsl` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the GLSL File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#glsl
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.GLSLFileConfig|Phaser.Types.Loader.FileTypes.GLSLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.glsl`, i.e. if `key` was "alien" then the URL will be "alien.glsl".
 * @param {string} [shaderType='fragment'] - The type of shader. Either `fragment` for a fragment shader, or `vertex` for a vertex shader. This is ignored if you load a shader bundle.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('glsl', function(key, url, shaderType, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new GLSLFile(this, key[i]));
                else this.addFile(new GLSLFile(this, key, url, shaderType, xhrSettings));
                return this;
            });
            module1.exports = GLSLFile;
        /***/ },
        /* 1343 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#html method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#html.
 *
 * @class HTMLFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLFile = new Class({
                Extends: File,
                initialize: function HTMLFile(loader, key, url, xhrSettings) {
                    var extension = 'html';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'text',
                        cache: loader.cacheManager.html,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                }
            });
            /**
 * Adds an HTML file, or array of HTML files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.html('story', 'files/LoginForm.html');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global HTML Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the HTML Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the HTML Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.html({
 *     key: 'login',
 *     url: 'files/LoginForm.html'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.html('login', 'files/LoginForm.html');
 * // and later in your game ...
 * var data = this.cache.html.get('login');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the html from the HTML Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the HTML File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#html
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLFileConfig|Phaser.Types.Loader.FileTypes.HTMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('html', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new HTMLFile(this, key[i]));
                else this.addFile(new HTMLFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = HTMLFile;
        /***/ },
        /* 1344 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single HTML File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#htmlTexture method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#htmlTexture.
 *
 * @class HTMLTextureFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.12.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {number} [width] - The width of the texture the HTML will be rendered to.
 * @param {number} [height] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var HTMLTextureFile = new Class({
                Extends: File,
                initialize: function HTMLTextureFile(loader, key, url, width, height, xhrSettings) {
                    if (width === undefined) width = 512;
                    if (height === undefined) height = 512;
                    var extension = 'html';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        width = GetFastValue(config, 'width', width);
                        height = GetFastValue(config, 'height', height);
                    }
                    var fileConfig = {
                        type: 'html',
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            width: width,
                            height: height
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var w = this.config.width;
                    var h = this.config.height;
                    var data = [];
                    data.push('<svg width="' + w + 'px" height="' + h + 'px" viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg">');
                    data.push('<foreignObject width="100%" height="100%">');
                    data.push('<body xmlns="http://www.w3.org/1999/xhtml">');
                    data.push(this.xhrLoader.responseText);
                    data.push('</body>');
                    data.push('</foreignObject>');
                    data.push('</svg>');
                    var svg = [
                        data.join('\n')
                    ];
                    var _this = this;
                    try {
                        var blob = new window.Blob(svg, {
                            type: 'image/svg+xml;charset=utf-8'
                        });
                    } catch (e) {
                        _this.state = CONST.FILE_ERRORED;
                        _this.onProcessComplete();
                        return;
                    }
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    this.data.onload = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(this.data, blob, 'image/svg+xml');
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.HTMLTextureFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds an HTML File, or array of HTML Files, to the current load queue. When the files are loaded they
 * will be rendered to textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.htmlTexture({
 *     key: 'instructions',
 *     url: 'content/intro.html',
 *     width: 256,
 *     height: 512
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.htmlTexture('instructions', 'content/intro.html', 256, 512);
 * // and later in your game ...
 * this.add.image(x, y, 'instructions');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * The width and height are the size of the texture to which the HTML will be rendered. It's not possible to determine these
 * automatically, so you will need to provide them, either as arguments or in the file config object.
 * When the HTML file has loaded a new SVG element is created with a size and viewbox set to the width and height given.
 * The SVG file has a body tag added to it, with the HTML file contents included. It then calls `window.Blob` on the SVG,
 * and if successful is added to the Texture Manager, otherwise it fails processing. The overall quality of the rendered
 * HTML depends on your browser, and some of them may not even support the svg / blob process used. Be aware that there are
 * limitations on what HTML can be inside an SVG. You can find out more details in this
 * [Mozilla MDN entry](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Drawing_DOM_objects_into_a_canvas).
 *
 * Note: The ability to load this type of file will only be available if the HTMLTextureFile File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#htmlTexture
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.12.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig|Phaser.Types.Loader.FileTypes.HTMLTextureFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.html`, i.e. if `key` was "alien" then the URL will be "alien.html".
 * @param {number} [width=512] - The width of the texture the HTML will be rendered to.
 * @param {number} [height=512] - The height of the texture the HTML will be rendered to.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('htmlTexture', function(key, url, width, height, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new HTMLTextureFile(this, key[i]));
                else this.addFile(new HTMLTextureFile(this, key, url, width, height, xhrSettings));
                return this;
            });
            module1.exports = HTMLTextureFile;
        /***/ },
        /* 1345 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var JSONFile = __webpack_require__(59);
            var MultiFile = __webpack_require__(47);
            /**
 * @classdesc
 * A single Multi Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#multiatlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#multiatlas.
 *
 * @class MultiAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig)} key - The key of the file. Must be unique within both the Loader and the Texture Manager. Or a config object.
 * @param {string} [atlasURL] - The absolute or relative URL to load the multi atlas json file from.
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture files.
 */ var MultiAtlasFile = new Class({
                Extends: MultiFile,
                initialize: function MultiAtlasFile(loader, key, atlasURL, path, baseURL, atlasXhrSettings, textureXhrSettings) {
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        if (GetFastValue(config, 'url', false)) atlasURL = GetFastValue(config, 'url');
                        else atlasURL = GetFastValue(config, 'atlasURL');
                        atlasXhrSettings = GetFastValue(config, 'xhrSettings');
                        path = GetFastValue(config, 'path');
                        baseURL = GetFastValue(config, 'baseURL');
                        textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
                    }
                    var data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
                    MultiFile.call(this, loader, 'multiatlas', key, [
                        data
                    ]);
                    this.config.path = path;
                    this.config.baseURL = baseURL;
                    this.config.textureXhrSettings = textureXhrSettings;
                },
                /**
     * Called by each File when it finishes loading.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#onFileComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File that has completed processing.
     */ onFileComplete: function(file) {
                    var index = this.files.indexOf(file);
                    if (index !== -1) {
                        this.pending--;
                        if (file.type === 'json' && file.data.hasOwnProperty('textures')) {
                            //  Inspect the data for the files to now load
                            var textures = file.data.textures;
                            var config = this.config;
                            var loader = this.loader;
                            var currentBaseURL = loader.baseURL;
                            var currentPath = loader.path;
                            var currentPrefix = loader.prefix;
                            var baseURL = GetFastValue(config, 'baseURL', this.baseURL);
                            var path = GetFastValue(config, 'path', this.path);
                            var prefix = GetFastValue(config, 'prefix', this.prefix);
                            var textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
                            loader.setBaseURL(baseURL);
                            loader.setPath(path);
                            loader.setPrefix(prefix);
                            for(var i = 0; i < textures.length; i++){
                                //  "image": "texture-packer-multi-atlas-0.png",
                                var textureURL = textures[i].image;
                                var key = 'MA' + this.multiKeyIndex + '_' + textureURL;
                                var image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                                this.addToMultiFile(image);
                                loader.addFile(image);
                                //  "normalMap": "texture-packer-multi-atlas-0_n.png",
                                if (textures[i].normalMap) {
                                    var normalMap = new ImageFile(loader, key, textures[i].normalMap, textureXhrSettings);
                                    normalMap.type = 'normalMap';
                                    image.setLink(normalMap);
                                    this.addToMultiFile(normalMap);
                                    loader.addFile(normalMap);
                                }
                            }
                            //  Reset the loader settings
                            loader.setBaseURL(currentBaseURL);
                            loader.setPath(currentPath);
                            loader.setPrefix(currentPrefix);
                        }
                    }
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var fileJSON = this.files[0];
                        var data = [];
                        var images = [];
                        var normalMaps = [];
                        for(var i = 1; i < this.files.length; i++){
                            var file = this.files[i];
                            if (file.type === 'normalMap') continue;
                            var pos = file.key.indexOf('_');
                            var key = file.key.substr(pos + 1);
                            var image = file.data;
                            //  Now we need to find out which json entry this mapped to
                            for(var t = 0; t < fileJSON.data.textures.length; t++){
                                var item = fileJSON.data.textures[t];
                                if (item.image === key) {
                                    images.push(image);
                                    data.push(item);
                                    if (file.linkFile) normalMaps.push(file.linkFile.data);
                                    break;
                                }
                            }
                        }
                        if (normalMaps.length === 0) normalMaps = undefined;
                        this.loader.textureManager.addAtlasJSONArray(this.key, images, data, normalMaps);
                        this.complete = true;
                        for(i = 0; i < this.files.length; i++)this.files[i].pendingDestroy();
                    }
                }
            });
            /**
 * Adds a Multi Texture Atlas, or array of multi atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.multiatlas('level1', 'images/Level1.json');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a JSON file as exported from the application Texture Packer,
 * version 4.6.3 or above, where you have made sure to use the Phaser 3 Export option.
 *
 * The way it works internally is that you provide a URL to the JSON file. Phaser then loads this JSON, parses it and
 * extracts which texture files it also needs to load to complete the process. If the JSON also defines normal maps,
 * Phaser will load those as well.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.multiatlas({
 *     key: 'level1',
 *     atlasURL: 'images/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig` for more details.
 *
 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.multiatlas('level1', 'images/Level1.json');
 * // and later in your game ...
 * this.add.image(x, y, 'level1', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Multi Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#multiatlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig|Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('multiatlas', function(key, atlasURL, path, baseURL, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new MultiAtlasFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new MultiAtlasFile(this, key, atlasURL, path, baseURL, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = MultiAtlasFile;
        /***/ },
        /* 1346 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(47);
            var ScriptFile = __webpack_require__(514);
            /**
 * @classdesc
 * A Multi Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scripts method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scripts.
 *
 * @class MultiScriptFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.17.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object for the script files. Used in replacement of the Loaders default XHR Settings.
 */ var MultiScriptFile = new Class({
                Extends: MultiFile,
                initialize: function MultiScriptFile(loader, key, url, xhrSettings) {
                    var extension = 'js';
                    var files = [];
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    if (!Array.isArray(url)) url = [
                        url
                    ];
                    for(var i = 0; i < url.length; i++){
                        var scriptFile = new ScriptFile(loader, {
                            key: key + '_' + i.toString(),
                            url: url[i],
                            extension: extension,
                            xhrSettings: xhrSettings
                        });
                        //  Override the default onProcess function
                        scriptFile.onProcess = function() {
                            this.onProcessComplete();
                        };
                        files.push(scriptFile);
                    }
                    MultiFile.call(this, loader, 'scripts', key, files);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.MultiScriptFile#addToCache
     * @since 3.17.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        for(var i = 0; i < this.files.length; i++){
                            var file = this.files[i];
                            file.data = document.createElement('script');
                            file.data.language = 'javascript';
                            file.data.type = 'text/javascript';
                            file.data.defer = false;
                            file.data.text = file.xhrLoader.responseText;
                            document.head.appendChild(file.data);
                        }
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds an array of Script files to the current load queue.
 *
 * The difference between this and the `ScriptFile` file type is that you give an array of scripts to this method,
 * and the scripts are then processed _exactly_ in that order. This allows you to load a bunch of scripts that
 * may have dependencies on each other without worrying about the async nature of traditional script loading.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scripts('PostProcess', [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *    ]);
 * }
 * ```
 *
 * In the code above the script files will all be loaded in parallel but only processed (i.e. invoked) in the exact
 * order given in the array.
 *
 * The files are **not** loaded right away. They are added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the files are queued
 * it means you cannot use the files immediately after calling this method, but must wait for the files to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scripts({
 *     key: 'PostProcess',
 *     url: [
 *         'libs/shaders/CopyShader.js',
 *         'libs/postprocessing/EffectComposer.js',
 *         'libs/postprocessing/RenderPass.js',
 *         'libs/postprocessing/MaskPass.js',
 *         'libs/postprocessing/ShaderPass.js',
 *         'libs/postprocessing/AfterimagePass.js'
 *        ]
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.MultiScriptFileConfig` for more details.
 *
 * Once all the files have finished loading they will automatically be converted into a script element
 * via `document.createElement('script')`. They will have their language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. This is done in the exact order the files are specified in the url array.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Note: The ability to load this type of file will only be available if the MultiScript File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scripts
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.17.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig|Phaser.Types.Loader.FileTypes.MultiScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string[]} [url] - An array of absolute or relative URLs to load the script files from. They are processed in the order given in the array.
 * @param {string} [extension='js'] - The default file extension to use if no url is provided.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('scripts', function(key, url, xhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new MultiScriptFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new MultiScriptFile(this, key, url, xhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = MultiScriptFile;
        /***/ },
        /* 1347 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(47);
            var ParseObj = __webpack_require__(492);
            var ParseObjMaterial = __webpack_require__(493);
            var TextFile = __webpack_require__(239);
            /**
 * @classdesc
 * A single Wavefront OBJ File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#obj method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#obj.
 *
 * @class OBJFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - The absolute or relative URL to load the material file from. If undefined or `null` it will be set to `<key>.mat`, i.e. if `key` was "alien" then the URL will be "alien.mat".
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for these files.
 */ var OBJFile = new Class({
                Extends: MultiFile,
                initialize: function OBJFile(loader, key, objURL, matURL, flipUV, xhrSettings) {
                    var obj;
                    var mat;
                    var cache = loader.cacheManager.obj;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        obj = new TextFile(loader, {
                            key: key,
                            type: 'obj',
                            cache: cache,
                            url: GetFastValue(config, 'url'),
                            extension: GetFastValue(config, 'extension', 'obj'),
                            xhrSettings: GetFastValue(config, 'xhrSettings'),
                            config: {
                                flipUV: GetFastValue(config, 'flipUV', flipUV)
                            }
                        });
                        matURL = GetFastValue(config, 'matURL');
                        if (matURL) mat = new TextFile(loader, {
                            key: key,
                            type: 'mat',
                            cache: cache,
                            url: matURL,
                            extension: GetFastValue(config, 'matExtension', 'mat'),
                            xhrSettings: GetFastValue(config, 'xhrSettings')
                        });
                    } else {
                        obj = new TextFile(loader, {
                            key: key,
                            url: objURL,
                            type: 'obj',
                            cache: cache,
                            extension: 'obj',
                            xhrSettings: xhrSettings,
                            config: {
                                flipUV: flipUV
                            }
                        });
                        if (matURL) mat = new TextFile(loader, {
                            key: key,
                            url: matURL,
                            type: 'mat',
                            cache: cache,
                            extension: 'mat',
                            xhrSettings: xhrSettings
                        });
                    }
                    MultiFile.call(this, loader, 'obj', key, [
                        obj,
                        mat
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.OBJFile#addToCache
     * @since 3.50.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var obj = this.files[0];
                        var mat = this.files[1];
                        var objData = ParseObj(obj.data, obj.config.flipUV);
                        if (mat) objData.materials = ParseObjMaterial(mat.data);
                        obj.cache.add(obj.key, objData);
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a Wavefront OBJ file, or array of OBJ files, to the current load queue.
 *
 * Note: You should ensure your 3D package has triangulated the OBJ file prior to export.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj');
 * }
 * ```
 *
 * You can optionally also load a Wavefront Material file as well, by providing the 3rd parameter:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.obj('ufo', 'files/spaceship.obj', 'files/spaceship.mtl');
 * }
 * ```
 *
 * If given, the material will be parsed and stored along with the obj data in the cache.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global OBJ Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the OBJ Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the OBJ Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.obj({
 *     key: 'ufo',
 *     url: 'files/spaceship.obj',
 *     matURL: 'files/spaceship.mtl',
 *     flipUV: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.OBJFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.obj('ufo', 'files/spaceship.obj');
 * // and later in your game ...
 * var data = this.cache.obj.get('ufo');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the obj from the OBJ Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.obj". It will always add `.obj` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the OBJ File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#obj
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.50.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.OBJFileConfig|Phaser.Types.Loader.FileTypes.OBJFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [objURL] - The absolute or relative URL to load the obj file from. If undefined or `null` it will be set to `<key>.obj`, i.e. if `key` was "alien" then the URL will be "alien.obj".
 * @param {string} [matURL] - Optional absolute or relative URL to load the obj material file from.
 * @param {boolean} [flipUV] - Flip the UV coordinates stored in the model data?
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('obj', function(key, objURL, matURL, flipUVs, xhrSettings) {
                var multifile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new OBJFile(this, key[i]);
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new OBJFile(this, key, objURL, matURL, flipUVs, xhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = OBJFile;
        /***/ },
        /* 1348 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(59);
            /**
 * @classdesc
 * A single JSON Pack File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#pack method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#pack.
 *
 * @class PackFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 */ var PackFile = new Class({
                Extends: JSONFile,
                initialize: //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
                //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
                function PackFile(loader, key, url, xhrSettings, dataKey) {
                    JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
                    this.type = 'packfile';
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PackFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    if (this.state !== CONST.FILE_POPULATED) {
                        this.state = CONST.FILE_PROCESSING;
                        this.data = JSON.parse(this.xhrLoader.responseText);
                    }
                    //  Let's pass the pack file data over to the Loader ...
                    this.loader.addPack(this.data, this.config);
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a JSON File Pack, or array of packs, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.pack('level1', 'data/Level1Files.json');
 * }
 * ```
 *
 * A File Pack is a JSON file (or object) that contains details about other files that should be added into the Loader.
 * Here is a small example:
 *
 * ```json
 * {
 *    "test1": {
 *        "files": [
 *            {
 *                "type": "image",
 *                "key": "taikodrummaster",
 *                "url": "assets/pics/taikodrummaster.jpg"
 *            },
 *            {
 *                "type": "image",
 *                "key": "sukasuka-chtholly",
 *                "url": "assets/pics/sukasuka-chtholly.png"
 *            }
 *        ]
 *    },
 *    "meta": {
 *        "generated": "1401380327373",
 *        "app": "Phaser 3 Asset Packer",
 *        "url": "https://phaser.io",
 *        "version": "1.0",
 *        "copyright": "Photon Storm Ltd. 2018"
 *    }
 * }
 * ```
 *
 * The pack can be split into sections. In the example above you'll see a section called `test1. You can tell
 * the `load.pack` method to parse only a particular section of a pack. The pack is stored in the JSON Cache,
 * so you can pass it to the Loader to process additional sections as needed in your game, or you can just load
 * them all at once without specifying anything.
 *
 * The pack file can contain an entry for any type of file that Phaser can load. The object structures exactly
 * match that of the file type configs, and all properties available within the file type configs can be used
 * in the pack file too.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the JSON Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.pack({
 *     key: 'level1',
 *     url: 'data/Level1Files.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PackFileConfig` for more details.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
 * this is what you would use to retrieve the text from the JSON Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
 * rather than the whole file. For example, if your JSON data had a structure like this:
 *
 * ```json
 * {
 *     "level1": {
 *         "baddies": {
 *             "aliens": {},
 *             "boss": {}
 *         }
 *     },
 *     "level2": {},
 *     "level3": {}
 * }
 * ```
 *
 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
 *
 * Note: The ability to load this type of file will only be available if the Pack File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#pack
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PackFileConfig|Phaser.Types.Loader.FileTypes.PackFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('pack', function(key, url, packKey, xhrSettings) {
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)this.addFile(new PackFile(this, key[i]));
                else this.addFile(new PackFile(this, key, url, xhrSettings, packKey));
                return this;
            });
            module1.exports = PackFile;
        /***/ },
        /* 1349 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#plugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#plugin.
 *
 * @class PluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {boolean} [start=false] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var PluginFile = new Class({
                Extends: File,
                initialize: function PluginFile(loader, key, url, start, mapping, xhrSettings) {
                    var extension = 'js';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        start = GetFastValue(config, 'start');
                        mapping = GetFastValue(config, 'mapping');
                    }
                    var fileConfig = {
                        type: 'plugin',
                        cache: false,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            start: start,
                            mapping: mapping
                        }
                    };
                    File.call(this, loader, fileConfig);
                    // If the url variable refers to a class, add the plugin directly
                    if (typeof url === 'function') {
                        this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.PluginFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    var pluginManager = this.loader.systems.plugins;
                    var config = this.config;
                    var start = GetFastValue(config, 'start', false);
                    var mapping = GetFastValue(config, 'mapping', null);
                    if (this.state === CONST.FILE_POPULATED) pluginManager.install(this.key, this.data, start, mapping);
                    else {
                        //  Plugin added via a js file
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement('script');
                        this.data.language = 'javascript';
                        this.data.type = 'text/javascript';
                        this.data.defer = false;
                        this.data.text = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        var plugin = pluginManager.install(this.key, window[this.key], start, mapping);
                        if (start || mapping) {
                            //  Install into the current Scene Systems and Scene
                            this.loader.systems[mapping] = plugin;
                            this.loader.scene[mapping] = plugin;
                        }
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.plugin('modplayer', 'plugins/ModPlayer.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.plugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.PluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Plugin File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#plugin
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.PluginFileConfig|Phaser.Types.Loader.FileTypes.PluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, a plugin function.
 * @param {boolean} [start] - Automatically start the plugin after loading?
 * @param {string} [mapping] - If this plugin is to be injected into the Scene, this is the property key used.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('plugin', function(key, url, start, mapping, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new PluginFile(this, key[i]));
                else this.addFile(new PluginFile(this, key, url, start, mapping, xhrSettings));
                return this;
            });
            module1.exports = PluginFile;
        /***/ },
        /* 1350 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * An external Scene JavaScript File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#sceneFile method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#sceneFile.
 *
 * @class SceneFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.16.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SceneFile = new Class({
                Extends: File,
                initialize: function SceneFile(loader, key, url, xhrSettings) {
                    var extension = 'js';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'text',
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#onProcess
     * @since 3.16.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SceneFile#addToCache
     * @since 3.16.0
     */ addToCache: function() {
                    var code = this.data.concat("(function(){\nreturn new " + this.key + '();\n' + '}).call(this);');
                    //  Stops rollup from freaking out during build
                    var eval2 = eval;
                    this.loader.sceneManager.add(this.key, eval2(code));
                    this.complete = true;
                }
            });
            /**
 * Adds an external Scene file, or array of Scene files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('Level1', 'src/Level1.js');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Scene Manager upon a successful load.
 *
 * For a Scene File it's vitally important that the key matches the class name in the JavaScript file.
 *
 * For example here is the source file:
 *
 * ```javascript
 * class ExternalScene extends Phaser.Scene {
 *
 *     constructor ()
 *     {
 *         super('myScene');
 *     }
 *
 * }
 * ```
 *
 * Because the class is called `ExternalScene` that is the exact same key you must use when loading it:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.sceneFile('ExternalScene', 'src/yourScene.js');
 * }
 * ```
 *
 * The key that is used within the Scene Manager can either be set to the same, or you can override it in the Scene
 * constructor, as we've done in the example above, where the Scene key was changed to `myScene`.
 *
 * The key should be unique both in terms of files being loaded and Scenes already present in the Scene Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Scene Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.sceneFile({
 *     key: 'Level1',
 *     url: 'src/Level1.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SceneFileConfig` for more details.
 *
 * Once the file has finished loading it will be added to the Scene Manager.
 *
 * ```javascript
 * this.load.sceneFile('Level1', 'src/Level1.js');
 * // and later in your game ...
 * this.scene.start('Level1');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `WORLD1.` and the key was `Story` the final key will be `WORLD1.Story` and
 * this is what you would use to retrieve the text from the Scene Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
 * and no URL is given then the Loader will set the URL to be "story.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Scene File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#sceneFile
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.16.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SceneFileConfig|Phaser.Types.Loader.FileTypes.SceneFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('sceneFile', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SceneFile(this, key[i]));
                else this.addFile(new SceneFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = SceneFile;
        /***/ },
        /* 1351 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Scene Plugin Script File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#scenePlugin method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scenePlugin.
 *
 * @class ScenePluginFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var ScenePluginFile = new Class({
                Extends: File,
                initialize: function ScenePluginFile(loader, key, url, systemKey, sceneKey, xhrSettings) {
                    var extension = 'js';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                        systemKey = GetFastValue(config, 'systemKey');
                        sceneKey = GetFastValue(config, 'sceneKey');
                    }
                    var fileConfig = {
                        type: 'scenePlugin',
                        cache: false,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            systemKey: systemKey,
                            sceneKey: sceneKey
                        }
                    };
                    File.call(this, loader, fileConfig);
                    // If the url variable refers to a class, add the plugin directly
                    if (typeof url === 'function') {
                        this.data = url;
                        this.state = CONST.FILE_POPULATED;
                    }
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.ScenePluginFile#onProcess
     * @since 3.8.0
     */ onProcess: function() {
                    var pluginManager = this.loader.systems.plugins;
                    var config = this.config;
                    var key = this.key;
                    var systemKey = GetFastValue(config, 'systemKey', key);
                    var sceneKey = GetFastValue(config, 'sceneKey', key);
                    if (this.state === CONST.FILE_POPULATED) pluginManager.installScenePlugin(systemKey, this.data, sceneKey, this.loader.scene, true);
                    else {
                        //  Plugin added via a js file
                        this.state = CONST.FILE_PROCESSING;
                        this.data = document.createElement('script');
                        this.data.language = 'javascript';
                        this.data.type = 'text/javascript';
                        this.data.defer = false;
                        this.data.text = this.xhrLoader.responseText;
                        document.head.appendChild(this.data);
                        pluginManager.installScenePlugin(systemKey, window[this.key], sceneKey, this.loader.scene, true);
                    }
                    this.onProcessComplete();
                }
            });
            /**
 * Adds a Scene Plugin Script file, or array of plugin files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.scenePlugin('ModPlayer', 'plugins/ModPlayer.js', 'modPlayer', 'mods');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String and not already in-use by another file in the Loader.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.scenePlugin({
 *     key: 'modplayer',
 *     url: 'plugins/ModPlayer.js'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.ScenePluginFileConfig` for more details.
 *
 * Once the file has finished loading it will automatically be converted into a script element
 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
 * false and then the resulting element will be appended to `document.head`. Any code then in the
 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#scenePlugin
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.8.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig|Phaser.Types.Loader.FileTypes.ScenePluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, set to a plugin function.
 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('scenePlugin', function(key, url, systemKey, sceneKey, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new ScenePluginFile(this, key[i]));
                else this.addFile(new ScenePluginFile(this, key, url, systemKey, sceneKey, xhrSettings));
                return this;
            });
            module1.exports = ScenePluginFile;
        /***/ },
        /* 1352 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var ImageFile = __webpack_require__(70);
            /**
 * @classdesc
 * A single Sprite Sheet Image File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#spritesheet method and are not typically created directly.
 * 
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#spritesheet.
 *
 * @class SpriteSheetFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SpriteSheetFile = new Class({
                Extends: ImageFile,
                initialize: function SpriteSheetFile(loader, key, url, frameConfig, xhrSettings) {
                    ImageFile.call(this, loader, key, url, xhrSettings, frameConfig);
                    this.type = 'spritesheet';
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SpriteSheetFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addSpriteSheet(this.key, this.data, this.config);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds a Sprite Sheet Image, or array of Sprite Sheet Images, to the current load queue.
 *
 * The term 'Sprite Sheet' in Phaser means a fixed-size sheet. Where every frame in the sheet is the exact same size,
 * and you reference those frames using numbers, not frame names. This is not the same thing as a Texture Atlas, where
 * the frames are packed in a way where they take up the least amount of space, and are referenced by their names,
 * not numbers. Some articles and software use the term 'Sprite Sheet' to mean Texture Atlas, so please be aware of
 * what sort of file you're actually trying to load.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 * 
 * ```javascript
 * function preload ()
 * {
 *     this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 * 
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
 * of animated gifs to Canvas elements.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 * 
 * ```javascript
 * this.load.spritesheet({
 *     key: 'bot',
 *     url: 'images/robot.png',
 *     frameConfig: {
 *         frameWidth: 32,
 *         frameHeight: 38,
 *         startFrame: 0,
 *         endFrame: 8
 *     }
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 * 
 * ```javascript
 * this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
 * // and later in your game ...
 * this.add.image(x, y, 'bot', 0);
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `PLAYER.` and the key was `Running` the final key will be `PLAYER.Running` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 * 
 * ```javascript
 * this.load.spritesheet('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ], { frameWidth: 256, frameHeight: 80 });
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 * 
 * ```javascript
 * this.load.spritesheet({
 *     key: 'logo',
 *     url: 'images/AtariLogo.png',
 *     normalMap: 'images/AtariLogo-n.png',
 *     frameConfig: {
 *         frameWidth: 256,
 *         frameHeight: 80
 *     }
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 * 
 * Note: The ability to load this type of file will only be available if the Sprite Sheet File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#spritesheet
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig|Phaser.Types.Loader.FileTypes.SpriteSheetFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {Phaser.Types.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. At a minimum it should have a `frameWidth` property.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('spritesheet', function(key, url, frameConfig, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SpriteSheetFile(this, key[i]));
                else this.addFile(new SpriteSheetFile(this, key, url, frameConfig, xhrSettings));
                return this;
            });
            module1.exports = SpriteSheetFile;
        /***/ },
        /* 1353 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single SVG File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#svg method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#svg.
 *
 * @class SVGFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var SVGFile = new Class({
                Extends: File,
                initialize: function SVGFile(loader, key, url, svgConfig, xhrSettings) {
                    var extension = 'svg';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        svgConfig = GetFastValue(config, 'svgConfig', {});
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'svg',
                        cache: loader.textureManager,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings,
                        config: {
                            width: GetFastValue(svgConfig, 'width'),
                            height: GetFastValue(svgConfig, 'height'),
                            scale: GetFastValue(svgConfig, 'scale')
                        }
                    };
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    var text = this.xhrLoader.responseText;
                    var svg = [
                        text
                    ];
                    var width = this.config.width;
                    var height = this.config.height;
                    var scale = this.config.scale;
                    resize: if (width && height || scale) {
                        var xml = null;
                        var parser = new DOMParser();
                        xml = parser.parseFromString(text, 'text/xml');
                        var svgXML = xml.getElementsByTagName('svg')[0];
                        var hasViewBox = svgXML.hasAttribute('viewBox');
                        var svgWidth = parseFloat(svgXML.getAttribute('width'));
                        var svgHeight = parseFloat(svgXML.getAttribute('height'));
                        if (!hasViewBox && svgWidth && svgHeight) //  If there's no viewBox attribute, set one
                        svgXML.setAttribute('viewBox', '0  0 ' + svgWidth + ' ' + svgHeight);
                        else if (hasViewBox && !svgWidth && !svgHeight) {
                            //  Get the w/h from the viewbox
                            var viewBox = svgXML.getAttribute('viewBox').split(/\s+|,/);
                            svgWidth = viewBox[2];
                            svgHeight = viewBox[3];
                        }
                        if (scale) {
                            if (svgWidth && svgHeight) {
                                width = svgWidth * scale;
                                height = svgHeight * scale;
                            } else break resize;
                        }
                        svgXML.setAttribute('width', width.toString() + 'px');
                        svgXML.setAttribute('height', height.toString() + 'px');
                        svg = [
                            new XMLSerializer().serializeToString(svgXML)
                        ];
                    }
                    try {
                        var blob = new window.Blob(svg, {
                            type: 'image/svg+xml;charset=utf-8'
                        });
                    } catch (e) {
                        this.onProcessError();
                        return;
                    }
                    this.data = new Image();
                    this.data.crossOrigin = this.crossOrigin;
                    var _this = this;
                    var retry = false;
                    this.data.onload = function() {
                        if (!retry) File.revokeObjectURL(_this.data);
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        //  Safari 8 re-try
                        if (!retry) {
                            retry = true;
                            File.revokeObjectURL(_this.data);
                            _this.data.src = 'data:image/svg+xml,' + encodeURIComponent(svg.join(''));
                        } else _this.onProcessError();
                    };
                    File.createObjectURL(this.data, blob, 'image/svg+xml');
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.SVGFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var texture = this.cache.addImage(this.key, this.data);
                    this.pendingDestroy(texture);
                }
            });
            /**
 * Adds an SVG File, or array of SVG Files, to the current load queue. When the files are loaded they
 * will be rendered to bitmap textures and stored in the Texture Manager.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.SVGFileConfig` for more details.
 *
 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.svg('morty', 'images/Morty.svg');
 * // and later in your game ...
 * this.add.image(x, y, 'morty');
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * You can optionally pass an SVG Resize Configuration object when you load an SVG file. By default the SVG will be rendered to a texture
 * at the same size defined in the SVG file attributes. However, this isn't always desirable. You may wish to resize the SVG (either down
 * or up) to improve texture clarity, or reduce texture memory consumption. You can either specify an exact width and height to resize
 * the SVG to:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { width: 300, height: 600 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         width: 300,
 *         height: 600
 *     }
 * });
 * ```
 *
 * Alternatively, you can just provide a scale factor instead:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.svg('morty', 'images/Morty.svg', { scale: 2.5 });
 * }
 * ```
 *
 * Or when using a configuration object:
 *
 * ```javascript
 * this.load.svg({
 *     key: 'morty',
 *     url: 'images/Morty.svg',
 *     svgConfig: {
 *         scale: 2.5
 *     }
 * });
 * ```
 *
 * If scale, width and height values are all given, the scale has priority and the width and height values are ignored.
 *
 * Note: The ability to load this type of file will only be available if the SVG File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#svg
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.SVGFileConfig|Phaser.Types.Loader.FileTypes.SVGFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
 * @param {Phaser.Types.Loader.FileTypes.SVGSizeConfig} [svgConfig] - The svg size configuration object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('svg', function(key, url, svgConfig, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new SVGFile(this, key[i]));
                else this.addFile(new SVGFile(this, key, url, svgConfig, xhrSettings));
                return this;
            });
            module1.exports = SVGFile;
        /***/ },
        /* 1354 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            var TILEMAP_FORMATS = __webpack_require__(39);
            /**
 * @classdesc
 * A single Tilemap CSV File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapCSV method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapCSV.
 *
 * @class TilemapCSVFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapCSVFile = new Class({
                Extends: File,
                initialize: function TilemapCSVFile(loader, key, url, xhrSettings) {
                    var extension = 'csv';
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        url = GetFastValue(config, 'url');
                        xhrSettings = GetFastValue(config, 'xhrSettings');
                        extension = GetFastValue(config, 'extension', extension);
                    }
                    var fileConfig = {
                        type: 'tilemapCSV',
                        cache: loader.cacheManager.tilemap,
                        extension: extension,
                        responseType: 'text',
                        key: key,
                        url: url,
                        xhrSettings: xhrSettings
                    };
                    File.call(this, loader, fileConfig);
                    this.tilemapFormat = TILEMAP_FORMATS.CSV;
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#onProcess
     * @since 3.7.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    this.data = this.xhrLoader.responseText;
                    this.onProcessComplete();
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapCSVFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: this.tilemapFormat,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds a CSV Tilemap file, or array of CSV files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * }
 * ```
 *
 * Tilemap CSV data can be created in a text editor, or a 3rd party app that exports as CSV.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapCSV({
 *     key: 'level1',
 *     url: 'maps/Level1.csv'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapCSV('level1', 'maps/Level1.csv');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.csv". It will always add `.csv` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap CSV File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapCSV
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig|Phaser.Types.Loader.FileTypes.TilemapCSVFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapCSV', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapCSVFile(this, key[i]));
                else this.addFile(new TilemapCSVFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapCSVFile;
        /***/ },
        /* 1355 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(59);
            var TILEMAP_FORMATS = __webpack_require__(39);
            /**
 * @classdesc
 * A single Impact.js Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapImpact method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapImpact.
 *
 * @class TilemapImpactFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.7.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapImpactFile = new Class({
                Extends: JSONFile,
                initialize: function TilemapImpactFile(loader, key, url, xhrSettings) {
                    JSONFile.call(this, loader, key, url, xhrSettings);
                    this.type = 'tilemapJSON';
                    this.cache = loader.cacheManager.tilemap;
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapImpactFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: TILEMAP_FORMATS.WELTMEISTER,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds an Impact.js Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapImpact('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * Impact Tilemap data is created the Impact.js Map Editor called Weltmeister.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapImpact({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapImpact('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap Impact File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapImpact
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.7.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig|Phaser.Types.Loader.FileTypes.TilemapImpactFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapImpact', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapImpactFile(this, key[i]));
                else this.addFile(new TilemapImpactFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapImpactFile;
        /***/ },
        /* 1356 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var JSONFile = __webpack_require__(59);
            var TILEMAP_FORMATS = __webpack_require__(39);
            /**
 * @classdesc
 * A single Tiled Tilemap JSON File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapTiledJSON method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapTiledJSON.
 *
 * @class TilemapJSONFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var TilemapJSONFile = new Class({
                Extends: JSONFile,
                initialize: function TilemapJSONFile(loader, key, url, xhrSettings) {
                    JSONFile.call(this, loader, key, url, xhrSettings);
                    this.type = 'tilemapJSON';
                    this.cache = loader.cacheManager.tilemap;
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.TilemapJSONFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    var tiledata = {
                        format: TILEMAP_FORMATS.TILED_JSON,
                        data: this.data
                    };
                    this.cache.add(this.key, tiledata);
                    this.pendingDestroy(tiledata);
                }
            });
            /**
 * Adds a Tiled JSON Tilemap file, or array of map files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * }
 * ```
 *
 * The Tilemap data is created using the Tiled Map Editor and selecting JSON as the export format.
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Text Cache first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.tilemapTiledJSON({
 *     key: 'level1',
 *     url: 'maps/Level1.json'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig` for more details.
 *
 * Once the file has finished loading you can access it from its Cache using its key:
 *
 * ```javascript
 * this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
 * // and later in your game ...
 * var map = this.make.tilemap({ key: 'level1' });
 * ```
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
 * this is what you would use to retrieve the text from the Tilemap Cache.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Note: The ability to load this type of file will only be available if the Tilemap JSON File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#tilemapTiledJSON
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig|Phaser.Types.Loader.FileTypes.TilemapJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {object|string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json". Or, a well formed JSON object.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('tilemapTiledJSON', function(key, url, xhrSettings) {
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++)//  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                this.addFile(new TilemapJSONFile(this, key[i]));
                else this.addFile(new TilemapJSONFile(this, key, url, xhrSettings));
                return this;
            });
            module1.exports = TilemapJSONFile;
        /***/ },
        /* 1357 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var ImageFile = __webpack_require__(70);
            var IsPlainObject = __webpack_require__(7);
            var MultiFile = __webpack_require__(47);
            var TextFile = __webpack_require__(239);
            /**
 * @classdesc
 * A single text file based Unity Texture Atlas File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#unityAtlas method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#unityAtlas.
 *
 * @class UnityAtlasFile
 * @extends Phaser.Loader.MultiFile
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 */ var UnityAtlasFile = new Class({
                Extends: MultiFile,
                initialize: function UnityAtlasFile(loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                    var image;
                    var data;
                    if (IsPlainObject(key)) {
                        var config = key;
                        key = GetFastValue(config, 'key');
                        image = new ImageFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'textureURL'),
                            extension: GetFastValue(config, 'textureExtension', 'png'),
                            normalMap: GetFastValue(config, 'normalMap'),
                            xhrSettings: GetFastValue(config, 'textureXhrSettings')
                        });
                        data = new TextFile(loader, {
                            key: key,
                            url: GetFastValue(config, 'atlasURL'),
                            extension: GetFastValue(config, 'atlasExtension', 'txt'),
                            xhrSettings: GetFastValue(config, 'atlasXhrSettings')
                        });
                    } else {
                        image = new ImageFile(loader, key, textureURL, textureXhrSettings);
                        data = new TextFile(loader, key, atlasURL, atlasXhrSettings);
                    }
                    if (image.linkFile) //  Image has a normal map
                    MultiFile.call(this, loader, 'unityatlas', key, [
                        image,
                        data,
                        image.linkFile
                    ]);
                    else MultiFile.call(this, loader, 'unityatlas', key, [
                        image,
                        data
                    ]);
                },
                /**
     * Adds this file to its target cache upon successful loading and processing.
     *
     * @method Phaser.Loader.FileTypes.UnityAtlasFile#addToCache
     * @since 3.7.0
     */ addToCache: function() {
                    if (this.isReadyToProcess()) {
                        var image = this.files[0];
                        var text = this.files[1];
                        var normalMap = this.files[2] ? this.files[2].data : null;
                        this.loader.textureManager.addUnityAtlas(image.key, image.data, text.data, normalMap);
                        text.pendingDestroy();
                        this.complete = true;
                    }
                }
            });
            /**
 * Adds a Unity YAML based Texture Atlas, or array of atlases, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.txt');
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
 *
 * Phaser expects the atlas data to be provided in a YAML formatted text file as exported from Unity.
 *
 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
 *
 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Texture Manager first, before loading a new one.
 *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig` for more details.
 *
 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
 * // and later in your game ...
 * this.add.image(x, y, 'mainmenu', 'background');
 * ```
 *
 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
 *
 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
 * this is what you would use to retrieve the image from the Texture Manager.
 *
 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
 *
 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
 *
 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
 * then you can specify it by providing an array as the `url` where the second element is the normal map:
 *
 * ```javascript
 * this.load.unityAtlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.txt');
 * ```
 *
 * Or, if you are using a config object use the `normalMap` property:
 *
 * ```javascript
 * this.load.unityAtlas({
 *     key: 'mainmenu',
 *     textureURL: 'images/MainMenu.png',
 *     normalMap: 'images/MainMenu-n.png',
 *     atlasURL: 'images/MainMenu.txt'
 * });
 * ```
 *
 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
 * Normal maps are a WebGL only feature.
 *
 * Note: The ability to load this type of file will only be available if the Unity Atlas File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#unityAtlas
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.0.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig|Phaser.Types.Loader.FileTypes.UnityAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
 * @param {Phaser.Types.Loader.XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('unityAtlas', function(key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings) {
                var multifile;
                //  Supports an Object file definition in the key argument
                //  Or an array of objects in the key argument
                //  Or a single entry where all arguments have been defined
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    multifile = new UnityAtlasFile(this, key[i]);
                    this.addFile(multifile.files);
                }
                else {
                    multifile = new UnityAtlasFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
                    this.addFile(multifile.files);
                }
                return this;
            });
            module1.exports = UnityAtlasFile;
        /***/ },
        /* 1358 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var File = __webpack_require__(23);
            var FileTypesManager = __webpack_require__(8);
            var GetURL = __webpack_require__(153);
            var GetFastValue = __webpack_require__(2);
            var IsPlainObject = __webpack_require__(7);
            /**
 * @classdesc
 * A single Video File suitable for loading by the Loader.
 *
 * These are created when you use the Phaser.Loader.LoaderPlugin#video method and are not typically created directly.
 *
 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#video.
 *
 * @class VideoFile
 * @extends Phaser.Loader.File
 * @memberof Phaser.Loader.FileTypes
 * @constructor
 * @since 3.20.0
 *
 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig)} key - The key to use for this file, or a file configuration object.
 * @param {any} [urlConfig] - The absolute or relative URL to load this file from in a config object.
 * @param {string} [loadEvent] - The load event to listen for when _not_ loading as a blob. Either 'loadeddata', 'canplay' or 'canplaythrough'.
 * @param {boolean} [asBlob] - Load the video as a data blob, or via the Video element?
 * @param {boolean} [noAudio] - Does the video have an audio track? If not you can enable auto-playing on it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
 */ var VideoFile = new Class({
                Extends: File,
                initialize: //  URL is an object created by VideoFile.getVideoURL
                function VideoFile(loader, key, urlConfig, loadEvent, asBlob, noAudio, xhrSettings) {
                    if (loadEvent === undefined) loadEvent = 'loadeddata';
                    if (asBlob === undefined) asBlob = false;
                    if (noAudio === undefined) noAudio = false;
                    if (loadEvent !== 'loadeddata' && loadEvent !== 'canplay' && loadEvent !== 'canplaythrough') loadEvent = 'loadeddata';
                    var fileConfig = {
                        type: 'video',
                        cache: loader.cacheManager.video,
                        extension: urlConfig.type,
                        responseType: 'blob',
                        key: key,
                        url: urlConfig.url,
                        xhrSettings: xhrSettings,
                        config: {
                            loadEvent: loadEvent,
                            asBlob: asBlob,
                            noAudio: noAudio
                        }
                    };
                    this.onLoadCallback = this.onVideoLoadHandler.bind(this);
                    this.onErrorCallback = this.onVideoErrorHandler.bind(this);
                    File.call(this, loader, fileConfig);
                },
                /**
     * Called automatically by Loader.nextFile.
     * This method controls what extra work this File does with its loaded data.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onProcess
     * @since 3.20.0
     */ onProcess: function() {
                    this.state = CONST.FILE_PROCESSING;
                    if (!this.config.asBlob) {
                        this.onProcessComplete();
                        return;
                    }
                    //  Load Video as blob
                    var video = this.createVideoElement();
                    this.data = video;
                    var _this = this;
                    this.data.onloadeddata = function() {
                        _this.onProcessComplete();
                    };
                    this.data.onerror = function() {
                        File.revokeObjectURL(_this.data);
                        _this.onProcessError();
                    };
                    File.createObjectURL(video, this.xhrLoader.response, '');
                    video.load();
                },
                /**
     * Creates a Video Element within the DOM.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#createVideoElement
     * @private
     * @since 3.20.0
     *
     * @return {HTMLVideoElement} The newly created Video element.
     */ createVideoElement: function() {
                    var video = document.createElement('video');
                    video.controls = false;
                    video.crossOrigin = this.loader.crossOrigin;
                    if (this.config.noAudio) {
                        video.muted = true;
                        video.defaultMuted = true;
                        video.setAttribute('autoplay', 'autoplay');
                    }
                    video.setAttribute('playsinline', 'playsinline');
                    video.setAttribute('preload', 'auto');
                    return video;
                },
                /**
     * Internal load event callback.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onVideoLoadHandler
     * @private
     * @since 3.20.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onVideoLoadHandler: function(event) {
                    var video = event.target;
                    video.removeEventListener(this.config.loadEvent, this.onLoadCallback, true);
                    video.removeEventListener('error', this.onErrorCallback, true);
                    this.data = video;
                    this.resetXHR();
                    this.loader.nextFile(this, true);
                },
                /**
     * Internal load error event callback.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#onVideoErrorHandler
     * @private
     * @since 3.20.0
     *
     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
     */ onVideoErrorHandler: function(event) {
                    var video = event.target;
                    if (video) {
                        video.removeEventListener(this.config.loadEvent, this.onLoadCallback, true);
                        video.removeEventListener('error', this.onErrorCallback, true);
                    }
                    this.resetXHR();
                    this.loader.nextFile(this, false);
                },
                /**
     * Called by the Loader, starts the actual file downloading.
     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
     *
     * @method Phaser.Loader.FileTypes.VideoFile#load
     * @since 3.20.0
     */ load: function() {
                    var loadEvent = this.config.loadEvent;
                    if (this.config.asBlob) File.prototype.load.call(this);
                    else {
                        this.percentComplete = 0;
                        var video = this.createVideoElement();
                        video.addEventListener(loadEvent, this.onLoadCallback, true);
                        video.addEventListener('error', this.onErrorCallback, true);
                        video.src = GetURL(this, this.loader.baseURL);
                        video.load();
                    }
                }
            });
            VideoFile.create = function(loader, key, urls, loadEvent, asBlob, noAudio, xhrSettings) {
                var game = loader.systems.game;
                //  url may be inside key, which may be an object
                if (IsPlainObject(key)) {
                    urls = GetFastValue(key, 'url', []);
                    loadEvent = GetFastValue(key, 'loadEvent', 'loadeddata');
                    asBlob = GetFastValue(key, 'asBlob', false);
                    noAudio = GetFastValue(key, 'noAudio', false);
                    xhrSettings = GetFastValue(key, 'xhrSettings');
                }
                var urlConfig = VideoFile.getVideoURL(game, urls);
                if (urlConfig) return new VideoFile(loader, key, urlConfig, loadEvent, asBlob, noAudio, xhrSettings);
            };
            VideoFile.getVideoURL = function(game, urls) {
                if (!Array.isArray(urls)) urls = [
                    urls
                ];
                for(var i = 0; i < urls.length; i++){
                    var url = GetFastValue(urls[i], 'url', urls[i]);
                    if (url.indexOf('blob:') === 0) return {
                        url: url,
                        type: ''
                    };
                    var videoType;
                    if (url.indexOf('data:') === 0) videoType = url.split(',')[0].match(/\/(.*?);/);
                    else videoType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
                    videoType = GetFastValue(urls[i], 'type', videoType ? videoType[1] : '').toLowerCase();
                    if (game.device.video[videoType]) return {
                        url: url,
                        type: videoType
                    };
                }
                return null;
            };
            /**
 * Adds a Video file, or array of video files, to the current load queue.
 *
 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
 *
 * ```javascript
 * function preload ()
 * {
 *     this.load.video('intro', [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ]);
 * }
 * ```
 *
 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
 * loaded.
 *
 * The key must be a unique String. It is used to add the file to the global Video Cache upon a successful load.
 * The key should be unique both in terms of files being loaded and files already present in the Video Cache.
 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
 * then remove it from the Video Cache first, before loading a new one.
  *
 * Instead of passing arguments you can pass a configuration object, such as:
 *
 * ```javascript
 * this.load.video({
 *     key: 'intro',
 *     url: [ 'video/level1.mp4', 'video/level1.webm', 'video/level1.mov' ],
 *     asBlob: false,
 *     noAudio: true
 * });
 * ```
 *
 * See the documentation for `Phaser.Types.Loader.FileTypes.VideoFileConfig` for more details.
 *
 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
 *
 * Due to different browsers supporting different video file types you should usually provide your video files in a variety of formats.
 * mp4, mov and webm are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
 * browser support, starting with the first in the array and progressing to the end.
 *
 * Unlike most asset-types, videos do not _need_ to be preloaded. You can create a Video Game Object and then call its `loadURL` method,
 * to load a video at run-time, rather than in advance.
 *
 * Note: The ability to load this type of file will only be available if the Video File type has been built into Phaser.
 * It is available in the default build but can be excluded from custom builds.
 *
 * @method Phaser.Loader.LoaderPlugin#video
 * @fires Phaser.Loader.LoaderPlugin#ADD
 * @since 3.20.0
 *
 * @param {(string|Phaser.Types.Loader.FileTypes.VideoFileConfig|Phaser.Types.Loader.FileTypes.VideoFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
 * @param {(string|string[])} [urls] - The absolute or relative URL to load the video files from.
 * @param {string} [loadEvent='loadeddata'] - The load event to listen for when _not_ loading as a blob. Either `loadeddata`, `canplay` or `canplaythrough`.
 * @param {boolean} [asBlob=false] - Load the video as a data blob, or stream it via the Video element?
 * @param {boolean} [noAudio=false] - Does the video have an audio track? If not you can enable auto-playing on it.
 * @param {Phaser.Types.Loader.XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
 *
 * @return {this} The Loader instance.
 */ FileTypesManager.register('video', function(key, urls, loadEvent, asBlob, noAudio, xhrSettings) {
                var videoFile;
                if (Array.isArray(key)) for(var i = 0; i < key.length; i++){
                    //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
                    videoFile = VideoFile.create(this, key[i]);
                    if (videoFile) this.addFile(videoFile);
                }
                else {
                    videoFile = VideoFile.create(this, key, urls, loadEvent, asBlob, noAudio, xhrSettings);
                    if (videoFile) this.addFile(videoFile);
                }
                return this;
            });
            module1.exports = VideoFile;
        /***/ },
        /* 1359 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var CONST = __webpack_require__(20);
            var CustomSet = __webpack_require__(148);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(91);
            var FileTypesManager = __webpack_require__(8);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            var XHRSettings = __webpack_require__(154);
            /**
 * @classdesc
 * The Loader handles loading all external content such as Images, Sounds, Texture Atlases and data files.
 * You typically interact with it via `this.load` in your Scene. Scenes can have a `preload` method, which is always
 * called before the Scenes `create` method, allowing you to preload assets that the Scene may need.
 *
 * If you call any `this.load` methods from outside of `Scene.preload` then you need to start the Loader going
 * yourself by calling `Loader.start()`. It's only automatically started during the Scene preload.
 *
 * The Loader uses a combination of tag loading (eg. Audio elements) and XHR and provides progress and completion events.
 * Files are loaded in parallel by default. The amount of concurrent connections can be controlled in your Game Configuration.
 *
 * Once the Loader has started loading you are still able to add files to it. These can be injected as a result of a loader
 * event, the type of file being loaded (such as a pack file) or other external events. As long as the Loader hasn't finished
 * simply adding a new file to it, while running, will ensure it's added into the current queue.
 *
 * Every Scene has its own instance of the Loader and they are bound to the Scene in which they are created. However,
 * assets loaded by the Loader are placed into global game-level caches. For example, loading an XML file will place that
 * file inside `Game.cache.xml`, which is accessible from every Scene in your game, no matter who was responsible
 * for loading it. The same is true of Textures. A texture loaded in one Scene is instantly available to all other Scenes
 * in your game.
 *
 * The Loader works by using custom File Types. These are stored in the FileTypesManager, which injects them into the Loader
 * when it's instantiated. You can create your own custom file types by extending either the File or MultiFile classes.
 * See those files for more details.
 *
 * @class LoaderPlugin
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Loader
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Loader instance.
 */ var LoaderPlugin = new Class({
                Extends: EventEmitter,
                initialize: function LoaderPlugin(scene) {
                    EventEmitter.call(this);
                    var gameConfig = scene.sys.game.config;
                    var sceneConfig = scene.sys.settings.loader;
                    /**
         * The Scene which owns this Loader instance.
         *
         * @name Phaser.Loader.LoaderPlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems.
         *
         * @name Phaser.Loader.LoaderPlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A reference to the global Cache Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#cacheManager
         * @type {Phaser.Cache.CacheManager}
         * @since 3.7.0
         */ this.cacheManager = scene.sys.cache;
                    /**
         * A reference to the global Texture Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#textureManager
         * @type {Phaser.Textures.TextureManager}
         * @since 3.7.0
         */ this.textureManager = scene.sys.textures;
                    /**
         * A reference to the global Scene Manager.
         *
         * @name Phaser.Loader.LoaderPlugin#sceneManager
         * @type {Phaser.Scenes.SceneManager}
         * @protected
         * @since 3.16.0
         */ this.sceneManager = scene.sys.game.scene;
                    //  Inject the available filetypes into the Loader
                    FileTypesManager.install(this);
                    /**
         * An optional prefix that is automatically prepended to the start of every file key.
         * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
         * You can set this directly, or call `Loader.setPrefix()`. It will then affect every file added to the Loader
         * from that point on. It does _not_ change any file already in the load queue.
         *
         * @name Phaser.Loader.LoaderPlugin#prefix
         * @type {string}
         * @default ''
         * @since 3.7.0
         */ this.prefix = '';
                    /**
         * The value of `path`, if set, is placed before any _relative_ file path given. For example:
         *
         * ```javascript
         * this.load.path = "images/sprites/";
         * this.load.image("ball", "ball.png");
         * this.load.image("tree", "level1/oaktree.png");
         * this.load.image("boom", "http://server.com/explode.png");
         * ```
         *
         * Would load the `ball` file from `images/sprites/ball.png` and the tree from
         * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
         * given as it's an absolute URL.
         *
         * Please note that the path is added before the filename but *after* the baseURL (if set.)
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setPath()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#path
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.path = '';
                    /**
         * If you want to append a URL before the path of any asset you can set this here.
         *
         * Useful if allowing the asset base url to be configured outside of the game code.
         *
         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setBaseURL()` and it'll do it for you.
         *
         * @name Phaser.Loader.LoaderPlugin#baseURL
         * @type {string}
         * @default ''
         * @since 3.0.0
         */ this.baseURL = '';
                    this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
                    this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
                    this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
                    /**
         * The number of concurrent / parallel resources to try and fetch at once.
         *
         * Old browsers limit 6 requests per domain; modern ones, especially those with HTTP/2 don't limit it at all.
         *
         * The default is 32 but you can change this in your Game Config, or by changing this property before the Loader starts.
         *
         * @name Phaser.Loader.LoaderPlugin#maxParallelDownloads
         * @type {number}
         * @since 3.0.0
         */ this.maxParallelDownloads = GetFastValue(sceneConfig, 'maxParallelDownloads', gameConfig.loaderMaxParallelDownloads);
                    /**
         * xhr specific global settings (can be overridden on a per-file basis)
         *
         * @name Phaser.Loader.LoaderPlugin#xhr
         * @type {Phaser.Types.Loader.XHRSettingsObject}
         * @since 3.0.0
         */ this.xhr = XHRSettings(GetFastValue(sceneConfig, 'responseType', gameConfig.loaderResponseType), GetFastValue(sceneConfig, 'async', gameConfig.loaderAsync), GetFastValue(sceneConfig, 'user', gameConfig.loaderUser), GetFastValue(sceneConfig, 'password', gameConfig.loaderPassword), GetFastValue(sceneConfig, 'timeout', gameConfig.loaderTimeout), GetFastValue(sceneConfig, 'withCredentials', gameConfig.loaderWithCredentials));
                    /**
         * The crossOrigin value applied to loaded images. Very often this needs to be set to 'anonymous'.
         *
         * @name Phaser.Loader.LoaderPlugin#crossOrigin
         * @type {string}
         * @since 3.0.0
         */ this.crossOrigin = GetFastValue(sceneConfig, 'crossOrigin', gameConfig.loaderCrossOrigin);
                    /**
         * The total number of files to load. It may not always be accurate because you may add to the Loader during the process
         * of loading, especially if you load a Pack File. Therefore this value can change, but in most cases remains static.
         *
         * @name Phaser.Loader.LoaderPlugin#totalToLoad
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.totalToLoad = 0;
                    /**
         * The progress of the current load queue, as a float value between 0 and 1.
         * This is updated automatically as files complete loading.
         * Note that it is possible for this value to go down again if you add content to the current load queue during a load.
         *
         * @name Phaser.Loader.LoaderPlugin#progress
         * @type {number}
         * @default 0
         * @since 3.0.0
         */ this.progress = 0;
                    /**
         * Files are placed in this Set when they're added to the Loader via `addFile`.
         *
         * They are moved to the `inflight` Set when they start loading, and assuming a successful
         * load, to the `queue` Set for further processing.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#list
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.list = new CustomSet();
                    /**
         * Files are stored in this Set while they're in the process of being loaded.
         *
         * Upon a successful load they are moved to the `queue` Set.
         *
         * By the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#inflight
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.inflight = new CustomSet();
                    /**
         * Files are stored in this Set while they're being processed.
         *
         * If the process is successful they are moved to their final destination, which could be
         * a Cache or the Texture Manager.
         *
         * At the end of the load process this Set will be empty.
         *
         * @name Phaser.Loader.LoaderPlugin#queue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @since 3.0.0
         */ this.queue = new CustomSet();
                    /**
         * A temporary Set in which files are stored after processing,
         * awaiting destruction at the end of the load process.
         *
         * @name Phaser.Loader.LoaderPlugin#_deleteQueue
         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
         * @private
         * @since 3.7.0
         */ this._deleteQueue = new CustomSet();
                    /**
         * The total number of files that failed to load during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalFailed
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalFailed = 0;
                    /**
         * The total number of files that successfully loaded during the most recent load.
         * This value is reset when you call `Loader.start`.
         *
         * @name Phaser.Loader.LoaderPlugin#totalComplete
         * @type {number}
         * @default 0
         * @since 3.7.0
         */ this.totalComplete = 0;
                    /**
         * The current state of the Loader.
         *
         * @name Phaser.Loader.LoaderPlugin#state
         * @type {number}
         * @readonly
         * @since 3.0.0
         */ this.state = CONST.LOADER_IDLE;
                    /**
         * The current index being used by multi-file loaders to avoid key clashes.
         *
         * @name Phaser.Loader.LoaderPlugin#multiKeyIndex
         * @type {number}
         * @private
         * @since 3.20.0
         */ this.multiKeyIndex = 0;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.pluginStart, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Loader.LoaderPlugin#pluginStart
     * @private
     * @since 3.5.1
     */ pluginStart: function() {
                    this.systems.events.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * If you want to append a URL before the path of any asset you can set this here.
     *
     * Useful if allowing the asset base url to be configured outside of the game code.
     *
     * Once a base URL is set it will affect every file loaded by the Loader from that point on. It does _not_ change any
     * file _already_ being loaded. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setBaseURL
     * @since 3.0.0
     *
     * @param {string} [url] - The URL to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setBaseURL: function(url) {
                    if (url === undefined) url = '';
                    if (url !== '' && url.substr(-1) !== '/') url = url.concat('/');
                    this.baseURL = url;
                    return this;
                },
                /**
     * The value of `path`, if set, is placed before any _relative_ file path given. For example:
     *
     * ```javascript
     * this.load.setPath("images/sprites/");
     * this.load.image("ball", "ball.png");
     * this.load.image("tree", "level1/oaktree.png");
     * this.load.image("boom", "http://server.com/explode.png");
     * ```
     *
     * Would load the `ball` file from `images/sprites/ball.png` and the tree from
     * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
     * given as it's an absolute URL.
     *
     * Please note that the path is added before the filename but *after* the baseURL (if set.)
     *
     * Once a path is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPath
     * @since 3.0.0
     *
     * @param {string} [path] - The path to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPath: function(path) {
                    if (path === undefined) path = '';
                    if (path !== '' && path.substr(-1) !== '/') path = path.concat('/');
                    this.path = path;
                    return this;
                },
                /**
     * An optional prefix that is automatically prepended to the start of every file key.
     *
     * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
     *
     * Once a prefix is set it will then affect every file added to the Loader from that point on. It does _not_ change any
     * file _already_ in the load queue. To reset it, call this method with no arguments.
     *
     * @method Phaser.Loader.LoaderPlugin#setPrefix
     * @since 3.7.0
     *
     * @param {string} [prefix] - The prefix to use. Leave empty to reset.
     *
     * @return {this} This Loader object.
     */ setPrefix: function(prefix) {
                    if (prefix === undefined) prefix = '';
                    this.prefix = prefix;
                    return this;
                },
                /**
     * Sets the Cross Origin Resource Sharing value used when loading files.
     *
     * Files can override this value on a per-file basis by specifying an alternative `crossOrigin` value in their file config.
     *
     * Once CORs is set it will then affect every file loaded by the Loader from that point on, as long as they don't have
     * their own CORs setting. To reset it, call this method with no arguments.
     *
     * For more details about CORs see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
     *
     * @method Phaser.Loader.LoaderPlugin#setCORS
     * @since 3.0.0
     *
     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the load request.
     *
     * @return {this} This Loader object.
     */ setCORS: function(crossOrigin) {
                    this.crossOrigin = crossOrigin;
                    return this;
                },
                /**
     * Adds a file, or array of files, into the load queue.
     *
     * The file must be an instance of `Phaser.Loader.File`, or a class that extends it. The Loader will check that the key
     * used by the file won't conflict with any other key either in the loader, the inflight queue or the target cache.
     * If allowed it will then add the file into the pending list, read for the load to start. Or, if the load has already
     * started, ready for the next batch of files to be pulled from the list to the inflight queue.
     *
     * You should not normally call this method directly, but rather use one of the Loader methods like `image` or `atlas`,
     * however you can call this as long as the file given to it is well formed.
     *
     * @method Phaser.Loader.LoaderPlugin#addFile
     * @fires Phaser.Loader.Events#ADD
     * @since 3.0.0
     *
     * @param {(Phaser.Loader.File|Phaser.Loader.File[])} file - The file, or array of files, to be added to the load queue.
     */ addFile: function(file) {
                    if (!Array.isArray(file)) file = [
                        file
                    ];
                    for(var i = 0; i < file.length; i++){
                        var item = file[i];
                        //  Does the file already exist in the cache or texture manager?
                        //  Or will it conflict with a file already in the queue or inflight?
                        if (!this.keyExists(item)) {
                            this.list.set(item);
                            this.emit(Events.ADD, item.key, item.type, this, item);
                            if (this.isLoading()) {
                                this.totalToLoad++;
                                this.updateProgress();
                            }
                        }
                    }
                },
                /**
     * Checks the key and type of the given file to see if it will conflict with anything already
     * in a Cache, the Texture Manager, or the list or inflight queues.
     *
     * @method Phaser.Loader.LoaderPlugin#keyExists
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file to check the key of.
     *
     * @return {boolean} `true` if adding this file will cause a cache or queue conflict, otherwise `false`.
     */ keyExists: function(file) {
                    var keyConflict = file.hasCacheConflict();
                    if (!keyConflict) this.list.iterate(function(item) {
                        if (item.type === file.type && item.key === file.key) {
                            keyConflict = true;
                            return false;
                        }
                    });
                    if (!keyConflict && this.isLoading()) {
                        this.inflight.iterate(function(item) {
                            if (item.type === file.type && item.key === file.key) {
                                keyConflict = true;
                                return false;
                            }
                        });
                        this.queue.iterate(function(item) {
                            if (item.type === file.type && item.key === file.key) {
                                keyConflict = true;
                                return false;
                            }
                        });
                    }
                    return keyConflict;
                },
                /**
     * Takes a well formed, fully parsed pack file object and adds its entries into the load queue. Usually you do not call
     * this method directly, but instead use `Loader.pack` and supply a path to a JSON file that holds the
     * pack data. However, if you've got the data prepared you can pass it to this method.
     *
     * You can also provide an optional key. If you do then it will only add the entries from that part of the pack into
     * to the load queue. If not specified it will add all entries it finds. For more details about the pack file format
     * see the `LoaderPlugin.pack` method.
     *
     * @method Phaser.Loader.LoaderPlugin#addPack
     * @since 3.7.0
     *
     * @param {any} pack - The Pack File data to be parsed and each entry of it to added to the load queue.
     * @param {string} [packKey] - An optional key to use from the pack file data.
     *
     * @return {boolean} `true` if any files were added to the queue, otherwise `false`.
     */ addPack: function(pack, packKey) {
                    //  if no packKey provided we'll add everything to the queue
                    if (packKey && pack.hasOwnProperty(packKey)) pack = {
                        packKey: pack[packKey]
                    };
                    var total = 0;
                    //  Store the loader settings in case this pack replaces them
                    var currentBaseURL = this.baseURL;
                    var currentPath = this.path;
                    var currentPrefix = this.prefix;
                    //  Here we go ...
                    for(var key in pack){
                        if (!Object.prototype.hasOwnProperty.call(pack, key)) continue;
                        var config = pack[key];
                        //  Any meta data to process?
                        var baseURL = GetFastValue(config, 'baseURL', currentBaseURL);
                        var path = GetFastValue(config, 'path', currentPath);
                        var prefix = GetFastValue(config, 'prefix', currentPrefix);
                        var files = GetFastValue(config, 'files', null);
                        var defaultType = GetFastValue(config, 'defaultType', 'void');
                        if (Array.isArray(files)) {
                            this.setBaseURL(baseURL);
                            this.setPath(path);
                            this.setPrefix(prefix);
                            for(var i = 0; i < files.length; i++){
                                var file = files[i];
                                var type = file.hasOwnProperty('type') ? file.type : defaultType;
                                if (this[type]) {
                                    this[type](file);
                                    total++;
                                }
                            }
                        }
                    }
                    //  Reset the loader settings
                    this.setBaseURL(currentBaseURL);
                    this.setPath(currentPath);
                    this.setPrefix(currentPrefix);
                    return total > 0;
                },
                /**
     * Is the Loader actively loading, or processing loaded files?
     *
     * @method Phaser.Loader.LoaderPlugin#isLoading
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is busy loading or processing, otherwise `false`.
     */ isLoading: function() {
                    return this.state === CONST.LOADER_LOADING || this.state === CONST.LOADER_PROCESSING;
                },
                /**
     * Is the Loader ready to start a new load?
     *
     * @method Phaser.Loader.LoaderPlugin#isReady
     * @since 3.0.0
     *
     * @return {boolean} `true` if the Loader is ready to start a new load, otherwise `false`.
     */ isReady: function() {
                    return this.state === CONST.LOADER_IDLE || this.state === CONST.LOADER_COMPLETE;
                },
                /**
     * Starts the Loader running. This will reset the progress and totals and then emit a `start` event.
     * If there is nothing in the queue the Loader will immediately complete, otherwise it will start
     * loading the first batch of files.
     *
     * The Loader is started automatically if the queue is populated within your Scenes `preload` method.
     *
     * However, outside of this, you need to call this method to start it.
     *
     * If the Loader is already running this method will simply return.
     *
     * @method Phaser.Loader.LoaderPlugin#start
     * @fires Phaser.Loader.Events#START
     * @since 3.0.0
     */ start: function() {
                    if (!this.isReady()) return;
                    this.progress = 0;
                    this.totalFailed = 0;
                    this.totalComplete = 0;
                    this.totalToLoad = this.list.size;
                    this.emit(Events.START, this);
                    if (this.list.size === 0) this.loadComplete();
                    else {
                        this.state = CONST.LOADER_LOADING;
                        this.inflight.clear();
                        this.queue.clear();
                        this.updateProgress();
                        this.checkLoadQueue();
                        this.systems.events.on(SceneEvents.UPDATE, this.update, this);
                    }
                },
                /**
     * Called automatically during the load process.
     * It updates the `progress` value and then emits a progress event, which you can use to
     * display a loading bar in your game.
     *
     * @method Phaser.Loader.LoaderPlugin#updateProgress
     * @fires Phaser.Loader.Events#PROGRESS
     * @since 3.0.0
     */ updateProgress: function() {
                    this.progress = 1 - (this.list.size + this.inflight.size) / this.totalToLoad;
                    this.emit(Events.PROGRESS, this.progress);
                },
                /**
     * Called automatically during the load process.
     *
     * @method Phaser.Loader.LoaderPlugin#update
     * @since 3.10.0
     */ update: function() {
                    if (this.state === CONST.LOADER_LOADING && this.list.size > 0 && this.inflight.size < this.maxParallelDownloads) this.checkLoadQueue();
                },
                /**
     * An internal method called by the Loader.
     *
     * It will check to see if there are any more files in the pending list that need loading, and if so it will move
     * them from the list Set into the inflight Set, set their CORs flag and start them loading.
     *
     * It will carrying on doing this for each file in the pending list until it runs out, or hits the max allowed parallel downloads.
     *
     * @method Phaser.Loader.LoaderPlugin#checkLoadQueue
     * @private
     * @since 3.7.0
     */ checkLoadQueue: function() {
                    this.list.each(function(file) {
                        if (file.state === CONST.FILE_POPULATED || file.state === CONST.FILE_PENDING && this.inflight.size < this.maxParallelDownloads) {
                            this.inflight.set(file);
                            this.list.delete(file);
                            //  If the file doesn't have its own crossOrigin set, we'll use the Loaders (which is undefined by default)
                            if (!file.crossOrigin) file.crossOrigin = this.crossOrigin;
                            file.load();
                        }
                        if (this.inflight.size === this.maxParallelDownloads) //  Tells the Set iterator to abort
                        return false;
                    }, this);
                },
                /**
     * An internal method called automatically by the XHRLoader belong to a File.
     *
     * This method will remove the given file from the inflight Set and update the load progress.
     * If the file was successful its `onProcess` method is called, otherwise it is added to the delete queue.
     *
     * @method Phaser.Loader.LoaderPlugin#nextFile
     * @fires Phaser.Loader.Events#FILE_LOAD
     * @fires Phaser.Loader.Events#FILE_LOAD_ERROR
     * @since 3.0.0
     *
     * @param {Phaser.Loader.File} file - The File that just finished loading, or errored during load.
     * @param {boolean} success - `true` if the file loaded successfully, otherwise `false`.
     */ nextFile: function(file, success) {
                    //  Has the game been destroyed during load? If so, bail out now.
                    if (!this.inflight) return;
                    this.inflight.delete(file);
                    this.updateProgress();
                    if (success) {
                        this.totalComplete++;
                        this.queue.set(file);
                        this.emit(Events.FILE_LOAD, file);
                        file.onProcess();
                    } else {
                        this.totalFailed++;
                        this._deleteQueue.set(file);
                        this.emit(Events.FILE_LOAD_ERROR, file);
                        this.fileProcessComplete(file);
                    }
                },
                /**
     * An internal method that is called automatically by the File when it has finished processing.
     *
     * If the process was successful, and the File isn't part of a MultiFile, its `addToCache` method is called.
     *
     * It this then removed from the queue. If there are no more files to load `loadComplete` is called.
     *
     * @method Phaser.Loader.LoaderPlugin#fileProcessComplete
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The file that has finished processing.
     */ fileProcessComplete: function(file) {
                    //  Has the game been destroyed during load? If so, bail out now.
                    if (!this.scene || !this.systems || !this.systems.game || this.systems.game.pendingDestroy) return;
                    //  This file has failed, so move it to the failed Set
                    if (file.state === CONST.FILE_ERRORED) {
                        if (file.multiFile) file.multiFile.onFileFailed(file);
                    } else if (file.state === CONST.FILE_COMPLETE) {
                        if (file.multiFile) {
                            if (file.multiFile.isReadyToProcess()) //  If we got here then all files the link file needs are ready to add to the cache
                            file.multiFile.addToCache();
                        } else //  If we got here, then the file processed, so let it add itself to its cache
                        file.addToCache();
                    }
                    //  Remove it from the queue
                    this.queue.delete(file);
                    //  Nothing left to do?
                    if (this.list.size === 0 && this.inflight.size === 0 && this.queue.size === 0) this.loadComplete();
                },
                /**
     * Called at the end when the load queue is exhausted and all files have either loaded or errored.
     * By this point every loaded file will now be in its associated cache and ready for use.
     *
     * Also clears down the Sets, puts progress to 1 and clears the deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#loadComplete
     * @fires Phaser.Loader.Events#COMPLETE
     * @fires Phaser.Loader.Events#POST_PROCESS
     * @since 3.7.0
     */ loadComplete: function() {
                    this.emit(Events.POST_PROCESS, this);
                    this.list.clear();
                    this.inflight.clear();
                    this.queue.clear();
                    this.progress = 1;
                    this.state = CONST.LOADER_COMPLETE;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    //  Call 'destroy' on each file ready for deletion
                    this._deleteQueue.iterateLocal('destroy');
                    this._deleteQueue.clear();
                    this.emit(Events.COMPLETE, this, this.totalComplete, this.totalFailed);
                },
                /**
     * Adds a File into the pending-deletion queue.
     *
     * @method Phaser.Loader.LoaderPlugin#flagForRemoval
     * @since 3.7.0
     *
     * @param {Phaser.Loader.File} file - The File to be queued for deletion when the Loader completes.
     */ flagForRemoval: function(file) {
                    this._deleteQueue.set(file);
                },
                /**
     * Converts the given JSON data into a file that the browser then prompts you to download so you can save it locally.
     *
     * The data must be well formed JSON and ready-parsed, not a JavaScript object.
     *
     * @method Phaser.Loader.LoaderPlugin#saveJSON
     * @since 3.0.0
     *
     * @param {*} data - The JSON data, ready parsed.
     * @param {string} [filename=file.json] - The name to save the JSON file as.
     *
     * @return {this} This Loader plugin.
     */ saveJSON: function(data, filename) {
                    return this.save(JSON.stringify(data), filename);
                },
                /**
     * Causes the browser to save the given data as a file to its default Downloads folder.
     *
     * Creates a DOM level anchor link, assigns it as being a `download` anchor, sets the href
     * to be an ObjectURL based on the given data, and then invokes a click event.
     *
     * @method Phaser.Loader.LoaderPlugin#save
     * @since 3.0.0
     *
     * @param {*} data - The data to be saved. Will be passed through URL.createObjectURL.
     * @param {string} [filename=file.json] - The filename to save the file as.
     * @param {string} [filetype=application/json] - The file type to use when saving the file. Defaults to JSON.
     *
     * @return {this} This Loader plugin.
     */ save: function(data, filename, filetype) {
                    if (filename === undefined) filename = 'file.json';
                    if (filetype === undefined) filetype = 'application/json';
                    var blob = new Blob([
                        data
                    ], {
                        type: filetype
                    });
                    var url = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.download = filename;
                    a.textContent = 'Download ' + filename;
                    a.href = url;
                    a.click();
                    return this;
                },
                /**
     * Resets the Loader.
     *
     * This will clear all lists and reset the base URL, path and prefix.
     *
     * Warning: If the Loader is currently downloading files, or has files in its queue, they will be aborted.
     *
     * @method Phaser.Loader.LoaderPlugin#reset
     * @since 3.0.0
     */ reset: function() {
                    this.list.clear();
                    this.inflight.clear();
                    this.queue.clear();
                    var gameConfig = this.systems.game.config;
                    var sceneConfig = this.systems.settings.loader;
                    this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
                    this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
                    this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
                    this.state = CONST.LOADER_IDLE;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Loader.LoaderPlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    this.reset();
                    this.state = CONST.LOADER_SHUTDOWN;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    this.systems.events.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Loader.LoaderPlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.state = CONST.LOADER_DESTROYED;
                    this.systems.events.off(SceneEvents.UPDATE, this.update, this);
                    this.systems.events.off(SceneEvents.START, this.pluginStart, this);
                    this.list = null;
                    this.inflight = null;
                    this.queue = null;
                    this.scene = null;
                    this.systems = null;
                    this.textureManager = null;
                    this.cacheManager = null;
                    this.sceneManager = null;
                }
            });
            PluginCache.register('Loader', LoaderPlugin, 'load');
            module1.exports = LoaderPlugin;
        /***/ },
        /* 1360 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(60);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Physics.Arcade
 */ var Arcade = {
                ArcadePhysics: __webpack_require__(1361),
                Body: __webpack_require__(521),
                Collider: __webpack_require__(522),
                Components: __webpack_require__(240),
                Events: __webpack_require__(242),
                Factory: __webpack_require__(515),
                GetOverlapX: __webpack_require__(243),
                GetOverlapY: __webpack_require__(244),
                SeparateX: __webpack_require__(531),
                SeparateY: __webpack_require__(532),
                Group: __webpack_require__(518),
                Image: __webpack_require__(516),
                Sprite: __webpack_require__(155),
                StaticBody: __webpack_require__(533),
                StaticGroup: __webpack_require__(519),
                Tilemap: __webpack_require__(1385),
                World: __webpack_require__(520)
            };
            //   Merge in the consts
            Arcade = Extend(false, Arcade, CONST);
            module1.exports = Arcade;
        /***/ },
        /* 1361 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var DegToRad = __webpack_require__(35);
            var DistanceBetween = __webpack_require__(48);
            var DistanceSquared = __webpack_require__(347);
            var Factory = __webpack_require__(515);
            var GetFastValue = __webpack_require__(2);
            var Merge = __webpack_require__(143);
            var OverlapCirc = __webpack_require__(517);
            var OverlapRect = __webpack_require__(241);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            var Vector2 = __webpack_require__(3);
            var World = __webpack_require__(520);
            /**
 * @classdesc
 * The Arcade Physics Plugin belongs to a Scene and sets up and manages the Scene's physics simulation.
 * It also holds some useful methods for moving and rotating Arcade Physics Bodies.
 *
 * You can access it from within a Scene using `this.physics`.
 *
 * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
 * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
 * The separation that stops two objects penetrating may create a new penetration against a different object. If you
 * require a high level of stability please consider using an alternative physics system, such as Matter.js.
 *
 * @class ArcadePhysics
 * @memberof Phaser.Physics.Arcade
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this Plugin belongs to.
 */ var ArcadePhysics = new Class({
                initialize: function ArcadePhysics(scene) {
                    /**
         * The Scene that this Plugin belongs to.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene's Systems.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * A configuration object. Union of the `physics.arcade.*` properties of the GameConfig and SceneConfig objects.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#config
         * @type {Phaser.Types.Physics.Arcade.ArcadeWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                    /**
         * The physics simulation.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#world
         * @type {Phaser.Physics.Arcade.World}
         * @since 3.0.0
         */ this.world;
                    /**
         * An object holding the Arcade Physics factory methods.
         *
         * @name Phaser.Physics.Arcade.ArcadePhysics#add
         * @type {Phaser.Physics.Arcade.Factory}
         * @since 3.0.0
         */ this.add;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.world = new World(this.scene, this.config);
                    this.add = new Factory(this.world);
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    if (!this.world) {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                    }
                    var eventEmitter = this.systems.events;
                    if (!GetFastValue(this.config, 'customUpdate', false)) eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Causes `World.update` to be automatically called each time the Scene
     * emits and `UPDATE` event. This is the default setting, so only needs
     * calling if you have specifically disabled it.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#enableUpdate
     * @since 3.50.0
     */ enableUpdate: function() {
                    this.systems.events.on(SceneEvents.UPDATE, this.world.update, this.world);
                },
                /**
     * Causes `World.update` to **not** be automatically called each time the Scene
     * emits and `UPDATE` event.
     *
     * If you wish to run the World update at your own rate, or from your own
     * component, then you should call this method to disable the built-in link,
     * and then call `World.update(delta, time)` accordingly.
     *
     * Note that `World.postUpdate` is always automatically called when the Scene
     * emits a `POST_UPDATE` event, regardless of this setting.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#disableUpdate
     * @since 3.50.0
     */ disableUpdate: function() {
                    this.systems.events.off(SceneEvents.UPDATE, this.world.update, this.world);
                },
                /**
     * Creates the physics configuration for the current Scene.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Arcade.ArcadeWorldConfig} The physics configuration.
     */ getConfig: function() {
                    var gameConfig = this.systems.game.config.physics;
                    var sceneConfig = this.systems.settings.physics;
                    var config = Merge(GetFastValue(sceneConfig, 'arcade', {}), GetFastValue(gameConfig, 'arcade', {}));
                    return config;
                },
                /**
     * Tests if Game Objects overlap. See {@link Phaser.Physics.Arcade.World#overlap}
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlap
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if at least one Game Object overlaps another.
     *
     * @see Phaser.Physics.Arcade.World#overlap
     */ overlap: function(object1, object2, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    return this.world.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
                },
                /**
     * Performs a collision check and separation between the two physics enabled objects given, which can be single
     * Game Objects, arrays of Game Objects, Physics Groups, arrays of Physics Groups or normal Groups.
     *
     * If you don't require separation then use {@link #overlap} instead.
     *
     * If two Groups or arrays are passed, each member of one will be tested against each member of the other.
     *
     * If **only** one Group is passed (as `object1`), each member of the Group will be collided against the other members.
     *
     * If **only** one Array is passed, the array is iterated and every element in it is tested against the others.
     *
     * Two callbacks can be provided. The `collideCallback` is invoked if a collision occurs and the two colliding
     * objects are passed to it.
     *
     * Arcade Physics uses the Projection Method of collision resolution and separation. While it's fast and suitable
     * for 'arcade' style games it lacks stability when multiple objects are in close proximity or resting upon each other.
     * The separation that stops two objects penetrating may create a new penetration against a different object. If you
     * require a high level of stability please consider using an alternative physics system, such as Matter.js.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collide
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} object1 - The first object or array of objects to check.
     * @param {Phaser.Types.Physics.Arcade.ArcadeColliderType} [object2] - The second object or array of objects to check, or `undefined`.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {*} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any overlapping Game Objects were separated, otherwise false.
     *
     * @see Phaser.Physics.Arcade.World#collide
     */ collide: function(object1, object2, collideCallback, processCallback, callbackContext) {
                    if (collideCallback === undefined) collideCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = collideCallback;
                    return this.world.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
                },
                /**
     * This advanced method is specifically for testing for collision between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `collide` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for collision with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic collisions
     * on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * Important: Use of this method skips the `interesting faces` system that Tilemap Layers use. This means if you have
     * say a row or column of tiles, and you jump into, or walk over them, it's possible to get stuck on the edges of the
     * tiles as the interesting face calculations are skipped. However, for quick-fire small collision set tests on
     * dynamic maps, this method can prove very useful.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#collideTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_COLLIDE
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects collide.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ collideTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    return this.world.collideTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                },
                /**
     * This advanced method is specifically for testing for overlaps between a single Sprite and an array of Tile objects.
     *
     * You should generally use the `overlap` method instead, with a Sprite vs. a Tilemap Layer, as that will perform
     * tile filtering and culling for you, as well as handle the interesting face collision automatically.
     *
     * This method is offered for those who would like to check for overlaps with specific Tiles in a layer, without
     * having to set any collision attributes on the tiles in question. This allows you to perform quick dynamic overlap
     * tests on small sets of Tiles. As such, no culling or checks are made to the array of Tiles given to this method,
     * you should filter them before passing them to this method.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapTiles
     * @fires Phaser.Physics.Arcade.Events#TILE_OVERLAP
     * @since 3.17.0
     *
     * @param {Phaser.GameObjects.GameObject} sprite - The first object to check for collision.
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of Tiles to check for collision against.
     * @param {ArcadePhysicsCallback} [collideCallback] - An optional callback function that is called if the objects overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
     * @param {any} [callbackContext] - The context in which to run the callbacks.
     *
     * @return {boolean} True if any objects overlap (with `overlapOnly`); or true if any overlapping objects were separated.
     */ overlapTiles: function(sprite, tiles, collideCallback, processCallback, callbackContext) {
                    return this.world.overlapTiles(sprite, tiles, collideCallback, processCallback, callbackContext);
                },
                /**
     * Pauses the simulation.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#pause
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ pause: function() {
                    return this.world.pause();
                },
                /**
     * Resumes the simulation (if paused).
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Arcade.World} The simulation.
     */ resume: function() {
                    return this.world.resume();
                },
                /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to accelerate towards.
     * @param {number} y - The y coordinate to accelerate towards.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateTo: function(gameObject, x, y, speed, xSpeedMax, ySpeedMax) {
                    if (speed === undefined) speed = 60;
                    var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                    gameObject.body.acceleration.setToPolar(angle, speed);
                    if (xSpeedMax !== undefined && ySpeedMax !== undefined) gameObject.body.maxVelocity.set(xSpeedMax, ySpeedMax);
                    return angle;
                },
                /**
     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
     *
     * You must give a maximum speed value, beyond which the game object won't go any faster.
     *
     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {Phaser.GameObjects.GameObject} destination - The Game Object to move towards. Can be any object but must have visible x/y properties.
     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ accelerateToObject: function(gameObject, destination, speed, xSpeedMax, ySpeedMax) {
                    return this.accelerateTo(gameObject, destination.x, destination.y, speed, xSpeedMax, ySpeedMax);
                },
                /**
     * Finds the Body or Game Object closest to a source point or object.
     *
     * If a `targets` argument is passed, this method finds the closest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the closest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#closest
     * @since 3.0.0
     *
     * @param {any} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[]|Phaser.GameObjects.GameObject[])} [targets] - The targets.
     *
     * @return {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject)} The target closest to the given source point.
     */ closest: function(source, targets) {
                    if (!targets) targets = this.world.bodies.entries;
                    var min = Number.MAX_VALUE;
                    var closest = null;
                    var x = source.x;
                    var y = source.y;
                    var len = targets.length;
                    for(var i = 0; i < len; i++){
                        var target = targets[i];
                        var body = target.body || target;
                        if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                        var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                        if (distance < min) {
                            closest = target;
                            min = distance;
                        }
                    }
                    return closest;
                },
                /**
     * Finds the Body or Game Object farthest from a source point or object.
     *
     * If a `targets` argument is passed, this method finds the farthest of those.
     * The targets can be Arcade Physics Game Objects, Dynamic Bodies, or Static Bodies.
     *
     * If no `targets` argument is passed, this method finds the farthest Dynamic Body.
     *
     * If two or more targets are the exact same distance from the source point, only the first target
     * is returned.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#furthest
     * @since 3.0.0
     *
     * @param {any} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[]|Phaser.GameObjects.GameObject[])} [targets] - The targets.
     *
     * @return {?(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody|Phaser.GameObjects.GameObject)} The target farthest from the given source point.
     */ furthest: function(source, targets) {
                    if (!targets) targets = this.world.bodies.entries;
                    var max = -1;
                    var farthest = null;
                    var x = source.x;
                    var y = source.y;
                    var len = targets.length;
                    for(var i = 0; i < len; i++){
                        var target = targets[i];
                        var body = target.body || target;
                        if (source === target || source === body || source === body.gameObject || source === body.center) continue;
                        var distance = DistanceSquared(x, y, body.center.x, body.center.y);
                        if (distance > max) {
                            farthest = target;
                            max = distance;
                        }
                    }
                    return farthest;
                },
                /**
     * Move the given display object towards the x/y coordinates at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveTo
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {number} x - The x coordinate to move towards.
     * @param {number} y - The y coordinate to move towards.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveTo: function(gameObject, x, y, speed, maxTime) {
                    if (speed === undefined) speed = 60;
                    if (maxTime === undefined) maxTime = 0;
                    var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
                    if (maxTime > 0) //  We know how many pixels we need to move, but how fast?
                    speed = DistanceBetween(gameObject.x, gameObject.y, x, y) / (maxTime / 1000);
                    gameObject.body.velocity.setToPolar(angle, speed);
                    return angle;
                },
                /**
     * Move the given display object towards the destination object at a steady velocity.
     * If you specify a maxTime then it will adjust the speed (overwriting what you set) so it arrives at the destination in that number of seconds.
     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#moveToObject
     * @since 3.0.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
     * @param {object} destination - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
     *
     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
     */ moveToObject: function(gameObject, destination, speed, maxTime) {
                    return this.moveTo(gameObject, destination.x, destination.y, speed, maxTime);
                },
                /**
     * Given the angle (in degrees) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromAngle(angle, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromAngle
     * @since 3.0.0
     *
     * @param {number} angle - The angle in degrees calculated in clockwise positive direction (down = 90 degrees positive, right = 0 degrees positive, up = 90 degrees negative)
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared.
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromAngle: function(angle, speed, vec2) {
                    if (speed === undefined) speed = 60;
                    if (vec2 === undefined) vec2 = new Vector2();
                    return vec2.setToPolar(DegToRad(angle), speed);
                },
                /**
     * Given the rotation (in radians) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
     * One way to use this is: velocityFromRotation(rotation, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromRotation
     * @since 3.0.0
     *
     * @param {number} rotation - The angle in radians.
     * @param {number} [speed=60] - The speed it will move, in pixels per second squared
     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
     *
     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
     */ velocityFromRotation: function(rotation, speed, vec2) {
                    if (speed === undefined) speed = 60;
                    if (vec2 === undefined) vec2 = new Vector2();
                    return vec2.setToPolar(rotation, speed);
                },
                /**
     * This method will search the given rectangular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search for is extremely fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapRect
     * @since 3.17.0
     *
     * @param {number} x - The top-left x coordinate of the area to search within.
     * @param {number} y - The top-left y coordinate of the area to search within.
     * @param {number} width - The width of the area to search within.
     * @param {number} height - The height of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapRect: function(x, y, width, height, includeDynamic, includeStatic) {
                    return OverlapRect(this.world, x, y, width, height, includeDynamic, includeStatic);
                },
                /**
     * This method will search the given circular area and return an array of all physics bodies that
     * overlap with it. It can return either Dynamic, Static bodies or a mixture of both.
     *
     * A body only has to intersect with the search area to be considered, it doesn't have to be fully
     * contained within it.
     *
     * If Arcade Physics is set to use the RTree (which it is by default) then the search is rather fast,
     * otherwise the search is O(N) for Dynamic Bodies.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#overlapCirc
     * @since 3.21.0
     *
     * @param {number} x - The x coordinate of the center of the area to search within.
     * @param {number} y - The y coordinate of the center of the area to search within.
     * @param {number} radius - The radius of the area to search within.
     * @param {boolean} [includeDynamic=true] - Should the search include Dynamic Bodies?
     * @param {boolean} [includeStatic=false] - Should the search include Static Bodies?
     *
     * @return {(Phaser.Physics.Arcade.Body[]|Phaser.Physics.Arcade.StaticBody[])} An array of bodies that overlap with the given area.
     */ overlapCirc: function(x, y, radius, includeDynamic, includeStatic) {
                    return OverlapCirc(this.world, x, y, radius, includeDynamic, includeStatic);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    if (!this.world) //  Already destroyed
                    return;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.add.destroy();
                    this.world.destroy();
                    this.add = null;
                    this.world = null;
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Arcade.ArcadePhysics#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('ArcadePhysics', ArcadePhysics, 'arcadePhysics');
            module1.exports = ArcadePhysics;
        /***/ },
        /* 1362 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Acceleration
 * @since 3.0.0
 */ var Acceleration = {
                /**
     * Sets the body's horizontal and vertical acceleration. If the vertical acceleration value is not provided, the vertical acceleration is set to the same value as the horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAcceleration
     * @since 3.0.0
     *
     * @param {number} x - The horizontal acceleration
     * @param {number} [y=x] - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAcceleration: function(x, y) {
                    this.body.acceleration.set(x, y);
                    return this;
                },
                /**
     * Sets the body's horizontal acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationX
     * @since 3.0.0
     *
     * @param {number} value - The horizontal acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationX: function(value) {
                    this.body.acceleration.x = value;
                    return this;
                },
                /**
     * Sets the body's vertical acceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationY
     * @since 3.0.0
     *
     * @param {number} value - The vertical acceleration
     *
     * @return {this} This Game Object.
     */ setAccelerationY: function(value) {
                    this.body.acceleration.y = value;
                    return this;
                }
            };
            module1.exports = Acceleration;
        /***/ },
        /* 1363 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the angular acceleration properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Angular
 * @since 3.0.0
 */ var Angular = {
                /**
     * Sets the angular velocity of the body.
     * 
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular velocity.
     *
     * @return {this} This Game Object.
     */ setAngularVelocity: function(value) {
                    this.body.angularVelocity = value;
                    return this;
                },
                /**
     * Sets the angular acceleration of the body.
     * 
     * In Arcade Physics, bodies cannot rotate. They are always axis-aligned.
     * However, they can have angular motion, which is passed on to the Game Object bound to the body,
     * causing them to visually rotate, even though the body remains axis-aligned.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularAcceleration
     * @since 3.0.0
     *
     * @param {number} value - The amount of angular acceleration.
     *
     * @return {this} This Game Object.
     */ setAngularAcceleration: function(value) {
                    this.body.angularAcceleration = value;
                    return this;
                },
                /**
     * Sets the angular drag of the body. Drag is applied to the current velocity, providing a form of deceleration.
     *
     * @method Phaser.Physics.Arcade.Components.Angular#setAngularDrag
     * @since 3.0.0
     *
     * @param {number} value - The amount of drag.
     *
     * @return {this} This Game Object.
     */ setAngularDrag: function(value) {
                    this.body.angularDrag = value;
                    return this;
                }
            };
            module1.exports = Angular;
        /***/ },
        /* 1364 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the bounce properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                /**
     * Sets the bounce values of this body.
     * 
     * Bounce is the amount of restitution, or elasticity, the body has when it collides with another object.
     * A value of 1 means that it will retain its full velocity after the rebound. A value of 0 means it will not rebound at all.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     * @param {number} [y=x] - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounce: function(x, y) {
                    this.body.bounce.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceX: function(value) {
                    this.body.bounce.x = value;
                    return this;
                },
                /**
     * Sets the vertical bounce value for this body.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical bounce to apply on collision. A float, typically between 0 and 1.
     *
     * @return {this} This Game Object.
     */ setBounceY: function(value) {
                    this.body.bounce.y = value;
                    return this;
                },
                /**
     * Sets whether this Body collides with the world boundary.
     * 
     * Optionally also sets the World Bounce values. If the `Body.worldBounce` is null, it's set to a new Phaser.Math.Vector2 first.
     *
     * @method Phaser.Physics.Arcade.Components.Bounce#setCollideWorldBounds
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - `true` if this body should collide with the world bounds, otherwise `false`.
     * @param {number} [bounceX] - If given this will be replace the `worldBounce.x` value.
     * @param {number} [bounceY] - If given this will be replace the `worldBounce.y` value.
     *
     * @return {this} This Game Object.
     */ setCollideWorldBounds: function(value, bounceX, bounceY) {
                    this.body.setCollideWorldBounds(value, bounceX, bounceY);
                    return this;
                }
            };
            module1.exports = Bounce;
        /***/ },
        /* 1365 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the debug properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Debug
 * @since 3.0.0
 */ var Debug = {
                /**
     * Sets the debug values of this body.
     * 
     * Bodies will only draw their debug if debug has been enabled for Arcade Physics as a whole.
     * Note that there is a performance cost in drawing debug displays. It should never be used in production.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebug
     * @since 3.0.0
     *
     * @param {boolean} showBody - Set to `true` to have this body render its outline to the debug display.
     * @param {boolean} showVelocity - Set to `true` to have this body render a velocity marker to the debug display.
     * @param {number} bodyColor - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebug: function(showBody, showVelocity, bodyColor) {
                    this.debugShowBody = showBody;
                    this.debugShowVelocity = showVelocity;
                    this.debugBodyColor = bodyColor;
                    return this;
                },
                /**
     * Sets the color of the body outline when it renders to the debug display.
     *
     * @method Phaser.Physics.Arcade.Components.Debug#setDebugBodyColor
     * @since 3.0.0
     *
     * @param {number} value - The color of the body outline when rendered to the debug display.
     *
     * @return {this} This Game Object.
     */ setDebugBodyColor: function(value) {
                    this.body.debugBodyColor = value;
                    return this;
                },
                /**
     * Set to `true` to have this body render its outline to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowBody
     * @type {boolean}
     * @since 3.0.0
     */ debugShowBody: {
                    get: function() {
                        return this.body.debugShowBody;
                    },
                    set: function(value) {
                        this.body.debugShowBody = value;
                    }
                },
                /**
     * Set to `true` to have this body render a velocity marker to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugShowVelocity
     * @type {boolean}
     * @since 3.0.0
     */ debugShowVelocity: {
                    get: function() {
                        return this.body.debugShowVelocity;
                    },
                    set: function(value) {
                        this.body.debugShowVelocity = value;
                    }
                },
                /**
     * The color of the body outline when it renders to the debug display.
     *
     * @name Phaser.Physics.Arcade.Components.Debug#debugBodyColor
     * @type {number}
     * @since 3.0.0
     */ debugBodyColor: {
                    get: function() {
                        return this.body.debugBodyColor;
                    },
                    set: function(value) {
                        this.body.debugBodyColor = value;
                    }
                }
            };
            module1.exports = Debug;
        /***/ },
        /* 1366 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the drag properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Drag
 * @since 3.0.0
 */ var Drag = {
                /**
     * Sets the body's horizontal and vertical drag. If the vertical drag value is not provided, the vertical drag is set to the same value as the horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDrag
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal drag to apply.
     * @param {number} [y=x] - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDrag: function(x, y) {
                    this.body.drag.set(x, y);
                    return this;
                },
                /**
     * Sets the body's horizontal drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragX
     * @since 3.0.0
     *
     * @param {number} value - The amount of horizontal drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragX: function(value) {
                    this.body.drag.x = value;
                    return this;
                },
                /**
     * Sets the body's vertical drag.
     *
     * Drag can be considered as a form of deceleration that will return the velocity of a body back to zero over time.
     * It is the absolute loss of velocity due to movement, in pixels per second squared.
     * The x and y components are applied separately.
     *
     * When `useDamping` is true, this is 1 minus the damping factor.
     * A value of 1 means the Body loses no velocity.
     * A value of 0.95 means the Body loses 5% of its velocity per step.
     * A value of 0.5 means the Body loses 50% of its velocity per step.
     *
     * Drag is applied only when `acceleration` is zero.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDragY
     * @since 3.0.0
     *
     * @param {number} value - The amount of vertical drag to apply.
     *
     * @return {this} This Game Object.
     */ setDragY: function(value) {
                    this.body.drag.y = value;
                    return this;
                },
                /**
     * If this Body is using `drag` for deceleration this function controls how the drag is applied.
     * If set to `true` drag will use a damping effect rather than a linear approach. If you are
     * creating a game where the Body moves freely at any angle (i.e. like the way the ship moves in
     * the game Asteroids) then you will get a far smoother and more visually correct deceleration
     * by using damping, avoiding the axis-drift that is prone with linear deceleration.
     *
     * If you enable this property then you should use far smaller `drag` values than with linear, as
     * they are used as a multiplier on the velocity. Values such as 0.95 will give a nice slow
     * deceleration, where-as smaller values, such as 0.5 will stop an object almost immediately.
     *
     * @method Phaser.Physics.Arcade.Components.Drag#setDamping
     * @since 3.10.0
     *
     * @param {boolean} value - `true` to use damping for deceleration, or `false` to use linear deceleration.
     *
     * @return {this} This Game Object.
     */ setDamping: function(value) {
                    this.body.useDamping = value;
                    return this;
                }
            };
            module1.exports = Drag;
        /***/ },
        /* 1367 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the enable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Enable
 * @since 3.0.0
 */ var Enable = {
                /**
     * Enables this Game Object's Body.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#enableBody
     * @since 3.0.0
     *
     * @param {boolean} reset - Also reset the Body and place it at (x, y).
     * @param {number} x - The horizontal position to place the Game Object and Body.
     * @param {number} y - The horizontal position to place the Game Object and Body.
     * @param {boolean} enableGameObject - Also activate this Game Object.
     * @param {boolean} showGameObject - Also show this Game Object.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.Physics.Arcade.Body#reset
     * @see Phaser.Physics.Arcade.StaticBody#reset
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ enableBody: function(reset, x, y, enableGameObject, showGameObject) {
                    if (reset) this.body.reset(x, y);
                    if (enableGameObject) this.body.gameObject.active = true;
                    if (showGameObject) this.body.gameObject.visible = true;
                    this.body.enable = true;
                    return this;
                },
                /**
     * Stops and disables this Game Object's Body.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#disableBody
     * @since 3.0.0
     *
     * @param {boolean} [disableGameObject=false] - Also deactivate this Game Object.
     * @param {boolean} [hideGameObject=false] - Also hide this Game Object.
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#enable
     * @see Phaser.Physics.Arcade.StaticBody#enable
     * @see Phaser.GameObjects.GameObject#active
     * @see Phaser.GameObjects.GameObject#visible
     */ disableBody: function(disableGameObject, hideGameObject) {
                    if (disableGameObject === undefined) disableGameObject = false;
                    if (hideGameObject === undefined) hideGameObject = false;
                    this.body.stop();
                    this.body.enable = false;
                    if (disableGameObject) this.body.gameObject.active = false;
                    if (hideGameObject) this.body.gameObject.visible = false;
                    return this;
                },
                /**
     * Syncs the Body's position and size with its parent Game Object.
     * You don't need to call this for Dynamic Bodies, as it happens automatically.
     * But for Static bodies it's a useful way of modifying the position of a Static Body
     * in the Physics World, based on its Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Enable#refreshBody
     * @since 3.1.0
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.StaticBody#updateFromGameObject
     */ refreshBody: function() {
                    this.body.updateFromGameObject();
                    return this;
                }
            };
            module1.exports = Enable;
        /***/ },
        /* 1368 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Methods for setting the friction of an Arcade Physics Body.
 *
 * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Friction
 * @since 3.0.0
 *
 * @see Phaser.Physics.Arcade.Body#friction
 */ var Friction = {
                /**
     * Sets the friction of this game object's physics body.
     * In Arcade Physics, friction is a special case of motion transfer from an "immovable" body to a riding body.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} x - The amount of horizontal friction to apply, [0, 1].
     * @param {number} [y=x] - The amount of vertical friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFriction: function(x, y) {
                    this.body.friction.set(x, y);
                    return this;
                },
                /**
     * Sets the horizontal friction of this game object's physics body.
     * This can move a riding body horizontally when it collides with this one on the vertical axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionX
     * @since 3.0.0
     *
     * @param {number} x - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionX: function(x) {
                    this.body.friction.x = x;
                    return this;
                },
                /**
     * Sets the vertical friction of this game object's physics body.
     * This can move a riding body vertically when it collides with this one on the horizontal axis.
     *
     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionY
     * @since 3.0.0
     *
     * @param {number} y - The amount of friction to apply, [0, 1].
     *
     * @return {this} This Game Object.
     *
     * @see Phaser.Physics.Arcade.Body#friction
     */ setFrictionY: function(y) {
                    this.body.friction.y = y;
                    return this;
                }
            };
            module1.exports = Friction;
        /***/ },
        /* 1369 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the gravity properties of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                /**
     * Set the X and Y values of the gravitational pull to act upon this Arcade Physics Game Object. Values can be positive or negative. Larger values result in a stronger effect.
     * 
     * If only one value is provided, this value will be used for both the X and Y axis.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravity
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     * @param {number} [y=x] - The gravitational force to be applied to the Y-axis. If this is not specified, the X value will be used.
     *
     * @return {this} This Game Object.
     */ setGravity: function(x, y) {
                    this.body.gravity.set(x, y);
                    return this;
                },
                /**
     * Set the gravitational force to be applied to the X axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityX
     * @since 3.0.0
     *
     * @param {number} x - The gravitational force to be applied to the X-axis.
     *
     * @return {this} This Game Object.
     */ setGravityX: function(x) {
                    this.body.gravity.x = x;
                    return this;
                },
                /**
     * Set the gravitational force to be applied to the Y axis. Value can be positive or negative. Larger values result in a stronger effect.
     *
     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityY
     * @since 3.0.0
     *
     * @param {number} y - The gravitational force to be applied to the Y-axis.
     *
     * @return {this} This Game Object.
     */ setGravityY: function(y) {
                    this.body.gravity.y = y;
                    return this;
                }
            };
            module1.exports = Gravity;
        /***/ },
        /* 1370 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the immovable properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Immovable
 * @since 3.0.0
 */ var Immovable = {
                /**
     * Sets if this Body can be separated during collisions with other bodies.
     *
     * When a body is immovable it means it won't move at all, not even to separate it from collision
     * overlap. If you just wish to prevent a body from being knocked around by other bodies, see
     * the `setPushable` method instead.
     *
     * @method Phaser.Physics.Arcade.Components.Immovable#setImmovable
     * @since 3.0.0
     *
     * @param {boolean} [value=true] - Sets if this body will be separated during collisions with other bodies.
     *
     * @return {this} This Game Object.
     */ setImmovable: function(value) {
                    if (value === undefined) value = true;
                    this.body.immovable = value;
                    return this;
                }
            };
            module1.exports = Immovable;
        /***/ },
        /* 1371 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the mass properties of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                /**
     * Sets the mass of the physics body
     *
     * @method Phaser.Physics.Arcade.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - New value for the mass of the body.
     *
     * @return {this} This Game Object.
     */ setMass: function(value) {
                    this.body.mass = value;
                    return this;
                }
            };
            module1.exports = Mass;
        /***/ },
        /* 1372 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods used for setting the pushable property of an Arcade Physics Body.
 *
 * @namespace Phaser.Physics.Arcade.Components.Pushable
 * @since 3.50.0
 */ var Pushable = {
                /**
     * Sets if this Body can be pushed by another Body.
     *
     * A body that cannot be pushed will reflect back all of the velocity it is given to the
     * colliding body. If that body is also not pushable, then the separation will be split
     * between them evenly.
     *
     * If you want your body to never move or seperate at all, see the `setImmovable` method.
     *
     * @method Phaser.Physics.Arcade.Components.Pushable#setPushable
     * @since 3.50.0
     *
     * @param {boolean} [value=true] - Sets if this body can be pushed by collisions with another Body.
     *
     * @return {this} This Game Object.
     */ setPushable: function(value) {
                    if (value === undefined) value = true;
                    this.body.pushable = value;
                    return this;
                }
            };
            module1.exports = Pushable;
        /***/ },
        /* 1373 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for setting the size of an Arcade Physics Game Object.
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Size
 * @since 3.0.0
 */ var Size = {
                /**
     * Sets the body offset. This allows you to adjust the difference between the center of the body
     * and the x and y coordinates of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setOffset
     * @since 3.0.0
     *
     * @param {number} x - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [y=x] - The amount to offset the body from the parent Game Object along the y-axis. Defaults to the value given for the x-axis.
     *
     * @return {this} This Game Object.
     */ setOffset: function(x, y) {
                    this.body.setOffset(x, y);
                    return this;
                },
                /**
     * **DEPRECATED**: Please use `setBodySize` instead.
     *
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setSize
     * @since 3.0.0
     * @deprecated
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setSize: function(width, height, center) {
                    this.body.setSize(width, height, center);
                    return this;
                },
                /**
     * Sets the size of this physics body. Setting the size does not adjust the dimensions of the parent Game Object.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setBodySize
     * @since 3.24.0
     *
     * @param {number} width - The new width of the physics body, in pixels.
     * @param {number} height - The new height of the physics body, in pixels.
     * @param {boolean} [center=true] - Should the body be re-positioned so its center aligns with the parent Game Object?
     *
     * @return {this} This Game Object.
     */ setBodySize: function(width, height, center) {
                    this.body.setSize(width, height, center);
                    return this;
                },
                /**
     * Sets this physics body to use a circle for collision instead of a rectangle.
     *
     * @method Phaser.Physics.Arcade.Components.Size#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the physics body, in pixels.
     * @param {number} [offsetX] - The amount to offset the body from the parent Game Object along the x-axis.
     * @param {number} [offsetY] - The amount to offset the body from the parent Game Object along the y-axis.
     *
     * @return {this} This Game Object.
     */ setCircle: function(radius, offsetX, offsetY) {
                    this.body.setCircle(radius, offsetX, offsetY);
                    return this;
                }
            };
            module1.exports = Size;
        /***/ },
        /* 1374 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Provides methods for modifying the velocity of an Arcade Physics body.
 *
 * Should be applied as a mixin and not used directly.
 *
 * @namespace Phaser.Physics.Arcade.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                /**
     * Sets the velocity of the Body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity of the body. Positive values move the body to the right, while negative values move it to the left.
     * @param {number} [y=x] - The vertical velocity of the body. Positive values move the body down, while negative values move it up.
     *
     * @return {this} This Game Object.
     */ setVelocity: function(x, y) {
                    this.body.setVelocity(x, y);
                    return this;
                },
                /**
     * Sets the horizontal component of the body's velocity.
     *
     * Positive values move the body to the right, while negative values move it to the left.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The new horizontal velocity.
     *
     * @return {this} This Game Object.
     */ setVelocityX: function(x) {
                    this.body.setVelocityX(x);
                    return this;
                },
                /**
     * Sets the vertical component of the body's velocity.
     *
     * Positive values move the body down, while negative values move it up.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The new vertical velocity of the body.
     *
     * @return {this} This Game Object.
     */ setVelocityY: function(y) {
                    this.body.setVelocityY(y);
                    return this;
                },
                /**
     * Sets the maximum velocity of the body.
     *
     * @method Phaser.Physics.Arcade.Components.Velocity#setMaxVelocity
     * @since 3.0.0
     *
     * @param {number} x - The new maximum horizontal velocity.
     * @param {number} [y=x] - The new maximum vertical velocity.
     *
     * @return {this} This Game Object.
     */ setMaxVelocity: function(x, y) {
                    this.body.maxVelocity.set(x, y);
                    return this;
                }
            };
            module1.exports = Velocity;
        /***/ },
        /* 1375 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Collide Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if two bodies collide _and_ at least
 * one of them has their [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('collide', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#COLLIDE
 * @since 3.0.0
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the collision. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the collision. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the collision.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the collision.
 */ module1.exports = 'collide';
        /***/ },
        /* 1376 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Overlap Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if two bodies overlap _and_ at least
 * one of them has their [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 * 
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('overlap', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#OVERLAP
 * @since 3.0.0
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject1 - The first Game Object involved in the overlap. This is the parent of `body1`.
 * @param {Phaser.GameObjects.GameObject} gameObject2 - The second Game Object involved in the overlap. This is the parent of `body2`.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1 - The first Physics Body involved in the overlap.
 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2 - The second Physics Body involved in the overlap.
 */ module1.exports = 'overlap';
        /***/ },
        /* 1377 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Pause Event.
 * 
 * This event is dispatched by an Arcade Physics World instance when it is paused.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = 'pause';
        /***/ },
        /* 1378 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Resume Event.
 * 
 * This event is dispatched by an Arcade Physics World instance when it resumes from a paused state.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#RESUME
 * @since 3.0.0
 */ module1.exports = 'resume';
        /***/ },
        /* 1379 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Collide Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body collides with a Tile _and_
 * has its [onCollide]{@link Phaser.Physics.Arcade.Body#onCollide} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('tilecollide', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_COLLIDE
 * @since 3.16.1
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the collision. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body collided with.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the collision.
 */ module1.exports = 'tilecollide';
        /***/ },
        /* 1380 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics Tile Overlap Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body overlaps with a Tile _and_
 * has its [onOverlap]{@link Phaser.Physics.Arcade.Body#onOverlap} property set to `true`.
 * 
 * It provides an alternative means to handling overlap events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('tileoverlap', listener)`.
 * 
 * Please note that 'collide' and 'overlap' are two different things in Arcade Physics.
 *
 * @event Phaser.Physics.Arcade.Events#TILE_OVERLAP
 * @since 3.16.1
 * 
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object involved in the overlap. This is the parent of `body`.
 * @param {Phaser.Tilemaps.Tile} tile - The tile the body overlapped.
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body of the Game Object involved in the overlap.
 */ module1.exports = 'tileoverlap';
        /***/ },
        /* 1381 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Bounds Event.
 * 
 * This event is dispatched by an Arcade Physics World instance if a body makes contact with the world bounds _and_
 * it has its [onWorldBounds]{@link Phaser.Physics.Arcade.Body#onWorldBounds} property set to `true`.
 * 
 * It provides an alternative means to handling collide events rather than using the callback approach.
 * 
 * Listen to it from a Scene using: `this.physics.world.on('worldbounds', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_BOUNDS
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Arcade.Body} body - The Arcade Physics Body that hit the world bounds.
 * @param {boolean} up - Is the Body blocked up? I.e. collided with the top of the world bounds.
 * @param {boolean} down - Is the Body blocked down? I.e. collided with the bottom of the world bounds.
 * @param {boolean} left - Is the Body blocked left? I.e. collided with the left of the world bounds.
 * @param {boolean} right - Is the Body blocked right? I.e. collided with the right of the world bounds.
 */ module1.exports = 'worldbounds';
        /***/ },
        /* 1382 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Arcade Physics World Step Event.
 *
 * This event is dispatched by an Arcade Physics World instance whenever a physics step is run.
 * It is emitted _after_ the bodies and colliders have been updated.
 *
 * In high framerate settings this can be multiple times per game frame.
 *
 * Listen to it from a Scene using: `this.physics.world.on('worldstep', listener)`.
 *
 * @event Phaser.Physics.Arcade.Events#WORLD_STEP
 * @since 3.18.0
 *
 * @param {number} delta - The delta time amount of this step, in seconds.
 */ module1.exports = 'worldstep';
        /***/ },
        /* 1383 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
            var body2;
            var body1Pushable;
            var body2Pushable;
            var body1MassImpact;
            var body2MassImpact;
            var body1FullImpact;
            var body2FullImpact;
            var body1MovingLeft;
            var body1MovingRight;
            var body1Stationary;
            var body2MovingLeft;
            var body2MovingRight;
            var body2Stationary;
            var body1OnLeft;
            var body2OnLeft;
            var overlap;
            /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateX` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                body1 = b1;
                body2 = b2;
                var v1 = body1.velocity.x;
                var v2 = body2.velocity.x;
                body1Pushable = body1.pushable;
                body1MovingLeft = body1._dx < 0;
                body1MovingRight = body1._dx > 0;
                body1Stationary = body1._dx === 0;
                body1OnLeft = Math.abs(body1.right - body2.x) <= Math.abs(body2.right - body1.x);
                body1FullImpact = v2 - v1 * body1.bounce.x;
                body2Pushable = body2.pushable;
                body2MovingLeft = body2._dx < 0;
                body2MovingRight = body2._dx > 0;
                body2Stationary = body2._dx === 0;
                body2OnLeft = !body1OnLeft;
                body2FullImpact = v1 - v2 * body2.bounce.x;
                //  negative delta = up, positive delta = down (inc. gravity)
                overlap = Math.abs(ov);
                return BlockCheck();
            };
            /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessX.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                //  Body1 is moving right and Body2 is blocked from going right any further
                if (body1MovingRight && body1OnLeft && body2.blocked.right) {
                    body1.processX(-overlap, body1FullImpact, false, true);
                    return 1;
                }
                //  Body1 is moving up and Body2 is blocked from going up any further
                if (body1MovingLeft && body2OnLeft && body2.blocked.left) {
                    body1.processX(overlap, body1FullImpact, true);
                    return 1;
                }
                //  Body2 is moving right and Body1 is blocked from going right any further
                if (body2MovingRight && body2OnLeft && body1.blocked.right) {
                    body2.processX(-overlap, body2FullImpact, false, true);
                    return 2;
                }
                //  Body2 is moving up and Body1 is blocked from going up any further
                if (body2MovingLeft && body1OnLeft && body1.blocked.left) {
                    body2.processX(overlap, body2FullImpact, true);
                    return 2;
                }
                return 0;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                var v1 = body1.velocity.x;
                var v2 = body2.velocity.x;
                var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                var avg = (nv1 + nv2) * 0.5;
                nv1 -= avg;
                nv2 -= avg;
                body1MassImpact = avg + nv1 * body1.bounce.x;
                body2MassImpact = avg + nv2 * body2.bounce.x;
                //  Body1 hits Body2 on the right hand side
                if (body1MovingLeft && body2OnLeft) return Run(0);
                //  Body2 hits Body1 on the right hand side
                if (body2MovingLeft && body1OnLeft) return Run(1);
                //  Body1 hits Body2 on the left hand side
                if (body1MovingRight && body1OnLeft) return Run(2);
                //  Body2 hits Body1 on the left hand side
                if (body2MovingRight && body2OnLeft) return Run(3);
                return false;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessX.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                if (body1Pushable && body2Pushable) {
                    //  Both pushable, or both moving at the same time, so equal rebound
                    overlap *= 0.5;
                    if (side === 0 || side === 3) {
                        //  body1MovingLeft && body2OnLeft
                        //  body2MovingRight && body2OnLeft
                        body1.processX(overlap, body1MassImpact);
                        body2.processX(-overlap, body2MassImpact);
                    } else {
                        //  body2MovingLeft && body1OnLeft
                        //  body1MovingRight && body1OnLeft
                        body1.processX(-overlap, body1MassImpact);
                        body2.processX(overlap, body2MassImpact);
                    }
                } else if (body1Pushable && !body2Pushable) {
                    //  Body1 pushable, Body2 not
                    if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                    //  body2MovingRight && body2OnLeft
                    body1.processX(overlap, body1FullImpact, true);
                    else //  body2MovingLeft && body1OnLeft
                    //  body1MovingRight && body1OnLeft
                    body1.processX(-overlap, body1FullImpact, false, true);
                } else if (!body1Pushable && body2Pushable) {
                    //  Body2 pushable, Body1 not
                    if (side === 0 || side === 3) //  body1MovingLeft && body2OnLeft
                    //  body2MovingRight && body2OnLeft
                    body2.processX(-overlap, body2FullImpact, false, true);
                    else //  body2MovingLeft && body1OnLeft
                    //  body1MovingRight && body1OnLeft
                    body2.processX(overlap, body2FullImpact, true);
                } else {
                    //  Neither body is pushable, so base it on movement
                    var halfOverlap = overlap * 0.5;
                    if (side === 0) {
                        //  body1MovingLeft && body2OnLeft
                        if (body2Stationary) {
                            body1.processX(overlap, 0, true);
                            body2.processX(0, null, false, true);
                        } else if (body2MovingRight) {
                            body1.processX(halfOverlap, 0, true);
                            body2.processX(-halfOverlap, 0, false, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processX(halfOverlap, body2.velocity.x, true);
                            body2.processX(-halfOverlap, null, false, true);
                        }
                    } else if (side === 1) {
                        //  body2MovingLeft && body1OnLeft
                        if (body1Stationary) {
                            body1.processX(0, null, false, true);
                            body2.processX(overlap, 0, true);
                        } else if (body1MovingRight) {
                            body1.processX(-halfOverlap, 0, false, true);
                            body2.processX(halfOverlap, 0, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processX(-halfOverlap, null, false, true);
                            body2.processX(halfOverlap, body1.velocity.x, true);
                        }
                    } else if (side === 2) {
                        //  body1MovingRight && body1OnLeft
                        if (body2Stationary) {
                            body1.processX(-overlap, 0, false, true);
                            body2.processX(0, null, true);
                        } else if (body2MovingLeft) {
                            body1.processX(-halfOverlap, 0, false, true);
                            body2.processX(halfOverlap, 0, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processX(-halfOverlap, body2.velocity.x, false, true);
                            body2.processX(halfOverlap, null, true);
                        }
                    } else if (side === 3) {
                        //  body2MovingRight && body2OnLeft
                        if (body1Stationary) {
                            body1.processX(0, null, true);
                            body2.processX(-overlap, 0, false, true);
                        } else if (body1MovingLeft) {
                            body1.processX(halfOverlap, 0, true);
                            body2.processX(-halfOverlap, 0, false, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processX(halfOverlap, body2.velocity.y, true);
                            body2.processX(-halfOverlap, null, false, true);
                        }
                    }
                }
                return true;
            };
            /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body2.velocity.x = 0;
                else if (body1OnLeft) body2.processX(overlap, body2FullImpact, true);
                else body2.processX(-overlap, body2FullImpact, false, true);
                //  This is special case code that handles things like vertically moving platforms you can ride
                if (body1.moves) {
                    body2.y += (body1.y - body1.prev.y) * body1.friction.y;
                    body2._dy = body2.y - body2.prev.y;
                }
            };
            /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessX.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body1.velocity.x = 0;
                if (body2OnLeft) body1.processX(overlap, body1FullImpact, true);
                else body1.processX(-overlap, body1FullImpact, false, true);
                //  This is special case code that handles things like vertically moving platforms you can ride
                if (body2.moves) {
                    body1.y += (body2.y - body2.prev.y) * body2.friction.y;
                    body1._dy = body1.y - body1.prev.y;
                }
            };
            /**
 * @namespace Phaser.Physics.Arcade.ProcessX
 * @ignore
 */ module1.exports = {
                BlockCheck: BlockCheck,
                Check: Check,
                Set: Set,
                Run: Run,
                RunImmovableBody1: RunImmovableBody1,
                RunImmovableBody2: RunImmovableBody2
            };
        /***/ },
        /* 1384 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var body1;
            var body2;
            var body1Pushable;
            var body2Pushable;
            var body1MassImpact;
            var body2MassImpact;
            var body1FullImpact;
            var body2FullImpact;
            var body1MovingUp;
            var body1MovingDown;
            var body1Stationary;
            var body2MovingUp;
            var body2MovingDown;
            var body2Stationary;
            var body1OnTop;
            var body2OnTop;
            var overlap;
            /**
 * Sets all of the local processing values and calculates the velocity exchanges.
 *
 * Then runs `BlockCheck` and returns the value from it.
 *
 * This method is called by `Phaser.Physics.Arcade.SeparateY` and should not be
 * called directly.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Set
 * @ignore
 * @since 3.50.0
 *
 * @param {Phaser.Physics.Arcade.Body} b1 - The first Body to separate.
 * @param {Phaser.Physics.Arcade.Body} b2 - The second Body to separate.
 * @param {number} ov - The overlap value.
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var Set = function(b1, b2, ov) {
                body1 = b1;
                body2 = b2;
                var v1 = body1.velocity.y;
                var v2 = body2.velocity.y;
                body1Pushable = body1.pushable;
                body1MovingUp = body1._dy < 0;
                body1MovingDown = body1._dy > 0;
                body1Stationary = body1._dy === 0;
                body1OnTop = Math.abs(body1.bottom - body2.y) <= Math.abs(body2.bottom - body1.y);
                body1FullImpact = v2 - v1 * body1.bounce.y;
                body2Pushable = body2.pushable;
                body2MovingUp = body2._dy < 0;
                body2MovingDown = body2._dy > 0;
                body2Stationary = body2._dy === 0;
                body2OnTop = !body1OnTop;
                body2FullImpact = v1 - v2 * body2.bounce.y;
                //  negative delta = up, positive delta = down (inc. gravity)
                overlap = Math.abs(ov);
                return BlockCheck();
            };
            /**
 * Blocked Direction checks, because it doesn't matter if an object can be pushed
 * or not, blocked is blocked.
 *
 * @function Phaser.Physics.Arcade.ProcessY.BlockCheck
 * @ignore
 * @since 3.50.0
 *
 * @return {number} The BlockCheck result. 0 = not blocked. 1 = Body 1 blocked. 2 = Body 2 blocked.
 */ var BlockCheck = function() {
                //  Body1 is moving down and Body2 is blocked from going down any further
                if (body1MovingDown && body1OnTop && body2.blocked.down) {
                    body1.processY(-overlap, body1FullImpact, false, true);
                    return 1;
                }
                //  Body1 is moving up and Body2 is blocked from going up any further
                if (body1MovingUp && body2OnTop && body2.blocked.up) {
                    body1.processY(overlap, body1FullImpact, true);
                    return 1;
                }
                //  Body2 is moving down and Body1 is blocked from going down any further
                if (body2MovingDown && body2OnTop && body1.blocked.down) {
                    body2.processY(-overlap, body2FullImpact, false, true);
                    return 2;
                }
                //  Body2 is moving up and Body1 is blocked from going up any further
                if (body2MovingUp && body1OnTop && body1.blocked.up) {
                    body2.processY(overlap, body2FullImpact, true);
                    return 2;
                }
                return 0;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Check
 * @ignore
 * @since 3.50.0
 *
 * @return {boolean} `true` if a check passed, otherwise `false`.
 */ var Check = function() {
                var v1 = body1.velocity.y;
                var v2 = body2.velocity.y;
                var nv1 = Math.sqrt(v2 * v2 * body2.mass / body1.mass) * (v2 > 0 ? 1 : -1);
                var nv2 = Math.sqrt(v1 * v1 * body1.mass / body2.mass) * (v1 > 0 ? 1 : -1);
                var avg = (nv1 + nv2) * 0.5;
                nv1 -= avg;
                nv2 -= avg;
                body1MassImpact = avg + nv1 * body1.bounce.y;
                body2MassImpact = avg + nv2 * body2.bounce.y;
                //  Body1 hits Body2 on the bottom side
                if (body1MovingUp && body2OnTop) return Run(0);
                //  Body2 hits Body1 on the bottom side
                if (body2MovingUp && body1OnTop) return Run(1);
                //  Body1 hits Body2 on the top side
                if (body1MovingDown && body1OnTop) return Run(2);
                //  Body2 hits Body1 on the top side
                if (body2MovingDown && body2OnTop) return Run(3);
                return false;
            };
            /**
 * The main check function. Runs through one of the four possible tests and returns the results.
 *
 * @function Phaser.Physics.Arcade.ProcessY.Run
 * @ignore
 * @since 3.50.0
 *
 * @param {number} side - The side to test. As passed in by the `Check` function.
 *
 * @return {boolean} Always returns `true`.
 */ var Run = function(side) {
                if (body1Pushable && body2Pushable) {
                    //  Both pushable, or both moving at the same time, so equal rebound
                    overlap *= 0.5;
                    if (side === 0 || side === 3) {
                        //  body1MovingUp && body2OnTop
                        //  body2MovingDown && body2OnTop
                        body1.processY(overlap, body1MassImpact);
                        body2.processY(-overlap, body2MassImpact);
                    } else {
                        //  body2MovingUp && body1OnTop
                        //  body1MovingDown && body1OnTop
                        body1.processY(-overlap, body1MassImpact);
                        body2.processY(overlap, body2MassImpact);
                    }
                } else if (body1Pushable && !body2Pushable) {
                    //  Body1 pushable, Body2 not
                    if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                    //  body2MovingDown && body2OnTop
                    body1.processY(overlap, body1FullImpact, true);
                    else //  body2MovingUp && body1OnTop
                    //  body1MovingDown && body1OnTop
                    body1.processY(-overlap, body1FullImpact, false, true);
                } else if (!body1Pushable && body2Pushable) {
                    //  Body2 pushable, Body1 not
                    if (side === 0 || side === 3) //  body1MovingUp && body2OnTop
                    //  body2MovingDown && body2OnTop
                    body2.processY(-overlap, body2FullImpact, false, true);
                    else //  body2MovingUp && body1OnTop
                    //  body1MovingDown && body1OnTop
                    body2.processY(overlap, body2FullImpact, true);
                } else {
                    //  Neither body is pushable, so base it on movement
                    var halfOverlap = overlap * 0.5;
                    if (side === 0) {
                        //  body1MovingUp && body2OnTop
                        if (body2Stationary) {
                            body1.processY(overlap, 0, true);
                            body2.processY(0, null, false, true);
                        } else if (body2MovingDown) {
                            body1.processY(halfOverlap, 0, true);
                            body2.processY(-halfOverlap, 0, false, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processY(halfOverlap, body2.velocity.y, true);
                            body2.processY(-halfOverlap, null, false, true);
                        }
                    } else if (side === 1) {
                        //  body2MovingUp && body1OnTop
                        if (body1Stationary) {
                            body1.processY(0, null, false, true);
                            body2.processY(overlap, 0, true);
                        } else if (body1MovingDown) {
                            body1.processY(-halfOverlap, 0, false, true);
                            body2.processY(halfOverlap, 0, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processY(-halfOverlap, null, false, true);
                            body2.processY(halfOverlap, body1.velocity.y, true);
                        }
                    } else if (side === 2) {
                        //  body1MovingDown && body1OnTop
                        if (body2Stationary) {
                            body1.processY(-overlap, 0, false, true);
                            body2.processY(0, null, true);
                        } else if (body2MovingUp) {
                            body1.processY(-halfOverlap, 0, false, true);
                            body2.processY(halfOverlap, 0, true);
                        } else {
                            //  Body2 moving same direction as Body1
                            body1.processY(-halfOverlap, body2.velocity.y, false, true);
                            body2.processY(halfOverlap, null, true);
                        }
                    } else if (side === 3) {
                        //  body2MovingDown && body2OnTop
                        if (body1Stationary) {
                            body1.processY(0, null, true);
                            body2.processY(-overlap, 0, false, true);
                        } else if (body1MovingUp) {
                            body1.processY(halfOverlap, 0, true);
                            body2.processY(-halfOverlap, 0, false, true);
                        } else {
                            //  Body1 moving same direction as Body2
                            body1.processY(halfOverlap, body2.velocity.y, true);
                            body2.processY(-halfOverlap, null, false, true);
                        }
                    }
                }
                return true;
            };
            /**
 * This function is run when Body1 is Immovable and Body2 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody1
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody1 = function(blockedState) {
                if (blockedState === 1) //  But Body2 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body2.velocity.y = 0;
                else if (body1OnTop) body2.processY(overlap, body2FullImpact, true);
                else body2.processY(-overlap, body2FullImpact, false, true);
                //  This is special case code that handles things like horizontally moving platforms you can ride
                if (body1.moves) {
                    body2.x += (body1.x - body1.prev.x) * body1.friction.x;
                    body2._dx = body2.x - body2.prev.x;
                }
            };
            /**
 * This function is run when Body2 is Immovable and Body1 is not.
 *
 * @function Phaser.Physics.Arcade.ProcessY.RunImmovableBody2
 * @ignore
 * @since 3.50.0
 *
 * @param {number} blockedState - The block state value.
 */ var RunImmovableBody2 = function(blockedState) {
                if (blockedState === 2) //  But Body1 cannot go anywhere either, so we cancel out velocity
                //  Separation happened in the block check
                body1.velocity.y = 0;
                else if (body2OnTop) body1.processY(overlap, body1FullImpact, true);
                else body1.processY(-overlap, body1FullImpact, false, true);
                //  This is special case code that handles things like horizontally moving platforms you can ride
                if (body2.moves) {
                    body1.x += (body2.x - body2.prev.x) * body2.friction.x;
                    body1._dx = body1.x - body1.prev.x;
                }
            };
            /**
 * @namespace Phaser.Physics.Arcade.ProcessY
 * @ignore
 */ module1.exports = {
                BlockCheck: BlockCheck,
                Check: Check,
                Set: Set,
                Run: Run,
                RunImmovableBody1: RunImmovableBody1,
                RunImmovableBody2: RunImmovableBody2
            };
        /***/ },
        /* 1385 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Arcade.Tilemap
 */ var Tilemap = {
                ProcessTileCallbacks: __webpack_require__(524),
                ProcessTileSeparationX: __webpack_require__(528),
                ProcessTileSeparationY: __webpack_require__(530),
                SeparateTile: __webpack_require__(526),
                TileCheckX: __webpack_require__(527),
                TileCheckY: __webpack_require__(529),
                TileIntersectsBody: __webpack_require__(245)
            };
            module1.exports = Tilemap;
        /***/ },
        /* 1386 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Joachim Grill <joachim@codeandweb.com>
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 CodeAndWeb GmbH
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            var Common = __webpack_require__(50);
            var GetFastValue = __webpack_require__(2);
            var Vertices = __webpack_require__(94);
            /**
 * Use PhysicsEditorParser.parseBody() to build a Matter body object, based on a physics data file
 * created and exported with PhysicsEditor (https://www.codeandweb.com/physicseditor).
 *
 * @namespace Phaser.Physics.Matter.PhysicsEditorParser
 * @since 3.10.0
 */ var PhysicsEditorParser = {
                /**
     * Parses a body element exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseBody
     * @since 3.10.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration and fixture (child body) definitions, as exported by PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType} A compound Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                    if (options === undefined) options = {};
                    var fixtureConfigs = GetFastValue(config, 'fixtures', []);
                    var fixtures = [];
                    for(var fc = 0; fc < fixtureConfigs.length; fc++){
                        var fixtureParts = this.parseFixture(fixtureConfigs[fc]);
                        for(var i = 0; i < fixtureParts.length; i++)fixtures.push(fixtureParts[i]);
                    }
                    var matterConfig = Common.clone(config, true);
                    Common.extend(matterConfig, options, true);
                    delete matterConfig.fixtures;
                    delete matterConfig.type;
                    var body = Body.create(matterConfig);
                    Body.setParts(body, fixtures);
                    Body.setPosition(body, {
                        x: x,
                        y: y
                    });
                    return body;
                },
                /**
     * Parses an element of the "fixtures" list exported by PhysicsEditor
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseFixture
     * @since 3.10.0
     *
     * @param {object} fixtureConfig - The fixture object to parse.
     * 
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseFixture: function(fixtureConfig) {
                    var matterConfig = Common.extend({}, false, fixtureConfig);
                    delete matterConfig.circle;
                    delete matterConfig.vertices;
                    var fixtures;
                    if (fixtureConfig.circle) {
                        var x = GetFastValue(fixtureConfig.circle, 'x');
                        var y = GetFastValue(fixtureConfig.circle, 'y');
                        var r = GetFastValue(fixtureConfig.circle, 'radius');
                        fixtures = [
                            Bodies.circle(x, y, r, matterConfig)
                        ];
                    } else if (fixtureConfig.vertices) fixtures = this.parseVertices(fixtureConfig.vertices, matterConfig);
                    return fixtures;
                },
                /**
     * Parses the "vertices" lists exported by PhysicsEditor.
     *
     * @function Phaser.Physics.Matter.PhysicsEditorParser.parseVertices
     * @since 3.10.0
     *
     * @param {array} vertexSets - The vertex lists to parse.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType[]} - An array of Matter JS Bodies.
     */ parseVertices: function(vertexSets, options) {
                    if (options === undefined) options = {};
                    var parts = [];
                    for(var v = 0; v < vertexSets.length; v++){
                        Vertices.clockwiseSort(vertexSets[v]);
                        parts.push(Body.create(Common.extend({
                            position: Vertices.centre(vertexSets[v]),
                            vertices: vertexSets[v]
                        }, options)));
                    }
                    // flag coincident part edges
                    return Bodies.flagCoincidentParts(parts);
                }
            };
            module1.exports = PhysicsEditorParser;
        /***/ },
        /* 1387 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            /**
 * Creates a body using the supplied physics data, as provided by a JSON file.
 * 
 * The data file should be loaded as JSON:
 * 
 * ```javascript
 * preload ()
 * {
 *   this.load.json('ninjas', 'assets/ninjas.json);
 * }
 * 
 * create ()
 * {
 *   const ninjaShapes = this.cache.json.get('ninjas');
 * 
 *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
 * }
 * ```
 * 
 * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
 * 
 * If you pas in an `options` object, any settings in there will override those in the config object.
 * 
 * The structure of the JSON file is as follows:
 * 
 * ```text
 * {
 *   'generator_info': // The name of the application that created the JSON data
 *   'shapeName': {
 *     'type': // The type of body
 *     'label': // Optional body label
 *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
 *   }
 * }
 * ```
 * 
 * At the time of writing, only the Phaser Physics Tracer App exports in this format.
 *
 * @namespace Phaser.Physics.Matter.PhysicsJSONParser
 * @since 3.22.0
 */ var PhysicsJSONParser = {
                /**
     * Parses a body element from the given JSON data.
     *
     * @function Phaser.Physics.Matter.PhysicsJSONParser.parseBody
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {object} config - The body configuration data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * 
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ parseBody: function(x, y, config, options) {
                    if (options === undefined) options = {};
                    var body;
                    var vertexSets = config.vertices;
                    if (vertexSets.length === 1) {
                        //  Just a single Body
                        options.vertices = vertexSets[0];
                        body = Body.create(options);
                        Bodies.flagCoincidentParts(body.parts);
                    } else {
                        var parts = [];
                        for(var i = 0; i < vertexSets.length; i++){
                            var part = Body.create({
                                vertices: vertexSets[i]
                            });
                            parts.push(part);
                        }
                        Bodies.flagCoincidentParts(parts);
                        options.parts = parts;
                        body = Body.create(options);
                    }
                    body.label = config.label;
                    Body.setPosition(body, {
                        x: x,
                        y: y
                    });
                    return body;
                }
            };
            module1.exports = PhysicsJSONParser;
        /***/ },
        /* 1388 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composites` module contains factory methods for creating composite bodies
* with commonly used configurations (such as stacks and chains).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composites
*/ var Composites = {};
            module1.exports = Composites;
            var Composite = __webpack_require__(163);
            var Constraint = __webpack_require__(246);
            var Common = __webpack_require__(50);
            var Body = __webpack_require__(71);
            var Bodies = __webpack_require__(126);
            (function() {
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method stack
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.stack = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composite.create({
                        label: 'Stack'
                    }), x = xx, y = yy, lastBody, i = 0;
                    for(var row = 0; row < rows; row++){
                        var maxHeight = 0;
                        for(var column = 0; column < columns; column++){
                            var body = callback(x, y, column, row, lastBody, i);
                            if (body) {
                                var bodyHeight = body.bounds.max.y - body.bounds.min.y, bodyWidth = body.bounds.max.x - body.bounds.min.x;
                                if (bodyHeight > maxHeight) maxHeight = bodyHeight;
                                Body.translate(body, {
                                    x: bodyWidth * 0.5,
                                    y: bodyHeight * 0.5
                                });
                                x = body.bounds.max.x + columnGap;
                                Composite.addBody(stack, body);
                                lastBody = body;
                                i += 1;
                            } else x += columnGap;
                        }
                        y += maxHeight + rowGap;
                        x = xx;
                    }
                    return stack;
                };
                /**
     * Chains all bodies in the given composite together using constraints.
     * @method chain
     * @param {composite} composite
     * @param {number} xOffsetA
     * @param {number} yOffsetA
     * @param {number} xOffsetB
     * @param {number} yOffsetB
     * @param {object} options
     * @return {composite} A new composite containing objects chained together with constraints
     */ Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    var bodies = composite.bodies;
                    for(var i = 1; i < bodies.length; i++){
                        var bodyA = bodies[i - 1], bodyB = bodies[i], bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y, bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y, bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
                        var defaults = {
                            bodyA: bodyA,
                            pointA: {
                                x: bodyAWidth * xOffsetA,
                                y: bodyAHeight * yOffsetA
                            },
                            bodyB: bodyB,
                            pointB: {
                                x: bodyBWidth * xOffsetB,
                                y: bodyBHeight * yOffsetB
                            }
                        };
                        var constraint = Common.extend(defaults, options);
                        Composite.addConstraint(composite, Constraint.create(constraint));
                    }
                    composite.label += ' Chain';
                    return composite;
                };
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     * @method mesh
     * @param {composite} composite
     * @param {number} columns
     * @param {number} rows
     * @param {boolean} crossBrace
     * @param {object} options
     * @return {composite} The composite containing objects meshed together with constraints
     */ Composites.mesh = function(composite, columns, rows, crossBrace, options) {
                    var bodies = composite.bodies, row, col, bodyA, bodyB, bodyC;
                    for(row = 0; row < rows; row++){
                        for(col = 1; col < columns; col++){
                            bodyA = bodies[col - 1 + row * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                        }
                        if (row > 0) for(col = 0; col < columns; col++){
                            bodyA = bodies[col + (row - 1) * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                            if (crossBrace && col > 0) {
                                bodyC = bodies[col - 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                            if (crossBrace && col < columns - 1) {
                                bodyC = bodies[col + 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                        }
                    }
                    composite.label += ' Mesh';
                    return composite;
                };
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method pyramid
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.pyramid = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
                    return Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y, column, row, lastBody, i) {
                        var actualRows = Math.min(rows, Math.ceil(columns / 2)), lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
                        if (row > actualRows) return;
                        // reverse row order
                        row = actualRows - row;
                        var start = row, end = columns - 1 - row;
                        if (column < start || column > end) return;
                        // retroactively fix the first body's position, since width was unknown
                        if (i === 1) Body.translate(lastBody, {
                            x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth,
                            y: 0
                        });
                        var xOffset = lastBody ? column * lastBodyWidth : 0;
                        return callback(xx + xOffset + column * columnGap, y, column, row, lastBody, i);
                    });
                };
                /**
     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
     * @method newtonsCradle
     * @param {number} xx
     * @param {number} yy
     * @param {number} number
     * @param {number} size
     * @param {number} length
     * @return {composite} A new composite newtonsCradle body
     */ Composites.newtonsCradle = function(xx, yy, number, size, length) {
                    var newtonsCradle = Composite.create({
                        label: 'Newtons Cradle'
                    });
                    for(var i = 0; i < number; i++){
                        var separation = 1.9, circle = Bodies.circle(xx + i * (size * separation), yy + length, size, {
                            inertia: Infinity,
                            restitution: 1,
                            friction: 0,
                            frictionAir: 0.0001,
                            slop: 1
                        }), constraint = Constraint.create({
                            pointA: {
                                x: xx + i * (size * separation),
                                y: yy
                            },
                            bodyB: circle
                        });
                        Composite.addBody(newtonsCradle, circle);
                        Composite.addConstraint(newtonsCradle, constraint);
                    }
                    return newtonsCradle;
                };
                /**
     * Creates a composite with simple car setup of bodies and constraints.
     * @method car
     * @param {number} xx
     * @param {number} yy
     * @param {number} width
     * @param {number} height
     * @param {number} wheelSize
     * @return {composite} A new composite car body
     */ Composites.car = function(xx, yy, width, height, wheelSize) {
                    var group = Body.nextGroup(true), wheelBase = 20, wheelAOffset = -width * 0.5 + wheelBase, wheelBOffset = width * 0.5 - wheelBase, wheelYOffset = 0;
                    var car = Composite.create({
                        label: 'Car'
                    }), body = Bodies.rectangle(xx, yy, width, height, {
                        collisionFilter: {
                            group: group
                        },
                        chamfer: {
                            radius: height * 0.5
                        },
                        density: 0.0002
                    });
                    var wheelA = Bodies.circle(xx + wheelAOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var wheelB = Bodies.circle(xx + wheelBOffset, yy + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var axelA = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelAOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelA,
                        stiffness: 1,
                        length: 0
                    });
                    var axelB = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelBOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelB,
                        stiffness: 1,
                        length: 0
                    });
                    Composite.addBody(car, body);
                    Composite.addBody(car, wheelA);
                    Composite.addBody(car, wheelB);
                    Composite.addConstraint(car, axelA);
                    Composite.addConstraint(car, axelB);
                    return car;
                };
                /**
     * Creates a simple soft body like object.
     * @method softBody
     * @param {number} xx
     * @param {number} yy
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {boolean} crossBrace
     * @param {number} particleRadius
     * @param {} particleOptions
     * @param {} constraintOptions
     * @return {composite} A new composite softBody
     */ Composites.softBody = function(xx, yy, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    particleOptions = Common.extend({
                        inertia: Infinity
                    }, particleOptions);
                    constraintOptions = Common.extend({
                        stiffness: 0.2,
                        render: {
                            type: 'line',
                            anchors: false
                        }
                    }, constraintOptions);
                    var softBody = Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y) {
                        return Bodies.circle(x, y, particleRadius, particleOptions);
                    });
                    Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
                    softBody.label = 'Soft Body';
                    return softBody;
                };
            })();
        /***/ },
        /* 1389 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
*
* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Svg
*/ var Svg = {};
            module1.exports = Svg;
            var Bounds = __webpack_require__(117);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Converts an SVG path into an array of vector points.
     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
     * See `Bodies.fromVertices` which provides support for this.
     * Note that this function is not guaranteed to support complex paths (such as those with holes).
     * You must load the `pathseg.js` polyfill on newer browsers.
     * @method pathToVertices
     * @param {SVGPathElement} path
     * @param {Number} [sampleLength=15]
     * @return {Vector[]} points
     */ Svg.pathToVertices = function(path, sampleLength) {
                    if (typeof window !== 'undefined' && !('SVGPathSeg' in window)) Common.warn('Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.');
                    // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
                    var i, il, total, point, segment, segments, segmentsQueue, lastSegment, lastPoint, segmentIndex, points = [], lx, ly, length = 0, x = 0, y = 0;
                    sampleLength = sampleLength || 15;
                    var addPoint = function(px, py, pathSegType) {
                        // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
                        var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
                        // when the last point doesn't equal the current point add the current point
                        if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
                            if (lastPoint && isRelative) {
                                lx = lastPoint.x;
                                ly = lastPoint.y;
                            } else {
                                lx = 0;
                                ly = 0;
                            }
                            var point = {
                                x: lx + px,
                                y: ly + py
                            };
                            // set last point
                            if (isRelative || !lastPoint) lastPoint = point;
                            points.push(point);
                            x = lx + px;
                            y = ly + py;
                        }
                    };
                    var addSegmentPoint = function(segment) {
                        var segType = segment.pathSegTypeAsLetter.toUpperCase();
                        // skip path ends
                        if (segType === 'Z') return;
                        // map segment to x and y
                        switch(segType){
                            case 'M':
                            case 'L':
                            case 'T':
                            case 'C':
                            case 'S':
                            case 'Q':
                                x = segment.x;
                                y = segment.y;
                                break;
                            case 'H':
                                x = segment.x;
                                break;
                            case 'V':
                                y = segment.y;
                                break;
                        }
                        addPoint(x, y, segment.pathSegType);
                    };
                    // ensure path is absolute
                    Svg._svgPathToAbsolute(path);
                    // get total length
                    total = path.getTotalLength();
                    // queue segments
                    segments = [];
                    for(i = 0; i < path.pathSegList.numberOfItems; i += 1)segments.push(path.pathSegList.getItem(i));
                    segmentsQueue = segments.concat();
                    // sample through path
                    while(length < total){
                        // get segment at position
                        segmentIndex = path.getPathSegAtLength(length);
                        segment = segments[segmentIndex];
                        // new segment
                        if (segment != lastSegment) {
                            while(segmentsQueue.length && segmentsQueue[0] != segment)addSegmentPoint(segmentsQueue.shift());
                            lastSegment = segment;
                        }
                        // add points in between when curving
                        // TODO: adaptive sampling
                        switch(segment.pathSegTypeAsLetter.toUpperCase()){
                            case 'C':
                            case 'T':
                            case 'S':
                            case 'Q':
                            case 'A':
                                point = path.getPointAtLength(length);
                                addPoint(point.x, point.y, 0);
                                break;
                        }
                        // increment by sample value
                        length += sampleLength;
                    }
                    // add remaining segments not passed by sampling
                    for(i = 0, il = segmentsQueue.length; i < il; ++i)addSegmentPoint(segmentsQueue[i]);
                    return points;
                };
                Svg._svgPathToAbsolute = function(path) {
                    // http://phrogz.net/convert-svg-path-to-all-absolute-commands
                    // Copyright (c) Gavin Kistner
                    // http://phrogz.net/js/_ReuseLicense.txt
                    // Modifications: tidy formatting and naming
                    var x0, y0, x1, y1, x2, y2, segs = path.pathSegList, x = 0, y = 0, len = segs.numberOfItems;
                    for(var i = 0; i < len; ++i){
                        var seg = segs.getItem(i), segType = seg.pathSegTypeAsLetter;
                        if (/[MLHVCSQTA]/.test(segType)) {
                            if ('x' in seg) x = seg.x;
                            if ('y' in seg) y = seg.y;
                        } else {
                            if ('x1' in seg) x1 = x + seg.x1;
                            if ('x2' in seg) x2 = x + seg.x2;
                            if ('y1' in seg) y1 = y + seg.y1;
                            if ('y2' in seg) y2 = y + seg.y2;
                            if ('x' in seg) x += seg.x;
                            if ('y' in seg) y += seg.y;
                            switch(segType){
                                case 'm':
                                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
                                    break;
                                case 'l':
                                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
                                    break;
                                case 'h':
                                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
                                    break;
                                case 'v':
                                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
                                    break;
                                case 'c':
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
                                    break;
                                case 's':
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
                                    break;
                                case 'q':
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
                                    break;
                                case 't':
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
                                    break;
                                case 'a':
                                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
                                    break;
                                case 'z':
                                case 'Z':
                                    x = x0;
                                    y = y0;
                                    break;
                            }
                        }
                        if (segType == 'M' || segType == 'm') {
                            x0 = x;
                            y0 = y;
                        }
                    }
                };
            })();
        /***/ },
        /* 1390 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(534);
            var EventEmitter = __webpack_require__(9);
            var GetFastValue = __webpack_require__(2);
            var HasValue = __webpack_require__(125);
            var Vertices = __webpack_require__(94);
            /**
 * @classdesc
 * A wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
 * have one Matter body associated with it. You can either pass in an existing Matter body for
 * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
 * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
 * tile's rectangle bounding box will be used.
 *
 * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
 *
 * Note: not all Tiled collision shapes are supported. See
 * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
 *
 * @class TileBody
 * @memberof Phaser.Physics.Matter
 * @extends Phaser.Events.EventEmitter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world instance this body belongs to.
 * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
 * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
 */ var MatterTileBody = new Class({
                Extends: EventEmitter,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.Sleep,
                    Components.Static
                ],
                initialize: function MatterTileBody(world, tile, options) {
                    EventEmitter.call(this);
                    /**
         * The tile object the body is associated with.
         *
         * @name Phaser.Physics.Matter.TileBody#tile
         * @type {Phaser.Tilemaps.Tile}
         * @since 3.0.0
         */ this.tile = tile;
                    /**
         * The Matter world the body exists within.
         *
         * @name Phaser.Physics.Matter.TileBody#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    // Install a reference to 'this' on the tile and ensure there can only be one matter body
                    // associated with the tile
                    if (tile.physics.matterBody) tile.physics.matterBody.destroy();
                    tile.physics.matterBody = this;
                    // Set the body either from an existing body (if provided), the shapes in the tileset
                    // collision layer (if it exists) or a rectangle matching the tile.
                    var body = GetFastValue(options, 'body', null);
                    var addToWorld = GetFastValue(options, 'addToWorld', true);
                    if (!body) {
                        var collisionGroup = tile.getCollisionGroup();
                        var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
                        if (collisionObjects.length > 0) this.setFromTileCollision(options);
                        else this.setFromTileRectangle(options);
                    } else this.setBody(body, addToWorld);
                },
                /**
     * Sets the current body to a rectangle that matches the bounds of the tile.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileRectangle
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileRectangle: function(options) {
                    if (options === undefined) options = {};
                    if (!HasValue(options, 'isStatic')) options.isStatic = true;
                    if (!HasValue(options, 'addToWorld')) options.addToWorld = true;
                    var bounds = this.tile.getBounds();
                    var cx = bounds.x + bounds.width / 2;
                    var cy = bounds.y + bounds.height / 2;
                    var body = Bodies.rectangle(cx, cy, bounds.width, bounds.height, options);
                    this.setBody(body, options.addToWorld);
                    return this;
                },
                /**
     * Sets the current body from the collision group associated with the Tile. This is typically
     * set up in Tiled's collision editor.
     *
     * Note: Matter doesn't support all shapes from Tiled. Rectangles and polygons are directly
     * supported. Ellipses are converted into circle bodies. Polylines are treated as if they are
     * closed polygons. If a tile has multiple shapes, a multi-part body will be created. Concave
     * shapes are supported if poly-decomp library is included. Decomposition is not guaranteed to
     * work for complex shapes (e.g. holes), so it's often best to manually decompose a concave
     * polygon into multiple convex polygons yourself.
     *
     * @method Phaser.Physics.Matter.TileBody#setFromTileCollision
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBodyTileOptions} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setFromTileCollision: function(options) {
                    if (options === undefined) options = {};
                    if (!HasValue(options, 'isStatic')) options.isStatic = true;
                    if (!HasValue(options, 'addToWorld')) options.addToWorld = true;
                    var sx = this.tile.tilemapLayer.scaleX;
                    var sy = this.tile.tilemapLayer.scaleY;
                    var tileX = this.tile.getLeft();
                    var tileY = this.tile.getTop();
                    var collisionGroup = this.tile.getCollisionGroup();
                    var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
                    var parts = [];
                    for(var i = 0; i < collisionObjects.length; i++){
                        var object = collisionObjects[i];
                        var ox = tileX + object.x * sx;
                        var oy = tileY + object.y * sy;
                        var ow = object.width * sx;
                        var oh = object.height * sy;
                        var body = null;
                        if (object.rectangle) body = Bodies.rectangle(ox + ow / 2, oy + oh / 2, ow, oh, options);
                        else if (object.ellipse) body = Bodies.circle(ox + ow / 2, oy + oh / 2, ow / 2, options);
                        else if (object.polygon || object.polyline) {
                            // Polygons and polylines are both treated as closed polygons
                            var originalPoints = object.polygon ? object.polygon : object.polyline;
                            var points = originalPoints.map(function(p) {
                                return {
                                    x: p.x * sx,
                                    y: p.y * sy
                                };
                            });
                            var vertices = Vertices.create(points);
                            // Points are relative to the object's origin (first point placed in Tiled), but
                            // matter expects points to be relative to the center of mass. This only applies to
                            // convex shapes. When a concave shape is decomposed, multiple parts are created and
                            // the individual parts are positioned relative to (ox, oy).
                            //
                            //  Update: 8th January 2019 - the latest version of Matter needs the Vertices adjusted,
                            //  regardless if convex or concave.
                            var center = Vertices.centre(vertices);
                            ox += center.x;
                            oy += center.y;
                            body = Bodies.fromVertices(ox, oy, vertices, options);
                        }
                        if (body) parts.push(body);
                    }
                    if (parts.length === 1) this.setBody(parts[0], options.addToWorld);
                    else if (parts.length > 1) {
                        options.parts = parts;
                        this.setBody(Body.create(options), options.addToWorld);
                    }
                    return this;
                },
                /**
     * Sets the current body to the given body. This will remove the previous body, if one already
     * exists.
     *
     * @method Phaser.Physics.Matter.TileBody#setBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The new Matter body to use.
     * @param {boolean} [addToWorld=true] - Whether or not to add the body to the Matter world.
     * 
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ setBody: function(body, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    if (this.body) this.removeBody();
                    this.body = body;
                    this.body.gameObject = this;
                    if (addToWorld) this.world.add(this.body);
                    return this;
                },
                /**
     * Removes the current body from the TileBody and from the Matter world
     *
     * @method Phaser.Physics.Matter.TileBody#removeBody
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ removeBody: function() {
                    if (this.body) {
                        this.world.remove(this.body);
                        this.body.gameObject = undefined;
                        this.body = undefined;
                    }
                    return this;
                },
                /**
     * Removes the current body from the tile and the world.
     *
     * @method Phaser.Physics.Matter.TileBody#destroy
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
     */ destroy: function() {
                    this.removeBody();
                    this.tile.physics.matterBody = undefined;
                    this.removeAllListeners();
                }
            });
            module1.exports = MatterTileBody;
        /***/ },
        /* 1391 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter.Matter
 */ var Matter = __webpack_require__(1493);
            Matter.Body = __webpack_require__(71);
            Matter.Composite = __webpack_require__(163);
            Matter.World = __webpack_require__(1393);
            Matter.Detector = __webpack_require__(587);
            Matter.Grid = __webpack_require__(1394);
            Matter.Pairs = __webpack_require__(1395);
            Matter.Pair = __webpack_require__(535);
            Matter.Query = __webpack_require__(1494);
            Matter.Resolver = __webpack_require__(1396);
            Matter.SAT = __webpack_require__(588);
            Matter.Constraint = __webpack_require__(246);
            Matter.Common = __webpack_require__(50);
            Matter.Engine = __webpack_require__(1495);
            Matter.Events = __webpack_require__(268);
            Matter.Sleeping = __webpack_require__(267);
            Matter.Plugin = __webpack_require__(1392);
            Matter.Bodies = __webpack_require__(126);
            Matter.Composites = __webpack_require__(1388);
            Matter.Axes = __webpack_require__(585);
            Matter.Bounds = __webpack_require__(117);
            Matter.Svg = __webpack_require__(1389);
            Matter.Vector = __webpack_require__(116);
            Matter.Vertices = __webpack_require__(94);
            // aliases
            Matter.World.add = Matter.Composite.add;
            Matter.World.remove = Matter.Composite.remove;
            Matter.World.addComposite = Matter.Composite.addComposite;
            Matter.World.addBody = Matter.Composite.addBody;
            Matter.World.addConstraint = Matter.Composite.addConstraint;
            Matter.World.clear = Matter.Composite.clear;
            module1.exports = Matter;
        /***/ },
        /* 1392 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
*
* @class Plugin
*/ var Plugin = {};
            module1.exports = Plugin;
            var Common = __webpack_require__(50);
            (function() {
                Plugin._registry = {};
                /**
     * Registers a plugin object so it can be resolved later by name.
     * @method register
     * @param plugin {} The plugin to register.
     * @return {object} The plugin.
     */ Plugin.register = function(plugin) {
                    if (!Plugin.isPlugin(plugin)) Common.warn('Plugin.register:', Plugin.toString(plugin), 'does not implement all required fields.');
                    if (plugin.name in Plugin._registry) {
                        var registered = Plugin._registry[plugin.name], pluginVersion = Plugin.versionParse(plugin.version).number, registeredVersion = Plugin.versionParse(registered.version).number;
                        if (pluginVersion > registeredVersion) {
                            Common.warn('Plugin.register:', Plugin.toString(registered), 'was upgraded to', Plugin.toString(plugin));
                            Plugin._registry[plugin.name] = plugin;
                        } else if (pluginVersion < registeredVersion) Common.warn('Plugin.register:', Plugin.toString(registered), 'can not be downgraded to', Plugin.toString(plugin));
                        else if (plugin !== registered) Common.warn('Plugin.register:', Plugin.toString(plugin), 'is already registered to different plugin object');
                    } else Plugin._registry[plugin.name] = plugin;
                    return plugin;
                };
                /**
     * Resolves a dependency to a plugin object from the registry if it exists. 
     * The `dependency` may contain a version, but only the name matters when resolving.
     * @method resolve
     * @param dependency {string} The dependency.
     * @return {object} The plugin if resolved, otherwise `undefined`.
     */ Plugin.resolve = function(dependency) {
                    return Plugin._registry[Plugin.dependencyParse(dependency).name];
                };
                /**
     * Returns a pretty printed plugin name and version.
     * @method toString
     * @param plugin {} The plugin.
     * @return {string} Pretty printed plugin name and version.
     */ Plugin.toString = function(plugin) {
                    return typeof plugin === 'string' ? plugin : (plugin.name || 'anonymous') + '@' + (plugin.version || plugin.range || '0.0.0');
                };
                /**
     * Returns `true` if the object meets the minimum standard to be considered a plugin.
     * This means it must define the following properties:
     * - `name`
     * - `version`
     * - `install`
     * @method isPlugin
     * @param obj {} The obj to test.
     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
     */ Plugin.isPlugin = function(obj) {
                    return obj && obj.name && obj.version && obj.install;
                };
                /**
     * Returns `true` if a plugin with the given `name` been installed on `module`.
     * @method isUsed
     * @param module {} The module.
     * @param name {string} The plugin name.
     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
     */ Plugin.isUsed = function(module1, name) {
                    return module1.used.indexOf(name) > -1;
                };
                /**
     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
     * If `plugin.for` is not specified then it is assumed to be applicable.
     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
     * @method isFor
     * @param plugin {} The plugin.
     * @param module {} The module.
     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
     */ Plugin.isFor = function(plugin, module1) {
                    var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
                    return !plugin.for || module1.name === parsed.name && Plugin.versionSatisfies(module1.version, parsed.range);
                };
                /**
     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
     * For installing plugins on `Matter` see the convenience function `Matter.use`.
     * Plugins may be specified either by their name or a reference to the plugin object.
     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
     * Order is important, a topological sort is performed to find the best resulting order of installation.
     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
     * This function logs the resulting status of each dependency in the console, along with any warnings.
     * - A green tick ✅ indicates a dependency was resolved and installed.
     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
     * - A red cross ❌ indicates a dependency could not be resolved.
     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
     * @method use
     * @param module {} The module install plugins on.
     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
     */ Plugin.use = function(module1, plugins) {
                    module1.uses = (module1.uses || []).concat(plugins || []);
                    if (module1.uses.length === 0) {
                        Common.warn('Plugin.use:', Plugin.toString(module1), 'does not specify any dependencies to install.');
                        return;
                    }
                    var dependencies = Plugin.dependencies(module1), sortedDependencies = Common.topologicalSort(dependencies), status = [];
                    for(var i = 0; i < sortedDependencies.length; i += 1){
                        if (sortedDependencies[i] === module1.name) continue;
                        var plugin = Plugin.resolve(sortedDependencies[i]);
                        if (!plugin) {
                            status.push("\u274C " + sortedDependencies[i]);
                            continue;
                        }
                        if (Plugin.isUsed(module1, plugin.name)) continue;
                        if (!Plugin.isFor(plugin, module1)) {
                            Common.warn('Plugin.use:', Plugin.toString(plugin), 'is for', plugin.for, 'but installed on', Plugin.toString(module1) + '.');
                            plugin._warned = true;
                        }
                        if (plugin.install) plugin.install(module1);
                        else {
                            Common.warn('Plugin.use:', Plugin.toString(plugin), 'does not specify an install function.');
                            plugin._warned = true;
                        }
                        if (plugin._warned) {
                            status.push("\uD83D\uDD36 " + Plugin.toString(plugin));
                            delete plugin._warned;
                        } else status.push("\u2705 " + Plugin.toString(plugin));
                        module1.used.push(plugin.name);
                    }
                    if (status.length > 0 && !plugin.silent) Common.info(status.join('  '));
                };
                /**
     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
     * @method dependencies
     * @param module {} The module.
     * @return {object} A dependency graph.
     */ Plugin.dependencies = function(module1, tracked) {
                    var parsedBase = Plugin.dependencyParse(module1), name = parsedBase.name;
                    tracked = tracked || {};
                    if (name in tracked) return;
                    module1 = Plugin.resolve(module1) || module1;
                    tracked[name] = Common.map(module1.uses || [], function(dependency) {
                        if (Plugin.isPlugin(dependency)) Plugin.register(dependency);
                        var parsed = Plugin.dependencyParse(dependency), resolved = Plugin.resolve(dependency);
                        if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
                            Common.warn('Plugin.dependencies:', Plugin.toString(resolved), 'does not satisfy', Plugin.toString(parsed), 'used by', Plugin.toString(parsedBase) + '.');
                            resolved._warned = true;
                            module1._warned = true;
                        } else if (!resolved) {
                            Common.warn('Plugin.dependencies:', Plugin.toString(dependency), 'used by', Plugin.toString(parsedBase), 'could not be resolved.');
                            module1._warned = true;
                        }
                        return parsed.name;
                    });
                    for(var i = 0; i < tracked[name].length; i += 1)Plugin.dependencies(tracked[name][i], tracked);
                    return tracked;
                };
                /**
     * Parses a dependency string into its components.
     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * This function can also handle dependencies that are already resolved (e.g. a module object).
     * @method dependencyParse
     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
     * @return {object} The dependency parsed into its components.
     */ Plugin.dependencyParse = function(dependency) {
                    if (Common.isString(dependency)) {
                        var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?))?$/;
                        if (!pattern.test(dependency)) Common.warn('Plugin.dependencyParse:', dependency, 'is not a valid dependency string.');
                        return {
                            name: dependency.split('@')[0],
                            range: dependency.split('@')[1] || '*'
                        };
                    }
                    return {
                        name: dependency.name,
                        range: dependency.range || dependency.version
                    };
                };
                /**
     * Parses a version string into its components.  
     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
     * Only the following range types are supported:
     * - Tilde ranges e.g. `~1.2.3`
     * - Caret ranges e.g. `^1.2.3`
     * - Exact version e.g. `1.2.3`
     * - Any version `*`
     * @method versionParse
     * @param range {string} The version string.
     * @return {object} The version range parsed into its components.
     */ Plugin.versionParse = function(range) {
                    var pattern = /^\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?$/;
                    if (!pattern.test(range)) Common.warn('Plugin.versionParse:', range, 'is not a valid version or range.');
                    var identifiers = range.split('-');
                    range = identifiers[0];
                    var isRange = isNaN(Number(range[0])), version = isRange ? range.substr(1) : range, parts = Common.map(version.split('.'), function(part) {
                        return Number(part);
                    });
                    return {
                        isRange: isRange,
                        version: version,
                        range: range,
                        operator: isRange ? range[0] : '',
                        parts: parts,
                        prerelease: identifiers[1],
                        number: parts[0] * 1e8 + parts[1] * 1e4 + parts[2]
                    };
                };
                /**
     * Returns `true` if `version` satisfies the given `range`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
     * @method versionSatisfies
     * @param version {string} The version string.
     * @param range {string} The range string.
     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
     */ Plugin.versionSatisfies = function(version, range) {
                    range = range || '*';
                    var rangeParsed = Plugin.versionParse(range), rangeParts = rangeParsed.parts, versionParsed = Plugin.versionParse(version), versionParts = versionParsed.parts;
                    if (rangeParsed.isRange) {
                        if (rangeParsed.operator === '*' || version === '*') return true;
                        if (rangeParsed.operator === '~') return versionParts[0] === rangeParts[0] && versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
                        if (rangeParsed.operator === '^') {
                            if (rangeParts[0] > 0) return versionParts[0] === rangeParts[0] && versionParsed.number >= rangeParsed.number;
                            if (rangeParts[1] > 0) return versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
                            return versionParts[2] === rangeParts[2];
                        }
                    }
                    return version === range || version === '*';
                };
            })();
        /***/ },
        /* 1393 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.World` module contains methods for creating and manipulating the world composite.
* A `Matter.World` is a `Matter.Composite` body, which is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`.
* A `Matter.World` has a few additional properties including `gravity` and `bounds`.
* It is important to use the functions in the `Matter.Composite` module to modify the world composite, rather than directly modifying its properties.
* There are also a few methods here that alias those in `Matter.Composite` for easier readability.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class World
* @extends Composite
*/ var World = {};
            module1.exports = World;
            var Composite = __webpack_require__(163);
            var Constraint = __webpack_require__(246);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Creates a new world composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @constructor
     * @param {} options
     * @return {world} A new world
     */ World.create = function(options) {
                    var composite = Composite.create();
                    var defaults = {
                        label: 'World',
                        gravity: {
                            x: 0,
                            y: 1,
                            scale: 0.001
                        },
                        bounds: {
                            min: {
                                x: -Infinity,
                                y: -Infinity
                            },
                            max: {
                                x: Infinity,
                                y: Infinity
                            }
                        }
                    };
                    return Common.extend(composite, defaults, options);
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * The gravity to apply on the world.
     *
     * @property gravity
     * @type object
     */ /**
     * The gravity x component.
     *
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravity y component.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The gravity scale factor.
     *
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ /**
     * A `Bounds` object that defines the world bounds for collision detection.
     *
     * @property bounds
     * @type bounds
     * @default { min: { x: -Infinity, y: -Infinity }, max: { x: Infinity, y: Infinity } }
     */ // World is a Composite body
            // see src/module/Outro.js for these aliases:
            /**
     * An alias for Composite.add
     * @method add
     * @param {world} world
     * @param {} object
     * @return {composite} The original world with the objects added
     */ /**
     * An alias for Composite.remove
     * @method remove
     * @param {world} world
     * @param {} object
     * @param {boolean} [deep=false]
     * @return {composite} The original world with the objects removed
     */ /**
     * An alias for Composite.clear
     * @method clear
     * @param {world} world
     * @param {boolean} keepStatic
     */ /**
     * An alias for Composite.addComposite
     * @method addComposite
     * @param {world} world
     * @param {composite} composite
     * @return {world} The original world with the objects from composite added
     */ /**
      * An alias for Composite.addBody
      * @method addBody
      * @param {world} world
      * @param {body} body
      * @return {world} The original world with the body added
      */ /**
      * An alias for Composite.addConstraint
      * @method addConstraint
      * @param {world} world
      * @param {constraint} constraint
      * @return {world} The original world with the constraint added
      */ })();
        /***/ },
        /* 1394 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
*
* @class Grid
*/ var Grid = {};
            module1.exports = Grid;
            var Pair = __webpack_require__(535);
            var Detector = __webpack_require__(587);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Creates a new grid.
     * @method create
     * @param {} options
     * @return {grid} A new grid
     */ Grid.create = function(options) {
                    var defaults = {
                        controller: Grid,
                        detector: Detector.collisions,
                        buckets: {},
                        pairs: {},
                        pairsList: [],
                        bucketWidth: 48,
                        bucketHeight: 48
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * The width of a single grid bucket.
     *
     * @property bucketWidth
     * @type number
     * @default 48
     */ /**
     * The height of a single grid bucket.
     *
     * @property bucketHeight
     * @type number
     * @default 48
     */ /**
     * Updates the grid.
     * @method update
     * @param {grid} grid
     * @param {body[]} bodies
     * @param {engine} engine
     * @param {boolean} forceUpdate
     */ Grid.update = function(grid, bodies, engine, forceUpdate) {
                    var i, col, row, world = engine.world, buckets = grid.buckets, bucket, bucketId, gridChanged = false;
                    // @if DEBUG
                    var metrics = engine.metrics;
                    metrics.broadphaseTests = 0;
                    // @endif
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isSleeping && !forceUpdate) continue;
                        // don't update out of world bodies
                        if (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y) continue;
                        var newRegion = Grid._getRegion(grid, body);
                        // if the body has changed grid region
                        if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
                            // @if DEBUG
                            metrics.broadphaseTests += 1;
                            // @endif
                            if (!body.region || forceUpdate) body.region = newRegion;
                            var union = Grid._regionUnion(newRegion, body.region);
                            // update grid buckets affected by region change
                            // iterate over the union of both regions
                            for(col = union.startCol; col <= union.endCol; col++)for(row = union.startRow; row <= union.endRow; row++){
                                bucketId = Grid._getBucketId(col, row);
                                bucket = buckets[bucketId];
                                var isInsideNewRegion = col >= newRegion.startCol && col <= newRegion.endCol && row >= newRegion.startRow && row <= newRegion.endRow;
                                var isInsideOldRegion = col >= body.region.startCol && col <= body.region.endCol && row >= body.region.startRow && row <= body.region.endRow;
                                // remove from old region buckets
                                if (!isInsideNewRegion && isInsideOldRegion) {
                                    if (isInsideOldRegion) {
                                        if (bucket) Grid._bucketRemoveBody(grid, bucket, body);
                                    }
                                }
                                // add to new region buckets
                                if (body.region === newRegion || isInsideNewRegion && !isInsideOldRegion || forceUpdate) {
                                    if (!bucket) bucket = Grid._createBucket(buckets, bucketId);
                                    Grid._bucketAddBody(grid, bucket, body);
                                }
                            }
                            // set the new region
                            body.region = newRegion;
                            // flag changes so we can update pairs
                            gridChanged = true;
                        }
                    }
                    // update pairs list only if pairs changed (i.e. a body changed region)
                    if (gridChanged) grid.pairsList = Grid._createActivePairsList(grid);
                };
                /**
     * Clears the grid.
     * @method clear
     * @param {grid} grid
     */ Grid.clear = function(grid) {
                    grid.buckets = {};
                    grid.pairs = {};
                    grid.pairsList = [];
                };
                /**
     * Finds the union of two regions.
     * @method _regionUnion
     * @private
     * @param {} regionA
     * @param {} regionB
     * @return {} region
     */ Grid._regionUnion = function(regionA, regionB) {
                    var startCol = Math.min(regionA.startCol, regionB.startCol), endCol = Math.max(regionA.endCol, regionB.endCol), startRow = Math.min(regionA.startRow, regionB.startRow), endRow = Math.max(regionA.endRow, regionB.endRow);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Gets the region a given body falls in for a given grid.
     * @method _getRegion
     * @private
     * @param {} grid
     * @param {} body
     * @return {} region
     */ Grid._getRegion = function(grid, body) {
                    var bounds = body.bounds, startCol = Math.floor(bounds.min.x / grid.bucketWidth), endCol = Math.floor(bounds.max.x / grid.bucketWidth), startRow = Math.floor(bounds.min.y / grid.bucketHeight), endRow = Math.floor(bounds.max.y / grid.bucketHeight);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Creates a region.
     * @method _createRegion
     * @private
     * @param {} startCol
     * @param {} endCol
     * @param {} startRow
     * @param {} endRow
     * @return {} region
     */ Grid._createRegion = function(startCol, endCol, startRow, endRow) {
                    return {
                        id: startCol + ',' + endCol + ',' + startRow + ',' + endRow,
                        startCol: startCol,
                        endCol: endCol,
                        startRow: startRow,
                        endRow: endRow
                    };
                };
                /**
     * Gets the bucket id at the given position.
     * @method _getBucketId
     * @private
     * @param {} column
     * @param {} row
     * @return {string} bucket id
     */ Grid._getBucketId = function(column, row) {
                    return 'C' + column + 'R' + row;
                };
                /**
     * Creates a bucket.
     * @method _createBucket
     * @private
     * @param {} buckets
     * @param {} bucketId
     * @return {} bucket
     */ Grid._createBucket = function(buckets, bucketId) {
                    var bucket = buckets[bucketId] = [];
                    return bucket;
                };
                /**
     * Adds a body to a bucket.
     * @method _bucketAddBody
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketAddBody = function(grid, bucket, body) {
                    // add new pairs
                    for(var i = 0; i < bucket.length; i++){
                        var bodyB = bucket[i];
                        if (body.id === bodyB.id || body.isStatic && bodyB.isStatic) continue;
                        // keep track of the number of buckets the pair exists in
                        // important for Grid.update to work
                        var pairId = Pair.id(body, bodyB), pair = grid.pairs[pairId];
                        if (pair) pair[2] += 1;
                        else grid.pairs[pairId] = [
                            body,
                            bodyB,
                            1
                        ];
                    }
                    // add to bodies (after pairs, otherwise pairs with self)
                    bucket.push(body);
                };
                /**
     * Removes a body from a bucket.
     * @method _bucketRemoveBody
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketRemoveBody = function(grid, bucket, body) {
                    // remove from bucket
                    bucket.splice(bucket.indexOf(body), 1);
                    // update pair counts
                    for(var i = 0; i < bucket.length; i++){
                        // keep track of the number of buckets the pair exists in
                        // important for _createActivePairsList to work
                        var bodyB = bucket[i], pairId = Pair.id(body, bodyB), pair = grid.pairs[pairId];
                        if (pair) pair[2] -= 1;
                    }
                };
                /**
     * Generates a list of the active pairs in the grid.
     * @method _createActivePairsList
     * @private
     * @param {} grid
     * @return [] pairs
     */ Grid._createActivePairsList = function(grid) {
                    var pairKeys, pair, pairs = [];
                    // grid.pairs is used as a hashmap
                    pairKeys = Common.keys(grid.pairs);
                    // iterate over grid.pairs
                    for(var k = 0; k < pairKeys.length; k++){
                        pair = grid.pairs[pairKeys[k]];
                        // if pair exists in at least one bucket
                        // it is a pair that needs further collision testing so push it
                        if (pair[2] > 0) pairs.push(pair);
                        else delete grid.pairs[pairKeys[k]];
                    }
                    return pairs;
                };
            })();
        /***/ },
        /* 1395 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
*
* @class Pairs
*/ var Pairs = {};
            module1.exports = Pairs;
            var Pair = __webpack_require__(535);
            var Common = __webpack_require__(50);
            (function() {
                Pairs._pairMaxIdleLife = 1000;
                /**
     * Creates a new pairs structure.
     * @method create
     * @param {object} options
     * @return {pairs} A new pairs structure
     */ Pairs.create = function(options) {
                    return Common.extend({
                        table: {},
                        list: [],
                        collisionStart: [],
                        collisionActive: [],
                        collisionEnd: []
                    }, options);
                };
                /**
     * Updates pairs given a list of collisions.
     * @method update
     * @param {object} pairs
     * @param {collision[]} collisions
     * @param {number} timestamp
     */ Pairs.update = function(pairs, collisions, timestamp) {
                    var pairsList = pairs.list, pairsTable = pairs.table, collisionStart = pairs.collisionStart, collisionEnd = pairs.collisionEnd, collisionActive = pairs.collisionActive, collision, pairId, pair, i;
                    // clear collision state arrays, but maintain old reference
                    collisionStart.length = 0;
                    collisionEnd.length = 0;
                    collisionActive.length = 0;
                    for(i = 0; i < pairsList.length; i++)pairsList[i].confirmedActive = false;
                    for(i = 0; i < collisions.length; i++){
                        collision = collisions[i];
                        if (collision.collided) {
                            pairId = Pair.id(collision.bodyA, collision.bodyB);
                            pair = pairsTable[pairId];
                            if (pair) {
                                // pair already exists (but may or may not be active)
                                if (pair.isActive) // pair exists and is active
                                collisionActive.push(pair);
                                else // pair exists but was inactive, so a collision has just started again
                                collisionStart.push(pair);
                                // update the pair
                                Pair.update(pair, collision, timestamp);
                                pair.confirmedActive = true;
                            } else {
                                // pair did not exist, create a new pair
                                pair = Pair.create(collision, timestamp);
                                pairsTable[pairId] = pair;
                                // push the new pair
                                collisionStart.push(pair);
                                pairsList.push(pair);
                            }
                        }
                    }
                    // deactivate previously active pairs that are now inactive
                    for(i = 0; i < pairsList.length; i++){
                        pair = pairsList[i];
                        if (pair.isActive && !pair.confirmedActive) {
                            Pair.setActive(pair, false, timestamp);
                            collisionEnd.push(pair);
                        }
                    }
                };
                /**
     * Finds and removes pairs that have been inactive for a set amount of time.
     * @method removeOld
     * @param {object} pairs
     * @param {number} timestamp
     */ Pairs.removeOld = function(pairs, timestamp) {
                    var pairsList = pairs.list, pairsTable = pairs.table, indexesToRemove = [], pair, collision, pairIndex, i;
                    for(i = 0; i < pairsList.length; i++){
                        pair = pairsList[i];
                        collision = pair.collision;
                        // never remove sleeping pairs
                        if (collision.bodyA.isSleeping || collision.bodyB.isSleeping) {
                            pair.timeUpdated = timestamp;
                            continue;
                        }
                        // if pair is inactive for too long, mark it to be removed
                        if (timestamp - pair.timeUpdated > Pairs._pairMaxIdleLife) indexesToRemove.push(i);
                    }
                    // remove marked pairs
                    for(i = 0; i < indexesToRemove.length; i++){
                        pairIndex = indexesToRemove[i] - i;
                        pair = pairsList[pairIndex];
                        delete pairsTable[pair.id];
                        pairsList.splice(pairIndex, 1);
                    }
                };
                /**
     * Clears the given pairs structure.
     * @method clear
     * @param {pairs} pairs
     * @return {pairs} pairs
     */ Pairs.clear = function(pairs) {
                    pairs.table = {};
                    pairs.list.length = 0;
                    pairs.collisionStart.length = 0;
                    pairs.collisionActive.length = 0;
                    pairs.collisionEnd.length = 0;
                    return pairs;
                };
            })();
        /***/ },
        /* 1396 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Resolver` module contains methods for resolving collision pairs.
*
* @class Resolver
*/ var Resolver = {};
            module1.exports = Resolver;
            var Vertices = __webpack_require__(94);
            var Vector = __webpack_require__(116);
            var Common = __webpack_require__(50);
            var Bounds = __webpack_require__(117);
            (function() {
                Resolver._restingThresh = 4;
                Resolver._restingThreshTangent = 6;
                Resolver._positionDampen = 0.9;
                Resolver._positionWarming = 0.8;
                Resolver._frictionNormalMultiplier = 5;
                /**
     * Prepare pairs for position solving.
     * @method preSolvePosition
     * @param {pair[]} pairs
     */ Resolver.preSolvePosition = function(pairs) {
                    var i, pair, activeCount;
                    // find total contacts on each body
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        activeCount = pair.activeContacts.length;
                        pair.collision.parentA.totalContacts += activeCount;
                        pair.collision.parentB.totalContacts += activeCount;
                    }
                };
                /**
     * Find a solution for pair positions.
     * @method solvePosition
     * @param {pair[]} pairs
     * @param {body[]} bodies
     * @param {number} timeScale
     */ Resolver.solvePosition = function(pairs, bodies, timeScale) {
                    var i, normalX, normalY, pair, collision, bodyA, bodyB, normal, separation, penetration, positionImpulseA, positionImpulseB, contactShare, bodyBtoAX, bodyBtoAY, positionImpulse, impulseCoefficient = timeScale * Resolver._positionDampen;
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        body.previousPositionImpulse.x = body.positionImpulse.x;
                        body.previousPositionImpulse.y = body.positionImpulse.y;
                    }
                    // find impulses required to resolve penetration
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        positionImpulseA = bodyA.previousPositionImpulse;
                        positionImpulseB = bodyB.previousPositionImpulse;
                        penetration = collision.penetration;
                        bodyBtoAX = positionImpulseB.x - positionImpulseA.x + penetration.x;
                        bodyBtoAY = positionImpulseB.y - positionImpulseA.y + penetration.y;
                        normalX = normal.x;
                        normalY = normal.y;
                        separation = normalX * bodyBtoAX + normalY * bodyBtoAY;
                        pair.separation = separation;
                        positionImpulse = (separation - pair.slop) * impulseCoefficient;
                        if (bodyA.isStatic || bodyB.isStatic) positionImpulse *= 2;
                        if (!(bodyA.isStatic || bodyA.isSleeping)) {
                            contactShare = positionImpulse / bodyA.totalContacts;
                            bodyA.positionImpulse.x += normalX * contactShare;
                            bodyA.positionImpulse.y += normalY * contactShare;
                        }
                        if (!(bodyB.isStatic || bodyB.isSleeping)) {
                            contactShare = positionImpulse / bodyB.totalContacts;
                            bodyB.positionImpulse.x -= normalX * contactShare;
                            bodyB.positionImpulse.y -= normalY * contactShare;
                        }
                    }
                };
                /**
     * Apply position resolution.
     * @method postSolvePosition
     * @param {body[]} bodies
     */ Resolver.postSolvePosition = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        // reset contact count
                        body.totalContacts = 0;
                        if (body.positionImpulse.x !== 0 || body.positionImpulse.y !== 0) {
                            // update body geometry
                            for(var j = 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                Vertices.translate(part.vertices, body.positionImpulse);
                                Bounds.update(part.bounds, part.vertices, body.velocity);
                                part.position.x += body.positionImpulse.x;
                                part.position.y += body.positionImpulse.y;
                            }
                            // move the body without changing velocity
                            body.positionPrev.x += body.positionImpulse.x;
                            body.positionPrev.y += body.positionImpulse.y;
                            if (Vector.dot(body.positionImpulse, body.velocity) < 0) {
                                // reset cached impulse if the body has velocity along it
                                body.positionImpulse.x = 0;
                                body.positionImpulse.y = 0;
                            } else {
                                // warm the next iteration
                                body.positionImpulse.x *= Resolver._positionWarming;
                                body.positionImpulse.y *= Resolver._positionWarming;
                            }
                        }
                    }
                };
                /**
     * Prepare pairs for velocity solving.
     * @method preSolveVelocity
     * @param {pair[]} pairs
     */ Resolver.preSolveVelocity = function(pairs) {
                    var i, j, pair, contacts, collision, bodyA, bodyB, normal, tangent, contact, contactVertex, normalImpulse, tangentImpulse, offset, impulse = Vector._temp[0], tempA = Vector._temp[1];
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        contacts = pair.activeContacts;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        tangent = collision.tangent;
                        // resolve each contact
                        for(j = 0; j < contacts.length; j++){
                            contact = contacts[j];
                            contactVertex = contact.vertex;
                            normalImpulse = contact.normalImpulse;
                            tangentImpulse = contact.tangentImpulse;
                            if (normalImpulse !== 0 || tangentImpulse !== 0) {
                                // total impulse from contact
                                impulse.x = normal.x * normalImpulse + tangent.x * tangentImpulse;
                                impulse.y = normal.y * normalImpulse + tangent.y * tangentImpulse;
                                // apply impulse from contact
                                if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                    offset = Vector.sub(contactVertex, bodyA.position, tempA);
                                    bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
                                    bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
                                    bodyA.anglePrev += Vector.cross(offset, impulse) * bodyA.inverseInertia;
                                }
                                if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                    offset = Vector.sub(contactVertex, bodyB.position, tempA);
                                    bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
                                    bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
                                    bodyB.anglePrev -= Vector.cross(offset, impulse) * bodyB.inverseInertia;
                                }
                            }
                        }
                    }
                };
                /**
     * Find a solution for pair velocities.
     * @method solveVelocity
     * @param {pair[]} pairs
     * @param {number} timeScale
     */ Resolver.solveVelocity = function(pairs, timeScale) {
                    var timeScaleSquared = timeScale * timeScale, impulse = Vector._temp[0], tempA = Vector._temp[1], tempB = Vector._temp[2], tempC = Vector._temp[3], tempD = Vector._temp[4], tempE = Vector._temp[5];
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normal = collision.normal, tangent = collision.tangent, contacts = pair.activeContacts, contactShare = 1 / contacts.length;
                        // update body velocities
                        bodyA.velocity.x = bodyA.position.x - bodyA.positionPrev.x;
                        bodyA.velocity.y = bodyA.position.y - bodyA.positionPrev.y;
                        bodyB.velocity.x = bodyB.position.x - bodyB.positionPrev.x;
                        bodyB.velocity.y = bodyB.position.y - bodyB.positionPrev.y;
                        bodyA.angularVelocity = bodyA.angle - bodyA.anglePrev;
                        bodyB.angularVelocity = bodyB.angle - bodyB.anglePrev;
                        // resolve each contact
                        for(var j = 0; j < contacts.length; j++){
                            var contact = contacts[j], contactVertex = contact.vertex, offsetA = Vector.sub(contactVertex, bodyA.position, tempA), offsetB = Vector.sub(contactVertex, bodyB.position, tempB), velocityPointA = Vector.add(bodyA.velocity, Vector.mult(Vector.perp(offsetA), bodyA.angularVelocity), tempC), velocityPointB = Vector.add(bodyB.velocity, Vector.mult(Vector.perp(offsetB), bodyB.angularVelocity), tempD), relativeVelocity = Vector.sub(velocityPointA, velocityPointB, tempE), normalVelocity = Vector.dot(normal, relativeVelocity);
                            var tangentVelocity = Vector.dot(tangent, relativeVelocity), tangentSpeed = Math.abs(tangentVelocity), tangentVelocityDirection = Common.sign(tangentVelocity);
                            // raw impulses
                            var normalImpulse = (1 + pair.restitution) * normalVelocity, normalForce = Common.clamp(pair.separation + normalVelocity, 0, 1) * Resolver._frictionNormalMultiplier;
                            // coulomb friction
                            var tangentImpulse = tangentVelocity, maxFriction = Infinity;
                            if (tangentSpeed > pair.friction * pair.frictionStatic * normalForce * timeScaleSquared) {
                                maxFriction = tangentSpeed;
                                tangentImpulse = Common.clamp(pair.friction * tangentVelocityDirection * timeScaleSquared, -maxFriction, maxFriction);
                            }
                            // modify impulses accounting for mass, inertia and offset
                            var oAcN = Vector.cross(offsetA, normal), oBcN = Vector.cross(offsetB, normal), share = contactShare / (bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * oAcN * oAcN + bodyB.inverseInertia * oBcN * oBcN);
                            normalImpulse *= share;
                            tangentImpulse *= share;
                            // handle high velocity and resting collisions separately
                            if (normalVelocity < 0 && normalVelocity * normalVelocity > Resolver._restingThresh * timeScaleSquared) // high normal velocity so clear cached contact normal impulse
                            contact.normalImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // impulse constraint tends to 0
                                var contactNormalImpulse = contact.normalImpulse;
                                contact.normalImpulse = Math.min(contact.normalImpulse + normalImpulse, 0);
                                normalImpulse = contact.normalImpulse - contactNormalImpulse;
                            }
                            // handle high velocity and resting collisions separately
                            if (tangentVelocity * tangentVelocity > Resolver._restingThreshTangent * timeScaleSquared) // high tangent velocity so clear cached contact tangent impulse
                            contact.tangentImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // tangent impulse tends to -tangentSpeed or +tangentSpeed
                                var contactTangentImpulse = contact.tangentImpulse;
                                contact.tangentImpulse = Common.clamp(contact.tangentImpulse + tangentImpulse, -maxFriction, maxFriction);
                                tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
                            }
                            // total impulse from contact
                            impulse.x = normal.x * normalImpulse + tangent.x * tangentImpulse;
                            impulse.y = normal.y * normalImpulse + tangent.y * tangentImpulse;
                            // apply impulse from contact
                            if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
                                bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
                                bodyA.anglePrev += Vector.cross(offsetA, impulse) * bodyA.inverseInertia;
                            }
                            if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
                                bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
                                bodyB.anglePrev -= Vector.cross(offsetB, impulse) * bodyB.inverseInertia;
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 1397 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Plugins
 */ module1.exports = {
                BasePlugin: __webpack_require__(536),
                DefaultPlugins: __webpack_require__(194),
                PluginCache: __webpack_require__(24),
                PluginManager: __webpack_require__(408),
                ScenePlugin: __webpack_require__(1398)
            };
        /***/ },
        /* 1398 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* @author       Richard Davey <rich@photonstorm.com>
* @copyright    2020 Photon Storm Ltd.
* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
*/ var BasePlugin = __webpack_require__(536);
            var Class = __webpack_require__(0);
            var SceneEvents = __webpack_require__(21);
            /**
 * @classdesc
 * A Scene Level Plugin is installed into every Scene and belongs to that Scene.
 * It can listen for Scene events and respond to them.
 * It can map itself to a Scene property, or into the Scene Systems, or both.
 *
 * @class ScenePlugin
 * @memberof Phaser.Plugins
 * @extends Phaser.Plugins.BasePlugin
 * @constructor
 * @since 3.8.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene that has installed this plugin.
 * @param {Phaser.Plugins.PluginManager} pluginManager - A reference to the Plugin Manager.
 */ var ScenePlugin = new Class({
                Extends: BasePlugin,
                initialize: function ScenePlugin(scene, pluginManager) {
                    BasePlugin.call(this, pluginManager);
                    /**
         * A reference to the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#scene
         * @type {?Phaser.Scene}
         * @protected
         * @since 3.8.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems of the Scene that has installed this plugin.
         * Only set if it's a Scene Plugin, otherwise `null`.
         * This property is only set when the plugin is instantiated and added to the Scene, not before.
         * You can use it during the `boot` method.
         *
         * @name Phaser.Plugins.ScenePlugin#systems
         * @type {?Phaser.Scenes.Systems}
         * @protected
         * @since 3.8.0
         */ this.systems = scene.sys;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                },
                /**
     * This method is called when the Scene boots. It is only ever called once.
     *
     * By this point the plugin properties `scene` and `systems` will have already been set.
     *
     * In here you can listen for {@link Phaser.Scenes.Events Scene events} and set-up whatever you need for this plugin to run.
     * Here are the Scene events you can listen to:
     *
     * - start
     * - ready
     * - preupdate
     * - update
     * - postupdate
     * - resize
     * - pause
     * - resume
     * - sleep
     * - wake
     * - transitioninit
     * - transitionstart
     * - transitioncomplete
     * - transitionout
     * - shutdown
     * - destroy
     *
     * At the very least you should offer a destroy handler for when the Scene closes down, i.e:
     *
     * ```javascript
     * var eventEmitter = this.systems.events;
     * eventEmitter.once('destroy', this.sceneDestroy, this);
     * ```
     *
     * @method Phaser.Plugins.ScenePlugin#boot
     * @since 3.8.0
     */ boot: function() {},
                /**
     * Game instance has been destroyed.
     * 
     * You must release everything in here, all references, all objects, free it all up.
     *
     * @method Phaser.Plugins.ScenePlugin#destroy
     * @since 3.8.0
     */ destroy: function() {
                    this.pluginManager = null;
                    this.game = null;
                    this.scene = null;
                    this.systems = null;
                }
            });
            module1.exports = ScenePlugin;
        /***/ },
        /* 1399 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer
 */ /**
 * @namespace Phaser.Types.Renderer
 */ module1.exports = {
                Canvas: __webpack_require__(1400),
                Events: __webpack_require__(88),
                Snapshot: __webpack_require__(1401),
                WebGL: __webpack_require__(1402)
            };
        /***/ },
        /* 1400 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Canvas
 */ module1.exports = {
                CanvasRenderer: __webpack_require__(362),
                GetBlendModes: __webpack_require__(364),
                SetTransform: __webpack_require__(30)
            };
        /***/ },
        /* 1401 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Renderer.Snapshot
 */ module1.exports = {
                Canvas: __webpack_require__(363),
                WebGL: __webpack_require__(377)
            };
        /***/ },
        /* 1402 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var WEBGL_CONST = __webpack_require__(104);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Renderer.WebGL
 */ var WebGL = {
                PipelineManager: __webpack_require__(366),
                Pipelines: __webpack_require__(1403),
                RenderTarget: __webpack_require__(139),
                Utils: __webpack_require__(12),
                WebGLPipeline: __webpack_require__(57),
                WebGLRenderer: __webpack_require__(365),
                WebGLShader: __webpack_require__(369)
            };
            //   Merge in the consts
            WebGL = Extend(false, WebGL, WEBGL_CONST);
            //  Export it
            module1.exports = WebGL;
        /***/ },
        /* 1403 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(65);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Renderer.WebGL.Pipelines
 */ var Pipelines = {
                BitmapMaskPipeline: __webpack_require__(367),
                Events: __webpack_require__(368),
                GraphicsPipeline: __webpack_require__(370),
                LightPipeline: __webpack_require__(371),
                MultiPipeline: __webpack_require__(105),
                PointLightPipeline: __webpack_require__(372),
                PostFXPipeline: __webpack_require__(1404),
                RopePipeline: __webpack_require__(373),
                SinglePipeline: __webpack_require__(374),
                UtilityPipeline: __webpack_require__(375)
            };
            //   Merge in the consts
            Pipelines = Extend(false, Pipelines, CONST);
            //  Export it
            module1.exports = Pipelines;
        /***/ },
        /* 1404 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var ColorMatrix = __webpack_require__(195);
            var GetFastValue = __webpack_require__(2);
            var ShaderSourceFS = __webpack_require__(1405);
            var ShaderSourceVS = __webpack_require__(376);
            var WebGLPipeline = __webpack_require__(57);
            /**
 * @classdesc
 * The Post FX Pipeline is a special kind of pipeline specifically for handling post
 * processing effects. Where-as a standard Pipeline allows you to control the process
 * of rendering Game Objects by configuring the shaders and attributes used to draw them,
 * a Post FX Pipeline is designed to allow you to apply processing _after_ the Game Object/s
 * have been rendered. Typical examples of post processing effects are bloom filters,
 * blurs, light effects and color manipulation.
 *
 * The pipeline works by creating a tiny vertex buffer with just one single hard-coded quad
 * in it. Game Objects can have a Post Pipeline set on them. Those objects are then rendered
 * using their standard pipeline, but are redirected to the Render Targets owned by the
 * post pipeline, which can then apply their own shaders and effects, before passing them
 * back to the main renderer.
 *
 * Please see the Phaser 3 examples for further details on this extensive subject.
 *
 * The default fragment shader it uses can be found in `shaders/src/PostFX.frag`.
 * The default vertex shader it uses can be found in `shaders/src/Quad.vert`.
 *
 * The default shader attributes for this pipeline are:
 *
 * `inPosition` (vec2, offset 0)
 * `inTexCoord` (vec2, offset 8)
 *
 * The vertices array layout is:
 *
 * -1,  1   B----C   1,  1
 *  0,  1   |   /|   1,  1
 *          |  / |
 *          | /  |
 *          |/   |
 * -1, -1   A----D   1, -1
 *  0,  0            1,  0
 *
 * A = -1, -1 (pos) and 0, 0 (uv)
 * B = -1,  1 (pos) and 0, 1 (uv)
 * C =  1,  1 (pos) and 1, 1 (uv)
 * D =  1, -1 (pos) and 1, 0 (uv)
 *
 * First tri: A, B, C
 * Second tri: A, C, D
 *
 * Array index:
 *
 * 0  = Tri 1 - Vert A - x pos
 * 1  = Tri 1 - Vert A - y pos
 * 2  = Tri 1 - Vert A - uv u
 * 3  = Tri 1 - Vert A - uv v
 *
 * 4  = Tri 1 - Vert B - x pos
 * 5  = Tri 1 - Vert B - y pos
 * 6  = Tri 1 - Vert B - uv u
 * 7  = Tri 1 - Vert B - uv v
 *
 * 8  = Tri 1 - Vert C - x pos
 * 9  = Tri 1 - Vert C - y pos
 * 10 = Tri 1 - Vert C - uv u
 * 11 = Tri 1 - Vert C - uv v
 *
 * 12 = Tri 2 - Vert A - x pos
 * 13 = Tri 2 - Vert A - y pos
 * 14 = Tri 2 - Vert A - uv u
 * 15 = Tri 2 - Vert A - uv v
 *
 * 16 = Tri 2 - Vert C - x pos
 * 17 = Tri 2 - Vert C - y pos
 * 18 = Tri 2 - Vert C - uv u
 * 19 = Tri 2 - Vert C - uv v
 *
 * 20 = Tri 2 - Vert D - x pos
 * 21 = Tri 2 - Vert D - y pos
 * 22 = Tri 2 - Vert D - uv u
 * 23 = Tri 2 - Vert D - uv v
 *
 * @class PostFXPipeline
 * @extends Phaser.Renderer.WebGL.WebGLPipeline
 * @memberof Phaser.Renderer.WebGL.Pipelines
 * @constructor
 * @since 3.50.0
 *
 * @param {Phaser.Types.Renderer.WebGL.WebGLPipelineConfig} config - The configuration options for this pipeline.
 */ var PostFXPipeline = new Class({
                Extends: WebGLPipeline,
                initialize: function PostFXPipeline(config) {
                    config.renderTarget = GetFastValue(config, 'renderTarget', 1);
                    config.fragShader = GetFastValue(config, 'fragShader', ShaderSourceFS);
                    config.vertShader = GetFastValue(config, 'vertShader', ShaderSourceVS);
                    config.attributes = GetFastValue(config, 'attributes', [
                        {
                            name: 'inPosition',
                            size: 2
                        },
                        {
                            name: 'inTexCoord',
                            size: 2
                        }
                    ]);
                    config.batchSize = 1;
                    config.vertices = [
                        -1,
                        -1,
                        0,
                        0,
                        -1,
                        1,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        -1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        -1,
                        1,
                        0
                    ];
                    WebGLPipeline.call(this, config);
                    this.isPostFX = true;
                    /**
         * If this post-pipeline belongs to a Game Object or Camera, this contains a reference to it.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#gameObject
         * @type {Phaser.GameObjects.GameObject}
         * @since 3.50.0
         */ this.gameObject;
                    /**
         * A Color Matrix instance belonging to this pipeline.
         *
         * Used during calls to the `drawFrame` method.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#colorMatrix
         * @type {Phaser.Display.ColorMatrix}
         * @since 3.50.0
         */ this.colorMatrix = new ColorMatrix();
                    /**
         * A reference to the Full Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame1;
                    /**
         * A reference to the Full Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is the full size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#fullFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.fullFrame2;
                    /**
         * A reference to the Half Frame 1 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame1
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame1;
                    /**
         * A reference to the Half Frame 2 Render Target that belongs to the
         * Utility Pipeline. This property is set during the `boot` method.
         *
         * This Render Target is half the size of the renderer.
         *
         * You can use this directly in Post FX Pipelines for multi-target effects.
         * However, be aware that these targets are shared between all post fx pipelines.
         *
         * @name Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#halfFrame2
         * @type {Phaser.Renderer.WebGL.RenderTarget}
         * @default null
         * @since 3.50.0
         */ this.halfFrame2;
                    if (this.renderer.isBooted) {
                        this.manager = this.renderer.pipelines;
                        this.boot();
                    }
                },
                boot: function() {
                    WebGLPipeline.prototype.boot.call(this);
                    var utility = this.manager.UTILITY_PIPELINE;
                    this.fullFrame1 = utility.fullFrame1;
                    this.fullFrame2 = utility.fullFrame2;
                    this.halfFrame1 = utility.halfFrame1;
                    this.halfFrame2 = utility.halfFrame2;
                    this.set1i('uMainSampler', 0);
                },
                onDraw: function(renderTarget) {
                    this.bindAndDraw(renderTarget);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * The difference between this method and `drawFrame` is that this method
     * uses a faster copy shader, where only the brightness can be modified.
     * If you need color level manipulation, see `drawFrame` instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrame: function(source, target, brightness, clear, clearAlpha) {
                    this.manager.copyFrame(source, target, brightness, clear, clearAlpha);
                },
                /**
     * Pops the framebuffer from the renderers FBO stack and sets that as the active target,
     * then draws the `source` Render Target to it. It then resets the renderer textures.
     *
     * This should be done when you need to draw the _final_ results of a pipeline to the game
     * canvas, or the next framebuffer in line on the FBO stack. You should only call this once
     * in the `onDraw` handler and it should be the final thing called. Be careful not to call
     * this if you need to actually use the pipeline shader, instead of the copy shader. In
     * those cases, use the `bindAndDraw` method.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyToGame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     */ copyToGame: function(source) {
                    this.manager.copyToGame(source);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target, using the
     * given Color Matrix.
     *
     * The difference between this method and `copyFrame` is that this method
     * uses a color matrix shader, where you have full control over the luminance
     * values used during the copy. If you don't need this, you can use the faster
     * `copyFrame` method instead.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#drawFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ drawFrame: function(source, target, clearAlpha) {
                    this.manager.drawFrame(source, target, clearAlpha, this.colorMatrix);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using a linear blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFrames
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFrames: function(source1, source2, target, strength, clearAlpha) {
                    this.manager.blendFrames(source1, source2, target, strength, clearAlpha);
                },
                /**
     * Draws the `source1` and `source2` Render Targets to the `target` Render Target
     * using an additive blend effect, which is controlled by the `strength` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blendFramesAdditive
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source1 - The first source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} source2 - The second source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The target Render Target.
     * @param {number} [strength=1] - The strength of the blend.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ blendFramesAdditive: function(source1, source2, target, strength, clearAlpha) {
                    this.manager.blendFramesAdditive(source1, source2, target, strength, clearAlpha);
                },
                /**
     * Clears the given Render Target.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#clearFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The Render Target to clear.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ clearFrame: function(target, clearAlpha) {
                    this.manager.clearFrame(target, clearAlpha);
                },
                /**
     * Copy the `source` Render Target to the `target` Render Target.
     *
     * The difference with this copy is that no resizing takes place. If the `source`
     * Render Target is larger than the `target` then only a portion the same size as
     * the `target` dimensions is copied across.
     *
     * You can optionally set the brightness factor of the copy.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#blitFrame
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} [brightness=1] - The brightness value applied to the frame copy.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {boolean} [eraseMode=false] - Erase source from target using ERASE Blend Mode?
     */ blitFrame: function(source, target, brightness, clear, clearAlpha, eraseMode) {
                    this.manager.blitFrame(source, target, brightness, clear, clearAlpha, eraseMode);
                },
                /**
     * Binds the `source` Render Target and then copies a section of it to the `target` Render Target.
     *
     * This method is extremely fast because it uses `gl.copyTexSubImage2D` and doesn't
     * require the use of any shaders. Remember the coordinates are given in standard WebGL format,
     * where x and y specify the lower-left corner of the section, not the top-left. Also, the
     * copy entirely replaces the contents of the target texture, no 'merging' or 'blending' takes
     * place.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#copyFrameRect
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The source Render Target.
     * @param {Phaser.Renderer.WebGL.RenderTarget} target - The target Render Target.
     * @param {number} x - The x coordinate of the lower left corner where to start copying.
     * @param {number} y - The y coordinate of the lower left corner where to start copying.
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {boolean} [clear=true] - Clear the target before copying?
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     */ copyFrameRect: function(source, target, x, y, width, height, clear, clearAlpha) {
                    this.manager.copyFrameRect(source, target, x, y, width, height, clear, clearAlpha);
                },
                /**
     * Binds this pipeline and draws the `source` Render Target to the `target` Render Target.
     *
     * If no `target` is specified, it will pop the framebuffer from the Renderers FBO stack
     * and use that instead, which should be done when you need to draw the final results of
     * this pipeline to the game canvas.
     *
     * You can optionally set the shader to be used for the draw here, if this is a multi-shader
     * pipeline. By default `currentShader` will be used. If you need to set a shader but not
     * a target, just pass `null` as the `target` parameter.
     *
     * @method Phaser.Renderer.WebGL.Pipelines.PostFXPipeline#bindAndDraw
     * @since 3.50.0
     *
     * @param {Phaser.Renderer.WebGL.RenderTarget} source - The Render Target to draw from.
     * @param {Phaser.Renderer.WebGL.RenderTarget} [target] - The Render Target to draw to. If not set, it will pop the fbo from the stack.
     * @param {boolean} [clear=true] - Clear the target before copying? Only used if `target` parameter is set.
     * @param {boolean} [clearAlpha=true] - Clear the alpha channel when running `gl.clear` on the target?
     * @param {Phaser.Renderer.WebGL.WebGLShader} [currentShader] - The shader to use during the draw.
     */ bindAndDraw: function(source, target, clear, clearAlpha, currentShader) {
                    if (clear === undefined) clear = true;
                    if (clearAlpha === undefined) clearAlpha = true;
                    var gl = this.gl;
                    var renderer = this.renderer;
                    this.bind(currentShader);
                    this.set1i('uMainSampler', 0);
                    if (target) {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.framebuffer);
                        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target.texture, 0);
                        if (clear) {
                            if (clearAlpha) gl.clearColor(0, 0, 0, 0);
                            else gl.clearColor(0, 0, 0, 1);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                    } else {
                        renderer.popFramebuffer(false, false, false);
                        if (!renderer.currentFramebuffer) gl.viewport(0, 0, renderer.width, renderer.height);
                    }
                    gl.activeTexture(gl.TEXTURE0);
                    gl.bindTexture(gl.TEXTURE_2D, source.texture);
                    gl.bufferData(gl.ARRAY_BUFFER, this.vertexData, gl.STATIC_DRAW);
                    gl.drawArrays(gl.TRIANGLES, 0, 6);
                    if (!target) renderer.resetTextures();
                    else {
                        gl.bindTexture(gl.TEXTURE_2D, null);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    }
                }
            });
            module1.exports = PostFXPipeline;
        /***/ },
        /* 1405 */ /***/ function(module1, exports) {
            module1.exports = [
                '#define SHADER_NAME PHASER_POSTFX_FS',
                '',
                'precision mediump float;',
                '',
                'uniform sampler2D uMainSampler;',
                '',
                'varying vec2 outTexCoord;',
                '',
                'void main ()',
                '{',
                '    gl_FragColor = texture2D(uMainSampler, outTexCoord);',
                '}',
                ''
            ].join('\n');
        /***/ },
        /* 1406 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var CONST = __webpack_require__(198);
            /**
 * @namespace Phaser.Scale
 * 
 * @borrows Phaser.Scale.Center.NO_CENTER as NO_CENTER
 * @borrows Phaser.Scale.Center.CENTER_BOTH as CENTER_BOTH
 * @borrows Phaser.Scale.Center.CENTER_HORIZONTALLY as CENTER_HORIZONTALLY
 * @borrows Phaser.Scale.Center.CENTER_VERTICALLY as CENTER_VERTICALLY
 * 
 * @borrows Phaser.Scale.Orientation.LANDSCAPE as LANDSCAPE
 * @borrows Phaser.Scale.Orientation.PORTRAIT as PORTRAIT
 * 
 * @borrows Phaser.Scale.ScaleModes.NONE as NONE
 * @borrows Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT as WIDTH_CONTROLS_HEIGHT
 * @borrows Phaser.Scale.ScaleModes.HEIGHT_CONTROLS_WIDTH as HEIGHT_CONTROLS_WIDTH
 * @borrows Phaser.Scale.ScaleModes.FIT as FIT
 * @borrows Phaser.Scale.ScaleModes.ENVELOP as ENVELOP
 * @borrows Phaser.Scale.ScaleModes.RESIZE as RESIZE
 * 
 * @borrows Phaser.Scale.Zoom.NO_ZOOM as NO_ZOOM
 * @borrows Phaser.Scale.Zoom.ZOOM_2X as ZOOM_2X
 * @borrows Phaser.Scale.Zoom.ZOOM_4X as ZOOM_4X
 * @borrows Phaser.Scale.Zoom.MAX_ZOOM as MAX_ZOOM
 */ var Scale = {
                Center: __webpack_require__(397),
                Events: __webpack_require__(101),
                Orientation: __webpack_require__(398),
                ScaleManager: __webpack_require__(409),
                ScaleModes: __webpack_require__(399),
                Zoom: __webpack_require__(400)
            };
            Scale = Extend(false, Scale, CONST.CENTER);
            Scale = Extend(false, Scale, CONST.ORIENTATION);
            Scale = Extend(false, Scale, CONST.SCALE_MODE);
            Scale = Extend(false, Scale, CONST.ZOOM);
            module1.exports = Scale;
        /***/ },
        /* 1407 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(142);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Scenes
 */ var Scene = {
                Events: __webpack_require__(21),
                GetPhysicsPlugins: __webpack_require__(413),
                GetScenePlugins: __webpack_require__(414),
                SceneManager: __webpack_require__(411),
                ScenePlugin: __webpack_require__(1408),
                Settings: __webpack_require__(415),
                Systems: __webpack_require__(201)
            };
            //   Merge in the consts
            Scene = Extend(false, Scene, CONST);
            module1.exports = Scene;
        /***/ },
        /* 1408 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clamp = __webpack_require__(18);
            var Class = __webpack_require__(0);
            var Events = __webpack_require__(21);
            var GetFastValue = __webpack_require__(2);
            var PluginCache = __webpack_require__(24);
            /**
 * @classdesc
 * A proxy class to the Global Scene Manager.
 *
 * @class ScenePlugin
 * @memberof Phaser.Scenes
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene that this ScenePlugin belongs to.
 */ var ScenePlugin = new Class({
                initialize: function ScenePlugin(scene) {
                    /**
         * The Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene Systems instance of the Scene that this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The settings of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#settings
         * @type {Phaser.Types.Scenes.SettingsObject}
         * @since 3.0.0
         */ this.settings = scene.sys.settings;
                    /**
         * The key of the Scene this ScenePlugin belongs to.
         *
         * @name Phaser.Scenes.ScenePlugin#key
         * @type {string}
         * @since 3.0.0
         */ this.key = scene.sys.settings.key;
                    /**
         * The Game's SceneManager.
         *
         * @name Phaser.Scenes.ScenePlugin#manager
         * @type {Phaser.Scenes.SceneManager}
         * @since 3.0.0
         */ this.manager = scene.sys.game.scene;
                    /**
         * If this Scene is currently transitioning to another, this holds
         * the current percentage of the transition progress, between 0 and 1.
         *
         * @name Phaser.Scenes.ScenePlugin#transitionProgress
         * @type {number}
         * @since 3.5.0
         */ this.transitionProgress = 0;
                    /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_elapsed
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._elapsed = 0;
                    /**
         * Transition elapsed timer.
         *
         * @name Phaser.Scenes.ScenePlugin#_target
         * @type {?Phaser.Scenes.Scene}
         * @private
         * @since 3.5.0
         */ this._target = null;
                    /**
         * Transition duration.
         *
         * @name Phaser.Scenes.ScenePlugin#_duration
         * @type {number}
         * @private
         * @since 3.5.0
         */ this._duration = 0;
                    /**
         * Transition callback.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdate
         * @type {function}
         * @private
         * @since 3.5.0
         */ this._onUpdate;
                    /**
         * Transition callback scope.
         *
         * @name Phaser.Scenes.ScenePlugin#_onUpdateScope
         * @type {object}
         * @private
         * @since 3.5.0
         */ this._onUpdateScope;
                    /**
         * Will this Scene sleep (true) after the transition, or stop (false)
         *
         * @name Phaser.Scenes.ScenePlugin#_willSleep
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willSleep = false;
                    /**
         * Will this Scene be removed from the Scene Manager after the transition completes?
         *
         * @name Phaser.Scenes.ScenePlugin#_willRemove
         * @type {boolean}
         * @private
         * @since 3.5.0
         */ this._willRemove = false;
                    scene.sys.events.once(Events.BOOT, this.boot, this);
                    scene.sys.events.on(Events.START, this.pluginStart, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#boot
     * @private
     * @since 3.0.0
     */ boot: function() {
                    this.systems.events.once(Events.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Scenes.ScenePlugin#pluginStart
     * @private
     * @since 3.5.0
     */ pluginStart: function() {
                    this._target = null;
                    this.systems.events.once(Events.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Shutdown this Scene and run the given one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#start
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to start.
     * @param {object} [data] - The Scene data.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ start: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('stop', this.key);
                    this.manager.queueOp('start', key, data);
                    return this;
                },
                /**
     * Restarts this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#restart
     * @since 3.4.0
     *
     * @param {object} [data] - The Scene data.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ restart: function(data) {
                    var key = this.key;
                    this.manager.queueOp('stop', key);
                    this.manager.queueOp('start', key, data);
                    return this;
                },
                /**
     * This will start a transition from the current Scene to the target Scene given.
     *
     * The transition will last for the duration specified in milliseconds.
     *
     * You can have the target Scene moved above or below this one in the display list.
     *
     * You can specify an update callback. This callback will be invoked _every frame_ for the duration
     * of the transition.
     *
     * This Scene can either be sent to sleep at the end of the transition, or stopped. The default is to stop.
     *
     * There are also 5 transition related events: This scene will emit the event `transitionout` when
     * the transition begins, which is typically the frame after calling this method.
     *
     * The target Scene will emit the event `transitioninit` when that Scene's `init` method is called.
     * It will then emit the event `transitionstart` when its `create` method is called.
     * If the Scene was sleeping and has been woken up, it will emit the event `transitionwake` instead of these two,
     * as the Scenes `init` and `create` methods are not invoked when a Scene wakes up.
     *
     * When the duration of the transition has elapsed it will emit the event `transitioncomplete`.
     * These events are cleared of all listeners when the Scene shuts down, but not if it is sent to sleep.
     *
     * It's important to understand that the duration of the transition begins the moment you call this method.
     * If the Scene you are transitioning to includes delayed processes, such as waiting for files to load, the
     * time still counts down even while that is happening. If the game itself pauses, or something else causes
     * this Scenes update loop to stop, then the transition will also pause for that duration. There are
     * checks in place to prevent you accidentally stopping a transitioning Scene but if you've got code to
     * override this understand that until the target Scene completes it might never be unlocked for input events.
     *
     * @method Phaser.Scenes.ScenePlugin#transition
     * @fires Phaser.Scenes.Events#TRANSITION_OUT
     * @since 3.5.0
     *
     * @param {Phaser.Types.Scenes.SceneTransitionConfig} config - The transition configuration object.
     *
     * @return {boolean} `true` is the transition was started, otherwise `false`.
     */ transition: function(config) {
                    if (config === undefined) config = {};
                    var key = GetFastValue(config, 'target', false);
                    var target = this.manager.getScene(key);
                    if (!key || !this.checkValidTransition(target)) return false;
                    var duration = GetFastValue(config, 'duration', 1000);
                    this._elapsed = 0;
                    this._target = target;
                    this._duration = duration;
                    this._willSleep = GetFastValue(config, 'sleep', false);
                    this._willRemove = GetFastValue(config, 'remove', false);
                    var callback = GetFastValue(config, 'onUpdate', null);
                    if (callback) {
                        this._onUpdate = callback;
                        this._onUpdateScope = GetFastValue(config, 'onUpdateScope', this.scene);
                    }
                    var allowInput = GetFastValue(config, 'allowInput', false);
                    this.settings.transitionAllowInput = allowInput;
                    var targetSettings = target.sys.settings;
                    targetSettings.isTransition = true;
                    targetSettings.transitionFrom = this.scene;
                    targetSettings.transitionDuration = duration;
                    targetSettings.transitionAllowInput = allowInput;
                    if (GetFastValue(config, 'moveAbove', false)) this.manager.moveAbove(this.key, key);
                    else if (GetFastValue(config, 'moveBelow', false)) this.manager.moveBelow(this.key, key);
                    if (target.sys.isSleeping()) target.sys.wake(GetFastValue(config, 'data'));
                    else this.manager.start(key, GetFastValue(config, 'data'));
                    this.systems.events.emit(Events.TRANSITION_OUT, target, duration);
                    this.systems.events.on(Events.UPDATE, this.step, this);
                    return true;
                },
                /**
     * Checks to see if this Scene can transition to the target Scene or not.
     *
     * @method Phaser.Scenes.ScenePlugin#checkValidTransition
     * @private
     * @since 3.5.0
     *
     * @param {Phaser.Scene} target - The Scene to test against.
     *
     * @return {boolean} `true` if this Scene can transition, otherwise `false`.
     */ checkValidTransition: function(target) {
                    //  Not a valid target if it doesn't exist, isn't active or is already transitioning in or out
                    if (!target || target.sys.isActive() || target.sys.isTransitioning() || target === this.scene || this.systems.isTransitioning()) return false;
                    return true;
                },
                /**
     * A single game step. This is only called if the parent Scene is transitioning
     * out to another Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#step
     * @private
     * @since 3.5.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ step: function(time, delta) {
                    this._elapsed += delta;
                    this.transitionProgress = Clamp(this._elapsed / this._duration, 0, 1);
                    if (this._onUpdate) this._onUpdate.call(this._onUpdateScope, this.transitionProgress);
                    if (this._elapsed >= this._duration) this.transitionComplete();
                },
                /**
     * Called by `step` when the transition out of this scene to another is over.
     *
     * @method Phaser.Scenes.ScenePlugin#transitionComplete
     * @private
     * @fires Phaser.Scenes.Events#TRANSITION_COMPLETE
     * @since 3.5.0
     */ transitionComplete: function() {
                    var targetSys = this._target.sys;
                    var targetSettings = this._target.sys.settings;
                    //  Stop the step
                    this.systems.events.off(Events.UPDATE, this.step, this);
                    //  Notify target scene
                    targetSys.events.emit(Events.TRANSITION_COMPLETE, this.scene);
                    //  Clear target scene settings
                    targetSettings.isTransition = false;
                    targetSettings.transitionFrom = null;
                    //  Clear local settings
                    this._duration = 0;
                    this._target = null;
                    this._onUpdate = null;
                    this._onUpdateScope = null;
                    //  Now everything is clear we can handle what happens to this Scene
                    if (this._willRemove) this.manager.remove(this.key);
                    else if (this._willSleep) this.systems.sleep();
                    else this.manager.stop(this.key);
                },
                /**
     * Add the Scene into the Scene Manager and start it if 'autoStart' is true or the Scene config 'active' property is set.
     *
     * @method Phaser.Scenes.ScenePlugin#add
     * @since 3.0.0
     *
     * @param {string} key - The Scene key.
     * @param {(Phaser.Scene|Phaser.Types.Scenes.SettingsConfig|Phaser.Types.Scenes.CreateSceneFromObjectConfig|function)} sceneConfig - The config for the Scene.
     * @param {boolean} autoStart - Whether to start the Scene after it's added.
     * @param {object} [data] - Optional data object. This will be set as Scene.settings.data and passed to `Scene.init`.
     *
     * @return {Phaser.Scene} An instance of the Scene that was added to the Scene Manager.
     */ add: function(key, sceneConfig, autoStart, data) {
                    return this.manager.add(key, sceneConfig, autoStart, data);
                },
                /**
     * Launch the given Scene and run it in parallel with this one.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#launch
     * @since 3.0.0
     *
     * @param {string} key - The Scene to launch.
     * @param {object} [data] - The Scene data.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ launch: function(key, data) {
                    if (key && key !== this.key) this.manager.queueOp('start', key, data);
                    return this;
                },
                /**
     * Runs the given Scene, but does not change the state of this Scene.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * If the given Scene is paused, it will resume it. If sleeping, it will wake it.
     * If not running at all, it will be started.
     *
     * Use this if you wish to open a modal Scene by calling `pause` on the current
     * Scene, then `run` on the modal Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#run
     * @since 3.10.0
     *
     * @param {string} key - The Scene to run.
     * @param {object} [data] - A data object that will be passed to the Scene and emitted in its ready, wake, or resume events.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ run: function(key, data) {
                    if (key && key !== this.key) this.manager.queueOp('run', key, data);
                    return this;
                },
                /**
     * Pause the Scene - this stops the update step from happening but it still renders.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#pause
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to pause.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its pause event.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ pause: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('pause', key, data);
                    return this;
                },
                /**
     * Resume the Scene - starts the update loop again.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#resume
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to resume.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its resume event.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ resume: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('resume', key, data);
                    return this;
                },
                /**
     * Makes the Scene sleep (no update, no render) but doesn't shutdown.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#sleep
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to put to sleep.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its sleep event.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ sleep: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('sleep', key, data);
                    return this;
                },
                /**
     * Makes the Scene wake-up (starts update and render)
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#wake
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to wake up.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted in its wake event.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ wake: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('wake', key, data);
                    return this;
                },
                /**
     * Makes this Scene sleep then starts the Scene given.
     *
     * This will happen at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#switch
     * @since 3.0.0
     *
     * @param {string} key - The Scene to start.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ switch: function(key) {
                    if (key !== this.key) this.manager.queueOp('switch', this.key, key);
                    return this;
                },
                /**
     * Shutdown the Scene, clearing display list, timers, etc.
     *
     * This happens at the next Scene Manager update, not immediately.
     *
     * @method Phaser.Scenes.ScenePlugin#stop
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to stop.
     * @param {any} [data] - Optional data object to pass to Scene.Systems.shutdown.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ stop: function(key, data) {
                    if (key === undefined) key = this.key;
                    this.manager.queueOp('stop', key, data);
                    return this;
                },
                /**
     * Sets the active state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setActive
     * @since 3.0.0
     *
     * @param {boolean} value - If `true` the Scene will be resumed. If `false` it will be paused.
     * @param {string} [key] - The Scene to set the active state of.
     * @param {object} [data] - An optional data object that will be passed to the Scene and emitted with its events.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ setActive: function(value, key, data) {
                    if (key === undefined) key = this.key;
                    var scene = this.manager.getScene(key);
                    if (scene) scene.sys.setActive(value, data);
                    return this;
                },
                /**
     * Sets the visible state of the given Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#setVisible
     * @since 3.0.0
     *
     * @param {boolean} value - The visible value.
     * @param {string} [key] - The Scene to set the visible state for.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ setVisible: function(value, key) {
                    if (key === undefined) key = this.key;
                    var scene = this.manager.getScene(key);
                    if (scene) scene.sys.setVisible(value);
                    return this;
                },
                /**
     * Checks if the given Scene is sleeping or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isSleeping
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is sleeping.
     */ isSleeping: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isSleeping(key);
                },
                /**
     * Checks if the given Scene is running or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isActive
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is running.
     */ isActive: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isActive(key);
                },
                /**
     * Checks if the given Scene is paused or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isPaused
     * @since 3.17.0
     *
     * @param {string} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is paused.
     */ isPaused: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isPaused(key);
                },
                /**
     * Checks if the given Scene is visible or not?
     *
     * @method Phaser.Scenes.ScenePlugin#isVisible
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to check.
     *
     * @return {boolean} Whether the Scene is visible.
     */ isVisible: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.isVisible(key);
                },
                /**
     * Swaps the position of two scenes in the Scenes list.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#swapPosition
     * @since 3.2.0
     *
     * @param {string} keyA - The first Scene to swap.
     * @param {string} [keyB] - The second Scene to swap. If none is given it defaults to this Scene.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ swapPosition: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.swapPosition(keyA, keyB);
                    return this;
                },
                /**
     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly above Scene A.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#moveAbove
     * @since 3.2.0
     *
     * @param {string} keyA - The Scene that Scene B will be moved to be above.
     * @param {string} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ moveAbove: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.moveAbove(keyA, keyB);
                    return this;
                },
                /**
     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly below Scene A.
     *
     * This controls the order in which they are rendered and updated.
     *
     * @method Phaser.Scenes.ScenePlugin#moveBelow
     * @since 3.2.0
     *
     * @param {string} keyA - The Scene that Scene B will be moved to be below.
     * @param {string} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ moveBelow: function(keyA, keyB) {
                    if (keyB === undefined) keyB = this.key;
                    if (keyA !== keyB) this.manager.moveBelow(keyA, keyB);
                    return this;
                },
                /**
     * Removes a Scene from the SceneManager.
     *
     * The Scene is removed from the local scenes array, it's key is cleared from the keys
     * cache and Scene.Systems.destroy is then called on it.
     *
     * If the SceneManager is processing the Scenes when this method is called it will
     * queue the operation for the next update sequence.
     *
     * @method Phaser.Scenes.ScenePlugin#remove
     * @since 3.2.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to be removed.
     *
     * @return {Phaser.Scenes.SceneManager} This SceneManager.
     */ remove: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.remove(key);
                    return this;
                },
                /**
     * Moves a Scene up one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveUp
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to move.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ moveUp: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.moveUp(key);
                    return this;
                },
                /**
     * Moves a Scene down one position in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#moveDown
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to move.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ moveDown: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.moveDown(key);
                    return this;
                },
                /**
     * Brings a Scene to the top of the Scenes list.
     *
     * This means it will render above all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#bringToTop
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to move.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ bringToTop: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.bringToTop(key);
                    return this;
                },
                /**
     * Sends a Scene to the back of the Scenes list.
     *
     * This means it will render below all other Scenes.
     *
     * @method Phaser.Scenes.ScenePlugin#sendToBack
     * @since 3.0.0
     *
     * @param {string} [key] - The Scene to move.
     *
     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
     */ sendToBack: function(key) {
                    if (key === undefined) key = this.key;
                    this.manager.sendToBack(key);
                    return this;
                },
                /**
     * Retrieve a Scene.
     *
     * @method Phaser.Scenes.ScenePlugin#get
     * @since 3.0.0
     *
     * @param {string} key - The Scene to retrieve.
     *
     * @return {Phaser.Scene} The Scene.
     */ get: function(key) {
                    return this.manager.getScene(key);
                },
                /**
     * Retrieves the numeric index of a Scene in the Scenes list.
     *
     * @method Phaser.Scenes.ScenePlugin#getIndex
     * @since 3.7.0
     *
     * @param {(string|Phaser.Scene)} [key] - The Scene to get the index of.
     *
     * @return {number} The index of the Scene.
     */ getIndex: function(key) {
                    if (key === undefined) key = this.key;
                    return this.manager.getIndex(key);
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Scenes.ScenePlugin#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(Events.SHUTDOWN, this.shutdown, this);
                    eventEmitter.off(Events.POST_UPDATE, this.step, this);
                    eventEmitter.off(Events.TRANSITION_OUT);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Scenes.ScenePlugin#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(Events.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                    this.settings = null;
                    this.manager = null;
                }
            });
            PluginCache.register('ScenePlugin', ScenePlugin, 'scenePlugin');
            module1.exports = ScenePlugin;
        /***/ },
        /* 1409 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Structs
 */ module1.exports = {
                Events: __webpack_require__(432),
                List: __webpack_require__(107),
                Map: __webpack_require__(99),
                ProcessQueue: __webpack_require__(208),
                RTree: __webpack_require__(525),
                Set: __webpack_require__(148),
                Size: __webpack_require__(410)
            };
        /***/ },
        /* 1410 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var FilterMode = __webpack_require__(1411);
            /**
 * @namespace Phaser.Textures
 */ /**
 * Linear filter type.
 * 
 * @name Phaser.Textures.LINEAR
 * @type {number}
 * @const
 * @since 3.0.0
 */ /**
 * Nearest Neighbor filter type.
 * 
 * @name Phaser.Textures.NEAREST
 * @type {number}
 * @const
 * @since 3.0.0
 */ var Textures = {
                CanvasTexture: __webpack_require__(417),
                Events: __webpack_require__(103),
                FilterMode: FilterMode,
                Frame: __webpack_require__(106),
                Parsers: __webpack_require__(419),
                Texture: __webpack_require__(203),
                TextureManager: __webpack_require__(416),
                TextureSource: __webpack_require__(418)
            };
            Textures = Extend(false, Textures, FilterMode);
            module1.exports = Textures;
        /***/ },
        /* 1411 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Filter Types.
 *
 * @namespace Phaser.Textures.FilterMode
 * @memberof Phaser.Textures
 * @since 3.0.0
 */ var CONST = {
                /**
     * Linear filter type.
     * 
     * @name Phaser.Textures.FilterMode.LINEAR
     * @type {number}
     * @const
     * @since 3.0.0
     */ LINEAR: 0,
                /**
     * Nearest neighbor filter type.
     * 
     * @name Phaser.Textures.FilterMode.NEAREST
     * @type {number}
     * @const
     * @since 3.0.0
     */ NEAREST: 1
            };
            module1.exports = CONST;
        /***/ },
        /* 1412 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Extend = __webpack_require__(17);
            var CONST = __webpack_require__(1413);
            /**
 * @namespace Phaser.Tilemaps
 *
 * @borrows Phaser.Tilemaps.Orientation.ORTHOGONAL as ORTHOGONAL
 * @borrows Phaser.Tilemaps.Orientation.ISOMETRIC as ISOMETRIC
 * @borrows Phaser.Tilemaps.Orientation.STAGGERED as STAGGERED
 * @borrows Phaser.Tilemaps.Orientation.HEXAGONAL as HEXAGONAL
 */ var Tilemaps = {
                Components: __webpack_require__(247),
                Parsers: __webpack_require__(1446),
                Formats: __webpack_require__(39),
                ImageCollection: __webpack_require__(572),
                ParseToTilemap: __webpack_require__(258),
                Tile: __webpack_require__(83),
                Tilemap: __webpack_require__(576),
                TilemapCreator: __webpack_require__(1452),
                TilemapFactory: __webpack_require__(1453),
                Tileset: __webpack_require__(121),
                TilemapLayer: __webpack_require__(577),
                Orientation: __webpack_require__(29),
                LayerData: __webpack_require__(119),
                MapData: __webpack_require__(120),
                ObjectLayer: __webpack_require__(568)
            };
            Tilemaps = Extend(false, Tilemaps, CONST.ORIENTATION);
            module1.exports = Tilemaps;
        /***/ },
        /* 1413 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = {
                ORIENTATION: __webpack_require__(29)
            };
            module1.exports = CONST;
        /***/ },
        /* 1414 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var CalculateFacesWithin = __webpack_require__(61);
            /**
 * Copies the tiles in the source rectangular area to a new destination (all specified in tile
 * coordinates) within the layer. This copies all tile properties & recalculates collision
 * information in the destination region.
 *
 * @function Phaser.Tilemaps.Components.Copy
 * @since 3.0.0
 *
 * @param {number} srcTileX - The x coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} srcTileY - The y coordinate of the area to copy from, in tiles, not pixels.
 * @param {number} width - The width of the area to copy, in tiles, not pixels.
 * @param {number} height - The height of the area to copy, in tiles, not pixels.
 * @param {number} destTileX - The x coordinate of the area to copy to, in tiles, not pixels.
 * @param {number} destTileY - The y coordinate of the area to copy to, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Copy = function(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (srcTileX < 0) srcTileX = 0;
                if (srcTileY < 0) srcTileY = 0;
                var srcTiles = GetTilesWithin(srcTileX, srcTileY, width, height, null, layer);
                var offsetX = destTileX - srcTileX;
                var offsetY = destTileY - srcTileY;
                for(var i = 0; i < srcTiles.length; i++){
                    var tileX = srcTiles[i].x + offsetX;
                    var tileY = srcTiles[i].y + offsetY;
                    if (tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height) {
                        if (layer.data[tileY][tileX]) layer.data[tileY][tileX].copy(srcTiles[i]);
                    }
                }
                if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                CalculateFacesWithin(destTileX - 1, destTileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = Copy;
        /***/ },
        /* 1415 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var ReplaceByIndex = __webpack_require__(538);
            /**
 * Creates a Sprite for every object matching the given tile indexes in the layer. You can
 * optionally specify if each tile will be replaced with a new tile after the Sprite has been
 * created. This is useful if you want to lay down special tiles in a level that are converted to
 * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
 *
 * @function Phaser.Tilemaps.Components.CreateFromTiles
 * @since 3.0.0
 *
 * @param {(number|number[])} indexes - The tile index, or array of indexes, to create Sprites from.
 * @param {(number|number[])} replacements - The tile index, or array of indexes, to change a converted tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a one-to-one mapping with the indexes array.
 * @param {Phaser.Types.GameObjects.Sprite.SpriteConfig} spriteConfig - The config object to pass into the Sprite creator (i.e. scene.make.sprite).
 * @param {Phaser.Scene} scene - The Scene to create the Sprites within.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when determining the world XY
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
 */ var CreateFromTiles = function(indexes, replacements, spriteConfig, scene, camera, layer) {
                if (!spriteConfig) spriteConfig = {};
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                var tilemapLayer = layer.tilemapLayer;
                if (!scene) scene = tilemapLayer.scene;
                if (!camera) camera = scene.cameras.main;
                var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
                var sprites = [];
                var i;
                for(i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    if (indexes.indexOf(tile.index) !== -1) {
                        var point = tilemapLayer.tileToWorldXY(tile.x, tile.y, undefined, camera, layer);
                        spriteConfig.x = point.x;
                        spriteConfig.y = point.y;
                        sprites.push(scene.make.sprite(spriteConfig));
                    }
                }
                if (typeof replacements === 'number') //  Assume 1 replacement for all types of tile given
                for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements, 0, 0, layer.width, layer.height, layer);
                else if (Array.isArray(replacements)) //  Assume 1 to 1 mapping with indexes array
                for(i = 0; i < indexes.length; i++)ReplaceByIndex(indexes[i], replacements[i], 0, 0, layer.width, layer.height, layer);
                return sprites;
            };
            module1.exports = CreateFromTiles;
        /***/ },
        /* 1416 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var CalculateFacesWithin = __webpack_require__(61);
            var SetTileCollision = __webpack_require__(72);
            /**
 * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
 * specified index. Tiles will be set to collide if the given index is a colliding index.
 * Collision information in the region will be recalculated.
 *
 * @function Phaser.Tilemaps.Components.Fill
 * @since 3.0.0
 *
 * @param {number} index - The tile index to fill the area with.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The tile layer to use. If not given the current layer is used.
 */ var Fill = function(index, tileX, tileY, width, height, recalculateFaces, layer) {
                var doesIndexCollide = layer.collideIndexes.indexOf(index) !== -1;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++){
                    tiles[i].index = index;
                    SetTileCollision(tiles[i], doesIndexCollide);
                }
                if (recalculateFaces) // Recalculate the faces within the area and neighboring tiles
                CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = Fill;
        /***/ },
        /* 1417 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
 * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FilterTiles
 * @since 3.0.0
 *
 * @param {function} callback - The callback. Each tile in the given area will be passed to this
 * callback as the first and only parameter. The callback should return true for tiles that pass the
 * filter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} The filtered array of Tiles.
 */ var FilterTiles = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                return tiles.filter(callback, context);
            };
            module1.exports = FilterTiles;
        /***/ },
        /* 1418 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Searches the entire map layer for the first tile matching the given index, then returns that Tile
 * object. If no match is found, it returns null. The search starts from the top-left tile and
 * continues horizontally until it hits the end of the row, then it drops down to the next column.
 * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
 * the top-left.
 *
 * @function Phaser.Tilemaps.Components.FindByIndex
 * @since 3.0.0
 *
 * @param {number} index - The tile index value to search for.
 * @param {number} skip - The number of times to skip a matching tile before returning.
 * @param {boolean} reverse - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} The first (or n skipped) tile with the matching index.
 */ var FindByIndex = function(findIndex, skip, reverse, layer) {
                if (skip === undefined) skip = 0;
                if (reverse === undefined) reverse = false;
                var count = 0;
                var tx;
                var ty;
                var tile;
                if (reverse) {
                    for(ty = layer.height - 1; ty >= 0; ty--)for(tx = layer.width - 1; tx >= 0; tx--){
                        tile = layer.data[ty][tx];
                        if (tile && tile.index === findIndex) {
                            if (count === skip) return tile;
                            else count += 1;
                        }
                    }
                } else {
                    for(ty = 0; ty < layer.height; ty++)for(tx = 0; tx < layer.width; tx++){
                        tile = layer.data[ty][tx];
                        if (tile && tile.index === findIndex) {
                            if (count === skip) return tile;
                            else count += 1;
                        }
                    }
                }
                return null;
            };
            module1.exports = FindByIndex;
        /***/ },
        /* 1419 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * @callback FindTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 *
 * @return {boolean} Return `true` if the callback should run, otherwise `false`.
 */ /**
 * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
 * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
 * true. Similar to Array.prototype.find in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.FindTile
 * @since 3.0.0
 *
 * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?Phaser.Tilemaps.Tile} A Tile that matches the search, or null if no Tile found
 */ var FindTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                return tiles.find(callback, context) || null;
            };
            module1.exports = FindTile;
        /***/ },
        /* 1420 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * @callback EachTileCallback
 *
 * @param {Phaser.Tilemaps.Tile} value - The Tile.
 * @param {number} index - The index of the tile.
 * @param {Phaser.Tilemaps.Tile[]} array - An array of Tile objects.
 */ /**
 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
 * callback. Similar to Array.prototype.forEach in vanilla JS.
 *
 * @function Phaser.Tilemaps.Components.ForEachTile
 * @since 3.0.0
 *
 * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
 * @param {object} context - The context under which the callback should be run.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area to filter.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var ForEachTile = function(callback, context, tileX, tileY, width, height, filteringOptions, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
                tiles.forEach(callback, context);
            };
            module1.exports = ForEachTile;
        /***/ },
        /* 1421 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var CullTiles = __webpack_require__(540);
            var HexagonalCullTiles = __webpack_require__(541);
            var IsometricCullTiles = __webpack_require__(543);
            var NOOP = __webpack_require__(1);
            var StaggeredCullTiles = __webpack_require__(544);
            /**
 * Gets the correct function to use to cull tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetCullTilesFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to cull tiles for the given map type.
 */ var GetCullTilesFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return CullTiles;
                else if (orientation === CONST.HEXAGONAL) return HexagonalCullTiles;
                else if (orientation === CONST.STAGGERED) return StaggeredCullTiles;
                else if (orientation === CONST.ISOMETRIC) return IsometricCullTiles;
                else return NOOP;
            };
            module1.exports = GetCullTilesFunction;
        /***/ },
        /* 1422 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTileAt = __webpack_require__(156);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Gets a tile at the given world coordinates from the given layer.
 *
 * @function Phaser.Tilemaps.Components.GetTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - X position to get the tile from (given in pixels)
 * @param {number} worldY - Y position to get the tile from (given in pixels)
 * @param {boolean} nonNull - If true, function won't return null for empty tiles, but a Tile object with an index of -1.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
 */ var GetTileAtWorldXY = function(worldX, worldY, nonNull, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                return GetTileAt(point.x, point.y, nonNull, layer);
            };
            module1.exports = GetTileAtWorldXY;
        /***/ },
        /* 1423 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Geom = __webpack_require__(477);
            var GetTilesWithin = __webpack_require__(26);
            var Intersects = __webpack_require__(478);
            var NOOP = __webpack_require__(1);
            var Vector2 = __webpack_require__(3);
            var TriangleToRectangle = function(triangle, rect) {
                return Intersects.RectangleToTriangle(rect, triangle);
            };
            var point = new Vector2();
            var pointStart = new Vector2();
            var pointEnd = new Vector2();
            /**
 * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
 * Line, Rectangle or Triangle. The shape should be in world coordinates.
 *
 * @function Phaser.Tilemaps.Components.GetTilesWithinShape
 * @since 3.0.0
 *
 * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
 * @param {Phaser.Types.Tilemaps.FilteringOptions} filteringOptions - Optional filters to apply when getting the tiles.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
 */ var GetTilesWithinShape = function(shape, filteringOptions, camera, layer) {
                if (shape === undefined) return [];
                // intersectTest is a function with parameters: shape, rect
                var intersectTest = NOOP;
                if (shape instanceof Geom.Circle) intersectTest = Intersects.CircleToRectangle;
                else if (shape instanceof Geom.Rectangle) intersectTest = Intersects.RectangleToRectangle;
                else if (shape instanceof Geom.Triangle) intersectTest = TriangleToRectangle;
                else if (shape instanceof Geom.Line) intersectTest = Intersects.LineToRectangle;
                // Top left corner of the shapes's bounding box, rounded down to include partial tiles
                layer.tilemapLayer.worldToTileXY(shape.left, shape.top, true, pointStart, camera);
                var xStart = pointStart.x;
                var yStart = pointStart.y;
                // Bottom right corner of the shapes's bounding box, rounded up to include partial tiles
                layer.tilemapLayer.worldToTileXY(shape.right, shape.bottom, true, pointEnd, camera);
                var xEnd = Math.ceil(pointEnd.x);
                var yEnd = Math.ceil(pointEnd.y);
                // Tiles within bounding rectangle of shape. Bounds are forced to be at least 1 x 1 tile in size
                // to grab tiles for shapes that don't have a height or width (e.g. a horizontal line).
                var width = Math.max(xEnd - xStart, 1);
                var height = Math.max(yEnd - yStart, 1);
                var tiles = GetTilesWithin(xStart, yStart, width, height, filteringOptions, layer);
                var tileWidth = layer.tileWidth;
                var tileHeight = layer.tileHeight;
                if (layer.tilemapLayer) {
                    tileWidth *= layer.tilemapLayer.scaleX;
                    tileHeight *= layer.tilemapLayer.scaleY;
                }
                var results = [];
                var tileRect = new Geom.Rectangle(0, 0, tileWidth, tileHeight);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    layer.tilemapLayer.tileToWorldXY(tile.x, tile.y, point, camera);
                    tileRect.x = point.x;
                    tileRect.y = point.y;
                    if (intersectTest(shape, tileRect)) results.push(tile);
                }
                return results;
            };
            module1.exports = GetTilesWithinShape;
        /***/ },
        /* 1424 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var NOOP = __webpack_require__(1);
            var TileToWorldX = __webpack_require__(249);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldX;
                else return NOOP;
            };
            module1.exports = GetTileToWorldXFunction;
        /***/ },
        /* 1425 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalTileToWorldXY = __webpack_require__(546);
            var IsometricTileToWorldXY = __webpack_require__(547);
            var NOOP = __webpack_require__(1);
            var StaggeredTileToWorldXY = __webpack_require__(548);
            var TileToWorldXY = __webpack_require__(549);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldXYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldXY;
                else if (orientation === CONST.ISOMETRIC) return IsometricTileToWorldXY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalTileToWorldXY;
                else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldXY;
                else return NOOP;
            };
            module1.exports = GetTileToWorldXYFunction;
        /***/ },
        /* 1426 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalTileToWorldY = __webpack_require__(550);
            var NOOP = __webpack_require__(1);
            var StaggeredTileToWorldY = __webpack_require__(551);
            var TileToWorldY = __webpack_require__(250);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetTileToWorldYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetTileToWorldYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return TileToWorldY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalTileToWorldY;
                else if (orientation === CONST.STAGGERED) return StaggeredTileToWorldY;
                else return NOOP;
            };
            module1.exports = GetTileToWorldYFunction;
        /***/ },
        /* 1427 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var NOOP = __webpack_require__(1);
            var WorldToTileX = __webpack_require__(251);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileX;
                else return NOOP;
            };
            module1.exports = GetWorldToTileXFunction;
        /***/ },
        /* 1428 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalWorldToTileXY = __webpack_require__(552);
            var IsometricWorldToTileXY = __webpack_require__(553);
            var NOOP = __webpack_require__(1);
            var StaggeredWorldToTileXY = __webpack_require__(554);
            var WorldToTileXY = __webpack_require__(555);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileXYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileXYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileXY;
                else if (orientation === CONST.ISOMETRIC) return IsometricWorldToTileXY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalWorldToTileXY;
                else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileXY;
                else return NOOP;
            };
            module1.exports = GetWorldToTileXYFunction;
        /***/ },
        /* 1429 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(29);
            var HexagonalWorldToTileY = __webpack_require__(556);
            var NOOP = __webpack_require__(1);
            var StaggeredWorldToTileY = __webpack_require__(557);
            var WorldToTileY = __webpack_require__(252);
            /**
 * Gets the correct function to use to translate tiles, based on the map orientation.
 *
 * @function Phaser.Tilemaps.Components.GetWorldToTileYFunction
 * @since 3.50.0
 *
 * @param {number} orientation - The Tilemap orientation constant.
 *
 * @return {function} The function to use to translate tiles for the given map type.
 */ var GetWorldToTileYFunction = function(orientation) {
                if (orientation === CONST.ORTHOGONAL) return WorldToTileY;
                else if (orientation === CONST.HEXAGONAL) return HexagonalWorldToTileY;
                else if (orientation === CONST.STAGGERED) return StaggeredWorldToTileY;
                else return NOOP;
            };
            module1.exports = GetWorldToTileYFunction;
        /***/ },
        /* 1430 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var HasTileAt = __webpack_require__(558);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
 * false if there is no tile or if the tile at that location has an index of -1.
 *
 * @function Phaser.Tilemaps.Components.HasTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The X coordinate of the world position.
 * @param {number} worldY - The Y coordinate of the world position.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when factoring in which tiles to return.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
 */ var HasTileAtWorldXY = function(worldX, worldY, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera);
                var tileX = point.x;
                var tileY = point.y;
                return HasTileAt(tileX, tileY, layer);
            };
            module1.exports = HasTileAtWorldXY;
        /***/ },
        /* 1431 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var PutTileAt = __webpack_require__(253);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
 * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
 * specified location. If you pass in an index, only the index at the specified location will be
 * changed. Collision information will be recalculated at the specified location.
 *
 * @function Phaser.Tilemaps.Components.PutTileAtWorldXY
 * @since 3.0.0
 *
 * @param {(number|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
 */ var PutTileAtWorldXY = function(tile, worldX, worldY, recalculateFaces, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                return PutTileAt(tile, point.x, point.y, recalculateFaces, layer);
            };
            module1.exports = PutTileAtWorldXY;
        /***/ },
        /* 1432 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CalculateFacesWithin = __webpack_require__(61);
            var PutTileAt = __webpack_require__(253);
            /**
 * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
 * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
 * all attributes will be copied over to the specified location. If you pass in an index, only the
 * index at the specified location will be changed. Collision information will be recalculated
 * within the region tiles were changed.
 *
 * @function Phaser.Tilemaps.Components.PutTilesAt
 * @since 3.0.0
 *
 * @param {(number[]|number[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles or tile indexes to place.
 * @param {number} tileX - The x coordinate, in tiles, not pixels.
 * @param {number} tileY - The y coordinate, in tiles, not pixels.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var PutTilesAt = function(tilesArray, tileX, tileY, recalculateFaces, layer) {
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!Array.isArray(tilesArray)) return null;
                // Force the input array to be a 2D array
                if (!Array.isArray(tilesArray[0])) tilesArray = [
                    tilesArray
                ];
                var height = tilesArray.length;
                var width = tilesArray[0].length;
                for(var ty = 0; ty < height; ty++)for(var tx = 0; tx < width; tx++){
                    var tile = tilesArray[ty][tx];
                    PutTileAt(tile, tileX + tx, tileY + ty, false, layer);
                }
                if (recalculateFaces) // Recalculate the faces within the destination area and neighboring tiles
                CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
            };
            module1.exports = PutTilesAt;
        /***/ },
        /* 1433 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var GetRandom = __webpack_require__(207);
            /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
 * those will be used for randomly assigning new tile indexes. If an array is not provided, the
 * indexes found within the region (excluding -1) will be used for randomly assigning new tile
 * indexes. This method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.Randomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {number[]} indexes - An array of indexes to randomly draw from during randomization.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Randomize = function(tileX, tileY, width, height, indexes, layer) {
                var i;
                var tiles = GetTilesWithin(tileX, tileY, width, height, {}, layer);
                // If no indices are given, then find all the unique indexes within the specified region
                if (!indexes) {
                    indexes = [];
                    for(i = 0; i < tiles.length; i++)if (indexes.indexOf(tiles[i].index) === -1) indexes.push(tiles[i].index);
                }
                for(i = 0; i < tiles.length; i++)tiles[i].index = GetRandom(indexes);
            };
            module1.exports = Randomize;
        /***/ },
        /* 1434 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var RemoveTileAt = __webpack_require__(559);
            var Vector2 = __webpack_require__(3);
            var point = new Vector2();
            /**
 * Removes the tile at the given world coordinates in the specified layer and updates the layer's
 * collision information.
 *
 * @function Phaser.Tilemaps.Components.RemoveTileAtWorldXY
 * @since 3.0.0
 *
 * @param {number} worldX - The x coordinate, in pixels.
 * @param {number} worldY - The y coordinate, in pixels.
 * @param {boolean} replaceWithNull - If true, this will replace the tile at the specified location with null instead of a Tile with an index of -1.
 * @param {boolean} recalculateFaces - `true` if the faces data should be recalculated.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to use when calculating the tile index from the world values.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 *
 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
 */ var RemoveTileAtWorldXY = function(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer) {
                layer.tilemapLayer.worldToTileXY(worldX, worldY, true, point, camera, layer);
                return RemoveTileAt(point.x, point.y, replaceWithNull, recalculateFaces, layer);
            };
            module1.exports = RemoveTileAtWorldXY;
        /***/ },
        /* 1435 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var Color = __webpack_require__(391);
            var defaultTileColor = new Color(105, 210, 231, 150);
            var defaultCollidingTileColor = new Color(243, 134, 48, 200);
            var defaultFaceColor = new Color(40, 39, 37, 150);
            /**
 * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
 * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
 * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
 * wherever you want on the screen.
 *
 * @function Phaser.Tilemaps.Components.RenderDebug
 * @since 3.0.0
 *
 * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
 * @param {Phaser.Types.Tilemaps.DebugStyleOptions} styleConfig - An object specifying the colors to use for the debug drawing.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var RenderDebug = function(graphics, styleConfig, layer) {
                if (styleConfig === undefined) styleConfig = {};
                // Default colors without needlessly creating Color objects
                var tileColor = styleConfig.tileColor !== undefined ? styleConfig.tileColor : defaultTileColor;
                var collidingTileColor = styleConfig.collidingTileColor !== undefined ? styleConfig.collidingTileColor : defaultCollidingTileColor;
                var faceColor = styleConfig.faceColor !== undefined ? styleConfig.faceColor : defaultFaceColor;
                var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
                graphics.translateCanvas(layer.tilemapLayer.x, layer.tilemapLayer.y);
                graphics.scaleCanvas(layer.tilemapLayer.scaleX, layer.tilemapLayer.scaleY);
                for(var i = 0; i < tiles.length; i++){
                    var tile = tiles[i];
                    var tw = tile.width;
                    var th = tile.height;
                    var x = tile.pixelX;
                    var y = tile.pixelY;
                    var color = tile.collides ? collidingTileColor : tileColor;
                    if (color !== null) {
                        graphics.fillStyle(color.color, color.alpha / 255);
                        graphics.fillRect(x, y, tw, th);
                    }
                    // Inset the face line to prevent neighboring tile's lines from overlapping
                    x += 1;
                    y += 1;
                    tw -= 2;
                    th -= 2;
                    if (faceColor !== null) {
                        graphics.lineStyle(1, faceColor.color, faceColor.alpha / 255);
                        if (tile.faceTop) graphics.lineBetween(x, y, x + tw, y);
                        if (tile.faceRight) graphics.lineBetween(x + tw, y, x + tw, y + th);
                        if (tile.faceBottom) graphics.lineBetween(x, y + th, x + tw, y + th);
                        if (tile.faceLeft) graphics.lineBetween(x, y, x, y + th);
                    }
                }
            };
            module1.exports = RenderDebug;
        /***/ },
        /* 1436 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(61);
            var SetLayerCollisionIndex = __webpack_require__(158);
            /**
 * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
 * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
 * collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollision
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollision = function(indexes, collides, recalculateFaces, layer, updateLayer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (updateLayer === undefined) updateLayer = true;
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                // Update the array of colliding indexes
                for(var i = 0; i < indexes.length; i++)SetLayerCollisionIndex(indexes[i], collides, layer);
                // Update the tiles
                if (updateLayer) {
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile && indexes.indexOf(tile.index) !== -1) SetTileCollision(tile, collides);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollision;
        /***/ },
        /* 1437 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(61);
            var SetLayerCollisionIndex = __webpack_require__(158);
            /**
 * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
 * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
 * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
 * enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionBetween
 * @since 3.0.0
 *
 * @param {number} start - The first index of the tile to be set for collision.
 * @param {number} stop - The last index of the tile to be set for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 * @param {boolean} [updateLayer=true] - If true, updates the current tiles on the layer. Set to false if no tiles have been placed for significant performance boost.
 */ var SetCollisionBetween = function(start, stop, collides, recalculateFaces, layer, updateLayer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (updateLayer === undefined) updateLayer = true;
                if (start > stop) return;
                //  Update the array of colliding indexes
                for(var index = start; index <= stop; index++)SetLayerCollisionIndex(index, collides, layer);
                //  Update the tiles
                if (updateLayer) {
                    for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                        var tile = layer.data[ty][tx];
                        if (tile) {
                            if (tile.index >= start && tile.index <= stop) SetTileCollision(tile, collides);
                        }
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionBetween;
        /***/ },
        /* 1438 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(61);
            var SetLayerCollisionIndex = __webpack_require__(158);
            /**
 * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
 * the given array. The `collides` parameter controls if collision will be enabled (true) or
 * disabled (false). Tile indexes not currently in the layer are not affected.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByExclusion
 * @since 3.0.0
 *
 * @param {number[]} indexes - An array of the tile indexes to not be counted for collision.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByExclusion = function(indexes, collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                if (!Array.isArray(indexes)) indexes = [
                    indexes
                ];
                // Note: this only updates layer.collideIndexes for tile indexes found currently in the layer
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (tile && indexes.indexOf(tile.index) === -1) {
                        SetTileCollision(tile, collides);
                        SetLayerCollisionIndex(tile.index, collides, layer);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionByExclusion;
        /***/ },
        /* 1439 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(61);
            var HasValue = __webpack_require__(125);
            /**
 * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
 * that matches the given properties object, its collision flag will be set. The `collides`
 * parameter controls if collision will be enabled (true) or disabled (false). Passing in
 * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
 * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
 * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
 * "types" property that matches any of those values, its collision flag will be updated.
 *
 * @function Phaser.Tilemaps.Components.SetCollisionByProperty
 * @since 3.0.0
 *
 * @param {object} properties - An object with tile properties and corresponding values that should be checked.
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionByProperty = function(properties, collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (!tile) continue;
                    for(var property in properties){
                        if (!HasValue(tile.properties, property)) continue;
                        var values = properties[property];
                        if (!Array.isArray(values)) values = [
                            values
                        ];
                        for(var i = 0; i < values.length; i++)if (tile.properties[property] === values[i]) SetTileCollision(tile, collides);
                    }
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionByProperty;
        /***/ },
        /* 1440 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var SetTileCollision = __webpack_require__(72);
            var CalculateFacesWithin = __webpack_require__(61);
            /**
 * Sets collision on the tiles within a layer by checking each tile's collision group data
 * (typically defined in Tiled within the tileset collision editor). If any objects are found within
 * a tile's collision group, the tile's colliding information will be set. The `collides` parameter
 * controls if collision will be enabled (true) or disabled (false).
 *
 * @function Phaser.Tilemaps.Components.SetCollisionFromCollisionGroup
 * @since 3.0.0
 *
 * @param {boolean} collides - If true it will enable collision. If false it will clear collision.
 * @param {boolean} recalculateFaces - Whether or not to recalculate the tile faces after the update.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetCollisionFromCollisionGroup = function(collides, recalculateFaces, layer) {
                if (collides === undefined) collides = true;
                if (recalculateFaces === undefined) recalculateFaces = true;
                for(var ty = 0; ty < layer.height; ty++)for(var tx = 0; tx < layer.width; tx++){
                    var tile = layer.data[ty][tx];
                    if (!tile) continue;
                    var collisionGroup = tile.getCollisionGroup();
                    // It's possible in Tiled to have a collision group without any shapes, e.g. create a
                    // shape and then delete the shape.
                    if (collisionGroup && collisionGroup.objects && collisionGroup.objects.length > 0) SetTileCollision(tile, collides);
                }
                if (recalculateFaces) CalculateFacesWithin(0, 0, layer.width, layer.height, layer);
            };
            module1.exports = SetCollisionFromCollisionGroup;
        /***/ },
        /* 1441 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Sets a global collision callback for the given tile index within the layer. This will affect all
 * tiles on this layer that have the same index. If a callback is already set for the tile index it
 * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
 * at a specific location on the map then see setTileLocationCallback.
 *
 * @function Phaser.Tilemaps.Components.SetTileIndexCallback
 * @since 3.0.0
 *
 * @param {(number|array)} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileIndexCallback = function(indexes, callback, callbackContext, layer) {
                if (typeof indexes === 'number') layer.callbacks[indexes] = callback !== null ? {
                    callback: callback,
                    callbackContext: callbackContext
                } : undefined;
                else for(var i = 0, len = indexes.length; i < len; i++)layer.callbacks[indexes[i]] = callback !== null ? {
                    callback: callback,
                    callbackContext: callbackContext
                } : undefined;
            };
            module1.exports = SetTileIndexCallback;
        /***/ },
        /* 1442 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
 * If a callback is already set for the tile index it will be replaced. Set the callback to null to
 * remove it.
 *
 * @function Phaser.Tilemaps.Components.SetTileLocationCallback
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {function} callback - The callback that will be invoked when the tile is collided with.
 * @param {object} callbackContext - The context under which the callback is called.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SetTileLocationCallback = function(tileX, tileY, width, height, callback, callbackContext, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)tiles[i].setCollisionCallback(callback, callbackContext);
            };
            module1.exports = SetTileLocationCallback;
        /***/ },
        /* 1443 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            var ShuffleArray = __webpack_require__(129);
            /**
 * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
 * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
 * appear to have changed! This method only modifies tile indexes and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.Shuffle
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var Shuffle = function(tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                var indexes = tiles.map(function(tile) {
                    return tile.index;
                });
                ShuffleArray(indexes);
                for(var i = 0; i < tiles.length; i++)tiles[i].index = indexes[i];
            };
            module1.exports = Shuffle;
        /***/ },
        /* 1444 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
 * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
 * information.
 *
 * @function Phaser.Tilemaps.Components.SwapByIndex
 * @since 3.0.0
 *
 * @param {number} tileA - First tile index.
 * @param {number} tileB - Second tile index.
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var SwapByIndex = function(indexA, indexB, tileX, tileY, width, height, layer) {
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                for(var i = 0; i < tiles.length; i++)if (tiles[i]) {
                    if (tiles[i].index === indexA) tiles[i].index = indexB;
                    else if (tiles[i].index === indexB) tiles[i].index = indexA;
                }
            };
            module1.exports = SwapByIndex;
        /***/ },
        /* 1445 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetTilesWithin = __webpack_require__(26);
            /**
 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
 * specified layer. Each tile will receive a new index. New indexes are drawn from the given
 * weightedIndexes array. An example weighted array:
 *
 * [
 *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
 *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
 *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
 *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
 * ]
 *
 * The probability of any index being choose is (the index's weight) / (sum of all weights). This
 * method only modifies tile indexes and does not change collision information.
 *
 * @function Phaser.Tilemaps.Components.WeightedRandomize
 * @since 3.0.0
 *
 * @param {number} tileX - The left most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} tileY - The top most tile index (in tile coordinates) to use as the origin of the area.
 * @param {number} width - How many tiles wide from the `tileX` index the area will be.
 * @param {number} height - How many tiles tall from the `tileY` index the area will be.
 * @param {object[]} weightedIndexes - An array of objects to randomly draw from during
 * randomization. They should be in the form: { index: 0, weight: 4 } or
 * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
 */ var WeightedRandomize = function(tileX, tileY, width, height, weightedIndexes, layer) {
                if (!weightedIndexes) return;
                var i;
                var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
                var weightTotal = 0;
                for(i = 0; i < weightedIndexes.length; i++)weightTotal += weightedIndexes[i].weight;
                if (weightTotal <= 0) return;
                for(i = 0; i < tiles.length; i++){
                    var rand = Math.random() * weightTotal;
                    var sum = 0;
                    var randomIndex = -1;
                    for(var j = 0; j < weightedIndexes.length; j++){
                        sum += weightedIndexes[j].weight;
                        if (rand <= sum) {
                            var chosen = weightedIndexes[j].index;
                            randomIndex = Array.isArray(chosen) ? chosen[Math.floor(Math.random() * chosen.length)] : chosen;
                            break;
                        }
                    }
                    tiles[i].index = randomIndex;
                }
            };
            module1.exports = WeightedRandomize;
        /***/ },
        /* 1446 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers
 */ module1.exports = {
                FromOrientationString: __webpack_require__(254),
                Parse: __webpack_require__(560),
                Parse2DArray: __webpack_require__(255),
                ParseCSV: __webpack_require__(561),
                Impact: __webpack_require__(1447),
                Tiled: __webpack_require__(1448)
            };
        /***/ },
        /* 1447 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Impact
 */ module1.exports = {
                ParseTileLayers: __webpack_require__(574),
                ParseTilesets: __webpack_require__(575),
                ParseWeltmeister: __webpack_require__(573)
            };
        /***/ },
        /* 1448 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tilemaps.Parsers.Tiled
 */ module1.exports = {
                AssignTileProperties: __webpack_require__(563),
                Base64Decode: __webpack_require__(570),
                BuildTilesetIndex: __webpack_require__(564),
                CreateGroupLayer: __webpack_require__(159),
                ParseGID: __webpack_require__(257),
                ParseImageLayers: __webpack_require__(565),
                ParseJSONTiled: __webpack_require__(562),
                ParseObject: __webpack_require__(256),
                ParseObjectLayers: __webpack_require__(566),
                ParseTileLayers: __webpack_require__(569),
                ParseTilesets: __webpack_require__(571)
            };
        /***/ },
        /* 1449 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var renderWebGL = __webpack_require__(1);
            var renderCanvas = __webpack_require__(1);
            renderWebGL = __webpack_require__(1450);
            renderCanvas = __webpack_require__(1451);
            module1.exports = {
                renderWebGL: renderWebGL,
                renderCanvas: renderCanvas
            };
        /***/ },
        /* 1450 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Utils = __webpack_require__(12);
            /**
 * Renders this Game Object with the WebGL Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderWebGL
 * @since 3.0.0
 * @private
 *
 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 */ var TilemapLayerWebGLRenderer = function(renderer, src, camera) {
                var renderTiles = src.cull(camera);
                var tileCount = renderTiles.length;
                var alpha = camera.alpha * src.alpha;
                if (tileCount === 0 || alpha <= 0) return;
                var gidMap = src.gidMap;
                var pipeline = renderer.pipelines.set(src.pipeline, src);
                var getTint = Utils.getTintAppendFloatAlpha;
                var scrollFactorX = src.scrollFactorX;
                var scrollFactorY = src.scrollFactorY;
                var x = src.x;
                var y = src.y;
                var sx = src.scaleX;
                var sy = src.scaleY;
                renderer.pipelines.preBatch(src);
                for(var i = 0; i < tileCount; i++){
                    var tile = renderTiles[i];
                    var tileset = gidMap[tile.index];
                    if (!tileset) continue;
                    var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                    if (tileTexCoords === null) continue;
                    var texture = tileset.glTexture;
                    var textureUnit = pipeline.setTexture2D(texture, src);
                    var frameWidth = tileset.tileWidth;
                    var frameHeight = tileset.tileHeight;
                    var frameX = tileTexCoords.x;
                    var frameY = tileTexCoords.y;
                    var tw = tileset.tileWidth * 0.5;
                    var th = tileset.tileHeight * 0.5;
                    var tint = getTint(tile.tint, alpha * tile.alpha);
                    pipeline.batchTexture(src, texture, texture.width, texture.height, x + (tw + tile.pixelX) * sx, y + (th + tile.pixelY) * sy, tile.width, tile.height, sx, sy, tile.rotation, tile.flipX, tile.flipY, scrollFactorX, scrollFactorY, tw, th, frameX, frameY, frameWidth, frameHeight, tint, tint, tint, tint, false, 0, 0, camera, null, true, textureUnit);
                }
                renderer.pipelines.postBatch(src);
            };
            module1.exports = TilemapLayerWebGLRenderer;
        /***/ },
        /* 1451 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var TransformMatrix = __webpack_require__(25);
            var tempMatrix1 = new TransformMatrix();
            var tempMatrix2 = new TransformMatrix();
            var tempMatrix3 = new TransformMatrix();
            /**
 * Renders this Game Object with the Canvas Renderer to the given Camera.
 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
 * This method should not be called directly. It is a utility function of the Render module.
 *
 * @method Phaser.Tilemaps.TilemapLayer#renderCanvas
 * @since 3.50.0
 * @private
 *
 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
 * @param {Phaser.Tilemaps.TilemapLayer} src - The Game Object being rendered in this call.
 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
 */ var TilemapLayerCanvasRenderer = function(renderer, src, camera, parentMatrix) {
                var renderTiles = src.cull(camera);
                var tileCount = renderTiles.length;
                var alpha = camera.alpha * src.alpha;
                if (tileCount === 0 || alpha <= 0) return;
                var camMatrix = tempMatrix1;
                var layerMatrix = tempMatrix2;
                var calcMatrix = tempMatrix3;
                layerMatrix.applyITRS(src.x, src.y, src.rotation, src.scaleX, src.scaleY);
                camMatrix.copyFrom(camera.matrix);
                var ctx = renderer.currentContext;
                var gidMap = src.gidMap;
                ctx.save();
                if (parentMatrix) {
                    //  Multiply the camera by the parent matrix
                    camMatrix.multiplyWithOffset(parentMatrix, -camera.scrollX * src.scrollFactorX, -camera.scrollY * src.scrollFactorY);
                    //  Undo the camera scroll
                    layerMatrix.e = src.x;
                    layerMatrix.f = src.y;
                    //  Multiply by the Sprite matrix, store result in calcMatrix
                    camMatrix.multiply(layerMatrix, calcMatrix);
                    calcMatrix.copyToContext(ctx);
                } else {
                    layerMatrix.e -= camera.scrollX * src.scrollFactorX;
                    layerMatrix.f -= camera.scrollY * src.scrollFactorY;
                    layerMatrix.copyToContext(ctx);
                }
                if (!renderer.antialias || src.scaleX > 1 || src.scaleY > 1) ctx.imageSmoothingEnabled = false;
                for(var i = 0; i < tileCount; i++){
                    var tile = renderTiles[i];
                    var tileset = gidMap[tile.index];
                    if (!tileset) continue;
                    var image = tileset.image.getSourceImage();
                    var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
                    if (tileTexCoords === null) continue;
                    var tileWidth = tileset.tileWidth;
                    var tileHeight = tileset.tileHeight;
                    var halfWidth = tileWidth * 0.5;
                    var halfHeight = tileHeight * 0.5;
                    ctx.save();
                    ctx.translate(tile.pixelX + halfWidth, tile.pixelY + halfHeight);
                    if (tile.rotation !== 0) ctx.rotate(tile.rotation);
                    if (tile.flipX || tile.flipY) ctx.scale(tile.flipX ? -1 : 1, tile.flipY ? -1 : 1);
                    ctx.globalAlpha = alpha * tile.alpha;
                    ctx.drawImage(image, tileTexCoords.x, tileTexCoords.y, tileWidth, tileHeight, -halfWidth, -halfHeight, tileWidth, tileHeight);
                    ctx.restore();
                }
                ctx.restore();
            };
            module1.exports = TilemapLayerCanvasRenderer;
        /***/ },
        /* 1452 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectCreator = __webpack_require__(16);
            var ParseToTilemap = __webpack_require__(258);
            /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectCreator#tilemap
 * @since 3.0.0
 * 
 * @param {Phaser.Types.Tilemaps.TilemapConfig} [config] - The config options for the Tilemap.
 * 
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectCreator.register('tilemap', function(config) {
                // Defaults are applied in ParseToTilemap
                var c = config !== undefined ? config : {};
                return ParseToTilemap(this.scene, c.key, c.tileWidth, c.tileHeight, c.width, c.height, c.data, c.insertNull);
            });
        /***/ },
        /* 1453 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GameObjectFactory = __webpack_require__(5);
            var ParseToTilemap = __webpack_require__(258);
            /**
 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
 *
 * @method Phaser.GameObjects.GameObjectFactory#tilemap
 * @since 3.0.0
 *
 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
 * @param {number} [tileWidth=32] - The width of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [tileHeight=32] - The height of a tile in pixels. Pass in `null` to leave as the
 * default.
 * @param {number} [width=10] - The width of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number} [height=10] - The height of the map in tiles. Pass in `null` to leave as the
 * default.
 * @param {number[][]} [data] - Instead of loading from the cache, you can also load directly from
 * a 2D array of tile indexes. Pass in `null` for no data.
 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
 * the tile data doesn't need to change then setting this value to `true` will help with memory
 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
 * the default value set.
 * 
 * @return {Phaser.Tilemaps.Tilemap}
 */ GameObjectFactory.register('tilemap', function(key, tileWidth, tileHeight, width, height, data, insertNull) {
                // Allow users to specify null to indicate that they want the default value, since null is
                // shorter & more legible than undefined. Convert null to undefined to allow ParseToTilemap
                // defaults to take effect.
                if (key === null) key = undefined;
                if (tileWidth === null) tileWidth = undefined;
                if (tileHeight === null) tileHeight = undefined;
                if (width === null) width = undefined;
                if (height === null) height = undefined;
                return ParseToTilemap(this.scene, key, tileWidth, tileHeight, width, height, data, insertNull);
            });
        //  When registering a factory function 'this' refers to the GameObjectFactory context.
        //
        //  There are several properties available to use:
        //
        //  this.scene - a reference to the Scene that owns the GameObjectFactory
        //  this.displayList - a reference to the Display List the Scene owns
        //  this.updateList - a reference to the Update List the Scene owns
        /***/ },
        /* 1454 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Time
 */ module1.exports = {
                Clock: __webpack_require__(1455),
                TimerEvent: __webpack_require__(578)
            };
        /***/ },
        /* 1455 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            var TimerEvent = __webpack_require__(578);
            var Remove = __webpack_require__(89);
            /**
 * @classdesc
 * The Clock is a Scene plugin which creates and updates Timer Events for its Scene.
 *
 * @class Clock
 * @memberof Phaser.Time
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Clock.
 */ var Clock = new Class({
                initialize: function Clock(scene) {
                    /**
         * The Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Scene Systems object of the Scene which owns this Clock.
         *
         * @name Phaser.Time.Clock#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The current time of the Clock, in milliseconds.
         *
         * If accessed externally, this is equivalent to the `time` parameter normally passed to a Scene's `update` method.
         *
         * @name Phaser.Time.Clock#now
         * @type {number}
         * @since 3.0.0
         */ this.now = 0;
                    /**
         * The scale of the Clock's time delta.
         *
         * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Clock and anything which uses it, such as its Timer Events. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing the Clock.
         *
         * @name Phaser.Time.Clock#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * Whether the Clock is paused (`true`) or active (`false`).
         *
         * When paused, the Clock will not update any of its Timer Events, thus freezing time.
         *
         * @name Phaser.Time.Clock#paused
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.paused = false;
                    /**
         * An array of all Timer Events whose delays haven't expired - these are actively updating Timer Events.
         *
         * @name Phaser.Time.Clock#_active
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._active = [];
                    /**
         * An array of all Timer Events which will be added to the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingInsertion
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingInsertion = [];
                    /**
         * An array of all Timer Events which will be removed from the Clock at the start of the next frame.
         *
         * @name Phaser.Time.Clock#_pendingRemoval
         * @type {Phaser.Time.TimerEvent[]}
         * @private
         * @default []
         * @since 3.0.0
         */ this._pendingRemoval = [];
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    //  Sync with the TimeStep
                    this.now = this.systems.game.loop.time;
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Time.Clock#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * Creates a Timer Event and adds it to the Clock at the start of the frame.
     *
     * You can also pass in an existing Timer Event, which will be reset and added to this Clock.
     *
     * Note that if the Timer Event is being used by _another_ Clock (in another Scene) it will still
     * be updated by that Clock as well, so be careful when using this feature.
     *
     * @method Phaser.Time.Clock#addEvent
     * @since 3.0.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Types.Time.TimerEventConfig)} config - The configuration for the Timer Event, or an existing Timer Event object.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created, or passed in.
     */ addEvent: function(config) {
                    var event;
                    if (config instanceof TimerEvent) {
                        event = config;
                        this.removeEvent(event);
                        event.elapsed = event.startAt;
                        event.hasDispatched = false;
                        event.repeatCount = event.repeat === -1 || event.loop ? 999999999999 : event.repeat;
                    } else event = new TimerEvent(config);
                    this._pendingInsertion.push(event);
                    return event;
                },
                /**
     * Creates a Timer Event and adds it to the Clock at the start of the frame.
     *
     * This is a shortcut for {@link #addEvent} which can be shorter and is compatible with the syntax of the GreenSock Animation Platform (GSAP).
     *
     * @method Phaser.Time.Clock#delayedCall
     * @since 3.0.0
     *
     * @param {number} delay - The delay of the function call, in milliseconds.
     * @param {function} callback - The function to call after the delay expires.
     * @param {Array.<*>} [args] - The arguments to call the function with.
     * @param {*} [callbackScope] - The scope (`this` object) to call the function with.
     *
     * @return {Phaser.Time.TimerEvent} The Timer Event which was created.
     */ delayedCall: function(delay, callback, args, callbackScope) {
                    return this.addEvent({
                        delay: delay,
                        callback: callback,
                        args: args,
                        callbackScope: callbackScope
                    });
                },
                /**
     * Clears and recreates the array of pending Timer Events.
     *
     * @method Phaser.Time.Clock#clearPendingEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ clearPendingEvents: function() {
                    this._pendingInsertion = [];
                    return this;
                },
                /**
     * Removes the given Timer Event, or an array of Timer Events, from this Clock.
     *
     * The events are removed from all internal lists (active, pending and removal),
     * freeing the event up to be re-used.
     *
     * @method Phaser.Time.Clock#removeEvent
     * @since 3.50.0
     *
     * @param {(Phaser.Time.TimerEvent | Phaser.Time.TimerEvent[])} events - The Timer Event, or an array of Timer Events, to remove from this Clock.
     *
     * @return {this} - This Clock instance.
     */ removeEvent: function(events) {
                    if (!Array.isArray(events)) events = [
                        events
                    ];
                    for(var i = 0; i < events.length; i++){
                        var event = events[i];
                        Remove(this._pendingRemoval, event);
                        Remove(this._pendingInsertion, event);
                        Remove(this._active, event);
                    }
                    return this;
                },
                /**
     * Schedules all active Timer Events for removal at the start of the frame.
     *
     * @method Phaser.Time.Clock#removeAllEvents
     * @since 3.0.0
     *
     * @return {this} - This Clock instance.
     */ removeAllEvents: function() {
                    this._pendingRemoval = this._pendingRemoval.concat(this._active);
                    return this;
                },
                /**
     * Updates the arrays of active and pending Timer Events. Called at the start of the frame.
     *
     * @method Phaser.Time.Clock#preUpdate
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ preUpdate: function() {
                    var toRemove = this._pendingRemoval.length;
                    var toInsert = this._pendingInsertion.length;
                    if (toRemove === 0 && toInsert === 0) //  Quick bail
                    return;
                    var i;
                    var event;
                    //  Delete old events
                    for(i = 0; i < toRemove; i++){
                        event = this._pendingRemoval[i];
                        var index = this._active.indexOf(event);
                        if (index > -1) this._active.splice(index, 1);
                        //  Pool them?
                        event.destroy();
                    }
                    for(i = 0; i < toInsert; i++){
                        event = this._pendingInsertion[i];
                        this._active.push(event);
                    }
                    //  Clear the lists
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                },
                /**
     * Updates the Clock's internal time and all of its Timer Events.
     *
     * @method Phaser.Time.Clock#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time, delta) {
                    this.now = time;
                    if (this.paused) return;
                    delta *= this.timeScale;
                    for(var i = 0; i < this._active.length; i++){
                        var event = this._active[i];
                        if (event.paused) continue;
                        //  Use delta time to increase elapsed.
                        //  Avoids needing to adjust for pause / resume.
                        //  Automatically smoothed by TimeStep class.
                        //  In testing accurate to +- 1ms!
                        event.elapsed += delta * event.timeScale;
                        if (event.elapsed >= event.delay) {
                            var remainder = event.elapsed - event.delay;
                            //  Limit it, in case it's checked in the callback
                            event.elapsed = event.delay;
                            //  Process the event
                            if (!event.hasDispatched && event.callback) {
                                event.hasDispatched = true;
                                event.callback.apply(event.callbackScope, event.args);
                            }
                            if (event.repeatCount > 0) {
                                event.repeatCount--;
                                event.elapsed = remainder;
                                event.hasDispatched = false;
                            } else this._pendingRemoval.push(event);
                        }
                    }
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Time.Clock#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var i;
                    for(i = 0; i < this._pendingInsertion.length; i++)this._pendingInsertion[i].destroy();
                    for(i = 0; i < this._active.length; i++)this._active[i].destroy();
                    for(i = 0; i < this._pendingRemoval.length; i++)this._pendingRemoval[i].destroy();
                    this._active.length = 0;
                    this._pendingRemoval.length = 0;
                    this._pendingInsertion.length = 0;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Time.Clock#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('Clock', Clock, 'time');
            module1.exports = Clock;
        /***/ },
        /* 1456 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var CONST = __webpack_require__(97);
            var Extend = __webpack_require__(17);
            /**
 * @namespace Phaser.Tweens
 */ var Tweens = {
                Builders: __webpack_require__(1457),
                Events: __webpack_require__(263),
                TweenManager: __webpack_require__(1473),
                Tween: __webpack_require__(262),
                TweenData: __webpack_require__(264),
                Timeline: __webpack_require__(584)
            };
            //   Merge in the consts
            Tweens = Extend(false, Tweens, CONST);
            module1.exports = Tweens;
        /***/ },
        /* 1457 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Tweens.Builders
 */ module1.exports = {
                GetBoolean: __webpack_require__(96),
                GetEaseFunction: __webpack_require__(80),
                GetNewValue: __webpack_require__(160),
                GetProps: __webpack_require__(579),
                GetTargets: __webpack_require__(259),
                GetTweens: __webpack_require__(580),
                GetValueOp: __webpack_require__(260),
                NumberTweenBuilder: __webpack_require__(581),
                StaggerBuilder: __webpack_require__(582),
                TimelineBuilder: __webpack_require__(583),
                TweenBuilder: __webpack_require__(161)
            };
        /***/ },
        /* 1458 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  RESERVED properties that a Tween config object uses
            //  completeDelay: The time the tween will wait before the onComplete event is dispatched once it has completed
            //  delay: The time the tween will wait before it first starts
            //  duration: The duration of the tween
            //  ease: The ease function used by the tween
            //  easeParams: The parameters to go with the ease function (if any)
            //  flipX: flip X the GameObject on tween end
            //  flipY: flip Y the GameObject on tween end//  hold: The time the tween will pause before running a yoyo
            //  hold: The time the tween will pause before running a yoyo
            //  loop: The time the tween will pause before starting either a yoyo or returning to the start for a repeat
            //  loopDelay:
            //  offset: Used when the Tween is part of a Timeline
            //  paused: Does the tween start in a paused state, or playing?
            //  props: The properties being tweened by the tween
            //  repeat: The number of times the tween will repeat itself (a value of 1 means the tween will play twice, as it repeated once)
            //  repeatDelay: The time the tween will pause for before starting a repeat. The tween holds in the start state.
            //  targets: The targets the tween is updating.
            //  useFrames: Use frames or milliseconds?
            //  yoyo: boolean - Does the tween reverse itself (yoyo) when it reaches the end?
            module1.exports = [
                'callbackScope',
                'completeDelay',
                'delay',
                'duration',
                'ease',
                'easeParams',
                'flipX',
                'flipY',
                'hold',
                'loop',
                'loopDelay',
                'offset',
                'onActive',
                'onActiveParams',
                'onActiveScope',
                'onComplete',
                'onCompleteParams',
                'onCompleteScope',
                'onLoop',
                'onLoopParams',
                'onLoopScope',
                'onRepeat',
                'onRepeatParams',
                'onRepeatScope',
                'onStart',
                'onStartParams',
                'onStartScope',
                'onStop',
                'onStopParams',
                'onStopScope',
                'onUpdate',
                'onUpdateParams',
                'onUpdateScope',
                'onYoyo',
                'onYoyoParams',
                'onYoyoScope',
                'paused',
                'props',
                'repeat',
                'repeatDelay',
                'targets',
                'useFrames',
                'yoyo'
            ];
        /***/ },
        /* 1459 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Complete Event.
 * 
 * This event is dispatched by a Tween Timeline when it completes playback.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('complete', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_COMPLETE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'complete';
        /***/ },
        /* 1460 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Loop Event.
 * 
 * This event is dispatched by a Tween Timeline every time it loops.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     loop: 4,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('loop', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_LOOP
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'loop';
        /***/ },
        /* 1461 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Pause Event.
 * 
 * This event is dispatched by a Tween Timeline when it is paused.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('pause', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('pause', listener);
 * // At some point later ...
 * timeline.pause();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_PAUSE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'pause';
        /***/ },
        /* 1462 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Resume Event.
 * 
 * This event is dispatched by a Tween Timeline when it is resumed from a paused state.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('resume', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('resume', listener);
 * // At some point later ...
 * timeline.resume();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_RESUME
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'resume';
        /***/ },
        /* 1463 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Start Event.
 * 
 * This event is dispatched by a Tween Timeline when it starts.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('start', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('start', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_START
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'start';
        /***/ },
        /* 1464 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Timeline Update Event.
 * 
 * This event is dispatched by a Tween Timeline every time it updates, which can happen a lot of times per second,
 * so be careful about listening to this event unless you absolutely require it.
 * 
 * Listen to it from a Timeline instance using `Timeline.on('update', listener)`, i.e.:
 * 
 * ```javascript
 * var timeline = this.tweens.timeline({
 *     targets: image,
 *     ease: 'Power1',
 *     duration: 3000,
 *     tweens: [ { x: 600 }, { y: 500 }, { x: 100 }, { y: 100 } ]
 * });
 * timeline.on('update', listener);
 * timeline.play();
 * ```
 *
 * @event Phaser.Tweens.Events#TIMELINE_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Tweens.Timeline} timeline - A reference to the Timeline instance that emitted the event.
 */ module1.exports = 'update';
        /***/ },
        /* 1465 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Active Event.
 * 
 * This event is dispatched by a Tween when it becomes active within the Tween Manager.
 * 
 * An 'active' Tween is one that is now progressing, although it may not yet be updating
 * any target properties, due to settings such as `delay`. If you need an event for when
 * the Tween starts actually updating its first property, see `TWEEN_START`.
 * 
 * Listen to it from a Tween instance using `Tween.on('active', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('active', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_ACTIVE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = 'active';
        /***/ },
        /* 1466 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Complete Event.
 * 
 * This event is dispatched by a Tween when it completes playback entirely, factoring in repeats and loops.
 * 
 * If the Tween has been set to loop or repeat infinitely, this event will not be dispatched
 * unless the `Tween.stop` method is called.
 * 
 * If a Tween has a `completeDelay` set, this event will fire after that delay expires.
 * 
 * Listen to it from a Tween instance using `Tween.on('complete', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('complete', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_COMPLETE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = 'complete';
        /***/ },
        /* 1467 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Loop Event.
 * 
 * This event is dispatched by a Tween when it loops.
 * 
 * This event will only be dispatched if the Tween has a loop count set.
 * 
 * If a Tween has a `loopDelay` set, this event will fire after that delay expires.
 * 
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 * 
 * Listen to it from a Tween instance using `Tween.on('loop', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     loop: 6
 * });
 * tween.on('loop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_LOOP
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = 'loop';
        /***/ },
        /* 1468 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Repeat Event.
 * 
 * This event is dispatched by a Tween when one of the properties it is tweening repeats.
 * 
 * This event will only be dispatched if the Tween has a property with a repeat count set.
 * 
 * If a Tween has a `repeatDelay` set, this event will fire after that delay expires.
 * 
 * The difference between `loop` and `repeat` is that `repeat` is a property setting,
 * where-as `loop` applies to the entire Tween.
 * 
 * Listen to it from a Tween instance using `Tween.on('repeat', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     repeat: 4
 * });
 * tween.on('repeat', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_REPEAT
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The key of the property that just repeated.
 * @param {any} target - The target that the property just repeated on.
 */ module1.exports = 'repeat';
        /***/ },
        /* 1469 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Start Event.
 * 
 * This event is dispatched by a Tween when it starts tweening its first property.
 * 
 * A Tween will only emit this event once, as it can only start once.
 * 
 * If a Tween has a `delay` set, this event will fire after that delay expires.
 * 
 * Listen to it from a Tween instance using `Tween.on('start', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('start', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_START
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = 'start';
        /***/ },
        /* 1470 */ /***/ function(module1, exports) {
            /**
 * @author       samme
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Stop Event.
 *
 * This event is dispatched by a Tween when it is stopped.
 *
 * Listen to it from a Tween instance using `Tween.on('stop', listener)`, i.e.:
 *
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000
 * });
 * tween.on('stop', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_STOP
 * @since 3.24.0
 *
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {any[]} targets - An array of references to the target/s the Tween is operating on.
 */ module1.exports = 'stop';
        /***/ },
        /* 1471 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Update Event.
 * 
 * This event is dispatched by a Tween every time it updates _any_ of the properties it is tweening.
 * 
 * A Tween that is changing 3 properties of a target will emit this event 3 times per change, once per property.
 * 
 * **Note:** This is a very high frequency event and may be dispatched multiple times, every single frame.
 * 
 * Listen to it from a Tween instance using `Tween.on('update', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 * });
 * tween.on('update', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_UPDATE
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property that was updated, i.e. `x` or `scale`.
 * @param {any} target - The target object that was updated. Usually a Game Object, but can be of any type.
 * @param {number} current - The current value of the property that was tweened.
 * @param {number} previous - The previous value of the property that was tweened, prior to this update.
 */ module1.exports = 'update';
        /***/ },
        /* 1472 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Tween Yoyo Event.
 * 
 * This event is dispatched by a Tween whenever a property it is tweening yoyos.
 * 
 * This event will only be dispatched if the Tween has a property with `yoyo` set.
 * 
 * If the Tween has a `hold` value, this event is dispatched when the hold expires.
 * 
 * This event is dispatched for every property, and for every target, that yoyos.
 * For example, if a Tween was updating 2 properties and had 10 targets, this event
 * would be dispatched 20 times (twice per target). So be careful how you use it!
 * 
 * Listen to it from a Tween instance using `Tween.on('yoyo', listener)`, i.e.:
 * 
 * ```javascript
 * var tween = this.tweens.add({
 *     targets: image,
 *     x: 500,
 *     ease: 'Power1',
 *     duration: 3000,
 *     yoyo: true
 * });
 * tween.on('yoyo', listener);
 * ```
 *
 * @event Phaser.Tweens.Events#TWEEN_YOYO
 * @since 3.19.0
 * 
 * @param {Phaser.Tweens.Tween} tween - A reference to the Tween instance that emitted the event.
 * @param {string} key - The property that yoyo'd, i.e. `x` or `scale`.
 * @param {any} target - The target object that was yoyo'd. Usually a Game Object, but can be of any type.
 */ module1.exports = 'yoyo';
        /***/ },
        /* 1473 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ArrayRemove = __webpack_require__(89);
            var Class = __webpack_require__(0);
            var NumberTweenBuilder = __webpack_require__(581);
            var PluginCache = __webpack_require__(24);
            var SceneEvents = __webpack_require__(21);
            var StaggerBuilder = __webpack_require__(582);
            var TimelineBuilder = __webpack_require__(583);
            var TWEEN_CONST = __webpack_require__(97);
            var TweenBuilder = __webpack_require__(161);
            /**
 * @classdesc
 * The Tween Manager is a default Scene Plugin which controls and updates Tweens and Timelines.
 *
 * @class TweenManager
 * @memberof Phaser.Tweens
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene which owns this Tween Manager.
 */ var TweenManager = new Class({
                initialize: function TweenManager(scene) {
                    /**
         * The Scene which owns this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * The Systems object of the Scene which owns this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The time scale of the Tween Manager.
         *
         * This value scales the time delta between two frames, thus influencing the speed of time for all Tweens owned by this Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#timeScale
         * @type {number}
         * @default 1
         * @since 3.0.0
         */ this.timeScale = 1;
                    /**
         * An array of Tweens and Timelines which will be added to the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_add
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._add = [];
                    /**
         * An array of Tweens and Timelines pending to be later added to the Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#_pending
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._pending = [];
                    /**
         * An array of Tweens and Timelines which are still incomplete and are actively processed by the Tween Manager.
         *
         * @name Phaser.Tweens.TweenManager#_active
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._active = [];
                    /**
         * An array of Tweens and Timelines which will be removed from the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_destroy
         * @type {array}
         * @private
         * @since 3.0.0
         */ this._destroy = [];
                    /**
         * The number of Tweens and Timelines which need to be processed by the Tween Manager at the start of the frame.
         *
         * @name Phaser.Tweens.TweenManager#_toProcess
         * @type {number}
         * @private
         * @default 0
         * @since 3.0.0
         */ this._toProcess = 0;
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Tweens.TweenManager#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.on(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                    this.timeScale = 1;
                },
                /**
     * Create a Tween Timeline and return it, but do NOT add it to the active or pending Tween lists.
     *
     * @method Phaser.Tweens.TweenManager#createTimeline
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TimelineBuilderConfig} [config] - The configuration object for the Timeline and its Tweens.
     *
     * @return {Phaser.Tweens.Timeline} The created Timeline object.
     */ createTimeline: function(config) {
                    return TimelineBuilder(this, config);
                },
                /**
     * Create a Tween Timeline and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#timeline
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TimelineBuilderConfig} [config] - The configuration object for the Timeline and its Tweens.
     *
     * @return {Phaser.Tweens.Timeline} The created Timeline object.
     */ timeline: function(config) {
                    var timeline = TimelineBuilder(this, config);
                    if (!timeline.paused) {
                        this._add.push(timeline);
                        this._toProcess++;
                    }
                    return timeline;
                },
                /**
     * Create a Tween and return it, but do NOT add it to the active or pending Tween lists.
     *
     * @method Phaser.Tweens.TweenManager#create
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The configuration object for the Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Tween object.
     */ create: function(config) {
                    return TweenBuilder(this, config);
                },
                /**
     * Create a Tween and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#add
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.TweenBuilderConfig|object} config - The configuration object for the Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Tween.
     */ add: function(config) {
                    var tween = TweenBuilder(this, config);
                    this._add.push(tween);
                    this._toProcess++;
                    return tween;
                },
                /**
     * Add an existing tween into the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#existing
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to add.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ existing: function(tween) {
                    this._add.push(tween);
                    this._toProcess++;
                    return this;
                },
                /**
     * Create a Number Tween and add it to the active Tween list.
     *
     * @method Phaser.Tweens.TweenManager#addCounter
     * @since 3.0.0
     *
     * @param {Phaser.Types.Tweens.NumberTweenBuilderConfig} config - The configuration object for the Number Tween.
     *
     * @return {Phaser.Tweens.Tween} The created Number Tween.
     */ addCounter: function(config) {
                    var tween = NumberTweenBuilder(this, config);
                    this._add.push(tween);
                    this._toProcess++;
                    return tween;
                },
                /**
     * Creates a Stagger function to be used by a Tween property.
     *
     * The stagger function will allow you to stagger changes to the value of the property across all targets of the tween.
     *
     * This is only worth using if the tween has multiple targets.
     *
     * The following will stagger the delay by 100ms across all targets of the tween, causing them to scale down to 0.2
     * over the duration specified:
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(100)
     * });
     * ```
     *
     * The following will stagger the delay by 500ms across all targets of the tween using a 10 x 6 grid, staggering
     * from the center out, using a cubic ease.
     *
     * ```javascript
     * this.tweens.add({
     *     targets: [ ... ],
     *     scale: 0.2,
     *     ease: 'linear',
     *     duration: 1000,
     *     delay: this.tweens.stagger(500, { grid: [ 10, 6 ], from: 'center', ease: 'cubic.out' })
     * });
     * ```
     *
     * @method Phaser.Tweens.TweenManager#stagger
     * @since 3.19.0
     *
     * @param {(number|number[])} value - The amount to stagger by, or an array containing two elements representing the min and max values to stagger between.
     * @param {Phaser.Types.Tweens.StaggerConfig} config - The configuration object for the Stagger function.
     *
     * @return {function} The stagger function.
     */ stagger: function(value, options) {
                    return StaggerBuilder(value, options);
                },
                /**
     * Updates the Tween Manager's internal lists at the start of the frame.
     *
     * This method will return immediately if no changes have been indicated.
     *
     * @method Phaser.Tweens.TweenManager#preUpdate
     * @since 3.0.0
     */ preUpdate: function() {
                    if (this._toProcess === 0) //  Quick bail
                    return;
                    var list = this._destroy;
                    var active = this._active;
                    var pending = this._pending;
                    var i;
                    var tween;
                    //  Clear the 'destroy' list
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        //  Remove from the 'active' array
                        var idx = active.indexOf(tween);
                        if (idx === -1) {
                            //  Not in the active array, is it in pending instead?
                            idx = pending.indexOf(tween);
                            if (idx > -1) {
                                tween.state = TWEEN_CONST.REMOVED;
                                pending.splice(idx, 1);
                            }
                        } else {
                            tween.state = TWEEN_CONST.REMOVED;
                            active.splice(idx, 1);
                        }
                    }
                    list.length = 0;
                    //  Process the addition list
                    //  This stops callbacks and out of sync events from populating the active array mid-way during the update
                    list = this._add;
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        if (tween.state === TWEEN_CONST.PENDING_ADD) {
                            //  Return true if the Tween should be started right away, otherwise false
                            if (tween.init()) {
                                tween.play();
                                this._active.push(tween);
                            } else this._pending.push(tween);
                        }
                    }
                    list.length = 0;
                    this._toProcess = 0;
                },
                /**
     * Updates all Tweens and Timelines of the Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#update
     * @since 3.0.0
     *
     * @param {number} timestamp - The current time in milliseconds.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(timestamp, delta) {
                    //  Process active tweens
                    var list = this._active;
                    var tween;
                    //  Scale the delta
                    delta *= this.timeScale;
                    for(var i = 0; i < list.length; i++){
                        tween = list[i];
                        //  If Tween.update returns 'true' then it means it has completed,
                        //  so move it to the destroy list
                        if (tween.update(timestamp, delta)) {
                            this._destroy.push(tween);
                            this._toProcess++;
                        }
                    }
                },
                /**
     * Removes the given tween from the Tween Manager, regardless of its state (pending or active).
     *
     * @method Phaser.Tweens.TweenManager#remove
     * @since 3.17.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to be removed.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ remove: function(tween) {
                    ArrayRemove(this._add, tween);
                    ArrayRemove(this._pending, tween);
                    ArrayRemove(this._active, tween);
                    ArrayRemove(this._destroy, tween);
                    tween.state = TWEEN_CONST.REMOVED;
                    return this;
                },
                /**
     * Checks if a Tween or Timeline is active and adds it to the Tween Manager at the start of the frame if it isn't.
     *
     * @method Phaser.Tweens.TweenManager#makeActive
     * @since 3.0.0
     *
     * @param {Phaser.Tweens.Tween} tween - The Tween to check.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
     */ makeActive: function(tween) {
                    if (this._add.indexOf(tween) !== -1 || this._active.indexOf(tween) !== -1) return this;
                    var idx = this._pending.indexOf(tween);
                    if (idx !== -1) this._pending.splice(idx, 1);
                    this._add.push(tween);
                    tween.state = TWEEN_CONST.PENDING_ADD;
                    this._toProcess++;
                    return this;
                },
                /**
     * Passes all Tweens to the given callback.
     *
     * @method Phaser.Tweens.TweenManager#each
     * @since 3.0.0
     *
     * @param {function} callback - The function to call.
     * @param {object} [scope] - The scope (`this` object) to call the function with.
     * @param {...*} [args] - The arguments to pass into the function. Its first argument will always be the Tween currently being iterated.
     */ each: function(callback, scope) {
                    var args = [
                        null
                    ];
                    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
                    for(var texture in this.list){
                        args[0] = this.list[texture];
                        callback.apply(scope, args);
                    }
                },
                /**
     * Returns an array of all active Tweens and Timelines in the Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#getAllTweens
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing references to all active Tweens and Timelines.
     */ getAllTweens: function() {
                    var list = this._active;
                    var output = [];
                    for(var i = 0; i < list.length; i++)output.push(list[i]);
                    return output;
                },
                /**
     * Returns the scale of the time delta for all Tweens and Timelines owned by this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#getGlobalTimeScale
     * @since 3.0.0
     *
     * @return {number} The scale of the time delta, usually 1.
     */ getGlobalTimeScale: function() {
                    return this.timeScale;
                },
                /**
     * Returns an array of all Tweens or Timelines in the Tween Manager which affect the given target or array of targets.
     *
     * Only the currently active tweens are tested. A tween that has completed and is
     * awaiting removal will not be included in the results.
     *
     * If you wish to also search pending tweens, use the `includePending` flag.
     *
     * @method Phaser.Tweens.TweenManager#getTweensOf
     * @since 3.0.0
     *
     * @param {(object|array)} target - The target to look for. Provide an array to look for multiple targets.
     * @param {boolean} [includePending=false] - Also check for pending tweens, not just active ones?
     *
     * @return {Phaser.Tweens.Tween[]} A new array containing all Tweens and Timelines which affect the given target(s).
     */ getTweensOf: function(target, includePending) {
                    if (includePending === undefined) includePending = false;
                    var list = this._active;
                    var tween;
                    var output = [];
                    var i;
                    var t;
                    if (!Array.isArray(target)) target = [
                        target
                    ];
                    for(i = 0; i < list.length; i++){
                        tween = list[i];
                        for(t = 0; t < target.length; t++)if (tween.hasTarget(target[t])) output.push(tween);
                    }
                    if (includePending) {
                        list = this._pending;
                        for(i = 0; i < list.length; i++){
                            tween = list[i];
                            for(t = 0; t < target.length; t++)if (tween.hasTarget(target[t])) output.push(tween);
                        }
                    }
                    return output;
                },
                /**
     * Checks if the given object is being affected by a playing Tween.
     *
     * @method Phaser.Tweens.TweenManager#isTweening
     * @since 3.0.0
     *
     * @param {object} target - target Phaser.Tweens.Tween object
     *
     * @return {boolean} returns if target tween object is active or not
     */ isTweening: function(target) {
                    var list = this._active;
                    var tween;
                    for(var i = 0; i < list.length; i++){
                        tween = list[i];
                        if (tween.hasTarget(target) && tween.isPlaying()) return true;
                    }
                    return false;
                },
                /**
     * Stops all Tweens in this Tween Manager. They will be removed at the start of the frame.
     *
     * @method Phaser.Tweens.TweenManager#killAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ killAll: function() {
                    var tweens = this.getAllTweens();
                    for(var i = 0; i < tweens.length; i++)tweens[i].stop();
                    return this;
                },
                /**
     * Stops all Tweens which affect the given target or array of targets. The Tweens will be removed from the Tween Manager at the start of the frame.
     *
     * @see {@link #getTweensOf}
     *
     * @method Phaser.Tweens.TweenManager#killTweensOf
     * @since 3.0.0
     *
     * @param {(object|array)} target - The target to look for. Provide an array to look for multiple targets.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ killTweensOf: function(target) {
                    var tweens = this.getTweensOf(target);
                    for(var i = 0; i < tweens.length; i++)tweens[i].stop();
                    return this;
                },
                /**
     * Pauses all Tweens in this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#pauseAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ pauseAll: function() {
                    var list = this._active;
                    for(var i = 0; i < list.length; i++)list[i].pause();
                    return this;
                },
                /**
     * Resumes all Tweens in this Tween Manager.
     *
     * @method Phaser.Tweens.TweenManager#resumeAll
     * @since 3.0.0
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ resumeAll: function() {
                    var list = this._active;
                    for(var i = 0; i < list.length; i++)list[i].resume();
                    return this;
                },
                /**
     * Sets a new scale of the time delta for this Tween Manager.
     *
     * The time delta is the time elapsed between two consecutive frames and influences the speed of time for this Tween Manager and all Tweens it owns. Values higher than 1 increase the speed of time, while values smaller than 1 decrease it. A value of 0 freezes time and is effectively equivalent to pausing all Tweens.
     *
     * @method Phaser.Tweens.TweenManager#setGlobalTimeScale
     * @since 3.0.0
     *
     * @param {number} value - The new scale of the time delta, where 1 is the normal speed.
     *
     * @return {Phaser.Tweens.TweenManager} This Tween Manager.
     */ setGlobalTimeScale: function(value) {
                    this.timeScale = value;
                    return this;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Tweens.TweenManager#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    this.killAll();
                    this._add = [];
                    this._pending = [];
                    this._active = [];
                    this._destroy = [];
                    this._toProcess = 0;
                    var eventEmitter = this.systems.events;
                    eventEmitter.off(SceneEvents.PRE_UPDATE, this.preUpdate, this);
                    eventEmitter.off(SceneEvents.UPDATE, this.update, this);
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Tweens.TweenManager#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('TweenManager', TweenManager, 'tweens');
            module1.exports = TweenManager;
        /***/ },
        /* 1474 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils
 */ module1.exports = {
                Array: __webpack_require__(205),
                Base64: __webpack_require__(1475),
                Objects: __webpack_require__(1477),
                String: __webpack_require__(1481),
                NOOP: __webpack_require__(1)
            };
        /***/ },
        /* 1475 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Base64
 */ module1.exports = {
                ArrayBufferToBase64: __webpack_require__(1476),
                Base64ToArrayBuffer: __webpack_require__(427)
            };
        /***/ },
        /* 1476 */ /***/ function(module1, exports) {
            /**
 * @author       Niklas von Hertzen (https://github.com/niklasvh/base64-arraybuffer)
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            /**
 * Converts an ArrayBuffer into a base64 string.
 * 
 * The resulting string can optionally be a data uri if the `mediaType` argument is provided.
 * 
 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs for more details.
 *
 * @function Phaser.Utils.Base64.ArrayBufferToBase64
 * @since 3.18.0
 * 
 * @param {ArrayBuffer} arrayBuffer - The Array Buffer to encode.
 * @param {string} [mediaType] - An optional media type, i.e. `audio/ogg` or `image/jpeg`. If included the resulting string will be a data URI.
 * 
 * @return {string} The base64 encoded Array Buffer.
 */ var ArrayBufferToBase64 = function(arrayBuffer, mediaType) {
                var bytes = new Uint8Array(arrayBuffer);
                var len = bytes.length;
                var base64 = mediaType ? 'data:' + mediaType + ';base64,' : '';
                for(var i = 0; i < len; i += 3){
                    base64 += chars[bytes[i] >> 2];
                    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                    base64 += chars[bytes[i + 2] & 63];
                }
                if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
                else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
                return base64;
            };
            module1.exports = ArrayBufferToBase64;
        /***/ },
        /* 1477 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.Objects
 */ module1.exports = {
                Clone: __webpack_require__(77),
                DeepCopy: __webpack_require__(172),
                Extend: __webpack_require__(17),
                GetAdvancedValue: __webpack_require__(13),
                GetFastValue: __webpack_require__(2),
                GetMinMaxValue: __webpack_require__(1478),
                GetValue: __webpack_require__(6),
                HasAll: __webpack_require__(1479),
                HasAny: __webpack_require__(449),
                HasValue: __webpack_require__(125),
                IsPlainObject: __webpack_require__(7),
                Merge: __webpack_require__(143),
                MergeRight: __webpack_require__(1480),
                Pick: __webpack_require__(567),
                SetValue: __webpack_require__(472)
            };
        /***/ },
        /* 1478 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var GetValue = __webpack_require__(6);
            var Clamp = __webpack_require__(18);
            /**
 * Retrieves and clamps a numerical value from an object.
 *
 * @function Phaser.Utils.Objects.GetMinMaxValue
 * @since 3.0.0
 *
 * @param {object} source - The object to retrieve the value from.
 * @param {string} key - The name of the property to retrieve from the object. If a property is nested, the names of its preceding properties should be separated by a dot (`.`).
 * @param {number} min - The minimum value which can be returned.
 * @param {number} max - The maximum value which can be returned.
 * @param {number} defaultValue - The value to return if the property doesn't exist. It's also constrained to the given bounds.
 *
 * @return {number} The clamped value from the `source` object.
 */ var GetMinMaxValue = function(source, key, min, max, defaultValue) {
                if (defaultValue === undefined) defaultValue = min;
                var value = GetValue(source, key, defaultValue);
                return Clamp(value, min, max);
            };
            module1.exports = GetMinMaxValue;
        /***/ },
        /* 1479 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Verifies that an object contains all requested keys
 *
 * @function Phaser.Utils.Objects.HasAll
 * @since 3.0.0
 *
 * @param {object} source - an object on which to check for key existence
 * @param {string[]} keys - an array of keys to ensure the source object contains
 *
 * @return {boolean} true if the source object contains all keys, false otherwise.
 */ var HasAll = function(source, keys) {
                for(var i = 0; i < keys.length; i++){
                    if (!source.hasOwnProperty(keys[i])) return false;
                }
                return true;
            };
            module1.exports = HasAll;
        /***/ },
        /* 1480 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Clone = __webpack_require__(77);
            /**
 * Creates a new Object using all values from obj1.
 * 
 * Then scans obj2. If a property is found in obj2 that *also* exists in obj1, the value from obj2 is used, otherwise the property is skipped.
 *
 * @function Phaser.Utils.Objects.MergeRight
 * @since 3.0.0
 *
 * @param {object} obj1 - The first object to merge.
 * @param {object} obj2 - The second object to merge. Keys from this object which also exist in `obj1` will be copied to `obj1`.
 *
 * @return {object} The merged object. `obj1` and `obj2` are not modified.
 */ var MergeRight = function(obj1, obj2) {
                var clone = Clone(obj1);
                for(var key in obj2)if (clone.hasOwnProperty(key)) clone[key] = obj2[key];
                return clone;
            };
            module1.exports = MergeRight;
        /***/ },
        /* 1481 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Utils.String
 */ module1.exports = {
                Format: __webpack_require__(1482),
                Pad: __webpack_require__(183),
                RemoveAt: __webpack_require__(1483),
                Reverse: __webpack_require__(1484),
                UppercaseFirst: __webpack_require__(202),
                UUID: __webpack_require__(219)
            };
        /***/ },
        /* 1482 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and replaces instances of markers with values in the given array.
 * The markers take the form of `%1`, `%2`, etc. I.e.:
 *
 * `Format("The %1 is worth %2 gold", [ 'Sword', 500 ])`
 *
 * @function Phaser.Utils.String.Format
 * @since 3.0.0
 *
 * @param {string} string - The string containing the replacement markers.
 * @param {array} values - An array containing values that will replace the markers. If no value exists an empty string is inserted instead.
 *
 * @return {string} The string containing replaced values.
 */ var Format = function(string, values) {
                return string.replace(/%([0-9]+)/g, function(s, n) {
                    return values[Number(n) - 1];
                });
            };
            module1.exports = Format;
        /***/ },
        /* 1483 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes a string and removes the character at the given index.
 *
 * @function Phaser.Utils.String.RemoveAt
 * @since 3.50.0
 *
 * @param {string} string - The string to be worked on.
 * @param {number} index - The index of the character to be removed.
 *
 * @return {string} The modified string.
 */ var RemoveAt = function(string, index) {
                if (index === 0) return string.slice(1);
                else return string.slice(0, index - 1) + string.slice(index);
            };
            module1.exports = RemoveAt;
        /***/ },
        /* 1484 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Takes the given string and reverses it, returning the reversed string.
 * For example if given the string `Atari 520ST` it would return `TS025 iratA`.
 *
 * @function Phaser.Utils.String.Reverse
 * @since 3.0.0
 *
 * @param {string} string - The string to be reversed.
 *
 * @return {string} The reversed string.
 */ var Reverse = function(string) {
                return string.split('').reverse().join('');
            };
            module1.exports = Reverse;
        /***/ },
        /* 1485 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Sound
 */ module1.exports = {
                SoundManagerCreator: __webpack_require__(420),
                Events: __webpack_require__(69),
                BaseSound: __webpack_require__(145),
                BaseSoundManager: __webpack_require__(144),
                WebAudioSound: __webpack_require__(428),
                WebAudioSoundManager: __webpack_require__(426),
                HTML5AudioSound: __webpack_require__(423),
                HTML5AudioSoundManager: __webpack_require__(421),
                NoAudioSound: __webpack_require__(425),
                NoAudioSoundManager: __webpack_require__(424)
            };
        /***/ },
        /* 1486 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * 
 * The Body Bounds class contains methods to help you extract the world coordinates from various points around
 * the bounds of a Matter Body. Because Matter bodies are positioned based on their center of mass, and not a
 * dimension based center, you often need to get the bounds coordinates in order to properly align them in the world.
 * 
 * You can access this class via the MatterPhysics class from a Scene, i.e.:
 * 
 * ```javascript
 * this.matter.bodyBounds.getTopLeft(body);
 * ```
 * 
 * See also the `MatterPhysics.alignBody` method.
 *
 * @class BodyBounds
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.22.0
 */ var BodyBounds = new Class({
                initialize: function BodyBounds() {
                    /**
         * A Vector2 that stores the temporary bounds center value during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#boundsCenter
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.boundsCenter = new Vector2();
                    /**
         * A Vector2 that stores the temporary center diff values during calculations by methods in this class.
         *
         * @name Phaser.Physics.Matter.BodyBounds#centerDiff
         * @type {Phaser.Math.Vector2}
         * @since 3.22.0
         */ this.centerDiff = new Vector2();
                },
                /**
     * Parses the given body to get the bounds diff values from it.
     * 
     * They're stored in this class in the temporary properties `boundsCenter` and `centerDiff`.
     * 
     * This method is called automatically by all other methods in this class.
     *
     * @method Phaser.Physics.Matter.BodyBounds#parseBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the bounds position from.
     *
     * @return {boolean} `true` if it was able to get the bounds, otherwise `false`.
     */ parseBody: function(body) {
                    body = body.hasOwnProperty('body') ? body.body : body;
                    if (!body.hasOwnProperty('bounds') || !body.hasOwnProperty('centerOfMass')) return false;
                    var boundsCenter = this.boundsCenter;
                    var centerDiff = this.centerDiff;
                    var boundsWidth = body.bounds.max.x - body.bounds.min.x;
                    var boundsHeight = body.bounds.max.y - body.bounds.min.y;
                    var bodyCenterX = boundsWidth * body.centerOfMass.x;
                    var bodyCenterY = boundsHeight * body.centerOfMass.y;
                    boundsCenter.set(boundsWidth / 2, boundsHeight / 2);
                    centerDiff.set(bodyCenterX - boundsCenter.x, bodyCenterY - boundsCenter.y);
                    return true;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-left of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopLeft: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the top-right of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getTopRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getTopRight: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y + center.y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the left-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getLeftCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getLeftCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the right-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getRightCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getRightCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y + diff.y);
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-left of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomLeft
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomLeft: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + center.x + diff.x, y - (center.y - diff.y));
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-center of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomCenter
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomCenter: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x + diff.x, y - (center.y - diff.y));
                    }
                    return false;
                },
                /**
     * Takes a Body and returns the world coordinates of the bottom-right of its _bounds_.
     * 
     * Body bounds are updated by Matter each step and factor in scale and rotation.
     * This will return the world coordinate based on the bodies _current_ position and bounds.
     *
     * @method Phaser.Physics.Matter.BodyBounds#getBottomRight
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to get the position from.
     * @param {number} [x=0] - Optional horizontal offset to add to the returned coordinates.
     * @param {number} [y=0] - Optional vertical offset to add to the returned coordinates.
     *
     * @return {(Phaser.Math.Vector2|false)} A Vector2 containing the coordinates, or `false` if it was unable to parse the body.
     */ getBottomRight: function(body, x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (this.parseBody(body)) {
                        var center = this.boundsCenter;
                        var diff = this.centerDiff;
                        return new Vector2(x - (center.x - diff.x), y - (center.y - diff.y));
                    }
                    return false;
                }
            });
            module1.exports = BodyBounds;
        /***/ },
        /* 1487 */ /***/ function(module1, exports) {
            /**
 * @author       Stefan Hedman <schteppe@gmail.com> (http://steffe.se)
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ //  v0.3.0
            module1.exports = {
                decomp: polygonDecomp,
                quickDecomp: polygonQuickDecomp,
                isSimple: polygonIsSimple,
                removeCollinearPoints: polygonRemoveCollinearPoints,
                removeDuplicatePoints: polygonRemoveDuplicatePoints,
                makeCCW: polygonMakeCCW
            };
            /**
 * Compute the intersection between two lines.
 * @static
 * @method lineInt
 * @param  {Array}  l1          Line vector 1
 * @param  {Array}  l2          Line vector 2
 * @param  {Number} precision   Precision to use when checking if the lines are parallel
 * @return {Array}              The intersection point.
 */ function lineInt(l1, l2, precision) {
                precision = precision || 0;
                var i = [
                    0,
                    0
                ]; // point
                var a1, b1, c1, a2, b2, c2, det; // scalars
                a1 = l1[1][1] - l1[0][1];
                b1 = l1[0][0] - l1[1][0];
                c1 = a1 * l1[0][0] + b1 * l1[0][1];
                a2 = l2[1][1] - l2[0][1];
                b2 = l2[0][0] - l2[1][0];
                c2 = a2 * l2[0][0] + b2 * l2[0][1];
                det = a1 * b2 - a2 * b1;
                if (!scalar_eq(det, 0, precision)) {
                    i[0] = (b2 * c1 - b1 * c2) / det;
                    i[1] = (a1 * c2 - a2 * c1) / det;
                }
                return i;
            }
            /**
 * Checks if two line segments intersects.
 * @method segmentsIntersect
 * @param {Array} p1 The start vertex of the first line segment.
 * @param {Array} p2 The end vertex of the first line segment.
 * @param {Array} q1 The start vertex of the second line segment.
 * @param {Array} q2 The end vertex of the second line segment.
 * @return {Boolean} True if the two line segments intersect
 */ function lineSegmentsIntersect(p1, p2, q1, q2) {
                var dx = p2[0] - p1[0];
                var dy = p2[1] - p1[1];
                var da = q2[0] - q1[0];
                var db = q2[1] - q1[1];
                // segments are parallel
                if (da * dy - db * dx === 0) return false;
                var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
                var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
                return s >= 0 && s <= 1 && t >= 0 && t <= 1;
            }
            /**
 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
 * @static
 * @method area
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return {Number}
 */ function triangleArea(a, b, c) {
                return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
            }
            function isLeft(a, b, c) {
                return triangleArea(a, b, c) > 0;
            }
            function isLeftOn(a, b, c) {
                return triangleArea(a, b, c) >= 0;
            }
            function isRight(a, b, c) {
                return triangleArea(a, b, c) < 0;
            }
            function isRightOn(a, b, c) {
                return triangleArea(a, b, c) <= 0;
            }
            var tmpPoint1 = [], tmpPoint2 = [];
            /**
 * Check if three points are collinear
 * @method collinear
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
 * @return {Boolean}
 */ function collinear(a, b, c, thresholdAngle) {
                if (!thresholdAngle) return triangleArea(a, b, c) === 0;
                else {
                    var ab = tmpPoint1, bc = tmpPoint2;
                    ab[0] = b[0] - a[0];
                    ab[1] = b[1] - a[1];
                    bc[0] = c[0] - b[0];
                    bc[1] = c[1] - b[1];
                    var dot = ab[0] * bc[0] + ab[1] * bc[1], magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]), magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]), angle = Math.acos(dot / (magA * magB));
                    return angle < thresholdAngle;
                }
            }
            function sqdist(a, b) {
                var dx = b[0] - a[0];
                var dy = b[1] - a[1];
                return dx * dx + dy * dy;
            }
            /**
 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
 * @method at
 * @param  {Number} i
 * @return {Array}
 */ function polygonAt(polygon, i) {
                var s = polygon.length;
                return polygon[i < 0 ? i % s + s : i % s];
            }
            /**
 * Clear the polygon data
 * @method clear
 * @return {Array}
 */ function polygonClear(polygon) {
                polygon.length = 0;
            }
            /**
 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
 * @method append
 * @param {Polygon} poly The polygon to get points from.
 * @param {Number}  from The vertex index in "poly".
 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
 * @return {Array}
 */ function polygonAppend(polygon, poly, from, to) {
                for(var i = from; i < to; i++)polygon.push(poly[i]);
            }
            /**
 * Make sure that the polygon vertices are ordered counter-clockwise.
 * @method makeCCW
 */ function polygonMakeCCW(polygon) {
                var br = 0, v = polygon;
                // find bottom right point
                for(var i = 1; i < polygon.length; ++i)if (v[i][1] < v[br][1] || v[i][1] === v[br][1] && v[i][0] > v[br][0]) br = i;
                // reverse poly if clockwise
                if (!isLeft(polygonAt(polygon, br - 1), polygonAt(polygon, br), polygonAt(polygon, br + 1))) {
                    polygonReverse(polygon);
                    return true;
                } else return false;
            }
            /**
 * Reverse the vertices in the polygon
 * @method reverse
 */ function polygonReverse(polygon) {
                var tmp = [];
                var N = polygon.length;
                for(var i = 0; i !== N; i++)tmp.push(polygon.pop());
                for(var i = 0; i !== N; i++)polygon[i] = tmp[i];
            }
            /**
 * Check if a point in the polygon is a reflex point
 * @method isReflex
 * @param  {Number}  i
 * @return {Boolean}
 */ function polygonIsReflex(polygon, i) {
                return isRight(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1));
            }
            var tmpLine1 = [], tmpLine2 = [];
            /**
 * Check if two vertices in the polygon can see each other
 * @method canSee
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee(polygon, a, b) {
                var p, dist, l1 = tmpLine1, l2 = tmpLine2;
                if (isLeftOn(polygonAt(polygon, a + 1), polygonAt(polygon, a), polygonAt(polygon, b)) && isRightOn(polygonAt(polygon, a - 1), polygonAt(polygon, a), polygonAt(polygon, b))) return false;
                dist = sqdist(polygonAt(polygon, a), polygonAt(polygon, b));
                for(var i = 0; i !== polygon.length; ++i){
                    if ((i + 1) % polygon.length === a || i === a) continue;
                    if (isLeftOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i + 1)) && isRightOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i))) {
                        l1[0] = polygonAt(polygon, a);
                        l1[1] = polygonAt(polygon, b);
                        l2[0] = polygonAt(polygon, i);
                        l2[1] = polygonAt(polygon, i + 1);
                        p = lineInt(l1, l2);
                        if (sqdist(polygonAt(polygon, a), p) < dist) return false;
                    }
                }
                return true;
            }
            /**
 * Check if two vertices in the polygon can see each other
 * @method canSee2
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ function polygonCanSee2(polygon, a, b) {
                // for each edge
                for(var i = 0; i !== polygon.length; ++i){
                    // ignore incident edges
                    if (i === a || i === b || (i + 1) % polygon.length === a || (i + 1) % polygon.length === b) continue;
                    if (lineSegmentsIntersect(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i), polygonAt(polygon, i + 1))) return false;
                }
                return true;
            }
            /**
 * Copy the polygon from vertex i to vertex j.
 * @method copy
 * @param  {Number} i
 * @param  {Number} j
 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
 * @return {Polygon}                The resulting copy.
 */ function polygonCopy(polygon, i, j, targetPoly) {
                var p = targetPoly || [];
                polygonClear(p);
                if (i < j) // Insert all vertices from i to j
                for(var k = i; k <= j; k++)p.push(polygon[k]);
                else {
                    // Insert vertices 0 to j
                    for(var k = 0; k <= j; k++)p.push(polygon[k]);
                    // Insert vertices i to end
                    for(var k = i; k < polygon.length; k++)p.push(polygon[k]);
                }
                return p;
            }
            /**
 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
 * @method getCutEdges
 * @return {Array}
 */ function polygonGetCutEdges(polygon) {
                var min = [], tmp1 = [], tmp2 = [], tmpPoly = [];
                var nDiags = Number.MAX_VALUE;
                for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(polygon, i)) {
                    for(var j = 0; j < polygon.length; ++j)if (polygonCanSee(polygon, i, j)) {
                        tmp1 = polygonGetCutEdges(polygonCopy(polygon, i, j, tmpPoly));
                        tmp2 = polygonGetCutEdges(polygonCopy(polygon, j, i, tmpPoly));
                        for(var k = 0; k < tmp2.length; k++)tmp1.push(tmp2[k]);
                        if (tmp1.length < nDiags) {
                            min = tmp1;
                            nDiags = tmp1.length;
                            min.push([
                                polygonAt(polygon, i),
                                polygonAt(polygon, j)
                            ]);
                        }
                    }
                }
                return min;
            }
            /**
 * Decomposes the polygon into one or more convex sub-Polygons.
 * @method decomp
 * @return {Array} An array or Polygon objects.
 */ function polygonDecomp(polygon) {
                var edges = polygonGetCutEdges(polygon);
                if (edges.length > 0) return polygonSlice(polygon, edges);
                else return [
                    polygon
                ];
            }
            /**
 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
 * @method slice
 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
 * @return {Array}
 */ function polygonSlice(polygon, cutEdges) {
                if (cutEdges.length === 0) return [
                    polygon
                ];
                if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length === 2 && cutEdges[0][0] instanceof Array) {
                    var polys = [
                        polygon
                    ];
                    for(var i = 0; i < cutEdges.length; i++){
                        var cutEdge = cutEdges[i];
                        // Cut all polys
                        for(var j = 0; j < polys.length; j++){
                            var poly = polys[j];
                            var result = polygonSlice(poly, cutEdge);
                            if (result) {
                                // Found poly! Cut and quit
                                polys.splice(j, 1);
                                polys.push(result[0], result[1]);
                                break;
                            }
                        }
                    }
                    return polys;
                } else {
                    // Was given one edge
                    var cutEdge = cutEdges;
                    var i = polygon.indexOf(cutEdge[0]);
                    var j = polygon.indexOf(cutEdge[1]);
                    if (i !== -1 && j !== -1) return [
                        polygonCopy(polygon, i, j),
                        polygonCopy(polygon, j, i)
                    ];
                    else return false;
                }
            }
            /**
 * Checks that the line segments of this polygon do not intersect each other.
 * @method isSimple
 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
 * @return {Boolean}
 * @todo Should it check all segments with all others?
 */ function polygonIsSimple(polygon) {
                var path = polygon, i;
                // Check
                for(i = 0; i < path.length - 1; i++)for(var j = 0; j < i - 1; j++){
                    if (lineSegmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) return false;
                }
                // Check the segment between the last and the first point to all others
                for(i = 1; i < path.length - 2; i++){
                    if (lineSegmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) return false;
                }
                return true;
            }
            function getIntersectionPoint(p1, p2, q1, q2, delta) {
                delta = delta || 0;
                var a1 = p2[1] - p1[1];
                var b1 = p1[0] - p2[0];
                var c1 = a1 * p1[0] + b1 * p1[1];
                var a2 = q2[1] - q1[1];
                var b2 = q1[0] - q2[0];
                var c2 = a2 * q1[0] + b2 * q1[1];
                var det = a1 * b2 - a2 * b1;
                if (!scalar_eq(det, 0, delta)) return [
                    (b2 * c1 - b1 * c2) / det,
                    (a1 * c2 - a2 * c1) / det
                ];
                else return [
                    0,
                    0
                ];
            }
            /**
 * Quickly decompose the Polygon into convex sub-polygons.
 * @method quickDecomp
 * @param  {Array} result
 * @param  {Array} [reflexVertices]
 * @param  {Array} [steinerPoints]
 * @param  {Number} [delta]
 * @param  {Number} [maxlevel]
 * @param  {Number} [level]
 * @return {Array}
 */ function polygonQuickDecomp(polygon, result, reflexVertices, steinerPoints, delta, maxlevel, level) {
                maxlevel = maxlevel || 100;
                level = level || 0;
                delta = delta || 25;
                result = typeof result !== "undefined" ? result : [];
                reflexVertices = reflexVertices || [];
                steinerPoints = steinerPoints || [];
                var upperInt = [
                    0,
                    0
                ], lowerInt = [
                    0,
                    0
                ], p = [
                    0,
                    0
                ]; // Points
                var upperDist = 0, lowerDist = 0, d = 0, closestDist = 0; // scalars
                var upperIndex = 0, lowerIndex = 0, closestIndex = 0; // Integers
                var lowerPoly = [], upperPoly = []; // polygons
                var poly = polygon, v = polygon;
                if (v.length < 3) return result;
                level++;
                if (level > maxlevel) {
                    console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
                    return result;
                }
                for(var i = 0; i < polygon.length; ++i)if (polygonIsReflex(poly, i)) {
                    reflexVertices.push(poly[i]);
                    upperDist = lowerDist = Number.MAX_VALUE;
                    for(var j = 0; j < polygon.length; ++j){
                        if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j - 1))) {
                            p = getIntersectionPoint(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j - 1)); // find the point of intersection
                            if (isRight(polygonAt(poly, i + 1), polygonAt(poly, i), p)) {
                                d = sqdist(poly[i], p);
                                if (d < lowerDist) {
                                    lowerDist = d;
                                    lowerInt = p;
                                    lowerIndex = j;
                                }
                            }
                        }
                        if (isLeft(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j + 1)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                            p = getIntersectionPoint(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j + 1));
                            if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), p)) {
                                d = sqdist(poly[i], p);
                                if (d < upperDist) {
                                    upperDist = d;
                                    upperInt = p;
                                    upperIndex = j;
                                }
                            }
                        }
                    }
                    // if there are no vertices to connect to, choose a point in the middle
                    if (lowerIndex === (upperIndex + 1) % polygon.length) {
                        //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+polygon.length+")");
                        p[0] = (lowerInt[0] + upperInt[0]) / 2;
                        p[1] = (lowerInt[1] + upperInt[1]) / 2;
                        steinerPoints.push(p);
                        if (i < upperIndex) {
                            //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
                            polygonAppend(lowerPoly, poly, i, upperIndex + 1);
                            lowerPoly.push(p);
                            upperPoly.push(p);
                            if (lowerIndex !== 0) //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
                            polygonAppend(upperPoly, poly, lowerIndex, poly.length);
                            //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
                            polygonAppend(upperPoly, poly, 0, i + 1);
                        } else {
                            if (i !== 0) //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
                            polygonAppend(lowerPoly, poly, i, poly.length);
                            //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
                            polygonAppend(lowerPoly, poly, 0, upperIndex + 1);
                            lowerPoly.push(p);
                            upperPoly.push(p);
                            //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
                            polygonAppend(upperPoly, poly, lowerIndex, i + 1);
                        }
                    } else {
                        // connect to the closest point within the triangle
                        //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+polygon.length+")\n");
                        if (lowerIndex > upperIndex) upperIndex += polygon.length;
                        closestDist = Number.MAX_VALUE;
                        if (upperIndex < lowerIndex) return result;
                        for(var j = lowerIndex; j <= upperIndex; ++j)if (isLeftOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
                            d = sqdist(polygonAt(poly, i), polygonAt(poly, j));
                            if (d < closestDist && polygonCanSee2(poly, i, j)) {
                                closestDist = d;
                                closestIndex = j % polygon.length;
                            }
                        }
                        if (i < closestIndex) {
                            polygonAppend(lowerPoly, poly, i, closestIndex + 1);
                            if (closestIndex !== 0) polygonAppend(upperPoly, poly, closestIndex, v.length);
                            polygonAppend(upperPoly, poly, 0, i + 1);
                        } else {
                            if (i !== 0) polygonAppend(lowerPoly, poly, i, v.length);
                            polygonAppend(lowerPoly, poly, 0, closestIndex + 1);
                            polygonAppend(upperPoly, poly, closestIndex, i + 1);
                        }
                    }
                    // solve smallest poly first
                    if (lowerPoly.length < upperPoly.length) {
                        polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                    } else {
                        polygonQuickDecomp(upperPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                        polygonQuickDecomp(lowerPoly, result, reflexVertices, steinerPoints, delta, maxlevel, level);
                    }
                    return result;
                }
                result.push(polygon);
                return result;
            }
            /**
 * Remove collinear points in the polygon.
 * @method removeCollinearPoints
 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
 * @return {Number}           The number of points removed
 */ function polygonRemoveCollinearPoints(polygon, precision) {
                var num = 0;
                for(var i = polygon.length - 1; polygon.length > 3 && i >= 0; --i)if (collinear(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1), precision)) {
                    // Remove the middle point
                    polygon.splice(i % polygon.length, 1);
                    num++;
                }
                return num;
            }
            /**
 * Remove duplicate points in the polygon.
 * @method removeDuplicatePoints
 * @param  {Number} [precision] The threshold to use when determining whether two points are the same. Use zero for best precision.
 */ function polygonRemoveDuplicatePoints(polygon, precision) {
                for(var i = polygon.length - 1; i >= 1; --i){
                    var pi = polygon[i];
                    for(var j = i - 1; j >= 0; --j)if (points_eq(pi, polygon[j], precision)) {
                        polygon.splice(i, 1);
                        continue;
                    }
                }
            }
            /**
 * Check if two scalars are equal
 * @static
 * @method eq
 * @param  {Number} a
 * @param  {Number} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function scalar_eq(a, b, precision) {
                precision = precision || 0;
                return Math.abs(a - b) <= precision;
            }
            /**
 * Check if two points are equal
 * @static
 * @method points_eq
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ function points_eq(a, b, precision) {
                return scalar_eq(a[0], b[0], precision) && scalar_eq(a[1], b[1], precision);
            }
        /***/ },
        /* 1488 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Class = __webpack_require__(0);
            var Composites = __webpack_require__(1388);
            var Constraint = __webpack_require__(246);
            var Svg = __webpack_require__(1389);
            var MatterGameObject = __webpack_require__(1489);
            var MatterImage = __webpack_require__(1490);
            var MatterSprite = __webpack_require__(1491);
            var MatterTileBody = __webpack_require__(1390);
            var PhysicsEditorParser = __webpack_require__(1386);
            var PhysicsJSONParser = __webpack_require__(1387);
            var PointerConstraint = __webpack_require__(1492);
            var Vertices = __webpack_require__(94);
            /**
 * @classdesc
 * The Matter Factory is responsible for quickly creating a variety of different types of
 * bodies, constraints and Game Objects and adding them into the physics world.
 *
 * You access the factory from within a Scene using `add`:
 *
 * ```javascript
 * this.matter.add.rectangle(x, y, width, height);
 * ```
 *
 * Use of the Factory is optional. All of the objects it creates can also be created
 * directly via your own code or constructors. It is provided as a means to keep your
 * code concise.
 *
 * @class Factory
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter World which this Factory adds to.
 */ var Factory = new Class({
                initialize: function Factory(world) {
                    /**
         * The Matter World which this Factory adds to.
         *
         * @name Phaser.Physics.Matter.Factory#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Scene which this Factory's Matter World belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = world.scene;
                    /**
         * A reference to the Scene.Systems this Matter Physics instance belongs to.
         *
         * @name Phaser.Physics.Matter.Factory#sys
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.sys = world.scene.sys;
                },
                /**
     * Creates a new rigid rectangular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#rectangle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the Body.
     * @param {number} height - The height of the Body.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ rectangle: function(x, y, width, height, options) {
                    var body = Bodies.rectangle(x, y, width, height, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid trapezoidal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#trapezoid
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ trapezoid: function(x, y, width, height, slope, options) {
                    var body = Bodies.trapezoid(x, y, width, height, slope, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid circular Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#circle
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {number} [maxSides] - The maximum amount of sides to use for the polygon which will approximate this circle.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ circle: function(x, y, radius, options, maxSides) {
                    var body = Bodies.circle(x, y, radius, options, maxSides);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a new rigid polygonal Body and adds it to the World.
     *
     * @method Phaser.Physics.Matter.Factory#polygon
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {number} sides - The number of sides the polygon will have.
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ polygon: function(x, y, sides, radius, options) {
                    var body = Bodies.polygon(x, y, sides, radius, options);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices) and adds it to the World.
     * If the vertices are convex, they will pass through as supplied. Otherwise, if the vertices are concave, they will be decomposed. Note that this process is not guaranteed to support complex sets of vertices, e.g. ones with holes.
     *
     * @method Phaser.Physics.Matter.Factory#fromVertices
     * @since 3.0.0
     *
     * @param {number} x - The X coordinate of the center of the Body.
     * @param {number} y - The Y coordinate of the center of the Body.
     * @param {(string|array)} vertexSets - The vertices data. Either a path string or an array of vertices.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [flagInternal=false] - Flag internal edges (coincident part edges)
     * @param {number} [removeCollinear=0.01] - Whether Matter.js will discard collinear edges (to improve performance).
     * @param {number} [minimumArea=10] - During decomposition discard parts that have an area less than this.
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromVertices: function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
                    if (typeof vertexSets === 'string') vertexSets = Vertices.fromPath(vertexSets);
                    var body = Bodies.fromVertices(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea);
                    this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using data exported from the application PhysicsEditor (https://www.codeandweb.com/physicseditor)
     *
     * The PhysicsEditor file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('vehicles', 'assets/vehicles.json);
     * }
     *
     * create ()
     * {
     *   const vehicleShapes = this.cache.json.get('vehicles');
     *   this.matter.add.fromPhysicsEditor(400, 300, vehicleShapes.truck);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the PhysicsEditor config object.
     *
     * @method Phaser.Physics.Matter.Factory#fromPhysicsEditor
     * @since 3.22.0
     *
     * @param {number} x - The horizontal world location of the body.
     * @param {number} y - The vertical world location of the body.
     * @param {any} config - The JSON data exported from PhysicsEditor.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromPhysicsEditor: function(x, y, config, options, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    var body = PhysicsEditorParser.parseBody(x, y, config, options);
                    if (addToWorld && !this.world.has(body)) this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the path data from an SVG file.
     *
     * SVG Parsing requires the pathseg polyfill from https://github.com/progers/pathseg
     *
     * The SVG file should be loaded as XML, as this method requires the ability to extract
     * the path data from it. I.e.:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.xml('face', 'assets/face.svg);
     * }
     *
     * create ()
     * {
     *   this.matter.add.fromSVG(400, 300, this.cache.xml.get('face'));
     * }
     * ```
     *
     * @method Phaser.Physics.Matter.Factory#fromSVG
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {object} xml - The SVG Path data.
     * @param {number} [scale=1] - Scale the vertices by this amount after creation.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromSVG: function(x, y, xml, scale, options, addToWorld) {
                    if (scale === undefined) scale = 1;
                    if (options === undefined) options = {};
                    if (addToWorld === undefined) addToWorld = true;
                    var path = xml.getElementsByTagName('path');
                    var vertexSets = [];
                    for(var i = 0; i < path.length; i++){
                        var points = Svg.pathToVertices(path[i], 30);
                        if (scale !== 1) Vertices.scale(points, scale, scale);
                        vertexSets.push(points);
                    }
                    var body = Bodies.fromVertices(x, y, vertexSets, options);
                    if (addToWorld) this.world.add(body);
                    return body;
                },
                /**
     * Creates a body using the supplied physics data, as provided by a JSON file.
     *
     * The data file should be loaded as JSON:
     *
     * ```javascript
     * preload ()
     * {
     *   this.load.json('ninjas', 'assets/ninjas.json);
     * }
     *
     * create ()
     * {
     *   const ninjaShapes = this.cache.json.get('ninjas');
     *
     *   this.matter.add.fromJSON(400, 300, ninjaShapes.shinobi);
     * }
     * ```
     *
     * Do not pass the entire JSON file to this method, but instead pass one of the shapes contained within it.
     *
     * If you pas in an `options` object, any settings in there will override those in the config object.
     *
     * The structure of the JSON file is as follows:
     *
     * ```text
     * {
     *   'generator_info': // The name of the application that created the JSON data
     *   'shapeName': {
     *     'type': // The type of body
     *     'label': // Optional body label
     *     'vertices': // An array, or an array of arrays, containing the vertex data in x/y object pairs
     *   }
     * }
     * ```
     *
     * At the time of writing, only the Phaser Physics Tracer App exports in this format.
     *
     * @method Phaser.Physics.Matter.Factory#fromJSON
     * @since 3.22.0
     *
     * @param {number} x - The X coordinate of the body.
     * @param {number} y - The Y coordinate of the body.
     * @param {any} config - The JSON physics data.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
     *
     * @return {MatterJS.BodyType} A Matter JS Body.
     */ fromJSON: function(x, y, config, options, addToWorld) {
                    if (options === undefined) options = {};
                    if (addToWorld === undefined) addToWorld = true;
                    var body = PhysicsJSONParser.parseBody(x, y, config, options);
                    if (body && addToWorld) this.world.add(body);
                    return body;
                },
                /**
     * Create a new composite containing Matter Image objects created in a grid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#imageStack
     * @since 3.0.0
     *
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} frame - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} [columnGap=0] - The distance between each column.
     * @param {number} [rowGap=0] - The distance between each row.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite Stack.
     */ imageStack: function(key, frame, x, y, columns, rows, columnGap, rowGap, options) {
                    if (columnGap === undefined) columnGap = 0;
                    if (rowGap === undefined) rowGap = 0;
                    if (options === undefined) options = {};
                    var world = this.world;
                    var displayList = this.sys.displayList;
                    options.addToWorld = false;
                    var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, function(x, y) {
                        var image = new MatterImage(world, x, y, key, frame, options);
                        displayList.add(image);
                        return image.body;
                    });
                    world.add(stack);
                    return stack;
                },
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     *
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#stack
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the grid.
     * @param {number} rows - The number of rows in the grid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback that creates the stack.
     *
     * @return {MatterJS.CompositeType} A new composite containing objects created in the callback.
     */ stack: function(x, y, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, callback);
                    this.world.add(stack);
                    return stack;
                },
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body bounds to prevent overlaps.
     *
     * @method Phaser.Physics.Matter.Factory#pyramid
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the pyramid.
     * @param {number} rows - The number of rows in the pyramid.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {function} callback - The callback function to be invoked.
     *
     * @return {MatterJS.CompositeType} A Matter JS Composite pyramid.
     */ pyramid: function(x, y, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composites.pyramid(x, y, columns, rows, columnGap, rowGap, callback);
                    this.world.add(stack);
                    return stack;
                },
                /**
     * Chains all bodies in the given composite together using constraints.
     *
     * @method Phaser.Physics.Matter.Factory#chain
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together sequentially.
     * @param {number} xOffsetA - The horizontal offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetA - The vertical offset of the BodyA constraint. This is a percentage based on the body size, not a world position.
     * @param {number} xOffsetB - The horizontal offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {number} yOffsetB - The vertical offset of the BodyB constraint. This is a percentage based on the body size, not a world position.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ chain: function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    return Composites.chain(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options);
                },
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     *
     * @method Phaser.Physics.Matter.Factory#mesh
     * @since 3.0.0
     *
     * @param {MatterJS.CompositeType} composite - The composite in which all bodies will be chained together.
     * @param {number} columns - The number of columns in the mesh.
     * @param {number} rows - The number of rows in the mesh.
     * @param {boolean} crossBrace - Create cross braces for the mesh as well?
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} The original composite that was passed to this method.
     */ mesh: function(composite, columns, rows, crossBrace, options) {
                    return Composites.mesh(composite, columns, rows, crossBrace, options);
                },
                /**
     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#newtonsCradle
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the start of the cradle.
     * @param {number} y - The vertical position of the start of the cradle.
     * @param {number} number - The number of balls in the cradle.
     * @param {number} size - The radius of each ball in the cradle.
     * @param {number} length - The length of the 'string' the balls hang from.
     *
     * @return {MatterJS.CompositeType} A Newton's cradle composite.
     */ newtonsCradle: function(x, y, number, size, length) {
                    var composite = Composites.newtonsCradle(x, y, number, size, length);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * Creates a composite with simple car setup of bodies and constraints.
     *
     * @method Phaser.Physics.Matter.Factory#car
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the car in the world.
     * @param {number} y - The vertical position of the car in the world.
     * @param {number} width - The width of the car chasis.
     * @param {number} height - The height of the car chasis.
     * @param {number} wheelSize - The radius of the car wheels.
     *
     * @return {MatterJS.CompositeType} A new composite car body.
     */ car: function(x, y, width, height, wheelSize) {
                    var composite = Composites.car(x, y, width, height, wheelSize);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * Creates a simple soft body like object.
     *
     * @method Phaser.Physics.Matter.Factory#softBody
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this composite in the world.
     * @param {number} y - The vertical position of this composite in the world.
     * @param {number} columns - The number of columns in the Composite.
     * @param {number} rows - The number of rows in the Composite.
     * @param {number} columnGap - The distance between each column.
     * @param {number} rowGap - The distance between each row.
     * @param {boolean} crossBrace - `true` to create cross braces between the bodies, or `false` to create just straight braces.
     * @param {number} particleRadius - The radius of this circlular composite.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [particleOptions] - An optional Body configuration object that is used to set initial Body properties on creation.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [constraintOptions] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.CompositeType} A new composite simple soft body.
     */ softBody: function(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    var composite = Composites.softBody(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions);
                    this.world.add(composite);
                    return composite;
                },
                /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#joint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ joint: function(bodyA, bodyB, length, stiffness, options) {
                    return this.constraint(bodyA, bodyB, length, stiffness, options);
                },
                /**
     * This method is an alias for `Factory.constraint`.
     *
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#spring
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ spring: function(bodyA, bodyB, length, stiffness, options) {
                    return this.constraint(bodyA, bodyB, length, stiffness, options);
                },
                /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#constraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} bodyA - The first possible `Body` that this constraint is attached to.
     * @param {MatterJS.BodyType} bodyB - The second possible `Body` that this constraint is attached to.
     * @param {number} [length] - A Number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ constraint: function(bodyA, bodyB, length, stiffness, options) {
                    if (stiffness === undefined) stiffness = 1;
                    if (options === undefined) options = {};
                    options.bodyA = bodyA.type === 'body' ? bodyA : bodyA.body;
                    options.bodyB = bodyB.type === 'body' ? bodyB : bodyB.body;
                    if (!isNaN(length)) options.length = length;
                    options.stiffness = stiffness;
                    var constraint = Constraint.create(options);
                    this.world.add(constraint);
                    return constraint;
                },
                /**
     * Constraints (or joints) are used for specifying that a fixed distance must be maintained
     * between two bodies, or a body and a fixed world-space position.
     *
     * A world constraint has only one body, you should specify a `pointA` position in
     * the constraint options parameter to attach the constraint to the world.
     *
     * The stiffness of constraints can be modified to create springs or elastic.
     *
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness`
     * value (e.g. `0.7` or above).
     *
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing
     * `constraintIterations` within the Matter Config.
     *
     * For compound bodies, constraints must be applied to the parent body and not one of its parts.
     *
     * @method Phaser.Physics.Matter.Factory#worldConstraint
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Matter `Body` that this constraint is attached to.
     * @param {number} [length] - A number that specifies the target resting length of the constraint. If not given it is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     * @param {number} [stiffness=1] - A Number that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`. A value of `1` means the constraint should be very stiff. A value of `0.2` means the constraint acts as a soft spring.
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ worldConstraint: function(body, length, stiffness, options) {
                    if (stiffness === undefined) stiffness = 1;
                    if (options === undefined) options = {};
                    options.bodyB = body.type === 'body' ? body : body.body;
                    if (!isNaN(length)) options.length = length;
                    options.stiffness = stiffness;
                    var constraint = Constraint.create(options);
                    this.world.add(constraint);
                    return constraint;
                },
                /**
     * This method is an alias for `Factory.pointerConstraint`.
     *
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#mouseSpring
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ mouseSpring: function(options) {
                    return this.pointerConstraint(options);
                },
                /**
     * A Pointer Constraint is a special type of constraint that allows you to click
     * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
     * and when one is pressed down it checks to see if that hit any part of any active
     * body in the world. If it did, and the body has input enabled, it will begin to
     * drag it until either released, or you stop it via the `stopDrag` method.
     *
     * You can adjust the stiffness, length and other properties of the constraint via
     * the `options` object on creation.
     *
     * @method Phaser.Physics.Matter.Factory#pointerConstraint
     * @since 3.0.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterConstraintConfig} [options] - An optional Constraint configuration object that is used to set initial Constraint properties on creation.
     *
     * @return {MatterJS.ConstraintType} A Matter JS Constraint.
     */ pointerConstraint: function(options) {
                    if (options === undefined) options = {};
                    if (!options.hasOwnProperty('render')) options.render = {
                        visible: false
                    };
                    var pointerConstraint = new PointerConstraint(this.scene, this.world, options);
                    this.world.add(pointerConstraint.constraint);
                    return pointerConstraint;
                },
                /**
     * Creates a Matter Physics Image Game Object.
     *
     * An Image is a light-weight Game Object useful for the display of static images in your game,
     * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
     * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
     * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
     *
     * @method Phaser.Physics.Matter.Factory#image
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Image} The Matter Image Game Object.
     */ image: function(x, y, key, frame, options) {
                    var image = new MatterImage(this.world, x, y, key, frame, options);
                    this.sys.displayList.add(image);
                    return image;
                },
                /**
     * Creates a wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
     * have one Matter body associated with it. You can either pass in an existing Matter body for
     * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
     * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
     * tile's rectangle bounding box will be used.
     *
     * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
     *
     * Note: not all Tiled collision shapes are supported. See
     * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
     *
     * @method Phaser.Physics.Matter.Factory#tileBody
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
     * @param {Phaser.Types.Physics.Matter.MatterTileOptions} [options] - Options to be used when creating the Matter body.
     *
     * @return {Phaser.Physics.Matter.TileBody} The Matter Tile Body Game Object.
     */ tileBody: function(tile, options) {
                    return new MatterTileBody(this.world, tile, options);
                },
                /**
     * Creates a Matter Physics Sprite Game Object.
     *
     * A Sprite Game Object is used for the display of both static and animated images in your game.
     * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
     * and animated.
     *
     * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
     * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
     * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
     *
     * @method Phaser.Physics.Matter.Factory#sprite
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of this Game Object in the world.
     * @param {number} y - The vertical position of this Game Object in the world.
     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
     * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.Physics.Matter.Sprite} The Matter Sprite Game Object.
     */ sprite: function(x, y, key, frame, options) {
                    var sprite = new MatterSprite(this.world, x, y, key, frame, options);
                    this.sys.displayList.add(sprite);
                    this.sys.updateList.add(sprite);
                    return sprite;
                },
                /**
     * Takes an existing Game Object and injects all of the Matter Components into it.
     *
     * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
     * this Game Object.
     *
     * You can also pass in either a Matter Body Configuration object, or a Matter Body instance
     * to link with this Game Object.
     *
     * @method Phaser.Physics.Matter.Factory#gameObject
     * @since 3.3.0
     *
     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to inject the Matter Components in to.
     * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
     * @param {boolean} [addToWorld=true] - Add this Matter Body to the World?
     *
     * @return {(Phaser.Physics.Matter.Image|Phaser.Physics.Matter.Sprite|Phaser.GameObjects.GameObject)} The Game Object that had the Matter Components injected into it.
     */ gameObject: function(gameObject, options, addToWorld) {
                    return MatterGameObject(this.world, gameObject, options, addToWorld);
                },
                /**
     * Destroys this Factory.
     *
     * @method Phaser.Physics.Matter.Factory#destroy
     * @since 3.5.0
     */ destroy: function() {
                    this.world = null;
                    this.scene = null;
                    this.sys = null;
                }
            });
            module1.exports = Factory;
        /***/ },
        /* 1489 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Components = __webpack_require__(534);
            var GetFastValue = __webpack_require__(2);
            var Vector2 = __webpack_require__(3);
            /**
 * Internal function to check if the object has a getter or setter.
 *
 * @function hasGetterOrSetter
 * @private
 *
 * @param {object} def - The object to check.
 *
 * @return {boolean} True if it has a getter or setter, otherwise false.
 */ function hasGetterOrSetter(def) {
                return !!def.get && typeof def.get === 'function' || !!def.set && typeof def.set === 'function';
            }
            /**
 * A Matter Game Object is a generic object that allows you to combine any Phaser Game Object,
 * including those you have extended or created yourself, with all of the Matter Components.
 * 
 * This enables you to use component methods such as `setVelocity` or `isSensor` directly from
 * this Game Object.
 *
 * @function Phaser.Physics.Matter.MatterGameObject
 * @since 3.3.0
 *
 * @param {Phaser.Physics.Matter.World} world - The Matter world to add the body to.
 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will have the Matter body applied to it.
 * @param {(Phaser.Types.Physics.Matter.MatterBodyConfig|MatterJS.Body)} [options] - A Matter Body configuration object, or an instance of a Matter Body.
 * @param {boolean} [addToWorld=true] - Should the newly created body be immediately added to the World?
 *
 * @return {Phaser.GameObjects.GameObject} The Game Object that was created with the Matter body.
 */ var MatterGameObject = function(world, gameObject, options, addToWorld) {
                if (options === undefined) options = {};
                if (addToWorld === undefined) addToWorld = true;
                var x = gameObject.x;
                var y = gameObject.y;
                //  Temp body pos to avoid body null checks
                gameObject.body = {
                    temp: true,
                    position: {
                        x: x,
                        y: y
                    }
                };
                var mixins = [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity
                ];
                //  First let's inject all of the components into the Game Object
                mixins.forEach(function(mixin) {
                    for(var key in mixin)if (hasGetterOrSetter(mixin[key])) Object.defineProperty(gameObject, key, {
                        get: mixin[key].get,
                        set: mixin[key].set
                    });
                    else Object.defineProperty(gameObject, key, {
                        value: mixin[key]
                    });
                });
                gameObject.world = world;
                gameObject._tempVec2 = new Vector2(x, y);
                if (options.hasOwnProperty('type') && options.type === 'body') gameObject.setExistingBody(options, addToWorld);
                else {
                    var shape = GetFastValue(options, 'shape', null);
                    if (!shape) shape = 'rectangle';
                    options.addToWorld = addToWorld;
                    gameObject.setBody(shape, options);
                }
                return gameObject;
            };
            module1.exports = MatterGameObject;
        /***/ },
        /* 1490 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Class = __webpack_require__(0);
            var Components = __webpack_require__(534);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Image1 = __webpack_require__(124);
            var Pipeline = __webpack_require__(171);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matter Physics Image Game Object.
 *
 * An Image is a light-weight Game Object useful for the display of static images in your game,
 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
 *
 * @class Image
 * @extends Phaser.GameObjects.Image
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterImage = new Class({
                Extends: Image1,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity,
                    Pipeline
                ],
                initialize: function MatterImage(world, x, y, texture, frame, options) {
                    GameObject.call(this, world.scene, 'Image');
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Image#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                    this.setTexture(texture, frame);
                    this.setSizeToFrame();
                    this.setOrigin();
                    /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Image#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Image#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                    var shape = GetFastValue(options, 'shape', null);
                    if (shape) this.setBody(shape, options);
                    else this.setRectangle(this.width, this.height, options);
                    this.setPosition(x, y);
                    this.initPipeline();
                }
            });
            module1.exports = MatterImage;
        /***/ },
        /* 1491 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var AnimationState = __webpack_require__(162);
            var Class = __webpack_require__(0);
            var Components = __webpack_require__(534);
            var GameObject = __webpack_require__(15);
            var GetFastValue = __webpack_require__(2);
            var Pipeline = __webpack_require__(171);
            var Sprite = __webpack_require__(73);
            var Vector2 = __webpack_require__(3);
            /**
 * @classdesc
 * A Matter Physics Sprite Game Object.
 *
 * A Sprite Game Object is used for the display of both static and animated images in your game.
 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
 * and animated.
 *
 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
 *
 * @class Sprite
 * @extends Phaser.GameObjects.Sprite
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @extends Phaser.Physics.Matter.Components.Bounce
 * @extends Phaser.Physics.Matter.Components.Collision
 * @extends Phaser.Physics.Matter.Components.Force
 * @extends Phaser.Physics.Matter.Components.Friction
 * @extends Phaser.Physics.Matter.Components.Gravity
 * @extends Phaser.Physics.Matter.Components.Mass
 * @extends Phaser.Physics.Matter.Components.Sensor
 * @extends Phaser.Physics.Matter.Components.SetBody
 * @extends Phaser.Physics.Matter.Components.Sleep
 * @extends Phaser.Physics.Matter.Components.Static
 * @extends Phaser.Physics.Matter.Components.Transform
 * @extends Phaser.Physics.Matter.Components.Velocity
 * @extends Phaser.GameObjects.Components.Alpha
 * @extends Phaser.GameObjects.Components.BlendMode
 * @extends Phaser.GameObjects.Components.Depth
 * @extends Phaser.GameObjects.Components.Flip
 * @extends Phaser.GameObjects.Components.GetBounds
 * @extends Phaser.GameObjects.Components.Origin
 * @extends Phaser.GameObjects.Components.Pipeline
 * @extends Phaser.GameObjects.Components.ScrollFactor
 * @extends Phaser.GameObjects.Components.Size
 * @extends Phaser.GameObjects.Components.Texture
 * @extends Phaser.GameObjects.Components.Tint
 * @extends Phaser.GameObjects.Components.Transform
 * @extends Phaser.GameObjects.Components.Visible
 *
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter.World instance that this body belongs to.
 * @param {number} x - The horizontal position of this Game Object in the world.
 * @param {number} y - The vertical position of this Game Object in the world.
 * @param {(string|Phaser.Textures.Texture)} texture - The key, or instance of the Texture this Game Object will use to render with, as stored in the Texture Manager.
 * @param {(string|number)} [frame] - An optional frame from the Texture this Game Object is rendering with.
 * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
 */ var MatterSprite = new Class({
                Extends: Sprite,
                Mixins: [
                    Components.Bounce,
                    Components.Collision,
                    Components.Force,
                    Components.Friction,
                    Components.Gravity,
                    Components.Mass,
                    Components.Sensor,
                    Components.SetBody,
                    Components.Sleep,
                    Components.Static,
                    Components.Transform,
                    Components.Velocity,
                    Pipeline
                ],
                initialize: function MatterSprite(world, x, y, texture, frame, options) {
                    GameObject.call(this, world.scene, 'Sprite');
                    /**
         * The internal crop data object, as used by `setCrop` and passed to the `Frame.setCropUVs` method.
         *
         * @name Phaser.Physics.Matter.Sprite#_crop
         * @type {object}
         * @private
         * @since 3.24.0
         */ this._crop = this.resetCropObject();
                    this.anims = new AnimationState(this);
                    this.setTexture(texture, frame);
                    this.setSizeToFrame();
                    this.setOrigin();
                    /**
         * A reference to the Matter.World instance that this body belongs to.
         *
         * @name Phaser.Physics.Matter.Sprite#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.Sprite#_tempVec2
         * @type {Phaser.Math.Vector2}
         * @private
         * @since 3.0.0
         */ this._tempVec2 = new Vector2(x, y);
                    var shape = GetFastValue(options, 'shape', null);
                    if (shape) this.setBody(shape, options);
                    else this.setRectangle(this.width, this.height, options);
                    this.setPosition(x, y);
                    this.initPipeline();
                }
            });
            module1.exports = MatterSprite;
        /***/ },
        /* 1492 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bounds = __webpack_require__(117);
            var Class = __webpack_require__(0);
            var Composite = __webpack_require__(163);
            var Constraint = __webpack_require__(246);
            var Detector = __webpack_require__(587);
            var Events = __webpack_require__(586);
            var InputEvents = __webpack_require__(49);
            var Merge = __webpack_require__(143);
            var Sleeping = __webpack_require__(267);
            var Vector2 = __webpack_require__(3);
            var Vertices = __webpack_require__(94);
            /**
 * @classdesc
 * A Pointer Constraint is a special type of constraint that allows you to click
 * and drag bodies in a Matter World. It monitors the active Pointers in a Scene,
 * and when one is pressed down it checks to see if that hit any part of any active
 * body in the world. If it did, and the body has input enabled, it will begin to
 * drag it until either released, or you stop it via the `stopDrag` method.
 * 
 * You can adjust the stiffness, length and other properties of the constraint via
 * the `options` object on creation.
 *
 * @class PointerConstraint
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - A reference to the Scene to which this Pointer Constraint belongs.
 * @param {Phaser.Physics.Matter.World} world - A reference to the Matter World instance to which this Constraint belongs.
 * @param {object} [options] - A Constraint configuration object.
 */ var PointerConstraint = new Class({
                initialize: function PointerConstraint(scene, world, options) {
                    if (options === undefined) options = {};
                    //  Defaults
                    var defaults = {
                        label: 'Pointer Constraint',
                        pointA: {
                            x: 0,
                            y: 0
                        },
                        pointB: {
                            x: 0,
                            y: 0
                        },
                        length: 0.01,
                        stiffness: 0.1,
                        angularStiffness: 1,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        }
                    };
                    /**
         * A reference to the Scene to which this Pointer Constraint belongs.
         * This is the same Scene as the Matter World instance.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Matter World instance to which this Constraint belongs.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world = world;
                    /**
         * The Camera the Pointer was interacting with when the input
         * down event was processed.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#camera
         * @type {Phaser.Cameras.Scene2D.Camera}
         * @since 3.0.0
         */ this.camera = null;
                    /**
         * A reference to the Input Pointer that activated this Constraint.
         * This is set in the `onDown` handler.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#pointer
         * @type {Phaser.Input.Pointer}
         * @default null
         * @since 3.0.0
         */ this.pointer = null;
                    /**
         * Is this Constraint active or not?
         * 
         * An active constraint will be processed each update. An inactive one will be skipped.
         * Use this to toggle a Pointer Constraint on and off.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#active
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.active = true;
                    /**
         * The internal transformed position.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#position
         * @type {Phaser.Math.Vector2}
         * @since 3.0.0
         */ this.position = new Vector2();
                    /**
         * The body that is currently being dragged, if any.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#body
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.body = null;
                    /**
         * The part of the body that was clicked on to start the drag.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#part
         * @type {?MatterJS.BodyType}
         * @since 3.16.2
         */ this.part = null;
                    /**
         * The native Matter Constraint that is used to attach to bodies.
         *
         * @name Phaser.Physics.Matter.PointerConstraint#constraint
         * @type {MatterJS.ConstraintType}
         * @since 3.0.0
         */ this.constraint = Constraint.create(Merge(options, defaults));
                    this.world.on(Events.BEFORE_UPDATE, this.update, this);
                    scene.sys.input.on(InputEvents.POINTER_DOWN, this.onDown, this);
                    scene.sys.input.on(InputEvents.POINTER_UP, this.onUp, this);
                },
                /**
     * A Pointer has been pressed down onto the Scene.
     * 
     * If this Constraint doesn't have an active Pointer then a hit test is set to
     * run against all active bodies in the world during the _next_ call to `update`.
     * If a body is found, it is bound to this constraint and the drag begins.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onDown
     * @since 3.0.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onDown: function(pointer) {
                    if (!this.pointer) {
                        this.pointer = pointer;
                        this.camera = pointer.camera;
                    }
                },
                /**
     * A Pointer has been released from the Scene. If it was the one this constraint was using, it's cleared.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#onUp
     * @since 3.22.0
     *
     * @param {Phaser.Input.Pointer} pointer - A reference to the Pointer that was pressed.
     */ onUp: function(pointer) {
                    if (pointer === this.pointer) this.pointer = null;
                },
                /**
     * Scans all active bodies in the current Matter World to see if any of them
     * are hit by the Pointer. The _first one_ found to hit is set as the active contraint
     * body.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#getBody
     * @fires Phaser.Physics.Matter.Events#DRAG_START
     * @since 3.16.2
     * 
     * @return {boolean} `true` if a body was found and set, otherwise `false`.
     */ getBody: function(pointer) {
                    var pos = this.position;
                    var constraint = this.constraint;
                    this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                    var bodies = Composite.allBodies(this.world.localWorld);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (!body.ignorePointer && Bounds.contains(body.bounds, pos) && Detector.canCollide(body.collisionFilter, constraint.collisionFilter)) {
                            if (this.hitTestBody(body, pos)) {
                                this.world.emit(Events.DRAG_START, body, this.part, this);
                                return true;
                            }
                        }
                    }
                    return false;
                },
                /**
     * Scans the current body to determine if a part of it was clicked on.
     * If a part is found the body is set as the `constraint.bodyB` property,
     * as well as the `body` property of this class. The part is also set.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#hitTestBody
     * @since 3.16.2
     *
     * @param {MatterJS.BodyType} body - The Matter Body to check.
     * @param {Phaser.Math.Vector2} position - A translated hit test position.
     *
     * @return {boolean} `true` if a part of the body was hit, otherwise `false`.
     */ hitTestBody: function(body, position) {
                    var constraint = this.constraint;
                    var partsLength = body.parts.length;
                    var start = partsLength > 1 ? 1 : 0;
                    for(var i = start; i < partsLength; i++){
                        var part = body.parts[i];
                        if (Vertices.contains(part.vertices, position)) {
                            constraint.pointA = position;
                            constraint.pointB = {
                                x: position.x - body.position.x,
                                y: position.y - body.position.y
                            };
                            constraint.bodyB = body;
                            constraint.angleB = body.angle;
                            Sleeping.set(body, false);
                            this.part = part;
                            this.body = body;
                            return true;
                        }
                    }
                    return false;
                },
                /**
     * Internal update handler. Called in the Matter BEFORE_UPDATE step.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#update
     * @fires Phaser.Physics.Matter.Events#DRAG
     * @since 3.0.0
     */ update: function() {
                    var pointer = this.pointer;
                    var body = this.body;
                    if (!this.active || !pointer) {
                        if (body) this.stopDrag();
                        return;
                    }
                    if (!pointer.isDown && body) {
                        this.stopDrag();
                        return;
                    } else if (pointer.isDown) {
                        if (!body && !this.getBody(pointer)) return;
                        body = this.body;
                        var pos = this.position;
                        var constraint = this.constraint;
                        this.camera.getWorldPoint(pointer.x, pointer.y, pos);
                        //  Drag update
                        constraint.pointA.x = pos.x;
                        constraint.pointA.y = pos.y;
                        Sleeping.set(body, false);
                        this.world.emit(Events.DRAG, body, this);
                    }
                },
                /**
     * Stops the Pointer Constraint from dragging the body any further.
     * 
     * This is called automatically if the Pointer is released while actively
     * dragging a body. Or, you can call it manually to release a body from a
     * constraint without having to first release the pointer.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#stopDrag
     * @fires Phaser.Physics.Matter.Events#DRAG_END
     * @since 3.16.2
     */ stopDrag: function() {
                    var body = this.body;
                    var constraint = this.constraint;
                    constraint.bodyB = null;
                    constraint.pointB = null;
                    this.pointer = null;
                    this.body = null;
                    this.part = null;
                    if (body) this.world.emit(Events.DRAG_END, body, this);
                },
                /**
     * Destroys this Pointer Constraint instance and all of its references.
     *
     * @method Phaser.Physics.Matter.PointerConstraint#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.world.removeConstraint(this.constraint);
                    this.pointer = null;
                    this.constraint = null;
                    this.body = null;
                    this.part = null;
                    this.world.off(Events.BEFORE_UPDATE, this.update);
                    this.scene.sys.input.off(InputEvents.POINTER_DOWN, this.onDown, this);
                    this.scene.sys.input.off(InputEvents.POINTER_UP, this.onUp, this);
                }
            });
            module1.exports = PointerConstraint;
        /***/ },
        /* 1493 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
*
* @class Matter
*/ var Matter = {};
            module1.exports = Matter;
            var Plugin = __webpack_require__(1392);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * The library name.
     * @property name
     * @readOnly
     * @type {String}
     */ Matter.name = 'matter-js';
                /**
     * The library version.
     * @property version
     * @readOnly
     * @type {String}
     */ Matter.version = '0.14.2';
                /**
     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
     * @property uses
     * @type {Array}
     */ Matter.uses = [];
                /**
     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
     * @property used
     * @readOnly
     * @type {Array}
     */ Matter.used = [];
                /**
     * Installs the given plugins on the `Matter` namespace.
     * This is a short-hand for `Plugin.use`, see it for more information.
     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
     * Avoid calling this function multiple times unless you intend to manually control installation order.
     * @method use
     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
     */ Matter.use = function() {
                    Plugin.use(Matter, Array.prototype.slice.call(arguments));
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method before
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Matter.before = function(path, func) {
                    path = path.replace(/^Matter./, '');
                    return Common.chainPathBefore(Matter, path, func);
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method after
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Matter.after = function(path, func) {
                    path = path.replace(/^Matter./, '');
                    return Common.chainPathAfter(Matter, path, func);
                };
            })();
        /***/ },
        /* 1494 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Query` module contains methods for performing collision queries.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Query
*/ var Query = {};
            module1.exports = Query;
            var Vector = __webpack_require__(116);
            var SAT = __webpack_require__(588);
            var Bounds = __webpack_require__(117);
            var Bodies = __webpack_require__(126);
            var Vertices = __webpack_require__(94);
            (function() {
                /**
     * Returns a list of collisions between `body` and `bodies`.
     * @method collides
     * @param {body} body
     * @param {body[]} bodies
     * @return {object[]} Collisions
     */ Query.collides = function(body, bodies) {
                    var collisions = [];
                    for(var i = 0; i < bodies.length; i++){
                        var bodyA = bodies[i];
                        //  Phaser addition - skip same body checks
                        if (body === bodyA) continue;
                        if (Bounds.overlaps(bodyA.bounds, body.bounds)) for(var j = bodyA.parts.length === 1 ? 0 : 1; j < bodyA.parts.length; j++){
                            var part = bodyA.parts[j];
                            if (Bounds.overlaps(part.bounds, body.bounds)) {
                                var collision = SAT.collides(part, body);
                                if (collision.collided) {
                                    collisions.push(collision);
                                    break;
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
     * @method ray
     * @param {body[]} bodies
     * @param {vector} startPoint
     * @param {vector} endPoint
     * @param {number} [rayWidth]
     * @return {object[]} Collisions
     */ Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
                    rayWidth = rayWidth || 1e-100;
                    var rayAngle = Vector.angle(startPoint, endPoint), rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)), rayX = (endPoint.x + startPoint.x) * 0.5, rayY = (endPoint.y + startPoint.y) * 0.5, ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, {
                        angle: rayAngle
                    }), collisions = Query.collides(ray, bodies);
                    for(var i = 0; i < collisions.length; i += 1){
                        var collision = collisions[i];
                        collision.body = collision.bodyB = collision.bodyA;
                    }
                    return collisions;
                };
                /**
     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
     * @method region
     * @param {body[]} bodies
     * @param {bounds} bounds
     * @param {bool} [outside=false]
     * @return {body[]} The bodies matching the query
     */ Query.region = function(bodies, bounds, outside) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], overlaps = Bounds.overlaps(body.bounds, bounds);
                        if (overlaps && !outside || !overlaps && outside) result.push(body);
                    }
                    return result;
                };
                /**
     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
     * @method point
     * @param {body[]} bodies
     * @param {vector} point
     * @return {body[]} The bodies matching the query
     */ Query.point = function(bodies, point) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (Bounds.contains(body.bounds, point)) for(var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++){
                            var part = body.parts[j];
                            if (Bounds.contains(part.bounds, point) && Vertices.contains(part.vertices, point)) {
                                result.push(body);
                                break;
                            }
                        }
                    }
                    return result;
                };
            })();
        /***/ },
        /* 1495 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Engine` module contains methods for creating and manipulating engines.
* An engine is a controller that manages updating the simulation of the world.
* See `Matter.Runner` for an optional game loop utility.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Engine
*/ var Engine = {};
            module1.exports = Engine;
            var World = __webpack_require__(1393);
            var Sleeping = __webpack_require__(267);
            var Resolver = __webpack_require__(1396);
            var Pairs = __webpack_require__(1395);
            var Metrics = __webpack_require__(1528);
            var Grid = __webpack_require__(1394);
            var Events = __webpack_require__(268);
            var Composite = __webpack_require__(163);
            var Constraint = __webpack_require__(246);
            var Common = __webpack_require__(50);
            var Body = __webpack_require__(71);
            (function() {
                /**
     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {engine} engine
     */ Engine.create = function(element, options) {
                    // options may be passed as the first (and only) argument
                    options = Common.isElement(element) ? options : element;
                    element = Common.isElement(element) ? element : null;
                    options = options || {};
                    if (element || options.render) Common.warn('Engine.create: engine.render is deprecated (see docs)');
                    var defaults = {
                        positionIterations: 6,
                        velocityIterations: 4,
                        constraintIterations: 2,
                        enableSleeping: false,
                        events: [],
                        plugin: {},
                        timing: {
                            timestamp: 0,
                            timeScale: 1
                        },
                        broadphase: {
                            controller: Grid
                        }
                    };
                    var engine = Common.extend(defaults, options);
                    engine.world = options.world || World.create(engine.world);
                    engine.pairs = Pairs.create();
                    engine.broadphase = engine.broadphase.controller.create(engine.broadphase);
                    engine.metrics = engine.metrics || {
                        extended: false
                    };
                    // @if DEBUG
                    engine.metrics = Metrics.create(engine.metrics);
                    // @endif
                    return engine;
                };
                /**
     * Moves the simulation forward in time by `delta` ms.
     * The `correction` argument is an optional `Number` that specifies the time correction factor to apply to the update.
     * This can help improve the accuracy of the simulation in cases where `delta` is changing between updates.
     * The value of `correction` is defined as `delta / lastDelta`, i.e. the percentage change of `delta` over the last step.
     * Therefore the value is always `1` (no correction) when `delta` constant (or when no correction is desired, which is the default).
     * See the paper on <a href="http://lonesock.net/article/verlet.html">Time Corrected Verlet</a> for more information.
     *
     * Triggers `beforeUpdate` and `afterUpdate` events.
     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * @method update
     * @param {engine} engine
     * @param {number} [delta=16.666]
     * @param {number} [correction=1]
     */ Engine.update = function(engine, delta, correction) {
                    delta = delta || 1000 / 60;
                    correction = correction || 1;
                    var world = engine.world, timing = engine.timing, broadphase = engine.broadphase, broadphasePairs = [], i;
                    // increment timestamp
                    timing.timestamp += delta * timing.timeScale;
                    // create an event object
                    var event = {
                        timestamp: timing.timestamp
                    };
                    Events.trigger(engine, 'beforeUpdate', event);
                    // get lists of all bodies and constraints, no matter what composites they are in
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world);
                    // @if DEBUG
                    // reset metrics logging
                    Metrics.reset(engine.metrics);
                    // @endif
                    // if sleeping enabled, call the sleeping controller
                    if (engine.enableSleeping) Sleeping.update(allBodies, timing.timeScale);
                    // applies gravity to all bodies
                    Engine._bodiesApplyGravity(allBodies, world.gravity);
                    // update all body position and rotation by integration
                    Engine._bodiesUpdate(allBodies, delta, timing.timeScale, correction, world.bounds);
                    // update all constraints (first pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // broadphase pass: find potential collision pairs
                    if (broadphase.controller) {
                        // if world is dirty, we must flush the whole grid
                        if (world.isModified) broadphase.controller.clear(broadphase);
                        // update the grid buckets based on current bodies
                        broadphase.controller.update(broadphase, allBodies, engine, world.isModified);
                        broadphasePairs = broadphase.pairsList;
                    } else // if no broadphase set, we just pass all bodies
                    broadphasePairs = allBodies;
                    // clear all composite modified flags
                    if (world.isModified) Composite.setModified(world, false, false, true);
                    // narrowphase pass: find actual collisions, then create or update collision pairs
                    var collisions = broadphase.detector(broadphasePairs, engine);
                    // update collision pairs
                    var pairs = engine.pairs, timestamp = timing.timestamp;
                    Pairs.update(pairs, collisions, timestamp);
                    Pairs.removeOld(pairs, timestamp);
                    // wake up bodies involved in collisions
                    if (engine.enableSleeping) Sleeping.afterCollisions(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionStart.length > 0) Events.trigger(engine, 'collisionStart', {
                        pairs: pairs.collisionStart
                    });
                    // iteratively resolve position between collisions
                    Resolver.preSolvePosition(pairs.list);
                    for(i = 0; i < engine.positionIterations; i++)Resolver.solvePosition(pairs.list, allBodies, timing.timeScale);
                    Resolver.postSolvePosition(allBodies);
                    // update all constraints (second pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, timing.timeScale);
                    Constraint.postSolveAll(allBodies);
                    // iteratively resolve velocity between collisions
                    Resolver.preSolveVelocity(pairs.list);
                    for(i = 0; i < engine.velocityIterations; i++)Resolver.solveVelocity(pairs.list, timing.timeScale);
                    // trigger collision events
                    if (pairs.collisionActive.length > 0) Events.trigger(engine, 'collisionActive', {
                        pairs: pairs.collisionActive
                    });
                    if (pairs.collisionEnd.length > 0) Events.trigger(engine, 'collisionEnd', {
                        pairs: pairs.collisionEnd
                    });
                    // @if DEBUG
                    // update metrics log
                    Metrics.update(engine.metrics, engine);
                    // @endif
                    // clear force buffers
                    Engine._bodiesClearForces(allBodies);
                    Events.trigger(engine, 'afterUpdate', event);
                    return engine;
                };
                /**
     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
     * @method merge
     * @param {engine} engineA
     * @param {engine} engineB
     */ Engine.merge = function(engineA, engineB) {
                    Common.extend(engineA, engineB);
                    if (engineB.world) {
                        engineA.world = engineB.world;
                        Engine.clear(engineA);
                        var bodies = Composite.allBodies(engineA.world);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            Sleeping.set(body, false);
                            body.id = Common.nextId();
                        }
                    }
                };
                /**
     * Clears the engine including the world, pairs and broadphase.
     * @method clear
     * @param {engine} engine
     */ Engine.clear = function(engine) {
                    var world = engine.world;
                    Pairs.clear(engine.pairs);
                    var broadphase = engine.broadphase;
                    if (broadphase.controller) {
                        var bodies = Composite.allBodies(world);
                        broadphase.controller.clear(broadphase);
                        broadphase.controller.update(broadphase, bodies, engine, true);
                    }
                };
                /**
     * Zeroes the `body.force` and `body.torque` force buffers.
     * @method _bodiesClearForces
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesClearForces = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        // reset force buffers
                        body.force.x = 0;
                        body.force.y = 0;
                        body.torque = 0;
                    }
                };
                /**
     * Applys a mass dependant force to all given bodies.
     * @method _bodiesApplyGravity
     * @private
     * @param {body[]} bodies
     * @param {vector} gravity
     */ Engine._bodiesApplyGravity = function(bodies, gravity) {
                    var gravityScale = typeof gravity.scale !== 'undefined' ? gravity.scale : 0.001;
                    if (gravity.x === 0 && gravity.y === 0 || gravityScale === 0) return;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.ignoreGravity || body.isStatic || body.isSleeping) continue;
                        // apply gravity
                        body.force.x += body.mass * gravity.x * gravityScale * body.gravityScale.x;
                        body.force.y += body.mass * gravity.y * gravityScale * body.gravityScale.y;
                    }
                };
                /**
     * Applys `Body.update` to all given `bodies`.
     * @method _bodiesUpdate
     * @private
     * @param {body[]} bodies
     * @param {number} deltaTime 
     * The amount of time elapsed between updates
     * @param {number} timeScale
     * @param {number} correction 
     * The Verlet correction factor (deltaTime / lastDeltaTime)
     * @param {bounds} worldBounds
     */ Engine._bodiesUpdate = function(bodies, deltaTime, timeScale, correction, worldBounds) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        Body.update(body, deltaTime, timeScale, correction);
                    }
                };
            /**
     * An alias for `Runner.run`, see `Matter.Runner` for more information.
     * @method run
     * @param {engine} engine
     */ /**
    * Fired just before an update
    *
    * @event beforeUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update and all collision events
    *
    * @event afterUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
    *
    * @event collisionStart
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
    *
    * @event collisionActive
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
    *
    * @event collisionEnd
    * @param {} event An event object
    * @param {} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` that specifies the number of position iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property positionIterations
     * @type number
     * @default 6
     */ /**
     * An integer `Number` that specifies the number of velocity iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property velocityIterations
     * @type number
     * @default 4
     */ /**
     * An integer `Number` that specifies the number of constraint iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     * The default value of `2` is usually very adequate.
     *
     * @property constraintIterations
     * @type number
     * @default 2
     */ /**
     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
     * Sleeping can improve stability and performance, but often at the expense of accuracy.
     *
     * @property enableSleeping
     * @type boolean
     * @default false
     */ /**
     * An `Object` containing properties regarding the timing systems of the engine. 
     *
     * @property timing
     * @type object
     */ /**
     * A `Number` that specifies the global scaling factor of time for all bodies.
     * A value of `0` freezes the simulation.
     * A value of `0.1` gives a slow-motion effect.
     * A value of `1.2` gives a speed-up effect.
     *
     * @property timing.timeScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
     * It is incremented on every `Engine.update` by the given `delta` argument. 
     *
     * @property timing.timestamp
     * @type number
     * @default 0
     */ /**
     * An instance of a `Render` controller. The default value is a `Matter.Render` instance created by `Engine.create`.
     * One may also develop a custom renderer module based on `Matter.Render` and pass an instance of it to `Engine.create` via `options.render`.
     *
     * A minimal custom renderer object must define at least three functions: `create`, `clear` and `world` (see `Matter.Render`).
     * It is also possible to instead pass the _module_ reference via `options.render.controller` and `Engine.create` will instantiate one for you.
     *
     * @property render
     * @type render
     * @deprecated see Demo.js for an example of creating a renderer
     * @default a Matter.Render instance
     */ /**
     * An instance of a broadphase controller. The default value is a `Matter.Grid` instance created by `Engine.create`.
     *
     * @property broadphase
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * A `World` composite object that will contain all simulated bodies and constraints.
     *
     * @property world
     * @type world
     * @default a Matter.World instance
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 1496 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            var Class = __webpack_require__(0);
            var Common = __webpack_require__(50);
            var Composite = __webpack_require__(163);
            var Engine = __webpack_require__(1495);
            var EventEmitter = __webpack_require__(9);
            var Events = __webpack_require__(586);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var MatterBody = __webpack_require__(71);
            var MatterEvents = __webpack_require__(268);
            var MatterTileBody = __webpack_require__(1390);
            var MatterWorld = __webpack_require__(1393);
            var Vector = __webpack_require__(116);
            /**
 * @classdesc
 * The Matter World class is responsible for managing one single instance of a Matter Physics World for Phaser.
 * 
 * Access this via `this.matter.world` from within a Scene.
 * 
 * This class creates a Matter JS World Composite along with the Matter JS Engine during instantiation. It also
 * handles delta timing, bounds, body and constraint creation and debug drawing.
 * 
 * If you wish to access the Matter JS World object directly, see the `localWorld` property.
 * If you wish to access the Matter Engine directly, see the `engine` property.
 * 
 * This class is an Event Emitter and will proxy _all_ Matter JS events, as they are received.
 *
 * @class World
 * @extends Phaser.Events.EventEmitter
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Scene to which this Matter World instance belongs.
 * @param {Phaser.Types.Physics.Matter.MatterWorldConfig} config - The Matter World configuration object.
 */ var World = new Class({
                Extends: EventEmitter,
                initialize: function World(scene, config) {
                    EventEmitter.call(this);
                    /**
         * The Scene to which this Matter World instance belongs.
         *
         * @name Phaser.Physics.Matter.World#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * An instance of the MatterJS Engine.
         *
         * @name Phaser.Physics.Matter.World#engine
         * @type {MatterJS.Engine}
         * @since 3.0.0
         */ this.engine = Engine.create(config);
                    /**
         * A `World` composite object that will contain all simulated bodies and constraints.
         *
         * @name Phaser.Physics.Matter.World#localWorld
         * @type {MatterJS.World}
         * @since 3.0.0
         */ this.localWorld = this.engine.world;
                    var gravity = GetValue(config, 'gravity', null);
                    if (gravity) this.setGravity(gravity.x, gravity.y, gravity.scale);
                    else if (gravity === false) this.setGravity(0, 0, 0);
                    /**
         * An object containing the 4 wall bodies that bound the physics world.
         *
         * @name Phaser.Physics.Matter.World#walls
         * @type {object}
         * @since 3.0.0
         */ this.walls = {
                        left: null,
                        right: null,
                        top: null,
                        bottom: null
                    };
                    /**
         * A flag that toggles if the world is enabled or not.
         *
         * @name Phaser.Physics.Matter.World#enabled
         * @type {boolean}
         * @default true
         * @since 3.0.0
         */ this.enabled = GetValue(config, 'enabled', true);
                    /**
         * The correction argument is an optional Number that specifies the time correction factor to apply to the update.
         * This can help improve the accuracy of the simulation in cases where delta is changing between updates.
         * The value of correction is defined as delta / lastDelta, i.e. the percentage change of delta over the last step.
         * Therefore the value is always 1 (no correction) when delta is constant (or when no correction is desired, which is the default).
         * See the paper on Time Corrected Verlet for more information.
         *
         * @name Phaser.Physics.Matter.World#correction
         * @type {number}
         * @default 1
         * @since 3.4.0
         */ this.correction = GetValue(config, 'correction', 1);
                    /**
         * This function is called every time the core game loop steps, which is bound to the
         * Request Animation Frame frequency unless otherwise modified.
         * 
         * The function is passed two values: `time` and `delta`, both of which come from the game step values.
         * 
         * It must return a number. This number is used as the delta value passed to Matter.Engine.update.
         * 
         * You can override this function with your own to define your own timestep.
         * 
         * If you need to update the Engine multiple times in a single game step then call
         * `World.update` as many times as required. Each call will trigger the `getDelta` function.
         * If you wish to have full control over when the Engine updates then see the property `autoUpdate`.
         *
         * You can also adjust the number of iterations that Engine.update performs.
         * Use the Scene Matter Physics config object to set the following properties:
         *
         * positionIterations (defaults to 6)
         * velocityIterations (defaults to 4)
         * constraintIterations (defaults to 2)
         *
         * Adjusting these values can help performance in certain situations, depending on the physics requirements
         * of your game.
         *
         * @name Phaser.Physics.Matter.World#getDelta
         * @type {function}
         * @since 3.4.0
         */ this.getDelta = GetValue(config, 'getDelta', this.update60Hz);
                    var runnerConfig = GetFastValue(config, 'runner', {});
                    var hasFPS = GetFastValue(runnerConfig, 'fps', false);
                    var fps = GetFastValue(runnerConfig, 'fps', 60);
                    var delta = GetFastValue(runnerConfig, 'delta', 1000 / fps);
                    var deltaMin = GetFastValue(runnerConfig, 'deltaMin', 1000 / fps);
                    var deltaMax = GetFastValue(runnerConfig, 'deltaMax', 1000 / (fps * 0.5));
                    if (!hasFPS) fps = 1000 / delta;
                    /**
         * The Matter JS Runner Configuration object.
         * 
         * This object is populated via the Matter Configuration object's `runner` property and is
         * updated constantly during the game step.
         *
         * @name Phaser.Physics.Matter.World#runner
         * @type {Phaser.Types.Physics.Matter.MatterRunnerConfig}
         * @since 3.22.0
         */ this.runner = {
                        fps: fps,
                        correction: GetFastValue(runnerConfig, 'correction', 1),
                        deltaSampleSize: GetFastValue(runnerConfig, 'deltaSampleSize', 60),
                        counterTimestamp: 0,
                        frameCounter: 0,
                        deltaHistory: [],
                        timePrev: null,
                        timeScalePrev: 1,
                        frameRequestId: null,
                        isFixed: GetFastValue(runnerConfig, 'isFixed', false),
                        delta: delta,
                        deltaMin: deltaMin,
                        deltaMax: deltaMax
                    };
                    /**
         * Automatically call Engine.update every time the game steps.
         * If you disable this then you are responsible for calling `World.step` directly from your game.
         * If you call `set60Hz` or `set30Hz` then `autoUpdate` is reset to `true`.
         *
         * @name Phaser.Physics.Matter.World#autoUpdate
         * @type {boolean}
         * @default true
         * @since 3.4.0
         */ this.autoUpdate = GetValue(config, 'autoUpdate', true);
                    var debugConfig = GetValue(config, 'debug', false);
                    /**
         * A flag that controls if the debug graphics will be drawn to or not.
         *
         * @name Phaser.Physics.Matter.World#drawDebug
         * @type {boolean}
         * @default false
         * @since 3.0.0
         */ this.drawDebug = typeof debugConfig === 'object' ? true : debugConfig;
                    /**
         * An instance of the Graphics object the debug bodies are drawn to, if enabled.
         *
         * @name Phaser.Physics.Matter.World#debugGraphic
         * @type {Phaser.GameObjects.Graphics}
         * @since 3.0.0
         */ this.debugGraphic;
                    /**
         * The debug configuration object.
         * 
         * The values stored in this object are read from the Matter World Config `debug` property.
         * 
         * When a new Body or Constraint is _added to the World_, they are given the values stored in this object,
         * unless they have their own `render` object set that will override them.
         * 
         * Note that while you can modify the values of properties in this object at run-time, it will not change
         * any of the Matter objects _already added_. It will only impact objects newly added to the world, or one
         * that is removed and then re-added at a later time.
         *
         * @name Phaser.Physics.Matter.World#debugConfig
         * @type {Phaser.Types.Physics.Matter.MatterDebugConfig}
         * @since 3.22.0
         */ this.debugConfig = {
                        showAxes: GetFastValue(debugConfig, 'showAxes', false),
                        showAngleIndicator: GetFastValue(debugConfig, 'showAngleIndicator', false),
                        angleColor: GetFastValue(debugConfig, 'angleColor', 0xe81153),
                        showBroadphase: GetFastValue(debugConfig, 'showBroadphase', false),
                        broadphaseColor: GetFastValue(debugConfig, 'broadphaseColor', 0xffb400),
                        showBounds: GetFastValue(debugConfig, 'showBounds', false),
                        boundsColor: GetFastValue(debugConfig, 'boundsColor', 0xffffff),
                        showVelocity: GetFastValue(debugConfig, 'showVelocity', false),
                        velocityColor: GetFastValue(debugConfig, 'velocityColor', 0x00aeef),
                        showCollisions: GetFastValue(debugConfig, 'showCollisions', false),
                        collisionColor: GetFastValue(debugConfig, 'collisionColor', 0xf5950c),
                        showSeparations: GetFastValue(debugConfig, 'showSeparations', false),
                        separationColor: GetFastValue(debugConfig, 'separationColor', 0xffa500),
                        showBody: GetFastValue(debugConfig, 'showBody', true),
                        showStaticBody: GetFastValue(debugConfig, 'showStaticBody', true),
                        showInternalEdges: GetFastValue(debugConfig, 'showInternalEdges', false),
                        renderFill: GetFastValue(debugConfig, 'renderFill', false),
                        renderLine: GetFastValue(debugConfig, 'renderLine', true),
                        fillColor: GetFastValue(debugConfig, 'fillColor', 0x106909),
                        fillOpacity: GetFastValue(debugConfig, 'fillOpacity', 1),
                        lineColor: GetFastValue(debugConfig, 'lineColor', 0x28de19),
                        lineOpacity: GetFastValue(debugConfig, 'lineOpacity', 1),
                        lineThickness: GetFastValue(debugConfig, 'lineThickness', 1),
                        staticFillColor: GetFastValue(debugConfig, 'staticFillColor', 0x0d177b),
                        staticLineColor: GetFastValue(debugConfig, 'staticLineColor', 0x1327e4),
                        showSleeping: GetFastValue(debugConfig, 'showSleeping', false),
                        staticBodySleepOpacity: GetFastValue(debugConfig, 'staticBodySleepOpacity', 0.7),
                        sleepFillColor: GetFastValue(debugConfig, 'sleepFillColor', 0x464646),
                        sleepLineColor: GetFastValue(debugConfig, 'sleepLineColor', 0x999a99),
                        showSensors: GetFastValue(debugConfig, 'showSensors', true),
                        sensorFillColor: GetFastValue(debugConfig, 'sensorFillColor', 0x0d177b),
                        sensorLineColor: GetFastValue(debugConfig, 'sensorLineColor', 0x1327e4),
                        showPositions: GetFastValue(debugConfig, 'showPositions', true),
                        positionSize: GetFastValue(debugConfig, 'positionSize', 4),
                        positionColor: GetFastValue(debugConfig, 'positionColor', 0xe042da),
                        showJoint: GetFastValue(debugConfig, 'showJoint', true),
                        jointColor: GetFastValue(debugConfig, 'jointColor', 0xe0e042),
                        jointLineOpacity: GetFastValue(debugConfig, 'jointLineOpacity', 1),
                        jointLineThickness: GetFastValue(debugConfig, 'jointLineThickness', 2),
                        pinSize: GetFastValue(debugConfig, 'pinSize', 4),
                        pinColor: GetFastValue(debugConfig, 'pinColor', 0x42e0e0),
                        springColor: GetFastValue(debugConfig, 'springColor', 0xe042e0),
                        anchorColor: GetFastValue(debugConfig, 'anchorColor', 0xefefef),
                        anchorSize: GetFastValue(debugConfig, 'anchorSize', 4),
                        showConvexHulls: GetFastValue(debugConfig, 'showConvexHulls', false),
                        hullColor: GetFastValue(debugConfig, 'hullColor', 0xd703d0)
                    };
                    if (this.drawDebug) this.createDebugGraphic();
                    this.setEventsProxy();
                    //  Create the walls
                    if (GetFastValue(config, 'setBounds', false)) {
                        var boundsConfig = config['setBounds'];
                        if (typeof boundsConfig === 'boolean') this.setBounds();
                        else {
                            var x = GetFastValue(boundsConfig, 'x', 0);
                            var y = GetFastValue(boundsConfig, 'y', 0);
                            var width = GetFastValue(boundsConfig, 'width', scene.sys.scale.width);
                            var height = GetFastValue(boundsConfig, 'height', scene.sys.scale.height);
                            var thickness = GetFastValue(boundsConfig, 'thickness', 64);
                            var left = GetFastValue(boundsConfig, 'left', true);
                            var right = GetFastValue(boundsConfig, 'right', true);
                            var top = GetFastValue(boundsConfig, 'top', true);
                            var bottom = GetFastValue(boundsConfig, 'bottom', true);
                            this.setBounds(x, y, width, height, thickness, left, right, top, bottom);
                        }
                    }
                },
                /**
     * Sets the debug render style for the children of the given Matter Composite.
     * 
     * Composites themselves do not render, but they can contain bodies, constraints and other composites that may do.
     * So the children of this composite are passed to the `setBodyRenderStyle`, `setCompositeRenderStyle` and
     * `setConstraintRenderStyle` methods accordingly.
     * 
     * @method Phaser.Physics.Matter.World#setCompositeRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.CompositeType} composite - The Matter Composite to set the render style on.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setCompositeRenderStyle: function(composite) {
                    var bodies = composite.bodies;
                    var constraints = composite.constraints;
                    var composites = composite.composites;
                    var i;
                    var obj;
                    var render;
                    for(i = 0; i < bodies.length; i++){
                        obj = bodies[i];
                        render = obj.render;
                        this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                    }
                    for(i = 0; i < constraints.length; i++){
                        obj = constraints[i];
                        render = obj.render;
                        this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                    }
                    for(i = 0; i < composites.length; i++){
                        obj = composites[i];
                        this.setCompositeRenderStyle(obj);
                    }
                    return this;
                },
                /**
     * Sets the debug render style for the given Matter Body.
     * 
     * If you are using this on a Phaser Game Object, such as a Matter Sprite, then pass in the body property
     * to this method, not the Game Object itself.
     * 
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     * 
     * If you wish to reset the Body render colors to the defaults found in the World Debug Config, then call
     * this method with just the `body` parameter provided and no others.
     * 
     * @method Phaser.Physics.Matter.World#setBodyRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.BodyType} body - The Matter Body to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [fillColor] - The fill color. If `null` it will use the World Debug Config value.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setBodyRenderStyle: function(body, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                    var render = body.render;
                    var config = this.debugConfig;
                    if (!render) return this;
                    if (lineColor === undefined || lineColor === null) lineColor = body.isStatic ? config.staticLineColor : config.lineColor;
                    if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.lineOpacity;
                    if (lineThickness === undefined || lineThickness === null) lineThickness = config.lineThickness;
                    if (fillColor === undefined || fillColor === null) fillColor = body.isStatic ? config.staticFillColor : config.fillColor;
                    if (fillOpacity === undefined || fillOpacity === null) fillOpacity = config.fillOpacity;
                    if (lineColor !== false) render.lineColor = lineColor;
                    if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                    if (lineThickness !== false) render.lineThickness = lineThickness;
                    if (fillColor !== false) render.fillColor = fillColor;
                    if (fillOpacity !== false) render.fillOpacity = fillOpacity;
                    return this;
                },
                /**
     * Sets the debug render style for the given Matter Constraint.
     * 
     * If you are using this on a Phaser Game Object, then pass in the body property
     * to this method, not the Game Object itself.
     * 
     * If you wish to skip a parameter, so it retains its current value, pass `false` for it.
     * 
     * If you wish to reset the Constraint render colors to the defaults found in the World Debug Config, then call
     * this method with just the `constraint` parameter provided and no others.
     * 
     * @method Phaser.Physics.Matter.World#setConstraintRenderStyle
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to set the render style on.
     * @param {number} [lineColor] - The line color. If `null` it will use the World Debug Config value.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1. If `null` it will use the World Debug Config value.
     * @param {number} [lineThickness] - The line thickness. If `null` it will use the World Debug Config value.
     * @param {number} [pinSize] - If this constraint is a pin, this sets the size of the pin circle. If `null` it will use the World Debug Config value.
     * @param {number} [anchorColor] - The color used when rendering this constraints anchors.  If `null` it will use the World Debug Config value.
     * @param {number} [anchorSize] - The size of the anchor circle, if this constraint has anchors. If `null` it will use the World Debug Config value.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ setConstraintRenderStyle: function(constraint, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                    var render = constraint.render;
                    var config = this.debugConfig;
                    if (!render) return this;
                    //  Reset them
                    if (lineColor === undefined || lineColor === null) {
                        var type = render.type;
                        if (type === 'line') lineColor = config.jointColor;
                        else if (type === 'pin') lineColor = config.pinColor;
                        else if (type === 'spring') lineColor = config.springColor;
                    }
                    if (lineOpacity === undefined || lineOpacity === null) lineOpacity = config.jointLineOpacity;
                    if (lineThickness === undefined || lineThickness === null) lineThickness = config.jointLineThickness;
                    if (pinSize === undefined || pinSize === null) pinSize = config.pinSize;
                    if (anchorColor === undefined || anchorColor === null) anchorColor = config.anchorColor;
                    if (anchorSize === undefined || anchorSize === null) anchorSize = config.anchorSize;
                    if (lineColor !== false) render.lineColor = lineColor;
                    if (lineOpacity !== false) render.lineOpacity = lineOpacity;
                    if (lineThickness !== false) render.lineThickness = lineThickness;
                    if (pinSize !== false) render.pinSize = pinSize;
                    if (anchorColor !== false) render.anchorColor = anchorColor;
                    if (anchorSize !== false) render.anchorSize = anchorSize;
                    return this;
                },
                /**
     * This internal method acts as a proxy between all of the Matter JS events and then re-emits them
     * via this class.
     *
     * @method Phaser.Physics.Matter.World#setEventsProxy
     * @since 3.0.0
     */ setEventsProxy: function() {
                    var _this = this;
                    var engine = this.engine;
                    var world = this.localWorld;
                    //  Inject debug styles
                    if (this.drawDebug) {
                        MatterEvents.on(world, 'compositeModified', function(composite) {
                            _this.setCompositeRenderStyle(composite);
                        });
                        MatterEvents.on(world, 'beforeAdd', function(event) {
                            var objects = [].concat(event.object);
                            for(var i = 0; i < objects.length; i++){
                                var obj = objects[i];
                                var render = obj.render;
                                if (obj.type === 'body') _this.setBodyRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.fillColor, render.fillOpacity);
                                else if (obj.type === 'composite') _this.setCompositeRenderStyle(obj);
                                else if (obj.type === 'constraint') _this.setConstraintRenderStyle(obj, render.lineColor, render.lineOpacity, render.lineThickness, render.pinSize, render.anchorColor, render.anchorSize);
                            }
                        });
                    }
                    MatterEvents.on(world, 'beforeAdd', function(event) {
                        _this.emit(Events.BEFORE_ADD, event);
                    });
                    MatterEvents.on(world, 'afterAdd', function(event) {
                        _this.emit(Events.AFTER_ADD, event);
                    });
                    MatterEvents.on(world, 'beforeRemove', function(event) {
                        _this.emit(Events.BEFORE_REMOVE, event);
                    });
                    MatterEvents.on(world, 'afterRemove', function(event) {
                        _this.emit(Events.AFTER_REMOVE, event);
                    });
                    MatterEvents.on(engine, 'beforeUpdate', function(event) {
                        _this.emit(Events.BEFORE_UPDATE, event);
                    });
                    MatterEvents.on(engine, 'afterUpdate', function(event) {
                        _this.emit(Events.AFTER_UPDATE, event);
                    });
                    MatterEvents.on(engine, 'collisionStart', function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_START, event, bodyA, bodyB);
                    });
                    MatterEvents.on(engine, 'collisionActive', function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_ACTIVE, event, bodyA, bodyB);
                    });
                    MatterEvents.on(engine, 'collisionEnd', function(event) {
                        var pairs = event.pairs;
                        var bodyA;
                        var bodyB;
                        if (pairs.length > 0) {
                            bodyA = pairs[0].bodyA;
                            bodyB = pairs[0].bodyB;
                        }
                        _this.emit(Events.COLLISION_END, event, bodyA, bodyB);
                    });
                },
                /**
     * Sets the bounds of the Physics world to match the given world pixel dimensions.
     * You can optionally set which 'walls' to create: left, right, top or bottom.
     * If none of the walls are given it will default to use the walls settings it had previously.
     * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
     * the newly created bounds will also not have the left and right walls.
     * Explicitly state them in the parameters to override this.
     *
     * @method Phaser.Physics.Matter.World#setBounds
     * @since 3.0.0
     *
     * @param {number} [x=0] - The x coordinate of the top-left corner of the bounds.
     * @param {number} [y=0] - The y coordinate of the top-left corner of the bounds.
     * @param {number} [width] - The width of the bounds.
     * @param {number} [height] - The height of the bounds.
     * @param {number} [thickness=64] - The thickness of each wall, in pixels.
     * @param {boolean} [left=true] - If true will create the left bounds wall.
     * @param {boolean} [right=true] - If true will create the right bounds wall.
     * @param {boolean} [top=true] - If true will create the top bounds wall.
     * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
     *
     * @return {Phaser.Physics.Matter.World} This Matter World object.
     */ setBounds: function(x, y, width, height, thickness, left, right, top, bottom) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 0;
                    if (width === undefined) width = this.scene.sys.scale.width;
                    if (height === undefined) height = this.scene.sys.scale.height;
                    if (thickness === undefined) thickness = 64;
                    if (left === undefined) left = true;
                    if (right === undefined) right = true;
                    if (top === undefined) top = true;
                    if (bottom === undefined) bottom = true;
                    this.updateWall(left, 'left', x - thickness, y - thickness, thickness, height + thickness * 2);
                    this.updateWall(right, 'right', x + width, y - thickness, thickness, height + thickness * 2);
                    this.updateWall(top, 'top', x, y - thickness, width, thickness);
                    this.updateWall(bottom, 'bottom', x, y + height, width, thickness);
                    return this;
                },
                /**
     * Updates the 4 rectangle bodies that were created, if `setBounds` was set in the Matter config, to use
     * the new positions and sizes. This method is usually only called internally via the `setBounds` method.
     *
     * @method Phaser.Physics.Matter.World#updateWall
     * @since 3.0.0
     *
     * @param {boolean} add - `true` if the walls are being added or updated, `false` to remove them from the world.
     * @param {string} [position] - Either `left`, `right`, `top` or `bottom`. Only optional if `add` is `false`.
     * @param {number} [x] - The horizontal position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [y] - The vertical position to place the walls at. Only optional if `add` is `false`.
     * @param {number} [width] - The width of the walls, in pixels. Only optional if `add` is `false`.
     * @param {number} [height] - The height of the walls, in pixels. Only optional if `add` is `false`.
     */ updateWall: function(add, position, x, y, width, height) {
                    var wall = this.walls[position];
                    if (add) {
                        if (wall) MatterWorld.remove(this.localWorld, wall);
                        //  adjust center
                        x += width / 2;
                        y += height / 2;
                        this.walls[position] = this.create(x, y, width, height, {
                            isStatic: true,
                            friction: 0,
                            frictionStatic: 0
                        });
                    } else {
                        if (wall) MatterWorld.remove(this.localWorld, wall);
                        this.walls[position] = null;
                    }
                },
                /**
     * Creates a Phaser.GameObjects.Graphics object that is used to render all of the debug bodies and joints to.
     * 
     * This method is called automatically by the constructor, if debugging has been enabled.
     * 
     * The created Graphics object is automatically added to the Scene at 0x0 and given a depth of `Number.MAX_VALUE`,
     * so it renders above all else in the Scene.
     * 
     * The Graphics object is assigned to the `debugGraphic` property of this class and `drawDebug` is enabled.
     *
     * @method Phaser.Physics.Matter.World#createDebugGraphic
     * @since 3.0.0
     *
     * @return {Phaser.GameObjects.Graphics} The newly created Graphics object.
     */ createDebugGraphic: function() {
                    var graphic = this.scene.sys.add.graphics({
                        x: 0,
                        y: 0
                    });
                    graphic.setDepth(Number.MAX_VALUE);
                    this.debugGraphic = graphic;
                    this.drawDebug = true;
                    return graphic;
                },
                /**
     * Sets the world gravity and gravity scale to 0.
     *
     * @method Phaser.Physics.Matter.World#disableGravity
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ disableGravity: function() {
                    this.localWorld.gravity.x = 0;
                    this.localWorld.gravity.y = 0;
                    this.localWorld.gravity.scale = 0;
                    return this;
                },
                /**
     * Sets the worlds gravity to the values given.
     * 
     * Gravity effects all bodies in the world, unless they have the `ignoreGravity` flag set.
     *
     * @method Phaser.Physics.Matter.World#setGravity
     * @since 3.0.0
     *
     * @param {number} [x=0] - The world gravity x component.
     * @param {number} [y=1] - The world gravity y component.
     * @param {number} [scale=0.001] - The gravity scale factor.
     *
     * @return {this} This Matter World object.
     */ setGravity: function(x, y, scale) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = 1;
                    this.localWorld.gravity.x = x;
                    this.localWorld.gravity.y = y;
                    if (scale !== undefined) this.localWorld.gravity.scale = scale;
                    return this;
                },
                /**
     * Creates a rectangle Matter body and adds it to the world.
     *
     * @method Phaser.Physics.Matter.World#create
     * @since 3.0.0
     *
     * @param {number} x - The horizontal position of the body in the world.
     * @param {number} y - The vertical position of the body in the world.
     * @param {number} width - The width of the body.
     * @param {number} height - The height of the body.
     * @param {object} options - Optional Matter configuration object.
     *
     * @return {MatterJS.BodyType} The Matter.js body that was created.
     */ create: function(x, y, width, height, options) {
                    var body = Bodies.rectangle(x, y, width, height, options);
                    MatterWorld.add(this.localWorld, body);
                    return body;
                },
                /**
     * Adds a Matter JS object, or array of objects, to the world.
     * 
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     * 
     * Triggers `beforeAdd` and `afterAdd` events.
     *
     * @method Phaser.Physics.Matter.World#add
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     *
     * @return {this} This Matter World object.
     */ add: function(object) {
                    MatterWorld.add(this.localWorld, object);
                    return this;
                },
                /**
     * Removes a Matter JS object, or array of objects, from the world.
     * 
     * The objects should be valid Matter JS entities, such as a Body, Composite or Constraint.
     * 
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#remove
     * @since 3.0.0
     *
     * @param {(object|object[])} object - Can be single object, or an array, and can be a body, composite or constraint.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ remove: function(object, deep) {
                    if (!Array.isArray(object)) object = [
                        object
                    ];
                    for(var i = 0; i < object.length; i++){
                        var entity = object[i];
                        var body = entity.body ? entity.body : entity;
                        Composite.remove(this.localWorld, body, deep);
                    }
                    return this;
                },
                /**
     * Removes a Matter JS constraint, or array of constraints, from the world.
     * 
     * Triggers `beforeRemove` and `afterRemove` events.
     *
     * @method Phaser.Physics.Matter.World#removeConstraint
     * @since 3.0.0
     *
     * @param {(MatterJS.ConstraintType|MatterJS.ConstraintType[])} constraint - A Matter JS Constraint, or an array of constraints, to be removed.
     * @param {boolean} [deep=false] - Optionally search the objects children and recursively remove those as well.
     *
     * @return {this} This Matter World object.
     */ removeConstraint: function(constraint, deep) {
                    Composite.remove(this.localWorld, constraint, deep);
                    return this;
                },
                /**
     * Adds `MatterTileBody` instances for all the colliding tiles within the given tilemap layer.
     * 
     * Set the appropriate tiles in your layer to collide before calling this method!
     *
     * @method Phaser.Physics.Matter.World#convertTilemapLayer
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.TilemapLayer} tilemapLayer - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTilemapLayer: function(tilemapLayer, options) {
                    var layerData = tilemapLayer.layer;
                    var tiles = tilemapLayer.getTilesWithin(0, 0, layerData.width, layerData.height, {
                        isColliding: true
                    });
                    this.convertTiles(tiles, options);
                    return this;
                },
                /**
     * Adds `MatterTileBody` instances for the given tiles. This adds bodies regardless of whether the
     * tiles are set to collide or not.
     *
     * @method Phaser.Physics.Matter.World#convertTiles
     * @since 3.0.0
     *
     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of tiles.
     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
     *
     * @return {this} This Matter World object.
     */ convertTiles: function(tiles, options) {
                    if (tiles.length === 0) return this;
                    for(var i = 0; i < tiles.length; i++)new MatterTileBody(this, tiles[i], options);
                    return this;
                },
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will not collide.
     *
     * @method Phaser.Physics.Matter.World#nextGroup
     * @since 3.0.0
     *
     * @param {boolean} [isNonColliding=false] - If `true`, returns the next unique group index for which bodies will _not_ collide.
     *
     * @return {number} Unique category bitfield
     */ nextGroup: function(isNonColliding) {
                    return MatterBody.nextGroup(isNonColliding);
                },
                /**
     * Returns the next unique category bitfield (starting after the initial default category 0x0001).
     * There are 32 available.
     *
     * @method Phaser.Physics.Matter.World#nextCategory
     * @since 3.0.0
     *
     * @return {number} Unique category bitfield
     */ nextCategory: function() {
                    return MatterBody.nextCategory();
                },
                /**
     * Pauses this Matter World instance and sets `enabled` to `false`.
     * 
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.World#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ pause: function() {
                    this.enabled = false;
                    this.emit(Events.PAUSE);
                    return this;
                },
                /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.World#resume
     * @fires Phaser.Physics.Matter.Events#RESUME
     * @since 3.0.0
     *
     * @return {this} This Matter World object.
     */ resume: function() {
                    this.enabled = true;
                    this.emit(Events.RESUME);
                    return this;
                },
                /**
     * The internal update method. This is called automatically by the parent Scene.
     * 
     * Moves the simulation forward in time by delta ms. Uses `World.correction` value as an optional number that
     * specifies the time correction factor to apply to the update. This can help improve the accuracy of the
     * simulation in cases where delta is changing between updates. The value of correction is defined as `delta / lastDelta`,
     * i.e. the percentage change of delta over the last step. Therefore the value is always 1 (no correction) when
     * delta is constant (or when no correction is desired, which is the default).
     * See the paper on Time Corrected Verlet for more information.
     * 
     * Triggers `beforeUpdate` and `afterUpdate` events. Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * 
     * If the World is paused, `update` is still run, but exits early and does not update the Matter Engine.
     *
     * @method Phaser.Physics.Matter.World#update
     * @since 3.0.0
     *
     * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
     * @param {number} delta - The delta time in ms since the last frame. This is a smoothed and capped value based on the FPS rate.
     */ update: function(time, delta) {
                    if (!this.enabled || !this.autoUpdate) return;
                    var engine = this.engine;
                    var runner = this.runner;
                    var timing = engine.timing;
                    var correction = this.correction;
                    if (runner.isFixed) //  fixed timestep
                    delta = this.getDelta(time, delta);
                    else {
                        //  dynamic timestep based on wall clock between calls
                        delta = time - runner.timePrev || runner.delta;
                        runner.timePrev = time;
                        // optimistically filter delta over a few frames, to improve stability
                        runner.deltaHistory.push(delta);
                        runner.deltaHistory = runner.deltaHistory.slice(-runner.deltaSampleSize);
                        delta = Math.min.apply(null, runner.deltaHistory);
                        // limit delta
                        delta = delta < runner.deltaMin ? runner.deltaMin : delta;
                        delta = delta > runner.deltaMax ? runner.deltaMax : delta;
                        // correction for delta
                        correction = delta / runner.delta;
                        // update engine timing object
                        runner.delta = delta;
                    }
                    // time correction for time scaling
                    if (runner.timeScalePrev !== 0) correction *= timing.timeScale / runner.timeScalePrev;
                    if (timing.timeScale === 0) correction = 0;
                    runner.timeScalePrev = timing.timeScale;
                    runner.correction = correction;
                    // fps counter
                    runner.frameCounter += 1;
                    if (time - runner.counterTimestamp >= 1000) {
                        runner.fps = runner.frameCounter * ((time - runner.counterTimestamp) / 1000);
                        runner.counterTimestamp = time;
                        runner.frameCounter = 0;
                    }
                    Engine.update(engine, delta, correction);
                },
                /**
     * Manually advances the physics simulation by one iteration.
     * 
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     * 
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     * 
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.World#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     * @param {number} [correction=1] - Optional delta correction value.
     */ step: function(delta, correction) {
                    Engine.update(this.engine, delta, correction);
                },
                /**
     * Runs the Matter Engine.update at a fixed timestep of 60Hz.
     *
     * @method Phaser.Physics.Matter.World#update60Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update60Hz: function() {
                    return 1000 / 60;
                },
                /**
     * Runs the Matter Engine.update at a fixed timestep of 30Hz.
     *
     * @method Phaser.Physics.Matter.World#update30Hz
     * @since 3.4.0
     *
     * @return {number} The delta value to be passed to Engine.update.
     */ update30Hz: function() {
                    return 1000 / 30;
                },
                /**
     * Returns `true` if the given body can be found within the World.
     *
     * @method Phaser.Physics.Matter.World#has
     * @since 3.22.0
     * 
     * @param {(MatterJS.Body|Phaser.GameObjects.GameObject)} body - The Matter Body, or Game Object, to search for within the world.
     * 
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ has: function(body) {
                    var src = body.hasOwnProperty('body') ? body.body : body;
                    return Composite.get(this.localWorld, src.id, src.type) !== null;
                },
                /**
     * Returns all the bodies in the Matter World, including all bodies in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllBodies
     * @since 3.22.0
     * 
     * @return {MatterJS.BodyType[]} An array of all the Matter JS Bodies in this World.
     */ getAllBodies: function() {
                    return Composite.allBodies(this.localWorld);
                },
                /**
     * Returns all the constraints in the Matter World, including all constraints in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllConstraints
     * @since 3.22.0
     * 
     * @return {MatterJS.ConstraintType[]} An array of all the Matter JS Constraints in this World.
     */ getAllConstraints: function() {
                    return Composite.allConstraints(this.localWorld);
                },
                /**
     * Returns all the composites in the Matter World, including all composites in children, recursively.
     *
     * @method Phaser.Physics.Matter.World#getAllComposites
     * @since 3.22.0
     * 
     * @return {MatterJS.CompositeType[]} An array of all the Matter JS Composites in this World.
     */ getAllComposites: function() {
                    return Composite.allComposites(this.localWorld);
                },
                /**
     * Handles the rendering of bodies and debug information to the debug Graphics object, if enabled.
     * 
     * This method is called automatically by the Scene after all processing has taken place.
     *
     * @method Phaser.Physics.Matter.World#postUpdate
     * @private
     * @since 3.0.0
     */ postUpdate: function() {
                    if (!this.drawDebug) return;
                    var config = this.debugConfig;
                    var engine = this.engine;
                    var graphics = this.debugGraphic;
                    var bodies = Composite.allBodies(this.localWorld);
                    this.debugGraphic.clear();
                    if (config.showBroadphase && engine.broadphase.controller) this.renderGrid(engine.broadphase, graphics, config.broadphaseColor, 0.5);
                    if (config.showBounds) this.renderBodyBounds(bodies, graphics, config.boundsColor, 0.5);
                    if (config.showBody || config.showStaticBody) this.renderBodies(bodies);
                    if (config.showJoint) this.renderJoints();
                    if (config.showAxes || config.showAngleIndicator) this.renderBodyAxes(bodies, graphics, config.showAxes, config.angleColor, 0.5);
                    if (config.showVelocity) this.renderBodyVelocity(bodies, graphics, config.velocityColor, 1, 2);
                    if (config.showSeparations) this.renderSeparations(engine.pairs.list, graphics, config.separationColor);
                    if (config.showCollisions) this.renderCollisions(engine.pairs.list, graphics, config.collisionColor);
                },
                /**
     * Renders the Engine Broadphase Controller Grid to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showBroadphase` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderGrid
     * @since 3.22.0
     * 
     * @param {MatterJS.Grid} grid - The Matter Grid to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderGrid: function(grid, graphics, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    var bucketKeys = Common.keys(grid.buckets);
                    for(var i = 0; i < bucketKeys.length; i++){
                        var bucketId = bucketKeys[i];
                        if (grid.buckets[bucketId].length < 2) continue;
                        var region = bucketId.split(/C|R/);
                        graphics.strokeRect(parseInt(region[1], 10) * grid.bucketWidth, parseInt(region[2], 10) * grid.bucketHeight, grid.bucketWidth, grid.bucketHeight);
                    }
                    return this;
                },
                /**
     * Renders the list of Pair separations to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showSeparations` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderSeparations
     * @since 3.22.0
     * 
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderSeparations: function(pairs, graphics, lineColor) {
                    graphics.lineStyle(1, lineColor, 1);
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        if (!pair.isActive) continue;
                        var collision = pair.collision;
                        var bodyA = collision.bodyA;
                        var bodyB = collision.bodyB;
                        var posA = bodyA.position;
                        var posB = bodyB.position;
                        var penetration = collision.penetration;
                        var k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                        if (bodyB.isStatic) k = 0;
                        graphics.lineBetween(posB.x, posB.y, posB.x - penetration.x * k, posB.y - penetration.y * k);
                        k = !bodyA.isStatic && !bodyB.isStatic ? 4 : 1;
                        if (bodyA.isStatic) k = 0;
                        graphics.lineBetween(posA.x, posA.y, posA.x - penetration.x * k, posA.y - penetration.y * k);
                    }
                    return this;
                },
                /**
     * Renders the list of collision points and normals to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showCollisions` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render the Grid to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderCollisions
     * @since 3.22.0
     * 
     * @param {MatterJS.Pair[]} pairs - An array of Matter Pairs to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderCollisions: function(pairs, graphics, lineColor) {
                    graphics.lineStyle(1, lineColor, 0.5);
                    graphics.fillStyle(lineColor, 1);
                    var i;
                    var pair;
                    //  Collision Positions
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        for(var j = 0; j < pair.activeContacts.length; j++){
                            var contact = pair.activeContacts[j];
                            var vertex = contact.vertex;
                            graphics.fillRect(vertex.x - 2, vertex.y - 2, 5, 5);
                        }
                    }
                    //  Collision Normals
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        var collision = pair.collision;
                        var contacts = pair.activeContacts;
                        if (contacts.length > 0) {
                            var normalPosX = contacts[0].vertex.x;
                            var normalPosY = contacts[0].vertex.y;
                            if (contacts.length === 2) {
                                normalPosX = (contacts[0].vertex.x + contacts[1].vertex.x) / 2;
                                normalPosY = (contacts[0].vertex.y + contacts[1].vertex.y) / 2;
                            }
                            if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic) graphics.lineBetween(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8, normalPosX, normalPosY);
                            else graphics.lineBetween(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8, normalPosX, normalPosY);
                        }
                    }
                    return this;
                },
                /**
     * Renders the bounds of an array of Bodies to the given Graphics instance.
     * 
     * If the body is a compound body, it will render the bounds for the parent compound.
     * 
     * The debug renderer calls this method if the `showBounds` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyBounds
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyBounds: function(bodies, graphics, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        var bounds = body.bounds;
                        if (bounds) graphics.strokeRect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
                        else {
                            var parts = body.parts;
                            for(var j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                var part = parts[j];
                                graphics.strokeRect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
                            }
                        }
                    }
                    return this;
                },
                /**
     * Renders either all axes, or a single axis indicator, for an array of Bodies, to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showAxes` or `showAngleIndicator` config values are set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyAxes
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showAxes - If `true` it will render all body axes. If `false` it will render a single axis indicator.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     */ renderBodyAxes: function(bodies, graphics, showAxes, lineColor, lineOpacity) {
                    graphics.lineStyle(1, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        var parts = body.parts;
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        var part;
                        var j;
                        var k;
                        if (showAxes) for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                var axis = part.axes[k];
                                graphics.lineBetween(part.position.x, part.position.y, part.position.x + axis.x * 20, part.position.y + axis.y * 20);
                            }
                        }
                        else for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++)graphics.lineBetween(part.position.x, part.position.y, (part.vertices[0].x + part.vertices[part.vertices.length - 1].x) / 2, (part.vertices[0].y + part.vertices[part.vertices.length - 1].y) / 2);
                        }
                    }
                    return this;
                },
                /**
     * Renders a velocity indicator for an array of Bodies, to the given Graphics instance.
     * 
     * The debug renderer calls this method if the `showVelocity` config value is set.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render bounds to your own Graphics instance.
     *
     * @method Phaser.Physics.Matter.World#renderBodyVelocity
     * @since 3.22.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     */ renderBodyVelocity: function(bodies, graphics, lineColor, lineOpacity, lineThickness) {
                    graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        graphics.lineBetween(body.position.x, body.position.y, body.position.x + (body.position.x - body.positionPrev.x) * 2, body.position.y + (body.position.y - body.positionPrev.y) * 2);
                    }
                    return this;
                },
                /**
     * Renders the given array of Bodies to the debug graphics instance.
     * 
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderBodies
     * @private
     * @since 3.14.0
     * 
     * @param {array} bodies - An array of bodies from the localWorld.
     */ renderBodies: function(bodies) {
                    var graphics = this.debugGraphic;
                    var config = this.debugConfig;
                    var showBody = config.showBody;
                    var showStaticBody = config.showStaticBody;
                    var showSleeping = config.showSleeping;
                    var showInternalEdges = config.showInternalEdges;
                    var showConvexHulls = config.showConvexHulls;
                    var renderFill = config.renderFill;
                    var renderLine = config.renderLine;
                    var staticBodySleepOpacity = config.staticBodySleepOpacity;
                    var sleepFillColor = config.sleepFillColor;
                    var sleepLineColor = config.sleepLineColor;
                    var hullColor = config.hullColor;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        //  1) Don't show invisible bodies
                        if (!body.render.visible) continue;
                        //  2) Don't show static bodies, OR
                        //  3) Don't show dynamic bodies
                        if (!showStaticBody && body.isStatic || !showBody && !body.isStatic) continue;
                        var lineColor = body.render.lineColor;
                        var lineOpacity = body.render.lineOpacity;
                        var lineThickness = body.render.lineThickness;
                        var fillColor = body.render.fillColor;
                        var fillOpacity = body.render.fillOpacity;
                        if (showSleeping && body.isSleeping) {
                            if (body.isStatic) {
                                lineOpacity *= staticBodySleepOpacity;
                                fillOpacity *= staticBodySleepOpacity;
                            } else {
                                lineColor = sleepLineColor;
                                fillColor = sleepFillColor;
                            }
                        }
                        if (!renderFill) fillColor = null;
                        if (!renderLine) lineColor = null;
                        this.renderBody(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity);
                        var partsLength = body.parts.length;
                        if (showConvexHulls && partsLength > 1) this.renderConvexHull(body, graphics, hullColor, lineThickness);
                    }
                },
                /**
     * Renders a single Matter Body to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body to your own Graphics instance.
     * 
     * If you don't wish to render a line around the body, set the `lineColor` parameter to `null`.
     * Equally, if you don't wish to render a fill, set the `fillColor` parameter to `null`.
     * 
     * @method Phaser.Physics.Matter.World#renderBody
     * @since 3.22.0
     * 
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {boolean} showInternalEdges - Render internal edges of the polygon?
     * @param {number} [lineColor] - The line color.
     * @param {number} [lineOpacity] - The line opacity, between 0 and 1.
     * @param {number} [lineThickness=1] - The line thickness.
     * @param {number} [fillColor] - The fill color.
     * @param {number} [fillOpacity] - The fill opacity, between 0 and 1.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderBody: function(body, graphics, showInternalEdges, lineColor, lineOpacity, lineThickness, fillColor, fillOpacity) {
                    if (lineColor === undefined) lineColor = null;
                    if (lineOpacity === undefined) lineOpacity = null;
                    if (lineThickness === undefined) lineThickness = 1;
                    if (fillColor === undefined) fillColor = null;
                    if (fillOpacity === undefined) fillOpacity = null;
                    var config = this.debugConfig;
                    var sensorFillColor = config.sensorFillColor;
                    var sensorLineColor = config.sensorLineColor;
                    //  Handle compound parts
                    var parts = body.parts;
                    var partsLength = parts.length;
                    for(var k = partsLength > 1 ? 1 : 0; k < partsLength; k++){
                        var part = parts[k];
                        var render = part.render;
                        var opacity = render.opacity;
                        if (!render.visible || opacity === 0 || part.isSensor && !config.showSensors) continue;
                        //  Part polygon
                        var circleRadius = part.circleRadius;
                        graphics.beginPath();
                        if (part.isSensor) {
                            if (fillColor !== null) graphics.fillStyle(sensorFillColor, fillOpacity * opacity);
                            if (lineColor !== null) graphics.lineStyle(lineThickness, sensorLineColor, lineOpacity * opacity);
                        } else {
                            if (fillColor !== null) graphics.fillStyle(fillColor, fillOpacity * opacity);
                            if (lineColor !== null) graphics.lineStyle(lineThickness, lineColor, lineOpacity * opacity);
                        }
                        if (circleRadius) graphics.arc(part.position.x, part.position.y, circleRadius, 0, 2 * Math.PI);
                        else {
                            var vertices = part.vertices;
                            var vertLength = vertices.length;
                            graphics.moveTo(vertices[0].x, vertices[0].y);
                            for(var j = 1; j < vertLength; j++){
                                var vert = vertices[j];
                                if (!vertices[j - 1].isInternal || showInternalEdges) graphics.lineTo(vert.x, vert.y);
                                else graphics.moveTo(vert.x, vert.y);
                                if (j < vertLength && vert.isInternal && !showInternalEdges) {
                                    var nextIndex = (j + 1) % vertLength;
                                    graphics.moveTo(vertices[nextIndex].x, vertices[nextIndex].y);
                                }
                            }
                            graphics.closePath();
                        }
                        if (fillColor !== null) graphics.fillPath();
                        if (lineColor !== null) graphics.strokePath();
                    }
                    if (config.showPositions && !body.isStatic) {
                        var px = body.position.x;
                        var py = body.position.y;
                        var hs = Math.ceil(config.positionSize / 2);
                        graphics.fillStyle(config.positionColor, 1);
                        graphics.fillRect(px - hs, py - hs, config.positionSize, config.positionSize);
                    }
                    return this;
                },
                /**
     * Renders the Convex Hull for a single Matter Body to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Body hull to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderConvexHull
     * @since 3.22.0
     * 
     * @param {MatterJS.BodyType} body - The Matter Body to be rendered.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} hullColor - The color used to render the hull.
     * @param {number} [lineThickness=1] - The hull line thickness.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderConvexHull: function(body, graphics, hullColor, lineThickness) {
                    if (lineThickness === undefined) lineThickness = 1;
                    var parts = body.parts;
                    var partsLength = parts.length;
                    //  Render Convex Hulls
                    if (partsLength > 1) {
                        var verts = body.vertices;
                        graphics.lineStyle(lineThickness, hullColor);
                        graphics.beginPath();
                        graphics.moveTo(verts[0].x, verts[0].y);
                        for(var v = 1; v < verts.length; v++)graphics.lineTo(verts[v].x, verts[v].y);
                        graphics.lineTo(verts[0].x, verts[0].y);
                        graphics.strokePath();
                    }
                    return this;
                },
                /**
     * Renders all of the constraints in the world (unless they are specifically set to invisible).
     * 
     * Called automatically by the `postUpdate` method.
     *
     * @method Phaser.Physics.Matter.World#renderJoints
     * @private
     * @since 3.14.0
     */ renderJoints: function() {
                    var graphics = this.debugGraphic;
                    // Render constraints 
                    var constraints = Composite.allConstraints(this.localWorld);
                    for(var i = 0; i < constraints.length; i++){
                        var config = constraints[i].render;
                        var lineColor = config.lineColor;
                        var lineOpacity = config.lineOpacity;
                        var lineThickness = config.lineThickness;
                        var pinSize = config.pinSize;
                        var anchorColor = config.anchorColor;
                        var anchorSize = config.anchorSize;
                        this.renderConstraint(constraints[i], graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize);
                    }
                },
                /**
     * Renders a single Matter Constraint, such as a Pin or a Spring, to the given Phaser Graphics Game Object.
     * 
     * This method is used internally by the Matter Debug Renderer, but is also exposed publically should
     * you wish to render a Constraint to your own Graphics instance.
     * 
     * @method Phaser.Physics.Matter.World#renderConstraint
     * @since 3.22.0
     * 
     * @param {MatterJS.ConstraintType} constraint - The Matter Constraint to render.
     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics object to render to.
     * @param {number} lineColor - The line color.
     * @param {number} lineOpacity - The line opacity, between 0 and 1.
     * @param {number} lineThickness - The line thickness.
     * @param {number} pinSize - If this constraint is a pin, this sets the size of the pin circle.
     * @param {number} anchorColor - The color used when rendering this constraints anchors. Set to `null` to not render anchors.
     * @param {number} anchorSize - The size of the anchor circle, if this constraint has anchors and is rendering them.
     * 
     * @return {this} This Matter World instance for method chaining.
     */ renderConstraint: function(constraint, graphics, lineColor, lineOpacity, lineThickness, pinSize, anchorColor, anchorSize) {
                    var render = constraint.render;
                    if (!render.visible || !constraint.pointA || !constraint.pointB) return this;
                    graphics.lineStyle(lineThickness, lineColor, lineOpacity);
                    var bodyA = constraint.bodyA;
                    var bodyB = constraint.bodyB;
                    var start;
                    var end;
                    if (bodyA) start = Vector.add(bodyA.position, constraint.pointA);
                    else start = constraint.pointA;
                    if (render.type === 'pin') graphics.strokeCircle(start.x, start.y, pinSize);
                    else {
                        if (bodyB) end = Vector.add(bodyB.position, constraint.pointB);
                        else end = constraint.pointB;
                        graphics.beginPath();
                        graphics.moveTo(start.x, start.y);
                        if (render.type === 'spring') {
                            var delta = Vector.sub(end, start);
                            var normal = Vector.perp(Vector.normalise(delta));
                            var coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20));
                            var offset;
                            for(var j = 1; j < coils; j += 1){
                                offset = j % 2 === 0 ? 1 : -1;
                                graphics.lineTo(start.x + delta.x * (j / coils) + normal.x * offset * 4, start.y + delta.y * (j / coils) + normal.y * offset * 4);
                            }
                        }
                        graphics.lineTo(end.x, end.y);
                    }
                    graphics.strokePath();
                    if (render.anchors && anchorSize > 0) {
                        graphics.fillStyle(anchorColor);
                        graphics.fillCircle(start.x, start.y, anchorSize);
                        graphics.fillCircle(end.x, end.y, anchorSize);
                    }
                    return this;
                },
                /**
     * Resets the internal collision IDs that Matter.JS uses for Body collision groups.
     * 
     * You should call this before destroying your game if you need to restart the game
     * again on the same page, without first reloading the page. Or, if you wish to
     * consistently destroy a Scene that contains Matter.js and then run it again
     * later in the same game.
     *
     * @method Phaser.Physics.Matter.World#resetCollisionIDs
     * @since 3.17.0
     */ resetCollisionIDs: function() {
                    Body._nextCollidingGroupId = 1;
                    Body._nextNonCollidingGroupId = -1;
                    Body._nextCategory = 0x0001;
                    return this;
                },
                /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * @method Phaser.Physics.Matter.World#shutdown
     * @since 3.0.0
     */ shutdown: function() {
                    MatterEvents.off(this.engine);
                    this.removeAllListeners();
                    MatterWorld.clear(this.localWorld, false);
                    Engine.clear(this.engine);
                    if (this.drawDebug) this.debugGraphic.destroy();
                },
                /**
     * Will remove all Matter physics event listeners and clear the matter physics world,
     * engine and any debug graphics, if any.
     *
     * After destroying the world it cannot be re-used again.
     *
     * @method Phaser.Physics.Matter.World#destroy
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                }
            });
            module1.exports = World;
        /***/ },
        /* 1497 */ /***/ function(module1, exports, __webpack_require__) {
            /* WEBPACK VAR INJECTION */ (function(global) {
                __webpack_require__(590);
                var CONST = __webpack_require__(32);
                var Extend = __webpack_require__(17);
                /**
 * @namespace Phaser
 */ var Phaser = {
                    Actions: __webpack_require__(269),
                    Animations: __webpack_require__(699),
                    BlendModes: __webpack_require__(34),
                    Cache: __webpack_require__(711),
                    Cameras: __webpack_require__(714),
                    Core: __webpack_require__(803),
                    Class: __webpack_require__(0),
                    Create: __webpack_require__(884),
                    Curves: __webpack_require__(890),
                    Data: __webpack_require__(892),
                    Display: __webpack_require__(894),
                    DOM: __webpack_require__(913),
                    Events: __webpack_require__(914),
                    Game: __webpack_require__(916),
                    GameObjects: __webpack_require__(1007),
                    Geom: __webpack_require__(477),
                    Input: __webpack_require__(1302),
                    Loader: __webpack_require__(1332),
                    Math: __webpack_require__(190),
                    Physics: __webpack_require__(1498),
                    Plugins: __webpack_require__(1397),
                    Renderer: __webpack_require__(1399),
                    Scale: __webpack_require__(1406),
                    ScaleModes: __webpack_require__(164),
                    Scene: __webpack_require__(412),
                    Scenes: __webpack_require__(1407),
                    Structs: __webpack_require__(1409),
                    Textures: __webpack_require__(1410),
                    Tilemaps: __webpack_require__(1412),
                    Time: __webpack_require__(1454),
                    Tweens: __webpack_require__(1456),
                    Utils: __webpack_require__(1474)
                };
                Phaser.Sound = __webpack_require__(1485);
                //   Merge in the consts
                Phaser = Extend(false, Phaser, CONST);
                /**
 * The root types namespace.
 *
 * @namespace Phaser.Types
 * @since 3.17.0
 */ //  Export it
                module1.exports = Phaser;
                global.Phaser = Phaser;
            /*
 * "Documentation is like pizza: when it is good, it is very, very good;
 * and when it is bad, it is better than nothing."
 *  -- Dick Brandon
 */ /* WEBPACK VAR INJECTION */ }).call(this, __webpack_require__(589));
        /***/ },
        /* 1498 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics
 */ /**
 * @namespace Phaser.Types.Physics
 */ module1.exports = {
                Arcade: __webpack_require__(1360),
                Matter: __webpack_require__(1499)
            };
        /***/ },
        /* 1499 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @namespace Phaser.Physics.Matter
 */ module1.exports = {
                BodyBounds: __webpack_require__(1486),
                Components: __webpack_require__(534),
                Events: __webpack_require__(586),
                Factory: __webpack_require__(1488),
                MatterGameObject: __webpack_require__(1489),
                Image: __webpack_require__(1490),
                Matter: __webpack_require__(1391),
                MatterPhysics: __webpack_require__(1529),
                PolyDecomp: __webpack_require__(1487),
                Sprite: __webpack_require__(1491),
                TileBody: __webpack_require__(1390),
                PhysicsEditorParser: __webpack_require__(1386),
                PhysicsJSONParser: __webpack_require__(1387),
                PointerConstraint: __webpack_require__(1492),
                World: __webpack_require__(1496)
            };
        /***/ },
        /* 1500 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to set restitution on objects.
 *
 * @namespace Phaser.Physics.Matter.Components.Bounce
 * @since 3.0.0
 */ var Bounce = {
                /**
     * Sets the restitution on the physics object.
     *
     * @method Phaser.Physics.Matter.Components.Bounce#setBounce
     * @since 3.0.0
     *
     * @param {number} value - A Number that defines the restitution (elasticity) of the body. The value is always positive and is in the range (0, 1). A value of 0 means collisions may be perfectly inelastic and no bouncing may occur. A value of 0.8 means the body may bounce back with approximately 80% of its kinetic energy. Note that collision response is based on pairs of bodies, and that restitution values are combined with the following formula: `Math.max(bodyA.restitution, bodyB.restitution)`
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setBounce: function(value) {
                    this.body.restitution = value;
                    return this;
                }
            };
            module1.exports = Bounce;
        /***/ },
        /* 1501 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the collision filter of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Collision
 * @since 3.0.0
 */ var Collision = {
                /**
     * Sets the collision category of this Game Object's Matter Body. This number must be a power of two between 2^0 (= 1) and 2^31.
     * Two bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionCategory
     * @since 3.0.0
     *
     * @param {number} value - Unique category bitfield.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollisionCategory: function(value) {
                    this.body.collisionFilter.category = value;
                    return this;
                },
                /**
     * Sets the collision group of this Game Object's Matter Body. If this is zero or two Matter Bodies have different values,
     * they will collide according to the usual rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     * If two Matter Bodies have the same positive value, they will always collide; if they have the same negative value,
     * they will never collide.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollisionGroup
     * @since 3.0.0
     *
     * @param {number} value - Unique group index.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollisionGroup: function(value) {
                    this.body.collisionFilter.group = value;
                    return this;
                },
                /**
     * Sets the collision mask for this Game Object's Matter Body. Two Matter Bodies with different collision groups will only
     * collide if each one includes the other's category in its mask based on a bitwise AND, i.e. `(categoryA & maskB) !== 0`
     * and `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setCollidesWith
     * @since 3.0.0
     *
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCollidesWith: function(categories) {
                    var flags = 0;
                    if (!Array.isArray(categories)) flags = categories;
                    else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                    this.body.collisionFilter.mask = flags;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollide
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body starts colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollide: function(callback) {
                    this.body.onCollideCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideEnd
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke when this body stops colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideEnd: function(callback) {
                    this.body.onCollideEndCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideActive
     * @since 3.22.0
     *
     * @param {function} callback - The callback to invoke for the duration of this body colliding with another.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideActive: function(callback) {
                    this.body.onCollideActiveCallback = callback;
                    return this;
                },
                /**
     * The callback is sent a reference to the other body, along with a `Phaser.Types.Physics.Matter.MatterCollisionData` object.
     * 
     * This does not change the bodies collision category, group or filter. Those must be set in addition
     * to the callback.
     *
     * @method Phaser.Physics.Matter.Components.Collision#setOnCollideWith
     * @since 3.22.0
     *
     * @param {(MatterJS.Body|MatterJS.Body[])} body - The body, or an array of bodies, to test for collisions with.
     * @param {function} callback - The callback to invoke when this body collides with the given body or bodies.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setOnCollideWith: function(body, callback) {
                    if (!Array.isArray(body)) body = [
                        body
                    ];
                    for(var i = 0; i < body.length; i++){
                        var src = body[i].hasOwnProperty('body') ? body[i].body : body[i];
                        this.body.setOnCollideWith(src, callback);
                    }
                    return this;
                }
            };
            module1.exports = Collision;
        /***/ },
        /* 1502 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(71);
            /**
 * A component to apply force to Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Force
 * @since 3.0.0
 */ var Force = {
                //  force = vec2 / point
                /**
     * Applies a force to a body.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForce
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ applyForce: function(force) {
                    this._tempVec2.set(this.body.position.x, this.body.position.y);
                    Body.applyForce(this.body, this._tempVec2, force);
                    return this;
                },
                /**
     * Applies a force to a body from a given position.
     *
     * @method Phaser.Physics.Matter.Components.Force#applyForceFrom
     * @since 3.0.0
     *
     * @param {Phaser.Math.Vector2} position - The position in which the force comes from.
     * @param {Phaser.Math.Vector2} force - A Vector that specifies the force to apply.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ applyForceFrom: function(position, force) {
                    Body.applyForce(this.body, position, force);
                    return this;
                },
                /**
     * Apply thrust to the forward position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrust
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrust: function(speed) {
                    var angle = this.body.angle;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the left position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustLeft
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustLeft: function(speed) {
                    var angle = this.body.angle - Math.PI / 2;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the right position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustRight
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustRight: function(speed) {
                    var angle = this.body.angle + Math.PI / 2;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                },
                /**
     * Apply thrust to the back position of the body.
     * 
     * Use very small values, such as 0.1, depending on the mass and required speed.
     *
     * @method Phaser.Physics.Matter.Components.Force#thrustBack
     * @since 3.0.0
     *
     * @param {number} speed - A speed value to be applied to a directional force.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ thrustBack: function(speed) {
                    var angle = this.body.angle - Math.PI;
                    this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
                    Body.applyForce(this.body, {
                        x: this.body.position.x,
                        y: this.body.position.y
                    }, this._tempVec2);
                    return this;
                }
            };
            module1.exports = Force;
        /***/ },
        /* 1503 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Contains methods for changing the friction of a Game Object's Matter Body. Should be used a mixin, not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Friction
 * @since 3.0.0
 */ var Friction = {
                /**
     * Sets new friction values for this Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFriction
     * @since 3.0.0
     *
     * @param {number} value - The new friction of the body, between 0 and 1, where 0 allows the Body to slide indefinitely, while 1 allows it to stop almost immediately after a force is applied.
     * @param {number} [air] - If provided, the new air resistance of the Body. The higher the value, the faster the Body will slow as it moves through space. 0 means the body has no air resistance.
     * @param {number} [fstatic] - If provided, the new static friction of the Body. The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary. 0 means the body will never "stick" when it is nearly stationary.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFriction: function(value, air, fstatic) {
                    this.body.friction = value;
                    if (air !== undefined) this.body.frictionAir = air;
                    if (fstatic !== undefined) this.body.frictionStatic = fstatic;
                    return this;
                },
                /**
     * Sets a new air resistance for this Game Object's Matter Body.
     * A value of 0 means the Body will never slow as it moves through space.
     * The higher the value, the faster a Body slows when moving through space.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionAir
     * @since 3.0.0
     *
     * @param {number} value - The new air resistance for the Body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFrictionAir: function(value) {
                    this.body.frictionAir = value;
                    return this;
                },
                /**
     * Sets a new static friction for this Game Object's Matter Body.
     * A value of 0 means the Body will never "stick" when it is nearly stationary.
     * The higher the value (e.g. 10), the more force it will take to initially get the Body moving when it is nearly stationary.
     *
     * @method Phaser.Physics.Matter.Components.Friction#setFrictionStatic
     * @since 3.0.0
     *
     * @param {number} value - The new static friction for the Body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setFrictionStatic: function(value) {
                    this.body.frictionStatic = value;
                    return this;
                }
            };
            module1.exports = Friction;
        /***/ },
        /* 1504 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * A component to manipulate world gravity for Matter.js bodies.
 *
 * @namespace Phaser.Physics.Matter.Components.Gravity
 * @since 3.0.0
 */ var Gravity = {
                /**
     * A togglable function for ignoring world gravity in real-time on the current body.
     *
     * @method Phaser.Physics.Matter.Components.Gravity#setIgnoreGravity
     * @since 3.0.0
     *
     * @param {boolean} value - Set to true to ignore the effect of world gravity, or false to not ignore it.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setIgnoreGravity: function(value) {
                    this.body.ignoreGravity = value;
                    return this;
                }
            };
            module1.exports = Gravity;
        /***/ },
        /* 1505 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(71);
            var Vector2 = __webpack_require__(3);
            /**
 * Allows accessing the mass, density, and center of mass of a Matter-enabled Game Object. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Mass
 * @since 3.0.0
 */ var Mass = {
                /**
     * Sets the mass of the Game Object's Matter Body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setMass
     * @since 3.0.0
     *
     * @param {number} value - The new mass of the body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setMass: function(value) {
                    Body.setMass(this.body, value);
                    return this;
                },
                /**
     * Sets density of the body.
     *
     * @method Phaser.Physics.Matter.Components.Mass#setDensity
     * @since 3.0.0
     *
     * @param {number} value - The new density of the body.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setDensity: function(value) {
                    Body.setDensity(this.body, value);
                    return this;
                },
                /**
     * The body's center of mass.
     * 
     * Calling this creates a new `Vector2 each time to avoid mutation.
     * 
     * If you only need to read the value and won't change it, you can get it from `GameObject.body.centerOfMass`.
     *
     * @name Phaser.Physics.Matter.Components.Mass#centerOfMass
     * @type {Phaser.Math.Vector2}
     * @readonly
     * @since 3.10.0
     *
     * @return {Phaser.Math.Vector2} The center of mass.
     */ centerOfMass: {
                    get: function() {
                        return new Vector2(this.body.centerOfMass.x, this.body.centerOfMass.y);
                    }
                }
            };
            module1.exports = Mass;
        /***/ },
        /* 1506 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * Enables a Matter-enabled Game Object to be a sensor. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sensor
 * @since 3.0.0
 */ var Sensor = {
                /**
     * Set the body belonging to this Game Object to be a sensor.
     * Sensors trigger collision events, but don't react with colliding body physically.
     *
     * @method Phaser.Physics.Matter.Components.Sensor#setSensor
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as a sensor, or `false` to disable it.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setSensor: function(value) {
                    this.body.isSensor = value;
                    return this;
                },
                /**
     * Is the body belonging to this Game Object a sensor or not?
     *
     * @method Phaser.Physics.Matter.Components.Sensor#isSensor
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is a sensor, otherwise `false`.
     */ isSensor: function() {
                    return this.body.isSensor;
                }
            };
            module1.exports = Sensor;
        /***/ },
        /* 1507 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            var FuzzyEquals = __webpack_require__(123);
            var GetFastValue = __webpack_require__(2);
            var PhysicsEditorParser = __webpack_require__(1386);
            var PhysicsJSONParser = __webpack_require__(1387);
            var Vertices = __webpack_require__(94);
            /**
 * Enables a Matter-enabled Game Object to set its Body. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.SetBody
 * @since 3.0.0
 */ var SetBody = {
                /**
     * Set the body on a Game Object to a rectangle.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setRectangle
     * @since 3.0.0
     *
     * @param {number} width - Width of the rectangle.
     * @param {number} height - Height of the rectangle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setRectangle: function(width, height, options) {
                    return this.setBody({
                        type: 'rectangle',
                        width: width,
                        height: height
                    }, options);
                },
                /**
     * Set the body on a Game Object to a circle.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setCircle
     * @since 3.0.0
     *
     * @param {number} radius - The radius of the circle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setCircle: function(radius, options) {
                    return this.setBody({
                        type: 'circle',
                        radius: radius
                    }, options);
                },
                /**
     * Set the body on the Game Object to a polygon shape.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setPolygon
     * @since 3.0.0
     *
     * @param {number} sides - The number of sides the polygon will have.
     * @param {number} radius - The "radius" of the polygon, i.e. the distance from its center to any vertex. This is also the radius of its circumcircle.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setPolygon: function(radius, sides, options) {
                    return this.setBody({
                        type: 'polygon',
                        sides: sides,
                        radius: radius
                    }, options);
                },
                /**
     * Set the body on the Game Object to a trapezoid shape.
     * 
     * Calling this methods resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setTrapezoid
     * @since 3.0.0
     *
     * @param {number} width - The width of the trapezoid Body.
     * @param {number} height - The height of the trapezoid Body.
     * @param {number} slope - The slope of the trapezoid. 0 creates a rectangle, while 1 creates a triangle. Positive values make the top side shorter, while negative values make the bottom side shorter.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setTrapezoid: function(width, height, slope, options) {
                    return this.setBody({
                        type: 'trapezoid',
                        width: width,
                        height: height,
                        slope: slope
                    }, options);
                },
                /**
     * Set this Game Object to use the given existing Matter Body.
     * 
     * The body is first removed from the world before being added to this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setExistingBody
     * @since 3.0.0
     *
     * @param {MatterJS.BodyType} body - The Body this Game Object should use.
     * @param {boolean} [addToWorld=true] - Should the body be immediately added to the World?
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setExistingBody: function(body, addToWorld) {
                    if (addToWorld === undefined) addToWorld = true;
                    if (this.body) this.world.remove(this.body, true);
                    this.body = body;
                    for(var i = 0; i < body.parts.length; i++)body.parts[i].gameObject = this;
                    var _this = this;
                    body.destroy = function destroy() {
                        _this.world.remove(_this.body, true);
                        _this.body.gameObject = null;
                    };
                    if (addToWorld) {
                        if (this.world.has(body)) //  Because it could be part of another Composite
                        this.world.remove(body, true);
                        this.world.add(body);
                    }
                    if (this._originComponent) {
                        var rx = body.render.sprite.xOffset;
                        var ry = body.render.sprite.yOffset;
                        var comx = body.centerOfMass.x;
                        var comy = body.centerOfMass.y;
                        if (FuzzyEquals(comx, 0.5) && FuzzyEquals(comy, 0.5)) this.setOrigin(rx + 0.5, ry + 0.5);
                        else {
                            var cx = body.centerOffset.x;
                            var cy = body.centerOffset.y;
                            this.setOrigin(rx + cx / this.displayWidth, ry + cy / this.displayHeight);
                        }
                    }
                    return this;
                },
                /**
     * Set this Game Object to create and use a new Body based on the configuration object given.
     * 
     * Calling this method resets previous properties you may have set on the body, including
     * plugins, mass, friction, etc. So be sure to re-apply these in the options object if needed.
     *
     * @method Phaser.Physics.Matter.Components.SetBody#setBody
     * @since 3.0.0
     *
     * @param {(string|Phaser.Types.Physics.Matter.MatterSetBodyConfig)} config - Either a string, such as `circle`, or a Matter Set Body Configuration object.
     * @param {Phaser.Types.Physics.Matter.MatterBodyConfig} [options] - An optional Body configuration object that is used to set initial Body properties on creation.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setBody: function(config, options) {
                    if (!config) return this;
                    var body;
                    //  Allow them to do: shape: 'circle' instead of shape: { type: 'circle' }
                    if (typeof config === 'string') //  Using defaults
                    config = {
                        type: config
                    };
                    var shapeType = GetFastValue(config, 'type', 'rectangle');
                    var bodyX = GetFastValue(config, 'x', this._tempVec2.x);
                    var bodyY = GetFastValue(config, 'y', this._tempVec2.y);
                    var bodyWidth = GetFastValue(config, 'width', this.width);
                    var bodyHeight = GetFastValue(config, 'height', this.height);
                    switch(shapeType){
                        case 'rectangle':
                            body = Bodies.rectangle(bodyX, bodyY, bodyWidth, bodyHeight, options);
                            break;
                        case 'circle':
                            var radius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
                            var maxSides = GetFastValue(config, 'maxSides', 25);
                            body = Bodies.circle(bodyX, bodyY, radius, options, maxSides);
                            break;
                        case 'trapezoid':
                            var slope = GetFastValue(config, 'slope', 0.5);
                            body = Bodies.trapezoid(bodyX, bodyY, bodyWidth, bodyHeight, slope, options);
                            break;
                        case 'polygon':
                            var sides = GetFastValue(config, 'sides', 5);
                            var pRadius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
                            body = Bodies.polygon(bodyX, bodyY, sides, pRadius, options);
                            break;
                        case 'fromVertices':
                        case 'fromVerts':
                            var verts = GetFastValue(config, 'verts', null);
                            if (verts) {
                                //  Has the verts array come from Vertices.fromPath, or is it raw?
                                if (typeof verts === 'string') verts = Vertices.fromPath(verts);
                                if (this.body && !this.body.hasOwnProperty('temp')) {
                                    Body.setVertices(this.body, verts);
                                    body = this.body;
                                } else {
                                    var flagInternal = GetFastValue(config, 'flagInternal', false);
                                    var removeCollinear = GetFastValue(config, 'removeCollinear', 0.01);
                                    var minimumArea = GetFastValue(config, 'minimumArea', 10);
                                    body = Bodies.fromVertices(bodyX, bodyY, verts, options, flagInternal, removeCollinear, minimumArea);
                                }
                            }
                            break;
                        case 'fromPhysicsEditor':
                            body = PhysicsEditorParser.parseBody(bodyX, bodyY, config, options);
                            break;
                        case 'fromPhysicsTracer':
                            body = PhysicsJSONParser.parseBody(bodyX, bodyY, config, options);
                            break;
                    }
                    if (body) this.setExistingBody(body, config.addToWorld);
                    return this;
                }
            };
            module1.exports = SetBody;
        /***/ },
        /* 1508 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Events = __webpack_require__(586);
            var Sleeping = __webpack_require__(267);
            var MatterEvents = __webpack_require__(268);
            /**
 * Enables a Matter-enabled Game Object to be able to go to sleep. Should be used as a mixin and not directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Sleep
 * @since 3.0.0
 */ var Sleep = {
                /**
     * Sets this Body to sleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setToSleep
     * @since 3.22.0
     *
     * @return {this} This Game Object.
     */ setToSleep: function() {
                    Sleeping.set(this.body, true);
                },
                /**
     * Wakes this Body if asleep.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setAwake
     * @since 3.22.0
     *
     * @return {this} This Game Object.
     */ setAwake: function() {
                    Sleeping.set(this.body, false);
                },
                /**
     * Sets the number of updates in which this body must have near-zero velocity before it is set as sleeping (if sleeping is enabled by the engine).
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepThreshold
     * @since 3.0.0
     *
     * @param {number} [value=60] - A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping.
     *
     * @return {this} This Game Object.
     */ setSleepThreshold: function(value) {
                    if (value === undefined) value = 60;
                    this.body.sleepThreshold = value;
                    return this;
                },
                /**
     * Enable sleep and wake events for this body.
     * 
     * By default when a body goes to sleep, or wakes up, it will not emit any events.
     * 
     * The events are emitted by the Matter World instance and can be listened to via
     * the `SLEEP_START` and `SLEEP_END` events.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEvents
     * @since 3.0.0
     *
     * @param {boolean} start - `true` if you want the sleep start event to be emitted for this body.
     * @param {boolean} end - `true` if you want the sleep end event to be emitted for this body.
     *
     * @return {this} This Game Object.
     */ setSleepEvents: function(start, end) {
                    this.setSleepStartEvent(start);
                    this.setSleepEndEvent(end);
                    return this;
                },
                /**
     * Enables or disables the Sleep Start event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepStartEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object.
     */ setSleepStartEvent: function(value) {
                    if (value) {
                        var world = this.world;
                        MatterEvents.on(this.body, 'sleepStart', function(event) {
                            world.emit(Events.SLEEP_START, event, this);
                        });
                    } else MatterEvents.off(this.body, 'sleepStart');
                    return this;
                },
                /**
     * Enables or disables the Sleep End event for this body.
     *
     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEndEvent
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to enable the sleep event, or `false` to disable it.
     *
     * @return {this} This Game Object.
     */ setSleepEndEvent: function(value) {
                    if (value) {
                        var world = this.world;
                        MatterEvents.on(this.body, 'sleepEnd', function(event) {
                            world.emit(Events.SLEEP_END, event, this);
                        });
                    } else MatterEvents.off(this.body, 'sleepEnd');
                    return this;
                }
            };
            module1.exports = Sleep;
        /***/ },
        /* 1509 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterAddEvent
 *
 * @property {any[]} object - An array of the object(s) that have been added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Add Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the end of the process when a new Body
 * or Constraint has just been added to the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afteradd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_ADD
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterAddEvent} event - The Add Event object.
 */ module1.exports = 'afteradd';
        /***/ },
        /* 1510 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) that were removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Remove Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the end of the process when a 
 * Body or Constraint was removed from the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afterremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_REMOVE
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterRemoveEvent} event - The Remove Event object.
 */ module1.exports = 'afterremove';
        /***/ },
        /* 1511 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.AfterUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics After Update Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated and all collision events have resolved.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('afterupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#AFTER_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.AfterUpdateEvent} event - The Update Event object.
 */ module1.exports = 'afterupdate';
        /***/ },
        /* 1512 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeAddEvent
 *
 * @property {any[]} object - An array of the object(s) to be added. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Add Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the start of the process when a new Body
 * or Constraint is being added to the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeadd', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_ADD
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeAddEvent} event - The Add Event object.
 */ module1.exports = 'beforeadd';
        /***/ },
        /* 1513 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeRemoveEvent
 *
 * @property {any[]} object - An array of the object(s) to be removed. May be a single body, constraint, composite or a mixture of these.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Remove Event.
 * 
 * This event is dispatched by a Matter Physics World instance at the start of the process when a 
 * Body or Constraint is being removed from the world.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeremove', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_REMOVE
 * @since 3.22.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeRemoveEvent} event - The Remove Event object.
 */ module1.exports = 'beforeremove';
        /***/ },
        /* 1514 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.BeforeUpdateEvent
 *
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Before Update Event.
 * 
 * This event is dispatched by a Matter Physics World instance right before all the collision processing takes place.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('beforeupdate', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#BEFORE_UPDATE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.BeforeUpdateEvent} event - The Update Event object.
 */ module1.exports = 'beforeupdate';
        /***/ },
        /* 1515 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionActiveEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Active Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that are colliding in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionactive', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_ACTIVE
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionActiveEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionactive';
        /***/ },
        /* 1516 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionEndEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision End Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have finished colliding in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_END
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionEndEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionend';
        /***/ },
        /* 1517 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.CollisionStartEvent
 *
 * @property {Phaser.Types.Physics.Matter.MatterCollisionData[]} pairs - A list of all affected pairs in the collision.
 * @property {number} timestamp - The Matter Engine `timing.timestamp` value for the event.
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Collision Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance after the engine has updated.
 * It provides a list of all pairs that have started to collide in the current tick (if any).
 * 
 * Listen to it from a Scene using: `this.matter.world.on('collisionstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#COLLISION_START
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.CollisionStartEvent} event - The Collision Event object.
 * @param {MatterJS.BodyType} bodyA - The first body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 * @param {MatterJS.BodyType} bodyB - The second body of the first colliding pair. The `event.pairs` array may contain more colliding bodies.
 */ module1.exports = 'collisionstart';
        /***/ },
        /* 1518 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag End Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * stops dragging a body.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('dragend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_END
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that has stopped being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that was dragging the body.
 */ module1.exports = 'dragend';
        /***/ },
        /* 1519 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * is actively dragging a body. It is emitted each time the pointer moves.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('drag', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that is being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = 'drag';
        /***/ },
        /* 1520 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics Drag Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Pointer Constraint
 * starts dragging a body.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('dragstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#DRAG_START
 * @since 3.16.2
 * 
 * @param {MatterJS.BodyType} body - The Body that has started being dragged. This is a Matter Body, not a Phaser Game Object.
 * @param {MatterJS.BodyType} part - The part of the body that was clicked on.
 * @param {Phaser.Physics.Matter.PointerConstraint} constraint - The Pointer Constraint that is dragging the body.
 */ module1.exports = 'dragstart';
        /***/ },
        /* 1521 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Pause Event.
 * 
 * This event is dispatched by an Matter Physics World instance when it is paused.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('pause', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#PAUSE
 * @since 3.0.0
 */ module1.exports = 'pause';
        /***/ },
        /* 1522 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * The Matter Physics World Resume Event.
 * 
 * This event is dispatched by an Matter Physics World instance when it resumes from a paused state.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('resume', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#RESUME
 * @since 3.0.0
 */ module1.exports = 'resume';
        /***/ },
        /* 1523 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepEndEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep End Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Body stop sleeping.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('sleepend', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_END
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.SleepEndEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has stopped sleeping.
 */ module1.exports = 'sleepend';
        /***/ },
        /* 1524 */ /***/ function(module1, exports) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ /**
 * @typedef {object} Phaser.Physics.Matter.Events.SleepStartEvent
 *
 * @property {any} source - The source object of the event.
 * @property {string} name - The name of the event.
 */ /**
 * The Matter Physics Sleep Start Event.
 * 
 * This event is dispatched by a Matter Physics World instance when a Body goes to sleep.
 * 
 * Listen to it from a Scene using: `this.matter.world.on('sleepstart', listener)`.
 *
 * @event Phaser.Physics.Matter.Events#SLEEP_START
 * @since 3.0.0
 * 
 * @param {Phaser.Physics.Matter.Events.SleepStartEvent} event - The Sleep Event object.
 * @param {MatterJS.BodyType} body - The body that has gone to sleep.
 */ module1.exports = 'sleepstart';
        /***/ },
        /* 1525 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(71);
            /**
 * Provides methods used for getting and setting the static state of a physics body.
 *
 * @namespace Phaser.Physics.Matter.Components.Static
 * @since 3.0.0
 */ var Static = {
                /**
     * Changes the physics body to be either static `true` or dynamic `false`.
     *
     * @method Phaser.Physics.Matter.Components.Static#setStatic
     * @since 3.0.0
     *
     * @param {boolean} value - `true` to set the body as being static, or `false` to make it dynamic.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setStatic: function(value) {
                    Body.setStatic(this.body, value);
                    return this;
                },
                /**
     * Returns `true` if the body is static, otherwise `false` for a dynamic body.
     *
     * @method Phaser.Physics.Matter.Components.Static#isStatic
     * @since 3.0.0
     *
     * @return {boolean} `true` if the body is static, otherwise `false`.
     */ isStatic: function() {
                    return this.body.isStatic;
                }
            };
            module1.exports = Static;
        /***/ },
        /* 1526 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(71);
            var MATH_CONST = __webpack_require__(14);
            var WrapAngle = __webpack_require__(265);
            var WrapAngleDegrees = __webpack_require__(266);
            //  global bitmask flag for GameObject.renderMask (used by Scale)
            var _FLAG = 4; // 0100
            //  Transform Component
            /**
 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
 *
 * @namespace Phaser.Physics.Matter.Components.Transform
 * @since 3.0.0
 */ var Transform = {
                /**
     * The x position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#x
     * @type {number}
     * @since 3.0.0
     */ x: {
                    get: function() {
                        return this.body.position.x;
                    },
                    set: function(value) {
                        this._tempVec2.set(value, this.y);
                        Body.setPosition(this.body, this._tempVec2);
                    }
                },
                /**
     * The y position of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#y
     * @type {number}
     * @since 3.0.0
     */ y: {
                    get: function() {
                        return this.body.position.y;
                    },
                    set: function(value) {
                        this._tempVec2.set(this.x, value);
                        Body.setPosition(this.body, this._tempVec2);
                    }
                },
                /**
     * The horizontal scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleX
     * @type {number}
     * @since 3.0.0
     */ scaleX: {
                    get: function() {
                        return this._scaleX;
                    },
                    set: function(value) {
                        var factorX = 1 / this._scaleX;
                        var factorY = 1 / this._scaleY;
                        this._scaleX = value;
                        if (this._scaleX === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        //  Reset Matter scale back to 1 (sigh)
                        Body.scale(this.body, factorX, factorY);
                        Body.scale(this.body, value, this._scaleY);
                    }
                },
                /**
     * The vertical scale of this Game Object.
     *
     * @name Phaser.Physics.Matter.Components.Transform#scaleY
     * @type {number}
     * @since 3.0.0
     */ scaleY: {
                    get: function() {
                        return this._scaleY;
                    },
                    set: function(value) {
                        var factorX = 1 / this._scaleX;
                        var factorY = 1 / this._scaleY;
                        this._scaleY = value;
                        if (this._scaleY === 0) this.renderFlags &= ~_FLAG;
                        else this.renderFlags |= _FLAG;
                        Body.scale(this.body, factorX, factorY);
                        Body.scale(this.body, this._scaleX, value);
                    }
                },
                /**
     * Use `angle` to set or get rotation of the physics body associated to this GameObject.
     * Unlike rotation, when using set the value can be in degrees, which will be converted to radians internally.
     *
     * @name Phaser.Physics.Matter.Components.Transform#angle
     * @type {number}
     * @since 3.0.0
     */ angle: {
                    get: function() {
                        return WrapAngleDegrees(this.body.angle * MATH_CONST.RAD_TO_DEG);
                    },
                    set: function(value) {
                        //  value is in degrees
                        this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
                    }
                },
                /**
     * Use `rotation` to set or get the rotation of the physics body associated with this GameObject.
     * The value when set must be in radians.
     *
     * @name Phaser.Physics.Matter.Components.Transform#rotation
     * @type {number}
     * @since 3.0.0
     */ rotation: {
                    get: function() {
                        return this.body.angle;
                    },
                    set: function(value) {
                        //  value is in radians
                        this._rotation = WrapAngle(value);
                        Body.setAngle(this.body, this._rotation);
                    }
                },
                /**
     * Sets the position of the physics body along x and y axes.
     * Both the parameters to this function are optional and if not passed any they default to 0.
     * Velocity, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setPosition
     * @since 3.0.0
     *
     * @param {number} [x=0] - The horizontal position of the body.
     * @param {number} [y=x] - The vertical position of the body.
     *
     * @return {this} This Game Object.
     */ setPosition: function(x, y) {
                    if (x === undefined) x = 0;
                    if (y === undefined) y = x;
                    this._tempVec2.set(x, y);
                    Body.setPosition(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setRotation
     * @since 3.0.0
     *
     * @param {number} [radians=0] - The angle of the body, in radians.
     *
     * @return {this} This Game Object.
     */ setRotation: function(radians) {
                    if (radians === undefined) radians = 0;
                    this._rotation = WrapAngle(radians);
                    Body.setAngle(this.body, radians);
                    return this;
                },
                /**
     * Setting fixed rotation sets the Body inertia to Infinity, which stops it
     * from being able to rotate when forces are applied to it.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setFixedRotation
     * @since 3.0.0
     *
     * @return {this} This Game Object.
     */ setFixedRotation: function() {
                    Body.setInertia(this.body, Infinity);
                    return this;
                },
                /**
     * Immediately sets the angle of the Body.
     * Angular velocity, position, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setAngle
     * @since 3.0.0
     *
     * @param {number} [degrees=0] - The angle to set, in degrees.
     *
     * @return {this} This Game Object.
     */ setAngle: function(degrees) {
                    if (degrees === undefined) degrees = 0;
                    this.angle = degrees;
                    Body.setAngle(this.body, this.rotation);
                    return this;
                },
                /**
     * Sets the scale of this Game Object.
     *
     * @method Phaser.Physics.Matter.Components.Transform#setScale
     * @since 3.0.0
     *
     * @param {number} [x=1] - The horizontal scale of this Game Object.
     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the x value.
     * @param {Phaser.Math.Vector2} [point] - The point (Vector2) from which scaling will occur.
     *
     * @return {this} This Game Object.
     */ setScale: function(x, y, point) {
                    if (x === undefined) x = 1;
                    if (y === undefined) y = x;
                    var factorX = 1 / this._scaleX;
                    var factorY = 1 / this._scaleY;
                    this._scaleX = x;
                    this._scaleY = y;
                    Body.scale(this.body, factorX, factorY, point);
                    Body.scale(this.body, x, y, point);
                    return this;
                }
            };
            module1.exports = Transform;
        /***/ },
        /* 1527 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var Body = __webpack_require__(71);
            /**
 * Contains methods for changing the velocity of a Matter Body. Should be used as a mixin and not called directly.
 *
 * @namespace Phaser.Physics.Matter.Components.Velocity
 * @since 3.0.0
 */ var Velocity = {
                /**
     * Sets the angular velocity of the body instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setAngularVelocity
     * @since 3.0.0
     *
     * @param {number} value - The angular velocity.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setAngularVelocity: function(value) {
                    Body.setAngularVelocity(this.body, value);
                    return this;
                },
                /**
     * Sets the horizontal velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityX
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocityX: function(x) {
                    this._tempVec2.set(x, this.body.velocity.y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Sets vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityY
     * @since 3.0.0
     *
     * @param {number} y - The vertical velocity value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocityY: function(y) {
                    this._tempVec2.set(this.body.velocity.x, y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                },
                /**
     * Sets both the horizontal and vertical velocity of the physics body.
     *
     * @method Phaser.Physics.Matter.Components.Velocity#setVelocity
     * @since 3.0.0
     *
     * @param {number} x - The horizontal velocity value.
     * @param {number} [y=x] - The vertical velocity value, it can be either positive or negative. If not given, it will be the same as the `x` value.
     *
     * @return {Phaser.GameObjects.GameObject} This Game Object.
     */ setVelocity: function(x, y) {
                    this._tempVec2.set(x, y);
                    Body.setVelocity(this.body, this._tempVec2);
                    return this;
                }
            };
            module1.exports = Velocity;
        /***/ },
        /* 1528 */ /***/ function(module1, exports, __webpack_require__) {
            // @if DEBUG
            /**
* _Internal Class_, not generally used outside of the engine's internals.
*
*/ var Metrics = {};
            module1.exports = Metrics;
            var Composite = __webpack_require__(163);
            var Common = __webpack_require__(50);
            (function() {
                /**
     * Creates a new metrics.
     * @method create
     * @private
     * @return {metrics} A new metrics
     */ Metrics.create = function(options) {
                    var defaults = {
                        extended: false,
                        narrowDetections: 0,
                        narrowphaseTests: 0,
                        narrowReuse: 0,
                        narrowReuseCount: 0,
                        midphaseTests: 0,
                        broadphaseTests: 0,
                        narrowEff: 0.0001,
                        midEff: 0.0001,
                        broadEff: 0.0001,
                        collisions: 0,
                        buckets: 0,
                        bodies: 0,
                        pairs: 0
                    };
                    return Common.extend(defaults, false, options);
                };
                /**
     * Resets metrics.
     * @method reset
     * @private
     * @param {metrics} metrics
     */ Metrics.reset = function(metrics) {
                    if (metrics.extended) {
                        metrics.narrowDetections = 0;
                        metrics.narrowphaseTests = 0;
                        metrics.narrowReuse = 0;
                        metrics.narrowReuseCount = 0;
                        metrics.midphaseTests = 0;
                        metrics.broadphaseTests = 0;
                        metrics.narrowEff = 0;
                        metrics.midEff = 0;
                        metrics.broadEff = 0;
                        metrics.collisions = 0;
                        metrics.buckets = 0;
                        metrics.pairs = 0;
                        metrics.bodies = 0;
                    }
                };
                /**
     * Updates metrics.
     * @method update
     * @private
     * @param {metrics} metrics
     * @param {engine} engine
     */ Metrics.update = function(metrics, engine) {
                    if (metrics.extended) {
                        var world = engine.world, bodies = Composite.allBodies(world);
                        metrics.collisions = metrics.narrowDetections;
                        metrics.pairs = engine.pairs.list.length;
                        metrics.bodies = bodies.length;
                        metrics.midEff = (metrics.narrowDetections / (metrics.midphaseTests || 1)).toFixed(2);
                        metrics.narrowEff = (metrics.narrowDetections / (metrics.narrowphaseTests || 1)).toFixed(2);
                        metrics.broadEff = (1 - metrics.broadphaseTests / (bodies.length || 1)).toFixed(2);
                        metrics.narrowReuse = (metrics.narrowReuseCount / (metrics.narrowphaseTests || 1)).toFixed(2);
                    //var broadphase = engine.broadphase[engine.broadphase.current];
                    //if (broadphase.instance)
                    //    metrics.buckets = Common.keys(broadphase.instance.buckets).length;
                    }
                };
            })();
        // @endif
        /***/ },
        /* 1529 */ /***/ function(module1, exports, __webpack_require__) {
            /**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2020 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var ALIGN_CONST = __webpack_require__(122);
            var Axes = __webpack_require__(585);
            var Bodies = __webpack_require__(126);
            var Body = __webpack_require__(71);
            var BodyBounds = __webpack_require__(1486);
            var Bounds = __webpack_require__(117);
            var Class = __webpack_require__(0);
            var Composite = __webpack_require__(163);
            var Composites = __webpack_require__(1388);
            var Constraint = __webpack_require__(246);
            var Detector = __webpack_require__(587);
            var DistanceBetween = __webpack_require__(48);
            var Factory = __webpack_require__(1488);
            var GetFastValue = __webpack_require__(2);
            var GetValue = __webpack_require__(6);
            var Grid = __webpack_require__(1394);
            var MatterAttractors = __webpack_require__(1530);
            var MatterCollisionEvents = __webpack_require__(1531);
            var MatterLib = __webpack_require__(1493);
            var MatterWrap = __webpack_require__(1532);
            var Merge = __webpack_require__(143);
            var Pair = __webpack_require__(535);
            var Pairs = __webpack_require__(1395);
            var Plugin = __webpack_require__(1392);
            var PluginCache = __webpack_require__(24);
            var Query = __webpack_require__(1494);
            var Resolver = __webpack_require__(1396);
            var SAT = __webpack_require__(588);
            var SceneEvents = __webpack_require__(21);
            var Svg = __webpack_require__(1389);
            var Vector = __webpack_require__(116);
            var Vertices = __webpack_require__(94);
            var World = __webpack_require__(1496);
            /**
 * @classdesc
 * The Phaser Matter plugin provides the ability to use the Matter JS Physics Engine within your Phaser games.
 * 
 * Unlike Arcade Physics, the other physics system provided with Phaser, Matter JS is a full-body physics system.
 * It features:
 * 
 * * Rigid bodies
 * * Compound bodies
 * * Composite bodies
 * * Concave and convex hulls
 * * Physical properties (mass, area, density etc.)
 * * Restitution (elastic and inelastic collisions)
 * * Collisions (broad-phase, mid-phase and narrow-phase)
 * * Stable stacking and resting
 * * Conservation of momentum
 * * Friction and resistance
 * * Constraints
 * * Gravity
 * * Sleeping and static bodies
 * * Rounded corners (chamfering)
 * * Views (translate, zoom)
 * * Collision queries (raycasting, region tests)
 * * Time scaling (slow-mo, speed-up)
 * 
 * Configuration of Matter is handled via the Matter World Config object, which can be passed in either the
 * Phaser Game Config, or Phaser Scene Config. Here is a basic example:
 * 
 * ```js
 * physics: {
 *     default: 'matter',
 *     matter: {
 *         enableSleeping: true,
 *         gravity: {
 *             y: 0
 *         },
 *         debug: {
 *             showBody: true,
 *             showStaticBody: true
 *         }
 *     }
 * }
 * ```
 * 
 * This class acts as an interface between a Phaser Scene and a single instance of the Matter Engine.
 * 
 * Use it to access the most common Matter features and helper functions.
 * 
 * You can find details, documentation and examples on the Matter JS website: https://brm.io/matter-js/
 *
 * @class MatterPhysics
 * @memberof Phaser.Physics.Matter
 * @constructor
 * @since 3.0.0
 *
 * @param {Phaser.Scene} scene - The Phaser Scene that owns this Matter Physics instance.
 */ var MatterPhysics = new Class({
                initialize: function MatterPhysics(scene) {
                    /**
         * The Phaser Scene that owns this Matter Physics instance
         *
         * @name Phaser.Physics.Matter.MatterPhysics#scene
         * @type {Phaser.Scene}
         * @since 3.0.0
         */ this.scene = scene;
                    /**
         * A reference to the Scene Systems that belong to the Scene owning this Matter Physics instance.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#systems
         * @type {Phaser.Scenes.Systems}
         * @since 3.0.0
         */ this.systems = scene.sys;
                    /**
         * The parsed Matter Configuration object.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#config
         * @type {Phaser.Types.Physics.Matter.MatterWorldConfig}
         * @since 3.0.0
         */ this.config = this.getConfig();
                    /**
         * An instance of the Matter World class. This class is responsible for the updating of the
         * Matter Physics world, as well as handling debug drawing functions.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#world
         * @type {Phaser.Physics.Matter.World}
         * @since 3.0.0
         */ this.world;
                    /**
         * An instance of the Matter Factory. This class provides lots of functions for creating a
         * wide variety of physics objects and adds them automatically to the Matter World.
         * 
         * You can use this class to cut-down on the amount of code required in your game, however,
         * use of the Factory is entirely optional and should be seen as a development aid. It's
         * perfectly possible to create and add components to the Matter world without using it.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#add
         * @type {Phaser.Physics.Matter.Factory}
         * @since 3.0.0
         */ this.add;
                    /**
         * An instance of the Body Bounds class. This class contains functions used for getting the
         * world position from various points around the bounds of a physics body.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodyBounds
         * @type {Phaser.Physics.Matter.BodyBounds}
         * @since 3.22.0
         */ this.bodyBounds;
                    //  Body
                    /**
         * A reference to the `Matter.Body` module.
         * 
         * The `Matter.Body` module contains methods for creating and manipulating body models.
         * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
         * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the `Bodies` module.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#body
         * @type {MatterJS.BodyFactory}
         * @since 3.18.0
         */ this.body = Body;
                    /**
         * A reference to the `Matter.Composite` module.
         * 
         * The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
         * A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
         * It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
         * Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composite
         * @type {MatterJS.CompositeFactory}
         * @since 3.22.0
         */ this.composite = Composite;
                    //  Collision:
                    /**
         * A reference to the `Matter.Detector` module.
         * 
         * The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#detector
         * @type {MatterJS.DetectorFactory}
         * @since 3.22.0
         */ this.detector = Detector;
                    /**
         * A reference to the `Matter.Grid` module.
         * 
         * The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#grid
         * @type {MatterJS.GridFactory}
         * @since 3.22.0
         */ this.grid = Grid;
                    /**
         * A reference to the `Matter.Pair` module.
         * 
         * The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pair
         * @type {MatterJS.PairFactory}
         * @since 3.22.0
         */ this.pair = Pair;
                    /**
         * A reference to the `Matter.Pairs` module.
         * 
         * The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#pairs
         * @type {MatterJS.PairsFactory}
         * @since 3.22.0
         */ this.pairs = Pairs;
                    /**
         * A reference to the `Matter.Query` module.
         * 
         * The `Matter.Query` module contains methods for performing collision queries.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#query
         * @type {MatterJS.QueryFactory}
         * @since 3.22.0
         */ this.query = Query;
                    /**
         * A reference to the `Matter.Resolver` module.
         * 
         * The `Matter.Resolver` module contains methods for resolving collision pairs.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#resolver
         * @type {MatterJS.ResolverFactory}
         * @since 3.22.0
         */ this.resolver = Resolver;
                    /**
         * A reference to the `Matter.SAT` module.
         * 
         * The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#sat
         * @type {MatterJS.SATFactory}
         * @since 3.22.0
         */ this.sat = SAT;
                    //  Constraint
                    /**
         * A reference to the `Matter.Constraint` module.
         * 
         * The `Matter.Constraint` module contains methods for creating and manipulating constraints.
         * Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
         * The stiffness of constraints can be modified to create springs or elastic.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#constraint
         * @type {MatterJS.ConstraintFactory}
         * @since 3.22.0
         */ this.constraint = Constraint;
                    //  Factory
                    /**
         * A reference to the `Matter.Bodies` module.
         * 
         * The `Matter.Bodies` module contains factory methods for creating rigid bodies
         * with commonly used body configurations (such as rectangles, circles and other polygons).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bodies
         * @type {MatterJS.BodiesFactory}
         * @since 3.18.0
         */ this.bodies = Bodies;
                    /**
         * A reference to the `Matter.Composites` module.
         * 
         * The `Matter.Composites` module contains factory methods for creating composite bodies
         * with commonly used configurations (such as stacks and chains).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#composites
         * @type {MatterJS.CompositesFactory}
         * @since 3.22.0
         */ this.composites = Composites;
                    //  Geometry
                    /**
         * A reference to the `Matter.Axes` module.
         * 
         * The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#axes
         * @type {MatterJS.AxesFactory}
         * @since 3.22.0
         */ this.axes = Axes;
                    /**
         * A reference to the `Matter.Bounds` module.
         * 
         * The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#bounds
         * @type {MatterJS.BoundsFactory}
         * @since 3.22.0
         */ this.bounds = Bounds;
                    /**
         * A reference to the `Matter.Svg` module.
         * 
         * The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
         *
         * To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
         *
         * @name Phaser.Physics.Matter.MatterPhysics#svg
         * @type {MatterJS.SvgFactory}
         * @since 3.22.0
         */ this.svg = Svg;
                    /**
         * A reference to the `Matter.Vector` module.
         * 
         * The `Matter.Vector` module contains methods for creating and manipulating vectors.
         * Vectors are the basis of all the geometry related operations in the engine.
         * A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vector
         * @type {MatterJS.VectorFactory}
         * @since 3.22.0
         */ this.vector = Vector;
                    /**
         * A reference to the `Matter.Vertices` module.
         * 
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#vertices
         * @type {MatterJS.VerticesFactory}
         * @since 3.22.0
         */ this.vertices = Vertices;
                    /**
         * A reference to the `Matter.Vertices` module.
         * 
         * The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
         * A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
         * A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
         *
         * @name Phaser.Physics.Matter.MatterPhysics#verts
         * @type {MatterJS.VerticesFactory}
         * @since 3.14.0
         */ this.verts = Vertices;
                    /**
         * An internal temp vector used for velocity and force calculations.
         *
         * @name Phaser.Physics.Matter.MatterPhysics#_tempVec2
         * @type {MatterJS.Vector}
         * @private
         * @since 3.22.0
         */ this._tempVec2 = Vector.create();
                    //  Matter plugins
                    if (GetValue(this.config, 'plugins.collisionevents', true)) this.enableCollisionEventsPlugin();
                    if (GetValue(this.config, 'plugins.attractors', false)) this.enableAttractorPlugin();
                    if (GetValue(this.config, 'plugins.wrap', false)) this.enableWrapPlugin();
                    Resolver._restingThresh = GetValue(this.config, 'restingThresh', 4);
                    Resolver._restingThreshTangent = GetValue(this.config, 'restingThreshTangent', 6);
                    Resolver._positionDampen = GetValue(this.config, 'positionDampen', 0.9);
                    Resolver._positionWarming = GetValue(this.config, 'positionWarming', 0.8);
                    Resolver._frictionNormalMultiplier = GetValue(this.config, 'frictionNormalMultiplier', 5);
                    scene.sys.events.once(SceneEvents.BOOT, this.boot, this);
                    scene.sys.events.on(SceneEvents.START, this.start, this);
                },
                /**
     * This method is called automatically, only once, when the Scene is first created.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#boot
     * @private
     * @since 3.5.1
     */ boot: function() {
                    this.world = new World(this.scene, this.config);
                    this.add = new Factory(this.world);
                    this.bodyBounds = new BodyBounds();
                    this.systems.events.once(SceneEvents.DESTROY, this.destroy, this);
                },
                /**
     * This method is called automatically by the Scene when it is starting up.
     * It is responsible for creating local systems, properties and listening for Scene events.
     * Do not invoke it directly.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#start
     * @private
     * @since 3.5.0
     */ start: function() {
                    if (!this.world) {
                        this.world = new World(this.scene, this.config);
                        this.add = new Factory(this.world);
                    }
                    var eventEmitter = this.systems.events;
                    eventEmitter.on(SceneEvents.UPDATE, this.world.update, this.world);
                    eventEmitter.on(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    eventEmitter.once(SceneEvents.SHUTDOWN, this.shutdown, this);
                },
                /**
     * This internal method is called when this class starts and retrieves the final Matter World Config.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConfig
     * @since 3.0.0
     *
     * @return {Phaser.Types.Physics.Matter.MatterWorldConfig} The Matter World Config.
     */ getConfig: function() {
                    var gameConfig = this.systems.game.config.physics;
                    var sceneConfig = this.systems.settings.physics;
                    var config = Merge(GetFastValue(sceneConfig, 'matter', {}), GetFastValue(gameConfig, 'matter', {}));
                    return config;
                },
                /**
     * Enables the Matter Attractors Plugin.
     * 
     * The attractors plugin that makes it easy to apply continual forces on bodies.
     * It's possible to simulate effects such as wind, gravity and magnetism.
     * 
     * https://github.com/liabru/matter-attractors
     * 
     * This method is called automatically if `plugins.attractors` is set in the Matter World Config.
     * However, you can also call it directly from within your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableAttractorPlugin
     * @since 3.0.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableAttractorPlugin: function() {
                    Plugin.register(MatterAttractors);
                    Plugin.use(MatterLib, MatterAttractors);
                    return this;
                },
                /**
     * Enables the Matter Wrap Plugin.
     * 
     * The coordinate wrapping plugin that automatically wraps the position of bodies such that they always stay
     * within the given bounds. Upon crossing a boundary the body will appear on the opposite side of the bounds,
     * while maintaining its velocity.
     * 
     * https://github.com/liabru/matter-wrap
     * 
     * This method is called automatically if `plugins.wrap` is set in the Matter World Config.
     * However, you can also call it directly from within your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableWrapPlugin
     * @since 3.0.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableWrapPlugin: function() {
                    Plugin.register(MatterWrap);
                    Plugin.use(MatterLib, MatterWrap);
                    return this;
                },
                /**
     * Enables the Matter Collision Events Plugin.
     * 
     * Note that this plugin is enabled by default. So you should only ever need to call this
     * method if you have specifically disabled the plugin in your Matter World Config.
     * You can disable it by setting `plugins.collisionevents: false` in your Matter World Config.
     * 
     * This plugin triggers three new events on Matter.Body:
     * 
     * 1. `onCollide`
     * 2. `onCollideEnd`
     * 3. `onCollideActive`
     * 
     * These events correspond to the Matter.js events `collisionStart`, `collisionActive` and `collisionEnd`, respectively.
     * You can listen to these events via Matter.Events or they will also be emitted from the Matter World.
     * 
     * This plugin also extends Matter.Body with three convenience functions:
     * 
     * `Matter.Body.setOnCollide(callback)`
     * `Matter.Body.setOnCollideEnd(callback)`
     * `Matter.Body.setOnCollideActive(callback)`
     * 
     * You can register event callbacks by providing a function of type (pair: Matter.Pair) => void
     * 
     * https://github.com/dxu/matter-collision-events
     *
     * @method Phaser.Physics.Matter.MatterPhysics#enableCollisionEventsPlugin
     * @since 3.22.0
     * 
     * @return {this} This Matter Physics instance.
     */ enableCollisionEventsPlugin: function() {
                    Plugin.register(MatterCollisionEvents);
                    Plugin.use(MatterLib, MatterCollisionEvents);
                    return this;
                },
                /**
     * Pauses the Matter World instance and sets `enabled` to `false`.
     * 
     * A paused world will not run any simulations for the duration it is paused.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#pause
     * @fires Phaser.Physics.Matter.Events#PAUSE
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ pause: function() {
                    return this.world.pause();
                },
                /**
     * Resumes this Matter World instance from a paused state and sets `enabled` to `true`.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#resume
     * @since 3.0.0
     *
     * @return {Phaser.Physics.Matter.World} The Matter World object.
     */ resume: function() {
                    return this.world.resume();
                },
                /**
     * Sets the Matter Engine to run at fixed timestep of 60Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set60Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set60Hz: function() {
                    this.world.getDelta = this.world.update60Hz;
                    this.world.autoUpdate = true;
                    return this;
                },
                /**
     * Sets the Matter Engine to run at fixed timestep of 30Hz and enables `autoUpdate`.
     * If you have set a custom `getDelta` function then this will override it.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#set30Hz
     * @since 3.4.0
     *
     * @return {this} This Matter Physics instance.
     */ set30Hz: function() {
                    this.world.getDelta = this.world.update30Hz;
                    this.world.autoUpdate = true;
                    return this;
                },
                /**
     * Manually advances the physics simulation by one iteration.
     * 
     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
     * If undefined they use the Matter defaults of 60Hz and no correction.
     * 
     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
     * 
     * It also ignores any custom `getDelta` functions, as you should be passing the delta
     * value in to this call.
     *
     * You can adjust the number of iterations that Engine.update performs internally.
     * Use the Scene Matter Physics config object to set the following properties:
     *
     * positionIterations (defaults to 6)
     * velocityIterations (defaults to 4)
     * constraintIterations (defaults to 2)
     *
     * Adjusting these values can help performance in certain situations, depending on the physics requirements
     * of your game.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#step
     * @since 3.4.0
     *
     * @param {number} [delta=16.666] - The delta value.
     * @param {number} [correction=1] - Optional delta correction value.
     */ step: function(delta, correction) {
                    this.world.step(delta, correction);
                },
                /**
     * Checks if the vertices of the given body, or an array of bodies, contains the given point, or not.
     * 
     * You can pass in either a single body, or an array of bodies to be checked. This method will
     * return `true` if _any_ of the bodies in the array contain the point. See the `intersectPoint` method if you need
     * to get a list of intersecting bodies.
     * 
     * The point should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use points from another system you may need to
     * transform them before passing them.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#containsPoint
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} body - The body, or an array of bodies, to check against the point.
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     * 
     * @return {boolean} `true` if the point is within one of the bodies given, otherwise `false`.
     */ containsPoint: function(body, x, y) {
                    body = this.getMatterBodies(body);
                    var position = Vector.create(x, y);
                    var result = Query.point(body, position);
                    return result.length > 0 ? true : false;
                },
                /**
     * Checks the given coordinates to see if any vertices of the given bodies contain it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     * 
     * The coordinates should be transformed into the Matter World coordinate system in advance. This happens by
     * default with Input Pointers, but if you wish to use coordinates from another system you may need to
     * transform them before passing them.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectPoint
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the point.
     * @param {number} y - The vertical coordinate of the point.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies which contain the given point.
     */ intersectPoint: function(x, y, bodies) {
                    bodies = this.getMatterBodies(bodies);
                    var position = Vector.create(x, y);
                    var output = [];
                    var result = Query.point(bodies, position);
                    result.forEach(function(body) {
                        if (output.indexOf(body) === -1) output.push(body);
                    });
                    return output;
                },
                /**
     * Checks the given rectangular area to see if any vertices of the given bodies intersect with it.
     * Or, if the `outside` parameter is set to `true`, it checks to see which bodies do not
     * intersect with it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World, including within Composites.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRect
     * @since 3.22.0
     *
     * @param {number} x - The horizontal coordinate of the top-left of the area.
     * @param {number} y - The vertical coordinate of the top-left of the area.
     * @param {number} width - The width of the area.
     * @param {number} height - The height of the area.
     * @param {boolean} [outside=false] - If `false` it checks for vertices inside the area, if `true` it checks for vertices outside the area.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies that intersect with the given area.
     */ intersectRect: function(x, y, width, height, outside, bodies) {
                    if (outside === undefined) outside = false;
                    bodies = this.getMatterBodies(bodies);
                    var bounds = {
                        min: {
                            x: x,
                            y: y
                        },
                        max: {
                            x: x + width,
                            y: y + height
                        }
                    };
                    var output = [];
                    var result = Query.region(bodies, bounds, outside);
                    result.forEach(function(body) {
                        if (output.indexOf(body) === -1) output.push(body);
                    });
                    return output;
                },
                /**
     * Checks the given ray segment to see if any vertices of the given bodies intersect with it.
     * 
     * If no bodies are provided it will search all bodies in the Matter World.
     * 
     * The width of the ray can be specified via the `rayWidth` parameter.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectRay
     * @since 3.22.0
     *
     * @param {number} x1 - The horizontal coordinate of the start of the ray segment.
     * @param {number} y1 - The vertical coordinate of the start of the ray segment.
     * @param {number} x2 - The horizontal coordinate of the end of the ray segment.
     * @param {number} y2 - The vertical coordinate of the end of the ray segment.
     * @param {number} [rayWidth=1] - The width of the ray segment.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with the ray segment.
     */ intersectRay: function(x1, y1, x2, y2, rayWidth, bodies) {
                    if (rayWidth === undefined) rayWidth = 1;
                    bodies = this.getMatterBodies(bodies);
                    var result = [];
                    var collisions = Query.ray(bodies, Vector.create(x1, y1), Vector.create(x2, y2), rayWidth);
                    for(var i = 0; i < collisions.length; i++)result.push(collisions[i].body);
                    return result;
                },
                /**
     * Checks the given Matter Body to see if it intersects with any of the given bodies.
     * 
     * If no bodies are provided it will check against all bodies in the Matter World.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#intersectBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The target body.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - An array of bodies to check the target body against. If not provided it will search all bodies in the world.
     * 
     * @return {Phaser.Types.Physics.Matter.MatterBody[]} An array of bodies whos vertices intersect with target body.
     */ intersectBody: function(body, bodies) {
                    bodies = this.getMatterBodies(bodies);
                    var result = [];
                    var collisions = Query.collides(body, bodies);
                    for(var i = 0; i < collisions.length; i++){
                        var pair = collisions[i];
                        if (pair.bodyA === body) result.push(pair.bodyB);
                        else result.push(pair.bodyA);
                    }
                    return result;
                },
                /**
     * Checks to see if the target body, or an array of target bodies, intersects with any of the given bodies.
     * 
     * If intersection occurs this method will return `true` and, if provided, invoke the callbacks.
     * 
     * If no bodies are provided for the second parameter the target will check again all bodies in the Matter World.
     * 
     * Note that bodies can only overlap if they are in non-colliding collision groups or categories.
     * 
     * If you provide a `processCallback` then the two bodies that overlap are sent to it. This callback
     * must return a boolean and is used to allow you to perform additional processing tests before a final
     * outcome is decided. If it returns `true` then the bodies are finally passed to the `overlapCallback`, if set.
     * 
     * If you provide an `overlapCallback` then the matching pairs of overlapping bodies will be sent to it.
     * 
     * Both callbacks have the following signature: `function (bodyA, bodyB, collisionInfo)` where `bodyA` is always
     * the target body. The `collisionInfo` object contains additional data, such as the angle and depth of penetration.
     * 
     * @method Phaser.Physics.Matter.MatterPhysics#overlap
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} target - The target body, or array of target bodies, to check.
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} [bodies] - The second body, or array of bodies, to check. If falsey it will check against all bodies in the world.
     * @param {ArcadePhysicsCallback} [overlapCallback] - An optional callback function that is called if the bodies overlap.
     * @param {ArcadePhysicsCallback} [processCallback] - An optional callback function that lets you perform additional checks against the two bodies if they overlap. If this is set then `overlapCallback` will only be invoked if this callback returns `true`.
     * @param {*} [callbackContext] - The context, or scope, in which to run the callbacks.
     * 
     * @return {boolean} `true` if the target body intersects with _any_ of the bodies given, otherwise `false`.
     */ overlap: function(target, bodies, overlapCallback, processCallback, callbackContext) {
                    if (overlapCallback === undefined) overlapCallback = null;
                    if (processCallback === undefined) processCallback = null;
                    if (callbackContext === undefined) callbackContext = overlapCallback;
                    if (!Array.isArray(target)) target = [
                        target
                    ];
                    target = this.getMatterBodies(target);
                    bodies = this.getMatterBodies(bodies);
                    var match = false;
                    for(var i = 0; i < target.length; i++){
                        var entry = target[i];
                        var collisions = Query.collides(entry, bodies);
                        for(var c = 0; c < collisions.length; c++){
                            var info = collisions[c];
                            var bodyB = info.bodyA.id === entry.id ? info.bodyB : info.bodyA;
                            if (!processCallback || processCallback.call(callbackContext, entry, bodyB, info)) {
                                match = true;
                                if (overlapCallback) overlapCallback.call(callbackContext, entry, bodyB, info);
                                else if (!processCallback) //  If there are no callbacks we don't need to test every body, just exit when the first is found
                                return true;
                            }
                        }
                    }
                    return match;
                },
                /**
     * Sets the collision filter category of all given Matter Bodies to the given value.
     * 
     * This number must be a power of two between 2^0 (= 1) and 2^31.
     * 
     * Bodies with different collision groups (see {@link #setCollisionGroup}) will only collide if their collision
     * categories are included in their collision masks (see {@link #setCollidesWith}).
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionCategory
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique category bitfield.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionCategory: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        body.collisionFilter.category = value;
                    });
                    return this;
                },
                /**
     * Sets the collision filter group of all given Matter Bodies to the given value.
     * 
     * If the group value is zero, or if two Matter Bodies have different group values,
     * they will collide according to the usual collision filter rules (see {@link #setCollisionCategory} and {@link #setCollisionGroup}).
     * 
     * If two Matter Bodies have the same positive group value, they will always collide;
     * if they have the same negative group value they will never collide.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollisionGroup
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - Unique group index.
     *
     * @return {this} This Matter Physics instance.
     */ setCollisionGroup: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        body.collisionFilter.group = value;
                    });
                    return this;
                },
                /**
     * Sets the collision filter mask of all given Matter Bodies to the given value.
     * 
     * Two Matter Bodies with different collision groups will only collide if each one includes the others
     * category in its mask based on a bitwise AND operation: `(categoryA & maskB) !== 0` and 
     * `(categoryB & maskA) !== 0` are both true.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setCollidesWith
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody[]} bodies - An array of bodies to update. If falsey it will use all bodies in the world.
     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
     *
     * @return {this} This Matter Physics instance.
     */ setCollidesWith: function(bodies, categories) {
                    bodies = this.getMatterBodies(bodies);
                    var flags = 0;
                    if (!Array.isArray(categories)) flags = categories;
                    else for(var i = 0; i < categories.length; i++)flags |= categories[i];
                    bodies.forEach(function(body) {
                        body.collisionFilter.mask = flags;
                    });
                    return this;
                },
                /**
     * Takes an array and returns a new array made from all of the Matter Bodies found in the original array.
     * 
     * For example, passing in Matter Game Objects, such as a bunch of Matter Sprites, to this method, would
     * return an array containing all of their native Matter Body objects.
     * 
     * If the `bodies` argument is falsey, it will return all bodies in the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getMatterBodies
     * @since 3.22.0
     *
     * @param {array} [bodies] - An array of objects to extract the bodies from. If falsey, it will return all bodies in the world.
     *
     * @return {MatterJS.BodyType[]} An array of native Matter Body objects.
     */ getMatterBodies: function(bodies) {
                    if (!bodies) return this.world.getAllBodies();
                    if (!Array.isArray(bodies)) bodies = [
                        bodies
                    ];
                    var output = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i].hasOwnProperty('body') ? bodies[i].body : bodies[i];
                        output.push(body);
                    }
                    return output;
                },
                /**
     * Sets both the horizontal and vertical linear velocity of the physics bodies.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocity: function(bodies, x, y) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.x = x;
                    vec2.y = y;
                    bodies.forEach(function(body) {
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets just the horizontal linear velocity of the physics bodies.
     * The vertical velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityX
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} x - The horizontal linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityX: function(bodies, x) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.x = x;
                    bodies.forEach(function(body) {
                        vec2.y = body.velocity.y;
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets just the vertical linear velocity of the physics bodies.
     * The horizontal velocity of the body is unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setVelocityY
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} y - The vertical linear velocity value.
     *
     * @return {this} This Matter Physics instance.
     */ setVelocityY: function(bodies, y) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    vec2.y = y;
                    bodies.forEach(function(body) {
                        vec2.x = body.velocity.x;
                        Body.setVelocity(body, vec2);
                    });
                    return this;
                },
                /**
     * Sets the angular velocity of the bodies instantly.
     * Position, angle, force etc. are unchanged.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#setAngularVelocity
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} value - The angular velocity.
     *
     * @return {this} This Matter Physics instance.
     */ setAngularVelocity: function(bodies, value) {
                    bodies = this.getMatterBodies(bodies);
                    bodies.forEach(function(body) {
                        Body.setAngularVelocity(body, value);
                    });
                    return this;
                },
                /**
     * Applies a force to a body, at the bodies current position, including resulting torque.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForce
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} force - A Vector that specifies the force to apply.
     *
     * @return {this} This Matter Physics instance.
     */ applyForce: function(bodies, force) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        vec2.x = body.position.x;
                        vec2.y = body.position.y;
                        Body.applyForce(body, vec2, force);
                    });
                    return this;
                },
                /**
     * Applies a force to a body, from the given world position, including resulting torque.
     * If no angle is given, the current body angle is used.
     * 
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromPosition
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {Phaser.Types.Math.Vector2Like} position - A Vector that specifies the world-space position to apply the force at.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromPosition: function(bodies, position, speed, angle) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        if (angle === undefined) angle = body.angle;
                        vec2.x = speed * Math.cos(angle);
                        vec2.y = speed * Math.sin(angle);
                        Body.applyForce(body, position, vec2);
                    });
                    return this;
                },
                /**
     * Apply a force to a body based on the given angle and speed.
     * If no angle is given, the current body angle is used.
     * 
     * Use very small speed values, such as 0.1, depending on the mass and required velocity.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#applyForceFromAngle
     * @since 3.22.0
     *
     * @param {(Phaser.Types.Physics.Matter.MatterBody|Phaser.Types.Physics.Matter.MatterBody[])} bodies - Either a single Body, or an array of bodies to update. If falsey it will use all bodies in the world.
     * @param {number} speed - A speed value to be applied to a directional force.
     * @param {number} [angle] - The angle, in radians, to apply the force from. Leave undefined to use the current body angle.
     *
     * @return {this} This Matter Physics instance.
     */ applyForceFromAngle: function(bodies, speed, angle) {
                    bodies = this.getMatterBodies(bodies);
                    var vec2 = this._tempVec2;
                    bodies.forEach(function(body) {
                        if (angle === undefined) angle = body.angle;
                        vec2.x = speed * Math.cos(angle);
                        vec2.y = speed * Math.sin(angle);
                        Body.applyForce(body, {
                            x: body.position.x,
                            y: body.position.y
                        }, vec2);
                    });
                    return this;
                },
                /**
     * Returns the length of the given constraint, which is the distance between the two points.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#getConstraintLength
     * @since 3.22.0
     *
     * @param {MatterJS.ConstraintType} constraint - The constraint to get the length from.
     *
     * @return {number} The length of the constraint.
     */ getConstraintLength: function(constraint) {
                    var aX = constraint.pointA.x;
                    var aY = constraint.pointA.y;
                    var bX = constraint.pointB.x;
                    var bY = constraint.pointB.y;
                    if (constraint.bodyA) {
                        aX += constraint.bodyA.position.x;
                        aY += constraint.bodyA.position.y;
                    }
                    if (constraint.bodyB) {
                        bX += constraint.bodyB.position.x;
                        bY += constraint.bodyB.position.y;
                    }
                    return DistanceBetween(aX, aY, bX, bY);
                },
                /**
     * Aligns a Body, or Matter Game Object, against the given coordinates.
     * 
     * The alignment takes place using the body bounds, which take into consideration things
     * like body scale and rotation.
     * 
     * Although a Body has a `position` property, it is based on the center of mass for the body,
     * not a dimension based center. This makes aligning bodies difficult, especially if they have
     * rotated or scaled. This method will derive the correct position based on the body bounds and
     * its center of mass offset, in order to align the body with the given coordinate.
     * 
     * For example, if you wanted to align a body so it sat in the bottom-center of the
     * Scene, and the world was 800 x 600 in size:
     * 
     * ```javascript
     * this.matter.alignBody(body, 400, 600, Phaser.Display.Align.BOTTOM_CENTER);
     * ```
     * 
     * You pass in 400 for the x coordinate, because that is the center of the world, and 600 for
     * the y coordinate, as that is the base of the world.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#alignBody
     * @since 3.22.0
     *
     * @param {Phaser.Types.Physics.Matter.MatterBody} body - The Body to align.
     * @param {number} x - The horizontal position to align the body to.
     * @param {number} y - The vertical position to align the body to.
     * @param {number} align - One of the `Phaser.Display.Align` constants, such as `Phaser.Display.Align.TOP_LEFT`.
     *
     * @return {this} This Matter Physics instance.
     */ alignBody: function(body, x, y, align) {
                    body = body.hasOwnProperty('body') ? body.body : body;
                    var pos;
                    switch(align){
                        case ALIGN_CONST.TOP_LEFT:
                        case ALIGN_CONST.LEFT_TOP:
                            pos = this.bodyBounds.getTopLeft(body, x, y);
                            break;
                        case ALIGN_CONST.TOP_CENTER:
                            pos = this.bodyBounds.getTopCenter(body, x, y);
                            break;
                        case ALIGN_CONST.TOP_RIGHT:
                        case ALIGN_CONST.RIGHT_TOP:
                            pos = this.bodyBounds.getTopRight(body, x, y);
                            break;
                        case ALIGN_CONST.LEFT_CENTER:
                            pos = this.bodyBounds.getLeftCenter(body, x, y);
                            break;
                        case ALIGN_CONST.CENTER:
                            pos = this.bodyBounds.getCenter(body, x, y);
                            break;
                        case ALIGN_CONST.RIGHT_CENTER:
                            pos = this.bodyBounds.getRightCenter(body, x, y);
                            break;
                        case ALIGN_CONST.LEFT_BOTTOM:
                        case ALIGN_CONST.BOTTOM_LEFT:
                            pos = this.bodyBounds.getBottomLeft(body, x, y);
                            break;
                        case ALIGN_CONST.BOTTOM_CENTER:
                            pos = this.bodyBounds.getBottomCenter(body, x, y);
                            break;
                        case ALIGN_CONST.BOTTOM_RIGHT:
                        case ALIGN_CONST.RIGHT_BOTTOM:
                            pos = this.bodyBounds.getBottomRight(body, x, y);
                            break;
                    }
                    if (pos) Body.setPosition(body, pos);
                    return this;
                },
                /**
     * The Scene that owns this plugin is shutting down.
     * We need to kill and reset all internal properties as well as stop listening to Scene events.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#shutdown
     * @private
     * @since 3.0.0
     */ shutdown: function() {
                    var eventEmitter = this.systems.events;
                    if (this.world) {
                        eventEmitter.off(SceneEvents.UPDATE, this.world.update, this.world);
                        eventEmitter.off(SceneEvents.POST_UPDATE, this.world.postUpdate, this.world);
                    }
                    eventEmitter.off(SceneEvents.SHUTDOWN, this.shutdown, this);
                    if (this.add) this.add.destroy();
                    if (this.world) this.world.destroy();
                    this.add = null;
                    this.world = null;
                },
                /**
     * The Scene that owns this plugin is being destroyed.
     * We need to shutdown and then kill off all external references.
     *
     * @method Phaser.Physics.Matter.MatterPhysics#destroy
     * @private
     * @since 3.0.0
     */ destroy: function() {
                    this.shutdown();
                    this.scene.sys.events.off(SceneEvents.START, this.start, this);
                    this.scene = null;
                    this.systems = null;
                }
            });
            PluginCache.register('MatterPhysics', MatterPhysics, 'matterPhysics');
            module1.exports = MatterPhysics;
        /***/ },
        /* 1530 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = __webpack_require__(1391);
            /**
 * An attractors plugin for matter.js.
 * See the readme for usage and examples.
 * @module MatterAttractors
 */ var MatterAttractors = {
                name: 'matter-attractors',
                version: '0.1.7',
                for: 'matter-js@^0.14.2',
                silent: true,
                // installs the plugin where `base` is `Matter`
                // you should not need to call this directly.
                install: function(base) {
                    base.after('Body.create', function() {
                        MatterAttractors.Body.init(this);
                    });
                    base.before('Engine.update', function(engine) {
                        MatterAttractors.Engine.update(engine);
                    });
                },
                Body: {
                    /**
         * Initialises the `body` to support attractors.
         * This is called automatically by the plugin.
         * @function MatterAttractors.Body.init
         * @param {Matter.Body} body The body to init.
         * @returns {void} No return value.
         */ init: function(body) {
                        body.plugin.attractors = body.plugin.attractors || [];
                    }
                },
                Engine: {
                    /**
         * Applies all attractors for all bodies in the `engine`.
         * This is called automatically by the plugin.
         * @function MatterAttractors.Engine.update
         * @param {Matter.Engine} engine The engine to update.
         * @returns {void} No return value.
         */ update: function(engine) {
                        var bodies = Matter.Composite.allBodies(engine.world);
                        for(var i = 0; i < bodies.length; i++){
                            var bodyA = bodies[i];
                            var attractors = bodyA.plugin.attractors;
                            if (attractors && attractors.length > 0) for(var j = 0; j < bodies.length; j++){
                                var bodyB = bodies[j];
                                if (i !== j) for(var k = 0; k < attractors.length; k++){
                                    var attractor = attractors[k];
                                    var forceVector = attractor;
                                    if (Matter.Common.isFunction(attractor)) forceVector = attractor(bodyA, bodyB);
                                    if (forceVector) Matter.Body.applyForce(bodyB, bodyB.position, forceVector);
                                }
                            }
                        }
                    }
                },
                /**
     * Defines some useful common attractor functions that can be used
     * by pushing them to your body's `body.plugin.attractors` array.
     * @namespace MatterAttractors.Attractors
     * @property {number} gravityConstant The gravitational constant used by the gravity attractor.
     */ Attractors: {
                    gravityConstant: 0.001,
                    /**
         * An attractor function that applies Newton's law of gravitation.
         * Use this by pushing `MatterAttractors.Attractors.gravity` to your body's `body.plugin.attractors` array.
         * The gravitational constant defaults to `0.001` which you can change
         * at `MatterAttractors.Attractors.gravityConstant`.
         * @function MatterAttractors.Attractors.gravity
         * @param {Matter.Body} bodyA The first body.
         * @param {Matter.Body} bodyB The second body.
         * @returns {void} No return value.
         */ gravity: function(bodyA, bodyB) {
                        // use Newton's law of gravitation
                        var bToA = Matter.Vector.sub(bodyB.position, bodyA.position);
                        var distanceSq = Matter.Vector.magnitudeSquared(bToA) || 0.0001;
                        var normal = Matter.Vector.normalise(bToA);
                        var magnitude = -MatterAttractors.Attractors.gravityConstant * (bodyA.mass * bodyB.mass / distanceSq);
                        var force = Matter.Vector.mult(normal, magnitude);
                        // to apply forces to both bodies
                        Matter.Body.applyForce(bodyA, bodyA.position, Matter.Vector.neg(force));
                        Matter.Body.applyForce(bodyB, bodyB.position, force);
                    }
                }
            };
            module1.exports = MatterAttractors;
        /**
 * @namespace Matter.Body
 * @see http://brm.io/matter-js/docs/classes/Body.html
 */ /**
 * This plugin adds a new property `body.plugin.attractors` to instances of `Matter.Body`.
 * This is an array of callback functions that will be called automatically
 * for every pair of bodies, on every engine update.
 * @property {Function[]} body.plugin.attractors
 * @memberof Matter.Body
 */ /**
 * An attractor function calculates the force to be applied
 * to `bodyB`, it should either:
 * - return the force vector to be applied to `bodyB`
 * - or apply the force to the body(s) itself
 * @callback AttractorFunction
 * @param {Matter.Body} bodyA
 * @param {Matter.Body} bodyB
 * @returns {(Vector|undefined)} a force vector (optional)
 */ /***/ },
        /* 1531 */ /***/ function(module1, exports) {
            /**
 * @author       @dxu https://github.com/dxu/matter-collision-events
 * @author       Richard Davey <rich@photonstorm.com>
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */ var MatterCollisionEvents = {
                name: 'matter-collision-events',
                version: '0.1.6',
                for: 'matter-js@^0.14.2',
                silent: true,
                install: function(matter) {
                    matter.after('Engine.create', function() {
                        matter.Events.on(this, 'collisionStart', function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collide', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collide', bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, 'onCollide', {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, 'onCollide', {
                                    pair: pair
                                });
                                if (bodyA.onCollideCallback) bodyA.onCollideCallback(pair);
                                if (bodyB.onCollideCallback) bodyB.onCollideCallback(pair);
                                if (bodyA.onCollideWith[bodyB.id]) bodyA.onCollideWith[bodyB.id](bodyB, pair);
                                if (bodyB.onCollideWith[bodyA.id]) bodyB.onCollideWith[bodyA.id](bodyA, pair);
                            });
                        });
                        matter.Events.on(this, 'collisionActive', function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collideActive', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collideActive', bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, 'onCollideActive', {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, 'onCollideActive', {
                                    pair: pair
                                });
                                if (bodyA.onCollideActiveCallback) bodyA.onCollideActiveCallback(pair);
                                if (bodyB.onCollideActiveCallback) bodyB.onCollideActiveCallback(pair);
                            });
                        });
                        matter.Events.on(this, 'collisionEnd', function(event) {
                            event.pairs.map(function(pair) {
                                var bodyA = pair.bodyA;
                                var bodyB = pair.bodyB;
                                if (bodyA.gameObject) bodyA.gameObject.emit('collideEnd', bodyA, bodyB, pair);
                                if (bodyB.gameObject) bodyB.gameObject.emit('collideEnd', bodyB, bodyA, pair);
                                matter.Events.trigger(bodyA, 'onCollideEnd', {
                                    pair: pair
                                });
                                matter.Events.trigger(bodyB, 'onCollideEnd', {
                                    pair: pair
                                });
                                if (bodyA.onCollideEndCallback) bodyA.onCollideEndCallback(pair);
                                if (bodyB.onCollideEndCallback) bodyB.onCollideEndCallback(pair);
                            });
                        });
                    });
                }
            };
            module1.exports = MatterCollisionEvents;
        /***/ },
        /* 1532 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = __webpack_require__(1391);
            /**
 * A coordinate wrapping plugin for matter.js.
 * See the readme for usage and examples.
 * @module MatterWrap
 */ var MatterWrap = {
                // plugin meta
                name: 'matter-wrap',
                version: '0.1.4',
                for: 'matter-js@^0.14.2',
                silent: true,
                // installs the plugin where `base` is `Matter`
                // you should not need to call this directly.
                install: function(base) {
                    base.after('Engine.update', function() {
                        MatterWrap.Engine.update(this);
                    });
                },
                Engine: {
                    /**
     * Updates the engine by wrapping bodies and composites inside `engine.world`.
     * This is called automatically by the plugin.
     * @function MatterWrap.Engine.update
     * @param {Matter.Engine} engine The engine to update.
     * @returns {void} No return value.
     */ update: function(engine) {
                        var world = engine.world, bodies = Matter.Composite.allBodies(world), composites = Matter.Composite.allComposites(world);
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            if (body.plugin.wrap) MatterWrap.Body.wrap(body, body.plugin.wrap);
                        }
                        for(i = 0; i < composites.length; i += 1){
                            var composite = composites[i];
                            if (composite.plugin.wrap) MatterWrap.Composite.wrap(composite, composite.plugin.wrap);
                        }
                    }
                },
                Bounds: {
                    /**
     * Returns a translation vector that wraps the `objectBounds` inside the `bounds`.
     * @function MatterWrap.Bounds.wrap
     * @param {Matter.Bounds} objectBounds The bounds of the object to wrap inside the bounds.
     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
     * @returns {?Matter.Vector} A translation vector (only if wrapping is required).
     */ wrap: function(objectBounds, bounds) {
                        var x = null, y = null;
                        if (typeof bounds.min.x !== 'undefined' && typeof bounds.max.x !== 'undefined') {
                            if (objectBounds.min.x > bounds.max.x) x = bounds.min.x - objectBounds.max.x;
                            else if (objectBounds.max.x < bounds.min.x) x = bounds.max.x - objectBounds.min.x;
                        }
                        if (typeof bounds.min.y !== 'undefined' && typeof bounds.max.y !== 'undefined') {
                            if (objectBounds.min.y > bounds.max.y) y = bounds.min.y - objectBounds.max.y;
                            else if (objectBounds.max.y < bounds.min.y) y = bounds.max.y - objectBounds.min.y;
                        }
                        if (x !== null || y !== null) return {
                            x: x || 0,
                            y: y || 0
                        };
                    }
                },
                Body: {
                    /**
     * Wraps the `body` position such that it always stays within the given bounds. 
     * Upon crossing a boundary the body will appear on the opposite side of the bounds, 
     * while maintaining its velocity.
     * This is called automatically by the plugin.
     * @function MatterWrap.Body.wrap
     * @param {Matter.Body} body The body to wrap.
     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ wrap: function(body, bounds) {
                        var translation = MatterWrap.Bounds.wrap(body.bounds, bounds);
                        if (translation) Matter.Body.translate(body, translation);
                        return translation;
                    }
                },
                Composite: {
                    /**
     * Returns the union of the bounds of all of the composite's bodies
     * (not accounting for constraints).
     * @function MatterWrap.Composite.bounds
     * @param {Matter.Composite} composite The composite.
     * @returns {Matter.Bounds} The composite bounds.
     */ bounds: function(composite) {
                        var bodies = Matter.Composite.allBodies(composite), vertices = [];
                        for(var i = 0; i < bodies.length; i += 1){
                            var body = bodies[i];
                            vertices.push(body.bounds.min, body.bounds.max);
                        }
                        return Matter.Bounds.create(vertices);
                    },
                    /**
     * Wraps the `composite` position such that it always stays within the given bounds. 
     * Upon crossing a boundary the composite will appear on the opposite side of the bounds, 
     * while maintaining its velocity.
     * This is called automatically by the plugin.
     * @function MatterWrap.Composite.wrap
     * @param {Matter.Composite} composite The composite to wrap.
     * @param {Matter.Bounds} bounds The bounds to wrap the composite inside.
     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
     */ wrap: function(composite, bounds) {
                        var translation = MatterWrap.Bounds.wrap(MatterWrap.Composite.bounds(composite), bounds);
                        if (translation) Matter.Composite.translate(composite, translation);
                        return translation;
                    }
                }
            };
            module1.exports = MatterWrap;
        /**
 * @namespace Matter.Body
 * @see http://brm.io/matter-js/docs/classes/Body.html
 */ /**
 * This plugin adds a new property `body.plugin.wrap` to instances of `Matter.Body`.  
 * This is a `Matter.Bounds` instance that specifies the wrapping region.
 * @property {Matter.Bounds} body.plugin.wrap
 * @memberof Matter.Body
 */ /**
 * This plugin adds a new property `composite.plugin.wrap` to instances of `Matter.Composite`.  
 * This is a `Matter.Bounds` instance that specifies the wrapping region.
 * @property {Matter.Bounds} composite.plugin.wrap
 * @memberof Matter.Composite
 */ /***/ }
    ]);
});




var $99470a54dfca5d81$exports = {};
$99470a54dfca5d81$exports = $parcel$resolve("533vU");


var $0b1a559fd7d0e027$exports = {};
$0b1a559fd7d0e027$exports = $parcel$resolve("j5dWA");


const $29344f62a7f81f67$var$progress_id = "load-progress";
function $29344f62a7f81f67$var$logProgress(progress) {
    let bar = document.getElementById($29344f62a7f81f67$var$progress_id);
    bar.setAttribute("value", progress);
    bar.innerText = `${(progress * 100).toFixed(0)}%`;
    if (progress >= 1) setTimeout(()=>{
        if (parseFloat(bar.getAttribute("value")) >= 1 && bar.classList.contains("visible")) bar.removeAttribute("value");
    }, 5000);
}
/**
 * setProgress(true) will end progress logging
 * setProgress(false) will start progress logging
 */ function $29344f62a7f81f67$var$setProgress(complete) {
    let bar = document.getElementById($29344f62a7f81f67$var$progress_id);
    if (complete) {
        bar.classList.remove("visible");
        bar.classList.add("hidden");
    } else {
        bar.classList.remove("hidden");
        bar.classList.add("visible");
    }
}
class $29344f62a7f81f67$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Scene {
    preload() {
        // console.table(images);
        // for (const key in images) {
        //   this.load.image(key, images[key]);
        // }
        this.load.image("planet", (0, (/*@__PURE__*/$parcel$interopDefault($99470a54dfca5d81$exports))));
        this.load.image("ares", (0, (/*@__PURE__*/$parcel$interopDefault($0b1a559fd7d0e027$exports))));
        $29344f62a7f81f67$var$setProgress(false);
        this.load.on("progress", $29344f62a7f81f67$var$logProgress);
        this.load.on("fileprogress", (file)=>console.log(`loaded ${file.key} from ${file.src}`));
        this.load.on("complete", ()=>$29344f62a7f81f67$var$setProgress(true));
    }
    create() {
        let centerX = this.cameras.main.displayWidth / 2;
        let centerY = this.cameras.main.displayHeight / 2;
        this.add.text(centerX, centerY / 2, "ExFour", {
            align: "center",
            fill: "white",
            fontFamily: "monospace",
            fontSize: 48
        }).setOrigin(0.5, 0.5);
    // let planet = this.add
    //   .image(centerX, centerY, "planet")
    //   .setDisplaySize(96, 96)
    //   .setOrigin(0.5, 0.5)
    //   .setInteractive();
    // planet.on("pointerdown", () => this.scene.switch("game"));
    }
    update(time, delta) {
        this.scene.start("game");
    }
    constructor(){
        super({
            key: "menu"
        });
    }
}




/**
 * Remove a given element from a given array
 * @param {Array<?>} array
 * @param {?} element
 */ function $179d01b24c3beda4$export$30a014203d0d7e4f(array, element) {
    let index = array.indexOf(element);
    if (index > -1) return array.splice(index, 1);
}
function $179d01b24c3beda4$export$f65a7599bbc6b121(value, from, to) {
    return to[0] + (value - from[0]) * (to[1] - to[0]) / (from[1] - from[0]);
}
function $179d01b24c3beda4$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}


const $abbb921f4a2f09a6$export$4afc387281808150 = 8;
const $abbb921f4a2f09a6$export$cc618b3f4f6850f5 = 0.04;
function $abbb921f4a2f09a6$var$zoomClamp(value) {
    return (0, $179d01b24c3beda4$export$7d15b64cf5a3a4c4)(value, $abbb921f4a2f09a6$export$cc618b3f4f6850f5, $abbb921f4a2f09a6$export$4afc387281808150);
}
class $abbb921f4a2f09a6$export$2e2bcd8739ae039 {
    /**
   *
   * @param {Phaser.Cameras.Scene2D.Camera} camera
   */ setCamera(camera) {
        this.camera = camera;
        if (camera) this.camera.zoom = this.targetZoomLevel;
    }
    setZoomTarget(zoom) {
        this.targetZoomLevel = $abbb921f4a2f09a6$var$zoomClamp(zoom);
    }
    zoom(amount) {
        if (amount != 0) this.setZoomTarget(this.targetZoomLevel * (1 - amount));
    }
    setStiffness(stiffness) {
        if (stiffness > 0 && stiffness <= 1) this.stiffness = stiffness;
        else throw new Error("stiffness must be in (0, 1]");
    }
    /**
   *
   * @param {Function(Number)} listener
   */ registerZoomListener(listener) {
        this.zoomListeners.push(listener);
        if (this.camera) listener(this.camera.zoom);
    }
    unregisterZoomListener(listener) {
        this.zoomListeners.remove(listener);
    }
    handleZoom() {
        if (this.camera) {
            let diff = this.targetZoomLevel - this.camera.zoom;
            if (diff != 0) {
                // enable difference stiffness based on zoom direction
                if (diff > $abbb921f4a2f09a6$export$cc618b3f4f6850f5 / 2) this.camera.zoom = $abbb921f4a2f09a6$var$zoomClamp(this.camera.zoom + diff * this.stiffness // * 0.67
                );
                else if (diff < -$abbb921f4a2f09a6$export$cc618b3f4f6850f5 / 2) this.camera.zoom = $abbb921f4a2f09a6$var$zoomClamp(this.camera.zoom + diff * this.stiffness);
                else if (diff != 0) this.camera.zoom = this.targetZoomLevel;
                this.zoomListeners.forEach((listener)=>listener(this.camera.zoom));
            }
        }
    }
    constructor(zoom = 1, stiffness = 0.3, camera = null){
        this.setZoomTarget(zoom);
        this.setStiffness(stiffness);
        this.setCamera(camera);
        /**
     * @type {Array<(zoom: Number) => ?>}
     */ this.zoomListeners = [];
    }
}









class $6f4fb73908b2a692$export$2e2bcd8739ae039 {
    /**
   * Create and add a ship to the given scene
   * @param {GameScene} scene the scene to add a new ship to
   * @param {Number} x the initial x position
   * @param {Number} y the initial y position
   * @returns {Ship} the added ship
   */ static add(scene, x = 0, y = 0) {
        // let image = scene
        //   .image(x, y, SHIP_IMAGE)
        //   .setOrigin(0.5, 0.5)
        //   .setDisplaySize(32, 16);
        let image = scene.add.triangle(x, y, 0, 0, 2, 0.7, 0, 1.4, 0xaaa9ad, 1).setOrigin(0.334, 0.5);
        let ship = new $6f4fb73908b2a692$export$2e2bcd8739ae039(image);
        scene.zoomManager.registerZoomListener(ship.handleZoom.bind(ship));
        return ship;
    }
    remove() {
        if (this.orbiting) this.orbiting.leaveOrbit(this);
        this.visual.destroy();
    }
    getCurrentOrbitalPosition(time) {
        if (this.orbiting) {
            let radian = this.getOrbitalRadian(time);
            return {
                x: this.orbiting.visual.x + this.orbitalRadius * Math.sin(radian),
                y: this.orbiting.visual.y + this.orbitalRadius * -Math.cos(radian),
                r: radian - Math.PI
            };
        } else return null;
    }
    handleZoom(zoom) {
    // this.visual.scale = Math.pow(1 / zoom, -MIN_ZOOM);
    }
    handleOrbit(time) {
        let params = this.getCurrentOrbitalPosition(time);
        if (params) {
            this.visual.x = params.x;
            this.visual.y = params.y;
            this.visual.setRotation(params.r);
            return true;
        }
        return false;
    }
    handleAttack(time, delta) {
        // put delta into seconds
        // delta /= 1000;
        if (this.attacking) {
            this.attackTransitDistance = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Distance.BetweenPoints(this.visual, this.attacking.visual);
            let targetX, targetY;
            if (this.attackTransitDistance < this.attacking.orbitalRadius * 3) {
                // aim towards orbital position
                let target = this.getCurrentOrbitalPosition(time);
                this.attackTransitDistance = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Distance.BetweenPoints(this.visual, target);
                if (this.attackTransitDistance < 3) {
                    this.attacking = null;
                    this.visual.x = target.x;
                    this.visual.y = target.y;
                    this.visual.rotation = target.r;
                    return false;
                } else {
                    targetX = target.x;
                    targetY = target.y;
                }
            } else {
                // aim towards planet center
                targetX = this.attacking.visual.x;
                targetY = this.attacking.visual.y;
            }
            let percentThisFrame = (0, $179d01b24c3beda4$export$f65a7599bbc6b121)(this.transitSpeed * delta, [
                0,
                this.attackTransitDistance
            ], [
                0,
                1
            ]);
            this.visual.x = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Linear(this.visual.x, targetX, percentThisFrame);
            this.visual.y = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Linear(this.visual.y, targetY, percentThisFrame);
            this.visual.angle = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Angle.Between(this.visual.x, this.visual.y, targetX, targetY);
            return true;
        }
        return false;
    }
    update(time, delta) {
        if (!this.handleAttack(time, delta) && !this.handleOrbit(time)) // this.visual.x += this.vx * delta;
        // this.visual.y += this.vy * delta;
        this.visual.angle += 180 * delta;
    }
    /**
   *
   * @param {Planet} planet the planet where this ship is now in orbit
   * @param {Number} orbitalRadius the distance from the planet this ship should orbit
   * @param {(time: Number) => Number} getTargetRadian a function to return the target radian at any given time
   */ onOrbit(planet, orbitalRadius, getTargetRadian) {
        this.vx = 0;
        this.vy = 0;
        this.orbiting = planet;
        this.orbitalRadius = orbitalRadius;
        this.getOrbitalRadian = getTargetRadian;
        console.log(`Entered orbit of ${planet.name}`);
    }
    /**
   * @param {Planet} planet the planet this ship left
   */ onLeaveOrbit(planet) {
        this.orbiting = null;
        this.orbitalRadius = NaN;
        this.getOrbitalRadian = null;
        console.log(`Left orbit of ${planet.name}`);
    }
    /**
   * @param {Planet} planet the planet this ship should attack
   */ onAttack(planet) {
        if (planet.requestOrbit(this)) {
            this.attacking = planet;
            // onOrbit should have been called by now
            this.attackTransitDistance = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Distance.BetweenPointsSquared(this.visual, planet.visual);
        } else throw new Error(`sent to attack ${planet.name} but failed to receive orbit`);
    }
    /**
   *
   * @param {Phaser.GameObjects.Components.Transform} visual the displayed visual of this ship
   * @param {Number} vx velocity on the x axis
   * @param {Number} vy velocity on the y axis
   */ constructor(visual, vx = 0, vy = 0){
        this.visual = visual;
        this.vx = vx;
        this.vy = vy;
        this.visual.setData("ship", this);
        /**
     * @type {Planet}
     */ this.orbiting = null;
        /**
     * @type {Planet}
     */ this.attacking = null;
        /**
     * @type {Number} the squared distance left to travel to the attacked planet
     */ this.attackTransitDistance = -1;
        /**
     * @type {Number} the transit speed (in pixels per second)
     */ this.transitSpeed = 100;
        /**
     * @type {Number}
     */ this.orbitalRadius = null;
        /**
     * @type {(time: Number) => Number}
     */ this.getOrbitalRadian = null;
    }
}



const $56babc5583c2ace7$var$PLANET_IMAGE = "planet";
/**
 * How far each orbital shell is from the last
 * @type {Number}
 */ const $56babc5583c2ace7$var$ORBITAL_SHELL_INCREMENT = 7;
/**
 * How much orbital circumference does one ship need, in pixels?
 * @type {Number}
 */ const $56babc5583c2ace7$var$ORBITAL_SPACE_PER_SHIP = 5;
class $56babc5583c2ace7$export$2e2bcd8739ae039 {
    /**
   *
   * @param {GameScene} scene the scene to add a new planet to
   * @param {Number} x the initial x position
   * @param {Number} y the initial y position
   * @param {Number} radius the radius of the planet
   * @param {String} name the name of the planet
   * @returns {Planet} the added planet
   */ static add(scene, x, y, radius, name = "planet") {
        let image = scene.add.image(x, y, $56babc5583c2ace7$var$PLANET_IMAGE).setDepth(-1).setOrigin(0.5, 0.5).setDisplaySize(radius * 2, radius * 2);
        let label = scene.add.text(x, y, name).setOrigin(0.5, 0.5).setAlign("center").setColor("white").setVisible(false);
        return new $56babc5583c2ace7$export$2e2bcd8739ae039(name, image, label, radius + 2);
    }
    remove() {
        this.visual.off("pointerover").off("pointerout").off("pointerdown");
        this.visual.destroy();
        this.label.destroy();
    }
    getOrbitRadius(shell) {
        return this.orbitalRadius + shell * $56babc5583c2ace7$var$ORBITAL_SHELL_INCREMENT;
    }
    getMaxShips(shell) {
        let radius = this.getOrbitRadius(shell);
        if (radius > this.orbitalRadius * 2.5) return 0;
        else if (!this.maxShips[shell]) this.maxShips[shell] = Math.floor(radius * 2 * Math.PI / $56babc5583c2ace7$var$ORBITAL_SPACE_PER_SHIP);
        return this.maxShips[shell];
    }
    getShipCapacity() {
        if (!this.shipCapacity) {
            let total = 0;
            for(let shell = 0; this.getMaxShips(shell) > 0; shell++)total += this.getMaxShips(shell);
            this.shipCapacity = total;
        }
        return this.shipCapacity;
    }
    getShipCount() {
        return this.shipCount;
    }
    getShellOrbits(shell) {
        if (!this.orbitals[shell]) {
            this.orbitals[shell] = [];
            console.log(`made new orbital ${shell}`);
        }
        return this.orbitals[shell];
    }
    getCompactOrbitals() {
        return this.orbitals.map((shell)=>shell.filter((ship)=>ship instanceof (0, $6f4fb73908b2a692$export$2e2bcd8739ae039)));
    }
    /**
   *
   * @param {Ship} ship the ship to search for
   * @returns {{shell: Number, orbit: Number}} location of ship or null if not found
   */ getShipLocation(ship) {
        let shell = this.orbitals.length - 1;
        let orbit = this.getMaxShips(shell) - 1;
        while(this.getShellOrbits(shell)[orbit] !== ship){
            if (orbit > 0) orbit--;
            else if (shell > 0) {
                shell--;
                orbit = this.getMaxShips(shell);
            } else {
                shell = -1;
                break;
            }
        }
        if (shell >= 0) return {
            shell: shell,
            orbit: orbit
        };
        else return null;
    }
    /**
   *
   * @param {Ship} ship the ship requesting orbital parameters
   * @returns {{shell: Number, orbit: Number}} location of new ship orbit or null if denied orbit
   */ requestOrbit(ship) {
        // determine innermost orbital slot
        let shell = 0;
        let orbit = 0;
        while(this.getShellOrbits(shell)[orbit] instanceof (0, $6f4fb73908b2a692$export$2e2bcd8739ae039)){
            if (orbit < this.getMaxShips(shell) - 1) orbit++;
            else if (this.getMaxShips(shell + 1) > 0) {
                shell++;
                orbit = 0;
            } else {
                shell = -1;
                break;
            }
        }
        if (shell >= 0) {
            this.orbitals[shell][orbit] = ship;
            let angleAtZero = orbit / this.getMaxShips(shell) * 2 * Math.PI;
            let orbitRadius = this.getOrbitRadius(shell);
            let radian = (time)=>angleAtZero - time / Math.pow(orbitRadius * 0.67, 2) % (Math.PI * 2);
            this.shipCount++;
            ship.onOrbit(this, orbitRadius, radian);
            return {
                shell: shell,
                orbit: orbit
            };
        } else return null;
    }
    /**
   *
   * @param {Ship | Number} shipShell the Ship to remove, or the shell index
   * @param {Number} [orbit=NaN] the orbit index
   */ leaveOrbit(shipShell, orbit = NaN) {
        let location;
        if (shipShell instanceof (0, $6f4fb73908b2a692$export$2e2bcd8739ae039)) location = this.getShipLocation(shipShell);
        else location = {
            shell: shipShell,
            orbit: orbit
        };
        if (location) {
            let ship = this.orbitals[location.shell][location.orbit];
            if (ship) {
                ship.onLeaveOrbit(this);
                delete this.orbitals[location.shell][location.orbit];
                this.shipCount--;
                return true;
            }
        }
        return false;
    }
    /**
   *
   * @param {Planet} planet the planet to attack
   */ attack(planet) {
        if (planet === this) return false; // throw Error("Cannot attack self");
        let numShipsToSend = (0, $179d01b24c3beda4$export$7d15b64cf5a3a4c4)(this.shipCount / 2, 0, planet.getShipCapacity() - planet.getShipCount());
        let ships = [];
        let shell = this.orbitals.length - 1;
        let orbit = this.getMaxShips(shell) - 1;
        while(ships.length < numShipsToSend){
            let ship = this.orbitals[shell][orbit];
            if (this.leaveOrbit(shell, orbit)) ships.push(ship);
            if (orbit > 0) orbit--;
            else if (shell > 0) {
                shell--;
                orbit = this.getMaxShips(shell);
            } else break;
        }
        // there are ships to send
        if (ships.length > 0) {
            for(let i = ships.length - 1; i >= 0; i--)ships[i].onAttack(planet);
            return ships;
        } else return false;
    }
    update(time, delta) {
        // TODO: this is for debugging only
        /** @type {Phaser.Input.Pointer} */ let mouse = globalThis.GAME.input.mousePointer;
        if (mouse.rightButtonDown() && (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Distance.BetweenPointsSquared(this.visual, {
            x: mouse.worldX,
            y: mouse.worldY
        }) < this.orbitalRadius * this.orbitalRadius) for(let i = 25; i--;){
            let ship = globalThis.GAME.makeShip();
            if (this.requestOrbit(ship)) ship.handleOrbit(time);
            else ship.remove();
        }
    }
    /**
   *
   * @param {String} name the name of this planet
   * @param {Phaser.GameObjects.Image} visual the displayed visual of this planet
   * @param {Phaser.GameObjects.Text} label the displayed label of this planet
   * @param {Number} orbitalRadius radius from center of obj to start orbits at
   * @param {Array<Ship>} [ships=[]] the ships to put in orbit
   */ constructor(name, visual, label, orbitalRadius, ships = []){
        this.name = name;
        this.visual = visual;
        this.label = label;
        this.orbitalRadius = orbitalRadius;
        this.visual.setInteractive();
        this.visual.setData("planet", this);
        this.visual.on("pointerover", ()=>this.label.setVisible(true));
        this.visual.on("pointerout", ()=>this.label.setVisible(false));
        /**
     * @type {Array<Array<Ship>>} orbital shell => ships in shell
     */ this.orbitals = [];
        /**
     * @type {Array<Number>} orbital shell => max ship count
     */ this.maxShips = [];
        /**
     * @type {Number} number of ships in orbitals
     */ this.shipCount = 0;
        /**
     * @type {Number} total number of ship orbital slots available
     */ this.shipCapacity = this.getShipCapacity();
        ships.forEach((ship)=>this.requestOrbit(ship));
    }
}




class $865b1c28016b3374$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Scene {
    makeShip(x = 0, y = 0) {
        let ship = (0, $6f4fb73908b2a692$export$2e2bcd8739ae039).add(this, x, y);
        this.ships.push(ship);
        this.shipGroup.add(ship.visual);
        return ship;
    }
    makePlanet(x, y, radius, name) {
        let planet = (0, $56babc5583c2ace7$export$2e2bcd8739ae039).add(this, x, y, radius, name);
        this.planets.push(planet);
        this.planetGroup.add(planet.visual);
        return planet;
    }
    makeSelectUI(x, y, radius) {
        return this.add.container(x, y, [
            this.add.circle(0, 0, radius * 0.94, 0xffffff, 0.175).setAlpha(0.1),
            this.add.container(0, 0, [
                this.add.line(radius, -radius, 0, 0, -0.2 * radius, 0.2 * radius).setStrokeStyle(1, 0xffffff).setLineWidth(0.33).setOrigin(0, 0),
                this.add.line(radius, radius, 0, 0, -0.2 * radius, -0.2 * radius).setStrokeStyle(1, 0xffffff).setLineWidth(0.33).setOrigin(0, 0),
                this.add.line(-radius, radius, 0, 0, 0.2 * radius, -0.2 * radius).setStrokeStyle(1, 0xffffff).setLineWidth(0.33).setOrigin(0, 0),
                this.add.line(-radius, -radius, 0, 0, 0.2 * radius, 0.2 * radius).setStrokeStyle(1, 0xffffff).setLineWidth(0.33).setOrigin(0, 0)
            ]).setName("lines")
        ]);
    }
    create() {
        globalThis.GAME = this;
        this.cameras.main.centerOn(0, 0);
        this.zoomManager.setCamera(this.cameras.main);
        // TODO: do we want to use Phaser's events system?
        // this.zoomManager.registerZoomListener(zoom => this.events.emit("zoom", zoom));
        this.input.keyboard.on("keydown-R", ()=>this.scene.restart()).on("keydown-Q", ()=>this.scene.start("menu"));
        this.input.on("wheel", (pointer)=>this.zoomManager.zoom(pointer.deltaY / 1000));
        // this.tweens.addCounter({
        //   from: 250,
        //   to: 200,
        //   ease: Phaser.Math.Easing.Sine.InOut,
        //   duration: 750,
        //   repeat: -1,
        //   yoyo: true,
        //   onUpdate: (tween) => {
        //     const value = Math.floor(tween.getValue());
        //     console.log(value);
        //     this.selectUI.strokeColor = Phaser.Display.Color.GetColor(240, 240, value);
        //     this.selectUI.lineWidth = (value - 180) / 42
        //   }
        // })
        this.shipGroup = this.add.group({
            name: "ships"
        });
        this.planetGroup = this.add.group({
            name: "planets"
        });
        let hugePlanet = this.makePlanet(150, -250, 128, "Lanto");
        let bigPlanet = this.makePlanet(-350, 150, 96, "Tylon");
        let smallPlanet = this.makePlanet(450, 250, 48, "Atrex");
        this.select(bigPlanet);
        // this.input.on("pointerdown", pointer =>
        //   this.makeShip(pointer.worldX, pointer.worldY)
        // );
        this.input.on("gameobjectdown", this.handleObjectClick, this);
        this.input.on("pointerdown", this.handleEmptyClick, this);
        this.scene.launch("ui");
        this.events.on("destroy", ()=>{
            this.ships.forEach((ship)=>ship.remove());
            this.shipGroup.destroy(true);
            this.planets.forEach((planet)=>planet.remove());
            this.planetGroup.destroy(true);
            this.zoomManager = null;
            this.planets = null;
            this.ships = null;
            globalThis.GAME = null;
        });
    // for (let i = 10; i--; ) {
    //   let ship = this.makeShip();
    //   if (bigPlanet.requestOrbit(ship)) {
    //     ship.handleOrbit(0);
    //   } else {
    //     ship.remove();
    //   }
    // }
    }
    /**
   *
   * @param {Phaser.Input.Pointer} pointer
   * @param {Phaser.GameObjects.GameObject} obj
   * @param {Phaser.Types.Input.EventData} event
   */ handleObjectClick(pointer, obj, event) {
        if (obj.getData("planet") && pointer.primaryDown) {
            let planet = obj.getData("planet");
            if (this.selectedPlanet) // send ships
            {
                if (!this.selectedPlanet.attack(planet, 0.5)) // if no ships to send (attack returns falsy)
                // select planet instead
                // this.select(planet);
                // flash selectUI red
                this.flashSelectUI();
            } else // if no selected planet, select clicked planet
            this.select(planet);
        }
        event.stopPropagation();
    }
    /**
   *
   * @param {Phaser.Input.Pointer} pointer
   */ handleEmptyClick(pointer) {
        this.select(null);
    }
    flashSelectUI() {
        let flashUI = this.selectUI;
        if (flashUI) {
            let lines = flashUI.getByName("lines");
            if (!flashUI.tweens) this.selectUI.tweens = [];
            flashUI.tweens.push(this.tweens.addCounter({
                from: 0,
                to: 255,
                duration: 500,
                ease: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Easing.Cubic.Out,
                yoyo: false,
                onUpdate: (tween)=>{
                    const value = Math.floor(tween.getValue());
                    lines.each((line)=>line.strokeColor = (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Display.Color.GetColor(255, value, value));
                    lines.setAlpha((0, $179d01b24c3beda4$export$f65a7599bbc6b121)(value / 255, [
                        0,
                        1
                    ], [
                        1,
                        lines.alpha
                    ]));
                    lines.setScale((0, $179d01b24c3beda4$export$f65a7599bbc6b121)(Math.abs(value / 255 - 0.5), [
                        0,
                        0.5
                    ], [
                        0.94,
                        lines.scale
                    ]));
                },
                onComplete: (tween)=>{
                    (0, $179d01b24c3beda4$export$30a014203d0d7e4f)(flashUI === null || flashUI === void 0 ? void 0 : flashUI.tweens, tween);
                    lines.each((line)=>line.strokeColor = 0xffffff);
                }
            }));
        }
    }
    /**
   *
   * @param {Planet} planet the planet to select
   */ select(planet) {
        if (planet && planet !== this.selectedPlanet) {
            this.select(null);
            this.selectedPlanet = planet;
            this.selectUI = this.makeSelectUI(planet.visual.x, planet.visual.y, planet.orbitalRadius - 2);
            this.selectUI.setScale(1.5);
            this.selectUI.setAlpha(0);
            // this.selectUI.getByName("lines").setScale(1.03);
            this.selectUI.setVisible(true);
            this.selectUI.tweens = [];
            this.selectUI.tweens.push(this.tweens.add({
                targets: this.selectUI,
                alpha: 1,
                scale: 1,
                ease: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Easing.Cubic.Out,
                duration: 500,
                repeat: 0,
                onComplete: (tween)=>{
                    var _this_selectUI;
                    if ((_this_selectUI = this.selectUI) === null || _this_selectUI === void 0 ? void 0 : _this_selectUI.tweens) {
                        (0, $179d01b24c3beda4$export$30a014203d0d7e4f)(this.selectUI.tweens, tween);
                        this.selectUI.setScale(1);
                        let lines = this.selectUI.getByName("lines");
                        lines.setAlpha(1);
                        // lines.setScale(1.03);
                        this.selectUI.tweens.push(this.tweens.add({
                            targets: lines,
                            alpha: 0.5,
                            scale: 1.03,
                            ease: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Easing.Sine.InOut,
                            duration: 685,
                            yoyo: true,
                            repeat: -1,
                            onComplete: (blink)=>{
                                var _this_selectUI;
                                if ((_this_selectUI = this.selectUI) === null || _this_selectUI === void 0 ? void 0 : _this_selectUI.tweens) (0, $179d01b24c3beda4$export$30a014203d0d7e4f)(this.selectUI.tweens, blink);
                            }
                        }));
                    }
                }
            }));
        } else {
            if (this.selectUI) {
                let oldSelectUI = this.selectUI;
                this.selectUI = null;
                // let oldSelectedPlanet = this.selectedPlanet;
                if (oldSelectUI.tweens) oldSelectUI.tweens.forEach((tween)=>tween.complete());
                oldSelectUI.tween = this.tweens.add({
                    targets: oldSelectUI,
                    alpha: 0,
                    scale: 2,
                    ease: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Math.Easing.Cubic.Out,
                    duration: 500,
                    repeat: 0,
                    onComplete: (tween)=>{
                        oldSelectUI.setVisible(false);
                        oldSelectUI.destroy();
                        if (oldSelectUI === null || oldSelectUI === void 0 ? void 0 : oldSelectUI.tweens) (0, $179d01b24c3beda4$export$30a014203d0d7e4f)(oldSelectUI.tweens, tween);
                        oldSelectUI.tweens.forEach((tween)=>tween.complete());
                        delete oldSelectUI.tweens;
                    }
                });
            }
            this.selectedPlanet = null;
        }
    }
    update(time, delta) {
        delta /= 1000;
        this.zoomManager.handleZoom();
        this.ships.forEach((ship)=>ship.update(time, delta));
        this.planets.forEach((planet)=>planet.update(time, delta));
    // console.log(this.tweens);
    }
    constructor(){
        super({
            key: "game"
        });
        this.zoomManager = new (0, $abbb921f4a2f09a6$export$2e2bcd8739ae039)(1, 0.34);
        globalThis.GAME = this;
        /**
     * @type {Array<Ship>}
     */ this.ships = [];
        /**
     * @type {Phaser.GameObjects.Group}
     */ this.shipGroup = null;
        /**
     * @type {Array<Planet>}
     */ this.planets = [];
        /**
     * @type {Phaser.GameObjects.Group}
     */ this.planetGroup = null;
        /**
     * @type {Planet}
     */ this.selectedPlanet = null;
        /**
     * @type {Phaser.GameObjects.Container}
     */ this.selectUI = null;
    }
}
if (!globalThis.GAME) globalThis.GAME = null;








const $34b1f98673ea4634$var$linearize = (x)=>Math.pow(x, 1 / (4 * Math.E));
const $34b1f98673ea4634$var$exponentiate = (x)=>Math.pow(x, 4 * Math.E);
const $34b1f98673ea4634$var$DELTA_TIME_ELEMENT = document.getElementById("delta");
class $34b1f98673ea4634$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Scene {
    create() {
        /**
     * @type {GameScene}
     */ this.game = this.scene.get("game");
        let width = this.cameras.main.width;
        let height = this.cameras.main.height;
        this.bar = this.add.rectangle(width - 20, 0, 20, height, 0xbbbbbb, 0.33).setAlpha(0.25).setOrigin(0, 0).setInteractive();
        this.pipRange = height - 40;
        this.pip = this.add.rectangle(width - 18, 2, 16, 36, 0xffffff, 0.83).setAlpha(0.67).setOrigin(0, 0).setInteractive();
        console.log(this.pip);
        this.input.setDraggable(this.pip);
        this.cameras.main.transparent = true;
        this.scene.moveAbove("game");
        console.log("created UI");
        this.game.zoomManager.registerZoomListener(this.handleZoom.bind(this));
        this.pip.on("pointerover", ()=>this.highlightPip(true));
        this.pip.on("pointerout", ()=>this.highlightPip(false));
        this.pip.on("dragstart", ()=>this.dragging = true);
        this.pip.on("dragend", ()=>this.dragging = false);
        this.bar.on("pointerover", ()=>this.highlightBar(true));
        this.bar.on("pointerout", ()=>this.highlightBar(false));
        this.pip.on("drag", (pointer)=>this.handleDrag(pointer.y - 18));
        this.bar.on("pointerdown", (pointer)=>this.handleDrag(pointer.y - 18));
    }
    highlightBar(active) {
        this.bar.alpha = active ? 0.67 : 0.33;
    }
    highlightPip(active) {
        this.pip.alpha = active ? 1 : 0.67;
        this.highlightBar(active);
    }
    zoomToPip(zoom) {
        return (0, $179d01b24c3beda4$export$f65a7599bbc6b121)($34b1f98673ea4634$var$linearize(zoom), [
            $34b1f98673ea4634$var$linearize((0, $abbb921f4a2f09a6$export$cc618b3f4f6850f5)),
            $34b1f98673ea4634$var$linearize((0, $abbb921f4a2f09a6$export$4afc387281808150))
        ], [
            this.pipRange,
            0
        ]);
    }
    pipToZoom(pip) {
        return $34b1f98673ea4634$var$exponentiate((0, $179d01b24c3beda4$export$f65a7599bbc6b121)(pip, [
            this.pipRange,
            0
        ], [
            $34b1f98673ea4634$var$linearize((0, $abbb921f4a2f09a6$export$cc618b3f4f6850f5)),
            $34b1f98673ea4634$var$linearize((0, $abbb921f4a2f09a6$export$4afc387281808150))
        ]));
    }
    setPip(height) {
        height = (0, $179d01b24c3beda4$export$7d15b64cf5a3a4c4)(height, 0, this.pipRange);
        this.pip.y = 2 + height;
        return height;
    }
    handleZoom(zoom) {
        if (this.dragging) return;
        this.setPip(this.zoomToPip(zoom));
    }
    handleDrag(drag) {
        let set = this.setPip(drag - 2);
        set = this.pipToZoom(set);
        this.game.zoomManager.setZoomTarget(set);
    }
    update(time, delta) {
        $34b1f98673ea4634$var$DELTA_TIME_ELEMENT.innerText = `${(1000 / delta).toPrecision(2)} fps - ${delta.toPrecision(2)} ms`;
    }
    constructor(){
        super({
            key: "ui"
        });
        this.bar = null;
        this.pip = null;
        this.pipRange = 0;
        this.dragging = false;
    }
}


var $d7b7c5ce0584a729$export$2e2bcd8739ae039 = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).AUTO,
    scale: {
        fullscreenTarget: "app",
        parent: "app",
        width: "100%",
        height: "100%",
        mode: (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Scale.ScaleModes.RESIZE
    },
    fps: {
        min: 30,
        target: 60,
        deltaHistory: 10,
        panicMax: 120,
        smoothStep: true
    },
    title: "ExFour",
    url: "http://exfour.saejinmh.com",
    disableContextMenu: true,
    banner: {
        text: "white",
        background: [
            "#FD7400",
            "#FFE11A",
            "#BEDB39",
            "#1F8A70",
            "#004358"
        ]
    },
    scene: [
        (0, $29344f62a7f81f67$export$2e2bcd8739ae039),
        (0, $865b1c28016b3374$export$2e2bcd8739ae039),
        (0, $34b1f98673ea4634$export$2e2bcd8739ae039)
    ],
    enableDebug: false
};



let $f9f45547744ce740$var$game;
function $f9f45547744ce740$var$create() {
    if ($f9f45547744ce740$var$game) return;
    $f9f45547744ce740$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($79f3f38722d4e01c$exports))).Game((0, $d7b7c5ce0584a729$export$2e2bcd8739ae039));
}
function $f9f45547744ce740$var$destroy() {
    if (!$f9f45547744ce740$var$game) return;
    console.log("reloading");
    location.reload();
}
// enable hot reloading
if (null) {
    null.dispose($f9f45547744ce740$var$destroy);
    null.accept($f9f45547744ce740$var$create);
}
if (!$f9f45547744ce740$var$game) $f9f45547744ce740$var$create();


//# sourceMappingURL=exfour.f4310db0.js.map
